/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1491);
	module.exports = __webpack_require__(1159);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1495);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var IconBase = function IconBase(_ref, _ref2) {
	  var children = _ref.children;
	  var color = _ref.color;
	  var size = _ref.size;
	  var style = _ref.style;
	  var width = _ref.width;
	  var height = _ref.height;
	
	  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);
	
	  var _ref2$reactIconBase = _ref2.reactIconBase;
	  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;
	
	  var computedSize = size || reactIconBase.size || '1em';
	  return _react2.default.createElement('svg', _extends({
	    children: children,
	    fill: 'currentColor',
	    preserveAspectRatio: 'xMidYMid meet',
	    height: height || computedSize,
	    width: width || computedSize
	  }, reactIconBase, props, {
	    style: _extends({
	      verticalAlign: 'middle',
	      color: color || reactIconBase.color
	    }, reactIconBase.style || {}, style)
	  }));
	};
	
	IconBase.propTypes = {
	  color: _propTypes2.default.string,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	};
	
	IconBase.contextTypes = {
	  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
	};
	
	exports.default = IconBase;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1237)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1509)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.VibrationIOS = exports.TVEventHandler = exports.TimePickerAndroid = exports.Systrace = exports.StatusBarIOS = exports.Settings = exports.PushNotificationIOS = exports.PermissionsAndroid = exports.ImagePickerIOS = exports.DatePickerAndroid = exports.CameraRoll = exports.AlertIOS = exports.ActionSheetIOS = exports.WebView = exports.ViewPagerAndroid = exports.ToolbarAndroid = exports.ToastAndroid = exports.TabBarIOS = exports.SnapshotViewIOS = exports.SegmentedControlIOS = exports.ProgressViewIOS = exports.ProgressBarAndroid = exports.PickerIOS = exports.NavigatorIOS = exports.MaskedViewIOS = exports.InputAccessoryView = exports.ImageStore = exports.ImageEditor = exports.DrawerLayoutAndroid = exports.DatePickerIOS = exports.PointPropType = exports.EdgeInsetsPropType = exports.ColorPropType = exports.YellowBox = exports.VirtualizedList = exports.View = exports.TouchableWithoutFeedback = exports.TouchableOpacity = exports.TouchableNativeFeedback = exports.TouchableHighlight = exports.Touchable = exports.TextInput = exports.Text = exports.Switch = exports.SwipeableListView = exports.SwipeableFlatList = exports.StatusBar = exports.Slider = exports.SectionList = exports.ScrollView = exports.SafeAreaView = exports.RefreshControl = exports.ProgressBar = exports.Picker = exports.Modal = exports.ListView = exports.KeyboardAvoidingView = exports.ImageBackground = exports.Image = exports.FlatList = exports.CheckBox = exports.Button = exports.ART = exports.ActivityIndicator = exports.Vibration = exports.UIManager = exports.StyleSheet = exports.Share = exports.Platform = exports.PixelRatio = exports.PanResponder = exports.NetInfo = exports.NativeEventEmitter = exports.Linking = exports.LayoutAnimation = exports.Keyboard = exports.InteractionManager = exports.I18nManager = exports.Easing = exports.Dimensions = exports.DeviceInfo = exports.Clipboard = exports.BackHandler = exports.AsyncStorage = exports.AppState = exports.AppRegistry = exports.Animated = exports.Alert = exports.AccessibilityInfo = exports.ViewPropTypes = exports.TextPropTypes = exports.NativeModules = exports.processColor = exports.unmountComponentAtNode = exports.render = exports.findNodeHandle = exports.createElement = undefined;
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _processColor = __webpack_require__(1041);
	
	var _processColor2 = _interopRequireDefault(_processColor);
	
	var _render = __webpack_require__(1042);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _unmountComponentAtNode = __webpack_require__(1043);
	
	var _unmountComponentAtNode2 = _interopRequireDefault(_unmountComponentAtNode);
	
	var _NativeModules = __webpack_require__(813);
	
	var _NativeModules2 = _interopRequireDefault(_NativeModules);
	
	var _TextPropTypes = __webpack_require__(1432);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _AccessibilityInfo = __webpack_require__(1381);
	
	var _AccessibilityInfo2 = _interopRequireDefault(_AccessibilityInfo);
	
	var _Alert = __webpack_require__(1383);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Animated = __webpack_require__(1027);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _AppRegistry = __webpack_require__(1385);
	
	var _AppRegistry2 = _interopRequireDefault(_AppRegistry);
	
	var _AppState = __webpack_require__(1387);
	
	var _AppState2 = _interopRequireDefault(_AppState);
	
	var _AsyncStorage = __webpack_require__(1388);
	
	var _AsyncStorage2 = _interopRequireDefault(_AsyncStorage);
	
	var _BackHandler = __webpack_require__(1389);
	
	var _BackHandler2 = _interopRequireDefault(_BackHandler);
	
	var _Clipboard = __webpack_require__(1392);
	
	var _Clipboard2 = _interopRequireDefault(_Clipboard);
	
	var _DeviceInfo = __webpack_require__(1393);
	
	var _DeviceInfo2 = _interopRequireDefault(_DeviceInfo);
	
	var _Dimensions = __webpack_require__(124);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	var _Easing = __webpack_require__(1394);
	
	var _Easing2 = _interopRequireDefault(_Easing);
	
	var _I18nManager = __webpack_require__(125);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _Keyboard = __webpack_require__(1399);
	
	var _Keyboard2 = _interopRequireDefault(_Keyboard);
	
	var _InteractionManager = __webpack_require__(126);
	
	var _InteractionManager2 = _interopRequireDefault(_InteractionManager);
	
	var _LayoutAnimation = __webpack_require__(1401);
	
	var _LayoutAnimation2 = _interopRequireDefault(_LayoutAnimation);
	
	var _Linking = __webpack_require__(1402);
	
	var _Linking2 = _interopRequireDefault(_Linking);
	
	var _NativeEventEmitter = __webpack_require__(1405);
	
	var _NativeEventEmitter2 = _interopRequireDefault(_NativeEventEmitter);
	
	var _NetInfo = __webpack_require__(1406);
	
	var _NetInfo2 = _interopRequireDefault(_NetInfo);
	
	var _PanResponder = __webpack_require__(1030);
	
	var _PanResponder2 = _interopRequireDefault(_PanResponder);
	
	var _PixelRatio = __webpack_require__(1410);
	
	var _PixelRatio2 = _interopRequireDefault(_PixelRatio);
	
	var _Platform = __webpack_require__(106);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _Share = __webpack_require__(1416);
	
	var _Share2 = _interopRequireDefault(_Share);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _Vibration = __webpack_require__(1437);
	
	var _Vibration2 = _interopRequireDefault(_Vibration);
	
	var _ActivityIndicator = __webpack_require__(1382);
	
	var _ActivityIndicator2 = _interopRequireDefault(_ActivityIndicator);
	
	var _ART = __webpack_require__(1380);
	
	var _ART2 = _interopRequireDefault(_ART);
	
	var _Button = __webpack_require__(1390);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _CheckBox = __webpack_require__(1391);
	
	var _CheckBox2 = _interopRequireDefault(_CheckBox);
	
	var _FlatList = __webpack_require__(1395);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	var _Image = __webpack_require__(812);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ImageBackground = __webpack_require__(1398);
	
	var _ImageBackground2 = _interopRequireDefault(_ImageBackground);
	
	var _KeyboardAvoidingView = __webpack_require__(1400);
	
	var _KeyboardAvoidingView2 = _interopRequireDefault(_KeyboardAvoidingView);
	
	var _ListView = __webpack_require__(1403);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	var _Modal = __webpack_require__(1404);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Picker = __webpack_require__(1031);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _ProgressBar = __webpack_require__(1412);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _RefreshControl = __webpack_require__(1032);
	
	var _RefreshControl2 = _interopRequireDefault(_RefreshControl);
	
	var _SafeAreaView = __webpack_require__(1413);
	
	var _SafeAreaView2 = _interopRequireDefault(_SafeAreaView);
	
	var _ScrollView = __webpack_require__(107);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _SectionList = __webpack_require__(1415);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	var _Slider = __webpack_require__(1417);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _StatusBar = __webpack_require__(1418);
	
	var _StatusBar2 = _interopRequireDefault(_StatusBar);
	
	var _SwipeableFlatList = __webpack_require__(1428);
	
	var _SwipeableFlatList2 = _interopRequireDefault(_SwipeableFlatList);
	
	var _SwipeableListView = __webpack_require__(1429);
	
	var _SwipeableListView2 = _interopRequireDefault(_SwipeableListView);
	
	var _Switch = __webpack_require__(1430);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	var _Text = __webpack_require__(818);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _TextInput = __webpack_require__(1431);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _Touchable = __webpack_require__(127);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _TouchableHighlight = __webpack_require__(1435);
	
	var _TouchableHighlight2 = _interopRequireDefault(_TouchableHighlight);
	
	var _TouchableNativeFeedback = __webpack_require__(1436);
	
	var _TouchableNativeFeedback2 = _interopRequireDefault(_TouchableNativeFeedback);
	
	var _TouchableOpacity = __webpack_require__(1039);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _TouchableWithoutFeedback = __webpack_require__(820);
	
	var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _VirtualizedList = __webpack_require__(1439);
	
	var _VirtualizedList2 = _interopRequireDefault(_VirtualizedList);
	
	var _YellowBox = __webpack_require__(1440);
	
	var _YellowBox2 = _interopRequireDefault(_YellowBox);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _EdgeInsetsPropType = __webpack_require__(811);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _PointPropType = __webpack_require__(1411);
	
	var _PointPropType2 = _interopRequireDefault(_PointPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// components
	var emptyObject = {};
	// compat (components)
	
	
	// propTypes
	
	
	// APIs
	var DatePickerIOS = _UnimplementedView2.default;
	var DrawerLayoutAndroid = _UnimplementedView2.default;
	var ImageEditor = _UnimplementedView2.default;
	var ImageStore = _UnimplementedView2.default;
	var InputAccessoryView = _UnimplementedView2.default;
	var MaskedViewIOS = _UnimplementedView2.default;
	var NavigatorIOS = _UnimplementedView2.default;
	var PickerIOS = _Picker2.default;
	var ProgressBarAndroid = _UnimplementedView2.default;
	var ProgressViewIOS = _UnimplementedView2.default;
	var SegmentedControlIOS = _UnimplementedView2.default;
	var SnapshotViewIOS = _UnimplementedView2.default;
	var TabBarIOS = _UnimplementedView2.default;
	var ToastAndroid = _UnimplementedView2.default;
	var ToolbarAndroid = _UnimplementedView2.default;
	var ViewPagerAndroid = _UnimplementedView2.default;
	var WebView = _UnimplementedView2.default;
	// compat (apis)
	var ActionSheetIOS = emptyObject;
	var AlertIOS = emptyObject;
	var CameraRoll = emptyObject;
	var DatePickerAndroid = emptyObject;
	var ImagePickerIOS = emptyObject;
	var PermissionsAndroid = emptyObject;
	var PushNotificationIOS = emptyObject;
	var Settings = emptyObject;
	var StatusBarIOS = emptyObject;
	var Systrace = emptyObject;
	var TimePickerAndroid = emptyObject;
	var TVEventHandler = emptyObject;
	var VibrationIOS = emptyObject;
	
	exports.createElement = _createElement2.default;
	exports.findNodeHandle = _findNodeHandle2.default;
	exports.render = _render2.default;
	exports.unmountComponentAtNode = _unmountComponentAtNode2.default;
	exports.processColor = _processColor2.default;
	exports.NativeModules = _NativeModules2.default;
	exports.TextPropTypes = _TextPropTypes2.default;
	exports.ViewPropTypes = _ViewPropTypes2.default;
	exports.AccessibilityInfo = _AccessibilityInfo2.default;
	exports.Alert = _Alert2.default;
	exports.Animated = _Animated2.default;
	exports.AppRegistry = _AppRegistry2.default;
	exports.AppState = _AppState2.default;
	exports.AsyncStorage = _AsyncStorage2.default;
	exports.BackHandler = _BackHandler2.default;
	exports.Clipboard = _Clipboard2.default;
	exports.DeviceInfo = _DeviceInfo2.default;
	exports.Dimensions = _Dimensions2.default;
	exports.Easing = _Easing2.default;
	exports.I18nManager = _I18nManager2.default;
	exports.InteractionManager = _InteractionManager2.default;
	exports.Keyboard = _Keyboard2.default;
	exports.LayoutAnimation = _LayoutAnimation2.default;
	exports.Linking = _Linking2.default;
	exports.NativeEventEmitter = _NativeEventEmitter2.default;
	exports.NetInfo = _NetInfo2.default;
	exports.PanResponder = _PanResponder2.default;
	exports.PixelRatio = _PixelRatio2.default;
	exports.Platform = _Platform2.default;
	exports.Share = _Share2.default;
	exports.StyleSheet = _StyleSheet2.default;
	exports.UIManager = _UIManager2.default;
	exports.Vibration = _Vibration2.default;
	exports.ActivityIndicator = _ActivityIndicator2.default;
	exports.ART = _ART2.default;
	exports.Button = _Button2.default;
	exports.CheckBox = _CheckBox2.default;
	exports.FlatList = _FlatList2.default;
	exports.Image = _Image2.default;
	exports.ImageBackground = _ImageBackground2.default;
	exports.KeyboardAvoidingView = _KeyboardAvoidingView2.default;
	exports.ListView = _ListView2.default;
	exports.Modal = _Modal2.default;
	exports.Picker = _Picker2.default;
	exports.ProgressBar = _ProgressBar2.default;
	exports.RefreshControl = _RefreshControl2.default;
	exports.SafeAreaView = _SafeAreaView2.default;
	exports.ScrollView = _ScrollView2.default;
	exports.SectionList = _SectionList2.default;
	exports.Slider = _Slider2.default;
	exports.StatusBar = _StatusBar2.default;
	exports.SwipeableFlatList = _SwipeableFlatList2.default;
	exports.SwipeableListView = _SwipeableListView2.default;
	exports.Switch = _Switch2.default;
	exports.Text = _Text2.default;
	exports.TextInput = _TextInput2.default;
	exports.Touchable = _Touchable2.default;
	exports.TouchableHighlight = _TouchableHighlight2.default;
	exports.TouchableNativeFeedback = _TouchableNativeFeedback2.default;
	exports.TouchableOpacity = _TouchableOpacity2.default;
	exports.TouchableWithoutFeedback = _TouchableWithoutFeedback2.default;
	exports.View = _View2.default;
	exports.VirtualizedList = _VirtualizedList2.default;
	exports.YellowBox = _YellowBox2.default;
	exports.ColorPropType = _ColorPropType2.default;
	exports.EdgeInsetsPropType = _EdgeInsetsPropType2.default;
	exports.PointPropType = _PointPropType2.default;
	exports.DatePickerIOS = DatePickerIOS;
	exports.DrawerLayoutAndroid = DrawerLayoutAndroid;
	exports.ImageEditor = ImageEditor;
	exports.ImageStore = ImageStore;
	exports.InputAccessoryView = InputAccessoryView;
	exports.MaskedViewIOS = MaskedViewIOS;
	exports.NavigatorIOS = NavigatorIOS;
	exports.PickerIOS = PickerIOS;
	exports.ProgressBarAndroid = ProgressBarAndroid;
	exports.ProgressViewIOS = ProgressViewIOS;
	exports.SegmentedControlIOS = SegmentedControlIOS;
	exports.SnapshotViewIOS = SnapshotViewIOS;
	exports.TabBarIOS = TabBarIOS;
	exports.ToastAndroid = ToastAndroid;
	exports.ToolbarAndroid = ToolbarAndroid;
	exports.ViewPagerAndroid = ViewPagerAndroid;
	exports.WebView = WebView;
	exports.ActionSheetIOS = ActionSheetIOS;
	exports.AlertIOS = AlertIOS;
	exports.CameraRoll = CameraRoll;
	exports.DatePickerAndroid = DatePickerAndroid;
	exports.ImagePickerIOS = ImagePickerIOS;
	exports.PermissionsAndroid = PermissionsAndroid;
	exports.PushNotificationIOS = PushNotificationIOS;
	exports.Settings = Settings;
	exports.StatusBarIOS = StatusBarIOS;
	exports.Systrace = Systrace;
	exports.TimePickerAndroid = TimePickerAndroid;
	exports.TVEventHandler = TVEventHandler;
	exports.VibrationIOS = VibrationIOS;
	
	
	var ReactNative = {
	  // top-level API
	  createElement: _createElement2.default,
	  findNodeHandle: _findNodeHandle2.default,
	  render: _render2.default,
	  unmountComponentAtNode: _unmountComponentAtNode2.default,
	  // modules
	  processColor: _processColor2.default,
	  NativeModules: _NativeModules2.default,
	  TextPropTypes: _TextPropTypes2.default,
	  ViewPropTypes: _ViewPropTypes2.default,
	  // APIs
	  AccessibilityInfo: _AccessibilityInfo2.default,
	  Alert: _Alert2.default,
	  Animated: _Animated2.default,
	  AppRegistry: _AppRegistry2.default,
	  AppState: _AppState2.default,
	  AsyncStorage: _AsyncStorage2.default,
	  BackHandler: _BackHandler2.default,
	  Clipboard: _Clipboard2.default,
	  DeviceInfo: _DeviceInfo2.default,
	  Dimensions: _Dimensions2.default,
	  Easing: _Easing2.default,
	  I18nManager: _I18nManager2.default,
	  InteractionManager: _InteractionManager2.default,
	  Keyboard: _Keyboard2.default,
	  LayoutAnimation: _LayoutAnimation2.default,
	  Linking: _Linking2.default,
	  NativeEventEmitter: _NativeEventEmitter2.default,
	  NetInfo: _NetInfo2.default,
	  PanResponder: _PanResponder2.default,
	  PixelRatio: _PixelRatio2.default,
	  Platform: _Platform2.default,
	  Share: _Share2.default,
	  StyleSheet: _StyleSheet2.default,
	  UIManager: _UIManager2.default,
	  Vibration: _Vibration2.default,
	  // components
	  ActivityIndicator: _ActivityIndicator2.default,
	  ART: _ART2.default,
	  Button: _Button2.default,
	  CheckBox: _CheckBox2.default,
	  FlatList: _FlatList2.default,
	  Image: _Image2.default,
	  ImageBackground: _ImageBackground2.default,
	  KeyboardAvoidingView: _KeyboardAvoidingView2.default,
	  ListView: _ListView2.default,
	  Modal: _Modal2.default,
	  Picker: _Picker2.default,
	  ProgressBar: _ProgressBar2.default,
	  RefreshControl: _RefreshControl2.default,
	  SafeAreaView: _SafeAreaView2.default,
	  ScrollView: _ScrollView2.default,
	  SectionList: _SectionList2.default,
	  Slider: _Slider2.default,
	  StatusBar: _StatusBar2.default,
	  SwipeableFlatList: _SwipeableFlatList2.default,
	  SwipeableListView: _SwipeableListView2.default,
	  Switch: _Switch2.default,
	  Text: _Text2.default,
	  TextInput: _TextInput2.default,
	  Touchable: _Touchable2.default,
	  TouchableHighlight: _TouchableHighlight2.default,
	  TouchableNativeFeedback: _TouchableNativeFeedback2.default,
	  TouchableOpacity: _TouchableOpacity2.default,
	  TouchableWithoutFeedback: _TouchableWithoutFeedback2.default,
	  View: _View2.default,
	  VirtualizedList: _VirtualizedList2.default,
	  YellowBox: _YellowBox2.default,
	  // propTypes
	  ColorPropType: _ColorPropType2.default,
	  EdgeInsetsPropType: _EdgeInsetsPropType2.default,
	  PointPropType: _PointPropType2.default,
	  // compat (components)
	  DatePickerIOS: DatePickerIOS,
	  DrawerLayoutAndroid: DrawerLayoutAndroid,
	  ImageEditor: ImageEditor,
	  ImageStore: ImageStore,
	  InputAccessoryView: InputAccessoryView,
	  MaskedViewIOS: MaskedViewIOS,
	  NavigatorIOS: NavigatorIOS,
	  PickerIOS: PickerIOS,
	  ProgressBarAndroid: ProgressBarAndroid,
	  ProgressViewIOS: ProgressViewIOS,
	  SegmentedControlIOS: SegmentedControlIOS,
	  SnapshotViewIOS: SnapshotViewIOS,
	  TabBarIOS: TabBarIOS,
	  ToastAndroid: ToastAndroid,
	  ToolbarAndroid: ToolbarAndroid,
	  ViewPagerAndroid: ViewPagerAndroid,
	  WebView: WebView,
	  // compat (apis)
	  ActionSheetIOS: ActionSheetIOS,
	  AlertIOS: AlertIOS,
	  CameraRoll: CameraRoll,
	  DatePickerAndroid: DatePickerAndroid,
	  ImagePickerIOS: ImagePickerIOS,
	  PermissionsAndroid: PermissionsAndroid,
	  PushNotificationIOS: PushNotificationIOS,
	  Settings: Settings,
	  StatusBarIOS: StatusBarIOS,
	  Systrace: Systrace,
	  TimePickerAndroid: TimePickerAndroid,
	  TVEventHandler: TVEventHandler,
	  VibrationIOS: VibrationIOS
	};
	
	exports.default = ReactNative;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(854);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1247)();
	}


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    View = ReactNative.View,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    PixelRatio = ReactNative.PixelRatio;
	
	
	var ReUpText = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      style: {},
	      fontKey: null,
	      isTitle: false,
	      isSuperTitle: false,
	      shrinksAtLength: 100,
	      children: React.createElement(View, null)
	    };
	  },
	
	  render: function render() {
	    var _props = this.props,
	        appManager = _props.appManager,
	        style = _props.style,
	        fontKey = _props.fontKey,
	        children = _props.children,
	        isTitle = _props.isTitle,
	        isSuperTitle = _props.isSuperTitle,
	        shrinksAtLength = _props.shrinksAtLength,
	        otherProps = _objectWithoutProperties(_props, ['appManager', 'style', 'fontKey', 'children', 'isTitle', 'isSuperTitle', 'shrinksAtLength']);
	
	    var fontScale = appManager == null ? 1 : appManager._fontScale;
	    var additionalFontPoints = 0;
	    if (fontScale >= 3) additionalFontPoints = 4;
	    if (fontScale >= 2) additionalFontPoints = 2;
	
	    var shouldShrink = typeof children !== 'undefined' && children != null && children.length >= shrinksAtLength;
	    var overridableStyle = { fontSize: shouldShrink ? 12 : 14 + additionalFontPoints, backgroundColor: 'transparent', textAlign: 'left' };
	    if (isTitle) overridableStyle = { fontSize: shouldShrink ? 14 : 16 + additionalFontPoints, fontWeight: 'bold', backgroundColor: 'transparent', textAlign: 'left' };
	    if (isSuperTitle) overridableStyle = { fontSize: shouldShrink ? 12 : 18, fontWeight: 'bold', backgroundColor: 'transparent', textAlign: 'left' };
	
	    var overrideStyle = {};
	    if (appManager != null && typeof appManager !== 'undefined') {
	      if (this.props.fontKey != null) overrideStyle.fontFamily = this.props.appManager.getFontForKey(this.props.fontKey);else {
	        var isBold = isTitle || isSuperTitle || overridableStyle.fontWeight == 'bold' || style.fontWeight == 'bold';
	        if (isBold) overrideStyle.fontFamily = this.props.appManager.getFontForKey("Bold");else overrideStyle.fontFamily = this.props.appManager.getFontForKey("Regular");
	      }
	
	      // if( overrideStyle.fontFamily.startsWith("Vonne") )
	      // {
	      //   var paddingTop = 0;
	      //   if( typeof style.paddingTop !== 'undefined' ) paddingTop = style.paddingTop;
	      //   if( typeof style === 'array' )
	      //   {
	      //     for( var i = 0; i < style.length; i++ )
	      //     {
	      //         if( typeof style[i].paddingTop !== 'undefined' ) paddingTop += style[i].paddingTop;
	      //     }
	      //   }
	      //   overrideStyle.paddingTop = 6 + paddingTop;
	      //   if( typeof style.fontSize !== 'undefined' ) overrideStyle.paddingTop = style.fontSize/3 + paddingTop;
	      //
	      // }
	    } else {}
	      // paddingTop = 10
	
	
	      // TODO: this should be in the config
	    if (Platform.OS === 'web') {
	      overrideStyle.fontFamily = "Helvetica";
	    }
	
	    var overallStyle = StyleSheet.flatten([overridableStyle, style, overrideStyle]);
	    // if( typeof overallStyle.fontSize !== 'undefined' ) overallStyle.fontSize = overallStyle.fontSize / PixelRatio.getFontScale();
	
	    return React.createElement(
	      Text,
	      Object.assign({ allowFontScaling: false, style: overallStyle }, otherProps),
	      typeof children !== 'undefined' && children != null ? children : ""
	    );
	  }
	});
	
	module.exports = ReUpText;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Animated = {};
	var animIndex = 0;
	Animated.Value = function (value, identifier) {
	  var me = this;
	  me.animIndex = animIndex++;
	  me.value = value;
	  if (typeof identifier !== 'undefined') {
	    me.identifier = identifier;
	  }
	
	  me.setValue = function (newValue) {
	    me.value = newValue;
	    if (typeof me.listeners === 'undefined') me.listeners = [];
	    for (var i = 0; i < me.listeners.length; i++) {
	      me.listeners[i]({ value: me.getValue() });
	    }
	  };
	
	  me.getValue = function () {
	    return me.value;
	  };
	
	  me.listeners = [];
	  me.addListener = function (listener) {
	    if (typeof me.listeners === 'undefined') me.listeners = [];
	    for (var i = 0; i < me.listeners.length; i++) {
	      if (me.listeners[i] === listener) return; // already registered
	    }
	
	    me.listeners.push(listener);
	  };
	
	  me.removeListener = function (listener) {
	    var newListeners = [];
	    for (var i = 0; i < me.listeners.length; i++) {
	      if (me.listeners[i] !== listener) newListeners.push(me.listeners[i]);
	    }
	
	    me.listeners = newListeners;
	  };
	
	  return me;
	};
	
	var DELTA_T = 10;
	Animated.timing = function (value, params) {
	  // var value = value;
	  var startValue = value.getValue();
	  var toValue = params.toValue;
	  var deltaValue = toValue - startValue;
	  var duration = params.duration;
	  value.callback = null;
	  value.duration = duration;
	  if (duration === 0) {
	    value.setValue(toValue);
	    return;
	  }
	
	  value.timeout = null;
	  var timeoutFunction = function timeoutFunction() {
	    var newTime = new Date().getTime();
	    var t = Math.min(value.duration, newTime - value.startTime);
	    var newValue = startValue + parseFloat(deltaValue * parseFloat(t / value.duration));
	    // console.log("time val", t, duration, newValue)
	    value.setValue(newValue);
	    if (t < duration) {
	      value.timeout = setTimeout(timeoutFunction, DELTA_T);
	    } else {
	      if (value.callback != null) value.callback();
	      value.callback = null;
	
	      if (value.timeout != null) clearTimeout(value.timeout);
	      value.timeout = null;
	
	      value.stop = null;
	    }
	  };
	
	  var stop = function stop() {
	    if (value.callback != null) value.callback();
	    value.callback = null;
	
	    if (value.timeout != null) clearTimeout(value.timeout);
	    value.timeout = null;
	  };
	  value.stop = stop;
	
	  var start = function start(newCallback) {
	    if (value.stop) value.stop();
	    value.startTime = new Date().getTime();
	    value.stop = value.newStop;
	    if (value.timeout != null) clearTimeout(value.timeout);
	    value.timeout = null;
	    if (typeof newCallback !== 'undefined') value.callback = newCallback;
	    timeoutFunction();
	
	    return value;
	  };
	  value.start = start;
	  value.newStop = stop;
	
	  return value;
	};
	
	Animated.spring = function (value, params) {
	  // var value = value;
	  var startValue = value.getValue();
	  var toValue = params.toValue;
	  return Animated.timing(value, { toValue: toValue, duration: 300 });
	};
	
	function separateStyle(style) {
	  var staticStyle = {};
	  var animatedStyle = {};
	  var flatStyle = StyleSheet.flatten(style);
	  for (var key in flatStyle) {
	    var thisStyle = flatStyle[key];
	    if (key == 'transform') {
	      var hasAnim = false;
	      for (var i = 0; i < thisStyle.length; i++) {
	        var thisTransform = thisStyle[i];
	        for (var transKey in thisTransform) {
	          if (typeof thisTransform[transKey].getValue !== 'undefined') {
	            hasAnim = true;
	            break;
	          }
	        }
	        if (hasAnim) break;
	      }
	      if (hasAnim) animatedStyle.transform = thisStyle;else staticStyle.transform = thisStyle;
	    } else if (typeof thisStyle !== 'undefined') {
	      if (typeof thisStyle.getValue !== 'undefined') animatedStyle[key] = thisStyle;else staticStyle[key] = thisStyle;
	    }
	  }
	
	  return { staticStyle: staticStyle, animatedStyle: animatedStyle };
	}
	
	Animated.View = createReactClass({
	  displayName: 'View',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var style = this.props.style;
	
	    var _separateStyle = separateStyle(style),
	        staticStyle = _separateStyle.staticStyle,
	        animatedStyle = _separateStyle.animatedStyle;
	
	    return {
	      staticStyle: staticStyle, animatedStyle: animatedStyle
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.style !== 'undefined') {
	      var _separateStyle2 = separateStyle(newProps.style),
	          staticStyle = _separateStyle2.staticStyle,
	          animatedStyle = _separateStyle2.animatedStyle;
	
	      this.registerAnimatedStyles(animatedStyle);
	      this.setState({ staticStyle: staticStyle, animatedStyle: animatedStyle });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.registerAnimatedStyles(this.state.animatedStyle);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unRegisterAnimatedStyles(this.state.animatedStyle);
	  },
	
	  registerAnimatedStyles: function registerAnimatedStyles(animatedStyle) {
	    for (var key in animatedStyle) {
	      if (key == 'transform') {
	        for (var i = 0; i < animatedStyle.transform.length; i++) {
	          for (var transKey in animatedStyle.transform[i]) {
	            if (typeof animatedStyle[key][i][transKey].getValue !== 'undefined') animatedStyle.transform[i][transKey].addListener(this.animatedValueUpdated);
	          }
	        }
	      } else animatedStyle[key].addListener(this.animatedValueUpdated);
	    }
	  },
	
	  unRegisterAnimatedStyles: function unRegisterAnimatedStyles(animatedStyle) {
	    for (var key in animatedStyle) {
	      if (key == 'transform') {
	        for (var i = 0; i < animatedStyle.transform.length; i++) {
	          for (var transKey in animatedStyle.transform[i]) {
	            if (typeof animatedStyle[key][i][transKey].getValue !== 'undefined') animatedStyle.transform[i][transKey].removeListener(this.animatedValueUpdated);
	          }
	        }
	      } else animatedStyle[key].removeListener(this.animatedValueUpdated);
	    }
	  },
	
	  animatedValueUpdated: function animatedValueUpdated(info) {
	    this.forceUpdate();
	  },
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        otherProps = _objectWithoutProperties(_props, ['style']);
	
	    var _state = this.state,
	        staticStyle = _state.staticStyle,
	        animatedStyle = _state.animatedStyle,
	        otherState = _objectWithoutProperties(_state, ['staticStyle', 'animatedStyle']);
	
	    var actualStyle = {};
	    for (var key in staticStyle) {
	      actualStyle[key] = staticStyle[key];
	    }for (var key in animatedStyle) {
	      if (key == 'transform') {
	        var actualTransform = [];
	        for (var i = 0; i < animatedStyle.transform.length; i++) {
	          var actualTranformItem = {};
	          for (var transKey in animatedStyle.transform[i]) {
	            if (typeof animatedStyle.transform[i][transKey].getValue !== 'undefined') {
	              actualTranformItem[transKey] = animatedStyle.transform[i][transKey].getValue();
	              if (transKey == "rotate" || transKey == "rotateY") actualTranformItem[transKey] += "deg";
	            } else actualTranformItem[transKey] = animatedStyle.transform[i][transKey];
	          }
	          actualTransform.push(actualTranformItem);
	        }
	        actualStyle.transform = actualTransform;
	      } else actualStyle[key] = animatedStyle[key].getValue();
	    }
	    // console.log("actualStyle", actualStyle)
	    return React.createElement(View, Object.assign({}, otherProps, { style: actualStyle }));
	  }
	});
	
	module.exports = Animated;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	var Globals = {
	  STATUS_BAR_HEIGHT: 0,
	  ACTION_BAR_HEIGHT: 44,
	  FEED_BOTTOM_SPACE_ADJUSTMENT: 0, //-30,
	  FEED_TOP_SPACE_ADJUSTMENT: 0, //44,
	  LAYOUT_HEIGHT_ADJUSTMENT: 0,
	  TOP_LEFT_STYLE_ADJUSTMENT: { marginLeft: 0 },
	  TOP_RIGHT_STYLE_ADJUSTMENT: { marginRight: 0, flexDirection: 'column' },
	  TOP_RIGHT_INNER_STYLE_ADJUSTMENT: { height: 28 },
	  TOP_CENTER_ADJUSTMENT: {},
	  TOP_CENTER_TEXT_ADJUSTMENT: { flex: 1 },
	  BANNER_ICON_ADJUSTMENT: { marginTop: 0 },
	  TUTORIAL_ICON_STYLE: {},
	  TAB_STYLE_ADJUSTMENT: {},
	  TAB_BAR_HEIGHT: 50,
	  addHardwareBackListener: function addHardwareBackListener(callback) {
	    // none existent on ios
	  },
	  removeHardwareBackListener: function removeHardwareBackListener(callback) {
	    // none existent on ios
	  }
	};
	
	module.exports = Globals;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	// Define action constants
	module.exports = {
		UserID: "UserID",
		UserName: "UserName",
		Password: "Password",
		Hash: "Hash",
		FirstName: "FirstName",
		LastName: "LastName",
		Birthday: "DOB",
		IsAdmin: "Admin",
		Credits: "Credit",
		Credit: "Credit",
		Points: "Points",
		UserCreditsQRID: "QRCode_Pay",
		UserPointsQRID: "QRCode_Redeem",
		LastFour: "STRIPE_lastFour",
		PaymentType: "STRIPE_paymentType",
		StripeKey: "STRIPE_pubKey",
		PayPalClientID: "PayPalClientID",
		PayPal_Environment: "PayPal_Environment",
		CardType: "STRIPE_cardType",
		PaymentInfo: "PaymentInfo",
		PayPal_ClientID: "PayPal_ClientID",
		DirtyPassword: "DirtyPassword",
		CC_Gateway_Primary: "CC_Gateway_Primary",
		PayMode: "PayMode",
		PhoneNumber: "PhoneNumber",
		ShowPhoneNumber: "ShowPhoneNumber",
		RequirePhoneForPurchase: "RequirePhoneForPurchase",
		RequirePhoneForRewards: "RequirePhoneForRewards",
		RequirePostalCode: "RequirePostalCode",
		RequirePhoneForPaymentTypes: "RequirePhoneForPaymentTypes",
		HasPassword: "HasPassword",
		HasFacebook: "HasFacebook",
		DefaultDistance: "DefaultDistance",
		UsePhoneLoyalty: "UsePhoneLoyalty",
		TotalCreditUsedAtScanner: "TotalCreditUsedAtScanner",
		TotalPointsUsedAtScanner: "TotalPointsUsedAtScanner",
		TotalPointsAddedAtScanner: "TotalPointsAddedAtScanner",
		OwnerUserID: "OwnerUserID",
		CanJoinGroups: "CanJoinGroups",
		JoinedGroupNames: "JoinedGroupNames",
		SupportEmail: "SupportEmail",
		ClassNames: "ClassNames"
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var ReUpText = __webpack_require__(8);
	
	var ReUpButton = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      text: "",
	      isSecondary: false,
	      useShadow: true,
	      isTertiary: false,
	      enabled: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      text: this.props.text
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.text !== 'undefined') this.setTitle(newProps.text);
	  },
	
	  setTitle: function setTitle(newText) {
	    this.setState({ text: newText });
	  },
	
	  render: function render() {
	    var _props = this.props,
	        text = _props.text,
	        appManager = _props.appManager,
	        icon = _props.icon,
	        isSecondary = _props.isSecondary,
	        isTertiary = _props.isTertiary,
	        isSkip = _props.isSkip,
	        style = _props.style,
	        other = _objectWithoutProperties(_props, ['text', 'appManager', 'icon', 'isSecondary', 'isTertiary', 'isSkip', 'style']);
	
	    if (Platform.OS == 'web') other.tabindex = -1;
	
	    var text = this.state.text;
	    if (appManager.useCapsButtons()) text = text.toUpperCase();
	    isSecondary = typeof isSecondary !== 'undefined' && isSecondary;
	    isTertiary = typeof isTertiary !== 'undefined' && isTertiary;
	    isSkip = typeof isSkip !== 'undefined' && isSkip;
	
	    var maskBorderRadius = 4;
	    if (appManager.buttonType() == 2) maskBorderRadius = 10;
	    if (appManager.buttonType() == 1) maskBorderRadius = 0;
	    if (typeof this.props.icon !== 'undefined' && text.length <= 0) maskBorderRadius = 12;
	    if (typeof this.props.maskBorderRadius !== 'undefined') maskBorderRadius = this.props.maskBorderRadius;
	
	    var buttonColor = typeof this.props.buttonColor !== 'undefined' ? this.props.buttonColor : isSecondary ? appManager.getColorForKey("ButtonSecondaryColor") : appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonTitleColor = typeof this.props.buttonTitleColor !== 'undefined' ? this.props.buttonTitleColor : isSecondary ? appManager.getColorForKey("ButtonSecondaryTitleColor") : appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var buttonBorderColor = isSecondary ? appManager.getColorForKey("ButtonSecondaryBorderColor") : appManager.getColorForKey("ButtonPrimaryBorderColor");
	
	    var rippleColor = isSecondary ? appManager.getColorForKey("ButtonPrimaryColor", 0.4) : appManager.getColorForKey("ButtonSecondaryColor", 0.4);
	
	    var fontSize = 20;
	    var moreStyle = { justifyContent: 'center', height: 40, borderRadius: maskBorderRadius, elevation: 2 };
	
	    if (isSkip) {
	      buttonColor = appManager.getColorForKey("HeaderColor");
	      buttonTitleColor = appManager.getColorForKey("HeaderIconColor");
	      buttonBorderColor = 'transparent';
	      moreStyle.height = 30;
	      fontSize = 16;
	      moreStyle.elevation = 0;
	    }
	
	    if (typeof style === 'undefined') style = {};
	    style = [moreStyle, style];
	
	    if (this.props.isTertiary) {
	      var internalContainerStyle = { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' };
	      if (Platform.OS === 'web') internalContainerStyle.height = "100%";
	
	      buttonTitleColor = appManager.getColorForKey("FeedCardBodyColor");
	      style.push({ elevation: 0 });
	      if (!this.props.enabled) style.push({ opacity: .4 });
	      buttonColor = 'transparent';
	      return React.createElement(
	        MKButton,
	        Object.assign({
	          allowFontScaling: false,
	          backgroundColor: buttonColor,
	          shadowRadius: 0,
	          shadowOffset: { width: 0, height: 0 },
	          shadowOpacity: 0,
	          shadowColor: 'transparent',
	          style: style,
	          enabled: this.props.enabled,
	          rippleColor: appManager.getColorForKey("FeedCardBannerColor", .2),
	          maskBorderRadius: maskBorderRadius,
	          testID: text
	        }, other),
	        React.createElement(
	          View,
	          { style: internalContainerStyle },
	          typeof this.props.children !== 'undefined' ? this.props.children : null,
	          typeof text !== 'undefined' && text.length > 0 ? React.createElement(
	            ReUpText,
	            { pointerEvents: 'none',
	              style: {
	                flex: 1,
	                textAlign: 'left',
	                marginLeft: 8,
	                alignSelf: 'center',
	                color: buttonTitleColor,
	                fontFamily: appManager.getFontForKey("Regular"),
	                backgroundColor: 'transparent' } },
	            text
	          ) : null,
	          typeof this.props.icon !== 'undefined' ? React.createElement(
	            View,
	            { style: [styles.bannerCircle, { backgroundColor: appManager.getColorForKey("ButtonSecondaryColor"), alignItems: 'center', justifyContent: 'center' }] },
	            React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 20, color: appManager.getColorForKey("ButtonSecondaryTitleColor"), style: { marginTop: 2, backgroundColor: 'transparent' } })
	          ) : null
	        )
	      );
	    } else if (typeof this.props.icon === 'undefined') {
	      var internalContainerStyle = { flexDirection: 'row', flex: 1, justifyContent: 'center', alignItems: 'center' };
	      if (Platform.OS === 'web') internalContainerStyle.height = "100%";
	
	      var textStyle = {
	        flex: 1,
	        textAlign: 'center',
	        lineHeight: 18,
	        alignSelf: 'center',
	        color: buttonTitleColor,
	        fontFamily: appManager.getFontForKey("Bold"),
	        backgroundColor: 'transparent',
	        fontWeight: 'bold',
	        paddingHorizontal: 4 };
	      if (typeof this.props.fontSize !== 'undefined') textStyle.fontSize = this.props.fontSize;
	      var shouldShowSquare = appManager.buttonType() == 1;
	      var shouldUseShadow = this.props.useShadow && appManager.buttonType() != 2;
	      if (appManager.buttonType() == 2 && this.props.isSecondary) {
	        style = StyleSheet.flatten([style, { borderColor: appManager.getColorForKey("ButtonPrimaryColor"), borderWidth: '1', borderStyle: 'solid', borderRadius: 8 }]);
	      } else if (appManager.buttonType() == 2) {
	        style = StyleSheet.flatten([style, _defineProperty({ borderRadius: 8, borderColor: appManager.getColorForKey("ButtonSecondaryColor"), borderWidth: '1', borderStyle: 'solid' }, 'borderRadius', 8)]);
	      }
	      return React.createElement(
	        MKButton,
	        Object.assign({
	          allowFontScaling: false,
	          backgroundColor: buttonColor,
	          shadowRadius: 2,
	          shadowOffset: { width: 0, height: 2 },
	          shadowOpacity: 0.9,
	          shadowColor: shouldShowSquare ? buttonBorderColor : 'transparent',
	          style: style,
	          rippleColor: rippleColor,
	          maskBorderRadius: maskBorderRadius,
	          testID: text,
	          disableBorder: appManager.buttonType() != 2
	        }, other),
	        shouldShowSquare ? React.createElement(View, { style: { position: 'absolute', top: 3, bottom: 3, left: 3, right: 3, borderColor: buttonTitleColor, borderWidth: 1, borderStyle: 'solid' } }) : null,
	        React.createElement(
	          View,
	          { style: internalContainerStyle },
	          typeof this.props.icon !== 'undefined' ? React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 30, color: buttonTitleColor }) : null,
	          typeof this.props.children !== 'undefined' ? this.props.children : null,
	          typeof text !== 'undefined' && text.length > 0 ? React.createElement(
	            ReUpText,
	            { isTitle: true, pointerEvents: 'none', appManager: appManager,
	              style: textStyle },
	            text
	          ) : null
	        )
	      );
	    } else {
	      var internalContainerStyle = { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' };
	      if (Platform.OS === 'web') internalContainerStyle.height = "100%";
	
	      var textStyle = {
	        textAlign: 'center',
	        lineHeight: 24,
	        alignSelf: 'center',
	        color: buttonTitleColor,
	        fontFamily: appManager.getFontForKey("Bold"),
	        backgroundColor: 'transparent',
	        fontWeight: 'bold' };
	      if (typeof this.props.fontSize !== 'undefined') textStyle.fontSize = this.props.fontSize;
	
	      return React.createElement(
	        MKButton,
	        Object.assign({
	          backgroundColor: buttonColor,
	          shadowRadius: 2,
	          shadowOffset: { width: 0, height: 2 },
	          shadowOpacity: 0.9,
	          shadowColor: this.props.useShadow ? buttonBorderColor : 'transparent',
	          style: style,
	          rippleColor: rippleColor,
	          maskBorderRadius: maskBorderRadius
	        }, other),
	        React.createElement(
	          View,
	          { style: internalContainerStyle },
	          typeof this.props.icon !== 'undefined' ? React.createElement(
	            View,
	            { style: { flex: 1, paddingLeft: typeof this.props.iconPaddingLeft !== 'undefined' ? this.props.iconPaddingLeft : 0 } },
	            React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: typeof this.props.iconSize === 'undefined' ? 30 : this.props.iconSize, color: buttonTitleColor })
	          ) : null,
	          typeof this.props.children !== 'undefined' ? this.props.children : null,
	          typeof text !== 'undefined' && text.length > 0 ? React.createElement(
	            View,
	            { style: { flex: -1, justifyContent: 'flex-start', flexDirection: 'row' } },
	            React.createElement(
	              ReUpText,
	              { isTitle: true, pointerEvents: 'none', appManager: appManager,
	                style: textStyle },
	              text
	            )
	          ) : null,
	          typeof this.props.icon !== 'undefined' ? React.createElement(
	            View,
	            { style: { flex: 1, justifyContent: 'flex-end', flexDirection: 'row' } },
	            typeof this.props.rightIcon !== 'undefined' ? React.createElement(_ReUpIcon2.default, { name: this.props.rightIcon, size: typeof this.props.iconSize === 'undefined' ? 30 : this.props.iconSize, color: buttonTitleColor }) : null
	          ) : null
	        )
	      );
	    }
	  }
	});
	
	var styles = StyleSheet.create({
	  bannerCircle: {
	    width: 25,
	    height: 25,
	    borderRadius: 25 / 2,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row',
	    marginRight: 3
	  }
	});
	
	module.exports = ReUpButton;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	// import * as FontAwesome from 'react-icons/lib/fa'
	// import FontAwesome from 'react-icons/lib/fa';
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var Icon = createReactClass({
	  displayName: 'Icon',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'black',
	      style: {},
	      name: 'pencil'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        name = _props.name,
	        color = _props.color,
	        otherProps = _objectWithoutProperties(_props, ['style', 'name', 'color']);
	
	    if (name == 'credit-pay') name = "money";
	    if (name == 'times') name = "times-circle";
	    if (name == "pay-shortcut") name = "money";
	    if (name == "usd") name = "money";
	    if (name == "users") name = "user-plus";
	    if (typeof style.color !== 'undefined' && this.props.color == 'black') color = style.color;
	    var TheClass = __webpack_require__(1257)("./" + name);
	    return React.createElement(
	      View,
	      { style: [style] },
	      React.createElement(TheClass, Object.assign({ style: { alignSelf: 'center' }, color: color }, otherProps))
	    );
	    // return <FontAwesome name="pencil" />
	    // return <MdIcon name="edit" />
	    // return <FontAwesome {...this.props} />
	  }
	});
	
	module.exports = Icon;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactMaterialize = __webpack_require__(1294);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var ReactDOM = __webpack_require__(65);
	var createReactClass = __webpack_require__(5);
	
	var StyleSheet = ReactNative.StyleSheet,
	    View = ReactNative.View,
	    TextInput = ReactNative.TextInput,
	    CheckBox = ReactNative.CheckBox;
	
	
	var ReUpText = __webpack_require__(8);
	var Animated = __webpack_require__(9);
	
	var MKButton = createReactClass({
	  displayName: 'MKButton',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onPress: function onPress() {},
	      style: {},
	      backgroundColor: null,
	      enabled: true,
	      disableBorder: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var element = ReactDOM.findDOMNode(this._button);
	    element.setAttribute('tabindex', '-1');
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        onPress = _props.onPress,
	        style = _props.style,
	        backgroundColor = _props.backgroundColor,
	        enabled = _props.enabled,
	        disableBorder = _props.disableBorder,
	        otherProps = _objectWithoutProperties(_props, ['onPress', 'style', 'backgroundColor', 'enabled', 'disableBorder']);
	
	    var newStyle = [];
	    newStyle.push({ backgroundColor: 'transparent' });
	    newStyle.push(style);
	    if (backgroundColor != null) newStyle.push({ backgroundColor: backgroundColor });
	    if (disableBorder) newStyle.push({ border: 'none' });
	    newStyle = StyleSheet.flatten(newStyle);
	    newStyle.flexDirection = "column";
	    newStyle.alignItems = "stretch";
	    newStyle.boxShadow = "0px 0px 5px " + this.props.shadowColor;
	    newStyle.cursor = "pointer";
	    if (typeof newStyle.marginHorizontal !== 'undefined' && typeof newStyle.marginLeft === 'undefined') newStyle.marginLeft = newStyle.marginHorizontal;
	    if (typeof newStyle.marginHorizontal !== 'undefined' && typeof newStyle.marginRight === 'undefined') newStyle.marginRight = newStyle.marginHorizontal;
	
	    return React.createElement(_reactMaterialize.Button, Object.assign({ ref: function ref(a) {
	        return _this._button = a;
	      }, waves: 'light', onClick: onPress, style: newStyle, disabled: !enabled }, otherProps));
	  }
	});
	
	MKButton.accentColoredFab = function () {
	  var defaultStyle = { width: 60, height: 60, borderRadius: 30, backgroundColor: 'red' };
	  var button = {
	    defaultProps: {
	      onPress: function onPress() {},
	      backgroundColor: null,
	      style: {}
	    },
	
	    getDefaultProps: function getDefaultProps() {
	      return this.defaultProps;
	    },
	
	    componentDidMount: function componentDidMount() {
	      var element = ReactDOM.findDOMNode(this._button);
	      element.setAttribute('tabindex', '-1');
	    },
	
	    render: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          onPress = _props2.onPress,
	          backgroundColor = _props2.backgroundColor,
	          style = _props2.style,
	          otherProps = _objectWithoutProperties(_props2, ['onPress', 'backgroundColor', 'style']);
	
	      var newStyle = [];
	      newStyle.push(style);
	      if (backgroundColor != null) newStyle.push({ backgroundColor: backgroundColor });
	      newStyle.push({ border: 'none' });
	      newStyle = StyleSheet.flatten(newStyle);
	      newStyle.cursor = "pointer";
	
	      return React.createElement(_reactMaterialize.Button, Object.assign({ ref: function ref(a) {
	          return _this2._button = a;
	        }, onClick: onPress, floating: true, large: true, style: newStyle }, otherProps));
	    }
	  };
	  button.withStyle = function (style) {
	    button.defaultProps.style = [defaultStyle, style];
	
	    return button;
	  };
	  button.build = function () {
	    return createReactClass(button);
	  };
	
	  return button;
	};
	
	var MKTextField = createReactClass({
	  displayName: 'MKTextField',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      floatingLabelFont: {},
	      textInputStyle: {},
	      highlightColor: 'transparent',
	      tintColor: 'transparent',
	      password: false,
	      onSubmitEditing: function onSubmitEditing() {},
	      maxLength: 100000
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var state = {};
	    state.text = "";
	    if (typeof this.props.value !== 'undefined') state.text = this.props.value;
	    for (var key in this.props) {
	      state[key] = this.props[key];
	    }state.isFocused = false;
	
	    return state;
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    this.setState(newProps);
	  },
	
	  componentDidMount: function componentDidMount() {
	    var element = ReactDOM.findDOMNode(this._input);
	    element.setAttribute('tabindex', '-1');
	  },
	
	  focus: function focus() {
	    if (this._input) this._input.focus();
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    var thisThing = this;
	    var isFocused = this.state.isFocused;
	    var otherProps = {};
	    if (typeof this.props.keyboardType !== 'undefined') otherProps.keyboardType = this.props.keyboardType;
	
	    var showFloating = this.state.text.length > 0;
	
	    return React.createElement(
	      View,
	      { key: "container", style: [this.state.style, { flexDirection: 'column', alignItems: 'stretch' }] },
	      React.createElement(
	        View,
	        { key: "floatingcontainer", style: { height: 12 } },
	        React.createElement(
	          ReUpText,
	          { style: [this.state.floatingLabelFont, { color: showFloating ? isFocused ? this.state.highlightColor : this.state.placeholderTextColor : 'transparent' }] },
	          this.state.placeholder
	        )
	      ),
	      React.createElement(
	        View,
	        { key: "lowercontainer", style: { flexDirection: 'column', alignItems: 'stretch' } },
	        React.createElement(TextInput, Object.assign({ ref: function ref(a) {
	            if (a != null) thisThing._input = a;
	          },
	          key: "input",
	          onFocus: function onFocus() {
	            thisThing.setState({ isFocused: true });
	          }, onBlur: function onBlur() {
	            return _this3.setState({ isFocused: false });
	          },
	          placeholder: showFloating ? "" : this.state.placeholder,
	          style: StyleSheet.flatten([this.state.textInputStyle, { marginBottom: 0, width: '100%', borderColor: this.state.tintColor }]),
	          value: this.state.text,
	          onChangeText: function onChangeText(text) {
	            thisThing.setState({ text: text });
	            if (typeof thisThing.props.onChangeText !== 'undefined') thisThing.props.onChangeText(text);
	          },
	          secureTextEntry: this.state.password,
	          onSubmitEditing: this.props.onSubmitEditing,
	          tabindex: "-1",
	          maxLength: this.props.maxLength
	        }, otherProps)),
	        React.createElement(View, { style: { height: 2, backgroundColor: isFocused ? this.state.highlightColor : this.state.tintColor } })
	      )
	    );
	  }
	});
	
	var MKSpinner = createReactClass({
	  displayName: 'MKSpinner',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      rotation: new Animated.Value(0, "spinner")
	    };
	  },
	
	  _isMounted: true,
	  componentDidMount: function componentDidMount() {
	    this.startRotation();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._animation && this._animation.stop) this._animation.stop();
	  },
	
	  startRotation: function startRotation() {
	    this._animation = Animated.timing(this.state.rotation, {
	      toValue: 360 * 30,
	      duration: 30000
	    }).start(function () {});
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var borderColors = {};
	    if (typeof this.props.strokeColor !== 'undefined') {
	      if (this.props.strokeColor.length == 1) borderColors.borderTopColor = this.props.strokeColor[0];else if (this.props.strokeColor.length == 2) {
	        borderColors.borderTopColor = this.props.strokeColor[0];
	        borderColors.borderBottomColor = this.props.strokeColor[1];
	      }
	    }
	
	    return React.createElement(
	      View,
	      { style: StyleSheet.flatten([thisThing.props.style, { height: 30, width: 30 }]) },
	      React.createElement(Animated.View, { style: [{ transform: [{ rotate: thisThing.state.rotation }], flex: 1, alignSelf: 'stretch', borderWidth: 2, borderRadius: 100, borderColor: 'transparent', borderStyle: 'solid' }, borderColors] })
	    );
	  }
	});
	
	var MKCheckbox = createReactClass({
	  displayName: 'MKCheckbox',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: { flex: -1, width: 28, height: 28, paddingTop: 4 },
	      checked: false,
	      description: null,
	      clickHandler: null,
	      fillColor: '#000',
	      textColor: 'black',
	      checkboxSideLength: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checked: this.props.checked,
	      description: this.props.description,
	      style: { flex: -1, width: 28, height: 28, paddingTop: 4 }
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.clickHandler !== null) {
	      this.setState({ clickHandler: newProps.clickHandler });
	    }
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  render: function render() {
	    var _props3 = this.props,
	        style = _props3.style,
	        fillColor = _props3.fillColor,
	        borderOnColor = _props3.borderOnColor,
	        borderOffColor = _props3.borderOffColor,
	        borderOffColor = _props3.borderOffColor,
	        rippleColor = _props3.rippleColor,
	        otherProps = _objectWithoutProperties(_props3, ['style', 'fillColor', 'borderOnColor', 'borderOffColor', 'borderOffColor', 'rippleColor']);
	
	    var thisThing = this;
	
	    return React.createElement(
	      View,
	      { style: [style, { flexDirection: 'row', width: '100%' }] },
	      React.createElement(
	        _reactMaterialize.Button,
	        { waves: 'light', style: {
	            backgroundColor: this.state.checked ? 'transparent' : 'transparent',
	            border: 'none',
	            display: 'flex'
	          },
	          onClick: function onClick() {
	            thisThing.setState({ checked: !thisThing.state.checked });
	            if (typeof thisThing.props.clickHandler !== null || typeof thisThing.props.clickHandler !== 'undefined') thisThing.props.clickHandler(!thisThing.state.checked);
	          } },
	        this.props.checkboxSideLength == null ? React.createElement(CheckBox, { color: this.props.fillColor, value: thisThing.state.checked, style: { alignSelf: 'center' } }) : React.createElement(CheckBox, { color: this.props.fillColor, value: thisThing.state.checked, style: { height: this.props.checkboxSideLength, width: this.props.checkboxSideLength, alignSelf: 'center' } }),
	        React.createElement(
	          View,
	          { style: { flex: 1, display: 'flex' } },
	          React.createElement(
	            ReUpText,
	            { style: { color: this.props.textColor, paddingLeft: 12 }, numberOfLines: 3 },
	            this.props.description
	          )
	        )
	      )
	    );
	  }
	
	});
	
	var MKIconToggle = createReactClass({
	  displayName: 'MKIconToggle',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: { flex: -1, width: 28, height: 28, paddingTop: 4 },
	      checked: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      checked: this.props.checked
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.checked !== 'undefined') this.setState({ checked: newProps.checked });
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  render: function render() {
	    var _props4 = this.props,
	        style = _props4.style,
	        fillColor = _props4.fillColor,
	        borderOnColor = _props4.borderOnColor,
	        borderOffColor = _props4.borderOffColor,
	        borderOffColor = _props4.borderOffColor,
	        rippleColor = _props4.rippleColor,
	        otherProps = _objectWithoutProperties(_props4, ['style', 'fillColor', 'borderOnColor', 'borderOffColor', 'borderOffColor', 'rippleColor']);
	
	    var thisThing = this;
	    return React.createElement(
	      View,
	      { style: style },
	      React.createElement(View, { style: { flex: 1 } }),
	      React.createElement(
	        _reactMaterialize.Button,
	        { waves: 'light', style: {
	            backgroundColor: this.state.checked ? 'transparent' : 'transparent',
	            border: 'none',
	            flex: -1
	          },
	          onClick: function onClick() {
	            var newState = {
	              checked: !thisThing.state.checked
	            };
	            thisThing.setState(newState);
	            thisThing.props.onCheckedChange(newState);
	          } },
	        this.state.checked ? this.props.children[0] : this.props.children[1]
	      ),
	      React.createElement(View, { style: { flex: 1 } })
	    );
	  }
	});
	
	module.exports = {
	  MKButton: MKButton,
	  MKTextField: MKTextField,
	  MKSpinner: MKSpinner,
	  MKIconToggle: MKIconToggle,
	  MKCheckbox: MKCheckbox,
	  MKRadioButton: MKCheckbox
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var ModelConstants = __webpack_require__(11);
	var CryptoJS = __webpack_require__(1178);
	var Buffer = __webpack_require__(79).Buffer;
	var AnalyticsManager = __webpack_require__(50);
	
	// var $ = require('@rtorr/ajax-only');
	// var Feed = require('./reup-components/Feed');
	
	var shouldRecordHistory = false;
	var shouldUseHistory = false;
	
	var ENABLE_LOGGING = false;
	//ENABLE_LOGGING = true;
	
	global.btoa = function (str) {
		return new Buffer(str).toString('base64');
	};
	global.atob = function (str) {
		return new Buffer(str, 'base64').toString('ascii');
	};
	
	var AVAILABLE_CHARS_FOR_RANDOM_STRING = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	function randomString(length) {
		var result = '';
		for (var i = length; i > 0; --i) {
			result += AVAILABLE_CHARS_FOR_RANDOM_STRING[Math.floor(Math.random() * AVAILABLE_CHARS_FOR_RANDOM_STRING.length)];
		}return result;
	}
	
	var NetworkManager = {
		_getAllPreviouslyUpdate: {},
		updateFeature: function updateFeature(appManager, featureName, success, failure) {
			var methodName = featureName == "Users" ? "GetUser" : "Get" + featureName;
			var thisThing = this;
			appManager.getCurrentUser(function (user) {
				var parameters = user != null ? [user[ModelConstants.UserName]] : [];
				thisThing.rpcCall(appManager, methodName, parameters, function (data) {
					var featureDatas = {};
					if (featureName == "Users") {
						featureDatas[featureName] = [data];
					} else {
						featureDatas[featureName] = data;
					}
					// NetworkActions.featureUpdated(featureDatas);
					success(data);
				}, function (data) {
					if (typeof failure !== 'undefined') failure(data);
				}, function (data) {
					if (typeof failure !== 'undefined') failure(data);
				});
			});
		},
	
		hasUpdated: function hasUpdated(featureNames) {
			for (var i = 0; i < featureNames.length; i++) {
				var featureName = featureNames[i];
				if (typeof this._getAllPreviouslyUpdate[featureName] === 'undefined' || !this._getAllPreviouslyUpdate[featureName]) {
					return false;
				}
			}
	
			return true;
		},
	
		update: function update(appManager, featureNames, success, failure) {
			if (typeof featureNames === 'undefined' || featureNames == null || featureNames.length <= 0) {
				success({});
				return;
			}
	
			for (var i = 0; i < featureNames.length; i++) {
				var featureName = featureNames[i];
				this._getAllPreviouslyUpdate[featureName] = true;
			}
	
			var methodName = "GetAll";
			var featureNamesRefined = [];
			for (var i = 0; i < featureNames.length; i++) {
				var featureName = featureNames[i];
				if (featureName == "Users" || featureName == "User") {
					if (appManager.isLoggedIn()) featureNamesRefined.push("User");
				} else {
					featureNamesRefined.push(featureName);
				}
			}
			this.rpcCall(appManager, methodName, [featureNamesRefined], function (data, error) {
				for (var key in data) {
					if ((key == "Users" || key == "User") && typeof data[key].UserID !== 'undefined') {
						data["Users"] = [data[key]];
					}
				}
				//console.log("Getall: " + JSON.stringify(data))
				success(data, error);
			}, function (data) {
				// alert(JSON.stringify(data))
				failure(data);
			}, function (data) {
				// alert(JSON.stringify(data))
				failure(data);
			});
		},
	
		updateUser: function updateUser(appManager, userObject, success, failure, networkFailure) {
			var methodName = "UpdateUser";
			var parameters = [userObject];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		login: function login(appManager, username, password, success, fail, networkFailure) {
			var methodName = "GetUser";
			var networkManager = this;
			appManager.getCurrentUser(function (user) {
				var parameters = user != null ? [user[ModelConstants.UserName]] : [];
				networkManager.rpcCallUserPass(appManager, username, password, methodName, parameters, function (data) {
					var featureDatas = {};
					data[ModelConstants.Password] = password;
					featureDatas["Users"] = [data];
					//console.log(JSON.stringify(data))
					// NetworkActions.featureUpdated(featureDatas)
					if (data[ModelConstants.UserName].length > 0) {
						// NetworkActions.userLoggedIn(data)
					}
					success(data);
				}, function (data) {
					fail(data);
				}, function (data) {
					if (typeof networkFailure !== 'undefined') networkFailure(data);
				});
			});
		},
	
		_domain: "",
		domainLogin: function domainLogin(appManager, domain, username, password, success, failure) {
			var methodName = "GetUser";
			appManager._domain = domain;
			var parameters = [username, password];
			this.rpcCallUserPass(appManager, username, password, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		createUser: function createUser(appManager, username, password, firstName, lastName, birthday, refCode, optIn, success, failure) {
			var methodName = "CreateAccount";
			var parameters = [username, password, firstName, lastName, birthday, refCode, optIn];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data["UserName"]);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		createUserVerified: function createUserVerified(appManager, username, password, firstName, lastName, birthday, refCode, optIn, success, failure) {
			var methodName = "CreateAccountVerified";
			var parameters = [username, password, firstName, lastName, birthday, refCode, optIn];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data["UserName"]);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		createUserEmail: function createUserEmail(appManager, username, firstName, lastName, birthday, refCode, optIn, linkUserID, linkUserHash, success, failure) {
			var methodName = "CreateAccountWithEmail";
			var parameters = [username, firstName, lastName, birthday, refCode, optIn, linkUserID, linkUserHash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		createUserFacebook: function createUserFacebook(appManager, facebookID, refCode, optIn, success, failure) {
			var methodName = "CreateAccountFacebook";
			var parameters = [facebookID, refCode, optIn];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data["UserName"]);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		getUser: function getUser(appManager, userID, hash, success, failure) {
			var methodName = "GetUser";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		optOutPhone: function optOutPhone(appManager, userID, hash, success, failure) {
			var methodName = "OptOutPhone";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		optInPhone: function optInPhone(appManager, userID, hash, success, failure) {
			var methodName = "OptInPhone";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		optOutEmail: function optOutEmail(appManager, userID, hash, success, failure) {
			var methodName = "OptOutEmail";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		optInEmail: function optInEmail(appManager, userID, hash, success, failure) {
			var methodName = "OptInEmail";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		linkUsers: function linkUsers(appManager, userID, hash, success, failure) {
			var methodName = "LinkUsers";
			var parameters = [userID, hash];
			this.rpcCall(appManager, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		getLinkedUsers: function getLinkedUsers(appManager, userID, hash, success, failure) {
			var methodName = "GetLinkedUsers";
			var parameters = [userID, hash];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				failure(data);
			});
		},
	
		refund: function refund(appManager, transactionID, success, failure) {
			var thisThing = this;
			var methodName = "RefundTransaction";
			var parameters = [transactionID];
			var thisThing = this;
			appManager.getCurrentUser(function (user) {
				thisThing.rpcCall(appManager, methodName, parameters, function (data) {
					success(data);
				}, function (data) {
					if (typeof failure !== 'undefined') failure(data);
				}, function (data) {
					if (typeof failure !== 'undefined') failure(data);
				});
			});
		},
	
		sendPhoneNumberCode: function sendPhoneNumberCode(appManager, phoneNumber, success, failure, networkFailure) {
			var methodName = "SendPhoneNumberCode";
			var parameters = [phoneNumber];
			this.rpcCall(appManager, methodName, parameters, function (data) {
				success();
			}, function (data) {
				failure(data);
			}, function (data) {
				if (typeof networkFailure !== 'undefined') networkFailure();
			});
		},
	
		verifyAndSetPhoneNumber: function verifyAndSetPhoneNumber(appManager, phoneNumber, code, success, failure, networkFailure) {
			var methodName = "VerifyAndSetPhoneNumber";
			var parameters = [phoneNumber, code];
			this.rpcCall(appManager, methodName, parameters, function (data) {
				success(data);
			}, function (data) {
				failure(data);
			}, function (data) {
				if (typeof networkFailure !== 'undefined') networkFailure();
			});
		},
	
		forgotPassword: function forgotPassword(appManager, username, success, failure, networkFailure) {
			var methodName = "ForgotPassword";
			var parameters = [username];
			this.rpcCallUserPass(appManager, null, null, methodName, parameters, function (data) {
				success();
			}, function (data) {
				failure(data);
			}, function (data) {
				if (typeof networkFailure !== 'undefined') networkFailure();
			});
		},
	
		getOneTimeRewards: function getOneTimeRewards(appManager, userID, hash, success, failure, networkFailure) {
			var methodName = "GetOneTimeRewards";
			var parameters = [];
			if (userID != null && hash != null) parameters = [userID, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, function (data) {
				if (typeof networkFailure !== 'undefined') networkFailure();
			});
		},
	
		unverifyAccount: function unverifyAccount(appManager, userID, hash, success, failure, networkFailure) {
			var methodName = "UnverifyAccount";
			var parameters = [userID, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		resendVerification: function resendVerification(appManager, userID, hash, success, failure, networkFailure) {
			var methodName = "ResendVerification";
			var parameters = [userID, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		stripeFetchToken: function stripeFetchToken(stripePublicKey, cardNumber, expMonth, expYear, cvc, postalZip, success, networkFailure) {
			var cardDetails = {
				"card[number]": cardNumber,
				"card[exp_month]": expMonth,
				"card[exp_year]": expYear,
				"card[cvc]": cvc
			};
	
			if (postalZip != null) {
				cardDetails["card[address_zip]"] = postalZip;
				// cardDetails["card[address_zip_check]"] = "fail";
			}
	
			var formBody = [];
			for (var property in cardDetails) {
				var encodedKey = encodeURIComponent(property);
				var encodedValue = encodeURIComponent(cardDetails[property]);
				formBody.push(encodedKey + "=" + encodedValue);
			}
			formBody = formBody.join("&");
	
			if (ENABLE_LOGGING) {
				console.log('https://api.stripe.com/v1/tokens', formBody);
			}
	
			var responseTextCached = "";
			return fetch('https://api.stripe.com/v1/tokens', {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': 'Bearer ' + stripePublicKey
				},
				body: formBody
			}).then(function (response) {
				return response.text();
			}).then(function (responseText) {
				responseTextCached = responseText;
				if (ENABLE_LOGGING) console.log(responseText);
				var data = JSON.parse(responseText);
				//console.log("not err?: " + JSON.stringify(responseText))
				success(data);
			}).catch(function (err) {
				AnalyticsManager.logException("stripeFetchToken error :: " + JSON.stringify(err));
				if (ENABLE_LOGGING) console.log("dataerr: " + JSON.stringify(err));
				if (networkFailure) networkFailure(err);
			});
		},
	
		beanStreamFetchToken: function beanStreamFetchToken(cardNumber, expMonth, expYear, cvc, success, networkFailure) {
			var url = "https://www.beanstream.com/scripts/tokenization/tokens";
			var cardDetails = {
				"number": cardNumber,
				"expiry_month": expMonth,
				"expiry_year": expYear,
				"cvd": cvc
			};
	
			var formBody = [];
			for (var property in cardDetails) {
				var encodedKey = encodeURIComponent(property);
				var encodedValue = encodeURIComponent(cardDetails[property]);
				formBody.push(encodedKey + "=" + encodedValue);
			}
			formBody = formBody.join("&");
	
			formBody = JSON.stringify(cardDetails);
			var responseTextCached = "";
			return fetch(url, {
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				body: formBody
			}).then(function (response) {
				return response.text();
			}).then(function (responseText) {
				responseTextCached = responseText;
				var data = JSON.parse(responseText);
				//console.log("beanstream: " + JSON.stringify(responseText))
				success(data);
			}).catch(function (err) {
				//console.log("dataerr: " + JSON.stringify(err))
				AnalyticsManager.logException("beanStreamFetchToken error :: " + responseTextCached + " :: " + JSON.stringify(err));
				if (networkFailure) networkFailure(err);
			});
		},
	
		setPayPal: function setPayPal(appManager, authorizationToken, username, success, failure, networkFailure) {
			var methodName = "SetPP";
			var parameters = [authorizationToken, username];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		setCreditCard: function setCreditCard(appManager, token, lastFour, expMonth, expYear, cardType, success, failure, networkFailure) {
			var methodName = "SetCC";
			var parameters = [token, lastFour, expMonth, expYear, cardType];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		submitPPPayment: function submitPPPayment(appManager, amount, clientMetadataID, refreshToken, success, failure, networkFailure) {
			var methodName = "ChargePP";
			var parameters = [amount, clientMetadataID, refreshToken];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		submitCCPayment: function submitCCPayment(appManager, amount, cardID, success, failure, networkFailure) {
			var methodName = "ChargeCC";
			var parameters = [amount, cardID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		submitPayment: function submitPayment(appManager, amount, paymentObj, success, failure, networkFailure) {
			var methodName = "ChargeAndAddCredit";
			var parameters = [amount, paymentObj];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		submitPassPayment: function submitPassPayment(appManager, passID, paymentObj, success, failure, networkFailure) {
			var methodName = "ChargeAndAddPass";
			var parameters = [passID, paymentObj];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorRedeemPass: function vendorRedeemPass(appManager, userID, passID, hash, success, failure, networkFailure) {
			var methodName = "VendorRedeemPass";
			var parameters = [userID, passID, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		sendCredit: function sendCredit(appManager, amount, email, message, firstName, lastName, success, failure, networkFailure) {
			var methodName = "SendCredit";
			var parameters = [amount, email, message, firstName, lastName];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		sendGiftCard: function sendGiftCard(appManager, amount, email, message, firstName, lastName, paymentObj, success, failure, networkFailure) {
			var methodName = "SendGC";
			var parameters = [amount, email, message, firstName, lastName, paymentObj];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		absorbGiftCardByUserID: function absorbGiftCardByUserID(appManager, giftCardUserID, pin, success, failure, networkFailure) {
			var methodName = "AbsorbGCByUserID";
			var parameters = [giftCardUserID, pin];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		absorbGiftCardByNumber: function absorbGiftCardByNumber(appManager, giftCardNumber, pin, success, failure, networkFailure) {
			var methodName = "AbsorbGCByGCNum";
			var parameters = [giftCardNumber, pin];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorUseCredit: function vendorUseCredit(appManager, userID, amount, userType, hash, tipType, tipAmount, success, failure, networkFailure) {
			var methodName = "VendorUseCredit";
			var parameters = [userID, amount, userType, hash, tipType, tipAmount];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorAddCreditGC: function vendorAddCreditGC(appManager, userID, amount, userType, hash, success, failure, networkFailure) {
			var methodName = "VendorAddCreditGiftCard";
			var parameters = [userID, amount, userType, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorRedeemReward: function vendorRedeemReward(appManager, userID, rewardID, userType, hash, success, failure, networkFailure) {
			var methodName = "VendorRedeemReward";
			var parameters = [userID, rewardID, userType, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		clientRedeemReward: function clientRedeemReward(appManager, rewardID, success, failure, networkFailure) {
			var methodName = "RedeemReward";
			var parameters = [rewardID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorCheckIn: function vendorCheckIn(appManager, userID, dollarAmount, userType, hash, success, failure, networkFailure) {
			var methodName = "CheckIn";
			var parameters = [userID, hash, dollarAmount];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		vendorTransferLoyaltyCampaign: function vendorTransferLoyaltyCampaign(appManager, userID, email, phone, externalID, hash, success, failure, networkFailure) {
			var methodName = "TransferLoyaltyToGiftCard";
			var parameters = [userID, hash, email, phone, externalID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		referEmail: function referEmail(appManager, email, firstName, lastName, success, failure, networkFailure) {
			var methodName = "SendReferralEmail";
			var parameters = [email, firstName, lastName];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		transferLoyaltyCampaign: function transferLoyaltyCampaign(appManager, email, phone, cardID, success, failure, networkFailure) {
			var methodName = "TransferLoyalty";
			var parameters = [email, phone, cardID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getGCInfoByUserID: function getGCInfoByUserID(appManager, giftCardUserID, pin, success, failure, networkFailure) {
			var methodName = "GetGCInfoByUserID";
			var parameters = [giftCardUserID, pin];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getGCInfoByGCNum: function getGCInfoByGCNum(appManager, giftCardNumber, pin, success, failure, networkFailure) {
			var methodName = "GetGCInfoByGCNum";
			var parameters = [giftCardNumber, pin];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getGCInfoByUserIDVendor: function getGCInfoByUserIDVendor(appManager, userID, hash, success, failure, networkFailure) {
			var methodName = "VendorGetGCUser";
			var parameters = [userID, hash];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
			// this.rpcCall( appManager, methodName, parameters, success, function(data){success({UserID:123,Credit:23.4,Points:167})}, networkFailure);
		},
	
		setPrimaryPaymentMethod: function setPrimaryPaymentMethod(appManager, refreshOrCardID, success, failure, networkFailure) {
			var methodName = "SetPrimaryPaymentMethod";
			var parameters = [refreshOrCardID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		removePaymentMethod: function removePaymentMethod(appManager, refreshOrCardID, success, failure, networkFailure) {
			var methodName = "RemovePaymentMethod";
			var parameters = [refreshOrCardID];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		changePassword: function changePassword(appManager, newPassword, success, failure, networkFailure) {
			var methodName = "ChangePassword";
			var parameters = [newPassword];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		resendVerifyEmail: function resendVerifyEmail(appManager, email, success, failure, networkFailure) {
			var methodName = "SendVerifyEmail";
			var parameters = [email];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		joinGroup: function joinGroup(appManager, groupCode, success, failure, networkFailure) {
			var methodName = "JoinGroup";
			var parameters = [groupCode];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getGrabbInfo: function getGrabbInfo(appManager, merchantID, currentDateTime, success, failure, networkFailure) {
			var methodName = "GetGrabbLocations";
			var parameters = [merchantID, currentDateTime];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getAuphanInfo: function getAuphanInfo(appManager, orderingType, merchantID, currentDateTime, lat, lng, success, failure, networkFailure) {
			var methodName = "GetOrderingLocations";
			var parameters = [merchantID, currentDateTime, lat, lng, orderingType];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getActiveOrders: function getActiveOrders(appManager, orderingType, merchantID, locationID, token, currentDateTime, lat, lng, success, failure, networkFailure) {
			var methodName = "GetOrderingActiveOrders";
			var parameters = [merchantID, currentDateTime, lat, lng, locationID, token, orderingType];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		uploadSelfie: function uploadSelfie(appManager, selfieURL, success, failure, networkFailure) {
			var methodName = "UploadSelfieToAmazon";
			var parameters = [selfieURL];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		lookUpUserByPhone: function lookUpUserByPhone(appManager, phoneNumber, success, failure, networkFailure) {
			var methodName = "LookUpUserByPhone";
			var parameters = [phoneNumber];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		createUserByPhone: function createUserByPhone(appManager, phone, countryCode, recaptcha, success, failure, networkFailure) {
			var methodName = "CreateAccountWithPhone";
			var parameters = [phone, null, null, null, null, null, countryCode, recaptcha];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		_companyLogin: "reupdemo4",
		_apiKey: "4ac8f50ea5f13f8c5e0a2f6175a763c3213c2e50b66882bbb93611f94620b77f",
		getSimplyBookToken: function getSimplyBookToken(appManager, success, failure, networkFailure) {
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			if (appManager.SIMPLY_BOOK_TOKEN != null && typeof appManager.SIMPLY_BOOK_TOKEN !== 'undefined') {
				success(appManager.SIMPLY_BOOK_TOKEN);
			} else {
				this.callURL("https://user-api.simplybook.me/login", null, null, { "jsonrpc": "2.0", "method": "getToken", "params": [companyLogin, apiKey], "id": randomString(8) }, function (data) {
					appManager.SIMPLY_BOOK_TOKEN = JSON.parse(data).result;
					success(appManager.SIMPLY_BOOK_TOKEN);
				}, failure, networkFailure);
			}
		},
	
		getSimplyBookEvents: function getSimplyBookEvents(appManager, success, failure, networkFailure) {
			var thisThing = this;
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			if (appManager.SIMPLY_BOOK_EVENTS != null && typeof appManager.SIMPLY_BOOK_EVENTS !== 'undefined') {
				success(appManager.SIMPLY_BOOK_EVENTS);
			} else {
				this.getSimplyBookToken(appManager, function (token) {
					thisThing.callURL("https://user-api.simplybook.me/", null, { "X-Company-Login": companyLogin, "X-Token": token }, { "jsonrpc": "2.0", "method": "getEventList", "params": [], "id": randomString(8) }, function (dataString) {
						var events = [];
						var data = JSON.parse(dataString);
						for (var key in data.result) {
							events.push(data.result[key]);
						}
						appManager.SIMPLY_BOOK_EVENTS = events;
						success(appManager.SIMPLY_BOOK_EVENTS);
					}, failure, networkFailure);
				}, failure, networkFailure);
			}
		},
	
		getSimplyBookPerformers: function getSimplyBookPerformers(appManager, success, failure, networkFailure) {
			var thisThing = this;
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			if (appManager.SIMPLY_BOOK_PERFORMERS != null && typeof appManager.SIMPLY_BOOK_PERFORMERS !== 'undefined') {
				success(appManager.SIMPLY_BOOK_PERFORMERS);
			} else {
				this.getSimplyBookToken(appManager, function (token) {
					thisThing.callURL("https://user-api.simplybook.me/", null, { "X-Company-Login": companyLogin, "X-Token": token }, { "jsonrpc": "2.0", "method": "getUnitList", "params": [], "id": randomString(8) }, function (dataString) {
						var performers = [];
						var data = JSON.parse(dataString);
						for (var key in data.result) {
							performers.push(data.result[key]);
						}
						appManager.SIMPLY_BOOK_PERFORMERS = performers;
						success(appManager.SIMPLY_BOOK_PERFORMERS);
					}, failure, networkFailure);
				}, failure, networkFailure);
			}
		},
	
		getSimplyBookTimeIntervals: function getSimplyBookTimeIntervals(appManager, dateFrom, dateTo, eventID, unitID, success, failure, networkFailure) {
			var thisThing = this;
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			this.getSimplyBookToken(appManager, function (token) {
				var mm = dateFrom.getMonth() + 1; // getMonth() is zero-based
				var dd = dateFrom.getDate();
				var dateStringFrom = [dateFrom.getFullYear(), mm <= 9 ? '0' : "", mm, dd <= 9 ? '0' : "", dd].join('');
	
				var mm = dateTo.getMonth() + 1; // getMonth() is zero-based
				var dd = dateTo.getDate();
				var dateStringTo = [dateTo.getFullYear(), mm <= 9 ? '0' : "", mm, dd <= 9 ? '0' : "", dd].join('');
	
				// console.log("https://user-api.simplybook.me/", {"X-Company-Login":companyLogin, "X-Token":token}, {"jsonrpc":"2.0","method":"getAvailableTimeIntervals","params":[dateStringFrom, dateStringTo, eventID, unitID, "1"],"id":1})
				thisThing.callURL("https://user-api.simplybook.me/", null, { "X-Company-Login": companyLogin, "X-Token": token }, { "jsonrpc": "2.0", "method": "getAvailableTimeIntervals", "params": [dateStringFrom, dateStringTo, eventID, unitID, "1"], "id": randomString(8) }, function (dataString) {
					// console.log("getSimplyBookTimeIntervals",dataString)
					var data = JSON.parse(dataString);
					success(data.result);
				}, failure, networkFailure);
			}, failure, networkFailure);
		},
	
		getSimplyBookTimeframe: function getSimplyBookTimeframe(appManager, success, failure, networkFailure) {
			if (appManager.SIMPLY_BOOK_TIMEFRAME != null && typeof appManager.SIMPLY_BOOK_TIMEFRAME !== 'undefined') {
				success(appManager.SIMPLY_BOOK_TIMEFRAME);
			} else {
				var thisThing = this;
				var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
				var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
				this.getSimplyBookToken(appManager, function (token) {
					thisThing.callURL("https://user-api.simplybook.me/", null, { "X-Company-Login": companyLogin, "X-Token": token }, { "jsonrpc": "2.0", "method": "getTimeframe", "params": [], "id": randomString(8) }, function (dataString) {
						var data = JSON.parse(dataString);
						success(data.result);
					}, failure, networkFailure);
				}, failure, networkFailure);
			}
		},
	
		bookSimplyBook: function bookSimplyBook(appManager, eventID, unitID, date, startTimeMinutes, clientData, success, failure, networkFailure) {
			var thisThing = this;
			var companyLogin = appManager.getFeatureForName("Booking").data.companyLogin;
			var apiKey = appManager.getFeatureForName("Booking").data.apiKey;
			this.getSimplyBookToken(appManager, function (token) {
				var mm = date.getMonth() + 1; // getMonth() is zero-based
				var dd = date.getDate();
				var dateString = [date.getFullYear(), "-", mm <= 9 ? '0' : '', mm, "-", dd <= 9 ? '0' : '', dd].join('');
	
				var hours = Math.floor(startTimeMinutes / 60);
				var minutes = startTimeMinutes % 60;
				var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes + ":00";
	
				thisThing.callURL("https://user-api.simplybook.me/", null, { "X-Company-Login": companyLogin, "X-Token": token }, { "jsonrpc": "2.0", "method": "book", "params": [eventID, unitID, dateString, timeString, clientData], "id": randomString(8) }, function (dataString) {
					var data = JSON.parse(dataString);
					success(data.result);
				}, failure, networkFailure);
			}, failure, networkFailure);
		},
	
		callURL: function callURL(url, auth, addedHeaders, body, success, failure, networkFailure) {
			var params = { method: 'get' };
			var postfix = "";
	
			params.headers = { "Content-Type": 'application/json; charset=UTF-8' };
			if (typeof auth !== 'undefined' && auth != null) {
				params.headers.Authorization = auth;
			}
	
			if (addedHeaders != null && typeof addedHeaders !== 'undefined') {
				for (var key in addedHeaders) {
					params.headers[key] = addedHeaders[key];
				}
			}
	
			if (typeof body !== 'undefined' && body != null) {
				params.body = JSON.stringify(body);
				params.headers["Content-Length"] = params.body.length;
				params.headers.Accept = "application/json";
				params.method = "POST";
				// postfix = "?"
				// for( var key in body )
				// {
				// 	if( postfix.length > 1 ) postfix += "&"
				// 	postfix += key + "=" + encodeURIComponent(body[key])
				// }
			}
	
			var responseTextCached = "";
			fetch(url + postfix, params).then(function (response) {
				return response.text();
			}).then(function (responseText) {
				responseTextCached = responseText;
				success(responseText);
			}).catch(function (err) {
				//console.log("ERR: " + err)
				AnalyticsManager.logException("callURL error :: " + url + " :: " + responseTextCached + " :: " + err);
				networkFailure(err);
			});
		},
	
		retrieveCustomDataDependencies: function retrieveCustomDataDependencies(appManager, customDataDependencies, data, completion, index) {
			if (typeof index === 'undefined') index = 0;
	
			if (index >= customDataDependencies.length || typeof customDataDependencies[index] === 'undefined') {
				completion(data);
				return;
			}
			customDataDependencies[index](appManager, function (newData) {
				for (var key in newData) {
					data[key] = newData[key];
				}
				NetworkManager.retrieveCustomDataDependencies(appManager, customDataDependencies, data, completion, index + 1);
			});
		},
	
		getFacebookInfo: function getFacebookInfo(appManager, facebook_user_id, success, failure, networkFailure) {
			var methodName = "GetFacebookFeed";
			var parameters = [facebook_user_id, 2];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		getTwitterInfo: function getTwitterInfo(appManager, twitter_screen_name, success, failure, networkFailure) {
			var methodName = "GetTwitterFeed";
			var parameters = [twitter_screen_name, 2];
			this.rpcCall(appManager, methodName, parameters, success, failure, networkFailure);
		},
	
		alertHistory: function alertHistory() {
			alert(JSON.stringify(history));
		},
	
		rpcCall: function rpcCall(appManager, methodName, parameters, success, failure, networkFailure) {
			if (appManager.isLoggedIn()) {
				var networkManager = this;
				appManager.getCurrentUser(function (user) {
					var username = user != null ? user[ModelConstants.UserName] : null;
					var password = user != null ? user[ModelConstants.Password] : null;
					networkManager.rpcCallUserPass(appManager, username, password, methodName, parameters, success, failure, networkFailure);
				});
			} else {
				this.rpcCallUserPass(appManager, null, null, methodName, parameters, success, failure, networkFailure);
			}
		},
	
		rpcCallHash: function rpcCallHash(appManager, methodName, parameters, success, failure, networkFailure) {
			if (appManager.isLoggedIn()) {
				var networkManager = this;
				appManager.getCurrentUser(function (user) {
					var hash = user != null ? user[ModelConstants.Hash] : null;
					networkManager.rpcCallUserPass(appManager, hash, null, methodName, parameters, success, failure, networkFailure);
				});
			} else {
				this.rpcCallUserPass(appManager, null, null, methodName, parameters, success, failure, networkFailure);
			}
		},
	
		// if password is null and username is not null, then username is used as hash
		rpcCallUserPass: function rpcCallUserPass(appManager, username, password, methodName, parameters, success, failure, networkFailure) {
			var networkManager = this;
			// var hash = crypto.createHmac('md5', "PALS_CLIENT_SECRET_1234").update(methodName).digest('hex');
			var hash = CryptoJS.HmacMD5(methodName, "PALS_CLIENT_SECRET_1234");
			hash = hash.toString(CryptoJS.enc.Hex);
	
			// console.log("methodName: " + methodName)
			// console.log("parameters: " + JSON.stringify(parameters))
	
			var serverURL = appManager.getServerURL() + "?hash=" + hash;
	
			var rpcInfo = { jsonrpc: '2.0', method: methodName, params: parameters, deviceinfo: appManager.getDeviceInfo(), id: randomString(8) };
			var appInfo = appManager.getAppInfo();
			if (appInfo.appid != "00000") {
				rpcInfo.appInfo = appInfo;
			}
			// use offline mode
			if (shouldUseHistory) {
				setTimeout(function () {
					var key = username + password + methodName + JSON.stringify(parameters);
					var response = typeof history[key] !== 'undefined' ? history[key] : {};
					var data = typeof response !== 'undefined' && typeof response.data !== 'undefined' ? response["data"] : {};
					if (response["success"]) {
						var isHaltingError = false;
						if (typeof data["error"] !== 'undefined' && typeof data["error"]["code"] !== 'undefined') {
							isHaltingError = networkManager.handleErrorCodeAndReturnIsHalting(data["error"]["code"]);
						}
	
						if (!isHaltingError) {
							if (typeof success !== 'undefined' && success != null) success(data["result"]);
						} else {
							var result = {};
							result["result"] = data["result"];
							for (var key in data["error"]) {
								var value = data["error"][key];
								result[key] = value;
							}
							if (typeof failure !== 'undefined' && failure != null) failure(result);
						}
					} else {
						var err = data;
						if (typeof networkFailure !== 'undefined') networkFailure(err);
					}
				}, 100);
				return;
			}
			var didRespond = false;
			var headers = { 'Content-Type': 'application/json' };
			var xhrFields = {};
			// basic auth
			if (typeof username !== 'undefined' && username != null && typeof password !== 'undefined' && password != null) {
				var auth = global.btoa(username + ':' + password);
				headers = { "Authorization": "Basic " + auth, 'Content-Type': 'application/json' };
				xhrFields = { withCredentials: true };
			} // reup auth
			else if (typeof username !== 'undefined' && username != null) {
					headers = { "Authorization": "Hash " + username, 'Content-Type': 'application/json' };
					xhrFields = { withCredentials: true };
				}
	
			var responseTextCached = "DID NOT GET RESPONSE";
			if (ENABLE_LOGGING) console.log("URL: " + serverURL + " param: " + JSON.stringify(rpcInfo) + " headers: " + JSON.stringify(headers));
			fetch(serverURL, {
				method: 'post',
				headers: headers,
				//mode: 'no-cors',
				body: JSON.stringify(rpcInfo)
			}).then(function (response) {
				return response.text();
			}).then(function (responseText) {
				responseTextCached = responseText;
				if (ENABLE_LOGGING) console.log("Response: " + responseText.substr(0, 80000));
				var data = JSON.parse(responseText);
				if (shouldRecordHistory) {
					var key = username + password + methodName + JSON.stringify(parameters);
					history[key] = {};
					history[key]["success"] = true;
					history[key]["data"] = data;
				}
				var isHaltingError = false;
				if (typeof data["error"] !== 'undefined' && typeof data["error"]["code"] !== 'undefined') {
					isHaltingError = networkManager.handleErrorCodeAndReturnIsHalting(data["error"]["code"]);
				}
				if (!isHaltingError) {
					didRespond = true;
					if (typeof success !== 'undefined' && success != null) success(data["result"], data["error"]);
				} else {
					didRespond = true;
					var result = {};
					result["result"] = data["result"];
					for (var key in data["error"]) {
						var value = data["error"][key];
						result[key] = value;
					}
					if (typeof failure !== 'undefined' && failure != null) failure(result);
				}
			}).catch(function (err) {
				AnalyticsManager.logException(err + " :: " + methodName + " :: " + JSON.stringify(parameters) + " :: " + responseTextCached);
				if (ENABLE_LOGGING) console.log("ERR: " + err, methodName, parameters, responseTextCached);
				if (didRespond) return;
				if (shouldRecordHistory) {
					var key = username + password + methodName + JSON.stringify(parameters);
					history[key] = {};
					history[key]["success"] = false;
					history[key]["data"] = err;
				}
				if (typeof networkFailure !== 'undefined') networkFailure(err);
			});
		},
	
		handleErrorCodeAndReturnIsHalting: function handleErrorCodeAndReturnIsHalting(errorCode) {
			return parseInt(errorCode) < 0;
		}
	};
	
	// Register callback with AppDispatcher
	
	module.exports = NetworkManager;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var NetworkManager = __webpack_require__(15);
	var ShadowView = __webpack_require__(20);
	var DB = __webpack_require__(846);
	var PullToRefreshScrollView = __webpack_require__(1163);
	
	var ReUpText = __webpack_require__(8);
	var LinkingManager = __webpack_require__(27);
	var Keyboard = __webpack_require__(76);
	
	var MK = __webpack_require__(14);
	var MKSpinner = MK.MKSpinner;
	
	// var DBEvents = require('react-native-db-models').DBEvents
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Easing = ReactNative.Easing,
	    Text = ReactNative.Text,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    InteractionManager = ReactNative.InteractionManager,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    KeyboardAvoidingView = ReactNative.KeyboardAvoidingView;
	
	
	var DB_UPDATE_CD = 400;
	
	var ReUpScrollView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      responder: {},
	      shadowEnabled: true,
	      shouldMinimizeEmptyMessage: false,
	      shouldOverlayRefreshView: false,
	      renderAlternativeView: null,
	      renderAlternative: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      keyboardOffset: new Animated.Value(0),
	      layout: { width: 0, height: 0 },
	      context: this.props.responder.props.appManager.getReUpScrollViewContext(),
	      behavior: 'padding',
	      isRefreshing: true
	    };
	  },
	
	  _shouldDoUpdate: true,
	  _dbUpdateSubscription: null,
	  _keyboardWillHideSubscription: null,
	  _keyboardWillShowSubscription: null,
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (Keyboard && Platform.OS != 'web') {
	      this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', function (e) {
	        return _this._keyboardWillShow(e);
	      });
	      this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', function (e) {
	        return _this._keyboardWillHide(e);
	      });
	    }
	
	    var responder = this.props.responder;
	    var appManager = responder.props.appManager;
	    var dataDependencies = responder.props.dataDependencies;
	    var customDependencies = responder.props.customDependencies;
	    var thisThing = this;
	    // this.localUpdate(appManager, dataDependencies, 0, function(data)
	    // {
	    //   thisThing.setState(data);
	    // })
	
	    if (!NetworkManager.hasUpdated(dataDependencies) || !appManager.hasUpdatedFeatureName(responder.props.featureData.name) || customDependencies.length > 0) {
	      var thisThing = this;
	      setTimeout(function () {
	        thisThing.doOnlineUpdate();
	        // InteractionManager.runAfterInteractions(() =>
	        // {
	        //   if(thisThing._shouldDoUpdate) thisThing.doOnlineUpdate();
	        //   thisThing._shouldDoUpdate = false;
	        // });
	      }, 400);
	    }
	
	    // DBEvents.on("all", this.dbDidUpdate, this.state.context);
	    //console.log("eventemitter: ",appManager._eventEmitter)
	    appManager._eventEmitter.on('dbUpdated', this.dbDidUpdate, this.state.context);
	    if (typeof responder.reupScrollViewDidMount !== 'undefined') {
	      responder.reupScrollViewDidMount(this);
	    }
	
	    this.dbDidUpdate();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {},
	
	  scrollTo: function scrollTo(x, y) {
	    if (this._pullToRefreshScroll) this._pullToRefreshScroll.scrollTo(x, y);
	  },
	
	  _data: {},
	  localUpdate: function localUpdate(appManager, dataDependencies, index, completion) {
	    if (index >= dataDependencies.length) {
	      completion(this._data);
	      return;
	    }
	
	    var thisDependency = dataDependencies[index];
	    var thisThing = this;
	    appManager.getDataType(thisDependency, function (data) {
	      thisThing._data[thisDependency] = data;
	      thisThing.localUpdate(appManager, dataDependencies, index + 1, completion);
	    });
	  },
	
	  updateIfDataDependenyIsNull: function updateIfDataDependenyIsNull(appManager, dataDependencies, index, doUpdate) {
	    if (index >= dataDependencies.length) return;
	
	    var thisDependency = dataDependencies[index];
	    var thisThing = this;
	    DB.table(thisDependency).get_all(function (data) {
	      if (data == null) {
	        doUpdate();
	      } else {
	        thisThing.updateIfDataDependenyIsNull(appManager, dataDependencies, index + 1, doUpdate);
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (Platform.OS != 'web') {
	      if (this._keyboardWillShowSubscription) this._keyboardWillShowSubscription.remove();
	      if (this._keyboardWillHideSubscription) this._keyboardWillHideSubscription.remove();
	    }
	    this.props.responder.props.appManager._eventEmitter.removeListener('dbUpdated', this.dbDidUpdate, this.state.context);
	
	    // DBEvents.removeListener("all", this.dbDidUpdate, this.state.context);
	  },
	
	  _keyboardOffset: 0,
	  _changingKeyboardOffset: null,
	  setKeyboardOffset: function setKeyboardOffset(keyboardOffset) {
	    if (this._changingKeyboardOffset != null) clearTimeout(this._changingKeyboardOffset);
	
	    var thisThing = this;
	    this._changingKeyboardOffset = setTimeout(function () {
	      thisThing._keyboardOffset = keyboardOffset;
	      Animated.spring(thisThing.state.keyboardOffset, {
	        toValue: keyboardOffset,
	        friction: 6
	      }).start();
	    }, 100);
	  },
	
	  _keyboardWillShow: function _keyboardWillShow(e) {
	    this.setKeyboardOffset(e.endCoordinates.height);
	  },
	
	  _keyboardWillHide: function _keyboardWillHide(e) {
	    this.setKeyboardOffset(0);
	  },
	
	  _DID_UPDATE_CD: 600,
	  _didUpdateTimeout: null,
	  didUpdate: function didUpdate(data) {
	    if (this._didUpdateTimout != null) clearTimeout(this._didUpdateTimout);
	
	    var thisThing = this;
	    this._didUpdateTimeout = setTimeout(function () {
	      thisThing._didUpdateTimout = null;
	      if (typeof thisThing._pullToRefreshScroll === 'undefined') return;
	      thisThing._pullToRefreshScroll.setIsRefreshing(false);
	
	      // thisThing.props.responder.didUpdate(data);
	      // thisThing.props.responder.props.appManager.setData(data, function()
	      // {
	      // });
	    }, this._DID_UPDATE_CD);
	  },
	
	  didFailUpdate: function didFailUpdate() {
	    if (this._pullToRefreshScroll) this._pullToRefreshScroll.setIsRefreshing(false);
	    if (this.props.responder.didFailUpdate) this.props.responder.didFailUpdate();
	  },
	
	  _dbCDTimeout: null,
	  _hasUpdated: false,
	  dbDidUpdate: function dbDidUpdate() {
	    var thisThing = this;
	    var responder = this.props.responder;
	    var appManager = responder.props.appManager;
	    var dataDependencies = responder.props.dataDependencies;
	    if (typeof responder.props.allDependencyKeys !== 'undefined') {
	      dataDependencies = responder.props.allDependencyKeys;
	    }
	    if (this._dbCDTimeout != null) clearTimeout(this._dbCDTimeout);
	    this._dbCDTimeout = setTimeout(function () {
	      appManager.getDataTypes(dataDependencies, function (data) {
	        responder.didUpdate(data);
	      });
	      thisThing._dbCDTimeout = null;
	    }, !this._hasUpdated ? 100 : DB_UPDATE_CD);
	    this._hasUpdated = true;
	  },
	
	  _isShowingUpdateAlert: false,
	  doOnlineUpdate: function doOnlineUpdate() {
	    var thisThing = this;
	    this.setState({ isRefreshing: true });
	    var responder = thisThing.props.responder;
	    var appManager = responder.props.appManager;
	    var appActions = typeof responder.props.appActions !== 'undefined' ? responder.props.appActions : null;
	
	    if (responder.props.dataDependencies.length <= 0 && responder.props.customDependencies.length <= 0) {
	      return;
	    }
	
	    if (responder.props.dataDependencies.length > 0) {
	      NetworkManager.update(appManager, responder.props.dataDependencies, function (data, error) {
	        if (typeof error !== 'undefined' && error.code == 1 && appActions != null) // soft update
	          {
	            appManager.shouldSoftUpdateAlert(function (shouldAlert) {
	              if (shouldAlert) {
	                appActions.showLocalizedAlert("VERSION_SOFT_ALERT_TITLE", "VERSION_SOFT_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	                  appActions.hideAlert();
	                }, function () {
	                  var url = Platform.OS == 'ios' ? error.AppStoreURL : error.PlayStoreURL;
	                  LinkingManager.openURL(url);
	                }], function () {
	                  appActions.hideAlert();
	                });
	              }
	            });
	          }
	        if (responder.props.customDependencies.length > 0) {
	          NetworkManager.retrieveCustomDataDependencies(appManager, responder.props.customDependencies, data, function (newData) {
	            for (var key in newData) {
	              data[key] = newData[key];
	            }thisThing.didUpdate(data);
	            appManager.setData(newData, function () {
	              setTimeout(function () {
	                thisThing.setState({ isRefreshing: false });
	              }, 1000);
	            });
	          });
	        } else {
	          thisThing.didUpdate(data);
	          appManager.setData(data, function () {
	            setTimeout(function () {
	              thisThing.setState({ isRefreshing: false });
	            }, 1000);
	          });
	        }
	      }, function (result) {
	        setTimeout(function () {
	          thisThing.setState({ isRefreshing: false });
	        }, 1000);
	        if (result.code == 1 && appActions != null) // soft update
	          {
	            appManager.shouldSoftUpdateAlert(function (shouldAlert) {
	              if (shouldAlert) {
	                appActions.showLocalizedAlert("VERSION_SOFT_ALERT_TITLE", "VERSION_SOFT_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	                  appActions.hideAlert();
	                }, function () {
	                  var url = Platform.OS == 'ios' ? result.AppStoreURL : result.PlayStoreURL;
	                  LinkingManager.openURL(url);
	                }], function () {
	                  appActions.hideAlert();
	                });
	              }
	            });
	          } else if (result.code == -21 && appActions != null) // password changed elsewhere
	          {
	            appActions.checkErrorCodeAndReturnIfHandled(result.code);
	          } else if (result.code == -27 && appActions != null) // hard update
	          {
	            appActions.showLocalizedAlert("VERSION_HARD_ALERT_TITLE", "VERSION_HARD_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	              var url = Platform.OS == 'ios' ? result.AppStoreURL : result.PlayStoreURL;
	              LinkingManager.openURL(url);
	            }], function () {}, false, true);
	          } else if (result.code == -26 && appActions != null) // app disabled
	          {
	            appActions.showLocalizedAlert("VERSION_DISABLED_ALERT_TITLE", "VERSION_DISABLED_BODY_ALERT", [], [function () {}], function () {}, false, true);
	          } else if (result.code == -72 && appActions != null) // user disabled
	          {
	            appActions.showLocalizedAlert("VERSION_DISABLED_ALERT_TITLE", result.message, [], [function () {}], function () {}, false, true);
	          } else {
	          thisThing.didFailUpdate(result);
	        }
	      });
	    }
	
	    if (responder.props.customDependencies.length > 0) {
	      thisThing.setState({ isRefreshing: true });
	      NetworkManager.retrieveCustomDataDependencies(appManager, responder.props.customDependencies, {}, function (newData) {
	        thisThing.didUpdate(newData);
	        appManager.setData(newData, function () {
	          setTimeout(function () {
	            thisThing.setState({ isRefreshing: false });
	          }, 1000);
	        }, false);
	      });
	    }
	  },
	
	  didScroll: function didScroll(info) {
	    if (typeof info.nativeEvent.contentOffset == 'undefined') {
	      return;
	    }
	    var offset = info.nativeEvent.contentOffset.y;
	    if (this.refs.shadowView) {
	      if (offset < 5) {
	        this.refs.shadowView.fadeOut();
	      } else {
	        this.refs.shadowView.fadeIn();
	      }
	    }
	
	    if (typeof this.props.onScroll === 'function') {
	      this.props.onScroll(info);
	    }
	  },
	
	  setRefreshEnabled: function setRefreshEnabled(refreshEnabled) {
	    if (this._pullToRefreshScroll) this._pullToRefreshScroll.setRefreshEnabled(refreshEnabled);
	  },
	
	  render: function render() {
	    var reUpScrollView = this;
	
	    var _reUpScrollView$props = reUpScrollView.props,
	        responder = _reUpScrollView$props.responder,
	        children = _reUpScrollView$props.children,
	        featureName = _reUpScrollView$props.featureName,
	        shouldOverlayRefreshView = _reUpScrollView$props.shouldOverlayRefreshView,
	        renderAlternative = _reUpScrollView$props.renderAlternative,
	        renderAlternativeView = _reUpScrollView$props.renderAlternativeView,
	        other = _objectWithoutProperties(_reUpScrollView$props, ['responder', 'children', 'featureName', 'shouldOverlayRefreshView', 'renderAlternative', 'renderAlternativeView']);
	
	    var appManager = responder.props.appManager;
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var locManager = appManager.getLocalizationManager();
	    var pullToRefreshStatement = locManager.localizedStringForKey("PULL_TO_REFRESH_STATEMENT");
	    var releaseToRefreshStatement = locManager.localizedStringForKey("RELEASE_TO_REFRESH_STATEMENT");
	    var refreshingStatement = locManager.localizedStringForKey("REFRESHING_STATEMENT");
	    var isEmptyPostfix = typeof this.props.isEmptyPostfix !== 'undefined' ? this.props.isEmptyPostfix : locManager.localizedStringForKey("IS_EMPTY_POSTFIX");
	
	    var thisThing = this;
	
	    if (this.props.shadowEnabled && (typeof responder.props.extras === 'undefined' || responder.props.extras == null || typeof responder.props.extras.shadowEnabled === 'undefined' || responder.props.extras.shadowEnabled == true)) {
	      if (typeof other.onScroll === 'function') {
	        var onScroll = other.onScroll;
	        other.onScroll = function (info) {
	          thisThing.didScroll(info);
	          onScroll(info);
	        };
	      } else if (typeof other.onScroll === 'undefined') {
	        other.onScroll = thisThing.didScroll;
	      }
	    }
	
	    var isEmpty = (typeof children === 'undefined' || children == null || children.length <= 0 || typeof this.props.isEmpty !== 'undefined' && this.props.isEmpty) && typeof featureName !== 'undefined' && featureName.length > 0;
	    var isRefreshing = this.state.isRefreshing;
	
	    return React.createElement(
	      View,
	      Object.assign({}, other, { style: { flexDirection: 'column', flex: 1 }, onLayout: function onLayout(info) {
	          if (info.nativeEvent.layout.width != thisThing.state.layout.width || info.nativeEvent.layout.height != thisThing.state.layout.height) {
	            thisThing.setState({ layout: info.nativeEvent.layout });
	            responder.setState({ layout: info.nativeEvent.layout });
	          }
	        } }),
	      React.createElement(
	        PullToRefreshScrollView,
	        Object.assign({
	          color1: headerColor,
	          color2: headerTitleColor,
	          color3: headerIconColor,
	          keyboardShouldPersistTaps: 'always',
	          keyboardDismissMode: "interactive",
	          didStartRefreshing: function didStartRefreshing(ptr) {
	            thisThing.doOnlineUpdate();
	          },
	          ref: function ref(a) {
	            if (thisThing._pullToRefreshScroll != null) thisThing._pullToRefreshScroll = a;
	          }, key: 'pullToRefreshScroll',
	          shouldOverlayRefreshView: shouldOverlayRefreshView,
	          pullRefreshView: React.createElement(
	            View,
	            { style: [styles.outerContainer, { backgroundColor: headerIconColor }] },
	            React.createElement(
	              View,
	              { style: [styles.innerContainer] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.pullTextStyle, { color: headerColor }] },
	                pullToRefreshStatement
	              )
	            )
	          ),
	          releaseRefreshView: React.createElement(
	            View,
	            { style: [{ flex: 1 }, styles.outerContainer, { backgroundColor: headerIconColor }] },
	            React.createElement(
	              View,
	              { style: [{ flex: 1 }, styles.innerContainer] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.releaseTextStyle, { color: headerColor }] },
	                releaseToRefreshStatement
	              )
	            )
	          ),
	          refreshingView: React.createElement(
	            View,
	            { style: [styles.outerContainer, { backgroundColor: headerIconColor }] },
	            React.createElement(
	              View,
	              { style: [styles.innerContainer] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.refreshingTextStyle, { color: headerColor }] },
	                refreshingStatement
	              ),
	              React.createElement(MKSpinner, { style: styles.progress, strokeColor: [headerColor] })
	            )
	          ) }, other, { style: { flex: 1 } }),
	        renderAlternative && renderAlternativeView != null ? renderAlternativeView() : children,
	        isEmpty && !isRefreshing ? React.createElement(
	          View,
	          { key: 'emp', style: { backgroundColor: generalColor, height: this.props.shouldMinimizeEmptyMessage ? -1 : 400, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: this.props.shouldMinimizeEmptyMessage ? 20 : 0 } },
	          React.createElement(_ReUpIcon2.default, { name: appManager.getFeatureForName(featureName).data.icon.replace("fa-", ""), size: 62, color: generalTitleColor }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20, height: 80 } },
	            React.createElement(
	              ReUpText,
	              { appManager: typeof appManager === 'undefined' ? null : appManager, isTitle: true },
	              appManager.getFeatureForName(featureName).data.title
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: typeof appManager === 'undefined' ? null : appManager, style: { textAlign: 'center' } },
	              isEmptyPostfix
	            )
	          )
	        ) : null,
	        isEmpty && isRefreshing ? React.createElement(
	          View,
	          { key: 'emp', style: { backgroundColor: generalColor, height: this.props.shouldMinimizeEmptyMessage ? -1 : 400, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: this.props.shouldMinimizeEmptyMessage ? 20 : 0 } },
	          React.createElement(_ReUpIcon2.default, { name: appManager.getFeatureForName(featureName).data.icon.replace("fa-", ""), size: 62, color: generalTitleColor }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20, height: 80 } },
	            React.createElement(MKSpinner, { style: styles.progress, strokeColor: [generalTitleColor] })
	          )
	        ) : null,
	        React.createElement(Animated.View, { style: { height: this.state.keyboardOffset, alignSelf: 'stretch', backgroundColor: 'transparent' } })
	      ),
	      React.createElement(ShadowView, { ref: "shadowView", shouldDrop: true, appManager: appManager, style: { position: 'absolute', backgroundColor: 'transparent', top: 0, left: 0, right: 0, height: 4 } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  innerContainer: {
	    height: 50,
	    flexDirection: 'row',
	    alignItems: 'center',
	    justifyContent: 'center',
	    flex: 1
	  },
	  outerContainer: {
	    height: 1000,
	    flexDirection: 'row',
	    alignItems: 'flex-end'
	  },
	  refreshingTextStyle: {
	    marginRight: 10
	  },
	  progress: {
	    backgroundColor: 'transparent'
	  }
	});
	
	module.exports = ReUpScrollView;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(88);


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Ionicon = _ReUpIcon2.default;
	// import Ionicon from 'react-native-vector-icons/Ionicons';
	var Globals = __webpack_require__(10);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpIconButton = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      iconName: "",
	      ionicIconName: null,
	      type: 0, // 0 primary, 1 secondary, 2 nav bar button
	      onPress: null,
	      iconSize: 22,
	      appActions: null,
	      featureData: null,
	      locParams: [],
	      accessibilityLabel: "Button",
	      enabled: true,
	      alertMessage: null,
	      buttonColorOverride: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      type: this.props.type,
	      iconName: this.props.iconName,
	      onPress: this.props.onPress,
	      isSecondary: this.props.isSecondary,
	      opacity: 1
	    };
	  },
	
	  setStateExternal: function setStateExternal(newState) {
	    this.setState(newState);
	  },
	
	  setOpacity: function setOpacity(opacity) {
	    opacity = Math.max(0, Math.min(1, opacity));
	    if (opacity != this.state.opacity) {
	      this.state.opacity = opacity;
	      this.setState({ opacity: opacity });
	    }
	  },
	
	  render: function render() {
	    var _state = this.state,
	        iconName = _state.iconName,
	        ionicIconName = _state.ionicIconName,
	        isSecondary = _state.isSecondary,
	        _onPress = _state.onPress,
	        type = _state.type,
	        accessibilityLabel = _state.accessibilityLabel,
	        enabled = _state.enabled,
	        other = _objectWithoutProperties(_state, ['iconName', 'ionicIconName', 'isSecondary', 'onPress', 'type', 'accessibilityLabel', 'enabled']);
	
	    if (typeof enabled === 'undefined') enabled = true;
	    var iconSize = this.props.iconSize;
	    var lineHeight = iconSize;
	    if ((iconName == null || iconName.length <= 0) && type != 3 && (ionicIconName == null || ionicIconName.length <= 0)) return React.createElement(View, null);
	
	    var appManager = this.props.appManager;
	    var style = this.props.style;
	    if (typeof style === 'undefined') style = {};
	    style = [style, styles.buttonStyle];
	    var buttonColor = "transparent";
	    var buttonTitleColor = "transparent";
	    var buttonBorderColor = "transparent";
	    var rippleColor = null;
	
	    var ionIconSize = 28;
	
	    var addedIconStyle = { backgroundColor: 'transparent' };
	
	    var AccentColoredFab = MKButton.accentColoredFab().withStyle(styles.creditCardEditButton).build();
	
	    if (type == 0) // primary
	      {
	        buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
	        buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	        buttonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	        style.push({ elevation: 2 });
	      } else if (type == 1) // secondary
	      {
	        buttonColor = appManager.getColorForKey("ButtonSecondaryColor");
	        buttonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	        buttonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	        style.push({ elevation: 2 });
	      } else if (type == 2) // header icon
	      {
	        buttonColor = appManager.getColorForKey("HeaderColor");
	        buttonTitleColor = appManager.getColorForKey("HeaderIconColor");
	        rippleColor = appManager.getColorForKey("HeaderIconColor", 0.2);
	        iconSize = 18;
	        style.push({ height: 36, width: 36, margin: 4 });
	      } else if (type == 3) // tutorial icon
	      {
	        if (this.props.featureData == null || this.props.appActions == null) return React.createElement(View, null);
	
	        buttonColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryColor");
	        buttonTitleColor = appManager.getColorForKey("InstructionTitleColor");
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryBorderColor");
	        iconName = "question-circle";
	        var tutorialFeature = appManager.getFeatureForName("Tutorial");
	        if (typeof tutorialFeature !== 'undefined') iconName = tutorialFeature.data.icon.replace("fa-", "");
	        iconSize = 18;
	        var appActions = this.props.appActions;
	        var locManager = appManager.getLocalizationManager();
	        var gotItButton = locManager.localizedStringForKey("GOT_IT_ALERT_BUTTON"); //TODO:localize
	        var featureData = this.props.featureData;
	        style.push({ width: 28, height: 28, margin: 4, marginRight: 12 });
	        style.push(Globals.TUTORIAL_ICON_STYLE);
	        var instructions = this.props.alertMessage == null ? locManager.localizedStringForKeyAndParams(featureData.instructions, this.props.locParams) : this.props.alertMessage;
	        if (typeof _onPress === 'undefined' || _onPress == null) {
	          _onPress = function onPress() {
	            appActions.showAlert(featureData.title, instructions, [gotItButton], [appActions.hideAlert], function () {});
	          };
	        }
	      } else if (type == 4) // primary header icon
	      {
	        buttonColor = appManager.getColorForKey("HeaderIconColor");
	        buttonTitleColor = appManager.getColorForKey("HeaderColor");
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonPrimaryBorderColor");
	        rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
	        style.push({ width: 26, height: 26, marginTop: 10, marginRight: 12, alignSelf: 'center' });
	      } else if (type == 5) // search clear
	      {
	        buttonColor = 'transparent';
	        buttonTitleColor = appManager.getColorForKey("GeneralTitleColor", 0.6);
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonPrimaryBorderColor");
	        rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
	        style.push({ width: 26, height: 26, marginTop: 0, marginRight: 26, alignSelf: 'center' });
	        iconSize = 16;
	      } else if (type == 6) // clear bg
	      {
	        buttonColor = 'transparent';
	        buttonTitleColor = appManager.getColorForKey("GeneralTitleColor", 0.6);
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonPrimaryBorderColor");
	        rippleColor = appManager.getColorForKey("HeaderColor", 0.2);
	        style.push({ width: 26, height: 26, marginTop: 0, alignSelf: 'center' });
	        iconSize = 16;
	      } else if (type == 7) // tutorial icon
	      {
	        buttonColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryColor");
	        buttonTitleColor = appManager.getColorForKey("InstructionTitleColor");
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryBorderColor");
	        iconSize = 30;
	      } else if (type == 8) // tutorial icon
	      {
	        buttonColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryColor");
	        buttonTitleColor = appManager.getColorForKey("HeaderColor");
	        buttonBorderColor = 'transparent'; //appManager.getColorForKey("ButtonSecondaryBorderColor");
	        iconSize = 60;
	        style.push({ width: 60, height: 60, marginTop: 0, alignSelf: 'center' });
	      }
	
	    lineHeight = iconSize;
	
	    var moreProps = { accessibilityLabel: accessibilityLabel, enabled: enabled };
	    if (rippleColor != null) moreProps.rippleColor = rippleColor;
	    if (typeof buttonColor !== 'undefined') style.push({ backgroundColor: buttonColor });
	    if (this.props.buttonColorOverride != null) style.push({ backgroundColor: this.props.buttonColorOverride });
	    if (this.props.iconSizeOverride != null) {
	      iconSize = this.props.iconSizeOverride;
	    }
	
	    if (ionicIconName != null && ionicIconName.length) style.push({ paddingTop: 4 });
	
	    style.push({ opacity: this.state.opacity });
	
	    if (typeof _onPress === 'undefined' || _onPress == null) _onPress = function onPress() {};
	
	    return React.createElement(
	      AccentColoredFab,
	      Object.assign({
	        key: 'button',
	        onPress: function onPress() {
	          _onPress();
	        },
	        shadowColor: buttonBorderColor,
	        shadowRadius: 2,
	        shadowOffset: { width: 0, height: 2 },
	        shadowOpacity: 0.4,
	        backgroundColor: buttonColor,
	        testID: iconName,
	        style: style }, moreProps),
	      ionicIconName != null && ionicIconName.length > 0 ? React.createElement(Ionicon, Object.assign({ name: ionicIconName, size: ionIconSize, color: buttonTitleColor, style: [styles.iconStyle, addedIconStyle] }, other)) : React.createElement(_ReUpIcon2.default, Object.assign({ name: iconName, size: iconSize, color: buttonTitleColor, style: [styles.iconStyle, { lineHeight: lineHeight, height: iconSize }, addedIconStyle] }, other))
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  buttonStyle: {
	    flexDirection: 'row',
	    width: 44,
	    height: 44,
	    borderRadius: 22,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    backgroundColor: 'transparent',
	    textAlign: 'center'
	  },
	  iconStyle: {
	    alignItems: 'center',
	    justifyContent: 'center'
	  }
	});
	
	module.exports = ReUpIconButton;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var ReUpText = __webpack_require__(8);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ShadowView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      layout: { width: 0, height: 0 },
	      appManager: {},
	      text: null,
	      shouldDrop: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      shadowOpacity: new Animated.Value(0)
	    };
	  },
	
	  _didFadeIn: false,
	  fadeIn: function fadeIn() {
	    if (this._didFadeIn) return;
	
	    this._didFadeIn = true;
	    var thisThing = this;
	    Animated.timing(thisThing.state.shadowOpacity, { toValue: 1,
	      duration: 100 }).start(function () {});
	  },
	
	  fadeOut: function fadeOut() {
	    if (!this._didFadeIn) return;
	
	    this._didFadeIn = false;
	    var thisThing = this;
	    Animated.timing(thisThing.state.shadowOpacity, { toValue: 0,
	      duration: 100 }).start(function () {});
	  },
	
	  render: function render() {
	    var navSpacerLineColor = this.props.appManager.getColorForKey("HeaderTitleColor", 0.1);
	    var navSpacerBGColor = this.props.appManager.getColorForKey("HeaderColor", 0.2);
	    var style = this.props.style;
	    if (typeof style === 'undefined') style = {};
	
	    if (this.props.shouldDrop) {
	      var navHeaderColor = this.props.appManager.getColorForKey("HeaderColor");
	      var primaryBorderColor = this.props.appManager.getColorForKey("ButtonPrimaryBorderColor");
	      return React.createElement(
	        Animated.View,
	        { style: [style, { overflow: 'hidden', height: 4, opacity: this.state.shadowOpacity }] },
	        React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, bottom: 5, backgroundColor: navHeaderColor, shadowOffset: { width: 0, height: 4 }, shadowOpacity: .6, shadowRadius: 1, height: 4, shadowColor: primaryBorderColor } })
	      );
	    } else if (this.props.text == null) {
	      return React.createElement(
	        View,
	        { style: [{ height: 1, backgroundColor: navSpacerLineColor, width: this.props.layout.width }, style] },
	        React.createElement(View, { style: { flex: 1, backgroundColor: navSpacerBGColor } })
	      );
	    } else {
	      var generalTitleColor = this.props.appManager.getColorForKey("GeneralTitleColor");
	      return React.createElement(
	        View,
	        { style: style },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', alignItems: 'center', padding: 10, paddingRight: 20, paddingLeft: 20 } },
	          React.createElement(
	            View,
	            { style: [{ height: 1, backgroundColor: navSpacerLineColor, flex: 1 }, style] },
	            React.createElement(View, { style: { flex: 1, backgroundColor: navSpacerBGColor } })
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: this.props.appManager, style: { marginLeft: 10, marginRight: 10, color: generalTitleColor } },
	            this.props.text
	          ),
	          React.createElement(
	            View,
	            { style: [{ height: 1, backgroundColor: navSpacerLineColor, flex: 1 }, style] },
	            React.createElement(View, { style: { flex: 1, backgroundColor: navSpacerBGColor } })
	          )
	        )
	      );
	    }
	  }
	});
	
	module.exports = ShadowView;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 24 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 25 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var MK = __webpack_require__(14);
	var MKTextField = MK.MKTextField;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet,
	    View = ReactNative.View,
	    Platform = ReactNative.Platform,
	    TextInput = ReactNative.TextInput;
	
	
	var ReUpField = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      isInError: false,
	      onChangeText: function onChangeText() {},
	      useGeneric: false,
	      hideLine: false,
	      disableBackground: false,
	      textInputStyle: {},
	      invertBG: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isInError: this.props.isInError,
	      text: typeof this.props.defaultValue !== 'undefined' ? this.props.defaultValue : ""
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.isInError !== 'undefined' && newProps.isInError != this.state.isInError) {
	      this.setState({ isInError: newProps.isInError });
	    }
	    if (typeof newProps.defaultValue !== 'undefined' && newProps.defaultValue != this.state.text) {
	      this.setState({ text: newProps.defaultValue });
	    }
	    if (typeof newProps.value !== 'undefined' && newProps.value != this.state.text) {
	      this.setState({ text: newProps.value });
	    }
	  },
	
	  focus: function focus() {
	    this.refs.field.focus();
	  },
	
	  isInError: function isInError() {
	    return this.state.isInError;
	  },
	
	  setIsInError: function setIsInError(isInError) {
	    this.setState({ isInError: isInError });
	  },
	
	  onChangeText: function onChangeText(text) {
	    this.props.onChangeText(text);
	    this.setText(text);
	
	    // hack to fix error color
	    if (typeof this.refs.field.refs.floatingLabel !== 'undefined') this.refs.field.refs.floatingLabel.aniFloatLabel();
	  },
	
	  setText: function setText(text) {
	    this.setState({ text: text });
	  },
	
	  onBlur: function onBlur() {
	    this.refs.field.focus();
	  },
	
	  render: function render() {
	    var _props = this.props,
	        text = _props.text,
	        appManager = _props.appManager,
	        onChangeText = _props.onChangeText,
	        style = _props.style,
	        useGeneric = _props.useGeneric,
	        textInputStyle = _props.textInputStyle,
	        hideLine = _props.hideLine,
	        secureTextEntry = _props.secureTextEntry,
	        other = _objectWithoutProperties(_props, ['text', 'appManager', 'onChangeText', 'style', 'useGeneric', 'textInputStyle', 'hideLine', 'secureTextEntry']);
	
	    style = typeof style !== 'undefined' ? style : {};
	
	    var thisThing = this;
	    var bgColor = appManager.getColorForKey("GeneralTitleColor", .03);
	    if (this.props.invertBG) bgColor = appManager.getColorForKey("GeneralColor", 1);
	    var generalColor = useGeneric ? 'white' : appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = useGeneric ? 'black' : appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = useGeneric ? 'black' : appManager.getColorForKey("FeedCardBannerColor");
	    if (bannerColor == generalColor) bannerColor = generalTitleColor;
	
	    if (Platform.OS == 'web') other.tabindex = "-1";
	
	    return React.createElement(
	      View,
	      { style: [{ height: 60, flexDirection: 'column' }, style], onStartShouldSetResponder: function onStartShouldSetResponder(evt) {
	          thisThing.refs.field.focus();
	        } },
	      React.createElement(MKTextField, Object.assign({
	        ref: 'field',
	        underlineColorAndroid: 'transparent',
	        onChangeText: this.onChangeText,
	        allowFontScaling: false,
	        tintColor: this.state.isInError ? 'red' : hideLine ? 'transparent' : generalTitleColor,
	        highlightColor: this.state.isInError ? 'red' : hideLine ? 'transparent' : bannerColor,
	        textInputStyle: [{
	          color: generalTitleColor,
	          fontSize: 16,
	          fontFamily: 'Arial',
	          flex: 1,
	          padding: 6,
	          backgroundColor: this.props.disableBackground ? 'transparent' : bgColor
	        }, textInputStyle],
	        floatingLabelEnabled: true,
	        floatingLabelAniDuration: 100,
	        placeholderTextColor: 'grey',
	        floatingLabelFont: {
	          fontSize: 12,
	          fontStyle: 'italic',
	          fontWeight: '200',
	          paddingRight: 10
	        },
	        style: [{
	          flex: 1,
	          borderRadius: 3,
	          backgroundColor: 'white',
	          padding: 8
	
	        }],
	        password: secureTextEntry,
	        value: this.state.text,
	        text: this.state.text
	      }, other))
	    );
	  }
	});
	
	module.exports = ReUpField;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Linking = ReactNative.Linking;
	
	
	module.exports = {
	  openURL: function openURL(url, tintColor, barTintColor) {
	    this.canOpenURL(url, function (canOpen) {
	      if (canOpen) {
	        window.open(url, '_blank');
	      }
	    });
	  },
	
	  canOpenURL: function canOpenURL(url, completion) {
	    Linking.canOpenURL(url).then(function (supported) {
	      completion(supported);
	    }).catch(function (err) {
	      return console.error('An error occurred', err);
	    });
	  },
	
	  removeDismissListener: function removeDismissListener() {},
	
	  addDismissListener: function addDismissListener(callback) {}
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _StyleSheet = __webpack_require__(1420);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// allow component styles to be editable in React Dev Tools
	if (false) {
	  if (_ExecutionEnvironment.canUseDOM && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
	    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle = _StyleSheet2.default.flatten;
	  }
	}
	
	exports.default = _StyleSheet2.default;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(823);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _propTypes = __webpack_require__(6);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _filterSupportedProps = __webpack_require__(1438);
	
	var _filterSupportedProps2 = _interopRequireDefault(_filterSupportedProps);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ViewPropTypes = __webpack_require__(1040);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * All rights reserved.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var calculateHitSlopStyle = function calculateHitSlopStyle(hitSlop) {
	  var hitStyle = {};
	  for (var prop in hitSlop) {
	    if (hitSlop.hasOwnProperty(prop)) {
	      var value = hitSlop[prop];
	      hitStyle[prop] = value > 0 ? -1 * value : 0;
	    }
	  }
	  return hitStyle;
	};
	
	var View = function (_Component) {
	  _inherits(View, _Component);
	
	  function View() {
	    _classCallCheck(this, View);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  View.prototype.render = function render() {
	    var hitSlop = this.props.hitSlop;
	    var supportedProps = (0, _filterSupportedProps2.default)(this.props);
	
	    if (false) {
	      _react2.default.Children.toArray(this.props.children).forEach(function (item) {
	        (0, _invariant2.default)(typeof item !== 'string', 'Unexpected text node: ' + item + '. A text node cannot be a child of a <View>.');
	      });
	    }
	
	    var isInAParentText = this.context.isInAParentText;
	
	
	    supportedProps.style = _StyleSheet2.default.compose(styles.initial, _StyleSheet2.default.compose(isInAParentText && styles.inline, this.props.style));
	
	    if (hitSlop) {
	      var hitSlopStyle = calculateHitSlopStyle(hitSlop);
	      var hitSlopChild = (0, _createElement2.default)('span', { style: [styles.hitSlop, hitSlopStyle] });
	      supportedProps.children = _react2.default.Children.toArray([hitSlopChild, supportedProps.children]);
	    }
	
	    return (0, _createElement2.default)('div', supportedProps);
	  };
	
	  return View;
	}(_react.Component);
	
	View.displayName = 'View';
	View.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	View.propTypes =  false ? _ViewPropTypes2.default : {};
	
	
	var styles = _StyleSheet2.default.create({
	  // https://github.com/facebook/css-layout#default-values
	  initial: {
	    alignItems: 'stretch',
	    borderWidth: 0,
	    borderStyle: 'solid',
	    boxSizing: 'border-box',
	    display: 'flex',
	    flexDirection: 'column',
	    margin: 0,
	    padding: 0,
	    position: 'relative',
	    zIndex: 0,
	    // fix flexbox bugs
	    minHeight: 0,
	    minWidth: 0
	  },
	  inline: {
	    display: 'inline-flex'
	  },
	  // this zIndex-ordering positions the hitSlop above the View but behind
	  // its children
	  hitSlop: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    zIndex: -1
	  })
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(View));
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(mixins){
		var proto = {};
		for (var i = 0, l = arguments.length; i < l; i++){
			var mixin = arguments[i];
			if (typeof mixin == 'function') mixin = mixin.prototype;
			for (var key in mixin) proto[key] = mixin[key];
		}
		if (!proto.initialize) proto.initialize = function(){};
		proto.constructor = function(a,b,c,d,e,f,g,h){
			return new proto.initialize(a,b,c,d,e,f,g,h);
		};
		proto.constructor.prototype = proto.initialize.prototype = proto;
		return proto.constructor;
	};


/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	var resourcesBaseURL = "https://s3.amazonaws.com/reup-app-builder-site-6/published_users/g72bu/reup-resources"; // get from get params.
	function findGetParameter(parameterName) {
	    var result = null,
	        tmp = [];
	    location.search.substr(1).split("&").forEach(function (item) {
	        tmp = item.split("=");
	        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	    });
	    return result;
	}
	
	var newResourceBaseURL = findGetParameter("resourcesDirectory");
	if (newResourceBaseURL != null) resourcesBaseURL = newResourceBaseURL;
	
	module.exports = {
	    absoluteFilesPrefix: resourcesBaseURL,
	    filesPrefix: "",
	    packagedResourcesDirectory: resourcesBaseURL,
	    resourcesDirectory: resourcesBaseURL,
	    oldResourcesDirectory: "",
	    pendingResourcesDirectory: "",
	    configFileName: resourcesBaseURL + "/ReUp-Config.plist",
	    pendingConfigFileName: ""
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMProperty = __webpack_require__(86);
	var ReactDOMComponentFlags = __webpack_require__(1003);
	
	var invariant = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(64));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./evpkdf"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher core components.
		 */
		CryptoJS.lib.Cipher || (function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var Base64 = C_enc.Base64;
		    var C_algo = C.algo;
		    var EvpKDF = C_algo.EvpKDF;
	
		    /**
		     * Abstract base cipher template.
		     *
		     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
		     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
		     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
		     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
		     */
		    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {WordArray} iv The IV to use for this operation.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Creates this cipher in encryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createEncryptor: function (key, cfg) {
		            return this.create(this._ENC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Creates this cipher in decryption mode.
		         *
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {Cipher} A cipher instance.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
		         */
		        createDecryptor: function (key, cfg) {
		            return this.create(this._DEC_XFORM_MODE, key, cfg);
		        },
	
		        /**
		         * Initializes a newly created cipher.
		         *
		         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @example
		         *
		         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
		         */
		        init: function (xformMode, key, cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Store transform mode and key
		            this._xformMode = xformMode;
		            this._key = key;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this cipher to its initial state.
		         *
		         * @example
		         *
		         *     cipher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-cipher logic
		            this._doReset();
		        },
	
		        /**
		         * Adds data to be encrypted or decrypted.
		         *
		         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.process('data');
		         *     var encrypted = cipher.process(wordArray);
		         */
		        process: function (dataUpdate) {
		            // Append
		            this._append(dataUpdate);
	
		            // Process available blocks
		            return this._process();
		        },
	
		        /**
		         * Finalizes the encryption or decryption process.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
		         *
		         * @return {WordArray} The data after final processing.
		         *
		         * @example
		         *
		         *     var encrypted = cipher.finalize();
		         *     var encrypted = cipher.finalize('data');
		         *     var encrypted = cipher.finalize(wordArray);
		         */
		        finalize: function (dataUpdate) {
		            // Final data update
		            if (dataUpdate) {
		                this._append(dataUpdate);
		            }
	
		            // Perform concrete-cipher logic
		            var finalProcessedData = this._doFinalize();
	
		            return finalProcessedData;
		        },
	
		        keySize: 128/32,
	
		        ivSize: 128/32,
	
		        _ENC_XFORM_MODE: 1,
	
		        _DEC_XFORM_MODE: 2,
	
		        /**
		         * Creates shortcut functions to a cipher's object interface.
		         *
		         * @param {Cipher} cipher The cipher to create a helper for.
		         *
		         * @return {Object} An object with encrypt and decrypt shortcut functions.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
		         */
		        _createHelper: (function () {
		            function selectCipherStrategy(key) {
		                if (typeof key == 'string') {
		                    return PasswordBasedCipher;
		                } else {
		                    return SerializableCipher;
		                }
		            }
	
		            return function (cipher) {
		                return {
		                    encrypt: function (message, key, cfg) {
		                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
		                    },
	
		                    decrypt: function (ciphertext, key, cfg) {
		                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
		                    }
		                };
		            };
		        }())
		    });
	
		    /**
		     * Abstract base stream cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
		     */
		    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
		        _doFinalize: function () {
		            // Process partial blocks
		            var finalProcessedBlocks = this._process(!!'flush');
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 1
		    });
	
		    /**
		     * Mode namespace.
		     */
		    var C_mode = C.mode = {};
	
		    /**
		     * Abstract base block cipher mode template.
		     */
		    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
		        /**
		         * Creates this mode for encryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
		         */
		        createEncryptor: function (cipher, iv) {
		            return this.Encryptor.create(cipher, iv);
		        },
	
		        /**
		         * Creates this mode for decryption.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
		         */
		        createDecryptor: function (cipher, iv) {
		            return this.Decryptor.create(cipher, iv);
		        },
	
		        /**
		         * Initializes a newly created mode.
		         *
		         * @param {Cipher} cipher A block cipher instance.
		         * @param {Array} iv The IV words.
		         *
		         * @example
		         *
		         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
		         */
		        init: function (cipher, iv) {
		            this._cipher = cipher;
		            this._iv = iv;
		        }
		    });
	
		    /**
		     * Cipher Block Chaining mode.
		     */
		    var CBC = C_mode.CBC = (function () {
		        /**
		         * Abstract base CBC mode.
		         */
		        var CBC = BlockCipherMode.extend();
	
		        /**
		         * CBC encryptor.
		         */
		        CBC.Encryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // XOR and encrypt
		                xorBlock.call(this, words, offset, blockSize);
		                cipher.encryptBlock(words, offset);
	
		                // Remember this block to use with next block
		                this._prevBlock = words.slice(offset, offset + blockSize);
		            }
		        });
	
		        /**
		         * CBC decryptor.
		         */
		        CBC.Decryptor = CBC.extend({
		            /**
		             * Processes the data block at offset.
		             *
		             * @param {Array} words The data words to operate on.
		             * @param {number} offset The offset where the block starts.
		             *
		             * @example
		             *
		             *     mode.processBlock(data.words, offset);
		             */
		            processBlock: function (words, offset) {
		                // Shortcuts
		                var cipher = this._cipher;
		                var blockSize = cipher.blockSize;
	
		                // Remember this block to use with next block
		                var thisBlock = words.slice(offset, offset + blockSize);
	
		                // Decrypt and XOR
		                cipher.decryptBlock(words, offset);
		                xorBlock.call(this, words, offset, blockSize);
	
		                // This block becomes the previous block
		                this._prevBlock = thisBlock;
		            }
		        });
	
		        function xorBlock(words, offset, blockSize) {
		            // Shortcut
		            var iv = this._iv;
	
		            // Choose mixing block
		            if (iv) {
		                var block = iv;
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            } else {
		                var block = this._prevBlock;
		            }
	
		            // XOR blocks
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= block[i];
		            }
		        }
	
		        return CBC;
		    }());
	
		    /**
		     * Padding namespace.
		     */
		    var C_pad = C.pad = {};
	
		    /**
		     * PKCS #5/7 padding strategy.
		     */
		    var Pkcs7 = C_pad.Pkcs7 = {
		        /**
		         * Pads data using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to pad.
		         * @param {number} blockSize The multiple that the data should be padded to.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
		         */
		        pad: function (data, blockSize) {
		            // Shortcut
		            var blockSizeBytes = blockSize * 4;
	
		            // Count padding bytes
		            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		            // Create padding word
		            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;
	
		            // Create padding
		            var paddingWords = [];
		            for (var i = 0; i < nPaddingBytes; i += 4) {
		                paddingWords.push(paddingWord);
		            }
		            var padding = WordArray.create(paddingWords, nPaddingBytes);
	
		            // Add padding
		            data.concat(padding);
		        },
	
		        /**
		         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
		         *
		         * @param {WordArray} data The data to unpad.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
		         */
		        unpad: function (data) {
		            // Get number of padding bytes from last byte
		            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		            // Remove padding
		            data.sigBytes -= nPaddingBytes;
		        }
		    };
	
		    /**
		     * Abstract base block cipher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
		     */
		    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Mode} mode The block mode to use. Default: CBC
		         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
		         */
		        cfg: Cipher.cfg.extend({
		            mode: CBC,
		            padding: Pkcs7
		        }),
	
		        reset: function () {
		            // Reset cipher
		            Cipher.reset.call(this);
	
		            // Shortcuts
		            var cfg = this.cfg;
		            var iv = cfg.iv;
		            var mode = cfg.mode;
	
		            // Reset block mode
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                var modeCreator = mode.createEncryptor;
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                var modeCreator = mode.createDecryptor;
		                // Keep at least one block in the buffer for unpadding
		                this._minBufferSize = 1;
		            }
	
		            if (this._mode && this._mode.__creator == modeCreator) {
		                this._mode.init(this, iv && iv.words);
		            } else {
		                this._mode = modeCreator.call(mode, this, iv && iv.words);
		                this._mode.__creator = modeCreator;
		            }
		        },
	
		        _doProcessBlock: function (words, offset) {
		            this._mode.processBlock(words, offset);
		        },
	
		        _doFinalize: function () {
		            // Shortcut
		            var padding = this.cfg.padding;
	
		            // Finalize
		            if (this._xformMode == this._ENC_XFORM_MODE) {
		                // Pad data
		                padding.pad(this._data, this.blockSize);
	
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
		            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
		                // Process final blocks
		                var finalProcessedBlocks = this._process(!!'flush');
	
		                // Unpad data
		                padding.unpad(finalProcessedBlocks);
		            }
	
		            return finalProcessedBlocks;
		        },
	
		        blockSize: 128/32
		    });
	
		    /**
		     * A collection of cipher parameters.
		     *
		     * @property {WordArray} ciphertext The raw ciphertext.
		     * @property {WordArray} key The key to this ciphertext.
		     * @property {WordArray} iv The IV used in the ciphering operation.
		     * @property {WordArray} salt The salt used with a key derivation function.
		     * @property {Cipher} algorithm The cipher algorithm.
		     * @property {Mode} mode The block mode used in the ciphering operation.
		     * @property {Padding} padding The padding scheme used in the ciphering operation.
		     * @property {number} blockSize The block size of the cipher.
		     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
		     */
		    var CipherParams = C_lib.CipherParams = Base.extend({
		        /**
		         * Initializes a newly created cipher params object.
		         *
		         * @param {Object} cipherParams An object with any of the possible cipher parameters.
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.lib.CipherParams.create({
		         *         ciphertext: ciphertextWordArray,
		         *         key: keyWordArray,
		         *         iv: ivWordArray,
		         *         salt: saltWordArray,
		         *         algorithm: CryptoJS.algo.AES,
		         *         mode: CryptoJS.mode.CBC,
		         *         padding: CryptoJS.pad.PKCS7,
		         *         blockSize: 4,
		         *         formatter: CryptoJS.format.OpenSSL
		         *     });
		         */
		        init: function (cipherParams) {
		            this.mixIn(cipherParams);
		        },
	
		        /**
		         * Converts this cipher params object to a string.
		         *
		         * @param {Format} formatter (Optional) The formatting strategy to use.
		         *
		         * @return {string} The stringified cipher params.
		         *
		         * @throws Error If neither the formatter nor the default formatter is set.
		         *
		         * @example
		         *
		         *     var string = cipherParams + '';
		         *     var string = cipherParams.toString();
		         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
		         */
		        toString: function (formatter) {
		            return (formatter || this.formatter).stringify(this);
		        }
		    });
	
		    /**
		     * Format namespace.
		     */
		    var C_format = C.format = {};
	
		    /**
		     * OpenSSL formatting strategy.
		     */
		    var OpenSSLFormatter = C_format.OpenSSL = {
		        /**
		         * Converts a cipher params object to an OpenSSL-compatible string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The OpenSSL-compatible string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            // Shortcuts
		            var ciphertext = cipherParams.ciphertext;
		            var salt = cipherParams.salt;
	
		            // Format
		            if (salt) {
		                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
		            } else {
		                var wordArray = ciphertext;
		            }
	
		            return wordArray.toString(Base64);
		        },
	
		        /**
		         * Converts an OpenSSL-compatible string to a cipher params object.
		         *
		         * @param {string} openSSLStr The OpenSSL-compatible string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
		         */
		        parse: function (openSSLStr) {
		            // Parse base64
		            var ciphertext = Base64.parse(openSSLStr);
	
		            // Shortcut
		            var ciphertextWords = ciphertext.words;
	
		            // Test for salt
		            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
		                // Extract salt
		                var salt = WordArray.create(ciphertextWords.slice(2, 4));
	
		                // Remove salt from ciphertext
		                ciphertextWords.splice(0, 4);
		                ciphertext.sigBytes -= 16;
		            }
	
		            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
		        }
		    };
	
		    /**
		     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
		     */
		    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
		         */
		        cfg: Base.extend({
		            format: OpenSSLFormatter
		        }),
	
		        /**
		         * Encrypts a message.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Encrypt
		            var encryptor = cipher.createEncryptor(key, cfg);
		            var ciphertext = encryptor.finalize(message);
	
		            // Shortcut
		            var cipherCfg = encryptor.cfg;
	
		            // Create and return serializable cipher params
		            return CipherParams.create({
		                ciphertext: ciphertext,
		                key: key,
		                iv: cipherCfg.iv,
		                algorithm: cipher,
		                mode: cipherCfg.mode,
		                padding: cipherCfg.padding,
		                blockSize: cipher.blockSize,
		                formatter: cfg.format
		            });
		        },
	
		        /**
		         * Decrypts serialized ciphertext.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {WordArray} key The key.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, key, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Decrypt
		            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
	
		            return plaintext;
		        },
	
		        /**
		         * Converts serialized ciphertext to CipherParams,
		         * else assumed CipherParams already and returns ciphertext unchanged.
		         *
		         * @param {CipherParams|string} ciphertext The ciphertext.
		         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
		         *
		         * @return {CipherParams} The unserialized ciphertext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
		         */
		        _parse: function (ciphertext, format) {
		            if (typeof ciphertext == 'string') {
		                return format.parse(ciphertext, this);
		            } else {
		                return ciphertext;
		            }
		        }
		    });
	
		    /**
		     * Key derivation function namespace.
		     */
		    var C_kdf = C.kdf = {};
	
		    /**
		     * OpenSSL key derivation function.
		     */
		    var OpenSSLKdf = C_kdf.OpenSSL = {
		        /**
		         * Derives a key and IV from a password.
		         *
		         * @param {string} password The password to derive from.
		         * @param {number} keySize The size in words of the key to generate.
		         * @param {number} ivSize The size in words of the IV to generate.
		         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
		         *
		         * @return {CipherParams} A cipher params object with the key, IV, and salt.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
		         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
		         */
		        execute: function (password, keySize, ivSize, salt) {
		            // Generate random salt
		            if (!salt) {
		                salt = WordArray.random(64/8);
		            }
	
		            // Derive key and IV
		            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);
	
		            // Separate key and IV
		            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
		            key.sigBytes = keySize * 4;
	
		            // Return params
		            return CipherParams.create({ key: key, iv: iv, salt: salt });
		        }
		    };
	
		    /**
		     * A serializable cipher wrapper that derives the key from a password,
		     * and returns ciphertext as a serializable cipher params object.
		     */
		    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
		         */
		        cfg: SerializableCipher.cfg.extend({
		            kdf: OpenSSLKdf
		        }),
	
		        /**
		         * Encrypts a message using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {WordArray|string} message The message to encrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {CipherParams} A cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
		         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        encrypt: function (cipher, message, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Encrypt
		            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
	
		            // Mix in derived params
		            ciphertext.mixIn(derivedParams);
	
		            return ciphertext;
		        },
	
		        /**
		         * Decrypts serialized ciphertext using a password.
		         *
		         * @param {Cipher} cipher The cipher algorithm to use.
		         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
		         * @param {string} password The password.
		         * @param {Object} cfg (Optional) The configuration options to use for this operation.
		         *
		         * @return {WordArray} The plaintext.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
		         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
		         */
		        decrypt: function (cipher, ciphertext, password, cfg) {
		            // Apply config defaults
		            cfg = this.cfg.extend(cfg);
	
		            // Convert string to CipherParams
		            ciphertext = this._parse(ciphertext, cfg.format);
	
		            // Derive key and other params
		            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
	
		            // Add IV to config
		            cfg.iv = derivedParams.iv;
	
		            // Decrypt
		            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
	
		            return plaintext;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeColor = __webpack_require__(825);
	
	var _normalizeColor2 = _interopRequireDefault(_normalizeColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colorPropType = function colorPropType(isRequired, props, propName, componentName, location, propFullName) {
	  var color = props[propName];
	  if (color === undefined || color === null) {
	    if (isRequired) {
	      return new Error('Required ' + location + ' `' + (propFullName || propName) + '` was not specified in `' + componentName + '`.');
	    }
	    return;
	  }
	
	  if (typeof color === 'number') {
	    // Developers should not use a number, but we are using the prop type
	    // both for user provided colors and for transformed ones. This isn't ideal
	    // and should be fixed but will do for now...
	    return;
	  }
	
	  if ((0, _normalizeColor2.default)(color) === null) {
	    return new Error('Invalid ' + location + ' `' + (propFullName || propName) + '` supplied to `' + componentName + '`: ' + color + '\n' + 'Valid color formats are\n  - \'#f0f\' (#rgb)\n  - \'#f0fc\' (#rgba)\n  - \'#ff00ff\' (#rrggbb)\n  - \'#ff00ff00\' (#rrggbbaa)\n  - \'rgb(255, 255, 255)\'\n  - \'rgba(255, 255, 255, 1.0)\'\n  - \'hsl(360, 100%, 100%)\'\n  - \'hsla(360, 100%, 100%, 1.0)\'\n  - \'transparent\'\n  - \'red\'\n  - 0xff00ff00 (0xrrggbbaa)\n');
	  }
	}; /**
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var ColorPropType = void 0;
	
	if (false) {
	  ColorPropType = colorPropType.bind(null, false /* isRequired */);
	  ColorPropType.isRequired = colorPropType.bind(null, true /* isRequired */);
	} else {
	  ColorPropType = function ColorPropType() {};
	}
	
	exports.default = ColorPropType;
	module.exports = exports['default'];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ViewPropTypes = __webpack_require__(1040);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ViewPropTypes2.default;
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var MK = __webpack_require__(14);
	var ReUpText = __webpack_require__(8);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MKSegmentControl = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedIndex: 0,
	      activeBackgroundColor: 'blue',
	      activeShadowColor: 'red',
	      activeTextColor: 'black',
	      activeRippleColor: 'rgba(255,255,255,.2)',
	      inactiveBackgroundColor: 'purple',
	      inactiveTextColor: 'black',
	      inactiveRippleColor: 'rgba(255,255,255,.2)',
	      choiceTitles: ["title1", "title2"],
	      didSelectIndex: function didSelectIndex(index) {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedIndex: this.props.selectedIndex
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didSelectIndex: function didSelectIndex(index) {
	    this.setState({ selectedIndex: index });
	    this.props.didSelectIndex(index);
	  },
	
	  setSelectedIndex: function setSelectedIndex(index) {
	    this.didSelectIndex(index);
	  },
	
	  render: function render() {
	    var selectedIndex = this.state.selectedIndex;
	    var activeBackgroundColor = this.props.activeBackgroundColor;
	    var activeShadowColor = this.props.activeShadowColor;
	    var activeTextColor = this.props.activeTextColor;
	    var activeRippleColor = this.props.inactiveBackgroundColor.indexOf("rgba") == 0 ? this.props.inactiveBackgroundColor.replace("\,1\)", ",.4)") : this.props.activeRippleColor;
	    var inactiveBackgroundColor = this.props.inactiveBackgroundColor;
	    var inactiveTextColor = this.props.inactiveTextColor;
	    var inactiveRippleColor = this.props.activeBackgroundColor.indexOf("rgba") == 0 ? this.props.activeBackgroundColor.replace("\,1\)", ",.4)") : this.props.inactiveRippleColor;
	    var didSelectIndex = this.didSelectIndex;
	
	    return React.createElement(
	      View,
	      { style: this.props.style },
	      React.createElement(
	        View,
	        { style: [styles.choicesContainer, { backgroundColor: inactiveBackgroundColor, elevation: 2 }] },
	        this.props.choiceTitles.map(function (title, index) {
	          var rippleColor = selectedIndex != index ? inactiveRippleColor : activeRippleColor;
	          return React.createElement(
	            MKButton,
	            { key: index, style: [styles.choiceButton],
	              backgroundColor: selectedIndex == index ? activeBackgroundColor : inactiveBackgroundColor,
	              shadowRadius: 2,
	              shadowOffset: { width: 0, height: 2 },
	              shadowOpacity: .7,
	              shadowColor: selectedIndex == index ? activeShadowColor : "transparent",
	              rippleColor: rippleColor,
	              maskBorderRadius: 0,
	              onPress: function onPress() {
	                didSelectIndex(index);
	              }
	            },
	            React.createElement(
	              ReUpText,
	              { pointerEvents: 'none',
	                style: {
	                  lineHeight: 24,
	                  textAlign: 'center',
	                  color: selectedIndex == index ? activeTextColor : inactiveTextColor,
	                  backgroundColor: 'transparent',
	                  fontWeight: 'normal' } },
	              title
	            )
	          );
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  choicesContainer: {
	    flexDirection: 'row',
	    borderRadius: 2
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    alignItems: 'center',
	    flexDirection: 'column',
	    flex: 1,
	    height: 40
	  }
	});
	
	module.exports = MKSegmentControl;

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.shouldUseNativeDriver = exports.assertNativeAnimatedModule = exports.generateNewAnimationId = exports.generateNewNodeTag = exports.validateInterpolation = exports.validateTransform = exports.validateStyles = exports.addWhitelistedInterpolationParam = exports.addWhitelistedTransformProp = exports.addWhitelistedStyleProp = exports.API = undefined;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _NativeModules = __webpack_require__(813);
	
	var _NativeModules2 = _interopRequireDefault(_NativeModules);
	
	var _NativeEventEmitter = __webpack_require__(1066);
	
	var _NativeEventEmitter2 = _interopRequireDefault(_NativeEventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NativeAnimatedModule = _NativeModules2.default.NativeAnimatedModule;
	
	var __nativeAnimatedNodeTagCount = 1; /* used for animated nodes */
	var __nativeAnimationIdCount = 1; /* used for started animations */
	
	var nativeEventEmitter = void 0;
	
	/**
	 * Simple wrappers around NativeAnimatedModule to provide flow and autocmplete support for
	 * the native module methods
	 */
	var API = {
	  createAnimatedNode: function createAnimatedNode(tag, config) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.createAnimatedNode(tag, config);
	  },
	  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startListeningToAnimatedNodeValue(tag);
	  },
	  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag);
	  },
	  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag);
	  },
	  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag);
	  },
	  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback);
	  },
	  stopAnimation: function stopAnimation(animationId) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.stopAnimation(animationId);
	  },
	  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value);
	  },
	  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset);
	  },
	  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag);
	  },
	  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag);
	  },
	  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag);
	  },
	  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag);
	  },
	  dropAnimatedNode: function dropAnimatedNode(tag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.dropAnimatedNode(tag);
	  },
	  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping);
	  },
	  removeAnimatedEventFromView: function removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
	    assertNativeAnimatedModule();
	    NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag);
	  }
	};
	
	/**
	 * Styles allowed by the native animated implementation.
	 *
	 * In general native animated implementation should support any numeric property that doesn't need
	 * to be updated through the shadow view hierarchy (all non-layout properties).
	 */
	var STYLES_WHITELIST = {
	  opacity: true,
	  transform: true,
	  /* ios styles */
	  shadowOpacity: true,
	  shadowRadius: true,
	  /* legacy android transform properties */
	  scaleX: true,
	  scaleY: true,
	  translateX: true,
	  translateY: true
	};
	
	var TRANSFORM_WHITELIST = {
	  translateX: true,
	  translateY: true,
	  scale: true,
	  scaleX: true,
	  scaleY: true,
	  rotate: true,
	  rotateX: true,
	  rotateY: true,
	  perspective: true
	};
	
	var SUPPORTED_INTERPOLATION_PARAMS = {
	  inputRange: true,
	  outputRange: true,
	  extrapolate: true,
	  extrapolateRight: true,
	  extrapolateLeft: true
	};
	
	function addWhitelistedStyleProp(prop) {
	  STYLES_WHITELIST[prop] = true;
	}
	
	function addWhitelistedTransformProp(prop) {
	  TRANSFORM_WHITELIST[prop] = true;
	}
	
	function addWhitelistedInterpolationParam(param) {
	  SUPPORTED_INTERPOLATION_PARAMS[param] = true;
	}
	
	function validateTransform(configs) {
	  configs.forEach(function (config) {
	    if (!TRANSFORM_WHITELIST.hasOwnProperty(config.property)) {
	      throw new Error('Property \'' + config.property + '\' is not supported by native animated module');
	    }
	  });
	}
	
	function validateStyles(styles) {
	  for (var key in styles) {
	    if (!STYLES_WHITELIST.hasOwnProperty(key)) {
	      throw new Error('Style property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function validateInterpolation(config) {
	  for (var key in config) {
	    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(key)) {
	      throw new Error('Interpolation property \'' + key + '\' is not supported by native animated module');
	    }
	  }
	}
	
	function generateNewNodeTag() {
	  return __nativeAnimatedNodeTagCount++;
	}
	
	function generateNewAnimationId() {
	  return __nativeAnimationIdCount++;
	}
	
	function assertNativeAnimatedModule() {
	  (0, _invariant2.default)(NativeAnimatedModule, 'Native animated module is not available');
	}
	
	var _warnedMissingNativeAnimated = false;
	
	function shouldUseNativeDriver(config) {
	  if (config.useNativeDriver && !NativeAnimatedModule) {
	    if (!_warnedMissingNativeAnimated) {
	      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'More info: https://github.com/facebook/react-native/issues/11094#issuecomment-263240420');
	      _warnedMissingNativeAnimated = true;
	    }
	    return false;
	  }
	
	  return config.useNativeDriver || false;
	}
	
	var NativeAnimatedHelper = {
	  API: API,
	  addWhitelistedStyleProp: addWhitelistedStyleProp,
	  addWhitelistedTransformProp: addWhitelistedTransformProp,
	  addWhitelistedInterpolationParam: addWhitelistedInterpolationParam,
	  validateStyles: validateStyles,
	  validateTransform: validateTransform,
	  validateInterpolation: validateInterpolation,
	  generateNewNodeTag: generateNewNodeTag,
	  generateNewAnimationId: generateNewAnimationId,
	  assertNativeAnimatedModule: assertNativeAnimatedModule,
	  shouldUseNativeDriver: shouldUseNativeDriver,
	  get nativeEventEmitter() {
	    if (!nativeEventEmitter) {
	      nativeEventEmitter = new _NativeEventEmitter2.default(NativeAnimatedModule);
	    }
	    return nativeEventEmitter;
	  }
	};
	
	exports.API = API;
	exports.addWhitelistedStyleProp = addWhitelistedStyleProp;
	exports.addWhitelistedTransformProp = addWhitelistedTransformProp;
	exports.addWhitelistedInterpolationParam = addWhitelistedInterpolationParam;
	exports.validateStyles = validateStyles;
	exports.validateTransform = validateTransform;
	exports.validateInterpolation = validateInterpolation;
	exports.generateNewNodeTag = generateNewNodeTag;
	exports.generateNewAnimationId = generateNewAnimationId;
	exports.assertNativeAnimatedModule = assertNativeAnimatedModule;
	exports.shouldUseNativeDriver = shouldUseNativeDriver;
	exports.default = NativeAnimatedHelper;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Note(vjeux): this would be better as an interface but flow doesn't
	// support them yet
	var AnimatedNode = function () {
	  function AnimatedNode() {
	    _classCallCheck(this, AnimatedNode);
	  }
	
	  AnimatedNode.prototype.__attach = function __attach() {};
	
	  AnimatedNode.prototype.__detach = function __detach() {
	    if (this.__isNative && this.__nativeTag != null) {
	      _NativeAnimatedHelper2.default.API.dropAnimatedNode(this.__nativeTag);
	      this.__nativeTag = undefined;
	    }
	  };
	
	  AnimatedNode.prototype.__getValue = function __getValue() {};
	
	  AnimatedNode.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this.__getValue();
	  };
	
	  AnimatedNode.prototype.__addChild = function __addChild(child) {};
	
	  AnimatedNode.prototype.__removeChild = function __removeChild(child) {};
	
	  AnimatedNode.prototype.__getChildren = function __getChildren() {
	    return [];
	  };
	
	  /* Methods and props used by native Animated impl */
	
	
	  AnimatedNode.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      throw new Error('This node cannot be made a "native" animated node');
	    }
	  };
	
	  AnimatedNode.prototype.__getNativeTag = function __getNativeTag() {
	    _NativeAnimatedHelper2.default.assertNativeAnimatedModule();
	    (0, _invariant2.default)(this.__isNative, 'Attempt to get native tag from node not marked as "native"');
	    if (this.__nativeTag == null) {
	      var nativeTag = _NativeAnimatedHelper2.default.generateNewNodeTag();
	      _NativeAnimatedHelper2.default.API.createAnimatedNode(nativeTag, this.__getNativeConfig());
	      this.__nativeTag = nativeTag;
	    }
	    return this.__nativeTag;
	  };
	
	  AnimatedNode.prototype.__getNativeConfig = function __getNativeConfig() {
	    throw new Error('This JS animated node type cannot be used as native animated node');
	  };
	
	  AnimatedNode.prototype.toJSON = function toJSON() {
	    return this.__getValue();
	  };
	
	  return AnimatedNode;
	}();
	
	exports.default = AnimatedNode;
	module.exports = exports['default'];

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLElement, XMLNode, XMLProcessingInstruction, XMLRaw, XMLText, isEmpty, isFunction, isObject, ref,
	    hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(60), isObject = ref.isObject, isFunction = ref.isFunction, isEmpty = ref.isEmpty;
	
	  XMLElement = null;
	
	  XMLCData = null;
	
	  XMLComment = null;
	
	  XMLDeclaration = null;
	
	  XMLDocType = null;
	
	  XMLRaw = null;
	
	  XMLText = null;
	
	  XMLProcessingInstruction = null;
	
	  module.exports = XMLNode = (function() {
	    function XMLNode(parent) {
	      this.parent = parent;
	      if (this.parent) {
	        this.options = this.parent.options;
	        this.stringify = this.parent.stringify;
	      }
	      this.children = [];
	      if (!XMLElement) {
	        XMLElement = __webpack_require__(138);
	        XMLCData = __webpack_require__(130);
	        XMLComment = __webpack_require__(131);
	        XMLDeclaration = __webpack_require__(136);
	        XMLDocType = __webpack_require__(137);
	        XMLRaw = __webpack_require__(140);
	        XMLText = __webpack_require__(141);
	        XMLProcessingInstruction = __webpack_require__(139);
	      }
	    }
	
	    XMLNode.prototype.element = function(name, attributes, text) {
	      var childNode, item, j, k, key, lastChild, len, len1, ref1, val;
	      lastChild = null;
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (Array.isArray(name)) {
	        for (j = 0, len = name.length; j < len; j++) {
	          item = name[j];
	          lastChild = this.element(item);
	        }
	      } else if (isFunction(name)) {
	        lastChild = this.element(name.apply());
	      } else if (isObject(name)) {
	        for (key in name) {
	          if (!hasProp.call(name, key)) continue;
	          val = name[key];
	          if (isFunction(val)) {
	            val = val.apply();
	          }
	          if ((isObject(val)) && (isEmpty(val))) {
	            val = null;
	          }
	          if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) {
	            lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
	          } else if (!this.options.separateArrayItems && Array.isArray(val)) {
	            for (k = 0, len1 = val.length; k < len1; k++) {
	              item = val[k];
	              childNode = {};
	              childNode[key] = item;
	              lastChild = this.element(childNode);
	            }
	          } else if (isObject(val)) {
	            lastChild = this.element(key);
	            lastChild.element(val);
	          } else {
	            lastChild = this.element(key, val);
	          }
	        }
	      } else {
	        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) {
	          lastChild = this.text(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) {
	          lastChild = this.cdata(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) {
	          lastChild = this.comment(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) {
	          lastChild = this.raw(text);
	        } else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) {
	          lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
	        } else {
	          lastChild = this.node(name, attributes, text);
	        }
	      }
	      if (lastChild == null) {
	        throw new Error("Could not create any elements with: " + name);
	      }
	      return lastChild;
	    };
	
	    XMLNode.prototype.insertBefore = function(name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.insertAfter = function(name, attributes, text) {
	      var child, i, removed;
	      if (this.isRoot) {
	        throw new Error("Cannot insert elements at root level");
	      }
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.element(name, attributes, text);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return child;
	    };
	
	    XMLNode.prototype.remove = function() {
	      var i, ref1;
	      if (this.isRoot) {
	        throw new Error("Cannot remove the root element");
	      }
	      i = this.parent.children.indexOf(this);
	      [].splice.apply(this.parent.children, [i, i - i + 1].concat(ref1 = [])), ref1;
	      return this.parent;
	    };
	
	    XMLNode.prototype.node = function(name, attributes, text) {
	      var child, ref1;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      attributes || (attributes = {});
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      child = new XMLElement(this, name, attributes);
	      if (text != null) {
	        child.text(text);
	      }
	      this.children.push(child);
	      return child;
	    };
	
	    XMLNode.prototype.text = function(value) {
	      var child;
	      child = new XMLText(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.cdata = function(value) {
	      var child;
	      child = new XMLCData(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.comment = function(value) {
	      var child;
	      child = new XMLComment(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.commentBefore = function(value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.comment(value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.commentAfter = function(value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.comment(value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.raw = function(value) {
	      var child;
	      child = new XMLRaw(this, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLNode.prototype.instruction = function(target, value) {
	      var insTarget, insValue, instruction, j, len;
	      if (target != null) {
	        target = target.valueOf();
	      }
	      if (value != null) {
	        value = value.valueOf();
	      }
	      if (Array.isArray(target)) {
	        for (j = 0, len = target.length; j < len; j++) {
	          insTarget = target[j];
	          this.instruction(insTarget);
	        }
	      } else if (isObject(target)) {
	        for (insTarget in target) {
	          if (!hasProp.call(target, insTarget)) continue;
	          insValue = target[insTarget];
	          this.instruction(insTarget, insValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        instruction = new XMLProcessingInstruction(this, target, value);
	        this.children.push(instruction);
	      }
	      return this;
	    };
	
	    XMLNode.prototype.instructionBefore = function(target, value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i);
	      child = this.parent.instruction(target, value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.instructionAfter = function(target, value) {
	      var child, i, removed;
	      i = this.parent.children.indexOf(this);
	      removed = this.parent.children.splice(i + 1);
	      child = this.parent.instruction(target, value);
	      Array.prototype.push.apply(this.parent.children, removed);
	      return this;
	    };
	
	    XMLNode.prototype.declaration = function(version, encoding, standalone) {
	      var doc, xmldec;
	      doc = this.document();
	      xmldec = new XMLDeclaration(doc, version, encoding, standalone);
	      if (doc.children[0] instanceof XMLDeclaration) {
	        doc.children[0] = xmldec;
	      } else {
	        doc.children.unshift(xmldec);
	      }
	      return doc.root() || doc;
	    };
	
	    XMLNode.prototype.doctype = function(pubID, sysID) {
	      var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
	      doc = this.document();
	      doctype = new XMLDocType(doc, pubID, sysID);
	      ref1 = doc.children;
	      for (i = j = 0, len = ref1.length; j < len; i = ++j) {
	        child = ref1[i];
	        if (child instanceof XMLDocType) {
	          doc.children[i] = doctype;
	          return doctype;
	        }
	      }
	      ref2 = doc.children;
	      for (i = k = 0, len1 = ref2.length; k < len1; i = ++k) {
	        child = ref2[i];
	        if (child.isRoot) {
	          doc.children.splice(i, 0, doctype);
	          return doctype;
	        }
	      }
	      doc.children.push(doctype);
	      return doctype;
	    };
	
	    XMLNode.prototype.up = function() {
	      if (this.isRoot) {
	        throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
	      }
	      return this.parent;
	    };
	
	    XMLNode.prototype.root = function() {
	      var node;
	      node = this;
	      while (node) {
	        if (node.isDocument) {
	          return node.rootObject;
	        } else if (node.isRoot) {
	          return node;
	        } else {
	          node = node.parent;
	        }
	      }
	    };
	
	    XMLNode.prototype.document = function() {
	      var node;
	      node = this;
	      while (node) {
	        if (node.isDocument) {
	          return node;
	        } else {
	          node = node.parent;
	        }
	      }
	    };
	
	    XMLNode.prototype.end = function(options) {
	      return this.document().end(options);
	    };
	
	    XMLNode.prototype.prev = function() {
	      var i;
	      i = this.parent.children.indexOf(this);
	      if (i < 1) {
	        throw new Error("Already at the first node");
	      }
	      return this.parent.children[i - 1];
	    };
	
	    XMLNode.prototype.next = function() {
	      var i;
	      i = this.parent.children.indexOf(this);
	      if (i === -1 || i === this.parent.children.length - 1) {
	        throw new Error("Already at the last node");
	      }
	      return this.parent.children[i + 1];
	    };
	
	    XMLNode.prototype.importDocument = function(doc) {
	      var clonedRoot;
	      clonedRoot = doc.root().clone();
	      clonedRoot.parent = this;
	      clonedRoot.isRoot = false;
	      this.children.push(clonedRoot);
	      return this;
	    };
	
	    XMLNode.prototype.ele = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.nod = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.txt = function(value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.dat = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.com = function(value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.ins = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLNode.prototype.doc = function() {
	      return this.document();
	    };
	
	    XMLNode.prototype.dec = function(version, encoding, standalone) {
	      return this.declaration(version, encoding, standalone);
	    };
	
	    XMLNode.prototype.dtd = function(pubID, sysID) {
	      return this.doctype(pubID, sysID);
	    };
	
	    XMLNode.prototype.e = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLNode.prototype.n = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLNode.prototype.t = function(value) {
	      return this.text(value);
	    };
	
	    XMLNode.prototype.d = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLNode.prototype.c = function(value) {
	      return this.comment(value);
	    };
	
	    XMLNode.prototype.r = function(value) {
	      return this.raw(value);
	    };
	
	    XMLNode.prototype.i = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLNode.prototype.u = function() {
	      return this.up();
	    };
	
	    XMLNode.prototype.importXMLBuilder = function(doc) {
	      return this.importDocument(doc);
	    };
	
	    return XMLNode;
	
	  })();
	
	}).call(this);


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var FeatureBuilder = __webpack_require__(90);
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	var ReUpText = __webpack_require__(8);
	var ReUpIconButton = __webpack_require__(18);
	var PlatformConstants = __webpack_require__(31);
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var PaymentMethodChooserView = __webpack_require__(94);
	var ShadowView = __webpack_require__(20);
	var AddToWalletButton = __webpack_require__(62);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton,
	    MKIconToggle = MK.MKIconToggle;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var FeedCard = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      didSelect: function didSelect() {},
	      title: "",
	      body1: "",
	      body2: "",
	      icon: "",
	      iconColor: "#000",
	      bannerColor: "#444",
	      rippleColor: "#444",
	      cardColor: "rgba(255,255,255,.8)",
	      highlightColor: "rgba(255,255,255,1)",
	      titleColor: "#000",
	      bodyColor: "#000",
	      image: "",
	      attachments: [],
	      media: [],
	      picture: "",
	      cardType: 0,
	      columnData: [],
	      cardHeight: function cardHeight(height) {},
	      loginPressed: function loginPressed(username, password) {
	        alert(username + " " + password);
	      },
	      registerPressed: function registerPressed() {
	        alert("register!");
	      },
	      forgotPasswordPressed: function forgotPasswordPressed() {
	        alert("need to set forgotPasswordPressed");
	      },
	      logoutPressed: function logoutPressed() {
	        alert("need to set logoutSelected");
	      },
	      changePasswordPressed: function changePasswordPressed() {
	        alert("need to set changePasswordPressed");
	      },
	      profilePicSelected: function profilePicSelected() {
	        alert("need to set profilePicSelected");
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      showPassword: false,
	      scrollEnabled: false,
	      shouldShowRightArrow: true,
	      shouldShowLeftArrow: false,
	      shouldShowEmailLogin: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  focus: function focus() {
	    if (this._fieldToFocus) this._fieldToFocus.focus();
	  },
	
	  _username: "",
	  onUsernameChange: function onUsernameChange(username) {
	    this._username = username;
	  },
	
	  _password: "",
	  onPasswordChange: function onPasswordChange(password) {
	    this._password = password;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var appManager = this.props.appManager;
	    if (this.props.cardType == 0) // default
	      {
	        var thisThing = this;
	        return React.createElement(
	          MKButton,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }],
	            onPress: function onPress() {
	              return _this.props.didSelect();
	            },
	            underlayColor: this.props.highlightColor,
	            rippleColor: this.props.rippleColor,
	            maskBorderRadius: 2,
	            onLayout: function onLayout(info) {
	              var layout = info.nativeEvent.layout;
	              _this.props.cardHeight(layout.height);
	            } },
	          React.createElement(
	            View,
	            { style: [styles.container] },
	            React.createElement(
	              View,
	              { style: [styles.bannerContainer] },
	              React.createElement(
	                View,
	                { style: [styles.bannerCircle, { backgroundColor: this.props.bannerColor }] },
	                React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 16, color: this.props.iconColor, style: [styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT] })
	              )
	            ),
	            React.createElement(
	              View,
	              { style: styles.contentContainer },
	              typeof this.props.title !== 'undefined' && this.props.title.length > 0 ? React.createElement(
	                View,
	                { style: styles.contentTitle },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                  this.props.title
	                )
	              ) : null,
	              typeof this.props.smallTitle !== 'undefined' && this.props.smallTitle.length > 0 ? React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.contentTitleSmall, { color: this.props.titleColor }] },
	                this.props.smallTitle
	              ) : null,
	              this.props.body1.length > 0 ? React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.contentBody, { color: this.props.bodyColor }] },
	                this.props.body1
	              ) : React.createElement(View, null),
	              this.props.columnData.map(function (data, index) {
	                return React.createElement(
	                  View,
	                  { key: JSON.stringify(data), style: [styles.rowData, index == thisThing.props.columnData.length - 1 ? { paddingBottom: 8 } : {}] },
	                  data.map(function (colData, colIndex) {
	                    var _React$createElement;
	
	                    return React.createElement(
	                      ReUpText,
	                      (_React$createElement = { key: colData, appManager: appManager }, _defineProperty(_React$createElement, 'key', colIndex), _defineProperty(_React$createElement, 'style', [styles.colData, colIndex == 0 ? { flex: 2, color: thisThing.props.bodyColor } : { textAlign: 'center', color: thisThing.props.bodyColor }]), _React$createElement),
	                      colData
	                    );
	                  })
	                );
	              }),
	              this.props.attachments.map(function (attachment, index) {
	                if (typeof attachment.media === 'undefined' || typeof attachment.media.image === 'undefined') return null;
	
	                var width = attachment.media.image.width;
	                var height = attachment.media.image.height;
	                if (width <= 0 || height <= 0) return null;
	
	                var aspectRatio = width / height;
	                height = 220;
	                width = height * aspectRatio;
	                return React.createElement(Image, { resizeMode: 'contain', style: {
	                    marginTop: 4,
	                    marginLeft: -42,
	                    marginRight: 8,
	                    marginBottom: 8,
	                    height: 120,
	                    borderBottomLeftRadius: 2, borderBottomRightRadius: 2 }, source: { uri: attachment.media.image.src } });
	              }),
	              this.props.media.map(function (aMedia, index) {
	                if (typeof aMedia.media_url_https === 'undefined') return null;
	
	                return React.createElement(Image, { resizeMode: 'contain', style: {
	                    marginTop: 4,
	                    marginLeft: -42,
	                    marginRight: 8,
	                    marginBottom: 8,
	                    height: 120,
	                    borderBottomLeftRadius: 2, borderBottomRightRadius: 2 }, source: { uri: aMedia.media_url_https } });
	              }),
	              this.props.picture.length > 0 ? React.createElement(Image, { resizeMode: 'contain', style: {
	                  marginTop: 4,
	                  marginLeft: -42,
	                  marginRight: 8,
	                  marginBottom: 8,
	                  height: 120,
	                  borderBottomLeftRadius: 2, borderBottomRightRadius: 2 }, source: { uri: this.props.picture } }) : null
	            )
	          )
	        );
	      } else if (this.props.cardType == 1) // image
	      {
	        var _ref;
	
	        return React.createElement(
	          MKButton,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }],
	            onPress: function onPress() {
	              return _this.props.didSelect();
	            },
	            underlayColor: this.props.highlightColor,
	            rippleColor: this.props.rippleColor,
	            maskBorderRadius: 2,
	            onLayout: function onLayout(info) {
	              var layout = info.nativeEvent.layout;
	              _this.props.cardHeight(layout.height);
	            } },
	          React.createElement(
	            Image,
	            { key: this.props.imageName, style: [styles.imageContainer], source: { uri: this.props.imageName } },
	            React.createElement(
	              View,
	              { style: [styles.bannerContainer] },
	              React.createElement(
	                View,
	                { style: [styles.bannerCircle, { backgroundColor: this.props.bannerColor }] },
	                React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 16, color: this.props.iconColor, style: [styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT] })
	              )
	            ),
	            React.createElement(
	              View,
	              { style: styles.imageFooterContainer },
	              React.createElement(
	                View,
	                { style: styles.contentTitle },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: [(_ref = { color: this.props.titleColor, textAlign: 'center' }, _defineProperty(_ref, 'color', 'black'), _defineProperty(_ref, 'marginTop', 4), _defineProperty(_ref, 'marginBottom', 4), _defineProperty(_ref, 'margin', 4), _ref)], numberOfLines: 3 },
	                  this.props.title
	                )
	              )
	            )
	          )
	        );
	      } else if (this.props.cardType == 2) // Login
	      {
	        var feedCard = this;
	        var locManager = appManager.getLocalizationManager();
	        var forgotPasswordFeature = appManager.getFeatureForName("ForgotPassword");
	
	        var forgotPasswordButton = appManager.getLocalizationManager().localizedStringForKey("FORGOT_PASSWORD_BUTTON");
	        var emailPlaceholder = locManager.localizedStringForKey("EMAIL_PLACEHOLDER_ELLIPSIS");
	        var passwordPlaceholder = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER_ELLIPSIS");
	
	        var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	        var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	        var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	        var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	        var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	        var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	        var feedFeature = appManager.getFeatureForName("Feed");
	        var headerImage = "";
	        if (feedFeature && feedFeature.data.headerImage && feedFeature.data.headerImage.trim().length > 0) {
	          headerImage = appManager.absoluteResourceForPath(feedFeature.data.name + '/' + feedFeature.data.headerImage);
	        }
	
	        var shouldShowEmailAndFacebook = appManager.useFacebookForFeatureName("Login") && !this.state.shouldShowEmailLogin;
	
	        if (shouldShowEmailAndFacebook) {
	          return React.createElement(
	            View,
	            { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	            React.createElement(
	              View,
	              { style: [styles.fullWidthContainer] },
	              headerImage.length > 0 ? React.createElement(View, null)
	              // <Image
	              //   style={{width:150, height:44, alignSelf:'center', marginBottom:4}}
	              //   source={{uri: headerImage}}
	              // />
	              : React.createElement(View, null),
	              React.createElement(ReUpButton, { key: 'fb', appManager: appManager, icon: 'facebook-official', iconSize: 22, iconPaddingLeft: 8, buttonColor: '#244BA1', buttonTitleColor: 'white', style: [styles.doneButton, { marginBottom: 0 }], text: locManager.localizedStringForKey("CONTINUE_WITH_FACEBOOK_BUTTON", "Continue With Facebook"),
	                onPress: this.props.loginFacebookPressed
	              }),
	              React.createElement(ShadowView, { layout: this.state.layout, text: locManager.localizedStringForKey("OR_LABEL"), appManager: appManager }),
	              React.createElement(ReUpButton, { key: 'showemail', appManager: appManager, style: [styles.doneButton], text: locManager.localizedStringForKey("LOG_IN_WITH_EMAIL", "Log In With Email"),
	                onPress: function onPress() {
	                  feedCard.setState({ shouldShowEmailLogin: true });
	                  setTimeout(function () {
	                    feedCard.focus();
	                  }, 100);
	                }
	              })
	            )
	          );
	        }
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            headerImage.length > 0 ? React.createElement(View, null)
	            // <Image
	            //   style={{width:150, height:44, alignSelf:'center', marginBottom:4}}
	            //   source={{uri: headerImage}}
	            // />
	            : React.createElement(View, null),
	            React.createElement(ReUpField, {
	              ref: function ref(a) {
	                return _this._fieldToFocus = a;
	              },
	              appManager: appManager,
	              onChangeText: this.onUsernameChange,
	              tintColor: this.props.bodyColor,
	              highlightColor: this.props.bannerColor,
	              textInputStyle: { color: this.props.titleColor },
	              placeholder: emailPlaceholder,
	              placeholderTextColor: 'grey',
	              autoCapitalize: 'none',
	              autoCorrect: false,
	              keyboardType: 'email-address',
	              returnKeyType: "next",
	              onSubmitEditing: function onSubmitEditing() {
	                return _this.refs["password"].focus();
	              } }),
	            React.createElement(ReUpField, {
	              ref: 'password',
	              appManager: appManager,
	              onChangeText: this.onPasswordChange,
	              tintColor: this.props.bodyColor,
	              highlightColor: this.props.bannerColor,
	              placeholderTextColor: 'grey',
	              textInputStyle: { color: this.props.titleColor },
	              placeholder: passwordPlaceholder,
	              secureTextEntry: true,
	              returnKeyType: "done",
	              onSubmitEditing: function onSubmitEditing() {
	                return _this.props.loginPressed(feedCard._username, feedCard._password);
	              } }),
	            React.createElement(ReUpButton, { appManager: appManager, style: styles.loginButton,
	              onPress: function onPress() {
	                _this.props.loginPressed(feedCard._username, feedCard._password);
	              },
	              text: this.props.loginFeatureData.title
	            }),
	            React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: [styles.loginButton, { marginTop: 8 }],
	              onPress: function onPress() {
	                _this.props.forgotPasswordPressed();
	              },
	              text: forgotPasswordButton
	            })
	          )
	        );
	      } else if (this.props.cardType == 3) // settings top card
	      {
	        var _ref2;
	
	        var appManager = this.props.appManager;
	        var thisThing = this;
	        var locMan = appManager.getLocalizationManager();
	        var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	        var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        var loggedInAsName = this.props.loggedInAsName;
	        var loggedInAsEmail = this.props.loggedInAsEmail;
	        var logoutText = this.props.logoutText;
	
	        var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
	        var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
	        var creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
	        var pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
	
	        var classNames = typeof appManager.currentUser()[ModelConstants.ClassNames] !== 'undefined' ? appManager.currentUser()[ModelConstants.ClassNames].join(", ") : "";
	
	        var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	        var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	        var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	        var profileImage = this.props.profileImage;
	        var profileColor = appManager.getColorForKey("ProfileColor");
	        var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	        var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	        var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	        var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	        var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	        var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);
	
	        var initials = appManager.currentUserInitials();
	
	        var useSelfie = typeof this.props.selfieURL !== 'undefined' && this.props.selfieURL != null && this.props.selfieURL.length > 0;
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor, padding: 10 }] },
	          React.createElement(
	            View,
	            { style: [styles.container, styles.profileContainer] },
	            React.createElement(
	              View,
	              { style: styles.profileTopContainer },
	              React.createElement(
	                View,
	                { style: [styles.profileImageContainer] },
	                React.createElement(
	                  TouchableHighlight,
	                  {
	                    underlayColor: "transparent",
	                    activeOpacity: 0.9,
	                    onPress: function onPress() {
	                      thisThing.props.profilePicSelected();
	                    } },
	                  React.createElement(
	                    View,
	                    { style: [styles.profileImage, { borderColor: profileColor, borderWidth: 0, backgroundColor: profileColor }] },
	                    useSelfie ? React.createElement(
	                      View,
	                      { style: { flex: 1 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [styles.profileImageText, { position: 'absolute', bottom: 0, right: 0, top: 16, left: 0 }] },
	                        initials
	                      ),
	                      React.createElement(Image, { source: { uri: this.props.selfieURL }, style: (_ref2 = { backgroundColor: 'transparent', margin: 0, borderRadius: 38 }, _defineProperty(_ref2, 'margin', 1), _defineProperty(_ref2, 'flex', 1), _defineProperty(_ref2, 'justifyContent', 'center'), _ref2) })
	                    ) : React.createElement(
	                      View,
	                      { style: { flex: 1, backgroundColor: profileImageColorLight, borderRadius: 39, justifyContent: 'center' } },
	                      React.createElement(
	                        View,
	                        null,
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: [styles.profileImageText, { color: profileImageColor }] },
	                          initials
	                        )
	                      ),
	                      React.createElement(
	                        View,
	                        { style: { position: 'absolute', bottom: 0, left: 0, right: 0, height: 24, justifyContent: 'center', alignItems: 'center' } },
	                        React.createElement(_ReUpIcon2.default, { name: "camera", size: 16, color: profileImageColor })
	                      )
	                    ),
	                    React.createElement(
	                      _reactNativeSvgWrapper2.default,
	                      {
	                        height: 110,
	                        width: 110,
	                        style: { position: 'absolute', top: -10, left: -10, backgroundColor: 'transparent' }
	                      },
	                      React.createElement(
	                        _reactNativeSvgWrapper.G,
	                        { scale: '1' },
	                        React.createElement(_reactNativeSvgWrapper.Circle, { cx: '50', cy: '50', r: '39.5', stroke: profileImageColor, 'stroke-width': 2, fill: 'transparent' })
	                      )
	                    )
	                  )
	                )
	              ),
	              React.createElement(
	                View,
	                { style: styles.profileInfoContainer },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: { color: this.props.titleColor, marginVertical: 4, marginTop: 20 } },
	                  loggedInAsName
	                ),
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: { color: this.props.bodyColor } },
	                  loggedInAsEmail
	                ),
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingTop: 20, paddingBottom: classNames.length > 0 ? 10 : 20 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center' } },
	                    React.createElement(_ReUpIcon2.default, { name: 'dollar', size: 15, color: this.props.bodyColor }),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: this.props.bodyColor, marginLeft: 10 } },
	                      creditString
	                    )
	                  ),
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center', marginLeft: 20 } },
	                    React.createElement(_ReUpIcon2.default, { name: 'star', size: 15, color: this.props.bodyColor }),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: this.props.bodyColor, marginLeft: 10 } },
	                      pointsString
	                    )
	                  )
	                ),
	                classNames.length > 0 ? React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', justifyContent: 'flex-start', paddingBottom: 20 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center' } },
	                    React.createElement(_ReUpIcon2.default, { name: 'trophy', size: 15, color: this.props.bodyColor }),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: this.props.bodyColor, marginLeft: 10 } },
	                      classNames
	                    )
	                  )
	                ) : null
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(AddToWalletButton, { appManager: appManager })
	            )
	          )
	        );
	      } else if (this.props.cardType == 4) // login create user
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var createUserButton = locMan.localizedStringForKey("CREATEUSER_CREATE_BUTTON");
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: [styles.contentTitle, { color: this.props.titleColor, marginTop: -4 }] },
	              this.props.createUserFeatureData.title
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.contentBody, { color: this.props.bodyColor }] },
	              this.props.createUserFeatureData.tip
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, style: [styles.loginButton, { marginTop: -4 }],
	              onPress: this.props.registerPressed,
	              text: this.props.createUserFeatureData.title
	            })
	          )
	        );
	      } else if (this.props.cardType == 5) // payment types
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var createUserButton = locMan.localizedStringForKey("CREATEUSER_CREATE_BUTTON");
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              View,
	              { style: [styles.contentTitle, { marginTop: -4 }] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                this.props.paymentTypesFeatureData.title
	              )
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.contentBody, { color: this.props.bodyColor }] },
	              this.props.paymentTypesFeatureData.tip
	            )
	          ),
	          React.createElement(
	            View,
	            { style: [{ flexDirection: 'row', marginTop: -8 }] },
	            React.createElement(PaymentMethodChooserView, { ref: "paymentMethod", style: { flex: 1, marginTop: 0 }, appManager: appManager, appActions: this.props.appActions,
	              paymentInfo: this.props.paymentInfo })
	          )
	        );
	      } else if (this.props.cardType == 6) // transaction history
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              View,
	              { style: [styles.contentTitle, { marginTop: -4 }] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                this.props.transactionHistoryFeatureData.title
	              )
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.contentBody, { color: this.props.bodyColor }] },
	              this.props.transactionHistoryFeatureData.tip
	            )
	          ),
	          React.createElement(
	            View,
	            { style: styles.profileBottomContainer },
	            React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, style: [styles.logoutButton, { marginTop: 0 }],
	              onPress: function onPress() {
	                thisThing.props.appActions.requestFeatureName("TransactionHistory");
	              },
	              text: this.props.transactionHistoryFeatureData.title
	            })
	          )
	        );
	      } else if (this.props.cardType == 7) // instagram
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	        var feedCardColor = appManager.getColorForKey("FeedCardColor");
	        var highlightColor = this.props.highlightColor;
	        var rippleColor = this.props.rippleColor;
	        var cardColor = this.props.cardColor;
	        var imageURLs = this.props.imageURLs;
	        if (imageURLs.length <= 0) return React.createElement(View, null);
	
	        var didSelect = this.props.didSelect;
	
	        return React.createElement(
	          View,
	          { key: 'instagram', style: [styles.outerContainer, { height: 200, borderRadius: 2 }] },
	          React.createElement(
	            View,
	            { key: 'instagramView' },
	            React.createElement(
	              ScrollView,
	              { key: 'instagramScrollView', scrollEnabled: this.state.scrollEnabled, alwaysBounceHorizontal: true, bounces: true, contentContainerStyle: { backgroundColor: 'transparent', borderRadius: 2 }, horizontal: true, snapToInterval: 200, style: { height: 200, flex: 1, borderRadius: 2, backgroundColor: 'transparent' } },
	              imageURLs.map(function (imageURL, index) {
	                var _this2 = this;
	
	                var style = { height: 200, width: 200 };
	                if (index == 0) {
	                  style.borderTopLeftRadius = 2;
	                  style.borderBottomLeftRadius = 2;
	                  style.borderRadius = 2;
	                }
	                if (index == imageURLs.length - 1) {
	                  style.borderTopRightRadius = 2;
	                  style.borderBottomRightRadius = 2;
	                  style.borderRadius = 2;
	                }
	                return React.createElement(
	                  MKButton,
	                  { key: "button" + imageURL, style: { backgroundColor: feedCardColor, borderRadius: 2 },
	                    onPress: function onPress() {
	                      return didSelect();
	                    },
	                    underlayColor: highlightColor,
	                    rippleColor: rippleColor,
	                    maskBorderRadius: 2,
	                    onLayout: function onLayout(info) {
	                      var layout = info.nativeEvent.layout;
	                      _this2.props.cardHeight(layout.height);
	                    } },
	                  React.createElement(Image, { key: imageURL, style: style, source: { uri: imageURL } })
	                );
	              })
	            )
	          ),
	          React.createElement(
	            View,
	            { style: [styles.bannerContainer, { marginTop: -200 }] },
	            React.createElement(
	              View,
	              { style: [styles.bannerCircle, { backgroundColor: this.props.bannerColor }] },
	              React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 18, color: this.props.iconColor, style: [styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT] })
	            )
	          ),
	          this.state.scrollEnabled ? null : React.createElement(
	            View,
	            { style: { alignSelf: 'flex-end', marginRight: 8 } },
	            React.createElement(ReUpIconButton, { iconName: "angle-right", style: { pointerEvents: 'auto', paddingLeft: 2, width: 30, height: 30, backgroundColor: 'red', marginTop: 30 }, appManager: appManager, type: 1, onPress: function onPress() {
	                thisThing.setState({ scrollEnabled: true });
	              } })
	          )
	        );
	      } else if (this.props.cardType == 8) // tutorial
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              View,
	              { style: [styles.contentTitle, { marginTop: -4 }] },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                this.props.tutorialFeatureData.title
	              )
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.contentBody, { color: this.props.bodyColor }] },
	              this.props.tutorialFeatureData.tip
	            )
	          ),
	          React.createElement(
	            View,
	            { style: styles.profileBottomContainer },
	            React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, style: [styles.logoutButton, { marginTop: 0 }],
	              onPress: function onPress() {
	                thisThing.props.appActions.requestFeatureName("Tutorial", { forceShow: true });
	              },
	              text: this.props.tutorialFeatureData.title
	            })
	          )
	        );
	      } else if (this.props.cardType == 9) // account info
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var appActions = thisThing.props.appActions;
	        var locMan = appManager.getLocalizationManager();
	
	        var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	        var acccountInfoTitle = locMan.localizedStringForKey("ACCOUNT_INFO_TITLE");
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	        var hasPrimaryPaymentMethod = appManager.userHasPrimaryPaymentMethod();
	        var phoneFeature = appManager.getFeatureForName("PhoneNumberVerify");
	        var phoneNumber = appManager.currentUser()[ModelConstants.PhoneNumber];
	        var showPhoneNumberButton = appManager.currentUser()[ModelConstants.ShowPhoneNumber];
	        var hasPhoneNumber = appManager.userHasPhoneNumber();
	        var editPhoneNumberButton = locMan.localizedStringForKey("EDIT_PHONE_BUTTON", "Edit Phone Number");
	        if (!hasPhoneNumber) editPhoneNumberButton = locMan.localizedStringForKey("SET_PHONE_BUTTON", "Set Phone Number");
	
	        var user = appManager.currentUser();
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor, padding: 10, paddingTop: 0 }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              View,
	              { style: styles.contentTitle },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                'Account Info'
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { padding: 0, margin: 0 }] },
	            React.createElement(PaymentMethodChooserView, { ref: "paymentMethod", style: { flex: 1, marginTop: 0, marginBootom: 0 }, appManager: appManager, appActions: this.props.appActions,
	              paymentInfo: this.props.paymentInfo })
	          ),
	          typeof phoneFeature !== 'undefined' && showPhoneNumberButton ? React.createElement(
	            View,
	            { style: { paddingHorizontal: 8, backgroundColor: 'transparent', flexDirection: 'row' } },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'pencil', style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0 }], text: editPhoneNumberButton,
	              onPress: function onPress() {
	                appActions.requestFeatureName("PhoneNumberVerify");
	              } })
	          ) : null,
	          user[ModelConstants.CanJoinGroups] && user[ModelConstants.JoinedGroupNames].length <= 0 ? React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0, backgroundColor: 'transparent' }] },
	            React.createElement(ReUpButton, { appManager: appManager, style: {
	                justifyContent: 'center',
	                flex: 1,
	                paddingHorizontal: 10 }, text: locMan.localizedStringForKey("JOIN_GROUP_BUTTON", "Join Group"),
	              onPress: this.props.joinGroupPressed })
	          ) : null,
	          user[ModelConstants.CanJoinGroups] && user[ModelConstants.JoinedGroupNames].length > 0 ? React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 10, paddingLeft: 14, backgroundColor: 'transparent', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }] },
	            React.createElement(_ReUpIcon2.default, { name: "users", size: 18, color: this.props.titleColor, style: { marginRight: 10 } }),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [{ color: this.props.titleColor }] },
	              user[ModelConstants.JoinedGroupNames].join(", ")
	            )
	          ) : null,
	          user[ModelConstants.HasPassword] ? React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0, backgroundColor: 'transparent' }] },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'pencil', iconColor: feedCardColor, style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0 }], text: locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON"),
	              onPress: this.props.changePasswordPressed })
	          ) : null,
	          appManager.useFacebookForFeatureName("Settings") ? React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0, backgroundColor: 'transparent' }] },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'angle-right', iconColor: feedCardColor, style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0 }],
	              text: user[ModelConstants.HasFacebook] ? locMan.localizedStringForKey("FACEBOOK_CONNECTED", "Facebook Connected") : locMan.localizedStringForKey("CONNECT_FACEBOOK", "Connect Facebook"),
	              onPress: this.props.loginFacebookPressed })
	          ) : null,
	          React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0 }] },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'angle-right', iconColor: feedCardColor, style: [styles.logoutButton, { margin: 0, marginVertical: 0, backgroundColor: 'transparent', padding: 0, marginTop: -5, marginBottom: -10 }],
	              onPress: function onPress() {
	                thisThing.props.appActions.requestFeatureName("TransactionHistory");
	              },
	              text: this.props.transactionHistoryFeatureData.title
	            })
	          ),
	          React.createElement(
	            View,
	            { style: styles.profileBottomContainer },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'angle-right', iconColor: feedCardColor, style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0 }], text: locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON"),
	              onPress: this.props.changePasswordPressed })
	          )
	        );
	      } else if (this.props.cardType == 10) // help
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	        var tutorialFeature = appManager.getFeatureForName("Tutorial");
	        var shouldShowTutorial = typeof tutorialFeature !== 'undefined' && !appManager.disableInterstitial();
	
	        return React.createElement(
	          View,
	          { style: [styles.outerContainer, { backgroundColor: this.props.cardColor, padding: 10, paddingTop: 0 }] },
	          React.createElement(
	            View,
	            { style: [styles.fullWidthContainer] },
	            React.createElement(
	              View,
	              { style: styles.contentTitle },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: this.props.titleColor }] },
	                'Help'
	              )
	            )
	          ),
	          shouldShowTutorial ? React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0, marginBottom: 0 }] },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'angle-right', style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0 }], text: tutorialFeature.data.title,
	              onPress: function onPress() {
	                thisThing.props.appActions.requestFeatureName("Tutorial", { forceShow: true });
	              } })
	          ) : null,
	          React.createElement(
	            View,
	            { style: [styles.profileBottomContainer, { paddingTop: 0, marginBottom: 0 }] },
	            React.createElement(ReUpButton, { appManager: appManager, style: [styles.logoutButton, { padding: 0 }],
	              onPress: function onPress() {
	                thisThing.props.appActions.requestFeatureName("Tutorial", { forceShow: true });
	              },
	              text: locMan.localizedStringForKey("VIEW_TUTORIAL_BUTTON")
	            })
	          ),
	          React.createElement(
	            View,
	            { style: [styles.profileBottomContainer] },
	            React.createElement(ReUpButton, { appManager: appManager, isTertiary: true, icon: 'angle-right', iconColor: feedCardColor, text: locMan.localizedStringForKey("CONTACT_SUPPORT_BUTTON"),
	              onPress: this.props.contactSupport, style: [styles.logoutButton, { backgroundColor: 'transparent', padding: 0, marginTop: -5 }] })
	          )
	        );
	      } else if (this.props.cardType == 11) // earn points
	      {
	        var thisThing = this;
	        var appManager = thisThing.props.appManager;
	        var locMan = appManager.getLocalizationManager();
	
	        var generalColor = appManager.getColorForKey("GeneralColor");
	        var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	        var feedCardColor = appManager.getColorForKey("FeedCardColor");
	        var highlightColor = this.props.highlightColor;
	        var rippleColor = this.props.rippleColor;
	        var cardColor = this.props.cardColor;
	        var campaigns = this.props.campaigns;
	        if (campaigns.length <= 0) return React.createElement(View, null);
	
	        return React.createElement(
	          View,
	          { key: 'earnPoints', style: [styles.outerContainer, { height: 200, borderRadius: 2, flexDirection: 'column' }] },
	          React.createElement(
	            View,
	            { key: 'earnPointsView', style: { flexDirection: 'row' } },
	            React.createElement(
	              ScrollView,
	              { key: 'earnPointsScrollView', ref: 'earnPointsScrollView', decelerationRate: 'fast', scrollEnabled: this.state.scrollEnabled, alwaysBounceHorizontal: true, bounces: true, contentContainerStyle: { backgroundColor: 'transparent', borderRadius: 2 }, horizontal: true, snapToInterval: 200, style: { height: 200, flex: 1, borderRadius: 2, backgroundColor: 'transparent' },
	                scrollEventThrottle: 20,
	                onScroll: function onScroll(info) {
	                  var scrollOffsetX = info.nativeEvent.contentOffset.x;
	                  thisThing._page = Math.round(scrollOffsetX / 200);
	                  var shouldShowRightArrow = thisThing._page < campaigns.length - 1;
	                  if (shouldShowRightArrow != thisThing.state.shouldShowRightArrow) thisThing.setState({ shouldShowRightArrow: shouldShowRightArrow });
	
	                  var shouldShowLeftArrow = thisThing._page > 0;
	                  if (shouldShowLeftArrow != thisThing.state.shouldShowLeftArrow) thisThing.setState({ shouldShowLeftArrow: shouldShowLeftArrow });
	                } },
	              campaigns.map(function (campaign, index) {
	                var _this3 = this;
	
	                var style = { height: 200, width: 200, flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 8 };
	                if (index == 0) {
	                  style.borderTopLeftRadius = 2;
	                  style.borderBottomLeftRadius = 2;
	                }
	                if (index == campaigns.length - 1) {
	                  style.borderTopRightRadius = 2;
	                  style.borderBottomRightRadius = 2;
	                }
	                var iconColor = thisThing.props.bannerColor;
	                var titleColor = thisThing.props.titleColor;
	                var bodyColor = thisThing.props.bodyColor;
	                style.backgroundColor = cardColor;
	                if (index % 2 == 1) {
	                  iconColor = thisThing.props.iconColor;
	                  titleColor = thisThing.props.iconColor;
	                  bodyColor = thisThing.props.iconColor;
	                  style.backgroundColor = thisThing.props.bannerColor;
	                }
	                return React.createElement(
	                  MKButton,
	                  { key: "button" + campaign.title, style: { backgroundColor: feedCardColor, borderRadius: 2 },
	                    onPress: function onPress() {
	                      return campaign.didSelect();
	                    },
	                    underlayColor: highlightColor,
	                    rippleColor: rippleColor,
	                    maskBorderRadius: 2,
	                    onLayout: function onLayout(info) {
	                      var layout = info.nativeEvent.layout;
	                      _this3.props.cardHeight(layout.height);
	                    } },
	                  React.createElement(
	                    View,
	                    { style: style },
	                    React.createElement(
	                      View,
	                      { style: { marginVertical: 0 } },
	                      typeof campaign.iconName !== 'undefined' ? React.createElement(_ReUpIcon2.default, { name: campaign.iconName, size: 60, color: iconColor }) : null,
	                      typeof campaign.iconText !== 'undefined' ? React.createElement(
	                        ReUpText,
	                        { isTitle: true, style: { fontSize: 36, iconColor: iconColor } },
	                        campaign.iconText
	                      ) : null
	                    ),
	                    React.createElement(
	                      View,
	                      { style: { marginBottom: 4 } },
	                      React.createElement(
	                        ReUpText,
	                        { isTitle: true, style: { color: titleColor } },
	                        campaign.title
	                      )
	                    ),
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { style: { color: bodyColor, textAlign: 'center' } },
	                        campaign.body
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          React.createElement(
	            View,
	            { style: [styles.bannerContainer, { marginTop: -200 }] },
	            React.createElement(
	              View,
	              { style: [styles.bannerCircle, { backgroundColor: this.props.bannerColor }] },
	              React.createElement(_ReUpIcon2.default, { name: this.props.icon, size: 18, color: this.props.iconColor, style: [styles.bannerIcon, Globals.BANNER_ICON_ADJUSTMENT] })
	            )
	          ),
	          this.state.scrollEnabled ? null : React.createElement(
	            View,
	            { style: { alignSelf: 'flex-end', marginRight: 8, flexDirection: 'row' } },
	            React.createElement(
	              View,
	              null,
	              this.state.shouldShowLeftArrow ? React.createElement(ReUpIconButton, { iconName: "angle-left", style: { pointerEvents: 'auto', opacity: this.state.shouldShowLeftArrow ? 1 : 0, paddingLeft: 2, width: 30, height: 30, marginTop: 30 }, appManager: appManager, type: 1, onPress: function onPress() {
	                  if (thisThing.refs.earnPointsScrollView && thisThing._page > 0) thisThing.refs.earnPointsScrollView.scrollTo({ x: (thisThing._page - 1) * 200 });
	                } }) : null
	            ),
	            React.createElement(View, { style: { width: 10 } }),
	            React.createElement(
	              View,
	              { style: { width: 40 } },
	              this.state.shouldShowRightArrow ? React.createElement(ReUpIconButton, { iconName: "angle-right", style: { pointerEvents: 'auto', paddingLeft: 2, width: 30, height: 30, marginTop: 30 }, appManager: appManager, type: 1, onPress: function onPress() {
	                  if (thisThing.refs.earnPointsScrollView && thisThing._page < campaigns.length - 1) thisThing.refs.earnPointsScrollView.scrollTo({ x: (thisThing._page + 1) * 200 });
	                  if (Platform.OS === 'ios') thisThing.setState({ scrollEnabled: true });
	                } }) : null
	            )
	          )
	        );
	      }
	  }
	});
	
	var styles = StyleSheet.create({
	  outerContainer: {
	    flex: -1,
	    marginTop: 4,
	    marginLeft: 4,
	    marginRight: 4,
	    alignItems: 'stretch',
	    borderRadius: 2
	  },
	  container: {
	    flex: 1,
	    flexDirection: 'row',
	    alignItems: 'stretch',
	    borderRadius: 2
	  },
	  imageContainer: {
	    flex: 1,
	    flexDirection: 'row',
	    alignItems: 'stretch',
	    height: 220,
	    borderRadius: 2
	  },
	
	  imageFooterContainer: {
	    alignSelf: 'flex-end',
	    flexDirection: 'row',
	    backgroundColor: 'rgba(255,255,255,.8)',
	    flex: 1,
	    marginLeft: -50,
	    paddingLeft: 10,
	    paddingRight: 10,
	    justifyContent: 'center',
	    alignItems: 'center'
	  },
	
	  fullWidthContainer: {
	    flex: 1,
	    padding: 10,
	    flexDirection: 'column'
	  },
	  fullWidthTitle: {
	    flex: 1
	  },
	  fullWidthBody: {
	    flex: 1
	  },
	  fullWidthContent: {
	    flex: 1,
	    flexDirection: 'column',
	    alignItems: 'stretch'
	  },
	  textField: {
	    flex: 1,
	    width: -1,
	    height: 50,
	    marginTop: 10
	  },
	  loginButton: {
	    marginTop: 20
	  },
	
	  bannerContainer: {
	    flexDirection: 'column',
	    width: 46,
	    alignItems: 'center',
	    borderRadius: 2,
	    height: 46,
	    backgroundColor: 'transparent'
	  },
	  bannerCircle: {
	    width: 30,
	    height: 30,
	    marginTop: 8,
	    borderRadius: 17,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  bannerIcon: {
	    backgroundColor: 'transparent',
	    textAlign: 'center',
	    lineHeight: 18,
	    height: 18,
	    width: 30,
	    marginTop: -2
	  },
	
	  contentContainer: {
	    flex: 1,
	    flexDirection: 'column',
	    borderRadius: 2,
	    paddingTop: 2
	  },
	  contentTitle: {
	    marginRight: 8,
	    height: 30,
	    marginTop: 6,
	    justifyContent: 'center',
	    flex: -1
	  },
	  contentTitleSmall: {
	    marginRight: 8,
	    marginBottom: 6,
	    marginTop: 14,
	    flex: -1,
	    opacity: 0.9
	  },
	  contentBody: {
	    marginRight: 8,
	    paddingBottom: 8,
	    paddingTop: 0,
	    flex: -1
	  },
	
	  floatingLabelFont: {
	    fontStyle: 'italic',
	    fontWeight: '200'
	  },
	
	  // settings styles
	
	  profileContainer: {
	    flexDirection: 'column'
	  },
	  profileTopContainer: {
	    flexDirection: 'row',
	    justifyContent: 'center',
	    alignItems: 'center'
	  },
	  profileBottomContainer: {
	    flexDirection: 'row',
	    alignItems: 'stretch',
	    justifyContent: 'center',
	    padding: 8
	  },
	  logoutButton: {
	    flex: 1
	  },
	  profileImageContainer: {
	    width: 100,
	    height: 100
	  },
	  profileInfoContainer: {
	    flex: 1,
	    justifyContent: 'center',
	    flexDirection: 'column'
	  },
	  profileImage: {
	    height: 80,
	    width: 80,
	    margin: 8,
	    borderRadius: 40,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: 40,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  rowData: {
	    flexDirection: 'row'
	  },
	  colData: {
	    flex: 1,
	    paddingBottom: 4,
	    paddingRight: 4
	  },
	  changePasswordContainer: {
	    padding: 8,
	    flexDirection: 'column'
	  },
	
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  passwordShowButton: {
	    borderRadius: 25,
	    width: 50,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    margin: 4
	  }
	});
	
	module.exports = FeedCard;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Animated = __webpack_require__(9);
	
	var BlurViewWrapper = createReactClass({
	  displayName: 'BlurViewWrapper',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      blurType: "light",
	      initialOpacity: 1,
	      imageName: "",
	      viewToBlur: 0,
	      innerView: React.createElement(View, null),
	      children: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      opacity: new Animated.Value(this.props.initialOpacity)
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  fadeOut: function fadeOut(completion) {
	    Animated.timing(this.state.opacity, { toValue: 0, duration: 200 }).start(function () {
	      completion();
	    });
	  },
	
	  setOpacity: function setOpacity(opacity) {
	    if (opacity >= 1 && this.state.opacity >= 1) return; // no change
	    if (opacity <= 0 && this.state.opacity <= 0) return; // no change
	
	    opacity = Math.min(Math.max(0, opacity), 1);
	
	    this.setState({ opacity: new Animated.Value(opacity) });
	  },
	
	  imageLoaded: function imageLoaded() {
	    this.setState({ viewRef: findNodeHandle(this.refs.backgroundImage) });
	  },
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        children = _props.children,
	        other = _objectWithoutProperties(_props, ['style', 'children']);
	
	    var addedStyle = { flex: 1 }; //{opacity : this.state.opacity};
	    var outerStyle = {};
	    if (typeof style === 'undefined') {
	      outerStyle = [addedStyle];
	      style = [addedStyle, { opacity: this.state.opacity }];
	    } else {
	      outerStyle = [style, addedStyle];
	      style = [style, addedStyle, { opacity: this.state.opacity }];
	    }
	
	    if (this.props.imageName != "") {
	      var innerStyle = { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, opacity: this.state.opacity };
	      return React.createElement(
	        View,
	        { style: StyleSheet.flatten(outerStyle) },
	        React.createElement(Image, {
	          style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
	          source: { uri: this.props.imageName } }),
	        React.createElement(
	          Animated.View,
	          { style: innerStyle },
	          React.createElement(View, { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,.2)' } }),
	          children
	        )
	      );
	    }
	
	    return React.createElement(
	      Animated.View,
	      { style: [style, { backgroundColor: 'rgba(0,0,0,.4)' }] },
	      React.createElement(View, { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,.2)' } }),
	      children
	    );
	  }
	});
	
	module.exports = { BlurView: BlurViewWrapper, VibrancyView: BlurViewWrapper };

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactDom = __webpack_require__(65);
	
	var findNodeHandle = function findNodeHandle(component) {
	  var node = void 0;
	
	  try {
	    node = (0, _reactDom.findDOMNode)(component);
	  } catch (e) {}
	
	  return node;
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = findNodeHandle;
	module.exports = exports['default'];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NativeMethodsMixin = __webpack_require__(1446);
	
	var _NativeMethodsMixin2 = _interopRequireDefault(_NativeMethodsMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyNativeMethods = function applyNativeMethods(Component) {
	  Object.keys(_NativeMethodsMixin2.default).forEach(function (method) {
	    if (!Component.prototype[method]) {
	      Component.prototype[method] = _NativeMethodsMixin2.default[method];
	    }
	  });
	  return Component;
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = applyNativeMethods;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View;
	exports.default = createReactClass({
	  displayName: 'react-native-svg-wrapper',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement('svg', this.props);
	  }
	});
	
	
	var G = createReactClass({
	  displayName: 'G',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      scale: 1
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(
	      'g',
	      { transform: "scale(" + this.props.scale + ")" },
	      this.props.children
	    );
	  }
	});
	
	var Path = createReactClass({
	  displayName: 'Path',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      d: "",
	      stroke: 'black',
	      strokeWidth: 2,
	      strokeLinecap: 'round',
	      fill: 'none'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement('path', this.props);
	  }
	});
	
	exports.Path = Path;
	exports.G = G;
	exports.Circle = View;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var CallbackQueue = __webpack_require__(1001);
	var PooledClass = __webpack_require__(67);
	var ReactFeatureFlags = __webpack_require__(1006);
	var ReactReconciler = __webpack_require__(87);
	var Transaction = __webpack_require__(120);
	
	var invariant = __webpack_require__(7);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setValueForStyles = __webpack_require__(1455);
	
	var _setValueForStyles2 = _interopRequireDefault(_setValueForStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getRect = function getRect(node) {
	  var height = node.offsetHeight;
	  var width = node.offsetWidth;
	  var left = node.offsetLeft;
	  var top = node.offsetTop;
	  node = node.offsetParent;
	
	  while (node && node.nodeType === 1 /* Node.ELEMENT_NODE */) {
	    left += node.offsetLeft - node.scrollLeft;
	    top += node.offsetTop - node.scrollTop;
	    node = node.offsetParent;
	  }
	  return { height: height, left: left, top: top, width: width };
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var _measureLayout = function _measureLayout(node, relativeToNativeNode, callback) {
	  var relativeNode = relativeToNativeNode || node && node.parentNode;
	  if (node && relativeNode) {
	    setTimeout(function () {
	      var relativeRect = getRect(relativeNode);
	
	      var _getRect = getRect(node),
	          height = _getRect.height,
	          left = _getRect.left,
	          top = _getRect.top,
	          width = _getRect.width;
	
	      var x = left - relativeRect.left;
	      var y = top - relativeRect.top;
	      callback(x, y, width, height, left, top);
	    }, 0);
	  }
	};
	
	var UIManager = {
	  blur: function blur(node) {
	    try {
	      node.blur();
	    } catch (err) {}
	  },
	  focus: function focus(node) {
	    try {
	      node.focus();
	    } catch (err) {}
	  },
	  measure: function measure(node, callback) {
	    _measureLayout(node, null, callback);
	  },
	  measureInWindow: function measureInWindow(node, callback) {
	    if (node) {
	      setTimeout(function () {
	        var _getRect2 = getRect(node),
	            height = _getRect2.height,
	            left = _getRect2.left,
	            top = _getRect2.top,
	            width = _getRect2.width;
	
	        callback(left, top, width, height);
	      }, 0);
	    }
	  },
	  measureLayout: function measureLayout(node, relativeToNativeNode, onFail, onSuccess) {
	    _measureLayout(node, relativeToNativeNode, onSuccess);
	  },
	  updateView: function updateView(node, props, component /* only needed to surpress React errors in development */) {
	    for (var prop in props) {
	      if (!Object.prototype.hasOwnProperty.call(props, prop)) {
	        continue;
	      }
	
	      var value = props[prop];
	      switch (prop) {
	        case 'style':
	          {
	            (0, _setValueForStyles2.default)(node, value, component._reactInternalInstance);
	            break;
	          }
	        case 'class':
	        case 'className':
	          {
	            node.setAttribute('class', value);
	            break;
	          }
	        case 'text':
	        case 'value':
	          // native platforms use `text` prop to replace text input value
	          node.value = value;
	          break;
	        default:
	          node.setAttribute(prop, value);
	      }
	    }
	  },
	  configureNextLayoutAnimation: function configureNextLayoutAnimation(config, onAnimationDidEnd) {
	    onAnimationDidEnd();
	  },
	
	
	  // mocks
	  setLayoutAnimationEnabledExperimental: function setLayoutAnimationEnabledExperimental() {}
	};
	
	exports.default = UIManager;
	module.exports = exports['default'];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedNode2 = __webpack_require__(39);
	
	var _AnimatedNode3 = _interopRequireDefault(_AnimatedNode2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedWithChildren = function (_AnimatedNode) {
	  _inherits(AnimatedWithChildren, _AnimatedNode);
	
	  function AnimatedWithChildren() {
	    _classCallCheck(this, AnimatedWithChildren);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._children = [];
	    return _this;
	  }
	
	  AnimatedWithChildren.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var _iterator = this._children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var child = _ref;
	
	        child.__makeNative();
	        _NativeAnimatedHelper2.default.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	      }
	    }
	  };
	
	  AnimatedWithChildren.prototype.__addChild = function __addChild(child) {
	    if (this._children.length === 0) {
	      this.__attach();
	    }
	    this._children.push(child);
	    if (this.__isNative) {
	      // Only accept "native" animated nodes as children
	      child.__makeNative();
	      _NativeAnimatedHelper2.default.API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	  };
	
	  AnimatedWithChildren.prototype.__removeChild = function __removeChild(child) {
	    var index = this._children.indexOf(child);
	    if (index === -1) {
	      console.warn("Trying to remove a child that doesn't exist");
	      return;
	    }
	    if (this.__isNative && child.__isNative) {
	      _NativeAnimatedHelper2.default.API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
	    }
	    this._children.splice(index, 1);
	    if (this._children.length === 0) {
	      this.__detach();
	    }
	  };
	
	  AnimatedWithChildren.prototype.__getChildren = function __getChildren() {
	    return this._children;
	  };
	
	  return AnimatedWithChildren;
	}(_AnimatedNode3.default);
	
	exports.default = AnimatedWithChildren;
	module.exports = exports['default'];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(4),
	    Platform = _require.Platform;
	
	var Fabric = __webpack_require__(1167);
	var Answers = Fabric.Answers,
	    Crashlytics = Fabric.Crashlytics;
	
	
	var AnalyticsManager = {
	  initialize: function initialize(appManager) {
	    var thisThing = this;
	    this.getDateForKey('FirstLaunch', appManager, function (date) {
	      if (date == null) {
	        thisThing.setDateForKey('FirstLaunch', appManager, function () {});
	      }
	    });
	    // FOR FUTURE CASES
	    // thisThing.setDateForKey('currentLaunch', appManager, function(){})
	  },
	
	  _datePrefix: 'analyticsTimeFor',
	
	  getDateForKey: function getDateForKey(key, appManager, completion) {
	    appManager.getVariable(this._datePrefix + key, completion);
	  },
	
	  setDateForKey: function setDateForKey(key, appManager, completion) {
	    var date = Math.round(new Date().getTime() / 1000);
	    appManager.setVariable(this._datePrefix + key, date, function () {
	      completion(date);
	    });
	
	    return date;
	  },
	
	  logFeature: function logFeature(title, name) {
	    if (title.indexOf("Astart") == 0) title = "Feed"; // hack for feed title
	    Answers.logContentView(title, 'feature', name);
	  },
	
	  logSignUpEvent: function logSignUpEvent(appManager, method, boolean, additionalParams) {
	    var thisThing = this;
	    var keyString = 'CreateUser' + (boolean ? 'True' : 'False');
	    this.setDateForKey(keyString, appManager, function () {
	      thisThing.getDateForKey(keyString, appManager, function (date) {
	        var createUserDate = date;
	        thisThing.getDateForKey('FirstLaunch', appManager, function (date) {
	          var timeSinceFirstLaunch = createUserDate - date;
	          var params = { 'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch) };
	          if (typeof additionalParams !== 'undefined') for (var key in additionalParams) {
	            params[key] = additionalParams[key];
	          }Answers.logSignUp(method, boolean, params);
	        });
	      });
	    });
	  },
	
	  logLoginEvent: function logLoginEvent(appManager, type, boolean) {
	    var thisThing = this;
	    var keyString = 'Login' + (boolean ? 'True' : 'False');
	    this.setDateForKey(keyString, appManager, function (loginDate) {
	      thisThing.getDateForKey('FirstLaunch', appManager, function (date) {
	        // console.log('LogLogin', 'FirstLaunch', date);
	        var timeSinceFirstLaunch = loginDate - date;
	        thisThing.getDateForKey('CreateUserTrue', appManager, function (date) {
	          // console.log('CreateUserTrue', date);
	          var timeSinceCreateUser = loginDate - date;
	          Answers.logLogin(type.toUpperCase(), boolean, {
	            'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch),
	            'Since Sign Up Interval': thisThing.customAttributeKeyForTime(timeSinceCreateUser)
	          });
	        });
	      });
	    });
	  },
	
	  logCustomEvent: function logCustomEvent(type, attributes) {
	    Answers.logCustom(type, attributes);
	  },
	
	  customAttributeKeyForTime: function customAttributeKeyForTime(timeSeconds) {
	    var maxTime = 5 * 60; // 5 minutes
	    if (timeSeconds >= maxTime) return 'Greater than 5 minutes';
	
	    var increments = 20;
	    var i = 0;
	    for (i = 0; i * increments <= timeSeconds; i++) {}
	
	    var startSeconds = (i - 1) * increments;
	    var endSeconds = i * increments;
	
	    return 'Between ' + startSeconds + ' and ' + endSeconds + ' seconds';
	  },
	
	  logPurchaseEvent: function logPurchaseEvent(appManager, itemPrice, boolean) {
	    var thisThing = this;
	    var keyString = 'FirstAddCredit' + (boolean ? 'True' : 'False');
	    this.getDateForKey(keyString, appManager, function (date) {
	      if (date == null) {
	        var addCreditDate = thisThing.setDateForKey(keyString, appManager, function () {});
	
	        thisThing.getDateForKey('FirstLaunch', appManager, function (date) {
	          var timeSinceFirstLaunch = addCreditDate - date;
	          thisThing.getDateForKey('LoginTrue', appManager, function (date) {
	            var timeSinceLogin = addCreditDate - date;
	            Answers.logPurchase(itemPrice, 'CAD', boolean, 'FirstAddCredit', 'FirstAddCredit', '', {
	              'Since Launch Interval': thisThing.customAttributeKeyForTime(timeSinceFirstLaunch),
	              'Since First Login Interval': thisThing.customAttributeKeyForTime(timeSinceLogin)
	            });
	          });
	        });
	      } else {
	        Answers.logPurchase(itemPrice, 'CAD', boolean, 'AddCredit', 'AddCredit', '', {});
	      }
	    });
	  },
	
	  logException: function logException(text) {
	    try {
	      console.log(text);
	      if (Platform.OS === 'ios') Crashlytics.recordError(text);else if (Platform.OS === 'android') Crashlytics.logException(text);
	    } catch (e) {
	      console.log("loggexception", e);
	    } finally {}
	  }
	};
	
	module.exports = AnalyticsManager;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var View = ReactNative.View,
	    Easing = ReactNative.Easing;
	
	
	var FadingView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      children: [React.createElement(View, null)],
	      initialOpacity: 0,
	      animDuration: 0
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    if (this.props.initialOpacity == 0) this._fadedOut = true;
	    return {
	      opacity: new Animated.Value(this.props.initialOpacity)
	    };
	  },
	
	  _fadedOut: false,
	  setFadedOut: function setFadedOut(fadedOut) {
	    if (fadedOut == this._fadedOut) return;
	    this._fadedOut = fadedOut;
	    var thisThing = this;
	    if (this._fadedOut) {
	      Animated.timing(thisThing.state.opacity, { toValue: 0,
	        duration: thisThing.props.animDuration,
	        easing: Easing.out(Easing.ease) }).start();
	    } else {
	      Animated.timing(thisThing.state.opacity, { toValue: 1,
	        duration: thisThing.props.animDuration,
	        easing: Easing.out(Easing.ease) }).start();
	    }
	  },
	
	  setOpacity: function setOpacity(opacity) {
	    this.setState({
	      opacity: new Animated.Value(opacity)
	    });
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        children = _props.children,
	        other = _objectWithoutProperties(_props, ['style', 'children']);
	
	    var style = [style, { opacity: this.state.opacity }];
	
	    return React.createElement(
	      Animated.View,
	      Object.assign({ style: style }, other),
	      children
	    );
	  }
	});
	
	module.exports = FadingView;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	// var Overlay = require('./wrappers/react-native-overlay-wrapper.android.js');
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var ReUpText = __webpack_require__(8);
	var Overlay = __webpack_require__(112);
	var Keyboard = __webpack_require__(76);
	var Animated = __webpack_require__(9);
	var ProgressOverlay = __webpack_require__(52);
	
	var MK = __webpack_require__(14);
	var MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ProgressOverlay = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      title: "",
	      color: "#000",
	      isVisible: false,
	      spinnerText: "",
	      spinnerBody: "",
	      initialOpacity: 0,
	      appManager: {},
	      layout: { x: 0, y: 0, width: 100, height: 100 }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      opacity: new Animated.Value(this.props.initialOpacity),
	      isVisible: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  _didFadeIn: false,
	  setDidFadeIn: function setDidFadeIn(didFadeIn) {
	    if (didFadeIn != this._didFadeIn) {
	      if (didFadeIn) this.fadeIn();else this.fadeOut();
	
	      this._didFadeIn = didFadeIn;
	    }
	  },
	
	  fadeIn: function fadeIn() {
	    var thisThing = this;
	    thisThing.setState({ isVisible: true });
	    Animated.timing(this.state.opacity, { toValue: 1, duration: 100 }).start(function () {});
	  },
	
	  fadeOut: function fadeOut() {
	    var thisThing = this;
	    Animated.timing(this.state.opacity, { toValue: 0,
	      duration: 100 }).start(function () {
	      thisThing.setState({ isVisible: false });
	    });
	  },
	
	  render: function render() {
	    this.setDidFadeIn(this.props.isVisible);
	    //Keyboard.dismiss();
	    if (!this.state.isVisible) return null;
	
	    var appManager = this.props.appManager;
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	
	    if (this.props.spinnerText.length <= 0) {
	      return React.createElement(
	        Animated.View,
	        { style: [{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }, { opacity: this.state.opacity }] },
	        React.createElement(
	          BlurView,
	          { blurType: 'dark', style: [styles.blurStyle, { width: this.props.layout.width }] },
	          React.createElement(
	            Overlay,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(MKSpinner, { style: styles.progress, strokeColor: [buttonColor, buttonTitleColor] }),
	            this.props.children
	          )
	        )
	      );
	    } else {
	      return React.createElement(
	        Animated.View,
	        { style: [{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }, { opacity: this.state.opacity }] },
	        React.createElement(
	          BlurView,
	          { blurType: 'dark', style: { top: 0, left: 0, right: 0, bottom: 0 } },
	          React.createElement(
	            Overlay,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(
	              View,
	              { style: styles.progressMessageContainer },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: styles.progressMessage },
	                this.props.spinnerText
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: false, style: styles.progressMessage },
	                this.props.spinnerBody
	              ),
	              React.createElement(MKSpinner, { style: styles.progress, strokeColor: [buttonColor, buttonTitleColor] }),
	              this.props.children
	            )
	          )
	        )
	      );
	    }
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    justifyContent: 'center',
	    flexDirection: 'row',
	    alignItems: 'stretch'
	  },
	  blurStyle: {
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'stretch'
	  },
	  progressMessageContainer: {
	    margin: 20,
	    backgroundColor: 'white',
	    borderRadius: 4,
	    padding: 8,
	    borderWidth: 1,
	    borderColor: '#DADADA'
	  },
	  progress: {
	    alignSelf: 'center',
	    backgroundColor: 'transparent'
	  },
	  progressMessage: {
	    paddingBottom: 8,
	    textAlign: 'center'
	  }
	});
	
	module.exports = ProgressOverlay;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Icon = function Icon(props) {
	  var classes = {
	    'material-icons': true
	  };
	  _constants2.default.PLACEMENTS.forEach(function (p) {
	    classes[p] = props[p];
	  });
	
	  _constants2.default.ICON_SIZES.forEach(function (s) {
	    classes[s] = props[s];
	  });
	
	  return _react2.default.createElement(
	    'i',
	    { className: (0, _classnames2.default)(classes, props.className) },
	    props.children
	  );
	};
	
	Icon.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	_constants2.default.PLACEMENTS.forEach(function (p) {
	  Icon.propTypes[p] = _propTypes2.default.bool;
	});
	
	_constants2.default.ICON_SIZES.forEach(function (s) {
	  Icon.propTypes[s] = _propTypes2.default.bool;
	});
	
	exports.default = Icon;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var PooledClass = __webpack_require__(67);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(19);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 55 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(821);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _createDOMProps = __webpack_require__(1053);
	
	var _createDOMProps2 = _interopRequireDefault(_createDOMProps);
	
	var _unstableNativeDependencies = __webpack_require__(993);
	
	var _normalizeNativeEvent = __webpack_require__(1057);
	
	var _normalizeNativeEvent2 = _interopRequireDefault(_normalizeNativeEvent);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ResponderEventPlugin = __webpack_require__(1447);
	
	var _ResponderEventPlugin2 = _interopRequireDefault(_ResponderEventPlugin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	(0, _unstableNativeDependencies.injectEventPluginsByName)({
	  ResponderEventPlugin: _ResponderEventPlugin2.default
	});
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * Ensure event handlers receive an event of the expected shape. The 'button'
	 * role – for accessibility reasons and functional equivalence to the native
	 * button element – must also support synthetic keyboard activation of onclick,
	 * and remove event handlers when disabled.
	 */
	var eventHandlerNames = {
	  onBlur: true,
	  onClick: true,
	  onClickCapture: true,
	  onContextMenu: true,
	  onFocus: true,
	  onResponderRelease: true,
	  onTouchCancel: true,
	  onTouchCancelCapture: true,
	  onTouchEnd: true,
	  onTouchEndCapture: true,
	  onTouchMove: true,
	  onTouchMoveCapture: true,
	  onTouchStart: true,
	  onTouchStartCapture: true
	};
	var adjustProps = function adjustProps(domProps) {
	  var onClick = domProps.onClick,
	      onResponderRelease = domProps.onResponderRelease,
	      role = domProps.role;
	
	
	  var isButtonLikeRole = _AccessibilityUtil2.default.buttonLikeRoles[role];
	  var isDisabled = _AccessibilityUtil2.default.isDisabled(domProps);
	  var isLinkRole = role === 'link';
	
	  Object.keys(domProps).forEach(function (propName) {
	    var prop = domProps[propName];
	    var isEventHandler = typeof prop === 'function' && eventHandlerNames[propName];
	    if (isEventHandler) {
	      if (isButtonLikeRole && isDisabled) {
	        domProps[propName] = undefined;
	      } else {
	        // TODO: move this out of the render path
	        domProps[propName] = function (e) {
	          e.nativeEvent = (0, _normalizeNativeEvent2.default)(e.nativeEvent);
	          return prop(e);
	        };
	      }
	    }
	  });
	
	  // Cancel click events if the responder system is being used on a link
	  // element. Click events are not an expected part of the React Native API,
	  // and browsers dispatch click events that cannot otherwise be cancelled from
	  // preceding mouse events in the responder system.
	  if (isLinkRole && onResponderRelease) {
	    domProps.onClick = function (e) {
	      if (!e.isDefaultPrevented() && !isModifiedEvent(e.nativeEvent) && !domProps.target) {
	        e.preventDefault();
	      }
	    };
	  }
	
	  // Button-like roles should trigger 'onClick' if SPACE or ENTER keys are pressed.
	  if (isButtonLikeRole && !isDisabled) {
	    domProps.onKeyPress = function (e) {
	      if (!e.isDefaultPrevented() && (e.which === 13 || e.which === 32)) {
	        e.preventDefault();
	        if (onClick) {
	          onClick(e);
	        }
	      }
	    };
	  }
	};
	
	var createElement = function createElement(component, props) {
	  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    children[_key - 2] = arguments[_key];
	  }
	
	  // use equivalent platform elements where possible
	  var accessibilityComponent = void 0;
	  if (component && component.constructor === String) {
	    accessibilityComponent = _AccessibilityUtil2.default.propsToAccessibilityComponent(props);
	  }
	  var Component = accessibilityComponent || component;
	  var domProps = (0, _createDOMProps2.default)(Component, props);
	  adjustProps(domProps);
	  return _react2.default.createElement.apply(_react2.default, [Component, domProps].concat(children));
	};
	
	exports.default = createElement;
	module.exports = exports['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	var _InteractionManager = __webpack_require__(126);
	
	var _InteractionManager2 = _interopRequireDefault(_InteractionManager);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NativeAnimatedAPI = _NativeAnimatedHelper2.default.API;
	
	var _uniqueId = 1;
	
	/**
	 * Animated works by building a directed acyclic graph of dependencies
	 * transparently when you render your Animated components.
	 *
	 *               new Animated.Value(0)
	 *     .interpolate()        .interpolate()    new Animated.Value(1)
	 *         opacity               translateY      scale
	 *          style                         transform
	 *         View#234                         style
	 *                                         View#123
	 *
	 * A) Top Down phase
	 * When an Animated.Value is updated, we recursively go down through this
	 * graph in order to find leaf nodes: the views that we flag as needing
	 * an update.
	 *
	 * B) Bottom Up phase
	 * When a view is flagged as needing an update, we recursively go back up
	 * in order to build the new value that it needs. The reason why we need
	 * this two-phases process is to deal with composite props such as
	 * transform which can receive values from multiple parents.
	 */
	function _flush(rootNode) {
	  var animatedStyles = new Set();
	  function findAnimatedStyles(node) {
	    if (typeof node.update === 'function') {
	      animatedStyles.add(node);
	    } else {
	      node.__getChildren().forEach(findAnimatedStyles);
	    }
	  }
	  findAnimatedStyles(rootNode);
	  /* $FlowFixMe */
	  animatedStyles.forEach(function (animatedStyle) {
	    return animatedStyle.update();
	  });
	}
	
	/**
	 * Standard value for driving animations.  One `Animated.Value` can drive
	 * multiple properties in a synchronized fashion, but can only be driven by one
	 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
	 * or calling `setValue`) will stop any previous ones.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvalue.html
	 */
	
	var AnimatedValue = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValue, _AnimatedWithChildren);
	
	  function AnimatedValue(value) {
	    _classCallCheck(this, AnimatedValue);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._startingValue = _this._value = value;
	    _this._offset = 0;
	    _this._animation = null;
	    _this._listeners = {};
	    return _this;
	  }
	
	  AnimatedValue.prototype.__detach = function __detach() {
	    this.stopAnimation();
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedValue.prototype.__getValue = function __getValue() {
	    return this._value + this._offset;
	  };
	
	  AnimatedValue.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	
	    if (Object.keys(this._listeners).length) {
	      this._startListeningToNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Directly set the value.  This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setvalue
	   */
	
	
	  AnimatedValue.prototype.setValue = function setValue(value) {
	    if (this._animation) {
	      this._animation.stop();
	      this._animation = null;
	    }
	    this._updateValue(value, !this.__isNative /* don't perform a flush for natively driven values */
	    );
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
	    }
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether via
	   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setoffset
	   */
	
	
	  AnimatedValue.prototype.setOffset = function setOffset(offset) {
	    this._offset = offset;
	    if (this.__isNative) {
	      NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
	    }
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#flattenoffset
	   */
	
	
	  AnimatedValue.prototype.flattenOffset = function flattenOffset() {
	    this._value += this._offset;
	    this._offset = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#extractoffset
	   */
	
	
	  AnimatedValue.prototype.extractOffset = function extractOffset() {
	    this._offset += this._value;
	    this._value = 0;
	    if (this.__isNative) {
	      NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
	    }
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to
	   * synchronously read the value because it might be driven natively.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#addlistener
	   */
	
	
	  AnimatedValue.prototype.addListener = function addListener(callback) {
	    var id = String(_uniqueId++);
	    this._listeners[id] = callback;
	    if (this.__isNative) {
	      this._startListeningToNativeValueUpdates();
	    }
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removelistener
	   */
	
	
	  AnimatedValue.prototype.removeListener = function removeListener(id) {
	    delete this._listeners[id];
	    if (this.__isNative && Object.keys(this._listeners).length === 0) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removealllisteners
	   */
	
	
	  AnimatedValue.prototype.removeAllListeners = function removeAllListeners() {
	    this._listeners = {};
	    if (this.__isNative) {
	      this._stopListeningForNativeValueUpdates();
	    }
	  };
	
	  AnimatedValue.prototype._startListeningToNativeValueUpdates = function _startListeningToNativeValueUpdates() {
	    var _this2 = this;
	
	    if (this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
	    this.__nativeAnimatedValueListener = _NativeAnimatedHelper2.default.nativeEventEmitter.addListener('onAnimatedValueUpdate', function (data) {
	      if (data.tag !== _this2.__getNativeTag()) {
	        return;
	      }
	      _this2._updateValue(data.value, false /* flush */);
	    });
	  };
	
	  AnimatedValue.prototype._stopListeningForNativeValueUpdates = function _stopListeningForNativeValueUpdates() {
	    if (!this.__nativeAnimatedValueListener) {
	      return;
	    }
	
	    this.__nativeAnimatedValueListener.remove();
	    this.__nativeAnimatedValueListener = null;
	    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#stopanimation
	   */
	
	
	  AnimatedValue.prototype.stopAnimation = function stopAnimation(callback) {
	    this.stopTracking();
	    this._animation && this._animation.stop();
	    this._animation = null;
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#resetanimation
	   */
	
	
	  AnimatedValue.prototype.resetAnimation = function resetAnimation(callback) {
	    this.stopAnimation(callback);
	    this._value = this._startingValue;
	  };
	
	  /**
	   * Interpolates the value before updating the property, e.g. mapping 0-1 to
	   * 0-10.
	   */
	
	
	  AnimatedValue.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  /**
	   * Typically only used internally, but could be used by a custom Animation
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvalue.html#animate
	   */
	
	
	  AnimatedValue.prototype.animate = function animate(animation, callback) {
	    var _this3 = this;
	
	    var handle = null;
	    if (animation.__isInteraction) {
	      handle = _InteractionManager2.default.createInteractionHandle();
	    }
	    var previousAnimation = this._animation;
	    this._animation && this._animation.stop();
	    this._animation = animation;
	    animation.start(this._value, function (value) {
	      // Natively driven animations will never call into that callback, therefore we can always
	      // pass flush = true to allow the updated value to propagate to native with setNativeProps
	      _this3._updateValue(value, true /* flush */);
	    }, function (result) {
	      _this3._animation = null;
	      if (handle !== null) {
	        _InteractionManager2.default.clearInteractionHandle(handle);
	      }
	      callback && callback(result);
	    }, previousAnimation, this);
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	
	  AnimatedValue.prototype.stopTracking = function stopTracking() {
	    this._tracking && this._tracking.__detach();
	    this._tracking = null;
	  };
	
	  /**
	   * Typically only used internally.
	   */
	
	
	  AnimatedValue.prototype.track = function track(tracking) {
	    this.stopTracking();
	    this._tracking = tracking;
	  };
	
	  AnimatedValue.prototype._updateValue = function _updateValue(value, flush) {
	    this._value = value;
	    if (flush) {
	      _flush(this);
	    }
	    for (var _key in this._listeners) {
	      this._listeners[_key]({ value: this.__getValue() });
	    }
	  };
	
	  AnimatedValue.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'value',
	      value: this._value,
	      offset: this._offset
	    };
	  };
	
	  return AnimatedValue;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedValue;
	module.exports = exports['default'];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
	  var angleInRadians = angleInDegrees * Math.PI / 180.0;
	  var x = centerX + radius * Math.cos(angleInRadians);
	  var y = centerY + radius * Math.sin(angleInRadians);
	  return [x, y];
	}
	
	function svgArc(startAngle, endAngle, percentage, dimension) {
	  var anglesStartedEqual = startAngle == endAngle;
	
	  while (startAngle < 0) {
	    startAngle += 360;
	  }while (endAngle < 0 || endAngle < startAngle) {
	    endAngle += 360;
	  }if (percentage == 1 && startAngle == endAngle) endAngle += 359;
	
	  var portionAngle = (endAngle - startAngle) * percentage;
	  var stopAngle = startAngle + portionAngle;
	
	  var center = dimension / 2;
	  var dist = 4 * dimension / 10;
	
	  var _polarToCartesian = polarToCartesian(center, center, dist, startAngle % 360),
	      _polarToCartesian2 = _slicedToArray(_polarToCartesian, 2),
	      sx = _polarToCartesian2[0],
	      sy = _polarToCartesian2[1];
	
	  var _polarToCartesian3 = polarToCartesian(center, center, dist, stopAngle),
	      _polarToCartesian4 = _slicedToArray(_polarToCartesian3, 2),
	      ex = _polarToCartesian4[0],
	      ey = _polarToCartesian4[1];
	
	  var flag = (stopAngle - startAngle) % 360 < 180 ? "0" : "1";
	
	  return "M " + ex + " " + ey + " A " + dist + " " + dist + " 0 " + flag + " 0 " + sx + " " + sy;
	}
	
	var ArcMeter = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      appManager: null,
	      dimension: 100,
	      thickness: 10,
	      startAngle: 90,
	      endAngle: 90,
	      percentage: 0.5,
	      children: React.createElement(View, null),
	      fgColor: 'red',
	      bgColor: 'blue',
	      animated: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      rewards: [],
	      angle: 10,
	      percentage: new Animated.Value(0),
	      percentageVal: 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.state.percentage.addListener(function (_ref) {
	      var value = _ref.value;
	
	      thisThing.setState({ percentageVal: value });
	    });
	
	    setTimeout(function () {
	      thisThing._hasDoneFirstSet = true;
	      thisThing.setPercentage(thisThing.props.percentage);
	    }, 500);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.percentage !== 'undefined') this.setPercentage(newProps.percentage);
	  },
	
	  _hasDoneFirstSet: false,
	  setPercentage: function setPercentage(newPercentage) {
	    if (!this._hasDoneFirstSet) return;
	
	    Animated.spring(this.state.percentage, {
	      toValue: newPercentage,
	      tension: 8,
	      friction: 9
	    }).start();
	  },
	
	  render: function render() {
	    var outerSVG = svgArc(this.props.startAngle, this.props.endAngle, 1, this.props.dimension);
	    var innerSVG = svgArc(this.props.startAngle + 1, this.props.endAngle - 1, this.state.percentageVal, this.props.dimension);
	
	    return React.createElement(
	      View,
	      { pointerEvents: "none", style: [{ width: this.props.dimension, height: this.props.dimension }, this.props.style] },
	      React.createElement(
	        _reactNativeSvgWrapper2.default,
	        {
	          height: this.props.dimension,
	          width: this.props.dimension
	        },
	        this.state.percentageVal <= 0 ? React.createElement(
	          _reactNativeSvgWrapper.G,
	          { scale: '1' },
	          React.createElement(_reactNativeSvgWrapper.Path, {
	            d: outerSVG,
	            stroke: this.props.bgColor,
	            strokeWidth: this.props.thickness,
	            strokeLinecap: "round",
	            fill: 'none'
	          })
	        ) : React.createElement(
	          _reactNativeSvgWrapper.G,
	          { scale: '1' },
	          React.createElement(_reactNativeSvgWrapper.Path, {
	            d: outerSVG,
	            stroke: this.props.bgColor,
	            strokeWidth: this.props.thickness,
	            strokeLinecap: "round",
	            fill: 'none'
	          }),
	          React.createElement(_reactNativeSvgWrapper.Path, {
	            d: innerSVG,
	            stroke: this.props.fgColor,
	            strokeWidth: this.props.thickness - 2,
	            strokeLinecap: "round",
	            fill: 'none'
	          })
	        )
	      ),
	      React.createElement(
	        View,
	        { style: { width: this.props.dimension, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: this.props.dimension, position: 'absolute', top: 0, left: 0 } },
	        this.props.children
	      )
	    );
	  }
	});
	
	module.exports = ArcMeter;

/***/ },
/* 59 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 60 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var assign, isArray, isEmpty, isFunction, isObject, isPlainObject,
	    slice = [].slice,
	    hasProp = {}.hasOwnProperty;
	
	  assign = function() {
	    var i, key, len, source, sources, target;
	    target = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    if (isFunction(Object.assign)) {
	      Object.assign.apply(null, arguments);
	    } else {
	      for (i = 0, len = sources.length; i < len; i++) {
	        source = sources[i];
	        if (source != null) {
	          for (key in source) {
	            if (!hasProp.call(source, key)) continue;
	            target[key] = source[key];
	          }
	        }
	      }
	    }
	    return target;
	  };
	
	  isFunction = function(val) {
	    return !!val && Object.prototype.toString.call(val) === '[object Function]';
	  };
	
	  isObject = function(val) {
	    var ref;
	    return !!val && ((ref = typeof val) === 'function' || ref === 'object');
	  };
	
	  isArray = function(val) {
	    if (isFunction(Array.isArray)) {
	      return Array.isArray(val);
	    } else {
	      return Object.prototype.toString.call(val) === '[object Array]';
	    }
	  };
	
	  isEmpty = function(val) {
	    var key;
	    if (isArray(val)) {
	      return !val.length;
	    } else {
	      for (key in val) {
	        if (!hasProp.call(val, key)) continue;
	        return false;
	      }
	      return true;
	    }
	  };
	
	  isPlainObject = function(val) {
	    var ctor, proto;
	    return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && (typeof ctor === 'function') && (ctor instanceof ctor) && (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
	  };
	
	  module.exports.assign = assign;
	
	  module.exports.isFunction = isFunction;
	
	  module.exports.isObject = isObject;
	
	  module.exports.isArray = isArray;
	
	  module.exports.isEmpty = isEmpty;
	
	  module.exports.isPlainObject = isPlainObject;
	
	}).call(this);


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	
	function Transform(xx, yx, xy, yy, x, y){
		if (xx && typeof xx == 'object'){
			yx = xx.yx; yy = xx.yy; y = xx.y;
			xy = xx.xy; x = xx.x; xx = xx.xx;
		}
		this.xx = xx == null ? 1 : xx;
		this.yx = yx || 0;
		this.xy = xy || 0;
		this.yy = yy == null ? 1 : yy;
		this.x = (x == null ? this.x : x) || 0;
		this.y = (y == null ? this.y : y) || 0;
		this._transform();
		return this;
	};
	
	module.exports = Class({
	
		initialize: Transform,
	
		_transform: function(){},
	
		xx: 1, yx: 0, x: 0,
		xy: 0, yy: 1, y: 0,
	
		transform: function(xx, yx, xy, yy, x, y){
			var m = this;
			if (xx && typeof xx == 'object'){
				yx = xx.yx; yy = xx.yy; y = xx.y;
				xy = xx.xy; x = xx.x; xx = xx.xx;
			}
			if (!x) x = 0;
			if (!y) y = 0;
			return this.transformTo(
				m.xx * xx + m.xy * yx,
				m.yx * xx + m.yy * yx,
				m.xx * xy + m.xy * yy,
				m.yx * xy + m.yy * yy,
				m.xx * x + m.xy * y + m.x,
				m.yx * x + m.yy * y + m.y
			);
		},
	
		transformTo: Transform,
	
		translate: function(x, y){
			return this.transform(1, 0, 0, 1, x, y);
		},
	
		move: function(x, y){
			this.x += x || 0;
			this.y += y || 0;
			this._transform();
			return this;
		},
	
		scale: function(x, y){
			if (y == null) y = x;
			return this.transform(x, 0, 0, y, 0, 0);
		},
	
		rotate: function(deg, x, y){
			if (x == null || y == null){
				x = (this.left || 0) + (this.width || 0) / 2;
				y = (this.top || 0) + (this.height || 0) / 2;
			}
	
			var rad = deg * Math.PI / 180, sin = Math.sin(rad), cos = Math.cos(rad);
	
			this.transform(1, 0, 0, 1, x, y);
			var m = this;
	
			return this.transformTo(
				cos * m.xx - sin * m.yx,
				sin * m.xx + cos * m.yx,
				cos * m.xy - sin * m.yy,
				sin * m.xy + cos * m.yy,
				m.x,
				m.y
			).transform(1, 0, 0, 1, -x, -y);
		},
	
		moveTo: function(x, y){
			var m = this;
			return this.transformTo(m.xx, m.yx, m.xy, m.yy, x, y);
		},
	
		rotateTo: function(deg, x, y){
			var m = this;
			var flip = m.yx / m.xx > m.yy / m.xy ? -1 : 1;
			if (m.xx < 0 ? m.xy >= 0 : m.xy < 0) flip = -flip;
			return this.rotate(deg - Math.atan2(flip * m.yx, flip * m.xx) * 180 / Math.PI, x, y);
		},
	
		scaleTo: function(x, y){
			// Normalize
			var m = this;
	
			var h = Math.sqrt(m.xx * m.xx + m.yx * m.yx);
			m.xx /= h; m.yx /= h;
	
			h = Math.sqrt(m.yy * m.yy + m.xy * m.xy);
			m.yy /= h; m.xy /= h;
	
			return this.scale(x, y);
		},
	
		resizeTo: function(width, height){
			var w = this.width, h = this.height;
			if (!w || !h) return this;
			return this.scaleTo(width / w, height / h);
		},
	
		/*
		inverse: function(){
			var a = this.xx, b = this.yx,
				c = this.xy, d = this.yy,
				e = this.x, f = this.y;
			if (a * d - b * c == 0) return null;
			return new Transform(
				d/(a * d-b * c), b/(b * c-a * d),
				c/(b * c-a * d), a/(a * d-b * c),
				(d * e-c * f)/(b * c-a * d), (b * e-a * f)/(a * d-b * c)
			);
		},
		*/
	
		inversePoint: function(x, y){
			var a = this.xx, b = this.yx,
				c = this.xy, d = this.yy,
				e = this.x, f = this.y;
			var det = b * c - a * d;
			if (det == 0) return null;
			return {
				x: (d * (e - x) + c * (y - f)) / det,
				y: (a * (f - y) + b * (x - e)) / det
			};
		},
	
		point: function(x, y){
			var m = this;
			return {
				x: m.xx * x + m.xy * y + m.x,
				y: m.yx * x + m.yy * y + m.y
			};
		}	
	
	});


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableOpacity = ReactNative.TouchableOpacity;
	
	
	var MK = __webpack_require__(14);
	
	var MKSpinner = MK.MKSpinner;
	
	
	var ReUpButton = __webpack_require__(12);
	
	var AddToWalletButton = createReactClass({
	  displayName: 'AddToWalletButton',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      iframeSrc: "",
	      showSpinner: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  _downloadCounter: 0, // used to force the iframe reload
	  downloadPass: function downloadPass() {
	    if (this.state.showSpinner) return;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appID = appManager._appData["Header"].AppID;
	    var userID = appManager.currentUser()[ModelConstants.UserID];
	    var hash = appManager.currentUser()[ModelConstants.Hash];
	    var hostname = window.location.hostname;
	    var baseURL = "https://api.getreup.com/misc/generate_pass.php";
	    if (typeof hostname !== 'undefined') {
	      if (hostname.indexOf(".dev.") >= 0) {
	        baseURL = "https://api.dev.getreup.com/misc/generate_pass.php";
	      } else if (hostname.indexOf(".stage.") >= 0) {
	        baseURL = "https://api.stage.getreup.com/misc/generate_pass.php";
	      } else if (hostname.indexOf(".feature01.") >= 0) {
	        baseURL = "https://api.feature01.getreup.com/misc/generate_pass.php";
	      } else if (hostname.indexOf(".feature02.") >= 0) {
	        baseURL = "https://api.feature02.getreup.com/misc/generate_pass.php";
	      }
	    }
	    var downloadURL = baseURL + "?appid=" + appID + "&userid=" + userID + "&hash=" + hash + "&n=" + this._downloadCounter;
	    this.setState({ showSpinner: true, iframeSrc: downloadURL });
	    this._downloadCounter++;
	
	    setTimeout(function () {
	      thisThing.setState({ showSpinner: false });
	    }, 10000);
	  },
	
	  shouldRender: function shouldRender() {
	    var ua = navigator.userAgent.toLowerCase();
	    var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
	
	    return !isAndroid;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    if (!this.shouldRender()) return null;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    return React.createElement(
	      TouchableOpacity,
	      { style: [this.props.style, { flexDirection: 'column', cursor: 'pointer', backgroundColor: 'transparent', justifyContent: 'center', alignItems: 'center' }],
	        onPress: function onPress() {
	          return _this.downloadPass();
	        } },
	      this.state.showSpinner ? React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { alignSelf: 'center' } }) : React.createElement(Image, { key: "addtowallet", resizeMode: "contain", source: { uri: "https://developer.apple.com/wallet/images/add-to-apple-wallet.svg" }, style: { flex: 1, alignSelf: 'stretch' } }),
	      Platform.OS === 'web' ? React.createElement('iframe', { key: 'iframe', src: this.state.iframeSrc, style: { display: 'none' } }) : null
	    );
	  }
	});
	
	module.exports = AddToWalletButton;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ExternalActions = __webpack_require__(1107);
	
	var APP_ACTIONS_PUSH_COOLDOWN = 400;
	var APP_ACTIONS_ATTEMPTED_FEATURE_PUSH = 5000; // should be less than cool down to work
	
	var AppActions = {
	  _appManager: {},
	  _navigator: null,
	  initialize: function initialize(appManager, nav) {
	    this._appManager = appManager;
	    this._navigator = nav;
	
	    ExternalActions.initialize(this);
	  },
	
	  _appActionsCoolDown: false,
	  _attemptedFeature: [],
	  _attemptedExtras: [],
	  requestFeatureName: function requestFeatureName(featureName, extras, shouldAnimate, doAfterLoginSuccess, shouldReplace, shouldPopAfterLogin) {
	    if (this._appActionsCoolDown) return;
	    if (typeof shouldAnimate === 'undefined') shouldAnimate = true;
	    if (typeof shouldReplace === 'undefined') shouldReplace = false;
	    if (featureName == "Rewards") {
	      var rewardsCampaignsFeature = this._appManager.getFeatureForName("RewardsCampaigns");
	      if (typeof rewardsCampaignsFeature !== 'undefined') {
	        featureName = "RewardsCampaigns";
	      }
	    }
	    if (featureName == "EarnPoints") {
	      var rewardsCampaignsFeature = this._appManager.getFeatureForName("RewardsCampaigns");
	      if (typeof rewardsCampaignsFeature !== 'undefined') {
	        featureName = "RewardsCampaigns";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showEarnPointsFirst = true;
	      }
	    }
	    if (featureName == "CheckIn") {
	      var earnPayFeature = this._appManager.getFeatureForName("EarnPay");
	      if (typeof earnPayFeature !== 'undefined') {
	        featureName = "EarnPay";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showCheckInFirst = true;
	      }
	    }
	    if (featureName == "UseCredit") {
	      var earnPayFeature = this._appManager.getFeatureForName("EarnPay");
	      if (typeof earnPayFeature !== 'undefined') {
	        featureName = "EarnPay";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showUseCreditFirst = true;
	      }
	    }
	    // this._attemptedFeature = [];
	    // this._attemptedExtras = [];
	
	    var appManager = this._appManager;
	    var nav = this._navigator;
	
	    // check for overrides, like if a feature is a subtab of a bigger feature
	    if (typeof extras === 'undefined' || extras == null) extras = {};
	
	    var _appManager$getFeatur = appManager.getFeatureOverrideForName(featureName, extras),
	        featureName = _appManager$getFeatur.featureName,
	        extras = _appManager$getFeatur.extras;
	
	    var feature = JSON.parse(JSON.stringify(appManager.getFeatureForName(featureName)));
	    // if( typeof feature === 'undefined' ) return;
	
	    var needsLogin = feature.data.requiresLogin;
	    var prerequisiteFeature = appManager.getPrerequisiteFeatureForName(featureName);
	    this._doAfterLoginSuccess = typeof doAfterLoginSuccess !== 'undefined' ? doAfterLoginSuccess : null;
	    this._shouldPopAfterLogin = typeof shouldPopAfterLogin !== 'undefined' ? shouldPopAfterLogin : true;
	    if (needsLogin && !appManager.isLoggedIn()) {
	      var loginFeature = appManager.getFeatureForName("Login");
	      nav.pushFeature(loginFeature, {}, shouldAnimate);
	      this._attemptedFeature.push(feature);
	      this._attemptedExtras.push(extras);
	
	      this._appActionsCoolDown = true;
	      setTimeout(function () {
	        AppActions._appActionsCoolDown = false;
	      }, APP_ACTIONS_PUSH_COOLDOWN);
	    } else if (prerequisiteFeature != null) {
	      this._attemptedFeature.push(feature);
	      this._attemptedExtras.push(extras);
	      var prerequisiteFeatureName = prerequisiteFeature.data.name;
	      this.requestFeatureName(prerequisiteFeatureName, extras, shouldAnimate, doAfterLoginSuccess, shouldReplace);
	
	      // prerequisiteFeature = JSON.parse(JSON.stringify(prerequisiteFeature)); // make a copy to make sure doubles in stack work
	      // if( shouldReplace ) nav.setCurrentFeature(prerequisiteFeature);
	      // else nav.pushFeature(prerequisiteFeature, {}, shouldAnimate);
	    } else {
	      if (shouldReplace) nav.setCurrentFeature(feature, extras);else nav.pushFeature(feature, extras, shouldAnimate);
	
	      this._appActionsCoolDown = true;
	      setTimeout(function () {
	        AppActions._appActionsCoolDown = false;
	      }, APP_ACTIONS_PUSH_COOLDOWN);
	    }
	  },
	
	  featureForData: function featureForData(feature, layout, appManager, extras) {
	    if (this._navigator == null) return null;
	
	    return this._navigator.featureForData(feature, layout, appManager, extras);
	  },
	
	  requestPop: function requestPop(shouldPushAttemptedFeature) {
	    var willPushAttemptedFeature = typeof shouldPushAttemptedFeature !== 'undefined' && shouldPushAttemptedFeature && this._attemptedFeature != null && this._attemptedFeature.length > 0;
	    var willAttemptFunction = typeof shouldPushAttemptedFeature !== 'undefined' && shouldPushAttemptedFeature && this._doAfterLoginSuccess != null;
	    var attemptedFeature = this._attemptedFeature.pop();
	    var attemptedFeatureExtras = this._attemptedExtras.pop();
	    var appManager = this._appManager;
	    var doAfterLoginSuccess = this._doAfterLoginSuccess;
	
	    if (willAttemptFunction) {
	      if (appManager.isLoggedIn()) {
	        if (this._shouldPopAfterLogin) this._navigator.popFeature();
	        doAfterLoginSuccess();
	      } else {
	        this._attemptedFeature = [];
	        this._attemptedExtras = [];
	        this._navigator.popFeature();
	      }
	    } else if (willPushAttemptedFeature) {
	      var needsLogin = attemptedFeature.data.requiresLogin;
	      if (!needsLogin || appManager.isLoggedIn()) {
	        this._navigator.setCurrentFeature(attemptedFeature, attemptedFeatureExtras);
	      } else {
	        this._attemptedFeature = [];
	        this._attemptedExtras = [];
	        this._navigator.popFeature();
	      }
	    } else {
	      this._attemptedFeature = [];
	      this._attemptedExtras = [];
	      this._navigator.popFeature();
	    }
	  },
	
	  requestPopToIndex: function requestPopToIndex(index) {
	    this._attemptedFeature = [];
	    this._attemptedExtras = [];
	    this._navigator.popToIndex(index);
	  },
	
	  checkErrorCodeAndReturnIfHandled: function checkErrorCodeAndReturnIfHandled(errorCode) {
	    if (errorCode !== -21) return false;
	
	    var thisThing = this;
	
	    if (this._appManager.isLoggedIn()) {
	      this._appManager.logout(function () {
	        thisThing.requestPopToIndex(0);
	        thisThing.showLocalizedAlert("PASSWORD_CHANGED_ALERT_TITLE", "PASSWORD_CHANGED_ALERT_BODY", ["OK_ALERT_BUTTON"]);
	      });
	    }
	
	    return true;
	  },
	
	  setSpinnerShown: function setSpinnerShown(spinnerShown, spinnerText) {
	    var spinnerTextTrue = typeof spinnerText !== 'undefined' ? spinnerText : "";
	    this._navigator.setState({ shouldShowSpinner: spinnerShown, spinnerText: spinnerTextTrue });
	  },
	
	  showAlert: function showAlert(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize) {
	    this._navigator.showAlert(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize);
	  },
	
	  showLocalizedAlert: function showLocalizedAlert(LOC_TITLE, LOC_BODY, LOC_BUTTON_TITLES, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize) {
	    var locManager = this._appManager.getLocalizationManager();
	    var title = locManager.localizedStringForKey(LOC_TITLE);
	    var body = locManager.localizedStringForKey(LOC_BODY);
	    var buttonTitles = [];
	    for (var i = 0; i < LOC_BUTTON_TITLES.length; i++) {
	      var LOC_KEY = LOC_BUTTON_TITLES[i];
	      var buttonTitle = locManager.localizedStringForKey(LOC_KEY);
	      buttonTitles.push(buttonTitle);
	    }
	    return AppActions.showAlert(title, body, buttonTitles, buttonActions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize);
	  },
	
	  showNetworkErrorAlert: function showNetworkErrorAlert(okAction, didCancel) {
	    this._navigator.showNetworkErrorAlert(okAction, didCancel);
	  },
	
	  hideAlert: function hideAlert() {
	    AppActions._navigator.hideAlert();
	  },
	
	  setCustomAlertShown: function setCustomAlertShown(alertShown, alertChildren, didCancel, hideFrame, disableBackgroundSelectionDismiss) {
	    if (alertShown) this._navigator.showCustomAlert(alertChildren, didCancel, hideFrame, disableBackgroundSelectionDismiss);else this._navigator.hideAlert();
	  },
	
	  _drawer: null,
	  setDrawer: function setDrawer(drawer) {
	    this._drawer = drawer;
	  },
	
	  closeDrawer: function closeDrawer() {
	    if (this._drawer != null) this._drawer.close();
	  },
	
	  openDrawer: function openDrawer() {
	    if (this._drawer != null) this._drawer.open();
	  },
	
	  toggleDrawer: function toggleDrawer() {
	    if (this._drawer != null) this._drawer.toggle();
	  },
	
	  drawerDidOpen: function drawerDidOpen() {
	    if (typeof this._navigator !== 'undefined') {
	      var nav = this._navigator;
	      setTimeout(function () {
	        if (!nav._menuExpanded) {
	          nav._menuExpanded = true;
	          nav.forceUpdate();
	        }
	      }, 50);
	    }
	  },
	
	  drawerDidClose: function drawerDidClose() {
	    if (typeof this._navigator !== 'undefined') {
	      var nav = this._navigator;
	      setTimeout(function () {
	        if (nav._menuExpanded && nav.stackIndex() <= 0) {
	          nav._menuExpanded = false;
	          nav.forceUpdate();
	        } else {
	          nav._menuExpanded = false;
	        }
	      }, 50);
	    }
	  }
	};
	
	module.exports = AppActions;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(154), __webpack_require__(153));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var MD5 = C_algo.MD5;
	
		    /**
		     * This key derivation function is meant to conform with EVP_BytesToKey.
		     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
		     */
		    var EvpKDF = C_algo.EvpKDF = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: MD5,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.EvpKDF.create();
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Derives a key from a password.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init hasher
		            var hasher = cfg.hasher.create();
	
		            // Initial values
		            var derivedKey = WordArray.create();
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                if (block) {
		                    hasher.update(block);
		                }
		                var block = hasher.update(password).finalize(salt);
		                hasher.reset();
	
		                // Iterations
		                for (var i = 1; i < iterations; i++) {
		                    block = hasher.finalize(block);
		                    hasher.reset();
		                }
	
		                derivedKey.concat(block);
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Derives a key from a password.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.EvpKDF(password, salt);
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.EvpKDF = function (password, salt, cfg) {
		        return EvpKDF.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.EvpKDF;
	
	}));

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1253);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  STYLES: ['large', 'floating', 'flat'],
	  WAVES: ['light', 'red', 'yellow', 'orange', 'purple', 'green', 'teal'],
	  SIZES: ['s', 'm', 'l'],
	  PLACEMENTS: ['left', 'center', 'right'],
	  SCALES: ['big', 'small'],
	  ICON_SIZES: ['tiny', 'small', 'medium', 'large']
	};

/***/ },
/* 67 */
[1517, 23],
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Common implementation for a simple stubbed view.
	 */
	/* eslint-disable react/prop-types */
	var UnimplementedView = function (_Component) {
	  _inherits(UnimplementedView, _Component);
	
	  function UnimplementedView() {
	    _classCallCheck(this, UnimplementedView);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  UnimplementedView.prototype.setNativeProps = function setNativeProps() {
	    // Do nothing.
	    // This method is required in order to use this view as a Touchable* child.
	    // See ensureComponentIsNative.js for more info
	  };
	
	  UnimplementedView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _View2.default,
	      { style: [unimplementedViewStyles, this.props.style] },
	      this.props.children
	    );
	  };
	
	  return UnimplementedView;
	}(_react.Component);
	
	var unimplementedViewStyles =  false ? {
	  alignSelf: 'flex-start',
	  borderColor: 'red',
	  borderWidth: 1
	} : {};
	
	exports.default = UnimplementedView;
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	/* eslint no-bitwise: 0 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _normalizeCssColor = __webpack_require__(160);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var linear = function linear(t) {
	  return t;
	};
	
	/**
	 * Very handy helper to map input ranges to output ranges with an easing
	 * function and custom behavior outside of the ranges.
	 */
	function createInterpolation(config) {
	  if (config.outputRange && typeof config.outputRange[0] === 'string') {
	    return createInterpolationFromStringOutputRange(config);
	  }
	
	  var outputRange = config.outputRange;
	  checkInfiniteRange('outputRange', outputRange);
	
	  var inputRange = config.inputRange;
	  checkInfiniteRange('inputRange', inputRange);
	  checkValidInputRange(inputRange);
	
	  (0, _invariant2.default)(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');
	
	  var easing = config.easing || linear;
	
	  var extrapolateLeft = 'extend';
	  if (config.extrapolateLeft !== undefined) {
	    extrapolateLeft = config.extrapolateLeft;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateLeft = config.extrapolate;
	  }
	
	  var extrapolateRight = 'extend';
	  if (config.extrapolateRight !== undefined) {
	    extrapolateRight = config.extrapolateRight;
	  } else if (config.extrapolate !== undefined) {
	    extrapolateRight = config.extrapolate;
	  }
	
	  return function (input) {
	    (0, _invariant2.default)(typeof input === 'number', 'Cannot interpolation an input which is not a number');
	
	    var range = findRange(input, inputRange);
	    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
	  };
	}
	
	function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
	  var result = input;
	
	  // Extrapolate
	  if (result < inputMin) {
	    if (extrapolateLeft === 'identity') {
	      return result;
	    } else if (extrapolateLeft === 'clamp') {
	      result = inputMin;
	    } else if (extrapolateLeft === 'extend') {
	      // noop
	    }
	  }
	
	  if (result > inputMax) {
	    if (extrapolateRight === 'identity') {
	      return result;
	    } else if (extrapolateRight === 'clamp') {
	      result = inputMax;
	    } else if (extrapolateRight === 'extend') {
	      // noop
	    }
	  }
	
	  if (outputMin === outputMax) {
	    return outputMin;
	  }
	
	  if (inputMin === inputMax) {
	    if (input <= inputMin) {
	      return outputMin;
	    }
	    return outputMax;
	  }
	
	  // Input Range
	  if (inputMin === -Infinity) {
	    result = -result;
	  } else if (inputMax === Infinity) {
	    result = result - inputMin;
	  } else {
	    result = (result - inputMin) / (inputMax - inputMin);
	  }
	
	  // Easing
	  result = easing(result);
	
	  // Output Range
	  if (outputMin === -Infinity) {
	    result = -result;
	  } else if (outputMax === Infinity) {
	    result = result + outputMin;
	  } else {
	    result = result * (outputMax - outputMin) + outputMin;
	  }
	
	  return result;
	}
	
	function colorToRgba(input) {
	  var int32Color = (0, _normalizeCssColor2.default)(input);
	  if (int32Color === null) {
	    return input;
	  }
	
	  int32Color = int32Color || 0;
	
	  var r = (int32Color & 0xff000000) >>> 24;
	  var g = (int32Color & 0x00ff0000) >>> 16;
	  var b = (int32Color & 0x0000ff00) >>> 8;
	  var a = (int32Color & 0x000000ff) / 255;
	
	  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
	}
	
	var stringShapeRegex = /[0-9\.-]+/g;
	
	/**
	 * Supports string shapes by extracting numbers so new values can be computed,
	 * and recombines those values into new strings of the same shape.  Supports
	 * things like:
	 *
	 *   rgba(123, 42, 99, 0.36) // colors
	 *   -45deg                  // values with units
	 */
	function createInterpolationFromStringOutputRange(config) {
	  var outputRange = config.outputRange;
	  (0, _invariant2.default)(outputRange.length >= 2, 'Bad output range');
	  outputRange = outputRange.map(colorToRgba);
	  checkPattern(outputRange);
	
	  // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
	  // ->
	  // [
	  //   [0, 50],
	  //   [100, 150],
	  //   [200, 250],
	  //   [0, 0.5],
	  // ]
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
	    return [];
	  });
	  outputRange.forEach(function (value) {
	    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
	     * against this possibility.
	     */
	    value.match(stringShapeRegex).forEach(function (number, i) {
	      outputRanges[i].push(+number);
	    });
	  });
	
	  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
	   * guard against this possibility.
	   */
	  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
	    return createInterpolation(Object.assign({}, config, {
	      outputRange: outputRanges[i]
	    }));
	  });
	
	  // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
	  // round the opacity (4th column).
	  var shouldRound = isRgbOrRgba(outputRange[0]);
	
	  return function (input) {
	    var i = 0;
	    // 'rgba(0, 100, 200, 0)'
	    // ->
	    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
	    return outputRange[0].replace(stringShapeRegex, function () {
	      var val = +interpolations[i++](input);
	      var rounded = shouldRound && i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
	      return String(rounded);
	    });
	  };
	}
	
	function isRgbOrRgba(range) {
	  return typeof range === 'string' && range.startsWith('rgb');
	}
	
	function checkPattern(arr) {
	  var pattern = arr[0].replace(stringShapeRegex, '');
	  for (var i = 1; i < arr.length; ++i) {
	    (0, _invariant2.default)(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
	  }
	}
	
	function findRange(input, inputRange) {
	  var i = void 0;
	  for (i = 1; i < inputRange.length - 1; ++i) {
	    if (inputRange[i] >= input) {
	      break;
	    }
	  }
	  return i - 1;
	}
	
	function checkValidInputRange(arr) {
	  (0, _invariant2.default)(arr.length >= 2, 'inputRange must have at least 2 elements');
	  for (var i = 1; i < arr.length; ++i) {
	    (0, _invariant2.default)(arr[i] >= arr[i - 1],
	    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	     * one or both of the operands may be something that doesn't cleanly
	     * convert to a string, like undefined, null, and object, etc. If you really
	     * mean this implicit string conversion, you can do something like
	     * String(myThing)
	     */
	    'inputRange must be monotonically increasing ' + arr);
	  }
	}
	
	function checkInfiniteRange(name, arr) {
	  (0, _invariant2.default)(arr.length >= 2, name + ' must have at least 2 elements');
	  (0, _invariant2.default)(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
	  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
	   * one or both of the operands may be something that doesn't cleanly convert
	   * to a string, like undefined, null, and object, etc. If you really mean
	   * this implicit string conversion, you can do something like
	   * String(myThing)
	   */
	  name + 'cannot be ]-infinity;+infinity[ ' + arr);
	}
	
	var AnimatedInterpolation = function (_AnimatedWithChildren) {
	  _inherits(AnimatedInterpolation, _AnimatedWithChildren);
	
	  // Export for testing.
	  function AnimatedInterpolation(parent, config) {
	    _classCallCheck(this, AnimatedInterpolation);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._parent = parent;
	    _this._config = config;
	    _this._interpolation = createInterpolation(config);
	    return _this;
	  }
	
	  AnimatedInterpolation.prototype.__makeNative = function __makeNative() {
	    this._parent.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__getValue = function __getValue() {
	    var parentValue = this._parent.__getValue();
	    (0, _invariant2.default)(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
	    return this._interpolation(parentValue);
	  };
	
	  AnimatedInterpolation.prototype.interpolate = function interpolate(config) {
	    return new AnimatedInterpolation(this, config);
	  };
	
	  AnimatedInterpolation.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	  };
	
	  AnimatedInterpolation.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedInterpolation.prototype.__transformDataType = function __transformDataType(range) {
	    // Change the string array type to number array
	    // So we can reuse the same logic in iOS and Android platform
	    return range.map(function (value) {
	      if (typeof value !== 'string') {
	        return value;
	      }
	      if (/deg$/.test(value)) {
	        var degrees = parseFloat(value) || 0;
	        var radians = degrees * Math.PI / 180.0;
	        return radians;
	      } else {
	        // Assume radians
	        return parseFloat(value) || 0;
	      }
	    });
	  };
	
	  AnimatedInterpolation.prototype.__getNativeConfig = function __getNativeConfig() {
	    if (false) {
	      _NativeAnimatedHelper2.default.validateInterpolation(this._config);
	    }
	
	    return {
	      inputRange: this._config.inputRange,
	      // Only the `outputRange` can contain strings so we don't need to transform `inputRange` here
	      outputRange: this.__transformDataType(this._config.outputRange),
	      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
	      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
	      type: 'interpolation'
	    };
	  };
	
	  return AnimatedInterpolation;
	}(_AnimatedWithChildren3.default);
	
	AnimatedInterpolation.__createInterpolation = createInterpolation;
	exports.default = AnimatedInterpolation;
	module.exports = exports['default'];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(116);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(98);
	util.inherits = __webpack_require__(82);
	/*</replacement>*/
	
	var Readable = __webpack_require__(1071);
	var Writable = __webpack_require__(830);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	
	module.exports = Class({
	
		grab: function(){
			for (var i = 0; i < arguments.length; i++) arguments[i].inject(this);
			return this;
		},
	
		empty: function(){
			var node;
			while (node = this.firstChild) node.eject();
			return this;
		}
	
	});

/***/ },
/* 72 */
/***/ function(module, exports) {

	var VMLCSS = 'behavior:url(#default#VML);display:inline-block;position:absolute;left:0px;top:0px;';
	
	var styleSheet, styledTags = {}, styleTag = function(tag){
		if (styleSheet) styledTags[tag] = styleSheet.addRule('av\\:' + tag, VMLCSS);
	};
	
	exports.init = function(document){
	
		var namespaces;
		try { // IE9 workaround: sometimes it throws here
			namespaces = document.namespaces;
		} catch (e) {
		}
		if (!namespaces) return false;
	
		namespaces.add('av', 'urn:schemas-microsoft-com:vml');
		namespaces.add('ao', 'urn:schemas-microsoft-com:office:office');
	
		styleSheet = document.createStyleSheet();
		styleSheet.addRule('vml', 'display:inline-block;position:relative;overflow:hidden;');
	/*	styleTag('skew');
		styleTag('fill');
		styleTag('stroke');
		styleTag('path');
		styleTag('textpath');
		styleTag('group');*/
	
		styleTag('vml');
	
		return true;
	
	};
	
	exports.createElement = function(tag){
		if (!(tag in styledTags)) styleTag(tag);
		return document.createElement('av:' + tag);
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var moment = __webpack_require__(3);
	var ReUpText = __webpack_require__(8);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    ScrollView = ReactNative.ScrollView;
	
	
	var ReUpCountdown = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      countdownComplete: function countdownComplete() {},
	      completionText: "now!",
	      endDate: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      counterText: "",
	      counterStartDate: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.endDate != null) {
	      this.startCountdown(this.props.endDate);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.stopCountdown();
	  },
	
	  _theTimeout: null,
	  _endSeconds: null,
	  startCountdown: function startCountdown(endDate) {
	    if (typeof endDate !== 'undefined') {
	      this.stopCountdown();
	      this._endDate = endDate;
	    }
	
	    var shouldContinue = this._updateTimer();
	    if (shouldContinue) {
	      var thisThing = this;
	      this._theTimeout = setTimeout(function () {
	        thisThing.startCountdown();
	      }, 200);
	    }
	  },
	
	  stopCountdown: function stopCountdown() {
	    if (this._theTimeout != null) clearTimeout(this._theTimeout);
	
	    this._theTimeout = null;
	  },
	
	  _updateTimer: function _updateTimer() {
	    var now = new Date();
	    var newCounterText = this.props.appManager.timeTill(this._endDate.getTime() / 1000);
	    if (now.getTime() >= this._endDate.getTime()) {
	      newCounterText = this.props.completionText;
	      if (this.props.complete) this.props.complete();
	    }
	    if (newCounterText != this.state.counterText) this.setState({ counterText: newCounterText });
	
	    return now.getTime() < this._endDate.getTime();
	  },
	
	  render: function render() {
	    return React.createElement(
	      ReUpText,
	      this.props,
	      this.state.counterText
	    );
	  }
	});
	
	module.exports = ReUpCountdown;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpText = __webpack_require__(8);
	
	var ReUpTabBar = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      text: "",
	      isSecondary: false,
	      useShadow: true,
	      buttonFeatures: [],
	      showFeature: function showFeature(feature, index, extras) {},
	      hideFeature: function hideFeature() {},
	      initialTabSelected: -1,
	      inactiveBackgroundColor: 'transparent',
	      activeBackgroundColor: 'red',
	      textColor: 'blue',
	      iconColor: 'red',
	      rippleColor: 'rgba(255,0,0,.3)',
	      addedTextStyle: {},
	      barColor: 'transparent',
	      layout: { width: 0, height: 0 },
	      canDismiss: true,
	      showX: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var barWidth = 0;
	    if (this.props.buttonFeatures.length > 0) {
	      barWidth = this.props.layout.width / this.props.buttonFeatures.length;
	    }
	
	    return {
	      tabIndexSelected: -1,
	      visible: true,
	      opacity: new Animated.Value(1),
	      barLeft: new Animated.Value(0),
	      barWidth: barWidth
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setTabSelected(this.props.initialTabSelected);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.buttonFeatures !== 'undefined') {
	      var barWidth = 0;
	      if (newProps.buttonFeatures.length > 0) {
	        barWidth = this.props.layout.width / newProps.buttonFeatures.length;
	        if (barWidth != this.state.barWidth) this.setState({ barWidth: barWidth });
	      }
	    }
	  },
	
	  setTabSelected: function setTabSelected(index, showFeatureAsWell) {
	    if (typeof showFeatureAsWell === 'undefined') showFeatureAsWell = true;
	
	    if (index != this.state.tabIndexSelected) {
	      var newLeft = index * this.state.barWidth;
	      if (this.state.tabIndexSelected < 0) {
	        if (showFeatureAsWell) this.props.showFeature(JSON.parse(JSON.stringify(this.props.buttonFeatures[index])), index, { shouldHideActionBar: true });
	        this.setState({ tabIndexSelected: index, barLeft: new Animated.Value(newLeft) });
	      } else if (index >= 0) {
	        if (showFeatureAsWell) this.props.showFeature(JSON.parse(JSON.stringify(this.props.buttonFeatures[index])), index, { shouldHideActionBar: true });
	        Animated.spring(this.state.barLeft, {
	          toValue: newLeft,
	          tension: 10,
	          friction: 5
	        }).start();
	      }
	      this.setState({ tabIndexSelected: index });
	    }
	  },
	
	  setVisible: function setVisible(visible, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    if (visible == this.state.visible) return;
	
	    var thisThing = this;
	    if (visible) {
	      thisThing.setState({ visible: visible });
	      Animated.timing(thisThing.state.opacity, { toValue: 1,
	        duration: 300 }).start(function () {});
	    } else {
	      Animated.timing(thisThing.state.opacity, { toValue: 0,
	        duration: 300 }).start(function () {
	        thisThing.setState({ visible: visible });
	      });
	    }
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var tabIndexSelected = this.state.tabIndexSelected;
	
	    var inactiveBackgroundColor = this.props.inactiveBackgroundColor;
	    var rippleColor = this.props.rippleColor;
	    var activeBackgroundColor = this.props.activeBackgroundColor;
	    var textColor = this.props.textColor;
	    var iconColor = this.props.iconColor;
	    var visible = this.state.visible;
	    var showFeature = this.props.showFeature;
	    var hideFeature = this.props.hideFeature;
	    var addedTextStyle = this.props.addedTextStyle;
	
	    if (!visible) return null;
	
	    return React.createElement(
	      Animated.View,
	      { style: [this.props.style, { flexDirection: 'row', height: 50, opacity: this.state.opacity, alignItems: 'stretch' }, this.props.canDismiss ? Globals.TAB_STYLE_ADJUSTMENT : {}],
	        onLayout: function onLayout(evt) {
	          var barWidth = evt.nativeEvent.layout.width / thisThing.props.buttonFeatures.length;
	          if (barWidth != thisThing.state.barWidth) thisThing.setState({ barWidth: barWidth });
	        } },
	      !visible ? null : this.props.buttonFeatures.map(function (feature, index) {
	        var _React$createElement;
	
	        if (typeof feature === 'undefined') return null;
	        var icon = null;
	        var buttonTitle = typeof feature.data.shortTitle === 'undefined' ? feature.data.title : feature.data.shortTitle;
	        if (iconColor != 'transparent') icon = feature.data.icon.replace("fa-", "");
	
	        return React.createElement(
	          View,
	          { style: { flex: 1, alignSelf: 'stretch' } },
	          React.createElement(
	            MKButton,
	            (_React$createElement = {
	              backgroundColor: inactiveBackgroundColor,
	              shadowRadius: 0,
	              shadowOffset: { width: 0, height: 0 },
	              shadowOpacity: 0,
	              shadowColor: 'transparent',
	              style: { flex: 1, alignSelf: 'center' },
	              rippleColor: rippleColor,
	              maskBorderRadius: 0,
	              enabled: visible
	            }, _defineProperty(_React$createElement, 'style', { pointerEvents: visible ? 'auto' : 'none', flex: 1, alignSelf: 'stretch', display: 'flex' }), _defineProperty(_React$createElement, 'onPress', function onPress() {
	              if (index == tabIndexSelected) {
	                if (thisThing.props.canDismiss) {
	                  thisThing.setTabSelected(-1);
	                  hideFeature();
	                }
	              } else {
	                thisThing.setTabSelected(index);
	              }
	            }), _React$createElement),
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', flex: 1 } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', alignItems: 'center', flexGrow: 1, flexShrink: 1, flexBasis: 'auto' } },
	                React.createElement(
	                  View,
	                  { style: { alignSelf: 'center', marginLeft: 2 } },
	                  icon != null ? React.createElement(_ReUpIcon2.default, { name: icon, size: 20, color: iconColor }) : null
	                ),
	                icon != null ? React.createElement(View, { style: { width: 4 } }) : null,
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', flex: 1, alignSelf: 'flex-start' } },
	                  React.createElement(
	                    ReUpText,
	                    { pointerEvents: 'none',
	                      style: [{ paddingLeft: 4,
	                        paddingRight: 4,
	                        wordWrap: 'break-word',
	                        fontSize: 14,
	                        textAlign: 'center',
	                        color: textColor,
	                        backgroundColor: 'transparent',
	                        fontWeight: tabIndexSelected == index ? 'bold' : 'normal' }, addedTextStyle] },
	                    buttonTitle
	                  )
	                )
	              )
	            )
	          ),
	          thisThing.props.showX && tabIndexSelected == index ? React.createElement(
	            View,
	            { style: { position: 'absolute', top: 4, left: 4, width: 20, height: 20, opacity: .4 } },
	            React.createElement(_ReUpIcon2.default, { name: 'times', size: 12, color: textColor })
	          ) : null
	        );
	      }),
	      React.createElement(Animated.View, { pointerEvents: 'none', style: { position: 'absolute', bottom: 0, opacity: tabIndexSelected >= 0 ? 1 : 0, left: this.state.barLeft, height: 6, width: this.state.barWidth, backgroundColor: this.props.barColor } })
	    );
	  }
	});
	
	module.exports = ReUpTabBar;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(114);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var PlatformConstants = __webpack_require__(31);
	var Animated = __webpack_require__(9);
	
	var ReUpText = __webpack_require__(8);
	var ReUpIconButton = __webpack_require__(18);
	var RNFS = __webpack_require__(96);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    TouchableOpacity = ReactNative.TouchableOpacity,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var ModelConstants = __webpack_require__(11);
	
	var MENU_WIDTH = 250;
	var MENU_ADDITIONAL_WIDTH = 0; //80;
	var MENU_EXPANDED_LEFT = -MENU_ADDITIONAL_WIDTH;
	var MENU_UNEXPANDED_LEFT = -MENU_WIDTH - 2 * MENU_ADDITIONAL_WIDTH;
	
	var Menu = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      menuExpandedChanged: function menuExpandedChanged() {},
	      menuFeatures: [],
	      menuIconColor: '#F00',
	      menuTitleColor: '#444',
	      menuHighlightColor: '#FF0',
	      menuSeparatorColor: '#FF0',
	      AppActions: null,
	      appManager: null,
	      style: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var showProfile = this.props.appManager.shouldUseFloatingNav();
	
	    return {
	      isExpanded: false,
	      menuLeft: new Animated.Value(MENU_UNEXPANDED_LEFT),
	      dismissOpacity: new Animated.Value(0),
	      layout: { x: 0, y: 0, width: 0, height: 0 },
	      selfieURL: null,
	      showProfile: showProfile
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.props.appManager.getSelfie(function (selfieURL) {
	      return _this.setState({ selfieURL: selfieURL });
	    });
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.selfieURL !== 'undefined') this.setState({ selfieURL: newProps.selfieURL });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  profilePicSelected: function profilePicSelected() {
	    if (Platform.OS === 'ios') {
	      var thisThing = this;
	      var appActions = this.props.AppActions;
	      _reactNativeCameraWrapper2.default.checkVideoAuthorizationStatus().then(function (hasPermission) {
	        if (hasPermission) {
	          thisThing.showCamera();
	        } else {
	          appActions.showAlert("Camera Permission Required", "You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.", ["Okay"], [function () {
	            appActions.hideAlert();
	          }]);
	        }
	      });
	    } else {
	      this.showCamera();
	    }
	  },
	
	  _camera: null,
	  _canCapture: false,
	  cameraDidLoad: function cameraDidLoad(camera) {
	    if (!camera) return;
	    this._canCapture = true;
	    this._camera = camera;
	  },
	
	  takePicture: function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var appManager, thisThing, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(this._camera && this._canCapture)) {
	                _context.next = 14;
	                break;
	              }
	
	              this._canCapture = false;
	              _context.prev = 2;
	              appManager = this.props.appManager;
	              thisThing = this;
	              _context.next = 7;
	              return this._camera.capture({ target: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk, mode: _reactNativeCameraWrapper2.default.constants.CaptureMode.still, type: _reactNativeCameraWrapper2.default.constants.Type.front, quality: 'medium' });
	
	            case 7:
	              data = _context.sent;
	
	              // console.log(data);
	              appManager.setSelfie(data, function () {
	                // console.log("did set selfie")
	                appManager.getSelfie(function (selfieURL) {
	                  // console.log("did get selfie with url" + selfieURL)
	                  thisThing.props.AppActions.hideAlert();
	                  thisThing.setState({ selfieURL: selfieURL });
	                });
	              });
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](2);
	
	              console.error(_context.t0);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[2, 11]]);
	    }));
	
	    function takePicture() {
	      return _ref.apply(this, arguments);
	    }
	
	    return takePicture;
	  }(),
	
	  checkUserChanged: function checkUserChanged() {
	    var thisThing = this;
	    this.props.appManager.getSelfie(function (selfieURL) {
	      thisThing.setState({ selfieURL: selfieURL });
	    });
	  },
	
	  showCamera: function showCamera() {
	    var _React$createElement, _React$createElement2;
	
	    var cameraDim = Math.min(this.props.layout.width, this.props.layout.height) - 20;
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	
	    var customAlert = Platform.OS === 'ios' ? React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0 },
	        keyboardShouldPersistTaps: 'always',
	        showsVerticalScrollIndicator: false,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        _reactNativeCameraWrapper2.default,
	        { ref: this.cameraDidLoad, style: {
	            alignSelf: 'center',
	            height: cameraDim, width: cameraDim,
	            justifyContent: 'flex-end',
	            padding: 10
	          },
	          captureAudio: false,
	          captureQuality: "medium",
	          captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	          type: _reactNativeCameraWrapper2.default.constants.Type.front,
	          aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill },
	        React.createElement(ReUpIconButton, (_React$createElement = { iconName: "camera", type: 1, style: { margin: 10 },
	          appManager: appManager
	        }, _defineProperty(_React$createElement, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement, 'onPress', function onPress() {
	          thisThing.takePicture();
	        }), _React$createElement))
	      )
	    ) : React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0, paddingBottom: 10 },
	        keyboardShouldPersistTaps: 'always',
	        showsVerticalScrollIndicator: false,
	        keyboardDismissMode: "interactive" },
	      React.createElement(_reactNativeCameraWrapper2.default, { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'flex-end', padding: 10, marginBottom: 10 },
	        captureAudio: false,
	        aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill,
	        captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	        captureQuality: "medium",
	        type: _reactNativeCameraWrapper2.default.constants.Type.front,
	        orientation: _reactNativeCameraWrapper2.default.constants.Orientation.portrait }),
	      React.createElement(ReUpIconButton, (_React$createElement2 = { iconName: "camera", type: 1, style: { margin: 10 },
	        appManager: appManager
	      }, _defineProperty(_React$createElement2, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement2, 'onPress', function onPress() {
	        thisThing.takePicture();
	      }), _React$createElement2))
	    );
	
	    this.props.AppActions.setCustomAlertShown(true, customAlert);
	  },
	
	  setIsExpanded: function setIsExpanded(isExpanded) {
	    if (isExpanded == this.state.isExpanded) return;
	
	    this.setState({ isExpanded: isExpanded });
	
	    if (isExpanded) {
	      this.refs.blur.setOpacity(1);
	    } else {
	      this.refs.blur.setOpacity(0);
	    }
	    this.props.menuExpandedChanged(isExpanded);
	    Animated.spring(this.state.menuLeft, {
	      toValue: isExpanded ? MENU_EXPANDED_LEFT : MENU_UNEXPANDED_LEFT,
	      velocity: 3,
	      tension: 6,
	      friction: 7
	    }).start();
	
	    Animated.timing(this.state.dismissOpacity, { toValue: isExpanded ? 1 : 0,
	      duration: 300 }).start(function () {});
	  },
	
	  toggleIsExpanded: function toggleIsExpanded() {
	    this.setIsExpanded(!this.state.isExpanded);
	  },
	
	  viewDidLayout: function viewDidLayout(info) {
	    var currentLayout = info.nativeEvent.layout;
	    var layout = info.nativeEvent.layout;
	
	    if (layout.height != this.state.layout.height || layout.width != this.state.layout.width) this.setState({ layout: layout });
	  },
	
	  didSelectFeature: function didSelectFeature(feature) {
	    this.props.AppActions.requestFeatureName(feature.key);
	  },
	
	  render: function render() {
	    var _ref2;
	
	    var menu = this;
	    var style = this.props.style;
	    if (typeof style === 'undefined') style = {};
	    var appManager = this.props.appManager;
	    var bgImage = this.props.appManager.absoluteResourceForPath('App/Menu.png');
	    var menuColor = this.props.appManager.getColorForKey("MenuColor", 1);
	    var menuTitleColor = this.props.appManager.getColorForKey("MenuTitleColor", 1);
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);
	
	    var user = appManager.currentUser();
	    var userFullName = "";
	    var email = "";
	    var currDollars = null;
	    var currPoints = null;
	    var creditString = null;
	    var pointsString = null;
	    var initials = null;
	    var classNames = "";
	    if (typeof user !== 'undefined' && user != null) {
	      initials = appManager.currentUserInitials();
	      userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
	      email = user[ModelConstants.UserName];
	      currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
	      currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
	      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
	      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
	      classNames = typeof appManager.currentUser()[ModelConstants.ClassNames] !== 'undefined' ? appManager.currentUser()[ModelConstants.ClassNames].join(", ") : "";
	    }
	
	    var useSelfie = typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0;
	
	    var thisThing = this;
	
	    return React.createElement(
	      View,
	      { style: [{ flex: 1, alignSelf: 'stretch', backgroundColor: menuColor }, this.props.style], onLayout: this.viewDidLayout,
	        testID: "menu" },
	      React.createElement(Image, {
	        key: appManager.getImageKey("menubg"),
	        style: [this.props.style, styles.image],
	        source: { uri: bgImage }
	      }),
	      React.createElement(
	        ScrollView,
	        { bounces: false, showsVerticalScrollIndicator: false, keyboardShouldPersistTaps: 'always' },
	        this.state.showProfile && appManager.isLoggedIn() ? React.createElement(
	          View,
	          { style: { flexDirection: 'column', marginHorizontal: 12, marginTop: 12 } },
	          React.createElement(
	            View,
	            { style: {
	                flexDirection: 'row',
	                justifyContent: 'center',
	                alignItems: 'center'
	              } },
	            React.createElement(
	              View,
	              { style: {
	                  width: 100,
	                  height: 100,
	                  flexDirection: 'row',
	                  alignItems: 'center',
	                  justifyContent: 'flex-start'
	                } },
	              React.createElement(
	                TouchableHighlight,
	                {
	                  underlayColor: "transparent",
	                  activeOpacity: 0.9,
	                  onPress: function onPress() {
	                    thisThing.profilePicSelected();
	                  } },
	                React.createElement(
	                  View,
	                  { style: { borderColor: profileColor, borderWidth: 0, backgroundColor: profileColor, borderRadius: 40, width: 80, height: 80 } },
	                  useSelfie ? React.createElement(
	                    View,
	                    { style: { flex: 1 } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: {
	                          textAlign: 'center',
	                          fontSize: 40,
	                          fontWeight: 'bold',
	                          backgroundColor: 'transparent', position: 'absolute', bottom: 0, right: 0, top: 16, left: 0 } },
	                      initials
	                    ),
	                    React.createElement(Image, { source: { uri: this.state.selfieURL }, style: (_ref2 = { backgroundColor: 'transparent', margin: 0, borderRadius: 38 }, _defineProperty(_ref2, 'margin', 1), _defineProperty(_ref2, 'flex', 1), _defineProperty(_ref2, 'justifyContent', 'center'), _ref2) })
	                  ) : React.createElement(
	                    View,
	                    { style: { flex: 1, backgroundColor: profileImageColorLight, borderRadius: 39, justifyContent: 'center' } },
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: {
	                            textAlign: 'center',
	                            fontSize: 40,
	                            fontWeight: 'bold',
	                            backgroundColor: 'transparent', color: profileImageColor } },
	                        initials
	                      )
	                    ),
	                    React.createElement(
	                      View,
	                      { style: { position: 'absolute', bottom: 0, left: 0, right: 0, height: 24, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(_ReUpIcon2.default, { name: "camera", size: 16, color: profileImageColor })
	                    )
	                  ),
	                  React.createElement(
	                    _reactNativeSvgWrapper2.default,
	                    {
	                      height: 110,
	                      width: 110,
	                      style: { position: 'absolute', top: -10, left: -10, backgroundColor: 'transparent' }
	                    },
	                    React.createElement(
	                      _reactNativeSvgWrapper.G,
	                      { scale: '1' },
	                      React.createElement(_reactNativeSvgWrapper.Circle, { cx: '50', cy: '50', r: '39.5', stroke: profileImageColor, 'stroke-width': 2, fill: 'transparent' })
	                    )
	                  )
	                )
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { flex: 1, flexDirection: 'column', paddingTop: 8 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: { backgroundColor: 'transparent', color: menuTitleColor } },
	                userFullName
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { backgroundColor: 'transparent', color: menuTitleColor } },
	                email
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', justifyContent: 'flex-start', marginBottom: 6 } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'center', marginRight: 20 } },
	                  React.createElement(_ReUpIcon2.default, { name: 'pay-shortcut', size: 15, color: menuTitleColor, style: { backgroundColor: 'transparent', color: menuTitleColor } }),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { backgroundColor: 'transparent', color: menuTitleColor, marginLeft: 10 } },
	                    creditString
	                  )
	                ),
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'center' } },
	                  React.createElement(_ReUpIcon2.default, { name: 'trophy', size: 15, color: menuTitleColor, style: { backgroundColor: 'transparent', color: menuTitleColor } }),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { backgroundColor: 'transparent', color: menuTitleColor, marginLeft: 10 } },
	                    pointsString
	                  )
	                )
	              ),
	              classNames.length > 0 ? React.createElement(
	                View,
	                { style: { flexDirection: 'row', justifyContent: 'flex-start' } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'center' } },
	                  React.createElement(_ReUpIcon2.default, { name: 'trophy', size: 15, color: menuTitleColor, style: { backgroundColor: 'transparent' } }),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { color: menuTitleColor, marginLeft: 10 } },
	                    classNames
	                  )
	                )
	              ) : null
	            )
	          )
	        ) : null,
	        this.props.menuFeatures.map(function (menuFeature, index) {
	          var _ref3;
	
	          var iconName = menuFeature.data.icon.replace("fa-", "");
	          var rippleColor = menu.props.menuHighlightColor; // not gonna use, rkbutton is foreground highlight, so no use
	          return React.createElement(
	            View,
	            { key: index },
	            React.createElement(
	              MKButton,
	              { key: index, style: styles.menuItem,
	                backgroundColor: "transparent",
	                onPress: function onPress() {
	                  menu.didSelectFeature(menuFeature);
	                },
	                testID: menuFeature.data.title
	              },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'column', height: 40 } },
	                React.createElement(
	                  View,
	                  { style: styles.menuItemInnerContainer },
	                  React.createElement(_ReUpIcon2.default, { style: styles.icon, name: iconName, size: 24, color: menu.props.menuIconColor }),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, isTitle: true, style: [styles.menuTitle, { color: menuTitleColor }] },
	                    appManager.useCapsButtons() ? menuFeature.data.title.toUpperCase() : menuFeature.data.title
	                  )
	                )
	              )
	            ),
	            React.createElement(View, { style: (_ref3 = { height: 1, backgroundColor: 'black', flexBasis: 'auto', flexGrow: 0, flexShrink: 0 }, _defineProperty(_ref3, 'backgroundColor', menu.props.menuSeparatorColor), _defineProperty(_ref3, 'marginLeft', 50), _ref3) })
	          );
	        }),
	        React.createElement(View, { style: { height: 20 } })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    width: MENU_WIDTH + MENU_ADDITIONAL_WIDTH,
	    backgroundColor: 'transparent',
	    alignItems: 'stretch'
	  },
	  menu: {
	    paddingLeft: MENU_ADDITIONAL_WIDTH,
	    flex: 1,
	    width: MENU_WIDTH + MENU_ADDITIONAL_WIDTH,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  menuItem: {
	    flex: 1,
	    height: 40,
	    flexDirection: 'column',
	    justifyContent: 'center'
	  },
	  menuItemInnerContainer: {
	    flex: 1,
	    flexDirection: 'row',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  icon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    marginTop: 2,
	    width: 50
	  },
	  menuTitle: {
	    flex: 1
	  },
	  image: {
	    position: 'absolute',
	    top: 0, left: 0, right: 0, bottom: 0
	  }
	});
	
	module.exports = Menu;

/***/ },
/* 76 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  dismiss: function dismiss() {}
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var Camera = createReactClass({
	  displayName: 'Camera',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	module.exports = Camera;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View;
	
	
	var MapView = createReactClass({
	  displayName: 'MapView',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	MapView.Marker = createReactClass({
	  displayName: 'Marker',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	module.exports = MapView;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1173)
	var ieee754 = __webpack_require__(1218)
	var isArray = __webpack_require__(862)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var T = [];
	
		    // Compute constants
		    (function () {
		        for (var i = 0; i < 64; i++) {
		            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
		        }
		    }());
	
		    /**
		     * MD5 hash algorithm.
		     */
		    var MD5 = C_algo.MD5 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
	
		            // Shortcuts
		            var H = this._hash.words;
	
		            var M_offset_0  = M[offset + 0];
		            var M_offset_1  = M[offset + 1];
		            var M_offset_2  = M[offset + 2];
		            var M_offset_3  = M[offset + 3];
		            var M_offset_4  = M[offset + 4];
		            var M_offset_5  = M[offset + 5];
		            var M_offset_6  = M[offset + 6];
		            var M_offset_7  = M[offset + 7];
		            var M_offset_8  = M[offset + 8];
		            var M_offset_9  = M[offset + 9];
		            var M_offset_10 = M[offset + 10];
		            var M_offset_11 = M[offset + 11];
		            var M_offset_12 = M[offset + 12];
		            var M_offset_13 = M[offset + 13];
		            var M_offset_14 = M[offset + 14];
		            var M_offset_15 = M[offset + 15];
	
		            // Working varialbes
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
	
		            // Computation
		            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
		            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
		            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
		            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
		            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
		            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
		            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
		            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
		            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
		            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
		            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
		            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
		            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
		            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
		            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
		            b = FF(b, c, d, a, M_offset_15, 22, T[15]);
	
		            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
		            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
		            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
		            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
		            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
		            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
		            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
		            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
		            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
		            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
		            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
		            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
		            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
		            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
		            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
		            b = GG(b, c, d, a, M_offset_12, 20, T[31]);
	
		            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
		            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
		            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
		            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
		            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
		            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
		            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
		            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
		            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
		            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
		            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
		            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
		            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
		            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
		            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
		            b = HH(b, c, d, a, M_offset_2,  23, T[47]);
	
		            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
		            d = II(d, a, b, c, M_offset_7,  10, T[49]);
		            c = II(c, d, a, b, M_offset_14, 15, T[50]);
		            b = II(b, c, d, a, M_offset_5,  21, T[51]);
		            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
		            d = II(d, a, b, c, M_offset_3,  10, T[53]);
		            c = II(c, d, a, b, M_offset_10, 15, T[54]);
		            b = II(b, c, d, a, M_offset_1,  21, T[55]);
		            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
		            d = II(d, a, b, c, M_offset_15, 10, T[57]);
		            c = II(c, d, a, b, M_offset_6,  15, T[58]);
		            b = II(b, c, d, a, M_offset_13, 21, T[59]);
		            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
		            d = II(d, a, b, c, M_offset_11, 10, T[61]);
		            c = II(c, d, a, b, M_offset_2,  15, T[62]);
		            b = II(b, c, d, a, M_offset_9,  21, T[63]);
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	
		            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
		            var nBitsTotalL = nBitsTotal;
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
		                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
		            );
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
		            );
	
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    function FF(a, b, c, d, x, s, t) {
		        var n = a + ((b & c) | (~b & d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function GG(a, b, c, d, x, s, t) {
		        var n = a + ((b & d) | (c & ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function HH(a, b, c, d, x, s, t) {
		        var n = a + (b ^ c ^ d) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    function II(a, b, c, d, x, s, t) {
		        var n = a + (c ^ (b | ~d)) + x + t;
		        return ((n << s) | (n >>> (32 - s))) + b;
		    }
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.MD5('message');
		     *     var hash = CryptoJS.MD5(wordArray);
		     */
		    C.MD5 = Hasher._createHelper(MD5);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacMD5(message, key);
		     */
		    C.HmacMD5 = Hasher._createHmacHelper(MD5);
		}(Math));
	
	
		return CryptoJS.MD5;
	
	}));

/***/ },
/* 82 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Col = function Col(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      _ref$node = _ref.node,
	      C = _ref$node === undefined ? 'div' : _ref$node,
	      s = _ref.s,
	      m = _ref.m,
	      l = _ref.l,
	      offset = _ref.offset,
	      other = _objectWithoutProperties(_ref, ['children', 'className', 'node', 's', 'm', 'l', 'offset']);
	
	  var sizes = { s: s, m: m, l: l };
	  var classes = { col: true };
	  _constants2.default.SIZES.forEach(function (size) {
	    classes[size + sizes[size]] = sizes[size];
	  });
	
	  if (offset) {
	    offset.split(' ').forEach(function (off) {
	      classes['offset-' + off] = true;
	    });
	  }
	
	  return _react2.default.createElement(
	    C,
	    _extends({}, other, { className: (0, _classnames2.default)(classes, className) }),
	    children
	  );
	};
	
	Col.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  /**
	   * Columns for large size screens
	   */
	  l: _propTypes2.default.number,
	  /**
	   * Columns for middle size screens
	   */
	  m: _propTypes2.default.number,
	  /**
	   * The node to be used for the column
	   * @default div
	   */
	  node: _propTypes2.default.node,
	  /**
	   * To offset, simply add s2 to the class where s signifies the screen
	   * class-prefix (s = small, m = medium, l = large) and the number after
	   * is the number of columns you want to offset by.
	   */
	  offset: _propTypes2.default.string,
	  /**
	   * Columns for small size screens
	   */
	  s: _propTypes2.default.number
	};
	
	exports.default = Col;

/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resetID = resetID;
	exports.default = idgen;
	var id = 0;
	
	function resetID() {
	  id = 0;
	}
	
	function idgen() {
	  var oldId = id;
	  id += 1;
	  return oldId;
	}

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(793);
	var setInnerHTML = __webpack_require__(122);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(801);
	var setTextContent = __webpack_require__(1019);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1331);
	var ReactInstrumentation = __webpack_require__(43);
	
	var warning = __webpack_require__(19);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var ReactBaseClasses = __webpack_require__(1021);
	var ReactChildren = __webpack_require__(1360);
	var ReactDOMFactories = __webpack_require__(1361);
	var ReactElement = __webpack_require__(89);
	var ReactPropTypes = __webpack_require__(1362);
	var ReactVersion = __webpack_require__(1363);
	
	var createReactClass = __webpack_require__(1364);
	var onlyChild = __webpack_require__(1368);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(55);
	
	var warning = __webpack_require__(19);
	var canDefineProperty = __webpack_require__(1025);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(1023);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classMap;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	
	var AppActions = __webpack_require__(63);
	
	var classMap = (_classMap = {
	  Feed: __webpack_require__(849),
	  Login: __webpack_require__(1121),
	  Settings: __webpack_require__(1143),
	  AddCredit: __webpack_require__(1093),
	  TransactionHistory: __webpack_require__(1149),
	  UseCredit: __webpack_require__(1153),
	  Rewards: __webpack_require__(1138),
	  UseReward: __webpack_require__(1155),
	  Promotions: __webpack_require__(1128),
	  Locations: __webpack_require__(1120),
	  CreateUser: __webpack_require__(1100),
	  SendCredit: __webpack_require__(1141),
	  SendGiftCard: __webpack_require__(1142),
	  AbsorbGiftCard: __webpack_require__(1092),
	  PaymentTypes: __webpack_require__(1125),
	  Gifts: __webpack_require__(1114),
	  DomainLogin: __webpack_require__(1104),
	  CheckIn: __webpack_require__(1098),
	  EarnPoints: __webpack_require__(1106),
	  TransactionScan: __webpack_require__(1151),
	  CreditInput: __webpack_require__(1101),
	  RewardVerify: __webpack_require__(1137),
	  CheckInInput: __webpack_require__(1099),
	  TransactionResult: __webpack_require__(1150),
	  GiftCardAddCredit: __webpack_require__(1111),
	  GiftCardOptions: __webpack_require__(1112),
	  GiftCardUseReward: __webpack_require__(1113),
	  Instagram: __webpack_require__(1117),
	  Facebook: __webpack_require__(1109),
	  Twitter: __webpack_require__(1152),
	  ExternalLink: __webpack_require__(1108),
	  Grabb: __webpack_require__(147), //require('./Grabb.js'),
	  Tutorial: __webpack_require__(848),
	  Booking: __webpack_require__(1097),
	  Passes: __webpack_require__(1124),
	  AddPass: __webpack_require__(1094),
	  UsePass: __webpack_require__(1154),
	  Auphan: __webpack_require__(147), //require('./Auphan.js'),
	  Refunds: __webpack_require__(1136),
	  FeedPlus: __webpack_require__(1110),
	  EarnPay: __webpack_require__(1105),
	  RewardsCampaigns: __webpack_require__(1139),
	  ReferAFriend: __webpack_require__(1135),
	  PhoneNumberVerify: __webpack_require__(1126),
	  PhoneLoyaltyInput: __webpack_require__(847),
	  OrderAhead: __webpack_require__(147),
	  Birthday: __webpack_require__(1096),
	  PassHome: __webpack_require__(1123)
	}, _defineProperty(_classMap, 'PhoneLoyaltyInput', __webpack_require__(847)), _defineProperty(_classMap, 'MyCard', __webpack_require__(1122)), _defineProperty(_classMap, 'SimpleSettings', __webpack_require__(1147)), _defineProperty(_classMap, 'SimpleCreateUser', __webpack_require__(1145)), _defineProperty(_classMap, 'SimpleLogin', __webpack_require__(1146)), _defineProperty(_classMap, 'BasicHome', __webpack_require__(1095)), _defineProperty(_classMap, 'SimpleCFD', __webpack_require__(1144)), _defineProperty(_classMap, 'TermsPreferences', __webpack_require__(1148)), _defineProperty(_classMap, 'ProHome', __webpack_require__(1127)), _classMap);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	
	
	var globalSpace = undefined;
	
	var AnalyticsManager = __webpack_require__(50);
	
	module.exports = {
	  _lastFeatureKeyBuilt: "",
	  featureForData: function featureForData(featureData, initialLayout, appManager, extras) {
	    if (featureData.data.name != this._lastFeatureKeyBuilt) AnalyticsManager.logFeature(featureData.data.title, featureData.data.name);
	
	    this._lastFeatureKeyBuilt = featureData.data.name;
	    var key = featureData.key.split("-")[0];
	    if (key == "Feed" || key == "FeedPlus" || key == "PassHome") {
	      var feedFeatureNames = appManager.getFeedFeatureNames();
	
	      var _dataDependencies = this.dataDependencies(feedFeatureNames),
	          dataDependencies = _dataDependencies.dataDependencies,
	          customDependencies = _dataDependencies.customDependencies,
	          customDependencyKeys = _dataDependencies.customDependencyKeys;
	
	      var ThisClass = classMap[key];
	      var allDependencyKeys = [];
	      if (dataDependencies !== 'undefined') {
	        for (var i = 0; i < dataDependencies.length; i++) {
	          allDependencyKeys.push(dataDependencies[i]);
	        }
	      }
	      if (typeof customDependencyKeys !== 'undefined') {
	        for (var i = 0; i < customDependencyKeys.length; i++) {
	          allDependencyKeys.push(customDependencyKeys[i]);
	        }
	      }
	
	      return React.createElement(ThisClass, {
	        key: key,
	        name: featureData.data.title,
	        initialLayout: initialLayout,
	        featureData: featureData.data,
	        extras: extras,
	        appManager: appManager,
	        appActions: AppActions,
	        dataDependencies: dataDependencies,
	        getCards: this.getCards,
	        dataDependencyRetriever: this.dataDependencies,
	        customDependencies: customDependencies,
	        allDependencyKeys: allDependencyKeys,
	        featureBuilder: this
	      });
	    }
	    if (typeof classMap[key] !== 'undefined') {
	      var ThisClass = classMap[key];
	      var allDependencyKeys = [];
	      for (var i = 0; i < ThisClass.dataDependencies.length; i++) {
	        allDependencyKeys.push(ThisClass.dataDependencies[i]);
	      }
	      if (typeof ThisClass.customDependencyKeys !== 'undefined') {
	        for (var i = 0; i < ThisClass.customDependencyKeys.length; i++) {
	          allDependencyKeys.push(ThisClass.customDependencyKeys[i]);
	        }
	      }
	      return React.createElement(ThisClass, {
	        key: key,
	        name: featureData.data.title,
	        initialLayout: initialLayout,
	        featureData: featureData.data,
	        extras: extras,
	        appManager: appManager,
	        appActions: AppActions,
	        dataDependencies: ThisClass.dataDependencies,
	        customDependencies: typeof ThisClass.customDataDependency !== 'undefined' ? [ThisClass.customDataDependency] : [],
	        allDependencyKeys: allDependencyKeys,
	        featureBuilder: this
	      });
	    }
	  },
	
	  backOverrideForFeatureData: function backOverrideForFeatureData(featureData) {
	    var key = featureData.key.split("-")[0];
	    if (typeof classMap[key] !== 'undefined') {
	      var ThisClass = classMap[key];
	      if (typeof ThisClass.backOverride !== 'undefined') {
	        return ThisClass.backOverride;
	      }
	    }
	    return null;
	  },
	
	  dataDependencies: function dataDependencies(featureNames) {
	    var reupDataDependencies = [];
	    var customDataDependencies = [];
	    var customDependencyKeys = [];
	    for (var i = 0; i < featureNames.length; i++) {
	      var featureName = featureNames[i];
	      if (typeof classMap[featureName] !== 'undefined') {
	        var ThisClass = classMap[featureName];
	        if (typeof ThisClass.dataDependencies !== 'undefined') {
	          var theseDependencies = ThisClass.dataDependencies;
	          for (var thisDependencyKey in theseDependencies) {
	            var thisDependency = theseDependencies[thisDependencyKey];
	            var alreadyHadDependency = false;
	            for (var dataDependencyKey in reupDataDependencies) {
	              var dataDependency = reupDataDependencies[dataDependencyKey];
	              if (thisDependency == dataDependency) {
	                alreadyHadDependency = true;
	                break;
	              }
	            }
	            if (!alreadyHadDependency) reupDataDependencies.push(thisDependency);
	          }
	
	          if (typeof ThisClass.customDataDependency !== 'undefined') {
	            customDataDependencies.push(ThisClass.customDataDependency);
	          }
	
	          if (typeof ThisClass.customDependencyKeys !== 'undefined') {
	            for (var j = 0; j < ThisClass.customDependencyKeys.length; j++) {
	              customDependencyKeys.push(ThisClass.customDependencyKeys[j]);
	            }
	          }
	        }
	      }
	    }
	
	    return { customDependencies: customDataDependencies, dataDependencies: reupDataDependencies, customDependencyKeys: customDependencyKeys };
	  },
	
	  getCards: function getCards(featureNames, appManager, appActions, data, feedFeatures) {
	    var cards = [];
	
	    if (typeof feedFeatures === 'undefined' && typeof appManager !== 'undefined') feedFeatures = appManager.getFeedFeatures();
	
	    // ensure objects are sorted
	    if (typeof data.Transactions !== 'undefined' && data.Transactions != null) {
	      data.Transactions = data.Transactions.sort(function (a, b) {
	        return appManager.getTime(a.Timestamp) - appManager.getTime(b.Timestamp);
	      });
	    }
	    if (typeof data.Rewards !== 'undefined' && data.Rewards != null) {
	      data.Rewards = data.Rewards.sort(function (a, b) {
	        return a.Cost - b.Cost;
	      });
	    }
	
	    for (var i = 0; i < featureNames.length; i++) {
	      var featureName = featureNames[i];
	      var FeatureClass = classMap[featureName.split('-')[0]];
	      if (typeof FeatureClass !== 'undefined' && typeof FeatureClass.getCards !== 'undefined') {
	        var featureData = appManager.getFeatureForName(featureName);
	        try {
	          var theseCards = FeatureClass.getCards(featureData, appActions, typeof data === 'undefined' ? {} : data);
	          for (var j = 0; j < theseCards.length; j++) {
	            var thisCard = theseCards[j];
	            thisCard.key = featureName + j;
	            cards.push(thisCard);
	          }
	        } catch (e) {
	          console.log("Failed to get cards for " + featureName, e);
	        } finally {}
	      }
	    }
	
	    return cards.sort(function (a, b) {
	      return a.sortOrder - b.sortOrder;
	    });
	  },
	
	  featureCustomNavigation: function featureCustomNavigation(featureData, appActions, layout, extras) {
	    var key = featureData.key.split("-")[0];
	    var ThisClass = classMap[key];
	    if (typeof ThisClass !== 'undefined' && typeof ThisClass.customNavigation !== 'undefined') {
	      ThisClass.customNavigation(featureData, appActions, this, layout, extras);
	      return true;
	    }
	    return false;
	  }
	};

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Animated = ReactNative.Animated,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Meter = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      outerColor: 'red',
	      innerColor: 'blue',
	      height: 20,
	      initialPercent: 0,
	      flexResolution: 100
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var flexPositive = Math.round(this.props.flexResolution * Math.min(this.props.initialPercent, 1));
	    var flexNegative = this.props.flexResolution - flexPositive;
	    return {
	      flexPositive: new Animated.Value(flexPositive),
	      flexNegative: new Animated.Value(flexNegative)
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.initialPercent !== 'undefined' && newProps.initialPercent != this.props.initialPercent) {
	      var flexPositive = Math.round(this.props.flexResolution * Math.min(newProps.initialPercent, 1));
	      var flexNegative = this.props.flexResolution - flexPositive;
	
	      this.setState({
	        flexPositive: new Animated.Value(flexPositive),
	        flexNegative: new Animated.Value(flexNegative)
	      });
	    }
	  },
	
	  render: function render() {
	    var outerRad = this.props.height / 2;
	    var innerRad = outerRad - 1;
	    return React.createElement(
	      View,
	      { key: 'outerMeter', style: [styles.meterContainer, { backgroundColor: this.props.outerColor, borderRadius: outerRad, height: this.props.height }, this.props.style] },
	      React.createElement(View, { style: { width: innerRad * 2, borderRadius: innerRad, backgroundColor: this.props.innerColor } }),
	      React.createElement(Animated.View, { key: 'innerMeter', style: [{ marginLeft: -innerRad, backgroundColor: this.props.innerColor, flex: this.state.flexPositive }] }),
	      React.createElement(
	        View,
	        { style: { width: innerRad * 2, borderRadius: innerRad, marginLeft: -innerRad, backgroundColor: this.props.innerColor, alignItems: 'center', justifyContent: 'center' } },
	        this.props.children
	      ),
	      React.createElement(Animated.View, { key: 'negativeMeter', style: [{ flex: this.state.flexNegative, borderRadius: innerRad }] })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  // meter
	  meterContainer: {
	    flexDirection: 'row',
	    padding: 1
	  }
	});
	
	module.exports = Meter;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var ReUpPhoneNumberInput = __webpack_require__(1132);
	var PlatformConstants = __webpack_require__(31);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var NumericalInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      previewStyle: {},
	      valueChanged: function valueChanged(newValue, newStringValue) {},
	      isDollars: false,
	      isCheckin: false,
	      appManager: null,
	      dollarsPerPoint: 1,
	      displayPoints: false,
	      isPhoneNumber: false,
	      isDisplayingPin: false,
	      checkPinError: function checkPinError() {
	        return false;
	      },
	      checkPinSuccess: function checkPinSuccess() {
	        return false;
	      },
	      maxLength: 4,
	      initialValue: "",
	      inputTextColor: null,
	      isInError: false,
	      phoneLocales: null
	
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      value: this.props.isPhoneNumber ? this.props.initialValue : this.props.isDisplayingPin ? "" : 0,
	      predictedValue: ""
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  setPhoneLocales: function setPhoneLocales(phoneLocales) {
	    // if( JSON.stringify(phoneLocales) != JSON.stringify(this.state.phoneLocales) ) this.setState({phoneLocales});
	  },
	
	  doTransaction: function doTransaction() {
	    this.props.appActions.requestFeatureName("TransactionResult");
	  },
	
	  numSelected: function numSelected(i) {
	    var thisThing = this;
	    if (this.props.isDisplayingPin) {
	      var newValue = this.state.value + "" + i;
	      var isSuccess = this.props.checkPinSuccess(newValue);
	      if (newValue.length <= this.props.maxLength) {
	        this.valueChanged(newValue);
	        this.setState({ value: newValue });
	        if (isSuccess) {
	          setTimeout(function () {
	            thisThing.props.didSucceed();
	          }, 500);
	        }
	      }
	    } else if (this.props.isPhoneNumber) {
	      var newValue = this.strippedPhoneNumber(this.state.value) + "" + i;
	      var stringPhoneValue = this.stringPhoneValue(newValue);
	      // this.valueChanged(stringPhoneValue);
	      this._phoneInput.setPhoneNumber(stringPhoneValue);
	      this.setState({ value: stringPhoneValue });
	    } else {
	      var newValue = this.state.value * 10 + i;
	      if (this.props.displayPoints && this.stringPointValue(newValue).length > 10) return;
	      if (this.stringDollarValue(newValue).length > 11) return; // some sort of max
	      this.valueChanged(newValue);
	
	      this.setState({ value: newValue });
	    }
	  },
	
	  deleteSelected: function deleteSelected() {
	    if (this.props.isDisplayingPin) {
	      if (this.state.value.length <= 0) return;
	
	      var newValue = this.state.value.substring(0, this.state.value.length - 1);
	      this.valueChanged(newValue);
	      this.setState({ value: newValue });
	    } else if (this.props.isPhoneNumber) {
	      if (this.state.value.length <= 0) return;
	
	      var newValue = this.strippedPhoneNumber(this.state.value);
	      if (newValue.length > 0) newValue = newValue.substring(0, newValue.length - 1);
	      newValue = this.stringPhoneValue(newValue);
	      this._phoneInput.setPhoneNumber(newValue);
	      this.valueChanged(newValue);
	      this.setState({ value: newValue });
	    } else {
	      var newValue = Math.floor(this.state.value / 10);
	      this.valueChanged(newValue);
	      this.setState({ value: newValue });
	    }
	  },
	
	  stringDollarValue: function stringDollarValue(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	
	    return this.props.appManager.getLocalizationManager().localizedDollars(parseFloat(value) / 100);
	  },
	
	  stringPointValue: function stringPointValue(value) {
	    value = this.pointsAmount(value);
	
	    var points = this.props.appManager.getLocalizationManager().localizedPoints(value);
	    if (points.length > 10) {
	      points = this.props.appManager.getLocalizationManager().localizedPts(value);
	    }
	
	    return points;
	  },
	
	  stringPhoneValue: function stringPhoneValue(value) {
	    // Kelsey, TODO: need to add formatting back at some point
	    return value;
	
	    if (typeof value === 'undefined') value = this.state.value;
	
	    var strippedValue = this.strippedPhoneNumber(value);
	    while (strippedValue.length < 11) {
	      strippedValue += ' ';
	    }return strippedValue.substring(0, 1) + "(" + strippedValue.substring(1, 4) + ")" + strippedValue.substring(4, 7) + "-" + strippedValue.substring(7, 11);
	  },
	
	  strippedPhoneNumber: function strippedPhoneNumber(phoneNumber) {
	    if (typeof phoneNumber === 'undefined') phoneNumber = this.state.value;
	
	    return phoneNumber.replace("-", "").replace("(", "").replace(")", "").replace(/ /g, "");
	  },
	
	  stringPinValue: function stringPinValue(value) {
	    var starredOutput = "";
	    if (typeof value === 'undefined') value = this.state.value;
	
	    for (var i = 0; i < value.length; i++) {
	      starredOutput += "*";
	    }return starredOutput;
	  },
	
	  stringValue: function stringValue(value) {
	    if (this.props.isDollars) {
	      return this.stringDollarValue(value);
	    } else if (this.props.isPhoneNumber) {
	      return this.stringPointValue(value);
	    } else {
	      return this.stringPointValue(value);
	    }
	  },
	
	  clearSelected: function clearSelected() {
	    if (this.props.isDisplayingPin) {
	      if (this.state.value.length <= 0) return;
	
	      var newValue = "";
	      this.valueChanged(newValue);
	      this.setState({ value: newValue });
	    } else if (this.props.isPhoneNumber) {
	      var newValue = this.stringPhoneValue(this.props.initialValue);
	      this._phoneInput.setPhoneNumber(newValue);
	      // this.valueChanged(this._phoneInput.getCountryCode() + newValue);
	
	      this.setState({ value: newValue });
	    } else {
	      var newValue = 0;
	      this.valueChanged(newValue);
	
	      this.setState({ value: newValue });
	    }
	  },
	
	  valueChanged: function valueChanged(newValue) {
	    if (this.props.isDollars) {
	      this.props.valueChanged(newValue, this.stringValue(newValue));
	    } else if (this.props.isCheckin) {
	      this.props.valueChanged(newValue, this.stringPointValue(newValue));
	    } else {
	      this.props.valueChanged(newValue);
	    }
	  },
	
	  pointsAmount: function pointsAmount(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	    if (this.props.displayPoints) return Math.floor(value);
	
	    return Math.floor(value / (100 * this.props.dollarsPerPoint));
	  },
	
	  dollarsAmount: function dollarsAmount(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	
	    return parseFloat(value) / 100;
	  },
	
	  phoneNumber: function phoneNumber(value) {},
	
	  setPredictedValue: function setPredictedValue(predictedValue) {
	    this.setState({ predictedValue: predictedValue });
	  },
	
	  phoneNumberChanged: function phoneNumberChanged(countryCode, phoneNumber) {
	    this.props.valueChanged(phoneNumber);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	
	    var locManager = appManager.getLocalizationManager();
	    var rowStyle = { flexDirection: 'row', flex: 1 };
	    var numSelected = thisThing.numSelected;
	    var clearSelected = thisThing.clearSelected;
	    var deleteSelected = thisThing.deleteSelected;
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var generalTitleColorAlphaed = appManager.getColorForKey("GeneralTitleColor", .6);
	    var buttonStyle = { flex: 1, margin: 4, height: -1 };
	    var inputTextColor = this.props.inputTextColor == null ? appManager.getColorForKey("GeneralTitleColor") : this.props.inputTextColor;
	
	    var isInError = false;
	    if (this.props.isDisplayingPin) isInError = this.props.checkPinError(this.state.value);
	    var monospaceFontFamily = 'CourierNewPS-BoldMT';
	    if (Platform.OS != 'ios') monospaceFontFamily = 'monospace';
	
	    return React.createElement(
	      View,
	      { style: [this.props.style, { flexDirection: 'column', marginTop: 6, marginBottom: 6 }] },
	      this.props.isDisplayingPin ? React.createElement(
	        View,
	        { style: rowStyle },
	        React.createElement(ReUpButton, { useShadow: false, fontSize: 24, onPress: function onPress() {
	            deleteSelected();
	          }, appManager: appManager, isSecondary: true, text: locManager.localizedStringForKey("NUMERICAL_INPUT_DELETE"), style: buttonStyle }),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', flex: 2, fontSize: 28, margin: 4, padding: 10, justifyContent: 'center', alignItems: 'flex-end', borderWidth: 2, borderStyle: 'solid', borderRadius: 4, borderColor: generalTitleColorAlphaed, backgroundColor: isInError ? 'red' : 'transparent' } },
	          React.createElement(
	            Text,
	            { style: { fontSize: 28, fontFamily: monospaceFontFamily, color: inputTextColor } },
	            this.stringPinValue()
	          )
	        )
	      ) : React.createElement(
	        View,
	        { style: rowStyle },
	        this.props.isPhoneNumber ? React.createElement(
	          View,
	          { style: [{ flexDirection: 'column', flex: 5, justifyContent: 'center', alignItems: 'center' }, this.props.previewStyle] },
	          React.createElement(ReUpPhoneNumberInput, { ref: function ref(a) {
	              return _this._phoneInput = a;
	            }, appManager: appManager,
	            isInError: this.props.isInError,
	            phoneLocales: this.props.phoneLocales, style: { alignSelf: 'stretch' },
	            phoneNumberChanged: function phoneNumberChanged(countryCode, newPhoneNumber) {
	              thisThing.phoneNumberChanged(countryCode, newPhoneNumber);
	            } })
	        ) : React.createElement(
	          View,
	          { style: [{ flexDirection: 'column', flex: 2, margin: 4, padding: 10, justifyContent: 'center', alignItems: this.props.isPhoneNumber ? 'center' : 'flex-end', borderWidth: 2, borderStyle: 'solid', borderRadius: 4, borderColor: generalTitleColorAlphaed }, this.props.previewStyle] },
	          React.createElement(
	            View,
	            { style: { position: 'absolute', opacity: .4, top: 0, left: 0, bottom: 0, right: 0, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(
	              Text,
	              { style: { fontSize: 24, fontFamily: monospaceFontFamily, color: inputTextColor } },
	              this.state.predictedValue
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { backgroundColor: 'transparent', position: 'absolute', top: 0, left: 0, bottom: 0, right: 0, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(
	              Text,
	              { style: { backgroundColor: 'transparent', fontSize: 24, fontFamily: monospaceFontFamily, color: inputTextColor } },
	              this.props.isPhoneNumber ? this.stringPhoneValue() : this.props.displayPoints ? this.stringPointValue() : this.stringDollarValue()
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({});
	
	NumericalInput.dataDependencies = ["PhoneLocales"];
	
	module.exports = NumericalInput;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var Animated = __webpack_require__(9);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var OFFSET_VIEW_SCROLL_TIMING = 400;
	
	var OffsetView = createReactClass({
	  displayName: 'OffsetView',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      horizontal: false,
	      style: {},
	      children: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      offsetX: new Animated.Value(0),
	      offsetY: new Animated.Value(0)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {},
	
	  _completion: null,
	  scrollTo: function scrollTo(info) {
	    var animated = typeof info.animated !== 'undefined' ? info.animated : false;
	    var offsetX = typeof info.x !== 'undefined' ? -info.x : null;
	    var offsetY = typeof info.y !== 'undefined' ? -info.y : null;
	    if (typeof info.completion !== 'undefined') this._completion = info.completion;else this._completion = null;
	
	    var duration = OFFSET_VIEW_SCROLL_TIMING;
	    if (animated !== false && animated !== true) duration = animated;
	
	    var thisThing = this;
	    if (animated) {
	      if (offsetX != null) {
	        Animated.timing(this.state.offsetX, {
	          toValue: offsetX,
	          duration: duration
	        }).start(function () {
	          if (thisThing._completion) thisThing._completion();
	        });
	      }
	      if (offsetY != null) {
	        Animated.timing(this.state.offsetY, {
	          toValue: offsetY,
	          duration: duration
	        }).start(function () {
	          if (thisThing._completion) thisThing._completion();
	        });
	      }
	    } else {
	      var newState = {};
	      if (offsetX != null) {
	        newState.offsetX = new Animated.Value(offsetX);
	        newState.offsetX.addListener(this.offsetXChanged);
	        Animated.timing(newState.offsetX, {
	          toValue: offsetX,
	          duration: 1
	        }).start(function () {
	          if (thisThing._completion) thisThing._completion();
	        });
	      }
	      if (offsetY != null) {
	        newState.offsetY = new Animated.Value(offsetY);
	        newState.offsetY.addListener(this.offsetYChanged);
	        Animated.timing(newState.offsetY, {
	          toValue: offsetY,
	          duration: 1
	        }).start(function () {
	          if (thisThing._completion) thisThing._completion();
	        });
	      }
	      this.props.onScroll({
	        nativeEvent: {
	          contentOffset: {
	            x: offsetX != null ? -offsetX : -this.state.offsetX.getValue(),
	            y: offsetY != null ? -offsetY : -this.state.offsetY.getValue()
	          }
	        }
	      });
	      this.setState(newState);
	    }
	  },
	
	  offsetYChanged: function offsetYChanged(_ref) {
	    var value = _ref.value;
	
	    this.props.onScroll({
	      nativeEvent: {
	        contentOffset: {
	          x: -this.state.offsetX.getValue(),
	          y: -this.state.offsetY.getValue()
	        }
	      }
	    });
	  },
	
	  offsetXChanged: function offsetXChanged(_ref2) {
	    var value = _ref2.value;
	
	    this.props.onScroll({
	      nativeEvent: {
	        contentOffset: {
	          x: -this.state.offsetX.getValue(),
	          y: -this.state.offsetY.getValue()
	        }
	      }
	    });
	  },
	
	  render: function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        style = _props.style,
	        children = _props.children;
	
	    var otherProps = {};
	    for (var key in this.props) {
	      if (key != 'horizontal' && key != 'style' && key != 'children') {
	        otherProps[key] = this.props[key];
	      }
	    }
	    style = StyleSheet.flatten(style);
	
	    return React.createElement(
	      View,
	      Object.assign({ style: style }, otherProps),
	      React.createElement(
	        Animated.View,
	        { style: { position: 'absolute', top: this.state.offsetY, left: this.state.offsetX, flex: -1, flexDirection: horizontal ? "row" : "column" } },
	        this.props.children
	      )
	    );
	  }
	});
	
	module.exports = OffsetView;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    NativeModules = ReactNative.NativeModules,
	    StyleSheet = ReactNative.StyleSheet;
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var PlatformConstants = __webpack_require__(31);
	var RNPayPalManager = NativeModules.RNPayPalManager;
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	
	var PRICE_BUTTON_WIDTH = 120;
	
	function cardTypeForNumber(cardNumber) {
	  if (cardNumber.length < 2) return -1;
	
	  var range = parseInt(cardNumber.substring(0, 2));
	
	  if (range >= 40 && range <= 49) {
	    return 1; //PKCardTypeVisa;
	  } else if (range >= 50 && range <= 59) {
	    return 2; //PKCardTypeMasterCard;
	  } else if (range == 34 || range == 37) {
	    return 3; //PKCardTypeAmex;
	  } else if (range == 60 || range == 62 || range == 64 || range == 65) {
	    return 4; //PKCardTypeDiscover;
	  } else if (range == 35) {
	    return 5; //PKCardTypeJCB;
	  } else if (range == 30 || range == 36 || range == 38 || range == 39) {
	    return 6; //PKCardTypeDinersClub;
	  } else {
	    return -1;
	  }
	}
	
	function cardNumberIsValidLength(cardNumber) {
	  var cardType = cardTypeForNumber(cardNumber);
	
	  return cardNumber.length >= validLengthForCardType(cardType);
	}
	
	function validLengthForCardType(cardType) {
	  if (cardType == 3) // amex
	    {
	      return 15;
	    } else {
	    return 16;
	  }
	}
	
	function iconNameForCardType(cardType) {
	  if (cardType == 1) {
	    return "cc-visa"; //PKCardTypeVisa;
	  } else if (cardType == 2) {
	    return "cc-mastercard"; //PKCardTypeMasterCard;
	  } else if (cardType == 3) {
	    return "cc-amex"; //PKCardTypeAmex;
	  } else if (cardType == 4) {
	    return "cc-discover"; //PKCardTypeDiscover;
	  } else if (cardType == 5) {
	    return "cc-jcb"; //PKCardTypeJCB;
	  } else if (cardType == 6) {
	    return "cc-diners-club"; //PKCardTypeDinersClub;
	  } else {
	    return "credit-card";
	  }
	}
	
	var PaymentMethodChooserView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      appActions: null,
	      paymentInfo: [],
	      enableEdit: true,
	      useSmall: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return this.props;
	  },
	
	  _didRetriveClientMetadataIDListener: null,
	  _clientMetadataID: null,
	  componentDidMount: function componentDidMount() {
	    if (RNPayPalManager) RNPayPalManager.retrieveClientMetadataID();
	    var thisThing = this;
	    if (Platform.OS == 'ios') {
	      this._didRetriveClientMetadataIDListener = NativeAppEventEmitter.addListener('didRetriveClientMetadataID', function (evt) {
	        thisThing._clientMetadataID = evt.clientMetadataID;
	      });
	    } else {
	      if (DeviceEventEmitter) {
	        this._didRetriveClientMetadataIDListener = DeviceEventEmitter.addListener('didRetriveClientMetadataID', function (evt) {
	          thisThing._clientMetadataID = evt.clientMetadataID;
	        });
	      }
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._didRetriveClientMetadataIDListener != null) this._didRetriveClientMetadataIDListener.remove();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    // RNPayPalManager.retrieveClientMetadataID();
	    this.setState(newProps);
	  },
	
	  getPrimaryPaymentMethod: function getPrimaryPaymentMethod() {
	    if (this.state.paymentInfo.length <= 0) return null;
	
	    for (var i = 0; i < this.state.paymentInfo.length; i++) {
	      var info = this.state.paymentInfo[i];
	      if (info.isPrimary) {
	        if (this.methodIsPayPal(info)) info.clientMetadataID = this.getClientMetadataID();
	        return info;
	      }
	    }
	
	    return null;
	  },
	
	  methodIsPayPal: function methodIsPayPal(method) {
	    return method != null && typeof method.sourceType !== 'undefined' && method.sourceType == 'pp';
	  },
	
	  getClientMetadataID: function getClientMetadataID() {
	    return this._clientMetadataID;
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var appActions = this.props.appActions;
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var currentMethod = this.getPrimaryPaymentMethod();
	    var isPayPal = this.methodIsPayPal(currentMethod);
	
	    if (this.props.useSmall) {
	      var cardText = null;
	      if (currentMethod != null) cardText = "**** **** **** " + currentMethod.last4;
	
	      return React.createElement(
	        View,
	        { style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center' } },
	        isPayPal ? React.createElement(
	          MKButton,
	          { disabled: !this.props.enableEdit, onPress: function onPress() {
	              appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	            },
	            style: { height: 50, flex: 1, flexDirection: 'row', alignItems: 'center' } },
	          React.createElement(Image, { resizeMode: Image.resizeMode.contain, source: { uri: PlatformConstants.packagedResourcesDirectory + '/App/paypal.png' }, style: { backgroundColor: 'transparent', height: 40, width: 120 } }),
	          React.createElement(
	            View,
	            { style: { flex: 1, alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { disabled: !this.props.enableEdit, appManager: appManager, style: {
	                  margin: 4,
	                  textAlign: 'center',
	                  opacity: .6
	                }, numberOfLines: 1 },
	              currentMethod.username
	            )
	          )
	        ) : currentMethod != null ? React.createElement(
	          MKButton,
	          { disabled: !this.props.enableEdit, onPress: function onPress() {
	              appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	            },
	            style: { height: 50, flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(_ReUpIcon2.default, { style: styles.creditCardIcon, name: iconNameForCardType(currentMethod.cardType), size: 26, color: generalTitleColor }),
	          React.createElement(
	            View,
	            { style: { flex: -1, flexDirection: 'row' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: {
	                  margin: 4,
	                  flex: -1,
	                  textAlign: 'center',
	                  opacity: .8
	                } },
	              currentMethod.last4
	            )
	          )
	        ) : React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: locManager.localizedStringForKey("SET_PAYMENT_TYPE_BUTTON"),
	          onPress: function onPress() {
	            appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	          } })
	      );
	    }
	
	    var cardText = null;
	    if (currentMethod != null) cardText = "**** **** **** " + currentMethod.last4;
	
	    var currentMethodProps = {};
	    if (this.props.enableEdit) currentMethodProps.icon = "pencil";
	
	    return React.createElement(
	      View,
	      { key: currentMethod != null ? "0" : "1", style: [styles.oldCardContainer, { backgroundColor: currentMethod != null ? generalColor : "transparent", borderRadius: 4, paddingHorizontal: 10, height: 50 }, this.props.style] },
	      isPayPal ? React.createElement(
	        ReUpButton,
	        Object.assign({ disabled: !this.props.enableEdit, appManager: appManager, isTertiary: true, iconColor: 'black', style: [{
	            flex: 1,
	            alignItems: 'stretch',
	            borderRadius: 2
	          }, { backgroundColor: 'transparent', paddingTop: 0 }],
	          onPress: function onPress() {
	            appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	          },
	          text: currentMethod.username
	        }, currentMethodProps),
	        React.createElement(
	          View,
	          null,
	          React.createElement(Image, { resizeMode: Image.resizeMode.contain, source: { uri: PlatformConstants.packagedResourcesDirectory + '/App/paypal.png' }, style: { backgroundColor: 'transparent', height: 30, width: 90 } })
	        )
	      ) : currentMethod != null ? React.createElement(
	        ReUpButton,
	        Object.assign({ disabled: !this.props.enableEdit, appManager: appManager, isTertiary: true, iconColor: 'black', style: [{
	            flex: 1,
	            alignItems: 'stretch',
	            borderRadius: 2
	          }, { backgroundColor: 'transparent', paddingTop: 0 }],
	          onPress: function onPress() {
	            appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	          },
	          text: cardText
	        }, currentMethodProps),
	        React.createElement(
	          View,
	          null,
	          React.createElement(_ReUpIcon2.default, { style: styles.creditCardIcon, name: iconNameForCardType(currentMethod.cardType), size: 26, color: generalTitleColor })
	        )
	      ) : React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: locManager.localizedStringForKey("SET_PAYMENT_TYPE_BUTTON"),
	        onPress: function onPress() {
	          appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	        } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  oldCardContainer: {
	    flexDirection: 'row',
	    // margin:10,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    width: 50,
	    justifyContent: 'center',
	    textAlign: 'center',
	    margin: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    margin: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    fontSize: 30,
	    backgroundColor: 'transparent'
	  },
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    paddingHorizontal: 10
	    // marginRight:10,
	    // marginLeft:10,
	  }
	});
	
	module.exports = PaymentMethodChooserView;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var JSQR = __webpack_require__(1236);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    InteractionManager = ReactNative.InteractionManager,
	    StyleSheet = ReactNative.StyleSheet;
	
	// var RNQRCodeView = require('react-native-qrcode-view');
	
	var QRCodeView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      data: "",
	      positiveColor: 'black',
	      negativeColor: 'white',
	      dimension: 200,
	      spinnerView: React.createElement(View, null)
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      qrRendered: React.createElement(
	        View,
	        { style: [styles.container, { margin: 10, width: this.props.dimension, height: this.props.dimension, justifyContent: 'center' }] },
	        this.props.spinnerView
	      )
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.data.length > 0) {
	      this.setData(this.props.data);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var shouldRerender = typeof newProps.dimension !== 'undefined' && newProps.dimension != this._dimension;
	    if (typeof newProps.data !== 'undefined' && newProps.data.length > 0 && newProps.data != this._data) {
	      this._data = newProps.data;
	      shouldRerender = true;
	    }
	    if (shouldRerender) {
	      this._dimension = newProps.dimension;
	      var qrcode = new JSQR.QrCode(this._data);
	      var matrix = qrcode.getData();
	      var blockDim = Math.floor(newProps.dimension / matrix.length);
	      var posCol = this.props.positiveColor;
	      var negCol = this.props.negativeColor;
	      var startIndex = -1;
	      this.renderQRCode(matrix, blockDim, posCol, negCol, startIndex);
	    }
	  },
	
	  _data: "",
	  _hasRendered: false,
	  _dimension: -1,
	  setData: function setData(newData) {
	    if (this._dimension < 0) this._dimension = this.props.dimension;
	    if (newData == this._data) return;
	
	    this._data = newData;
	    this.setState({ qrRendered: React.createElement(
	        View,
	        { style: [styles.container, { width: this._dimension, height: this._dimension, margin: 10, padding: 0, justifyContent: 'center' }] },
	        this.props.spinnerView
	      ) });
	
	    var thisThing = this;
	    thisThing._hasRendered = false;
	    InteractionManager.runAfterInteractions(function () {
	      var qrcode = new JSQR.QrCode(thisThing._data);
	      var matrix = qrcode.getData();
	      var blockDim = Math.floor(thisThing._dimension / matrix.length);
	      var posCol = thisThing.props.positiveColor;
	      var negCol = thisThing.props.negativeColor;
	
	      var startIndex = -1;
	      thisThing.renderQRCode(matrix, blockDim, posCol, negCol, startIndex);
	    });
	    setTimeout(function () {
	      if (!thisThing._hasRendered) {
	        var qrcode = new JSQR.QrCode(thisThing._data);
	        var matrix = qrcode.getData();
	        var blockDim = Math.floor(thisThing._dimension / matrix.length);
	        var posCol = thisThing.props.positiveColor;
	        var negCol = thisThing.props.negativeColor;
	        var startIndex = -1;
	        thisThing.renderQRCode(matrix, blockDim, posCol, negCol, startIndex);
	      }
	    }, 400);
	  },
	
	  renderQRCode: function renderQRCode(matrix, blockDim, posCol, negCol, startIndex) {
	    var thisThing = this;
	    this._hasRendered = true;
	
	    var blocksSize = matrix.length > 0 ? matrix.length * blockDim : 0;
	    var blocks = [];
	    for (var i = 0; i < matrix.length; i++) {
	      var row = matrix[i];
	      var startIndex = -1;
	      for (var j = 0; j < row.length; j++) {
	        var value = row[j];
	        if (value == "1") {
	          if (startIndex < 0) {
	            startIndex = j;
	          }
	        } else if (value == "0") {
	          if (startIndex >= 0) {
	            blocks.push(React.createElement(View, { style: { position: 'absolute', top: i * blockDim, left: blockDim * startIndex, width: blockDim * (j - startIndex), height: blockDim, backgroundColor: posCol } }));
	            startIndex = -1;
	          }
	        }
	      }
	      if (startIndex >= 0) {
	        blocks.push(React.createElement(View, { style: { position: 'absolute', top: i * blockDim, left: blockDim * startIndex, width: blockDim * (j - startIndex), height: blockDim, backgroundColor: posCol } }));
	      }
	    }
	
	    var qrRendered = React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: negCol, width: this._dimension + 20, height: this._dimension + 20, justifyContent: 'center', alignItems: 'center' }] },
	      React.createElement(
	        View,
	        { style: { flex: -1, alignSelf: 'center', width: blocksSize, height: blocksSize } },
	        blocks
	      )
	    );
	
	    thisThing.setState({ qrRendered: qrRendered });
	  },
	
	  render: function render() {
	    return React.createElement(
	      View,
	      { ref: 'container', style: this.props.style },
	      this.state.qrRendered
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  row: {
	    flexDirection: 'row'
	  },
	  block: {},
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  }
	});
	
	module.exports = QRCodeView;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNative = __webpack_require__(4);
	
	if (_reactNative.Platform.OS === 'web') {
	  module.exports = {
	    readFile: function readFile(url) {
	      return fetch(url, {
	        method: 'get'
	      }).then(function (response) {
	        return response.text();
	      }).then(function (responseText) {
	        return responseText;
	      });
	    },
	    writeFile: function writeFile() {
	      return Promise.resolve({});
	    },
	    mkdir: function mkdir() {
	      return Promise.resolve({});
	    },
	    readDir: function readDir() {
	      return Promise.resolve({});
	    },
	    exists: function exists(imageSrc) {
	      var callback = null;
	      var result = {
	        then: function then(newCallback) {
	          callback = newCallback;
	        }
	      };
	      var img = new Image();
	      img.onload = function () {
	        if (callback != null) callback(true);
	      };
	      img.onerror = function () {
	        if (callback != null) callback(false);
	      };
	      img.src = imageSrc;
	
	      return result;
	    },
	    unlink: function unlink() {}
	  };
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var ParallaxScrollView = createReactClass({
	  displayName: 'ParallaxScrollView',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	module.exports = { ParallaxScrollView: ParallaxScrollView };

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer))

/***/ },
/* 99 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventPluginRegistry = __webpack_require__(794);
	var EventPluginUtils = __webpack_require__(795);
	var ReactErrorUtils = __webpack_require__(799);
	
	var accumulateInto = __webpack_require__(1012);
	var forEachAccumulated = __webpack_require__(1013);
	var invariant = __webpack_require__(7);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(100);
	var EventPluginUtils = __webpack_require__(795);
	
	var accumulateInto = __webpack_require__(1012);
	var forEachAccumulated = __webpack_require__(1013);
	var warning = __webpack_require__(19);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	var getEventTarget = __webpack_require__(804);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 104 */
23,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.default = dismissKeyboard;
	
	var _reactNative = __webpack_require__(4);
	
	var TextInputState = _reactNative.TextInput.State;
	
	function dismissKeyboard() {
	  TextInputState.blurTextInput(TextInputState.currentlyFocusedField());
	}
	
	module.exports = exports.default;

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var Platform = {
	  OS: 'web',
	  select: function select(obj) {
	    return 'web' in obj ? obj.web : obj.default;
	  }
	};
	
	exports.default = Platform;
	module.exports = exports['default'];

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _dismissKeyboard = __webpack_require__(1054);
	
	var _dismissKeyboard2 = _interopRequireDefault(_dismissKeyboard);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ScrollResponder = __webpack_require__(1050);
	
	var _ScrollResponder2 = _interopRequireDefault(_ScrollResponder);
	
	var _ScrollViewBase = __webpack_require__(1414);
	
	var _ScrollViewBase2 = _interopRequireDefault(_ScrollViewBase);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                              * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @noflow
	                                                                                                                                                                                                                              */
	
	var emptyObject = {};
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var ScrollView = (0, _createReactClass2.default)({
	  displayName: 'ScrollView',
	
	  propTypes: Object.assign({}, _ViewPropTypes2.default, {
	    contentContainerStyle: _ViewPropTypes2.default.style,
	    horizontal: _propTypes.bool,
	    keyboardDismissMode: (0, _propTypes.oneOf)(['none', 'interactive', 'on-drag']),
	    onContentSizeChange: _propTypes.func,
	    onScroll: _propTypes.func,
	    pagingEnabled: _propTypes.bool,
	    refreshControl: _propTypes.element,
	    scrollEnabled: _propTypes.bool,
	    scrollEventThrottle: _propTypes.number,
	    stickyHeaderIndices: (0, _propTypes.arrayOf)(_propTypes.number),
	    style: _ViewPropTypes2.default.style
	  }),
	
	  mixins: [_ScrollResponder2.default.Mixin],
	
	  getInitialState: function getInitialState() {
	    return this.scrollResponderMixinGetInitialState();
	  },
	  flashScrollIndicators: function flashScrollIndicators() {
	    this.scrollResponderFlashScrollIndicators();
	  },
	  setNativeProps: function setNativeProps(props) {
	    if (this._scrollViewRef) {
	      this._scrollViewRef.setNativeProps(props);
	    }
	  },
	
	
	  /**
	   * Returns a reference to the underlying scroll responder, which supports
	   * operations like `scrollTo`. All ScrollView-like components should
	   * implement this method so that they can be composed while providing access
	   * to the underlying scroll responder's methods.
	   */
	  getScrollResponder: function getScrollResponder() {
	    return this;
	  },
	  getScrollableNode: function getScrollableNode() {
	    return (0, _findNodeHandle2.default)(this._scrollViewRef);
	  },
	  getInnerViewNode: function getInnerViewNode() {
	    return (0, _findNodeHandle2.default)(this._innerViewRef);
	  },
	
	
	  /**
	   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
	   * Syntax:
	   *
	   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollTo: function scrollTo(y, x, animated) {
	    if (typeof y === 'number') {
	      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = y || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	
	    this.getScrollResponder().scrollResponderScrollTo({
	      x: x || 0,
	      y: y || 0,
	      animated: animated !== false
	    });
	  },
	
	
	  /**
	   * If this is a vertical ScrollView scrolls to the bottom.
	   * If this is a horizontal ScrollView scrolls to the right.
	   *
	   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
	   * `scrollToEnd({ animated: false })` for immediate scrolling.
	   * If no options are passed, `animated` defaults to true.
	   */
	  scrollToEnd: function scrollToEnd(options) {
	    // Default to true
	    var animated = (options && options.animated) !== false;
	    var horizontal = this.props.horizontal;
	
	    var scrollResponder = this.getScrollResponder();
	    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
	    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
	    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
	    scrollResponder.scrollResponderScrollTo({ x: x, y: y, animated: animated });
	  },
	
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollWithoutAnimationTo: function scrollWithoutAnimationTo() {
	    var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');
	    this.scrollTo({ x: x, y: y, animated: false });
	  },
	  render: function render() {
	    var _props = this.props,
	        contentContainerStyle = _props.contentContainerStyle,
	        horizontal = _props.horizontal,
	        onContentSizeChange = _props.onContentSizeChange,
	        refreshControl = _props.refreshControl,
	        stickyHeaderIndices = _props.stickyHeaderIndices,
	        keyboardDismissMode = _props.keyboardDismissMode,
	        onScroll = _props.onScroll,
	        pagingEnabled = _props.pagingEnabled,
	        other = _objectWithoutProperties(_props, ['contentContainerStyle', 'horizontal', 'onContentSizeChange', 'refreshControl', 'stickyHeaderIndices', 'keyboardDismissMode', 'onScroll', 'pagingEnabled']);
	
	    if (false) {
	      var style = _StyleSheet2.default.flatten(this.props.style);
	      var childLayoutProps = ['alignItems', 'justifyContent'].filter(function (prop) {
	        return style && style[prop] !== undefined;
	      });
	      (0, _invariant2.default)(childLayoutProps.length === 0, 'ScrollView child layout (' + JSON.stringify(childLayoutProps) + ') ' + 'must be applied through the contentContainerStyle prop.');
	    }
	
	    var contentSizeChangeProps = {};
	    if (onContentSizeChange) {
	      contentSizeChangeProps = {
	        onLayout: this._handleContentOnLayout
	      };
	    }
	
	    var children = !horizontal && Array.isArray(stickyHeaderIndices) ? _react2.default.Children.map(this.props.children, function (child, i) {
	      if (stickyHeaderIndices.indexOf(i) > -1) {
	        return _react2.default.cloneElement(child, { style: [child.props.style, styles.stickyHeader] });
	      } else {
	        return child;
	      }
	    }) : this.props.children;
	
	    var contentContainer = _react2.default.createElement(_View2.default, _extends({}, contentSizeChangeProps, {
	      children: children,
	      collapsable: false,
	      ref: this._setInnerViewRef,
	      style: [horizontal && styles.contentContainerHorizontal, contentContainerStyle]
	    }));
	
	    var baseStyle = horizontal ? styles.baseHorizontal : styles.baseVertical;
	
	    var props = Object.assign({}, other, {
	      style: [baseStyle, this.props.style],
	      onTouchStart: this.scrollResponderHandleTouchStart,
	      onTouchMove: this.scrollResponderHandleTouchMove,
	      onTouchEnd: this.scrollResponderHandleTouchEnd,
	      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
	      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
	      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
	      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
	      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
	      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
	      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
	      onScroll: this._handleScroll,
	      onResponderGrant: this.scrollResponderHandleResponderGrant,
	      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
	      onResponderTerminate: this.scrollResponderHandleTerminate,
	      onResponderRelease: this.scrollResponderHandleResponderRelease,
	      onResponderReject: this.scrollResponderHandleResponderReject
	    });
	
	    var ScrollViewClass = _ScrollViewBase2.default;
	
	    (0, _invariant2.default)(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');
	
	    if (refreshControl) {
	      return _react2.default.cloneElement(refreshControl, { style: props.style }, _react2.default.createElement(
	        ScrollViewClass,
	        _extends({}, props, { ref: this._setScrollViewRef, style: baseStyle }),
	        contentContainer
	      ));
	    }
	
	    return _react2.default.createElement(
	      ScrollViewClass,
	      _extends({}, props, { ref: this._setScrollViewRef, style: props.style }),
	      contentContainer
	    );
	  },
	  _handleContentOnLayout: function _handleContentOnLayout(e) {
	    var _e$nativeEvent$layout = e.nativeEvent.layout,
	        width = _e$nativeEvent$layout.width,
	        height = _e$nativeEvent$layout.height;
	
	    this.props.onContentSizeChange(width, height);
	  },
	  _handleScroll: function _handleScroll(e) {
	    if (false) {
	      if (this.props.onScroll && !this.props.scrollEventThrottle) {
	        console.log('You specified `onScroll` on a <ScrollView> but not ' + '`scrollEventThrottle`. You will only receive one event. ' + 'Using `16` you get all the events but be aware that it may ' + "cause frame drops, use a bigger number if you don't need as " + 'much precision.');
	      }
	    }
	
	    if (this.props.keyboardDismissMode === 'on-drag') {
	      (0, _dismissKeyboard2.default)();
	    }
	
	    this.scrollResponderHandleScroll(e);
	  },
	  _setInnerViewRef: function _setInnerViewRef(component) {
	    this._innerViewRef = component;
	  },
	  _setScrollViewRef: function _setScrollViewRef(component) {
	    this._scrollViewRef = component;
	  }
	});
	
	var commonStyle = {
	  flexGrow: 1,
	  flexShrink: 1,
	  // Enable hardware compositing in modern browsers.
	  // Creates a new layer with its own backing surface that can significantly
	  // improve scroll performance.
	  transform: [{ translateZ: 0 }],
	  // iOS native scrolling
	  WebkitOverflowScrolling: 'touch'
	};
	
	var styles = _StyleSheet2.default.create({
	  baseVertical: Object.assign({}, commonStyle, {
	    flexDirection: 'column',
	    overflowX: 'hidden',
	    overflowY: 'auto',
	    touchAction: 'pan-y'
	  }),
	  baseHorizontal: Object.assign({}, commonStyle, {
	    flexDirection: 'row',
	    overflowX: 'auto',
	    overflowY: 'hidden',
	    touchAction: 'pan-x'
	  }),
	  contentContainerHorizontal: {
	    flexDirection: 'row'
	  },
	  stickyHeader: {
	    position: 'sticky',
	    top: 0,
	    zIndex: 10
	  }
	});
	
	exports.default = ScrollView;
	module.exports = exports['default'];

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AnimationPropTypes = __webpack_require__(1045);
	
	var _AnimationPropTypes2 = _interopRequireDefault(_AnimationPropTypes);
	
	var _BorderPropTypes = __webpack_require__(1046);
	
	var _BorderPropTypes2 = _interopRequireDefault(_BorderPropTypes);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _InteractionPropTypes = __webpack_require__(1047);
	
	var _InteractionPropTypes2 = _interopRequireDefault(_InteractionPropTypes);
	
	var _LayoutPropTypes = __webpack_require__(1048);
	
	var _LayoutPropTypes2 = _interopRequireDefault(_LayoutPropTypes);
	
	var _ShadowPropTypes = __webpack_require__(1051);
	
	var _ShadowPropTypes2 = _interopRequireDefault(_ShadowPropTypes);
	
	var _TransformPropTypes = __webpack_require__(1052);
	
	var _TransformPropTypes2 = _interopRequireDefault(_TransformPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var overscrollBehaviorType = (0, _propTypes.oneOf)(['auto', 'contain', 'none']);
	
	var ViewStylePropTypes = Object.assign({}, _AnimationPropTypes2.default, _BorderPropTypes2.default, _InteractionPropTypes2.default, _LayoutPropTypes2.default, _ShadowPropTypes2.default, _TransformPropTypes2.default, {
	  backgroundColor: _ColorPropType2.default,
	  opacity: _propTypes.number,
	  /**
	   * @platform unsupported
	   */
	  elevation: _propTypes.number,
	  /**
	   * @platform web
	   */
	  backgroundAttachment: _propTypes.string,
	  backgroundBlendMode: _propTypes.string,
	  backgroundClip: _propTypes.string,
	  backgroundImage: _propTypes.string,
	  backgroundOrigin: (0, _propTypes.oneOf)(['border-box', 'content-box', 'padding-box']),
	  backgroundPosition: _propTypes.string,
	  backgroundRepeat: _propTypes.string,
	  backgroundSize: _propTypes.string,
	  boxShadow: _propTypes.string,
	  clip: _propTypes.string,
	  filter: _propTypes.string,
	  outline: _propTypes.string,
	  outlineColor: _ColorPropType2.default,
	  overscrollBehavior: overscrollBehaviorType,
	  overscrollBehaviorX: overscrollBehaviorType,
	  overscrollBehaviorY: overscrollBehaviorType,
	  WebkitMaskImage: _propTypes.string,
	  WebkitOverflowScrolling: (0, _propTypes.oneOf)(['auto', 'touch'])
	});
	
	exports.default = ViewStylePropTypes;
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createStrictShapeTypeChecker = __webpack_require__(824);
	
	var _createStrictShapeTypeChecker2 = _interopRequireDefault(_createStrictShapeTypeChecker);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function StyleSheetPropType(shape) {
	  var shapePropType = (0, _createStrictShapeTypeChecker2.default)(shape);
	  return function (props, propName, componentName, location) {
	    var newProps = props;
	    if (props[propName]) {
	      // Just make a dummy prop object with only the flattened style
	      newProps = {};
	      var flatStyle = _StyleSheet2.default.flatten(props[propName]);
	      // Remove custom properties from check
	      var nextStyle = Object.keys(flatStyle).reduce(function (acc, curr) {
	        if (curr.indexOf('--') !== 0) {
	          acc[curr] = flatStyle[curr];
	        }
	        return acc;
	      }, {});
	      newProps[propName] = nextStyle;
	    }
	
	    for (var _len = arguments.length, rest = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
	      rest[_key - 4] = arguments[_key];
	    }
	
	    return shapePropType.apply(undefined, [newProps, propName, componentName, location].concat(rest));
	  };
	}
	
	exports.default = StyleSheetPropType;
	module.exports = exports['default'];

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var View = ReactNative.View;
	
	
	var FeedPlusSideView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showOnlyTappable: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isVisible: true,
	      scale: .9,
	      opacity: .5
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  setAmountIn: function setAmountIn(amountIn) {
	    var scale = Math.max(Math.min(1, amountIn), .9);
	    if (scale != this.state.scale) this.setState({ scale: scale });
	    this.state.scale = scale;
	
	    var opacity = Math.max(Math.min(1, amountIn), .5);
	    if (opacity != this.state.opacity) this.setState({ opacity: opacity });
	    this.state.opacity = opacity;
	  },
	
	  setVisible: function setVisible(isVisible) {
	    if (this.state.isVisible != isVisible) this.setState({ isVisible: isVisible });
	  },
	
	  render: function render() {
	    if (this.state.isVisible == false) return null;
	
	    var _props = this.props,
	        style = _props.style,
	        otherProps = _objectWithoutProperties(_props, ['style']);
	
	    return React.createElement(View, Object.assign({ pointerEvents: "box-none", style: [this.props.style, { transform: [{ scale: this.state.scale }], opacity: this.state.opacity }] }, otherProps));
	  }
	});
	module.exports = FeedPlusSideView;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ArcMeter = __webpack_require__(58);
	var ModelConstants = __webpack_require__(11);
	
	// const Icon = require('./wrappers/ReUpIcon');
	
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var ImageMeter = __webpack_require__(1116);
	var PointsTicker = __webpack_require__(149);
	var AddToWalletButton = __webpack_require__(62);
	
	var ModelConstants = __webpack_require__(11);
	
	var Icon = __webpack_require__(13);
	
	var View = ReactNative.View,
	    Animated = ReactNative.Animated,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image;
	
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner;
	
	
	var FeedPlusView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showOnlyTappable: false,
	      upArrowSelected: function upArrowSelected() {},
	      initialLayout: { width: -1, height: -1 }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var feedPlusFeatures = this.props.appManager.getFeedPlusFeatures();
	    var shouldHideArrow = true;
	    for (var i = 0; i < feedPlusFeatures.length; i++) {
	      if (feedPlusFeatures[i].key != "Login" && feedPlusFeatures[i].key != "CreateUser") {
	        shouldHideArrow = false;
	        break;
	      }
	    }
	    return {
	      zoomOut: 0,
	      points: 0,
	      rewards: null,
	      isVisible: true,
	      enabled: true,
	      shouldHideArrow: shouldHideArrow
	    };
	  },
	
	  _context: 500,
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	    this.props.appManager.getDataType("Rewards", function (rewards) {
	      if (typeof rewards !== 'undefined' && rewards != null) {
	        _this.setRewards(rewards);
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  checkUserChanged: function checkUserChanged() {
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (loggedIn) {
	      var user = this.props.appManager.currentUser();
	      this.setState({ points: user.Points });
	    }
	  },
	
	  setEnabled: function setEnabled(enabled) {
	    if (enabled != this.state.enabled) this.setState({ enabled: enabled });
	  },
	
	  setZoomOut: function setZoomOut(zoomOut) {
	    zoomOut = Math.min(1, zoomOut);
	    this.setState({ zoomOut: zoomOut });
	  },
	
	  setVisible: function setVisible(isVisible) {
	    if (this.state.isVisible != isVisible) this.setState({ isVisible: isVisible });
	  },
	
	  setRewards: function setRewards(rewards) {
	    // TODO:remove
	    var appManager = this.props.appManager;
	    if (appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com") {
	      this.setState({ rewards: { RewardID: 0, RewardName: "Reward", Description: "A reward here", Points: 100 } });
	    } else {
	      this.setState({ rewards: rewards.sort(function (a, b) {
	          if (a.Points == b.Points) return b.RewardName.localeCompare(a.RewardName);else return a.Points - b.Points;
	        }) });
	    }
	  },
	
	  getLocalizedRewardData: function getLocalizedRewardData(reward) {
	    var preferredLocale = this.props.appManager.getActiveLocale();
	    var localizedRewardData = {};
	    if (typeof reward.LocaleOverride !== 'undefined' && reward.LocaleOverride != null && reward.LocaleOverride.length > 0) {
	      var preferredLocaleOverrides = JSON.parse(reward.LocaleOverride);
	      if (typeof preferredLocaleOverrides[preferredLocale] !== 'undefined') {
	        localizedRewardData.name = preferredLocaleOverrides[preferredLocale].RewardName;
	        localizedRewardData.description = preferredLocaleOverrides[preferredLocale].Description;
	      } else {
	        localizedRewardData.name = reward.RewardName;
	        localizedRewardData.description = reward.Description;
	      }
	    } else {
	      localizedRewardData.name = reward.RewardName;
	      localizedRewardData.description = reward.Description;
	    }
	
	    return localizedRewardData;
	  },
	
	  setPoints: function setPoints(points) {
	    if (points != this.state.points) this.setState({ points: points });
	  },
	
	  renderRewardMeter: function renderRewardMeter() {
	    var _this2 = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var generalColor = !appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
	    var generalTitleColor = appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var circleBackgroundColor = appManager.getColorForKey("ProfileColor");
	    var circleTextColor = appManager.getColorForKey("ProfileTitleColor");
	    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var rewardsFetched = false;
	    var meterDim = 240;
	    var outerDim = 220;
	
	    var imageMeterStyle = { flex: 1, alignSelf: 'stretch' };
	    if (Platform.OS == 'web') {
	      imageMeterStyle.height = "100%";
	      imageMeterStyle.width = "100%";
	    }
	
	    if (appManager.isLoggedIn()) {
	      var amountFontSize = 60;
	      var amountFontSize = 60 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3) * 12 : 0);
	      var amountLeftText1 = "";
	      var amountLeftText2 = "";
	
	      if (this.state.rewards != null && this.state.rewards.length > 0) {
	        var mostExpensiveAcheivedReward = null;
	        var mostExpensiveAcheivedRewardLocalized = "";
	        var nextReward = null;
	        for (var i = 0; i < this.state.rewards.length; i++) {
	          var reward = this.state.rewards[i];
	
	          if (parseInt(reward.Points) > parseInt(this.state.points) && (nextReward == null || parseInt(nextReward.Points) > parseInt(reward.Points))) {
	            nextReward = reward;
	          }
	
	          if (parseInt(reward.Points) <= parseInt(this.state.points) && (mostExpensiveAcheivedReward == null || parseInt(mostExpensiveAcheivedReward.Points) < parseInt(reward.Points))) {
	            mostExpensiveAcheivedReward = reward;
	            mostExpensiveAcheivedRewardLocalized = this.getLocalizedRewardData(mostExpensiveAcheivedReward);
	          }
	        }
	
	        if (nextReward != null) {
	          var localizedPoints = locManager.localizedPoints(nextReward.Points - this.state.points);
	          var localizedRewardData = this.getLocalizedRewardData(nextReward);
	          amountLeftText1 = locManager.localizedStringForKeyAndParams("POINTS_LEFT_NEXT_REWARD_STATEMENT", [localizedPoints], "%0% until next reward:");
	          amountLeftText2 = localizedRewardData.name;
	        }
	        rewardsFetched = true;
	      }
	
	      var myCardFeatureData = appManager.getFeatureForName("MyCard");
	      var rewardsCampaignsFeatureData = appManager.getFeatureForName("RewardsCampaigns");
	      var createUserFeatureData = appManager.getFeatureForName("CreateUser");
	      var auphanFeatureData = appManager.getFeatureForName("Auphan");
	      var grabbFeatureData = appManager.getFeatureForName("Grabb");
	      var earnPayFeatureData = appManager.getFeatureForName("EarnPay");
	      var earnPayTitle = "";
	      if (typeof earnPayFeatureData !== 'undefined') {
	        earnPayTitle = earnPayFeatureData.data.title;
	        var prereqFeature = appManager.getPrerequisiteFeatureForName("EarnPay");
	        if (prereqFeature != null) earnPayTitle = prereqFeature.data.title;
	      }
	      var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
	      var useCreditTitle = "";
	      if (typeof useCreditFeatureData !== 'undefined') {
	        useCreditTitle = useCreditFeatureData.data.title;
	        var prereqFeature = appManager.getPrerequisiteFeatureForName("UseCredit");
	        if (prereqFeature != null) useCreditTitle = prereqFeature.data.title;
	      }
	      // TODO:remove
	      if (appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com") {
	        this.state.rewards = [{ RewardID: 0, RewardName: "Reward", Description: "A reward here", Points: 100 }];
	        this.state.points = 100;
	      }
	
	      switch (appManager.feedPlusType()) {
	        case 0:
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: { flex: 1 } },
	            React.createElement(View, { pointerEvents: 'box-none', style: { flex: 1 } }),
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: -1,
	                  borderRadius: outerDim / 2,
	                  backgroundColor: cardColor,
	                  overflow: 'hidden',
	                  padding: 0
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: cardColor,
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                View,
	                { style: { flexDirection: 'column', height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(MKSpinner, { style: {
	                    alignSelf: 'center',
	                    backgroundColor: 'transparent'
	                  }, strokeColor: [buttonColor, buttonTitleColor] })
	              ) : null,
	              nextReward != null ? React.createElement(
	                View,
	                { key: 'rewardmetercontainer', style: { backgroundColor: circleBackgroundColor, paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ArcMeter,
	                  { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 14, bgColor: profileMeterBackgroundColor, percentage: this.state.points / nextReward.Points },
	                  React.createElement(
	                    View,
	                    { style: { width: 150, justifyContent: 'center', alignItems: 'center', paddingBottom: 20 } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: [{ fontSize: amountFontSize, color: circleIconColor, justifyContent: 'center' }],
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } }),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                      amountLeftText1
	                    ),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, isTitle: true, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                      amountLeftText2
	                    )
	                  )
	                ),
	                React.createElement(View, { style: { marginTop: 18 } })
	              ) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	                View,
	                { key: 'rewardmetercontainer', style: { backgroundColor: circleBackgroundColor, paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ArcMeter,
	                  { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 14, bgColor: profileMeterBackgroundColor, percentage: 1 },
	                  React.createElement(
	                    View,
	                    { style: { width: 150, justifyContent: 'center', alignItems: 'center', paddingBottom: 20 } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: [{ fontSize: amountFontSize, color: circleIconColor, justifyContent: 'center' }],
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } }),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                      locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	                    ),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, isTitle: true, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                      mostExpensiveAcheivedRewardLocalized.name
	                    )
	                  )
	                ),
	                React.createElement(View, { style: { marginTop: 18 } })
	              ) : null
	            ),
	            React.createElement(View, { pointerEvents: 'box-none', style: { flex: 1 } })
	          );
	
	        case 1:
	          var meterDim = 260;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(Image, { pointerEvents: 'none', key: appManager.getImageKey("feedplusHeader"), style: { alignSelf: 'stretch', height: 50, backgroundColor: 'transparent' }, resizeMode: "contain", source: { uri: appManager.absoluteResourceForPath('FeedPlus/header.png') } }),
	            React.createElement(View, { style: { height: 20 } }),
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null
	            ),
	            React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	              React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                renderText: function renderText(points) {
	                  return locManager.localizedPoints(Math.round(points));
	                } })
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedReward.RewardName
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	        case 2:
	          meterDim = 140;
	          outerDim = meterDim + 20;
	          amountFontSize = amountFontSize / 2;
	          return React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', marginBottom: 20 } },
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: -1,
	                  borderRadius: outerDim / 2,
	                  backgroundColor: 'transparent',
	                  flexDirection: 'column',
	                  alignItems: 'center',
	                  marginBottom: 20
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns", { disableUseReward: _this2.props.appManager.feedPlusType() == 2 });else _this2.props.appActions.requestFeatureName("Rewards", { disableUseReward: _this2.props.appManager.feedPlusType() == 2 });
	                },
	                underlayColor: cardColor,
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center' } },
	                this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                  View,
	                  { style: { flexDirection: 'column', height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                ) : null,
	                nextReward != null ? React.createElement(
	                  View,
	                  { key: 'rewardmetercontainer', style: { backgroundColor: 'transparent', paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(
	                    ArcMeter,
	                    { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 20, bgColor: profileMeterBackgroundColor, percentage: this.state.points / nextReward.Points },
	                    React.createElement(
	                      View,
	                      { style: { width: 150, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: [{ fontSize: amountFontSize, color: generalTitleColor, justifyContent: 'center' }],
	                        renderText: function renderText(points) {
	                          return Math.round(points);
	                        } }),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { fontSize: amountFontSize / 2, textAlign: 'center', color: generalTitleColor } },
	                        this.state.points == 1 ? "pt" : "pts"
	                      )
	                    )
	                  )
	                ) : null,
	                mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	                  View,
	                  { key: 'rewardmetercontainer', style: { backgroundColor: 'transparent', paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(
	                    ArcMeter,
	                    { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 20, bgColor: profileMeterBackgroundColor, percentage: 1 },
	                    React.createElement(
	                      View,
	                      { style: { width: 150, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: [{ fontSize: amountFontSize, color: generalTitleColor, justifyContent: 'center' }],
	                        renderText: function renderText(points) {
	                          return Math.round(points);
	                        } }),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { fontSize: amountFontSize / 2, textAlign: 'center' } },
	                        this.state.points == 1 ? "pt" : "pts"
	                      )
	                    )
	                  )
	                ) : null
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { flex: -1, flexDirection: 'column', alignItems: 'stretch', padding: 4 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor }, isTitle: true },
	                appManager.currentUserFullName()
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	                appManager.currentUser()[ModelConstants.UserName]
	              )
	            )
	          );
	
	        case 3:
	          var meterDim = 340;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle,
	                  overlayView: function overlayView() {
	                    return React.createElement(
	                      View,
	                      { style: { width: 90, flex: 1, paddingTop: 60 } },
	                      React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                        style: { fontSize: 20, color: generalColor, textAlign: 'center' }, isTitle: true,
	                        renderText: function renderText(points) {
	                          return locManager.localizedPts(Math.round(points));
	                        } })
	                    );
	                  }
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { width: 90, flex: 1, paddingTop: 60 } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 20, color: generalColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return locManager.localizedPts(Math.round(points));
	                      } })
	                  );
	                }
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { width: 90, flex: 1, paddingTop: 60 } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 20, color: generalColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return locManager.localizedPts(Math.round(points));
	                      } })
	                  );
	                }
	              }) : null
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedReward.RewardName
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	
	        case 4:
	          var meterDim = 280;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              View,
	              { style: { height: 80 } },
	              React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points),
	                style: { fontSize: 50, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                renderText: function renderText(points) {
	                  return locManager.localizedPts(Math.round(points));
	                } })
	            ),
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle,
	                  overlayView: function overlayView() {
	                    return React.createElement(
	                      View,
	                      { style: { alignSelf: 'stretch', flexDirection: 'column', flex: 1, alignItems: 'center', justifyContent: 'center', paddingBottom: 30 } },
	                      React.createElement(View, { style: { flex: 1 } }),
	                      mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	                        View,
	                        { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center', height: 40 } },
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                          locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	                        ),
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                          mostExpensiveAcheivedRewardLocalized.name
	                        )
	                      ) : React.createElement(
	                        View,
	                        { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center', height: 40 } },
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                          amountLeftText1
	                        ),
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                          amountLeftText2
	                        )
	                      )
	                    );
	                  }
	                },
	                rewardsFetched == false ? React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                ) : null
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { alignSelf: 'stretch', flexDirection: 'column', flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                    React.createElement(View, { style: { flex: 1 } }),
	                    mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	                      View,
	                      { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        mostExpensiveAcheivedRewardLocalized.name
	                      )
	                    ) : React.createElement(
	                      View,
	                      { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        amountLeftText1
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        amountLeftText2
	                      )
	                    )
	                  );
	                }
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { alignSelf: 'stretch', flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                    React.createElement(View, { style: { flex: 1 } }),
	                    mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	                      View,
	                      { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        mostExpensiveAcheivedRewardLocalized.name
	                      )
	                    ) : React.createElement(
	                      View,
	                      { pointerEvents: 'none', style: { alignSelf: 'stretch', flex: 1, justifyContent: 'center', alignItems: 'center' } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        amountLeftText1
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                        amountLeftText2
	                      )
	                    )
	                  );
	                }
	              }) : null
	            )
	          );
	
	        case 5:
	          var meterDim = 340;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle,
	                  overlayView: function overlayView() {
	                    return React.createElement(
	                      View,
	                      { style: { paddingBottom: 70, alignSelf: 'stretch', flex: 1, flexDirection: 'column', justifyContent: 'flex-end' } },
	                      React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                        style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                        renderText: function renderText(points) {
	                          return Math.round(points);
	                        } })
	                    );
	                  }
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { paddingBottom: 70, flex: 1, flexDirection: 'column', justifyContent: 'flex-end' } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } })
	                  );
	                }
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { paddingBottom: 70, alignSelf: 'stretch', flex: 1, flexDirection: 'column', justifyContent: 'flex-end' } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } })
	                  );
	                }
	              }) : null
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedRewardLocalized.name
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	        case 6:
	          var meterDim = 320;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns", { disableUseReward: _this2.props.appManager.feedPlusType() == 2 });else _this2.props.appActions.requestFeatureName("Rewards", { disableUseReward: _this2.props.appManager.feedPlusType() == 2 });
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null
	            ),
	            React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	              React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                renderText: function renderText(points) {
	                  return locManager.localizedPoints(Math.round(points));
	                } })
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedRewardLocalized.name
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	        case 7:
	          var meterDim = 375;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 600));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'column', justifyContent: 'flex-end', height: 60 } },
	              React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points),
	                style: { fontSize: 40, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                renderText: function renderText(points) {
	                  return locManager.localizedPts(Math.round(points));
	                } })
	            ),
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden',
	                  alignSelf: 'stretch'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                  style: imageMeterStyle
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle
	              }) : null
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedRewardLocalized.name
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	
	        case 8:
	          var meterDim = 340;
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	          if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	          return React.createElement(
	            View,
	            { pointerEvents: 'box-none', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden',
	                flexDirection: 'column',
	                alignSelf: 'stretch'
	              }] },
	            React.createElement(
	              MKButton,
	              { key: 'rewardbutton', style: [{
	                  flex: 1,
	                  backgroundColor: 'transparent',
	                  overflow: 'hidden'
	                }],
	                onPress: function onPress() {
	                  if (typeof rewardsCampaignsFeatureData !== 'undefined') _this2.props.appActions.requestFeatureName("RewardsCampaigns");else _this2.props.appActions.requestFeatureName("Rewards");
	                },
	                underlayColor: 'transparent',
	                rippleColor: rippleColor,
	                maskBorderRadius: 2
	              },
	              this.state.rewards == null || nextReward == null && mostExpensiveAcheivedReward == null ? React.createElement(
	                ImageMeter,
	                { key: 'rewardsmeter',
	                  offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                  offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                  percentage: 0,
	                  appManager: appManager,
	                  bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                  fgSource: null,
	                  fillSource: null,
	                  style: imageMeterStyle,
	                  overlayView: function overlayView() {
	                    return React.createElement(
	                      View,
	                      { style: { paddingBottom: 70, alignSelf: 'stretch', flex: 1, flexDirection: 'column', justifyContent: 'flex-end' } },
	                      React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                        style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                        renderText: function renderText(points) {
	                          return Math.round(points);
	                        } })
	                    );
	                  }
	                },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(MKSpinner, { style: {
	                      alignSelf: 'center',
	                      backgroundColor: 'transparent'
	                    }, strokeColor: [buttonColor, buttonTitleColor] })
	                )
	              ) : null,
	              nextReward != null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                offsetTopPercentage: appManager.feedPlusTopOffsetPercentage(),
	                offsetBottomPercentage: appManager.feedPlusBottomOffsetPercentage(),
	                percentage: this.state.points / nextReward.Points,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { flex: 1, flexDirection: 'column', justifyContent: 'center' } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } })
	                  );
	                }
	              }) : null,
	              mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(ImageMeter, { key: 'rewardsmeter',
	                percentage: 1,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: appManager.absoluteResourceForPath('FeedPlus/meter_fg.png'),
	                fillSource: appManager.absoluteResourceForPath('FeedPlus/meter_fill.png'),
	                style: imageMeterStyle,
	                overlayView: function overlayView() {
	                  return React.createElement(
	                    View,
	                    { style: { alignSelf: 'stretch', flex: 1, flexDirection: 'column', justifyContent: 'center' } },
	                    React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(_this2.state.points),
	                      style: { fontSize: 60, color: generalTitleColor, textAlign: 'center' }, isTitle: true,
	                      renderText: function renderText(points) {
	                        return Math.round(points);
	                      } })
	                  );
	                }
	              }) : null
	            ),
	            mostExpensiveAcheivedReward != null && nextReward == null ? React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                locManager.localizedStringForKey("YOU_HAVE_EARNED_REWARD_STATEMENT", "You have earned a reward:")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                mostExpensiveAcheivedRewardLocalized.name
	              )
	            ) : React.createElement(
	              View,
	              { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', height: 40 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText1
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, textAlign: 'center' }] },
	                amountLeftText2
	              )
	            )
	          );
	      }
	    }
	    switch (appManager.feedPlusType()) {
	      case 0:
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : circleIconColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: "box-none", style: { flex: 1, flexDirection: 'column' } },
	          React.createElement(View, { pointerEvents: "box-none", style: { flex: 1 } }),
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: -1,
	                borderRadius: outerDim / 2,
	                backgroundColor: cardColor,
	                overflow: 'hidden',
	                padding: 0
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: cardColor,
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              View,
	              { key: 'rewardmetercontainer', style: { backgroundColor: circleBackgroundColor, paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(
	                ArcMeter,
	                { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 14, bgColor: profileMeterBackgroundColor, percentage: 0 },
	                React.createElement(
	                  View,
	                  { style: { width: 150, justifyContent: 'center', alignItems: 'center', paddingBottom: 20 } },
	                  React.createElement(
	                    View,
	                    { style: { margin: 10 } },
	                    React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                  ),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                    locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	                  )
	                )
	              ),
	              React.createElement(View, { style: { marginTop: 18 } })
	            )
	          ),
	          React.createElement(View, { pointerEvents: "box-none", style: { flex: 1 } })
	        );
	
	      case 1:
	        var meterDim = 260;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(Image, { pointerEvents: 'none', key: appManager.getImageKey("feedplusHeader"), style: { alignSelf: 'stretch', height: 50, backgroundColor: 'transparent' }, resizeMode: "contain", source: { uri: appManager.absoluteResourceForPath('FeedPlus/header.png') } }),
	          React.createElement(View, { style: { height: 20 } }),
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	        return React.createElement(
	          MKButton,
	          { key: 'rewardbutton', style: [{
	              flex: -1,
	              borderRadius: outerDim / 2,
	              backgroundColor: cardColor,
	              overflow: 'hidden'
	            }],
	            onPress: function onPress() {
	              return _this2.props.appActions.requestFeatureName("Login");
	            },
	            underlayColor: cardColor,
	            rippleColor: rippleColor,
	            maskBorderRadius: 2
	          },
	          React.createElement(
	            View,
	            { key: 'rewardmetercontainer', style: { backgroundColor: circleBackgroundColor, paddingTop: 18, borderRadius: outerDim / 2, height: outerDim, width: outerDim, alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(
	              ArcMeter,
	              { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 14, bgColor: profileMeterBackgroundColor, percentage: 0 },
	              React.createElement(
	                View,
	                { style: { width: 150, justifyContent: 'center', alignItems: 'center', paddingBottom: 20 } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: circleIconColor })
	                ),
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ color: circleTextColor, textAlign: 'center' }] },
	                  locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	                )
	              )
	            ),
	            React.createElement(View, { style: { marginTop: 18 } })
	          )
	        );
	      case 3:
	        var meterDim = 340;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	      case 4:
	        var meterDim = 280;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(View, { style: { height: 80 } }),
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(ImageMeter, { key: 'rewardsmeter',
	              percentage: 0,
	              appManager: appManager,
	              bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	              fgSource: null,
	              fillSource: null,
	              style: imageMeterStyle,
	              overlayView: function overlayView() {
	                return React.createElement(
	                  View,
	                  { style: { alignSelf: 'stretch', flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(View, { style: { height: 20 } }),
	                  React.createElement(
	                    View,
	                    { style: { margin: 10 } },
	                    React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                  ),
	                  React.createElement(View, { style: { height: 20 } }),
	                  React.createElement(
	                    View,
	                    { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	                      locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	                    )
	                  )
	                );
	              }
	            })
	          )
	        );
	
	      case 5:
	        var meterDim = 340;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	      case 6:
	        var meterDim = 320;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	      case 7:
	        var meterDim = 375;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 600));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(View, { style: { flexDirection: 'column', justifyContent: 'flex-end', height: 60 } }),
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	
	      case 8:
	        var meterDim = 340;
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * (meterDim / 375));
	        if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height * (meterDim / 667));
	
	        var lockColor = appManager.shouldDisableLockOnFeedPlus() ? 'transparent' : generalTitleColor;
	
	        return React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: [{
	              flex: 1,
	              backgroundColor: 'transparent',
	              overflow: 'hidden',
	              flexDirection: 'column',
	              alignSelf: 'stretch'
	            }] },
	          React.createElement(
	            MKButton,
	            { key: 'rewardbutton', style: [{
	                flex: 1,
	                backgroundColor: 'transparent',
	                overflow: 'hidden'
	              }],
	              onPress: function onPress() {
	                return _this2.props.appActions.requestFeatureName("Login");
	              },
	              underlayColor: 'transparent',
	              rippleColor: rippleColor,
	              maskBorderRadius: 2
	            },
	            React.createElement(
	              ImageMeter,
	              { key: 'rewardsmeter',
	                percentage: 0,
	                appManager: appManager,
	                bgSource: appManager.absoluteResourceForPath('FeedPlus/meter_bg.png'),
	                fgSource: null,
	                fillSource: null,
	                style: imageMeterStyle
	              },
	              React.createElement(
	                View,
	                { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { margin: 10 } },
	                  React.createElement(Icon, { name: "lock", size: 70, color: lockColor })
	                )
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', marginVertical: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { fontSize: 20, color: generalTitleColor, textAlign: 'center' }, isTitle: true },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          )
	        );
	      default:
	
	    }
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
	    if (this.state.isVisible == false) return null;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var circleBackgroundColor = appManager.getColorForKey("ProfileColor");
	    var circleTextColor = appManager.getColorForKey("ProfileTitleColor");
	    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var buttonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	
	    if (appManager.isLoggedIn()) {
	      var amountFontSize = 60;
	      var amountFontSize = 60 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3) * 12 : 0);
	      var amountLeftText1 = "";
	      var amountLeftText2 = "";
	
	      if (this.state.rewards != null && this.state.rewards.length > 0) {
	        var mostExpensiveAcheivedReward = null;
	        var nextReward = null;
	        for (var i = 0; i < this.state.rewards.length; i++) {
	          var reward = this.state.rewards[i];
	
	          if (parseInt(reward.Points) > parseInt(this.state.points) && (nextReward == null || parseInt(nextReward.Points) > parseInt(reward.Points))) {
	            nextReward = reward;
	          }
	
	          if (parseInt(reward.Points) <= parseInt(this.state.points) && (mostExpensiveAcheivedReward == null || parseInt(mostExpensiveAcheivedReward.Points) < parseInt(reward.Points))) {
	            mostExpensiveAcheivedReward = reward;
	          }
	        }
	
	        if (nextReward != null) {
	          var localizedPoints = locManager.localizedPoints(nextReward.Points - this.state.points);
	          amountLeftText1 = locManager.localizedStringForKeyAndParams("POINTS_LEFT_NEXT_REWARD_STATEMENT", [localizedPoints], "%0% until next reward:");
	          var localizedNextRewardData = this.getLocalizedRewardData(nextReward);
	          amountLeftText2 = localizedNextRewardData.name;
	        }
	      }
	
	      var meterDim = 240;
	      var outerDim = 220;
	
	      var myCardFeatureData = appManager.getFeatureForName("MyCard");
	      var rewardsCampaignsFeatureData = appManager.getFeatureForName("RewardsCampaigns");
	      var rewardsFeatureData = appManager.getFeatureForName("Rewards");
	      var settingsFeatureData = appManager.getFeatureForName("Settings");
	      var simpleSettingsFeatureData = appManager.getFeatureForName("SimpleSettings");
	      var createUserFeatureData = appManager.getFeatureForName("CreateUser");
	      var auphanFeatureData = appManager.getFeatureForName("Auphan");
	      var grabbFeatureData = appManager.getFeatureForName("Grabb");
	      var orderAheadFeatureData = appManager.getFeatureForName("OrderAhead");
	      var earnPayFeatureData = appManager.getFeatureForName("EarnPay");
	      var earnPayTitle = "";
	      if (typeof earnPayFeatureData !== 'undefined') {
	        earnPayTitle = earnPayFeatureData.data.title;
	        var prereqFeature = appManager.getPrerequisiteFeatureForName("EarnPay");
	        if (prereqFeature != null) earnPayTitle = prereqFeature.data.title;
	      }
	      var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
	      var useCreditTitle = "";
	      if (typeof useCreditFeatureData !== 'undefined') {
	        useCreditTitle = useCreditFeatureData.data.title;
	        var prereqFeature = appManager.getPrerequisiteFeatureForName("UseCredit");
	        if (prereqFeature != null) useCreditTitle = prereqFeature.data.title;
	      }
	      // TODO: remove
	      // earnPayFeatureData.data.shouldShowOnFeedPlus = false;
	      // useCreditFeatureData.data.shouldShowOnFeedPlus = false;
	      // rewardsFeatureData.data.shouldShowOnFeedPlus = true;
	      // if( typeof auphanFeatureData !== 'undefined' ) auphanFeatureData.data.shouldShowOnFeedPlus = true;
	      // if( typeof grabbFeatureData !== 'undefined' ) grabbFeatureData.data.shouldShowOnFeedPlus = true;
	
	      var buttonWidth = 220;
	      var margin = 10;
	      if (appManager.shouldShowPassButton()) {
	        buttonWidth = 142;
	        margin = 4;
	      }
	      return React.createElement(
	        View,
	        { key: 'feedplusview', pointerEvents: this.state.enabled ? "box-none" : "none", style: [this.props.style, { transform: [{ scale: 1 - this.state.zoomOut }], opacity: 1 - this.state.zoomOut, flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }] },
	        typeof rewardsCampaignsFeatureData !== 'undefined' && rewardsCampaignsFeatureData.data.shouldShowOnFeedPlus || typeof rewardsFeatureData !== 'undefined' && rewardsFeatureData.data.shouldShowOnFeedPlus ? this.renderRewardMeter() : null,
	        typeof earnPayFeatureData !== 'undefined' && earnPayFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { appManager: appManager, style: { margin: 4, width: 220 }, text: earnPayTitle,
	          onPress: function onPress() {
	            appActions.requestFeatureName("EarnPay");
	          } }) : null,
	        typeof myCardFeatureData !== 'undefined' && myCardFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { appManager: appManager, style: { margin: margin, width: buttonWidth }, text: myCardFeatureData.data.title,
	          onPress: function onPress() {
	            if (typeof thisThing.props.flipSelected !== 'undefined') {
	              thisThing.props.flipSelected(myCardFeatureData);
	            } else {
	              appActions.requestFeatureName("MyCard");
	            }
	          } }) : null,
	        appManager.shouldShowPassButton() ? React.createElement(AddToWalletButton, { appManager: appManager, style: { margin: margin, width: buttonWidth, height: 44 } }) : null,
	        typeof rewardsFeatureData !== 'undefined' && rewardsFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: margin, width: buttonWidth }, text: rewardsFeatureData.data.shortTitle,
	          onPress: function onPress() {
	            appActions.requestFeatureName("Rewards", { disableUseReward: _this3.props.appManager.feedPlusType() == 2 });
	          } }) : null,
	        typeof useCreditFeatureData !== 'undefined' && useCreditFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { appManager: appManager, style: { margin: 4, width: 220 }, text: useCreditTitle,
	          onPress: function onPress() {
	            appActions.requestFeatureName("UseCredit");
	          } }) : null,
	        typeof auphanFeatureData !== 'undefined' && auphanFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { isSecondary: typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined', appManager: appManager, style: { margin: 4, width: 220 }, text: auphanFeatureData.data.title,
	          onPress: function onPress() {
	            appActions.requestFeatureName("Auphan");
	          } }) : null,
	        typeof grabbFeatureData !== 'undefined' && grabbFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { isSecondary: typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined', appManager: appManager, style: { margin: 4, width: 220 }, text: grabbFeatureData.data.title,
	          onPress: function onPress() {
	            appActions.requestFeatureName("Grabb");
	          } }) : null,
	        typeof orderAheadFeatureData !== 'undefined' && orderAheadFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { isSecondary: typeof earnPayFeatureData !== 'undefined' || typeof useCreditFeatureData !== 'undefined', appManager: appManager, style: { margin: 4, width: 220 }, text: orderAheadFeatureData.data.title,
	          onPress: function onPress() {
	            appActions.requestFeatureName("OrderAhead");
	          } }) : null,
	        typeof simpleSettingsFeatureData !== 'undefined' && simpleSettingsFeatureData.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, style: { margin: margin, width: buttonWidth }, text: simpleSettingsFeatureData.data.title,
	          onPress: function onPress() {
	            if (typeof thisThing.props.flipSelected !== 'undefined') {
	              thisThing.props.flipSelected(simpleSettingsFeatureData);
	            } else {
	              appActions.requestFeatureName("SimpleSettings");
	            }
	          } }) : null,
	        !appManager.disableFeed() ? React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: { flexDirection: 'column', alignSelf: 'stretch' } },
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', height: 50 } },
	            this.state.shouldHideArrow ? null : React.createElement(ReUpIconButton, { ref: 'upButton', type: 8, appManager: appManager, iconName: "angle-up", onPress: function onPress() {
	                thisThing.props.upArrowSelected();
	              } })
	          ),
	          React.createElement(View, { pointerEvents: 'auto', onStartShouldSetResponder: function onStartShouldSetResponder() {
	              thisThing.props.upArrowSelected();
	            },
	            style: { alignSelf: 'stretch', height: 20 } })
	        ) : React.createElement(View, { style: { height: 20 } })
	      );
	    } else {
	      var amountFontSize = 60;
	
	      var meterDim = 240;
	      var outerDim = 220;
	
	      var loginFeature = appManager.getFeatureForName("Login");
	      var createUserFeature = appManager.getFeatureForName("CreateUser");
	
	      loginFeature.data.shouldShowOnFeedPlus = true;
	      createUserFeature.data.shouldShowOnFeedPlus = true;
	      return React.createElement(
	        View,
	        { key: 'feedplusview', pointerEvents: this.state.enabled ? "box-none" : "none", style: [this.props.style, { transform: [{ scale: 1 - this.state.zoomOut }], opacity: 1 - this.state.zoomOut, alignItems: 'center', justifyContent: 'center' }] },
	        typeof loginFeature !== 'undefined' && loginFeature.data.shouldShowOnFeedPlus ? this.renderRewardMeter() : null,
	        typeof createUserFeature !== 'undefined' && createUserFeature.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { appManager: appManager, style: { margin: 4, width: 220 }, text: createUserFeature.data.title,
	          onPress: function onPress() {
	            appActions.requestFeatureName("CreateUser");
	          } }) : null,
	        typeof loginFeature !== 'undefined' && loginFeature.data.shouldShowOnFeedPlus ? React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, style: { margin: 4, width: 220 }, text: loginFeature.data.title,
	          onPress: function onPress() {
	            appActions.requestFeatureName("Login");
	          } }) : null,
	        !appManager.disableFeed() ? React.createElement(
	          View,
	          { pointerEvents: 'box-none', style: { flexDirection: 'column', alignSelf: 'stretch' } },
	          React.createElement(
	            View,
	            { pointerEvents: 'none', style: { alignSelf: 'stretch', height: 50 } },
	            this.state.shouldHideArrow ? null : React.createElement(ReUpIconButton, { ref: 'upButton', type: 8, appManager: appManager, iconName: "angle-up", onPress: function onPress() {
	                thisThing.props.upArrowSelected();
	              } })
	          ),
	          React.createElement(View, { pointerEvents: 'auto', onStartShouldSetResponder: function onStartShouldSetResponder() {
	              thisThing.props.upArrowSelected();
	            },
	            style: { alignSelf: 'stretch', height: 20 } })
	        ) : null
	      );
	    }
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  }
	});
	FeedPlusView.dataDependencies = ["Users", "Rewards"];
	
	module.exports = FeedPlusView;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var KeyboardAvoidingView = ReactNative.KeyboardAvoidingView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    Platform = ReactNative.Platform;
	
	var Keyboard = DeviceEventEmitter;
	var Overlay = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      keyboardOffset: new Animated.Value(0)
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.mounted = true;
	    // DeviceEventEmitter.addListener('keyboardDidShow', this._keyboardWillShow.bind(this))
	    // DeviceEventEmitter.addListener('keyboardDidHide', this._keyboardWillHide.bind(this))
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.mounted = false;
	  },
	
	  _keyboardWillShow: function _keyboardWillShow(e) {
	    if (!this.mounted) return;
	
	    Animated.spring(this.state.keyboardOffset, {
	      toValue: e.endCoordinates.height,
	      friction: 6
	    }).start();
	  },
	
	  _keyboardWillHide: function _keyboardWillHide(e) {
	    if (!this.mounted) return;
	
	    Animated.spring(this.state.keyboardOffset, {
	      toValue: 0,
	      friction: 6
	    }).start();
	  },
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        other = _objectWithoutProperties(_props, ['style']);
	
	    if (Platform.OS === 'ios') {
	      return React.createElement(KeyboardAvoidingView, Object.assign({ behavior: "padding", style: [{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }, style] }, other));
	    } else {
	      return React.createElement(Animated.View, Object.assign({ style: [{ position: 'absolute', top: 0, left: 0, right: 0, bottom: this.state.keyboardOffset }, style] }, other));
	    }
	  }
	});
	
	module.exports = Overlay;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var HyperLink = createReactClass({
	  displayName: 'HyperLink',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	module.exports = HyperLink;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1171);


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var X32WordArray = C_lib.WordArray;
	
		    /**
		     * x64 namespace.
		     */
		    var C_x64 = C.x64 = {};
	
		    /**
		     * A 64-bit word.
		     */
		    var X64Word = C_x64.Word = Base.extend({
		        /**
		         * Initializes a newly created 64-bit word.
		         *
		         * @param {number} high The high 32 bits.
		         * @param {number} low The low 32 bits.
		         *
		         * @example
		         *
		         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
		         */
		        init: function (high, low) {
		            this.high = high;
		            this.low = low;
		        }
	
		        /**
		         * Bitwise NOTs this word.
		         *
		         * @return {X64Word} A new x64-Word object after negating.
		         *
		         * @example
		         *
		         *     var negated = x64Word.not();
		         */
		        // not: function () {
		            // var high = ~this.high;
		            // var low = ~this.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ANDs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to AND with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ANDing.
		         *
		         * @example
		         *
		         *     var anded = x64Word.and(anotherX64Word);
		         */
		        // and: function (word) {
		            // var high = this.high & word.high;
		            // var low = this.low & word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise ORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to OR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after ORing.
		         *
		         * @example
		         *
		         *     var ored = x64Word.or(anotherX64Word);
		         */
		        // or: function (word) {
		            // var high = this.high | word.high;
		            // var low = this.low | word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Bitwise XORs this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to XOR with this word.
		         *
		         * @return {X64Word} A new x64-Word object after XORing.
		         *
		         * @example
		         *
		         *     var xored = x64Word.xor(anotherX64Word);
		         */
		        // xor: function (word) {
		            // var high = this.high ^ word.high;
		            // var low = this.low ^ word.low;
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the left.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftL(25);
		         */
		        // shiftL: function (n) {
		            // if (n < 32) {
		                // var high = (this.high << n) | (this.low >>> (32 - n));
		                // var low = this.low << n;
		            // } else {
		                // var high = this.low << (n - 32);
		                // var low = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Shifts this word n bits to the right.
		         *
		         * @param {number} n The number of bits to shift.
		         *
		         * @return {X64Word} A new x64-Word object after shifting.
		         *
		         * @example
		         *
		         *     var shifted = x64Word.shiftR(7);
		         */
		        // shiftR: function (n) {
		            // if (n < 32) {
		                // var low = (this.low >>> n) | (this.high << (32 - n));
		                // var high = this.high >>> n;
		            // } else {
		                // var low = this.high >>> (n - 32);
		                // var high = 0;
		            // }
	
		            // return X64Word.create(high, low);
		        // },
	
		        /**
		         * Rotates this word n bits to the left.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotL(25);
		         */
		        // rotL: function (n) {
		            // return this.shiftL(n).or(this.shiftR(64 - n));
		        // },
	
		        /**
		         * Rotates this word n bits to the right.
		         *
		         * @param {number} n The number of bits to rotate.
		         *
		         * @return {X64Word} A new x64-Word object after rotating.
		         *
		         * @example
		         *
		         *     var rotated = x64Word.rotR(7);
		         */
		        // rotR: function (n) {
		            // return this.shiftR(n).or(this.shiftL(64 - n));
		        // },
	
		        /**
		         * Adds this word with the passed word.
		         *
		         * @param {X64Word} word The x64-Word to add with this word.
		         *
		         * @return {X64Word} A new x64-Word object after adding.
		         *
		         * @example
		         *
		         *     var added = x64Word.add(anotherX64Word);
		         */
		        // add: function (word) {
		            // var low = (this.low + word.low) | 0;
		            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
		            // var high = (this.high + word.high + carry) | 0;
	
		            // return X64Word.create(high, low);
		        // }
		    });
	
		    /**
		     * An array of 64-bit words.
		     *
		     * @property {Array} words The array of CryptoJS.x64.Word objects.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var X64WordArray = C_x64.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create();
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ]);
		         *
		         *     var wordArray = CryptoJS.x64.WordArray.create([
		         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
		         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
		         *     ], 10);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 8;
		            }
		        },
	
		        /**
		         * Converts this 64-bit word array to a 32-bit word array.
		         *
		         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
		         *
		         * @example
		         *
		         *     var x32WordArray = x64WordArray.toX32();
		         */
		        toX32: function () {
		            // Shortcuts
		            var x64Words = this.words;
		            var x64WordsLength = x64Words.length;
	
		            // Convert
		            var x32Words = [];
		            for (var i = 0; i < x64WordsLength; i++) {
		                var x64Word = x64Words[i];
		                x32Words.push(x64Word.high);
		                x32Words.push(x64Word.low);
		            }
	
		            return X32WordArray.create(x32Words, this.sigBytes);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {X64WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = x64WordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
	
		            // Clone "words" array
		            var words = clone.words = this.words.slice(0);
	
		            // Clone each X64Word object
		            var wordsLength = words.length;
		            for (var i = 0; i < wordsLength; i++) {
		                words[i] = words[i].clone();
		            }
	
		            return clone;
		        }
		    });
		}());
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = function Row(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      _ref$node = _ref.node,
	      Node = _ref$node === undefined ? 'div' : _ref$node;
	  return _react2.default.createElement(
	    Node,
	    { className: (0, _classnames2.default)('row', className) },
	    children
	  );
	};
	
	Row.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  node: _propTypes2.default.node
	};
	
	exports.default = Row;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var EventPluginRegistry = __webpack_require__(794);
	var ReactEventEmitterMixin = __webpack_require__(1323);
	var ViewportMetrics = __webpack_require__(1011);
	
	var getVendorPrefixedEventName = __webpack_require__(1355);
	var isEventSupported = __webpack_require__(805);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(103);
	var ViewportMetrics = __webpack_require__(1011);
	
	var getEventModifierState = __webpack_require__(803);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	var DOMNamespaces = __webpack_require__(793);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(801);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 123 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _debounce = __webpack_require__(155);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	var win = _ExecutionEnvironment.canUseDOM ? window : {
	  devicePixelRatio: undefined,
	  innerHeight: undefined,
	  innerWidth: undefined,
	  screen: {
	    height: undefined,
	    width: undefined
	  }
	};
	
	var dimensions = {};
	var listeners = {};
	
	var Dimensions = function () {
	  function Dimensions() {
	    _classCallCheck(this, Dimensions);
	  }
	
	  Dimensions.get = function get(dimension) {
	    (0, _invariant2.default)(dimensions[dimension], 'No dimension set for key ' + dimension);
	    return dimensions[dimension];
	  };
	
	  Dimensions.set = function set(initialDimensions) {
	    if (initialDimensions) {
	      if (_ExecutionEnvironment.canUseDOM) {
	        (0, _invariant2.default)(false, 'Dimensions cannot be set in the browser');
	      } else {
	        dimensions.screen = initialDimensions.screen;
	        dimensions.window = initialDimensions.window;
	      }
	    }
	  };
	
	  Dimensions._update = function _update() {
	    dimensions.window = {
	      fontScale: 1,
	      height: win.innerHeight,
	      scale: win.devicePixelRatio || 1,
	      width: win.innerWidth
	    };
	
	    dimensions.screen = {
	      fontScale: 1,
	      height: win.screen.height,
	      scale: win.devicePixelRatio || 1,
	      width: win.screen.width
	    };
	
	    if (Array.isArray(listeners['change'])) {
	      listeners['change'].forEach(function (handler) {
	        return handler(dimensions);
	      });
	    }
	  };
	
	  Dimensions.addEventListener = function addEventListener(type, handler) {
	    listeners[type] = listeners[type] || [];
	    listeners[type].push(handler);
	  };
	
	  Dimensions.removeEventListener = function removeEventListener(type, handler) {
	    if (Array.isArray(listeners[type])) {
	      listeners[type] = listeners[type].filter(function (_handler) {
	        return _handler !== handler;
	      });
	    }
	  };
	
	  return Dimensions;
	}();
	
	exports.default = Dimensions;
	
	
	Dimensions._update();
	
	if (_ExecutionEnvironment.canUseDOM) {
	  window.addEventListener('resize', (0, _debounce2.default)(Dimensions._update, 16), false);
	}
	module.exports = exports['default'];

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _ExecutionEnvironment2 = _interopRequireDefault(_ExecutionEnvironment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var doLeftAndRightSwapInRTL = true; /**
	                                     * Copyright (c) 2016-present, Nicolas Gallagher.
	                                     * Copyright (c) 2015-present, Facebook, Inc.
	                                     *
	                                     * This source code is licensed under the MIT license found in the
	                                     * LICENSE file in the root directory of this source tree.
	                                     *
	                                     * 
	                                     */
	
	var isPreferredLanguageRTL = false;
	var isRTLAllowed = true;
	var isRTLForced = false;
	
	var isRTL = function isRTL() {
	  if (isRTLForced) {
	    return true;
	  }
	  return isRTLAllowed && isPreferredLanguageRTL;
	};
	
	var onDirectionChange = function onDirectionChange() {
	  if (_ExecutionEnvironment2.default.canUseDOM) {
	    if (document.documentElement && document.documentElement.setAttribute) {
	      document.documentElement.setAttribute('dir', isRTL() ? 'rtl' : 'ltr');
	    }
	  }
	};
	
	var I18nManager = {
	  allowRTL: function allowRTL(bool) {
	    isRTLAllowed = bool;
	    onDirectionChange();
	  },
	  forceRTL: function forceRTL(bool) {
	    isRTLForced = bool;
	    onDirectionChange();
	  },
	  setPreferredLanguageRTL: function setPreferredLanguageRTL(bool) {
	    isPreferredLanguageRTL = bool;
	    onDirectionChange();
	  },
	  swapLeftAndRightInRTL: function swapLeftAndRightInRTL(bool) {
	    doLeftAndRightSwapInRTL = bool;
	  },
	
	  get doLeftAndRightSwapInRTL() {
	    return doLeftAndRightSwapInRTL;
	  },
	  get isRTL() {
	    return isRTL();
	  }
	};
	
	exports.default = I18nManager;
	module.exports = exports['default'];

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _requestIdleCallback = __webpack_require__(1453);
	
	var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var InteractionManager = {
	  Events: {
	    interactionStart: 'interactionStart',
	    interactionComplete: 'interactionComplete'
	  },
	
	  /**
	   * Schedule a function to run after all interactions have completed.
	   */
	  runAfterInteractions: function runAfterInteractions(task) {
	    var handle = void 0;
	
	    var promise = new Promise(function (resolve) {
	      handle = (0, _requestIdleCallback2.default)(function () {
	        if (task) {
	          resolve(task());
	        }
	      });
	    });
	    return {
	      then: promise.then.bind(promise),
	      done: promise.then.bind(promise),
	      cancel: function cancel() {
	        (0, _requestIdleCallback.cancelIdleCallback)(handle);
	      }
	    };
	  },
	
	
	  /**
	   * Notify manager that an interaction has started.
	   */
	  createInteractionHandle: function createInteractionHandle() {
	    return 1;
	  },
	
	
	  /**
	   * Notify manager that an interaction has completed.
	   */
	  clearInteractionHandle: function clearInteractionHandle(handle) {
	    (0, _invariant2.default)(!!handle, 'Must provide a handle to clear.');
	  },
	
	
	  addListener: function addListener() {}
	};
	
	exports.default = InteractionManager;
	module.exports = exports['default'];

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(821);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _BoundingDimensions = __webpack_require__(1433);
	
	var _BoundingDimensions2 = _interopRequireDefault(_BoundingDimensions);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _normalizeCssColor = __webpack_require__(160);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	var _Position = __webpack_require__(1434);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TouchEventUtils = __webpack_require__(1202);
	
	var _TouchEventUtils2 = _interopRequireDefault(_TouchEventUtils);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * `Touchable`: Taps done right.
	 *
	 * You hook your `ResponderEventPlugin` events into `Touchable`. `Touchable`
	 * will measure time/geometry and tells you when to give feedback to the user.
	 *
	 * ====================== Touchable Tutorial ===============================
	 * The `Touchable` mixin helps you handle the "press" interaction. It analyzes
	 * the geometry of elements, and observes when another responder (scroll view
	 * etc) has stolen the touch lock. It notifies your component when it should
	 * give feedback to the user. (bouncing/highlighting/unhighlighting).
	 *
	 * - When a touch was activated (typically you highlight)
	 * - When a touch was deactivated (typically you unhighlight)
	 * - When a touch was "pressed" - a touch ended while still within the geometry
	 *   of the element, and no other element (like scroller) has "stolen" touch
	 *   lock ("responder") (Typically you bounce the element).
	 *
	 * A good tap interaction isn't as simple as you might think. There should be a
	 * slight delay before showing a highlight when starting a touch. If a
	 * subsequent touch move exceeds the boundary of the element, it should
	 * unhighlight, but if that same touch is brought back within the boundary, it
	 * should rehighlight again. A touch can move in and out of that boundary
	 * several times, each time toggling highlighting, but a "press" is only
	 * triggered if that touch ends while within the element's boundary and no
	 * scroller (or anything else) has stolen the lock on touches.
	 *
	 * To create a new type of component that handles interaction using the
	 * `Touchable` mixin, do the following:
	 *
	 * - Initialize the `Touchable` state.
	 *
	 *   getInitialState: function() {
	 *     return merge(this.touchableGetInitialState(), yourComponentState);
	 *   }
	 *
	 * - Choose the rendered component who's touches should start the interactive
	 *   sequence. On that rendered node, forward all `Touchable` responder
	 *   handlers. You can choose any rendered node you like. Choose a node whose
	 *   hit target you'd like to instigate the interaction sequence:
	 *
	 *   // In render function:
	 *   return (
	 *     <View
	 *       onStartShouldSetResponder={this.touchableHandleStartShouldSetResponder}
	 *       onResponderTerminationRequest={this.touchableHandleResponderTerminationRequest}
	 *       onResponderGrant={this.touchableHandleResponderGrant}
	 *       onResponderMove={this.touchableHandleResponderMove}
	 *       onResponderRelease={this.touchableHandleResponderRelease}
	 *       onResponderTerminate={this.touchableHandleResponderTerminate}>
	 *       <View>
	 *         Even though the hit detection/interactions are triggered by the
	 *         wrapping (typically larger) node, we usually end up implementing
	 *         custom logic that highlights this inner one.
	 *       </View>
	 *     </View>
	 *   );
	 *
	 * - You may set up your own handlers for each of these events, so long as you
	 *   also invoke the `touchable*` handlers inside of your custom handler.
	 *
	 * - Implement the handlers on your component class in order to provide
	 *   feedback to the user. See documentation for each of these class methods
	 *   that you should implement.
	 *
	 *   touchableHandlePress: function() {
	 *      this.performBounceAnimation();  // or whatever you want to do.
	 *   },
	 *   touchableHandleActivePressIn: function() {
	 *     this.beginHighlighting(...);  // Whatever you like to convey activation
	 *   },
	 *   touchableHandleActivePressOut: function() {
	 *     this.endHighlighting(...);  // Whatever you like to convey deactivation
	 *   },
	 *
	 * - There are more advanced methods you can implement (see documentation below):
	 *   touchableGetHighlightDelayMS: function() {
	 *     return 20;
	 *   }
	 *   // In practice, *always* use a predeclared constant (conserve memory).
	 *   touchableGetPressRectOffset: function() {
	 *     return {top: 20, left: 20, right: 20, bottom: 100};
	 *   }
	 */
	
	/**
	 * Touchable states.
	 */
	var States = {
	  NOT_RESPONDER: 'NOT_RESPONDER', // Not the responder
	  RESPONDER_INACTIVE_PRESS_IN: 'RESPONDER_INACTIVE_PRESS_IN', // Responder, inactive, in the `PressRect`
	  RESPONDER_INACTIVE_PRESS_OUT: 'RESPONDER_INACTIVE_PRESS_OUT', // Responder, inactive, out of `PressRect`
	  RESPONDER_ACTIVE_PRESS_IN: 'RESPONDER_ACTIVE_PRESS_IN', // Responder, active, in the `PressRect`
	  RESPONDER_ACTIVE_PRESS_OUT: 'RESPONDER_ACTIVE_PRESS_OUT', // Responder, active, out of `PressRect`
	  RESPONDER_ACTIVE_LONG_PRESS_IN: 'RESPONDER_ACTIVE_LONG_PRESS_IN', // Responder, active, in the `PressRect`, after long press threshold
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: 'RESPONDER_ACTIVE_LONG_PRESS_OUT', // Responder, active, out of `PressRect`, after long press threshold
	  ERROR: 'ERROR'
	};
	
	/**
	 * Quick lookup map for states that are considered to be "active"
	 */
	/* eslint-disable react/prop-types */
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var IsActive = {
	  RESPONDER_ACTIVE_PRESS_OUT: true,
	  RESPONDER_ACTIVE_PRESS_IN: true
	};
	
	/**
	 * Quick lookup for states that are considered to be "pressing" and are
	 * therefore eligible to result in a "selection" if the press stops.
	 */
	var IsPressingIn = {
	  RESPONDER_INACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_PRESS_IN: true,
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	var IsLongPressingIn = {
	  RESPONDER_ACTIVE_LONG_PRESS_IN: true
	};
	
	/**
	 * Inputs to the state machine.
	 */
	var Signals = {
	  DELAY: 'DELAY',
	  RESPONDER_GRANT: 'RESPONDER_GRANT',
	  RESPONDER_RELEASE: 'RESPONDER_RELEASE',
	  RESPONDER_TERMINATED: 'RESPONDER_TERMINATED',
	  ENTER_PRESS_RECT: 'ENTER_PRESS_RECT',
	  LEAVE_PRESS_RECT: 'LEAVE_PRESS_RECT',
	  LONG_PRESS_DETECTED: 'LONG_PRESS_DETECTED'
	};
	
	/**
	 * Mapping from States x Signals => States
	 */
	var Transitions = {
	  NOT_RESPONDER: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.ERROR,
	    RESPONDER_TERMINATED: States.ERROR,
	    ENTER_PRESS_RECT: States.ERROR,
	    LEAVE_PRESS_RECT: States.ERROR,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_IN: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_INACTIVE_PRESS_OUT: {
	    DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_IN: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
	  },
	  RESPONDER_ACTIVE_LONG_PRESS_OUT: {
	    DELAY: States.ERROR,
	    RESPONDER_GRANT: States.ERROR,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
	    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
	    LONG_PRESS_DETECTED: States.ERROR
	  },
	  error: {
	    DELAY: States.NOT_RESPONDER,
	    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
	    RESPONDER_RELEASE: States.NOT_RESPONDER,
	    RESPONDER_TERMINATED: States.NOT_RESPONDER,
	    ENTER_PRESS_RECT: States.NOT_RESPONDER,
	    LEAVE_PRESS_RECT: States.NOT_RESPONDER,
	    LONG_PRESS_DETECTED: States.NOT_RESPONDER
	  }
	};
	
	// ==== Typical Constants for integrating into UI components ====
	// var HIT_EXPAND_PX = 20;
	// var HIT_VERT_OFFSET_PX = 10;
	var HIGHLIGHT_DELAY_MS = 130;
	
	var PRESS_EXPAND_PX = 20;
	
	var LONG_PRESS_THRESHOLD = 500;
	
	var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
	
	var LONG_PRESS_ALLOWED_MOVEMENT = 10;
	
	// Default amount "active" region protrudes beyond box
	
	/**
	 * By convention, methods prefixed with underscores are meant to be @private,
	 * and not @protected. Mixers shouldn't access them - not even to provide them
	 * as callback handlers.
	 *
	 *
	 * ========== Geometry =========
	 * `Touchable` only assumes that there exists a `HitRect` node. The `PressRect`
	 * is an abstract box that is extended beyond the `HitRect`.
	 *
	 *  +--------------------------+
	 *  |                          | - "Start" events in `HitRect` cause `HitRect`
	 *  |  +--------------------+  |   to become the responder.
	 *  |  |  +--------------+  |  | - `HitRect` is typically expanded around
	 *  |  |  |              |  |  |   the `VisualRect`, but shifted downward.
	 *  |  |  |  VisualRect  |  |  | - After pressing down, after some delay,
	 *  |  |  |              |  |  |   and before letting up, the Visual React
	 *  |  |  +--------------+  |  |   will become "active". This makes it eligible
	 *  |  |     HitRect        |  |   for being highlighted (so long as the
	 *  |  +--------------------+  |   press remains in the `PressRect`).
	 *  |        PressRect     o   |
	 *  +----------------------|---+
	 *           Out Region    |
	 *                         +-----+ This gap between the `HitRect` and
	 *                                 `PressRect` allows a touch to move far away
	 *                                 from the original hit rect, and remain
	 *                                 highlighted, and eligible for a "Press".
	 *                                 Customize this via
	 *                                 `touchableGetPressRectOffset()`.
	 *
	 *
	 *
	 * ======= State Machine =======
	 *
	 * +-------------+ <---+ RESPONDER_RELEASE
	 * |NOT_RESPONDER|
	 * +-------------+ <---+ RESPONDER_TERMINATED
	 *     +
	 *     | RESPONDER_GRANT (HitRect)
	 *     v
	 * +---------------------------+  DELAY   +-------------------------+  T + DELAY     +------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_IN|+-------->|RESPONDER_ACTIVE_PRESS_IN| +------------> |RESPONDER_ACTIVE_LONG_PRESS_IN|
	 * +---------------------------+          +-------------------------+                +------------------------------+
	 *     +            ^                         +           ^                                 +           ^
	 *     |LEAVE_      |ENTER_                   |LEAVE_     |ENTER_                           |LEAVE_     |ENTER_
	 *     |PRESS_RECT  |PRESS_RECT               |PRESS_RECT |PRESS_RECT                       |PRESS_RECT |PRESS_RECT
	 *     |            |                         |           |                                 |           |
	 *     v            +                         v           +                                 v           +
	 * +----------------------------+  DELAY  +--------------------------+               +-------------------------------+
	 * |RESPONDER_INACTIVE_PRESS_OUT|+------->|RESPONDER_ACTIVE_PRESS_OUT|               |RESPONDER_ACTIVE_LONG_PRESS_OUT|
	 * +----------------------------+         +--------------------------+               +-------------------------------+
	 *
	 * T + DELAY => LONG_PRESS_DELAY_MS + DELAY
	 *
	 * Not drawn are the side effects of each transition. The most important side
	 * effect is the `touchableHandlePress` abstract method invocation that occurs
	 * when a responder is released while in either of the "Press" states.
	 *
	 * The other important side effects are the highlight abstract method
	 * invocations (internal callbacks) to be implemented by the mixer.
	 *
	 *
	 * @lends Touchable.prototype
	 */
	var TouchableMixin = {
	  // HACK (part 1): basic support for touchable interactions using a keyboard
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this._touchableNode = (0, _findNodeHandle2.default)(this);
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableBlurListener = function (e) {
	        if (_this._isTouchableKeyboardActive) {
	          if (_this.state.touchable.touchState && _this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            _this.touchableHandleResponderTerminate({ nativeEvent: e });
	          }
	          _this._isTouchableKeyboardActive = false;
	        }
	      };
	      this._touchableNode.addEventListener('blur', this._touchableBlurListener);
	    }
	  },
	
	  /**
	   * Clear all timeouts on unmount
	   */
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._touchableNode && this._touchableNode.addEventListener) {
	      this._touchableNode.removeEventListener('blur', this._touchableBlurListener);
	    }
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	  },
	
	  /**
	   * It's prefer that mixins determine state in this way, having the class
	   * explicitly mix the state in the one and only `getInitialState` method.
	   *
	   * @return {object} State object to be placed inside of
	   * `this.state.touchable`.
	   */
	  touchableGetInitialState: function touchableGetInitialState() {
	    return {
	      touchable: { touchState: undefined, responderID: null }
	    };
	  },
	
	  // ==== Hooks to Gesture Responder system ====
	  /**
	   * Must return true if embedded in a native platform scroll view.
	   */
	  touchableHandleResponderTerminationRequest: function touchableHandleResponderTerminationRequest() {
	    return !this.props.rejectResponderTermination;
	  },
	
	  /**
	   * Must return true to start the process of `Touchable`.
	   */
	  touchableHandleStartShouldSetResponder: function touchableHandleStartShouldSetResponder() {
	    return !this.props.disabled;
	  },
	
	  /**
	   * Return true to cancel press on long press.
	   */
	  touchableLongPressCancelsPress: function touchableLongPressCancelsPress() {
	    return true;
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderGrant` event.
	   */
	  touchableHandleResponderGrant: function touchableHandleResponderGrant(e) {
	    var dispatchID = e.currentTarget;
	    // Since e is used in a callback invoked on another event loop
	    // (as in setTimeout etc), we need to call e.persist() on the
	    // event to make sure it doesn't get reused in the event object pool.
	    e.persist();
	    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
	    this.pressOutDelayTimeout = null;
	
	    this.state.touchable.touchState = States.NOT_RESPONDER;
	    this.state.touchable.responderID = dispatchID;
	    this._receiveSignal(Signals.RESPONDER_GRANT, e);
	    var delayMS = this.touchableGetHighlightDelayMS !== undefined ? Math.max(this.touchableGetHighlightDelayMS(), 0) : HIGHLIGHT_DELAY_MS;
	    delayMS = isNaN(delayMS) ? HIGHLIGHT_DELAY_MS : delayMS;
	    if (delayMS !== 0) {
	      this.touchableDelayTimeout = setTimeout(this._handleDelay.bind(this, e), delayMS);
	    } else {
	      this.state.touchable.positionOnActivate = null;
	      this._handleDelay(e);
	    }
	
	    var longDelayMS = this.touchableGetLongPressDelayMS !== undefined ? Math.max(this.touchableGetLongPressDelayMS(), 10) : LONG_PRESS_DELAY_MS;
	    longDelayMS = isNaN(longDelayMS) ? LONG_PRESS_DELAY_MS : longDelayMS;
	    this.longPressDelayTimeout = setTimeout(this._handleLongDelay.bind(this, e), longDelayMS + delayMS);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderRelease` event.
	   */
	  touchableHandleResponderRelease: function touchableHandleResponderRelease(e) {
	    this._receiveSignal(Signals.RESPONDER_RELEASE, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderTerminate` event.
	   */
	  touchableHandleResponderTerminate: function touchableHandleResponderTerminate(e) {
	    this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
	  },
	
	  /**
	   * Place as callback for a DOM element's `onResponderMove` event.
	   */
	  touchableHandleResponderMove: function touchableHandleResponderMove(e) {
	    // Not enough time elapsed yet, wait for highlight -
	    // this is just a perf optimization.
	    if (this.state.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
	      return;
	    }
	
	    // Measurement may not have returned yet.
	    if (!this.state.touchable.positionOnActivate) {
	      return;
	    }
	
	    var positionOnActivate = this.state.touchable.positionOnActivate;
	    var dimensionsOnActivate = this.state.touchable.dimensionsOnActivate;
	    var pressRectOffset = this.touchableGetPressRectOffset ? this.touchableGetPressRectOffset() : {
	      left: PRESS_EXPAND_PX,
	      right: PRESS_EXPAND_PX,
	      top: PRESS_EXPAND_PX,
	      bottom: PRESS_EXPAND_PX
	    };
	
	    var pressExpandLeft = pressRectOffset.left;
	    var pressExpandTop = pressRectOffset.top;
	    var pressExpandRight = pressRectOffset.right;
	    var pressExpandBottom = pressRectOffset.bottom;
	
	    var hitSlop = this.touchableGetHitSlop ? this.touchableGetHitSlop() : null;
	
	    if (hitSlop) {
	      pressExpandLeft += hitSlop.left;
	      pressExpandTop += hitSlop.top;
	      pressExpandRight += hitSlop.right;
	      pressExpandBottom += hitSlop.bottom;
	    }
	
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	
	    if (this.pressInLocation) {
	      var movedDistance = this._getDistanceBetweenPoints(pageX, pageY, this.pressInLocation.pageX, this.pressInLocation.pageY);
	      if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
	        this._cancelLongPressDelayTimeout();
	      }
	    }
	
	    var isTouchWithinActive = pageX > positionOnActivate.left - pressExpandLeft && pageY > positionOnActivate.top - pressExpandTop && pageX < positionOnActivate.left + dimensionsOnActivate.width + pressExpandRight && pageY < positionOnActivate.top + dimensionsOnActivate.height + pressExpandBottom;
	    if (isTouchWithinActive) {
	      this._receiveSignal(Signals.ENTER_PRESS_RECT, e);
	      var curState = this.state.touchable.touchState;
	      if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
	        // fix for t7967420
	        this._cancelLongPressDelayTimeout();
	      }
	    } else {
	      this._cancelLongPressDelayTimeout();
	      this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
	    }
	  },
	
	  // ==== Abstract Application Callbacks ====
	
	  /**
	   * Invoked when the item should be highlighted. Mixers should implement this
	   * to visually distinguish the `VisualRect` so that the user knows that
	   * releasing a touch will result in a "selection" (analog to click).
	   *
	   * @abstract
	   * touchableHandleActivePressIn: function,
	   */
	
	  /**
	   * Invoked when the item is "active" (in that it is still eligible to become
	   * a "select") but the touch has left the `PressRect`. Usually the mixer will
	   * want to unhighlight the `VisualRect`. If the user (while pressing) moves
	   * back into the `PressRect` `touchableHandleActivePressIn` will be invoked
	   * again and the mixer should probably highlight the `VisualRect` again. This
	   * event will not fire on an `touchEnd/mouseUp` event, only move events while
	   * the user is depressing the mouse/touch.
	   *
	   * @abstract
	   * touchableHandleActivePressOut: function
	   */
	
	  /**
	   * Invoked when the item is "selected" - meaning the interaction ended by
	   * letting up while the item was either in the state
	   * `RESPONDER_ACTIVE_PRESS_IN` or `RESPONDER_INACTIVE_PRESS_IN`.
	   *
	   * @abstract
	   * touchableHandlePress: function
	   */
	
	  /**
	   * Invoked when the item is long pressed - meaning the interaction ended by
	   * letting up while the item was in `RESPONDER_ACTIVE_LONG_PRESS_IN`. If
	   * `touchableHandleLongPress` is *not* provided, `touchableHandlePress` will
	   * be called as it normally is. If `touchableHandleLongPress` is provided, by
	   * default any `touchableHandlePress` callback will not be invoked. To
	   * override this default behavior, override `touchableLongPressCancelsPress`
	   * to return false. As a result, `touchableHandlePress` will be called when
	   * lifting up, even if `touchableHandleLongPress` has also been called.
	   *
	   * @abstract
	   * touchableHandleLongPress: function
	   */
	
	  /**
	   * Returns the number of millis to wait before triggering a highlight.
	   *
	   * @abstract
	   * touchableGetHighlightDelayMS: function
	   */
	
	  /**
	   * Returns the amount to extend the `HitRect` into the `PressRect`. Positive
	   * numbers mean the size expands outwards.
	   *
	   * @abstract
	   * touchableGetPressRectOffset: function
	   */
	
	  // ==== Internal Logic ====
	
	  /**
	   * Measures the `HitRect` node on activation. The Bounding rectangle is with
	   * respect to viewport - not page, so adding the `pageXOffset/pageYOffset`
	   * should result in points that are in the same coordinate system as an
	   * event's `globalX/globalY` data values.
	   *
	   * - Consider caching this for the lifetime of the component, or possibly
	   *   being able to share this cache between any `ScrollMap` view.
	   *
	   * @sideeffects
	   * @private
	   */
	  _remeasureMetricsOnActivation: function _remeasureMetricsOnActivation() {
	    var tag = this.state.touchable.responderID;
	    if (tag == null) {
	      return;
	    }
	
	    _UIManager2.default.measure(tag, this._handleQueryLayout);
	  },
	
	  _handleQueryLayout: function _handleQueryLayout(x, y, width, height, globalX, globalY) {
	    // don't do anything if UIManager failed to measure node
	    if (!x && !y && !width && !height && !globalX && !globalY) {
	      return;
	    }
	    this.state.touchable.positionOnActivate && _Position2.default.release(this.state.touchable.positionOnActivate);
	    this.state.touchable.dimensionsOnActivate &&
	    // $FlowFixMe
	    _BoundingDimensions2.default.release(this.state.touchable.dimensionsOnActivate);
	    this.state.touchable.positionOnActivate = _Position2.default.getPooled(globalX, globalY);
	    // $FlowFixMe
	    this.state.touchable.dimensionsOnActivate = _BoundingDimensions2.default.getPooled(width, height);
	  },
	
	  _handleDelay: function _handleDelay(e) {
	    this.touchableDelayTimeout = null;
	    this._receiveSignal(Signals.DELAY, e);
	  },
	
	  _handleLongDelay: function _handleLongDelay(e) {
	    this.longPressDelayTimeout = null;
	    var curState = this.state.touchable.touchState;
	    if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
	      console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
	    } else {
	      this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
	    }
	  },
	
	  /**
	   * Receives a state machine signal, performs side effects of the transition
	   * and stores the new state. Validates the transition as well.
	   *
	   * @param {Signals} signal State machine signal.
	   * @throws Error if invalid state transition or unrecognized signal.
	   * @sideeffects
	   */
	  _receiveSignal: function _receiveSignal(signal, e) {
	    var responderID = this.state.touchable.responderID;
	    var curState = this.state.touchable.touchState;
	    var nextState = Transitions[curState] && Transitions[curState][signal];
	    if (!responderID && signal === Signals.RESPONDER_RELEASE) {
	      return;
	    }
	    if (!nextState) {
	      throw new Error('Unrecognized signal `' + signal + '` or state `' + curState + '` for Touchable responder `' + responderID + '`');
	    }
	    if (nextState === States.ERROR) {
	      throw new Error('Touchable cannot transition from `' + curState + '` to `' + signal + '` for responder `' + responderID + '`');
	    }
	    if (curState !== nextState) {
	      this._performSideEffectsForTransition(curState, nextState, signal, e);
	      this.state.touchable.touchState = nextState;
	    }
	  },
	
	  _cancelLongPressDelayTimeout: function _cancelLongPressDelayTimeout() {
	    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
	    this.longPressDelayTimeout = null;
	  },
	
	  _isHighlight: function _isHighlight(state) {
	    return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
	  },
	
	  _savePressInLocation: function _savePressInLocation(e) {
	    var touch = _TouchEventUtils2.default.extractSingleTouch(e.nativeEvent);
	    var pageX = touch && touch.pageX;
	    var pageY = touch && touch.pageY;
	    var locationX = touch && touch.locationX;
	    var locationY = touch && touch.locationY;
	    this.pressInLocation = { pageX: pageX, pageY: pageY, locationX: locationX, locationY: locationY };
	  },
	
	  _getDistanceBetweenPoints: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
	    var deltaX = aX - bX;
	    var deltaY = aY - bY;
	    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
	  },
	
	  /**
	   * Will perform a transition between touchable states, and identify any
	   * highlighting or unhighlighting that must be performed for this particular
	   * transition.
	   *
	   * @param {States} curState Current Touchable state.
	   * @param {States} nextState Next Touchable state.
	   * @param {Signal} signal Signal that triggered the transition.
	   * @param {Event} e Native event.
	   * @sideeffects
	   */
	  _performSideEffectsForTransition: function _performSideEffectsForTransition(curState, nextState, signal, e) {
	    var curIsHighlight = this._isHighlight(curState);
	    var newIsHighlight = this._isHighlight(nextState);
	
	    var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;
	
	    if (isFinalSignal) {
	      this._cancelLongPressDelayTimeout();
	    }
	
	    if (!IsActive[curState] && IsActive[nextState]) {
	      this._remeasureMetricsOnActivation();
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
	      this.touchableHandleLongPress && this.touchableHandleLongPress(e);
	    }
	
	    if (newIsHighlight && !curIsHighlight) {
	      this._startHighlight(e);
	    } else if (!newIsHighlight && curIsHighlight) {
	      this._endHighlight(e);
	    }
	
	    if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
	      var hasLongPressHandler = !!this.props.onLongPress;
	      var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
	      !hasLongPressHandler || // But either has no long handler
	      !this.touchableLongPressCancelsPress()); // or we're told to ignore it.
	
	      var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;
	      if (shouldInvokePress && this.touchableHandlePress) {
	        if (!newIsHighlight && !curIsHighlight) {
	          // we never highlighted because of delay, but we should highlight now
	          this._startHighlight(e);
	          this._endHighlight(e);
	        }
	        this.touchableHandlePress(e);
	      }
	    }
	
	    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
	    this.touchableDelayTimeout = null;
	  },
	
	  _startHighlight: function _startHighlight(e) {
	    this._savePressInLocation(e);
	    this.touchableHandleActivePressIn && this.touchableHandleActivePressIn(e);
	  },
	
	  _endHighlight: function _endHighlight(e) {
	    var _this2 = this;
	
	    if (this.touchableHandleActivePressOut) {
	      if (this.touchableGetPressOutDelayMS && this.touchableGetPressOutDelayMS()) {
	        this.pressOutDelayTimeout = setTimeout(function () {
	          _this2.touchableHandleActivePressOut(e);
	        }, this.touchableGetPressOutDelayMS());
	      } else {
	        this.touchableHandleActivePressOut(e);
	      }
	    }
	  },
	
	  // HACK (part 2): basic support for touchable interactions using a keyboard (including
	  // delays and longPress)
	  touchableHandleKeyEvent: function touchableHandleKeyEvent(e) {
	    var ENTER = 13;
	    var SPACE = 32;
	    var type = e.type,
	        which = e.which;
	
	    if (which === ENTER || which === SPACE) {
	      if (type === 'keydown') {
	        if (!this._isTouchableKeyboardActive) {
	          if (!this.state.touchable.touchState || this.state.touchable.touchState === States.NOT_RESPONDER) {
	            this.touchableHandleResponderGrant(e);
	            this._isTouchableKeyboardActive = true;
	          }
	        }
	      } else if (type === 'keyup') {
	        if (this._isTouchableKeyboardActive) {
	          if (this.state.touchable.touchState && this.state.touchable.touchState !== States.NOT_RESPONDER) {
	            this.touchableHandleResponderRelease(e);
	            this._isTouchableKeyboardActive = false;
	          }
	        }
	      }
	      e.stopPropagation();
	      // prevent the default behaviour unless the Touchable functions as a link
	      // and Enter is pressed
	      if (!(which === ENTER && _AccessibilityUtil2.default.propsToAriaRole(this.props) === 'link')) {
	        e.preventDefault();
	      }
	    }
	  }
	};
	
	var Touchable = {
	  Mixin: TouchableMixin,
	  TOUCH_TARGET_DEBUG: false, // Highlights all touchable targets. Toggle with Inspector.
	  /**
	   * Renders a debugging overlay to visualize touch target with hitSlop (might not work on Android).
	   */
	  renderDebugView: function renderDebugView(_ref) {
	    var color = _ref.color,
	        hitSlop = _ref.hitSlop;
	
	    if (false) {
	      if (!Touchable.TOUCH_TARGET_DEBUG) {
	        return null;
	      }
	      var debugHitSlopStyle = {};
	      hitSlop = hitSlop || { top: 0, bottom: 0, left: 0, right: 0 };
	      for (var key in hitSlop) {
	        debugHitSlopStyle[key] = -hitSlop[key];
	      }
	      var hexColor = '#' + ('00000000' + (0, _normalizeCssColor2.default)(color).toString(16)).substr(-8);
	      return _react2.default.createElement(_View2.default, {
	        pointerEvents: 'none',
	        style: Object.assign({
	          position: 'absolute',
	          borderColor: hexColor.slice(0, -2) + '55', // More opaque
	          borderWidth: 1,
	          borderStyle: 'dashed',
	          backgroundColor: hexColor.slice(0, -2) + '0F' }, debugHitSlopStyle)
	      });
	    }
	  }
	};
	
	exports.default = Touchable;
	module.exports = exports['default'];

/***/ },
/* 128 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var GLOBAL = typeof window === 'undefined' ? global : window;
	
	var setter = function(_setter, _clearer, array) {
	  return function(callback, delta) {
	    var id = _setter(function() {
	      _clearer.call(this, id);
	      callback.apply(this, arguments);
	    }.bind(this), delta);
	
	    if (!this[array]) {
	      this[array] = [id];
	    } else {
	      this[array].push(id);
	    }
	    return id;
	  };
	};
	
	var clearer = function(_clearer, array) {
	  return function(id) {
	    if (this[array]) {
	      var index = this[array].indexOf(id);
	      if (index !== -1) {
	        this[array].splice(index, 1);
	      }
	    }
	    _clearer(id);
	  };
	};
	
	var _timeouts = 'TimerMixin_timeouts';
	var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
	var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);
	
	var _intervals = 'TimerMixin_intervals';
	var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
	var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);
	
	var _immediates = 'TimerMixin_immediates';
	var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
	var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);
	
	var _rafs = 'TimerMixin_rafs';
	var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
	var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);
	
	var TimerMixin = {
	  componentWillUnmount: function() {
	    this[_timeouts] && this[_timeouts].forEach(function(id) {
	      GLOBAL.clearTimeout(id);
	    });
	    this[_timeouts] = null;
	    this[_intervals] && this[_intervals].forEach(function(id) {
	      GLOBAL.clearInterval(id);
	    });
	    this[_intervals] = null;
	    this[_immediates] && this[_immediates].forEach(function(id) {
	      GLOBAL.clearImmediate(id);
	    });
	    this[_immediates] = null;
	    this[_rafs] && this[_rafs].forEach(function(id) {
	      GLOBAL.cancelAnimationFrame(id);
	    });
	    this[_rafs] = null;
	  },
	
	  setTimeout: _setTimeout,
	  clearTimeout: _clearTimeout,
	
	  setInterval: _setInterval,
	  clearInterval: _clearInterval,
	
	  setImmediate: _setImmediate,
	  clearImmediate: _clearImmediate,
	
	  requestAnimationFrame: _requestAnimationFrame,
	  cancelAnimationFrame: _cancelAnimationFrame,
	};
	
	module.exports = TimerMixin;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(79)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLCData, XMLNode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLCData = (function(superClass) {
	    extend(XMLCData, superClass);
	
	    function XMLCData(parent, text) {
	      XMLCData.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing CDATA text");
	      }
	      this.text = this.stringify.cdata(text);
	    }
	
	    XMLCData.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLCData.prototype.toString = function(options) {
	      return this.options.writer.set(options).cdata(this);
	    };
	
	    return XMLCData;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLComment, XMLNode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLComment = (function(superClass) {
	    extend(XMLComment, superClass);
	
	    function XMLComment(parent, text) {
	      XMLComment.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing comment text");
	      }
	      this.text = this.stringify.comment(text);
	    }
	
	    XMLComment.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLComment.prototype.toString = function(options) {
	      return this.options.writer.set(options).comment(this);
	    };
	
	    return XMLComment;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDTDAttList, XMLNode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLDTDAttList = (function(superClass) {
	    extend(XMLDTDAttList, superClass);
	
	    function XMLDTDAttList(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      XMLDTDAttList.__super__.constructor.call(this, parent);
	      if (elementName == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (attributeName == null) {
	        throw new Error("Missing DTD attribute name");
	      }
	      if (!attributeType) {
	        throw new Error("Missing DTD attribute type");
	      }
	      if (!defaultValueType) {
	        throw new Error("Missing DTD attribute default");
	      }
	      if (defaultValueType.indexOf('#') !== 0) {
	        defaultValueType = '#' + defaultValueType;
	      }
	      if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) {
	        throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT");
	      }
	      if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) {
	        throw new Error("Default value only applies to #FIXED or #DEFAULT");
	      }
	      this.elementName = this.stringify.eleName(elementName);
	      this.attributeName = this.stringify.attName(attributeName);
	      this.attributeType = this.stringify.dtdAttType(attributeType);
	      this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
	      this.defaultValueType = defaultValueType;
	    }
	
	    XMLDTDAttList.prototype.toString = function(options) {
	      return this.options.writer.set(options).dtdAttList(this);
	    };
	
	    return XMLDTDAttList;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDTDElement, XMLNode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLDTDElement = (function(superClass) {
	    extend(XMLDTDElement, superClass);
	
	    function XMLDTDElement(parent, name, value) {
	      XMLDTDElement.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing DTD element name");
	      }
	      if (!value) {
	        value = '(#PCDATA)';
	      }
	      if (Array.isArray(value)) {
	        value = '(' + value.join(',') + ')';
	      }
	      this.name = this.stringify.eleName(name);
	      this.value = this.stringify.dtdElementValue(value);
	    }
	
	    XMLDTDElement.prototype.toString = function(options) {
	      return this.options.writer.set(options).dtdElement(this);
	    };
	
	    return XMLDTDElement;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDTDEntity, XMLNode, isObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(60).isObject;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLDTDEntity = (function(superClass) {
	    extend(XMLDTDEntity, superClass);
	
	    function XMLDTDEntity(parent, pe, name, value) {
	      XMLDTDEntity.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing entity name");
	      }
	      if (value == null) {
	        throw new Error("Missing entity value");
	      }
	      this.pe = !!pe;
	      this.name = this.stringify.eleName(name);
	      if (!isObject(value)) {
	        this.value = this.stringify.dtdEntityValue(value);
	      } else {
	        if (!value.pubID && !value.sysID) {
	          throw new Error("Public and/or system identifiers are required for an external entity");
	        }
	        if (value.pubID && !value.sysID) {
	          throw new Error("System identifier is required for a public external entity");
	        }
	        if (value.pubID != null) {
	          this.pubID = this.stringify.dtdPubID(value.pubID);
	        }
	        if (value.sysID != null) {
	          this.sysID = this.stringify.dtdSysID(value.sysID);
	        }
	        if (value.nData != null) {
	          this.nData = this.stringify.dtdNData(value.nData);
	        }
	        if (this.pe && this.nData) {
	          throw new Error("Notation declaration is not allowed in a parameter entity");
	        }
	      }
	    }
	
	    XMLDTDEntity.prototype.toString = function(options) {
	      return this.options.writer.set(options).dtdEntity(this);
	    };
	
	    return XMLDTDEntity;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDTDNotation, XMLNode,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLDTDNotation = (function(superClass) {
	    extend(XMLDTDNotation, superClass);
	
	    function XMLDTDNotation(parent, name, value) {
	      XMLDTDNotation.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing notation name");
	      }
	      if (!value.pubID && !value.sysID) {
	        throw new Error("Public or system identifiers are required for an external entity");
	      }
	      this.name = this.stringify.eleName(name);
	      if (value.pubID != null) {
	        this.pubID = this.stringify.dtdPubID(value.pubID);
	      }
	      if (value.sysID != null) {
	        this.sysID = this.stringify.dtdSysID(value.sysID);
	      }
	    }
	
	    XMLDTDNotation.prototype.toString = function(options) {
	      return this.options.writer.set(options).dtdNotation(this);
	    };
	
	    return XMLDTDNotation;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDeclaration, XMLNode, isObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(60).isObject;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLDeclaration = (function(superClass) {
	    extend(XMLDeclaration, superClass);
	
	    function XMLDeclaration(parent, version, encoding, standalone) {
	      var ref;
	      XMLDeclaration.__super__.constructor.call(this, parent);
	      if (isObject(version)) {
	        ref = version, version = ref.version, encoding = ref.encoding, standalone = ref.standalone;
	      }
	      if (!version) {
	        version = '1.0';
	      }
	      this.version = this.stringify.xmlVersion(version);
	      if (encoding != null) {
	        this.encoding = this.stringify.xmlEncoding(encoding);
	      }
	      if (standalone != null) {
	        this.standalone = this.stringify.xmlStandalone(standalone);
	      }
	    }
	
	    XMLDeclaration.prototype.toString = function(options) {
	      return this.options.writer.set(options).declaration(this);
	    };
	
	    return XMLDeclaration;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNode, isObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  isObject = __webpack_require__(60).isObject;
	
	  XMLNode = __webpack_require__(40);
	
	  XMLDTDAttList = __webpack_require__(132);
	
	  XMLDTDEntity = __webpack_require__(134);
	
	  XMLDTDElement = __webpack_require__(133);
	
	  XMLDTDNotation = __webpack_require__(135);
	
	  module.exports = XMLDocType = (function(superClass) {
	    extend(XMLDocType, superClass);
	
	    function XMLDocType(parent, pubID, sysID) {
	      var ref, ref1;
	      XMLDocType.__super__.constructor.call(this, parent);
	      this.documentObject = parent;
	      if (isObject(pubID)) {
	        ref = pubID, pubID = ref.pubID, sysID = ref.sysID;
	      }
	      if (sysID == null) {
	        ref1 = [pubID, sysID], sysID = ref1[0], pubID = ref1[1];
	      }
	      if (pubID != null) {
	        this.pubID = this.stringify.dtdPubID(pubID);
	      }
	      if (sysID != null) {
	        this.sysID = this.stringify.dtdSysID(sysID);
	      }
	    }
	
	    XMLDocType.prototype.element = function(name, value) {
	      var child;
	      child = new XMLDTDElement(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      var child;
	      child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.entity = function(name, value) {
	      var child;
	      child = new XMLDTDEntity(this, false, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.pEntity = function(name, value) {
	      var child;
	      child = new XMLDTDEntity(this, true, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.notation = function(name, value) {
	      var child;
	      child = new XMLDTDNotation(this, name, value);
	      this.children.push(child);
	      return this;
	    };
	
	    XMLDocType.prototype.toString = function(options) {
	      return this.options.writer.set(options).docType(this);
	    };
	
	    XMLDocType.prototype.ele = function(name, value) {
	      return this.element(name, value);
	    };
	
	    XMLDocType.prototype.att = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
	    };
	
	    XMLDocType.prototype.ent = function(name, value) {
	      return this.entity(name, value);
	    };
	
	    XMLDocType.prototype.pent = function(name, value) {
	      return this.pEntity(name, value);
	    };
	
	    XMLDocType.prototype.not = function(name, value) {
	      return this.notation(name, value);
	    };
	
	    XMLDocType.prototype.up = function() {
	      return this.root() || this.documentObject;
	    };
	
	    return XMLDocType;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLAttribute, XMLElement, XMLNode, isFunction, isObject, ref,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(60), isObject = ref.isObject, isFunction = ref.isFunction;
	
	  XMLNode = __webpack_require__(40);
	
	  XMLAttribute = __webpack_require__(1075);
	
	  module.exports = XMLElement = (function(superClass) {
	    extend(XMLElement, superClass);
	
	    function XMLElement(parent, name, attributes) {
	      XMLElement.__super__.constructor.call(this, parent);
	      if (name == null) {
	        throw new Error("Missing element name");
	      }
	      this.name = this.stringify.eleName(name);
	      this.attributes = {};
	      if (attributes != null) {
	        this.attribute(attributes);
	      }
	      if (parent.isDocument) {
	        this.isRoot = true;
	        this.documentObject = parent;
	        parent.rootObject = this;
	      }
	    }
	
	    XMLElement.prototype.clone = function() {
	      var att, attName, clonedSelf, ref1;
	      clonedSelf = Object.create(this);
	      if (clonedSelf.isRoot) {
	        clonedSelf.documentObject = null;
	      }
	      clonedSelf.attributes = {};
	      ref1 = this.attributes;
	      for (attName in ref1) {
	        if (!hasProp.call(ref1, attName)) continue;
	        att = ref1[attName];
	        clonedSelf.attributes[attName] = att.clone();
	      }
	      clonedSelf.children = [];
	      this.children.forEach(function(child) {
	        var clonedChild;
	        clonedChild = child.clone();
	        clonedChild.parent = clonedSelf;
	        return clonedSelf.children.push(clonedChild);
	      });
	      return clonedSelf;
	    };
	
	    XMLElement.prototype.attribute = function(name, value) {
	      var attName, attValue;
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (isObject(name)) {
	        for (attName in name) {
	          if (!hasProp.call(name, attName)) continue;
	          attValue = name[attName];
	          this.attribute(attName, attValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        if (!this.options.skipNullAttributes || (value != null)) {
	          this.attributes[name] = new XMLAttribute(this, name, value);
	        }
	      }
	      return this;
	    };
	
	    XMLElement.prototype.removeAttribute = function(name) {
	      var attName, i, len;
	      if (name == null) {
	        throw new Error("Missing attribute name");
	      }
	      name = name.valueOf();
	      if (Array.isArray(name)) {
	        for (i = 0, len = name.length; i < len; i++) {
	          attName = name[i];
	          delete this.attributes[attName];
	        }
	      } else {
	        delete this.attributes[name];
	      }
	      return this;
	    };
	
	    XMLElement.prototype.toString = function(options) {
	      return this.options.writer.set(options).element(this);
	    };
	
	    XMLElement.prototype.att = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    XMLElement.prototype.a = function(name, value) {
	      return this.attribute(name, value);
	    };
	
	    return XMLElement;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLNode, XMLProcessingInstruction,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLProcessingInstruction = (function(superClass) {
	    extend(XMLProcessingInstruction, superClass);
	
	    function XMLProcessingInstruction(parent, target, value) {
	      XMLProcessingInstruction.__super__.constructor.call(this, parent);
	      if (target == null) {
	        throw new Error("Missing instruction target");
	      }
	      this.target = this.stringify.insTarget(target);
	      if (value) {
	        this.value = this.stringify.insValue(value);
	      }
	    }
	
	    XMLProcessingInstruction.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLProcessingInstruction.prototype.toString = function(options) {
	      return this.options.writer.set(options).processingInstruction(this);
	    };
	
	    return XMLProcessingInstruction;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLNode, XMLRaw,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLRaw = (function(superClass) {
	    extend(XMLRaw, superClass);
	
	    function XMLRaw(parent, text) {
	      XMLRaw.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing raw text");
	      }
	      this.value = this.stringify.raw(text);
	    }
	
	    XMLRaw.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLRaw.prototype.toString = function(options) {
	      return this.options.writer.set(options).raw(this);
	    };
	
	    return XMLRaw;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLNode, XMLText,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLNode = __webpack_require__(40);
	
	  module.exports = XMLText = (function(superClass) {
	    extend(XMLText, superClass);
	
	    function XMLText(parent, text) {
	      XMLText.__super__.constructor.call(this, parent);
	      if (text == null) {
	        throw new Error("Missing element text");
	      }
	      this.value = this.stringify.eleText(text);
	    }
	
	    XMLText.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLText.prototype.toString = function(options) {
	      return this.options.writer.set(options).text(this);
	    };
	
	    return XMLText;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	
	function elementFrom(node){
		if (node.toElement) return node.toElement();
		if (node.getDOMNode) return node.getDOMNode();
		if (node.getNode) return node.getNode();
		return node;
	}
	
	module.exports = Class({
	
		// conventions
	
		toElement: function(){
			return this.element;
		},
	
		getDOMNode: function(){
			return this.toElement();
		},
	
		getNode: function(){
			return this.toElement();
		},
	
		// placement
	
		inject: function(container){
			(container.containerElement || elementFrom(container))
				.appendChild(this.element);
			return this;
		},
	
		injectBefore: function(sibling){
			var element = elementFrom(sibling);
			element.parentNode.insertBefore(this.element, element);
			return this;
		},
	
		eject: function(){
			var element = this.element, parent = element.parentNode;
			if (parent) parent.removeChild(element); // TODO: VML Nodes are dead after being ejected
			return this;
		},
	
		// events
	
		subscribe: function(type, fn, bind){
			if (typeof type != 'string'){ // listen type / fn with object
				var subscriptions = [];
				for (var t in type) subscriptions.push(this.subscribe(t, type[t]));
				return function(){ // unsubscribe
					for (var i = 0, l = subscriptions.length; i < l; i++)
						subscriptions[i]();
					return this;
				};
			} else { // listen to one
				if (!bind) bind = this;
				var bound;
				if (typeof fn === 'function'){
					bound = fn.bind ? fn.bind(bind)
						: function(){ return fn.apply(bind, arguments); };
				} else {
					bound = fn;
				}
				var element = this.element;
				if (element.addEventListener){
					element.addEventListener(type, bound, false);
					return function(){ // unsubscribe
						element.removeEventListener(type, bound, false);
						return this;
					};
				} else {
					element.attachEvent('on' + type, bound);
					return function(){ // unsubscribe
						element.detachEvent('on' + type, bound);
						return this;
					};
				}
			}
		}
	
	});


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Transform = __webpack_require__(61);
	var Element = __webpack_require__(837);
	
	var CanvasNode = Class(Transform, Element, {
		
		invalidate: function(){
			if (this.parentNode) this.parentNode.invalidate();
			if (this._layer) this._layerCache = null;
			return this;
		},
	
		_place: function(){
			this.invalidate();
		},
		
		_transform: function(){
			this.invalidate();
		},
		
		blend: function(opacity){
			if (opacity >= 1 && this._layer) this._layer = null;
			this._opacity = opacity;
			if (this.parentNode) this.parentNode.invalidate();
			return this;
		},
		
		// visibility
		
		hide: function(){
			this._invisible = true;
			if (this.parentNode) this.parentNode.invalidate();
			return this;
		},
		
		show: function(){
			this._invisible = false;
			if (this.parentNode) this.parentNode.invalidate();
			return this;
		},
		
		// interaction
		
		indicate: function(cursor, tooltip){
			this._cursor = cursor;
			this._tooltip = tooltip;
			return this.invalidate();
		},
	
		hitTest: function(x, y){
			if (this._invisible) return null;
			var point = this.inversePoint(x, y);
			if (!point) return null;
			return this.localHitTest(point.x, point.y);
		},
	
		// rendering
	
		renderTo: function(context, xx, yx, xy, yy, x, y){
			var opacity = this._opacity;
			if (opacity == null || opacity >= 1){
				return this.renderLayerTo(context, xx, yx, xy, yy, x, y);
			}
	
			// Render to a compositing layer and cache it
	
			var layer = this._layer, canvas, isDirty = true,
				w = context.canvas.width, h = context.canvas.height;
			if (layer){
				layer.setTransform(1, 0, 0, 1, 0, 0);
				canvas = layer.canvas;
				if (canvas.width < w || canvas.height < h){
					canvas.width = w;
					canvas.height = h;
				} else {
					var c = this._layerCache;
					if (c && c.xx === xx && c.yx === yx && c.xy === xy
						&& c.yy === yy && c.x === x && c.y === y){
						isDirty = false;
					} else {
						layer.clearRect(0, 0, w, h);
					}
				}
			} else {
				canvas = document.createElement('canvas');
				canvas.width = w;
				canvas.height = h;
				this._layer = layer = canvas.getContext('2d');
			}
	
			if (isDirty){
				this.renderLayerTo(layer, xx, yx, xy, yy, x, y);
				this._layerCache = {
					xx: xx,
					yx: yx,
					xy: xy,
					yy: yy,
					x: x,
					y: y
				};
			}
	
			context.globalAlpha = opacity;
			context.setTransform(1, 0, 0, 1, 0, 0);
			context.drawImage(
				canvas,
				0, 0, w, h,
				0, 0, w, h
			);
			context.globalAlpha = 1;
		}
	
	});
	
	module.exports = CanvasNode;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Transform = __webpack_require__(61);
	var Element = __webpack_require__(1080);
	var DOM = __webpack_require__(72);
	
	module.exports = Class(Element, Transform, {
	
		initialize: function(tag){
			//this.uid = uniqueID();
			var element = this.element = DOM.createElement(tag);
			//element.setAttribute('id', 'e' + this.uid);
		},
	
		_place: function(){
			if (this.parentNode){
				this._transform();
			}
		},
	
		// visibility
	
		hide: function(){
			this.element.style.display = 'none';
			return this;
		},
	
		show: function(){
			this.element.style.display = '';
			return this;
		},
	
		// interaction
	
		indicate: function(cursor, tooltip){
			if (cursor) this.element.style.cursor = cursor;
			if (tooltip) this.element.title = tooltip;
			return this;
		}
	
	});


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Path = __webpack_require__(836);
	
	var precision = 100;
	
	var round = Math.round;
	
	var VMLPath = Class(Path, {
	
		initialize: function(path){
			this.reset();
			if (path instanceof VMLPath){
				this.path = [Array.prototype.join.call(path.path, ' ')];
			} else if (path){
				if (path.applyToPath)
					path.applyToPath(this);
				else
					this.push(path);
			}
		},
	
		onReset: function(){
			this.path = [];
		},
	
		onMove: function(sx, sy, x, y){
			this.path.push('m', round(x * precision), round(y * precision));
		},
	
		onLine: function(sx, sy, x, y){
			this.path.push('l', round(x * precision), round(y * precision));
		},
	
		onBezierCurve: function(sx, sy, p1x, p1y, p2x, p2y, x, y){
			this.path.push('c',
				round(p1x * precision), round(p1y * precision),
				round(p2x * precision), round(p2y * precision),
				round(x * precision), round(y * precision)
			);
		},
	
		_arcToBezier: Path.prototype.onArc,
	
		onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
			if (rx != ry || rotation) return this._arcToBezier(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation);
			cx *= precision;
			cy *= precision;
			rx *= precision;
			this.path.push(ccw ? 'at' : 'wa',
				round(cx - rx), round(cy - rx),
				round(cx + rx), round(cy + rx),
				round(sx * precision), round(sy * precision),
				round(ex * precision), round(ey * precision)
			);
		},
	
		onClose: function(){
			this.path.push('x');
		},
	
		toVML: function(){
			return this.path.join(' ');
		}
	
	});
	
	VMLPath.prototype.toString = VMLPath.prototype.toVML;
	
	module.exports = VMLPath;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Animated = ReactNative.Animated;
	
	
	function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
	  var angleInRadians = angleInDegrees * Math.PI / 180.0;
	  var x = centerX + radius * Math.cos(angleInRadians);
	  var y = centerY + radius * Math.sin(angleInRadians);
	  return [x, y];
	}
	
	function svgArc(startAngle, endAngle, percentage, dimension) {
	  if (percentage <= 0) return null;
	  var anglesStartedEqual = startAngle == endAngle;
	
	  while (startAngle < 0) {
	    startAngle += 360;
	  }while (endAngle < 0 || endAngle < startAngle) {
	    endAngle += 360;
	  }if (percentage == 1 && startAngle == endAngle) endAngle += 359;
	
	  var portionAngle = parseFloat(endAngle - startAngle) * percentage;
	  var stopAngle = startAngle + portionAngle;
	
	  var center = dimension / 2;
	  var dist = 4 * dimension / 10;
	
	  var _polarToCartesian = polarToCartesian(center, center, dist, startAngle % 360),
	      _polarToCartesian2 = _slicedToArray(_polarToCartesian, 2),
	      sx = _polarToCartesian2[0],
	      sy = _polarToCartesian2[1];
	
	  var _polarToCartesian3 = polarToCartesian(center, center, dist, stopAngle),
	      _polarToCartesian4 = _slicedToArray(_polarToCartesian3, 2),
	      ex = _polarToCartesian4[0],
	      ey = _polarToCartesian4[1];
	
	  var flag = (stopAngle - startAngle) % 360 < 180 ? "0" : "1";
	  console.log("svgArc", "M " + ex + " " + ey + " A " + dist + " " + dist + " 0 " + flag + " 0 " + sx + " " + sy);
	  return "M " + ex + " " + ey + " A " + dist + " " + dist + " 0 " + flag + " 0 " + sx + " " + sy;
	}
	
	var MAX_FIRST_PART = .3;
	function svgCheckMark(percentage, dimension) {
	  if (percentage <= 0) return null;
	  var percentageFirstPart = Math.min(1, percentage / MAX_FIRST_PART);
	
	  var startX = 1 / 5 * dimension;
	  var startY = 1 / 2 * dimension;
	  var end1X = startX + percentageFirstPart * (2 / 5 * dimension - startX);
	  var end1Y = startY + percentageFirstPart * (7 / 10 * dimension - startY);
	  var end2X = end1X;
	  var end2Y = end1Y;
	  if (percentage > .3) {
	    var percentageSecondPart = Math.max(0, (percentage - MAX_FIRST_PART) / (1 - MAX_FIRST_PART));
	    end2X = end1X + percentage * (15 / 20 * dimension - end1X);
	    end2Y = end1Y + percentage * (7 / 20 * dimension - end1Y);
	  }
	  var d = "M " + startX + " " + startY + " L " + end1X + " " + end1Y;
	  if (percentage > .3) d += " L " + end2X + " " + end2Y;
	  console.log("svgCheckMark", d);
	  return d;
	}
	
	var CheckMarkView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: 'blue',
	      thickness: 6
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      progress: new Animated.Value(0),
	      height: -1,
	      width: -1,
	      progressVal: 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.state.progress.addListener(function (_ref) {
	      var value = _ref.value;
	
	      thisThing.setState({ progressVal: value });
	    });
	
	    setTimeout(function () {
	      thisThing._hasDoneFirstSet = true;
	      thisThing.setProgress(1);
	    }, 500);
	  },
	
	  _hasDoneFirstSet: false,
	  setProgress: function setProgress(newProgress) {
	    if (!this._hasDoneFirstSet) return;
	
	    // Animated.spring(
	    //   this.state.progress,
	    //   {
	    //     toValue: newProgress,
	    //     tension: 4,
	    //     friction: 7,
	    //   },
	    // ).start();
	
	    Animated.timing(this.state.progress, { toValue: newProgress,
	      duration: 800 }).start(function () {});
	  },
	
	  render: function render() {
	    var dimension = Math.min(this.state.width, this.state.height);
	
	    var _props = this.props,
	        color = _props.color,
	        thickness = _props.thickness,
	        otherProps = _objectWithoutProperties(_props, ['color', 'thickness']);
	
	    var ringSVG = svgArc(91, 89, this.state.progressVal, dimension);
	    var checkSVG = svgCheckMark(this.state.progressVal, dimension);
	
	    var thisThing = this;
	    console.log("ringSVG", ringSVG);
	    console.log("checkSVG", checkSVG);
	    return React.createElement(
	      View,
	      Object.assign({}, otherProps, { onLayout: function onLayout(evt) {
	          thisThing.setState({ height: evt.nativeEvent.layout.height, width: evt.nativeEvent.layout.width });
	        } }),
	      this.state.width > 0 && this.state.height > 0 ? React.createElement(
	        View,
	        { style: { width: dimension, height: dimension, backgroundColor: 'transparent', alignSelf: 'center' } },
	        React.createElement(
	          _reactNativeSvgWrapper2.default,
	          {
	            height: dimension,
	            width: dimension
	          },
	          React.createElement(
	            _reactNativeSvgWrapper.G,
	            { scale: '1' },
	            ringSVG !== null ? React.createElement(_reactNativeSvgWrapper.Path, {
	              d: ringSVG,
	              stroke: color,
	              strokeWidth: thickness,
	              strokeLinecap: "round",
	              fill: 'none'
	            }) : null,
	            checkSVG !== null ? React.createElement(_reactNativeSvgWrapper.Path, {
	              d: checkSVG,
	              stroke: color,
	              strokeWidth: thickness - 2,
	              strokeLinecap: "round",
	              fill: 'none'
	            }) : null
	          )
	        )
	      ) : null
	    );
	  }
	});
	
	module.exports = CheckMarkView;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeParallaxScrollViewWrapper = __webpack_require__(97);
	
	var _reactNativeParallaxScrollViewWrapper2 = _interopRequireDefault(_reactNativeParallaxScrollViewWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	
	var Icon = __webpack_require__(13);
	var WebView = __webpack_require__(851);
	var Keyboard = __webpack_require__(76);
	
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpCountdown = __webpack_require__(73);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MapView = __webpack_require__(78);
	var ReUpButton = __webpack_require__(12);
	var moment = __webpack_require__(3);
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner,
	    MKProgress = MK.MKProgress;
	var View = ReactNative.View,
	    Animated = ReactNative.Animated,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var dummyOrderObject = {
	  CurrentInQueue: 1,
	  OrderID: 123,
	  OrderStatus: 0,
	  StatusMessage: "Being prepared...",
	  StatusText: "Being made...",
	  TotalInQueue: 12,
	  WaitingTime: 25
	};
	
	var _cachedDistances = {};
	function calculateDistance(lat1, lon1, lat2, lon2) {
	  if (typeof lat1 === 'undefined' || typeof lon1 === 'undefined' || typeof lat2 === 'undefined' || typeof lon2 === 'undefined' || lat1 == null || lon1 == null || lat2 == null || lon2 == null || parseFloat(lat1) == 0 || parseFloat(lon1) == 0 || parseFloat(lat2) == 0 || parseFloat(lon2) == 0) {
	    return Number.MAX_VALUE;
	  }
	  var cachedKey = lat1 + "," + lon1 + "-" + lat2 + "," + lon2;
	  if (typeof _cachedDistances[cachedKey] !== 'undefined') return (_cachedDistances[cachedKey] * 1000).toFixed(2);
	
	  var radlat1 = Math.PI * lat1 / 180;
	  var radlat2 = Math.PI * lat2 / 180;
	  var theta = lon1 - lon2;
	  var radtheta = Math.PI * theta / 180;
	  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	  dist = Math.acos(dist);
	  dist = dist * 180 / Math.PI;
	  dist = dist * 60 * 1.1515;
	
	  _cachedDistances[cachedKey] = dist;
	
	  return (_cachedDistances[cachedKey] * 1000).toFixed(2);
	}
	
	function getLocationInfo(location) {
	  var latitude = typeof location.latitude !== 'undefined' ? location.latitude : typeof location.Address !== 'undefined' && location.Address.Latitude !== 'undefined' ? location.Address.Latitude : 0;
	  var longitude = typeof location.longitude !== 'undefined' ? location.longitude : typeof location.Address !== 'undefined' && location.Address.Longitude !== 'undefined' ? location.Address.Longitude : 0;
	  var name = typeof location.name !== 'undefined' ? location.name : location.Name;
	  var address = typeof location.address !== 'undefined' ? location.address.trim() : (location.Address.Line1 + " " + location.Address.Line2).trim();
	  var storeID = typeof location.store_id !== 'undefined' ? location.store_id : location.LocationID;
	  var url = typeof location.url !== 'undefined' ? location.url : location.GrabbURL;
	
	  return { latitude: latitude, longitude: longitude, name: name, address: address, storeID: storeID, url: url };
	}
	
	function getParameterByName(url, name) {
	  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	      results = regex.exec(url);
	  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	
	var ACTIVE_ORDER_EXPIRY_SECONDS = 60 * 5;
	var ACTIVE_ORDER_DISMISS_KEY = "ACTIVE_ORDER_DISMISS_KEY";
	var LAST_ACTIVE_ORDER_STORE_ID = "LAST_ACTIVE_ORDER_STORE_ID";
	
	var OrderAhead = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    var hasCurrentPosition = this.props.appManager.hasCurrentPosition();
	
	    return {
	      locations: [],
	      filteredLocations: [],
	      layout: this.props.initialLayout,
	      shouldShowX: false,
	      searchQuery: "",
	      searchKey: 0,
	      selectedLocation: null,
	      modalOpacity: new Animated.Value(0),
	      isWebViewLoading: false,
	      webViewLoadingOpacity: new Animated.Value(1),
	      progressOpacity: new Animated.Value(0),
	      mapView: React.createElement(View, null),
	      currentPosition: this.props.appManager.getCurrentPosition(),
	      instructionHeight: 0,
	      parallaxHeaderHeight: this.props.initialLayout.height / 2,
	      activeOrders: null,
	      showOneLocation: hasCurrentPosition,
	      orderIsReady: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.props.appManager.updateCurrentPosition(function () {
	      // if location is different, then do an update
	      setTimeout(function () {
	        thisThing.forceUpdate();
	      }, 1000);
	      if (typeof thisThing.refs.parallax !== 'undefined' && typeof thisThing.refs.parallax.refs.ScrollView !== 'undefined' && typeof thisThing.refs.parallax.refs.ScrollView.doOnlineUpdate !== 'undefined') thisThing.refs.parallax.refs.ScrollView.doOnlineUpdate();else if (thisThing.refs.ptr) thisThing.refs.ptr.doOnlineUpdate();
	    });
	
	    setTimeout(function () {
	      Animated.timing(thisThing.state.progressOpacity, { toValue: 1,
	        duration: 0 }).start(function () {});
	    }, 0);
	
	    setTimeout(function () {
	      thisThing.updateActiveOrders(function () {});
	    }, 200);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    LinkingManager.removeDismissListener();
	  },
	
	  _markers: null,
	  didUpdate: function didUpdate(data) {
	    var _this = this;
	
	    if (this._disableUpdate) return;
	    //
	    // TODO: this is rendering 7 god damn times, fix that shit...
	    //
	    if (typeof data.OrderingLocations !== 'undefined' && data.OrderingLocations != null && (this.state.locations.length <= 0 || data.OrderingLocations.length > 0)) {
	      var locations = data.OrderingLocations;
	      var currentPosition = this.props.appManager.getCurrentPosition();
	      var locManager = this.props.appManager.getLocalizationManager();
	      var markerTitle = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_TITLE");
	      var markerBody = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_BODY");
	      var refinedLocations = [];
	      var storeIDs = [];
	      for (var i = 0; i < locations.length; i++) {
	        var loc = locations[i];
	
	        var _getLocationInfo = getLocationInfo(loc),
	            latitude = _getLocationInfo.latitude,
	            longitude = _getLocationInfo.longitude,
	            storeID = _getLocationInfo.storeID;
	
	        if (storeIDs.indexOf(storeID) >= 0) continue;
	
	        // if we came to this location while logged out, lets automatically go back there
	        if (this.props.appManager._loggedOutOrderingStoreIDSelected == storeID) this.didSelectLocation(loc);
	
	        storeIDs.push(storeID);
	        loc.distance = calculateDistance(latitude, longitude, currentPosition.latitude, currentPosition.longitude);
	        if (typeof loc.ActiveOrders !== 'undefined') loc.active_orders = loc.ActiveOrders;
	        refinedLocations.push(loc);
	      }
	      locations = refinedLocations;
	
	      var thisThing = this;
	      this.props.appManager.getVariable(LAST_ACTIVE_ORDER_STORE_ID, function (last_active_order_store_id) {
	        locations = locations.sort(function (a, b) {
	          var locInfoA = getLocationInfo(a);
	          var locInfoB = getLocationInfo(b);
	          if (last_active_order_store_id != null) {
	            if (locInfoA.storeID == last_active_order_store_id) return -1;
	            if (locInfoB.storeID == last_active_order_store_id) return 1;
	          }
	          if (a.distance == b.distance) return locInfoA.name.localeCompare(locInfoB.name);
	
	          return a.distance - b.distance;
	        });
	
	        var hasStartedPoll = false;
	        var filteredLocations = thisThing.filterItems(locations, thisThing._searchQuery);
	        for (var i = 0; i < locations.length; i++) {
	          if (typeof locations[i].active_orders !== 'undefined' && locations[i].active_orders != null && locations[i].active_orders.length > 0 && !hasStartedPoll) {
	            _this._activeGrabbLocationID = locations[i].LocationID;
	            _this._activeGrabbToken = locations[i].Token;
	            var locInfo = getLocationInfo(locations[i]);
	            if (typeof locInfo.storeID !== 'undefined') thisThing.props.appManager.setVariable(LAST_ACTIVE_ORDER_STORE_ID, locInfo.storeID, function () {});
	
	            hasStartedPoll = true;
	            thisThing.filterActiveOrders(locations[i].active_orders, function (filteredActiveOrders) {
	              thisThing.setState({ activeOrders: filteredActiveOrders, locations: locations, filteredLocations: filteredLocations });
	              thisThing.queueToPollActiveOrders();
	            });
	          }
	        }
	        thisThing.state.locations = locations;
	        thisThing.setState({ locations: locations, filteredLocations: filteredLocations });
	
	        var allMarkers = [];
	        var region = null;
	        for (var i = 0; i < locations.length; i++) {
	          var _getLocationInfo2 = getLocationInfo(locations[i]),
	              latitude = _getLocationInfo2.latitude,
	              longitude = _getLocationInfo2.longitude,
	              name = _getLocationInfo2.name,
	              address = _getLocationInfo2.address;
	
	          if (region == null) {
	            region = {
	              latitude: parseFloat(latitude),
	              longitude: parseFloat(longitude),
	              latitudeDelta: 0.01,
	              longitudeDelta: 0.01
	            };
	          }
	          allMarkers.push({
	            latlng: {
	              latitude: parseFloat(latitude),
	              longitude: parseFloat(longitude)
	            },
	            title: name,
	            description: address
	          });
	          // TODO: rethink this
	          if (i >= 20) break;
	        }
	        if (thisThing._markers != JSON.stringify(allMarkers)) {
	          thisThing.setState({ mapView: React.createElement(
	              MapView,
	              { key: 'mapview',
	                region: region,
	                onRegionChange: thisThing.onRegionChange,
	                style: { width: thisThing.state.layout.width, flex: 1 }
	              },
	              allMarkers.map(function (marker) {
	                return React.createElement(MapView.Marker, {
	                  coordinate: marker.latlng,
	                  title: marker.title,
	                  description: marker.description
	                });
	              }),
	              React.createElement(MapView.Marker, {
	                coordinate: currentPosition,
	                title: markerTitle,
	                description: markerBody,
	                pinColor: 'blue'
	              })
	            ) });
	          thisThing._markers = JSON.stringify(allMarkers);
	        }
	      });
	    }
	  },
	
	  _queuedToPollActiveOrder: false,
	  POLL_ACTIVE_ORDER_DELAY: 5000,
	  pollActiveOrderTimeout: null,
	  queueToPollActiveOrders: function queueToPollActiveOrders(activeOrders) {
	    var thisThing = this;
	    if (typeof activeOrders !== 'undefined') this.setState({ activeOrders: activeOrders });
	    if (thisThing.pollActiveOrderTimeout != null) clearTimeout(thisThing.pollActiveOrderTimeout);
	
	    this.pollActiveOrderTimeout = setTimeout(function () {
	      thisThing.pollActiveOrderTimeout = null;
	      thisThing.updateActiveOrders(function (shouldUpdateAgain) {
	        if (shouldUpdateAgain) thisThing.queueToPollActiveOrders();
	      });
	    }, this.POLL_ACTIVE_ORDER_DELAY);
	  },
	
	  filterActiveOrders: function filterActiveOrders(activeOrders, completion) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var date = new Date().getTime();
	
	    var shouldUpdate = typeof activeOrders !== 'undefined' && date != null && activeOrders.length > 0 || typeof thisThing.state.activeOrders === 'undefined' || thisThing.state.activeOrders == null;
	    if (shouldUpdate && thisThing.state.activeOrders != null && thisThing.state.activeOrders.length > 0 && activeOrders.length > 0) {
	      var oldOrder = thisThing.state.activeOrders[0];
	      var newOrder = activeOrders[0];
	      shouldUpdate = shouldUpdate && (oldOrder.store_id != newOrder.store_id || oldOrder.invoice_id != newOrder.invoice_id || oldOrder.store_invoice_id != newOrder.store_invoice_id || oldOrder.status != newOrder.status //||
	      // oldOrder.ready_time_seconds != newOrder.ready_time_seconds
	      );
	      var hasCountdown = typeof thisThing._countdown !== 'undefined' && thisThing._countdown != null;
	    }
	    shouldUpdate = shouldUpdate || activeOrders.length <= 0;
	
	    //
	    // choose wether to use ready_time_seconds or not
	    //
	    if (activeOrders.length > 0 && typeof activeOrders[0].ready_time_seconds !== 'undefined') {
	      var filteredActiveOrders = [];
	      var nowSeconds = new Date().getTime() / 1000;
	      appManager.getVariable(ACTIVE_ORDER_DISMISS_KEY, function (shouldIgnoreBelowReadyThisReadyTimeSeconds) {
	        if (shouldIgnoreBelowReadyThisReadyTimeSeconds == null) shouldIgnoreBelowReadyThisReadyTimeSeconds = 0;
	        shouldIgnoreBelowReadyThisReadyTimeSeconds = parseInt(shouldIgnoreBelowReadyThisReadyTimeSeconds);
	        for (var i = 0; activeOrders != null && i < activeOrders.length; i++) {
	          var readyTimeSeconds = parseInt(activeOrders[i].ready_time_seconds);
	          var secondsSinceReady = nowSeconds - readyTimeSeconds;
	          if (secondsSinceReady < ACTIVE_ORDER_EXPIRY_SECONDS && readyTimeSeconds > shouldIgnoreBelowReadyThisReadyTimeSeconds) {
	            filteredActiveOrders.push(activeOrders[i]);
	          }
	        }
	
	        if (shouldUpdate && activeOrders.length > 0) thisThing.setState({ activeOrders: filteredActiveOrders, orderIsReady: false });
	        if (filteredActiveOrders.length > 0 && hasCountdown && typeof filteredActiveOrders[0].ready_time_seconds !== 'undefined') {
	          thisThing._countdown.startCountdown(moment(filteredActiveOrders[0].ready_time_seconds * 1000).toDate());
	        }
	
	        if (activeOrders.length <= 0) {
	          if (thisThing.refs.parallax && typeof thisThing.refs.parallax.refs.ScrollView !== 'undefined' && typeof thisThing.refs.parallax.refs.ScrollView.doOnlineUpdate !== 'undefined') thisThing.refs.parallax.refs.ScrollView.doOnlineUpdate();else if (thisThing.refs.ptr) thisThing.refs.ptr.doOnlineUpdate();
	        }
	        completion(filteredActiveOrders);
	      });
	    } else {
	      thisThing.setState({ activeOrders: activeOrders, orderIsReady: false });
	      completion(activeOrders);
	    }
	  },
	
	  _activeGrabbLocationID: "", // only important for grabb
	  _activeGrabbToken: "",
	  updateActiveOrders: function updateActiveOrders(completion) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var date = new Date().getTime();
	    var merchantID = null;
	    var currentDateTime = null;
	    var orderingType = null;
	    if (typeof appManager.getFeatureForName("Auphan") !== 'undefined') {
	      orderingType = "AUPHAN";
	      merchantID = appManager.getFeatureForName("Auphan").data.franchise_id;
	      currentDateTime = appManager.getLocalizationManager().dateTimeAuphan(date);
	    } else if (typeof appManager.getFeatureForName("Grabb") !== 'undefined') {
	      orderingType = "GRABB";
	      merchantID = appManager.getFeatureForName("Grabb").data.merchantID;
	      currentDateTime = appManager.getLocalizationManager().dateTimeGrabb(date);
	    }
	    var locations = this.state.locations;
	    for (var i = 0; i < locations.length; i++) {
	      if (typeof locations[i].ActiveOrders === 'undefined') locations[i].active_orders = locations[i].ActiveOrders;
	      if (typeof locations[i].active_orders !== 'undefined' && locations[i].active_orders != null && locations[i].active_orders.length > 0) {
	
	        this._activeGrabbLocationID = locations[i].LocationID;
	        this._activeGrabbToken = locations[i].Token;
	      }
	    }
	    NetworkManager.getActiveOrders(appManager, orderingType, merchantID, this._activeGrabbLocationID, this._activeGrabbToken, currentDateTime, "", "", function (activeOrders) {
	      var refinedActiveOrders = [];
	      for (var i = 0; i < activeOrders.length; i++) {
	        var refinedActiveOrder = activeOrders[i];
	        // Auphan
	        if (typeof activeOrders[i].store_id !== 'undefined') refinedActiveOrder.store_id = activeOrders[i].store_id;
	        if (typeof activeOrders[i].order_id !== 'undefined') refinedActiveOrder.order_id = activeOrders[i].order_id;
	        if (typeof activeOrders[i].ready_time_seconds !== 'undefined') refinedActiveOrder.ready_time_seconds = activeOrders[i].ready_time_seconds;
	
	        // Grabb
	        if (typeof activeOrders[i].LocationID !== 'undefined') refinedActiveOrder.store_id = activeOrders[i].LocationID;
	        if (typeof activeOrders[i].OrderStatus !== 'undefined') refinedActiveOrder.status = activeOrders[i].OrderStatus;
	        if (typeof activeOrders[i].OrderId !== 'undefined') refinedActiveOrder.order_id = activeOrders[i].OrderId;
	
	        refinedActiveOrders.push(refinedActiveOrder);
	      }
	
	      thisThing.filterActiveOrders(refinedActiveOrders, function (filteredActiveOrders) {
	        completion(typeof filteredActiveOrders !== 'undefined' && filteredActiveOrders != null && filteredActiveOrders.length > 0);
	      });
	    }, function () {
	      completion(true);
	    }, function () {
	      completion(true);
	    });
	  },
	
	  _searchQuery: "",
	  searchChanged: function searchChanged(newText) {
	    var thisThing = this;
	    var shouldShowX = newText.length > 0;
	    if (shouldShowX != this.state.shouldShowX) {
	      this.setState({ shouldShowX: shouldShowX });
	    }
	    if (newText != this._searchQuery) {
	      var filteredLocations = [];
	      if (newText.length > this._searchQuery.length) {
	        // only removing from current
	        filteredLocations = this.filterItems(this.state.filteredLocations, newText);
	      } else {
	        filteredLocations = this.filterItems(this.state.locations, newText);
	      }
	      if (filteredLocations.length != this.state.filteredLocations.length) {
	        this.setState({ filteredLocations: filteredLocations });
	      }
	    }
	    this._searchQuery = newText;
	  },
	
	  filterItems: function filterItems(items, query) {
	    var output = [];
	    var terms = query.toLowerCase().split(" ");
	    for (var i = 0; i < items.length; i++) {
	      var _getLocationInfo3 = getLocationInfo(items[i]),
	          address = _getLocationInfo3.address,
	          name = _getLocationInfo3.name;
	
	      var item = (address + " " + name).toLowerCase();
	      var shouldAdd = true;
	      for (var j = 0; j < terms.length; j++) {
	        if (terms[j].length <= 0) continue;
	        if (item.indexOf(terms[j]) <= -1) {
	          shouldAdd = false;
	          break;
	        }
	      }
	      if (shouldAdd) output.push(items[i]);
	    }
	
	    return output;
	  },
	
	  didSelectLocation: function didSelectLocation(selectedLocation) {
	    var _React$createElement;
	
	    if (selectedLocation["RequiresLogin"]) {
	      this.doLogin();
	      return;
	    }
	
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    var navLayout = this.props.appActions.navLayout;
	    var titleFontSize = 24;
	
	    var _getLocationInfo4 = getLocationInfo(selectedLocation),
	        name = _getLocationInfo4.name,
	        address = _getLocationInfo4.address,
	        url = _getLocationInfo4.url,
	        storeID = _getLocationInfo4.storeID;
	
	    var title = name;
	    if (title.length > 12) titleFontSize = 14;
	
	    // hack to allow the logged out ordering location to be automatically navigated to after logging in
	    if (!appManager.isLoggedIn()) appManager._loggedOutOrderingStoreIDSelected = storeID;else appManager._loggedOutOrderingStoreIDSelected = null;
	
	    var patchPostMessageFunction = function patchPostMessageFunction() {
	      var originalPostMessage = window.postMessage;
	
	      var patchedPostMessage = function patchedPostMessage(message, targetOrigin, transfer) {
	        originalPostMessage(message, targetOrigin, transfer);
	      };
	
	      patchedPostMessage.toString = function () {
	        return String(Object.hasOwnProperty).replace('hasOwnProperty', 'postMessage');
	      };
	
	      window.postMessage = patchedPostMessage;
	    };
	
	    var patchPostMessageJsCode = '(' + String(patchPostMessageFunction) + ')();';
	
	    var injectedJavaScript = Platform.OS == 'ios' ? patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.webkit.messageHandlers.reactNative.postMessage({data: {url:window.location.href}});},200);" : patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.postMessage(JSON.stringify({url:window.location.href}));},200);";
	
	    // putting this here to get rid of reborn
	    injectedJavaScript = patchPostMessageJsCode + "; document.addEventListener(\"touchmove\", ()=>{}, false); window.setInterval(()=>{window.postMessage(JSON.stringify({url:window.location.href}));},200);";
	
	    this._locationURL = "";
	
	    var alert = React.createElement(
	      View,
	      { style: { flexDirection: 'column', height: navLayout.height } },
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column', flex: 1, width: this.state.width, height: navLayout.height } },
	        React.createElement(
	          View,
	          { style: { backgroundColor: appManager.getColorForKey("HeaderColor"), paddingTop: Globals.STATUS_BAR_HEIGHT, flexDirection: 'row', height: Globals.ACTION_BAR_HEIGHT, width: this.state.layout.width, alignItems: 'center' } },
	          React.createElement(
	            View,
	            { style: { width: 50, backgroundColor: 'transparent', height: Globals.ACTION_BAR_HEIGHT, alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(ReUpIconButton, { iconName: "times", type: 2,
	              appManager: appManager,
	              onPress: function onPress() {
	                if (thisThing._modalOpen) {
	                  thisThing._webView.injectJavaScript("ReUpCloseAllModals()");
	                  thisThing._modalOpen = false;
	                } else {
	                  thisThing.props.appActions.hideAlert();
	                  thisThing.props.appManager._loggedOutOrderingStoreIDSelected = null;
	                  thisThing.updateActiveOrders(function (shouldUpdateAgain) {
	                    if (shouldUpdateAgain) thisThing.queueToPollActiveOrders();
	                  });
	                }
	              }
	            })
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent', paddingHorizontal: 10 } },
	            React.createElement(
	              View,
	              { style: { alignSelf: 'center', alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{
	                    fontSize: titleFontSize,
	                    fontWeight: '500',
	                    textAlign: 'center'
	                  }, { color: appManager.getColorForKey("HeaderTitleColor") }] },
	                title
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { width: 50, height: Globals.ACTION_BAR_HEIGHT, alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(ReUpIconButton, { iconName: "refresh", type: 2,
	              appManager: appManager,
	              onPress: function onPress() {
	                if (typeof thisThing._webView !== 'undefined') {
	                  thisThing._webView.reload();
	                  // thisThing._webView.injectJavaScript("jQuery.trigger('menu.reup');");
	                }
	              }
	            })
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { flex: 1, width: this.state.layout.width, flexDirection: 'column' } },
	          React.createElement(WebView, (_React$createElement = {
	            ref: function ref(a) {
	              thisThing._webView = a;
	            },
	            onMessage: function onMessage(event) {
	              if (typeof event === 'undefined' || event == null) return;
	              // probably ios
	              if (typeof event.body !== 'undefined' && typeof event.body.data !== 'undefined' && typeof event.body.data.url !== 'undefined') {
	                thisThing.setLocationURL(event.body.data.url);
	              }
	              // probably android
	              else if (typeof event.nativeEvent !== 'undefined' && typeof event.nativeEvent.data !== 'undefined') {
	                  try {
	                    var data = JSON.parse(event.nativeEvent.data);
	                    if (typeof data.url !== 'undefined') {
	                      thisThing.setLocationURL(data.url);
	                    }
	                  } catch (e) {}
	                }
	            },
	            javaScriptEnabled: true,
	            domStorageEnabled: true,
	            scrollEventThrottle: 20,
	            injectedJavaScript: injectedJavaScript,
	            startInLoadingState: false,
	            decelerationRate: 'normal'
	          }, _defineProperty(_React$createElement, 'startInLoadingState', true), _defineProperty(_React$createElement, 'onLoad', thisThing.webViewLoaded), _defineProperty(_React$createElement, 'source', { uri: url }), _defineProperty(_React$createElement, 'style', { width: navLayout.width, flex: 1 }), _defineProperty(_React$createElement, 'renderLoading', function renderLoading() {
	            return React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { alignSelf: 'center', marginTop: thisThing.state.layout.height / 2 } });
	          }), _React$createElement))
	        )
	      )
	    );
	
	    this.props.appActions.setCustomAlertShown(true, alert, function () {}, true);
	  },
	
	  _locationURL: "",
	  _modalOpen: false,
	  _checkoutOpen: false,
	  setLocationURL: function setLocationURL(newURL) {
	    // console.log("new url: ", newURL)
	    if (this._locationURL != newURL) {
	      this._locationURL = newURL;
	
	      // detect if a modal is open and have the "x" override to close the modal
	      this._modalOpen = getParameterByName(newURL, "modalOpen") == "true";
	      this._checkoutOpen = getParameterByName(newURL, "checkoutOpen") == "true";
	
	      if (this._checkoutOpen) {
	        this.doLogin();
	      } else {
	        // auphan has a url change that includes the file order_type_time.php, so check for that
	        var isCheckingOut = this._locationURL.indexOf("order_type_time.php") >= 0;
	        if (isCheckingOut) this.doLogin();
	      }
	    }
	  },
	
	  doLogin: function doLogin() {
	    if (this.props.appManager.isLoggedIn()) return;
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var alertTitle = this.props.appManager.getLocalizationManager().localizedStringForKey("ORDER_AHEAD_LOGIN_ALERT_TITLE", "Requires Login");
	    var alertBody = this.props.appManager.getLocalizationManager().localizedStringForKey("ORDER_AHEAD_LOGIN_ALERT_BODY", "Please log in or create your account to place your order.");
	    var alertButton = this.props.appManager.getLocalizationManager().localizedStringForKey("LOGIN_BUTTON");
	    appActions.hideAlert();
	    appActions.showLocalizedAlert(alertTitle, alertBody, [alertButton], [function () {
	      appActions.hideAlert();
	      appActions.requestFeatureName('Login', {}, false, function () {
	        appManager.setData({ "OrderingLocations": [] }, function () {
	          if (typeof appManager.getFeatureForName("Grabb") !== 'undefined') appActions.requestFeatureName('Grabb', { shouldSpinUntilUpdated: true }, false, function () {}, true);else if (typeof appManager.getFeatureForName("Auphan") !== 'undefined') appActions.requestFeatureName('Auphan', { shouldSpinUntilUpdated: true }, false, function () {}, true);else if (typeof appManager.getFeatureForName("OrderAhead") !== 'undefined') appActions.requestFeatureName('OrderAhead', { shouldSpinUntilUpdated: true }, false, function () {}, true);
	        });
	      }, true, false);
	    }], function () {});
	  },
	
	  didSelectMap: function didSelectMap() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    var navLayout = this.props.appActions.navLayout;
	
	    var alert = React.createElement(
	      View,
	      { style: { flexDirection: 'column', backgroundColor: appManager.getColorForKey("GeneralColor"), height: navLayout.height } },
	      this.state.mapView,
	      React.createElement(
	        View,
	        { style: { position: 'absolute', bottom: 10, left: 10, right: 10 } },
	        React.createElement(ReUpButton, { appManager: appManager, onPress: function onPress() {
	            thisThing.props.appActions.setCustomAlertShown(false);
	          },
	          text: locManager.localizedStringForKey("CLOSE_MAP_BUTTON") })
	      )
	    );
	
	    this.props.appActions.setCustomAlertShown(true, alert, function () {}, true);
	  },
	
	  didSelectLocationMap: function didSelectLocationMap(location) {
	    var _getLocationInfo5 = getLocationInfo(location),
	        latitude = _getLocationInfo5.latitude,
	        longitude = _getLocationInfo5.longitude;
	    // "https://www.google.com/maps/preview/@-15.623037,18.388672,8z"
	
	
	    var url = "https://www.google.com/maps?q=" + latitude + "," + longitude;
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.openURL(url, tintColor, barTintColor);
	  },
	
	  webViewLoaded: function webViewLoaded() {
	    var thisThing = this;
	    setTimeout(function () {
	      Animated.timing(thisThing.state.webViewLoadingOpacity, { toValue: 0,
	        duration: 500 }).start(function () {
	        thisThing.setState({ isWebViewLoading: false });
	      });
	    }, 500);
	  },
	
	  showLocationInfo: function showLocationInfo(location) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var okButton = "Absorb";
	
	    var _getLocationInfo6 = getLocationInfo(location),
	        name = _getLocationInfo6.name,
	        address = _getLocationInfo6.address;
	
	    var title = name;
	    var body = address;
	
	    var hoursDelivery = [];
	    var hoursPickup = [];
	    var shouldShowPickup = false;
	    var shouldShowDelivery = false;
	    if (typeof location.hours !== 'undefined' && location.hours.length > 0) {
	      var dayNames = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
	      for (var i = 0; i < location.hours.length; i++) {
	        var hourDelivery = location.hours[i].delivery;
	        if (typeof hourDelivery !== 'undefined') {
	          var openTimeParts = typeof hourDelivery[0] !== 'undefined' && hourDelivery[0].length > 0 ? hourDelivery[0][0].split(":") : [];
	          var openTime = openTimeParts.length >= 2 ? openTimeParts[0] + ":" + openTimeParts[1] : "";
	          var closedTimeParts = typeof hourDelivery[0] !== 'undefined' && hourDelivery[0].length > 1 ? hourDelivery[0][1].split(":") : [];
	          var closedTime = closedTimeParts.length >= 2 ? closedTimeParts[0] + ":" + closedTimeParts[1] : "";
	          var isActive = openTime != closedTime;
	          if (isActive) shouldShowDelivery = true;
	          hoursDelivery.push({ dayName: locManager.nameOfDay(i), timeFrom: locManager.localizedTime(openTime), timeTill: locManager.localizedTime(closedTime), isActive: isActive });
	        }
	
	        var hourPickup = location.hours[i].pickup;
	        if (typeof hourPickup !== 'undefined') {
	          var openTimeParts = typeof hourPickup[0] !== 'undefined' && hourPickup[0].length > 0 ? hourPickup[0][0].split(":") : [];
	          var openTime = openTimeParts.length >= 2 ? openTimeParts[0] + ":" + openTimeParts[1] : "";
	          var closedTimeParts = typeof hourPickup[0] !== 'undefined' && hourPickup[0].length > 1 ? hourPickup[0][1].split(":") : [];
	          var closedTime = closedTimeParts.length >= 2 ? closedTimeParts[0] + ":" + closedTimeParts[1] : "";
	          var isActive = openTime != closedTime;
	          if (isActive) shouldShowPickup = true;
	          hoursPickup.push({ dayName: locManager.nameOfDay(i), timeFrom: locManager.localizedTime(openTime), timeTill: locManager.localizedTime(closedTime), isActive: isActive });
	        }
	      }
	    }
	
	    if (typeof location.Hours !== 'undefined' && location.Hours.length > 0) {
	      for (var i = 0; i < location.Hours.length; i++) {
	        var hour = location.Hours[i];
	        var openTimeParts = typeof hour.OpenTime !== 'undefined' ? hour.OpenTime.split(":") : [];
	        var openTime = openTimeParts.length >= 2 ? openTimeParts[0] + ":" + openTimeParts[1] : "";
	        var closedTimeParts = typeof hour.ClosedTime !== 'undefined' ? hour.ClosedTime.split(":") : [];
	        var closedTime = closedTimeParts.length >= 2 ? closedTimeParts[0] + ":" + closedTimeParts[1] : "";
	        var isActive = hour.OpenTime != hour.ClosedTime;
	        if (isActive) shouldShowPickup = true;
	        hoursPickup.push({ dayName: hour.DayOfWeek, timeFrom: locManager.localizedTime(openTime), timeTill: locManager.localizedTime(closedTime), isActive: isActive });
	      }
	    }
	
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	
	    var closedLabel = "closed";
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 4, marginLeft: 4, marginRight: 4 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        MKButton,
	        { onPress: function onPress() {
	            thisThing.didSelectLocationMap(location);
	          }, maskBorderRadius: 0,
	          rippleColor: primaryButtonColorLight },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', marginVertical: 4, flex: 1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(View, { style: { width: 30 } }),
	            React.createElement(
	              View,
	              { style: { flex: 1 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: { textAlign: 'center' } },
	                title
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { width: 30, alignSelf: 'flex-start', flexDirection: 'row' } },
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(Icon, { name: "map", size: 13, color: generalTitleColor })
	            )
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: _defineProperty({ marginTop: 10, textAlign: 'left' }, 'textAlign', 'center') },
	            body
	          )
	        )
	      ),
	      React.createElement(
	        View,
	        null,
	        shouldShowPickup ? React.createElement(
	          View,
	          { style: { alignItems: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { justifyContent: 'center', alignSelf: 'center', marginTop: 4, marginBottom: 8 } },
	            React.createElement(
	              ReUpText,
	              null,
	              locManager.localizedStringForKey("FOR_PICK_UP_LABEL")
	            )
	          ),
	          hoursPickup.map(function (hour, index) {
	            var isClosed = !hour.isActive;
	            var dayName = hour.dayName;
	            var time = isClosed ? closedLabel : hour.timeFrom + " - " + hour.timeTill;
	            return React.createElement(
	              View,
	              { style: { paddingLeft: 4,
	                  paddingRight: 4,
	                  marginBottom: 4,
	                  flexDirection: 'row' } },
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: {
	                    fontStyle: 'italic',
	                    flex: -1, color: generalTitleColor
	                  } },
	                dayName
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: [{
	                    fontStyle: 'italic',
	                    flex: -1,
	                    textAlign: 'right'
	                  }, { color: generalTitleColor }] },
	                time
	              )
	            );
	          })
	        ) : null,
	        shouldShowDelivery > 0 ? React.createElement(
	          View,
	          { style: { alignItems: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { justifyContent: 'center', alignSelf: 'center', marginTop: 4, marginBottom: 8 } },
	            React.createElement(
	              ReUpText,
	              null,
	              locManager.localizedStringForKey("FOR_DELIVERY_LABEL")
	            )
	          ),
	          hoursDelivery.map(function (hour, index) {
	            var isClosed = !hour.isActive;
	            var dayName = hour.dayName;
	            var time = isClosed ? closedLabel : hour.timeFrom + " - " + hour.timeTill;
	            return React.createElement(
	              View,
	              { style: { paddingLeft: 4,
	                  paddingRight: 4,
	                  marginBottom: 4,
	                  flexDirection: 'row' } },
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: {
	                    fontStyle: 'italic',
	                    flex: -1, color: generalTitleColor
	                  } },
	                dayName
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: [{
	                    fontStyle: 'italic',
	                    flex: -1,
	                    textAlign: 'right'
	                  }, { color: generalTitleColor }] },
	                time
	              )
	            );
	          })
	        ) : null
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  onRegionChange: function onRegionChange(region) {
	    this.state.region = region;
	  },
	
	  locationForStoreID: function locationForStoreID(storeID) {
	    if (typeof storeID === 'undefined' && this.state.locations.length > 0) return this.state.locations[0];
	
	    for (var i = 0; i < this.state.locations.length; i++) {
	      if (this.state.locations[i].store_id == storeID) return this.state.locations[i];
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	
	    var featureName = "OrderAhead";
	    var auphanFeatureData = appManager.getFeatureForName("Auphan");
	    var grabbFeatureData = appManager.getFeatureForName("Grabb");
	    if (typeof auphanFeatureData !== 'undefined') featureName = "Auphan";else if (typeof grabbFeatureData !== 'undefined') featureName = "Grabb";
	
	    if (this.state.locations.length <= 0) {
	      return React.createElement(
	        View,
	        { style: { paddingTop: Globals.ACTION_BAR_HEIGHT, backgroundColor: this.props.appManager.getColorForKey("GeneralColor"), flex: 1, alignSelf: 'stretch' } },
	        React.createElement(ReUpScrollView, { ref: 'ptr', shouldOverlayRefreshView: true, bounces: true, responder: this, isEmpty: true, customDependencies: [OrderAhead.customDataDependency], featureName: featureName, isEmptyPostfix: locManager.localizedStringForKey("NO_LOCATIONS_AVAILABLE_STATEMENT") })
	      );
	    }
	    var locations = this.state.filteredLocations;
	    var instructions = this.props.featureData.instructions;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor", 1);
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", 0.6);
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var progressForegroundColor = appManager.getColorForKey("PrimaryColor");
	    var progressBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    var noLocationsAvailableStr = locManager.localizedStringForKey("NO_LOCATIONS_AVAILABLE_STATEMENT");
	    if (progressBackgroundColor == generalColor) progressBackgroundColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	
	    if (this.state.activeOrders != null && this.state.activeOrders.length > 0) {
	      return React.createElement(
	        View,
	        { style: { backgroundColor: generalColor, height: 1000 } },
	        this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	        React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height + Globals.ACTION_BAR_HEIGHT, overflow: 'hidden', backgroundColor: generalColor }] }),
	        React.createElement(
	          ReUpScrollView,
	          { ref: 'ptr', shouldOverlayRefreshView: true, responder: this, isEmpty: false, customDependencies: [OrderAhead.customDataDependency], featureName: featureName, isEmptyPostfix: noLocationsAvailableStr },
	          this.state.activeOrders.map(function (order, index) {
	            var location = thisThing.locationForStoreID(order.store_id);
	            if (location == null) return null;
	
	            var _getLocationInfo7 = getLocationInfo(location),
	                name = _getLocationInfo7.name,
	                address = _getLocationInfo7.address,
	                latitude = _getLocationInfo7.latitude,
	                longitude = _getLocationInfo7.longitude,
	                storeID = _getLocationInfo7.storeID;
	
	            var region = {
	              latitude: parseFloat(latitude),
	              longitude: parseFloat(longitude),
	              latitudeDelta: 0.003, longitudeDelta: 0.003
	            };
	            var markers = [{
	              latlng: {
	                latitude: parseFloat(latitude),
	                longitude: parseFloat(longitude)
	              },
	              title: name,
	              description: address
	            }];
	            var status = typeof order.status !== 'undefined' ? order.status : order.OrderStatus;
	            var orderID = typeof order.order_id !== 'undefined' ? order.order_id : order.OrderId;
	            return React.createElement(
	              View,
	              { key: storeID, style: { flexDirection: 'column' } },
	              React.createElement(
	                MKButton,
	                { key: "map",
	                  backgroundColor: 'transparent',
	                  shadowRadius: 2,
	                  shadowOffset: { width: 0, height: 2 },
	                  shadowOpacity: 0.7,
	                  rippleColor: rippleColor,
	                  shadowColor: 'transparent',
	                  onPress: function onPress() {
	                    thisThing.didSelectLocationMap(location);
	                  }, style: { height: 150, flex: 1 } },
	                React.createElement(
	                  MapView,
	                  { key: 'mapviewactiveorder',
	                    region: region,
	                    onRegionChange: thisThing.onRegionChange,
	                    style: { width: thisThing.state.layout.width, height: 150 }
	                  },
	                  markers.map(function (marker) {
	                    return React.createElement(MapView.Marker, {
	                      key: 'activeordermarkers',
	                      coordinate: marker.latlng,
	                      title: marker.title,
	                      description: marker.description
	                    });
	                  })
	                )
	              ),
	              React.createElement(
	                View,
	                { key: 'active', style: { flexDirection: 'row', alignItems: 'center' } },
	                React.createElement(
	                  MKButton,
	                  { key: JSON.stringify(location),
	                    backgroundColor: 'transparent',
	                    shadowRadius: 2,
	                    shadowOffset: { width: 0, height: 2 },
	                    shadowOpacity: 0.7,
	                    rippleColor: rippleColor,
	                    shadowColor: 'transparent',
	                    onPress: function onPress() {
	                      thisThing.showLocationInfo(location);
	                      // thisThing.didSelectLocation(location);
	                    }, style: { height: 100, flex: 1 } },
	                  React.createElement(
	                    View,
	                    { style: { flex: 1, alignSelf: 'stretch' } },
	                    React.createElement(
	                      View,
	                      { style: { flexDirection: 'column', height: 100, flex: 1 } },
	                      React.createElement(View, { style: { flex: 1 } }),
	                      React.createElement(
	                        View,
	                        { style: { padding: 10 } },
	                        React.createElement(
	                          View,
	                          { style: { flex: -1 } },
	                          React.createElement(
	                            ReUpText,
	                            { appManager: appManager, isTitle: true },
	                            name
	                          )
	                        ),
	                        React.createElement(View, { style: { height: 10 } }),
	                        React.createElement(
	                          View,
	                          { style: { flex: -1 } },
	                          React.createElement(
	                            ReUpText,
	                            { appManager: appManager },
	                            address
	                          )
	                        ),
	                        typeof location.distance !== 'undefined' && location.distance > 0 && location.distance < Number.MAX_VALUE ? React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: { color: generalTitleColorLight } },
	                          locManager.localizedDistance(location.distance)
	                        ) : null
	                      ),
	                      React.createElement(View, { style: { flex: 1 } })
	                    )
	                  )
	                ),
	                React.createElement(
	                  View,
	                  { style: { width: 50, flex: -1 } },
	                  React.createElement(ReUpIconButton, { iconName: "info", type: 6,
	                    appManager: appManager,
	                    onPress: function onPress() {
	                      thisThing.showLocationInfo(location);
	                    }
	                  })
	                )
	              ),
	              typeof order.ready_time_seconds !== 'undefined' ? React.createElement(
	                View,
	                { style: { width: thisThing.state.layout.width, flex: -1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: false, style: { textAlign: 'left', marginHorizontal: 20 } },
	                  _this2.state.orderIsReady ? locManager.localizedStringForKey("YOUR_ORDER_IS_READY_STATEMENT") : locManager.localizedStringForKey("YOUR_ORDER_WILL_BE_READY_STATEMENT")
	                ),
	                React.createElement(ReUpCountdown, { ref: function ref(countdown) {
	                    if (countdown != null) {
	                      thisThing._countdown = countdown;
	                      appManager.getVariable(ACTIVE_ORDER_DISMISS_KEY, function (shouldIgnoreBelowReadyThisReadyTimeSeconds) {
	                        if (parseInt(shouldIgnoreBelowReadyThisReadyTimeSeconds) < parseInt(order.ready_time_seconds) && typeof order.ready_time_seconds !== 'undefined') {
	                          countdown.startCountdown(moment(order.ready_time_seconds * 1000).toDate());
	                        }
	                      });
	                      // countdown.startCountdown(moment().add("second",2).add("minute",1).toDate());
	                    }
	                  }, appManager: appManager, isTitle: true, style: { textAlign: 'center', marginHorizontal: 20, fontSize: 40 },
	                  complete: function complete() {
	                    appActions.showLocalizedAlert("ORDER_READY_ALERT_TITLE", "ORDER_READY_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                      appManager.setVariable(ACTIVE_ORDER_DISMISS_KEY, order.ready_time_seconds);
	                      appActions.hideAlert();
	                      thisThing.setState({ activeOrders: null, orderIsReady: true });
	                    }], function () {});
	                  },
	                  completionText: locManager.localizedStringForKey("DONE_STATEMENT") })
	              ) : React.createElement(
	                View,
	                { style: { width: thisThing.state.layout.width, flex: -1, flexDirection: 'column', justifyContent: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: { textAlign: 'left', marginHorizontal: 20 } },
	                  locManager.localizedStringForKeyAndParams("ORDER_STATUS_ORDER_NUMBER", [orderID], "Order #%0%")
	                ),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center', padding: 20 } },
	                    React.createElement(
	                      View,
	                      { style: { height: 20, width: 20, borderRadius: 10, borderColor: progressForegroundColor, borderWidth: 2, alignItems: 'center', justifyContent: 'center' } },
	                      React.createElement(View, { style: { height: 10, width: 10, borderRadius: 5, backgroundColor: status < 0 ? 'transparent' : progressForegroundColor } })
	                    ),
	                    React.createElement(
	                      View,
	                      { style: { flex: 1, marginLeft: 10 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { flexWrap: 'wrap', textAlign: 'left' } },
	                        locManager.localizedStringForKey("ORDER_STATUS_SUBMITTED_RESTAURANT", "Order submitted to the restaurant")
	                      )
	                    )
	                  ),
	                  React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout })
	                ),
	                React.createElement(
	                  View,
	                  { style: { opacity: status <= 1 ? 0.4 : 1 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center', padding: 20 } },
	                    React.createElement(
	                      View,
	                      { style: { height: 20, width: 20, borderRadius: 10, borderColor: status <= 1 ? progressBackgroundColor : progressForegroundColor, borderWidth: 2, alignItems: 'center', justifyContent: 'center' } },
	                      React.createElement(View, { style: { height: 10, width: 10, borderRadius: 5, backgroundColor: status <= 1 ? 'transparent' : progressForegroundColor } })
	                    ),
	                    React.createElement(
	                      View,
	                      { style: { flex: 1, marginLeft: 10 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { flexWrap: 'wrap', textAlign: 'left' } },
	                        locManager.localizedStringForKey("ORDER_STATUS_MEAL_BEING_PREPPED", "Your meal is being prepared!")
	                      )
	                    )
	                  ),
	                  React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout })
	                ),
	                React.createElement(
	                  View,
	                  { style: { opacity: status <= 2 ? 0.4 : 1 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'center', padding: 20 } },
	                    React.createElement(
	                      View,
	                      { style: { height: 20, width: 20, borderRadius: 10, borderColor: status <= 2 ? progressBackgroundColor : progressForegroundColor, borderWidth: 2, alignItems: 'center', justifyContent: 'center' } },
	                      React.createElement(View, { style: { height: 10, width: 10, borderRadius: 5, backgroundColor: status <= 2 ? 'transparent' : progressForegroundColor } })
	                    ),
	                    React.createElement(
	                      View,
	                      { style: { flex: 1, marginLeft: 10 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { flexWrap: 'wrap', textAlign: 'left' } },
	                        locManager.localizedStringForKey("ORDER_STATUS_READY_FOR_PICKUP", "Ready for pickup. Enjoy!")
	                      )
	                    )
	                  )
	                )
	              ),
	              typeof order.ready_time_seconds !== 'undefined' ? React.createElement(
	                View,
	                { style: { padding: 20 } },
	                React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, text: locManager.localizedStringForKey("HIDE_ORDER_BUTTON"), onPress: function onPress() {
	                    appManager.setVariable(ACTIVE_ORDER_DISMISS_KEY, order.ready_time_seconds);
	                    thisThing.setState({ activeOrders: null });
	                  } })
	              ) : null
	            );
	          })
	        )
	      );
	    }
	
	    var shouldShowSearch = this.state.locations.length > 3;
	    var showOtherLocationsWhenOneIsActive = false;
	    var activeLocations = this.state.activeLocations;
	    var shouldShowInstruction = false;
	    var allMarkers = [];
	    var region = null;
	    for (var i = 0; i < locations.length; i++) {
	      var _getLocationInfo8 = getLocationInfo(locations[i]),
	          latitude = _getLocationInfo8.latitude,
	          longitude = _getLocationInfo8.longitude,
	          name = _getLocationInfo8.name,
	          address = _getLocationInfo8.address;
	
	      if (region == null) {
	        region = {
	          latitude: latitude,
	          longitude: longitude,
	          latitudeDelta: 0.01,
	          longitudeDelta: 0.01
	        };
	      }
	      allMarkers.push({
	        latlng: {
	          latitude: parseFloat(latitude),
	          longitude: parseFloat(longitude)
	        },
	        title: name,
	        description: address
	      });
	      // TODO: ... Think about this..
	      if (i >= 10) break;
	    }
	
	    var parallaxHeaderHeight = this.state.parallaxHeaderHeight;
	
	    var AnimatedCustomScrollView = Animated.createAnimatedComponent(ReUpScrollView);
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        _reactNativeParallaxScrollViewWrapper2.default,
	        {
	          ref: 'parallax',
	          stickyHeaderHeight: thisThing.state.showOneLocation ? 0 : 45,
	          backgroundColor: generalColor,
	          contentBackgroundColor: generalColor,
	          parallaxHeaderHeight: parallaxHeaderHeight,
	          backgroundSpeed: 1,
	          onScroll: function onScroll(info) {
	            var offset = info.nativeEvent.contentOffset.y;
	            if (offset < 50) Keyboard.dismiss();
	          },
	          renderStickyHeader: function renderStickyHeader() {
	            if (thisThing.state.showOneLocation) return null;
	            return React.createElement(
	              View,
	              { style: { flexDirection: 'column', backgroundColor: generalColor, width: thisThing.state.layout.width, height: 45 } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: generalColor } },
	                React.createElement(
	                  View,
	                  { style: { width: 30, marginHorizontal: 10, alignItems: 'center', flex: -1, justifyContent: 'center' } },
	                  React.createElement(Icon, { pointerEvents: 'auto', style: {}, name: "search", size: 16, color: generalTitleColorLight })
	                ),
	                React.createElement(View, { style: { alignSelf: 'stretch', flexDirection: 'row', margin: 0, flex: 1 } }),
	                React.createElement(ReUpField, {
	                  appManager: appManager,
	                  ref: function ref(a) {
	                    return thisThing._searchField = a;
	                  },
	                  onChangeText: thisThing.searchChanged,
	                  key: "search" + thisThing.state.searchKey,
	                  hideLine: true,
	                  onFocus: function onFocus() {
	                    if (thisThing.refs.parallax) thisThing.refs.parallax.scrollTo(parallaxHeaderHeight);
	                  },
	                  disableBackground: true,
	                  placeholder: locManager.localizedStringForKey("SEARCH_PLACEHOLDER"),
	                  style: {
	                    flex: 1, height: 50, position: 'absolute', left: 50, right: 50, top: -4, bottom: 0
	                  },
	                  floatingLabelEnabled: false }),
	                React.createElement(
	                  MKButton,
	                  { key: "info",
	                    backgroundColor: 'transparent',
	                    shadowRadius: 2,
	                    shadowOffset: { width: 0, height: 2 },
	                    shadowOpacity: 0.7,
	                    rippleColor: rippleColor,
	                    shadowColor: 'transparent',
	                    onPress: function onPress() {
	                      Keyboard.dismiss();
	                      thisThing.searchChanged("");
	                      thisThing.setState({ searchKey: thisThing.state.searchKey + 1 });
	                    }, style: { width: 50 } },
	                  React.createElement(
	                    View,
	                    { style: { alignSelf: 'stretch', flex: 1, flexDirection: 'column' } },
	                    React.createElement(View, { style: { flex: 1 } }),
	                    React.createElement(
	                      View,
	                      { style: { flex: -1 } },
	                      React.createElement(ReUpIconButton, { iconName: "times", type: 6,
	                        appManager: appManager,
	                        onPress: function onPress() {
	                          Keyboard.dismiss();
	                          thisThing.searchChanged("");
	                          thisThing.setState({ searchKey: thisThing.state.searchKey + 1 });
	                        }
	                      })
	                    ),
	                    React.createElement(View, { style: { flex: 1 } })
	                  )
	                )
	              ),
	              React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout })
	            );
	          },
	          renderBackground: function renderBackground() {
	            return React.createElement(
	              View,
	              { key: 'mapviewcontainer', style: { height: parallaxHeaderHeight, alignItems: 'center', flexDirection: 'column', justifyContent: 'center' } },
	              thisThing.state.mapView
	            );
	          },
	          renderForeground: function renderForeground() {
	            return React.createElement(
	              View,
	              { style: { flexDirection: 'column', backgroundColor: 'transparent' } },
	              shouldShowInstruction ? React.createElement(
	                View,
	                { style: [styles.instructionContainer, { flexDirection: 'column', backgroundColor: instructionColor, color: instructionTitleColor, width: _this2.state.layout.width }],
	                  onLayout: function onLayout(evt) {
	                    thisThing.setState({ instructionHeight: evt.nativeEvent.layout.height });
	                  } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', flex: -1, alignSelf: 'stretch', alignItems: 'stretch' } },
	                  React.createElement(
	                    View,
	                    { style: { alignSelf: 'center' } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	                      creditsLeftStatement
	                    )
	                  ),
	                  React.createElement(View, { style: { flex: 1 } }),
	                  React.createElement(
	                    View,
	                    { pointerEvents: "auto", style: { flex: -1 } },
	                    React.createElement(ReUpIconButton, { type: 3,
	                      appManager: appManager,
	                      featureData: _this2.props.featureData,
	                      appActions: _this2.props.appActions
	                    })
	                  )
	                ),
	                React.createElement(ShadowView, { appManager: appManager, layout: _this2.state.layout })
	              ) : null,
	              React.createElement(MKButton, {
	                backgroundColor: 'transparent',
	                shadowRadius: 0,
	                shadowOffset: { width: 0, height: 0 },
	                shadowOpacity: 0,
	                shadowColor: 'transparent',
	                rippleColor: appManager.getColorForKey("ButtonPrimaryColor", .2),
	                maskBorderRadius: 0,
	                style: { width: thisThing.state.layout.width, height: parallaxHeaderHeight - (shouldShowInstruction ? thisThing.state.instructionHeight : 0) },
	                onPress: function onPress() {
	                  thisThing.didSelectMap();
	                } })
	            );
	          } },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', width: this.state.layout.width } },
	          React.createElement(View, { style: { height: this.props.initialLayout.height - (shouldShowInstruction ? this.state.instructionHeight : 0) - 60 - (thisThing.state.showOneLocation ? 60 : 0), width: 0 } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column' } },
	             true ? React.createElement(
	              View,
	              { style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	              React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout }),
	              React.createElement(
	                View,
	                { style: { padding: 10, textAlign: 'center', justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { type: 1, appManager: appManager },
	                  this.props.featureData.instructions + ""
	                )
	              ),
	              !thisThing.state.showOneLocation ? React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout }) : null
	            ) : null,
	            locations.length <= 0 ? React.createElement(
	              View,
	              { key: 'empty', style: { backgroundColor: generalColor, height: -1, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 20 } },
	              React.createElement(Icon, { name: thisThing.props.featureData.icon.replace("fa-", ""), size: 62, color: generalTitleColor }),
	              React.createElement(
	                View,
	                { style: { flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: 20 } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true },
	                  thisThing.props.featureData.title
	                ),
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: { textAlign: 'center' } },
	                  locManager.localizedStringForKey("NO_LOCATIONS_STATEMENT", "No locations for this search.")
	                )
	              )
	            ) : null,
	            locations.map(function (location, index) {
	              if (thisThing.state.showOneLocation && index > 0) return null;
	              if (index > 20) return null;
	
	              var _getLocationInfo9 = getLocationInfo(location),
	                  latitude = _getLocationInfo9.latitude,
	                  longitude = _getLocationInfo9.longitude,
	                  name = _getLocationInfo9.name,
	                  address = _getLocationInfo9.address,
	                  storeID = _getLocationInfo9.storeID;
	
	              var cannotOrder = false; //location.IsClosedForTheDay || !location.IsRestaurantOpen;
	              return React.createElement(
	                View,
	                { key: storeID, style: { flexDirection: 'column', width: thisThing.state.layout.width, alignItems: 'stretch' } },
	                thisThing.state.showOneLocation ? React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout }) : null,
	                React.createElement(
	                  View,
	                  { style: { alignItems: 'center', flexDirection: 'row' } },
	                  React.createElement(
	                    MKButton,
	                    { key: JSON.stringify(location),
	                      backgroundColor: 'transparent',
	                      shadowRadius: 2,
	                      shadowOffset: { width: 0, height: 2 },
	                      shadowOpacity: 0.7,
	                      rippleColor: rippleColor,
	                      shadowColor: 'transparent',
	                      onPress: function onPress() {
	                        if (cannotOrder) {
	                          appActions.showLocalizedAlert("LOCATION_CLOSED_ALERT_TITLE", "LOCATION_CLOSED_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                            appActions.hideAlert();
	                          }], function () {});
	                        } else {
	                          thisThing.didSelectLocation(location);
	                        }
	                      }, style: { height: 100, flex: 1, opacity: thisThing.state.activeLocation != null ? 0.4 : 1 }, enabled: thisThing.state.activeLocation == null },
	                    React.createElement(
	                      View,
	                      { style: { flexDirection: 'column', height: 100, flex: 1 } },
	                      React.createElement(View, { style: { flex: 1 } }),
	                      React.createElement(
	                        View,
	                        { style: { padding: 10 } },
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, isTitle: true },
	                          name + (cannotOrder ? " (Closed)" : "")
	                        ),
	                        React.createElement(View, { style: { height: 10 } }),
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager },
	                          address
	                        ),
	                        typeof location.distance !== 'undefined' && location.distance > 0 && location.distance < Number.MAX_VALUE ? React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: { color: generalTitleColorLight } },
	                          locManager.localizedDistance(location.distance)
	                        ) : null
	                      ),
	                      React.createElement(View, { style: { flex: 1 } })
	                    )
	                  ),
	                  React.createElement(
	                    MKButton,
	                    { key: "info",
	                      backgroundColor: 'transparent',
	                      shadowRadius: 2,
	                      shadowOffset: { width: 0, height: 2 },
	                      shadowOpacity: 0.7,
	                      rippleColor: rippleColor,
	                      shadowColor: 'transparent',
	                      onPress: function onPress() {
	                        thisThing.showLocationInfo(location);
	                      }, style: { height: 100, width: 50, opacity: thisThing.state.activeLocation != null ? 0.4 : 1 }, enabled: thisThing.state.activeLocation == null },
	                    React.createElement(
	                      View,
	                      { style: { alignSelf: 'stretch', flex: 1, flexDirection: 'column' } },
	                      React.createElement(View, { style: { flex: 1 } }),
	                      React.createElement(
	                        View,
	                        { style: { flex: -1 } },
	                        React.createElement(ReUpIconButton, { iconName: "info", type: 6,
	                          appManager: appManager,
	                          onPress: function onPress() {
	                            thisThing.showLocationInfo(location);
	                          }
	                        })
	                      ),
	                      React.createElement(View, { style: { flex: 1 } })
	                    )
	                  )
	                ),
	                React.createElement(ShadowView, { appManager: appManager, layout: thisThing.state.layout }),
	                thisThing.state.showOneLocation ? React.createElement(
	                  View,
	                  null,
	                  React.createElement(ReUpButton, { appManager: appManager, onPress: function onPress() {
	                      if (cannotOrder) {
	                        appActions.showLocalizedAlert("LOCATION_CLOSED_ALERT_TITLE", "LOCATION_CLOSED_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                          appActions.hideAlert();
	                        }], function () {});
	                      } else {
	                        thisThing.didSelectLocation(location);
	                      }
	                    },
	                    text: locManager.localizedStringForKey("ORDER_NOW_BUTTON"), style: { margin: 10 } }),
	                  thisThing.state.locations.length > 1 ? React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, onPress: function onPress() {
	                      thisThing.setState({ showOneLocation: false });
	                    },
	                    text: locManager.localizedStringForKey("SEE_MORE_LOCATIONS_BUTTON"), style: { marginHorizontal: 10 } }) : null
	                ) : null
	              );
	            })
	          )
	        )
	      )
	    );
	    // return (<View style={styles.container}>
	    //   { this.props.extras && this.props.extras.shouldHideActionBar ? null : <View style={styles.actionBarSpacer} /> }
	    //   {
	    //     url == null ?
	    //     null
	    //     :
	    //     <WebView  url={url} style={{flex:1}} />
	    //   }
	    // </View>)
	  }
	});
	
	OrderAhead.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	
	  var auphanFeatureData = appManager.getFeatureForName("Auphan");
	  var grabbFeatureData = appManager.getFeatureForName("Grabb");
	
	  var featureName = "OrderAhead";
	  if (typeof auphanFeatureData !== 'undefined') featureName = "Auphan";else if (typeof grabbFeatureData !== 'undefined') featureName = "Grabb";
	  var didSelect = function didSelect() {
	    appActions.requestFeatureName(featureName);
	  };
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var sortOrder = 999999999999;
	  if (typeof data.OrderingLocations !== 'undefined' && data.OrderingLocations.length > 0) {
	    try {
	      var locations = data.OrderingLocations;
	      for (var i = 0; i < locations.length; i++) {
	        var location = locations[i];
	        var cannotOrder = (typeof location.IsClosedForTheDay !== 'undefined' || typeof location.IsRestaurantOpen !== 'undefined') && (location.IsClosedForTheDay || !location.IsRestaurantOpen);
	        if (!cannotOrder) {
	          sortOrder = 0;
	          break;
	        }
	      }
	    } catch (e) {} finally {}
	  }
	
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: featureData.data.tip,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: sortOrder
	  }];
	};
	
	// OrderAhead.customDependencyKeys = ["OrderAhead"];
	// OrderAhead.customDataDependency = function(appManager, completion)
	// {
	//   var auphanFeatureData = appManager.getFeatureForName("Auphan");
	//   var grabbFeatureData = appManager.getFeatureForName("Grabb");
	
	//   var updateFunction = null;
	//   if( typeof auphanFeatureData !== 'undefined' )
	//   {
	//     updateFunction = function()
	//     {
	//       appManager.setUpdatedDateOfFeatureName("OrderAhead");
	
	//       var date = (new Date()).getTime();
	//       var currentDateTime =  appManager.getLocalizationManager().dateTimeAuphan(date);
	//       // TODO: remove this
	//       // auphanFeatureData.data.franchise_id = 6941;
	//       NetworkManager.getAuphanInfo(appManager, "AUPHAN", auphanFeatureData.data.franchise_id, currentDateTime, "", "", function(data)
	//       {
	//         if( data != null && typeof data !== 'undefined' )
	//         {
	//           var currentPosition = appManager.getCurrentPosition();
	//           var locations = data;
	//           for( var i = 0; i < locations.length; i++ )
	//           {
	//             var loc = locations[i];
	//             loc.distance = calculateDistance(loc.latitude, loc.longitude, currentPosition.latitude, currentPosition.longitude);
	//           }
	//           data = locations.sort(function(a,b)
	//           {
	//             if( a.distance == b.distance ) return a.name.localeCompare(b.name);
	
	//             return a.distance - b.distance;
	//           });
	
	//           var output = {OrderAhead:[{Locations:JSON.stringify(data), store_id:0}]};
	//           appManager.setData(output, function()
	//           {
	//             completion(output)
	//           });
	//         }
	//         else
	//         {
	//           completion({})
	//         }
	//       }, function(a)
	//       {
	//         completion({OrderAhead:[]})
	//       }, function()
	//       {
	//         completion({})
	//       })
	//     }
	//   }
	//   else if( typeof grabbFeatureData !== 'undefined' )
	//   {
	//     updateFunction = function()
	//     {
	//       appManager.setUpdatedDateOfFeatureName("OrderAhead");
	
	//       var date = (new Date()).getTime();
	//       var currentDateTime =  appManager.getLocalizationManager().dateTimeGrabb(date);
	//       NetworkManager.getGrabbInfo(appManager, grabbFeatureData.data.merchantID, currentDateTime, function(data)
	//       {
	//         if( data != null && typeof data.Locations !== 'undefined' && data.Locations != null )
	//         {
	//           appManager._grabbToken = data.Token;
	
	//           var currentPosition = appManager.getCurrentPosition();
	//           var locations = data.Locations;
	//           var refinedLocations = [];
	//           for( var i = 0; i < locations.length; i++ )
	//           {
	//             var loc = locations[i];
	//             var refinedLoc = {};
	//             refinedLoc.distance = calculateDistance(loc.latitude, loc.longitude, currentPosition.latitude, currentPosition.longitude);
	//             refinedLoc.address = loc.Address.Line1 + " " + loc.Address.Line2;
	//             refinedLoc.name = loc.Name;
	//             refinedLoc.store_id = loc.LocationID;
	//             refinedLoc.url = loc.GrabbURL;
	//             refinedLoc.latitude = loc.Address.Latitude;
	//             refinedLoc.longitude = loc.Address.Longitude;
	//             refinedLoc.hours = [];
	//             for( var j = 0; j < loc.Hours.length; j++ )
	//             {
	//               refinedLoc.hours.push({
	//                 pickup:[
	//                   [loc.Hours[j].OpenTime, loc.Hours[j].ClosedTime]
	//                 ],
	//                 delivery:[],
	//               })
	//             }
	//             refinedLoc.active_orders = [];
	//             if( typeof loc.ActiveOrders !== 'undefined' )
	//             {
	//               for( var j = 0; j < loc.ActiveOrders.length; j++ )
	//               {
	//                 refinedLoc.active_orders.push({
	//                   status:loc.ActiveOrders[j].OrderStatus,
	//                   store_id:loc.LocationID,
	//                   order_id:loc.ActiveOrders[j].OrderId
	//                 })
	//               }
	//             }
	
	//             refinedLocations.push(refinedLoc);
	//           }
	//           refinedLocations = refinedLocations.sort(function(a,b)
	//           {
	//             if( a.distance == b.distance ) return a.name.localeCompare(b.name);
	
	//             return a.distance - b.distance;
	//           });
	
	//           var output = {OrderAhead:[{Locations:JSON.stringify(refinedLocations), store_id:0}]};
	//           appManager.setData(output, function()
	//           {
	//             completion(output)
	//           });
	//         }
	//         else
	//         {
	//           completion({})
	//         }
	//       }, function(a)
	//       {
	//         completion({OrderAhead:[]})
	//       }, function()
	//       {
	//         completion({})
	//       })
	//     }
	//   }
	
	//   var timeSinceLastUpdated = appManager.getTimeSinceLastUpdateOfFeatureName("OrderAhead");
	//   if( timeSinceLastUpdated < 5000 )
	//   {
	//     appManager.getDataType("OrderAhead", function(data)
	//     {
	//       if( data != null && typeof data !== 'undefined' && data.length > 0 )
	//       {
	//         var locations = JSON.parse(data[0].Locations).sort(function(a,b)
	//         {
	//           if( a.distance == b.distance ) return a.name.localeCompare(b.name);
	
	//           return a.distance - b.distance;
	//         });
	//         completion({OrderAhead:[{Locations:JSON.stringify(locations), store_id:0}]});
	//       }
	//       else
	//       {
	//         if( updateFunction != null ) updateFunction();
	//       }
	//     })
	//   }
	//   else
	//   {
	//     if( updateFunction != null ) updateFunction();
	//   }
	
	// }
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  }
	});
	OrderAhead.dataDependencies = ["Users", "OrderingLocations"];
	
	module.exports = OrderAhead;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeSensorsWrapper = __webpack_require__(1169);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var View = ReactNative.View,
	    Animated = ReactNative.Animated,
	    Easing = ReactNative.Easing;
	
	
	var OTHER_OBJ_PUSH_DIST = .1;
	var OTHER_OBJ_PUSH_ACC = .000002;
	var OTHER_OBJ_PUSH_ACC_MAX = 3 * OTHER_OBJ_PUSH_ACC;
	var SPIN_CO = 1000;
	var MAX_NUM_COLLISSIONS = 30;
	var MAX_ACC = 0.000002;
	var SHOW_RED_COLLISSION = false;
	
	function percentCollisionSameDir(start, end, startV, endV, acc, deltaT, threshold, bounded) {
	  var delta = end - start;
	  if (delta == 0) return { isColl: false };
	  if (deltaT == 0) return { isColl: false };
	
	  if (startV >= 0 && endV >= 0 || startV <= 0 && endV <= 0) {
	    if (bounded < 0 && (start <= threshold || end <= threshold) || bounded > 0 && (start >= threshold || end >= threshold)) {
	      var avgV = (startV + endV) / 2;
	      var colT = (threshold - start) / avgV;
	      var percentage = colT / deltaT;
	      var newVel = startV + percentage * (endV - startV);
	      var newPos = 0;
	      return { isColl: true, newVel: newVel, newPos: newPos, percentage: percentage };
	    } else {
	      return { isColl: false };
	    }
	  }
	
	  return { isColl: false };
	}
	
	function percentCollision(start, end, startV, endV, acc, deltaT, threshold, bounded) {
	  var delta = end - start;
	  if (delta == 0) return { isColl: false };
	  if (deltaT == 0) return { isColl: false };
	
	  // if the V's are in the same direction, easy
	  if (startV >= 0 && endV >= 0 || startV <= 0 && endV <= 0) {
	    var sameDirColl = percentCollisionSameDir(start, end, startV, endV, acc, deltaT, threshold, bounded);
	    if (sameDirColl.isColl) return sameDirColl;
	  } else {
	    // find when v becomes 0
	    var changeDirT = Math.abs(startV / acc);
	
	    // if collision at changeDirT, then we are done
	    var changeDirPos = start + startV * changeDirT / 2;
	
	    var _percentCollisionSame = percentCollisionSameDir(start, changeDirPos, startV, 0, acc, changeDirT, threshold, bounded),
	        isColl = _percentCollisionSame.isColl,
	        percentage = _percentCollisionSame.percentage;
	
	    if (isColl) {
	      var collT = percentage * changeDirT;
	      return { isColl: true, percentage: Math.min(1, collT / deltaT) };
	    }
	
	    var _percentCollisionSame2 = percentCollisionSameDir(changeDirPos, end, 0, endV, acc, deltaT - changeDirT, threshold, bounded),
	        isColl = _percentCollisionSame2.isColl,
	        percentage = _percentCollisionSame2.percentage;
	
	    if (isColl) {
	      var collT = changeDirT + percentage * (deltaT - changeDirT);
	      return { isColl: true, percentage: collT / deltaT };
	    }
	  }
	
	  return { isColl: false }; // no collision
	}
	
	var PhysScene = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      objectInfos: []
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      time: new Animated.Value(0),
	      width: -1,
	      height: -1
	    };
	  },
	
	  _lastTime: 0,
	  _acceleration: { x: 0, y: 0, z: 0 },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var thisThing = this;
	
	    this._accelerationObservable = new _reactNativeSensorsWrapper.Accelerometer({
	      updateInterval: 100 // defaults to 100ms
	    });
	
	    var thisThing = this;
	    this._accelerationObservable.map(function (_ref) {
	      var x = _ref.x,
	          y = _ref.y,
	          z = _ref.z;
	
	      thisThing._acceleration = { x: x, y: y, z: z };
	    }).filter(function (speed) {
	      return speed > 20;
	    }).subscribe(function (speed) {
	      return console.log('You moved your phone with ' + speed);
	    });;
	
	    this.state.time.addListener(function (_ref2) {
	      var value = _ref2.value;
	
	      var deltaT = value - thisThing._lastTime;
	      deltaT = Math.min(10, deltaT);
	
	      for (var i = 0; i < thisThing.props.objectInfos.length; i++) {
	        if (typeof thisThing.refs["obj" + i] === 'undefined') continue;
	
	        var obj = thisThing.refs["obj" + i];
	        var oldInfo = obj.getInfo();
	        var isShown = oldInfo.startTime <= value;
	        if (!isShown) {
	          oldInfo.isShown = oldInfo.startTime <= value;
	          obj.setInfo(oldInfo);
	          continue;
	        }
	
	        var newInfo = obj.getInfoAfterDeltaT(deltaT);
	
	        // add other obj pushes
	        var numCollissions = 0;
	        newInfo.collisionVectors = [];
	        for (var j = 0; j < thisThing.props.objectInfos.length; j++) {
	          if (j == i || typeof thisThing.refs["obj" + j] === 'undefined') continue;
	
	          var otherObj = thisThing.refs["obj" + j];
	          if (!otherObj.isShown()) continue;
	
	          var otherInfo = otherObj.getInfo();
	
	          var distX = Math.abs(otherInfo.posX - oldInfo.posX) * _this.state.width;
	          var distY = Math.abs(otherInfo.posY - oldInfo.posY) * _this.state.height;
	          var maxDist = (obj.radius() + otherObj.radius()) / 2;
	          // console.log("distX",distX)
	          // console.log("distY",distY)
	          // console.log("maxDist",maxDist)
	          if (distX < maxDist && distY < maxDist) {
	            newInfo.isInCollision = true;
	
	            var deltaX = (otherInfo.posX - oldInfo.posX) * _this.state.width;
	            if (deltaX == 0) deltaX = .00000001;
	            var deltaY = (otherInfo.posY - oldInfo.posY) * _this.state.height;
	            if (deltaY == 0) deltaY = .00000001;
	            newInfo.collisionVectors.push([-Math.max(-OTHER_OBJ_PUSH_ACC_MAX, Math.min(OTHER_OBJ_PUSH_ACC_MAX, OTHER_OBJ_PUSH_ACC * maxDist / deltaX)), -Math.max(-OTHER_OBJ_PUSH_ACC_MAX, Math.min(OTHER_OBJ_PUSH_ACC_MAX, OTHER_OBJ_PUSH_ACC * maxDist / deltaY))]);
	            // console.log("velYAvg",velYAvg)
	            // newInfo.velX = (otherInfo.posX - oldInfo.posX) < 0 ? velXAvg : -velXAvg;
	            // newInfo.velY = (otherInfo.posY - oldInfo.posY) < 0 ? velYAvg : -velYAvg;
	            // newInfo.velX += deltaT*((distX < 0) ? OTHER_OBJ_PUSH_ACC : -OTHER_OBJ_PUSH_ACC);//Math.max(-OTHER_OBJ_PUSH_ACC_MAX,Math.min(OTHER_OBJ_PUSH_ACC_MAX, vel));
	            // newInfo.velY += deltaT*((distY < 0) ? OTHER_OBJ_PUSH_ACC : -OTHER_OBJ_PUSH_ACC);//Math.max(-OTHER_OBJ_PUSH_ACC_MAX,Math.min(OTHER_OBJ_PUSH_ACC_MAX, vel));
	
	            numCollissions++;
	          }
	
	          if (numCollissions > MAX_NUM_COLLISSIONS) break;
	        }
	
	        var bounceDamp = 7 / 10;
	        var bounceDampPos = 2 / 10;
	        var timeDecel = .00000005; // needs to be related to time
	        var accX = oldInfo.accX;
	        var accY = oldInfo.accY;
	
	        var _percentCollision = percentCollision(oldInfo.posX, newInfo.posX, oldInfo.velX, newInfo.velX, accX, deltaT, 0, -1),
	            isColl = _percentCollision.isColl,
	            percentage = _percentCollision.percentage;
	
	        if (isColl) {
	          var newVelX = oldInfo.velX + percentage * (newInfo.velX - oldInfo.velX);
	          newInfo.velX = Math.abs(newVelX) * bounceDamp;
	          var deltaX = newInfo.posX - oldInfo.posX;
	          newInfo.posX = oldInfo.posX + deltaX * percentage - deltaX * (1 - percentage) * bounceDampPos;
	          newInfo.angularVel = newInfo.velY * SPIN_CO;
	        }
	
	        var _percentCollision2 = percentCollision(oldInfo.posY, newInfo.posY, oldInfo.velY, newInfo.velY, accY, deltaT, 0, -1),
	            isColl = _percentCollision2.isColl,
	            percentage = _percentCollision2.percentage;
	
	        if (isColl) {
	          var newVelY = oldInfo.velY + percentage * (newInfo.velY - oldInfo.velY);
	          newInfo.velY = Math.abs(newVelY) * bounceDamp;
	          var avgVelY = (newInfo.velY + oldInfo.velY) / 2;
	          var deltaY = avgVelY * deltaT;
	          newInfo.posY = Math.max(0, oldInfo.posY - deltaY * percentage + deltaY * (1 - percentage) * bounceDampPos);
	          newInfo.angularVel = -newInfo.velX * SPIN_CO;
	        }
	
	        var _percentCollision3 = percentCollision(oldInfo.posX, newInfo.posX, oldInfo.velX, newInfo.velX, accX, deltaT, 1, 1),
	            isColl = _percentCollision3.isColl,
	            percentage = _percentCollision3.percentage;
	
	        if (isColl) {
	          var newVelX = oldInfo.velX + percentage * (newInfo.velX - oldInfo.velX);
	          newInfo.velX = -Math.abs(newVelX) * bounceDamp;
	          var deltaX = newInfo.posX - oldInfo.posX;
	          newInfo.posX = oldInfo.posX + deltaX * percentage - deltaX * (1 - percentage) * bounceDampPos;
	          newInfo.angularVel = -newInfo.velY * SPIN_CO;
	        }
	
	        var _percentCollision4 = percentCollision(oldInfo.posY, newInfo.posY, oldInfo.velY, newInfo.velY, accY, deltaT, 1, 1),
	            isColl = _percentCollision4.isColl,
	            percentage = _percentCollision4.percentage;
	
	        if (isColl) {
	          var newVelY = oldInfo.velY + percentage * (newInfo.velY - oldInfo.velY);
	          newInfo.velY = -Math.abs(newVelY) * bounceDamp;
	          var avgVelY = (newInfo.velY + oldInfo.velY) / 2;
	          var deltaY = avgVelY * deltaT;
	          newInfo.posY = oldInfo.posY + deltaY * percentage - deltaY * (1 - percentage) * bounceDampPos;
	          newInfo.angularVel = newInfo.velX * SPIN_CO;
	        }
	        // var decelVel = timeDecel*deltaT;
	        // if( newInfo.velX < 0 ) newInfo.velX += Math.min(decelVel, Math.abs(newInfo.velX));
	        // if( newInfo.velY < 0 ) newInfo.velY += Math.min(decelVel, Math.abs(newInfo.velY));
	        // if( newInfo.velX > 0 ) newInfo.velX -= Math.min(decelVel, newInfo.velX);
	        // if( newInfo.velY > 0 ) newInfo.velY -= Math.min(decelVel, newInfo.velY);
	
	        // wall sticky
	        // var WALL_STICK_THRESHOLD = .008;
	        // if( newInfo.posX < WALL_STICK_THRESHOLD && newInfo.accX < 0 ) newInfo.posX = 0;
	        // if( newInfo.posY < WALL_STICK_THRESHOLD && newInfo.accY < 0 ) newInfo.posY = 0;
	        // if( newInfo.posX > (1 - WALL_STICK_THRESHOLD) && newInfo.accX > 0 ) newInfo.posX = 1;
	        // if( newInfo.posY > (1 - WALL_STICK_THRESHOLD) && newInfo.accY > 0 && Math.abs(newInfo.velY) < .0001 )
	        // {
	        //   newInfo.velY = 0;
	        //   newInfo.posY = 1;
	        // }
	
	        newInfo.accX = parseFloat(Math.max(Math.min(thisThing._acceleration.x * MAX_ACC, MAX_ACC), -MAX_ACC));
	        newInfo.accY = thisThing._acceleration.y != 0 ? parseFloat(Math.max(Math.min(-thisThing._acceleration.y * MAX_ACC, MAX_ACC), -MAX_ACC)) : .000001;
	        // console.log("newInfo", thisThing._acceleration.x, newInfo)
	        // var THRESHOLD_STOP_VEL = .0001;
	        // console.log(thisThing._acceleration);
	        // if( Math.abs(newInfo.velY) < THRESHOLD_STOP_VEL ) newInfo.velY = 0;
	        // if( Math.abs(newInfo.velX) < THRESHOLD_STOP_VEL ) newInfo.velX = 0;
	
	        newInfo.isShown = true;
	        obj.setInfo(newInfo);
	      }
	      thisThing._lastTime = value;
	    });
	
	    this.start();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._accelerationObservable.stop();
	
	    Animated.timing(this.state.time, {
	      toValue: 0,
	      duration: 0,
	      easing: Easing.out
	    }).start(function () {});
	  },
	
	  start: function start() {
	    var duration = 1000 * 30;
	
	    Animated.timing(this.state.time, {
	      toValue: duration,
	      duration: duration
	    }).start(function () {});
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        objects = _props.objects,
	        otherProps = _objectWithoutProperties(_props, ['objects']);
	
	    var thisThing = this;
	
	    return React.createElement(
	      View,
	      Object.assign({}, otherProps, {
	        onLayout: function onLayout(event) {
	          return _this2.setState({ width: event.nativeEvent.layout.width, height: event.nativeEvent.layout.height });
	        } }),
	      this.state.width > 0 && this.state.height > 0 ? thisThing.props.objectInfos.map(function (objectInfo, index) {
	        return React.createElement(PhysObject, {
	          ref: "obj" + index,
	          key: "obj" + index,
	          startPosX: objectInfo.posX,
	          startPosY: objectInfo.posY,
	          startVelX: objectInfo.velX,
	          startVelY: objectInfo.velY,
	          containerWidth: thisThing.state.width,
	          containerHeight: thisThing.state.height,
	          renderObject: objectInfo.renderObject,
	          startTime: objectInfo.startTime
	        });
	      }) : null
	    );
	  }
	});
	
	var PhysObject = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      startPosX: .5,
	      startPosY: .5,
	      startVelX: -0.02,
	      startVelY: -0.02,
	      startAngle: 0,
	      startAngularVel: .01,
	      startTime: 0,
	      containerWidth: 0,
	      containerHeight: 0,
	      radius: 40,
	      renderObject: function renderObject() {
	        return React.createElement(View, { style: { width: 40, height: 40, borderRadius: 20, backgroundColor: 'red' } });
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      posX: this.props.startPosX,
	      posY: this.props.startPosY,
	      angle: this.props.startAngle,
	      containerWidth: this.props.containerWidth,
	      containerHeight: this.props.containerHeight,
	      isShown: false,
	      isInCollision: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._velX = this.props.startVelX;
	    this._velY = this.props.startVelY;
	    this._angularVel = this.props.startAngularVel;
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.containerWidth !== this.state.containerWidth) this.setState({ containerWidth: newProps.containerWidth });
	    if (newProps.containerHeight !== this.state.containerHeight) this.setState({ containerHeight: newProps.containerHeight });
	  },
	
	  _velX: -0.02,
	  _velY: -0.02,
	  _accX: 0.00000,
	  _accY: 0.00001,
	  getInfo: function getInfo() {
	    return {
	      velX: this._velX,
	      velY: this._velY,
	      accX: this._accX,
	      accY: this._accY,
	      posX: this.state.posX,
	      posY: this.state.posY,
	      angle: this.state.angle,
	      startTime: this.props.startTime,
	      isInCollision: false
	    };
	  },
	  getInfoAfterDeltaT: function getInfoAfterDeltaT(deltaT) {
	    var collisionVectorVelX = 0;
	    var collisionVectorVelY = 0;
	    if (typeof this._collisionVectors !== 'undefined') {
	      for (var i = 0; i < this._collisionVectors.length; i++) {
	        collisionVectorVelX += this._collisionVectors[i][0] * deltaT;
	        collisionVectorVelY += this._collisionVectors[i][1] * deltaT;
	      }
	    }
	
	    return {
	      velX: this._velX + deltaT * this._accX + collisionVectorVelX,
	      velY: this._velY + deltaT * this._accY + collisionVectorVelY,
	      accX: this._accX,
	      accY: this._accY,
	      posX: this.state.posX + deltaT * this._velX,
	      posY: this.state.posY + deltaT * this._velY,
	      angularVel: this._angularVel,
	      angle: this.state.angle + deltaT * this._angularVel,
	      startTime: this.props.startTime,
	      isInCollision: false
	    };
	  },
	  setInfo: function setInfo(newInfo) {
	    if (typeof newInfo.velX !== 'undefined' && !isNaN(newInfo.velX)) this._velX = newInfo.velX;
	    if (typeof newInfo.velY !== 'undefined' && !isNaN(newInfo.velY)) this._velY = newInfo.velY;
	    if (typeof newInfo.accX !== 'undefined' && !isNaN(newInfo.accX)) this._accX = newInfo.accX;
	    if (typeof newInfo.accY !== 'undefined' && !isNaN(newInfo.accY)) this._accY = newInfo.accY;
	    if (typeof newInfo.posX !== 'undefined' && !isNaN(newInfo.posX)) this.setState({ posX: newInfo.posX });
	    if (typeof newInfo.posY !== 'undefined' && !isNaN(newInfo.posY)) this.setState({ posY: newInfo.posY });
	    if (typeof newInfo.angularVel !== 'undefined' && !isNaN(newInfo.angularVel)) this._angularVel = newInfo.angularVel;
	    if (typeof newInfo.angle !== 'undefined' && !isNaN(newInfo.angle)) this.setState({ angle: newInfo.angle });
	    if (typeof newInfo.isShown !== 'undefined' && !isNaN(newInfo.isShown)) this.setState({ isShown: newInfo.isShown });
	    if (typeof newInfo.isInCollision !== 'undefined' && !isNaN(newInfo.isInCollision)) this.setState({ isInCollision: newInfo.isInCollision });
	    if (typeof newInfo.collisionVectors !== 'undefined') this._collisionVectors = newInfo.collisionVectors;
	  },
	
	
	  isShown: function isShown() {
	    return this.state.isShown;
	  },
	
	  radius: function radius() {
	    return this.props.radius;
	  },
	
	  render: function render() {
	    if (!this.state.isShown) return null;
	    return React.createElement(
	      View,
	      { style: {
	          position: 'absolute',
	          left: 0 + (this.state.containerWidth - 2 / 2 * this.props.radius) * this.state.posX,
	          top: 0 + (this.state.containerHeight - 2 / 2 * this.props.radius) * this.state.posY,
	          transform: [{ rotate: this.state.angle + "deg" }, { scale: this.state.isInCollision ? .95 : 1 }],
	          borderRadius: 100000,
	          backgroundColor: SHOW_RED_COLLISSION && this.state.isInCollision ? 'red' : 'transparent'
	        } },
	      this.props.renderObject()
	    );
	  }
	});
	
	module.exports = { PhysScene: PhysScene, PhysObject: PhysObject };

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Animated = ReactNative.Animated,
	    Image = ReactNative.Image;
	
	
	var ReUpText = __webpack_require__(8);
	
	var Ticker = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      appManager: null,
	      animated: true,
	      points: 0,
	      isTitle: false,
	      renderText: function renderText(input) {
	        return input;
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      points: new Animated.Value(0),
	      pointsVal: 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.state.points.addListener(function (_ref) {
	      var value = _ref.value;
	
	      thisThing.setState({ pointsVal: value });
	    });
	
	    setTimeout(function () {
	      thisThing._hasDoneFirstSet = true;
	      thisThing.setPoints(thisThing.props.points);
	    }, 500);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.points !== 'undefined') this.setPoints(newProps.points);
	  },
	
	  _hasDoneFirstSet: false,
	  setPoints: function setPoints(newPoints) {
	    if (!this._hasDoneFirstSet) return;
	
	    Animated.spring(this.state.points, {
	      toValue: newPoints,
	      tension: 8,
	      friction: 9
	    }).start();
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    return React.createElement(
	      ReUpText,
	      { appManager: appManager, style: this.props.style, isTitle: this.props.isTitle },
	      this.props.renderText(this.state.pointsVal)
	    );
	  }
	});
	
	module.exports = Ticker;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var PRICE_BUTTON_WIDTH = 120;
	
	var PriceChooserView = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialAmount: null,
	      initialLayout: {},
	      initialIndex: 4,
	      choiceValue: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200],
	      didChangeValueAndText: function didChangeValueAndText(value, text) {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var appManager = this.props.appManager;
	    var choiceValue = this.props.choiceValue;
	    var locMan = appManager.getLocalizationManager();
	    var choiceText = [];
	    for (var i = 0; i < choiceValue.length; i++) {
	      choiceText.push(locMan.localizedDollars(choiceValue[i]));
	    }
	
	    var initialIndex = this.props.initialIndex;
	    if (this.props.initialAmount != null) {
	      for (var i = 0; i < choiceValue.length; i++) {
	        if (this.props.initialAmount == choiceValue[i]) {
	          initialIndex = i;
	          break;
	        }
	      }
	    }
	    return {
	      layout: this.props.initialLayout,
	      choiceIndex: initialIndex,
	      isEditingAmount: false,
	      chooserOpacity: new Animated.Value(0),
	      buttonOpacity: new Animated.Value(1),
	      choiceText: choiceText,
	      choiceValue: choiceValue
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.refs.choicesScrollView.scrollTo({ x: -this.state.layout.width / 2 + PRICE_BUTTON_WIDTH / 2 + PRICE_BUTTON_WIDTH * this.state.choiceIndex, y: 0, animated: true });
	    var index = this.state.choiceIndex;
	
	    this.props.didChangeValueAndText(this.state.choiceValue[index], this.state.choiceText[index]);
	  },
	
	  getAmount: function getAmount() {
	    return this.state.choiceValue[this.state.choiceIndex];
	  },
	
	  setAmount: function setAmount(amount) {
	    for (var i = 0; i < this.state.choiceValue.length; i++) {
	      if (this.state.choiceValue[i] == amount) {
	        this.props.didChangeValueAndText(this.state.choiceValue[i], this.state.choiceText[i]);
	        this.refs.choicesScrollView.scrollTo({ x: -this.state.layout.width / 2 + PRICE_BUTTON_WIDTH / 2 + PRICE_BUTTON_WIDTH * i, y: 0, animated: true });
	        this.refs.choices.setSelectedIndex(i);
	        this.setState({ choiceIndex: i, isEditingAmount: false });
	        break;
	      }
	    }
	  },
	
	  getAmountText: function getAmountText() {
	    return this.state.choiceText[this.state.choiceIndex];
	  },
	
	  focus: function focus() {
	    var thisThing = this;
	    Animated.timing(thisThing.state.chooserOpacity, { toValue: 1,
	      duration: 150 }).start(function () {
	      thisThing.setState({ isEditingAmount: true });
	    });
	    Animated.timing(thisThing.state.buttonOpacity, { toValue: 0,
	      duration: 150 }).start(function () {});
	    if (typeof this.props.didStartChoosingPrice !== 'undefined') this.props.didStartChoosingPrice();
	  },
	
	  choiceSelected: function choiceSelected(index) {
	    this.props.didChangeValueAndText(this.state.choiceValue[index], this.state.choiceText[index]);
	    this.refs.choicesScrollView.scrollTo({ x: -this.state.layout.width / 2 + PRICE_BUTTON_WIDTH / 2 + PRICE_BUTTON_WIDTH * index, y: 0, animated: true });
	    var thisThing = this;
	    this.setState({ choiceIndex: index, isEditingAmount: false });
	    setTimeout(function () {
	      Animated.timing(thisThing.state.chooserOpacity, { toValue: 0,
	        duration: 150 }).start(function () {});
	      Animated.timing(thisThing.state.buttonOpacity, { toValue: 1,
	        duration: 150 }).start(function () {});
	    }, 250);
	    if (typeof this.props.didEndChoosingPrice !== 'undefined') this.props.didEndChoosingPrice();
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    return React.createElement(
	      View,
	      { style: this.props.style },
	      React.createElement(
	        Animated.View,
	        { style: { flex: 1, position: 'absolute', top: 0, left: 0, right: 0, height: 50, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 8, opacity: this.state.buttonOpacity }, pointerEvents: !this.state.isEditingAmount ? 'auto' : 'none' },
	        React.createElement(ReUpButton, { isSecondary: true, style: { width: PRICE_BUTTON_WIDTH, flex: 1 }, appManager: appManager,
	          text: this.state.choiceText[this.state.choiceIndex],
	          icon: "angle-left",
	          rightIcon: "angle-right",
	          iconSize: 20,
	          onPress: function onPress() {
	            Animated.timing(thisThing.state.chooserOpacity, { toValue: 1,
	              duration: 150 }).start(function () {
	              thisThing.setState({ isEditingAmount: true });
	            });
	            Animated.timing(thisThing.state.buttonOpacity, { toValue: 0,
	              duration: 150 }).start(function () {
	              thisThing.setState({ isEditingAmount: true });
	            });
	            if (typeof thisThing.props.didStartChoosingPrice !== 'undefined') thisThing.props.didStartChoosingPrice();
	          }
	        })
	      ),
	      React.createElement(
	        Animated.View,
	        { style: { flex: 1, position: 'absolute', top: 0, left: 0, right: 0, height: 50, opacity: this.state.chooserOpacity }, pointerEvents: this.state.isEditingAmount ? 'auto' : 'none' },
	        React.createElement(
	          ScrollView,
	          { ref: "choicesScrollView",
	            bounces: true,
	            keyboardShouldPersistTaps: true,
	            keyboardDismissMode: "interactive",
	            horizontal: true,
	            scrollEnabled: this.state.isEditingAmount,
	            snapToInterval: PRICE_BUTTON_WIDTH,
	            snapToAlignment: 'center',
	            style: { backgroundColor: primaryButtonBorderColor, height: 50 } },
	          React.createElement(MKSegmentControl, {
	            ref: 'choices',
	            style: [{ height: 50, flex: 1, alignSelf: 'center' }, { width: this.state.choiceText.length * PRICE_BUTTON_WIDTH, marginTop: 10 }],
	            selectedIndex: this.state.choiceIndex,
	            choiceTitles: this.state.choiceText,
	            didSelectIndex: thisThing.choiceSelected,
	            activeBackgroundColor: primaryButtonColor,
	            activeShadowColor: primaryButtonBorderColor,
	            activeTextColor: primaryButtonTitleColor,
	            inactiveBackgroundColor: secondaryButtonColor,
	            inactiveTextColor: secondaryButtonTitleColor })
	        )
	      )
	    );
	  }
	});
	
	module.exports = PriceChooserView;

/***/ },
/* 151 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  textField: {
	    fontFamily: 'Cochin'
	  }
	};

/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  LoginManager: {},
	  AccessToken: {}
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var C_enc = C.enc;
		    var Utf8 = C_enc.Utf8;
		    var C_algo = C.algo;
	
		    /**
		     * HMAC algorithm.
		     */
		    var HMAC = C_algo.HMAC = Base.extend({
		        /**
		         * Initializes a newly created HMAC.
		         *
		         * @param {Hasher} hasher The hash algorithm to use.
		         * @param {WordArray|string} key The secret key.
		         *
		         * @example
		         *
		         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
		         */
		        init: function (hasher, key) {
		            // Init hasher
		            hasher = this._hasher = new hasher.init();
	
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof key == 'string') {
		                key = Utf8.parse(key);
		            }
	
		            // Shortcuts
		            var hasherBlockSize = hasher.blockSize;
		            var hasherBlockSizeBytes = hasherBlockSize * 4;
	
		            // Allow arbitrary length keys
		            if (key.sigBytes > hasherBlockSizeBytes) {
		                key = hasher.finalize(key);
		            }
	
		            // Clamp excess bits
		            key.clamp();
	
		            // Clone key for inner and outer pads
		            var oKey = this._oKey = key.clone();
		            var iKey = this._iKey = key.clone();
	
		            // Shortcuts
		            var oKeyWords = oKey.words;
		            var iKeyWords = iKey.words;
	
		            // XOR keys with pad constants
		            for (var i = 0; i < hasherBlockSize; i++) {
		                oKeyWords[i] ^= 0x5c5c5c5c;
		                iKeyWords[i] ^= 0x36363636;
		            }
		            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this HMAC to its initial state.
		         *
		         * @example
		         *
		         *     hmacHasher.reset();
		         */
		        reset: function () {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Reset
		            hasher.reset();
		            hasher.update(this._iKey);
		        },
	
		        /**
		         * Updates this HMAC with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {HMAC} This HMAC instance.
		         *
		         * @example
		         *
		         *     hmacHasher.update('message');
		         *     hmacHasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            this._hasher.update(messageUpdate);
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the HMAC computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The HMAC.
		         *
		         * @example
		         *
		         *     var hmac = hmacHasher.finalize();
		         *     var hmac = hmacHasher.finalize('message');
		         *     var hmac = hmacHasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Shortcut
		            var hasher = this._hasher;
	
		            // Compute HMAC
		            var innerHash = hasher.finalize(messageUpdate);
		            hasher.reset();
		            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
	
		            return hmac;
		        }
		    });
		}());
	
	
	}));

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-1 hash algorithm.
		     */
		    var SHA1 = C_algo.SHA1 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0x67452301, 0xefcdab89,
		                0x98badcfe, 0x10325476,
		                0xc3d2e1f0
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
	
		            // Computation
		            for (var i = 0; i < 80; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
		                    W[i] = (n << 1) | (n >>> 31);
		                }
	
		                var t = ((a << 5) | (a >>> 27)) + e + W[i];
		                if (i < 20) {
		                    t += ((b & c) | (~b & d)) + 0x5a827999;
		                } else if (i < 40) {
		                    t += (b ^ c ^ d) + 0x6ed9eba1;
		                } else if (i < 60) {
		                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
		                } else /* if (i < 80) */ {
		                    t += (b ^ c ^ d) - 0x359d3e2a;
		                }
	
		                e = d;
		                d = c;
		                c = (b << 30) | (b >>> 2);
		                b = a;
		                a = t;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA1('message');
		     *     var hash = CryptoJS.SHA1(wordArray);
		     */
		    C.SHA1 = Hasher._createHelper(SHA1);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA1(message, key);
		     */
		    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
		}());
	
	
		return CryptoJS.SHA1;
	
	}));

/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Returns a function, that, as long as it continues to be invoked, will not
	 * be triggered. The function will be called after it stops being called for
	 * N milliseconds. If `immediate` is passed, trigger the function on the
	 * leading edge, instead of the trailing. The function also has a property 'clear' 
	 * that is a function which will clear the timer to prevent previously scheduled executions. 
	 *
	 * @source underscore.js
	 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
	 * @param {Function} function to wrap
	 * @param {Number} timeout in ms (`100`)
	 * @param {Boolean} whether to execute at the beginning (`false`)
	 * @api public
	 */
	function debounce(func, wait, immediate){
	  var timeout, args, context, timestamp, result;
	  if (null == wait) wait = 100;
	
	  function later() {
	    var last = Date.now() - timestamp;
	
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	    }
	  };
	
	  var debounced = function(){
	    context = this;
	    args = arguments;
	    timestamp = Date.now();
	    var callNow = immediate && !timeout;
	    if (!timeout) timeout = setTimeout(later, wait);
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	
	    return result;
	  };
	
	  debounced.clear = function() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	  
	  debounced.flush = function() {
	    if (timeout) {
	      result = func.apply(context, args);
	      context = args = null;
	      
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	
	  return debounced;
	};
	
	// Adds compatibility for ES modules
	debounce.debounce = debounce;
	
	module.exports = debounce;


/***/ },
/* 156 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 159 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 160 */
/***/ function(module, exports) {

	/*
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	function normalizeColor(color) {
	  var match;
	
	  if (typeof color === 'number') {
	    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
	      return color;
	    }
	    return null;
	  }
	
	  // Ordered based on occurrences on Facebook codebase
	  if ((match = matchers.hex6.exec(color))) {
	    return parseInt(match[1] + 'ff', 16) >>> 0;
	  }
	
	  if (names.hasOwnProperty(color)) {
	    return names[color];
	  }
	
	  if ((match = matchers.rgb.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.rgba.exec(color))) {
	    return (
	        parse255(match[1]) << 24 | // r
	        parse255(match[2]) << 16 | // g
	        parse255(match[3]) << 8 | // b
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hex3.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        'ff', // a
	        16
	      ) >>> 0;
	  }
	
	  // https://drafts.csswg.org/css-color-4/#hex-notation
	  if ((match = matchers.hex8.exec(color))) {
	    return parseInt(match[1], 16) >>> 0;
	  }
	
	  if ((match = matchers.hex4.exec(color))) {
	    return parseInt(
	        match[1] + match[1] + // r
	        match[2] + match[2] + // g
	        match[3] + match[3] + // b
	        match[4] + match[4], // a
	        16
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsl.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        0x000000ff // a
	      ) >>> 0;
	  }
	
	  if ((match = matchers.hsla.exec(color))) {
	    return (
	        hslToRgb(
	          parse360(match[1]), // h
	          parsePercentage(match[2]), // s
	          parsePercentage(match[3]) // l
	        ) |
	        parse1(match[4]) // a
	      ) >>> 0;
	  }
	
	  return null;
	}
	
	function hue2rgb(p, q, t) {
	  if (t < 0) {
	    t += 1;
	  }
	  if (t > 1) {
	    t -= 1;
	  }
	  if (t < 1 / 6) {
	    return p + (q - p) * 6 * t;
	  }
	  if (t < 1 / 2) {
	    return q;
	  }
	  if (t < 2 / 3) {
	    return p + (q - p) * (2 / 3 - t) * 6;
	  }
	  return p;
	}
	
	function hslToRgb(h, s, l) {
	  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	  var p = 2 * l - q;
	  var r = hue2rgb(p, q, h + 1 / 3);
	  var g = hue2rgb(p, q, h);
	  var b = hue2rgb(p, q, h - 1 / 3);
	
	  return (
	    Math.round(r * 255) << 24 |
	    Math.round(g * 255) << 16 |
	    Math.round(b * 255) << 8
	  );
	}
	
	// var INTEGER = '[-+]?\\d+';
	var NUMBER = '[-+]?\\d*\\.?\\d+';
	var PERCENTAGE = NUMBER + '%';
	
	function toArray(arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	}
	
	function call() {
	  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
	}
	
	var matchers = {
	  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
	  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
	  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
	  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
	  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	  hex6: /^#([0-9a-fA-F]{6})$/,
	  hex8: /^#([0-9a-fA-F]{8})$/,
	};
	
	function parse255(str) {
	  var int = parseInt(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 255) {
	    return 255;
	  }
	  return int;
	}
	
	function parse360(str) {
	  var int = parseFloat(str);
	  return (((int % 360) + 360) % 360) / 360;
	}
	
	function parse1(str) {
	  var num = parseFloat(str);
	  if (num < 0) {
	    return 0;
	  }
	  if (num > 1) {
	    return 255;
	  }
	  return Math.round(num * 255);
	}
	
	function parsePercentage(str) {
	  // parseFloat conveniently ignores the final %
	  var int = parseFloat(str, 10);
	  if (int < 0) {
	    return 0;
	  }
	  if (int > 100) {
	    return 1;
	  }
	  return int / 100;
	}
	
	var names = {
	  transparent: 0x00000000,
	
	  // http://www.w3.org/TR/css3-color/#svg-color
	  aliceblue: 0xf0f8ffff,
	  antiquewhite: 0xfaebd7ff,
	  aqua: 0x00ffffff,
	  aquamarine: 0x7fffd4ff,
	  azure: 0xf0ffffff,
	  beige: 0xf5f5dcff,
	  bisque: 0xffe4c4ff,
	  black: 0x000000ff,
	  blanchedalmond: 0xffebcdff,
	  blue: 0x0000ffff,
	  blueviolet: 0x8a2be2ff,
	  brown: 0xa52a2aff,
	  burlywood: 0xdeb887ff,
	  burntsienna: 0xea7e5dff,
	  cadetblue: 0x5f9ea0ff,
	  chartreuse: 0x7fff00ff,
	  chocolate: 0xd2691eff,
	  coral: 0xff7f50ff,
	  cornflowerblue: 0x6495edff,
	  cornsilk: 0xfff8dcff,
	  crimson: 0xdc143cff,
	  cyan: 0x00ffffff,
	  darkblue: 0x00008bff,
	  darkcyan: 0x008b8bff,
	  darkgoldenrod: 0xb8860bff,
	  darkgray: 0xa9a9a9ff,
	  darkgreen: 0x006400ff,
	  darkgrey: 0xa9a9a9ff,
	  darkkhaki: 0xbdb76bff,
	  darkmagenta: 0x8b008bff,
	  darkolivegreen: 0x556b2fff,
	  darkorange: 0xff8c00ff,
	  darkorchid: 0x9932ccff,
	  darkred: 0x8b0000ff,
	  darksalmon: 0xe9967aff,
	  darkseagreen: 0x8fbc8fff,
	  darkslateblue: 0x483d8bff,
	  darkslategray: 0x2f4f4fff,
	  darkslategrey: 0x2f4f4fff,
	  darkturquoise: 0x00ced1ff,
	  darkviolet: 0x9400d3ff,
	  deeppink: 0xff1493ff,
	  deepskyblue: 0x00bfffff,
	  dimgray: 0x696969ff,
	  dimgrey: 0x696969ff,
	  dodgerblue: 0x1e90ffff,
	  firebrick: 0xb22222ff,
	  floralwhite: 0xfffaf0ff,
	  forestgreen: 0x228b22ff,
	  fuchsia: 0xff00ffff,
	  gainsboro: 0xdcdcdcff,
	  ghostwhite: 0xf8f8ffff,
	  gold: 0xffd700ff,
	  goldenrod: 0xdaa520ff,
	  gray: 0x808080ff,
	  green: 0x008000ff,
	  greenyellow: 0xadff2fff,
	  grey: 0x808080ff,
	  honeydew: 0xf0fff0ff,
	  hotpink: 0xff69b4ff,
	  indianred: 0xcd5c5cff,
	  indigo: 0x4b0082ff,
	  ivory: 0xfffff0ff,
	  khaki: 0xf0e68cff,
	  lavender: 0xe6e6faff,
	  lavenderblush: 0xfff0f5ff,
	  lawngreen: 0x7cfc00ff,
	  lemonchiffon: 0xfffacdff,
	  lightblue: 0xadd8e6ff,
	  lightcoral: 0xf08080ff,
	  lightcyan: 0xe0ffffff,
	  lightgoldenrodyellow: 0xfafad2ff,
	  lightgray: 0xd3d3d3ff,
	  lightgreen: 0x90ee90ff,
	  lightgrey: 0xd3d3d3ff,
	  lightpink: 0xffb6c1ff,
	  lightsalmon: 0xffa07aff,
	  lightseagreen: 0x20b2aaff,
	  lightskyblue: 0x87cefaff,
	  lightslategray: 0x778899ff,
	  lightslategrey: 0x778899ff,
	  lightsteelblue: 0xb0c4deff,
	  lightyellow: 0xffffe0ff,
	  lime: 0x00ff00ff,
	  limegreen: 0x32cd32ff,
	  linen: 0xfaf0e6ff,
	  magenta: 0xff00ffff,
	  maroon: 0x800000ff,
	  mediumaquamarine: 0x66cdaaff,
	  mediumblue: 0x0000cdff,
	  mediumorchid: 0xba55d3ff,
	  mediumpurple: 0x9370dbff,
	  mediumseagreen: 0x3cb371ff,
	  mediumslateblue: 0x7b68eeff,
	  mediumspringgreen: 0x00fa9aff,
	  mediumturquoise: 0x48d1ccff,
	  mediumvioletred: 0xc71585ff,
	  midnightblue: 0x191970ff,
	  mintcream: 0xf5fffaff,
	  mistyrose: 0xffe4e1ff,
	  moccasin: 0xffe4b5ff,
	  navajowhite: 0xffdeadff,
	  navy: 0x000080ff,
	  oldlace: 0xfdf5e6ff,
	  olive: 0x808000ff,
	  olivedrab: 0x6b8e23ff,
	  orange: 0xffa500ff,
	  orangered: 0xff4500ff,
	  orchid: 0xda70d6ff,
	  palegoldenrod: 0xeee8aaff,
	  palegreen: 0x98fb98ff,
	  paleturquoise: 0xafeeeeff,
	  palevioletred: 0xdb7093ff,
	  papayawhip: 0xffefd5ff,
	  peachpuff: 0xffdab9ff,
	  peru: 0xcd853fff,
	  pink: 0xffc0cbff,
	  plum: 0xdda0ddff,
	  powderblue: 0xb0e0e6ff,
	  purple: 0x800080ff,
	  rebeccapurple: 0x663399ff,
	  red: 0xff0000ff,
	  rosybrown: 0xbc8f8fff,
	  royalblue: 0x4169e1ff,
	  saddlebrown: 0x8b4513ff,
	  salmon: 0xfa8072ff,
	  sandybrown: 0xf4a460ff,
	  seagreen: 0x2e8b57ff,
	  seashell: 0xfff5eeff,
	  sienna: 0xa0522dff,
	  silver: 0xc0c0c0ff,
	  skyblue: 0x87ceebff,
	  slateblue: 0x6a5acdff,
	  slategray: 0x708090ff,
	  slategrey: 0x708090ff,
	  snow: 0xfffafaff,
	  springgreen: 0x00ff7fff,
	  steelblue: 0x4682b4ff,
	  tan: 0xd2b48cff,
	  teal: 0x008080ff,
	  thistle: 0xd8bfd8ff,
	  tomato: 0xff6347ff,
	  turquoise: 0x40e0d0ff,
	  violet: 0xee82eeff,
	  wheat: 0xf5deb3ff,
	  white: 0xffffffff,
	  whitesmoke: 0xf5f5f5ff,
	  yellow: 0xffff00ff,
	  yellowgreen: 0x9acd32ff,
	};
	
	function rgba(colorInt) {
	  var r = Math.round(((colorInt & 0xff000000) >>> 24));
	  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
	  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
	  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
	  return {
	    r: r,
	    g: g,
	    b: b,
	    a: a,
	  };
	};
	
	normalizeColor.rgba = rgba;
	
	module.exports = normalizeColor;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1249)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fa500px = function Fa500px(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.3 34.5l-0.2 0.2q-2.5 2.5-5.7 3.9-3.5 1.4-7.1 1.4-3.7 0-7.1-1.4-3.3-1.4-5.8-3.9-2.5-2.5-3.9-5.8-0.9-2.3-1.2-4.2-0.1-0.6 1.1-0.8 1.1-0.2 1.2 0.4 0.1 0.1 0.1 0.1 0.4 2 1 3.6 1.1 2.7 3.4 5 2.2 2.2 5 3.4 3 1.3 6.2 1.3 3.2 0 6.1-1.3 2.9-1.2 5.1-3.4l0.1-0.1q0.2-0.2 0.6-0.2 0.2 0.1 0.7 0.5 0.8 0.9 0.4 1.3z m-10.6-13.7l-1.4 1.5 1.4 1.4q0.4 0.5-0.2 1.1-0.4 0.4-0.7 0.4-0.2 0-0.4-0.3l-1.4-1.3-1.5 1.4q-0.1 0.2-0.3 0.2-0.4 0-0.7-0.4l-0.1 0q-0.4-0.4-0.4-0.7 0-0.1 0.2-0.4l1.5-1.4-1.5-1.5q-0.3-0.4 0.3-1 0.4-0.4 0.7-0.4 0.2 0 0.3 0.1l1.5 1.5 1.4-1.5q0.4-0.3 1.1 0.3 0.6 0.6 0.2 1z m10.6 1.3q0 2.6-1.1 5.1-1 2.3-2.8 4.1-1.8 1.8-4.2 2.8t-5.1 1.1-5-1.1-4.2-2.8q-1.8-1.8-2.8-4.1-0.3-0.7-0.3-0.9h-0.1q-0.2-0.6 1-1 1.1-0.4 1.3 0.3 0.9 2.2 2.2 3.7h0v-7.6q0.1-3.1 2.3-5.2 2.3-2.3 5.6-2.3 3.3 0 5.7 2.3t2.3 5.6q0 3.2-2.4 5.6t-5.6 2.3q-1.2 0-2.5-0.4-0.6-0.2-0.2-1.3 0.3-1.2 0.9-1l0.4 0.1q0.3 0 0.7 0.1t0.7 0.1q2.3 0 3.9-1.6t1.6-3.9q0-2.3-1.6-3.8-1.6-1.6-3.9-1.6-2.4 0-4 1.8-1.4 1.6-1.4 3.5v9.2q2.4 1.5 5.4 1.5 2.1 0 4.1-0.8t3.5-2.3 2.3-3.4 0.8-4.1q0-4.4-3.1-7.6-3.2-3.1-7.6-3.1-4.5 0-7.6 3.1-1.2 1.2-1.7 1.9l0 0.1q-0.2 0.2-0.3 0.3t-0.5 0.3-0.9-0.1q-0.4-0.1-0.8-0.4t-0.3-0.6v-15.2q0-0.3 0.2-0.5t0.6-0.3h19.6q0.7 0 0.7 1.2t-0.7 1.3h-18.1v10.7h0q0.9-0.9 2.3-1.8t2.4-1.4q2.4-1 5.1-1 2.7 0 5.1 1t4.2 2.8q1.8 1.8 2.8 4.2 1 2.5 1 5.1z m-0.7-13q0.2 0.2 0.2 0.4t-0.2 0.4-0.3 0.5q-0.6 0.6-0.9 0.6-0.2 0-0.4-0.2-2.3-2-4.6-3-2.8-1.2-6.1-1.2-3 0-5.9 1.1-0.6 0.2-1-0.8-0.2-0.6-0.2-0.9 0.1-0.4 0.4-0.4 2.9-1.3 6.7-1.3 3.6 0 7 1.4 3.1 1.3 5.3 3.4z' })
	        )
	    );
	};
	
	exports.default = Fa500px;
	module.exports = exports['default'];

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAdjust = function FaAdjust(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 32.1v-24.2q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6z m17.2-12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaAdjust;
	module.exports = exports['default'];

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAdn = function FaAdn(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 13.9l4.5 6.8h-8.9z m8.2 11.8h2.1l-10.3-15.4-10.2 15.4h2.1l2.3-3.6h11.7z m9-5.7q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaAdn;
	module.exports = exports['default'];

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAlignCenter = function FaAlignCenter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 30v2.9q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m-8.6-8.6v2.9q0 0.6-0.4 1t-1 0.4h-20q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h20q0.6 0 1 0.4t0.4 1z m5.7-8.5v2.8q0 0.6-0.4 1t-1 0.4h-31.4q-0.6 0-1-0.4t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h31.4q0.6 0 1 0.5t0.4 1z m-8.5-8.6v2.8q0 0.6-0.5 1t-1 0.5h-14.2q-0.6 0-1-0.5t-0.5-1v-2.8q0-0.6 0.5-1t1-0.4h14.2q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaAlignCenter;
	module.exports = exports['default'];

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAlignJustify = function FaAlignJustify(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 30v2.9q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m0-8.6v2.9q0 0.6-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m0-8.5v2.8q0 0.6-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h37.2q0.5 0 1 0.5t0.4 1z m0-8.6v2.8q0 0.6-0.4 1t-1 0.5h-37.2q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaAlignJustify;
	module.exports = exports['default'];

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAlignLeft = function FaAlignLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 30v2.9q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m-8.6-8.6v2.9q0 0.6-0.4 1t-1 0.4h-28.6q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h28.6q0.6 0 1 0.4t0.4 1z m5.7-8.5v2.8q0 0.6-0.4 1t-1 0.4h-34.3q-0.6 0-1-0.4t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h34.3q0.6 0 1 0.5t0.4 1z m-8.5-8.6v2.8q0 0.6-0.5 1t-1 0.5h-25.7q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.4h25.7q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaAlignLeft;
	module.exports = exports['default'];

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAlignRight = function FaAlignRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 30v2.9q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m0-8.6v2.9q0 0.6-0.4 1t-1 0.4h-28.6q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h28.6q0.6 0 1 0.4t0.4 1z m0-8.5v2.8q0 0.6-0.4 1t-1 0.4h-34.3q-0.6 0-1-0.4t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h34.3q0.6 0 1 0.5t0.4 1z m0-8.6v2.8q0 0.6-0.4 1t-1 0.5h-25.7q-0.6 0-1-0.5t-0.5-1v-2.8q0-0.6 0.5-1t1-0.4h25.7q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaAlignRight;
	module.exports = exports['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAmazon = function FaAmazon(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.6 32.9q0.4-0.1 0.6 0t0.2 0.4-0.3 0.7q-0.3 0.4-1 1t-2.1 1.5-3.1 1.7-4.2 1.3-5.2 0.5q-2.6 0-5.3-0.7t-4.6-1.7-3.9-2.3-3-2.4-1.8-1.9q-0.2-0.2-0.3-0.4t0.1-0.3 0.2-0.1 0.2-0.1 0.3 0.1q4.3 2.7 6.7 3.8 8.6 3.9 17.8 2 4.2-0.9 8.7-3.1z m4.6-2.5q0.3 0.3 0.1 1.5t-0.6 2.3q-0.8 1.9-1.9 2.8-0.4 0.3-0.6 0.2t0-0.5q0.5-1.1 1-2.8t0.1-2.2q-0.1-0.1-0.3-0.2t-0.6-0.2-0.7 0-0.8 0-0.7 0-0.7 0.1-0.5 0q-0.1 0.1-0.3 0.1t-0.2 0-0.2 0-0.1 0h-0.3l0 0-0.1 0 0-0.1q-0.1-0.3 1-0.9t2.3-0.6q1.1-0.2 2.4-0.1t1.7 0.6z m-8.8-9.9q0 0.7 0.3 1.4t0.8 1.3 0.8 1 0.7 0.8l0.3 0.2-5 5q-0.9-0.8-1.8-1.7t-1.3-1.3l-0.4-0.4q-0.3-0.3-0.6-0.8-0.8 1.3-2.2 2.3t-2.8 1.4-3.1 0.5-3.1-0.4-2.6-1.5-1.9-2.5-0.7-3.6q0-1.9 0.7-3.5t1.6-2.6 2.3-1.8 2.8-1.3 2.9-0.8 2.6-0.4 2.3-0.1v-2.9q0-1.4-0.5-2.1-0.8-1.2-2.7-1.2-0.1 0-0.4 0t-0.9 0.3-1.2 0.6-1.3 1.4-1 2.1l-6.6-0.6q0-1.3 0.5-2.6t1.5-2.6 2.4-2.1 3.4-1.5 4.2-0.5q2.3 0 4.1 0.6t2.9 1.3 1.8 1.9 1 1.9 0.2 1.6v13.2z m-15 0.5q0 1.9 1.6 2.9 1.5 1 3.1 0.5 1.9-0.5 2.6-2.7 0.3-1 0.3-2.3v-3.6q-1.3 0-2.5 0.3t-2.4 0.7-1.9 1.6-0.8 2.6z' })
	        )
	    );
	};
	
	exports.default = FaAmazon;
	module.exports = exports['default'];

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAmbulance = function FaAmbulance(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13 30.4q0-1.1-0.8-1.8t-1.8-0.8-1.8 0.8-0.8 1.8 0.8 1.8 1.8 0.8 1.8-0.8 0.8-1.8z m-7.8-10.4h7.8v-5.2h-3.2q-0.3 0-0.5 0.2l-3.9 3.9q-0.2 0.3-0.2 0.5v0.6z m26 10.4q0-1.1-0.8-1.8t-1.8-0.8-1.9 0.8-0.7 1.8 0.7 1.8 1.9 0.8 1.8-0.8 0.8-1.8z m2.6-13.6v-3.9q0-0.3-0.2-0.5t-0.5-0.2h-4.5v-4.5q0-0.3-0.2-0.5t-0.5-0.2h-3.9q-0.3 0-0.4 0.2t-0.2 0.5v4.5h-4.6q-0.3 0-0.4 0.2t-0.2 0.5v3.9q0 0.2 0.2 0.4t0.4 0.2h4.6v4.5q0 0.3 0.2 0.5t0.4 0.2h3.9q0.3 0 0.5-0.2t0.2-0.5v-4.5h4.5q0.3 0 0.5-0.2t0.2-0.4z m5.2-11.1v23.4q0 0.5-0.4 0.9t-0.9 0.4h-3.9q0 2.1-1.6 3.7t-3.6 1.5-3.7-1.5-1.5-3.7h-7.8q0 2.1-1.5 3.7t-3.7 1.5-3.7-1.5-1.5-3.7h-2.6q-0.5 0-0.9-0.4t-0.4-0.9 0.4-0.9 0.9-0.4v-8.4q0-0.6 0.3-1.2t0.6-1.1l4-4q0.4-0.4 1.1-0.6t1.1-0.3h3.3v-6.5q0-0.5 0.4-0.9t0.9-0.4h23.4q0.5 0 0.9 0.4t0.4 0.9z' })
	        )
	    );
	};
	
	exports.default = FaAmbulance;
	module.exports = exports['default'];

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAmericanSignLanguageInterpreting = function FaAmericanSignLanguageInterpreting(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.1 21.1q-1.1 0-1.5-0.9-0.3-0.6-0.8-1t-1.2-0.3q-1 0-1.6 0.6t-0.7 1.6q0 1 0.7 1.6l0.1 0.1q0.6 0.6 1.5 0.6 0.6 0 1.2-0.4t0.8-0.9q0.4-0.9 1.5-1z m9.9-2.2q0-1-0.6-1.6l-0.2-0.1q-0.6-0.6-1.4-0.6-0.7 0-1.2 0.4t-0.9 0.9q-0.4 0.9-1.4 1 1 0 1.4 0.9 0.3 0.6 0.9 1t1.2 0.3q0.9 0 1.6-0.6t0.6-1.6z m-7.4-3.9q-0.3 0.6-1 0.8t-1.3 0q-1.1-0.6-2.3-0.6-0.9 0-1.8 0.3 0.1 0 0.2 0t0.2 0q1.6 0 2.9 0.9t2.1 2.3q0.3 0.7 0.1 1.3t-0.9 1q-0.3 0.1-0.7 0.1 0.4 0 0.7 0.2 0.6 0.3 0.9 0.9t-0.1 1.3q-0.7 1.5-2.1 2.3t-2.9 0.9h-0.1q-0.3 0-0.8 0l-5.1-0.5-4.2 2.1q-0.2 0.1-0.5 0.1-0.7 0-1-0.6l-2.8-5.6q-0.2-0.4 0-0.8t0.5-0.7l3.6-2.1 2.6-4.7q0.3-2.7 1.6-5.1t3.4-4.1q0.6-0.4 1.3-0.4t1.1 0.6 0.4 1.3-0.6 1.1q-1.3 1-2.1 2.2 2.2-1.4 4.7-1.7 0.7-0.1 1.2 0.3t0.7 1.1q0.1 0.7-0.4 1.3t-1.1 0.6q-1.5 0.2-2.8 1 0.8-0.2 1.8-0.2 2 0 3.8 0.9 0.6 0.3 0.8 0.9t0 1.3z m16.8-2.8l2.8 5.6q0.2 0.4 0.1 0.8t-0.5 0.7l-3.7 2.1-2.6 4.7q-0.3 2.7-1.6 5.1t-3.4 4.1q-0.5 0.4-1.1 0.4-0.8 0-1.3-0.6-0.4-0.6-0.3-1.3t0.6-1.1q1.2-1 2-2.2-2.1 1.4-4.7 1.7 0 0.1-0.2 0.1-0.6 0-1.1-0.5t-0.5-1q-0.1-0.7 0.3-1.3t1.1-0.6q1.5-0.2 2.8-1-0.8 0.2-1.7 0.2-2 0-3.8-0.9-0.7-0.3-0.9-0.9t0.1-1.3q0.3-0.6 0.9-0.9t1.3 0.1q1.1 0.6 2.4 0.6 0.9 0 1.7-0.3 0 0-0.2 0t-0.1 0q-1.6 0-3-0.9t-2.1-2.3q-0.3-0.7 0-1.3t0.8-1q0.3-0.1 0.7-0.1-0.4 0-0.7-0.2-0.6-0.3-0.8-0.9t0-1.3q0.7-1.5 2.1-2.3t3-0.9h0.1q0.2 0 0.7 0l5.1 0.5 4.2-2.1q0.3-0.1 0.5-0.1 0.7 0 1 0.6z' })
	        )
	    );
	};
	
	exports.default = FaAmericanSignLanguageInterpreting;
	module.exports = exports['default'];

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAnchor = function FaAnchor(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.4 5.7q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m18.6 20.7v7.9q0 0.5-0.4 0.7-0.2 0-0.3 0-0.3 0-0.5-0.2l-2.1-2.1q-2.7 3.2-7.1 5.1t-9.6 1.8-9.6-1.8-7.1-5.1l-2.1 2.1q-0.2 0.2-0.5 0.2-0.1 0-0.3 0-0.4-0.2-0.4-0.7v-7.9q0-0.3 0.2-0.5t0.5-0.2h7.9q0.5 0 0.6 0.5 0.2 0.4-0.1 0.7l-2.2 2.3q1.5 2 4.2 3.4t6 1.8v-14.4h-4.2q-0.6 0-1-0.4t-0.5-1v-2.9q0-0.6 0.5-1t1-0.4h4.2v-3.6q-1.2-0.8-2-2.1t-0.8-2.9q0-2.4 1.7-4t4-1.7 4 1.7 1.7 4q0 1.6-0.8 2.9t-2 2v3.7h4.2q0.6 0 1 0.4t0.5 1v2.9q0 0.6-0.5 1t-1 0.4h-4.2v14.4q3.3-0.4 6-1.8t4.2-3.4l-2.2-2.3q-0.3-0.3-0.1-0.7 0.1-0.5 0.6-0.5h7.9q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAnchor;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAndroid = function FaAndroid(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.5 10.8q0.4 0 0.6-0.3t0.3-0.6-0.3-0.6-0.6-0.3-0.6 0.3-0.2 0.6 0.2 0.6 0.6 0.3z m9.4 0q0.4 0 0.6-0.3t0.3-0.6-0.3-0.6-0.6-0.3-0.6 0.3-0.2 0.6 0.2 0.6 0.6 0.3z m-18.1 4.1q0.9 0 1.6 0.7t0.7 1.6v9.6q0 0.9-0.7 1.6t-1.6 0.7-1.6-0.7-0.7-1.6v-9.6q0-1 0.7-1.6t1.6-0.7z m23.7 0.4v14.9q0 1-0.8 1.7t-1.7 0.7h-1.6v5.1q0 1-0.7 1.6t-1.6 0.7-1.7-0.7-0.6-1.6v-5.1h-3.1v5.1q0 1-0.7 1.6t-1.6 0.7q-1 0-1.6-0.7t-0.7-1.6l0-5.1h-1.7q-1 0-1.7-0.7t-0.7-1.7v-14.9h20.5z m-5.2-9q2.4 1.2 3.8 3.4t1.4 4.8h-20.6q0-2.6 1.4-4.8t3.8-3.4l-1.5-3q-0.2-0.2 0.1-0.4 0.3-0.1 0.4 0.1l1.6 3q2.1-1 4.5-1t4.5 1l1.6-3q0.2-0.2 0.5-0.1 0.2 0.2 0.1 0.4z m10.6 10.9v9.6q0 0.9-0.6 1.6t-1.7 0.7q-0.9 0-1.6-0.7t-0.6-1.6v-9.6q0-1 0.6-1.7t1.6-0.6q1 0 1.7 0.6t0.6 1.7z' })
	        )
	    );
	};
	
	exports.default = FaAndroid;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngellist = function FaAngellist(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.8 8.4l-2.6 7.4 2.6 0.4q3.7-10 3.7-11.5 0-1.3-0.8-1.3-1.3 0-2.9 5z m-6.7 15.4l0.7 1.9q0.9-0.9 1.6-1.5l-0.7-0.1-0.9-0.1-0.7-0.2z m-6.5-20q0 2.2 3.5 11.6 0.4-0.2 1.1-0.2 0.4 0 1.7 0.1l-2.7-7.8q-1.7-5-2.8-5-0.4 0-0.6 0.4t-0.2 0.9z m-1.8 16.9q0 0.8 1.2 2.7t2.6 3.4 2.2 1.5q0.3 0 0.6-0.2t0.2-0.6q0-0.6-0.7-2.3-0.3-0.7-0.7-1.6t-1-2-1.4-1.8-1.4-0.7q-0.4 0-1 0.6t-0.6 1z m-3.5 7.5q0 0.9 0.5 2.3 1.4 3.3 4.1 5.1t6.3 1.8q5.1 0 8.6-3.8 3.3-3.8 3.3-9.5 0-1 0-1.5t-0.2-1.4-0.7-1.2q-1.3-1.1-4.7-1.7t-6.1-0.6q-0.8 0-1.1 0.2-0.2 0.1-0.2 0.8 0 0.8 0.4 1.3t1.3 0.9 1.7 0.6 2 0.2 1.9 0.1 1.5 0h0.5q0.6 0 0.9 0.4 0.4 0.5 0.5 1.3-0.7 0.6-2.2 1.2-1.3 0.5-2.1 1-1.4 1-2.4 2.5t-1 3.1q0 0.7 0.4 2t0.4 1.9l0 0.3q-0.1 0.3-0.1 0.3-3.1-0.2-3.3-4.8-0.1 0-0.9 0 0.1 0.2 0.1 0.5 0 1.2-0.9 2t-2.1 0.8q-1.9 0-3.8-1.7t-1.9-3.6q0-0.7 0.8-1.5 1.1 1.5 1.3 1.7 1.7 2.3 3 2.3 0.3 0 0.6-0.2t0.3-0.4q0-0.8-1.9-3.2t-2.6-2.5q-1 0-1.6 1t-0.6 2z m-2.6 0.2q0-2.3 1-3.6t3-2q-0.6-1.7-0.6-2.3 0-1.4 1.4-2.8t2.7-1.3q0.6 0 1.6 0.3-3.7-10.3-3.7-12.7 0-1.7 0.9-2.9t2.7-1.1q2.9 0 7.3 13 0.1 0.4 0.1 0.5 0.2-0.4 0.7-1.8t0.9-2.6 1.3-2.9 1.4-2.7 1.6-2 1.7-0.8q1.6 0 2.5 1.1t0.9 2.8q0 2.4-3.6 12.2 1.4 0.4 2.3 1.1t1.3 1.7 0.6 2.1 0.1 2.5q0 3.3-1 6.2t-3 5-4.7 3.4-6.2 1.2q-2.5 0-5-0.9-3.3-1.3-5.7-4.3t-2.5-6.4z' })
	        )
	    );
	};
	
	exports.default = FaAngellist;
	module.exports = exports['default'];

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDoubleDown = function FaAngleDoubleDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 19.3q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.2-0.5 0.2t-0.6-0.2l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l1.2-1.1q0.2-0.3 0.5-0.3t0.5 0.3l8.8 8.7 8.7-8.7q0.3-0.3 0.5-0.3t0.6 0.3l1.1 1.1q0.2 0.2 0.2 0.5z m0-8.6q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.5 0.3t-0.6-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l1.2-1.1q0.2-0.2 0.5-0.2t0.5 0.2l8.8 8.8 8.7-8.8q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDoubleDown;
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDoubleLeft = function FaAngleDoubleLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22 30.7q0 0.3-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.3 0.2 0.5t-0.2 0.6l-8.8 8.7 8.8 8.8q0.2 0.2 0.2 0.5z m8.6 0q0 0.3-0.3 0.5l-1.1 1.1q-0.2 0.3-0.5 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.2-0.2 0.5-0.2t0.5 0.2l1.1 1.1q0.3 0.3 0.3 0.5t-0.3 0.6l-8.7 8.7 8.7 8.8q0.3 0.2 0.3 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDoubleLeft;
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDoubleRight = function FaAngleDoubleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z m8.6 0q0 0.3-0.3 0.5l-10.4 10.4q-0.2 0.3-0.5 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.2-0.2 0.5-0.2t0.5 0.2l10.4 10.4q0.3 0.2 0.3 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDoubleRight;
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDoubleUp = function FaAngleDoubleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 29.3q0 0.3-0.2 0.5l-1.1 1.1q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.3 0.6-0.3t0.5 0.3l10.4 10.4q0.2 0.2 0.2 0.5z m0-8.6q0 0.3-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-8.7-8.7-8.8 8.7q-0.2 0.3-0.5 0.3t-0.5-0.3l-1.2-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDoubleUp;
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleDown = function FaAngleDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 16.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.5 0.3t-0.6-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l1.2-1.1q0.2-0.2 0.5-0.2t0.5 0.2l8.8 8.8 8.7-8.8q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleDown;
	module.exports = exports['default'];

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleLeft = function FaAngleLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.5 12.1q0 0.3-0.2 0.6l-8.8 8.7 8.8 8.8q0.2 0.2 0.2 0.5t-0.2 0.5l-1.1 1.1q-0.3 0.3-0.6 0.3t-0.5-0.3l-10.4-10.4q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.5-0.2t0.6 0.2l1.1 1.1q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleLeft;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleRight = function FaAngleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.3 21.4q0 0.3-0.2 0.5l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleRight;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAngleUp = function FaAngleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31 26.4q0 0.3-0.2 0.5l-1.1 1.2q-0.3 0.2-0.6 0.2t-0.5-0.2l-8.7-8.8-8.8 8.8q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.2-1.2q-0.2-0.2-0.2-0.5t0.2-0.5l10.4-10.4q0.3-0.2 0.6-0.2t0.5 0.2l10.4 10.4q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaAngleUp;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaApple = function FaApple(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.6 27.1q-0.9 2.8-2.8 5.6-2.8 4.4-5.7 4.4-1.1 0-3.1-0.7-1.9-0.8-3.4-0.8-1.3 0-3.2 0.8-1.8 0.7-2.9 0.7-3.4 0-6.7-5.7-3.3-5.9-3.3-11.3 0-5.1 2.5-8.3 2.5-3.2 6.4-3.2 1.6 0 3.9 0.6 2.3 0.7 3.1 0.7 1 0 3.2-0.7 2.3-0.8 3.8-0.8 2.7 0 4.8 1.4 1.2 0.8 2.3 2.3-1.7 1.5-2.5 2.6-1.5 2.1-1.5 4.6 0 2.8 1.6 5t3.5 2.8z m-8.4-26.2q0 1.4-0.6 3.1-0.7 1.7-2.1 3.1-1.2 1.2-2.4 1.6-0.9 0.2-2.4 0.3 0.1-3.3 1.8-5.7 1.6-2.4 5.6-3.3 0 0.1 0 0.2t0.1 0.3q0 0.1 0 0.2t0 0.2z' })
	        )
	    );
	};
	
	exports.default = FaApple;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArchive = function FaArchive(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.3 18.6q0-0.6-0.4-1t-1-0.5h-5.8q-0.5 0-1 0.5t-0.4 1 0.4 1 1 0.4h5.8q0.5 0 1-0.4t0.4-1z m12.8-4.3v21.4q0 0.6-0.4 1t-1 0.4h-31.4q-0.6 0-1-0.4t-0.4-1v-21.4q0-0.6 0.4-1t1-0.4h31.4q0.6 0 1 0.4t0.4 1z m1.5-10v5.7q0 0.6-0.5 1t-1 0.4h-34.2q-0.6 0-1-0.4t-0.5-1v-5.7q0-0.6 0.5-1t1-0.4h34.2q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaArchive;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAreaChart = function FaAreaChart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 32.4v2.5h-39.8v-29.8h2.5v27.3h37.3z m-7.5-19.9l5 17.4h-32.3v-11.1l8.7-11.2 11.1 11.2z' })
	        )
	    );
	};
	
	exports.default = FaAreaChart;
	module.exports = exports['default'];

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleDown = function FaArrowCircleDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 20q0-0.6-0.4-1l-2.1-2q-0.4-0.4-1-0.4t-1 0.4l-4.2 4.2v-11.2q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v11.2l-4.2-4.2q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1t0.4 1l10.1 10.1q0.4 0.4 1 0.4t1.1-0.4l10.1-10.1q0.4-0.4 0.4-1z m5.6 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleDown;
	module.exports = exports['default'];

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleLeft = function FaArrowCircleLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 21.4v-2.8q0-0.6-0.5-1t-1-0.5h-11.2l4.3-4.2q0.4-0.4 0.4-1t-0.4-1l-2.1-2q-0.4-0.4-1-0.4t-1 0.4l-10.1 10.1q-0.4 0.4-0.4 1t0.4 1l10.1 10.1q0.4 0.4 1 0.4t1-0.4l2.1-2q0.4-0.4 0.4-1t-0.4-1l-4.3-4.2h11.2q0.6 0 1-0.5t0.5-1z m5.7-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleLeft;
	module.exports = exports['default'];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleODown = function FaArrowCircleODown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28 20.7q0 0.3-0.2 0.6l-7.1 7.1q-0.3 0.2-0.6 0.2t-0.5-0.2l-7.1-7.2q-0.3-0.3-0.2-0.8 0.2-0.4 0.7-0.4h4.3v-7.9q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v7.9h4.3q0.3 0 0.5 0.2t0.2 0.5z m-7.9-12.8q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6z m17.2 12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleODown;
	module.exports = exports['default'];

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleOLeft = function FaArrowCircleOLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.7 17.9v4.2q0 0.3-0.2 0.5t-0.5 0.3h-7.9v4.2q0 0.4-0.2 0.6t-0.5 0.2q-0.2 0-0.5-0.3l-7.1-7.1q-0.2-0.2-0.2-0.5t0.2-0.5l7.1-7.2q0.2-0.2 0.5-0.2 0.3 0 0.5 0.3t0.2 0.5v4.2h7.9q0.3 0 0.5 0.3t0.2 0.5z m3.6 2.1q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleOLeft;
	module.exports = exports['default'];

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleORight = function FaArrowCircleORight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.7 20q0 0.3-0.2 0.5l-7.1 7.2q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.3t-0.3-0.5v-4.2h-7.8q-0.3 0-0.5-0.3t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.3h7.8v-4.2q0-0.4 0.2-0.6t0.6-0.2q0.2 0 0.5 0.3l7.1 7.1q0.2 0.2 0.2 0.5z m3.6 0q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleORight;
	module.exports = exports['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleOUp = function FaArrowCircleOUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28 19.6q-0.2 0.4-0.7 0.4h-4.3v7.9q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-7.9h-4.3q-0.3 0-0.5-0.2t-0.2-0.5q0-0.3 0.2-0.5l7.1-7.2q0.3-0.2 0.5-0.2t0.6 0.2l7.1 7.2q0.3 0.3 0.2 0.8z m-7.9-11.7q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6z m17.2 12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleOUp;
	module.exports = exports['default'];

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleRight = function FaArrowCircleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 20q0-0.6-0.4-1l-10.1-10.1q-0.4-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1t0.4 1l4.3 4.2h-11.3q-0.5 0-1 0.5t-0.4 1v2.8q0 0.6 0.4 1t1 0.5h11.3l-4.3 4.2q-0.4 0.4-0.4 1t0.4 1l2.1 2q0.4 0.4 1 0.4t1-0.4l10.1-10.1q0.4-0.4 0.4-1z m5.6 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleRight;
	module.exports = exports['default'];

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowCircleUp = function FaArrowCircleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 20q0-0.6-0.4-1l-10.2-10.1q-0.4-0.4-1-0.4t-1 0.4l-10.1 10.1q-0.4 0.4-0.4 1t0.4 1l2.1 2q0.4 0.4 1 0.4t1-0.4l4.2-4.2v11.2q0 0.6 0.4 1t1 0.4h2.9q0.5 0 1-0.4t0.4-1v-11.2l4.2 4.2q0.4 0.4 1 0.4t1-0.4l2.1-2q0.4-0.4 0.4-1z m5.6 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaArrowCircleUp;
	module.exports = exports['default'];

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowDown = function FaArrowDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.5 18.6q0 1.2-0.9 2l-14.5 14.5q-0.9 0.9-2 0.9-1.2 0-2-0.9l-14.6-14.5q-0.8-0.8-0.8-2 0-1.2 0.8-2.1l1.7-1.6q0.9-0.9 2-0.9 1.2 0 2 0.9l6.6 6.5v-15.7q0-1.1 0.8-2t2-0.8h2.9q1.2 0 2 0.8t0.9 2v15.7l6.5-6.5q0.8-0.9 2-0.9 1.2 0 2.1 0.9l1.6 1.6q0.9 0.9 0.9 2.1z' })
	        )
	    );
	};
	
	exports.default = FaArrowDown;
	module.exports = exports['default'];

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowLeft = function FaArrowLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.3 20v2.9q0 1.1-0.7 2t-1.9 0.8h-15.7l6.5 6.6q0.9 0.8 0.9 2t-0.9 2l-1.7 1.7q-0.8 0.8-2 0.8-1.1 0-2-0.8l-14.5-14.6q-0.9-0.8-0.9-2 0-1.1 0.9-2l14.5-14.5q0.8-0.9 2-0.9 1.2 0 2 0.9l1.7 1.6q0.9 0.9 0.9 2.1t-0.9 2l-6.5 6.5h15.7q1.1 0 1.9 0.9t0.7 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowLeft;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowRight = function FaArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.4 21.4q0 1.2-0.9 2.1l-14.5 14.5q-0.9 0.8-2 0.8-1.2 0-2-0.8l-1.7-1.7q-0.9-0.8-0.9-2t0.9-2l6.5-6.6h-15.7q-1.1 0-1.9-0.8t-0.7-2v-2.9q0-1.2 0.7-2t1.9-0.9h15.7l-6.5-6.5q-0.9-0.8-0.9-2t0.9-2l1.7-1.7q0.8-0.9 2-0.9 1.2 0 2 0.9l14.5 14.5q0.9 0.8 0.9 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowRight;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowUp = function FaArrowUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.5 21.7q0 1.1-0.9 2l-1.6 1.7q-0.9 0.8-2.1 0.8-1.2 0-2-0.8l-6.5-6.6v15.7q0 1.2-0.9 1.9t-2 0.7h-2.9q-1.1 0-2-0.7t-0.8-1.9v-15.7l-6.6 6.6q-0.8 0.8-2 0.8t-2-0.8l-1.7-1.7q-0.8-0.9-0.8-2 0-1.2 0.8-2.1l14.6-14.5q0.7-0.8 2-0.8 1.2 0 2 0.8l14.5 14.5q0.9 0.9 0.9 2.1z' })
	        )
	    );
	};
	
	exports.default = FaArrowUp;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowsAlt = function FaArrowsAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 12.1l-7.9 7.9 7.9 7.9 3.3-3.2q0.6-0.7 1.5-0.3 0.9 0.4 0.9 1.3v10q0 0.6-0.4 1t-1 0.4h-10q-1 0-1.4-0.9-0.3-0.8 0.4-1.5l3.2-3.2-8-7.9-7.9 7.9 3.2 3.2q0.7 0.7 0.3 1.5-0.3 0.9-1.3 0.9h-10q-0.5 0-1-0.4t-0.4-1v-10q0-0.9 0.9-1.3 0.9-0.4 1.5 0.3l3.2 3.2 8-7.9-7.9-7.9-3.3 3.2q-0.4 0.4-1 0.4-0.2 0-0.5-0.1-0.9-0.4-0.9-1.3v-10q0-0.6 0.4-1t1-0.4h10q1 0 1.3 0.9 0.4 0.8-0.3 1.5l-3.2 3.2 7.9 7.9 8-7.9-3.2-3.2q-0.7-0.7-0.4-1.5 0.4-0.9 1.4-0.9h10q0.5 0 1 0.4t0.4 1v10q0 0.9-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4z' })
	        )
	    );
	};
	
	exports.default = FaArrowsAlt;
	module.exports = exports['default'];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowsH = function FaArrowsH(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 20q0 0.6-0.4 1l-5.7 5.7q-0.5 0.4-1 0.4t-1-0.4-0.5-1v-2.8h-22.8v2.8q0 0.6-0.5 1t-1 0.4-1-0.4l-5.7-5.7q-0.4-0.4-0.4-1t0.4-1l5.7-5.7q0.5-0.4 1-0.4t1.1 0.4 0.4 1v2.8h22.8v-2.8q0-0.6 0.5-1t1-0.4 1 0.4l5.7 5.7q0.4 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaArrowsH;
	module.exports = exports['default'];

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowsV = function FaArrowsV(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 7.1q0 0.6-0.4 1t-1 0.5h-2.9v22.8h2.9q0.6 0 1 0.5t0.4 1-0.4 1l-5.7 5.7q-0.4 0.4-1 0.4t-1-0.4l-5.7-5.7q-0.5-0.5-0.5-1t0.5-1 1-0.5h2.8v-22.8h-2.8q-0.6 0-1-0.5t-0.5-1 0.5-1l5.7-5.7q0.4-0.4 1-0.4t1 0.4l5.7 5.7q0.4 0.5 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaArrowsV;
	module.exports = exports['default'];

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrows = function FaArrows(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 20q0 0.6-0.4 1l-5.7 5.7q-0.5 0.4-1 0.4t-1-0.4-0.5-1v-2.8h-8.5v8.5h2.8q0.6 0 1 0.5t0.4 1-0.4 1l-5.7 5.7q-0.4 0.4-1 0.4t-1-0.4l-5.7-5.7q-0.4-0.5-0.4-1t0.4-1 1-0.5h2.8v-8.5h-8.5v2.8q0 0.6-0.5 1t-1 0.4-1-0.4l-5.7-5.7q-0.4-0.4-0.4-1t0.4-1l5.7-5.7q0.5-0.4 1-0.4t1.1 0.4 0.4 1v2.8h8.5v-8.5h-2.8q-0.6 0-1-0.5t-0.4-1 0.4-1l5.7-5.7q0.4-0.4 1-0.4t1 0.4l5.7 5.7q0.4 0.5 0.4 1t-0.4 1-1 0.5h-2.8v8.5h8.5v-2.8q0-0.6 0.5-1t1-0.4 1 0.4l5.7 5.7q0.4 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaArrows;
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAssistiveListeningSystems = function FaAssistiveListeningSystems(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm2.9 38.6q0 0.5-0.5 1t-1 0.4-1-0.4-0.4-1 0.4-1 1-0.5 1 0.5 0.5 1z m4.2-4.3q0 0.6-0.4 1t-1 0.4-1-0.4-0.4-1 0.4-1 1-0.4 1 0.4 0.4 1z m1-8.2l5.8 5.8-2 2-5.8-5.8z m7.6-0.4q0 0.6-0.4 1t-1 0.4-1-0.4-0.4-1 0.4-1 1-0.4 1 0.4 0.4 1z m15.8-7.1q0 1.3-0.3 2.4t-0.8 2.1-1 1.5-1.2 1.4q-0.7 0.8-1 1.2t-0.7 1.1-0.6 1.5-0.2 1.6q0 3.6-2.5 6.1t-6.1 2.5q-0.5 0-1-0.4t-0.4-1 0.4-1 1-0.5q2.4 0 4.1-1.6t1.7-4.1q0-1.2 0.2-2.3t0.8-2.1 1-1.4 1.2-1.4q0.9-1.1 1.3-1.7t0.8-1.6 0.4-2.3q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1q0 0.6-0.4 1t-1 0.4-1-0.4-0.4-1q0-2.6 1-5t2.7-4.1 4.2-2.8 4.9-1 5 1 4.1 2.8 2.8 4.1 1 5z m-11.5 2.8q0 0.6-0.4 1t-1 0.5-1-0.5-0.5-1 0.5-1 1-0.4 1 0.4 0.4 1z m6.4-2.8q0 0.5-0.4 1t-1 0.4-1-0.4-0.4-1q0-2.1-1.5-3.6t-3.5-1.4q-2.1 0-3.6 1.4t-1.4 3.6q0 0.6-0.4 1t-1.1 0.4-1-0.4-0.4-1q0-3.3 2.3-5.6t5.6-2.3 5.5 2.3 2.3 5.6z m8.8-6.5q0.2 0.6 0 1.1t-0.8 0.8q-0.2 0.1-0.5 0.1-0.4 0-0.8-0.3t-0.5-0.7q-1.5-3.9-5-6.5-0.5-0.4-0.6-1t0.3-1q0.4-0.5 0.9-0.6t1.1 0.3q4.1 3 5.9 7.8z m4.7-1.8q0.2 0.6 0 1.1t-0.8 0.8q-0.3 0.1-0.5 0.1-1 0-1.4-1-2-5.3-6.6-8.7-0.5-0.4-0.6-1t0.3-1q0.4-0.5 1-0.6t1 0.3q5.2 3.9 7.6 10z' })
	        )
	    );
	};
	
	exports.default = FaAssistiveListeningSystems;
	module.exports = exports['default'];

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAsterisk = function FaAsterisk(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.6 23.4q1 0.6 1.3 1.8t-0.3 2.1l-1.4 2.5q-0.6 1-1.7 1.3t-2.2-0.3l-5.9-3.4v6.9q0 1.1-0.9 2t-2 0.8h-2.9q-1.1 0-2-0.8t-0.8-2v-6.9l-6 3.4q-1 0.6-2.1 0.3t-1.8-1.3l-1.4-2.5q-0.6-1-0.3-2.1t1.4-1.8l5.9-3.4-5.9-3.4q-1.1-0.6-1.4-1.8t0.3-2.1l1.4-2.5q0.6-1 1.8-1.3t2.1 0.3l6 3.4v-6.9q0-1.1 0.8-2t2-0.8h2.9q1.2 0 2 0.8t0.9 2v6.9l5.9-3.4q1-0.6 2.2-0.3t1.7 1.3l1.4 2.5q0.6 1 0.3 2.1t-1.3 1.8l-6 3.4z' })
	        )
	    );
	};
	
	exports.default = FaAsterisk;
	module.exports = exports['default'];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAt = function FaAt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.7 17.3q0-2.4-1.2-3.8t-3.3-1.3q-1.4 0-2.8 0.6t-2.4 1.9-1.8 3.1-0.7 4q0 2.5 1.2 3.9t3.4 1.3q2.1 0 3.9-1.5t2.7-3.7 1-4.5z m12.6 2.7q0 2.5-0.8 4.4t-2.2 3-3 1.7-3.2 0.6q-0.1 0-0.4 0t-0.3 0q-2.1 0-3.2-1.2-0.6-0.7-0.7-1.8-1.2 1.4-3 2.4t-3.8 1q-3.6 0-5.6-2.1t-2-6q0-3.5 1.5-6.5t4-4.7 5.5-1.7q1.9 0 3.4 0.7t2.4 2.3l0-0.5 0.3-1.2q0-0.1 0.1-0.3t0.2-0.1h2.7q0.1 0 0.3 0.2 0.1 0.2 0 0.4l-2.7 13.7q-0.1 0.5-0.1 1.1 0 0.8 0.3 1.1t1 0.3q0.6 0 1.3-0.1t1.6-0.5 1.7-1.2 1.3-1.9 0.5-3.1q0-6.5-3.9-10.4t-10.4-3.9q-2.9 0-5.5 1.1t-4.6 3.1-3 4.5-1.1 5.6 1.1 5.5 3 4.6 4.6 3 5.5 1.2q5.1 0 9.1-3.2 0.2-0.2 0.5-0.2t0.5 0.3l0.9 1.1q0.2 0.2 0.2 0.5-0.1 0.3-0.3 0.5-2.3 1.8-5.1 2.8t-5.8 1q-3.4 0-6.6-1.3t-5.5-3.7-3.6-5.5-1.4-6.6 1.4-6.7 3.6-5.4 5.5-3.7 6.6-1.3q7.7 0 12.5 4.7t4.7 12.4z' })
	        )
	    );
	};
	
	exports.default = FaAt;
	module.exports = exports['default'];

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAudioDescription = function FaAudioDescription(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.8 21.7h3l0-4.6z m18-1.7q0-1.5-0.9-2.5t-2.6-0.9h-0.9v6.8h0.9q1.6 0 2.5-1t1-2.4z m-10.1-6.6l0.1 13.2q0 0.3-0.2 0.4t-0.4 0.2h-3.8q-0.3 0-0.4-0.2t-0.2-0.4v-1.1h-5.1l-0.9 1.5q-0.2 0.2-0.5 0.2h-4.7q-0.4 0-0.5-0.3t0-0.6l9.8-13.3q0.1-0.2 0.4-0.2h5.8q0.3 0 0.5 0.2t0.1 0.4z m14.5 6.6q0 3.4-2.2 5.3t-5.7 1.9h-4.7q-0.2 0-0.4-0.2t-0.2-0.4v-13.2q0-0.3 0.2-0.4t0.4-0.2h4.7q3.5 0 5.7 1.9t2.2 5.3z m2.7 0q0 0.2 0 0.5t-0.1 1.3-0.4 1.7-0.8 1.9-1.2 1.8h-0.9q0.6-0.8 1.1-1.8t0.8-2 0.3-1.7 0.2-1.2l0-0.5q0-0.2 0-0.4t-0.1-1.1-0.4-1.6-0.7-1.9-1.2-2.2h0.8q0.7 0.8 1.2 1.9t0.8 1.9 0.4 1.7 0.2 1.2z m3.3 0q0 0.2 0 0.5t-0.2 1.3-0.4 1.7-0.7 1.9-1.3 1.8h-0.9q0.6-0.8 1.1-1.8t0.8-2 0.3-1.7 0.2-1.2l0-0.5q0-0.2 0-0.4t-0.1-1.1-0.4-1.6-0.7-1.9-1.1-2.2h0.7q0.7 0.8 1.3 1.9t0.8 1.9 0.4 1.7 0.1 1.2z m3.1 0q0 0.2 0 0.5t-0.1 1.3-0.4 1.7-0.8 1.9-1.3 1.8h-0.8q0.6-0.8 1.1-1.8t0.7-2 0.4-1.7 0.2-1.2l0-0.5q0-0.2 0-0.4t-0.2-1.1-0.3-1.6-0.7-1.9-1.2-2.2h0.8q0.7 0.8 1.2 1.9t0.8 1.9 0.4 1.7 0.2 1.2z' })
	        )
	    );
	};
	
	exports.default = FaAudioDescription;
	module.exports = exports['default'];

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaAutomobile = function FaAutomobile(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.3 23.7q0-1.3-0.9-2.2t-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9 2.2-0.9 0.9-2.2z m0.7-6.2h19.7l-1.7-6.9q0-0.2-0.3-0.4t-0.4-0.1h-14.9q-0.2 0-0.4 0.1t-0.3 0.4z m26.6 6.2q0-1.3-0.9-2.2t-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9 2.2-0.9 0.9-2.2z m3.2-1.8v7.4q0 0.3-0.2 0.5t-0.5 0.1h-1.8v2.5q0 1.6-1.1 2.7t-2.7 1-2.6-1-1.1-2.7v-2.5h-19.9v2.5q0 1.6-1 2.7t-2.7 1-2.6-1-1.1-2.7v-2.5h-1.9q-0.3 0-0.4-0.1t-0.2-0.5v-7.4q0-1.8 1.3-3.1t3-1.3h0.6l2-8.1q0.5-1.8 2-3.1t3.5-1.2h14.9q1.9 0 3.5 1.2t2 3.1l2.1 8.1h0.5q1.8 0 3.1 1.3t1.3 3.1z' })
	        )
	    );
	};
	
	exports.default = FaAutomobile;
	module.exports = exports['default'];

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBackward = function FaBackward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.1 3.1q0.5-0.4 0.8-0.2t0.2 0.7v32.8q0 0.6-0.2 0.7t-0.8-0.2l-15.8-15.9q-0.2-0.2-0.3-0.4v15.8q0 0.6-0.3 0.7t-0.7-0.2l-15.9-15.9q-0.4-0.4-0.4-1t0.4-1l15.9-15.9q0.4-0.4 0.7-0.2t0.3 0.7v15.8q0.1-0.2 0.3-0.4z' })
	        )
	    );
	};
	
	exports.default = FaBackward;
	module.exports = exports['default'];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBalanceScale = function FaBalanceScale(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.5 11.8l-7 12.9h14z m-23.3 0l-7 12.9h14z m14.9-3.5q-0.2 0.8-0.8 1.3t-1.3 0.9v23.5h11.1q0.2 0 0.4 0.2t0.2 0.4v1.1q0 0.3-0.2 0.5t-0.4 0.1h-24.5q-0.3 0-0.4-0.1t-0.2-0.5v-1.1q0-0.3 0.2-0.4t0.4-0.2h11.1v-23.5q-0.8-0.3-1.3-0.9t-0.9-1.3h-8.9q-0.3 0-0.4-0.1t-0.2-0.4v-1.2q0-0.3 0.2-0.4t0.4-0.2h8.9q0.4-1 1.3-1.7t2-0.6 2 0.6 1.3 1.7h9q0.2 0 0.4 0.2t0.2 0.4v1.2q0 0.2-0.2 0.4t-0.4 0.1h-9z m-3.3 0.3q0.6 0 1.1-0.4t0.4-1-0.4-1.1-1.1-0.4-1 0.4-0.4 1.1 0.4 1 1 0.4z m19.8 16.1q0 1.3-0.8 2.4t-2.1 1.6-2.7 0.9-2.5 0.3-2.6-0.3-2.6-0.9-2.1-1.6-0.9-2.4q0-0.2 0.7-1.5t1.6-3.2 2-3.6 1.8-3.3 1.1-1.8q0.3-0.6 1-0.6t1 0.6q0.1 0.1 1 1.8t1.9 3.3 1.9 3.6 1.7 3.2 0.6 1.5z m-23.3 0q0 1.3-0.8 2.4t-2.2 1.6-2.6 0.9-2.5 0.3-2.6-0.3-2.6-0.9-2.2-1.6-0.8-2.4q0-0.2 0.6-1.5t1.7-3.2 2-3.6 1.8-3.3 1-1.8q0.4-0.6 1.1-0.6t1 0.6q0.1 0.1 1 1.8t1.9 3.3 1.9 3.6 1.7 3.2 0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaBalanceScale;
	module.exports = exports['default'];

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBan = function FaBan(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.3 19.9q0-3.6-2-6.6l-16.8 16.9q3.1 1.9 6.6 1.9 2.5 0 4.8-0.9t3.8-2.6 2.6-3.9 1-4.8z m-22.3 6.7l16.8-16.8q-3-2.1-6.7-2.1-3.3 0-6.1 1.7t-4.4 4.4-1.6 6.1q0 3.6 2 6.7z m27.3-6.7q0 3.5-1.4 6.7t-3.6 5.5-5.5 3.7-6.7 1.3-6.6-1.3-5.5-3.7-3.6-5.5-1.4-6.7 1.4-6.7 3.6-5.4 5.5-3.7 6.6-1.4 6.7 1.4 5.5 3.7 3.6 5.4 1.4 6.7z' })
	        )
	    );
	};
	
	exports.default = FaBan;
	module.exports = exports['default'];

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBank = function FaBank(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 1.4l20 8v2.6h-2.7q0 0.6-0.4 1t-1 0.4h-31.7q-0.6 0-1-0.4t-0.4-1h-2.7v-2.6z m-14.6 13.3h5.3v15.9h2.7v-15.9h5.3v15.9h2.7v-15.9h5.3v15.9h2.6v-15.9h5.3v15.9h1.3q0.6 0 1 0.4t0.4 1v1.3h-34.5v-1.3q0-0.6 0.4-1t1-0.4h1.2v-15.9z m33.1 19.9q0.6 0 1 0.4t0.5 0.9v2.7h-39.9v-2.7q0-0.5 0.4-0.9t1-0.4h37z' })
	        )
	    );
	};
	
	exports.default = FaBank;
	module.exports = exports['default'];

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBarChart = function FaBarChart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.4 20v9.9h-4.9v-9.9h4.9z m7.5-9.9v19.8h-5v-19.8h5z m19.9 22.3v2.5h-39.8v-29.8h2.5v27.3h37.3z m-12.5-17.4v14.9h-4.9v-14.9h4.9z m7.5-7.4v22.3h-5v-22.3h5z' })
	        )
	    );
	};
	
	exports.default = FaBarChart;
	module.exports = exports['default'];

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBarcode = function FaBarcode(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm1.4 34.3h-1.4v-31.4h1.4v31.4z m1.4 0h-0.7v-31.4h0.7v31.4z m2.1 0h-0.7v-31.4h0.7v31.4z m3.5 0h-0.7v-31.4h0.7v31.4z m3.5 0h-1.4v-31.4h1.4v31.4z m2.8 0h-0.7v-31.4h0.7v31.4z m1.4 0h-0.7v-31.4h0.7v31.4z m1.4 0h-0.6v-31.4h0.6v31.4z m3.6 0h-1.5v-31.4h1.4v31.4z m3.5 0h-1.5v-31.4h1.5v31.4z m2.8 0h-1.4v-31.4h1.4v31.4z m2.8 0h-1.4v-31.4h1.4v31.4z m2.1 0h-1.4v-31.4h1.4v31.4z m4.2 0h-2.1v-31.4h2.1v31.4z m1.4 0h-0.7v-31.4h0.7v31.4z m2.1 0h-1.4v-31.4h1.4v31.4z' })
	        )
	    );
	};
	
	exports.default = FaBarcode;
	module.exports = exports['default'];

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBars = function FaBars(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 30v2.9q0 0.5-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z m0-11.4v2.8q0 0.6-0.4 1t-1 0.5h-31.5q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h31.5q0.5 0 1 0.5t0.4 1z m0-11.5v2.9q0 0.6-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.5 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaBars;
	module.exports = exports['default'];

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBattery0 = function FaBattery0(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.1 14.4q0.9 0 1.6 0.7t0.6 1.5v6.8q0 0.9-0.6 1.5t-1.6 0.7v2.8q0 1.2-0.8 2t-2 0.8h-32.5q-1.2 0-2-0.8t-0.8-2v-16.8q0-1.2 0.8-2t2-0.8h32.5q1.1 0 2 0.8t0.8 2v2.8z m0 9v-6.8h-2.2v-5q0-0.2-0.2-0.4t-0.4-0.2h-32.5q-0.2 0-0.4 0.2t-0.2 0.4v16.8q0 0.2 0.2 0.4t0.4 0.2h32.5q0.2 0 0.4-0.2t0.2-0.4v-5h2.2z' })
	        )
	    );
	};
	
	exports.default = FaBattery0;
	module.exports = exports['default'];

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBattery1 = function FaBattery1(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.5 26.7v-13.4h8.9v13.4h-8.9z m33.6-12.3q0.9 0 1.6 0.7t0.6 1.5v6.8q0 0.9-0.6 1.5t-1.6 0.7v2.8q0 1.2-0.8 2t-2 0.8h-32.5q-1.2 0-2-0.8t-0.8-2v-16.8q0-1.2 0.8-2t2-0.8h32.5q1.1 0 2 0.8t0.8 2v2.8z m0 9v-6.8h-2.2v-5q0-0.2-0.2-0.4t-0.4-0.2h-32.5q-0.2 0-0.4 0.2t-0.2 0.4v16.8q0 0.3 0.2 0.4t0.4 0.2h32.5q0.2 0 0.4-0.2t0.2-0.4v-5h2.2z' })
	        )
	    );
	};
	
	exports.default = FaBattery1;
	module.exports = exports['default'];

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBattery2 = function FaBattery2(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.5 26.7v-13.4h15.7v13.4h-15.7z m33.6-12.3q0.9 0 1.6 0.7t0.6 1.5v6.8q0 0.9-0.6 1.5t-1.6 0.7v2.8q0 1.2-0.8 2t-2 0.8h-32.5q-1.2 0-2-0.8t-0.8-2v-16.8q0-1.2 0.8-2t2-0.8h32.5q1.1 0 2 0.8t0.8 2v2.8z m0 9v-6.8h-2.2v-5q0-0.2-0.2-0.4t-0.4-0.2h-32.5q-0.2 0-0.4 0.2t-0.2 0.4v16.8q0 0.3 0.2 0.4t0.4 0.2h32.5q0.2 0 0.4-0.2t0.2-0.4v-5h2.2z' })
	        )
	    );
	};
	
	exports.default = FaBattery2;
	module.exports = exports['default'];

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBattery3 = function FaBattery3(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.5 26.7v-13.4h22.4v13.4h-22.4z m33.6-12.3q0.9 0 1.6 0.7t0.6 1.5v6.8q0 0.9-0.6 1.5t-1.6 0.7v2.8q0 1.2-0.8 2t-2 0.8h-32.5q-1.2 0-2-0.8t-0.8-2v-16.8q0-1.2 0.8-2t2-0.8h32.5q1.1 0 2 0.8t0.8 2v2.8z m0 9v-6.8h-2.2v-5q0-0.2-0.2-0.4t-0.4-0.2h-32.5q-0.2 0-0.4 0.2t-0.2 0.4v16.8q0 0.3 0.2 0.4t0.4 0.2h32.5q0.2 0 0.4-0.2t0.2-0.4v-5h2.2z' })
	        )
	    );
	};
	
	exports.default = FaBattery3;
	module.exports = exports['default'];

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBattery4 = function FaBattery4(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.6 13.3v13.4h-29.1v-13.4h29.1z m2.3 10.1h2.2v-6.8h-2.2v-5q0-0.2-0.2-0.4t-0.4-0.2h-32.5q-0.2 0-0.4 0.2t-0.2 0.4v16.8q0 0.2 0.2 0.4t0.4 0.2h32.5q0.2 0 0.4-0.2t0.2-0.4v-5z m4.4-6.8v6.8q0 0.9-0.6 1.5t-1.6 0.7v2.8q0 1.2-0.8 2t-2 0.8h-32.5q-1.2 0-2-0.8t-0.8-2v-16.8q0-1.2 0.8-2t2-0.8h32.5q1.2 0 2 0.8t0.8 2v2.8q0.9 0 1.6 0.7t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaBattery4;
	module.exports = exports['default'];

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBed = function FaBed(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5 22.5h33.5q0.5 0 0.9 0.4t0.3 0.8v8.7h-4.9v-4.9h-29.8v4.9h-5v-23.6q0-0.5 0.4-0.9t0.8-0.3h2.5q0.5 0 0.9 0.3t0.4 0.9v13.7z m11.1-6.2q0-2.1-1.4-3.5t-3.5-1.5-3.5 1.5-1.5 3.5 1.5 3.5 3.5 1.4 3.5-1.4 1.4-3.5z m23.7 4.9v-1.2q0-3.1-2.2-5.3t-5.3-2.2h-13.7q-0.5 0-0.8 0.4t-0.4 0.9v7.4h22.4z' })
	        )
	    );
	};
	
	exports.default = FaBed;
	module.exports = exports['default'];

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBeer = function FaBeer(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.8 20v-8.6h-5.7v5.7q0 1.2 0.8 2.1t2 0.8h2.9z m22.8 10v4.3h-25.7v-4.3l2.9-4.3h-2.9q-3.5 0-6-2.5t-2.5-6.1v-7.1l-1.5-1.4 0.7-2.9h10.8l0.7-2.8h21.4l0.7 4.2-1.4 0.8v17.8z' })
	        )
	    );
	};
	
	exports.default = FaBeer;
	module.exports = exports['default'];

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBehanceSquare = function FaBehanceSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z m-16.8 8.1h-8.2v17.6h8.5q2.6 0 4.4-1.3t1.8-3.8q0-3.5-3.2-4.4 2.4-1.2 2.4-3.7 0-1.3-0.5-2.2t-1.2-1.3-1.8-0.7-2.2-0.2z m-0.5 7.1h-3.9v-4.1h3.7q2.6 0 2.6 2 0 2.1-2.4 2.1z m0.2 7.5h-4.1v-4.8h4.2q2.8 0 2.8 2.5 0 2.3-2.9 2.3z m14.6 0.7q-1.6 0-2.4-0.8t-0.8-2.4h9.2q0-0.2 0-0.7 0-2.9-1.6-4.9t-4.6-2q-2.8 0-4.7 2t-1.8 4.8q0 3 1.8 4.8t4.7 1.8q4.6 0 6-4.2h-3.1q-0.2 0.7-1.1 1.2t-1.6 0.4z m-0.3-8.1q2.6 0 2.8 2.7h-5.7q0.1-1.3 0.9-2t2-0.7z m-3.6-6h7.1v1.8h-7.1v-1.8z' })
	        )
	    );
	};
	
	exports.default = FaBehanceSquare;
	module.exports = exports['default'];

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBehance = function FaBehance(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 9.2h-9.9v2.4h9.9v-2.4z m-4.9 8.3q-1.8 0-2.9 1t-1.2 2.7h8q-0.4-3.7-3.9-3.7z m0.3 11.3q1.2 0 2.4-0.6t1.4-1.7h4.3q-1.9 6-8.3 6-4.1 0-6.6-2.6t-2.4-6.7q0-4.1 2.5-6.7t6.5-2.7q2.7 0 4.7 1.3t3 3.5 1 4.8q0 0.3-0.1 0.9h-12.8q0 2.2 1.2 3.3t3.2 1.2z m-25.9-1h5.7q4 0 4-3.2 0-3.5-3.9-3.5h-5.8v6.7z m0-10.4h5.4q1.5 0 2.4-0.7t0.9-2.2q0-2.8-3.7-2.8h-5v5.7z m-5.4-9.9h11.5q1.7 0 3 0.3t2.5 0.9 1.7 1.9 0.7 3q0 3.5-3.4 5.1 2.2 0.6 3.4 2.2t1.1 4q0 1.4-0.5 2.6t-1.3 2.1-1.9 1.3-2.3 0.8-2.6 0.3h-11.9v-24.5z' })
	        )
	    );
	};
	
	exports.default = FaBehance;
	module.exports = exports['default'];

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBellO = function FaBellO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.4 37.9q0-0.4-0.4-0.4-1.3 0-2.3-1t-0.9-2.2q0-0.4-0.4-0.4t-0.3 0.4q0 1.6 1.1 2.8t2.8 1.1q0.4 0 0.4-0.3z m-14.9-6.5h29q-5.9-6.7-5.9-18.5 0-1.2-0.6-2.4t-1.5-2.3-2.7-1.8-3.8-0.7-3.8 0.7-2.7 1.8-1.5 2.3-0.6 2.4q0 11.8-5.9 18.5z m33.1 0q0 1.2-0.9 2t-2 0.9h-10q0 2.4-1.7 4t-4 1.7-4-1.7-1.7-4h-10q-1.2 0-2-0.9t-0.9-2q1.1-0.9 2.1-1.9t1.9-2.7 1.6-3.5 1.1-4.6 0.5-5.8q0-3.4 2.6-6.3t6.8-3.6q-0.1-0.4-0.1-0.9 0-0.8 0.6-1.5t1.5-0.6 1.5 0.6 0.6 1.5q0 0.5-0.1 0.9 4.2 0.6 6.8 3.6t2.6 6.3q0 3.1 0.5 5.8t1.1 4.6 1.6 3.5 1.9 2.7 2.1 1.9z' })
	        )
	    );
	};
	
	exports.default = FaBellO;
	module.exports = exports['default'];

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBellSlashO = function FaBellSlashO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.2 35.5q0-0.3-0.3-0.3-1.2 0-2-0.8t-0.8-2q0-0.3-0.3-0.3t-0.3 0.3q0 1.4 1 2.4t2.4 1q0.3 0 0.3-0.3z m-10.4-9.2l17-14.7q-0.8-1.8-2.6-2.9t-4.3-1.1q-1.8 0-3.3 0.6t-2.4 1.6-1.3 2-0.5 2q0 7.4-2.6 12.5z m26.2 3.6q0 1-0.7 1.8t-1.8 0.7h-8.7q0 2.1-1.4 3.5t-3.5 1.5-3.5-1.5-1.5-3.5l2.9-2.5h14.7q-3.2-3.6-4.4-8.9l2.1-1.9q1.2 7 5.8 10.8z m1.7-27l1.6 1.9q0.2 0.2 0.2 0.4t-0.2 0.5l-36.4 31.5q-0.2 0.1-0.4 0.1t-0.4-0.2l-1.7-1.9q-0.1-0.2-0.1-0.4t0.2-0.5l3.6-3.1q-0.4-0.6-0.4-1.3 1-0.8 1.8-1.7t1.6-2.3 1.5-3.1 1-4 0.3-5q0-3 2.3-5.5t6-3.1q-0.2-0.3-0.2-0.7 0-0.8 0.6-1.4t1.3-0.5 1.3 0.6 0.5 1.3q0 0.4-0.1 0.7 2.4 0.4 4.2 1.6t2.9 3.1l8.1-7.1q0.2-0.1 0.5-0.1t0.4 0.2z' })
	        )
	    );
	};
	
	exports.default = FaBellSlashO;
	module.exports = exports['default'];

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBellSlash = function FaBellSlash(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.2 19.1q1.2 7 5.8 10.8 0 1-0.7 1.8t-1.8 0.7h-8.7q0 2.1-1.4 3.5t-3.5 1.5-3.5-1.5-1.5-3.5z m-10.3 16.7q0.3 0 0.3-0.3t-0.3-0.3q-1.2 0-2-0.8t-0.8-2q0-0.3-0.3-0.3t-0.3 0.3q0 1.4 1 2.4t2.4 1z m19.4-31q0.2 0.2 0.2 0.4t-0.2 0.5l-36.4 31.5q-0.2 0.1-0.4 0.1t-0.4-0.2l-1.7-1.9q-0.1-0.2-0.1-0.4t0.2-0.5l3.6-3.1q-0.4-0.6-0.4-1.3 1-0.8 1.8-1.7t1.6-2.3 1.5-3.1 1-4 0.3-5q0-3 2.3-5.5t6-3.1q-0.2-0.3-0.2-0.7 0-0.8 0.6-1.4t1.3-0.5 1.3 0.6 0.5 1.3q0 0.4-0.1 0.7 2.4 0.4 4.2 1.6t2.9 3.1l8.1-7.1q0.2-0.1 0.5-0.1t0.4 0.2z' })
	        )
	    );
	};
	
	exports.default = FaBellSlash;
	module.exports = exports['default'];

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBell = function FaBell(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.4 37.9q0-0.4-0.4-0.4-1.3 0-2.3-1t-0.9-2.2q0-0.4-0.4-0.4t-0.3 0.4q0 1.6 1.1 2.8t2.8 1.1q0.4 0 0.4-0.3z m18.2-6.5q0 1.2-0.9 2t-2 0.9h-10q0 2.4-1.7 4t-4 1.7-4-1.7-1.7-4h-10q-1.2 0-2-0.9t-0.9-2q1.1-0.9 2.1-1.9t1.9-2.7 1.6-3.5 1.1-4.6 0.5-5.8q0-3.4 2.6-6.3t6.8-3.6q-0.1-0.4-0.1-0.9 0-0.8 0.6-1.5t1.5-0.6 1.5 0.6 0.6 1.5q0 0.5-0.1 0.9 4.2 0.6 6.8 3.6t2.6 6.3q0 3.1 0.5 5.8t1.1 4.6 1.6 3.5 1.9 2.7 2.1 1.9z' })
	        )
	    );
	};
	
	exports.default = FaBell;
	module.exports = exports['default'];

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBicycle = function FaBicycle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.3 24.5h-5.5q-0.7 0-1-0.6t0.2-1.2l3.2-4.4q-1.1-0.5-2.4-0.5-2.3 0-3.9 1.6t-1.7 4 1.7 3.9 3.9 1.7q2.1 0 3.6-1.3t1.9-3.2z m-3.2-2.3h3.2q-0.3-1.4-1.3-2.6z m8.4 0l5-6.7h-8.4l-1.7 2.3q1.8 1.8 2.2 4.4h2.9z m19.6 1.2q0-2.3-1.6-4t-4-1.6q-1.1 0-2.1 0.4l3 4.5q0.3 0.4 0.2 0.9t-0.5 0.7q-0.2 0.2-0.6 0.2-0.6 0-0.9-0.5l-3.1-4.6q-1.6 1.7-1.6 4 0 2.3 1.6 3.9t4 1.7 4-1.7 1.6-3.9z m2.2 0q0 3.2-2.3 5.5t-5.5 2.3-5.5-2.3-2.3-5.5q0-1.7 0.6-3.2t2-2.7l-1.2-1.7-6.2 8.2q-0.3 0.5-0.9 0.5h-3.4q-0.4 2.9-2.6 4.8t-5.2 1.9q-3.2 0-5.5-2.3t-2.3-5.5 2.3-5.6 5.5-2.3q2 0 3.8 1l2.4-3.2h-3.9q-0.5 0-0.8-0.4t-0.3-0.7 0.3-0.8 0.8-0.4h6.7v2.3h7.6l-1.5-2.3h-3.9q-0.4 0-0.7-0.3t-0.4-0.8 0.4-0.8 0.7-0.3h4.5q0.6 0 1 0.5l4.6 7q1.6-0.8 3.4-0.8 3.2 0 5.5 2.3t2.3 5.6z' })
	        )
	    );
	};
	
	exports.default = FaBicycle;
	module.exports = exports['default'];

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBinoculars = function FaBinoculars(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.7 7.1v17.2q0 0.6-0.4 1t-1 0.4v12.9q0 0.5-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-11.5l5.6-19.4q0.1-0.6 0.7-0.6h9.4z m7.2 0v15.8h-5.8v-15.8h5.8z m17.1 20v11.5q0 0.6-0.4 1t-1 0.4h-11.5q-0.5 0-1-0.4t-0.4-1v-12.9q-0.6 0-1-0.4t-0.4-1v-17.2h9.5q0.5 0 0.6 0.6z m-23.6-26.4v5h-7.8v-5q0-0.3 0.2-0.5t0.5-0.2h6.4q0.3 0 0.5 0.2t0.2 0.5z m15 0v5h-7.8v-5q0-0.3 0.2-0.5t0.5-0.2h6.4q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaBinoculars;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBirthdayCake = function FaBirthdayCake(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 31.4v8.6h-40v-8.6q1 0 1.9-0.3t1.3-0.6 1.1-0.8q0.6-0.6 1.1-0.9t1.3-0.2 1.2 0.2 1.2 0.9q0.6 0.5 1 0.8t1.3 0.6 1.9 0.3q1.1 0 1.9-0.3t1.3-0.6 1.1-0.8q0.5-0.5 0.7-0.6t0.7-0.4 1-0.1q0.8 0 1.3 0.2t1.1 0.9q0.6 0.5 1.1 0.8t1.3 0.6 1.9 0.3 1.9-0.3 1.3-0.6 1-0.8q0.7-0.6 1.2-0.9t1.2-0.2q0.8 0 1.3 0.2t1.1 0.9q0.7 0.5 1.1 0.8t1.3 0.6 1.9 0.3z m0-7.1v4.3q-0.8 0-1.2-0.3t-1.2-0.8q-0.7-0.6-1.1-0.9t-1.3-0.6-1.9-0.3q-1 0-1.9 0.3t-1.3 0.6-1 0.9q-0.5 0.4-0.8 0.6t-0.6 0.3-1 0.2q-0.8 0-1.3-0.3t-1.1-0.8q-0.7-0.6-1.1-0.9t-1.3-0.6-1.9-0.3q-1 0-1.9 0.3t-1.3 0.6-1.1 0.9q-0.4 0.4-0.7 0.6t-0.7 0.3-1 0.2q-0.7 0-1.2-0.3t-1.2-0.8q-0.6-0.6-1-0.9t-1.3-0.6-1.9-0.3q-1.1 0-1.9 0.3t-1.3 0.6-1.1 0.9q-0.7 0.6-1.1 0.8t-1.3 0.3v-4.3q0-1.8 1.3-3t3-1.3h1.4v-10h5.7v10h5.7v-10h5.8v10h5.7v-10h5.7v10h1.4q1.8 0 3 1.3t1.3 3z m-28.6-19.3q0 1.7-0.8 2.6t-2 1q-1.2 0-2-0.9t-0.9-2q0-0.6 0.2-1.1t0.6-0.8 0.6-0.6 0.7-0.7 0.6-1 0.2-1.5q0.8 0 1.8 1.7t1 3.3z m11.5 0q0 1.7-0.8 2.6t-2.1 1q-1.2 0-2-0.9t-0.9-2q0-0.6 0.3-1.1t0.5-0.8 0.7-0.6 0.7-0.7 0.5-1 0.2-1.5q0.8 0 1.9 1.7t1 3.3z m11.4 0q0 1.7-0.8 2.6t-2.1 1q-1.2 0-2-0.9t-0.8-2q0-0.6 0.2-1.1t0.5-0.8 0.7-0.6 0.7-0.7 0.5-1 0.2-1.5q0.9 0 1.9 1.7t1 3.3z' })
	        )
	    );
	};
	
	exports.default = FaBirthdayCake;
	module.exports = exports['default'];

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBitbucketSquare = function FaBitbucketSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.9 19.4q0-0.9-0.9-1.5t-1.7 0q-1 0.5-1 1.6t1 1.6q0.9 0.5 1.8-0.1t0.8-1.6z m1.8-0.3q0.2 1.4-0.8 2.7t-2.4 1.3-2.7-0.9-1.3-2.5q0-1.1 0.6-2.1t1.6-1.4q1.6-0.7 3.2 0.2t1.8 2.7z m3.9-8.8q-0.5 0.5-1.2 0.8t-1.2 0.4-1.4 0.1q-3.5 0.5-7.3 0-1-0.1-1.4-0.2t-1.2-0.3-1.2-0.8q0.3-0.4 0.8-0.7t0.9-0.3 1.1-0.2q4.4-0.8 9.1 0 0.7 0.1 1.1 0.2t1 0.3 0.9 0.7z m0.9 16.7q0-0.2 0.1-0.6t0.1-0.7-0.4-0.4q-3.6 2.4-8.2 2.4t-8.1-2.4l-0.3 0.1-0.1 0.3q0.6 3.5 0.9 4.7 1.1 1.8 4.6 2.4 5.5 1 9.5-1.2 0.8-0.4 1.1-1.1t0.5-1.9 0.3-1.6z m2.9-15.5q0.2-1.2-0.2-1.7-0.9-1.2-3.4-1.9-4.9-1.4-10.9-0.8-3 0.2-5.1 1-0.8 0.3-1.3 0.6t-1 0.7-0.7 1.2q0.2 1.5 0.4 3.1t0.7 3.8 0.5 3.1q0 0.1 0.1 0.7t0.2 0.8 0.2 0.6 0.5 0.6q2.4 1.8 6.4 2.2 5.8 0.7 9.8-1.4 0.5-0.3 0.9-0.5t0.7-0.6 0.4-0.9q1.1-6 1.8-10.6z m5.9-2.2v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaBitbucketSquare;
	module.exports = exports['default'];

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBitbucket = function FaBitbucket(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.7 19.2q0.2 1.4-1.1 2.2t-2.5 0.2q-0.9-0.4-1.2-1.3t0-1.9 1.1-1.3q0.8-0.4 1.6-0.2t1.5 0.8 0.6 1.5z m2.5-0.5q-0.3-2.4-2.6-3.7t-4.3-0.2q-1.5 0.6-2.3 1.9t-0.8 2.9q0.1 2 1.8 3.5t3.7 1.2q2-0.2 3.4-1.8t1.1-3.8z m5.3-12.1q-0.4-0.6-1.2-1t-1.3-0.5-1.6-0.3q-6.5-1-12.7 0.1-0.9 0.1-1.4 0.3t-1.3 0.4-1.1 1q0.7 0.6 1.7 1t1.7 0.5 1.9 0.3q5.1 0.6 10 0 1.4-0.2 2-0.3t1.6-0.5 1.7-1z m1.3 23.1q-0.2 0.6-0.4 1.7t-0.3 1.9-0.6 1.6-1.3 1.2q-1.9 1.1-4.2 1.6t-4.6 0.5-4.4-0.4q-1.1-0.2-1.9-0.4t-1.7-0.6-1.6-1-1.2-1.4q-0.5-2.1-1.2-6.5l0.1-0.3 0.4-0.2q5 3.3 11.3 3.3t11.3-3.3q0.5 0.1 0.6 0.5t-0.1 1-0.2 0.8z m4-21.4q-0.6 3.7-2.5 14.6-0.1 0.7-0.6 1.2t-0.9 0.9-1.3 0.7q-5.6 2.8-13.6 2-5.5-0.6-8.8-3.1-0.3-0.3-0.5-0.6t-0.4-0.8-0.2-0.8-0.1-0.8-0.2-0.8q-0.2-1.1-0.6-3.4t-0.6-3.6-0.5-3.3-0.5-3.5q0.1-0.6 0.4-1.1t0.7-0.8 1-0.7 1-0.5 1.1-0.4q2.8-1 7-1.4 8.4-0.9 15.1 1.1 3.4 1 4.8 2.7 0.3 0.5 0.3 1.1t-0.1 1.3z' })
	        )
	    );
	};
	
	exports.default = FaBitbucket;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBitcoin = function FaBitcoin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.1 14.3q0.3 4-3 5.7 2.6 0.7 3.9 2.3t1 4.8q-0.1 1.6-0.7 2.8t-1.4 2-2.2 1.3-2.7 0.8-3.3 0.3v5.7h-3.4v-5.6q-1.8 0-2.7 0v5.6h-3.5v-5.7q-0.4 0-1.2 0t-1.2 0h-4.4l0.6-4.1h2.5q1.1 0 1.3-1.1v-9h0.4q-0.2 0-0.4 0v-6.4q-0.3-1.6-2-1.6h-2.4v-3.6l4.7 0q1.4 0 2.1 0v-5.6h3.5v5.5q1.8-0.1 2.7-0.1v-5.4h3.4v5.6q1.8 0.1 3.2 0.5t2.5 1 1.8 1.7 0.8 2.6z m-4.8 12.2q0-0.9-0.4-1.5t-0.8-1-1.3-0.7-1.5-0.4-1.6-0.2-1.5-0.1-1.5 0.1-1 0v7.5q0.1 0 0.8 0t1 0 1.2 0 1.3-0.1 1.3-0.2 1.2-0.3 1.1-0.4 0.9-0.7 0.5-0.9 0.2-1.1z m-1.6-10.7q0-0.7-0.3-1.3t-0.7-0.9-1.1-0.6-1.2-0.4-1.4-0.2-1.3 0-1.2 0-0.8 0v6.8q0.1 0 0.7 0.1t1.1 0 1.1-0.1 1.2-0.1 1.2-0.3 1-0.4 0.9-0.6 0.6-0.8 0.2-1.2z' })
	        )
	    );
	};
	
	exports.default = FaBitcoin;
	module.exports = exports['default'];

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBlackTie = function FaBlackTie(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3 2.9h34.3v34.2h-34.3v-34.2z m24.2 24.8l-4.9-14 4.9-6.7h-14.1l4.9 6.7-4.9 14 7 6.8z' })
	        )
	    );
	};
	
	exports.default = FaBlackTie;
	module.exports = exports['default'];

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBlind = function FaBlind(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.7 6.9q-1.5 0-2.5-1t-1-2.4q0-1.5 1-2.5t2.5-1 2.4 1 1 2.5q0 1.4-1 2.4t-2.4 1z m12.3 14.4q0 1.1-0.7 1.5t-1.4 0.1-1.1-0.7l-8.2-9.8q-0.1-0.3-0.3-0.4t-0.2 0l-0.1 0.1q-0.2 0.2 0.1 0.4l2.7 3.1 0 8-3.6 10.2q-1.5 4.2-2 5.2-0.4 0.6-0.6 0.7-1.2 0.6-2.3 0-0.7-0.3-1-0.9t-0.2-1.3q0.1-0.4 4.4-13.8l0.1-9.3-1.9 3.7 0.8 4.9q0.1 0.6 0 1t-0.3 0.6-0.4 0.3-0.4 0.2l-0.2 0q-0.4 0.1-0.7 0t-0.6-0.4-0.3-0.5-0.2-0.4 0-0.2l-1-6.7 4.7-8.5q0.5-0.8 2.5-0.8 1.7 0 2.4 0.9l9.5 11.7q0.1 0.1 0.3 0.3l0 0.1 0 0q0.2 0.3 0.2 0.7z m-9 3.3q0.9 2.5 1.9 5t1.6 3.8l0.5 1.2q0.8 2.1 1 2.8 0.2 1.6-0.8 2.2-0.8 0.5-1.5 0.3t-1.1-0.5-0.7-0.7h0q-0.1-0.4-0.2-0.6l-2.8-7.8z m18.4 13.2q0.7 1.1 0.7 1.3 0 0.1-0.1 0.2-0.2 0.1-0.3 0t-0.4-0.6-0.3-0.7q-2.6-3.8-9.5-14.8 0.1 0.1 0.2 0t0.1-0.1l0.1 0q0.2-0.2 0.2-0.4z' })
	        )
	    );
	};
	
	exports.default = FaBlind;
	module.exports = exports['default'];

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBluetoothB = function FaBluetoothB(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.8 31.8l3.9-3.9-3.9-3.8v7.7z m0-15.9l3.9-3.8-3.9-3.9v7.7z m0.7 4.1l8 7.9-12.1 12.1v-15.9l-6.6 6.6-2.4-2.4 8.3-8.3-8.3-8.3 2.4-2.4 6.6 6.6v-15.9l12.1 12.1z' })
	        )
	    );
	};
	
	exports.default = FaBluetoothB;
	module.exports = exports['default'];

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBluetooth = function FaBluetooth(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.8 23.5l3.3 3.3-3.4 3.3z m0-13.6l3.3 3.3-3.3 3.3z m-3 27.3l10.4-10.4-6.8-6.8 6.8-6.8-10.4-10.4v13.7l-5.6-5.7-2.1 2 7.1 7.2-7.1 7.2 2.1 2 5.6-5.6v13.6z m16.1-17.2q0 4.7-0.7 8.2t-2 5.7-3.1 3.6-4.1 2-4.9 0.5-4.9-0.5-4-2-3.1-3.6-2-5.7-0.7-8.2 0.7-8.2 2-5.7 3.1-3.6 4-2 4.9-0.5 4.9 0.5 4.1 2 3.1 3.6 2 5.7 0.7 8.2z' })
	        )
	    );
	};
	
	exports.default = FaBluetooth;
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBold = function FaBold(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.9 34q1.6 0.7 3.1 0.7 8.4 0 8.4-7.5 0-2.6-0.9-4-0.6-1-1.4-1.7t-1.5-1-1.8-0.6-1.9-0.2-2.1-0.1q-1.6 0-2.2 0.3 0 1.1 0 3.5t0 3.5q0 0.2-0.1 1.5t0 2.2 0.1 1.9 0.3 1.5z m-0.3-16.7q0.9 0.2 2.4 0.2 1.8 0 3.2-0.3t2.5-1 1.6-2 0.6-3.2q0-1.6-0.7-2.7t-1.7-1.9-2.4-0.9-2.8-0.3q-1.1 0-2.9 0.2 0 1.2 0.1 3.4t0.1 3.4q0 0.6 0 1.8t0 1.8q0 1 0 1.5z m-12.1 19.8l0-2.1q0.4 0 1.9-0.3t2.4-0.6q0.2-0.3 0.3-0.6t0.2-0.8 0.1-0.7 0.1-0.8 0-0.8v-1.5q0-21.9-0.5-22.8-0.1-0.2-0.5-0.4t-1-0.2-1.1-0.2-1.1-0.1-0.7 0l-0.1-1.9q2.2 0 7.6-0.2t8.4-0.2q0.5 0 1.5 0t1.5 0q1.6 0 3 0.3t2.9 0.9 2.4 1.6 1.7 2.3 0.6 3.1q0 1.2-0.4 2.1t-0.8 1.6-1.5 1.3-1.6 1-1.9 0.9q3.5 0.8 5.7 3t2.3 5.5q0 2.3-0.8 4t-2 3-3.1 1.9-3.7 1.1-3.9 0.3q-1 0-2.9-0.1t-3-0.1q-2.4 0-6.8 0.3t-5.2 0.2z' })
	        )
	    );
	};
	
	exports.default = FaBold;
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBolt = function FaBolt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.8 12.6q0.4 0.5 0.1 1l-12 25.8q-0.3 0.6-1 0.6-0.1 0-0.3 0-0.4-0.2-0.6-0.5t-0.1-0.6l4.4-18.1-9 2.3q-0.1 0-0.3 0-0.4 0-0.7-0.2-0.4-0.4-0.3-0.9l4.5-18.4q0.1-0.3 0.4-0.5t0.6-0.2h7.3q0.4 0 0.7 0.2t0.3 0.7q0 0.2-0.1 0.4l-3.8 10.3 8.8-2.2q0.2 0 0.3 0 0.4 0 0.8 0.3z' })
	        )
	    );
	};
	
	exports.default = FaBolt;
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBomb = function FaBomb(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.7 13.1q-0.2-0.5-0.7-0.7t-1.1 0q-2.4 0.9-4.3 2.8t-2.8 4.3q-0.2 0.5 0 1.1t0.8 0.7q0.3 0.1 0.5 0.1 1 0 1.4-0.9 0.7-1.8 2.2-3.3t3.3-2.2q0.5-0.2 0.7-0.8t0-1.1z m21.1-7.9l1 1-5.4 5.5 1.5 1.5q0.4 0.4 0.4 1t-0.4 1l-1.5 1.4q2 3.6 2 7.7 0 3.2-1.2 6.1t-3.4 5-5 3.4-6.1 1.2-6.1-1.2-5-3.4-3.4-5-1.2-6.1 1.2-6.1 3.4-5 5-3.4 6.1-1.2q4.1 0 7.7 2l1.4-1.5q0.4-0.4 1-0.4t1 0.4l1.6 1.6z m0.2-1.2q-0.3 0.2-0.5 0.2-0.3 0-0.6-0.2l-2-2.1q-0.2-0.2-0.2-0.5t0.2-0.5q0.2-0.2 0.5-0.2t0.5 0.2l2.1 2q0.2 0.2 0.2 0.5t-0.2 0.5z m5.1 5.1q-0.3 0.2-0.5 0.2t-0.5-0.2l-2.1-2q-0.2-0.2-0.2-0.5t0.2-0.5q0.2-0.3 0.6-0.3t0.5 0.3l2 2q0.2 0.2 0.2 0.5t-0.2 0.5z m0.9-4.1q0 0.3-0.2 0.5t-0.5 0.2h-2.2q-0.3 0-0.5-0.2t-0.2-0.5 0.2-0.5 0.5-0.2h2.2q0.3 0 0.5 0.2t0.2 0.5z m-4.3-4.3v2.2q0 0.3-0.2 0.5t-0.5 0.2-0.5-0.2-0.2-0.5v-2.2q0-0.3 0.2-0.5t0.5-0.2 0.5 0.2 0.2 0.5z m3.4 1.2l-2 2.1q-0.3 0.2-0.5 0.2-0.3 0-0.6-0.2-0.2-0.2-0.2-0.5t0.2-0.6l2.1-2q0.2-0.2 0.5-0.2t0.5 0.2q0.2 0.2 0.2 0.5t-0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaBomb;
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBook = function FaBook(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.1 10.7q0.9 1.2 0.4 2.9l-6.1 20.2q-0.5 1.4-1.8 2.4t-2.7 0.9h-20.6q-1.7 0-3.3-1.2t-2.2-2.9q-0.6-1.5-0.1-2.8 0-0.1 0.1-0.6t0.1-0.9q0-0.1-0.1-0.4t-0.1-0.5q0.1-0.2 0.2-0.4t0.4-0.6 0.4-0.5q0.5-0.8 1-2t0.6-2.1q0.1-0.2 0-0.6t0-0.7q0.1-0.2 0.4-0.6t0.4-0.5q0.5-0.8 0.9-2.1t0.6-2q0-0.2-0.1-0.7t0-0.6q0.1-0.3 0.5-0.7t0.5-0.5q0.4-0.6 1-1.9t0.6-2.1q0-0.2-0.1-0.6t0-0.6q0-0.2 0.2-0.4t0.4-0.5 0.4-0.5q0.1-0.2 0.3-0.6t0.4-0.8 0.3-0.8 0.5-0.7 0.5-0.6 0.9-0.2 1 0.1l0 0.1q0.8-0.2 1.1-0.2h17q1.7 0 2.6 1.2t0.4 2.9l-6.2 20.2q-0.8 2.7-1.6 3.5t-2.8 0.7h-19.4q-0.6 0-0.9 0.4-0.2 0.3 0 0.9 0.5 1.6 3.2 1.6h20.6q0.7 0 1.3-0.4t0.8-0.9l6.7-22q0.1-0.5 0.1-1.3 0.8 0.3 1.3 1z m-23.8 0q-0.1 0.3 0.1 0.5t0.4 0.2h13.6q0.3 0 0.6-0.2t0.3-0.5l0.5-1.4q0.1-0.3 0-0.5t-0.5-0.2h-13.6q-0.2 0-0.5 0.2t-0.4 0.5z m-1.8 5.7q-0.1 0.3 0 0.5t0.5 0.2h13.5q0.3 0 0.6-0.2t0.4-0.5l0.5-1.4q0-0.3-0.1-0.5t-0.4-0.2h-13.6q-0.3 0-0.6 0.2t-0.4 0.5z' })
	        )
	    );
	};
	
	exports.default = FaBook;
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBookmarkO = function FaBookmarkO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.2 5.7h-22.8v27.7l11.4-10.9 2 1.9 9.4 9v-27.7z m0.3-2.8q0.5 0 1 0.2 0.7 0.2 1.1 0.9t0.5 1.4v28.7q0 0.8-0.5 1.4t-1.1 0.9q-0.5 0.2-1 0.2-1.1 0-1.9-0.7l-9.8-9.5-9.9 9.5q-0.8 0.7-1.8 0.7-0.5 0-1-0.2-0.7-0.3-1.2-0.9t-0.4-1.4v-28.7q0-0.8 0.4-1.4t1.2-0.9q0.5-0.2 1-0.2h23.4z' })
	        )
	    );
	};
	
	exports.default = FaBookmarkO;
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBookmark = function FaBookmark(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.5 2.9q0.5 0 1 0.2 0.7 0.2 1.1 0.9t0.5 1.4v28.7q0 0.8-0.5 1.4t-1.1 0.9q-0.5 0.2-1 0.2-1.1 0-1.9-0.7l-9.8-9.5-9.9 9.5q-0.8 0.7-1.8 0.7-0.5 0-1-0.2-0.7-0.3-1.2-0.9t-0.4-1.4v-28.7q0-0.8 0.4-1.4t1.2-0.9q0.5-0.2 1-0.2h23.4z' })
	        )
	    );
	};
	
	exports.default = FaBookmark;
	module.exports = exports['default'];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBraille = function FaBraille(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3.5 25.2q-1.2 0-2.1 0.9t-0.8 2.1 0.8 2 2.1 0.9 2.1-0.9 0.8-2-0.8-2.1-2.1-0.9z m9.3 0q-1.2 0-2 0.9t-0.9 2.1 0.9 2 2 0.9 2.1-0.9 0.8-2-0.8-2.1-2.1-0.9z m0-9.3q-1.2 0-2 0.9t-0.9 2 0.9 2.1 2 0.8 2.1-0.8 0.8-2.1-0.8-2-2.1-0.9z m14 9.3q-1.2 0-2 0.9t-0.9 2.1 0.9 2 2 0.9 2.1-0.9 0.8-2-0.8-2.1-2.1-0.9z m9.4 0q-1.3 0-2.1 0.9t-0.9 2.1 0.9 2 2.1 0.9 2-0.9 0.9-2-0.9-2.1-2-0.9z m-9.4-9.3q-1.2 0-2 0.9t-0.9 2 0.9 2.1 2 0.8 2.1-0.8 0.8-2.1-0.8-2-2.1-0.9z m9.4 0q-1.3 0-2.1 0.9t-0.9 2 0.9 2.1 2.1 0.8 2-0.8 0.9-2.1-0.9-2-2-0.9z m0-9.3q-1.3 0-2.1 0.8t-0.9 2.1 0.9 2.1 2.1 0.8 2-0.8 0.9-2.1-0.9-2.1-2-0.8z m-29.2 21.6q0 1.4-1 2.4t-2.5 1.1-2.5-1.1-1-2.4 1-2.5 2.5-1 2.5 1 1 2.5z m9.3 0q0 1.4-1 2.4t-2.5 1.1-2.5-1.1-1-2.4 1-2.5 2.5-1 2.5 1 1 2.5z m-9.3-9.4q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.4 2.5-1.1 2.5 1.1 1 2.4z m9.3 0q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.4 2.5-1.1 2.5 1.1 1 2.4z m-9.3-9.3q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.5 2.5-1 2.5 1 1 2.5z m23.3 18.7q0 1.4-1 2.4t-2.5 1.1-2.5-1.1-1-2.4 1-2.5 2.5-1 2.5 1 1 2.5z m-14-18.7q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.5 2.5-1 2.5 1 1 2.5z m23.3 18.7q0 1.4-1 2.4t-2.4 1.1-2.5-1.1-1-2.4 1-2.5 2.5-1 2.4 1 1 2.5z m-9.3-9.4q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.4 2.5-1.1 2.5 1.1 1 2.4z m9.4 0q0 1.5-1.1 2.5t-2.4 1-2.5-1-1-2.5 1-2.4 2.5-1.1 2.4 1.1 1 2.4z m-9.4-9.3q0 1.5-1 2.5t-2.5 1-2.5-1-1-2.5 1-2.5 2.5-1 2.5 1 1 2.5z m9.4 0q0 1.5-1.1 2.5t-2.4 1-2.5-1-1-2.5 1-2.5 2.5-1 2.4 1 1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaBraille;
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBriefcase = function FaBriefcase(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 5.7h11.4v-2.8h-11.4v2.8z m25.7 14.3v10.7q0 1.5-1 2.5t-2.6 1.1h-32.8q-1.5 0-2.6-1.1t-1-2.5v-10.7h15v3.6q0 0.5 0.4 1t1 0.4h7.2q0.6 0 1-0.4t0.4-1v-3.6h15z m-17.1 0v2.9h-5.8v-2.9h5.8z m17.1-10.7v8.6h-40v-8.6q0-1.5 1.1-2.5t2.5-1.1h7.8v-3.6q0-0.8 0.7-1.5t1.5-0.6h12.8q0.9 0 1.5 0.6t0.7 1.5v3.6h7.8q1.5 0 2.6 1.1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaBriefcase;
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBug = function FaBug(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.9 21.4q0 0.6-0.4 1t-1 0.5h-5q0 3.8-1.5 6.4l4.6 4.7q0.5 0.4 0.5 1t-0.5 1q-0.4 0.4-1 0.4t-1-0.4l-4.4-4.4q-0.1 0.1-0.3 0.3t-1 0.6-1.4 0.8-1.8 0.7-2.2 0.3v-20h-2.9v20q-1.1 0-2.2-0.3t-2-0.8-1.4-0.8-1-0.8l-0.3-0.3-4.1 4.7q-0.5 0.4-1.1 0.4-0.5 0-1-0.3-0.4-0.4-0.4-1t0.3-1.1l4.5-5q-1.3-2.6-1.3-6.1h-5q-0.5 0-1-0.5t-0.4-1 0.4-1 1-0.4h5v-6.6l-3.8-3.8q-0.4-0.4-0.4-1t0.4-1 1-0.5 1 0.5l3.8 3.8h18.9l3.9-3.8q0.4-0.5 1-0.5t1 0.5 0.4 1-0.4 1l-3.9 3.8v6.6h5q0.6 0 1 0.4t0.4 1z m-10.7-12.8h-14.3q0-3 2.1-5.1t5.1-2.1 5 2.1 2.1 5.1z' })
	        )
	    );
	};
	
	exports.default = FaBug;
	module.exports = exports['default'];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBuildingO = function FaBuildingO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 29.3v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m5.7 0v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.5q0.2 0 0.5 0.3t0.2 0.5z m17.1 11.4v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.4q0-0.3 0.3-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.5q0.3 0 0.5 0.3t0.2 0.5z m-5.7-5.8v1.5q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.2 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m17.1 11.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.4q0-0.3 0.3-0.5t0.5-0.3h1.4q0.3 0 0.5 0.3t0.2 0.5z m-5.7-5.8v1.5q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.5q0-0.2 0.2-0.5t0.5-0.2h1.5q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.5q0 0.2-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m17.1 11.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.4q0.3 0 0.5 0.3t0.2 0.5z m-5.7-5.8v1.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.5q0-0.2 0.3-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.5q0 0.2-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h1.5q0.3 0 0.5 0.2t0.2 0.5z m11.4 5.7v1.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.2 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.5q0 0.2-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.5q0-0.3 0.3-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m5.7 0v1.5q0 0.2-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7 30.7h8.6v-34.2h-25.7v34.2h8.5v-5q0-0.2 0.2-0.5t0.5-0.2h7.2q0.3 0 0.5 0.2t0.2 0.5v5z m11.4-35.7v37.2q0 0.5-0.4 1t-1 0.4h-28.6q-0.6 0-1-0.4t-0.4-1v-37.2q0-0.6 0.4-1t1-0.4h28.6q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaBuildingO;
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBuilding = function FaBuilding(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.5 0q0.6 0 1 0.4t0.4 1v37.2q0 0.5-0.4 1t-1 0.4h-28.6q-0.6 0-1-0.4t-0.4-1v-37.2q0-0.6 0.4-1t1-0.4h28.6z m-18.6 6.4v1.5q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5z m0 5.7v1.5q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5z m0 5.8v1.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.6z m0 5.7v1.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5z m-2.8 7.1v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.6v1.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m11.4 28.5v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-7.2q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.2q0.3 0 0.5-0.2t0.2-0.5z m0-11.4v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.4 0-0.6 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.6 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-1.4q-0.4 0-0.6 0.2t-0.2 0.6v1.4q0 0.3 0.2 0.5t0.6 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.4 0-0.6 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.6 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.4 0-0.6 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.6 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.7 22.8v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.6v1.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.5q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v1.5q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z' })
	        )
	    );
	};
	
	exports.default = FaBuilding;
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBullhorn = function FaBullhorn(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.1 14.3q1.2 0 2.1 0.8t0.8 2-0.8 2.1-2.1 0.8v8.6q0 1.1-0.8 2t-2 0.8q-9.3-7.7-18.1-8.5-1.3 0.5-2.1 1.5t-0.7 2.3 0.9 2q-0.4 0.8-0.5 1.5t0.2 1.3 0.7 1.2 1.1 1.1 1.3 1.2q-0.6 1.2-2.4 1.8t-3.8 0.3-2.9-1.3q-0.2-0.5-0.7-1.9t-0.7-2.1-0.5-2-0.4-2.3 0.1-2.2 0.5-2.4h-2.7q-1.5 0-2.5-1.1t-1.1-2.5v-4.3q0-1.5 1.1-2.5t2.5-1.1h10.7q9.7 0 20-8.5 1.1 0 2 0.8t0.8 2v8.6z m-2.8 13.5v-21.3q-8.8 6.7-17.2 7.6v6.1q8.5 0.9 17.2 7.6z' })
	        )
	    );
	};
	
	exports.default = FaBullhorn;
	module.exports = exports['default'];

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBullseye = function FaBullseye(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 20q0 2.4-1.7 4t-4.1 1.7-4-1.7-1.7-4 1.7-4 4-1.7 4.1 1.7 1.7 4z m2.8 0q0-3.6-2.5-6.1t-6.1-2.5-6 2.5-2.5 6.1 2.5 6.1 6 2.5 6.1-2.5 2.5-6.1z m2.9 0q0 4.7-3.4 8.1t-8.1 3.3-8-3.3-3.4-8.1 3.4-8.1 8-3.3 8.1 3.3 3.4 8.1z m2.8 0q0-2.9-1.1-5.5t-3.1-4.6-4.5-3.1-5.6-1.1-5.5 1.1-4.6 3.1-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5z m2.9 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaBullseye;
	module.exports = exports['default'];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBus = function FaBus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 27.1q0-1.1-0.9-2t-2-0.8-2 0.8-0.8 2 0.8 2.1 2 0.8 2-0.8 0.9-2.1z m22.8 0q0-1.1-0.8-2t-2-0.8-2 0.8-0.9 2 0.9 2.1 2 0.8 2-0.8 0.8-2.1z m-1-8.8l-1.6-8.6q-0.1-0.5-0.5-0.8t-0.9-0.3h-20.5q-0.5 0-0.9 0.3t-0.5 0.8l-1.6 8.6q-0.1 0.7 0.3 1.2t1.1 0.5h23.7q0.7 0 1.1-0.5t0.3-1.2z m-5-13.7q0-0.4-0.4-0.7t-0.7-0.3h-14.3q-0.4 0-0.8 0.3t-0.3 0.7 0.3 0.8 0.8 0.3h14.3q0.4 0 0.7-0.3t0.4-0.8z m8.9 16.2v13.5h-2.9v2.8q0 1.2-0.8 2.1t-2 0.8-2-0.8-0.9-2.1v-2.8h-17.1v2.8q0 1.2-0.9 2.1t-2 0.8-2-0.8-0.8-2.1v-2.8h-2.9v-13.5q0-2.5 0.6-5l2.3-10.1q0.2-1.7 2.1-3t5.2-2 6.9-0.7 7 0.7 5.2 2 2.1 3l2.4 10.1q0.5 2.3 0.5 5z' })
	        )
	    );
	};
	
	exports.default = FaBus;
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaBuysellads = function FaBuysellads(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.4 24.2h-6.5l3.2-12.3z m1.9 7.2h7l-7.2-22.8h-9.9l-7.2 22.8h6.9l8.6-7z m12-22.1v21.4q0 2.6-1.9 4.5t-4.5 1.9h-21.5q-2.6 0-4.5-1.9t-1.9-4.5v-21.4q0-2.6 1.9-4.5t4.5-1.9h21.5q2.6 0 4.5 1.9t1.9 4.5z' })
	        )
	    );
	};
	
	exports.default = FaBuysellads;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCab = function FaCab(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.4 20q1.8 0 3.1 1.3t1.3 3v7.5q0 0.3-0.2 0.4t-0.5 0.2h-1.8v1.3q0 1.5-1.1 2.6t-2.7 1.1-2.6-1.1-1.1-2.6v-1.3h-19.9v1.3q0 1.5-1 2.6t-2.7 1.1-2.6-1.1-1.1-2.6v-1.3h-1.9q-0.3 0-0.4-0.2t-0.2-0.4v-7.5q0-1.8 1.3-3t3-1.3h0.6l2-8.1q0.5-1.9 2-3.1t3.5-1.2h2.5v-4.4q0-0.2 0.2-0.4t0.4-0.2h8.7q0.3 0 0.5 0.2t0.1 0.4v4.4h2.5q1.9 0 3.5 1.2t2 3.1l2.1 8.1h0.5z m-29.2 9.3q1.3 0 2.2-0.9t0.9-2.2-0.9-2.2-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9z m3.8-9.3h19.7l-1.7-6.9q0-0.2-0.3-0.4t-0.4-0.2h-14.9q-0.2 0-0.4 0.2t-0.3 0.4z m23.5 9.3q1.3 0 2.2-0.9t0.9-2.2-0.9-2.2-2.2-0.9-2.2 0.9-0.9 2.2 0.9 2.2 2.2 0.9z' })
	        )
	    );
	};
	
	exports.default = FaCab;
	module.exports = exports['default'];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalculator = function FaCalculator(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.1 34.3q0-1.2-0.9-2t-2-0.9-2 0.9-0.8 2 0.8 2 2 0.8 2-0.8 0.9-2z m8.5 0q0-1.2-0.8-2t-2-0.9-2 0.9-0.9 2 0.9 2 2 0.8 2-0.8 0.8-2z m-8.5-8.6q0-1.2-0.9-2t-2-0.8-2 0.8-0.8 2 0.8 2 2 0.9 2-0.9 0.9-2z m17.1 8.6q0-1.2-0.8-2t-2-0.9-2.1 0.9-0.8 2 0.8 2 2.1 0.8 2-0.8 0.8-2z m-8.6-8.6q0-1.2-0.8-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.8-2z m-8.5-8.6q0-1.1-0.9-2t-2-0.8-2 0.8-0.8 2 0.8 2.1 2 0.8 2-0.8 0.9-2.1z m17.1 8.6q0-1.2-0.8-2t-2-0.8-2.1 0.8-0.8 2 0.8 2 2.1 0.9 2-0.9 0.8-2z m-8.6-8.6q0-1.1-0.8-2t-2-0.8-2 0.8-0.9 2 0.9 2.1 2 0.8 2-0.8 0.8-2.1z m17.2 17.2v-8.6q0-1.1-0.9-2t-2-0.8-2 0.8-0.8 2v8.6q0 1.1 0.8 2t2 0.8 2-0.8 0.9-2z m-8.6-17.2q0-1.1-0.8-2t-2-0.8-2.1 0.8-0.8 2 0.8 2.1 2.1 0.8 2-0.8 0.8-2.1z m8.6-7.1v-5.7q0-0.6-0.4-1t-1-0.4h-28.6q-0.6 0-1 0.4t-0.4 1v5.7q0 0.6 0.4 1t1 0.4h28.6q0.5 0 1-0.4t0.4-1z m0 7.1q0-1.1-0.9-2t-2-0.8-2 0.8-0.8 2 0.8 2.1 2 0.8 2-0.8 0.9-2.1z m2.8-14.2v34.2q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.8t-0.8-2.1v-34.2q0-1.2 0.8-2.1t2.1-0.8h31.4q1.1 0 2 0.8t0.8 2.1z' })
	        )
	    );
	};
	
	exports.default = FaCalculator;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarCheckO = function FaCalendarCheckO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.6 21.5l-11.4 11.4q-0.3 0.2-0.6 0.2t-0.5-0.2l-6.4-6.4q-0.2-0.2-0.2-0.5t0.2-0.5l1-1q0.2-0.2 0.5-0.2t0.5 0.2l4.9 4.9 10-9.9q0.2-0.2 0.5-0.2t0.5 0.2l1 1q0.2 0.2 0.2 0.5t-0.2 0.5z m-26.2 15.6h31.4v-22.8h-31.4v22.8z m8.5-27.1v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m17.2 0v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendarCheckO;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarMinusO = function FaCalendarMinusO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 25v1.4q0 0.3-0.2 0.5t-0.5 0.2h-12.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h12.9q0.3 0 0.5 0.2t0.2 0.5z m-22.8 12.1h31.4v-22.8h-31.4v22.8z m8.5-27.1v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m17.2 0v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendarMinusO;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarO = function FaCalendarO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h31.4v-22.8h-31.4v22.8z m8.5-27.1v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m17.2 0v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendarO;
	module.exports = exports['default'];

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarPlusO = function FaCalendarPlusO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 5.7q1.1 0 2 0.9t0.8 2v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9z m-8.6-2.1v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5z m-17.1 0v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5z m25.7 33.5v-22.8h-31.4v22.8h31.4z m-14.3-12.8h5q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-5v5q0 0.4-0.2 0.6t-0.5 0.2h-1.4q-0.4 0-0.6-0.2t-0.2-0.6v-5h-5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h5v-5q0-0.3 0.2-0.5t0.6-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5v5z' })
	        )
	    );
	};
	
	exports.default = FaCalendarPlusO;
	module.exports = exports['default'];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendarTimesO = function FaCalendarTimesO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.3 30.9l-1 1q-0.2 0.2-0.5 0.2t-0.5-0.2l-4.2-4.2-4.2 4.2q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.1-1q-0.2-0.2-0.2-0.5t0.2-0.5l4.3-4.2-4.3-4.2q-0.2-0.2-0.2-0.5t0.2-0.5l1.1-1q0.2-0.2 0.5-0.2t0.5 0.2l4.2 4.2 4.2-4.2q0.2-0.2 0.5-0.2t0.5 0.2l1 1q0.2 0.2 0.2 0.5t-0.2 0.5l-4.2 4.2 4.2 4.2q0.2 0.2 0.2 0.5t-0.2 0.5z m-21.9 6.2h31.4v-22.8h-31.4v22.8z m8.5-27.1v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m17.2 0v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendarTimesO;
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = function FaCalendar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h6.4v-6.4h-6.4v6.4z m7.8 0h7.2v-6.4h-7.2v6.4z m-7.8-7.8h6.4v-7.2h-6.4v7.2z m7.8 0h7.2v-7.2h-7.2v7.2z m-7.8-8.6h6.4v-6.4h-6.4v6.4z m16.4 16.4h7.1v-6.4h-7.1v6.4z m-8.6-16.4h7.2v-6.4h-7.2v6.4z m17.2 16.4h6.4v-6.4h-6.4v6.4z m-8.6-7.8h7.1v-7.2h-7.1v7.2z m-7.9-19.3v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m16.5 19.3h6.4v-7.2h-6.4v7.2z m-8.6-8.6h7.1v-6.4h-7.1v6.4z m8.6 0h6.4v-6.4h-6.4v6.4z m0.7-10.7v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.2 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendar;
	module.exports = exports['default'];

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCameraRetro = function FaCameraRetro(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.7 18.6q0-0.3-0.2-0.5t-0.5-0.2q-1.5 0-2.5 1t-1.1 2.5q0 0.3 0.2 0.5t0.5 0.2 0.6-0.2 0.2-0.5q0-0.9 0.6-1.5t1.5-0.6q0.3 0 0.5-0.2t0.2-0.5z m5 2.9q0 2.3-1.7 4t-4 1.7-4-1.7-1.7-4 1.7-4.1 4-1.6 4 1.6 1.7 4.1z m-22.8 12.8h34.2v-2.9h-34.2v2.9z m25.7-12.8q0-3.6-2.5-6.1t-6.1-2.5-6.1 2.5-2.5 6.1 2.5 6 6.1 2.5 6.1-2.5 2.5-6z m-22.9-14.4h8.6v-2.8h-8.6v2.8z m-2.8 4.3h34.2v-5.7h-18.4l-1.5 2.9h-14.3v2.8z m37.1-5.7v28.6q0 1.2-0.8 2t-2.1 0.8h-34.2q-1.2 0-2.1-0.8t-0.8-2v-28.6q0-1.2 0.8-2t2.1-0.8h34.2q1.2 0 2.1 0.8t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCameraRetro;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCamera = function FaCamera(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 15.3q2.5 0 4.3 1.8t1.7 4.2-1.7 4.3-4.3 1.7-4.2-1.7-1.7-4.3 1.7-4.2 4.2-1.8z m14.7-8.6q2.2 0 3.7 1.6t1.6 3.7v18.6q0 2.2-1.6 3.8t-3.7 1.5h-29.3q-2.2 0-3.7-1.5t-1.6-3.8v-18.6q0-2.2 1.6-3.7t3.7-1.6h4.7l1-2.8q0.4-1 1.5-1.8t2.1-0.7h10.6q1.1 0 2.2 0.7t1.4 1.8l1.1 2.8h4.7z m-14.7 23.9q3.9 0 6.6-2.7t2.7-6.6-2.7-6.5-6.6-2.8-6.5 2.8-2.8 6.5 2.8 6.6 6.5 2.7z' })
	        )
	    );
	};
	
	exports.default = FaCamera;
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretDown = function FaCaretDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 15.7q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.4-0.4-0.4-1t0.4-1 1-0.4h20q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretDown;
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretLeft = function FaCaretLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.3 10v20q0 0.6-0.4 1t-1 0.4-1-0.4l-10-10q-0.5-0.4-0.5-1t0.5-1l10-10q0.4-0.4 1-0.4t1 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretLeft;
	module.exports = exports['default'];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretRight = function FaCaretRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.4 20q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4-0.4-1v-20q0-0.6 0.4-1t1-0.4 1 0.4l10 10q0.5 0.4 0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretRight;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretSquareODown = function FaCaretSquareODown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 15.1q0.4 0.7-0.2 1.4l-7.1 10q-0.4 0.6-1.2 0.6t-1.1-0.6l-7.2-10q-0.5-0.7-0.1-1.4 0.4-0.8 1.3-0.8h14.3q0.9 0 1.3 0.8z m3 15.6v-21.4q0-0.3-0.2-0.5t-0.5-0.2h-21.5q-0.3 0-0.5 0.2t-0.2 0.5v21.4q0 0.3 0.2 0.5t0.5 0.2h21.5q0.2 0 0.5-0.2t0.2-0.5z m5.7-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaCaretSquareODown;
	module.exports = exports['default'];

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretSquareOLeft = function FaCaretSquareOLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 12.9v14.2q0 0.6-0.5 1t-1 0.5q-0.4 0-0.8-0.3l-10-7.1q-0.6-0.5-0.6-1.2t0.6-1.2l10-7.1q0.4-0.3 0.8-0.3 0.6 0 1 0.5t0.5 1z m5.7 17.8v-21.4q0-0.3-0.2-0.5t-0.5-0.2h-21.5q-0.3 0-0.5 0.2t-0.2 0.5v21.4q0 0.3 0.2 0.5t0.5 0.2h21.5q0.2 0 0.5-0.2t0.2-0.5z m5.7-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaCaretSquareOLeft;
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretSquareORight = function FaCaretSquareORight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.3 20q0 0.7-0.6 1.2l-10 7.1q-0.7 0.5-1.5 0.1-0.8-0.4-0.8-1.3v-14.2q0-0.9 0.8-1.3 0.8-0.4 1.5 0.1l10 7.1q0.6 0.5 0.6 1.2z m4.3 10.7v-21.4q0-0.3-0.2-0.5t-0.5-0.2h-21.5q-0.3 0-0.5 0.2t-0.2 0.5v21.4q0 0.3 0.2 0.5t0.5 0.2h21.5q0.3 0 0.5-0.2t0.2-0.5z m5.7-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaCaretSquareORight;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretSquareOUp = function FaCaretSquareOUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 24.9q-0.4 0.8-1.3 0.8h-14.3q-0.9 0-1.3-0.8-0.4-0.7 0.1-1.4l7.2-10q0.4-0.6 1.1-0.6t1.2 0.6l7.1 10q0.6 0.7 0.2 1.4z m3 5.8v-21.4q0-0.3-0.2-0.5t-0.5-0.2h-21.5q-0.3 0-0.5 0.2t-0.2 0.5v21.4q0 0.3 0.2 0.5t0.5 0.2h21.5q0.2 0 0.5-0.2t0.2-0.5z m5.7-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaCaretSquareOUp;
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCaretUp = function FaCaretUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 27.1q0 0.6-0.5 1t-1 0.5h-20q-0.6 0-1-0.5t-0.4-1 0.4-1l10-10q0.4-0.4 1-0.4t1 0.4l10 10q0.5 0.5 0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaCaretUp;
	module.exports = exports['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCartArrowDown = function FaCartArrowDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 15.7q0-0.6-0.5-1t-1-0.4-1 0.4l-3.2 3.3v-6.6q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1v6.6l-3.3-3.3q-0.4-0.4-1-0.4t-1 0.4-0.4 1 0.4 1l5.7 5.7q0.4 0.5 1 0.5t1-0.5l5.7-5.7q0.5-0.4 0.5-1z m-14.3 18.6q0 1.2-0.8 2t-2.1 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m20 0q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m2.8-24.3v11.4q0 0.6-0.3 1t-0.9 0.5l-23.3 2.7q0 0.1 0.1 0.5t0.1 0.6 0.1 0.4q0 0.4-0.6 1.5h20.6q0.5 0 1 0.4t0.4 1-0.4 1-1 0.4h-22.9q-0.6 0-1-0.4t-0.4-1q0-0.3 0.2-0.9t0.7-1.3 0.4-0.9l-3.9-18.3h-4.6q-0.6 0-1-0.5t-0.4-1 0.4-1 1-0.4h5.7q0.4 0 0.7 0.2t0.4 0.3 0.3 0.6 0.2 0.5 0.1 0.7 0.1 0.6h26.8q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaCartArrowDown;
	module.exports = exports['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCartPlus = function FaCartPlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 15.7q0-0.6-0.4-1t-1-0.4h-2.8v-2.9q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1v2.9h-2.9q-0.5 0-1 0.4t-0.4 1 0.4 1 1 0.4h2.9v2.9q0 0.6 0.4 1t1 0.4 1-0.4 0.5-1v-2.9h2.8q0.6 0 1-0.4t0.4-1z m-12.8 18.6q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m20 0q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m2.8-24.3v11.4q0 0.6-0.3 1t-0.9 0.5l-23.3 2.7q0 0.1 0.1 0.5t0.1 0.6 0.1 0.4q0 0.4-0.6 1.5h20.6q0.5 0 1 0.4t0.4 1-0.4 1-1 0.4h-22.9q-0.6 0-1-0.4t-0.4-1q0-0.3 0.2-0.9t0.7-1.3 0.4-0.9l-3.9-18.3h-4.6q-0.6 0-1-0.5t-0.4-1 0.4-1 1-0.4h5.7q0.4 0 0.7 0.2t0.4 0.3 0.3 0.6 0.2 0.5 0.1 0.7 0.1 0.6h26.8q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaCartPlus;
	module.exports = exports['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcAmex = function FaCcAmex(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm2.1 16.3h1.5l-0.7-1.9z m10.9 9.2l1.3-1.4-1.3-1.4h-2.8v0.9h2.5v0.9h-2.5v1h2.8z m2.7-1.4l1.8 1.9v-3.8z m5.1-0.8q0-0.6-0.7-0.6h-1.5v1.2h1.4q0.8 0 0.8-0.6z m5-0.1q0-0.5-0.7-0.5h-1.4v1.1h1.4q0.7 0 0.7-0.6z m-4.8-8.2q0-0.5-0.8-0.5h-1.4v1.1h1.4q0.8 0 0.8-0.6z m8 1.3h1.5l-0.7-1.9z m-16.8-2.8v4.8h-1.1v-3.7l-1.7 3.7h-1l-1.6-3.7v3.7h-2.3l-0.5-1.1h-2.3l-0.5 1.1h-1.2l2.1-4.8h1.6l2 4.5v-4.5h1.8l1.5 3.3 1.3-3.3h1.9z m9.8 9.8q0 0.3-0.1 0.6t-0.3 0.4-0.4 0.3-0.4 0.2-0.6 0.1-0.5 0-0.6 0-0.5 0v1.6h-2.2l-1.4-1.6-1.5 1.6h-4.4v-4.8h4.5l1.4 1.6 1.4-1.6h3.7q1.9 0 1.9 1.6z m-5.1-6v1h-3.8v-4.8h3.8v1h-2.7v0.9h2.6v1h-2.6v0.9h2.7z m23.4 9.8v4q0 1-0.6 1.7t-1.7 0.6h-35.7q-1 0-1.6-0.6t-0.7-1.7v-11.9h1.9l0.5-1h0.9l0.5 1h3.8v-0.8l0.3 0.8h2l0.4-0.8v0.8h9.4v-1.7l0.2 0q0.2 0 0.2 0.2v1.5h4.9v-0.4q0.4 0.2 0.9 0.3t0.9 0.2 1.2-0.1 0.9 0l0.4-1h1l0.4 1h4v-1l0.6 1h3.2v-6.6h-3.2v0.8l-0.4-0.8h-3.3v0.8l-0.4-0.8h-4.3q-1.2 0-1.9 0.4v-0.4h-3v0.4q-0.5-0.4-1.3-0.4h-11l-0.8 1.7-0.7-1.7h-3.5v0.8l-0.4-0.8h-2.9l-1.4 3.1v-6.8q0-1 0.7-1.7t1.6-0.6h35.7q1 0 1.7 0.6t0.6 1.7v11.9h-2.1q-0.9 0-1.4 0.4v-0.4h-3.1q-0.9 0-1.3 0.4v-0.4h-5.6v0.4q-0.5-0.4-1.5-0.4h-3.7v0.4q-0.4-0.4-1.6-0.4h-4l-1 1-0.9-1h-6.1v6.6h6l1-1 0.9 1h3.7v-1.6h0.4q1 0 1.5-0.2v1.8h3.1v-1.7h0.1q0.2 0 0.2 0t0 0.2v1.5h9.3q1 0 1.5-0.4v0.4h3q1 0 1.6-0.3z m-13.2-4.1q0 0.4-0.2 0.7t-0.6 0.6q0.4 0.1 0.6 0.4t0.1 0.8v1h-1.1v-0.8q0-0.6-0.2-0.8t-0.8-0.2h-1.2v1.8h-1.2v-4.8h2.7q0.9 0 1.4 0.3t0.5 1z m-4.9-8.2q0 0.4-0.2 0.8t-0.6 0.5q0.5 0.2 0.6 0.4t0.2 0.9v0.9h-1.2q0-0.2 0-0.5t0-0.4 0-0.3-0.2-0.3-0.3-0.2-0.5 0h-1.2v1.7h-1.1v-4.8l2.6 0.1q0.9 0 1.4 0.2t0.5 1z m9.3 10.7v1h-3.8v-4.8h3.8v1h-2.7v0.9h2.6v0.9h-2.6v1z m-7.5-12v4.8h-1.1v-4.8h1.1z m12.2 11.5q0 1.5-1.8 1.5h-2.2v-1.1h2.2q0.6 0 0.6-0.4 0-0.3-0.3-0.4t-0.8 0-0.8-0.1-0.8-0.4-0.3-1q0-0.6 0.5-1t1.1-0.4h2.3v1h-2.1q-0.6 0-0.6 0.4 0 0.3 0.3 0.4t0.8 0.1 0.8 0 0.7 0.4 0.4 1z m4.1-0.9v1.7q-0.4 0.7-1.5 0.7h-2.2v-1.1h2.2q0.6 0 0.6-0.4 0-0.2-0.2-0.3t-0.6-0.1-0.7-0.1-0.7-0.1-0.5-0.4-0.3-0.9q0-0.6 0.5-1t1.2-0.4h2.2v1h-2q-0.7 0-0.7 0.4 0 0.4 0.5 0.4t1.2 0.1 1 0.5z m-2.9-10.5v4.7h-1.6l-2.1-3.6v3.6h-2.3l-0.5-1.1h-2.3l-0.4 1.1h-1.4q-2.2 0-2.2-2.3 0-2.5 2.3-2.5h1.1v1.1q-0.1 0-0.5 0t-0.5-0.1-0.4 0.1-0.4 0.1-0.2 0.2-0.2 0.4-0.1 0.6q0 0.7 0.3 1t0.8 0.4h0.5l1.7-3.7h1.7l1.9 4.4v-4.4h1.7l2 3.2v-3.2h1.1z' })
	        )
	    );
	};
	
	exports.default = FaCcAmex;
	module.exports = exports['default'];

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcDinersClub = function FaCcDinersClub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15 26v-12.1q-1.8 0.7-3 2.4t-1.1 3.7 1.1 3.7 3 2.3z m8.8-6q0-2.1-1.1-3.7t-3-2.4v12.2q1.8-0.8 3-2.4t1.1-3.7z m3.8 0q0 2.8-1.4 5.1t-3.7 3.8-5.2 1.3q-2 0-3.9-0.8t-3.3-2.2-2.2-3.2-0.8-4q0-2.8 1.4-5.2t3.7-3.7 5.1-1.4 5.2 1.4 3.7 3.7 1.4 5.2z m6.7 0.1q0-2.4-1-4.6t-2.5-3.6-3.8-2.3-4.4-0.8h-5.3q-3 0-5.6 1.4t-4.1 4-1.6 5.9q0 3 1.5 5.6t4.2 4 5.6 1.5h5.3q2.3 0 4.4-0.9t3.8-2.3 2.5-3.6 1-4.3z m6-11.3v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcDinersClub;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcDiscover = function FaCcDiscover(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.5 17.9q0 0.9-0.7 1.5-0.5 0.4-1.5 0.4h-0.3v-3.8h0.3q1.1 0 1.5 0.5 0.7 0.5 0.7 1.4z m31.1-1.1q0 0.9-1.1 0.9h-0.4v-1.8h0.4q1.1 0 1.1 0.9z m-29.9 1.1q0-1.3-0.9-2.1t-2.3-0.8h-1.6v5.8h1.6q1.3 0 2.1-0.6 1.1-0.9 1.1-2.3z m0.5 2.9h1.1v-5.8h-1.1v5.8z m5.6-1.7q0-0.7-0.4-1.1t-1.3-0.8q-0.5-0.1-0.7-0.3t-0.2-0.4q0-0.3 0.3-0.5t0.6-0.2q0.5 0 0.9 0.5l0.6-0.7q-0.7-0.7-1.7-0.7-0.8 0-1.3 0.5t-0.6 1.2q0 0.6 0.4 0.9t1.1 0.7q0.6 0.2 0.8 0.3 0.3 0.2 0.3 0.6 0 0.4-0.2 0.6t-0.7 0.2q-0.8 0-1.2-0.7l-0.7 0.7q0.7 1.1 2 1.1 0.9 0 1.4-0.6t0.6-1.3z m4.8 1.5v-1.3q-0.6 0.6-1.3 0.6-0.9 0-1.4-0.5t-0.6-1.5q0-0.8 0.6-1.4t1.3-0.6q0.8 0 1.4 0.7v-1.4q-0.7-0.3-1.4-0.3-1.3 0-2.2 0.9t-0.9 2.1 0.9 2.2 2.2 0.9q0.8 0 1.4-0.4z m21.6 10.6v-9.2q-1.1 0.7-2.5 1.5t-4.2 2-5.7 2.4-7.3 2.4-8.9 2h27.5q0.4 0 0.8-0.3t0.3-0.8z m-14.9-13.2q0-1.4-0.9-2.3t-2.3-0.9-2.2 0.9-0.9 2.3 0.9 2.2 2.2 0.9 2.3-0.9 0.9-2.2z m2.7 3l2.5-6h-1.2l-1.6 3.9-1.6-3.9h-1.2l2.5 6h0.6z m3-0.2h3.2v-1h-2.1v-1.5h2.1v-1h-2.1v-1.3h2.1v-1h-3.2v5.8z m6.9 0h1.4l-1.9-2.4q1.3-0.3 1.3-1.7 0-0.8-0.5-1.3t-1.5-0.4h-1.7v5.8h1.1v-2.3h0.2z m3.4-11.9v22.2q0 1-0.6 1.7t-1.7 0.6h-35.7q-1 0-1.6-0.6t-0.7-1.7v-22.2q0-1 0.7-1.7t1.6-0.6h35.7q1 0 1.7 0.6t0.6 1.7z' })
	        )
	    );
	};
	
	exports.default = FaCcDiscover;
	module.exports = exports['default'];

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcJcb = function FaCcJcb(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.2 21.8q0 0.4-0.3 0.8t-0.7 0.4q-0.1 0-0.3 0h-2.7v-2.4h2.7q0.2 0 0.3 0 0.4 0.1 0.7 0.4t0.3 0.8z m-0.4-3.7q0 0.4-0.2 0.7t-0.7 0.4q0 0-0.2 0h-2.5v-2.3h2.4q0.1 0 0.2 0t0.1 0q0.4 0.1 0.7 0.4t0.2 0.8z m-21.1 2.8v-5.4h-3.9v5.4q0 1-0.7 1.7t-1.8 0.6q-1.9 0-4.1-1v2q1 0.2 2.2 0.4t1.9 0.1l0.7 0q5.7 0 5.7-3.8z m12.5 3.2v-1.9q-1.7 0.9-3.5 1-1.8 0.1-2.9-0.7t-1.1-2.5 1.1-2.5 2.9-0.7q1.8 0.1 3.5 1v-1.9q-0.8-0.3-1.7-0.4t-1.4-0.2l-0.5 0q-2.2-0.1-3.8 0.3t-2.5 1-1.2 1.5-0.4 1.9 0.4 1.9 1.2 1.5 2.5 1 3.8 0.3q1.8-0.1 3.6-0.6z m12.9-2q0-0.9-0.8-1.5t-1.9-0.7v-0.1q1-0.1 1.6-0.7t0.6-1.4q0-0.9-0.8-1.5t-1.8-0.6q-0.1 0-0.2-0.1t-0.3 0h-8v9h8.6q1.3 0 2.2-0.7t0.8-1.7z m2.2-13.3v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcJcb;
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcMastercard = function FaCcMastercard(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.7 20.6h-0.2q-0.8 0-0.8 0.6 0 0.4 0.3 0.4 0.3 0 0.5-0.3t0.2-0.7z m7-0.6h1v0q0.1-0.1 0.1-0.1t-0.1-0.2 0-0.1-0.1-0.1-0.1-0.1-0.2 0q-0.5 0-0.6 0.6z m9.4 0.6h-0.2q-0.8 0-0.8 0.6 0 0.4 0.3 0.4 0.3 0 0.5-0.3t0.2-0.7z m5.6-0.4q0-0.7-0.5-0.7-0.4 0-0.6 0.3t-0.2 0.9q0 0.8 0.5 0.8 0.4 0 0.6-0.4t0.2-0.9z m-25.3-2.5h1.5l-0.7 4.6h-1l0.5-3.5-1.2 3.5h-0.7l-0.1-3.5-0.6 3.5h-0.9l0.8-4.6h1.4l0 2.9z m4.4 1.9q0 0.1 0 0.7-0.3 1.8-0.3 2h-0.9l0.1-0.4q-0.4 0.5-1.1 0.5-0.4 0-0.6-0.3t-0.3-0.7q0-0.7 0.5-1.1t1.3-0.4q0.2 0 0.4 0 0 0 0 0t0-0.1 0-0.1q0-0.3-0.6-0.3-0.5 0-1.1 0.1 0 0 0.2-0.8 0.6-0.2 1.1-0.2 1.3 0 1.3 1.1z m2.8-1l-0.2 0.8q-0.4 0-0.7 0-0.5 0-0.5 0.3 0 0.1 0.1 0.2t0.4 0.2q0.7 0.3 0.7 1 0 1.3-1.5 1.3-0.6 0-1.1-0.1 0-0.1 0.2-0.9 0.5 0.2 0.9 0.2 0.5 0 0.5-0.4 0-0.1-0.1-0.2t-0.3-0.2q-0.8-0.3-0.8-1 0-1.3 1.5-1.3 0.5 0 0.9 0.1z m1.5 0h0.5l-0.1 0.9h-0.5q-0.1 0.3-0.1 0.7t-0.2 0.7 0 0.3q0 0.3 0.3 0.3 0.2 0 0.3-0.1l-0.1 0.9q-0.4 0.1-0.7 0.1-0.8 0-0.8-0.8 0-0.3 0.1-1 0.1-0.4 0.4-2.6h1z m3.6 1.3q0 0.4-0.2 0.9h-1.9q-0.1 0.4 0.2 0.5t0.6 0.2q0.6 0 1-0.2l-0.1 0.9q-0.5 0.2-1 0.2-1.7 0-1.7-1.7 0-0.9 0.5-1.6t1.2-0.6q0.6 0 1 0.4t0.4 1z m2.4-1.3q-0.2 0.4-0.4 1.1-0.4-0.1-0.5 0.4t-0.5 2.2h-1l0.1-0.2q0.4-2.3 0.5-3.5h0.9l-0.1 0.6q0.3-0.4 0.5-0.6t0.5 0z m3.3-0.8l-0.2 1q-0.5-0.2-0.9-0.2-0.5 0-0.9 0.5t-0.3 1.2q0 0.5 0.2 0.8t0.7 0.3q0.4 0 0.8-0.2l-0.1 1q-0.5 0.2-0.9 0.2-0.8 0-1.3-0.6t-0.4-1.4q0-1.2 0.6-2t1.6-0.8q0.5 0 1.1 0.2z m2.8 1.8q0 0.3-0.1 0.7-0.2 1.4-0.3 2h-0.8l0-0.4q-0.3 0.5-1 0.5-0.4 0-0.6-0.3t-0.3-0.7q0-0.7 0.5-1.1t1.2-0.4q0.3 0 0.4 0 0.1-0.1 0.1-0.2 0-0.3-0.7-0.3-0.5 0-1 0.1 0 0 0.1-0.8 0.7-0.2 1.2-0.2 1.3 0 1.3 1.1z m2.5-1q-0.3 0.4-0.4 1.1-0.4-0.1-0.6 0.4t-0.4 2.2h-1l0.1-0.2q0.3-1.9 0.5-3.5h0.9q0 0.2-0.1 0.6 0.3-0.4 0.5-0.6t0.5 0z m2.4-0.9h1l-0.7 4.6h-1l0.1-0.3q-0.4 0.4-0.9 0.4-0.6 0-0.9-0.4t-0.3-1.2q0-0.9 0.5-1.6t1.1-0.7q0.5 0 0.9 0.6z m2 2.3q0-2.6-1.3-4.8t-3.5-3.4-4.7-1.3q-3.2 0-5.8 1.9 2.2 2 3 5h-0.9q-0.7-2.7-2.7-4.5-2 1.8-2.8 4.5h-0.9q0.8-3 3-5-2.6-1.9-5.7-1.9-2.6 0-4.8 1.3t-3.5 3.4-1.2 4.8 1.2 4.8 3.5 3.4 4.8 1.3q3.1 0 5.7-1.9-2.1-1.9-2.9-4.6h0.9q0.8 2.4 2.7 4.1 1.8-1.7 2.6-4.1h0.9q-0.8 2.7-2.9 4.6 2.6 1.9 5.8 1.9 2.5 0 4.7-1.3t3.5-3.4 1.3-4.8z m4.2-11.2v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcMastercard;
	module.exports = exports['default'];

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcPaypal = function FaCcPaypal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13 20.2q0 0.6-0.4 1.1t-1.1 0.4q-0.5 0-0.8-0.3t-0.3-0.8q0-0.6 0.4-1.1t1.1-0.4q0.5 0 0.8 0.3t0.3 0.8z m13.8-2.6q0 0.7-0.4 1t-1.2 0.2l-0.5 0 0.3-1.8q0-0.2 0.2-0.2h0.3q0.4 0 0.6 0t0.5 0.2 0.2 0.6z m6.1 2.6q0 0.6-0.4 1t-1.1 0.5q-0.5 0-0.8-0.3t-0.3-0.8q0-0.6 0.4-1.1t1.1-0.4q0.5 0 0.8 0.3t0.3 0.8z m-23.9-3q0-1.1-0.7-1.5t-1.8-0.5h-2.8q-0.3 0-0.3 0.4l-1.2 7.1q0 0.1 0.1 0.2t0.2 0.1h1.3q0.3 0 0.4-0.4l0.3-1.9q0-0.1 0.1-0.2t0.3-0.1 0.3 0 0.3 0 0.3 0q1.5 0 2.3-0.9t0.9-2.3z m5.4 5.4l0.7-4.5q0-0.1 0-0.2t-0.2-0.1h-1.3q-0.3 0-0.3 0.6-0.5-0.7-1.7-0.7-1.3 0-2.2 0.9t-0.8 2.2q0 1.1 0.6 1.7t1.6 0.6q0.5 0 1-0.2t0.8-0.6q0 0.2 0 0.4 0 0.3 0.2 0.3h1.2q0.3 0 0.4-0.4z m7.8-4.6q0 0-0.1-0.1t-0.1-0.1h-1.4q-0.2 0-0.3 0.2l-1.8 2.7-0.8-2.6q-0.1-0.3-0.4-0.3h-1.3q-0.1 0-0.2 0.1t0 0.1q0 0.1 0.3 1.1t0.7 2.1 0.5 1.3q-1.5 1.9-1.5 2.1 0 0.2 0.3 0.2h1.3q0.2 0 0.3-0.2l4.5-6.4q0-0.1 0-0.2z m6.7-0.8q0-1.1-0.7-1.5t-1.8-0.5h-2.7q-0.4 0-0.4 0.4l-1.2 7.1q0 0.1 0.1 0.2t0.2 0.1h1.4q0.2 0 0.3-0.3l0.3-2q0-0.1 0.1-0.2t0.3-0.1 0.3 0 0.3 0 0.2 0q1.6 0 2.4-0.9t0.9-2.3z m5.4 5.4l0.7-4.5q0-0.1-0.1-0.2t-0.1-0.1h-1.4q-0.2 0-0.3 0.6-0.4-0.7-1.6-0.7-1.3 0-2.2 0.9t-0.9 2.2q0 1.1 0.7 1.7t1.6 0.6q0.5 0 1-0.2t0.8-0.6q0 0 0 0.2t0 0.2q0 0.3 0.2 0.3h1.2q0.3 0 0.4-0.4z m3.8-7.1v0q0-0.3-0.2-0.3h-1.3q-0.2 0-0.3 0.2l-1.1 7.3 0 0q0 0.1 0.1 0.2t0.1 0.1h1.2q0.3 0 0.4-0.4z m-31.2 2.3q-0.1 0.6-0.5 0.8t-1 0.2l-0.6 0 0.3-1.8q0-0.2 0.2-0.2h0.3q0.7 0 1.1 0.2t0.2 0.8z m33.4-9v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcPaypal;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcStripe = function FaCcStripe(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28 20.1q0 1.2-0.4 1.9-0.3 0.6-0.9 0.6-0.4 0-0.7-0.2v-3.9q0.5-0.5 1-0.5 1 0 1 2.1z m7.6-0.6h-1.9q0.1-1.7 1-1.7 0.9 0 0.9 1.7z m-27.3 2.4q0-1.1-0.5-1.6t-1.8-1.1q-0.6-0.2-0.9-0.4t-0.3-0.4q0-0.5 0.7-0.5 1 0 2.1 0.6l0.3-1.9q-1.1-0.6-2.6-0.6-1.3 0-2.1 0.7-0.9 0.6-0.9 1.9 0 1 0.6 1.5t1.8 1q0.6 0.3 0.9 0.5t0.3 0.5q0 0.5-0.9 0.5-0.5 0-1.2-0.2t-1.2-0.5l-0.4 1.9q1.3 0.8 3 0.8 1.4 0 2.2-0.7 0.9-0.7 0.9-2z m5.2-3.8l0.3-2h-1.7v-2.3l-2.2 0.4-0.3 1.9-0.8 0.2-0.3 1.8h1.1v3.8q0 1.5 0.7 2.1 0.7 0.6 2 0.6 0.5 0 1.4-0.2v-2.1q-0.6 0.1-0.8 0.1-0.8 0-0.8-0.9v-3.4h1.4z m5.5 0.4v-2.4q-0.2-0.1-0.5-0.1-0.5 0-0.9 0.3t-0.6 0.8l-0.2-1h-2.3v8.3h2.6v-5.4q0.5-0.5 1.5-0.5 0.3 0 0.4 0z m0.7 5.9h2.6v-8.3h-2.6v8.3z m10.9-4.4q0-2.1-0.8-3.1-0.7-0.9-2-0.9-1.1 0-2 1l-0.2-0.9h-2.3v11.3l2.7-0.4v-2.6q0.6 0.2 1.2 0.2 1.4 0 2.3-1 1.1-1.2 1.1-3.6z m-8.2-6.1q0-0.5-0.4-0.9t-1-0.4-1 0.4-0.4 0.9 0.4 1 1 0.4 1-0.4 0.4-1z m15.7 6.3q0-2-0.8-3.1-0.9-1.1-2.6-1.1-1.6 0-2.6 1.1t-1 3.2q0 2.2 1.1 3.3 1 1 2.8 1 1.8 0 2.8-0.7l-0.2-1.9q-1 0.6-2.3 0.6-0.7 0-1.1-0.3-0.4-0.4-0.5-1.2h4.4q0-0.2 0-0.9z m2.2-11.4v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcStripe;
	module.exports = exports['default'];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCcVisa = function FaCcVisa(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.6 21.6h-2.4q0.2-0.6 1.1-3.1l0.1-0.1q0-0.2 0.1-0.5t0.2-0.5l0.2 1z m-25.3-1.1l-1-5.2q-0.2-0.9-1.3-0.9h-4.7l-0.1 0.2q5.5 1.4 7.1 5.9z m3.1-6.1l-2.8 7.7-0.3-1.6q-0.5-1.2-1.5-2.3t-2.3-1.5l2.4 8.9h3l4.6-11.2h-3.1z m2.5 11.2h2.9l1.8-11.2h-2.9z m13.4-10.9q-1.2-0.5-2.6-0.5-2.2 0-3.5 1t-1.4 2.7q0 1.8 2.5 3.1 0.9 0.4 1.2 0.7t0.3 0.7q0 0.5-0.5 0.8t-1.2 0.2q-1.5 0-2.7-0.5l-0.4-0.2-0.4 2.5q1.3 0.6 3.2 0.6 2.3 0 3.7-1t1.4-2.8q0-1.9-2.5-3.1-0.8-0.4-1.2-0.7t-0.4-0.7q0-0.4 0.4-0.7t1.3-0.2q1.2-0.1 2.1 0.4l0.3 0.1z m7.4-0.3h-2.2q-1.1 0-1.5 0.9l-4.3 10.3h3l0.6-1.6h3.8q0 0.3 0.3 1.6h2.7z m4.6-5.6v22.4q0 0.9-0.6 1.6t-1.6 0.6h-35.9q-0.9 0-1.5-0.6t-0.7-1.6v-22.4q0-0.9 0.7-1.6t1.5-0.6h35.9q0.9 0 1.6 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCcVisa;
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCc = function FaCc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.2 22.2h4.1q-0.3 3-2 4.8t-4.1 1.8q-3.2 0-5-2.3t-1.8-6.1q0-3.8 1.8-6.1t4.6-2.3q2.8 0 4.5 1.7t1.9 4.8h-4q-0.1-1.2-0.7-1.9t-1.6-0.7q-1.1 0-1.7 1.2t-0.6 3.4q0 1 0.1 1.7t0.4 1.3 0.7 1 1.3 0.4q1.9 0 2.1-2.7z m13.9 0h4q-0.3 3-1.9 4.8t-4.2 1.8q-3.1 0-4.9-2.3t-1.8-6.1q0-3.8 1.8-6.1t4.5-2.3q2.9 0 4.5 1.7t1.9 4.8h-4q-0.1-1.2-0.7-1.9t-1.5-0.7q-1.1 0-1.8 1.2t-0.6 3.4q0 1 0.1 1.7t0.4 1.3 0.8 1 1.2 0.4q1 0 1.5-0.8t0.7-1.9z m6.9-2.3q0-4.1-0.3-6t-1.2-3.1q-0.1-0.2-0.2-0.3t-0.4-0.3-0.3-0.2q-1.7-1.2-13.6-1.2-12.1 0-13.7 1.2-0.1 0.1-0.4 0.2t-0.4 0.3-0.3 0.3q-0.9 1.1-1.1 3.1t-0.3 6q0 4 0.3 5.9t1.1 3.1q0.1 0.2 0.3 0.3t0.4 0.3 0.3 0.2q0.9 0.7 4.7 1t9.1 0.3q11.9 0 13.6-1.3 0.1 0 0.3-0.2t0.4-0.2 0.2-0.4q0.9-1.1 1.2-3t0.3-6z m3.8-14.8v29.8h-39.8v-29.8h39.8z' })
	        )
	    );
	};
	
	exports.default = FaCc;
	module.exports = exports['default'];

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCertificate = function FaCertificate(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.7 20l3.1 3q0.7 0.6 0.4 1.6-0.2 0.9-1.1 1.1l-4.2 1.1 1.2 4.1q0.2 1-0.5 1.6-0.6 0.7-1.5 0.4l-4.2-1.2-1 4.2q-0.3 0.9-1.2 1.2-0.3 0-0.4 0-0.7 0-1.1-0.4l-3.1-3.1-3 3.1q-0.6 0.6-1.5 0.4-0.9-0.2-1.2-1.2l-1-4.2-4.2 1.2q-0.9 0.3-1.6-0.4-0.7-0.6-0.4-1.6l1.2-4.1-4.2-1.1q-0.9-0.2-1.2-1.1-0.2-1 0.5-1.6l3.1-3-3.1-3q-0.7-0.6-0.5-1.6 0.3-0.9 1.2-1.1l4.2-1.1-1.2-4.1q-0.3-1 0.4-1.6 0.7-0.7 1.6-0.4l4.2 1.2 1-4.2q0.3-1 1.2-1.2 0.9-0.2 1.5 0.4l3 3.1 3.1-3.1q0.6-0.6 1.5-0.4 0.9 0.2 1.2 1.2l1 4.2 4.2-1.2q0.9-0.3 1.5 0.4 0.7 0.6 0.5 1.6l-1.2 4.1 4.2 1.1q0.9 0.2 1.1 1.1 0.3 1-0.4 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCertificate;
	module.exports = exports['default'];

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChainBroken = function FaChainBroken(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.3 28.4l-5.7 5.7q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2-0.2-0.2-0.2-0.5t0.2-0.5l5.7-5.8q0.2-0.2 0.5-0.2t0.5 0.2q0.2 0.3 0.2 0.6t-0.2 0.5z m3.8 0.9v7.1q0 0.3-0.2 0.5t-0.5 0.2-0.6-0.2-0.2-0.5v-7.1q0-0.3 0.2-0.5t0.6-0.2 0.5 0.2 0.2 0.5z m-5-5q0 0.3-0.2 0.5t-0.5 0.2h-7.2q-0.3 0-0.5-0.2t-0.2-0.5 0.2-0.5 0.5-0.2h7.2q0.3 0 0.5 0.2t0.2 0.5z m28.2 2.8q0 2.7-1.9 4.6l-3.3 3.2q-1.8 1.9-4.5 1.9-2.7 0-4.6-1.9l-7.4-7.5q-0.5-0.5-1-1.2l5.4-0.4 6.1 6.1q0.6 0.6 1.5 0.6t1.5-0.6l3.3-3.3q0.6-0.6 0.6-1.5 0-0.9-0.6-1.5l-6.1-6.1 0.4-5.4q0.7 0.5 1.2 1l7.5 7.5q1.9 1.9 1.9 4.5z m-13.8-16.1l-5.3 0.4-6.1-6.1q-0.6-0.7-1.5-0.7-0.9 0-1.6 0.6l-3.2 3.3q-0.7 0.6-0.7 1.5 0 0.9 0.7 1.5l6.1 6.1-0.4 5.4q-0.8-0.5-1.3-0.9l-7.5-7.5q-1.8-2-1.8-4.6 0-2.7 1.9-4.5l3.2-3.3q1.9-1.8 4.6-1.8 2.7 0 4.5 1.9l7.5 7.4q0.4 0.5 0.9 1.3z m14.1 1.9q0 0.3-0.2 0.5t-0.5 0.2h-7.1q-0.3 0-0.5-0.2t-0.2-0.5 0.2-0.6 0.5-0.2h7.1q0.3 0 0.5 0.2t0.2 0.6z m-12.1-12.2v7.2q0 0.3-0.2 0.5t-0.5 0.2-0.5-0.2-0.2-0.5v-7.2q0-0.3 0.2-0.5t0.5-0.2 0.5 0.2 0.2 0.5z m9.1 3.4l-5.7 5.7q-0.3 0.2-0.5 0.2t-0.6-0.2q-0.2-0.2-0.2-0.5t0.2-0.5l5.8-5.7q0.2-0.2 0.5-0.2t0.5 0.2q0.2 0.2 0.2 0.5t-0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaChainBroken;
	module.exports = exports['default'];

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChain = function FaChain(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34 27.1q0-0.8-0.6-1.5l-4.7-4.6q-0.6-0.6-1.5-0.6-0.9 0-1.6 0.7 0.1 0 0.4 0.4t0.5 0.5 0.3 0.4 0.3 0.6 0.1 0.6q0 0.9-0.6 1.5t-1.5 0.6q-0.4 0-0.6-0.1t-0.6-0.3-0.4-0.3-0.5-0.5-0.4-0.4q-0.8 0.7-0.8 1.6 0 0.9 0.7 1.6l4.6 4.6q0.6 0.6 1.5 0.6 0.9 0 1.5-0.6l3.3-3.3q0.6-0.6 0.6-1.5z m-15.7-15.7q0-0.9-0.6-1.5l-4.6-4.6q-0.6-0.7-1.5-0.7-0.9 0-1.6 0.6l-3.2 3.3q-0.7 0.6-0.7 1.5 0 0.9 0.7 1.5l4.6 4.7q0.6 0.6 1.5 0.6 1 0 1.6-0.7 0-0.1-0.4-0.4t-0.5-0.5-0.3-0.4-0.3-0.6-0.1-0.6q0-0.9 0.7-1.5t1.5-0.7q0.3 0 0.6 0.1t0.6 0.3 0.4 0.3 0.5 0.5 0.4 0.4q0.7-0.7 0.7-1.6z m20 15.7q0 2.7-1.9 4.6l-3.3 3.2q-1.8 1.9-4.5 1.9-2.7 0-4.6-1.9l-4.6-4.6q-1.8-1.9-1.8-4.6 0-2.7 1.9-4.6l-1.9-2q-1.9 2-4.7 2-2.7 0-4.5-1.9l-4.7-4.6q-1.8-1.9-1.8-4.6t1.9-4.5l3.2-3.3q1.9-1.8 4.6-1.8 2.7 0 4.5 1.9l4.6 4.6q1.9 1.8 1.9 4.5 0 2.8-2 4.7l2 1.9q1.9-1.9 4.6-1.9 2.7 0 4.6 1.8l4.6 4.7q1.9 1.9 1.9 4.5z' })
	        )
	    );
	};
	
	exports.default = FaChain;
	module.exports = exports['default'];

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheckCircleO = function FaCheckCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.1 18.1l-9.4 9.5q-0.4 0.4-1 0.4t-1-0.4l-6.6-6.6q-0.4-0.4-0.4-1t0.4-1l2.3-2.3q0.4-0.4 1-0.4t1 0.4l3.3 3.3 6.2-6.1q0.4-0.5 1-0.5t1 0.5l2.2 2.2q0.5 0.5 0.5 1t-0.5 1z m3.2 1.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCheckCircleO;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheckCircle = function FaCheckCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCheckCircle;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheckSquareO = function FaCheckSquareO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.9 20.8v7.1q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.2 0.2-0.5 0.2-0.1 0-0.2-0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-5.7q0-0.3 0.2-0.5l1.4-1.4q0.2-0.3 0.5-0.3 0.1 0 0.3 0.1 0.4 0.2 0.4 0.7z m5.2-11l-18.2 18.2q-0.5 0.6-1.3 0.6t-1.2-0.6l-9.6-9.6q-0.6-0.5-0.6-1.3t0.6-1.2l2.4-2.5q0.6-0.5 1.3-0.5t1.3 0.5l5.8 5.9 14.5-14.5q0.5-0.5 1.3-0.5t1.2 0.5l2.5 2.5q0.5 0.5 0.5 1.3t-0.5 1.2z' })
	        )
	    );
	};
	
	exports.default = FaCheckSquareO;
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheckSquare = function FaCheckSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.3 29l13.7-13.7q0.4-0.4 0.4-1t-0.4-1l-2.3-2.3q-0.4-0.4-1-0.4t-1 0.4l-10.4 10.4-4.7-4.7q-0.4-0.4-1-0.4t-1 0.4l-2.3 2.3q-0.4 0.4-0.4 1t0.4 1l8 8q0.4 0.4 1 0.4t1-0.4z m19-19.7v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaCheckSquare;
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCheck = function FaCheck(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 12.6q0 0.9-0.6 1.6l-19.2 19.1q-0.6 0.7-1.5 0.7t-1.6-0.7l-11.1-11.1q-0.6-0.6-0.6-1.5t0.6-1.5l3.1-3q0.6-0.7 1.5-0.7t1.5 0.7l6.6 6.5 14.6-14.6q0.6-0.6 1.5-0.6t1.5 0.6l3.1 3q0.6 0.6 0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaCheck;
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronCircleDown = function FaChevronCircleDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.1 29l10.2-10.1q0.4-0.5 0.4-1t-0.4-1l-2.3-2.3q-0.4-0.4-1-0.4t-1 0.4l-6.9 6.8-6.8-6.8q-0.4-0.4-1-0.4t-1 0.4l-2.3 2.3q-0.4 0.4-0.4 1t0.4 1l10.1 10.1q0.5 0.4 1 0.4t1-0.4z m16.2-9q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaChevronCircleDown;
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronCircleLeft = function FaChevronCircleLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.3 31.1l2.3-2.2q0.4-0.5 0.4-1t-0.4-1l-6.9-6.9 6.9-6.9q0.4-0.4 0.4-1t-0.4-1l-2.3-2.2q-0.4-0.5-1-0.5t-1 0.5l-10.2 10.1q-0.4 0.4-0.4 1t0.4 1l10.2 10.1q0.4 0.5 1 0.5t1-0.5z m14-11.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaChevronCircleLeft;
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronCircleRight = function FaChevronCircleRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19 31.1l10.1-10.1q0.5-0.4 0.5-1t-0.5-1l-10.1-10.1q-0.4-0.5-1-0.5t-1 0.5l-2.3 2.2q-0.4 0.5-0.4 1t0.4 1l6.9 6.9-6.9 6.9q-0.4 0.4-0.4 1t0.4 1l2.3 2.2q0.4 0.5 1 0.5t1-0.5z m18.3-11.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaChevronCircleRight;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronCircleUp = function FaChevronCircleUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29 25.4l2.3-2.3q0.4-0.4 0.4-1t-0.4-1l-10.2-10.1q-0.4-0.4-1-0.4t-1 0.4l-10.1 10.1q-0.4 0.5-0.4 1t0.4 1l2.3 2.3q0.4 0.4 1 0.4t1-0.4l6.8-6.8 6.9 6.8q0.4 0.4 1 0.4t1-0.4z m8.3-5.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaChevronCircleUp;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronDown = function FaChevronDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.6 18l-16.6 16.6q-0.4 0.4-1 0.4t-1-0.4l-16.6-16.6q-0.4-0.4-0.4-1t0.4-1l3.7-3.7q0.5-0.4 1-0.4t1 0.4l11.9 11.9 11.9-11.9q0.4-0.4 1-0.4t1 0.4l3.7 3.7q0.4 0.4 0.4 1t-0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaChevronDown;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronLeft = function FaChevronLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.1 6.7l-11.8 11.9 11.8 11.8q0.5 0.4 0.5 1t-0.5 1l-3.7 3.7q-0.4 0.5-1 0.5t-1-0.5l-16.5-16.5q-0.5-0.4-0.5-1t0.5-1l16.5-16.6q0.5-0.4 1-0.4t1 0.4l3.7 3.7q0.5 0.4 0.5 1t-0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaChevronLeft;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronRight = function FaChevronRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.2 19.6l-16.6 16.5q-0.4 0.5-1 0.5t-1-0.5l-3.7-3.7q-0.4-0.4-0.4-1t0.4-1l11.9-11.8-11.9-11.9q-0.4-0.4-0.4-1t0.4-1l3.7-3.7q0.5-0.4 1-0.4t1 0.4l16.6 16.6q0.4 0.4 0.4 1t-0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaChevronRight;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChevronUp = function FaChevronUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.6 29.7l-3.7 3.7q-0.5 0.4-1 0.4t-1-0.4l-11.9-11.9-11.8 11.9q-0.5 0.4-1.1 0.4t-1-0.4l-3.7-3.7q-0.4-0.4-0.4-1t0.4-1l16.6-16.6q0.4-0.4 1-0.4t1 0.4l16.6 16.6q0.4 0.4 0.4 1t-0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaChevronUp;
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChild = function FaChild(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32 12.2l-6.5 6.6v18.3q0 1.1-0.7 1.8t-1.8 0.7-1.8-0.7-0.7-1.8v-8.5h-1.4v8.5q0 1.1-0.8 1.8t-1.7 0.7-1.8-0.7-0.7-1.8v-18.3l-6.5-6.6q-0.7-0.6-0.7-1.5t0.7-1.5 1.5-0.6 1.5 0.6l5.1 5.1h8.2l5.1-5.1q0.6-0.6 1.5-0.6t1.5 0.6 0.6 1.5-0.6 1.5z m-7.2-3.6q0 2-1.5 3.5t-3.5 1.5-3.6-1.5-1.4-3.5 1.4-3.6 3.6-1.4 3.5 1.4 1.5 3.6z' })
	        )
	    );
	};
	
	exports.default = FaChild;
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaChrome = function FaChrome(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 0q5.4 0 10.1 2.7 5.2 3 7.9 8.3l-16.6-0.9q-3.6-0.2-6.6 1.7t-4.1 5.1l-6.2-9.5q2.9-3.5 7-5.4t8.5-2z m-16.6 9l7.5 14.8q1.6 3.2 4.7 4.9t6.5 1l-5.1 10.1q-4.7-0.8-8.6-3.6t-6.1-7-2.2-9.2q0-6 3.3-11z m35.4 3.8q1.3 3.4 1.3 6.9t-1.1 6.9-3.4 6-5.5 4.7q-5.1 3-11.1 2.7l9-13.9q2-3 1.9-6.5t-2.4-6.2z m-18.7 0.5q2.8 0 4.8 1.9t1.9 4.8-1.9 4.8-4.8 1.9-4.8-1.9-1.9-4.8 1.9-4.8 4.8-1.9z' })
	        )
	    );
	};
	
	exports.default = FaChrome;
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCircleONotch = function FaCircleONotch(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.3 20q0 3.9-1.5 7.5t-4.2 6.1-6.1 4.2-7.5 1.5-7.5-1.5-6.2-4.2-4.1-6.1-1.5-7.5q0-4.8 2.2-8.9t5.9-6.8 8.3-3.4v5.1q-4.9 1-8.1 4.9t-3.3 9.1q0 2.9 1.1 5.5t3.1 4.6 4.6 3 5.5 1.2 5.5-1.2 4.6-3 3-4.6 1.2-5.5q0-5.1-3.3-9.1t-8.1-4.9v-5.1q4.6 0.7 8.3 3.4t5.9 6.8 2.2 8.9z' })
	        )
	    );
	};
	
	exports.default = FaCircleONotch;
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCircleO = function FaCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 7.9q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6z m17.2 12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCircleO;
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCircleThin = function FaCircleThin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 5.7q-2.9 0-5.5 1.2t-4.6 3-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5-1.1-5.5-3.1-4.6-4.5-3.1-5.6-1.1z m17.2 14.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCircleThin;
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCircle = function FaCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 20q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCircle;
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClipboard = function FaClipboard(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.1 37.1h20v-14.2h-9.2q-0.9 0-1.6-0.7t-0.6-1.5v-9.3h-8.6v25.7z m5.8-32.1v-1.4q0-0.3-0.3-0.5t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.3-0.5z m5.7 15h6.6l-6.6-6.7v6.7z m11.4 2.9v15q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-3.6h-12.2q-0.9 0-1.5-0.6t-0.6-1.6v-30q0-0.8 0.6-1.5t1.5-0.6h24.3q0.9 0 1.5 0.6t0.7 1.5v7.4q0.4 0.3 0.8 0.6l9.1 9.1q0.6 0.6 1.1 1.7t0.4 2z' })
	        )
	    );
	};
	
	exports.default = FaClipboard;
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClockO = function FaClockO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 12.1v10q0 0.4-0.2 0.6t-0.5 0.2h-7.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h5v-7.9q0-0.3 0.2-0.5t0.6-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m9.3 7.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaClockO;
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClone = function FaClone(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.1 36.4v-24.3q0-0.2-0.2-0.5t-0.5-0.2h-24.3q-0.2 0-0.5 0.2t-0.2 0.5v24.3q0 0.3 0.2 0.5t0.5 0.2h24.3q0.3 0 0.5-0.2t0.2-0.5z m2.9-24.3v24.3q0 1.5-1 2.6t-2.6 1h-24.3q-1.4 0-2.5-1t-1-2.6v-24.3q0-1.4 1-2.5t2.5-1h24.3q1.5 0 2.6 1t1 2.5z m-8.6-8.5v3.5h-2.8v-3.5q0-0.3-0.2-0.5t-0.5-0.2h-24.3q-0.3 0-0.5 0.2t-0.2 0.5v24.3q0 0.2 0.2 0.5t0.5 0.2h3.5v2.8h-3.5q-1.5 0-2.6-1t-1-2.5v-24.3q0-1.5 1.1-2.5t2.5-1.1h24.3q1.4 0 2.5 1.1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaClone;
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaClose = function FaClose(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.5 29.5q0 0.9-0.7 1.5l-3 3.1q-0.6 0.6-1.5 0.6t-1.5-0.6l-6.6-6.6-6.5 6.6q-0.7 0.6-1.6 0.6t-1.5-0.6l-3-3.1q-0.6-0.6-0.6-1.5t0.6-1.5l6.5-6.6-6.5-6.5q-0.6-0.7-0.6-1.6t0.6-1.5l3-3q0.6-0.6 1.5-0.6t1.6 0.6l6.5 6.6 6.6-6.6q0.6-0.6 1.5-0.6t1.5 0.6l3.1 3q0.6 0.7 0.6 1.5t-0.6 1.6l-6.6 6.5 6.6 6.6q0.6 0.6 0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaClose;
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCloudDownload = function FaCloudDownload(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.6 20.7q0-0.3-0.2-0.5t-0.5-0.2h-4.6v-7.3q0-0.3-0.2-0.5t-0.5-0.2h-4q-0.3 0-0.5 0.2t-0.2 0.5v7.3h-4.6q-0.3 0-0.5 0.2t-0.2 0.5q0 0.3 0.2 0.4l7.3 7.4q0.2 0.1 0.5 0.1t0.5-0.1l7.3-7.3q0.2-0.3 0.2-0.5z m13.3 4.6q0 3.3-2.4 5.7t-5.6 2.3h-22.6q-3.8 0-6.6-2.7t-2.7-6.6q0-2.7 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.5-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.6-0.8 2.8 2.7 0.7 4.4 2.9t1.8 4.9z' })
	        )
	    );
	};
	
	exports.default = FaCloudDownload;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCloudUpload = function FaCloudUpload(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.6 19.3q0-0.3-0.2-0.4l-7.3-7.4q-0.2-0.1-0.5-0.1t-0.5 0.1l-7.3 7.3q-0.2 0.3-0.2 0.5 0 0.3 0.2 0.5t0.5 0.2h4.6v7.3q0 0.3 0.2 0.5t0.5 0.2h4q0.3 0 0.5-0.2t0.2-0.5v-7.3h4.6q0.3 0 0.5-0.2t0.2-0.5z m13.3 6q0 3.3-2.4 5.7t-5.6 2.3h-22.6q-3.8 0-6.6-2.7t-2.7-6.6q0-2.7 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.5-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.6-0.8 2.8 2.7 0.7 4.4 2.9t1.8 4.9z' })
	        )
	    );
	};
	
	exports.default = FaCloudUpload;
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCloud = function FaCloud(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.9 25.3q0 3.3-2.4 5.7t-5.6 2.3h-22.6q-3.8 0-6.6-2.7t-2.7-6.6q0-2.8 1.5-5t3.9-3.4q-0.1-0.6-0.1-0.9 0-4.4 3.1-7.5t7.5-3.1q3.3 0 6 1.8t3.9 4.8q1.4-1.3 3.4-1.3 2.2 0 3.8 1.5t1.5 3.8q0 1.5-0.8 2.8 2.7 0.7 4.4 2.8t1.8 5z' })
	        )
	    );
	};
	
	exports.default = FaCloud;
	module.exports = exports['default'];

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCny = function FaCny(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22 34.3h-3.9q-0.3 0-0.5-0.2t-0.2-0.5v-7.4h-6.4q-0.3 0-0.5-0.2t-0.2-0.5v-2.3q0-0.3 0.2-0.5t0.5-0.2h6.4v-1.9h-6.4q-0.3 0-0.5-0.2t-0.2-0.5v-2.4q0-0.2 0.2-0.5t0.5-0.2h4.8l-7.2-12.9q-0.2-0.3 0-0.7 0.2-0.3 0.6-0.3h4.3q0.5 0 0.7 0.4l4.8 9.4q0.4 0.9 1.2 2.8 0.3-0.5 0.7-1.5t0.6-1.3l4.3-9.4q0.2-0.4 0.6-0.4h4.3q0.4 0 0.6 0.3 0.2 0.3 0 0.7l-7 12.9h4.8q0.3 0 0.5 0.2t0.3 0.5v2.4q0 0.3-0.3 0.5t-0.5 0.2h-6.4v1.9h6.4q0.3 0 0.5 0.2t0.3 0.5v2.3q0 0.3-0.3 0.5t-0.5 0.2h-6.4v7.4q0 0.3-0.2 0.5t-0.5 0.2z' })
	        )
	    );
	};
	
	exports.default = FaCny;
	module.exports = exports['default'];

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCodeFork = function FaCodeFork(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.9 32.9q0-0.9-0.6-1.6t-1.5-0.6-1.5 0.6-0.7 1.6 0.7 1.5 1.5 0.6 1.5-0.6 0.6-1.5z m0-25.8q0-0.8-0.6-1.5t-1.5-0.6-1.5 0.6-0.7 1.5 0.7 1.6 1.5 0.6 1.5-0.6 0.6-1.6z m14.3 2.9q0-0.9-0.6-1.5t-1.5-0.6-1.5 0.6-0.7 1.5 0.7 1.5 1.5 0.6 1.5-0.6 0.6-1.5z m2.2 0q0 1.2-0.6 2.2t-1.6 1.5q0 6.4-5 9.2-1.6 0.9-4.6 1.9-2.8 0.8-3.7 1.5t-1 2.3v0.5q1 0.6 1.6 1.6t0.6 2.2q0 1.7-1.3 3t-3 1.2-3.1-1.2-1.2-3q0-1.2 0.6-2.2t1.5-1.5v-18.4q-0.9-0.5-1.5-1.5t-0.6-2.2q0-1.7 1.3-3t3-1.2 3 1.2 1.3 3q0 1.2-0.6 2.2t-1.6 1.5v11.1q1.2-0.5 3.5-1.2 1.2-0.4 1.9-0.7t1.6-0.7 1.3-0.9 0.9-1.1 0.6-1.6 0.2-2q-1-0.6-1.5-1.5t-0.6-2.2q0-1.8 1.2-3t3.1-1.3 3 1.3 1.3 3z' })
	        )
	    );
	};
	
	exports.default = FaCodeFork;
	module.exports = exports['default'];

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCode = function FaCode(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.8 30.4l-1 1.1q-0.2 0.2-0.5 0.2t-0.5-0.2l-9.7-9.7q-0.2-0.2-0.2-0.5t0.2-0.4l9.7-9.7q0.2-0.2 0.5-0.2t0.5 0.2l1 1q0.2 0.2 0.2 0.5t-0.2 0.5l-8.1 8.1 8.1 8.2q0.2 0.2 0.2 0.5t-0.2 0.4z m12.3-22.1l-7.8 26.8q0 0.3-0.3 0.4t-0.5 0.1l-1.3-0.4q-0.2-0.1-0.4-0.3t0-0.5l7.7-26.8q0.1-0.3 0.4-0.4t0.4-0.1l1.3 0.4q0.3 0 0.4 0.3t0.1 0.5z m13.6 13.5l-9.7 9.7q-0.2 0.2-0.4 0.2t-0.5-0.2l-1-1.1q-0.3-0.2-0.3-0.4t0.3-0.5l8.1-8.2-8.1-8.1q-0.3-0.2-0.3-0.5t0.3-0.5l1-1q0.2-0.2 0.5-0.2t0.4 0.2l9.7 9.7q0.2 0.2 0.2 0.4t-0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaCode;
	module.exports = exports['default'];

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCodepen = function FaCodepen(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.8 26.1l13.5 9v-8l-7.5-5z m-1.4-3.2l4.3-2.9-4.3-2.9v5.8z m18.3 12.2l13.5-9-6-4-7.5 5v8z m-1.7-11l6.1-4.1-6.1-4.1-6.1 4.1z m-9.2-6.2l7.5-5v-8l-13.5 9z m21.5 2.1l4.3 2.9v-5.8z m-3.1-2.1l6-4-13.5-9v8z m10.8-4v12.2q0 0.9-0.8 1.4l-18.2 12.2q-0.5 0.3-1 0.3t-1-0.3l-18.2-12.2q-0.8-0.5-0.8-1.4v-12.2q0-0.9 0.8-1.4l18.2-12.2q0.5-0.3 1-0.3t1 0.3l18.2 12.2q0.8 0.5 0.8 1.4z' })
	        )
	    );
	};
	
	exports.default = FaCodepen;
	module.exports = exports['default'];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCodiepie = function FaCodiepie(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.6 15.2q1.2 0 1.9 0.6t0.7 1.9-0.8 1.8-2 0.6h-3.1v3.9h-0.5v-8.8h3.8z m3.6 13.1l-0.1 0.3-0.1 0.2q-2.6 5.1-7.4 8.2t-10.6 3q-4.1 0-7.8-1.6t-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6q5.4 0 10.1 2.8t7.4 7.5l0.2 0.5q-0.6 0.3-3 1.5t-3.7 1.9q-0.1 0-10.7 6 8.6 4 17.9 8.1z m-18.2 11.2q5.6 0 10.3-3t7.2-7.9l-6.4-2.9q-1.6 3.1-4.6 4.9t-6.5 1.9q-3.4 0-6.2-1.7t-4.6-4.5-1.7-6.3 1.7-6.2 4.6-4.6 6.2-1.7 6.3 1.7 4.5 4.5l6.3-3.2q-2.6-4.6-7.2-7.3t-9.9-2.7q-2.7 0-5.2 0.7t-4.7 1.9-3.9 3.1-3.1 3.9-1.9 4.7-0.7 5.2 0.7 5.2 1.9 4.7 3.1 3.9 3.9 3.1 4.7 1.9 5.2 0.7z' })
	        )
	    );
	};
	
	exports.default = FaCodiepie;
	module.exports = exports['default'];

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCoffee = function FaCoffee(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.2 14.4q0-1.7-1.2-2.9t-2.9-1.3h-1.4v8.4h1.4q1.7 0 2.9-1.2t1.2-3z m-36.2 16.8h39q0 2.3-1.6 3.9t-4 1.6h-27.8q-2.3 0-4-1.6t-1.6-3.9z m40.4-16.8q0 3.5-2.4 5.9t-5.9 2.5h-1.4v0.7q0 2-1.5 3.4t-3.4 1.5h-15.3q-2.1 0-3.5-1.5t-1.4-3.4v-16q0-0.6 0.4-1t1-0.4h25.1q3.4 0 5.9 2.4t2.4 5.9z' })
	        )
	    );
	};
	
	exports.default = FaCoffee;
	module.exports = exports['default'];

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCog = function FaCog(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 20q0-2.4-1.7-4t-4.1-1.7-4 1.7-1.7 4 1.7 4 4 1.7 4.1-1.7 1.7-4z m11.4-2.4v4.9q0 0.3-0.2 0.5t-0.4 0.3l-4.2 0.6q-0.4 1.3-0.8 2.1 0.7 1.1 2.3 3.1 0.3 0.2 0.3 0.5t-0.2 0.5q-0.6 0.9-2.2 2.4t-2.1 1.6q-0.3 0-0.6-0.2l-3.1-2.4q-1 0.5-2 0.9-0.4 3-0.7 4.1-0.1 0.6-0.8 0.6h-4.9q-0.3 0-0.6-0.1t-0.2-0.5l-0.7-4.1q-1.1-0.4-2-0.9l-3.1 2.4q-0.2 0.2-0.6 0.2-0.3 0-0.5-0.2-2.8-2.6-3.7-3.8-0.2-0.2-0.2-0.5 0-0.2 0.2-0.5 0.3-0.5 1.1-1.5t1.2-1.5q-0.6-1.2-0.9-2.3l-4.1-0.6q-0.2 0-0.4-0.2t-0.2-0.6v-4.9q0-0.3 0.2-0.5t0.4-0.3l4.2-0.7q0.3-1 0.8-2-0.9-1.3-2.4-3.1-0.2-0.3-0.2-0.5 0-0.2 0.2-0.5 0.6-0.8 2.2-2.4t2.1-1.6q0.3 0 0.6 0.2l3.1 2.4q1-0.5 2-0.9 0.4-3 0.7-4.1 0.1-0.6 0.8-0.6h4.9q0.3 0 0.6 0.1t0.2 0.5l0.7 4.1q1 0.4 2 0.9l3.1-2.4q0.2-0.2 0.6-0.2 0.3 0 0.5 0.2 2.9 2.6 3.7 3.8 0.2 0.2 0.2 0.5 0 0.2-0.2 0.5-0.4 0.5-1.2 1.5t-1.2 1.5q0.6 1.2 1 2.2l4 0.7q0.3 0 0.5 0.2t0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaCog;
	module.exports = exports['default'];

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCogs = function FaCogs(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 20q0-2.2-1.6-3.8t-3.7-1.5-3.8 1.5-1.5 3.8 1.5 3.8 3.8 1.5 3.7-1.5 1.6-3.8z m16 10.6q0-1-0.8-1.8t-1.9-0.8-1.9 0.8-0.8 1.8q0 1.1 0.8 1.9t1.9 0.8 1.9-0.8 0.8-1.9z m0-21.2q0-1.1-0.8-1.9t-1.9-0.8-1.9 0.8-0.8 1.9q0 1.1 0.8 1.8t1.9 0.8 1.9-0.8 0.8-1.8z m-8 8.7v3.9q0 0.2-0.2 0.4t-0.3 0.2l-3.2 0.5q-0.2 0.7-0.7 1.6 0.7 0.9 1.9 2.3 0.1 0.2 0.1 0.5 0 0.2-0.1 0.3-0.5 0.7-1.7 1.9t-1.7 1.2q-0.2 0-0.4-0.1l-2.4-1.9q-0.7 0.4-1.6 0.7-0.2 2.2-0.5 3.2-0.1 0.5-0.6 0.5h-3.8q-0.3 0-0.5-0.2t-0.2-0.3l-0.4-3.2q-0.7-0.2-1.6-0.7l-2.4 1.9q-0.2 0.1-0.5 0.1-0.2 0-0.4-0.1-3-2.8-3-3.3 0-0.2 0.2-0.4 0.2-0.3 0.8-1.1t1-1.3q-0.5-0.9-0.7-1.7l-3.2-0.5q-0.2 0-0.4-0.2t-0.1-0.4v-3.9q0-0.2 0.1-0.4t0.4-0.2l3.2-0.5q0.2-0.7 0.7-1.6-0.7-0.9-1.9-2.3-0.2-0.3-0.2-0.5 0-0.2 0.2-0.4 0.4-0.6 1.7-1.8t1.6-1.2q0.3 0 0.5 0.1l2.4 1.9q0.7-0.4 1.6-0.7 0.2-2.2 0.4-3.2 0.2-0.5 0.7-0.5h3.8q0.2 0 0.4 0.2t0.2 0.3l0.5 3.2q0.7 0.2 1.6 0.7l2.4-1.9q0.2-0.1 0.4-0.1 0.3 0 0.5 0.1 3 2.8 3 3.3 0 0.2-0.2 0.4-0.2 0.4-0.8 1.2t-1 1.2q0.5 1 0.7 1.7l3.2 0.5q0.2 0 0.3 0.2t0.2 0.4z m13.3 11.1v2.9q0 0.3-3.1 0.6-0.3 0.6-0.6 1.1 1 2.4 1 2.9 0 0.1-0.1 0.1-2.5 1.5-2.5 1.5-0.2 0-1-1t-1.1-1.4q-0.4 0-0.6 0t-0.6 0q-0.3 0.4-1.1 1.4t-1 1q0 0-2.5-1.5-0.1 0-0.1-0.1 0-0.5 1-2.9-0.3-0.5-0.6-1.1-3.1-0.3-3.1-0.6v-2.9q0-0.4 3.1-0.7 0.3-0.6 0.6-1-1-2.4-1-2.9 0-0.1 0.1-0.2 0 0 0.7-0.4t1.2-0.7 0.6-0.3q0.2 0 1 1t1.1 1.4q0.4-0.1 0.6-0.1t0.6 0.1q1.1-1.5 1.9-2.4l0.2 0q0 0 2.5 1.4 0.1 0.1 0.1 0.2 0 0.5-1.1 2.9 0.4 0.4 0.7 1 3.1 0.3 3.1 0.7z m0-21.3v2.9q0 0.4-3.1 0.7-0.3 0.5-0.6 1 1 2.4 1 2.9 0 0.1-0.1 0.2-2.5 1.4-2.5 1.4-0.2 0-1-0.9t-1.1-1.5q-0.4 0.1-0.6 0.1t-0.6-0.1q-0.3 0.5-1.1 1.5t-1 0.9q0 0-2.5-1.4-0.1-0.1-0.1-0.2 0-0.5 1-2.9-0.3-0.5-0.6-1-3.1-0.3-3.1-0.7v-2.9q0-0.3 3.1-0.6 0.3-0.6 0.6-1.1-1-2.4-1-2.9 0-0.1 0.1-0.1 0-0.1 0.7-0.4t1.2-0.7 0.6-0.4q0.2 0 1 1t1.1 1.4q0.4 0 0.6 0t0.6 0q1.1-1.5 1.9-2.3l0.2-0.1q0 0 2.5 1.5 0.1 0 0.1 0.1 0 0.5-1.1 2.9 0.4 0.5 0.7 1.1 3.1 0.3 3.1 0.6z' })
	        )
	    );
	};
	
	exports.default = FaCogs;
	module.exports = exports['default'];

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaColumns = function FaColumns(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.1 34.3h13.5v-25.7h-14.2v25q0 0.3 0.2 0.5t0.5 0.2z m30.7-0.7v-25h-14.3v25.7h13.6q0.3 0 0.5-0.2t0.2-0.5z m2.8-27.2v27.2q0 1.4-1 2.5t-2.5 1h-30q-1.5 0-2.5-1t-1.1-2.5v-27.2q0-1.4 1-2.5t2.6-1h30q1.4 0 2.5 1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaColumns;
	module.exports = exports['default'];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCommentO = function FaCommentO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 8.6q-4.6 0-8.5 1.5t-6.3 4.2-2.3 5.7q0 2.5 1.6 4.8t4.4 3.9l2 1.1-0.6 2.1q-0.5 2.1-1.6 3.9 3.4-1.4 6.2-3.8l0.9-0.9 1.3 0.2q1.5 0.1 2.9 0.1 4.6 0 8.5-1.5t6.3-4.2 2.3-5.7-2.3-5.7-6.3-4.2-8.5-1.5z m20 11.4q0 3.9-2.7 7.2t-7.3 5.2-10 1.9q-1.6 0-3.2-0.2-4.5 3.9-10.3 5.4-1.1 0.3-2.6 0.5h-0.1q-0.3 0-0.6-0.2t-0.3-0.6v-0.1q-0.1-0.1 0-0.2t0-0.3 0.1-0.2l0.1-0.2 0.2-0.2 0.2-0.2q0.1-0.1 0.7-0.7t0.7-0.9 0.7-0.9 0.8-1.1 0.6-1.3 0.5-1.7q-3.5-2-5.5-4.9t-2-6.3q0-3.9 2.7-7.2t7.3-5.2 10-1.9 10 1.9 7.3 5.2 2.7 7.2z' })
	        )
	    );
	};
	
	exports.default = FaCommentO;
	module.exports = exports['default'];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaComment = function FaComment(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 20q0 3.9-2.7 7.2t-7.3 5.2-10 1.9q-1.6 0-3.2-0.2-4.5 3.9-10.3 5.4-1.1 0.3-2.6 0.5-0.3 0-0.6-0.2t-0.4-0.6v-0.1q-0.1-0.1 0-0.2t0-0.3 0.1-0.2l0.1-0.2 0.2-0.2 0.2-0.2q0.1-0.1 0.7-0.7t0.7-0.9 0.7-0.9 0.8-1.1 0.6-1.3 0.5-1.7q-3.5-2-5.5-4.9t-2-6.3q0-2.9 1.6-5.5t4.2-4.6 6.4-3.1 7.8-1.1q5.4 0 10 1.9t7.3 5.2 2.7 7.2z' })
	        )
	    );
	};
	
	exports.default = FaComment;
	module.exports = exports['default'];

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCommentingO = function FaCommentingO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 20q0 1.2-0.9 2t-2 0.9-2-0.9-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m8.6 0q0 1.2-0.9 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.9 2 0.9 0.9 2z m8.5 0q0 1.2-0.8 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.9 2 0.9 0.8 2z m-11.4-11.4q-4.6 0-8.5 1.5t-6.3 4.2-2.3 5.7q0 2.5 1.6 4.8t4.4 3.9l2 1.1-0.6 2.1q-0.5 2.1-1.6 3.9 3.4-1.4 6.2-3.8l0.9-0.9 1.3 0.2q1.5 0.1 2.9 0.1 4.6 0 8.5-1.5t6.3-4.2 2.3-5.7-2.3-5.7-6.3-4.2-8.5-1.5z m20 11.4q0 3.9-2.7 7.2t-7.3 5.2-10 1.9q-1.6 0-3.2-0.2-4.5 3.9-10.3 5.4-1.1 0.3-2.6 0.5h-0.1q-0.3 0-0.6-0.2t-0.3-0.6v-0.1q-0.1-0.1 0-0.2t0-0.3 0.1-0.2l0.1-0.2 0.2-0.2 0.2-0.2q0.1-0.1 0.7-0.7t0.7-0.9 0.7-0.9 0.8-1.1 0.6-1.3 0.5-1.7q-3.5-2-5.5-4.9t-2-6.3q0-2.9 1.6-5.5t4.2-4.6 6.4-3.1 7.8-1.1 7.8 1.1 6.3 3.1 4.3 4.6 1.6 5.5z' })
	        )
	    );
	};
	
	exports.default = FaCommentingO;
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCommenting = function FaCommenting(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 20q0-1.2-0.9-2t-2-0.9-2 0.9-0.8 2 0.8 2 2 0.9 2-0.9 0.9-2z m8.6 0q0-1.2-0.9-2t-2-0.9-2 0.9-0.9 2 0.9 2 2 0.9 2-0.9 0.9-2z m8.5 0q0-1.2-0.8-2t-2-0.9-2 0.9-0.9 2 0.9 2 2 0.9 2-0.9 0.8-2z m8.6 0q0 3.9-2.7 7.2t-7.3 5.2-10 1.9q-2.5 0-4.7-0.4-3.9 3.8-9.7 5.1-1.2 0.2-1.9 0.3-0.3 0-0.5-0.1t-0.3-0.4q-0.1-0.4 0.4-0.9 0.1-0.1 0.5-0.5t0.6-0.5 0.5-0.5 0.6-0.8 0.4-0.8 0.5-1 0.3-1.3 0.3-1.6q-3.3-2.1-5.1-4.9t-1.9-6q0-3.9 2.7-7.2t7.3-5.2 10-1.9 10 1.9 7.3 5.2 2.7 7.2z' })
	        )
	    );
	};
	
	exports.default = FaCommenting;
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCommentsO = function FaCommentsO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.7 8.6q-3.4 0-6.4 1.1t-4.7 3.2-1.7 4.2q0 1.9 1.1 3.6t3.4 2.9l2.1 1.3-0.7 1.8q0.7-0.4 1.3-0.8l1-0.7 1.2 0.2q1.7 0.3 3.4 0.3 3.4 0 6.4-1.2t4.7-3.1 1.8-4.3-1.8-4.2-4.7-3.2-6.4-1.1z m0-2.9q4.3 0 7.9 1.5t5.7 4.2 2.1 5.7-2.1 5.8-5.7 4.1-7.9 1.6q-1.9 0-3.9-0.4-2.8 2-6.2 2.9-0.8 0.2-1.9 0.3h-0.1q-0.3 0-0.5-0.2t-0.2-0.4q0-0.1 0-0.2t0-0.1 0-0.1l0.1-0.2 0-0.1 0.1-0.1 0.1-0.1 0.1-0.1q0.1-0.1 0.5-0.6t0.6-0.6 0.5-0.7 0.6-0.8 0.4-1q-2.7-1.6-4.3-4t-1.6-5q0-3.1 2.1-5.7t5.7-4.2 7.9-1.5z m18.4 26.1q0.2 0.5 0.4 1t0.6 0.8 0.5 0.7 0.6 0.7 0.5 0.5q0 0 0.1 0.1t0.1 0.1 0.1 0.1 0 0.2l0.1 0.1 0 0.1 0 0.1 0 0.2q0 0.3-0.3 0.5t-0.5 0.1q-1.1-0.1-1.9-0.3-3.4-0.9-6.2-2.9-2 0.4-3.9 0.4-6.1 0-10.5-3 1.2 0.1 1.9 0.1 3.6 0 6.9-1t5.9-2.9q2.8-2 4.3-4.7t1.5-5.7q0-1.7-0.5-3.4 2.9 1.6 4.5 4t1.7 5.2q0 2.6-1.6 5t-4.3 3.9z' })
	        )
	    );
	};
	
	exports.default = FaCommentsO;
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaComments = function FaComments(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 17.1q0 3.1-2.1 5.8t-5.7 4.1-7.9 1.6q-1.9 0-3.9-0.4-2.8 2-6.2 2.9-0.8 0.2-1.9 0.3h-0.1q-0.3 0-0.5-0.2t-0.2-0.4q0-0.1 0-0.2t0-0.1 0-0.1l0.1-0.2 0-0.1 0.1-0.1 0.1-0.1 0.1-0.1q0.1-0.1 0.5-0.6t0.6-0.6 0.5-0.7 0.6-0.8 0.4-1q-2.7-1.6-4.3-4t-1.6-5q0-3.1 2.1-5.7t5.7-4.2 7.9-1.5 7.9 1.5 5.7 4.2 2.1 5.7z m8.6 5.8q0 2.6-1.6 5t-4.3 3.9q0.2 0.5 0.4 1t0.6 0.8 0.5 0.7 0.6 0.7 0.5 0.5q0 0 0.1 0.1t0.1 0.1 0.1 0.1 0 0.2l0.1 0.1 0 0.1 0 0.1 0 0.2q0 0.3-0.3 0.5t-0.5 0.1q-1.1-0.1-1.9-0.3-3.4-0.9-6.2-2.9-2 0.4-3.9 0.4-6.1 0-10.6-3 1.3 0.1 2 0.1 3.6 0 6.9-1t5.9-2.9q2.8-2 4.3-4.7t1.5-5.7q0-1.7-0.5-3.4 2.9 1.6 4.5 4t1.7 5.2z' })
	        )
	    );
	};
	
	exports.default = FaComments;
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCompass = function FaCompass(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.3 24.3l5.7-2.9-5.7-2.8v5.7z m8.6-13.2v12.1l-11.5 5.7v-12.1z m6.4 8.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6 1.6-4.5 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCompass;
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCompress = function FaCompress(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 21.4v10q0 0.6-0.4 1t-1 0.5-1-0.5l-3.2-3.2-7.4 7.4q-0.2 0.3-0.5 0.3t-0.5-0.3l-2.6-2.5q-0.2-0.2-0.2-0.5t0.2-0.5l7.4-7.5-3.2-3.2q-0.4-0.4-0.4-1t0.4-1 1-0.4h10q0.6 0 1 0.4t0.4 1z m16.9-15q0 0.3-0.2 0.5l-7.4 7.5 3.2 3.2q0.4 0.4 0.4 1t-0.4 1-1 0.4h-10q-0.6 0-1-0.4t-0.5-1v-10q0-0.6 0.5-1t1-0.5 1 0.5l3.2 3.2 7.4-7.4q0.2-0.3 0.5-0.3t0.5 0.3l2.6 2.5q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaCompress;
	module.exports = exports['default'];

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaConnectdevelop = function FaConnectdevelop(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 20q0 0.4-0.3 0.7t-0.6 0.4l-4 6.9q0 0.2 0 0.3 0 0.4-0.2 0.7t-0.6 0.4l-3.8 6.5q0.1 0.2 0.1 0.3 0 0.5-0.3 0.8t-0.8 0.4q-0.5 0-0.8-0.4h-7.8q-0.3 0.4-0.8 0.4t-0.9-0.4h-7.7q-0.3 0.4-0.8 0.4-0.5 0-0.8-0.3t-0.3-0.8q0-0.2 0-0.4l-3.7-6.5q-0.4-0.1-0.6-0.4t-0.3-0.7q0-0.1 0.1-0.3l-4-6.9q-0.4-0.1-0.7-0.4t-0.2-0.7q0-0.4 0.3-0.7t0.6-0.4l3.9-6.7q0 0 0 0t0-0.1q0-0.7 0.6-1l4.1-7q-0.1-0.2-0.1-0.4 0-0.5 0.3-0.8t0.8-0.3q0.5 0 0.9 0.4h7.6q0.4-0.4 0.9-0.4t0.8 0.4h7.7q0.4-0.4 0.9-0.4 0.4 0 0.8 0.3t0.3 0.8q0 0.1-0.1 0.4l4 6.9q0.5 0 0.8 0.4t0.3 0.7q0 0.3-0.1 0.5l3.6 6.3q0.4 0.1 0.6 0.4t0.3 0.7z m-19.2 15.5h7.6l-6.7-6.9h-2.7l-6.7 6.9h7q0.4-0.3 0.8-0.3t0.7 0.3z m-18.4-15.8q0 0.1 0 0.3 0 0.2 0 0.3l4 7q0 0 0.1 0t0.1 0l0.1 0.1 3.6-3.9v-6.7l-3.6-3.8q-0.2 0.2-0.6 0.2z m16.9-15.2h-7.5l3.7 3.9 10.7-3.9h-5.4q-0.3 0.3-0.7 0.3t-0.8-0.3z m13.7 23.5q0-0.1 0.1-0.2l-1.3-1.3-0.3 1.5h1.5z m-2.1 0l0.5-2-4.9-5.2-5.8 6 1.2 1.2h9z m-1.7 7.2l0.3-0.6 1.3-6h-8.3l6.5 6.7q0.1-0.1 0.2-0.1z m-17.8 0.3h0.1l6.7-6.9h-7.3v6.5l0.1 0.1q0.3 0.1 0.4 0.3z m-0.5-7.5h7.8l1.3-1.2-6-6.3-3.1 3.2v4.3z m-3.7 0h3.1v-3.6l-3.2 3.4q0 0.2 0.1 0.2z m0-16q0 0 0 0.1t0 0q0 0.3-0.2 0.6l3.3 3.4v-5.2z m3.7-1.3v6l3 3 5.7-6-4.3-4.6z m0.1-5.9l-0.1 0.1v5.1l4-1.4-3.7-3.9q-0.1 0-0.2 0.1z m17.3-0.3h-0.3l-12.1 4.4 4.2 4.3z m-8.2 9.6l-5.8 6.1 6 6.2 5.8-6z m-6.5 6l-2.7-2.7v5.5z m6.7 7.1l-0.8 0.8h1.7z m6.6-6.8l4.6 4.9 2.6-12.1-0.1-0.1 0 0z m6.6-7.7q-0.1-0.3-0.1-0.6v0l-4.2-7.3q-0.1-0.1-0.3-0.1l-8.4 9 6 6.3z m-23.2-2.4v-4.4l-3.1 5.5z m0 18.3h-3.1l3.1 5.5v-5.5z m21.1 0l-0.9 4.4 2.5-4.4h-1.6z m2.4-1.3l4-7q-0.1-0.2-0.1-0.3 0 0 0.1-0.3l-3.3-5.8-2.5 11.9 1.5 1.6q0.1-0.1 0.3-0.1z' })
	        )
	    );
	};
	
	exports.default = FaConnectdevelop;
	module.exports = exports['default'];

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaContao = function FaContao(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3.1 2.9h4.4q-1.6 1.4-2.8 3.3-0.8 1.2-1.4 2.6t-0.6 2.8-0.2 2.6 0.2 3 0.5 2.8 0.6 3l0.1 0.7q1.2 5.3 1.9 7.3 1.2 3.8 3.3 6.1h-6q-1.1 0-1.8-0.7t-0.8-1.8v-29.2q0-1 0.8-1.8t1.8-0.7z m26.9 0h6.9q1.1 0 1.9 0.7t0.7 1.8v29.2q0 1-0.7 1.8t-1.9 0.7h-4q4.8-4.6 4.4-12.6l-10.4 2.3q-0.1 1-0.3 1.8t-0.7 1.6-1.3 1.4-2.1 0.8q-2.8 0.5-4.5-0.9-0.7-0.6-1.1-1.4t-1.2-2.9-1.4-5.7q-0.8-3.7-1.1-5.9t-0.1-3.1 0.5-1.7q0.5-0.9 1.4-1.6t2.3-1.1q1-0.2 1.9-0.1t1.5 0.4 1.2 0.8 0.9 1 0.8 1.3l10.5-2.2q-1.6-3.9-4.1-6.4z' })
	        )
	    );
	};
	
	exports.default = FaContao;
	module.exports = exports['default'];

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCopy = function FaCopy(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.9 8.6q0.9 0 1.5 0.6t0.6 1.5v27.2q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-6.5h-12.2q-0.9 0-1.5-0.6t-0.6-1.5v-15q0-0.9 0.4-2t1.1-1.7l9.1-9.1q0.6-0.6 1.7-1.1t2-0.4h9.3q0.9 0 1.5 0.6t0.6 1.5v7.4q1.5-0.9 2.9-0.9h9.3z m-12.2 4.7l-6.7 6.7h6.7v-6.7z m-14.3-8.5l-6.6 6.6h6.6v-6.6z m4.4 14.4l7.1-7.1v-9.2h-8.6v9.2q0 0.9-0.6 1.6t-1.6 0.6h-9.2v14.3h11.4v-5.7q0-0.9 0.4-2t1.1-1.7z m21.3 17.9v-25.7h-8.5v9.3q0 0.9-0.7 1.5t-1.5 0.7h-9.3v14.2h20z' })
	        )
	    );
	};
	
	exports.default = FaCopy;
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCopyright = function FaCopyright(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.7 24v2.4q0 1.1-0.8 2t-2.1 1.3-2.7 0.8-2.6 0.2q-4.6 0-7.6-3.1t-3.1-7.7q0-4.5 3-7.6t7.6-3q0.7 0 1.7 0.1t2 0.4 2.1 0.7 1.6 1.3 0.6 1.8v2.4q0 0.4-0.4 0.4h-2.6q-0.4 0-0.4-0.4v-1.5q0-1-1.4-1.5t-3.1-0.6q-3.1 0-5.1 2.1t-2 5.3q0 3.3 2.1 5.5t5.2 2.2q1.5 0 3.1-0.5t1.5-1.5v-1.5q0-0.2 0.1-0.3t0.3-0.1h2.6q0.1 0 0.3 0.1t0.1 0.3z m-8.6-18.3q-2.9 0-5.5 1.2t-4.6 3-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5-1.1-5.5-3.1-4.6-4.5-3.1-5.6-1.1z m17.2 14.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCopyright;
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCreativeCommons = function FaCreativeCommons(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.5 27.5q3.4 0 5.7-2.3 0.4-0.4 0.1-0.8l-1-1.8q-0.1-0.3-0.5-0.4-0.4-0.1-0.6 0.2l-0.1 0.1q-0.1 0.1-0.3 0.2t-0.4 0.3-0.5 0.3-0.6 0.3-0.8 0.3-0.8 0q-1.7 0-2.8-1.1t-1.1-2.8q0-1.7 1.1-2.8t2.7-1.1q0.8 0 1.6 0.3t1.1 0.6l0.4 0.3q0.2 0.3 0.6 0.2 0.3 0 0.5-0.3l1.2-1.7q0.3-0.5-0.1-0.9 0-0.1-0.2-0.2t-0.7-0.6-1.1-0.6-1.5-0.5-1.9-0.2q-3.3 0-5.5 2.1t-2.2 5.4q0 3.3 2.2 5.4t5.5 2.1z m14.1 0q3.4 0 5.7-2.3 0.3-0.4 0.1-0.8l-1-1.8q-0.2-0.3-0.6-0.4-0.3-0.1-0.6 0.2l-0.1 0.1q-0.1 0.1-0.2 0.2t-0.4 0.3-0.5 0.3-0.7 0.3-0.7 0.3-0.9 0q-1.7 0-2.7-1.1t-1.1-2.8q0-1.7 1-2.8t2.8-1.1q0.8 0 1.6 0.3t1.1 0.6l0.3 0.3q0.3 0.3 0.6 0.2 0.4 0 0.6-0.3l1.1-1.7q0.3-0.5 0-0.9-0.1-0.1-0.3-0.2t-0.6-0.6-1.1-0.6-1.5-0.5-1.9-0.2q-3.3 0-5.5 2.1t-2.2 5.4q0 3.3 2.1 5.4t5.6 2.1z m-7.6-23.9q-3.3 0-6.4 1.3t-5.2 3.5-3.5 5.2-1.3 6.4 1.3 6.4 3.5 5.2 5.2 3.5 6.4 1.3 6.4-1.3 5.2-3.5 3.5-5.2 1.3-6.4-1.3-6.4-3.5-5.2-5.2-3.5-6.4-1.3z m0-3.6q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z' })
	        )
	    );
	};
	
	exports.default = FaCreativeCommons;
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCreditCardAlt = function FaCreditCardAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm0 30.6v-10.6h40.3v10.6q0 1.2-0.8 2t-2 0.8h-34.7q-1.2 0-2-0.8t-0.8-2z m11.2-3.9v2.3h6.7v-2.3h-6.7z m-6.7 0v2.3h4.5v-2.3h-4.5z m33-20.1q1.2 0 2 0.8t0.8 2v3.9h-40.3v-3.9q0-1.2 0.8-2t2-0.8h34.7z' })
	        )
	    );
	};
	
	exports.default = FaCreditCardAlt;
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCreditCard = function FaCreditCard(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.5 4.1q1.4 0 2.4 0.9t1 2.4v25.2q0 1.4-1 2.4t-2.4 0.9h-33.2q-1.3 0-2.3-0.9t-1-2.4v-25.2q0-1.4 1-2.4t2.3-0.9h33.2z m-33.2 2.6q-0.2 0-0.4 0.2t-0.2 0.5v4.6h34.5v-4.6q0-0.3-0.2-0.5t-0.5-0.2h-33.2z m33.2 26.6q0.3 0 0.5-0.2t0.2-0.5v-12.6h-34.5v12.6q0 0.3 0.2 0.5t0.4 0.2h33.2z m-31.2-2.7v-2.6h5.3v2.6h-5.3z m8 0v-2.6h8v2.6h-8z' })
	        )
	    );
	};
	
	exports.default = FaCreditCard;
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCrop = function FaCrop(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.9 28.6h13.3v-13.3z m-1-1l13.3-13.3h-13.3v13.3z m25.7 1.7v4.3q0 0.3-0.2 0.5t-0.5 0.2h-5v5q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-5h-19.3q-0.3 0-0.5-0.2t-0.2-0.5v-19.3h-5q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h5v-5q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v5h19l5.5-5.5q0.2-0.2 0.5-0.2t0.5 0.2q0.2 0.2 0.2 0.5t-0.2 0.5l-5.5 5.5v19h5q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaCrop;
	module.exports = exports['default'];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCrosshairs = function FaCrosshairs(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.7 22.9h-2.4q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h2.4q-0.7-2.4-2.5-4.2t-4.2-2.5v2.5q0 0.5-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-2.5q-2.4 0.7-4.2 2.5t-2.5 4.2h2.4q0.6 0 1 0.5t0.4 1v2.8q0 0.6-0.4 1t-1 0.5h-2.4q0.7 2.4 2.5 4.2t4.2 2.5v-2.5q0-0.5 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v2.5q2.4-0.7 4.2-2.5t2.5-4.2z m7.6-4.3v2.8q0 0.6-0.4 1t-1 0.5h-3.2q-0.9 3.6-3.5 6.2t-6.2 3.4v3.2q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-3.2q-3.6-0.8-6.2-3.4t-3.5-6.2h-3.2q-0.6 0-1-0.5t-0.4-1v-2.8q0-0.6 0.4-1t1-0.5h3.2q0.8-3.6 3.5-6.2t6.2-3.4v-3.2q0-0.6 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v3.2q3.6 0.8 6.2 3.4t3.5 6.2h3.2q0.5 0 1 0.5t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaCrosshairs;
	module.exports = exports['default'];

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCss3 = function FaCss3(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm6.1 2.9h33.6l-5.9 29.7-18 6-15.5-6 1.6-7.9h6.6l-0.7 3.2 9.5 3.6 10.8-3.6 1.5-7.5h-26.9l1.3-6.7h26.9l0.9-4.2h-27z' })
	        )
	    );
	};
	
	exports.default = FaCss3;
	module.exports = exports['default'];

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCube = function FaCube(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.5 36.4l14.3-7.8v-14.2l-14.3 5.2v16.8z m-1.4-19.3l15.5-5.7-15.5-5.7-15.6 5.7z m18.5-5.7v17.2q0 0.8-0.4 1.4t-1.1 1.1l-15.7 8.5q-0.6 0.4-1.3 0.4t-1.4-0.4l-15.7-8.5q-0.7-0.4-1.1-1.1t-0.4-1.4v-17.2q0-0.9 0.5-1.6t1.4-1.1l15.7-5.7q0.5-0.1 1-0.1t1 0.1l15.7 5.8q0.8 0.3 1.3 1t0.5 1.6z' })
	        )
	    );
	};
	
	exports.default = FaCube;
	module.exports = exports['default'];

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCubes = function FaCubes(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.7 33.4l7-3.5v-5.7l-7 3v6.2z m-1.2-8.3l7.4-3.1-7.4-3.2-7.4 3.2z m19.8 8.3l7-3.5v-5.7l-7 3v6.2z m-1.1-8.3l7.3-3.1-7.3-3.2-7.4 3.2z m-8.2-5.3l7-3v-4.9l-7 3v4.9z m-1.2-6.9l8.1-3.5-8.1-3.4-8 3.5z m19.8 9.4v7.6q0 0.7-0.3 1.2t-0.9 0.9l-8.2 4.1q-0.5 0.2-1 0.2t-1.1-0.2l-8.1-4.1q-0.1 0-0.2-0.1 0 0.1-0.1 0.1l-8.2 4.1q-0.4 0.2-1 0.2t-1-0.2l-8.2-4.1q-0.6-0.3-1-0.9t-0.3-1.2v-7.6q0-0.7 0.4-1.2t1-0.9l7.9-3.4v-7.3q0-0.7 0.4-1.3t1.1-0.8l8.1-3.5q0.4-0.2 0.9-0.2t0.9 0.2l8.2 3.5q0.6 0.2 1 0.8t0.4 1.3v7.3l7.9 3.4q0.7 0.3 1.1 0.9t0.4 1.2z' })
	        )
	    );
	};
	
	exports.default = FaCubes;
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCut = function FaCut(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.4 20q0.6 0 1 0.4t0.5 1-0.5 1-1 0.5-1-0.5-0.4-1 0.4-1 1-0.4z m6.7 1.4l11.3 8.9q0.7 0.5 0.6 1.3-0.1 0.7-0.8 1.1l-2.8 1.4q-0.3 0.2-0.7 0.2-0.4 0-0.7-0.2l-15.4-8.6-2.4 1.4q-0.2 0.1-0.3 0.2 0.3 1 0.2 2.1-0.1 1.7-1.2 3.3t-3 2.8q-2.9 1.8-6.2 1.8-3 0-4.9-1.7-2-1.9-1.8-4.6 0.2-1.7 1.3-3.3t2.9-2.8q2.9-1.8 6.2-1.8 1.9 0 3.4 0.6 0.2-0.2 0.5-0.4l2.7-1.7-2.7-1.6q-0.3-0.2-0.5-0.5-1.5 0.7-3.4 0.7-3.3 0-6.2-1.9-1.8-1.2-2.9-2.7t-1.3-3.3q-0.1-1.3 0.4-2.5t1.4-2.1q1.9-1.8 4.9-1.8 3.3 0 6.2 1.9 1.9 1.2 3 2.7t1.2 3.3q0.1 1.1-0.2 2.2 0.1 0 0.3 0.1l2.4 1.5 15.4-8.6q0.3-0.2 0.7-0.2 0.4 0 0.7 0.1l2.8 1.5q0.7 0.3 0.8 1.1 0.1 0.8-0.6 1.3z m-15.2-5.8q1.1-0.9 0.5-2.4t-2.4-2.6q-2-1.3-4.3-1.3-1.6 0-2.5 0.8-1 0.9-0.4 2.4t2.3 2.6q2.1 1.3 4.3 1.3 1.7 0 2.5-0.8z m-1.9 16.7q1.8-1.2 2.4-2.7t-0.5-2.4q-0.8-0.8-2.5-0.8-2.2 0-4.3 1.3-1.8 1.2-2.3 2.7t0.4 2.4q0.9 0.8 2.5 0.8 2.3 0 4.3-1.3z m4-13.7l2.1 1.3v-0.3q0-0.8 0.8-1.2l0.3-0.2-1.8-1.1-0.6 0.6q0 0.1-0.2 0.3t-0.2 0.2q-0.1 0.1-0.1 0.1t-0.1 0.1z m5 5l2.1 0.7 16.5-12.9-2.9-1.4-17.1 9.6v2.5l-3.6 2.2 0.2 0.2q0 0 0.2 0.1 0 0.1 0.2 0.3t0.3 0.2l0.5 0.6z m15.7 9.3l2.9-1.5-11.6-9.1-4 3.1q0 0.1-0.3 0.2z' })
	        )
	    );
	};
	
	exports.default = FaCut;
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCutlery = function FaCutlery(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.8 1.4v14.3q0 1.4-0.8 2.5t-2.1 1.6v17.3q0 1.2-0.8 2.1t-2 0.8h-2.9q-1.1 0-2-0.8t-0.8-2.1v-17.3q-1.3-0.5-2.1-1.6t-0.8-2.5v-14.3q0-0.6 0.4-1t1-0.4 1 0.4 0.5 1v9.3q0 0.6 0.4 1t1 0.4 1-0.4 0.4-1v-9.3q0-0.6 0.4-1t1-0.4 1 0.4 0.5 1v9.3q0 0.6 0.4 1t1 0.4 1-0.4 0.4-1v-9.3q0-0.6 0.4-1t1.1-0.4 1 0.4 0.4 1z m17.1 0v35.7q0 1.2-0.8 2.1t-2 0.8h-2.9q-1.1 0-2-0.8t-0.8-2.1v-11.4h-5q-0.3 0-0.5-0.2t-0.3-0.5v-17.9q0-2.9 2.1-5t5.1-2.1h5.7q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaCutlery;
	module.exports = exports['default'];

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDashboard = function FaDashboard(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 25.7q0-1.2-0.9-2t-2-0.8-2 0.8-0.8 2 0.8 2 2 0.9 2-0.9 0.9-2z m4.3-10q0-1.2-0.9-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.9-2z m9.5 10.7l2.3-8.5q0.1-0.6-0.2-1.1t-0.9-0.6-1 0.1-0.7 0.9l-2.3 8.5q-1.3 0.1-2.3 1t-1.5 2.2q-0.4 1.7 0.5 3.3t2.6 2 3.3-0.5 2-2.6q0.3-1.3-0.2-2.6t-1.6-2z m14.7-0.7q0-1.2-0.8-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.8-2z m-14.2-14.3q0-1.2-0.9-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.9-2z m10 4.3q0-1.2-0.9-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.9-2z m7.1 10q0 5.8-3.1 10.8-0.5 0.6-1.3 0.6h-31.2q-0.8 0-1.3-0.6-3.1-4.9-3.1-10.8 0-4 1.6-7.8t4.2-6.3 6.4-4.3 7.8-1.6 7.8 1.6 6.4 4.3 4.2 6.3 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaDashboard;
	module.exports = exports['default'];

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDashcube = function FaDashcube(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.5 15.2q0-2.9 2-5.1t5-2.1h16.6l7.8-8v32.8q0 3-2 5.1t-5 2.1h-17.4q-2.9 0-5-2.1t-2-5.1v-17.6z m27.5 16.8l-3.9-4v-9.5q0-1-0.7-1.8t-1.8-0.7h-10.8q-1 0-1.7 0.7t-0.7 1.8v11q0 1 0.7 1.8t1.7 0.7h17.2z' })
	        )
	    );
	};
	
	exports.default = FaDashcube;
	module.exports = exports['default'];

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDatabase = function FaDatabase(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 17.1q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0 17.2q5.3 0 9.9-1t7.3-2.8v3.8q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-3.8q2.7 1.9 7.3 2.8t9.8 1z m0-8.6q5.3 0 9.9-0.9t7.3-2.9v3.8q0 1.6-2.3 2.9t-6.3 2.1-8.6 0.7-8.6-0.7-6.2-2.1-2.3-2.9v-3.8q2.7 1.9 7.3 2.9t9.8 0.9z m0-25.7q4.7 0 8.6 0.8t6.3 2.1 2.3 2.8v2.9q0 1.5-2.3 2.8t-6.3 2.1-8.6 0.8-8.6-0.8-6.2-2.1-2.3-2.8v-2.9q0-1.5 2.3-2.8t6.3-2.1 8.5-0.8z' })
	        )
	    );
	};
	
	exports.default = FaDatabase;
	module.exports = exports['default'];

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDeaf = function FaDeaf(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.6 18.6q0 0.5 0.4 1t1 0.4 1-0.4 0.4-1q0-3.3-2.3-5.6t-5.5-2.3-5.6 2.3-2.3 5.6q0 0.6 0.4 1t1 0.4 1-0.4 0.5-1q0-2.1 1.4-3.6t3.6-1.4 3.5 1.4 1.5 3.6z m-5-12.9q-2.6 0-4.9 1t-4.2 2.8-2.7 4.1-1 5q0 0.6 0.4 1t1 0.4 1-0.4 0.4-1q0-4.2 3-7.1t7-2.9 7.1 2.9 2.9 7.1q0 1.2-0.4 2.3t-0.8 1.6-1.3 1.7q-0.8 0.8-1.2 1.4t-1 1.4-0.8 2.1-0.2 2.3q0 2.4-1.7 4.1t-4.1 1.6q-0.5 0-1 0.5t-0.4 1 0.4 1 1 0.4q3.6 0 6.1-2.5t2.5-6.1q0-0.9 0.2-1.6t0.6-1.5 0.7-1.1 1-1.2q0.8-0.9 1.2-1.4t1-1.5 0.8-2.1 0.3-2.4q0-2.6-1-5t-2.8-4.1-4.1-2.8-5-1z m-5.4 16.1l5 5-12.9 12.9q-0.3 0.3-0.6 0.3t-0.7-0.3l-3.7-3.7q-0.3-0.3-0.3-0.7t0.3-0.6z m22.8-21.5l3.7 3.7q0.3 0.3 0.3 0.7t-0.3 0.6l-5.2 5.2-0.5 0.6-1.6 1.6q-1.5-3.4-4.4-5.8l6.7-6.6q0.3-0.3 0.6-0.3t0.7 0.3z' })
	        )
	    );
	};
	
	exports.default = FaDeaf;
	module.exports = exports['default'];

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDedent = function FaDedent(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 12.1v12.9q0 0.3-0.2 0.5t-0.5 0.2q-0.4 0-0.6-0.2l-6.4-6.4q-0.2-0.2-0.2-0.5t0.2-0.5l6.4-6.5q0.2-0.2 0.6-0.2 0.2 0 0.5 0.2t0.2 0.5z m31.4 17.2v4.3q0 0.3-0.2 0.5t-0.5 0.2h-38.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h38.6q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-24.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h24.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-24.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h24.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.5v4.3q0 0.2-0.2 0.5t-0.5 0.2h-38.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h38.6q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaDedent;
	module.exports = exports['default'];

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDelicious = function FaDelicious(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 30.7v-10.7h-15.8v-15.7h-10.7q-2 0-3.5 1.4t-1.5 3.6v10.7h15.7v15.7h10.8q2 0 3.5-1.4t1.5-3.6z m1.4-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaDelicious;
	module.exports = exports['default'];

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDesktop = function FaDesktop(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.2 22v-17.3q0-0.3-0.2-0.4t-0.5-0.2h-33.2q-0.2 0-0.4 0.2t-0.2 0.4v17.3q0 0.3 0.2 0.5t0.4 0.2h33.2q0.3 0 0.5-0.2t0.2-0.5z m2.7-17.3v22.6q0 1.4-1 2.4t-2.4 0.9h-11.3q0 0.8 0.4 1.6t0.6 1.5 0.4 0.9q0 0.6-0.4 1t-1 0.3h-10.6q-0.5 0-0.9-0.3t-0.4-1q0-0.3 0.3-0.9t0.7-1.5 0.3-1.6h-11.3q-1.3 0-2.3-0.9t-1-2.4v-22.6q0-1.4 1-2.3t2.3-1h33.2q1.4 0 2.4 1t1 2.3z' })
	        )
	    );
	};
	
	exports.default = FaDesktop;
	module.exports = exports['default'];

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDeviantart = function FaDeviantart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 6.8l-6.8 13 0.5 0.6h6.3v9.3h-11.4l-0.9 0.7-3.2 6.1-0.7 0.6h-6.7v-6.7l6.8-13-0.6-0.7h-6.2v-9.3h11.3l1-0.6 3.2-6.1 0.6-0.7h6.8v6.8z' })
	        )
	    );
	};
	
	exports.default = FaDeviantart;
	module.exports = exports['default'];

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDiamond = function FaDiamond(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.1 17.5l12.1 12.9-5.8-12.9h-6.3z m15.8 15l6.7-15h-13.5z m-9.5-17.5l4-7.4h-5.1l-5.6 7.4h6.7z m13.1 15.4l12.1-12.9h-6.2z m-10.2-15.4h13.2l-4-7.4h-5.3z m16 0h6.7l-5.6-7.4h-5.1z m2.7-9.4l7.5 9.9q0.3 0.4 0.3 0.8t-0.4 0.8l-18.6 19.9q-0.4 0.4-0.9 0.4t-0.9-0.4l-18.7-19.9q-0.3-0.3-0.3-0.8t0.3-0.8l7.4-9.9q0.4-0.5 1-0.5h22.4q0.6 0 0.9 0.5z' })
	        )
	    );
	};
	
	exports.default = FaDiamond;
	module.exports = exports['default'];

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDigg = function FaDigg(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm6.4 8.1h3.9v19.1h-10.3v-13.6h6.4v-5.5z m0 15.9v-7.2h-2.4v7.2h2.4z m5.5-10.4v13.6h4v-13.6h-4z m0-5.5v3.9h4v-3.9h-4z m5.6 5.5h10.3v18.3h-10.3v-3.1h6.4v-1.6h-6.4v-13.6z m6.4 10.4v-7.2h-2.4v7.2h2.4z m5.5-10.4h10.4v18.3h-10.4v-3.1h6.4v-1.6h-6.4v-13.6z m6.4 10.4v-7.2h-2.4v7.2h2.4z' })
	        )
	    );
	};
	
	exports.default = FaDigg;
	module.exports = exports['default'];

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDollar = function FaDollar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.3 26.4q0 3.5-2.2 5.9t-5.8 3.1v3.9q0 0.3-0.2 0.5t-0.5 0.2h-3q-0.3 0-0.5-0.2t-0.2-0.5v-3.9q-1.5-0.2-2.8-0.7t-2.3-1-1.7-1.1-1-0.8-0.4-0.4q-0.4-0.5 0-0.9l2.3-3q0.1-0.3 0.5-0.3 0.3-0.1 0.5 0.2l0.1 0q2.5 2.2 5.4 2.8 0.8 0.2 1.6 0.2 1.8 0 3.2-1t1.4-2.7q0-0.6-0.4-1.2t-0.7-0.9-1.3-0.8-1.5-0.8-1.8-0.7q-0.8-0.3-1.3-0.5t-1.4-0.6-1.4-0.7-1.3-0.8-1.2-1-0.9-1.1-0.8-1.2-0.5-1.5-0.2-1.8q0-3.1 2.2-5.4t5.7-3v-4q0-0.3 0.2-0.5t0.5-0.2h3q0.3 0 0.5 0.2t0.2 0.5v3.9q1.3 0.2 2.5 0.6t1.9 0.7 1.5 0.8 0.8 0.7 0.4 0.3q0.3 0.4 0.1 0.9l-1.8 3.2q-0.2 0.3-0.5 0.4-0.4 0-0.6-0.2-0.1-0.1-0.4-0.3t-0.8-0.5-1.3-0.8-1.7-0.5-1.9-0.3q-2.1 0-3.5 1t-1.3 2.4q0 0.6 0.2 1.1t0.6 0.9 0.9 0.8 1.3 0.7 1.3 0.6 1.6 0.6q1.2 0.4 1.8 0.7t1.7 0.8 1.7 0.9 1.4 1.1 1.1 1.5 0.7 1.7 0.3 2.1z' })
	        )
	    );
	};
	
	exports.default = FaDollar;
	module.exports = exports['default'];

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDotCircleO = function FaDotCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 20q0 2.4-1.7 4t-4.1 1.7-4-1.7-1.7-4 1.7-4 4-1.7 4.1 1.7 1.7 4z m-5.8-12.1q-3.3 0-6.1 1.6t-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6z m17.2 12.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaDotCircleO;
	module.exports = exports['default'];

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDownload = function FaDownload(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 30q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m5.7 0q0-0.6-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.4 1-0.4 0.4-1z m2.8-5v7.1q0 0.9-0.6 1.6t-1.5 0.6h-32.9q-0.8 0-1.5-0.6t-0.6-1.6v-7.1q0-0.9 0.6-1.5t1.5-0.6h10.4l3 3q1.3 1.2 3.1 1.2t3-1.2l3-3h10.4q0.9 0 1.5 0.6t0.6 1.5z m-7.2-12.7q0.4 0.9-0.3 1.6l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.7-0.7-0.3-1.6 0.3-0.9 1.3-0.9h5.7v-10q0-0.6 0.4-1t1-0.4h5.7q0.6 0 1 0.4t0.5 1v10h5.7q0.9 0 1.3 0.9z' })
	        )
	    );
	};
	
	exports.default = FaDownload;
	module.exports = exports['default'];

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDribbble = function FaDribbble(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 33.5q-1-5.4-3.2-11.1h0l-0.1 0q-0.3 0.1-0.9 0.4t-2.3 1-3 1.9-3 2.5-2.3 3.3l-0.3-0.2q4.1 3.3 9.3 3.3 3 0 5.8-1.1z m-4.2-13.6q-0.4-1.1-1.2-2.4-6.9 2-15 2 0 0.2 0 0.5 0 2.8 1 5.3t2.8 4.5q1.1-2 2.7-3.7t3.2-2.8 2.9-1.8 2.2-1.1l0.9-0.3q0 0 0.2-0.1t0.3-0.1z m-2.4-4.7q-2.6-4.8-5.4-8.4-3.1 1.4-5.2 4.1t-2.9 6.1q6.8 0 13.5-1.8z m15.3 7.1q-4.7-1.3-9.1-0.6 1.9 5.3 2.8 10.4 2.5-1.6 4.2-4.2t2.1-5.6z m-18-16.5q0 0 0 0 0 0 0 0z m13.2 3.2q-4.1-3.6-9.7-3.6-1.7 0-3.4 0.4 2.9 3.8 5.5 8.5 1.5-0.6 2.9-1.3t2.1-1.4 1.5-1.3 0.8-0.9z m5 10.8q-0.1-5.1-3.3-9.1l-0.1 0q-0.2 0.3-0.4 0.6t-1 1-1.5 1.3-2.3 1.5-2.9 1.4q0.6 1.2 1 2.1 0 0.1 0.1 0.4t0.2 0.4q0.8-0.1 1.6-0.2t1.7 0 1.5 0 1.5 0.1 1.2 0.1 1.1 0.2 0.8 0.1 0.6 0.1z m2.5 0.2q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaDribbble;
	module.exports = exports['default'];

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDropbox = function FaDropbox(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9 15.8l11 6.8-7.6 6.3-11-7.1z m22 12.4v2.4l-11 6.5v0l0 0 0 0v0l-10.9-6.5v-2.4l3.3 2.1 7.6-6.3v-0.1l0 0 0 0v0.1l7.7 6.3z m-18.6-25.6l7.6 6.4-11 6.8-7.6-6z m18.6 13.2l7.6 6-10.9 7.2-7.7-6.4z m-3.3-13.2l10.9 7.2-7.6 6-11-6.8z' })
	        )
	    );
	};
	
	exports.default = FaDropbox;
	module.exports = exports['default'];

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaDrupal = function FaDrupal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.1 35.4q-0.2-0.4-0.6-0.1-0.7 0.5-1.9 0.9t-3 0.3q-2.8 0-4.3-1.1-0.1 0-0.2 0-0.3 0-0.6 0.2-0.2 0.2-0.2 0.4t0.2 0.4q0.7 0.7 1.9 1.1t2.3 0.2 2.2-0.1q0.9-0.1 1.9-0.4t1.5-0.7 0.6-0.5q0.3-0.2 0.1-0.6z m-0.9-2.6q-0.4-1-0.9-1.3-0.5-0.4-1.7-0.4-1 0-1.6 0.3-0.6 0.2-1.7 1.2-0.6 0.5-0.3 1 0.2 0.2 0.4 0.1t0.7-0.5q0.1-0.1 0.2-0.2t0.3-0.2 0.2-0.2 0.3-0.1 0.2-0.1 0.4-0.1 0.3-0.1 0.5 0q0.6 0 1 0.2t0.5 0.3 0.3 0.5q0.2 0.3 0.3 0.4t0.3 0q0.5-0.3 0.3-0.8z m7.9-6.2q0-0.5-0.1-1t-0.4-1-0.7-0.8-1.2-0.4q-0.7 0-2.2 1t-2.9 1.8-2.2 1q-0.6 0-1.4-0.5t-1.7-1.1-1.9-1.2-2.2-1.1-2.5-0.5q-2.6 0.1-4.4 1.8t-1.9 4q0 2.5 1.7 3.6 0.6 0.5 1.4 0.7t2.3 0.2q1.3 0 2.9-0.8t3-1.6 2.7-1.5 2.1-0.7q0.6 0 1.4 0.7t1.6 1.5 1.6 1.5 1.2 0.7q0.8 0.1 1.3-0.3t1.2-1.4q0.7-0.9 1-2.3t0.3-2.3z m1.2-3.6q0 3.7-1.4 6.8t-3.7 5.3-5.4 3.3-6.5 1.2-6.5-1.3-5.6-3.5-3.8-5.4-1.4-6.7q0-2 0.4-3.9t1.1-3.2 1.6-2.7 1.8-2.1 1.7-1.5 1.4-1.1 1-0.5q0.3-0.2 1.1-0.6t1.2-0.6 1.1-0.7 1.4-1q0.8-0.6 1.3-1.6t0.6-2.8q2.9 3.5 4.2 4.3 1 0.7 2.9 1.5t2.9 1.5q0.4 0.3 0.8 0.6t1.4 1 1.7 1.6 1.7 2.1 1.5 2.7 1.1 3.3 0.4 4z' })
	        )
	    );
	};
	
	exports.default = FaDrupal;
	module.exports = exports['default'];

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEdge = function FaEdge(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm1.5 17.7h0.1q0.3-2.8 1.3-5.3t2.5-4.9 3.8-3.9 5-2.6 6.1-1q5.2 0 9.3 2.4t6.5 6.7q2.4 4.2 2.4 9.9v4.2h-25.2q0.1 2.5 1.2 4.3t3.1 2.7 4.2 1.3 4.8 0.1 4.6-1.1 3.9-1.9v8.5q-2.1 1.2-5.1 2t-7 0.9-7.1-1.2q-4.2-1.7-6.9-5.6t-2.8-8.3q-0.1-5.4 2.5-9.2t7.2-6q-1 1.4-1.7 2.8t-1 3.6h14.1q0.2-1.7-0.1-3.1t-1.1-2.3-1.6-1.5-1.8-0.9-1.6-0.5-1.3-0.1l-0.5-0.1q-3 0.1-5.8 1t-5 2.4-3.9 3.1-3.1 3.6z' })
	        )
	    );
	};
	
	exports.default = FaEdge;
	module.exports = exports['default'];

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEdit = function FaEdit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEdit;
	module.exports = exports['default'];

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEject = function FaEject(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3.3 21.9l15.9-15.9q0.4-0.4 1-0.4t1 0.4l15.8 15.9q0.4 0.4 0.3 0.7t-0.7 0.3h-32.9q-0.5 0-0.7-0.3t0.3-0.7z m32.6 12.4h-31.4q-0.6 0-1.1-0.4t-0.4-1v-5.8q0-0.5 0.4-1t1.1-0.4h31.4q0.6 0 1 0.4t0.4 1v5.8q0 0.5-0.4 1t-1 0.4z' })
	        )
	    );
	};
	
	exports.default = FaEject;
	module.exports = exports['default'];

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEllipsisH = function FaEllipsisH(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 16.4v4.3q0 0.9-0.7 1.5t-1.5 0.7h-4.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.7 1.5z m11.4 0v4.3q0 0.9-0.6 1.5t-1.5 0.7h-4.3q-0.9 0-1.5-0.7t-0.7-1.5v-4.3q0-0.9 0.7-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.6 1.5z m11.4 0v4.3q0 0.9-0.6 1.5t-1.5 0.7h-4.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEllipsisH;
	module.exports = exports['default'];

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEllipsisV = function FaEllipsisV(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.1 27.9v4.2q0 0.9-0.7 1.6t-1.5 0.6h-4.3q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h4.3q0.9 0 1.5 0.6t0.7 1.6z m0-11.5v4.3q0 0.9-0.7 1.5t-1.5 0.7h-4.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.7 1.5z m0-11.4v4.3q0 0.9-0.7 1.5t-1.5 0.6h-4.3q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.7 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEllipsisV;
	module.exports = exports['default'];

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEmpire = function FaEmpire(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.5 36.6v1.4q-4.6-0.1-8.6-2.4t-6.3-6.2l1.3-0.7q0.6 1.1 1.6 2.2l1.5-1.3q3.3 3.8 8.2 4.8l-0.4 1.9q1.5 0.2 2.7 0.3z m-13.3-11.9l-1.9 0.7q0.5 1.3 1.1 2.5l-1.3 0.7q-2.2-4-2.2-8.6t2.2-8.6l1.3 0.7q-0.7 1.3-1.1 2.5l1.8 0.7q-0.7 2.2-0.7 4.7 0 2.4 0.8 4.7z m27.9 4l1.3 0.7q-2.4 3.9-6.3 6.2t-8.6 2.4v-1.4q1.2-0.1 2.7-0.3l-0.4-1.9q4.9-1 8.2-4.8l1.5 1.3q1-1.1 1.6-2.2z m-3.4-12.4l-5.2 1.8q0.3 0.9 0.3 1.9t-0.3 1.9l5.2 1.8q-0.7 2-2.2 3.8l-4.1-3.7q-1.3 1.5-3.3 1.9l1.1 5.4q-1.2 0.2-2.2 0.2t-2.2-0.2l1.1-5.4q-2-0.4-3.3-1.9l-4.1 3.7q-1.5-1.8-2.2-3.8l5.2-1.8q-0.3-0.9-0.3-1.9t0.3-1.9l-5.2-1.8q0.7-2.1 2.2-3.8l4.1 3.7q1.3-1.6 3.3-2l-1.1-5.3q1-0.2 2.2-0.2t2.2 0.2l-1.1 5.3q2 0.4 3.3 2l4.1-3.7q1.5 1.7 2.2 3.8z m-11.2-14.3v1.4q-1.4 0.1-2.7 0.3l0.4 1.9q-4.9 1-8.2 4.8l-1.5-1.3q-0.8 0.9-1.6 2.2l-1.3-0.7q2.4-3.9 6.3-6.2t8.6-2.4z m18.6 18q0 4.6-2.2 8.6l-1.3-0.7q0.6-1.2 1.1-2.5l-1.9-0.7q0.8-2.3 0.8-4.7 0-2.5-0.7-4.7l1.8-0.7q-0.4-1.2-1.1-2.5l1.3-0.7q2.2 4 2.2 8.6z m-2.7-9.4l-1.3 0.7q-0.8-1.3-1.6-2.2l-1.5 1.3q-3.3-3.8-8.2-4.8l0.4-1.9q-1.3-0.2-2.7-0.3v-1.4q4.7 0.1 8.6 2.4t6.3 6.2z m3.6 9.4q0-3.9-1.5-7.4t-4-6.1-6.1-4-7.4-1.5-7.4 1.5-6.1 4-4 6.1-1.5 7.4 1.5 7.4 4 6.1 6.1 4 7.4 1.5 7.4-1.5 6.1-4 4-6.1 1.5-7.4z m1 0q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaEmpire;
	module.exports = exports['default'];

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEnvelopeO = function FaEnvelopeO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.1 33.6v-17.2q-0.7 0.8-1.5 1.5-6 4.6-9.5 7.5-1.1 1-1.9 1.5t-1.9 1.1-2.3 0.6h0q-1.1 0-2.3-0.6t-1.9-1.1-1.9-1.5q-3.5-2.9-9.5-7.5-0.8-0.7-1.5-1.5v17.2q0 0.3 0.2 0.5t0.5 0.2h32.8q0.3 0 0.5-0.2t0.2-0.5z m0-23.5v-0.5l0-0.3 0-0.3-0.2-0.2-0.2-0.2-0.3 0h-32.8q-0.3 0-0.5 0.2t-0.2 0.5q0 3.7 3.2 6.3 4.3 3.4 9 7.1 0.1 0.1 0.8 0.7t1 0.8 1 0.7 1.1 0.6 1 0.2h0q0.5 0 1-0.2t1.1-0.6 1-0.7 1-0.8 0.8-0.7q4.7-3.7 9-7.1 1.2-0.9 2.2-2.6t1-2.9z m2.9-0.8v24.3q0 1.4-1 2.5t-2.6 1h-32.8q-1.5 0-2.6-1t-1-2.5v-24.3q0-1.5 1.1-2.5t2.5-1.1h32.8q1.5 0 2.6 1.1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaEnvelopeO;
	module.exports = exports['default'];

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEnvelopeSquare = function FaEnvelopeSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z m0.7 23.5v-9.7q-0.7 0.8-1.5 1.2-0.7 0.5-2.9 1.9t-3.4 2.2q-2.2 1.6-3.7 1.6-1.4 0-3.6-1.6-1-0.7-3.2-2t-3.2-2.1q-0.2-0.2-0.7-0.6t-0.7-0.6v9.7q0 0.9 0.6 1.5t1.6 0.7h18.5q0.9 0 1.5-0.7t0.7-1.5z m0-12.8q0-0.9-0.6-1.5t-1.6-0.7h-18.5q-0.9 0-1.6 0.7t-0.6 1.5q0 0.8 0.7 1.7t1.5 1.4q1.1 0.7 3.1 2t2.9 1.9l0.3 0.2 0.5 0.3 0.5 0.3 0.5 0.3 0.5 0.2 0.5 0.2 0.4 0 0.5 0 0.5-0.2 0.5-0.2 0.5-0.3 0.5-0.3 0.4-0.3 0.4-0.2 6-3.9q0.8-0.5 1.5-1.4t0.7-1.7z' })
	        )
	    );
	};
	
	exports.default = FaEnvelopeSquare;
	module.exports = exports['default'];

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEnvelope = function FaEnvelope(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 15.8v17.8q0 1.4-1 2.5t-2.6 1h-32.8q-1.5 0-2.6-1t-1-2.5v-17.8q1 1.1 2.3 2 8 5.5 11 7.7 1.3 0.9 2.1 1.5t2.1 1 2.5 0.6h0q1.2 0 2.5-0.6t2.1-1 2.1-1.5q3.7-2.8 11.1-7.7 1.2-0.9 2.2-1.9z m0-6.5q0 1.7-1.1 3.4t-2.7 2.7q-8.4 5.8-10.5 7.3-0.2 0.1-0.9 0.6t-1.2 0.9-1.2 0.7-1.3 0.6-1.1 0.2h0q-0.5 0-1.1-0.2t-1.3-0.6-1.2-0.7-1.2-0.9-0.9-0.6q-2.1-1.5-5.9-4.1t-4.6-3.2q-1.3-0.9-2.6-2.6t-1.2-3q0-1.8 0.9-2.9t2.7-1.2h32.8q1.5 0 2.5 1.1t1.1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaEnvelope;
	module.exports = exports['default'];

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEnvira = function FaEnvira(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 18.2q-2.3-4.4-3.6-6.2-3.1-4.5-7.7-7.1-0.8-0.4-1.6-0.8-2-0.9-2.1-0.7t0.8 0.8l0.9 0.7q1.3 1 2.5 2.1t2.1 2.6 1.5 2.5 1.6 3q0.2 0.3 0.3 0.5 1 1.9 1.9 3.4t2.2 3.5 2.6 3.3 2.9 2.8 3.3 2q3.4 1.5 3.4 1.3 0.1 0-1.1-0.8-1.1-0.8-1.8-1.3-1.7-1.3-4-4.7t-4.1-6.9z m-7.7 12.1q-1.7-1.3-3-2.8t-2.2-3.2-1.6-3.4-1.3-4.2-1.1-4.6-1.4-5.6-1.7-6.5q6.1 0 11.1 0.8t8.5 2.1 6 3.2 4.2 3.8 2.4 4.5 1.3 4.4 0.2 4.4-0.2 3.9-0.4 3.2-0.3 2.4l7.2 7.3h-2.3l-6.3-6.4q-0.5 0.1-2 0.4t-2.7 0.4-3.1 0.1-3.6-0.4-3.8-1.3-3.9-2.5z' })
	        )
	    );
	};
	
	exports.default = FaEnvira;
	module.exports = exports['default'];

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEraser = function FaEraser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 30.6l7-7.9h-16l-6.9 7.9h15.9z m21-22.3q0.4 0.7 0.2 1.5t-0.6 1.3l-18.6 21.3q-0.8 0.9-2 0.9h-15.9q-0.8 0-1.5-0.4t-1-1.2q-0.3-0.7-0.2-1.5t0.7-1.3l18.6-21.3q0.8-0.9 2-0.9h15.9q0.8 0 1.5 0.4t0.9 1.2z' })
	        )
	    );
	};
	
	exports.default = FaEraser;
	module.exports = exports['default'];

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEur = function FaEur(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.3 29.2l0.8 3.5q0 0.3-0.1 0.5t-0.4 0.3l-0.1 0.1q-0.1 0-0.2 0t-0.4 0.1-0.5 0.2-0.5 0.1-0.7 0.1-0.7 0.1-0.9 0.1-0.8 0q-5.2 0-9.2-2.9t-5.3-7.9h-2.1q-0.3 0-0.5-0.2t-0.2-0.5v-2.5q0-0.3 0.2-0.5t0.5-0.2h1.5q-0.1-1.3 0-2.4h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-2.5q0-0.3 0.2-0.5t0.5-0.2h2.2q1.5-4.7 5.4-7.6t9-2.8q2.3 0 4.3 0.5 0.3 0 0.5 0.3 0.1 0.3 0 0.5l-0.9 3.6q-0.1 0.3-0.4 0.4t-0.5 0.1l-0.1 0q-0.1-0.1-0.2-0.1l-0.4-0.1-0.5-0.1-0.6 0-0.7-0.1-0.6 0q-2.8 0-5.1 1.4t-3.3 4h10.4q0.4 0 0.6 0.2 0.2 0.3 0.2 0.6l-0.6 2.6q-0.1 0.5-0.7 0.5h-10.9q-0.1 0.9 0 2.4h10.3q0.3 0 0.5 0.2 0.2 0.3 0.1 0.6l-0.5 2.5q0 0.3-0.2 0.5t-0.5 0.1h-8.6q1.1 2.6 3.3 4.2t5.1 1.5q0.4 0 0.8 0t0.8-0.1 0.6-0.1 0.6-0.1 0.4-0.1l0.3-0.1 0.1 0q0.3-0.1 0.5 0 0.3 0.2 0.4 0.5z' })
	        )
	    );
	};
	
	exports.default = FaEur;
	module.exports = exports['default'];

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExchange = function FaExchange(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 26.4v4.3q0 0.3-0.2 0.5t-0.5 0.2h-30.7v4.3q0 0.3-0.2 0.5t-0.5 0.2q-0.3 0-0.6-0.2l-7.1-7.1q-0.2-0.2-0.2-0.5 0-0.3 0.2-0.5l7.1-7.2q0.2-0.2 0.6-0.2 0.2 0 0.5 0.2t0.2 0.5v4.3h30.7q0.3 0 0.5 0.2t0.2 0.5z m0-12.1q0 0.3-0.2 0.5l-7.1 7.1q-0.2 0.2-0.6 0.2-0.2 0-0.5-0.2t-0.2-0.5v-4.3h-30.7q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h30.7v-4.3q0-0.3 0.2-0.5t0.5-0.2q0.3 0 0.6 0.3l7.1 7.1q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaExchange;
	module.exports = exports['default'];

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExclamationCircle = function FaExclamationCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m2.9 27.8v-4.2q0-0.4-0.2-0.6t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m0-7.7l0.4-13.8q0-0.3-0.3-0.5-0.2-0.1-0.5-0.1h-4.9q-0.3 0-0.5 0.1-0.3 0.2-0.3 0.4l0.4 13.9q0 0.2 0.2 0.4t0.6 0.2h4.1q0.3 0 0.5-0.2t0.3-0.4z' })
	        )
	    );
	};
	
	exports.default = FaExclamationCircle;
	module.exports = exports['default'];

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExclamationTriangle = function FaExclamationTriangle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.9 30.7v-4.2q0-0.4-0.3-0.6t-0.5-0.2h-4.2q-0.3 0-0.5 0.2t-0.3 0.6v4.2q0 0.3 0.3 0.5t0.5 0.2h4.2q0.3 0 0.5-0.2t0.3-0.5z m-0.1-8.4l0.4-10.2q0-0.3-0.2-0.4-0.3-0.3-0.5-0.3h-5q-0.2 0-0.5 0.3-0.2 0.1-0.2 0.4l0.4 10.2q0 0.3 0.2 0.4t0.5 0.2h4.2q0.3 0 0.5-0.2t0.2-0.4z m-0.3-20.8l17.1 31.4q0.8 1.4 0 2.8-0.4 0.7-1 1.1t-1.5 0.3h-34.2q-0.8 0-1.5-0.3t-1-1.1q-0.8-1.4 0-2.8l17.1-31.4q0.4-0.7 1.1-1.1t1.4-0.4 1.4 0.4 1.1 1.1z' })
	        )
	    );
	};
	
	exports.default = FaExclamationTriangle;
	module.exports = exports['default'];

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExclamation = function FaExclamation(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.4 27.9v5q0 0.5-0.4 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.4-1v-5q0-0.6 0.4-1t1-0.5h5.7q0.6 0 1 0.5t0.4 1z m0.7-23.6l-0.6 17.1q0 0.6-0.5 1t-1 0.5h-5.7q-0.6 0-1-0.5t-0.5-1l-0.6-17.1q0-0.6 0.4-1t1-0.4h7.1q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaExclamation;
	module.exports = exports['default'];

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExpand = function FaExpand(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 23.6q0 0.3-0.3 0.5l-7.4 7.4 3.2 3.2q0.5 0.4 0.5 1t-0.5 1-1 0.4h-10q-0.6 0-1-0.4t-0.4-1v-10q0-0.6 0.4-1t1-0.4 1 0.4l3.2 3.2 7.5-7.4q0.2-0.2 0.5-0.2t0.5 0.2l2.5 2.6q0.3 0.2 0.3 0.5z m17.4-19.3v10q0 0.6-0.4 1t-1 0.4-1-0.4l-3.3-3.2-7.4 7.4q-0.2 0.2-0.5 0.2t-0.5-0.2l-2.5-2.6q-0.3-0.2-0.3-0.5t0.3-0.5l7.4-7.4-3.2-3.2q-0.5-0.4-0.5-1t0.5-1 1-0.4h10q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaExpand;
	module.exports = exports['default'];

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExpeditedssl = function FaExpeditedssl(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 1.4q-3.8 0-7.2 1.5t-5.9 4-4 5.9-1.5 7.2 1.5 7.2 4 5.9 5.9 4 7.2 1.5 7.2-1.5 5.9-4 4-5.9 1.5-7.2-1.5-7.2-4-5.9-5.9-4-7.2-1.5z m0-1.4q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z m-8.9 18.6q0.3 0 0.3 0.3v10.7q0 0.4-0.3 0.4h-0.7q-0.4 0-0.4-0.4v-10.7q0-0.3 0.4-0.3h0.7z m8.9 1.4q1.2 0 2 0.8t0.9 2.1q0 0.7-0.4 1.4t-1.1 1v2.6q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-2.6q-0.7-0.4-1.1-1t-0.4-1.4q0-1.2 0.9-2.1t2-0.8z m0-17.1q4.7 0 8.6 2.3t6.2 6.2 2.3 8.6-2.3 8.6-6.2 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m-7.9 10.7v2.1q0 0.3 0.2 0.5t0.6 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5v-2.1q0-2.1 1.5-3.6t3.5-1.4 3.5 1.4 1.5 3.6v2.1q0 0.3 0.2 0.5t0.5 0.2h1.4q0.4 0 0.6-0.2t0.2-0.5v-2.1q0-3.3-2.3-5.6t-5.6-2.3-5.6 2.3-2.3 5.6z m19.3 16.4v-11.4q0-0.6-0.4-1t-1-0.5h-20q-0.6 0-1 0.5t-0.4 1v11.4q0 0.6 0.4 1t1 0.4h20q0.6 0 1-0.4t0.4-1z' })
	        )
	    );
	};
	
	exports.default = FaExpeditedssl;
	module.exports = exports['default'];

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExternalLinkSquare = function FaExternalLinkSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 20.7v-10.7q0-0.6-0.5-1t-1-0.4h-10.7q-0.9 0-1.3 0.8-0.4 1 0.3 1.6l3.2 3.2-11.9 11.9q-0.4 0.5-0.4 1t0.4 1l2.3 2.3q0.4 0.4 1 0.4t1-0.4l11.9-11.9 3.2 3.2q0.4 0.4 1 0.4 0.3 0 0.6-0.1 0.9-0.3 0.9-1.3z m5.7-11.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaExternalLinkSquare;
	module.exports = exports['default'];

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaExternalLink = function FaExternalLink(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 20.7v7.2q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h15.7q0.4 0 0.6 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.6 0.2h-15.7q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-7.2q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m8.6-19.3v11.5q0 0.5-0.4 1t-1 0.4-1-0.4l-4-4-14.5 14.6q-0.2 0.2-0.5 0.2t-0.5-0.2l-2.6-2.6q-0.2-0.2-0.2-0.5t0.2-0.5l14.6-14.5-4-4q-0.4-0.4-0.4-1t0.4-1 1-0.4h11.5q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaExternalLink;
	module.exports = exports['default'];

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEyeSlash = function FaEyeSlash(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.4 29.8l1.7-3.1q-1.9-1.5-3-3.6t-1.1-4.5q0-2.7 1.4-5-5.2 2.6-8.5 7.8 3.7 5.8 9.5 8.4z m8.7-16.9q0-0.5-0.3-0.8t-0.8-0.3q-2.8 0-4.8 2t-2 4.8q0 0.4 0.3 0.7t0.8 0.3 0.7-0.3 0.4-0.7q0-1.9 1.3-3.3t3.3-1.4q0.4 0 0.8-0.3t0.3-0.7z m8.1-4.3q0 0.2 0 0.2-2.4 4.2-7.1 12.6t-7 12.7l-1.1 2q-0.2 0.3-0.7 0.3-0.2 0-2.9-1.5-0.4-0.3-0.4-0.7 0-0.2 1-1.9-3.2-1.5-5.9-3.9t-4.7-5.4q-0.4-0.7-0.4-1.6t0.4-1.5q3.5-5.3 8.5-8.3t11.1-3q2 0 4 0.4l1.2-2.2q0.2-0.4 0.6-0.4 0.2 0 0.4 0.2t0.7 0.3 0.8 0.4 0.7 0.4 0.4 0.3q0.4 0.2 0.4 0.6z m0.8 10q0 3.1-1.8 5.6t-4.6 3.7l6.2-11.2q0.2 1 0.2 1.9z m10 2.8q0 0.8-0.4 1.6-0.9 1.4-2.5 3.2-3.3 3.8-7.7 6t-9.4 2.1l1.7-3q4.7-0.4 8.7-3t6.7-6.9q-2.5-4-6.3-6.5l1.5-2.5q2.1 1.4 4 3.4t3.3 4.1q0.4 0.7 0.4 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEyeSlash;
	module.exports = exports['default'];

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEye = function FaEye(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.1 21.4q-3.3-5.2-8.5-7.8 1.4 2.3 1.4 5 0 4.1-2.9 7t-7.1 3-7.1-3-2.9-7q0-2.7 1.4-5.1-5.1 2.7-8.5 7.9 2.9 4.6 7.4 7.3t9.7 2.7 9.7-2.7 7.4-7.3z m-16-8.5q0-0.5-0.3-0.8t-0.8-0.3q-2.8 0-4.8 2t-2 4.8q0 0.4 0.3 0.7t0.8 0.3 0.7-0.3 0.4-0.7q0-2 1.3-3.3t3.3-1.4q0.4 0 0.8-0.3t0.3-0.7z m18.9 8.5q0 0.8-0.4 1.6-3.2 5.1-8.4 8.2t-11.2 3.1-11.2-3.1-8.4-8.2q-0.4-0.8-0.4-1.6t0.4-1.5q3.2-5.1 8.4-8.2t11.2-3.1 11.1 3.1 8.5 8.2q0.4 0.8 0.4 1.5z' })
	        )
	    );
	};
	
	exports.default = FaEye;
	module.exports = exports['default'];

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaEyedropper = function FaEyedropper(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.9 2.1q2.1 2.1 2.1 5.1t-2.1 5l-5 5 2.3 2.3q0.2 0.2 0.2 0.5t-0.2 0.5l-4.7 4.7q-0.2 0.2-0.5 0.2t-0.5-0.2l-2.4-2.3-13.4 13.4q-0.8 0.8-2 0.8h-4.6l-5.7 2.9-1.4-1.4 2.9-5.7v-4.6q0-1.2 0.8-2l13.4-13.4-2.3-2.4q-0.2-0.2-0.2-0.5t0.2-0.5l4.7-4.7q0.2-0.2 0.5-0.2t0.5 0.2l2.3 2.3 5-5q2.1-2.1 5-2.1t5.1 2.1z m-26.5 30.8l12.9-12.9-4.3-4.3-12.9 12.9v4.3h4.3z' })
	        )
	    );
	};
	
	exports.default = FaEyedropper;
	module.exports = exports['default'];

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebookOfficial = function FaFacebookOfficial(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.4 2.9q0.8 0 1.3 0.5t0.6 1.4v30.4q0 0.8-0.6 1.4t-1.3 0.5h-8.7v-13.2h4.4l0.7-5.2h-5.1v-3.3q0-1.3 0.5-1.9t2-0.6l2.7 0v-4.7q-1.4-0.2-3.9-0.2-3.1 0-4.9 1.8t-1.8 5.1v3.8h-4.5v5.2h4.5v13.2h-16.4q-0.8 0-1.3-0.5t-0.6-1.4v-30.4q0-0.8 0.6-1.4t1.3-0.5h30.5z' })
	        )
	    );
	};
	
	exports.default = FaFacebookOfficial;
	module.exports = exports['default'];

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebookSquare = function FaFacebookSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-4.2v-13.2h4.4l0.7-5.2h-5.1v-3.3q0-1.3 0.5-1.9t2-0.6l2.8 0v-4.7q-1.5-0.2-4-0.2-3.1 0-4.9 1.8t-1.8 5.1v3.8h-4.5v5.2h4.5v13.2h-11.9q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z' })
	        )
	    );
	};
	
	exports.default = FaFacebookSquare;
	module.exports = exports['default'];

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFacebook = function FaFacebook(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 0.3v5.9h-3.5q-1.9 0-2.6 0.8t-0.7 2.4v4.2h6.6l-0.9 6.6h-5.7v16.9h-6.8v-16.9h-5.7v-6.6h5.7v-4.9q0-4.1 2.3-6.4t6.2-2.3q3.3 0 5.1 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFacebook;
	module.exports = exports['default'];

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFastBackward = function FaFastBackward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39 3.1q0.4-0.4 0.7-0.2t0.3 0.7v32.8q0 0.6-0.3 0.7t-0.7-0.2l-15.9-15.9q-0.2-0.2-0.2-0.4v15.8q0 0.6-0.3 0.7t-0.7-0.2l-15.9-15.9q-0.2-0.2-0.3-0.4v15.1q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v15.1q0.1-0.2 0.3-0.4l15.9-15.9q0.4-0.4 0.7-0.2t0.3 0.7v15.8q0-0.2 0.2-0.4z' })
	        )
	    );
	};
	
	exports.default = FaFastBackward;
	module.exports = exports['default'];

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFastForward = function FaFastForward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm1 36.9q-0.4 0.4-0.7 0.2t-0.3-0.7v-32.8q0-0.6 0.3-0.7t0.7 0.2l15.9 15.9q0.1 0.2 0.2 0.4v-15.8q0-0.6 0.3-0.7t0.7 0.2l15.9 15.9q0.2 0.2 0.3 0.4v-15.1q0-0.6 0.4-1t1-0.4h2.9q0.5 0 1 0.4t0.4 1v31.4q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-15.1q-0.1 0.2-0.3 0.4l-15.9 15.9q-0.4 0.4-0.7 0.2t-0.3-0.7v-15.8q-0.1 0.2-0.2 0.4z' })
	        )
	    );
	};
	
	exports.default = FaFastForward;
	module.exports = exports['default'];

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFax = function FaFax(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm6.4 8.6q1.5 0 2.5 1t1.1 2.5v24.3q0 1.5-1.1 2.5t-2.5 1.1h-2.8q-1.5 0-2.5-1t-1.1-2.6v-24.3q0-1.4 1.1-2.5t2.5-1h2.8z m30.7 3.6q1.3 0.8 2.1 2.1t0.8 2.8v17.2q0 2.4-1.7 4t-4 1.7h-19.3q-1.5 0-2.5-1t-1.1-2.6v-34.3q0-0.9 0.7-1.5t1.5-0.6h15q0.9 0 1.9 0.4t1.7 1.1l3.4 3.4q0.7 0.6 1.1 1.7t0.4 2v3.6z m-16.4 22.1v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.9q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.9q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.9q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.9q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.9q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.9q0.3 0 0.5-0.2t0.2-0.5z m5.7 11.4v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.4 0-0.6 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.6 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.4 0-0.6 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.6 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.4 0-0.6 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.6 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m5.7 11.4v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-2.9q0-0.3-0.2-0.5t-0.5-0.2h-2.8q-0.3 0-0.5 0.2t-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2h2.8q0.3 0 0.5-0.2t0.2-0.5z m2.2-8.6v-5.7h-3.6q-0.9 0-1.5-0.7t-0.6-1.5v-3.5h-14.3v11.4h20z' })
	        )
	    );
	};
	
	exports.default = FaFax;
	module.exports = exports['default'];

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFeed = function FaFeed(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 30q0 1.8-1.3 3t-3 1.3-3.1-1.3-1.2-3 1.3-3 3-1.3 3 1.3 1.3 3z m11.4 2.7q0 0.7-0.4 1.1-0.4 0.5-1 0.5h-3q-0.6 0-1-0.4t-0.4-0.9q-0.5-5.1-4.2-8.7t-8.7-4.2q-0.6 0-0.9-0.4t-0.4-1v-3q0-0.6 0.5-1 0.3-0.4 0.9-0.4h0.1q3.6 0.3 6.9 1.8t5.8 4q2.5 2.6 4 5.8t1.8 6.8z m11.4 0.1q0.1 0.6-0.4 1-0.4 0.5-1 0.5h-3.2q-0.6 0-1-0.4t-0.4-1q-0.3-4.8-2.3-9.1t-5.1-7.5-7.5-5.1-9.2-2.3q-0.5 0-0.9-0.5t-0.4-0.9v-3.2q0-0.6 0.4-1 0.5-0.4 1-0.4h0.1q5.8 0.2 11.2 2.6t9.5 6.6q4.2 4.1 6.6 9.5t2.6 11.2z' })
	        )
	    );
	};
	
	exports.default = FaFeed;
	module.exports = exports['default'];

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFemale = function FaFemale(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.1 23.6q0 0.9-0.7 1.5t-1.5 0.6q-1.1 0-1.8-0.9l-5-7.7h-1v3l5.5 9.2q0.2 0.3 0.2 0.7 0 0.6-0.4 1t-1 0.4h-4.3v6.1q0 1-0.8 1.8t-1.7 0.7h-3.6q-1 0-1.8-0.7t-0.7-1.8v-6.1h-4.3q-0.6 0-1-0.4t-0.4-1q0-0.4 0.2-0.7l5.5-9.2v-3h-1l-5.1 7.7q-0.6 0.9-1.8 0.9-0.8 0-1.5-0.6t-0.6-1.5q0-0.7 0.4-1.2l5.7-8.6q1.6-2.4 3.9-2.4h8.6q2.3 0 3.9 2.4l5.7 8.6q0.4 0.5 0.4 1.2z m-9.3-17.9q0 2.1-1.5 3.6t-3.5 1.4-3.6-1.4-1.4-3.6 1.4-3.5 3.6-1.5 3.5 1.5 1.5 3.5z' })
	        )
	    );
	};
	
	exports.default = FaFemale;
	module.exports = exports['default'];

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFighterJet = function FaFighterJet(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.9 21.3q-0.1 0.7-6 2l-7.3 0.7-4.7 1.3h-1.3l-6.1 7.3h1.4q0.6 0 1 0.1t0.4 0.3-0.4 0.2-1 0.1h-6.6v-0.7h1.3v-8.6h-3.3l-4 4.6h-2l-0.6-0.6v-4h0.6v-0.7h2.7v-0.1l-4-0.5v-2.7l4-0.5v-0.2h-2.7v-0.6h-0.6v-4l0.6-0.7h2l4 4.7h3.3v-8.7h-1.3v-0.6h6.6q0.6 0 1 0.1t0.4 0.2-0.4 0.2-1 0.1h-1.4l6.1 7.3h1.3l4.7 1.4 7.3 0.6q5.4 1.2 5.9 2z' })
	        )
	    );
	};
	
	exports.default = FaFighterJet;
	module.exports = exports['default'];

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileArchiveO = function FaFileArchiveO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.3 8.6v-2.9h-2.9v2.9h2.9z m2.8 2.8v-2.8h-2.8v2.8h2.8z m-2.8 2.9v-2.9h-2.9v2.9h2.9z m2.8 2.8v-2.8h-2.8v2.8h2.8z m15.7-8.6q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-2.9v2.8h-2.8v-2.8h-11.4v34.2h28.5z m-14-16l2.4 7.7q0.2 0.6 0.2 1.2 0 1.9-1.6 3.1t-4.1 1.2-4.1-1.2-1.6-3.1q0-0.6 0.2-1.2 0.4-1.4 2.6-8.8v-2.9h2.9v2.9h1.7q0.5 0 0.9 0.3t0.5 0.8z m-3.1 10.3q1.2 0 2-0.4t0.8-1-0.8-1-2-0.4-2 0.4-0.9 1 0.9 1 2 0.4z' })
	        )
	    );
	};
	
	exports.default = FaFileArchiveO;
	module.exports = exports['default'];

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileAudioO = function FaFileAudioO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-17.6-18.1q0.5 0.2 0.5 0.6v12.2q0 0.5-0.5 0.7-0.1 0-0.2 0-0.3 0-0.5-0.2l-3.7-3.7h-3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h3l3.7-3.8q0.3-0.3 0.7-0.1z m9.3 15.4q0.7 0 1.2-0.6 2.8-3.5 2.8-8.1t-2.8-8.1q-0.4-0.5-1-0.5t-1 0.3q-0.5 0.4-0.6 1t0.4 1q2.2 2.8 2.2 6.3t-2.2 6.3q-0.4 0.5-0.4 1.1t0.6 0.9q0.4 0.4 0.8 0.4z m-4.7-3.4q0.6 0 1.1-0.4 1.9-2.1 1.9-4.9t-1.9-4.9q-0.4-0.4-1-0.4t-1 0.4-0.5 1 0.4 1q1.2 1.3 1.2 2.9t-1.2 2.9q-0.4 0.5-0.4 1.1t0.5 1q0.4 0.4 0.9 0.4z' })
	        )
	    );
	};
	
	exports.default = FaFileAudioO;
	module.exports = exports['default'];

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileCodeO = function FaFileCodeO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-20.7-20q0.2-0.2 0.5-0.2t0.5 0.1l1.2 0.9q0.2 0.1 0.2 0.4t-0.1 0.6l-4.1 5.4 4.1 5.4q0.2 0.3 0.1 0.5t-0.2 0.5l-1.2 0.9q-0.2 0.1-0.5 0.1t-0.5-0.3l-5-6.7q-0.3-0.4 0-0.8z m17.9 6.8q0.3 0.4 0 0.8l-5 6.7q-0.2 0.3-0.5 0.3t-0.5-0.1l-1.2-0.9q-0.2-0.2-0.3-0.5t0.2-0.5l4.1-5.4-4.1-5.4q-0.2-0.3-0.2-0.6t0.3-0.4l1.2-0.9q0.2-0.2 0.5-0.1t0.5 0.2z m-13.8 10.3q-0.3-0.1-0.5-0.3t-0.1-0.6l3.1-18.5q0-0.3 0.3-0.5t0.5-0.1l1.4 0.2q0.3 0.1 0.5 0.3t0.1 0.5l-3.1 18.6q0 0.3-0.3 0.5t-0.5 0.1z' })
	        )
	    );
	};
	
	exports.default = FaFileCodeO;
	module.exports = exports['default'];

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileExcelO = function FaFileExcelO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-21.8-5.2v2.4h6.2v-2.4h-1.6l2.3-3.6q0.1-0.1 0.2-0.3t0.2-0.3 0-0.1h0.1q0 0.1 0.1 0.2 0 0.1 0.1 0.2t0.1 0.1 0.2 0.2l2.4 3.6h-1.7v2.4h6.5v-2.4h-1.6l-4.2-6.1 4.3-6.3h1.5v-2.4h-6.2v2.4h1.6l-2.3 3.6q-0.1 0.1-0.2 0.3t-0.2 0.3l0 0.1h-0.1q0-0.1-0.1-0.2-0.1-0.3-0.4-0.5l-2.3-3.6h1.7v-2.4h-6.5v2.4h1.5l4.2 6.1-4.3 6.3h-1.5z' })
	        )
	    );
	};
	
	exports.default = FaFileExcelO;
	module.exports = exports['default'];

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileImageO = function FaFileImageO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-2.8-10v7.2h-22.9v-4.3l4.3-4.3 2.9 2.9 8.5-8.6z m-18.6-4.2q-1.8 0-3-1.3t-1.3-3 1.3-3.1 3-1.2 3 1.2 1.3 3.1-1.3 3-3 1.3z' })
	        )
	    );
	};
	
	exports.default = FaFileImageO;
	module.exports = exports['default'];

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileMovieO = function FaFileMovieO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-14.3-20q1.2 0 2.1 0.9t0.8 2v8.6q0 1.1-0.8 2t-2.1 0.8h-8.5q-1.2 0-2-0.8t-0.9-2v-8.6q0-1.2 0.9-2t2-0.9h8.5z m11 0.1q0.5 0.2 0.5 0.7v12.8q0 0.5-0.5 0.7-0.2 0-0.2 0-0.4 0-0.6-0.2l-5.9-5.9v-2l5.9-6q0.2-0.2 0.6-0.2 0 0 0.2 0.1z' })
	        )
	    );
	};
	
	exports.default = FaFileMovieO;
	module.exports = exports['default'];

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileO = function FaFileO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z' })
	        )
	    );
	};
	
	exports.default = FaFileO;
	module.exports = exports['default'];

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFilePdfO = function FaFilePdfO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-11.4-13.2q0.7 0.6 1.8 1.3 1.3-0.2 2.6-0.2 3.3 0 4 1.1 0.4 0.5 0 1.2 0 0 0 0l0 0v0.1q-0.2 0.8-1.6 0.8-1.1 0-2.6-0.4t-2.9-1.2q-4.9 0.5-8.7 1.8-3.4 5.9-5.4 5.9-0.4 0-0.7-0.2l-0.5-0.2q0-0.1-0.1-0.2-0.3-0.2-0.2-0.8 0.2-0.8 1.3-2t2.9-2.1q0.3-0.2 0.5 0.1 0.1 0 0.1 0.1 1.1-1.9 2.4-4.4 1.5-3.1 2.3-5.9-0.5-1.8-0.7-3.5t0.2-2.9q0.2-0.9 0.9-0.9h0.5q0.5 0 0.8 0.4 0.4 0.4 0.2 1.5-0.1 0.1-0.1 0.2 0 0 0 0.1v0.7q0 2.8-0.3 4.3 1.2 3.7 3.3 5.3z m-12.9 9.2q1.2-0.6 3.1-3.5-1.2 0.8-2 1.8t-1.1 1.7z m8.9-20.6q-0.4 1-0.1 3 0.1-0.2 0.2-1 0-0.1 0.1-0.9 0.1-0.1 0.1-0.2 0-0.1 0-0.1t0 0 0 0q0-0.5-0.3-0.8 0 0 0 0v0z m-2.8 14.8q3-1.2 6.4-1.8-0.1 0-0.3-0.2t-0.4-0.3q-1.7-1.5-2.8-4-0.6 2-1.9 4.4-0.7 1.3-1 1.9z m14.4-0.4q-0.5-0.5-3.1-0.5 1.7 0.6 2.8 0.6 0.3 0 0.4 0 0 0-0.1-0.1z' })
	        )
	    );
	};
	
	exports.default = FaFilePdfO;
	module.exports = exports['default'];

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFilePowerpointO = function FaFilePowerpointO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-22.1-5.2v2.4h7.3v-2.4h-2.1v-3.7h3.1q1.7 0 2.6-0.3 1.5-0.6 2.4-2t0.9-3.2q0-1.9-0.9-3.2t-2.2-1.9q-1.1-0.5-2.9-0.5h-8.2v2.4h2v12.4h-2z m7.9-6.2h-2.7v-6h2.7q1.1 0 1.8 0.4 1.3 0.7 1.3 2.6 0 1.9-1.4 2.6-0.7 0.4-1.7 0.4z' })
	        )
	    );
	};
	
	exports.default = FaFilePowerpointO;
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileTextO = function FaFileTextO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-22.8-19.2q0-0.4 0.2-0.6t0.5-0.2h15.7q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4z m16.4 5q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h15.7z m0 5.7q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h15.7z' })
	        )
	    );
	};
	
	exports.default = FaFileTextO;
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileText = function FaFileText(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 10.6q0.3 0.3 0.6 0.8h-10.5v-10.5q0.4 0.3 0.8 0.6z m-10.7 3.7h12.2v23.6q0 0.9-0.6 1.5t-1.6 0.6h-30q-0.8 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h17.9v12.1q0 0.9 0.6 1.6t1.5 0.6z m3.6 16.4v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z m0-5.7v-1.4q0-0.4-0.2-0.6t-0.5-0.2h-15.7q-0.3 0-0.5 0.2t-0.2 0.6v1.4q0 0.3 0.2 0.5t0.5 0.2h15.7q0.3 0 0.5-0.2t0.2-0.5z' })
	        )
	    );
	};
	
	exports.default = FaFileText;
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFileWordO = function FaFileWordO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 8.5q0.6 0.6 1 1.7t0.5 1.9v25.8q0 0.8-0.6 1.5t-1.6 0.6h-30q-0.9 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h20q0.9 0 2 0.4t1.7 1.1z m-9.9-5.5v8.4h8.4q-0.3-0.6-0.5-0.9l-7-7q-0.3-0.2-0.9-0.5z m8.5 34.1v-22.8h-9.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-17.1v34.2h28.5z m-26.2-20v2.4h1.6l3.6 14.8h3.6l2.8-10.8q0.2-0.5 0.3-1.1 0-0.3 0-0.5h0.1l0.1 0.5q0 0.1 0 0.5t0.2 0.6l2.8 10.8h3.6l3.6-14.8h1.6v-2.4h-6.7v2.4h2l-2.2 9.8q-0.1 0.5-0.2 1l0 0.5h-0.1l-0.1-0.5q0-0.1-0.1-0.4t-0.1-0.6l-3.2-12.2h-2.5l-3.2 12.2q-0.1 0.2-0.1 0.6t-0.1 0.4l-0.1 0.5h-0.1l0-0.5q-0.1-0.5-0.2-1l-2.2-9.8h2v-2.4h-6.7z' })
	        )
	    );
	};
	
	exports.default = FaFileWordO;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFile = function FaFile(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 11.4v-10.5q0.4 0.3 0.8 0.6l9.1 9.1q0.3 0.3 0.6 0.8h-10.5z m-2.9 0.7q0 0.9 0.6 1.6t1.5 0.6h12.2v23.6q0 0.9-0.6 1.5t-1.6 0.6h-30q-0.8 0-1.5-0.6t-0.6-1.5v-35.8q0-0.8 0.6-1.5t1.5-0.6h17.9v12.1z' })
	        )
	    );
	};
	
	exports.default = FaFile;
	module.exports = exports['default'];

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFilm = function FaFilm(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8 34.6v-2.6q0-0.6-0.4-1t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 1v2.6q0 0.6 0.4 1t0.9 0.3h2.6q0.6 0 1-0.3t0.4-1z m0-8v-2.6q0-0.6-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.6q0 0.6 0.4 1t0.9 0.4h2.6q0.6 0 1-0.4t0.4-1z m0-7.9v-2.7q0-0.5-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.6q0.6 0 1-0.4t0.4-0.9z m21.2 15.9v-10.6q0-0.6-0.4-0.9t-0.9-0.4h-15.9q-0.6 0-1 0.4t-0.4 0.9v10.6q0 0.6 0.4 1t1 0.3h15.9q0.5 0 0.9-0.3t0.4-1z m-21.2-23.9v-2.7q0-0.5-0.4-0.9t-1-0.4h-2.6q-0.6 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.6q0.6 0 1-0.4t0.4-0.9z m29.2 23.9v-2.6q0-0.6-0.4-1t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 1v2.6q0 0.6 0.4 1t0.9 0.3h2.7q0.5 0 0.9-0.3t0.4-1z m-8-15.9v-10.7q0-0.5-0.4-0.9t-0.9-0.4h-15.9q-0.6 0-1 0.4t-0.4 0.9v10.7q0 0.5 0.4 0.9t1 0.4h15.9q0.5 0 0.9-0.4t0.4-0.9z m8 7.9v-2.6q0-0.6-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.6q0 0.6 0.4 1t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-1z m0-7.9v-2.7q0-0.5-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-0.9z m0-8v-2.7q0-0.5-0.4-0.9t-0.9-0.4h-2.7q-0.5 0-0.9 0.4t-0.4 0.9v2.7q0 0.5 0.4 0.9t0.9 0.4h2.7q0.5 0 0.9-0.4t0.4-0.9z m2.7-3.3v27.9q0 1.4-1 2.3t-2.4 1h-33.2q-1.3 0-2.3-1t-1-2.3v-27.9q0-1.4 1-2.4t2.3-0.9h33.2q1.4 0 2.4 0.9t1 2.4z' })
	        )
	    );
	};
	
	exports.default = FaFilm;
	module.exports = exports['default'];

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFilter = function FaFilter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 6.6q0.4 0.9-0.3 1.5l-11 11.1v16.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-5.7-5.7q-0.5-0.4-0.5-1v-10.8l-11-11q-0.7-0.7-0.3-1.6 0.4-0.9 1.3-0.9h28.6q0.9 0 1.3 0.9z' })
	        )
	    );
	};
	
	exports.default = FaFilter;
	module.exports = exports['default'];

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFireExtinguisher = function FaFireExtinguisher(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.9 4.3q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m20-0.7v7.1q0 0.4-0.2 0.6-0.2 0.1-0.5 0.1-0.1 0-0.1 0l-10-2.1q-0.3-0.1-0.4-0.3t-0.2-0.4h-5.7v2.2q2.5 0.6 4.1 2.5t1.6 4.6v17.8q0 0.6-0.4 1t-1 0.4h-11.5q-0.5 0-1-0.4t-0.4-1v-17.8q0-2.4 1.4-4.3t3.6-2.6v-2.4h-0.7q-1.3 0-2.6 0.5t-2 1.2-1.5 1.5-0.9 1.2-0.3 0.5q-0.4 0.8-1.3 0.8-0.3 0-0.6-0.2-0.5-0.2-0.7-0.8t0.1-1.1q0.1-0.2 0.3-0.6t0.8-1.2 1.4-1.5 1.9-1.5 2.4-1.2q-0.6-0.9-0.6-1.9 0-1.5 1.1-2.5t2.5-1.1 2.5 1.1 1.1 2.5q0 0.7-0.3 1.4h6.7q0-0.2 0.2-0.4t0.4-0.3l10-2.1q0 0 0.1 0 0.3 0 0.5 0.1 0.2 0.2 0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaFireExtinguisher;
	module.exports = exports['default'];

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFire = function FaFire(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 37.9v1.4q0 0.3-0.2 0.5t-0.5 0.2h-30q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h30q0.3 0 0.5 0.3t0.2 0.5z m-5.7-23.6q0 1.7-0.5 3.2t-1.5 2.5-1.9 2-2.2 1.7-1.9 1.6-1.4 1.8-0.6 2.2q0 2.1 1.5 5l-0.1 0 0 0q-2-0.9-3.5-1.9t-3.1-2.2-2.6-2.7-1.6-3.4-0.6-4.1q0-1.7 0.6-3.2t1.4-2.5 1.9-2 2.2-1.7 1.9-1.6 1.5-1.8 0.5-2.2q0-2.1-1.5-5l0.1 0 0 0q2 0.9 3.6 1.9t3 2.2 2.6 2.7 1.6 3.4 0.6 4.1z' })
	        )
	    );
	};
	
	exports.default = FaFire;
	module.exports = exports['default'];

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFirefox = function FaFirefox(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.2 40q-6.4 0-11.3-3.4t-7.4-8.9q-1.3-2.9-1.5-6.7t0.6-7.4 2.5-7 4-5.4l-0.2 6.3q0.2-0.3 1.5-0.3t1.5 0.3q1-1.8 3.6-3.1t5.3-1.3q-1.3 1-2.7 3.3t-1.3 3.7q0.5 0.1 1.4 0.3t1.4 0.1 1.5 0.1 1.1 0.1q0.4 0.1 0.2 1t-0.6 1.7q-0.2 0.1-0.4 0.4t-1.3 0.8-2.2 0.8l0.3 4.2-3.1-1.5q-0.4 0.9-0.2 1.8t0.8 1.5 1.5 0.9 1.8 0.2q1.1-0.2 2.2-0.8t1.9-1 1.6-0.4q1.4 0.1 2 0.7t0.4 1.5q0 0 0 0.1t-0.2 0.3-0.4 0.3-0.7 0.3-1.1 0q-1.3 2.1-3.2 3t-4.7 0.7q1.7 1.3 3.7 1.8t3.7 0.1 3.5-1.1 2.8-2 1.8-2.3q1-2 0.9-4.3t-0.8-4.2-1.8-2.8q2 0.9 3.1 1.8t1.7 2.5q0.3-3.8-1.3-7.7t-4.7-6.3q6 1.7 9.2 6.2t3.4 11.6q0 2.8-0.9 5.7t-2.8 5.3-4.2 4.4-5.5 3-6.4 1.1z' })
	        )
	    );
	};
	
	exports.default = FaFirefox;
	module.exports = exports['default'];

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFlagCheckered = function FaFlagCheckered(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.1 22.3v-4.2q-3.9 0.3-8.3 2.5v4.1q4.4-2.1 8.3-2.4z m0-9.1v-4.3q-3.7 0.1-8.3 2.7v4.1q4.6-2.4 8.3-2.5z m18.1 10v-4q-5.1 2.6-8.3 1.6v-4.9q-0.5-0.1-0.9-0.3-0.1-0.1-0.7-0.4t-0.7-0.4-0.7-0.3-0.8-0.3-0.7-0.3-0.8-0.3-0.7-0.2-0.9-0.1-0.9-0.1-0.9-0.1q-0.5 0-1.1 0.1v4.8h0.4q2.3 0 4.2 0.7t4.3 1.8q0.4 0.2 0.9 0.3v4.1q0.9 0.3 2 0.3 2.6 0 6.3-2z m0-9.3v-4.1q-3.6 2-6.6 2-1 0-1.7-0.2v4.3q3.2 0.9 8.3-2z m-29.2-7.8q0 0.7-0.4 1.4t-1 1v27.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-27.5q-0.6-0.4-1-1t-0.4-1.4q0-1.2 0.8-2t2-0.8 2 0.8 0.8 2z m32 1.4v16.6q0 0.8-0.7 1.2-0.3 0.1-0.4 0.2-4.8 2.5-8 2.5-2 0-3.5-0.7l-0.6-0.3q-1.4-0.8-2.2-1.1t-1.9-0.6-2.5-0.3q-2.2 0-5.1 0.9t-5 2.3q-0.3 0.2-0.7 0.2-0.4 0-0.7-0.2-0.7-0.4-0.7-1.2v-16.2q0-0.8 0.6-1.2 0.8-0.4 1.8-0.9t2.4-1.1 3.4-1.1 3.3-0.4q2.5 0 4.6 0.6t4.5 1.9q0.9 0.4 2 0.4 2.6 0 6.7-2.4l0.7-0.4q0.7-0.3 1.4 0.1 0.6 0.4 0.6 1.2z' })
	        )
	    );
	};
	
	exports.default = FaFlagCheckered;
	module.exports = exports['default'];

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFlagO = function FaFlagO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.2 23.2v-13.4q-3.6 2-6.6 2-1.8 0-3.2-0.7-2.2-1.1-4-1.7t-3.9-0.6q-3.7 0-8.7 2.8v13.1q5.3-2.5 9.4-2.5 1.2 0 2.2 0.2t2.2 0.5 1.7 0.7 1.7 0.9l0.7 0.3q0.9 0.4 2.2 0.4 2.6 0 6.3-2z m-29.2-17.1q0 0.7-0.4 1.4t-1 1v27.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-27.5q-0.6-0.4-1-1t-0.4-1.4q0-1.2 0.8-2t2-0.8 2 0.8 0.8 2z m32 1.4v16.6q0 0.8-0.7 1.2-0.3 0.1-0.4 0.2-4.8 2.5-8 2.5-2 0-3.5-0.7l-0.6-0.3q-1.4-0.8-2.2-1.1t-1.9-0.6-2.5-0.3q-2.2 0-5.1 0.9t-5 2.3q-0.3 0.2-0.7 0.2-0.4 0-0.7-0.2-0.7-0.4-0.7-1.2v-16.2q0-0.8 0.6-1.2 0.8-0.4 1.8-0.9t2.4-1.1 3.4-1.1 3.3-0.4q2.5 0 4.6 0.6t4.5 1.9q0.9 0.4 2 0.4 2.6 0 6.7-2.4l0.7-0.4q0.7-0.3 1.4 0.1 0.6 0.4 0.6 1.2z' })
	        )
	    );
	};
	
	exports.default = FaFlagO;
	module.exports = exports['default'];

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFlag = function FaFlag(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm7 6.1q0 1.5-1.4 2.4v27.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-27.5q-1.4-0.9-1.4-2.4 0-1.2 0.8-2t2-0.8 2 0.8 0.8 2z m32 1.4v16.6q0 0.5-0.2 0.8t-0.9 0.6q-4.7 2.5-8 2.5-1.4 0-2.7-0.4t-2.4-1.1-2.5-1-3.1-0.5q-4.2 0-10.1 3.2-0.4 0.2-0.7 0.2-0.6 0-1-0.4t-0.4-1v-16.2q0-0.7 0.6-1.2 0.5-0.3 1.8-0.9 5.1-2.6 9.1-2.6 2.4 0 4.4 0.6t4.8 1.9q0.8 0.4 1.9 0.4 1.1 0 2.5-0.4t2.4-1.1 1.9-1 1.2-0.4q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaFlag;
	module.exports = exports['default'];

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFlask = function FaFlask(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.6 32.3q1.2 2 0.5 3.4t-3.2 1.4h-25.7q-2.4 0-3.1-1.4t0.5-3.4l11.2-17.7v-8.9h-1.4q-0.6 0-1-0.4t-0.5-1 0.5-1 1-0.4h11.4q0.6 0 1 0.4t0.4 1-0.4 1-1 0.4h-1.4v8.9z m-17.4-16.2l-6.1 9.6h15.9l-6.1-9.6-0.4-0.7v-9.7h-2.9v9.7z' })
	        )
	    );
	};
	
	exports.default = FaFlask;
	module.exports = exports['default'];

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFlickr = function FaFlickr(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z m-12.3 17.1q0-2-1.4-3.3t-3.4-1.4-3.3 1.4-1.4 3.3 1.4 3.3 3.3 1.4 3.4-1.4 1.4-3.3z m12.6 0q0-2-1.4-3.3t-3.4-1.4-3.3 1.4-1.4 3.3 1.4 3.3 3.3 1.4 3.4-1.4 1.4-3.3z' })
	        )
	    );
	};
	
	exports.default = FaFlickr;
	module.exports = exports['default'];

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFloppyO = function FaFloppyO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.6 34.3h17.1v-8.6h-17.1v8.6z m20 0h2.8v-20q0-0.3-0.2-0.9t-0.4-0.7l-6.3-6.3q-0.2-0.2-0.8-0.5t-0.8-0.2v9.3q0 0.9-0.7 1.5t-1.5 0.6h-12.8q-0.9 0-1.6-0.6t-0.6-1.5v-9.3h-2.8v28.6h2.8v-9.3q0-0.9 0.6-1.5t1.6-0.6h18.5q0.9 0 1.5 0.6t0.7 1.5v9.3z m-8.6-20.7v-7.2q0-0.3-0.2-0.5t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v7.2q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m14.3 0.7v20.7q0 0.9-0.6 1.5t-1.6 0.6h-30q-0.8 0-1.5-0.6t-0.6-1.5v-30q0-0.9 0.6-1.5t1.5-0.6h20.8q0.9 0 1.9 0.4t1.7 1.1l6.3 6.2q0.6 0.6 1 1.7t0.5 2z' })
	        )
	    );
	};
	
	exports.default = FaFloppyO;
	module.exports = exports['default'];

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFolderO = function FaFolderO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 29.3v-15.7q0-0.9-0.6-1.5t-1.6-0.7h-15.7q-0.9 0-1.5-0.6t-0.6-1.5v-1.4q0-0.9-0.6-1.6t-1.6-0.6h-7.1q-0.9 0-1.5 0.6t-0.6 1.6v21.4q0 0.9 0.6 1.5t1.5 0.6h27.1q0.9 0 1.6-0.6t0.6-1.5z m2.8-15.7v15.7q0 2-1.4 3.5t-3.6 1.5h-27.1q-2.1 0-3.5-1.5t-1.5-3.5v-21.4q0-2.1 1.5-3.6t3.5-1.4h7.1q2.1 0 3.6 1.4t1.4 3.6v0.7h15q2.1 0 3.6 1.4t1.4 3.6z' })
	        )
	    );
	};
	
	exports.default = FaFolderO;
	module.exports = exports['default'];

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFolderOpenO = function FaFolderOpenO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37 20.7q0-0.7-1.1-0.7h-22.6q-0.8 0-1.8 0.4t-1.5 1.1l-6.1 7.6q-0.3 0.5-0.3 0.8 0 0.7 1.1 0.7h22.5q0.9 0 1.8-0.4t1.5-1.1l6.1-7.6q0.4-0.4 0.4-0.8z m-23.7-3.4h15.9v-3.3q0-0.8-0.5-1.4t-1.5-0.6h-11.9q-0.8 0-1.4-0.6t-0.6-1.4v-1.3q0-0.8-0.6-1.4t-1.4-0.6h-6.6q-0.9 0-1.5 0.6t-0.5 1.4v17.7l5.3-6.5q0.9-1.1 2.4-1.8t2.9-0.8z m26.3 3.4q0 1.3-0.9 2.5l-6.1 7.6q-0.9 1.1-2.5 1.8t-2.9 0.7h-22.5q-2 0-3.3-1.4t-1.4-3.3v-19.9q0-1.9 1.4-3.3t3.3-1.3h6.6q1.9 0 3.3 1.3t1.3 3.3v0.7h11.3q2 0 3.3 1.3t1.4 3.3v3.3h4q1.1 0 2 0.6t1.4 1.4q0.3 0.7 0.3 1.4z' })
	        )
	    );
	};
	
	exports.default = FaFolderOpenO;
	module.exports = exports['default'];

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFolderOpen = function FaFolderOpen(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.9 21.2q0 0.6-0.6 1.4l-7.2 8.4q-0.9 1.1-2.5 1.9t-3.1 0.7h-23.1q-0.7 0-1.3-0.3t-0.5-0.9q0-0.6 0.6-1.4l7.2-8.4q0.9-1.1 2.5-1.8t3.1-0.8h23.1q0.7 0 1.3 0.3t0.5 0.9z m-7.2-7.3v3.4h-17.7q-2 0-4.2 1t-3.5 2.5l-7.3 8.6q0-0.1 0-0.3t0-0.3v-20.4q0-1.9 1.4-3.3t3.4-1.4h6.8q1.9 0 3.3 1.4t1.4 3.3v0.7h11.6q1.9 0 3.4 1.4t1.4 3.4z' })
	        )
	    );
	};
	
	exports.default = FaFolderOpen;
	module.exports = exports['default'];

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFolder = function FaFolder(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 13.6v15.7q0 2-1.4 3.5t-3.6 1.5h-27.1q-2.1 0-3.5-1.5t-1.5-3.5v-21.4q0-2.1 1.5-3.6t3.5-1.4h7.1q2.1 0 3.6 1.4t1.4 3.6v0.7h15q2.1 0 3.6 1.4t1.4 3.6z' })
	        )
	    );
	};
	
	exports.default = FaFolder;
	module.exports = exports['default'];

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFont = function FaFont(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.7 12.5l-3.8 10q0.7 0 3 0.1t3.6 0q0.4 0 1.3 0-2-5.7-4.1-10.1z m-16.2 24.6l0-1.7q0.6-0.2 1.3-0.3t1.3-0.2 1.1-0.4 1-0.6 0.7-1.1l5.2-13.8 6.3-16.1h2.9q0.1 0.3 0.2 0.4l4.6 10.7q0.7 1.8 2.3 5.8t2.6 6.1q0.3 0.8 1.3 3.2t1.6 3.8q0.4 1 0.8 1.3 0.4 0.3 1.9 0.6t1.9 0.5q0.1 0.8 0.1 1.3 0 0.1 0 0.3t0 0.2q-1.4 0-4.2-0.1t-4.3-0.2q-1.7 0-4.8 0.1t-4 0.2q0-0.9 0.1-1.7l3-0.6q0 0 0.2-0.1t0.4-0.1 0.3-0.1 0.3-0.1 0.3-0.2 0.2-0.3 0-0.3q0-0.3-0.6-2.1t-1.7-4-0.9-2.2l-10-0.1q-0.6 1.3-1.7 4.4t-1.2 3.6q0 0.5 0.3 0.9t1 0.5 1.1 0.3 1.3 0.2 0.9 0.1q0 0.4 0 1.3 0 0.2 0 0.6-1.3 0-3.9-0.2t-3.9-0.3q-0.2 0-0.6 0.1t-0.5 0.1q-1.8 0.3-4.2 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFont;
	module.exports = exports['default'];

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFonticons = function FaFonticons(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3 2.9h34.3v34.2h-34.3v-34.2z m20.3 7.1l-0.3 0.7 1.7 1.9-0.7 2.5 0.5 0.6 2.4-1.3 2.4 1.3 0.6-0.6-0.7-2.5 1.7-1.9-0.3-0.7h-2.1l-1.2-2.1h-0.7l-1.2 2.1h-2.1z m-6 3.6q0.7 0 1 0.4t0.3 1.4l3.8-0.5q0-1.2-0.3-2t-1.2-1.3-1.5-0.6-1.9-0.1q-3 0-4.5 1.3t-1.4 4.1v1.6h-2.2v2.8h1.7q0.5 0 0.5 0.2v8.5q0 0.3-0.1 0.5t-0.4 0.1l-1.7 0.2v1.9h10v-1.9l-3.3-0.3q-0.1 0-0.2 0t-0.1-0.1 0-0.1 0-0.1 0.1-0.2v-8.7h4.2l0.9-2.8h-5.2q-0.1 0 0-0.2t0.1-0.2v-1.8q0-0.6 0-0.9t0.2-0.6 0.4-0.4 0.8-0.2z m13.6 18.5v-1.9l-1.2-0.2q-0.2 0-0.3 0t0-0.1 0-0.2 0-0.2v-11.6h-6.1l-0.5 2.2 1.8 0.5q0.5 0.2 0.5 0.6v8.3q0 0.3-0.1 0.4t-0.4 0.1l-1.6 0.2v1.9h7.9z' })
	        )
	    );
	};
	
	exports.default = FaFonticons;
	module.exports = exports['default'];

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFortAwesome = function FaFortAwesome(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.8 22.5v-5q0-0.4-0.4-0.4h-2.1q-0.4 0-0.4 0.4v5q0 0.4 0.4 0.4h2.1q0.4 0 0.4-0.4z m11.4 0v-5q0-0.4-0.3-0.4h-2.2q-0.3 0-0.3 0.4v5q0 0.4 0.3 0.4h2.2q0.3 0 0.3-0.4z m11.4 0.7v16.8h-14.2v-7.1q0-1.8-1.3-3.1t-3-1.2-3.1 1.2-1.2 3.1v7.1h-14.3v-16.8q0-0.3 0.4-0.3h2.1q0.4 0 0.4 0.3v2.5h2.8v-13.9q0-0.4 0.4-0.4h2.1q0.4 0 0.4 0.4v2.5h2.8v-2.5q0-0.4 0.4-0.4h2.1q0.4 0 0.4 0.4v2.5h2.8v-2.5q0-0.4 0.4-0.4h0.4v-8.7q-0.8-0.5-0.8-1.3 0-0.6 0.5-1t1-0.4 1 0.4 0.4 1q0 0.8-0.7 1.3v0.2h6.1q0.3 0 0.3 0.3v5q0 0.4-0.3 0.4h-6.1v2.8h0.3q0.4 0 0.4 0.4v2.5h2.9v-2.5q0-0.4 0.3-0.4h2.2q0.3 0 0.3 0.4v2.5h2.9v-2.5q0-0.4 0.3-0.4h2.2q0.3 0 0.3 0.4v13.9h2.9v-2.5q0-0.3 0.3-0.3h2.2q0.3 0 0.3 0.3z' })
	        )
	    );
	};
	
	exports.default = FaFortAwesome;
	module.exports = exports['default'];

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaForumbee = function FaForumbee(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.8 3.3q-7 2.7-12.4 8.1t-8 12.5q-0.4-1.9-0.4-3.9 0-4.6 2.3-8.6t6.2-6.2 8.6-2.3q1.8 0 3.7 0.4z m6.1 2.7q2 1.5 3.6 3.5-8.7 2.5-15 8.9t-8.9 15.1q-2.1-1.6-3.5-3.6 2.5-8.6 8.9-15t14.9-8.9z m-16.4 29.8q2.6-8 8.5-13.9t13.8-8.6q0.9 2.1 1.2 4.4-6.5 2.7-11.5 7.7t-7.7 11.5q-2.3-0.3-4.3-1.1z m23.8 1.3q-4.3-1.1-8.2-2.6-3 1.9-6.5 2.4 2.5-4.6 6.1-8.3t8.3-6.1q-0.5 3.4-2.3 6.3 1.5 3.9 2.6 8.3z' })
	        )
	    );
	};
	
	exports.default = FaForumbee;
	module.exports = exports['default'];

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaForward = function FaForward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4 36.9q-0.4 0.4-0.7 0.2t-0.3-0.7v-32.8q0-0.6 0.3-0.7t0.7 0.2l15.9 15.9q0.1 0.2 0.2 0.4v-15.8q0-0.6 0.3-0.7t0.7 0.2l15.9 15.9q0.4 0.4 0.4 1t-0.4 1l-15.9 15.9q-0.4 0.4-0.7 0.2t-0.3-0.7v-15.8q-0.1 0.2-0.2 0.4z' })
	        )
	    );
	};
	
	exports.default = FaForward;
	module.exports = exports['default'];

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFoursquare = function FaFoursquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.8 9.7l0.8-4.3q0.2-0.6-0.2-0.9t-0.7-0.4h-15.9q-0.5 0-0.9 0.4t-0.3 0.8v24.6q0 0.1 0.1 0l6.5-7.9q0.5-0.5 0.8-0.7t1.1-0.2h5.4q0.4 0 0.8-0.3t0.4-0.7q0.5-2.9 0.8-4.2 0.1-0.5-0.3-0.9t-0.8-0.4h-6.5q-0.7 0-1.1-0.5t-0.4-1v-1q0-0.6 0.4-1t1.1-0.5h7.7q0.4 0 0.8-0.3t0.4-0.6z m5.1-5q-0.3 1.7-1.2 6t-1.6 7.8-0.7 3.9q-0.2 0.5-0.2 0.7t-0.4 0.7-0.5 0.8-0.9 0.4-1.3 0.2h-6q-0.3 0-0.5 0.3-0.2 0.2-9.5 11-0.5 0.6-1.3 0.6t-1.1-0.1q-1.2-0.5-1.2-2.2v-31.4q0-1.3 0.8-2.3t2.7-1.1h19.8q2.1 0 2.9 1.2t0.2 3.5z m0 0l-3.5 17.7q0-0.4 0.7-3.9t1.6-7.8 1.2-6z' })
	        )
	    );
	};
	
	exports.default = FaFoursquare;
	module.exports = exports['default'];

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFrownO = function FaFrownO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.3 27.4q0.2 0.6-0.1 1.1t-0.8 0.7-1.1-0.1-0.7-0.8q-0.6-1.8-2.1-2.9t-3.4-1.1-3.3 1.1-2.1 2.9q-0.2 0.6-0.7 0.8t-1.1 0.1q-0.6-0.2-0.8-0.7t-0.1-1.1q0.8-2.7 3.1-4.3t5-1.7 5.1 1.7 3.1 4.3z m-11-13.1q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m11.4 0q0 1.2-0.8 2t-2 0.8-2.1-0.8-0.8-2 0.8-2 2.1-0.9 2 0.9 0.8 2z m5.7 5.7q0-2.9-1.1-5.5t-3.1-4.6-4.5-3.1-5.6-1.1-5.5 1.1-4.6 3.1-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5z m2.9 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaFrownO;
	module.exports = exports['default'];

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaFutbolO = function FaFutbolO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.6 18.2l6.4-4.6 6.4 4.6-2.4 7.5h-7.9z m6.4-18.2q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z m13.8 30.1q3.3-4.5 3.3-10.1v-0.1l-2.2 2-5.4-5 1.4-7.2 3 0.3q-3.3-4.6-8.7-6.3l1.2 2.8-6.4 3.5-6.4-3.5 1.2-2.8q-5.4 1.7-8.7 6.3l3-0.3 1.4 7.2-5.4 5-2.2-2v0.1q0 5.6 3.3 10.1l0.7-2.9 7.2 0.9 3.1 6.6-2.6 1.6q2.7 0.8 5.4 0.8t5.4-0.8l-2.6-1.6 3.1-6.6 7.3-0.9z' })
	        )
	    );
	};
	
	exports.default = FaFutbolO;
	module.exports = exports['default'];

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGamepad = function FaGamepad(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.3 24v-2.7q0-0.3-0.2-0.4t-0.5-0.2h-4v-4q0-0.3-0.2-0.5t-0.4-0.2h-2.7q-0.3 0-0.5 0.2t-0.2 0.5v4h-3.9q-0.3 0-0.5 0.1t-0.2 0.5v2.7q0 0.3 0.2 0.5t0.5 0.2h3.9v3.9q0 0.3 0.2 0.5t0.5 0.2h2.7q0.3 0 0.4-0.2t0.2-0.5v-3.9h4q0.3 0 0.5-0.2t0.2-0.5z m11.9 1.3q0-1.1-0.7-1.9t-1.9-0.7-1.9 0.7-0.8 1.9 0.8 1.9 1.9 0.8 1.9-0.8 0.7-1.9z m5.4-5.3q0-1.1-0.8-1.9t-1.9-0.8-1.9 0.8-0.8 1.9 0.8 1.9 1.9 0.8 1.9-0.8 0.8-1.9z m5.3 2.7q0 4.4-3.1 7.5t-7.6 3.1q-4 0-7-2.7h-4.6q-3 2.7-7 2.7-4.4 0-7.5-3.1t-3.1-7.5 3.1-7.6 7.5-3.1h18.6q4.4 0 7.6 3.1t3.1 7.6z' })
	        )
	    );
	};
	
	exports.default = FaGamepad;
	module.exports = exports['default'];

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGavel = function FaGavel(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.5 34.3q0 1.2-0.8 2l-2.4 2.4q-0.9 0.8-2 0.8-1.2 0-2-0.8l-8.1-8.1q-0.9-0.8-0.9-2 0-1.2 1-2.2l-5.7-5.7-2.8 2.8q-0.4 0.3-0.8 0.3t-0.8-0.3q0.1 0.1 0.3 0.3t0.3 0.3 0.2 0.2 0.2 0.3 0.2 0.3 0.1 0.4 0 0.4q0 0.9-0.6 1.5-0.1 0.1-0.4 0.4t-0.4 0.5-0.4 0.4-0.5 0.3-0.5 0.2-0.6 0.1q-0.8 0-1.5-0.6l-9.1-9.1q-0.6-0.6-0.6-1.5 0-0.3 0.1-0.6t0.2-0.5 0.3-0.5 0.4-0.4 0.5-0.4 0.4-0.4q0.6-0.6 1.5-0.6 0.2 0 0.4 0t0.4 0.1 0.3 0.2 0.3 0.2 0.2 0.2 0.3 0.3 0.3 0.3q-0.3-0.4-0.3-0.8t0.3-0.8l7.7-7.7q0.4-0.3 0.8-0.3t0.8 0.3q-0.1-0.1-0.3-0.3t-0.3-0.3-0.2-0.2-0.2-0.3-0.2-0.3-0.1-0.4 0-0.4q0-0.9 0.6-1.5 0.1-0.1 0.4-0.4t0.4-0.5 0.4-0.4 0.5-0.3 0.5-0.2 0.6-0.1q0.8 0 1.5 0.6l9.1 9.1q0.6 0.6 0.6 1.5 0 0.3-0.1 0.6t-0.2 0.5-0.3 0.5-0.4 0.4-0.5 0.4-0.4 0.4q-0.6 0.6-1.5 0.6-0.2 0-0.4 0t-0.4-0.1-0.3-0.2-0.3-0.2-0.2-0.2-0.3-0.3-0.3-0.3q0.3 0.4 0.3 0.8t-0.3 0.8l-2.8 2.8 5.7 5.7q1-1 2.2-1 1.1 0 2 0.9l8.1 8.1q0.8 0.8 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaGavel;
	module.exports = exports['default'];

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGbp = function FaGbp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.3 25.4v8.2q0 0.3-0.2 0.5t-0.5 0.2h-21.4q-0.3 0-0.5-0.2t-0.2-0.5v-3.4q0-0.3 0.2-0.5t0.5-0.2h2.2v-8.5h-2.1q-0.4 0-0.6-0.2t-0.2-0.6v-2.9q0-0.3 0.2-0.5t0.6-0.2h2.1v-5q0-3.8 2.7-6.3t7.1-2.4q4.1 0 7.4 2.7 0.2 0.2 0.3 0.5t-0.2 0.5l-2.3 2.8q-0.2 0.3-0.5 0.3-0.3 0.1-0.5-0.1-0.1-0.2-0.6-0.5t-1.5-0.7-2.1-0.4q-1.9 0-3.1 1.1t-1.1 2.7v4.8h6.8q0.3 0 0.5 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.5 0.3h-6.8v8.4h9.2v-4q0-0.3 0.2-0.5t0.5-0.2h3.7q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaGbp;
	module.exports = exports['default'];

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGenderless = function FaGenderless(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.9 21.4q0-4.1-3-7t-7-3-7.1 3-2.9 7 2.9 7.1 7.1 2.9 7-2.9 3-7.1z m2.8 0q0 2.6-1 5t-2.7 4.1-4.2 2.8-4.9 1-5-1-4.1-2.8-2.8-4.1-1-5 1-5 2.8-4.1 4.1-2.7 5-1 4.9 1 4.2 2.7 2.7 4.1 1 5z' })
	        )
	    );
	};
	
	exports.default = FaGenderless;
	module.exports = exports['default'];

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGetPocket = function FaGetPocket(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 2.9q1.5 0 2.5 1t1 2.4v11.6q0 4-1.5 7.5t-4.1 6.2-6.1 4-7.5 1.5q-3.9 0-7.5-1.5t-6.1-4-4.1-6.2-1.5-7.5v-11.6q0-1.4 1-2.4t2.5-1h31.4z m-15.7 23.7q1.1 0 1.8-0.7l9.1-8.7q0.8-0.8 0.8-1.9 0-1.1-0.8-1.9t-1.8-0.7q-1.1 0-1.9 0.7l-7.2 6.9-7.2-6.9q-0.8-0.7-1.8-0.7-1.1 0-1.9 0.7t-0.7 1.9q0 1.2 0.8 1.9l9 8.7q0.7 0.7 1.8 0.7z' })
	        )
	    );
	};
	
	exports.default = FaGetPocket;
	module.exports = exports['default'];

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGgCircle = function FaGgCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16 30.2l6.1-6-6.3-6.3-1.9 2 4.2 4.3-2.1 2.1-6.2-6.2 6.2-6.2 0.9 0.9 1.9-2-2.8-2.8-10.1 10.1z m8-0.2l10.1-10.1-10.1-10.1-6.1 6 6.3 6.3 1.9-2-4.2-4.3 2.1-2.1 6.2 6.2-6.2 6.2-0.9-0.9-1.9 2z m16-10q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaGgCircle;
	module.exports = exports['default'];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGg = function FaGg(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 18.1l7.4 7.5-7.4 7.4-13.1-13 13.1-13 3.2 3.2-1.8 1.9-1.4-1.4-9.3 9.3 9.3 9.3 3.7-3.7-5.6-5.6z m11.2-11.1l13 13-13 13-3.3-3.2 1.9-1.9 1.4 1.4 9.3-9.3-9.3-9.3-3.8 3.7 5.6 5.6-1.8 1.9-7.5-7.5z' })
	        )
	    );
	};
	
	exports.default = FaGg;
	module.exports = exports['default'];

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGift = function FaGift(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.7 30.3v-16h-7.1v16q0 0.5 0.4 0.8t1 0.3h4.3q0.6 0 1-0.3t0.4-0.8z m-10.2-18.9h4.4l-2.8-3.6q-0.6-0.7-1.6-0.7-0.9 0-1.5 0.7t-0.6 1.5 0.6 1.5 1.5 0.6z m15.4-2.1q0-0.9-0.6-1.5t-1.6-0.7q-0.9 0-1.5 0.7l-2.8 3.6h4.4q0.8 0 1.5-0.6t0.6-1.5z m8.4 5.7v7.1q0 0.4-0.2 0.6t-0.5 0.2h-2.2v9.2q0 0.9-0.6 1.6t-1.5 0.6h-24.3q-0.9 0-1.5-0.6t-0.6-1.6v-9.2h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-7.1q0-0.3 0.2-0.5t0.5-0.2h9.8q-2 0-3.5-1.5t-1.5-3.5 1.5-3.6 3.5-1.4q2.4 0 3.8 1.7l2.8 3.7 2.9-3.7q1.4-1.7 3.8-1.7 2 0 3.5 1.4t1.4 3.6-1.4 3.5-3.6 1.5h9.9q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaGift;
	module.exports = exports['default'];

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGitSquare = function FaGitSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16 29.2q0 1.5-2.1 1.5-2.4 0-2.4-1.4 0-1.5 2.2-1.5 2.3 0 2.3 1.4z m-0.8-10.4q0 1.9-1.7 1.9-1.7 0-1.7-1.9 0-2 1.7-2 0.8 0 1.3 0.6t0.4 1.4z m3.7-1.7v-2.8q-1.7 0.7-3 0.7-1.1-0.7-2.5-0.7-1.9 0-3.2 1.3t-1.3 3.2q0 1.1 0.6 2.3t1.7 1.5v0q-0.9 0.4-0.9 1.9 0 1.2 0.9 1.8v0q-2.5 0.8-2.5 3.1 0 1 0.5 1.8t1.2 1.1 1.6 0.6 1.8 0.2q5 0 5-4.2 0-1.5-1.1-2.2t-2.8-1.1q-0.6-0.1-1.2-0.4t-0.5-0.9q0-1 1.1-1.2 1.7-0.3 2.7-1.5t1-3q0-0.6-0.2-1.2 0.8-0.2 1.1-0.3z m1.3 9.4h3.1q-0.1-0.6-0.1-1.9v-8.6q0-1 0.1-1.5h-3.1q0.1 0.5 0.1 1.6v8.7q0 1.1-0.1 1.7z m11.4-0.4v-2.7q-0.7 0.5-1.5 0.5-1.2 0-1.2-1.8v-5.1h1.1q0.2 0 0.6 0.1t0.6 0v-2.6h-2.3q0-1.9 0-2.3h-3.1q0.1 0.5 0.1 1.2v1.1h-1.3v2.6q0.8-0.1 0.8-0.1 0.1 0 0.2 0t0.3 0v0.1h0v4.8q0 0.8 0 1.5t0.3 1.2 0.5 1.1 1 0.7 1.5 0.3q1.4 0 2.4-0.6z m-8-15.7q0-0.8-0.5-1.5t-1.4-0.6-1.3 0.6-0.5 1.5q0 0.8 0.5 1.4t1.3 0.5 1.4-0.6 0.5-1.3z m13.7-1.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaGitSquare;
	module.exports = exports['default'];

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGit = function FaGit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.3 33.8q0-2.2-3.7-2.2-3.5 0-3.5 2.3 0 2.2 3.8 2.2 3.4 0 3.4-2.3z m-1.3-16.9q0-1.3-0.7-2.2t-2-0.9q-2.8 0-2.8 3.2 0 3 2.8 3 2.7 0 2.7-3.1z m6-7.2v4.5q-0.8 0.3-1.8 0.5 0.4 1 0.4 1.9 0 2.8-1.7 4.8t-4.4 2.5q-0.9 0.2-1.3 0.6t-0.4 1.3q0 0.7 0.5 1.2t1.3 0.7 1.7 0.5 1.9 0.6 1.8 0.8 1.3 1.4 0.5 2.2q0 6.8-8.1 6.8-1.6 0-2.9-0.3t-2.6-0.9-2-1.8-0.7-2.9q0-3.7 4.1-5v-0.1q-1.5-0.9-1.5-2.8 0-2.4 1.4-3v-0.1q-1.6-0.6-2.7-2.5t-1-3.7q0-3.1 2.1-5.1t5.2-2.1q2.2 0 4 1.1 2.2 0 4.9-1.1z m7.1 19.7h-5q0.1-1 0.1-3v-13.6q0-2.1-0.1-2.9h5q-0.1 0.8-0.1 2.8v13.7q0 2 0.1 3z m13.4-5v4.4q-1.6 0.9-3.9 0.9-1.4 0-2.4-0.5t-1.6-1.1-0.8-1.7-0.4-2.1-0.1-2.3v-7.8h0v-0.1q-0.1 0-0.4 0t-0.4-0.1q-0.5 0-1.3 0.2v-4.3h2.1v-1.7q0-1.2-0.1-1.9h5q-0.1 0.9-0.1 3.6h3.8v4.3q-0.3 0-0.9-0.1t-1 0h-1.9v8.1q0 3 1.9 3 1.4 0 2.5-0.8z m-12.9-21.1q0 1.3-0.8 2.2t-2.2 1q-1.3 0-2.2-1t-0.9-2.2q0-1.3 0.9-2.3t2.2-1q1.3 0 2.2 1t0.8 2.3z' })
	        )
	    );
	};
	
	exports.default = FaGit;
	module.exports = exports['default'];

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGithubAlt = function FaGithubAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.8 27.1q0 0.9-0.3 1.9t-1 1.7-1.6 0.7-1.6-0.7-1-1.7-0.2-1.9 0.3-1.8 0.9-1.7 1.6-0.7 1.6 0.7 1 1.7 0.3 1.8z m14.3 0q0 0.9-0.3 1.9t-1 1.7-1.6 0.7-1.6-0.7-1-1.7-0.2-1.9 0.2-1.8 1-1.7 1.6-0.7 1.6 0.7 1 1.7 0.3 1.8z m3.5 0q0-2.6-1.5-4.5t-4.2-1.9q-0.9 0-4.3 0.5-1.6 0.2-3.5 0.2t-3.5-0.2q-3.4-0.5-4.4-0.5-2.6 0-4.2 1.9t-1.5 4.5q0 2 0.7 3.5t1.8 2.3 2.7 1.3 3.2 0.7 3.3 0.1h3.7q1.9 0 3.4-0.1t3.1-0.7 2.7-1.3 1.8-2.3 0.7-3.5z m5-3.9q0 4.6-1.3 7.4-0.9 1.7-2.4 3t-3.1 1.9-3.8 1.1-3.8 0.4-3.8 0.1q-1.7 0-3.1 0t-3.3-0.3-3.4-0.7-3.1-1.1-2.7-1.8-1.9-2.6q-1.4-2.7-1.4-7.4 0-5.3 3-8.8-0.6-1.9-0.6-3.8 0-2.6 1.2-4.9 2.4 0 4.2 0.9t4.2 2.8q3.3-0.8 6.9-0.8 3.3 0 6.3 0.7 2.3-1.8 4.2-2.7t4.2-0.9q1.1 2.3 1.1 4.9 0 1.9-0.6 3.7 3 3.6 3 8.9z' })
	        )
	    );
	};
	
	exports.default = FaGithubAlt;
	module.exports = exports['default'];

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGithubSquare = function FaGithubSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.6 26.8q0.1-0.1-0.1-0.3-0.2-0.2-0.3 0-0.1 0.1 0.1 0.2 0.2 0.2 0.3 0.1z m-0.6-0.9q-0.2-0.2-0.3-0.1-0.1 0.1 0 0.3 0.1 0.1 0.3 0.1 0.1-0.1 0-0.3z m-1-0.9q0.1-0.1-0.1-0.2-0.1 0-0.1 0-0.1 0.2 0 0.2 0.2 0.1 0.2 0z m0.5 0.5q0.1 0 0-0.1t0-0.1q-0.2-0.2-0.3-0.1t0.1 0.3q0.1 0.1 0.2 0z m1.9 1.7q0.1-0.2-0.2-0.3-0.2 0-0.3 0.1 0 0.2 0.2 0.3 0.2 0 0.3-0.1z m1 0q0-0.1-0.3-0.1-0.2 0-0.2 0.1t0.2 0.2 0.3-0.2z m0.8-0.1q0-0.2-0.2-0.1t-0.2 0.2q0 0.1 0.2 0.1t0.2-0.2z m14.4-7.1q0-4.7-3.4-8.1t-8.1-3.3-8 3.3-3.4 8.1q0 3.7 2.2 6.7t5.6 4.1q0.4 0.1 0.6-0.1t0.2-0.4q0-1.2 0-2.1-0.1 0-0.4 0t-0.8 0.1-1-0.1-1-0.5-0.7-0.9q-0.5-1.3-1.2-1.6-0.1-0.1-0.1-0.1l-0.2-0.2-0.2-0.2 0.1-0.2 0.5-0.1q0.1 0 0.3 0.1t0.7 0.3 0.7 0.8q0.4 0.7 0.8 1t1 0.3 0.9-0.1 0.6-0.2q0.2-1.1 0.8-1.6-1.1-0.1-1.9-0.4t-1.7-0.8-1.2-1.7-0.5-2.7q0-1.8 1.2-3.1-0.5-1.3 0.1-3 0.5-0.1 1.3 0.2t1.3 0.6l0.6 0.4q1.3-0.4 2.8-0.4t2.9 0.4q0.3-0.2 0.6-0.4t1.3-0.6 1.3-0.2q0.6 1.7 0.1 3 1.1 1.3 1.1 3.1 0 1.3-0.3 2.2t-0.8 1.6-1.2 1-1.3 0.6-1.6 0.2q0.8 0.7 0.8 2.2 0 0.9 0 2t0 1.1q0 0.3 0.2 0.4t0.6 0.1q3.4-1.1 5.6-4.1t2.2-6.7z m5.7-10.7v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaGithubSquare;
	module.exports = exports['default'];

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGithub = function FaGithub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6q0 5.6-3.3 10.1t-8.4 6.2q-0.6 0.1-0.9-0.2t-0.3-0.7q0 0 0-1.7t0-3q0-2.1-1.2-3.1 1.3-0.2 2.3-0.4t2.1-0.9 1.8-1.5 1.2-2.3 0.5-3.4q0-2.7-1.8-4.6 0.8-2-0.2-4.5-0.6-0.2-1.8 0.2t-2 1l-0.9 0.5q-2-0.6-4.3-0.6t-4.2 0.6q-0.4-0.2-1-0.6t-1.9-0.8-1.9-0.3q-1 2.5-0.1 4.5-1.8 1.9-1.8 4.6 0 1.9 0.5 3.4t1.1 2.3 1.8 1.5 2.1 0.9 2.3 0.4q-0.9 0.8-1.1 2.3-0.4 0.2-1 0.3t-1.3 0.1-1.4-0.5-1.3-1.4q-0.4-0.7-1-1.1t-1.1-0.6l-0.5 0q-0.5 0-0.6 0.1t-0.1 0.2 0.2 0.3 0.2 0.3l0.2 0.1q0.5 0.2 1 0.9t0.7 1.1l0.2 0.5q0.3 0.9 1 1.4t1.5 0.7 1.5 0.1 1.3-0.1l0.5 0q0 0.8 0 1.9t0 1.2q0 0.5-0.3 0.7t-0.9 0.2q-5.2-1.7-8.4-6.2t-3.3-10.1q0-4.7 2.3-8.6t6.2-6.2 8.6-2.3z m-10.6 24.6q0.1-0.2-0.2-0.3-0.2-0.1-0.2 0.1-0.1 0.1 0.1 0.2 0.2 0.2 0.3 0z m0.7 0.7q0.1-0.1-0.1-0.3-0.2-0.2-0.3-0.1-0.2 0.1 0 0.4 0.3 0.2 0.4 0z m0.7 1q0.2-0.1 0-0.4-0.2-0.3-0.4-0.1-0.2 0.1 0 0.4t0.4 0.1z m0.9 1q0.2-0.2-0.1-0.4-0.3-0.3-0.4-0.1-0.2 0.2 0 0.4 0.3 0.3 0.5 0.1z m1.3 0.5q0-0.2-0.3-0.3-0.4-0.1-0.4 0.1t0.2 0.4q0.4 0.1 0.5-0.2z m1.4 0.1q0-0.2-0.4-0.2-0.4 0-0.4 0.2 0 0.3 0.4 0.3 0.4 0 0.4-0.3z m1.3-0.2q-0.1-0.2-0.4-0.2-0.4 0.1-0.3 0.4t0.4 0.1 0.3-0.3z' })
	        )
	    );
	};
	
	exports.default = FaGithub;
	module.exports = exports['default'];

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGitlab = function FaGitlab(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm2.3 15.8l17.7 22.6-19.4-14q-0.4-0.3-0.5-0.8t0-1l2.2-6.8z m10.3 0h14.8l-7.4 22.6z m-4.4-13.7l4.4 13.7h-10.3l4.4-13.7q0.2-0.5 0.8-0.5t0.7 0.5z m29.5 13.7l2.2 6.8q0.2 0.5 0 1t-0.5 0.8l-19.4 14 17.7-22.6z m0 0h-10.3l4.4-13.7q0.2-0.5 0.7-0.5t0.8 0.5z' })
	        )
	    );
	};
	
	exports.default = FaGitlab;
	module.exports = exports['default'];

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGittip = function FaGittip(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.3 29.1l7.8-10.6q0.3-0.5 0.5-1.3t-0.1-1.9-1.4-1.8q-0.9-0.6-1.8-0.5t-1.7 0.4-1.2 1q-0.8 0.8-2.1 0.8-1.4 0-2.2-0.8-0.5-0.7-1.2-1t-1.6-0.4-1.9 0.5q-1 0.7-1.4 1.8t-0.1 1.9 0.6 1.3z m17-9.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaGittip;
	module.exports = exports['default'];

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGlass = function FaGlass(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.9 4.2q0 0.7-0.9 1.7l-14.1 14.1v17.1h7.1q0.6 0 1 0.5t0.4 1-0.4 1-1 0.4h-20q-0.6 0-1-0.4t-0.4-1 0.4-1 1-0.5h7.1v-17.1l-14.1-14.1q-0.9-1-0.9-1.7 0-0.6 0.4-0.9t0.8-0.4 1 0h31.4q0.5 0 1 0t0.8 0.4 0.4 0.9z' })
	        )
	    );
	};
	
	exports.default = FaGlass;
	module.exports = exports['default'];

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGlideG = function FaGlideG(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.6 6.8q0-0.5 0-0.9t-0.2-0.6-0.5-0.5-0.8-0.2q-0.9 0-1.8 0.5-2.3 1.3-3.5 4.3t-1.2 6q0 1 0.2 1.9t0.6 1.8 1.1 1.4 1.8 0.5q0.1 0 0.4 0t0.5 0 0.3-0.1 0.4-0.1 0.1-0.4q0.4-1.7 1.1-5.2t1.1-5.1q0.4-2.1 0.4-3.3z m16.8 14.7q0 0.1-0.1 0.3t-0.4 0.1l-0.1 0q-0.5-0.1-1.4-0.3t-1.6-0.2-1.4-0.1q-3.7 0-7.8 2-0.4 0.2-0.5 0.6-0.2 0.8-0.6 2.4t-0.5 2.2q-0.5 2.1-1.5 4t-2.5 3.7-3.5 2.8-4.1 1q-3 0-4.8-1.9t-1.8-4.9q0-1.1 0.5-2.6t1.4-2.6 2.1-1.1q0.9 0 2.7 0.7t1.9 1.4q0 0-0.4 0.3t-0.9 0.6-1 1-0.9 1.4-0.3 1.7q0 0.7 0.3 1.1t1.1 0.5q1 0 1.9-0.7t1.5-1.8 1.1-2.3 0.7-2.4 0.4-2v-0.2q0-0.1-0.1-0.1t-0.2 0h-0.2l-0.3 0-0.1 0q-5.1 0-7.8-2.7t-2.8-7.8q0-2.4 0.7-4.9t2.2-4.7 3.5-3.8 4.5-2q1.2-0.2 2.4-0.2 8.3 0 8.3 8.1 0 2.1-0.8 6.1t-1 4.7l0.1 0q2.2-1.2 4.1-1.9t3.7-0.7q0.5 0 1.2 0.3 0.4 0.1 1.8 2.3t1.3 2.6z' })
	        )
	    );
	};
	
	exports.default = FaGlideG;
	module.exports = exports['default'];

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGlide = function FaGlide(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.3 11.5q0 0.6-0.3 2.1-0.2 1.1-0.7 3.3t-0.6 3.4q-0.1 0.2-0.1 0.3t-0.3 0q-0.5 0.1-0.7 0.1-1.3 0-1.9-1.1t-0.6-2.6q0-1.9 0.8-3.9t2.3-2.7q0.6-0.3 1.1-0.3 0.7 0 0.8 0.3t0.2 1.1z m10.9 9.5q0-0.4-0.9-1.7t-1.2-1.5q-0.4-0.2-0.7-0.2-2 0-5.1 1.7l0 0q0.1-0.5 0.6-3t0.6-4q0-5.2-5.4-5.2-0.6 0-1.6 0.1-2.1 0.4-3.7 2t-2.5 3.8-0.8 4.2q0 3.2 1.8 5t5 1.8q0.6 0 0.6 0t0 0.1q-0.1 0.8-0.6 2.6-0.3 1.2-1.2 2.3t-1.8 1.1q-0.9 0-0.9-1.1 0-0.5 0.2-1t0.6-0.9 0.6-0.6 0.6-0.5 0.2-0.2q0 0-0.1-0.2-0.6-0.5-1.3-0.8t-1.5-0.3q-0.8 0-1.4 0.7t-0.9 1.7-0.3 1.7q0 1.9 1.2 3.1t3 1.2q1.9 0 3.5-1.1t2.6-2.8 1.5-3.5q0.1-0.5 0.3-1.4t0.4-1.5q0-0.3 0.3-0.4 2.6-1.4 5-1.4 1.1 0 2.9 0.4 0 0.1 0.1 0.1 0.1 0 0.2-0.1t0.1-0.2z m4.1-11.7v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaGlide;
	module.exports = exports['default'];

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGlobe = function FaGlobe(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m6.2 11.6q-0.1 0-0.3 0.2t-0.3 0.2q0.1 0 0.1-0.1t0.2-0.2 0-0.2q0.2-0.2 0.5-0.3 0.3-0.2 1.2-0.3 0.7-0.2 1.1 0.2 0 0 0.2-0.3t0.4-0.2q0-0.1 0.3-0.1t0.3-0.2l0.1-0.5q-0.3 0-0.4-0.1t-0.2-0.5q0 0-0.1 0.2 0-0.2-0.1-0.2t-0.3 0-0.2 0q-0.2 0-0.3-0.1t-0.2-0.4-0.1-0.3q0-0.1-0.2-0.3t-0.2-0.2q0 0 0-0.1t-0.1-0.2-0.1-0.1-0.1 0-0.2 0.1-0.1 0.2-0.1 0.1q-0.1 0-0.2 0t-0.1 0-0.1 0.1-0.1 0q0 0.1-0.2 0.1t-0.2 0.1q0.4-0.2 0-0.3-0.2-0.1-0.3-0.1 0.2-0.1 0.1-0.2t-0.2-0.3h0.1q0-0.1-0.1-0.2t-0.4-0.2-0.3-0.2q-0.2-0.1-0.8-0.2t-0.7 0q-0.1 0.2-0.1 0.3t0.1 0.3 0 0.2q0.1 0.2-0.1 0.3t-0.1 0.3q0 0.2 0.3 0.4t0.2 0.4q-0.1 0.2-0.3 0.4t-0.4 0.3q-0.1 0.1 0 0.4t0.2 0.3q0 0.1 0 0.1t0 0.1-0.2 0.1-0.1 0.1l-0.1 0q-0.2 0.2-0.4-0.1t-0.3-0.6q-0.2-0.5-0.4-0.6-0.5-0.2-0.6 0-0.2-0.3-1-0.6-0.5-0.2-1.3-0.1 0.2 0 0-0.3-0.1-0.4-0.4-0.3 0.1-0.1 0.1-0.4t0-0.3q0.1-0.3 0.3-0.5 0 0 0.2-0.2t0.2-0.3 0-0.1q0.8 0.1 1.1-0.3 0.1-0.1 0.3-0.3t0.2-0.4q0.2-0.2 0.3-0.2t0.3 0.2 0.4 0.1q0.3 0 0.3-0.3t-0.2-0.4q0.3 0 0.1-0.4-0.1-0.1-0.2-0.2-0.2-0.1-0.6 0.1-0.2 0.1 0.1 0.2-0.1 0-0.2 0.2t-0.4 0.4-0.4-0.1q0 0-0.1-0.3t-0.2-0.3q-0.2 0-0.4 0.3 0.1-0.1-0.2-0.3t-0.5-0.2q0.4-0.2-0.2-0.6-0.2-0.1-0.5-0.1t-0.4 0.1q-0.1 0.2-0.1 0.3t0.1 0.1 0.2 0.2 0.3 0.1 0.2 0q0.3 0.2 0.1 0.3 0 0.1-0.2 0.1t-0.2 0.1-0.2 0.1q0 0.1 0 0.3t0 0.3q-0.1-0.1-0.2-0.4t-0.2-0.3q0.2 0.2-0.5 0.1l-0.2 0q-0.1 0-0.4 0t-0.4 0-0.3-0.1q-0.1-0.2 0-0.5 0-0.1 0 0 0-0.1-0.2-0.2t-0.2-0.2q-1.1 0.3-2.1 0.9 0.1 0 0.2 0 0.2-0.1 0.3-0.2t0.3-0.1q0.7-0.3 0.9-0.2l0.1-0.1q0.3 0.4 0.4 0.6-0.1-0.1-0.6 0-0.5 0.1-0.5 0.2 0.1 0.3 0.1 0.4-0.1 0-0.3-0.2t-0.3-0.2-0.3-0.1q-0.4 0-0.5 0-3.3 1.8-5.3 4.9 0.2 0.2 0.3 0.2 0.1 0 0.1 0.2t0.1 0.3 0.2-0.1q0.2 0.2 0.1 0.4 0 0 1 0.6 0.4 0.4 0.5 0.5 0 0.2-0.3 0.4 0-0.1-0.2-0.2t-0.2-0.1q0 0.1 0 0.4t0.3 0.3q-0.2 0-0.2 0.4t-0.1 0.7 0 0.6l0 0q0 0.3 0.2 0.8t0.4 0.4q-0.3 0.1 0.5 1 0.1 0.1 0.2 0.2 0 0 0.2 0.1t0.4 0.2 0.2 0.3q0.1 0.1 0.2 0.5t0.3 0.5q0 0.1 0.2 0.4t0.3 0.6q-0.1 0-0.1 0t0 0q0 0.2 0.3 0.3t0.4 0.3q0 0.1 0 0.2t0.1 0.3 0.1 0q0.1-0.4-0.5-1.4-0.3-0.5-0.4-0.6 0-0.1-0.1-0.4t-0.1-0.3q0 0 0.1 0.1t0.2 0 0.2 0.1 0 0.1q0 0.1 0.1 0.4t0.3 0.4 0.3 0.4 0.3 0.3q0.1 0.1 0.3 0.4t0 0.3q0.2 0 0.5 0.3t0.3 0.4q0.1 0.2 0.2 0.6t0.1 0.5q0.1 0.2 0.2 0.3t0.3 0.2l0.4 0.2 0.2 0.2q0.2 0 0.5 0.2t0.4 0.3q0.3 0.1 0.4 0.1t0.3-0.1 0.3-0.1q0.4 0 0.7 0.4t0.4 0.4q0.8 0.4 1.3 0.3-0.1 0 0 0.1t0.2 0.4 0.2 0.3 0.1 0.2q0.1 0.1 0.4 0.3t0.4 0.4q0.1-0.1 0.1-0.2 0 0.1 0.2 0.4t0.4 0.2q0.3 0 0.3-0.7-0.7 0.4-1.1-0.4 0 0 0-0.1t-0.1-0.2-0.1-0.2 0-0.1 0.1-0.1q0.2 0 0.2-0.1t0-0.3-0.1-0.3q0-0.1-0.2-0.4t-0.3-0.3q-0.1 0.2-0.4 0.1t-0.3-0.2q0 0.1-0.1 0.2t0 0.1q-0.3 0-0.3 0 0-0.1 0-0.4t0.1-0.5q0-0.1 0.1-0.3t0.2-0.3 0.1-0.3-0.1-0.2-0.4-0.1q-0.4 0.1-0.6 0.5 0 0.1 0 0.2t-0.2 0.3-0.2 0.1q-0.1 0.1-0.5 0.1t-0.5-0.1q-0.3-0.2-0.5-0.7t-0.2-0.8q0-0.2 0-0.6t0.1-0.5-0.1-0.6q0 0 0.2-0.2t0.2-0.2q0-0.1 0.1-0.1t0.1 0 0.1 0 0-0.1q0-0.1-0.1-0.1 0-0.1 0-0.1 0.1 0.1 0.6 0t0.6 0q0.3 0.3 0.5 0 0 0-0.1-0.2t0-0.3q0.1 0.6 0.7 0.2 0 0 0.3 0.1t0.4 0.1q0.1 0 0.2 0.1t0.1 0.1 0.1 0 0.2-0.1q0.2 0.3 0.3 0.5 0.2 0.9 0.4 1 0.1 0 0.2 0t0.1-0.2 0-0.3 0-0.3l0-0.2v-0.4l0-0.1q-0.4-0.1-0.5-0.3t0.1-0.4 0.3-0.4q0-0.1 0.2-0.1t0.3-0.2 0.3-0.1q0.5-0.5 0.4-0.8 0.1 0 0.2-0.2 0 0-0.1-0.1t-0.2-0.1-0.1 0q0.2-0.2 0.1-0.4 0.1-0.1 0.1-0.2t0.2-0.3q0.2 0.3 0.5 0.1 0.1-0.2 0-0.4 0.1-0.1 0.4-0.2t0.5-0.2q0.1 0 0.1-0.1t0.1-0.2 0-0.3q0.1-0.1 0.4-0.2t0.2-0.1l0.4-0.3q0.1-0.1 0-0.1 0.4 0.1 0.7-0.2 0.2-0.2-0.1-0.4 0.1-0.2-0.1-0.3t-0.3-0.1q0.1 0 0.2 0t0.3 0q0.3-0.2-0.2-0.4-0.4-0.1-0.9 0.3z m-3.7 19.6q4.6-0.8 7.9-4.3-0.1 0-0.3-0.1t-0.3 0q-0.4-0.2-0.5-0.2 0-0.2-0.1-0.3t-0.2-0.2-0.3-0.2-0.2-0.1q0-0.1-0.2-0.2t-0.1-0.1-0.2-0.1-0.2 0-0.2 0l-0.1 0q0 0-0.1 0.1t-0.1 0-0.1 0.1 0 0q-0.5-0.3-0.8-0.4-0.1-0.1-0.2-0.2t-0.3-0.1-0.2-0.1-0.3 0.2q-0.1 0.1-0.1 0.3t0 0.3q-0.2-0.1 0-0.4t0-0.4q-0.1-0.1-0.2-0.1t-0.3 0.1-0.2 0.2-0.2 0.2-0.2 0.1-0.2 0.1q-0.1 0.1-0.2 0.3t-0.1 0.3q0-0.1-0.2-0.2t-0.2-0.1q0 0.2 0 0.8t0.2 0.8q0.1 0.7-0.3 1.1-0.6 0.5-0.7 0.9 0 0.5 0.3 0.6 0 0.1-0.2 0.4t-0.1 0.5q0 0.1 0 0.4z' })
	        )
	    );
	};
	
	exports.default = FaGlobe;
	module.exports = exports['default'];

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGooglePlusSquare = function FaGooglePlusSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.5 20.2q0-0.6-0.2-1.4h-8v2.9h4.8q-0.1 0.6-0.4 1.1t-0.8 1.2-1.5 1-2.1 0.4q-2.3 0-3.8-1.6t-1.6-3.8 1.6-3.8 3.8-1.6q2 0 3.4 1.3l2.3-2.2q-2.4-2.3-5.7-2.3-3.6 0-6.1 2.5t-2.5 6.1 2.5 6.1 6.1 2.5q3.6 0 5.9-2.4t2.3-6z m7.7 1h2.4v-2.4h-2.4v-2.5h-2.5v2.5h-2.4v2.4h2.4v2.5h2.5v-2.5z m6.1-11.9v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaGooglePlusSquare;
	module.exports = exports['default'];

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGooglePlus = function FaGooglePlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.2 20.3q0 3.6-1.6 6.5t-4.3 4.4-6.5 1.6q-2.6 0-5-1t-4.1-2.7-2.7-4.1-1-5 1-5 2.7-4.1 4.1-2.7 5-1q5 0 8.6 3.3l-3.5 3.4q-2-2-5.1-2-2.1 0-4 1.1t-2.8 2.9-1.1 4.1 1.1 4.1 2.8 2.9 4 1.1q1.5 0 2.7-0.4t2-1 1.4-1.4 0.8-1.4 0.4-1.3h-7.3v-4.4h12.1q0.3 1.1 0.3 2.1z m15.1-2.1v3.6h-3.6v3.7h-3.7v-3.7h-3.7v-3.6h3.7v-3.7h3.7v3.7h3.6z' })
	        )
	    );
	};
	
	exports.default = FaGooglePlus;
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGoogleWallet = function FaGoogleWallet(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.6 15.1q0.7 0 1.1 0.6 5.8 7.9 7.9 16.8h-9.7q-2.8-9.6-8-16.3-0.2-0.3-0.1-0.7t0.7-0.4h8.1z m12.2 7.8q-1.1 4.3-2.7 8.6-1.8-6.8-5.6-13 0.9-4.8 0.9-9.8 4.6 7.4 7.4 14.2z m2.1-15.4q5.2 7 8.4 15.2t4 16.8h-9.8q-0.9-14.5-12-32h9.4z m15.1 12.5q0 9.2-2.2 17.7-1.4-12.2-7.8-23.6-0.5-6.6-2.3-12.7-0.1-0.4 0.1-0.6t0.6-0.3h7.8q0.5 0 0.8 0.3t0.5 0.7q2.5 8.9 2.5 18.5z' })
	        )
	    );
	};
	
	exports.default = FaGoogleWallet;
	module.exports = exports['default'];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGoogle = function FaGoogle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 17.5h16.2q0.3 1.5 0.3 2.9 0 4.8-2 8.7t-5.8 5.9-8.7 2.1q-3.5 0-6.6-1.3t-5.5-3.7-3.7-5.4-1.3-6.7 1.3-6.7 3.7-5.4 5.5-3.7 6.6-1.3q6.7 0 11.5 4.4l-4.6 4.5q-2.8-2.6-6.9-2.6-2.8 0-5.3 1.4t-3.9 4-1.4 5.4 1.4 5.4 3.9 4 5.3 1.4q2 0 3.6-0.5t2.7-1.3 1.8-1.9 1.2-1.9 0.5-1.8h-9.8v-5.9z' })
	        )
	    );
	};
	
	exports.default = FaGoogle;
	module.exports = exports['default'];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGraduationCap = function FaGraduationCap(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.1 18.9l0.3 5.6q0 1.2-1.5 2.2t-4.1 1.7-5.6 0.6-5.7-0.6-4.1-1.7-1.4-2.2l0.3-5.6 10 3.2q0.4 0.1 0.9 0.1t0.8-0.1z m9.2-5.6q0 0.4-0.3 0.5l-19.7 6.2q0 0-0.1 0t-0.2 0l-11.4-3.6q-0.8 0.6-1.3 1.9t-0.6 3.2q1.1 0.6 1.1 1.9 0 1.2-1 1.8l1 7.6q0.1 0.3-0.1 0.5-0.2 0.1-0.4 0.1h-3.4q-0.2 0-0.4-0.1-0.2-0.2-0.1-0.5l1-7.6q-1-0.6-1-1.8 0-1.3 1.1-2 0.2-3.6 1.7-5.8l-5.8-1.8q-0.4-0.1-0.4-0.5t0.4-0.6l19.6-6.1q0.1 0 0.2 0t0.1 0l19.6 6.1q0.4 0.2 0.4 0.6z' })
	        )
	    );
	};
	
	exports.default = FaGraduationCap;
	module.exports = exports['default'];

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaGroup = function FaGroup(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.3 20q-3.4 0.1-5.5 2.7h-2.8q-1.7 0-2.8-0.9t-1.2-2.4q0-7.4 2.6-7.4 0.1 0 0.9 0.5t2 0.8 2.5 0.5q1.4 0 2.7-0.5-0.1 0.8-0.1 1.4 0 2.9 1.7 5.3z m22.3 13.2q0 2.5-1.6 4t-4 1.4h-18.1q-2.6 0-4.1-1.4t-1.5-4q0-1.1 0.1-2.1t0.3-2.3 0.5-2.2 0.9-2.1 1.3-1.6 1.8-1.2 2.3-0.4q0.2 0 0.9 0.5t1.5 1 2.2 1 2.8 0.4 2.8-0.4 2.3-1 1.5-1 0.9-0.5q1.2 0 2.3 0.4t1.8 1.2 1.2 1.6 0.9 2.1 0.6 2.2 0.3 2.3 0.1 2.1z m-21.3-26.5q0 2.2-1.6 3.8t-3.7 1.5-3.8-1.5-1.5-3.8 1.5-3.7 3.8-1.6 3.7 1.6 1.6 3.7z m14.6 8q0 3.3-2.3 5.6t-5.7 2.4-5.6-2.4-2.3-5.6 2.3-5.7 5.6-2.3 5.7 2.3 2.3 5.7z m12 4.7q0 1.6-1.2 2.4t-2.9 0.9h-2.7q-2.2-2.6-5.5-2.7 1.6-2.4 1.6-5.3 0-0.6-0.1-1.4 1.4 0.5 2.8 0.5 1.2 0 2.5-0.5t2-0.8 0.9-0.5q2.6 0 2.6 7.4z m-2.7-12.7q0 2.2-1.5 3.8t-3.8 1.5-3.8-1.5-1.5-3.8 1.5-3.7 3.8-1.6 3.8 1.6 1.5 3.7z' })
	        )
	    );
	};
	
	exports.default = FaGroup;
	module.exports = exports['default'];

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHSquare = function FaHSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 30v-20q0-0.6-0.5-1t-1-0.4h-2.8q-0.6 0-1 0.4t-0.4 1v7.1h-11.5v-7.1q0-0.6-0.4-1t-1-0.4h-2.9q-0.5 0-1 0.4t-0.4 1v20q0 0.6 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-7.1h11.5v7.1q0 0.6 0.4 1t1 0.4h2.8q0.6 0 1-0.4t0.5-1z m5.7-20.7v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaHSquare;
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHackerNews = function FaHackerNews(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.1 22.4l5.9-11.1h-2.5l-3.5 6.9q-0.5 1.1-1 2.1l-0.9-2.1-3.5-6.9h-2.7l5.9 11v7.2h2.3v-7.1z m16.2-13.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaHackerNews;
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandGrabO = function FaHandGrabO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 8.6q-1.1 0-2 0.8t-0.8 2v2.9h-0.7v-2.1q0-1.1-0.7-1.8t-1.8-0.8q-1.1 0-1.8 0.8t-0.7 1.7v9.6l-0.7-0.7v-3.8q0-1.1-0.8-1.8t-1.7-0.8q-1.1 0-1.8 0.8t-0.7 1.7v5q0 1.1 0.7 1.9l7 6.6q0.8 0.8 0.8 2.3 0 0.5 0.5 1t1 0.4h14.2q0.6 0 1-0.4t0.5-1v-0.6q0-0.9 0.2-1.7l2.4-9.8q0.2-0.8 0.2-1.7v-5.5q0-1-0.7-1.8t-1.8-0.7q-1 0-1.7 0.7t-0.8 1.8v0.7h-0.7v-2.8q0-0.9-0.5-1.6t-1.5-0.9q-0.3-0.1-0.5-0.1-1 0-1.8 0.8t-0.7 1.7v2.9h-0.7v-2.7q0-1.2-0.7-2t-1.9-1q-0.1 0-0.3 0z m0-2.9q1.9 0 3.4 1.1 1.2-0.7 2.7-0.7 1.3 0 2.5 0.6t1.9 1.7q0.6-0.2 1.3-0.2 2.3 0 3.8 1.6t1.6 3.8v5.5q0 1.2-0.3 2.4l-2.4 9.8q-0.2 0.5-0.2 1.6 0 1.7-1.2 3t-3.1 1.2h-14.2q-1.9 0-3.1-1.3t-1.2-3.1l-6.9-6.7q-1.7-1.6-1.7-3.9v-5q0-2.2 1.6-3.7t3.8-1.6q0.2 0 0.3 0 0.1-2.1 1.7-3.6t3.7-1.4q1.1 0 2.2 0.5 1.6-1.6 3.8-1.6z' })
	        )
	    );
	};
	
	exports.default = FaHandGrabO;
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandLizardO = function FaHandLizardO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.3 2.6q1.2 0 2.3 0.6t1.8 1.4l11.1 15.2q2.3 3.1 2.3 7v6.9q0 1.5-1.1 2.6t-2.7 1.1h-7.4q-1.6 0-2.7-1.1t-1.1-2.6v-3.5l-5.5-2.7h-10.6q-1.6 0-2.6-1.1t-1.1-2.7v-0.6q0-2.3 1.6-3.9t4-1.7h8.1l0.8-2.5h-13.3q-1.9 0-3.4-1.3t-1.5-3.2q-1.3-1.5-1.3-3.5v-0.7q0-1.5 1.1-2.6t2.6-1.1h18.6z m15 31.1v-6.9q0-3.1-1.8-5.5l-11.2-15.2q-0.7-1-2-1h-18.6q-0.5 0-0.8 0.4t-0.4 0.8q0 0.7 0 1t0.2 0.8 0.5 0.8q0.2-0.6 0.7-1t1.1-0.3h16.1v0.6h-16.1q-0.5 0-0.9 0.4t-0.4 0.8q0 0.9 0.1 1.2 0.1 0.8 0.8 1.4t1.6 0.5h14.2q0.8 0 1.3 0.6t0.6 1.3q0 0.3-0.1 0.6l-1.3 3.7q-0.2 0.6-0.7 0.9t-1 0.4h-8.6q-1.3 0-2.2 0.9t-0.9 2.2v0.6q0 0.5 0.3 0.9t0.9 0.4h10.9q0.3 0 0.5 0.1l6.2 3.1q0.5 0.2 0.7 0.7t0.3 0.9v3.9q0 0.5 0.4 0.8t0.9 0.4h7.4q0.5 0 0.9-0.4t0.4-0.8z' })
	        )
	    );
	};
	
	exports.default = FaHandLizardO;
	module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandODown = function FaHandODown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 21.4q0-1.8-0.7-4.1t-1.4-4.3-0.7-3.7v-0.7h-14.3v0.7q0 0.8-0.3 1.5t-0.8 1.4-1 1.1-1.2 1.1q-0.2 0.2-0.4 0.3-1.8 1.6-3.2 2.5-0.5 0.3-1.5 0.8-0.1 0-0.5 0.2t-0.8 0.5-0.8 0.4-0.7 0.5-0.2 0.4q0 1.6 0.6 2.6t2.2 1q1 0 1.9-0.4t1.5-0.7 1.2-0.7 1.1-0.4v12.9q0 1.1 0.9 2t2 0.8q1.1 0 2-0.8t0.8-2v-7.4q1.1 0.8 2.3 0.8 1.6 0 2.7-1.2 0.7 0.4 1.5 0.4t1.7-0.4 1.1-1.1q0.6 0.1 1.3 0.1 1.9 0 2.8-1t0.9-3.1z m-2.8-17.1q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m5.7 17q0 3.2-1.7 5.2t-4.9 1.9l-0.1 0q-1.7 1.4-4 1.4-0.5 0-0.9-0.1-1.2 0.7-2.7 0.8v3.8q0 2.3-1.7 4t-4 1.7q-2.3 0-4-1.7t-1.7-4v-8.4q-1.2 0.5-2.9 0.5-2.7 0-4.2-1.8t-1.5-4.6q0-0.8 0.4-1.6t1.1-1.2 1.4-0.9 1.6-0.8 1.4-0.7q1.2-0.8 2.9-2.3 0 0 0.3-0.3t0.5-0.4 0.5-0.5 0.5-0.5 0.4-0.5 0.3-0.5 0.1-0.5v-6.4q0-1.2 0.9-2.1t2-0.8h14.3q1.2 0 2 0.8t0.8 2.1v6.4q0 1.3 1.3 5 1.6 4.2 1.6 7z' })
	        )
	    );
	};
	
	exports.default = FaHandODown;
	module.exports = exports['default'];

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandOLeft = function FaHandOLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.7 31.4h0.7v-14.3h-0.7q-0.8 0-1.5-0.2t-1.4-0.9-1.1-1-1.1-1.2q0-0.1-0.1-0.1t-0.1-0.1-0.1-0.1q-1.6-1.8-2.5-3.2-0.3-0.5-0.8-1.6 0 0-0.2-0.5t-0.5-0.8-0.4-0.8-0.5-0.6-0.4-0.3q-1.6 0-2.6 0.7t-1 2.2q0 0.9 0.4 1.9t0.7 1.5 0.7 1.2 0.4 1.1h-12.9q-1.1 0-2 0.8t-0.8 2q0 1.2 0.8 2.1t2 0.8h7.4q-0.3 0.4-0.6 1.1t-0.2 1.2q0 1.5 1.2 2.7-0.4 0.7-0.4 1.5t0.4 1.6 1.1 1.2q-0.1 0.5-0.1 1.3 0 1.9 1 2.8t3.1 0.9q1.8 0 4.1-0.7t4.3-1.5 3.7-0.7z m6.4-1.4q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m2.9-12.9v14.3q0 1.2-0.8 2.1t-2.1 0.8h-6.4q-1.3 0-5 1.3-4.2 1.5-7 1.5-3.2 0-5.2-1.7t-1.9-4.8l0-0.2q-1.4-1.6-1.4-3.9 0-0.5 0.1-1-0.7-1.3-0.8-2.6h-3.8q-2.3 0-4-1.7t-1.7-4.1q0-2.3 1.7-4t4-1.7h8.4q-0.5-1.3-0.5-2.8 0-2.8 1.8-4.2t4.6-1.5q0.8 0 1.5 0.3t1.3 1.2 0.9 1.4 0.8 1.6 0.7 1.3q0.8 1.3 2.3 2.9 0 0.1 0.3 0.4t0.4 0.5 0.5 0.5 0.5 0.5 0.5 0.4 0.5 0.3 0.5 0.1h6.4q1.2 0 2.1 0.8t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaHandOLeft;
	module.exports = exports['default'];

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandORight = function FaHandORight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.7 30q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m31.4-12.9q0-1.1-0.8-2t-2-0.8h-12.9q0-0.5 0.4-1.1t0.7-1.2 0.7-1.5 0.4-1.9q0-1.5-1-2.2t-2.6-0.7q-0.5 0-2 3.1-0.5 1-0.8 1.5-0.9 1.4-2.5 3.2-1.6 1.8-2.3 2.4-1.5 1.2-3.1 1.2h-0.7v14.3h0.7q1.6 0 3.7 0.7t4.3 1.5 4 0.7q4.3 0 4.3-3.7 0-0.6-0.2-1.3 0.7-0.3 1.1-1.2t0.4-1.6-0.4-1.5q1.2-1.2 1.2-2.7 0-0.6-0.2-1.2t-0.6-1.1h7.4q1.1 0 2-0.8t0.8-2.1z m2.9 0q0 2.4-1.7 4.1t-4 1.7h-3.8q-0.1 1.3-0.8 2.6 0.1 0.5 0.1 1 0 2.2-1.4 3.9 0 3.1-1.9 4.9t-5 1.8q-3 0-7.2-1.5-3.7-1.3-5-1.3h-6.4q-1.2 0-2.1-0.9t-0.8-2v-14.3q0-1.1 0.8-2t2.1-0.8h6.4q0.2 0 0.5-0.1t0.5-0.3 0.5-0.4 0.5-0.5 0.5-0.5 0.4-0.5 0.3-0.4q1.5-1.6 2.3-2.8 0.2-0.5 0.7-1.4t0.8-1.6 0.9-1.4 1.2-1.1 1.6-0.4q2.8 0 4.6 1.5t1.8 4.2q0 1.5-0.5 2.8h8.4q2.3 0 4 1.7t1.7 4z' })
	        )
	    );
	};
	
	exports.default = FaHandORight;
	module.exports = exports['default'];

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandOUp = function FaHandOUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 35.7q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m2.8-17q0-4.3-3.7-4.3-0.6 0-1.3 0.2-0.3-0.7-1.1-1.1t-1.7-0.4-1.5 0.4q-1.1-1.2-2.7-1.2-0.5 0-1.2 0.2t-1.1 0.6v-7.4q0-1.1-0.8-2t-2-0.8q-1.2 0-2 0.8t-0.9 2v12.9q-0.4 0-1.1-0.4t-1.2-0.7-1.5-0.7-1.9-0.4q-1.5 0-2.2 1t-0.6 2.6q0 0.5 3.1 2 0.9 0.5 1.4 0.8 1.4 0.9 3.2 2.5 1.9 1.6 2.4 2.3 1.3 1.5 1.3 3.1v0.7h14.3v-0.7q0-1.6 0.7-3.7t1.4-4.3 0.7-4z m2.9-0.1q0 2.9-1.6 7.1-1.3 3.7-1.3 5v6.4q0 1.2-0.8 2.1t-2 0.8h-14.3q-1.2 0-2-0.8t-0.9-2.1v-6.4q0-0.2-0.1-0.5t-0.3-0.5-0.4-0.5-0.5-0.5-0.5-0.5-0.4-0.4-0.4-0.3q-1.7-1.5-2.9-2.3-0.5-0.2-1.4-0.7t-1.6-0.8-1.4-0.9-1.1-1.2-0.4-1.6q0-2.8 1.5-4.6t4.2-1.8q1.5 0 2.9 0.5v-8.4q0-2.3 1.7-4t4-1.7q2.3 0 4 1.7t1.7 4v3.8q1.4 0.1 2.7 0.8 0.4-0.1 0.9-0.1 2.3 0 4 1.4 3.1 0 4.9 1.9t1.8 5z' })
	        )
	    );
	};
	
	exports.default = FaHandOUp;
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandPaperO = function FaHandPaperO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.6 2.9q-1 0-1.7 0.7t-0.8 1.8v14.6h-0.7v-11.8q0-1-0.7-1.7t-1.8-0.8-1.7 0.8-0.8 1.7v17.5l-3.4-4.6q-0.9-1.1-2.3-1.1-1.2 0-2 0.8t-0.8 2.1q0 0.9 0.5 1.7l8.6 11.4q0.9 1.1 2.3 1.1h15.3q0.8 0 1.4-0.4t0.8-1.3l1.7-9q0.1-0.8 0.1-1.4v-11.1q0-1-0.8-1.7t-1.7-0.8-1.8 0.8-0.7 1.7v6.1h-0.7v-11.8q0-1-0.8-1.7t-1.7-0.8-1.8 0.8-0.7 1.7v11.8h-0.8v-14.6q0-1.1-0.7-1.8t-1.8-0.7z m0-2.9q1.6 0 2.8 0.8t2 2.1q0.4 0 1 0 2.2 0 3.7 1.5t1.6 3.8v0.4q2.4-0.1 4 1.4t1.7 3.9v11.1q0 0.9-0.2 1.9l-1.6 9q-0.4 1.8-1.8 2.9t-3.2 1.2h-15.3q-1.4 0-2.6-0.6t-2-1.7l-8.6-11.4q-1.1-1.5-1.1-3.4 0-2.4 1.7-4.1t4-1.7q1.8 0 2.9 0.8v-9.7q0-2.2 1.5-3.8t3.8-1.5q0.5 0 1 0 0.7-1.3 1.9-2.1t2.8-0.8z' })
	        )
	    );
	};
	
	exports.default = FaHandPaperO;
	module.exports = exports['default'];

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandPeaceO = function FaHandPeaceO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.8 14.4q1.3 0 2.3 0.6 3.2 1.4 3.2 5v3.9q0 2.2-0.5 4.2l-1.9 7.6q-0.5 1.9-2 3.1t-3.6 1.2h-14.9q-2.3 0-4-1.7t-1.7-4v-9l-5.3-14q-0.4-1-0.4-2 0-2.4 1.7-4.1t4-1.6q1.8 0 3.3 1t2 2.7l0.4 0.9v-2.5q0-2.4 1.7-4t4-1.7 4.1 1.7 1.7 4v5.8q0.6-0.1 1-0.1 1.6 0 2.9 0.8t1.9 2.2z m-4.9-0.1q-0.7 0-1.3 0.4t-0.9 1.1l-1.7 3.6-1.6 3.5h1.2q1.2 0 2.1 0.7t1.1 1.8l3.4-7.6q0.2-0.4 0.2-1 0-1-0.7-1.8t-1.8-0.7z m5 3q-0.5 0-0.9 0.2t-0.7 0.3-0.5 0.7-0.4 0.7-0.4 0.8l-2.9 6.5q-0.2 0.4-0.2 1 0 1 0.7 1.8t1.8 0.7q0.7 0 1.3-0.4t0.9-1.1l3.6-7.8q0.2-0.4 0.2-0.9 0-1.1-0.7-1.8t-1.8-0.7z m-26-8q0 0.5 0.1 1l5.6 14.5v1.6l2.2-2.5q1-1 2.4-1h4.4l2.4-5.2v-12q0-1.2-0.8-2t-2.1-0.8-2 0.8-0.8 2v14.3h-1.4l-4.5-11.7q-0.3-0.9-1.1-1.4t-1.6-0.5q-1.2 0-2 0.9t-0.8 2z m23.4 27.8q1 0 1.8-0.6t1-1.5l1.9-7.6q0.4-1.6 0.4-3.5v-2l-3.1 6.9q-0.4 0.9-1.2 1.4t-1.7 0.5q-1.2 0-2.1-0.8t-1.1-1.9q-1 1.3-2.6 1.3h-4.6v-0.7h4.6q1.1 0 1.8-0.8t0.8-1.7-0.7-1.8-1.7-0.7h-6.6q-1.1 0-1.8 0.8l-2.8 3v6.9q0 1.2 0.8 2t2 0.8h14.9z' })
	        )
	    );
	};
	
	exports.default = FaHandPeaceO;
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandPointerO = function FaHandPointerO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.8 2.9q-1.2 0-2 0.8t-0.9 2v20l-3.3-4.5q-1-1.2-2.4-1.2-1.2 0-2 0.8t-0.8 2.1q0 0.9 0.5 1.7l8.6 11.4q0.9 1.1 2.3 1.1h16q0.5 0 0.9-0.3t0.5-0.7l2.1-8.2q0.5-2.2 0.5-4.4v-4.8q0-0.9-0.6-1.6t-1.6-0.7-1.5 0.7-0.6 1.5h-0.7v-1.4q0-1.1-0.7-1.8t-1.8-0.8q-1 0-1.8 0.8t-0.7 1.7v1.5h-0.7v-2q0-1.3-0.9-2.1t-2-0.9q-1.2 0-2 0.8t-0.8 2v2.2h-0.8v-12.8q0-1.2-0.8-2.1t-2-0.8z m0-2.9q2.4 0 4 1.7t1.7 4.1v5q0.5-0.1 0.7-0.1 2.2 0 3.9 1.6 1-0.5 2.2-0.5 2.5 0 4.1 1.9 0.6-0.1 1.2-0.1 2.1 0 3.6 1.5t1.4 3.6v4.8q0 2.6-0.6 5l-2 8.3q-0.4 1.4-1.6 2.3t-2.6 0.9h-16q-1.4 0-2.6-0.6t-2-1.7l-8.6-11.4q-1.1-1.5-1.1-3.4 0-2.4 1.7-4.1t4-1.7q1.6 0 2.9 0.8v-12.2q0-2.4 1.6-4t4.1-1.7z m2.8 31.4v-8.5h-0.7v8.5h0.7z m5.8 0v-8.5h-0.8v8.5h0.8z m5.7 0v-8.5h-0.7v8.5h0.7z' })
	        )
	    );
	};
	
	exports.default = FaHandPointerO;
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandScissorsO = function FaHandScissorsO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.9 37.1h-3.9q-3.6 0-5-3.1-0.6-1.1-0.6-2.3v-0.1q-1.3-0.7-2.2-2t-0.8-2.8q0-0.9 0.1-1.1h-5.8q-2.4 0-4-1.7t-1.7-4 1.7-4 4-1.7h2.5l-0.9-0.4q-1.7-0.6-2.7-2.1t-1-3.2q0-2.4 1.6-4.1t4.1-1.6q1 0 2 0.3l14 5.4h9q2.4 0 4 1.6t1.7 4.1v14.9q0 2-1.2 3.5t-3.1 2l-7.6 1.9q-2.1 0.5-4.2 0.5z m-1-15.8l-3.5 1.6-3.6 1.6q-0.7 0.3-1.1 0.9t-0.4 1.4q0 1 0.7 1.7t1.8 0.8q0.6 0 1-0.2l7.6-3.5q-1.1-0.2-1.8-1.1t-0.7-2v-1.2z m7.1 6.9q0-1-0.7-1.8t-1.8-0.7q-0.6 0-1 0.2l-6.5 3q-0.6 0.3-0.8 0.4t-0.7 0.3-0.7 0.6-0.3 0.6-0.2 0.9q0 1.1 0.7 1.8t1.8 0.8q0.5 0 0.9-0.2l7.8-3.6q0.7-0.3 1.1-0.9t0.4-1.4z m-5.2-16.8l-14.5-5.5q-0.5-0.2-1-0.2-1.2 0-2 0.9t-0.9 2q0 0.9 0.5 1.6t1.4 1.1l11.7 4.4v1.4h-14.3q-1.2 0-2 0.9t-0.8 2 0.8 2 2 0.9h12l5.2-2.4v-4.4q0-1.4 1-2.4l2.5-2.3h-1.6z m-0.9 22.9q1.9 0 3.5-0.4l7.6-1.9q0.9-0.3 1.5-1.1t0.6-1.7v-14.9q0-1.2-0.8-2t-2-0.9h-6.9l-3 2.8q-0.8 0.8-0.8 1.9v6.6q0 1 0.7 1.7t1.8 0.7 1.7-0.8 0.8-1.8v-4.6h0.7v4.6q0 1.6-1.3 2.5 1.2 0.2 1.9 1.1t0.8 2.1q0 1-0.5 1.8t-1.4 1.1l-6.9 3.2h2.1z' })
	        )
	    );
	};
	
	exports.default = FaHandScissorsO;
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHandSpockO = function FaHandSpockO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.9 4.1q-1 0-1.6 0.7t-0.7 1.7q0 0.3 0.1 0.5l3.1 13h-0.5l-2.4-10q-0.2-0.8-0.9-1.3t-1.4-0.5q-1 0-1.6 0.7t-0.7 1.7q0 0.2 0.1 0.6 0 0.3 0.8 3.3t1.4 5.9 0.7 2.9v4.7l-6.4-4.8q-0.7-0.5-1.6-0.5-1.1 0-1.9 0.7t-0.7 1.9q0 1.3 1.1 2.2l10.5 7.9q0.8 0.5 1.6 0.5h14.4q0.7 0 1.3-0.4t0.7-1.1l2-8.3q0.2-0.6 0.3-1.8t0.1-1.8l2.4-9.9q0.1-0.3 0.1-0.6 0-0.9-0.7-1.6t-1.6-0.7q-0.8 0-1.5 0.5t-0.8 1.3l-2.1 8.5h-0.5l2.7-11.4q0.1-0.3 0.1-0.5 0-1-0.7-1.7t-1.6-0.7q-0.8 0-1.4 0.5t-0.9 1.3l-3 12.5h-2.6l-3.4-14.2q-0.2-0.8-0.8-1.3t-1.5-0.4z m13.4 34.5h-14.4q-1.7 0-3.2-1.1l-10.5-7.8q-1-0.8-1.6-2t-0.6-2.4q0-2.2 1.6-3.8t3.7-1.5q0.5 0 1 0.1t0.9 0.2 0.8 0.5 0.8 0.4 0.8 0.7 0.7 0.5l-2.5-10.6q-0.2-0.7-0.2-1.2 0-1.9 1.3-3.4t3.1-1.6q0.3-1.8 1.7-3t3.2-1.2q1.8 0 3.1 1.1t1.8 2.7l2.1 8.9 1.7-7.2q0.5-1.7 1.8-2.8t3.1-1q1.8 0 3.1 1.1t1.8 2.9q1.9 0.2 3.2 1.6t1.3 3.3q0 0.7-0.2 1.2l-2.4 9.9q-0.1 0.5-0.1 1.4 0 1.1-0.3 2.2l-2.1 8.4q-0.4 1.5-1.6 2.5t-2.9 1z' })
	        )
	    );
	};
	
	exports.default = FaHandSpockO;
	module.exports = exports['default'];

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHashtag = function FaHashtag(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.1 22.9l1.5-5.8h-5.7l-1.4 5.8h5.6z m17.2-11.3l-1.3 5q-0.1 0.5-0.7 0.5h-7.3l-1.4 5.8h6.9q0.4 0 0.6 0.2 0.2 0.3 0.1 0.7l-1.2 5q-0.1 0.5-0.7 0.5h-7.3l-1.8 7.3q-0.2 0.5-0.7 0.5h-5q-0.4 0-0.6-0.2-0.2-0.3-0.1-0.6l1.7-7h-5.7l-1.8 7.3q-0.1 0.5-0.7 0.5h-5q-0.3 0-0.5-0.2-0.2-0.3-0.2-0.6l1.8-7h-7q-0.3 0-0.5-0.3-0.2-0.2-0.2-0.6l1.3-5q0.1-0.5 0.7-0.5h7.3l1.4-5.8h-6.9q-0.4 0-0.6-0.2-0.2-0.3-0.1-0.6l1.2-5q0.1-0.6 0.7-0.6h7.3l1.8-7.3q0.2-0.5 0.7-0.5h5q0.4 0 0.6 0.2 0.2 0.3 0.1 0.7l-1.7 6.9h5.7l1.8-7.3q0.1-0.5 0.7-0.5h5q0.3 0 0.5 0.2 0.2 0.3 0.2 0.7l-1.8 6.9h7q0.3 0 0.5 0.3 0.2 0.3 0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaHashtag;
	module.exports = exports['default'];

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHddO = function FaHddO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.2 27.1q0 0.8-0.5 1.3t-1.3 0.5-1.2-0.5-0.6-1.3 0.6-1.2 1.2-0.5 1.3 0.5 0.5 1.2z m5.7 0q0 0.8-0.5 1.3t-1.3 0.5-1.2-0.5-0.5-1.3 0.5-1.2 1.2-0.5 1.3 0.5 0.5 1.2z m2.5 3.6v-7.1q0-0.3-0.2-0.5t-0.5-0.2h-27.1q-0.3 0-0.5 0.2t-0.2 0.5v7.1q0 0.3 0.2 0.5t0.5 0.2h27.1q0.3 0 0.5-0.2t0.2-0.5z m-27.4-10.7h26.3l-3.5-10.8q-0.1-0.2-0.4-0.4t-0.5-0.2h-17.5q-0.3 0-0.6 0.2t-0.3 0.4z m30.3 3.6v7.1q0 1.5-1.1 2.5t-2.5 1.1h-27.1q-1.5 0-2.6-1.1t-1-2.5v-7.1q0-0.6 0.4-1.7l4.4-13.5q0.3-1.2 1.4-2t2.2-0.7h17.5q1.2 0 2.2 0.7t1.4 2l4.4 13.5q0.4 1.1 0.4 1.7z' })
	        )
	    );
	};
	
	exports.default = FaHddO;
	module.exports = exports['default'];

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeader = function FaHeader(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.5 37.1q-0.9 0-2.9 0t-3-0.1q-1 0-2.9 0.1t-3 0q-0.5 0-0.8-0.4t-0.3-1q0-0.7 0.4-1.1t0.8-0.3 1.2-0.2 1-0.3q0.7-0.5 0.7-3.2l0-8.7q0-0.5 0-0.7-0.3-0.1-1.1-0.1h-15.1q-0.8 0-1.1 0.1-0.1 0.2-0.1 0.7l0 8.3q0 3.2 0.8 3.7 0.4 0.2 1.1 0.2t1.3 0.1 1 0.4 0.4 1q0 0.6-0.2 1t-0.9 0.5q-1 0-3.1 0t-3.1-0.1q-0.9 0-2.8 0.1t-2.9 0q-0.5 0-0.7-0.4t-0.3-1q0-0.7 0.3-1t0.8-0.4 1.1-0.2 0.9-0.3q0.8-0.5 0.8-3.2l-0.1-1.3v-18.1q0-0.1 0.1-0.6t0-0.8-0.1-0.9-0.1-0.9-0.1-0.8-0.3-0.7-0.3-0.4q-0.3-0.3-1-0.3t-1.2-0.1-0.9-0.3-0.4-1q0-0.6 0.3-1t0.8-0.5q1 0 3.1 0t3 0.1q1 0 2.9-0.1t2.8 0q0.6 0 0.8 0.4t0.3 1.1q0 0.7-0.4 1t-0.8 0.3-1.1 0.1-1 0.3q-0.8 0.5-0.8 3.6l0 7.1q0 0.5 0.1 0.7 0.3 0.1 0.8 0.1h15.6q0.6 0 0.9-0.1 0-0.2 0-0.7l0-7.1q0-3.1-0.7-3.6-0.5-0.3-1.4-0.3t-1.4-0.3-0.6-1.1q0-0.6 0.3-1.1t0.8-0.4q1 0 3 0t2.9 0.1q1 0 2.9-0.1t2.9 0q0.5 0 0.8 0.4t0.3 1.1q0 0.7-0.4 1t-0.9 0.3-1.1 0.1-1 0.3q-0.8 0.5-0.8 3.6l0 21q0 2.7 0.8 3.1 0.3 0.3 1 0.3t1.2 0.1 0.9 0.4 0.4 1q0 0.6-0.2 1t-0.9 0.5z' })
	        )
	    );
	};
	
	exports.default = FaHeader;
	module.exports = exports['default'];

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeadphones = function FaHeadphones(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 19.8q0 3.7-1.3 7l-0.4 1.1-4.2 0.7q-0.5 1.9-2 3.1t-3.5 1.2v0.7q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-12.9q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5v0.7q1.6 0 2.9 0.8t2.1 2.2l1.5-0.3q0.7-2.1 0.7-4.3 0-3.3-2-6.3t-5.3-4.6-7-1.8-7.1 1.8-5.2 4.6-2 6.3q0 2.2 0.6 4.3l1.6 0.2q0.7-1.3 2-2.1t2.9-0.8v-0.7q0-0.3 0.2-0.5t0.5-0.2h1.5q0.3 0 0.5 0.2t0.2 0.5v12.9q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-0.7q-1.9 0-3.5-1.2t-2-3.1l-4.1-0.7-0.5-1.1q-1.3-3.3-1.3-7 0-3.4 1.5-6.5t4-5.4 5.9-3.7 7.2-1.3 7.1 1.3 6 3.7 4 5.4 1.5 6.5z' })
	        )
	    );
	};
	
	exports.default = FaHeadphones;
	module.exports = exports['default'];

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeartO = function FaHeartO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.1 13.3q0-1.8-0.4-3.2t-1.3-2.2-1.8-1.3-2.1-0.7-2.2-0.2-2.5 0.6-2.4 1.4-2 1.6-1.3 1.4q-0.4 0.5-1.1 0.5t-1.1-0.5q-0.5-0.6-1.3-1.4t-2-1.6-2.4-1.4-2.5-0.6-2.2 0.2-2.1 0.7-1.8 1.3-1.3 2.2-0.4 3.2q0 3.8 4.1 7.9l13 12.5 12.9-12.4q4.2-4.2 4.2-8z m2.9 0q0 4.9-5.1 10l-13.9 13.4q-0.4 0.4-1 0.4t-1-0.4l-13.9-13.4q-0.2-0.2-0.6-0.6t-1.3-1.4-1.5-2.2-1.2-2.7-0.5-3.1q0-4.9 2.8-7.7t7.9-2.7q1.4 0 2.8 0.4t2.7 1.3 2.1 1.6 1.7 1.5q0.8-0.8 1.7-1.5t2.1-1.6 2.7-1.3 2.8-0.4q5 0 7.9 2.7t2.8 7.7z' })
	        )
	    );
	};
	
	exports.default = FaHeartO;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeart = function FaHeart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 37.1q-0.6 0-1-0.4l-13.9-13.4q-0.2-0.2-0.6-0.6t-1.3-1.4-1.5-2.2-1.2-2.7-0.5-3.1q0-4.9 2.8-7.7t7.9-2.7q1.4 0 2.8 0.4t2.7 1.3 2.1 1.6 1.7 1.5q0.8-0.8 1.7-1.5t2.1-1.6 2.7-1.3 2.8-0.4q5 0 7.9 2.7t2.8 7.7q0 4.9-5.1 10l-13.9 13.4q-0.4 0.4-1 0.4z' })
	        )
	    );
	};
	
	exports.default = FaHeart;
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHeartbeat = function FaHeartbeat(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 22.9h6.8q-0.1 0.1-0.2 0.2t-0.2 0.2l-0.1 0-13.9 13.4q-0.4 0.4-1 0.4t-1-0.4l-13.9-13.4q-0.1 0-0.5-0.4h8.3q0.4 0 0.8-0.3t0.5-0.8l1.6-6.3 4.2 14.9q0.2 0.4 0.6 0.7t0.8 0.3q0.5 0 0.9-0.3t0.5-0.7l3.2-10.8 1.3 2.5q0.4 0.8 1.3 0.8z m11.4-9.6q0 3.2-2.3 6.7h-8.2l-2.5-4.9q-0.2-0.4-0.6-0.6t-0.8-0.2q-1 0.1-1.2 1l-2.9 9.6-4.4-15.3q-0.1-0.4-0.5-0.7t-0.9-0.3-0.9 0.3-0.5 0.7l-2.6 10.4h-9.4q-2.3-3.5-2.3-6.7 0-4.9 2.8-7.7t7.9-2.7q1.4 0 2.8 0.4t2.7 1.3 2.1 1.6 1.7 1.5q0.8-0.8 1.7-1.5t2.1-1.6 2.7-1.3 2.8-0.4q5 0 7.9 2.7t2.8 7.7z' })
	        )
	    );
	};
	
	exports.default = FaHeartbeat;
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHistory = function FaHistory(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 20q0 3.5-1.4 6.7t-3.6 5.4-5.5 3.7-6.7 1.3q-3.8 0-7.3-1.6t-5.8-4.5q-0.2-0.3-0.2-0.5t0.2-0.5l3.1-3.1q0.2-0.2 0.5-0.2 0.4 0.1 0.5 0.3 1.7 2.1 4 3.3t5 1.1q2.4 0 4.5-0.9t3.6-2.4 2.5-3.7 0.9-4.4-0.9-4.4-2.5-3.7-3.6-2.4-4.5-0.9q-2.1 0-4.2 0.8t-3.5 2.2l3 3.1q0.7 0.7 0.3 1.6-0.3 0.8-1.3 0.8h-10q-0.5 0-1-0.4t-0.4-1v-10q0-0.9 0.9-1.3 0.9-0.4 1.5 0.3l2.9 2.9q2.4-2.3 5.5-3.5t6.3-1.2q3.5 0 6.7 1.3t5.5 3.7 3.6 5.4 1.4 6.7z m-14.3-6.4v10q0 0.3-0.2 0.5t-0.5 0.2h-7.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h5v-7.8q0-0.3 0.2-0.5t0.6-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaHistory;
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHome = function FaHome(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.9 22.1v10.8q0 0.5-0.4 1t-1 0.4h-8.6v-8.6h-5.7v8.6h-8.6q-0.5 0-1-0.4t-0.4-1v-10.8q0 0 0 0t0-0.1l12.9-10.6 12.8 10.6q0 0.1 0 0.1z m5-1.5l-1.4 1.7q-0.2 0.2-0.4 0.2h-0.1q-0.3 0-0.5-0.2l-15.4-12.8-15.5 12.8q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-1.4-1.7q-0.1-0.2-0.1-0.5t0.2-0.5l16.1-13.4q0.7-0.6 1.7-0.6t1.7 0.6l5.4 4.6v-4.4q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v9.1l4.9 4.1q0.2 0.2 0.3 0.5t-0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaHome;
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHospitalO = function FaHospitalO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 29.3v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m5.7 0v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.5q0.2 0 0.5 0.3t0.2 0.5z m17.1 11.4v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.4q0-0.3 0.3-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.5q0.3 0 0.5 0.3t0.2 0.5z m11.4 5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m-5.7-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.3-0.5v-1.4q0-0.3 0.3-0.5t0.5-0.3h1.4q0.3 0 0.5 0.3t0.2 0.5z m5.7 0v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h1.4q0.3 0 0.5 0.3t0.2 0.5z m-5.7 19.2h8.6v-25.7h-5.7v0.7q0 0.9-0.7 1.6t-1.5 0.6h-10q-0.9 0-1.5-0.6t-0.6-1.6v-0.7h-5.7v25.7h8.5v-5q0-0.2 0.2-0.5t0.5-0.2h7.2q0.3 0 0.5 0.2t0.2 0.5v5z m0-26.4v-7.1q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.3 0.5v2.1h-2.8v-2.1q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.2 0-0.5 0.2t-0.2 0.5v7.1q0 0.3 0.2 0.5t0.5 0.2h1.5q0.3 0 0.5-0.2t0.2-0.5v-2.1h2.8v2.1q0 0.3 0.3 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m11.4-0.7v28.6q0 0.5-0.4 1t-1 0.4h-28.6q-0.6 0-1-0.4t-0.4-1v-28.6q0-0.6 0.4-1t1-0.4h7.2v-6.5q0-0.8 0.6-1.5t1.5-0.6h10q0.9 0 1.5 0.6t0.7 1.5v6.5h7.1q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaHospitalO;
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHourglass1 = function FaHourglass1(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 2.9q0 5.8-2.3 10.3t-6 6.8q3.6 2.4 6 6.8t2.3 10.3h2.2q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h2.2q0-5.8 2.3-10.3t6-6.8q-3.6-2.4-6-6.8t-2.3-10.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h32.9q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-2.2z m-2.8 0h-22.9q0 1.4 0.2 2.8h22.5q0.2-1.3 0.2-2.8z m0 34.2q0-2.9-0.8-5.5t-2-4.7-2.8-3.4-3.3-2.1h-5.1q-1.7 0.7-3.3 2.1t-2.8 3.4-2 4.7-0.8 5.5h22.9z' })
	        )
	    );
	};
	
	exports.default = FaHourglass1;
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHourglass2 = function FaHourglass2(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 2.9q0 5.8-2.3 10.3t-6 6.8q3.6 2.4 6 6.8t2.3 10.3h2.2q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h2.2q0-5.8 2.3-10.3t6-6.8q-3.6-2.4-6-6.8t-2.3-10.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h32.9q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-2.2z m-2.8 0h-22.9q0 4.6 1.9 8.5h19.1q1.9-3.9 1.9-8.5z m-1.3 27.1q-1.2-3.1-3.2-5.4t-4.4-3.2h-5.1q-2.3 1-4.4 3.2t-3.2 5.4h20.3z' })
	        )
	    );
	};
	
	exports.default = FaHourglass2;
	module.exports = exports['default'];

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHourglass3 = function FaHourglass3(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 2.9q0 5.8-2.3 10.3t-6 6.8q3.6 2.4 6 6.8t2.3 10.3h2.2q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h2.2q0-5.8 2.3-10.3t6-6.8q-3.6-2.4-6-6.8t-2.3-10.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h32.9q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-2.2z m-11.9 15.8q1.7-0.7 3.3-2.1t2.9-3.4 2.1-4.7 0.8-5.6h-22.9q0 2.9 0.8 5.6t2.1 4.7 2.9 3.4 3.3 2.1q0.4 0.1 0.7 0.5t0.2 0.8-0.2 0.8-0.7 0.5q-3.1 1.2-5.5 4.4h15.7q-2.4-3.2-5.5-4.4-0.4-0.1-0.7-0.5t-0.2-0.8 0.2-0.8 0.7-0.5z' })
	        )
	    );
	};
	
	exports.default = FaHourglass3;
	module.exports = exports['default'];

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHourglassO = function FaHourglassO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 2.9q0 5.8-2.3 10.3t-6 6.8q3.6 2.4 6 6.8t2.3 10.3h2.2q0.3 0 0.5 0.2t0.2 0.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h2.2q0-5.8 2.3-10.3t6-6.8q-3.6-2.4-6-6.8t-2.3-10.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h32.9q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-2.2z m-11.9 15.8q1.7-0.7 3.3-2.1t2.9-3.4 2.1-4.7 0.8-5.6h-22.9q0 2.9 0.8 5.6t2.1 4.7 2.9 3.4 3.3 2.1q0.4 0.1 0.7 0.5t0.2 0.8-0.2 0.8-0.7 0.5q-1.7 0.7-3.3 2.1t-2.9 3.4-2.1 4.7-0.8 5.6h22.9q0-2.9-0.8-5.6t-2.1-4.7-2.9-3.4-3.3-2.1q-0.4-0.1-0.7-0.5t-0.2-0.8 0.2-0.8 0.7-0.5z' })
	        )
	    );
	};
	
	exports.default = FaHourglassO;
	module.exports = exports['default'];

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHourglass = function FaHourglass(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.6 35.7q0.3 0 0.5 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h32.9z m-30.7-1.4q0.1-1.2 0.4-2.4t0.6-2.1 1.1-2 1.2-1.7 1.4-1.5 1.5-1.4 1.5-1.2 1.5-1 1.5-1q-1-0.6-1.5-1t-1.5-1-1.5-1.2-1.5-1.4-1.4-1.5-1.2-1.7-1.1-2-0.6-2.1-0.4-2.4h28.5q-0.1 1.2-0.4 2.4t-0.6 2.1-1.1 2-1.2 1.7-1.4 1.5-1.5 1.4-1.6 1.2-1.4 1-1.5 1q1 0.6 1.5 1t1.4 1 1.6 1.3 1.5 1.3 1.4 1.5 1.2 1.7 1.1 2 0.6 2.1 0.4 2.4h-28.5z m30.7-34.3q0.3 0 0.5 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.5 0.2h-32.9q-0.3 0-0.5-0.2t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h32.9z' })
	        )
	    );
	};
	
	exports.default = FaHourglass;
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHouzz = function FaHouzz(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 26.6l11.5-6.6v13.2l-11.5 6.6v-13.2z m-11.4-6.6v13.2l11.4-6.6z m11.4-19.8v13.2l-11.4 6.6v-13.2z m0 13.2l11.5-6.6v13.2z' })
	        )
	    );
	};
	
	exports.default = FaHouzz;
	module.exports = exports['default'];

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaHtml5 = function FaHtml5(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.7 13.3l0.4-3.9h-19.8l1.1 11.9h13.7l-0.5 5.1-4.4 1.2-4.4-1.2-0.3-3.1h-3.9l0.5 6.2 8.1 2.2h0.1v0l8-2.2 1.1-12.1h-14.4l-0.3-4.1h15z m-25.2-10.4h31.4l-2.8 32.1-12.9 3.6-12.8-3.6z' })
	        )
	    );
	};
	
	exports.default = FaHtml5;
	module.exports = exports['default'];

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaICursor = function FaICursor(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 2.9q-7.2 0-7.2 5v9.2h2.9v2.9h-2.9v12.1q0 5 7.2 5h1.4v2.9h-1.4q-6.1 0-8.6-3.3-2.5 3.3-8.6 3.3h-1.4v-2.9h1.4q7.2 0 7.2-5v-12.1h-2.9v-2.9h2.9v-9.2q0-5-7.2-5h-1.4v-2.9h1.4q6.1 0 8.6 3.3 2.5-3.3 8.6-3.3h1.4v2.9h-1.4z' })
	        )
	    );
	};
	
	exports.default = FaICursor;
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIls = function FaIls(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.6 13.9v11.1q0 0.3-0.2 0.5t-0.5 0.2h-3.5q-0.4 0-0.6-0.2t-0.2-0.5v-11.1q0-2.5-1.7-4.3t-4.3-1.7h-6.1v25.7q0 0.3-0.2 0.5t-0.5 0.2h-3.6q-0.3 0-0.5-0.2t-0.2-0.5v-30q0-0.3 0.2-0.5t0.5-0.2h10.4q3 0 5.5 1.4t4.1 4.1 1.4 5.5z m8.6-10.3v19.6q0 3-1.5 5.6t-4 4-5.6 1.5h-10.3q-0.3 0-0.5-0.2t-0.2-0.5v-21.5q0-0.3 0.2-0.5t0.5-0.2h3.6q0.3 0 0.5 0.2t0.2 0.5v17.2h6q2.5 0 4.3-1.8t1.8-4.3v-19.6q0-0.3 0.2-0.5t0.5-0.2h3.6q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaIls;
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaImage = function FaImage(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.3 13.4q0 1.6-1.2 2.8t-2.8 1.1-2.8-1.1-1.2-2.8 1.2-2.9 2.8-1.1 2.8 1.1 1.2 2.9z m21.3 7.9v9.3h-29.3v-4l6.7-6.6 3.3 3.3 10.6-10.6z m1.9-14.6h-33.2q-0.2 0-0.4 0.2t-0.2 0.5v25.2q0 0.3 0.2 0.5t0.4 0.2h33.2q0.3 0 0.5-0.2t0.2-0.5v-25.2q0-0.3-0.2-0.5t-0.5-0.2z m3.4 0.7v25.2q0 1.4-1 2.4t-2.4 0.9h-33.2q-1.3 0-2.3-0.9t-1-2.4v-25.2q0-1.4 1-2.4t2.3-0.9h33.2q1.4 0 2.4 0.9t1 2.4z' })
	        )
	    );
	};
	
	exports.default = FaImage;
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInbox = function FaInbox(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.8 21.4h7.1q0 0-0.1-0.1t0-0.2l-4.8-11.1h-15.8l-4.7 11.1q0 0 0 0.2t-0.1 0.1h7.1l2.1 4.3h7.1z m11.5 0.7v10.8q0 0.5-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-10.8q0-1.4 0.6-2.7l5.3-12.4q0.2-0.5 0.8-0.9t1.2-0.4h18.5q0.6 0 1.2 0.4t0.8 0.9l5.3 12.4q0.6 1.3 0.6 2.7z' })
	        )
	    );
	};
	
	exports.default = FaInbox;
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIndent = function FaIndent(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm7.9 18.6q0 0.3-0.2 0.5l-6.5 6.4q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2t-0.2-0.5v-12.9q0-0.2 0.2-0.5t0.5-0.2q0.3 0 0.5 0.2l6.5 6.5q0.2 0.2 0.2 0.5z m32.1 10.7v4.3q0 0.3-0.2 0.5t-0.5 0.2h-38.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h38.6q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-24.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h24.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-24.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h24.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.5v4.3q0 0.2-0.2 0.5t-0.5 0.2h-38.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h38.6q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaIndent;
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIndustry = function FaIndustry(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10 0q0.6 0 1 0.4t0.4 1v19.9l12-9.6q0.4-0.3 0.9-0.3 0.6 0 1 0.5t0.4 1v8.4l12-9.6q0.4-0.3 0.9-0.3 0.5 0 1 0.5t0.4 1v25.7q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-37.2q0-0.6 0.4-1t1-0.4h8.6z' })
	        )
	    );
	};
	
	exports.default = FaIndustry;
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInfoCircle = function FaInfoCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 30.7v-3.6q0-0.3-0.2-0.5t-0.6-0.2h-2.1v-11.4q0-0.3-0.2-0.5t-0.5-0.2h-7.2q-0.3 0-0.5 0.2t-0.2 0.5v3.6q0 0.3 0.2 0.5t0.5 0.2h2.2v7.1h-2.2q-0.3 0-0.5 0.2t-0.2 0.5v3.6q0 0.3 0.2 0.5t0.5 0.2h10q0.4 0 0.6-0.2t0.2-0.5z m-2.9-20v-3.6q0-0.3-0.2-0.5t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v3.6q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m14.3 9.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaInfoCircle;
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInfo = function FaInfo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.3 30v2.9q0 0.5-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h1.5v-8.6h-1.5q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h8.6q0.6 0 1 0.4t0.4 1v12.9h1.5q0.5 0 1 0.4t0.4 1z m-2.9-25.7v4.3q0 0.6-0.4 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.4-1v-4.3q0-0.6 0.4-1t1-0.4h5.7q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaInfo;
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInr = function FaInr(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30 10.5v2.3q0 0.3-0.2 0.5t-0.5 0.2h-3.7q-0.5 3.2-2.9 5.2t-6.2 2.5q3.8 3.9 10.3 11.9 0.3 0.4 0.1 0.8-0.2 0.4-0.7 0.4h-4.3q-0.4 0-0.6-0.3-6.8-8.2-11.1-12.7-0.2-0.2-0.2-0.5v-2.9q0-0.2 0.2-0.5t0.5-0.2h2.5q3 0 4.8-0.9t2.2-2.8h-9.5q-0.3 0-0.5-0.2t-0.2-0.5v-2.3q0-0.3 0.2-0.5t0.5-0.2h9.2q-1.2-2.5-6-2.5h-3.2q-0.3 0-0.5-0.3t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h18.6q0.3 0 0.5 0.2t0.2 0.5v2.2q0 0.4-0.2 0.6t-0.5 0.2h-5.2q1 1.3 1.4 3.2h3.8q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaInr;
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInstagram = function FaInstagram(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.4 31.8v-14.4h-3q0.4 1.4 0.4 2.9 0 2.8-1.4 5.2t-3.9 3.7-5.3 1.4q-4.4 0-7.6-3t-3.1-7.3q0-1.5 0.5-2.9h-3.2v14.4q0 0.6 0.4 1t1 0.4h23.8q0.6 0 1-0.4t0.4-1z m-6.3-11.9q0-2.7-2.1-4.7t-4.8-1.9q-2.9 0-4.9 1.9t-2 4.7 2 4.8 4.9 1.9q2.8 0 4.8-1.9t2.1-4.8z m6.3-8v-3.7q0-0.6-0.4-1.1t-1.1-0.4h-3.9q-0.7 0-1.1 0.4t-0.5 1.1v3.7q0 0.6 0.5 1.1t1.1 0.4h3.9q0.6 0 1.1-0.4t0.4-1.1z m3.9-4.6v25.4q0 1.9-1.3 3.1t-3.1 1.3h-25.5q-1.8 0-3.1-1.3t-1.3-3.1v-25.4q0-1.9 1.3-3.1t3.1-1.3h25.5q1.8 0 3.1 1.3t1.3 3.1z' })
	        )
	    );
	};
	
	exports.default = FaInstagram;
	module.exports = exports['default'];

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaInternetExplorer = function FaInternetExplorer(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 20.9q0 1.3-0.2 2.3h-25.6q0 3.3 2.4 5.5t5.7 2.2q2.3 0 4.2-1t3-3h9.5q-1.3 3.6-3.8 6.3t-6 4.2-7.2 1.5q-4.1 0-7.9-1.8-5.1 2.5-8.8 2.5-5.3 0-5.3-5.8 0-2.6 1-6.2 0.4-1.3 2.4-5.1 4.5-8 10.6-13.5-4.1 1.8-9.5 7.9 1.4-6.1 6.3-10t11.2-4q0.7 0 1 0.1 5.7-2.6 9.7-2.6 1.4 0 2.6 0.2t2.1 0.9 1.5 1.8 0.5 2.5q0 2.6-1.7 6.4 2.3 4.1 2.3 8.7z m-1.6-14.3q0-1.8-1.1-2.9t-3.1-1.1q-2.4 0-5.7 1.6 2.7 1 5 2.9t3.8 4.3q1.1-3 1.1-4.8z m-35.5 27.6q0 2 1 3t3 1q2.6 0 6-1.8-2.7-1.6-4.8-4.1t-3.1-5.5q-2.1 4.6-2.1 7.4z m11.2-15.9h16.3q-0.2-3.1-2.6-5.3t-5.6-2.1q-3.2 0-5.6 2.1t-2.5 5.3z' })
	        )
	    );
	};
	
	exports.default = FaInternetExplorer;
	module.exports = exports['default'];

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIntersex = function FaIntersex(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.4 0.7q0-0.3 0.2-0.5t0.5-0.2h6.4q0.6 0 1 0.4t0.4 1v6.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-3l-5.7 5.7q2.8 3.5 2.8 8 0 4.9-3.3 8.6t-8.1 4.1v3h2.1q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v2.2q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-2.2h-2.1q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h2.1v-3q-3.3-0.3-6-2.3t-4.2-4.9-1.2-6.6q0.4-4.5 3.6-7.8t7.8-3.9q2.6-0.3 5.1 0.4t4.4 2.3l5.7-5.6h-3q-0.3 0-0.5-0.2t-0.2-0.6v-1.4z m-10 27.9q4.1 0 7-3t3-7-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7 7.1 3z' })
	        )
	    );
	};
	
	exports.default = FaIntersex;
	module.exports = exports['default'];

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIoxhost = function FaIoxhost(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.4 18.8q0 0.6-0.5 1.1t-1.2 0.5h-13.6q-0.7 0-1.2-0.5t-0.5-1.1 0.5-1.2 1.2-0.5h13.6q0.7 0 1.2 0.5t0.5 1.2z m4.2 0q0-1.7-0.5-3.3h-19.1q-0.7 0-1.1-0.5t-0.5-1.2q0-0.7 0.5-1.2t1.1-0.5h17.7q-1.7-2.7-4.6-4.4t-6.2-1.6q-3.4 0-6.4 1.7t-4.6 4.6-1.7 6.4q0 1.6 0.5 3.3h19q0.7 0 1.2 0.4t0.5 1.2q0 0.7-0.5 1.2t-1.2 0.5h-17.6q1.7 2.8 4.6 4.4t6.2 1.6q2.6 0 4.9-1t4-2.7 2.7-4 1-4.9z m7.2-5q0 0.7-0.5 1.2t-1.2 0.5h-2.6q0.4 1.6 0.4 3.3 0 3.2-1.3 6.2t-3.4 5.1-5.1 3.4-6.2 1.3q-4.8 0-8.7-2.6t-5.9-6.8h-3.6q-0.7 0-1.2-0.5t-0.5-1.2q0-0.7 0.5-1.2t1.2-0.4h2.5q-0.3-1.7-0.3-3.3 0-3.3 1.3-6.2t3.4-5.1 5.1-3.5 6.2-1.2q4.7 0 8.7 2.5t5.8 6.8h3.7q0.7 0 1.2 0.5t0.4 1.2z' })
	        )
	    );
	};
	
	exports.default = FaIoxhost;
	module.exports = exports['default'];

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaItalic = function FaItalic(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.5 37.1l0.4-1.9q0.1 0 1.8-0.5t2.5-0.8q0.6-0.8 0.9-2.3 0-0.1 1.4-6.4t2.5-12.2 1.2-6.6v-0.5q-0.5-0.3-1.2-0.4t-1.6-0.2-1.3-0.1l0.5-2.3q0.7 0 2.6 0.1t3.4 0.2 2.7 0q1 0 2.2 0t2.7-0.2 2.2-0.1q-0.2 0.8-0.5 1.9-0.6 0.3-2.2 0.7t-2.5 0.7q-0.1 0.4-0.3 1t-0.2 0.9-0.1 1-0.2 0.9q-0.6 3.3-1.9 9.4t-1.8 7.9q0 0.2-0.3 1.3t-0.4 2-0.4 1.9-0.1 1.3l0 0.4q0.4 0.1 4.2 0.7-0.1 0.9-0.4 2.2-0.2 0-0.7 0t-0.7 0q-0.7 0-2-0.2t-1.9-0.2q-3.1 0-4.6 0-1.1 0-3.2 0.2t-2.7 0.2z' })
	        )
	    );
	};
	
	exports.default = FaItalic;
	module.exports = exports['default'];

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaJoomla = function FaJoomla(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.9 23.9l-3.6 3.6-3.4 3.4-0.6 0.7q-1.5 1.4-3.4 1.9t-3.8 0.1q-0.4 1.5-1.6 2.5t-2.9 1q-1.9 0-3.3-1.3t-1.3-3.3q0-1.6 1-2.8t2.5-1.6q-0.5-1.9 0-3.9t2-3.4l0.3-0.2 3.4 3.4-0.3 0.2q-0.8 0.8-0.8 2t0.8 2q0.8 0.8 2 0.8t2-0.8l0.6-0.7 3.4-3.4 3.6-3.5z m-7.6-15.2l0.2 0.3-3.4 3.4-0.2-0.3q-0.8-0.8-2-0.8t-2 0.8-0.8 2 0.8 2l7.6 7.6-3.4 3.4-3.6-3.5-3.3-3.4-0.7-0.7q-1.5-1.5-2-3.6t0.1-4q-1.6-0.3-2.6-1.6t-1-2.8q0-1.9 1.4-3.3t3.2-1.3q1.7 0 3 1.1t1.6 2.7q1.8-0.4 3.7 0.1t3.4 1.9z m18 23.8q0 1.9-1.4 3.3t-3.2 1.3q-1.6 0-2.9-1t-1.6-2.6q-1.9 0.6-4 0.1t-3.6-2l-0.3-0.3 3.4-3.4 0.3 0.3q0.8 0.8 2 0.8t2-0.8 0.8-2-0.8-2l-7.7-7.6 3.4-3.4 7 7 0.6 0.6q1.5 1.5 2 3.4t0 3.8q1.7 0.3 2.9 1.5t1.1 3z m-0.1-25q0 1.7-1.1 3t-2.8 1.5q0.5 1.9 0 3.9t-2 3.6l-0.2 0.3-3.4-3.4 0.3-0.3q0.8-0.8 0.8-2t-0.8-2-2-0.8-2 0.8l-7.7 7.7-3.3-3.4 3.6-3.6 3.3-3.4 0.7-0.7q1.5-1.5 3.5-2t4 0.1q0.3-1.7 1.5-2.8t3.1-1.1q1.9 0 3.2 1.3t1.3 3.3z' })
	        )
	    );
	};
	
	exports.default = FaJoomla;
	module.exports = exports['default'];

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaJsfiddle = function FaJsfiddle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.9 17.6q2.2 0.9 3.5 2.8t1.4 4.3q0 3.2-2.3 5.5t-5.6 2.2q0 0-0.2 0t-0.2 0h-23.6q-3.3-0.2-5.6-2.4t-2.3-5.5q0-2.1 1.1-3.9t2.8-2.9q-0.2-0.7-0.2-1.6 0-2.2 1.6-3.8t3.8-1.5q1.9 0 3.4 1.1 1.4-3 4.3-4.8t6.3-1.8q3.3 0 6 1.5t4.3 4.3 1.6 5.8q0 0.1-0.1 0.3t0 0.4z m-25.8 5.2q0 2.3 1.6 3.7t4.1 1.4q2.6 0 4.6-1.9-0.3-0.4-0.9-1.1t-0.9-1q-1.3 1.2-2.8 1.2-1 0-1.8-0.6t-0.7-1.7q0-1 0.7-1.7t1.8-0.7q0.9 0 1.6 0.5t1.5 1 1.2 1.5 1.4 1.6 1.5 1.4 1.8 1.1 2.4 0.4q2.4 0 4-1.4t1.6-3.7q0-2.3-1.6-3.7t-4.1-1.4q-2.7 0-4.6 1.9 0.2 0.3 0.5 0.7t0.7 0.7 0.6 0.7q1.3-1.3 2.7-1.3 1 0 1.8 0.7t0.8 1.6q0 1.1-0.7 1.8t-1.9 0.7q-0.8 0-1.6-0.4t-1.4-1.1-1.2-1.5-1.4-1.6-1.5-1.4-1.8-1.1-2.3-0.4q-2.4 0-4.1 1.4t-1.6 3.7z' })
	        )
	    );
	};
	
	exports.default = FaJsfiddle;
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaKey = function FaKey(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.6 11.4q0-1.8-1.3-3t-3-1.3-3.1 1.3-1.2 3q0 1 0.4 1.9-0.9-0.4-1.8-0.4-1.8 0-3.1 1.2t-1.2 3 1.2 3.1 3.1 1.2 3-1.2 1.3-3.1q0-0.9-0.5-1.8 0.9 0.4 1.9 0.4 1.8 0 3-1.2t1.3-3.1z m19 15.7q0 0.4-1.1 1.5t-1.5 1.1q-0.2 0-0.6-0.3t-0.9-0.8-0.8-0.9-0.6-0.6l-2.1 2.2 4.9 4.9q0.6 0.6 0.6 1.5 0 1-0.8 1.8t-1.8 0.9q-0.9 0-1.6-0.6l-14.9-15q-4 2.9-8.2 2.9-3.6 0-5.9-2.3t-2.3-5.9q0-3.6 2.1-7t5.6-5.5 6.9-2.1q3.7 0 6 2.2t2.3 6q0 4.2-3 8.1l8 7.9 2.1-2.1q-0.1-0.1-0.6-0.5t-0.9-0.9-0.7-0.8-0.4-0.7q0-0.3 1.1-1.4t1.5-1.1q0.3 0 0.5 0.2 0.1 0.1 1 1t1.9 1.8 1.9 1.9 1.6 1.7 0.7 0.9z' })
	        )
	    );
	};
	
	exports.default = FaKey;
	module.exports = exports['default'];

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaKeyboardO = function FaKeyboardO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8 25.6v2q0 0.4-0.4 0.4h-2q-0.3 0-0.3-0.4v-2q0-0.3 0.3-0.3h2q0.4 0 0.4 0.3z m2.6-5.3v2q0 0.4-0.3 0.4h-4.7q-0.3 0-0.3-0.4v-2q0-0.3 0.3-0.3h4.7q0.3 0 0.3 0.3z m-2.6-5.3v2q0 0.3-0.4 0.3h-2q-0.3 0-0.3-0.3v-2q0-0.3 0.3-0.3h2q0.4 0 0.4 0.3z m21.2 10.6v2q0 0.4-0.3 0.4h-17.9q-0.4 0-0.4-0.4v-2q0-0.3 0.4-0.3h17.9q0.3 0 0.3 0.3z m-13.3-5.3v2q0 0.4-0.3 0.4h-2q-0.3 0-0.3-0.4v-2q0-0.3 0.3-0.3h2q0.3 0 0.3 0.3z m-2.6-5.3v2q0 0.3-0.3 0.3h-2q-0.4 0-0.4-0.3v-2q0-0.3 0.4-0.3h2q0.3 0 0.3 0.3z m8 5.3v2q0 0.4-0.4 0.4h-2q-0.3 0-0.3-0.4v-2q0-0.3 0.3-0.3h2q0.4 0 0.4 0.3z m-2.7-5.3v2q0 0.3-0.3 0.3h-2q-0.4 0-0.4-0.3v-2q0-0.3 0.4-0.3h2q0.3 0 0.3 0.3z m8 5.3v2q0 0.4-0.4 0.4h-1.9q-0.4 0-0.4-0.4v-2q0-0.3 0.4-0.3h1.9q0.4 0 0.4 0.3z m8 5.3v2q0 0.4-0.4 0.4h-2q-0.3 0-0.3-0.4v-2q0-0.3 0.3-0.3h2q0.4 0 0.4 0.3z m-10.7-10.6v2q0 0.3-0.3 0.3h-2q-0.3 0-0.3-0.3v-2q0-0.3 0.3-0.3h2q0.3 0 0.3 0.3z m5.3 0v2q0 0.3-0.3 0.3h-2q-0.3 0-0.3-0.3v-2q0-0.3 0.3-0.3h2q0.3 0 0.3 0.3z m5.4 0v7.3q0 0.4-0.4 0.4h-4.6q-0.4 0-0.4-0.4v-2q0-0.3 0.4-0.3h2.3v-5q0-0.3 0.3-0.3h2q0.3 0 0.3 0.3z m2.6 15.6v-18.6h-34.5v18.6h34.5z m2.7-18.6v18.6q0 1.1-0.8 1.9t-1.9 0.8h-34.5q-1.1 0-1.9-0.8t-0.8-1.9v-18.6q0-1.1 0.8-1.9t1.9-0.7h34.5q1.1 0 1.9 0.7t0.8 1.9z' })
	        )
	    );
	};
	
	exports.default = FaKeyboardO;
	module.exports = exports['default'];

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaKrw = function FaKrw(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.5 26.7l1.8-6.7h-3.6l1.7 6.7q0 0 0 0.1t0.1 0q0 0 0 0t0-0.1z m2.6-9.6l0.7-2.8h-6.5l0.7 2.8h5.1z m4.2 0h3.2l-0.8-2.8h-1.6z m10.1 9.6l1.7-6.7h-3.6l1.8 6.7q0 0 0 0.1t0 0q0 0 0.1 0t0-0.1z m2.4-9.6l0.8-2.8h-6.6l0.7 2.8h5.2z m9.2 0.8v1.4q0 0.3-0.2 0.5t-0.5 0.2h-4.8l-3.6 13.7q-0.2 0.6-0.7 0.6h-3.6q-0.5 0-0.7-0.6l-3.7-13.7h-4.6l-3.8 13.8q-0.1 0.5-0.7 0.5h-3.5q-0.2 0-0.4-0.2t-0.3-0.3l-3.5-13.8h-4.7q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h3.9l-0.7-2.8h-3.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h2.4l-1.9-7.6q-0.2-0.4 0.1-0.7 0.2-0.2 0.6-0.2h3q0.6 0 0.7 0.5l2 8h8l2.2-8q0.1-0.5 0.7-0.5h2.8q0.5 0 0.7 0.5l2.2 8h8.1l2.1-8q0.1-0.5 0.7-0.5h3q0.4 0 0.6 0.2 0.2 0.3 0.1 0.7l-2 7.6h2.5q0.3 0 0.5 0.2t0.2 0.5v1.5q0 0.3-0.2 0.5t-0.5 0.2h-3.3l-0.7 2.8h4q0.3 0 0.5 0.2t0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaKrw;
	module.exports = exports['default'];

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLanguage = function FaLanguage(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.6 24.1q0 0-0.3 0t-0.7-0.3l-0.4-0.2q-1-0.5-2-1.1-0.1-0.1-0.9-0.7t-0.8-0.6q-1.5 2.3-3 4-1.8 2.1-2.4 2.5-0.1 0-0.4 0t-0.4 0q0.1 0 1.8-2 0.5-0.5 1.9-2.6t1.8-2.6q0.4-0.7 1.1-2.2t0.8-1.7q-0.2-0.1-2.4 0.7-0.2 0-0.7 0.2t-0.7 0.2-0.4 0.1q-0.1 0-0.1 0.2t0 0.2q-0.1 0.3-0.7 0.4-0.5 0.1-1 0-0.4-0.1-0.6-0.5-0.1-0.1-0.1-0.5 0.1-0.1 0.5-0.1t0.7-0.2q1.3-0.3 2.3-0.7 2.2-0.8 2.3-0.8 0.2 0 0.9-0.4t1-0.5q0.2 0 0.5-0.1t0.3-0.2 0.2 0q0 0.3-0.1 0.8 0 0-0.2 0.6t-0.6 1.2-0.4 0.7q-0.6 1.1-1.7 2.9l1.4 0.7q0.3 0.1 1.7 0.7t1.5 0.6q0.1 0 0.2 0.6t0.1 0.7z m-4.6-10.9q0.1 0.3-0.1 0.6-0.2 0.6-1.1 0.9-0.7 0.3-1.3 0.3-0.6-0.1-1.1-0.6-0.3-0.4-0.4-0.9l0-0.1q0.1 0.1 0.4 0.1t0.6 0 1.3-0.4q0.8-0.2 1.3-0.3 0.3 0 0.4 0.4z m15.6 2.9l1.4 5.1-3.1-1z m-24.7 17.9l15.5-5.2v-23.1l-15.5 5.2v23.1z m27.7-7.1l2.2 0.7-4-14.7-2.2-0.7-4.8 12 2.2 0.7 1-2.5 4.7 1.5z m-11.3-21.5l12.8 4.1v-8.5z m7 29.5l3.5 0.3-1.2 3.6-0.9-1.5q-2.9 1.9-6.1 2.4-1.3 0.3-2.1 0.3h-1.9q-1.7 0-4.4-0.9t-4.1-1.9q-0.2-0.1-0.2-0.3 0-0.2 0.1-0.3t0.3-0.2q0.1 0 0.4 0.2t0.7 0.4 0.5 0.2q1.6 0.9 3.5 1.4t3.5 0.6q2.2 0 3.8-0.4t3.5-1.1q0.3-0.2 0.7-0.3t0.7-0.5 0.6-0.3z m10-24.1v24.1l-17.3-5.5q-0.3 0.2-8.4 2.9t-8.2 2.7q-0.3 0-0.4-0.3 0 0 0-0.1v-24q0.1-0.2 0.1-0.2 0.1-0.2 0.4-0.3 2.4-0.8 3.4-1.1v-8.6l12.4 4.4q0.1 0 3.6-1.2t7.1-2.4 3.6-1.2q0.4 0 0.4 0.5v9.3z' })
	        )
	    );
	};
	
	exports.default = FaLanguage;
	module.exports = exports['default'];

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLaptop = function FaLaptop(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 28q-1.3 0-2.3-1t-1-2.3v-14.7q0-1.3 1-2.3t2.3-1h22.6q1.4 0 2.4 1t1 2.3v14.7q0 1.3-1 2.3t-2.4 1h-22.6z m-0.6-18v14.7q0 0.2 0.2 0.4t0.4 0.2h22.6q0.3 0 0.5-0.2t0.2-0.4v-14.7q0-0.2-0.2-0.4t-0.5-0.2h-22.6q-0.2 0-0.4 0.2t-0.2 0.4z m28.5 19.3h3.4v2q0 0.8-1 1.4t-2.4 0.6h-33.2q-1.3 0-2.3-0.6t-1-1.4v-2h36.5z m-14.9 2q0.3 0 0.3-0.3t-0.3-0.4h-3.3q-0.4 0-0.4 0.4t0.4 0.3h3.3z' })
	        )
	    );
	};
	
	exports.default = FaLaptop;
	module.exports = exports['default'];

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLastfmSquare = function FaLastfmSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35 23.5q0-3.9-5.3-5.4-0.7-0.2-1.1-0.3t-0.9-0.6-0.6-1q0-0.1-0.1-0.2t0-0.3-0.1-0.1q0-0.8 0.6-1.4t1.3-0.5q1.2 0 1.6 0.3h0q0.4 0.4 0.9 1.2l2-1.6q-0.8-1.2-1.1-1.4-0.7-0.7-1.5-0.9t-1.9-0.2q-1.8 0-3.1 1.3t-1.4 3q0 0.2 0 0.5 0.4 2.2 1.5 3.2t3.3 1.6q0.6 0.2 1.1 0.3t1 0.5 0.8 0.8 0.3 1v0.1q0.1 1.3-0.9 2.1t-2.2 0.8q-2.2 0-3.7-3.2-0.6-1.1-1.2-2.7t-1.1-2.8-1.2-2.5-1.6-2.1-2.3-1.4-3.3-0.5q-2.3 0-4.3 1.2t-3.2 3.3-1.1 4.3v0q0.1 2.4 1.1 4.5t3 3.3 4.4 1.2q4.1 0 6.2-2.4 0.4-0.6 0.7-1.2l-1.4-2.4q-0.9 1.8-2.2 2.6t-3.2 0.8q-2.6 0-4.3-1.9t-1.7-4.6q0-2.3 1.8-4.2t4.2-1.9q2.5 0 3.8 1.2t2.3 3.8q0.2 0.5 0.6 1.6t0.6 1.7 0.7 1.6 0.9 1.7 1 1.4 1.2 1.2 1.5 0.7 1.8 0.3q2.4 0 4.1-1.5t1.7-3.9z m2.3-14.2v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaLastfmSquare;
	module.exports = exports['default'];

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLastfm = function FaLastfm(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.8 15.7q0 0.1 0.3 0.9 0.2 0.7 0.5 1.1t0.9 0.8 1 0.4 1.2 0.4q7.3 2 7.3 7.4 0 3.3-2.4 5.4t-5.6 2.2q-1.4 0-2.5-0.4t-2.1-1-1.7-1.7-1.4-2-1.2-2.3-1-2.3-0.8-2.3-0.8-2.2q-0.7-1.8-1.4-2.9t-1.6-2.2-2.4-1.4-3.1-0.5q-2.2 0-4.1 1.3t-3.1 3.2-1.1 4.1q0 3.6 2.3 6.3t5.9 2.6q4 0 5.8-2.1 1.2-1.4 1.8-2.6l1.9 3.4q-0.3 0.8-1 1.6l0 0q-2.9 3.4-8.6 3.4-3.3 0-6-1.8t-4.3-4.6-1.5-6.1q0-2.4 1-4.6t2.6-4 3.8-2.7 4.6-1q1.9 0 3.5 0.4t2.8 1.1 2.1 1.8 1.6 2.2 1.3 2.6 1.1 2.8 1.2 2.9 1.2 2.9q2.1 4.4 5.2 4.4 1.8 0 3.1-1.1t1.3-2.8q0-1-0.5-1.6t-1.1-1.1-1.6-0.7-1.9-0.6-1.9-0.7-1.9-1.2-1.4-1.8-0.9-2.8q0-0.3 0-0.7 0-2.4 1.9-4.3t4.4-1.7q1.8 0.1 2.7 0.3t2 1.2h0q0.3 0.2 0.5 0.5t0.6 0.9 0.4 0.6l-2.8 2.2q-0.6-1.1-1.2-1.6v0q-0.6-0.5-2.2-0.5-1.1 0-1.9 0.8t-0.8 1.8z' })
	        )
	    );
	};
	
	exports.default = FaLastfm;
	module.exports = exports['default'];

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLeaf = function FaLeaf(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 15.7q0-0.6-0.5-1t-1-0.4q-3.8 0-7.1 1.1t-5.7 3-5.3 4.9q-0.4 0.5-0.4 1 0 0.6 0.4 1t1 0.4q0.5 0 1-0.4 0.6-0.5 1.7-1.6t1.5-1.5q3-2.7 5.9-3.9t7-1.2q0.6 0 1-0.4t0.5-1z m11.4-4.4q0 2.1-0.4 4.3-1.1 5-4.2 8.6t-7.9 5.9q-4.8 2.4-9.8 2.4-3.3 0-6.4-1-0.3-0.1-2-0.9t-2.1-0.9q-0.4 0-0.9 0.7t-1 1.6-1.2 1.6-1.3 0.7q-0.7 0-1.1-0.3t-0.7-0.5-0.6-0.9q-0.1-0.1-0.2-0.3t-0.1-0.2-0.1-0.2 0-0.3q0-0.8 0.7-1.7t1.5-1.4 1.5-1.3 0.7-1q0-0.1-0.3-0.9t-0.3-1q-0.2-1.1-0.2-2.3 0-2.6 0.9-4.9t2.7-4.1 3.8-3.1 4.5-2.2q1.3-0.4 3.3-0.5t4-0.2 4-0.2 3.6-0.5 2.5-1.3l0.7-0.6 0.7-0.6 0.6-0.5 0.8-0.3 1-0.1q0.8 0 1.5 1t1.1 2.5 0.5 2.8 0.2 2.1z' })
	        )
	    );
	};
	
	exports.default = FaLeaf;
	module.exports = exports['default'];

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLeanpub = function FaLeanpub(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.7 10.2l3.1 24.7q-2.6 0-5-1.1-3.9-1.8-7.7-1.8-4.4 0-7.2 2.9-2.9-2.9-7.3-2.9-3.7 0-7.6 1.8-2.5 1.1-4.9 1.1h-0.1l3-24.7q4.4-2.4 9.4-2.4 4.5 0 7.5 2 3-2 7.5-2 5 0 9.3 2.4z m-9.6 19.2q2.5 0 4.5 0.5t5.1 1.8l-2.4-19.8q-3.3-1.5-7.2-1.5-4.3 0-7.2 2.7-2.9-2.7-7.3-2.7-3.8 0-7.1 1.5l-2.4 19.8q2-0.8 3.2-1.2t2.9-0.8 3.4-0.3q3.9 0 7.3 2.1 3.3-2.1 7.2-2.1z m0.8-0.7l-1.1-17.6q-4.1 0.1-6.9 3-3-3-7.3-3-3.4 0-6.5 1.3l-2.2 18.3q2.4-1 4.4-1.5t4.3-0.5q4.1 0 7.3 2 3.3-2.1 7.2-2z' })
	        )
	    );
	};
	
	exports.default = FaLeanpub;
	module.exports = exports['default'];

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLemonO = function FaLemonO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.4 18.4q0-0.9-0.1-2.5t-0.5-2.1q-0.2-0.7-0.3-1t-0.2-0.8-0.1-1.1q0-0.5 0.1-1.6t0.1-1.5q0-0.8-0.2-1.2-0.1 0-0.3 0-0.4 0-1.3 0.1t-1.3 0.1q-1.4 0-4-0.5t-3.9-0.6q-0.9 0-2.1 0.3t-1.9 0.5-2 0.8q-3 1.2-4.5 2.3-2.1 1.6-3.5 4.2t-2 5.3-0.5 5.5q0 0.9 0.2 2.7t0.3 2.7q0 0.5-0.2 1.5t-0.3 1.4 0.3 0.8 0.8 0.4q0.5 0 1.6-0.3t1.6-0.2q1.3 0 3.8 0.3t3.8 0.4q4 0 6.3-0.8 2.9-1 5.3-3.4t3.7-5.5 1.3-6.2z m2.9 0q0 3.7-1.6 7.3t-4.4 6.4-6.2 4.1q-2.8 0.9-7.3 0.9-1.3 0-3.8-0.3t-3.8-0.3q-0.5 0-1.6 0.3t-1.6 0.3q-1.7 0-2.8-1.2t-1.1-2.9q0-0.5 0.2-1.5t0.3-1.5q0-0.9-0.3-2.7t-0.3-2.7q0-2.5 0.4-4.8t1.2-4.7 2.3-4.3 3.3-3.5q1.8-1.3 5.2-2.7 4.3-1.7 7-1.7 1.4 0 4 0.5t3.8 0.5q0.5 0 1.3-0.1t1.3-0.1q1.8 0 2.6 1.1t0.9 3q0 0.5-0.2 1.5t-0.1 1.6q0 0.2 0.1 0.4t0 0.4 0.1 0.3 0.2 0.3 0.1 0.4q0.4 0.9 0.6 2.6t0.2 3.1z' })
	        )
	    );
	};
	
	exports.default = FaLemonO;
	module.exports = exports['default'];

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLevelDown = function FaLevelDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.2 5.7h15.7q0.3 0 0.5 0.2t0.2 0.6v19.2h4.3q0.9 0 1.3 0.8t-0.2 1.6l-7.1 8.6q-0.4 0.4-1.1 0.4t-1.1-0.4l-7.1-8.6q-0.6-0.7-0.2-1.6 0.4-0.8 1.2-0.8h4.3v-14.3h-7.1q-0.3 0-0.6-0.2l-3.5-4.3q-0.3-0.3-0.1-0.8 0.2-0.4 0.6-0.4z' })
	        )
	    );
	};
	
	exports.default = FaLevelDown;
	module.exports = exports['default'];

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLevelUp = function FaLevelUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.2 13.5q-0.4 0.8-1.3 0.8h-4.3v19.3q0 0.3-0.2 0.5t-0.5 0.2h-15.7q-0.5 0-0.6-0.4-0.2-0.5 0.1-0.8l3.5-4.3q0.2-0.2 0.6-0.2h7.1v-14.3h-4.3q-0.9 0-1.3-0.8-0.3-0.9 0.2-1.6l7.2-8.5q0.4-0.5 1.1-0.5t1.1 0.5l7.1 8.5q0.6 0.8 0.2 1.6z' })
	        )
	    );
	};
	
	exports.default = FaLevelUp;
	module.exports = exports['default'];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLifeBouy = function FaLifeBouy(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 0q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z m0 2.9q-4.2 0-8.1 2l4.4 4.3q1.8-0.6 3.7-0.6t3.7 0.6l4.4-4.3q-3.9-2-8.1-2z m-15.1 25.2l4.3-4.4q-0.6-1.8-0.6-3.7t0.6-3.7l-4.3-4.4q-2 3.9-2 8.1t2 8.1z m15.1 9q4.2 0 8.1-2l-4.4-4.3q-1.8 0.6-3.7 0.6t-3.7-0.6l-4.4 4.3q3.9 2 8.1 2z m0-8.5q3.6 0 6.1-2.5t2.5-6.1-2.5-6.1-6.1-2.5-6.1 2.5-2.5 6.1 2.5 6.1 6.1 2.5z m10.8-4.9l4.3 4.4q2-3.9 2-8.1t-2-8.1l-4.3 4.4q0.6 1.8 0.6 3.7t-0.6 3.7z' })
	        )
	    );
	};
	
	exports.default = FaLifeBouy;
	module.exports = exports['default'];

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLightbulbO = function FaLightbulbO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.9 12.9q0 0.2-0.2 0.5t-0.5 0.2-0.5-0.2-0.2-0.5q0-1.1-1.2-1.6t-2.4-0.6q-0.3 0-0.5-0.2t-0.2-0.5 0.2-0.5 0.5-0.2q1.1 0 2.2 0.3t2 1.2 0.8 2.1z m3.6 0q0-1.6-0.8-3t-2-2.3-2.7-1.4-3.1-0.5-3 0.5-2.8 1.4-2 2.3-0.7 3q0 2.2 1.5 4 0.2 0.2 0.7 0.7t0.6 0.7q2.9 3.5 3.2 6.7h5.1q0.3-3.2 3.1-6.6 0.2-0.3 0.7-0.8t0.7-0.7q1.5-1.8 1.5-4z m2.9 0q0 3.4-2.3 5.9-1 1.1-1.7 2t-1.3 2.1-0.8 2.4q1.1 0.6 1.1 1.8 0 0.9-0.6 1.5 0.6 0.6 0.6 1.4 0 1.2-1 1.8 0.2 0.5 0.2 1.1 0 1-0.7 1.5t-1.7 0.6q-0.4 1-1.3 1.6t-2 0.5-1.9-0.5-1.4-1.6q-1 0-1.7-0.6t-0.7-1.5q0-0.6 0.3-1.1-1-0.6-1-1.8 0-0.8 0.6-1.4-0.6-0.6-0.6-1.5 0-1.2 1.1-1.8-0.1-1.1-0.8-2.4t-1.3-2.1-1.7-2q-2.3-2.5-2.3-5.9 0-2.3 1-4.2t2.6-3.1 3.7-2 4.1-0.7 4.2 0.7 3.7 2 2.6 3.1 1 4.2z' })
	        )
	    );
	};
	
	exports.default = FaLightbulbO;
	module.exports = exports['default'];

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLineChart = function FaLineChart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 32.4v2.5h-39.8v-29.8h2.5v27.3h37.3z m-2.5-24.2v8.4q0 0.5-0.4 0.6t-0.7-0.1l-2.3-2.4-12.3 12.3q-0.2 0.2-0.5 0.2t-0.4-0.2l-4.5-4.5-8.1 8.1-3.8-3.8 11.4-11.3q0.2-0.2 0.4-0.2t0.5 0.2l4.5 4.5 9-9-2.3-2.4q-0.3-0.3-0.2-0.6t0.6-0.4h8.4q0.3 0 0.5 0.2t0.2 0.4z' })
	        )
	    );
	};
	
	exports.default = FaLineChart;
	module.exports = exports['default'];

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLinkedinSquare = function FaLinkedinSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.3 31.6h5.1v-15.5h-5.1v15.5z m5.5-20.3q0-1.2-0.8-1.9t-2.1-0.8-2.1 0.8-0.8 1.9q0 1.1 0.8 1.9t2 0.8h0.1q1.3 0 2.1-0.8t0.8-1.9z m13 20.3h5.2v-8.9q0-3.5-1.6-5.2t-4.3-1.8q-3.1 0-4.7 2.6h0v-2.2h-5.1q0 1.4 0 15.5h5.1v-8.7q0-0.8 0.2-1.2 0.3-0.8 1-1.4t1.7-0.5q2.5 0 2.5 3.5v8.3z m10.5-22.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaLinkedinSquare;
	module.exports = exports['default'];

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLinkedin = function FaLinkedin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.8 13.9v22.2h-7.4v-22.1h7.4z m0.5-6.8q0 1.7-1.2 2.7t-3 1.1h0q-1.9 0-3-1.1t-1.1-2.7q0-1.6 1.2-2.7t3-1.1 2.9 1.1 1.2 2.7z m26 16.3v12.7h-7.4v-11.9q0-2.3-0.9-3.6t-2.8-1.4q-1.4 0-2.3 0.8t-1.5 1.9q-0.2 0.7-0.2 1.8v12.4h-7.3q0-8.9 0-14.5t0-6.6l0-1h7.3v3.2h-0.1q0.5-0.7 1-1.3t1.2-1.1 2-1 2.5-0.4q3.8 0 6.2 2.6t2.3 7.4z' })
	        )
	    );
	};
	
	exports.default = FaLinkedin;
	module.exports = exports['default'];

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLinux = function FaLinux(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.8 9.2q-0.2 0-0.3 0.2t-0.2 0.2q-0.1 0-0.1-0.1 0-0.3 0.4-0.3h0.2z m1.9 0.3q0 0-0.2-0.2t-0.4-0.1q0.5-0.2 0.7 0.1 0.1 0.1-0.1 0.2z m-7.8 9.5q-0.1 0-0.1 0.1t-0.1 0.3-0.2 0.3-0.2 0.3q-0.1 0.2 0 0.2 0.1 0 0.3-0.1t0.3-0.4q0-0.1 0-0.2t0.1-0.1 0-0.1 0-0.1v-0.1l0 0-0.1-0.1z m19.1 8q0-0.4-1.2-0.9 0.1-0.3 0.1-0.6t0.1-0.6 0.1-0.5 0-0.5 0-0.4-0.1-0.5-0.1-0.5-0.1-0.5-0.1-0.6q-0.2-1.1-1.1-2.3t-1.6-1.7q0.6 0.5 1.3 1.9 2 3.6 1.2 6.2-0.2 0.9-1.1 0.9-0.7 0.1-0.9-0.4t-0.1-1.9-0.3-2.4q-0.2-0.8-0.4-1.5t-0.5-1-0.3-0.6-0.3-0.3-0.2-0.2q-0.3-1.3-0.7-2.3t-0.6-1.2-0.5-0.7-0.4-0.9q-0.1-0.5 0.2-1.2t0.1-1.1-1-0.6q-0.4-0.1-1-0.4t-0.8-0.3q-0.2-0.1-0.3-0.6t0.2-1.2 0.8-0.6q0.8 0 1.2 0.7t0 1.3q-0.2 0.4 0 0.6t0.7 0q0.3-0.1 0.3-0.8v-0.8q-0.1-0.7-0.3-1.1t-0.5-0.7-0.5-0.4-0.6-0.1q-2.4 0.1-2 3 0 0.3 0 0.3-0.2-0.2-0.7-0.2t-0.7 0-0.4-0.1q0-1.3-0.3-2t-1-0.8q-0.6 0-1 0.6t-0.3 1.3q-0.1 0.4 0 0.9t0.3 0.8 0.4 0.3q0.2-0.1 0.3-0.3 0.1-0.2-0.1-0.2-0.2 0-0.4-0.3t-0.2-0.8q0-0.5 0.2-0.8t0.8-0.3q0.4 0 0.6 0.5t0.2 0.8 0 0.5q-0.5 0.4-0.7 0.7-0.2 0.2-0.6 0.5t-0.5 0.3q-0.3 0.3-0.4 0.6t0.2 0.4q0.3 0.2 0.6 0.4t0.3 0.4 0.4 0.3 0.8 0.2q1.1 0 2.3-0.4 0.1 0 0.5-0.1t0.8-0.2 0.7-0.3 0.4-0.4q0.2-0.3 0.5-0.2 0.1 0.1 0.1 0.2t-0.1 0.3-0.3 0.2q-0.5 0.1-1.3 0.4t-1 0.5q-1 0.4-1.6 0.5-0.5 0.1-1.7-0.1-0.2 0-0.2 0.1t0.4 0.4q0.5 0.5 1.4 0.5 0.4 0 0.9-0.2t0.8-0.3 0.7-0.4 0.7-0.3 0.5-0.3 0.4-0.1 0.2 0.3q0 0 0 0.1t-0.1 0.1-0.1 0.1-0.2 0.1-0.2 0.1-0.3 0.1-0.2 0.1q-0.6 0.3-1.5 1t-1.5 1-1.1 0q-0.4-0.3-1.4-1.6-0.4-0.7-0.5-0.5 0 0 0 0.2 0 0.6-0.4 1.3t-0.6 1.2-0.5 1.3 0.3 1.4q-0.6 0.1-1.4 2t-1.1 3.1q0 0.5 0 1.6t-0.2 1.3q-0.1 0.5-0.6 0.1-0.7-0.7-0.8-2.1 0-0.7 0.1-1.3 0.1-0.4 0-0.4l-0.1 0.1q-0.8 1.5 0.2 3.7 0.1 0.3 0.6 0.7t0.5 0.4q0.4 0.5 2.3 2t2.1 1.7q0.3 0.4 0.4 0.9t-0.3 0.9-1 0.6q0.1 0.3 0.6 0.9t0.6 1.3 0.2 1.5q1-0.5 0.1-2-0.1-0.2-0.2-0.4t-0.2-0.2-0.1-0.2q0.1-0.1 0.3-0.2t0.5 0.1q1 1.1 3.7 0.8 3-0.4 3.9-2 0.5-0.8 0.8-0.6 0.3 0.1 0.2 1.1 0 0.6-0.5 2.1-0.2 0.5-0.1 0.8t0.5 0.3q0.1-0.4 0.3-1.7t0.3-2q0.1-0.4-0.1-1.6t-0.2-2.2 0.5-1.6q0.4-0.4 1.2-0.4 0-0.8 0.7-1.1t1.7-0.3 1.3 0.5z m-14-18.4q0-0.4-0.1-0.7t-0.2-0.3q-0.2-0.1-0.2 0.1 0 0.1 0.1 0.2 0.2 0 0.1 0.3 0 0.4 0.2 0.4 0.1 0 0.1 0z m9.3 4.4q0-0.2-0.1-0.3t-0.3-0.1-0.3-0.1q-0.1-0.1-0.2-0.2t-0.2-0.2-0.1-0.1-0.1-0.1-0.1 0q-0.3 0.4 0.2 1t0.8 0.7q0.2 0 0.4-0.2t0-0.4z m-3.9-4.8q0-0.2-0.2-0.4t-0.2-0.3-0.2-0.1q-0.3 0.1-0.2 0.2l0.1 0q0.3 0.1 0.4 0.7 0 0.1 0.2 0z m1.2-5.2q0 0-0.1-0.1t-0.2-0.2-0.2-0.1q-0.3-0.3-0.5-0.3-0.2 0-0.3 0.1t0 0.3 0 0.3q-0.1 0.1-0.2 0.2t-0.1 0.2 0.1 0.2q0.1 0.1 0.1 0t0.3-0.2 0.3-0.2q0 0 0.2 0t0.4 0 0.2-0.2z m12.6 29.9q0.4 0.3 0.7 0.6t0.2 0.5 0 0.5-0.4 0.5-0.5 0.5-0.7 0.4-0.7 0.3-0.7 0.4-0.6 0.3q-0.8 0.4-1.9 1.2t-1.7 1.5q-0.4 0.3-1.5 0.4t-2-0.3q-0.4-0.2-0.6-0.6t-0.4-0.5-0.5-0.5-1.1-0.2q-0.9 0-2.9 0-0.4 0-1.2 0t-1.3 0.1q-1 0-1.8 0.3t-1.2 0.7-1 0.6-1.2 0.3q-0.6 0-2.4-0.7t-3.3-1q-0.4-0.1-1.1-0.2t-1.1-0.2-0.9-0.2-0.8-0.3-0.4-0.4q-0.2-0.6 0.2-1.5t0.4-1.2q0-0.4-0.1-0.9t-0.2-1-0.1-0.8 0.2-0.6q0.3-0.3 1.3-0.3t1.3-0.3q0.7-0.4 1-0.8t0.2-1.1q0.5 1.6-0.7 2.4-0.7 0.4-1.8 0.3-0.8-0.1-1 0.2-0.3 0.4 0.1 1.3 0.1 0.1 0.2 0.4t0.2 0.4 0.1 0.4 0 0.5q0 0.3-0.4 1.1t-0.3 1q0.1 0.4 0.9 0.6 0.4 0.1 1.8 0.4t2.3 0.5q0.5 0.1 1.6 0.5t1.9 0.5 1.2 0.1q1-0.2 1.4-0.7t0.5-1-0.1-1.3-0.4-1.2-0.5-0.8q-2.7-4.2-3.8-5.4-1.5-1.7-2.5-0.9-0.2 0.2-0.3-0.3-0.1-0.4-0.1-0.9 0.1-0.6 0.3-1.1t0.5-1.1 0.5-0.9q0.2-0.5 0.6-1.6t0.6-1.8 0.7-1.3 0.9-1.2q2.4-3.2 2.7-4.4-0.2-2.5-0.3-6.9-0.1-2 0.5-3.4t2.4-2.3q0.9-0.5 2.3-0.5 1.2 0 2.4 0.3t2 0.9q1.2 1 2 2.7t0.7 3.3q-0.1 2.1 0.6 4.8 0.8 2.5 3 4.9 1.2 1.3 2.2 3.6t1.4 4.3q0.1 1.1 0.1 1.9t-0.3 1.2-0.4 0.5q-0.3 0-0.6 0.4t-0.6 0.8-0.9 0.7-1.3 0.4q-0.4-0.1-0.7-0.2t-0.5-0.3-0.3-0.3-0.3-0.5-0.2-0.4q-0.5-0.8-0.9-0.7t-0.6 1.1 0.1 2.2q0.5 1.6 0 4.3-0.2 1.5 0.4 2.3t1.7 0.7 1.9-0.8q1.3-1.1 2-1.4t2.3-1q1.1-0.4 1.7-0.8t0.4-0.8-0.6-0.6-1.1-0.5q-0.7-0.3-1.1-1.1t-0.4-1.6 0.4-1.1q0 0.7 0.2 1.3t0.3 0.9 0.5 0.6 0.4 0.4 0.5 0.3 0.4 0.2z' })
	        )
	    );
	};
	
	exports.default = FaLinux;
	module.exports = exports['default'];

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaListAlt = function FaListAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 26.4v1.5q0 0.2-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.3h-1.5q-0.3 0-0.5-0.3t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h1.5q0.2 0 0.5 0.2t0.2 0.5z m25.7 11.4v1.5q0 0.2-0.2 0.5t-0.5 0.2h-21.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h21.5q0.3 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.3h-21.5q-0.2 0-0.5-0.3t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h21.5q0.3 0 0.5 0.2t0.2 0.5z m0-5.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-21.5q-0.2 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h21.5q0.3 0 0.5 0.2t0.2 0.5z m2.8 15.7v-18.6q0-0.2-0.2-0.5t-0.5-0.2h-32.8q-0.3 0-0.5 0.2t-0.2 0.5v18.6q0 0.3 0.2 0.5t0.5 0.2h32.8q0.3 0 0.5-0.2t0.2-0.5z m2.9-24.3v24.3q0 1.5-1 2.5t-2.6 1.1h-32.8q-1.5 0-2.6-1.1t-1-2.5v-24.3q0-1.4 1.1-2.5t2.5-1h32.8q1.5 0 2.6 1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaListAlt;
	module.exports = exports['default'];

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaListOl = function FaListOl(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.5 36.2q0 1.7-1.2 2.8t-3 1q-2.4 0-3.9-1.5l1.3-1.9q1.1 1 2.4 1 0.6 0 1.1-0.4t0.5-0.9q0-1.4-2.4-1.3l-0.6-1.2q0.2-0.2 0.8-1t0.9-1.2 0.8-0.8v-0.1q-0.3 0-1 0.1t-1.1 0v1.2h-2.4v-3.4h7.4v1.9l-2.1 2.6q1.2 0.3 1.8 1.1t0.7 2z m0-14v3.5h-8q-0.2-0.8-0.2-1.2 0-1.1 0.6-2.1t1.2-1.5 1.5-1 1.3-1 0.5-1q0-0.6-0.3-0.9t-0.9-0.3q-1.1 0-1.8 1.3l-1.9-1.3q0.5-1.1 1.6-1.8t2.3-0.6q1.6 0 2.8 0.9t1.1 2.5q0 1.1-0.8 2.1t-1.7 1.4-1.6 1.1-0.8 1.2h2.8v-1.3h2.4z m31.5 7.1v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z m-31.4-20.1v2.2h-7.5v-2.2h2.4q0-0.9 0-2.7t0-2.7v-0.3h0q-0.2 0.4-1.2 1.2l-1.5-1.7 3-2.8h2.4v9h2.4z m31.4 8.7v4.2q0 0.3-0.2 0.5t-0.5 0.3h-27.2q-0.2 0-0.5-0.3t-0.2-0.5v-4.2q0-0.4 0.2-0.6t0.5-0.2h27.2q0.3 0 0.5 0.3t0.2 0.5z m0-11.5v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaListOl;
	module.exports = exports['default'];

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaListUl = function FaListUl(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 31.4q0 1.8-1.3 3.1t-3 1.2-3.1-1.2-1.2-3.1 1.3-3 3-1.3 3 1.3 1.3 3z m0-11.4q0 1.8-1.3 3t-3 1.3-3.1-1.3-1.2-3 1.3-3 3-1.3 3 1.3 1.3 3z m31.4 9.3v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z m-31.4-20.7q0 1.8-1.3 3t-3 1.3-3.1-1.3-1.2-3 1.3-3.1 3-1.2 3 1.2 1.3 3.1z m31.4 9.3v4.2q0 0.3-0.2 0.5t-0.5 0.3h-27.2q-0.2 0-0.5-0.3t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.3h27.2q0.3 0 0.5 0.3t0.2 0.5z m0-11.5v4.3q0 0.3-0.2 0.5t-0.5 0.2h-27.2q-0.2 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h27.2q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaListUl;
	module.exports = exports['default'];

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaList = function FaList(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.7 29.3v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m34.3 17.2v4.3q0 0.3-0.2 0.5t-0.5 0.2h-30q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h30q0.3 0 0.5 0.2t0.2 0.5z m-34.3-25.7v4.3q0 0.2-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m34.3 17.1v4.3q0 0.3-0.2 0.5t-0.5 0.2h-30q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h30q0.3 0 0.5 0.2t0.2 0.5z m0-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-30q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.2 0.2-0.5t0.5-0.2h30q0.3 0 0.5 0.2t0.2 0.5z m0-8.5v4.3q0 0.2-0.2 0.5t-0.5 0.2h-30q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h30q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaList;
	module.exports = exports['default'];

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLocationArrow = function FaLocationArrow(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 7.8l-14.3 28.6q-0.4 0.7-1.3 0.7-0.1 0-0.3 0-0.5-0.1-0.8-0.5t-0.3-0.9v-12.8h-12.9q-0.5 0-0.9-0.3t-0.5-0.8 0.1-1 0.7-0.6l28.6-14.3q0.2-0.2 0.6-0.2 0.6 0 1 0.4 0.3 0.4 0.4 0.8t-0.1 0.9z' })
	        )
	    );
	};
	
	exports.default = FaLocationArrow;
	module.exports = exports['default'];

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLock = function FaLock(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.1 17.1h11.5v-4.2q0-2.4-1.7-4.1t-4-1.7-4.1 1.7-1.7 4.1v4.2z m18.6 2.2v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h0.8v-4.2q0-4.1 2.9-7.1t7.1-2.9 7 2.9 3 7.1v4.2h0.7q0.9 0 1.5 0.7t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaLock;
	module.exports = exports['default'];

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowDown = function FaLongArrowDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 29q0.2 0.4-0.1 0.8l-7.9 8.6q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.9-8.6q-0.3-0.4-0.1-0.8 0.2-0.4 0.6-0.4h5v-27.9q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v27.9h5q0.5 0 0.7 0.4z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowDown;
	module.exports = exports['default'];

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowLeft = function FaLongArrowLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39 17.9v4.2q0 0.3-0.2 0.5t-0.5 0.2h-27.1v4.9q0 0.4-0.5 0.6t-0.7-0.1l-8.4-7.6q-0.2-0.3-0.2-0.5 0-0.3 0.2-0.6l8.4-7.7q0.3-0.3 0.7-0.1 0.4 0.2 0.4 0.6v4.9h27.2q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowLeft;
	module.exports = exports['default'];

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowRight = function FaLongArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.1 19.9q0 0.3-0.3 0.6l-8.5 7.9q-0.4 0.3-0.8 0.1-0.4-0.2-0.4-0.6v-5h-27.9q-0.3 0-0.5-0.2t-0.2-0.6v-4.2q0-0.4 0.2-0.6t0.5-0.2h27.9v-5q0-0.4 0.4-0.6t0.8 0.1l8.5 7.8q0.3 0.2 0.3 0.5z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowRight;
	module.exports = exports['default'];

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLongArrowUp = function FaLongArrowUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 11q-0.2 0.4-0.7 0.4h-5v27.9q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-27.9h-5q-0.5 0-0.6-0.4t0.1-0.8l7.8-8.6q0.2-0.2 0.5-0.2 0.3 0 0.5 0.2l8 8.6q0.3 0.4 0.1 0.8z' })
	        )
	    );
	};
	
	exports.default = FaLongArrowUp;
	module.exports = exports['default'];

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaLowVision = function FaLowVision(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm7.5 30.3q-0.1 0-0.2-0.1-1.9-1.2-3.7-3.2t-3.1-4q-0.5-0.7-0.5-1.6 0-0.2 0-0.4t0.1-0.4 0.2-0.4 0.2-0.4 0.2-0.3 0.2-0.4 0.3-0.3 0.2-0.3q4.2-5.6 10.1-8.2-2.4-4.4-2.4-4.7 0-0.4 0.4-0.6 2.6-1.5 2.8-1.5 0.4 0 0.6 0.4l2.8 5.1q2.1-0.4 4.3-0.4 5.9 0 11.1 3t8.5 8.3q0.4 0.7 0.4 1.5t-0.4 1.6q-2.1 3.1-4.9 5.6t-6.2 3.9q2.4 4.5 2.4 4.8 0 0.4-0.4 0.6-2.6 1.4-2.8 1.4-0.4 0-0.6-0.3l-2.8-5.1-1.4-2.7-10-18.3 0.2-0.2q-1.3 0.6-2.2 1.1 0.1 0.1 2.8 5.2t5.5 10 2.6 5q0 0.2-0.2 0.2-0.3 0.1-1.6 0.1-1.3 0-1.3-0.2l-10.2-18.7q-0.9 0.6-1.8 1.5 0.5 0.9 4.7 8.8t4.3 7.9q0 0.2-0.3 0.2-0.3 0-1.8-0.5t-1.6-0.6l-2.4-4.4-5-9.2q-1 1.1-1.7 2.3 0 0.1 0.4 0.6t0.5 0.7l3.9 7.3q0 0.3-0.2 0.3z m18.5-2.3l1.1 2q6.1-2.5 10-8.6-4-6.2-10.2-8.7 1.5 1.5 2.3 3.4t0.8 3.9q0 2.4-1.1 4.5t-2.9 3.5z m-7.1-13.7q0 0.4 0.3 0.7t0.8 0.4q1.9 0 3.3 1.3t1.3 3.3q0 0.4 0.4 0.8t0.7 0.3 0.8-0.3 0.3-0.8q0-2.8-2-4.8t-4.8-2q-0.4 0-0.8 0.3t-0.3 0.8z m8.2-1.5l-0.2-0.1 0.2 0.2z' })
	        )
	    );
	};
	
	exports.default = FaLowVision;
	module.exports = exports['default'];

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMagic = function FaMagic(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.6 13l6.5-6.6-2.4-2.4-6.5 6.6z m9.9-6.6q0 0.6-0.4 1l-28.7 28.7q-0.4 0.4-1 0.4t-1-0.4l-4.4-4.4q-0.4-0.4-0.4-1t0.4-1l28.7-28.7q0.4-0.4 1-0.4t1 0.4l4.4 4.4q0.4 0.4 0.4 1z m-30.1-4.2l2.2 0.7-2.2 0.6-0.7 2.2-0.7-2.2-2.1-0.6 2.1-0.7 0.7-2.2z m7.8 3.6l4.4 1.3-4.4 1.4-1.3 4.4-1.4-4.4-4.4-1.4 4.4-1.3 1.4-4.4z m20.8 10.7l2.1 0.6-2.1 0.7-0.7 2.2-0.7-2.2-2.2-0.7 2.2-0.6 0.7-2.2z m-14.3-14.3l2.2 0.7-2.2 0.6-0.7 2.2-0.7-2.2-2.2-0.6 2.2-0.7 0.7-2.2z' })
	        )
	    );
	};
	
	exports.default = FaMagic;
	module.exports = exports['default'];

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMagnet = function FaMagnet(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 18.6v2.8q0 4.5-2.2 8.1t-6.1 5.6-8.9 2-8.8-2-6.1-5.6-2.2-8.1v-2.8q0-0.6 0.4-1t1-0.5h8.6q0.6 0 1 0.5t0.4 1v2.8q0 1.2 0.6 2t1.1 1.3 1.6 0.7 1.5 0.3 0.9 0 1 0 1.5-0.3 1.5-0.7 1.2-1.3 0.6-2v-2.8q0-0.6 0.4-1t1-0.5h8.6q0.5 0 1 0.5t0.4 1z m-22.9-14.3v8.6q0 0.5-0.4 1t-1 0.4h-8.6q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h8.6q0.6 0 1 0.4t0.4 1z m22.9 0v8.6q0 0.5-0.4 1t-1 0.4h-8.6q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h8.6q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaMagnet;
	module.exports = exports['default'];

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMailForward = function FaMailForward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 14.3q0 0.6-0.4 1l-11.5 11.4q-0.4 0.4-1 0.4t-1-0.4-0.4-1v-5.7h-5q-2.2 0-3.9 0.1t-3.4 0.5-3 1-2.4 1.5-1.7 2.3-1.1 3.1-0.4 4q0 1.2 0.1 2.7 0 0.2 0 0.6t0.1 0.6q0 0.3-0.2 0.5t-0.5 0.2q-0.4 0-0.6-0.3-0.2-0.2-0.3-0.5t-0.3-0.7-0.3-0.5q-2.8-6.4-2.8-10.1 0-4.4 1.2-7.4 3.6-9 19.5-9h5v-5.7q0-0.6 0.4-1t1-0.5 1 0.5l11.5 11.4q0.4 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaMailForward;
	module.exports = exports['default'];

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMailReplyAll = function FaMailReplyAll(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 24.2v1.5q0 1-0.9 1.3-0.3 0.1-0.5 0.1-0.6 0-1-0.4l-11.5-11.4q-0.4-0.4-0.4-1t0.4-1l11.5-11.4q0.6-0.7 1.5-0.4 0.9 0.4 0.9 1.4v1.5l-8.9 8.9q-0.4 0.4-0.4 1t0.4 1z m25.7 0.8q0 1.3-0.4 3t-0.8 3.1-1.1 2.8-0.9 2l-0.5 0.9q-0.1 0.3-0.6 0.3-0.1 0-0.2 0-0.5-0.2-0.5-0.7 1-9-2.4-12.6-1.4-1.6-3.8-2.5t-5.9-1.2v5.6q0 1-0.9 1.3-0.3 0.1-0.6 0.1-0.6 0-1-0.4l-11.4-11.4q-0.4-0.4-0.4-1t0.4-1l11.4-11.4q0.7-0.7 1.6-0.4 0.9 0.4 0.9 1.4v5.8q9.1 0.6 13.3 4.9 3.8 3.9 3.8 11.4z' })
	        )
	    );
	};
	
	exports.default = FaMailReplyAll;
	module.exports = exports['default'];

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMailReply = function FaMailReply(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 25q0 3.7-2.8 10.1-0.1 0.1-0.3 0.5t-0.3 0.7-0.3 0.5q-0.2 0.3-0.6 0.3-0.3 0-0.5-0.2t-0.2-0.5q0-0.2 0.1-0.6t0-0.6q0.1-1.5 0.1-2.7 0-2.3-0.4-4t-1-3.1-1.8-2.3-2.4-1.5-3-1-3.4-0.5-3.9-0.1h-5v5.7q0 0.6-0.4 1t-1 0.4-1-0.4l-11.5-11.4q-0.4-0.4-0.4-1t0.4-1l11.5-11.4q0.4-0.5 1-0.5t1 0.5 0.4 1v5.7h5q15.9 0 19.5 9 1.2 3 1.2 7.4z' })
	        )
	    );
	};
	
	exports.default = FaMailReply;
	module.exports = exports['default'];

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMale = function FaMale(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 15.7v9.3q0 0.9-0.7 1.5t-1.5 0.6-1.5-0.6-0.6-1.5v-7.9h-1.5v20.4q0 1-0.7 1.8t-1.8 0.7-1.7-0.7-0.8-1.8v-10.4h-1.4v10.4q0 1-0.7 1.8t-1.8 0.7-1.7-0.7-0.8-1.8v-20.4h-1.4v7.9q0 0.9-0.6 1.5t-1.6 0.6-1.5-0.6-0.6-1.5v-9.3q0-1.8 1.2-3t3.1-1.3h14.3q1.8 0 3 1.3t1.3 3z m-6.5-10q0 2.1-1.4 3.6t-3.6 1.4-3.5-1.4-1.5-3.6 1.5-3.5 3.5-1.5 3.6 1.5 1.4 3.5z' })
	        )
	    );
	};
	
	exports.default = FaMale;
	module.exports = exports['default'];

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMapMarker = function FaMapMarker(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.6 14.3q0-2.4-1.6-4.1t-4.1-1.6-4 1.6-1.7 4.1 1.7 4 4 1.7 4.1-1.7 1.6-4z m5.8 0q0 2.4-0.8 4l-8.1 17.3q-0.4 0.7-1.1 1.1t-1.5 0.4-1.5-0.4-1-1.1l-8.2-17.3q-0.7-1.6-0.7-4 0-4.7 3.3-8.1t8.1-3.3 8.1 3.3 3.4 8.1z' })
	        )
	    );
	};
	
	exports.default = FaMapMarker;
	module.exports = exports['default'];

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMapO = function FaMapO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.2 2.8q0.6 0.4 0.6 1.1v27.3q0 0.4-0.3 0.7t-0.5 0.4l-12.4 5q-0.5 0.2-1 0l-11.9-4.8-12 4.8q-0.2 0.1-0.5 0.1-0.3 0-0.7-0.2-0.5-0.4-0.5-1.1v-27.3q0-0.4 0.2-0.7t0.6-0.4l12.4-5q0.5-0.2 0.9 0l12 4.8 11.9-4.8q0.7-0.2 1.2 0.1z m-24.9 2.6v24.7l11.2 4.5v-24.7z m-11.8 4.3v24.6l10.5-4.2v-24.7z m34.8 20.6v-24.6l-10.6 4.2v24.7z' })
	        )
	    );
	};
	
	exports.default = FaMapO;
	module.exports = exports['default'];

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMapPin = function FaMapPin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 24.3q1.5 0 2.9-0.3v14.6q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-14.6q1.3 0.3 2.8 0.3z m0-24.3q4.8 0 8.1 3.3t3.4 8.1-3.4 8.1-8.1 3.4-8.1-3.4-3.3-8.1 3.3-8.1 8.1-3.3z m0 5q0.3 0 0.5-0.2t0.2-0.5-0.2-0.5-0.5-0.2q-3.2 0-5.5 2.3t-2.3 5.5q0 0.3 0.2 0.5t0.5 0.2 0.5-0.2 0.2-0.5q0-2.6 1.9-4.5t4.5-1.9z' })
	        )
	    );
	};
	
	exports.default = FaMapPin;
	module.exports = exports['default'];

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMapSigns = function FaMapSigns(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39 6.6q0.2 0.3 0.2 0.5t-0.2 0.6l-3.2 3.1q-0.6 0.6-1.5 0.6h-30q-0.6 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.4h12.8v-1.5q0-0.6 0.5-1t1-0.4h2.8q0.6 0 1 0.4t0.5 1v1.5h11.4q0.9 0 1.5 0.6z m-21.9 20.5h5.8v11.5q0 0.6-0.5 1t-1 0.4h-2.8q-0.6 0-1-0.4t-0.5-1v-11.5z m18.6-10q0.6 0 1 0.5t0.4 1v5.7q0 0.6-0.4 1t-1 0.4h-30q-0.9 0-1.5-0.6l-3.1-3.2q-0.3-0.2-0.3-0.5t0.2-0.5l3.2-3.1q0.6-0.7 1.5-0.7h11.4v-4.2h5.8v4.2h12.8z' })
	        )
	    );
	};
	
	exports.default = FaMapSigns;
	module.exports = exports['default'];

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMap = function FaMap(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.3 0.6l-10.7 5.7q-0.2 0.1-0.4 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.4-0.6l10.7-5.7q0.2-0.1 0.3-0.1z m27.9 0q0.3 0 0.5 0.2t0.2 0.5v32.9q0 0.4-0.4 0.6l-10.7 5.7q-0.1 0.1-0.3 0.1-0.3 0-0.5-0.2t-0.2-0.5v-32.9q0-0.4 0.3-0.6l10.8-5.7q0.1-0.1 0.3-0.1z m-25 0q0.2 0 0.3 0.1l11.4 5.7q0.4 0.2 0.4 0.6v32.9q0 0.3-0.2 0.5t-0.5 0.2q-0.2 0-0.3-0.1l-11.4-5.7q-0.4-0.2-0.4-0.6v-32.9q0-0.3 0.2-0.5t0.5-0.2z' })
	        )
	    );
	};
	
	exports.default = FaMap;
	module.exports = exports['default'];

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMarsDouble = function FaMarsDouble(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.9 10q0-0.3 0.2-0.4t0.5-0.2h5.9q0.6 0 1 0.4t0.4 0.9v6q0 0.3-0.2 0.5t-0.5 0.1h-1.3q-0.3 0-0.5-0.1t-0.2-0.5v-2.8l-5.3 5.3q1.6 2 2.3 4.4t0.2 5.2q-0.7 3.7-3.5 6.4t-6.6 3.3q-4.3 0.6-8-1.7t-5-6.2q-2.4-0.1-4.6-1.2t-3.7-2.8-2.3-4-0.7-4.7q0.2-2.8 1.6-5.3t3.8-3.9 5.2-1.9q2.4-0.3 4.7 0.4t4.1 2.1l5.3-5.2h-2.8q-0.3 0-0.4-0.2t-0.2-0.5v-1.3q0-0.3 0.2-0.5t0.4-0.2h6q0.6 0 0.9 0.4t0.4 0.9v6q0 0.3-0.1 0.5t-0.5 0.2h-1.4q-0.2 0-0.4-0.2t-0.2-0.5v-2.8l-5.3 5.3q1.2 1.6 1.9 3.5 3.8 0.2 6.8 2.6l5.3-5.3h-2.7q-0.3 0-0.5-0.2t-0.2-0.4v-1.4z m-10.6 8.7q0-0.4-0.1-1.2-3.4 0.5-5.6 3.1t-2.3 6q0 0.5 0.1 1.2 3.3-0.5 5.6-3.1t2.3-6z m-18.6 0q0 3.5 2.3 6.1t5.7 3.1q-0.1-0.6-0.1-1.3 0-4.3 2.8-7.6t7.1-4.1q-1.1-2.5-3.4-4t-5.1-1.5q-3.9 0-6.6 2.7t-2.7 6.6z m19.9 17.2q3.8 0 6.6-2.7t2.7-6.6q0-3.4-2.3-6.1t-5.7-3.1q0 0.6 0 1.3 0 4.3-2.8 7.6t-7 4.1q1.1 2.5 3.4 4t5.1 1.5z' })
	        )
	    );
	};
	
	exports.default = FaMarsDouble;
	module.exports = exports['default'];

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMarsStrokeH = function FaMarsStrokeH(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.5 20.4q0.4 0.4 0.4 0.9t-0.4 1l-6.1 6.1q-0.2 0.2-0.5 0.2t-0.5-0.2l-0.9-1q-0.2-0.2-0.2-0.4t0.2-0.5l3.8-3.8h-6.1v4.6q0 0.3-0.2 0.5t-0.4 0.2h-1.4q-0.3 0-0.4-0.2t-0.2-0.5v-4.6h-2.8q-0.5 4.5-3.9 7.5t-7.9 3.1q-3.5 0-6.4-1.8t-4.4-4.9-1.1-6.6q0.3-2.8 1.8-5.1t3.9-3.8 5.2-1.7q3.2-0.2 6 1.1t4.7 3.9 2.1 5.6h2.8v-4.7q0-0.2 0.2-0.4t0.4-0.2h1.4q0.3 0 0.4 0.2t0.2 0.4v4.7h6.1l-3.8-3.8q-0.2-0.2-0.2-0.5t0.2-0.5l0.9-0.9q0.2-0.2 0.5-0.2t0.5 0.2z m-27.5 10.2q3.8 0 6.5-2.7t2.8-6.6-2.8-6.5-6.5-2.8-6.6 2.8-2.7 6.5 2.7 6.6 6.6 2.7z' })
	        )
	    );
	};
	
	exports.default = FaMarsStrokeH;
	module.exports = exports['default'];

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMarsStrokeV = function FaMarsStrokeV(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.8 14.4q4.8 0.5 8.1 4.2t3.3 8.5q0 3.8-1.9 6.9t-5.3 4.7-7.1 1.2q-3-0.3-5.5-2t-4.1-4.1-1.8-5.6q-0.2-3.5 1.2-6.5t4.2-5 6-2.3v-3h-3.5q-0.4 0-0.6-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.6-0.2h3.5v-3.7l-2 2q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.1-1q-0.2-0.2-0.2-0.5t0.2-0.5l4.6-4.5q0.4-0.4 1-0.4t1 0.4l4.5 4.5q0.2 0.2 0.2 0.5t-0.2 0.5l-1.1 1q-0.2 0.2-0.4 0.2t-0.6-0.2l-2-2v3.7h3.6q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-3.6v3z m-1.4 22.7q4.1 0 7-2.9t3-7.1-3-7-7-3-7.1 3-2.9 7 2.9 7.1 7.1 2.9z' })
	        )
	    );
	};
	
	exports.default = FaMarsStrokeV;
	module.exports = exports['default'];

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMarsStroke = function FaMarsStroke(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 2.9q0.5 0 1 0.4t0.4 1v9.3q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-5.9l-4.7 4.8 3.1 3.1q0.2 0.2 0.2 0.5t-0.2 0.5l-1 1.1q-0.2 0.2-0.5 0.2t-0.5-0.2l-3.2-3.2-1.7 1.8q2.8 3.5 2.8 8 0 2.6-1 5t-2.7 4.1-4.2 2.7-4.9 1-5-1-4.1-2.7-2.8-4.1-1-5 1-5 2.8-4.1 4.1-2.8 5-1q4.5 0 8 2.8l1.7-1.7-3.8-3.8q-0.2-0.3-0.2-0.6t0.2-0.4l1-1.1q0.2-0.2 0.5-0.2t0.5 0.2l3.8 3.9 4.8-4.8h-5.8q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h9.3z m-20 31.4q4.1 0 7-2.9t3-7.1-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7.1 7.1 2.9z' })
	        )
	    );
	};
	
	exports.default = FaMarsStroke;
	module.exports = exports['default'];

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMars = function FaMars(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 2.9q0.5 0 1 0.4t0.4 1v9.3q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-5.9l-8.5 8.6q2.8 3.5 2.8 8 0 2.6-1 5t-2.7 4.1-4.2 2.7-4.9 1-5-1-4.1-2.7-2.8-4.1-1-5 1-5 2.8-4.1 4.1-2.8 5-1q4.5 0 8 2.8l8.5-8.5h-5.8q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h9.3z m-20 31.4q4.1 0 7-2.9t3-7.1-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7.1 7.1 2.9z' })
	        )
	    );
	};
	
	exports.default = FaMars;
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMaxcdn = function FaMaxcdn(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.5 17.3l-3.7 17h-7.5l4-18.6q0.3-1.2-0.3-1.9-0.6-0.8-1.9-0.8h-3.8l-4.5 21.3h-7.5l4.6-21.3h-6.4l-4.5 21.3h-7.5l4.6-21.3-3.5-7.3h28.5q2.3 0 4.2 0.9t3.3 2.6q1.4 1.6 1.9 3.7t0 4.4z' })
	        )
	    );
	};
	
	exports.default = FaMaxcdn;
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMeanpath = function FaMeanpath(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.3 18.8v2.5q0 0.6-0.3 0.9t-0.9 0.3h-4.5q-0.5 0-0.8-0.3t-0.3-0.9v-2.5q0-0.5 0.3-0.9t0.8-0.3h4.5q0.6 0 0.9 0.3t0.3 0.9z m-11 5.1v-5.5q0-1.2-0.7-2t-1.9-0.7h-3q-1.5 0-2.1 1.2-0.6-1.2-2.2-1.2h-2.9q-1.1 0-1.9 0.7t-0.7 2v5.5q0 0.5 0.5 0.5h1.2q0.5 0 0.5-0.5v-5.1q0-0.5 0.3-0.9t0.9-0.3h2q0.6 0 0.9 0.3t0.3 0.9v5.1q0 0.5 0.5 0.5h1.2q0.5 0 0.5-0.5v-5.1q0-0.5 0.3-0.9t0.8-0.3h2.2q0.5 0 0.8 0.3t0.3 0.9v5.1q0 0.5 0.5 0.5h1.3q0.4 0 0.4-0.5z m13.2-2.1v-3.5q0-1.1-0.8-1.9t-1.9-0.7h-5.9q-1.2 0-1.9 0.7t-0.7 1.9v9.2q0 0.5 0.5 0.5h1.2q0.5 0 0.5-0.5v-4q0.6 0.9 2.1 0.9h4.2q1.2 0 1.9-0.7t0.8-1.9z m2.8-13.8v24q0 2.1-1.5 3.6t-3.7 1.5h-23.9q-2.2 0-3.7-1.5t-1.5-3.6v-24q0-2.1 1.5-3.6t3.7-1.5h23.9q2.1 0 3.7 1.5t1.5 3.6z' })
	        )
	    );
	};
	
	exports.default = FaMeanpath;
	module.exports = exports['default'];

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMedium = function FaMedium(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.3 9.4v26.2q0 0.5-0.3 0.9t-0.8 0.4q-0.3 0-0.7-0.2l-10.4-5.2q-0.5-0.2-0.8-0.7t-0.3-1v-25.5q0-0.4 0.2-0.8t0.7-0.3q0.3 0 1 0.4l11.4 5.7q0 0.1 0 0.1z m1.5 2.3l11.9 19.3-11.9-6v-13.3z m25.2 0.4v23.5q0 0.5-0.3 0.9t-0.9 0.3-1-0.3l-9.9-4.9z m-0.1-2.7q0 0-5.7 9.3t-6.7 10.9l-8.7-14.1 7.2-11.8q0.4-0.6 1.2-0.6 0.3 0 0.6 0.1l12 6q0.1 0.1 0.1 0.2z' })
	        )
	    );
	};
	
	exports.default = FaMedium;
	module.exports = exports['default'];

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMedkit = function FaMedkit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 25v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-5v-5q0-0.3-0.2-0.5t-0.6-0.2h-4.2q-0.4 0-0.6 0.2t-0.2 0.5v5h-5q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h5v5q0 0.3 0.2 0.5t0.6 0.2h4.2q0.4 0 0.6-0.2t0.2-0.5v-5h5q0.3 0 0.5-0.2t0.2-0.5z m-14.3-16.4h11.4v-2.9h-11.4v2.9z m-8.6 0v28.5h-0.7q-2.1 0-3.5-1.4t-1.5-3.6v-18.5q0-2.1 1.5-3.6t3.5-1.4h0.7z m26.4 0v28.5h-24.2v-28.5h3.5v-3.6q0-0.9 0.7-1.5t1.5-0.6h12.8q0.9 0 1.5 0.6t0.7 1.5v3.6h3.5z m7.9 5v18.5q0 2.1-1.5 3.6t-3.5 1.4h-0.7v-28.5h0.7q2.1 0 3.5 1.4t1.5 3.6z' })
	        )
	    );
	};
	
	exports.default = FaMedkit;
	module.exports = exports['default'];

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMehO = function FaMehO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.7 24.3q0 0.6-0.4 1t-1 0.4h-14.3q-0.6 0-1-0.4t-0.4-1 0.4-1 1-0.4h14.3q0.6 0 1 0.4t0.4 1z m-11.4-10q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m11.4 0q0 1.2-0.8 2t-2 0.8-2.1-0.8-0.8-2 0.8-2 2.1-0.9 2 0.9 0.8 2z m5.7 5.7q0-2.9-1.1-5.5t-3.1-4.6-4.5-3.1-5.6-1.1-5.5 1.1-4.6 3.1-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5z m2.9 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaMehO;
	module.exports = exports['default'];

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMercury = function FaMercury(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.5 7.1q3.3 1.6 5.2 4.7t2 6.8q0 4.9-3.3 8.6t-8.1 4.1v3h2.1q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v2.2q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-2.2h-2.1q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h2.1v-3q-4.8-0.5-8.1-4.1t-3.3-8.6q0-3.8 2-6.8t5.2-4.7q-3.7-2.2-5.1-6.1-0.1-0.4 0.1-0.7t0.6-0.3h1.5q0.5 0 0.7 0.4 0.9 2.4 3.1 3.9t4.8 1.4 4.7-1.4 3.2-3.9q0.1-0.4 0.8-0.4h1.3q0.4 0 0.6 0.3t0.1 0.7q-1.4 3.9-5.1 6.1z m-5.6 21.5q4.1 0 7-3t3-7-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7 7.1 3z' })
	        )
	    );
	};
	
	exports.default = FaMercury;
	module.exports = exports['default'];

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMicrophoneSlash = function FaMicrophoneSlash(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.6 21.1l-2.3 2.2q-0.9-2.3-0.9-4.7v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.4 1v2.9q0 1.2 0.3 2.5z m24.8-13.4l-8 8v2.9q0 2.9-2.1 5t-5.1 2.1q-1.2 0-2.4-0.4l-2.2 2.1q2.2 1.2 4.6 1.2 4.1 0 7.1-3t2.9-7v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.5 1v2.9q0 4.9-3.3 8.6t-8.2 4.1v3h5.8q0.5 0 1 0.4t0.4 1-0.4 1-1 0.4h-14.3q-0.6 0-1-0.4t-0.5-1 0.5-1 1-0.4h5.7v-3q-2.8-0.2-5.3-1.8l-5.6 5.7q-0.3 0.2-0.5 0.2t-0.6-0.2l-1.8-1.8q-0.2-0.3-0.2-0.5t0.2-0.6l27.6-27.5q0.2-0.2 0.5-0.2t0.5 0.2l1.8 1.8q0.2 0.3 0.2 0.5t-0.2 0.6z m-8.5-3l-13.8 13.9v-11.5q0-2.9 2.1-5t5-2.1q2.3 0 4.1 1.3t2.6 3.4z' })
	        )
	    );
	};
	
	exports.default = FaMicrophoneSlash;
	module.exports = exports['default'];

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMicrophone = function FaMicrophone(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.7 15.7v2.9q0 4.9-3.3 8.6t-8.1 4.1v3h5.7q0.6 0 1 0.4t0.4 1-0.4 1-1 0.4h-14.3q-0.6 0-1-0.4t-0.4-1 0.4-1 1-0.4h5.7v-3q-4.8-0.5-8.1-4.1t-3.3-8.6v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.5 1v2.9q0 4.1 2.9 7t7.1 3 7-3 3-7v-2.9q0-0.6 0.4-1t1-0.4 1 0.4 0.4 1z m-5.7-8.6v11.5q0 2.9-2.1 5t-5 2.1-5.1-2.1-2.1-5v-11.5q0-2.9 2.1-5t5.1-2.1 5 2.1 2.1 5z' })
	        )
	    );
	};
	
	exports.default = FaMicrophone;
	module.exports = exports['default'];

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMinusCircle = function FaMinusCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaMinusCircle;
	module.exports = exports['default'];

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMinusSquareO = function FaMinusSquareO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.2 17.9v1.4q0 0.3-0.2 0.5t-0.5 0.2h-18.6q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h18.6q0.3 0 0.5 0.2t0.2 0.6z m2.9 10v-18.6q0-1.5-1.1-2.5t-2.5-1.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5z m2.8-18.6v18.6q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q2.7 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaMinusSquareO;
	module.exports = exports['default'];

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMinusSquare = function FaMinusSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 21.4v-2.8q0-0.6-0.5-1t-1-0.5h-20q-0.5 0-1 0.5t-0.4 1v2.8q0 0.6 0.4 1t1 0.5h20q0.6 0 1-0.5t0.5-1z m5.7-12.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaMinusSquare;
	module.exports = exports['default'];

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMinus = function FaMinus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 16.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-27.2q-0.8 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h27.2q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaMinus;
	module.exports = exports['default'];

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMixcloud = function FaMixcloud(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.8 23.5q0-1-0.6-1.8t-1.5-1.2q-0.1 0.8-0.4 1.6-0.1 0.4-0.5 0.6t-0.8 0.3q-0.2 0-0.4-0.1-0.5-0.1-0.8-0.6t-0.1-1.1q0.4-1.2 0.4-2.5 0-2.1-1-3.9t-2.9-2.9-4-1.1q-2.4 0-4.3 1.3t-3 3.4q1.9 0.5 3.3 1.8 0.4 0.4 0.4 1t-0.4 0.9-0.9 0.4-1-0.4q-1.3-1.3-3.1-1.3-1.9 0-3.2 1.3t-1.3 3.2 1.3 3.1 3.2 1.3h18.3q1.4 0 2.3-0.9t1-2.4z m2.7 0q0 2.5-1.8 4.3t-4.2 1.7h-18.3q-3 0-5.1-2.1t-2.1-5q0-2.7 1.8-4.7t4.3-2.4q1.1-3.2 3.9-5.2t6.2-2q4.1 0 7.1 2.8t3.5 6.8q2 0.4 3.3 2.1t1.4 3.7z m4.4 0q0 3.1-1.7 5.6-0.4 0.6-1.2 0.6-0.4 0-0.7-0.2-0.5-0.3-0.6-0.9t0.2-1q1.3-1.8 1.3-4.1t-1.3-4q-0.3-0.5-0.2-1t0.6-0.9 1-0.2 0.9 0.6q1.7 2.5 1.7 5.5z m4.4 0q0 4.3-2.3 7.8-0.4 0.6-1.1 0.6-0.4 0-0.8-0.2-0.4-0.4-0.5-0.9t0.2-1q1.9-2.9 1.9-6.3 0-3.4-1.9-6.2-0.3-0.5-0.2-1t0.5-0.9q0.5-0.3 1-0.2t0.9 0.6q2.3 3.5 2.3 7.7z' })
	        )
	    );
	};
	
	exports.default = FaMixcloud;
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMobile = function FaMobile(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.9 31.4q0-0.7-0.6-1.2t-1.2-0.6-1.3 0.6-0.5 1.2 0.5 1.3 1.3 0.5 1.2-0.5 0.6-1.3z m4.6-3.5v-15.8q0-0.2-0.2-0.5t-0.5-0.2h-11.4q-0.3 0-0.5 0.2t-0.3 0.5v15.8q0 0.2 0.3 0.5t0.5 0.2h11.4q0.3 0 0.5-0.2t0.2-0.5z m-4.3-19q0-0.3-0.3-0.3h-3.6q-0.4 0-0.4 0.3t0.4 0.4h3.6q0.3 0 0.3-0.4z m6.4-0.3v22.8q0 1.2-0.8 2t-2 0.9h-11.4q-1.2 0-2.1-0.9t-0.8-2v-22.8q0-1.2 0.8-2t2.1-0.9h11.4q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaMobile;
	module.exports = exports['default'];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaModx = function FaModx(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.9 15.8l-13.8-8.6 2.1-3.4h19.1z m-22.9 5.9l-4.1-2.5v-19.2l26.4 16.6z m22.8-3l3.3 2.1v19.2l-11.9-7.5z m-0.8-0.4l-11.2 17.9h-19.1l8-12.8z' })
	        )
	    );
	};
	
	exports.default = FaModx;
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMoney = function FaMoney(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.9 25.3h8v-2h-2.6v-9.3h-2.4l-3.1 2.9 1.6 1.6q0.9-0.7 1.2-1.2h0v6h-2.7v2z m10.7-5.3q0 1.5-0.5 2.9t-1.2 2.8-2.1 2.1-2.9 0.8-2.8-0.8-2.1-2.1-1.3-2.8-0.4-2.9 0.4-2.9 1.3-2.8 2.1-2.1 2.8-0.8 2.9 0.8 2.1 2.1 1.2 2.8 0.5 2.9z m10.6 5.3v-10.6q-2.2 0-3.7-1.6t-1.6-3.7h-23.9q0 2.2-1.6 3.7t-3.7 1.6v10.6q2.2 0 3.7 1.6t1.6 3.7h23.9q0-2.2 1.6-3.7t3.7-1.6z m2.7-17.3v24q0 0.5-0.4 0.9t-1 0.4h-37.2q-0.5 0-0.9-0.4t-0.4-0.9v-24q0-0.5 0.4-0.9t0.9-0.4h37.2q0.6 0 1 0.4t0.4 0.9z' })
	        )
	    );
	};
	
	exports.default = FaMoney;
	module.exports = exports['default'];

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMoonO = function FaMoonO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.7 29.1q-1.2 0.2-2.5 0.2-4 0-7.5-2t-5.5-5.5-2-7.5q0-4.3 2.3-8-4.5 1.4-7.3 5.1t-2.8 8.6q0 2.9 1.1 5.5t3 4.6 4.6 3 5.5 1.2q3.3 0 6.1-1.4t5-3.8z m4.5-1.9q-2.1 4.5-6.3 7.2t-9.3 2.7q-3.4 0-6.6-1.3t-5.5-3.7-3.6-5.4-1.4-6.7q0-3.4 1.3-6.5t3.5-5.4 5.2-3.7 6.5-1.5q1-0.1 1.4 0.8 0.4 1-0.4 1.7-1.9 1.7-2.9 4t-1 4.9q0 3.3 1.6 6.1t4.4 4.4 6.1 1.6q2.6 0 5.1-1.1 0.9-0.4 1.6 0.3 0.3 0.3 0.4 0.7t-0.1 0.9z' })
	        )
	    );
	};
	
	exports.default = FaMoonO;
	module.exports = exports['default'];

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMotorcycle = function FaMotorcycle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.5 22.4q0.2 1.8-0.4 3.4t-1.7 2.8-2.7 1.8-3.4 0.6q-2.7-0.2-4.8-2.2t-2.3-4.7q-0.2-1.9 0.5-3.6t2-2.9l-1.2-1.9q-1.6 1.4-2.6 3.4t-0.9 4.2q0 0.4-0.3 0.8t-0.8 0.3h-5.6q-0.4 2.8-2.6 4.7t-5 1.9q-3.2 0-5.4-2.3t-2.3-5.4 2.3-5.4 5.4-2.3q1.3 0 2.6 0.5l0.4-0.8q-2.1-1.9-5.2-1.9h-1.1q-0.5 0-0.8-0.3t-0.3-0.8 0.3-0.8 0.8-0.3h2.2q1.3 0 2.5 0.2t2 0.7 1.2 0.7 0.9 0.6h10.8l-1.5-2.2h-3.8q-0.5 0-0.9-0.4t-0.2-0.9q0.1-0.4 0.4-0.6t0.7-0.3h4.4q0.5 0 0.9 0.5l1.2 1.8 1.9-2q0.4-0.3 0.8-0.3h1.8q0.4 0 0.7 0.3t0.4 0.8v2.2q0 0.5-0.4 0.8t-0.7 0.3h-3.1l2 3q2.2-1.1 4.7-0.7 2.4 0.5 4.2 2.4t2 4.3z m-31.8 6.4q2 0 3.5-1.3t1.9-3.1h-5.4q-0.6 0-1-0.5-0.3-0.6 0-1.1l2.6-4.8q-0.9-0.2-1.6-0.2-2.3 0-3.9 1.6t-1.6 3.9 1.6 3.9 3.9 1.6z m24.2 0q2.2 0 3.8-1.6t1.7-3.9-1.7-3.9-3.8-1.6q-1.1 0-2.1 0.4l3 4.5q0.2 0.4 0.1 0.8t-0.4 0.7q-0.3 0.2-0.6 0.2-0.6 0-0.9-0.5l-3-4.5q-1.6 1.7-1.6 3.9 0 2.3 1.6 3.9t3.9 1.6z' })
	        )
	    );
	};
	
	exports.default = FaMotorcycle;
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMousePointer = function FaMousePointer(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.3 23.3q0.7 0.7 0.3 1.5-0.4 0.9-1.3 0.9h-8.5l4.4 10.6q0.3 0.6 0 1.1t-0.7 0.8l-4 1.7q-0.5 0.2-1.1 0t-0.7-0.8l-4.3-10.1-7 7q-0.4 0.4-1 0.4-0.2 0-0.5-0.1-0.9-0.4-0.9-1.3v-33.6q0-0.9 0.9-1.3 0.3-0.1 0.5-0.1 0.6 0 1 0.4z' })
	        )
	    );
	};
	
	exports.default = FaMousePointer;
	module.exports = exports['default'];

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaMusic = function FaMusic(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 5v25q0 1.1-0.8 2t-1.9 1.3-2.3 0.8-2.2 0.2-2.1-0.2-2.3-0.8-1.9-1.3-0.8-2 0.8-2 1.9-1.3 2.3-0.8 2.1-0.2q2.4 0 4.3 0.9v-12l-17.1 5.3v15.8q0 1.1-0.8 2t-1.9 1.4-2.3 0.7-2.2 0.2-2.1-0.2-2.3-0.7-1.9-1.4-0.8-2 0.8-2 1.9-1.3 2.3-0.7 2.1-0.3q2.4 0 4.3 0.9v-21.6q0-0.7 0.5-1.2t1-0.8l18.6-5.7q0.3-0.1 0.6-0.1 0.9 0 1.6 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaMusic;
	module.exports = exports['default'];

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaNeuter = function FaNeuter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.7 12.9q0 4.9-3.3 8.5t-8.1 4.2v13.7q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-13.7q-4.8-0.5-8.1-4.2t-3.3-8.5q0-2.7 1-5t2.8-4.1 4.1-2.8 5-1 4.9 1 4.2 2.8 2.7 4.1 1 5z m-12.8 10q4.1 0 7-3t3-7-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7 7.1 3z' })
	        )
	    );
	};
	
	exports.default = FaNeuter;
	module.exports = exports['default'];

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaNewspaperO = function FaNewspaperO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 12.5h-7.5v7.5h7.5v-7.5z m2.5 12.5v2.5h-12.5v-2.5h12.5z m0-14.9v12.4h-12.5v-12.4h12.5z m12.4 14.9v2.5h-10v-2.5h10z m0-5v2.5h-10v-2.5h10z m0-5v2.5h-10v-2.5h10z m0-4.9v2.4h-10v-2.4h10z m-29.8 18.6v-18.6h-2.5v18.6q0 0.5 0.4 0.9t0.8 0.3 0.9-0.3 0.4-0.9z m32.3 0v-21.1h-29.8v21.1q0 0.6-0.3 1.2h28.8q0.5 0 0.9-0.3t0.4-0.9z m2.5-23.6v23.6q0 1.5-1.1 2.6t-2.7 1.1h-32.3q-1.5 0-2.6-1.1t-1.1-2.6v-21.1h5v-2.5h34.8z' })
	        )
	    );
	};
	
	exports.default = FaNewspaperO;
	module.exports = exports['default'];

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaObjectGroup = function FaObjectGroup(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 10.1h-2.5v19.8h2.5v7.5h-7.5v-2.5h-24.8v2.5h-7.5v-7.5h2.5v-19.8h-2.5v-7.5h7.5v2.5h24.8v-2.5h7.5v7.5z m-5-5v2.5h2.5v-2.5h-2.5z m-32.3 0v2.5h2.5v-2.5h-2.5z m2.5 29.8v-2.5h-2.5v2.5h2.5z m27.3-2.5v-2.5h2.5v-19.8h-2.5v-2.5h-24.8v2.5h-2.5v19.8h2.5v2.5h24.8z m5 2.5v-2.5h-2.5v2.5h2.5z m-12.5-19.9h7.5v14.9h-17.4v-4.9h-7.4v-14.9h17.3v4.9z m-14.9 7.5h12.5v-10h-12.5v10z m19.9 5v-10h-5v7.5h-7.4v2.5h12.4z' })
	        )
	    );
	};
	
	exports.default = FaObjectGroup;
	module.exports = exports['default'];

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaObjectUngroup = function FaObjectUngroup(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40.3 17.8h-2.2v11.2h2.2v6.7h-6.7v-2.3h-15.7v2.3h-6.7v-6.7h2.2v-2.3h-6.7v2.3h-6.7v-6.8h2.2v-11.2h-2.2v-6.7h6.7v2.3h15.7v-2.3h6.7v6.7h-2.2v2.3h6.7v-2.3h6.7v6.8z m-4.4-4.5v2.2h2.2v-2.2h-2.2z m-11.2-6.7v2.2h2.2v-2.2h-2.2z m-22.5 0v2.2h2.3v-2.2h-2.3z m2.3 20.1v-2.2h-2.3v2.2h2.3z m22.4-2.2h-2.2v2.2h2.2v-2.2z m-20.2 0h15.7v-2.3h2.3v-11.2h-2.3v-2.2h-15.7v2.2h-2.2v11.2h2.2v2.3z m9 8.9v-2.2h-2.3v2.2h2.3z m22.4 0v-2.2h-2.2v2.2h2.2z m-2.2-4.4v-11.2h-2.3v-2.3h-6.7v6.7h2.2v6.8h-6.7v-2.3h-6.7v2.3h2.2v2.2h15.7v-2.2h2.3z' })
	        )
	    );
	};
	
	exports.default = FaObjectUngroup;
	module.exports = exports['default'];

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOdnoklassnikiSquare = function FaOdnoklassnikiSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.7 12.9q0 1.5-1 2.6t-2.6 1-2.5-1-1-2.6 1-2.5 2.5-1 2.6 1 1 2.5z m4.8 8.1q-0.3-0.4-0.7-0.7t-1-0.2-1.4 0.6q-0.2 0.2-0.6 0.5t-1.8 0.7-2.9 0.4-2.7-0.4-1.9-0.8l-0.6-0.4q-0.7-0.5-1.4-0.6t-1.1 0.2-0.6 0.7q-0.5 1.1 0 1.7t1.9 1.7q1.9 1.1 5.1 1.4l-1.2 1.2q-3.1 3.2-4.2 4.3-0.5 0.4-0.5 1.1t0.5 1.2l0.2 0.2q0.4 0.5 1.1 0.5t1.2-0.5l4.3-4.3q2.5 2.6 4.2 4.3 0.5 0.5 1.2 0.5t1.2-0.5l0.2-0.2q0.5-0.5 0.5-1.2t-0.5-1.1l-4.3-4.3-1.2-1.2q3.2-0.3 5.1-1.4 1.5-1 1.9-1.7t0-1.7z m-1.1-8.1q0-2.9-2.1-5.1t-5.2-2.1-5.1 2.1-2.1 5.1 2.1 5.2 5.1 2.1 5.2-2.1 2.1-5.2z m9.9-3.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaOdnoklassnikiSquare;
	module.exports = exports['default'];

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOdnoklassniki = function FaOdnoklassniki(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.8 20.2q-4.2 0-7.2-2.9t-2.9-7.2q0-4.2 2.9-7.1t7.2-3 7.1 3 3 7.1q0 4.2-3 7.2t-7.1 2.9z m0-15.1q-2.1 0-3.5 1.5t-1.5 3.5q0 2.1 1.5 3.5t3.5 1.5 3.5-1.5 1.5-3.5q0-2-1.5-3.5t-3.5-1.5z m11.7 16.4q0.3 0.6 0.3 1.1t-0.1 0.9-0.6 0.8-0.9 0.9-1.4 0.9q-2.6 1.6-7 2.1l1.6 1.6 5.9 6q0.7 0.7 0.7 1.6t-0.7 1.6l-0.2 0.3q-0.7 0.7-1.7 0.7t-1.6-0.7q-1.5-1.5-6-6l-6 6q-0.6 0.7-1.6 0.7t-1.6-0.7l-0.3-0.3q-0.7-0.6-0.7-1.6t0.7-1.6l7.6-7.6q-4.6-0.5-7.1-2.1-0.9-0.6-1.4-0.9t-0.9-0.9-0.6-0.8-0.1-0.9 0.3-1.1q0.2-0.5 0.6-0.8t1-0.5 1.2 0 1.5 0.8q0.1 0.1 0.3 0.3t1 0.5 1.5 0.7 2.1 0.5 2.5 0.3q2 0 3.9-0.6t2.6-1.1l0.9-0.6q0.7-0.5 1.4-0.8t1.3 0 0.9 0.5 0.7 0.8z' })
	        )
	    );
	};
	
	exports.default = FaOdnoklassniki;
	module.exports = exports['default'];

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOpencart = function FaOpencart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.7 31.6q0 1.2-0.9 2.1t-2 0.8-2-0.8-0.9-2.1 0.9-2 2-0.8 2 0.8 0.9 2z m-13.1 0q0 1.2-0.9 2.1t-2 0.8-2.1-0.8-0.8-2.1 0.8-2 2.1-0.8 2 0.8 0.9 2z m-13.6-26.1q1 1 1.9 1.8t2.2 1.5 2.3 1.1 2.9 0.8 3.5 0.5 4.4 0.3 5.3 0.2 6.6 0q2.4 0 4.2 0.1t3.2 0.3 2.2 0.5 1.2 0.7 0.4 0.9-0.3 1.1-1 1.3-1.6 1.6-2 1.9-2.4 2.1q-3.3 2.7-5 4.3 0.5-0.9 1.3-1.9t1.7-1.9 1.6-1.7 1.5-1.6 0.9-1.4 0.2-1.2-0.8-1-2-0.7-3.6-0.4-5.3-0.1q-2.9 0-5.5-0.1t-4.5-0.4-3.5-0.8-2.8-0.9-2.2-1-1.6-1.2-1.2-1.3-0.9-1.2-0.7-1.2-0.6-1z' })
	        )
	    );
	};
	
	exports.default = FaOpencart;
	module.exports = exports['default'];

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOpenid = function FaOpenid(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.2 0v34.3l-6 2.8q-5.1-0.4-9.3-2.2t-6.5-4.7-2.4-6.1q0-3.1 2.2-5.9t6.2-4.5 8.7-2.4v3.8q-4.8 0.8-7.9 3.3t-3.2 5.7q0 3.4 3.5 6t8.7 3.2v-30.3z m15 13l0.8 8.7-11.7-2.6 3.3-1.8q-2.7-1.6-6.3-2.2v-3.9q6.2 0.8 10.7 3.6z' })
	        )
	    );
	};
	
	exports.default = FaOpenid;
	module.exports = exports['default'];

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOpera = function FaOpera(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.3 5.1q-3.7-2.5-8-2.5-3.4 0-6.5 1.7t-5.4 4.4q-1.7 2.1-2.7 4.9t-1 5.9v1q0.1 3.1 1 5.9t2.7 4.9q2.3 2.8 5.4 4.4t6.5 1.7q4.3 0 8-2.5-2.7 2.4-6.1 3.8t-7.2 1.3q-0.6 0-1 0-3.9-0.2-7.4-1.9t-6.1-4.3-4-6.2-1.5-7.6q0-4.1 1.6-7.8t4.2-6.4 6.4-4.2 7.8-1.6h0.1q3.7 0 7.1 1.4t6.1 3.7z m6.7 14.9q0 4.3-1.7 8.1t-4.8 6.6q-2.3 1.4-4.9 1.4-3.1 0-5.7-1.9 3.4-1.2 5.6-5.2t2.3-9q0-5.1-2.3-9t-5.6-5.2q2.7-1.9 5.7-1.9 2.6 0 5 1.5 3 2.7 4.7 6.5t1.7 8.1z' })
	        )
	    );
	};
	
	exports.default = FaOpera;
	module.exports = exports['default'];

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaOptinMonster = function FaOptinMonster(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.4 33.6q-0.2 0.3-0.5 0.6t-0.7 0.5q-0.4 0.1-0.9-0.1t-0.5-0.5q0-0.4 0.7-1t1.2-0.7q0.4 0 0.6 0.4t0.1 0.8z m23.4 0q0.2 0.3 0.5 0.6t0.7 0.5q0.4 0.1 0.9-0.1t0.4-0.5q0.1-0.4-0.6-1t-1.2-0.7q-0.4 0-0.6 0.4t-0.1 0.8z m0.9-1.9q0.2 0.5 1 1.1t1.3 0.7q0.8 0.2 1.5-0.1t0.6-0.9q0-0.8-1.2-1.7t-2-1.1q-0.7-0.1-1.1 0.7t-0.1 1.3z m-25.2 0q-0.2 0.5-1 1.1t-1.3 0.7q-0.8 0.2-1.5-0.1t-0.6-0.9q0-0.8 1.2-1.7t2-1.1q0.7-0.1 1.1 0.7t0.1 1.3z m12.8-19.6h0q-0.7 0-1.3 0.2 0.4 0.2 0.7 0.5t0.3 0.9q0 0.6-0.4 1.1t-1.2 0.4q-0.9 0-1.4-0.7-0.1 0.4-0.1 0.7 0 1.3 1 2.2t2.4 0.9q1.4 0 2.4-0.9t0.9-2.2-0.9-2.2-2.4-0.9z m5.3-3.9q-1.7-1.9-3.9-2.3t-4.3 0.8q0.5-1 1.5-1.7t2-0.7 2.2 0.3 1.7 1.3 0.8 2.3z m13.1 21.7q0.2 0.2-0.2 0.8 0.2 0.4 0.2 0.7 0 0.9-0.8 1.9t-1.9 1.6-2.1 0.7q-0.8 0-1.6-0.4t-1.2-1.1q-12 0.4-22 0-0.4 0.7-1.2 1.1t-1.6 0.4q-1.5-0.1-3.1-1.4t-1.7-2.8q0.1-0.4 0.2-0.7-0.4-0.6-0.2-0.8 0.1-0.2 0.5 0 0.3-0.4 0.7-0.9-0.1-0.5 0.1-0.7 0.2-0.1 0.6 0.1 0.6-0.3 1.1-0.6 0-0.5 0.2-0.6 0.4-0.2 0.9 0.3 0.6-0.1 1.1 0 0.3 0.1 0.6 0.3v-1.3q-0.2 0-0.3 0-0.9-0.2-1.7-0.8t-0.9-1.5q-0.2-0.7 0-1.4 0.2-1.1 1.6-1.7 0-0.3 0.3-0.6t0.6-0.4 0.6 0.1 0.4 0.6h0.2q0.8 0 1 0.4 0.1 0 0.1 0.1 0.2 0 0.6-0.1t0.5 0q-0.3-0.2-0.5-0.3-0.4-0.7-1.6-0.8 0-0.1 0-0.2-1.1 0-2.1-0.3t-1.5-0.8q-0.5-0.7-0.7-1.6t0-2q0.2-2.2 1.5-3.1 0.4-0.3 0.9-0.1t0.6 0.7q0 0 0 0.2t0.1 0.4 0 0.4 0.1 0.3 0.2 0.2q0.4 0.2 1.3 0.2 0.8-0.8 1.7-1.3-0.7-0.1-2.8 0.2l0.8-0.8q1.1-1 2.8-1.9 2.6-1.3 5-1.5-0.4-0.2-0.7-0.3t-0.9-0.2-0.7-0.2-0.8-0.2-0.8-0.2q10.4-2.2 15.8 2.4 1.8 1.5 2.8 3.9 1.5 0.2 2.1-0.1h0q0.1-0.1 0.2-0.2t0.1-0.3 0-0.4 0.1-0.4l0-0.2q0.1-0.5 0.6-0.7t0.9 0.1q1.3 0.9 1.6 3.1 0.1 1-0.1 2t-0.7 1.6q-0.5 0.5-1.5 0.8t-2 0.3v0.2q-1.3 0.1-1.7 0.8-0.2 0.1-0.5 0.3 0.2 0 0.5 0t0.6 0.1q0-0.1 0.1-0.1 0.2-0.4 1-0.4h0.2q0.1-0.4 0.4-0.6t0.5-0.1 0.7 0.4 0.3 0.6q1.4 0.6 1.6 1.7 0.2 0.7 0.1 1.4-0.3 0.9-1 1.5t-1.7 0.8q-0.2 0-0.3 0 0 0.9 0 1.3 0.3-0.2 0.6-0.3 0.5-0.1 1.1 0 0.5-0.5 0.9-0.3 0.2 0.1 0.2 0.6 0.6 0.3 1.1 0.6 0.4-0.2 0.6-0.1 0.2 0.2 0.1 0.7 0.5 0.5 0.7 0.9 0.4-0.1 0.5 0z m-4.8-16.6q0 0.5-0.1 0.9 1.4 0.6 1.9 2.3 0.1-0.6-0.2-1.7t-0.7-1.6q-0.3-0.3-0.6-0.3t-0.3 0.4z m-1.4 1.7q0.7 0.7 0.9 1.9t0 2.2q1.1-0.2 1.7-0.8 0.2-0.2 0.3-0.5-0.1-1.1-0.6-2t-1.3-1.2q-0.3 0.3-1 0.4z m-0.6 0.1q-0.5 0-0.8 0 0.8 2 1 4.1 0.3 0 0.7 0 0.3-1.2 0-2.4t-0.9-1.7z m-27.4 1.4q0.5-1.7 2-2.3-0.2-0.4-0.2-0.9 0-0.4-0.3-0.4t-0.6 0.3q-0.5 0.5-0.7 1.6t-0.2 1.7z m0.6 1.8q0.6 0.5 1.7 0.8-0.2-1 0-2.2t0.9-1.9q-0.7-0.1-0.9-0.4-0.9 0.3-1.4 1.2t-0.6 2q0.2 0.3 0.3 0.5z m3.1 0.9q0.3-2.1 1.3-4.1-0.3 0.1-0.9 0.3l-0.8 0.4v0q-0.8 1.5-0.4 3.4 0.5 0 0.8 0z m16.9 0.7q0.1 0.7 0.3 1.9t0.2 1.6q0 0.3 0.2 0.4t0.4-0.1q0.7-0.4 1.1-1.5t0.4-2.2q-0.5 0-2.6-0.1z m-4.9-11.2q-2.1 0-3.5 1.5t-1.5 3.4q0 2.1 1.5 3.5t3.5 1.5 3.5-1.5 1.4-3.5q0-2-1.5-3.4t-3.4-1.5z m4 11.2q-1.9 0-3.7 0v0q-0.1 0.5 0 1.5t0.2 1.1q0.6 0.3 1.7 0.3t1.7-0.2q0.1 0 0.1-0.7t0-1.2 0-0.8z m-4.7 3.5q0.1-0.1 0.1-0.9t0-1.5 0-1.1v0l-3.8 0q-0.1 0.4-0.1 1.1t0 1.5 0.2 0.8q0.6 0.2 1.8 0.3t1.8-0.2z m-6.9-3.3q-0.3 1 0 2t1.4 1.5q0.3 0.2 0.4 0.1t0.2-0.4q0.1-0.2 0.2-1.5t0.2-1.8q-1.3 0-2.4 0.1z m-2.3 2.2q0.1 0.4-0.5 0.6 2.3 2.5 4.7 4.2t5.4 2.7q3-0.9 5.4-2.5t5.1-4.4q-0.6-0.3-0.5-0.6l0.1-0.2q-0.3 0-0.9-0.1t-0.9-0.1q-0.4 1.6-1.4 2.4-0.9 0.6-1.4-0.1-0.1-0.1-0.2-0.2-0.1-0.2-0.3-1.1 0 0.1-0.1 0.2t-0.1 0.1-0.1 0.1-0.2 0.1l-0.2 0-0.2 0-0.2 0.1-0.2 0-0.3 0q-1.8 0.1-2.8-0.2-0.1 0.3-0.2 0.5t-0.4 0.2-0.4 0.1-0.6 0.1q0 0-0.1 0t0 0h-0.1q-3.1 0.3-3.5-0.7-0.1 1.1-1 1-0.8-0.2-1.6-1-0.2-0.2-0.3-0.4-0.3-0.5-0.5-1.2-1 0.1-1.5 0.2 0 0 0 0.2z m-1.4 11q0-0.3 0-0.6-0.3-1.2-0.9-2.2t-1.2-1.3q-0.8-0.2-1.8 0.3t-1.8 1.4-0.7 1.9q0.6 0.9 1.7 1.6t2.1 0.7q0.9 0.1 1.6-0.4t1-1.4z m0-3q0.4 1.1 0.5 2.1 3.4-2 6.9-3.1-1.8-0.9-3.2-2.1t-3.1-2.9q-0.1 0.1-0.5 0.3 0 0-0.1 0t0 0.1q0.6 0.3 0.4 0.7-0.2 0.4-1 0.6-0.1 0.2-0.5 0.4h0q0 1.4 0 2.6 0.4 0.6 0.6 1.3z m1.2 2.9q9.4 0.4 20.1 0-4.5-2.6-7.5-3.4-1.3 0.6-2.7 0.9-0.2 0.1-0.3 0-1.2-0.3-2.3-0.8-3.6 1-7.3 3.3h0v0q0 0 0 0z m20.8-0.8q0-1 0.5-2.1 0.2-0.7 0.5-1.3l0 0.1q0.1-1.4 0.1-2.7-0.3-0.2-0.6-0.5-0.7-0.1-0.9-0.5-0.2-0.4 0.3-0.7 0-0.1 0-0.2-0.3 0-0.5-0.2-3.5 3.3-6.7 5 3.5 1 7.3 3.1z m6.8 0.4q0.1-1-0.7-1.9t-1.8-1.4-1.8-0.3q-0.6 0.2-1.2 1.3t-0.9 2.2q0 0.3 0 0.6 0.2 0.8 0.9 1.4t1.7 0.4q0.9 0 2.1-0.7t1.7-1.6z' })
	        )
	    );
	};
	
	exports.default = FaOptinMonster;
	module.exports = exports['default'];

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPagelines = function FaPagelines(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 24.6q-0.7 1.8-1.7 3.1t-2 2-2.2 1-2.3 0.3-2.2-0.2-1.9-0.4-1.5-0.7-1.1-0.5l-0.4-0.2q-2.5 5.1-6.4 8t-8.6 3q-0.4 0-0.7-0.3t-0.3-0.7 0.3-0.7 0.7-0.3q3.9 0 7.2-2.4t5.6-6.6q-0.8 0.4-1.6 0.6t-1.8 0.2-2.1 0-2-0.6-2.1-1.4-1.9-2.2-1.6-3.3q2.5-1 4.7-1.2t3.8 0.1 2.7 1.3 2 1.7 1.3 1.9q1.2-3 1.7-6.5-0.1 0-0.4 0t-1 0.1-1.5 0-1.9-0.3-1.9-0.5-1.9-0.9-1.7-1.5-1.2-2.1-0.6-2.8q1.5-0.7 2.9-0.9t2.5 0.1 2.1 0.6 1.6 1.2 1.3 1.3 0.9 1.4 0.6 1.3 0.4 0.9l0.1 0.3q0.3-2.7 0.3-4.3-0.2-0.2-0.5-0.4t-1.1-1-1.4-1.6-1.2-2.1-0.8-2.5 0.3-2.8 1.6-3.1q1.6 0.6 2.8 1.4t1.9 1.7 1.1 1.9 0.4 2 0 1.9-0.3 1.7-0.4 1.4-0.4 0.9l-0.1 0.3q0 0.2 0 1.2t0 1.6q0-0.2 0.2-0.4t0.7-1 1.1-1.3 1.6-1.2 2-1 2.5-0.4 3 0.6q-0.1 1.7-0.5 3.1t-1.1 2.4-1.6 1.6-1.8 1-1.9 0.5-1.8 0.2-1.5 0-1-0.1l-0.4-0.1q-0.5 3.3-1.6 6.4 0.1-0.2 0.4-0.5t1.1-0.9 1.7-1.1 2.2-1 2.7-0.4 2.8 0.5 3.1 1.7z' })
	        )
	    );
	};
	
	exports.default = FaPagelines;
	module.exports = exports['default'];

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaintBrush = function FaPaintBrush(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36 0q1.6 0 2.8 1t1.2 2.6q0 1.4-1 3.4-7.5 14-10.4 16.8-2.2 2-4.9 2-2.8 0-4.8-2t-2-4.9q0-2.9 2-4.8l14.2-12.9q1.4-1.2 2.9-1.2z m-20.2 23.1q0.8 1.7 2.3 2.9t3.4 1.7l0 1.6q0.1 4.7-2.9 7.7t-7.8 3q-2.7 0-4.8-1t-3.4-2.9-2-4.1-0.6-4.9q0.2 0.1 0.9 0.7t1.4 1 1.3 0.8 1 0.4q1 0 1.3-0.8 0.5-1.5 1.3-2.6t1.5-1.7 2-1 2.3-0.6 2.8-0.2z' })
	        )
	    );
	};
	
	exports.default = FaPaintBrush;
	module.exports = exports['default'];

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaperPlaneO = function FaPaperPlaneO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.4 0.2q0.7 0.6 0.6 1.5l-5.7 34.3q-0.1 0.6-0.7 1-0.4 0.1-0.7 0.1-0.3 0-0.6-0.1l-11.7-4.8-6.7 7.3q-0.4 0.5-1 0.5-0.4 0-0.6-0.1-0.4-0.1-0.6-0.5t-0.3-0.8v-10.1l-10.5-4.3q-0.8-0.3-0.9-1.3-0.1-0.8 0.7-1.3l37.2-21.4q0.7-0.5 1.5 0z m-7.7 33.5l5-29.5-32 18.4 7.5 3.1 19.2-14.3-10.6 17.8z' })
	        )
	    );
	};
	
	exports.default = FaPaperPlaneO;
	module.exports = exports['default'];

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaperPlane = function FaPaperPlane(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.4 0.2q0.7 0.6 0.6 1.5l-5.7 34.3q-0.1 0.6-0.7 1-0.4 0.1-0.7 0.1-0.3 0-0.6-0.1l-10.1-4.1-5.4 6.6q-0.4 0.5-1.1 0.5-0.3 0-0.5-0.1-0.4-0.1-0.7-0.5t-0.2-0.8v-7.8l19.3-23.7-23.9 20.7-8.8-3.6q-0.8-0.3-0.9-1.3 0-0.8 0.7-1.3l37.2-21.4q0.3-0.2 0.7-0.2 0.4 0 0.8 0.2z' })
	        )
	    );
	};
	
	exports.default = FaPaperPlane;
	module.exports = exports['default'];

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaperclip = function FaPaperclip(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.8 30.9q0 2.6-1.7 4.4t-4.4 1.8q-3 0-5.2-2.3l-17.4-17.3q-2.5-2.6-2.5-6.1 0-3.5 2.4-6t6-2.5q3.6 0 6.1 2.6l13.5 13.5q0.3 0.2 0.3 0.5 0 0.3-0.7 1t-1.1 0.7q-0.2 0-0.5-0.2l-13.5-13.6q-1.8-1.7-4-1.7-2.4 0-4 1.7t-1.7 4q0 2.4 1.7 4.1l17.4 17.3q1.4 1.4 3.2 1.4 1.4 0 2.4-0.9t0.9-2.4q0-1.8-1.4-3.2l-13-13q-0.6-0.5-1.3-0.5-0.7 0-1.1 0.4t-0.4 1.1q0 0.7 0.6 1.3l9.1 9.1q0.2 0.3 0.2 0.5 0 0.4-0.7 1.1t-1 0.7q-0.3 0-0.5-0.3l-9.2-9.1q-1.4-1.4-1.4-3.3 0-1.9 1.3-3.1t3.1-1.3q2 0 3.3 1.4l13 13q2.2 2.2 2.2 5.2z' })
	        )
	    );
	};
	
	exports.default = FaPaperclip;
	module.exports = exports['default'];

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaParagraph = function FaParagraph(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34 4.2v1.6q0 0.7-0.4 1.4t-0.9 0.7q-1.2 0-1.2 0-0.6 0.2-0.8 0.7 0 0.3 0 1.5v25.7q0 0.5-0.4 0.9t-1 0.4h-2.4q-0.6 0-1-0.4t-0.4-0.9v-27.2h-3.1v27.2q0 0.5-0.4 0.9t-1 0.4h-2.4q-0.6 0-1-0.4t-0.4-0.9v-11.1q-3.3-0.3-5.5-1.3-2.8-1.3-4.2-4-1.5-2.6-1.5-5.8 0-3.7 2-6.4 2-2.6 4.7-3.5 2.4-0.8 9.3-0.8h10.7q0.5 0 0.9 0.4t0.4 0.9z' })
	        )
	    );
	};
	
	exports.default = FaParagraph;
	module.exports = exports['default'];

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPauseCircleO = function FaPauseCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m0 29.2q3.3 0 6.1-1.6t4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6z m2.2-5q-0.3 0-0.5-0.2t-0.2-0.5v-12.8q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v12.8q0 0.3-0.2 0.5t-0.5 0.2h-4.3z m-8.6 0q-0.3 0-0.5-0.2t-0.2-0.5v-12.8q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v12.8q0 0.3-0.2 0.5t-0.5 0.2h-4.3z' })
	        )
	    );
	};
	
	exports.default = FaPauseCircleO;
	module.exports = exports['default'];

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPauseCircle = function FaPauseCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.7 26.4v-12.8q0-0.3-0.2-0.5t-0.5-0.2h-5.7q-0.3 0-0.5 0.2t-0.2 0.5v12.8q0 0.3 0.2 0.5t0.5 0.2h5.7q0.3 0 0.5-0.2t0.2-0.5z m10 0v-12.8q0-0.3-0.2-0.5t-0.5-0.2h-5.7q-0.3 0-0.5 0.2t-0.2 0.5v12.8q0 0.3 0.2 0.5t0.5 0.2h5.7q0.3 0 0.5-0.2t0.2-0.5z m8.6-6.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaPauseCircle;
	module.exports = exports['default'];

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPause = function FaPause(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 4.3v31.4q0 0.6-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h11.5q0.5 0 1 0.4t0.4 1z m-20 0v31.4q0 0.6-0.4 1t-1 0.4h-11.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h11.5q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaPause;
	module.exports = exports['default'];

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaw = function FaPaw(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.9 10.5q0 1.4-0.4 2.6t-1.4 2-2.4 0.9q-1.7 0-3-1.3t-2.1-3-0.7-3.4q0-1.3 0.5-2.5t1.4-2.1 2.3-0.8q1.7 0 3.1 1.2t2 3.1 0.7 3.3z m-7.6 10.8q0 1.8-1 3.1t-2.6 1.3q-1.7 0-3.2-1.2t-2.2-3-0.8-3.4q0-1.8 0.9-3.1t2.7-1.3q1.7 0 3.2 1.2t2.2 3 0.8 3.4z m8.8-0.6q2.6 0 5.7 2.2t5.1 5.3 2 5.7q0 1-0.3 1.7t-1.1 1-1.5 0.4-1.7 0.1q-1.5 0-4.2-1t-4-1q-1.5 0-4.3 1t-4.5 1q-4.1 0-4.1-3.2 0-2 1.3-4.3t3.1-4.3 4.2-3.3 4.3-1.3z m5.3-4.7q-1.4 0-2.3-0.9t-1.4-2-0.5-2.6q0-1.6 0.7-3.3t2-3.1 3.1-1.2q1.4 0 2.4 0.8t1.4 2.1 0.4 2.5q0 1.7-0.7 3.4t-2 3-3.1 1.3z m9.7-2.3q1.7 0 2.6 1.3t0.9 3.1q0 1.7-0.7 3.4t-2.3 3-3.1 1.2q-1.8 0-2.7-1.3t-0.9-3.1q0-1.6 0.7-3.4t2.3-3 3.2-1.2z' })
	        )
	    );
	};
	
	exports.default = FaPaw;
	module.exports = exports['default'];

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPaypal = function FaPaypal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.9 14.4q0.4 1.9-0.1 4.6-1.9 9.9-12.6 9.9h-1q-0.5 0-1 0.4t-0.5 0.9l-0.1 0.4-1.2 7.7-0.1 0.4q-0.1 0.6-0.5 0.9t-1 0.4h-5.6q-0.5 0-0.7-0.3t-0.2-0.8q0.2-1.3 0.6-3.8t0.5-3.7 0.6-3.8 0.7-3.7q0.1-0.8 0.9-0.8h2.9q3 0 5.3-0.5 3.9-0.9 6.4-3.2 2.3-2.1 3.5-5.5 0.5-1.6 0.7-3 0.1-0.1 0.1-0.2t0.1 0 0.1 0.1q1.8 1.3 2.2 3.6z m-3.8-6.3q0 2.4-1.1 5.3-1.7 5.2-6.7 7-2.5 0.9-5.6 1 0 0-2 0l-2 0q-2.3 0-2.7 2.1 0 0.2-1.9 11.8 0 0.3-0.2 0.3h-6.6q-0.5 0-0.8-0.4t-0.3-0.9l5.2-32.8q0.1-0.6 0.6-1.1t1.1-0.4h13.4q0.8 0 2.2 0.3t2.5 0.7q2.3 0.9 3.6 2.8t1.3 4.3z' })
	        )
	    );
	};
	
	exports.default = FaPaypal;
	module.exports = exports['default'];

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPencilSquare = function FaPencilSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12 24.7l3.4 3.4-1.1 1.2h-1.3v-2.2h-2.1v-1.2z m9.3-8.7q0.3 0.3-0.1 0.7l-6.5 6.5q-0.4 0.4-0.7 0.1-0.3-0.3 0.1-0.7l6.5-6.5q0.4-0.4 0.7-0.1z m-6.2 15.4l12.2-12.1-6.4-6.4-12.2 12.1v6.4h6.4z m13.6-13.5l2.1-2.1q0.6-0.6 0.6-1.5t-0.6-1.5l-3.4-3.4q-0.6-0.7-1.5-0.7t-1.6 0.7l-2 2z m8.6-8.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaPencilSquare;
	module.exports = exports['default'];

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPencil = function FaPencil(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.1 34.3l2-2-5.2-5.3-2 2v2.4h2.8v2.9h2.4z m11.7-20.7q0-0.5-0.5-0.5-0.2 0-0.4 0.1l-12.1 12.1q-0.1 0.2-0.1 0.4 0 0.5 0.4 0.5 0.3 0 0.4-0.2l12.1-12.1q0.2-0.1 0.2-0.3z m-1.2-4.3l9.3 9.3-18.6 18.5h-9.3v-9.2z m15.2 2.1q0 1.2-0.8 2l-3.7 3.7-9.3-9.2 3.7-3.7q0.8-0.9 2-0.9 1.2 0 2 0.9l5.3 5.2q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaPencil;
	module.exports = exports['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPercent = function FaPercent(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 28.6q0-1.2-0.9-2t-2-0.9-2 0.9-0.8 2 0.8 2 2 0.8 2-0.8 0.9-2z m-17.2-17.2q0-1.1-0.8-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.8-2z m22.9 17.2q0 3.5-2.5 6t-6.1 2.5-6-2.5-2.6-6 2.6-6.1 6-2.5 6.1 2.5 2.5 6.1z m-2.2-24.3q0 0.4-0.2 0.8l-23.6 31.5q-0.4 0.5-1.2 0.5h-3.5q-0.6 0-1-0.4t-0.5-1q0-0.4 0.3-0.8l23.6-31.5q0.4-0.5 1.1-0.5h3.6q0.6 0 1 0.4t0.4 1z m-15 7.1q0 3.6-2.5 6.1t-6 2.5-6.1-2.5-2.5-6.1 2.5-6 6.1-2.5 6 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaPercent;
	module.exports = exports['default'];

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPhoneSquare = function FaPhoneSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 26.6q0-0.2-0.1-0.3 0-0.2-0.8-0.7t-2-1.1l-1.2-0.6q-0.1-0.1-0.4-0.3t-0.6-0.4-0.4-0.1q-0.4 0-1.1 0.7t-1.3 1.5-0.9 0.7q-0.2 0-0.4 0t-0.4-0.2-0.3-0.2-0.4-0.2q-2.2-1.2-3.8-2.8t-2.8-3.8q0-0.1-0.2-0.3t-0.2-0.4-0.1-0.3-0.1-0.4q0-0.3 0.4-0.8t1.1-0.8 1-0.9 0.4-0.8q0-0.2-0.1-0.5t-0.3-0.5-0.3-0.5q-0.1-0.1-0.4-0.6t-0.5-1-0.6-1.1-0.6-0.9-0.3-0.4-0.4 0q-1.1 0-2.2 0.5-1.1 0.4-1.8 2.1t-0.8 2.9q0 0.3 0.1 0.7t0.1 0.7 0.2 0.8 0.2 0.6 0.3 0.8 0.2 0.6q1.4 3.7 4.9 7.2t7.1 4.8q0.2 0.1 0.7 0.3t0.7 0.2 0.7 0.3 0.7 0.2 0.7 0.1 0.8 0q1.2 0 2.9-0.7t2.1-1.8q0.5-1.2 0.5-2.3z m5.7-17.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaPhoneSquare;
	module.exports = exports['default'];

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPhone = function FaPhone(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 27.7q0 0.6-0.2 1.6t-0.5 1.5q-0.4 1.1-2.7 2.3-2.1 1.2-4.1 1.2-0.6 0-1.2-0.1t-1.3-0.3-1.1-0.3-1.2-0.5-1.1-0.4q-2.2-0.7-3.9-1.8-2.8-1.8-5.9-4.8t-4.8-5.9q-1.1-1.7-1.9-3.9 0-0.2-0.4-1.1t-0.4-1.3-0.3-1-0.3-1.3-0.1-1.2q0-2 1.1-4.1 1.3-2.3 2.4-2.8 0.6-0.2 1.5-0.4t1.6-0.2q0.3 0 0.5 0 0.4 0.2 1.2 1.7 0.2 0.4 0.6 1.2t0.8 1.4 0.7 1.2q0.1 0.1 0.4 0.6t0.5 0.8 0.1 0.6q0 0.5-0.6 1.1t-1.4 1.3-1.4 1.1-0.6 1.1q0 0.2 0.1 0.5t0.2 0.4 0.3 0.6 0.3 0.4q1.7 3.1 3.8 5.2t5.3 3.9q0 0 0.4 0.3t0.6 0.3 0.4 0.2 0.5 0.1q0.4 0 1-0.6t1.2-1.4 1.3-1.4 1.1-0.6q0.3 0 0.6 0.1t0.8 0.5 0.6 0.4q0.5 0.3 1.1 0.7t1.5 0.8 1.2 0.6q1.5 0.8 1.7 1.2 0 0.2 0 0.5z' })
	        )
	    );
	};
	
	exports.default = FaPhone;
	module.exports = exports['default'];

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPieChart = function FaPieChart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.6 19.9l12.2 12.2q-2.3 2.4-5.5 3.7t-6.7 1.3q-4.6 0-8.6-2.3t-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3v17z m4.2 0.1h17.3q0 3.5-1.4 6.7t-3.7 5.5z m15.8-2.9h-17.1v-17.1q4.7 0 8.6 2.3t6.2 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaPieChart;
	module.exports = exports['default'];

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPiedPiperAlt = function FaPiedPiperAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.2 20.7q1.5-0.1 2.9 0.4t2.3 1.1 2 1.9 1.7 2.1 1.5 2.4q0.7 1.1 1.6 2.2t1.5 1.6 1.9 1.7q-0.9 0.6-2.1 1.2t-2.8 1.2-2.2 0.9q-0.9-0.7-1.5-2.3t-0.9-3.2-0.6-3.6-0.9-3.4-1.4-2.4-2.4-1l-0.2 0.1-0.2 0q0.1 0.1 0.3 0.3 0.1 0.1 0.6 0.5t0.5 0.4 0.3 0.4 0.4 0.4 0.2 0.4 0.2 0.6 0.1 0.6 0.1 0.8l0 0.6q0 0.5 0 1.2t-0.2 1-0.2 1.2-0.3 1q-0.6 0-2 0.2t-1.9 0.2q-0.8 0-1.4-0.2-0.1-0.3-0.1-0.9 0-1.5 0.1-1.9 0-0.3 0.6-0.8t1.1-1.2 0.6-1q-0.5-0.1-0.9 0.4-0.7 1.1-2.2 2t-2.7 0.9q-0.5 0-1.5-1.2t-2.1-2.8-1.7-1.9q-0.1-0.1-0.5-0.6-9.6 2.2-10.2 2.2-0.3 0-0.6-0.2t-0.2-0.5q0-0.3 0.2-0.6t0.4-0.2l9.7-2.1q-0.2-0.3-0.2-0.5t0.1-0.4 0.3-0.2 0.4-0.2 0.5 0 0.4-0.1q0-0.1 0.3-0.2t0.3-0.1q0.3 0 0.6 0.3t0.4 0.7q3.2-0.8 3.4-0.8 0.3 0 0.6 0.2t0.2 0.6q0 0.3-0.2 0.5t-0.4 0.3l-3.6 0.8-0.1 0.3q0 0.5 1.7 2.3t2 1.9q1 0 2.4-1.6t1.4-2.6q0-0.7-0.4-1t-1.1-0.4-1-0.2-0.4-0.7q0-0.3 0.2-0.7l-1.4-0.4q0.9-0.8 0.9-2.3 0-0.5-0.1-1.1 1.6-0.4 2.8-0.4 0.9 0 1.4 0.1t1 0.1 0.6 0.3 0.4 0.5 0.3 0.7 0.4 0.9 0.4 1.2l1-0.5q0 0.8-0.4 1.2t-0.9 0.4-0.8 0.1-0.3 0.4z m1.2-4.7q-0.1-0.1-0.2-0.3t-0.3-0.3-0.2-0.2-0.2-0.2l-0.1-0.2-0.2-0.1-0.2-0.1-0.1-0.1q-0.2-0.1-0.3-0.1t-0.4-0.1-0.5 0h-1.4q-2.5 0-4.3 0.9 0.4-0.6 0.8-1t1-0.5 1.3-0.8 0.9-0.7 1-1.1 0.9-1q0.2 0.2 0.6 0.6t0.6 0.8 0.7 0.2l0.3 0v1.5l0.4 0q4.9-1.8 7.4-3.7 0.5-0.5 1-0.8t0.8-0.8 0.7-0.6 0.6-0.6 0.4-0.7 0.5-0.7 0.5-0.7 0.5-1 0.6-1l0.1-0.2q0 1-0.8 2.7-1.6 3.3-4.1 5.3t-6.1 2.8q-0.2 0.1-0.8 0.1t-1 0.2-0.8 0.3q0.1 0.4 0.5 0.9t0.5 0.7q0 0.2-0.6 0.6z m-4.3 18.3q0.7-0.5 2.6-1t2.9-0.4q0.1 0 0.4 0.3t0.6 0.8 0.5 1 0.5 1.1 0.2 0.6q-2.4 0.9-4.8 0.9-1.2 0-2.5-0.2z m-4.8-12.9l1-0.2 2.1 3.5-1.4 1z m9.9 10.3q0.1 0.3 0.1 0.3 0 0.1-0.3 0.3t-1 0.3-1 0.1-1.1 0.2-0.6 0.1l-0.2-0.9q0.5 0 1.2-0.1t1.5-0.2 1.2-0.1h0.3z m-9-12.5l-1.9 0.4-0.1-0.3q0.2 0 0.6-0.2t0.7-0.1q0.4 0 0.7 0.2z m3.9 12.6h0.6l0.2 1.7-0.8 0.2v-1.9z m17.6-29.6z m0 0l0 0.1-0.1 0.1 0.1-0.1z m0 0l0 0z' })
	        )
	    );
	};
	
	exports.default = FaPiedPiperAlt;
	module.exports = exports['default'];

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPiedPiper = function FaPiedPiper(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.3 22.8q0 1.4-0.8 2.4t-2 1q-1 0-1.6-0.3v-6.2q0.6-0.4 1.6-0.4 1.2 0 2 1t0.8 2.5z m-7.6-9.6q0 1.4-0.9 2.5t-2 1q-0.9 0-1.5-0.4v-6.1q0.6-0.4 1.5-0.4 1.2 0 2 1t0.9 2.4z m12.5 9.6q0-3-1.9-5.1t-4.8-2.1q-0.4 0-0.9 0.1-0.5 1.7-1.7 3-1.9 2.1-4.7 2.3v14.2l4.7-1v-4.6q1.1 0.5 2.6 0.5 2.8 0 4.8-2.2t1.9-5.1z m-7.6-9.5q0-3-2-5.1t-4.8-2.1q-1.6 0-3.1 0.8h-4.2v18.7l4.8-0.9v-4.6q1.2 0.4 2.5 0.4 2.8 0 4.8-2.1t2-5.1z m13.7-4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaPiedPiper;
	module.exports = exports['default'];

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterestP = function FaPinterestP(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.5 13.3q0-2.4 0.8-4.5t2.3-3.7 3.4-2.8 4.2-1.7 4.5-0.6q3.5 0 6.5 1.5t5 4.3 1.9 6.4q0 2.2-0.5 4.2t-1.3 4-2.2 3.3-3.3 2.3-4.2 0.9q-1.5 0-3-0.8t-2.1-1.9q-0.3 0.8-0.7 2.5t-0.5 2.1-0.4 1.6-0.6 1.6-0.7 1.4-1.1 1.7-1.4 1.9l-0.3 0.1-0.2-0.2q-0.3-3.5-0.3-4.2 0-2 0.5-4.6t1.5-6.4 1.1-4.5q-0.7-1.5-0.7-3.8 0-1.9 1.2-3.5t2.9-1.6q1.4 0 2.1 0.9t0.8 2.3q0 1.5-1 4.2t-1 4.2q0 1.4 1 2.3t2.5 1q1.2 0 2.3-0.6t1.7-1.5 1.3-2.1 0.8-2.5 0.4-2.5 0.2-2.2q0-3.9-2.5-6t-6.3-2.2q-4.5 0-7.5 2.9t-3 7.4q0 0.9 0.3 1.9t0.6 1.4 0.6 1 0.3 0.7q0 0.6-0.3 1.6t-0.9 1q0 0-0.3 0-1.2-0.4-2.1-1.3t-1.3-2.1-0.8-2.4-0.2-2.4z' })
	        )
	    );
	};
	
	exports.default = FaPinterestP;
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterestSquare = function FaPinterestSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.9 2.9q2.6 0 4.5 1.8t1.9 4.6v21.4q0 2.7-1.9 4.6t-4.5 1.8h-16.2q1.9-2.7 2.4-4.6 0.2-0.8 1.2-4.7 0.4 0.9 1.6 1.5t2.5 0.6q4.1 0 6.6-3.3t2.6-8.3q0-1.9-0.8-3.6t-2.2-3.1-3.4-2.2-4.4-0.8q-2.3 0-4.3 0.6t-3.4 1.7-2.4 2.5-1.5 2.8-0.5 3q0 2.3 0.9 4t2.6 2.4q0.3 0.2 0.5 0t0.3-0.4q0.3-1 0.4-1.3 0.1-0.5-0.3-1-1.1-1.4-1.1-3.3 0-3.4 2.3-5.8t6.1-2.3q3.3 0 5.2 1.8t1.8 4.7q0 3.7-1.5 6.4t-3.9 2.6q-1.3 0-2.1-1t-0.5-2.3q0.1-0.8 0.6-2.1t0.6-2.2 0.3-1.7q0-1.1-0.6-1.8t-1.7-0.7q-1.4 0-2.3 1.2t-1 3.1q0 1.6 0.6 2.7l-2.2 9.3q-0.6 2.2-0.2 5.6h-4.1q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5z' })
	        )
	    );
	};
	
	exports.default = FaPinterestSquare;
	module.exports = exports['default'];

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPinterest = function FaPinterest(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 20q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3q-2.4 0-4.8-0.7 1.3-2 1.7-3.6 0.2-0.8 1.2-4.7 0.5 0.8 1.7 1.5t2.5 0.6q2.7 0 4.8-1.5t3.3-4.2 1.2-6.1q0-2.5-1.4-4.7t-3.8-3.7-5.7-1.4q-2.4 0-4.4 0.7t-3.4 1.7-2.5 2.4-1.5 2.9-0.4 3q0 2.4 0.8 4.1t2.7 2.5q0.6 0.3 0.8-0.5 0.1-0.1 0.2-0.6t0.2-0.7q0.1-0.5-0.3-1-1.1-1.3-1.1-3.3 0-3.4 2.3-5.8t6.1-2.5q3.4 0 5.3 1.9t1.9 4.7q0 3.8-1.6 6.5t-3.9 2.6q-1.3 0-2.2-0.9t-0.5-2.4q0.2-0.8 0.6-2.1t0.7-2.3 0.2-1.6q0-1.2-0.6-1.9t-1.7-0.7q-1.4 0-2.3 1.2t-1 3.2q0 1.6 0.6 2.7l-2.2 9.4q-0.4 1.5-0.3 3.9-4.6-2-7.5-6.3t-2.8-9.4q0-4.7 2.3-8.6t6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaPinterest;
	module.exports = exports['default'];

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlane = function FaPlane(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.7 3.6q1 1.1 0.3 3.3t-2.4 3.8l-3.6 3.6 3.5 15.5q0.2 0.5-0.2 0.8l-2.9 2.1q-0.1 0.2-0.4 0.2-0.1 0-0.2-0.1-0.3 0-0.4-0.3l-6.3-11.4-5.7 5.8 1.1 4.4q0.2 0.3-0.1 0.6l-2.2 2.2q-0.2 0.2-0.5 0.2h0q-0.4-0.1-0.6-0.3l-4.2-5.6-5.6-4.2q-0.3-0.2-0.3-0.6 0-0.2 0.2-0.5l2.1-2.2q0.2-0.2 0.6-0.2 0.1 0 0.1 0l4.4 1.2 5.7-5.8-11.3-6.2q-0.3-0.2-0.4-0.5 0-0.4 0.2-0.6l2.9-2.9q0.3-0.3 0.7-0.2l14.8 3.6 3.6-3.6q1.7-1.7 3.8-2.4t3.3 0.3z' })
	        )
	    );
	};
	
	exports.default = FaPlane;
	module.exports = exports['default'];

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlayCircleO = function FaPlayCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 20q0 0.8-0.7 1.2l-12.1 7.2q-0.4 0.2-0.7 0.2-0.4 0-0.8-0.2-0.7-0.4-0.7-1.3v-14.2q0-0.9 0.7-1.3 0.8-0.4 1.5 0l12.1 7.2q0.7 0.4 0.7 1.2z m2.9 0q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaPlayCircleO;
	module.exports = exports['default'];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlayCircle = function FaPlayCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m8.6 18.3q0.7-0.4 0.7-1.2t-0.7-1.2l-12.1-7.2q-0.7-0.4-1.5 0-0.7 0.4-0.7 1.3v14.2q0 0.9 0.7 1.3 0.4 0.2 0.8 0.2 0.3 0 0.7-0.2z' })
	        )
	    );
	};
	
	exports.default = FaPlayCircle;
	module.exports = exports['default'];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlay = function FaPlay(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.4 20.7l-29.6 16.5q-0.6 0.3-0.9 0t-0.4-0.8v-32.8q0-0.6 0.4-0.8t0.9 0l29.6 16.5q0.5 0.3 0.5 0.7t-0.5 0.7z' })
	        )
	    );
	};
	
	exports.default = FaPlay;
	module.exports = exports['default'];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlug = function FaPlug(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.2 10.1q0.8 0.8 0.8 2t-0.8 2.1l-9 8.9 3.4 3.3-3.6 3.6q-3.6 3.6-8.7 4.2t-9.2-2.3l-8.1 8.1h-4v-4l8.1-8.1q-2.8-4.1-2.3-9.2t4.2-8.7l3.6-3.6 3.3 3.4 8.9-9q0.9-0.8 2.1-0.8t2 0.8 0.8 2-0.8 2.1l-8.9 8.9 5.2 5.2 8.9-8.9q0.9-0.8 2.1-0.8t2 0.8z' })
	        )
	    );
	};
	
	exports.default = FaPlug;
	module.exports = exports['default'];

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlusCircle = function FaPlusCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaPlusCircle;
	module.exports = exports['default'];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlusSquareO = function FaPlusSquareO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.2 17.9v1.4q0 0.3-0.2 0.5t-0.5 0.2h-7.9v7.9q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-7.9h-7.9q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.4 0.2-0.6t0.5-0.2h7.9v-7.8q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5v7.8h7.9q0.3 0 0.5 0.2t0.2 0.6z m2.9 10v-18.6q0-1.5-1.1-2.5t-2.5-1.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5z m2.8-18.6v18.6q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q2.7 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaPlusSquareO;
	module.exports = exports['default'];

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlusSquare = function FaPlusSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 21.4v-2.8q0-0.6-0.5-1t-1-0.5h-7.1v-7.1q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v7.1h-7.2q-0.5 0-1 0.5t-0.4 1v2.8q0 0.6 0.4 1t1 0.5h7.2v7.1q0 0.6 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-7.1h7.1q0.6 0 1-0.5t0.5-1z m5.7-12.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaPlusSquare;
	module.exports = exports['default'];

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPlus = function FaPlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 16.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-9.3v9.2q0 0.9-0.6 1.6t-1.5 0.6h-4.3q-0.9 0-1.5-0.6t-0.7-1.6v-9.2h-9.3q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h9.3v-9.3q0-0.9 0.7-1.5t1.5-0.6h4.3q0.9 0 1.5 0.6t0.6 1.5v9.3h9.3q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaPlus;
	module.exports = exports['default'];

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPowerOff = function FaPowerOff(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 20q0 3.5-1.4 6.7t-3.6 5.4-5.5 3.7-6.7 1.3-6.6-1.3-5.5-3.7-3.6-5.4-1.4-6.7q0-4.1 1.8-7.7t5-6q1-0.7 2.2-0.5t1.8 1.1q0.8 0.9 0.6 2.1t-1.1 1.9q-2.2 1.6-3.4 4t-1.2 5.1q0 2.3 0.9 4.4t2.5 3.7 3.6 2.4 4.4 0.9 4.5-0.9 3.6-2.4 2.5-3.7 0.9-4.4q0-2.7-1.2-5.1t-3.4-4q-0.9-0.7-1.1-1.9t0.5-2.1q0.7-1 1.9-1.1t2.1 0.5q3.3 2.4 5.1 6t1.8 7.7z m-14.3-17.1v14.2q0 1.2-0.8 2.1t-2.1 0.8-2-0.8-0.8-2.1v-14.2q0-1.2 0.8-2.1t2-0.8 2.1 0.8 0.8 2.1z' })
	        )
	    );
	};
	
	exports.default = FaPowerOff;
	module.exports = exports['default'];

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPrint = function FaPrint(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.1 34.3h20v-5.7h-20v5.7z m0-14.3h20v-8.6h-3.6q-0.9 0-1.5-0.6t-0.6-1.5v-3.6h-14.3v14.3z m25.7 1.4q0-0.5-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.5 1-0.5 0.4-1z m2.8 0v9.3q0 0.3-0.2 0.5t-0.5 0.2h-5v3.6q0 0.9-0.6 1.5t-1.5 0.6h-21.4q-0.9 0-1.6-0.6t-0.6-1.5v-3.6h-5q-0.3 0-0.5-0.2t-0.2-0.5v-9.3q0-1.7 1.3-3t3-1.3h1.4v-12.1q0-0.9 0.6-1.5t1.6-0.6h15q0.9 0 1.9 0.4t1.7 1.1l3.4 3.4q0.6 0.6 1.1 1.7t0.4 1.9v5.7h1.5q1.7 0 3 1.3t1.2 3z' })
	        )
	    );
	};
	
	exports.default = FaPrint;
	module.exports = exports['default'];

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaProductHunt = function FaProductHunt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.7 17q0 1.3-0.9 2.1t-2.1 0.9h-5.7v-6h5.7q1.2 0 2.1 0.9t0.9 2.1z m4 0q0-2.9-2.1-4.9t-4.9-2.1h-9.7v20h4v-6h5.7q2.9 0 4.9-2t2.1-5z m10.3 3q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaProductHunt;
	module.exports = exports['default'];

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaPuzzlePiece = function FaPuzzlePiece(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 24.5q0 1.8-1 3t-2.7 1.2q-0.9 0-1.7-0.4t-1.4-0.8-1.2-0.9-1.6-0.3q-2.5 0-2.5 2.7 0 0.9 0.4 2.6t0.3 2.6v0.1q-0.5 0-0.7 0-0.8 0.1-2.2 0.2t-2.6 0.3-2.1 0.2q-1.4 0-2.3-0.6t-1-1.9q0-0.8 0.4-1.6t0.9-1.2 0.8-1.4 0.4-1.7q0-1.8-1.2-2.8t-3-0.9q-1.9 0-3.2 1t-1.3 2.8q0 1 0.3 1.9t0.8 1.4 0.7 1.2 0.3 1.1q0 1-1 2-0.8 0.8-2.6 0.8-2.1 0-5.5-0.5-0.2-0.1-0.6-0.1t-0.6-0.1l-0.3-0.1q0 0-0.1 0 0 0 0 0v-22.9q0 0 0.4 0.1t0.7 0.1 0.5 0.1q3.4 0.5 5.5 0.5 1.8 0 2.6-0.7 1-1 1-2 0-0.5-0.3-1.2t-0.7-1.1-0.8-1.5-0.3-1.8q0-1.9 1.3-2.9t3.2-1q1.8 0 3 1t1.2 2.8q0 0.9-0.4 1.7t-0.8 1.3-0.9 1.3-0.4 1.5q0 1.3 1 1.9t2.3 0.6q1.4 0 4-0.3t3.6-0.4v0q0 0.1-0.1 0.4t-0.1 0.8-0.1 0.5q-0.5 3.3-0.5 5.4 0 1.8 0.8 2.6 1 1.1 2 1.1 0.5 0 1.1-0.4t1.2-0.7 1.4-0.8 1.9-0.3q1.8 0 2.8 1.3t1 3.2z' })
	        )
	    );
	};
	
	exports.default = FaPuzzlePiece;
	module.exports = exports['default'];

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQq = function FaQq(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm6 18q-0.2-0.4-0.2-1.2 0-0.4 0.3-1.1t0.5-1q0-0.5 0.2-1.2t0.5-0.9q0-3.1 2.1-6.5t4.8-4.6q3.1-1.5 7.2-1.5 3 0 6 1.2 1.1 0.5 2 1.1t1.6 1.2 1.2 1.6 1 1.6 0.7 1.9 0.5 2 0.5 2.2l0.1 0.1q1.2 1.9 1.2 3.4 0 0.3-0.2 0.8t-0.2 0.9q0 0 0 0.1t0.1 0.1 0 0.1q1.8 2.5 2.7 4.7t1 4.7q0 1-0.4 2.2t-1.3 1.3q-0.2 0-0.4-0.2t-0.4-0.4-0.5-0.5-0.3-0.6-0.3-0.6-0.2-0.4q0 0-0.1 0l-0.1 0.1q-1.3 3.4-2.9 5 0.4 0.4 1.3 0.8t1.6 0.9 0.8 1.5q-0.1 0.1-0.1 0.3t-0.2 0.4q-1.4 2.2-6.7 2.2-1.2 0-2.5-0.2t-2.2-0.4-2.3-0.7q-0.3-0.1-0.5-0.2-0.3-0.1-1.1-0.1t-0.8 0q-1 1-2.9 1.5t-3.8 0.4q-0.7 0-1.5 0t-2.1-0.2-2.2-0.5-1.7-0.9-0.7-1.4q0-0.9 0.2-1.3t0.9-1.1q0.3-0.1 0.9-0.3t1.1-0.3q0.1 0 0.4 0 0-0.1 0-0.1l0-0.1q-1.1-0.2-2.5-2.3t-1.6-3.5l-0.1-0.1q-0.1 0-0.3 0.4-0.4 1-1.2 1.7t-1.7 0.8h0q-0.1 0-0.2-0.1t-0.1-0.1q-0.5-1.2-0.5-2.2 0-6.1 5.6-10.4z' })
	        )
	    );
	};
	
	exports.default = FaQq;
	module.exports = exports['default'];

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQrcode = function FaQrcode(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 25.7v2.9h-2.9v-2.9h2.9z m0-17.1v2.8h-2.9v-2.8h2.9z m17.1 0v2.8h-2.8v-2.8h2.8z m-22.8 22.8h8.5v-8.5h-8.5v8.5z m0-17.1h8.5v-8.6h-8.5v8.6z m17.1 0h8.6v-8.6h-8.6v8.6z m-5.7 5.7v14.3h-14.3v-14.3h14.3z m11.4 11.4v2.9h-2.8v-2.9h2.8z m5.7 0v2.9h-2.8v-2.9h2.8z m0-11.4v8.6h-8.5v-2.9h-2.9v8.6h-2.9v-14.3h8.6v2.9h2.9v-2.9h2.8z m-17.1-17.1v14.2h-14.3v-14.2h14.3z m17.1 0v14.2h-14.3v-14.2h14.3z' })
	        )
	    );
	};
	
	exports.default = FaQrcode;
	module.exports = exports['default'];

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQuestionCircleO = function FaQuestionCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.6 26.8v3.6q0 0.3-0.2 0.5t-0.5 0.2h-3.5q-0.4 0-0.6-0.2t-0.2-0.5v-3.6q0-0.3 0.2-0.5t0.6-0.2h3.5q0.3 0 0.5 0.2t0.2 0.5z m5.8-11.1q0 1.1-0.4 2t-1 1.6-1.2 0.9-1.3 0.8q-0.7 0.4-1 0.7t-0.6 0.5-0.3 0.7v0.7q0 0.3-0.2 0.5t-0.5 0.2h-3.5q-0.4 0-0.6-0.2t-0.2-0.5v-1.5q0-0.8 0.3-1.5t0.5-1 0.9-0.8 0.9-0.6 1-0.5q1.2-0.5 1.7-0.9t0.5-1.1q0-1-1-1.6t-2.1-0.7q-1.3 0-2.2 0.6-0.6 0.5-1.8 1.9-0.2 0.2-0.5 0.2-0.3 0-0.4-0.1l-2.4-1.8q-0.3-0.2-0.3-0.5t0.1-0.5q2.7-4.3 7.8-4.3 2.9 0 5.3 2t2.5 4.8z m-8.3-10q-2.9 0-5.5 1.2t-4.6 3-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5-1.1-5.5-3.1-4.6-4.5-3.1-5.6-1.1z m17.2 14.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaQuestionCircleO;
	module.exports = exports['default'];

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQuestionCircle = function FaQuestionCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 30.7v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-4.3q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5z m5.7-15q0-2-1.2-3.6t-3.1-2.6-3.8-0.9q-5.4 0-8.3 4.7-0.3 0.6 0.2 1l2.9 2.2q0.2 0.1 0.5 0.1 0.3 0 0.5-0.2 1.2-1.6 1.9-2.1 0.8-0.5 2-0.5 1 0 1.9 0.6t0.8 1.3q0 0.8-0.4 1.3t-1.6 1q-1.4 0.7-2.5 2t-1.2 2.8v0.8q0 0.3 0.2 0.5t0.5 0.2h4.3q0.3 0 0.5-0.2t0.2-0.5q0-0.5 0.5-1.1t1.2-1.1q0.7-0.4 1.1-0.7t1-0.8 1-1 0.6-1.4 0.3-1.8z m8.6 4.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaQuestionCircle;
	module.exports = exports['default'];

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQuestion = function FaQuestion(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.2 28v5.4q0 0.4-0.3 0.6t-0.6 0.3h-5.3q-0.4 0-0.7-0.3t-0.2-0.6v-5.4q0-0.3 0.2-0.6t0.7-0.3h5.3q0.4 0 0.6 0.3t0.3 0.6z m7.1-13.4q0 1.2-0.4 2.3t-0.8 1.7-1.2 1.3-1.3 1-1.3 0.8q-0.9 0.5-1.6 1.4t-0.6 1.5q0 0.4-0.2 0.8t-0.7 0.3h-5.3q-0.4 0-0.6-0.4t-0.2-0.8v-1q0-1.9 1.4-3.5t3.2-2.5q1.3-0.6 1.9-1.2t0.5-1.7q0-0.9-1-1.7t-2.4-0.7q-1.4 0-2.4 0.7-0.8 0.5-2.4 2.5-0.3 0.4-0.7 0.4-0.2 0-0.5-0.2l-3.7-2.8q-0.3-0.2-0.3-0.5t0.1-0.6q3.5-6 10.3-6 1.8 0 3.6 0.7t3.3 1.9 2.4 2.8 0.9 3.5z' })
	        )
	    );
	};
	
	exports.default = FaQuestion;
	module.exports = exports['default'];

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQuoteLeft = function FaQuoteLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 21.4v8.6q0 1.8-1.2 3t-3 1.3h-8.6q-1.8 0-3-1.3t-1.3-3v-15.7q0-2.3 0.9-4.4t2.4-3.7 3.7-2.4 4.4-0.9h1.5q0.5 0 1 0.4t0.4 1v2.8q0 0.6-0.4 1t-1 0.5h-1.5q-2.3 0-4 1.6t-1.7 4.1v0.7q0 0.9 0.6 1.5t1.6 0.6h5q1.7 0 3 1.3t1.2 3z m20 0v8.6q0 1.8-1.2 3t-3 1.3h-8.6q-1.8 0-3-1.3t-1.3-3v-15.7q0-2.3 0.9-4.4t2.4-3.7 3.7-2.4 4.4-0.9h1.5q0.5 0 1 0.4t0.4 1v2.8q0 0.6-0.4 1t-1 0.5h-1.5q-2.3 0-4 1.6t-1.7 4.1v0.7q0 0.9 0.6 1.5t1.6 0.6h5q1.7 0 3 1.3t1.2 3z' })
	        )
	    );
	};
	
	exports.default = FaQuoteLeft;
	module.exports = exports['default'];

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaQuoteRight = function FaQuoteRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 7.1v15.8q0 2.3-0.9 4.4t-2.4 3.6-3.7 2.5-4.4 0.9h-1.4q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h1.4q2.4 0 4.1-1.7t1.6-4v-0.8q0-0.8-0.6-1.5t-1.5-0.6h-5q-1.8 0-3.1-1.2t-1.2-3.1v-8.6q0-1.7 1.3-3t3-1.2h8.6q1.7 0 3 1.2t1.2 3z m20 0v15.8q0 2.3-0.9 4.4t-2.4 3.6-3.7 2.5-4.4 0.9h-1.4q-0.6 0-1-0.4t-0.4-1v-2.9q0-0.6 0.4-1t1-0.4h1.4q2.4 0 4.1-1.7t1.6-4v-0.8q0-0.8-0.6-1.5t-1.5-0.6h-5q-1.8 0-3.1-1.2t-1.2-3.1v-8.6q0-1.7 1.3-3t3-1.2h8.6q1.7 0 3 1.2t1.2 3z' })
	        )
	    );
	};
	
	exports.default = FaQuoteRight;
	module.exports = exports['default'];

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRa = function FaRa(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm0.4 19.5q0.2-4.8 2.6-9.1t6.8-7.1h0.1q0 0.1 0 0.1-0.2 0.2-0.6 0.8t-1.2 1.7-1.3 2.4-1 3.1-0.3 3.3 0.8 3.5 2.5 3.5q1.1 1.1 2.2 1.5t2.1 0.3 1.5-0.5 1.1-0.8l0.3-0.3q0.9-1.2 1.2-2.6t0.2-2.8-0.5-2.3-0.6-1.8l-0.3-0.7q-0.2-0.5-0.7-1.1t-1-0.9-0.9-0.7-0.8-0.4l-0.3-0.1 2.3-2.6q0.9 0.4 1.8 1.2t1.3 1.3l0.4 0.6q0-1-0.4-2.3t-0.9-1.9l-0.5-0.7 3.6-4.1 3.6 4q-0.7 1.1-1.2 2.3t-0.5 2.1l-0.1 0.7q0.5-0.8 1.4-1.6t1.5-1.2l0.6-0.4 2.3 2.6q-0.9 0.3-1.9 1.1t-1.3 1.5l-0.4 0.6q-0.7 1.3-1.1 3t-0.1 3.8 1.2 3.5q0.8 1 1.8 1.3t1.9 0.1 1.7-0.5 1.2-0.8l0.5-0.4q1.3-1.1 2.2-2.5t1-2.7 0.3-2.7-0.4-2.7-0.9-2.4-1-2.1-1-1.6-0.8-1l-0.2-0.4q-0.4-0.3-0.2-0.3l0.2 0.1q0.9 0.6 1.4 1t1.4 1.1 1.4 1.3 1.3 1.5 1.3 1.7 1 1.9 0.8 2.3 0.6 2.7 0.2 3q0.1 5.8-2.4 10.4t-7 7.1-10.2 2.6q-4.1 0-7.8-1.6t-6.3-4.5-4.1-6.5-1.4-7.9z' })
	        )
	    );
	};
	
	exports.default = FaRa;
	module.exports = exports['default'];

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRandom = function FaRandom(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.9 10.7q-1.4 2.1-3.1 6.1-0.5-1-0.8-1.6t-0.9-1.4-1.2-1.3-1.4-0.7-1.8-0.4h-5q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h5q5.6 0 9.2 5z m25.1 17.9q0 0.3-0.2 0.5l-7.1 7.1q-0.2 0.2-0.6 0.2-0.2 0-0.5-0.2t-0.2-0.5v-4.3q-0.7 0-1.9 0t-1.8 0.1-1.6-0.1-1.6-0.1-1.4-0.2-1.4-0.4-1.3-0.7-1.3-0.8-1.3-1.2-1.2-1.6q1.3-2.1 3-6.1 0.5 1 0.8 1.6t1 1.4 1.1 1.3 1.4 0.8 1.8 0.3h5.7v-4.3q0-0.3 0.2-0.5t0.5-0.2q0.3 0 0.6 0.2l7.1 7.2q0.2 0.2 0.2 0.5z m0-20q0 0.3-0.2 0.5l-7.1 7.1q-0.2 0.2-0.6 0.2-0.2 0-0.5-0.2t-0.2-0.5v-4.3h-5.7q-1.1 0-1.9 0.4t-1.6 1-1.1 1.3-1 1.8q-0.7 1.4-1.7 3.8-0.7 1.5-1.2 2.5t-1.2 2.3-1.4 2.2-1.6 1.9-2.1 1.5-2.3 1-2.9 0.3h-5q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h5q1.1 0 2-0.3t1.5-1 1.1-1.4 1-1.7q0.8-1.4 1.8-3.8 0.6-1.5 1.1-2.5t1.2-2.4 1.4-2.2 1.7-1.9 2-1.5 2.4-0.9 2.8-0.4h5.7v-4.3q0-0.3 0.2-0.5t0.5-0.2q0.3 0 0.6 0.2l7.1 7.2q0.2 0.2 0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaRandom;
	module.exports = exports['default'];

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRecycle = function FaRecycle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.7 26.1l-0.4 8.2 0 0.5-9.4-0.6q-0.8-0.1-1.5-0.8t-1-1.4q-0.3-0.6-0.4-1.2t0.1-1.5 0.3-1.2 0.5-1.5 0.4-1.1q1.7 0.2 11.4 0.6z m-8.7-13.1l4 8.5-3.2-2.1q-1.4 1.6-2.5 3.2t-1.6 2.8-0.9 2.1-0.4 1.4l-0.1 0.5-4.3-8q-0.4-0.5-0.4-1.2t0.2-1.1l0.1-0.4q0.8-1.4 2.6-4.1l-3.1-2z m27.5 11.6l-4.2 8q-0.3 0.6-0.8 1t-1 0.5l-0.4 0.1q-1.6 0.1-4.9 0.2l0.2 3.7-5.1-8.2 4.7-8.1 0.1 3.9q3.8 0.3 6.4 0.1t3.7-0.8z m-17.5-20.7q-1.1 1.4-5.9 9.7l-7.1-4.1-0.4-0.3 5-7.9q0.4-0.7 1.3-1.1t1.8-0.2q0.5 0.1 1.1 0.3t0.9 0.5 1 0.7 0.8 0.8 0.8 0.8 0.7 0.8z m14.6 6.9l4.7 8.1q0.4 0.8 0.3 1.7t-0.6 1.6q-0.3 0.5-0.7 0.9t-0.9 0.6-1.1 0.5-1 0.3-1.2 0.3-1 0.3q-0.8-1.6-5.9-9.7l7-4.4z m-3.2-5.1l3.2-1.8-4.9 8.3-9.4-0.4 3.4-2q-0.8-1.9-1.7-3.7t-1.7-2.7-1.4-1.8-1.1-1l-0.3-0.3 9 0q0.7-0.1 1.3 0.2t0.9 0.7l0.2 0.3q0.9 1.4 2.5 4.2z' })
	        )
	    );
	};
	
	exports.default = FaRecycle;
	module.exports = exports['default'];

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRedditAlien = function FaRedditAlien(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 18.9q0 1.3-0.7 2.3t-1.7 1.7q0.2 1 0.2 2.1 0 3.5-2.3 6.4t-6.5 4.7-9 1.7-8.9-1.7-6.4-4.7-2.4-6.4q0-1.1 0.2-2.1-1.1-0.6-1.8-1.6t-0.7-2.4q0-1.8 1.3-3.2t3.1-1.3q1.9 0 3.3 1.4 4.8-3.3 11.5-3.6l2.6-11.6q0-0.3 0.3-0.5t0.6-0.1l8.2 1.8q0.4-0.8 1.2-1.3t1.8-0.5q1.4 0 2.4 1t0.9 2.3-0.9 2.4-2.4 1-2.4-1-0.9-2.4l-7.5-1.6-2.3 10.5q6.7 0.2 11.6 3.6 1.3-1.4 3.2-1.4 1.8 0 3.1 1.3t1.3 3.2z m-30.7 4.4q0 1.4 1 2.4t2.4 1 2.3-1 1-2.4-1-2.3-2.3-1q-1.4 0-2.4 1t-1 2.3z m18.1 8q0.3-0.3 0.3-0.6t-0.3-0.6q-0.2-0.2-0.5-0.2t-0.6 0.2q-0.9 0.9-2.7 1.4t-3.6 0.4-3.6-0.4-2.7-1.4q-0.2-0.2-0.5-0.2t-0.6 0.2q-0.3 0.2-0.3 0.6t0.3 0.6q1 0.9 2.6 1.5t2.8 0.6 2 0.1 2-0.1 2.8-0.6 2.6-1.6z m-0.1-4.6q1.4 0 2.4-1t1-2.4q0-1.3-1-2.3t-2.4-1q-1.3 0-2.3 1t-1 2.3 1 2.4 2.3 1z' })
	        )
	    );
	};
	
	exports.default = FaRedditAlien;
	module.exports = exports['default'];

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRedditSquare = function FaRedditSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24 25.2q0.3 0.3 0 0.6-1.2 1.2-3.9 1.2t-3.8-1.2q-0.3-0.3 0-0.6 0.1-0.1 0.3-0.1t0.3 0.1q0.9 0.9 3.2 0.9t3.3-0.9q0.1-0.1 0.3-0.1t0.3 0.1z m-5.9-3.5q0 0.7-0.5 1.2t-1.2 0.5-1.2-0.5-0.5-1.2q0-0.7 0.5-1.2t1.2-0.5 1.2 0.5 0.5 1.2z m7.5 0q0 0.7-0.5 1.2t-1.2 0.5-1.2-0.5-0.5-1.2q0-0.7 0.5-1.2t1.2-0.5 1.2 0.5 0.5 1.2z m4.8-2.3q0-0.9-0.6-1.6t-1.7-0.7q-0.9 0-1.6 0.7-2.5-1.7-6-1.8l1.3-5.4 3.8 0.9q0 0.7 0.5 1.2t1.2 0.4q0.7 0 1.2-0.5t0.5-1.2-0.5-1.2-1.2-0.5q-1.1 0-1.6 1l-4.2-1q-0.4-0.1-0.4 0.3l-1.4 6q-3.4 0.1-5.9 1.9-0.7-0.8-1.6-0.8-1 0-1.7 0.7t-0.6 1.6q0 0.7 0.3 1.2t0.9 0.9q-0.1 0.6-0.1 1.1 0 2.7 2.7 4.6t6.5 2q3.8 0 6.4-2t2.7-4.6q0-0.6-0.1-1.1 0.5-0.3 0.9-0.9t0.3-1.2z m6.9-10.1v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaRedditSquare;
	module.exports = exports['default'];

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaReddit = function FaReddit(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.4 26.1q0.4 0.3 0 0.6-1.3 1.4-4.4 1.4t-4.4-1.4q-0.4-0.3 0-0.6 0.1-0.2 0.3-0.2t0.3 0.2q1.1 1 3.8 1 2.7 0 3.8-1.1 0.1-0.1 0.3-0.1t0.3 0.1z m-6.8-4.1q0 0.8-0.6 1.4t-1.4 0.6-1.4-0.6-0.6-1.4q0-0.8 0.6-1.4t1.4-0.6 1.4 0.6 0.6 1.4z m8.8 0q0 0.8-0.6 1.4t-1.4 0.6-1.4-0.6-0.6-1.4 0.6-1.4 1.4-0.6 1.4 0.6 0.6 1.4z m5.6-2.7q0-1.1-0.8-1.8t-1.9-0.8-1.9 0.8q-2.9-2-6.9-2.2l1.4-6.3 4.4 1q0 0.8 0.6 1.4t1.4 0.6 1.4-0.6 0.6-1.4-0.6-1.4-1.4-0.6q-1.2 0-1.8 1.1l-4.9-1.1q-0.4-0.1-0.6 0.4l-1.5 6.9q-4 0.2-6.9 2.2-0.8-0.8-1.9-0.8-1.1 0-1.9 0.8t-0.8 1.8q0 0.8 0.4 1.5t1.1 0.9q-0.1 0.6-0.1 1.3 0 3.2 3.1 5.4t7.5 2.3q4.4 0 7.6-2.3t3.1-5.4q0-0.7-0.2-1.3 0.7-0.3 1.1-1t0.4-1.4z m8 0.7q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaReddit;
	module.exports = exports['default'];

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRefresh = function FaRefresh(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.7 23.6q0 0.1 0 0.1-1.4 6-6 9.7t-10.6 3.7q-3.3 0-6.4-1.2t-5.4-3.5l-2.9 2.9q-0.4 0.4-1 0.4t-1-0.4-0.4-1v-10q0-0.6 0.4-1t1-0.4h10q0.6 0 1 0.4t0.5 1-0.5 1l-3 3q1.6 1.5 3.6 2.3t4.1 0.8q3 0 5.6-1.4t4.2-4q0.2-0.4 1.2-2.6 0.1-0.5 0.6-0.5h4.3q0.3 0 0.5 0.2t0.2 0.5z m0.6-17.9v10q0 0.6-0.4 1t-1 0.4h-10q-0.6 0-1-0.4t-0.5-1 0.5-1l3-3.1q-3.3-3-7.8-3-2.9 0-5.5 1.4t-4.2 4q-0.2 0.4-1.2 2.6-0.2 0.5-0.6 0.5h-4.5q-0.3 0-0.5-0.2t-0.2-0.5v-0.1q1.5-6 6-9.7t10.7-3.7q3.3 0 6.4 1.2t5.4 3.5l3-2.9q0.4-0.4 1-0.4t1 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaRefresh;
	module.exports = exports['default'];

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRegistered = function FaRegistered(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.3 15.7q0-2-1.4-2.7-0.7-0.4-2.6-0.4h-2.7v6.3h3.6q1.5 0 2.3-0.9t0.8-2.3z m1.1 6.4l4.6 8.3q0.2 0.4 0 0.7-0.2 0.3-0.6 0.3h-3.4q-0.5 0-0.6-0.4l-4.4-8.1h-3.4v7.8q0 0.3-0.2 0.5t-0.5 0.2h-3q-0.4 0-0.6-0.2t-0.2-0.5v-21.4q0-0.3 0.2-0.5t0.6-0.2h6.5q2.9 0 4.3 0.5 1.9 0.7 3 2.4t1 4.1q0 2-0.9 3.7t-2.6 2.4q0.2 0.2 0.2 0.4z m-4.4-18.5q-3.3 0-6.4 1.3t-5.2 3.5-3.5 5.2-1.3 6.4 1.3 6.4 3.5 5.2 5.2 3.5 6.4 1.3 6.4-1.3 5.2-3.5 3.5-5.2 1.3-6.4-1.3-6.4-3.5-5.2-5.2-3.5-6.4-1.3z m20 16.4q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaRegistered;
	module.exports = exports['default'];

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRenren = function FaRenren(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.3 35q-3.8 2.1-8.2 2.1-4.4 0-8.2-2.1 3.1-1.9 5.2-4.7t3-5.9q0.8 3.2 2.9 5.9t5.3 4.7z m-11.1-31.8v10.8q0 5.6-2.8 10.3t-7.4 6.8q-4-4.8-4-11.1 0-4.1 1.9-7.8t5.1-6 7.2-3z m20.1 16.8q0 6.3-4.1 11.1-4.5-2.2-7.3-6.8t-2.9-10.3v-10.8q4 0.6 7.3 3t5.1 6 1.9 7.8z' })
	        )
	    );
	};
	
	exports.default = FaRenren;
	module.exports = exports['default'];

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRepeat = function FaRepeat(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 5.7v10q0 0.6-0.4 1t-1 0.4h-10q-1 0-1.4-0.9-0.3-0.8 0.4-1.5l3-3.1q-3.3-3-7.8-3-2.3 0-4.4 0.9t-3.6 2.4-2.5 3.7-0.9 4.4 0.9 4.4 2.5 3.7 3.6 2.4 4.4 0.9q2.7 0 5.1-1.1t4-3.3q0.1-0.2 0.5-0.3 0.3 0 0.5 0.2l3.1 3.1q0.2 0.2 0.2 0.5t-0.2 0.5q-2.4 2.9-5.9 4.5t-7.3 1.6q-3.4 0-6.6-1.3t-5.5-3.7-3.6-5.4-1.4-6.7 1.4-6.7 3.6-5.4 5.5-3.7 6.6-1.3q3.3 0 6.4 1.2t5.5 3.5l2.9-2.9q0.6-0.7 1.5-0.3 0.9 0.4 0.9 1.3z' })
	        )
	    );
	};
	
	exports.default = FaRepeat;
	module.exports = exports['default'];

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRetweet = function FaRetweet(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.6 32.6q0 0.3-0.2 0.5t-0.5 0.2h-19.9q-0.2 0-0.3-0.1t-0.2-0.1-0.1-0.2-0.1-0.2 0-0.2v-12.5h-4q-0.5 0-0.9-0.4t-0.4-0.9q0-0.5 0.3-0.9l6.7-8q0.4-0.4 1-0.4t1 0.4l6.6 8q0.3 0.4 0.3 0.9 0 0.5-0.3 0.9t-1 0.4h-4v8h12q0.3 0 0.5 0.2l3.3 4q0.2 0.2 0.2 0.4z m13.3-8.6q0 0.5-0.3 0.8l-6.7 8q-0.4 0.5-1 0.5t-1-0.5l-6.7-8q-0.3-0.3-0.3-0.8 0-0.6 0.4-0.9t0.9-0.4h4v-8h-11.9q-0.4 0-0.5-0.3l-3.4-3.9q-0.1-0.2-0.1-0.5 0-0.2 0.2-0.4t0.5-0.2h19.9q0.2 0 0.3 0t0.2 0.2 0.1 0.1 0 0.3 0.1 0.2v12.5h3.9q0.6 0 1 0.4t0.4 0.9z' })
	        )
	    );
	};
	
	exports.default = FaRetweet;
	module.exports = exports['default'];

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRoad = function FaRoad(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.1 22.1v-0.1l-0.5-6.7q-0.1-0.2-0.3-0.4t-0.4-0.2h-3.9q-0.3 0-0.5 0.2t-0.2 0.4l-0.5 6.7v0.1q0 0.2 0.2 0.4t0.4 0.2h5.1q0.2 0 0.4-0.2t0.2-0.4z m15.7 9.7q0 1.5-0.9 1.5h-14.6q0.2 0 0.4-0.2t0.2-0.5l-0.4-5.3q-0.1-0.3-0.3-0.5t-0.4-0.2h-5.7q-0.3 0-0.5 0.2t-0.2 0.5l-0.4 5.3q0 0.3 0.2 0.5t0.4 0.2h-14.6q-1 0-1-1.5 0-1.1 0.6-2.4l8.6-21.7q0.2-0.4 0.6-0.7t0.8-0.3h7q-0.3 0-0.5 0.2t-0.2 0.5l-0.3 4q0 0.3 0.2 0.4t0.4 0.2h3.5q0.2 0 0.4-0.2t0.2-0.4l-0.3-4q-0.1-0.3-0.3-0.5t-0.4-0.2h7q0.4 0 0.8 0.3t0.5 0.7l8.7 21.7q0.5 1.3 0.5 2.4z' })
	        )
	    );
	};
	
	exports.default = FaRoad;
	module.exports = exports['default'];

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRocket = function FaRocket(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.1 10q0-0.9-0.6-1.5t-1.5-0.6-1.5 0.6-0.6 1.5 0.6 1.5 1.5 0.6 1.5-0.6 0.6-1.5z m5-6.4q0 5.5-1.6 9.6t-5.7 8q-1.8 1.8-4.4 4l-0.4 8.4q0 0.4-0.4 0.6l-8.5 5q-0.2 0.1-0.4 0.1-0.3 0-0.5-0.2l-1.4-1.4q-0.3-0.4-0.2-0.8l1.9-6.1-6.3-6.3-6.1 1.9q-0.1 0-0.2 0-0.4 0-0.6-0.2l-1.4-1.4q-0.4-0.4-0.1-0.9l5-8.5q0.2-0.4 0.6-0.4l8.4-0.4q2.2-2.6 4-4.4 4.2-4.2 8-5.8t9.6-1.5q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaRocket;
	module.exports = exports['default'];

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRotateLeft = function FaRotateLeft(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 20q0 3.5-1.4 6.7t-3.6 5.4-5.5 3.7-6.7 1.3q-3.8 0-7.3-1.6t-5.8-4.5q-0.2-0.3-0.2-0.5t0.2-0.5l3.1-3.1q0.2-0.2 0.5-0.2 0.4 0.1 0.5 0.3 1.7 2.1 4 3.3t5 1.1q2.4 0 4.5-0.9t3.6-2.4 2.5-3.7 0.9-4.4-0.9-4.4-2.5-3.7-3.6-2.4-4.5-0.9q-2.1 0-4.2 0.8t-3.5 2.2l3 3.1q0.7 0.7 0.3 1.6-0.3 0.8-1.3 0.8h-10q-0.5 0-1-0.4t-0.4-1v-10q0-0.9 0.9-1.3 0.9-0.4 1.5 0.3l2.9 2.9q2.4-2.3 5.5-3.5t6.3-1.2q3.5 0 6.7 1.3t5.5 3.7 3.6 5.4 1.4 6.7z' })
	        )
	    );
	};
	
	exports.default = FaRotateLeft;
	module.exports = exports['default'];

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRouble = function FaRouble(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.8 12.6q0-2.2-1.5-3.6t-3.8-1.4h-7.1v10h7.1q2.4 0 3.8-1.4t1.5-3.6z m5.3 0q0 4.3-2.9 7t-7.2 2.8h-7.6v2.6h11.2q0.4 0 0.6 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.6 0.2h-11.2v4.3q0 0.3-0.2 0.5t-0.5 0.2h-3.8q-0.3 0-0.5-0.2t-0.2-0.5v-4.3h-5q-0.3 0-0.5-0.2t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h5v-2.6h-5q-0.3 0-0.5-0.2t-0.2-0.6v-3.3q0-0.3 0.2-0.5t0.5-0.2h5v-14q0-0.3 0.2-0.5t0.5-0.2h12.1q4.4 0 7.2 2.7t2.9 7z' })
	        )
	    );
	};
	
	exports.default = FaRouble;
	module.exports = exports['default'];

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaRssSquare = function FaRssSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.4 28.6q0-1.2-0.8-2t-2-0.9-2 0.9-0.9 2 0.9 2 2 0.8 2-0.8 0.8-2z m7.9 2.1q-0.3-5.2-4-8.9t-8.8-3.9q-0.3 0-0.6 0.2t-0.2 0.5v2.9q0 0.2 0.2 0.4t0.5 0.3q3.4 0.2 5.9 2.7t2.7 5.9q0 0.2 0.2 0.4t0.5 0.2h2.8q0.3 0 0.6-0.2t0.2-0.5z m8.5 0q-0.1-3.4-1.2-6.6t-3.1-5.9-4.6-4.5-5.8-3.1-6.6-1.3q-0.4 0-0.6 0.2-0.2 0.2-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2q4.6 0.2 8.4 2.5t6.3 6.2 2.5 8.4q0 0.3 0.2 0.5t0.5 0.2h2.8q0.3 0 0.5-0.2 0.3-0.2 0.2-0.5z m6.5-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaRssSquare;
	module.exports = exports['default'];

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSafari = function FaSafari(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.2 19.9q0 0.6-0.4 1t-0.9 0.5q-0.6 0-1-0.4t-0.4-0.9q0-0.6 0.3-1t1-0.5 1 0.4 0.4 0.9z m0.3 1.3l7.8-12.9q-0.2 0.1-1.5 1.4t-2.8 2.6-3 2.8-2.6 2.5-1.2 1.1l-7.8 13q0.2-0.2 1.5-1.4t2.9-2.6 3-2.9 2.6-2.4 1.1-1.2z m14.5-1.2q0 4.5-2.4 8.3 0-0.1-0.3-0.3t-0.6-0.3-0.4-0.2q-0.3 0-0.3 0.3 0 0.2 1.3 1-1.6 2.5-4.1 4.2t-5.4 2.5l-0.3-1.5q-0.1-0.2-0.4-0.2-0.1 0-0.2 0.1t0 0.2l0.4 1.5q-1.6 0.4-3.3 0.4-4.4 0-8.3-2.4 0 0 0.3-0.4t0.5-0.8 0.2-0.4q0-0.3-0.3-0.3-0.1 0-0.4 0.3t-0.5 0.8-0.3 0.5q-2.5-1.7-4.3-4.2t-2.4-5.4l1.5-0.4q0.2 0 0.2-0.3 0-0.1-0.1-0.2t-0.2 0l-1.5 0.3q-0.4-1.6-0.4-3.1 0-4.6 2.5-8.5 0 0.1 0.4 0.3t0.7 0.4 0.3 0.2q0.3 0 0.3-0.3 0-0.1-0.2-0.3t-0.8-0.5l-0.4-0.3q1.7-2.5 4.2-4.2t5.4-2.4l0.4 1.5q0 0.3 0.3 0.3 0.1 0 0.2-0.2t0-0.2l-0.3-1.5q1.6-0.3 3-0.3 4.6 0 8.5 2.5-0.9 1.2-0.9 1.4 0 0.3 0.3 0.3 0.2 0 1-1.4 2.5 1.7 4.2 4.1t2.4 5.4l-1.2 0.3q-0.3 0-0.3 0.3 0 0.2 0.2 0.2t0.2 0.1l1.2-0.3q0.4 1.6 0.4 3.1z m1.9 0q0-3.6-1.5-6.9t-3.8-5.7-5.7-3.8-6.9-1.5-6.9 1.5-5.7 3.8-3.8 5.7-1.5 6.9 1.5 6.9 3.8 5.7 5.7 3.8 6.9 1.5 6.9-1.5 5.7-3.8 3.8-5.7 1.5-6.9z m2.1 0q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaSafari;
	module.exports = exports['default'];

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaScribd = function FaScribd(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.5 34.6q0 2-1.4 3.4t-3.4 1.4-3.5-1.4-1.4-3.4q0-2 1.4-3.4t3.5-1.5 3.4 1.5 1.4 3.4z m-5.2-6.3q-2.6 0.3-4.3 2.3t-1.7 4.6q0 1.6 0.7 3.1-3.3 1.7-8.5 1.7-2.4 0-4.5-0.5t-3.4-1.2-2.4-1.7-1.7-1.9-1-1.8-0.6-1.5-0.1-0.9q0-0.4 0.1-1t0.4-1.2 0.8-1.3 1.5-1 2.1-0.4 2.1 0.4 1.4 0.9 0.8 1.2 0.4 1.1 0 0.8q0 0.7-0.5 1.8 0.7 0.6 1.9 0.9t2 0.4l0.9 0q2.6 0 4.3-1.1t1.6-3q0-0.6-0.2-1.1t-0.7-1-1.1-0.9-1.6-1-2.1-1-2.7-1.3l-0.9-0.4q-2.6-1.3-4.2-2.3t-2.7-2.3-1.6-2.8-0.5-3.6q0-1.7 0.5-3.3t1.4-3.1 2.5-2.5 3.8-1.8 4.9-0.6q2.7 0 4.9 0.6t3.7 1.5 2.4 2.1 1.5 2.3 0.4 2.3q0 1.1-0.4 1.9t-0.8 1.3-1.1 0.8-1 0.4-0.9 0.1h-0.9l-0.9-0.1-1-0.3-0.9-0.6-0.8-1.1-0.5-1.5-0.3-2.2q-0.3-0.4-1.3-0.6t-1.8-0.2l-0.8 0q-1.5 0-2.6 0.7t-1.6 1.5-0.5 1.7q0 0.6 0.1 1t0.6 1 1.2 1.2 2.1 1.1 3.4 1.4q1.7 0.5 3.1 1.1t2.4 1.3 1.8 1.3 1.4 1.3 0.9 1.4 0.6 1.4 0.3 1.4 0.2 1.4 0 1.4z' })
	        )
	    );
	};
	
	exports.default = FaScribd;
	module.exports = exports['default'];

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSearchMinus = function FaSearchMinus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.4 17.9v1.4q0 0.3-0.3 0.5t-0.5 0.2h-12.8q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h12.8q0.3 0 0.5 0.3t0.3 0.5z m2.8 0.7q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaSearchMinus;
	module.exports = exports['default'];

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSearchPlus = function FaSearchPlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.4 17.9v1.4q0 0.3-0.3 0.5t-0.5 0.2h-5v5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-5h-5q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.3h5v-5q0-0.2 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5v5h5q0.3 0 0.5 0.3t0.3 0.5z m2.8 0.7q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaSearchPlus;
	module.exports = exports['default'];

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSearch = function FaSearch(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 18.6q0-4.2-2.9-7.1t-7.1-2.9-7 2.9-3 7.1 2.9 7 7.1 3 7.1-3 2.9-7z m11.4 18.5q0 1.2-0.8 2.1t-2 0.8q-1.2 0-2-0.8l-7.7-7.7q-4 2.8-8.9 2.8-3.2 0-6.1-1.3t-5-3.3-3.4-5-1.2-6.1 1.2-6.1 3.4-5.1 5-3.3 6.1-1.2 6.1 1.2 5 3.3 3.4 5.1 1.2 6.1q0 4.9-2.7 8.9l7.6 7.6q0.8 0.9 0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaSearch;
	module.exports = exports['default'];

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSellsy = function FaSellsy(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.1 29.2v-14.2q0-0.4-0.3-0.7t-0.7-0.3h-1.8q-0.3 0-0.6 0.3t-0.3 0.7v14.2q0 0.4 0.3 0.7t0.6 0.3h1.8q0.4 0 0.7-0.3t0.3-0.7z m-5.5 0v-10.3q0-0.4-0.3-0.7t-0.7-0.3h-1.9q-0.4 0-0.7 0.3t-0.3 0.7v10.3q0 0.4 0.3 0.7t0.7 0.3h1.9q0.4 0 0.7-0.3t0.3-0.7z m-5.7 0v-8.3q0-0.4-0.3-0.7t-0.6-0.3h-2q-0.4 0-0.7 0.3t-0.3 0.7v8.3q0 0.4 0.3 0.7t0.7 0.3h2q0.4 0 0.6-0.3t0.3-0.7z m-5.6 0v-7q0-0.4-0.3-0.7t-0.7-0.3h-2q-0.4 0-0.6 0.3t-0.3 0.7v7q0 0.4 0.3 0.7t0.6 0.3h2q0.4 0 0.7-0.3t0.3-0.7z m27.5-2.8q0 3.2-2.3 5.5t-5.6 2.3h-24.1q-3.2 0-5.5-2.3t-2.3-5.5q0-2.3 1.2-4.2t3.3-2.9q-0.2-0.6-0.2-1.4 0-2.2 1.6-3.7t3.7-1.6q2 0 3.5 1.3 0.9-3.5 3.8-5.8t6.5-2.3q2.9 0 5.4 1.4t3.8 3.9 1.5 5.3q0 1.3-0.3 2.4 2.6 0.7 4.3 2.8t1.7 4.8z' })
	        )
	    );
	};
	
	exports.default = FaSellsy;
	module.exports = exports['default'];

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaServer = function FaServer(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm2.9 31.4h22.8v-2.8h-22.8v2.8z m0-11.4h22.8v-2.9h-22.8v2.9z m35 10q0-0.9-0.7-1.5t-1.5-0.6-1.5 0.6-0.6 1.5 0.6 1.5 1.5 0.6 1.5-0.6 0.7-1.5z m-35-21.4h22.8v-2.9h-22.8v2.9z m35 10q0-0.9-0.7-1.5t-1.5-0.7-1.5 0.7-0.6 1.5 0.6 1.5 1.5 0.6 1.5-0.6 0.7-1.5z m0-11.5q0-0.8-0.7-1.5t-1.5-0.6-1.5 0.6-0.6 1.5 0.6 1.6 1.5 0.6 1.5-0.6 0.7-1.6z m2.1 18.6v8.6h-40v-8.6h40z m0-11.4v8.6h-40v-8.6h40z m0-11.4v8.5h-40v-8.5h40z' })
	        )
	    );
	};
	
	exports.default = FaServer;
	module.exports = exports['default'];

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShareAltSquare = function FaShareAltSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 26.7q0-2-1.4-3.4t-3.4-1.4q-1.9 0-3.2 1.3l-5.4-2.7q0-0.3 0-0.5t0-0.5l5.4-2.7q1.3 1.3 3.2 1.3 2 0 3.4-1.4t1.4-3.4-1.4-3.3-3.4-1.4-3.4 1.4-1.4 3.3q0 0.2 0.1 0.5l-5.4 2.7q-1.4-1.3-3.2-1.3-2 0-3.4 1.4t-1.4 3.4 1.4 3.4 3.4 1.4q1.8 0 3.2-1.3l5.4 2.7q-0.1 0.3-0.1 0.5 0 1.9 1.4 3.3t3.4 1.4 3.4-1.4 1.4-3.3z m5.7-17.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaShareAltSquare;
	module.exports = exports['default'];

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShareAlt = function FaShareAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 22.9q3 0 5.1 2t2.1 5.1-2.1 5.1-5.1 2-5-2-2.1-5.1q0-0.3 0-0.8l-8-4q-2 1.9-4.9 1.9-2.9 0-5-2t-2.1-5.1 2.1-5.1 5-2q2.9 0 4.9 1.9l8-4q0-0.5 0-0.8 0-3 2.1-5.1t5-2 5.1 2 2.1 5.1-2.1 5.1-5.1 2q-2.8 0-4.8-1.9l-8.1 4q0.1 0.5 0.1 0.8t-0.1 0.8l8.1 4q2-1.9 4.8-1.9z' })
	        )
	    );
	};
	
	exports.default = FaShareAlt;
	module.exports = exports['default'];

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShareSquareO = function FaShareSquareO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.9 22.1v5.8q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h5.7q0.3 0 0.5 0.2t0.2 0.5q0 0.6-0.5 0.7-1.8 0.6-3 1.3-0.2 0.1-0.4 0.1h-2.5q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-4.8q0-0.4 0.4-0.7 0.6-0.3 1.2-0.8 0.3-0.4 0.8-0.2 0.4 0.2 0.4 0.7z m5.3-11.1l-8.6 8.6q-0.4 0.4-1 0.4-0.2 0-0.5-0.1-0.9-0.4-0.9-1.3v-4.3h-3.6q-7.2 0-9.7 2.9-2.7 3.1-1.7 10.6 0.1 0.5-0.4 0.7-0.2 0.1-0.3 0.1-0.4 0-0.6-0.3-0.2-0.3-0.4-0.7t-0.9-1.5-1.1-2.3-0.9-2.5-0.4-2.7q0-1.1 0.1-2.1t0.3-2 0.6-1.9 1.1-1.9 1.5-1.6 2.1-1.4 2.8-1.1 3.6-0.6 4.3-0.3h3.6v-4.3q0-0.9 0.9-1.3 0.3-0.1 0.5-0.1 0.6 0 1 0.4l8.6 8.6q0.4 0.4 0.4 1t-0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaShareSquareO;
	module.exports = exports['default'];

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShareSquare = function FaShareSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.4 24.6l7.9-7.9q0.4-0.4 0.4-1t-0.4-1l-7.9-7.8q-0.6-0.7-1.5-0.4-0.9 0.4-0.9 1.4v3.5q-2.7 0-4.8 0.5t-3.6 1.1-2.6 1.8-1.7 2.1-1 2.4-0.5 2.5-0.1 2.5q0 4 3.7 9 0.3 0.3 0.6 0.3 0.2 0 0.3-0.1 0.5-0.2 0.4-0.7-1-7.9 1.4-10.6 1-1.1 2.9-1.7t5-0.5v3.6q0 0.9 0.9 1.3 0.3 0.1 0.5 0.1 0.6 0 1-0.4z m11.9-15.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaShareSquare;
	module.exports = exports['default'];

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShield = function FaShield(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.8 21.4v-14.3h-10v25.4q2.6-1.4 4.7-3 5.3-4.1 5.3-8.1z m4.3-17.1v17.1q0 2-0.8 3.8t-1.8 3.4-2.7 2.8-2.8 2.3-2.7 1.8-2 1.1-0.9 0.4q-0.3 0.1-0.6 0.1t-0.6-0.1q-0.4-0.2-0.9-0.4t-2-1.1-2.7-1.8-2.9-2.3-2.6-2.8-1.9-3.4-0.7-3.8v-17.1q0-0.6 0.4-1t1-0.4h25.7q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaShield;
	module.exports = exports['default'];

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShip = function FaShip(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.2 32.8q0.3-0.4 0.8-0.4t0.9 0.4l2.5 2.5-1.8 1.7-1.6-1.6-1.6 1.6q-0.3 0.4-0.9 0.4t-0.8-0.4l-1.6-1.6-1.7 1.6q-0.3 0.4-0.8 0.4t-0.9-0.4l-1.6-1.6-1.6 1.6q-0.4 0.4-0.9 0.4t-0.9-0.4l-1.6-1.6-1.6 1.6q-0.4 0.4-0.9 0.4t-0.8-0.4l-1.7-1.6-1.6 1.6q-0.3 0.4-0.8 0.4t-0.9-0.4l-1.6-1.6-1.6 1.6q-0.4 0.4-0.9 0.4t-0.9-0.4l-1.6-1.6-1.6 1.6q-0.4 0.4-0.9 0.4t-0.8-0.4l-2.5-2.5 1.7-1.7 1.6 1.6 1.6-1.6q0.4-0.4 0.9-0.4t0.9 0.4l1.6 1.6 1.6-1.6q0.4-0.4 0.9-0.4t0.9 0.4l1.6 1.6 1.6-1.6q0.3-0.4 0.8-0.4t0.9 0.4l1.6 1.6 1.6-1.6q0.4-0.4 0.9-0.4t0.9 0.4l1.6 1.6 1.6-1.6q0.4-0.4 0.9-0.4t0.9 0.4l1.6 1.6 1.6-1.6q0.4-0.4 0.9-0.4t0.8 0.4l1.6 1.6z m-30.6-0.7q-0.4 0.3-0.9 0.3t-0.8-0.3l-2.5-2.5 1.7-1.8 1.6 1.6 1.6-1.6q0.4-0.3 0.9-0.3t0.9 0.3l1.6 1.6 1.2-1.2v-5.7l-4-6.1q-0.4-0.5-0.2-1.1t0.8-0.8l3.4-1.1v-5.8h2.5v-2.5h5v-2.5h5v2.5h4.9v2.5h2.5v5.8l3.4 1.1q0.6 0.2 0.8 0.8t-0.1 1.1l-4.1 6.1v5.7l0.4-0.4q0.4-0.3 0.9-0.3t0.8 0.3l1.6 1.6 1.7-1.6q0.3-0.3 0.8-0.3t0.9 0.3l2.5 2.5-1.8 1.8-1.6-1.7-1.6 1.7q-0.3 0.3-0.9 0.3t-0.8-0.3l-1.6-1.7-1.7 1.7q-0.3 0.3-0.8 0.3t-0.9-0.3l-1.6-1.7-1.6 1.7q-0.4 0.3-0.9 0.3t-0.9-0.3l-1.6-1.7-1.6 1.7q-0.4 0.3-0.9 0.3t-0.8-0.3l-1.7-1.7-1.6 1.7q-0.3 0.3-0.8 0.3t-0.9-0.3l-1.6-1.7-1.6 1.7q-0.4 0.3-0.9 0.3t-0.9-0.3l-1.6-1.7z m7.8-22v2.4l7.5-2.4 7.4 2.4v-2.4h-2.5v-2.5h-9.9v2.5h-2.5z' })
	        )
	    );
	};
	
	exports.default = FaShip;
	module.exports = exports['default'];

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShirtsinbulk = function FaShirtsinbulk(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm3 0h34.3v31.1l-17.3 7.5-17-7.5v-31.1z m32.1 29.6v-20.7h-29.9v20.7l14.8 6.6z m0-22.9v-4.5h-29.9v4.5h29.9z m-28.1 6.7v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.5h-0.8v-2.5h0.8z m0 3.3v2.6h-0.8v-2.6h0.8z m0.6 3.2l0.4-0.8 2.3 1.1-0.3 0.7z m3.1 1.3l0.3-0.7 2.3 1-0.3 0.7z m3 1.4l0.3-0.8 2.3 1-0.3 0.8z m3 1.3l0.3-0.8 2.4 1.1-0.4 0.7z m4.1 0.3l2.3-1.1 0.4 0.8-2.4 1z m3-1.4l2.3-1 0.4 0.8-2.4 1z m3-1.3l2.4-1 0.3 0.7-2.3 1z m3.1-1.3l2.3-1.1 0.3 0.8-2.3 1z m-21.1-26.8v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.7 0v0.8h-2.6v-0.8h2.6z m3.5 0v0.8h-2.5v-0.8h2.5z m-27 7.6v1.7h-0.8v-2.5h2.6v0.8h-1.8z m5.4-0.8v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.6v-0.8h2.6z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.6 0v0.8h-2.5v-0.8h2.5z m3.7 0v0.8h-2.6v-0.8h2.6z m2.7 2.5v-1.7h-1.7v-0.8h2.6v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.3v-2.5h0.9v2.5h-0.9z m0 3.4v-2.6h0.9v2.6h-0.9z m-13.2-0.8q-2.9 0-5-2.1t-2-4.9q0-2.9 2-4.9t5-2.1q2.9 0 4.9 2.1t2.1 4.9q0 2.9-2.1 4.9t-4.9 2.1z m-3.7-8.5q0 0.8 0.4 1.2t1.1 0.6 1.5 0.1 1.4 0.1 1.1 0.2 0.4 0.7q0 1.1-2.5 1.1-2.1 0-2.7-1.2h-0.1l-0.7 1.4q1.5 1 3.6 1 0.7 0 1.3-0.1t1.2-0.4 1-0.7 0.4-1.2q0-1-0.6-1.6t-1.5-0.6-1.8 0-1.5-0.2-0.6-0.5q0-0.5 0.5-0.8t0.9-0.3 0.9-0.1q0.8 0 1.6 0.3t1.1 0.7h0.1l0.7-1.3q-0.1 0-0.5-0.1t-0.5-0.2-0.4-0.2-0.5-0.2-0.5-0.1-0.5 0-0.5-0.1q-0.7 0-1.3 0.1t-1.2 0.4-0.9 0.8-0.4 1.2z' })
	        )
	    );
	};
	
	exports.default = FaShirtsinbulk;
	module.exports = exports['default'];

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShoppingBag = function FaShoppingBag(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.2 31.4l0.8 7q0.1 0.6-0.4 1.1-0.4 0.5-1 0.5h-37.2q-0.6 0-1-0.5-0.5-0.5-0.4-1.1l0.8-7h38.4z m-2.1-18.7l2 17.3h-38.2l2-17.3q0-0.5 0.4-0.9t1-0.4h5.7v2.9q0 1.2 0.8 2t2.1 0.8 2-0.8 0.8-2v-2.9h8.6v2.9q0 1.2 0.8 2t2 0.8 2.1-0.8 0.8-2v-2.9h5.7q0.6 0 1 0.4t0.4 0.9z m-8.5-4.1v5.7q0 0.6-0.5 1t-1 0.4-1-0.4-0.4-1v-5.7q0-2.4-1.7-4.1t-4-1.6-4 1.6-1.7 4.1v5.7q0 0.6-0.4 1t-1 0.4-1-0.4-0.5-1v-5.7q0-3.6 2.5-6.1t6.1-2.5 6.1 2.5 2.5 6.1z' })
	        )
	    );
	};
	
	exports.default = FaShoppingBag;
	module.exports = exports['default'];

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShoppingBasket = function FaShoppingBasket(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 17.5q1 0 1.7 0.7t0.8 1.8-0.8 1.8-1.7 0.7h-0.3l-2.3 12.8q-0.1 0.9-0.8 1.5t-1.6 0.6h-24.8q-0.9 0-1.6-0.6t-0.9-1.5l-2.2-12.8h-0.3q-1 0-1.8-0.7t-0.7-1.8 0.7-1.8 1.8-0.7h34.8z m-27.9 15.5q0.5 0 0.9-0.4t0.3-0.9l-0.7-8.1q0-0.5-0.4-0.8t-0.9-0.3-0.8 0.4-0.3 0.9l0.6 8.1q0 0.5 0.4 0.8t0.8 0.3h0.1z m8-1.2v-8.1q0-0.5-0.4-0.8t-0.9-0.4-0.8 0.4-0.4 0.8v8.1q0 0.5 0.4 0.9t0.8 0.3 0.9-0.3 0.4-0.9z m7.4 0v-8.1q0-0.5-0.3-0.8t-0.9-0.4-0.9 0.4-0.3 0.8v8.1q0 0.5 0.3 0.9t0.9 0.3 0.9-0.3 0.3-0.9z m6.9 0.1l0.6-8.1q0-0.5-0.3-0.9t-0.8-0.4-1 0.3-0.4 0.8l-0.6 8.1q0 0.5 0.3 0.9t0.8 0.4h0.1q0.5 0 0.9-0.3t0.4-0.8z m-22.5-23.6l-1.8 8h-2.5l1.9-8.6q0.4-1.7 1.8-2.8t3.1-1.1h3.2q0-0.5 0.4-0.8t0.8-0.4h7.5q0.5 0 0.9 0.4t0.3 0.9h3.3q1.7 0 3.1 1t1.7 2.8l2 8.6h-2.6l-1.8-8q-0.2-0.9-0.9-1.4t-1.5-0.6h-3.3q0 0.5-0.3 0.9t-0.9 0.4h-7.5q-0.5 0-0.8-0.4t-0.4-0.9h-3.2q-0.9 0-1.6 0.6t-0.9 1.4z' })
	        )
	    );
	};
	
	exports.default = FaShoppingBasket;
	module.exports = exports['default'];

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaShoppingCart = function FaShoppingCart(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.8 34.3q0 1.1-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m20 0q0 1.1-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m2.8-24.3v11.4q0 0.6-0.3 1t-0.9 0.5l-23.3 2.7q0.3 1.3 0.3 1.5 0 0.4-0.6 1.5h20.6q0.5 0 1 0.4t0.4 1-0.4 1-1 0.4h-22.9q-0.6 0-1-0.4t-0.4-1q0-0.2 0.2-0.7t0.3-0.8 0.5-0.9 0.3-0.7l-3.9-18.3h-4.6q-0.6 0-1-0.5t-0.4-1 0.4-1 1-0.4h5.7q0.4 0 0.7 0.2t0.4 0.3 0.3 0.6 0.2 0.5 0.1 0.7 0.1 0.6h26.8q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaShoppingCart;
	module.exports = exports['default'];

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSignIn = function FaSignIn(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.4 20q0 0.6-0.4 1l-12.1 12.1q-0.5 0.5-1 0.5t-1-0.5-0.5-1v-6.4h-10q-0.5 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h10v-6.4q0-0.6 0.5-1t1-0.5 1 0.5l12.1 12.1q0.4 0.4 0.4 1z m7.9-7.9v15.8q0 2.6-1.9 4.5t-4.5 1.9h-7.2q-0.3 0-0.5-0.2t-0.2-0.5q0-0.1 0-0.5t0-0.6 0-0.5 0.3-0.4 0.4-0.2h7.2q1.4 0 2.5-1t1-2.5v-15.8q0-1.4-1-2.5t-2.5-1h-7l-0.3-0.1-0.2 0-0.2-0.1-0.2-0.2 0-0.3q0-0.1 0-0.5t0-0.6 0-0.5 0.3-0.4 0.4-0.2h7.2q2.6 0 4.5 1.9t1.9 4.5z' })
	        )
	    );
	};
	
	exports.default = FaSignIn;
	module.exports = exports['default'];

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSignLanguage = function FaSignLanguage(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 15q0.7 0 1.3 0.4l4.9 3.3q1.4 0.9 2.5 2.2l3.2 3.8q0.9 1 0.7 2.4l-1.6 9.2q-0.2 0.7-0.7 1.2t-1.2 0.5l-11.8 1.3-7.8 0.7h-0.2q-0.9 0-1.5-0.6t-0.7-1.5q0-0.9 0.6-1.5t1.5-0.7l5.8-0.7h-10q-0.9 0-1.6-0.7t-0.6-1.6q0.1-0.8 0.7-1.4t1.6-0.6l9.8 0-11.6-1.4q-0.9-0.1-1.5-0.9t-0.4-1.6q0.2-0.8 0.8-1.3t1.5-0.5h0.2l10.7 1.4-7.8-2.1q-0.9-0.3-1.4-1t-0.4-1.5q0.1-0.8 0.7-1.3t1.4-0.5q0.2 0 0.5 0l10 2.2 4.8 0.8q0 0 0.1 0t0 0q0.6 0 0.7-0.5t-0.3-0.8l-4.1-2.8q-0.8-0.5-0.9-1.4t0.4-1.6q0.6-0.9 1.6-0.9z m-1.6 4.5l4.1 2.8-4.8-0.8-0.1-0.1-0.8-0.8-5.4-5.8q0-0.1 0-0.1t-0.1-0.1q-0.5-0.7-0.4-1.6t0.9-1.4q0.6-0.5 1.5-0.4t1.4 0.8l3.2 3.2-0.1 0.1-0.1 0.1q-0.7 1-0.5 2.2t1.2 1.9z m19.8-10.1l0.3 5.9q0.1 1.7-0.2 3.3l-1.1 4.9q-0.3 1.3-1.5 1.9l-2.4 1.3q0.1-1.4-0.8-2.5l-3.3-3.8q-1.2-1.3-2.6-2.3l-5-3.3q-0.7-0.5-1.6-0.5-1.2 0-2 0.8l-5.3-6.9q-0.5-0.8-0.4-1.7t1-1.4q0.7-0.5 1.5-0.3t1.4 0.9l6 7.9-5.9-10.2q-0.4-0.8-0.2-1.7t1.1-1.3q0.7-0.4 1.6-0.1t1.3 1l5.3 9.4-3-7.6q-0.3-0.7-0.1-1.6t1-1.3q0.8-0.4 1.7-0.1t1.2 1.2l4.3 9.2 2.3 4.4q0.2 0.3 0.5 0.4t0.6-0.2 0.3-0.6l-0.3-5q0-0.9 0.6-1.6t1.5-0.6q0.9 0 1.5 0.6t0.7 1.5z' })
	        )
	    );
	};
	
	exports.default = FaSignLanguage;
	module.exports = exports['default'];

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSignOut = function FaSignOut(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.8 32.1q0 0.1 0 0.5t0 0.6 0 0.5-0.3 0.4-0.4 0.2h-7.2q-2.6 0-4.5-1.9t-1.9-4.5v-15.8q0-2.6 1.9-4.5t4.5-1.9h7.2q0.3 0 0.5 0.2t0.2 0.5q0 0.1 0 0.5t0 0.6 0 0.5-0.3 0.4-0.4 0.2h-7.2q-1.4 0-2.5 1t-1 2.5v15.8q0 1.4 1 2.5t2.5 1h7l0.2 0.1 0.3 0 0.2 0.1 0.1 0.2 0.1 0.3z m20.7-12.1q0 0.6-0.4 1l-12.2 12.1q-0.4 0.5-1 0.5t-1-0.5-0.4-1v-6.4h-10q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h10v-6.4q0-0.6 0.4-1t1-0.5 1 0.5l12.2 12.1q0.4 0.4 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaSignOut;
	module.exports = exports['default'];

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSignal = function FaSignal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm5.7 32.1v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m8.6-2.8v7.1q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-7.1q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m8.6-5.7v12.8q0 0.3-0.2 0.5t-0.6 0.2h-4.2q-0.4 0-0.6-0.2t-0.2-0.5v-12.8q0-0.3 0.2-0.5t0.6-0.2h4.2q0.4 0 0.6 0.2t0.2 0.5z m8.5-8.6v21.4q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-21.4q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m8.6-11.4v32.8q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-32.8q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaSignal;
	module.exports = exports['default'];

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSimplybuilt = function FaSimplybuilt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.8 22.6q0-2.1-1.6-3.7t-3.7-1.5-3.7 1.5-1.6 3.7 1.6 3.7 3.7 1.6 3.7-1.6 1.6-3.7z m16.7 0q0-2.2-1.5-3.7t-3.7-1.5-3.8 1.5-1.5 3.7q0 2.2 1.5 3.7t3.8 1.6 3.7-1.6 1.5-3.7z m6.3-15.7v26.2q0 0.8-0.7 1.4t-1.4 0.7h-35.6q-0.9 0-1.5-0.7t-0.6-1.4v-26.2q0-0.8 0.6-1.4t1.5-0.7h8.4q0.8 0 1.4 0.7t0.7 1.4v3.1h14.6v-3.1q0-0.8 0.6-1.4t1.5-0.7h8.4q0.8 0 1.4 0.7t0.7 1.4z' })
	        )
	    );
	};
	
	exports.default = FaSimplybuilt;
	module.exports = exports['default'];

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSitemap = function FaSitemap(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 27.9v7.1q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-7.1q0-0.9 0.6-1.6t1.5-0.6h2.2v-4.3h-11.5v4.3h2.2q0.9 0 1.5 0.6t0.6 1.6v7.1q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-7.1q0-0.9 0.6-1.6t1.5-0.6h2.2v-4.3h-11.5v4.3h2.2q0.9 0 1.5 0.6t0.6 1.6v7.1q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-7.1q0-0.9 0.6-1.6t1.5-0.6h2.2v-4.3q0-1.1 0.8-2t2-0.8h11.5v-4.3h-2.2q-0.9 0-1.5-0.6t-0.6-1.6v-7.1q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5v7.1q0 0.9-0.6 1.6t-1.5 0.6h-2.2v4.3h11.5q1.1 0 2 0.8t0.8 2v4.3h2.2q0.9 0 1.5 0.6t0.6 1.6z' })
	        )
	    );
	};
	
	exports.default = FaSitemap;
	module.exports = exports['default'];

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSkyatlas = function FaSkyatlas(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.8 17.9q2.9 0 4.9 1.9t2.1 4.7q0 3.1-2.2 5.1t-5.1 2q-1.7 0-3.2-0.5t-2.7-1.4-2.3-2.1-2.1-2.4-2-2.6-2.1-2.4-2.3-2.1-2.6-1.4-3.1-0.6q-3 0-4.9 1.8t-1.9 4.8q0 3 2.1 4.8t5.1 1.8q1.9 0 4-0.7t3.7-1.9q0.1-0.1 0.5-0.4t0.5-0.5 0.5-0.1q0.2 0 0.4 0.2t0.2 0.4q0 0.5-1.1 1.5-2 1.7-4.6 2.8t-5 1q-2.6 0-4.8-1.1t-3.5-3.2-1.3-4.7q0-3.9 2.7-6.6t6.8-2.6q2.3 0 4.4 0.8t3.6 2.2 2.9 3 2.7 3.2 2.6 3 2.9 2.2 3.4 0.9q1.9 0 3.2-1.2t1.3-3.2q0-1.8-1.2-3.1t-3.1-1.2q-0.6 0-1.6 0.3t-1.3 0.4q-0.4 0-0.7-0.3t-0.3-0.7q0-0.3 0.1-1.1t0.2-1.1q0-3.1-2.1-5.1t-5.1-2.1q-1.2 0-2.2 0.4t-1.6 0.8-1.1 0.8-0.7 0.3q-0.3 0-0.5-0.2t-0.2-0.5q0-0.3 0.5-0.9 1.2-1.3 2.9-2t3.5-0.7q3.7 0 6.2 2.5t2.5 6.1q0 0.7-0.1 1.3 1.1-0.3 2.2-0.3z' })
	        )
	    );
	};
	
	exports.default = FaSkyatlas;
	module.exports = exports['default'];

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSkype = function FaSkype(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.2 23.7q0-1.1-0.5-2t-1-1.5-1.7-1.1-1.8-0.8-2-0.5l-2.3-0.5q-0.6-0.2-1-0.3t-0.7-0.2-0.7-0.4-0.4-0.5-0.1-0.6q0-1.7 3.2-1.7 0.9 0 1.7 0.2t1.2 0.7 0.8 0.7 0.9 0.6 1.1 0.3q1.1 0 1.7-0.7t0.6-1.7q0-1.2-1.2-2.2t-3.2-1.5-4.1-0.6q-1.5 0-2.9 0.4t-2.7 1-2 2-0.7 2.8q0 1.4 0.4 2.4t1.3 1.7 1.8 1.1 2.3 0.7l3.2 0.8q2 0.5 2.5 0.8 0.7 0.5 0.7 1.4 0 0.8-0.9 1.4t-2.3 0.6q-1.1 0-2.1-0.4t-1.4-0.8-1-1-1-0.9-1.3-0.4q-1.1 0-1.6 0.7t-0.6 1.7q0 2 2.7 3.5t6.5 1.5q1.6 0 3.1-0.5t2.8-1.1 2-2.1 0.7-3z m8.1 4.9q0 3.5-2.5 6t-6.1 2.5q-2.9 0-5.2-1.7-1.7 0.3-3.4 0.3-3.1 0-6.1-1.2t-5-3.4-3.3-5-1.3-6.1q0-1.6 0.4-3.4-1.8-2.3-1.8-5.2 0-3.5 2.5-6t6.1-2.5q2.9 0 5.2 1.7 1.7-0.3 3.3-0.3 3.2 0 6.1 1.2t5.1 3.4 3.3 5 1.3 6.1q0 1.6-0.4 3.3 1.8 2.4 1.8 5.3z' })
	        )
	    );
	};
	
	exports.default = FaSkype;
	module.exports = exports['default'];

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSlack = function FaSlack(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.4 17.3q1.4 0 2.3 0.9t0.9 2.3q0 2.2-2 2.9l-3.9 1.3 1.3 3.7q0.1 0.5 0.1 1.1 0 1.3-0.9 2.3t-2.3 0.9q-1 0-1.9-0.6t-1.2-1.6l-1.2-3.7-6.9 2.4 1.2 3.7q0.2 0.5 0.2 1 0 1.3-0.9 2.3t-2.3 0.9q-1.1 0-1.9-0.6t-1.2-1.6l-1.2-3.6-3.4 1.2q-0.7 0.2-1.2 0.2-1.3 0-2.2-0.9t-0.9-2.3q0-1 0.6-1.9t1.6-1.1l3.5-1.2-2.4-7-3.5 1.2q-0.5 0.2-1 0.2-1.4 0-2.3-0.9t-0.9-2.3q0-1 0.6-1.9t1.6-1.2l3.5-1.1-1.2-3.6q-0.1-0.5-0.1-1 0-1.4 0.9-2.3t2.3-1q1 0 1.9 0.6t1.1 1.6l1.3 3.6 6.9-2.3-1.2-3.6q-0.2-0.5-0.2-1.1 0-1.3 0.9-2.2t2.3-1q1.1 0 1.9 0.6t1.2 1.6l1.2 3.6 3.6-1.2q0.5-0.2 1-0.2 1.3 0 2.3 0.9t0.9 2.2q0 1-0.7 1.8t-1.6 1.2l-3.5 1.2 2.3 7.1 3.7-1.3q0.5-0.2 1-0.2z m-17.7 5.9l6.9-2.4-2.3-7-7 2.4z' })
	        )
	    );
	};
	
	exports.default = FaSlack;
	module.exports = exports['default'];

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSliders = function FaSliders(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10.9 31.4v2.9h-7.9v-2.9h7.9z m7.8-2.8q0.6 0 1 0.4t0.4 1v5.7q0 0.6-0.4 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.4h5.7z m3.6-8.6v2.9h-19.3v-2.9h19.3z m-14.3-11.4v2.8h-5v-2.8h5z m29.3 22.8v2.9h-16.4v-2.9h16.4z m-21.4-25.7q0.5 0 1 0.4t0.4 1v5.8q0 0.5-0.4 1t-1 0.4h-5.8q-0.5 0-1-0.4t-0.4-1v-5.8q0-0.5 0.4-1t1-0.4h5.8z m14.2 11.4q0.6 0 1 0.5t0.5 1v5.7q0 0.6-0.5 1t-1 0.4h-5.7q-0.5 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.5h5.7z m7.2 2.9v2.9h-5v-2.9h5z m0-11.4v2.8h-19.3v-2.8h19.3z' })
	        )
	    );
	};
	
	exports.default = FaSliders;
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSlideshare = function FaSlideshare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.5 16.5q0 1.9-1.4 3.2t-3.4 1.3-3.4-1.3-1.5-3.2q0-1.9 1.5-3.2t3.4-1.3 3.4 1.3 1.4 3.2z m11.2 0q0 1.9-1.4 3.2t-3.4 1.3q-2 0-3.4-1.3t-1.4-3.2q0-1.9 1.4-3.2t3.4-1.3q2 0 3.4 1.3t1.4 3.2z m5 4v-14.9q0-1.9-0.7-2.7t-2.5-0.8h-24.8q-1.9 0-2.5 0.7t-0.7 2.8v15.1q1 0.5 2 0.9t1.8 0.6 1.8 0.4 1.6 0.2 1.6 0.1 1.3 0 1.2 0 1 0q1.6-0.1 2.2 0.6 0.1 0.1 0.2 0.2 0.6 0.5 1.3 1.1 0.2-2 2.7-1.9 0.1 0 0.8 0t0.9 0 1.1 0.1 1.1-0.1 1.3-0.1 1.3-0.2 1.4-0.3 1.5-0.4 1.5-0.6 1.6-0.8z m3.7-0.1q-2.7 3.4-8.4 5.6 1.9 6.4-0.5 10.4-1.4 2.5-4.1 3.3-2.3 0.7-4-0.3-1.9-1.1-1.8-3.7l-0.1-7.2v-0.1q-0.1 0-0.5-0.1t-0.5-0.1l-0.1 7.5q0.1 2.6-1.8 3.7-1.8 1-4.1 0.3-2.6-0.8-4.1-3.3-2.3-4-0.5-10.4-5.6-2.3-8.3-5.6-0.5-0.8 0-1.4t1.3 0q0.1 0.1 0.2 0.2t0.3 0.2v-15.5q0-1.6 1-2.8t2.6-1.1h28q1.5 0 2.6 1.1t1 2.8v15.5l0.5-0.4q0.9-0.6 1.3 0t0 1.4z' })
	        )
	    );
	};
	
	exports.default = FaSlideshare;
	module.exports = exports['default'];

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSmileO = function FaSmileO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.3 24q-0.8 2.7-3.1 4.3t-5.1 1.7-5-1.6-3.1-4.4q-0.2-0.6 0.1-1.1t0.8-0.7q0.6-0.2 1.1 0.1t0.7 0.8q0.6 1.8 2.1 2.9t3.3 1.1 3.4-1.1 2.1-2.9q0.2-0.5 0.7-0.8t1.1-0.1 0.8 0.7 0.1 1.1z m-11-9.7q0 1.2-0.9 2t-2 0.8-2-0.8-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m11.4 0q0 1.2-0.8 2t-2 0.8-2.1-0.8-0.8-2 0.8-2 2.1-0.9 2 0.9 0.8 2z m5.7 5.7q0-2.9-1.1-5.5t-3.1-4.6-4.5-3.1-5.6-1.1-5.5 1.1-4.6 3.1-3 4.6-1.1 5.5 1.1 5.5 3 4.6 4.6 3 5.5 1.2 5.6-1.2 4.5-3 3.1-4.6 1.1-5.5z m2.9 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaSmileO;
	module.exports = exports['default'];

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSnapchatGhost = function FaSnapchatGhost(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.4 2.9q3-0.1 5.4 1.5t3.6 4.3q0.7 1.3 0.7 4 0 1-0.2 4.2 0.3 0.2 0.6 0.2 0.4 0 1.1-0.3t1.2-0.3q0.6 0 1.2 0.4t0.6 1q0 0.7-0.7 1.2t-1.5 0.7-1.6 0.7-0.7 1q0 0.4 0.3 1 0.8 1.8 2.3 3.3t3.2 2.3q0.6 0.3 1.8 0.5 0.6 0.1 0.6 0.8 0 1.6-4.9 2.3-0.1 0.2-0.2 0.9t-0.3 1-0.8 0.4q-0.4 0-1.4-0.1t-1.4-0.2q-0.8 0-1.4 0.1-0.7 0.1-1.4 0.5t-1.3 0.9-1.3 0.9-1.7 0.7-2.2 0.3q-1.1 0-2.1-0.3t-1.7-0.7-1.3-0.9-1.3-0.9-1.4-0.5q-0.5-0.1-1.4-0.1-0.5 0-1.4 0.2t-1.3 0.2q-0.6 0-0.8-0.5t-0.3-1-0.3-0.9q-4.9-0.7-4.9-2.3 0-0.7 0.7-0.8 1.1-0.2 1.7-0.5 1.8-0.7 3.3-2.3t2.3-3.3q0.2-0.6 0.2-1 0-0.6-0.7-1t-1.5-0.7-1.6-0.7-0.7-1.2q0-0.6 0.6-1t1.2-0.4q0.4 0 1.1 0.3t1.2 0.3q0.4 0 0.7-0.2-0.2-3.1-0.2-4.2 0-2.7 0.6-4 1.4-3.1 3.8-4.4t5.9-1.4z' })
	        )
	    );
	};
	
	exports.default = FaSnapchatGhost;
	module.exports = exports['default'];

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSnapchatSquare = function FaSnapchatSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 25.6q0-0.5-0.5-0.6-1.5-0.3-2.7-1.3t-1.7-2.4q-0.2-0.3-0.2-0.6 0-0.3 0.4-0.5t1-0.4 0.9-0.5 0.5-0.8q0-0.4-0.4-0.7t-0.9-0.3q-0.2 0-0.7 0.2t-0.7 0.2q-0.1 0-0.3-0.1 0.1-1.4 0.1-2.5 0-1.8-0.3-2.6-0.8-1.7-2.3-2.7t-3.4-1q-4.5 0-6.2 3.7-0.4 0.9-0.4 2.6 0 0.8 0.2 2.5-0.3 0.1-0.4 0.1-0.2 0-0.7-0.2t-0.7-0.2q-0.4 0-0.8 0.3t-0.4 0.7q0 0.5 0.4 0.8t1 0.5 0.9 0.4 0.5 0.5q0 0.3-0.2 0.6-1.4 3.1-4.4 3.7-0.5 0.1-0.5 0.6 0 1.1 3.1 1.6 0 0.1 0.1 0.5t0.3 0.7 0.5 0.2q0.3 0 0.8-0.1t0.9-0.1q0.8 0 1.5 0.4t1.2 0.7 1.3 0.7 1.7 0.3q1 0 1.8-0.3t1.3-0.7 1.2-0.7 1.5-0.4q0.3 0 0.8 0.1t0.9 0.1q0.4 0 0.5-0.2t0.3-0.7 0.1-0.5q3.1-0.5 3.1-1.6z m5.7-16.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaSnapchatSquare;
	module.exports = exports['default'];

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSnapchat = function FaSnapchat(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 25.6q0-0.5-0.5-0.6-1.5-0.3-2.7-1.3t-1.8-2.4q-0.1-0.4-0.1-0.6 0-0.3 0.4-0.5t1-0.4 0.9-0.5 0.5-0.8q0-0.4-0.4-0.7t-0.9-0.3q-0.3 0-0.7 0.2t-0.7 0.2q-0.1 0-0.3-0.1 0.1-2.1 0.1-2.5 0-1.8-0.3-2.6-0.8-1.7-2.3-2.7t-3.4-0.9q-4.5 0-6.2 3.6-0.4 0.8-0.4 2.6 0 0.4 0.2 2.5-0.1 0.1-0.4 0.1-0.2 0-0.7-0.2t-0.6-0.2q-0.5 0-0.9 0.3t-0.4 0.7q0 0.5 0.4 0.8t1 0.5 1 0.4 0.4 0.5q0 0.2-0.2 0.6-1.4 3.1-4.4 3.7-0.5 0.1-0.5 0.6 0 1.1 3.1 1.5 0 0.2 0.1 0.6t0.3 0.7 0.5 0.2q0.3 0 0.8-0.1t0.9-0.1q0.8 0 1.5 0.4t1.2 0.7 1.3 0.7 1.7 0.3q1 0 1.8-0.3t1.3-0.7 1.2-0.7 1.5-0.4q0.3 0 0.8 0.1t0.9 0.1q0.3 0 0.5-0.2t0.3-0.7 0.1-0.6q3-0.4 3-1.5z m5.7-5.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaSnapchat;
	module.exports = exports['default'];

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortAlphaAsc = function FaSortAlphaAsc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.6 9.1h3.9l-1.6-4.9-0.2-1q-0.1-0.4-0.1-0.5h-0.1l0 0.5q0 0-0.1 0.4t-0.2 0.6z m-10.2 23q0 0.3-0.2 0.6l-7.1 7.1q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.2-7.1q-0.3-0.4-0.1-0.8 0.1-0.5 0.6-0.5h4.3v-30.7q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v30.7h4.3q0.3 0 0.5 0.2t0.2 0.5z m18.7 2.7v5.2h-13v-2l8.2-11.8q0.3-0.4 0.5-0.6l0.2-0.2v-0.1q0 0-0.1 0t-0.2 0q-0.3 0.1-0.7 0.1h-5.2v2.6h-2.6v-5.1h12.6v1.9l-8.2 11.9q-0.2 0.2-0.5 0.6l-0.2 0.2v0l0.3 0q0.2 0 0.7 0h5.5v-2.7h2.7z m2-20v2.3h-6.5v-2.3h1.7l-1-3.2h-5.5l-1 3.2h1.7v2.3h-6.4v-2.3h1.5l5.2-14.8h3.6l5.1 14.8h1.6z' })
	        )
	    );
	};
	
	exports.default = FaSortAlphaAsc;
	module.exports = exports['default'];

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortAlphaDesc = function FaSortAlphaDesc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.6 32h3.9l-1.6-4.9-0.2-1.1q-0.1-0.3-0.1-0.4h-0.1l0 0.4q0 0.1-0.1 0.4t-0.2 0.7z m-10.2 0.1q0 0.3-0.2 0.6l-7.1 7.1q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.2-7.1q-0.3-0.4-0.1-0.8 0.1-0.5 0.6-0.5h4.3v-30.7q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v30.7h4.3q0.3 0 0.5 0.2t0.2 0.5z m20.7 5.5v2.4h-6.5v-2.4h1.7l-1-3.2h-5.5l-1 3.2h1.7v2.4h-6.4v-2.4h1.5l5.2-14.7h3.6l5.1 14.7h1.6z m-2-25.7v5.2h-13v-2l8.2-11.8q0.3-0.4 0.5-0.6l0.2-0.2v0q0 0-0.1 0t-0.2 0q-0.3 0-0.7 0h-5.2v2.6h-2.6v-5.1h12.6v2l-8.2 11.8q-0.2 0.2-0.5 0.6l-0.2 0.2v0.1l0.3-0.1q0.2 0 0.7 0h5.5v-2.7h2.7z' })
	        )
	    );
	};
	
	exports.default = FaSortAlphaDesc;
	module.exports = exports['default'];

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortAmountAsc = function FaSortAmountAsc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16 31.8q0 0.3-0.2 0.6l-6.9 6.9q-0.3 0.2-0.5 0.2-0.3 0-0.5-0.2l-7-7q-0.3-0.3-0.2-0.7 0.2-0.4 0.7-0.4h4.2v-30q0-0.3 0.2-0.5t0.5-0.2h4.2q0.3 0 0.5 0.2t0.2 0.5v30h4.1q0.3 0 0.5 0.1t0.2 0.5z m23 2.8v4.2q0 0.3-0.2 0.5t-0.5 0.2h-18.1q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h18.1q0.3 0 0.5 0.2t0.2 0.5z m-4.2-11.1v4.2q0 0.3-0.2 0.5t-0.5 0.2h-13.9q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h13.9q0.4 0 0.5 0.2t0.2 0.5z m-4.1-11.2v4.2q0 0.3-0.2 0.5t-0.5 0.2h-9.8q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h9.8q0.3 0 0.5 0.2t0.2 0.5z m-4.2-11.1v4.2q0 0.3-0.2 0.5t-0.5 0.2h-5.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h5.6q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaSortAmountAsc;
	module.exports = exports['default'];

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortAmountDesc = function FaSortAmountDesc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.5 34.6v4.2q0 0.3-0.2 0.5t-0.5 0.2h-5.6q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h5.6q0.3 0 0.5 0.2t0.2 0.5z m-10.5-2.8q0 0.3-0.2 0.6l-6.9 6.9q-0.3 0.2-0.5 0.2-0.3 0-0.5-0.2l-7-7q-0.3-0.3-0.2-0.7 0.2-0.4 0.7-0.4h4.2v-30q0-0.3 0.2-0.5t0.5-0.2h4.2q0.3 0 0.5 0.2t0.2 0.5v30h4.1q0.3 0 0.5 0.1t0.2 0.5z m14.7-8.3v4.2q0 0.3-0.2 0.5t-0.5 0.2h-9.8q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h9.8q0.3 0 0.5 0.2t0.2 0.5z m4.1-11.2v4.2q0 0.3-0.2 0.5t-0.5 0.2h-13.9q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h13.9q0.4 0 0.5 0.2t0.2 0.5z m4.2-11.1v4.2q0 0.3-0.2 0.5t-0.5 0.2h-18.1q-0.3 0-0.5-0.2t-0.2-0.5v-4.2q0-0.3 0.2-0.5t0.5-0.2h18.1q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaSortAmountDesc;
	module.exports = exports['default'];

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortAsc = function FaSortAsc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 15.7q0 0.6-0.5 1t-1 0.4h-20q-0.6 0-1-0.4t-0.4-1 0.4-1l10-10q0.4-0.4 1-0.4t1 0.4l10 10q0.5 0.4 0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaSortAsc;
	module.exports = exports['default'];

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortDesc = function FaSortDesc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 24.3q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.4-0.4-0.4-1t0.4-1 1-0.4h20q0.6 0 1 0.4t0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaSortDesc;
	module.exports = exports['default'];

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortNumericAsc = function FaSortNumericAsc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33 29.3q0-1.4-0.9-2.6t-2.3-1.2q-1.2 0-1.9 0.9t-0.7 2.1 0.8 2.1 2.4 0.8q1.1 0 1.9-0.6t0.7-1.5z m-13.6 2.8q0 0.3-0.2 0.6l-7.1 7.1q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.2-7.1q-0.3-0.4-0.1-0.8 0.1-0.5 0.6-0.5h4.3v-30.7q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v30.7h4.3q0.3 0 0.5 0.2t0.2 0.5z m16.8-1.5q0 1.4-0.3 2.7t-0.9 2.6-1.6 2.1-2.2 1.5-2.8 0.5q-1.4 0-2.4-0.4-0.5-0.1-0.9-0.3l0.8-2.5q0.4 0.1 0.7 0.2 0.8 0.3 1.7 0.3 1.9 0 3-1.3t1.5-3.2h-0.1q-0.4 0.5-1.3 0.8t-1.9 0.3q-2.4 0-3.9-1.6t-1.5-3.8q0-2.4 1.6-4t4.1-1.6q2.7 0 4.5 2.1t1.9 5.6z m-0.7-16v2.5h-10.5v-2.5h3.8v-9.6q0-0.2 0-0.5t0-0.3v-0.4h-0.1l-0.1 0.3q-0.2 0.3-0.6 0.7l-1.4 1.2-1.8-1.9 4.3-4.1h2.7v14.6h3.7z' })
	        )
	    );
	};
	
	exports.default = FaSortNumericAsc;
	module.exports = exports['default'];

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSortNumericDesc = function FaSortNumericDesc(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33 6.5q0-1.5-0.9-2.6t-2.3-1.2q-1.2 0-1.9 0.8t-0.7 2.1 0.8 2.1 2.4 0.9q1.1 0 1.9-0.6t0.7-1.6z m-13.6 25.6q0 0.3-0.2 0.6l-7.1 7.1q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2l-7.2-7.1q-0.3-0.4-0.1-0.8 0.1-0.5 0.6-0.5h4.3v-30.7q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5v30.7h4.3q0.3 0 0.5 0.2t0.2 0.5z m16.1 5.4v2.5h-10.5v-2.5h3.8v-9.7q0-0.1 0-0.4t0-0.4v-0.3h-0.1l-0.1 0.2q-0.2 0.3-0.6 0.7l-1.4 1.3-1.8-1.9 4.3-4.1h2.7v14.6h3.7z m0.7-29.8q0 1.4-0.3 2.8t-0.9 2.5-1.6 2.1-2.2 1.5-2.8 0.5q-1.4 0-2.4-0.3-0.5-0.2-0.9-0.3l0.8-2.6q0.4 0.2 0.7 0.3 0.8 0.3 1.7 0.3 1.9 0 3-1.3t1.5-3.3h-0.1q-0.4 0.5-1.3 0.8t-1.9 0.4q-2.4 0-3.9-1.6t-1.5-3.9q0-2.3 1.6-4t4.1-1.6q2.7 0 4.5 2.1t1.9 5.6z' })
	        )
	    );
	};
	
	exports.default = FaSortNumericDesc;
	module.exports = exports['default'];

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSort = function FaSort(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.4 24.3q0 0.6-0.5 1l-10 10q-0.4 0.4-1 0.4t-1-0.4l-10-10q-0.4-0.4-0.4-1t0.4-1 1-0.4h20q0.6 0 1 0.4t0.5 1z m0-8.6q0 0.6-0.5 1t-1 0.4h-20q-0.6 0-1-0.4t-0.4-1 0.4-1l10-10q0.4-0.4 1-0.4t1 0.4l10 10q0.5 0.4 0.5 1z' })
	        )
	    );
	};
	
	exports.default = FaSort;
	module.exports = exports['default'];

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSoundcloud = function FaSoundcloud(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.7 28.3l0.3-4.2-0.3-9.1q0-0.2-0.1-0.3t-0.3-0.2q-0.2 0-0.3 0.2t-0.1 0.3l-0.2 9.1 0.2 4.2q0 0.2 0.1 0.3t0.3 0.1q0.4 0 0.4-0.4z m5.2-0.5l0.2-3.7-0.2-10.2q0-0.3-0.2-0.4-0.2-0.1-0.3-0.1t-0.3 0.1q-0.2 0.1-0.2 0.4l0 0.1-0.2 10.1q0 0 0.2 4.1v0.1q0 0.1 0.1 0.3 0.1 0.2 0.4 0.2 0.2 0 0.3-0.2 0.2-0.1 0.2-0.4z m-18.3-5.9l0.4 2.2-0.4 2.2q0 0.2-0.1 0.2t-0.2-0.2l-0.3-2.2 0.3-2.2q0-0.2 0.2-0.2t0.1 0.2z m1.5-1.4l0.5 3.6-0.5 3.6q0 0.1-0.2 0.1-0.1 0-0.1-0.1l-0.4-3.6 0.4-3.6q0-0.2 0.1-0.2 0.2 0 0.2 0.2z m1.6-0.7l0.5 4.3-0.5 4.2q0 0.2-0.2 0.2-0.1 0-0.2-0.2l-0.3-4.2 0.3-4.3q0.1-0.2 0.2-0.2 0.2 0 0.2 0.2z m1.7-0.1l0.4 4.4-0.4 4.3q-0.1 0.2-0.3 0.2-0.2 0-0.2-0.2l-0.4-4.3 0.4-4.4q0-0.2 0.2-0.2 0.2 0 0.3 0.2z m1.6 0.3l0.4 4.1-0.4 4.3q0 0.3-0.3 0.3-0.1 0-0.1-0.1t-0.1-0.2l-0.4-4.3 0.4-4.1q0-0.1 0.1-0.2t0.1 0q0.3 0 0.3 0.2z m1.7-2.5l0.3 6.6-0.3 4.3q0 0.1-0.1 0.2t-0.2 0.1q-0.3 0-0.3-0.3l-0.4-4.3 0.4-6.6q0-0.4 0.3-0.4 0.1 0 0.2 0.1t0.1 0.3z m1.6-1.5l0.3 8.1-0.3 4.3q0 0.2-0.1 0.3t-0.2 0.1q-0.3 0-0.4-0.4l-0.2-4.3 0.2-8.1q0.1-0.4 0.4-0.4 0.1 0 0.2 0.1t0.1 0.3z m1.7-0.7l0.3 8.8-0.3 4.3q0 0.3-0.4 0.3-0.3 0-0.3-0.3l-0.3-4.3 0.3-8.8q0-0.2 0.1-0.3t0.2-0.1q0.2 0 0.3 0.1t0.1 0.3z m6.9 12.9z m-3.5-13l0.3 8.9-0.3 4.2q0 0.2-0.1 0.3t-0.3 0.1-0.3-0.1-0.2-0.3l-0.2-4.2 0.2-8.9q0-0.2 0.2-0.3t0.3-0.2 0.3 0.2 0.1 0.3z m1.8 0.3l0.2 8.6-0.2 4.2q0 0.2-0.2 0.3t-0.3 0.1-0.3-0.1-0.2-0.3l-0.2-4.2 0.2-8.6q0-0.2 0.2-0.3t0.3-0.2 0.3 0.2 0.2 0.3z m3.7 8.6l-0.3 4.1q0 0.2-0.1 0.4t-0.4 0.1-0.4-0.1-0.2-0.4l-0.1-2-0.1-2.1 0.2-11.1v-0.1q0.1-0.2 0.2-0.4 0.2-0.1 0.4-0.1 0.1 0 0.2 0.1 0.3 0.1 0.3 0.4z m19.4-0.3q0 2-1.4 3.5t-3.5 1.4h-13.8q-0.2 0-0.4-0.2t-0.1-0.3v-15.8q0-0.4 0.5-0.6 1.5-0.6 3.1-0.6 3.5 0 6 2.3t2.8 5.7q0.9-0.4 1.9-0.4 2 0 3.5 1.5t1.4 3.5z' })
	        )
	    );
	};
	
	exports.default = FaSoundcloud;
	module.exports = exports['default'];

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSpaceShuttle = function FaSpaceShuttle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.3 24.1q-2 1.1-4.9 1.1h-2.3v-1.1h-1.2q-0.2 0-0.4-0.4t-0.2-1.1q0-0.4 0.2-0.9-1.1 0-1.8-0.2t-0.7-0.3 0.7-0.4 1.8-0.2q-0.2-0.5-0.2-0.9 0-0.6 0.2-1t0.4-0.5h1.2v-1.1h2.3q2.9 0 4.9 1.1h20.3q0.7 0.2 1.9 0.4t1.5 0.2q1.6 0.3 2.7 0.8t1.5 0.8 0.4 0.8-0.4 0.7-1.5 0.9-2.7 0.7q-0.3 0.1-1.5 0.3t-1.9 0.3h-20.3z m20.4-4.6q1 0.6 1 1.7t-1 1.6l1.5 0.6q1.2-0.9 1.2-2.2t-1.2-2.3z m-20.3 4.9h18.5q-4 0.7-8.3 1.4-1.1 0-2.1 0.5t-1.5 0.8l-0.5 0.5-5.3 5.2q-0.4 0.5-1.2 0.8t-1.7 0.4h-1.7l-1.7-8.5h0.5q2.9 0 5-1.1z m-5-7.6h-0.5l1.7-8.5h1.7q0.9 0 1.7 0.4t1.2 0.8l5.3 5.3q0.1 0 0.2 0.1t0.5 0.5 0.9 0.5 1.2 0.4 1.3 0.2l8.3 1.5h-18.5q-2.1-1.2-5-1.2z' })
	        )
	    );
	};
	
	exports.default = FaSpaceShuttle;
	module.exports = exports['default'];

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSpinner = function FaSpinner(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.7 31.1q0 1.2-0.8 2t-2 0.9q-1.2 0-2-0.9t-0.9-2q0-1.2 0.9-2t2-0.8 2 0.8 0.8 2z m11.2 4.6q0 1.2-0.9 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.8 2 0.8 0.9 2z m-15.8-15.7q0 1.2-0.8 2t-2 0.9-2-0.9-0.9-2 0.9-2 2-0.9 2 0.9 0.8 2z m26.9 11.1q0 1.2-0.9 2t-2 0.9q-1.2 0-2-0.9t-0.8-2 0.8-2 2-0.8 2 0.8 0.9 2z m-21.5-22.2q0 1.5-1.1 2.5t-2.5 1.1-2.5-1.1-1.1-2.5 1.1-2.5 2.5-1.1 2.5 1.1 1.1 2.5z m26.1 11.1q0 1.2-0.9 2t-2 0.9-2-0.9-0.8-2 0.8-2 2-0.9 2 0.9 0.9 2z m-14.3-15.7q0 1.8-1.3 3t-3 1.3-3-1.3-1.3-3 1.3-3.1 3-1.2 3 1.3 1.3 3z m11.8 4.6q0 2.1-1.5 3.5t-3.5 1.5q-2.1 0-3.5-1.5t-1.5-3.5q0-2.1 1.5-3.5t3.5-1.5q2.1 0 3.5 1.5t1.5 3.5z' })
	        )
	    );
	};
	
	exports.default = FaSpinner;
	module.exports = exports['default'];

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSpoon = function FaSpoon(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.2 11.8q0 3.2-1.3 5.4t-3.4 3l1.1 18.4q0 0.6-0.4 1t-1 0.4h-4.3q-0.6 0-1-0.4t-0.3-1l1-18.4q-2.1-0.8-3.4-3t-1.3-5.4q0-2.9 1-5.6t2.6-4.4 3.6-1.8 3.5 1.8 2.7 4.4 0.9 5.6z' })
	        )
	    );
	};
	
	exports.default = FaSpoon;
	module.exports = exports['default'];

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSpotify = function FaSpotify(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.2 27q0-0.7-0.7-1.1-4.3-2.6-10-2.6-3 0-6.4 0.8-0.9 0.2-0.9 1.1 0 0.5 0.3 0.8t0.8 0.3q0.1 0 0.8-0.2 2.9-0.6 5.4-0.6 5.1 0 8.9 2.3 0.4 0.3 0.7 0.3 0.4 0 0.7-0.3t0.4-0.8z m2.1-4.8q0-0.9-0.8-1.4-5.3-3.1-12.2-3.1-3.4 0-6.8 0.9-1 0.3-1 1.5 0 0.5 0.3 0.9t1 0.4q0.1 0 0.8-0.2 2.7-0.7 5.6-0.7 6.2 0 10.9 2.8 0.5 0.3 0.9 0.3 0.5 0 0.9-0.4t0.4-1z m2.4-5.5q0-1.1-0.9-1.6-2.8-1.6-6.5-2.5t-7.7-0.8q-4.5 0-8.1 1.1-0.5 0.1-0.9 0.5t-0.3 1.1q0 0.7 0.5 1.2t1.1 0.4q0.2 0 0.9-0.1 3-0.9 6.8-0.9 3.6 0 7 0.8t5.6 2.1q0.5 0.3 0.9 0.3 0.7 0 1.1-0.5t0.5-1.1z m4.6 3.3q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaSpotify;
	module.exports = exports['default'];

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSquareO = function FaSquareO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.5 5.7h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-18.6q0-1.5-1.1-2.5t-2.5-1.1z m6.4 3.6v18.6q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q2.7 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaSquareO;
	module.exports = exports['default'];

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSquare = function FaSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 9.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaSquare;
	module.exports = exports['default'];

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStackExchange = function FaStackExchange(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.6 28v1.4q0 1.9-1.3 3.3t-3.1 1.3h-1.2l-5.8 6v-6h-11.9q-1.8 0-3-1.3t-1.3-3.3v-1.4h27.6z m0-7.3v5.7h-27.6v-5.7h27.6z m0-7.3v5.7h-27.6v-5.7h27.6z m0-3.2v1.5h-27.6v-1.5q0-1.8 1.3-3.2t3-1.3h18.9q1.8 0 3.1 1.3t1.3 3.2z' })
	        )
	    );
	};
	
	exports.default = FaStackExchange;
	module.exports = exports['default'];

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStackOverflow = function FaStackOverflow(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.8 36.4h-25v-10.7h-3.6v14.3h32.1v-14.3h-3.5v10.7z m-21.1-11.7l0.8-3.5 17.5 3.7-0.8 3.5z m2.3-8.3l1.5-3.3 16.2 7.6-1.5 3.2z m4.5-8l2.3-2.7 13.7 11.4-2.3 2.8z m8.9-8.4l10.6 14.3-2.8 2.2-10.7-14.4z m-16 32.8v-3.5h17.8v3.5h-17.8z' })
	        )
	    );
	};
	
	exports.default = FaStackOverflow;
	module.exports = exports['default'];

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStarHalfEmpty = function FaStarHalfEmpty(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28 21.4l5.7-5.6-9.4-1.4-0.7-1.3-3.5-7.2v21.5l1.3 0.7 7.1 3.7-1.4-7.9-0.2-1.5z m10.1-5.9l-8.1 7.9 1.9 11.2q0.1 0.7-0.2 1.1t-0.7 0.4q-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.6 0.2-0.9 0.2-0.6 0-0.8-0.4t-0.1-1.1l1.9-11.2-8.1-7.9q-0.8-0.7-0.6-1.3t1.3-0.8l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9 0.6 0 1.1 0.9l5 10.2 11.2 1.6q1 0.2 1.2 0.8t-0.5 1.3z' })
	        )
	    );
	};
	
	exports.default = FaStarHalfEmpty;
	module.exports = exports['default'];

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStarHalf = function FaStarHalf(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.1 0.7v29.9l-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9z' })
	        )
	    );
	};
	
	exports.default = FaStarHalf;
	module.exports = exports['default'];

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStarO = function FaStarO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.9 22.4l6.8-6.6-9.4-1.4-4.2-8.5-4.2 8.5-9.5 1.4 6.9 6.6-1.7 9.4 8.5-4.4 8.4 4.4z m11.7-8q0 0.5-0.5 1.1l-8.1 7.9 1.9 11.2q0 0.1 0 0.4 0 1.1-0.9 1.1-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9t1.1 0.9l5 10.2 11.2 1.6q1.2 0.2 1.2 1z' })
	        )
	    );
	};
	
	exports.default = FaStarO;
	module.exports = exports['default'];

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStar = function FaStar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 14.4q0 0.5-0.5 1.1l-8.1 7.9 1.9 11.2q0 0.1 0 0.4 0 0.5-0.2 0.8t-0.7 0.3q-0.4 0-0.9-0.2l-10-5.3-10 5.3q-0.5 0.2-0.9 0.2-0.5 0-0.7-0.3t-0.3-0.8q0-0.1 0.1-0.4l1.9-11.2-8.1-7.9q-0.6-0.6-0.6-1.1 0-0.8 1.3-1l11.2-1.6 5-10.2q0.4-0.9 1.1-0.9t1.1 0.9l5 10.2 11.2 1.6q1.2 0.2 1.2 1z' })
	        )
	    );
	};
	
	exports.default = FaStar;
	module.exports = exports['default'];

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSteamSquare = function FaSteamSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.7 14.4q0-1.7-1.2-3t-3.1-1.3-3.1 1.3-1.2 3q0 1.8 1.2 3.1t3.1 1.2 3.1-1.2 1.2-3.1z m-13.6 13.2q0 1.8-1.3 3.1t-3.1 1.3q-1.3 0-2.3-0.7t-1.6-1.7q1.1 0.5 2.2 0.9 1.3 0.5 2.6 0t1.9-2q0.6-1.3 0-2.6t-1.9-1.9l-1.8-0.7q0.4-0.2 0.9-0.2 1.8 0 3.1 1.3t1.3 3.2z m20.2-18.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-3.4l3.8 1.5q0.5 2.1 2.1 3.4t3.8 1.4q2.3 0 4-1.6t2-3.9l7.7-5.6q3.3 0 5.7-2.3t2.3-5.7q0-3.4-2.3-5.7t-5.7-2.4q-3.3 0-5.7 2.4t-2.4 5.6l-5 7.2q-0.2 0-0.6 0-1.7 0-3.1 0.8l-6.6-2.7v-10.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z m-5.5 5.2q0 2.2-1.6 3.8t-3.8 1.6-3.8-1.6-1.6-3.8 1.6-3.8 3.8-1.6q2.2 0 3.8 1.6t1.6 3.8z' })
	        )
	    );
	};
	
	exports.default = FaSteamSquare;
	module.exports = exports['default'];

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSteam = function FaSteam(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.3 13q0 2.2-1.6 3.8t-3.8 1.6-3.9-1.6-1.6-3.8 1.6-3.9 3.9-1.6 3.8 1.6 1.6 3.9z m-17.2 16.6q0-2.4-1.6-4t-4-1.6q-0.6 0-1.2 0.1l2.4 0.9q1.7 0.7 2.4 2.4t0 3.4q-0.7 1.7-2.3 2.4t-3.4 0.1q-0.5-0.2-1.4-0.6t-1.4-0.5q0.7 1.3 2 2.1t2.9 0.8q2.4 0 4-1.6t1.6-3.9z m18.6-16.6q0-2.8-2-4.8t-4.9-2q-2.8 0-4.8 2t-2 4.8q0 2.8 2 4.8t4.8 2q2.9 0 4.9-2t2-4.8z m3.3 0q0 4.2-3 7.2t-7.2 3l-9.7 7.1q-0.3 2.9-2.4 4.9t-5.2 1.9q-2.7 0-4.7-1.6t-2.7-4.3l-5.1-2.1v-9.6l8.7 3.5q1.7-1 3.8-1 0.3 0 0.8 0l6.4-9.1q0-4.1 3-7.1t7.1-2.9q4.2 0 7.2 2.9t3 7.2z' })
	        )
	    );
	};
	
	exports.default = FaSteam;
	module.exports = exports['default'];

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStepBackward = function FaStepBackward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.4 3.1q0.4-0.4 0.7-0.2t0.3 0.7v32.8q0 0.6-0.3 0.7t-0.7-0.2l-15.9-15.9q-0.2-0.2-0.3-0.4v15.1q0 0.6-0.4 1t-1 0.4h-2.9q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h2.9q0.6 0 1 0.4t0.4 1v15.1q0.1-0.2 0.3-0.4z' })
	        )
	    );
	};
	
	exports.default = FaStepBackward;
	module.exports = exports['default'];

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStepForward = function FaStepForward(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.5 36.9q-0.4 0.4-0.7 0.2t-0.3-0.7v-32.8q0-0.6 0.3-0.7t0.7 0.2l15.9 15.9q0.1 0.2 0.2 0.4v-15.1q0-0.6 0.5-1t1-0.4h2.8q0.6 0 1 0.4t0.5 1v31.4q0 0.6-0.5 1t-1 0.4h-2.8q-0.6 0-1-0.4t-0.5-1v-15.1q-0.1 0.2-0.2 0.4z' })
	        )
	    );
	};
	
	exports.default = FaStepForward;
	module.exports = exports['default'];

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStethoscope = function FaStethoscope(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.1 15.7q0-0.6-0.5-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m2.8 0q0 1.4-0.8 2.5t-2 1.6v8.8q0 3.5-3 6t-7 2.5-7.1-2.5-2.9-6v-3q-3.7-0.4-6.1-2.8t-2.5-5.7v-11.4q0-0.6 0.4-1t1-0.4q0.2 0 0.4 0 0.4-0.6 1-1t1.5-0.4q1.2 0 2 0.8t0.8 2-0.8 2-2 0.9q-0.8 0-1.4-0.4v8.9q0 2.4 2.1 4.1t5 1.7 5-1.7 2.1-4.1v-8.9q-0.6 0.4-1.4 0.4-1.2 0-2-0.9t-0.8-2 0.8-2 2-0.8q0.8 0 1.5 0.4t1 1q0.2 0 0.4 0 0.6 0 1 0.4t0.4 1v11.4q0 3.3-2.5 5.7t-6.1 2.8v3q0 2.3 2.1 4t5.1 1.7 5-1.7 2.1-4v-8.8q-1.3-0.5-2.1-1.6t-0.7-2.5q0-1.8 1.2-3t3-1.3 3.1 1.3 1.2 3z' })
	        )
	    );
	};
	
	exports.default = FaStethoscope;
	module.exports = exports['default'];

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStickyNoteO = function FaStickyNoteO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm34.3 28.6h-5.6v5.5q0.7-0.2 0.9-0.5l4.2-4.1q0.2-0.3 0.4-0.9z m-6.3-2.9h6.4v-20h-28.5v28.6h20v-6.4q0-0.9 0.6-1.6t1.5-0.6z m9.3-20.7v22.9q0 0.9-0.5 1.9t-1 1.7l-4.1 4.1q-0.7 0.7-1.7 1.1t-2 0.4h-22.9q-0.8 0-1.5-0.6t-0.6-1.5v-30q0-0.9 0.6-1.5t1.5-0.6h30q0.9 0 1.6 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaStickyNoteO;
	module.exports = exports['default'];

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStickyNote = function FaStickyNote(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25.9 27.9v9.2h-20.8q-0.8 0-1.5-0.6t-0.6-1.5v-30q0-0.9 0.6-1.5t1.5-0.6h30q0.9 0 1.6 0.6t0.6 1.5v20.7h-9.3q-0.9 0-1.5 0.6t-0.6 1.6z m2.8 0.7h8.5q-0.3 1.8-1.4 2.9l-4.1 4.1q-1.2 1.1-3 1.5v-8.5z' })
	        )
	    );
	};
	
	exports.default = FaStickyNote;
	module.exports = exports['default'];

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStopCircleO = function FaStopCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.1 2.9q4.7 0 8.6 2.3t6.3 6.2 2.3 8.6-2.3 8.6-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3z m0 29.2q3.3 0 6.1-1.6t4.5-4.4 1.6-6.1-1.6-6.1-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6z m-6.4-5q-0.3 0-0.5-0.2t-0.2-0.5v-12.8q0-0.3 0.2-0.5t0.5-0.2h12.9q0.3 0 0.5 0.2t0.2 0.5v12.8q0 0.3-0.2 0.5t-0.5 0.2h-12.9z' })
	        )
	    );
	};
	
	exports.default = FaStopCircleO;
	module.exports = exports['default'];

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStopCircle = function FaStopCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.3 26.4v-12.8q0-0.3-0.2-0.5t-0.5-0.2h-12.9q-0.3 0-0.5 0.2t-0.2 0.5v12.8q0 0.3 0.2 0.5t0.5 0.2h12.9q0.3 0 0.5-0.2t0.2-0.5z m10-6.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaStopCircle;
	module.exports = exports['default'];

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStop = function FaStop(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 4.3v31.4q0 0.6-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaStop;
	module.exports = exports['default'];

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStreetView = function FaStreetView(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 34.3q0 1.4-1.3 2.5t-3.7 1.8-5 1.1-5.7 0.3-5.6-0.3-5.1-1.1-3.6-1.8-1.4-2.5q0-1.1 0.7-2t2.1-1.5 2.6-1 2.9-0.6q0.6-0.1 1.1 0.2t0.6 0.9q0.1 0.6-0.3 1.1t-0.9 0.6q-1.3 0.2-2.3 0.5t-1.8 0.6-1 0.5-0.7 0.4-0.1 0.3q0 0.3 0.6 0.6t1.6 0.7 2.5 0.8 3.6 0.5 4.5 0.2 4.5-0.2 3.6-0.5 2.5-0.8 1.7-0.7 0.6-0.6q0-0.1-0.2-0.3t-0.6-0.4-1.1-0.5-1.7-0.6-2.4-0.5q-0.6-0.1-0.9-0.6t-0.2-1.1q0-0.5 0.5-0.9t1.1-0.2q1.6 0.2 2.9 0.6t2.7 1 2 1.5 0.7 2z m-8.5-20v8.6q0 0.5-0.5 1t-1 0.4h-1.4v8.6q0 0.5-0.4 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.5-1v-8.6h-1.4q-0.6 0-1-0.4t-0.4-1v-8.6q0-1.2 0.8-2t2-0.9h8.6q1.2 0 2 0.9t0.9 2z m-2.2-8.6q0 2.1-1.4 3.6t-3.6 1.4-3.5-1.4-1.5-3.6 1.5-3.5 3.5-1.5 3.6 1.5 1.4 3.5z' })
	        )
	    );
	};
	
	exports.default = FaStreetView;
	module.exports = exports['default'];

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStrikethrough = function FaStrikethrough(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.3 20q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-38.6q-0.3 0-0.5-0.2t-0.2-0.6v-1.4q0-0.3 0.2-0.5t0.5-0.2h38.6z m-28.5-1.4q-0.6-0.8-1.2-1.8-1-2.2-1-4.2 0-4.1 3-6.9 2.9-2.8 8.7-2.8 1.2 0 3.8 0.4 1.4 0.3 3.9 1.1 0.2 0.8 0.5 2.6 0.3 2.7 0.3 4.1 0 0.4-0.1 1l-0.3 0-1.9-0.1-0.3 0q-1.1-3.4-2.3-4.6-1.9-2-4.7-2-2.5 0-4 1.3-1.5 1.3-1.5 3.2 0 1.7 1.5 3.2t6.2 2.8q1.5 0.5 3.8 1.5 1.3 0.6 2.2 1.2h-16.6z m11.3 5.7h9.2q0.1 0.9 0.1 2 0 2.5-0.9 4.8-0.5 1.2-1.6 2.3-0.8 0.8-2.4 1.8-1.8 1.1-3.4 1.5-1.8 0.4-4.5 0.4-2.6 0-4.4-0.5l-3.1-0.9q-1.3-0.3-1.6-0.6-0.2-0.2-0.2-0.5v-0.3q0-2.4-0.1-3.5 0-0.6 0-1.5l0.1-0.8v-1l2.3 0q0.3 0.7 0.6 1.6t0.5 1.2 0.3 0.6q0.8 1.3 1.8 2.1 1 0.8 2.3 1.3 1.4 0.5 3 0.5 1.4 0 3.1-0.6 1.7-0.6 2.7-1.9 1.1-1.4 1.1-2.9 0-1.9-1.8-3.5-0.8-0.7-3.1-1.6z' })
	        )
	    );
	};
	
	exports.default = FaStrikethrough;
	module.exports = exports['default'];

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStumbleuponCircle = function FaStumbleuponCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.3 18.7l2-0.6v-1.4q0-1.7-1.3-3t-3-1.2-3.1 1.2-1.3 3v6.3q0 0.5-0.3 0.8t-0.8 0.3-0.7-0.3-0.3-0.8v-2.6h-3.4v2.7q0 1.8 1.3 3.1t3.1 1.3q1.8 0 3.1-1.3t1.3-3.1v-6.2q0-0.4 0.3-0.7t0.8-0.4q0.4 0 0.7 0.4t0.3 0.7v1.2z m7.5 4.4v-2.7h-3.4v2.8q0 0.4-0.3 0.7t-0.7 0.3q-0.5 0-0.8-0.3t-0.3-0.7v-2.8l-2 0.6-1.3-0.6v2.7q0 1.8 1.3 3.1t3.1 1.3 3.1-1.3 1.3-3.1z m7.5-3.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaStumbleuponCircle;
	module.exports = exports['default'];

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaStumbleupon = function FaStumbleupon(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.1 16.2v-2.5q0-0.8-0.7-1.5t-1.5-0.6-1.5 0.6-0.6 1.5v12.7q0 3.7-2.6 6.2t-6.3 2.6q-3.7 0-6.3-2.6t-2.6-6.3v-5.5h6.8v5.4q0 0.9 0.6 1.5t1.5 0.6 1.5-0.6 0.6-1.5v-12.8q0-3.6 2.7-6.1t6.2-2.5q3.7 0 6.3 2.5t2.6 6.1v2.8l-4 1.2z m11 4.6h6.8v5.5q0 3.7-2.6 6.3t-6.3 2.6q-3.7 0-6.3-2.6t-2.6-6.2v-5.6l2.7 1.3 4-1.2v5.6q0 0.9 0.6 1.5t1.5 0.6 1.5-0.6 0.7-1.5v-5.7z' })
	        )
	    );
	};
	
	exports.default = FaStumbleupon;
	module.exports = exports['default'];

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSubscript = function FaSubscript(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 30.6v3.7h-5.5l-3.6-5.6-0.5-1q-0.2-0.2-0.2-0.4h-0.1l-0.2 0.4q-0.2 0.5-0.6 1l-3.4 5.6h-5.8v-3.7h2.9l4.4-6.5-4.2-6.1h-3v-3.8h6.1l3.1 5.1q0.1 0.1 0.6 1 0.1 0.2 0.2 0.4h0.1q0-0.2 0.2-0.4l0.6-1 3.1-5.1h5.7v3.8h-2.8l-4.1 5.9 4.6 6.7h2.4z m14.3 4.8v4.6h-11.5l-0.1-0.6q0-1 0-1 0-1.5 0.5-2.6t1.5-2 1.9-1.4 1.8-1.2 1.5-1.2 0.6-1.5q0-0.8-0.7-1.4t-1.6-0.5q-1.1 0-2.1 0.9-0.3 0.2-0.8 0.8l-2.4-2.1q0.6-0.8 1.4-1.4 1.8-1.5 4.2-1.5 2.5 0 4 1.4t1.5 3.5q0 1.5-0.8 2.6t-1.8 2-2.2 1.3-2 1.5-0.9 1.6h5.2v-1.8h2.8z' })
	        )
	    );
	};
	
	exports.default = FaSubscript;
	module.exports = exports['default'];

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSubway = function FaSubway(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.3 0q4.1 0 7.1 2.1t2.9 5v20q0 2.9-2.8 5t-6.8 2.2l4.7 4.5q0.4 0.3 0.2 0.8t-0.7 0.4h-23.5q-0.5 0-0.7-0.4t0.2-0.8l4.7-4.5q-4-0.2-6.8-2.2t-2.8-5v-20q0-2.9 2.9-5t7.1-2.1h14.3z m-17.9 29.3q1.5 0 2.5-1.1t1.1-2.5-1.1-2.5-2.5-1.1-2.5 1.1-1 2.5 1 2.5 2.5 1.1z m9.3-12.2v-11.4h-12.1v11.4h12.1z m12.2 12.2q1.4 0 2.5-1.1t1-2.5-1-2.5-2.5-1.1-2.6 1.1-1 2.5 1 2.5 2.6 1.1z m3.5-12.2v-11.4h-12.8v11.4h12.8z' })
	        )
	    );
	};
	
	exports.default = FaSubway;
	module.exports = exports['default'];

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSuitcase = function FaSuitcase(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.3 8.6h11.4v-2.9h-11.4v2.9z m-7.9 0v28.5h-1.4q-2.1 0-3.5-1.4t-1.5-3.6v-18.5q0-2.1 1.5-3.6t3.5-1.4h1.4z m25 0v28.5h-22.8v-28.5h2.8v-3.6q0-0.9 0.7-1.5t1.5-0.6h12.8q0.9 0 1.5 0.6t0.7 1.5v3.6h2.8z m8.6 5v18.5q0 2.1-1.5 3.6t-3.5 1.4h-1.4v-28.5h1.4q2.1 0 3.5 1.4t1.5 3.6z' })
	        )
	    );
	};
	
	exports.default = FaSuitcase;
	module.exports = exports['default'];

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSunO = function FaSunO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.9 20q0-2.6-1.1-5t-2.7-4.1-4.1-2.7-5-1.1-5 1.1-4.1 2.7-2.7 4.1-1.1 5 1.1 5 2.7 4.1 4.1 2.7 5 1.1 5-1.1 4.1-2.7 2.7-4.1 1.1-5z m6.1 6.2q-0.1 0.3-0.4 0.4l-6.5 2.2v6.8q0 0.4-0.3 0.6-0.4 0.2-0.7 0.1l-6.5-2.1-4 5.5q-0.2 0.3-0.6 0.3t-0.6-0.3l-4-5.5-6.5 2.1q-0.3 0.1-0.7-0.1-0.3-0.2-0.3-0.6v-6.8l-6.5-2.2q-0.3-0.1-0.4-0.4-0.1-0.4 0.1-0.7l4-5.5-4-5.5q-0.2-0.3-0.1-0.7 0.1-0.3 0.4-0.4l6.5-2.2v-6.8q0-0.4 0.3-0.6 0.4-0.2 0.7-0.1l6.5 2.1 4-5.5q0.2-0.3 0.6-0.3t0.6 0.3l4 5.5 6.5-2.1q0.3-0.1 0.7 0.1 0.3 0.2 0.3 0.6v6.8l6.5 2.2q0.3 0.1 0.4 0.4 0.1 0.4-0.1 0.7l-4 5.5 4 5.5q0.2 0.3 0.1 0.7z' })
	        )
	    );
	};
	
	exports.default = FaSunO;
	module.exports = exports['default'];

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaSuperscript = function FaSuperscript(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23 30.6v3.7h-5.5l-3.6-5.6-0.5-1q-0.2-0.2-0.2-0.4h-0.1l-0.2 0.4q-0.2 0.5-0.6 1l-3.4 5.6h-5.8v-3.7h2.9l4.4-6.5-4.2-6.1h-3v-3.8h6.1l3.1 5.1q0.1 0.1 0.6 1 0.1 0.2 0.2 0.4h0.1q0-0.2 0.2-0.4l0.6-1 3.1-5.1h5.7v3.8h-2.8l-4.1 5.9 4.6 6.7h2.4z m14.2-15.2v4.6h-11.4l-0.1-0.6q-0.1-0.6-0.1-1 0-1.5 0.6-2.6t1.4-2 1.9-1.4 1.9-1.2 1.4-1.2 0.6-1.5q0-0.8-0.6-1.4t-1.6-0.5q-1.1 0-2.2 0.9-0.3 0.2-0.8 0.8l-2.3-2.1q0.6-0.8 1.4-1.4 1.8-1.5 4.2-1.5 2.4 0 4 1.4t1.5 3.5q0 1.2-0.6 2.3t-1.4 1.7-1.8 1.3-1.8 1.1-1.5 1.2-0.6 1.4h5.1v-1.8h2.8z' })
	        )
	    );
	};
	
	exports.default = FaSuperscript;
	module.exports = exports['default'];

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTable = function FaTable(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm12.9 30.7v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.1q0.3 0 0.5-0.2t0.2-0.5z m0-8.6v-4.2q0-0.4-0.2-0.6t-0.5-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.6v4.2q0 0.4 0.2 0.6t0.5 0.2h7.1q0.3 0 0.5-0.2t0.2-0.6z m11.5 8.6v-4.3q0-0.3-0.2-0.5t-0.6-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.1q0.4 0 0.6-0.2t0.2-0.5z m-11.5-17.1v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.1q0.3 0 0.5-0.2t0.2-0.5z m11.5 8.5v-4.2q0-0.4-0.2-0.6t-0.6-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.6v4.2q0 0.4 0.2 0.6t0.5 0.2h7.1q0.4 0 0.6-0.2t0.2-0.6z m11.4 8.6v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-7.2q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.2q0.3 0 0.5-0.2t0.2-0.5z m-11.4-17.1v-4.3q0-0.3-0.2-0.5t-0.6-0.2h-7.1q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.1q0.4 0 0.6-0.2t0.2-0.5z m11.4 8.5v-4.2q0-0.4-0.2-0.6t-0.5-0.2h-7.2q-0.3 0-0.5 0.2t-0.2 0.6v4.2q0 0.4 0.2 0.6t0.5 0.2h7.2q0.3 0 0.5-0.2t0.2-0.6z m0-8.5v-4.3q0-0.3-0.2-0.5t-0.5-0.2h-7.2q-0.3 0-0.5 0.2t-0.2 0.5v4.3q0 0.3 0.2 0.5t0.5 0.2h7.2q0.3 0 0.5-0.2t0.2-0.5z m2.8-7.2v24.3q0 1.5-1 2.5t-2.5 1.1h-30q-1.5 0-2.5-1.1t-1.1-2.5v-24.3q0-1.4 1-2.5t2.6-1h30q1.4 0 2.5 1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaTable;
	module.exports = exports['default'];

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTablet = function FaTablet(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.3 31.4q0-0.5-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.5 1-0.5 0.4-1z m8.6-3.5v-21.5q0-0.3-0.3-0.5t-0.5-0.2h-18.5q-0.3 0-0.5 0.2t-0.2 0.5v21.5q0 0.2 0.2 0.5t0.5 0.2h18.5q0.3 0 0.5-0.2t0.3-0.5z m2.8-21.5v24.3q0 1.5-1 2.5t-2.6 1.1h-18.5q-1.5 0-2.6-1.1t-1-2.5v-24.3q0-1.4 1.1-2.5t2.5-1h18.5q1.5 0 2.6 1t1 2.5z' })
	        )
	    );
	};
	
	exports.default = FaTablet;
	module.exports = exports['default'];

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTag = function FaTag(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13 10q0-1.2-0.8-2t-2.1-0.9-2 0.9-0.8 2 0.8 2 2 0.9 2.1-0.9 0.8-2z m23.8 12.9q0 1.1-0.8 2l-11 10.9q-0.8 0.9-2 0.9-1.2 0-2-0.9l-16-15.9q-0.8-0.9-1.4-2.3t-0.6-2.6v-9.3q0-1.1 0.8-2t2.1-0.8h9.2q1.2 0 2.7 0.5t2.2 1.5l16 15.9q0.8 0.9 0.8 2.1z' })
	        )
	    );
	};
	
	exports.default = FaTag;
	module.exports = exports['default'];

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTags = function FaTags(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.5 10.5q0-1.2-0.8-1.9t-1.9-0.8-1.9 0.8-0.8 1.9 0.8 1.9 1.9 0.8 1.9-0.8 0.8-1.9z m22.7 12.2q0 1.1-0.8 1.9l-10.4 10.5q-0.8 0.8-2 0.8-1.1 0-1.9-0.8l-15.2-15.2q-0.8-0.8-1.3-2.2t-0.6-2.5v-8.8q0-1.1 0.8-1.9t1.9-0.8h8.9q1.1 0 2.5 0.5t2.1 1.4l15.2 15.2q0.8 0.8 0.8 1.9z m8.2 0q0 1.1-0.8 1.9l-10.5 10.5q-0.8 0.8-1.9 0.8-0.8 0-1.2-0.3t-1.2-1l10-10q0.8-0.8 0.8-1.9 0-1.1-0.8-1.9l-15.2-15.2q-0.8-0.8-2.1-1.4t-2.5-0.5h4.7q1.2 0 2.5 0.5t2.2 1.4l15.2 15.2q0.8 0.8 0.8 1.9z' })
	        )
	    );
	};
	
	exports.default = FaTags;
	module.exports = exports['default'];

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTasks = function FaTasks(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.9 31.4h14.2v-2.8h-14.2v2.8z m-8.6-11.4h22.8v-2.9h-22.8v2.9z m14.3-11.4h8.5v-2.9h-8.5v2.9z m11.4 18.5v5.8q0 0.5-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-5.8q0-0.5 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m0-11.4v5.7q0 0.6-0.4 1t-1 0.5h-37.2q-0.6 0-1-0.5t-0.4-1v-5.7q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z m0-11.4v5.7q0 0.6-0.4 1t-1 0.4h-37.2q-0.6 0-1-0.4t-0.4-1v-5.7q0-0.6 0.4-1t1-0.4h37.2q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaTasks;
	module.exports = exports['default'];

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTelevision = function FaTelevision(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.2 27.3v-19.9q0-0.3-0.2-0.5t-0.5-0.2h-33.2q-0.2 0-0.4 0.2t-0.2 0.5v19.9q0 0.3 0.2 0.5t0.4 0.2h33.2q0.3 0 0.5-0.2t0.2-0.5z m2.7-19.9v19.9q0 1.4-1 2.4t-2.4 0.9h-15.2v2.7h7.3q0.3 0 0.4 0.2t0.2 0.5v1.3q0 0.3-0.2 0.5t-0.4 0.1h-17.3q-0.3 0-0.5-0.1t-0.2-0.5v-1.3q0-0.3 0.2-0.5t0.5-0.2h7.3v-2.7h-15.3q-1.3 0-2.3-0.9t-1-2.4v-19.9q0-1.4 1-2.4t2.3-0.9h33.2q1.4 0 2.4 0.9t1 2.4z' })
	        )
	    );
	};
	
	exports.default = FaTelevision;
	module.exports = exports['default'];

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTencentWeibo = function FaTencentWeibo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.3 12.8q0 1.8-1.3 3t-3 1.3q-1.4 0-2.5-0.8-1.4 1.5-2.6 3.3-5.5 8.2-4.5 19.1 0.1 0.5-0.2 0.9t-0.8 0.4h-0.1q-0.5 0-0.8-0.3t-0.4-0.8q-0.3-2.8-0.1-5.5t0.7-4.8 1.2-4.2 1.5-3.4 1.7-2.8q1.3-2 2.9-3.7-0.3-0.8-0.3-1.7 0-1.8 1.2-3.1t3.1-1.2 3 1.2 1.3 3.1z m8.5 0.2q0 3.5-1.7 6.5t-4.8 4.8-6.5 1.7q-1.4 0-2.9-0.3-0.5-0.1-0.8-0.5t-0.1-0.9q0.1-0.5 0.5-0.7t0.9-0.2q1.1 0.3 2.4 0.3 2.2 0 4.1-0.8t3.5-2.3 2.2-3.4 0.9-4.2-0.9-4.1-2.2-3.5-3.5-2.2-4.1-0.9-4.2 0.9-3.4 2.2-2.3 3.5-0.8 4.1q0 2.6 1.2 4.9 0.2 0.4 0 0.9t-0.5 0.6-0.9 0.1-0.7-0.6q-1.4-2.7-1.4-5.9 0-2.6 1-5.1t2.8-4.1 4.1-2.8 5.1-1q3.5 0 6.5 1.7t4.8 4.8 1.7 6.5z' })
	        )
	    );
	};
	
	exports.default = FaTencentWeibo;
	module.exports = exports['default'];

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTerminal = function FaTerminal(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.6 21.9l-10.4 10.4q-0.3 0.3-0.6 0.3t-0.5-0.3l-1.1-1.1q-0.2-0.2-0.2-0.5t0.2-0.5l8.8-8.8-8.8-8.7q-0.2-0.3-0.2-0.6t0.2-0.5l1.1-1.1q0.3-0.2 0.5-0.2t0.6 0.2l10.4 10.4q0.2 0.2 0.2 0.5t-0.2 0.5z m24 10.2v1.5q0 0.3-0.2 0.5t-0.5 0.2h-21.4q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h21.4q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaTerminal;
	module.exports = exports['default'];

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTextHeight = function FaTextHeight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.9 31.4q0.8 0 1 0.4t-0.3 1l-2.8 3.7q-0.4 0.5-1.1 0.5t-1.1-0.5l-2.8-3.7q-0.4-0.5-0.2-1t0.9-0.4h1.8v-22.8h-1.8q-0.7 0-0.9-0.4t0.2-1l2.8-3.7q0.5-0.5 1.1-0.5t1.1 0.5l2.8 3.7q0.5 0.5 0.3 1t-1 0.4h-1.8v22.8h1.8z m-37.1-28.5l1.2 0.6q0.3 0.1 4.7 0.1 1 0 3-0.1t2.9 0q0.8 0 2.4 0t2.4 0h6.6q0.1 0 0.4 0t0.5 0 0.3 0 0.4-0.2 0.4-0.4l0.9 0q0.1 0 0.3 0t0.3 0q0.1 2.5 0.1 7.5 0 1.8-0.1 2.4-0.9 0.3-1.6 0.4-0.5-1-1.2-2.8 0-0.2-0.2-1.1t-0.3-1.7-0.2-0.7q-0.1-0.2-0.3-0.3t-0.3-0.2-0.3 0-0.4 0-0.4 0q-0.4 0-1.5 0t-1.6 0-1.4 0-1.6 0.1q-0.2 1.8-0.2 3.1 0 2.1 0 8.6t0.1 10.2q0 0.4-0.1 1.6t0 2 0.3 1.6q0.9 0.4 2.8 0.9t2.6 0.9q0.2 0.8 0.2 1.1 0 0.3-0.1 0.6l-0.8 0q-1.7 0.1-4.8-0.1t-4.7-0.3q-1.1 0-3.3 0.2t-3.4 0.2q-0.1-1.1-0.1-1.1v-0.2q0.4-0.6 1.4-1t2.2-0.6 1.7-0.6q0.5-1 0.5-8.6 0-2.2-0.1-6.7t-0.1-6.8v-2.6q0-0.1 0-0.4t0-0.5 0-0.6-0.1-0.5-0.1-0.3q-0.2-0.3-3.6-0.3-0.7 0-2.1 0.3t-1.7 0.5q-0.5 0.3-0.8 1.7t-0.7 2.4-0.9 1.2q-1-0.6-1.3-1v-8.5z' })
	        )
	    );
	};
	
	exports.default = FaTextHeight;
	module.exports = exports['default'];

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTextWidth = function FaTextWidth(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.8 2.9l1.2 0.6q0.3 0.1 4.7 0.1 1 0 3-0.1t2.9 0q1.6 0 5.5 0t6.8 0 5.5 0.1q0.8 0 1.3-0.7l0.9 0q0.1 0 0.3 0t0.3 0q0.1 2.5 0.1 7.5 0 1.8-0.1 2.4-0.9 0.3-1.5 0.4-0.6-1-1.2-2.8-0.1-0.2-0.3-1.1t-0.3-1.6-0.2-0.9q-0.2-0.2-0.6-0.4-0.1 0-1.5 0-0.6 0-2 0t-2.3-0.1-2.1 0.1-2.2 0.1q-0.2 1.8-0.2 3.1l0.1 3.4v-1.2q0 1.2 0 3.4t0 4.1 0 3.4q0 0.3 0 1.6t0 2 0.3 1.6q0.8 0.4 2.7 0.9t2.7 0.8q0.1 0.9 0.1 1.2 0 0.3-0.1 0.6l-0.7 0q-1.7 0.1-4.9-0.2t-4.6-0.2q-1.1 0-3.4 0.2t-3.4 0.2q0-1.1 0-1.1v-0.2q0.3-0.6 1.3-1t2.2-0.6 1.8-0.7q0.1-0.3 0.2-1.6t0.2-3.3 0-3.4 0-3.4 0-2q0-0.2-0.1-0.5t0-0.5q0-0.2 0-1t0-1.6 0-1.7-0.1-1.5-0.1-0.7q-0.3-0.3-3.6-0.3-0.9 0-3.7 0.3t-3 0.5q-0.5 0.3-0.8 1.6t-0.7 2.5-1 1.2q-0.9-0.6-1.2-1v-8.5z m27.4 28.6q0.3 0 1 0.4t1.3 1 1.3 1.1 0.8 0.6q0.6 0.5 0.6 1.1t-0.6 1.1q-0.1 0.1-0.8 0.7t-1.3 1.1-1.3 0.9-1 0.4q-0.3 0-0.4-0.2t-0.2-0.6-0.1-0.8 0-0.7 0.1-0.5h-22.9q0 0.1 0 0.5t0.1 0.7-0.1 0.8-0.2 0.6-0.5 0.2q-0.2 0-0.9-0.4t-1.3-0.9-1.3-1.1-0.8-0.7q-0.6-0.5-0.6-1.1t0.6-1.1q0.1-0.1 0.8-0.7t1.3-1 1.3-1 0.9-0.4q0.3 0 0.5 0.2t0.2 0.7 0.1 0.7-0.1 0.7 0 0.5h22.9q0-0.1-0.1-0.5t0-0.7 0.1-0.7 0.2-0.7 0.4-0.2z' })
	        )
	    );
	};
	
	exports.default = FaTextWidth;
	module.exports = exports['default'];

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThLarge = function FaThLarge(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 22.9v8.5q0 1.2-0.8 2t-2 0.9h-11.4q-1.2 0-2.1-0.9t-0.8-2v-8.5q0-1.2 0.8-2.1t2.1-0.8h11.4q1.1 0 2 0.8t0.8 2.1z m0-17.2v8.6q0 1.1-0.8 2t-2 0.8h-11.4q-1.2 0-2.1-0.8t-0.8-2v-8.6q0-1.1 0.8-2t2.1-0.8h11.4q1.1 0 2 0.8t0.8 2z m20 17.2v8.5q0 1.2-0.8 2t-2 0.9h-11.4q-1.2 0-2.1-0.9t-0.8-2v-8.5q0-1.2 0.8-2.1t2.1-0.8h11.4q1.1 0 2 0.8t0.8 2.1z m0-17.2v8.6q0 1.1-0.8 2t-2 0.8h-11.4q-1.2 0-2.1-0.8t-0.8-2v-8.6q0-1.1 0.8-2t2.1-0.8h11.4q1.1 0 2 0.8t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaThLarge;
	module.exports = exports['default'];

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThList = function FaThList(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 27.9v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m0-11.5v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m28.6 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.6z m-28.6-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m28.6 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-21.5q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.5z m0-11.4v4.3q0 0.9-0.6 1.5t-1.5 0.6h-21.5q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h21.5q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaThList;
	module.exports = exports['default'];

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTh = function FaTh(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 27.9v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m0-11.5v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m-14.3-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.5v4.2q0 0.9-0.6 1.6t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.6v-4.2q0-0.9 0.6-1.6t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.6z m-14.3-22.9v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m14.3 11.4v4.3q0 0.9-0.6 1.5t-1.5 0.7h-7.2q-0.9 0-1.5-0.7t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z m0-11.4v4.3q0 0.9-0.6 1.5t-1.5 0.6h-7.2q-0.9 0-1.5-0.6t-0.6-1.5v-4.3q0-0.9 0.6-1.5t1.5-0.6h7.2q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaTh;
	module.exports = exports['default'];

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThumbTack = function FaThumbTack(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.7 19.3v-10q0-0.3-0.2-0.5t-0.5-0.2-0.5 0.2-0.2 0.5v10q0 0.3 0.2 0.5t0.5 0.2 0.5-0.2 0.2-0.5z m15 7.8q0 0.6-0.4 1t-1 0.5h-9.6l-1.1 10.8q-0.1 0.2-0.3 0.4t-0.4 0.2h0q-0.6 0-0.8-0.6l-1.7-10.8h-9q-0.6 0-1-0.5t-0.4-1q0-2.7 1.8-4.9t3.9-2.2v-11.4q-1.1 0-2-0.9t-0.8-2 0.8-2 2-0.8h14.3q1.2 0 2 0.8t0.9 2-0.9 2-2 0.9v11.4q2.2 0 4 2.2t1.7 4.9z' })
	        )
	    );
	};
	
	exports.default = FaThumbTack;
	module.exports = exports['default'];

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThumbsDown = function FaThumbsDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm7.7 12.9q0 0.5-0.4 1t-1 0.4q-0.6 0-1-0.4t-0.4-1q0-0.6 0.4-1.1t1-0.4q0.6 0 1 0.4t0.4 1.1z m3.6 11.4v-14.3q0-0.6-0.4-1t-1-0.4h-6.5q-0.6 0-1 0.4t-0.4 1v14.3q0 0.6 0.4 1t1 0.4h6.5q0.5 0 1-0.4t0.4-1z m25.2-3.3q1.2 1.3 1.2 3.3 0 1.7-1.3 3t-3 1.3h-6.2q0.1 0.3 0.2 0.5t0.3 0.5 0.2 0.4q0.4 0.8 0.6 1.3t0.4 1.3 0.2 1.7q0 0.5 0 0.9t-0.1 1-0.2 1.1-0.6 1-0.9 0.9-1.3 0.6-1.9 0.2q-0.5 0-1-0.4-0.4-0.5-0.7-1.1t-0.5-1.2-0.2-1.4q-0.2-0.9-0.3-1.3t-0.4-1.1-0.7-1.1q-0.8-0.7-2.3-2.6-1.1-1.5-2.2-2.7t-1.7-1.4q-0.6 0-1-0.4t-0.4-1v-14.3q0-0.6 0.4-1t1-0.4q0.8-0.1 3.6-1 1.7-0.6 2.7-0.9t2.7-0.6 3.2-0.4h2.9q2.9 0.1 4.4 1.8 1.3 1.5 1.1 4 0.8 0.8 1.2 2.1 0.3 1.4 0 2.6 1 1.4 0.9 3.1 0 0.7-0.3 1.7z' })
	        )
	    );
	};
	
	exports.default = FaThumbsDown;
	module.exports = exports['default'];

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThumbsODown = function FaThumbsODown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.7 10q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m25.7 12.9q0-0.8-0.4-1.9t-1.2-1q0.3-0.4 0.5-1.1t0.2-1.2q0-1.5-1.1-2.7 0.4-0.7 0.4-1.5t-0.4-1.6-1.1-1.2q0.1-0.7 0.1-1.3 0-1.9-1.1-2.8t-3-0.9h-2.9q-2.9 0-7.6 1.6-0.1 0.1-0.7 0.3t-0.7 0.3-0.8 0.2-0.9 0.3-0.7 0.1-0.7 0.1h-0.7v14.3h0.7q0.3 0 0.8 0.2t0.9 0.6 0.8 0.8 0.9 0.9 0.8 1 0.7 0.9 0.5 0.7q1.2 1.5 1.7 2 0.9 1 1.4 2.4t0.6 2.8 0.9 1.9q2.1 0 2.8-1t0.8-3.2q0-1.4-1.1-3.6t-1.1-3.6h7.9q1.1 0 2-0.8t0.8-2z m2.9 0q0 2.3-1.7 4t-4 1.7h-4q1.1 2.2 1.1 4.3 0 2.6-0.8 4.1-0.7 1.5-2.2 2.3t-3.4 0.7q-1.2 0-2-0.8-0.8-0.8-1.2-1.9t-0.6-2-0.4-1.9-0.7-1.4q-1.1-1.1-2.4-2.8-2.2-3-3-3.5h-6.1q-1.2 0-2.1-0.8t-0.8-2v-14.3q0-1.2 0.8-2.1t2.1-0.8h6.4q0.5 0 3.1-0.9 2.8-1 4.9-1.5t4.5-0.4h2.5q3.1 0 5.1 1.7t1.9 4.8v0.2q1.3 1.7 1.3 3.9 0 0.5-0.1 1 0.9 1.5 0.9 3.2 0 0.8-0.2 1.5 1.1 1.7 1.1 3.7z' })
	        )
	    );
	};
	
	exports.default = FaThumbsODown;
	module.exports = exports['default'];

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThumbsOUp = function FaThumbsOUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.7 30q0-0.6-0.4-1t-1-0.4-1 0.4-0.4 1 0.4 1 1 0.4 1-0.4 0.4-1z m25.7-12.9q0-1.1-0.8-2t-2-0.8h-7.9q0-1.3 1.1-3.6t1.1-3.6q0-2.1-0.8-3.2t-2.8-1q-0.6 0.5-0.9 1.9t-0.6 2.8-1.4 2.4q-0.5 0.5-1.7 2-0.1 0.1-0.5 0.7t-0.7 0.9-0.8 1-0.9 0.9-0.8 0.8-0.9 0.6-0.8 0.2h-0.7v14.3h0.7q0.3 0 0.7 0.1t0.7 0.1 0.9 0.3 0.8 0.2 0.7 0.3 0.7 0.3q4.7 1.6 7.6 1.6h2.7q4.3 0 4.3-3.7 0-0.6-0.1-1.3 0.7-0.3 1.1-1.2t0.4-1.6-0.4-1.5q1.1-1.2 1.1-2.7 0-0.6-0.2-1.2t-0.5-1.1q0.7 0 1.1-1t0.5-1.9z m2.9 0q0 2-1.1 3.7 0.2 0.7 0.2 1.5 0 1.7-0.9 3.2 0.1 0.5 0.1 1 0 2.2-1.3 3.9 0 3.2-1.9 4.9t-5.1 1.8h-2.9q-2.1 0-4.2-0.5t-4.8-1.4q-2.6-0.9-3.1-0.9h-6.4q-1.2 0-2.1-0.8t-0.8-2.1v-14.3q0-1.1 0.8-2t2.1-0.8h6.1q0.8-0.6 3-3.5 1.3-1.6 2.4-2.8 0.6-0.6 0.8-1.9t0.7-2.9 1.4-2.4q0.8-0.8 2-0.8 1.9 0 3.4 0.7t2.2 2.3 0.8 4.1q0 2.1-1.1 4.3h4q2.3 0 4 1.7t1.7 4z' })
	        )
	    );
	};
	
	exports.default = FaThumbsOUp;
	module.exports = exports['default'];

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaThumbsUp = function FaThumbsUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm7.7 30q0-0.6-0.4-1t-1-0.4q-0.6 0-1 0.4t-0.4 1q0 0.6 0.4 1t1 0.4q0.6 0 1-0.4t0.4-1z m3.6-11.4v14.3q0 0.5-0.4 1t-1 0.4h-6.5q-0.6 0-1-0.4t-0.4-1v-14.3q0-0.6 0.4-1t1-0.5h6.5q0.5 0 1 0.5t0.4 1z m26.4 0q0 1.9-1.2 3.3 0.3 1 0.3 1.7 0.1 1.7-0.9 3.1 0.3 1.2 0 2.6-0.4 1.2-1.2 2.1 0.2 2.5-1.1 4-1.5 1.7-4.4 1.7h-2.9q-1.5 0-3.2-0.3t-2.7-0.6-2.7-0.9q-2.8-1-3.6-1-0.5 0-1-0.4t-0.4-1v-14.3q0-0.6 0.4-1t1-0.5q0.5 0 1.7-1.3t2.2-2.7q1.5-1.9 2.3-2.7 0.4-0.4 0.7-1t0.4-1.1 0.3-1.4q0.1-0.9 0.2-1.3t0.5-1.2 0.7-1.1q0.5-0.4 1-0.4 1.1 0 1.9 0.2t1.3 0.6 0.9 0.9 0.6 1 0.2 1.1 0.1 1 0 0.9q0 0.8-0.2 1.7t-0.4 1.3-0.6 1.3q-0.1 0.1-0.2 0.4t-0.3 0.4-0.2 0.6h6.2q1.8 0 3 1.3t1.3 3z' })
	        )
	    );
	};
	
	exports.default = FaThumbsUp;
	module.exports = exports['default'];

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTicket = function FaTicket(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.9 10.1l7 7-12.8 12.8-7-7z m-4.8 21.8l13.8-13.8q0.5-0.4 0.5-1t-0.5-1l-8-8q-0.4-0.4-1-0.4t-1 0.4l-13.8 13.8q-0.5 0.4-0.5 1t0.5 1l8 8q0.4 0.4 1 0.4t1-0.4z m19.9-14.2l-20.3 20.3q-0.8 0.8-2 0.8t-2-0.8l-2.8-2.8q1.2-1.3 1.2-3.1t-1.2-3-3-1.2-3.1 1.2l-2.8-2.8q-0.8-0.8-0.8-2t0.8-2l20.3-20.3q0.8-0.8 2-0.8t2 0.8l2.8 2.8q-1.2 1.3-1.2 3.1t1.2 3 3 1.2 3.1-1.2l2.8 2.8q0.8 0.8 0.8 2t-0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaTicket;
	module.exports = exports['default'];

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTimesCircleO = function FaTimesCircleO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.5 24.1l-3.3 3.2q-0.2 0.3-0.5 0.3t-0.5-0.3l-3.1-3-3 3q-0.2 0.3-0.5 0.3t-0.5-0.3l-3.3-3.2q-0.2-0.2-0.2-0.5t0.2-0.5l3.1-3.1-3.1-3.1q-0.2-0.2-0.2-0.5t0.2-0.5l3.3-3.2q0.2-0.3 0.5-0.3t0.5 0.3l3 3 3.1-3q0.2-0.3 0.5-0.3t0.5 0.3l3.3 3.2q0.2 0.2 0.2 0.5t-0.2 0.5l-3.1 3.1 3.1 3.1q0.2 0.2 0.2 0.5t-0.2 0.5z m4.8-4.1q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6.1 1.6-4.4 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaTimesCircleO;
	module.exports = exports['default'];

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTimesCircle = function FaTimesCircle(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaTimesCircle;
	module.exports = exports['default'];

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTint = function FaTint(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 25.7q0-0.8-0.4-1.5 0 0-0.4-0.5t-0.5-0.9-0.6-1-0.5-1.1q0-0.3-0.4-0.3t-0.5 0.3q-0.2 0.5-0.5 1.1t-0.5 1-0.6 0.9-0.3 0.5q-0.5 0.7-0.5 1.5 0 1.2 0.9 2t2 0.9 2-0.9 0.8-2z m11.5-2.8q0 4.7-3.4 8t-8.1 3.4-8.1-3.4-3.3-8q0-3.3 1.8-6.2 0.1-0.2 1.4-2t2.3-3.4 2.2-3.9 1.8-4.5q0.2-0.7 0.8-1.1t1.1-0.4 1.2 0.4 0.7 1.1q0.7 2 1.9 4.5t2.2 3.9 2.3 3.4 1.3 2q1.9 2.9 1.9 6.2z' })
	        )
	    );
	};
	
	exports.default = FaTint;
	module.exports = exports['default'];

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaToggleOff = function FaToggleOff(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.4 20q0-2-0.8-3.9t-2.2-3.1-3.1-2.2-3.9-0.7-3.8 0.7-3.2 2.2-2.1 3.1-0.8 3.9 0.8 3.9 2.1 3.1 3.2 2.2 3.8 0.7 3.9-0.7 3.1-2.2 2.2-3.1 0.8-3.9z m14.9 0q0-2-0.8-3.9t-2.1-3.1-3.2-2.2-3.9-0.7h-7.5q2.3 1.7 3.7 4.3t1.3 5.6-1.3 5.6-3.7 4.3h7.5q2 0 3.9-0.7t3.2-2.2 2.1-3.1 0.8-3.9z m2.5 0q0 2.5-1 4.8t-2.7 4-3.9 2.6-4.9 1h-14.9q-2.5 0-4.8-1t-4-2.6-2.6-4-1-4.8 1-4.8 2.6-4 4-2.6 4.8-1h14.9q2.6 0 4.9 1t3.9 2.6 2.7 4 1 4.8z' })
	        )
	    );
	};
	
	exports.default = FaToggleOff;
	module.exports = exports['default'];

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaToggleOn = function FaToggleOn(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm0 20q0-2.5 1-4.8t2.6-4 4-2.6 4.8-1h14.9q2.6 0 4.9 1t3.9 2.6 2.7 4 1 4.8-1 4.8-2.7 4-3.9 2.6-4.9 1h-14.9q-2.5 0-4.8-1t-4-2.6-2.6-4-1-4.8z m27.3 9.9q2 0 3.9-0.7t3.2-2.2 2.1-3.1 0.8-3.9-0.8-3.9-2.1-3.1-3.2-2.2-3.9-0.7-3.8 0.7-3.2 2.2-2.1 3.1-0.8 3.9 0.8 3.9 2.1 3.1 3.2 2.2 3.8 0.7z' })
	        )
	    );
	};
	
	exports.default = FaToggleOn;
	module.exports = exports['default'];

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrademark = function FaTrademark(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.4 12.9v2.3q0 0.3-0.2 0.5t-0.5 0.2h-6v16.4q0 0.3-0.2 0.5t-0.4 0.2h-2.8q-0.2 0-0.4-0.2t-0.2-0.5v-16.4h-6.1q-0.2 0-0.4-0.2t-0.2-0.5v-2.3q0-0.3 0.2-0.5t0.5-0.2h16q0.3 0 0.5 0.2t0.2 0.5z m21.1-0.1l1.5 19.5q0 0.3-0.1 0.5-0.2 0.2-0.5 0.2h-2.7q-0.3 0-0.5-0.2t-0.2-0.4l-0.9-11.9-3.8 8.6q-0.2 0.4-0.6 0.4h-2.5q-0.4 0-0.5-0.4l-3.9-8.7-0.9 12q0 0.2-0.2 0.4t-0.4 0.2h-2.7q-0.3 0-0.5-0.2-0.2-0.2-0.2-0.5l1.6-19.5q0-0.2 0.2-0.4t0.4-0.2h2.9q0.4 0 0.6 0.4l4.5 10.5q0.2 0.5 0.4 1.1 0-0.2 0.2-0.5t0.2-0.6l4.5-10.5q0.1-0.4 0.5-0.4h2.9q0.3 0 0.4 0.2t0.3 0.4z' })
	        )
	    );
	};
	
	exports.default = FaTrademark;
	module.exports = exports['default'];

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrain = function FaTrain(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm27.3 0q4.1 0 7.1 2.1t2.9 5v20q0 2.9-2.8 5t-6.8 2.2l4.7 4.5q0.4 0.3 0.2 0.8t-0.7 0.4h-23.5q-0.5 0-0.7-0.4t0.2-0.8l4.7-4.5q-4-0.2-6.8-2.2t-2.8-5v-20q0-2.9 2.9-5t7.1-2.1h14.3z m-7.2 30q1.8 0 3.1-1.2t1.2-3.1-1.2-3-3.1-1.3-3 1.3-1.2 3 1.2 3.1 3 1.2z m12.9-12.9v-11.4h-25.7v11.4h25.7z' })
	        )
	    );
	};
	
	exports.default = FaTrain;
	module.exports = exports['default'];

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTransgenderAlt = function FaTransgenderAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 0.7q0-0.3 0.2-0.5t0.5-0.2h6.4q0.6 0 1 0.4t0.4 1v6.5q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-3l-5.7 5.7q2.8 3.5 2.8 8 0 4.9-3.3 8.6t-8.1 4.1v3h2.1q0.4 0 0.6 0.2t0.2 0.5v1.4q0 0.3-0.2 0.5t-0.6 0.2h-2.1v2.2q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.4 0-0.6-0.2t-0.2-0.5v-2.2h-2.1q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h2.1v-3q-4.8-0.5-8.1-4.1t-3.3-8.6q0-4.5 2.8-8l-1.1-1.2-2.3 2.5q-0.2 0.2-0.5 0.2t-0.5-0.2l-1.1-1q-0.2-0.1-0.2-0.4t0.2-0.6l2.3-2.5-2.4-2.5v3q0 0.3-0.2 0.5t-0.6 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-6.5q0-0.6 0.4-1t1-0.4h6.5q0.3 0 0.5 0.2t0.2 0.5v1.4q0 0.4-0.2 0.6t-0.5 0.2h-3l2.4 2.3 1.9-2.1q0.2-0.2 0.5-0.2t0.5 0.2l1.1 1q0.2 0.1 0.2 0.4t-0.2 0.6l-2 2.2 1.3 1.2q3.5-2.8 8-2.8t8 2.8l5.7-5.6h-3q-0.3 0-0.5-0.2t-0.2-0.6v-1.4z m-10 27.9q4.1 0 7-3t3-7-3-7.1-7-2.9-7.1 2.9-2.9 7.1 2.9 7 7.1 3z' })
	        )
	    );
	};
	
	exports.default = FaTransgenderAlt;
	module.exports = exports['default'];

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrashO = function FaTrashO(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.9 16.4v12.9q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-12.9q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m5.7 0v12.9q0 0.3-0.2 0.5t-0.5 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-12.9q0-0.3 0.2-0.5t0.5-0.2h1.4q0.3 0 0.5 0.2t0.2 0.5z m5.8 0v12.9q0 0.3-0.2 0.5t-0.6 0.2h-1.4q-0.3 0-0.5-0.2t-0.2-0.5v-12.9q0-0.3 0.2-0.5t0.5-0.2h1.4q0.4 0 0.6 0.2t0.2 0.5z m2.8 16.2v-21.2h-20v21.2q0 0.5 0.2 0.9t0.3 0.6 0.2 0.2h18.6q0.1 0 0.2-0.2t0.4-0.6 0.1-0.9z m-15-24h10l-1.1-2.6q-0.1-0.2-0.3-0.3h-7.1q-0.2 0.1-0.4 0.3z m20.7 0.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v21.2q0 1.8-1.1 3.2t-2.5 1.3h-18.6q-1.4 0-2.5-1.3t-1-3.1v-21.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h6.9l1.6-3.8q0.3-0.8 1.2-1.4t1.7-0.5h7.2q0.9 0 1.8 0.5t1.2 1.4l1.5 3.8h6.9q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaTrashO;
	module.exports = exports['default'];

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrash = function FaTrash(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.9 30.7v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.7 0v-15.7q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m5.8 0v-15.7q0-0.3-0.2-0.5t-0.6-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v15.7q0 0.3 0.2 0.5t0.5 0.2h1.4q0.4 0 0.6-0.2t0.2-0.5z m-12.2-22.1h10l-1.1-2.6q-0.1-0.2-0.3-0.3h-7.1q-0.2 0.1-0.4 0.3z m20.7 0.7v1.4q0 0.3-0.2 0.5t-0.5 0.2h-2.1v21.2q0 1.8-1.1 3.2t-2.5 1.3h-18.6q-1.4 0-2.5-1.3t-1-3.1v-21.3h-2.2q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-0.3 0.2-0.5t0.5-0.2h6.9l1.6-3.8q0.3-0.8 1.2-1.4t1.7-0.5h7.2q0.9 0 1.8 0.5t1.2 1.4l1.5 3.8h6.9q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaTrash;
	module.exports = exports['default'];

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTree = function FaTree(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.6 32.9q0 0.5-0.5 1t-1 0.4h-10.3q0.1 0.4 0.2 1.9t0.1 2.5q0 0.5-0.4 0.9t-1 0.4h-7.1q-0.6 0-1-0.4t-0.4-0.9q0-0.9 0.1-2.5t0.2-1.9h-10.4q-0.5 0-1-0.4t-0.4-1 0.4-1l9-9h-5.1q-0.6 0-1-0.5t-0.4-1 0.4-1l9-9h-4.4q-0.6 0-1-0.4t-0.5-1 0.5-1l8.5-8.6q0.5-0.4 1-0.4t1 0.4l8.6 8.6q0.4 0.4 0.4 1t-0.4 1-1 0.4h-4.4l9 9q0.4 0.4 0.4 1t-0.4 1-1 0.5h-5.1l8.9 8.9q0.5 0.5 0.5 1.1z' })
	        )
	    );
	};
	
	exports.default = FaTree;
	module.exports = exports['default'];

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrello = function FaTrello(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.7 30v-22.9q0-0.3-0.2-0.5t-0.5-0.2h-10.7q-0.3 0-0.5 0.2t-0.2 0.5v22.9q0 0.3 0.2 0.5t0.5 0.2h10.7q0.3 0 0.5-0.2t0.2-0.5z m15-8.6v-14.3q0-0.3-0.2-0.5t-0.5-0.2h-10.7q-0.3 0-0.5 0.2t-0.2 0.5v14.3q0 0.3 0.2 0.5t0.5 0.2h10.7q0.3 0 0.5-0.2t0.2-0.5z m3.6-17.1v31.4q0 0.6-0.4 1t-1 0.4h-31.5q-0.6 0-1-0.4t-0.4-1v-31.4q0-0.6 0.4-1t1-0.4h31.5q0.5 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaTrello;
	module.exports = exports['default'];

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTripadvisor = function FaTripadvisor(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.4 21.8q0 0.7-0.5 1.1t-1.1 0.5q-0.7 0-1.2-0.5t-0.5-1.1q0-0.7 0.5-1.2t1.2-0.5q0.6 0 1.1 0.5t0.5 1.2z m20.2 0q0 0.6-0.5 1.1t-1.1 0.5-1.2-0.5-0.5-1.1 0.5-1.2 1.2-0.5 1.1 0.5 0.5 1.1z m-18.2 0q0-1.4-1-2.4t-2.4-1-2.4 1-1 2.4 1 2.4 2.4 0.9 2.4-0.9 1-2.4z m20.2 0q0-1.5-1-2.4t-2.4-1q-1.4 0-2.4 1t-1 2.4 1 2.3 2.4 1 2.4-1 1-2.4z m-18.7 0q0 2-1.4 3.4t-3.5 1.5q-2 0-3.4-1.5t-1.5-3.4 1.5-3.5 3.4-1.4 3.5 1.4 1.4 3.5z m20.2 0q0 2-1.4 3.4t-3.5 1.4q-2 0-3.4-1.4t-1.5-3.4 1.5-3.5 3.4-1.4q2 0 3.5 1.4t1.4 3.5z m-16.9 0q0-3.3-2.4-5.7t-5.7-2.4q-2.2 0-4 1.1t-3 2.9-1.1 4.1 1.1 4.1 3 2.9 4 1.1q3.4 0 5.7-2.4t2.4-5.7z m11.7-10q-4.4-2-9.7-2-5.6 0-10.1 2 2.1 0 3.9 0.8t3.2 2.1 2.2 3.2 0.8 3.9q0-2 0.7-3.8t2.1-3.2 3.1-2.2 3.8-0.8z m8.4 10q0-3.3-2.4-5.7t-5.7-2.4-5.7 2.4-2.4 5.7 2.4 5.7 5.7 2.4 5.7-2.4 2.4-5.7z m-4.7-9.9h6.7q-0.7 0.9-1.3 2t-0.7 2q1.9 2.6 1.9 5.9 0 2.7-1.3 5t-3.7 3.7-5 1.3q-2.3 0-4.3-0.9t-3.5-2.8q-0.8 1-2.2 3.2-0.2-0.4-1-1.5t-1.3-1.7q-1.4 1.8-3.4 2.7t-4.4 1q-2.7 0-5-1.3t-3.7-3.7-1.3-5q0-3.3 1.9-5.9-0.1-0.9-0.7-2t-1.3-2h6.4q2.6-1.8 6.2-2.7t7.6-1q3.9 0 7.3 0.9t6.1 2.8z' })
	        )
	    );
	};
	
	exports.default = FaTripadvisor;
	module.exports = exports['default'];

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTrophy = function FaTrophy(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.7 19.7q-1.6-3.6-1.6-8.3h-5.7v2.2q0 1.7 2.1 3.6t5.2 2.5z m24.1-6.1v-2.2h-5.7q0 4.7-1.7 8.3 3.2-0.6 5.3-2.5t2.1-3.6z m2.8-2.9v2.9q0 1.6-0.9 3.2t-2.5 2.9-3.8 2.1-4.9 1q-0.9 1.2-2.1 2.2-0.8 0.7-1.1 1.6t-0.4 2q0 1.2 0.7 2t2.2 0.8q1.7 0 3 1t1.3 2.6v1.4q0 0.3-0.2 0.5t-0.5 0.2h-18.6q-0.3 0-0.5-0.2t-0.2-0.5v-1.4q0-1.5 1.3-2.6t3-1q1.5 0 2.1-0.8t0.7-2q0-1.2-0.3-2t-1.2-1.6q-1.2-1-2.1-2.2-2.5-0.1-4.8-1t-3.9-2.1-2.5-2.9-0.9-3.2v-2.9q0-0.9 0.6-1.5t1.5-0.6h6.5v-2.2q0-1.4 1-2.5t2.5-1h12.9q1.5 0 2.5 1t1.1 2.5v2.2h6.4q0.9 0 1.5 0.6t0.6 1.5z' })
	        )
	    );
	};
	
	exports.default = FaTrophy;
	module.exports = exports['default'];

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTruck = function FaTruck(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.9 31.2q0-1.2-0.8-2t-2-0.8-1.9 0.8-0.8 2 0.8 1.9 2 0.8 1.9-0.8 0.8-2z m-8.3-11.2h8.3v-5.6h-3.4q-0.3 0-0.5 0.2l-4.2 4.3q-0.2 0.2-0.2 0.4v0.7z m27.8 11.2q0-1.2-0.8-2t-1.9-0.8-2 0.8-0.8 2 0.8 1.9 2 0.8 1.9-0.8 0.8-2z m5.6-23.7v22.3q0 0.3-0.1 0.5t-0.3 0.4-0.3 0.3-0.5 0.1-0.5 0.1-0.6 0-0.5 0q0 2.3-1.6 3.9t-3.9 1.6-4-1.6-1.6-3.9h-8.4q0 2.3-1.6 3.9t-3.9 1.6-4-1.6-1.6-3.9h-1.4q-0.1 0-0.5 0t-0.6 0-0.5-0.1-0.5-0.1-0.3-0.3-0.3-0.4-0.1-0.5q0-0.6 0.4-1t1-0.4v-7q0-0.2 0-0.8t0-0.8 0-0.7 0.2-0.9 0.3-0.6 0.5-0.7l4.3-4.3q0.4-0.4 1.1-0.7t1.3-0.3h3.4v-4.1q0-0.6 0.5-1t0.9-0.4h22.3q0.6 0 1 0.4t0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaTruck;
	module.exports = exports['default'];

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTry = function FaTry(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm32.7 18.6q0 4.2-2.1 7.8t-5.7 5.8-7.9 2.1h-3.6q-0.3 0-0.5-0.2t-0.2-0.5v-13.7l-4.8 1.5q0 0-0.2 0-0.2 0-0.4-0.1-0.3-0.2-0.3-0.6v-2.8q0-0.6 0.5-0.7l5.2-1.6v-2.1l-4.8 1.5q0 0-0.2 0-0.2 0-0.4-0.1-0.3-0.3-0.3-0.6v-2.9q0-0.5 0.5-0.7l5.2-1.6v-5.5q0-0.3 0.2-0.5t0.5-0.2h3.6q0.3 0 0.5 0.2t0.2 0.5v4l8.4-2.6q0.3-0.1 0.6 0.1t0.3 0.6v2.9q0 0.5-0.5 0.7l-8.8 2.7v2l8.4-2.6q0.3-0.1 0.6 0.2t0.3 0.5v2.9q0 0.5-0.5 0.7l-8.8 2.7v10.9q4.2-0.3 7.1-3.4t2.9-7.3q0-0.3 0.2-0.5t0.5-0.2h3.6q0.3 0 0.5 0.2t0.2 0.5z' })
	        )
	    );
	};
	
	exports.default = FaTry;
	module.exports = exports['default'];

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTty = function FaTty(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm10 29.3v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m-4.3-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m12.9 8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m-4.3-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m-12.8-3.6q-0.7 0-1.1-0.4t-0.4-1v-2.9h11.5v2.9q0 0.6-0.5 1t-1 0.4h-8.5z m25.6 12.2v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m-4.2-8.6v4.3q0 0.3-0.2 0.5t-0.6 0.2h-4.2q-0.4 0-0.6-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.6-0.2h4.2q0.4 0 0.6 0.2t0.2 0.5z m12.8 8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m-4.3-8.6v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m8.6-9.1v0.3h-11.5v-0.2q0-2.3-8.5-2.3-8.5 0-8.5 2.3v0.2h-11.5v-0.3q0-0.4 0.2-1t0.7-1.4 1.5-1.7 2.5-1.7 3.5-1.5 5-1 6.6-0.4 6.5 0.4 5 1 3.6 1.5 2.5 1.7 1.5 1.7 0.7 1.4 0.2 1z m0 9.1v4.3q0 0.3-0.2 0.5t-0.5 0.2h-4.3q-0.3 0-0.5-0.2t-0.2-0.5v-4.3q0-0.3 0.2-0.5t0.5-0.2h4.3q0.3 0 0.5 0.2t0.2 0.5z m0-7.9v2.9q0 0.6-0.4 1t-1.1 0.4h-8.5q-0.6 0-1.1-0.4t-0.4-1v-2.9h11.5z' })
	        )
	    );
	};
	
	exports.default = FaTty;
	module.exports = exports['default'];

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTumblrSquare = function FaTumblrSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.4 32.6l-1.4-4.1q-1 0.5-2.3 0.5-0.8 0-1.4-0.2t-0.9-0.7-0.4-0.9-0.1-1v-8.9h5.8v-4.3h-5.8v-7.3h-4.1q-0.2 0-0.2 0.2-0.2 1-0.4 2t-0.9 2.1-1.7 2.1-2.7 1.5v3.7h2.9v9.4q0 1.2 0.5 2.5t1.5 2.5 2.7 1.9 3.9 0.7q1.5 0 3-0.6t2-1.1z m8.9-23.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaTumblrSquare;
	module.exports = exports['default'];

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTumblr = function FaTumblr(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm29.1 29.7l1.8 5.3q-0.6 0.7-2.5 1.4t-4 0.7q-2.3 0.1-4.2-0.5t-3.2-1.7-2.1-2.4-1.3-2.6-0.3-2.7v-12.1h-3.8v-4.8q1.6-0.6 2.9-1.6t2-2 1.3-2.2 0.8-2.3 0.3-1.9q0-0.1 0.1-0.2t0.2-0.1h5.4v9.5h7.5v5.6h-7.5v11.5q0 0.7 0.2 1.3t0.5 1.2 1.1 0.9 1.8 0.3q1.7 0 3-0.6z' })
	        )
	    );
	};
	
	exports.default = FaTumblr;
	module.exports = exports['default'];

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitch = function FaTwitch(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20 9.7v9.7h-3.2v-9.7h3.2z m8.9 0v9.7h-3.3v-9.7h3.3z m0 17l5.6-5.7v-17.8h-26.6v23.4h7.3v4.9l4.8-4.9h8.9z m8.9-26.7v22.6l-9.7 9.7h-7.3l-4.8 4.8h-4.9v-4.8h-8.9v-25.8l2.5-6.5h33.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitch;
	module.exports = exports['default'];

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitterSquare = function FaTwitterSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.6 13.6q-1.3 0.6-2.7 0.8 1.5-0.9 2-2.6-1.4 0.8-2.9 1.1-1.4-1.5-3.5-1.5-1.9 0-3.3 1.4t-1.3 3.3q0 0.7 0.1 1.1-2.9-0.2-5.4-1.5t-4.3-3.4q-0.7 1.1-0.7 2.3 0 2.6 2.1 3.9-1.1 0-2.3-0.5v0q0 1.7 1.1 3t2.8 1.6q-0.7 0.2-1.1 0.2-0.3 0-0.9-0.1 0.4 1.4 1.6 2.3t2.8 1q-2.6 2-5.9 2-0.6 0-1.1-0.1 3.3 2.1 7.2 2.1 2.5 0 4.7-0.8t3.7-2.1 2.7-3.1 1.7-3.6 0.5-3.7q0-0.4 0-0.7 1.4-1 2.4-2.4z m5.7-4.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaTwitterSquare;
	module.exports = exports['default'];

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaTwitter = function FaTwitter(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.7 9.1q-1.5 2.2-3.7 3.7 0.1 0.3 0.1 1 0 2.9-0.9 5.8t-2.6 5.5-4.1 4.7-5.7 3.3-7.2 1.2q-6.1 0-11.1-3.3 0.8 0.1 1.7 0.1 5 0 9-3-2.4-0.1-4.2-1.5t-2.6-3.5q0.8 0.1 1.4 0.1 1 0 1.9-0.3-2.5-0.5-4.1-2.5t-1.7-4.6v0q1.5 0.8 3.3 0.9-1.5-1-2.4-2.6t-0.8-3.4q0-2 0.9-3.7 2.7 3.4 6.6 5.4t8.3 2.2q-0.2-0.9-0.2-1.7 0-3 2.1-5.1t5.1-2.1q3.2 0 5.3 2.3 2.4-0.5 4.6-1.7-0.8 2.5-3.2 3.9 2.1-0.2 4.2-1.1z' })
	        )
	    );
	};
	
	exports.default = FaTwitter;
	module.exports = exports['default'];

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUmbrella = function FaUmbrella(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.5 18.5v12.9q0 2.3-1.7 4t-4 1.7-4-1.7-1.7-4q0-0.6 0.4-1t1-0.4 1 0.4 0.4 1q0 1.1 0.9 2t2 0.9 2-0.9 0.8-2v-12.9q0.8-0.3 1.5-0.3t1.4 0.3z m17.1 0.6q0 0.3-0.2 0.5t-0.5 0.2q-0.2 0-0.5-0.2-1.1-1.1-2.1-1.6t-2.2-0.5q-1.6 0-2.9 0.8t-2.3 2.2q-0.1 0.2-0.4 0.6t-0.3 0.6q-0.3 0.4-0.6 0.4-0.4 0-0.7-0.4-0.1-0.2-0.3-0.6t-0.4-0.6q-1-1.3-2.3-2.2t-2.8-0.8-2.9 0.8-2.3 2.2q-0.1 0.2-0.4 0.6t-0.3 0.6q-0.2 0.3-0.6 0.3-0.4 0-0.6-0.3-0.1-0.2-0.4-0.6t-0.4-0.6q-0.9-1.3-2.3-2.2t-2.8-0.8q-1.3 0-2.3 0.5t-2.1 1.6q-0.2 0.2-0.5 0.2-0.3 0-0.5-0.2t-0.2-0.5q0-0.1 0-0.2 1-4.1 3.9-7.1t6.6-4.6 8.1-1.5q3.1 0 6.1 0.9t5.5 2.5 4.3 4.2 2.6 5.6q0 0.1 0 0.2z m-17.1-16.2v2.1q-0.9 0-1.4 0t-1.5 0v-2.1q0-0.6 0.5-1t1-0.5 1 0.5 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaUmbrella;
	module.exports = exports['default'];

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUnderline = function FaUnderline(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.1 5q-0.9-0.1-1-0.1l-0.1-2q0.3 0 0.9 0 1.3 0 2.5 0.1 2.9 0.1 3.7 0.1 1.9 0 3.7 0l3.3-0.1q1.3 0 1.9-0.1l0 0.3 0.1 1.5v0.2q-1.4 0.2-2.8 0.2-1.4 0-1.8 0.5-0.3 0.3-0.3 3 0 0.3 0 0.7t0 0.6l0.1 5.1 0.3 6.2q0.1 2.8 1.1 4.5 0.8 1.4 2.2 2.1 1.9 1 3.9 1 2.3 0 4.3-0.6 1.2-0.4 2.2-1.1 1.1-0.8 1.4-1.4 0.8-1.3 1.2-2.6 0.5-1.6 0.5-5.1 0-1.8-0.1-2.9t-0.2-2.7-0.3-3.6l-0.1-1.3q-0.1-1.5-0.6-1.9-0.7-0.8-1.7-0.8l-2.2 0-0.3 0 0-1.9h1.9l4.6 0.2q1.7 0 4.4-0.2l0.4 0q0.1 0.9 0.1 1.1 0 0.2-0.1 0.7-1 0.3-1.9 0.3-1.6 0.3-1.7 0.4-0.4 0.3-0.4 0.9 0 0.2 0.1 0.6t0 0.7q0.2 0.4 0.5 8.9 0.1 4.3-0.4 6.7-0.3 1.7-0.9 2.8-0.8 1.4-2.5 2.7-1.6 1.3-4 2-2.5 0.7-5.7 0.7-3.8 0-6.4-1-2.6-1-4-2.7-1.3-1.7-1.8-4.4-0.4-1.8-0.4-5.3v-7.4q0-4.2-0.3-4.7-0.6-0.9-3.3-0.9z m33.2 31.4v-1.4q0-0.3-0.2-0.5t-0.5-0.2h-32.9q-0.3 0-0.5 0.2t-0.2 0.5v1.4q0 0.3 0.2 0.5t0.5 0.2h32.9q0.3 0 0.5-0.2t0.2-0.5z' })
	        )
	    );
	};
	
	exports.default = FaUnderline;
	module.exports = exports['default'];

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUniversalAccess = function FaUniversalAccess(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.7 14.7q-0.2-0.6-0.7-0.9t-1-0.2q-5.9 1.4-9 1.4t-8.9-1.4q-0.6-0.1-1.1 0.2t-0.7 0.9 0.2 1 0.9 0.7q4.3 1 6.7 1.3 0 3.5-0.3 6t-0.6 3.5-0.9 2.5l-0.2 0.5q-0.2 0.6 0 1.1t0.8 0.8q0.2 0 0.5 0 1 0 1.4-0.9l0.1-0.4q1.2-3.1 1.6-5.8h1q0.3 2.7 1.6 5.8l0.1 0.4q0.4 0.9 1.4 0.9 0.3 0 0.5 0 0.5-0.3 0.8-0.8t0-1.1l-0.2-0.5q-0.6-1.6-0.9-2.5t-0.6-3.5-0.3-6q2.4-0.3 6.7-1.3 0.6-0.1 0.9-0.7t0.2-1z m-7.8-3.3q0-1.2-0.9-2t-2-0.8-2 0.8-0.9 2 0.9 2 2 0.9 2-0.9 0.9-2z m12.8 8.6q0 3.2-1.2 6.1t-3.4 5-5 3.4-6.1 1.2-6.1-1.2-5-3.4-3.4-5-1.2-6.1 1.2-6.1 3.4-5 5-3.4 6.1-1.2 6.1 1.2 5 3.4 3.4 5 1.2 6.1z m-15.7-17.1q-3.5 0-6.7 1.3t-5.4 3.7-3.7 5.4-1.3 6.7 1.3 6.7 3.7 5.4 5.4 3.7 6.7 1.3 6.7-1.3 5.4-3.7 3.7-5.4 1.3-6.7-1.3-6.7-3.7-5.4-5.4-3.7-6.7-1.3z m20 17.1q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
	        )
	    );
	};
	
	exports.default = FaUniversalAccess;
	module.exports = exports['default'];

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUnlockAlt = function FaUnlockAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.6 17.1q0.9 0 1.5 0.7t0.6 1.5v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h0.8v-7.1q0-4.1 2.9-7.1t7.1-2.9 7 2.9 3 7.1q0 0.6-0.5 1t-1 0.4h-1.4q-0.6 0-1-0.4t-0.4-1q0-2.4-1.7-4t-4-1.7-4.1 1.7-1.7 4v7.1h16.5z' })
	        )
	    );
	};
	
	exports.default = FaUnlockAlt;
	module.exports = exports['default'];

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUnlock = function FaUnlock(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.6 12.9v5.7q0 0.6-0.4 1t-1 0.4h-1.4q-0.6 0-1-0.4t-0.4-1v-5.7q0-2.4-1.7-4.1t-4.1-1.7-4 1.7-1.7 4.1v4.2h2.2q0.9 0 1.5 0.7t0.6 1.5v12.8q0 0.9-0.6 1.6t-1.5 0.6h-21.5q-0.8 0-1.5-0.6t-0.6-1.6v-12.8q0-0.9 0.6-1.5t1.5-0.7h15v-4.2q0-4.2 3-7.1t7-2.9 7.1 2.9 2.9 7.1z' })
	        )
	    );
	};
	
	exports.default = FaUnlock;
	module.exports = exports['default'];

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUpload = function FaUpload(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm30.1 32.9q0-0.6-0.5-1t-1-0.5-1 0.5-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m5.7 0q0-0.6-0.4-1t-1-0.5-1 0.5-0.5 1 0.5 1 1 0.4 1-0.4 0.4-1z m2.8-5v7.1q0 0.9-0.6 1.5t-1.5 0.6h-32.9q-0.8 0-1.5-0.6t-0.6-1.5v-7.1q0-0.9 0.6-1.6t1.5-0.6h9.6q0.4 1.3 1.5 2.1t2.5 0.8h5.7q1.4 0 2.5-0.8t1.6-2.1h9.5q0.9 0 1.5 0.6t0.6 1.6z m-7.2-14.5q-0.4 0.9-1.3 0.9h-5.7v10q0 0.6-0.5 1t-1 0.4h-5.7q-0.6 0-1-0.4t-0.4-1v-10h-5.7q-1 0-1.3-0.9-0.4-0.9 0.3-1.5l10-10q0.4-0.5 1-0.5t1 0.5l10 10q0.7 0.6 0.3 1.5z' })
	        )
	    );
	};
	
	exports.default = FaUpload;
	module.exports = exports['default'];

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUsb = function FaUsb(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40.1 18.4q0.2 0.1 0.2 0.5t-0.2 0.5l-5.6 3.3q-0.2 0.1-0.3 0.1-0.2 0-0.3-0.1-0.3-0.1-0.3-0.5v-2.2h-15q0.6 1 1.4 2.9 0.3 0.6 0.5 1t0.4 0.8 0.5 0.8 0.4 0.6 0.6 0.5 0.6 0.1h1.7v-1.7q0-0.2 0.1-0.4t0.4-0.1h5.6q0.3 0 0.4 0.1t0.2 0.4v5.6q0 0.3-0.2 0.4t-0.4 0.2h-5.6q-0.2 0-0.4-0.2t-0.1-0.4v-1.6h-1.7q-0.6 0-1.1-0.2t-0.9-0.4-0.8-0.7-0.6-0.8-0.6-1-0.5-1-0.5-1.1q-0.4-0.9-0.6-1.4t-0.7-1.2-0.8-0.9-0.8-0.3h-6.3q-0.4 1.5-1.6 2.4t-2.7 1q-1.9 0-3.2-1.3t-1.3-3.2 1.3-3.2 3.2-1.3q1.5 0 2.7 0.9t1.6 2.5h1.8q0.5 0 0.9-0.3t0.7-1 0.7-1.1 0.6-1.4q0.3-0.8 0.5-1.1t0.5-1 0.6-1 0.6-0.8 0.8-0.7 0.9-0.4 1.1-0.2h1.9q0.3-1 1.2-1.6t1.9-0.6q1.4 0 2.4 0.9t1 2.4-1 2.4-2.4 1q-1.1 0-1.9-0.6t-1.2-1.7h-1.9q-0.3 0-0.6 0.2t-0.5 0.4-0.5 0.6-0.5 0.9-0.4 0.8-0.4 1q-0.8 1.8-1.5 2.9h19.5v-2.3q0-0.3 0.3-0.5t0.6 0z' })
	        )
	    );
	};
	
	exports.default = FaUsb;
	module.exports = exports['default'];

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUserMd = function FaUserMd(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.1 30q0 0.6-0.5 1t-1 0.4-1-0.4-0.4-1 0.4-1 1-0.4 1 0.4 0.5 1z m22.8 1.4q0 2.7-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.6 0.1-3t0.6-3 1-3 1.8-2.3 2.7-1.4q-0.5 1.2-0.5 2.7v4.6q-1.3 0.4-2.1 1.5t-0.7 2.5q0 1.8 1.2 3t3 1.3 3.1-1.3 1.2-3q0-1.4-0.8-2.5t-2-1.5v-4.6q0-1.4 0.5-2 3 2.3 6.6 2.3t6.6-2.3q0.6 0.6 0.6 2v1.5q-2.4 0-4.1 1.6t-1.7 4.1v2q-0.7 0.6-0.7 1.5 0 0.9 0.7 1.6t1.5 0.6 1.5-0.6 0.6-1.6q0-0.9-0.7-1.5v-2q0-1.2 0.9-2t2-0.9 2 0.9 0.8 2v2q-0.7 0.6-0.7 1.5 0 0.9 0.6 1.6t1.5 0.6 1.6-0.6 0.6-1.6q0-0.9-0.7-1.5v-2q0-1.5-0.8-2.9t-2.1-2.1q0-0.2 0-0.9t0-1.1 0-0.9-0.2-1.1-0.3-0.8q1.5 0.3 2.7 1.3t1.8 2.3 1.1 3 0.5 3 0.1 3z m-7.1-20q0 3.6-2.5 6.1t-6.1 2.5-6-2.5-2.6-6.1 2.6-6 6-2.5 6.1 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaUserMd;
	module.exports = exports['default'];

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUserPlus = function FaUserPlus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.7 20q-3.1 0-5.3-2.2t-2.2-5.3 2.2-5.2 5.3-2.2 5.2 2.2 2.2 5.2-2.2 5.3-5.2 2.2z m18.6 2.5h6.8q0.3 0 0.5 0.2t0.2 0.4v3.7q0 0.3-0.2 0.5t-0.5 0.2h-6.8v6.8q0 0.2-0.2 0.4t-0.4 0.2h-3.7q-0.3 0-0.5-0.2t-0.2-0.4v-6.8h-6.8q-0.3 0-0.4-0.2t-0.2-0.5v-3.7q0-0.2 0.2-0.4t0.4-0.2h6.8v-6.8q0-0.3 0.2-0.5t0.4-0.2h3.8q0.2 0 0.4 0.2t0.2 0.5v6.8z m-14.3 4.3q0 1 0.7 1.8t1.8 0.7h5v4.6q-1.4 1-3.4 1h-16.9q-2.4 0-3.8-1.3t-1.4-3.7q0-1 0.1-2t0.2-2.1 0.6-2.2 0.8-1.8 1.2-1.6 1.7-1.1 2.1-0.3q0.4 0 0.8 0.3 1.5 1.2 3 1.8t3.2 0.6 3.2-0.6 3-1.8q0.3-0.3 0.7-0.3 2.6 0 4.2 1.8h-4.3q-1 0-1.7 0.8t-0.8 1.7v3.7z' })
	        )
	    );
	};
	
	exports.default = FaUserPlus;
	module.exports = exports['default'];

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUserSecret = function FaUserSecret(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.4 34.3l2.1-10-2.1-2.9-2.9-1.4z m5.7 0l2.8-14.3-2.8 1.4-2.2 2.9z m3.5-22.6q0 0 0-0.1-0.3-0.2-2.2-0.2-1.6 0-3.7 0.5-0.2 0-0.5 0t-0.5 0q-2.1-0.5-3.7-0.5-1.9 0-2.1 0.2-0.1 0.1-0.1 0.1 0 0.4 0.1 0.6 0 0.1 0.1 0.2t0.2 0.2q0.1 0.1 0.2 0.5t0.1 0.4 0.2 0.4 0.2 0.4 0.2 0.3 0.3 0.3 0.3 0.2 0.4 0.2 0.4 0.1 0.6 0q0.8 0 1.3-0.2t0.7-0.7 0.3-0.8 0.3-0.6 0.4-0.3h0.3q0.2 0 0.3 0.3t0.3 0.6 0.3 0.8 0.7 0.7 1.4 0.2q0.3 0 0.5 0t0.5-0.1 0.4-0.2 0.3-0.2 0.2-0.3 0.2-0.3 0.2-0.4 0.2-0.4 0.2-0.4 0.1-0.5q0.1-0.1 0.2-0.2t0.2-0.2q0-0.2 0-0.6z m9.3 19.7q0 2.7-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.4 0.1-2.7t0.4-2.8 0.9-2.7 1.4-2.3 2.1-1.7l-2-4.9h4.7q-0.5-1.4-0.5-2.9 0-0.2 0.1-0.7-4.3-0.9-4.3-2.1 0-1.3 4.6-2.2 0.4-1.4 1.2-3t1.6-2.6q0.7-0.8 1.7-0.8 0.6 0 1.8 0.7t1.9 0.7 1.9-0.7 1.9-0.7q0.9 0 1.7 0.8 0.8 1 1.5 2.6t1.2 3q4.7 0.9 4.7 2.2 0 1.2-4.4 2.1 0.2 1.8-0.4 3.6h4.8l-1.9 5q1.5 0.7 2.4 2.2t1.5 3.2 0.7 3.3 0.1 3.4z' })
	        )
	    );
	};
	
	exports.default = FaUserSecret;
	module.exports = exports['default'];

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUserTimes = function FaUserTimes(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm13.7 20q-3.1 0-5.3-2.2t-2.2-5.3 2.2-5.2 5.3-2.2 5.2 2.2 2.2 5.2-2.2 5.3-5.2 2.2z m20.9 6.2l4.8 4.8q0.2 0.2 0.2 0.5 0 0.2-0.2 0.4l-2.6 2.7q-0.2 0.1-0.5 0.1-0.2 0-0.4-0.1l-4.8-4.9-4.9 4.9q-0.2 0.1-0.4 0.1-0.3 0-0.4-0.1l-2.7-2.7q-0.2-0.2-0.2-0.4 0-0.3 0.2-0.5l4.8-4.8-4.8-4.8q-0.2-0.2-0.2-0.5 0-0.2 0.2-0.4l2.6-2.6q0.2-0.2 0.5-0.2 0.2 0 0.4 0.2l4.9 4.8 4.8-4.8q0.2-0.2 0.4-0.2 0.3 0 0.5 0.2l2.6 2.6q0.2 0.2 0.2 0.4 0 0.3-0.2 0.5z m-9.7 0l-3.5 3.5q-0.7 0.7-0.7 1.8 0 1 0.7 1.7l1.6 1.6q-0.4 0.1-0.9 0.1h-16.9q-2.4 0-3.8-1.3t-1.4-3.7q0-1 0.1-2t0.2-2.1 0.6-2.2 0.8-1.8 1.2-1.6 1.7-1.1 2.1-0.3q0.4 0 0.8 0.3 3 2.4 6.2 2.4t6.2-2.4q0.3-0.3 0.7-0.3 0.6 0 1.1 0.1-0.5 0.5-0.8 0.9t-0.2 1.1q0 1.1 0.7 1.8z' })
	        )
	    );
	};
	
	exports.default = FaUserTimes;
	module.exports = exports['default'];

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUser = function FaUser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 31.4q0 2.6-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.2 0.1-2.3t0.3-2.5 0.6-2.4 0.9-2.2 1.4-1.8 1.9-1.2 2.5-0.4q0.2 0 1 0.5t1.6 1 2.4 1.1 3 0.5 3-0.5 2.4-1.1 1.7-1 0.9-0.5q1.4 0 2.5 0.4t1.9 1.2 1.4 1.8 0.9 2.2 0.6 2.4 0.4 2.5 0 2.3z m-7.1-20q0 3.6-2.5 6.1t-6.1 2.5-6-2.5-2.6-6.1 2.6-6 6-2.5 6.1 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaUser;
	module.exports = exports['default'];

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVenusDouble = function FaVenusDouble(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 11.8q0.2 3.5-1.2 6.5t-4.2 5-6 2.3v5.8h5q0.3 0 0.5 0.2t0.2 0.5v1.5q0 0.3-0.2 0.5t-0.5 0.2h-5v5q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-5h-11.4v5q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-5h-5q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h5v-5.8q-3.3-0.3-6-2.3t-4.2-5-1.2-6.5q0.4-4.6 3.7-7.9t7.9-3.8q4.6-0.5 8.4 2.1 3.8-2.6 8.4-2.1 4.6 0.4 7.9 3.8t3.7 7.9z m-20 8q2.9-2.9 2.9-6.9t-2.9-7q-2.9 2.9-2.9 7t2.9 6.9z m-7.1 3.1q2.5 0 4.8-1.3-3.4-3.7-3.4-8.7 0-5 3.4-8.8-2.3-1.2-4.8-1.2-4.2 0-7.1 2.9t-2.9 7.1 2.9 7 7.1 3z m12.8 8.5v-5.8q-3-0.3-5.7-2.1-2.7 1.8-5.7 2.1v5.8h11.4z m1.4-8.5q4.2 0 7.1-3t2.9-7-2.9-7.1-7.1-2.9q-2.5 0-4.8 1.2 3.4 3.8 3.4 8.8 0 5-3.4 8.7 2.3 1.3 4.8 1.3z' })
	        )
	    );
	};
	
	exports.default = FaVenusDouble;
	module.exports = exports['default'];

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVenusMars = function FaVenusMars(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33 2.9q0-0.3 0.2-0.5t0.5-0.2h5.7q0.5 0 0.9 0.4t0.3 0.9v5.7q0 0.3-0.1 0.5t-0.5 0.1h-1.3q-0.2 0-0.4-0.1t-0.2-0.5v-2.7l-5 5.1q1.5 1.9 2.1 4.3t0.2 4.9q-0.7 3.5-3.3 6.1t-6.2 3.1q-4.4 0.7-8.1-1.8-2.3 1.6-5.1 1.9v2.6h1.9q0.3 0 0.5 0.2t0.1 0.4v1.3q0 0.3-0.1 0.5t-0.5 0.1h-1.9v1.9q0 0.3-0.2 0.5t-0.4 0.2h-1.3q-0.3 0-0.5-0.2t-0.1-0.5v-1.9h-1.9q-0.3 0-0.5-0.1t-0.2-0.5v-1.3q0-0.2 0.2-0.4t0.5-0.2h1.9v-2.6q-3.1-0.4-5.6-2.2t-3.7-4.7-0.8-6.1q0.5-3.7 3.2-6.4t6.3-3.3q4.5-0.6 8.2 1.8 2.9-1.9 6.3-1.9 4 0 7.1 2.5l5.1-5h-2.7q-0.2 0-0.4-0.2t-0.2-0.5v-1.2z m-15.2 22q2.5-2.6 2.5-6.2t-2.5-6.2q-2.6 2.6-2.6 6.2t2.6 6.2z m-15.3-6.2q0 3.7 2.6 6.3t6.3 2.6q2.4 0 4.4-1.1-3.1-3.3-3.1-7.8t3.1-7.7q-2-1.2-4.4-1.2-3.6 0-6.3 2.6t-2.6 6.3z m21.6 8.9q3.7 0 6.3-2.6t2.6-6.3-2.6-6.2-6.3-2.7q-2.3 0-4.3 1.2 3.1 3.3 3.1 7.7t-3.1 7.8q2 1.1 4.3 1.1z' })
	        )
	    );
	};
	
	exports.default = FaVenusMars;
	module.exports = exports['default'];

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVenus = function FaVenus(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm33.2 12.9q0 4.9-3.3 8.5t-8.1 4.2v5.8h5q0.3 0 0.5 0.2t0.2 0.5v1.5q0 0.3-0.2 0.5t-0.5 0.2h-5v5q0 0.3-0.2 0.5t-0.5 0.2h-1.5q-0.3 0-0.5-0.2t-0.2-0.5v-5h-5q-0.3 0-0.5-0.2t-0.2-0.5v-1.5q0-0.3 0.2-0.5t0.5-0.2h5v-5.8q-3.3-0.3-6-2.3t-4.2-5-1.2-6.5q0.3-3 1.8-5.5t4.1-4.2 5.5-2q3.8-0.4 7.1 1.2t5.3 4.7 1.9 6.9z m-22.8 0q0 4.1 2.9 7t7.1 3 7-3 3-7-3-7.1-7-2.9-7.1 2.9-2.9 7.1z' })
	        )
	    );
	};
	
	exports.default = FaVenus;
	module.exports = exports['default'];

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaViacoin = function FaViacoin(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm37.3 0l-4.3 10h4.3v4.3h-6.1l-1.3 2.8h7.4v4.3h-9.2l-8 18.6-7.9-18.6h-9.2v-4.3h7.3l-1.2-2.8h-6.1v-4.3h4.3l-4.3-10h5.7l7.2 17.1h8.5l7.2-17.1h5.7z m-17.2 27.1l2.5-5.7h-4.9z' })
	        )
	    );
	};
	
	exports.default = FaViacoin;
	module.exports = exports['default'];

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaViadeoSquare = function FaViadeoSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.4 23.2q0-1.7-0.6-3.2-0.9 0.5-1.9 0.7 0.5 1.1 0.5 2.6 0 2.6-1.7 4.4t-4.3 1.8-4.3-1.8-1.8-4.4q0-2.6 1.8-4.5t4.3-1.9q1.2 0 2.2 0.4 0.1-0.9 0.6-1.9-1.4-0.5-2.8-0.5-3.5 0-5.8 2.5t-2.3 5.8 2.3 5.9 5.8 2.3 5.7-2.3 2.3-5.9z m-3.9-7.9q0 0.5 0 1.6 0 1.4-0.1 2.7t-0.5 3-0.9 2.9-1.5 2.4-2.2 1.5q0.4 0.1 0.9 0.1h0.2q4.9-3.1 4.9-9.2 0-2.6-0.8-5z m0 0q-0.1-1.8-1-3.8t-2.2-2.9q2 3.5 3.2 6.7z m7.4-2.3q0-2.3-1.1-3.9-0.9 1.9-2.8 2.4-1.5 0.4-2.4 1.2t-0.9 2.2q0 0.9 0.5 1.8 1.7-0.4 3.2-1.5t2.1-2.6q-0.1 1.1-1.6 2.5t-3.1 2.2q1.1 1.1 2.4 1.1 1.2 0 2-0.8t1.4-2q0.3-1 0.3-2.6z m7.4-3.7v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaViadeoSquare;
	module.exports = exports['default'];

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaViadeo = function FaViadeo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.9 24.7q0 4.8-3.2 8.3-3.3 3.6-8.5 3.6-5.2 0-8.4-3.6-3.3-3.5-3.3-8.3 0-3.3 1.5-6.1t4.2-4.3 6-1.7q2.2 0 4.1 0.7-0.7 1.4-0.9 2.8-1.5-0.6-3.2-0.6-3.7 0-6.2 2.8t-2.6 6.5q0 3.8 2.5 6.4t6.3 2.6 6.3-2.6 2.5-6.4q0-2-0.7-3.7 1.4-0.3 2.7-1.1 0.9 2.1 0.9 4.7z m-4.5-4.2q0 4.3-1.8 7.7t-5.3 5.6l-0.3 0q-0.7 0-1.4-0.1 1.8-0.7 3.3-2.3t2.2-3.4 1.3-4.2 0.7-4.3 0.1-4q0-1.6 0-2.3 1.2 3.6 1.2 7.3z m-1.2-7.4v0.1q-1.7-4.8-4.6-9.8 1.9 1.3 3.1 4.1t1.5 5.6z m5.4 4.6q-1.9 0-3.6-1.7 4.9-2.7 6.5-5.5 0.4-0.8 0.5-1.3-1 2.1-3.1 3.8t-4.6 2.1q-0.8-1.2-0.8-2.5 0-0.8 0.4-1.8t1-1.5q1-1 3.5-1.6 1.3-0.4 2.3-1.3t1.7-2.3q1.6 2.4 1.6 5.7 0 2.4-0.5 3.8-0.7 1.7-2 2.9t-2.9 1.2z' })
	        )
	    );
	};
	
	exports.default = FaViadeo;
	module.exports = exports['default'];

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVideoCamera = function FaVideoCamera(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm40 7.9v24.2q0 1-0.9 1.4-0.3 0.1-0.5 0.1-0.6 0-1-0.5l-9-8.9v3.7q0 2.6-1.9 4.5t-4.6 1.9h-15.7q-2.6 0-4.5-1.9t-1.9-4.5v-15.8q0-2.6 1.9-4.5t4.5-1.9h15.7q2.7 0 4.6 1.9t1.9 4.5v3.7l9-8.9q0.4-0.5 1-0.5 0.2 0 0.5 0.1 0.9 0.4 0.9 1.4z' })
	        )
	    );
	};
	
	exports.default = FaVideoCamera;
	module.exports = exports['default'];

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVimeoSquare = function FaVimeoSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm31.8 14.2q0.3-4.8-3.6-4.9-5.1-0.2-6.9 5.8 1-0.4 1.8-0.4 1.9 0 1.7 2.1-0.1 1.3-1.7 3.8t-2.3 2.4q-1 0-1.9-3.8-0.3-1.2-1-5.6-0.6-4.3-3.5-4-1.4 0.2-3.7 2.2l-3.6 3.2 1.1 1.5q1.7-1.1 2-1.1 1.3 0 2.4 4 0.3 1.2 1 3.7t1 3.6q1.5 4 3.6 4 3.6 0 8.6-6.5 4.9-6.4 5-10z m5.5-4.9v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaVimeoSquare;
	module.exports = exports['default'];

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVimeo = function FaVimeo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm38.1 11.6q-0.2 5.2-7.4 14.5-7.4 9.6-12.5 9.6-3.2 0-5.4-5.9-0.9-3.5-2.9-10.7-1.6-5.9-3.5-5.9-0.4 0-2.9 1.7l-1.7-2.2q0.6-0.4 2.4-2.1t2.9-2.6q3.5-3.1 5.4-3.2 2.1-0.2 3.4 1.2t1.8 4.5q1 6.4 1.5 8.4 1.2 5.5 2.7 5.5 1.1 0 3.4-3.6 2.3-3.6 2.5-5.5 0.3-3.1-2.5-3.1-1.2 0-2.7 0.6 2.7-8.8 10.3-8.5 5.6 0.2 5.2 7.3z' })
	        )
	    );
	};
	
	exports.default = FaVimeo;
	module.exports = exports['default'];

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVine = function FaVine(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.4 18.5v4.4q-2.2 0.5-4.4 0.5-1.5 3-3.7 6t-4 4.9-2.9 2.3q-1.8 1-3.6 0-0.6-0.4-1.4-1t-1.9-1.9-2.3-2.8-2.4-4.1-2.3-5.5-2.1-7-1.5-8.7h6.3q0.6 4.8 1.6 8.9t2.3 7.1 2.7 5.2 3.1 4.4q3.8-3.8 6.4-9.1-3.1-1.6-4.9-4.9t-1.9-7.4q0-4.3 2.4-7.1t6.3-2.7q4 0 6.1 2.4t2.1 6.6q0 3.5-1.3 6.4-0.1 0-0.4 0t-1 0.1-1.4-0.1-1.4-0.6-1.2-1.2q0.7-2.3 0.7-4.1 0-1.9-0.6-2.9t-1.8-1q-1.2 0-1.9 1.1t-0.7 3.1q0 4.2 2.4 6.6t5.9 2.4q1.4 0 2.7-0.3z' })
	        )
	    );
	};
	
	exports.default = FaVine;
	module.exports = exports['default'];

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVk = function FaVk(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm39.8 12.2q0.5 1.3-3.1 6.1-0.5 0.7-1.4 1.8-1.6 2-1.8 2.7-0.4 0.8 0.3 1.7 0.3 0.4 1.6 1.7h0.1l0 0q3 2.8 4 4.6 0.1 0.1 0.1 0.3t0.2 0.5 0 0.8-0.5 0.5-1.3 0.3l-5.3 0.1q-0.5 0.1-1.1-0.1t-1.1-0.5l-0.4-0.2q-0.7-0.5-1.5-1.4t-1.4-1.6-1.3-1.2-1.1-0.3q-0.1 0-0.2 0.1t-0.4 0.3-0.4 0.6-0.4 1.1-0.1 1.6q0 0.3-0.1 0.5t-0.1 0.4l-0.1 0.1q-0.4 0.4-1.1 0.5h-2.4q-1.5 0.1-3-0.4t-2.8-1.1-2.1-1.3-1.5-1.2l-0.5-0.5q-0.2-0.2-0.6-0.6t-1.4-1.9-2.2-3.2-2.6-4.4-2.7-5.6q-0.1-0.3-0.1-0.6t0-0.3l0.1-0.1q0.3-0.4 1.2-0.4l5.7-0.1q0.2 0.1 0.5 0.2t0.3 0.2l0.1 0q0.3 0.2 0.5 0.7 0.4 1 1 2.1t0.8 1.7l0.3 0.6q0.6 1.3 1.2 2.2t1 1.4 0.9 0.8 0.7 0.3 0.5-0.1q0.1 0 0.1-0.1t0.3-0.5 0.3-0.9 0.2-1.7 0-2.6q-0.1-0.9-0.2-1.5t-0.3-1l-0.1-0.2q-0.5-0.7-1.8-0.9-0.3-0.1 0.1-0.5 0.4-0.4 0.8-0.7 1.1-0.5 5-0.5 1.7 0.1 2.8 0.3 0.4 0.1 0.7 0.3t0.4 0.5 0.2 0.7 0.1 0.9 0 1.1-0.1 1.5 0 1.7q0 0.3 0 0.9t-0.1 1 0.1 0.8 0.3 0.8 0.4 0.6q0.2 0 0.4 0t0.5-0.2 0.8-0.7 1.1-1.4 1.4-2.2q1.2-2.2 2.2-4.7 0.1-0.2 0.2-0.4t0.3-0.2l0 0 0.1-0.1 0.3-0.1 0.4 0 6 0q0.8-0.1 1.3 0t0.7 0.4z' })
	        )
	    );
	};
	
	exports.default = FaVk;
	module.exports = exports['default'];

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVolumeControlPhone = function FaVolumeControlPhone(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.3 37.7q0-0.2-0.3-1.3t-0.7-2.4-0.5-1.5q0-0.1-0.1-0.6t-0.2-0.8-0.3-0.5q-0.3-0.3-1.1-0.3-0.5 0-1.6 0.1t-1.5 0.1q-0.8 0-1.1-0.2-0.1-0.1-0.2-0.4t-0.2-0.4-0.2-0.5-0.1-0.5q-0.8-2.8-0.8-5.6t0.8-5.7q0.1-0.1 0.1-0.4t0.2-0.6 0.2-0.4 0.2-0.4q0.3-0.2 1.1-0.2 0.5 0 1.5 0.1t1.6 0.1q0.8 0 1.1-0.3 0.2-0.2 0.3-0.5t0.2-0.8 0.1-0.6q0.1-0.2 0.5-1.5t0.7-2.4 0.3-1.3q0-0.5-1-1.2t-1.7-0.9q-0.4-0.2-1-0.2-0.7 0-2.2 0.4-1.2 0.4-2.1 0.9t-1.6 1.5-1 1.6-1.1 2.1q-0.1 0.2-0.2 0.4-1.1 2.4-1.5 4.8t-0.4 5.5 0.4 5.4 1.5 4.8q1.3 2.7 1.9 3.6 1.4 2 4 2.8l0.1 0.1q1.5 0.4 2.2 0.4 0.6 0 1-0.2 0.7-0.3 1.7-0.9t1-1.2z m3.5-20.4q-0.6 0-1-0.4t-0.4-1 0.4-1q0.8-0.9 0.8-2 0-1.2-0.8-2.1-0.4-0.4-0.4-1t0.4-1 1-0.4 1 0.4q1.7 1.7 1.7 4.1t-1.7 4q-0.4 0.4-1 0.4z m4.1 4.1q-0.6 0-1-0.5-0.5-0.4-0.5-1t0.5-1q2.5-2.5 2.5-6t-2.5-6.1q-0.5-0.4-0.5-1t0.5-1 1-0.4 1 0.4q3.3 3.3 3.3 8.1t-3.3 8q-0.4 0.5-1 0.5z m4 4q-0.6 0-1-0.4-0.4-0.4-0.4-1t0.4-1q2-2.1 3.1-4.7t1.1-5.4-1.1-5.5-3.1-4.7q-0.4-0.4-0.4-1t0.4-1 1-0.4 1 0.4q2.4 2.5 3.7 5.6t1.3 6.6-1.3 6.5-3.7 5.6q-0.4 0.4-1 0.4z' })
	        )
	    );
	};
	
	exports.default = FaVolumeControlPhone;
	module.exports = exports['default'];

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVolumeDown = function FaVolumeDown(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.1 7.9v24.2q0 0.6-0.4 1t-1 0.5-1-0.5l-7.4-7.4h-5.9q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h5.9l7.4-7.4q0.4-0.5 1-0.5t1 0.5 0.4 1z m8.6 12.1q0 1.7-0.9 3.2t-2.5 2q-0.3 0.2-0.6 0.2-0.6 0-1-0.5t-0.4-1q0-0.4 0.2-0.8t0.7-0.5 0.7-0.5 0.7-0.8 0.3-1.3-0.3-1.3-0.7-0.8-0.7-0.5-0.7-0.5-0.2-0.8q0-0.6 0.4-1t1-0.5q0.3 0 0.6 0.2 1.5 0.6 2.5 2t0.9 3.2z' })
	        )
	    );
	};
	
	exports.default = FaVolumeDown;
	module.exports = exports['default'];

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVolumeOff = function FaVolumeOff(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 7.9v24.2q0 0.6-0.4 1t-1 0.5-1-0.5l-7.4-7.4h-5.9q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h5.9l7.4-7.4q0.4-0.5 1-0.5t1 0.5 0.4 1z' })
	        )
	    );
	};
	
	exports.default = FaVolumeOff;
	module.exports = exports['default'];

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaVolumeUp = function FaVolumeUp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.6 7.9v24.2q0 0.6-0.4 1t-1 0.5-1-0.5l-7.4-7.4h-5.9q-0.6 0-1-0.4t-0.4-1v-8.6q0-0.6 0.4-1t1-0.4h5.9l7.4-7.4q0.4-0.5 1-0.5t1 0.5 0.4 1z m8.6 12.1q0 1.7-0.9 3.2t-2.5 2q-0.3 0.2-0.6 0.2-0.6 0-1-0.5t-0.4-1q0-0.4 0.2-0.8t0.7-0.5 0.7-0.5 0.7-0.8 0.3-1.3-0.3-1.3-0.7-0.8-0.7-0.5-0.7-0.5-0.2-0.8q0-0.6 0.4-1t1-0.5q0.3 0 0.6 0.2 1.5 0.6 2.5 2t0.9 3.2z m5.7 0q0 3.4-1.9 6.3t-5 4.2q-0.3 0.1-0.5 0.1-0.7 0-1.1-0.4t-0.4-1q0-0.9 0.9-1.3 1.2-0.7 1.7-1 1.6-1.2 2.5-3t1-3.9-1-3.9-2.5-3q-0.5-0.3-1.7-1-0.9-0.4-0.9-1.3 0-0.6 0.4-1t1-0.4q0.3 0 0.6 0.1 3.1 1.3 5 4.2t1.9 6.3z m5.7 0q0 5.1-2.8 9.4t-7.5 6.4q-0.3 0.1-0.6 0.1-0.6 0-1-0.5t-0.4-1q0-0.8 0.8-1.3 0.2-0.1 0.5-0.2t0.5-0.2q1.1-0.6 1.9-1.2 2.7-2 4.2-5t1.6-6.5-1.6-6.4-4.2-5.1q-0.8-0.6-1.9-1.2-0.1 0-0.5-0.2t-0.5-0.2q-0.8-0.5-0.8-1.3 0-0.6 0.4-1t1-0.5q0.3 0 0.6 0.1 4.7 2.1 7.5 6.4t2.8 9.4z' })
	        )
	    );
	};
	
	exports.default = FaVolumeUp;
	module.exports = exports['default'];

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWechat = function FaWechat(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm11.3 11.6q0-0.8-0.5-1.3t-1.3-0.5q-0.8 0-1.5 0.5t-0.6 1.3q0 0.7 0.6 1.2t1.5 0.5q0.8 0 1.3-0.5t0.5-1.2z m14.4 9.8q0-0.5-0.5-1t-1.3-0.4q-0.5 0-0.9 0.4t-0.5 1q0 0.5 0.5 1t0.9 0.4q0.8 0 1.3-0.4t0.5-1z m-4.6-9.8q0-0.8-0.5-1.3t-1.2-0.5q-0.9 0-1.5 0.5t-0.7 1.3q0 0.7 0.7 1.2t1.5 0.5q0.7 0 1.2-0.5t0.5-1.2z m12.3 9.8q0-0.5-0.5-1t-1.2-0.4q-0.6 0-1 0.4t-0.4 1q0 0.5 0.4 1t1 0.4q0.7 0 1.2-0.4t0.5-1z m-5.1-7.7q-0.6-0.1-1.4-0.1-3.3 0-6 1.5t-4.4 4.1-1.6 5.5q0 1.5 0.5 3-0.7 0-1.3 0-0.5 0-1 0t-1.1-0.1-0.8-0.1-1.1-0.2-1-0.3l-4.9 2.5 1.4-4.2q-5.6-4-5.6-9.5 0-3.3 1.9-6.1t5.1-4.3 7.1-1.6q3.4 0 6.4 1.3t5.1 3.5 2.7 5.1z m11.5 10.9q0 2.3-1.4 4.3t-3.6 3.8l1.1 3.5-3.9-2.1q-2.9 0.7-4.2 0.7-3.3 0-6-1.4t-4.4-3.7-1.6-5.1 1.6-5.1 4.4-3.8 6-1.3q3.1 0 5.9 1.3t4.4 3.8 1.6 5.1z' })
	        )
	    );
	};
	
	exports.default = FaWechat;
	module.exports = exports['default'];

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWeibo = function FaWeibo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm15.1 28.7q0.4-0.8 0.2-1.6t-1-1.1q-0.8-0.3-1.6 0t-1.4 1q-0.5 0.8-0.3 1.5t1 1.2 1.7 0 1.4-1z m2.1-2.7q0.1-0.3 0-0.6t-0.3-0.4q-0.4-0.2-0.7 0t-0.5 0.4q-0.3 0.7 0.3 1 0.3 0.1 0.7 0t0.5-0.4z m3.8 2.3q-1 2.3-3.5 3.4t-5 0.3q-2.4-0.8-3.3-2.9t0.2-4.1q1-2.1 3.4-3.1t4.7-0.5q2.4 0.7 3.5 2.7t0 4.2z m7-3.5q-0.2-2.2-2-3.8t-4.6-2.5-6.2-0.4q-4.9 0.5-8.2 3.1t-3 5.9q0.2 2.2 2 3.8t4.7 2.5 6.1 0.4q5-0.5 8.3-3.1t2.9-5.9z m6.9 0.1q0 1.5-0.8 3.1t-2.5 3-3.7 2.7-5.1 1.8-6 0.7-6.2-0.7-5.3-2.1-3.9-3.4-1.4-4.4q0-2.6 1.6-5.5t4.4-5.8q3.7-3.7 7.6-5.2t5.5 0.1q1.4 1.4 0.4 4.7-0.1 0.3 0 0.4t0.2 0.2 0.4 0 0.3-0.1l0.1-0.1q3.1-1.3 5.5-1.3t3.4 1.4q1 1.4 0 4 0 0.3-0.1 0.4t0.1 0.3 0.3 0.2 0.3 0.1q1.3 0.4 2.3 1t1.8 1.9 0.8 2.6z m-1.7-14q1 1.1 1.3 2.5t-0.2 2.6q-0.2 0.5-0.7 0.7t-0.9 0.1q-0.6-0.1-0.8-0.6t-0.1-1q0.5-1.4-0.5-2.5t-2.4-0.8q-0.6 0.1-1-0.2t-0.6-0.8q-0.1-0.5 0.2-1t0.8-0.5q1.4-0.3 2.7 0.1t2.2 1.4z m4.1-3.6q1.9 2.1 2.5 5t-0.3 5.4q-0.2 0.6-0.8 0.8t-1.1 0.1-0.9-0.7-0.1-1.2q0.6-1.8 0.2-3.8t-1.8-3.5q-1.4-1.6-3.3-2.2t-3.9-0.2q-0.6 0.2-1.1-0.2t-0.7-1 0.2-1.1 1-0.7q2.7-0.5 5.4 0.3t4.7 3z' })
	        )
	    );
	};
	
	exports.default = FaWeibo;
	module.exports = exports['default'];

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWhatsapp = function FaWhatsapp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm25 21.7q0.3 0 2.2 1t2 1.2q0 0.1 0 0.3 0 0.8-0.4 1.7-0.3 0.9-1.6 1.5t-2.2 0.6q-1.3 0-4.3-1.4-2.2-1-3.8-2.6t-3.3-4.2q-1.6-2.3-1.6-4.3v-0.2q0.1-2 1.7-3.5 0.5-0.5 1.2-0.5 0.1 0 0.4 0t0.4 0.1q0.4 0 0.6 0.1t0.3 0.6q0.2 0.5 0.8 2t0.5 1.7q0 0.5-0.8 1.3t-0.7 1q0 0.2 0.1 0.3 0.7 1.7 2.3 3.1 1.2 1.2 3.3 2.2 0.3 0.2 0.5 0.2 0.4 0 1.2-1.1t1.2-1.1z m-4.5 11.9q2.8 0 5.4-1.1t4.5-3 3-4.5 1.1-5.4-1.1-5.5-3-4.5-4.5-2.9-5.4-1.2-5.5 1.2-4.5 2.9-2.9 4.5-1.2 5.5q0 4.5 2.7 8.2l-1.7 5.2 5.4-1.8q3.5 2.4 7.7 2.4z m0-30.9q3.4 0 6.5 1.4t5.4 3.6 3.5 5.3 1.4 6.6-1.4 6.5-3.5 5.3-5.4 3.6-6.5 1.4q-4.4 0-8.2-2.1l-9.3 3 3-9.1q-2.4-3.9-2.4-8.6 0-3.5 1.4-6.6t3.6-5.3 5.3-3.6 6.6-1.4z' })
	        )
	    );
	};
	
	exports.default = FaWhatsapp;
	module.exports = exports['default'];

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWheelchairAlt = function FaWheelchairAlt(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.1 18.1q0.8 0.8 0.6 1.9l-0.9 12.3q-0.1 0.9-0.8 1.5t-1.6 0.7q-0.1 0-0.2-0.1-1 0-1.6-0.8t-0.6-1.7l0.8-9.6-3.2 0.2q1.2 2.5 1.2 5.4 0 4.8-3.3 8.3l-3-3.1q2-2.3 2-5.2 0-3.3-2.3-5.6t-5.5-2.3q-3 0-5.3 2.1l-3-3.1q2.6-2.5 6.3-3.1l5.9-6.7-3.3-2-4.1 3.6q-0.7 0.7-1.7 0.6t-1.6-0.8-0.6-1.7 0.8-1.6l5.3-4.8q0.6-0.5 1.3-0.6t1.5 0.4l10.8 6.3q0.9 0.4 1.1 1.5 0.4 1.5-0.6 2.6l-4.5 5.2 8.2-0.5q1.1 0 1.9 0.8z m-4.4-10.2q-1.7 0-2.8-1.1t-1.2-2.8 1.2-2.8 2.8-1.2 2.8 1.2 1.2 2.8-1.2 2.8-2.8 1.1z m-14 27.8q2.3 0 4.4-1.4l3.1 3.1q-3.3 2.6-7.5 2.6-3.3 0-6.1-1.6t-4.5-4.5-1.6-6q0-4.2 2.6-7.5l3.1 3.1q-1.3 1.9-1.3 4.4 0 3.2 2.3 5.5t5.5 2.3z' })
	        )
	    );
	};
	
	exports.default = FaWheelchairAlt;
	module.exports = exports['default'];

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWheelchair = function FaWheelchair(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.8 26.5l2.3 4.5q-1.3 4-4.7 6.5t-7.5 2.5q-3.5 0-6.5-1.7t-4.7-4.7-1.7-6.5q0-4 2.3-7.3t6.2-4.7l0.3 2.9q-2.7 1.2-4.3 3.7t-1.6 5.4q0 4.2 2.9 7.1t7.1 2.9q2.8 0 5.1-1.4t3.7-3.9 1.1-5.3z m12.3 2.2l1.3 2.6-5.8 2.8q-0.2 0.2-0.6 0.2-0.9 0-1.3-0.8l-5.3-10.6h-10.5q-0.6 0-1-0.4t-0.5-0.9l-2.1-17.4q-0.1-0.4 0.1-0.9 0.3-1.2 1.3-1.9t2.2-0.7q1.4 0 2.5 1.1t1 2.5q0 1.5-1.1 2.6t-2.7 0.9l0.8 6.5h9.5v2.8h-9.1l0.3 2.9h10.2q0.9 0 1.3 0.8l5 10.1z' })
	        )
	    );
	};
	
	exports.default = FaWheelchair;
	module.exports = exports['default'];

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWifi = function FaWifi(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm19.9 32.2q-0.4 0-1.8-1.5t-1.4-1.8q0-0.6 1.2-1t2-0.4 2 0.4 1.2 1q0 0.4-1.4 1.8t-1.8 1.5z m5.2-5.3q0 0-0.8-0.5t-1.9-0.9-2.5-0.5-2.5 0.5-2 0.9-0.8 0.5q-0.3 0-1.8-1.4t-1.4-1.9q0-0.2 0.1-0.4 1.6-1.5 3.9-2.3t4.5-0.9 4.5 0.9 3.8 2.3q0.2 0.2 0.2 0.4 0 0.4-1.5 1.9t-1.8 1.4z m5.3-5.3q-0.2 0-0.4-0.1-2.7-2.1-4.9-3t-5.2-1q-1.7 0-3.3 0.4t-2.9 1.1-2.2 1.2-1.6 1-0.6 0.4q-0.3 0-1.7-1.4t-1.5-1.8q0-0.3 0.2-0.5 2.6-2.5 6.2-3.9t7.4-1.5 7.4 1.5 6.2 3.9q0.2 0.2 0.2 0.5 0 0.3-1.5 1.8t-1.8 1.4z m5.3-5.2q-0.2 0-0.5-0.2-3.4-3.1-7.2-4.6t-8.1-1.5-8.2 1.5-7.2 4.6q-0.2 0.2-0.4 0.2-0.4 0-1.8-1.5t-1.5-1.8q0-0.2 0.2-0.4 3.6-3.6 8.6-5.6t10.3-2 10.2 2 8.6 5.6q0.2 0.2 0.2 0.4 0 0.4-1.4 1.8t-1.8 1.5z' })
	        )
	    );
	};
	
	exports.default = FaWifi;
	module.exports = exports['default'];

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWikipediaW = function FaWikipediaW(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm26.2 33l-5.2-12.2q-0.4 0.9-2.8 5.4t-3.5 6.8q0 0-0.4 0t-0.5 0q-1.4-3.4-4.5-10.3t-4.5-10.4q-0.4-0.9-1.2-1.9t-1.8-1.8-1.8-0.7q0-0.1 0-0.4t0-0.5h10.2v0.9q-0.7 0-1.4 0.2t-1.1 0.8-0.2 1.1q0.4 1.1 3.8 8.8t4.1 9.4q0.5-1.1 2.4-4.7t2.3-4.3q-0.3-0.7-2.2-4.9t-2.4-5.2q-0.6-1.2-3.5-1.2v-0.9l9 0v0.8q-1 0.1-1.6 0.5t-0.2 1.2q0.5 1.2 1.5 3.3t1.5 3.3q1.9-3.8 3-6.4 0.4-0.9-0.2-1.4t-2.2-0.4q0-0.1 0-0.5v-0.4q1.1 0 3 0t3.1 0 1.7 0v0.8q-1.1 0.1-2.1 0.6t-1.6 1.4l-3.7 7.8q0.2 0.6 2.2 5.1t2.1 4.8l7.7-17.8q-0.2-0.7-0.8-1.1t-1.2-0.6-0.9-0.1v-0.9l8 0.1 0 0 0 0.8q-2.4 0-3.5 2.5-9.2 21.3-9.8 22.6h-0.8z' })
	        )
	    );
	};
	
	exports.default = FaWikipediaW;
	module.exports = exports['default'];

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWindows = function FaWindows(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm16.7 22.5v14.5l-15.2-2.1v-12.4h15.2z m0-16.6v14.7h-15.2v-12.6z m21.9 16.6v17.5l-20.2-2.8v-14.7h20.2z m0-19.6v17.7h-20.2v-15z' })
	        )
	    );
	};
	
	exports.default = FaWindows;
	module.exports = exports['default'];

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWordpress = function FaWordpress(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm2.8 20q0-3.6 1.5-7l8.2 22.4q-4.4-2.1-7-6.2t-2.7-9.2z m28.8-0.9q0 0.5-0.1 0.9t-0.2 1.1-0.3 1-0.3 1.3-0.4 1.3l-1.7 5.7-6.2-18.4q1-0.1 1.9-0.2 0.5-0.1 0.6-0.4t0-0.7-0.7-0.3l-4.6 0.2q-1.6 0-4.5-0.2-0.2 0-0.4 0.1t-0.3 0.3 0 0.4 0.2 0.4 0.4 0.2l1.8 0.2 2.7 7.3-3.8 11.2-6.2-18.5q1-0.1 2-0.2 0.4-0.1 0.5-0.4t0-0.7-0.7-0.3l-4.5 0.2q-0.2 0-0.6 0t-0.5 0q2.3-3.6 6.1-5.7t8.2-2.1q3.3 0 6.3 1.2t5.3 3.3h-0.2q-1.3 0-2.1 0.9t-0.8 2.2q0 0.2 0 0.5t0.1 0.5 0.2 0.5 0.2 0.5 0.3 0.5 0.2 0.4 0.4 0.6 0.3 0.5q1.4 2.4 1.4 4.7z m-11.3 2.4l5.3 14.4q0 0.2 0.1 0.3-2.8 1-5.7 1-2.5 0-4.8-0.7z m14.7-9.7q2.2 3.8 2.2 8.2 0 4.7-2.4 8.6t-6.2 6.2l5.3-15.1q1.3-3.8 1.3-6.2 0-0.9-0.2-1.7z m-15-11.8q4.1 0 7.8 1.6t6.4 4.2 4.2 6.4 1.6 7.8-1.6 7.8-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6z m0 39.1q3.9 0 7.4-1.5t6.1-4.1 4.1-6.1 1.5-7.4-1.5-7.4-4.1-6.1-6.1-4.1-7.4-1.5-7.4 1.5-6.1 4.1-4.1 6.1-1.5 7.4 1.5 7.4 4.1 6.1 6.1 4.1 7.4 1.5z' })
	        )
	    );
	};
	
	exports.default = FaWordpress;
	module.exports = exports['default'];

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWpbeginner = function FaWpbeginner(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm8.6 18.6h3.5v-5h-3.5v5z m18.7 7.4v-2.1q-2.4 0.8-5.5 0.9-3 0-5.8-1.1t-4.9-2.7l0 2.1q2 1.8 4.8 2.9t6 1.1q2.9 0 5.4-1.1z m-13-7.4h14.3v-5h-14.3v5z m25.7-0.7q0 4.1-2.2 7.8 2 2.3 2 5.1 0 3.5-2.9 6t-7 2.5q-2.7 0-5-1.2t-3.6-3.1q-0.5 0-1.3 0t-1.3 0q-1.3 1.9-3.6 3.1t-5 1.2q-4.1 0-7-2.5t-2.9-6q0-2.8 2-5.1-2.2-3.7-2.2-7.8 0-4.7 2.7-8.6t7.3-6.3 10-2.3 10 2.3 7.3 6.3 2.7 8.6z' })
	        )
	    );
	};
	
	exports.default = FaWpbeginner;
	module.exports = exports['default'];

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWpforms = function FaWpforms(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm14.5 20.3v2.9h-5.6v-2.9h5.6z m0-5.7v2.9h-5.6v-2.9h5.6z m16.9 11.4v2.9h-7.6v-2.8h7.6z m0-5.7v2.9h-15v-2.9h15z m0-5.7v2.9h-15v-2.9h15z m3 19.2v-27.6q0-0.2-0.1-0.4t-0.3-0.1h-0.7l-8.5 5.7-4.7-3.8-4.6 3.8-8.5-5.7h-0.7q-0.2 0-0.3 0.1t-0.1 0.4v27.6q0 0.2 0.1 0.4t0.3 0.1h27.7q0.2 0 0.3-0.1t0.1-0.4z m-19.1-24.7l4.2-3.4h-9.1z m9.6 0l5-3.4h-9.1z m12.4-2.9v27.6q0 1.4-1 2.4t-2.3 0.9h-27.7q-1.4 0-2.3-0.9t-1-2.4v-27.6q0-1.4 1-2.4t2.3-0.9h27.7q1.4 0 2.3 0.9t1 2.4z' })
	        )
	    );
	};
	
	exports.default = FaWpforms;
	module.exports = exports['default'];

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaWrench = function FaWrench(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm9.6 32.9q0-0.6-0.5-1t-1-0.5-1 0.5-0.4 1 0.4 1 1 0.4 1-0.4 0.5-1z m14.3-9.4l-15.2 15.2q-0.8 0.8-2 0.8-1.1 0-2-0.8l-2.4-2.4q-0.8-0.8-0.8-2 0-1.2 0.8-2l15.2-15.2q0.9 2.1 2.6 3.8t3.8 2.6z m14.2-9.7q0 0.8-0.5 2.3-1.1 3-3.7 4.9t-5.8 1.9q-4.1 0-7-3t-3-7 3-7.1 7-2.9q1.3 0 2.8 0.3t2.4 1.1q0.3 0.2 0.3 0.6t-0.3 0.6l-6.6 3.8v5l4.3 2.4q0.1-0.1 1.8-1.1t3-1.8 1.6-0.8q0.3 0 0.5 0.2t0.2 0.6z' })
	        )
	    );
	};
	
	exports.default = FaWrench;
	module.exports = exports['default'];

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaXingSquare = function FaXingSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm18.3 17.1q0 0-2.8-5-0.5-0.7-1.2-0.7h-4.1q-0.4 0-0.6 0.2-0.1 0.3 0 0.7l2.8 4.8v0l-4.3 7.7q-0.2 0.3 0 0.6 0.1 0.3 0.5 0.3h4.1q0.7 0 1.1-0.8z m13.9-11.1q-0.1-0.3-0.5-0.3h-4.2q-0.7 0-1.1 0.8l-9.2 16.3q0.1 0 5.9 10.7 0.4 0.8 1.2 0.8h4.1q0.4 0 0.5-0.3 0.2-0.3 0-0.6l-5.8-10.6v-0.1l9.1-16.1q0.2-0.4 0-0.6z m5.1 3.3v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaXingSquare;
	module.exports = exports['default'];

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaXing = function FaXing(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.8 14.9q-0.2 0.4-5.7 10.2-0.6 1-1.5 1h-5.3q-0.5 0-0.7-0.4t0-0.8l5.7-10q0 0 0 0l-3.6-6.2q-0.3-0.5-0.1-0.9 0.2-0.3 0.8-0.3h5.3q0.9 0 1.5 1z m18-14.3q0.3 0.3 0 0.8l-11.8 20.8v0.1l7.5 13.7q0.3 0.4 0.1 0.8-0.3 0.3-0.8 0.3h-5.3q-0.9 0-1.5-1l-7.5-13.8 11.8-21.1q0.6-1 1.4-1h5.4q0.5 0 0.7 0.4z' })
	        )
	    );
	};
	
	exports.default = FaXing;
	module.exports = exports['default'];

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYCombinator = function FaYCombinator(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm21.1 22.4l5.9-11.1h-2.5l-3.5 6.9q-0.5 1.1-1 2.1l-0.9-2.1-3.5-6.9h-2.7l5.9 11v7.2h2.3v-7.1z m16.2-19.5v34.2h-34.3v-34.2h34.3z' })
	        )
	    );
	};
	
	exports.default = FaYCombinator;
	module.exports = exports['default'];

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYahoo = function FaYahoo(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm22.2 21.4l0.3 15.7q-1.4-0.2-2.4-0.2-0.9 0-2.3 0.2l0.3-15.7q-0.9-1.6-3.8-6.6t-4.8-8.4-4.1-6.4q1.3 0.3 2.4 0.3 1 0 2.5-0.3 1.4 2.5 3 5.1t3.7 6.2 3.1 5.1q0.8-1.4 2.5-4t2.6-4.2 2.3-4 2.4-4.2q1.2 0.3 2.4 0.3 1.3 0 2.6-0.3-0.7 0.9-1.4 2t-1.1 1.7-1.3 2.2-1 1.8q-3.3 5.6-7.9 13.7z' })
	        )
	    );
	};
	
	exports.default = FaYahoo;
	module.exports = exports['default'];

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYelp = function FaYelp(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm20.3 29.4v2.9q-0.1 6.5-0.2 6.8-0.2 0.7-1.1 0.9-1.2 0.2-4.1-0.9t-3.6-2q-0.3-0.3-0.4-0.8 0-0.2 0.1-0.5 0.1-0.3 0.8-1.1t4-4.8q0 0 1.4-1.6 0.3-0.4 0.8-0.5t1.1 0.1q0.6 0.2 0.9 0.6t0.3 0.9z m-3.4-5.6q0 1.3-1.1 1.6l-2.7 0.9q-6.1 1.9-6.5 1.9-0.8 0-1.2-0.8-0.3-0.5-0.4-1.6-0.2-1.7 0-3.8t0.7-2.7 1.2-0.8q0.3 0 4.5 1.8 1.6 0.6 2.6 1l1.9 0.8q0.5 0.2 0.8 0.7t0.2 1z m18.5 6.7q-0.2 1.2-2.1 3.6t-3 2.8q-0.8 0.3-1.4-0.2-0.3-0.2-4.1-6.4l-1.1-1.7q-0.3-0.5-0.2-1t0.4-1q0.8-1 1.9-0.6 0 0 2.6 0.9 4.6 1.4 5.4 1.8t1.1 0.4q0.6 0.5 0.5 1.4z m-15-14.1q0.1 2.2-1.2 2.7-1.3 0.4-2.6-1.6l-8.4-13.3q-0.2-0.8 0.4-1.4 0.9-1 4.6-2t5-0.7q0.9 0.2 1.1 1 0.1 0.4 0.5 6.8t0.6 8.5z m14.7 2.4q0.1 0.8-0.5 1.3-0.4 0.2-7.4 1.9-1.5 0.3-2 0.5l0 0q-0.5 0.1-1-0.1t-0.8-0.7q-0.7-1.1 0-2 0 0 1.6-2.2 2.8-3.9 3.4-4.6t0.7-0.9q0.7-0.4 1.5 0 1.1 0.5 2.7 3t1.8 3.7v0.1z' })
	        )
	    );
	};
	
	exports.default = FaYelp;
	module.exports = exports['default'];

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYoutubePlay = function FaYoutubePlay(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm28.6 20q0-0.8-0.7-1.2l-11.4-7.1q-0.7-0.5-1.5-0.1-0.7 0.4-0.7 1.3v14.2q0 0.9 0.7 1.3 0.4 0.2 0.7 0.2 0.5 0 0.8-0.3l11.4-7.1q0.7-0.4 0.7-1.2z m11.4 0q0 2.1 0 3.3t-0.2 3.1-0.5 3.3q-0.4 1.6-1.6 2.7t-2.7 1.3q-5 0.6-15 0.6t-15-0.6q-1.6-0.2-2.8-1.3t-1.5-2.7q-0.3-1.5-0.5-3.3t-0.2-3.1 0-3.3 0-3.3 0.2-3.1 0.5-3.3q0.4-1.6 1.6-2.7t2.7-1.3q5-0.6 15-0.6t15 0.6q1.6 0.2 2.8 1.3t1.5 2.7q0.3 1.5 0.5 3.3t0.2 3.1 0 3.3z' })
	        )
	    );
	};
	
	exports.default = FaYoutubePlay;
	module.exports = exports['default'];

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYoutubeSquare = function FaYoutubeSquare(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm23.5 29.1v-3.5q0-1.1-0.6-1.1-0.4 0-0.8 0.3v5q0.4 0.4 0.8 0.4 0.6 0 0.6-1.1z m4.1-2.7h1.5v-0.8q0-1.1-0.7-1.1t-0.8 1.1v0.8z m-12.7-6v1.6h-1.8v9.4h-1.7v-9.4h-1.7v-1.6h5.2z m4.5 2.8v8.2h-1.5v-0.9q-0.9 1-1.7 1-0.8 0-1-0.6-0.1-0.3-0.1-1.2v-6.5h1.5v6.1q0 0.5 0 0.5 0 0.4 0.3 0.4 0.5 0 1-0.7v-6.3h1.5z m5.6 2.5v3.3q0 1.1-0.2 1.6-0.2 0.9-1.1 0.9-0.8 0-1.6-0.9v0.8h-1.5v-11h1.5v3.6q0.7-0.9 1.6-0.9 0.9 0 1.1 1 0.2 0.4 0.2 1.6z m5.6 2.9v0.2q0 0.6-0.1 1 0 0.4-0.3 0.8-0.6 0.9-1.8 0.9-1.1 0-1.8-0.8-0.5-0.6-0.5-1.9v-2.9q0-1.3 0.5-1.9 0.6-0.9 1.8-0.9t1.7 0.9q0.5 0.6 0.5 1.9v1.7h-3v1.4q0 1.2 0.8 1.2 0.5 0 0.6-0.6 0 0 0.1-0.2t0-0.3v-0.5h1.5z m-10.1-18.4v3.5q0 1.1-0.7 1.1t-0.7-1.1v-3.5q0-1.2 0.7-1.2t0.7 1.2z m11.9 15.9q0-3.9-0.4-5.8-0.2-1-1-1.6t-1.7-0.8q-3-0.3-9.2-0.3-6.1 0-9.1 0.3-1 0.1-1.7 0.8t-1 1.6q-0.4 2-0.4 5.8 0 3.9 0.4 5.8 0.2 1 1 1.7t1.6 0.7q3.1 0.4 9.2 0.4t9.2-0.4q1-0.1 1.7-0.7t1-1.7q0.4-1.9 0.4-5.8z m-16.8-14.5l2-6.6h-1.7l-1.1 4.3-1.2-4.3h-1.8l0.6 1.5 0.5 1.6q0.8 2.3 1 3.5v4.5h1.7v-4.5z m6.4 1.8v-2.9q0-1.3-0.5-1.9-0.6-0.9-1.7-0.9-1.1 0-1.7 0.9-0.5 0.6-0.5 1.9v2.9q0 1.3 0.5 1.9 0.6 0.9 1.7 0.9 1.1 0 1.7-0.9 0.5-0.6 0.5-1.9z m4.1 2.7h1.5v-8.3h-1.5v6.3q-0.5 0.7-1 0.7-0.3 0-0.3-0.3-0.1-0.1-0.1-0.6v-6.1h-1.5v6.6q0 0.8 0.2 1.2 0.2 0.6 0.9 0.6 0.8 0 1.8-1v0.9z m11.2-6.8v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
	        )
	    );
	};
	
	exports.default = FaYoutubeSquare;
	module.exports = exports['default'];

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(2);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaYoutube = function FaYoutube(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm24.7 27.8v4.7q0 1.5-0.9 1.5-0.5 0-1-0.5v-6.7q0.5-0.5 1-0.5 0.9 0 0.9 1.5z m7.5 0v1h-2v-1q0-1.5 1-1.5t1 1.5z m-21.5-4.9h2.3v-2.1h-6.9v2.1h2.3v12.7h2.3v-12.7z m6.4 12.7h2v-11h-2v8.4q-0.7 1-1.3 1-0.4 0-0.5-0.5 0-0.1 0-0.8v-8.1h-2v8.7q0 1.1 0.2 1.7 0.3 0.8 1.3 0.8 1.1 0 2.3-1.4v1.2z m9.6-3.3v-4.4q0-1.6-0.2-2.2-0.4-1.2-1.6-1.2-1.1 0-2.1 1.2v-4.9h-2v14.8h2v-1q1 1.2 2.1 1.2 1.2 0 1.6-1.2 0.2-0.6 0.2-2.3z m7.5-0.2v-0.3h-2q0 1.1-0.1 1.4-0.1 0.8-0.9 0.8-1 0-1-1.6v-1.9h4v-2.3q0-1.8-0.6-2.6-0.9-1.1-2.4-1.1-1.5 0-2.4 1.1-0.6 0.8-0.6 2.6v3.9q0 1.7 0.7 2.5 0.8 1.2 2.4 1.2 1.6 0 2.4-1.2 0.4-0.6 0.5-1.2 0-0.2 0-1.3z m-13.6-20.4v-4.7q0-1.5-0.9-1.5t-1 1.5v4.7q0 1.6 1 1.6t0.9-1.6z m16.1 16.8q0 5.2-0.6 7.8-0.3 1.3-1.3 2.2t-2.3 1q-4.1 0.5-12.4 0.5t-12.3-0.5q-1.3-0.1-2.3-1t-1.3-2.2q-0.6-2.5-0.6-7.8 0-5.2 0.6-7.8 0.3-1.3 1.3-2.2t2.3-1.1q4.1-0.4 12.3-0.4t12.4 0.4q1.3 0.2 2.3 1.1t1.3 2.2q0.6 2.5 0.6 7.8z m-22.3-28.5h2.3l-2.7 8.9v6.1h-2.2v-6.1q-0.4-1.6-1.4-4.7-0.8-2.3-1.5-4.2h2.4l1.6 5.9z m8.3 7.4v3.9q0 1.8-0.7 2.7-0.8 1.1-2.3 1.1-1.5 0-2.4-1.1-0.6-0.9-0.6-2.7v-3.9q0-1.8 0.6-2.6 0.9-1.1 2.4-1.1 1.5 0 2.3 1.1 0.7 0.8 0.7 2.6z m7.4-3.6v11.2h-2v-1.3q-1.2 1.4-2.3 1.4-1 0-1.3-0.8-0.2-0.5-0.2-1.7v-8.8h2v8.2q0 0.7 0.1 0.8 0 0.5 0.4 0.5 0.6 0 1.3-1v-8.5h2z' })
	        )
	    );
	};
	
	exports.default = FaYoutube;
	module.exports = exports['default'];

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button(props) {
	    _classCallCheck(this, Button);
	
	    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	    _this.renderIcon = _this.renderIcon.bind(_this);
	    _this.renderFab = _this.renderFab.bind(_this);
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          node = _props.node,
	          fab = _props.fab,
	          fabClickOnly = _props.fabClickOnly,
	          modal = _props.modal,
	          flat = _props.flat,
	          floating = _props.floating,
	          large = _props.large,
	          disabled = _props.disabled,
	          waves = _props.waves,
	          other = _objectWithoutProperties(_props, ['className', 'node', 'fab', 'fabClickOnly', 'modal', 'flat', 'floating', 'large', 'disabled', 'waves']);
	
	      var toggle = fabClickOnly ? 'click-to-toggle' : '';
	      var C = node;
	      var classes = {
	        btn: true,
	        disabled: disabled,
	        'waves-effect': waves
	      };
	
	      if (_constants2.default.WAVES.indexOf(waves) > -1) {
	        classes['waves-' + waves] = true;
	      }
	
	      var styles = { flat: flat, floating: floating, large: large };
	      _constants2.default.STYLES.forEach(function (style) {
	        classes['btn-' + style] = styles[style];
	      });
	
	      if (modal) {
	        classes['modal-action'] = true;
	        classes['modal-' + modal] = true;
	      }
	      if (fab) {
	        return this.renderFab((0, _classnames2.default)(classes, className), fab, toggle);
	      } else {
	        return _react2.default.createElement(
	          C,
	          _extends({}, other, {
	            disabled: !!disabled,
	            onClick: this.props.onClick,
	            className: (0, _classnames2.default)(classes, className)
	          }),
	          this.renderIcon(),
	          this.props.children
	        );
	      }
	    }
	  }, {
	    key: 'renderFab',
	    value: function renderFab(className, orientation, clickOnly) {
	      var classes = (0, _classnames2.default)(orientation, clickOnly);
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('fixed-action-btn', classes) },
	        _react2.default.createElement(
	          'a',
	          { className: className },
	          this.renderIcon()
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.Children.map(this.props.children, function (child) {
	            return _react2.default.createElement(
	              'li',
	              { key: (0, _idgen2.default)() },
	              child
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon() {
	      var icon = this.props.icon;
	
	      if (!icon) return;
	
	      return _react2.default.createElement(
	        _Icon2.default,
	        null,
	        icon
	      );
	    }
	  }]);
	
	  return Button;
	}(_react.Component);
	
	Button.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  /**
	   * Enable other styles
	   */
	  flat: _propTypes2.default.bool,
	  large: _propTypes2.default.bool,
	  floating: _propTypes2.default.bool,
	  /**
	   * Fixed action button
	   * If enabled, any children button will be rendered as actions, remember to provide an icon.
	   * @default vertical
	   */
	  fab: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  /**
	   * The icon to display, if specified it will create a button with the material icon
	   */
	  icon: _propTypes2.default.string,
	  modal: _propTypes2.default.oneOf(['close', 'confirm']),
	  node: _propTypes2.default.node,
	  /**
	   * Tooltip to show when mouse hovered
	   */
	  onClick: _propTypes2.default.func,
	  tooltip: _propTypes2.default.string,
	  waves: _propTypes2.default.oneOf(_constants2.default.WAVES),
	  /**
	   * FAB Click-Only
	   * Turns a FAB from a hover-toggle to a click-toggle
	   */
	  fabClickOnly: _propTypes2.default.bool
	};
	
	Button.defaultProps = {
	  node: 'button'
	};
	
	exports.default = Button;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(85);
	var Danger = __webpack_require__(1300);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(43);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(801);
	var setInnerHTML = __webpack_require__(122);
	var setTextContent = __webpack_require__(1019);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 793 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactErrorUtils = __webpack_require__(799);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 796 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactPropTypesSecret = __webpack_require__(1329);
	var propTypesFactory = __webpack_require__(991);
	
	var React = __webpack_require__(88);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(55);
	var ReactInstanceMap = __webpack_require__(102);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactUpdates = __webpack_require__(47);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 801 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 802 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 803 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 804 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 806 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var emptyFunction = __webpack_require__(37);
	var warning = __webpack_require__(19);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 808 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 809 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 810 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createStrictShapeTypeChecker = __webpack_require__(824);
	
	var _createStrictShapeTypeChecker2 = _interopRequireDefault(_createStrictShapeTypeChecker);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var EdgeInsetsPropType = (0, _createStrictShapeTypeChecker2.default)({
	  top: _propTypes.number,
	  left: _propTypes.number,
	  bottom: _propTypes.number,
	  right: _propTypes.number
	});
	
	exports.default = EdgeInsetsPropType;
	module.exports = exports['default'];

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _AssetRegistry = __webpack_require__(1444);
	
	var _resolveShadowValue = __webpack_require__(1037);
	
	var _resolveShadowValue2 = _interopRequireDefault(_resolveShadowValue);
	
	var _ImageLoader = __webpack_require__(1445);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _ImageResizeMode = __webpack_require__(1028);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _ImageSourcePropType = __webpack_require__(1396);
	
	var _ImageSourcePropType2 = _interopRequireDefault(_ImageSourcePropType);
	
	var _ImageStylePropTypes = __webpack_require__(1029);
	
	var _ImageStylePropTypes2 = _interopRequireDefault(_ImageStylePropTypes);
	
	var _ImageUriCache = __webpack_require__(1397);
	
	var _ImageUriCache2 = _interopRequireDefault(_ImageUriCache);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetPropType = __webpack_require__(109);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var emptyObject = {};
	
	var STATUS_ERRORED = 'ERRORED';
	var STATUS_LOADED = 'LOADED';
	var STATUS_LOADING = 'LOADING';
	var STATUS_PENDING = 'PENDING';
	var STATUS_IDLE = 'IDLE';
	
	var getImageState = function getImageState(uri, shouldDisplaySource) {
	  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
	};
	
	var resolveAssetDimensions = function resolveAssetDimensions(source) {
	  if (typeof source === 'number') {
	    var _getAssetByID = (0, _AssetRegistry.getAssetByID)(source),
	        height = _getAssetByID.height,
	        width = _getAssetByID.width;
	
	    return { height: height, width: width };
	  } else if (typeof source === 'object') {
	    var _height = source.height,
	        _width = source.width;
	
	    return { height: _height, width: _width };
	  }
	};
	
	var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;
	var resolveAssetUri = function resolveAssetUri(source) {
	  var uri = '';
	  if (typeof source === 'number') {
	    // get the URI from the packager
	    var asset = (0, _AssetRegistry.getAssetByID)(source);
	    var scale = asset.scales[0];
	    var scaleSuffix = scale !== 1 ? '@' + scale + 'x' : '';
	    uri = asset ? asset.httpServerLocation + '/' + asset.name + scaleSuffix + '.' + asset.type : '';
	  } else if (typeof source === 'string') {
	    uri = source;
	  } else if (source && typeof source.uri === 'string') {
	    uri = source.uri;
	  }
	
	  if (uri) {
	    var match = uri.match(svgDataUriPattern);
	    // inline SVG markup may contain characters (e.g., #, ") that need to be escaped
	    if (match) {
	      var prefix = match[1],
	          svg = match[2];
	
	      var encodedSvg = encodeURIComponent(svg);
	      return '' + prefix + encodedSvg;
	    }
	  }
	
	  return uri;
	};
	
	var filterId = 0;
	
	var createTintColorSVG = function createTintColorSVG(tintColor, id) {
	  return tintColor && id != null ? _react2.default.createElement(
	    'svg',
	    { style: { position: 'absolute', height: 0, visibility: 'hidden', width: 0 } },
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement(
	        'filter',
	        { id: 'tint-' + id },
	        _react2.default.createElement('feFlood', { floodColor: '' + tintColor }),
	        _react2.default.createElement('feComposite', { in2: 'SourceAlpha', operator: 'atop' })
	      )
	    )
	  ) : null;
	};
	
	var Image = function (_Component) {
	  _inherits(Image, _Component);
	
	  Image.getSize = function getSize(uri, success, failure) {
	    _ImageLoader2.default.getSize(uri, success, failure);
	  };
	
	  Image.prefetch = function prefetch(uri) {
	    return _ImageLoader2.default.prefetch(uri);
	  };
	
	  function Image(props, context) {
	    _classCallCheck(this, Image);
	
	    // If an image has been loaded before, render it immediately
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this._filterId = 0;
	    _this._imageRef = null;
	    _this._imageRequestId = null;
	    _this._imageState = null;
	    _this._isMounted = false;
	
	    _this._createLayoutHandler = function (resizeMode) {
	      var onLayout = _this.props.onLayout;
	
	      if (resizeMode === 'center' || resizeMode === 'repeat' || onLayout) {
	        return function (e) {
	          var layout = e.nativeEvent.layout;
	
	          onLayout && onLayout(e);
	          _this.setState(function () {
	            return { layout: layout };
	          });
	        };
	      }
	    };
	
	    _this._getBackgroundSize = function (resizeMode) {
	      if (_this._imageRef && (resizeMode === 'center' || resizeMode === 'repeat')) {
	        var _this$_imageRef = _this._imageRef,
	            naturalHeight = _this$_imageRef.naturalHeight,
	            naturalWidth = _this$_imageRef.naturalWidth;
	        var _this$state$layout = _this.state.layout,
	            height = _this$state$layout.height,
	            width = _this$state$layout.width;
	
	        if (naturalHeight && naturalWidth && height && width) {
	          var scaleFactor = Math.min(1, width / naturalWidth, height / naturalHeight);
	          var x = Math.ceil(scaleFactor * naturalWidth);
	          var y = Math.ceil(scaleFactor * naturalHeight);
	          return {
	            backgroundSize: x + 'px ' + y + 'px'
	          };
	        }
	      }
	    };
	
	    _this._onError = function () {
	      var _this$props = _this.props,
	          onError = _this$props.onError,
	          source = _this$props.source;
	
	      _this._updateImageState(STATUS_ERRORED);
	      if (onError) {
	        onError({
	          nativeEvent: {
	            error: 'Failed to load resource ' + resolveAssetUri(source) + ' (404)'
	          }
	        });
	      }
	      _this._onLoadEnd();
	    };
	
	    _this._onLoad = function (e) {
	      var _this$props2 = _this.props,
	          onLoad = _this$props2.onLoad,
	          source = _this$props2.source;
	
	      var event = { nativeEvent: e };
	      _ImageUriCache2.default.add(resolveAssetUri(source));
	      _this._updateImageState(STATUS_LOADED);
	      if (onLoad) {
	        onLoad(event);
	      }
	      _this._onLoadEnd();
	    };
	
	    _this._setImageRef = function (ref) {
	      _this._imageRef = ref;
	    };
	
	    var uri = resolveAssetUri(props.source);
	    var shouldDisplaySource = _ImageUriCache2.default.has(uri);
	    _this.state = { layout: {}, shouldDisplaySource: shouldDisplaySource };
	    _this._imageState = getImageState(uri, shouldDisplaySource);
	    _this._filterId = filterId;
	    filterId++;
	    return _this;
	  }
	
	  Image.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    } else if (this._imageState === STATUS_LOADED) {
	      this._onLoad({ target: this._imageRef });
	    }
	  };
	
	  Image.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevUri = resolveAssetUri(prevProps.source);
	    var uri = resolveAssetUri(this.props.source);
	    if (prevUri !== uri) {
	      _ImageUriCache2.default.remove(prevUri);
	      var isPreviouslyLoaded = _ImageUriCache2.default.has(uri);
	      isPreviouslyLoaded && _ImageUriCache2.default.add(uri);
	      this._updateImageState(getImageState(uri, isPreviouslyLoaded));
	    }
	    if (this._imageState === STATUS_PENDING) {
	      this._createImageLoader();
	    }
	  };
	
	  Image.prototype.componentWillUnmount = function componentWillUnmount() {
	    var uri = resolveAssetUri(this.props.source);
	    _ImageUriCache2.default.remove(uri);
	    this._destroyImageLoader();
	    this._isMounted = false;
	  };
	
	  Image.prototype.render = function render() {
	    var shouldDisplaySource = this.state.shouldDisplaySource;
	
	    var _props = this.props,
	        accessibilityLabel = _props.accessibilityLabel,
	        accessible = _props.accessible,
	        blurRadius = _props.blurRadius,
	        defaultSource = _props.defaultSource,
	        draggable = _props.draggable,
	        source = _props.source,
	        testID = _props.testID,
	        capInsets = _props.capInsets,
	        onError = _props.onError,
	        onLayout = _props.onLayout,
	        onLoad = _props.onLoad,
	        onLoadEnd = _props.onLoadEnd,
	        onLoadStart = _props.onLoadStart,
	        resizeMethod = _props.resizeMethod,
	        resizeMode = _props.resizeMode,
	        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessible', 'blurRadius', 'defaultSource', 'draggable', 'source', 'testID', 'capInsets', 'onError', 'onLayout', 'onLoad', 'onLoadEnd', 'onLoadStart', 'resizeMethod', 'resizeMode']);
	
	    if (false) {
	      if (this.props.src) {
	        console.warn('The <Image> component requires a `source` property rather than `src`.');
	      }
	
	      if (this.props.children) {
	        throw new Error('The <Image> component cannot contain children. If you want to render content on top of the image, consider using the <ImageBackground> component or absolute positioning.');
	      }
	    }
	
	    var selectedSource = shouldDisplaySource ? source : defaultSource;
	    var displayImageUri = resolveAssetUri(selectedSource);
	    var imageSizeStyle = resolveAssetDimensions(selectedSource);
	    var backgroundImage = displayImageUri ? 'url("' + displayImageUri + '")' : null;
	    var flatStyle = Object.assign({}, _StyleSheet2.default.flatten(this.props.style));
	    var finalResizeMode = resizeMode || flatStyle.resizeMode || _ImageResizeMode2.default.cover;
	
	    // CSS filters
	    var filters = [];
	    var tintColor = flatStyle.tintColor;
	    if (flatStyle.filter) {
	      filters.push(flatStyle.filter);
	    }
	    if (blurRadius) {
	      filters.push('blur(' + blurRadius + 'px)');
	    }
	    if (flatStyle.shadowOffset) {
	      var shadowString = (0, _resolveShadowValue2.default)(flatStyle);
	      if (shadowString) {
	        filters.push('drop-shadow(' + shadowString + ')');
	      }
	    }
	    if (flatStyle.tintColor) {
	      filters.push('url(#tint-' + this._filterId + ')');
	    }
	
	    // these styles were converted to filters
	    delete flatStyle.shadowColor;
	    delete flatStyle.shadowOpacity;
	    delete flatStyle.shadowOffset;
	    delete flatStyle.shadowRadius;
	    delete flatStyle.tintColor;
	    // these styles are not supported on View
	    delete flatStyle.overlayColor;
	    delete flatStyle.resizeMode;
	
	    // Accessibility image allows users to trigger the browser's image context menu
	    var hiddenImage = displayImageUri ? (0, _createElement2.default)('img', {
	      alt: accessibilityLabel || '',
	      draggable: draggable || false,
	      ref: this._setImageRef,
	      src: displayImageUri,
	      style: styles.accessibilityImage
	    }) : null;
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, {
	        accessibilityLabel: accessibilityLabel,
	        accessible: accessible,
	        onLayout: this._createLayoutHandler(finalResizeMode),
	        style: [styles.root, this.context.isInAParentText && styles.inline, imageSizeStyle, flatStyle],
	        testID: testID
	      }),
	      _react2.default.createElement(_View2.default, {
	        style: [styles.image, resizeModeStyles[finalResizeMode], this._getBackgroundSize(finalResizeMode), backgroundImage && { backgroundImage: backgroundImage }, filters.length > 0 && { filter: filters.join(' ') }]
	      }),
	      hiddenImage,
	      createTintColorSVG(tintColor, this._filterId)
	    );
	  };
	
	  Image.prototype._createImageLoader = function _createImageLoader() {
	    var source = this.props.source;
	
	    this._destroyImageLoader();
	    var uri = resolveAssetUri(source);
	    this._imageRequestId = _ImageLoader2.default.load(uri, this._onLoad, this._onError);
	    this._onLoadStart();
	  };
	
	  Image.prototype._destroyImageLoader = function _destroyImageLoader() {
	    if (this._imageRequestId) {
	      _ImageLoader2.default.abort(this._imageRequestId);
	      this._imageRequestId = null;
	    }
	  };
	
	  Image.prototype._onLoadEnd = function _onLoadEnd() {
	    var onLoadEnd = this.props.onLoadEnd;
	
	    if (onLoadEnd) {
	      onLoadEnd();
	    }
	  };
	
	  Image.prototype._onLoadStart = function _onLoadStart() {
	    var onLoadStart = this.props.onLoadStart;
	
	    this._updateImageState(STATUS_LOADING);
	    if (onLoadStart) {
	      onLoadStart();
	    }
	  };
	
	  Image.prototype._updateImageState = function _updateImageState(status) {
	    this._imageState = status;
	    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING;
	    // only triggers a re-render when the image is loading (to support PJEG), loaded, or failed
	    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
	      if (this._isMounted) {
	        this.setState(function () {
	          return { shouldDisplaySource: shouldDisplaySource };
	        });
	      }
	    }
	  };
	
	  return Image;
	}(_react.Component);
	
	Image.displayName = 'Image';
	Image.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Image.defaultProps = {
	  style: emptyObject
	};
	Image.resizeMode = _ImageResizeMode2.default;
	Image.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  blurRadius: _propTypes.number,
	  defaultSource: _ImageSourcePropType2.default,
	  draggable: _propTypes.bool,
	  onError: _propTypes.func,
	  onLayout: _propTypes.func,
	  onLoad: _propTypes.func,
	  onLoadEnd: _propTypes.func,
	  onLoadStart: _propTypes.func,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  source: _ImageSourcePropType2.default,
	  style: (0, _StyleSheetPropType2.default)(_ImageStylePropTypes2.default),
	  // compatibility with React Native
	  /* eslint-disable react/sort-prop-types */
	  capInsets: (0, _propTypes.shape)({ top: _propTypes.number, left: _propTypes.number, bottom: _propTypes.number, right: _propTypes.number }),
	  resizeMethod: (0, _propTypes.oneOf)(['auto', 'resize', 'scale'])
	  /* eslint-enable react/sort-prop-types */
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    flexBasis: 'auto',
	    overflow: 'hidden',
	    zIndex: 0
	  },
	  inline: {
	    display: 'inline-flex'
	  },
	  image: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    backgroundColor: 'transparent',
	    backgroundPosition: 'center',
	    backgroundRepeat: 'no-repeat',
	    backgroundSize: 'cover',
	    height: '100%',
	    width: '100%',
	    zIndex: -1
	  }),
	  accessibilityImage: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '100%',
	    opacity: 0,
	    width: '100%',
	    zIndex: -1
	  })
	});
	
	var resizeModeStyles = _StyleSheet2.default.create({
	  center: {
	    backgroundSize: 'auto'
	  },
	  contain: {
	    backgroundSize: 'contain'
	  },
	  cover: {
	    backgroundSize: 'cover'
	  },
	  none: {
	    backgroundPosition: '0 0',
	    backgroundSize: 'auto'
	  },
	  repeat: {
	    backgroundPosition: '0 0',
	    backgroundRepeat: 'repeat',
	    backgroundSize: 'auto'
	  },
	  stretch: {
	    backgroundSize: '100% 100%'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(Image);
	module.exports = exports['default'];

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NativeModules shim
	var NativeModules = {
	  UIManager: _UIManager2.default
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = NativeModules;
	module.exports = exports['default'];

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _unitlessNumbers = __webpack_require__(1059);
	
	var _unitlessNumbers2 = _interopRequireDefault(_unitlessNumbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var normalizeValue = function normalizeValue(property, value) {
	  if (!_unitlessNumbers2.default[property] && typeof value === 'number') {
	    value = value + 'px';
	  }
	  return value;
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	exports.default = normalizeValue;
	module.exports = exports['default'];

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactNativeStyleResolver = __webpack_require__(1419);
	
	var _ReactNativeStyleResolver2 = _interopRequireDefault(_ReactNativeStyleResolver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleResolver = new _ReactNativeStyleResolver2.default(); /**
	                                                               * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                               *
	                                                               * This source code is licensed under the MIT license found in the
	                                                               * LICENSE file in the root directory of this source tree.
	                                                               *
	                                                               * 
	                                                               */
	
	exports.default = styleResolver;
	module.exports = exports['default'];

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetPropType = __webpack_require__(109);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _TextStylePropTypes = __webpack_require__(817);
	
	var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextPropTypes = {
	  accessibilityComponentType: _propTypes.string,
	  accessibilityLabel: _propTypes.string,
	  accessibilityLiveRegion: (0, _propTypes.oneOf)(['assertive', 'none', 'polite']),
	  accessibilityRole: (0, _propTypes.oneOf)(['button', 'heading', 'label', 'link', 'listitem']),
	  accessibilityTraits: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
	  accessible: _propTypes.bool,
	  children: _propTypes.any,
	  importantForAccessibility: (0, _propTypes.oneOf)(['auto', 'no', 'no-hide-descendants', 'yes']),
	  nativeID: _propTypes.string,
	  numberOfLines: _propTypes.number,
	  onBlur: _propTypes.func,
	  onContextMenu: _propTypes.func,
	  onFocus: _propTypes.func,
	  onLayout: _propTypes.func,
	  onPress: _propTypes.func,
	  selectable: _propTypes.bool,
	  style: (0, _StyleSheetPropType2.default)(_TextStylePropTypes2.default),
	  testID: _propTypes.string
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextPropTypes;
	module.exports = exports['default'];

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ViewStylePropTypes = __webpack_require__(108);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]); /**
	                                                                                         * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                         * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                         *
	                                                                                         * This source code is licensed under the MIT license found in the
	                                                                                         * LICENSE file in the root directory of this source tree.
	                                                                                         *
	                                                                                         * 
	                                                                                         */
	
	var TextStylePropTypes = Object.assign({}, _ViewStylePropTypes2.default, {
	  color: _ColorPropType2.default,
	  fontFamily: _propTypes.string,
	  fontFeatureSettings: _propTypes.string,
	  fontSize: numberOrString,
	  fontStyle: _propTypes.string,
	  fontWeight: _propTypes.string,
	  fontVariant: _propTypes.array,
	  letterSpacing: numberOrString,
	  lineHeight: numberOrString,
	  textAlign: (0, _propTypes.oneOf)(['center', 'end', 'inherit', 'justify', 'justify-all', 'left', 'right', 'start']),
	  textAlignVertical: _propTypes.string,
	  textDecorationColor: _ColorPropType2.default,
	  textDecorationLine: _propTypes.string,
	  textDecorationStyle: _propTypes.string,
	  textShadowColor: _ColorPropType2.default,
	  textShadowOffset: (0, _propTypes.shape)({ width: _propTypes.number, height: _propTypes.number }),
	  textShadowRadius: _propTypes.number,
	  writingDirection: (0, _propTypes.oneOf)(['auto', 'ltr', 'rtl']),
	  /* @platform web */
	  textIndent: numberOrString,
	  textOverflow: _propTypes.string,
	  textRendering: (0, _propTypes.oneOf)(['auto', 'geometricPrecision', 'optimizeLegibility', 'optimizeSpeed']),
	  textTransform: (0, _propTypes.oneOf)(['capitalize', 'lowercase', 'none', 'uppercase']),
	  unicodeBidi: (0, _propTypes.oneOf)(['normal', 'bidi-override', 'embed', 'isolate', 'isolate-override', 'plaintext']),
	  whiteSpace: _propTypes.string,
	  wordWrap: _propTypes.string,
	  MozOsxFontSmoothing: _propTypes.string,
	  WebkitFontSmoothing: _propTypes.string
	});
	
	exports.default = TextStylePropTypes;
	module.exports = exports['default'];

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(823);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TextPropTypes = __webpack_require__(816);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Text = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    _classCallCheck(this, Text);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Text.prototype.getChildContext = function getChildContext() {
	    return { isInAParentText: true };
	  };
	
	  Text.prototype.render = function render() {
	    var _props = this.props,
	        dir = _props.dir,
	        numberOfLines = _props.numberOfLines,
	        onPress = _props.onPress,
	        selectable = _props.selectable,
	        style = _props.style,
	        adjustsFontSizeToFit = _props.adjustsFontSizeToFit,
	        allowFontScaling = _props.allowFontScaling,
	        ellipsizeMode = _props.ellipsizeMode,
	        lineBreakMode = _props.lineBreakMode,
	        minimumFontScale = _props.minimumFontScale,
	        onLayout = _props.onLayout,
	        onLongPress = _props.onLongPress,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        selectionColor = _props.selectionColor,
	        suppressHighlighting = _props.suppressHighlighting,
	        textBreakStrategy = _props.textBreakStrategy,
	        tvParallaxProperties = _props.tvParallaxProperties,
	        otherProps = _objectWithoutProperties(_props, ['dir', 'numberOfLines', 'onPress', 'selectable', 'style', 'adjustsFontSizeToFit', 'allowFontScaling', 'ellipsizeMode', 'lineBreakMode', 'minimumFontScale', 'onLayout', 'onLongPress', 'pressRetentionOffset', 'selectionColor', 'suppressHighlighting', 'textBreakStrategy', 'tvParallaxProperties']);
	
	    var isInAParentText = this.context.isInAParentText;
	
	
	    if (onPress) {
	      otherProps.accessible = true;
	      otherProps.onClick = this._createPressHandler(onPress);
	      otherProps.onKeyDown = this._createEnterHandler(onPress);
	    }
	
	    // allow browsers to automatically infer the language writing direction
	    otherProps.dir = dir !== undefined ? dir : 'auto';
	    otherProps.style = [styles.initial, this.context.isInAParentText === true && styles.isInAParentText, style, selectable === false && styles.notSelectable, numberOfLines === 1 && styles.singleLineStyle, onPress && styles.pressable];
	
	    var component = isInAParentText ? 'span' : 'div';
	
	    return (0, _createElement2.default)(component, otherProps);
	  };
	
	  Text.prototype._createEnterHandler = function _createEnterHandler(fn) {
	    return function (e) {
	      if (e.keyCode === 13) {
	        fn && fn(e);
	      }
	    };
	  };
	
	  Text.prototype._createPressHandler = function _createPressHandler(fn) {
	    return function (e) {
	      e.stopPropagation();
	      fn && fn(e);
	    };
	  };
	
	  return Text;
	}(_react.Component);
	
	Text.displayName = 'Text';
	Text.childContextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.contextTypes = {
	  isInAParentText: _propTypes.bool
	};
	Text.propTypes =  false ? _TextPropTypes2.default : {};
	
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    borderWidth: 0,
	    boxSizing: 'border-box',
	    color: 'inherit',
	    display: 'inline',
	    fontFamily: 'System',
	    fontSize: 14,
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit',
	    margin: 0,
	    padding: 0,
	    textDecorationLine: 'none',
	    whiteSpace: 'pre-wrap',
	    wordWrap: 'break-word'
	  },
	  isInAParentText: {
	    // inherit parent font styles
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    whiteSpace: 'inherit'
	  },
	  notSelectable: {
	    userSelect: 'none'
	  },
	  pressable: {
	    cursor: 'pointer'
	  },
	  singleLineStyle: {
	    maxWidth: '100%',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	  }
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(Text));
	module.exports = exports['default'];

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ensurePositiveDelayProps = function ensurePositiveDelayProps(props) {
	  (0, _invariant2.default)(!(props.delayPressIn < 0 || props.delayPressOut < 0 || props.delayLongPress < 0), 'Touchable components cannot have negative delay properties');
	}; /**
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = ensurePositiveDelayProps;
	module.exports = exports['default'];

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _EdgeInsetsPropType = __webpack_require__(811);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _ensurePositiveDelayProps = __webpack_require__(819);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _reactTimerMixin = __webpack_require__(128);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _Touchable = __webpack_require__(127);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                              * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * 
	                                                                                                                                                                                                                              */
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * Do not use unless you have a very good reason. All elements that
	 * respond to press should have a visual feedback when touched.
	 *
	 * TouchableWithoutFeedback supports only one child.
	 * If you wish to have several child components, wrap them in a View.
	 */
	
	/* eslint-disable react/prefer-es6-class, react/prop-types */
	var TouchableWithoutFeedback = (0, _createReactClass2.default)({
	  displayName: 'TouchableWithoutFeedback',
	  mixins: [_reactTimerMixin2.default, _Touchable2.default.Mixin],
	
	  propTypes: {
	    accessibilityComponentType: _ViewPropTypes2.default.accessibilityComponentType,
	    accessibilityLabel: _propTypes.string,
	    accessibilityRole: _ViewPropTypes2.default.accessibilityRole,
	    accessibilityTraits: _ViewPropTypes2.default.accessibilityTraits,
	    accessible: _propTypes.bool,
	    children: _propTypes.any,
	    /**
	     * Delay in ms, from onPressIn, before onLongPress is called.
	     */
	    delayLongPress: _propTypes.number,
	    /**
	     * Delay in ms, from the start of the touch, before onPressIn is called.
	     */
	    delayPressIn: _propTypes.number,
	    /**
	     * Delay in ms, from the release of the touch, before onPressOut is called.
	     */
	    delayPressOut: _propTypes.number,
	    /**
	     * If true, disable all interactions for this component.
	     */
	    disabled: _propTypes.bool,
	    /**
	     * This defines how far your touch can start away from the button. This is
	     * added to `pressRetentionOffset` when moving off of the button.
	     */
	    // $FlowFixMe(>=0.41.0)
	    hitSlop: _EdgeInsetsPropType2.default,
	    /**
	     * Invoked on mount and layout changes with
	     *
	     *   `{nativeEvent: {layout: {x, y, width, height}}}`
	     */
	    onLayout: _propTypes.func,
	    onLongPress: _propTypes.func,
	    /**
	     * Called when the touch is released, but not if cancelled (e.g. by a scroll
	     * that steals the responder lock).
	     */
	    onPress: _propTypes.func,
	    onPressIn: _propTypes.func,
	    onPressOut: _propTypes.func,
	    /**
	     * When the scroll view is disabled, this defines how far your touch may
	     * move off of the button, before deactivating the button. Once deactivated,
	     * try moving it back and you'll see that the button is once again
	     * reactivated! Move it back and forth several times while the scroll view
	     * is disabled. Ensure you pass in a constant to reduce memory allocations.
	     */
	    // $FlowFixMe
	    pressRetentionOffset: _EdgeInsetsPropType2.default,
	    testID: _propTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut || 0;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    // Note(avik): remove dynamic typecast once Flow has been upgraded
	    // $FlowFixMe
	
	
	    var child = _react2.default.Children.only(this.props.children);
	    var children = child.props.children;
	    (0, _warning2.default)(!child.type || child.type.displayName !== 'Text', 'TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See ' + (child._owner && child._owner.getName && child._owner.getName() || '<unknown>'));
	    if (false) {
	      children = _react2.default.Children.toArray(children);
	      children.push(_Touchable2.default.renderDebugView({ color: 'red', hitSlop: this.props.hitSlop }));
	    }
	    var style = _Touchable2.default.TOUCH_TARGET_DEBUG && child.type && child.type.displayName === 'Text' ? [!this.props.disabled && styles.actionable, child.props.style, { color: 'red' }] : [!this.props.disabled && styles.actionable, child.props.style];
	    return _react2.default.cloneElement(child, Object.assign({}, other, {
	      accessible: this.props.accessible !== false,
	      children: children,
	      onKeyDown: this.touchableHandleKeyEvent,
	      onKeyUp: this.touchableHandleKeyEvent,
	      onResponderGrant: this.touchableHandleResponderGrant,
	      onResponderMove: this.touchableHandleResponderMove,
	      onResponderRelease: this.touchableHandleResponderRelease,
	      onResponderTerminate: this.touchableHandleResponderTerminate,
	      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	      style: style
	    }));
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = TouchableWithoutFeedback;
	module.exports = exports['default'];

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _buttonLikeRoles = __webpack_require__(1441);
	
	var _buttonLikeRoles2 = _interopRequireDefault(_buttonLikeRoles);
	
	var _isDisabled = __webpack_require__(1442);
	
	var _isDisabled2 = _interopRequireDefault(_isDisabled);
	
	var _propsToAccessibilityComponent = __webpack_require__(1443);
	
	var _propsToAccessibilityComponent2 = _interopRequireDefault(_propsToAccessibilityComponent);
	
	var _propsToAriaRole = __webpack_require__(1044);
	
	var _propsToAriaRole2 = _interopRequireDefault(_propsToAriaRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var AccessibilityUtil = {
	  buttonLikeRoles: _buttonLikeRoles2.default,
	  isDisabled: _isDisabled2.default,
	  propsToAccessibilityComponent: _propsToAccessibilityComponent2.default,
	  propsToAriaRole: _propsToAriaRole2.default
	};
	
	exports.default = AccessibilityUtil;
	module.exports = exports['default'];

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * This class is responsible for coordinating the "focused"
	 * state for TextInputs. All calls relating to the keyboard
	 * should be funneled through here
	 */
	var TextInputState = {
	  /**
	   * Internal state
	   */
	  _currentlyFocusedNode: null,
	
	  /**
	   * Returns the ID of the currently focused text field, if one exists
	   * If no text field is focused it returns null
	   */
	  currentlyFocusedField: function currentlyFocusedField() {
	    if (document.activeElement !== this._currentlyFocusedNode) {
	      this._currentlyFocusedNode = null;
	    }
	    return this._currentlyFocusedNode;
	  },
	
	
	  /**
	   * @param {Object} TextInputID id of the text field to focus
	   * Focuses the specified text field
	   * noop if the text field was already focused
	   */
	  focusTextInput: function focusTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = textFieldNode;
	      if (document.activeElement !== textFieldNode) {
	        _UIManager2.default.focus(textFieldNode);
	      }
	    }
	  },
	
	
	  /**
	   * @param {Object} textFieldNode id of the text field to focus
	   * Unfocuses the specified text field
	   * noop if it wasn't focused
	   */
	  blurTextInput: function blurTextInput(textFieldNode) {
	    if (textFieldNode !== null) {
	      this._currentlyFocusedNode = null;
	      if (document.activeElement === textFieldNode) {
	        _UIManager2.default.blur(textFieldNode);
	      }
	    }
	  }
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = TextInputState;
	module.exports = exports['default'];

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _debounce = __webpack_require__(155);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2015-present, Nicolas Gallagher.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * @noflow
	                       */
	
	var registry = {};
	
	var id = 1;
	var guid = function guid() {
	  return 'r-' + id++;
	};
	
	var resizeObserver = void 0;
	if (_ExecutionEnvironment.canUseDOM) {
	  if (typeof window.ResizeObserver !== 'undefined') {
	    resizeObserver = new window.ResizeObserver(function (entries) {
	      entries.forEach(function (_ref) {
	        var target = _ref.target;
	
	        var instance = registry[target._layoutId];
	        instance && instance._handleLayout();
	      });
	    });
	  } else {
	    if (false) {
	      console.warn('onLayout relies on ResizeObserver which is not supported by your browser. ' + 'Please include a polyfill, e.g., https://github.com/que-etc/resize-observer-polyfill. ' + 'Falling back to window.onresize.');
	    }
	
	    var triggerAll = function triggerAll() {
	      Object.keys(registry).forEach(function (key) {
	        var instance = registry[key];
	        instance._handleLayout();
	      });
	    };
	
	    window.addEventListener('resize', (0, _debounce2.default)(triggerAll, 16), false);
	  }
	}
	
	var observe = function observe(instance) {
	  var id = guid();
	  registry[id] = instance;
	
	  if (resizeObserver) {
	    var node = (0, _findNodeHandle2.default)(instance);
	    if (node) {
	      node._layoutId = id;
	      resizeObserver.observe(node);
	    }
	  } else {
	    instance._layoutId = id;
	    instance._handleLayout();
	  }
	};
	
	var unobserve = function unobserve(instance) {
	  if (resizeObserver) {
	    var node = (0, _findNodeHandle2.default)(instance);
	    if (node) {
	      delete registry[node._layoutId];
	      delete node._layoutId;
	      resizeObserver.unobserve(node);
	    }
	  } else {
	    delete registry[instance._layoutId];
	    delete instance._layoutId;
	  }
	};
	
	var safeOverride = function safeOverride(original, next) {
	  if (original) {
	    return function prototypeOverride() {
	      /* eslint-disable prefer-rest-params */
	      original.call(this, arguments);
	      next.call(this, arguments);
	      /* eslint-enable prefer-rest-params */
	    };
	  }
	  return next;
	};
	
	var applyLayout = function applyLayout(Component) {
	  var componentDidMount = Component.prototype.componentDidMount;
	  var componentDidUpdate = Component.prototype.componentDidUpdate;
	  var componentWillUnmount = Component.prototype.componentWillUnmount;
	
	  Component.prototype.componentDidMount = safeOverride(componentDidMount, function componentDidMount() {
	    this._layoutState = emptyObject;
	    this._isMounted = true;
	    if (this.props.onLayout) {
	      observe(this);
	    }
	  });
	
	  Component.prototype.componentDidUpdate = safeOverride(componentDidUpdate, function componentDidUpdate(prevProps) {
	    if (this.props.onLayout && !prevProps.onLayout) {
	      observe(this);
	    } else if (!this.props.onLayout && prevProps.onLayout) {
	      unobserve(this);
	    }
	  });
	
	  Component.prototype.componentWillUnmount = safeOverride(componentWillUnmount, function componentWillUnmount() {
	    this._isMounted = false;
	    if (this.props.onLayout) {
	      unobserve(this);
	    }
	  });
	
	  Component.prototype._handleLayout = function () {
	    var _this = this;
	
	    var layout = this._layoutState;
	    var onLayout = this.props.onLayout;
	
	
	    if (onLayout) {
	      this.measure(function (x, y, width, height) {
	        if (_this._isMounted) {
	          if (layout.x !== x || layout.y !== y || layout.width !== width || layout.height !== height) {
	            _this._layoutState = { x: x, y: y, width: width, height: height };
	            var nativeEvent = {
	              layout: _this._layoutState
	            };
	            Object.defineProperty(nativeEvent, 'target', {
	              enumerable: true,
	              get: function get() {
	                return (0, _findNodeHandle2.default)(_this);
	              }
	            });
	            onLayout({ nativeEvent: nativeEvent, timeStamp: Date.now() });
	          }
	        }
	      });
	    }
	  };
	  return Component;
	};
	
	exports.default = applyLayout;
	module.exports = exports['default'];

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStrictShapeTypeChecker(shapeTypes) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    if (!props[propName]) {
	      if (isRequired) {
	        (0, _invariant2.default)(false, 'Required object `' + propName + '` was not specified in `' + componentName + '`.');
	      }
	      return;
	    }
	    var propValue = props[propName];
	    var propType = typeof propValue;
	    var locationName = location || '(unknown)';
	    if (propType !== 'object') {
	      (0, _invariant2.default)(false, 'Invalid ' + locationName + ' `' + propName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    // We need to check all keys in case some are required but missing from
	    // props.
	    var allKeys = Object.assign({}, props[propName], shapeTypes);
	
	    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      rest[_key - 5] = arguments[_key];
	    }
	
	    for (var _key2 in allKeys) {
	      var checker = shapeTypes[_key2];
	      if (!checker) {
	        (0, _invariant2.default)(false, 'Invalid props.' + propName + ' key `' + _key2 + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
	      }
	      var error = checker.apply(undefined, [propValue, _key2, componentName, location].concat(rest));
	      if (error) {
	        (0, _invariant2.default)(false, error.message + '\nBad object: ' + JSON.stringify(props[propName], null, '  '));
	      }
	    }
	  }
	  function chainedCheckType(props, propName, componentName, location) {
	    for (var _len2 = arguments.length, rest = Array(_len2 > 4 ? _len2 - 4 : 0), _key3 = 4; _key3 < _len2; _key3++) {
	      rest[_key3 - 4] = arguments[_key3];
	    }
	
	    return checkType.apply(undefined, [false, props, propName, componentName, location].concat(rest));
	  }
	  chainedCheckType.isRequired = checkType.bind(null, true);
	  return chainedCheckType;
	} /**
	   * Copyright (c) 2015-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   */
	
	exports.default = createStrictShapeTypeChecker;
	module.exports = exports['default'];

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isWebColor = __webpack_require__(1450);
	
	var _isWebColor2 = _interopRequireDefault(_isWebColor);
	
	var _processColor = __webpack_require__(1041);
	
	var _processColor2 = _interopRequireDefault(_processColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var normalizeColor = function normalizeColor(color) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	  if (color == null) return;
	
	  if (typeof color === 'string' && (0, _isWebColor2.default)(color)) {
	    return color;
	  }
	
	  var colorInt = (0, _processColor2.default)(color);
	  if (colorInt != null) {
	    var r = colorInt >> 16 & 255;
	    var g = colorInt >> 8 & 255;
	    var b = colorInt & 255;
	    var a = (colorInt >> 24 & 255) / 255;
	    var alpha = (a * opacity).toFixed(2);
	    return 'rgba(' + r + ',' + g + ',' + b + ',' + alpha + ')';
	  }
	};
	
	exports.default = normalizeColor;
	module.exports = exports['default'];

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.attachNativeEvent = exports.AnimatedEvent = undefined;
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var shouldUseNativeDriver = _NativeAnimatedHelper2.default.shouldUseNativeDriver;
	
	
	function attachNativeEvent(viewRef, eventName, argMapping) {
	  // Find animated values in `argMapping` and create an array representing their
	  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
	  var eventMappings = [];
	
	  var traverse = function traverse(value, path) {
	    if (value instanceof _AnimatedValue2.default) {
	      value.__makeNative();
	
	      eventMappings.push({
	        nativeEventPath: path,
	        animatedValueTag: value.__getNativeTag()
	      });
	    } else if (typeof value === 'object') {
	      for (var _key in value) {
	        traverse(value[_key], path.concat(_key));
	      }
	    }
	  };
	
	  (0, _invariant2.default)(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.');
	
	  // Assume that the event containing `nativeEvent` is always the first argument.
	  traverse(argMapping[0].nativeEvent, []);
	
	  var viewTag = (0, _findNodeHandle2.default)(viewRef);
	
	  eventMappings.forEach(function (mapping) {
	    _NativeAnimatedHelper2.default.API.addAnimatedEventToView(viewTag, eventName, mapping);
	  });
	
	  return {
	    detach: function detach() {
	      eventMappings.forEach(function (mapping) {
	        _NativeAnimatedHelper2.default.API.removeAnimatedEventFromView(viewTag, eventName, mapping.animatedValueTag);
	      });
	    }
	  };
	}
	
	var AnimatedEvent = function () {
	  function AnimatedEvent(argMapping) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, AnimatedEvent);
	
	    this._listeners = [];
	
	    this._argMapping = argMapping;
	    if (config.listener) {
	      this.__addListener(config.listener);
	    }
	    this._callListeners = this._callListeners.bind(this);
	    this._attachedEvent = null;
	    this.__isNative = shouldUseNativeDriver(config);
	
	    if (false) {
	      this._validateMapping();
	    }
	  }
	
	  AnimatedEvent.prototype.__addListener = function __addListener(callback) {
	    this._listeners.push(callback);
	  };
	
	  AnimatedEvent.prototype.__removeListener = function __removeListener(callback) {
	    this._listeners = this._listeners.filter(function (listener) {
	      return listener !== callback;
	    });
	  };
	
	  AnimatedEvent.prototype.__attach = function __attach(viewRef, eventName) {
	    (0, _invariant2.default)(this.__isNative, 'Only native driven events need to be attached.');
	
	    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
	  };
	
	  AnimatedEvent.prototype.__detach = function __detach(viewTag, eventName) {
	    (0, _invariant2.default)(this.__isNative, 'Only native driven events need to be detached.');
	
	    this._attachedEvent && this._attachedEvent.detach();
	  };
	
	  AnimatedEvent.prototype.__getHandler = function __getHandler() {
	    var _this = this;
	
	    if (this.__isNative) {
	      return this._callListeners;
	    }
	
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      var traverse = function traverse(recMapping, recEvt, key) {
	        if (typeof recEvt === 'number' && recMapping instanceof _AnimatedValue2.default) {
	          recMapping.setValue(recEvt);
	        } else if (typeof recMapping === 'object') {
	          for (var mappingKey in recMapping) {
	            /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	             * comment suppresses an error when upgrading Flow's support for
	             * React. To see the error delete this comment and run Flow. */
	            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	          }
	        }
	      };
	
	      if (!_this.__isNative) {
	        _this._argMapping.forEach(function (mapping, idx) {
	          traverse(mapping, args[idx], 'arg' + idx);
	        });
	      }
	      _this._callListeners.apply(_this, args);
	    };
	  };
	
	  AnimatedEvent.prototype._callListeners = function _callListeners() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    this._listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  AnimatedEvent.prototype._validateMapping = function _validateMapping() {
	    var traverse = function traverse(recMapping, recEvt, key) {
	      if (typeof recEvt === 'number') {
	        (0, _invariant2.default)(recMapping instanceof _AnimatedValue2.default, 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
	        return;
	      }
	      (0, _invariant2.default)(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
	      (0, _invariant2.default)(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);
	      for (var mappingKey in recMapping) {
	        traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
	      }
	    };
	  };
	
	  return AnimatedEvent;
	}();
	
	exports.AnimatedEvent = AnimatedEvent;
	exports.attachNativeEvent = attachNativeEvent;
	exports.default = { AnimatedEvent: AnimatedEvent, attachNativeEvent: attachNativeEvent };

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Important note: start() and stop() will only be called at most once.
	// Once an animation has been stopped or finished its course, it will
	// not be reused.
	var Animation = function () {
	  function Animation() {
	    _classCallCheck(this, Animation);
	  }
	
	  Animation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {};
	
	  Animation.prototype.stop = function stop() {
	    if (this.__nativeId) {
	      _NativeAnimatedHelper2.default.API.stopAnimation(this.__nativeId);
	    }
	  };
	
	  Animation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    // Subclasses that have corresponding animation implementation done in native
	    // should override this method
	    throw new Error('This animation type cannot be offloaded to native');
	  };
	  // Helper function for subclasses to make sure onEnd is only called once.
	
	
	  Animation.prototype.__debouncedOnEnd = function __debouncedOnEnd(result) {
	    var onEnd = this.__onEnd;
	    this.__onEnd = null;
	    onEnd && onEnd(result);
	  };
	
	  Animation.prototype.__startNativeAnimation = function __startNativeAnimation(animatedValue) {
	    animatedValue.__makeNative();
	    this.__nativeId = _NativeAnimatedHelper2.default.generateNewAnimationId();
	    _NativeAnimatedHelper2.default.API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
	  };
	
	  return Animation;
	}();
	
	exports.default = Animation;
	module.exports = exports['default'];

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _uniqueId = 1;
	
	/**
	 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
	 * API to normal `Animated.Value`, but multiplexed.
	 *
	 * See http://facebook.github.io/react-native/docs/animatedvaluexy.html
	 */
	
	var AnimatedValueXY = function (_AnimatedWithChildren) {
	  _inherits(AnimatedValueXY, _AnimatedWithChildren);
	
	  function AnimatedValueXY(valueIn) {
	    _classCallCheck(this, AnimatedValueXY);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    var value = valueIn || { x: 0, y: 0 }; // fixme: shouldn't need `: any`
	    if (typeof value.x === 'number' && typeof value.y === 'number') {
	      _this.x = new _AnimatedValue2.default(value.x);
	      _this.y = new _AnimatedValue2.default(value.y);
	    } else {
	      (0, _invariant2.default)(value.x instanceof _AnimatedValue2.default && value.y instanceof _AnimatedValue2.default, 'AnimatedValueXY must be initialized with an object of numbers or ' + 'AnimatedValues.');
	      _this.x = value.x;
	      _this.y = value.y;
	    }
	    _this._listeners = {};
	    return _this;
	  }
	
	  /**
	   * Directly set the value. This will stop any animations running on the value
	   * and update all the bound properties.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setvalue
	   */
	
	
	  AnimatedValueXY.prototype.setValue = function setValue(value) {
	    this.x.setValue(value.x);
	    this.y.setValue(value.y);
	  };
	
	  /**
	   * Sets an offset that is applied on top of whatever value is set, whether
	   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
	   * things like the start of a pan gesture.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setoffset
	   */
	
	
	  AnimatedValueXY.prototype.setOffset = function setOffset(offset) {
	    this.x.setOffset(offset.x);
	    this.y.setOffset(offset.y);
	  };
	
	  /**
	   * Merges the offset value into the base value and resets the offset to zero.
	   * The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#flattenoffset
	   */
	
	
	  AnimatedValueXY.prototype.flattenOffset = function flattenOffset() {
	    this.x.flattenOffset();
	    this.y.flattenOffset();
	  };
	
	  /**
	   * Sets the offset value to the base value, and resets the base value to
	   * zero. The final output of the value is unchanged.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#extractoffset
	   */
	
	
	  AnimatedValueXY.prototype.extractOffset = function extractOffset() {
	    this.x.extractOffset();
	    this.y.extractOffset();
	  };
	
	  AnimatedValueXY.prototype.__getValue = function __getValue() {
	    return {
	      x: this.x.__getValue(),
	      y: this.y.__getValue()
	    };
	  };
	
	  /**
	   * Stops any animation and resets the value to its original.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#resetanimation
	   */
	
	
	  AnimatedValueXY.prototype.resetAnimation = function resetAnimation(callback) {
	    this.x.resetAnimation();
	    this.y.resetAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Stops any running animation or tracking. `callback` is invoked with the
	   * final value after stopping the animation, which is useful for updating
	   * state to match the animation position with layout.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#stopanimation
	   */
	
	
	  AnimatedValueXY.prototype.stopAnimation = function stopAnimation(callback) {
	    this.x.stopAnimation();
	    this.y.stopAnimation();
	    callback && callback(this.__getValue());
	  };
	
	  /**
	   * Adds an asynchronous listener to the value so you can observe updates from
	   * animations.  This is useful because there is no way to synchronously read
	   * the value because it might be driven natively.
	   *
	   * Returns a string that serves as an identifier for the listener.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#addlistener
	   */
	
	
	  AnimatedValueXY.prototype.addListener = function addListener(callback) {
	    var _this2 = this;
	
	    var id = String(_uniqueId++);
	    var jointCallback = function jointCallback(_ref) {
	      var number = _ref.value;
	
	      callback(_this2.__getValue());
	    };
	    this._listeners[id] = {
	      x: this.x.addListener(jointCallback),
	      y: this.y.addListener(jointCallback)
	    };
	    return id;
	  };
	
	  /**
	   * Unregister a listener. The `id` param shall match the identifier
	   * previously returned by `addListener()`.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removelistener
	   */
	
	
	  AnimatedValueXY.prototype.removeListener = function removeListener(id) {
	    this.x.removeListener(this._listeners[id].x);
	    this.y.removeListener(this._listeners[id].y);
	    delete this._listeners[id];
	  };
	
	  /**
	   * Remove all registered listeners.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removealllisteners
	   */
	
	
	  AnimatedValueXY.prototype.removeAllListeners = function removeAllListeners() {
	    this.x.removeAllListeners();
	    this.y.removeAllListeners();
	    this._listeners = {};
	  };
	
	  /**
	   * Converts `{x, y}` into `{left, top}` for use in style.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#getlayout
	   */
	
	
	  AnimatedValueXY.prototype.getLayout = function getLayout() {
	    return {
	      left: this.x,
	      top: this.y
	    };
	  };
	
	  /**
	   * Converts `{x, y}` into a useable translation transform.
	   *
	   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#gettranslatetransform
	   */
	
	
	  AnimatedValueXY.prototype.getTranslateTransform = function getTranslateTransform() {
	    return [{ translateX: this.x }, { translateY: this.y }];
	  };
	
	  return AnimatedValueXY;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedValueXY;
	module.exports = exports['default'];

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Batchinator = __webpack_require__(1472);
	
	var _Batchinator2 = _interopRequireDefault(_Batchinator);
	
	var _FillRateHelper = __webpack_require__(1473);
	
	var _FillRateHelper2 = _interopRequireDefault(_FillRateHelper);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RefreshControl = __webpack_require__(1032);
	
	var _RefreshControl2 = _interopRequireDefault(_RefreshControl);
	
	var _ScrollView = __webpack_require__(107);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewabilityHelper = __webpack_require__(1483);
	
	var _ViewabilityHelper2 = _interopRequireDefault(_ViewabilityHelper);
	
	var _VirtualizeUtils = __webpack_require__(1484);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _infoLog = __webpack_require__(1490);
	
	var _infoLog2 = _interopRequireDefault(_infoLog);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @noflow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var flattenStyle = _StyleSheet2.default.flatten;
	var __DEV__ = ("production") !== 'production';
	/* $FlowFixMe - this Props seems to be missing a bunch of stuff. Remove this
	 * comment to see the errors */
	
	
	var _usedIndexForKey = false;
	
	/**
	 * Base implementation for the more convenient [`<FlatList>`](/react-native/docs/flatlist.html)
	 * and [`<SectionList>`](/react-native/docs/sectionlist.html) components, which are also better
	 * documented. In general, this should only really be used if you need more flexibility than
	 * `FlatList` provides, e.g. for use with immutable data instead of plain arrays.
	 *
	 * Virtualization massively improves memory consumption and performance of large lists by
	 * maintaining a finite render window of active items and replacing all items outside of the render
	 * window with appropriately sized blank space. The window adapts to scrolling behavior, and items
	 * are rendered incrementally with low-pri (after any running interactions) if they are far from the
	 * visible area, or with hi-pri otherwise to minimize the potential of seeing blank space.
	 *
	 * Some caveats:
	 *
	 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
	 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
	 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
	 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
	 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
	 *   changes. This includes the `data` prop and parent component state.
	 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
	 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
	 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
	 *   and we are working on improving it behind the scenes.
	 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
	 *   Alternatively, you can provide a custom `keyExtractor` prop.
	 *
	 */
	var VirtualizedList = function (_React$PureComponent) {
	  _inherits(VirtualizedList, _React$PureComponent);
	
	  // scrollToEnd may be janky without getItemLayout prop
	  VirtualizedList.prototype.scrollToEnd = function scrollToEnd(params) {
	    var animated = params ? params.animated : true;
	    var veryLast = this.props.getItemCount(this.props.data) - 1;
	    var frame = this._getFrameMetricsApprox(veryLast);
	    var offset = Math.max(0, frame.offset + frame.length + this._footerLength - this._scrollMetrics.visibleLength);
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	     * suppresses an error when upgrading Flow's support for React. To see the
	     * error delete this comment and run Flow. */
	    this._scrollRef.scrollTo(
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	     * comment suppresses an error when upgrading Flow's support for React.
	     * To see the error delete this comment and run Flow. */
	    this.props.horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
	  };
	
	  // scrollToIndex may be janky without getItemLayout prop
	
	
	  VirtualizedList.prototype.scrollToIndex = function scrollToIndex(params) {
	    var _props = this.props,
	        data = _props.data,
	        horizontal = _props.horizontal,
	        getItemCount = _props.getItemCount,
	        getItemLayout = _props.getItemLayout,
	        onScrollToIndexFailed = _props.onScrollToIndexFailed;
	    var animated = params.animated,
	        index = params.index,
	        viewOffset = params.viewOffset,
	        viewPosition = params.viewPosition;
	
	    (0, _invariant2.default)(index >= 0 && index < getItemCount(data), 'scrollToIndex out of range: ' + index + ' vs ' + (getItemCount(data) - 1));
	    if (!getItemLayout && index > this._highestMeasuredFrameIndex) {
	      (0, _invariant2.default)(!!onScrollToIndexFailed, 'scrollToIndex should be used in conjunction with getItemLayout or onScrollToIndexFailed, ' + 'otherwise there is no way to know the location of offscreen indices or handle failures.');
	      onScrollToIndexFailed({
	        averageItemLength: this._averageCellLength,
	        highestMeasuredFrameIndex: this._highestMeasuredFrameIndex,
	        index: index
	      });
	      return;
	    }
	    var frame = this._getFrameMetricsApprox(index);
	    var offset = Math.max(0, frame.offset - (viewPosition || 0) * (this._scrollMetrics.visibleLength - frame.length)) - (viewOffset || 0);
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	     * suppresses an error when upgrading Flow's support for React. To see the
	     * error delete this comment and run Flow. */
	    this._scrollRef.scrollTo(
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	     * comment suppresses an error when upgrading Flow's support for React.
	     * To see the error delete this comment and run Flow. */
	    horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
	  };
	
	  // scrollToItem may be janky without getItemLayout prop. Required linear scan through items -
	  // use scrollToIndex instead if possible.
	
	
	  VirtualizedList.prototype.scrollToItem = function scrollToItem(params) {
	    var item = params.item;
	    var _props2 = this.props,
	        data = _props2.data,
	        getItem = _props2.getItem,
	        getItemCount = _props2.getItemCount;
	
	    var itemCount = getItemCount(data);
	    for (var _index = 0; _index < itemCount; _index++) {
	      if (getItem(data, _index) === item) {
	        this.scrollToIndex(Object.assign({}, params, { index: _index }));
	        break;
	      }
	    }
	  };
	
	  /**
	   * Scroll to a specific content pixel offset in the list.
	   *
	   * Param `offset` expects the offset to scroll to.
	   * In case of `horizontal` is true, the offset is the x-value,
	   * in any other case the offset is the y-value.
	   *
	   * Param `animated` (`true` by default) defines whether the list
	   * should do an animation while scrolling.
	   */
	
	
	  VirtualizedList.prototype.scrollToOffset = function scrollToOffset(params) {
	    var animated = params.animated,
	        offset = params.offset;
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	     * suppresses an error when upgrading Flow's support for React. To see the
	     * error delete this comment and run Flow. */
	
	    this._scrollRef.scrollTo(
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	     * comment suppresses an error when upgrading Flow's support for React.
	     * To see the error delete this comment and run Flow. */
	    this.props.horizontal ? { x: offset, animated: animated } : { y: offset, animated: animated });
	  };
	
	  VirtualizedList.prototype.recordInteraction = function recordInteraction() {
	    this._nestedChildLists.forEach(function (childList) {
	      childList.ref && childList.ref.recordInteraction();
	    });
	    this._viewabilityTuples.forEach(function (t) {
	      t.viewabilityHelper.recordInteraction();
	    });
	    this._updateViewableItems(this.props.data);
	  };
	
	  VirtualizedList.prototype.flashScrollIndicators = function flashScrollIndicators() {
	    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	     * suppresses an error when upgrading Flow's support for React. To see the
	     * error delete this comment and run Flow. */
	    this._scrollRef.flashScrollIndicators();
	  };
	
	  /**
	   * Provides a handle to the underlying scroll responder.
	   * Note that `this._scrollRef` might not be a `ScrollView`, so we
	   * need to check that it responds to `getScrollResponder` before calling it.
	   */
	
	
	  VirtualizedList.prototype.getScrollResponder = function getScrollResponder() {
	    if (this._scrollRef && this._scrollRef.getScrollResponder) {
	      return this._scrollRef.getScrollResponder();
	    }
	  };
	
	  VirtualizedList.prototype.getScrollableNode = function getScrollableNode() {
	    if (this._scrollRef && this._scrollRef.getScrollableNode) {
	      return this._scrollRef.getScrollableNode();
	    } else {
	      return (0, _findNodeHandle2.default)(this._scrollRef);
	    }
	  };
	
	  VirtualizedList.prototype.setNativeProps = function setNativeProps(props) {
	    if (this._scrollRef) {
	      this._scrollRef.setNativeProps(props);
	    }
	  };
	
	  VirtualizedList.prototype.getChildContext = function getChildContext() {
	    return {
	      virtualizedList: {
	        getScrollMetrics: this._getScrollMetrics,
	        horizontal: this.props.horizontal,
	        getOutermostParentListRef: this._getOutermostParentListRef,
	        getNestedChildState: this._getNestedChildState,
	        registerAsNestedChild: this._registerAsNestedChild,
	        unregisterAsNestedChild: this._unregisterAsNestedChild
	      }
	    };
	  };
	
	  VirtualizedList.prototype._getCellKey = function _getCellKey() {
	    return this.context.virtualizedCell && this.context.virtualizedCell.cellKey || 'rootList';
	  };
	
	  VirtualizedList.prototype.hasMore = function hasMore() {
	    return this._hasMore;
	  };
	
	  function VirtualizedList(props, context) {
	    _classCallCheck(this, VirtualizedList);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    (0, _invariant2.default)(!props.onScroll || !props.onScroll.__isNative, 'Components based on VirtualizedList must be wrapped with Animated.createAnimatedComponent ' + 'to support native onScroll events with useNativeDriver');
	
	    (0, _invariant2.default)(props.windowSize > 0, 'VirtualizedList: The windowSize prop must be present and set to a value greater than 0.');
	
	    _this._fillRateHelper = new _FillRateHelper2.default(_this._getFrameMetrics);
	    _this._updateCellsToRenderBatcher = new _Batchinator2.default(_this._updateCellsToRender, _this.props.updateCellsBatchingPeriod);
	
	    if (_this.props.viewabilityConfigCallbackPairs) {
	      _this._viewabilityTuples = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
	        return {
	          viewabilityHelper: new _ViewabilityHelper2.default(pair.viewabilityConfig),
	          onViewableItemsChanged: pair.onViewableItemsChanged
	        };
	      });
	    } else if (_this.props.onViewableItemsChanged) {
	      _this._viewabilityTuples.push({
	        viewabilityHelper: new _ViewabilityHelper2.default(_this.props.viewabilityConfig),
	        onViewableItemsChanged: _this.props.onViewableItemsChanged
	      });
	    }
	
	    var initialState = {
	      first: _this.props.initialScrollIndex || 0,
	      last: Math.min(_this.props.getItemCount(_this.props.data), (_this.props.initialScrollIndex || 0) + _this.props.initialNumToRender) - 1
	    };
	
	    if (_this._isNestedWithSameOrientation()) {
	      var storedState = _this.context.virtualizedList.getNestedChildState(_this.props.listKey || _this._getCellKey());
	      if (storedState) {
	        initialState = storedState;
	        _this.state = storedState;
	        _this._frames = storedState.frames;
	      }
	    }
	
	    _this.state = initialState;
	    return _this;
	  }
	
	  VirtualizedList.prototype.componentDidMount = function componentDidMount() {
	    if (this._isNestedWithSameOrientation()) {
	      this.context.virtualizedList.registerAsNestedChild({
	        cellKey: this._getCellKey(),
	        key: this.props.listKey || this._getCellKey(),
	        ref: this
	      });
	    }
	  };
	
	  VirtualizedList.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this._isNestedWithSameOrientation()) {
	      this.context.virtualizedList.unregisterAsNestedChild({
	        key: this.props.listKey || this._getCellKey(),
	        state: {
	          first: this.state.first,
	          last: this.state.last,
	          frames: this._frames
	        }
	      });
	    }
	    this._updateViewableItems(null);
	    this._updateCellsToRenderBatcher.dispose({ abort: true });
	    this._viewabilityTuples.forEach(function (tuple) {
	      tuple.viewabilityHelper.dispose();
	    });
	    this._fillRateHelper.deactivateAndFlush();
	  };
	
	  VirtualizedList.getDerivedStateFromProps = function getDerivedStateFromProps(newProps, prevState) {
	    var data = newProps.data,
	        extraData = newProps.extraData,
	        getItemCount = newProps.getItemCount,
	        maxToRenderPerBatch = newProps.maxToRenderPerBatch;
	    // first and last could be stale (e.g. if a new, shorter items props is passed in), so we make
	    // sure we're rendering a reasonable range here.
	
	    return {
	      first: Math.max(0, Math.min(prevState.first, getItemCount(data) - 1 - maxToRenderPerBatch)),
	      last: Math.max(0, Math.min(prevState.last, getItemCount(data) - 1))
	    };
	  };
	
	  VirtualizedList.prototype._pushCells = function _pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, first, last, inversionStyle) {
	    var _this2 = this;
	
	    var _props3 = this.props,
	        CellRendererComponent = _props3.CellRendererComponent,
	        ItemSeparatorComponent = _props3.ItemSeparatorComponent,
	        data = _props3.data,
	        getItem = _props3.getItem,
	        getItemCount = _props3.getItemCount,
	        horizontal = _props3.horizontal,
	        keyExtractor = _props3.keyExtractor;
	
	    var stickyOffset = this.props.ListHeaderComponent ? 1 : 0;
	    var end = getItemCount(data) - 1;
	    var prevCellKey = void 0;
	    last = Math.min(end, last);
	
	    var _loop = function _loop(ii) {
	      var item = getItem(data, ii);
	      var key = keyExtractor(item, ii);
	      _this2._indicesToKeys.set(ii, key);
	      if (stickyIndicesFromProps.has(ii + stickyOffset)) {
	        stickyHeaderIndices.push(cells.length);
	      }
	      cells.push(_react2.default.createElement(CellRenderer, {
	        CellRendererComponent: CellRendererComponent,
	        ItemSeparatorComponent: ii < end ? ItemSeparatorComponent : undefined,
	        cellKey: key,
	        fillRateHelper: _this2._fillRateHelper,
	        horizontal: horizontal,
	        index: ii,
	        inversionStyle: inversionStyle,
	        item: item,
	        key: key,
	        prevCellKey: prevCellKey,
	        onUpdateSeparators: _this2._onUpdateSeparators,
	        onLayout: function onLayout(e) {
	          return _this2._onCellLayout(e, key, ii);
	        },
	        onUnmount: _this2._onCellUnmount,
	        parentProps: _this2.props,
	        ref: function (_ref) {
	          function ref(_x) {
	            return _ref.apply(this, arguments);
	          }
	
	          ref.toString = function () {
	            return _ref.toString();
	          };
	
	          return ref;
	        }(function (ref) {
	          _this2._cellRefs[key] = ref;
	        })
	      }));
	      prevCellKey = key;
	    };
	
	    for (var ii = first; ii <= last; ii++) {
	      _loop(ii);
	    }
	  };
	
	  VirtualizedList.prototype._isVirtualizationDisabled = function _isVirtualizationDisabled() {
	    return this.props.disableVirtualization;
	  };
	
	  VirtualizedList.prototype._isNestedWithSameOrientation = function _isNestedWithSameOrientation() {
	    var nestedContext = this.context.virtualizedList;
	    return !!(nestedContext && !!nestedContext.horizontal === !!this.props.horizontal);
	  };
	
	  VirtualizedList.prototype.render = function render() {
	    if (__DEV__) {
	      var flatStyles = flattenStyle(this.props.contentContainerStyle);
	      (0, _warning2.default)(flatStyles == null || flatStyles.flexWrap !== 'wrap', '`flexWrap: `wrap`` is not supported with the `VirtualizedList` components.' + 'Consider using `numColumns` with `FlatList` instead.');
	    }
	    var _props4 = this.props,
	        ListEmptyComponent = _props4.ListEmptyComponent,
	        ListFooterComponent = _props4.ListFooterComponent,
	        ListHeaderComponent = _props4.ListHeaderComponent;
	    var _props5 = this.props,
	        data = _props5.data,
	        horizontal = _props5.horizontal;
	
	    var isVirtualizationDisabled = this._isVirtualizationDisabled();
	    var inversionStyle = this.props.inverted ? this.props.horizontal ? styles.horizontallyInverted : styles.verticallyInverted : null;
	    var cells = [];
	    var stickyIndicesFromProps = new Set(this.props.stickyHeaderIndices);
	    var stickyHeaderIndices = [];
	    if (ListHeaderComponent) {
	      if (stickyIndicesFromProps.has(0)) {
	        stickyHeaderIndices.push(0);
	      }
	      var element = _react2.default.isValidElement(ListHeaderComponent) ? ListHeaderComponent :
	      // $FlowFixMe
	      _react2.default.createElement(ListHeaderComponent, null);
	      cells.push(_react2.default.createElement(
	        VirtualizedCellWrapper,
	        {
	          cellKey: this._getCellKey() + '-header',
	          key: '$header' },
	        _react2.default.createElement(
	          _View2.default,
	          { onLayout: this._onLayoutHeader, style: inversionStyle },
	          element
	        )
	      ));
	    }
	    var itemCount = this.props.getItemCount(data);
	    if (itemCount > 0) {
	      _usedIndexForKey = false;
	      var spacerKey = !horizontal ? 'height' : 'width';
	      var lastInitialIndex = this.props.initialScrollIndex ? -1 : this.props.initialNumToRender - 1;
	      var _state = this.state,
	          _first = _state.first,
	          _last = _state.last;
	
	      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, 0, lastInitialIndex, inversionStyle);
	      var firstAfterInitial = Math.max(lastInitialIndex + 1, _first);
	      if (!isVirtualizationDisabled && _first > lastInitialIndex + 1) {
	        var insertedStickySpacer = false;
	        if (stickyIndicesFromProps.size > 0) {
	          var stickyOffset = ListHeaderComponent ? 1 : 0;
	          // See if there are any sticky headers in the virtualized space that we need to render.
	          for (var ii = firstAfterInitial - 1; ii > lastInitialIndex; ii--) {
	            if (stickyIndicesFromProps.has(ii + stickyOffset)) {
	              var _ref2, _ref3;
	
	              var initBlock = this._getFrameMetricsApprox(lastInitialIndex);
	              var stickyBlock = this._getFrameMetricsApprox(ii);
	              var leadSpace = stickyBlock.offset - (initBlock.offset + initBlock.length);
	              cells.push(_react2.default.createElement(_View2.default, { key: '$sticky_lead', style: (_ref2 = {}, _ref2[spacerKey] = leadSpace, _ref2) }));
	              this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, ii, ii, inversionStyle);
	              var trailSpace = this._getFrameMetricsApprox(_first).offset - (stickyBlock.offset + stickyBlock.length);
	              cells.push(_react2.default.createElement(_View2.default, { key: '$sticky_trail', style: (_ref3 = {}, _ref3[spacerKey] = trailSpace, _ref3) }));
	              insertedStickySpacer = true;
	              break;
	            }
	          }
	        }
	        if (!insertedStickySpacer) {
	          var _ref4;
	
	          var _initBlock = this._getFrameMetricsApprox(lastInitialIndex);
	          var firstSpace = this._getFrameMetricsApprox(_first).offset - (_initBlock.offset + _initBlock.length);
	          cells.push(_react2.default.createElement(_View2.default, { key: '$lead_spacer', style: (_ref4 = {}, _ref4[spacerKey] = firstSpace, _ref4) }));
	        }
	      }
	      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, firstAfterInitial, _last, inversionStyle);
	      if (!this._hasWarned.keys && _usedIndexForKey) {
	        console.warn('VirtualizedList: missing keys for items, make sure to specify a key property on each ' + 'item or provide a custom keyExtractor.');
	        this._hasWarned.keys = true;
	      }
	      if (!isVirtualizationDisabled && _last < itemCount - 1) {
	        var _ref5;
	
	        var lastFrame = this._getFrameMetricsApprox(_last);
	        // Without getItemLayout, we limit our tail spacer to the _highestMeasuredFrameIndex to
	        // prevent the user for hyperscrolling into un-measured area because otherwise content will
	        // likely jump around as it renders in above the viewport.
	        var end = this.props.getItemLayout ? itemCount - 1 : Math.min(itemCount - 1, this._highestMeasuredFrameIndex);
	        var endFrame = this._getFrameMetricsApprox(end);
	        var tailSpacerLength = endFrame.offset + endFrame.length - (lastFrame.offset + lastFrame.length);
	        cells.push(_react2.default.createElement(_View2.default, { key: '$tail_spacer', style: (_ref5 = {}, _ref5[spacerKey] = tailSpacerLength, _ref5) }));
	      }
	    } else if (ListEmptyComponent) {
	      var _element = _react2.default.isValidElement(ListEmptyComponent) ? ListEmptyComponent :
	      // $FlowFixMe
	      _react2.default.createElement(ListEmptyComponent, null);
	      cells.push(_react2.default.createElement(
	        _View2.default,
	        {
	          key: '$empty',
	          onLayout: this._onLayoutEmpty,
	          style: inversionStyle },
	        _element
	      ));
	    }
	    if (ListFooterComponent) {
	      var _element2 = _react2.default.isValidElement(ListFooterComponent) ? ListFooterComponent :
	      // $FlowFixMe
	      _react2.default.createElement(ListFooterComponent, null);
	      cells.push(_react2.default.createElement(
	        VirtualizedCellWrapper,
	        {
	          cellKey: this._getCellKey() + '-footer',
	          key: '$footer' },
	        _react2.default.createElement(
	          _View2.default,
	          { onLayout: this._onLayoutFooter, style: inversionStyle },
	          _element2
	        )
	      ));
	    }
	    var scrollProps = Object.assign({}, this.props, {
	      onContentSizeChange: this._onContentSizeChange,
	      onLayout: this._onLayout,
	      onScroll: this._onScroll,
	      onScrollBeginDrag: this._onScrollBeginDrag,
	      onScrollEndDrag: this._onScrollEndDrag,
	      onMomentumScrollEnd: this._onMomentumScrollEnd,
	      scrollEventThrottle: this.props.scrollEventThrottle, // TODO: Android support
	      invertStickyHeaders: this.props.invertStickyHeaders !== undefined ? this.props.invertStickyHeaders : this.props.inverted,
	      stickyHeaderIndices: stickyHeaderIndices
	    });
	    if (inversionStyle) {
	      scrollProps.style = [inversionStyle, this.props.style];
	    }
	
	    this._hasMore = this.state.last < this.props.getItemCount(this.props.data) - 1;
	
	    var ret = _react2.default.cloneElement((this.props.renderScrollComponent || this._defaultRenderScrollComponent)(scrollProps), {
	      ref: this._captureScrollRef
	    }, cells);
	    if (this.props.debug) {
	      return _react2.default.createElement(
	        _View2.default,
	        { style: { flex: 1 } },
	        ret,
	        this._renderDebugOverlay()
	      );
	    } else {
	      return ret;
	    }
	  };
	
	  VirtualizedList.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props6 = this.props,
	        data = _props6.data,
	        extraData = _props6.extraData;
	
	    if (data !== prevProps.data || extraData !== prevProps.extraData) {
	      this._hasDataChangedSinceEndReached = true;
	
	      // clear the viewableIndices cache to also trigger
	      // the onViewableItemsChanged callback with the new data
	      this._viewabilityTuples.forEach(function (tuple) {
	        tuple.viewabilityHelper.resetViewableIndices();
	      });
	    }
	    this._scheduleCellsToRenderUpdate();
	  };
	  // Maps a cell key to the set of keys for all outermost child lists within that cell
	
	
	  VirtualizedList.prototype._computeBlankness = function _computeBlankness() {
	    this._fillRateHelper.computeBlankness(this.props, this.state, this._scrollMetrics);
	  };
	
	  VirtualizedList.prototype._onCellLayout = function _onCellLayout(e, cellKey, index) {
	    var layout = e.nativeEvent.layout;
	    var next = {
	      offset: this._selectOffset(layout),
	      length: this._selectLength(layout),
	      index: index,
	      inLayout: true
	    };
	    var curr = this._frames[cellKey];
	    if (!curr || next.offset !== curr.offset || next.length !== curr.length || index !== curr.index) {
	      this._totalCellLength += next.length - (curr ? curr.length : 0);
	      this._totalCellsMeasured += curr ? 0 : 1;
	      this._averageCellLength = this._totalCellLength / this._totalCellsMeasured;
	      this._frames[cellKey] = next;
	      this._highestMeasuredFrameIndex = Math.max(this._highestMeasuredFrameIndex, index);
	      this._scheduleCellsToRenderUpdate();
	    } else {
	      this._frames[cellKey].inLayout = true;
	    }
	    this._computeBlankness();
	  };
	
	  VirtualizedList.prototype._measureLayoutRelativeToContainingList = function _measureLayoutRelativeToContainingList() {
	    var _this3 = this;
	
	    _UIManager2.default.measureLayout((0, _findNodeHandle2.default)(this), (0, _findNodeHandle2.default)(this.context.virtualizedList.getOutermostParentListRef()), function (error) {
	      console.warn("VirtualizedList: Encountered an error while measuring a list's" + ' offset from its containing VirtualizedList.');
	    }, function (x, y, width, height) {
	      _this3._offsetFromParentVirtualizedList = _this3._selectOffset({ x: x, y: y });
	      _this3._scrollMetrics.contentLength = _this3._selectLength({ width: width, height: height });
	
	      var scrollMetrics = _this3._convertParentScrollMetrics(_this3.context.virtualizedList.getScrollMetrics());
	      _this3._scrollMetrics.visibleLength = scrollMetrics.visibleLength;
	      _this3._scrollMetrics.offset = scrollMetrics.offset;
	    });
	  };
	
	  VirtualizedList.prototype._renderDebugOverlay = function _renderDebugOverlay() {
	    var normalize = this._scrollMetrics.visibleLength / this._scrollMetrics.contentLength;
	    var framesInLayout = [];
	    var itemCount = this.props.getItemCount(this.props.data);
	    for (var ii = 0; ii < itemCount; ii++) {
	      var frame = this._getFrameMetricsApprox(ii);
	      if (frame.inLayout) {
	        framesInLayout.push(frame);
	      }
	    }
	    var windowTop = this._getFrameMetricsApprox(this.state.first).offset;
	    var frameLast = this._getFrameMetricsApprox(this.state.last);
	    var windowLen = frameLast.offset + frameLast.length - windowTop;
	    var visTop = this._scrollMetrics.offset;
	    var visLen = this._scrollMetrics.visibleLength;
	    var baseStyle = { position: 'absolute', top: 0, right: 0 };
	    return _react2.default.createElement(
	      _View2.default,
	      {
	        style: Object.assign({}, baseStyle, {
	          bottom: 0,
	          width: 20,
	          borderColor: 'blue',
	          borderWidth: 1
	        }) },
	      framesInLayout.map(function (f, ii) {
	        return _react2.default.createElement(_View2.default, {
	          key: 'f' + ii,
	          style: Object.assign({}, baseStyle, {
	            left: 0,
	            top: f.offset * normalize,
	            height: f.length * normalize,
	            backgroundColor: 'orange'
	          })
	        });
	      }),
	      _react2.default.createElement(_View2.default, {
	        style: Object.assign({}, baseStyle, {
	          left: 0,
	          top: windowTop * normalize,
	          height: windowLen * normalize,
	          borderColor: 'green',
	          borderWidth: 2
	        })
	      }),
	      _react2.default.createElement(_View2.default, {
	        style: Object.assign({}, baseStyle, {
	          left: 0,
	          top: visTop * normalize,
	          height: visLen * normalize,
	          borderColor: 'red',
	          borderWidth: 2
	        })
	      })
	    );
	  };
	
	  VirtualizedList.prototype._selectLength = function _selectLength(metrics) {
	    return !this.props.horizontal ? metrics.height : metrics.width;
	  };
	
	  VirtualizedList.prototype._selectOffset = function _selectOffset(metrics) {
	    return !this.props.horizontal ? metrics.y : metrics.x;
	  };
	
	  VirtualizedList.prototype._maybeCallOnEndReached = function _maybeCallOnEndReached() {
	    var _props7 = this.props,
	        data = _props7.data,
	        getItemCount = _props7.getItemCount,
	        onEndReached = _props7.onEndReached,
	        onEndReachedThreshold = _props7.onEndReachedThreshold;
	    var _scrollMetrics = this._scrollMetrics,
	        contentLength = _scrollMetrics.contentLength,
	        visibleLength = _scrollMetrics.visibleLength,
	        offset = _scrollMetrics.offset;
	
	    var distanceFromEnd = contentLength - visibleLength - offset;
	    if (onEndReached && this.state.last === getItemCount(data) - 1 &&
	    /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	     * error found when Flow v0.63 was deployed. To see the error delete this
	     * comment and run Flow. */
	    distanceFromEnd < onEndReachedThreshold * visibleLength && (this._hasDataChangedSinceEndReached || this._scrollMetrics.contentLength !== this._sentEndForContentLength)) {
	      // Only call onEndReached once for a given dataset + content length.
	      this._hasDataChangedSinceEndReached = false;
	      this._sentEndForContentLength = this._scrollMetrics.contentLength;
	      onEndReached({ distanceFromEnd: distanceFromEnd });
	    }
	  };
	
	  /* Translates metrics from a scroll event in a parent VirtualizedList into
	   * coordinates relative to the child list.
	   */
	
	
	  VirtualizedList.prototype._scheduleCellsToRenderUpdate = function _scheduleCellsToRenderUpdate() {
	    var _state2 = this.state,
	        first = _state2.first,
	        last = _state2.last;
	    var _scrollMetrics2 = this._scrollMetrics,
	        offset = _scrollMetrics2.offset,
	        visibleLength = _scrollMetrics2.visibleLength,
	        velocity = _scrollMetrics2.velocity;
	
	    var itemCount = this.props.getItemCount(this.props.data);
	    var hiPri = false;
	    if (first > 0 || last < itemCount - 1) {
	      var distTop = offset - this._getFrameMetricsApprox(first).offset;
	      var distBottom = this._getFrameMetricsApprox(last).offset - (offset + visibleLength);
	      var scrollingThreshold =
	      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	       * error found when Flow v0.63 was deployed. To see the error delete
	       * this comment and run Flow. */
	      this.props.onEndReachedThreshold * visibleLength / 2;
	      hiPri = Math.min(distTop, distBottom) < 0 || velocity < -2 && distTop < scrollingThreshold || velocity > 2 && distBottom < scrollingThreshold;
	    }
	    // Only trigger high-priority updates if we've actually rendered cells,
	    // and with that size estimate, accurately compute how many cells we should render.
	    // Otherwise, it would just render as many cells as it can (of zero dimension),
	    // each time through attempting to render more (limited by maxToRenderPerBatch),
	    // starving the renderer from actually laying out the objects and computing _averageCellLength.
	    if (hiPri && this._averageCellLength) {
	      // Don't worry about interactions when scrolling quickly; focus on filling content as fast
	      // as possible.
	      this._updateCellsToRenderBatcher.dispose({ abort: true });
	      this._updateCellsToRender();
	      return;
	    } else {
	      this._updateCellsToRenderBatcher.schedule();
	    }
	  };
	
	  VirtualizedList.prototype._updateViewableItems = function _updateViewableItems(data) {
	    var _this4 = this;
	
	    var getItemCount = this.props.getItemCount;
	
	
	    this._viewabilityTuples.forEach(function (tuple) {
	      tuple.viewabilityHelper.onUpdate(getItemCount(data), _this4._scrollMetrics.offset, _this4._scrollMetrics.visibleLength, _this4._getFrameMetrics, _this4._createViewToken, tuple.onViewableItemsChanged, _this4.state);
	    });
	  };
	
	  return VirtualizedList;
	}(_react2.default.PureComponent);
	
	VirtualizedList.defaultProps = {
	  disableVirtualization: ("production") === 'test',
	  horizontal: false,
	  initialNumToRender: 10,
	  keyExtractor: function keyExtractor(item, index) {
	    if (item.key != null) {
	      return item.key;
	    }
	    _usedIndexForKey = true;
	    return String(index);
	  },
	  maxToRenderPerBatch: 10,
	  onEndReachedThreshold: 2, // multiples of length
	  scrollEventThrottle: 50,
	  updateCellsBatchingPeriod: 50,
	  windowSize: 21 // multiples of length
	};
	VirtualizedList.contextTypes = {
	  virtualizedCell: _propTypes2.default.shape({
	    cellKey: _propTypes2.default.string
	  }),
	  virtualizedList: _propTypes2.default.shape({
	    getScrollMetrics: _propTypes2.default.func,
	    horizontal: _propTypes2.default.bool,
	    getOutermostParentListRef: _propTypes2.default.func,
	    getNestedChildState: _propTypes2.default.func,
	    registerAsNestedChild: _propTypes2.default.func,
	    unregisterAsNestedChild: _propTypes2.default.func
	  })
	};
	VirtualizedList.childContextTypes = {
	  virtualizedList: _propTypes2.default.shape({
	    getScrollMetrics: _propTypes2.default.func,
	    horizontal: _propTypes2.default.bool,
	    getOutermostParentListRef: _propTypes2.default.func,
	    getNestedChildState: _propTypes2.default.func,
	    registerAsNestedChild: _propTypes2.default.func,
	    unregisterAsNestedChild: _propTypes2.default.func
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this7 = this;
	
	  this._getScrollMetrics = function () {
	    return _this7._scrollMetrics;
	  };
	
	  this._getOutermostParentListRef = function () {
	    if (_this7._isNestedWithSameOrientation()) {
	      return _this7.context.virtualizedList.getOutermostParentListRef();
	    } else {
	      return _this7;
	    }
	  };
	
	  this._getNestedChildState = function (key) {
	    var existingChildData = _this7._nestedChildLists.get(key);
	    return existingChildData && existingChildData.state;
	  };
	
	  this._registerAsNestedChild = function (childList) {
	    // Register the mapping between this child key and the cellKey for its cell
	    var childListsInCell = _this7._cellKeysToChildListKeys.get(childList.cellKey) || new Set();
	    childListsInCell.add(childList.key);
	    _this7._cellKeysToChildListKeys.set(childList.cellKey, childListsInCell);
	
	    var existingChildData = _this7._nestedChildLists.get(childList.key);
	    (0, _invariant2.default)(!(existingChildData && existingChildData.ref !== null), 'A VirtualizedList contains a cell which itself contains ' + 'more than one VirtualizedList of the same orientation as the parent ' + 'list. You must pass a unique listKey prop to each sibling list.');
	    _this7._nestedChildLists.set(childList.key, {
	      ref: childList.ref,
	      state: null
	    });
	
	    if (_this7._hasInteracted) {
	      childList.ref.recordInteraction();
	    }
	  };
	
	  this._unregisterAsNestedChild = function (childList) {
	    _this7._nestedChildLists.set(childList.key, {
	      ref: null,
	      state: childList.state
	    });
	  };
	
	  this._onUpdateSeparators = function (keys, newProps) {
	    keys.forEach(function (key) {
	      var ref = key != null && _this7._cellRefs[key];
	      ref && ref.updateSeparatorProps(newProps);
	    });
	  };
	
	  this._averageCellLength = 0;
	  this._cellKeysToChildListKeys = new Map();
	  this._cellRefs = {};
	  this._frames = {};
	  this._footerLength = 0;
	  this._hasDataChangedSinceEndReached = true;
	  this._hasInteracted = false;
	  this._hasMore = false;
	  this._hasWarned = {};
	  this._highestMeasuredFrameIndex = 0;
	  this._headerLength = 0;
	  this._indicesToKeys = new Map();
	  this._hasDoneInitialScroll = false;
	  this._nestedChildLists = new Map();
	  this._offsetFromParentVirtualizedList = 0;
	  this._prevParentOffset = 0;
	  this._scrollMetrics = {
	    contentLength: 0,
	    dOffset: 0,
	    dt: 10,
	    offset: 0,
	    timestamp: 0,
	    velocity: 0,
	    visibleLength: 0
	  };
	  this._scrollRef = null;
	  this._sentEndForContentLength = 0;
	  this._totalCellLength = 0;
	  this._totalCellsMeasured = 0;
	  this._viewabilityTuples = [];
	
	  this._captureScrollRef = function (ref) {
	    _this7._scrollRef = ref;
	  };
	
	  this._defaultRenderScrollComponent = function (props) {
	    if (_this7._isNestedWithSameOrientation()) {
	      return _react2.default.createElement(_View2.default, props);
	    } else if (props.onRefresh) {
	      (0, _invariant2.default)(typeof props.refreshing === 'boolean', '`refreshing` prop must be set as a boolean in order to use `onRefresh`, but got `' + JSON.stringify(props.refreshing) + '`');
	      return _react2.default.createElement(_ScrollView2.default, _extends({}, props, {
	        refreshControl:
	        /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
	         * comment suppresses an error when upgrading Flow's support for
	         * React. To see the error delete this comment and run Flow. */
	        _react2.default.createElement(_RefreshControl2.default, {
	          refreshing: props.refreshing,
	          onRefresh: props.onRefresh,
	          progressViewOffset: props.progressViewOffset
	        })
	      }));
	    } else {
	      return _react2.default.createElement(_ScrollView2.default, props);
	    }
	  };
	
	  this._onCellUnmount = function (cellKey) {
	    var curr = _this7._frames[cellKey];
	    if (curr) {
	      _this7._frames[cellKey] = Object.assign({}, curr, { inLayout: false });
	    }
	  };
	
	  this._onLayout = function (e) {
	    if (_this7._isNestedWithSameOrientation()) {
	      // Need to adjust our scroll metrics to be relative to our containing
	      // VirtualizedList before we can make claims about list item viewability
	      _this7._measureLayoutRelativeToContainingList();
	    } else {
	      _this7._scrollMetrics.visibleLength = _this7._selectLength(e.nativeEvent.layout);
	    }
	    _this7.props.onLayout && _this7.props.onLayout(e);
	    _this7._scheduleCellsToRenderUpdate();
	    _this7._maybeCallOnEndReached();
	  };
	
	  this._onLayoutEmpty = function (e) {
	    _this7.props.onLayout && _this7.props.onLayout(e);
	  };
	
	  this._onLayoutFooter = function (e) {
	    _this7._footerLength = _this7._selectLength(e.nativeEvent.layout);
	  };
	
	  this._onLayoutHeader = function (e) {
	    _this7._headerLength = _this7._selectLength(e.nativeEvent.layout);
	  };
	
	  this._onContentSizeChange = function (width, height) {
	    if (width > 0 && height > 0 && _this7.props.initialScrollIndex != null && _this7.props.initialScrollIndex > 0 && !_this7._hasDoneInitialScroll) {
	      _this7.scrollToIndex({
	        animated: false,
	        index: _this7.props.initialScrollIndex
	      });
	      _this7._hasDoneInitialScroll = true;
	    }
	    if (_this7.props.onContentSizeChange) {
	      _this7.props.onContentSizeChange(width, height);
	    }
	    _this7._scrollMetrics.contentLength = _this7._selectLength({ height: height, width: width });
	    _this7._scheduleCellsToRenderUpdate();
	    _this7._maybeCallOnEndReached();
	  };
	
	  this._convertParentScrollMetrics = function (metrics) {
	    // Offset of the top of the nested list relative to the top of its parent's viewport
	    var offset = metrics.offset - _this7._offsetFromParentVirtualizedList;
	    // Child's visible length is the same as its parent's
	    var visibleLength = metrics.visibleLength;
	    var dOffset = offset - _this7._scrollMetrics.offset;
	    var contentLength = _this7._scrollMetrics.contentLength;
	
	    return {
	      visibleLength: visibleLength,
	      contentLength: contentLength,
	      offset: offset,
	      dOffset: dOffset
	    };
	  };
	
	  this._onScroll = function (e) {
	    _this7._nestedChildLists.forEach(function (childList) {
	      childList.ref && childList.ref._onScroll(e);
	    });
	    if (_this7.props.onScroll) {
	      _this7.props.onScroll(e);
	    }
	    var timestamp = e.timeStamp;
	    var visibleLength = _this7._selectLength(e.nativeEvent.layoutMeasurement);
	    var contentLength = _this7._selectLength(e.nativeEvent.contentSize);
	    var offset = _this7._selectOffset(e.nativeEvent.contentOffset);
	    var dOffset = offset - _this7._scrollMetrics.offset;
	
	    if (_this7._isNestedWithSameOrientation()) {
	      if (_this7._scrollMetrics.contentLength === 0) {
	        // Ignore scroll events until onLayout has been called and we
	        // know our offset from our offset from our parent
	        return;
	      }
	
	      var _convertParentScrollM = _this7._convertParentScrollMetrics({
	        visibleLength: visibleLength,
	        offset: offset
	      });
	
	      visibleLength = _convertParentScrollM.visibleLength;
	      contentLength = _convertParentScrollM.contentLength;
	      offset = _convertParentScrollM.offset;
	      dOffset = _convertParentScrollM.dOffset;
	    }
	
	    var dt = _this7._scrollMetrics.timestamp ? Math.max(1, timestamp - _this7._scrollMetrics.timestamp) : 1;
	    var velocity = dOffset / dt;
	
	    if (dt > 500 && _this7._scrollMetrics.dt > 500 && contentLength > 5 * visibleLength && !_this7._hasWarned.perf) {
	      (0, _infoLog2.default)('VirtualizedList: You have a large list that is slow to update - make sure your ' + 'renderItem function renders components that follow React performance best practices ' + 'like PureComponent, shouldComponentUpdate, etc.', { dt: dt, prevDt: _this7._scrollMetrics.dt, contentLength: contentLength });
	      _this7._hasWarned.perf = true;
	    }
	    _this7._scrollMetrics = {
	      contentLength: contentLength,
	      dt: dt,
	      dOffset: dOffset,
	      offset: offset,
	      timestamp: timestamp,
	      velocity: velocity,
	      visibleLength: visibleLength
	    };
	    _this7._updateViewableItems(_this7.props.data);
	    if (!_this7.props) {
	      return;
	    }
	    _this7._maybeCallOnEndReached();
	    if (velocity !== 0) {
	      _this7._fillRateHelper.activate();
	    }
	    _this7._computeBlankness();
	    _this7._scheduleCellsToRenderUpdate();
	  };
	
	  this._onScrollBeginDrag = function (e) {
	    _this7._nestedChildLists.forEach(function (childList) {
	      childList.ref && childList.ref._onScrollBeginDrag(e);
	    });
	    _this7._viewabilityTuples.forEach(function (tuple) {
	      tuple.viewabilityHelper.recordInteraction();
	    });
	    _this7._hasInteracted = true;
	    _this7.props.onScrollBeginDrag && _this7.props.onScrollBeginDrag(e);
	  };
	
	  this._onScrollEndDrag = function (e) {
	    var velocity = e.nativeEvent.velocity;
	
	    if (velocity) {
	      _this7._scrollMetrics.velocity = _this7._selectOffset(velocity);
	    }
	    _this7._computeBlankness();
	    _this7.props.onScrollEndDrag && _this7.props.onScrollEndDrag(e);
	  };
	
	  this._onMomentumScrollEnd = function (e) {
	    _this7._scrollMetrics.velocity = 0;
	    _this7._computeBlankness();
	    _this7.props.onMomentumScrollEnd && _this7.props.onMomentumScrollEnd(e);
	  };
	
	  this._updateCellsToRender = function () {
	    var _props9 = _this7.props,
	        data = _props9.data,
	        getItemCount = _props9.getItemCount,
	        onEndReachedThreshold = _props9.onEndReachedThreshold;
	
	    var isVirtualizationDisabled = _this7._isVirtualizationDisabled();
	    _this7._updateViewableItems(data);
	    if (!data) {
	      return;
	    }
	    _this7.setState(function (state) {
	      var newState = void 0;
	      if (!isVirtualizationDisabled) {
	        // If we run this with bogus data, we'll force-render window {first: 0, last: 0},
	        // and wipe out the initialNumToRender rendered elements.
	        // So let's wait until the scroll view metrics have been set up. And until then,
	        // we will trust the initialNumToRender suggestion
	        if (_this7._scrollMetrics.visibleLength) {
	          // If we have a non-zero initialScrollIndex and run this before we've scrolled,
	          // we'll wipe out the initialNumToRender rendered elements starting at initialScrollIndex.
	          // So let's wait until we've scrolled the view to the right place. And until then,
	          // we will trust the initialScrollIndex suggestion.
	          if (!_this7.props.initialScrollIndex || _this7._scrollMetrics.offset) {
	            newState = (0, _VirtualizeUtils.computeWindowedRenderLimits)(_this7.props, state, _this7._getFrameMetricsApprox, _this7._scrollMetrics);
	          }
	        }
	      } else {
	        var _scrollMetrics3 = _this7._scrollMetrics,
	            contentLength = _scrollMetrics3.contentLength,
	            _offset = _scrollMetrics3.offset,
	            visibleLength = _scrollMetrics3.visibleLength;
	
	        var _distanceFromEnd = contentLength - visibleLength - _offset;
	        var renderAhead =
	        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses
	         * an error found when Flow v0.63 was deployed. To see the error
	         * delete this comment and run Flow. */
	        _distanceFromEnd < onEndReachedThreshold * visibleLength ? _this7.props.maxToRenderPerBatch : 0;
	        newState = {
	          first: 0,
	          last: Math.min(state.last + renderAhead, getItemCount(data) - 1)
	        };
	      }
	      if (newState && _this7._nestedChildLists.size > 0) {
	        var newFirst = newState.first;
	        var newLast = newState.last;
	        // If some cell in the new state has a child list in it, we should only render
	        // up through that item, so that we give that list a chance to render.
	        // Otherwise there's churn from multiple child lists mounting and un-mounting
	        // their items.
	        for (var ii = newFirst; ii <= newLast; ii++) {
	          var cellKeyForIndex = _this7._indicesToKeys.get(ii);
	          var childListKeys = cellKeyForIndex && _this7._cellKeysToChildListKeys.get(cellKeyForIndex);
	          if (!childListKeys) {
	            continue;
	          }
	          var someChildHasMore = false;
	          // For each cell, need to check whether any child list in it has more elements to render
	          for (var _iterator = childListKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref6;
	
	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref6 = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref6 = _i.value;
	            }
	
	            var childKey = _ref6;
	
	            var childList = _this7._nestedChildLists.get(childKey);
	            if (childList && childList.ref && childList.ref.hasMore()) {
	              someChildHasMore = true;
	              break;
	            }
	          }
	          if (someChildHasMore) {
	            newState.last = ii;
	            break;
	          }
	        }
	      }
	      return newState;
	    });
	  };
	
	  this._createViewToken = function (index, isViewable) {
	    var _props10 = _this7.props,
	        data = _props10.data,
	        getItem = _props10.getItem,
	        keyExtractor = _props10.keyExtractor;
	
	    var item = getItem(data, index);
	    return { index: index, item: item, key: keyExtractor(item, index), isViewable: isViewable };
	  };
	
	  this._getFrameMetricsApprox = function (index) {
	    var frame = _this7._getFrameMetrics(index);
	    if (frame && frame.index === index) {
	      // check for invalid frames due to row re-ordering
	      return frame;
	    } else {
	      var _getItemLayout = _this7.props.getItemLayout;
	
	      (0, _invariant2.default)(!_getItemLayout, 'Should not have to estimate frames when a measurement metrics function is provided');
	      return {
	        length: _this7._averageCellLength,
	        offset: _this7._averageCellLength * index
	      };
	    }
	  };
	
	  this._getFrameMetrics = function (index) {
	    var _props11 = _this7.props,
	        data = _props11.data,
	        getItem = _props11.getItem,
	        getItemCount = _props11.getItemCount,
	        getItemLayout = _props11.getItemLayout,
	        keyExtractor = _props11.keyExtractor;
	
	    (0, _invariant2.default)(getItemCount(data) > index, 'Tried to get frame for out of range index ' + index);
	    var item = getItem(data, index);
	    var frame = item && _this7._frames[keyExtractor(item, index)];
	    if (!frame || frame.index !== index) {
	      if (getItemLayout) {
	        frame = getItemLayout(data, index);
	        if (__DEV__) {
	          var frameType = _propTypes2.default.shape({
	            length: _propTypes2.default.number.isRequired,
	            offset: _propTypes2.default.number.isRequired,
	            index: _propTypes2.default.number.isRequired
	          }).isRequired;
	          _propTypes2.default.checkPropTypes({ frame: frameType }, { frame: frame }, 'frame', 'VirtualizedList.getItemLayout');
	        }
	      }
	    }
	    /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	     * error found when Flow v0.63 was deployed. To see the error delete this
	     * comment and run Flow. */
	    return frame;
	  };
	};
	
	var CellRenderer = function (_React$Component) {
	  _inherits(CellRenderer, _React$Component);
	
	  function CellRenderer() {
	    var _temp, _this5, _ret2;
	
	    _classCallCheck(this, CellRenderer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret2 = (_temp = (_this5 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this5), _this5.state = {
	      separatorProps: {
	        highlighted: false,
	        leadingItem: _this5.props.item
	      }
	    }, _this5._separators = {
	      highlight: function highlight() {
	        var _this5$props = _this5.props,
	            cellKey = _this5$props.cellKey,
	            prevCellKey = _this5$props.prevCellKey;
	
	        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
	          highlighted: true
	        });
	      },
	      unhighlight: function unhighlight() {
	        var _this5$props2 = _this5.props,
	            cellKey = _this5$props2.cellKey,
	            prevCellKey = _this5$props2.prevCellKey;
	
	        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
	          highlighted: false
	        });
	      },
	      updateProps: function updateProps(select, newProps) {
	        var _this5$props3 = _this5.props,
	            cellKey = _this5$props3.cellKey,
	            prevCellKey = _this5$props3.prevCellKey;
	
	        _this5.props.onUpdateSeparators([select === 'leading' ? prevCellKey : cellKey], newProps);
	      }
	    }, _temp), _possibleConstructorReturn(_this5, _ret2);
	  }
	
	  CellRenderer.prototype.getChildContext = function getChildContext() {
	    return {
	      virtualizedCell: {
	        cellKey: this.props.cellKey
	      }
	    };
	  };
	
	  // TODO: consider factoring separator stuff out of VirtualizedList into FlatList since it's not
	  // reused by SectionList and we can keep VirtualizedList simpler.
	
	
	  CellRenderer.prototype.updateSeparatorProps = function updateSeparatorProps(newProps) {
	    this.setState(function (state) {
	      return {
	        separatorProps: Object.assign({}, state.separatorProps, newProps)
	      };
	    });
	  };
	
	  CellRenderer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.onUnmount(this.props.cellKey);
	  };
	
	  CellRenderer.prototype.render = function render() {
	    var _props8 = this.props,
	        CellRendererComponent = _props8.CellRendererComponent,
	        ItemSeparatorComponent = _props8.ItemSeparatorComponent,
	        fillRateHelper = _props8.fillRateHelper,
	        horizontal = _props8.horizontal,
	        item = _props8.item,
	        index = _props8.index,
	        inversionStyle = _props8.inversionStyle,
	        parentProps = _props8.parentProps,
	        style = _props8.style;
	    var renderItem = parentProps.renderItem,
	        getItemLayout = parentProps.getItemLayout;
	
	    (0, _invariant2.default)(renderItem, 'no renderItem!');
	    var element = renderItem({
	      item: item,
	      index: index,
	      separators: this._separators
	    });
	    var onLayout = getItemLayout && !parentProps.debug && !fillRateHelper.enabled() ? undefined : this.props.onLayout;
	    // NOTE: that when this is a sticky header, `onLayout` will get automatically extracted and
	    // called explicitly by `ScrollViewStickyHeader`.
	    var itemSeparator = ItemSeparatorComponent && _react2.default.createElement(ItemSeparatorComponent, this.state.separatorProps);
	    var cellStyle = inversionStyle ? horizontal ? [styles.rowReverse, inversionStyle, style] : [styles.columnReverse, inversionStyle, style] : horizontal ? [styles.row, inversionStyle, style] : [inversionStyle, style];
	    if (!CellRendererComponent) {
	      return _react2.default.createElement(
	        _View2.default,
	        { style: cellStyle, onLayout: onLayout },
	        element,
	        itemSeparator
	      );
	    }
	    return _react2.default.createElement(
	      CellRendererComponent,
	      _extends({}, this.props, {
	        style: cellStyle,
	        onLayout: onLayout }),
	      element,
	      itemSeparator
	    );
	  };
	
	  return CellRenderer;
	}(_react2.default.Component);
	
	CellRenderer.childContextTypes = {
	  virtualizedCell: _propTypes2.default.shape({
	    cellKey: _propTypes2.default.string
	  })
	};
	
	var VirtualizedCellWrapper = function (_React$Component2) {
	  _inherits(VirtualizedCellWrapper, _React$Component2);
	
	  function VirtualizedCellWrapper() {
	    _classCallCheck(this, VirtualizedCellWrapper);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  VirtualizedCellWrapper.prototype.getChildContext = function getChildContext() {
	    return {
	      virtualizedCell: {
	        cellKey: this.props.cellKey
	      }
	    };
	  };
	
	  VirtualizedCellWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return VirtualizedCellWrapper;
	}(_react2.default.Component);
	
	VirtualizedCellWrapper.childContextTypes = {
	  virtualizedCell: _propTypes2.default.shape({
	    cellKey: _propTypes2.default.string
	  })
	};
	
	
	var styles = _StyleSheet2.default.create({
	  verticallyInverted: {
	    transform: [{ scaleY: -1 }]
	  },
	  horizontallyInverted: {
	    transform: [{ scaleX: -1 }]
	  },
	  row: {
	    flexDirection: 'row'
	  },
	  rowReverse: {
	    flexDirection: 'row-reverse'
	  },
	  columnReverse: {
	    flexDirection: 'column-reverse'
	  }
	});
	
	exports.default = VirtualizedList;
	module.exports = exports['default'];

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(116);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(98);
	util.inherits = __webpack_require__(82);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1508)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(1074);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(129).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(1073);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(70);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(70);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(1507).setImmediate, (function() { return this; }())))

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1071);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(830);
	exports.Duplex = __webpack_require__(70);
	exports.Transform = __webpack_require__(1072);
	exports.PassThrough = __webpack_require__(1497);


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(129).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLText, XMLWriterBase,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLDeclaration = __webpack_require__(136);
	
	  XMLDocType = __webpack_require__(137);
	
	  XMLCData = __webpack_require__(130);
	
	  XMLComment = __webpack_require__(131);
	
	  XMLElement = __webpack_require__(138);
	
	  XMLRaw = __webpack_require__(140);
	
	  XMLText = __webpack_require__(141);
	
	  XMLProcessingInstruction = __webpack_require__(139);
	
	  XMLDTDAttList = __webpack_require__(132);
	
	  XMLDTDElement = __webpack_require__(133);
	
	  XMLDTDEntity = __webpack_require__(134);
	
	  XMLDTDNotation = __webpack_require__(135);
	
	  XMLWriterBase = __webpack_require__(1077);
	
	  module.exports = XMLStringWriter = (function(superClass) {
	    extend(XMLStringWriter, superClass);
	
	    function XMLStringWriter(options) {
	      XMLStringWriter.__super__.constructor.call(this, options);
	    }
	
	    XMLStringWriter.prototype.document = function(doc) {
	      var child, i, len, r, ref;
	      this.textispresent = false;
	      r = '';
	      ref = doc.children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        r += (function() {
	          switch (false) {
	            case !(child instanceof XMLDeclaration):
	              return this.declaration(child);
	            case !(child instanceof XMLDocType):
	              return this.docType(child);
	            case !(child instanceof XMLComment):
	              return this.comment(child);
	            case !(child instanceof XMLProcessingInstruction):
	              return this.processingInstruction(child);
	            default:
	              return this.element(child, 0);
	          }
	        }).call(this);
	      }
	      if (this.pretty && r.slice(-this.newline.length) === this.newline) {
	        r = r.slice(0, -this.newline.length);
	      }
	      return r;
	    };
	
	    XMLStringWriter.prototype.attribute = function(att) {
	      return ' ' + att.name + '="' + att.value + '"';
	    };
	
	    XMLStringWriter.prototype.cdata = function(node, level) {
	      return this.space(level) + '<![CDATA[' + node.text + ']]>' + this.newline;
	    };
	
	    XMLStringWriter.prototype.comment = function(node, level) {
	      return this.space(level) + '<!-- ' + node.text + ' -->' + this.newline;
	    };
	
	    XMLStringWriter.prototype.declaration = function(node, level) {
	      var r;
	      r = this.space(level);
	      r += '<?xml version="' + node.version + '"';
	      if (node.encoding != null) {
	        r += ' encoding="' + node.encoding + '"';
	      }
	      if (node.standalone != null) {
	        r += ' standalone="' + node.standalone + '"';
	      }
	      r += this.spacebeforeslash + '?>';
	      r += this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.docType = function(node, level) {
	      var child, i, len, r, ref;
	      level || (level = 0);
	      r = this.space(level);
	      r += '<!DOCTYPE ' + node.root().name;
	      if (node.pubID && node.sysID) {
	        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	      } else if (node.sysID) {
	        r += ' SYSTEM "' + node.sysID + '"';
	      }
	      if (node.children.length > 0) {
	        r += ' [';
	        r += this.newline;
	        ref = node.children;
	        for (i = 0, len = ref.length; i < len; i++) {
	          child = ref[i];
	          r += (function() {
	            switch (false) {
	              case !(child instanceof XMLDTDAttList):
	                return this.dtdAttList(child, level + 1);
	              case !(child instanceof XMLDTDElement):
	                return this.dtdElement(child, level + 1);
	              case !(child instanceof XMLDTDEntity):
	                return this.dtdEntity(child, level + 1);
	              case !(child instanceof XMLDTDNotation):
	                return this.dtdNotation(child, level + 1);
	              case !(child instanceof XMLCData):
	                return this.cdata(child, level + 1);
	              case !(child instanceof XMLComment):
	                return this.comment(child, level + 1);
	              case !(child instanceof XMLProcessingInstruction):
	                return this.processingInstruction(child, level + 1);
	              default:
	                throw new Error("Unknown DTD node type: " + child.constructor.name);
	            }
	          }).call(this);
	        }
	        r += ']';
	      }
	      r += this.spacebeforeslash + '>';
	      r += this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.element = function(node, level) {
	      var att, child, i, j, len, len1, name, r, ref, ref1, ref2, space, textispresentwasset;
	      level || (level = 0);
	      textispresentwasset = false;
	      if (this.textispresent) {
	        this.newline = '';
	        this.pretty = false;
	      } else {
	        this.newline = this.newlinedefault;
	        this.pretty = this.prettydefault;
	      }
	      space = this.space(level);
	      r = '';
	      r += space + '<' + node.name;
	      ref = node.attributes;
	      for (name in ref) {
	        if (!hasProp.call(ref, name)) continue;
	        att = ref[name];
	        r += this.attribute(att);
	      }
	      if (node.children.length === 0 || node.children.every(function(e) {
	        return e.value === '';
	      })) {
	        if (this.allowEmpty) {
	          r += '></' + node.name + '>' + this.newline;
	        } else {
	          r += this.spacebeforeslash + '/>' + this.newline;
	        }
	      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
	        r += '>';
	        r += node.children[0].value;
	        r += '</' + node.name + '>' + this.newline;
	      } else {
	        if (this.dontprettytextnodes) {
	          ref1 = node.children;
	          for (i = 0, len = ref1.length; i < len; i++) {
	            child = ref1[i];
	            if (child.value != null) {
	              this.textispresent++;
	              textispresentwasset = true;
	              break;
	            }
	          }
	        }
	        if (this.textispresent) {
	          this.newline = '';
	          this.pretty = false;
	          space = this.space(level);
	        }
	        r += '>' + this.newline;
	        ref2 = node.children;
	        for (j = 0, len1 = ref2.length; j < len1; j++) {
	          child = ref2[j];
	          r += (function() {
	            switch (false) {
	              case !(child instanceof XMLCData):
	                return this.cdata(child, level + 1);
	              case !(child instanceof XMLComment):
	                return this.comment(child, level + 1);
	              case !(child instanceof XMLElement):
	                return this.element(child, level + 1);
	              case !(child instanceof XMLRaw):
	                return this.raw(child, level + 1);
	              case !(child instanceof XMLText):
	                return this.text(child, level + 1);
	              case !(child instanceof XMLProcessingInstruction):
	                return this.processingInstruction(child, level + 1);
	              default:
	                throw new Error("Unknown XML node type: " + child.constructor.name);
	            }
	          }).call(this);
	        }
	        if (textispresentwasset) {
	          this.textispresent--;
	        }
	        if (!this.textispresent) {
	          this.newline = this.newlinedefault;
	          this.pretty = this.prettydefault;
	        }
	        r += space + '</' + node.name + '>' + this.newline;
	      }
	      return r;
	    };
	
	    XMLStringWriter.prototype.processingInstruction = function(node, level) {
	      var r;
	      r = this.space(level) + '<?' + node.target;
	      if (node.value) {
	        r += ' ' + node.value;
	      }
	      r += this.spacebeforeslash + '?>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.raw = function(node, level) {
	      return this.space(level) + node.value + this.newline;
	    };
	
	    XMLStringWriter.prototype.text = function(node, level) {
	      return this.space(level) + node.value + this.newline;
	    };
	
	    XMLStringWriter.prototype.dtdAttList = function(node, level) {
	      var r;
	      r = this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
	      if (node.defaultValueType !== '#DEFAULT') {
	        r += ' ' + node.defaultValueType;
	      }
	      if (node.defaultValue) {
	        r += ' "' + node.defaultValue + '"';
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.dtdElement = function(node, level) {
	      return this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value + this.spacebeforeslash + '>' + this.newline;
	    };
	
	    XMLStringWriter.prototype.dtdEntity = function(node, level) {
	      var r;
	      r = this.space(level) + '<!ENTITY';
	      if (node.pe) {
	        r += ' %';
	      }
	      r += ' ' + node.name;
	      if (node.value) {
	        r += ' "' + node.value + '"';
	      } else {
	        if (node.pubID && node.sysID) {
	          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	        } else if (node.sysID) {
	          r += ' SYSTEM "' + node.sysID + '"';
	        }
	        if (node.nData) {
	          r += ' NDATA ' + node.nData;
	        }
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.dtdNotation = function(node, level) {
	      var r;
	      r = this.space(level) + '<!NOTATION ' + node.name;
	      if (node.pubID && node.sysID) {
	        r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	      } else if (node.pubID) {
	        r += ' PUBLIC "' + node.pubID + '"';
	      } else if (node.sysID) {
	        r += ' SYSTEM "' + node.sysID + '"';
	      }
	      r += this.spacebeforeslash + '>' + this.newline;
	      return r;
	    };
	
	    XMLStringWriter.prototype.openNode = function(node, level) {
	      var att, name, r, ref;
	      level || (level = 0);
	      if (node instanceof XMLElement) {
	        r = this.space(level) + '<' + node.name;
	        ref = node.attributes;
	        for (name in ref) {
	          if (!hasProp.call(ref, name)) continue;
	          att = ref[name];
	          r += this.attribute(att);
	        }
	        r += (node.children ? '>' : '/>') + this.newline;
	        return r;
	      } else {
	        r = this.space(level) + '<!DOCTYPE ' + node.rootNodeName;
	        if (node.pubID && node.sysID) {
	          r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
	        } else if (node.sysID) {
	          r += ' SYSTEM "' + node.sysID + '"';
	        }
	        r += (node.children ? ' [' : '>') + this.newline;
	        return r;
	      }
	    };
	
	    XMLStringWriter.prototype.closeNode = function(node, level) {
	      level || (level = 0);
	      switch (false) {
	        case !(node instanceof XMLElement):
	          return this.space(level) + '</' + node.name + '>' + this.newline;
	        case !(node instanceof XMLDocType):
	          return this.space(level) + ']>' + this.newline;
	      }
	    };
	
	    return XMLStringWriter;
	
	  })(XMLWriterBase);
	
	}).call(this);


/***/ },
/* 834 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (arr, predicate, ctx) {
		if (typeof Array.prototype.findIndex === 'function') {
			return arr.findIndex(predicate, ctx);
		}
	
		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}
	
		var list = Object(arr);
		var len = list.length;
	
		if (len === 0) {
			return -1;
		}
	
		for (var i = 0; i < len; i++) {
			if (predicate.call(ctx, list[i], i, list)) {
				return i;
			}
		}
	
		return -1;
	};


/***/ },
/* 835 */
/***/ function(module, exports) {

	var colors = {
		maroon: '#800000', red: '#ff0000', orange: '#ffA500', yellow: '#ffff00', olive: '#808000',
		purple: '#800080', fuchsia: "#ff00ff", white: '#ffffff', lime: '#00ff00', green: '#008000',
		navy: '#000080', blue: '#0000ff', aqua: '#00ffff', teal: '#008080',
		black: '#000000', silver: '#c0c0c0', gray: '#808080'
	};
	
	var map = function(array, fn){
		var results = [];
		for (var i = 0, l = array.length; i < l; i++)
			results[i] = fn(array[i], i);
		return results;
	};
	
	var Color = function(color, type){
		
		if (color.isColor){
			
			this.red = color.red;
			this.green = color.green;
			this.blue = color.blue;
			this.alpha = color.alpha;
	
		} else {
			
			var namedColor = colors[color];
			if (namedColor){
				color = namedColor;
				type = 'hex';
			}
	
			switch (typeof color){
				case 'string': if (!type) type = (type = color.match(/^rgb|^hsb|^hsl/)) ? type[0] : 'hex'; break;
				case 'object': type = type || 'rgb'; color = color.toString(); break;
				case 'number': type = 'hex'; color = color.toString(16); break;
			}
	
			color = Color['parse' + type.toUpperCase()](color);
			this.red = color[0];
			this.green = color[1];
			this.blue = color[2];
			this.alpha = color[3];
		}
		
		this.isColor = true;
	
	};
	
	var limit = function(number, min, max){
		return Math.min(max, Math.max(min, number));
	};
	
	var listMatch = /([-.\d]+\%?)\s*,\s*([-.\d]+\%?)\s*,\s*([-.\d]+\%?)\s*,?\s*([-.\d]*\%?)/;
	var hexMatch = /^#?([a-f0-9]{1,2})([a-f0-9]{1,2})([a-f0-9]{1,2})([a-f0-9]{0,2})$/i;
	
	Color.parseRGB = function(color){
		return map(color.match(listMatch).slice(1), function(bit, i){
			if (bit) bit = parseFloat(bit) * (bit[bit.length - 1] == '%' ? 2.55 : 1);
			return (i < 3) ? Math.round(((bit %= 256) < 0) ? bit + 256 : bit) : limit(((bit === '') ? 1 : Number(bit)), 0, 1);
		});
	};
		
	Color.parseHEX = function(color){
		if (color.length == 1) color = color + color + color;
		return map(color.match(hexMatch).slice(1), function(bit, i){
			if (i == 3) return (bit) ? parseInt(bit, 16) / 255 : 1;
			return parseInt((bit.length == 1) ? bit + bit : bit, 16);
		});
	};
		
	Color.parseHSB = function(color){
		var hsb = map(color.match(listMatch).slice(1), function(bit, i){
			if (bit) bit = parseFloat(bit);
			if (i === 0) return Math.round(((bit %= 360) < 0) ? (bit + 360) : bit);
			else if (i < 3) return limit(Math.round(bit), 0, 100);
			else return limit(((bit === '') ? 1 : Number(bit)), 0, 1);
		});
		
		var a = hsb[3];
		var br = Math.round(hsb[2] / 100 * 255);
		if (hsb[1] == 0) return [br, br, br, a];
			
		var hue = hsb[0];
		var f = hue % 60;
		var p = Math.round((hsb[2] * (100 - hsb[1])) / 10000 * 255);
		var q = Math.round((hsb[2] * (6000 - hsb[1] * f)) / 600000 * 255);
		var t = Math.round((hsb[2] * (6000 - hsb[1] * (60 - f))) / 600000 * 255);
	
		switch (Math.floor(hue / 60)){
			case 0: return [br, t, p, a];
			case 1: return [q, br, p, a];
			case 2: return [p, br, t, a];
			case 3: return [p, q, br, a];
			case 4: return [t, p, br, a];
			default: return [br, p, q, a];
		}
	};
	
	Color.parseHSL = function(color){
		var hsb = map(color.match(listMatch).slice(1), function(bit, i){
			if (bit) bit = parseFloat(bit);
			if (i === 0) return Math.round(((bit %= 360) < 0) ? (bit + 360) : bit);
			else if (i < 3) return limit(Math.round(bit), 0, 100);
			else return limit(((bit === '') ? 1 : Number(bit)), 0, 1);
		});
	
		var h = hsb[0] / 60;
		var s = hsb[1] / 100;
		var l = hsb[2] / 100;
		var a = hsb[3];
		
		var c = (1 - Math.abs(2 * l - 1)) * s;
		var x = c * (1 - Math.abs(h % 2 - 1));
		var m = l - c / 2;
		
		var p = Math.round((c + m) * 255);
		var q = Math.round((x + m) * 255);
		var t = Math.round((m) * 255);
	
		switch (Math.floor(h)){
			case 0: return [p, q, t, a];
			case 1: return [q, p, t, a];
			case 2: return [t, p, q, a];
			case 3: return [t, q, p, a];
			case 4: return [q, t, p, a];
			default: return [p, t, q, a];
		}
	};
	
	var toString = function(type, array){
		if (array[3] != 1) type += 'a';
		else array.pop();
		return type + '(' + array.join(', ') + ')';
	};
	
	Color.prototype = {
	
		toHSB: function(array){
			var red = this.red, green = this.green, blue = this.blue, alpha = this.alpha;
	
			var max = Math.max(red, green, blue), min = Math.min(red, green, blue), delta = max - min;
			var hue = 0, saturation = (delta != 0) ? delta / max : 0, brightness = max / 255;
			if (saturation){
				var rr = (max - red) / delta, gr = (max - green) / delta, br = (max - blue) / delta;
				hue = (red == max) ? br - gr : (green == max) ? 2 + rr - br : 4 + gr - rr;
				if ((hue /= 6) < 0) hue++;
			}
	
			var hsb = [Math.round(hue * 360), Math.round(saturation * 100), Math.round(brightness * 100), alpha];
	
			return (array) ? hsb : toString('hsb', hsb);
		},
	
		toHSL: function(array){
			var red = this.red, green = this.green, blue = this.blue, alpha = this.alpha;
	
			var max = Math.max(red, green, blue), min = Math.min(red, green, blue), delta = max - min;
			var hue = 0, saturation = (delta != 0) ? delta / (255 - Math.abs((max + min) - 255)) : 0, lightness = (max + min) / 512;
			if (saturation){
				var rr = (max - red) / delta, gr = (max - green) / delta, br = (max - blue) / delta;
				hue = (red == max) ? br - gr : (green == max) ? 2 + rr - br : 4 + gr - rr;
				if ((hue /= 6) < 0) hue++;
			}
	
			var hsl = [Math.round(hue * 360), Math.round(saturation * 100), Math.round(lightness * 100), alpha];
	
			return (array) ? hsl : toString('hsl', hsl);
		},
	
		toHEX: function(array){
	
			var a = this.alpha;
			var alpha = ((a = Math.round((a * 255)).toString(16)).length == 1) ? a + a : a;
			
			var hex = map([this.red, this.green, this.blue], function(bit){
				bit = bit.toString(16);
				return (bit.length == 1) ? '0' + bit : bit;
			});
			
			return (array) ? hex.concat(alpha) : '#' + hex.join('') + ((alpha == 'ff') ? '' : alpha);
		},
		
		toRGB: function(array){
			var rgb = [this.red, this.green, this.blue, this.alpha];
			return (array) ? rgb : toString('rgb', rgb);
		}
	
	};
	
	Color.prototype.toString = Color.prototype.toRGB;
	
	Color.hex = function(hex){
		return new Color(hex, 'hex');
	};
	
	if (this.hex == null) this.hex = Color.hex;
	
	Color.hsb = function(h, s, b, a){
		return new Color([h || 0, s || 0, b || 0, (a == null) ? 1 : a], 'hsb');
	};
	
	if (this.hsb == null) this.hsb = Color.hsb;
	
	Color.hsl = function(h, s, l, a){
		return new Color([h || 0, s || 0, l || 0, (a == null) ? 1 : a], 'hsl');
	};
	
	if (this.hsl == null) this.hsl = Color.hsl;
	
	Color.rgb = function(r, g, b, a){
		return new Color([r || 0, g || 0, b || 0, (a == null) ? 1 : a], 'rgb');
	};
	
	if (this.rgb == null) this.rgb = Color.rgb;
	
	Color.detach = function(color){
		color = new Color(color);
		return [Color.rgb(color.red, color.green, color.blue).toString(), color.alpha];
	};
	
	module.exports = Color;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	
	module.exports = Class({
		
		initialize: function(path){
			this.reset().push(path);
		},
	
		/* parser */
		
		push: function(){
			var p = Array.prototype.join.call(arguments, ' ')
				.match(/[a-df-z]|[\-+]?(?:[\d\.]e[\-+]?|[^\s\-+,a-z])+/ig);
			if (!p) return this;
	
			var last, cmd = p[0], i = 1;
			while (cmd){
				switch (cmd){
					case 'm': this.move(p[i++], p[i++]); break;
					case 'l': this.line(p[i++], p[i++]); break;
					case 'c': this.curve(p[i++], p[i++], p[i++], p[i++], p[i++], p[i++]); break;
					case 's': this.curve(p[i++], p[i++], null, null, p[i++], p[i++]); break;
					case 'q': this.curve(p[i++], p[i++], p[i++], p[i++]); break;
					case 't': this.curve(p[i++], p[i++]); break;
					case 'a': this.arc(p[i+5], p[i+6], p[i], p[i+1], p[i+3], !+p[i+4], p[i+2]); i += 7; break;
					case 'h': this.line(p[i++], 0); break;
					case 'v': this.line(0, p[i++]); break;
	
					case 'M': this.moveTo(p[i++], p[i++]); break;
					case 'L': this.lineTo(p[i++], p[i++]); break;
					case 'C': this.curveTo(p[i++], p[i++], p[i++], p[i++], p[i++], p[i++]); break;
					case 'S': this.curveTo(p[i++], p[i++], null, null, p[i++], p[i++]); break;
					case 'Q': this.curveTo(p[i++], p[i++], p[i++], p[i++]); break;
					case 'T': this.curveTo(p[i++], p[i++]); break;
					case 'A': this.arcTo(p[i+5], p[i+6], p[i], p[i+1], p[i+3], !+p[i+4], p[i+2]); i += 7; break;
					case 'H': this.lineTo(p[i++], this.penY); break;
					case 'V': this.lineTo(this.penX, p[i++]); break;
					
					case 'Z': case 'z': this.close(); break;
					default: cmd = last; i--; continue;
				}
	
				last = cmd;
				if (last == 'm') last = 'l';
				else if (last == 'M') last = 'L';
				cmd = p[i++];
			}
			return this;
		},
	
		/* utility methods */
	
		reset: function(){
			this.penX = this.penY = 0;
			this.penDownX = this.penDownY = null;
			this._pivotX = this._pivotY = 0;
			this.onReset();
			return this;
		},
		
		move: function(x,y){
			this.onMove(this.penX, this.penY, this._pivotX = this.penX += (+x), this._pivotY = this.penY += (+y));
			return this;
		},
		moveTo: function(x,y){
			this.onMove(this.penX, this.penY, this._pivotX = this.penX = (+x), this._pivotY = this.penY = (+y));
			return this;
		},
	
		line: function(x,y){
			return this.lineTo(this.penX + (+x), this.penY + (+y));
		},
		lineTo: function(x,y){
			if (this.penDownX == null){ this.penDownX = this.penX; this.penDownY = this.penY; }
			this.onLine(this.penX, this.penY, this._pivotX = this.penX = (+x), this._pivotY = this.penY = (+y));
			return this;
		},
		
		curve: function(c1x, c1y, c2x, c2y, ex, ey){
			var x = this.penX, y = this.penY;
			return this.curveTo(
				x + (+c1x), y + (+c1y),
				c2x == null ? null : x + (+c2x),
				c2y == null ? null : y + (+c2y),
				ex == null ? null : x + (+ex),
				ey == null ? null : y + (+ey)
			);
		},
		curveTo: function(c1x, c1y, c2x, c2y, ex, ey){
			var x = this.penX, y = this.penY;
			if (c2x == null){
				c2x = +c1x; c2y = +c1y;
				c1x = (x * 2) - (this._pivotX || 0); c1y = (y * 2) - (this._pivotY || 0);
			}
			if (ex == null){
				this._pivotX = +c1x; this._pivotY = +c1y;
				ex = +c2x; ey = +c2y;
				c2x = (ex + (+c1x) * 2) / 3; c2y = (ey + (+c1y) * 2) / 3;
				c1x = (x + (+c1x) * 2) / 3; c1y = (y + (+c1y) * 2) / 3;
			} else {
				this._pivotX = +c2x; this._pivotY = +c2y;
			}
			if (this.penDownX == null){ this.penDownX = x; this.penDownY = y; }
			this.onBezierCurve(x, y, +c1x, +c1y, +c2x, +c2y, this.penX = +ex, this.penY = +ey);
			return this;
		},
		
		arc: function(x, y, rx, ry, outer, counterClockwise, rotation){
			return this.arcTo(this.penX + (+x), this.penY + (+y), rx, ry, outer, counterClockwise, rotation);
		},
		arcTo: function(x, y, rx, ry, outer, counterClockwise, rotation){
			ry = Math.abs(+ry || +rx || (+y - this.penY));
			rx = Math.abs(+rx || (+x - this.penX));
	
			if (!rx || !ry || (x == this.penX && y == this.penY)) return this.lineTo(x, y);
	
			var tX = this.penX, tY = this.penY, clockwise = !+counterClockwise, large = !!+outer;
	
			var rad = rotation ? rotation * Math.PI / 180 : 0, cos = Math.cos(rad), sin = Math.sin(rad);
			x -= tX; y -= tY;
			
			// Ellipse Center
			var cx = cos * x / 2 + sin * y / 2,
				cy = -sin * x / 2 + cos * y / 2,
				rxry = rx * rx * ry * ry,
				rycx = ry * ry * cx * cx,
				rxcy = rx * rx * cy * cy,
				a = rxry - rxcy - rycx;
	
			if (a < 0){
				a = Math.sqrt(1 - a / rxry);
				rx *= a; ry *= a;
				cx = x / 2; cy = y / 2;
			} else {
				a = Math.sqrt(a / (rxcy + rycx));
				if (large == clockwise) a = -a;
				var cxd = -a * cy * rx / ry,
				    cyd =  a * cx * ry / rx;
				cx = cos * cxd - sin * cyd + x / 2;
				cy = sin * cxd + cos * cyd + y / 2;
			}
	
			// Rotation + Scale Transform
			var xx =  cos / rx, yx = sin / rx,
			    xy = -sin / ry, yy = cos / ry;
	
			// Start and End Angle
			var sa = Math.atan2(xy * -cx + yy * -cy, xx * -cx + yx * -cy),
			    ea = Math.atan2(xy * (x - cx) + yy * (y - cy), xx * (x - cx) + yx * (y - cy));
	
			cx += tX; cy += tY;
			x += tX; y += tY;
	
			// Circular Arc
			if (this.penDownX == null){ this.penDownX = this.penX; this.penDownY = this.penY; }
			this.onArc(
				tX, tY, this._pivotX = this.penX = x, this._pivotY = this.penY = y,
				cx, cy, rx, ry, sa, ea, !clockwise, rotation
			);
			return this;
		},
	
		counterArc: function(x, y, rx, ry, outer){
			return this.arc(x, y, rx, ry, outer, true);
		},
		counterArcTo: function(x, y, rx, ry, outer){
			return this.arcTo(x, y, rx, ry, outer, true);
		},
	
		close: function(){
			if (this.penDownX != null){
				this.onClose(this.penX, this.penY, this.penX = this.penDownX, this.penY = this.penDownY);
				this.penDownX = null;
			}
			return this;
		},
	
		/* overridable handlers */
		
		onReset: function(){
		},
	
		onMove: function(sx, sy, ex, ey){
		},
	
		onLine: function(sx, sy, ex, ey){
			this.onBezierCurve(sx, sy, sx, sy, ex, ey, ex, ey);
		},
	
		onBezierCurve: function(sx, sy, c1x, c1y, c2x, c2y, ex, ey){
			var gx = ex - sx, gy = ey - sy,
				g = gx * gx + gy * gy,
				v1, v2, cx, cy, u;
	
			cx = c1x - sx; cy = c1y - sy;
			u = cx * gx + cy * gy;
	
			if (u > g){
				cx -= gx;
				cy -= gy;
			} else if (u > 0 && g != 0){
				cx -= u/g * gx;
				cy -= u/g * gy;
			}
	
			v1 = cx * cx + cy * cy;
	
			cx = c2x - sx; cy = c2y - sy;
			u = cx * gx + cy * gy;
	
			if (u > g){
				cx -= gx;
				cy -= gy;
			} else if (u > 0 && g != 0){
				cx -= u/g * gx;
				cy -= u/g * gy;
			}
	
			v2 = cx * cx + cy * cy;
	
			if (v1 < 0.01 && v2 < 0.01){
				this.onLine(sx, sy, ex, ey);
				return;
			}
	
			// Avoid infinite recursion
			if (isNaN(v1) || isNaN(v2)){
				throw new Error('Bad input');
			}
	
			// Split curve
			var s1x =   (c1x + c2x) * 0.5,   s1y =   (c1y + c2y) * 0.5,
			    l1x =   (c1x + sx)  * 0.5,   l1y =   (c1y + sy)  * 0.5,
			    l2x =   (l1x + s1x) * 0.5,   l2y =   (l1y + s1y) * 0.5,
			    r2x =   (ex + c2x)  * 0.5,   r2y =   (ey + c2y)  * 0.5,
			    r1x =   (r2x + s1x) * 0.5,   r1y =   (r2y + s1y) * 0.5,
			    l2r1x = (l2x + r1x) * 0.5,   l2r1y = (l2y + r1y) * 0.5;
	
			// TODO: Manual stack if necessary. Currently recursive without tail optimization.
			this.onBezierCurve(sx, sy, l1x, l1y, l2x, l2y, l2r1x, l2r1y);
			this.onBezierCurve(l2r1x, l2r1y, r1x, r1y, r2x, r2y, ex, ey);
		},
	
		onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
			// Inverse Rotation + Scale Transform
			var rad = rotation ? rotation * Math.PI / 180 : 0, cos = Math.cos(rad), sin = Math.sin(rad),
				xx = cos * rx, yx = -sin * ry,
			    xy = sin * rx, yy =  cos * ry;
	
			// Bezier Curve Approximation
			var arc = ea - sa;
			if (arc < 0 && !ccw) arc += Math.PI * 2;
			else if (arc > 0 && ccw) arc -= Math.PI * 2;
	
			var n = Math.ceil(Math.abs(arc / (Math.PI / 2))),
			    step = arc / n,
			    k = (4 / 3) * Math.tan(step / 4);
	
			var x = Math.cos(sa), y = Math.sin(sa);
	
			for (var i = 0; i < n; i++){
				var cp1x = x - k * y, cp1y = y + k * x;
	
				sa += step;
				x = Math.cos(sa); y = Math.sin(sa);
	
				var cp2x = x + k * y, cp2y = y - k * x;
	
				this.onBezierCurve(
					sx, sy,
					cx + xx * cp1x + yx * cp1y, cy + xy * cp1x + yy * cp1y,
					cx + xx * cp2x + yx * cp2y, cy + xy * cp2x + yy * cp2y,
					(sx = (cx + xx * x + yx * y)), (sy = (cy + xy * x + yy * y))
				);
			}
		},
	
		onClose: function(sx, sy, ex, ey){
			this.onLine(sx, sy, ex, ey);
		}
	
	});

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	
	module.exports = Class({
	
		// placement
	
		_resetPlacement: function(){
			var container = this.parentNode;
			if (container){
				var previous = this.previousSibling, next = this.nextSibling;
				if (previous){
					previous.nextSibling = next;
				} else {
					container.firstChild = next;
				}
				if (next){
					next.previousSibling = previous;
				} else {
					container.lastChild = this.previousSibling;
				}
			}
			this.previousSibling = null;
			this.nextSibling = null;
			this.parentNode = null;
			return this;
		},
	
		inject: function(container){
			this._resetPlacement();
			var last = container.lastChild;
			if (last){
				last.nextSibling = this;
				this.previousSibling = last;
			} else {
				container.firstChild = this;
			}
			container.lastChild = this;
			this.parentNode = container;
			this._place();
			return this;
		},
	
		injectBefore: function(sibling){
			this._resetPlacement();
			var container = sibling.parentNode;
			if (!container) return this;
			var previous = sibling.previousSibling;
			if (previous){
				previous.nextSibling = this;
				this.previousSibling = previous;
			} else {
				container.firstChild = this;
			}
			sibling.previousSibling = this;
			this.nextSibling = sibling;
			this.parentNode = container;
			this._place();
			return this;
		},
	
		eject: function(){
			this._resetPlacement();
			this._place();
			return this;
		},
	
		_place: function(){},
	
		// events
	
		dispatch: function(event){
			var events = this._events,
				listeners = events && events[event.type];
			if (listeners){
				listeners = listeners.slice(0);
				for (var i = 0, l = listeners.length; i < l; i++){
					var fn = listeners[i], result;
					if (typeof fn == 'function')
						result = fn.call(this, event);
					else
						result = fn.handleEvent(event);
					if (result === false) event.preventDefault();
				}
			}
			if (this.parentNode && this.parentNode.dispatch){
				this.parentNode.dispatch(event);
			}
		},
	
		subscribe: function(type, fn, bind){
			if (typeof type != 'string'){ // listen type / fn with object
				var subscriptions = [];
				for (var t in type) subscriptions.push(this.subscribe(t, type[t]));
				return function(){ // unsubscribe
					for (var i = 0, l = subscriptions.length; i < l; i++)
						subscriptions[i]();
					return this;
				};
			} else { // listen to one
				var bound = typeof fn === 'function' ? fn.bind(bind || this) : fn,
					events = this._events || (this._events = {}),
					listeners = events[type] || (events[type] = []);
				listeners.push(bound);
				return function(){
					// unsubscribe
					for (var i = 0, l = listeners.length; i < l; i++){
						if (listeners[i] === bound){
							listeners.splice(i, 1);
							break;
						}
					}
				}
			}
		}
	
	});


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Color = __webpack_require__(835);
	var Transform = __webpack_require__(61);
	var Node = __webpack_require__(143);
	
	var genericCanvas = typeof document !== 'undefined' && document.createElement('canvas'),
	    genericContext = genericCanvas && genericCanvas.getContext && genericCanvas.getContext('2d');
	
	function recolorImage(img, color1, color2){
		// TODO: Fix this experimental implementation
		color1 = Color.detach(color1);
		color2 = Color.detach(color2);
		var canvas = document.createElement('canvas'),
			context = canvas.getContext('2d');
		canvas.width = img.width;
		canvas.height = img.height;
		context.fillStyle = color2[0];
		context.fillRect(0, 0, img.width, img.height);
		context.globalCompositeOperation = 'lighter';
		context.drawImage(img, 0, 0);
		return canvas;
	}
	
	var Base = Class(Node, {
	
		initialize: function(){
			this._fill = null;
			this._pendingFill = null;
			this._fillTransform = null;
			this._stroke = null;
			this._strokeCap = null;
			this._strokeDash = null;
			this._strokeJoin = null;
			this._strokeWidth = null;
		},
	
		/* styles */
	
		_addColors: function(gradient, stops){
			// Enumerate stops, assumes offsets are enumerated in order
			// TODO: Sort. Chrome doesn't always enumerate in expected order but requires stops to be specified in order.
			if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++)
				gradient.addColorStop(i / l, new Color(stops[i]).toString());
			else for (var offset in stops)
				gradient.addColorStop(offset, new Color(stops[offset]).toString());
			return gradient;
		},
	
	
		fill: function(color){
			if (arguments.length > 1) return this.fillLinear(arguments);
			if (this._pendingFill) this._pendingFill();
			this._fill = color ? new Color(color).toString() : null;
			return this.invalidate();
		},
	
		fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
			if (focusX == null) focusX = (this.left || 0) + (this.width || 0) * 0.5;
			if (focusY == null) focusY = (this.top || 0) + (this.height || 0) * 0.5;
			if (radiusY == null) radiusY = radiusX || (this.height * 0.5) || 0;
			if (radiusX == null) radiusX = (this.width || 0) * 0.5;
			if (centerX == null) centerX = focusX;
			if (centerY == null) centerY = focusY;
	
			centerX += centerX - focusX;
			centerY += centerY - focusY;
	
			if (radiusX === 0 || radiusX === '0') return this.fillLinear(stops);
			var ys = radiusY / radiusX;
	
			if (this._pendingFill) this._pendingFill();
	
			var gradient = genericContext.createRadialGradient(focusX, focusY / ys, 0, centerX, centerY / ys, radiusX * 2);
	
			// Double fill radius to simulate repeating gradient
			if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++){
				gradient.addColorStop(i / l / 2, new Color(stops[i]).toString());
				gradient.addColorStop(1 - i / l / 2, new Color(stops[i]).toString());
			} else for (var offset in stops){
				gradient.addColorStop(offset / 2, new Color(stops[offset]).toString());
				gradient.addColorStop(1- offset / 2, new Color(stops[offset]).toString());
			}
	
			this._fill = gradient;
			this._fillTransform = new Transform(1, 0, 0, ys);
			return this.invalidate();
		},
	
		fillLinear: function(stops, x1, y1, x2, y2){
			if (arguments.length < 5){
				var angle = ((x1 == null) ? 270 : x1) * Math.PI / 180;
	
				var x = Math.cos(angle), y = -Math.sin(angle),
					l = (Math.abs(x) + Math.abs(y)) / 2,
					w = this.width || 1, h = this.height || 1;
	
				x *= l; y *= l;
	
				x1 = 0.5 - x;
				x2 = 0.5 + x;
				y1 = 0.5 - y;
				y2 = 0.5 + y;
				this._fillTransform = new Transform(w, 0, 0, h);
			} else {
				this._fillTransform = null;
			}
			if (this._pendingFill) this._pendingFill();
			var gradient = genericContext.createLinearGradient(x1, y1, x2, y2);
			this._addColors(gradient, stops);
			this._fill = gradient;
			return this.invalidate();
		},
	
		fillImage: function(url, width, height, left, top, color1, color2){
			if (this._pendingFill) this._pendingFill();
			var img = url;
			if (!(img instanceof Image)){
				img = new Image();
				img.src = url;
			}
			if (img.width && img.height){
				return this._fillImage(img, width, height, left || 0, top || 0, color1, color2);
			}
	
			// Not yet loaded
			this._fill = null;
			var self = this,
				callback = function(){
					cancel();
					self._fillImage(img, width, height, left || 0, top || 0, color1, color2);
				},
				cancel = function(){
					img.removeEventListener('load', callback, false);
					self._pendingFill = null;
				};
			this._pendingFill = cancel;
			img.addEventListener('load', callback, false);
			return this;
		},
	
		_fillImage: function(img, width, height, left, top, color1, color2){
			var w = width ? width / img.width : 1,
				h = height ? height / img.height : 1;
			if (color1 != null) img = recolorImage(img, color1, color2);
			this._fill = genericContext.createPattern(img, 'repeat');
			this._fillTransform = new Transform(w, 0, 0, h, left || 0, top || 0);
			return this.invalidate();
		},
	
		stroke: function(color, width, cap, join, dash){
			this._stroke = color ? new Color(color).toString() : null;
			this._strokeWidth = (width != null) ? width : 1;
			this._strokeCap = (cap != null) ? cap : 'round';
			this._strokeJoin = (join != null) ? join : 'round';
			this._strokeDash = dash;
			return this.invalidate();
		},
	
		// Rendering
	
		element_renderTo: Node.prototype.renderTo,
	
		renderTo: function(context, xx, yx, xy, yy, x, y){
			var opacity = this._opacity;
			if (opacity == null || opacity >= 1){
				return this.renderLayerTo(context, xx, yx, xy, yy, x, y);
			}
			if (this._fill && this._stroke){
				return this.element_renderTo(context, xx, yx, xy, yy, x, y);
			}
			context.globalAlpha = opacity;
			var r = this.renderLayerTo(context, xx, yx, xy, yy, x, y);
			context.globalAlpha = 1;
			return r;
		},
	
		renderLayerTo: function(context, xx, yx, xy, yy, x, y){
			context.setTransform(xx, yx, xy, yy, x, y);
			this.renderShapeTo(context);
		}
	
	});
	
	Base._genericContext = genericContext;
	
	module.exports = Base;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Path = __webpack_require__(836);
	
	var CanvasPath = Class(Path, {
	
		initialize: function(path){
			this.reset();
			if (path instanceof CanvasPath){
				this.path = path.path.slice(0);
			} else if (path){
				if (path.applyToPath)
					path.applyToPath(this);
				else
					this.push(path);
			}
		},
	
		onReset: function(){
			this.path = [];
		},
	
		onMove: function(sx, sy, x, y){
			this.path.push(function(context){
				context.moveTo(x, y);
			});
		},
	
		onLine: function(sx, sy, x, y){
			this.path.push(function(context){
				context.lineTo(x, y);
			});
		},
	
		onBezierCurve: function(sx, sy, p1x, p1y, p2x, p2y, x, y){
			this.path.push(function(context){
				context.bezierCurveTo(p1x, p1y, p2x, p2y, x, y);
			});
		},
	
		_arcToBezier: Path.prototype.onArc,
	
		onArc: function(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation){
			if (rx != ry || rotation) return this._arcToBezier(sx, sy, ex, ey, cx, cy, rx, ry, sa, ea, ccw, rotation);
			this.path.push(function(context){
				context.arc(cx, cy, rx, sa, ea, ccw);
			});
		},
	
		onClose: function(){
			this.path.push(function(context){
				context.closePath();
			});
		},
	
		toCommands: function(){
			return this.path.slice(0);
		}
	
	});
	
	module.exports = CanvasPath;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Transform = __webpack_require__(61);
	var Color = __webpack_require__(835);
	var Node = __webpack_require__(144);
	var DOM = __webpack_require__(72);
	
	var precision = 100;
	
	var defaultBox = { left: 0, top: 0, width: 500, height: 500 };
	
	module.exports = Class(Node, {
	
		element_initialize: Node.prototype.initialize,
	
		initialize: function(tag){
			this.element_initialize(tag);
			var element = this.element;
			
			var skew = this.skewElement = DOM.createElement('skew');
			skew.on = true;
			element.appendChild(skew);
	
			var fill = this.fillElement = DOM.createElement('fill');
			fill.on = false;
			element.appendChild(fill);
			
			var stroke = this.strokeElement = DOM.createElement('stroke');
			stroke.on = false;
			element.appendChild(stroke);
		},
		
		/* transform */
		
		_transform: function(){
			var container = this.parentNode;
			
			// Active Transformation Matrix
			var m = container ? new Transform(container._activeTransform).transform(this) : this;
			
			// Box in shape user space
			
			var box = this._boxCoords || this._size || defaultBox;
			
			var originX = box.left || 0,
				originY = box.top || 0,
				width = box.width || 1,
				height = box.height || 1;
					
			// Flipped
		    var flip = m.yx / m.xx > m.yy / m.xy;
			if (m.xx < 0 ? m.xy >= 0 : m.xy < 0) flip = !flip;
			flip = flip ? -1 : 1;
			
			m = new Transform().scale(flip, 1).transform(m);
			
			// Rotation is approximated based on the transform
			var rotation = Math.atan2(-m.xy, m.yy) * 180 / Math.PI;
			
			// Reverse the rotation, leaving the final transform in box space
			var rad = rotation * Math.PI / 180, sin = Math.sin(rad), cos = Math.cos(rad);
			
			var transform = new Transform(
				(m.xx * cos - m.xy * sin),
				(m.yx * cos - m.yy * sin) * flip,
				(m.xy * cos + m.xx * sin) * flip,
				(m.yy * cos + m.yx * sin)
			);
	
			var rotationTransform = new Transform().rotate(rotation, 0, 0);
	
			var shapeToBox = new Transform().rotate(-rotation, 0, 0).transform(m).moveTo(0,0);
	
			// Scale box after reversing rotation
			width *= Math.abs(shapeToBox.xx);
			height *= Math.abs(shapeToBox.yy);
			
			// Place box
			var left = m.x, top = m.y;
			
			// Compensate for offset by center origin rotation
			var vx = -width / 2, vy = -height / 2;
			var point = rotationTransform.point(vx, vy);
			left -= point.x - vx;
			top -= point.y - vy;
			
			// Adjust box position based on offset
			var rsm = new Transform(m).moveTo(0,0);
			point = rsm.point(originX, originY);
			left += point.x;
			top += point.y;
			
			if (flip < 0) left = -left - width;
			
			// Place transformation origin
			var point0 = rsm.point(-originX, -originY);
			var point1 = rotationTransform.point(width, height);
			var point2 = rotationTransform.point(width, 0);
			var point3 = rotationTransform.point(0, height);
			
			var minX = Math.min(0, point1.x, point2.x, point3.x),
			    maxX = Math.max(0, point1.x, point2.x, point3.x),
			    minY = Math.min(0, point1.y, point2.y, point3.y),
			    maxY = Math.max(0, point1.y, point2.y, point3.y);
			
			var transformOriginX = (point0.x - point1.x / 2) / (maxX - minX) * flip,
			    transformOriginY = (point0.y - point1.y / 2) / (maxY - minY);
			
			// Adjust the origin
			point = shapeToBox.point(originX, originY);
			originX = point.x;
			originY = point.y;
			
			// Scale stroke
			var strokeWidth = this._strokeWidth;
			if (strokeWidth){
				// Scale is the hypothenus between the two vectors
				// TODO: Use area calculation instead
				var vx = m.xx + m.xy, vy = m.yy + m.yx;
				strokeWidth *= Math.sqrt(vx * vx + vy * vy) / Math.sqrt(2);
			}
			
			// convert to multiplied precision space
			originX *= precision;
			originY *= precision;
			left *= precision;
			top *= precision;
			width *= precision;
			height *= precision;
			
			// Set box
			var element = this.element;
			element.coordorigin = originX + ',' + originY;
			element.coordsize = width + ',' + height;
			element.style.left = left + 'px';
			element.style.top = top + 'px';
			element.style.width = width;
			element.style.height = height;
			element.style.rotation = rotation.toFixed(8);
			element.style.flip = flip < 0 ? 'x' : '';
			
			// Set transform
			var skew = this.skewElement;
			skew.matrix = [transform.xx.toFixed(4), transform.xy.toFixed(4), transform.yx.toFixed(4), transform.yy.toFixed(4), 0, 0];
			skew.origin = transformOriginX + ',' + transformOriginY;
	
			// Set stroke
			this.strokeElement.weight = strokeWidth + 'px';
		},
		
		/* styles */
	
		_createGradient: function(style, stops){
			var fill = this.fillElement;
	
			// Temporarily eject the fill from the DOM
			this.element.removeChild(fill);
	
			fill.type = style;
			fill.method = 'none';
			fill.rotate = true;
	
			var colors = [], color1, color2;
	
			var addColor = function(offset, color){
				color = Color.detach(color);
				if (color1 == null) color1 = color2 = color;
				else color2 = color;
				colors.push(offset + ' ' + color[0]);
			};
	
			// Enumerate stops, assumes offsets are enumerated in order
			if ('length' in stops) for (var i = 0, l = stops.length - 1; i <= l; i++) addColor(i / l, stops[i]);
			else for (var offset in stops) addColor(offset, stops[offset]);
			
			fill.color = color1[0];
			fill.color2 = color2[0];
			
			//if (fill.colors) fill.colors.value = colors; else
			fill.colors = colors;
	
			// Opacity order gets flipped when color stops are specified
			fill.opacity = color2[1];
			fill['ao:opacity2'] = color1[1];
	
			fill.on = true;
			this.element.appendChild(fill);
			return fill;
		},
		
		_setColor: function(type, color){
			var element = type == 'fill' ? this.fillElement : this.strokeElement;
			if (color == null){
				element.on = false;
			} else {
				color = Color.detach(color);
				element.color = color[0];
				element.opacity = color[1];
				element.on = true;
			}
		},
		
		fill: function(color){
			if (arguments.length > 1){
				this.fillLinear(arguments);
			} else {
				this._boxCoords = defaultBox;
				var fill = this.fillElement;
				fill.type = 'solid';
				fill.color2 = '';
				fill['ao:opacity2'] = '';
				if (fill.colors) fill.colors.value = '';
				this._setColor('fill', color);
			}
			return this;
		},
	
		fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
			var fill = this._createGradient('gradientradial', stops);
			if (focusX == null) focusX = this.left + this.width * 0.5;
			if (focusY == null) focusY = this.top + this.height * 0.5;
			if (radiusY == null) radiusY = radiusX || (this.height * 0.5);
			if (radiusX == null) radiusX = this.width * 0.5;
			if (centerX == null) centerX = focusX;
			if (centerY == null) centerY = focusY;
			
			centerX += centerX - focusX;
			centerY += centerY - focusY;
			
			var box = this._boxCoords = {
				left: centerX - radiusX * 2,
				top: centerY - radiusY * 2,
				width: radiusX * 4,
				height: radiusY * 4
			};
			focusX -= box.left;
			focusY -= box.top;
			focusX /= box.width;
			focusY /= box.height;
	
			fill.focussize = '0 0';
			fill.focusposition = focusX + ',' + focusY;
			fill.focus = '50%';
			
			this._transform();
			
			return this;
		},
	
		fillLinear: function(stops, x1, y1, x2, y2){
			var fill = this._createGradient('gradient', stops);
			fill.focus = '100%';
			if (arguments.length == 5){
				var w = Math.abs(x2 - x1), h = Math.abs(y2 - y1);
				this._boxCoords = {
					left: Math.min(x1, x2),
					top: Math.min(y1, y2),
					width: w < 1 ? h : w,
					height: h < 1 ? w : h
				};
				fill.angle = (360 + Math.atan2((x2 - x1) / h, (y2 - y1) / w) * 180 / Math.PI) % 360;
			} else {
				this._boxCoords = null;
				fill.angle = (x1 == null) ? 0 : (90 + x1) % 360;
			}
			this._transform();
			return this;
		},
	
		fillImage: function(url, width, height, left, top, color1, color2){
			var fill = this.fillElement;
			if (color1 != null){
				color1 = Color.detach(color1);
				if (color2 != null) color2 = Color.detach(color2);
				fill.type = 'pattern';
				fill.color = color1[0];
				fill.color2 = color2 == null ? color1[0] : color2[0];
				fill.opacity = color2 == null ? 0 : color2[1];
				fill['ao:opacity2'] = color1[1];
			} else {
				fill.type = 'tile';
				fill.color = '';
				fill.color2 = '';
				fill.opacity = 1;
				fill['ao:opacity2'] = 1;
			}
			if (fill.colors) fill.colors.value = '';
			fill.rotate = true;
			fill.src = url;
			
			fill.size = '1,1';
			fill.position = '0,0';
			fill.origin = '0,0';
			fill.aspect = 'ignore'; // ignore, atleast, atmost
			fill.on = true;
	
			if (!left) left = 0;
			if (!top) top = 0;
			this._boxCoords = width ? { left: left + 0.5, top: top + 0.5, width: width, height: height } : null;
			this._transform();
			return this;
		},
	
		/* stroke */
		
		stroke: function(color, width, cap, join){
			var stroke = this.strokeElement;
			this._strokeWidth = (width != null) ? width : 1;
			stroke.weight = (width != null) ? width + 'px' : 1;
			stroke.endcap = (cap != null) ? ((cap == 'butt') ? 'flat' : cap) : 'round';
			stroke.joinstyle = (join != null) ? join : 'round';
	
			this._setColor('stroke', color);
			return this;
		}
	
	});

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Transform = __webpack_require__(61);
	var Container = __webpack_require__(71);
	var Node = __webpack_require__(144);
	
	module.exports = Class(Node, Container, {
		
		element_initialize: Node.prototype.initialize,
		
		initialize: function(width, height){
			this.element_initialize('group');
			this.width = width;
			this.height = height;
		},
	
		_transform: function(){
			var element = this.element;
			element.coordorigin = '0,0';
			element.coordsize = '1000,1000';
			element.style.left = 0;
			element.style.top = 0;
			element.style.width = 1000;
			element.style.height = 1000;
			element.style.rotation = 0;
			
			var container = this.parentNode;
			this._activeTransform = container ? new Transform(container._activeTransform).transform(this) : this;
			var node = this.firstChild;
			while (node){
				node._transform();
				node = node.nextSibling;
			}
		}
	
	});

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Container = __webpack_require__(71);
	var Element = __webpack_require__(142);
	var DOM = __webpack_require__(72);
	
	var precision = 100;
	
	var VMLSurface = Class(Element, Container, {
		
		initialize: function VMLSurface(width, height, existingElement){
			this.element = existingElement || document.createElement('vml');
			this.containerElement = DOM.createElement('group');
			this.element.appendChild(this.containerElement);
			if (width != null && height != null) this.resize(width, height);
		},
	
		resize: function(width, height){
			this.width = width;
			this.height = height;
			
			var style = this.element.style;
			style.pixelWidth = width;
			style.pixelHeight = height;
			
			style = this.containerElement.style;
			style.width = width;
			style.height = height;
			
			var halfPixel = (0.5 * precision);
			
			this.containerElement.coordorigin = halfPixel + ',' + halfPixel;
			this.containerElement.coordsize = (width * precision) + ',' + (height * precision);
	
			return this;
		}
		
	});
	
	VMLSurface.tagName = 'av:vml';
	
	module.exports = VMLSurface;

/***/ },
/* 843 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = "BundleVersion: 10.7.1500352320";

/***/ },
/* 844 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = "10.7.1500352320";

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(4),
	    requireNativeComponent = _require.requireNativeComponent,
	    NativeModules = _require.NativeModules,
	    Platform = _require.Platform;
	
	if (Platform.OS === "ios") {
	  module.exports = requireNativeComponent('RNCardIOView', null);
	} else {
	  module.exports = NativeModules.RNCardIO;
	}

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RNDBModel = __webpack_require__(1165);
	var DB = {
	  table: function table(tableName) {
	    if (typeof DB[tableName] === 'undefined') DB[tableName] = new RNDBModel.create_db(tableName);
	
	    return DB[tableName];
	  }
	};
	module.exports = DB;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	var Icon = __webpack_require__(13);
	var NumericalInput = __webpack_require__(92);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Animated = ReactNative.Animated,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MK = __webpack_require__(14);
	var MKSpinner = MK.MKSpinner;
	
	
	var PREDICTION_DELAY = 50;
	
	var PhoneLoyaltyInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var phoneNumberButtonStr = locManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON");
	    return {
	      layout: this.props.initialLayout,
	      campaigns: [],
	      useCreditCampaign: null,
	      referCampaign: null,
	      checkInCampaign: null,
	      transferLoyaltyCampaign: null,
	      isShowingSpinner: false,
	      buttonIsEnabled: false,
	      buttonTitle: phoneNumberButtonStr
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Campaigns !== 'undefined') {
	      var useCreditCampaign = null;
	      var referCampaign = null;
	      var checkInCampaign = null;
	      var transferLoyaltyCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        var campaign = data.Campaigns[i];
	        if (campaign.Type == "UseCredit") useCreditCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "TransferLoyalty") transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
	      }
	      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
	      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
	      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0, AssignPoints: 0/1};
	      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};
	
	      this.setState({
	        campaigns: data.Campaigns,
	        useCreditCampaign: useCreditCampaign,
	        referCampaign: referCampaign,
	        checkInCampaign: checkInCampaign,
	        transferLoyaltyCampaign: transferLoyaltyCampaign
	      });
	    }
	  },
	
	  resetPredictions: function resetPredictions() {
	    this._predictions = [];
	    this._currentPhoneNumber = "";
	    if (this.refs.phoneInput) this.refs.phoneInput.clearSelected();
	    this.setPredictions();
	  },
	
	  _currentPhoneNumber: "",
	  _predictions: [],
	  setPredictions: function setPredictions(predictions) {
	    if (typeof predictions === 'undefined') predictions = this._predictions;
	    var newPredictions = [];
	    var foundMatch = false;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var phoneNumberButtonStr = locManager.localizedStringForKey("TYPE_PHONE_NUMBER_BUTTON");
	    var createAccountStr = locManager.localizedStringForKey("CREATE_USER_TITLE");
	    var continueStr = locManager.localizedStringForKey("CONTINUE_BUTTON");
	    for (var i = 0; i < predictions.length; i++) {
	      var user = predictions[i];
	      if (user.PhoneNumber.indexOf(this._currentPhoneNumber) == 0) {
	        foundMatch = true;
	        newPredictions.push(user);
	      }
	    }
	    this._predictions = newPredictions;
	    console.log("foundMatch");
	    if (foundMatch) {
	      this.refs.phoneInput.setPredictedValue(this.refs.phoneInput.stringPhoneValue(newPredictions[0].PhoneNumber));
	      this.setState({ buttonTitle: continueStr, buttonIsEnabled: true });
	    } else if (this._currentPhoneNumber.length >= 11) {
	      this.refs.phoneInput.setPredictedValue("");
	      this.setState({ buttonTitle: createAccountStr, buttonIsEnabled: true });
	    } else {
	      this.refs.phoneInput.setPredictedValue("");
	      this.setState({ buttonTitle: phoneNumberButtonStr, buttonIsEnabled: false });
	    }
	  },
	
	  updatePredictions: function updatePredictions(phoneNumber, shouldFetchNew) {
	    this._currentPhoneNumber = phoneNumber;
	    if (!shouldFetchNew) {
	      this.setPredictions();
	      this.setState({ isShowingSpinner: false });
	      return;
	    }
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	
	    this.setState({ isShowingSpinner: true });
	    thisThing.setPredictions();
	    setTimeout(function () {
	      if (thisThing._currentPhoneNumber != phoneNumber) return; // early return because its changed
	
	      NetworkManager.lookUpUserByPhone(appManager, phoneNumber, function (result) {
	        if (thisThing._currentPhoneNumber != phoneNumber) return; // early return because its changed
	        thisThing.setState({ isShowingSpinner: false });
	        thisThing.setPredictions(result);
	      }, function () {
	        if (thisThing._currentPhoneNumber != phoneNumber) return; // early return because its changed
	        thisThing.setState({ isShowingSpinner: false });
	        thisThing.setPredictions();
	      }, function () {
	        if (thisThing._currentPhoneNumber != phoneNumber) return; // early return because its changed
	        thisThing.setState({ isShowingSpinner: false });
	        thisThing.setPredictions();
	      });
	    }, PREDICTION_DELAY);
	  },
	
	  submitPressed: function submitPressed() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	
	    if (this._predictions.length > 0) {
	      var userID = this._predictions[0].UserID;
	      var hash = this._predictions[0].Hash;
	      var extras = {};
	      extras.userID = userID;
	      extras.UserID = userID;
	      extras.U = userID;
	      extras.hash = hash;
	      extras.H = hash;
	      extras.onlyPoints = true;
	      extras.shouldShowResendVerify = true;
	      extras.phoneNumber = this._predictions[0].PhoneNumber;
	      appActions.requestFeatureName("GiftCardOptions", extras);
	    } else {
	      var phone = this._currentPhoneNumber;
	      var createAccountAlertStr = locManager.localizedStringForKeyAndParams("CREATE_ACCOUNT_ALERT_BODY", [this.refs.phoneInput.stringPhoneValue()]);
	      var processingSpinnerStr = locManager.localizedStringForKey("PROCESSING_SPINNER");
	
	      appActions.showLocalizedAlert("CREATE_ACCOUNT_ALERT_TITLE", createAccountAlertStr, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	        appActions.setSpinnerShown(false);
	        appActions.hideAlert();
	      }, function () {
	        appActions.hideAlert();
	        appActions.setSpinnerShown(true, thisThing.processingSpinnerStr);
	        var failure = function failure(data) {
	          appActions.setSpinnerShown(false);
	          var createAccountFailureTitle = locManager.localizedStringForKey("CREATE_ACCOUNT_FAILURE_ALERT_TITLE", "Failure");
	          var createAccountFailureBody = locManager.localizedStringForKey("CREATE_ACCOUNT_FAILURE_ALERT_BODY", "Could not create account.");
	          var yesButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
	
	          appActions.showAlert(createAccountFailureTitle, createAccountFailureBody, [yesButton], [function () {
	            appActions.hideAlert();
	          }]);
	        };
	        NetworkManager.createUserByPhone(appManager, phone, null, function (data) {
	          if (typeof data.UserName !== 'undefined') {
	            NetworkManager.lookUpUserByPhone(appManager, phone, function (data) {
	              if (data.length == 1) {
	                appActions.setSpinnerShown(false);
	                var extras = {};
	                extras.userID = data[0].UserID;
	                extras.UserID = data[0].UserID;
	                extras.U = data[0].UserID;
	                extras.hash = data[0].Hash;
	                extras.H = data[0].Hash;
	                extras.onlyPoints = true;
	                extras.shouldShowResendVerify = true;
	                extras.phoneNumber = phone;
	                extras.Verified = data[0].Verified;
	                appActions.requestFeatureName("GiftCardOptions", extras);
	
	                thisThing.resetPredictions();
	              } else {
	                failure();
	              }
	            }, failure, failure);
	          } else {
	            failure();
	          }
	        }, failure, failure);
	      }], function () {}, false, false, 20, 18, 20);
	    }
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var dollarsPerPoint = 0;
	    var isAssignPoints = false;
	    if (this.state.checkInCampaign != null && this.state.checkInCampaign.DollarsPerPoint != 0) {
	      dollarsPerPoint = this.state.checkInCampaign.DollarsPerPoint;
	    } else if (this.state.checkInCampaign != null && typeof this.state.checkInCampaign.AssignPoints !== 'undefined' && this.state.checkInCampaign.AssignPoints != 0) {
	      isAssignPoints = true;
	    }
	    var inputHeight = 400;
	    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width - 20;
	    var buttonWidth = this.state.layout.width - 20;
	    var buttonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var cancelStr = locManager.localizedStringForKey("CANCEL_BUTTON");
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { paddingTop: Globals.STATUS_BAR_HEIGHT, backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', alignItems: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'row' } },
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(NumericalInput, { ref: 'phoneInput',
	              style: { height: inputHeight, width: inputWidth, marginTop: 20 },
	              isPhoneNumber: true,
	              appManager: this.props.appManager,
	              initialValue: "1",
	              valueChanged: function valueChanged(newValue, newStringValue) {
	                var phoneNumber = thisThing.refs.phoneInput.strippedPhoneNumber(newValue);
	                thisThing.updatePredictions(phoneNumber, phoneNumber.length >= 7);
	              }
	            }),
	            React.createElement(View, { style: { flex: 1 } })
	          ),
	          React.createElement(
	            ReUpButton,
	            { style: [styles.button, { margin: 10, width: buttonWidth, opacity: thisThing.state.buttonIsEnabled ? 1 : .6 }],
	              appManager: appManager,
	              onPress: function onPress() {
	                if (thisThing.state.buttonIsEnabled) thisThing.submitPressed();
	              } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' } },
	              React.createElement(
	                View,
	                { style: { flex: -1, justifyContent: 'flex-start', flexDirection: 'row' } },
	                this.state.isShowingSpinner ? React.createElement(MKSpinner, { style: {
	                    alignSelf: 'center',
	                    backgroundColor: 'transparent'
	                  }, strokeColor: [buttonTitleColor] }) : React.createElement(
	                  ReUpText,
	                  { isTitle: true, pointerEvents: 'none', appManager: appManager,
	                    style: {
	                      textAlign: 'center',
	                      lineHeight: 24,
	                      alignSelf: 'center',
	                      color: buttonTitleColor,
	                      fontFamily: appManager.getFontForKey("Bold"),
	                      backgroundColor: 'transparent',
	                      fontWeight: 'bold' } },
	                  this.state.buttonTitle
	                )
	              )
	            )
	          ),
	          React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, width: buttonWidth }],
	            appManager: appManager,
	            text: cancelStr,
	            onPress: function onPress() {
	              thisThing.props.appActions.requestPop();
	              if (typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true) {
	                setTimeout(function () {
	                  thisThing.props.extras.scanner.scan();
	                }, 300);
	              }
	            }
	          })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	PhoneLoyaltyInput.dataDependencies = ["Campaigns"];
	
	module.exports = PhoneLoyaltyInput;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView; //require('./wrappers/react-native-blur-wrapper');
	
	
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpImage = __webpack_require__(1131);
	var RNFS = __webpack_require__(96);
	var PlatformConstants = __webpack_require__(31);
	
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    Keyboard = ReactNative.Keyboard,
	    ListView = ReactNative.ListView;
	
	
	var Tutorial = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      additionalPages: [],
	      shouldShowCloseButton: true,
	      useInterstitialFlow: false,
	      tutorialDidFinish: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var ds = new ListView.DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
	        return r1 !== r2;
	      } });
	    return {
	      layout: this.props.initialLayout,
	      pages: [],
	      currentPageIndex: 0,
	      currentPageOffset: new Animated.Value(0),
	      newImageOpacity: new Animated.Value(0),
	      dataSource: ds.cloneWithRows(['John', 'Joel', 'James', 'Jimmy', 'Jackson', 'Jillian', 'Julie', 'Devin']),
	      scrollEnabled: true,
	      cardHeight: -1,
	      additionalPages: typeof this.props.extras !== 'undefined' && typeof this.props.extras.additionalPages !== 'undefined' ? this.props.extras.additionalPages : [],
	      opacity: new Animated.Value(0),
	      shouldShowPageUI: true
	    };
	  },
	
	  setAdditionalPages: function setAdditionalPages(additionalPages, additionalPageDatas) {
	    this.setState({ additionalPages: additionalPages, additionalPageDatas: additionalPageDatas });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._didMount = true;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var date = new Date().getTime();
	    appManager.setVariable(appManager.TUTORIAL_LAST_VIEWED, date, function () {});
	    var addCredit = null;
	    var feedNotLoggedIn = null;
	    var menuOut = null;
	    var rewards = null;
	    var useCredit = null;
	    var earnPoints = null;
	
	    var thisThing = this;
	
	    appManager.doesResourceExist("Tutorial/iPhone6Plus-AddCredit.png", function (exists) {
	      if (exists) addCredit = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-AddCredit.png";
	      appManager.doesResourceExist("Tutorial/iPhone6Plus-EarnPoints.png", function (exists) {
	        if (exists) earnPoints = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-EarnPoints.png";
	        appManager.doesResourceExist("Tutorial/iPhone6Plus-FeedUpNotLoggedIn.png", function (exists) {
	          if (exists) feedNotLoggedIn = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-FeedUpNotLoggedIn.png";
	          appManager.doesResourceExist("Tutorial/iPhone6Plus-MenuOut.png", function (exists) {
	            if (exists) menuOut = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-MenuOut.png";
	            appManager.doesResourceExist("Tutorial/iPhone6Plus-Rewards.png", function (exists) {
	              if (exists) rewards = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-Rewards.png";
	              appManager.doesResourceExist("Tutorial/iPhone6Plus-UseCredit.png", function (exists) {
	                if (exists) useCredit = PlatformConstants.resourcesDirectory + "/Tutorial/iPhone6Plus-UseCredit.png";
	
	                var addCreditFeature = appManager.getFeatureForName("AddCredit");
	                var rewardsFeature = appManager.getFeatureForName("Rewards");
	                var rewardsCampaignsFeature = appManager.getFeatureForName("RewardsCampaigns");
	                var useCreditFeature = appManager.getFeatureForName("UseCredit");
	
	                var introText = locManager.localizedStringForKey("INTRO_TEXT_ONE");
	                if (typeof addCreditFeature !== 'undefined') introText += " " + locManager.localizedStringForKey("INTRO_ADD_CREDIT");
	                if (typeof rewardsCampaignsFeature !== 'undefined') introText += " " + locManager.localizedStringForKeyAndParams("INTRO_REWARDS", [rewardsCampaignsFeature.data.title]);else if (typeof rewardsFeature !== 'undefined') introText += " " + locManager.localizedStringForKeyAndParams("INTRO_REWARDS", [rewardsFeature.data.title]);
	
	                var pages = [];
	
	                pages.push({ title: thisThing.props.appManager.appNameLong, body: introText, image: PlatformConstants.resourcesDirectory + '/App/Splash.png', button: "Tell me more..." });
	
	                // if( feedNotLoggedIn != null )
	                // {
	                //   pages.push({title:"Join Up", body:"Create an account or log into the app to experience all its features.", image:feedNotLoggedIn, button:"Next..."});
	                // }
	
	                // if( menuOut != null )
	                // {
	                //   pages.push({title:"The Menu", body:"To navigate, open up the menu by tapping the icon on the top left.", image:menuOut, button:"I can do that..."});
	                // }
	
	                // if( addCredit != null && typeof addCreditFeature !== 'undefined' )
	                // {
	                //   pages.push({title:addCreditFeature.data.title, body:"Select the " + addCreditFeature.data.title + " option from the menu to add credit to your app.", image:addCredit, button:"Sounds good..."});
	                // }
	
	                if (useCredit != null && typeof useCreditFeature !== 'undefined') {
	                  pages.push({ title: useCreditFeature.data.title, body: locManager.localizedStringForKeyAndParams("INTRO_USE_CREDIT", [useCreditFeature.data.title]), image: useCredit, button: "Okay..." });
	                }
	
	                // if( rewards != null && typeof rewardsFeature !== 'undefined' )
	                // {
	                //   pages.push({title:rewardsFeature.data.title, body:"After earning enough points, select the " + rewardsFeature.data.title + " option in the menu to redeem your free reward!", image:rewards, button:"Got it..."});
	                // }
	
	                if (earnPoints != null) {
	                  var earnPointsFeature = appManager.getFeatureForName("EarnPoints");
	                  if (typeof earnPointsFeature !== 'undefined') pages.push({ title: earnPointsFeature.data.title, body: locManager.localizedStringForKeyAndParams("INTRO_EARN_POINTS", [earnPointsFeature.data.title]), image: earnPoints, button: "Points are nice..." });
	                }
	
	                if (pages.length > 1) {
	                  var settingsFeature = appManager.getFeatureForName("Settings");
	                  pages.push({ title: locManager.localizedStringForKey("INTRO_FINISHED_TITLE"), body: locManager.localizedStringForKey("INTRO_SETTINGS") });
	                }
	
	                var imageOpacities = [];
	                for (var i = 0; i < pages.length; i++) {
	                  imageOpacities.push(new Animated.Value(0));
	                }
	                if (thisThing._didMount) thisThing.setState({ pages: pages, imageOpacities: imageOpacities });
	              });
	            });
	          });
	        });
	      });
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._didMount = false;
	  },
	
	  fadeIn: function fadeIn() {
	    Animated.timing(this.state.opacity, {
	      toValue: 1,
	      duration: 100
	    }).start(function () {});
	  },
	
	  getInfoForSkip: function getInfoForSkip() {
	    var isAdditionalPage = this.state.pages.length <= this.state.currentPageIndex;
	    if (isAdditionalPage && typeof this.props.extras === 'undefined') return "";
	
	    var currentPageIndex = this.state.currentPageIndex;
	    var indexAndPageString = '';
	    if (isAdditionalPage) {
	      var additionalPageIndex = currentPageIndex - this.state.pages.length;
	      var thisAdditionalData = this.props.extras.additionalPageDatas[additionalPageIndex];
	      indexAndPageString = currentPageIndex + '-' + thisAdditionalData.data.title;
	    } else {
	      var currentPageData = this.state.pages[currentPageIndex];
	      indexAndPageString = currentPageIndex + '-' + currentPageData.title;
	    }
	    return indexAndPageString;
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  dismiss: function dismiss(completion) {
	    if (this.props.useInterstitialFlow) {
	      this.props.tutorialDidFinish(completion);
	    } else {
	      this.props.appActions.setCustomAlertShown(false);
	    }
	  },
	
	  _navButtonCoolDown: false,
	  _disableGoNextButton: false,
	  goNext: function goNext(completion) {
	    var _this = this;
	
	    var isFromButton = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (this._navButtonCoolDown) return;
	    if (isFromButton && this._disableGoNextButton) return;
	
	    this._navButtonCoolDown = true;
	    setTimeout(function () {
	      return _this._navButtonCoolDown = false;
	    }, 300);
	
	    Keyboard.dismiss();
	    var thisThing = this;
	    var isLastPage = this.state.currentPageIndex >= this.state.pages.length - 1 + this.state.additionalPages.length;
	    var isLastPageBeforeAdditional = this.state.currentPageIndex >= this.state.pages.length - 1;
	    if (isLastPageBeforeAdditional) {
	      this._disableGoNextButton = true;
	      this.setState({ shouldShowPageUI: false });
	    }
	
	    if (isLastPage) {
	      this.dismiss(completion);
	    } else {
	      var newCurrentPageIndex = this.state.currentPageIndex + 1;
	      var xOffset = newCurrentPageIndex * this.state.layout.width;
	      this.refs.scroll.scrollTo({ x: xOffset });
	      var thisThing = this;
	      setTimeout(function () {
	        thisThing.onScroll(xOffset);
	      }, 150);
	    }
	  },
	
	  goBack: function goBack() {
	    var _this2 = this;
	
	    if (this._navButtonCoolDown) return;
	    this._navButtonCoolDown = true;
	    setTimeout(function () {
	      return _this2._navButtonCoolDown = false;
	    }, 300);
	
	    var thisThing = this;
	    var isFirstPage = this.state.currentPageIndex == 0;
	    if (isFirstPage) {
	      // do nothing
	    } else {
	      var newCurrentPageIndex = this.state.currentPageIndex - 1;
	      var xOffset = newCurrentPageIndex * this.state.layout.width;
	      this.refs.scroll.scrollTo({ x: xOffset });
	      var thisThing = this;
	      setTimeout(function () {
	        thisThing.onScroll(xOffset);
	      }, 150);
	    }
	  },
	
	  onScroll: function onScroll(offset) {
	    var page = Math.round(offset / this.state.layout.width);
	    if (page != this.state.currentPageIndex) {
	      this.state.currentPageIndex = page;
	      if (this.state.pages.length > this.state.currentPageIndex) {
	        var activePage = this.state.pages[this.state.currentPageIndex];
	        if (typeof activePage.image !== 'undefined') {
	          this.refs.image.setImage(activePage.image);
	        } else {
	          this.refs.image.setImage(null);
	        }
	      } else {
	        if (this.state.currentPageIndex >= this.state.pages.length + this.state.additionalPages.length) this.dismiss();
	      }
	      if (Platform.OS != 'ios') this.onMomentumScrollEnd();
	      this.setState({ currentPageIndex: page });
	    }
	  },
	
	  onMomentumScrollEnd: function onMomentumScrollEnd() {
	    if (this.state.pages.length <= this.state.currentPageIndex) {
	      console.log("this.setState({scrollEnabled:false})");
	      if (this.state.scrollEnabled) this.setState({ scrollEnabled: false });
	
	      var additionalPageIndex = this.state.currentPageIndex - this.state.pages.length;
	      if (typeof this.refs["additional" + additionalPageIndex] !== 'undefined' && typeof this.refs["additional" + additionalPageIndex].focus !== 'undefined') {
	        this.refs["additional" + additionalPageIndex].focus();
	      }
	
	      if (typeof this.props.extras.didShowAdditional !== 'undefined') {
	        this.props.extras.didShowAdditional();
	      }
	
	      if (typeof this.props.extras !== 'undefined' && typeof this.props.extras.additionalPageDatas !== 'undefined' && this.props.extras.additionalPageDatas.length > additionalPageIndex) {
	        var featureData = this.props.extras.additionalPageDatas[additionalPageIndex];
	        if (typeof this.props.extras.didChangeTitle !== 'undefined') this.props.extras.didChangeTitle(featureData.data.title);
	        if (this.state.scrollEnabled) {
	          // thisThing.refs.scroll.scrollTo({x:page*thisThing.state.layout.width})
	          // thisThing.state.scrollEnabled = false;
	        }
	      }
	    }
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var layout = this.state.layout;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var feedCardColor = appManager.getColorForKey("FeedCardColor");
	    var feedCardTitleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var feedCardBannerColor = appManager.getColorForKey("FeedCardBannerColor");
	
	    var phoneFrameRatio = parseFloat(16 / 9); // (H/W)
	    var percentOfWidth = parseFloat(0.6);
	    var percentSpeakerWidth = parseFloat(0.17);
	    var percentScreenWidth = parseFloat(0.85);
	    var phoneScreenRatio = parseFloat(16.0) / parseFloat(9.0);
	    var phoneFrameAdditionalHeight = 26;
	    var phoneFrameWidth = this.state.layout.width * percentOfWidth;
	    var phoneFrameHeight = phoneFrameRatio * phoneFrameWidth + phoneFrameAdditionalHeight;
	    var phoneScreenWidth = phoneFrameWidth * percentScreenWidth;
	    var phoneScreenHeight = phoneScreenWidth * phoneScreenRatio;
	    var phoneSpeakerHeight = 4;
	    var phoneSpeakerWidth = phoneFrameWidth * percentSpeakerWidth;
	
	    var tutorialBackgroundColor = Platform.OS === 'ios' ? 'transparent' : 'transparent';
	
	    var activePage = this.state.currentPageIndex < this.state.pages.length ? this.state.pages[this.state.currentPageIndex] : {};
	    var index = this.state.currentPageIndex;
	
	    var shouldShowBackArrow = this.state.currentPageIndex > 0 && this.state.currentPageIndex < this.state.pages.length && this.state.shouldShowPageUI;
	    var shouldShowForwardArrow = this.state.currentPageIndex < this.state.pages.length && this.state.shouldShowPageUI;
	    var shouldShowPageControl = this.state.cardHeight > 0 && this.state.currentPageIndex < this.state.pages.length && this.state.shouldShowPageUI;
	    // this.state.cardHeight = 0;
	    return React.createElement(
	      Animated.View,
	      { key: "tutorialContainer", style: { opacity: this.state.opacity, flexDirection: 'column', width: this.state.layout.width, height: this.state.layout.height, backgroundColor: tutorialBackgroundColor } },
	      this.state.cardHeight > 0 ? React.createElement(
	        View,
	        { key: "tutorial", style: { backgroundColor: 'transparent', marginLeft: 0, flexDirection: 'row', width: this.state.layout.width, height: this.state.layout.height, paddingTop: this.state.cardHeight + (this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : Globals.STATUS_BAR_HEIGHT) } },
	        React.createElement(
	          View,
	          { pointerEvents: 'none', style: { width: layout.width, height: layout.height - (this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : Globals.STATUS_BAR_HEIGHT) } },
	          React.createElement(
	            View,
	            { key: "imageFrame", style: { flex: 1, flexDirection: 'row', marginTop: 10 } },
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(
	              View,
	              { key: "phoneFrame", style: { flexDirection: 'column', elevation: 2, width: phoneFrameWidth, paddingTop: phoneFrameWidth / 24, height: phoneFrameHeight, borderRadius: 25, backgroundColor: 'white' },
	                shadowColor: 'black',
	                shadowRadius: 2,
	                shadowOffset: { width: 0, height: 2 },
	                shadowOpacity: 0.7 },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', flex: 1, alignItems: 'center' } },
	                React.createElement(
	                  View,
	                  { style: { flex: 1 } },
	                  React.createElement(View, { style: { width: phoneFrameWidth / 24, height: phoneFrameWidth / 24, borderRadius: 100000, backgroundColor: 'grey', alignSelf: 'flex-end' } })
	                ),
	                React.createElement(
	                  View,
	                  { style: { flex: 0, marginHorizontal: phoneFrameWidth / 20, flexDirection: 'column' } },
	                  React.createElement(
	                    View,
	                    { style: { flex: 1, flexDirection: 'column', alignItems: 'center' } },
	                    React.createElement(View, { style: { flex: 1 } }),
	                    React.createElement(View, { style: { width: phoneFrameWidth / 36, height: phoneFrameWidth / 36, borderRadius: 100000, backgroundColor: 'grey', marginBottom: phoneSpeakerHeight * 1.5 } })
	                  ),
	                  React.createElement(View, { style: { height: phoneSpeakerHeight, width: phoneSpeakerWidth, borderRadius: 100000, backgroundColor: 'grey', alignSelf: 'flex-end' } }),
	                  React.createElement(View, { style: { flex: 1 } })
	                ),
	                React.createElement(View, { style: { flex: 1 } })
	              ),
	              React.createElement(
	                View,
	                { key: "phoneFrame2", style: { flex: -1, flexDirection: 'row' } },
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  View,
	                  { key: "phoneFrame3", style: { width: phoneScreenWidth + 6, height: phoneScreenHeight + 6, borderRadius: 2, borderWidth: 3, borderColor: 'grey' } },
	                  React.createElement(ReUpImage, { ref: "image", key: "image", backgroundImage: PlatformConstants.resourcesDirectory + '/App/Splash.png', style: { width: phoneScreenWidth, height: phoneScreenHeight, position: 'absolute', opacity: 1 } })
	                ),
	                React.createElement(View, { style: { flex: 1 } })
	              ),
	              React.createElement(
	                View,
	                { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(View, { style: { width: phoneFrameWidth / 8, height: phoneFrameWidth / 8, borderRadius: 1000, backgroundColor: "#EEE" } })
	              )
	            ),
	            React.createElement(View, { style: { flex: 1 } })
	          ),
	          React.createElement(
	            View,
	            { style: { alignItems: 'center' } },
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(View, { style: { backgroundColor: generalColor, padding: 4, alignItems: 'center' } }),
	            React.createElement(View, { style: { flex: 1 } })
	          )
	        )
	      ) : null,
	      React.createElement(
	        ScrollView,
	        { ref: 'scroll', key: 'scroll',
	          bounces: false, horizontal: true, showsHorizontalScrollIndicator: false,
	          scrollEnabled: this.state.scrollEnabled,
	          keyboardShouldPersistTaps: true,
	          pagingEnabled: true, style: { backgroundColor: 'transparent', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 },
	          onScroll: function onScroll(info) {
	            thisThing.onScroll(info.nativeEvent.contentOffset.x);
	          },
	          scrollEventThrottle: 200,
	          onMomentumScrollEnd: function onMomentumScrollEnd() {
	            thisThing.onMomentumScrollEnd();
	          }
	        },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', backgroundColor: 'transparent' } },
	          React.createElement(
	            View,
	            { shadowRadius: 2,
	              style: { backgroundColor: 'transparent', flexDirection: 'row', marginTop: this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : 0 }, onLayout: function onLayout(e) {
	                if (e.nativeEvent.layout.height > 0 && thisThing.state.cardHeight != e.nativeEvent.layout.height) {
	                  thisThing.setState({ cardHeight: e.nativeEvent.layout.height });thisThing.fadeIn();
	                }
	              } },
	            this.state.pages.map(function (page, pageIndex) {
	              return React.createElement(
	                View,
	                { key: "page" + pageIndex, style: { width: thisThing.state.layout.width - 8, marginHorizontal: 4, backgroundColor: feedCardColor, borderRadius: 2 } },
	                React.createElement(
	                  View,
	                  { style: { paddingBottom: 20, paddingHorizontal: 10, paddingTop: 8 } },
	                  typeof page.title !== 'undefined' ? React.createElement(
	                    View,
	                    { style: { flexDirection: 'row' } },
	                    React.createElement(View, { style: { flex: 1 } }),
	                    React.createElement(
	                      View,
	                      { style: { flexWrap: 'wrap', flex: -1 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: { margin: 4, textAlign: 'center', color: feedCardTitleColor } },
	                        page.title
	                      )
	                    ),
	                    React.createElement(View, { style: { flex: 1 } })
	                  ) : null,
	                  typeof page.body !== 'undefined' ? React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { margin: 4, textAlign: 'center', color: feedCardTitleColor } },
	                    page.body
	                  ) : null
	                )
	              );
	            })
	          ),
	          React.createElement(View, { style: { flex: 1 } })
	        ),
	        thisThing.state.additionalPages.map(function (component, index) {
	          var currentPageIndex = thisThing.state.currentPageIndex;
	          var additionalPageIndex = currentPageIndex - thisThing.state.pages.length;
	          if (index > additionalPageIndex + 1) return null;
	
	          var clonedComponent = React.cloneElement(component, { ref: "additional" + index });
	          return React.createElement(
	            View,
	            { key: "additional" + index, style: { width: thisThing.state.layout.width, height: thisThing.state.layout.height + Globals.ACTION_BAR_HEIGHT, marginTop: -Globals.ACTION_BAR_HEIGHT } },
	            clonedComponent
	          );
	        }),
	        React.createElement(View, { key: "buffer", style: { width: thisThing.state.layout.width, height: thisThing.state.layout.height + Globals.ACTION_BAR_HEIGHT, marginTop: -Globals.ACTION_BAR_HEIGHT } })
	      ),
	      this.props.shouldShowCloseButton ? React.createElement(
	        View,
	        { style: { position: 'absolute', top: 0, left: 0, right: 0, flexDirection: 'row', height: Globals.ACTION_BAR_HEIGHT, paddingHorizontal: 10, paddingTop: Globals.STATUS_BAR_HEIGHT } },
	        React.createElement(View, { style: { flex: 1 } }),
	        React.createElement(
	          View,
	          { style: { backgroundColor: appManager.getColorForKey("GeneralColor", 1), borderRadius: 1000000, alignSelf: 'center' } },
	          React.createElement(ReUpIconButton, { iconName: "times", type: 6, appManager: appManager, onPress: function onPress() {
	              _this3.dismiss();
	            } })
	        )
	      ) : null,
	      React.createElement(
	        View,
	        { style: { position: 'absolute', top: this.state.cardHeight - 14 + (this.props.shouldShowCloseButton ? Globals.ACTION_BAR_HEIGHT : 0), left: 0, right: 0, flexDirection: 'row', paddingBottom: 10, justifyContent: 'center' } },
	        shouldShowPageControl ? thisThing.state.pages.map(function (page, index) {
	          if (index == thisThing.state.currentPageIndex) {
	            return React.createElement(View, { key: "page" + index, style: { marginHorizontal: 5, width: 8, height: 8, borderRadius: 999, backgroundColor: feedCardBannerColor } });
	          }
	          return React.createElement(View, { key: "page" + index, style: { marginHorizontal: 5, width: 8, height: 8, borderRadius: 999, backgroundColor: feedCardTitleColor } });
	        }) : null
	      ),
	      React.createElement(
	        View,
	        { pointerEvents: Platform.OS != 'ios' ? 'box-only' : "auto", onStartShouldSetResponder: function onStartShouldSetResponder() {
	            if (Platform.OS != 'ios') thisThing.goBack();return shouldShowBackArrow;
	          }, style: { position: 'absolute', left: 0, top: (thisThing.state.layout.height - 30 - thisThing.state.cardHeight) / 2 - 50 + thisThing.state.cardHeight, padding: 10, flexDirection: 'row', alignItems: 'center' } },
	        shouldShowBackArrow ? React.createElement(ReUpIconButton, { iconName: "angle-left", appManager: appManager, type: 1, onPress: function onPress() {
	            thisThing.goBack();
	          } }) : null
	      ),
	      React.createElement(
	        View,
	        { pointerEvents: Platform.OS != 'ios' ? 'box-only' : "auto", onStartShouldSetResponder: function onStartShouldSetResponder() {
	            if (Platform.OS != 'ios') thisThing.goNext();return shouldShowForwardArrow;
	          }, style: { position: 'absolute', right: 0, width: 60, height: 60, top: (thisThing.state.layout.height - 30 - thisThing.state.cardHeight) / 2 - 50 + thisThing.state.cardHeight, padding: 10, flexDirection: 'row', alignItems: 'center' } },
	        shouldShowForwardArrow ? React.createElement(ReUpIconButton, { iconName: "angle-right", appManager: appManager, type: 0, onPress: function onPress() {
	            thisThing.goNext(function () {}, true);
	          } }) : null
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    justifyContent: 'center',
	    flexDirection: 'row',
	    alignItems: 'stretch'
	  },
	  blurStyle: {
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'stretch'
	  }
	});
	
	Tutorial.getCards = function (featureData, appActions, data) {
	  if (typeof data.Transactions !== 'undefined' && data.Transactions.length > 1) return [];
	
	  var appManager = appActions._appManager;
	  var didSelect = function didSelect() {
	    appActions.requestFeatureName("Tutorial", { forceShow: true });
	  };
	  var iconName = featureData.data.icon.replace("fa-", "");
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: featureData.data.tip,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: 2
	  }];
	};
	
	Tutorial.customNavigation = function (featureData, appActions, featureBuilder, layout, extras) {
	  if (appActions._appManager.skipTutorial) return;
	  // if( featureData.data.tutorialImages == "TUTORIAL_IMAGE_LIST" ) return;
	
	  appActions._appManager.getVariable(appActions._appManager.TUTORIAL_LAST_VIEWED, function (date) {
	    if (date == null || extras.forceShow == true) {
	      appActions.setCustomAlertShown(true, featureBuilder.featureForData(featureData, layout, appActions._appManager, {}, extras), function () {}, true);
	    }
	  });
	};
	
	Tutorial.dataDependencies = [];
	
	module.exports = Tutorial;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeDrawerWrapper = __webpack_require__(1166);
	
	var _reactNativeDrawerWrapper2 = _interopRequireDefault(_reactNativeDrawerWrapper);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var PlatformConstants = __webpack_require__(31);
	
	var Menu = __webpack_require__(75);
	var FeedCard = __webpack_require__(41);
	
	var Meter = __webpack_require__(91);
	var Category = __webpack_require__(1158);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var ModelConstants = __webpack_require__(11);
	var NetworkManager = __webpack_require__(15);
	var ShadowView = __webpack_require__(20);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    ListView = ReactNative.ListView,
	    ScrollView = ReactNative.ScrollView,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter;
	
	// Tells the library to detect iBeacons
	
	
	var FEED_HEADER_HEIGHT = 80;
	var FEED_CARD_COOLDOWN = 1000;
	
	var dataBlob = {};
	
	var Feed = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialLayout: { x: 0, y: 0, width: 0, height: 0 },
	      getCards: function getCards(featureNames, data) {},
	      dataDependencies: [],
	      loggedOutDataDependencies: [],
	      oldFixedHeaderAndroidEnabled: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var ds = new ListView.DataSource({
	      rowHasChanged: function rowHasChanged(row1, row2) {
	        return row1 !== row2 || true || typeof row1.cardType === 'undefined' || typeof row2.cardType === 'undefined';
	      },
	      sectionHeaderHasChanged: function sectionHeaderHasChanged(s1, s2) {
	        return s1 !== s2;
	      }
	    });
	
	    return {
	      dataSource: ds.cloneWithRowsAndSections([{}]),
	      topFeedSpacerHeight: this.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT,
	      bottomFeedSpacerHeight: this.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT,
	      headerOffset: new Animated.Value(0),
	      stickHeader: false,
	      stickHeaderOffset: new Animated.Value(0),
	      stickHeaderWidth: this.props.initialLayout.width,
	      layout: this.props.initialLayout,
	      cards: [],
	      blurOpacity: new Animated.Value(0),
	      fixedHeaderTop: new Animated.Value(0),
	      fixedHeaderOpacity: new Animated.Value(1),
	      fixedHeaderEnabled: false,
	      nonFixedHeaderOpacity: new Animated.Value(1),
	      nonFixedHeaderTop: new Animated.Value(0)
	    };
	  },
	
	  _context: 0,
	  _didPushUseCredit: false,
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    //     Beacons.detectIBeacons()
	    //
	    //     // Start detecting all iBeacons in the nearby
	    //     try {
	    //       Beacons.startRangingBeaconsInRegion('REGION1')
	    //       console.log(`Beacons ranging started succesfully!`)
	    //     } catch (err) {
	    //       console.log(`Beacons ranging not started, error: ${error}`)
	    //     }
	    //
	    //     // Print a log of the detected iBeacons (1 per second)
	    //     DeviceEventEmitter.addListener('beaconsDidRange', (data) => {
	    //       console.log('Found beacons!', data.beacons)
	    //       if( data.beacons.length > 0 )
	    //       {
	    //         var beacon = data.beacons[0];
	    //         if( beacon.distance < .3 && !thisThing._didPushUseCredit  )
	    //         {
	    //           thisThing._didPushUseCredit = true;
	    //           PushNotification.localNotification({
	    //     /* Android Only Properties */
	    //     id: '0', // (optional) Valid unique 32 bit integer specified as string. default: Autogenerated Unique ID
	    //     ticker: "My Notification Ticker", // (optional)
	    //     autoCancel: true, // (optional) default: true
	    //     largeIcon: "ic_launcher", // (optional) default: "ic_launcher"
	    //     smallIcon: "ic_notification", // (optional) default: "ic_notification" with fallback for "ic_launcher"
	    //     bigText: "My big text that will be shown when notification is expanded", // (optional) default: "message" prop
	    //     subText: "This is a subText", // (optional) default: none
	    //     color: "red", // (optional) default: system default
	    //     vibrate: true, // (optional) default: true
	    //     vibration: 300, // vibration length in milliseconds, ignored if vibrate=false, default: 1000
	    //     tag: 'some_tag', // (optional) add tag to message
	    //     group: "group", // (optional) add group to message
	    //     ongoing: false, // (optional) set whether this is an "ongoing" notification
	    //
	    //     /* iOS and Android properties */
	    //     title: "My Notification Title", // (optional, for iOS this is only used in apple watch, the title will be the app name on other iOS devices)
	    //     message: "My Notification Message", // (required)
	    //     playSound: false, // (optional) default: true
	    //     soundName: 'default', // (optional) Sound to play when the notification is shown. Value of 'default' plays the default sound. It can be set to a custom sound such as 'android.resource://com.xyz/raw/my_sound'. It will look for the 'my_sound' audio file in 'res/raw' directory and play it. default: 'default' (default sound is played)
	    //     number: '10', // (optional) Valid 32 bit integer specified as string. default: none (Cannot be zero)
	    // });
	    //           appActions.requestFeatureName("UseCredit");
	    //         }
	    //       }
	    //     })
	
	    appManager.loginCallBackStart = function () {
	      appActions.requestPop(false);
	      appActions.setSpinnerShown(true, "Logging in...");
	      appManager.getCurrentUser(function (a) {
	        thisThing.checkUserChanged();
	      });
	    };
	    appManager.loginCallBackFinish = function () {
	      appActions.requestPop(false);
	      appActions.setSpinnerShown(false);
	      appManager.getCurrentUser(function (a) {
	        thisThing.checkUserChanged();
	      });
	    };
	    var appActions = this.props.appActions;
	    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
	
	    var _props$dataDependency = this.props.dataDependencyRetriever(feedFeatureNames),
	        dataDependencies = _props$dataDependency.dataDependencies,
	        customDependencies = _props$dataDependency.customDependencies;
	
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	
	    appManager.getDataTypes(thisThing.props.allDependencyKeys, function (data) {
	      thisThing.didUpdate(data);
	    });
	
	    NetworkManager.update(appManager, dataDependencies, function (newData) {
	      if (customDependencies.length <= 0) {
	        thisThing.didUpdate(newData);
	      } else {
	        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function (totalData) {
	          thisThing.didUpdate(totalData);
	        });
	      }
	    }, function () {});
	
	    var thisThing = this;
	    this.props.appManager.getSelfie(function (selfieURL) {
	      thisThing.setState({ selfieURL: selfieURL });
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  viewDidLayout: function viewDidLayout(info) {
	    var layout = info.nativeEvent.layout;
	    var topFeedSpacerHeight = Platform.OS !== 'ios' && Platform.OS !== 'web' && !this.props.oldFixedHeaderAndroidEnabled ? 0 : layout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT;
	    if (JSON.stringify(layout) == JSON.stringify(this.state.layout) && topFeedSpacerHeight == this.state.topFeedSpacerHeight) return;
	
	    this.setState({ layout: layout, topFeedSpacerHeight: topFeedSpacerHeight });
	  },
	
	  renderRow: function renderRow(rowData, sectionID, rowNumber) {
	    if (typeof rowData.cardType === 'undefined') {
	      return null;
	    }
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	
	    return React.createElement(FeedCard, Object.assign({}, rowData, {
	      key: rowData.key,
	      appManager: appManager,
	      iconColor: bannerIconColor,
	      bannerColor: bannerColor,
	      cardColor: cardColor,
	      titleColor: titleColor,
	      bodyColor: bodyColor,
	      rippleColor: rippleColor,
	      cardHeight: function cardHeight(height) {} }));
	  },
	
	  renderSectionHeader: function renderSectionHeader(sectionData, sectionID) {
	    var _ref;
	
	    var loggedIn = this.props.appManager.isLoggedIn();
	
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", 0.2);
	
	    var useCreditFeature = this.props.appManager.getFeatureForName("UseCredit");
	    var creditIconName = "pay-shortcut"; //typeof useCreditFeature === 'undefined' ? "" : useCreditFeature.data.icon.replace("fa-", "");
	    var useCreditIsInFeed = typeof useCreditFeature === 'undefined' ? false : useCreditFeature.data.shouldShowInFeed;
	
	    var earnPointsFeature = this.props.appManager.getFeatureForName("EarnPoints");
	    var rewardsIconName = typeof earnPointsFeature === 'undefined' ? "trophy" : earnPointsFeature.data.icon.replace("fa-", "");
	    var rewardsIsInFeed = typeof earnPointsFeature === 'undefined' ? false : earnPointsFeature.data.shouldShowInFeed;
	
	    var creditPercentage = 0;
	    var pointPercentage = 0;
	    var creditString = "";
	    var pointsString = "";
	    var initials = "";
	
	    if (loggedIn) {
	      initials = appManager.currentUserInitials();
	      var maxDollars = parseFloat(appManager.getLocalizationManager().getConstants()["CREDITS_FOR_MAX"]);
	      var maxPoints = parseFloat(appManager.getLocalizationManager().getConstants()["TOTAL_POINTS_FOR_REWARD"]);
	      var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
	      var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
	      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
	      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
	      creditPercentage = parseFloat(currDollars / maxDollars);
	      pointPercentage = parseFloat(currPoints / maxPoints);
	    }
	
	    var leftTextStyle = { backgroundColor: 'transparent', margin: 0, marginTop: 0, marginLeft: 2, width: FEED_HEADER_HEIGHT - 16 - 4, height: FEED_HEADER_HEIGHT - 16 - 4, borderRadius: (FEED_HEADER_HEIGHT - 16 - 4) / 2, justifyContent: 'center', alignItems: 'center' };
	    return React.createElement(
	      View,
	      null,
	      React.createElement(
	        View,
	        { style: [styles.feedHeader, { backgroundColor: profileColor, flexDirection: 'row', justifyContent: 'center', width: this.state.layout.width, height: FEED_HEADER_HEIGHT }] },
	        React.createElement(
	          View,
	          { style: styles.feedHeaderLeftContainer },
	          React.createElement(
	            TouchableHighlight,
	            {
	              underlayColor: "transparent",
	              activeOpacity: 0.9,
	              onPress: function onPress() {
	                appActions.requestFeatureName("Settings");
	              } },
	            React.createElement(
	              View,
	              { style: [styles.profileImage, (_ref = { borderColor: 'transparent', backgroundColor: profileColor }, _defineProperty(_ref, 'backgroundColor', 'transparent'), _defineProperty(_ref, 'borderWidth', 0), _ref)] },
	              !loggedIn ? React.createElement(
	                View,
	                { style: leftTextStyle },
	                React.createElement(_ReUpIcon2.default, { name: "lock", size: 48, color: profileImageColor })
	              ) : typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0 ? React.createElement(
	                View,
	                null,
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [styles.profileImageText, { color: profileImageColor, position: 'absolute', top: 13, left: 0, right: 0, bottom: 0 }] },
	                  initials
	                ),
	                React.createElement(Image, { source: { uri: this.state.selfieURL }, style: leftTextStyle })
	              ) : React.createElement(
	                View,
	                { style: leftTextStyle },
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.profileImageText, { color: profileImageColor }] },
	                    initials
	                  )
	                )
	              ),
	              React.createElement(
	                _reactNativeSvgWrapper2.default,
	                {
	                  height: FEED_HEADER_HEIGHT,
	                  width: FEED_HEADER_HEIGHT,
	                  style: { position: 'absolute', top: -12, left: -12, backgroundColor: 'transparent' }
	                },
	                React.createElement(
	                  _reactNativeSvgWrapper.G,
	                  { scale: '1' },
	                  React.createElement(_reactNativeSvgWrapper.Circle, { cx: (FEED_HEADER_HEIGHT + 8) / 2, cy: (FEED_HEADER_HEIGHT + 8) / 2, r: (FEED_HEADER_HEIGHT - 16 - 4) / 2, stroke: profileImageColor, 'stroke-width': '2', fill: 'transparent' })
	                )
	              )
	            )
	          )
	        ),
	        loggedIn ? React.createElement(
	          View,
	          { style: [styles.feedHeaderCenterContainer] },
	          useCreditIsInFeed ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              MKButton,
	              { onPress: function onPress() {
	                  return appActions.requestFeatureName("UseCredit");
	                } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  Meter,
	                  { height: FEED_HEADER_HEIGHT / 3, initialPercent: creditPercentage, innerColor: profileMeterColor, outerColor: profileMeterBackgroundColor, style: { flex: 1 } },
	                  React.createElement(_ReUpIcon2.default, { name: creditIconName, size: FEED_HEADER_HEIGHT / 5, color: profileIconColor, style: { backgroundColor: 'transparent' } })
	                ),
	                React.createElement(
	                  View,
	                  { style: { width: FEED_HEADER_HEIGHT, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(
	                    View,
	                    null,
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, isTitle: true, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	                      creditString
	                    )
	                  )
	                )
	              )
	            )
	          ) : null,
	          rewardsIsInFeed ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              MKButton,
	              { onPress: function onPress() {
	                  return appActions.requestFeatureName("Rewards");
	                }, style: { flexDirection: 'row' } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  Meter,
	                  { height: FEED_HEADER_HEIGHT / 3, initialPercent: pointPercentage, innerColor: profileMeterColor, outerColor: profileMeterBackgroundColor, style: { flex: 1 } },
	                  React.createElement(_ReUpIcon2.default, { name: rewardsIconName, size: FEED_HEADER_HEIGHT / 5, color: profileIconColor, style: { backgroundColor: 'transparent', alignSelf: 'center' } })
	                ),
	                React.createElement(
	                  View,
	                  { style: { width: FEED_HEADER_HEIGHT, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(
	                    View,
	                    null,
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, isTitle: true, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	                      pointsString
	                    )
	                  )
	                )
	              )
	            )
	          ) : null
	        ) : React.createElement(
	          View,
	          { style: styles.feedHeaderCenterContainer },
	          React.createElement(View, null),
	          React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	              locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	            )
	          ),
	          React.createElement(View, null)
	        )
	      )
	    );
	  },
	
	  renderFooter: function renderFooter() {
	    return React.createElement(View, null);
	  },
	
	  renderHeader: function renderHeader() {
	    return React.createElement(View, { style: [styles.topFeedSpacer, { height: this.state.topFeedSpacerHeight }] });
	  },
	
	  selfieUpdated: function selfieUpdated(data) {
	    if (data.selfieURL != this.state.selfieURL) this.setState({ selfieURL: data.selfieURL });
	  },
	
	  checkUserChanged: function checkUserChanged() {
	    var appManager = this.props.appManager;
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (loggedIn != this._loggedInRendered) {
	      this._loggedInRendered = loggedIn;
	      this.didUpdate({});
	    }
	  },
	
	  _loggedIn: false,
	  _loggedInRendered: false,
	  _hasGoneUp: false,
	  _cardUpdateTimeout: null,
	  _data: {},
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (loggedIn != this._loggedIn) {
	      // logged in status changed, should refresh feed
	      this._hasGoneUp = false;
	      var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
	
	      var _props$dataDependency2 = this.props.dataDependencyRetriever(feedFeatureNames),
	          dataDependencies = _props$dataDependency2.dataDependencies,
	          customDependencies = _props$dataDependency2.customDependencies;
	
	      NetworkManager.update(this.props.appManager, dataDependencies, function (newData) {
	        if (customDependencies.length <= 0) {
	          thisThing.goUp();
	        } else {
	          NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function (totalData) {
	            thisThing.goUp();
	          });
	        }
	      }, function () {});
	      this._loggedIn = loggedIn;
	    } else {
	      setTimeout(function () {
	        if (!thisThing._hasGoneUp) thisThing.goUp();
	      }, 2000);
	    }
	
	    var thisThing = this;
	    thisThing._cardUpdateTimeout = null;
	    var feedFeatureNames = thisThing.props.appManager.getFeedFeatureNames();
	    var feedFeatures = thisThing.props.appManager.getFeedFeatures();
	
	    thisThing.props.appManager.getDataTypes(thisThing.props.allDependencyKeys, function (data) {
	      if (typeof data !== 'undefined') {
	        var cards = thisThing.props.getCards(feedFeatureNames, thisThing.props.appManager, thisThing.props.appActions, data, feedFeatures);
	        cards.push({ footerHeight: thisThing.props.initialLayout.height, date: new Date() });
	        thisThing.props.appManager.getSelfie(function (selfieURL) {
	          if (thisThing.state.bottomFeedSpacerHeight != thisThing.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT || thisThing.state.selfieURL == selfieURL || JSON.stringify(thisThing.state.cards) != JSON.stringify(cards)) {
	            thisThing.setState({ selfieURL: selfieURL, cards: cards, dataSource: thisThing.state.dataSource.cloneWithRowsAndSections([cards]), bottomFeedSpacerHeight: thisThing.props.initialLayout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT });
	          }
	        });
	        if (!thisThing._hasGoneUp) thisThing.goUp();
	      }
	    });
	  },
	
	  _reupScrollView: null,
	  reupScrollViewDidMount: function reupScrollViewDidMount(reupScrollView) {
	    this._reupScrollView = reupScrollView;
	  },
	
	  goUp: function goUp() {
	    if (this._reupScrollView != null) {
	      var thisThing = this;
	      setTimeout(function () {
	        if (thisThing._reupScrollView == null) return;
	        if (Platform.OS != 'ios') thisThing._reupScrollView.scrollTo(0, thisThing.state.layout.height - Globals.FEED_TOP_SPACE_ADJUSTMENT - FEED_HEADER_HEIGHT);else thisThing._reupScrollView.scrollTo(0, thisThing.state.topFeedSpacerHeight);
	      }, 1000);
	      this._hasGoneUp = true;
	    }
	  },
	
	  _isBlurred: false,
	  setIsBlurred: function setIsBlurred(isBlurred) {
	    if (this._isBlurred != isBlurred) {
	      this._isBlurred = isBlurred;
	      Animated.timing(this.state.blurOpacity, { toValue: isBlurred ? 1 : 0, duration: 100 }).start(function () {});
	    }
	  },
	
	  feedDidScroll: function feedDidScroll(info) {
	    if (typeof info.nativeEvent.contentOffset === 'undefined') return;
	    var offset = info.nativeEvent.contentOffset.y;
	    if (this.refs.blurView) {
	      this.refs.blurView.setOpacity(offset / (this.state.layout.height - FEED_HEADER_HEIGHT - Globals.FEED_TOP_SPACE_ADJUSTMENT));
	    }
	    if (this._isBlurred) {
	      this.setIsBlurred(offset > 5);
	    } else {
	      this.setIsBlurred(offset >= this.state.topFeedSpacerHeight - 5);
	    }
	
	    if (Platform.OS != 'ios') {
	      if (offset > this.state.topFeedSpacerHeight && !this.state.fixedHeaderEnabled && this.props.oldFixedHeaderAndroidEnabled) {
	        this.setState({ fixedHeaderEnabled: true, fixedHeaderTop: new Animated.Value(this.state.topFeedSpacerHeight - offset + Globals.ACTION_BAR_HEIGHT) });
	        //
	        // Animated.timing(
	        //   this.state.fixedHeaderOpacity,
	        //   {toValue: 1, duration:200},
	        // ).start(function()
	        // {
	        //
	        // });
	
	        // Animated.timing(
	        //   this.state.fixedHeaderTop,
	        //   {toValue: Globals.ACTION_BAR_HEIGHT, duration:200},
	        // ).start(function()
	        // {
	        //
	        // });
	
	        Animated.spring(this.state.fixedHeaderTop, {
	          toValue: Globals.ACTION_BAR_HEIGHT,
	          friction: 6
	        }).start();
	
	        Animated.timing(this.state.nonFixedHeaderOpacity, { toValue: 0, duration: 0 }).start(function () {});
	      } else if (offset < this.state.topFeedSpacerHeight && this.state.fixedHeaderEnabled) {
	        this.setState({ fixedHeaderEnabled: false, nonFixedHeaderTop: new Animated.Value(this.state.topFeedSpacerHeight - offset) });
	
	        Animated.timing(this.state.nonFixedHeaderOpacity, { toValue: 1, duration: 0 }).start(function () {});
	
	        Animated.spring(this.state.nonFixedHeaderTop, {
	          toValue: 0,
	          friction: 6
	        }).start();
	
	        // Animated.timing(
	        //   this.state.fixedHeaderOpacity,
	        //   {toValue: 0, duration:200},
	        // ).start(function()
	        // {
	        //
	        // });
	      }
	    }
	  },
	
	  render: function render() {
	    var _React$createElement2;
	
	    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
	    var onScroll = this.onScroll;
	    var thisFeed = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var scrollDidMount = this.reupScrollViewDidMount;
	    var bgImage = this.props.appManager.absoluteResourceForPath(this.props.featureData.name + '/' + this.props.featureData.bgImage);
	
	    return React.createElement(
	      View,
	      { style: styles.container, onLayout: this.viewDidLayout },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        _reactNativeDrawerWrapper2.default,
	        (_React$createElement2 = {
	          ref: function ref(a) {
	            if (a != null) appActions.setDrawer(a);
	          },
	          type: 'overlay',
	          onOpen: function onOpen() {
	            appActions.drawerDidOpen();
	          },
	          onClose: function onClose() {
	            appActions.drawerDidClose();
	          },
	          content: React.createElement(Menu, { key: 'menu', ref: 'menu',
	            menuFeatures: this.props.appManager ? this.props.appManager.getMenuFeatures() : [],
	            menuTitleColor: appManager.getColorForKey("MenuTitleColor"),
	            menuIconColor: appManager.getColorForKey("MenuIconColor"),
	            menuHighlightColor: appManager.getColorForKey("MenuSelectionColor"),
	            menuBackgroundColor: appManager.getColorForKey("MenuColor"),
	            menuSeparatorColor: appManager.getColorForKey("MenuIconColor", 0.4),
	            AppActions: this.props.appActions,
	            appActions: this.props.appActions,
	            appManager: appManager
	          }),
	          closedDrawerOffset: -3,
	          openDrawerOffset: 0.2,
	          panOpenMask: .1,
	          panCloseMask: .2,
	          negotiatePan: true,
	          tweenHandler: _reactNativeDrawerWrapper2.default.tweenPresets.parallax,
	          allowPan: true
	        }, _defineProperty(_React$createElement2, 'negotiatePan', true), _defineProperty(_React$createElement2, 'styles', {
	          drawer: { shadowColor: '#000000', shadowOpacity: 0.8, shadowRadius: 3 },
	          main: { paddingLeft: 3 }
	        }), _defineProperty(_React$createElement2, 'tweenHandler', function tweenHandler(ratio) {
	          return {
	            main: { opacity: (2 - ratio) / 2 }
	          };
	        }), _React$createElement2),
	        React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	        React.createElement(
	          ReUpScrollView,
	          _defineProperty({ shouldOverlayRefreshView: true,
	            key: "feedScroll", shadowEnabled: false,
	            bounces: true, onScroll: this.feedDidScroll, scrollEventThrottle: 20,
	            style: styles.scrollContainer,
	            responder: thisFeed,
	            stickyHeaderIndices: [Platform.OS === 'ios' ? 2 : 1]
	          }, 'style', { height: this.state.layout.height }),
	          React.createElement(View, { style: { height: this.state.layout.height - FEED_HEADER_HEIGHT - (Platform.OS == 'web' ? Globals.ACTION_BAR_HEIGHT : 0) } }),
	          this.renderSectionHeader(),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row' } },
	            React.createElement(View, { style: { height: this.state.layout.height - FEED_HEADER_HEIGHT - Globals.ACTION_BAR_HEIGHT } }),
	            React.createElement(
	              View,
	              { style: { flex: 1, paddingBottom: 8 } },
	              this.state.cards.map(function (card, index) {
	                return thisFeed.renderRow(card);
	              })
	            )
	          )
	        )
	      ),
	      this.state.fixedHeaderEnabled ? React.createElement(
	        Animated.View,
	        { style: { position: 'absolute', top: this.state.fixedHeaderTop, left: 0, right: 0, height: FEED_HEADER_HEIGHT + 2, opacity: this.state.fixedHeaderOpacity } },
	        this.renderSectionHeader(null, -1),
	        React.createElement(ShadowView, { appManager: this.props.appManager, layout: this.state.layout })
	      ) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  feedHeader: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'row'
	  },
	  feedHeaderLeftContainer: {
	    padding: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  profileImage: {
	    height: FEED_HEADER_HEIGHT - 16,
	    width: FEED_HEADER_HEIGHT - 16,
	    borderRadius: (FEED_HEADER_HEIGHT - 16) / 2,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: (FEED_HEADER_HEIGHT - 20) / 2,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  feedHeaderCenterContainer: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'column',
	    paddingVertical: 10,
	    flex: 1,
	    justifyContent: 'space-around'
	  },
	
	  feedHeaderRightContainer: {
	    paddingVertical: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  feedHeaderInfo: {
	    fontWeight: 'bold'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  topFeedSpacer: {},
	  bottomFeedSpacer: {},
	  dummyContainer: {
	    position: 'absolute',
	    flex: 1
	  },
	  scrollContainer: {
	    flex: 1
	  },
	  card: {
	    height: 200,
	    margin: 10,
	    backgroundColor: 'brown'
	  },
	  image: {
	    position: 'absolute',
	    flex: 1
	  }
	});
	
	module.exports = Feed;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var Globals = __webpack_require__(10);
	var Animated = __webpack_require__(9);
	
	var ANIM_DURATION = 300;
	
	var NAV_BAR_ANIM_OFFSET_START = 400;
	
	var Navigator = createReactClass({
	  displayName: 'Navigator',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: { position: 'absolute', left: 0, right: 0, bottom: 0, top: 0, flexDirection: 'column' },
	      navigationBar: null,
	      initialRoute: null,
	      renderScene: function renderScene(route, theNav) {},
	      onWillFocus: function onWillFocus(route) {},
	      onDidFocus: function onDidFocus(route) {}
	    };
	  },
	
	  _isAnimating: false,
	  _leftOffsets: [],
	  _rightOffsets: [],
	  getInitialState: function getInitialState() {
	    var navBar = null;
	    if (this.props.navigationBar != null) {
	      var newProps = {
	        nav: this
	      };
	      if (this.props.initialRoute != null) {
	        newProps.initialRouteStack = [this.props.initialRoute];
	      }
	      navBar = React.cloneElement(this.props.navigationBar, newProps);
	    }
	    var routeStack = [];
	    if (this.props.initialRoute != null) {
	      this._leftOffsets.push(new Animated.Value(0));
	      this._rightOffsets.push(new Animated.Value(0));
	      routeStack.push(this.props.initialRoute);
	    }
	
	    return {
	      navBar: navBar,
	      routeStack: routeStack
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.navigationBar !== 'undefined') {
	      var thisThing = this;
	      var newProps = {
	        nav: this
	      };
	      if (this.props.initialRoute != null) {
	        newProps.initialRouteStack = [this.props.initialRoute];
	      }
	      this.setState({
	        navBar: this.props.navigationBar ? React.cloneElement(this.props.navigationBar, newProps) : null
	      });
	    }
	  },
	
	  immediatelyResetRouteStack: function immediatelyResetRouteStack(routeStack) {
	    this._isAnimating = false;
	    this._leftOffsets = [];
	    this._rightOffsets = [];
	    for (var i = 0; i < routeStack.length; i++) {
	      this._leftOffsets.push(new Animated.Value(0));
	      this._rightOffsets.push(new Animated.Value(0));
	    }
	    this.setState({ routeStack: routeStack });
	    if (this._navBar) {
	      if (this._navBar._isMounted) this._navBar.setRouteStack(routeStack);
	    }
	  },
	
	  resetTo: function resetTo(route) {
	    this.immediatelyResetRouteStack([route]);
	  },
	
	  popToTop: function popToTop() {
	    this.immediatelyResetRouteStack([]);
	  },
	
	  push: function push(newRoute) {
	    if (this._isAnimating) return;
	    this._isAnimating = true;
	
	    var routeStack = this.state.routeStack;
	    routeStack.push(newRoute);
	    if (this._navBar && this._navBar._isMounted) this._navBar.push(newRoute);
	
	    // console.log("animss push ", newRoute, routeStack)
	
	    this._shouldStartPushAnim = true;
	    this._leftOffsets.push(new Animated.Value(this._width));
	    this._rightOffsets.push(new Animated.Value(-this._width));
	
	    this.setState({ routeStack: routeStack });
	
	    var thisThing = this;
	    setTimeout(function () {
	      thisThing.doPushAnim();
	    }, 10);
	  },
	
	  pop: function pop() {
	    if (this._isAnimating) return;
	    this._isAnimating = true;
	    if (this._navBar) this._navBar.pop();
	
	    var thisThing = this;
	    thisThing.props.onWillFocus(thisThing.state.routeStack[thisThing.state.routeStack.length - 2]);
	    Animated.timing(this._rightOffsets[this._rightOffsets.length - 1], { toValue: -this._width, duration: ANIM_DURATION }).start(function () {});
	    Animated.timing(this._leftOffsets[this._leftOffsets.length - 1], { toValue: this._width, duration: ANIM_DURATION }).start(function () {
	      thisThing.props.onDidFocus(thisThing.state.routeStack[thisThing.state.routeStack.length - 2]);
	      setTimeout(function () {
	        var routeStack = thisThing.state.routeStack;
	        routeStack.pop();
	
	        thisThing._rightOffsets.pop();
	        thisThing._leftOffsets.pop();
	        thisThing._isAnimating = false;
	
	        thisThing.setState({ routeStack: routeStack });
	      }, 10);
	    });
	  },
	
	  replace: function replace(topRoute) {
	    var routeStack = this.state.routeStack;
	    if (routeStack.length <= 0) {
	      this._rightOffsets = [new Animated.Value(0)];
	      this._leftOffsets = [new Animated.Value(0)];
	      routeStack = [topRoute];
	    } else {
	      routeStack[routeStack.length - 1] = topRoute;
	    }
	
	    if (this._navBar && this._navBar._isMounted) this._navBar.replace(topRoute);
	    this.setState({ routeStack: routeStack });
	  },
	
	  doPushAnim: function doPushAnim() {
	    if (!this._shouldStartPushAnim) return;
	    this._shouldStartPushAnim = false;
	    var thisThing = this;
	
	    thisThing.props.onWillFocus(thisThing.state.routeStack[thisThing.state.routeStack.length - 1]);
	    Animated.timing(thisThing._rightOffsets[thisThing._rightOffsets.length - 1], { toValue: 0, duration: ANIM_DURATION }).start(function () {
	      thisThing.props.onDidFocus(thisThing.state.routeStack[thisThing.state.routeStack.length - 1]);
	    });
	    Animated.timing(thisThing._leftOffsets[thisThing._leftOffsets.length - 1], { toValue: 0, duration: ANIM_DURATION }).start(function () {
	      thisThing._isAnimating = false;
	    });
	  },
	
	  setNavBar: function setNavBar(navBar) {
	    this._navBar = navBar;
	  },
	
	  render: function render() {
	    if (this.state.routeStack.length <= 0) return null;
	
	    var currentIndex = this.state.routeStack.length - 1;
	    var currentRoute = this.state.routeStack[currentIndex];
	
	    var thisThing = this;
	
	    return React.createElement(
	      View,
	      { style: [this.props.style, { flexDirection: 'column' }], onLayout: function onLayout(evt) {
	          if (thisThing._width != evt.nativeEvent.layout.width) {
	            thisThing._width = evt.nativeEvent.layout.width;
	            thisThing.forceUpdate();
	          }
	        } },
	      React.createElement(
	        View,
	        { style: { position: 'relative', flex: 1, backgroundColor: 'transparent', maxWidth: thisThing._width, alignSelf: 'stretch', overflow: 'hidden' }, onLayout: function onLayout(evt) {
	            // console.log("thisThing._width",evt.nativeEvent.layout)
	          } },
	        thisThing.state.routeStack.map(function (route, index) {
	          var otherStyle = {};
	          if (typeof thisThing._width !== 'undefined') {
	            otherStyle.width = thisThing._width;
	            otherStyle.maxWidth = thisThing._width;
	          } else {
	            otherStyle.width = '100%';
	            otherStyle.right = thisThing._rightOffsets[index];
	          }
	          return React.createElement(
	            Animated.View,
	            { key: "route-" + index,
	              style: [{
	                position: 'absolute',
	                top: 0,
	                bottom: 0,
	                left: thisThing._leftOffsets[index],
	                overflow: 'hidden'
	              }, otherStyle], onLayout: function onLayout(evt) {
	                // console.log("animss - layout - "+index, thisThing.state.routeStack, evt.nativeEvent.layout.width)
	              } },
	            thisThing.props.renderScene(route, thisThing)
	          );
	        })
	      ),
	      this.state.navBar != null ? React.createElement(
	        View,
	        { style: { pointerEvents: 'box-none', position: 'absolute', left: 0, right: 0, top: 0, height: Globals.ACTION_BAR_HEIGHT, flexDirection: 'row' } },
	        this.state.navBar
	      ) : null
	    );
	  }
	});
	
	Navigator.NavigationBar = createReactClass({
	  displayName: 'NavigationBar',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      nav: null,
	      routeMapper: null,
	      onWillFocus: function onWillFocus(route) {},
	      onDidFocus: function onDidFocus(route) {}
	    };
	  },
	
	  _leftOffsets: [],
	  _rightOffsets: [],
	  _opacities: [],
	  getInitialState: function getInitialState() {
	    var routeStack = JSON.parse(JSON.stringify(this.props.nav.state.routeStack));
	    this._leftOffsets = [];
	    this._rightOffsets = [];
	    this._opacities = [];
	    for (var i = 0; i < routeStack.length; i++) {
	      this._opacities.push(new Animated.Value(1, "opa 0"));
	      this._leftOffsets.push(new Animated.Value(0));
	      this._rightOffsets.push(new Animated.Value(0));
	    }
	    return {
	      routeStack: routeStack
	    };
	  },
	
	  _isMounted: false,
	  componentDidMount: function componentDidMount() {
	    this._isMounted = true;
	    this.props.nav.setNavBar(this);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._isMounted = false;
	  },
	
	  setNav: function setNav(nav) {
	    this.setState({ nav: nav });
	  },
	
	  push: function push(newRoute) {
	    var routeStack = this.state.routeStack;
	    routeStack.push(JSON.parse(JSON.stringify(newRoute)));
	    this._shouldStartPushAnim = true;
	    for (var i = 0; i < routeStack.length; i++) {
	      if (i >= routeStack.length - 1) {
	        if (typeof this._leftOffsets[i] === 'undefined') this._leftOffsets.push(new Animated.Value(NAV_BAR_ANIM_OFFSET_START));
	        if (typeof this._rightOffsets[i] === 'undefined') this._rightOffsets.push(new Animated.Value(-NAV_BAR_ANIM_OFFSET_START));
	        if (typeof this._opacities[i] === 'undefined') this._opacities.push(new Animated.Value(0, "opa " + i));
	      } else if (i >= routeStack.length - 2) {
	        if (typeof this._leftOffsets[i] === 'undefined') this._leftOffsets.push(new Animated.Value(0));
	        if (typeof this._rightOffsets[i] === 'undefined') this._rightOffsets.push(new Animated.Value(0));
	        if (typeof this._opacities[i] === 'undefined') this._opacities.push(new Animated.Value(1, "opa " + i));
	      } else {
	        if (typeof this._leftOffsets[i] === 'undefined') this._leftOffsets.push(new Animated.Value(0));
	        if (typeof this._rightOffsets[i] === 'undefined') this._rightOffsets.push(new Animated.Value(0));
	        if (typeof this._opacities[i] === 'undefined') this._opacities.push(new Animated.Value(0, "opa " + i));
	      }
	    }
	
	    this.setState({ routeStack: routeStack });
	
	    var thisThing = this;
	    setTimeout(function () {
	      thisThing.doPushAnim();
	    }, 10);
	  },
	
	  pop: function pop() {
	    var _this = this;
	
	    var thisThing = this;
	    // Animated.timing(this._rightOffsets[this._rightOffsets.length-1],{toValue:-NAV_BAR_ANIM_OFFSET_START, duration:ANIM_DURATION}).start(()=>
	    // {
	    // })
	    // Animated.timing(this._leftOffsets[this._leftOffsets.length-1],{toValue:NAV_BAR_ANIM_OFFSET_START, duration:ANIM_DURATION}).start(()=>
	    // {
	    // })
	    Animated.timing(this._opacities[this._opacities.length - 1], { toValue: 0, duration: ANIM_DURATION / 2 }).start(function () {
	      Animated.timing(_this._opacities[_this._opacities.length - 2], { toValue: 1, duration: ANIM_DURATION / 2 }).start(function () {
	        setTimeout(function () {
	          var routeStack = thisThing.state.routeStack;
	          routeStack.pop();
	
	          thisThing._rightOffsets.pop();
	          thisThing._leftOffsets.pop();
	          thisThing._opacities.pop();
	
	          thisThing.setState({ routeStack: routeStack });
	        }, 10);
	      });
	    });
	  },
	
	  setRouteStack: function setRouteStack(routeStack) {
	    this._leftOffsets = [];
	    this._rightOffsets = [];
	    this._opacities = [];
	    for (var i = 0; i < routeStack.length; i++) {
	      this._leftOffsets.push(new Animated.Value(0));
	      this._rightOffsets.push(new Animated.Value(0));
	      this._opacities.push(new Animated.Value(i == routeStack.length - 1 ? 1 : 0, "opa " + i));
	    }
	    this.setState({ routeStack: JSON.parse(JSON.stringify(routeStack)) });
	  },
	
	  replace: function replace(topRoute) {
	    var routeStack = this.state.routeStack;
	    if (routeStack.length <= 0) routeStack = [topRoute];else routeStack[routeStack.length - 1] = topRoute;
	    this._rightOffsets = [];
	    this._leftOffsets = [];
	    this._opacities = [];
	    for (var i = 0; i < routeStack.length; i++) {
	      this._rightOffsets.push(new Animated.Value(0));
	      this._leftOffsets.push(new Animated.Value(0));
	      this._opacities.push(new Animated.Value(1));
	    }
	
	    this.setState({ routeStack: routeStack });
	  },
	
	  doPushAnim: function doPushAnim() {
	    if (!this._shouldStartPushAnim) return;
	    this._shouldStartPushAnim = false;
	
	    var thisThing = this;
	    Animated.timing(this._rightOffsets[this._rightOffsets.length - 1], { toValue: 0, duration: ANIM_DURATION }).start(function () {});
	    Animated.timing(this._leftOffsets[this._leftOffsets.length - 1], { toValue: 0, duration: ANIM_DURATION }).start(function () {});
	    Animated.timing(this._opacities[this._opacities.length - 2], { toValue: 0, duration: ANIM_DURATION / 2 }).start(function () {
	      Animated.timing(thisThing._opacities[thisThing._opacities.length - 1], { toValue: 1, duration: ANIM_DURATION / 2 }).start(function () {});
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    if (this.state.routeStack.length <= 0) return null;
	
	    var thisThing = this;
	
	    var currentIndex = this.state.routeStack.length - 1;
	    var currentRoute = this.state.routeStack[currentIndex];
	
	    var style = [this.props.style, { height: Globals.ACTION_BAR_HEIGHT, flex: 1, flexDirection: 'row', alignItems: 'stretch' }];
	    return React.createElement(
	      View,
	      { style: style },
	      React.createElement(
	        View,
	        { style: { width: 90, alignItems: 'flex-start' } },
	        this.props.routeMapper.LeftButton(currentRoute, this.props.nav, currentIndex, this.state)
	      ),
	      React.createElement(
	        View,
	        { style: { flex: 1, alignItems: 'center', justifyContent: 'center', flexDirection: 'row' } },
	        thisThing.state.routeStack.map(function (route, index) {
	          return React.createElement(
	            Animated.View,
	            { key: "route-" + index,
	              style: {
	                position: 'absolute',
	                opacity: thisThing._opacities[index],
	                top: 0,
	                bottom: 0,
	                left: thisThing._leftOffsets[index],
	                right: thisThing._rightOffsets[index] } },
	            _this2.props.routeMapper.Title(route, _this2.props.nav, index, _this2.state)
	          );
	        })
	      ),
	      React.createElement(
	        View,
	        { style: { width: 90, alignItems: 'flex-end' } },
	        this.props.routeMapper.RightButton(currentRoute, this.props.nav, currentIndex, this.state)
	      )
	    );
	  }
	});
	
	module.exports = Navigator;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ReactNative = __webpack_require__(4);
	
	module.exports = ReactNative.WebView;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var moment = __webpack_require__(3);
	
	var DatePicker = createReactClass({
	  displayName: 'DatePicker',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      date: null,
	      format: 'YYYY-MM-DD'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var inputValue = '';
	    var dateValue = null;
	    if (typeof this.props.value === 'string') {
	      dateValue = moment(this.props.value, this.props.format);
	    } else {
	      dateValue = moment(this.props.value);
	    }
	    if (dateValue.isValid()) {
	      inputValue = dateValue.format(this.props.format);
	    }
	    return {
	      inputValue: inputValue
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  handleInput: function handleInput(e) {
	    console.log(e.target.value);
	    this.setState({
	      inputValue: e.target.value
	    });
	  },
	
	  handleBlur: function handleBlur() {
	    var value = moment(this.state.inputValue, this.props.format);
	    console.log("handleBlur", value);
	    this.props.onDateChange && this.props.onDateChange(value.isValid() ? value.toDate() : null, value.isValid() ? this.state.inputValue : null);
	  },
	
	  onPressDate: function onPressDate() {
	    // if( this._dateInput ) this._dateInput.focus();
	  },
	
	  render: function render() {
	    return React.createElement(
	      View,
	      { style: this.props.style },
	      React.createElement('input', { value: this.state.inputValue, onChange: this.handleInput, onBlur: this.handleBlur, style: { fontSize: 20 }, type: 'date' })
	    );
	  }
	});
	
	module.exports = DatePicker;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var RNShare = createReactClass({
	  displayName: 'RNShare',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  render: function render() {
	    return React.createElement(View, { style: this.props.style });
	  }
	});
	
	module.exports = RNShare;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(115));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
	
		    function X64Word_create() {
		        return X64Word.create.apply(X64Word, arguments);
		    }
	
		    // Constants
		    var K = [
		        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
		        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
		        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
		        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
		        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
		        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
		        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
		        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
		        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
		        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
		        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
		        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
		        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
		        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
		        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
		        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
		        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
		        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
		        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
		        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
		        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
		        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
		        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
		        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
		        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
		        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
		        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
		        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
		        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
		        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
		        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
		        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
		        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
		        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
		        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
		        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
		        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
		        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
		        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
		        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
		    ];
	
		    // Reusable objects
		    var W = [];
		    (function () {
		        for (var i = 0; i < 80; i++) {
		            W[i] = X64Word_create();
		        }
		    }());
	
		    /**
		     * SHA-512 hash algorithm.
		     */
		    var SHA512 = C_algo.SHA512 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
		                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
		                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
		                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
		            ]);
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var H = this._hash.words;
	
		            var H0 = H[0];
		            var H1 = H[1];
		            var H2 = H[2];
		            var H3 = H[3];
		            var H4 = H[4];
		            var H5 = H[5];
		            var H6 = H[6];
		            var H7 = H[7];
	
		            var H0h = H0.high;
		            var H0l = H0.low;
		            var H1h = H1.high;
		            var H1l = H1.low;
		            var H2h = H2.high;
		            var H2l = H2.low;
		            var H3h = H3.high;
		            var H3l = H3.low;
		            var H4h = H4.high;
		            var H4l = H4.low;
		            var H5h = H5.high;
		            var H5l = H5.low;
		            var H6h = H6.high;
		            var H6l = H6.low;
		            var H7h = H7.high;
		            var H7l = H7.low;
	
		            // Working variables
		            var ah = H0h;
		            var al = H0l;
		            var bh = H1h;
		            var bl = H1l;
		            var ch = H2h;
		            var cl = H2l;
		            var dh = H3h;
		            var dl = H3l;
		            var eh = H4h;
		            var el = H4l;
		            var fh = H5h;
		            var fl = H5l;
		            var gh = H6h;
		            var gl = H6l;
		            var hh = H7h;
		            var hl = H7l;
	
		            // Rounds
		            for (var i = 0; i < 80; i++) {
		                // Shortcut
		                var Wi = W[i];
	
		                // Extend message
		                if (i < 16) {
		                    var Wih = Wi.high = M[offset + i * 2]     | 0;
		                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
		                } else {
		                    // Gamma0
		                    var gamma0x  = W[i - 15];
		                    var gamma0xh = gamma0x.high;
		                    var gamma0xl = gamma0x.low;
		                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
		                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));
	
		                    // Gamma1
		                    var gamma1x  = W[i - 2];
		                    var gamma1xh = gamma1x.high;
		                    var gamma1xl = gamma1x.low;
		                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
		                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));
	
		                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
		                    var Wi7  = W[i - 7];
		                    var Wi7h = Wi7.high;
		                    var Wi7l = Wi7.low;
	
		                    var Wi16  = W[i - 16];
		                    var Wi16h = Wi16.high;
		                    var Wi16l = Wi16.low;
	
		                    var Wil = gamma0l + Wi7l;
		                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
		                    var Wil = Wil + gamma1l;
		                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
		                    var Wil = Wil + Wi16l;
		                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);
	
		                    Wi.high = Wih;
		                    Wi.low  = Wil;
		                }
	
		                var chh  = (eh & fh) ^ (~eh & gh);
		                var chl  = (el & fl) ^ (~el & gl);
		                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
		                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);
	
		                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
		                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
		                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
		                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));
	
		                // t1 = h + sigma1 + ch + K[i] + W[i]
		                var Ki  = K[i];
		                var Kih = Ki.high;
		                var Kil = Ki.low;
	
		                var t1l = hl + sigma1l;
		                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
		                var t1l = t1l + chl;
		                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
		                var t1l = t1l + Kil;
		                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
		                var t1l = t1l + Wil;
		                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);
	
		                // t2 = sigma0 + maj
		                var t2l = sigma0l + majl;
		                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);
	
		                // Update working variables
		                hh = gh;
		                hl = gl;
		                gh = fh;
		                gl = fl;
		                fh = eh;
		                fl = el;
		                el = (dl + t1l) | 0;
		                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
		                dh = ch;
		                dl = cl;
		                ch = bh;
		                cl = bl;
		                bh = ah;
		                bl = al;
		                al = (t1l + t2l) | 0;
		                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
		            }
	
		            // Intermediate hash value
		            H0l = H0.low  = (H0l + al);
		            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
		            H1l = H1.low  = (H1l + bl);
		            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
		            H2l = H2.low  = (H2l + cl);
		            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
		            H3l = H3.low  = (H3l + dl);
		            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
		            H4l = H4.low  = (H4l + el);
		            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
		            H5l = H5.low  = (H5l + fl);
		            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
		            H6l = H6.low  = (H6l + gl);
		            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
		            H7l = H7.low  = (H7l + hl);
		            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Convert hash to 32-bit word array before returning
		            var hash = this._hash.toX32();
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        },
	
		        blockSize: 1024/32
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA512('message');
		     *     var hash = CryptoJS.SHA512(wordArray);
		     */
		    C.SHA512 = Hasher._createHelper(SHA512);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA512(message, key);
		     */
		    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
		}());
	
	
		return CryptoJS.SHA512;
	
	}));

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(37);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 859 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 860 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 861 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 862 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 990 */
/***/ function(module, exports) {

	function copy(src,dest){
		for(var p in src){
			dest[p] = src[p];
		}
	}
	/**
	^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
	^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
	 */
	function _extends(Class,Super){
		var pt = Class.prototype;
		if(!(pt instanceof Super)){
			function t(){};
			t.prototype = Super.prototype;
			t = new t();
			copy(pt,t);
			Class.prototype = pt = t;
		}
		if(pt.constructor != Class){
			if(typeof Class != 'function'){
				console.error("unknow Class:"+Class)
			}
			pt.constructor = Class
		}
	}
	var htmlns = 'http://www.w3.org/1999/xhtml' ;
	// Node Types
	var NodeType = {}
	var ELEMENT_NODE                = NodeType.ELEMENT_NODE                = 1;
	var ATTRIBUTE_NODE              = NodeType.ATTRIBUTE_NODE              = 2;
	var TEXT_NODE                   = NodeType.TEXT_NODE                   = 3;
	var CDATA_SECTION_NODE          = NodeType.CDATA_SECTION_NODE          = 4;
	var ENTITY_REFERENCE_NODE       = NodeType.ENTITY_REFERENCE_NODE       = 5;
	var ENTITY_NODE                 = NodeType.ENTITY_NODE                 = 6;
	var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
	var COMMENT_NODE                = NodeType.COMMENT_NODE                = 8;
	var DOCUMENT_NODE               = NodeType.DOCUMENT_NODE               = 9;
	var DOCUMENT_TYPE_NODE          = NodeType.DOCUMENT_TYPE_NODE          = 10;
	var DOCUMENT_FRAGMENT_NODE      = NodeType.DOCUMENT_FRAGMENT_NODE      = 11;
	var NOTATION_NODE               = NodeType.NOTATION_NODE               = 12;
	
	// ExceptionCode
	var ExceptionCode = {}
	var ExceptionMessage = {};
	var INDEX_SIZE_ERR              = ExceptionCode.INDEX_SIZE_ERR              = ((ExceptionMessage[1]="Index size error"),1);
	var DOMSTRING_SIZE_ERR          = ExceptionCode.DOMSTRING_SIZE_ERR          = ((ExceptionMessage[2]="DOMString size error"),2);
	var HIERARCHY_REQUEST_ERR       = ExceptionCode.HIERARCHY_REQUEST_ERR       = ((ExceptionMessage[3]="Hierarchy request error"),3);
	var WRONG_DOCUMENT_ERR          = ExceptionCode.WRONG_DOCUMENT_ERR          = ((ExceptionMessage[4]="Wrong document"),4);
	var INVALID_CHARACTER_ERR       = ExceptionCode.INVALID_CHARACTER_ERR       = ((ExceptionMessage[5]="Invalid character"),5);
	var NO_DATA_ALLOWED_ERR         = ExceptionCode.NO_DATA_ALLOWED_ERR         = ((ExceptionMessage[6]="No data allowed"),6);
	var NO_MODIFICATION_ALLOWED_ERR = ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ((ExceptionMessage[7]="No modification allowed"),7);
	var NOT_FOUND_ERR               = ExceptionCode.NOT_FOUND_ERR               = ((ExceptionMessage[8]="Not found"),8);
	var NOT_SUPPORTED_ERR           = ExceptionCode.NOT_SUPPORTED_ERR           = ((ExceptionMessage[9]="Not supported"),9);
	var INUSE_ATTRIBUTE_ERR         = ExceptionCode.INUSE_ATTRIBUTE_ERR         = ((ExceptionMessage[10]="Attribute in use"),10);
	//level2
	var INVALID_STATE_ERR        	= ExceptionCode.INVALID_STATE_ERR        	= ((ExceptionMessage[11]="Invalid state"),11);
	var SYNTAX_ERR               	= ExceptionCode.SYNTAX_ERR               	= ((ExceptionMessage[12]="Syntax error"),12);
	var INVALID_MODIFICATION_ERR 	= ExceptionCode.INVALID_MODIFICATION_ERR 	= ((ExceptionMessage[13]="Invalid modification"),13);
	var NAMESPACE_ERR            	= ExceptionCode.NAMESPACE_ERR           	= ((ExceptionMessage[14]="Invalid namespace"),14);
	var INVALID_ACCESS_ERR       	= ExceptionCode.INVALID_ACCESS_ERR      	= ((ExceptionMessage[15]="Invalid access"),15);
	
	/**
	 * DOM Level 2
	 * Object DOMException
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
	 */
	function DOMException(code, message) {
		if(message instanceof Error){
			var error = message;
		}else{
			error = this;
			Error.call(this, ExceptionMessage[code]);
			this.message = ExceptionMessage[code];
			if(Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
		}
		error.code = code;
		if(message) this.message = this.message + ": " + message;
		return error;
	};
	DOMException.prototype = Error.prototype;
	copy(ExceptionCode,DOMException)
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
	 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
	 * The items in the NodeList are accessible via an integral index, starting from 0.
	 */
	function NodeList() {
	};
	NodeList.prototype = {
		/**
		 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
		 * @standard level1
		 */
		length:0, 
		/**
		 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
		 * @standard level1
		 * @param index  unsigned long 
		 *   Index into the collection.
		 * @return Node
		 * 	The node at the indexth position in the NodeList, or null if that is not a valid index. 
		 */
		item: function(index) {
			return this[index] || null;
		},
		toString:function(isHTML,nodeFilter){
			for(var buf = [], i = 0;i<this.length;i++){
				serializeToString(this[i],buf,isHTML,nodeFilter);
			}
			return buf.join('');
		}
	};
	function LiveNodeList(node,refresh){
		this._node = node;
		this._refresh = refresh
		_updateLiveList(this);
	}
	function _updateLiveList(list){
		var inc = list._node._inc || list._node.ownerDocument._inc;
		if(list._inc != inc){
			var ls = list._refresh(list._node);
			//console.log(ls.length)
			__set__(list,'length',ls.length);
			copy(ls,list);
			list._inc = inc;
		}
	}
	LiveNodeList.prototype.item = function(i){
		_updateLiveList(this);
		return this[i];
	}
	
	_extends(LiveNodeList,NodeList);
	/**
	 * 
	 * Objects implementing the NamedNodeMap interface are used to represent collections of nodes that can be accessed by name. Note that NamedNodeMap does not inherit from NodeList; NamedNodeMaps are not maintained in any particular order. Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index, but this is simply to allow convenient enumeration of the contents of a NamedNodeMap, and does not imply that the DOM specifies an order to these Nodes.
	 * NamedNodeMap objects in the DOM are live.
	 * used for attributes or DocumentType entities 
	 */
	function NamedNodeMap() {
	};
	
	function _findNodeIndex(list,node){
		var i = list.length;
		while(i--){
			if(list[i] === node){return i}
		}
	}
	
	function _addNamedNode(el,list,newAttr,oldAttr){
		if(oldAttr){
			list[_findNodeIndex(list,oldAttr)] = newAttr;
		}else{
			list[list.length++] = newAttr;
		}
		if(el){
			newAttr.ownerElement = el;
			var doc = el.ownerDocument;
			if(doc){
				oldAttr && _onRemoveAttribute(doc,el,oldAttr);
				_onAddAttribute(doc,el,newAttr);
			}
		}
	}
	function _removeNamedNode(el,list,attr){
		//console.log('remove attr:'+attr)
		var i = _findNodeIndex(list,attr);
		if(i>=0){
			var lastIndex = list.length-1
			while(i<lastIndex){
				list[i] = list[++i]
			}
			list.length = lastIndex;
			if(el){
				var doc = el.ownerDocument;
				if(doc){
					_onRemoveAttribute(doc,el,attr);
					attr.ownerElement = null;
				}
			}
		}else{
			throw DOMException(NOT_FOUND_ERR,new Error(el.tagName+'@'+attr))
		}
	}
	NamedNodeMap.prototype = {
		length:0,
		item:NodeList.prototype.item,
		getNamedItem: function(key) {
	//		if(key.indexOf(':')>0 || key == 'xmlns'){
	//			return null;
	//		}
			//console.log()
			var i = this.length;
			while(i--){
				var attr = this[i];
				//console.log(attr.nodeName,key)
				if(attr.nodeName == key){
					return attr;
				}
			}
		},
		setNamedItem: function(attr) {
			var el = attr.ownerElement;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			var oldAttr = this.getNamedItem(attr.nodeName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
		/* returns Node */
		setNamedItemNS: function(attr) {// raises: WRONG_DOCUMENT_ERR,NO_MODIFICATION_ALLOWED_ERR,INUSE_ATTRIBUTE_ERR
			var el = attr.ownerElement, oldAttr;
			if(el && el!=this._ownerElement){
				throw new DOMException(INUSE_ATTRIBUTE_ERR);
			}
			oldAttr = this.getNamedItemNS(attr.namespaceURI,attr.localName);
			_addNamedNode(this._ownerElement,this,attr,oldAttr);
			return oldAttr;
		},
	
		/* returns Node */
		removeNamedItem: function(key) {
			var attr = this.getNamedItem(key);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
			
			
		},// raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
		
		//for level2
		removeNamedItemNS:function(namespaceURI,localName){
			var attr = this.getNamedItemNS(namespaceURI,localName);
			_removeNamedNode(this._ownerElement,this,attr);
			return attr;
		},
		getNamedItemNS: function(namespaceURI, localName) {
			var i = this.length;
			while(i--){
				var node = this[i];
				if(node.localName == localName && node.namespaceURI == namespaceURI){
					return node;
				}
			}
			return null;
		}
	};
	/**
	 * @see http://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490
	 */
	function DOMImplementation(/* Object */ features) {
		this._features = {};
		if (features) {
			for (var feature in features) {
				 this._features = features[feature];
			}
		}
	};
	
	DOMImplementation.prototype = {
		hasFeature: function(/* string */ feature, /* string */ version) {
			var versions = this._features[feature.toLowerCase()];
			if (versions && (!version || version in versions)) {
				return true;
			} else {
				return false;
			}
		},
		// Introduced in DOM Level 2:
		createDocument:function(namespaceURI,  qualifiedName, doctype){// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR,WRONG_DOCUMENT_ERR
			var doc = new Document();
			doc.implementation = this;
			doc.childNodes = new NodeList();
			doc.doctype = doctype;
			if(doctype){
				doc.appendChild(doctype);
			}
			if(qualifiedName){
				var root = doc.createElementNS(namespaceURI,qualifiedName);
				doc.appendChild(root);
			}
			return doc;
		},
		// Introduced in DOM Level 2:
		createDocumentType:function(qualifiedName, publicId, systemId){// raises:INVALID_CHARACTER_ERR,NAMESPACE_ERR
			var node = new DocumentType();
			node.name = qualifiedName;
			node.nodeName = qualifiedName;
			node.publicId = publicId;
			node.systemId = systemId;
			// Introduced in DOM Level 2:
			//readonly attribute DOMString        internalSubset;
			
			//TODO:..
			//  readonly attribute NamedNodeMap     entities;
			//  readonly attribute NamedNodeMap     notations;
			return node;
		}
	};
	
	
	/**
	 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
	 */
	
	function Node() {
	};
	
	Node.prototype = {
		firstChild : null,
		lastChild : null,
		previousSibling : null,
		nextSibling : null,
		attributes : null,
		parentNode : null,
		childNodes : null,
		ownerDocument : null,
		nodeValue : null,
		namespaceURI : null,
		prefix : null,
		localName : null,
		// Modified in DOM Level 2:
		insertBefore:function(newChild, refChild){//raises 
			return _insertBefore(this,newChild,refChild);
		},
		replaceChild:function(newChild, oldChild){//raises 
			this.insertBefore(newChild,oldChild);
			if(oldChild){
				this.removeChild(oldChild);
			}
		},
		removeChild:function(oldChild){
			return _removeChild(this,oldChild);
		},
		appendChild:function(newChild){
			return this.insertBefore(newChild,null);
		},
		hasChildNodes:function(){
			return this.firstChild != null;
		},
		cloneNode:function(deep){
			return cloneNode(this.ownerDocument||this,this,deep);
		},
		// Modified in DOM Level 2:
		normalize:function(){
			var child = this.firstChild;
			while(child){
				var next = child.nextSibling;
				if(next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE){
					this.removeChild(next);
					child.appendData(next.data);
				}else{
					child.normalize();
					child = next;
				}
			}
		},
	  	// Introduced in DOM Level 2:
		isSupported:function(feature, version){
			return this.ownerDocument.implementation.hasFeature(feature,version);
		},
	    // Introduced in DOM Level 2:
	    hasAttributes:function(){
	    	return this.attributes.length>0;
	    },
	    lookupPrefix:function(namespaceURI){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			for(var n in map){
	    				if(map[n] == namespaceURI){
	    					return n;
	    				}
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    lookupNamespaceURI:function(prefix){
	    	var el = this;
	    	while(el){
	    		var map = el._nsMap;
	    		//console.dir(map)
	    		if(map){
	    			if(prefix in map){
	    				return map[prefix] ;
	    			}
	    		}
	    		el = el.nodeType == ATTRIBUTE_NODE?el.ownerDocument : el.parentNode;
	    	}
	    	return null;
	    },
	    // Introduced in DOM Level 3:
	    isDefaultNamespace:function(namespaceURI){
	    	var prefix = this.lookupPrefix(namespaceURI);
	    	return prefix == null;
	    }
	};
	
	
	function _xmlEncoder(c){
		return c == '<' && '&lt;' ||
	         c == '>' && '&gt;' ||
	         c == '&' && '&amp;' ||
	         c == '"' && '&quot;' ||
	         '&#'+c.charCodeAt()+';'
	}
	
	
	copy(NodeType,Node);
	copy(NodeType,Node.prototype);
	
	/**
	 * @param callback return true for continue,false for break
	 * @return boolean true: break visit;
	 */
	function _visitNode(node,callback){
		if(callback(node)){
			return true;
		}
		if(node = node.firstChild){
			do{
				if(_visitNode(node,callback)){return true}
	        }while(node=node.nextSibling)
	    }
	}
	
	
	
	function Document(){
	}
	function _onAddAttribute(doc,el,newAttr){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns == 'http://www.w3.org/2000/xmlns/'){
			//update namespace
			el._nsMap[newAttr.prefix?newAttr.localName:''] = newAttr.value
		}
	}
	function _onRemoveAttribute(doc,el,newAttr,remove){
		doc && doc._inc++;
		var ns = newAttr.namespaceURI ;
		if(ns == 'http://www.w3.org/2000/xmlns/'){
			//update namespace
			delete el._nsMap[newAttr.prefix?newAttr.localName:'']
		}
	}
	function _onUpdateChild(doc,el,newChild){
		if(doc && doc._inc){
			doc._inc++;
			//update childNodes
			var cs = el.childNodes;
			if(newChild){
				cs[cs.length++] = newChild;
			}else{
				//console.log(1)
				var child = el.firstChild;
				var i = 0;
				while(child){
					cs[i++] = child;
					child =child.nextSibling;
				}
				cs.length = i;
			}
		}
	}
	
	/**
	 * attributes;
	 * children;
	 * 
	 * writeable properties:
	 * nodeValue,Attr:value,CharacterData:data
	 * prefix
	 */
	function _removeChild(parentNode,child){
		var previous = child.previousSibling;
		var next = child.nextSibling;
		if(previous){
			previous.nextSibling = next;
		}else{
			parentNode.firstChild = next
		}
		if(next){
			next.previousSibling = previous;
		}else{
			parentNode.lastChild = previous;
		}
		_onUpdateChild(parentNode.ownerDocument,parentNode);
		return child;
	}
	/**
	 * preformance key(refChild == null)
	 */
	function _insertBefore(parentNode,newChild,nextChild){
		var cp = newChild.parentNode;
		if(cp){
			cp.removeChild(newChild);//remove and update
		}
		if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
			var newFirst = newChild.firstChild;
			if (newFirst == null) {
				return newChild;
			}
			var newLast = newChild.lastChild;
		}else{
			newFirst = newLast = newChild;
		}
		var pre = nextChild ? nextChild.previousSibling : parentNode.lastChild;
	
		newFirst.previousSibling = pre;
		newLast.nextSibling = nextChild;
		
		
		if(pre){
			pre.nextSibling = newFirst;
		}else{
			parentNode.firstChild = newFirst;
		}
		if(nextChild == null){
			parentNode.lastChild = newLast;
		}else{
			nextChild.previousSibling = newLast;
		}
		do{
			newFirst.parentNode = parentNode;
		}while(newFirst !== newLast && (newFirst= newFirst.nextSibling))
		_onUpdateChild(parentNode.ownerDocument||parentNode,parentNode);
		//console.log(parentNode.lastChild.nextSibling == null)
		if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
			newChild.firstChild = newChild.lastChild = null;
		}
		return newChild;
	}
	function _appendSingleChild(parentNode,newChild){
		var cp = newChild.parentNode;
		if(cp){
			var pre = parentNode.lastChild;
			cp.removeChild(newChild);//remove and update
			var pre = parentNode.lastChild;
		}
		var pre = parentNode.lastChild;
		newChild.parentNode = parentNode;
		newChild.previousSibling = pre;
		newChild.nextSibling = null;
		if(pre){
			pre.nextSibling = newChild;
		}else{
			parentNode.firstChild = newChild;
		}
		parentNode.lastChild = newChild;
		_onUpdateChild(parentNode.ownerDocument,parentNode,newChild);
		return newChild;
		//console.log("__aa",parentNode.lastChild.nextSibling == null)
	}
	Document.prototype = {
		//implementation : null,
		nodeName :  '#document',
		nodeType :  DOCUMENT_NODE,
		doctype :  null,
		documentElement :  null,
		_inc : 1,
		
		insertBefore :  function(newChild, refChild){//raises 
			if(newChild.nodeType == DOCUMENT_FRAGMENT_NODE){
				var child = newChild.firstChild;
				while(child){
					var next = child.nextSibling;
					this.insertBefore(child,refChild);
					child = next;
				}
				return newChild;
			}
			if(this.documentElement == null && newChild.nodeType == ELEMENT_NODE){
				this.documentElement = newChild;
			}
			
			return _insertBefore(this,newChild,refChild),(newChild.ownerDocument = this),newChild;
		},
		removeChild :  function(oldChild){
			if(this.documentElement == oldChild){
				this.documentElement = null;
			}
			return _removeChild(this,oldChild);
		},
		// Introduced in DOM Level 2:
		importNode : function(importedNode,deep){
			return importNode(this,importedNode,deep);
		},
		// Introduced in DOM Level 2:
		getElementById :	function(id){
			var rtv = null;
			_visitNode(this.documentElement,function(node){
				if(node.nodeType == ELEMENT_NODE){
					if(node.getAttribute('id') == id){
						rtv = node;
						return true;
					}
				}
			})
			return rtv;
		},
		
		getElementsByClassName: function(className) {
			var pattern = new RegExp("(^|\\s)" + className + "(\\s|$)");
			return new LiveNodeList(this, function(base) {
				var ls = [];
				_visitNode(base.documentElement, function(node) {
					if(node !== base && node.nodeType == ELEMENT_NODE) {
						if(pattern.test(node.getAttribute('class'))) {
							ls.push(node);
						}
					}
				});
				return ls;
			});
		},
		
		//document factory method:
		createElement :	function(tagName){
			var node = new Element();
			node.ownerDocument = this;
			node.nodeName = tagName;
			node.tagName = tagName;
			node.childNodes = new NodeList();
			var attrs	= node.attributes = new NamedNodeMap();
			attrs._ownerElement = node;
			return node;
		},
		createDocumentFragment :	function(){
			var node = new DocumentFragment();
			node.ownerDocument = this;
			node.childNodes = new NodeList();
			return node;
		},
		createTextNode :	function(data){
			var node = new Text();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createComment :	function(data){
			var node = new Comment();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createCDATASection :	function(data){
			var node = new CDATASection();
			node.ownerDocument = this;
			node.appendData(data)
			return node;
		},
		createProcessingInstruction :	function(target,data){
			var node = new ProcessingInstruction();
			node.ownerDocument = this;
			node.tagName = node.target = target;
			node.nodeValue= node.data = data;
			return node;
		},
		createAttribute :	function(name){
			var node = new Attr();
			node.ownerDocument	= this;
			node.name = name;
			node.nodeName	= name;
			node.localName = name;
			node.specified = true;
			return node;
		},
		createEntityReference :	function(name){
			var node = new EntityReference();
			node.ownerDocument	= this;
			node.nodeName	= name;
			return node;
		},
		// Introduced in DOM Level 2:
		createElementNS :	function(namespaceURI,qualifiedName){
			var node = new Element();
			var pl = qualifiedName.split(':');
			var attrs	= node.attributes = new NamedNodeMap();
			node.childNodes = new NodeList();
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.tagName = qualifiedName;
			node.namespaceURI = namespaceURI;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			attrs._ownerElement = node;
			return node;
		},
		// Introduced in DOM Level 2:
		createAttributeNS :	function(namespaceURI,qualifiedName){
			var node = new Attr();
			var pl = qualifiedName.split(':');
			node.ownerDocument = this;
			node.nodeName = qualifiedName;
			node.name = qualifiedName;
			node.namespaceURI = namespaceURI;
			node.specified = true;
			if(pl.length == 2){
				node.prefix = pl[0];
				node.localName = pl[1];
			}else{
				//el.prefix = null;
				node.localName = qualifiedName;
			}
			return node;
		}
	};
	_extends(Document,Node);
	
	
	function Element() {
		this._nsMap = {};
	};
	Element.prototype = {
		nodeType : ELEMENT_NODE,
		hasAttribute : function(name){
			return this.getAttributeNode(name)!=null;
		},
		getAttribute : function(name){
			var attr = this.getAttributeNode(name);
			return attr && attr.value || '';
		},
		getAttributeNode : function(name){
			return this.attributes.getNamedItem(name);
		},
		setAttribute : function(name, value){
			var attr = this.ownerDocument.createAttribute(name);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		removeAttribute : function(name){
			var attr = this.getAttributeNode(name)
			attr && this.removeAttributeNode(attr);
		},
		
		//four real opeartion method
		appendChild:function(newChild){
			if(newChild.nodeType === DOCUMENT_FRAGMENT_NODE){
				return this.insertBefore(newChild,null);
			}else{
				return _appendSingleChild(this,newChild);
			}
		},
		setAttributeNode : function(newAttr){
			return this.attributes.setNamedItem(newAttr);
		},
		setAttributeNodeNS : function(newAttr){
			return this.attributes.setNamedItemNS(newAttr);
		},
		removeAttributeNode : function(oldAttr){
			//console.log(this == oldAttr.ownerElement)
			return this.attributes.removeNamedItem(oldAttr.nodeName);
		},
		//get real attribute name,and remove it by removeAttributeNode
		removeAttributeNS : function(namespaceURI, localName){
			var old = this.getAttributeNodeNS(namespaceURI, localName);
			old && this.removeAttributeNode(old);
		},
		
		hasAttributeNS : function(namespaceURI, localName){
			return this.getAttributeNodeNS(namespaceURI, localName)!=null;
		},
		getAttributeNS : function(namespaceURI, localName){
			var attr = this.getAttributeNodeNS(namespaceURI, localName);
			return attr && attr.value || '';
		},
		setAttributeNS : function(namespaceURI, qualifiedName, value){
			var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
			attr.value = attr.nodeValue = "" + value;
			this.setAttributeNode(attr)
		},
		getAttributeNodeNS : function(namespaceURI, localName){
			return this.attributes.getNamedItemNS(namespaceURI, localName);
		},
		
		getElementsByTagName : function(tagName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType == ELEMENT_NODE && (tagName === '*' || node.tagName == tagName)){
						ls.push(node);
					}
				});
				return ls;
			});
		},
		getElementsByTagNameNS : function(namespaceURI, localName){
			return new LiveNodeList(this,function(base){
				var ls = [];
				_visitNode(base,function(node){
					if(node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === '*' || node.namespaceURI === namespaceURI) && (localName === '*' || node.localName == localName)){
						ls.push(node);
					}
				});
				return ls;
				
			});
		}
	};
	Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
	Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
	
	
	_extends(Element,Node);
	function Attr() {
	};
	Attr.prototype.nodeType = ATTRIBUTE_NODE;
	_extends(Attr,Node);
	
	
	function CharacterData() {
	};
	CharacterData.prototype = {
		data : '',
		substringData : function(offset, count) {
			return this.data.substring(offset, offset+count);
		},
		appendData: function(text) {
			text = this.data+text;
			this.nodeValue = this.data = text;
			this.length = text.length;
		},
		insertData: function(offset,text) {
			this.replaceData(offset,0,text);
		
		},
		appendChild:function(newChild){
			throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR])
		},
		deleteData: function(offset, count) {
			this.replaceData(offset,count,"");
		},
		replaceData: function(offset, count, text) {
			var start = this.data.substring(0,offset);
			var end = this.data.substring(offset+count);
			text = start + text + end;
			this.nodeValue = this.data = text;
			this.length = text.length;
		}
	}
	_extends(CharacterData,Node);
	function Text() {
	};
	Text.prototype = {
		nodeName : "#text",
		nodeType : TEXT_NODE,
		splitText : function(offset) {
			var text = this.data;
			var newText = text.substring(offset);
			text = text.substring(0, offset);
			this.data = this.nodeValue = text;
			this.length = text.length;
			var newNode = this.ownerDocument.createTextNode(newText);
			if(this.parentNode){
				this.parentNode.insertBefore(newNode, this.nextSibling);
			}
			return newNode;
		}
	}
	_extends(Text,CharacterData);
	function Comment() {
	};
	Comment.prototype = {
		nodeName : "#comment",
		nodeType : COMMENT_NODE
	}
	_extends(Comment,CharacterData);
	
	function CDATASection() {
	};
	CDATASection.prototype = {
		nodeName : "#cdata-section",
		nodeType : CDATA_SECTION_NODE
	}
	_extends(CDATASection,CharacterData);
	
	
	function DocumentType() {
	};
	DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
	_extends(DocumentType,Node);
	
	function Notation() {
	};
	Notation.prototype.nodeType = NOTATION_NODE;
	_extends(Notation,Node);
	
	function Entity() {
	};
	Entity.prototype.nodeType = ENTITY_NODE;
	_extends(Entity,Node);
	
	function EntityReference() {
	};
	EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
	_extends(EntityReference,Node);
	
	function DocumentFragment() {
	};
	DocumentFragment.prototype.nodeName =	"#document-fragment";
	DocumentFragment.prototype.nodeType =	DOCUMENT_FRAGMENT_NODE;
	_extends(DocumentFragment,Node);
	
	
	function ProcessingInstruction() {
	}
	ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
	_extends(ProcessingInstruction,Node);
	function XMLSerializer(){}
	XMLSerializer.prototype.serializeToString = function(node,isHtml,nodeFilter){
		return nodeSerializeToString.call(node,isHtml,nodeFilter);
	}
	Node.prototype.toString = nodeSerializeToString;
	function nodeSerializeToString(isHtml,nodeFilter){
		var buf = [];
		var refNode = this.nodeType == 9 && this.documentElement || this;
		var prefix = refNode.prefix;
		var uri = refNode.namespaceURI;
		
		if(uri && prefix == null){
			//console.log(prefix)
			var prefix = refNode.lookupPrefix(uri);
			if(prefix == null){
				//isHTML = true;
				var visibleNamespaces=[
				{namespace:uri,prefix:null}
				//{namespace:uri,prefix:''}
				]
			}
		}
		serializeToString(this,buf,isHtml,nodeFilter,visibleNamespaces);
		//console.log('###',this.nodeType,uri,prefix,buf.join(''))
		return buf.join('');
	}
	function needNamespaceDefine(node,isHTML, visibleNamespaces) {
		var prefix = node.prefix||'';
		var uri = node.namespaceURI;
		if (!prefix && !uri){
			return false;
		}
		if (prefix === "xml" && uri === "http://www.w3.org/XML/1998/namespace" 
			|| uri == 'http://www.w3.org/2000/xmlns/'){
			return false;
		}
		
		var i = visibleNamespaces.length 
		//console.log('@@@@',node.tagName,prefix,uri,visibleNamespaces)
		while (i--) {
			var ns = visibleNamespaces[i];
			// get namespace prefix
			//console.log(node.nodeType,node.tagName,ns.prefix,prefix)
			if (ns.prefix == prefix){
				return ns.namespace != uri;
			}
		}
		//console.log(isHTML,uri,prefix=='')
		//if(isHTML && prefix ==null && uri == 'http://www.w3.org/1999/xhtml'){
		//	return false;
		//}
		//node.flag = '11111'
		//console.error(3,true,node.flag,node.prefix,node.namespaceURI)
		return true;
	}
	function serializeToString(node,buf,isHTML,nodeFilter,visibleNamespaces){
		if(nodeFilter){
			node = nodeFilter(node);
			if(node){
				if(typeof node == 'string'){
					buf.push(node);
					return;
				}
			}else{
				return;
			}
			//buf.sort.apply(attrs, attributeSorter);
		}
		switch(node.nodeType){
		case ELEMENT_NODE:
			if (!visibleNamespaces) visibleNamespaces = [];
			var startVisibleNamespaces = visibleNamespaces.length;
			var attrs = node.attributes;
			var len = attrs.length;
			var child = node.firstChild;
			var nodeName = node.tagName;
			
			isHTML =  (htmlns === node.namespaceURI) ||isHTML 
			buf.push('<',nodeName);
			
			
			
			for(var i=0;i<len;i++){
				// add namespaces for attributes
				var attr = attrs.item(i);
				if (attr.prefix == 'xmlns') {
					visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
				}else if(attr.nodeName == 'xmlns'){
					visibleNamespaces.push({ prefix: '', namespace: attr.value });
				}
			}
			for(var i=0;i<len;i++){
				var attr = attrs.item(i);
				if (needNamespaceDefine(attr,isHTML, visibleNamespaces)) {
					var prefix = attr.prefix||'';
					var uri = attr.namespaceURI;
					var ns = prefix ? ' xmlns:' + prefix : " xmlns";
					buf.push(ns, '="' , uri , '"');
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
				serializeToString(attr,buf,isHTML,nodeFilter,visibleNamespaces);
			}
			// add namespace for current node		
			if (needNamespaceDefine(node,isHTML, visibleNamespaces)) {
				var prefix = node.prefix||'';
				var uri = node.namespaceURI;
				if (uri) {
					// Avoid empty namespace value like xmlns:ds=""
					// Empty namespace URL will we produce an invalid XML document
					var ns = prefix ? ' xmlns:' + prefix : " xmlns";
					buf.push(ns, '="' , uri , '"');
					visibleNamespaces.push({ prefix: prefix, namespace:uri });
				}
			}
			
			if(child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)){
				buf.push('>');
				//if is cdata child node
				if(isHTML && /^script$/i.test(nodeName)){
					while(child){
						if(child.data){
							buf.push(child.data);
						}else{
							serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
						}
						child = child.nextSibling;
					}
				}else
				{
					while(child){
						serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
						child = child.nextSibling;
					}
				}
				buf.push('</',nodeName,'>');
			}else{
				buf.push('/>');
			}
			// remove added visible namespaces
			//visibleNamespaces.length = startVisibleNamespaces;
			return;
		case DOCUMENT_NODE:
		case DOCUMENT_FRAGMENT_NODE:
			var child = node.firstChild;
			while(child){
				serializeToString(child,buf,isHTML,nodeFilter,visibleNamespaces);
				child = child.nextSibling;
			}
			return;
		case ATTRIBUTE_NODE:
			/**
			 * Well-formedness constraint: No < in Attribute Values
			 * The replacement text of any entity referred to directly or indirectly in an attribute value must not contain a <.
			 * @see https://www.w3.org/TR/xml/#CleanAttrVals
			 * @see https://www.w3.org/TR/xml/#NT-AttValue
			 */
			return buf.push(' ', node.name, '="', node.value.replace(/[<&"]/g,_xmlEncoder), '"');
		case TEXT_NODE:
			/**
			 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
			 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
			 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
			 * `&amp;` and `&lt;` respectively.
			 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
			 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
			 * when that string is not marking the end of a CDATA section.
			 *
			 * In the content of elements, character data is any string of characters
			 * which does not contain the start-delimiter of any markup
			 * and does not include the CDATA-section-close delimiter, `]]>`.
			 *
			 * @see https://www.w3.org/TR/xml/#NT-CharData
			 */
			return buf.push(node.data
				.replace(/[<&]/g,_xmlEncoder)
				.replace(/]]>/g, ']]&gt;')
			);
		case CDATA_SECTION_NODE:
			return buf.push( '<![CDATA[',node.data,']]>');
		case COMMENT_NODE:
			return buf.push( "<!--",node.data,"-->");
		case DOCUMENT_TYPE_NODE:
			var pubid = node.publicId;
			var sysid = node.systemId;
			buf.push('<!DOCTYPE ',node.name);
			if(pubid){
				buf.push(' PUBLIC ', pubid);
				if (sysid && sysid!='.') {
					buf.push(' ', sysid);
				}
				buf.push('>');
			}else if(sysid && sysid!='.'){
				buf.push(' SYSTEM ', sysid, '>');
			}else{
				var sub = node.internalSubset;
				if(sub){
					buf.push(" [",sub,"]");
				}
				buf.push(">");
			}
			return;
		case PROCESSING_INSTRUCTION_NODE:
			return buf.push( "<?",node.target," ",node.data,"?>");
		case ENTITY_REFERENCE_NODE:
			return buf.push( '&',node.nodeName,';');
		//case ENTITY_NODE:
		//case NOTATION_NODE:
		default:
			buf.push('??',node.nodeName);
		}
	}
	function importNode(doc,node,deep){
		var node2;
		switch (node.nodeType) {
		case ELEMENT_NODE:
			node2 = node.cloneNode(false);
			node2.ownerDocument = doc;
			//var attrs = node2.attributes;
			//var len = attrs.length;
			//for(var i=0;i<len;i++){
				//node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
			//}
		case DOCUMENT_FRAGMENT_NODE:
			break;
		case ATTRIBUTE_NODE:
			deep = true;
			break;
		//case ENTITY_REFERENCE_NODE:
		//case PROCESSING_INSTRUCTION_NODE:
		////case TEXT_NODE:
		//case CDATA_SECTION_NODE:
		//case COMMENT_NODE:
		//	deep = false;
		//	break;
		//case DOCUMENT_NODE:
		//case DOCUMENT_TYPE_NODE:
		//cannot be imported.
		//case ENTITY_NODE:
		//case NOTATION_NODE：
		//can not hit in level3
		//default:throw e;
		}
		if(!node2){
			node2 = node.cloneNode(false);//false
		}
		node2.ownerDocument = doc;
		node2.parentNode = null;
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(importNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	//
	//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
	//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
	function cloneNode(doc,node,deep){
		var node2 = new node.constructor();
		for(var n in node){
			var v = node[n];
			if(typeof v != 'object' ){
				if(v != node2[n]){
					node2[n] = v;
				}
			}
		}
		if(node.childNodes){
			node2.childNodes = new NodeList();
		}
		node2.ownerDocument = doc;
		switch (node2.nodeType) {
		case ELEMENT_NODE:
			var attrs	= node.attributes;
			var attrs2	= node2.attributes = new NamedNodeMap();
			var len = attrs.length
			attrs2._ownerElement = node2;
			for(var i=0;i<len;i++){
				node2.setAttributeNode(cloneNode(doc,attrs.item(i),true));
			}
			break;;
		case ATTRIBUTE_NODE:
			deep = true;
		}
		if(deep){
			var child = node.firstChild;
			while(child){
				node2.appendChild(cloneNode(doc,child,deep));
				child = child.nextSibling;
			}
		}
		return node2;
	}
	
	function __set__(object,key,value){
		object[key] = value
	}
	//do dynamic
	try{
		if(Object.defineProperty){
			Object.defineProperty(LiveNodeList.prototype,'length',{
				get:function(){
					_updateLiveList(this);
					return this.$$length;
				}
			});
			Object.defineProperty(Node.prototype,'textContent',{
				get:function(){
					return getTextContent(this);
				},
				set:function(data){
					switch(this.nodeType){
					case ELEMENT_NODE:
					case DOCUMENT_FRAGMENT_NODE:
						while(this.firstChild){
							this.removeChild(this.firstChild);
						}
						if(data || String(data)){
							this.appendChild(this.ownerDocument.createTextNode(data));
						}
						break;
					default:
						//TODO:
						this.data = data;
						this.value = data;
						this.nodeValue = data;
					}
				}
			})
			
			function getTextContent(node){
				switch(node.nodeType){
				case ELEMENT_NODE:
				case DOCUMENT_FRAGMENT_NODE:
					var buf = [];
					node = node.firstChild;
					while(node){
						if(node.nodeType!==7 && node.nodeType !==8){
							buf.push(getTextContent(node));
						}
						node = node.nextSibling;
					}
					return buf.join('');
				default:
					return node.nodeValue;
				}
			}
			__set__ = function(object,key,value){
				//console.log(value)
				object['$$'+key] = value
			}
		}
	}catch(e){//ie8
	}
	
	//if(typeof require == 'function'){
		exports.Node = Node;
		exports.DOMException = DOMException;
		exports.DOMImplementation = DOMImplementation;
		exports.XMLSerializer = XMLSerializer;
	//}


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1248);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 992 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1252);
	} else {
	  module.exports = require('./cjs/react-dom-unstable-native-dependencies.development.js');
	}


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FaYoutube = exports.FaYoutubeSquare = exports.FaYoutubePlay = exports.FaYelp = exports.FaYahoo = exports.FaYCombinator = exports.FaXing = exports.FaXingSquare = exports.FaWrench = exports.FaWpforms = exports.FaWpbeginner = exports.FaWordpress = exports.FaWindows = exports.FaWikipediaW = exports.FaWifi = exports.FaWheelchair = exports.FaWheelchairAlt = exports.FaWhatsapp = exports.FaWeibo = exports.FaWechat = exports.FaVolumeUp = exports.FaVolumeOff = exports.FaVolumeDown = exports.FaVolumeControlPhone = exports.FaVk = exports.FaVine = exports.FaVimeo = exports.FaVimeoSquare = undefined;
	exports.FaVideoCamera = exports.FaViadeo = exports.FaViadeoSquare = exports.FaViacoin = exports.FaVenus = exports.FaVenusMars = exports.FaVenusDouble = exports.FaUser = exports.FaUserTimes = exports.FaUserSecret = exports.FaUserPlus = exports.FaUserMd = exports.FaUsb = exports.FaUpload = exports.FaUnlock = exports.FaUnlockAlt = exports.FaUniversalAccess = exports.FaUnderline = exports.FaUmbrella = exports.FaTwitter = exports.FaTwitterSquare = exports.FaTwitch = exports.FaTumblr = exports.FaTumblrSquare = exports.FaTty = exports.FaTry = exports.FaTruck = exports.FaTrophy = exports.FaTripadvisor = exports.FaTrello = exports.FaTree = exports.FaTrash = exports.FaTrashO = exports.FaTransgenderAlt = exports.FaTrain = exports.FaTrademark = exports.FaToggleOn = exports.FaToggleOff = exports.FaTint = exports.FaTimesCircle = exports.FaTimesCircleO = exports.FaTicket = exports.FaThumbsUp = exports.FaThumbsOUp = exports.FaThumbsODown = exports.FaThumbsDown = exports.FaThumbTack = exports.FaTh = exports.FaThList = exports.FaThLarge = exports.FaTextWidth = exports.FaTextHeight = exports.FaTerminal = exports.FaTencentWeibo = exports.FaTelevision = exports.FaTasks = exports.FaTags = exports.FaTag = exports.FaTablet = exports.FaTable = exports.FaSuperscript = exports.FaSunO = exports.FaSuitcase = exports.FaSubway = exports.FaSubscript = exports.FaStumbleupon = exports.FaStumbleuponCircle = exports.FaStrikethrough = exports.FaStreetView = exports.FaStop = exports.FaStopCircle = exports.FaStopCircleO = exports.FaStickyNote = exports.FaStickyNoteO = exports.FaStethoscope = exports.FaStepForward = exports.FaStepBackward = exports.FaSteam = exports.FaSteamSquare = exports.FaStar = exports.FaStarO = exports.FaStarHalf = exports.FaStarHalfEmpty = exports.FaStackOverflow = exports.FaStackExchange = exports.FaSquare = exports.FaSquareO = exports.FaSpotify = exports.FaSpoon = exports.FaSpinner = exports.FaSpaceShuttle = exports.FaSoundcloud = exports.FaSort = exports.FaSortNumericDesc = exports.FaSortNumericAsc = exports.FaSortDesc = exports.FaSortAsc = exports.FaSortAmountDesc = exports.FaSortAmountAsc = exports.FaSortAlphaDesc = undefined;
	exports.FaSortAlphaAsc = exports.FaSnapchat = exports.FaSnapchatSquare = exports.FaSnapchatGhost = exports.FaSmileO = exports.FaSlideshare = exports.FaSliders = exports.FaSlack = exports.FaSkype = exports.FaSkyatlas = exports.FaSitemap = exports.FaSimplybuilt = exports.FaSignal = exports.FaSignOut = exports.FaSignLanguage = exports.FaSignIn = exports.FaShoppingCart = exports.FaShoppingBasket = exports.FaShoppingBag = exports.FaShirtsinbulk = exports.FaShip = exports.FaShield = exports.FaShareSquare = exports.FaShareSquareO = exports.FaShareAlt = exports.FaShareAltSquare = exports.FaServer = exports.FaSellsy = exports.FaSearch = exports.FaSearchPlus = exports.FaSearchMinus = exports.FaScribd = exports.FaSafari = exports.FaRssSquare = exports.FaRouble = exports.FaRotateLeft = exports.FaRocket = exports.FaRoad = exports.FaRetweet = exports.FaRepeat = exports.FaRenren = exports.FaRegistered = exports.FaRefresh = exports.FaReddit = exports.FaRedditSquare = exports.FaRedditAlien = exports.FaRecycle = exports.FaRandom = exports.FaRa = exports.FaQuoteRight = exports.FaQuoteLeft = exports.FaQuestion = exports.FaQuestionCircle = exports.FaQuestionCircleO = exports.FaQrcode = exports.FaQq = exports.FaPuzzlePiece = exports.FaProductHunt = exports.FaPrint = exports.FaPowerOff = exports.FaPlus = exports.FaPlusSquare = exports.FaPlusSquareO = exports.FaPlusCircle = exports.FaPlug = exports.FaPlay = exports.FaPlayCircle = exports.FaPlayCircleO = exports.FaPlane = exports.FaPinterest = exports.FaPinterestSquare = exports.FaPinterestP = exports.FaPiedPiper = exports.FaPiedPiperAlt = exports.FaPieChart = exports.FaPhone = exports.FaPhoneSquare = exports.FaPercent = exports.FaPencil = exports.FaPencilSquare = exports.FaPaypal = exports.FaPaw = exports.FaPause = exports.FaPauseCircle = exports.FaPauseCircleO = exports.FaParagraph = exports.FaPaperclip = exports.FaPaperPlane = exports.FaPaperPlaneO = exports.FaPaintBrush = exports.FaPagelines = exports.FaOptinMonster = exports.FaOpera = exports.FaOpenid = exports.FaOpencart = exports.FaOdnoklassniki = exports.FaOdnoklassnikiSquare = exports.FaObjectUngroup = exports.FaObjectGroup = exports.FaNewspaperO = undefined;
	exports.FaNeuter = exports.FaMusic = exports.FaMousePointer = exports.FaMotorcycle = exports.FaMoonO = exports.FaMoney = exports.FaModx = exports.FaMobile = exports.FaMixcloud = exports.FaMinus = exports.FaMinusSquare = exports.FaMinusSquareO = exports.FaMinusCircle = exports.FaMicrophone = exports.FaMicrophoneSlash = exports.FaMercury = exports.FaMehO = exports.FaMedkit = exports.FaMedium = exports.FaMeanpath = exports.FaMaxcdn = exports.FaMars = exports.FaMarsStroke = exports.FaMarsStrokeV = exports.FaMarsStrokeH = exports.FaMarsDouble = exports.FaMap = exports.FaMapSigns = exports.FaMapPin = exports.FaMapO = exports.FaMapMarker = exports.FaMale = exports.FaMailReply = exports.FaMailReplyAll = exports.FaMailForward = exports.FaMagnet = exports.FaMagic = exports.FaLowVision = exports.FaLongArrowUp = exports.FaLongArrowRight = exports.FaLongArrowLeft = exports.FaLongArrowDown = exports.FaLock = exports.FaLocationArrow = exports.FaList = exports.FaListUl = exports.FaListOl = exports.FaListAlt = exports.FaLinux = exports.FaLinkedin = exports.FaLinkedinSquare = exports.FaLineChart = exports.FaLightbulbO = exports.FaLifeBouy = exports.FaLevelUp = exports.FaLevelDown = exports.FaLemonO = exports.FaLeanpub = exports.FaLeaf = exports.FaLastfm = exports.FaLastfmSquare = exports.FaLaptop = exports.FaLanguage = exports.FaKrw = exports.FaKeyboardO = exports.FaKey = exports.FaJsfiddle = exports.FaJoomla = exports.FaItalic = exports.FaIoxhost = exports.FaIntersex = exports.FaInternetExplorer = exports.FaInstagram = exports.FaInr = exports.FaInfo = exports.FaInfoCircle = exports.FaIndustry = exports.FaIndent = exports.FaInbox = exports.FaImage = exports.FaIls = exports.FaICursor = exports.FaHtml5 = exports.FaHouzz = exports.FaHourglass = exports.FaHourglassO = exports.FaHourglass3 = exports.FaHourglass2 = exports.FaHourglass1 = exports.FaHospitalO = exports.FaHome = exports.FaHistory = exports.FaHeartbeat = exports.FaHeart = exports.FaHeartO = exports.FaHeadphones = exports.FaHeader = exports.FaHddO = exports.FaHashtag = exports.FaHandSpockO = undefined;
	exports.FaHandScissorsO = exports.FaHandPointerO = exports.FaHandPeaceO = exports.FaHandPaperO = exports.FaHandOUp = exports.FaHandORight = exports.FaHandOLeft = exports.FaHandODown = exports.FaHandLizardO = exports.FaHandGrabO = exports.FaHackerNews = exports.FaHSquare = exports.FaGroup = exports.FaGraduationCap = exports.FaGoogle = exports.FaGoogleWallet = exports.FaGooglePlus = exports.FaGooglePlusSquare = exports.FaGlobe = exports.FaGlide = exports.FaGlideG = exports.FaGlass = exports.FaGittip = exports.FaGitlab = exports.FaGithub = exports.FaGithubSquare = exports.FaGithubAlt = exports.FaGit = exports.FaGitSquare = exports.FaGift = exports.FaGg = exports.FaGgCircle = exports.FaGetPocket = exports.FaGenderless = exports.FaGbp = exports.FaGavel = exports.FaGamepad = exports.FaFutbolO = exports.FaFrownO = exports.FaFoursquare = exports.FaForward = exports.FaForumbee = exports.FaFortAwesome = exports.FaFonticons = exports.FaFont = exports.FaFolder = exports.FaFolderOpen = exports.FaFolderOpenO = exports.FaFolderO = exports.FaFloppyO = exports.FaFlickr = exports.FaFlask = exports.FaFlag = exports.FaFlagO = exports.FaFlagCheckered = exports.FaFirefox = exports.FaFire = exports.FaFireExtinguisher = exports.FaFilter = exports.FaFilm = exports.FaFile = exports.FaFileWordO = exports.FaFileText = exports.FaFileTextO = exports.FaFilePowerpointO = exports.FaFilePdfO = exports.FaFileO = exports.FaFileMovieO = exports.FaFileImageO = exports.FaFileExcelO = exports.FaFileCodeO = exports.FaFileAudioO = exports.FaFileArchiveO = exports.FaFighterJet = exports.FaFemale = exports.FaFeed = exports.FaFax = exports.FaFastForward = exports.FaFastBackward = exports.FaFacebook = exports.FaFacebookSquare = exports.FaFacebookOfficial = exports.FaEyedropper = exports.FaEye = exports.FaEyeSlash = exports.FaExternalLink = exports.FaExternalLinkSquare = exports.FaExpeditedssl = exports.FaExpand = exports.FaExclamation = exports.FaExclamationTriangle = exports.FaExclamationCircle = exports.FaExchange = exports.FaEur = exports.FaEraser = exports.FaEnvira = exports.FaEnvelope = exports.FaEnvelopeSquare = exports.FaEnvelopeO = exports.FaEmpire = undefined;
	exports.FaEllipsisV = exports.FaEllipsisH = exports.FaEject = exports.FaEdit = exports.FaEdge = exports.FaDrupal = exports.FaDropbox = exports.FaDribbble = exports.FaDownload = exports.FaDotCircleO = exports.FaDollar = exports.FaDigg = exports.FaDiamond = exports.FaDeviantart = exports.FaDesktop = exports.FaDelicious = exports.FaDedent = exports.FaDeaf = exports.FaDatabase = exports.FaDashcube = exports.FaDashboard = exports.FaCutlery = exports.FaCut = exports.FaCubes = exports.FaCube = exports.FaCss3 = exports.FaCrosshairs = exports.FaCrop = exports.FaCreditCard = exports.FaCreditCardAlt = exports.FaCreativeCommons = exports.FaCopyright = exports.FaCopy = exports.FaContao = exports.FaConnectdevelop = exports.FaCompress = exports.FaCompass = exports.FaComments = exports.FaCommentsO = exports.FaCommenting = exports.FaCommentingO = exports.FaComment = exports.FaCommentO = exports.FaColumns = exports.FaCogs = exports.FaCog = exports.FaCoffee = exports.FaCodiepie = exports.FaCodepen = exports.FaCode = exports.FaCodeFork = exports.FaCny = exports.FaCloud = exports.FaCloudUpload = exports.FaCloudDownload = exports.FaClose = exports.FaClone = exports.FaClockO = exports.FaClipboard = exports.FaCircle = exports.FaCircleThin = exports.FaCircleO = exports.FaCircleONotch = exports.FaChrome = exports.FaChild = exports.FaChevronUp = exports.FaChevronRight = exports.FaChevronLeft = exports.FaChevronDown = exports.FaChevronCircleUp = exports.FaChevronCircleRight = exports.FaChevronCircleLeft = exports.FaChevronCircleDown = exports.FaCheck = exports.FaCheckSquare = exports.FaCheckSquareO = exports.FaCheckCircle = exports.FaCheckCircleO = exports.FaChain = exports.FaChainBroken = exports.FaCertificate = exports.FaCc = exports.FaCcVisa = exports.FaCcStripe = exports.FaCcPaypal = exports.FaCcMastercard = exports.FaCcJcb = exports.FaCcDiscover = exports.FaCcDinersClub = exports.FaCcAmex = exports.FaCartPlus = exports.FaCartArrowDown = exports.FaCaretUp = exports.FaCaretSquareOUp = exports.FaCaretSquareORight = exports.FaCaretSquareOLeft = exports.FaCaretSquareODown = exports.FaCaretRight = exports.FaCaretLeft = exports.FaCaretDown = undefined;
	exports.FaCamera = exports.FaCameraRetro = exports.FaCalendar = exports.FaCalendarTimesO = exports.FaCalendarPlusO = exports.FaCalendarO = exports.FaCalendarMinusO = exports.FaCalendarCheckO = exports.FaCalculator = exports.FaCab = exports.FaBuysellads = exports.FaBus = exports.FaBullseye = exports.FaBullhorn = exports.FaBuilding = exports.FaBuildingO = exports.FaBug = exports.FaBriefcase = exports.FaBraille = exports.FaBookmark = exports.FaBookmarkO = exports.FaBook = exports.FaBomb = exports.FaBolt = exports.FaBold = exports.FaBluetooth = exports.FaBluetoothB = exports.FaBlind = exports.FaBlackTie = exports.FaBitcoin = exports.FaBitbucket = exports.FaBitbucketSquare = exports.FaBirthdayCake = exports.FaBinoculars = exports.FaBicycle = exports.FaBell = exports.FaBellSlash = exports.FaBellSlashO = exports.FaBellO = exports.FaBehance = exports.FaBehanceSquare = exports.FaBeer = exports.FaBed = exports.FaBattery4 = exports.FaBattery3 = exports.FaBattery2 = exports.FaBattery1 = exports.FaBattery0 = exports.FaBars = exports.FaBarcode = exports.FaBarChart = exports.FaBank = exports.FaBan = exports.FaBalanceScale = exports.FaBackward = exports.FaAutomobile = exports.FaAudioDescription = exports.FaAt = exports.FaAsterisk = exports.FaAssistiveListeningSystems = exports.FaArrows = exports.FaArrowsV = exports.FaArrowsH = exports.FaArrowsAlt = exports.FaArrowUp = exports.FaArrowRight = exports.FaArrowLeft = exports.FaArrowDown = exports.FaArrowCircleUp = exports.FaArrowCircleRight = exports.FaArrowCircleOUp = exports.FaArrowCircleORight = exports.FaArrowCircleOLeft = exports.FaArrowCircleODown = exports.FaArrowCircleLeft = exports.FaArrowCircleDown = exports.FaAreaChart = exports.FaArchive = exports.FaApple = exports.FaAngleUp = exports.FaAngleRight = exports.FaAngleLeft = exports.FaAngleDown = exports.FaAngleDoubleUp = exports.FaAngleDoubleRight = exports.FaAngleDoubleLeft = exports.FaAngleDoubleDown = exports.FaAngellist = exports.FaAndroid = exports.FaAnchor = exports.FaAmericanSignLanguageInterpreting = exports.FaAmbulance = exports.FaAmazon = exports.FaAlignRight = exports.FaAlignLeft = exports.FaAlignJustify = exports.FaAlignCenter = exports.FaAdn = exports.FaAdjust = exports.Fa500px = undefined;
	
	var _px = __webpack_require__(163);
	
	var _px2 = _interopRequireDefault(_px);
	
	var _adjust = __webpack_require__(164);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _adn = __webpack_require__(165);
	
	var _adn2 = _interopRequireDefault(_adn);
	
	var _alignCenter = __webpack_require__(166);
	
	var _alignCenter2 = _interopRequireDefault(_alignCenter);
	
	var _alignJustify = __webpack_require__(167);
	
	var _alignJustify2 = _interopRequireDefault(_alignJustify);
	
	var _alignLeft = __webpack_require__(168);
	
	var _alignLeft2 = _interopRequireDefault(_alignLeft);
	
	var _alignRight = __webpack_require__(169);
	
	var _alignRight2 = _interopRequireDefault(_alignRight);
	
	var _amazon = __webpack_require__(170);
	
	var _amazon2 = _interopRequireDefault(_amazon);
	
	var _ambulance = __webpack_require__(171);
	
	var _ambulance2 = _interopRequireDefault(_ambulance);
	
	var _americanSignLanguageInterpreting = __webpack_require__(172);
	
	var _americanSignLanguageInterpreting2 = _interopRequireDefault(_americanSignLanguageInterpreting);
	
	var _anchor = __webpack_require__(173);
	
	var _anchor2 = _interopRequireDefault(_anchor);
	
	var _android = __webpack_require__(174);
	
	var _android2 = _interopRequireDefault(_android);
	
	var _angellist = __webpack_require__(175);
	
	var _angellist2 = _interopRequireDefault(_angellist);
	
	var _angleDoubleDown = __webpack_require__(176);
	
	var _angleDoubleDown2 = _interopRequireDefault(_angleDoubleDown);
	
	var _angleDoubleLeft = __webpack_require__(177);
	
	var _angleDoubleLeft2 = _interopRequireDefault(_angleDoubleLeft);
	
	var _angleDoubleRight = __webpack_require__(178);
	
	var _angleDoubleRight2 = _interopRequireDefault(_angleDoubleRight);
	
	var _angleDoubleUp = __webpack_require__(179);
	
	var _angleDoubleUp2 = _interopRequireDefault(_angleDoubleUp);
	
	var _angleDown = __webpack_require__(180);
	
	var _angleDown2 = _interopRequireDefault(_angleDown);
	
	var _angleLeft = __webpack_require__(181);
	
	var _angleLeft2 = _interopRequireDefault(_angleLeft);
	
	var _angleRight = __webpack_require__(182);
	
	var _angleRight2 = _interopRequireDefault(_angleRight);
	
	var _angleUp = __webpack_require__(183);
	
	var _angleUp2 = _interopRequireDefault(_angleUp);
	
	var _apple = __webpack_require__(184);
	
	var _apple2 = _interopRequireDefault(_apple);
	
	var _archive = __webpack_require__(185);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _areaChart = __webpack_require__(186);
	
	var _areaChart2 = _interopRequireDefault(_areaChart);
	
	var _arrowCircleDown = __webpack_require__(187);
	
	var _arrowCircleDown2 = _interopRequireDefault(_arrowCircleDown);
	
	var _arrowCircleLeft = __webpack_require__(188);
	
	var _arrowCircleLeft2 = _interopRequireDefault(_arrowCircleLeft);
	
	var _arrowCircleODown = __webpack_require__(189);
	
	var _arrowCircleODown2 = _interopRequireDefault(_arrowCircleODown);
	
	var _arrowCircleOLeft = __webpack_require__(190);
	
	var _arrowCircleOLeft2 = _interopRequireDefault(_arrowCircleOLeft);
	
	var _arrowCircleORight = __webpack_require__(191);
	
	var _arrowCircleORight2 = _interopRequireDefault(_arrowCircleORight);
	
	var _arrowCircleOUp = __webpack_require__(192);
	
	var _arrowCircleOUp2 = _interopRequireDefault(_arrowCircleOUp);
	
	var _arrowCircleRight = __webpack_require__(193);
	
	var _arrowCircleRight2 = _interopRequireDefault(_arrowCircleRight);
	
	var _arrowCircleUp = __webpack_require__(194);
	
	var _arrowCircleUp2 = _interopRequireDefault(_arrowCircleUp);
	
	var _arrowDown = __webpack_require__(195);
	
	var _arrowDown2 = _interopRequireDefault(_arrowDown);
	
	var _arrowLeft = __webpack_require__(196);
	
	var _arrowLeft2 = _interopRequireDefault(_arrowLeft);
	
	var _arrowRight = __webpack_require__(197);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _arrowUp = __webpack_require__(198);
	
	var _arrowUp2 = _interopRequireDefault(_arrowUp);
	
	var _arrowsAlt = __webpack_require__(199);
	
	var _arrowsAlt2 = _interopRequireDefault(_arrowsAlt);
	
	var _arrowsH = __webpack_require__(200);
	
	var _arrowsH2 = _interopRequireDefault(_arrowsH);
	
	var _arrowsV = __webpack_require__(201);
	
	var _arrowsV2 = _interopRequireDefault(_arrowsV);
	
	var _arrows = __webpack_require__(202);
	
	var _arrows2 = _interopRequireDefault(_arrows);
	
	var _assistiveListeningSystems = __webpack_require__(203);
	
	var _assistiveListeningSystems2 = _interopRequireDefault(_assistiveListeningSystems);
	
	var _asterisk = __webpack_require__(204);
	
	var _asterisk2 = _interopRequireDefault(_asterisk);
	
	var _at = __webpack_require__(205);
	
	var _at2 = _interopRequireDefault(_at);
	
	var _audioDescription = __webpack_require__(206);
	
	var _audioDescription2 = _interopRequireDefault(_audioDescription);
	
	var _automobile = __webpack_require__(207);
	
	var _automobile2 = _interopRequireDefault(_automobile);
	
	var _backward = __webpack_require__(208);
	
	var _backward2 = _interopRequireDefault(_backward);
	
	var _balanceScale = __webpack_require__(209);
	
	var _balanceScale2 = _interopRequireDefault(_balanceScale);
	
	var _ban = __webpack_require__(210);
	
	var _ban2 = _interopRequireDefault(_ban);
	
	var _bank = __webpack_require__(211);
	
	var _bank2 = _interopRequireDefault(_bank);
	
	var _barChart = __webpack_require__(212);
	
	var _barChart2 = _interopRequireDefault(_barChart);
	
	var _barcode = __webpack_require__(213);
	
	var _barcode2 = _interopRequireDefault(_barcode);
	
	var _bars = __webpack_require__(214);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _battery = __webpack_require__(215);
	
	var _battery2 = _interopRequireDefault(_battery);
	
	var _battery3 = __webpack_require__(216);
	
	var _battery4 = _interopRequireDefault(_battery3);
	
	var _battery5 = __webpack_require__(217);
	
	var _battery6 = _interopRequireDefault(_battery5);
	
	var _battery7 = __webpack_require__(218);
	
	var _battery8 = _interopRequireDefault(_battery7);
	
	var _battery9 = __webpack_require__(219);
	
	var _battery10 = _interopRequireDefault(_battery9);
	
	var _bed = __webpack_require__(220);
	
	var _bed2 = _interopRequireDefault(_bed);
	
	var _beer = __webpack_require__(221);
	
	var _beer2 = _interopRequireDefault(_beer);
	
	var _behanceSquare = __webpack_require__(222);
	
	var _behanceSquare2 = _interopRequireDefault(_behanceSquare);
	
	var _behance = __webpack_require__(223);
	
	var _behance2 = _interopRequireDefault(_behance);
	
	var _bellO = __webpack_require__(224);
	
	var _bellO2 = _interopRequireDefault(_bellO);
	
	var _bellSlashO = __webpack_require__(225);
	
	var _bellSlashO2 = _interopRequireDefault(_bellSlashO);
	
	var _bellSlash = __webpack_require__(226);
	
	var _bellSlash2 = _interopRequireDefault(_bellSlash);
	
	var _bell = __webpack_require__(227);
	
	var _bell2 = _interopRequireDefault(_bell);
	
	var _bicycle = __webpack_require__(228);
	
	var _bicycle2 = _interopRequireDefault(_bicycle);
	
	var _binoculars = __webpack_require__(229);
	
	var _binoculars2 = _interopRequireDefault(_binoculars);
	
	var _birthdayCake = __webpack_require__(230);
	
	var _birthdayCake2 = _interopRequireDefault(_birthdayCake);
	
	var _bitbucketSquare = __webpack_require__(231);
	
	var _bitbucketSquare2 = _interopRequireDefault(_bitbucketSquare);
	
	var _bitbucket = __webpack_require__(232);
	
	var _bitbucket2 = _interopRequireDefault(_bitbucket);
	
	var _bitcoin = __webpack_require__(233);
	
	var _bitcoin2 = _interopRequireDefault(_bitcoin);
	
	var _blackTie = __webpack_require__(234);
	
	var _blackTie2 = _interopRequireDefault(_blackTie);
	
	var _blind = __webpack_require__(235);
	
	var _blind2 = _interopRequireDefault(_blind);
	
	var _bluetoothB = __webpack_require__(236);
	
	var _bluetoothB2 = _interopRequireDefault(_bluetoothB);
	
	var _bluetooth = __webpack_require__(237);
	
	var _bluetooth2 = _interopRequireDefault(_bluetooth);
	
	var _bold = __webpack_require__(238);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _bolt = __webpack_require__(239);
	
	var _bolt2 = _interopRequireDefault(_bolt);
	
	var _bomb = __webpack_require__(240);
	
	var _bomb2 = _interopRequireDefault(_bomb);
	
	var _book = __webpack_require__(241);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _bookmarkO = __webpack_require__(242);
	
	var _bookmarkO2 = _interopRequireDefault(_bookmarkO);
	
	var _bookmark = __webpack_require__(243);
	
	var _bookmark2 = _interopRequireDefault(_bookmark);
	
	var _braille = __webpack_require__(244);
	
	var _braille2 = _interopRequireDefault(_braille);
	
	var _briefcase = __webpack_require__(245);
	
	var _briefcase2 = _interopRequireDefault(_briefcase);
	
	var _bug = __webpack_require__(246);
	
	var _bug2 = _interopRequireDefault(_bug);
	
	var _buildingO = __webpack_require__(247);
	
	var _buildingO2 = _interopRequireDefault(_buildingO);
	
	var _building = __webpack_require__(248);
	
	var _building2 = _interopRequireDefault(_building);
	
	var _bullhorn = __webpack_require__(249);
	
	var _bullhorn2 = _interopRequireDefault(_bullhorn);
	
	var _bullseye = __webpack_require__(250);
	
	var _bullseye2 = _interopRequireDefault(_bullseye);
	
	var _bus = __webpack_require__(251);
	
	var _bus2 = _interopRequireDefault(_bus);
	
	var _buysellads = __webpack_require__(252);
	
	var _buysellads2 = _interopRequireDefault(_buysellads);
	
	var _cab = __webpack_require__(253);
	
	var _cab2 = _interopRequireDefault(_cab);
	
	var _calculator = __webpack_require__(254);
	
	var _calculator2 = _interopRequireDefault(_calculator);
	
	var _calendarCheckO = __webpack_require__(255);
	
	var _calendarCheckO2 = _interopRequireDefault(_calendarCheckO);
	
	var _calendarMinusO = __webpack_require__(256);
	
	var _calendarMinusO2 = _interopRequireDefault(_calendarMinusO);
	
	var _calendarO = __webpack_require__(257);
	
	var _calendarO2 = _interopRequireDefault(_calendarO);
	
	var _calendarPlusO = __webpack_require__(258);
	
	var _calendarPlusO2 = _interopRequireDefault(_calendarPlusO);
	
	var _calendarTimesO = __webpack_require__(259);
	
	var _calendarTimesO2 = _interopRequireDefault(_calendarTimesO);
	
	var _calendar = __webpack_require__(260);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _cameraRetro = __webpack_require__(261);
	
	var _cameraRetro2 = _interopRequireDefault(_cameraRetro);
	
	var _camera = __webpack_require__(262);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _caretDown = __webpack_require__(263);
	
	var _caretDown2 = _interopRequireDefault(_caretDown);
	
	var _caretLeft = __webpack_require__(264);
	
	var _caretLeft2 = _interopRequireDefault(_caretLeft);
	
	var _caretRight = __webpack_require__(265);
	
	var _caretRight2 = _interopRequireDefault(_caretRight);
	
	var _caretSquareODown = __webpack_require__(266);
	
	var _caretSquareODown2 = _interopRequireDefault(_caretSquareODown);
	
	var _caretSquareOLeft = __webpack_require__(267);
	
	var _caretSquareOLeft2 = _interopRequireDefault(_caretSquareOLeft);
	
	var _caretSquareORight = __webpack_require__(268);
	
	var _caretSquareORight2 = _interopRequireDefault(_caretSquareORight);
	
	var _caretSquareOUp = __webpack_require__(269);
	
	var _caretSquareOUp2 = _interopRequireDefault(_caretSquareOUp);
	
	var _caretUp = __webpack_require__(270);
	
	var _caretUp2 = _interopRequireDefault(_caretUp);
	
	var _cartArrowDown = __webpack_require__(271);
	
	var _cartArrowDown2 = _interopRequireDefault(_cartArrowDown);
	
	var _cartPlus = __webpack_require__(272);
	
	var _cartPlus2 = _interopRequireDefault(_cartPlus);
	
	var _ccAmex = __webpack_require__(273);
	
	var _ccAmex2 = _interopRequireDefault(_ccAmex);
	
	var _ccDinersClub = __webpack_require__(274);
	
	var _ccDinersClub2 = _interopRequireDefault(_ccDinersClub);
	
	var _ccDiscover = __webpack_require__(275);
	
	var _ccDiscover2 = _interopRequireDefault(_ccDiscover);
	
	var _ccJcb = __webpack_require__(276);
	
	var _ccJcb2 = _interopRequireDefault(_ccJcb);
	
	var _ccMastercard = __webpack_require__(277);
	
	var _ccMastercard2 = _interopRequireDefault(_ccMastercard);
	
	var _ccPaypal = __webpack_require__(278);
	
	var _ccPaypal2 = _interopRequireDefault(_ccPaypal);
	
	var _ccStripe = __webpack_require__(279);
	
	var _ccStripe2 = _interopRequireDefault(_ccStripe);
	
	var _ccVisa = __webpack_require__(280);
	
	var _ccVisa2 = _interopRequireDefault(_ccVisa);
	
	var _cc = __webpack_require__(281);
	
	var _cc2 = _interopRequireDefault(_cc);
	
	var _certificate = __webpack_require__(282);
	
	var _certificate2 = _interopRequireDefault(_certificate);
	
	var _chainBroken = __webpack_require__(283);
	
	var _chainBroken2 = _interopRequireDefault(_chainBroken);
	
	var _chain = __webpack_require__(284);
	
	var _chain2 = _interopRequireDefault(_chain);
	
	var _checkCircleO = __webpack_require__(285);
	
	var _checkCircleO2 = _interopRequireDefault(_checkCircleO);
	
	var _checkCircle = __webpack_require__(286);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _checkSquareO = __webpack_require__(287);
	
	var _checkSquareO2 = _interopRequireDefault(_checkSquareO);
	
	var _checkSquare = __webpack_require__(288);
	
	var _checkSquare2 = _interopRequireDefault(_checkSquare);
	
	var _check = __webpack_require__(289);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _chevronCircleDown = __webpack_require__(290);
	
	var _chevronCircleDown2 = _interopRequireDefault(_chevronCircleDown);
	
	var _chevronCircleLeft = __webpack_require__(291);
	
	var _chevronCircleLeft2 = _interopRequireDefault(_chevronCircleLeft);
	
	var _chevronCircleRight = __webpack_require__(292);
	
	var _chevronCircleRight2 = _interopRequireDefault(_chevronCircleRight);
	
	var _chevronCircleUp = __webpack_require__(293);
	
	var _chevronCircleUp2 = _interopRequireDefault(_chevronCircleUp);
	
	var _chevronDown = __webpack_require__(294);
	
	var _chevronDown2 = _interopRequireDefault(_chevronDown);
	
	var _chevronLeft = __webpack_require__(295);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(296);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _chevronUp = __webpack_require__(297);
	
	var _chevronUp2 = _interopRequireDefault(_chevronUp);
	
	var _child = __webpack_require__(298);
	
	var _child2 = _interopRequireDefault(_child);
	
	var _chrome = __webpack_require__(299);
	
	var _chrome2 = _interopRequireDefault(_chrome);
	
	var _circleONotch = __webpack_require__(300);
	
	var _circleONotch2 = _interopRequireDefault(_circleONotch);
	
	var _circleO = __webpack_require__(301);
	
	var _circleO2 = _interopRequireDefault(_circleO);
	
	var _circleThin = __webpack_require__(302);
	
	var _circleThin2 = _interopRequireDefault(_circleThin);
	
	var _circle = __webpack_require__(303);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _clipboard = __webpack_require__(304);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _clockO = __webpack_require__(305);
	
	var _clockO2 = _interopRequireDefault(_clockO);
	
	var _clone = __webpack_require__(306);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _close = __webpack_require__(307);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _cloudDownload = __webpack_require__(308);
	
	var _cloudDownload2 = _interopRequireDefault(_cloudDownload);
	
	var _cloudUpload = __webpack_require__(309);
	
	var _cloudUpload2 = _interopRequireDefault(_cloudUpload);
	
	var _cloud = __webpack_require__(310);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _cny = __webpack_require__(311);
	
	var _cny2 = _interopRequireDefault(_cny);
	
	var _codeFork = __webpack_require__(312);
	
	var _codeFork2 = _interopRequireDefault(_codeFork);
	
	var _code = __webpack_require__(313);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _codepen = __webpack_require__(314);
	
	var _codepen2 = _interopRequireDefault(_codepen);
	
	var _codiepie = __webpack_require__(315);
	
	var _codiepie2 = _interopRequireDefault(_codiepie);
	
	var _coffee = __webpack_require__(316);
	
	var _coffee2 = _interopRequireDefault(_coffee);
	
	var _cog = __webpack_require__(317);
	
	var _cog2 = _interopRequireDefault(_cog);
	
	var _cogs = __webpack_require__(318);
	
	var _cogs2 = _interopRequireDefault(_cogs);
	
	var _columns = __webpack_require__(319);
	
	var _columns2 = _interopRequireDefault(_columns);
	
	var _commentO = __webpack_require__(320);
	
	var _commentO2 = _interopRequireDefault(_commentO);
	
	var _comment = __webpack_require__(321);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _commentingO = __webpack_require__(322);
	
	var _commentingO2 = _interopRequireDefault(_commentingO);
	
	var _commenting = __webpack_require__(323);
	
	var _commenting2 = _interopRequireDefault(_commenting);
	
	var _commentsO = __webpack_require__(324);
	
	var _commentsO2 = _interopRequireDefault(_commentsO);
	
	var _comments = __webpack_require__(325);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _compass = __webpack_require__(326);
	
	var _compass2 = _interopRequireDefault(_compass);
	
	var _compress = __webpack_require__(327);
	
	var _compress2 = _interopRequireDefault(_compress);
	
	var _connectdevelop = __webpack_require__(328);
	
	var _connectdevelop2 = _interopRequireDefault(_connectdevelop);
	
	var _contao = __webpack_require__(329);
	
	var _contao2 = _interopRequireDefault(_contao);
	
	var _copy = __webpack_require__(330);
	
	var _copy2 = _interopRequireDefault(_copy);
	
	var _copyright = __webpack_require__(331);
	
	var _copyright2 = _interopRequireDefault(_copyright);
	
	var _creativeCommons = __webpack_require__(332);
	
	var _creativeCommons2 = _interopRequireDefault(_creativeCommons);
	
	var _creditCardAlt = __webpack_require__(333);
	
	var _creditCardAlt2 = _interopRequireDefault(_creditCardAlt);
	
	var _creditCard = __webpack_require__(334);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _crop = __webpack_require__(335);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _crosshairs = __webpack_require__(336);
	
	var _crosshairs2 = _interopRequireDefault(_crosshairs);
	
	var _css = __webpack_require__(337);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _cube = __webpack_require__(338);
	
	var _cube2 = _interopRequireDefault(_cube);
	
	var _cubes = __webpack_require__(339);
	
	var _cubes2 = _interopRequireDefault(_cubes);
	
	var _cut = __webpack_require__(340);
	
	var _cut2 = _interopRequireDefault(_cut);
	
	var _cutlery = __webpack_require__(341);
	
	var _cutlery2 = _interopRequireDefault(_cutlery);
	
	var _dashboard = __webpack_require__(342);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashcube = __webpack_require__(343);
	
	var _dashcube2 = _interopRequireDefault(_dashcube);
	
	var _database = __webpack_require__(344);
	
	var _database2 = _interopRequireDefault(_database);
	
	var _deaf = __webpack_require__(345);
	
	var _deaf2 = _interopRequireDefault(_deaf);
	
	var _dedent = __webpack_require__(346);
	
	var _dedent2 = _interopRequireDefault(_dedent);
	
	var _delicious = __webpack_require__(347);
	
	var _delicious2 = _interopRequireDefault(_delicious);
	
	var _desktop = __webpack_require__(348);
	
	var _desktop2 = _interopRequireDefault(_desktop);
	
	var _deviantart = __webpack_require__(349);
	
	var _deviantart2 = _interopRequireDefault(_deviantart);
	
	var _diamond = __webpack_require__(350);
	
	var _diamond2 = _interopRequireDefault(_diamond);
	
	var _digg = __webpack_require__(351);
	
	var _digg2 = _interopRequireDefault(_digg);
	
	var _dollar = __webpack_require__(352);
	
	var _dollar2 = _interopRequireDefault(_dollar);
	
	var _dotCircleO = __webpack_require__(353);
	
	var _dotCircleO2 = _interopRequireDefault(_dotCircleO);
	
	var _download = __webpack_require__(354);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _dribbble = __webpack_require__(355);
	
	var _dribbble2 = _interopRequireDefault(_dribbble);
	
	var _dropbox = __webpack_require__(356);
	
	var _dropbox2 = _interopRequireDefault(_dropbox);
	
	var _drupal = __webpack_require__(357);
	
	var _drupal2 = _interopRequireDefault(_drupal);
	
	var _edge = __webpack_require__(358);
	
	var _edge2 = _interopRequireDefault(_edge);
	
	var _edit = __webpack_require__(359);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _eject = __webpack_require__(360);
	
	var _eject2 = _interopRequireDefault(_eject);
	
	var _ellipsisH = __webpack_require__(361);
	
	var _ellipsisH2 = _interopRequireDefault(_ellipsisH);
	
	var _ellipsisV = __webpack_require__(362);
	
	var _ellipsisV2 = _interopRequireDefault(_ellipsisV);
	
	var _empire = __webpack_require__(363);
	
	var _empire2 = _interopRequireDefault(_empire);
	
	var _envelopeO = __webpack_require__(364);
	
	var _envelopeO2 = _interopRequireDefault(_envelopeO);
	
	var _envelopeSquare = __webpack_require__(365);
	
	var _envelopeSquare2 = _interopRequireDefault(_envelopeSquare);
	
	var _envelope = __webpack_require__(366);
	
	var _envelope2 = _interopRequireDefault(_envelope);
	
	var _envira = __webpack_require__(367);
	
	var _envira2 = _interopRequireDefault(_envira);
	
	var _eraser = __webpack_require__(368);
	
	var _eraser2 = _interopRequireDefault(_eraser);
	
	var _eur = __webpack_require__(369);
	
	var _eur2 = _interopRequireDefault(_eur);
	
	var _exchange = __webpack_require__(370);
	
	var _exchange2 = _interopRequireDefault(_exchange);
	
	var _exclamationCircle = __webpack_require__(371);
	
	var _exclamationCircle2 = _interopRequireDefault(_exclamationCircle);
	
	var _exclamationTriangle = __webpack_require__(372);
	
	var _exclamationTriangle2 = _interopRequireDefault(_exclamationTriangle);
	
	var _exclamation = __webpack_require__(373);
	
	var _exclamation2 = _interopRequireDefault(_exclamation);
	
	var _expand = __webpack_require__(374);
	
	var _expand2 = _interopRequireDefault(_expand);
	
	var _expeditedssl = __webpack_require__(375);
	
	var _expeditedssl2 = _interopRequireDefault(_expeditedssl);
	
	var _externalLinkSquare = __webpack_require__(376);
	
	var _externalLinkSquare2 = _interopRequireDefault(_externalLinkSquare);
	
	var _externalLink = __webpack_require__(377);
	
	var _externalLink2 = _interopRequireDefault(_externalLink);
	
	var _eyeSlash = __webpack_require__(378);
	
	var _eyeSlash2 = _interopRequireDefault(_eyeSlash);
	
	var _eye = __webpack_require__(379);
	
	var _eye2 = _interopRequireDefault(_eye);
	
	var _eyedropper = __webpack_require__(380);
	
	var _eyedropper2 = _interopRequireDefault(_eyedropper);
	
	var _facebookOfficial = __webpack_require__(381);
	
	var _facebookOfficial2 = _interopRequireDefault(_facebookOfficial);
	
	var _facebookSquare = __webpack_require__(382);
	
	var _facebookSquare2 = _interopRequireDefault(_facebookSquare);
	
	var _facebook = __webpack_require__(383);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _fastBackward = __webpack_require__(384);
	
	var _fastBackward2 = _interopRequireDefault(_fastBackward);
	
	var _fastForward = __webpack_require__(385);
	
	var _fastForward2 = _interopRequireDefault(_fastForward);
	
	var _fax = __webpack_require__(386);
	
	var _fax2 = _interopRequireDefault(_fax);
	
	var _feed = __webpack_require__(387);
	
	var _feed2 = _interopRequireDefault(_feed);
	
	var _female = __webpack_require__(388);
	
	var _female2 = _interopRequireDefault(_female);
	
	var _fighterJet = __webpack_require__(389);
	
	var _fighterJet2 = _interopRequireDefault(_fighterJet);
	
	var _fileArchiveO = __webpack_require__(390);
	
	var _fileArchiveO2 = _interopRequireDefault(_fileArchiveO);
	
	var _fileAudioO = __webpack_require__(391);
	
	var _fileAudioO2 = _interopRequireDefault(_fileAudioO);
	
	var _fileCodeO = __webpack_require__(392);
	
	var _fileCodeO2 = _interopRequireDefault(_fileCodeO);
	
	var _fileExcelO = __webpack_require__(393);
	
	var _fileExcelO2 = _interopRequireDefault(_fileExcelO);
	
	var _fileImageO = __webpack_require__(394);
	
	var _fileImageO2 = _interopRequireDefault(_fileImageO);
	
	var _fileMovieO = __webpack_require__(395);
	
	var _fileMovieO2 = _interopRequireDefault(_fileMovieO);
	
	var _fileO = __webpack_require__(396);
	
	var _fileO2 = _interopRequireDefault(_fileO);
	
	var _filePdfO = __webpack_require__(397);
	
	var _filePdfO2 = _interopRequireDefault(_filePdfO);
	
	var _filePowerpointO = __webpack_require__(398);
	
	var _filePowerpointO2 = _interopRequireDefault(_filePowerpointO);
	
	var _fileTextO = __webpack_require__(399);
	
	var _fileTextO2 = _interopRequireDefault(_fileTextO);
	
	var _fileText = __webpack_require__(400);
	
	var _fileText2 = _interopRequireDefault(_fileText);
	
	var _fileWordO = __webpack_require__(401);
	
	var _fileWordO2 = _interopRequireDefault(_fileWordO);
	
	var _file = __webpack_require__(402);
	
	var _file2 = _interopRequireDefault(_file);
	
	var _film = __webpack_require__(403);
	
	var _film2 = _interopRequireDefault(_film);
	
	var _filter = __webpack_require__(404);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _fireExtinguisher = __webpack_require__(405);
	
	var _fireExtinguisher2 = _interopRequireDefault(_fireExtinguisher);
	
	var _fire = __webpack_require__(406);
	
	var _fire2 = _interopRequireDefault(_fire);
	
	var _firefox = __webpack_require__(407);
	
	var _firefox2 = _interopRequireDefault(_firefox);
	
	var _flagCheckered = __webpack_require__(408);
	
	var _flagCheckered2 = _interopRequireDefault(_flagCheckered);
	
	var _flagO = __webpack_require__(409);
	
	var _flagO2 = _interopRequireDefault(_flagO);
	
	var _flag = __webpack_require__(410);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _flask = __webpack_require__(411);
	
	var _flask2 = _interopRequireDefault(_flask);
	
	var _flickr = __webpack_require__(412);
	
	var _flickr2 = _interopRequireDefault(_flickr);
	
	var _floppyO = __webpack_require__(413);
	
	var _floppyO2 = _interopRequireDefault(_floppyO);
	
	var _folderO = __webpack_require__(414);
	
	var _folderO2 = _interopRequireDefault(_folderO);
	
	var _folderOpenO = __webpack_require__(415);
	
	var _folderOpenO2 = _interopRequireDefault(_folderOpenO);
	
	var _folderOpen = __webpack_require__(416);
	
	var _folderOpen2 = _interopRequireDefault(_folderOpen);
	
	var _folder = __webpack_require__(417);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _font = __webpack_require__(418);
	
	var _font2 = _interopRequireDefault(_font);
	
	var _fonticons = __webpack_require__(419);
	
	var _fonticons2 = _interopRequireDefault(_fonticons);
	
	var _fortAwesome = __webpack_require__(420);
	
	var _fortAwesome2 = _interopRequireDefault(_fortAwesome);
	
	var _forumbee = __webpack_require__(421);
	
	var _forumbee2 = _interopRequireDefault(_forumbee);
	
	var _forward = __webpack_require__(422);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	var _foursquare = __webpack_require__(423);
	
	var _foursquare2 = _interopRequireDefault(_foursquare);
	
	var _frownO = __webpack_require__(424);
	
	var _frownO2 = _interopRequireDefault(_frownO);
	
	var _futbolO = __webpack_require__(425);
	
	var _futbolO2 = _interopRequireDefault(_futbolO);
	
	var _gamepad = __webpack_require__(426);
	
	var _gamepad2 = _interopRequireDefault(_gamepad);
	
	var _gavel = __webpack_require__(427);
	
	var _gavel2 = _interopRequireDefault(_gavel);
	
	var _gbp = __webpack_require__(428);
	
	var _gbp2 = _interopRequireDefault(_gbp);
	
	var _genderless = __webpack_require__(429);
	
	var _genderless2 = _interopRequireDefault(_genderless);
	
	var _getPocket = __webpack_require__(430);
	
	var _getPocket2 = _interopRequireDefault(_getPocket);
	
	var _ggCircle = __webpack_require__(431);
	
	var _ggCircle2 = _interopRequireDefault(_ggCircle);
	
	var _gg = __webpack_require__(432);
	
	var _gg2 = _interopRequireDefault(_gg);
	
	var _gift = __webpack_require__(433);
	
	var _gift2 = _interopRequireDefault(_gift);
	
	var _gitSquare = __webpack_require__(434);
	
	var _gitSquare2 = _interopRequireDefault(_gitSquare);
	
	var _git = __webpack_require__(435);
	
	var _git2 = _interopRequireDefault(_git);
	
	var _githubAlt = __webpack_require__(436);
	
	var _githubAlt2 = _interopRequireDefault(_githubAlt);
	
	var _githubSquare = __webpack_require__(437);
	
	var _githubSquare2 = _interopRequireDefault(_githubSquare);
	
	var _github = __webpack_require__(438);
	
	var _github2 = _interopRequireDefault(_github);
	
	var _gitlab = __webpack_require__(439);
	
	var _gitlab2 = _interopRequireDefault(_gitlab);
	
	var _gittip = __webpack_require__(440);
	
	var _gittip2 = _interopRequireDefault(_gittip);
	
	var _glass = __webpack_require__(441);
	
	var _glass2 = _interopRequireDefault(_glass);
	
	var _glideG = __webpack_require__(442);
	
	var _glideG2 = _interopRequireDefault(_glideG);
	
	var _glide = __webpack_require__(443);
	
	var _glide2 = _interopRequireDefault(_glide);
	
	var _globe = __webpack_require__(444);
	
	var _globe2 = _interopRequireDefault(_globe);
	
	var _googlePlusSquare = __webpack_require__(445);
	
	var _googlePlusSquare2 = _interopRequireDefault(_googlePlusSquare);
	
	var _googlePlus = __webpack_require__(446);
	
	var _googlePlus2 = _interopRequireDefault(_googlePlus);
	
	var _googleWallet = __webpack_require__(447);
	
	var _googleWallet2 = _interopRequireDefault(_googleWallet);
	
	var _google = __webpack_require__(448);
	
	var _google2 = _interopRequireDefault(_google);
	
	var _graduationCap = __webpack_require__(449);
	
	var _graduationCap2 = _interopRequireDefault(_graduationCap);
	
	var _group = __webpack_require__(450);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _hSquare = __webpack_require__(451);
	
	var _hSquare2 = _interopRequireDefault(_hSquare);
	
	var _hackerNews = __webpack_require__(452);
	
	var _hackerNews2 = _interopRequireDefault(_hackerNews);
	
	var _handGrabO = __webpack_require__(453);
	
	var _handGrabO2 = _interopRequireDefault(_handGrabO);
	
	var _handLizardO = __webpack_require__(454);
	
	var _handLizardO2 = _interopRequireDefault(_handLizardO);
	
	var _handODown = __webpack_require__(455);
	
	var _handODown2 = _interopRequireDefault(_handODown);
	
	var _handOLeft = __webpack_require__(456);
	
	var _handOLeft2 = _interopRequireDefault(_handOLeft);
	
	var _handORight = __webpack_require__(457);
	
	var _handORight2 = _interopRequireDefault(_handORight);
	
	var _handOUp = __webpack_require__(458);
	
	var _handOUp2 = _interopRequireDefault(_handOUp);
	
	var _handPaperO = __webpack_require__(459);
	
	var _handPaperO2 = _interopRequireDefault(_handPaperO);
	
	var _handPeaceO = __webpack_require__(460);
	
	var _handPeaceO2 = _interopRequireDefault(_handPeaceO);
	
	var _handPointerO = __webpack_require__(461);
	
	var _handPointerO2 = _interopRequireDefault(_handPointerO);
	
	var _handScissorsO = __webpack_require__(462);
	
	var _handScissorsO2 = _interopRequireDefault(_handScissorsO);
	
	var _handSpockO = __webpack_require__(463);
	
	var _handSpockO2 = _interopRequireDefault(_handSpockO);
	
	var _hashtag = __webpack_require__(464);
	
	var _hashtag2 = _interopRequireDefault(_hashtag);
	
	var _hddO = __webpack_require__(465);
	
	var _hddO2 = _interopRequireDefault(_hddO);
	
	var _header = __webpack_require__(466);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _headphones = __webpack_require__(467);
	
	var _headphones2 = _interopRequireDefault(_headphones);
	
	var _heartO = __webpack_require__(468);
	
	var _heartO2 = _interopRequireDefault(_heartO);
	
	var _heart = __webpack_require__(469);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _heartbeat = __webpack_require__(470);
	
	var _heartbeat2 = _interopRequireDefault(_heartbeat);
	
	var _history = __webpack_require__(471);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _home = __webpack_require__(472);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _hospitalO = __webpack_require__(473);
	
	var _hospitalO2 = _interopRequireDefault(_hospitalO);
	
	var _hourglass = __webpack_require__(474);
	
	var _hourglass2 = _interopRequireDefault(_hourglass);
	
	var _hourglass3 = __webpack_require__(475);
	
	var _hourglass4 = _interopRequireDefault(_hourglass3);
	
	var _hourglass5 = __webpack_require__(476);
	
	var _hourglass6 = _interopRequireDefault(_hourglass5);
	
	var _hourglassO = __webpack_require__(477);
	
	var _hourglassO2 = _interopRequireDefault(_hourglassO);
	
	var _hourglass7 = __webpack_require__(478);
	
	var _hourglass8 = _interopRequireDefault(_hourglass7);
	
	var _houzz = __webpack_require__(479);
	
	var _houzz2 = _interopRequireDefault(_houzz);
	
	var _html = __webpack_require__(480);
	
	var _html2 = _interopRequireDefault(_html);
	
	var _iCursor = __webpack_require__(481);
	
	var _iCursor2 = _interopRequireDefault(_iCursor);
	
	var _ils = __webpack_require__(482);
	
	var _ils2 = _interopRequireDefault(_ils);
	
	var _image = __webpack_require__(483);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _inbox = __webpack_require__(484);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _indent = __webpack_require__(485);
	
	var _indent2 = _interopRequireDefault(_indent);
	
	var _industry = __webpack_require__(486);
	
	var _industry2 = _interopRequireDefault(_industry);
	
	var _infoCircle = __webpack_require__(487);
	
	var _infoCircle2 = _interopRequireDefault(_infoCircle);
	
	var _info = __webpack_require__(488);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _inr = __webpack_require__(489);
	
	var _inr2 = _interopRequireDefault(_inr);
	
	var _instagram = __webpack_require__(490);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _internetExplorer = __webpack_require__(491);
	
	var _internetExplorer2 = _interopRequireDefault(_internetExplorer);
	
	var _intersex = __webpack_require__(492);
	
	var _intersex2 = _interopRequireDefault(_intersex);
	
	var _ioxhost = __webpack_require__(493);
	
	var _ioxhost2 = _interopRequireDefault(_ioxhost);
	
	var _italic = __webpack_require__(494);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _joomla = __webpack_require__(495);
	
	var _joomla2 = _interopRequireDefault(_joomla);
	
	var _jsfiddle = __webpack_require__(496);
	
	var _jsfiddle2 = _interopRequireDefault(_jsfiddle);
	
	var _key = __webpack_require__(497);
	
	var _key2 = _interopRequireDefault(_key);
	
	var _keyboardO = __webpack_require__(498);
	
	var _keyboardO2 = _interopRequireDefault(_keyboardO);
	
	var _krw = __webpack_require__(499);
	
	var _krw2 = _interopRequireDefault(_krw);
	
	var _language = __webpack_require__(500);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _laptop = __webpack_require__(501);
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	var _lastfmSquare = __webpack_require__(502);
	
	var _lastfmSquare2 = _interopRequireDefault(_lastfmSquare);
	
	var _lastfm = __webpack_require__(503);
	
	var _lastfm2 = _interopRequireDefault(_lastfm);
	
	var _leaf = __webpack_require__(504);
	
	var _leaf2 = _interopRequireDefault(_leaf);
	
	var _leanpub = __webpack_require__(505);
	
	var _leanpub2 = _interopRequireDefault(_leanpub);
	
	var _lemonO = __webpack_require__(506);
	
	var _lemonO2 = _interopRequireDefault(_lemonO);
	
	var _levelDown = __webpack_require__(507);
	
	var _levelDown2 = _interopRequireDefault(_levelDown);
	
	var _levelUp = __webpack_require__(508);
	
	var _levelUp2 = _interopRequireDefault(_levelUp);
	
	var _lifeBouy = __webpack_require__(509);
	
	var _lifeBouy2 = _interopRequireDefault(_lifeBouy);
	
	var _lightbulbO = __webpack_require__(510);
	
	var _lightbulbO2 = _interopRequireDefault(_lightbulbO);
	
	var _lineChart = __webpack_require__(511);
	
	var _lineChart2 = _interopRequireDefault(_lineChart);
	
	var _linkedinSquare = __webpack_require__(512);
	
	var _linkedinSquare2 = _interopRequireDefault(_linkedinSquare);
	
	var _linkedin = __webpack_require__(513);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _linux = __webpack_require__(514);
	
	var _linux2 = _interopRequireDefault(_linux);
	
	var _listAlt = __webpack_require__(515);
	
	var _listAlt2 = _interopRequireDefault(_listAlt);
	
	var _listOl = __webpack_require__(516);
	
	var _listOl2 = _interopRequireDefault(_listOl);
	
	var _listUl = __webpack_require__(517);
	
	var _listUl2 = _interopRequireDefault(_listUl);
	
	var _list = __webpack_require__(518);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _locationArrow = __webpack_require__(519);
	
	var _locationArrow2 = _interopRequireDefault(_locationArrow);
	
	var _lock = __webpack_require__(520);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _longArrowDown = __webpack_require__(521);
	
	var _longArrowDown2 = _interopRequireDefault(_longArrowDown);
	
	var _longArrowLeft = __webpack_require__(522);
	
	var _longArrowLeft2 = _interopRequireDefault(_longArrowLeft);
	
	var _longArrowRight = __webpack_require__(523);
	
	var _longArrowRight2 = _interopRequireDefault(_longArrowRight);
	
	var _longArrowUp = __webpack_require__(524);
	
	var _longArrowUp2 = _interopRequireDefault(_longArrowUp);
	
	var _lowVision = __webpack_require__(525);
	
	var _lowVision2 = _interopRequireDefault(_lowVision);
	
	var _magic = __webpack_require__(526);
	
	var _magic2 = _interopRequireDefault(_magic);
	
	var _magnet = __webpack_require__(527);
	
	var _magnet2 = _interopRequireDefault(_magnet);
	
	var _mailForward = __webpack_require__(528);
	
	var _mailForward2 = _interopRequireDefault(_mailForward);
	
	var _mailReplyAll = __webpack_require__(529);
	
	var _mailReplyAll2 = _interopRequireDefault(_mailReplyAll);
	
	var _mailReply = __webpack_require__(530);
	
	var _mailReply2 = _interopRequireDefault(_mailReply);
	
	var _male = __webpack_require__(531);
	
	var _male2 = _interopRequireDefault(_male);
	
	var _mapMarker = __webpack_require__(532);
	
	var _mapMarker2 = _interopRequireDefault(_mapMarker);
	
	var _mapO = __webpack_require__(533);
	
	var _mapO2 = _interopRequireDefault(_mapO);
	
	var _mapPin = __webpack_require__(534);
	
	var _mapPin2 = _interopRequireDefault(_mapPin);
	
	var _mapSigns = __webpack_require__(535);
	
	var _mapSigns2 = _interopRequireDefault(_mapSigns);
	
	var _map = __webpack_require__(536);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _marsDouble = __webpack_require__(537);
	
	var _marsDouble2 = _interopRequireDefault(_marsDouble);
	
	var _marsStrokeH = __webpack_require__(538);
	
	var _marsStrokeH2 = _interopRequireDefault(_marsStrokeH);
	
	var _marsStrokeV = __webpack_require__(539);
	
	var _marsStrokeV2 = _interopRequireDefault(_marsStrokeV);
	
	var _marsStroke = __webpack_require__(540);
	
	var _marsStroke2 = _interopRequireDefault(_marsStroke);
	
	var _mars = __webpack_require__(541);
	
	var _mars2 = _interopRequireDefault(_mars);
	
	var _maxcdn = __webpack_require__(542);
	
	var _maxcdn2 = _interopRequireDefault(_maxcdn);
	
	var _meanpath = __webpack_require__(543);
	
	var _meanpath2 = _interopRequireDefault(_meanpath);
	
	var _medium = __webpack_require__(544);
	
	var _medium2 = _interopRequireDefault(_medium);
	
	var _medkit = __webpack_require__(545);
	
	var _medkit2 = _interopRequireDefault(_medkit);
	
	var _mehO = __webpack_require__(546);
	
	var _mehO2 = _interopRequireDefault(_mehO);
	
	var _mercury = __webpack_require__(547);
	
	var _mercury2 = _interopRequireDefault(_mercury);
	
	var _microphoneSlash = __webpack_require__(548);
	
	var _microphoneSlash2 = _interopRequireDefault(_microphoneSlash);
	
	var _microphone = __webpack_require__(549);
	
	var _microphone2 = _interopRequireDefault(_microphone);
	
	var _minusCircle = __webpack_require__(550);
	
	var _minusCircle2 = _interopRequireDefault(_minusCircle);
	
	var _minusSquareO = __webpack_require__(551);
	
	var _minusSquareO2 = _interopRequireDefault(_minusSquareO);
	
	var _minusSquare = __webpack_require__(552);
	
	var _minusSquare2 = _interopRequireDefault(_minusSquare);
	
	var _minus = __webpack_require__(553);
	
	var _minus2 = _interopRequireDefault(_minus);
	
	var _mixcloud = __webpack_require__(554);
	
	var _mixcloud2 = _interopRequireDefault(_mixcloud);
	
	var _mobile = __webpack_require__(555);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	var _modx = __webpack_require__(556);
	
	var _modx2 = _interopRequireDefault(_modx);
	
	var _money = __webpack_require__(557);
	
	var _money2 = _interopRequireDefault(_money);
	
	var _moonO = __webpack_require__(558);
	
	var _moonO2 = _interopRequireDefault(_moonO);
	
	var _motorcycle = __webpack_require__(559);
	
	var _motorcycle2 = _interopRequireDefault(_motorcycle);
	
	var _mousePointer = __webpack_require__(560);
	
	var _mousePointer2 = _interopRequireDefault(_mousePointer);
	
	var _music = __webpack_require__(561);
	
	var _music2 = _interopRequireDefault(_music);
	
	var _neuter = __webpack_require__(562);
	
	var _neuter2 = _interopRequireDefault(_neuter);
	
	var _newspaperO = __webpack_require__(563);
	
	var _newspaperO2 = _interopRequireDefault(_newspaperO);
	
	var _objectGroup = __webpack_require__(564);
	
	var _objectGroup2 = _interopRequireDefault(_objectGroup);
	
	var _objectUngroup = __webpack_require__(565);
	
	var _objectUngroup2 = _interopRequireDefault(_objectUngroup);
	
	var _odnoklassnikiSquare = __webpack_require__(566);
	
	var _odnoklassnikiSquare2 = _interopRequireDefault(_odnoklassnikiSquare);
	
	var _odnoklassniki = __webpack_require__(567);
	
	var _odnoklassniki2 = _interopRequireDefault(_odnoklassniki);
	
	var _opencart = __webpack_require__(568);
	
	var _opencart2 = _interopRequireDefault(_opencart);
	
	var _openid = __webpack_require__(569);
	
	var _openid2 = _interopRequireDefault(_openid);
	
	var _opera = __webpack_require__(570);
	
	var _opera2 = _interopRequireDefault(_opera);
	
	var _optinMonster = __webpack_require__(571);
	
	var _optinMonster2 = _interopRequireDefault(_optinMonster);
	
	var _pagelines = __webpack_require__(572);
	
	var _pagelines2 = _interopRequireDefault(_pagelines);
	
	var _paintBrush = __webpack_require__(573);
	
	var _paintBrush2 = _interopRequireDefault(_paintBrush);
	
	var _paperPlaneO = __webpack_require__(574);
	
	var _paperPlaneO2 = _interopRequireDefault(_paperPlaneO);
	
	var _paperPlane = __webpack_require__(575);
	
	var _paperPlane2 = _interopRequireDefault(_paperPlane);
	
	var _paperclip = __webpack_require__(576);
	
	var _paperclip2 = _interopRequireDefault(_paperclip);
	
	var _paragraph = __webpack_require__(577);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _pauseCircleO = __webpack_require__(578);
	
	var _pauseCircleO2 = _interopRequireDefault(_pauseCircleO);
	
	var _pauseCircle = __webpack_require__(579);
	
	var _pauseCircle2 = _interopRequireDefault(_pauseCircle);
	
	var _pause = __webpack_require__(580);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _paw = __webpack_require__(581);
	
	var _paw2 = _interopRequireDefault(_paw);
	
	var _paypal = __webpack_require__(582);
	
	var _paypal2 = _interopRequireDefault(_paypal);
	
	var _pencilSquare = __webpack_require__(583);
	
	var _pencilSquare2 = _interopRequireDefault(_pencilSquare);
	
	var _pencil = __webpack_require__(584);
	
	var _pencil2 = _interopRequireDefault(_pencil);
	
	var _percent = __webpack_require__(585);
	
	var _percent2 = _interopRequireDefault(_percent);
	
	var _phoneSquare = __webpack_require__(586);
	
	var _phoneSquare2 = _interopRequireDefault(_phoneSquare);
	
	var _phone = __webpack_require__(587);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _pieChart = __webpack_require__(588);
	
	var _pieChart2 = _interopRequireDefault(_pieChart);
	
	var _piedPiperAlt = __webpack_require__(589);
	
	var _piedPiperAlt2 = _interopRequireDefault(_piedPiperAlt);
	
	var _piedPiper = __webpack_require__(590);
	
	var _piedPiper2 = _interopRequireDefault(_piedPiper);
	
	var _pinterestP = __webpack_require__(591);
	
	var _pinterestP2 = _interopRequireDefault(_pinterestP);
	
	var _pinterestSquare = __webpack_require__(592);
	
	var _pinterestSquare2 = _interopRequireDefault(_pinterestSquare);
	
	var _pinterest = __webpack_require__(593);
	
	var _pinterest2 = _interopRequireDefault(_pinterest);
	
	var _plane = __webpack_require__(594);
	
	var _plane2 = _interopRequireDefault(_plane);
	
	var _playCircleO = __webpack_require__(595);
	
	var _playCircleO2 = _interopRequireDefault(_playCircleO);
	
	var _playCircle = __webpack_require__(596);
	
	var _playCircle2 = _interopRequireDefault(_playCircle);
	
	var _play = __webpack_require__(597);
	
	var _play2 = _interopRequireDefault(_play);
	
	var _plug = __webpack_require__(598);
	
	var _plug2 = _interopRequireDefault(_plug);
	
	var _plusCircle = __webpack_require__(599);
	
	var _plusCircle2 = _interopRequireDefault(_plusCircle);
	
	var _plusSquareO = __webpack_require__(600);
	
	var _plusSquareO2 = _interopRequireDefault(_plusSquareO);
	
	var _plusSquare = __webpack_require__(601);
	
	var _plusSquare2 = _interopRequireDefault(_plusSquare);
	
	var _plus = __webpack_require__(602);
	
	var _plus2 = _interopRequireDefault(_plus);
	
	var _powerOff = __webpack_require__(603);
	
	var _powerOff2 = _interopRequireDefault(_powerOff);
	
	var _print = __webpack_require__(604);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _productHunt = __webpack_require__(605);
	
	var _productHunt2 = _interopRequireDefault(_productHunt);
	
	var _puzzlePiece = __webpack_require__(606);
	
	var _puzzlePiece2 = _interopRequireDefault(_puzzlePiece);
	
	var _qq = __webpack_require__(607);
	
	var _qq2 = _interopRequireDefault(_qq);
	
	var _qrcode = __webpack_require__(608);
	
	var _qrcode2 = _interopRequireDefault(_qrcode);
	
	var _questionCircleO = __webpack_require__(609);
	
	var _questionCircleO2 = _interopRequireDefault(_questionCircleO);
	
	var _questionCircle = __webpack_require__(610);
	
	var _questionCircle2 = _interopRequireDefault(_questionCircle);
	
	var _question = __webpack_require__(611);
	
	var _question2 = _interopRequireDefault(_question);
	
	var _quoteLeft = __webpack_require__(612);
	
	var _quoteLeft2 = _interopRequireDefault(_quoteLeft);
	
	var _quoteRight = __webpack_require__(613);
	
	var _quoteRight2 = _interopRequireDefault(_quoteRight);
	
	var _ra = __webpack_require__(614);
	
	var _ra2 = _interopRequireDefault(_ra);
	
	var _random = __webpack_require__(615);
	
	var _random2 = _interopRequireDefault(_random);
	
	var _recycle = __webpack_require__(616);
	
	var _recycle2 = _interopRequireDefault(_recycle);
	
	var _redditAlien = __webpack_require__(617);
	
	var _redditAlien2 = _interopRequireDefault(_redditAlien);
	
	var _redditSquare = __webpack_require__(618);
	
	var _redditSquare2 = _interopRequireDefault(_redditSquare);
	
	var _reddit = __webpack_require__(619);
	
	var _reddit2 = _interopRequireDefault(_reddit);
	
	var _refresh = __webpack_require__(620);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _registered = __webpack_require__(621);
	
	var _registered2 = _interopRequireDefault(_registered);
	
	var _renren = __webpack_require__(622);
	
	var _renren2 = _interopRequireDefault(_renren);
	
	var _repeat = __webpack_require__(623);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _retweet = __webpack_require__(624);
	
	var _retweet2 = _interopRequireDefault(_retweet);
	
	var _road = __webpack_require__(625);
	
	var _road2 = _interopRequireDefault(_road);
	
	var _rocket = __webpack_require__(626);
	
	var _rocket2 = _interopRequireDefault(_rocket);
	
	var _rotateLeft = __webpack_require__(627);
	
	var _rotateLeft2 = _interopRequireDefault(_rotateLeft);
	
	var _rouble = __webpack_require__(628);
	
	var _rouble2 = _interopRequireDefault(_rouble);
	
	var _rssSquare = __webpack_require__(629);
	
	var _rssSquare2 = _interopRequireDefault(_rssSquare);
	
	var _safari = __webpack_require__(630);
	
	var _safari2 = _interopRequireDefault(_safari);
	
	var _scribd = __webpack_require__(631);
	
	var _scribd2 = _interopRequireDefault(_scribd);
	
	var _searchMinus = __webpack_require__(632);
	
	var _searchMinus2 = _interopRequireDefault(_searchMinus);
	
	var _searchPlus = __webpack_require__(633);
	
	var _searchPlus2 = _interopRequireDefault(_searchPlus);
	
	var _search = __webpack_require__(634);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _sellsy = __webpack_require__(635);
	
	var _sellsy2 = _interopRequireDefault(_sellsy);
	
	var _server = __webpack_require__(636);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _shareAltSquare = __webpack_require__(637);
	
	var _shareAltSquare2 = _interopRequireDefault(_shareAltSquare);
	
	var _shareAlt = __webpack_require__(638);
	
	var _shareAlt2 = _interopRequireDefault(_shareAlt);
	
	var _shareSquareO = __webpack_require__(639);
	
	var _shareSquareO2 = _interopRequireDefault(_shareSquareO);
	
	var _shareSquare = __webpack_require__(640);
	
	var _shareSquare2 = _interopRequireDefault(_shareSquare);
	
	var _shield = __webpack_require__(641);
	
	var _shield2 = _interopRequireDefault(_shield);
	
	var _ship = __webpack_require__(642);
	
	var _ship2 = _interopRequireDefault(_ship);
	
	var _shirtsinbulk = __webpack_require__(643);
	
	var _shirtsinbulk2 = _interopRequireDefault(_shirtsinbulk);
	
	var _shoppingBag = __webpack_require__(644);
	
	var _shoppingBag2 = _interopRequireDefault(_shoppingBag);
	
	var _shoppingBasket = __webpack_require__(645);
	
	var _shoppingBasket2 = _interopRequireDefault(_shoppingBasket);
	
	var _shoppingCart = __webpack_require__(646);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _signIn = __webpack_require__(647);
	
	var _signIn2 = _interopRequireDefault(_signIn);
	
	var _signLanguage = __webpack_require__(648);
	
	var _signLanguage2 = _interopRequireDefault(_signLanguage);
	
	var _signOut = __webpack_require__(649);
	
	var _signOut2 = _interopRequireDefault(_signOut);
	
	var _signal = __webpack_require__(650);
	
	var _signal2 = _interopRequireDefault(_signal);
	
	var _simplybuilt = __webpack_require__(651);
	
	var _simplybuilt2 = _interopRequireDefault(_simplybuilt);
	
	var _sitemap = __webpack_require__(652);
	
	var _sitemap2 = _interopRequireDefault(_sitemap);
	
	var _skyatlas = __webpack_require__(653);
	
	var _skyatlas2 = _interopRequireDefault(_skyatlas);
	
	var _skype = __webpack_require__(654);
	
	var _skype2 = _interopRequireDefault(_skype);
	
	var _slack = __webpack_require__(655);
	
	var _slack2 = _interopRequireDefault(_slack);
	
	var _sliders = __webpack_require__(656);
	
	var _sliders2 = _interopRequireDefault(_sliders);
	
	var _slideshare = __webpack_require__(657);
	
	var _slideshare2 = _interopRequireDefault(_slideshare);
	
	var _smileO = __webpack_require__(658);
	
	var _smileO2 = _interopRequireDefault(_smileO);
	
	var _snapchatGhost = __webpack_require__(659);
	
	var _snapchatGhost2 = _interopRequireDefault(_snapchatGhost);
	
	var _snapchatSquare = __webpack_require__(660);
	
	var _snapchatSquare2 = _interopRequireDefault(_snapchatSquare);
	
	var _snapchat = __webpack_require__(661);
	
	var _snapchat2 = _interopRequireDefault(_snapchat);
	
	var _sortAlphaAsc = __webpack_require__(662);
	
	var _sortAlphaAsc2 = _interopRequireDefault(_sortAlphaAsc);
	
	var _sortAlphaDesc = __webpack_require__(663);
	
	var _sortAlphaDesc2 = _interopRequireDefault(_sortAlphaDesc);
	
	var _sortAmountAsc = __webpack_require__(664);
	
	var _sortAmountAsc2 = _interopRequireDefault(_sortAmountAsc);
	
	var _sortAmountDesc = __webpack_require__(665);
	
	var _sortAmountDesc2 = _interopRequireDefault(_sortAmountDesc);
	
	var _sortAsc = __webpack_require__(666);
	
	var _sortAsc2 = _interopRequireDefault(_sortAsc);
	
	var _sortDesc = __webpack_require__(667);
	
	var _sortDesc2 = _interopRequireDefault(_sortDesc);
	
	var _sortNumericAsc = __webpack_require__(668);
	
	var _sortNumericAsc2 = _interopRequireDefault(_sortNumericAsc);
	
	var _sortNumericDesc = __webpack_require__(669);
	
	var _sortNumericDesc2 = _interopRequireDefault(_sortNumericDesc);
	
	var _sort = __webpack_require__(670);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _soundcloud = __webpack_require__(671);
	
	var _soundcloud2 = _interopRequireDefault(_soundcloud);
	
	var _spaceShuttle = __webpack_require__(672);
	
	var _spaceShuttle2 = _interopRequireDefault(_spaceShuttle);
	
	var _spinner = __webpack_require__(673);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _spoon = __webpack_require__(674);
	
	var _spoon2 = _interopRequireDefault(_spoon);
	
	var _spotify = __webpack_require__(675);
	
	var _spotify2 = _interopRequireDefault(_spotify);
	
	var _squareO = __webpack_require__(676);
	
	var _squareO2 = _interopRequireDefault(_squareO);
	
	var _square = __webpack_require__(677);
	
	var _square2 = _interopRequireDefault(_square);
	
	var _stackExchange = __webpack_require__(678);
	
	var _stackExchange2 = _interopRequireDefault(_stackExchange);
	
	var _stackOverflow = __webpack_require__(679);
	
	var _stackOverflow2 = _interopRequireDefault(_stackOverflow);
	
	var _starHalfEmpty = __webpack_require__(680);
	
	var _starHalfEmpty2 = _interopRequireDefault(_starHalfEmpty);
	
	var _starHalf = __webpack_require__(681);
	
	var _starHalf2 = _interopRequireDefault(_starHalf);
	
	var _starO = __webpack_require__(682);
	
	var _starO2 = _interopRequireDefault(_starO);
	
	var _star = __webpack_require__(683);
	
	var _star2 = _interopRequireDefault(_star);
	
	var _steamSquare = __webpack_require__(684);
	
	var _steamSquare2 = _interopRequireDefault(_steamSquare);
	
	var _steam = __webpack_require__(685);
	
	var _steam2 = _interopRequireDefault(_steam);
	
	var _stepBackward = __webpack_require__(686);
	
	var _stepBackward2 = _interopRequireDefault(_stepBackward);
	
	var _stepForward = __webpack_require__(687);
	
	var _stepForward2 = _interopRequireDefault(_stepForward);
	
	var _stethoscope = __webpack_require__(688);
	
	var _stethoscope2 = _interopRequireDefault(_stethoscope);
	
	var _stickyNoteO = __webpack_require__(689);
	
	var _stickyNoteO2 = _interopRequireDefault(_stickyNoteO);
	
	var _stickyNote = __webpack_require__(690);
	
	var _stickyNote2 = _interopRequireDefault(_stickyNote);
	
	var _stopCircleO = __webpack_require__(691);
	
	var _stopCircleO2 = _interopRequireDefault(_stopCircleO);
	
	var _stopCircle = __webpack_require__(692);
	
	var _stopCircle2 = _interopRequireDefault(_stopCircle);
	
	var _stop = __webpack_require__(693);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _streetView = __webpack_require__(694);
	
	var _streetView2 = _interopRequireDefault(_streetView);
	
	var _strikethrough = __webpack_require__(695);
	
	var _strikethrough2 = _interopRequireDefault(_strikethrough);
	
	var _stumbleuponCircle = __webpack_require__(696);
	
	var _stumbleuponCircle2 = _interopRequireDefault(_stumbleuponCircle);
	
	var _stumbleupon = __webpack_require__(697);
	
	var _stumbleupon2 = _interopRequireDefault(_stumbleupon);
	
	var _subscript = __webpack_require__(698);
	
	var _subscript2 = _interopRequireDefault(_subscript);
	
	var _subway = __webpack_require__(699);
	
	var _subway2 = _interopRequireDefault(_subway);
	
	var _suitcase = __webpack_require__(700);
	
	var _suitcase2 = _interopRequireDefault(_suitcase);
	
	var _sunO = __webpack_require__(701);
	
	var _sunO2 = _interopRequireDefault(_sunO);
	
	var _superscript = __webpack_require__(702);
	
	var _superscript2 = _interopRequireDefault(_superscript);
	
	var _table = __webpack_require__(703);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _tablet = __webpack_require__(704);
	
	var _tablet2 = _interopRequireDefault(_tablet);
	
	var _tag = __webpack_require__(705);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _tags = __webpack_require__(706);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _tasks = __webpack_require__(707);
	
	var _tasks2 = _interopRequireDefault(_tasks);
	
	var _television = __webpack_require__(708);
	
	var _television2 = _interopRequireDefault(_television);
	
	var _tencentWeibo = __webpack_require__(709);
	
	var _tencentWeibo2 = _interopRequireDefault(_tencentWeibo);
	
	var _terminal = __webpack_require__(710);
	
	var _terminal2 = _interopRequireDefault(_terminal);
	
	var _textHeight = __webpack_require__(711);
	
	var _textHeight2 = _interopRequireDefault(_textHeight);
	
	var _textWidth = __webpack_require__(712);
	
	var _textWidth2 = _interopRequireDefault(_textWidth);
	
	var _thLarge = __webpack_require__(713);
	
	var _thLarge2 = _interopRequireDefault(_thLarge);
	
	var _thList = __webpack_require__(714);
	
	var _thList2 = _interopRequireDefault(_thList);
	
	var _th = __webpack_require__(715);
	
	var _th2 = _interopRequireDefault(_th);
	
	var _thumbTack = __webpack_require__(716);
	
	var _thumbTack2 = _interopRequireDefault(_thumbTack);
	
	var _thumbsDown = __webpack_require__(717);
	
	var _thumbsDown2 = _interopRequireDefault(_thumbsDown);
	
	var _thumbsODown = __webpack_require__(718);
	
	var _thumbsODown2 = _interopRequireDefault(_thumbsODown);
	
	var _thumbsOUp = __webpack_require__(719);
	
	var _thumbsOUp2 = _interopRequireDefault(_thumbsOUp);
	
	var _thumbsUp = __webpack_require__(720);
	
	var _thumbsUp2 = _interopRequireDefault(_thumbsUp);
	
	var _ticket = __webpack_require__(721);
	
	var _ticket2 = _interopRequireDefault(_ticket);
	
	var _timesCircleO = __webpack_require__(722);
	
	var _timesCircleO2 = _interopRequireDefault(_timesCircleO);
	
	var _timesCircle = __webpack_require__(723);
	
	var _timesCircle2 = _interopRequireDefault(_timesCircle);
	
	var _tint = __webpack_require__(724);
	
	var _tint2 = _interopRequireDefault(_tint);
	
	var _toggleOff = __webpack_require__(725);
	
	var _toggleOff2 = _interopRequireDefault(_toggleOff);
	
	var _toggleOn = __webpack_require__(726);
	
	var _toggleOn2 = _interopRequireDefault(_toggleOn);
	
	var _trademark = __webpack_require__(727);
	
	var _trademark2 = _interopRequireDefault(_trademark);
	
	var _train = __webpack_require__(728);
	
	var _train2 = _interopRequireDefault(_train);
	
	var _transgenderAlt = __webpack_require__(729);
	
	var _transgenderAlt2 = _interopRequireDefault(_transgenderAlt);
	
	var _trashO = __webpack_require__(730);
	
	var _trashO2 = _interopRequireDefault(_trashO);
	
	var _trash = __webpack_require__(731);
	
	var _trash2 = _interopRequireDefault(_trash);
	
	var _tree = __webpack_require__(732);
	
	var _tree2 = _interopRequireDefault(_tree);
	
	var _trello = __webpack_require__(733);
	
	var _trello2 = _interopRequireDefault(_trello);
	
	var _tripadvisor = __webpack_require__(734);
	
	var _tripadvisor2 = _interopRequireDefault(_tripadvisor);
	
	var _trophy = __webpack_require__(735);
	
	var _trophy2 = _interopRequireDefault(_trophy);
	
	var _truck = __webpack_require__(736);
	
	var _truck2 = _interopRequireDefault(_truck);
	
	var _try = __webpack_require__(737);
	
	var _try2 = _interopRequireDefault(_try);
	
	var _tty = __webpack_require__(738);
	
	var _tty2 = _interopRequireDefault(_tty);
	
	var _tumblrSquare = __webpack_require__(739);
	
	var _tumblrSquare2 = _interopRequireDefault(_tumblrSquare);
	
	var _tumblr = __webpack_require__(740);
	
	var _tumblr2 = _interopRequireDefault(_tumblr);
	
	var _twitch = __webpack_require__(741);
	
	var _twitch2 = _interopRequireDefault(_twitch);
	
	var _twitterSquare = __webpack_require__(742);
	
	var _twitterSquare2 = _interopRequireDefault(_twitterSquare);
	
	var _twitter = __webpack_require__(743);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _umbrella = __webpack_require__(744);
	
	var _umbrella2 = _interopRequireDefault(_umbrella);
	
	var _underline = __webpack_require__(745);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _universalAccess = __webpack_require__(746);
	
	var _universalAccess2 = _interopRequireDefault(_universalAccess);
	
	var _unlockAlt = __webpack_require__(747);
	
	var _unlockAlt2 = _interopRequireDefault(_unlockAlt);
	
	var _unlock = __webpack_require__(748);
	
	var _unlock2 = _interopRequireDefault(_unlock);
	
	var _upload = __webpack_require__(749);
	
	var _upload2 = _interopRequireDefault(_upload);
	
	var _usb = __webpack_require__(750);
	
	var _usb2 = _interopRequireDefault(_usb);
	
	var _userMd = __webpack_require__(751);
	
	var _userMd2 = _interopRequireDefault(_userMd);
	
	var _userPlus = __webpack_require__(752);
	
	var _userPlus2 = _interopRequireDefault(_userPlus);
	
	var _userSecret = __webpack_require__(753);
	
	var _userSecret2 = _interopRequireDefault(_userSecret);
	
	var _userTimes = __webpack_require__(754);
	
	var _userTimes2 = _interopRequireDefault(_userTimes);
	
	var _user = __webpack_require__(755);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _venusDouble = __webpack_require__(756);
	
	var _venusDouble2 = _interopRequireDefault(_venusDouble);
	
	var _venusMars = __webpack_require__(757);
	
	var _venusMars2 = _interopRequireDefault(_venusMars);
	
	var _venus = __webpack_require__(758);
	
	var _venus2 = _interopRequireDefault(_venus);
	
	var _viacoin = __webpack_require__(759);
	
	var _viacoin2 = _interopRequireDefault(_viacoin);
	
	var _viadeoSquare = __webpack_require__(760);
	
	var _viadeoSquare2 = _interopRequireDefault(_viadeoSquare);
	
	var _viadeo = __webpack_require__(761);
	
	var _viadeo2 = _interopRequireDefault(_viadeo);
	
	var _videoCamera = __webpack_require__(762);
	
	var _videoCamera2 = _interopRequireDefault(_videoCamera);
	
	var _vimeoSquare = __webpack_require__(763);
	
	var _vimeoSquare2 = _interopRequireDefault(_vimeoSquare);
	
	var _vimeo = __webpack_require__(764);
	
	var _vimeo2 = _interopRequireDefault(_vimeo);
	
	var _vine = __webpack_require__(765);
	
	var _vine2 = _interopRequireDefault(_vine);
	
	var _vk = __webpack_require__(766);
	
	var _vk2 = _interopRequireDefault(_vk);
	
	var _volumeControlPhone = __webpack_require__(767);
	
	var _volumeControlPhone2 = _interopRequireDefault(_volumeControlPhone);
	
	var _volumeDown = __webpack_require__(768);
	
	var _volumeDown2 = _interopRequireDefault(_volumeDown);
	
	var _volumeOff = __webpack_require__(769);
	
	var _volumeOff2 = _interopRequireDefault(_volumeOff);
	
	var _volumeUp = __webpack_require__(770);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _wechat = __webpack_require__(771);
	
	var _wechat2 = _interopRequireDefault(_wechat);
	
	var _weibo = __webpack_require__(772);
	
	var _weibo2 = _interopRequireDefault(_weibo);
	
	var _whatsapp = __webpack_require__(773);
	
	var _whatsapp2 = _interopRequireDefault(_whatsapp);
	
	var _wheelchairAlt = __webpack_require__(774);
	
	var _wheelchairAlt2 = _interopRequireDefault(_wheelchairAlt);
	
	var _wheelchair = __webpack_require__(775);
	
	var _wheelchair2 = _interopRequireDefault(_wheelchair);
	
	var _wifi = __webpack_require__(776);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _wikipediaW = __webpack_require__(777);
	
	var _wikipediaW2 = _interopRequireDefault(_wikipediaW);
	
	var _windows = __webpack_require__(778);
	
	var _windows2 = _interopRequireDefault(_windows);
	
	var _wordpress = __webpack_require__(779);
	
	var _wordpress2 = _interopRequireDefault(_wordpress);
	
	var _wpbeginner = __webpack_require__(780);
	
	var _wpbeginner2 = _interopRequireDefault(_wpbeginner);
	
	var _wpforms = __webpack_require__(781);
	
	var _wpforms2 = _interopRequireDefault(_wpforms);
	
	var _wrench = __webpack_require__(782);
	
	var _wrench2 = _interopRequireDefault(_wrench);
	
	var _xingSquare = __webpack_require__(783);
	
	var _xingSquare2 = _interopRequireDefault(_xingSquare);
	
	var _xing = __webpack_require__(784);
	
	var _xing2 = _interopRequireDefault(_xing);
	
	var _yCombinator = __webpack_require__(785);
	
	var _yCombinator2 = _interopRequireDefault(_yCombinator);
	
	var _yahoo = __webpack_require__(786);
	
	var _yahoo2 = _interopRequireDefault(_yahoo);
	
	var _yelp = __webpack_require__(787);
	
	var _yelp2 = _interopRequireDefault(_yelp);
	
	var _youtubePlay = __webpack_require__(788);
	
	var _youtubePlay2 = _interopRequireDefault(_youtubePlay);
	
	var _youtubeSquare = __webpack_require__(789);
	
	var _youtubeSquare2 = _interopRequireDefault(_youtubeSquare);
	
	var _youtube = __webpack_require__(790);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Fa500px = _px2.default;
	exports.FaAdjust = _adjust2.default;
	exports.FaAdn = _adn2.default;
	exports.FaAlignCenter = _alignCenter2.default;
	exports.FaAlignJustify = _alignJustify2.default;
	exports.FaAlignLeft = _alignLeft2.default;
	exports.FaAlignRight = _alignRight2.default;
	exports.FaAmazon = _amazon2.default;
	exports.FaAmbulance = _ambulance2.default;
	exports.FaAmericanSignLanguageInterpreting = _americanSignLanguageInterpreting2.default;
	exports.FaAnchor = _anchor2.default;
	exports.FaAndroid = _android2.default;
	exports.FaAngellist = _angellist2.default;
	exports.FaAngleDoubleDown = _angleDoubleDown2.default;
	exports.FaAngleDoubleLeft = _angleDoubleLeft2.default;
	exports.FaAngleDoubleRight = _angleDoubleRight2.default;
	exports.FaAngleDoubleUp = _angleDoubleUp2.default;
	exports.FaAngleDown = _angleDown2.default;
	exports.FaAngleLeft = _angleLeft2.default;
	exports.FaAngleRight = _angleRight2.default;
	exports.FaAngleUp = _angleUp2.default;
	exports.FaApple = _apple2.default;
	exports.FaArchive = _archive2.default;
	exports.FaAreaChart = _areaChart2.default;
	exports.FaArrowCircleDown = _arrowCircleDown2.default;
	exports.FaArrowCircleLeft = _arrowCircleLeft2.default;
	exports.FaArrowCircleODown = _arrowCircleODown2.default;
	exports.FaArrowCircleOLeft = _arrowCircleOLeft2.default;
	exports.FaArrowCircleORight = _arrowCircleORight2.default;
	exports.FaArrowCircleOUp = _arrowCircleOUp2.default;
	exports.FaArrowCircleRight = _arrowCircleRight2.default;
	exports.FaArrowCircleUp = _arrowCircleUp2.default;
	exports.FaArrowDown = _arrowDown2.default;
	exports.FaArrowLeft = _arrowLeft2.default;
	exports.FaArrowRight = _arrowRight2.default;
	exports.FaArrowUp = _arrowUp2.default;
	exports.FaArrowsAlt = _arrowsAlt2.default;
	exports.FaArrowsH = _arrowsH2.default;
	exports.FaArrowsV = _arrowsV2.default;
	exports.FaArrows = _arrows2.default;
	exports.FaAssistiveListeningSystems = _assistiveListeningSystems2.default;
	exports.FaAsterisk = _asterisk2.default;
	exports.FaAt = _at2.default;
	exports.FaAudioDescription = _audioDescription2.default;
	exports.FaAutomobile = _automobile2.default;
	exports.FaBackward = _backward2.default;
	exports.FaBalanceScale = _balanceScale2.default;
	exports.FaBan = _ban2.default;
	exports.FaBank = _bank2.default;
	exports.FaBarChart = _barChart2.default;
	exports.FaBarcode = _barcode2.default;
	exports.FaBars = _bars2.default;
	exports.FaBattery0 = _battery2.default;
	exports.FaBattery1 = _battery4.default;
	exports.FaBattery2 = _battery6.default;
	exports.FaBattery3 = _battery8.default;
	exports.FaBattery4 = _battery10.default;
	exports.FaBed = _bed2.default;
	exports.FaBeer = _beer2.default;
	exports.FaBehanceSquare = _behanceSquare2.default;
	exports.FaBehance = _behance2.default;
	exports.FaBellO = _bellO2.default;
	exports.FaBellSlashO = _bellSlashO2.default;
	exports.FaBellSlash = _bellSlash2.default;
	exports.FaBell = _bell2.default;
	exports.FaBicycle = _bicycle2.default;
	exports.FaBinoculars = _binoculars2.default;
	exports.FaBirthdayCake = _birthdayCake2.default;
	exports.FaBitbucketSquare = _bitbucketSquare2.default;
	exports.FaBitbucket = _bitbucket2.default;
	exports.FaBitcoin = _bitcoin2.default;
	exports.FaBlackTie = _blackTie2.default;
	exports.FaBlind = _blind2.default;
	exports.FaBluetoothB = _bluetoothB2.default;
	exports.FaBluetooth = _bluetooth2.default;
	exports.FaBold = _bold2.default;
	exports.FaBolt = _bolt2.default;
	exports.FaBomb = _bomb2.default;
	exports.FaBook = _book2.default;
	exports.FaBookmarkO = _bookmarkO2.default;
	exports.FaBookmark = _bookmark2.default;
	exports.FaBraille = _braille2.default;
	exports.FaBriefcase = _briefcase2.default;
	exports.FaBug = _bug2.default;
	exports.FaBuildingO = _buildingO2.default;
	exports.FaBuilding = _building2.default;
	exports.FaBullhorn = _bullhorn2.default;
	exports.FaBullseye = _bullseye2.default;
	exports.FaBus = _bus2.default;
	exports.FaBuysellads = _buysellads2.default;
	exports.FaCab = _cab2.default;
	exports.FaCalculator = _calculator2.default;
	exports.FaCalendarCheckO = _calendarCheckO2.default;
	exports.FaCalendarMinusO = _calendarMinusO2.default;
	exports.FaCalendarO = _calendarO2.default;
	exports.FaCalendarPlusO = _calendarPlusO2.default;
	exports.FaCalendarTimesO = _calendarTimesO2.default;
	exports.FaCalendar = _calendar2.default;
	exports.FaCameraRetro = _cameraRetro2.default;
	exports.FaCamera = _camera2.default;
	exports.FaCaretDown = _caretDown2.default;
	exports.FaCaretLeft = _caretLeft2.default;
	exports.FaCaretRight = _caretRight2.default;
	exports.FaCaretSquareODown = _caretSquareODown2.default;
	exports.FaCaretSquareOLeft = _caretSquareOLeft2.default;
	exports.FaCaretSquareORight = _caretSquareORight2.default;
	exports.FaCaretSquareOUp = _caretSquareOUp2.default;
	exports.FaCaretUp = _caretUp2.default;
	exports.FaCartArrowDown = _cartArrowDown2.default;
	exports.FaCartPlus = _cartPlus2.default;
	exports.FaCcAmex = _ccAmex2.default;
	exports.FaCcDinersClub = _ccDinersClub2.default;
	exports.FaCcDiscover = _ccDiscover2.default;
	exports.FaCcJcb = _ccJcb2.default;
	exports.FaCcMastercard = _ccMastercard2.default;
	exports.FaCcPaypal = _ccPaypal2.default;
	exports.FaCcStripe = _ccStripe2.default;
	exports.FaCcVisa = _ccVisa2.default;
	exports.FaCc = _cc2.default;
	exports.FaCertificate = _certificate2.default;
	exports.FaChainBroken = _chainBroken2.default;
	exports.FaChain = _chain2.default;
	exports.FaCheckCircleO = _checkCircleO2.default;
	exports.FaCheckCircle = _checkCircle2.default;
	exports.FaCheckSquareO = _checkSquareO2.default;
	exports.FaCheckSquare = _checkSquare2.default;
	exports.FaCheck = _check2.default;
	exports.FaChevronCircleDown = _chevronCircleDown2.default;
	exports.FaChevronCircleLeft = _chevronCircleLeft2.default;
	exports.FaChevronCircleRight = _chevronCircleRight2.default;
	exports.FaChevronCircleUp = _chevronCircleUp2.default;
	exports.FaChevronDown = _chevronDown2.default;
	exports.FaChevronLeft = _chevronLeft2.default;
	exports.FaChevronRight = _chevronRight2.default;
	exports.FaChevronUp = _chevronUp2.default;
	exports.FaChild = _child2.default;
	exports.FaChrome = _chrome2.default;
	exports.FaCircleONotch = _circleONotch2.default;
	exports.FaCircleO = _circleO2.default;
	exports.FaCircleThin = _circleThin2.default;
	exports.FaCircle = _circle2.default;
	exports.FaClipboard = _clipboard2.default;
	exports.FaClockO = _clockO2.default;
	exports.FaClone = _clone2.default;
	exports.FaClose = _close2.default;
	exports.FaCloudDownload = _cloudDownload2.default;
	exports.FaCloudUpload = _cloudUpload2.default;
	exports.FaCloud = _cloud2.default;
	exports.FaCny = _cny2.default;
	exports.FaCodeFork = _codeFork2.default;
	exports.FaCode = _code2.default;
	exports.FaCodepen = _codepen2.default;
	exports.FaCodiepie = _codiepie2.default;
	exports.FaCoffee = _coffee2.default;
	exports.FaCog = _cog2.default;
	exports.FaCogs = _cogs2.default;
	exports.FaColumns = _columns2.default;
	exports.FaCommentO = _commentO2.default;
	exports.FaComment = _comment2.default;
	exports.FaCommentingO = _commentingO2.default;
	exports.FaCommenting = _commenting2.default;
	exports.FaCommentsO = _commentsO2.default;
	exports.FaComments = _comments2.default;
	exports.FaCompass = _compass2.default;
	exports.FaCompress = _compress2.default;
	exports.FaConnectdevelop = _connectdevelop2.default;
	exports.FaContao = _contao2.default;
	exports.FaCopy = _copy2.default;
	exports.FaCopyright = _copyright2.default;
	exports.FaCreativeCommons = _creativeCommons2.default;
	exports.FaCreditCardAlt = _creditCardAlt2.default;
	exports.FaCreditCard = _creditCard2.default;
	exports.FaCrop = _crop2.default;
	exports.FaCrosshairs = _crosshairs2.default;
	exports.FaCss3 = _css2.default;
	exports.FaCube = _cube2.default;
	exports.FaCubes = _cubes2.default;
	exports.FaCut = _cut2.default;
	exports.FaCutlery = _cutlery2.default;
	exports.FaDashboard = _dashboard2.default;
	exports.FaDashcube = _dashcube2.default;
	exports.FaDatabase = _database2.default;
	exports.FaDeaf = _deaf2.default;
	exports.FaDedent = _dedent2.default;
	exports.FaDelicious = _delicious2.default;
	exports.FaDesktop = _desktop2.default;
	exports.FaDeviantart = _deviantart2.default;
	exports.FaDiamond = _diamond2.default;
	exports.FaDigg = _digg2.default;
	exports.FaDollar = _dollar2.default;
	exports.FaDotCircleO = _dotCircleO2.default;
	exports.FaDownload = _download2.default;
	exports.FaDribbble = _dribbble2.default;
	exports.FaDropbox = _dropbox2.default;
	exports.FaDrupal = _drupal2.default;
	exports.FaEdge = _edge2.default;
	exports.FaEdit = _edit2.default;
	exports.FaEject = _eject2.default;
	exports.FaEllipsisH = _ellipsisH2.default;
	exports.FaEllipsisV = _ellipsisV2.default;
	exports.FaEmpire = _empire2.default;
	exports.FaEnvelopeO = _envelopeO2.default;
	exports.FaEnvelopeSquare = _envelopeSquare2.default;
	exports.FaEnvelope = _envelope2.default;
	exports.FaEnvira = _envira2.default;
	exports.FaEraser = _eraser2.default;
	exports.FaEur = _eur2.default;
	exports.FaExchange = _exchange2.default;
	exports.FaExclamationCircle = _exclamationCircle2.default;
	exports.FaExclamationTriangle = _exclamationTriangle2.default;
	exports.FaExclamation = _exclamation2.default;
	exports.FaExpand = _expand2.default;
	exports.FaExpeditedssl = _expeditedssl2.default;
	exports.FaExternalLinkSquare = _externalLinkSquare2.default;
	exports.FaExternalLink = _externalLink2.default;
	exports.FaEyeSlash = _eyeSlash2.default;
	exports.FaEye = _eye2.default;
	exports.FaEyedropper = _eyedropper2.default;
	exports.FaFacebookOfficial = _facebookOfficial2.default;
	exports.FaFacebookSquare = _facebookSquare2.default;
	exports.FaFacebook = _facebook2.default;
	exports.FaFastBackward = _fastBackward2.default;
	exports.FaFastForward = _fastForward2.default;
	exports.FaFax = _fax2.default;
	exports.FaFeed = _feed2.default;
	exports.FaFemale = _female2.default;
	exports.FaFighterJet = _fighterJet2.default;
	exports.FaFileArchiveO = _fileArchiveO2.default;
	exports.FaFileAudioO = _fileAudioO2.default;
	exports.FaFileCodeO = _fileCodeO2.default;
	exports.FaFileExcelO = _fileExcelO2.default;
	exports.FaFileImageO = _fileImageO2.default;
	exports.FaFileMovieO = _fileMovieO2.default;
	exports.FaFileO = _fileO2.default;
	exports.FaFilePdfO = _filePdfO2.default;
	exports.FaFilePowerpointO = _filePowerpointO2.default;
	exports.FaFileTextO = _fileTextO2.default;
	exports.FaFileText = _fileText2.default;
	exports.FaFileWordO = _fileWordO2.default;
	exports.FaFile = _file2.default;
	exports.FaFilm = _film2.default;
	exports.FaFilter = _filter2.default;
	exports.FaFireExtinguisher = _fireExtinguisher2.default;
	exports.FaFire = _fire2.default;
	exports.FaFirefox = _firefox2.default;
	exports.FaFlagCheckered = _flagCheckered2.default;
	exports.FaFlagO = _flagO2.default;
	exports.FaFlag = _flag2.default;
	exports.FaFlask = _flask2.default;
	exports.FaFlickr = _flickr2.default;
	exports.FaFloppyO = _floppyO2.default;
	exports.FaFolderO = _folderO2.default;
	exports.FaFolderOpenO = _folderOpenO2.default;
	exports.FaFolderOpen = _folderOpen2.default;
	exports.FaFolder = _folder2.default;
	exports.FaFont = _font2.default;
	exports.FaFonticons = _fonticons2.default;
	exports.FaFortAwesome = _fortAwesome2.default;
	exports.FaForumbee = _forumbee2.default;
	exports.FaForward = _forward2.default;
	exports.FaFoursquare = _foursquare2.default;
	exports.FaFrownO = _frownO2.default;
	exports.FaFutbolO = _futbolO2.default;
	exports.FaGamepad = _gamepad2.default;
	exports.FaGavel = _gavel2.default;
	exports.FaGbp = _gbp2.default;
	exports.FaGenderless = _genderless2.default;
	exports.FaGetPocket = _getPocket2.default;
	exports.FaGgCircle = _ggCircle2.default;
	exports.FaGg = _gg2.default;
	exports.FaGift = _gift2.default;
	exports.FaGitSquare = _gitSquare2.default;
	exports.FaGit = _git2.default;
	exports.FaGithubAlt = _githubAlt2.default;
	exports.FaGithubSquare = _githubSquare2.default;
	exports.FaGithub = _github2.default;
	exports.FaGitlab = _gitlab2.default;
	exports.FaGittip = _gittip2.default;
	exports.FaGlass = _glass2.default;
	exports.FaGlideG = _glideG2.default;
	exports.FaGlide = _glide2.default;
	exports.FaGlobe = _globe2.default;
	exports.FaGooglePlusSquare = _googlePlusSquare2.default;
	exports.FaGooglePlus = _googlePlus2.default;
	exports.FaGoogleWallet = _googleWallet2.default;
	exports.FaGoogle = _google2.default;
	exports.FaGraduationCap = _graduationCap2.default;
	exports.FaGroup = _group2.default;
	exports.FaHSquare = _hSquare2.default;
	exports.FaHackerNews = _hackerNews2.default;
	exports.FaHandGrabO = _handGrabO2.default;
	exports.FaHandLizardO = _handLizardO2.default;
	exports.FaHandODown = _handODown2.default;
	exports.FaHandOLeft = _handOLeft2.default;
	exports.FaHandORight = _handORight2.default;
	exports.FaHandOUp = _handOUp2.default;
	exports.FaHandPaperO = _handPaperO2.default;
	exports.FaHandPeaceO = _handPeaceO2.default;
	exports.FaHandPointerO = _handPointerO2.default;
	exports.FaHandScissorsO = _handScissorsO2.default;
	exports.FaHandSpockO = _handSpockO2.default;
	exports.FaHashtag = _hashtag2.default;
	exports.FaHddO = _hddO2.default;
	exports.FaHeader = _header2.default;
	exports.FaHeadphones = _headphones2.default;
	exports.FaHeartO = _heartO2.default;
	exports.FaHeart = _heart2.default;
	exports.FaHeartbeat = _heartbeat2.default;
	exports.FaHistory = _history2.default;
	exports.FaHome = _home2.default;
	exports.FaHospitalO = _hospitalO2.default;
	exports.FaHourglass1 = _hourglass2.default;
	exports.FaHourglass2 = _hourglass4.default;
	exports.FaHourglass3 = _hourglass6.default;
	exports.FaHourglassO = _hourglassO2.default;
	exports.FaHourglass = _hourglass8.default;
	exports.FaHouzz = _houzz2.default;
	exports.FaHtml5 = _html2.default;
	exports.FaICursor = _iCursor2.default;
	exports.FaIls = _ils2.default;
	exports.FaImage = _image2.default;
	exports.FaInbox = _inbox2.default;
	exports.FaIndent = _indent2.default;
	exports.FaIndustry = _industry2.default;
	exports.FaInfoCircle = _infoCircle2.default;
	exports.FaInfo = _info2.default;
	exports.FaInr = _inr2.default;
	exports.FaInstagram = _instagram2.default;
	exports.FaInternetExplorer = _internetExplorer2.default;
	exports.FaIntersex = _intersex2.default;
	exports.FaIoxhost = _ioxhost2.default;
	exports.FaItalic = _italic2.default;
	exports.FaJoomla = _joomla2.default;
	exports.FaJsfiddle = _jsfiddle2.default;
	exports.FaKey = _key2.default;
	exports.FaKeyboardO = _keyboardO2.default;
	exports.FaKrw = _krw2.default;
	exports.FaLanguage = _language2.default;
	exports.FaLaptop = _laptop2.default;
	exports.FaLastfmSquare = _lastfmSquare2.default;
	exports.FaLastfm = _lastfm2.default;
	exports.FaLeaf = _leaf2.default;
	exports.FaLeanpub = _leanpub2.default;
	exports.FaLemonO = _lemonO2.default;
	exports.FaLevelDown = _levelDown2.default;
	exports.FaLevelUp = _levelUp2.default;
	exports.FaLifeBouy = _lifeBouy2.default;
	exports.FaLightbulbO = _lightbulbO2.default;
	exports.FaLineChart = _lineChart2.default;
	exports.FaLinkedinSquare = _linkedinSquare2.default;
	exports.FaLinkedin = _linkedin2.default;
	exports.FaLinux = _linux2.default;
	exports.FaListAlt = _listAlt2.default;
	exports.FaListOl = _listOl2.default;
	exports.FaListUl = _listUl2.default;
	exports.FaList = _list2.default;
	exports.FaLocationArrow = _locationArrow2.default;
	exports.FaLock = _lock2.default;
	exports.FaLongArrowDown = _longArrowDown2.default;
	exports.FaLongArrowLeft = _longArrowLeft2.default;
	exports.FaLongArrowRight = _longArrowRight2.default;
	exports.FaLongArrowUp = _longArrowUp2.default;
	exports.FaLowVision = _lowVision2.default;
	exports.FaMagic = _magic2.default;
	exports.FaMagnet = _magnet2.default;
	exports.FaMailForward = _mailForward2.default;
	exports.FaMailReplyAll = _mailReplyAll2.default;
	exports.FaMailReply = _mailReply2.default;
	exports.FaMale = _male2.default;
	exports.FaMapMarker = _mapMarker2.default;
	exports.FaMapO = _mapO2.default;
	exports.FaMapPin = _mapPin2.default;
	exports.FaMapSigns = _mapSigns2.default;
	exports.FaMap = _map2.default;
	exports.FaMarsDouble = _marsDouble2.default;
	exports.FaMarsStrokeH = _marsStrokeH2.default;
	exports.FaMarsStrokeV = _marsStrokeV2.default;
	exports.FaMarsStroke = _marsStroke2.default;
	exports.FaMars = _mars2.default;
	exports.FaMaxcdn = _maxcdn2.default;
	exports.FaMeanpath = _meanpath2.default;
	exports.FaMedium = _medium2.default;
	exports.FaMedkit = _medkit2.default;
	exports.FaMehO = _mehO2.default;
	exports.FaMercury = _mercury2.default;
	exports.FaMicrophoneSlash = _microphoneSlash2.default;
	exports.FaMicrophone = _microphone2.default;
	exports.FaMinusCircle = _minusCircle2.default;
	exports.FaMinusSquareO = _minusSquareO2.default;
	exports.FaMinusSquare = _minusSquare2.default;
	exports.FaMinus = _minus2.default;
	exports.FaMixcloud = _mixcloud2.default;
	exports.FaMobile = _mobile2.default;
	exports.FaModx = _modx2.default;
	exports.FaMoney = _money2.default;
	exports.FaMoonO = _moonO2.default;
	exports.FaMotorcycle = _motorcycle2.default;
	exports.FaMousePointer = _mousePointer2.default;
	exports.FaMusic = _music2.default;
	exports.FaNeuter = _neuter2.default;
	exports.FaNewspaperO = _newspaperO2.default;
	exports.FaObjectGroup = _objectGroup2.default;
	exports.FaObjectUngroup = _objectUngroup2.default;
	exports.FaOdnoklassnikiSquare = _odnoklassnikiSquare2.default;
	exports.FaOdnoklassniki = _odnoklassniki2.default;
	exports.FaOpencart = _opencart2.default;
	exports.FaOpenid = _openid2.default;
	exports.FaOpera = _opera2.default;
	exports.FaOptinMonster = _optinMonster2.default;
	exports.FaPagelines = _pagelines2.default;
	exports.FaPaintBrush = _paintBrush2.default;
	exports.FaPaperPlaneO = _paperPlaneO2.default;
	exports.FaPaperPlane = _paperPlane2.default;
	exports.FaPaperclip = _paperclip2.default;
	exports.FaParagraph = _paragraph2.default;
	exports.FaPauseCircleO = _pauseCircleO2.default;
	exports.FaPauseCircle = _pauseCircle2.default;
	exports.FaPause = _pause2.default;
	exports.FaPaw = _paw2.default;
	exports.FaPaypal = _paypal2.default;
	exports.FaPencilSquare = _pencilSquare2.default;
	exports.FaPencil = _pencil2.default;
	exports.FaPercent = _percent2.default;
	exports.FaPhoneSquare = _phoneSquare2.default;
	exports.FaPhone = _phone2.default;
	exports.FaPieChart = _pieChart2.default;
	exports.FaPiedPiperAlt = _piedPiperAlt2.default;
	exports.FaPiedPiper = _piedPiper2.default;
	exports.FaPinterestP = _pinterestP2.default;
	exports.FaPinterestSquare = _pinterestSquare2.default;
	exports.FaPinterest = _pinterest2.default;
	exports.FaPlane = _plane2.default;
	exports.FaPlayCircleO = _playCircleO2.default;
	exports.FaPlayCircle = _playCircle2.default;
	exports.FaPlay = _play2.default;
	exports.FaPlug = _plug2.default;
	exports.FaPlusCircle = _plusCircle2.default;
	exports.FaPlusSquareO = _plusSquareO2.default;
	exports.FaPlusSquare = _plusSquare2.default;
	exports.FaPlus = _plus2.default;
	exports.FaPowerOff = _powerOff2.default;
	exports.FaPrint = _print2.default;
	exports.FaProductHunt = _productHunt2.default;
	exports.FaPuzzlePiece = _puzzlePiece2.default;
	exports.FaQq = _qq2.default;
	exports.FaQrcode = _qrcode2.default;
	exports.FaQuestionCircleO = _questionCircleO2.default;
	exports.FaQuestionCircle = _questionCircle2.default;
	exports.FaQuestion = _question2.default;
	exports.FaQuoteLeft = _quoteLeft2.default;
	exports.FaQuoteRight = _quoteRight2.default;
	exports.FaRa = _ra2.default;
	exports.FaRandom = _random2.default;
	exports.FaRecycle = _recycle2.default;
	exports.FaRedditAlien = _redditAlien2.default;
	exports.FaRedditSquare = _redditSquare2.default;
	exports.FaReddit = _reddit2.default;
	exports.FaRefresh = _refresh2.default;
	exports.FaRegistered = _registered2.default;
	exports.FaRenren = _renren2.default;
	exports.FaRepeat = _repeat2.default;
	exports.FaRetweet = _retweet2.default;
	exports.FaRoad = _road2.default;
	exports.FaRocket = _rocket2.default;
	exports.FaRotateLeft = _rotateLeft2.default;
	exports.FaRouble = _rouble2.default;
	exports.FaRssSquare = _rssSquare2.default;
	exports.FaSafari = _safari2.default;
	exports.FaScribd = _scribd2.default;
	exports.FaSearchMinus = _searchMinus2.default;
	exports.FaSearchPlus = _searchPlus2.default;
	exports.FaSearch = _search2.default;
	exports.FaSellsy = _sellsy2.default;
	exports.FaServer = _server2.default;
	exports.FaShareAltSquare = _shareAltSquare2.default;
	exports.FaShareAlt = _shareAlt2.default;
	exports.FaShareSquareO = _shareSquareO2.default;
	exports.FaShareSquare = _shareSquare2.default;
	exports.FaShield = _shield2.default;
	exports.FaShip = _ship2.default;
	exports.FaShirtsinbulk = _shirtsinbulk2.default;
	exports.FaShoppingBag = _shoppingBag2.default;
	exports.FaShoppingBasket = _shoppingBasket2.default;
	exports.FaShoppingCart = _shoppingCart2.default;
	exports.FaSignIn = _signIn2.default;
	exports.FaSignLanguage = _signLanguage2.default;
	exports.FaSignOut = _signOut2.default;
	exports.FaSignal = _signal2.default;
	exports.FaSimplybuilt = _simplybuilt2.default;
	exports.FaSitemap = _sitemap2.default;
	exports.FaSkyatlas = _skyatlas2.default;
	exports.FaSkype = _skype2.default;
	exports.FaSlack = _slack2.default;
	exports.FaSliders = _sliders2.default;
	exports.FaSlideshare = _slideshare2.default;
	exports.FaSmileO = _smileO2.default;
	exports.FaSnapchatGhost = _snapchatGhost2.default;
	exports.FaSnapchatSquare = _snapchatSquare2.default;
	exports.FaSnapchat = _snapchat2.default;
	exports.FaSortAlphaAsc = _sortAlphaAsc2.default;
	exports.FaSortAlphaDesc = _sortAlphaDesc2.default;
	exports.FaSortAmountAsc = _sortAmountAsc2.default;
	exports.FaSortAmountDesc = _sortAmountDesc2.default;
	exports.FaSortAsc = _sortAsc2.default;
	exports.FaSortDesc = _sortDesc2.default;
	exports.FaSortNumericAsc = _sortNumericAsc2.default;
	exports.FaSortNumericDesc = _sortNumericDesc2.default;
	exports.FaSort = _sort2.default;
	exports.FaSoundcloud = _soundcloud2.default;
	exports.FaSpaceShuttle = _spaceShuttle2.default;
	exports.FaSpinner = _spinner2.default;
	exports.FaSpoon = _spoon2.default;
	exports.FaSpotify = _spotify2.default;
	exports.FaSquareO = _squareO2.default;
	exports.FaSquare = _square2.default;
	exports.FaStackExchange = _stackExchange2.default;
	exports.FaStackOverflow = _stackOverflow2.default;
	exports.FaStarHalfEmpty = _starHalfEmpty2.default;
	exports.FaStarHalf = _starHalf2.default;
	exports.FaStarO = _starO2.default;
	exports.FaStar = _star2.default;
	exports.FaSteamSquare = _steamSquare2.default;
	exports.FaSteam = _steam2.default;
	exports.FaStepBackward = _stepBackward2.default;
	exports.FaStepForward = _stepForward2.default;
	exports.FaStethoscope = _stethoscope2.default;
	exports.FaStickyNoteO = _stickyNoteO2.default;
	exports.FaStickyNote = _stickyNote2.default;
	exports.FaStopCircleO = _stopCircleO2.default;
	exports.FaStopCircle = _stopCircle2.default;
	exports.FaStop = _stop2.default;
	exports.FaStreetView = _streetView2.default;
	exports.FaStrikethrough = _strikethrough2.default;
	exports.FaStumbleuponCircle = _stumbleuponCircle2.default;
	exports.FaStumbleupon = _stumbleupon2.default;
	exports.FaSubscript = _subscript2.default;
	exports.FaSubway = _subway2.default;
	exports.FaSuitcase = _suitcase2.default;
	exports.FaSunO = _sunO2.default;
	exports.FaSuperscript = _superscript2.default;
	exports.FaTable = _table2.default;
	exports.FaTablet = _tablet2.default;
	exports.FaTag = _tag2.default;
	exports.FaTags = _tags2.default;
	exports.FaTasks = _tasks2.default;
	exports.FaTelevision = _television2.default;
	exports.FaTencentWeibo = _tencentWeibo2.default;
	exports.FaTerminal = _terminal2.default;
	exports.FaTextHeight = _textHeight2.default;
	exports.FaTextWidth = _textWidth2.default;
	exports.FaThLarge = _thLarge2.default;
	exports.FaThList = _thList2.default;
	exports.FaTh = _th2.default;
	exports.FaThumbTack = _thumbTack2.default;
	exports.FaThumbsDown = _thumbsDown2.default;
	exports.FaThumbsODown = _thumbsODown2.default;
	exports.FaThumbsOUp = _thumbsOUp2.default;
	exports.FaThumbsUp = _thumbsUp2.default;
	exports.FaTicket = _ticket2.default;
	exports.FaTimesCircleO = _timesCircleO2.default;
	exports.FaTimesCircle = _timesCircle2.default;
	exports.FaTint = _tint2.default;
	exports.FaToggleOff = _toggleOff2.default;
	exports.FaToggleOn = _toggleOn2.default;
	exports.FaTrademark = _trademark2.default;
	exports.FaTrain = _train2.default;
	exports.FaTransgenderAlt = _transgenderAlt2.default;
	exports.FaTrashO = _trashO2.default;
	exports.FaTrash = _trash2.default;
	exports.FaTree = _tree2.default;
	exports.FaTrello = _trello2.default;
	exports.FaTripadvisor = _tripadvisor2.default;
	exports.FaTrophy = _trophy2.default;
	exports.FaTruck = _truck2.default;
	exports.FaTry = _try2.default;
	exports.FaTty = _tty2.default;
	exports.FaTumblrSquare = _tumblrSquare2.default;
	exports.FaTumblr = _tumblr2.default;
	exports.FaTwitch = _twitch2.default;
	exports.FaTwitterSquare = _twitterSquare2.default;
	exports.FaTwitter = _twitter2.default;
	exports.FaUmbrella = _umbrella2.default;
	exports.FaUnderline = _underline2.default;
	exports.FaUniversalAccess = _universalAccess2.default;
	exports.FaUnlockAlt = _unlockAlt2.default;
	exports.FaUnlock = _unlock2.default;
	exports.FaUpload = _upload2.default;
	exports.FaUsb = _usb2.default;
	exports.FaUserMd = _userMd2.default;
	exports.FaUserPlus = _userPlus2.default;
	exports.FaUserSecret = _userSecret2.default;
	exports.FaUserTimes = _userTimes2.default;
	exports.FaUser = _user2.default;
	exports.FaVenusDouble = _venusDouble2.default;
	exports.FaVenusMars = _venusMars2.default;
	exports.FaVenus = _venus2.default;
	exports.FaViacoin = _viacoin2.default;
	exports.FaViadeoSquare = _viadeoSquare2.default;
	exports.FaViadeo = _viadeo2.default;
	exports.FaVideoCamera = _videoCamera2.default;
	exports.FaVimeoSquare = _vimeoSquare2.default;
	exports.FaVimeo = _vimeo2.default;
	exports.FaVine = _vine2.default;
	exports.FaVk = _vk2.default;
	exports.FaVolumeControlPhone = _volumeControlPhone2.default;
	exports.FaVolumeDown = _volumeDown2.default;
	exports.FaVolumeOff = _volumeOff2.default;
	exports.FaVolumeUp = _volumeUp2.default;
	exports.FaWechat = _wechat2.default;
	exports.FaWeibo = _weibo2.default;
	exports.FaWhatsapp = _whatsapp2.default;
	exports.FaWheelchairAlt = _wheelchairAlt2.default;
	exports.FaWheelchair = _wheelchair2.default;
	exports.FaWifi = _wifi2.default;
	exports.FaWikipediaW = _wikipediaW2.default;
	exports.FaWindows = _windows2.default;
	exports.FaWordpress = _wordpress2.default;
	exports.FaWpbeginner = _wpbeginner2.default;
	exports.FaWpforms = _wpforms2.default;
	exports.FaWrench = _wrench2.default;
	exports.FaXingSquare = _xingSquare2.default;
	exports.FaXing = _xing2.default;
	exports.FaYCombinator = _yCombinator2.default;
	exports.FaYahoo = _yahoo2.default;
	exports.FaYelp = _yelp2.default;
	exports.FaYoutubePlay = _youtubePlay2.default;
	exports.FaYoutubeSquare = _youtubeSquare2.default;
	exports.FaYoutube = _youtube2.default;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chip = function Chip(_ref) {
	  var children = _ref.children,
	      close = _ref.close;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'chip' },
	    children,
	    close ? _react2.default.createElement(
	      'i',
	      { className: 'material-icons' },
	      'close'
	    ) : null
	  );
	};
	
	Chip.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * If show a close icon
	   * @default false
	   */
	  close: _propTypes2.default.bool
	};
	
	exports.default = Chip;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(999);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      try {
	        this._unrenderOverlay();
	      } catch (e) {
	        this._overlayInstance = null;
	      }
	      if (this._overlayTarget) {
	        this.getContainerDOMNode().removeChild(this._overlayTarget);
	        this._overlayTarget = null;
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._renderOverlay();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._renderOverlay();
	    }
	  }, {
	    key: '_mountOverlayTarget',
	    value: function _mountOverlayTarget() {
	      this._overlayTarget = document.createElement('div');
	      this.getContainerDOMNode().appendChild(this._overlayTarget);
	    }
	  }, {
	    key: '_renderOverlay',
	    value: function _renderOverlay() {
	      if (!this._overlayTarget) {
	        this._mountOverlayTarget();
	      }
	
	      // Save reference to help testing
	      this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.renderOverlay(), this._overlayTarget);
	    }
	  }, {
	    key: '_unrenderOverlay',
	    value: function _unrenderOverlay() {
	      _react2.default.unmountComponentAtNode(this._overlayTarget);
	      this._overlayInstance = null;
	    }
	  }, {
	    key: 'getOverlayDOMNode',
	    value: function getOverlayDOMNode() {
	      if (!this.isMounted()) {
	        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	      }
	
	      return this._overlayInstance.getDOMNode();
	    }
	  }, {
	    key: 'getContainerDOMNode',
	    value: function getContainerDOMNode() {
	      return this.props.container.getDOMNode ? this.props.container.getDOMNode() : this.props.container;
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  container: _propTypes2.default.any.isRequired
	};
	
	Overlay.defaultProps = {
	  container: {
	    // Provide `getDOMNode` fn mocking a React component API. The `document.body`
	    // reference needs to be contained within this function so that it is not accessed
	    // in environments where it would not be defined, e.g. nodejs. Equally this is needed
	    // before the body is defined where `document.body === null`, this ensures
	    // `document.body` is only accessed after componentDidMount.
	    getDOMNode: function getDOMNode() {
	      return document.body;
	    }
	  }
	};
	
	exports.default = Overlay;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay2 = __webpack_require__(996);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OverlayTrigger = function (_Overlay) {
	  _inherits(OverlayTrigger, _Overlay);
	
	  function OverlayTrigger(props) {
	    _classCallCheck(this, OverlayTrigger);
	
	    var _this = _possibleConstructorReturn(this, (OverlayTrigger.__proto__ || Object.getPrototypeOf(OverlayTrigger)).call(this, props));
	
	    _this.showOverlay = _this.showOverlay.bind(_this);
	    _this.renderOverlay = _this.renderOverlay.bind(_this);
	    _this.overlayID = _this.props.overlay.props.id || 'overlay_' + (0, _idgen2.default)();
	    return _this;
	  }
	
	  _createClass(OverlayTrigger, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	      if (!children) return null;
	
	      var child = _react2.default.Children.only(children);
	      return _react2.default.cloneElement(child, {
	        onClick: this.showOverlay
	      });
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay() {
	      return _react2.default.cloneElement(this.props.overlay, {
	        id: this.overlayID
	      });
	    }
	  }, {
	    key: 'showOverlay',
	    value: function showOverlay(e) {
	      e.preventDefault();
	      $('#' + this.overlayID).modal(this.props.modalOptions).modal('open');
	    }
	  }]);
	
	  return OverlayTrigger;
	}(_Overlay3.default);
	
	OverlayTrigger.propTypes = {
	  /**
	  * ModalOptions
	  * Object with options for modal
	  */
	  modalOptions: _propTypes2.default.shape({
	    /*
	     * Modal can be dismissed by clicking outside of the modal
	     */
	    dismissible: _propTypes2.default.bool,
	    /*
	     * Opacity of modal background ( from 0 to 1 )
	     */
	    opacity: _propTypes2.default.number,
	    /*
	     * Transition in duration
	     */
	    inDuration: _propTypes2.default.number,
	    /*
	     * Transition out duration
	     */
	    outDuration: _propTypes2.default.number,
	    /*
	     * Starting top style attribute
	     */
	    startingTop: _propTypes2.default.string,
	    /*
	     * Ending top style attribute
	     */
	    endingTop: _propTypes2.default.string,
	    /*
	     * Callback for Modal open. Modal and trigger parameters available.
	     */
	    ready: _propTypes2.default.func,
	    /*
	     *  Callback for Modal close
	     */
	    complete: _propTypes2.default.func
	  }),
	  overlay: _propTypes2.default.node
	};
	
	exports.default = OverlayTrigger;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaginationButton = function PaginationButton(_ref) {
	  var _ref$active = _ref.active,
	      active = _ref$active === undefined ? false : _ref$active,
	      children = _ref.children,
	      className = _ref.className,
	      _ref$disabled = _ref.disabled,
	      disabled = _ref$disabled === undefined ? false : _ref$disabled,
	      _ref$href = _ref.href,
	      href = _ref$href === undefined ? '#' : _ref$href,
	      onSelect = _ref.onSelect;
	
	  var classes = {
	    'waves-effect': true,
	    disabled: disabled,
	    active: active
	  };
	
	  return _react2.default.createElement(
	    'li',
	    { className: (0, _classnames2.default)(classes, className), onClick: onSelect },
	    _react2.default.createElement(
	      'a',
	      { href: href },
	      children
	    )
	  );
	};
	
	PaginationButton.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  href: _propTypes2.default.string,
	  onSelect: _propTypes2.default.func
	};
	
	exports.default = PaginationButton;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1308);


/***/ },
/* 1000 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(67);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(86);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstrumentation = __webpack_require__(43);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1356);
	var warning = __webpack_require__(19);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 1003 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var LinkedValueUtils = __webpack_require__(797);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(47);
	
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 1005 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 1006 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1316);
	
	var containsNode = __webpack_require__(1205);
	var focusNode = __webpack_require__(859);
	var getActiveElement = __webpack_require__(860);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(85);
	var DOMProperty = __webpack_require__(86);
	var React = __webpack_require__(88);
	var ReactBrowserEventEmitter = __webpack_require__(118);
	var ReactCurrentOwner = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMContainerInfo = __webpack_require__(1310);
	var ReactDOMFeatureFlags = __webpack_require__(1312);
	var ReactFeatureFlags = __webpack_require__(1006);
	var ReactInstanceMap = __webpack_require__(102);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMarkupChecksum = __webpack_require__(1326);
	var ReactReconciler = __webpack_require__(87);
	var ReactUpdateQueue = __webpack_require__(800);
	var ReactUpdates = __webpack_require__(47);
	
	var emptyObject = __webpack_require__(157);
	var instantiateReactComponent = __webpack_require__(1017);
	var invariant = __webpack_require__(7);
	var setInnerHTML = __webpack_require__(122);
	var shouldUpdateReactComponent = __webpack_require__(806);
	var warning = __webpack_require__(19);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var React = __webpack_require__(88);
	
	var invariant = __webpack_require__(7);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 1011 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 1013 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(1010);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var ReactCompositeComponent = __webpack_require__(1307);
	var ReactEmptyComponent = __webpack_require__(1005);
	var ReactHostComponent = __webpack_require__(1007);
	
	var getNextDebugID = __webpack_require__(1366);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 1018 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(121);
	var setInnerHTML = __webpack_require__(122);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(55);
	var REACT_ELEMENT_TYPE = __webpack_require__(1322);
	
	var getIteratorFn = __webpack_require__(1353);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(796);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(104),
	    _assign = __webpack_require__(25);
	
	var ReactNoopUpdateQueue = __webpack_require__(1024);
	
	var canDefineProperty = __webpack_require__(1025);
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(7);
	var lowPriorityWarning = __webpack_require__(1367);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(104);
	
	var ReactCurrentOwner = __webpack_require__(55);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 1023 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 1026 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedImplementation = __webpack_require__(1457);
	
	var _AnimatedImplementation2 = _interopRequireDefault(_AnimatedImplementation);
	
	var _Image = __webpack_require__(812);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _ScrollView = __webpack_require__(107);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _Text = __webpack_require__(818);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Animated = Object.assign({}, _AnimatedImplementation2.default, {
	  Image: _AnimatedImplementation2.default.createAnimatedComponent(_Image2.default),
	  ScrollView: _AnimatedImplementation2.default.createAnimatedComponent(_ScrollView2.default),
	  View: _AnimatedImplementation2.default.createAnimatedComponent(_View2.default),
	  Text: _AnimatedImplementation2.default.createAnimatedComponent(_Text2.default)
	}); /**
	     * Copyright (c) 2016-present, Nicolas Gallagher.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     *
	     * 
	     */
	
	exports.default = Animated;
	module.exports = exports['default'];

/***/ },
/* 1028 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ImageResizeMode = {
	  center: 'center',
	  contain: 'contain',
	  cover: 'cover',
	  none: 'none',
	  repeat: 'repeat',
	  stretch: 'stretch'
	};
	
	exports.default = ImageResizeMode;
	module.exports = exports['default'];

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AnimationPropTypes = __webpack_require__(1045);
	
	var _AnimationPropTypes2 = _interopRequireDefault(_AnimationPropTypes);
	
	var _BorderPropTypes = __webpack_require__(1046);
	
	var _BorderPropTypes2 = _interopRequireDefault(_BorderPropTypes);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ImageResizeMode = __webpack_require__(1028);
	
	var _ImageResizeMode2 = _interopRequireDefault(_ImageResizeMode);
	
	var _InteractionPropTypes = __webpack_require__(1047);
	
	var _InteractionPropTypes2 = _interopRequireDefault(_InteractionPropTypes);
	
	var _LayoutPropTypes = __webpack_require__(1048);
	
	var _LayoutPropTypes2 = _interopRequireDefault(_LayoutPropTypes);
	
	var _ShadowPropTypes = __webpack_require__(1051);
	
	var _ShadowPropTypes2 = _interopRequireDefault(_ShadowPropTypes);
	
	var _TransformPropTypes = __webpack_require__(1052);
	
	var _TransformPropTypes2 = _interopRequireDefault(_TransformPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStylePropTypes = Object.assign({}, _AnimationPropTypes2.default, _BorderPropTypes2.default, _InteractionPropTypes2.default, _LayoutPropTypes2.default, _ShadowPropTypes2.default, _TransformPropTypes2.default, {
	  backgroundColor: _ColorPropType2.default,
	  opacity: _propTypes.number,
	  resizeMode: (0, _propTypes.oneOf)(Object.keys(_ImageResizeMode2.default)),
	  tintColor: _ColorPropType2.default,
	  /**
	   * @platform unsupported
	   */
	  overlayColor: _propTypes.string,
	  /**
	   * @platform web
	   */
	  boxShadow: _propTypes.string,
	  filter: _propTypes.string
	});
	
	exports.default = ImageStylePropTypes;
	module.exports = exports['default'];

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PanResponder = __webpack_require__(1476);
	
	var _PanResponder2 = _interopRequireDefault(_PanResponder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _PanResponder2.default;
	module.exports = exports['default'];

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _react = __webpack_require__(1);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _PickerItem = __webpack_require__(1407);
	
	var _PickerItem2 = _interopRequireDefault(_PickerItem);
	
	var _PickerItemPropType = __webpack_require__(1408);
	
	var _PickerItemPropType2 = _interopRequireDefault(_PickerItemPropType);
	
	var _PickerStylePropTypes = __webpack_require__(1409);
	
	var _PickerStylePropTypes2 = _interopRequireDefault(_PickerStylePropTypes);
	
	var _StyleSheetPropType = __webpack_require__(109);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TextPropTypes = __webpack_require__(816);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var pickerStyleType = (0, _StyleSheetPropType2.default)(_PickerStylePropTypes2.default);
	
	var Picker = function (_Component) {
	  _inherits(Picker, _Component);
	
	  function Picker() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Picker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (e) {
	      var onValueChange = _this.props.onValueChange;
	      var _e$target = e.target,
	          selectedIndex = _e$target.selectedIndex,
	          value = _e$target.value;
	
	      if (onValueChange) {
	        onValueChange(value, selectedIndex);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Picker.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        enabled = _props.enabled,
	        selectedValue = _props.selectedValue,
	        style = _props.style,
	        testID = _props.testID,
	        itemStyle = _props.itemStyle,
	        mode = _props.mode,
	        prompt = _props.prompt,
	        onValueChange = _props.onValueChange,
	        otherProps = _objectWithoutProperties(_props, ['children', 'enabled', 'selectedValue', 'style', 'testID', 'itemStyle', 'mode', 'prompt', 'onValueChange']);
	
	    return (0, _createElement2.default)('select', Object.assign({
	      children: children,
	      disabled: enabled === false ? true : undefined,
	      onChange: this._handleChange,
	      style: [styles.initial, style],
	      testID: testID,
	      value: selectedValue
	    }, otherProps));
	  };
	
	  return Picker;
	}(_react.Component);
	
	Picker.Item = _PickerItem2.default;
	Picker.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  children: (0, _propTypes.oneOfType)([_PickerItemPropType2.default, (0, _propTypes.arrayOf)(_PickerItemPropType2.default)]),
	  enabled: _propTypes.bool,
	  onValueChange: _propTypes.func,
	  selectedValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  style: pickerStyleType,
	  testID: _propTypes.string
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    fontFamily: 'System',
	    fontSize: 'inherit',
	    margin: 0
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(Picker);
	module.exports = exports['default'];

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var RefreshControl = function (_Component) {
	  _inherits(RefreshControl, _Component);
	
	  function RefreshControl() {
	    _classCallCheck(this, RefreshControl);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RefreshControl.prototype.render = function render() {
	    var _props = this.props,
	        colors = _props.colors,
	        enabled = _props.enabled,
	        onRefresh = _props.onRefresh,
	        progressBackgroundColor = _props.progressBackgroundColor,
	        progressViewOffset = _props.progressViewOffset,
	        refreshing = _props.refreshing,
	        size = _props.size,
	        tintColor = _props.tintColor,
	        title = _props.title,
	        titleColor = _props.titleColor,
	        rest = _objectWithoutProperties(_props, ['colors', 'enabled', 'onRefresh', 'progressBackgroundColor', 'progressViewOffset', 'refreshing', 'size', 'tintColor', 'title', 'titleColor']);
	
	    return _react2.default.createElement(_View2.default, rest);
	  };
	
	  return RefreshControl;
	}(_react.Component);
	
	RefreshControl.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  colors: (0, _propTypes.arrayOf)(_ColorPropType2.default),
	  enabled: _propTypes.bool,
	  onRefresh: _propTypes.func,
	  progressBackgroundColor: _ColorPropType2.default,
	  progressViewOffset: _propTypes.number,
	  refreshing: _propTypes.bool.isRequired,
	  size: (0, _propTypes.oneOf)([0, 1]),
	  tintColor: _ColorPropType2.default,
	  title: _propTypes.string,
	  titleColor: _ColorPropType2.default
	}) : {};
	exports.default = RefreshControl;
	module.exports = exports['default'];

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeColor = __webpack_require__(825);
	
	var _normalizeColor2 = _interopRequireDefault(_normalizeColor);
	
	var _normalizeValue = __webpack_require__(814);
	
	var _normalizeValue2 = _interopRequireDefault(_normalizeValue);
	
	var _resolveShadowValue = __webpack_require__(1037);
	
	var _resolveShadowValue2 = _interopRequireDefault(_resolveShadowValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The browser implements the CSS cascade, where the order of properties is a
	 * factor in determining which styles to paint. React Native is different. It
	 * gives giving precedence to the more specific style property. For example,
	 * the value of `paddingTop` takes precedence over that of `padding`.
	 *
	 * This module creates mutally exclusive style declarations by expanding all of
	 * React Native's supported shortform properties (e.g. `padding`) to their
	 * longfrom equivalents.
	 */
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * @noflow
	                       */
	
	var styleShortFormProperties = {
	  borderColor: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'],
	  borderRadius: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'],
	  borderStyle: ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'],
	  borderWidth: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'],
	  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
	  marginHorizontal: ['marginRight', 'marginLeft'],
	  marginVertical: ['marginTop', 'marginBottom'],
	  overflow: ['overflowX', 'overflowY'],
	  overscrollBehavior: ['overscrollBehaviorX', 'overscrollBehaviorY'],
	  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
	  paddingHorizontal: ['paddingRight', 'paddingLeft'],
	  paddingVertical: ['paddingTop', 'paddingBottom'],
	  writingDirection: ['direction']
	};
	
	var colorProps = {
	  backgroundColor: true,
	  borderColor: true,
	  borderTopColor: true,
	  borderRightColor: true,
	  borderBottomColor: true,
	  borderLeftColor: true,
	  color: true
	};
	
	var borderWidthProps = {
	  borderWidth: true,
	  borderTopWidth: true,
	  borderRightWidth: true,
	  borderBottomWidth: true,
	  borderLeftWidth: true
	};
	
	var monospaceFontStack = 'monospace, monospace';
	var systemFontStack = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif';
	
	var alphaSortProps = function alphaSortProps(propsArray) {
	  return propsArray.sort(function (a, b) {
	    if (a < b) {
	      return -1;
	    }
	    if (a > b) {
	      return 1;
	    }
	    return 0;
	  });
	};
	
	var defaultOffset = { height: 0, width: 0 };
	
	/**
	 * Shadow
	 */
	
	var resolveShadow = function resolveShadow(resolvedStyle, style) {
	  var boxShadow = style.boxShadow;
	
	  var shadow = (0, _resolveShadowValue2.default)(style);
	  resolvedStyle.boxShadow = boxShadow ? boxShadow + ', ' + shadow : shadow;
	};
	
	/**
	 * Text Decoration
	 */
	
	var resolveTextDecoration = function resolveTextDecoration(resolvedStyle, style) {
	  var textDecorationColor = style.textDecorationColor,
	      textDecorationLine = style.textDecorationLine,
	      textDecorationStyle = style.textDecorationStyle;
	
	  var color = (0, _normalizeColor2.default)(textDecorationColor);
	
	  if (textDecorationLine) {
	    // use 'text-decoration' for browsers that support CSS2 text-decoration (e.g., IE, Edge)
	    resolvedStyle.textDecoration = textDecorationLine;
	
	    if (textDecorationColor) {
	      resolvedStyle.textDecorationColor = color;
	    }
	    if (textDecorationStyle) {
	      resolvedStyle.textDecorationStyle = textDecorationStyle;
	    }
	  }
	};
	
	/**
	 * Text Shadow
	 */
	
	var resolveTextShadow = function resolveTextShadow(resolvedStyle, style) {
	  var textShadowColor = style.textShadowColor,
	      textShadowOffset = style.textShadowOffset,
	      textShadowRadius = style.textShadowRadius;
	
	  var _ref = textShadowOffset || defaultOffset,
	      height = _ref.height,
	      width = _ref.width;
	
	  var offsetX = (0, _normalizeValue2.default)(null, width);
	  var offsetY = (0, _normalizeValue2.default)(null, height);
	  var blurRadius = (0, _normalizeValue2.default)(null, textShadowRadius || 0);
	  var color = (0, _normalizeColor2.default)(textShadowColor);
	
	  if (color && (height !== 0 || width !== 0)) {
	    resolvedStyle.textShadow = offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
	  }
	};
	
	/**
	 * Transform
	 */
	
	// { scale: 2 } => 'scale(2)'
	// { translateX: 20 } => 'translateX(20px)'
	var mapTransform = function mapTransform(transform) {
	  var type = Object.keys(transform)[0];
	  var value = (0, _normalizeValue2.default)(type, transform[type]);
	  return type + '(' + value + ')';
	};
	
	// [1,2,3,4,5,6] => 'matrix3d(1,2,3,4,5,6)'
	var convertTransformMatrix = function convertTransformMatrix(transformMatrix) {
	  var matrix = transformMatrix.join(',');
	  return 'matrix3d(' + matrix + ')';
	};
	
	var resolveTransform = function resolveTransform(resolvedStyle, style) {
	  var transform = style.transform;
	  if (Array.isArray(style.transform)) {
	    transform = style.transform.map(mapTransform).join(' ');
	  } else if (style.transformMatrix) {
	    transform = convertTransformMatrix(style.transformMatrix);
	  }
	  resolvedStyle.transform = transform;
	};
	
	/**
	 * Reducer
	 */
	
	var createReducer = function createReducer(style, styleProps) {
	  var hasResolvedShadow = false;
	  var hasResolvedTextDecoration = false;
	  var hasResolvedTextShadow = false;
	
	  return function (resolvedStyle, prop) {
	    var value = (0, _normalizeValue2.default)(prop, style[prop]);
	
	    // Make sure the default border width is explicitly set to '0' to avoid
	    // falling back to any unwanted user-agent styles.
	    if (borderWidthProps[prop]) {
	      value = value == null ? (0, _normalizeValue2.default)(null, 0) : value;
	    }
	
	    // Normalize color values
	    if (colorProps[prop]) {
	      value = (0, _normalizeColor2.default)(value);
	    }
	
	    // Ignore everything else with a null value
	    if (value == null) {
	      return resolvedStyle;
	    }
	
	    switch (prop) {
	      // Ignore some React Native styles
	      case 'aspectRatio':
	      case 'elevation':
	      case 'overlayColor':
	      case 'resizeMode':
	      case 'tintColor':
	        {
	          break;
	        }
	
	      // TODO: remove once this issue is fixed
	      // https://github.com/rofrischmann/inline-style-prefixer/issues/159
	      case 'backgroundClip':
	        {
	          if (value === 'text') {
	            resolvedStyle.backgroundClip = value;
	            resolvedStyle.WebkitBackgroundClip = value;
	          }
	          break;
	        }
	
	      case 'display':
	        {
	          resolvedStyle.display = value;
	          // A flex container in React Native has these defaults which should be
	          // set only if there is no otherwise supplied flex style.
	          if (style.display === 'flex' && style.flex == null) {
	            if (style.flexShrink == null) {
	              resolvedStyle.flexShrink = 0;
	            }
	            if (style.flexBasis == null) {
	              resolvedStyle.flexBasis = 'auto';
	            }
	          }
	          break;
	        }
	
	      // The 'flex' property value in React Native must be a positive integer,
	      // 0, or -1.
	      case 'flex':
	        {
	          if (value > 0) {
	            resolvedStyle.flexGrow = value;
	            resolvedStyle.flexShrink = 1;
	            resolvedStyle.flexBasis = '0%';
	          } else if (value === 0) {
	            resolvedStyle.flexGrow = 0;
	            resolvedStyle.flexShrink = 0;
	            resolvedStyle.flexBasis = '0%';
	          } else if (value === -1) {
	            resolvedStyle.flexGrow = 0;
	            resolvedStyle.flexShrink = 1;
	            resolvedStyle.flexBasis = 'auto';
	          }
	          break;
	        }
	
	      case 'fontFamily':
	        {
	          if (value.indexOf('System') > -1) {
	            var stack = value.split(/\s*,\s*/);
	            stack[stack.indexOf('System')] = systemFontStack;
	            resolvedStyle.fontFamily = stack.join(', ');
	          } else if (value === 'monospace') {
	            resolvedStyle.fontFamily = monospaceFontStack;
	          } else {
	            resolvedStyle.fontFamily = value;
	          }
	          break;
	        }
	
	      case 'fontVariant':
	        {
	          if (Array.isArray(value) && value.length > 0) {
	            resolvedStyle.fontVariant = value.join(' ');
	          }
	          break;
	        }
	
	      case 'shadowColor':
	      case 'shadowOffset':
	      case 'shadowOpacity':
	      case 'shadowRadius':
	        {
	          if (!hasResolvedShadow) {
	            resolveShadow(resolvedStyle, style);
	          }
	          hasResolvedShadow = true;
	          break;
	        }
	
	      case 'textAlignVertical':
	        {
	          resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
	          break;
	        }
	
	      case 'textDecorationColor':
	      case 'textDecorationLine':
	      case 'textDecorationStyle':
	        {
	          if (!hasResolvedTextDecoration) {
	            resolveTextDecoration(resolvedStyle, style);
	          }
	          hasResolvedTextDecoration = true;
	          break;
	        }
	
	      case 'textShadowColor':
	      case 'textShadowOffset':
	      case 'textShadowRadius':
	        {
	          if (!hasResolvedTextShadow) {
	            resolveTextShadow(resolvedStyle, style);
	          }
	          hasResolvedTextShadow = true;
	          break;
	        }
	
	      case 'transform':
	      case 'transformMatrix':
	        {
	          resolveTransform(resolvedStyle, style);
	          break;
	        }
	
	      default:
	        {
	          var longFormProperties = styleShortFormProperties[prop];
	          if (longFormProperties) {
	            longFormProperties.forEach(function (longForm, i) {
	              // The value of any longform property in the original styles takes
	              // precedence over the shortform's value.
	              if (styleProps.indexOf(longForm) === -1) {
	                resolvedStyle[longForm] = value;
	              }
	            });
	          } else {
	            resolvedStyle[prop] = value;
	          }
	        }
	    }
	
	    return resolvedStyle;
	  };
	};
	
	var createReactDOMStyle = function createReactDOMStyle(style) {
	  if (!style) {
	    return emptyObject;
	  }
	  var styleProps = Object.keys(style);
	  var sortedStyleProps = alphaSortProps(styleProps);
	  var reducer = createReducer(style, styleProps);
	  var resolvedStyle = sortedStyleProps.reduce(reducer, {});
	  return resolvedStyle;
	};
	
	exports.default = createReactDOMStyle;
	module.exports = exports['default'];

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hyphenateStyleName = __webpack_require__(159);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _mapKeyValue = __webpack_require__(1451);
	
	var _mapKeyValue2 = _interopRequireDefault(_mapKeyValue);
	
	var _normalizeValue = __webpack_require__(814);
	
	var _normalizeValue2 = _interopRequireDefault(_normalizeValue);
	
	var _prefixStyles = __webpack_require__(1058);
	
	var _prefixStyles2 = _interopRequireDefault(_prefixStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var createDeclarationString = function createDeclarationString(prop, val) {
	  var name = (0, _hyphenateStyleName2.default)(prop);
	  var value = (0, _normalizeValue2.default)(prop, val);
	  if (Array.isArray(val)) {
	    return val.map(function (v) {
	      return name + ':' + v;
	    }).join(';');
	  }
	  return name + ':' + value;
	};
	
	/**
	 * Generates valid CSS rule body from a JS object
	 *
	 * createRuleBlock({ width: 20, color: 'blue' });
	 * // => 'color:blue;width:20px'
	 */
	var createRuleBlock = function createRuleBlock(style) {
	  return (0, _mapKeyValue2.default)((0, _prefixStyles2.default)(style), createDeclarationString).sort().join(';');
	};
	
	exports.default = createRuleBlock;
	module.exports = exports['default'];

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ReactNativePropRegistry = __webpack_require__(1049);
	
	var _ReactNativePropRegistry2 = _interopRequireDefault(_ReactNativePropRegistry);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function getStyle(style) {
	  if (typeof style === 'number') {
	    return _ReactNativePropRegistry2.default.getByID(style);
	  }
	  return style;
	}
	
	function flattenStyle(style) {
	  if (!style) {
	    return undefined;
	  }
	
	  if (false) {
	    (0, _invariant2.default)(style !== true, 'style may be false but not true');
	  }
	
	  if (!Array.isArray(style)) {
	    // $FlowFixMe
	    return getStyle(style);
	  }
	
	  var result = {};
	  for (var i = 0, styleLength = style.length; i < styleLength; ++i) {
	    var computedStyle = flattenStyle(style[i]);
	    if (computedStyle) {
	      for (var key in computedStyle) {
	        var value = computedStyle[key];
	        result[key] = value;
	      }
	    }
	  }
	  return result;
	}
	
	exports.default = flattenStyle;
	module.exports = exports['default'];

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _I18nManager = __webpack_require__(125);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _multiplyStyleLengthValue = __webpack_require__(1056);
	
	var _multiplyStyleLengthValue2 = _interopRequireDefault(_multiplyStyleLengthValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var emptyObject = {};
	
	var borderTopLeftRadius = 'borderTopLeftRadius';
	var borderTopRightRadius = 'borderTopRightRadius';
	var borderBottomLeftRadius = 'borderBottomLeftRadius';
	var borderBottomRightRadius = 'borderBottomRightRadius';
	var borderLeftColor = 'borderLeftColor';
	var borderLeftStyle = 'borderLeftStyle';
	var borderLeftWidth = 'borderLeftWidth';
	var borderRightColor = 'borderRightColor';
	var borderRightStyle = 'borderRightStyle';
	var borderRightWidth = 'borderRightWidth';
	var right = 'right';
	var marginLeft = 'marginLeft';
	var marginRight = 'marginRight';
	var paddingLeft = 'paddingLeft';
	var paddingRight = 'paddingRight';
	var left = 'left';
	
	// Map of LTR property names to their BiDi equivalent.
	var PROPERTIES_FLIP = {
	  borderTopLeftRadius: borderTopRightRadius,
	  borderTopRightRadius: borderTopLeftRadius,
	  borderBottomLeftRadius: borderBottomRightRadius,
	  borderBottomRightRadius: borderBottomLeftRadius,
	  borderLeftColor: borderRightColor,
	  borderLeftStyle: borderRightStyle,
	  borderLeftWidth: borderRightWidth,
	  borderRightColor: borderLeftColor,
	  borderRightStyle: borderLeftStyle,
	  borderRightWidth: borderLeftWidth,
	  left: right,
	  marginLeft: marginRight,
	  marginRight: marginLeft,
	  paddingLeft: paddingRight,
	  paddingRight: paddingLeft,
	  right: left
	};
	
	// Map of I18N property names to their LTR equivalent.
	var PROPERTIES_I18N = {
	  borderTopStartRadius: borderTopLeftRadius,
	  borderTopEndRadius: borderTopRightRadius,
	  borderBottomStartRadius: borderBottomLeftRadius,
	  borderBottomEndRadius: borderBottomRightRadius,
	  borderStartColor: borderLeftColor,
	  borderStartStyle: borderLeftStyle,
	  borderStartWidth: borderLeftWidth,
	  borderEndColor: borderRightColor,
	  borderEndStyle: borderRightStyle,
	  borderEndWidth: borderRightWidth,
	  end: right,
	  marginStart: marginLeft,
	  marginEnd: marginRight,
	  paddingStart: paddingLeft,
	  paddingEnd: paddingRight,
	  start: left
	};
	
	var PROPERTIES_VALUE = {
	  clear: true,
	  float: true,
	  textAlign: true
	};
	
	// Invert the sign of a numeric-like value
	var additiveInverse = function additiveInverse(value) {
	  return (0, _multiplyStyleLengthValue2.default)(value, -1);
	};
	
	var i18nStyle = function i18nStyle(originalStyle) {
	  var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	      isRTL = _I18nManager2.default.isRTL;
	
	  var style = originalStyle || emptyObject;
	  var frozenProps = {};
	  var nextStyle = {};
	
	  for (var originalProp in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, originalProp)) {
	      continue;
	    }
	    var originalValue = style[originalProp];
	    var prop = originalProp;
	    var value = originalValue;
	
	    // BiDi flip properties
	    if (PROPERTIES_I18N.hasOwnProperty(originalProp)) {
	      // convert start/end
	      var convertedProp = PROPERTIES_I18N[originalProp];
	      prop = isRTL ? PROPERTIES_FLIP[convertedProp] : convertedProp;
	    } else if (isRTL && doLeftAndRightSwapInRTL && PROPERTIES_FLIP[originalProp]) {
	      prop = PROPERTIES_FLIP[originalProp];
	    }
	
	    // BiDi flip values
	    if (PROPERTIES_VALUE.hasOwnProperty(originalProp)) {
	      if (originalValue === 'start') {
	        value = isRTL ? 'right' : 'left';
	      } else if (originalValue === 'end') {
	        value = isRTL ? 'left' : 'right';
	      } else if (isRTL && doLeftAndRightSwapInRTL) {
	        if (originalValue === 'left') {
	          value = 'right';
	        } else if (originalValue === 'right') {
	          value = 'left';
	        }
	      }
	    }
	
	    if (isRTL && prop === 'textShadowOffset') {
	      nextStyle[prop] = value;
	      nextStyle[prop].width = additiveInverse(value.width);
	    } else if (!frozenProps[prop]) {
	      nextStyle[prop] = value;
	    }
	
	    if (PROPERTIES_I18N[originalProp]) {
	      frozenProps[prop] = true;
	    }
	  }
	
	  return nextStyle;
	};
	
	exports.default = i18nStyle;
	module.exports = exports['default'];

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeColor = __webpack_require__(825);
	
	var _normalizeColor2 = _interopRequireDefault(_normalizeColor);
	
	var _normalizeValue = __webpack_require__(814);
	
	var _normalizeValue2 = _interopRequireDefault(_normalizeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2018-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var defaultOffset = { height: 0, width: 0 };
	
	var resolveShadowValue = function resolveShadowValue(style) {
	  var shadowColor = style.shadowColor,
	      shadowOffset = style.shadowOffset,
	      shadowOpacity = style.shadowOpacity,
	      shadowRadius = style.shadowRadius;
	
	  var _ref = shadowOffset || defaultOffset,
	      height = _ref.height,
	      width = _ref.width;
	
	  var offsetX = (0, _normalizeValue2.default)(null, width);
	  var offsetY = (0, _normalizeValue2.default)(null, height);
	  var blurRadius = (0, _normalizeValue2.default)(null, shadowRadius || 0);
	  var color = (0, _normalizeColor2.default)(shadowColor || 'black', shadowOpacity);
	  if (color) {
	    return offsetX + ' ' + offsetY + ' ' + blurRadius + ' ' + color;
	  }
	};
	
	exports.default = resolveShadowValue;
	module.exports = exports['default'];

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _TextStylePropTypes = __webpack_require__(817);
	
	var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextInputStylePropTypes = Object.assign({}, _TextStylePropTypes2.default, {
	  /* @platform web */
	  caretColor: _ColorPropType2.default,
	  resize: (0, _propTypes.oneOf)(['none', 'vertical', 'horizontal', 'both'])
	}); /**
	     * Copyright (c) 2015-present, Nicolas Gallagher.
	     *
	     * This source code is licensed under the MIT license found in the
	     * LICENSE file in the root directory of this source tree.
	     *
	     * 
	     */
	
	exports.default = TextInputStylePropTypes;
	module.exports = exports['default'];

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ensurePositiveDelayProps = __webpack_require__(819);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _Touchable = __webpack_require__(127);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _TouchableWithoutFeedback = __webpack_require__(820);
	
	var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                              * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @noflow
	                                                                                                                                                                                                                              */
	
	var flattenStyle = _StyleSheet2.default.flatten;
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * A wrapper for making views respond properly to touches.
	 * On press down, the opacity of the wrapped view is decreased, dimming it.
	 *
	 * Opacity is controlled by wrapping the children in a View, which is
	 * added to the view hiearchy. Be aware that this can affect layout.
	 *
	 * Example:
	 *
	 * ```
	 * renderButton: function() {
	 *   return (
	 *     <TouchableOpacity onPress={this._onPressButton}>
	 *       <Image
	 *         style={styles.button}
	 *         source={require('./myButton.png')}
	 *       />
	 *     </TouchableOpacity>
	 *   );
	 * },
	 * ```
	 */
	
	/* eslint-disable react/prefer-es6-class */
	var TouchableOpacity = (0, _createReactClass2.default)({
	  displayName: 'TouchableOpacity',
	  mixins: [_Touchable2.default.Mixin],
	
	  propTypes: Object.assign({}, _TouchableWithoutFeedback2.default.propTypes, {
	    /**
	     * Determines what the opacity of the wrapped view should be when touch is
	     * active.
	     */
	    activeOpacity: _propTypes.number,
	    focusedOpacity: _propTypes.number
	  }),
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      activeOpacity: 0.2,
	      focusedOpacity: 0.7
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return this.touchableGetInitialState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	  },
	
	  /**
	   * Animate the touchable to a new opacity.
	   */
	  setOpacityTo: function setOpacityTo(value, duration) {
	    this.setNativeProps({
	      style: {
	        opacity: value,
	        transitionDuration: duration ? duration / 1000 + 's' : '0s'
	      }
	    });
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    if (e.dispatchConfig.registrationName === 'onResponderGrant') {
	      this._opacityActive(0);
	    } else {
	      this._opacityActive(150);
	    }
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    this._opacityInactive(250);
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn || 0;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut;
	  },
	
	  _opacityActive: function _opacityActive(duration) {
	    this.setOpacityTo(this.props.activeOpacity, duration);
	  },
	
	  _opacityInactive: function _opacityInactive(duration) {
	    this.setOpacityTo(this._getChildStyleOpacityWithDefault(), duration);
	  },
	
	  _opacityFocused: function _opacityFocused() {
	    this.setOpacityTo(this.props.focusedOpacity);
	  },
	
	  _getChildStyleOpacityWithDefault: function _getChildStyleOpacityWithDefault() {
	    var childStyle = flattenStyle(this.props.style) || {};
	    return childStyle.opacity === undefined ? 1 : childStyle.opacity;
	  },
	
	  render: function render() {
	    var _props = this.props,
	        activeOpacity = _props.activeOpacity,
	        focusedOpacity = _props.focusedOpacity,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['activeOpacity', 'focusedOpacity', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, {
	        accessible: this.props.accessible !== false,
	        onKeyDown: this.touchableHandleKeyEvent,
	        onKeyUp: this.touchableHandleKeyEvent,
	        onResponderGrant: this.touchableHandleResponderGrant,
	        onResponderMove: this.touchableHandleResponderMove,
	        onResponderRelease: this.touchableHandleResponderRelease,
	        onResponderTerminate: this.touchableHandleResponderTerminate,
	        onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	        onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	        style: [styles.root, !this.props.disabled && styles.actionable, this.props.style]
	      }),
	      this.props.children,
	      _Touchable2.default.renderDebugView({ color: 'blue', hitSlop: this.props.hitSlop })
	    );
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    transitionProperty: 'opacity',
	    transitionDuration: '0.15s',
	    userSelect: 'none'
	  },
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(TouchableOpacity);
	module.exports = exports['default'];

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _EdgeInsetsPropType = __webpack_require__(811);
	
	var _EdgeInsetsPropType2 = _interopRequireDefault(_EdgeInsetsPropType);
	
	var _StyleSheetPropType = __webpack_require__(109);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _ViewStylePropTypes = __webpack_require__(108);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var stylePropType = (0, _StyleSheetPropType2.default)(_ViewStylePropTypes2.default);
	
	var ViewPropTypes = {
	  accessibilityComponentType: _propTypes.string,
	  accessibilityLabel: _propTypes.string,
	  accessibilityLiveRegion: (0, _propTypes.oneOf)(['assertive', 'none', 'polite']),
	  accessibilityRole: _propTypes.string,
	  accessibilityTraits: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),
	  accessible: _propTypes.bool,
	  children: _propTypes.any,
	  hitSlop: _EdgeInsetsPropType2.default,
	  importantForAccessibility: (0, _propTypes.oneOf)(['auto', 'no', 'no-hide-descendants', 'yes']),
	  nativeID: _propTypes.string,
	  onBlur: _propTypes.func,
	  onClick: _propTypes.func,
	  onClickCapture: _propTypes.func,
	  onContextMenu: _propTypes.func,
	  onFocus: _propTypes.func,
	  onLayout: _propTypes.func,
	  onMoveShouldSetResponder: _propTypes.func,
	  onMoveShouldSetResponderCapture: _propTypes.func,
	  onResponderGrant: _propTypes.func,
	  onResponderMove: _propTypes.func,
	  onResponderReject: _propTypes.func,
	  onResponderRelease: _propTypes.func,
	  onResponderTerminate: _propTypes.func,
	  onResponderTerminationRequest: _propTypes.func,
	  onStartShouldSetResponder: _propTypes.func,
	  onStartShouldSetResponderCapture: _propTypes.func,
	  onTouchCancel: _propTypes.func,
	  onTouchCancelCapture: _propTypes.func,
	  onTouchEnd: _propTypes.func,
	  onTouchEndCapture: _propTypes.func,
	  onTouchMove: _propTypes.func,
	  onTouchMoveCapture: _propTypes.func,
	  onTouchStart: _propTypes.func,
	  onTouchStartCapture: _propTypes.func,
	  pointerEvents: (0, _propTypes.oneOf)(['auto', 'box-none', 'box-only', 'none']),
	  style: stylePropType,
	  testID: _propTypes.string,
	  // compatibility with React Native
	  accessibilityViewIsModal: _propTypes.bool,
	  collapsable: _propTypes.bool,
	  needsOffscreenAlphaCompositing: _propTypes.bool,
	  onAccessibilityTap: _propTypes.func,
	  onMagicTap: _propTypes.func,
	  removeClippedSubviews: _propTypes.bool,
	  renderToHardwareTextureAndroid: _propTypes.bool,
	  shouldRasterizeIOS: _propTypes.bool,
	  tvParallaxProperties: _propTypes.object
	};
	
	exports.default = ViewPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeCssColor = __webpack_require__(160);
	
	var _normalizeCssColor2 = _interopRequireDefault(_normalizeCssColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var processColor = function processColor(color) {
	  if (color === undefined || color === null) {
	    return color;
	  }
	
	  // convert number and hex
	  var int32Color = (0, _normalizeCssColor2.default)(color);
	  if (int32Color === undefined || int32Color === null) {
	    return undefined;
	  }
	
	  int32Color = (int32Color << 24 | int32Color >>> 8) >>> 0;
	
	  return int32Color;
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = processColor;
	module.exports = exports['default'];

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactDom = __webpack_require__(65);
	
	exports.default = _reactDom.render; /**
	                                     * Copyright (c) 2016-present, Nicolas Gallagher.
	                                     *
	                                     * This source code is licensed under the MIT license found in the
	                                     * LICENSE file in the root directory of this source tree.
	                                     *
	                                     * @noflow
	                                     */
	
	module.exports = exports['default'];

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactDom = __webpack_require__(65);
	
	exports.default = _reactDom.unmountComponentAtNode; /**
	                                                     * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                     *
	                                                     * This source code is licensed under the MIT license found in the
	                                                     * LICENSE file in the root directory of this source tree.
	                                                     *
	                                                     * @noflow
	                                                     */
	
	module.exports = exports['default'];

/***/ },
/* 1044 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var accessibilityComponentTypeToRole = {
	  button: 'button',
	  none: 'presentation'
	};
	
	var accessibilityTraitsToRole = {
	  adjustable: 'slider',
	  button: 'button',
	  header: 'heading',
	  image: 'img',
	  link: 'link',
	  none: 'presentation',
	  search: 'search',
	  summary: 'region'
	};
	
	/**
	 * Provides compatibility with React Native's "accessibilityTraits" (iOS) and
	 * "accessibilityComponentType" (Android), converting them to equivalent ARIA
	 * roles.
	 */
	var propsToAriaRole = function propsToAriaRole(_ref) {
	  var accessibilityComponentType = _ref.accessibilityComponentType,
	      accessibilityRole = _ref.accessibilityRole,
	      accessibilityTraits = _ref.accessibilityTraits;
	
	  if (accessibilityRole) {
	    return accessibilityRole;
	  }
	  if (accessibilityTraits) {
	    var trait = Array.isArray(accessibilityTraits) ? accessibilityTraits[0] : accessibilityTraits;
	    return accessibilityTraitsToRole[trait];
	  }
	  if (accessibilityComponentType) {
	    return accessibilityComponentTypeToRole[accessibilityComponentType];
	  }
	};
	
	exports.default = propsToAriaRole;
	module.exports = exports['default'];

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var AnimationPropTypes = {
	  animationDelay: _propTypes.string,
	  animationDirection: (0, _propTypes.oneOf)(['alternate', 'alternate-reverse', 'normal', 'reverse']),
	  animationDuration: _propTypes.string,
	  animationFillMode: (0, _propTypes.oneOf)(['none', 'forwards', 'backwards', 'both']),
	  animationIterationCount: (0, _propTypes.oneOfType)([_propTypes.number, (0, _propTypes.oneOf)(['infinite'])]),
	  animationName: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object]))]),
	  animationPlayState: (0, _propTypes.oneOf)(['paused', 'running']),
	  animationTimingFunction: _propTypes.string,
	  transitionDelay: _propTypes.string,
	  transitionDuration: _propTypes.string,
	  transitionProperty: _propTypes.string,
	  transitionTimingFunction: _propTypes.string
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = AnimationPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	var BorderStylePropType = (0, _propTypes.oneOf)(['solid', 'dotted', 'dashed']);
	
	var BorderPropTypes = {
	  borderColor: _ColorPropType2.default,
	  borderBottomColor: _ColorPropType2.default,
	  borderEndColor: _ColorPropType2.default,
	  borderLeftColor: _ColorPropType2.default,
	  borderRightColor: _ColorPropType2.default,
	  borderStartColor: _ColorPropType2.default,
	  borderTopColor: _ColorPropType2.default,
	  borderRadius: numberOrString,
	  borderBottomEndRadius: numberOrString,
	  borderBottomLeftRadius: numberOrString,
	  borderBottomRightRadius: numberOrString,
	  borderBottomStartRadius: numberOrString,
	  borderTopEndRadius: numberOrString,
	  borderTopLeftRadius: numberOrString,
	  borderTopRightRadius: numberOrString,
	  borderTopStartRadius: numberOrString,
	  borderStyle: BorderStylePropType,
	  borderBottomStyle: BorderStylePropType,
	  borderEndStyle: BorderStylePropType,
	  borderLeftStyle: BorderStylePropType,
	  borderRightStyle: BorderStylePropType,
	  borderStartStyle: BorderStylePropType,
	  borderTopStyle: BorderStylePropType
	};
	
	exports.default = BorderPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var InteractionPropTypes = {
	  cursor: _propTypes.string,
	  touchAction: (0, _propTypes.oneOf)(['auto', 'inherit', 'manipulation', 'none', 'pan-down', 'pan-left', 'pan-right', 'pan-up', 'pan-x', 'pan-y', 'pinch-zoom']),
	  userSelect: _propTypes.string,
	  willChange: _propTypes.string
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = InteractionPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var OverflowPropType = (0, _propTypes.oneOf)(['auto', 'hidden', 'scroll', 'visible']); /**
	                                                                                        * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                        *
	                                                                                        * This source code is licensed under the MIT license found in the
	                                                                                        * LICENSE file in the root directory of this source tree.
	                                                                                        *
	                                                                                        * 
	                                                                                        */
	
	var hiddenOrVisible = (0, _propTypes.oneOf)(['hidden', 'visible']);
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	
	var LayoutPropTypes = {
	  alignContent: (0, _propTypes.oneOf)(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'stretch']),
	  alignItems: (0, _propTypes.oneOf)(['baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
	  alignSelf: (0, _propTypes.oneOf)(['auto', 'baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
	  backfaceVisibility: hiddenOrVisible,
	  borderWidth: numberOrString,
	  borderBottomWidth: numberOrString,
	  borderEndWidth: numberOrString,
	  borderLeftWidth: numberOrString,
	  borderRightWidth: numberOrString,
	  borderStartWidth: numberOrString,
	  borderTopWidth: numberOrString,
	  bottom: numberOrString,
	  boxSizing: _propTypes.string,
	  direction: (0, _propTypes.oneOf)(['inherit', 'ltr', 'rtl']),
	  display: _propTypes.string,
	  end: numberOrString,
	  flex: _propTypes.number,
	  flexBasis: numberOrString,
	  flexDirection: (0, _propTypes.oneOf)(['column', 'column-reverse', 'row', 'row-reverse']),
	  flexGrow: _propTypes.number,
	  flexShrink: _propTypes.number,
	  flexWrap: (0, _propTypes.oneOf)(['nowrap', 'wrap', 'wrap-reverse']),
	  height: numberOrString,
	  justifyContent: (0, _propTypes.oneOf)(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly']),
	  left: numberOrString,
	  margin: numberOrString,
	  marginBottom: numberOrString,
	  marginHorizontal: numberOrString,
	  marginEnd: numberOrString,
	  marginLeft: numberOrString,
	  marginRight: numberOrString,
	  marginStart: numberOrString,
	  marginTop: numberOrString,
	  marginVertical: numberOrString,
	  maxHeight: numberOrString,
	  maxWidth: numberOrString,
	  minHeight: numberOrString,
	  minWidth: numberOrString,
	  order: _propTypes.number,
	  overflow: OverflowPropType,
	  overflowX: OverflowPropType,
	  overflowY: OverflowPropType,
	  padding: numberOrString,
	  paddingBottom: numberOrString,
	  paddingHorizontal: numberOrString,
	  paddingEnd: numberOrString,
	  paddingLeft: numberOrString,
	  paddingRight: numberOrString,
	  paddingStart: numberOrString,
	  paddingTop: numberOrString,
	  paddingVertical: numberOrString,
	  position: (0, _propTypes.oneOf)(['absolute', 'fixed', 'relative', 'static', 'sticky']),
	  right: numberOrString,
	  start: numberOrString,
	  top: numberOrString,
	  visibility: hiddenOrVisible,
	  width: numberOrString,
	  zIndex: _propTypes.number,
	  /**
	   * @platform unsupported
	   */
	  aspectRatio: _propTypes.number,
	  /**
	   * @platform web
	   */
	  gridAutoColumns: _propTypes.string,
	  gridAutoFlow: _propTypes.string,
	  gridAutoRows: _propTypes.string,
	  gridColumnEnd: _propTypes.string,
	  gridColumnGap: _propTypes.string,
	  gridColumnStart: _propTypes.string,
	  gridRowEnd: _propTypes.string,
	  gridRowGap: _propTypes.string,
	  gridRowStart: _propTypes.string,
	  gridTemplateColumns: _propTypes.string,
	  gridTemplateRows: _propTypes.string,
	  gridTemplateAreas: _propTypes.string
	};
	
	exports.default = LayoutPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var emptyObject = {};
	var objects = {};
	var prefix = 'r';
	var uniqueID = 1;
	
	var createKey = function createKey(id) {
	  return prefix + '-' + id;
	};
	
	var ReactNativePropRegistry = function () {
	  function ReactNativePropRegistry() {
	    _classCallCheck(this, ReactNativePropRegistry);
	  }
	
	  ReactNativePropRegistry.register = function register(object) {
	    var id = uniqueID++;
	    if (false) {
	      Object.freeze(object);
	    }
	    var key = createKey(id);
	    objects[key] = object;
	    return id;
	  };
	
	  ReactNativePropRegistry.getByID = function getByID(id) {
	    if (!id) {
	      // Used in the style={[condition && id]} pattern,
	      // we want it to be a no-op when the value is false or null
	      return emptyObject;
	    }
	    var key = createKey(id);
	    var object = objects[key];
	    if (!object) {
	      console.warn('Invalid style with id `' + id + '`. Skipping ...');
	      return emptyObject;
	    }
	    return object;
	  };
	
	  return ReactNativePropRegistry;
	}();
	
	exports.default = ReactNativePropRegistry;
	module.exports = exports['default'];

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dimensions = __webpack_require__(124);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Platform = __webpack_require__(106);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _TextInputState = __webpack_require__(822);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Mixin that can be integrated in order to handle scrolling that plays well
	 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
	 * views, or even your custom built (every-frame animating) scroll views so that
	 * all of these systems play well with the `ResponderEventPlugin`.
	 *
	 * iOS scroll event timing nuances:
	 * ===============================
	 *
	 *
	 * Scrolling without bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... physical touch starts ...
	 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
	 * 3. `onTouchStart`          (same, but bubble phase)
	 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
	 * 5. `onMomentumScrollEnd`
	 *
	 *
	 * Scrolling with bouncing, if you touch down:
	 * -------------------------------
	 *
	 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
	 *    ... bounce begins ...
	 *    ... some time elapses ...
	 *    ... physical touch during bounce ...
	 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
	 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
	 * 4. `onTouchStart`          (same, but bubble phase)
	 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
	 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
	 *
	 * So when we receive an `onTouchStart`, how can we tell if we are touching
	 * *during* an animation (which then causes the animation to stop)? The only way
	 * to tell is if the `touchStart` occurred immediately after the
	 * `onMomentumScrollEnd`.
	 *
	 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
	 * necessary
	 *
	 * `ScrollResponder` also includes logic for blurring a currently focused input
	 * if one is focused while scrolling. The `ScrollResponder` is a natural place
	 * to put this logic since it can support not dismissing the keyboard while
	 * scrolling, unless a recognized "tap"-like gesture has occurred.
	 *
	 * The public lifecycle API includes events for keyboard interaction, responder
	 * interaction, and scrolling (among others). The keyboard callbacks
	 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
	 * responder's props so that you can guarantee that the scroll responder's
	 * internal state has been updated accordingly (and deterministically) by
	 * the time the props callbacks are invoke. Otherwise, you would always wonder
	 * if the scroll responder is currently in a state where it recognizes new
	 * keyboard positions etc. If coordinating scrolling with keyboard movement,
	 * *always* use these hooks instead of listening to your own global keyboard
	 * events.
	 *
	 * Public keyboard lifecycle API: (props callbacks)
	 *
	 * Standard Keyboard Appearance Sequence:
	 *
	 *   this.props.onKeyboardWillShow
	 *   this.props.onKeyboardDidShow
	 *
	 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
	 * tap inside the scroll responder's scrollable region was responsible
	 * for the dismissal of the keyboard. There are other reasons why the
	 * keyboard could be dismissed.
	 *
	 *   this.props.onScrollResponderKeyboardDismissed
	 *
	 * Standard Keyboard Hide Sequence:
	 *
	 *   this.props.onKeyboardWillHide
	 *   this.props.onKeyboardDidHide
	 */
	
	var emptyObject = {}; /**
	                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                       * Copyright (c) 2015-present, Facebook, Inc.
	                       *
	                       * This source code is licensed under the MIT license found in the
	                       * LICENSE file in the root directory of this source tree.
	                       *
	                       * 
	                       */
	
	var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;
	
	var ScrollResponderMixin = {
	  // mixins: [Subscribable.Mixin],
	  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
	    return {
	      isTouching: false,
	      lastMomentumScrollBeginTime: 0,
	      lastMomentumScrollEndTime: 0,
	
	      // Reset to false every time becomes responder. This is used to:
	      // - Determine if the scroll view has been scrolled and therefore should
	      // refuse to give up its responder lock.
	      // - Determine if releasing should dismiss the keyboard when we are in
	      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
	      observedScrollSinceBecomingResponder: false,
	      becameResponderWhileAnimating: false
	    };
	  },
	
	  /**
	   * Invoke this from an `onScroll` event.
	   */
	  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
	    return this.state.isTouching;
	  },
	
	  /**
	   * Merely touch starting is not sufficient for a scroll view to become the
	   * responder. Being the "responder" means that the very next touch move/end
	   * event will result in an action/movement.
	   *
	   * Invoke this from an `onStartShouldSetResponder` event.
	   *
	   * `onStartShouldSetResponder` is used when the next move/end will trigger
	   * some UI movement/action, but when you want to yield priority to views
	   * nested inside of the view.
	   *
	   * There may be some cases where scroll views actually should return `true`
	   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
	   * that gives priority to nested views.
	   *
	   * - If a single tap on the scroll view triggers an action such as
	   *   recentering a map style view yet wants to give priority to interaction
	   *   views inside (such as dropped pins or labels), then we would return true
	   *   from this method when there is a single touch.
	   *
	   * - Similar to the previous case, if a two finger "tap" should trigger a
	   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
	   *   true.
	   *
	   */
	  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
	    return false;
	  },
	
	  /**
	   * There are times when the scroll view wants to become the responder
	   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
	   * that *doesn't* give priority to nested views (hence the capture phase):
	   *
	   * - Currently animating.
	   * - Tapping anywhere that is not the focused input, while the keyboard is
	   *   up (which should dismiss the keyboard).
	   *
	   * Invoke this from an `onStartShouldSetResponderCapture` event.
	   */
	  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
	    // First see if we want to eat taps while the keyboard is up
	    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
	    // if (!this.props.keyboardShouldPersistTaps &&
	    //   currentlyFocusedTextInput != null &&
	    //   e.target !== currentlyFocusedTextInput) {
	    //   return true;
	    // }
	    return this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Invoke this from an `onResponderReject` event.
	   *
	   * Some other element is not yielding its role as responder. Normally, we'd
	   * just disable the `UIScrollView`, but a touch has already began on it, the
	   * `UIScrollView` will not accept being disabled after that. The easiest
	   * solution for now is to accept the limitation of disallowing this
	   * altogether. To improve this, find a way to disable the `UIScrollView` after
	   * a touch has already started.
	   */
	  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
	    (0, _warning2.default)(false, "ScrollView doesn't take rejection well - scrolls anyway");
	  },
	
	  /**
	   * We will allow the scroll view to give up its lock iff it acquired the lock
	   * during an animation. This is a very useful default that happens to satisfy
	   * many common user experiences.
	   *
	   * - Stop a scroll on the left edge, then turn that into an outer view's
	   *   backswipe.
	   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
	   *   view dismiss.
	   * - However, without catching the scroll view mid-bounce (while it is
	   *   motionless), if you drag far enough for the scroll view to become
	   *   responder (and therefore drag the scroll view a bit), any backswipe
	   *   navigation of a swipe gesture higher in the view hierarchy, should be
	   *   rejected.
	   */
	  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
	    return !this.state.observedScrollSinceBecomingResponder;
	  },
	
	  /**
	   * Invoke this from an `onTouchEnd` event.
	   *
	   * @param {SyntheticEvent} e Event.
	   */
	  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
	    var nativeEvent = e.nativeEvent;
	    this.state.isTouching = nativeEvent.touches.length !== 0;
	    this.props.onTouchEnd && this.props.onTouchEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderRelease` event.
	   */
	  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
	    this.props.onResponderRelease && this.props.onResponderRelease(e);
	
	    // By default scroll views will unfocus a textField
	    // if another touch occurs outside of it
	    var currentlyFocusedTextInput = _TextInputState2.default.currentlyFocusedField();
	    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
	      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
	      _TextInputState2.default.blurTextInput(currentlyFocusedTextInput);
	    }
	  },
	
	  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
	    this.state.observedScrollSinceBecomingResponder = true;
	    this.props.onScroll && this.props.onScroll(e);
	  },
	
	  /**
	   * Invoke this from an `onResponderGrant` event.
	   */
	  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
	    this.state.observedScrollSinceBecomingResponder = false;
	    this.props.onResponderGrant && this.props.onResponderGrant(e);
	    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
	  },
	
	  /**
	   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
	   * animation, and there's not an easy way to distinguish a drag vs. stopping
	   * momentum.
	   *
	   * Invoke this from an `onScrollBeginDrag` event.
	   */
	  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
	    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onScrollEndDrag` event.
	   */
	  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
	    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollBegin` event.
	   */
	  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
	    this.state.lastMomentumScrollBeginTime = Date.now();
	    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
	  },
	
	  /**
	   * Invoke this from an `onMomentumScrollEnd` event.
	   */
	  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
	    this.state.lastMomentumScrollEndTime = Date.now();
	    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchStart` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
	    this.state.isTouching = true;
	    this.props.onTouchStart && this.props.onTouchStart(e);
	  },
	
	  /**
	   * Invoke this from an `onTouchMove` event.
	   *
	   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
	   * order, after `ResponderEventPlugin`, we can detect that we were *not*
	   * permitted to be the responder (presumably because a contained view became
	   * responder). The `onResponderReject` won't fire in that case - it only
	   * fires when a *current* responder rejects our request.
	   *
	   * @param {SyntheticEvent} e Touch Start event.
	   */
	  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
	    this.props.onTouchMove && this.props.onTouchMove(e);
	  },
	
	  /**
	   * A helper function for this class that lets us quickly determine if the
	   * view is currently animating. This is particularly useful to know when
	   * a touch has just started or ended.
	   */
	  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
	    var now = Date.now();
	    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
	    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
	    return isAnimating;
	  },
	
	  /**
	   * Returns the node that represents native view that can be scrolled.
	   * Components can pass what node to use by defining a `getScrollableNode`
	   * function otherwise `this` is used.
	   */
	  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
	    return this.getScrollableNode ? this.getScrollableNode() : (0, _findNodeHandle2.default)(this);
	  },
	
	  /**
	   * A helper function to scroll to a specific point in the scrollview.
	   * This is currently used to help focus on child textviews, but can also
	   * be used to quickly scroll to any element we want to focus. Syntax:
	   *
	   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
	   *
	   * Note: The weird argument signature is due to the fact that, for historical reasons,
	   * the function also accepts separate arguments as as alternative to the options object.
	   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
	   */
	  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
	    if (typeof x === 'number') {
	      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
	    } else {
	      var _ref = x || emptyObject;
	
	      x = _ref.x;
	      y = _ref.y;
	      animated = _ref.animated;
	    }
	    var node = this.scrollResponderGetScrollableNode();
	    _UIManager2.default.updateView(node, { style: { scrollBehavior: !animated ? 'auto' : 'smooth' } }, this);
	    node.scrollLeft = x || 0;
	    node.scrollTop = y || 0;
	  },
	
	  /**
	   * Deprecated, do not use.
	   */
	  scrollResponderScrollWithoutAnimationTo: function scrollResponderScrollWithoutAnimationTo(offsetX, offsetY) {
	    console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');
	    this.scrollResponderScrollTo({ x: offsetX, y: offsetY, animated: false });
	  },
	
	  /**
	   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
	   * {x: number; y: number; width: number; height: number; animated: boolean = true}
	   *
	   * @platform ios
	   */
	  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated // deprecated, put this inside the rect argument instead
	  ) {
	    if (_Platform2.default.OS !== 'ios') {
	      (0, _invariant2.default)('zoomToRect is not implemented');
	    }
	  },
	
	  /**
	   * Displays the scroll indicators momentarily.
	   */
	  scrollResponderFlashScrollIndicators: function scrollResponderFlashScrollIndicators() {},
	
	  /**
	   * This method should be used as the callback to onFocus in a TextInputs'
	   * parent view. Note that any module using this mixin needs to return
	   * the parent view's ref in getScrollViewRef() in order to use this method.
	   * @param {any} nodeHandle The TextInput node handle
	   * @param {number} additionalOffset The scroll view's top "contentInset".
	   *        Default is 0.
	   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
	   *        down to make it meet the keyboard's top. Default is false.
	   */
	  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
	    this.additionalScrollOffset = additionalOffset || 0;
	    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
	    _UIManager2.default.measureLayout(nodeHandle, (0, _findNodeHandle2.default)(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
	  },
	
	  /**
	   * The calculations performed here assume the scroll view takes up the entire
	   * screen - even if has some content inset. We then measure the offsets of the
	   * keyboard, and compensate both for the scroll view's "contentInset".
	   *
	   * @param {number} left Position of input w.r.t. table view.
	   * @param {number} top Position of input w.r.t. table view.
	   * @param {number} width Width of the text input.
	   * @param {number} height Height of the text input.
	   */
	  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
	    var keyboardScreenY = _Dimensions2.default.get('window').height;
	    if (this.keyboardWillOpenTo) {
	      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
	    }
	    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset;
	
	    // By default, this can scroll with negative offset, pulling the content
	    // down so that the target component's bottom meets the keyboard's top.
	    // If requested otherwise, cap the offset at 0 minimum to avoid content
	    // shifting down.
	    if (this.preventNegativeScrollOffset) {
	      scrollOffsetY = Math.max(0, scrollOffsetY);
	    }
	    this.scrollResponderScrollTo({ x: 0, y: scrollOffsetY, animated: true });
	
	    this.additionalOffset = 0;
	    this.preventNegativeScrollOffset = false;
	  },
	
	  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
	    console.error('Error measuring text field: ', e);
	  },
	
	  /**
	   * `componentWillMount` is the closest thing to a  standard "constructor" for
	   * React components.
	   *
	   * The `keyboardWillShow` is called before input focus.
	   */
	  componentWillMount: function componentWillMount() {
	    this.keyboardWillOpenTo = null;
	    this.additionalScrollOffset = 0;
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
	    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
	  },
	
	  /**
	   * Warning, this may be called several times for a single keyboard opening.
	   * It's best to store the information in this method and then take any action
	   * at a later point (either in `keyboardDidShow` or other).
	   *
	   * Here's the order that events occur in:
	   * - focus
	   * - willShow {startCoordinates, endCoordinates} several times
	   * - didShow several times
	   * - blur
	   * - willHide {startCoordinates, endCoordinates} several times
	   * - didHide several times
	   *
	   * The `ScrollResponder` providesModule callbacks for each of these events.
	   * Even though any user could have easily listened to keyboard events
	   * themselves, using these `props` callbacks ensures that ordering of events
	   * is consistent - and not dependent on the order that the keyboard events are
	   * subscribed to. This matters when telling the scroll view to scroll to where
	   * the keyboard is headed - the scroll responder better have been notified of
	   * the keyboard destination before being instructed to scroll to where the
	   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
	   * will work.
	   *
	   * WARNING: These callbacks will fire even if a keyboard is displayed in a
	   * different navigation pane. Filter out the events to determine if they are
	   * relevant to you. (For example, only if you receive these callbacks after
	   * you had explicitly focused a node etc).
	   */
	  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
	    this.keyboardWillOpenTo = e;
	    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
	  },
	
	  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
	  },
	
	  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
	    // TODO(7693961): The event for DidShow is not available on iOS yet.
	    // Use the one from WillShow and do not assign.
	    if (e) {
	      this.keyboardWillOpenTo = e;
	    }
	    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
	  },
	
	  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
	    this.keyboardWillOpenTo = null;
	    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
	  }
	};
	
	var ScrollResponder = {
	  Mixin: ScrollResponderMixin
	};
	
	exports.default = ScrollResponder;
	module.exports = exports['default'];

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]);
	
	var ShadowPropTypes = {
	  shadowColor: _ColorPropType2.default,
	  shadowOffset: (0, _propTypes.shape)({
	    width: numberOrString,
	    height: numberOrString
	  }),
	  shadowOpacity: _propTypes.number,
	  shadowRadius: numberOrString,
	  shadowSpread: numberOrString
	};
	
	exports.default = ShadowPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var numberOrString = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]); /**
	                                                                                         * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                         *
	                                                                                         * This source code is licensed under the MIT license found in the
	                                                                                         * LICENSE file in the root directory of this source tree.
	                                                                                         *
	                                                                                         * 
	                                                                                         */
	
	var TransformPropTypes = {
	  perspective: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
	  perspectiveOrigin: _propTypes.string,
	  transform: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([(0, _propTypes.shape)({ perspective: numberOrString }), (0, _propTypes.shape)({ rotate: _propTypes.string }), (0, _propTypes.shape)({ rotateX: _propTypes.string }), (0, _propTypes.shape)({ rotateY: _propTypes.string }), (0, _propTypes.shape)({ rotateZ: _propTypes.string }), (0, _propTypes.shape)({ scale: _propTypes.number }), (0, _propTypes.shape)({ scaleX: _propTypes.number }), (0, _propTypes.shape)({ scaleY: _propTypes.number }), (0, _propTypes.shape)({ skewX: _propTypes.string }), (0, _propTypes.shape)({ skewY: _propTypes.string }), (0, _propTypes.shape)({ translateX: numberOrString }), (0, _propTypes.shape)({ translateY: numberOrString }), (0, _propTypes.shape)({ translateZ: numberOrString }), (0, _propTypes.shape)({ translate3d: _propTypes.string })])),
	  transformOrigin: _propTypes.string,
	  transformStyle: (0, _propTypes.oneOf)(['flat', 'preserve-3d'])
	};
	
	exports.default = TransformPropTypes;
	module.exports = exports['default'];

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AccessibilityUtil = __webpack_require__(821);
	
	var _AccessibilityUtil2 = _interopRequireDefault(_AccessibilityUtil);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _styleResolver2 = __webpack_require__(815);
	
	var _styleResolver3 = _interopRequireDefault(_styleResolver2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @noflow
	                                                                                                                                                                                                                              */
	
	var emptyObject = {};
	
	var resetStyles = _StyleSheet2.default.create({
	  ariaButton: {
	    cursor: 'pointer'
	  },
	  button: {
	    appearance: 'none',
	    backgroundColor: 'transparent',
	    color: 'inherit',
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit',
	    textAlign: 'inherit'
	  },
	  heading: {
	    fontFamily: 'inherit',
	    fontSize: 'inherit',
	    fontStyle: 'inherit',
	    fontVariant: ['inherit'],
	    fontWeight: 'inherit',
	    lineHeight: 'inherit'
	  },
	  link: {
	    backgroundColor: 'transparent',
	    color: 'inherit',
	    textDecorationLine: 'none'
	  },
	  list: {
	    listStyle: 'none'
	  }
	});
	
	var pointerEventsStyles = _StyleSheet2.default.create({
	  auto: {
	    pointerEvents: 'auto'
	  },
	  'box-none': {
	    pointerEvents: 'box-none'
	  },
	  'box-only': {
	    pointerEvents: 'box-only'
	  },
	  none: {
	    pointerEvents: 'none'
	  }
	});
	
	var defaultStyleResolver = function defaultStyleResolver(style) {
	  return _styleResolver3.default.resolve(style);
	};
	
	var createDOMProps = function createDOMProps(component, props, styleResolver) {
	  if (!styleResolver) {
	    styleResolver = defaultStyleResolver;
	  }
	
	  if (!props) {
	    props = emptyObject;
	  }
	
	  var _props = props,
	      accessibilityLabel = _props.accessibilityLabel,
	      accessibilityLiveRegion = _props.accessibilityLiveRegion,
	      importantForAccessibility = _props.importantForAccessibility,
	      nativeID = _props.nativeID,
	      placeholderTextColor = _props.placeholderTextColor,
	      pointerEvents = _props.pointerEvents,
	      providedStyle = _props.style,
	      testID = _props.testID,
	      accessible = _props.accessible,
	      accessibilityComponentType = _props.accessibilityComponentType,
	      accessibilityRole = _props.accessibilityRole,
	      accessibilityTraits = _props.accessibilityTraits,
	      domProps = _objectWithoutProperties(_props, ['accessibilityLabel', 'accessibilityLiveRegion', 'importantForAccessibility', 'nativeID', 'placeholderTextColor', 'pointerEvents', 'style', 'testID', 'accessible', 'accessibilityComponentType', 'accessibilityRole', 'accessibilityTraits']);
	
	  var disabled = _AccessibilityUtil2.default.isDisabled(props);
	  var role = _AccessibilityUtil2.default.propsToAriaRole(props);
	
	  // GENERAL ACCESSIBILITY
	  if (importantForAccessibility === 'no-hide-descendants') {
	    domProps['aria-hidden'] = true;
	  }
	  if (accessibilityLabel && accessibilityLabel.constructor === String) {
	    domProps['aria-label'] = accessibilityLabel;
	  }
	  if (accessibilityLiveRegion && accessibilityLiveRegion.constructor === String) {
	    domProps['aria-live'] = accessibilityLiveRegion === 'none' ? 'off' : accessibilityLiveRegion;
	  }
	  if (role && role.constructor === String && role !== 'label') {
	    domProps.role = role;
	  }
	
	  // DISABLED
	  if (disabled) {
	    domProps['aria-disabled'] = disabled;
	    domProps.disabled = disabled;
	  }
	
	  // FOCUS
	  // Assume that 'link' is focusable by default (uses <a>).
	  // Assume that 'button' is not (uses <div role='button'>) but must be treated as such.
	  var focusable = !disabled && importantForAccessibility !== 'no' && importantForAccessibility !== 'no-hide-descendants';
	  if (role === 'link' || component === 'input' || component === 'select' || component === 'textarea') {
	    if (accessible === false || !focusable) {
	      domProps.tabIndex = '-1';
	    } else {
	      domProps['data-focusable'] = true;
	    }
	  } else if (_AccessibilityUtil2.default.buttonLikeRoles[role] || role === 'textbox') {
	    if (accessible !== false && focusable) {
	      domProps['data-focusable'] = true;
	      domProps.tabIndex = '0';
	    }
	  } else {
	    if (accessible === true && focusable) {
	      domProps['data-focusable'] = true;
	      domProps.tabIndex = '0';
	    }
	  }
	
	  // STYLE
	  // Resolve React Native styles to optimized browser equivalent
	  var reactNativeStyle = [component === 'a' && resetStyles.link, component === 'button' && resetStyles.button, role === 'heading' && resetStyles.heading, component === 'ul' && resetStyles.list, role === 'button' && !disabled && resetStyles.ariaButton, pointerEvents && pointerEventsStyles[pointerEvents], providedStyle, placeholderTextColor && { placeholderTextColor: placeholderTextColor }];
	
	  var _styleResolver = styleResolver(reactNativeStyle),
	      className = _styleResolver.className,
	      style = _styleResolver.style;
	
	  if (className && className.constructor === String) {
	    domProps.className = props.className ? props.className + ' ' + className : className;
	  }
	  if (style) {
	    domProps.style = style;
	  }
	
	  // OTHER
	  // Native element ID
	  if (nativeID && nativeID.constructor === String) {
	    domProps.id = nativeID;
	  }
	  // Link security and automation test ids
	  if (component === 'a' && domProps.target === '_blank') {
	    domProps.rel = (domProps.rel || '') + ' noopener noreferrer';
	  }
	  // Automated test IDs
	  if (testID && testID.constructor === String) {
	    domProps['data-testid'] = testID;
	  }
	
	  return domProps;
	};
	
	exports.default = createDOMProps;
	module.exports = exports['default'];

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TextInputState = __webpack_require__(822);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dismissKeyboard = function dismissKeyboard() {
	  _TextInputState2.default.blurTextInput(_TextInputState2.default.currentlyFocusedField());
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = dismissKeyboard;
	module.exports = exports['default'];

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ensureComponentIsNative = function ensureComponentIsNative(component) {
	  (0, _invariant2.default)(component && typeof component.setNativeProps === 'function', 'Touchable child must either be native or forward setNativeProps to a native component');
	}; /**
	    * Copyright (c) 2015-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = ensureComponentIsNative;
	module.exports = exports['default'];

/***/ },
/* 1056 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var CSS_UNIT_RE = /^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/;
	
	var getUnit = function getUnit(str) {
	  return str.match(CSS_UNIT_RE)[1];
	};
	
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	
	var multiplyStyleLengthValue = function multiplyStyleLengthValue(value, multiple) {
	  if (typeof value === 'string') {
	    var number = parseFloat(value) * multiple;
	    var unit = getUnit(value);
	    return '' + number + unit;
	  } else if (isNumeric(value)) {
	    return value * multiple;
	  }
	};
	
	exports.default = multiplyStyleLengthValue;
	module.exports = exports['default'];

/***/ },
/* 1057 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var emptyArray = [];
	var emptyFunction = function emptyFunction() {};
	
	var getRect = function getRect(node) {
	  if (node) {
	    var isElement = node.nodeType === 1 /* Node.ELEMENT_NODE */;
	    if (isElement && typeof node.getBoundingClientRect === 'function') {
	      return node.getBoundingClientRect();
	    }
	  }
	};
	
	// Mobile Safari re-uses touch objects, so we copy the properties we want and normalize the identifier
	var normalizeTouches = function normalizeTouches(touches) {
	  if (!touches) {
	    return emptyArray;
	  }
	
	  return Array.prototype.slice.call(touches).map(function (touch) {
	    var identifier = touch.identifier > 20 ? touch.identifier % 20 : touch.identifier;
	    var rect = void 0;
	
	    return {
	      _normalized: true,
	      clientX: touch.clientX,
	      clientY: touch.clientY,
	      force: touch.force,
	      get locationX() {
	        rect = rect || getRect(touch.target);
	        if (rect) {
	          return touch.pageX - rect.left;
	        }
	      },
	      get locationY() {
	        rect = rect || getRect(touch.target);
	        if (rect) {
	          return touch.pageY - rect.top;
	        }
	      },
	      identifier: identifier,
	      pageX: touch.pageX,
	      pageY: touch.pageY,
	      radiusX: touch.radiusX,
	      radiusY: touch.radiusY,
	      rotationAngle: touch.rotationAngle,
	      screenX: touch.screenX,
	      screenY: touch.screenY,
	      target: touch.target,
	      // normalize the timestamp
	      // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
	      timestamp: Date.now()
	    };
	  });
	};
	
	function normalizeTouchEvent(nativeEvent) {
	  var changedTouches = normalizeTouches(nativeEvent.changedTouches);
	  var touches = normalizeTouches(nativeEvent.touches);
	
	  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
	  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
	  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
	
	  var event = {
	    _normalized: true,
	    bubbles: nativeEvent.bubbles,
	    cancelable: nativeEvent.cancelable,
	    changedTouches: changedTouches,
	    defaultPrevented: nativeEvent.defaultPrevented,
	    identifier: undefined,
	    locationX: undefined,
	    locationY: undefined,
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    preventDefault: preventDefault,
	    stopImmediatePropagation: stopImmediatePropagation,
	    stopPropagation: stopPropagation,
	    target: nativeEvent.target,
	    // normalize the timestamp
	    // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
	    timestamp: Date.now(),
	    touches: touches,
	    type: nativeEvent.type,
	    which: nativeEvent.which
	  };
	
	  if (changedTouches[0]) {
	    event.identifier = changedTouches[0].identifier;
	    event.pageX = changedTouches[0].pageX;
	    event.pageY = changedTouches[0].pageY;
	    event.locationX = changedTouches[0].locationX;
	    event.locationY = changedTouches[0].locationY;
	  }
	
	  return event;
	}
	
	function normalizeMouseEvent(nativeEvent) {
	  var rect = void 0;
	
	  var touches = [{
	    _normalized: true,
	    clientX: nativeEvent.clientX,
	    clientY: nativeEvent.clientY,
	    force: nativeEvent.force,
	    identifier: 0,
	    get locationX() {
	      rect = rect || getRect(nativeEvent.target);
	      if (rect) {
	        return nativeEvent.pageX - rect.left;
	      }
	    },
	    get locationY() {
	      rect = rect || getRect(nativeEvent.target);
	      if (rect) {
	        return nativeEvent.pageY - rect.top;
	      }
	    },
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    screenX: nativeEvent.screenX,
	    screenY: nativeEvent.screenY,
	    target: nativeEvent.target,
	    timestamp: Date.now()
	  }];
	
	  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
	  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
	  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
	
	  return {
	    _normalized: true,
	    bubbles: nativeEvent.bubbles,
	    cancelable: nativeEvent.cancelable,
	    changedTouches: touches,
	    defaultPrevented: nativeEvent.defaultPrevented,
	    identifier: touches[0].identifier,
	    locationX: touches[0].locationX,
	    locationY: touches[0].locationY,
	    pageX: nativeEvent.pageX,
	    pageY: nativeEvent.pageY,
	    preventDefault: preventDefault,
	    stopImmediatePropagation: stopImmediatePropagation,
	    stopPropagation: stopPropagation,
	    target: nativeEvent.target,
	    timestamp: touches[0].timestamp,
	    touches: nativeEvent.type === 'mouseup' ? emptyArray : touches,
	    type: nativeEvent.type,
	    which: nativeEvent.which
	  };
	}
	
	// TODO: how to best handle keyboard events?
	function normalizeNativeEvent(nativeEvent) {
	  if (!nativeEvent || nativeEvent._normalized) {
	    return nativeEvent;
	  }
	  var eventType = nativeEvent.type || '';
	  var mouse = eventType.indexOf('mouse') >= 0;
	  if (mouse) {
	    return normalizeMouseEvent(nativeEvent);
	  } else {
	    return normalizeTouchEvent(nativeEvent);
	  }
	}
	
	exports.default = normalizeNativeEvent;
	module.exports = exports['default'];

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.prefixInlineStyles = undefined;
	
	var _createPrefixer = __webpack_require__(1219);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _static = __webpack_require__(1452);
	
	var _static2 = _interopRequireDefault(_static);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var prefixAll = (0, _createPrefixer2.default)(_static2.default);
	
	exports.default = prefixAll;
	var prefixInlineStyles = exports.prefixInlineStyles = function prefixInlineStyles(style) {
	  var prefixedStyles = prefixAll(style);
	
	  // React@15 removed undocumented support for fallback values in
	  // inline-styles. Revert array values to the standard CSS value
	  Object.keys(prefixedStyles).forEach(function (prop) {
	    var value = prefixedStyles[prop];
	    if (Array.isArray(value)) {
	      prefixedStyles[prop] = value[value.length - 1];
	    }
	  });
	
	  return prefixedStyles;
	};

/***/ },
/* 1059 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var unitlessNumbers = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexOrder: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  gridRow: true,
	  gridColumn: true,
	  lineClamp: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	  // SVG-related
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true,
	  // transform types
	  scale: true,
	  scaleX: true,
	  scaleY: true,
	  scaleZ: true,
	  // RN properties
	  shadowOpacity: true
	};
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['ms', 'Moz', 'O', 'Webkit'];
	var prefixKey = function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	};
	Object.keys(unitlessNumbers).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
	  });
	});
	
	exports.default = unitlessNumbers;
	module.exports = exports['default'];

/***/ },
/* 1060 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/* eslint-disable */
	
	/**
	 * JS Implementation of MurmurHash2
	 *
	 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
	 * @see http://github.com/garycourt/murmurhash-js
	 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
	 * @see http://sites.google.com/site/murmurhash/
	 *
	 * @param {string} str ASCII only
	 * @param {number} seed Positive integer only
	 * @return {number} 32-bit positive integer hash
	 */
	
	function murmurhash2_32_gc(str, seed) {
	  var l = str.length,
	      h = seed ^ l,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	var hash = function hash(str) {
	  return murmurhash2_32_gc(str, 1).toString(36);
	};
	
	exports.default = hash;
	module.exports = exports["default"];

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _bezier2 = __webpack_require__(1462);
	
	var _bezier3 = _interopRequireDefault(_bezier2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ease = void 0;
	
	/**
	 * The `Easing` module implements common easing functions. This module is used
	 * by [Animate.timing()](docs/animate.html#timing) to convey physically
	 * believable motion in animations.
	 *
	 * You can find a visualization of some common easing functions at
	 * http://easings.net/
	 *
	 * ### Predefined animations
	 *
	 * The `Easing` module provides several predefined animations through the
	 * following methods:
	 *
	 * - [`back`](docs/easing.html#back) provides a simple animation where the
	 *   object goes slightly back before moving forward
	 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
	 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
	 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
	 *
	 * ### Standard functions
	 *
	 * Three standard easing functions are provided:
	 *
	 * - [`linear`](docs/easing.html#linear)
	 * - [`quad`](docs/easing.html#quad)
	 * - [`cubic`](docs/easing.html#cubic)
	 *
	 * The [`poly`](docs/easing.html#poly) function can be used to implement
	 * quartic, quintic, and other higher power functions.
	 *
	 * ### Additional functions
	 *
	 * Additional mathematical functions are provided by the following methods:
	 *
	 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
	 * - [`circle`](docs/easing.html#circle) provides a circular function
	 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
	 * - [`exp`](docs/easing.html#exp) provides an exponential function
	 *
	 * The following helpers are used to modify other easing functions.
	 *
	 * - [`in`](docs/easing.html#in) runs an easing function forwards
	 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
	 * - [`out`](docs/easing.html#out) runs an easing function backwards
	 */
	
	var Easing = function () {
	  function Easing() {
	    _classCallCheck(this, Easing);
	  }
	
	  /**
	   * A stepping function, returns 1 for any positive value of `n`.
	   */
	  Easing.step0 = function step0(n) {
	    return n > 0 ? 1 : 0;
	  };
	
	  /**
	   * A stepping function, returns 1 if `n` is greater than or equal to 1.
	   */
	
	
	  Easing.step1 = function step1(n) {
	    return n >= 1 ? 1 : 0;
	  };
	
	  /**
	   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
	   * one.
	   *
	   * http://cubic-bezier.com/#0,0,1,1
	   */
	
	
	  Easing.linear = function linear(t) {
	    return t;
	  };
	
	  /**
	   * A simple inertial interaction, similar to an object slowly accelerating to
	   * speed.
	   *
	   * http://cubic-bezier.com/#.42,0,1,1
	   */
	
	
	  Easing.ease = function ease(t) {
	    if (!_ease) {
	      _ease = Easing.bezier(0.42, 0, 1, 1);
	    }
	    return _ease(t);
	  };
	
	  /**
	   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInQuad
	   */
	
	
	  Easing.quad = function quad(t) {
	    return t * t;
	  };
	
	  /**
	   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
	   * time.
	   *
	   * http://easings.net/#easeInCubic
	   */
	
	
	  Easing.cubic = function cubic(t) {
	    return t * t * t;
	  };
	
	  /**
	   * A power function. Position is equal to the Nth power of elapsed time.
	   *
	   * n = 4: http://easings.net/#easeInQuart
	   * n = 5: http://easings.net/#easeInQuint
	   */
	
	
	  Easing.poly = function poly(n) {
	    return function (t) {
	      return Math.pow(t, n);
	    };
	  };
	
	  /**
	   * A sinusoidal function.
	   *
	   * http://easings.net/#easeInSine
	   */
	
	
	  Easing.sin = function sin(t) {
	    return 1 - Math.cos(t * Math.PI / 2);
	  };
	
	  /**
	   * A circular function.
	   *
	   * http://easings.net/#easeInCirc
	   */
	
	
	  Easing.circle = function circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  };
	
	  /**
	   * An exponential function.
	   *
	   * http://easings.net/#easeInExpo
	   */
	
	
	  Easing.exp = function exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  };
	
	  /**
	   * A simple elastic interaction, similar to a spring oscillating back and
	   * forth.
	   *
	   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
	   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
	   * times.
	   *
	   * http://easings.net/#easeInElastic
	   */
	
	
	  Easing.elastic = function elastic() {
	    var bounciness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    var p = bounciness * Math.PI;
	    return function (t) {
	      return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
	    };
	  };
	
	  /**
	   * Use with `Animated.parallel()` to create a simple effect where the object
	   * animates back slightly as the animation starts.
	   *
	   * Wolfram Plot:
	   *
	   * - http://tiny.cc/back_default (s = 1.70158, default)
	   */
	
	
	  Easing.back = function back(s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return function (t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  };
	
	  /**
	   * Provides a simple bouncing effect.
	   *
	   * http://easings.net/#easeInBounce
	   */
	
	
	  Easing.bounce = function bounce(t) {
	    if (t < 1 / 2.75) {
	      return 7.5625 * t * t;
	    }
	
	    if (t < 2 / 2.75) {
	      t -= 1.5 / 2.75;
	      return 7.5625 * t * t + 0.75;
	    }
	
	    if (t < 2.5 / 2.75) {
	      t -= 2.25 / 2.75;
	      return 7.5625 * t * t + 0.9375;
	    }
	
	    t -= 2.625 / 2.75;
	    return 7.5625 * t * t + 0.984375;
	  };
	
	  /**
	   * Provides a cubic bezier curve, equivalent to CSS Transitions'
	   * `transition-timing-function`.
	   *
	   * A useful tool to visualize cubic bezier curves can be found at
	   * http://cubic-bezier.com/
	   */
	
	
	  Easing.bezier = function bezier(x1, y1, x2, y2) {
	    return (0, _bezier3.default)(x1, y1, x2, y2);
	  };
	
	  /**
	   * Runs an easing function forwards.
	   */
	
	
	  Easing.in = function _in(easing) {
	    return easing;
	  };
	
	  /**
	   * Runs an easing function backwards.
	   */
	
	
	  Easing.out = function out(easing) {
	    return function (t) {
	      return 1 - easing(1 - t);
	    };
	  };
	
	  /**
	   * Makes any easing function symmetrical. The easing function will run
	   * forwards for half of the duration, then backwards for the rest of the
	   * duration.
	   */
	
	
	  Easing.inOut = function inOut(easing) {
	    return function (t) {
	      if (t < 0.5) {
	        return easing(t * 2) / 2;
	      }
	      return 1 - easing((1 - t) * 2) / 2;
	    };
	  };
	
	  return Easing;
	}();
	
	exports.default = Easing;
	module.exports = exports['default'];

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedEvent = __webpack_require__(826);
	
	var _AnimatedNode2 = __webpack_require__(39);
	
	var _AnimatedNode3 = _interopRequireDefault(_AnimatedNode2);
	
	var _AnimatedStyle = __webpack_require__(1469);
	
	var _AnimatedStyle2 = _interopRequireDefault(_AnimatedStyle);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedProps = function (_AnimatedNode) {
	  _inherits(AnimatedProps, _AnimatedNode);
	
	  function AnimatedProps(props, callback) {
	    _classCallCheck(this, AnimatedProps);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    if (props.style) {
	      props = Object.assign({}, props, {
	        style: new _AnimatedStyle2.default(props.style)
	      });
	    }
	    _this._props = props;
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedProps.prototype.__getValue = function __getValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof _AnimatedNode3.default) {
	        if (!value.__isNative || value instanceof _AnimatedStyle2.default) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          props[key] = value.__getValue();
	        }
	      } else if (value instanceof _AnimatedEvent.AnimatedEvent) {
	        props[key] = value.__getHandler();
	      } else {
	        props[key] = value;
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    var props = {};
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof _AnimatedNode3.default) {
	        props[key] = value.__getAnimatedValue();
	      }
	    }
	    return props;
	  };
	
	  AnimatedProps.prototype.__attach = function __attach() {
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof _AnimatedNode3.default) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedProps.prototype.__detach = function __detach() {
	    if (this.__isNative && this._animatedView) {
	      this.__disconnectAnimatedView();
	    }
	    for (var key in this._props) {
	      var value = this._props[key];
	      if (value instanceof _AnimatedNode3.default) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedProps.prototype.update = function update() {
	    this._callback();
	  };
	
	  AnimatedProps.prototype.__makeNative = function __makeNative() {
	    if (!this.__isNative) {
	      this.__isNative = true;
	      for (var key in this._props) {
	        var value = this._props[key];
	        if (value instanceof _AnimatedNode3.default) {
	          value.__makeNative();
	        }
	      }
	      if (this._animatedView) {
	        this.__connectAnimatedView();
	      }
	    }
	  };
	
	  AnimatedProps.prototype.setNativeView = function setNativeView(animatedView) {
	    if (this._animatedView === animatedView) {
	      return;
	    }
	    this._animatedView = animatedView;
	    if (this.__isNative) {
	      this.__connectAnimatedView();
	    }
	  };
	
	  AnimatedProps.prototype.__connectAnimatedView = function __connectAnimatedView() {
	    (0, _invariant2.default)(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = (0, _findNodeHandle2.default)(this._animatedView);
	    (0, _invariant2.default)(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    _NativeAnimatedHelper2.default.API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__disconnectAnimatedView = function __disconnectAnimatedView() {
	    (0, _invariant2.default)(this.__isNative, 'Expected node to be marked as "native"');
	    var nativeViewTag = (0, _findNodeHandle2.default)(this._animatedView);
	    (0, _invariant2.default)(nativeViewTag != null, 'Unable to locate attached view in the native tree');
	    _NativeAnimatedHelper2.default.API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
	  };
	
	  AnimatedProps.prototype.__getNativeConfig = function __getNativeConfig() {
	    var propsConfig = {};
	    for (var propKey in this._props) {
	      var value = this._props[propKey];
	      if (value instanceof _AnimatedNode3.default) {
	        propsConfig[propKey] = value.__getNativeTag();
	      }
	    }
	    return {
	      type: 'props',
	      props: propsConfig
	    };
	  };
	
	  return AnimatedProps;
	}(_AnimatedNode3.default);
	
	exports.default = AnimatedProps;
	module.exports = exports['default'];

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _VirtualizedList = __webpack_require__(829);
	
	var _VirtualizedList2 = _interopRequireDefault(_VirtualizedList);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @noflow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var defaultProps = Object.assign({}, _VirtualizedList2.default.defaultProps, {
	  numColumns: 1
	});
	
	/**
	 * A performant interface for rendering simple, flat lists, supporting the most handy features:
	 *
	 *  - Fully cross-platform.
	 *  - Optional horizontal mode.
	 *  - Configurable viewability callbacks.
	 *  - Header support.
	 *  - Footer support.
	 *  - Separator support.
	 *  - Pull to Refresh.
	 *  - Scroll loading.
	 *  - ScrollToIndex support.
	 *
	 * If you need section support, use [`<SectionList>`](docs/sectionlist.html).
	 *
	 * Minimal Example:
	 *
	 *     <FlatList
	 *       data={[{key: 'a'}, {key: 'b'}]}
	 *       renderItem={({item}) => <Text>{item.key}</Text>}
	 *     />
	 *
	 * More complex, multi-select example demonstrating `PureComponent` usage for perf optimization and avoiding bugs.
	 *
	 * - By binding the `onPressItem` handler, the props will remain `===` and `PureComponent` will
	 *   prevent wasteful re-renders unless the actual `id`, `selected`, or `title` props change, even
	 *   if the components rendered in `MyListItem` did not have such optimizations.
	 * - By passing `extraData={this.state}` to `FlatList` we make sure `FlatList` itself will re-render
	 *   when the `state.selected` changes. Without setting this prop, `FlatList` would not know it
	 *   needs to re-render any items because it is also a `PureComponent` and the prop comparison will
	 *   not show any changes.
	 * - `keyExtractor` tells the list to use the `id`s for the react keys instead of the default `key` property.
	 *
	 *
	 *     class MyListItem extends React.PureComponent {
	 *       _onPress = () => {
	 *         this.props.onPressItem(this.props.id);
	 *       };
	 *
	 *       render() {
	 *         const textColor = this.props.selected ? "red" : "black";
	 *         return (
	 *           <TouchableOpacity onPress={this._onPress}>
	 *             <View>
	 *               <Text style={{ color: textColor }}>
	 *                 {this.props.title}
	 *               </Text>
	 *             </View>
	 *           </TouchableOpacity>
	 *         );
	 *       }
	 *     }
	 *
	 *     class MultiSelectList extends React.PureComponent {
	 *       state = {selected: (new Map(): Map<string, boolean>)};
	 *
	 *       _keyExtractor = (item, index) => item.id;
	 *
	 *       _onPressItem = (id: string) => {
	 *         // updater functions are preferred for transactional updates
	 *         this.setState((state) => {
	 *           // copy the map rather than modifying state.
	 *           const selected = new Map(state.selected);
	 *           selected.set(id, !selected.get(id)); // toggle
	 *           return {selected};
	 *         });
	 *       };
	 *
	 *       _renderItem = ({item}) => (
	 *         <MyListItem
	 *           id={item.id}
	 *           onPressItem={this._onPressItem}
	 *           selected={!!this.state.selected.get(item.id)}
	 *           title={item.title}
	 *         />
	 *       );
	 *
	 *       render() {
	 *         return (
	 *           <FlatList
	 *             data={this.props.data}
	 *             extraData={this.state}
	 *             keyExtractor={this._keyExtractor}
	 *             renderItem={this._renderItem}
	 *           />
	 *         );
	 *       }
	 *     }
	 *
	 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
	 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
	 * here, along with the following caveats:
	 *
	 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
	 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
	 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
	 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
	 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
	 *   changes. This includes the `data` prop and parent component state.
	 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
	 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
	 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
	 *   and we are working on improving it behind the scenes.
	 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
	 *   Alternatively, you can provide a custom `keyExtractor` prop.
	 *
	 * Also inherits [ScrollView Props](docs/scrollview.html#props), unless it is nested in another FlatList of same orientation.
	 */
	var FlatList = function (_React$PureComponent) {
	  _inherits(FlatList, _React$PureComponent);
	
	  /**
	   * Scrolls to the end of the content. May be janky without `getItemLayout` prop.
	   */
	  FlatList.prototype.scrollToEnd = function scrollToEnd(params) {
	    if (this._listRef) {
	      this._listRef.scrollToEnd(params);
	    }
	  };
	
	  /**
	   * Scrolls to the item at the specified index such that it is positioned in the viewable area
	   * such that `viewPosition` 0 places it at the top, 1 at the bottom, and 0.5 centered in the
	   * middle. `viewOffset` is a fixed number of pixels to offset the final target position.
	   *
	   * Note: cannot scroll to locations outside the render window without specifying the
	   * `getItemLayout` prop.
	   */
	
	
	  FlatList.prototype.scrollToIndex = function scrollToIndex(params) {
	    if (this._listRef) {
	      this._listRef.scrollToIndex(params);
	    }
	  };
	
	  /**
	   * Requires linear scan through data - use `scrollToIndex` instead if possible.
	   *
	   * Note: cannot scroll to locations outside the render window without specifying the
	   * `getItemLayout` prop.
	   */
	
	
	  FlatList.prototype.scrollToItem = function scrollToItem(params) {
	    if (this._listRef) {
	      this._listRef.scrollToItem(params);
	    }
	  };
	
	  /**
	   * Scroll to a specific content pixel offset in the list.
	   *
	   * Check out [scrollToOffset](docs/virtualizedlist.html#scrolltooffset) of VirtualizedList
	   */
	
	
	  FlatList.prototype.scrollToOffset = function scrollToOffset(params) {
	    if (this._listRef) {
	      this._listRef.scrollToOffset(params);
	    }
	  };
	
	  /**
	   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
	   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
	   * taps on items or by navigation actions.
	   */
	
	
	  FlatList.prototype.recordInteraction = function recordInteraction() {
	    if (this._listRef) {
	      this._listRef.recordInteraction();
	    }
	  };
	
	  /**
	   * Displays the scroll indicators momentarily.
	   *
	   * @platform ios
	   */
	
	
	  FlatList.prototype.flashScrollIndicators = function flashScrollIndicators() {
	    if (this._listRef) {
	      this._listRef.flashScrollIndicators();
	    }
	  };
	
	  /**
	   * Provides a handle to the underlying scroll responder.
	   */
	
	
	  FlatList.prototype.getScrollResponder = function getScrollResponder() {
	    if (this._listRef) {
	      return this._listRef.getScrollResponder();
	    }
	  };
	
	  FlatList.prototype.getScrollableNode = function getScrollableNode() {
	    if (this._listRef) {
	      return this._listRef.getScrollableNode();
	    }
	  };
	
	  FlatList.prototype.setNativeProps = function setNativeProps(props) {
	    if (this._listRef) {
	      this._listRef.setNativeProps(props);
	    }
	  };
	
	  FlatList.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	    this._checkProps(this.props);
	  };
	
	  FlatList.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    (0, _invariant2.default)(nextProps.numColumns === this.props.numColumns, 'Changing numColumns on the fly is not supported. Change the key prop on FlatList when ' + 'changing the number of columns to force a fresh render of the component.');
	    (0, _invariant2.default)(nextProps.onViewableItemsChanged === this.props.onViewableItemsChanged, 'Changing onViewableItemsChanged on the fly is not supported');
	    (0, _invariant2.default)(nextProps.viewabilityConfig === this.props.viewabilityConfig, 'Changing viewabilityConfig on the fly is not supported');
	    (0, _invariant2.default)(nextProps.viewabilityConfigCallbackPairs === this.props.viewabilityConfigCallbackPairs, 'Changing viewabilityConfigCallbackPairs on the fly is not supported');
	
	    this._checkProps(nextProps);
	  };
	
	  function FlatList(props) {
	    _classCallCheck(this, FlatList);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	
	    _this._hasWarnedLegacy = false;
	    _this._virtualizedListPairs = [];
	
	    _this._captureRef = function (ref) {
	      _this._listRef = ref;
	    };
	
	    _this._getItem = function (data, index) {
	      var numColumns = _this.props.numColumns;
	
	      if (numColumns > 1) {
	        var ret = [];
	        for (var kk = 0; kk < numColumns; kk++) {
	          var _item = data[index * numColumns + kk];
	          _item && ret.push(_item);
	        }
	        return ret;
	      } else {
	        return data[index];
	      }
	    };
	
	    _this._getItemCount = function (data) {
	      return data ? Math.ceil(data.length / _this.props.numColumns) : 0;
	    };
	
	    _this._keyExtractor = function (items, index) {
	      var _this$props = _this.props,
	          keyExtractor = _this$props.keyExtractor,
	          numColumns = _this$props.numColumns;
	
	      if (numColumns > 1) {
	        (0, _invariant2.default)(Array.isArray(items), 'FlatList: Encountered internal consistency error, expected each item to consist of an ' + 'array with 1-%s columns; instead, received a single item.', numColumns);
	        return items.map(function (it, kk) {
	          return keyExtractor(it, index * numColumns + kk);
	        }).join(':');
	      } else {
	        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	         * error found when Flow v0.63 was deployed. To see the error delete this
	         * comment and run Flow. */
	        return keyExtractor(items, index);
	      }
	    };
	
	    _this._renderItem = function (info) {
	      var _this$props2 = _this.props,
	          renderItem = _this$props2.renderItem,
	          numColumns = _this$props2.numColumns,
	          columnWrapperStyle = _this$props2.columnWrapperStyle;
	
	      if (numColumns > 1) {
	        var _item2 = info.item,
	            _index = info.index;
	
	        (0, _invariant2.default)(Array.isArray(_item2), 'Expected array of items with numColumns > 1');
	        return _react2.default.createElement(
	          _View2.default,
	          { style: [{ flexDirection: 'row' }, columnWrapperStyle] },
	          _item2.map(function (it, kk) {
	            var element = renderItem({
	              item: it,
	              index: _index * numColumns + kk,
	              separators: info.separators
	            });
	            return element && _react2.default.cloneElement(element, { key: kk });
	          })
	        );
	      } else {
	        return renderItem(info);
	      }
	    };
	
	    if (_this.props.viewabilityConfigCallbackPairs) {
	      _this._virtualizedListPairs = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
	        return {
	          viewabilityConfig: pair.viewabilityConfig,
	          onViewableItemsChanged: _this._createOnViewableItemsChanged(pair.onViewableItemsChanged)
	        };
	      });
	    } else if (_this.props.onViewableItemsChanged) {
	      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	       * error found when Flow v0.63 was deployed. To see the error delete this
	       * comment and run Flow. */
	      _this._virtualizedListPairs.push({
	        viewabilityConfig: _this.props.viewabilityConfig,
	        onViewableItemsChanged: _this._createOnViewableItemsChanged(_this.props.onViewableItemsChanged)
	      });
	    }
	    return _this;
	  }
	
	  FlatList.prototype._checkProps = function _checkProps(props) {
	    var getItem = props.getItem,
	        getItemCount = props.getItemCount,
	        horizontal = props.horizontal,
	        legacyImplementation = props.legacyImplementation,
	        numColumns = props.numColumns,
	        columnWrapperStyle = props.columnWrapperStyle,
	        onViewableItemsChanged = props.onViewableItemsChanged,
	        viewabilityConfigCallbackPairs = props.viewabilityConfigCallbackPairs;
	
	    (0, _invariant2.default)(!getItem && !getItemCount, 'FlatList does not support custom data formats.');
	    if (numColumns > 1) {
	      (0, _invariant2.default)(!horizontal, 'numColumns does not support horizontal.');
	    } else {
	      (0, _invariant2.default)(!columnWrapperStyle, 'columnWrapperStyle not supported for single column lists');
	    }
	    if (legacyImplementation) {
	      (0, _invariant2.default)(numColumns === 1, 'Legacy list does not support multiple columns.');
	      // Warning: may not have full feature parity and is meant more for debugging and performance
	      // comparison.
	      if (!this._hasWarnedLegacy) {
	        console.warn('FlatList: Using legacyImplementation - some features not supported and performance ' + 'may suffer');
	        this._hasWarnedLegacy = true;
	      }
	    }
	    (0, _invariant2.default)(!(onViewableItemsChanged && viewabilityConfigCallbackPairs), 'FlatList does not support setting both onViewableItemsChanged and ' + 'viewabilityConfigCallbackPairs.');
	  };
	
	  FlatList.prototype._pushMultiColumnViewable = function _pushMultiColumnViewable(arr, v) {
	    var _props = this.props,
	        numColumns = _props.numColumns,
	        keyExtractor = _props.keyExtractor;
	
	    v.item.forEach(function (item, ii) {
	      (0, _invariant2.default)(v.index != null, 'Missing index!');
	      var index = v.index * numColumns + ii;
	      arr.push(Object.assign({}, v, { item: item, key: keyExtractor(item, index), index: index }));
	    });
	  };
	
	  FlatList.prototype._createOnViewableItemsChanged = function _createOnViewableItemsChanged(onViewableItemsChanged) {
	    var _this2 = this;
	
	    return function (info) {
	      var numColumns = _this2.props.numColumns;
	
	      if (onViewableItemsChanged) {
	        if (numColumns > 1) {
	          var _changed = [];
	          var _viewableItems = [];
	          info.viewableItems.forEach(function (v) {
	            return _this2._pushMultiColumnViewable(_viewableItems, v);
	          });
	          info.changed.forEach(function (v) {
	            return _this2._pushMultiColumnViewable(_changed, v);
	          });
	          onViewableItemsChanged({ viewableItems: _viewableItems, changed: _changed });
	        } else {
	          onViewableItemsChanged(info);
	        }
	      }
	    };
	  };
	
	  FlatList.prototype.render = function render() {
	    if (this.props.legacyImplementation) {
	      return (
	        /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
	         * error found when Flow v0.66 was deployed. To see the error delete
	         * this comment and run Flow. */
	        _react2.default.createElement(_UnimplementedView2.default, _extends({}, this.props, {
	          /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses
	           * an error found when Flow v0.66 was deployed. To see the error
	           * delete this comment and run Flow. */
	          items: this.props.data,
	          ref: this._captureRef
	        }))
	      );
	    } else {
	      return _react2.default.createElement(_VirtualizedList2.default, _extends({}, this.props, {
	        renderItem: this._renderItem,
	        getItem: this._getItem,
	        getItemCount: this._getItemCount,
	        keyExtractor: this._keyExtractor,
	        ref: this._captureRef,
	        viewabilityConfigCallbackPairs: this._virtualizedListPairs
	      }));
	    }
	  };
	
	  return FlatList;
	}(_react2.default.PureComponent);
	
	FlatList.defaultProps = defaultProps;
	exports.default = FlatList;
	module.exports = exports['default'];

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule ListViewDataSource
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isEmpty = __webpack_require__(1069);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function defaultGetRowData(dataBlob, sectionID, rowID) {
	  return dataBlob[sectionID][rowID];
	}
	
	function defaultGetSectionHeaderData(dataBlob, sectionID) {
	  return dataBlob[sectionID];
	}
	
	/**
	 * Provides efficient data processing and access to the
	 * `ListView` component.  A `ListViewDataSource` is created with functions for
	 * extracting data from the input blob, and comparing elements (with default
	 * implementations for convenience).  The input blob can be as simple as an
	 * array of strings, or an object with rows nested inside section objects.
	 *
	 * To update the data in the datasource, use `cloneWithRows` (or
	 * `cloneWithRowsAndSections` if you care about sections).  The data in the
	 * data source is immutable, so you can't modify it directly.  The clone methods
	 * suck in the new data and compute a diff for each row so ListView knows
	 * whether to re-render it or not.
	 *
	 * In this example, a component receives data in chunks, handled by
	 * `_onDataArrived`, which concats the new data onto the old data and updates the
	 * data source.  We use `concat` to create a new array - mutating `this._data`,
	 * e.g. with `this._data.push(newRowData)`, would be an error. `_rowHasChanged`
	 * understands the shape of the row data and knows how to efficiently compare
	 * it.
	 *
	 * ```
	 * getInitialState: function() {
	 *   var ds = new ListView.DataSource({rowHasChanged: this._rowHasChanged});
	 *   return {ds};
	 * },
	 * _onDataArrived(newData) {
	 *   this._data = this._data.concat(newData);
	 *   this.setState({
	 *     ds: this.state.ds.cloneWithRows(this._data)
	 *   });
	 * }
	 * ```
	 */
	
	var ListViewDataSource = function () {
	  /**
	   * You can provide custom extraction and `hasChanged` functions for section
	   * headers and rows.  If absent, data will be extracted with the
	   * `defaultGetRowData` and `defaultGetSectionHeaderData` functions.
	   *
	   * The default extractor expects data of one of the following forms:
	   *
	   *      { sectionID_1: { rowID_1: <rowData1>, ... }, ... }
	   *
	   *    or
	   *
	   *      { sectionID_1: [ <rowData1>, <rowData2>, ... ], ... }
	   *
	   *    or
	   *
	   *      [ [ <rowData1>, <rowData2>, ... ], ... ]
	   *
	   * The constructor takes in a params argument that can contain any of the
	   * following:
	   *
	   * - getRowData(dataBlob, sectionID, rowID);
	   * - getSectionHeaderData(dataBlob, sectionID);
	   * - rowHasChanged(prevRowData, nextRowData);
	   * - sectionHeaderHasChanged(prevSectionData, nextSectionData);
	   */
	  function ListViewDataSource(params) {
	    _classCallCheck(this, ListViewDataSource);
	
	    (0, _invariant2.default)(params && typeof params.rowHasChanged === 'function', 'Must provide a rowHasChanged function.');
	    this._rowHasChanged = params.rowHasChanged;
	    this._getRowData = params.getRowData || defaultGetRowData;
	    this._sectionHeaderHasChanged = params.sectionHeaderHasChanged;
	    this._getSectionHeaderData = params.getSectionHeaderData || defaultGetSectionHeaderData;
	
	    this._dataBlob = null;
	    this._dirtyRows = [];
	    this._dirtySections = [];
	    this._cachedRowCount = 0;
	
	    // These two private variables are accessed by outsiders because ListView
	    // uses them to iterate over the data in this class.
	    this.rowIdentities = [];
	    this.sectionIdentities = [];
	  }
	
	  /**
	   * Clones this `ListViewDataSource` with the specified `dataBlob` and
	   * `rowIdentities`. The `dataBlob` is just an arbitrary blob of data. At
	   * construction an extractor to get the interesting information was defined
	   * (or the default was used).
	   *
	   * The `rowIdentities` is a 2D array of identifiers for rows.
	   * ie. [['a1', 'a2'], ['b1', 'b2', 'b3'], ...].  If not provided, it's
	   * assumed that the keys of the section data are the row identities.
	   *
	   * Note: This function does NOT clone the data in this data source. It simply
	   * passes the functions defined at construction to a new data source with
	   * the data specified. If you wish to maintain the existing data you must
	   * handle merging of old and new data separately and then pass that into
	   * this function as the `dataBlob`.
	   */
	
	
	  ListViewDataSource.prototype.cloneWithRows = function cloneWithRows(dataBlob, rowIdentities) {
	    var rowIds = rowIdentities ? [[].concat(rowIdentities)] : null;
	    if (!this._sectionHeaderHasChanged) {
	      this._sectionHeaderHasChanged = function () {
	        return false;
	      };
	    }
	    return this.cloneWithRowsAndSections({ s1: dataBlob }, ['s1'], rowIds);
	  };
	
	  /**
	   * This performs the same function as the `cloneWithRows` function but here
	   * you also specify what your `sectionIdentities` are. If you don't care
	   * about sections you should safely be able to use `cloneWithRows`.
	   *
	   * `sectionIdentities` is an array of identifiers for sections.
	   * ie. ['s1', 's2', ...].  The identifiers should correspond to the keys or array indexes
	   * of the data you wish to include.  If not provided, it's assumed that the
	   * keys of dataBlob are the section identities.
	   *
	   * Note: this returns a new object!
	   *
	   * ```
	   * const dataSource = ds.cloneWithRowsAndSections({
	   *   addresses: ['row 1', 'row 2'],
	   *   phone_numbers: ['data 1', 'data 2'],
	   * }, ['phone_numbers']);
	   * ```
	   */
	
	
	  ListViewDataSource.prototype.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
	    (0, _invariant2.default)(typeof this._sectionHeaderHasChanged === 'function', 'Must provide a sectionHeaderHasChanged function with section data.');
	    (0, _invariant2.default)(!sectionIdentities || !rowIdentities || sectionIdentities.length === rowIdentities.length, 'row and section ids lengths must be the same');
	
	    var newSource = new ListViewDataSource({
	      getRowData: this._getRowData,
	      getSectionHeaderData: this._getSectionHeaderData,
	      rowHasChanged: this._rowHasChanged,
	      sectionHeaderHasChanged: this._sectionHeaderHasChanged
	    });
	    newSource._dataBlob = dataBlob;
	    if (sectionIdentities) {
	      newSource.sectionIdentities = sectionIdentities;
	    } else {
	      newSource.sectionIdentities = Object.keys(dataBlob);
	    }
	    if (rowIdentities) {
	      newSource.rowIdentities = rowIdentities;
	    } else {
	      newSource.rowIdentities = [];
	      newSource.sectionIdentities.forEach(function (sectionID) {
	        newSource.rowIdentities.push(Object.keys(dataBlob[sectionID]));
	      });
	    }
	    newSource._cachedRowCount = countRows(newSource.rowIdentities);
	
	    newSource._calculateDirtyArrays(this._dataBlob, this.sectionIdentities, this.rowIdentities);
	
	    return newSource;
	  };
	
	  /**
	   * Returns the total number of rows in the data source.
	   *
	   * If you are specifying the rowIdentities or sectionIdentities, then `getRowCount` will return the number of rows in the filtered data source.
	   */
	
	
	  ListViewDataSource.prototype.getRowCount = function getRowCount() {
	    return this._cachedRowCount;
	  };
	
	  /**
	   * Returns the total number of rows in the data source (see `getRowCount` for how this is calculated) plus the number of sections in the data.
	   *
	   * If you are specifying the rowIdentities or sectionIdentities, then `getRowAndSectionCount` will return the number of rows & sections in the filtered data source.
	   */
	
	
	  ListViewDataSource.prototype.getRowAndSectionCount = function getRowAndSectionCount() {
	    return this._cachedRowCount + this.sectionIdentities.length;
	  };
	
	  /**
	   * Returns if the row is dirtied and needs to be rerendered
	   */
	
	
	  ListViewDataSource.prototype.rowShouldUpdate = function rowShouldUpdate(sectionIndex, rowIndex) {
	    var needsUpdate = this._dirtyRows[sectionIndex][rowIndex];
	    (0, _warning2.default)(needsUpdate !== undefined, 'missing dirtyBit for section, row: ' + sectionIndex + ', ' + rowIndex);
	    return needsUpdate;
	  };
	
	  /**
	   * Gets the data required to render the row.
	   */
	
	
	  ListViewDataSource.prototype.getRowData = function getRowData(sectionIndex, rowIndex) {
	    var sectionID = this.sectionIdentities[sectionIndex];
	    var rowID = this.rowIdentities[sectionIndex][rowIndex];
	    (0, _warning2.default)(sectionID !== undefined && rowID !== undefined, 'rendering invalid section, row: ' + sectionIndex + ', ' + rowIndex);
	    return this._getRowData(this._dataBlob, sectionID, rowID);
	  };
	
	  /**
	   * Gets the rowID at index provided if the dataSource arrays were flattened,
	   * or null of out of range indexes.
	   */
	
	
	  ListViewDataSource.prototype.getRowIDForFlatIndex = function getRowIDForFlatIndex(index) {
	    var accessIndex = index;
	    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
	      if (accessIndex >= this.rowIdentities[ii].length) {
	        accessIndex -= this.rowIdentities[ii].length;
	      } else {
	        return this.rowIdentities[ii][accessIndex];
	      }
	    }
	    return null;
	  };
	
	  /**
	   * Gets the sectionID at index provided if the dataSource arrays were flattened,
	   * or null for out of range indexes.
	   */
	
	
	  ListViewDataSource.prototype.getSectionIDForFlatIndex = function getSectionIDForFlatIndex(index) {
	    var accessIndex = index;
	    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
	      if (accessIndex >= this.rowIdentities[ii].length) {
	        accessIndex -= this.rowIdentities[ii].length;
	      } else {
	        return this.sectionIdentities[ii];
	      }
	    }
	    return null;
	  };
	
	  /**
	   * Returns an array containing the number of rows in each section
	   */
	
	
	  ListViewDataSource.prototype.getSectionLengths = function getSectionLengths() {
	    var results = [];
	    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
	      results.push(this.rowIdentities[ii].length);
	    }
	    return results;
	  };
	
	  /**
	   * Returns if the section header is dirtied and needs to be rerendered
	   */
	
	
	  ListViewDataSource.prototype.sectionHeaderShouldUpdate = function sectionHeaderShouldUpdate(sectionIndex) {
	    var needsUpdate = this._dirtySections[sectionIndex];
	    (0, _warning2.default)(needsUpdate !== undefined, 'missing dirtyBit for section: ' + sectionIndex);
	    return needsUpdate;
	  };
	
	  /**
	   * Gets the data required to render the section header
	   */
	
	
	  ListViewDataSource.prototype.getSectionHeaderData = function getSectionHeaderData(sectionIndex) {
	    if (!this._getSectionHeaderData) {
	      return null;
	    }
	    var sectionID = this.sectionIdentities[sectionIndex];
	    (0, _warning2.default)(sectionID !== undefined, 'renderSection called on invalid section: ' + sectionIndex);
	    return this._getSectionHeaderData(this._dataBlob, sectionID);
	  };
	
	  /**
	   * Private members and methods.
	   */
	
	  // These two 'protected' variables are accessed by ListView to iterate over
	  // the data in this class.
	
	
	  ListViewDataSource.prototype._calculateDirtyArrays = function _calculateDirtyArrays(prevDataBlob, prevSectionIDs, prevRowIDs) {
	    // construct a hashmap of the existing (old) id arrays
	    var prevSectionsHash = keyedDictionaryFromArray(prevSectionIDs);
	    var prevRowsHash = {};
	    for (var ii = 0; ii < prevRowIDs.length; ii++) {
	      var sectionID = prevSectionIDs[ii];
	      (0, _warning2.default)(!prevRowsHash[sectionID], 'SectionID appears more than once: ' + sectionID);
	      prevRowsHash[sectionID] = keyedDictionaryFromArray(prevRowIDs[ii]);
	    }
	
	    // compare the 2 identity array and get the dirtied rows
	    this._dirtySections = [];
	    this._dirtyRows = [];
	
	    var dirty;
	    for (var sIndex = 0; sIndex < this.sectionIdentities.length; sIndex++) {
	      var sectionID = this.sectionIdentities[sIndex];
	      // dirty if the sectionHeader is new or _sectionHasChanged is true
	      dirty = !prevSectionsHash[sectionID];
	      var sectionHeaderHasChanged = this._sectionHeaderHasChanged;
	      if (!dirty && sectionHeaderHasChanged) {
	        dirty = sectionHeaderHasChanged(this._getSectionHeaderData(prevDataBlob, sectionID), this._getSectionHeaderData(this._dataBlob, sectionID));
	      }
	      this._dirtySections.push(!!dirty);
	
	      this._dirtyRows[sIndex] = [];
	      for (var rIndex = 0; rIndex < this.rowIdentities[sIndex].length; rIndex++) {
	        var rowID = this.rowIdentities[sIndex][rIndex];
	        // dirty if the section is new, row is new or _rowHasChanged is true
	        dirty = !prevSectionsHash[sectionID] || !prevRowsHash[sectionID][rowID] || this._rowHasChanged(this._getRowData(prevDataBlob, sectionID, rowID), this._getRowData(this._dataBlob, sectionID, rowID));
	        this._dirtyRows[sIndex].push(!!dirty);
	      }
	    }
	  };
	
	  return ListViewDataSource;
	}();
	
	function countRows(allRowIDs) {
	  var totalRows = 0;
	  for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
	    var rowIDs = allRowIDs[sectionIdx];
	    totalRows += rowIDs.length;
	  }
	  return totalRows;
	}
	
	function keyedDictionaryFromArray(arr) {
	  if ((0, _isEmpty2.default)(arr)) {
	    return {};
	  }
	  var result = {};
	  for (var ii = 0; ii < arr.length; ii++) {
	    var key = arr[ii];
	    (0, _warning2.default)(!result[key], 'Value appears more than once in array: ' + key);
	    result[key] = true;
	  }
	  return result;
	}
	
	exports.default = ListViewDataSource;
	module.exports = exports['default'];

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule ListView
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _ListViewDataSource = __webpack_require__(1064);
	
	var _ListViewDataSource2 = _interopRequireDefault(_ListViewDataSource);
	
	var _Platform = __webpack_require__(106);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _NativeModules = __webpack_require__(813);
	
	var _NativeModules2 = _interopRequireDefault(_NativeModules);
	
	var _ScrollView = __webpack_require__(107);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _ScrollResponder = __webpack_require__(1050);
	
	var _ScrollResponder2 = _interopRequireDefault(_ScrollResponder);
	
	var _StaticRenderer = __webpack_require__(1478);
	
	var _StaticRenderer2 = _interopRequireDefault(_StaticRenderer);
	
	var _reactTimerMixin = __webpack_require__(128);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _cloneReferencedElement = __webpack_require__(1475);
	
	var _cloneReferencedElement2 = _interopRequireDefault(_cloneReferencedElement);
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _isEmpty = __webpack_require__(1069);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var merge = function merge() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return Object.assign.apply(Object, [{}].concat(args));
	};
	var RCTScrollViewManager = _NativeModules2.default.ScrollViewManager;
	
	var DEFAULT_PAGE_SIZE = 1;
	var DEFAULT_INITIAL_ROWS = 10;
	var DEFAULT_SCROLL_RENDER_AHEAD = 1000;
	var DEFAULT_END_REACHED_THRESHOLD = 1000;
	var DEFAULT_SCROLL_CALLBACK_THROTTLE = 50;
	
	/**
	 * DEPRECATED - use one of the new list components, such as [`FlatList`](docs/flatlist.html)
	 * or [`SectionList`](docs/sectionlist.html) for bounded memory use, fewer bugs,
	 * better performance, an easier to use API, and more features. Check out this
	 * [blog post](https://facebook.github.io/react-native/blog/2017/03/13/better-list-views.html)
	 * for more details.
	 *
	 * ListView - A core component designed for efficient display of vertically
	 * scrolling lists of changing data. The minimal API is to create a
	 * [`ListView.DataSource`](docs/listviewdatasource.html), populate it with a simple
	 * array of data blobs, and instantiate a `ListView` component with that data
	 * source and a `renderRow` callback which takes a blob from the data array and
	 * returns a renderable component.
	 *
	 * Minimal example:
	 *
	 * ```
	 * class MyComponent extends Component {
	 *   constructor() {
	 *     super();
	 *     const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
	 *     this.state = {
	 *       dataSource: ds.cloneWithRows(['row 1', 'row 2']),
	 *     };
	 *   }
	 *
	 *   render() {
	 *     return (
	 *       <ListView
	 *         dataSource={this.state.dataSource}
	 *         renderRow={(rowData) => <Text>{rowData}</Text>}
	 *       />
	 *     );
	 *   }
	 * }
	 * ```
	 *
	 * ListView also supports more advanced features, including sections with sticky
	 * section headers, header and footer support, callbacks on reaching the end of
	 * the available data (`onEndReached`) and on the set of rows that are visible
	 * in the device viewport change (`onChangeVisibleRows`), and several
	 * performance optimizations.
	 *
	 * There are a few performance operations designed to make ListView scroll
	 * smoothly while dynamically loading potentially very large (or conceptually
	 * infinite) data sets:
	 *
	 *  * Only re-render changed rows - the rowHasChanged function provided to the
	 *    data source tells the ListView if it needs to re-render a row because the
	 *    source data has changed - see ListViewDataSource for more details.
	 *
	 *  * Rate-limited row rendering - By default, only one row is rendered per
	 *    event-loop (customizable with the `pageSize` prop). This breaks up the
	 *    work into smaller chunks to reduce the chance of dropping frames while
	 *    rendering rows.
	 */
	
	var ListView = (0, _createReactClass2.default)({
	  displayName: 'ListView',
	  _childFrames: [],
	  _sentEndForContentLength: null,
	  _scrollComponent: null,
	  _prevRenderedRowsCount: 0,
	  _visibleRows: {},
	  scrollProperties: {},
	
	  mixins: [_ScrollResponder2.default.Mixin, _reactTimerMixin2.default],
	
	  statics: {
	    DataSource: _ListViewDataSource2.default
	  },
	
	  /**
	   * You must provide a renderRow function. If you omit any of the other render
	   * functions, ListView will simply skip rendering them.
	   *
	   * - renderRow(rowData, sectionID, rowID, highlightRow);
	   * - renderSectionHeader(sectionData, sectionID);
	   */
	  propTypes: Object.assign({}, _ScrollView2.default.propTypes, {
	    /**
	     * An instance of [ListView.DataSource](docs/listviewdatasource.html) to use
	     */
	    dataSource: _propTypes2.default.instanceOf(_ListViewDataSource2.default).isRequired,
	    /**
	     * (sectionID, rowID, adjacentRowHighlighted) => renderable
	     *
	     * If provided, a renderable component to be rendered as the separator
	     * below each row but not the last row if there is a section header below.
	     * Take a sectionID and rowID of the row above and whether its adjacent row
	     * is highlighted.
	     */
	    renderSeparator: _propTypes2.default.func,
	    /**
	     * (rowData, sectionID, rowID, highlightRow) => renderable
	     *
	     * Takes a data entry from the data source and its ids and should return
	     * a renderable component to be rendered as the row. By default the data
	     * is exactly what was put into the data source, but it's also possible to
	     * provide custom extractors. ListView can be notified when a row is
	     * being highlighted by calling `highlightRow(sectionID, rowID)`. This
	     * sets a boolean value of adjacentRowHighlighted in renderSeparator, allowing you
	     * to control the separators above and below the highlighted row. The highlighted
	     * state of a row can be reset by calling highlightRow(null).
	     */
	    renderRow: _propTypes2.default.func.isRequired,
	    /**
	     * How many rows to render on initial component mount. Use this to make
	     * it so that the first screen worth of data appears at one time instead of
	     * over the course of multiple frames.
	     */
	    initialListSize: _propTypes2.default.number.isRequired,
	    /**
	     * Called when all rows have been rendered and the list has been scrolled
	     * to within onEndReachedThreshold of the bottom. The native scroll
	     * event is provided.
	     */
	    onEndReached: _propTypes2.default.func,
	    /**
	     * Threshold in pixels (virtual, not physical) for calling onEndReached.
	     */
	    onEndReachedThreshold: _propTypes2.default.number.isRequired,
	    /**
	     * Number of rows to render per event loop. Note: if your 'rows' are actually
	     * cells, i.e. they don't span the full width of your view (as in the
	     * ListViewGridLayoutExample), you should set the pageSize to be a multiple
	     * of the number of cells per row, otherwise you're likely to see gaps at
	     * the edge of the ListView as new pages are loaded.
	     */
	    pageSize: _propTypes2.default.number.isRequired,
	    /**
	     * () => renderable
	     *
	     * The header and footer are always rendered (if these props are provided)
	     * on every render pass. If they are expensive to re-render, wrap them
	     * in StaticContainer or other mechanism as appropriate. Footer is always
	     * at the bottom of the list, and header at the top, on every render pass.
	     * In a horizontal ListView, the header is rendered on the left and the
	     * footer on the right.
	     */
	    renderFooter: _propTypes2.default.func,
	    renderHeader: _propTypes2.default.func,
	    /**
	     * (sectionData, sectionID) => renderable
	     *
	     * If provided, a header is rendered for this section.
	     */
	    renderSectionHeader: _propTypes2.default.func,
	    /**
	     * (props) => renderable
	     *
	     * A function that returns the scrollable component in which the list rows
	     * are rendered. Defaults to returning a ScrollView with the given props.
	     */
	    renderScrollComponent: _propTypes2.default.func.isRequired,
	    /**
	     * How early to start rendering rows before they come on screen, in
	     * pixels.
	     */
	    scrollRenderAheadDistance: _propTypes2.default.number.isRequired,
	    /**
	     * (visibleRows, changedRows) => void
	     *
	     * Called when the set of visible rows changes. `visibleRows` maps
	     * { sectionID: { rowID: true }} for all the visible rows, and
	     * `changedRows` maps { sectionID: { rowID: true | false }} for the rows
	     * that have changed their visibility, with true indicating visible, and
	     * false indicating the view has moved out of view.
	     */
	    onChangeVisibleRows: _propTypes2.default.func,
	    /**
	     * A performance optimization for improving scroll perf of
	     * large lists, used in conjunction with overflow: 'hidden' on the row
	     * containers. This is enabled by default.
	     */
	    removeClippedSubviews: _propTypes2.default.bool,
	    /**
	     * Makes the sections headers sticky. The sticky behavior means that it
	     * will scroll with the content at the top of the section until it reaches
	     * the top of the screen, at which point it will stick to the top until it
	     * is pushed off the screen by the next section header. This property is
	     * not supported in conjunction with `horizontal={true}`. Only enabled by
	     * default on iOS because of typical platform standards.
	     */
	    stickySectionHeadersEnabled: _propTypes2.default.bool,
	    /**
	     * An array of child indices determining which children get docked to the
	     * top of the screen when scrolling. For example, passing
	     * `stickyHeaderIndices={[0]}` will cause the first child to be fixed to the
	     * top of the scroll view. This property is not supported in conjunction
	     * with `horizontal={true}`.
	     */
	    stickyHeaderIndices: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	    /**
	     * Flag indicating whether empty section headers should be rendered. In the future release
	     * empty section headers will be rendered by default, and the flag will be deprecated.
	     * If empty sections are not desired to be rendered their indices should be excluded from sectionID object.
	     */
	    enableEmptySections: _propTypes2.default.bool
	  }),
	
	  /**
	   * Exports some data, e.g. for perf investigations or analytics.
	   */
	  getMetrics: function getMetrics() {
	    return {
	      contentLength: this.scrollProperties.contentLength,
	      totalRows: this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount(),
	      renderedRows: this.state.curRenderedRowsCount,
	      visibleRows: Object.keys(this._visibleRows).length
	    };
	  },
	
	  /**
	   * Provides a handle to the underlying scroll responder.
	   * Note that `this._scrollComponent` might not be a `ScrollView`, so we
	   * need to check that it responds to `getScrollResponder` before calling it.
	   */
	  getScrollResponder: function getScrollResponder() {
	    if (this._scrollComponent && this._scrollComponent.getScrollResponder) {
	      return this._scrollComponent.getScrollResponder();
	    }
	  },
	
	  getScrollableNode: function getScrollableNode() {
	    if (this._scrollComponent && this._scrollComponent.getScrollableNode) {
	      return this._scrollComponent.getScrollableNode();
	    } else {
	      return (0, _findNodeHandle2.default)(this._scrollComponent);
	    }
	  },
	
	  /**
	   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
	   *
	   * See `ScrollView#scrollTo`.
	   */
	  scrollTo: function scrollTo() {
	    if (this._scrollComponent && this._scrollComponent.scrollTo) {
	      var _scrollComponent;
	
	      (_scrollComponent = this._scrollComponent).scrollTo.apply(_scrollComponent, arguments);
	    }
	  },
	
	  /**
	   * If this is a vertical ListView scrolls to the bottom.
	   * If this is a horizontal ListView scrolls to the right.
	   *
	   * Use `scrollToEnd({animated: true})` for smooth animated scrolling,
	   * `scrollToEnd({animated: false})` for immediate scrolling.
	   * If no options are passed, `animated` defaults to true.
	   *
	   * See `ScrollView#scrollToEnd`.
	   */
	  scrollToEnd: function scrollToEnd(options) {
	    if (this._scrollComponent) {
	      if (this._scrollComponent.scrollToEnd) {
	        this._scrollComponent.scrollToEnd(options);
	      } else {
	        console.warn('The scroll component used by the ListView does not support ' + 'scrollToEnd. Check the renderScrollComponent prop of your ListView.');
	      }
	    }
	  },
	
	  /**
	   * Displays the scroll indicators momentarily.
	   *
	   * @platform ios
	   */
	  flashScrollIndicators: function flashScrollIndicators() {
	    if (this._scrollComponent && this._scrollComponent.flashScrollIndicators) {
	      this._scrollComponent.flashScrollIndicators();
	    }
	  },
	
	  setNativeProps: function setNativeProps(props) {
	    if (this._scrollComponent) {
	      this._scrollComponent.setNativeProps(props);
	    }
	  },
	
	  /**
	   * React life cycle hooks.
	   */
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialListSize: DEFAULT_INITIAL_ROWS,
	      pageSize: DEFAULT_PAGE_SIZE,
	      renderScrollComponent: function renderScrollComponent(props) {
	        return _react2.default.createElement(_ScrollView2.default, props);
	      },
	      scrollRenderAheadDistance: DEFAULT_SCROLL_RENDER_AHEAD,
	      onEndReachedThreshold: DEFAULT_END_REACHED_THRESHOLD,
	      stickySectionHeadersEnabled: _Platform2.default.OS === 'ios' || _Platform2.default.OS === 'web',
	      stickyHeaderIndices: []
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      curRenderedRowsCount: this.props.initialListSize,
	      highlightedRow: {}
	    };
	  },
	
	  getInnerViewNode: function getInnerViewNode() {
	    return this._scrollComponent.getInnerViewNode();
	  },
	
	  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
	    // this data should never trigger a render pass, so don't put in state
	    this.scrollProperties = {
	      visibleLength: null,
	      contentLength: null,
	      offset: 0
	    };
	    this._childFrames = [];
	    this._visibleRows = {};
	    this._prevRenderedRowsCount = 0;
	    this._sentEndForContentLength = null;
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    // do this in animation frame until componentDidMount actually runs after
	    // the component is laid out
	    this.requestAnimationFrame(function () {
	      _this._measureAndUpdateScrollProps();
	    });
	  },
	
	  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (this.props.dataSource !== nextProps.dataSource || this.props.initialListSize !== nextProps.initialListSize) {
	      this.setState(function (state, props) {
	        _this2._prevRenderedRowsCount = 0;
	        return {
	          curRenderedRowsCount: Math.min(Math.max(state.curRenderedRowsCount, props.initialListSize), props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount())
	        };
	      }, function () {
	        return _this2._renderMoreRowsIfNeeded();
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    var _this3 = this;
	
	    this.requestAnimationFrame(function () {
	      _this3._measureAndUpdateScrollProps();
	    });
	  },
	
	  _onRowHighlighted: function _onRowHighlighted(sectionID, rowID) {
	    this.setState({ highlightedRow: { sectionID: sectionID, rowID: rowID } });
	  },
	
	  render: function render() {
	    var bodyComponents = [];
	
	    var dataSource = this.props.dataSource;
	    var allRowIDs = dataSource.rowIdentities;
	    var rowCount = 0;
	    var stickySectionHeaderIndices = [];
	
	    var renderSectionHeader = this.props.renderSectionHeader;
	
	
	    var header = this.props.renderHeader && this.props.renderHeader();
	    var footer = this.props.renderFooter && this.props.renderFooter();
	    var totalIndex = header ? 1 : 0;
	
	    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
	      var sectionID = dataSource.sectionIdentities[sectionIdx];
	      var rowIDs = allRowIDs[sectionIdx];
	      if (rowIDs.length === 0) {
	        if (this.props.enableEmptySections === undefined) {
	          /* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses
	           * an error found when Flow v0.54 was deployed. To see the error
	           * delete this comment and run Flow. */
	          var warning = __webpack_require__(19);
	          warning(false, 'In next release empty section headers will be rendered.' + " In this release you can use 'enableEmptySections' flag to render empty section headers.");
	          continue;
	        } else {
	          var invariant = __webpack_require__(7);
	          invariant(this.props.enableEmptySections, "In next release 'enableEmptySections' flag will be deprecated, empty section headers will always be rendered." + ' If empty section headers are not desirable their indices should be excluded from sectionIDs object.' + " In this release 'enableEmptySections' may only have value 'true' to allow empty section headers rendering.");
	        }
	      }
	
	      if (renderSectionHeader) {
	        var element = renderSectionHeader(dataSource.getSectionHeaderData(sectionIdx), sectionID);
	        if (element) {
	          bodyComponents.push(_react2.default.cloneElement(element, { key: 's_' + sectionID }));
	          if (this.props.stickySectionHeadersEnabled) {
	            stickySectionHeaderIndices.push(totalIndex);
	          }
	          totalIndex++;
	        }
	      }
	
	      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
	        var rowID = rowIDs[rowIdx];
	        var comboID = sectionID + '_' + rowID;
	        var shouldUpdateRow = rowCount >= this._prevRenderedRowsCount && dataSource.rowShouldUpdate(sectionIdx, rowIdx);
	        var row = _react2.default.createElement(_StaticRenderer2.default, {
	          key: 'r_' + comboID,
	          shouldUpdate: !!shouldUpdateRow,
	          render: this.props.renderRow.bind(null, dataSource.getRowData(sectionIdx, rowIdx), sectionID, rowID, this._onRowHighlighted)
	        });
	        bodyComponents.push(row);
	        totalIndex++;
	
	        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
	          var adjacentRowHighlighted = this.state.highlightedRow.sectionID === sectionID && (this.state.highlightedRow.rowID === rowID || this.state.highlightedRow.rowID === rowIDs[rowIdx + 1]);
	          var separator = this.props.renderSeparator(sectionID, rowID, adjacentRowHighlighted);
	          if (separator) {
	            bodyComponents.push(_react2.default.createElement(
	              _View2.default,
	              { key: 's_' + comboID },
	              separator
	            ));
	            totalIndex++;
	          }
	        }
	        if (++rowCount === this.state.curRenderedRowsCount) {
	          break;
	        }
	      }
	      if (rowCount >= this.state.curRenderedRowsCount) {
	        break;
	      }
	    }
	
	    var _props = this.props,
	        renderScrollComponent = _props.renderScrollComponent,
	        props = _objectWithoutProperties(_props, ['renderScrollComponent']);
	
	    if (!props.scrollEventThrottle) {
	      props.scrollEventThrottle = DEFAULT_SCROLL_CALLBACK_THROTTLE;
	    }
	    if (props.removeClippedSubviews === undefined) {
	      props.removeClippedSubviews = true;
	    }
	    Object.assign(props, {
	      onScroll: this._onScroll,
	      stickyHeaderIndices: this.props.stickyHeaderIndices.concat(stickySectionHeaderIndices),
	
	      // Do not pass these events downstream to ScrollView since they will be
	      // registered in ListView's own ScrollResponder.Mixin
	      onKeyboardWillShow: undefined,
	      onKeyboardWillHide: undefined,
	      onKeyboardDidShow: undefined,
	      onKeyboardDidHide: undefined
	    });
	
	    return (0, _cloneReferencedElement2.default)(renderScrollComponent(props), {
	      ref: this._setScrollComponentRef,
	      onContentSizeChange: this._onContentSizeChange,
	      onLayout: this._onLayout,
	      DEPRECATED_sendUpdatedChildFrames: typeof props.onChangeVisibleRows !== undefined
	    }, header, bodyComponents, footer);
	  },
	
	  /**
	   * Private methods
	   */
	
	  _measureAndUpdateScrollProps: function _measureAndUpdateScrollProps() {
	    var scrollComponent = this.getScrollResponder();
	    if (!scrollComponent || !scrollComponent.getInnerViewNode) {
	      return;
	    }
	
	    // RCTScrollViewManager.calculateChildFrames is not available on
	    // every platform
	    RCTScrollViewManager && RCTScrollViewManager.calculateChildFrames && RCTScrollViewManager.calculateChildFrames((0, _findNodeHandle2.default)(scrollComponent), this._updateVisibleRows);
	  },
	
	  _setScrollComponentRef: function _setScrollComponentRef(scrollComponent) {
	    this._scrollComponent = scrollComponent;
	  },
	
	  _onContentSizeChange: function _onContentSizeChange(width, height) {
	    var contentLength = !this.props.horizontal ? height : width;
	    if (contentLength !== this.scrollProperties.contentLength) {
	      this.scrollProperties.contentLength = contentLength;
	      this._updateVisibleRows();
	      this._renderMoreRowsIfNeeded();
	    }
	    this.props.onContentSizeChange && this.props.onContentSizeChange(width, height);
	  },
	
	  _onLayout: function _onLayout(event) {
	    var _event$nativeEvent$la = event.nativeEvent.layout,
	        width = _event$nativeEvent$la.width,
	        height = _event$nativeEvent$la.height;
	
	    var visibleLength = !this.props.horizontal ? height : width;
	    if (visibleLength !== this.scrollProperties.visibleLength) {
	      this.scrollProperties.visibleLength = visibleLength;
	      this._updateVisibleRows();
	      this._renderMoreRowsIfNeeded();
	    }
	    this.props.onLayout && this.props.onLayout(event);
	  },
	
	  _maybeCallOnEndReached: function _maybeCallOnEndReached(event) {
	    if (this.props.onEndReached && this.scrollProperties.contentLength !== this._sentEndForContentLength && this._getDistanceFromEnd(this.scrollProperties) < this.props.onEndReachedThreshold && this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
	      this._sentEndForContentLength = this.scrollProperties.contentLength;
	      this.props.onEndReached(event);
	      return true;
	    }
	    return false;
	  },
	
	  _renderMoreRowsIfNeeded: function _renderMoreRowsIfNeeded() {
	    if (this.scrollProperties.contentLength === null || this.scrollProperties.visibleLength === null || this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
	      this._maybeCallOnEndReached();
	      return;
	    }
	
	    var distanceFromEnd = this._getDistanceFromEnd(this.scrollProperties);
	    if (distanceFromEnd < this.props.scrollRenderAheadDistance) {
	      this._pageInNewRows();
	    }
	  },
	
	  _pageInNewRows: function _pageInNewRows() {
	    var _this4 = this;
	
	    this.setState(function (state, props) {
	      var rowsToRender = Math.min(state.curRenderedRowsCount + props.pageSize, props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount());
	      _this4._prevRenderedRowsCount = state.curRenderedRowsCount;
	      return {
	        curRenderedRowsCount: rowsToRender
	      };
	    }, function () {
	      _this4._measureAndUpdateScrollProps();
	      _this4._prevRenderedRowsCount = _this4.state.curRenderedRowsCount;
	    });
	  },
	
	  _getDistanceFromEnd: function _getDistanceFromEnd(scrollProperties) {
	    return scrollProperties.contentLength - scrollProperties.visibleLength - scrollProperties.offset;
	  },
	
	  _updateVisibleRows: function _updateVisibleRows(updatedFrames) {
	    var _this5 = this;
	
	    if (!this.props.onChangeVisibleRows) {
	      return; // No need to compute visible rows if there is no callback
	    }
	    if (updatedFrames) {
	      updatedFrames.forEach(function (newFrame) {
	        _this5._childFrames[newFrame.index] = merge(newFrame);
	      });
	    }
	    var isVertical = !this.props.horizontal;
	    var dataSource = this.props.dataSource;
	    var visibleMin = this.scrollProperties.offset;
	    var visibleMax = visibleMin + this.scrollProperties.visibleLength;
	    var allRowIDs = dataSource.rowIdentities;
	
	    var header = this.props.renderHeader && this.props.renderHeader();
	    var totalIndex = header ? 1 : 0;
	    var visibilityChanged = false;
	    var changedRows = {};
	    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
	      var rowIDs = allRowIDs[sectionIdx];
	      if (rowIDs.length === 0) {
	        continue;
	      }
	      var sectionID = dataSource.sectionIdentities[sectionIdx];
	      if (this.props.renderSectionHeader) {
	        totalIndex++;
	      }
	      var visibleSection = this._visibleRows[sectionID];
	      if (!visibleSection) {
	        visibleSection = {};
	      }
	      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
	        var rowID = rowIDs[rowIdx];
	        var frame = this._childFrames[totalIndex];
	        totalIndex++;
	        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
	          totalIndex++;
	        }
	        if (!frame) {
	          break;
	        }
	        var rowVisible = visibleSection[rowID];
	        var min = isVertical ? frame.y : frame.x;
	        var max = min + (isVertical ? frame.height : frame.width);
	        if (!min && !max || min === max) {
	          break;
	        }
	        if (min > visibleMax || max < visibleMin) {
	          if (rowVisible) {
	            visibilityChanged = true;
	            delete visibleSection[rowID];
	            if (!changedRows[sectionID]) {
	              changedRows[sectionID] = {};
	            }
	            changedRows[sectionID][rowID] = false;
	          }
	        } else if (!rowVisible) {
	          visibilityChanged = true;
	          visibleSection[rowID] = true;
	          if (!changedRows[sectionID]) {
	            changedRows[sectionID] = {};
	          }
	          changedRows[sectionID][rowID] = true;
	        }
	      }
	      if (!(0, _isEmpty2.default)(visibleSection)) {
	        this._visibleRows[sectionID] = visibleSection;
	      } else if (this._visibleRows[sectionID]) {
	        delete this._visibleRows[sectionID];
	      }
	    }
	    visibilityChanged && this.props.onChangeVisibleRows(this._visibleRows, changedRows);
	  },
	
	  _onScroll: function _onScroll(e) {
	    var isVertical = !this.props.horizontal;
	    this.scrollProperties.visibleLength = e.nativeEvent.layoutMeasurement[isVertical ? 'height' : 'width'];
	    this.scrollProperties.contentLength = e.nativeEvent.contentSize[isVertical ? 'height' : 'width'];
	    this.scrollProperties.offset = e.nativeEvent.contentOffset[isVertical ? 'y' : 'x'];
	    this._updateVisibleRows(e.nativeEvent.updatedChildFrames);
	    if (!this._maybeCallOnEndReached(e)) {
	      this._renderMoreRowsIfNeeded();
	    }
	
	    if (this.props.onEndReached && this._getDistanceFromEnd(this.scrollProperties) > this.props.onEndReachedThreshold) {
	      // Scrolled out of the end zone, so it should be able to trigger again.
	      this._sentEndForContentLength = null;
	    }
	
	    this.props.onScroll && this.props.onScroll(e);
	  }
	});
	
	exports.default = ListView;
	module.exports = exports['default'];

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule NativeEventEmitter
	 * 
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _EventEmitter2 = __webpack_require__(1487);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _Platform = __webpack_require__(106);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Abstract base class for implementing event-emitting modules. This implements
	 * a subset of the standard EventEmitter node module API.
	 */
	var NativeEventEmitter = function (_EventEmitter) {
	  _inherits(NativeEventEmitter, _EventEmitter);
	
	  function NativeEventEmitter(nativeModule) {
	    _classCallCheck(this, NativeEventEmitter);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    if (_Platform2.default.OS === 'ios') {
	      (0, _invariant2.default)(nativeModule, 'Native module cannot be null.');
	      _this._nativeModule = nativeModule;
	    }
	    return _this;
	  }
	
	  NativeEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
	    if (this._nativeModule != null) {
	      this._nativeModule.addListener(eventType);
	    }
	    return _EventEmitter.prototype.addListener.call(this, eventType, listener, context);
	  };
	
	  NativeEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
	    (0, _invariant2.default)(eventType, 'eventType argument is required.');
	    var count = this.listeners(eventType).length;
	    if (this._nativeModule != null) {
	      this._nativeModule.removeListeners(count);
	    }
	    _EventEmitter.prototype.removeAllListeners.call(this, eventType);
	  };
	
	  NativeEventEmitter.prototype.removeSubscription = function removeSubscription(subscription) {
	    if (this._nativeModule != null) {
	      this._nativeModule.removeListeners(1);
	    }
	    _EventEmitter.prototype.removeSubscription.call(this, subscription);
	  };
	
	  return NativeEventEmitter;
	}(_EventEmitter3.default);
	
	exports.default = NativeEventEmitter;
	module.exports = exports['default'];

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	}; /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * From React 16.0.0
	 */
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = twoArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  twoArgumentPooler: twoArgumentPooler
	};
	
	exports.default = PooledClass;
	module.exports = exports['default'];

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule SwipeableRow
	 * @noflow
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _Animated = __webpack_require__(1027);
	
	var _Animated2 = _interopRequireDefault(_Animated);
	
	var _I18nManager = __webpack_require__(125);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _PanResponder = __webpack_require__(1030);
	
	var _PanResponder2 = _interopRequireDefault(_PanResponder);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _reactTimerMixin = __webpack_require__(128);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _emptyFunction = __webpack_require__(37);
	
	var _emptyFunction2 = _interopRequireDefault(_emptyFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses an error
	 * found when Flow v0.54 was deployed. To see the error delete this comment and
	 * run Flow. */
	var isRTL = function isRTL() {
	  return _I18nManager2.default.isRTL;
	};
	
	// NOTE: Eventually convert these consts to an input object of configurations
	
	// Position of the left of the swipable item when closed
	var CLOSED_LEFT_POSITION = 0;
	// Minimum swipe distance before we recognize it as such
	var HORIZONTAL_SWIPE_DISTANCE_THRESHOLD = 10;
	// Minimum swipe speed before we fully animate the user's action (open/close)
	var HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD = 0.3;
	// Factor to divide by to get slow speed; i.e. 4 means 1/4 of full speed
	var SLOW_SPEED_SWIPE_FACTOR = 4;
	// Time, in milliseconds, of how long the animated swipe should be
	var SWIPE_DURATION = 300;
	
	/**
	 * On SwipeableListView mount, the 1st item will bounce to show users it's
	 * possible to swipe
	 */
	var ON_MOUNT_BOUNCE_DELAY = 700;
	var ON_MOUNT_BOUNCE_DURATION = 400;
	
	// Distance left of closed position to bounce back when right-swiping from closed
	var RIGHT_SWIPE_BOUNCE_BACK_DISTANCE = 30;
	var RIGHT_SWIPE_BOUNCE_BACK_DURATION = 300;
	/**
	 * Max distance of right swipe to allow (right swipes do functionally nothing).
	 * Must be multiplied by SLOW_SPEED_SWIPE_FACTOR because gestureState.dx tracks
	 * how far the finger swipes, and not the actual animation distance.
	*/
	var RIGHT_SWIPE_THRESHOLD = 30 * SLOW_SPEED_SWIPE_FACTOR;
	
	/**
	 * Creates a swipable row that allows taps on the main item and a custom View
	 * on the item hidden behind the row. Typically this should be used in
	 * conjunction with SwipeableListView for additional functionality, but can be
	 * used in a normal ListView. See the renderRow for SwipeableListView to see how
	 * to use this component separately.
	 */
	var SwipeableRow = (0, _createReactClass2.default)({
	  displayName: 'SwipeableRow',
	  _panResponder: {},
	  _previousLeft: CLOSED_LEFT_POSITION,
	
	  mixins: [_reactTimerMixin2.default],
	
	  propTypes: {
	    children: _propTypes2.default.any,
	    isOpen: _propTypes2.default.bool,
	    preventSwipeRight: _propTypes2.default.bool,
	    maxSwipeDistance: _propTypes2.default.number.isRequired,
	    onOpen: _propTypes2.default.func.isRequired,
	    onClose: _propTypes2.default.func.isRequired,
	    onSwipeEnd: _propTypes2.default.func.isRequired,
	    onSwipeStart: _propTypes2.default.func.isRequired,
	    // Should bounce the row on mount
	    shouldBounceOnMount: _propTypes2.default.bool,
	    /**
	     * A ReactElement that is unveiled when the user swipes
	     */
	    slideoutView: _propTypes2.default.node.isRequired,
	    /**
	     * The minimum swipe distance required before fully animating the swipe. If
	     * the user swipes less than this distance, the item will return to its
	     * previous (open/close) position.
	     */
	    swipeThreshold: _propTypes2.default.number.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      currentLeft: new _Animated2.default.Value(this._previousLeft),
	      /**
	       * In order to render component A beneath component B, A must be rendered
	       * before B. However, this will cause "flickering", aka we see A briefly
	       * then B. To counter this, _isSwipeableViewRendered flag is used to set
	       * component A to be transparent until component B is loaded.
	       */
	      isSwipeableViewRendered: false,
	      rowHeight: null
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isOpen: false,
	      preventSwipeRight: false,
	      maxSwipeDistance: 0,
	      onOpen: _emptyFunction2.default,
	      onClose: _emptyFunction2.default,
	      onSwipeEnd: _emptyFunction2.default,
	      onSwipeStart: _emptyFunction2.default,
	      swipeThreshold: 30
	    };
	  },
	  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
	    this._panResponder = _PanResponder2.default.create({
	      onMoveShouldSetPanResponderCapture: this._handleMoveShouldSetPanResponderCapture,
	      onPanResponderGrant: this._handlePanResponderGrant,
	      onPanResponderMove: this._handlePanResponderMove,
	      onPanResponderRelease: this._handlePanResponderEnd,
	      onPanResponderTerminationRequest: this._onPanResponderTerminationRequest,
	      onPanResponderTerminate: this._handlePanResponderEnd,
	      onShouldBlockNativeResponder: function onShouldBlockNativeResponder(event, gestureState) {
	        return false;
	      }
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (this.props.shouldBounceOnMount) {
	      /**
	       * Do the on mount bounce after a delay because if we animate when other
	       * components are loading, the animation will be laggy
	       */
	      this.setTimeout(function () {
	        _this._animateBounceBack(ON_MOUNT_BOUNCE_DURATION);
	      }, ON_MOUNT_BOUNCE_DELAY);
	    }
	  },
	  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
	    /**
	     * We do not need an "animateOpen(noCallback)" because this animation is
	     * handled internally by this component.
	     */
	    if (this.props.isOpen && !nextProps.isOpen) {
	      this._animateToClosedPosition();
	    }
	  },
	  render: function render() {
	    // The view hidden behind the main view
	    var slideOutView = void 0;
	    if (this.state.isSwipeableViewRendered && this.state.rowHeight) {
	      slideOutView = _react2.default.createElement(
	        _View2.default,
	        { style: [styles.slideOutContainer, { height: this.state.rowHeight }] },
	        this.props.slideoutView
	      );
	    }
	
	    // The swipeable item
	    var swipeableView = _react2.default.createElement(
	      _Animated2.default.View,
	      {
	        onLayout: this._onSwipeableViewLayout,
	        style: { transform: [{ translateX: this.state.currentLeft }] } },
	      this.props.children
	    );
	
	    return _react2.default.createElement(
	      _View2.default,
	      this._panResponder.panHandlers,
	      slideOutView,
	      swipeableView
	    );
	  },
	  close: function close() {
	    this.props.onClose();
	    this._animateToClosedPosition();
	  },
	  _onSwipeableViewLayout: function _onSwipeableViewLayout(event) {
	    this.setState({
	      isSwipeableViewRendered: true,
	      rowHeight: event.nativeEvent.layout.height
	    });
	  },
	  _handleMoveShouldSetPanResponderCapture: function _handleMoveShouldSetPanResponderCapture(event, gestureState) {
	    // Decides whether a swipe is responded to by this component or its child
	    return gestureState.dy < 10 && this._isValidSwipe(gestureState);
	  },
	  _handlePanResponderGrant: function _handlePanResponderGrant(event, gestureState) {},
	  _handlePanResponderMove: function _handlePanResponderMove(event, gestureState) {
	    if (this._isSwipingExcessivelyRightFromClosedPosition(gestureState)) {
	      return;
	    }
	
	    this.props.onSwipeStart();
	
	    if (this._isSwipingRightFromClosed(gestureState)) {
	      this._swipeSlowSpeed(gestureState);
	    } else {
	      this._swipeFullSpeed(gestureState);
	    }
	  },
	  _isSwipingRightFromClosed: function _isSwipingRightFromClosed(gestureState) {
	    var gestureStateDx = isRTL() ? -gestureState.dx : gestureState.dx;
	    return this._previousLeft === CLOSED_LEFT_POSITION && gestureStateDx > 0;
	  },
	  _swipeFullSpeed: function _swipeFullSpeed(gestureState) {
	    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx);
	  },
	  _swipeSlowSpeed: function _swipeSlowSpeed(gestureState) {
	    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx / SLOW_SPEED_SWIPE_FACTOR);
	  },
	  _isSwipingExcessivelyRightFromClosedPosition: function _isSwipingExcessivelyRightFromClosedPosition(gestureState) {
	    /**
	     * We want to allow a BIT of right swipe, to allow users to know that
	     * swiping is available, but swiping right does not do anything
	     * functionally.
	     */
	    var gestureStateDx = isRTL() ? -gestureState.dx : gestureState.dx;
	    return this._isSwipingRightFromClosed(gestureState) && gestureStateDx > RIGHT_SWIPE_THRESHOLD;
	  },
	  _onPanResponderTerminationRequest: function _onPanResponderTerminationRequest(event, gestureState) {
	    return false;
	  },
	  _animateTo: function _animateTo(toValue) {
	    var _this2 = this;
	
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SWIPE_DURATION;
	    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emptyFunction2.default;
	
	    _Animated2.default.timing(this.state.currentLeft, {
	      duration: duration,
	      toValue: toValue,
	      useNativeDriver: true
	    }).start(function () {
	      _this2._previousLeft = toValue;
	      callback();
	    });
	  },
	  _animateToOpenPosition: function _animateToOpenPosition() {
	    var maxSwipeDistance = isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;
	    this._animateTo(-maxSwipeDistance);
	  },
	  _animateToOpenPositionWith: function _animateToOpenPositionWith(speed, distMoved) {
	    /**
	     * Ensure the speed is at least the set speed threshold to prevent a slow
	     * swiping animation
	     */
	    speed = speed > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD ? speed : HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
	    /**
	     * Calculate the duration the row should take to swipe the remaining distance
	     * at the same speed the user swiped (or the speed threshold)
	     */
	    var duration = Math.abs((this.props.maxSwipeDistance - Math.abs(distMoved)) / speed);
	    var maxSwipeDistance = isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;
	    this._animateTo(-maxSwipeDistance, duration);
	  },
	  _animateToClosedPosition: function _animateToClosedPosition() {
	    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SWIPE_DURATION;
	
	    this._animateTo(CLOSED_LEFT_POSITION, duration);
	  },
	  _animateToClosedPositionDuringBounce: function _animateToClosedPositionDuringBounce() {
	    this._animateToClosedPosition(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
	  },
	  _animateBounceBack: function _animateBounceBack(duration) {
	    /**
	     * When swiping right, we want to bounce back past closed position on release
	     * so users know they should swipe right to get content.
	     */
	    var swipeBounceBackDistance = isRTL() ? -RIGHT_SWIPE_BOUNCE_BACK_DISTANCE : RIGHT_SWIPE_BOUNCE_BACK_DISTANCE;
	    this._animateTo(-swipeBounceBackDistance, duration, this._animateToClosedPositionDuringBounce);
	  },
	
	
	  // Ignore swipes due to user's finger moving slightly when tapping
	  _isValidSwipe: function _isValidSwipe(gestureState) {
	    if (this.props.preventSwipeRight && this._previousLeft === CLOSED_LEFT_POSITION && gestureState.dx > 0) {
	      return false;
	    }
	
	    return Math.abs(gestureState.dx) > HORIZONTAL_SWIPE_DISTANCE_THRESHOLD;
	  },
	  _shouldAnimateRemainder: function _shouldAnimateRemainder(gestureState) {
	    /**
	     * If user has swiped past a certain distance, animate the rest of the way
	     * if they let go
	     */
	    return Math.abs(gestureState.dx) > this.props.swipeThreshold || gestureState.vx > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
	  },
	  _handlePanResponderEnd: function _handlePanResponderEnd(event, gestureState) {
	    var horizontalDistance = isRTL() ? -gestureState.dx : gestureState.dx;
	    if (this._isSwipingRightFromClosed(gestureState)) {
	      this.props.onOpen();
	      this._animateBounceBack(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
	    } else if (this._shouldAnimateRemainder(gestureState)) {
	      if (horizontalDistance < 0) {
	        // Swiped left
	        this.props.onOpen();
	        this._animateToOpenPositionWith(gestureState.vx, horizontalDistance);
	      } else {
	        // Swiped right
	        this.props.onClose();
	        this._animateToClosedPosition();
	      }
	    } else {
	      if (this._previousLeft === CLOSED_LEFT_POSITION) {
	        this._animateToClosedPosition();
	      } else {
	        this._animateToOpenPosition();
	      }
	    }
	
	    this.props.onSwipeEnd();
	  }
	});
	
	var styles = _StyleSheet2.default.create({
	  slideOutContainer: {
	    bottom: 0,
	    left: 0,
	    position: 'absolute',
	    right: 0,
	    top: 0
	  }
	});
	
	exports.default = SwipeableRow;
	module.exports = exports['default'];

/***/ },
/* 1069 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule isEmpty
	 */
	'use strict';
	
	/**
	 * Mimics empty from PHP.
	 */
	
	exports.__esModule = true;
	function isEmpty(obj) {
	  if (Array.isArray(obj)) {
	    return obj.length === 0;
	  } else if (typeof obj === 'object') {
	    for (var i in obj) {
	      return false;
	    }
	    return true;
	  } else {
	    return !obj;
	  }
	}
	
	exports.default = isEmpty;
	module.exports = exports['default'];

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1091);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(116);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(862);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(156).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(1074);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(129).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(98);
	util.inherits = __webpack_require__(82);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1514);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1498);
	var destroyImpl = __webpack_require__(1073);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(70);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(832).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(70);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(832).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)))

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(70);
	
	/*<replacement>*/
	var util = __webpack_require__(98);
	util.inherits = __webpack_require__(82);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(116);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(156).EventEmitter;


/***/ },
/* 1075 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLAttribute;
	
	  module.exports = XMLAttribute = (function() {
	    function XMLAttribute(parent, name, value) {
	      this.options = parent.options;
	      this.stringify = parent.stringify;
	      if (name == null) {
	        throw new Error("Missing attribute name of element " + parent.name);
	      }
	      if (value == null) {
	        throw new Error("Missing attribute value for attribute " + name + " of element " + parent.name);
	      }
	      this.name = this.stringify.attName(name);
	      this.value = this.stringify.attValue(value);
	    }
	
	    XMLAttribute.prototype.clone = function() {
	      return Object.create(this);
	    };
	
	    XMLAttribute.prototype.toString = function(options) {
	      return this.options.writer.set(options).attribute(this);
	    };
	
	    return XMLAttribute;
	
	  })();
	
	}).call(this);


/***/ },
/* 1076 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLStringifier,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    hasProp = {}.hasOwnProperty;
	
	  module.exports = XMLStringifier = (function() {
	    function XMLStringifier(options) {
	      this.assertLegalChar = bind(this.assertLegalChar, this);
	      var key, ref, value;
	      options || (options = {});
	      this.noDoubleEncoding = options.noDoubleEncoding;
	      ref = options.stringify || {};
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this[key] = value;
	      }
	    }
	
	    XMLStringifier.prototype.eleName = function(val) {
	      val = '' + val || '';
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.eleText = function(val) {
	      val = '' + val || '';
	      return this.assertLegalChar(this.elEscape(val));
	    };
	
	    XMLStringifier.prototype.cdata = function(val) {
	      val = '' + val || '';
	      val = val.replace(']]>', ']]]]><![CDATA[>');
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.comment = function(val) {
	      val = '' + val || '';
	      if (val.match(/--/)) {
	        throw new Error("Comment text cannot contain double-hypen: " + val);
	      }
	      return this.assertLegalChar(val);
	    };
	
	    XMLStringifier.prototype.raw = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.attName = function(val) {
	      return val = '' + val || '';
	    };
	
	    XMLStringifier.prototype.attValue = function(val) {
	      val = '' + val || '';
	      return this.attEscape(val);
	    };
	
	    XMLStringifier.prototype.insTarget = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.insValue = function(val) {
	      val = '' + val || '';
	      if (val.match(/\?>/)) {
	        throw new Error("Invalid processing instruction value: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlVersion = function(val) {
	      val = '' + val || '';
	      if (!val.match(/1\.[0-9]+/)) {
	        throw new Error("Invalid version number: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlEncoding = function(val) {
	      val = '' + val || '';
	      if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) {
	        throw new Error("Invalid encoding: " + val);
	      }
	      return val;
	    };
	
	    XMLStringifier.prototype.xmlStandalone = function(val) {
	      if (val) {
	        return "yes";
	      } else {
	        return "no";
	      }
	    };
	
	    XMLStringifier.prototype.dtdPubID = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdSysID = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdElementValue = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttType = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdAttDefault = function(val) {
	      if (val != null) {
	        return '' + val || '';
	      } else {
	        return val;
	      }
	    };
	
	    XMLStringifier.prototype.dtdEntityValue = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.dtdNData = function(val) {
	      return '' + val || '';
	    };
	
	    XMLStringifier.prototype.convertAttKey = '@';
	
	    XMLStringifier.prototype.convertPIKey = '?';
	
	    XMLStringifier.prototype.convertTextKey = '#text';
	
	    XMLStringifier.prototype.convertCDataKey = '#cdata';
	
	    XMLStringifier.prototype.convertCommentKey = '#comment';
	
	    XMLStringifier.prototype.convertRawKey = '#raw';
	
	    XMLStringifier.prototype.assertLegalChar = function(str) {
	      var res;
	      res = str.match(/[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/);
	      if (res) {
	        throw new Error("Invalid character in string: " + str + " at index " + res.index);
	      }
	      return str;
	    };
	
	    XMLStringifier.prototype.elEscape = function(str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
	    };
	
	    XMLStringifier.prototype.attEscape = function(str) {
	      var ampregex;
	      ampregex = this.noDoubleEncoding ? /(?!&\S+;)&/g : /&/g;
	      return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
	    };
	
	    return XMLStringifier;
	
	  })();
	
	}).call(this);


/***/ },
/* 1077 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLWriterBase,
	    hasProp = {}.hasOwnProperty;
	
	  module.exports = XMLWriterBase = (function() {
	    function XMLWriterBase(options) {
	      var key, ref, ref1, ref2, ref3, ref4, ref5, ref6, value;
	      options || (options = {});
	      this.pretty = options.pretty || false;
	      this.allowEmpty = (ref = options.allowEmpty) != null ? ref : false;
	      if (this.pretty) {
	        this.indent = (ref1 = options.indent) != null ? ref1 : '  ';
	        this.newline = (ref2 = options.newline) != null ? ref2 : '\n';
	        this.offset = (ref3 = options.offset) != null ? ref3 : 0;
	        this.dontprettytextnodes = (ref4 = options.dontprettytextnodes) != null ? ref4 : 0;
	      } else {
	        this.indent = '';
	        this.newline = '';
	        this.offset = 0;
	        this.dontprettytextnodes = 0;
	      }
	      this.spacebeforeslash = (ref5 = options.spacebeforeslash) != null ? ref5 : '';
	      if (this.spacebeforeslash === true) {
	        this.spacebeforeslash = ' ';
	      }
	      this.newlinedefault = this.newline;
	      this.prettydefault = this.pretty;
	      ref6 = options.writer || {};
	      for (key in ref6) {
	        if (!hasProp.call(ref6, key)) continue;
	        value = ref6[key];
	        this[key] = value;
	      }
	    }
	
	    XMLWriterBase.prototype.set = function(options) {
	      var key, ref, value;
	      options || (options = {});
	      if ("pretty" in options) {
	        this.pretty = options.pretty;
	      }
	      if ("allowEmpty" in options) {
	        this.allowEmpty = options.allowEmpty;
	      }
	      if (this.pretty) {
	        this.indent = "indent" in options ? options.indent : '  ';
	        this.newline = "newline" in options ? options.newline : '\n';
	        this.offset = "offset" in options ? options.offset : 0;
	        this.dontprettytextnodes = "dontprettytextnodes" in options ? options.dontprettytextnodes : 0;
	      } else {
	        this.indent = '';
	        this.newline = '';
	        this.offset = 0;
	        this.dontprettytextnodes = 0;
	      }
	      this.spacebeforeslash = "spacebeforeslash" in options ? options.spacebeforeslash : '';
	      if (this.spacebeforeslash === true) {
	        this.spacebeforeslash = ' ';
	      }
	      this.newlinedefault = this.newline;
	      this.prettydefault = this.pretty;
	      ref = options.writer || {};
	      for (key in ref) {
	        if (!hasProp.call(ref, key)) continue;
	        value = ref[key];
	        this[key] = value;
	      }
	      return this;
	    };
	
	    XMLWriterBase.prototype.space = function(level) {
	      var indent;
	      if (this.pretty) {
	        indent = (level || 0) + this.offset + 1;
	        if (indent > 0) {
	          return new Array(indent).join(this.indent);
	        } else {
	          return '';
	        }
	      } else {
	        return '';
	      }
	    };
	
	    return XMLWriterBase;
	
	  })();
	
	}).call(this);


/***/ },
/* 1078 */
/***/ function(module, exports) {

	/**
	 * @module 1-liners/assign
	 *
	 * @description
	 *
	 * Returns a new object and assigns `assign` to `object`.
	 *
	 * @example
	 *
	 * 	const assign = require('1-liners/assign');
	 *
	 * 	const yedi = { id: 1, age: 100 };
	 *
	 * 	assign({ name: 'Yoda', age: 900 }, yedi);  // => { id: 1, name: 'Yoda', 900 }
	 *
	 */
	"use strict";
	
	exports.__esModule = true;
	// istanbul ignore next
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = function (assign, object) {
	  return _extends({}, object, assign);
	};
	
	module.exports = exports["default"];

/***/ },
/* 1079 */
/***/ function(module, exports) {

	/**
	 * @module 1-liners/isFunction
	 *
	 * @description
	 *
	 * Same as `typeof value === 'function'`.
	 *
	 * @example
	 *
	 * 	const isFunction = require('1-liners/isFunction');
	 *
	 * 	isFunction(function() {});        // => true
	 * 	isFunction(function named() {});  // => true
	 *
	 * 	isFunction('any other value');    // => false
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	exports['default'] = function (value) {
	  return typeof value === 'function';
	};
	
	module.exports = exports['default'];

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Dummy = __webpack_require__(837);
	var Native = __webpack_require__(142);
	
	module.exports = Class(Dummy, Native, {
	
		dummy_inject: Dummy.prototype.inject,
		dummy_injectBefore: Dummy.prototype.injectBefore,
		dummy_eject: Dummy.prototype.eject,
		native_inject: Native.prototype.inject,
		native_injectBefore: Native.prototype.injectBefore,
		native_eject: Native.prototype.eject,
	
		inject: function(container){
			this.dummy_inject(container);
			this.native_inject(container);
			return this;
		},
	
		injectBefore: function(sibling){
			this.dummy_injectBefore(sibling);
			this.native_injectBefore(sibling);
			return this;
		},
	
		eject: function(){
			this.dummy_eject();
			this.native_eject();
			return this;
		}
	
	});


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Container = __webpack_require__(71);
	var Node = __webpack_require__(143);
	
	module.exports = Class(Node, Container, {
	
		initialize: function(width, height){
			this.width = width;
			this.height = height;
		},
	
		localHitTest: function(x, y) {
			var node = this.lastChild;
			while (node){
				var hit = node.hitTest(x, y);
				if (hit) return hit;
				node = node.previousSibling;
			}
			return null;
		},
	
		renderLayerTo: function(context, xx, yx, xy, yy, x, y) {
			context.setTransform(xx, yx, xy, yy, x, y);
			context.save();
			// Need beginPath to fix Firefox bug. See 3354054.
			context.beginPath();
			context.rect(this.x, this.y, this.width, this.height);
			context.clip();
	
			var node = this.firstChild;
			while(node) {
				node.renderTo(context, xx, yx, xy, yy, x, y);
				node = node.nextSibling;
			}
			context.restore();
		}
	});


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Container = __webpack_require__(71);
	var Node = __webpack_require__(143);
	
	module.exports = Class(Node, Container, {
		
		initialize: function(width, height){
			this.width = width;
			this.height = height;
		},
	
		localHitTest: function(x, y){
			var node = this.lastChild;
			while (node){
				var hit = node.hitTest(x, y);
				if (hit) return hit;
				node = node.previousSibling;
			}
			return null;
		},
	
		renderLayerTo: function(context, xx, yx, xy, yy, x, y){
			if (this._invisible) return;
	
			x = xx * this.x + xy * this.y + x;
			y = yx * this.x + yy * this.y + y;
	
			var t = xx;
			xx = t * this.xx + xy * this.yx;
			xy = t * this.xy + xy * this.yy;
			t = yx;
			yx = t * this.xx + yy * this.yx;
			yy = t * this.xy + yy * this.yy;
	
			var node = this.firstChild;
			while (node){
				node.renderTo(context, xx, yx, xy, yy, x, y);
				node = node.nextSibling;
			}
		}
	
	});


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Base = __webpack_require__(838);
	var Path = __webpack_require__(839);
	
	module.exports = Class(Base, {
	
		base_initialize: Base.prototype.initialize,
	
		initialize: function(path, width, height){
			this.base_initialize();
			this.width = width;
			this.height = height;
			if (path != null) this.draw(path);
		},
	
		draw: function(path, width, height){
			if (!(path instanceof Path)) path = new Path(path);
			this.path = path;
			this._commands = path.toCommands();
			if (width != null) this.width = width;
			if (height != null) this.height = height;
			return this.invalidate();
		},
	
		localHitTest: function(x, y){
			if (!this._fill) return null;
			if (this.width == null || this.height == null){
				var context = Base._genericContext, commands = this._commands;
				if (!commands) return null;
				context.beginPath();
				for (var i = 0, l = commands.length; i < l; i++)
					commands[i](context);
				return context.isPointInPath(x, y) ? this : null;
			}
			if (x > 0 && y > 0 && x < this.width && y < this.height){
				return this;
			}
			return null;
		},
	
		renderShapeTo: function(context){
			if (this._invisible || !this._commands || (!this._fill && !this._stroke)) {
				return null;
			}
			context.transform(this.xx, this.yx, this.xy, this.yy, this.x, this.y);
			var commands = this._commands,
			    fill = this._fill,
			    stroke = this._stroke,
			    dash = this._strokeDash;
	
			context.beginPath();
	
			if (dash) {
				if (context.setLineDash) {
					context.setLineDash(dash);
				} else {
					// TODO: Remove when FF supports setLineDash.
					context.mozDash = dash;
				}
				// TODO: Create fallback to other browsers.
			} else {
				if (context.setLineDash) {
					context.setLineDash([]);
				} else {
					context.mozDash = null;
				}
			}
	
			for (var i = 0, l = commands.length; i < l; i++)
				commands[i](context);
	
			if (fill){
				var m = this._fillTransform;
				if (m){
					context.save(); // TODO: Optimize away this by restoring the transform before stroking
					context.transform(m.xx, m.yx, m.xy, m.yy, m.x, m.y);
					context.fillStyle = fill;
					context.fill();
					context.restore();
				} else {
					context.fillStyle = fill;
					context.fill();
				}
			}
			if (stroke){
				context.strokeStyle = stroke;
				context.lineWidth = this._strokeWidth;
				context.lineCap = this._strokeCap;
				context.lineJoin = this._strokeJoin;
				context.stroke();
			}
		}
	
	});


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Container = __webpack_require__(71);
	var Element = __webpack_require__(142);
	
	var fps = 1000 / 60, invalids = [], renderTimer, renderInvalids = function(){
		clearTimeout(renderTimer);
		renderTimer = null;
		var canvases = invalids;
		invalids = [];
		for (var i = 0, l = canvases.length; i < l; i++){
			var c = canvases[i];
			c._valid = true;
			c.render();
		}
	};
	
	var resolution = typeof window !== 'undefined' && window.devicePixelRatio || 1;
	
	var previousHit = null, previousHitSurface = null;
	
	var CanvasSurface = Class(Element, Container, {
	
		initialize: function(width, height, existingElement){
			var element = this.element = existingElement || document.createElement('canvas');
			var context = this.context = element.getContext('2d');
			this._valid = true;
			if (width != null && height != null) this.resize(width, height);
	
			element.addEventListener('mousemove', this, false);
			element.addEventListener('mouseout', this, false);
			element.addEventListener('mouseover', this, false);
			element.addEventListener('mouseup', this, false);
			element.addEventListener('mousedown', this, false);
			element.addEventListener('click', this, false);
		},
	
		handleEvent: function(event){
			if (event.clientX == null) return;
			var element = this.element,
				rect = element.getBoundingClientRect(),
				x = event.clientX - rect.left - element.clientLeft,
				y = event.clientY - rect.top - element.clientTop,
				hit = this.hitTest(x, y);
	
			if (hit !== previousHit){
				if (previousHit){
					previousHit.dispatch({
						type: 'mouseout',
						target: previousHit,
						relatedTarget: hit,
						sourceEvent: event
					});
				}
				if (hit){
					hit.dispatch({
						type: 'mouseover',
						target: hit,
						relatedTarget: previousHit,
						sourceEvent: event
					});
				}
				previousHit = hit;
				previousHitSurface = this;
				this.refreshCursor();
			}
	
			if (hit) hit.dispatch(event);
		},
	
		refreshCursor: function(){
			if (previousHitSurface !== this) return;
			var hit = previousHit, hitCursor = '', hitTooltip = '';
			while (hit){
				if (!hitCursor && hit._cursor){
					hitCursor = hit._cursor;
					if (hitTooltip) break;
				}
				if (!hitTooltip && hit._tooltip){
					hitTooltip = hit._tooltip;
					if (hitCursor) break;
				}
				hit = hit.parentNode;
			}
			// TODO: No way to set cursor/title on the surface
			this.element.style.cursor = hitCursor;
			this.element.title = hitTooltip;
		},
	
		resize: function(width, height){
			var element = this.element;
			element.setAttribute('width', width * resolution);
			element.setAttribute('height', height * resolution);
			element.style.width = width + 'px';
			element.style.height = height + 'px';
			this.width = width;
			this.height = height;
			return this;
		},
	
		invalidate: function(left, top, width, height){
			if (this._valid){
				this._valid = false;
				invalids.push(this);
				if (!renderTimer){
					if (window.mozRequestAnimationFrame){
						renderTimer = true;
						window.mozRequestAnimationFrame(renderInvalids);
					} else {
						renderTimer = setTimeout(renderInvalids, fps);
					}
				}
			}
			return this;
		},
	
		hitTest: function(x, y){
			if (x < 0 || y < 0 || x > this.width || y > this.height) return null;
			var node = this.lastChild;
			while (node){
				var hit = node.hitTest(x, y);
				if (hit) return hit;
				node = node.previousSibling;
			}
			return null;
		},
	
		render: function(){
			var node = this.firstChild, context = this.context;
			context.setTransform(resolution, 0, 0, resolution, 0, 0);
			context.clearRect(0, 0, this.width, this.height);
			while (node){
				node.renderTo(context, resolution, 0, 0, resolution, 0, 0);
				node = node.nextSibling;
			}
			this.refreshCursor();
		}
	
	});
	
	CanvasSurface.tagName = 'canvas';
	
	module.exports = CanvasSurface;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Base = __webpack_require__(838);
	
	var fontAnchors = { middle: 'center' };
	
	module.exports = Class(Base, {
	
		base_initialize: Base.prototype.initialize,
	
		initialize: function(text, font, alignment, path){
			this.base_initialize();
			this.draw.apply(this, arguments);
		},
	
		draw: function(text, font, alignment, path){
			var em;
			if (typeof font == 'string'){
				em = Number(/(\d+)/.exec(font)[0]);
			} else if (font){
				em = parseFloat(font.fontSize || font['font-size'] || '12');
				font = (font.fontStyle || font['font-style'] || '') + ' ' +
					(font.fontVariant || font['font-variant'] || '') + ' ' +
					(font.fontWeight || font['font-weight'] || '') + ' ' +
					em + 'px ' +
					(font.fontFamily || font['font-family'] || 'Arial');
			} else {
				font = this._font;
			}
	
			var lines = text && text.split(/\r?\n/);
			this._font = font;
			this._fontSize = em;
			this._text = lines;
			this._alignment = fontAnchors[alignment] || alignment || 'left';
	
			var context = Base._genericContext;
	
			context.font = this._font;
			context.textAlign = this._alignment;
			context.textBaseline = 'middle';
	
			lines = this._text;
			var l = lines.length, width = 0;
			for (var i = 0; i < l; i++){
				var w = context.measureText(lines[i]).width;
				if (w > width) width = w;
			}
			this.width = width;
			this.height = l ? l * 1.1 * em : 0;
			return this.invalidate();
		},
	
		// Interaction
	
		localHitTest: function(x, y){
			if (!this._fill) return null;
			if (x > 0 && y > 0 && x < this.width && y < this.height){
				return this;
			}
			return null;
		},
	
		// Rendering
	
		renderShapeTo: function(context){
			if (this._invisible || !this._text || (!this._fill && !this._stroke)) {
				return null;
			}
			context.transform(this.xx, this.yx, this.xy, this.yy, this.x, this.y);
			var fill = this._fill,
			    stroke = this._stroke,
			    text = this._text,
			    dash = this._strokeDash;
	
			context.font = this._font;
			context.textAlign = this._alignment;
			context.textBaseline = 'middle';
	
			var em = this._fontSize,
			    y = em / 2,
			    lineHeight = 1.1 * em,
			    lines = text,
			    l = lines.length;
	
			if (fill){
				context.fillStyle = fill;
				for (var i = 0; i < l; i++)
					context.fillText(lines[i], 0, y + i * lineHeight);
			}
			if (stroke){
				if (dash) {
					if (context.setLineDash) {
						context.setLineDash(dash);
					} else {
						// TODO: Remove when FF supports setLineDash.
						context.mozDash = dash;
					}
					// TODO: Create fallback to other browsers.
				} else {
					if (context.setLineDash) {
						context.setLineDash([]);
					} else {
						context.mozDash = null;
					}
				}
	
				context.strokeStyle = stroke;
				context.lineWidth = this._strokeWidth;
				context.lineCap = this._strokeCap;
				context.lineJoin = this._strokeJoin;
				for (i = 0; i < l; i++)
					context.strokeText(lines[i], 0, y + i * lineHeight);
			}
		}
	
	});


/***/ },
/* 1086 */
/***/ function(module, exports) {

	function warning(){
		throw new Error('You must require a mode before requiring anything else.');
	}
	
	exports.Surface = warning;
	exports.Path = warning;
	exports.Shape = warning;
	exports.Group = warning;
	exports.ClippingRectangle = warning;
	exports.Text = warning;
	
	exports.setCurrent = function(mode){
		for (var key in mode){
			exports[key] = mode[key];
		}
	};


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	var hasCanvas = function(){
	
	  var canvas = typeof window !== 'undefined' && window.document && window.document.createElement && document.createElement('canvas');
	  return canvas && !!canvas.getContext;
	
	};
	
	if (hasCanvas()) {
	  exports.Surface = __webpack_require__(1084);
	  exports.Path = __webpack_require__(839);
	  exports.Shape = __webpack_require__(1083);
	  exports.Group = __webpack_require__(1082);
	  exports.ClippingRectangle = __webpack_require__(1081);
	  exports.Text = __webpack_require__(1085);
	} else {
	  exports.Surface = __webpack_require__(842);
	  exports.Path = __webpack_require__(145);
	  exports.Shape = __webpack_require__(1089);
	  exports.Group = __webpack_require__(841);
	  exports.ClippingRectangle = __webpack_require__(1088);
	  exports.Text = __webpack_require__(1090);
	
	  var DOM = __webpack_require__(72);
	  if (typeof document !== 'undefined') DOM.init(document);
	}


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Transform = __webpack_require__(61);
	var Container = __webpack_require__(71);
	var Node = __webpack_require__(144);
	
	module.exports = Class(Node, Container, {
	
	  element_initialize: Node.prototype.initialize,
	
	  initialize: function(width, height){
	    this.element_initialize('clippingrectangle');
	    this.width = width;
	    this.height = height;
	  },
	
	  _transform: function(){
	    var element = this.element;
	    element.clip = true;
	    element.coordorigin = -this.x + ',' + (-1 * this.y);
	    element.coordsize = this.width + ',' + this.height;
	    // IE8 doesn't like clipBottom.  Don't ask me why.
	    // element.style.clipBottom = this.height + this.y;
	    element.style.clipLeft = this.x;
	    element.style.clipRight = this.width + this.x;
	    element.style.clipTop = this.y;
	    element.style.left = -this.x;
	    element.style.top = -this.y;
	    element.style.width = this.width + this.x;
	    element.style.height = this.height + this.y;
	    element.style.rotation = 0;
	
	    var container = this.parentNode;
	    this._activeTransform = container ? new Transform(container._activeTransform).transform(this) : this;
	    var node = this.firstChild;
	    while (node){
	      node._transform();
	      node = node.nextSibling;
	    }
	  }
	
	});


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Base = __webpack_require__(840);
	var Path = __webpack_require__(145);
	var DOM = __webpack_require__(72);
	
	var precision = 100;
	
	module.exports = Class(Base, {
	
		base_initialize: Base.prototype.initialize,
		
		initialize: function(path, width, height){
			this.base_initialize('shape');
	
			var p = this.pathElement = DOM.createElement('path');
			p.gradientshapeok = true;
			this.element.appendChild(p);
			
			this.width = width;
			this.height = height;
			
			if (path != null) this.draw(path);
		},
		
		// SVG to VML
		
		draw: function(path, width, height){
			
			if (!(path instanceof Path)) path = new Path(path);
			this._vml = path.toVML();
			//this._size = path.measure();
			
			if (width != null) this.width = width;
			if (height != null) this.height = height;
			
			if (!this._boxCoords) this._transform();
			this._redraw(this._prefix, this._suffix);
			
			return this;
		},
		
		// radial gradient workaround
	
		_redraw: function(prefix, suffix){
			var vml = this._vml || '';
	
			this._prefix = prefix;
			this._suffix = suffix
			if (prefix){
				vml = [
					prefix, vml, suffix,
					// Don't stroke the path with the extra ellipse, redraw the stroked path separately
					'ns e', vml, 'nf'
				].join(' ');
			}
	
			this.element.path = vml + 'e';
		},
	
		fillRadial: function(stops, focusX, focusY, radiusX, radiusY, centerX, centerY){
			var fill = this._createGradient('gradientradial', stops);
			if (focusX == null) focusX = (this.left || 0) + (this.width || 0) * 0.5;
			if (focusY == null) focusY = (this.top || 0) + (this.height || 0) * 0.5;
			if (radiusY == null) radiusY = radiusX || (this.height * 0.5) || 0;
			if (radiusX == null) radiusX = (this.width || 0) * 0.5;
			if (centerX == null) centerX = focusX;
			if (centerY == null) centerY = focusY;
	
			centerX += centerX - focusX;
			centerY += centerY - focusY;
			
			var cx = Math.round(centerX * precision),
				cy = Math.round(centerY * precision),
	
				rx = Math.round(radiusX * 2 * precision),
				ry = Math.round(radiusY * 2 * precision),
	
				arc = ['wa', cx - rx, cy - ry, cx + rx, cy + ry].join(' ');
	
			this._redraw(
				// Resolve rendering bug
				['m', cx, cy - ry, 'l', cx, cy - ry].join(' '),
				// Draw an ellipse around the path to force an elliptical gradient on any shape
				[
					'm', cx, cy - ry,
					arc, cx, cy - ry, cx, cy + ry, arc, cx, cy + ry, cx, cy - ry,
					arc, cx, cy - ry, cx, cy + ry, arc, cx, cy + ry, cx, cy - ry
				].join(' ')
			);
	
			this._boxCoords = { left: focusX - 2, top: focusY - 2, width: 4, height: 4 };
			
			fill.focusposition = '0.5,0.5';
			fill.focussize = '0 0';
			fill.focus = '50%';
			
			this._transform();
			
			return this;
		}
	
	});

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var Class = __webpack_require__(30);
	var Base = __webpack_require__(840);
	var Path = __webpack_require__(145);
	var Surface = __webpack_require__(842);
	var Group = __webpack_require__(841);
	var DOM = __webpack_require__(72);
	
	var fontAnchors = { start: 'left', middle: 'center', end: 'right' };
	
	module.exports = Class(Base, {
	
		base_initialize: Base.prototype.initialize,
	
		initialize: function(text, font, alignment, path){
			this.base_initialize('shape');
			
			var p = this.pathElement = DOM.createElement('path');
			p.textpathok = true;
			this.element.appendChild(p);
			
			p = this.textPathElement = DOM.createElement("textpath");
			p.on = true;
			p.style['v-text-align'] = 'left';
			this.element.appendChild(p);
			
			this.draw.apply(this, arguments);
		},
		
		draw: function(text, font, alignment, path){
			var element = this.element,
			    textPath = this.textPathElement,
			    style = textPath.style;
			
			textPath.string = text;
			
			if (font){
				if (typeof font == 'string'){
					style.font = font;
				} else {
					for (var key in font){
						var ckey = key.camelCase ? key.camelCase() : key;
						if (ckey == 'fontFamily') style[ckey] = "'" + font[key] + "'";
						// NOT UNIVERSALLY SUPPORTED OPTIONS
						// else if (ckey == 'kerning') style['v-text-kern'] = !!font[key];
						// else if (ckey == 'rotateGlyphs') style['v-rotate-letters'] = !!font[key];
						// else if (ckey == 'letterSpacing') style['v-text-spacing'] = Number(font[key]) + '';
						else style[ckey] = font[key];
					}
				}
			}
			
			if (alignment) style['v-text-align'] = fontAnchors[alignment] || alignment;
			
			if (path){
				this.currentPath = path = new Path(path);
				this.element.path = path.toVML();
			} else if (!this.currentPath){
				var i = -1, offsetRows = '\n';
				while ((i = text.indexOf('\n', i + 1)) > -1) offsetRows += '\n';
				textPath.string = offsetRows + textPath.string;
				this.element.path = 'm0,0l1,0';
			}
			
			// Measuring the bounding box is currently necessary for gradients etc.
			
			// Clone element because the element is dead once it has been in the DOM
			element = element.cloneNode(true);
			style = element.style;
			
			// Reset coordinates while measuring
			element.coordorigin = '0,0';
			element.coordsize = '10000,10000';
			style.left = '0px';
			style.top = '0px';
			style.width = '10000px';
			style.height = '10000px';
			style.rotation = 0;
			element.removeChild(element.firstChild); // Remove skew
			
			// Inject the clone into the document
			
			var canvas = new Surface(1, 1),
			    group = new Group(), // Wrapping it in a group seems to alleviate some client rect weirdness
			    body = element.ownerDocument.body;
			
			canvas.inject(body);
			group.element.appendChild(element);
			group.inject(canvas);
			
			var ebb = element.getBoundingClientRect(),
			    cbb = canvas.toElement().getBoundingClientRect();
			
			canvas.eject();
			
			this.left = ebb.left - cbb.left;
			this.top = ebb.top - cbb.top;
			this.width = ebb.right - ebb.left;
			this.height = ebb.bottom - ebb.top;
			this.right = ebb.right - cbb.left;
			this.bottom = ebb.bottom - cbb.top;
			
			this._transform();
	
			//this._size = { left: this.left, top: this.top, width: this.width, height: this.height};
			return this;
		}
	
	});


/***/ },
/* 1091 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ReUpText = __webpack_require__(8);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Platform = ReactNative.Platform,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	function removeSpaces(str) {
	  return str.replace(/\s+/g, '');
	}
	
	var AbsorbGiftCard = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      message: "",
	      numMessageLines: 1,
	      sendButton: "Send", //TODO:localize
	      emailError: false,
	      giftCardNumber: "",
	      shouldShowButton: false,
	      buttonOpacity: new Animated.Value(0),
	      qrCodeOpacity: new Animated.Value(0),
	      shouldShowCamera: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  _camera: null,
	  _canCapture: false,
	  cameraDidLoad: function cameraDidLoad(camera) {
	    if (!camera) return;
	    this._canCapture = true;
	    this._camera = camera;
	  },
	
	  onBarCodeRead: function onBarCodeRead(evt) {
	    //console.log(evt)
	    // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
	    this.didScanData(evt.data);
	  },
	
	  _PIN: "",
	  showPinScreen: function showPinScreen() {
	    this._PIN = "";
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var okButton = locManager.localizedStringForKey("ENTER_PIN_CONFIRMATION");
	    var title = locManager.localizedStringForKey("ENTER_PIN_STATEMENT");
	    var body = locManager.localizedStringForKey("ENTER_PIN_INSTRUCTIONS");;
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        ReUpText,
	        { appManager: typeof appManager === 'undefined' ? null : appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	        title
	      ),
	      React.createElement(
	        ReUpText,
	        { appManager: typeof appManager === 'undefined' ? null : appManager, style: { marginTop: 10, textAlign: 'left' } },
	        body
	      ),
	      React.createElement(ReUpField, {
	        appManager: appManager,
	        onChangeText: function onChangeText(text) {
	          thisThing._PIN = text;
	        },
	        placeholder: "PIN",
	        maxLength: 5,
	        keyboardType: "phone-pad",
	        style: [styles.textField] }),
	      React.createElement(ReUpButton, { style: [styles.button, { marginTop: 20 }],
	        appManager: appManager,
	        text: okButton,
	        onPress: function onPress() {
	          // removing check in case there is no pin
	          // if( thisThing._PIN.length >= 5 )
	          {
	            thisThing.submitPressed();
	          }
	        }
	      })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitPressed: function submitPressed() {
	    var thisThing = this;
	    var isUsingUserID = this._userID != null && this._userID.length > 0;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    appActions.hideAlert();
	    if (isUsingUserID) {
	      appActions.setSpinnerShown(true, locManager.localizedStringForKey("FETCHING_HUD"));
	      NetworkManager.getGCInfoByUserID(this.props.appManager, this._userID, this._PIN, function (data) {
	        appActions.setSpinnerShown(false);
	        var points = locManager.localizedPoints(data.Points);
	        var credit = locManager.localizedDollars(data.Credit);
	        var msg = locManager.localizedStringForKeyAndParams("ABSORB_GIFT_CARD_ALERT_BODY", [credit, points]);
	        appActions.showLocalizedAlert(locManager.localizedStringForKey("ABSORB_GIFT_CARD_ALERT_TITLE"), msg, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }, function () {
	          appActions.hideAlert();
	          thisThing.submitAbsorb();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	      });
	    } else {
	      appActions.setSpinnerShown(true, "Fetching...");
	      NetworkManager.getGCInfoByGCNum(this.props.appManager, this._number, this._PIN, function (data) {
	        appActions.setSpinnerShown(false);
	        var points = locManager.localizedPoints(data.Points);
	        var credit = locManager.localizedDollars(data.Credit);
	        var msg = locManager.localizedStringForKeyAndParams("ABSORB_GIFT_CARD_ALERT_BODY", [credit, points]);
	        appActions.showLocalizedAlert(locManager.localizedStringForKey("ABSORB_GIFT_CARD_ALERT_TITLE"), msg, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }, function () {
	          appActions.hideAlert();
	          thisThing.submitAbsorb();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	      });
	    }
	  },
	
	  submitAbsorb: function submitAbsorb() {
	    var isUsingUserID = this._userID != null && this._userID.length > 0;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    appActions.hideAlert();
	    if (isUsingUserID) {
	      appActions.setSpinnerShown(true, locManager.localizedStringForKey("MERGING_HUD"));
	      NetworkManager.absorbGiftCardByUserID(this.props.appManager, this._userID, this._PIN, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_SUCCESS_ALERT_TITLE", "MERGE_GC_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          appActions.requestPop();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	      });
	    } else {
	      appActions.setSpinnerShown(true, locManager.localizedStringForKey("MERGING_HUD"));
	      NetworkManager.absorbGiftCardByNumber(this.props.appManager, this._number, this._PIN, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_SUCCESS_ALERT_TITLE", "MERGE_GC_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          appActions.requestPop();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("MERGE_GC_FAIL_ALERT_TITLE", "MERGE_GC_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	      });
	    }
	  },
	
	  send: function send(amount, email, message) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	    appActions.setSpinnerShown(true, processingHUD);
	    NetworkManager.sendCredit(appManager, amount, email, message, function (data) {
	      appActions.setSpinnerShown(false);
	      var user = appManager.currentUser();
	      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) - amount;
	      var sendSuccess = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_TITLE");
	      var creditSent = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_BODY");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appManager.setCurrentUser(user, function () {
	        appActions.showAlert(sendSuccess, creditSent, [okayText], [function () {
	          appActions.requestPop(false);appActions.hideAlert();
	        }]);
	      });
	    }, function (data) {
	      var sendFailedTitle = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_TITLE");
	      var sendFailedBody = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_BODY");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appActions.setSpinnerShown(false);
	      appActions.showAlert(sendFailedTitle, sendFailedBody, [okayText]);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  _qrCodePulsing: false,
	  setQRCodePulsing: function setQRCodePulsing(enable) {
	    if (enable != this._qrCodePulsing) {
	      if (enable) {
	        this.fadeInQRCode();
	      }
	      this._qrCodePulsing = enable;
	    }
	  },
	
	  fadeInQRCode: function fadeInQRCode() {
	    var thisThing = this;
	    Animated.timing(thisThing.state.qrCodeOpacity, { toValue: 1,
	      duration: 700 }).start(function () {
	      if (thisThing._qrCodePulsing) thisThing.fadeOutQRCode();
	    });
	  },
	
	  fadeOutQRCode: function fadeOutQRCode() {
	    var thisThing = this;
	    Animated.timing(thisThing.state.qrCodeOpacity, { toValue: 0,
	      duration: 700 }).start(function () {
	      if (thisThing._qrCodePulsing) thisThing.fadeInQRCode();
	    });
	  },
	
	  _userID: null,
	  didScanData: function didScanData(data) {
	    var jsonString = atob(data);
	    var obj = JSON.parse(jsonString);
	    if (obj) {
	      if (obj.T == "GC" && typeof obj.U !== 'undefined') // is gift card
	        {
	          this._userID = obj.U;
	          this.showPinScreen();
	          return;
	        }
	    }
	    this.showScanError();
	  },
	
	  showScanError: function showScanError() {
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    appActions.showLocalizedAlert("INVALIDQR_FAIL_ALERT_TITLE", "INVALIDQR_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	      appActions.hideAlert();
	      thisThing.scanCard();
	    }], function () {});
	  },
	
	  tryToScanCard: function tryToScanCard() {
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    if (Platform.OS === 'ios') {
	      var thisThing = this;
	      var appActions = this.props.appActions;
	      _reactNativeCameraWrapper2.default.checkVideoAuthorizationStatus().then(function (hasPermission) {
	        if (hasPermission) {
	          thisThing.scanCard();
	        } else {
	          appActions.showAlert(locManager.localizedStringForKey("CAMERA_PERMISSION_TITLE"), locManager.localizedStringForKey("CAMERA_PERMISSION_BODY"), [locManager.localizedStringForKey("OK_ALERT_BUTTON")], [function () {
	            appActions.hideAlert();
	          }]);
	        }
	      });
	    } else {
	      this.scanCard();
	    }
	  },
	
	  scanCard: function scanCard() {
	    var cameraDim = Math.min(this.state.layout.width, this.state.layout.height) - 20;
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	
	    this.setQRCodePulsing(true);
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        _reactNativeCameraWrapper2.default,
	        { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'center', padding: 10 },
	          captureAudio: false,
	          type: _reactNativeCameraWrapper2.default.constants.Type.back,
	          aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill,
	          onBarCodeRead: function onBarCodeRead(evt) {
	            // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
	            thisThing.didScanData(evt.data);
	          } },
	        React.createElement(
	          Animated.View,
	          { style: { opacity: thisThing.state.qrCodeOpacity } },
	          React.createElement(_ReUpIcon2.default, { name: "qrcode", size: 200, color: 'black', style: { backgroundColor: 'transparent', justifyContent: 'center', alignSelf: 'center', padding: 0, paddingBottom: 0, lineHeight: 216 } })
	        )
	      )
	    );
	
	    // <ScrollView bounces={true} style={{margin:0,padding:0}}
	    //   keyboardShouldPersistTaps={true}
	    //   keyboardDismissMode={"interactive"}>
	    //   <Camera ref={this.cameraDidLoad} style={{alignSelf:'center', height:cameraDim,width:cameraDim, justifyContent:'center', padding:10}}
	    //     captureAudio={false}
	    //     captureTarget={Camera.constants.CaptureTarget.disk}
	    //     type={Camera.constants.Type.back}
	    //     aspect={Camera.constants.Aspect.Fill}>
	    //       <Animated.View style={{opacity:thisThing.state.qrCodeOpacity}}><Icon name={"qrcode"} size={200} color={'black'} style={{backgroundColor:'transparent',justifyContent:'center', alignSelf:'center', padding:0, paddingBottom:0, lineHeight:216}}/></Animated.View>
	    //   </Camera>
	    // </ScrollView>
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {
	      thisThing.setQRCodePulsing(false);
	    });
	  },
	
	  _number: "",
	  numberChanged: function numberChanged(text) {
	    var didAddText = text.length > this.state.giftCardNumber.length;
	    var noSpaces = removeSpaces(text);
	    this._number = noSpaces;
	    var moddedText = noSpaces.substring(0, 5);
	    if (noSpaces.length > 5) {
	      moddedText += " " + noSpaces.substring(5, 10);
	    }
	    if (noSpaces.length > 10) {
	      moddedText += " " + noSpaces.substring(10, 15);
	    }
	    var shouldShowButton = moddedText.length >= 1;
	    if (shouldShowButton != this.state.shouldShowButton) {
	      var thisThing = this;
	      Animated.timing(thisThing.state.buttonOpacity, { toValue: shouldShowButton ? 1 : 0,
	        duration: 250 }).start(function () {});
	    }
	    this.setState({ giftCardNumber: moddedText, shouldShowButton: shouldShowButton });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var orLabel = locManager.localizedStringForKey("OR_LABEL");
	    var user = this.state.user;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var cardNumberLabel = "Gift Card Number"; //TODO:localize
	    var pinLabel = "PIN:"; //TODO:localize
	    var creditsPointLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
	    var absorbCardButton = "Enter PIN"; //TODO:localize
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: typeof appManager === 'undefined' ? null : appManager, numberOfLines: 3, style: [styles.instructionText, { color: instructionTitleColor, width: this.state.layout.width - 80 }] },
	              creditsPointLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: appActions
	          })
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        React.createElement(
	          View,
	          { style: { paddingTop: 20 } },
	          React.createElement(ReUpIconButton, { iconName: "camera", type: 0,
	            appManager: appManager,
	            onPress: function onPress() {
	              thisThing.tryToScanCard();
	            }
	          }),
	          React.createElement(ShadowView, { layout: this.state.layout, text: orLabel, appManager: appManager }),
	          React.createElement(ReUpField, _defineProperty({
	            appManager: appManager,
	            key: 'number', ref: 'number',
	            autoCapitalize: 'none',
	            value: this.state.giftCardNumber,
	            onChangeText: this.numberChanged,
	            placeholder: cardNumberLabel,
	            style: [styles.textField, { margin: 10 }],
	            maxLength: 17
	          }, 'autoCapitalize', "characters")),
	          React.createElement(
	            Animated.View,
	            { style: { opacity: this.state.buttonOpacity } },
	            React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton, { marginTop: 20 }], text: absorbCardButton,
	              onPress: function onPress() {
	                if (thisThing.state.shouldShowButton) {
	                  thisThing._userID = null;_this.showPinScreen();
	                }
	              } })
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    margin: 10,
	    alignItems: 'center',
	    marginLeft: 20,
	    marginRight: 20,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    padding: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    padding: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    flex: 1,
	    width: -1,
	    height: 50,
	    marginTop: 10
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    margin: 8,
	    marginTop: 0
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginRight: 10, marginLeft: 10, marginBottom: 10
	  },
	
	  segmentContainer: {
	    height: 50,
	    padding: 4,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	AbsorbGiftCard.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn || typeof ModelConstants === 'undefined') return [];else {
	    var user = appManager.currentUser();
	    var credit = user[ModelConstants.Credits];
	    if (credit < 20) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("AbsorbGiftCard");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	AbsorbGiftCard.dataDependencies = ["Users"];
	
	module.exports = AbsorbGiftCard;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var PriceChooserView = __webpack_require__(150);
	var PaymentMethodChooserView = __webpack_require__(94);
	var AnalyticsManager = __webpack_require__(50);
	var ProgressOverlay = __webpack_require__(52);
	
	// var CardIO, { CardIOConstants } = require('react-native-card.io')
	// import CardIO, { CardIOConstants } from 'react-native-card.io';
	var CardIO = __webpack_require__(845);
	
	var MAX_CREDIT = parseFloat(10);
	var lastSelectedAmount = null;
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	
	var FeedCard = __webpack_require__(41);
	
	var StyleSheet = ReactNative.StyleSheet,
	    AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    Animated = ReactNative.Animated;
	
	
	function removeSpaces(str) {
	  return str.replace(/\s+/g, '');
	}
	
	var AddCredit = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var appManager = this.props.appManager;
	    var user = appManager.currentUser();
	
	    return {
	      layout: this.props.initialLayout,
	      user: user,
	      purchaseButtonTitle: appManager.getLocalizationManager().localizedStringForKey("PURCHASE_BUTTON"),
	      refreshDisabled: false,
	      spinnerText: appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD"),
	      shouldShowSpinner: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	
	    var appManager = this.props.appManager;
	    this.props.appManager.getDataType("Transactions", function (transactions) {
	      var sortedTransactions = transactions.sort(function (a, b) {
	        return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
	      });
	      var initialValue = null;
	      for (var i = 0; i < sortedTransactions.length; i++) {
	        var transaction = sortedTransactions[i];
	        if (typeof transaction.Credit !== 'undefined' && transaction.Credit != null && parseInt(transaction.Credit) > 0) {
	          initialValue = parseInt(transaction.Credit);
	          break;
	        }
	      }
	      if (initialValue != null) {
	        setTimeout(function () {
	          if (typeof thisThing.refs.PriceChooserView !== 'undefined') thisThing.refs.PriceChooserView.setAmount(initialValue);
	        }, 10);
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (typeof this.refs.PriceChooserView !== 'undefined') lastSelectedAmount = this.refs.PriceChooserView.getAmount();
	  },
	
	  amount: function amount() {
	    return this.refs.PriceChooserView.getAmount();
	  },
	
	  amountText: function amountText() {
	    return this.refs.PriceChooserView.getAmountText();
	  },
	
	  submit: function submit() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var transactionConfirmTitle = locManager.localizedStringForKey("ADDCREDIT_CONFIRM_ALERT_TITLE");
	    var transactionConfirmBody = locManager.localizedStringForKeyAndParams("ADDCREDIT_CONFIRM_ALERT_BODY", [this.amountText()]);
	    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
	    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");
	
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	
	    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
	    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
	    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
	    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    if (useInterstitialFlow) {
	      thisThing.setState({ shouldShowSpinner: true });
	      this.makePayment();
	    } else {
	      appActions.showAlert(transactionConfirmTitle, transactionConfirmBody, [noText, yesText], [appActions.hideAlert, function () {
	        appActions.hideAlert();
	        appActions.setSpinnerShown(true, processingHUD);
	        thisThing.makePayment();
	      }, appActions.hideAlert], function () {});
	    }
	  },
	
	  makePayment: function makePayment() {
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var paymentMethodChooser = thisThing.refs.paymentMethod;
	    var paymentMethod = paymentMethodChooser.getPrimaryPaymentMethod();
	
	    var useCreditFeature = thisThing.props.appManager.getFeatureForName("UseCredit");
	    var shouldShowUseCredit = typeof useCreditFeature !== 'undefined' && useCreditFeature != null && !useInterstitialFlow && !thisThing.props.appActions._navigator.featureIsInStack(useCreditFeature);
	
	    NetworkManager.submitPayment(appManager, thisThing.amount(), paymentMethod, function (data) {
	      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), true);
	      if (!useInterstitialFlow) {
	        appActions.setSpinnerShown(false);
	      } else {
	        thisThing.setState({ shouldShowSpinner: false });
	      }
	
	      var user = appManager.currentUser();
	      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) + parseFloat(thisThing.amount());
	      appManager.setCurrentUser(user, function () {
	        var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
	        var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
	        var useCreditBody = locManager.localizedStringForKey("PAY_NOW_ALERT_BODY", 'Would you like to pay now?');
	        var yesText = appManager.getFeatureForName("UseCredit").data.title;
	        var noText = locManager.localizedStringForKey("LATER_ALERT_BUTTON", "Later");
	        var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	        if (useInterstitialFlow) {
	          thisThing.props.extras.addCreditDidFinish(function (appActions) {
	            if (typeof useCreditFeature !== 'undefined') {
	              appActions.showAlert(paymentSuccessTitle, useCreditBody, [noText, yesText], [function () {
	                appActions.hideAlert();
	              }, function () {
	                appActions.requestFeatureName('UseCredit');
	                appActions.hideAlert();
	              }]);
	            }
	          });
	        } else if (shouldShowUseCredit) {
	          appActions.showAlert(paymentSuccessTitle, useCreditBody, [noText, yesText], [function () {
	            appActions.hideAlert();
	          }, function () {
	            appActions.requestFeatureName('UseCredit');
	            appActions.hideAlert();
	          }]);
	        } else {
	          appActions.showAlert(paymentSuccessTitle, paymentSuccessBody, [okayText], [function () {
	            appActions.requestPop(false);appActions.hideAlert();
	          }]);
	        }
	      });
	    }, function (data) {
	      var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
	      var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
	      var useInterstitialFlow = typeof thisThing.props.extras !== 'undefined' && thisThing.props.extras.useInterstitialFlow;
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), false);
	      if (!useInterstitialFlow) {
	        appActions.setSpinnerShown(false);
	        appActions.showAlert(paymentFailTitle, paymentFailBody, [okayText]);
	      } else {
	        thisThing.setState({ shouldShowSpinner: false });
	        thisThing.props.extras.addCreditDidFinish(function (appActions) {
	          appActions.showAlert(paymentFailTitle, paymentFailBody, [okayText]);
	        });
	      }
	    }, function (data) {
	      AnalyticsManager.logPurchaseEvent(appManager, thisThing.amount(), false);
	      if (!useInterstitialFlow) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      } else {
	        thisThing.setState({ shouldShowSpinner: false });
	        thisThing.props.extras.showNetworkErrorAlert();
	      }
	    });
	  },
	
	  pullToRefreshView: function pullToRefreshView() {
	    return this.refs.ptr;
	  },
	
	  update: function update() {},
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    this.props.appManager.getCurrentUser(function (user) {
	      thisThing.setState({ user: user });
	    });
	  },
	
	  didStartChoosingPrice: function didStartChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(false);
	  },
	
	  didEndChoosingPrice: function didEndChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(true);
	  },
	
	  render: function render() {
	    var addCredit = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var credit = user != null ? parseFloat(user[ModelConstants.Credits]) : '';
	    var maxCredit = MAX_CREDIT;
	    var creditRatio = parseFloat(credit) / parseFloat(maxCredit);
	    var flexPositive = Math.round(100 * Math.min(creditRatio, 1));
	    var useMinWidth = flexPositive > 0;
	    var flexNegative = 100 - flexPositive;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var howMuchStatement = locManager.localizedStringForKey("HOW_MUCH_LABEL");
	    var purchaseButtonTitle = this.state.purchaseButtonTitle;
	
	    var paymentInfo = appManager.getPaymentInfo();
	    var hasPrimaryPaymentMethod = false;
	    for (var i = 0; i < paymentInfo.length; i++) {
	      if (paymentInfo[i].isPrimary) {
	        hasPrimaryPaymentMethod = true;
	        break;
	      }
	    }
	
	    var priceChooserProps = {};
	    if (lastSelectedAmount != null) {
	      priceChooserProps.initialAmount = lastSelectedAmount;
	    }
	    if (typeof this.props.featureData.choiceValue !== 'undefined') {
	      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
	    }
	    if (typeof this.props.featureData.choiceIndex !== 'undefined') {
	      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, refreshDisabled: this.state.refreshDisabled },
	        !useInterstitialFlow ? React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	              creditsLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: appActions
	          })
	        ) : null,
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        hasPrimaryPaymentMethod ? React.createElement(
	          View,
	          null,
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	            howMuchStatement
	          ),
	          React.createElement(PriceChooserView, Object.assign({ ref: "PriceChooserView", style: styles.choicesContainer, appManager: addCredit.props.appManager,
	            didStartChoosingPrice: addCredit.didStartChoosingPrice, didEndChoosingPrice: addCredit.didEndChoosingPrice,
	            initialLayout: addCredit.state.layout, didChangeValueAndText: function didChangeValueAndText(v, t) {
	              addCredit.setState({ purchaseButtonTitle: locManager.localizedStringForKey("PURCHASE_BUTTON") + " - " + t });
	            } }, priceChooserProps))
	        ) : React.createElement(
	          ReUpText,
	          { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	          locManager.localizedStringForKey("TO_ADD_CREDIT_LABEL")
	        ),
	        React.createElement(PaymentMethodChooserView, { ref: "paymentMethod", enableEdit: !useInterstitialFlow, style: [styles.paymentMethodContainer, { marginBottom: 10 }], appManager: appManager, appActions: appActions,
	          initialLayout: this.state.layout, paymentInfo: paymentInfo }),
	        hasPrimaryPaymentMethod ? React.createElement(ReUpButton, { style: [styles.doneButton, { margin: 10 }], appManager: appManager,
	          text: purchaseButtonTitle,
	          onPress: function onPress() {
	            addCredit.submit();
	          }
	        }) : null
	      ),
	      this.state.shouldShowSpinner ? React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner,
	        spinnerText: this.state.spinnerText, spinnerBody: this.state.spinnerBody,
	        layout: this.state.layout, appManager: appManager }) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 10,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    margin: 10,
	    alignItems: 'center',
	    marginLeft: 20,
	    marginRight: 20,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    padding: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    padding: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    backgroundColor: 'transparent'
	  },
	
	  paymentMethodContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 60,
	    flex: 1,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    flex: 1,
	    width: -1,
	    height: 50,
	    marginTop: 10
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    margin: 8,
	    marginTop: 0
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1
	  },
	
	  segmentContainer: {
	    height: 50,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	AddCredit.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var credit = parseFloat(user[ModelConstants.Credits]);
	    if (credit > MAX_CREDIT) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("AddCredit");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	AddCredit.dataDependencies = ["Users", "Transactions"];
	
	module.exports = AddCredit;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var PaymentMethodChooserView = __webpack_require__(94);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	
	var FeedCard = __webpack_require__(41);
	
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    Animated = ReactNative.Animated;
	
	
	var AddPass = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var appManager = this.props.appManager;
	    var user = appManager.currentUser();
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    return {
	      layout: this.props.initialLayout,
	      user: user,
	      purchaseButtonTitle: "Purchase - " + locManager.localizedDollars(this.props.extras.pass.AmountCharged),
	      refreshDisabled: false
	    };
	  },
	
	  submit: function submit() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var transactionConfirmTitle = locManager.localizedStringForKey("ADDPASSS_CONFIRM_ALERT_TITLE");
	    var transactionConfirmBody = locManager.localizedStringForKey("ADDPASS_CONFIRM_ALERT_BODY");
	    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
	    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");
	
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	
	    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
	    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
	    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
	    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
	    appActions.showAlert(transactionConfirmTitle, transactionConfirmBody, [noText, yesText], [appActions.hideAlert, function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, processingHUD);
	      var paymentMethodChooser = thisThing.refs.paymentMethod;
	      var paymentMethod = paymentMethodChooser.getPrimaryPaymentMethod();
	      NetworkManager.submitPassPayment(appManager, thisThing.props.extras.pass.PassID, paymentMethod, function (data) {
	        appActions.setSpinnerShown(false);
	        var user = appManager.currentUser();
	        appManager.setCurrentUser(user, function () {
	          appActions.showAlert(paymentSuccessTitle, paymentSuccessBody, [okayText], [function () {
	            appActions.requestPop(false);thisThing.props.extras.passes.refs.ptr.doOnlineUpdate();appActions.hideAlert();
	          }]);
	        });
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showAlert(paymentFailTitle, paymentFailBody, [okayText]);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }, appActions.hideAlert], function () {});
	  },
	
	  pullToRefreshView: function pullToRefreshView() {
	    return this.refs.ptr;
	  },
	
	  update: function update() {},
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    this.props.appManager.getCurrentUser(function (user) {
	      thisThing.setState({ user: user });
	    });
	  },
	
	  render: function render() {
	    var AddPass = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var credit = parseFloat(user[ModelConstants.Credits]);
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var purchaseButtonTitle = this.state.purchaseButtonTitle;
	
	    var paymentInfo = appManager.getPaymentInfo();
	    var hasPrimaryPaymentMethod = false;
	    for (var i = 0; i < paymentInfo.length; i++) {
	      if (paymentInfo[i].isPrimary) {
	        hasPrimaryPaymentMethod = true;
	        break;
	      }
	    }
	
	    var instructions = this.props.extras.pass.RedeemQuantity + " " + this.props.extras.pass.Name;
	    var totalPriceString = locManager.localizedStringForKey("TOTAL_LABEL") + "  " + locManager.localizedDollars(parseFloat(this.props.extras.pass.AmountCharged));
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, refreshDisabled: this.state.refreshDisabled },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	              instructions
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: appActions
	          })
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: { color: generalTitleColor, margin: 10, textAlign: 'center' } },
	          this.props.extras.pass.Description
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { color: generalTitleColor, margin: 4, textAlign: 'center' } },
	          totalPriceString
	        ),
	        React.createElement(PaymentMethodChooserView, { ref: "paymentMethod", style: [styles.paymentMethodContainer, { marginBottom: 10 }], appManager: appManager, appActions: appActions,
	          initialLayout: this.state.layout, paymentInfo: paymentInfo }),
	        hasPrimaryPaymentMethod ? React.createElement(ReUpButton, { style: [styles.doneButton, { margin: 10 }], appManager: appManager,
	          text: purchaseButtonTitle,
	          onPress: function onPress() {
	            AddPass.submit();
	          }
	        }) : null
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'center'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  paymentMethodContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 60,
	    flex: 1,
	    alignItems: 'center',
	    justifyContent: 'center'
	  }
	});
	
	AddPass.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var credit = parseFloat(user[ModelConstants.Credits]);
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("AddPass");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	AddPass.dataDependencies = ["Users", "Passes"];
	
	module.exports = AddPass;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	var _reactNativeParallaxScrollViewWrapper = __webpack_require__(97);
	
	var _reactNativeParallaxScrollViewWrapper2 = _interopRequireDefault(_reactNativeParallaxScrollViewWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppActions = __webpack_require__(63);
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var FadingView = __webpack_require__(51);
	var FeedPlusView = __webpack_require__(111);
	var FeedPlusSideView = __webpack_require__(110);
	var Animated = __webpack_require__(9);
	var ReUpTabBar = __webpack_require__(74);
	var AddToWalletButton = __webpack_require__(62);
	var ArcMeter = __webpack_require__(58);
	var PointsTicker = __webpack_require__(149);
	var createReactClass = __webpack_require__(5);
	var Icon = __webpack_require__(13);
	var FEED_HEADER_HEIGHT = 80;
	
	var Menu = __webpack_require__(75);
	var FeedCard = __webpack_require__(41);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpCountdown = __webpack_require__(73);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MapView = __webpack_require__(78);
	var ReUpButton = __webpack_require__(12);
	var Meter = __webpack_require__(91);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton,
	    MKTextField = MK.MKTextField;
	
	
	var dismissKeyboard = __webpack_require__(105);
	
	var View = ReactNative.View,
	    WebView = ReactNative.WebView,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Dimensions = ReactNative.Dimensions,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	
	  return result;
	}
	
	var BasicHome = createReactClass({
	  displayName: 'BasicHome',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    var maxWidth = 400;
	    var maxHeight = 700;
	    var width = Math.min(this.props.initialLayout.width - 24, maxWidth);
	    var height = Math.min(this.props.initialLayout.height - 24, maxHeight);
	    // var ratio = parseFloat(750 / 1334);
	    // width = Math.min(width, height*ratio);
	    // height = Math.min(height, width/ratio);
	    var horizontalMargin = (this.props.initialLayout.width - width) / 2;
	    var verticalMargin = (this.props.initialLayout.height - height) / 2;
	    return {
	      horizontalMargin: horizontalMargin,
	      verticalMargin: verticalMargin,
	      rotationFront: new Animated.Value(90),
	      rotationBack: new Animated.Value(90),
	
	      isShowingFront: true,
	
	      isShowingHome: false,
	      isShowingError: false,
	
	      userName: null,
	      rewards: [],
	      points: 0,
	
	      isInError: false,
	      errorMessage: ""
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var userID = findGetParameter("userid");
	    var hash = findGetParameter("hash");
	
	    if (userID != null && hash != null) {
	      if (appManager.isLoggedIn()) // appmanager initialize managed to get the user
	        {
	          var user = appManager.currentUser();
	          thisThing.setState({ points: user.Points });
	          NetworkManager.update(appManager, ["Rewards", "Campaigns"], function (data) {
	            thisThing.setState({ isShowingHome: true, rewards: data.Rewards, points: user.Points });
	
	            var checkInCampaign = null;
	            for (var i = 0; i < data.Campaigns.length; i++) {
	              var campaign = data.Campaigns[i];
	              if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	            }
	            thisThing.setState({
	              dollarsPerPoint: checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint
	            });
	
	            thisThing.showFront();
	          }, function () {
	            thisThing.setState({ isShowingHome: true, rewards: [] });
	            thisThing.showFront();
	          }, function () {
	            thisThing.setState({ isShowingHome: true, rewards: [] });
	            thisThing.showFront();
	          });
	        } else // should never happen, but hey, you never know
	        {
	          NetworkManager.getUser(appManager, userID, hash, function (urlUser) {
	            setTimeout(function () {
	              thisThing.setState({ points: urlUser.Points });
	            }, 500);
	            urlUser[ModelConstants.Password] = hash;
	            appManager.setCurrentUser(urlUser, function () {});
	
	            NetworkManager.update(appManager, ["Rewards", "Campaigns"], function (data) {
	              thisThing.setState({ isShowingHome: true, rewards: data.Rewards });
	
	              var checkInCampaign = null;
	              for (var i = 0; i < data.Campaigns.length; i++) {
	                var campaign = data.Campaigns[i];
	                if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	              }
	              thisThing.setState({
	                dollarsPerPoint: checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint
	              });
	
	              thisThing.showFront();
	            }, function () {
	              thisThing.setState({ isShowingHome: true, rewards: [] });
	              thisThing.showFront();
	            }, function () {
	              thisThing.setState({ isShowingHome: true, rewards: [] });
	              thisThing.showFront();
	            });
	          }, function () {
	            thisThing.setState({ isShowingError: true, errorTitle: locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE"), errorBody: locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY") });
	            thisThing.showFront();
	          }, function () {
	            thisThing.setState({ isShowingError: true, errorTitle: locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE"), errorBody: locManager.localizedStringForKey("NO_CONNECTION_STATEMENT") });
	            thisThing.showFront();
	          });
	        }
	    } else if (appManager._isDemo) {
	      NetworkManager.login(appManager, 'kjregan10@gmail.com', 'asdfwxyzabcd', function (urlUser) {
	        setTimeout(function () {
	          thisThing.setState({ points: urlUser.Points });
	        }, 500);
	        appManager.setCurrentUser(urlUser, function () {});
	
	        NetworkManager.update(appManager, ["Rewards", "Campaigns"], function (data) {
	          thisThing.setState({ isShowingHome: true, rewards: data.Rewards });
	
	          var checkInCampaign = null;
	          for (var i = 0; i < data.Campaigns.length; i++) {
	            var campaign = data.Campaigns[i];
	            if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	          }
	          thisThing.setState({
	            dollarsPerPoint: checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint
	          });
	
	          thisThing.showFront();
	        }, function () {
	          thisThing.setState({ isShowingHome: true, rewards: [] });
	          thisThing.showFront();
	        }, function () {
	          thisThing.setState({ isShowingHome: true, rewards: [] });
	          thisThing.showFront();
	        });
	      }, function () {
	        thisThing.setState({ isShowingError: true, errorTitle: locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE"), errorBody: locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY") });
	        thisThing.showFront();
	      }, function () {
	        thisThing.setState({ isShowingError: true, errorTitle: locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE"), errorBody: locManager.localizedStringForKey("NO_CONNECTION_STATEMENT") });
	        thisThing.showFront();
	      });
	    } else {
	      this.setState({ isShowingCFD: true });
	      this.showFront();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.initialLayout !== 'undefined') {
	      var maxWidth = 400;
	      var maxHeight = 700;
	      var width = Math.min(newProps.initialLayout.width - 24, maxWidth);
	      var height = Math.min(newProps.initialLayout.height - 24, maxHeight);
	      // var ratio = parseFloat(750 / 1234);
	      // width = Math.min(width, height*ratio);
	      // height = Math.min(height, width/ratio);
	      var horizontalMargin = (newProps.initialLayout.width - width) / 2;
	      var verticalMargin = (newProps.initialLayout.height - height) / 2;
	
	      this.setState({ horizontalMargin: horizontalMargin, verticalMargin: verticalMargin });
	    }
	  },
	
	  _showingFront: false,
	  showFront: function showFront() {
	    if (this._showingFront) return;
	    this._showingFront = true;
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationBack, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: true });
	      Animated.timing(thisThing.state.rotationFront, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  showBack: function showBack() {
	    if (!this._showingFront) return;
	    this._showingFront = false;
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationFront, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: false });
	      Animated.timing(thisThing.state.rotationBack, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  checkUserChanged: function checkUserChanged() {
	    var appManager = this.props.appManager;
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (!loggedIn && this.state.isShowingHome) {
	      this.goToPage(0);
	      this.setState({ isShowingHome: false, isShowingLogin: true });
	    }
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  _phoneTextCountryCode: "1",
	  _phoneText1: "",
	  _phoneText2: "",
	  _phoneText3: "",
	  hasValidPhone: function hasValidPhone() {
	    return this._phoneText1.length == 3 && this._phoneText2.length == 3 && this._phoneText3.length == 4;
	  },
	
	  setIsInError: function setIsInError(isInError, errorMessage) {
	    if (isInError != this.state.isInError) this.setState({ isInError: isInError });
	    if (typeof errorMessage !== 'undefined' && errorMessage != this.state.errorMessage) {
	      this.setState({ errorMessage: errorMessage });
	    } else if (typeof errorMessage === 'undefined' && this.state.errorMessage != null) {
	      this.setState({ errorMessage: null });
	    }
	  },
	
	  _phoneText1Placeholder: "###",
	  _phoneText2Placeholder: "###",
	  _phoneText3Placeholder: "####",
	  backSpacePressed: function backSpacePressed(fieldKey) {
	    switch (fieldKey) {
	      case 'code1':
	        break;
	      case 'code2':
	        if (this._codeText2.length <= 0) {
	          this._codeText1 = "";
	          this._code1.setText("");
	          this._code1.focus();
	        }
	        break;
	      case 'code3':
	        if (this._codeText3.length <= 0) {
	          this._codeText2 = "";
	          this._code2.setText("");
	          this._code2.focus();
	        }
	        break;
	      case 'code4':
	        if (this._codeText4.length <= 0) {
	          this._codeText3 = "";
	          this._code3.setText("");
	          this._code3.focus();
	        }
	        break;
	      case 'code5':
	        if (this._codeText5.length <= 0) {
	          this._codeText4 = "";
	          this._code4.setText("");
	          this._code4.focus();
	        }
	        break;
	      case 'code6':
	        if (this._codeText6.length <= 0) {
	          this._codeText5 = "";
	          this._code5.setText("");
	          this._code5.focus();
	        }
	        break;
	      case 'phone1':
	        break;
	      case 'phone2':
	        if (this._phoneText2.length <= 0) {
	          this._phoneText1 = "";
	          this._phone1.setText("");
	          this._phone1.focus();
	        }
	        break;
	      case 'phone3':
	        if (this._phoneText3.length <= 0) {
	          this._phoneText2 = "";
	          this._phone2.setText("");
	          this._phone2.focus();
	        }
	        break;
	      default:
	
	    }
	  },
	
	  storeFocus: function storeFocus() {
	    if (this._focusStore) this._focusStore.focus();
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);
	
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", .6);
	    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
	
	    var simpleCFD = appManager.getFeatureForName("SimpleCFD");
	    var termsPreferencesFeatureData = appManager.getFeatureForName("TermsPreferences");
	
	    var showBack = this.showBack;
	
	    var iconImageName = appManager.absoluteResourceForPath('App/iTunesArtwork.png');
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	    var termsAndPreferencesLocalized = locManager.localizedStringForKey("TERMS_AND_PREFERENCES_BUTTON");
	
	    var stripHeight = 120;
	
	    var rewardTitle = "";
	    var rewardCost = "";
	    var nextReward = { Points: 1 };
	    var amountFontSize = 40;
	    if (this.state.rewards.length > 0) {
	      for (var i = 0; i < this.state.rewards.length; i++) {
	        if (this.state.rewards[i].IsDeleted == "1") continue;
	        nextReward = this.state.rewards[i];
	        break;
	      }
	      rewardTitle = nextReward.RewardName;
	      rewardCost = locManager.localizedPoints(nextReward.Points);
	      amountFontSize = 40 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3) * 12 : 0);
	    }
	
	    var meterDim = 240;
	    if (this.props.initialLayout.width > 0) meterDim = Math.min(meterDim, this.props.initialLayout.width * .8);
	    if (this.props.initialLayout.height > 0) meterDim = Math.min(meterDim, this.props.initialLayout.height - 330);
	    meterDim = Math.max(meterDim, 110);
	    meterDim = Math.min(meterDim, 160);
	
	    var dollarsPerPointInstruction = "";
	    if (this.state.dollarsPerPoint != null) {
	      dollarsPerPointInstruction = locManager.localizedStringForKeyAndParams("DOLLARS_PER_POINT_INSTRUCTION", [locManager.localizedPoints(Math.round(1 / this.state.dollarsPerPoint)), locManager.localizedDollars(1)]);
	    }
	
	    var phoneSeparators = ["(", ") ", " - "];
	
	    if (this.state.isShowingCFD) {
	      return this.props.featureBuilder.featureForData(appManager.getFeatureForName("SimpleCFD"), { width: this.props.initialLayout.width, height: this.props.initialLayout.height }, this.props.appManager);
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor, height: this.props.initialLayout.height, width: this.props.initialLayout.width }] },
	      React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	      React.createElement(MKTextField, { ref: function ref(a) {
	          return _this._focusStore = a;
	        }, style: { display: 'none' } }),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'block' : 'none',
	            transform: [{ rotateY: this.state.rotationFront }],
	            flexDirection: 'column', alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: generalColor,
	            overflow: 'hidden'
	          } },
	        this.state.isShowingError ? React.createElement(
	          View,
	          { style: { flex: 1, flexDirection: 'column', alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { textAlign: 'center', margin: 10 } },
	            this.state.errorTitle
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', margin: 10 } },
	            this.state.errorBody
	          )
	        ) : null,
	        this.state.isShowingHome ? React.createElement(
	          View,
	          { key: 'feedPlusView', ref: function ref(a) {
	              if (a != null) thisThing._feedPlusView = a;
	            },
	            style: { backgroundColor: profileColor, flexDirection: 'column', flex: 1, alignSelf: 'stretch', height: this.props.initialLayout.height - 2 * this.state.verticalMargin } },
	          React.createElement(View, { style: { height: 30 } }),
	          React.createElement(
	            View,
	            { style: { height: stripHeight, backgroundColor: profileImageColor } },
	            React.createElement(Image, { style: { width: '100%', height: stripHeight }, resizeMode: "cover", source: { uri: stripImage } }),
	            React.createElement(
	              View,
	              { style: { position: 'absolute', top: 20, left: 20, right: 20, bottom: 20 } },
	              React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { alignItems: 'center', flexDirection: 'column', margin: 10 } },
	            React.createElement(
	              ArcMeter,
	              { key: 'rewardmeter', fgColor: profileMeterColor, dimension: meterDim, thickness: 16, bgColor: profileMeterBackgroundColor, percentage: parseInt(this.state.points) > parseInt(nextReward.Points) ? 1 : parseFloat(this.state.points / Math.max(1, nextReward.Points)) },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'column', width: 150, justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(PointsTicker, { key: "pointsticker", appManager: appManager, points: parseInt(this.state.points), style: [{ fontSize: amountFontSize, color: circleIconColor, justifyContent: 'center' }],
	                  renderText: function renderText(points) {
	                    return Math.round(points);
	                  } }),
	                React.createElement(View, { style: { flex: 1 } })
	              )
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center', marginBottom: 4 } },
	              rewardTitle
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: profileTitleColor, textAlign: 'center' } },
	              rewardCost
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: profileTitleColor, textAlign: 'center', margin: 10 } },
	              dollarsPerPointInstruction
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', marginBottom: 20 } },
	            React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { width: 240 }, text: termsAndPreferencesLocalized,
	              onPress: function onPress() {
	                thisThing.showBack();
	              } })
	          )
	        ) : null
	      ),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'none' : 'block',
	            flexDirection: 'column',
	            transform: [{ rotateY: this.state.rotationBack }],
	            alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: headerColor,
	            alignItems: 'stretch',
	            overflow: 'hidden'
	          } },
	        React.createElement(
	          View,
	          { key: 'feedPlusView', ref: function ref(a) {
	              if (a != null) thisThing._feedPlusView = a;
	            },
	            style: { backgroundColor: headerColor, flexDirection: 'column', flex: 1, alignSelf: 'stretch', height: this.props.initialLayout.height - 2 * this.state.verticalMargin } },
	          React.createElement(
	            View,
	            { style: { height: 60, flexDirection: 'row', alignItems: 'stretch', justifyContent: 'center', backgroundColor: generalColor } },
	            React.createElement(
	              View,
	              { style: { width: 60, justifyContent: 'center', alignItems: 'center' } },
	              React.createElement(ReUpIconButton, { appManager: appManager, iconName: "angle-left", onPress: function onPress() {
	                  return _this.showFront();
	                }, type: 2 })
	            ),
	            React.createElement(View, { style: { flex: 1, justifyContent: 'center', alignItems: 'center' } }),
	            React.createElement(View, { style: { width: 60 } })
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'column', alignItems: 'stretch' } },
	            this.props.featureBuilder.featureForData(termsPreferencesFeatureData, { width: this.props.initialLayout.width - 2 * this.state.horizontalMargin, height: this.props.initialLayout.height - 40 - 2 * this.state.verticalMargin }, this.props.appManager)
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  feedHeader: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'row'
	  },
	  feedHeaderLeftContainer: {
	    padding: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  profileImage: {
	    height: FEED_HEADER_HEIGHT - 16,
	    width: FEED_HEADER_HEIGHT - 16,
	    borderRadius: (FEED_HEADER_HEIGHT - 16) / 2,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: (FEED_HEADER_HEIGHT - 20) / 2,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  feedHeaderCenterContainer: {
	    height: FEED_HEADER_HEIGHT,
	    paddingVertical: 10,
	    flex: 1,
	    justifyContent: 'space-between'
	  },
	
	  feedHeaderRightContainer: {
	    paddingVertical: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  feedHeaderInfo: {
	    fontWeight: 'bold'
	  }
	});
	BasicHome.dataDependencies = ["Users", "Rewards"];
	
	module.exports = BasicHome;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpButton = __webpack_require__(12);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var NetworkManager = __webpack_require__(15);
	var DatePicker = __webpack_require__(852);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var Birthday = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      date: Platform.OS == 'web' ? new Date() : false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    setTimeout(function () {
	      if (typeof thisThing.refs.date !== 'undefined') thisThing.refs.date.onPressDate();
	    }, 500);
	  },
	
	  didUpdate: function didUpdate() {},
	
	  setDate: function setDate(date) {
	    if (typeof date === 'undefined') date = this.state.date;
	    var appManager = this.props.appManager;
	
	    var thisThing = this;
	    thisThing.setState({ date: date });
	  },
	
	  setBirthday: function setBirthday(birthday) {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var bdayString = locManager.dateTimeReUp(birthday);
	
	    appActions.setSpinnerShown(true);
	    NetworkManager.updateUser(appManager, { DOB: bdayString }, function (data) {
	      if (typeof thisThing.props.extras.didSetBirthday !== 'undefined') thisThing.props.extras.didSetBirthday();
	      appActions.setSpinnerShown(false);
	      appActions.requestPop();
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	    }, function () {
	      appActions.setSpinnerShown(false);
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    if (user == null) return null;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var selectBirthdayLocalized = locManager.localizedStringForKey("SELECT_BIRTHDAY_BUTTON");
	    var setBirthdayLocalized = locManager.localizedStringForKey("SET_BIRTHDAY_BUTTON");
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: generalColor } }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, isEmpty: false },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', backgroundColor: instructionColor } },
	          React.createElement(
	            View,
	            { style: { padding: 10, flex: 1 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: instructionTitleColor } },
	              this.props.featureData.instructions
	            )
	          )
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        React.createElement(
	          View,
	          { style: { alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(DatePicker, {
	            ref: 'date',
	            key: 'date',
	            style: { width: 200, height: this.state.date !== false ? 60 : 0, justifyContent: 'center', alignItems: 'center', opacity: this.state.date !== false ? 1 : 0 },
	            date: this.state.date,
	            mode: 'date',
	            format: 'MMMM DD, YYYY',
	            confirmBtnText: locManager.localizedStringForKey("CONFIRM_BUTTON", "Confirm"),
	            cancelBtnText: locManager.localizedStringForKey("CANCEL_BUTTON", "Cancel"),
	            onDateChange: function onDateChange(dateStr, date) {
	              thisThing.setDate(date);
	            },
	            customStyles: {
	              dateInput: {
	                borderColor: 'transparent'
	              },
	              placeholderText: {},
	              dateText: {
	                color: generalTitleColor, fontSize: 22, fontWeight: 'bold'
	              }
	            },
	            showIcon: false
	          })
	        ),
	        this.state.date === false ? React.createElement(ReUpButton, { onPress: function onPress() {
	            _this.refs.date.onPressDate();
	          }, style: { marginTop: 10, marginHorizontal: 20 }, appManager: appManager, text: selectBirthdayLocalized }) : React.createElement(ReUpButton, { onPress: function onPress() {
	            _this.setBirthday(_this.state.date);
	          }, style: { marginTop: 10, marginHorizontal: 20 }, appManager: appManager, text: setBirthdayLocalized })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  }
	});
	
	Birthday.dataDependencies = ["Users", "Campaigns"];
	
	module.exports = Birthday;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var moment = __webpack_require__(3);
	
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var DatePicker = __webpack_require__(852);
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner,
	    MKProgress = MK.MKProgress,
	    MKRadioButton = MK.MKRadioButton;
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    ScrollView = ReactNative.ScrollView;
	
	
	function dateKeyForDate(date) {
	  var mm = date.getMonth() + 1; // getMonth() is zero-based
	  var dd = date.getDate();
	  var dateString = [date.getFullYear(), "-", mm <= 9 ? '0' : '', mm, "-", dd <= 9 ? '0' : '', dd].join('');
	
	  return dateString;
	}
	
	var Booking = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      timeStartMinutes: 9 * 60,
	      timeEndMinutes: 17 * 60
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: { x: 0, y: 0, width: 0, height: 0 },
	      bookingEvents: [],
	      bookingPerformers: [],
	      bookingTimeframe: 30,
	      bookingEventID: null,
	      bookingPerformerID: null,
	      date: new Date(),
	      availabilities: [],
	      cachedAvailabilities: {},
	      fetchingAvailabilities: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setDate(this.state.date);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.BookingEvents !== 'undefined' && typeof data.BookingPerformers !== 'undefined') {
	      var thisThing = this;
	      // make sure the event still exists
	      var bookingEventID = null;
	      for (var i = 0; i < data.BookingEvents.length; i++) {
	        if (data.BookingEvents[i].id == this.state.bookingEventID) {
	          bookingEventID = this.state.bookingEventID;
	          break;
	        }
	      }
	      if (bookingEventID == null && data.BookingEvents.length > 0) bookingEventID = data.BookingEvents[0].id;
	
	      // make sure the performer still exists
	      var bookingPerformerID = null;
	      for (var i = 0; i < data.BookingPerformers.length; i++) {
	        if (data.BookingPerformers[i].id == this.state.bookingPerformerID) {
	          bookingPerformerID = this.state.bookingPerformerID;
	          break;
	        }
	      }
	      if (bookingPerformerID == null && data.BookingPerformers.length > 0) bookingPerformerID = data.BookingPerformers[0].id;
	
	      var timeframe = 30;
	      if (typeof data.BookingTimeframe !== 'undefined' && data.BookingTimeframe.length > 0) {
	        timeframe = parseInt(data.BookingTimeframe[0].timeFrame);
	      }
	      this.setState({ bookingEvents: data.BookingEvents, bookingPerformers: data.BookingPerformers, bookingEventID: bookingEventID, bookingPerformerID: bookingPerformerID, bookingTimeframe: timeframe });
	      this.setDate(this.state.date);
	    }
	  },
	
	  selectEvent: function selectEvent() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10, flexDirection: 'column', height: this.state.layout.height - 60 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      thisThing.state.bookingEvents.map(function (event, index) {
	        if (event.is_public != '1' || event.is_active != '1') return null;
	
	        return React.createElement(
	          View,
	          { key: "event" + event.id, style: { flexDirection: 'column', flex: -1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', flex: 1 } },
	            React.createElement(
	              MKButton,
	              { onPress: function onPress() {
	                  thisThing.setEvent(event);
	                }, maskBorderRadius: 0, key: "event" + index, rippleColor: primaryButtonColorLight, style: { flexDirection: 'row', alignItems: 'center', flex: -1 } },
	              React.createElement(MKRadioButton, {
	                checked: event.id == thisThing.state.bookingEventID,
	                fillColor: generalTitleColor,
	                borderOnColor: generalTitleColor,
	                borderOffColor: generalTitleColor,
	                rippleColor: primaryButtonColorLight
	              }),
	              React.createElement(
	                View,
	                { style: { flexDirection: 'column', marginVertical: 4, flex: 1 } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: { fontWeight: 'bold' } },
	                  event.name
	                ),
	                typeof event.price !== 'undefined' ? React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: {} },
	                    locMan.localizedDollars(event.price)
	                  )
	                ) : null,
	                typeof event.duration !== 'undefined' && event.hide_duration == '0' ? React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: {} },
	                    event.duration + " minutes"
	                  )
	                ) : null,
	                typeof event.description !== 'undefined' && event.description != null ? React.createElement(
	                  View,
	                  { style: { width: 200 } },
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { fontStyle: 'italic' } },
	                    event.description
	                  )
	                ) : null
	              )
	            )
	          ),
	          index < thisThing.state.bookingEvents.length - 1 ? React.createElement(ShadowView, { layout: thisThing.state.layout, appManager: appManager }) : null
	        );
	      })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  selectPerformer: function selectPerformer() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10, flexDirection: 'column', height: this.state.layout.height - 60 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      thisThing.state.bookingPerformers.map(function (performer, index) {
	        return React.createElement(
	          View,
	          { key: "performer" + performer.id, style: { flexDirection: 'column', flex: 1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', flex: 1 } },
	            React.createElement(
	              MKButton,
	              { onPress: function onPress() {
	                  thisThing.setPerformer(performer);
	                }, maskBorderRadius: 0, key: "performer" + index, rippleColor: primaryButtonColorLight, style: { flexDirection: 'row', alignItems: 'center', flex: 1 } },
	              React.createElement(MKRadioButton, {
	                checked: performer.id == thisThing.state.bookingPerformerID,
	                fillColor: generalTitleColor,
	                borderOnColor: generalTitleColor,
	                borderOffColor: generalTitleColor,
	                rippleColor: primaryButtonColorLight
	              }),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: {} },
	                performer.name
	              )
	            )
	          ),
	          index < thisThing.state.bookingPerformers.length - 1 ? React.createElement(ShadowView, { layout: thisThing.state.layout, appManager: appManager }) : null
	        );
	      })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  dayBack: function dayBack() {
	    var yesterday = new Date(this.state.date.setTime(this.state.date.getTime() - 1 * 86400000));
	    this.setDate(yesterday);
	  },
	
	  dayForward: function dayForward() {
	    var tomorrow = new Date(this.state.date.setTime(this.state.date.getTime() + 1 * 86400000));
	    this.setDate(tomorrow);
	  },
	
	  selectedTime: function selectedTime(time) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locMan = appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
	    var clientData = {
	      name: userFullName,
	      email: user[ModelConstants.UserName],
	      phone: "1"
	    };
	    var hours = Math.floor(time / 60);
	    var minutes = time % 60;
	    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
	    var msg = "Book " + this.bookingEvent().name + " with " + this.bookingPerformer().name + " on " + locMan.localizedDate(this.state.date) + " at " + timeString + "?";
	    appActions.showLocalizedAlert("Confirmation", msg, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	      appActions.hideAlert();
	    }, function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, "Booking...");
	      NetworkManager.bookSimplyBook(appManager, thisThing.state.bookingEventID, thisThing.state.bookingPerformerID, thisThing.state.date, time, clientData, function (data) {
	        appActions.setSpinnerShown(false);
	        if (typeof data !== 'undefined') {
	          thisThing.setDate(thisThing.state.date);
	          appActions.showLocalizedAlert("Success!", "You have been emailed a confirmation.", [locMan.localizedStringForKey("GOT_IT_ALERT_BUTTON")], [appActions.hideAlert]);
	        } else {
	          console.log("data", data);
	          appActions.showLocalizedAlert("Error", "That time seems to not be available.", ["Okay"], [appActions.hideAlert]);
	        }
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	      }, function () {
	        appActions.setSpinnerShown(false);
	      });
	    }], function () {});
	  },
	
	  setEvent: function setEvent(bookingEvent) {
	    this.props.appActions.setCustomAlertShown(false);
	    this.state.bookingEventID = bookingEvent.id;
	    this.setState({ bookingEventID: bookingEvent.id });
	    this.setDate();
	  },
	
	  setPerformer: function setPerformer(performer) {
	    this.props.appActions.setCustomAlertShown(false);
	    this.state.bookingPerformerID = performer.id;
	    this.setState({ bookingPerformerID: performer.id });
	    this.setDate();
	  },
	
	  setDate: function setDate(date) {
	    if (typeof date === 'undefined') date = this.state.date;
	    var appManager = this.props.appManager;
	
	    var thisThing = this;
	    var dateKey = dateKeyForDate(date);
	    if (typeof this.state.cachedAvailabilities[dateKey] !== 'undefined') {
	      this.setState({ date: date, availabilities: this.state.cachedAvailabilities[dateKey], fetchingAvailabilities: false });
	    } else {
	      this.setState({ date: date, availabilities: [], fetchingAvailabilities: true });
	    }
	
	    NetworkManager.getSimplyBookTimeIntervals(appManager, date, date, this.state.bookingEventID, this.state.bookingPerformerID, function (data) {
	      var cachedAvailabilities = thisThing.state.cachedAvailabilities;
	      for (var dateString in data) {
	        cachedAvailabilities[dateString] = data[dateString];
	      }
	      if (JSON.stringify(typeof data[dateKey] !== 'undefined' ? data[dateKey] : []) == JSON.stringify(thisThing.state.availabilities) && thisThing.state.fetchingAvailabilities == false) return;
	      thisThing.setState({ availabilities: typeof data[dateKey] !== 'undefined' ? data[dateKey] : [], fetchingAvailabilities: false, cachedAvailabilities: cachedAvailabilities });
	    }, function (data) {
	      thisThing.setState({ fetchingAvailabilities: false });
	    }, function (data) {
	      thisThing.setState({ fetchingAvailabilities: false });
	    });
	    // refresh
	  },
	
	  bookingEvent: function bookingEvent() {
	    for (var i = 0; i < this.state.bookingEvents.length; i++) {
	      var thisEvent = this.state.bookingEvents[i];
	      if (thisEvent.id == this.state.bookingEventID) {
	        return thisEvent;
	      }
	    }
	
	    return null;
	  },
	
	  bookingPerformer: function bookingPerformer() {
	    for (var i = 0; i < this.state.bookingPerformers.length; i++) {
	      var thisPerformer = this.state.bookingPerformers[i];
	      if (thisPerformer.id == this.state.bookingPerformerID) {
	        return thisPerformer;
	      }
	    }
	
	    return null;
	  },
	
	  render: function render() {
	    var instructions = this.props.featureData.instructions;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", 0.6);
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	
	    var bookingEvent = this.bookingEvent();
	    var bookingPerformer = this.bookingPerformer();
	
	    var availabilities = typeof this.state.availabilities[this.state.bookingPerformerID] === 'undefined' ? [] : this.state.availabilities[this.state.bookingPerformerID];
	    var amTimeSlots = [];
	    var pmTimeSlots = [];
	
	    var bookingTimeframe = this.state.bookingTimeframe;
	    if (typeof bookingEvent !== 'undefined' && bookingEvent != null && typeof bookingEvent.duration !== 'undefined') {
	      bookingTimeframe = Math.max(bookingTimeframe, bookingEvent.duration);
	    }
	    for (var i = 0; i < availabilities.length; i++) {
	      var avail = availabilities[i];
	      var fromTime = avail.from.split(":");
	      var toTime = avail.to.split(":");
	      var fromTimeMinutes = parseInt(fromTime[0]) * 60 + parseInt(fromTime[1]);
	      var toTimeMinutes = parseInt(toTime[0]) * 60 + parseInt(toTime[1]);
	      for (var currentTime = fromTimeMinutes; currentTime + bookingTimeframe <= toTimeMinutes; currentTime += bookingTimeframe) {
	        if (currentTime < 12 * 60) amTimeSlots.push(currentTime);else pmTimeSlots.push(currentTime);
	      }
	    }
	
	    var dateName = locManager.localizedDate(this.state.date);
	
	    var totallyEmpty = bookingEvent == null || bookingPerformer == null;
	    var emptyMessage = "No appointments available on this date.";
	    if (totallyEmpty) {
	      emptyMessage = "No appointments available.";
	    }
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', shouldMinimizeEmptyMessage: !totallyEmpty, bounces: true, responder: this, isEmpty: amTimeSlots.length <= 0 && pmTimeSlots.length <= 0 && !this.state.fetchingAvailabilities, customDependencies: [Booking.customDataDependency], featureName: "Booking", isEmptyPostfix: emptyMessage },
	        !totallyEmpty ? React.createElement(
	          View,
	          null,
	          bookingEvent != null ? React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(View, null),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor, margin: 8 } },
	                "What would you like to book?"
	              ),
	              React.createElement(View, null)
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { flex: 1, marginBottom: 4, width: this.state.layout.width - 20, marginHorizontal: 10 }, text: bookingEvent.name,
	              onPress: this.selectEvent })
	          ) : null,
	          bookingPerformer != null ? React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(View, null),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor, margin: 8 } },
	                "Who would you like to book with?"
	              ),
	              React.createElement(View, null)
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { flex: 1, marginBottom: 4, width: this.state.layout.width - 20, marginHorizontal: 10 }, text: bookingPerformer.name,
	              onPress: this.selectPerformer })
	          ) : null,
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(View, null),
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor, margin: 8 } },
	                "When would you like to book?"
	              ),
	              React.createElement(View, null)
	            ),
	            React.createElement(
	              View,
	              { style: { flexDirection: 'column' } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: this.state.layout.width } },
	                React.createElement(
	                  View,
	                  { style: { alignItems: 'center', justifyContent: 'center', flex: -1, marginHorizontal: 4, width: 30 } },
	                  React.createElement(ReUpIconButton, { key: 'leftButton', iconName: "angle-left", style: { pointerEvents: 'auto', paddingLeft: 2, width: 30, height: 50 }, appManager: appManager, type: 6, onPress: function onPress() {
	                      thisThing.dayBack();
	                    } })
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(DatePicker, {
	                  style: { width: 200 },
	                  date: thisThing.state.date,
	                  mode: 'date',
	                  placeholder: 'select date',
	                  format: 'MMMM DD, YYYY',
	                  confirmBtnText: 'Confirm',
	                  cancelBtnText: 'Cancel',
	                  onDateChange: function onDateChange(dateStr, date) {
	                    thisThing.setDate(date);
	                  },
	                  customStyles: {
	                    dateInput: {
	                      borderColor: 'transparent'
	                    },
	                    dateText: {
	                      color: generalTitleColor, fontSize: 22, fontWeight: 'bold'
	                    }
	                  },
	                  showIcon: false
	                }),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  View,
	                  { style: { alignItems: 'center', justifyContent: 'center', flex: -1, marginHorizontal: 4, width: 30 } },
	                  React.createElement(ReUpIconButton, { key: 'rightButton', iconName: "angle-right", style: { paddingLeft: 2, width: 30, height: 50 }, appManager: appManager, type: 6, onPress: function onPress() {
	                      thisThing.dayForward();
	                    } })
	                )
	              )
	            ),
	            this.state.fetchingAvailabilities ? React.createElement(
	              View,
	              { style: { flexDirection: 'row', marginTop: 20 } },
	              React.createElement(View, null),
	              React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }),
	              React.createElement(View, null)
	            ) : amTimeSlots.length > 0 || pmTimeSlots.length > 0 ? React.createElement(
	              View,
	              { style: { flexDirection: 'row', width: this.state.layout.width } },
	              React.createElement(View, { style: { flex: 1 } }),
	              amTimeSlots.length > 0 ? React.createElement(
	                View,
	                { style: { flexDirection: 'column', flex: -1, alignItems: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor } },
	                  "AM"
	                ),
	                React.createElement(
	                  View,
	                  null,
	                  amTimeSlots.map(function (time, index) {
	                    var hours = Math.floor(time / 60);
	                    var minutes = time % 60;
	                    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
	                    return React.createElement(ReUpButton, { appManager: appManager, style: { width: 100, marginVertical: 4 }, text: timeString,
	                      onPress: function onPress() {
	                        thisThing.selectedTime(time);
	                      } });
	                  })
	                )
	              ) : null,
	              amTimeSlots.length > 0 && pmTimeSlots.length > 0 ? React.createElement(View, { style: { flex: 1 } }) : null,
	              pmTimeSlots.length > 0 ? React.createElement(
	                View,
	                { style: { flexDirection: 'column', flex: -1, alignItems: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor } },
	                  "PM"
	                ),
	                React.createElement(
	                  View,
	                  { style: { flex: -1 } },
	                  pmTimeSlots.map(function (time, index) {
	                    var hours = Math.floor(time / 60);
	                    var minutes = time % 60;
	                    var timeString = hours + ":" + (minutes < 10 ? "0" : "") + minutes;
	                    return React.createElement(ReUpButton, { appManager: appManager, style: { width: 100, marginVertical: 4 }, text: timeString,
	                      onPress: function onPress() {
	                        thisThing.selectedTime(time);
	                      } });
	                  })
	                )
	              ) : null,
	              React.createElement(View, { style: { flex: 1 } })
	            ) : null
	          )
	        ) : React.createElement(View, null)
	      )
	    );
	  }
	});
	
	Booking.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	
	  var didSelect = function didSelect() {
	    appActions.requestFeatureName("Booking");
	  };
	  var iconName = featureData.data.icon.replace("fa-", "");
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: featureData.data.tip,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: 0
	  }];
	};
	
	Booking.customDependencyKeys = ["BookingEvents", "BookingPerformers", "BookingTimeframe"];
	Booking.customDataDependency = function (appManager, completion) {
	  NetworkManager.getSimplyBookEvents(appManager, function (events) {
	    NetworkManager.getSimplyBookPerformers(appManager, function (performers) {
	      NetworkManager.getSimplyBookTimeframe(appManager, function (timeFrame) {
	        console.log({ BookingEvents: events, BookingPerformers: performers, BookingTimeframe: [{ timeFrame: timeFrame }] });
	        completion({ BookingEvents: events, BookingPerformers: performers, BookingTimeframe: [{ timeFrame: timeFrame }] });
	      }, function (data) {
	        completion();
	      }, function () {
	        completion();
	      });
	    }, function (data) {
	      completion();
	    }, function () {
	      completion();
	    });
	  }, function (data) {
	    completion();
	  }, function () {
	    completion();
	  });
	};
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    margin: 4,
	    opacity: .6
	  }
	});
	Booking.dataDependencies = ["Users"];
	
	module.exports = Booking;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var QRCodeView = __webpack_require__(95);
	var ReUpButton = __webpack_require__(12);
	var MKSegmentControl = __webpack_require__(36);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var NetworkManager = __webpack_require__(15);
	var CheckMarkView = __webpack_require__(146);
	var FadingView = __webpack_require__(51);
	
	var _require = __webpack_require__(148),
	    PhysScene = _require.PhysScene,
	    PhysObject = _require.PhysObject;
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet,
	    Vibration = ReactNative.Vibration,
	    Platform = ReactNative.Platform,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	function getBase64Data(data) {
	  var dataJsonString = JSON.stringify(data);
	  var dataBase64 = btoa(dataJsonString);
	
	  return dataBase64;
	}
	
	var CheckIn = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      dollarsPerPoint: 1
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.setQRCode();
	    var appManager = this.props.appManager;
	    if (appManager.isLoggedIn()) {
	      this._pointsAdded = appManager.currentUser()[ModelConstants.TotalPointsAddedAtScanner];
	      this._points = appManager.currentUser()[ModelConstants.Points];
	      this._credit = appManager.currentUser()[ModelConstants.Credits];
	      this._hash = appManager.currentUser()[ModelConstants.Hash];
	    }
	    this.queuePoll();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._pollTimeout != null) clearTimeout(this._pollTimeout);
	  },
	
	  _hash: null,
	  _pollTimeout: null,
	  _isFirstPoll: true,
	  queuePoll: function queuePoll() {
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    this._pollTimeout = setTimeout(function () {
	      if (appManager.isLoggedIn()) {
	        NetworkManager.updateFeature(appManager, "User", function (user) {
	          if (typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined') {
	            var newHash = user[ModelConstants.Hash];
	            var newPointsAdded = user.TotalPointsAddedAtScanner;
	            var newCredit = user[ModelConstants.Credits];
	            var newPoints = user[ModelConstants.Points];
	            if (newCredit != thisThing._credit || newPoints != thisThing._points || newHash != thisThing._hash || newPointsAdded != thisThing._pointsAdded) {
	              appManager.setCurrentUser(user, function () {
	                if (newPointsAdded > thisThing._pointsAdded && !thisThing._isFirstPoll) thisThing.announceTransaction(0, newPointsAdded - thisThing._pointsAdded);
	                thisThing._pointsAdded = newPointsAdded;
	                thisThing._credit = newCredit;
	                thisThing._points = newPoints;
	                thisThing._hash = newHash;
	                thisThing.setQRCode();
	                thisThing.forceUpdate();
	              });
	            }
	          }
	          thisThing._isFirstPoll = false;
	          thisThing.queuePoll();
	        }, function () {
	          thisThing.queuePoll();
	        });
	      } else {
	        thisThing.queuePoll();
	      }
	    }, appManager._isDemo ? 20000 : 5000);
	  },
	
	  setQRCode: function setQRCode() {
	    var appManager = this.props.appManager;
	    var user = appManager.currentUser();
	    var qrData = {};
	    this._hash = user[ModelConstants.Hash];
	    qrData["Type"] = "checkin";
	    qrData["AppID"] = appManager.getAppInfo()["appid"];
	    qrData["U"] = user[ModelConstants.UserID];
	    qrData["H"] = user[ModelConstants.Hash];
	
	    var qrDataBase64 = getBase64Data(qrData);
	
	    if (this.refs.qrcode) this.refs.qrcode.setData(qrDataBase64);
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Campaigns !== 'undefined') {
	      var checkInCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        var campaign = data.Campaigns[i];
	        if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	      }
	
	      this.setState({
	        dollarsPerPoint: checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint
	      });
	    }
	  },
	
	  announceTransaction: function announceTransaction(deltaCredit, deltaPoints) {
	    var _this = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	
	    var message = "";
	    if (deltaCredit > 0 && deltaPoints > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_EARNED_STATEMENT", [locManager.localizedDollars(deltaCredit), locManager.localizedPoints(deltaPoints)], "You spent %0% and earned %1%.");
	    } else if (deltaCredit < 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(-deltaCredit)]);
	    } else if (deltaPoints > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locManager.localizedPoints(deltaPoints)]);
	    }
	
	    var pattern, patternLiteral, patternDescription;
	    if (Platform.OS === 'android') {
	      pattern = [0, 2000];
	    } else {
	      pattern = [0];
	    }
	    Vibration.vibrate(pattern);
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var objBG = 'transparent'; //appManager.getColorForKey("FeedCardBannerColor");
	    var objFG = appManager.getColorForKey("ButtonPrimaryColor"); //appManager.getColorForKey("FeedCardBannerIconColor");
	
	    var MAX_OBJECTS = 10;
	    var numObjects = Math.abs(deltaPoints);
	    while (numObjects > MAX_OBJECTS) {
	      numObjects /= 2;
	    }var renderObject = function renderObject() {
	      return React.createElement(
	        View,
	        { style: { width: 40, height: 40, borderRadius: 20, backgroundColor: objBG, alignItems: 'center', flexDirection: 'row', justifyContent: 'center' } },
	        React.createElement(_ReUpIcon2.default, { name: "trophy", size: 40, color: objFG, style: { backgroundColor: 'transparent' } })
	      );
	    };
	    var objects = [];
	    for (var i = 0; i < numObjects; i++) {
	      var imod = i % 4;
	      var velX = (imod == 0 || imod == 1 ? -1 : 1) * (0.0005 + 0.0001 * Math.random());
	      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
	      var velY = -0.001 + -0.002 * Math.random();
	      var startTime = 300 + (i + 1) * 100;
	      objects.push({
	        posX: .5, posY: .5, velX: velX, velY: velY, renderObject: renderObject, startTime: startTime
	      });
	    }
	    var thisThing = this;
	    thisThing._doneButtonFadingView = null;
	    setTimeout(function () {
	      if (thisThing._doneButtonFadingView) thisThing._doneButtonFadingView.setFadedOut(false);
	    }, 3000);
	    // setTimeout(()=>
	    // {
	    //   if( thisThing.state.renderAlternative )
	    //   {
	    //     thisThing.setState({renderAlternative:false});
	    //     setTimeout(()=>
	    //     {
	    //       thisThing.setQRCode();
	    //     }, 200)
	    //   }
	    // }, 10000)
	    this.setState({
	      renderAlternative: true,
	      renderAlternativeView: function renderAlternativeView() {
	        return React.createElement(
	          View,
	          { style: { backgroundColor: generalColor, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: _this.state.layout.width, height: _this.state.layout.height } },
	          false ? React.createElement(PhysScene, {
	            style: { position: 'absolute', top: 0, left: 0, width: _this.state.layout.width, height: _this.state.layout.height },
	            objectInfos: objects }) : null,
	          React.createElement(
	            View,
	            { style: { marginHorizontal: 20, borderRadius: 8, flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              View,
	              { style: { width: 100, height: 100, flexDirection: 'column', marginBottom: 20 } },
	              React.createElement(CheckMarkView, { color: appManager.getColorForKey("FeedCardBannerColor"), style: { flex: 1, alignSelf: 'stretch' } })
	            ),
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: appManager, style: { color: appManager.getColorForKey("FeedCardTitleColor"), backgroundColor: appManager.getColorForKey("FeedCardColor", .6), textAlign: 'center' } },
	              message
	            )
	          ),
	          React.createElement(
	            FadingView,
	            { ref: function ref(a) {
	                return thisThing._doneButtonFadingView = a;
	              }, animDuration: 200, style: { height: 50, marginHorizontal: 20, marginTop: 40, alignSelf: 'stretch' } },
	            React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("DONE_BUTTON", "Done") })
	          ),
	          React.createElement(
	            TouchableWithoutFeedback,
	            { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, onPress: function onPress() {
	                thisThing.setState({ renderAlternative: false });
	                setTimeout(function () {
	                  thisThing.setQRCode();
	                }, 200);
	              } },
	            React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 } })
	          )
	        );
	      }
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var addCredit = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    var dimension = Math.min(this.state.layout.width - 100, this.state.layout.height - 164);
	    var localizedDollarsPerPoint = locManager.localizedDollars(this.state.dollarsPerPoint);
	    var instructions = "";
	    if (this.state.dollarsPerPoint != null) {
	      instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints((1 / this.state.dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]);
	    }
	    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;
	    var isEmptyString = locManager.localizedStringForKey("CHECK_IN_DISABLED_STATEMENT", "You can currently only earn points when you pay with your app.");
	    var isEmpty = this.state.dollarsPerPoint == null;
	    var alertMessage = locManager.localizedStringForKeyAndParams(this.props.featureData.instructions, [locManager.localizedPoints((1 / this.state.dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]);
	
	    return React.createElement(
	      View,
	      { style: styles.container,
	        onLayout: function onLayout(event) {
	          return _this2.setState({ containerLayout: event.nativeEvent.layout });
	        } },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { backgroundColor: generalColor, borderRadius: borderRadius }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, featureName: 'CheckIn', isEmpty: isEmpty, isEmptyPostfix: isEmptyString,
	          renderAlternative: this.state.renderAlternative, renderAlternativeView: this.state.renderAlternativeView },
	        !isEmpty ? React.createElement(
	          View,
	          { style: { flexDirection: 'row', flex: -1 } },
	          React.createElement(View, { style: { height: this.state.layout.height } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', flex: 1 } },
	            React.createElement(
	              View,
	              { style: { flex: 1 } },
	              React.createElement(
	                View,
	                { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	                React.createElement(
	                  View,
	                  { style: { alignSelf: 'center', flex: 1 } },
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	                    instructions
	                  )
	                ),
	                React.createElement(ReUpIconButton, { type: 3,
	                  appManager: appManager,
	                  featureData: this.props.featureData,
	                  locParams: [localizedDollarsPerPoint],
	                  appActions: this.props.appActions,
	                  alertMessage: alertMessage
	                })
	              ),
	              React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	              React.createElement(View, { style: { flex: 1 } })
	            ),
	            React.createElement(QRCodeView, { ref: 'qrcode', key: 'qrcode', data: "", dimension: dimension, style: styles.qrcode, spinnerView: React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }) }),
	            React.createElement(View, { style: { flex: 1 } })
	          )
	        ) : null
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    alignSelf: 'stretch'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row',
	    flex: -1
	  },
	  instructionText: {
	    margin: 10
	  },
	  tipText: {
	    alignSelf: 'center'
	  },
	  backgroundView: {
	    position: 'absolute',
	    top: 0, left: 0, right: 0, bottom: 0
	  },
	  qrcode: {
	    padding: 30,
	    alignItems: 'center'
	  },
	  tipContainer: {
	    height: 50,
	    flex: 1,
	    padding: 10
	  },
	  tipTypeContainer: {
	    height: 50,
	    width: 180,
	    alignSelf: 'center'
	  },
	  textField: {
	    width: 120,
	    height: 50,
	    marginTop: 10
	  },
	  button: {
	    justifyContent: 'center',
	    flex: 1
	  },
	  tipValueContainer: {
	    paddingTop: 4,
	    paddingLeft: 20,
	    paddingRight: 20,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row'
	  },
	  tipLabel: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    textAlign: 'center',
	    alignSelf: 'flex-end'
	  }
	});
	
	CheckIn.dataDependencies = ["Users", "Campaigns"];
	
	module.exports = CheckIn;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	
	var NumericalInput = __webpack_require__(92);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var CreditInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    return {
	      layout: this.props.initialLayout,
	      chargeText: locManager.localizedStringForKeyAndParams("CHECK_IN_ADD_STATEMENT", ["0"], "Add - 0 points"),
	      campaigns: [],
	      useCreditCampaign: null,
	      referCampaign: null,
	      checkInCampaign: null,
	      transferLoyaltyCampaign: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Campaigns !== 'undefined') {
	      var useCreditCampaign = null;
	      var referCampaign = null;
	      var checkInCampaign = null;
	      var transferLoyaltyCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        var campaign = data.Campaigns[i];
	        if (campaign.Type == "UseCredit") useCreditCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "TransferLoyalty") transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
	      }
	      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
	      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
	      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0, AssignPoints: 0/1};
	      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};
	
	      this.setState({
	        campaigns: data.Campaigns,
	        useCreditCampaign: useCreditCampaign,
	        referCampaign: referCampaign,
	        checkInCampaign: checkInCampaign,
	        transferLoyaltyCampaign: transferLoyaltyCampaign
	      });
	    }
	  },
	
	  submitPressed: function submitPressed() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var pointsString = this.refs.numInput.stringPointValue();
	    var dollarsAmount = this.refs.numInput.dollarsAmount();
	    var pointsAmount = this.refs.numInput.pointsAmount();
	    var processingSpinner = locManager.localizedStringForKey("PAYING_HUD");
	    var checkinAmount = dollarsAmount;
	    if (this.state.checkInCampaign != null && typeof this.state.checkInCampaign.AssignPoints !== 'undefined' && this.state.checkInCampaign.AssignPoints != 0) {
	      checkinAmount = pointsAmount;
	    }
	    var msgLocalized = locManager.localizedStringForKeyAndParams("ADD_STATEMENT", [pointsString]);
	    appActions.showLocalizedAlert("ASSIGN_POINTS_ALERT_TITLE", msgLocalized, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	      appActions.hideAlert();
	    }, function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, processingSpinner);
	      NetworkManager.vendorCheckIn(appManager, thisThing.props.extras.userID, checkinAmount, thisThing.props.extras.userType, thisThing.props.extras.hash, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = true;
	        extras.isCheckin = true;
	        extras.scanner = thisThing.props.extras.scanner;;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = false;
	        extras.scanner = thisThing.props.extras.scanner;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	      });
	    }], function () {}, false, false, 20, 18, 20);
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var dollarsPerPoint = 0;
	    var isAssignPoints = false;
	    if (this.state.checkInCampaign != null && this.state.checkInCampaign.DollarsPerPoint != 0) {
	      dollarsPerPoint = this.state.checkInCampaign.DollarsPerPoint;
	    } else if (this.state.checkInCampaign != null && typeof this.state.checkInCampaign.AssignPoints !== 'undefined' && this.state.checkInCampaign.AssignPoints != 0) {
	      isAssignPoints = true;
	    }
	    var inputHeight = 400;
	    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width - 20;
	    var buttonWidth = this.state.layout.width - 20;
	    var cancelButton = locManager.localizedStringForKey("CANCEL_BUTTON");
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', alignItems: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'row' } },
	            React.createElement(View, { style: { flex: 1 } }),
	            isAssignPoints ? React.createElement(NumericalInput, { ref: 'numInput', style: { height: inputHeight, width: inputWidth, marginTop: 20 }, isCheckin: true, appManager: this.props.appManager, valueChanged: function valueChanged(newValue, newStringValue) {
	                thisThing.setState({ chargeText: thisThing.localizedStringForKey("CHECK_IN_ADD_STATEMENT", [newStringValue]) });
	              },
	              displayPoints: true }) : React.createElement(NumericalInput, { ref: 'numInput', style: { height: inputHeight, width: inputWidth, marginTop: 20 }, isCheckin: true, appManager: this.props.appManager, valueChanged: function valueChanged(newValue, newStringValue) {
	                thisThing.setState({ chargeText: thisThing.localizedStringForKey("CHECK_IN_ADD_STATEMENT", [newStringValue]) });
	              },
	              dollarsPerPoint: dollarsPerPoint }),
	            React.createElement(View, { style: { flex: 1 } })
	          ),
	          React.createElement(ReUpButton, { style: [styles.button, { margin: 10, width: buttonWidth }],
	            appManager: appManager,
	            text: this.state.chargeText,
	            onPress: function onPress() {
	              thisThing.submitPressed();
	            }
	          }),
	          React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, width: buttonWidth }],
	            appManager: appManager,
	            text: cancelButton,
	            onPress: function onPress() {
	              thisThing.props.appActions.requestPop();
	              if (typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true) {
	                setTimeout(function () {
	                  thisThing.props.extras.scanner.scan();
	                }, 300);
	              }
	            }
	          })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	CreditInput.dataDependencies = ["Campaigns"];
	
	module.exports = CreditInput;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var NetworkManager = __webpack_require__(15);
	var LinkingManager = __webpack_require__(27);
	
	var ReUpScrollView = __webpack_require__(16);
	var ReUpField = __webpack_require__(26);
	var ReUpButton = __webpack_require__(12);
	var ReUpStyle = __webpack_require__(151);
	var ReUpText = __webpack_require__(8);
	var ShadowView = __webpack_require__(20);
	var ProgressOverlay = __webpack_require__(52);
	var LinkingManager = __webpack_require__(27);
	var AnalyticsManager = __webpack_require__(50);
	var Hyperlink = __webpack_require__(113);
	var Keyboard = __webpack_require__(76);
	
	var MK = __webpack_require__(14);
	
	var MKIconToggle = MK.MKIconToggle,
	    MKCheckbox = MK.MKCheckbox,
	    MKButton = MK.MKButton;
	
	
	var FBSDK = __webpack_require__(152);
	var LoginManager = FBSDK.LoginManager,
	    AccessToken = FBSDK.AccessToken;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    AppState = ReactNative.AppState;
	
	
	var CreateUser = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var initialEmailErrorString = locManager.localizedStringForKey("VALID_EMAIL_STRING_ERROR");
	    return {
	      layout: this.props.initialLayout,
	      showPassword: false,
	      showRefCode: false,
	      fadeRefCode: new Animated.Value(0),
	      nameError: false,
	      firstNameError: false,
	      lastNameError: false,
	      emailError: false,
	      emailErrorString: initialEmailErrorString,
	      passwordError: false,
	      refCodeErrorString: '',
	      shouldShowSpinner: false,
	      spinnerText: '',
	      canOpenMailApp: false,
	      optedIn: false,
	      signingUpWithEmail: !this.props.appManager.useFacebookForFeatureName("CreateUser")
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    AppState.addEventListener('change', this._handleAppStateChange);
	    this.didUpdate();
	    if (typeof this.props.extras === 'undefined' || !this.props.extras.useInterstitialFlow) {
	      var thisThing = this;
	      setTimeout(function () {
	        thisThing.focus();
	      }, 400);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    AppState.removeEventListener('change', this._handleAppStateChange);
	    this._shouldContinueRecuriveLogin = false;
	    clearTimeout(this._recursiveLoginTimeout);
	  },
	
	  _handleAppStateChange: function _handleAppStateChange(appState) {
	    if (appState == 'active') {} else {}
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  focus: function focus() {
	    if (this.refs.firstName) this.refs.firstName.focus();
	  },
	
	  _email: "",
	  emailChanged: function emailChanged(text) {
	    if (this.props.appManager.isValidEmail(text)) this._enableEmailError = true;
	    this._email = text;
	
	    var newState = this.checkErrors();
	    if (this.state.emailError != newState.emailError) {
	      this.setState(newState);
	    }
	  },
	
	  _firstName: "",
	  firstNameChanged: function firstNameChanged(text) {
	    var firstNameValid = this._firstName.length > 0;
	    if (firstNameValid) this._enableFirstNameError = true;
	
	    this._firstName = text;
	    var newState = this.checkErrors();
	    if (this.state.firstNameError !== newState.firstNameError) {
	      this.setState(newState);
	    }
	  },
	
	  _lastName: "",
	  lastNameChanged: function lastNameChanged(text) {
	    var lastNameValid = this._lastName.length > 0;
	    if (lastNameValid) this._enableLastNameError = true;
	
	    this._lastName = text;
	    var newState = this.checkErrors();
	    if (this.state.lastNameError !== newState.lastNameError) {
	      this.setState(newState);
	    }
	  },
	
	  _password: "",
	  passwordChanged: function passwordChanged(text) {
	    if (this.props.appManager.isValidPassword(text)) this._enablePasswordError = true;
	
	    this._password = text;
	    var newState = this.checkErrors();
	    if (this.state.passwordError != newState.passwordError) {
	      this.setState(newState);
	    }
	  },
	
	  _refCode: "",
	  refCodeChanged: function refCodeChanged(text) {
	    this._refCode = text;
	  },
	
	  _enableFirstNameError: false,
	  _enableLastNameError: false,
	  _enableEmailError: false,
	  _enablePasswordError: false,
	  _enableInlineErrors: false,
	  checkErrors: function checkErrors() {
	    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
	    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
	    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
	    var passwordError = this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);
	
	    return { emailError: emailError, firstNameError: firstNameError, lastNameError: lastNameError, passwordError: passwordError };
	  },
	
	  showRefCodeField: function showRefCodeField() {
	    var thisThing = this;
	    thisThing.setState({ showRefCode: !thisThing.state.showRefCode });
	    Animated.timing(this.state.fadeRefCode, {
	      toValue: 1,
	      duration: 500
	    }).start(function () {
	      thisThing.refs.refCode.focus();
	    });
	  },
	
	  showEmailSpinnerAndMessage: function showEmailSpinnerAndMessage(email) {
	    var thisThing = this;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var spinnerText = locMan.localizedStringForKey("VERIFY_EMAIL_HUD_TITLE");
	    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_EMAIL_HUD_BODY", [email]);
	    this.checkForMailApp(function (can) {
	      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
	    });
	  },
	
	  showSpinnerAndMessage: function showSpinnerAndMessage(spinnerText, spinnerBody, showMail) {
	    Keyboard.dismiss();
	    this.setState({ shouldShowSpinner: true, spinnerText: spinnerText, spinnerBody: spinnerBody, canOpenMailApp: showMail });
	  },
	
	  hideSpinnerAndMessage: function hideSpinnerAndMessage() {
	    this.setState({ shouldShowSpinner: false });
	  },
	
	  checkForMailApp: function checkForMailApp(completion) {
	    var thisThing = this;
	    var mailURL = "message://";
	    LinkingManager.canOpenURL(mailURL, function (can) {
	      thisThing.setState({ canOpenMailApp: can });
	      completion(can);
	    });
	  },
	
	  submitPressed: function submitPressed() {
	    this._enableEmailError = true;
	    this._enableFirstNameError = true;
	    this._enableLastNameError = true;
	    this._enablePasswordError = true;
	
	    var newState = this.checkErrors();
	    this.setState(newState);
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;
	
	    if (newState.firstNameError) {
	      if (!useInterstitialFlow) {
	        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", "NAME_EMPTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          if (thisThing.refs.firstName) thisThing.refs.firstName.focus();
	        }], function () {});
	      }
	    } else if (newState.lastNameError) {
	      if (!useInterstitialFlow) {
	        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", "NAME_EMPTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          if (thisThing.refs.lastName) thisThing.refs.lastName.focus();
	        }], function () {});
	      }
	    } else if (newState.emailError) {
	      if (!useInterstitialFlow) {
	        appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          if (thisThing.refs.email) thisThing.refs.email.focus();
	        }], function () {});
	      }
	    } else if (newState.passwordError) {
	      if (!useInterstitialFlow) {
	        appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          if (thisThing.refs.password) thisThing.refs.password.focus();
	        }], function () {});
	      }
	    } else {
	      var appManager = this.props.appManager;
	      var locManager = appManager.getLocalizationManager();
	      var email = this._email;
	      var password = this._password;
	      var registering = appManager.getLocalizationManager().localizedStringForKey("REGISTERING_HUD");
	
	      this.showEmailSpinnerAndMessage(email);
	
	      NetworkManager.createUser(this.props.appManager, this._email, this._password, this._firstName, this._lastName, "", this._refCode, this.state.optedIn, function (email) {
	        if (!useInterstitialFlow) {
	          AnalyticsManager.logSignUpEvent(appManager, 'Normal', true);
	          appActions.setSpinnerShown(false);
	          appManager.setTempUserPass([email, password]);
	          thisThing._shouldContinueRecuriveLogin = true;
	          thisThing.recursiveLogin(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	            data[ModelConstants.Password] = password;
	            appManager.setCurrentUser(data, function () {
	              thisThing.hideSpinnerAndMessage();
	              var addCreditFeature = appManager.getFeatureForName("AddCredit");
	              if (typeof addCreditFeature !== 'undefined') {
	                appActions.requestFeatureName("AddCredit", {}, true, null, true);
	              }
	            });
	          });
	        } else {
	          appManager.setTempUserPass([email, password]);
	          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', true);
	          thisThing._shouldContinueRecuriveLogin = true;
	          thisThing.recursiveLogin(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	            data[ModelConstants.Password] = password;
	            appManager.setCurrentUser(data, function () {
	              thisThing.props.extras.createUserDidFinish();
	            });
	          });
	        }
	      }, function (data) {
	        if (!useInterstitialFlow) {
	          AnalyticsManager.logSignUpEvent(appManager, 'Normal', false, { error: data.code });
	          appActions.setSpinnerShown(false);
	          thisThing.setState({ shouldShowSpinner: false });
	          if (data.code == -4) {
	            // not verified or account already created, so lets try to log them in anyways
	            NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	              data[ModelConstants.Password] = password;
	              appManager.setCurrentUser(data, function () {
	                thisThing.hideSpinnerAndMessage();
	                var addCreditFeature = appManager.getFeatureForName("AddCredit");
	                if (typeof addCreditFeature !== 'undefined') {
	                  appActions.requestFeatureName("AddCredit", {}, true, null, true);
	                } else {
	                  appActions.requestPopToIndex(0);
	                }
	              });
	            }, function (data) {
	              thisThing.refs.email.setIsInError(true);
	              appActions.showLocalizedAlert("CREATEUSER_EXISTS_FAIL_ALERT_TITLE", "CREATEUSER_EXISTS_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                appActions.hideAlert();
	                thisThing.refs.email.focus();
	              }], function () {});
	            }, function (data) {
	              thisThing.refs.email.setIsInError(true);
	              appActions.showLocalizedAlert("CREATEUSER_EXISTS_FAIL_ALERT_TITLE", "CREATEUSER_EXISTS_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                appActions.hideAlert();
	                thisThing.refs.email.focus();
	              }], function () {});
	            });
	          } else if (data.code == -44) {
	            thisThing.refs.refCode.setIsInError(true);
	            appActions.showLocalizedAlert("Referral Code Invalid!", "Please enter a valid referral code or clear the field.", ["OK_ALERT_BUTTON"], [function () {
	              appActions.hideAlert();
	              thisThing.refs.refCode.focus();
	            }], function () {});
	          } else {
	            thisThing.refs.email.setIsInError(true);
	            appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	              appActions.hideAlert();
	              thisThing.refs.email.focus();
	            }], function () {});
	          }
	        } else {
	          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', false, { error: data.code });
	          thisThing.setState({ shouldShowSpinner: false });
	          if (data.code == -4) {
	            // not verified or account already created, so lets try to log them in anyways
	            NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	              data[ModelConstants.Password] = password;
	              appManager.setCurrentUser(data, function () {
	                thisThing.props.extras.createUserDidFinish(null, true);
	              });
	            }, function (data) {
	              var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EXISTS_FAIL_ALERT_BODY");
	              thisThing.setState({ emailError: true, emailErrorString: errorStringLocalized });
	              thisThing.refs.email.focus();
	            }, function (data) {
	              var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EXISTS_FAIL_ALERT_BODY");
	              thisThing.setState({ emailError: true, emailErrorString: errorStringLocalized });
	              thisThing.refs.email.focus();
	            });
	          } else if (data.code == -44) {
	            var errorStringLocalized = locManager.localizedStringForKey("VALID_REFFERAL_CODE_ERROR");
	            thisThing.setState({ refCodeError: true, refCodeErrorString: errorStringLocalized });
	            thisThing.refs.refCode.focus();
	          } else if (typeof data.code === 'undefined') {
	            thisThing.props.extras.showNetworkErrorAlert();
	          } else {
	            var errorStringLocalized = locManager.localizedStringForKey("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY");
	            thisThing.setState({ emailError: true, emailErrorString: errorStringLocalized });
	            thisThing.refs.email.focus();
	          }
	        }
	      }, function (data) {
	        if (!useInterstitialFlow) {
	          AnalyticsManager.logSignUpEvent(appManager, 'Normal', false);
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	        } else {
	          AnalyticsManager.logSignUpEvent(appManager, 'Interstitial', false);
	          thisThing.setState({ shouldShowSpinner: false });
	          thisThing.props.extras.showNetworkErrorAlert();
	        }
	      });
	    }
	  },
	
	  setScrollOffset: function setScrollOffset(yOffset) {
	    var thisThing = this;
	    setTimeout(function () {
	      var minScrollOffset = 0;
	      var keyboardOffset = typeof thisThing.refs.ptr !== 'undefined' ? thisThing.refs.ptr._keyboardOffset : 0;
	      var maxScrollOffset = thisThing._contentHeight - (thisThing._scrollViewHeight - keyboardOffset);
	      var normalizedScroll = Math.max(minScrollOffset, Math.min(maxScrollOffset, yOffset));
	
	      thisThing.refs.ptr.scrollTo(0, normalizedScroll);
	    }, 100);
	  },
	
	  openTosLink: function openTosLink(url) {
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.canOpenURL(url, function (can) {
	      if (can) {
	        LinkingManager.openURL(url, tintColor, barTintColor);
	      }
	    });
	  },
	
	  _recursiveLoginPaused: false,
	  setRecursiveLoginPaused: function setRecursiveLoginPaused(paused) {
	    if (paused != this._recursiveLoginPaused) {
	      if (paused) // can only pause if there is login info recorded
	        {
	          if (this._loginInfoForPause != null) {
	            this._recursiveLoginPaused = paused;
	            clearTimeout(this._recursiveLoginTimeout);
	          }
	        } else {
	        this._recursiveLoginPaused = paused;
	        if (this._loginInfoForPause != null) // can only resume if login info is recorded
	          {
	            this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin);
	          }
	      }
	    }
	  },
	
	  _shouldContinueRecuriveLogin: false,
	  _recursiveLoginTimeout: null,
	  _loginInfoForPause: null,
	  recursiveLogin: function recursiveLogin(appManager, email, password, didLogin) {
	    if (!this._shouldContinueRecuriveLogin || this._recursiveLoginPaused) return;
	
	    this._loginInfoForPause = { appManager: appManager, email: email, password: password, didLogin: didLogin };
	    var thisThing = this;
	    NetworkManager.login(appManager, email, password, function (data) {
	      didLogin(data);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    });
	  },
	
	  submitFacebookPressed: function submitFacebookPressed() {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;
	    this.showSpinnerAndMessage("", "");
	    LoginManager.logInWithReadPermissions(['email', 'public_profile']).then(function (result) {
	      if (result.isCancelled) {
	        console.log("Facebook cancelled");
	        thisThing.hideSpinnerAndMessage();
	      } else {
	        AccessToken.getCurrentAccessToken().then(function (data) {
	          var password = data.accessToken.toString();
	          NetworkManager.createUserFacebook(appManager, password, thisThing._refCode, thisThing.state.optedIn, function (email) {
	            NetworkManager.login(appManager, email, password, function (data) {
	              data[ModelConstants.Password] = password;
	              if (!useInterstitialFlow) {
	                AnalyticsManager.logSignUpEvent(appManager, 'Normal-Facebook', true);
	                appManager.setCurrentUser(data, function () {
	                  thisThing.hideSpinnerAndMessage();
	                  var addCreditFeature = appManager.getFeatureForName("AddCredit");
	                  if (typeof addCreditFeature !== 'undefined') {
	                    appActions.requestFeatureName("AddCredit", {}, true, null, true);
	                  } else {
	                    appActions.requestPop(true);
	                  }
	                });
	              } else {
	                AnalyticsManager.logSignUpEvent(appManager, 'Interstitial-Facebook', true);
	                appManager.setCurrentUser(data, function () {
	                  thisThing.hideSpinnerAndMessage();
	                  thisThing.props.extras.createUserDidFinish();
	                });
	              }
	            }, function () {
	              thisThing.hideSpinnerAndMessage();
	            }, function () {
	              thisThing.hideSpinnerAndMessage();
	            });
	          }, function () {
	            thisThing.hideSpinnerAndMessage();
	          });
	        });
	      }
	    }, function (error) {
	      thisThing.hideSpinnerAndMessage();
	      console.log('Login fail with error: ' + error);
	    });
	  },
	
	  _firstNameError: false,
	  _secondNameError: false,
	  _emailError: false,
	  _passwordError: false,
	  render: function render() {
	    var _this = this;
	
	    var createUser = this;
	    var appManager = this.props.appManager;
	    var featureData = appManager.getFeatureForName("CreateUser");
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var appInfo = appManager.getAppInfo();
	    var tosLink = appManager.getTermsLink();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	
	    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
	    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
	    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
	    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
	    var fillInFirstNameInstruction = locManager.localizedStringForKey("FILL_IN_FIRST_NAME_INSTRUCTION");
	    var fillInLastNameInstruction = locManager.localizedStringForKey("FILL_IN_LAST_NAME_INSTRUCTION");
	    var passwordEightCharInstruction = locManager.localizedStringForKey("PW_EIGHT_CHAR_INSTRUCTION");
	    var openEmailButton = locManager.localizedStringForKey("OPEN_EMAIL_BUTTON");
	    var registerButton = featureData.data.title;
	    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
	    var mailURL = "message://";
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras.useInterstitialFlow;
	    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
	    if (typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK") {
	      optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
	    }
	
	    var fieldHeightForAutoScroll = 60;
	
	    if (this.state.signingUpWithEmail) {
	      return React.createElement(
	        View,
	        { style: [styles.container, { backgroundColor: generalColor }] },
	        this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	        React.createElement(
	          ReUpScrollView,
	          { ref: 'ptr', bounces: true, responder: this, onLayout: function onLayout(event) {
	              return _this._scrollViewHeight = event.nativeEvent.layout.height;
	            } },
	          React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	          React.createElement(
	            View,
	            { onLayout: function onLayout(event) {
	                return _this._contentHeight = event.nativeEvent.layout.height;
	              } },
	            React.createElement(
	              View,
	              { key: 'fields', style: styles.fieldsContainer },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'column', flex: 1 } },
	                  React.createElement(ReUpField, {
	                    appManager: appManager,
	                    underlineColorAndroid: 'transparent',
	                    key: 'firstName', ref: 'firstName',
	                    autoCapitalize: 'words',
	                    autoCorrect: false,
	                    onFocus: function onFocus() {
	                      return _this.setScrollOffset(fieldHeightForAutoScroll * 0);
	                    },
	                    onChangeText: this.firstNameChanged,
	                    onSubmitEditing: function onSubmitEditing() {
	                      _this.refs.lastName.focus();
	                    },
	                    returnKeyType: 'next',
	                    isInError: this.state.firstNameError,
	                    placeholder: firstNameLabel,
	                    style: [styles.textField, { flex: -1 }] }),
	                  this.state.firstNameError && useInterstitialFlow ? React.createElement(
	                    ReUpText,
	                    { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                    fillInFirstNameInstruction
	                  ) : null
	                ),
	                React.createElement(View, { style: { width: 8 } }),
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'column', flex: 1 } },
	                  React.createElement(ReUpField, {
	                    appManager: appManager,
	                    underlineColorAndroid: 'transparent',
	                    key: 'lastName', ref: 'lastName',
	                    autoCapitalize: 'words',
	                    autoCorrect: false,
	                    onFocus: function onFocus() {
	                      return _this.setScrollOffset(fieldHeightForAutoScroll * 0);
	                    },
	                    onChangeText: this.lastNameChanged,
	                    onSubmitEditing: function onSubmitEditing() {
	                      _this.refs.email.focus();
	                    },
	                    returnKeyType: 'next',
	                    isInError: this.state.lastNameError,
	                    placeholder: lastNameLabel,
	                    style: [styles.textField, { flex: -1 }] }),
	                  this.state.lastNameError && useInterstitialFlow ? React.createElement(
	                    ReUpText,
	                    { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                    fillInLastNameInstruction
	                  ) : null
	                )
	              ),
	              React.createElement(ReUpField, {
	                appManager: appManager,
	                key: 'email', ref: 'email',
	                underlineColorAndroid: 'transparent',
	                autoCapitalize: 'none',
	                autoCorrect: false,
	                onFocus: function onFocus() {
	                  return _this.setScrollOffset(fieldHeightForAutoScroll * 1);
	                },
	                keyboardType: 'email-address',
	                onChangeText: this.emailChanged,
	                onSubmitEditing: function onSubmitEditing() {
	                  _this.refs.password.focus();
	                },
	                returnKeyType: 'next',
	                placeholder: emailLabel,
	                isInError: this.state.emailError,
	                style: [styles.textField] }),
	              this.state.emailError && useInterstitialFlow ? React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                this.state.emailErrorString
	              ) : null,
	              React.createElement(
	                View,
	                { style: styles.passwordContainer },
	                React.createElement(ReUpField, {
	                  appManager: appManager,
	                  underlineColorAndroid: 'transparent',
	                  onChangeText: this.passwordChanged,
	                  onSubmitEditing: this.state.showRefCode ? function () {
	                    _this.refs.refCode.focus();
	                  } : this.submitPressed,
	                  returnKeyType: this.state.showRefCode ? 'next' : 'done',
	                  key: 'password',
	                  ref: 'password',
	                  onFocus: function onFocus() {
	                    return _this.setScrollOffset(fieldHeightForAutoScroll * 2);
	                  },
	                  isInError: this.state.passwordError,
	                  placeholder: passwordLabel,
	                  secureTextEntry: !this.state.showPassword,
	                  style: [styles.textField] }),
	                React.createElement(
	                  MKIconToggle,
	                  {
	                    style: { marginTop: 22, height: 30, width: 30, position: 'absolute', right: 0, backgroundColor: 'transparent' },
	                    checked: this.state.showPassword,
	                    onCheckedChange: this.state.showPassword ? function () {
	                      createUser.setState({ showPassword: false });_this.refs.password.onBlur();_this.refs.password.focus();
	                    } : function () {
	                      createUser.setState({ showPassword: true });_this.refs.password.onBlur();_this.refs.password.focus();
	                    }
	                  },
	                  React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	                  React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	                )
	              ),
	              this.state.passwordError && useInterstitialFlow ? React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                passwordEightCharInstruction
	              ) : null,
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', marginTop: 10 } },
	                React.createElement(
	                  MKButton,
	                  { onPress: function onPress() {
	                      createUser.setState({ optedIn: !createUser.state.optedIn });
	                    },
	                    rippleColor: primaryButtonColorLight, maskBorderRadius: 0, style: {
	                      flexDirection: 'row',
	                      flex: 1,
	                      alignItems: 'center',
	                      height: 40,
	                      alignSelf: 'center',
	                      justifyContent: 'center'
	                    } },
	                  React.createElement(MKCheckbox, {
	                    checked: this.state.optedIn,
	                    fillColor: generalTitleColor,
	                    borderOnColor: generalTitleColor,
	                    borderOffColor: generalTitleColor,
	                    rippleColor: primaryButtonColorLight
	                  }),
	                  React.createElement(
	                    View,
	                    { style: { flex: 1, alignSelf: 'center' } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: {}, numberOfLines: 3 },
	                      optInText
	                    )
	                  )
	                )
	              ),
	              this.state.showRefCode ? React.createElement(
	                Animated.View,
	                {
	                  style: {
	                    opacity: this.state.fadeRefCode,
	                    marginBottom: 10
	                  } },
	                React.createElement(ReUpField, {
	                  appManager: appManager,
	                  underlineColorAndroid: 'transparent',
	                  key: 'refCode', ref: 'refCode',
	                  autoCapitalize: 'none',
	                  autoCorrect: false,
	                  onFocus: function onFocus() {
	                    return _this.setScrollOffset(fieldHeightForAutoScroll * 3);
	                  },
	                  onSubmitEditing: this.submitPressed,
	                  returnKeyType: 'done',
	                  onChangeText: this.refCodeChanged,
	                  placeholder: locManager.localizeStringForKey("REFERRAL_CODE_PLACEHOLDER"),
	                  isInError: this.state.refCodeError,
	                  style: [styles.textField] })
	              ) : React.createElement(ReUpButton, { appManager: appManager, style: { marginHorizontal: 0, marginTop: 16 }, text: refCodeButton, isSecondary: true,
	                onPress: this.showRefCodeField
	              }),
	              this.state.refCodeError && useInterstitialFlow ? React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                this.state.refCodeErrorString
	              ) : null
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: registerButton,
	              onPress: this.submitPressed
	            }),
	            React.createElement(
	              Hyperlink,
	              {
	                linkStyle: { color: '#2980b9' },
	                linkText: function linkText(url) {
	                  return url === tosLink ? locManager.localizedStringForKey("TERMS_OF_SERVICE") : url;
	                },
	                onPress: function onPress(url) {
	                  return createUser.openTosLink(url);
	                }
	              },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { marginLeft: 15, marginRight: 15 } },
	                locManager.localizedStringForKeyAndParams("BY_CREATING_ACCOUNT_STATEMENT", [tosLink])
	              )
	            )
	          )
	        ),
	        this.state.shouldShowSpinner ? React.createElement(
	          ProgressOverlay,
	          { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner,
	            spinnerText: this.state.spinnerText, spinnerBody: this.state.spinnerBody,
	            layout: this.state.layout, appManager: appManager },
	          createUser.state.canOpenMailApp ? React.createElement(ReUpButton, { appManager: appManager, style: { justifyContent: 'center', marginTop: 6, padding: 4 }, text: openEmailButton,
	            onPress: function onPress() {
	              LinkingManager.openURL(mailURL);
	            }
	          }) : null
	        ) : null
	      );
	    } else {
	      return React.createElement(
	        View,
	        { style: [styles.container, { backgroundColor: generalColor }] },
	        this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	        React.createElement(
	          ReUpScrollView,
	          { ref: 'ptr', bounces: true, responder: this, onLayout: function onLayout(event) {
	              return _this._scrollViewHeight = event.nativeEvent.layout.height;
	            } },
	          React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	          React.createElement(
	            View,
	            { onLayout: function onLayout(event) {
	                return _this._contentHeight = event.nativeEvent.layout.height;
	              } },
	            React.createElement(
	              View,
	              { key: 'fields', style: styles.fieldsContainer },
	              this.state.showRefCode ? React.createElement(
	                Animated.View,
	                {
	                  style: {
	                    opacity: this.state.fadeRefCode,
	                    marginBottom: 10
	                  } },
	                React.createElement(ReUpField, {
	                  appManager: appManager,
	                  underlineColorAndroid: 'transparent',
	                  key: 'refCode', ref: 'refCode',
	                  autoCapitalize: 'none',
	                  autoCorrect: false,
	                  onFocus: function onFocus() {
	                    return _this.setScrollOffset(fieldHeightForAutoScroll * 3);
	                  },
	                  onSubmitEditing: this.submitPressed,
	                  returnKeyType: 'done',
	                  onChangeText: this.refCodeChanged,
	                  placeholder: locManager.localizeStringForKey("REFERRAL_CODE_PLACEHOLDER"),
	                  isInError: this.state.refCodeError,
	                  style: [styles.textField] })
	              ) : React.createElement(ReUpButton, { appManager: appManager, style: { marginHorizontal: 0, marginTop: 16 }, text: refCodeButton, isSecondary: true,
	                onPress: this.showRefCodeField
	              }),
	              this.state.refCodeError && useInterstitialFlow ? React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: 'red', marginLeft: 10 } },
	                this.state.refCodeErrorString
	              ) : null
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, icon: 'facebook-official', iconSize: 22, iconPaddingLeft: 8, buttonColor: '#244BA1', buttonTitleColor: 'white', style: [styles.doneButton, { marginBottom: 0 }], text: locManager.localizedStringForKey("CONTINUE_WITH_FACEBOOK_BUTTON", "Continue With Facebook"),
	              onPress: this.submitFacebookPressed
	            }),
	            React.createElement(ShadowView, { layout: this.state.layout, text: locManager.localizedStringForKey("OR_LABEL"), appManager: appManager }),
	            React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: locManager.localizedStringForKey("SIGN_UP_WITH_EMAIL", "Sign Up With Email"),
	              onPress: function onPress() {
	                createUser.setState({ signingUpWithEmail: true });
	                setTimeout(function () {
	                  createUser.focus();
	                }, 100);
	              }
	            }),
	            React.createElement(
	              Hyperlink,
	              {
	                linkStyle: { color: '#2980b9' },
	                linkText: function linkText(url) {
	                  return url === tosLink ? locManager.localizedStringForKey("TERMS_OF_SERVICE") : url;
	                },
	                onPress: function onPress(url) {
	                  return createUser.openTosLink(url);
	                }
	              },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { marginLeft: 15, marginRight: 15 } },
	                locManager.localizedStringForKeyAndParams("BY_CREATING_ACCOUNT_STATEMENT", [tosLink])
	              )
	            )
	          )
	        ),
	        this.state.shouldShowSpinner ? React.createElement(
	          ProgressOverlay,
	          { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner,
	            spinnerText: this.state.spinnerText, spinnerBody: this.state.spinnerBody,
	            layout: this.state.layout, appManager: appManager },
	          createUser.state.canOpenMailApp ? React.createElement(ReUpButton, { appManager: appManager, style: { justifyContent: 'center', marginTop: 6, padding: 4 }, text: openEmailButton,
	            onPress: function onPress() {
	              LinkingManager.openURL(mailURL);
	            }
	          }) : null
	        ) : null
	      );
	    }
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  backgroundView: _defineProperty({
	    position: 'absolute',
	    top: 0, left: 0, bottom: 0 }, 'top', 0),
	  textField: {
	    flex: 1
	  },
	  fieldsContainer: {
	    flexDirection: 'column',
	    paddingHorizontal: 16,
	    paddingVertical: 10
	  },
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  passwordShowButton: {
	    borderRadius: 25,
	    width: 50,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    margin: 4
	  },
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginHorizontal: 16,
	    marginBottom: 8
	  }
	});
	
	CreateUser.dataDependencies = ["Users"];
	
	CreateUser.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (isLoggedIn) return [];else {
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("CreateUser");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	module.exports = CreateUser;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	
	var NumericalInput = __webpack_require__(92);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var CreditInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      addingCredit: false,
	      extras: { addingCredit: false }
	    };
	  },
	
	  _prefix: "Charge - ",
	  getInitialState: function getInitialState() {
	    var locMan = this.props.appManager.getLocalizationManager();
	    if (this.props.extras.addingCredit) {
	      this._prefix = "Add - ";
	    }
	    return {
	      layout: this.props.initialLayout,
	      chargeText: this._prefix + locMan.localizedDollars(0)
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  isUsingCredit: function isUsingCredit() {
	    return typeof this.props.extras === 'undefined' || typeof this.props.extras.addingCredit === 'undefined' || !this.props.extras.addingCredit;
	  },
	
	  doTransaction: function doTransaction() {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var amount = this.refs.numInput.dollarsAmount();
	    var extras = this.props.extras;
	    var thisThing = this;
	    if (this.isUsingCredit()) {
	      appActions.setSpinnerShown(true, "Processing...");
	      NetworkManager.vendorUseCredit(appManager, extras.U, amount, extras.Type, extras.H, extras.TT, extras.T, function (data) {
	        appActions.setSpinnerShown(false);
	        var newExtras = data;
	        newExtras.success = true;
	        newExtras.scanner = thisThing.props.extras.scanner;
	        newExtras.isAddingCredit = false;
	        appActions.requestFeatureName("TransactionResult", newExtras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var newExtras = data;
	        newExtras.success = false;
	        newExtras.scanner = thisThing.props.extras.scanner;
	        newExtras.isAddingCredit = false;
	        appActions.requestFeatureName("TransactionResult", newExtras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	      });
	    } else // is adding credit
	      {
	        appActions.setSpinnerShown(true, "Processing...");
	        NetworkManager.vendorAddCreditGC(appManager, this.props.extras.U, amount, "U", this.props.extras.H, function (data) {
	          appActions.setSpinnerShown(false);
	          var newExtras = data;
	          newExtras.success = true;
	          newExtras.type = "credit";
	          newExtras.scanner = thisThing.props.extras.scanner;
	          newExtras.isAddingCredit = true;
	          appActions.requestFeatureName("TransactionResult", newExtras);
	        }, function (data) {
	          appActions.setSpinnerShown(false);
	          var newExtras = data;
	          newExtras.success = false;
	          newExtras.type = "credit";
	          newExtras.scanner = thisThing.props.extras.scanner;
	          newExtras.isAddingCredit = true;
	          appActions.requestFeatureName("TransactionResult", newExtras);
	        }, function (data) {
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	        });
	      }
	  },
	
	  submitPressed: function submitPressed() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var creditString = this.refs.numInput.stringDollarValue();
	    if (this.isUsingCredit()) {
	      var msg = "CHARGE " + creditString + "?";
	      appActions.showLocalizedAlert("Charge", msg, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	      }, function () {
	        appActions.hideAlert();
	        thisThing.doTransaction();
	      }], function () {}, false, false, 20, 18, 20);
	    } else {
	      var msg = "ADD " + creditString + "?";
	      appActions.showLocalizedAlert("Add Credit", msg, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	      }, function () {
	        appActions.hideAlert();
	        thisThing.doTransaction();
	      }], function () {}, false, false, 20, 18, 20);
	    }
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var inputHeight = 400;
	    var inputWidth = this.state.layout.width > 620 ? 600 : this.state.layout.width - 20;
	    var buttonWidth = this.state.layout.width - 20;
	    var cancelButton = locManager.localizedStringForKey("CANCEL_BUTTON");
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', alignItems: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'row' } },
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(NumericalInput, { ref: 'numInput', isDollars: true, style: { height: inputHeight, width: inputWidth, marginTop: 20 }, appManager: this.props.appManager, valueChanged: function valueChanged(newValue, newStringValue) {
	                thisThing.setState({ chargeText: thisThing._prefix + newStringValue });
	              } }),
	            React.createElement(View, { style: { flex: 1 } })
	          ),
	          React.createElement(ReUpButton, { style: [styles.button, { margin: 10, width: buttonWidth }],
	            appManager: appManager,
	            text: this.state.chargeText,
	            onPress: function onPress() {
	              thisThing.submitPressed();
	            }
	          }),
	          React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, width: buttonWidth }],
	            appManager: appManager,
	            text: cancelButton,
	            onPress: function onPress() {
	              thisThing.props.appActions.requestPop();
	              if (typeof thisThing.props.extras.scanner !== 'undefined' && thisThing.props.extras.disableAutoScannerLaunch != true) {
	                setTimeout(function () {
	                  thisThing.props.extras.scanner.scan();
	                }, 300);
	              }
	            }
	          })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	CreditInput.dataDependencies = [];
	
	module.exports = CreditInput;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Overlay = __webpack_require__(112);
	var ReUpText = __webpack_require__(8);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    TouchableOpacity = ReactNative.TouchableOpacity,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet,
	    Keyboard = ReactNative.Keyboard,
	    ListView = ReactNative.ListView,
	    Text = ReactNative.Text,
	    Platform = ReactNative.Platform,
	    Dimensions = ReactNative.Dimensions;
	
	
	var CustomAlertOverlay = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isVisible: false,
	      initialOpacity: 0,
	      layout: { x: 0, y: 0, width: 100, height: 100 }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var ds = new ListView.DataSource({ rowHasChanged: function rowHasChanged(r1, r2) {
	        return r1 !== r2;
	      } });
	    var thisThing = this;
	    return {
	      keyboardOffset: new Animated.Value(0),
	      customAlert: this.props.children,
	      opacity: new Animated.Value(this.props.initialOpacity),
	      isVisible: this.props.isVisible,
	      didCancel: function didCancel() {
	        thisThing.fadeOut();
	      },
	      disableBackgroundSelectionDismiss: false,
	      hideFrame: false,
	      dataSource: ds.cloneWithRows(['John', 'Joel', 'James', 'Jimmy', 'Jackson', 'Jillian', 'Julie', 'Devin']),
	      width: -1,
	      height: -1
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (Platform.OS !== 'web') {
	      if (this._keyboardWillShowSubscription) this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', function (e) {
	        return _this._keyboardWillShow(e);
	      });
	      if (this._keyboardWillHideSubscription) this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', function (e) {
	        return _this._keyboardWillHide(e);
	      });
	    }
	
	    try {
	      var _Dimensions$get = Dimensions.get('window'),
	          height = _Dimensions$get.height,
	          width = _Dimensions$get.width;
	
	      if (height > 0 && width > 0) {
	        this.setState({ width: width, height: height });
	      }
	    } catch (e) {} finally {}
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (Platform.OS !== 'web') {
	      if (this._keyboardWillShowSubscription) this._keyboardWillShowSubscription.remove();
	      if (this._keyboardWillHideSubscription) this._keyboardWillHideSubscription.remove();
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.state.isVisible != nextProps.isVisible) {
	      // this.setState({isVisible:nextProps.isVisible});
	    }
	  },
	
	  _keyboardWillShow: function _keyboardWillShow(e) {
	    var thisThing = this;
	    Animated.timing(thisThing.state.keyboardOffset, { toValue: e.endCoordinates.height,
	      duration: 100 }).start(function () {});
	  },
	
	  _keyboardWillHide: function _keyboardWillHide(e) {
	    var thisThing = this;
	    Animated.timing(thisThing.state.keyboardOffset, { toValue: 0,
	      duration: 100 }).start(function () {});
	  },
	
	  _didFadeIn: false,
	  setDidFadeIn: function setDidFadeIn(didFadeIn) {
	    if (didFadeIn != this._didFadeIn) {
	      if (didFadeIn) this.fadeIn();else this.fadeOut();
	
	      this._didFadeIn = didFadeIn;
	    }
	  },
	
	  fadeIn: function fadeIn(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss) {
	    this._didFadeIn = true;
	    var thisThing = this;
	    thisThing.setState({
	      isVisible: true,
	      customAlert: typeof customAlert !== 'undefined' ? customAlert : this.state.customAlert,
	      didCancel: typeof didCancel !== 'undefined' ? didCancel : this.state.didCancel,
	      hideFrame: hideFrame,
	      disableBackgroundSelectionDismiss: typeof disableBackgroundSelectionDismiss === 'undefined' ? false : disableBackgroundSelectionDismiss
	    });
	    Animated.timing(this.state.opacity, { toValue: 1, duration: 200 }).start(function () {});
	  },
	
	  fadeOut: function fadeOut() {
	    if (!this._didFadeIn) return;
	
	    this._didFadeIn = false;
	    var thisThing = this;
	    Animated.timing(this.state.opacity, { toValue: 0,
	      duration: 200 }).start(function () {
	      thisThing.setState({ isVisible: false });
	    });
	  },
	
	  render: function render() {
	    var _React$createElement;
	
	    var thisThing = this;
	
	    if (!this._didFadeIn) return null;
	
	    var useBlur = false;
	    var containerStyle = { position: 'absolute', flexDirection: 'column', top: 0, left: 0, right: 0 };
	    if (this.state.width > 0 && this.state.height > 0) {
	      containerStyle.height = this.state.height;
	    } else {
	      containerStyle.bottom = 0;
	    }
	
	    return React.createElement(
	      View,
	      { style: containerStyle },
	      React.createElement(
	        TouchableOpacity,
	        { activeOpacity: 0.95, style: styles.container,
	          onPress: function onPress() {
	            thisThing.state.didCancel();
	            if (!thisThing.state.disableBackgroundSelectionDismiss) {
	              thisThing.fadeOut();
	            }
	          } },
	        React.createElement(
	          Animated.View,
	          { style: { opacity: this.state.opacity, position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } },
	          useBlur ? React.createElement(BlurView, { blurType: 'light', style: { flex: 1 } }) : React.createElement(View, { style: { backgroundColor: 'black', opacity: .6, flex: 1 } })
	        )
	      ),
	      React.createElement(
	        Animated.View,
	        { pointerEvents: "box-none", style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, paddingBottom: this.state.height > 0 ? this.state.keyboardOffset : 0, opacity: this.state.opacity } },
	        React.createElement(
	          View,
	          { pointerEvents: "box-none", style: [styles.blurStyle] },
	          this.state.hideFrame ? React.createElement(
	            View,
	            (_React$createElement = { pointerEvents: "box-none" }, _defineProperty(_React$createElement, 'pointerEvents', "auto"), _defineProperty(_React$createElement, 'style', styles.progressMessageContainerTransparent), _React$createElement),
	            this.state.customAlert
	          ) : React.createElement(
	            View,
	            { pointerEvents: "box-none", style: styles.progressMessageContainerContainer },
	            React.createElement(
	              View,
	              { pointerEvents: "auto", style: styles.progressMessageContainer },
	              this.state.customAlert
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    justifyContent: 'center',
	    flexDirection: 'column',
	    alignItems: 'stretch'
	  },
	  blurStyle: {
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  progressMessageContainerContainer: {
	    marginVertical: 10,
	    justifyContent: 'center',
	    alignItems: 'stretch',
	    flex: 1,
	    flexBasis: 'auto'
	  },
	  progressMessageContainer: {
	    margin: 20,
	    flex: -1,
	    backgroundColor: 'white',
	    borderRadius: 4,
	    borderWidth: 1,
	    borderColor: '#DADADA',
	    flexBasis: 'auto'
	  },
	  progressMessageContainerTransparent: {
	    margin: 0,
	    backgroundColor: 'transparent',
	    borderRadius: 0,
	    borderWidth: 0,
	    borderColor: 'transparent',
	    flexBasis: 'auto'
	  }
	});
	
	module.exports = CustomAlertOverlay;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var AsyncStorage = ReactNative.AsyncStorage;
	
	
	var TABLE_NAME_PREFIX = "@RNDB@";
	var TABLE_NAME_PREFIX_LENGTH = TABLE_NAME_PREFIX.length;
	
	var TABLE_NAME_PRIMARY_VALUE_SEPARATOR = ":";
	var TABLE_NAME_PRIMARY_VALUE_SEPARATOR_LENGTH = TABLE_NAME_PRIMARY_VALUE_SEPARATOR.length;
	
	var TABLE_INFO_NAME = "@RNDBINFO@";
	
	Array.prototype.inArray = function (comparer) {
	  for (var i = 0; i < this.length; i++) {
	    if (comparer(this[i])) return true;
	  }
	  return false;
	};
	
	Array.prototype.pushIfNotExist = function (element, comparer) {
	  if (!this.inArray(comparer)) {
	    this.push(element);
	  }
	};
	
	var DBManager = function () {
	  function DBManager() {
	    _classCallCheck(this, DBManager);
	
	    this._tableInfo = {};
	    this._tables = {};
	  }
	
	  //
	  // tableInfoEntriesArray is of the form:
	  //
	  // [
	  //   {tableName:"MyTableName1", primaryKey:"MyTable1sPrimaryKey"},
	  //   {tableName:"MyTableName2", primaryKey:"MyTable2sPrimaryKey"}
	  // ]
	  //
	
	
	  _createClass(DBManager, [{
	    key: 'initialize',
	    value: function initialize(tableInfoEntriesArray, completion) {
	      var self = this;
	      DBManager.loadTableInfo(function (tableInfo) {
	        self._tableInfo = tableInfo;
	        self.addTables(tableInfoEntriesArray, function () {
	          DBManager.loadTableRowsForTableInfo(self._tableInfo, function (tableNameRowKeys) {
	            for (var tableName in tableNameRowKeys) {
	              self._tables[tableName].setRowKeys(tableNameRowKeys[tableName]);
	            }
	
	            completion();
	          });
	        });
	      });
	    }
	  }, {
	    key: 'table',
	    value: function table(tableName) {
	      if (typeof tableName === 'undefined' || // can't retrieve table without name
	      typeof this._tables[tableName] === 'undefined') // can't retrieve table if it isn't added
	        {
	          return null;
	        }
	
	      return this._tables[tableName];
	    }
	  }, {
	    key: 'addTable',
	    value: function addTable(tableInfoEntry, completion) {
	      var primaryKey = tableInfoEntry.primaryKey;
	      var tableName = tableInfoEntry.tableName;
	      if (typeof this._tableInfo[tableName] === 'undefined' || this._tableInfo[tableName].primaryKey != primaryKey || typeof this._tables[tableName] === 'undefined') {
	        this._tables[tableName] = new Table(tableName, primaryKey);
	        this._tableInfo[tableName] = this._tables[tableName].getTableInfoEntry();
	
	        var self = this;
	        DBManager.saveTableInfo(this._tableInfo, function () {
	          completion(self._tables[tableName]);
	        });
	        return;
	      } else {
	        completion(this._tables[tableName]);
	      }
	    }
	
	    // recursively add tables, don't pass in index
	
	  }, {
	    key: 'addTables',
	    value: function addTables(tableInfoEntriesArray, completion, index) {
	      if (typeof index === 'undefined') index = 0;
	
	      if (index >= tableInfoEntriesArray.length) {
	        completion();
	        return;
	      }
	
	      var self = this;
	      this.addTable(tableInfoEntriesArray[index], function () {
	        self.addTables(tableInfoEntriesArray, completion, index + 1);
	      });
	    }
	  }, {
	    key: 'clear',
	    value: function clear(completion) {
	      AsyncStorage.clear(completion);
	    }
	  }]);
	
	  return DBManager;
	}();
	
	//
	// separates the table name and primary key value and returns them
	//
	// if tableNamePrimaryValue is invalid, then it return false
	//
	
	
	exports.default = DBManager;
	DBManager.isValidTableEntryForDB = function (tableNamePrimaryValue, tableInfo) {
	  if (tableNamePrimaryValue.indexOf(TABLE_NAME_PREFIX) != 0) return false; // no table name prefix
	
	  var indexOfSeparator = tableNamePrimaryValue.indexOf(TABLE_NAME_PRIMARY_VALUE_SEPARATOR);
	  if (indexOfSeparator < TABLE_NAME_PREFIX_LENGTH + 1) return false; // no valid primary value
	
	  var tableName = tableNamePrimaryValue.substring(TABLE_NAME_PREFIX_LENGTH, indexOfSeparator);
	  if (typeof tableInfo[tableName] === 'undefined') return false; // table does not exist in table info
	
	  var primaryValue = tableNamePrimaryValue.substring(indexOfSeparator + TABLE_NAME_PRIMARY_VALUE_SEPARATOR_LENGTH, tableNamePrimaryValue.length);
	
	  return { tableName: tableName, primaryValue: primaryValue };
	};
	
	//
	// retrieves the table info
	//
	DBManager.loadTableInfo = function (completion) {
	  AsyncStorage.getItem(TABLE_INFO_NAME, function (error, tableInfoResult) {
	    if (tableInfoResult == null || error != null) {
	      // table info doesn't exist yet, lets make it
	      AsyncStorage.setItem(TABLE_INFO_NAME, JSON.stringify({}), function () {
	        completion({});
	      });
	    } else {
	      var tableInfo = tableInfoResult;
	      try {
	        var tableInfoParsed = JSON.parse(tableInfo);
	        completion(tableInfoParsed);
	      } catch (e) {
	        console.log("ERROR!!! Cannot parse table info", tableInfoResult, e);
	
	        // table info isn't valid, lets remake it
	        AsyncStorage.setItem(TABLE_INFO_NAME, JSON.stringify({}), function () {
	          completion({});
	        });
	      }
	    }
	  });
	};
	
	DBManager.saveTableInfo = function (tableInfo, completion) {
	  var tableInfoStr = JSON.stringify(tableInfo);
	  AsyncStorage.setItem(TABLE_INFO_NAME, tableInfoStr, completion);
	};
	
	DBManager.loadTableRowsForTableInfo = function (tableInfo, completion) {
	  var tableNameRowKeys = {};
	  for (var tableName in tableInfo) {
	    tableNameRowKeys[tableName] = [];
	  }AsyncStorage.getAllKeys(function (error, keys) {
	    if (error == null) {
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i];
	        var tableNamePrimaryValue = DBManager.isValidTableEntryForDB(key, tableInfo);
	        if (tableNamePrimaryValue === false) continue;
	
	        tableNameRowKeys[tableNamePrimaryValue.tableName].push(key);
	      }
	    }
	
	    completion(tableNameRowKeys);
	  });
	};
	
	var Table = function () {
	  function Table(tableName, primaryKey, allPrimaryKeyValues) {
	    _classCallCheck(this, Table);
	
	    this._tableName = null;
	    this._primaryKey = null;
	    this._rowKeys = [];
	
	    this._tableName = tableName;
	    this._primaryKey = primaryKey;
	  }
	
	  _createClass(Table, [{
	    key: 'setRowKeys',
	    value: function setRowKeys(rowKeys) {
	      // alert(JSON.stringify(rowKeys));
	      this._rowKeys = rowKeys;
	    }
	
	    //
	    // will overwrite an existing row
	    //
	
	  }, {
	    key: 'set',
	    value: function set(row, completion) {
	      if (typeof row[this._primaryKey] === 'undefined') {
	        row[this._primaryKey] = Math.round(Math.random() * 10000);
	      }
	
	      if (typeof row.id === 'undefined') {
	        row.id = Math.round(Math.random() * 10000);
	      }
	
	      try {
	        var rowString = JSON.stringify(row);
	        var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);
	
	        // alert(fullKey + " " + rowString)
	        var self = this;
	        AsyncStorage.setItem(fullKey, rowString, function (result) {
	          self._rowKeys.push(fullKey);
	          if (completion) completion(result == null || typeof result === 'undefined');
	        });
	        return;
	      } catch (e) {
	        console.log("Error!!! Could not parse row.", row, e);
	        if (completion) completion(false);
	      }
	    }
	
	    //
	    // multiple row set, do not pass in index
	    //
	
	  }, {
	    key: 'setRows',
	    value: function setRows(rows, completion, index) {
	      if (typeof index === 'undefined') index = 0;
	      if (index >= rows.length) {
	        completion();
	        return;
	      }
	
	      // check if there are different keys
	      var shouldClear = rows.length != this._rowKeys.length && this._rowKeys.length > 0;
	      if (!shouldClear && this._rowKeys.length > 0 && rows.length == this._rowKeys.length) {
	        for (var i = 0; i < rows.length; i++) {
	          var rowKey = rows[i][this._primaryKey];
	          var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, rowKey);
	          var foundKey = false;
	          for (var j = 0; j < this._rowKeys.length; j++) {
	            if (this._rowKeys[j] == fullKey) {
	              foundKey = true;
	              break;
	            }
	          }
	          if (!foundKey) {
	            shouldClear = true;
	            break;
	          }
	        }
	      }
	
	      if (shouldClear) {
	        var self = this;
	        this.removeAll(function () {
	          self.setRows(rows, completion, index);
	        });
	        return;
	      }
	
	      var keyValuePairs = [];
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        if (typeof row[this._primaryKey] === 'undefined') {
	          row[this._primaryKey] = Math.round(Math.random() * 10000);
	        }
	
	        if (typeof row.id === 'undefined') {
	          row.id = Math.round(Math.random() * 10000);
	        }
	
	        var rowString = JSON.stringify(row);
	        var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);
	        keyValuePairs.push([fullKey, rowString]);
	        this._rowKeys.pushIfNotExist(fullKey, function (e) {
	          return e == fullKey;
	        });
	      }
	
	      try {
	        var self = this;
	        AsyncStorage.multiMerge(keyValuePairs, function (result) {
	          if (completion) completion(result == null || typeof result === 'undefined');
	        });
	        return;
	      } catch (e) {
	        console.log("Error!!! Could not parse row.", row, e);
	        if (completion) completion(false);
	      }
	
	      this.update(rows[index], function () {
	        self.setRows(rows, completion, index + 1);
	      });
	    }
	
	    //
	    // updates a row if it exists, or adds it if not
	    //
	
	  }, {
	    key: 'update',
	    value: function update(row, completion) {
	      if (typeof row[this._primaryKey] === 'undefined') {
	        row[this._primaryKey] = Math.round(Math.random() * 10000);
	      }
	
	      if (typeof row.id === 'undefined') {
	        row.id = Math.round(Math.random() * 10000);
	      }
	
	      try {
	        var rowString = JSON.stringify(row);
	        var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, row[this._primaryKey]);
	        this._rowKeys.pushIfNotExist(fullKey, function (e) {
	          return e == fullKey;
	        });
	        AsyncStorage.mergeItem(fullKey, rowString, function (error) {
	          completion(error == null || typeof error === 'undefined');
	        });
	        return;
	      } catch (e) {
	        console.log("Error!!! Could not parse row.", row, e);
	        completion(false);
	      }
	    }
	  }, {
	    key: 'get',
	    value: function get(primaryValue, completion) {
	      var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, primaryValue);
	
	      AsyncStorage.getItem(fullKey, function (error, result) {
	        var parsedObj = null;
	        try {
	          parsedObj = JSON.parse(result);
	        } catch (e) {} finally {}
	        completion(parsedObj);
	      });
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll(completion) {
	      AsyncStorage.multiGet(this._rowKeys, function (error, stores) {
	        var rows = [];
	        stores.map(function (result, i, store) {
	          // get at each store's key/value so you can work with it
	          var key = store[i][0];
	          try {
	            var value = JSON.parse(store[i][1]);
	            rows.push(value);
	          } catch (e) {
	            console.log("Error!!!!! getAll parse error", store, key, e);
	          } finally {}
	        });
	        completion(rows);
	      });
	    }
	  }, {
	    key: 'remove',
	    value: function remove(primaryValue, completion) {
	      var fullKey = Table.fullKeyForTableNamePrimaryValue(this._tableName, primaryValue);
	
	      var self = this;
	      AsyncStorage.removeItem(fullKey, function (error) {
	        for (var i = 0; i < self._rowKeys; i++) {
	          if (self._rowKeys[i] == primaryValue) {
	            self._rowKeys.splice(i, 1);
	            break;
	          }
	        }
	        if (completion) completion();
	      });
	    }
	  }, {
	    key: 'removeAll',
	    value: function removeAll(completion) {
	      var self = this;
	      self._rowKeys = [];
	      AsyncStorage.multiRemove(this._rowKeys, function (error) {
	        if (completion) completion();
	      });
	    }
	  }, {
	    key: 'getTableInfoEntry',
	    value: function getTableInfoEntry() {
	      return { tableName: this._tableName, primaryKey: this._primaryKey };
	    }
	  }]);
	
	  return Table;
	}();
	
	Table.fullKeyForTableNamePrimaryValue = function (tableName, primaryValue) {
	  return TABLE_NAME_PREFIX + tableName + TABLE_NAME_PRIMARY_VALUE_SEPARATOR + primaryValue;
	};

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpField = __webpack_require__(26);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	var BundleInfo = __webpack_require__(843);
	
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	
	
	var FeedCard = __webpack_require__(41);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Keyboard = ReactNative.Keyboard,
	    Platform = ReactNative.Platform;
	
	
	var DomainLogin = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      domain: "",
	      username: "",
	      password: "",
	      headerImageMargin: new Animated.Value(20)
	    };
	  },
	
	  _keyboardWillShowSubscription: null,
	  _keyboardWillHideSubscription: null,
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var thisThing = this;
	    this.props.appManager.getLastDomainEmail(function (domainEmailArray) {
	      if (domainEmailArray == null || domainEmailArray.length != 2) {} else {
	        thisThing.props.appManager.getCurrentUser(function (currentUser) {
	          thisThing.setState({ domain: domainEmailArray[0], username: domainEmailArray[1] });
	          if (currentUser && currentUser != null) {
	            thisThing.props.appManager._domain = domainEmailArray[0];
	            thisThing.props.appActions.requestFeatureName("TransactionScan", {}, false);
	          }
	        });
	      }
	    });
	
	    this._keyboardWillShowSubscription = Keyboard.addListener('keyboardDidShow', function (e) {
	      return _this._keyboardWillShow(e);
	    });
	    this._keyboardWillHideSubscription = Keyboard.addListener('keyboardDidHide', function (e) {
	      return _this._keyboardWillHide(e);
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._keyboardWillShowSubscription.remove();
	    this._keyboardWillHideSubscription.remove();
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	
	  _keyboardWillShow: function _keyboardWillShow(e) {
	    var newHeight = this.state.layout.height - e.endCoordinates.height;
	    var headerImageMargin = Math.max(-58, Math.min(20, newHeight - 380));
	
	    Animated.spring(this.state.headerImageMargin, {
	      toValue: headerImageMargin,
	      friction: 6
	    }).start();
	  },
	
	  _keyboardWillHide: function _keyboardWillHide(e) {
	    Animated.spring(this.state.headerImageMargin, {
	      toValue: 20,
	      friction: 6
	    }).start();
	  },
	
	  _showPassword: false,
	  _currentPassword: "",
	  _newPassword: "",
	  _currentPasswordError: false,
	  _newPasswordError: false,
	  showChangePass: function showChangePass() {
	    var _this2 = this;
	
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locManager = thisThing.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	
	    var locMan = appManager.getLocalizationManager();
	    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	    var newPassDescription = locMan.localizedStringForKey("SET_NEW_PASSWORD_STATEMENT");
	    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
	    var currPass = appManager.currentUser()[ModelConstants.Password];
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          ReUpText,
	          { appManager: typeof appManager === 'undefined' ? null : appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	          locMan.localizedStringForKey("CHANGE_PASS_STATEMENT")
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: typeof appManager === 'undefined' ? null : appManager, style: { marginTop: 10, textAlign: 'center' } },
	          newPassDescription
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row' } },
	          React.createElement(ReUpField, {
	            onChangeText: function onChangeText(text) {
	              _this2._newPassword = text;
	            },
	            key: 'password',
	            ref: function ref(a) {
	              return thisThing._passwordField = a;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor, fontFamily: 'Arial' },
	            appManager: appManager,
	            placeholder: newPassPlaceholder,
	            secureTextEntry: !this._showPassword,
	            style: [{ marginRight: 4 }] }),
	          React.createElement(
	            MKIconToggle,
	            {
	              style: [{ marginTop: 10 }, { marginTop: 22, height: 30, width: 30 }],
	              checked: this._showPassword,
	              onCheckedChange: function onCheckedChange(info) {
	                thisThing._passwordField.onBlur();
	                thisThing._showPassword = info.checked;
	                thisThing.showChangePass();
	              }
	            },
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	          )
	        ),
	        React.createElement(ReUpButton, { onPress: function onPress() {
	            appActions.hideAlert();
	            if (appManager.isValidPassword(thisThing._newPassword)) {
	              thisThing.changePassword(thisThing._newPassword);
	            } else {
	              appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showChangePass], function () {});
	            }
	          }, appManager: this.props.appManager, text: changePasswordButton, style: [styles.logoutButton, { marginTop: 10, marginBottom: 10 }] })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {
	      appActions.requestPop(true);
	    });
	  },
	
	  changePassword: function changePassword(newPass) {
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locMan = appManager.getLocalizationManager();
	    var changingPassword = locMan.localizedStringForKey("SAVING_HUD");
	    thisThing.props.appActions.setSpinnerShown(true, changingPassword);
	    NetworkManager.changePassword(this.props.appManager, newPass, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var user = appManager.getCurrentUser(function (currentUser) {
	        currentUser[ModelConstants.Password] = newPass;
	        appManager.setCurrentUser(currentUser, function () {
	          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
	          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
	          var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	
	          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function () {
	            thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	          }], function () {
	            appActions.setSpinnerShown(false);appActions.requestPop(true);
	          });
	        });
	      });
	    }, function (data) {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
	      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
	      var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	
	      thisThing.props.appActions.showAlert(title, body, [okayButton], [function () {
	        thisThing.showChangePass();
	      }], function () {
	        thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	      });
	    }, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      thisThing.props.appActions.showNetworkErrorAlert(function () {
	        thisThing.showChangePass();
	      }, function () {
	        thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	      });
	    });
	  },
	
	  _lastDoubleTouch: -1,
	  _doubleTouchCount: 0,
	  MULTI_TOUCH_TIME_THRESHOLD: 500,
	  DEBUG_MENU_NUMBER_OF_TOUCHES: 5,
	  showDebugIfEnoughTouches: function showDebugIfEnoughTouches(timestamp) {
	    // touch too long, reset
	    if (this._lastDoubleTouch > 0 && timestamp - this._lastDoubleTouch > this.MULTI_TOUCH_TIME_THRESHOLD) {
	      this._doubleTouchCount = 0;
	      this._lastDoubleTouch = -1;
	    }
	
	    // show info
	    this._doubleTouchCount++;
	    if (this._doubleTouchCount >= this.DEBUG_MENU_NUMBER_OF_TOUCHES) {
	      this._doubleTouchCount = 0;
	      this._lastDoubleTouch = -1;
	      var appManager = this.props.appManager;
	      var resourceInfo = appManager.getResourceInfo();
	      this.props.appActions.setCustomAlertShown(true, React.createElement(
	        View,
	        null,
	        React.createElement(
	          Text,
	          { style: { fontSize: 12 } },
	          "Bundle Info\n\n" + BundleInfo + "\nResource Info\n\n" + resourceInfo
	        )
	      ));
	      return;
	    }
	
	    this._lastDoubleTouch = timestamp;
	  },
	
	  doLogin: function doLogin() {
	    Keyboard.dismiss();
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    var loggingIn = appManager.getLocalizationManager().localizedStringForKey("LOGIN_HUD");
	    appActions.setSpinnerShown(true, loggingIn);
	    NetworkManager.domainLogin(appManager, thisThing.state.domain, thisThing.state.username, thisThing.state.password, function (data) {
	      if (data.Admin != "1") {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("NON_AMIN_USER_ALERT_TITLE", "NON_AMIN_USER_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	        return;
	      }
	      appManager.setLastDomainEmail([thisThing.state.domain, thisThing.state.username], function () {
	        data[ModelConstants.Password] = thisThing.state.password;
	        appManager.setCurrentUser(data, function () {
	          appActions.setSpinnerShown(false);
	          if (data[ModelConstants.DirtyPassword] == 1) {
	            thisThing.showChangePass();
	          } else {
	            setTimeout(function () {
	              thisThing.setState({ password: "" }), 1000;
	            });
	            thisThing.props.appActions.requestFeatureName("TransactionScan");
	          }
	        });
	      });
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      if (data.code == -23) // not verified
	        {
	          appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function () {
	            appActions.setSpinnerShown(true, "");
	            NetworkManager.resendVerifyEmail(appManager, thisThing.state.username, function () {
	              appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              appActions.setSpinnerShown(false);
	            }, function () {
	              appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              appActions.setSpinnerShown(false);
	            }, function () {
	              appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	              appActions.setSpinnerShown(false);
	            });
	          }], appActions.hideAlert);
	        } else {
	        appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	      }
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	    });
	  },
	
	  render: function render() {
	    var _this3 = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var subdomainPlaceholder = locManager.localizedStringForKey("SUBDOMAIN_PLACEHOLDER");
	    var emailPlaceholder = locManager.localizedStringForKey("EMAIL_PLACEHOLDER");
	    var passwordPlaceholder = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER_SIMPLE");
	    var loginButton = locManager.localizedStringForKey("LOGIN_BUTTON");
	    var appActions = this.props.appActions;
	    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
	    var thisThing = this;
	
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	    var headerImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/header.png");
	
	    var fieldWidth = this.state.layout.width - 100;
	
	    return React.createElement(
	      View,
	      { style: [styles.container] },
	      React.createElement(View, {
	        style: [styles.image, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }]
	      }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: function ref(a) {
	            if (a != null) a.setRefreshEnabled(false);
	          }, bounces: false, responder: this },
	        React.createElement(
	          Animated.View,
	          { style: { width: 150, alignSelf: 'center', marginTop: this.state.headerImageMargin } },
	          React.createElement(Image, { key: appManager.getImageKey("header"), onStartShouldSetResponder: function onStartShouldSetResponder(evt) {
	              if (evt.nativeEvent.identifier == 2 || Platform.OS != "ios" && evt.nativeEvent.identifier == 1) thisThing.showDebugIfEnoughTouches(evt.nativeEvent.timestamp);
	            },
	            style: { width: 150, height: 78 },
	            source: { uri: headerImage }
	          })
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', margin: 10, borderRadius: 10, backgroundColor: 'white' } },
	          React.createElement(
	            View,
	            { style: { margin: 10 } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', alignItems: 'center' } },
	              React.createElement(ReUpField, {
	                key: "Domain" + fieldWidth,
	                appManager: appManager,
	                onChangeText: function onChangeText(text) {
	                  thisThing.setState({ domain: text });
	                },
	                placeholder: subdomainPlaceholder,
	                autoCapitalize: 'none',
	                autoCorrect: false,
	                style: [{
	                  flex: 1,
	                  width: -1,
	                  height: 50,
	                  marginTop: 10
	                }],
	                value: thisThing.state.domain,
	                onSubmitEditing: function onSubmitEditing() {
	                  return _this3.refs["email"].focus();
	                } })
	            ),
	            React.createElement(ReUpField, {
	              ref: 'email',
	              key: "Email" + fieldWidth,
	              appManager: appManager,
	              onChangeText: function onChangeText(text) {
	                thisThing.setState({ username: text });
	              },
	              placeholder: emailPlaceholder,
	              autoCapitalize: 'none',
	              autoCorrect: false,
	              keyboardType: 'email-address',
	              style: [{
	                flex: 1,
	                width: -1,
	                height: 50,
	                marginTop: 10
	              }],
	              value: thisThing.state.username,
	              onSubmitEditing: function onSubmitEditing() {
	                return _this3.refs["password"].focus();
	              } }),
	            React.createElement(ReUpField, {
	              ref: 'password',
	              key: "Password" + fieldWidth,
	              appManager: appManager,
	              onChangeText: function onChangeText(text) {
	                thisThing.setState({ password: text });
	              },
	              placeholder: passwordPlaceholder,
	              secureTextEntry: true,
	              returnKeyType: "done",
	              style: [{
	                flex: 1,
	                width: -1,
	                height: 50,
	                marginTop: 10
	              }],
	              value: thisThing.state.password,
	              onSubmitEditing: this.doLogin })
	          )
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	          appManager: appManager,
	          text: loginButton,
	          onPress: this.doLogin
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	DomainLogin.dataDependencies = [];
	
	module.exports = DomainLogin;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var Globals = __webpack_require__(10);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpTabBar = __webpack_require__(74);
	
	var EarnPay = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      visibleFeature: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", .6);
	    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var shouldShowCheckInFirst = typeof this.props.extras !== 'undefined' && typeof this.props.extras.showCheckInFirst !== 'undefined' && this.props.extras.showCheckInFirst;
	    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;
	
	    return React.createElement(
	      View,
	      { clipToSubviews: true, style: { flex: 1, backgroundColor: generalColor, alignSelf: 'stretch', borderRadius: borderRadius, overflow: 'hidden', flexDirection: 'column' },
	        onLayout: function onLayout(evt) {
	          thisThing.setState({ layout: { width: evt.nativeEvent.layout.width, height: evt.nativeEvent.layout.height } });
	        } },
	      React.createElement(
	        View,
	        { style: { flex: 1, overflow: 'hidden', marginTop: Globals.TAB_BAR_HEIGHT } },
	        this.state.visibleFeature
	      ),
	      React.createElement(
	        View,
	        { style: { position: 'absolute', top: this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left: 0, right: 0, height: Globals.TAB_BAR_HEIGHT } },
	        React.createElement(ReUpTabBar, {
	          style: { flex: 1, alignSelf: 'stretch' },
	          textColor: generalTitleColor,
	          barColor: iconColor,
	          rippleColor: rippleColor,
	          iconColor: iconColor,
	          layout: this.state.layout,
	          canDismiss: false,
	          initialTabSelected: shouldShowCheckInFirst ? 1 : 0,
	          showFeature: function showFeature(feature) {
	            var layout = { width: thisThing.state.layout.width, height: thisThing.state.layout.height - 40 - (thisThing.props.extras && thisThing.props.extras.shouldHideActionBar ? Globals.ACTION_BAR_HEIGHT : 0) };
	            var featureView = appActions.featureForData(feature, layout, appManager, thisThing.props.extras);
	            thisThing.setState({ visibleFeature: featureView });
	          },
	          hideFeature: function hideFeature() {},
	          buttonFeatures: [appManager.getFeatureForName("UseCredit"), appManager.getFeatureForName("CheckIn")]
	        })
	      )
	    );
	  }
	});
	
	EarnPay.dataDependencies = [];
	
	module.exports = EarnPay;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var ReUpField = __webpack_require__(26);
	var MKSegmentControl = __webpack_require__(36);
	var NetworkManager = __webpack_require__(15);
	var ArcMeter = __webpack_require__(58);
	var FadingView = __webpack_require__(51);
	
	var MK = __webpack_require__(14);
	
	var Share = __webpack_require__(853);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet,
	    Easing = ReactNative.Easing;
	
	
	var EarnPoints = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {},
	      referTitle: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      campaigns: [],
	      useCreditCampaign: null,
	      referCampaign: null,
	      checkInCampaign: null,
	      transferLoyaltyCampaign: null,
	      vipCampaign: null,
	      birthdayCampaign: null,
	      starZoom: new Animated.Value(1)
	    };
	  },
	
	  _didShowTransferLoyalty: false,
	  componentDidMount: function componentDidMount() {
	    if (this.props.extras && this.props.extras.shouldShowTransfer) {
	      if (this.state.transferLoyaltyCampaign != null) this.showLoyaltyTransfer();
	    } else if (this.props.extras && this.props.extras.shouldShowVIP) {
	      if (this.state.vipCampaign != null) this.showVIPProgress({ Blob: this.state.vipCampaign });
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Campaigns !== 'undefined') {
	      var useCreditCampaign = null;
	      var referCampaign = null;
	      var checkInCampaign = null;
	      var transferLoyaltyCampaign = null;
	      var vipCampaign = null;
	      var birthdayCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        try {
	          var campaign = data.Campaigns[i];
	          if (campaign.Type == "UseCredit") useCreditCampaign = JSON.parse(campaign.CampaignBlob);
	          if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	          if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	          if (campaign.Type == "TransferLoyalty") transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
	          if (campaign.Type == "VIP") vipCampaign = JSON.parse(campaign.CampaignBlob);
	          if (campaign.Type == "Birthday") birthdayCampaign = JSON.parse(campaign.CampaignBlob);
	        } catch (e) {}
	      }
	      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
	      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
	      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0};
	      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};
	      if (!this._didShowTransferLoyalty && this.props.extras && this.props.extras.shouldShowTransfer && transferLoyaltyCampaign) {
	        this.state.transferLoyaltyCampaign = transferLoyaltyCampaign;
	        this.showLoyaltyTransfer();
	      } else if (!this._didShowVIPProgress && this.props.extras && this.props.extras.shouldShowVIP && vipCampaign) {
	        this.state.vipCampaign = vipCampaign;
	        this.showVIPProgress({ Blob: vipCampaign });
	      }
	
	      this.setState({
	        campaigns: data.Campaigns,
	        useCreditCampaign: useCreditCampaign,
	        referCampaign: referCampaign,
	        checkInCampaign: checkInCampaign,
	        transferLoyaltyCampaign: transferLoyaltyCampaign,
	        vipCampaign: vipCampaign,
	        birthdayCampaign: birthdayCampaign
	      });
	    }
	  },
	
	  _isLoyaltyingEmail: true,
	  _loyaltyTransferEmail: "",
	  _loyaltyTransferPhone1: "",
	  _loyaltyTransferPhone2: "",
	  _loyaltyTransferPhone3: "",
	  _loyaltyLabels: [],
	  _loyaltyTransferTabSelected: [],
	  _loyaltyTransferPhoneIndex: 0,
	  _loyaltyTransferEmailIndex: 0,
	  _loyaltyTransferExternalIDIndex: 0,
	  showLoyaltyTransfer: function showLoyaltyTransfer() {
	    var _this = this;
	
	    this._didShowTransferLoyalty = true;
	
	    var locMan = this.props.appManager.getLocalizationManager();
	    this._loyaltyTransferEmail = "";
	    this._loyaltyTransferPhone = "";
	    var modes = this.state.transferLoyaltyCampaign.Modes;
	    this._loyaltyLabels = [];
	    this._loyaltyTransferTabSelected = [];
	    var showSwitch = modes.length > 1;
	    if (modes.length <= 0) return;
	
	    for (var i = 0; i < modes.length; i++) {
	      if (modes[i] == "p") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("PHONE_OPTION"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferPhone(showSwitch);
	        });
	        this._loyaltyTransferPhoneIndex = i;
	      } else if (modes[i] == "e") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("EMAIL_OPTION"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferEmail(showSwitch);
	        });
	        this._loyaltyTransferEmailIndex = i;
	      } else if (modes[i] == "i") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("CARDID_OPTION", "Card ID"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferExternalID(showSwitch);
	        });
	        this._loyaltyTransferExternalIDIndex = i;
	      }
	    }
	    if (modes[0] == "p") {
	      this.showLoyaltyTransferPhone(showSwitch);
	    } else if (modes[0] == "e") {
	      this.showLoyaltyTransferEmail(showSwitch);
	    } else if (modes[0] == "i") {
	      this.showLoyaltyTransferExternalID(showSwitch);
	    }
	  },
	
	  showLoyaltyTransferEmail: function showLoyaltyTransferEmail(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingEmail = true;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
	    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          selectedIndex: thisThing._loyaltyTransferEmailIndex,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: styles.alertInnerContainer },
	          React.createElement(ReUpField, {
	            ref: function ref(a) {
	              thisThing._loyaltyTransferEmailField = a;if (a != null) a.focus();
	            },
	            key: 'email',
	            appManager: appManager,
	            keyboardType: "email-address",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferEmail = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: emailLabel,
	            floatingLabelEnabled: true,
	            floatingLabelAniDuration: .1,
	            returnKeyType: "done",
	            onSubmitEditing: thisThing.submitEmail,
	            style: { flex: 1 } })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitEmail
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitEmail: function submitEmail() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var extras = this.props.extras;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.UserID;
	    var locManager = appManager.getLocalizationManager();
	
	    thisThing._loyaltyTransferEmailField.setIsInError(!appManager.isValidEmail(thisThing._loyaltyTransferEmail));
	    if (appManager.isValidEmail(thisThing._loyaltyTransferEmail)) {
	      thisThing._loyaltyTransferEmailField.setIsInError(false);
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.transferLoyaltyCampaign(appManager, thisThing._loyaltyTransferEmail, "", "", function (data) {
	        appActions.setSpinnerShown(false);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
	        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
	        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
	        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody, [okButton], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    } else {
	      thisThing._loyaltyTransferEmailField.setIsInError(true);
	    }
	  },
	
	  showLoyaltyTransferPhone: function showLoyaltyTransferPhone(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingEmail = false;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
	    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	
	    var phoneSeparators = ["(", ") ", " - "];
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          selectedIndex: thisThing._loyaltyTransferPhoneIndex,
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: [styles.alertInnerContainer, { paddingRight: 8, alignItems: 'center', height: 70, justifyContent: 'center' }] },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { marginTop: 26, padding: 4 } },
	            phoneSeparators[0]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone1 = a;if (a != null) a.focus();
	            },
	            key: 'phone1',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone1 = text;if (text.length >= 3) thisThing._phone2.focus();
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "###",
	            maxLength: 3,
	            style: [styles.textField, { width: 45 }] }),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { flex: -1, marginTop: 26, padding: 4 } },
	            phoneSeparators[1]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone2 = a;
	            },
	            key: 'phone2',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone2 = text;if (text.length >= 3) thisThing._phone3.focus();
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "###",
	            maxLength: 3,
	            style: [styles.textField, { width: 45 }] }),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { flex: -1, marginTop: 26, padding: 4 } },
	            phoneSeparators[2]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone3 = a;
	            },
	            key: 'phone3',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone3 = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "####",
	            maxLength: 4,
	            onSubmitEditing: thisThing.submitPhone,
	            returnKeyType: "done",
	            style: [styles.textField, { width: 65 }] })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitPhone
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitPhone: function submitPhone() {
	    var thisThing = this;
	    var extras = this.props.extras;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var userID = this.props.extras.UserID;
	
	    thisThing._phone1.setIsInError(thisThing._loyaltyTransferPhone1.length != 3);
	    thisThing._phone2.setIsInError(thisThing._loyaltyTransferPhone2.length != 3);
	    thisThing._phone3.setIsInError(thisThing._loyaltyTransferPhone3.length != 4);
	    thisThing._loyaltyTransferPhone = thisThing._loyaltyTransferPhone1 + thisThing._loyaltyTransferPhone2 + thisThing._loyaltyTransferPhone3;
	
	    if (thisThing._loyaltyTransferPhone1.length == 3 && thisThing._loyaltyTransferPhone2.length == 3 && thisThing._loyaltyTransferPhone3.length == 4) {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.transferLoyaltyCampaign(appManager, "", thisThing._loyaltyTransferPhone, "", function (data) {
	        appActions.setSpinnerShown(false);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
	        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
	        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
	        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody, [okButton], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    }
	  },
	
	  _loyaltyTransferExternalID: "",
	  showLoyaltyTransferExternalID: function showLoyaltyTransferExternalID(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingExternalID = true;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	    var externalIDLabel = locMan.localizedStringForKey("CARDID_OPTION", "Card ID");
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          selectedIndex: thisThing._loyaltyTransferExternalIDIndex,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: styles.alertInnerContainer },
	          React.createElement(ReUpField, {
	            ref: function ref(a) {
	              thisThing._loyaltyTransferExternalIDField = a;if (a != null) a.focus();
	            },
	            key: 'externalID',
	            appManager: appManager,
	            autoCapitalize: "none",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferExternalID = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: externalIDLabel,
	            floatingLabelEnabled: true,
	            floatingLabelAniDuration: .1,
	            returnKeyType: "done",
	            onSubmitEditing: thisThing.submitExternalID,
	            style: { flex: 1 } })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitExternalID
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitExternalID: function submitExternalID() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var extras = this.props.extras;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.UserID;
	    var locManager = appManager.getLocalizationManager();
	
	    var isValidExternalID = thisThing._loyaltyTransferExternalID.length > 0;
	    thisThing._loyaltyTransferExternalIDField.setIsInError(!isValidExternalID);
	    if (isValidExternalID) {
	      thisThing._loyaltyTransferExternalIDField.setIsInError(false);
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.transferLoyaltyCampaign(appManager, "", "", thisThing._loyaltyTransferExternalID, function (data) {
	        appActions.setSpinnerShown(false);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var transferLoyaltyAlertTitle = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "Failure");
	        var transferLoyaltyAlertBody = locManager.localizedStringForKey("TRANSFER_LOYALTY_FAIL_ALERT_BODY", "This loyalty account either does not exist or has already been consumed.");
	        var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
	        thisThing.props.appActions.showAlert(transferLoyaltyAlertTitle, transferLoyaltyAlertBody, [okButton], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    } else {
	      thisThing._loyaltyTransferExternalIDField.setIsInError(true);
	    }
	  },
	
	  _didShowVIPProgress: false,
	  showVIPProgress: function showVIPProgress(campaign) {
	    this._didShowVIPProgress = true;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var generalColor = !appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
	    var generalTitleColor = appManager.shouldInvertColorOnFeedPlus() ? appManager.getColorForKey("GeneralColor") : appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	
	    var titleStyle = { marginTop: 10, textAlign: 'center', generalTitleColor: generalTitleColor };
	    var bodyStyle = { textAlign: 'center', margin: 50, generalColor: generalColor };
	
	    var title = locMan.localizedStringForKey("VIP_ALERT_TITLE", "VIP Progress");
	    var multiplier = (1 / campaign.Blob.DollarsPerPointMultiplier).toFixed(1);
	    var progress = parseFloat(parseInt(campaign.Blob.ProgressPoints) / parseInt(campaign.Blob.GoalPoints));
	    var isVIP = parseInt(campaign.Blob.ProgressPoints) >= parseInt(campaign.Blob.GoalPoints);
	    var remainder = locMan.localizedPoints(parseInt(campaign.Blob.GoalPoints) - parseInt(campaign.Blob.ProgressPoints));
	    var body = isVIP ? locMan.localizedStringForKeyAndParams("VIP_COMPLETE_STATEMENT", [multiplier], "You now earn %0%x points!") : locMan.localizedStringForKeyAndParams("VIP_PROGRESS_STATEMENT", [remainder], "Earn %0% more from purchases to be a VIP!");
	    var buttonText = locMan.localizedStringForKey("GOT_IT_ALERT_BUTTON");
	    var dimension = this.state.layout.width - 100;
	    if (isVIP) bodyStyle.color = profileMeterColor;
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        { style: { alignItems: 'center', flexDirection: 'column', justifyContent: 'center', padding: 10 } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: titleStyle },
	          title
	        ),
	        isVIP ? React.createElement(ArcMeter, { appManager: appManager,
	          fgColor: profileMeterColor, bgColor: profileMeterBackgroundColor,
	          dimension: dimension, thickness: 20, percentage: 1,
	          children: React.createElement(
	            FadingView,
	            { ref: function ref(a) {
	                if (a != null) {
	                  setTimeout(function () {
	                    return a.setFadedOut(false);
	                  }, 500);
	                  setTimeout(function () {
	                    Animated.timing(thisThing.state.starZoom, { toValue: 1.3,
	                      duration: 300,
	                      easing: Easing.out(Easing.ease) }).start(function () {
	                      Animated.timing(thisThing.state.starZoom, { toValue: 1,
	                        duration: 300,
	                        easing: Easing.in(Easing.ease) }).start(function () {});
	                    });
	                  }, 500);
	                }
	              }, style: bodyStyle, animDuration: 1000 },
	            React.createElement(
	              Animated.View,
	              { style: { width: dimension / 2, height: dimension / 2, alignItems: 'center', justifyContent: 'center', flexDirection: 'column', backgroundColor: 'transparent',
	                  transform: [{ scale: this.state.starZoom }] } },
	              React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', name: "star-o", size: dimension / 2, color: profileMeterColor, style: { backgroundColor: 'transparent', marginTop: Platform.OS == 'web' ? 0 : 18 } }),
	              React.createElement(
	                View,
	                { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { isTitle: true, appManager: appManager, style: { textAlign: 'center', color: profileMeterColor } },
	                  locMan.localizedStringForKey("VIP_BUTTON", "VIP")
	                )
	              )
	            )
	          ) }) : React.createElement(ArcMeter, { appManager: appManager,
	          fgColor: profileMeterColor, bgColor: profileMeterBackgroundColor,
	          dimension: dimension, thickness: 20, percentage: progress,
	          children: React.createElement(
	            View,
	            { style: bodyStyle },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { textAlign: 'center' } },
	              body
	            )
	          ) }),
	        isVIP ? React.createElement(
	          View,
	          { style: { margin: 10 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	            body
	          )
	        ) : null,
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', marginTop: 4 } },
	          React.createElement(ReUpButton, { onPress: thisThing.props.appActions.hideAlert, appManager: appManager, text: buttonText, style: [{ margin: 10, flex: 1 }] })
	        )
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  _referEmail: "",
	  _referFirstName: "",
	  _referLastName: "",
	  _referFullName: "",
	  showRefer: function showRefer() {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var pointsLocalized = locManager.localizedPoints(this.state.referCampaign.ReferrerPoints);
	    var referTitle = this.props.referTitle == null ? locManager.localizedStringForKeyAndParams('REFER_BUTTON') : this.props.referTitle;
	    var bundleID = appManager.getAppData()["Header"]["BundleID"];
	    var link = bundleID.split('.')[2] + ".getreup.com";
	    var body = locManager.localizedStringForKeyAndParams("REFERRAL_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link], "Claim a free %0% towards a reward at %1%! Use referral code %2% to sign up. Download here: %3%");
	
	    var shareOptions = {
	      title: referTitle,
	      subject: "Check out the " + appManager.appName + " app.",
	      message: body
	    };
	
	    Share.open(shareOptions);
	  },
	
	  renderCampaign: function renderCampaign(campaign, index) {
	    var _this2 = this;
	
	    if (!campaign) return null;
	
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	
	    var icon = null;
	    var title = null;
	    var body = null;
	    var onPress = null;
	
	    switch (campaign.Type) {
	      case "UseCredit":
	        {
	          var feature = appManager.getFeatureForName("UseCredit");
	          if (typeof feature === 'undefined') return null;
	          icon = feature.data.icon.replace("fa-", "");
	          title = feature.data.title;
	          var dollarsPerPoint = campaign.Blob.DollarsPerPoint;
	          body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3", [locManager.localizedPoints((1 / dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]) + ('\n\n' + locManager.localizedStringForKey("EXCLUDED_PRODUCTS_STATEMENT"));
	          onPress = function onPress() {
	            appActions.requestFeatureName("UseCredit");
	          };
	        }
	        break;
	
	      case "Referral":
	        {
	          var feature = appManager.getFeatureForName("ReferAFriend");
	          if (typeof feature === 'undefined') return null;
	          icon = feature.data.icon.replace("fa-", "");
	          title = feature.data.title;
	          body = "";
	          if (typeof campaign.Blob.ReferrerPoints !== 'undefined') {
	            var pointsLocalized = locManager.localizedPoints(campaign.Blob.ReferrerPoints);
	            body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT", [pointsLocalized]);
	          } else if (typeof campaign.Blob.RewardName !== 'undefined') {
	            body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT", ["one " + campaign.Blob.RewardName]);
	          }
	          onPress = function onPress() {
	            appActions.requestFeatureName("ReferAFriend");
	          };
	        }
	        break;
	
	      case "Checkin":
	        {
	          var checkInFeatureName = "CheckIn";
	          var feature = appManager.getFeatureForName(checkInFeatureName);
	          if (typeof feature === 'undefined') {
	            checkInFeatureName = "MyCard";
	            feature = appManager.getFeatureForName(checkInFeatureName);
	            if (typeof feature === 'undefined') return null;
	          }
	          icon = feature.data.icon.replace("fa-", "");
	          title = feature.data.title;
	          var dollarsPerPoint = campaign.Blob.DollarsPerPoint;
	
	          body = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3", [locManager.localizedPoints((1 / dollarsPerPoint).toFixed(1)), locManager.localizedDollars(1)]) + ('\n\n' + locManager.localizedStringForKey("EXCLUDED_PRODUCTS_STATEMENT"));
	          onPress = feature.data.disableScan === true ? null : function () {
	            appActions.requestFeatureName(checkInFeatureName);
	          };
	        }
	        break;
	
	      case "TransferLoyalty":
	        {
	          // return null if user has already transferred loyalty
	          if (appManager.isLoggedIn() && appManager.currentUser()["HasTransferredLoyalty"] != "0") return null;
	
	          icon = "exchange";
	          title = locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON", "Transfer Loyalty");
	          body = locManager.localizedStringForKey("LOYALTY_STATEMENT");
	          onPress = function onPress() {
	            thisThing.showLoyaltyTransfer();
	          };
	        }
	        break;
	
	      case "VIP":
	        {
	          // return null if dollars per point is invalid
	          if (typeof campaign.Blob.DollarsPerPointMultiplier === 'undefined' || campaign.Blob.DollarsPerPointMultiplier == 0) return null;
	
	          var multiplier = (1 / campaign.Blob.DollarsPerPointMultiplier).toFixed(1);
	          icon = "smile-o";
	          title = locManager.localizedStringForKey("VIP_BUTTON", "VIP");
	          body = locManager.localizedStringForKeyAndParams("VIP_STATEMENT", [multiplier], "Earn %0%x points as a VIP!");
	          onPress = function onPress() {
	            thisThing.showVIPProgress(campaign);
	          };
	        }
	        break;
	
	      case "Birthday":
	        {
	          var feature = appManager.getFeatureForName("Birthday");
	          if (typeof feature === 'undefined') return null;
	          icon = feature.data.icon.replace("fa-", "");
	          title = feature.data.title;
	          var points = locManager.localizedPoints(campaign.Blob.Points);
	          body = locManager.localizedStringForKeyAndParams("BIRTHDAY_STATEMENT", [points], "Earn %0% for entering your birthday."), onPress = function onPress() {
	            appActions.requestFeatureName("Birthday", { didSetBirthday: _this2.didSetBirthday });
	          };
	        }
	        break;
	
	      default:
	        return null;
	    }
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonSecondaryColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var buttonSecondaryTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	
	    var other = {};
	    if (onPress != null) {
	      other.onPress = onPress;
	      other.icon = "angle-right";
	    }
	
	    return React.createElement(
	      View,
	      { style: { overflow: 'auto' } },
	      React.createElement(
	        ReUpButton,
	        Object.assign({ appManager: appManager, isTertiary: true,
	          iconColor: 'red',
	          maskBorderRadius: 0,
	          style: { backgroundColor: 'transparent', padding: 0, alignSelf: 'stretch', margin: 0, width: -1, height: -1 }
	        }, other),
	        React.createElement(
	          View,
	          { style: { flex: 1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', alignItems: 'center' } },
	            React.createElement(
	              View,
	              { style: { margin: 20, width: 80, height: 80, borderRadius: 40, alignItems: 'center', backgroundColor: buttonPrimaryColor, justifyContent: 'center' } },
	              React.createElement(
	                View,
	                { style: { marginTop: Platform.OS === "web" ? 0 : 5 } },
	                icon != null ? React.createElement(_ReUpIcon2.default, { name: icon, size: 44, color: buttonPrimaryTitleColor }) : null
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { marginRight: 20, flex: 1, flexDirection: 'column' } },
	              React.createElement(
	                View,
	                null,
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor }] },
	                  title
	                )
	              ),
	              React.createElement(View, { style: { height: 4 } }),
	              React.createElement(
	                View,
	                { style: { alignSelf: 'stretch' } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: { color: generalTitleColor } },
	                  body
	                )
	              )
	            )
	          )
	        ),
	        React.createElement(View, { style: {
	            height: 1,
	            position: 'absolute',
	            left: 0, right: 0, bottom: 0,
	            backgroundColor: '#DADADA'
	          } })
	      )
	    );
	  },
	
	  didSetBirthday: function didSetBirthday() {
	    this.setState({ birthdayCampaign: null });
	    if (typeof this.refs.ptr !== 'undefined' && this.refs.ptr != null) this.refs.ptr.doOnlineUpdate();
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var campaignRows = [];
	
	    var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
	    var checkInFeatureData = appManager.getFeatureForName("CheckIn");
	    var myCardFeatureData = appManager.getFeatureForName("MyCard");
	    var referTitle = this.props.referTitle == null ? locManager.localizedStringForKeyAndParams('REFER_BUTTON') : this.props.referTitle;
	    var referralCodeStatement = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + ": " + user.ReferralCode;
	
	    if (this.state.useCreditCampaign != null && typeof useCreditFeatureData !== 'undefined') campaignRows.push({ Type: "UseCredit", Blob: this.state.useCreditCampaign });
	    if (this.state.checkInCampaign != null && (typeof checkInFeatureData !== 'undefined' || typeof myCardFeatureData !== 'undefined')) campaignRows.push({ Type: "Checkin", Blob: this.state.checkInCampaign });
	    if (this.state.birthdayCampaign != null) campaignRows.push({ Type: "Birthday", Blob: this.state.birthdayCampaign });
	    if (this.state.vipCampaign != null) campaignRows.push({ Type: "VIP", Blob: this.state.vipCampaign });
	    if (this.state.referCampaign != null) campaignRows.push({ Type: "Referral", Blob: this.state.referCampaign });
	    if (this.state.transferLoyaltyCampaign != null) campaignRows.push({ Type: "TransferLoyalty", Blob: this.state.transferLoyaltyCampaign });
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, featureName: 'EarnPoints', isEmpty: campaignRows.length <= 0, responder: this },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [{ margin: 10, color: instructionTitleColor }] },
	              pointsLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: this.props.appActions,
	            alertMessage: typeof this.props.featureData.instructions2 === 'undefined' ? null : this.props.featureData.instructions2
	          })
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        campaignRows.map(function (campaignRow, index) {
	          return thisThing.renderCampaign(campaignRow, index);
	        })
	      )
	    );
	  }
	});
	
	EarnPoints.getCards = function (featureData, appActions, data) {
	  if (typeof data.Campaigns === 'undefined') return [];
	  var appManager = appActions._appManager;
	  var locManager = appManager.getLocalizationManager();
	  var isLoggedIn = appManager.isLoggedIn();
	
	  var useCreditCampaign = null;
	  var referCampaign = null;
	  var checkInCampaign = null;
	  var transferLoyaltyCampaign = null;
	  var vipCampaign = null;
	  var birthdayCampaign = null;
	  for (var i = 0; i < data.Campaigns.length; i++) {
	    var campaign = data.Campaigns[i];
	    if (campaign.Type == "UseCredit") useCreditCampaign = JSON.parse(campaign.CampaignBlob);
	    if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	    if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	    if (campaign.Type == "TransferLoyalty") transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
	    if (campaign.Type == "VIP") vipCampaign = JSON.parse(campaign.CampaignBlob);
	    if (campaign.Type == "Birthday") birthdayCampaign = JSON.parse(campaign.CampaignBlob);
	  }
	
	  var cardCampaigns = [];
	  if (useCreditCampaign != null) {
	    var useCreditFeatureData = appManager.getFeatureForName("UseCredit");
	    var dollarsPerPoint = useCreditCampaign.DollarsPerPoint;
	    cardCampaigns.push({
	      didSelect: function didSelect() {
	        appActions.requestFeatureName("UseCredit");
	      },
	      iconName: useCreditFeatureData.data.icon.replace("fa-", ""),
	      title: useCreditFeatureData.data.title,
	      body: locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3", [locManager.localizedPoints(Math.round(1 / dollarsPerPoint)), locManager.localizedDollars(1)])
	    });
	  }
	  if (referCampaign != null) {
	    var pointsLocalized = locManager.localizedPoints(referCampaign.ReferrerPoints);
	    var referaFeatureData = appManager.getFeatureForName("ReferAFriend");
	    cardCampaigns.push({
	      didSelect: function didSelect() {
	        appActions.requestFeatureName("ReferAFriend");
	      },
	      iconName: referaFeatureData.data.icon.replace("fa-", ""),
	      title: referaFeatureData.data.title,
	      body: pointsLocalized
	    });
	  }
	  if (checkInCampaign != null) {
	    var checkInFeatureData = appManager.getFeatureForName("CheckIn");
	    var myCardFeatureData = appManager.getFeatureForName("MyCard");
	    var thisFeature = typeof checkInFeatureData !== 'undefined' ? checkInFeatureData : myCardFeatureData;
	    var thisFeatureName = typeof checkInFeatureData !== 'undefined' ? "CheckIn" : "MyCard";
	    var dollarsPerPoint = checkInCampaign.DollarsPerPoint;
	    cardCampaigns.push({
	      didSelect: function didSelect() {
	        appActions.requestFeatureName(thisFeatureName);
	      },
	      iconName: thisFeature.data.icon.replace("fa-", ""),
	      title: thisFeature.data.title,
	      body: locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT_3", [locManager.localizedPoints(Math.round(1 / dollarsPerPoint)), locManager.localizedDollars(1)])
	    });
	  }
	  if (transferLoyaltyCampaign != null) {
	    if (!appManager.isLoggedIn() || appManager.currentUser()["HasTransferredLoyalty"] == "0") {
	      cardCampaigns.push({
	        didSelect: function didSelect() {
	          appActions.requestFeatureName("EarnPoints", { shouldShowTransfer: true });
	        },
	        iconName: "exchange",
	        title: locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON", "Transfer Loyalty"),
	        body: locManager.localizedStringForKey("LOYALTY_STATEMENT")
	      });
	    }
	  }
	  if (vipCampaign != null) {
	    var multiplier = (1 / vipCampaign.DollarsPerPointMultiplier).toFixed(1);
	    cardCampaigns.push({
	      didSelect: function didSelect() {
	        appActions.requestFeatureName("EarnPoints", { shouldShowVIP: true });
	      },
	      iconName: "smile-o",
	      title: locManager.localizedStringForKey("VIP_BUTTON", "VIP"),
	      body: locManager.localizedStringForKeyAndParams("VIP_STATEMENT", [multiplier], "Earn %0%x points per dollar as a VIP!")
	    });
	  }
	  if (birthdayCampaign != null) {
	    var feature = appManager.getFeatureForName("Birthday");
	    if (typeof feature !== 'undefined') {
	      var points = locManager.localizedPoints(birthdayCampaign.Points);
	      cardCampaigns.push({
	        didSelect: function didSelect() {
	          appActions.requestFeatureName("Birthday", { didSetBirthday: function didSetBirthday() {
	              for (var i = 0; i < data.Campaigns.length; i++) {
	                var campaign = data.Campaigns[i];
	                if (campaign.Type == "Birthday") {
	                  // remove bday and set data
	                  delete data.Campaigns[i];
	                  appManager.setData({ Campaigns: data.Campaigns });
	                }
	              }
	              NetworkManager.update(appManager, ["Campaigns"], function () {}, function () {});
	            } });
	        },
	        iconName: feature.data.icon.replace("fa-", ""),
	        title: feature.data.title,
	        body: locManager.localizedStringForKeyAndParams("BIRTHDAY_STATEMENT", [points], "Earn %0% for entering your birthday.")
	      });
	    }
	  }
	
	  var iconName = featureData.data.icon.replace("fa-", "");
	  if (cardCampaigns.length > 0) {
	    return [{
	      title: featureData.data.title,
	      icon: iconName,
	      cardType: 11,
	      sortOrder: 24 * 60 * 60 * 1000,
	      campaigns: cardCampaigns
	    }];
	  }
	
	  var didSelect = function didSelect() {
	    appActions.requestFeatureName("EarnPoints");
	  };
	  var body = featureData.data.tip;
	
	  if (useCreditCampaign != null) body = featureData.data.instructions2;else if (referCampaign != null) {
	    var pointsLocalized = locManager.localizedPoints(referCampaign.ReferrerPoints);
	    body = locManager.localizedStringForKey("EARN_POINTS_STATEMENT_2", pointsLocalized);
	  } else if (checkInCampaign != null) {
	    body = locManager.localizedStringForKey("CHECK_IN_STATEMENT");
	  } else if (transferLoyaltyCampaign != null) {
	    body = locManager.localizedStringForKey("LOYALTY_STATEMENT");
	  }
	
	  var sortOrder = 24 * 60 * 60 * 1000;
	  if (isLoggedIn && typeof data.Transactions !== 'undefined' && data.Transactions.length > 0) {
	    var transaction = data.Transactions[0];
	    var date = transaction.Timestamp;
	    var thisDateTime = appManager.getTime(date);
	    sortOrder = new Date().getTime() - thisDateTime - 10;
	  }
	
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: body,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: 24 * 60 * 60 * 1000
	  }];
	};
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  image: {
	    position: 'absolute',
	    flex: 1
	  },
	  profileImage: {
	    height: 80,
	    width: 80,
	    borderRadius: 40,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: 40,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  alertInnerContainer: {
	    paddingTop: 4,
	    paddingLeft: 10,
	    paddingRight: 10,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row'
	  },
	  referTypeContainer: {
	    height: 50,
	    width: 180,
	    alignSelf: 'center'
	  },
	  textField: {
	    flex: 1,
	    height: 50
	  },
	  button: {
	    justifyContent: 'center',
	    flex: 1
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  }
	});
	
	EarnPoints.dataDependencies = ["Users", "Campaigns", "Transactions"];
	
	module.exports = EarnPoints;

/***/ },
/* 1107 */
/***/ function(module, exports) {

	"use strict";
	
	// var AppDispatcher = require('../dispatcher/AppDispatcher');
	
	var currentAppActions = null;
	var configOverride = null;
	
	var ExternalActions = {
	  initialize: function initialize(appActions) {
	    currentAppActions = appActions;
	
	    window.addEventListener("message", this.receiveMessage, false);
	  },
	
	  receiveMessage: function receiveMessage(event) {
	    try {
	      var data = JSON.parse(event.data);
	      switch (data.method) {
	        case "loadFeatureDictionary":
	          currentAppActions._appManager.setFeatureDatas(data.params);
	          currentAppActions._navigator.forceUpdate();
	          break;
	        case "loadColorDictionary":
	          currentAppActions._appManager.setColorDictionary(data.params);
	          currentAppActions._navigator.forceUpdate();
	          break;
	        case "reload":
	          if (typeof data.params !== 'undefined' && currentAppActions != null) currentAppActions._appManager.configOverride = data.params;
	          currentAppActions._navigator.props.restartApp();
	          break;
	        default:
	
	      }
	    } catch (e) {
	      // console.log("parse error", e, event)
	    } finally {}
	  }
	
	};
	
	module.exports = ExternalActions;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var LinkingManager = __webpack_require__(27);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ExternalLink = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  render: function render() {
	    return React.createElement(View, null);
	  }
	});
	
	ExternalLink.getCards = function (featureData, appActions, data) {
	  var didSelect = function didSelect() {
	    ExternalLink.customNavigation(featureData, appActions);
	  };
	
	  var appManager = appActions._appManager;
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var feedSortOrderOffset = featureData.data.feedSortOrder;
	  var feedSortOrder = 0;
	  if (typeof appManager !== 'undefined') {
	    feedSortOrder = new Date().getTime() - appManager.externalLinkDateForFeatureName(featureData.data.name) + feedSortOrderOffset;
	  }
	
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: featureData.data.tip,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: feedSortOrder
	  }];
	};
	
	ExternalLink.customNavigation = function (featureData, appActions) {
	  var url = featureData.data.url;
	  if (url.search("http") != 0) url = "http://" + url;
	
	  var appManager = appActions._appManager;
	  var barTintColor = appManager.getColorForKey("HeaderColor");
	  var tintColor = appManager.getColorForKey("HeaderIconColor");
	
	  LinkingManager.openURL(url, tintColor, barTintColor);
	};
	
	ExternalLink.dataDependencies = [];
	
	module.exports = ExternalLink;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var LinkingManager = __webpack_require__(27);
	var NetworkManager = __webpack_require__(15);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Facebook = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  render: function render() {
	    return React.createElement(View, null);
	  }
	});
	
	Facebook.getCards = function (featureData, appActions, data) {
	  return []; // disabling facebook
	
	  var didSelect = function didSelect() {
	    Facebook.customNavigation(featureData, appActions);
	  };
	  var appManager = appActions._appManager;
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var cards = [];
	  if (typeof data.Facebook !== 'undefined') {
	    data.Facebook = data.Facebook.sort(function (a, b) {
	      return b.created_time - a.created_time;
	    });
	
	    var MAX_FACEBOOK_POSTS = 1;
	    for (var i = 0; i < data.Facebook.length && i < MAX_FACEBOOK_POSTS; i++) {
	      var fb = data.Facebook[i];
	      var message = fb.message;
	      var date = new Date(fb.created_time * 1000);
	      var dateText = appManager.timeSince(date);
	      var sortOrder = new Date().getTime() - fb.created_time * 1000;
	      var attachments = typeof fb.attachments !== 'undefined' ? fb.attachments : [];
	
	      cards.push({
	        key: "fb-" + fb.id,
	        didSelect: didSelect,
	        smallTitle: dateText,
	        body1: message,
	        picture: fb.picture,
	        icon: iconName,
	        cardType: 0,
	        sortOrder: sortOrder
	      });
	    }
	  }
	  return cards;
	};
	Facebook.customNavigation = function (featureData, appActions) {
	  // facebook linking not working on iOS, so just use the URL
	  var facebookURL = "fb://page/" + featureData.data.facebook_user_id;
	  LinkingManager.canOpenURL(facebookURL, function (can) {
	    if (can) {
	      LinkingManager.openURL(facebookURL);
	    } else {
	      var url = "https://www.facebook.com/" + featureData.data.facebook_user_id;
	      var appManager = appActions._appManager;
	      var barTintColor = appManager.getColorForKey("HeaderColor");
	      var tintColor = appManager.getColorForKey("HeaderIconColor");
	
	      LinkingManager.openURL(url, tintColor, barTintColor);
	    }
	  });
	};
	// Facebook.customDependencyKeys = ["Facebook"];
	// Facebook.customDataDependency = function(appManager, completion)
	// {
	//   var featureData = appManager.getFeatureForName("Facebook");
	//   NetworkManager.getFacebookInfo(appManager, featureData.data.facebook_user_id, function(data)
	//   {
	//     appManager.setData({Facebook:data}, function()
	//     {
	//       completion({Facebook:data})
	//     })
	//   }, function(a)
	//   {
	//     completion({})
	//   }, function()
	//   {
	//     completion({})
	//   })
	// }
	
	Facebook.dataDependencies = [];
	
	module.exports = Facebook;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	var _reactNativeParallaxScrollViewWrapper = __webpack_require__(97);
	
	var _reactNativeParallaxScrollViewWrapper2 = _interopRequireDefault(_reactNativeParallaxScrollViewWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppActions = __webpack_require__(63);
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var FadingView = __webpack_require__(51);
	var FeedPlusView = __webpack_require__(111);
	var FeedPlusSideView = __webpack_require__(110);
	var OffsetView = __webpack_require__(93);
	var OverlayView = __webpack_require__(112);
	
	var Icon = __webpack_require__(13);
	var FEED_HEADER_HEIGHT = 80;
	
	var Menu = __webpack_require__(75);
	var FeedCard = __webpack_require__(41);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpCountdown = __webpack_require__(73);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MapView = __webpack_require__(78);
	var ReUpButton = __webpack_require__(12);
	var Meter = __webpack_require__(91);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var View = ReactNative.View,
	    Animated = ReactNative.Animated,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Dimensions = ReactNative.Dimensions,
	    Keyboard = ReactNative.Keyboard,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	var FeedPlus = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    var feedPlusFeatures = this.props.appManager.getFeedPlusFeatures();
	    var shouldAlwaysShowHeader = true;
	    for (var i = 0; i < feedPlusFeatures.length; i++) {
	      if (feedPlusFeatures[i].key != "Login" && feedPlusFeatures[i].key != "CreateUser") {
	        shouldAlwaysShowHeader = false;
	        break;
	      }
	    }
	
	    return {
	      menuOpen: false,
	      rightOpen: false,
	      cards: [],
	      movePlusFront: true,
	      shouldAlwaysShowHeader: shouldAlwaysShowHeader,
	      tempHideLeft: false,
	      tempHideRight: false
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    if (this.refs.scrollView) this.refs.scrollView.scrollTo({ x: this.props.initialLayout.width });
	
	    appActions._drawer = this;
	    var height = 0;
	    var width = 0;
	    var didJigger = false;
	    try {
	      var _Dimensions$get = Dimensions.get('window'),
	          height = _Dimensions$get.height,
	          width = _Dimensions$get.width;
	
	      if (height > 0 && width > 0) {
	        didJigger = true;
	        setTimeout(function () {
	          if (thisThing.refs.scrollView && Platform.OS == "ios") thisThing.refs.scrollView.scrollTo({ x: width - 1 });
	          if (thisThing.refs.scrollView) thisThing.refs.scrollView.scrollTo({ x: width });
	        }, 1);
	      }
	    } catch (e) {} finally {}
	
	    if (!didJigger) {
	      setTimeout(function () {
	        if (thisThing.refs.scrollView) {
	          if (thisThing.refs.scrollView && Platform.OS == "ios") thisThing.refs.scrollView.scrollTo({ x: thisThing.props.initialLayout.width - 1 });
	          if (thisThing.refs.scrollView) thisThing.refs.scrollView.scrollTo({ x: thisThing.props.initialLayout.width });
	        }
	      }, 1);
	    }
	
	    appManager.loginCallBackStart = function () {
	      appActions.requestPop(false);
	      appActions.setSpinnerShown(true, "Logging in...");
	      appManager.getCurrentUser(function (a) {
	        thisThing.checkUserChanged();
	      });
	    };
	    appManager.loginCallBackFinish = function () {
	      appActions.requestPop(false);
	      appActions.setSpinnerShown(false);
	      appManager.getCurrentUser(function (a) {
	        thisThing.checkUserChanged();
	      });
	    };
	
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	
	    var appActions = this.props.appActions;
	    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
	
	    var _props$dataDependency = this.props.dataDependencyRetriever(feedFeatureNames),
	        dataDependencies = _props$dataDependency.dataDependencies,
	        customDependencies = _props$dataDependency.customDependencies;
	
	    this.doUpdate();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  doUpdate: function doUpdate() {
	    this._shouldUpdateOnScroll = false;
	    this._shouldUpdateOnScrollAfterGoingDown = false;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
	
	    var _props$dataDependency2 = this.props.dataDependencyRetriever(feedFeatureNames),
	        dataDependencies = _props$dataDependency2.dataDependencies,
	        customDependencies = _props$dataDependency2.customDependencies;
	
	    var hasRewards = false;
	    for (var i = 0; i < dataDependencies.length; i++) {
	      if (dataDependencies[i] == "Rewards") {
	        hasRewards = true;
	      }
	    }
	    if (!hasRewards) dataDependencies.push("Rewards");
	
	    appManager.getDataTypes(thisThing.props.allDependencyKeys, function (data) {
	      thisThing.didUpdate(data);
	    });
	
	    NetworkManager.update(appManager, dataDependencies, function (newData) {
	      if (customDependencies.length <= 0) {
	        thisThing._shouldUpdateOnScrollAfterGoingDown = true;
	        appManager.setData(newData, function () {
	          thisThing.didUpdate(newData);
	        });
	      } else {
	        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function (totalData) {
	          thisThing._shouldUpdateOnScrollAfterGoingDown = true;
	          appManager.setData(totalData, function () {
	            thisThing.didUpdate(totalData);
	          });
	        });
	      }
	    }, function () {
	      thisThing._shouldUpdateOnScrollAfterGoingDown = true;
	    });
	  },
	
	  open: function open() {
	    this.props.appActions._navigator.overrideMenuOpen = true;
	    this.setHorizontalScrollerOffset(0);
	  },
	
	  setHorizontalScrollerOffset: function setHorizontalScrollerOffset(offset) {
	    var _this = this;
	
	    if (Platform.OS == 'web') {
	      var thisThing = this;
	      var x = new Animated.Value(this._menuScrollOffsetX);
	      x.addListener(function (_ref) {
	        var value = _ref.value;
	
	        if (thisThing.refs.scrollView) thisThing.refs.scrollView.scrollTo({ x: value, animated: false });
	      });
	      Animated.timing(x, {
	        toValue: offset,
	        duration: 200
	      }).start();
	    } else {
	      if (this.refs.scrollView) this.refs.scrollView.scrollTo({ x: offset, animated: true });
	      setTimeout(function () {
	        _this.props.appActions._navigator.forceUpdate();
	      }, 50);
	    }
	  },
	
	  close: function close() {
	    this.props.appActions._navigator.overrideMenuOpen = false;
	    this.setHorizontalScrollerOffset(this.props.initialLayout.width);
	  },
	
	  toggle: function toggle() {
	    if (this.state.menuOpen) this.close();else this.open();
	  },
	
	  _loggedInRendered: null,
	  _oldPoints: null,
	  _oldDollars: null,
	  checkUserChanged: function checkUserChanged() {
	    var appManager = this.props.appManager;
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (loggedIn != this._loggedInRendered) {
	      this._loggedInRendered = loggedIn;
	      if (!this._loggedInRendered) {
	        this.didUpdate({});
	        this.scrollMiddle();
	        this.scrollDown();
	      }
	      this.doUpdate();
	    }
	
	    if (loggedIn) {
	      if (this._feedPlusView) this._feedPlusView.setPoints(appManager.currentUser()[ModelConstants.Points]);
	      if (this._oldPoints != appManager.currentUser()[ModelConstants.Points] || this._oldDollars != appManager.currentUser()[ModelConstants.Credits]) {
	        this.forceUpdate();
	      }
	
	      var thisThing = this;
	      thisThing.props.appManager.getSelfie(function (selfieURL) {
	        if (selfieURL != thisThing.state.selfieURL) thisThing.setState({ selfieURL: selfieURL });
	      });
	    }
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    thisThing._cardUpdateTimeout = null;
	    var feedFeatureNames = thisThing.props.appManager.getFeedFeatureNames();
	    var feedFeatures = thisThing.props.appManager.getFeedFeatures();
	    if (typeof data !== 'undefined' && typeof data.Rewards !== 'undefined' && data.Rewards.length > 0) {
	      if (thisThing._feedPlusView) thisThing._feedPlusView.setRewards(data.Rewards);
	    } else {
	      thisThing.props.appManager.getDataType("Rewards", function (rewards) {
	        if (typeof rewards !== 'undefined') {
	          if (thisThing._feedPlusView) thisThing._feedPlusView.setRewards(rewards);
	        }
	      });
	    }
	
	    thisThing.props.appManager.getDataTypes(thisThing.props.allDependencyKeys, function (data) {
	      if (typeof data !== 'undefined') {
	        var cards = thisThing.props.getCards(feedFeatureNames, thisThing.props.appManager, thisThing.props.appActions, data, feedFeatures);
	        thisThing.props.appManager.getSelfie(function (selfieURL) {
	          thisThing.setState({ selfieURL: selfieURL, cards: cards });
	        });
	      }
	    });
	  },
	
	  scrollUp: function scrollUp() {
	    if (this._feedScrollContainer) this._feedScrollContainer.scrollTo({ y: this.props.initialLayout.height });
	  },
	
	  scrollDown: function scrollDown() {
	    if (this._feedScrollContainer) this._feedScrollContainer.scrollTo({ y: 0 });
	  },
	
	  scrollMiddle: function scrollMiddle() {
	    if (this.refs.scrollView) this.refs.scrollView.scrollTo({ x: this.props.initialLayout.width });
	  },
	
	  renderFeedHeader: function renderFeedHeader() {
	    var _ref2;
	
	    var loggedIn = this.props.appManager.isLoggedIn();
	
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", 0.2);
	
	    var useCreditFeature = this.props.appManager.getFeatureForName("UseCredit");
	    var creditIconName = typeof useCreditFeature === 'undefined' ? "" : useCreditFeature.data.icon.replace("fa-", "");
	    var useCreditIsInFeed = typeof useCreditFeature === 'undefined' ? false : useCreditFeature.data.shouldShowInFeed;
	
	    var rewardsFeature = this.props.appManager.getFeatureForName("Rewards");
	    var rewardsIconName = typeof rewardsFeature === 'undefined' ? "" : rewardsFeature.data.icon.replace("fa-", "");
	    var rewardsIsInFeed = typeof rewardsFeature === 'undefined' ? false : rewardsFeature.data.shouldShowInFeed;
	
	    var creditPercentage = 0;
	    var pointPercentage = 0;
	    var creditString = "";
	    var pointsString = "";
	    var initials = "";
	
	    if (loggedIn) {
	      initials = appManager.currentUserInitials();
	      var maxDollars = parseFloat(appManager.getLocalizationManager().getConstants()["CREDITS_FOR_MAX"]);
	      var maxPoints = parseFloat(appManager.getLocalizationManager().getConstants()["TOTAL_POINTS_FOR_REWARD"]);
	      var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
	      var currPoints = parseFloat(appManager.currentUser()[ModelConstants.Points]);
	      creditString = appManager.getLocalizationManager().localizedDollars(currDollars);
	      pointsString = appManager.getLocalizationManager().localizedPts(currPoints);
	      creditPercentage = parseFloat(currDollars / maxDollars);
	      pointPercentage = parseFloat(currPoints / maxPoints);
	    }
	
	    var leftTextStyle = { backgroundColor: 'transparent', margin: 0, marginTop: 0, marginLeft: 2, width: FEED_HEADER_HEIGHT - 16 - 4, height: FEED_HEADER_HEIGHT - 16 - 4, borderRadius: (FEED_HEADER_HEIGHT - 16 - 4) / 2, justifyContent: 'center', alignItems: 'center' };
	
	    return React.createElement(
	      Animated.View,
	      { style: [styles.feedHeader, { backgroundColor: profileColor }] },
	      React.createElement(
	        View,
	        { style: styles.feedHeaderLeftContainer },
	        React.createElement(
	          TouchableHighlight,
	          {
	            underlayColor: "transparent",
	            activeOpacity: 0.9,
	            onPress: function onPress() {
	              appActions.requestFeatureName("Settings");
	            } },
	          React.createElement(
	            View,
	            { style: [styles.profileImage, (_ref2 = { borderColor: 'transparent', backgroundColor: profileColor }, _defineProperty(_ref2, 'backgroundColor', 'transparent'), _defineProperty(_ref2, 'borderWidth', 0), _ref2)] },
	            !loggedIn ? React.createElement(
	              View,
	              { style: leftTextStyle },
	              React.createElement(Icon, { name: "lock", size: 48, color: profileImageColor })
	            ) : typeof this.state.selfieURL !== 'undefined' && this.state.selfieURL != null && this.state.selfieURL.length > 0 ? React.createElement(
	              View,
	              null,
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.profileImageText, { color: profileImageColor, position: 'absolute', top: 13, left: 0, right: 0, bottom: 0 }] },
	                initials
	              ),
	              React.createElement(Image, { source: { uri: this.state.selfieURL }, style: leftTextStyle })
	            ) : React.createElement(
	              View,
	              { style: leftTextStyle },
	              React.createElement(
	                View,
	                null,
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [styles.profileImageText, { color: profileImageColor }] },
	                  initials
	                )
	              )
	            ),
	            React.createElement(
	              _reactNativeSvgWrapper2.default,
	              {
	                height: FEED_HEADER_HEIGHT,
	                width: FEED_HEADER_HEIGHT,
	                style: { position: 'absolute', top: -12, left: -12, backgroundColor: 'transparent' }
	              },
	              React.createElement(
	                _reactNativeSvgWrapper.G,
	                { scale: '1' },
	                React.createElement(_reactNativeSvgWrapper.Circle, { cx: (FEED_HEADER_HEIGHT + 8) / 2, cy: (FEED_HEADER_HEIGHT + 8) / 2, r: (FEED_HEADER_HEIGHT - 16 - 4) / 2, stroke: profileImageColor, 'stroke-width': '2', fill: 'transparent' })
	              )
	            )
	          )
	        )
	      ),
	      loggedIn ? React.createElement(
	        View,
	        { style: [styles.feedHeaderCenterContainer] },
	        React.createElement(View, null),
	        useCreditIsInFeed ? React.createElement(
	          MKButton,
	          { onPress: function onPress() {
	              return appActions.requestFeatureName("AddCredit");
	            } },
	          React.createElement(
	            Meter,
	            { height: FEED_HEADER_HEIGHT / 3, initialPercent: creditPercentage, innerColor: profileMeterColor, outerColor: profileMeterBackgroundColor },
	            React.createElement(Icon, { name: creditIconName, size: FEED_HEADER_HEIGHT / 5, color: profileIconColor, style: { backgroundColor: 'transparent' } })
	          )
	        ) : null,
	        rewardsIsInFeed ? React.createElement(
	          MKButton,
	          { onPress: function onPress() {
	              return appActions.requestFeatureName("Rewards");
	            } },
	          React.createElement(
	            Meter,
	            { height: FEED_HEADER_HEIGHT / 3, initialPercent: pointPercentage, innerColor: profileMeterColor, outerColor: profileMeterBackgroundColor },
	            React.createElement(Icon, { name: rewardsIconName, size: FEED_HEADER_HEIGHT / 5, color: profileIconColor, style: { backgroundColor: 'transparent', alignSelf: 'center' } })
	          )
	        ) : null,
	        React.createElement(View, null)
	      ) : React.createElement(
	        View,
	        { style: styles.feedHeaderCenterContainer },
	        React.createElement(View, null),
	        React.createElement(
	          View,
	          null,
	          React.createElement(
	            ReUpText,
	            { isTitle: true, appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	            locManager.localizedStringForKey("NOT_LOGGED_IN_STATEMENT")
	          )
	        ),
	        React.createElement(View, null)
	      ),
	      loggedIn ? React.createElement(
	        View,
	        { style: styles.feedHeaderRightContainer },
	        React.createElement(View, null),
	        useCreditIsInFeed ? React.createElement(
	          MKButton,
	          { onPress: function onPress() {
	              return appActions.requestFeatureName("AddCredit");
	            }, style: { height: FEED_HEADER_HEIGHT / 3, alignItems: 'center', flexDirection: 'row' } },
	          React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	              creditString
	            )
	          )
	        ) : null,
	        rewardsIsInFeed ? React.createElement(
	          MKButton,
	          { onPress: function onPress() {
	              return appActions.requestFeatureName("Rewards");
	            }, style: { height: FEED_HEADER_HEIGHT / 3, alignItems: 'center', flexDirection: 'row' } },
	          React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: [styles.feedHeaderInfo, { color: profileTitleColor }] },
	              pointsString
	            )
	          )
	        ) : null,
	        React.createElement(View, null)
	      ) : React.createElement(View, null)
	    );
	  },
	
	  _leftRightBlur: 0,
	  _upDownBlur: 0,
	  _shouldUpdateOnScroll: false,
	  _shouldUpdateOnScrollAfterGoingDown: true,
	  _shouldCenterHorizonalScroll: false,
	  render: function render() {
	    var _this2 = this;
	
	    // return <View style={{width:100, height:100, backgroundColor:'red'}} />
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	
	    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/background.png');
	
	    // link is expired, instruct user to register again or w/e
	    var overlayView = null;
	    if (appManager.expiredLink()) {
	      overlayView = React.createElement(
	        OverlayView,
	        { style: [styles.container, addedContainerStyle, { alignItems: 'stretch', justifyContent: 'center', flexDirection: 'column', backgroundColor: generalColor }] },
	        React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	        React.createElement(
	          View,
	          { style: { padding: 20, margin: 12, backgroundColor: generalColor, borderRadius: 4, flexDirection: 'column' } },
	          React.createElement(
	            View,
	            { style: { marginBottom: 8, flex: -1 } },
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: appManager, style: { color: generalTitleColor, textAlign: 'center' } },
	              locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE")
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { flex: -1 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: generalTitleColor, textAlign: 'center' } },
	              locManager.localizedStringForKey("EXPIRED_LINK_ERROR_STATEMENT")
	            )
	          )
	        )
	      );
	    } else if (appManager.needsRegistration()) {
	      var registrationFeatureData = this.props.appManager.getFeatureForName("SimpleCreateUser");
	      var registrationFeature = this.props.featureBuilder.featureForData(registrationFeatureData, this.props.initialLayout, appManager, { shouldHideActionBar: true, didCompleteRegistration: function didCompleteRegistration() {
	          appManager._needsRegistration = false;
	          thisThing.setState({ didRegister: true });
	        } });
	      overlayView = React.createElement(
	        OverlayView,
	        { style: [{ alignItems: 'stretch', justifyContent: 'center', flexDirection: 'column', backgroundColor: generalColor }] },
	        registrationFeature
	      );
	    } else if (appManager.needsCFD()) {
	      var simpleCFDFeatureData = this.props.appManager.getFeatureForName("SimpleCFD");
	      var simpleCFDFeature = this.props.featureBuilder.featureForData(simpleCFDFeatureData, this.props.initialLayout, appManager, { shouldHideActionBar: true });
	      overlayView = React.createElement(
	        OverlayView,
	        { style: [{ alignItems: 'stretch', justifyContent: 'center', flexDirection: 'column', backgroundColor: generalColor }] },
	        simpleCFDFeature
	      );
	    }
	
	    var headerPath = appManager.absoluteResourceForPath('Feed' + '/' + 'header.png');
	    var menuOpenThreshold = (this.state.tempHideLeft ? -1 : 1) * this.props.initialLayout.width / 2;
	    var rightOpenThreshold = (this.state.tempHideLeft ? 1 : 3) * this.props.initialLayout.width / 2;
	
	    var topRightFeatures = appManager.getTopRightFeatures();
	    var shouldShowTopRightFeature = topRightFeatures.length > 0 && (!topRightFeatures[0].data.requiresLogin || appManager.isLoggedIn());
	    var rightFeature = null;
	    var topRightText = null;
	    if (shouldShowTopRightFeature) {
	      var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;
	      if (topRightFeatures[0].key == "UseCredit" || topRightFeatures[0].key == "EarnPay") {
	        if (isLivePay) {
	          topRightText = topRightFeatures[0].data.shortTitle;
	        } else {
	          var currDollars = parseFloat(appManager.currentUser()[ModelConstants.Credits]);
	          // TODO:remove
	          if (appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com") {
	            currDollars = 12.75;
	          }
	          topRightText = appManager.getLocalizationManager().localizedDollars(currDollars);
	        }
	      }
	      var rightLayout = { width: this.props.initialLayout.width - 40, height: this.props.initialLayout.height - (Globals.ACTION_BAR_HEIGHT + 12) - 20 };
	      rightFeature = this.props.featureBuilder.featureForData(topRightFeatures[0], rightLayout, appManager, { shouldHideActionBar: true, borderRadius: 10 });
	      // rightFeature = this.props.featureBuilder.featureForData(appManager.getFeatureForName("EarnPay"), rightLayout, appManager, {shouldHideActionBar:true});
	    }
	    // TODO: remove this
	    // rightFeature = this.props.featureBuilder.featureForData(appManager.getFeatureForName("EarnPay"), this.props.initialLayout, appManager, {shouldHideActionBar:true})
	
	    var shouldShowHeaderImageOnFeedPlus = false;
	
	    var shouldAlwaysShowHeader = this.state.shouldAlwaysShowHeader;
	
	    var addedContainerStyle = { backgroundColor: generalColor, position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 };
	    var height = 0;
	    var width = 0;
	    try {
	      var _Dimensions$get2 = Dimensions.get('window'),
	          height = _Dimensions$get2.height,
	          width = _Dimensions$get2.width;
	
	      if (height > 0 && width > 0) {
	        if (Platform.OS !== 'ios') height -= Globals.STATUS_BAR_HEIGHT; // status bar
	        addedContainerStyle = { width: width, height: height, backgroundColor: generalColor };
	      }
	    } catch (e) {} finally {}
	
	    var HorizontalScrollClass = Platform.OS == 'web' ? OffsetView : ScrollView;
	    var showTopBar = appManager.showTopBar();
	
	    var mainView = React.createElement(
	      View,
	      { style: { flex: 1, backgroundColor: 'transparent', width: this.props.initialLayout.width } },
	      React.createElement(
	        ScrollView,
	        { key: function key(a) {
	            return _this2._feedScrollContainer;
	          }, ref: 'feedScrollContainer',
	          bounces: false,
	          keyboardShouldPersistTaps: 'handled',
	          snapToInterval: this.props.initialLayout.height - (shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0),
	          decelerationRate: "fast",
	          scrollEventThrottle: 20,
	          scrollEnabled: true,
	          showsHorizontalScrollIndicator: false,
	          showsVerticalScrollIndicator: false,
	          style: { alignSelf: "stretch", flex: 1, width: this.props.initialLayout.width, height: this.props.initialLayout.height }, onScroll: function onScroll(info) {
	            if (thisThing._shouldCenterHorizonalScroll && thisThing.refs.scrollView) thisThing.refs.scrollView.scrollTo({ x: _this2.props.initialLayout.width });
	            thisThing._upDownBlur = info.nativeEvent.contentOffset.y / (thisThing.props.initialLayout.height - Globals.ACTION_BAR_HEIGHT);
	            if (thisThing._upDownBlur < .75) thisThing._shouldScrollOuterUp = true;
	            thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
	            if (!shouldAlwaysShowHeader) thisThing.refs.fadingView.setOpacity(thisThing._upDownBlur);
	            if (Platform.OS === 'ios' || Platform.OS === 'web') {
	              if (thisThing._feedPlusView) thisThing._feedPlusView.setZoomOut(thisThing._upDownBlur <= 0 ? thisThing._upDownBlur : thisThing._upDownBlur * 2);
	              // thisThing._feedPlusViewBack.setZoomOut(thisThing._upDownBlur);
	              var plusEnabled = thisThing._upDownBlur > .5;
	              if (thisThing._feedPlusView) thisThing._feedPlusView.setEnabled(!plusEnabled);
	            }
	
	            if (info.nativeEvent.contentOffset.y >= thisThing.props.initialLayout.height - Globals.ACTION_BAR_HEIGHT && thisThing._shouldUpdateOnScrollAfterGoingDown) {
	              thisThing._shouldUpdateOnScroll = true;
	            }
	
	            if (thisThing._shouldUpdateOnScroll && info.nativeEvent.contentOffset.y <= 0) thisThing.doUpdate();
	          }
	        },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row' } },
	          appManager.disableFeed() ? React.createElement(View, { style: { height: this.props.initialLayout.height - (shouldAlwaysShowHeader ? 2 * FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT : 0), width: 0 } }) : React.createElement(View, { style: { height: this.props.initialLayout.height * 2 - (shouldAlwaysShowHeader ? 2 * FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT : 0), width: 0 } }),
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'column' } },
	            React.createElement(
	              View,
	              { style: { height: this.props.initialLayout.height - (shouldAlwaysShowHeader ? 2 * FEED_HEADER_HEIGHT - Globals.STATUS_BAR_HEIGHT : 0), width: this.props.initialLayout.width } },
	              Platform.OS !== 'ios' ? React.createElement(FeedPlusView, { key: "feedPlusView" + thisThing.props.appManager._featureVersion, ref: function ref(a) {
	                  return _this2._feedPlusView = a;
	                },
	                initialLayout: this.props.initialLayout,
	                style: { position: 'absolute', top: showTopBar ? Globals.ACTION_BAR_HEIGHT : 0, left: 0, right: 0, bottom: 0 },
	                upArrowSelected: function upArrowSelected() {
	                  thisThing.scrollUp();
	                },
	                appManager: appManager, appActions: appActions }) : React.createElement(View, { style: { flex: 1 } })
	            ),
	            !appManager.disableFeed() ? React.createElement(
	              View,
	              { style: { flexDirection: 'column' } },
	              React.createElement(View, { style: { height: showTopBar ? Globals.ACTION_BAR_HEIGHT : 0 } }),
	              Platform.OS === 'ios' ? React.createElement(
	                ScrollView,
	                {
	                  pagingEnabled: false,
	                  bounces: true,
	                  keyboardShouldPersistTaps: 'handled',
	                  showsHorizontalScrollIndicator: false, showsVerticalScrollIndicator: false,
	                  style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height - (showTopBar ? Globals.ACTION_BAR_HEIGHT : 0) },
	                  scrollEventThrottle: 20,
	                  onScroll: function onScroll(info) {
	                    if (thisThing._shouldScrollOuterUp && info.nativeEvent.contentOffset.y < -200) {
	                      thisThing._shouldScrollOuterUp = false;
	                      thisThing.scrollDown();
	                    }
	                  } },
	                React.createElement(
	                  View,
	                  { style: { flex: 1, paddingBottom: 4, marginTop: shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0, width: this.props.initialLayout.width } },
	                  this.state.cards.map(function (card, index) {
	                    return React.createElement(FeedCard, Object.assign({}, card, {
	                      key: card.key,
	                      appManager: appManager,
	                      iconColor: bannerIconColor,
	                      bannerColor: bannerColor,
	                      cardColor: cardColor,
	                      titleColor: titleColor,
	                      bodyColor: bodyColor,
	                      rippleColor: rippleColor,
	                      cardHeight: function cardHeight(height) {} }));
	                  })
	                )
	              ) : React.createElement(
	                View,
	                { style: { flex: 1, paddingBottom: 4, marginTop: shouldAlwaysShowHeader ? FEED_HEADER_HEIGHT : 0, width: this.props.initialLayout.width } },
	                this.state.cards.map(function (card, index) {
	                  return React.createElement(FeedCard, Object.assign({}, card, {
	                    key: JSON.stringify(card),
	                    appManager: appManager,
	                    iconColor: bannerIconColor,
	                    bannerColor: bannerColor,
	                    cardColor: cardColor,
	                    titleColor: titleColor,
	                    bodyColor: bodyColor,
	                    rippleColor: rippleColor,
	                    cardHeight: function cardHeight(height) {} }));
	                })
	              )
	            ) : null,
	            shouldAlwaysShowHeader ? React.createElement(
	              View,
	              { style: { position: 'absolute', height: FEED_HEADER_HEIGHT, left: 0, right: 0, top: this.props.initialLayout.height - FEED_HEADER_HEIGHT } },
	              thisThing.renderFeedHeader()
	            ) : null
	          )
	        )
	      ),
	      Platform.OS === 'ios' ? React.createElement(FeedPlusView, { key: 'feedPlusView', ref: function ref(a) {
	          return _this2._feedPlusView = a;
	        },
	        initialLayout: this.props.initialLayout,
	        style: { position: 'absolute', top: showTopBar ? Globals.ACTION_BAR_HEIGHT : 0, left: 0, right: 0, bottom: 0 },
	        upArrowSelected: function upArrowSelected() {
	          thisThing.scrollUp();
	        },
	        appManager: appManager, appActions: appActions }) : null
	    );
	    if (!showTopBar) {
	      return React.createElement(
	        View,
	        { style: [styles.container, addedContainerStyle] },
	        React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	        mainView,
	        overlayView
	      );
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, addedContainerStyle] },
	      React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	      React.createElement(
	        HorizontalScrollClass,
	        { ref: 'scrollView', keyboardShouldPersistTaps: 'handled', showsHorizontalScrollIndicator: false, showsVerticalScrollIndicator: false, decelerationRate: "fast", scrollEventThrottle: 20, onScroll: function onScroll(info) {
	            var scrollOffsetX = info.nativeEvent.contentOffset.x;
	            thisThing._menuScrollOffsetX = scrollOffsetX;
	            var width = thisThing.props.initialLayout.width;
	            thisThing._shouldCenterHorizonalScroll = Platform.OS === 'web' && scrollOffsetX != width;
	
	            if (Platform.OS === 'ios' || Platform.OS === 'web') {
	              var menuOpen = menuOpenThreshold > scrollOffsetX;
	              if (thisThing.state.menuOpen != menuOpen) {
	                thisThing.setState({ menuOpen: menuOpen });
	                thisThing.props.appActions._navigator.overrideMenuOpen = menuOpen;
	                setTimeout(function () {
	                  thisThing.props.appActions._navigator.forceUpdate();
	                }, 50);
	              }
	
	              var rightOpen = rightOpenThreshold < scrollOffsetX;
	              if (thisThing.state.rightOpen != rightOpen) thisThing.setState({ rightOpen: rightOpen });
	
	              thisThing._leftRightBlur = Math.abs(parseFloat(scrollOffsetX + (thisThing.state.tempHideLeft ? width : 0) - width) / width);
	              thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
	              if (thisThing.refs.leftSideView && scrollOffsetX < width) thisThing.refs.leftSideView.setAmountIn(thisThing._leftRightBlur);
	              if (thisThing.refs.rightSideView && scrollOffsetX > width) thisThing.refs.rightSideView.setAmountIn(thisThing._leftRightBlur);
	              if (scrollOffsetX <= 0 && !thisThing.state.tempHideRight) thisThing.setState({ tempHideRight: true });
	              if (scrollOffsetX >= width && thisThing.state.tempHideRight) thisThing.setState({ tempHideRight: false });
	              // if( scrollOffsetX >= 2*width && !thisThing.state.tempHideLeft ) thisThing.setState({tempHideLeft:true});
	              // if( scrollOffsetX <= 0 && thisThing.state.tempHideLeft )
	              // {
	              //   thisThing.setState({tempHideLeft:false});
	              //   thisThing.refs.scrollView.scrollTo({x:width, animated:false})
	              // }
	              if (typeof thisThing._lastScrollOffsetX !== 'undefined') {
	                thisThing._lastScrollOffsetXDelta = scrollOffsetX - thisThing._lastScrollOffsetX;
	              }
	              thisThing._lastScrollOffsetX = scrollOffsetX;
	            } else {
	              var menuOpen = menuOpenThreshold > scrollOffsetX;
	              if (thisThing.state.menuOpen != menuOpen) thisThing.setState({ menuOpen: menuOpen });
	
	              var rightOpen = rightOpenThreshold < scrollOffsetX;
	              if (thisThing.state.rightOpen != rightOpen) thisThing.setState({ rightOpen: rightOpen });
	
	              thisThing._leftRightBlur = Math.abs(parseFloat(info.nativeEvent.contentOffset.x - thisThing.props.initialLayout.width) / thisThing.props.initialLayout.width);
	              thisThing.refs.blurView.setOpacity(Math.max(thisThing._leftRightBlur, thisThing._upDownBlur));
	              thisThing.refs.leftSideView.setAmountIn(1);
	              if (thisThing.refs.rightSideView) thisThing.refs.rightSideView.setAmountIn(1);
	            }
	          },
	          onScrollEndDrag: function onScrollEndDrag() {
	            if (Platform.OS == 'ios' || Platform.OS === 'web') {
	              var width = thisThing.props.initialLayout.width;
	              if (!thisThing.state.tempHideRight && thisThing._lastScrollOffsetX < width && thisThing._lastScrollOffsetXDelta > 0) {
	                thisThing.refs.scrollView.scrollTo({ x: width });
	              }
	              if (!thisThing.state.tempHideLeft && thisThing._lastScrollOffsetX > width && thisThing._lastScrollOffsetXDelta < 0) {
	                thisThing.refs.scrollView.scrollTo({ x: width });
	              }
	            }
	          },
	          removeClippedSubviews: true, bounces: false, horizontal: true, pagingEnabled: Platform.OS !== 'ios', snapToInterval: this.props.initialLayout.width, style: [{ flex: 1, alignSelf: 'stretch' }] },
	        React.createElement(
	          View,
	          { style: { flex: -1, height: this.props.initialLayout.height, flexDirection: 'row', alignItems: 'stretch' } },
	          !this.state.tempHideLeft ? React.createElement(
	            FeedPlusSideView,
	            { ref: 'leftSideView', style: { flex: 1, backgroundColor: 'transparent', width: this.props.initialLayout.width } },
	            React.createElement(
	              View,
	              { style: { marginTop: Globals.ACTION_BAR_HEIGHT + 12, marginBottom: 20, marginHorizontal: 20, flex: 1 } },
	              React.createElement(
	                View,
	                { clipToSubviews: true, style: { overflow: 'hidden', flex: 1, borderRadius: 10 } },
	                React.createElement(Menu, { key: 'menu', ref: 'menu',
	                  menuFeatures: this.props.appManager.getMenuFeatures(),
	                  menuTitleColor: appManager.getColorForKey("MenuTitleColor"),
	                  menuIconColor: appManager.getColorForKey("MenuIconColor"),
	                  menuHighlightColor: appManager.getColorForKey("MenuSelectionColor"),
	                  menuBackgroundColor: appManager.getColorForKey("MenuColor"),
	                  menuSeparatorColor: appManager.getColorForKey("MenuIconColor", 0.4),
	                  AppActions: this.props.appActions,
	                  appManager: appManager,
	                  appActions: appActions,
	                  layout: this.props.initialLayout,
	                  style: { borderTopRightRadius: 20, borderBottomRightRadius: 20, borderTopLeftRadius: 20, borderBottomLeftRadius: 20 }
	                })
	              )
	            )
	          ) : null,
	          mainView,
	          rightFeature && !this.state.tempHideRight ? React.createElement(
	            FeedPlusSideView,
	            { ref: 'rightSideView', style: { flex: 1, backgroundColor: 'transparent', width: this.props.initialLayout.width } },
	            React.createElement(
	              View,
	              { style: { marginTop: Globals.ACTION_BAR_HEIGHT + 12, marginBottom: 20, marginHorizontal: 20, flex: 1 } },
	              React.createElement(
	                View,
	                { clipToSubviews: true, style: { overflow: 'hidden', flex: 1, borderRadius: 10 } },
	                rightFeature
	              )
	            )
	          ) : null
	        )
	      ),
	      React.createElement(
	        FadingView,
	        { ref: 'fadingView',
	          style: { position: 'absolute', alignItems: 'flex-end', flexDirection: 'row', top: 0, left: 0, right: 0, height: Globals.ACTION_BAR_HEIGHT, backgroundColor: headerColor },
	          initialOpacity: shouldAlwaysShowHeader ? 1 : 0 },
	        React.createElement(
	          TouchableWithoutFeedback,
	          { onPress: function onPress() {
	              thisThing.props.appActions._navigator.showDebugIfEnoughTouches(new Date().getTime());
	            } },
	          React.createElement(
	            View,
	            { style: [{ flex: 1, marginHorizontal: 50, alignItems: 'center' }, Globals.TOP_CENTER_ADJUSTMENT] },
	            React.createElement(Image, { key: appManager.getImageKey("header"), style: {
	                height: 44,
	                width: 150,
	                padding: 0,
	                flex: -1
	              }, resizeMode: "stretch", source: { uri: headerPath } })
	          )
	        )
	      ),
	      React.createElement(
	        View,
	        { onStartShouldSetResponder: function onStartShouldSetResponder(evt) {
	            if (evt.nativeEvent.identifier == 2 || Platform.OS != "ios" && evt.nativeEvent.identifier == 1) _this2.props.appActions._navigator.showDebugIfEnoughTouches(evt.nativeEvent.timestamp);
	          },
	          style: [{
	            alignItems: 'stretch',
	            justifyContent: 'center',
	            height: Globals.ACTION_BAR_HEIGHT - Globals.STATUS_BAR_HEIGHT,
	            position: 'absolute',
	            top: Globals.STATUS_BAR_HEIGHT,
	            left: 0,
	            right: 0,
	            flexDirection: 'row'
	          }] },
	        showTopBar ? React.createElement(
	          View,
	          { style: [{ width: 50 }, Globals.TOP_LEFT_STYLE_ADJUSTMENT] },
	          !thisThing.state.rightOpen ? React.createElement(
	            View,
	            null,
	            React.createElement(ReUpIconButton, { key: this.state.menuOpen ? "times" : "bars",
	              iconName: this.state.menuOpen ? "times" : "bars",
	              appManager: appManager,
	              buttonColorOverride: headerColor,
	              type: 2,
	              accessibilityLabel: locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON"),
	              onPress: function onPress() {
	                thisThing.toggle();
	              } })
	          ) : null
	        ) : null,
	        React.createElement(
	          View,
	          { style: [{ flex: 1, alignItems: 'center' }, Globals.TOP_CENTER_ADJUSTMENT] },
	           false ? React.createElement(Image, { key: appManager.getImageKey("header"), style: {
	              height: 44,
	              width: 150,
	              padding: 0,
	              flex: -1
	            }, resizeMode: "stretch", source: { uri: headerPath } }) : null
	        ),
	        showTopBar ? React.createElement(
	          View,
	          { style: [Globals.TOP_RIGHT_STYLE_ADJUSTMENT] },
	          topRightText != null && !this.state.rightOpen && !this.state.menuOpen ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              MKButton,
	              { onPress: function onPress() {
	                  thisThing.setHorizontalScrollerOffset(thisThing.state.rightOpen ? thisThing.props.initialLayout.width : 2 * thisThing.props.initialLayout.width);
	                },
	                backgroundColor: 'transparent',
	                shadowRadius: 0,
	                shadowOffset: { width: 0, height: 0 },
	                shadowOpacity: 0,
	                shadowColor: 'transparent',
	                style: [{ height: 36, borderRadius: 18, margin: 4, backgroundColor: 'transparent' }],
	                maskBorderRadius: 22,
	                rippleColor: appManager.getColorForKey("HeaderIconColor", .2) },
	              React.createElement(
	                View,
	                { style: [{ height: 36, borderRadius: 18, paddingHorizontal: 8, alignItems: 'center', justifyContent: 'center', backgroundColor: headerColor }] },
	                React.createElement(
	                  View,
	                  { style: { flex: -1 } },
	                  React.createElement(
	                    ReUpText,
	                    { isTitle: true, appManager: appManager, style: { color: headerIconColor } },
	                    topRightText
	                  )
	                )
	              )
	            )
	          ) : null,
	          (topRightText == null || this.state.rightOpen) && shouldShowTopRightFeature && !this.state.menuOpen ? React.createElement(
	            View,
	            null,
	            React.createElement(ReUpIconButton, { key: this.state.rightOpen ? "times" : topRightFeatures[0].data.icon.replace("fa-", ""),
	              iconName: this.state.rightOpen ? "times" : topRightFeatures[0].data.icon.replace("fa-", ""),
	              appManager: appManager,
	              buttonColorOverride: headerColor,
	              type: 2,
	              style: { marginRight: Platform.OS != 'web' ? 12 : 4 },
	              accessibilityLabel: locManager.localizedStringForKey("TOPRIGHT_ACCESSIBILITY_BUTTON"),
	              onPress: function onPress() {
	                thisThing.setHorizontalScrollerOffset(thisThing.state.rightOpen ? thisThing.props.initialLayout.width : 2 * thisThing.props.initialLayout.width);
	              } })
	          ) : null
	        ) : null
	      ),
	      overlayView
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  feedHeader: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'row'
	  },
	  feedHeaderLeftContainer: {
	    padding: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  profileImage: {
	    height: FEED_HEADER_HEIGHT - 16,
	    width: FEED_HEADER_HEIGHT - 16,
	    borderRadius: (FEED_HEADER_HEIGHT - 16) / 2,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: (FEED_HEADER_HEIGHT - 20) / 2,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  feedHeaderCenterContainer: {
	    height: FEED_HEADER_HEIGHT,
	    paddingVertical: 10,
	    flex: 1,
	    justifyContent: 'space-between'
	  },
	
	  feedHeaderRightContainer: {
	    paddingVertical: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  feedHeaderInfo: {
	    fontWeight: 'bold'
	  }
	});
	FeedPlus.dataDependencies = ["Users", "Rewards"];
	
	module.exports = FeedPlus;

/***/ },
/* 1111 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var ReUpField = __webpack_require__(26);
	var PlatformConstants = __webpack_require__(31);
	var NumericalInput = __webpack_require__(92);
	var MKSegmentControl = __webpack_require__(36);
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var GiftCardOptions = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      campaigns: [],
	      useCreditCampaign: null,
	      referCampaign: null,
	      checkInCampaign: null,
	      transferLoyaltyCampaign: null,
	      transferLabels: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.props.appManager.getCurrentUser(function (currentUser) {
	      thisThing._PIN = currentUser.ScannerPIN;
	    });
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    NetworkManager.getGCInfoByUserIDVendor(appManager, thisThing.props.extras.UserID, thisThing.props.extras.hash, function (data) {
	      for (var key in data) {
	        thisThing.props.extras[key] = data[key];
	      }
	      if (typeof thisThing.props.extras.PhoneNumber !== 'undefined') thisThing.props.extras.phoneNumber = thisThing.props.extras.PhoneNumber;
	      thisThing.forceUpdate();
	    }, function (data) {}, function (data) {});
	    if (typeof data.Campaigns !== 'undefined') {
	      var useCreditCampaign = null;
	      var referCampaign = null;
	      var checkInCampaign = null;
	      var transferLoyaltyCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        var campaign = data.Campaigns[i];
	        if (campaign.Type == "UseCredit") useCreditCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "Checkin" || campaign.Type == "CheckIn") checkInCampaign = JSON.parse(campaign.CampaignBlob);
	        if (campaign.Type == "TransferLoyalty") transferLoyaltyCampaign = JSON.parse(campaign.CampaignBlob);
	      }
	      // var useCreditCampaign =  {Type: "UseCredit", DollarsPerPoint: 1};
	      // var referCampaign =  {Type: "Referral", ReferrerPoints: 10, RefereePoints: 10};
	      // var checkInCampaign =  {Type: "Checkin", DollarsPerPoint: 2, FixedPoints: 0};
	      // var transferLoyaltyCampaign =  {Type: "TransferLoyalty", Identifier: ["p", "e"]};
	
	      this.setState({
	        campaigns: data.Campaigns,
	        useCreditCampaign: useCreditCampaign,
	        referCampaign: referCampaign,
	        checkInCampaign: checkInCampaign,
	        transferLoyaltyCampaign: transferLoyaltyCampaign
	      });
	    }
	  },
	
	  _isLoyaltyingEmail: true,
	  _loyaltyTransferEmail: "",
	  _loyaltyTransferPhone1: "",
	  _loyaltyTransferPhone2: "",
	  _loyaltyTransferPhone3: "",
	  _loyaltyLabels: [],
	  _loyaltyTransferTabSelected: [],
	  _loyaltyTransferPhoneIndex: 0,
	  _loyaltyTransferEmailIndex: 0,
	  _loyaltyTransferExternalIDIndex: 0,
	  showLoyaltyTransfer: function showLoyaltyTransfer() {
	    var _this = this;
	
	    var locMan = this.props.appManager.getLocalizationManager();
	    this._loyaltyTransferEmail = "";
	    this._loyaltyTransferPhone = "";
	    var modes = this.state.transferLoyaltyCampaign.Modes;
	    this._loyaltyLabels = [];
	    this._loyaltyTransferTabSelected = [];
	    var showSwitch = modes.length > 1;
	    if (modes.length <= 0) return;
	
	    for (var i = 0; i < modes.length; i++) {
	      if (modes[i] == "p") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("PHONE_OPTION"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferPhone(showSwitch);
	        });
	        this._loyaltyTransferPhoneIndex = i;
	      } else if (modes[i] == "e") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("EMAIL_OPTION"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferEmail(showSwitch);
	        });
	        this._loyaltyTransferEmailIndex = i;
	      } else if (modes[i] == "i") {
	        this._loyaltyLabels.push(locMan.localizedStringForKey("CARDID_OPTION", "Card ID"));
	        this._loyaltyTransferTabSelected.push(function () {
	          return _this.showLoyaltyTransferExternalID(showSwitch);
	        });
	        this._loyaltyTransferExternalIDIndex = i;
	      }
	    }
	    if (modes[0] == "p") {
	      this.showLoyaltyTransferPhone(showSwitch);
	    } else if (modes[0] == "e") {
	      this.showLoyaltyTransferEmail(showSwitch);
	    } else if (modes[0] == "i") {
	      this.showLoyaltyTransferExternalID(showSwitch);
	    }
	  },
	
	  showLoyaltyTransferEmail: function showLoyaltyTransferEmail(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingEmail = true;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
	    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          selectedIndex: thisThing._loyaltyTransferEmailIndex,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: styles.alertInnerContainer },
	          React.createElement(ReUpField, {
	            ref: function ref(a) {
	              thisThing._loyaltyTransferEmailField = a;if (a != null) a.focus();
	            },
	            key: 'email',
	            appManager: appManager,
	            keyboardType: "email-address",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferEmail = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: emailLabel,
	            floatingLabelEnabled: true,
	            floatingLabelAniDuration: .1,
	            returnKeyType: "done",
	            onSubmitEditing: thisThing.submitEmail,
	            style: { flex: 1 } })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitEmail
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitEmail: function submitEmail() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var extras = this.props.extras;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.UserID;
	
	    thisThing._loyaltyTransferEmailField.setIsInError(!appManager.isValidEmail(thisThing._loyaltyTransferEmail));
	    if (appManager.isValidEmail(thisThing._loyaltyTransferEmail)) {
	      thisThing._loyaltyTransferEmailField.setIsInError(false);
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, thisThing._loyaltyTransferEmail, "", "", thisThing.props.extras.hash, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = true;
	        extras.isTransfer = true;
	        extras.scanner = thisThing.props.extras.scanner;;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    } else {
	      thisThing._loyaltyTransferEmailField.setIsInError(true);
	    }
	  },
	
	  _loyaltyTransferExternalID: "",
	  showLoyaltyTransferExternalID: function showLoyaltyTransferExternalID(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingExternalID = true;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	    var externalIDLabel = locMan.localizedStringForKey("CARDID_OPTION", "Card ID");
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          selectedIndex: thisThing._loyaltyTransferExternalIDIndex,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: styles.alertInnerContainer },
	          React.createElement(ReUpField, {
	            ref: function ref(a) {
	              thisThing._loyaltyTransferExternalIDField = a;if (a != null) a.focus();
	            },
	            key: 'externalID',
	            appManager: appManager,
	            autoCapitalize: "none",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferExternalID = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: externalIDLabel,
	            floatingLabelEnabled: true,
	            floatingLabelAniDuration: .1,
	            returnKeyType: "done",
	            onSubmitEditing: thisThing.submitExternalID,
	            style: { flex: 1 } })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitExternalID
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  submitExternalID: function submitExternalID() {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var extras = this.props.extras;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.UserID;
	
	    var isValidExternalID = thisThing._loyaltyTransferExternalID.length > 0;
	    thisThing._loyaltyTransferExternalIDField.setIsInError(!isValidExternalID);
	    if (isValidExternalID) {
	      thisThing._loyaltyTransferExternalIDField.setIsInError(false);
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, "", "", thisThing._loyaltyTransferExternalID, thisThing.props.extras.hash, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = true;
	        extras.isTransfer = true;
	        extras.scanner = thisThing.props.extras.scanner;;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    } else {
	      thisThing._loyaltyTransferExternalIDField.setIsInError(true);
	    }
	  },
	
	  _PIN: "",
	  checkPinError: function checkPinError(value) {
	    if (value.length < this._PIN.length) return false;
	
	    return value != this._PIN;
	  },
	
	  checkPinSuccess: function checkPinSuccess(value) {
	    return value == this._PIN;
	  },
	
	  showPin: function showPin(success) {
	    if (this._PIN.length <= 0) {
	      success();
	      return;
	    }
	
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var enterPinStr = locManager.localizedStringForKey("ENTER_PIN_STATEMENT");
	    var customAlert = React.createElement(
	      View,
	      { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' } },
	      React.createElement(
	        View,
	        { style: { margin: 5 } },
	        React.createElement(
	          ReUpText,
	          { isTitle: true, fontSize: 32 },
	          enterPinStr
	        )
	      ),
	      React.createElement(NumericalInput, { style: { height: 400, alignSelf: 'stretch' }, maxLength: this._PIN.length, didSucceed: function didSucceed() {
	          appActions.hideAlert();
	          success();
	        }, checkPinSuccess: this.checkPinSuccess, checkPinError: this.checkPinError, appManager: this.props.appManager, isDisplayingPin: true })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  showLoyaltyTransferPhone: function showLoyaltyTransferPhone(showSwitch) {
	    var showSwitch = typeof showSwitch === 'undefined' || showSwitch;
	    this._isLoyaltyingEmail = false;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var emailLabel = locMan.localizedStringForKey("EMAIL_OPTION");
	    var phoneLabel = locMan.localizedStringForKey("PHONE_OPTION");
	    var okButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var oneTimeOnly = locMan.localizedStringForKey("LOYALTY_TRANSFER_STATEMENT");
	
	    var phoneSeparators = ["(", ") ", " - "];
	
	    var userID = this.props.extras.UserID;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: { paddingBottom: 8 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center' } },
	            oneTimeOnly
	          )
	        ),
	        showSwitch ? React.createElement(MKSegmentControl, {
	          style: styles.referTypeContainer,
	          choiceTitles: this._loyaltyLabels,
	          didSelectIndex: function didSelectIndex(index) {
	            thisThing._loyaltyTransferTabSelected[index]();
	          },
	          selectedIndex: thisThing._loyaltyTransferPhoneIndex,
	          activeBackgroundColor: primaryButtonColor,
	          activeShadowColor: primaryButtonBorderColor,
	          activeTextColor: primaryButtonTitleColor,
	          inactiveBackgroundColor: secondaryButtonColor,
	          inactiveTextColor: secondaryButtonTitleColor }) : null,
	        React.createElement(
	          View,
	          { style: [styles.alertInnerContainer, { paddingRight: 8, alignItems: 'center', height: 70, justifyContent: 'center' }] },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { marginTop: 26, padding: 4 } },
	            phoneSeparators[0]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone1 = a;if (a != null) a.focus();
	            },
	            key: 'phone1',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone1 = text;if (text.length >= 3) thisThing._phone2.focus();
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "###",
	            maxLength: 3,
	            style: [styles.textField, { width: 45 }] }),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { flex: -1, marginTop: 18, padding: 4, fontSize: 24 } },
	            phoneSeparators[1]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone2 = a;
	            },
	            key: 'phone2',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone2 = text;if (text.length >= 3) thisThing._phone3.focus();
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "###",
	            maxLength: 3,
	            style: [styles.textField, { width: 45 }] }),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { flex: -1, marginTop: 18, padding: 4, fontSize: 24 } },
	            phoneSeparators[2]
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            ref: function ref(a) {
	              thisThing._phone3 = a;
	            },
	            key: 'phone3',
	            keyboardType: "phone-pad",
	            onChangeText: function onChangeText(text) {
	              thisThing._loyaltyTransferPhone3 = text;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor },
	            placeholder: "####",
	            maxLength: 4,
	            onSubmitEditing: thisThing.submitPhone,
	            returnKeyType: "done",
	            style: [styles.textField, { width: 65 }] })
	        ),
	        React.createElement(ReUpButton, { style: [styles.button, { marginTop: 30 }],
	          appManager: appManager,
	          text: okButton,
	          onPress: thisThing.submitPhone
	        })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {});
	  },
	
	  resendVerification: function resendVerification() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.userID;
	    var hash = this.props.extras.hash;
	    appActions.setSpinnerShown(true);
	    NetworkManager.resendVerification(this.props.appManager, userID, hash, function () {
	      appActions.setSpinnerShown(false);
	      appActions.showLocalizedAlert("SUCCESS_VERIFICATION_SENT_ALERT_TITLE", "SUCCESS_VERIFICATION_SENT_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	    }, function () {
	      appActions.setSpinnerShown(false);
	      appActions.showLocalizedAlert("ERROR_VERIFICATION_SENT_ALERT_TITLE", "ERROR_VERIFICATION_SENT_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	    }, function () {
	      appActions.setSpinnerShown(false);
	      appActions.showLocalizedAlert("ERROR_VERIFICATION_SENT_ALERT_TITLE", "ERROR_VERIFICATION_SENT_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	    });
	  },
	
	  submitPhone: function submitPhone() {
	    var thisThing = this;
	    var extras = this.props.extras;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var userID = this.props.extras.UserID;
	
	    thisThing._phone1.setIsInError(thisThing._loyaltyTransferPhone1.length != 3);
	    thisThing._phone2.setIsInError(thisThing._loyaltyTransferPhone2.length != 3);
	    thisThing._phone3.setIsInError(thisThing._loyaltyTransferPhone3.length != 4);
	    thisThing._loyaltyTransferPhone = thisThing._loyaltyTransferPhone1 + thisThing._loyaltyTransferPhone2 + thisThing._loyaltyTransferPhone3;
	
	    if (thisThing._loyaltyTransferPhone1.length == 3 && thisThing._loyaltyTransferPhone2.length == 3 && thisThing._loyaltyTransferPhone3.length == 4) {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true);
	      NetworkManager.vendorTransferLoyaltyCampaign(appManager, userID, "", thisThing._loyaltyTransferPhone, "", thisThing.props.extras.hash, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = true;
	        extras.isTransfer = true;
	        extras.scanner = thisThing.props.extras.scanner;;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appActions.showLocalizedAlert("TRANSFER_LOYALTY_FAIL_ALERT_TITLE", "TRANSFER_LOYALTY_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showLoyaltyTransfer], thisThing.props.appActions.hideAlert);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        thisThing.props.appAction.showNetworkErrorAlert();
	      });
	    }
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	
	    var userID = this.props.extras.UserID;
	    var phoneNumber = typeof this.props.extras.phoneNumber !== 'undefined' ? this.props.extras.phoneNumber : null;
	    var dollars = appManager.getLocalizationManager().localizedDollars(this.props.extras.Credit);
	    var points = appManager.getLocalizationManager().localizedPoints(this.props.extras.Points);
	
	    var localizedPhoneNumber = locManager.localizedPhone(phoneNumber);
	    var phoneNumberStr = locManager.localizedStringForKeyAndParams("PHONE_NUMBER_LABEL_WITH_NUMBER", [localizedPhoneNumber], "Phone#: %0%");
	    var resendVerificationLocalized = locManager.localizedStringForKey("RESEND_VERIFICATION_BUTTON", "Resend Verification");
	    var sendPortalLinkLocalized = locManager.localizedStringForKey("SEND_PORTAL_LINK_BUTTON", "Send Portal Link");
	    var resendAppDownloadLinkLocalized = locManager.localizedStringForKey("RESEND_APP_DOWNLOAD_LINK_BUTTON", "Resend App Download Link");
	    var accountNotVerifiedCapsLocalized = locManager.localizedStringForKey("ACCOUNT_NOT_VERIFIED_CAPS_STATEMENT", "ACCOUNT NOT VERIFIED");
	    var addCreditExtras = { addingCredit: true };
	    for (var key in this.props.extras) {
	      addCreditExtras[key] = this.props.extras[key];
	    }
	
	    var hasTransferredLoyalty = typeof this.props.extras.HasTransferredLoyalty === 'undefined' ? false : this.props.extras.HasTransferredLoyalty == 1;
	
	    var shouldShowResendVerify = typeof this.props.extras !== 'undefined' && this.props.extras.shouldShowResendVerify;
	
	    var user = appManager.currentUser();
	    var sendPortalLinkButtonText = typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0 && appManager.currentUser()["RequireVerificationForRewards"] == 1 ? resendVerificationLocalized : sendPortalLinkLocalized;
	    if (user != null && typeof user.ReUpPackage !== 'undefined' && user.ReUpPackage.length > 0) {
	      var reUpPackage = JSON.parse(user.ReUpPackage);
	      if (typeof reUpPackage.type !== 'undefined' && reUpPackage.type == 'pro') sendPortalLinkButtonText = resendAppDownloadLinkLocalized;
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { flexDirection: 'column', backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', flex: 1, height: this.state.layout.height, width: this.state.layout.width } },
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: 10, padding: 10, borderRadius: 10, backgroundColor: 'white', width: -1 } },
	            false ? React.createElement(
	              ReUpText,
	              { style: { color: generalTitleColor } },
	              "UserID: " + userID
	            ) : null,
	            phoneNumber == null ? null : React.createElement(
	              ReUpText,
	              { style: { color: generalTitleColor } },
	              phoneNumberStr
	            ),
	            typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0 ? React.createElement(
	              ReUpText,
	              { style: { color: 'red' } },
	              accountNotVerifiedCapsLocalized
	            ) : null,
	            React.createElement(
	              ReUpText,
	              { isTitle: true, style: { color: generalTitleColor } },
	              dollars
	            ),
	            React.createElement(
	              ReUpText,
	              { isTitle: true, style: { color: generalTitleColor } },
	              points
	            )
	          ),
	          typeof this.props.extras.onlyPoints === 'undefined' || !this.props.extras.onlyPoints ? React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("ADD_CREDIT_BUTTON"),
	            onPress: function onPress() {
	              var extras = addCreditExtras;
	              extras.disableAutoScannerLaunch = true;
	              thisThing.showPin(function () {
	                appActions.requestFeatureName("CreditInput", extras);
	              });
	            }
	          }) : null,
	          typeof this.props.extras.onlyPoints === 'undefined' || !this.props.extras.onlyPoints ? React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("USE_CREDIT_BUTTON"),
	            onPress: function onPress() {
	              var extras = thisThing.props.extras;
	              extras.disableAutoScannerLaunch = true;
	              appActions.requestFeatureName("CreditInput", extras);
	            }
	          }) : null,
	          React.createElement(ReUpButton, { style: [styles.button, { margin: 10, opacity: typeof this.props.extras.Verified !== 'undefined' && this.props.extras.Verified == 0 && appManager.currentUser()["RequireVerificationForRewards"] == 1 ? .4 : 1 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("USE_REWARD_BUTTON"),
	            onPress: function onPress() {
	              if (typeof thisThing.props.extras.Verified !== 'undefined' && thisThing.props.extras.Verified == 0 && appManager.currentUser()["RequireVerificationForRewards"] == 1) {
	                appActions.showLocalizedAlert("ACCOUNT_NOT_VERIFIED_ALERT_TITLE", "ACCOUNT_NOT_VERIFIED_ALERT_BODY", ["NO_ALERT_BUTTON", "OK_ALERT_BUTTON"], [appActions.hideAlert, function () {
	                  thisThing.resendVerification();
	                  appActions.hideAlert();
	                }], appActions.hideAlert);
	                return;
	              }
	
	              var extras = thisThing.props.extras;
	              extras.disableAutoScannerLaunch = true;
	              appActions.requestFeatureName("GiftCardUseReward", extras);
	            }
	          }),
	          React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("ASSIGN_POINTS_BUTTON"),
	            onPress: function onPress() {
	              var extras = thisThing.props.extras;
	              extras.disableAutoScannerLaunch = true;
	              thisThing.showPin(function () {
	                appActions.requestFeatureName("CheckInInput", extras);
	              });
	            }
	          }),
	          shouldShowResendVerify ? React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: sendPortalLinkButtonText,
	            onPress: function onPress() {
	              thisThing.resendVerification();
	            }
	          }) : null,
	          hasTransferredLoyalty ? null : React.createElement(ReUpButton, { style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("TRANSFER_LOYALTY_BUTTON"),
	            onPress: function onPress() {
	              var extras = {};
	              extras.disableAutoScannerLaunch = true;
	              thisThing.showLoyaltyTransfer(extras);
	            }
	          }),
	          React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10 }],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("CANCEL_BUTTON"),
	            onPress: function onPress() {
	              thisThing.props.appActions.requestPop();
	              if (typeof thisThing.props.extras.scanner !== 'undefined') {
	                setTimeout(function () {
	                  thisThing.props.extras.scanner.scan();
	                }, 300);
	              }
	            }
	          }),
	          React.createElement(View, { style: { flex: 1 } })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  },
	  textField: {},
	  alertInnerContainer: {
	    paddingTop: 4,
	    paddingLeft: 10,
	    paddingRight: 10,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row'
	  }
	});
	
	GiftCardOptions.dataDependencies = ["Rewards", "Campaigns"];
	
	module.exports = GiftCardOptions;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var moment = __webpack_require__(3);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var RewardsList = __webpack_require__(1140);
	var PlatformConstants = __webpack_require__(31);
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var GiftCardUseReward = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      chargeText: "Charge - $0.00",
	      rewards: [],
	      oneTimeRewards: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    NetworkManager.getOneTimeRewards(this.props.appManager, this.props.extras.UserID, this.props.extras.hash, function (data) {
	      var deduplicatedOneTimeRewards = [];
	      for (var i = 0; i < data.length; i++) {
	        var alreadyExists = false;
	        var reward = data[i];
	        for (var j = 0; j < deduplicatedOneTimeRewards.length; j++) {
	          if (reward.RewardID == deduplicatedOneTimeRewards[j].RewardID) {
	            if (typeof deduplicatedOneTimeRewards[j].others === 'undefined') deduplicatedOneTimeRewards[j].others = [];
	            deduplicatedOneTimeRewards[j].others.push(reward);
	            alreadyExists = true;
	          }
	        }
	        if (!alreadyExists) {
	          deduplicatedOneTimeRewards.push(reward);
	        }
	      }
	      thisThing.setState({ oneTimeRewards: deduplicatedOneTimeRewards });
	    }, function () {});
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Rewards !== 'undefined') {
	      var rewards = data.Rewards.sort(function (a, b) {
	        if (a.Points == b.Points) return b.RewardName.localeCompare(a.RewardName);else return a.Points - b.Points;
	      });
	
	      this.setState({ rewards: rewards });
	    }
	  },
	
	  didSelectReward: function didSelectReward(reward) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var appActions = this.props.appActions;
	    var pointsLoc = appManager.getLocalizationManager().localizedPoints(reward.Points);
	    var ptsLoc = appManager.getLocalizationManager().localizedPts(reward.Points);
	    var redeemRewardAlertTitle = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_TITLE", [reward.RewardName]);
	    var redeemRewardAlertBody = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BODY", [pointsLoc]);
	    var usePointsAlertButton = locManager.localizedStringForKeyAndParams();
	    appActions.showLocalizedAlert(redeemRewardAlertTitle, redeemRewardAlertBody, ["NO_ALERT_BUTTON", usePointsAlertButton], [function () {
	      appActions.hideAlert();
	    }, function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, "Processing...");
	      var scanner = thisThing.props.extras.scanner;
	      NetworkManager.vendorRedeemReward(appManager, thisThing.props.extras.U, reward.RewardID, "U", thisThing.props.extras.H, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = true;
	        extras.type = "credit";
	        extras.scanner = scanner;
	        extras.isReward = true;
	        extras.reward = reward;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        var extras = data;
	        extras.success = false;
	        extras.type = "credit";
	        extras.scanner = scanner;
	        extras.isReward = true;
	        extras.reward = reward;
	        appActions.requestFeatureName("TransactionResult", extras);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	      });
	    }], function () {});
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var thisThing = this;
	    var generalColor = appManager.getColorForKey("GeneralColor");
	
	    var rewards = this.state.rewards.sort(function (a, b) {
	      return a.Points - b.Points;
	    });
	
	    var oneTimeRewards = this.state.oneTimeRewards.sort(function (a, b) {
	      if (a.DateExpires == b.DateExpires) return b.RewardName.localeCompare(a.RewardName);else {
	        var dateA = new Date(a.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsA = moment(dateA).valueOf();
	        var dateB = new Date(b.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsB = moment(dateB).valueOf();
	
	        return dateSecondsA - dateSecondsB;
	      }
	    });
	
	    var shownRewards = [];
	    for (var i = 0; i < oneTimeRewards.length; i++) {
	      shownRewards.push(oneTimeRewards[i]);
	    }for (var i = 0; i < rewards.length; i++) {
	      shownRewards.push(rewards[i]);
	    }var userPoints = this.props.extras.Points;
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { paddingTop: 20, backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column' } },
	          React.createElement(RewardsList, { appManager: appManager, numUserPoints: userPoints, rewards: shownRewards, didSelectReward: thisThing.didSelectReward })
	        )
	      ),
	      React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10 }],
	        appManager: appManager,
	        text: locManager.localizedStringForKey("CANCEL_BUTTON"),
	        onPress: function onPress() {
	          thisThing.props.appActions.requestPop();
	        }
	      })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	GiftCardUseReward.dataDependencies = ["Rewards"];
	
	module.exports = GiftCardUseReward;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Icon = __webpack_require__(13);
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	var ModelConstants = __webpack_require__(11);
	
	var Globals = __webpack_require__(10);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Animated = ReactNative.Animated,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    Animated = ReactNative.Animated,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Gifts = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate() {},
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = this.state.user;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	
	    var cardNumberLabel = "Gift Card Number"; //TODO:localize
	    var pinLabel = "PIN:"; //TODO:localize
	    var creditsPointLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
	    var absorbCardButton = "Enter PIN"; //TODO:localize
	
	    var buttons = [];
	    var sendGCFeature = appManager.getFeatureForName("SendGiftCard");
	    if (typeof sendGCFeature !== 'undefined' && sendGCFeature != null) buttons.push(sendGCFeature);
	    var absorbFeature = appManager.getFeatureForName("AbsorbGiftCard");
	    if (typeof absorbFeature !== 'undefined' && absorbFeature != null) buttons.push(absorbFeature);
	    // var sendCreditFeature = appManager.getFeatureForName("SendCredit");
	    // if( typeof sendCreditFeature !== 'undefined' && sendCreditFeature != null ) buttons.push(sendCreditFeature);
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var iconName = this.props.featureData.icon.replace("fa-", "");
	    var instructionText = locManager.localizedStringForKey(this.props.featureData.instructions);
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this },
	        React.createElement(
	          View,
	          { style: { flex: -1, backgroundColor: instructionColor, alignItems: 'center', justifyContent: 'center', padding: 12 } },
	          React.createElement(Icon, { name: iconName, size: 140, color: instructionTitleColor, style: { backgroundColor: 'transparent' } }),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { color: instructionTitleColor, textAlign: 'center' } },
	            instructionText
	          )
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        React.createElement(
	          View,
	          { style: { padding: 20 } },
	          buttons.map(function (feature, index) {
	            return React.createElement(ReUpButton, { key: index, isSecondary: index != 0, appManager: appManager, style: [{ marginBottom: 20 }], text: feature.data.title,
	              onPress: function onPress() {
	                appActions.requestFeatureName(feature.data.name);
	              } });
	          })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    margin: 10,
	    alignItems: 'center',
	    marginLeft: 20,
	    marginRight: 20,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    fontSize: 26,
	    padding: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    padding: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    flex: 1,
	    width: -1,
	    height: 50,
	    marginTop: 10
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    margin: 8,
	    marginTop: 0
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginRight: 10, marginLeft: 10, marginBottom: 10
	  },
	
	  segmentContainer: {
	    height: 50,
	    padding: 4,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	Gifts.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn || typeof ModelConstants === 'undefined') return [];else {
	    var user = appManager.currentUser();
	    var credit = user[ModelConstants.Credits];
	    if (credit < 20) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("AbsorbGiftCard");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	Gifts.dataDependencies = ["Users"];
	
	module.exports = Gifts;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var LinkingManager = __webpack_require__(27);
	var createReactClass = __webpack_require__(5);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableOpacity = ReactNative.TouchableOpacity;
	
	
	var MK = __webpack_require__(14);
	
	var MKSpinner = MK.MKSpinner;
	
	
	var ReUpButton = __webpack_require__(12);
	
	var GoToAppStoreButton = createReactClass({
	  displayName: 'GoToAppStoreButton',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {},
	      appStoreURL: null,
	      playStoreURL: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      showSpinner: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  goToStore: function goToStore() {
	    var thisThing = this;
	    this.setState({ showSpinner: true });
	    setTimeout(function () {
	      thisThing.setState({ showSpinner: false });
	    }, 5000);
	
	    var phoneOS = this.props.appManager.getMobileOperatingSystem();
	    if (phoneOS == "android") LinkingManager.openURL(this.props.playStoreURL);else LinkingManager.openURL(this.props.appStoreURL);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    if (this.props.appStoreURL == null || this.props.appStoreURL.length <= 0) return null;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    if (this.state.showSpinner) {
	      return React.createElement(
	        View,
	        { ref: 'spinner', key: 'spinner', style: [this.props.style, { flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }] },
	        React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { alignSelf: 'center' } })
	      );
	    }
	
	    var phoneOS = appManager.getMobileOperatingSystem();
	    var imageURL = "https://devimages-cdn.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg";
	    if (phoneOS == "android") imageURL = "https://play.google.com/intl/en_us/badges/images/badge_new.png";
	
	    return React.createElement(
	      TouchableOpacity,
	      { style: [this.props.style, { flexDirection: 'column', cursor: 'pointer', backgroundColor: 'transparent' }],
	        onPress: function onPress() {
	          return _this.goToStore();
	        } },
	      React.createElement(Image, { key: "store", resizeMode: "contain", source: { uri: imageURL }, style: { flex: 1, alignSelf: 'stretch' } })
	    );
	  }
	});
	
	module.exports = GoToAppStoreButton;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var ModelConstants = __webpack_require__(11);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Animated = ReactNative.Animated,
	    Image = ReactNative.Image;
	
	
	var ImageMeter = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      appManager: null,
	      offsetTopPercentage: 0,
	      offsetBottomPercentage: 0,
	      meterDim: 100,
	      percentage: 0.5,
	      children: React.createElement(View, null),
	      animated: true,
	      bgSource: null,
	      fgSource: null,
	      fillSource: null,
	      overlayView: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      percentage: new Animated.Value(0),
	      percentageVal: 0,
	      meterDim: -1
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.state.percentage.addListener(function (_ref) {
	      var value = _ref.value;
	
	      thisThing.setState({ percentageVal: value });
	    });
	
	    setTimeout(function () {
	      thisThing._hasDoneFirstSet = true;
	      thisThing.setPercentage(thisThing.props.percentage);
	    }, 500);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.percentage !== 'undefined') this.setPercentage(newProps.percentage);
	  },
	
	  _hasDoneFirstSet: false,
	  setPercentage: function setPercentage(newPercentage) {
	    if (!this._hasDoneFirstSet) return;
	
	    Animated.spring(this.state.percentage, {
	      toValue: newPercentage,
	      tension: 8,
	      friction: 9
	    }).start();
	  },
	
	  render: function render() {
	    var meterDim = this.state.meterDim;
	    var appManager = this.props.appManager;
	    var amount = (parseFloat(this.props.offsetBottomPercentage) + this.state.percentageVal * (1 - parseFloat(this.props.offsetBottomPercentage) - parseFloat(this.props.offsetTopPercentage))) * meterDim;
	    var bgSource = this.props.bgSource;
	    var fgSource = this.props.fgSource;
	    var fillSource = this.props.fillSource;
	    var thisThing = this;
	
	    if (this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com") {
	      amount = meterDim;
	    }
	
	    return React.createElement(
	      View,
	      { pointerEvents: "none", style: [{ alignItems: 'center', justifyContent: 'center' }, this.props.style], onLayout: function onLayout(evt) {
	          var meterDim = Math.min(evt.nativeEvent.layout.height, evt.nativeEvent.layout.width);
	          if (meterDim != thisThing.state.meterDim) thisThing.setState({ meterDim: meterDim });
	        } },
	      this.state.meterDim > 0 ? React.createElement(
	        View,
	        { key: 'rewardmetercontainer', style: { width: meterDim, height: meterDim, backgroundColor: 'transparent', alignItems: 'center', justifyContent: 'center' } },
	        React.createElement(
	          View,
	          { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } },
	          this.props.bgSource != null ? React.createElement(Image, { key: appManager.getImageKey("feedplusbg"), style: { width: meterDim, height: meterDim, backgroundColor: 'transparent' }, resizeMode: "contain", source: { uri: this.props.bgSource } }) : null
	        ),
	        React.createElement(
	          View,
	          { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, flexDirection: 'column' } },
	          React.createElement(
	            View,
	            { clipToSubviews: true, style: { backgroundColor: 'transparent', overflow: 'hidden', height: amount, marginTop: meterDim - amount } },
	            this.props.fillSource != null ? React.createElement(Image, { key: appManager.getImageKey("feedplusfill"), style: { overflow: 'hidden', marginTop: -(meterDim - amount), width: meterDim, height: meterDim, backgroundColor: 'transparent' }, resizeMode: "contain", source: { uri: this.props.fillSource } }) : null
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } },
	          this.props.fgSource != null ? React.createElement(Image, { key: appManager.getImageKey("feedplusfg"), style: { width: meterDim, height: meterDim, backgroundColor: 'transparent' }, resizeMode: "contain", source: { uri: this.props.fgSource } }) : null
	        ),
	        this.props.overlayView != null ? React.createElement(
	          View,
	          { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' } },
	          this.props.overlayView()
	        ) : null,
	        React.createElement(View, { style: { marginTop: 18 } })
	      ) : null,
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } },
	        this.props.children
	      )
	    );
	  }
	});
	
	module.exports = ImageMeter;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var LinkingManager = __webpack_require__(27);
	var NetworkManager = __webpack_require__(15);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var Instagram = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  render: function render() {
	    return React.createElement(View, null);
	  }
	});
	
	Instagram.getCards = function (featureData, appActions, data) {
	  var didSelect = function didSelect(index) {
	    Instagram.customNavigation(featureData, appActions);
	  };
	  var imageURLs = [];
	  var MAX_NUM_INSTAGRAM = 5;
	  if (typeof data.Instagrams !== 'undefined') {
	    data.Instagrams = data.Instagrams.sort(function (a, b) {
	      return b.created_time - a.created_time;
	    });
	    var numAdded = 0;
	    for (var i = 0; i < data.Instagrams.length && numAdded < MAX_NUM_INSTAGRAM; i++) {
	      var insta = data.Instagrams[i];
	      var imageURL = insta.images.low_resolution.url;
	      var foundImageURL = false;
	      for (var j = 0; j < imageURLs.length; j++) {
	        if (imageURLs[j] == imageURL) {
	          foundImageURL = true;
	          break;
	        }
	      }
	      if (!foundImageURL && typeof imageURL !== 'undefined' && imageURL.length > 0) {
	        // alert(imageURLs)
	        imageURLs.push(imageURL);
	        numAdded++;
	      }
	    }
	    var appManager = appActions._appManager;
	    didSelect = function didSelect(index) {
	      if (typeof data !== 'undefined' && typeof data.Instagrams !== 'undefined' && data.Instagrams.length > index) {
	        var url = data.Instagrams[index].link;
	        var barTintColor = appManager.getColorForKey("HeaderColor");
	        var tintColor = appManager.getColorForKey("HeaderIconColor");
	        LinkingManager.openURL(url, tintColor, barTintColor);
	      } else {
	        Instagram.customNavigation(featureData, appActions);
	      }
	    };
	  }
	
	  if (imageURLs.length <= 0) return [];
	
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var sortOrder = new Date().getTime() - data.Instagrams[0].created_time * 1000;
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    body1: featureData.data.tip,
	    icon: iconName,
	    cardType: 7,
	    imageURLs: imageURLs,
	    sortOrder: sortOrder
	  }];
	};
	Instagram.customNavigation = function (featureData, appActions) {
	  var instagramURL = "instagram://user?username=" + featureData.data.instagram_user_id;
	  LinkingManager.canOpenURL(instagramURL, function (can) {
	    if (can) {
	      LinkingManager.openURL(instagramURL);
	    } else {
	      var url = "http://www.instagram.com/" + featureData.data.instagram_user_id;
	      var appManager = appActions._appManager;
	      var barTintColor = appManager.getColorForKey("HeaderColor");
	      var tintColor = appManager.getColorForKey("HeaderIconColor");
	
	      LinkingManager.openURL(url, tintColor, barTintColor);
	    }
	  });
	};
	
	Instagram.dataDependencies = ["Instagrams"];
	
	module.exports = Instagram;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var Tutorial = __webpack_require__(848);
	var ReUpButton = __webpack_require__(12);
	var ReUpText = __webpack_require__(8);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var PlatformConstants = __webpack_require__(31);
	
	var AnalyticsManager = __webpack_require__(50);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Image = ReactNative.Image,
	    Keyboard = ReactNative.Keyboard,
	    ScrollView = ReactNative.ScrollView,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var InterstitialContainer = __webpack_require__(5)({
	  getInitialState: function getInitialState() {
	    var thisThing = this;
	
	    var state = {
	      layout: { width: 100, height: 100 },
	      headerOpacity: new Animated.Value(0),
	      title: "",
	      keyboardOffset: new Animated.Value(0)
	    };
	
	    var createUserFeatureData = this.props.appManager.getFeatureForName('CreateUser');
	    if (typeof createUserFeatureData !== 'undefined') {
	      state.createUserFeatureData = createUserFeatureData;
	      state.createUserComponent = this.props.featureBuilder.featureForData(createUserFeatureData, { width: 0, height: 0 }, this.props.appManager, {
	        useInterstitialFlow: true,
	        createUserDidFinish: function createUserDidFinish(completion, shouldSkipRestOfTutorial) {
	          if (typeof shouldSkipRestOfTutorial !== 'undefined' && shouldSkipRestOfTutorial) {
	            thisThing.props.interstitialDidFinish();
	          } else {
	            thisThing.checkUserChanged();
	            thisThing.refs.tutorial.goNext(completion);
	          }
	        },
	        showNetworkErrorAlert: function showNetworkErrorAlert() {
	          thisThing.networkErrorOccurred();
	        }
	      });
	    }
	
	    var paymentTypePrereq = this.props.appManager.getPrerequisiteFeatureForName("PaymentTypes");
	    var addCreditPrereq = this.props.appManager.getPrerequisiteFeatureForName("AddCredit");
	    var phoneNumberVerifyFeatureData = this.props.appManager.getFeatureForName('PhoneNumberVerify');
	    if (typeof phoneNumberVerifyFeatureData !== 'undefined' && (addCreditPrereq != null && addCreditPrereq.data.name == "PhoneNumberVerify" || paymentTypePrereq != null && paymentTypePrereq.data.name == "PhoneNumberVerify")) {
	      state.phoneNumberVerifyFeatureData = phoneNumberVerifyFeatureData;
	      state.phoneNumberVerifyComponent = this.props.featureBuilder.featureForData(phoneNumberVerifyFeatureData, { width: 0, height: 0 }, this.props.appManager, {
	        useInterstitialFlow: true,
	        setPhoneDidFinish: function setPhoneDidFinish(completion) {
	          thisThing.forceUpdate();
	          thisThing.refs.tutorial.goNext(completion);
	        },
	        showNetworkErrorAlert: function showNetworkErrorAlert() {
	          thisThing.networkErrorOccurred();
	        }
	      });
	    }
	
	    var addCreditFeatureData = this.props.appManager.getFeatureForName('AddCredit');
	    var paymentTypesFeatureData = this.props.appManager.getFeatureForName('PaymentTypes');
	    if (typeof paymentTypesFeatureData !== 'undefined' && typeof addCreditFeatureData !== 'undefined') {
	      state.paymentTypesFeatureData = paymentTypesFeatureData;
	      state.paymentTypesComponent = this.props.featureBuilder.featureForData(paymentTypesFeatureData, { width: 0, height: 0 }, this.props.appManager, {
	        useInterstitialFlow: true,
	        paymentTypesDidFinish: function paymentTypesDidFinish(completion) {
	          thisThing.forceUpdate();
	          thisThing.refs.tutorial.goNext(completion);
	        },
	        showNetworkErrorAlert: function showNetworkErrorAlert() {
	          thisThing.networkErrorOccurred();
	        },
	        interstitialDidFinish: thisThing.props.interstitialDidFinish
	      });
	
	      state.addCreditFeatureData = addCreditFeatureData;
	      state.addCreditComponent = this.props.featureBuilder.featureForData(addCreditFeatureData, { width: 0, height: 0 }, this.props.appManager, {
	        useInterstitialFlow: true,
	        addCreditDidFinish: function addCreditDidFinish(completion) {
	          thisThing.refs.tutorial.goNext(completion);
	        },
	        showNetworkErrorAlert: function showNetworkErrorAlert() {
	          thisThing.networkErrorOccurred();
	        }
	      });
	    }
	
	    return state;
	  },
	
	  _keyboardWillShowSubscription: null,
	  _keyboardWillHideSubscription: null,
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (Keyboard) {
	      this._keyboardWillShowSubscription = Keyboard.addListener('keyboardWillShow', function (e) {
	        return _this._keyboardWillShow(e);
	      });
	      this._keyboardWillHideSubscription = Keyboard.addListener('keyboardWillHide', function (e) {
	        return _this._keyboardWillHide(e);
	      });
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._keyboardWillShowSubscription) this._keyboardWillShowSubscription.remove();
	    if (this._keyboardWillHideSubscription) this._keyboardWillHideSubscription.remove();
	
	    // DBEvents.removeListener("all", this.dbDidUpdate, this.state.context);
	  },
	
	  _keyboardWillShow: function _keyboardWillShow(e) {
	    this.setKeyboardOffset(e.endCoordinates.height);
	  },
	
	  _keyboardWillHide: function _keyboardWillHide(e) {
	    this.setKeyboardOffset(0);
	  },
	
	  _keyboardOffset: 0,
	  _changingKeyboardOffset: null,
	  setKeyboardOffset: function setKeyboardOffset(keyboardOffset) {
	    if (this._changingKeyboardOffset != null) clearTimeout(this._changingKeyboardOffset);
	
	    var thisThing = this;
	    this._changingKeyboardOffset = setTimeout(function () {
	      thisThing._keyboardOffset = keyboardOffset;
	      Animated.spring(thisThing.state.keyboardOffset, {
	        toValue: keyboardOffset,
	        friction: 6
	      }).start();
	    }, 100);
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      interstitialDidFinish: function interstitialDidFinish() {}
	    };
	  },
	
	  skipTutorialAndLogAnalytic: function skipTutorialAndLogAnalytic() {
	    if (this.props.interstitialDidFinish != null) {
	      var indexAndPageString = this.refs.tutorial.getInfoForSkip();
	      AnalyticsManager.logCustomEvent('Skip Tutorial', { 'Index and Page': indexAndPageString });
	      this.props.interstitialDidFinish();
	    }
	  },
	
	  networkErrorOccurred: function networkErrorOccurred() {
	    if (this.props.interstitialDidFinish != null) {
	      this.props.interstitialDidFinish(function (appActions) {
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }
	  },
	
	  checkUserChanged: function checkUserChanged() {
	    var thisThing = this;
	    var paymentTypePrereq = this.props.appManager.getPrerequisiteFeatureForName("PaymentTypes");
	    var addCreditPrereq = this.props.appManager.getPrerequisiteFeatureForName("AddCredit");
	    var phoneNumberVerifyFeatureData = this.props.appManager.getFeatureForName('PhoneNumberVerify');
	    var state = {};
	    if (typeof phoneNumberVerifyFeatureData !== 'undefined' && (addCreditPrereq != null && addCreditPrereq.data.name == "PhoneNumberVerify" || paymentTypePrereq != null && paymentTypePrereq.data.name == "PhoneNumberVerify")) {
	      this.state.phoneNumberVerifyFeatureData = phoneNumberVerifyFeatureData;
	      this.state.phoneNumberVerifyComponent = this.props.featureBuilder.featureForData(phoneNumberVerifyFeatureData, { width: 0, height: 0 }, this.props.appManager, {
	        useInterstitialFlow: true,
	        setPhoneDidFinish: function setPhoneDidFinish(completion) {
	          thisThing.forceUpdate();
	          thisThing.refs.tutorial.goNext(completion);
	        },
	        showNetworkErrorAlert: function showNetworkErrorAlert() {
	          thisThing.networkErrorOccurred();
	        }
	      });
	      this.setState(state);
	    }
	
	    var additionalPages = [];
	    // if( typeof thisThing.state.createUserComponent !== 'undefined' ) additionalPages.push(thisThing.state.createUserComponent);
	    // if( typeof thisThing.state.phoneNumberVerifyComponent !== 'undefined' ) additionalPages.push(thisThing.state.phoneNumberVerifyComponent);
	    // if( typeof thisThing.state.paymentTypesComponent !== 'undefined' ) additionalPages.push(thisThing.state.paymentTypesComponent);
	    // if( typeof thisThing.state.addCreditComponent !== 'undefined' ) additionalPages.push(thisThing.state.addCreditComponent);
	
	    var additionalPageDatas = [];
	    // if( typeof thisThing.state.createUserFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.createUserFeatureData);
	    // if( typeof thisThing.state.phoneNumberVerifyFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.phoneNumberVerifyFeatureData);
	    // if( typeof thisThing.state.paymentTypesFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.paymentTypesFeatureData);
	    // if( typeof thisThing.state.addCreditFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.addCreditFeatureData);
	
	    this.refs.tutorial.setAdditionalPages(additionalPages, additionalPageDatas);
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var thisThing = this;
	
	    var splashImageURI = PlatformConstants.resourcesDirectory + '/App/Splash.png';
	    if (!this.state.resourcesSynced) {
	      splashImageURI = PlatformConstants.packagedResourcesDirectory + '/App/Splash.png';
	    }
	
	    var appManager = this.props.appManager;
	    var headerColor = appManager.getColorForKey("HeaderColor");
	
	    var createUserComponent = this.state.createUserComponent;
	    var paymentTypesComponent = this.state.paymentTypesComponent;
	    var addCreditComponent = this.state.addCreditComponent;
	    var locManager = appManager.getLocalizationManager();
	
	    var additionalPages = [];
	    // if( typeof thisThing.state.createUserComponent !== 'undefined' ) additionalPages.push(thisThing.state.createUserComponent);
	    // if( typeof thisThing.state.phoneNumberVerifyComponent !== 'undefined' ) additionalPages.push(thisThing.state.phoneNumberVerifyComponent);
	    // if( typeof thisThing.state.paymentTypesComponent !== 'undefined' ) additionalPages.push(thisThing.state.paymentTypesComponent);
	    // if( typeof thisThing.state.addCreditComponent !== 'undefined' ) additionalPages.push(thisThing.state.addCreditComponent);
	
	    var additionalPageDatas = [];
	    // if( typeof thisThing.state.createUserFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.createUserFeatureData);
	    // if( typeof thisThing.state.phoneNumberVerifyFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.phoneNumberVerifyFeatureData);
	    // if( typeof thisThing.state.paymentTypesFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.paymentTypesFeatureData);
	    // if( typeof thisThing.state.addCreditFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.addCreditFeatureData);
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { flex: 1, justifyContent: 'center', flexDirection: 'column' }], onLayout: function onLayout(info) {
	          var newLayout = info.nativeEvent.layout;
	          newLayout.height = newLayout.height - Globals.ACTION_BAR_HEIGHT;
	          if (thisThing.state.layout == null || thisThing.state.layout.height != newLayout.height) thisThing.setState({ layout: newLayout });
	        } },
	      React.createElement(BlurView, { style: { flex: 1, alignSelf: 'stretch' }, imageName: splashImageURI, innerView: React.createElement(View, { style: { position: 'absolute', top: 0, left: 0, right: 0, backgroundColor: 'transparent', height: Globals.ACTION_BAR_HEIGHT } }) }),
	      React.createElement(
	        View,
	        { style: { position: 'absolute', left: 0, right: 0, top: 0, flexDirection: 'row', height: Globals.ACTION_BAR_HEIGHT, paddingHorizontal: 10, alignItems: 'center', paddingTop: Globals.STATUS_BAR_HEIGHT } },
	        React.createElement(
	          Animated.View,
	          { style: { position: 'absolute', opacity: this.state.headerOpacity, left: 0, right: 0, top: 0, bottom: 0, paddingTop: Globals.STATUS_BAR_HEIGHT, backgroundColor: headerColor, flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
	          React.createElement(
	            View,
	            { style: { flex: 1, alignSelf: 'stretch', marginHorizontal: 50, alignItems: 'center', justifyContent: 'center', flexDirection: 'row' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isSuperTitle: true, shrinksAtLength: 20, style: [{ color: appManager.getColorForKey("HeaderTitleColor") }] },
	              this.state.title
	            )
	          )
	        ),
	        React.createElement(View, { style: { flex: 1 } }),
	        React.createElement(ReUpButton, { isSkip: true, text: locManager.localizedStringForKeyAndParams('SKIP_BUTTON'), appManager: this.props.appManager, onPress: function onPress() {
	            return _this2.skipTutorialAndLogAnalytic();
	          }, style: { width: 80 } })
	      ),
	      this.state.layout != null ? React.createElement(
	        View,
	        { style: { position: 'absolute', top: Globals.ACTION_BAR_HEIGHT, left: 0, right: 0, bottom: 0 } },
	        React.createElement(Tutorial, { ref: "tutorial", initialLayout: this.state.layout, appManager: this.props.appManager,
	          shouldShowCloseButton: false,
	          useInterstitialFlow: true,
	          tutorialDidFinish: function tutorialDidFinish(completion) {
	            _this2.props.interstitialDidFinish(completion);
	          },
	          extras: {
	            additionalPages: additionalPages,
	            additionalPageDatas: additionalPageDatas,
	            didShowAdditional: function didShowAdditional() {
	              Animated.timing(thisThing.state.headerOpacity, { toValue: 1,
	                duration: 300 }).start(function () {});
	            },
	            didChangeTitle: function didChangeTitle(newTitle) {
	              thisThing.setState({ title: newTitle });
	            }
	          }
	        }),
	        React.createElement(Animated.View, { style: { height: this.state.keyboardOffset, width: 100, opacity: 0 } })
	      ) : React.createElement(View, { style: { flex: 1, alignSelf: 'stretch' } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    position: 'absolute',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    flexDirection: 'column'
	  }
	});
	
	InterstitialContainer.getShouldShow = function (appManager, gotShouldShow) {
	  Tutorial.getLastViewed(appManager, function (date) {
	    gotShouldShow(date == null);
	  });
	};
	
	module.exports = InterstitialContainer;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ModelConstants = __webpack_require__(11);
	var ReactNative = __webpack_require__(4);
	
	var moment = __webpack_require__(3);
	
	var Platform = ReactNative.Platform;
	
	var LocalizationManager = {
	  _appManager: null,
	  _modelConstants: ModelConstants,
	  _defaultCurrency: "CAD",
	  setAppManager: function setAppManager(appManager) {
	    this._appManager = appManager;
	  },
	
	  getLocalizedStrings: function getLocalizedStrings() {
	    var activeLocale = this._appManager.getActiveLocale();
	    if (typeof activeLocale !== 'undefined' && activeLocale !== "") return this._appManager.getAppData()["LocalizedStrings-" + activeLocale];
	
	    return this._appManager.getAppData()["LocalizedStrings"];
	  },
	
	  getConstants: function getConstants() {
	    return this._appManager.getAppData()["Constants"];
	  },
	
	  getFeatureDict: function getFeatureDict() {
	    return this._appManager.getFeatureDict();
	  },
	
	  getCurrentUser: function getCurrentUser() {
	    var user = this._appManager.currentUser();
	
	    return user != null ? user : {};
	  },
	
	  getEligibleRefunds: function getEligibleRefunds() {
	    // TODO: implement refunds
	    return null;
	  },
	
	  shouldShowKey: function shouldShowKey() {
	    return this._appManager._shouldShowLocKeys;
	  },
	
	  localizedStringForKeyAndParams: function localizedStringForKeyAndParams(key, params, fallback) {
	    if (this.shouldShowKey()) return key;
	
	    if (typeof key === 'undefined') return "";
	
	    var outputString = "";
	    var components = key.split("%");
	    for (var i = 0; i < components.length; i++) {
	      var component = components[i];
	      var result = null;
	
	      if (component.length <= 0) continue;
	
	      if (typeof this.getLocalizedStrings()[component] !== 'undefined') {
	        result = this.localizedStringForKeyAndParams(this.getLocalizedStrings()[component], params);
	      } else if (component.search("FEATURENAME_") >= 0) {
	        var featureClassName = component.replace("FEATURENAME_", "");
	        var feature = this.getFeatureDict()[featureClassName];
	        result = feature["title"];
	      } else if (component == "POINTS_LEFT") {
	        result = this.getCurrentUser()[this._modelConstants.Points];
	      } else if (component == "REFUNDS_ELIGIBLE") {
	        result = this.getEligibleRefunds().length;
	      } else if (component == "POINTS_FOR_REWARD") {
	        // not implemented anymore
	      } else if (component == "CREDITS_LEFT") {
	        var key = this._modelConstants.Credits;
	        result = this.localizedDollars(this.getCurrentUser()[key]);
	      } else if (component == "REWARDS_LEFT") {
	        // not implemented anymore
	      } else if (component == "REWARD_NAME_CONTEXTUAL") {
	        // not implemented anymore
	      } else if (component == "POINTS_REQUIRED_NAME_CONTEXTUAL") {
	        // not implemented anymore
	      } else if (component == "POINTS_NAME_CONTEXTUAL") {
	        var numPoints = parseInt(this.getCurrentUser()[this._modelConstants.Points]);
	        if (numPoints == 1) result = this.localizedStringForKey("POINTS_NAME_SINGULAR");else result = this.localizedStringForKey("POINTS_NAME_PLURAL");
	      } else if (component == "POINTS_REQUIRED") {
	        // not implemented anymore
	      } else if (typeof this.getConstants()[component] !== 'undefined') {
	        result = this.getConstants()[component];
	      } else {
	        var periodComponents = component.split(".");
	        if (periodComponents.length > 1) {
	          if (periodComponents[0] == "User") {
	            if (this.getCurrentUser() && typeof this.getCurrentUser()[periodComponents[1]] !== 'undefined') {
	              var value = this.getCurrentUser()[periodComponents[1]];
	              if (typeof value !== 'undefined') {
	                if (periodComponents.length > 2) {
	                  if (periodComponents[2] == "Dollars") result = this.localizedDollars(parseFloat(value));else if (periodComponents[2] == "Points") result = this.localizedPoints(parseFloat(value));
	                } else {
	                  result = value;
	                }
	              }
	            }
	          } else {
	            var feature = this.getFeatureDict()[periodComponents[0]];
	            if (typeof feature !== 'undefined' && typeof feature.data[periodComponents[1]] !== 'undefined') {
	              result = this.localizedStringForKeyAndParams(feature.data[periodComponents[1]], params);
	            }
	          }
	        } else if (params != null && typeof params !== 'undefined') {
	          for (var j = 0; j < params.length; j++) {
	            if (component == j + "") {
	              result = params[j];
	              break;
	            }
	          }
	        }
	      }
	
	      if (result != null) {
	        outputString += result;
	      } else {
	        // TODO: re-enable percent signs.  I can't figure this out right now.
	        // 				if( component != components[0] ) outputString += "%";
	        outputString += component;
	        // 				if( component != components[components.length-1] ) outputString += "%";
	      }
	    }
	
	    return typeof fallback === 'undefined' || outputString != key ? outputString : this.localizedStringForKeyAndParams(fallback, params);
	  },
	
	  localizedDollarSymbol: function localizedDollarSymbol() {
	    var currencySign = this._appManager.getCurrencySign();
	
	    return currencySign;
	  },
	
	  shouldUseComma: function shouldUseComma() {
	    return this._appManager != null && typeof this._appManager.getDeviceInfo().locale !== 'undefined' && this._appManager.getDeviceInfo().locale == "fr-CA";
	  },
	
	  localizedDollars: function localizedDollars(price) {
	    var currencySign = this.localizedDollarSymbol();
	    var shouldUseComma = this.shouldUseComma();
	    if (shouldUseComma) {
	      if (typeof price === 'undefined') return currencySign + "0,00";
	      if (typeof price === 'string') {
	        price = price.replace(",", ".");
	        price = parseFloat(price);
	      }
	
	      var isNegative = price < 0;
	      price = Math.abs(price);
	
	      var strPrice = price.toFixed(2).toString();
	      strPrice = strPrice.replace(".", ",");
	
	      return (isNegative ? "-" : "") + strPrice + " " + currencySign;
	    }
	
	    if (typeof price === 'undefined') return currencySign + "0.00";
	    if (typeof price === 'string') {
	      price = price.replace(",", "");
	      price = parseFloat(price);
	    }
	
	    var isNegative = price < 0;
	    price = Math.abs(price);
	
	    var strPrice = price.toFixed(2).toString();
	    var a = strPrice.split('');
	    a = typeof a === 'undefined' || a == null ? "" : a;
	    if (price > 1000000000) a.splice(a.length - 12, 0, ',');
	
	    if (price > 1000000) a.splice(a.length - 9, 0, ',');
	
	    if (price > 1000) a.splice(a.length - 6, 0, ',');
	
	    return (isNegative ? "-" : "") + currencySign + a.join("");
	  },
	
	  localizedDollarsShort: function localizedDollarsShort(price) {
	    var localized = this.localizedDollars(price);
	    if (localized.substring(localized.length - 3) == ".00") return localized.substring(0, localized.length - 3);
	
	    return localized;
	  },
	
	  localizedPhone: function localizedPhone(phoneString) {
	    if (!this.isValidPhone(phoneString)) return phoneString;
	
	    return phoneString.substring(0, 1) + "-" + phoneString.substring(1, 4) + "-" + phoneString.substring(4, 7) + "-" + phoneString.substring(7, 11);
	  },
	
	  isValidPhone: function isValidPhone(phoneNumber) {
	    if (phoneNumber.length != 11) return false;
	    if (isNaN(phoneNumber)) return false;
	
	    return true;
	  },
	
	  localizedDistance: function localizedDistance(distanceM) {
	    if (this._defaultDistance == "feet") {
	      distanceM = parseFloat(distanceM);
	      var distanceF = 3.28084 * distanceM;
	      var distanceMiles = parseFloat(distanceF / 5280);
	      if (distanceMiles > 1) return distanceMiles.toFixed(2) + " mi.";
	
	      return distanceF.toFixed(2) + " ft";
	    }
	
	    distanceM = parseFloat(distanceM);
	    if (distanceM >= 1000) return (distanceM / 1000).toFixed(2) + " km";
	
	    return distanceM.toFixed(2) + " m";
	  },
	
	  localizedTime: function localizedTime(timeString) {
	    var timeStringLower = timeString.toLowerCase();
	    var is12hr = timeStringLower.indexOf("am") >= 0 || timeStringLower.indexOf("pm") >= 0;
	    if (is12hr) {
	      if (this._defaultTime == "12") return timeString;
	
	      // convert 12 -> 24
	      var isAM = timeStringLower.indexOf("am") >= 0;
	      if (isAM) {
	        var strippedTimeString = timeStringLower.replace("am", "").trim();
	        var timeStringParts = strippedTimeString.split(":");
	        if (timeStringParts.length != 2) return timeString;
	
	        var hoursString = timeStringParts[0];
	        var minutesString = timeStringParts[1];
	        if (hoursString.length <= 0 || minutesString.length <= 0) return timeString;
	
	        return parseInt(hoursString) + (parseInt(hoursString) == 12 ? 12 : 0) + ":" + minutesString;
	      } else {
	        var strippedTimeString = timeStringLower.replace("pm", "").trim();
	        var timeStringParts = strippedTimeString.split(":");
	        if (timeStringParts.length != 2) return timeString;
	
	        var hoursString = timeStringParts[0];
	        var minutesString = timeStringParts[1];
	        if (hoursString.length <= 0 || minutesString.length <= 0) return timeString;
	
	        return parseInt(hoursString) + (parseInt(hoursString) != 12 ? 12 : 0) + ":" + minutesString;
	      }
	    } else // is 24 times
	      {
	        // convert 24 -> 12
	        var strippedTimeString = timeStringLower.trim();
	        var timeStringParts = strippedTimeString.split(":");
	        if (timeStringParts.length != 2) return timeString;
	
	        var hoursString = timeStringParts[0];
	        var minutesString = timeStringParts[1];
	        if (hoursString.length <= 0 || minutesString.length <= 0) return timeString;
	
	        if (this._defaultTime == "24") {
	          return (parseInt(hoursString) == 0 ? "24" : hoursString) + ":" + minutesString;
	        }
	
	        var isAM = parseInt(hoursString) == 24 || parseInt(hoursString) < 12;
	        var newHours = parseInt(hoursString) % 12;
	        if (newHours == 0) newHours = 12;
	        return newHours + ":" + minutesString + (isAM ? " am" : " pm");
	      }
	
	    return timeString;
	  },
	
	  localizedPoints: function localizedPoints(points) {
	    if (typeof points === 'undefined') return "0 " + this.localizedStringForKey("POINTS_NAME_PLURAL");
	    if (typeof points === 'string') points = parseFloat(points);
	
	    if (points == 1) {
	      return points + " " + this.localizedStringForKey("POINTS_NAME_SINGULAR");
	    } else {
	      return points + " " + this.localizedStringForKey("POINTS_NAME_PLURAL");
	    }
	  },
	
	  localizedPts: function localizedPts(points) {
	    if (typeof points === 'undefined') return "0 " + this.localizedStringForKey("POINTS_NAME_SHORT_PLURAL");
	    if (typeof points === 'string') points = parseFloat(points);
	
	    if (points == 1) {
	      return points + " " + this.localizedStringForKey("POINTS_NAME_SHORT_SINGULAR");
	    } else {
	      return points + " " + this.localizedStringForKey("POINTS_NAME_SHORT_PLURAL");
	    }
	  },
	
	  localizedRewards: function localizedRewards(rewards) {
	    // not needed
	    return "";
	  },
	
	  localizedLongDate: function localizedLongDate(dateString) {
	    this.setupMomentLocale();
	    var now = moment(dateString).fromNow();
	
	    return now;
	  },
	
	  localizedLongDateFuture: function localizedLongDateFuture(dateString) {
	    this.setupMomentLocale();
	    var now = moment(dateString).fromNow();
	
	    return now;
	  },
	
	  localizedDate: function localizedDate(dateString) {
	    var now = moment(dateString).format("MMMM DD, YYYY");
	
	    return now;
	  },
	
	  dateTime: function dateTime(dateString) {
	    var now = moment(dateString).format('MMM DD, YYYY HH:mm');
	
	    return now;
	  },
	
	  dateTimeGrabb: function dateTimeGrabb(dateString) {
	    var now = moment(dateString).format('YYYY-MM-DDTHH:mm:ss');
	
	    return now;
	  },
	
	  dateTimeAuphan: function dateTimeAuphan(dateString) {
	    var now = moment(dateString).format('YYYY-MM-DD');
	
	    return now;
	  },
	
	  dateTimeReUp: function dateTimeReUp(dateString) {
	    var now = moment(dateString).format('YYYY-MM-DD');
	
	    return now;
	  },
	
	  nameOfDay: function nameOfDay(dayNumber) {
	    this.setupMomentLocale();
	
	    return moment().weekday(dayNumber).format('dddd');
	  },
	
	  setupMomentLocale: function setupMomentLocale() {
	    if (this._appManager != null) {
	      var locale = Platform.OS == "web" ? window.navigator.userLanguage || window.navigator.language : this._appManager.getDeviceInfo().locale;
	      if (locale.indexOf("fr-") === 0) moment.locale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	          LT: 'HH:mm',
	          LTS: 'HH:mm:ss',
	          L: 'DD/MM/YYYY',
	          LL: 'D MMMM YYYY',
	          LLL: 'D MMMM YYYY HH:mm',
	          LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	          sameDay: '[Aujourd’hui à] LT',
	          nextDay: '[Demain à] LT',
	          nextWeek: 'dddd [à] LT',
	          lastDay: '[Hier à] LT',
	          lastWeek: 'dddd [dernier à] LT',
	          sameElse: 'L'
	        },
	        relativeTime: {
	          future: 'dans %s',
	          past: 'il y a %s',
	          s: 'quelques secondes',
	          m: 'une minute',
	          mm: '%d minutes',
	          h: 'une heure',
	          hh: '%d heures',
	          d: 'un jour',
	          dd: '%d jours',
	          M: 'un mois',
	          MM: '%d mois',
	          y: 'un an',
	          yy: '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function ordinal(number) {
	          return number + (number === 1 ? 'er' : 'e');
	        },
	        meridiemParse: /PD|MD/,
	        isPM: function isPM(input) {
	          return input.charAt(0) === 'M';
	        },
	        // In case the meridiem units are not separated around 12, then implement
	        // this function (look at locale/id.js for an example).
	        // meridiemHour : function (hour, meridiem) {
	        //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
	        // },
	        meridiem: function meridiem(hours, minutes, isLower) {
	          return hours < 12 ? 'PD' : 'MD';
	        },
	        week: {
	          dow: 0, // Sunday is the first day of the week.
	          doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	      });
	    }
	  },
	
	  localizedStringForKey: function localizedStringForKey(key, fallback) {
	    if (this.shouldShowKey()) return key;
	
	    var result = this.localizedStringForKeyAndParams(key, []);
	
	    return typeof fallback === 'undefined' || result != key ? result : fallback;
	  },
	
	  localizedStringForKeyParams: function localizedStringForKeyParams(keyParams) {
	    if (keyParams.length <= 0) return "";
	    var key = keyParams[0];
	    var params = [];
	    for (var i = 1; i < keyParams.length; i++) {
	      params.push(keyParams[i]);
	    }
	
	    return this.localizedStringForKeyAndParams(key, params);
	  }
	
	};
	
	module.exports = LocalizationManager;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	// var Communications = require('react-native-communications');
	var PhoneManager = __webpack_require__(1162);
	var LinkingManager = __webpack_require__(27);
	// var url = "https://www.google.com/maps?q="+location.Address.Latitude+","+location.Address.Longitude
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var MapView = __webpack_require__(78);
	
	var MK = __webpack_require__(14);
	
	var ReUpButton = __webpack_require__(12);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var LOCATION_UPDATE_CD = 500;
	
	function titleCase(str) {
	  var splitStr = str.toLowerCase().split(' ');
	  for (var i = 0; i < splitStr.length; i++) {
	    // You do not need to check if i is larger than splitStr length, as your for does that for you
	    // Assign it back to the array
	    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
	  }
	  // Directly return the joined string
	  return splitStr.join(' ');
	}
	
	var Locations = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      locations: [],
	      region: { latitude: 0, longitude: 0, latitudeDelta: 0, longitudeDelta: 0 },
	      selectedLocation: null,
	      currentPosition: this.props.appManager.getCurrentPosition(),
	      markers: [],
	      showingAll: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.didUpdate();
	
	    var thisThing = this;
	    this.props.appManager.updateCurrentPosition(function () {
	      // if location is different, then do an update
	      if (thisThing._ptr) thisThing._ptr.doOnlineUpdate();
	    });
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	
	    if (typeof data === 'undefined') {
	      // var thisThing = this;
	      // this.props.appManager.getDataType("Locations", function(data)
	      // {
	      //   var oldLocations = thisThing.state.locations;
	      //   var oldSelectedLocation = thisThing.state.selectedLocation;
	      //   var newSelectedLocation = data.length > 0 ? data[0] : null;
	      //   if( oldSelectedLocation != null )
	      //   {
	      //     for( var i = 0; i < data.length; i++ )
	      //     {
	      //       var thisLoc = data[i];
	      //       if( thisLoc.LocationID == oldSelectedLocation.LocationID )
	      //       {
	      //         newSelectedLocation = thisLoc;
	      //         break;
	      //       }
	      //     }
	      //   }
	      //   thisThing.setState({locations:data, selectedLocation: newSelectedLocation});
	      // })
	      if (this.state.locations.length > 0 && this.state.selectedLocation == null) {
	        this.didSelectLocation(this.state.locations[0]);
	      }
	    } else if (typeof data.Locations !== 'undefined') {
	      var oldLocations = this.state.locations;
	      var oldSelectedLocation = this.state.selectedLocation;
	      var locations = data.Locations;
	      var filteredLocations = [];
	      var markers = [];
	      var addedLocationIDs = [];
	      for (var i = 0; i < locations.length; i++) {
	        var location = locations[i];
	        if (addedLocationIDs.indexOf(location.LocationID) > -1) continue;
	
	        if (location.IsDeleted != "1" || location.IsDisabled != "1") {
	          addedLocationIDs.push(location.LocationID);
	          location.distance = thisThing.calculateDistance(location.Latitude, location.Longitude, thisThing.state.currentPosition.latitude, thisThing.state.currentPosition.longitude);
	          markers.push({
	            latlng: {
	              latitude: parseFloat(location.Latitude),
	              longitude: parseFloat(location.Longitude)
	            },
	            title: location.Name,
	            description: location.Description
	          });
	          filteredLocations.push(location);
	        }
	      }
	      locations = filteredLocations;
	      // var locations = data.Locations.sort(function(a,b)
	      // {
	      // 	return a.Name.localeCompare(b.Name);
	      // })
	      // var newSelectedLocation = locations.length > 0 ? locations[0] : this.state.selectedLocation;
	      // if( oldSelectedLocation != null )
	      // {
	      //   for( var i = 0; i < locations.length; i++ )
	      //   {
	      //     var thisLoc = locations[i];
	      //     if( thisLoc.LocationID == oldSelectedLocation.LocationID )
	      //     {
	      //       newSelectedLocation = thisLoc;
	      //       break;
	      //     }
	      //   }
	      // }
	      // var selectedRegion;
	      // if( newSelectedLocation != null )
	      // {
	      //   var latitude = parseFloat(newSelectedLocation.Latitude);
	      //   var longitude = parseFloat(newSelectedLocation.Longitude);
	      //
	      //   selectedRegion =
	      //   {
	      //     latitude:latitude,
	      //     longitude:longitude,
	      //     latitudeDelta:0.002,
	      //     longitudeDelta:0.002,
	      //   }
	      // }
	
	      var sortedLocations = locations.sort(function (a, b) {
	        if (a.distance == b.distance) return a.Name.localeCompare(b.Name);
	
	        return parseFloat(a.distance) - parseFloat(b.distance);
	      });
	
	      thisThing.setState({ locations: sortedLocations, markers: markers });
	    } else {
	      // if( this.state.locations.length > 0 && this.state.selectedLocation == null )
	      // {
	      //   this.didSelectLocation(this.state.locations[0]);
	      // }
	    }
	  },
	
	  didSelectLocation: function didSelectLocation(location) {
	    var latitude = parseFloat(location.Latitude);
	    var longitude = parseFloat(location.Longitude);
	
	    var selectedRegion = {
	      latitude: latitude,
	      longitude: longitude,
	      latitudeDelta: .002,
	      longitudeDelta: .002
	    };
	
	    this.setState({ region: selectedRegion, selectedLocation: location });
	  },
	
	  callLocation: function callLocation(location) {
	    PhoneManager.call(location.Phone);
	  },
	
	  openMaps: function openMaps(location) {
	    var url = "https://www.google.com/maps?q=" + location.Latitude + "," + location.Longitude;
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.openURL(url, tintColor, barTintColor);
	  },
	
	  onRegionChange: function onRegionChange(region) {
	    this.state.region = region;
	  },
	
	  calculateDistance: function calculateDistance(lat1, lon1, lat2, lon2) {
	    var radlat1 = Math.PI * lat1 / 180;
	    var radlat2 = Math.PI * lat2 / 180;
	    var theta = lon1 - lon2;
	    var radtheta = Math.PI * theta / 180;
	    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	    dist = Math.acos(dist);
	    dist = dist * 180 / Math.PI;
	    dist = dist * 60 * 1.1515;
	    return dist.toFixed(2);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	
	    if (this.state.locations.length > 0 && this.state.selectedLocation == null) {
	      this.didSelectLocation(this.state.locations[0]);
	    } else if (typeof this.state.region !== 'undefined' && this.state.region.longitudeDelta <= 0 && this.state.selectedLocation != null) {
	      this.didSelectLocation(this.state.selectedLocation);
	    }
	    var thisLocations = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var locations = this.state.locations;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var phoneLabel = locManager.localizedStringForKey("PHONE_OPTION") + ":";
	    var closedLabel = locManager.localizedStringForKey("CLOSED_LABEL");
	
	    var markerTitle = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_TITLE");
	    var markerBody = locManager.localizedStringForKey("MARKER_YOUR_LOCATION_BODY");
	    var selectedLocation = this.state.selectedLocation == null ? locations.length > 0 ? locations[0] : null : this.state.selectedLocation;
	    var markers = this.state.markers;
	
	    var selectedRegion = this.state.selectedRegion;
	    if (selectedLocation != null && selectedRegion == null) {
	      var latitude = parseFloat(selectedLocation.Latitude);
	      var longitude = parseFloat(selectedLocation.Longitude);
	
	      selectedRegion = {
	        latitude: latitude,
	        longitude: longitude,
	        latitudeDelta: 0.002,
	        longitudeDelta: 0.002
	      };
	    }
	
	    var AccentColoredFab = MKButton.accentColoredFab().withStyle(styles.callButton).build();
	    // MapView key={"map"} annotations={annotations} style={[styles.mapView]} {...otherProps} />
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor, flexDirection: 'column' }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      Platform.OS != 'web' ? React.createElement(View, { style: { height: locations.length <= 0 ? 0 : 200 } }) : null,
	      React.createElement(
	        ReUpScrollView,
	        { ref: function ref(a) {
	            return _this._ptr = a;
	          }, style: styles.locationList, bounces: true, responder: this, isEmpty: locations.length <= 0, featureName: 'Locations' },
	        locations.map(function (location, index) {
	          if (index > 2 && !thisThing.state.showingAll) return null;
	
	          var hours = typeof location.Hours !== 'undefined' && location.Hours != null && location.Hours.length > 0 ? JSON.parse(location.Hours) : [];
	
	          return React.createElement(
	            View,
	            { key: "locrow-" + location.LocationID },
	            React.createElement(
	              View,
	              null,
	              React.createElement(
	                MKButton,
	                { key: location.LocationID,
	                  backgroundColor: 'transparent',
	                  shadowRadius: 2,
	                  shadowOffset: { width: 0, height: 2 },
	                  shadowOpacity: 0.7,
	                  shadowColor: 'transparent',
	                  onPress: function onPress() {
	                    thisLocations.didSelectLocation(location);
	                  }, style: styles.rowContainer },
	                React.createElement(
	                  View,
	                  { style: styles.row },
	                  React.createElement(
	                    View,
	                    { style: styles.topContainer },
	                    React.createElement(_ReUpIcon2.default, { style: styles.mapIcon, name: "map-marker", size: 25, color: secondaryButtonTitleColor }),
	                    React.createElement(
	                      View,
	                      { style: styles.infoContainer },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor, fontSize: 22 } },
	                        location.Name
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { paddingTop: 4, color: generalTitleColor } },
	                        location.Address
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: styles.phone },
	                        phoneLabel + " " + location.Phone
	                      )
	                    )
	                  )
	                )
	              ),
	              React.createElement(
	                View,
	                { style: styles.buttonContainer },
	                React.createElement(
	                  AccentColoredFab,
	                  {
	                    backgroundColor: secondaryButtonColor,
	                    shadowRadius: 2,
	                    shadowOffset: { width: 0, height: 0 },
	                    shadowOpacity: 0,
	                    shadowColor: secondaryButtonBorderColor,
	                    style: styles.callButton,
	                    onPress: function onPress() {
	                      thisLocations.callLocation(location);
	                    } },
	                  React.createElement(_ReUpIcon2.default, { style: styles.callIcon, name: "phone", size: 25, color: secondaryButtonTitleColor })
	                )
	              )
	            ),
	            !isNaN(location.distance) ? React.createElement(
	              View,
	              { style: { flexDirection: 'row', justifyContent: 'flex-end', marginRight: 0 } },
	              React.createElement(
	                View,
	                { style: { flex: 1, height: 70, flexDirection: 'row', alignItems: 'center', marginLeft: 20 } },
	                React.createElement(
	                  ReUpText,
	                  { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: generalTitleColor, marginLeft: 15 } },
	                  locManager.localizedDistance(location.distance * 1000)
	                )
	              ),
	              React.createElement(
	                View,
	                { style: [styles.buttonContainer, { height: 50 }] },
	                React.createElement(
	                  AccentColoredFab,
	                  {
	                    backgroundColor: secondaryButtonColor,
	                    shadowRadius: 2,
	                    shadowOffset: { width: 0, height: 0 },
	                    shadowOpacity: 0,
	                    shadowColor: secondaryButtonBorderColor,
	                    style: styles.callButton,
	                    onPress: function onPress() {
	                      thisLocations.openMaps(location);
	                    } },
	                  React.createElement(_ReUpIcon2.default, { style: styles.callIcon, name: "compass", size: 25, color: secondaryButtonTitleColor })
	                )
	              )
	            ) : null,
	            typeof hours === 'undefined' || selectedLocation == null || selectedLocation.LocationID != location.LocationID ? React.createElement(View, null) : React.createElement(
	              View,
	              { style: styles.hours },
	              hours.map(function (hour, index) {
	                var isClosed = !hour.isActive;
	                var dayName = locManager.nameOfDay((index + 1) % 7);
	                var time = isClosed ? closedLabel : locManager.localizedTime(hour.timeFrom) + " - " + locManager.localizedTime(hour.timeTill);
	                return React.createElement(
	                  View,
	                  { style: styles.hour },
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.dayText, { color: generalTitleColor }] },
	                    dayName
	                  ),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.time, { color: generalTitleColor }] },
	                    time
	                  )
	                );
	              })
	            ),
	            React.createElement(View, { style: styles.divider })
	          );
	        }),
	        !this.state.showingAll && locations.length > 2 ? React.createElement(ReUpButton, { isSecondary: true, onPress: function onPress() {
	            _this.setState({ showingAll: true });
	          }, style: { marginVertical: 10, marginHorizontal: 20 }, appManager: appManager, text: titleCase(locManager.localizedStringForKey("MORE_LABEL")) }) : null
	      ),
	      locations.length !== 0 ? React.createElement(
	        MapView,
	        { key: 'mapview',
	          region: this.state.region,
	          onRegionChange: this.onRegionChange,
	          style: [styles.mapView, { position: 'absolute', left: 0, right: 0, top: this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, height: 200 }]
	        },
	        markers.map(function (marker) {
	          return React.createElement(MapView.Marker, {
	            coordinate: marker.latlng,
	            title: marker.title,
	            description: marker.description
	          });
	        }),
	        React.createElement(MapView.Marker, {
	          coordinate: thisLocations.state.currentPosition,
	          title: markerTitle,
	          description: markerBody,
	          pinColor: 'blue'
	        })
	      ) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  mapView: {
	    flex: 1,
	    borderColor: '#000000'
	  },
	  locationList: {
	    flex: 1
	  },
	  divider: {
	    marginTop: 10,
	    height: 1,
	    backgroundColor: '#DADADA'
	  },
	  row: {
	    padding: 10,
	    paddingBottom: 0
	  },
	  phone: {
	    paddingTop: 4,
	    paddingBottom: 4
	  },
	  hour: {
	    paddingLeft: 20,
	    paddingRight: 20,
	    flexDirection: 'row'
	  },
	  dayText: {
	    fontStyle: 'italic',
	    flex: 1
	  },
	  time: {
	    fontStyle: 'italic',
	    flex: 1,
	    textAlign: 'right'
	  },
	  topContainer: {
	    flexDirection: 'row',
	    marginRight: 60
	  },
	  infoContainer: {
	    flex: 1
	  },
	  buttonContainer: {
	    width: 50,
	    alignItems: 'flex-end',
	    position: 'absolute',
	    right: 10,
	    top: 10
	  },
	  callButton: {
	    position: 'absolute',
	    borderRadius: 25,
	    width: 50,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center'
	  },
	  mapIcon: {
	    marginTop: 5,
	    marginRight: 10
	  }
	});
	
	Locations.dataDependencies = ["Locations"];
	
	module.exports = Locations;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpField = __webpack_require__(26);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	var AnalyticsManager = __webpack_require__(50);
	
	var Keyboard = __webpack_require__(76);
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	
	
	var FBSDK = __webpack_require__(152);
	var LoginManager = FBSDK.LoginManager,
	    AccessToken = FBSDK.AccessToken;
	
	
	var FeedCard = __webpack_require__(41);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var Login = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    setTimeout(function () {
	      if (typeof thisThing.refs.loginCard !== 'undefined' && thisThing.refs.loginCard != null) thisThing.refs.loginCard.focus();
	    }, 400);
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	
	  loginPressed: function loginPressed(username, password) {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    var loggingIn = this.props.appManager.getLocalizationManager().localizedStringForKey("LOGIN_HUD");
	    appActions.setSpinnerShown(true, loggingIn);
	    Keyboard.dismiss();
	    NetworkManager.login(appManager, username.trim(), password, function (data) {
	      AnalyticsManager.logLoginEvent(appManager, 'regular', true);
	      data[ModelConstants.Password] = password;
	      appManager.setCurrentUser(data, function () {
	        appActions.setSpinnerShown(false);
	        if (data[ModelConstants.DirtyPassword] == 1) {
	          thisThing.showChangePass();
	        } else {
	          appActions.requestPop(true);
	        }
	      });
	    }, function (data) {
	      AnalyticsManager.logLoginEvent(appManager, 'regular', false);
	      appActions.setSpinnerShown(false);
	      if (data.code == -23) // not verified
	        {
	          appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function () {
	            appActions.setSpinnerShown(true, "");
	            NetworkManager.resendVerifyEmail(appManager, username, function () {
	              appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              appActions.setSpinnerShown(false);
	            }, function () {
	              appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              appActions.setSpinnerShown(false);
	            }, function () {
	              appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	              appActions.setSpinnerShown(false);
	            });
	          }], appActions.hideAlert);
	        } else {
	        appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	      }
	    }, function (data) {
	      AnalyticsManager.logLoginEvent(appManager, 'regular', false);
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	    });
	  },
	
	  loginFacebookPressed: function loginFacebookPressed() {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    appActions.setSpinnerShown(true);
	    LoginManager.logInWithReadPermissions(['email', 'public_profile']).then(function (result) {
	      if (result.isCancelled) {
	        console.log("Facebook cancelled");
	        appActions.setSpinnerShown(false);
	      } else {
	        AccessToken.getCurrentAccessToken().then(function (data) {
	          var password = data.accessToken.toString();
	          NetworkManager.createUserFacebook(appManager, password, "", true, function (email) {
	            NetworkManager.login(appManager, email, password, function (data) {
	              data[ModelConstants.Password] = password;
	              appManager.setCurrentUser(data, function () {
	                appActions.setSpinnerShown(false);
	                appActions.requestPop(true);
	              });
	            }, function () {
	              appActions.setSpinnerShown(false);
	              appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	            }, function () {
	              appActions.setSpinnerShown(false);
	              appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	            });
	          }, function () {
	            appActions.setSpinnerShown(false);
	            appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	          });
	        });
	      }
	    }, function (error) {
	      appActions.setSpinnerShown(false);
	      appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	      console.log('Login fail with error: ' + error);
	    });
	  },
	
	  _showPassword: false,
	  _currentPassword: "",
	  _newPassword: "",
	  _currentPasswordError: false,
	  _newPasswordError: false,
	  showChangePass: function showChangePass() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locManager = thisThing.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	
	    var locMan = appManager.getLocalizationManager();
	    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	    var newPassDescription = locMan.localizedStringForKey("SET_NEW_PASSWORD_STATEMENT");
	    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
	    var currPass = appManager.currentUser()[ModelConstants.Password];
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column' } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	          "Change Password"
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { marginTop: 10, textAlign: 'center' } },
	          newPassDescription
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row' } },
	          React.createElement(ReUpField, {
	            onChangeText: function onChangeText(text) {
	              _this._newPassword = text;
	            },
	            key: 'password',
	            ref: function ref(a) {
	              return thisThing._passwordField = a;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            textInputStyle: { color: generalTitleColor, fontFamily: 'Arial' },
	            appManager: appManager,
	            placeholder: newPassPlaceholder,
	            secureTextEntry: !this._showPassword,
	            style: [{ flex: 1, alignSelf: 'center', height: 50 }] }),
	          React.createElement(
	            MKIconToggle,
	            {
	              style: { marginTop: 22, height: 30, width: 30, position: 'absolute', right: 0, backgroundColor: 'transparent' },
	              checked: this._showPassword,
	              onCheckedChange: function onCheckedChange(info) {
	                thisThing._passwordField.onBlur();
	                thisThing._showPassword = info.checked;
	                thisThing.showChangePass();
	              }
	            },
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	          )
	        ),
	        React.createElement(ReUpButton, { onPress: function onPress() {
	            if (appManager.isValidPassword(thisThing._newPassword)) {
	              thisThing.changePassword(thisThing._newPassword);
	            } else {
	              appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showChangePass], function () {});
	            }
	          }, appManager: this.props.appManager, text: changePasswordButton, style: [styles.logoutButton, { marginTop: 10, marginBottom: 10 }] })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {
	      appActions.requestPop(true);
	    });
	  },
	
	  changePassword: function changePassword(newPass) {
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locMan = appManager.getLocalizationManager();
	    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
	    thisThing.props.appActions.setSpinnerShown(true, changingPassword);
	    NetworkManager.changePassword(this.props.appManager, newPass, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var user = appManager.getCurrentUser(function (currentUser) {
	        currentUser[ModelConstants.Password] = newPass;
	        appManager.setCurrentUser(currentUser, function () {
	          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
	          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
	          var okayButton = locMan.localizedStringForKey("VERSION_OKAY_ALERT_OPTION");
	
	          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function () {
	            thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	          }], function () {
	            appActions.setSpinnerShown(false);appActions.requestPop(true);
	          });
	        });
	      });
	    }, function (data) {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
	      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
	      var okayButton = locMan.localizedStringForKey("OKAY_ALERT_OPTION");
	
	      thisThing.props.appActions.showAlert(title, body, [okayButton], [function () {
	        thisThing.showChangePass();
	      }], function () {
	        thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	      });
	    }, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      thisThing.props.appActions.showNetworkErrorAlert(function () {
	        thisThing.showChangePass();
	      }, function () {
	        thisThing.props.appActions.hideAlert();appActions.setSpinnerShown(false);appActions.requestPop(true);
	      });
	    });
	  },
	
	  forgotPasswordPressed: function forgotPasswordPressed() {
	    var thisThing = this;
	    thisThing._email = "";
	    var appManager = thisThing.props.appManager;
	    var locManager = thisThing.props.appManager.getLocalizationManager();
	
	    var forgotPasswordFeature = appManager.getFeatureForName("ForgotPassword");
	    var forgotPasswordTitle = locManager.localizedStringForKey(forgotPasswordFeature.data.tip);
	    var forgotPasswordBody = locManager.localizedStringForKey(forgotPasswordFeature.data.instructions);
	    var emailMeButton = locManager.localizedStringForKey("EMAIL_PASSWORD_BUTTON");
	    var emailBody = locManager.localizedStringForKey("EMAIL_LABEL");
	
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; // appManager.getColorForKey("FeedCardBannerColor");
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	          forgotPasswordTitle
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { marginTop: 10, textAlign: 'center' } },
	          forgotPasswordBody
	        ),
	        React.createElement(ReUpField, { ref: function ref(a) {
	            if (typeof a !== 'undefined' && a != null) a.focus();
	          }, appManager: appManager,
	          onChangeText: function onChangeText(newText) {
	            thisThing._email = newText;
	          },
	          placeholder: emailBody,
	          secureTextEntry: false,
	          autoCapitalize: 'none',
	          autoCorrect: false,
	          keyboardType: 'email-address',
	          tintColor: 'black',
	          highlightColor: 'black',
	          textInputStyle: { color: generalTitleColor } }),
	        React.createElement(ReUpButton, { text: emailMeButton, onPress: function onPress() {
	            var checkingUserLabel = appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD");
	            thisThing.props.appActions.setSpinnerShown(true, checkingUserLabel);
	            NetworkManager.forgotPassword(appManager, thisThing._email, function () {
	              thisThing.props.appActions.setSpinnerShown(false);
	              var successTitle = locManager.localizedStringForKey("EMAIL_PASS_SUCCESS_ALERT_TITLE");
	              var successBody = locManager.localizedStringForKey("EMAIL_PASS_SUCCESS_ALERT_BODY");
	              var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	              thisThing.props.appActions.showAlert(successTitle, successBody, [successOkay], [thisThing.props.appActions.hideAlert], function () {});
	            }, function () {
	              thisThing.props.appActions.setSpinnerShown(false);
	              var errorTitle = locManager.localizedStringForKey("EMAIL_PASS_FAIL_ALERT_TITLE");
	              var errorBody = locManager.localizedStringForKey("EMAIL_PASS_FAIL_ALERT_BODY");
	              var errorOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	              thisThing.props.appActions.showAlert(errorTitle, errorBody, [errorOkay], [thisThing.forgotPasswordPressed], function () {});
	            }, function () {
	              thisThing.props.appActions.setSpinnerShown(false);
	              thisThing.props.appActions.showNetworkErrorAlert(thisThing.forgotPasswordPressed, thisThing.forgotPasswordPressed);
	            });
	          }, appManager: thisThing.props.appManager, style: [styles.logoutButton, { marginTop: 10, marginBottom: 10 }] })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  registerPressed: function registerPressed() {
	    this.props.appActions.requestFeatureName("CreateUser");
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var createUserFeatureData = appManager.getFeatureForName("CreateUser");
	    var feedFeatureData = appManager.getFeatureForName("Feed");
	
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(Image, {
	        key: appManager.getImageKey("loginbg"),
	        style: { position: 'absolute', left: 0, right: 0, bottom: 0, top: 0 },
	        source: { uri: bgImage }
	      }),
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(FeedCard, { loginFeatureData: this.props.featureData, createUserFeatureData: createUserFeatureData.data,
	          ref: 'loginCard',
	          cardType: 2,
	          iconColor: bannerIconColor,
	          bannerColor: bannerColor,
	          cardColor: cardColor,
	          titleColor: titleColor,
	          bodyColor: bodyColor,
	          appManager: appManager,
	          loginPressed: this.loginPressed,
	          registerPressed: this.registerPressed,
	          loginFacebookPressed: this.loginFacebookPressed,
	          forgotPasswordPressed: this.forgotPasswordPressed
	        }),
	        React.createElement(FeedCard, { createUserFeatureData: createUserFeatureData.data,
	          ref: 'createCard',
	          cardType: 4,
	          iconColor: bannerIconColor,
	          bannerColor: bannerColor,
	          cardColor: cardColor,
	          titleColor: titleColor,
	          bodyColor: bodyColor,
	          appManager: appManager,
	          registerPressed: this.registerPressed
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	Login.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (isLoggedIn) return [];else {
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("Login");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 1
	    }];
	  }
	};
	
	Login.dataDependencies = ["Users"];
	
	module.exports = Login;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var QRCodeView = __webpack_require__(95);
	var AddToWalletButton = __webpack_require__(62);
	var createReactClass = __webpack_require__(5);
	var MK = __webpack_require__(14);
	
	var MKSpinner = MK.MKSpinner;
	var View = ReactNative.View,
	    WebView = ReactNative.WebView,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback,
	    StyleSheet = ReactNative.StyleSheet,
	    Image = ReactNative.Image;
	
	
	var MyCard = createReactClass({
	  displayName: 'MyCard',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      qrData: this.getQRDataFromUser(this.props.appManager.currentUser())
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  getQRDataFromUser: function getQRDataFromUser(user) {
	    if (user == null) return "";
	
	    var data = {
	      "U": user[ModelConstants.UserID],
	      "T": "GC",
	      "H": user[ModelConstants.Hash]
	    };
	
	    var dataJsonString = JSON.stringify(data);
	    var dataBase64 = btoa(dataJsonString);
	
	    return dataBase64;
	  },
	
	  _loggedInRendered: null,
	  _oldHash: null,
	  _oldDollars: null,
	  checkUserChanged: function checkUserChanged() {
	    var appManager = this.props.appManager;
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (loggedIn) {}
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	
	    var stripHeight = this.props.initialLayout.width * 123 / 375;
	
	    var dimension = Math.min(this.props.initialLayout.width - 100, this.props.initialLayout.height - 120 - stripHeight);
	
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: headerColor, height: this.props.initialLayout.height, width: this.props.initialLayout.width }] },
	      React.createElement(
	        View,
	        { style: { width: this.props.initialLayout.width, height: stripHeight, backgroundColor: headerIconColor } },
	        React.createElement(Image, { style: { width: this.props.initialLayout.width, height: stripHeight }, resizeMode: "cover", source: { uri: stripImage } }),
	        React.createElement(
	          View,
	          { style: { position: 'absolute', top: 20, left: 20, right: 20, bottom: 20 } },
	          React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	        )
	      ),
	      React.createElement(View, { style: { flex: 1 } }),
	      React.createElement(QRCodeView, { ref: 'qrcode', key: 'qrcode', data: this.state.qrData, dimension: dimension,
	        style: {
	          alignItems: 'center',
	          backgroundColor: generalColor,
	          borderRadius: 8,
	          alignSelf: 'center',
	          overflow: 'hidden'
	        },
	        positiveColor: 'black', negativeColor: 'white',
	        spinnerView: React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }) }),
	      React.createElement(View, { style: { flex: 1 } }),
	      React.createElement(
	        View,
	        { style: { alignItems: 'center', justifyContent: 'center' } },
	        React.createElement(AddToWalletButton, { appManager: appManager, style: { margin: 8, width: 140, height: 44 } })
	      ),
	      React.createElement(View, { style: { flex: 1 } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    flexBasis: 'auto'
	  }
	});
	MyCard.dataDependencies = ["Users"];
	
	module.exports = MyCard;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	var _reactNativeParallaxScrollViewWrapper = __webpack_require__(97);
	
	var _reactNativeParallaxScrollViewWrapper2 = _interopRequireDefault(_reactNativeParallaxScrollViewWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppActions = __webpack_require__(63);
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var FadingView = __webpack_require__(51);
	var FeedPlusView = __webpack_require__(111);
	var FeedPlusSideView = __webpack_require__(110);
	var OffsetView = __webpack_require__(93);
	var Animated = __webpack_require__(9);
	var ReUpTabBar = __webpack_require__(74);
	var AddToWalletButton = __webpack_require__(62);
	
	var Icon = __webpack_require__(13);
	var FEED_HEADER_HEIGHT = 80;
	
	var Menu = __webpack_require__(75);
	var FeedCard = __webpack_require__(41);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpCountdown = __webpack_require__(73);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MapView = __webpack_require__(78);
	var ReUpButton = __webpack_require__(12);
	var Meter = __webpack_require__(91);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton,
	    MKTextField = MK.MKTextField;
	var View = ReactNative.View,
	    WebView = ReactNative.WebView,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Dimensions = ReactNative.Dimensions,
	    Keyboard = ReactNative.Keyboard,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	
	  return result;
	}
	
	var PassHome = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    var maxWidth = 400;
	    var maxHeight = 700;
	    var width = Math.min(this.props.initialLayout.width - 24, maxWidth);
	    var height = Math.min(this.props.initialLayout.height - 24, maxHeight);
	    // var ratio = parseFloat(750 / 1334);
	    // width = Math.min(width, height*ratio);
	    // height = Math.min(height, width/ratio);
	    var horizontalMargin = (this.props.initialLayout.width - width) / 2;
	    var verticalMargin = (this.props.initialLayout.height - height) / 2;
	    return {
	      horizontalMargin: horizontalMargin,
	      verticalMargin: verticalMargin,
	      rotationFront: new Animated.Value(90),
	      rotationBack: new Animated.Value(90),
	
	      isShowingFront: true,
	
	      isShowingRegistration: false,
	      isShowingFreeHome: false,
	      isShowingHome: false,
	      isShowingLogin: false,
	      isShowingOnlyLogin: false,
	      isShowingError: false,
	      isShowingCFD: false,
	
	      userName: null,
	      phoneNumber: null,
	
	      formOffset: new Animated.Value(0, "formOffset"),
	
	      shouldDrawPage: [true, false],
	
	      backFeatureData: this.props.appManager.getFeatureForName("MyCard")
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    this.props.appManager._eventEmitter.on('checkUserChanged', this.checkUserChanged, this._context++);
	    this.determineUser();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.props.appManager._eventEmitter.removeListener('checkUserChanged', this.checkUserChanged, this._context);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.initialLayout !== 'undefined') {
	      var maxWidth = 400;
	      var maxHeight = 700;
	      var width = Math.min(newProps.initialLayout.width - 24, maxWidth);
	      var height = Math.min(newProps.initialLayout.height - 24, maxHeight);
	      // var ratio = parseFloat(750 / 1234);
	      // width = Math.min(width, height*ratio);
	      // height = Math.min(height, width/ratio);
	      var horizontalMargin = (newProps.initialLayout.width - width) / 2;
	      var verticalMargin = (newProps.initialLayout.height - height) / 2;
	
	      this.setState({ horizontalMargin: horizontalMargin, verticalMargin: verticalMargin });
	    }
	  },
	
	  determineUser: function determineUser() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var userID = findGetParameter("userid");
	    var hash = findGetParameter("hash");
	    console.log("[passhome]", "URL INFO", userID, hash, appManager.currentUser());
	    if (userID != null && hash != null) {
	      // logged into correct account, proceed to pass home
	      NetworkManager.getUser(appManager, userID, hash, function (urlUser) {
	        urlUser[ModelConstants.Password] = hash;
	        NetworkManager.getLinkedUsers(appManager, userID, hash, function (linkedUsers) {
	          var emailUser = null;
	          var phoneUser = null;
	          for (var i = 0; i < linkedUsers.length; i++) {
	            if (linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app") emailUser = linkedUsers[i];
	            if (linkedUsers[i]["Type"] == "phone") phoneUser = linkedUsers[i];
	          }
	          if (phoneUser != null) thisThing.setState({ phoneNumber: locManager.localizedPhone(phoneUser["PhoneNumber"]) });
	
	          if (emailUser == null) {
	            console.log("[passhome]", "no owner, so lets try to register");
	            thisThing.setState({ isShowingRegistration: true });
	            setTimeout(function () {
	              thisThing.showFront();
	            }, 400);
	          } else {
	            userID = emailUser[ModelConstants.UserID];
	            hash = emailUser[ModelConstants.Hash];
	            NetworkManager.getUser(appManager, userID, hash, function (emailUser) {
	              emailUser[ModelConstants.Password] = hash;
	              appManager.setCurrentUser(emailUser, function () {
	                _this.setState({ isShowingHome: true });
	                setTimeout(function () {
	                  thisThing.showFront();
	                }, 400);
	              });
	            }, function () {
	              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	              thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	              setTimeout(function () {
	                thisThing.showFront();
	              }, 400);
	            }, function () {
	              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
	              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
	              thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	              setTimeout(function () {
	                thisThing.showFront();
	              }, 400);
	            });
	          }
	        }, function (errorData) {
	          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	          thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          setTimeout(function () {
	            thisThing.showFront();
	          }, 400);
	          console.log("errorData", errorData);
	        }, function (errorData) {
	          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	          thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          setTimeout(function () {
	            thisThing.showFront();
	          }, 400);
	          console.log("errorData", errorData);
	        });
	      }, function () {
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	        setTimeout(function () {
	          thisThing.showFront();
	        }, 400);
	      }, function () {
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	        setTimeout(function () {
	          thisThing.showFront();
	        }, 400);
	      });
	    } else if (appManager._isDemo) {
	      NetworkManager.login(appManager, "kjregan10@gmail.com", "asdfwxyzabcd", function (urlUser) {
	        userID = urlUser[ModelConstants.UserID];
	        hash = urlUser[ModelConstants.Hash];
	        NetworkManager.getLinkedUsers(appManager, userID, hash, function (linkedUsers) {
	          var emailUser = null;
	          var phoneUser = null;
	          for (var i = 0; i < linkedUsers.length; i++) {
	            if (linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app") emailUser = linkedUsers[i];
	            if (linkedUsers[i]["Type"] == "phone") phoneUser = linkedUsers[i];
	          }
	          if (phoneUser != null) thisThing.setState({ phoneNumber: locManager.localizedPhone(phoneUser["PhoneNumber"]) });
	
	          if (emailUser == null) {
	            console.log("[passhome]", "no owner, so lets try to register");
	            thisThing.setState({ isShowingRegistration: true });
	            setTimeout(function () {
	              thisThing.showFront();
	            }, 400);
	          } else {
	            userID = emailUser[ModelConstants.UserID];
	            hash = emailUser[ModelConstants.Hash];
	            NetworkManager.getUser(appManager, userID, hash, function (emailUser) {
	              emailUser[ModelConstants.Password] = hash;
	              appManager.setCurrentUser(emailUser, function () {
	                _this.setState({ isShowingHome: true });
	                setTimeout(function () {
	                  thisThing.showFront();
	                }, 400);
	              });
	            }, function () {
	              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	              thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	              setTimeout(function () {
	                thisThing.showFront();
	              }, 400);
	            }, function () {
	              var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
	              var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
	              thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	              setTimeout(function () {
	                thisThing.showFront();
	              }, 400);
	            });
	          }
	        }, function (errorData) {
	          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	          thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          setTimeout(function () {
	            thisThing.showFront();
	          }, 400);
	          console.log("errorData", errorData);
	        }, function (errorData) {
	          var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	          var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	          thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          setTimeout(function () {
	            thisThing.showFront();
	          }, 400);
	          console.log("errorData", errorData);
	        });
	      }, function () {
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	        setTimeout(function () {
	          thisThing.showFront();
	        }, 400);
	      }, function () {
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("NO_CONNECTION_STATEMENT");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	        setTimeout(function () {
	          thisThing.showFront();
	        }, 400);
	      });
	    } else {
	      // this.setState({isShowingRegistration:true});
	      this.setState({ isShowingCFD: true });
	      setTimeout(function () {
	        return _this.showFront();
	      }, 200);
	    }
	  },
	
	  _currentPageNum: 0,
	  goToPage: function goToPage(pageNum, animated) {
	    if (this._currentPageNum == pageNum) return;
	    this._currentPageNum = pageNum;
	
	    if (typeof animated === 'undefined') animated = true;
	
	    var newOffset = pageNum * (this.props.initialLayout.width - 2 * this.state.horizontalMargin);
	
	    var shouldDrawPage = this.state.shouldDrawPage;
	    shouldDrawPage[pageNum] = true;
	    this.setState({ shouldDrawPage: shouldDrawPage });
	
	    var thisThing = this;
	    if (this._pageContainer && this._pageContainer.scrollTo) {
	      this._pageContainer.scrollTo({ x: newOffset, animated: animated, completion: function completion() {
	          thisThing.setState({ shouldDrawPage: [pageNum == 0, pageNum == 1] });
	        } });
	    }
	  },
	
	  _showingFront: false,
	  showFront: function showFront() {
	    if (this._showingFront) return;
	    this._showingFront = true;
	    this.doUpdate();
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationBack, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: true });
	      Animated.timing(thisThing.state.rotationFront, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  showBack: function showBack(backFeatureData) {
	    if (!this._showingFront) return;
	    this._showingFront = false;
	
	    if (typeof backFeatureData !== 'undefined') this.setState({ backFeatureData: backFeatureData });else this.setState({ backFeatureData: this.props.appManager.getFeatureForName("MyCard") });
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationFront, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: false });
	      Animated.timing(thisThing.state.rotationBack, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  showNone: function showNone() {
	    this._showingFront = false;
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationBack, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {});
	
	    Animated.timing(thisThing.state.rotationFront, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: true });
	    });
	  },
	
	  checkUserChanged: function checkUserChanged() {
	    var appManager = this.props.appManager;
	    var loggedIn = this.props.appManager.isLoggedIn();
	    if (!loggedIn && this.state.isShowingHome) {
	      this._hasUpdated = false;
	      this.goToPage(0);
	      this.showNone();
	      this.setState({
	        isShowingFront: true,
	        isShowingRegistration: false,
	        isShowingFreeHome: false,
	        isShowingHome: false,
	        isShowingLogin: false,
	        isShowingOnlyLogin: false,
	        isShowingError: false });
	      this.determineUser();
	    }
	  },
	
	  _hasUpdated: false,
	  doUpdate: function doUpdate() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var feedFeatureNames = this.props.appManager.getFeedFeatureNames();
	
	    var _props$dataDependency = this.props.dataDependencyRetriever(feedFeatureNames),
	        dataDependencies = _props$dataDependency.dataDependencies,
	        customDependencies = _props$dataDependency.customDependencies;
	
	    var hasRewards = false;
	    for (var i = 0; i < dataDependencies.length; i++) {
	      if (dataDependencies[i] == "Rewards") {
	        hasRewards = true;
	      }
	    }
	    if (!hasRewards) dataDependencies.push("Rewards");
	
	    if (!this._hasUpdated) {
	      appManager.getDataTypes(thisThing.props.allDependencyKeys, function (data) {
	        thisThing.didUpdate(data);
	      });
	    }
	    this._hasUpdated = true;
	
	    NetworkManager.update(appManager, dataDependencies, function (newData) {
	      if (customDependencies.length <= 0) {
	        thisThing._shouldUpdateOnScrollAfterGoingDown = true;
	        console.log("[setdata passhome]", newData);
	        appManager.setData(newData, function () {
	          thisThing.didUpdate(newData);
	        });
	      } else {
	        NetworkManager.retrieveCustomDataDependencies(appManager, customDependencies, newData, function (totalData) {
	          appManager.setData(totalData, function () {
	            thisThing.didUpdate(totalData);
	          });
	        });
	      }
	    }, function () {});
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	
	    if (thisThing._feedPlusView == null || typeof thisThing._feedPlusView === 'undefined') return;
	
	    if (typeof data !== 'undefined' && typeof data.Rewards !== 'undefined' && data.Rewards.length > 0) {
	      thisThing._feedPlusView.setRewards(data.Rewards);
	    } else {
	      thisThing.props.appManager.getDataType("Rewards", function (rewards) {
	        if (typeof rewards !== 'undefined') {
	          thisThing._feedPlusView.setRewards(rewards);
	        }
	      });
	    }
	  },
	
	  didCompleteRegistration: function didCompleteRegistration() {
	    var userID = findGetParameter("userid");
	    var hash = findGetParameter("hash");
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    if (userID != null && hash != null) {
	      NetworkManager.linkUsers(appManager, userID, hash, function (data) {
	        thisThing.showPreHome();
	      }, function (data) {
	        thisThing.showPreHome();
	      }, function (data) {
	        thisThing.showPreHome();
	      });
	    } else {
	      thisThing.showPreHome();
	    }
	    // thisThing.setState({isShowingRegistration:false, isShowingLogin:false, isShowingHome:true});
	    // Animated.timing(
	    //   thisThing.state.rotationFront,
	    //   {
	    //     toValue: 90,
	    //     duration: 200
	    //   }
	    // ).start(function()
	    // {
	    //   thisThing.setState({isShowingRegistration:false, isShowingLogin:false, isShowingHome:true});
	    //   Animated.timing(
	    //     thisThing.state.rotationFront,
	    //     {
	    //       toValue: 0,
	    //       duration: 200
	    //     }
	    //   ).start(function()
	    //   {
	    //
	    //   });
	    // });
	  },
	
	  newAccountSelected: function newAccountSelected() {
	    this.setState({ isShowingLogin: false, isShowingRegistration: true });
	  },
	
	  loginSelected: function loginSelected() {
	    this.setState({ isShowingLogin: false, isShowingRegistration: true });
	  },
	
	  didCompleteLogin: function didCompleteLogin() {
	    var userID = findGetParameter("userid");
	    var hash = findGetParameter("hash");
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    if (userID != null && hash != null) {
	      NetworkManager.getLinkedUsers(appManager, userID, hash, function (linkedUsers) {
	        var owner = null;
	        for (var i = 0; i < linkedUsers.length; i++) {
	          if (linkedUsers[i]["Type"] == "app") {
	            owner = linkedUsers[i];
	            break;
	          }
	        }
	        if (owner != null && owner[ModelConstants.UserID] == appManager.currentUser()[ModelConstants.UserID]) {
	          console.log("[passhome]", "logged in to correct account");
	          thisThing.setState({ isShowingHome: true, isShowingLogin: false, isShowingRegistration: false, isShowingOnlyLogin: false, isShowingError: false });
	          thisThing.doUpdate();
	        } else {
	          console.log("[passhome]", "could not find owner or is isn't the same");
	          NetworkManager.linkUsers(appManager, userID, hash, function (data) {
	            thisThing.showPreHome();
	          }, function (errorData) {
	            console.log("[passhome]", "account already linked 4", errorData);
	            var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
	            var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
	            thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          }, function (errorData) {
	            console.log("[passhome]", "account already linked 4", errorData);
	            var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
	            var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
	            thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	          });
	        }
	      }, function (errorData) {
	        console.log("[passhome]", "account already linked 4", errorData);
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	      }, function (errorData) {
	        console.log("[passhome]", "account already linked 4", errorData);
	        var errorTitleLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_TITLE");
	        var errorBodyLocalized = thisThing.locManager.localizedStringForKey("ACCOUNT_LINKED_PASS_ALERT_BODY");
	        thisThing.setState({ isShowingError: true, errorTitle: errorTitleLocalized, errorBody: errorBodyLocalized });
	      });
	    } else {
	      thisThing.showPreHome();
	    }
	  },
	
	  showPreHome: function showPreHome() {
	    // disabling prehome for now
	    // this.goToPage(1);
	    this.setState({ isShowingHome: true, isShowingLogin: false, isShowingRegistration: false, isShowingOnlyLogin: false, isShowingError: false });
	    this.doUpdate();
	  },
	
	  storeFocus: function storeFocus() {
	    console.log("storeFocus");
	    if (this._focusStore) this._focusStore.focus();
	  },
	
	  render: function render() {
	    var _this2 = this,
	        _ref;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);
	
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", .6);
	
	    // var myCardFeatureData = appManager.getFeatureForName("MyCard");
	    var simpleCreateUser = appManager.getFeatureForName("SimpleCreateUser");
	    var simpleLogin = appManager.getFeatureForName("SimpleLogin");
	    var simpleCFDFeatureData = appManager.getFeatureForName("SimpleCFD");
	
	    var didCompleteRegistration = this.didCompleteRegistration;
	    var showBack = this.showBack;
	    var newAccountSelected = function newAccountSelected() {
	      thisThing.newAccountSelected(thisThing);
	    };
	    var didCompleteLogin = function didCompleteLogin() {
	      thisThing.didCompleteLogin(thisThing);
	    };
	
	    var iconImageName = appManager.absoluteResourceForPath('App/iTunesArtwork.png');
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	
	    var stripHeight = 120;
	
	    var addedBackStyle = {};
	    if (Platform.OS == 'web') addedBackStyle.height = "calc(100% - 60px)";
	
	    var layout = { width: thisThing.props.initialLayout.width - 2 * thisThing.state.horizontalMargin, height: thisThing.props.initialLayout.height - 40 - stripHeight - 2 * thisThing.state.verticalMargin };
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor, height: this.props.initialLayout.height, width: this.props.initialLayout.width }] },
	      React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	      React.createElement(MKTextField, { ref: function ref(a) {
	          return _this2._focusStore = a;
	        }, style: { display: 'none' } }),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'block' : 'none',
	            transform: [{ rotateY: this.state.rotationFront }],
	            flexDirection: 'column', alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: generalColor,
	            overflow: 'hidden'
	          } },
	        this.state.isShowingOnlyLogin ? React.createElement(
	          View,
	          { key: 'onlylogincontainer', style: { marginLeft: 0, height: thisThing.props.initialLayout.height - 2 * this.state.verticalMargin, alignSelf: 'stretch', flexDirection: 'row' } },
	          React.createElement(
	            View,
	            { style: { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } },
	            appActions.featureForData(simpleLogin, { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, height: thisThing.props.initialLayout.height - 2 * this.state.verticalMargin }, appManager, { didCompleteRegistration: didCompleteRegistration, showBack: showBack, newAccountSelected: newAccountSelected, didCompleteLogin: didCompleteLogin, userName: this.state.userName, phoneNumber: this.state.phoneNumber })
	          )
	        ) : null,
	        this.state.isShowingError ? React.createElement(
	          View,
	          { style: { flex: 1, flexDirection: 'column', alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { textAlign: 'center', margin: 10 } },
	            this.state.errorTitle
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', margin: 10 } },
	            this.state.errorBody
	          )
	        ) : null,
	        this.state.isShowingRegistration || this.state.isShowingLogin ? React.createElement(
	          OffsetView,
	          { ref: function ref(a) {
	              return _this2._pageContainer = a;
	            }, key: 'reglogincontainer', horizontal: true, style: (_ref = { height: thisThing.props.initialLayout.height - 2 * this.state.verticalMargin, alignSelf: 'stretch' }, _defineProperty(_ref, 'height', this.props.initialLayout.height), _defineProperty(_ref, 'flexDirection', 'row'), _defineProperty(_ref, 'alignItems', 'stretch'), _ref) },
	          this.state.shouldDrawPage[0] ? React.createElement(
	            View,
	            { style: { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, height: thisThing.props.initialLayout.height - 2 * this.state.verticalMargin, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } },
	            React.createElement(
	              View,
	              { style: { height: stripHeight, backgroundColor: headerIconColor } },
	              React.createElement(Image, { style: { width: '100%', height: stripHeight }, resizeMode: "cover", source: { uri: stripImage } }),
	              React.createElement(
	                View,
	                { style: { position: 'absolute', top: 20, left: 20, right: 20, bottom: 20 } },
	                React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { height: thisThing.props.initialLayout.height - stripHeight - 2 * this.state.verticalMargin, alignSelf: 'stretch', overflow: 'hidden' } },
	              appActions.featureForData(simpleCreateUser, layout, appManager, { didCompleteRegistration: didCompleteRegistration, showBack: showBack, newAccountSelected: newAccountSelected, didCompleteLogin: didCompleteLogin, storeFocus: thisThing.storeFocus })
	            )
	          ) : React.createElement(View, { style: { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } }),
	          this.state.shouldDrawPage[1] ? React.createElement(
	            View,
	            { style: { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, height: thisThing.props.initialLayout.height - 2 * this.state.verticalMargin, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(
	              View,
	              { style: { alignSelf: 'center', margin: 20 } },
	              React.createElement(Image, {
	                style: { width: 200, height: 200 },
	                resizeMode: "contain",
	                source: { uri: iconImageName } })
	            ),
	            Platform.OS == "web" ? React.createElement(AddToWalletButton, { appManager: appManager, style: { margin: 10, width: 140, height: 44 } }) : null,
	            React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: 0, width: 140 }, text: locManager.localizedStringForKey("MORE_LABEL"),
	              onPress: function onPress() {
	                _this2.setState({ isShowingHome: true, isShowingLogin: false, isShowingRegistration: false, isShowingOnlyLogin: false, isShowingError: false });thisThing.doUpdate();
	              } })
	          ) : React.createElement(View, { style: { width: thisThing.props.initialLayout.width - 2 * this.state.horizontalMargin, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' } })
	        ) : null,
	        this.state.isShowingHome ? React.createElement(FeedPlusView, { key: 'feedPlusView', ref: function ref(a) {
	            if (a != null) thisThing._feedPlusView = a;
	          },
	          style: { flex: 1, alignSelf: 'stretch', height: this.props.initialLayout.height - 2 * this.state.verticalMargin },
	          upArrowSelected: function upArrowSelected() {
	            thisThing.scrollUp();
	          },
	          flipSelected: function flipSelected(featureData) {
	            thisThing.showBack(featureData);
	          },
	          appManager: appManager, appActions: appActions }) : null,
	        this.state.isShowingCFD ? this.props.featureBuilder.featureForData(simpleCFDFeatureData, { width: this.props.initialLayout.width - 2 * this.state.horizontalMargin, height: this.props.initialLayout.height - 2 * this.state.verticalMargin }, this.props.appManager) : null
	      ),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'none' : 'block',
	            flexDirection: 'column',
	            transform: [{ rotateY: this.state.rotationBack }],
	            alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: headerColor,
	            alignItems: 'stretch',
	            overflow: 'hidden'
	          } },
	        React.createElement(
	          View,
	          { style: { height: 60, flexDirection: 'row', alignItems: 'stretch', justifyContent: 'center' } },
	          React.createElement(
	            View,
	            { style: { width: 60, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(ReUpIconButton, { appManager: appManager, iconName: "angle-left", onPress: function onPress() {
	                return _this2.showFront();
	              }, type: 2 })
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: headerTitleColor, textAlign: 'center' } },
	              this.state.backFeatureData.data.title
	            )
	          ),
	          React.createElement(View, { style: { width: 60 } })
	        ),
	        React.createElement(
	          View,
	          { style: [{ flex: 1 }, addedBackStyle] },
	          appManager.isLoggedIn() ? this.props.featureBuilder.featureForData(this.state.backFeatureData, { width: this.props.initialLayout.width - 2 * this.state.horizontalMargin, height: this.props.initialLayout.height - 60 - 2 * this.state.verticalMargin }, this.props.appManager) : null
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  feedHeader: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'row'
	  },
	  feedHeaderLeftContainer: {
	    padding: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  profileImage: {
	    height: FEED_HEADER_HEIGHT - 16,
	    width: FEED_HEADER_HEIGHT - 16,
	    borderRadius: (FEED_HEADER_HEIGHT - 16) / 2,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: (FEED_HEADER_HEIGHT - 20) / 2,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  feedHeaderCenterContainer: {
	    height: FEED_HEADER_HEIGHT,
	    paddingVertical: 10,
	    flex: 1,
	    justifyContent: 'space-between'
	  },
	
	  feedHeaderRightContainer: {
	    paddingVertical: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  feedHeaderInfo: {
	    fontWeight: 'bold'
	  }
	});
	PassHome.dataDependencies = ["Users", "Rewards"];
	
	module.exports = PassHome;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var NetworkManager = __webpack_require__(15);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ArcMeter = __webpack_require__(58);
	
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter;
	
	
	var testData = [{
	  "PassID": "1",
	  "Name": "Facials",
	  "Description": "Get 5 facials for the price of 4!",
	  "RedeemQuantity": "5",
	  "Cost": "100.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
	  "AmountCharged": "113.00"
	}, {
	  "PassID": "2",
	  "Name": "Manicures",
	  "Description": "Get 10 manicures for $200!",
	  "RedeemQuantity": "10",
	  "Cost": "200.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
	  "AmountCharged": "226.00",
	  "StateEnum": "1",
	  "RedeemQuantityRemaining": "6"
	}, {
	  "PassID": "3",
	  "Name": "Unlimited Blows",
	  "Description": "Subscribe now and get unlimited blows for $30 per month!",
	  "RedeemQuantity": "10",
	  "Cost": "30.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"type\": \"1\"}",
	  "AmountCharged": "33.90"
	}];
	
	var MK = __webpack_require__(14);
	
	var MKButton = MK.MKButton;
	
	
	var Passes = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      passes: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.didUpdate();
	  },
	
	  didUpdate: function didUpdate() {
	    var thisThing = this;
	    this.props.appManager.getDataType("Passes", function (data) {
	      thisThing.setState({ passes: data });
	      // thisThing.setState({passes:testData});
	    });
	  },
	
	  didSelectPass: function didSelectPass(pass) {
	    var thisPass = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	
	    if (pass.RedeemQuantityRemaining) {
	      appActions.requestFeatureName("UsePass", { pass: pass });
	    } else {
	      appActions.requestFeatureName("AddPass", { pass: pass, passes: this });
	    }
	  },
	
	  render: function render() {
	    var thisPass = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryColor = appManager.getColorForKey("PrimaryColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var selectOneToRedeemStr = locManager.localizedStringForKey("SELECT_PASS_TO_REDEEM_ALERT_BODY");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    var passes = this.state.passes.sort(function (a, b) {
	      if (a.StateEnum == '0' && b.StateEnum != '0') return 1;
	      if (b.StateEnum == '0' && a.StateEnum != '0') return -1;
	
	      return a.Cost - b.Cost;
	    });
	
	    var passesWithHeadings = [];
	    var hasFoundPurchased = false;
	    var hasFoundNonPurchased = false;
	    var purchasedTitle = "Purchased";
	    var forSaleTitle = "For Sale";
	    for (var i = 0; i < passes.length; i++) {
	      var isPurchased = typeof passes[i].RedeemQuantityRemaining !== 'undefined';
	      if (isPurchased && !hasFoundPurchased) {
	        passesWithHeadings.push(purchasedTitle);
	        hasFoundPurchased = true;
	      }
	      if (!isPurchased && !hasFoundNonPurchased) {
	        passesWithHeadings.push(forSaleTitle);
	        hasFoundNonPurchased = true;
	      }
	
	      passesWithHeadings.push(passes[i]);
	    }
	
	    var numUserPoints = user[ModelConstants.Points];
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, featureName: 'Passes', isEmpty: passes.length <= 0 },
	        passesWithHeadings.map(function (pass, index) {
	          if (typeof pass === "string") {
	            var moreProps = {};
	            if (pass == purchasedTitle) moreProps.alertMessage = selectOneToRedeemStr;
	            return React.createElement(
	              View,
	              null,
	              React.createElement(
	                View,
	                { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	                React.createElement(
	                  View,
	                  { style: { alignSelf: 'center' } },
	                  React.createElement(
	                    ReUpText,
	                    { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	                    pass
	                  )
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(ReUpIconButton, Object.assign({ type: 3,
	                  appManager: typeof appManager === 'undefined' ? null : appManager,
	                  featureData: thisPass.props.featureData,
	                  appActions: thisPass.props.appActions
	                }, moreProps))
	              ),
	              React.createElement(ShadowView, { appManager: typeof appManager === 'undefined' ? null : appManager, layout: thisPass.state.layout })
	            );
	          }
	
	          var isPurchased = typeof pass.StateEnum !== 'undefined' && pass.StateEnum == '1';
	          var amountFontSize = 20;
	          var type = typeof pass.PassBlob === 'undefined' || pass.PassBlob == null || typeof JSON.parse(pass.PassBlob).type === 'undefined' ? 0 : JSON.parse(pass.PassBlob).type;
	          var leftText = locManager.localizedDollars(pass.Cost);
	          var rightText = "";
	          if (type == 0) {
	            rightText = pass.RedeemQuantity + " " + pass.Name;
	          } else {
	            rightText = locManager.localizedStringForKeyAndParams("PASS_SUBSCRIPTION_STATEMENT", [pass.Name]);
	          }
	
	          var fraction = 1;
	          if (isPurchased) {
	            // pass.RedeemQuantityRemaining = 10;
	            // pass.RedeemQuantity = 100;
	            rightText = pass.Name;
	            fraction = parseFloat(pass.RedeemQuantityRemaining) / parseFloat(pass.RedeemQuantity);
	            leftText = pass.RedeemQuantityRemaining + "/" + pass.RedeemQuantity;
	            amountFontSize = 30 - (leftText.length > 3 ? (leftText.length - 3) * 5 : 0);
	          }
	
	          return React.createElement(
	            MKButton,
	            { key: pass.PassId, style: [styles.passRowContainer, { opacity: 1 }],
	              backgroundColor: 'transparent',
	              shadowRadius: 2,
	              shadowOffset: { width: 0, height: 2 },
	              shadowOpacity: 0.7,
	              shadowColor: 'transparent',
	              enabled: true,
	              onPress: function onPress() {
	                thisPass.didSelectPass(pass);
	              }
	            },
	            React.createElement(
	              View,
	              { style: styles.passRow },
	              isPurchased ? React.createElement(
	                View,
	                { style: { margin: 5, width: 110, height: 110, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ArcMeter,
	                  { fgColor: profileMeterColor, bgColor: profileMeterBackgroundColor, percentage: fraction, style: { width: 100, height: 100 } },
	                  React.createElement(
	                    View,
	                    null,
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { fontSize: amountFontSize, color: generalTitleColor,
	                          alignSelf: 'center',
	                          justifyContent: 'center' } },
	                      leftText
	                    )
	                  )
	                )
	              ) : React.createElement(
	                View,
	                { style: { margin: 5, width: 110, height: 110, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.passRedeemQuantity, { fontSize: amountFontSize, color: generalTitleColor }] },
	                    leftText
	                  )
	                )
	              ),
	              React.createElement(
	                View,
	                { style: styles.passRightContainer },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor }] },
	                  rightText
	                ),
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [styles.passDescription, { color: generalTitleColor }] },
	                  pass.Description
	                )
	              )
	            ),
	            React.createElement(ShadowView, { appManager: typeof appManager === 'undefined' ? null : appManager, layout: thisPass.state.layout })
	          );
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  passRow: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	  passDivider: {
	    height: 1,
	    backgroundColor: 'grey'
	  },
	  passLeftContainer: {
	    width: 100,
	    height: 100,
	    paddingTop: 8,
	    marginLeft: 4,
	    marginRight: 4,
	    paddingBottom: 8,
	    justifyContent: 'center',
	    alignItems: 'center',
	    alignSelf: 'center'
	  },
	  passRedeemQuantity: {
	    fontSize: 34,
	    alignSelf: 'center',
	    justifyContent: 'center'
	  },
	  passRightContainer: {
	    flex: 1,
	    justifyContent: 'center',
	    paddingRight: 8,
	    paddingBottom: 4,
	    paddingTop: 4
	  },
	  passDescription: {
	    padding: 0,
	    margin: 0,
	    opacity: .8
	  }
	});
	
	Passes.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var points = parseFloat(user[ModelConstants.Points]);
	    var passes = typeof data.Passes !== 'undefined' ? data.Passes : [];
	    var passes = typeof data.Passes !== 'undefined' ? data.Passes.sort(function (a, b) {
	      return parseFloat(b.Cost) - parseFloat(a.Cost);
	    }) : [];
	    if (typeof passes === 'undefined' || passes == null || passes.length <= 0) return [];
	
	    // get date acheived
	    var sortOrder = -1;
	
	    sortOrder -= 1000; // reduce by a second so that it is above transaction history
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("Passes");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: sortOrder
	    }];
	  }
	};
	
	Passes.dataDependencies = ["Users", "Passes"];
	
	module.exports = Passes;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var PlatformConstants = __webpack_require__(31);
	var ReUpField = __webpack_require__(26);
	
	// var CardIO, { CardIOConstants } = require('react-native-card.io')
	// import CardIO, { CardIOConstants } from 'react-native-card.io';
	var CardIO = __webpack_require__(845);
	var ReUpCreditCardInput = __webpack_require__(1129);
	
	var MAX_CREDIT = parseFloat(10);
	var lastSelectedAmount = null;
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton,
	    MKRadioButton = MK.MKRadioButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var FeedCard = __webpack_require__(41);
	var ProgressOverlay = __webpack_require__(52);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    NativeModules = ReactNative.NativeModules,
	    StyleSheet = ReactNative.StyleSheet,
	    Keyboard = ReactNative.Keyboard;
	
	
	var RNPayPalManager = NativeModules.RNPayPalManager;
	
	function cardTypeForNumber(cardNumber) {
	  if (cardNumber.length < 2) return -1;
	
	  var range = parseInt(cardNumber.substring(0, 2));
	
	  if (range >= 40 && range <= 49) {
	    return 1; //PKCardTypeVisa;
	  } else if (range >= 50 && range <= 59) {
	    return 2; //PKCardTypeMasterCard;
	  } else if (range == 34 || range == 37) {
	    return 3; //PKCardTypeAmex;
	  } else if (range == 60 || range == 62 || range == 64 || range == 65) {
	    return 4; //PKCardTypeDiscover;
	  } else if (range == 35) {
	    return 5; //PKCardTypeJCB;
	  } else if (range == 30 || range == 36 || range == 38 || range == 39) {
	    return 6; //PKCardTypeDinersClub;
	  } else {
	    return -1;
	  }
	}
	
	function cardNumberIsValidLength(cardNumber) {
	  var cardType = cardTypeForNumber(cardNumber);
	
	  return cardNumber.length >= validLengthForCardType(cardType);
	}
	
	function validLengthForCardType(cardType) {
	  if (cardType == 3) // amex
	    {
	      return 15;
	    } else if (cardType == 6) // PKCardTypeDinersClub
	    {
	      return 14;
	    } else {
	    return 16;
	  }
	}
	
	function validLengthCVCForCardType(cardType) {
	  if (cardType == 3) {
	    return 4; // amex
	  }
	
	  return 3;
	}
	
	function cardTypeFromName(cardTypeName) {
	  var lowerName = cardTypeName.toLowerCase();
	  if (lowerName == "visa") return 1;
	  if (lowerName == "mastercard" || lowerName == "mc") return 2;
	  if (lowerName == "american express" || lowerName == "americanexpress" || lowerName == "amex") return 3;
	
	  return -1;
	}
	
	function iconNameForCardType(cardType) {
	  if (cardType == 1) {
	    return "cc-visa"; //PKCardTypeVisa;
	  } else if (cardType == 2) {
	    return "cc-mastercard"; //PKCardTypeMasterCard;
	  } else if (cardType == 3) {
	    return "cc-amex"; //PKCardTypeAmex;
	  } else if (cardType == 4) {
	    return "cc-discover"; //PKCardTypeDiscover;
	  } else if (cardType == 5) {
	    return "cc-jcb"; //PKCardTypeJCB;
	  } else if (cardType == 6) {
	    return "cc-diners-club"; //PKCardTypeDinersClub;
	  } else {
	    return "credit-card";
	  }
	}
	
	function removeSpaces(str) {
	  return str.replace(/\s+/g, '');
	}
	
	function isValidPostalCode(postalCode, countryCode) {
	  var postalCodeRegex = "";
	  switch (countryCode) {
	    case "US":
	      postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
	      break;
	    case "CA":
	      postalCodeRegex = /^(([A-Z]|[a-z])[0-9]([A-Z]|[a-z]))\s*([0-9]([A-Z]|[a-z])[0-9])$/;
	      break;
	    default:
	      postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
	  }
	  return postalCodeRegex.test(postalCode);
	}
	
	function isPossiblyPostalCode(code) {
	  if (code.length < 2) return false;
	  var firstChar = code.substr(0, 1);
	
	  return firstChar.match(/[a-z]|[A-Z]/i);
	}
	
	var PaymentTypes = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: { shouldPopAfterSelectingPaymentType: false }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    if (!this.props.appManager.isLoggedIn()) {
	      return {
	        layout: this.props.initialLayout,
	        creditCardPresent: false,
	        newCardValid: false,
	        proposedCardNumber: "",
	        proposedYearNumber: "",
	        proposedMonthNumber: "",
	        proposedCVVNumber: "",
	        user: null,
	        sources: [],
	        hasStripe: false,
	        hasBeanStream: false,
	        hasPayPal: false,
	        cameraView: null,
	        errorMessage: this.props.appManager.getLocalizationManager().localizedStringForKey("CARD_ERROR"),
	        cardViewLoaded: false // only used for stripe + iOS for now,  stripe elements
	      };
	    }
	
	    return this.getUpdatedState();
	  },
	
	  getUpdatedState: function getUpdatedState() {
	    var user = this.props.appManager.currentUser();
	    var sources = this.props.appManager.getPaymentInfo();
	
	    var hasPayPal = user != null && typeof user[ModelConstants.PayPal_ClientID] !== 'undefined' && user[ModelConstants.PayPal_ClientID].length > 0;
	    var hasStripe = user != null && typeof user[ModelConstants.StripeKey] !== 'undefined' && user[ModelConstants.StripeKey].length > 0;
	
	    var gateway = user != null && typeof user[ModelConstants.CC_Gateway_Primary] !== 'undefined' ? user[ModelConstants.CC_Gateway_Primary] : "stripecc";
	    var hasBeanStream = gateway == "beancc";
	    hasStripe = hasStripe && gateway == "stripecc";
	
	    return {
	      layout: this.state != null && typeof this.state.layout !== 'undefined' ? this.state.layout : this.props.initialLayout,
	      creditCardPresent: user != null && user[ModelConstants.LastFour].length > 0,
	      newCardValid: false,
	      proposedCardNumber: "",
	      proposedYearNumber: "",
	      proposedMonthNumber: "",
	      proposedCVVNumber: "",
	      user: user,
	      sources: sources,
	      hasStripe: hasStripe,
	      hasBeanStream: hasBeanStream,
	      hasPayPal: hasPayPal,
	      payPalClientID: user[ModelConstants.PayPal_ClientID],
	      payPalEnvironment: user[ModelConstants.PayPal_Environment],
	      cameraView: null,
	      shouldShowSpinner: false,
	      spinnerText: this.props.appManager.getLocalizationManager().localizedStringForKey("CHECKING_HUD"),
	      errorMessage: this.props.appManager.getLocalizationManager().localizedStringForKey("CARD_ERROR"),
	      numberOfSuccessfulCardAdds: 0
	    };
	  },
	
	  updateState: function updateState() {
	    this.setState(this.getUpdatedState());
	  },
	
	  focus: function focus() {
	    var thisThing = this;
	    this.updateState();
	    setTimeout(function () {
	      thisThing._newCardNumberField.focus();
	    }, 200);
	  },
	
	  _hasCamera: false,
	  _cardIODidScanCardListener: null,
	  _payPalDidSucceedListener: null,
	  _payPalDidFailListener: null,
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    var appActions = thisThing.props.appActions;
	    var appManager = thisThing.props.appManager;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    thisThing._hasCamera = true;
	    if (Platform.OS == 'ios') {
	      this._cardIODidScanCardListener = NativeAppEventEmitter.addListener('cardIODidScanCard', function (evt) {
	        if (evt.cardInfo.cardNumber) {
	          thisThing.newCardTextChange(evt.cardInfo.cardNumber + "");
	        }
	        if (evt.cardInfo.expiryMonth) {
	          thisThing.newCardMonthTextChange(evt.cardInfo.expiryMonth + "");
	        }
	        if (evt.cardInfo.expiryYear) {
	          evt.cardInfo.expiryYear = evt.cardInfo.expiryYear % 100;
	          thisThing.newCardYearTextChange(evt.cardInfo.expiryYear + "");
	        }
	        if (evt.cardInfo.cvv) {
	          thisThing.newCardSecurityTextChange(evt.cardInfo.cvv + "");
	        }
	        thisThing.showSetCard();
	      });
	      this._payPalDidSucceedListener = NativeAppEventEmitter.addListener('payPalDidSucceed', function (evt) {
	        var authorizationToken = evt.response.code;
	        NetworkManager.setPayPal(thisThing.props.appManager, authorizationToken, "connected", function (data) {
	          var paymentInfo = JSON.parse(data[0]);
	          appManager.setPaymentInfo(data[0], function (user) {
	            RNPayPalManager.payPalDidConnect();
	            thisThing.setState({ sources: paymentInfo });
	          });
	        }, function (data) {
	          RNPayPalManager.payPalDidConnect();
	          if (!useInterstitialFlow) {
	            appActions.showLocalizedAlert("PAYPAL_CONNECT_FAILURE_ALERT_TITLE", "PAYPAL_CONNECT_FAILURE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	              appActions.hideAlert();
	            }], function () {});
	          } else {
	            thisThing.setState({ shouldShowSpinner: false, showError: false });
	            thisThing.props.extras.showNetworkErrorAlert();
	          }
	        }, function (data) {
	          if (!useInterstitialFlow) {
	            appActions.setSpinnerShown(false);
	            appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	          } else {
	            thisThing.setState({ shouldShowSpinner: false, showError: false });
	            thisThing.props.extras.showNetworkErrorAlert();
	          }
	          RNPayPalManager.payPalDidConnect();
	        });
	      });
	      this._payPalDidFailListener = NativeAppEventEmitter.addListener('payPalDidFail', function (evt) {});
	    } else {
	      if (DeviceEventEmitter) {
	        this._cardIODidScanCardListener = DeviceEventEmitter.addListener('cardIODidScanCard', function (evt) {
	          if (evt.cardInfo.cardNumber) {
	            thisThing.newCardTextChange(evt.cardInfo.cardNumber + "");
	          }
	          if (evt.cardInfo.expiryMonth) {
	            thisThing.newCardMonthTextChange(evt.cardInfo.expiryMonth + "");
	          }
	          if (evt.cardInfo.expiryYear) {
	            evt.cardInfo.expiryYear = evt.cardInfo.expiryYear % 100;
	            thisThing.newCardYearTextChange(evt.cardInfo.expiryYear + "");
	          }
	          if (evt.cardInfo.cvv) {
	            thisThing.newCardSecurityTextChange(evt.cardInfo.cvv + "");
	          }
	          thisThing.showSetCard();
	        });
	        this._payPalDidSucceedListener = DeviceEventEmitter.addListener('payPalDidSucceed', function (evt) {
	          var authorizationToken = evt.response.code;
	          NetworkManager.setPayPal(thisThing.props.appManager, authorizationToken, "connected", function (data) {
	            var paymentInfo = JSON.parse(data[0]);
	            appManager.setPaymentInfo(data[0], function (user) {
	              RNPayPalManager.payPalDidConnect();
	              thisThing.setState({ sources: paymentInfo });
	            });
	          }, function (data) {
	            RNPayPalManager.payPalDidConnect();
	            if (!useInterstitialFlow) {
	              appActions.showLocalizedAlert("PAYPAL_CONNECT_FAILURE_ALERT_TITLE", "PAYPAL_CONNECT_FAILURE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                appActions.hideAlert();
	              }], function () {});
	            } else {
	              thisThing.setState({ shouldShowSpinner: false, showError: false });
	              thisThing.props.extras.showNetworkErrorAlert();
	            }
	          }, function (data) {
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(false);
	              appActions.showNetworkErrorAlert(thisThing.showSetCard, function () {});
	            } else {
	              thisThing.setState({ shouldShowSpinner: false, showError: false });
	              thisThing.props.extras.showNetworkErrorAlert();
	            }
	            RNPayPalManager.payPalDidConnect();
	          });
	        });
	        this._payPalDidFailListener = DeviceEventEmitter.addListener('payPalDidFail', function (evt) {});
	      }
	    }
	
	    var appManager = this.props.appManager;
	    this.props.appManager.getDataType("Transactions", function (transactions) {
	      if (typeof transactions === 'undefined' || transactions.length <= 0) return;
	
	      var sortedTransactions = transactions.sort(function (a, b) {
	        return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
	      });
	      var initialValue = null;
	      for (var i = 0; i < sortedTransactions.length; i++) {
	        var transaction = sortedTransactions[i];
	        if (typeof transaction.Credit !== 'undefined' && transaction.Credit != null && parseInt(transaction.Credit) > 0) {
	          initialValue = parseInt(transaction.Credit);
	          break;
	        }
	      }
	      if (initialValue != null) {
	        if (thisThing.refs.PriceChooserView) thisThing.refs.PriceChooserView.setAmount(initialValue);
	      }
	    });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._cardIODidScanCardListener != null) this._cardIODidScanCardListener.remove();
	    if (this._payPalDidSucceedListener != null) this._payPalDidSucceedListener.remove();
	    if (this._payPalDidFailListener != null) this._payPalDidFailListener.remove();
	  },
	
	  _newCardNumber: "",
	  newCardTextChange: function newCardTextChange(text) {
	    var didAddText = text.length > this._newCardNumber.length;
	    var noSpaces = removeSpaces(text);
	    var moddedText = noSpaces.substring(0, 4);
	
	    if (noSpaces.length > 4) {
	      moddedText += " " + noSpaces.substring(4, 8);
	    }
	    if (noSpaces.length > 8) {
	      moddedText += " " + noSpaces.substring(8, 12);
	    }
	    if (noSpaces.length > 12) {
	      moddedText += " " + noSpaces.substring(12, 16);
	    }
	    if (didAddText && noSpaces.length % 4 == 0) {
	      moddedText += " ";
	    }
	    moddedText = moddedText.substring(0, 19);
	    this._newCardNumber = moddedText;
	
	    var cardType = cardTypeForNumber(moddedText);
	    var maxLengthCVC = validLengthCVCForCardType(cardType);
	    if (this._newCardSecurityMaxLength != maxLengthCVC) {
	      this._newCardSecurityMaxLength = maxLengthCVC;
	    }
	
	    if (moddedText != text) {
	      this._newCardNumber = moddedText;
	      this.showSetCard();
	    } else {
	      this._newCardNumber = text;
	      this.showSetCard();
	    }
	    var cardType = cardTypeForNumber(this._newCardNumber);
	    var maxLength = validLengthForCardType(cardType);
	    if (didAddText && maxLength > 0 && removeSpaces(this._newCardNumber).length == maxLength) {
	      if (typeof this._newCardMonthField.focus !== 'undefined') this._newCardMonthField.focus();
	    }
	  },
	
	  _newCardSecurity: "",
	  _newCardSecurityMaxLength: 3,
	  newCardSecurityTextChange: function newCardSecurityTextChange(text) {
	    var cardType = cardTypeForNumber(this._newCardNumber);
	    var maxLengthCVC = validLengthCVCForCardType(cardType);
	
	    var didAddText = text.length > this._newCardSecurity.length;
	    this._newCardSecurity = text;
	    if (didAddText && text.length >= maxLengthCVC) {
	      if (this.props.appManager.userRequiresPostalCode()) this._newCardPostalCodeField.focus();else this.setCardFinished();
	    }
	
	    if (this._newCardSecurityMaxLength != maxLengthCVC) {
	      this._newCardSecurityMaxLength = maxLengthCVC;
	      this.showSetCard();
	    }
	  },
	
	  _newCardPostalCode: "",
	  _newCardPostalCodeMaxLength: 7,
	  newCardPostalCodeTextChange: function newCardPostalCodeTextChange(text) {
	    var moddedText = text;
	    var didAddText = text.length > this._newCardPostalCode.length;
	    var noSpaces = removeSpaces(text);
	
	    if (isPossiblyPostalCode(noSpaces)) {
	      if (noSpaces.length > 3) {
	        moddedText = noSpaces.substring(0, 3) + " " + noSpaces.substring(3, noSpaces.length);
	      } else if (noSpaces.length > 2 && !didAddText) {
	        moddedText = noSpaces.substring(0, noSpaces.length);
	      } else if (noSpaces.length > 2 && didAddText) {
	        moddedText = noSpaces.substring(0, noSpaces.length) + " ";
	      }
	    }
	
	    var shouldReShow = moddedText != text;
	    this._newCardPostalCode = moddedText;
	
	    var postalError = !(isValidPostalCode(moddedText, "CA") || isValidPostalCode(moddedText, "US"));
	    shouldReShow |= postalError != this._postalError;
	    this._postalError = postalError;
	
	    var maxLength = isPossiblyPostalCode(moddedText) ? 7 : 5;
	    shouldReShow |= maxLength != this._newCardPostalCodeMaxLength;
	    this._newCardPostalCodeMaxLength = maxLength;
	
	    if (didAddText && moddedText.length >= maxLength) {
	      this.setCardFinished();
	    } else if (shouldReShow) {
	      this.showSetCard();
	    }
	  },
	
	  _newCardMonth: "",
	  newCardMonthTextChange: function newCardMonthTextChange(text) {
	    if (text.length > this._newCardMonth.length && (text.length == 1 && text != "1" && text != "0" || text.length == 2 && parseInt(text) < 13)) {
	      this._newCardYearField.focus();
	    }
	    this._newCardMonth = text;
	    this.showSetCard();
	  },
	
	  _newCardYear: "",
	  newCardYearTextChange: function newCardYearTextChange(text) {
	    if (text.length > this._newCardYear.length && text.length == 2) {
	      this._newCardSecurityField.focus();
	    }
	    this._newCardYear = text.substring(0, 2);
	  },
	
	  saveCard: function saveCard(token, lastFour, cardMonth, cardYear, cardType) {
	    var addCredit = this;
	    var user = this.props.appManager.currentUser();
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var appManager = this.props.appManager;
	    var checkingHUD = locManager.localizedStringForKey('CHECKING_HUD');
	    var savingHUD = locManager.localizedStringForKey('SAVING_HUD');
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    if (!useInterstitialFlow) {
	      appActions.setSpinnerShown(true, savingHUD);
	    } else {
	      addCredit.setState({ spinnerText: savingHUD });
	    }
	    NetworkManager.setCreditCard(addCredit.props.appManager, token, lastFour, cardMonth, cardYear, cardType, function (data) {
	      var paymentInfo = JSON.parse(data[0]);
	      appManager.setPaymentInfo(data[0], function (user) {
	        addCredit.setState({ numberOfSuccessfulCardAdds: addCredit.state.numberOfSuccessfulCardAdds + 1 });
	        if (!useInterstitialFlow) {
	          appActions.setSpinnerShown(false);
	          addCredit.setState({ sources: paymentInfo });
	          var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
	          var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
	          var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	          appActions.showAlert(successTitle, successBody, [successOkay], [function () {
	            appActions.hideAlert();
	            if (paymentInfo.length <= 1) appActions.requestPop(true);
	          }], function () {});
	        } else {
	          addCredit.setState({ shouldShowSpinner: false });
	          addCredit.props.extras.paymentTypesDidFinish();
	        }
	      });
	    }, function () {
	      var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	      var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	      var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      if (!useInterstitialFlow) {
	        appActions.setSpinnerShown(false);
	        appActions.showAlert(title, body, [okay], [addCredit.showSetCard], function () {});
	      } else {
	        addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	      }
	    }, function () {
	      if (!useInterstitialFlow) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(addCredit.showSetCard, function () {});
	      } else {
	        addCredit.setState({ shouldShowSpinner: false, showError: false });
	        addCredit.props.extras.showNetworkErrorAlert();
	      }
	    });
	  },
	
	  _cardError: false,
	  _monthError: false,
	  _yearError: false,
	  _cvvError: false,
	  _postalError: false,
	  setCardFinished: function setCardFinished() {
	    Keyboard.dismiss();
	    var addCredit = this;
	    this._cardError = false;
	    this._monthError = false;
	    this._YearError = false;
	    this._cvvError = false;
	    this._postalError = false;
	    if (!cardNumberIsValidLength(removeSpaces(this._newCardNumber))) {
	      this._cardError = true;
	    }
	    if (this._newCardMonth.length < 1 || parseInt(this._newCardMonth) < 0 || parseInt(this._newCardMonth) > 12) {
	      this._monthError = true;
	    }
	    if (this._newCardYear.length <= 0) {
	      this._yearError = true;
	    }
	    if (this._newCardSecurity.length < 3) {
	      this._cvvError = true;
	    }
	    if (this.props.appManager.userRequiresPostalCode() && !(isValidPostalCode(this._newCardPostalCode, "CA") || isValidPostalCode(this._newCardPostalCode, "US"))) {
	      this._postalError = true;
	    }
	
	    if (this._cardError || this._monthError || this._YearError || this._cvvError || this._postalError) {
	      this._setCardShown = false;
	      this.showSetCard();
	    } else {
	      var addCredit = this;
	      var user = this.props.appManager.currentUser();
	      var appActions = this.props.appActions;
	      var locManager = this.props.appManager.getLocalizationManager();
	      var appManager = this.props.appManager;
	      var checkingHUD = locManager.localizedStringForKey('CHECKING_HUD');
	      var savingHUD = locManager.localizedStringForKey('SAVING_HUD');
	      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	      if (!useInterstitialFlow) {
	        appActions.setCustomAlertShown(false);
	        appActions.setSpinnerShown(true, checkingHUD);
	      } else {
	        this.setState({ shouldShowSpinner: true, spinnerText: checkingHUD });
	        Keyboard.dismiss();
	      }
	
	      if (this.state.hasStripe) {
	        NetworkManager.stripeFetchToken(user[ModelConstants.StripeKey], removeSpaces(this._newCardNumber), this._newCardMonth, this._newCardYear, this._newCardSecurity, appManager.userRequiresPostalCode() ? removeSpaces(this._newCardPostalCode) : null, function (data) {
	          console.log("stripeFetchToken", data);
	          if (typeof data.error !== 'undefined') {
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(false);
	            } else {
	              addCredit.setState({ shouldShowSpinner: false });
	            }
	            if (data.error.type == "invalid_request_error") {
	              alert("Vendor's stripe account is not connected.");
	            } else if (data.error.code == "card_declined" || data.error.code == "number" || data.error.code == "incorrect_number") {
	              addCredit._cardError = true;
	            } else if (data.error.code == "month_error" || data.error.code == "invalid_expiry_month") {
	              addCredit._monthError = true;
	            } else if (data.error.code == "exp_year" || data.error.code == "invalid_expiry_year") {
	              addCredit._yearError = true;
	            } else if (data.error.code == "cvv_error" || data.error.code == "invalid_cvv" || data.error.code == "invalid_cvc") {
	              addCredit._cvvError = true;
	            } else if (data.error.code == "incorrect_zip") {
	              addCredit._postalError = true;
	            }
	            addCredit.showSetCard();
	          } else {
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(true, savingHUD);
	            } else {
	              addCredit.setState({ spinnerText: 'Saving Card...' });
	            }
	            var lastFour = addCredit._newCardNumber.substring(addCredit._newCardNumber.length - 4, addCredit._newCardNumber.length);
	            var cardType = cardTypeForNumber(addCredit._newCardNumber);
	            NetworkManager.setCreditCard(addCredit.props.appManager, data.id, lastFour, addCredit._newCardMonth, addCredit._newCardYear, cardType, function (data) {
	              var paymentInfo = JSON.parse(data[0]);
	              appManager.setPaymentInfo(data[0], function (user) {
	                addCredit.setCard();
	                if (!useInterstitialFlow) {
	                  appActions.setSpinnerShown(false);
	                  addCredit.setState({ sources: paymentInfo });
	                  var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
	                  var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
	                  var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	                  appActions.showAlert(successTitle, successBody, [successOkay], [function () {
	                    appActions.hideAlert();
	                    if (paymentInfo.length <= 1) appActions.requestPop(true);
	                  }], function () {});
	                } else {
	                  addCredit.setState({ shouldShowSpinner: false });
	                  addCredit.props.extras.paymentTypesDidFinish();
	                }
	              });
	            }, function () {
	              var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	              var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	              var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	              if (!useInterstitialFlow) {
	                appActions.setSpinnerShown(false);
	                appActions.showAlert(title, body, [okay], [addCredit.showSetCard], function () {});
	              } else {
	                addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	              }
	            }, function () {
	              if (!useInterstitialFlow) {
	                appActions.setSpinnerShown(false);
	                appActions.showNetworkErrorAlert(addCredit.showSetCard, function () {});
	              } else {
	                addCredit.setState({ shouldShowSpinner: false, showError: false });
	                addCredit.props.extras.showNetworkErrorAlert();
	              }
	            });
	          }
	        }, function (data) {
	          if (!useInterstitialFlow) {
	            appActions.setSpinnerShown(false);
	            appActions.showNetworkErrorAlert(addCredit.showSetCard, addCredit.showSetCard);
	          } else {
	            addCredit.setState({ shouldShowSpinner: false, showError: false });
	            addCredit.props.extras.showNetworkErrorAlert();
	          }
	        });
	      } else if (this.state.hasBeanStream) {
	        NetworkManager.beanStreamFetchToken(removeSpaces(this._newCardNumber), this._newCardMonth, this._newCardYear, this._newCardSecurity, function (data) {
	          if (typeof data.token === 'undefined') {
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(false);
	              appActions.showLocalizedAlert("CARD_PAYMENT_FAIL_ALERT_TITLE", "CARD_PAYMENT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"][addCredit.showSetCard], function () {});
	            } else {
	              addCredit.setState({ shouldShowSpinner: false, showError: true });
	            }
	          } else {
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(true, savingHUD);
	            } else {
	              var savingCardSpinnerStr = locManager.localizedStringForKey("SAVING_CARD_SPINNER");
	              addCredit.setState({ spinnerText: savingCardSpinnerStr });
	            }
	            var lastFour = addCredit._newCardNumber.substring(addCredit._newCardNumber.length - 4, addCredit._newCardNumber.length);
	            var cardType = cardTypeForNumber(addCredit._newCardNumber);
	            NetworkManager.setCreditCard(addCredit.props.appManager, data.token, lastFour, addCredit._newCardMonth, addCredit._newCardYear, cardType, function (data) {
	              var paymentInfo = JSON.parse(data[0]);
	              appManager.setPaymentInfo(data[0], function (user) {
	                if (!useInterstitialFlow) {
	                  appActions.setSpinnerShown(false);
	                  addCredit.setState({ sources: paymentInfo });
	                  var successTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_TITLE", "Success!");
	                  var successBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_TYPE_ALERT_BODY", "This card is now associated with your account.");
	                  var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	                  appActions.showAlert(successTitle, successBody, [successOkay], [function () {
	                    appActions.hideAlert();
	                    if (paymentInfo.length <= 1) appActions.requestPop(true);
	                  }], function () {});
	                } else {
	                  addCredit.setState({ shouldShowSpinner: false });
	                  addCredit.props.extras.paymentTypesDidFinish();
	                }
	              });
	            }, function () {
	              if (!useInterstitialFlow) {
	                appActions.setSpinnerShown(false);
	              } else {
	                addCredit.setState({ shouldShowSpinner: false });
	              }
	
	              if (data.code == -51) {
	                var title = locManager.localizedStringForKey("CREDIT_CARD_EXISTS_ERROR_ALERT_TITLE");
	                var body = locManager.localizedStringForKey("CREDIT_CARD_EXISTS_ERROR_ALERT_BODY");
	                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	                if (!useInterstitialFlow) {
	                  appActions.showAlert(title, body, [okay], [addCredit.showSetCard], function () {});
	                } else {
	                  addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	                }
	              } else if (data.code == -54) {
	                var title = locManager.localizedStringForKey("MAX_CARDS_ERROR_ALERT_TITLE");
	                var body = locManager.localizedStringForKey("MAX_CARDS_ERROR_ALERT_BODY");
	                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	                if (!useInterstitialFlow) {
	                  appActions.showAlert(title, body, [okay], [appActions.hideAlert()], function () {});
	                } else {
	                  addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	                }
	              } else {
	                var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	                var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	                var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	                if (!useInterstitialFlow) {
	                  appActions.showAlert(title, body, [okay], [addCredit.showSetCard], function () {});
	                } else {
	                  addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	                }
	              }
	            }, function () {
	              if (!useInterstitialFlow) {
	                appActions.setSpinnerShown(false);
	                appActions.showNetworkErrorAlert(addCredit.showSetCard, function () {});
	              } else {
	                addCredit.setState({ shouldShowSpinner: false, showError: false });
	                addCredit.props.extras.showNetworkErrorAlert();
	              }
	            });
	          }
	        }, function (data) {
	          if (!useInterstitialFlow) {
	            appActions.setSpinnerShown(false);
	            appActions.showNetworkErrorAlert(addCredit.showSetCard, addCredit.showSetCard);
	          } else {
	            addCredit.setState({ shouldShowSpinner: false, showError: false });
	            addCredit.props.extras.showNetworkErrorAlert();
	          }
	        });
	      }
	    }
	  },
	
	  _newCardNumberField: null,
	  _newCardMonthField: null,
	  _newCardYearField: null,
	  _newCardSecurityField: null,
	  setCard: function setCard() {
	    // reset any old new card info
	    this._newCardSecurity = "";
	    this._newCardMonth = "";
	    this._newCardYear = "";
	    this._newCardNumber = "";
	    this._newCardPostalCode = "";
	    this._cardError = false;
	    this._monthError = false;
	    this._yearError = false;
	    this._cvvError = false;
	    this._postalError = false;
	
	    this.showSetCard();
	  },
	
	  _errorCount: 0,
	  getSetCardView: function getSetCardView() {
	    var _this = this;
	
	    var user = this.props.appManager.currentUser();
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var setCreditCardLabel = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    if (this.state.hasStripe && Platform.OS == 'ios') {
	      return React.createElement(
	        View,
	        { style: { flex: 1, alignSelf: 'stretch', flexDirection: 'column', paddingBottom: useInterstitialFlow ? 0 : 10 } },
	        React.createElement(ReUpCreditCardInput, {
	          ref: function ref(_ref) {
	            return _this._cardInput = _ref;
	          },
	          key: "stripecreditinput" + this.state.numberOfSuccessfulCardAdds,
	          style: { height: 100, flex: 1 },
	          appManager: this.props.appManager,
	          onLoad: function onLoad() {
	            return _this.setState({ cardViewLoaded: true });
	          },
	          onError: function onError() {
	            var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	            var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	            var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(false);
	              appActions.showAlert(title, body, [okay], [appActions.hideAlert], appActions.hideAlert);
	            } else {
	              addCredit.setState({ shouldShowSpinner: false, showError: true, errorMessage: body });
	            }
	          } }),
	        React.createElement(ReUpButton, { appManager: this.props.appManager, text: setCreditCardLabel, style: { marginHorizontal: 10, opacity: this.state.cardViewLoaded ? 1 : .4 }, onPress: function onPress() {
	            if (!thisThing._cardInput.hasLoaded()) return;
	
	            if (!useInterstitialFlow) {
	              appActions.setSpinnerShown(true, processingHUD);
	            } else {
	              thisThing.setState({ shouldShowSpinner: true, spinnerText: processingHUD });
	            }
	            thisThing._cardInput.retrieveCardInfo(function (cardInfo) {
	              thisThing.saveCard(cardInfo.token, cardInfo.last4, cardInfo.exp_month, cardInfo.exp_year, cardTypeFromName(cardInfo.cardType));
	              thisThing._cardInfo = cardInfo;
	            }, function () {
	              // if ( !useInterstitialFlow )
	              // {
	              //   appActions.setSpinnerShown(false);
	              // }
	              // else
	              // {
	              //   thisThing.setState({shouldShowSpinner: false, spinnerText: ""})
	              // }
	              // Leaving this blank because elements seems to take care of the error
	              //
	              var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	              var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	              var okay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	              if (!useInterstitialFlow) {
	                appActions.setSpinnerShown(false);
	                appActions.showAlert(title, body, [okay], [function () {
	                  appActions.hideAlert();
	                  thisThing.showSetCard();
	                }], function () {});
	              } else {
	                thisThing.setState({ shouldShowSpinner: false, spinnerText: "" });
	                thisThing._errorCount++;
	                if (thisThing._errorCount > 2) {
	                  thisThing.props.extras.interstitialDidFinish(function (appActions) {
	                    appActions.showAlert(title, body, [okay], [appActions.hideAlert], function () {});
	                  });
	                }
	              }
	            });
	          }
	        })
	      );
	    } else if (this.state.hasStripe || this.state.hasBeanStream) {
	      var addCredit = this;
	      var appManager = this.props.appManager;
	      var locManager = this.props.appManager.getLocalizationManager();
	      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	      var setCreditCardLabel = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");
	
	      var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	      var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	      var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	
	      var cardType = cardTypeForNumber(this._newCardNumber);
	      var maxLength = validLengthForCardType(cardType);
	      var errorMessage = this.state.errorMessage;
	      if (maxLength < 0) maxLength = 16;
	      maxLength += 3;
	
	      var cardNumberError = this._newCardNumber.length >= 4 ? cardType < 0 : false;
	
	      var _newCardNumberField = React.createElement(ReUpField, {
	        key: 'card',
	        ref: function ref(a) {
	          addCredit._newCardNumberField = a;
	          if (!addCredit._setCardShown && addCredit._newCardNumberField && addCredit._newCardNumberField != null && !useInterstitialFlow) {
	            setTimeout(function () {
	              if (typeof addCredit._newCardNumberField !== 'undefined' && addCredit._newCardNumberField != null) {
	                addCredit._newCardNumberField.focus();
	                addCredit._setCardShown = true;
	              }
	            }, 2000);
	          }
	        },
	        value: this._newCardNumber,
	        underlineColorAndroid: 'transparent',
	        keyboardType: "phone-pad",
	        appManager: appManager,
	        onChangeText: this.newCardTextChange.bind(this),
	        tintColor: this._cardError || cardNumberError ? 'red' : bannerColor,
	        highlightColor: this._cardError || cardNumberError ? 'red' : bannerColor,
	        textInputStyle: { color: generalTitleColor },
	        placeholder: locManager.localizedStringForKey("CARD_NUMBER_PLACEHOLDER"),
	        onSubmitEditing: function onSubmitEditing() {
	          return _this._newCardMonthField.focus();
	        },
	        maxLength: maxLength,
	        style: { flex: 1 } });
	
	      var isMonthError = parseInt(this._newCardMonth) > 12;
	      var _newCardMonthField = React.createElement(ReUpField, {
	        key: 'month',
	        ref: function ref(a) {
	          return addCredit._newCardMonthField = a;
	        },
	        underlineColorAndroid: 'transparent',
	        maxLength: 2,
	        appManager: appManager,
	        defaultValue: this._newCardMonth,
	        keyboardType: "phone-pad",
	        onChangeText: this.newCardMonthTextChange.bind(this),
	        tintColor: this._monthError || isMonthError ? 'red' : bannerColor,
	        highlightColor: this._monthError || isMonthError ? 'red' : bannerColor,
	        textInputStyle: { color: generalTitleColor },
	        placeholder: locManager.localizedStringForKey("MONTH_MONTH_SHORT_DATE_PLACEHOLDER", "MM"),
	        onSubmitEditing: function onSubmitEditing() {
	          return _this._newCardYearField.focus();
	        },
	        style: { width: 50, alignSelf: 'stretch' } });
	
	      var _newCardYearField = React.createElement(ReUpField, {
	        key: 'Year',
	        ref: function ref(a) {
	          return addCredit._newCardYearField = a;
	        },
	        underlineColorAndroid: 'transparent',
	        maxLength: 2,
	        appManager: appManager,
	        defaultValue: this._newCardYear,
	        keyboardType: "phone-pad",
	        onChangeText: this.newCardYearTextChange.bind(this),
	        tintColor: this._yearError ? 'red' : bannerColor,
	        highlightColor: this._yearError ? 'red' : bannerColor,
	        textInputStyle: { color: generalTitleColor },
	        placeholder: locManager.localizedStringForKey("YEAR_YEAR_SHORT_DATE_PLACEHOLDER", "YY"),
	        onSubmitEditing: function onSubmitEditing() {
	          return _this._newCardSecurityField.focus();
	        },
	        style: { width: 50 } });
	
	      var _newCardSecurityField = React.createElement(ReUpField, {
	        key: 'CVV',
	        ref: function ref(a) {
	          return addCredit._newCardSecurityField = a;
	        },
	        underlineColorAndroid: 'transparent',
	        maxLength: this._newCardSecurityMaxLength,
	        appManager: appManager,
	        defaultValue: this._newCardSecurity,
	        keyboardType: "phone-pad",
	        onChangeText: this.newCardSecurityTextChange.bind(this),
	        tintColor: this._cvvError ? 'red' : bannerColor,
	        highlightColor: this._cvvError ? 'red' : bannerColor,
	        textInputStyle: { color: generalTitleColor },
	        placeholder: locManager.localizedStringForKey("CREDIT_CARD_CSV_PLACEHOLDER", "CVV"),
	        style: { width: 60 } });
	
	      var _newCardPostalCodeField = null;
	      if (appManager.userRequiresPostalCode()) {
	        _newCardPostalCodeField = React.createElement(ReUpField, {
	          key: 'POSTAL',
	          ref: function ref(a) {
	            return addCredit._newCardPostalCodeField = a;
	          },
	          underlineColorAndroid: 'transparent',
	          maxLength: this._newCardPostalCodeMaxLength,
	          appManager: appManager,
	          defaultValue: this._newCardPostalCode,
	          onChangeText: this.newCardPostalCodeTextChange.bind(this),
	          tintColor: this._postalError ? 'red' : bannerColor,
	          highlightColor: this._postalError ? 'red' : bannerColor,
	          textInputStyle: { color: generalTitleColor },
	          placeholder: locManager.localizedStringForKey("POSTAL_ZIP_CODE", "postal/zip Code"),
	          style: { width: 120 } });
	      }
	
	      var outerStyle = {};
	      if (useInterstitialFlow) outerStyle = { paddingHorizontal: 20 };
	      var setCardView = React.createElement(
	        View,
	        { key: "stripecreditinput" + this.state.numberOfSuccessfulCardAdds },
	        addCredit._hasCamera && CardIO != null ? React.createElement(
	          View,
	          { style: { paddingBottom: 4, marginTop: useInterstitialFlow ? 10 : 0 } },
	          React.createElement(ReUpIconButton, { key: addCredit.state.cameraView != null ? "credit-card" : "camera", iconName: addCredit.state.cameraView != null ? "credit-card" : "camera", type: 1,
	            appManager: appManager,
	            style: { alignSelf: 'flex-end' },
	            onPress: function onPress() {
	              if (addCredit.state.cameraView == null) addCredit.showCardIO();else addCredit.setState({ cameraView: null });
	            }
	          })
	        ) : React.createElement(View, null),
	        addCredit.state.cameraView !== 'undefined' && addCredit.state.cameraView != null ? addCredit.state.cameraView : React.createElement(
	          View,
	          { style: outerStyle },
	          React.createElement(
	            View,
	            { style: styles.cardNumberContainer },
	            _newCardNumberField
	          ),
	          React.createElement(
	            View,
	            { style: styles.dateContainer },
	            _newCardMonthField,
	            React.createElement(
	              View,
	              { style: { alignSelf: 'flex-end' } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: styles.dateSlash },
	                '/'
	              )
	            ),
	            _newCardYearField,
	            React.createElement(View, { style: { flex: 1 } }),
	            _newCardSecurityField
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', marginHorizontal: 8, alignSelf: 'center' } },
	            _newCardPostalCodeField
	          ),
	          addCredit.state.showError && useInterstitialFlow ? React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { color: 'red', marginLeft: 10, marginTop: 10 } },
	            errorMessage
	          ) : null,
	          React.createElement(ReUpButton, { style: [styles.choiceButton, { marginTop: 20, marginBottom: 10, marginLeft: 10, marginRight: 10 }],
	            appManager: appManager,
	            text: setCreditCardLabel,
	            onPress: function onPress() {
	              addCredit.setCardFinished();
	            }
	          })
	        )
	      );
	
	      return setCardView;
	    }
	
	    return React.createElement(View, { key: "stripecreditinput" + this.state.numberOfSuccessfulCardAdds });
	  },
	
	  _setCardShown: false,
	  showSetCard: function showSetCard() {
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    if (useInterstitialFlow) {
	      this.setState({ cameraView: null });
	      return;
	    }
	    this.props.appActions.hideAlert();
	    this.setState({ cameraView: null });
	    return;
	
	    var thisThing = this;
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true,
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive", style: { margin: 0, padding: 2, paddingTop: 10 } },
	      thisThing.getSetCardView()
	    );
	
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  showCardIO: function showCardIO() {
	    if (Platform.OS === 'ios') {
	      var addCredit = this;
	      var appManager = this.props.appManager;
	      var locManager = this.props.appManager.getLocalizationManager();
	      var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	      var customAlert = React.createElement(
	        ScrollView,
	        { bounces: true,
	          keyboardShouldPersistTaps: true,
	          keyboardDismissMode: "interactive", style: { margin: 0 } },
	        React.createElement(CardIO, {
	          style: {
	            height: this.state.layout.height - 120,
	            backgroundColor: 'black'
	          }
	        })
	      );
	
	      if (useInterstitialFlow) {
	        this.setState({ cameraView: customAlert });
	      } else {
	        this.props.appActions.setCustomAlertShown(true, customAlert);
	      }
	    } else {
	      CardIO.show();
	    }
	  },
	
	  submit: function submit() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var transactionConfirmTitle = locManager.localizedStringForKey("ADDCREDIT_CONFIRM_ALERT_TITLE");
	    var transactionConfirmBody = locManager.localizedStringForKeyAndParams("ADDCREDIT_CONFIRM_ALERT_BODY", [this.amountText()]);
	    var yesText = locManager.localizedStringForKey("YES_ALERT_BUTTON");
	    var noText = locManager.localizedStringForKey("NO_ALERT_BUTTON");
	
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	
	    var paymentSuccessTitle = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_TITLE");
	    var paymentSuccessBody = locManager.localizedStringForKey("SUCCESS_PAYMENT_ALERT_BODY");
	    var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	    var paymentFailTitle = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_TITLE");
	    var paymentFailBody = locManager.localizedStringForKey("CARD_PAYMENT_FAIL_ALERT_BODY");
	    appActions.showAlert(transactionConfirmTitle, transactionConfirmBody, [noText, yesText], [appActions.hideAlert, function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, processingHUD);
	      NetworkManager.submitPayment(appManager, thisThing.amount(), function (data) {
	        appActions.setSpinnerShown(false);
	        var user = appManager.currentUser();
	        user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) + parseFloat(thisThing.amount());
	        appManager.setCurrentUser(user, function () {
	          appActions.showAlert(paymentSuccessTitle, paymentSuccessBody, [okayText], [function () {
	            appActions.requestPop(false);appActions.hideAlert();
	          }]);
	        });
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showAlert(paymentFailTitle, paymentFailBody, [okayText]);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }, appActions.hideAlert], function () {});
	  },
	
	  pullToRefreshView: function pullToRefreshView() {
	    return this.refs.ptr;
	  },
	
	  update: function update() {},
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    this.props.appManager.getCurrentUser(function (user) {
	      thisThing.setState({ user: user, sources: thisThing.props.appManager.getPaymentInfo() });
	    });
	  },
	
	  didSelectSourceIndex: function didSelectSourceIndex(index) {
	    var method = this.state.sources[index];
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    if (method.isPrimary) {
	      if (thisThing.props.extras.shouldPopAfterSelectingPaymentType) {
	        setTimeout(function () {
	          appActions.requestPop(true);
	        }, 100);
	      }
	      return; // already primary
	    }
	
	    var refreshOrCardID = method.sourceType == 'pp' ? method.refreshToken : method.cardID;
	    appActions.setSpinnerShown(true, appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD"));
	    NetworkManager.setPrimaryPaymentMethod(this.props.appManager, refreshOrCardID, function (data) {
	      thisThing._setCardShown = false;
	      var paymentInfo = JSON.parse(data[0]);
	      appManager.setPaymentInfo(data[0], function (user) {
	        appActions.setSpinnerShown(false);
	        thisThing.setState({ sources: paymentInfo });
	        if (thisThing.props.extras.shouldPopAfterSelectingPaymentType) {
	          setTimeout(function () {
	            appActions.requestPop(true);
	          }, 100);
	        }
	      });
	    }, function (data) {
	      thisThing._setCardShown = false;
	      appActions.setSpinnerShown(false);
	      appActions.showLocalizedAlert("CHANGE_PAYMENT_METHOD_ERROR_ALERT_TITLE", "CHANGE_PAYMENT_METHOD_ERROR_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	      }], function () {});
	    }, function (data) {
	      thisThing._setCardShown = false;
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	  },
	
	  didSelectDeleteSourceIndex: function didSelectDeleteSourceIndex(index) {
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    appActions.showLocalizedAlert("DELETE_PAYMENT_TYPE_ALERT_TITLE", "DELETE_PAYMENT_TYPE_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	      appActions.hideAlert();
	    }, function () {
	      var method = thisThing.state.sources[index];
	      var refreshOrCardID = method.sourceType == 'pp' ? method.refreshToken : method.cardID;
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD"));
	      NetworkManager.removePaymentMethod(thisThing.props.appManager, refreshOrCardID, function (data) {
	        var paymentInfo = JSON.parse(data[0]);
	        appManager.setPaymentInfo(data[0], function (user) {
	          appActions.setSpinnerShown(false);
	          thisThing.setState({ sources: paymentInfo });
	        });
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert("UNABLE_TO_REMOVE_PAYMENT_TYPE_ALERT_TITLE", "UNABLE_TO_REMOVE_PAYMENT_TYPE_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }], function () {});
	  },
	
	  addPayPal: function addPayPal() {
	    RNPayPalManager.showPayPal(this.props.appManager.currentUser()[ModelConstants.UserName], this.props.appManager.appName);
	    // var sources = this.state.sources;
	    // sources.push({isPayPal:true,userName:"kjregan10@gmail.com",isPrimary:false});
	    // this.setState({sources:sources})
	  },
	
	  hasPayPal: function hasPayPal() {
	    var hasPayPal = false;
	    var sources = this.state.sources;
	    for (var i = 0; i < sources.length; i++) {
	      if (sources[i].sourceType == 'pp') {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  render: function render() {
	    if (RNPayPalManager) {
	      if (typeof this.state.payPalEnvironment !== 'undefined') {
	        RNPayPalManager.setPayPalSandbox(this.state.payPalEnvironment == "sandbox");
	      }
	      if (typeof this.state.payPalClientID !== 'undefined') {
	        RNPayPalManager.setPayPalClientID(this.state.payPalClientID, this.state.payPalClientID);
	        RNPayPalManager.retrieveClientMetadataID();
	      }
	    }
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = this.state.user;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    var credit = user != null ? parseFloat(user[ModelConstants.Credits]) : '';
	    var maxCredit = MAX_CREDIT;
	    var creditRatio = parseFloat(credit) / parseFloat(maxCredit);
	    var flexPositive = Math.round(100 * Math.min(creditRatio, 1));
	    var useMinWidth = flexPositive > 0;
	    var flexNegative = 100 - flexPositive;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var howMuchStatement = locManager.localizedStringForKey("HOW_MUCH_LABEL");
	    var setCreditCardButton = locManager.localizedStringForKey("ADD_CREDIT_CARD_BUTTON");
	
	    var cardText = "";
	    var cardType = user != null ? user[ModelConstants.CardType] : null;
	    if (this.state.proposedCardNumber.length > 0) {
	      cardText = "**** **** **** " + this.state.proposedCardNumber.substring(this.state.proposedCardNumber.length - 4, this.state.proposedCardNumber.length);
	      cardType = cardTypeForNumber(this.state.proposedCardNumber);
	    } else if (user != null && user[ModelConstants.LastFour]) {
	      cardText = "**** **** **** " + user[ModelConstants.LastFour];
	    }
	
	    var priceChooserProps = {};
	    if (lastSelectedAmount != null) {
	      priceChooserProps.initialAmount = lastSelectedAmount;
	    }
	
	    var shouldShowOr = (this.state.hasStripe || this.state.hasBeanStream) && this.state.hasPayPal && !this.hasPayPal();
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, style: { backgroundColor: generalColor } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	          useInterstitialFlow ? locManager.localizedStringForKey("PAYMENT_TYPE_INSTRUCTION") : appManager.getFeatureForName("PaymentTypes").data.instructions
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        useInterstitialFlow && thisThing.getSetCardView(),
	        this.state.sources.map(function (source, index) {
	          if (useInterstitialFlow) return null;
	
	          if (source.sourceType == 'pp') {
	            return React.createElement(
	              View,
	              { style: { flexDirection: 'column' }, key: "source" + index },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  MKButton,
	                  { onPress: function onPress() {
	                      thisThing.didSelectSourceIndex(index);
	                    }, rippleColor: primaryButtonColorLight, maskBorderRadius: 0, style: [styles.oldCardContainer] },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row' } },
	                    React.createElement(MKRadioButton, {
	                      checked: source.isPrimary,
	                      fillColor: generalTitleColor,
	                      borderOnColor: generalTitleColor,
	                      borderOffColor: generalTitleColor,
	                      rippleColor: primaryButtonColorLight
	                    }),
	                    React.createElement(Image, { resizeMode: Image.resizeMode.contain, source: { uri: PlatformConstants.packagedResourcesDirectory + '/App/paypal.png' }, style: { backgroundColor: 'transparent', height: 30, width: 110 } }),
	                    React.createElement(
	                      View,
	                      { style: { flex: 1, alignSelf: 'center' } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: {
	                            fontStyle: 'italic',
	                            margin: 4,
	                            textAlign: 'center',
	                            opacity: .6
	                          }, numberOfLines: 1 },
	                        source.username
	                      )
	                    )
	                  )
	                ),
	                React.createElement(
	                  MKButton,
	                  { onPress: function onPress() {
	                      thisThing.didSelectDeleteSourceIndex(index);
	                    }, maskBorderRadius: 0, style: { marginRight: 10, height: 60, width: 40, alignItems: 'center', justifyContent: 'center' } },
	                  React.createElement(_ReUpIcon2.default, { style: styles.creditCardIcon, name: "times", size: 28, color: generalTitleColor })
	                )
	              ),
	              React.createElement(ShadowView, { layout: thisThing.state.layout, appManager: appManager })
	            );
	          }
	          cardText = "**** **** **** " + source.last4;
	          return React.createElement(
	            View,
	            { style: { flexDirection: 'column' }, key: "source" + index },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', flex: 1 } },
	              React.createElement(
	                MKButton,
	                { onPress: function onPress() {
	                    thisThing.didSelectSourceIndex(index);
	                  }, maskBorderRadius: 0, key: "source" + index, rippleColor: primaryButtonColorLight, style: [styles.oldCardContainer] },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row' } },
	                  React.createElement(MKRadioButton, {
	                    checked: source.isPrimary,
	                    fillColor: generalTitleColor,
	                    borderOnColor: generalTitleColor,
	                    borderOffColor: generalTitleColor,
	                    rippleColor: primaryButtonColorLight
	                  }),
	                  React.createElement(_ReUpIcon2.default, { style: styles.creditCardIcon, maskBorderRadius: 0, name: iconNameForCardType(source.cardType), size: 22, color: generalTitleColor }),
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: styles.creditCardText },
	                    cardText
	                  )
	                )
	              ),
	              React.createElement(
	                MKButton,
	                { onPress: function onPress() {
	                    thisThing.didSelectDeleteSourceIndex(index);
	                  }, maskBorderRadius: 0, rippleColor: primaryButtonColorLight, style: { padding: 10, height: 60, width: 60, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(_ReUpIcon2.default, { style: styles.creditCardIcon, name: "times", size: 18, color: generalTitleColor })
	              )
	            ),
	            React.createElement(ShadowView, { layout: thisThing.state.layout, appManager: appManager })
	          );
	        }),
	        this.state.hasStripe && !useInterstitialFlow ? React.createElement(
	          View,
	          { style: { alignSelf: 'stretch' } },
	          thisThing.getSetCardView()
	        ) : null,
	        this.state.hasBeanStream && !useInterstitialFlow ? React.createElement(
	          View,
	          { style: { alignSelf: 'stretch' } },
	          thisThing.getSetCardView()
	        ) : null,
	        shouldShowOr ? React.createElement(ShadowView, { layout: this.state.layout, text: locManager.localizedStringForKey("OR_LABEL"), appManager: appManager }) : null,
	        this.state.hasPayPal && !this.hasPayPal() ? React.createElement(
	          ReUpButton,
	          { isSecondary: true, style: [styles.doneButton, { margin: 10, marginTop: 0 }, this.state.hasStripe || this.state.hasBeanStream ? {} : { marginTop: 10 }], appManager: appManager,
	            text: "",
	            onPress: function onPress() {
	              thisThing.addPayPal();
	            }
	          },
	          React.createElement(Image, { resizeMode: 'contain', source: { uri: PlatformConstants.packagedResourcesDirectory + '/App/paypal.png' }, style: { backgroundColor: 'transparent', height: 26, width: 110, flex: -1 } })
	        ) : null
	      ),
	      this.state.shouldShowSpinner ? React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner,
	        spinnerText: this.state.spinnerText, spinnerBody: this.state.spinnerBody,
	        layout: this.state.layout, appManager: appManager }) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 10,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 60,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    flex: 1,
	    alignItems: 'center',
	    height: 60,
	    paddingLeft: 10,
	    alignSelf: 'center',
	    paddingRight: 10,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    width: 50,
	    justifyContent: 'center',
	    textAlign: 'center',
	    margin: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    margin: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    fontSize: 30,
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0,
	    marginBottom: 0
	  },
	
	  textField: {
	    width: -1
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    marginHorizontal: 8
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1
	  },
	
	  segmentContainer: {
	    height: 50,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	PaymentTypes.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var locManager = appManager.getLocalizationManager();
	  var isLoggedIn = appManager.isLoggedIn();
	  if (!isLoggedIn) return [];
	  if (typeof appManager.getFeatureForName("UseCredit") === 'undefined' && typeof appManager.getFeatureForName("AddPass") === 'undefined' && typeof appManager.getFeatureForName("SendGiftCard") === 'undefined') return [];
	
	  var user = appManager.currentUser();
	  var paymentInfo = appManager.getPaymentInfo();
	  var hasPrimaryPaymentMethod = appManager.userHasPrimaryPaymentMethod();
	  if (hasPrimaryPaymentMethod) return [];
	
	  var iconName = featureData.data.icon.replace("fa-", "");
	
	  return [{
	    didSelect: function didSelect() {
	      appActions.requestFeatureName("PaymentTypes");
	    },
	    title: featureData.data.title,
	    body1: locManager.localizedStringForKey("PAYMENT_TYPE_TIP"),
	    icon: featureData.data.icon.replace("fa-", ""),
	    cardType: 0,
	    sortOrder: 5
	  }];
	};
	
	PaymentTypes.dataDependencies = ["Users", "Transactions"];
	
	module.exports = PaymentTypes;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Icon = __webpack_require__(13);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpField = __webpack_require__(26);
	
	var ReUpButton = __webpack_require__(12);
	var ReUpText = __webpack_require__(8);
	var ProgressOverlay = __webpack_require__(52);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    Platform = ReactNative.Platform,
	    Animated = ReactNative.Animated,
	    StyleSheet = ReactNative.StyleSheet,
	    Keyboard = ReactNative.Keyboard;
	
	
	var PhoneNumberVerify = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isInputtingPhone: true,
	      hasValidPhone: false,
	      hasValidCode: false,
	      isInError: false
	    };
	  },
	
	  _phoneText1Placeholder: "###",
	  _phoneText2Placeholder: "###",
	  _phoneText3Placeholder: "####",
	  componentDidMount: function componentDidMount() {
	    var appManager = this.props.appManager;
	    if (appManager.isLoggedIn()) {
	      var phoneNumber = appManager.currentUser()[ModelConstants.PhoneNumber];
	      if (typeof phoneNumber !== 'undefined' && phoneNumber != null) {
	        this._phoneText1Placeholder = phoneNumber.substring(1, 4);
	        this._phoneText2Placeholder = phoneNumber.substring(4, 7);
	        this._phoneText3Placeholder = phoneNumber.substring(7, 11);
	      }
	    }
	
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    if (!useInterstitialFlow) {
	      var thisThing = this;
	      setTimeout(function () {
	        if (thisThing._phone1) thisThing._phone1.focus();
	      }, 1000);
	    }
	    this.setIsInError(false);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate() {},
	
	  focus: function focus() {
	    var thisThing = this;
	    setTimeout(function () {
	      if (thisThing._phone1) thisThing._phone1.focus();
	    }, 200);
	  },
	
	  _phoneTextCountryCode: "1",
	  _phoneText1: "",
	  _phoneText2: "",
	  _phoneText3: "",
	  hasValidPhone: function hasValidPhone() {
	    return this._phoneText1.length == 3 && this._phoneText2.length == 3 && this._phoneText3.length == 4;
	  },
	
	  _codeText1: "",
	  _codeText2: "",
	  _codeText3: "",
	  _codeText4: "",
	  _codeText5: "",
	  _codeText6: "",
	  hasValidCode: function hasValidCode() {
	    return this._codeText1.length == 1 && this._codeText2.length == 1 && this._codeText3.length == 1 && this._codeText4.length == 1 && this._codeText5.length == 1 && this._codeText6.length == 1;
	  },
	
	  getPhoneNumber: function getPhoneNumber() {
	    return this._phoneTextCountryCode + "-" + this._phoneText1 + "-" + this._phoneText2 + "-" + this._phoneText3;
	  },
	
	  getPhoneNumberPlain: function getPhoneNumberPlain() {
	    return this._phoneTextCountryCode + this._phoneText1 + this._phoneText2 + this._phoneText3;
	  },
	
	  getCode: function getCode() {
	    return this._codeText1 + this._codeText2 + this._codeText3 + this._codeText4 + this._codeText5 + this._codeText6;
	  },
	
	  _hasAutoCheckedCode: false,
	  checkCode: function checkCode() {
	    this._hasAutoCheckedCode = true;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    this.setSpinnerShown(true);
	    NetworkManager.verifyAndSetPhoneNumber(appManager, thisThing.getPhoneNumber(), thisThing.getCode(), function (data) {
	      thisThing.setSpinnerShown(false);
	      var user = appManager.currentUser();
	      user[ModelConstants.PhoneNumber] = thisThing.getPhoneNumberPlain();
	      appManager.setCurrentUser(user);
	      if (useInterstitialFlow) {
	        thisThing.props.extras.setPhoneDidFinish();
	      } else {
	        var phoneSuccessTitle = locManager.localizedStringForKey("PHONE_SUCCESS_ALERT_TITLE", "Success!");
	        var phoneSuccessBody = locManager.localizedStringForKey("PHONE_SUCCESS_ALERT_BODY", "Your phone number has been set.");
	        var successOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	        appActions.showAlert(phoneSuccessTitle, phoneSuccessBody, [successOkay], [function () {
	          appActions.hideAlert();
	          appActions.requestPop(true);
	        }], function () {
	          appActions.requestPop(true);
	        });
	      }
	    }, function () {
	      thisThing.setSpinnerShown(false);
	      thisThing.setIsInError(true, locManager.localizedStringForKey("INVALID_CODE", "Invalid code."));
	    }, function () {
	      thisThing.setSpinnerShown(false);
	      if (useInterstitialFlow) {
	        thisThing.props.extras.showNetworkErrorAlert();
	      } else {
	        thisThing.setIsInError(false);
	      }
	    });
	  },
	
	  setSpinnerShown: function setSpinnerShown(shouldShowSpinner) {
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	    if (useInterstitialFlow) {
	      this.setState({ shouldShowSpinner: shouldShowSpinner });
	    } else {
	      this.props.appActions.setSpinnerShown(shouldShowSpinner);
	    }
	  },
	
	  sendCode: function sendCode() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    this.setSpinnerShown(true);
	    NetworkManager.sendPhoneNumberCode(appManager, thisThing.getPhoneNumber(), function () {
	      thisThing.setSpinnerShown(false);
	      thisThing.setState({ isInputtingPhone: false });
	      setTimeout(function () {
	        if (thisThing._code1) thisThing._code1.focus();
	        thisThing.setIsInError(false);;
	      }, 200);
	    }, function (error) {
	      thisThing.setSpinnerShown(false);
	      if (typeof error !== 'undefined' && error.code == -69) {
	        thisThing.setIsInError(true, locManager.localizedStringForKey("DUPLICATE_PHONE_ERROR", "This phone number is already in use."));
	      } else {
	        thisThing.setIsInError(true, locManager.localizedStringForKey("INVALID_PHONE_ERROR", "This phone number is invalid."));
	      }
	      thisThing.setState({ isInputtingPhone: true });
	    }, function () {
	      thisThing.setSpinnerShown(false);
	      thisThing.setState({ isInputtingPhone: true });
	    });
	  },
	
	  setIsInError: function setIsInError(isInError, errorMessage) {
	    if (isInError != this.state.isInError) this.setState({ isInError: isInError });
	    if (typeof errorMessage !== 'undefined' && errorMessage != this.state.errorMessage) {
	      this.setState({ errorMessage: errorMessage });
	    } else if (typeof errorMessage === 'undefined' && this.state.errorMessage != null) {
	      this.setState({ errorMessage: null });
	    }
	  },
	
	  backSpacePressed: function backSpacePressed(fieldKey) {
	    switch (fieldKey) {
	      case 'code1':
	        break;
	      case 'code2':
	        if (this._codeText2.length <= 0) {
	          this._codeText1 = "";
	          this._code1.setText("");
	          this._code1.focus();
	        }
	        break;
	      case 'code3':
	        if (this._codeText3.length <= 0) {
	          this._codeText2 = "";
	          this._code2.setText("");
	          this._code2.focus();
	        }
	        break;
	      case 'code4':
	        if (this._codeText4.length <= 0) {
	          this._codeText3 = "";
	          this._code3.setText("");
	          this._code3.focus();
	        }
	        break;
	      case 'code5':
	        if (this._codeText5.length <= 0) {
	          this._codeText4 = "";
	          this._code4.setText("");
	          this._code4.focus();
	        }
	        break;
	      case 'code6':
	        if (this._codeText6.length <= 0) {
	          this._codeText5 = "";
	          this._code5.setText("");
	          this._code5.focus();
	        }
	        break;
	      case 'phone1':
	        break;
	      case 'phone2':
	        if (this._phoneText2.length <= 0) {
	          this._phoneText1 = "";
	          this._phone1.setText("");
	          this._phone1.focus();
	        }
	        break;
	      case 'phone3':
	        if (this._phoneText3.length <= 0) {
	          this._phoneText2 = "";
	          this._phone2.setText("");
	          this._phone2.focus();
	        }
	        break;
	      default:
	
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var isInputtingPhone = this.state.isInputtingPhone;
	    var useInterstitialFlow = typeof this.props.extras !== 'undefined' && this.props.extras != null && this.props.extras.useInterstitialFlow;
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var phoneSeparators = ["(", ") ", " - "];
	
	    var instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS", "Please verify your phone number below.");
	    if (useInterstitialFlow) {
	      instructions = locManager.localizedStringForKey("PAYMENTTYPES_PHONE_INSTRUCTIONS", "You must verify your phone number before you can reload your app.");
	    } else if (appActions._attemptedFeature != null && appActions._attemptedFeature.length > 0) {
	      for (var i = 0; i < appActions._attemptedFeature.length; i++) {
	        var firstAttemptedFeature = appActions._attemptedFeature[i];
	        if (firstAttemptedFeature.key == "PaymentTypes") instructions = locManager.localizedStringForKey("PAYMENTTYPES_PHONE_INSTRUCTIONS", "You must verify your phone number before you can add a payment type.");
	        if (firstAttemptedFeature.key == "AddCredit") instructions = locManager.localizedStringForKey("ADDCREDIT_PHONE_INSTRUCTIONS", "You must verify your phone number before you can reload your app.");
	        if (firstAttemptedFeature.key == "UseReward") instructions = locManager.localizedStringForKey("USEREWARD_PHONE_INSTRUCTIONS", "You must verify your phone number before you can redeem a reward.");
	        if (firstAttemptedFeature.key == "SendGiftCard") instructions = locManager.localizedStringForKey("SENDGIFTCARD_PHONE_INSTRUCTIONS", "You must verify your phone number before you can purchase a gift card.");
	        if (firstAttemptedFeature.key == "AddPass") instructions = locManager.localizedStringForKey("ADDPASS_PHONE_INSTRUCTIONS", "You must verify your phone number before you can purchase a pass.");
	        if (firstAttemptedFeature.key == "UsePass") instructions = locManager.localizedStringForKey("USEPASS_PHONE_INSTRUCTIONS", "You must verify your phone number before you can use a pass.");
	        if (instructions != locManager.localizedStringForKey("PHONE_INSTRUCTIONS", "Please verify your phone number below.")) break;
	      }
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, style: { backgroundColor: generalColor } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	          isInputtingPhone ? instructions : locManager.localizedStringForKeyAndParams("INPUT_CODE_STATEMENT", [thisThing.getPhoneNumber()], "We have texted a code to %0%. Please input that code below.")
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        isInputtingPhone ? React.createElement(
	          View,
	          { style: { alignSelf: 'stretch', flexDirection: 'column' } },
	          React.createElement(
	            View,
	            { style: { paddingRight: 8, alignItems: 'center', justifyContent: 'center', flexDirection: 'row' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { marginTop: 18, padding: 4, fontSize: 24 } },
	              phoneSeparators[0]
	            ),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._phone1 = a;
	              },
	              key: 'phone1',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("phone1");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._phoneText1 = text;
	                var hasValidPhone = thisThing.hasValidPhone();
	                if (thisThing.state.hasValidPhone != hasValidPhone) thisThing.setState({ hasValidPhone: hasValidPhone });
	                if (text.length >= 3) thisThing._phone2.focus();
	                thisThing.setIsInError(false);
	              },
	              placeholder: thisThing._phoneText1Placeholder,
	              maxLength: 3,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 45 } }),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { flex: -1, marginTop: 18, padding: 4, fontSize: 24 } },
	              phoneSeparators[1]
	            ),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._phone2 = a;
	              },
	              key: 'phone2',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("phone2");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._phoneText2 = text;
	                var hasValidPhone = thisThing.hasValidPhone();
	                if (thisThing.state.hasValidPhone != hasValidPhone) thisThing.setState({ hasValidPhone: hasValidPhone });
	                if (text.length >= 3) thisThing._phone3.focus();
	                thisThing.setIsInError(false);
	              },
	              placeholder: thisThing._phoneText2Placeholder,
	              maxLength: 3,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 45 } }),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { flex: -1, marginTop: 18, padding: 4, fontSize: 24 } },
	              phoneSeparators[2]
	            ),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._phone3 = a;
	              },
	              key: 'phone3',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("phone3");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._phoneText3 = text;
	                var hasValidPhone = thisThing.hasValidPhone();
	                if (thisThing.state.hasValidPhone != hasValidPhone) thisThing.setState({ hasValidPhone: hasValidPhone });
	                thisThing.setIsInError(false);
	              },
	              placeholder: thisThing._phoneText3Placeholder,
	              maxLength: 4,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 65 } })
	          ),
	          this.state.errorMessage != null ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: 'red', alignSelf: 'center', margin: 10 } },
	              this.state.errorMessage
	            )
	          ) : null,
	          this.state.hasValidPhone && this.state.errorMessage == null ? React.createElement(
	            View,
	            { style: { padding: 20 } },
	            React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("TEXT_CODE_BUTTON", "Text My Code"), onPress: function onPress() {
	                thisThing.sendCode();
	              } })
	          ) : null
	        ) : React.createElement(
	          View,
	          { style: { alignSelf: 'stretch' } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', justifyContent: 'center' } },
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code1 = a;
	              },
	              key: "code1" + thisThing.state.code1Date,
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code1");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText1 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (text.length >= 1) thisThing._code2.focus();
	                thisThing.setIsInError(false);
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } }),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code2 = a;
	              },
	              key: 'code2',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code2");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText2 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (text.length >= 1) thisThing._code3.focus();
	                thisThing.setIsInError(false);
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } }),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code3 = a;
	              },
	              key: 'code3',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code3");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText3 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (text.length >= 1) thisThing._code4.focus();
	                thisThing.setIsInError(false);
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } }),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code4 = a;
	              },
	              key: 'code4',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code4");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText4 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (text.length >= 1) thisThing._code5.focus();
	                thisThing.setIsInError(false);
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } }),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code5 = a;
	              },
	              key: 'code5',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code5");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText5 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (text.length >= 1) thisThing._code6.focus();
	                thisThing.setIsInError(false);
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } }),
	            React.createElement(ReUpField, {
	              appManager: appManager,
	              ref: function ref(a) {
	                thisThing._code6 = a;
	              },
	              key: 'code6',
	              keyboardType: "phone-pad",
	              onKeyPress: function onKeyPress(event) {
	                if (event.nativeEvent.key == "Backspace") thisThing.backSpacePressed("code6");
	              },
	              onChangeText: function onChangeText(text) {
	                thisThing._codeText6 = text;
	                var hasValidCode = thisThing.hasValidCode();
	                if (thisThing.state.hasValidCode != hasValidCode) thisThing.setState({ hasValidCode: hasValidCode });
	                if (hasValidCode && !_this._hasAutoCheckedCode) thisThing.checkCode();
	                thisThing.setIsInError(false);
	              },
	              maxLength: 1,
	              isInError: this.state.isInError,
	              style: { flex: -1, width: 20, margin: 10 } })
	          ),
	          this.state.errorMessage != null ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: 'red', alignSelf: 'center', margin: 10 } },
	              this.state.errorMessage
	            )
	          ) : null,
	          this.state.hasValidCode && this.state.errorMessage == null ? React.createElement(
	            View,
	            { style: { padding: 20 } },
	            React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("SUBMIT_CODE_BUTTON", "Submit Code"), onPress: function onPress() {
	                thisThing.checkCode();
	              } })
	          ) : null
	        )
	      ),
	      this.state.shouldShowSpinner ? React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner,
	        layout: this.state.layout, appManager: appManager }) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 10,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 60,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    flex: 1,
	    alignItems: 'center',
	    height: 60,
	    paddingLeft: 10,
	    alignSelf: 'center',
	    paddingRight: 10,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    width: 50,
	    justifyContent: 'center',
	    textAlign: 'center',
	    margin: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    margin: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    fontSize: 30,
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    width: -1
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    marginHorizontal: 8
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1
	  },
	
	  segmentContainer: {
	    height: 50,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	// PhoneNumberVerify.getCards = function(featureData, appActions, data)
	// {
	//   var appManager = appActions._appManager;
	//   var locManager = appManager.getLocalizationManager();
	//   var isLoggedIn = appManager.isLoggedIn();
	//   if( !isLoggedIn ) return [];
	//   if( typeof appManager.getFeatureForName("AddCredit") === 'undefined' ) return [];
	//
	//   var user = appManager.currentUser();
	//   var paymentInfo = appManager.getPaymentInfo();
	//   if( !(typeof paymentInfo === 'undefined' || paymentInfo.length <= 0) ) return [];
	//
	//   var iconName = featureData.data.icon.replace("fa-", "")
	//
	//   return [{
	//     didSelect : function() {appActions.requestFeatureName("PhoneNumberVerify")},
	//     title : featureData.data.title,
	//     body1 : locManager.localizedStringForKey("PAYMENT_TYPE_TIP"),
	//     icon : featureData.data.icon.replace("fa-", ""),
	//     cardType : 0,
	//     sortOrder : 5
	//   }]
	// }
	
	
	PhoneNumberVerify.dataDependencies = ["Users"];
	
	module.exports = PhoneNumberVerify;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNativeSvgWrapper = __webpack_require__(46);
	
	var _reactNativeSvgWrapper2 = _interopRequireDefault(_reactNativeSvgWrapper);
	
	var _reactNativeParallaxScrollViewWrapper = __webpack_require__(97);
	
	var _reactNativeParallaxScrollViewWrapper2 = _interopRequireDefault(_reactNativeParallaxScrollViewWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppActions = __webpack_require__(63);
	var LinkingManager = __webpack_require__(27);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var FadingView = __webpack_require__(51);
	var FeedPlusView = __webpack_require__(111);
	var FeedPlusSideView = __webpack_require__(110);
	var Animated = __webpack_require__(9);
	var ReUpTabBar = __webpack_require__(74);
	var GoToAppStoreButton = __webpack_require__(1115);
	var ArcMeter = __webpack_require__(58);
	var PointsTicker = __webpack_require__(149);
	var createReactClass = __webpack_require__(5);
	var Icon = __webpack_require__(13);
	var FEED_HEADER_HEIGHT = 80;
	
	var Menu = __webpack_require__(75);
	var FeedCard = __webpack_require__(41);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpCountdown = __webpack_require__(73);
	
	var _require = __webpack_require__(42),
	    BlurView = _require.BlurView,
	    VibrancyView = _require.VibrancyView;
	
	var MapView = __webpack_require__(78);
	var ReUpButton = __webpack_require__(12);
	var Meter = __webpack_require__(91);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	
	
	var dismissKeyboard = __webpack_require__(105);
	
	var View = ReactNative.View,
	    WebView = ReactNative.WebView,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Dimensions = ReactNative.Dimensions,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	
	  return result;
	}
	
	var ProHome = createReactClass({
	  displayName: 'ProHome',
	
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    var maxWidth = 400;
	    var maxHeight = 700;
	    var width = Math.min(this.props.initialLayout.width - 24, maxWidth);
	    var height = Math.min(this.props.initialLayout.height - 24, maxHeight);
	    // var ratio = parseFloat(750 / 1334);
	    // width = Math.min(width, height*ratio);
	    // height = Math.min(height, width/ratio);
	    var horizontalMargin = (this.props.initialLayout.width - width) / 2;
	    var verticalMargin = (this.props.initialLayout.height - height) / 2;
	
	    var userID = findGetParameter("userid");
	    if (userID == null) userID = -1;
	    var hash = findGetParameter("hash");
	    if (hash == null) hash = "";
	
	    return {
	      horizontalMargin: horizontalMargin,
	      verticalMargin: verticalMargin,
	      rotationFront: new Animated.Value(90),
	      rotationBack: new Animated.Value(90),
	
	      isShowingFront: true,
	
	      isShowingHome: false,
	      isShowingError: false,
	
	      userIsInURL: false,
	
	      isInError: false,
	      errorMessage: "",
	
	      appStoreURL: "",
	      playStoreURL: "",
	
	      backFeatureData: this.props.appManager.getFeatureForName("SimpleSettings")
	    };
	  },
	
	  _context: 0,
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var userID = findGetParameter("userid");
	    if (userID == null) userID = -1;
	    var hash = findGetParameter("hash");
	    if (hash == null) hash = "";
	
	    if (userID != null && hash != null) {
	      NetworkManager.getUser(appManager, userID, hash, function (urlUser) {
	        urlUser[ModelConstants.Password] = hash;
	        appManager.setCurrentUser(urlUser, function () {});
	        NetworkManager.update(appManager, ["Campaigns"], function (data) {
	          thisThing.setState({ isShowingHome: true });
	
	          var signupCampaign = null;
	          for (var i = 0; i < data.Campaigns.length; i++) {
	            var campaign = data.Campaigns[i];
	            if (campaign.Type == "Signup") signupCampaign = JSON.parse(campaign.CampaignBlob);
	          }
	          thisThing.setState({
	            signupPoints: signupCampaign == null ? null : signupCampaign.Points,
	            userIsInURL: true,
	            appStoreURL: urlUser.AppStoreURL,
	            playStoreURL: urlUser.PlayStoreURL
	          });
	
	          thisThing.showFront();
	        }, function (data) {
	          thisThing.setState({ isShowingHome: true,
	            appStoreURL: data.AppStoreURL,
	            playStoreURL: data.PlayStoreURL });
	          thisThing.showFront();
	        }, function () {
	          thisThing.setState({ isShowingHome: true });
	          thisThing.showFront();
	        });
	      }, function (data) {
	        thisThing.setState({
	          isShowingHome: true,
	          appStoreURL: data.AppStoreURL,
	          playStoreURL: data.PlayStoreURL });
	        thisThing.showFront();
	      }, function () {
	        thisThing.setState({ isShowingError: true, errorTitle: "Connection Issue", errorBody: locManager.localizedStringForKey("NO_CONNECTION_STATEMENT") });
	        thisThing.showFront();
	      });
	    } else if (appManager._isDemo) {
	      NetworkManager.getUser(appManager, 'kjregan10@gmail.com', 'asdfwxyzabcd', function (urlUser) {
	        hash = urlUser[ModelConstants.Hash];
	        urlUser[ModelConstants.Password] = hash;
	        appManager.setCurrentUser(urlUser, function () {});
	        NetworkManager.update(appManager, ["Campaigns"], function (data) {
	          thisThing.setState({ isShowingHome: true });
	
	          var signupCampaign = null;
	          for (var i = 0; i < data.Campaigns.length; i++) {
	            var campaign = data.Campaigns[i];
	            if (campaign.Type == "Signup") signupCampaign = JSON.parse(campaign.CampaignBlob);
	          }
	          thisThing.setState({
	            signupPoints: signupCampaign == null ? null : signupCampaign.Points,
	            userIsInURL: true,
	            appStoreURL: urlUser.AppStoreURL,
	            playStoreURL: urlUser.PlayStoreURL
	          });
	
	          thisThing.showFront();
	        }, function (data) {
	          thisThing.setState({ isShowingHome: true,
	            appStoreURL: data.AppStoreURL,
	            playStoreURL: data.PlayStoreURL });
	          thisThing.showFront();
	        }, function () {
	          thisThing.setState({ isShowingHome: true });
	          thisThing.showFront();
	        });
	      }, function (data) {
	        thisThing.setState({
	          isShowingHome: true,
	          appStoreURL: data.AppStoreURL,
	          playStoreURL: data.PlayStoreURL });
	        thisThing.showFront();
	      }, function () {
	        thisThing.setState({ isShowingError: true, errorTitle: "Connection Issue", errorBody: locManager.localizedStringForKey("NO_CONNECTION_STATEMENT") });
	        thisThing.showFront();
	      });
	    } else {
	      thisThing.setState({ isShowingHome: true });
	      this.showFront();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.initialLayout !== 'undefined') {
	      var maxWidth = 400;
	      var maxHeight = 700;
	      var width = Math.min(newProps.initialLayout.width - 24, maxWidth);
	      var height = Math.min(newProps.initialLayout.height - 24, maxHeight);
	      // var ratio = parseFloat(750 / 1234);
	      // width = Math.min(width, height*ratio);
	      // height = Math.min(height, width/ratio);
	      var horizontalMargin = (newProps.initialLayout.width - width) / 2;
	      var verticalMargin = (newProps.initialLayout.height - height) / 2;
	
	      this.setState({ horizontalMargin: horizontalMargin, verticalMargin: verticalMargin });
	    }
	  },
	
	  _showingFront: false,
	  showFront: function showFront() {
	    if (this._showingFront) return;
	    this._showingFront = true;
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationBack, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: true });
	      Animated.timing(thisThing.state.rotationFront, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  showBack: function showBack() {
	    if (!this._showingFront) return;
	    this._showingFront = false;
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.rotationFront, {
	      toValue: 90,
	      duration: 200
	    }).start(function () {
	      thisThing.setState({ isShowingFront: false });
	      Animated.timing(thisThing.state.rotationBack, {
	        toValue: 0,
	        duration: 200
	      }).start(function () {});
	    });
	  },
	
	  checkUserChanged: function checkUserChanged() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  showTerms: function showTerms() {
	    var tosLink = this.props.appManager.getTermsLink();
	    LinkingManager.openURL(tosLink);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);
	
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", .6);
	    var circleIconColor = appManager.getColorForKey("ProfileImageColor");
	
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	
	    var stripHeight = 120;
	
	    var signupInstruction = locManager.localizedStringForKey("SIGN_UP_INSTRUCTION");
	    if (this.state.signupPoints != null) {
	      signupInstruction = locManager.localizedStringForKeyAndParams("SIGN_UP_INSTRUCTION_BONUS", [locManager.localizedPoints(this.state.signupPoints)]);
	    }
	
	    var addedBackStyle = {};
	    if (Platform.OS == 'web') addedBackStyle.height = "calc(100% - 60px)";
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor, height: this.props.initialLayout.height, width: this.props.initialLayout.width }] },
	      React.createElement(BlurView, { ref: 'blurView', blurType: 'light', initialOpacity: 0, style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, imageName: bgImage, imageKey: appManager.getImageKey("bg") }),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'block' : 'none',
	            transform: [{ rotateY: this.state.rotationFront }],
	            flexDirection: 'column', alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: generalColor,
	            overflow: 'hidden'
	          } },
	        this.state.isShowingError ? React.createElement(
	          View,
	          { style: { flex: 1, flexDirection: 'column', alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center', margin: 10 } },
	            this.state.errorTitle
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { color: profileTitleColor, textAlign: 'center', margin: 10 } },
	            this.state.errorBody
	          )
	        ) : null,
	        this.state.isShowingHome ? React.createElement(
	          View,
	          { key: 'feedPlusView', ref: function ref(a) {
	              if (a != null) thisThing._feedPlusView = a;
	            },
	            style: { backgroundColor: profileColor, flexDirection: 'column', flex: 1, alignSelf: 'stretch', height: this.props.initialLayout.height - 2 * this.state.verticalMargin } },
	          React.createElement(View, { style: { height: 30 } }),
	          React.createElement(
	            View,
	            { style: { height: stripHeight, backgroundColor: profileImageColor } },
	            React.createElement(Image, { style: { width: '100%', height: stripHeight }, resizeMode: "cover", source: { uri: stripImage } }),
	            React.createElement(
	              View,
	              { style: { position: 'absolute', top: 20, left: 20, right: 20, bottom: 20 } },
	              React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          this.state.userIsInURL ? React.createElement(
	            View,
	            { style: { padding: 20, flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center', marginBottom: 4 } },
	              locManager.localizedStringForKey("YOU_ARE_VERIFIED_STATEMENT")
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: profileTitleColor, marginTop: 20, marginBottom: 20, textAlign: 'center' } },
	              signupInstruction
	            )
	          ) : React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center', marginBottom: 4 } },
	              signupInstruction
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(GoToAppStoreButton, { appManager: appManager, appStoreURL: this.state.appStoreURL, playStoreURL: this.state.playStoreURL, style: { margin: 10, width: 140, height: 44 } })
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'column', alignSelf: 'stretch', alignItems: 'center', justifyContent: 'flex-end' } },
	            React.createElement(ReUpButton, { isTertiary: true, appManager: appManager, text: locManager.localizedStringForKey("TERMS_AND_PREFERENCES_BUTTON"),
	              onPress: function onPress() {
	                thisThing.showBack();
	              } }),
	            React.createElement(View, { style: { height: 20 } })
	          )
	        ) : null
	      ),
	      React.createElement(
	        Animated.View,
	        { style: {
	            display: this.state.isShowingFront ? 'none' : 'block',
	            flexDirection: 'column',
	            transform: [{ rotateY: this.state.rotationBack }],
	            alignSelf: 'stretch', flex: 1, marginLeft: this.state.horizontalMargin, marginRight: this.state.horizontalMargin, marginTop: this.state.verticalMargin, marginBottom: this.state.verticalMargin, borderRadius: 20, backgroundColor: headerColor,
	            alignItems: 'stretch',
	            overflow: 'hidden'
	          } },
	        React.createElement(
	          View,
	          { style: { height: 60, flexDirection: 'row', alignItems: 'stretch', justifyContent: 'center' } },
	          React.createElement(
	            View,
	            { style: { width: 60, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(ReUpIconButton, { appManager: appManager, iconName: "angle-left", onPress: function onPress() {
	                return _this.showFront();
	              }, type: 2 })
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, justifyContent: 'center', alignItems: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: headerTitleColor, textAlign: 'center' } },
	              this.state.backFeatureData.data.title
	            )
	          ),
	          React.createElement(View, { style: { width: 60 } })
	        ),
	        React.createElement(
	          View,
	          { style: [{ flex: 1 }, addedBackStyle] },
	          appManager.isLoggedIn() ? this.props.featureBuilder.featureForData(this.state.backFeatureData, { width: this.props.initialLayout.width - 2 * this.state.horizontalMargin, height: this.props.initialLayout.height - 60 - 2 * this.state.verticalMargin }, this.props.appManager) : null
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT,
	    backgroundColor: 'red'
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  feedHeader: {
	    height: FEED_HEADER_HEIGHT,
	    flexDirection: 'row'
	  },
	  feedHeaderLeftContainer: {
	    padding: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  profileImage: {
	    height: FEED_HEADER_HEIGHT - 16,
	    width: FEED_HEADER_HEIGHT - 16,
	    borderRadius: (FEED_HEADER_HEIGHT - 16) / 2,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: (FEED_HEADER_HEIGHT - 20) / 2,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  feedHeaderCenterContainer: {
	    height: FEED_HEADER_HEIGHT,
	    paddingVertical: 10,
	    flex: 1,
	    justifyContent: 'space-between'
	  },
	
	  feedHeaderRightContainer: {
	    paddingVertical: 10,
	    width: FEED_HEADER_HEIGHT + 4,
	    height: FEED_HEADER_HEIGHT,
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  feedHeaderInfo: {
	    fontWeight: 'bold'
	  }
	});
	ProHome.dataDependencies = [];
	
	module.exports = ProHome;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Hyperlink = __webpack_require__(113);
	var LinkingManager = __webpack_require__(27);
	var Animated = __webpack_require__(9);
	
	var NetworkManager = __webpack_require__(15);
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var ReUpIconButton = __webpack_require__(18);
	var moment = __webpack_require__(3);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform;
	
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	
	
	var Promotions = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      features: [],
	      Instagrams: [],
	      Twitter: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    this.props.appManager.getDataType("Features", function (data) {
	      thisThing.didUpdate(data);
	    });
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data === 'undefined') {
	      var thisThing = this;
	      this.props.appManager.getDataType("Features", function (data) {
	        thisThing.setState({ features: data == null ? [] : data });
	      });
	      return;
	    }
	
	    if (typeof data.Features !== 'undefined') {
	      this.setState({ features: data.Features == null ? [] : data.Features });
	    }
	
	    if (typeof data.Instagrams !== 'undefined') {
	      this.setState({ Instagrams: data.Instagrams == null ? [] : data.Instagrams });
	    }
	
	    if (typeof data.Twitter !== 'undefined') {
	      this.setState({ Twitter: data.Twitter == null ? [] : data.Twitter });
	    }
	  },
	
	  _scrolledToItem: false,
	  didRenderNewsItem: function didRenderNewsItem(feature, offset) {
	    if (typeof this.props.extras === 'undefined' || typeof this.props.extras.featureID === 'undefined' || this.props.extras.featureID != feature.FeatureID) return;
	
	    if (this._scrolledToItem) return;
	    this._scrolledToItem = true;
	
	    this.refs.ptr.scrollTo(0, offset);
	  },
	
	  didSelectInstagram: function didSelectInstagram(url) {
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.openURL(url, tintColor, barTintColor);
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var rippleColor = appManager.getColorForKey("FeedCardBannerColor", 0.2);
	
	    var features = this.state.features.sort(function (a, b) {
	      return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
	    });
	
	    var instagramPosts = this.state.Instagrams.sort(function (a, b) {
	      return b.created_time - a.created_time;
	    });
	
	    var twitterPosts = this.state.Twitter.sort(function (a, b) {
	      return b.created_time - a.created_time;
	    });
	
	    var facebookFeature = appManager.getFeatureForName("Facebook");
	    var twitterFeature = appManager.getFeatureForName("Twitter");
	    var instagramFeature = appManager.getFeatureForName("Instagram");
	
	    var showSocialMedia = (typeof facebookFeature !== 'undefined' || typeof twitterFeature !== 'undefined' || typeof instagramFeature !== 'undefined') && (typeof this.props.featureData.hideSocialMedia === 'undefined' || !this.props.featureData.hideSocialMedia);
	
	    var compiledFeatures = [];
	    for (var i = 0; i < features.length; i++) {
	      compiledFeatures.push(features[i]);
	    }for (var i = 0; i < instagramPosts.length; i++) {
	      instagramPosts[i].isInstagram = true;
	      compiledFeatures.push(instagramPosts[i]);
	    }
	    for (var i = 0; i < twitterPosts.length; i++) {
	      twitterPosts[i].isTwitter = true;
	      compiledFeatures.push(twitterPosts[i]);
	    }
	
	    compiledFeatures = compiledFeatures.sort(function (a, b) {
	      var aTime = 0;
	      if (a.isInstagram) aTime = a.created_time;else if (a.isTwitter) aTime = new Date(a.created_at).getTime() / 1000;else aTime = appManager.getTime(a.Timestamp) / 1000;
	
	      var bTime = 0;
	      if (b.isInstagram) bTime = b.created_time;else if (b.isTwitter) bTime = new Date(b.created_at).getTime() / 1000;else bTime = appManager.getTime(b.Timestamp) / 1000;
	
	      return bTime - aTime;
	    });
	
	    // get image dimensions
	    var width = this.state.layout.width - 30;
	    var ratio = 400.0 / 640.0; // height / width
	    var height = width * ratio;
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      showSocialMedia ? React.createElement(View, { style: { height: 60, width: this.state.layout.width } }) : null,
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, isEmpty: compiledFeatures.length <= 0, featureName: 'Promotions' },
	        compiledFeatures.map(function (feature, index) {
	          var _this = this;
	
	          if (feature.isInstagram) {
	            var post = feature;
	            var url = post.images.low_resolution.url;
	            var shouldShowCaption = typeof post.caption !== 'undefined' && post.caption != null;
	
	            return React.createElement(
	              MKButton,
	              {
	                onPress: function onPress() {
	                  thisThing.didSelectInstagram(post.link);
	                },
	                underlayColor: generalColor,
	                rippleColor: rippleColor,
	                maskBorderRadius: 0,
	                onLayout: function onLayout(info) {
	                  var layout = info.nativeEvent.layout;
	                  _this.props.cardHeight(layout.height);
	                },
	                key: url },
	              React.createElement(
	                View,
	                { key: url },
	                React.createElement(
	                  View,
	                  { style: { margin: 5, marginLeft: 15, marginRight: 15 } },
	                  React.createElement(Image, { style: [styles.featureImage, { height: height }], source: { uri: url } }),
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5 } },
	                    React.createElement(_ReUpIcon2.default, { name: 'instagram', size: 20 }),
	                    React.createElement(
	                      View,
	                      { style: { flexDirection: 'column', flex: 1, marginLeft: 10 } },
	                      shouldShowCaption ? React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [styles.featureDescription, { color: generalTitleColor }] },
	                        post.caption.text.substr(0, 120).replace(/\n/g, " ") + '...'
	                      ) : null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor, fontSize: 12, marginTop: shouldShowCaption ? 10 : 3 } },
	                        moment.unix(post.created_time).format("MM/DD/YYYY")
	                      )
	                    )
	                  )
	                ),
	                React.createElement(View, { style: [styles.divider, { backgroundColor: 'grey', marginLeft: 5, marginRight: 5 }] })
	              )
	            );
	          } else if (feature.isTwitter) {
	            var post = feature;
	            if (typeof post.entities.media === 'undefined' || post.entities.media.length <= 0) {
	              return React.createElement(
	                View,
	                { key: feature.text },
	                React.createElement(
	                  View,
	                  { style: { margin: 5, marginLeft: 15, marginRight: 15 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5 } },
	                    React.createElement(_ReUpIcon2.default, { name: 'twitter', size: 20 }),
	                    React.createElement(
	                      View,
	                      { style: { flexDirection: 'column', flex: 1, marginLeft: 10 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [{ color: generalTitleColor }] },
	                        feature.text
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor, fontSize: 12, marginTop: 10 } },
	                        moment(new Date(post.created_at)).format("MM/DD/YYYY")
	                      )
	                    )
	                  )
	                ),
	                React.createElement(View, { style: [styles.divider, { backgroundColor: 'grey', marginLeft: 5, marginRight: 5 }] })
	              );
	            }
	
	            var url = post.entities.media[0].media_url_https;
	            return React.createElement(
	              View,
	              { key: url },
	              React.createElement(
	                View,
	                { style: { margin: 5, marginLeft: 15, marginRight: 15 } },
	                React.createElement(Image, { style: [styles.featureImage, { height: height }], source: { uri: url } }),
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5 } },
	                  React.createElement(_ReUpIcon2.default, { name: 'twitter', size: 20 }),
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'column', flex: 1, marginLeft: 10 } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: [styles.featureDescription, { color: generalTitleColor }] },
	                      post.text.substr(0, 120).replace(/\n/g, " ") + '...'
	                    ),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: generalTitleColor, fontSize: 12, marginTop: 10 } },
	                      moment.unix(post.created_time).format("MM/DD/YYYY")
	                    )
	                  )
	                )
	              ),
	              React.createElement(View, { style: [styles.divider, { backgroundColor: 'grey', marginLeft: 5, marginRight: 5 }] })
	            );
	          } else {
	            if (feature.IsDeleted == "1") return null;
	            if (feature.IsDisabled == "1") return null;
	
	            var url = feature.ImageFileName;
	            if (typeof feature.ImageFileName === 'undefined' || feature.ImageFileName == null || feature.ImageFileName == "null") {
	              return React.createElement(
	                View,
	                { key: index + feature.ImageFileName,
	                  onLayout: function onLayout(info) {
	                    thisThing.didRenderNewsItem(feature, info.nativeEvent.layout.y);
	                  } },
	                React.createElement(
	                  View,
	                  { style: { margin: 5, marginLeft: 15, marginRight: 15 } },
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5 } },
	                    React.createElement(_ReUpIcon2.default, { name: thisThing.props.featureData.icon.replace("fa-", ""), size: 20 }),
	                    React.createElement(
	                      View,
	                      { style: { flexDirection: 'column', flex: 1, marginLeft: 10 } },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [styles.featureTitle, { color: generalTitleColor }] },
	                        feature.FeatureName
	                      ),
	                      React.createElement(
	                        Hyperlink,
	                        {
	                          linkStyle: { color: '#2980b9' },
	                          onPress: function onPress(url) {
	                            var barTintColor = thisThing.props.appManager.getColorForKey("HeaderColor");
	                            var tintColor = thisThing.props.appManager.getColorForKey("HeaderIconColor");
	                            LinkingManager.openURL(url, tintColor, barTintColor);
	                          }
	                        },
	                        React.createElement(
	                          ReUpText,
	                          { appManager: appManager, style: [styles.featureDescription, { color: generalTitleColor }] },
	                          feature.Description
	                        )
	                      ),
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor, fontSize: 12, marginTop: 10 } },
	                        moment(appManager.getTime(feature.Timestamp)).format("MM/DD/YYYY")
	                      )
	                    )
	                  )
	                ),
	                React.createElement(View, { style: [styles.divider, { backgroundColor: 'grey', marginLeft: 5, marginRight: 5 }] })
	              );
	            }
	
	            if (url.search("http") != 0) url = "https://" + url;
	            return React.createElement(
	              View,
	              { key: url + index,
	                onLayout: function onLayout(info) {
	                  thisThing.didRenderNewsItem(feature, info.nativeEvent.layout.y);
	                } },
	              React.createElement(
	                View,
	                { style: { margin: 5, marginLeft: 15, marginRight: 15 } },
	                React.createElement(Image, { style: [styles.featureImage, { height: height }], source: { uri: url } }),
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 10, marginBottom: 5 } },
	                  React.createElement(_ReUpIcon2.default, { name: thisThing.props.featureData.icon.replace("fa-", ""), size: 20 }),
	                  React.createElement(
	                    View,
	                    { style: { flexDirection: 'column', flex: 1, marginLeft: 10 } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, isTitle: true, style: [styles.featureTitle, { color: generalTitleColor }] },
	                      feature.FeatureName
	                    ),
	                    React.createElement(
	                      Hyperlink,
	                      {
	                        linkStyle: { color: '#2980b9' },
	                        onPress: function onPress(url) {
	                          var barTintColor = thisThing.props.appManager.getColorForKey("HeaderColor");
	                          var tintColor = thisThing.props.appManager.getColorForKey("HeaderIconColor");
	                          LinkingManager.openURL(url, tintColor, barTintColor);
	                        }
	                      },
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: [styles.featureDescription, { color: generalTitleColor }] },
	                        feature.Description
	                      )
	                    ),
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager, style: { color: generalTitleColor, fontSize: 12, marginTop: 10 } },
	                      moment(appManager.getTime(feature.Timestamp)).format("MM/DD/YYYY")
	                    )
	                  )
	                )
	              ),
	              React.createElement(View, { style: [styles.divider, { backgroundColor: 'grey', marginLeft: 5, marginRight: 5 }] })
	            );
	          }
	        })
	      ),
	      showSocialMedia ? React.createElement(
	        View,
	        { style: { position: 'absolute', alignItems: 'center', justifyContent: 'center', top: this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left: 0, right: 0, height: 60, width: this.state.layout.width, backgroundColor: instructionColor, flexDirection: 'row' } },
	        typeof instagramFeature !== 'undefined' ? React.createElement(ReUpIconButton, { style: { width: 40, height: 40, margin: 6 },
	          appManager: appManager,
	          iconName: instagramFeature.data.icon.replace("fa-", ""),
	          iconSize: 100,
	          type: 7,
	          onPress: function onPress() {
	            appActions.requestFeatureName(instagramFeature.data.name);
	          }
	        }) : null,
	        typeof twitterFeature !== 'undefined' ? React.createElement(ReUpIconButton, { style: { width: 40, height: 40, margin: 6 },
	          appManager: appManager,
	          iconName: twitterFeature.data.icon.replace("fa-", ""),
	          type: 7,
	          onPress: function onPress() {
	            appActions.requestFeatureName(twitterFeature.data.name);
	          }
	        }) : null,
	        typeof facebookFeature !== 'undefined' ? React.createElement(ReUpIconButton, { style: { width: 40, height: 40, margin: 6 },
	          appManager: appManager,
	          iconName: facebookFeature.data.icon.replace("fa-", ""),
	          type: 7,
	          onPress: function onPress() {
	            appActions.requestFeatureName(facebookFeature.data.name);
	          }
	        }) : null
	      ) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  featureImage: {
	    height: 150,
	    borderRadius: 2
	  },
	  divider: {
	    height: 1,
	    marginBottom: 5
	  }
	});
	
	Promotions.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var cards = [];
	  var promotions = typeof data.Features !== 'undefined' && data.Features != null ? data.Features : [];
	
	  var _loop = function _loop() {
	    promotion = promotions[i];
	
	    var promotionID = promotion.FeatureID;
	
	    didSelect = function didSelect() {
	      appActions.requestFeatureName("Promotions", { featureID: promotionID });
	    };
	
	    if (typeof promotion.ImageFileName === 'undefined' || promotion.ImageFileName == null || promotion.ImageFileName == "null") {
	      time = appManager.getTime(promotion.Timestamp);
	      sortOrder = new Date().getTime() - time;
	
	      cards.push({
	        didSelect: didSelect,
	        title: promotion.FeatureName,
	        body1: promotion.Description,
	        body2: "",
	        icon: iconName,
	        cardType: 0,
	        sortOrder: sortOrder
	      });
	      return 'continue';
	    }
	
	    url = promotion.ImageFileName;
	
	    if (url.search("http") != 0) url = "https://" + url;
	    time = appManager.getTime(promotion.Timestamp);
	    sortOrder = new Date().getTime() - time;
	
	    cards.push({
	      didSelect: didSelect,
	      title: promotion.FeatureName,
	      body1: "",
	      body2: "",
	      imageName: url,
	      icon: iconName,
	      cardType: 1,
	      sortOrder: sortOrder
	    });
	  };
	
	  for (var i = 0; i < promotions.length; i++) {
	    var promotion;
	    var didSelect;
	    var time;
	    var sortOrder;
	    var url;
	    var time;
	    var sortOrder;
	
	    var _ret = _loop();
	
	    if (_ret === 'continue') continue;
	  }
	
	  return cards;
	};
	
	Promotions.customDependencyKeys = ["Twitter"];
	Promotions.customDataDependency = function (appManager, completion) {
	  var twitterFeatureData = appManager.getFeatureForName("Twitter");
	  if (typeof twitterFeatureData !== 'undefined') {
	    NetworkManager.getTwitterInfo(appManager, twitterFeatureData.data.twitter_screen_name, function (data) {
	      var filteredData = [];
	      for (var i = 0; i < data.length; i++) {
	        var thisData = data[i];
	        var media = typeof thisData.entities !== 'undefined' && typeof thisData.entities.media !== 'undefined' && thisData.entities.media.length > 0 ? thisData.entities.media : [];
	        var newMedia = [];
	        for (var j = 0; j < media.length; j++) {
	          if (typeof media[j].media_url_https !== 'undefined') {
	            newMedia.push({ media_url_https: media[j].media_url_https });
	          }
	        }
	        filteredData.push({ created_time: thisData.created_time, created_at: thisData.created_at, text: thisData.text, entities: { media: newMedia } });
	      }
	      appManager.setData({ Twitter: filteredData }, function () {
	        completion({ Twitter: filteredData });
	      });
	    }, function (a) {
	      completion({});
	    }, function () {
	      completion({});
	    });
	  } else {
	    completion({});
	  }
	};
	
	Promotions.dataDependencies = ["Features", "Instagrams"];
	
	module.exports = Promotions;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var WebView = __webpack_require__(851);
	var ReUpButton = __webpack_require__(12);
	var ReUpText = __webpack_require__(8);
	
	var MK = __webpack_require__(14);
	var MKSpinner = MK.MKSpinner;
	
	
	var patchPostMessageJsCode = '(' + String(function () {
	  var originalPostMessage = window.postMessage;
	  var patchedPostMessage = function patchedPostMessage(message, targetOrigin, transfer) {
	    originalPostMessage(message, targetOrigin, transfer);
	  };
	  patchedPostMessage.toString = function () {
	    return String(Object.hasOwnProperty).replace('hasOwnProperty', 'postMessage');
	  };
	  window.postMessage = patchedPostMessage;
	}) + ')();';
	
	var ReUpCreditCardInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    var _ref;
	
	    return _ref = {
	      appManager: {},
	      style: {}
	    }, _defineProperty(_ref, 'appManager', null), _defineProperty(_ref, 'onLoad', function onLoad() {}), _defineProperty(_ref, 'onError', function onError() {}), _ref;
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isInError: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {},
	
	  _successCallback: null,
	  retrieveCardInfo: function retrieveCardInfo(successCallback, errorCallback) {
	    this._successCallback = successCallback;
	    this._errorCallback = errorCallback;
	
	    if (this._webView.evaluateJavaScript) this._webView.evaluateJavaScript('retrieveCardInfo();');else if (this._webView.injectJavaScript) this._webView.injectJavaScript('retrieveCardInfo();');
	  },
	
	  onLoad: function onLoad() {
	    var thisThing = this;
	    setTimeout(function () {
	      if (typeof thisThing._webView !== 'undefined' && thisThing._webView != null && typeof thisThing._webView.evaluateJavaScript !== 'undefined' && thisThing._webView.evaluateJavaScript != null) thisThing._webView.evaluateJavaScript('checkIfLoaded();');
	      // else if( thisThing._webView.injectJavaScript ) thisThing._webView.injectJavaScript('checkIfLoaded();')
	      else thisThing.didLoadForSure();
	    }, 1000);
	  },
	
	  didLoadForSure: function didLoadForSure() {
	    this._hasLoaded = true;
	    this.props.onLoad();
	  },
	
	  renderError: function renderError() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var stripeElementsURL = appManager.getStripeElementsURL();
	    var title = locManager.localizedStringForKey("STRIP_FAIL_ALERT_TITLE");
	    var body = locManager.localizedStringForKey("STRIP_FAIL_ALERT_BODY");
	    return React.createElement(
	      View,
	      { style: { flexDirection: 'column', padding: 10, justifyContent: 'center', alignItems: 'center' } },
	      React.createElement(
	        ReUpText,
	        { appManager: appManager, isTitle: true, style: { textAlign: 'center', marginBottom: 8 } },
	        title
	      ),
	      React.createElement(
	        ReUpText,
	        { appManager: appManager, style: { textAlign: 'center' } },
	        body
	      )
	    );
	  },
	
	  _hasLoaded: false,
	  hasLoaded: function hasLoaded() {
	    return this._hasLoaded;
	  },
	
	  render: function render() {
	    var _this = this,
	        _React$createElement;
	
	    if (this.state.isInError) return this.renderError();
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var stripeElementsURL = appManager.getStripeElementsURL();
	    console.log("stripeElementsURL", stripeElementsURL);
	
	    return React.createElement(
	      View,
	      { style: [this.props.style, { flexDirection: 'column' }] },
	      React.createElement(WebView, (_React$createElement = { ref: function ref(_ref2) {
	          return _this._webView = _ref2;
	        },
	        javaScriptEnabled: true,
	        javaScriptEnabledAndroid: true,
	        domStorageEnabled: true,
	        injectedJavaScript: patchPostMessageJsCode,
	        style: { flex: 1, alignSelf: 'stretch' },
	        source: { uri: stripeElementsURL, baseURL: '/' },
	        onLoad: function onLoad() {
	          thisThing.onLoad();
	        },
	        onMessage: function onMessage(data) {
	          if (typeof data.body.data === 'undefined' || data.body.data == "error") {
	            thisThing._errorCallback();
	            return;
	          }
	          if (typeof data.body.data !== 'undefined' && data.body.data == "Is Loaded") {
	            thisThing.didLoadForSure();
	            return;
	          }
	          var cardInfo = {};
	          cardInfo.last4 = data.body.data.token.card.last4;
	          cardInfo.exp_month = data.body.data.token.card.exp_month;
	          cardInfo.exp_year = data.body.data.token.card.exp_year;
	          cardInfo.country = data.body.data.token.card.country;
	          cardInfo.address_zip = data.body.data.token.card.address_zip;
	          cardInfo.cardID = data.body.data.token.card.id;
	          cardInfo.cardType = data.body.data.token.card.type;
	          cardInfo.token = data.body.data.token.id;
	          thisThing._successCallback(cardInfo);
	        }
	      }, _defineProperty(_React$createElement, 'domStorageEnabled', true), _defineProperty(_React$createElement, 'decelerationRate', 'normal'), _defineProperty(_React$createElement, 'startInLoadingState', true), _defineProperty(_React$createElement, 'renderLoading', function renderLoading() {
	        return React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { marginTop: 40, alignSelf: 'center' } });
	      }), _defineProperty(_React$createElement, 'renderError', this.renderError), _defineProperty(_React$createElement, 'onError', this.props.onError), _React$createElement))
	    );
	  }
	});
	
	module.exports = ReUpCreditCardInput;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    ScrollView = ReactNative.ScrollView,
	    Image = ReactNative.Image,
	    Text = ReactNative.Text,
	    PixelRatio = ReactNative.PixelRatio,
	    Platform = ReactNative.Platform;
	
	
	var Navigator = __webpack_require__(850);
	
	var Globals = __webpack_require__(10);
	
	var FeatureBuilder = __webpack_require__(90);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var FadingView = __webpack_require__(51);
	var Animated = __webpack_require__(9);
	var OffsetView = __webpack_require__(93);
	
	var ReUpFloatingNavigator = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      didMount: null,
	      willUnmount: null,
	      onDismiss: null,
	      onShow: null,
	      style: {},
	      appManager: null,
	      shouldUseTab: false,
	      disableNavHeader: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      height: 200, //-1,
	      width: 200, //-1,
	      enabled: false,
	      viewOffset: null,
	      shadowOpacity: new Animated.Value(0),
	      shouldShowBack: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.didMount != null) this.props.didMount(this);
	
	    this.refs.scrollView.scrollTo({ y: 1 });
	    this.refs.scrollView.scrollTo({ y: 0 });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.props.willUnmount != null) this.props.willUnmount(this);
	  },
	
	  _didDismiss: false,
	  dismiss: function dismiss() {
	    if (this._didDismiss) return;
	    this._didDismiss = true;
	    this._didShow = false;
	
	    var thisThing = this;
	    if (this.refs.scrollView) {
	      if (Platform.OS == 'web') {
	        var thisThing = this;
	        var scrollOffsetY = new Animated.Value(this._scrollOffsetY);
	        scrollOffsetY.addListener(function (_ref) {
	          var value = _ref.value;
	
	          thisThing.refs.scrollView.scrollTo({ y: value });
	        });
	        Animated.timing(scrollOffsetY, {
	          toValue: 0,
	          duration: 200
	        }).start(function () {
	          thisThing._nav.popToTop();
	          thisThing._didShow = false;
	          thisThing._nav.replace({});
	        });
	      } else {
	        this.refs.scrollView.scrollTo({ y: 0 });
	
	        thisThing._didShow = false;
	
	        setTimeout(function () {
	          if (thisThing._didDismiss) {
	            thisThing._nav.replace({});
	          }
	        }, 400);
	      }
	    }
	    this.setState({ enabled: false });
	
	    if (this.props.onDismiss != null) this.props.onDismiss();
	
	    setTimeout(function () {
	      if (thisThing._didDismiss) {
	        thisThing._nav.popToTop();
	        thisThing._nav.replace({});
	      }
	    }, 400);
	  },
	
	  _didShow: false,
	  show: function show() {
	    if (this._didShow) return false;
	    this._didShow = true;
	    this._didDismiss = false;
	
	    this.setState({ shouldShowBack: false });
	    var thisThing = this;
	    if (this.refs.scrollView) {
	      if (Platform.OS == 'web') {
	        var thisThing = this;
	        var scrollOffsetY = new Animated.Value(this._scrollOffsetY);
	        scrollOffsetY.addListener(function (_ref2) {
	          var value = _ref2.value;
	
	          thisThing.refs.scrollView.scrollTo({ y: value });
	        });
	        Animated.timing(scrollOffsetY, {
	          toValue: this.state.height,
	          duration: 200
	        }).start();
	      } else {
	        this.refs.scrollView.scrollTo({ y: this.state.height });
	      }
	    }
	    if (thisThing.props.onShow != null) thisThing.props.onShow(this);
	
	    return true;
	  },
	
	  pushFeature: function pushFeature(feature, extras, shouldAnimate) {
	    if (typeof extras === 'undefined') extras = {};
	    if (typeof feature.extras !== 'undefined') {
	      for (var key in feature.extras) {
	        extras[key] = feature.extras[key];
	      }
	    }
	    extras.shouldHideActionBar = true;
	    feature.extras = extras;
	    if (!this._didShow) this._nav.resetTo(feature);else this._nav.push(feature);
	    if (!this.show()) this.setState({ shouldShowBack: true });
	  },
	
	  popFeature: function popFeature() {
	    var routeStack = this._nav.state.routeStack;
	    if (routeStack.length <= 2) this.setState({ shouldShowBack: false });
	    if (routeStack.length <= 1) this.dismiss();else this._nav.pop();
	  },
	
	  replace: function replace(feature, extras) {
	    if (typeof extras === 'undefined') extras = {};
	    if (typeof feature.extras !== 'undefined') {
	      for (var key in feature.extras) {
	        extras[key] = feature.extras[key];
	      }
	    }
	    extras.shouldHideActionBar = true;
	    feature.extras = extras;
	
	    this.show();
	    this._nav.replace(feature);
	  },
	
	  isShown: function isShown() {
	    return this._didShow;
	  },
	
	  viewDidLayout: function viewDidLayout(info) {
	    var currentLayout = info.nativeEvent.layout;
	    this.setState({ height: currentLayout.height, width: currentLayout.width });
	    if (!this._didShow) this.setState({ viewOffset: new Animated.Value(currentLayout.height) });
	  },
	
	  _lastYOffset: -100000000,
	  render: function render() {
	    var _this = this,
	        _React$createElement;
	
	    var _props = this.props,
	        style = _props.style,
	        didMount = _props.didMount,
	        willUnmount = _props.willUnmount,
	        otherProps = _objectWithoutProperties(_props, ['style', 'didMount', 'willUnmount']);
	
	    var thisThing = this;
	
	    var featureView = null;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var appActions = this.props.appActions;
	
	    // var featureView = FeatureBuilder.featureForData(thisThing.props.appManager.getFeatureForName("UseCredit"), {width:thisThing.state.width, height:thisThing.state.height}, thisThing.props.appManager, {shouldHideActionBar:true});;
	
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	
	    var shouldShowClose = true;
	
	    var headerPath = appManager.absoluteResourceForPath('Feed' + '/' + 'header.png');
	
	    var bottomBufferHeight = 400;
	
	    // TODO: figure this out... for some reason adding the offsetview makes it so that tabs can't be pressed
	    var VerticalScrollClass = Platform.OS == 'web' ? OffsetView : ScrollView;
	
	    var navStyles = Navigator.NavigationBar.Styles;
	    if (Platform.OS == 'ios') {
	      navStyles.General.TotalNavHeight = Globals.NAV_BAR_HEIGHT + 20;
	      navStyles.Stages.Left.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Left.RightButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Center.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Center.RightButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Right.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Right.RightButton.height = Globals.NAV_BAR_HEIGHT;
	    }
	
	    return React.createElement(
	      View,
	      Object.assign({ pointerEvents: "none", style: [style, { opacity: this.state.height > 0 ? 1 : 0 }], onLayout: this.viewDidLayout }, otherProps),
	      React.createElement(FadingView, { ref: "fadingView", pointerEvents: "none", style: { position: 'absolute', pointerEvents: 'none', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,.4)' } }),
	      true ? React.createElement(
	        Animated.View,
	        { pointerEvents: "none", style: { pointerEvents: 'none', position: 'absolute', top: 0, left: 0, right: 0, height: this.state.height - (this.props.disableNavHeader ? Globals.ACTION_BAR_HEIGHT : 0) } },
	        React.createElement(
	          VerticalScrollClass,
	          (_React$createElement = { ref: "scrollView",
	            pointerEvents: Platform.OS == 'web' ? this.state.enabled ? "none" : "none" : "box-none",
	            scrollEnabled: Platform.OS === 'ios',
	            bounces: false, showsVerticalScrollIndicator: false, decelerationRate: "fast", scrollEventThrottle: 40,
	            keyboardShouldPersistTaps: 'always',
	            snapToInterval: this.state.height,
	            style: { flex: 1, alignSelf: 'stretch', flexDirection: 'column' } }, _defineProperty(_React$createElement, 'scrollEventThrottle', 20), _defineProperty(_React$createElement, 'onScroll', function onScroll(info) {
	            if (typeof info.nativeEvent.contentOffset === 'undefined') return;
	
	            var newYOffset = info.nativeEvent.contentOffset.y;
	            thisThing._scrollOffsetY = newYOffset;
	            if (thisThing._lastYOffset < newYOffset && newYOffset > thisThing.state.height / 2) {
	              if (!thisThing.state.enabled) thisThing.setState({ enabled: true });
	            }
	
	            if (Platform.OS === 'ios') {
	              if (thisThing._lastYOffset > newYOffset && newYOffset < thisThing.state.height / 4) {
	                if (thisThing.state.enabled) thisThing.setState({ enabled: false });
	              }
	            } else {
	              if (thisThing._lastYOffset > newYOffset && newYOffset < 4 * thisThing.state.height / 5) {
	                if (thisThing.state.enabled) thisThing.setState({ enabled: false });
	                setTimeout(function () {
	                  thisThing.dismiss();
	                }, 20);
	              }
	            }
	
	            if (thisThing._lastYOffset > newYOffset && newYOffset < 20) {
	              thisThing.dismiss();
	            }
	
	            thisThing.refs.fadingView.setOpacity(newYOffset / thisThing.state.height);
	
	            thisThing._lastYOffset = newYOffset;
	          }), _React$createElement),
	          React.createElement(View, { pointerEvents: 'none', style: { height: this.state.height, width: 100 } }),
	          React.createElement(
	            View,
	            { pointerEvents: 'auto', style: { overflow: 'hidden', pointerEvents: 'auto', flexDirection: 'column', marginTop: this.props.ignoreStatusBar ? 0 : Globals.STATUS_BAR_HEIGHT, height: this.state.height - (this.props.ignoreStatusBar ? 0 : Globals.STATUS_BAR_HEIGHT) - (this.props.disableNavHeader ? Globals.ACTION_BAR_HEIGHT : 0), alignSelf: 'stretch', borderTopLeftRadius: 10, borderTopRightRadius: 10, backgroundColor: generalColor } },
	            !this.props.disableNavHeader ? React.createElement(View, { style: { position: 'absolute', left: 0, top: 0, right: 0, height: Globals.ACTION_BAR_HEIGHT - Globals.STATUS_BAR_HEIGHT, alignSelf: 'stretch', backgroundColor: headerColor } }) : null,
	            React.createElement(Navigator, {
	              ref: function ref(a) {
	                if (a != null) thisThing._nav = a;
	              },
	              renderScene: function renderScene(route, navigator) {
	                if (typeof route === 'undefined') return null;
	                if (typeof route.data === 'undefined') return null;
	
	                return FeatureBuilder.featureForData(route, { width: thisThing.state.width, height: thisThing.state.height }, appManager, route.extras);
	              },
	              style: { width: thisThing.state.width, height: thisThing.state.height - Globals.STATUS_BAR_HEIGHT, paddingTop: (this.props.disableNavHeader ? 0 : Globals.ACTION_BAR_HEIGHT) - (this.props.ignoreStatusBar ? Globals.STATUS_BAR_HEIGHT : 0), marginTop: this.props.ignoreStatusBar ? 0 : -Globals.STATUS_BAR_HEIGHT },
	              navigationBar: this.props.disableNavHeader ? null : React.createElement(Navigator.NavigationBar, {
	                navigationStyles: navStyles,
	                routeMapper: {
	                  LeftButton: function LeftButton(route, navigator, index, navState) {
	                    if (typeof route === 'undefined') return null;
	                    if (typeof route.data === 'undefined') return null;
	                    if (!thisThing.state.shouldShowBack) {
	                      return React.createElement(
	                        View,
	                        { style: [{ margin: 0 }, Globals.TOP_LEFT_STYLE_ADJUSTMENT] },
	                        React.createElement(ReUpIconButton, { key: "angle-down",
	                          iconName: "angle-down",
	                          appManager: appManager,
	                          type: 2,
	                          accessibilityLabel: locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON"),
	                          onPress: function onPress() {
	                            appActions.requestPop();
	                          },
	                          style: [{ margin: 0 }] })
	                      );
	                    }
	
	                    return React.createElement(
	                      View,
	                      { style: [{ margin: 0 }, Globals.TOP_LEFT_STYLE_ADJUSTMENT] },
	                      React.createElement(ReUpIconButton, { key: "angle-left",
	                        iconName: "angle-left",
	                        appManager: appManager,
	                        type: 2,
	                        accessibilityLabel: locManager.localizedStringForKey("BACK_ACCESSIBILITY_BUTTON"),
	                        style: [{ margin: 0 }],
	                        onPress: function onPress() {
	                          appActions.requestPop();
	                        } })
	                    );
	                  },
	                  RightButton: function RightButton(route, navigator, index, navState) {
	                    if (typeof route === 'undefined') return null;
	                    if (typeof route.data === 'undefined') return null;
	                    var topRightFeatures = appManager.getTopRightFeatures();
	                    if (topRightFeatures.length <= 0) return React.createElement(View, null);
	
	                    var feature = topRightFeatures[0];
	                    if (feature.data.name == route.data.name || typeof feature === 'undefined') return React.createElement(View, null);
	                    if (feature.data.requiresLogin && !appManager.isLoggedIn()) return React.createElement(View, null);
	                    for (var i = 0, len = navState.routeStack.length; i < len && i < navState.routeStack.length; i++) {
	                      var thisFeature = navState.routeStack[i];
	                      if (typeof thisFeature.data === 'undefined' || thisFeature.data.name == feature.data.name) {
	                        return React.createElement(View, null);
	                      }
	                    }
	
	                    var thisThing = _this;
	                    var iconName = feature.data.icon.replace("fa-", "");
	                    return React.createElement(
	                      View,
	                      { style: [{ margin: 0 }, Globals.TOP_LEFT_STYLE_ADJUSTMENT] },
	                      React.createElement(ReUpIconButton, { key: iconName,
	                        iconName: iconName,
	                        appManager: appManager,
	                        type: 2,
	                        accessibilityLabel: locManager.localizedStringForKey("BACK_ACCESSIBILITY_BUTTON"),
	                        onPress: function onPress() {
	                          if (thisThing._topRightDisabled) return;
	                          thisThing._topRightDisabled = true;
	                          setTimeout(function () {
	                            thisThing._topRightDisabled = false;
	                          }, 2000);
	                          appActions.requestFeatureName(feature.data.name);
	                        } })
	                    );
	                  },
	                  Title: function Title(route, navigator, index, navState) {
	                    if (typeof route === 'undefined') return null;
	                    if (typeof route.data === 'undefined') return null;
	                    if (route.data.headerImage && route.data.headerImage.trim().length > 0) {
	                      var headerPath = appManager.absoluteResourceForPath(route.key + '/' + route.data.headerImage);
	                      return React.createElement(
	                        View,
	                        {
	                          style: [styles.navBarTitleContainer, { marginRight: Platform.OS == "android" ? 70 : 0 }, Globals.TOP_CENTER_ADJUSTMENT] },
	                        React.createElement(Image, { style: [styles.navBarTitleImage], resizeMode: "stretch", source: { uri: headerPath } })
	                      );
	                    } else {
	                      return React.createElement(
	                        View,
	                        {
	                          style: [styles.navBarTitleContainer, { marginRight: Platform.OS == "android" ? 70 : 0 }, Globals.TOP_CENTER_TEXT_ADJUSTMENT] },
	                        React.createElement(
	                          View,
	                          { style: { alignSelf: 'center' } },
	                          React.createElement(
	                            ReUpText,
	                            { appManager: appManager, isSuperTitle: true, shrinksAtLength: 20, style: [styles.navBarTitleText, { color: appManager.getColorForKey("HeaderTitleColor") }] },
	                            route.data.title
	                          )
	                        )
	                      );
	                    }
	                  }
	                },
	                style: { backgroundColor: 'transparent', height: Globals.NAV_BAR_HEIGHT, padding: 0, flex: -1 }
	              })
	            })
	          )
	        )
	      ) : null
	    );
	  }
	});
	
	module.exports = ReUpFloatingNavigator;
	
	// <View style={{overflow:'hidden', marginTop:Globals.STATUS_BAR_HEIGHT, height:this.state.height - Globals.STATUS_BAR_HEIGHT, alignSelf:'stretch', borderTopLeftRadius:10, borderTopRightRadius:10, backgroundColor:generalColor}}>
	//   <View style={{alignSelf:'stretch', flexDirection:'row', height:Globals.ACTION_BAR_HEIGHT - Globals.STATUS_BAR_HEIGHT, backgroundColor:headerColor}}>
	//     <View style={{width:50, marginLeft:10}}>
	//       <ReUpIconButton key={shouldShowClose ? "angle-down" : "angle-left"}
	//         iconName={shouldShowClose ? "angle-down" : "angle-left"}
	//         appManager={appManager}
	//         buttonColorOverride={headerColor}
	//         type={2}
	//         accessibilityLabel={"Menu"}
	//         onPress={()=>
	//         {
	//           if( shouldShowClose ) thisThing.dismiss();
	//         }}/>
	//     </View>
	//     <View style={{flex:1, alignItems:'center'}}>
	//       <Image style={{
	//         height:44,
	//         width:150,
	//         padding:0,
	//         flex:-1,
	//       }} resizeMode={"stretch"} source={{uri: headerPath}}/>
	//     </View>
	//    <View style={{marginRight:10}}>
	//      <ReUpIconButton key={"usd"}
	//        iconName={"usd"}
	//        appManager={appManager}
	//        buttonColorOverride={headerColor}
	//        type={2}
	//        accessibilityLabel={"Menu"}
	//        onPress={()=>
	//        {
	//          if( shouldShowClose ) thisThing.dismiss();
	//        }}/>
	//     </View>
	//   </View>
	//   {
	//     featureView
	//   }
	var styles = StyleSheet.create({
	  floatView: {
	    position: 'absolute',
	    backgroundColor: 'transparent',
	    flex: 1,
	    width: 0,
	    height: 0,
	    top: Globals.ACTION_BAR_HEIGHT,
	    left: 0
	  },
	  container: {
	    flex: 1,
	    alignItems: 'stretch'
	  },
	  messageText: {
	    fontWeight: '500',
	    padding: 15,
	    marginTop: 50,
	    marginLeft: 15
	  },
	  button: {
	    backgroundColor: 'white',
	    padding: 15,
	    borderBottomWidth: 1 / PixelRatio.get(),
	    borderBottomColor: '#CDCDCD'
	  },
	  buttonText: {},
	  navBar: {
	    backgroundColor: 'grey',
	    padding: 0,
	    flex: -1
	  },
	  navBarTitleImage: {
	    height: 44,
	    width: 150,
	    padding: 0,
	    flex: -1
	  },
	  navBarTitleContainer: {
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  navBarText: {
	    marginVertical: 10
	  },
	  navBarTitleText: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center'
	  },
	  navBarLeftButton: {
	    flexDirection: 'row',
	    width: 44,
	    height: 44,
	    marginTop: 6,
	    borderRadius: 22,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    backgroundColor: 'transparent'
	  },
	  navBarRightButton: {
	    paddingRight: 10,
	    flexDirection: 'row',
	    width: 44,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flex: -1
	  },
	  navBarButtonText: {
	    color: 'green',
	    paddingLeft: 2,
	    paddingTop: 2
	  },
	  scene: {
	    flex: 1,
	    paddingTop: 20,
	    backgroundColor: '#EAEAEA'
	  },
	  menuContainerShown: {
	    opacity: 1
	  },
	  updateMeter: {
	    position: 'absolute',
	    flexDirection: 'row',
	    top: 0,
	    left: 0,
	    right: 0,
	    height: 2,
	    backgroundColor: 'transparent'
	  },
	  networkStatus: {
	    position: 'absolute',
	    flexDirection: 'row',
	    left: 0,
	    right: 0,
	    height: 30
	  }
	});

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Image = ReactNative.Image,
	    View = ReactNative.View;
	
	
	var ReUpImage = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      backgroundImage: null,
	      style: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      lastImage: null,
	      currentImage: null
	    };
	  },
	
	  setImage: function setImage(image) {
	    if (image == null) {
	      this.setState({ lastImage: null, currentImage: null });
	    } else {
	      this.setState({ lastImage: this.state.currentImage, currentImage: image });
	    }
	  },
	
	  render: function render() {
	    var _props = this.props,
	        style = _props.style,
	        other = _objectWithoutProperties(_props, ['style']);
	
	    return React.createElement(
	      View,
	      { style: [style] },
	      this.props.backgroundImage != null ? React.createElement(Image, { key: this.props.backgroundImage + "bg", source: { uri: this.props.backgroundImage }, resizeMode: "stretch", style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } }) : null,
	      this.state.lastImage != null ? React.createElement(Image, { key: this.state.lastImage, source: { uri: this.state.lastImage }, resizeMode: "stretch", style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } }) : null,
	      this.state.currentImage != null ? React.createElement(Image, { key: this.state.currentImage, source: { uri: this.state.currentImage }, resizeMode: "stretch", style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } }) : null
	    );
	  }
	});
	
	module.exports = ReUpImage;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// import React, { Component } from 'react';
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var ReUpField = __webpack_require__(26);
	var ReUpPicker = __webpack_require__(1133);
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet,
	    View = ReactNative.View,
	    TextInput = ReactNative.TextInput;
	
	// import Button from '@lightspeed/cirrus-button';
	
	var DEFAULT_PHONE_LOCALES = [{ "Region": "CA", "Code": "1" }];
	
	var ReUpPhoneNumberInput = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      isInError: false,
	      phoneLocales: DEFAULT_PHONE_LOCALES,
	      phoneNumberChanged: function phoneNumberChanged() {},
	      countryChanged: function countryChanged() {},
	      okSelected: function okSelected() {},
	      needsNewPredictedPhoneNumber: function needsNewPredictedPhoneNumber(phoneNumber) {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var state = {};
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    state.isInError = false;
	    state.currentPhoneNumber = "";
	    state.currentCountryIndex = 0;
	    state.partialPlaceHolderPhoneNumber = locManager.localizedStringForKey("PHONE_OPTION");
	    state.phoneLocales = this.props.phoneLocales == null || typeof this.props.phoneLocales === 'undefined' || this.props.phoneLocales.length <= 0 ? [{ "Region": "CA", "Code": "1" }] : this.props.phoneLocales;
	
	    return state;
	  },
	
	  _hasSetPlaceholder: false,
	  setPlaceHolderPhoneNumber: function setPlaceHolderPhoneNumber(fullPhoneNumber) {
	    if (fullPhoneNumber === null) return;
	
	    var currentCountryCode = this.getCountryCode();
	    if (fullPhoneNumber.indexOf(currentCountryCode) === 0) {
	      this._hasSetPlaceholder = true;
	
	      var partialPlaceHolderPhoneNumber = fullPhoneNumber.substring(currentCountryCode.length, fullPhoneNumber.length);
	      this.setState({ partialPlaceHolderPhoneNumber: partialPlaceHolderPhoneNumber });
	    } else if (!this._hasSetPlaceholder) {
	      for (var i = 0; i < this.state.phoneLocales.length; i++) {
	        var phoneLocale = this.state.phoneLocales[i];
	        var fullPhoneNumberHasThisCountryCode = fullPhoneNumber.indexOf(phoneLocale.Code) === 0;
	        if (fullPhoneNumberHasThisCountryCode) {
	          this._hasSetPlaceholder = true;
	
	          var partialPlaceHolderPhoneNumber = fullPhoneNumber.substring(phoneLocale.Code.length);
	          this.countrySelected(i);
	          this.setState({ partialPlaceHolderPhoneNumber: partialPlaceHolderPhoneNumber });
	          break;
	        }
	      }
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var phoneLocales = newProps.phoneLocales == null || typeof newProps.phoneLocales === 'undefined' || newProps.phoneLocales.length <= 0 ? [{ "Region": "CA", "Code": "1" }] : newProps.phoneLocales;
	    this.setState({ phoneLocales: phoneLocales });
	  },
	
	  focus: function focus() {
	    // this._field.focus();
	  },
	
	  getCountryCode: function getCountryCode() {
	    return this.state.phoneLocales[this._picker.state.valueIndex].Code;
	  },
	
	  setPhoneNumber: function setPhoneNumber(currentPhoneNumber) {
	    var currentPhoneNumber = currentPhoneNumber.substring(0, 20);
	    // this._field.setText(currentPhoneNumber);
	    this.setState({ currentPhoneNumber: currentPhoneNumber });
	    this.props.phoneNumberChanged(this.getCountryCode(), this.getCountryCode() + currentPhoneNumber);
	  },
	
	  setFullPhoneNumber: function setFullPhoneNumber(fullPhoneNumber) {
	    var currentCountryCode = this.getCountryCode();
	    var needsNewCountryCode = fullPhoneNumber.indexOf(currentCountryCode) !== 0;
	    if (needsNewCountryCode) {
	      for (var i = 0; i < this.state.phoneLocales.length; i++) {
	        var phoneLocale = this.state.phoneLocales[i];
	        var fullPhoneNumberHasThisCountryCode = fullPhoneNumber.indexOf(phoneLocale.Code) === 0;
	        if (fullPhoneNumberHasThisCountryCode) {
	          var phoneNumber = fullPhoneNumber.substring(phoneLocale.Code.length, fullPhoneNumber.length - phoneLocale.Code.length + 1);
	          this.countrySelected(i);
	          this.setPhoneNumber(phoneNumber);
	        }
	      }
	    } else {
	      var phoneNumber = fullPhoneNumber.substring(currentCountryCode.length, fullPhoneNumber.length - currentCountryCode.length + 1);
	      this.setPhoneNumber(phoneNumber);
	    }
	  },
	
	  setPredictedPhoneNumber: function setPredictedPhoneNumber(predictedPhoneNumber) {
	    this.setState({ predictedPhoneNumber: predictedPhoneNumber });
	  },
	
	  getPhoneNumber: function getPhoneNumber() {
	    return this.getCountryCode() + this.state.currentPhoneNumber;
	  },
	
	  deleteSelected: function deleteSelected() {
	    this.setPhoneNumber(this.state.currentPhoneNumber.substring(0, Math.max(0, this.state.currentPhoneNumber.length - 1)));
	  },
	
	  numSelected: function numSelected(num) {
	    var newPhoneRaw = this.state.currentPhoneNumber + "" + num;
	    this.setPhoneNumber(newPhoneRaw);
	  },
	
	  clearSelected: function clearSelected() {
	    this.countrySelected(0);
	    // this.
	  },
	
	  countrySelected: function countrySelected(index) {
	    this.setState({ currentCountryIndex: index });
	    this._picker.setValue(index);
	    this.props.countryChanged(this.state.phoneLocales[index]);
	    this.props.phoneNumberChanged(this.state.phoneLocales[index], this.state.phoneLocales[index].Code + this.state.currentPhoneNumber);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var self = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var values = [];
	    var errorStyle = this.props.isInError ? { borderColor: appManager.getErrorColor() } : { borderColor: '#abb3b3' };
	    for (var i = 0; i < this.state.phoneLocales.length; i++) {
	      values.push("+" + this.state.phoneLocales[i].Code);
	    }return React.createElement(
	      View,
	      { style: this.props.style },
	      React.createElement(
	        View,
	        { style: { flex: -1, flexDirection: 'row', justifyContent: 'space-around', fontSize: 20 } },
	        React.createElement(
	          View,
	          { style: { flex: 1, paddingTop: 4, paddingRight: 4, paddingBottom: 4 } },
	          React.createElement(ReUpPicker, { ref: function ref(a) {
	              return _this._picker = a;
	            }, style: [{ borderRadius: 3, backgroundColor: "white", borderColor: '#abb3b3', borderWidth: 1, borderStyle: 'solid' }, errorStyle], appManager: appManager, values: values, onValueChange: function onValueChange(value) {
	              self.countrySelected(value);
	            } })
	        ),
	        React.createElement(
	          View,
	          { style: { flex: 4, paddingTop: 4, paddingLeft: 4, paddingBottom: 4 } },
	          React.createElement(TextInput, { ref: function ref(a) {
	              return _this._field = a;
	            }, style: [{ borderRadius: 3, margin: 0, backgroundColor: 'white', padding: 15, fontSize: 20, borderWidth: 1, borderStyle: 'solid' }, errorStyle], keyboardType: 'phone-pad', autoCompleteType: 'tel', textContentType: 'telephoneNumber', appManager: appManager, invertBG: true, hideLine: true, value: this.state.currentPhoneNumber, placeholder: this.state.partialPlaceHolderPhoneNumber, onChangeText: function onChangeText(phoneNumber) {
	              self.setPhoneNumber(phoneNumber.replace());
	            } })
	        )
	      )
	    );
	  }
	});
	
	module.exports = ReUpPhoneNumberInput;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Text = ReactNative.Text,
	    View = ReactNative.View,
	    Picker = ReactNative.Picker;
	
	
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	
	var ReUpPicker = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      isInError: false,
	      onValueChange: function onValueChange() {},
	      disableBackground: false,
	      textInputStyle: {},
	      values: ["asdf"]
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isInError: this.props.isInError,
	      value: 0,
	      valueIndex: 0
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.isInError !== 'undefined' && newProps.isInError != this.state.isInError) {
	      this.setState({ isInError: newProps.isInError });
	    }
	  },
	
	  focus: function focus() {
	    this._picker.togglePicker();
	  },
	
	  isInError: function isInError() {
	    return this.state.isInError;
	  },
	
	  setIsInError: function setIsInError(isInError) {
	    this.setState({ isInError: isInError });
	  },
	
	  onSelect: function onSelect(valueIndex) {
	    this.setValueIndex(valueIndex, true);
	  },
	
	  setValueIndex: function setValueIndex(valueIndex) {
	    var notify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (valueIndex < 0) valueIndex = 0;else if (valueIndex >= this.props.values.length) valueIndex = this.props.values.length - 1;else if (valueIndex === null) valueIndex = 0;
	
	    this.setState({ valueIndex: valueIndex });
	    //this._field.setText(this.props.values[valueIndex] + (this.props.values.length > 1 ? " ▼" : ""));
	    //if( notify ) this.props.onValueChange(valueIndex);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var index = 0;
	    var appManager = this.props.appManager;
	    var bgColor = appManager.getColorForKey("GeneralTitleColor", .03);
	    if (this.props.invertBG) bgColor = appManager.getColorForKey("GeneralColor", 1);
	
	    var useGeneric = false;
	    var generalColor = useGeneric ? 'white' : appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = useGeneric ? 'black' : appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = useGeneric ? 'black' : appManager.getColorForKey("FeedCardBannerColor");
	    if (bannerColor == generalColor) bannerColor = generalTitleColor;
	    // var values = [];
	    // for( var i = 0; i < this.props.values.length; i++ ) values.push({label:this.props.values[i], value:i});
	
	    return React.createElement(
	      View,
	      { style: this.props.style },
	      React.createElement(
	        'select',
	        { style: {
	            borderTop: 'none',
	            borderLeft: 'none',
	            borderRight: 'none',
	            borderBottom: 'none',
	            color: generalTitleColor,
	            borderColor: bannerColor,
	            outline: 'none',
	            boxShadow: 'none',
	            WebkitAppearance: 'none',
	            fontFamily: 'Arial',
	            fontSize: 20,
	            borderRadius: 3,
	            textAlignLast: 'center',
	            padding: 15,
	            backgroundColor: 'white',
	            margin: 0
	          }, onChange: function onChange(event) {
	            _this.onSelect(event.target.value);
	          } },
	        this.props.values.map(function (value, valueIndex) {
	          return React.createElement(
	            'option',
	            { value: valueIndex },
	            value
	          );
	        })
	      )
	    );
	  }
	});
	
	module.exports = ReUpPicker;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var FeatureBuilder = __webpack_require__(90);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpTabContentContainer = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: {},
	      activeTop: 100,
	      height: 200,
	      width: 300,
	      layout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      tabIndexSelected: this.props.initialTabSelected,
	      visible: false,
	      opacity: new Animated.Value(1),
	      newFeatureOpacity: new Animated.Value(1),
	      activeTop: this.props.activeTop,
	      height: this.props.activeHeight,
	      width: this.props.width,
	      currentTop: new Animated.Value(this.props.height + this.props.activeTop + 10),
	      currentFeatureView: null,
	      previousFeatureView: null,
	      layout: this.props.layout,
	      currentFeature: { name: "none" },
	      previousFeature: { name: "none" }
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    this.setState(newProps);
	
	    var thisThing = this;
	    if (this.state.visible) {
	      setTimeout(function () {
	        thisThing.showFeature();
	      }, 200);
	    }
	  },
	
	  _attemptedFeature: null,
	  _attemptedFeatureExtras: null,
	  showFeature: function showFeature(feature, extras, animate, doThisIfHadToLogIn, doThisBeforeAttemptLogin) {
	    var thisThing = this;
	    if (typeof animate === 'undefined') animate = true;
	    if (typeof feature !== 'undefined') {
	      this._attemptedFeature = null;
	
	      var appManager = this.props.appManager;
	
	      var needsLogin = feature.data.requiresLogin;
	      if (needsLogin && !appManager.isLoggedIn()) {
	        doThisBeforeAttemptLogin();
	        this.props.appActions.requestFeatureName("Login", {}, true, function () {
	          thisThing.showFeature(feature);
	          if (typeof doThisIfHadToLogIn !== 'undefined') doThisIfHadToLogIn();
	        });
	        return;
	        var loginFeature = appManager.getFeatureForName("Login");
	        this.showFeature(loginFeature, { shadowEnabled: false }, animate);
	        this._attemptedFeature = feature;
	        this._attemptedFeatureExtras = extras;
	      } else {
	        if (typeof extras === 'undefined') extras = {};
	        extras.shadowEnabled = false;
	        var featureView = FeatureBuilder.featureForData(feature, this.state.layout, this.props.appManager, extras);
	        if (this.state.visible) {
	          setTimeout(function () {
	            thisThing.state.newFeatureOpacity = new Animated.Value(1);
	            // thisThing.state.newFeatureOpacity = new Animated.Value(0);
	            thisThing.setState({ previousFeatureView: thisThing.state.currentFeatureView, previousFeature: thisThing.state.previousFeature, currentFeatureView: featureView, currentFeature: feature, newFeatureOpacity: new Animated.Value(1) });
	            // setTimeout(function()
	            // {
	            //   Animated.timing(
	            //    thisThing.state.newFeatureOpacity,
	            //    {toValue: 1,
	            //    duration:0},
	            //   ).start(function()
	            //   {
	            //     // thisThing.setState({previousFeatureView:null});
	            //   });
	            // }, 0)
	          }, 0);
	        } else {
	          this.setState({ currentFeatureView: featureView, currentFeature: feature });
	        }
	      }
	    }
	
	    this.setVisible(true, animate);
	  },
	  hideFeature: function hideFeature(animate) {
	    if (typeof animate === 'undefined') animate = true;
	    this.setVisible(false, animate);
	  },
	
	
	  setVisible: function setVisible(visible, animated) {
	    if (typeof animated === 'undefined') animated = true;
	    if (visible == this.state.visible) return;
	
	    var thisThing = this;
	    this.setState({ visible: visible });
	    if (visible) {
	      Animated.spring(thisThing.state.currentTop, {
	        toValue: thisThing.state.activeTop,
	        tension: 100,
	        friction: 15
	      }).start();
	    } else {
	      Animated.spring(thisThing.state.currentTop, {
	        toValue: thisThing.state.height + this.props.activeTop + 10,
	        tension: 100,
	        friction: 15
	      }).start();
	    }
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var visible = this.state.visible;
	
	    return React.createElement(
	      Animated.View,
	      { style: { shadowColor: 'black', backgroundColor: 'transparent', shadowOpacity: 0.8, shadowRadius: 4, shadowOffset: { width: 0, height: 0 }, position: 'absolute', top: this.state.currentTop, width: this.state.width, height: this.state.height, borderTopLeftRadius: 20, borderTopRightRadius: 20 } },
	      React.createElement(
	        View,
	        { style: { overflow: 'hidden', backgroundColor: 'transparent', borderTopLeftRadius: 20, borderTopRightRadius: 20 } },
	        React.createElement(
	          View,
	          { style: { marginTop: -this.state.activeTop, height: this.state.height + this.state.activeTop } },
	          React.createElement(
	            Animated.View,
	            { key: this.state.previousFeature.name, style: { position: 'absolute', width: this.state.width, height: this.state.height + this.state.activeTop } },
	            this.state.previousFeatureView
	          ),
	          React.createElement(
	            Animated.View,
	            { key: this.state.currentFeature.name, style: { opacity: 1, position: 'absolute', width: this.state.width, height: this.state.height + this.state.activeTop } },
	            this.state.currentFeatureView
	          )
	        )
	      )
	    );
	  }
	});
	
	module.exports = ReUpTabContentContainer;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Icon = __webpack_require__(13);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpButton = __webpack_require__(12);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpIconButton = __webpack_require__(18);
	var LinkingManager = __webpack_require__(27);
	
	var Share = __webpack_require__(853);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton;
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    Clipboard = ReactNative.Clipboard;
	
	
	var ReferAFriend = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      referCampaign: null,
	      shouldShowFacebook: false,
	      shouldShowTwitter: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var thisThing = this;
	    LinkingManager.canOpenURL("fb://feed", function (shouldShowFacebook) {
	      if (shouldShowFacebook) thisThing.setState({ shouldShowFacebook: shouldShowFacebook });
	    });
	
	    LinkingManager.canOpenURL("twitter://timeline", function (shouldShowFacebook) {
	      if (shouldShowFacebook) thisThing.setState({ shouldShowFacebook: shouldShowFacebook });
	    });
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Campaigns !== 'undefined') {
	      var referCampaign = null;
	      for (var i = 0; i < data.Campaigns.length; i++) {
	        var campaign = data.Campaigns[i];
	        if (campaign.Type == "Referral") referCampaign = JSON.parse(campaign.CampaignBlob);
	      }
	      this.setState({
	        campaigns: data.Campaigns,
	        referCampaign: referCampaign
	      });
	    }
	  },
	
	  _referEmail: "",
	  _referFirstName: "",
	  _referLastName: "",
	  _referFullName: "",
	  showRefer: function showRefer(type) {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var pointsLocalized = typeof this.state.referCampaign.RefereePoints !== 'undefined' ? locManager.localizedPoints(this.state.referCampaign.RefereePoints) : this.state.referCampaign.RewardName;
	    var referTitle = this.props.referTitle;
	    var bundleID = appManager.getAppData()["Header"]["BundleID"];
	    var link = bundleID.split('.')[2] + ".getreup.com";
	    var body = "";
	    if (typeof this.state.referCampaign.RefereePoints !== 'undefined') {
	      body = locManager.localizedStringForKeyAndParams("REFERRAL_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link]);
	    } else {
	      body = locManager.localizedStringForKeyAndParams("REFERRAL_SMS_BODY", [pointsLocalized, appManager.appName, user.ReferralCode, link], "Receive a %0% at %1%! Use referral code %2% to sign up. Download here: %3%");
	    }
	    var shareOptions = {
	      title: referTitle,
	      subject: locManager.localizedStringForKeyAndParams("REFERRAL_SUBJECT", [appManager.appName]),
	      message: body
	    };
	
	    if (typeof type === 'undefined') Share.open(shareOptions);else {
	      shareOptions.social = type;
	      Share.shareSingle(shareOptions);
	    }
	  },
	
	  render: function render() {
	    // if( this.state.referCampaign == null ) return null;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var sendEmailButton = locManager.localizedStringForKey("SEND_AN_EMAIL_BUTTON");
	    var postOnFacebookButton = locManager.localizedStringForKey("POST_ON_FACEBOOK_BUTTON");
	    var postOnTwitterButton = locManager.localizedStringForKey("POST_ON_TWITTER_BUTTON");
	    var otherButton = locManager.localizedStringForKey("OTHER_BUTTON");
	    var user = appManager.currentUser();
	    if (user == null) return null;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalTitleColorLight = appManager.getColorForKey("GeneralTitleColor", .6);
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", 0.4);
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	
	    var instructions = "";
	    if (this.state.referCampaign != null) {
	      if (typeof this.state.referCampaign.ReferrerPoints !== 'undefined') {
	        var pointsLocalized = locManager.localizedPoints(this.state.referCampaign.ReferrerPoints);
	        instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT", [pointsLocalized]);
	      } else if (typeof this.state.referCampaign.RewardName !== 'undefined') {
	        instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_STATEMENT", ["one " + this.state.referCampaign.RewardName]);
	      }
	    }
	
	    var referralCode = user.ReferralCode;
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, backgroundColor: generalColor } }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, isEmpty: this.state.referCampaign == null },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', backgroundColor: instructionColor } },
	          React.createElement(
	            View,
	            { style: { padding: 10, flex: 1 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: instructionTitleColor } },
	              instructions
	            )
	          ),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: this.props.appActions
	          })
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        React.createElement(
	          View,
	          { style: { alignSelf: 'stretch' } },
	          React.createElement(
	            MKButton,
	            { key: "info",
	              backgroundColor: 'transparent',
	              shadowRadius: 2,
	              shadowOffset: { width: 0, height: 2 },
	              shadowOpacity: 0.7,
	              rippleColor: rippleColor,
	              shadowColor: 'transparent',
	              onPress: function onPress() {
	                Clipboard.setString(referralCode);
	              },
	              style: { flexDirection: 'row', marginVertical: 20 } },
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(
	              View,
	              { style: { alignSelf: 'center', flex: 3 } },
	              React.createElement(
	                View,
	                { style: { padding: 15, alignSelf: 'stretch', flex: 1 } },
	                React.createElement(
	                  View,
	                  { style: { alignSelf: 'stretch', padding: 12, justifyContent: 'center', borderWidth: 1, flex: 1, borderStyle: 'dashed', borderColor: generalTitleColorLight } },
	                  React.createElement(
	                    View,
	                    null,
	                    React.createElement(
	                      ReUpText,
	                      { isTitle: true, appManager: appManager, style: { fontSize: 20, alignSelf: 'center', color: generalTitleColor } },
	                      referralCode
	                    )
	                  )
	                ),
	                React.createElement(
	                  View,
	                  { style: { position: 'absolute', width: 30, height: 30, borderRadius: 15, overflow: 'hidden', alignItems: 'center', justifyContent: 'center', backgroundColor: buttonPrimaryColor, top: 0, right: 0 } },
	                  React.createElement(Icon, { name: "clipboard", size: 16, color: buttonPrimaryTitleColor })
	                )
	              )
	            ),
	            React.createElement(View, { style: { flex: 1 } })
	          )
	        ),
	        React.createElement(ReUpButton, { onPress: function onPress() {
	            thisThing.showRefer("email");
	          }, style: { marginBottom: 10, marginHorizontal: 20 }, appManager: appManager, text: sendEmailButton }),
	        this.state.shouldShowFacebook ? React.createElement(ReUpButton, { isSecondary: true, onPress: function onPress() {
	            thisThing.showRefer("facebook");
	          }, style: { marginBottom: 10, marginHorizontal: 20 }, appManager: appManager, text: postOnFacebookButton }) : null,
	        this.state.shouldShowTwitter ? React.createElement(ReUpButton, { isSecondary: true, onPress: function onPress() {
	            thisThing.showRefer("twitter");
	          }, style: { marginBottom: 10, marginHorizontal: 20 }, appManager: appManager, text: postOnTwitterButton }) : null,
	        React.createElement(ReUpButton, { isSecondary: true, onPress: function onPress() {
	            thisThing.showRefer();
	          }, style: { marginBottom: 10, marginHorizontal: 20 }, appManager: appManager, text: otherButton })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  }
	});
	
	ReferAFriend.dataDependencies = ["Users", "Campaigns"];
	
	module.exports = ReferAFriend;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ArcMeter = __webpack_require__(58);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var NetworkManager = __webpack_require__(15);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MK = __webpack_require__(14);
	
	var MKButton = MK.MKButton;
	
	
	function getCreditPointsText(transaction, appManager) {
	  var locManager = appManager.getLocalizationManager();
	  var creditTransaction = transaction.creditTransaction;
	  var pointsTransaction = transaction.pointsTransaction;
	  var passTransaction = transaction.passTransaction;
	  var creditText = null;
	  var pointsText = null;
	  var passText = null;
	  var dateText = null;
	  var timeStamp = null;
	  var userName = "";
	  var transactionIDs = [];
	
	  if (creditTransaction) transactionIDs.push(creditTransaction.TransactionID);
	  if (pointsTransaction) transactionIDs.push(pointsTransaction.TransactionID);
	  if (passTransaction) transactionIDs.push(passTransaction.TransactionID);
	
	  if (creditTransaction != null) {
	    if (typeof creditTransaction.UserName !== 'undefined' && creditTransaction.UserName.length > 0) userName = creditTransaction.UserName;
	    dateText = typeof creditTransaction.TimestampEpoch !== 'undefined' && creditTransaction.TimestampEpoch > 0 ? appManager.timeSince(creditTransaction.TimestampEpoch) : appManager.timeSince(creditTransaction.Timestamp);
	    timeStamp = creditTransaction.Timestamp;
	    var credit = parseFloat(creditTransaction['Credit']);
	    if (credit == 0) {} else if (credit < 0) {
	      if (creditTransaction["Source"] == "99") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(-credit)]);
	      } else if (creditTransaction["Source"] == "6") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_SENT_GC_STATEMENT", [locManager.localizedDollars(-credit), "You sent a %0% gift card!"]);
	      } else {
	        creditText = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(-credit)]);
	      }
	    } else {
	      if (creditTransaction["Source"] == "99") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(credit)]);
	      } else if (creditTransaction["Source"] == "6") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_GC_STATEMENT", [locManager.localizedDollars(credit)], "You received a %0% gift card!");
	      } else if (creditTransaction["Source"] == "11") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locManager.localizedDollars(credit)], "You transferred %0% from an old loyalty account!");
	      } else {
	        creditText = locManager.localizedStringForKeyAndParams("USER_DEPOSITED_STATEMENT", [locManager.localizedDollars(credit)]);
	      }
	    }
	  }
	
	  if (pointsTransaction != null) {
	    if (typeof pointsTransaction.UserName !== 'undefined' && pointsTransaction.UserName.length > 0) userName = pointsTransaction.UserName;
	    dateText = typeof pointsTransaction.TimestampEpoch !== 'undefined' && pointsTransaction.TimestampEpoch > 0 ? appManager.timeSince(pointsTransaction.TimestampEpoch) : appManager.timeSince(pointsTransaction.Timestamp);
	    timeStamp = pointsTransaction.Timestamp;
	    var points = parseInt(pointsTransaction['Points']);
	    if (points == 0) {} else if (points < 0) {
	      points = Math.abs(points);
	      if (pointsTransaction["Source"] == "99") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_LOST_STATEMENT", [locManager.localizedPoints(points)]);
	      } else if (pointsTransaction["Source"] == "6") {
	        pointsText = "You sent " + [locManager.localizedPoints(points)] + "!";
	      } else {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", [locManager.localizedPoints(points)]);
	      }
	    } else {
	      var locPoints = locManager.localizedPoints(points);
	      if (pointsTransaction["Source"] == "99") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locPoints]);
	      } else if (pointsTransaction["Source"] == "6") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_POINTS_STATEMENT", [locPoints], "You received %0%!");
	      } else if (pointsTransaction["Source"] == "11") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locPoints], "You transferred %0% from an old loyalty account!");
	      } else if (pointsTransaction["Source"] == "10") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_POINTS_FOR_REFERRAL", [locPoints], "You earned %0% for a referral!");
	      } else {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locPoints], "You earned %0%!");
	      }
	    }
	  }
	
	  if (passTransaction != null) {
	    if (typeof passTransaction.UserName !== 'undefined' && passTransaction.UserName.length > 0) userName = passTransaction.UserName;
	    dateText = typeof passTransaction.TimestampEpoch !== 'undefined' && passTransaction.TimestampEpoch > 0 ? appManager.timeSince(passTransaction.TimestampEpoch) : appManager.timeSince(passTransaction.Timestamp);
	    timeStamp = passTransaction.Timestamp;
	    if (passTransaction.IsCredit == "1") {
	      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_PURCHASE", [passTransaction.PassQuantityRemaining, passTransaction.PassName, locManager.localizedDollars(passTransaction.Credit)], "You purchased %0% %1% for %2%!");
	    } else {
	      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassName], "You redeemed one of the %0%.");
	      if (passTransaction.PassQuantityRemaining > 0) passText += " " + locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassQuantityRemaining], "Only %0% are left!");else passText += " " + locManager.localizedStringForKey("PASS_TRANSACTION_NONE_ARE_LEFT", "None are left.");
	    }
	  }
	
	  if (userName.length > 0 && !appManager.isValidEmail(userName)) userName = appManager.getLocalizationManager().localizedPhone(userName);
	
	  return { creditText: creditText, pointsText: pointsText, passText: passText, dateText: dateText, timeStamp: timeStamp, transactionIDs: transactionIDs, userName: userName };
	}
	
	function compiledTransactions(transactions, appManager) {
	  var timeThreshold = 2000;
	  if (transactions == null) return [];
	
	  transactions = transactions.sort(function (a, b) {
	    return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
	  });
	  var compiledTransactions = [];
	  for (var i = 0; i < transactions.length; i++) {
	    var thisTrans = transactions[i];
	    if (thisTrans.IsDeleted == '1') continue;
	    var thisCreditTrans = null;
	    var thisPointsTrans = null;
	    var thisPassTrans = null;
	    if (thisTrans.IsCredit == "1") {
	      if (typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 && thisTrans.PassID >= 0) {
	        thisPassTrans = thisTrans;
	      } else {
	        thisCreditTrans = thisTrans;
	      }
	    } else {
	      if (typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0 && thisTrans.PassID >= 0) {
	        thisPassTrans = thisTrans;
	      } else {
	        thisPointsTrans = thisTrans;
	      }
	    }
	
	    if (i < transactions.length - 1) {
	      var nextTrans = transactions[i + 1];
	      if (nextTrans.IsDeleted == '1') continue;
	      var thisTime = appManager.getTime(thisTrans.Timestamp);
	      var nextTime = appManager.getTime(nextTrans.Timestamp);
	      if (Math.abs(thisTime - nextTime) <= timeThreshold) {
	        if (typeof nextTrans.PassID !== 'undefined' && nextTrans.PassID.length > 0 && thisPassTrans != null) {
	          if (thisPassTrans.Credit < 0 && nextTrans.Credit > 0) {
	            thisPassTrans = nextTrans;
	          }
	          i++;
	        } else if (nextTrans.IsCredit == "1" && thisCreditTrans == null) {
	          thisCreditTrans = nextTrans;
	          i++;
	        } else if (thisPointsTrans == null && nextTrans.IsCredit != "1") {
	          thisPointsTrans = nextTrans;
	          i++;
	        }
	      }
	    }
	    compiledTransactions.push({ pointsTransaction: thisPointsTrans, creditTransaction: thisCreditTrans, passTransaction: thisPassTrans });
	  }
	
	  return compiledTransactions;
	}
	
	var Refunds = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      refunds: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    // this.didUpdate();
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.EligibleRefunds !== 'undefined') {
	      var transactions = data.EligibleRefunds;
	      transactions = compiledTransactions(transactions, this.props.appManager);
	
	      this.setState({ refunds: transactions });
	    }
	    // if( this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
	    // {
	    //   refunds.setState({refunds:[
	    //         {
	    //             "RefundID": "-1",
	    //             "RefundName": "Free Item",
	    //             "Description": "Enjoy one of our signature Items, on the house!",
	    //             "Points": "100",
	    //             "IsDeleted": "0"
	    //         },
	    //         {
	    //             "RefundID": "-2",
	    //             "RefundName": "Free Thing",
	    //             "Description": "Feeling thirsty today? We've got the Thing you need!",
	    //             "Points": "200",
	    //             "IsDeleted": "0"
	    //         },
	    //         {
	    //             "RefundID": "-3",
	    //             "RefundName": "Free Stuff",
	    //             "Description": "Keep it up! You've got the Stuff!",
	    //             "Points": "500",
	    //             "IsDeleted": "0"
	    //         }
	    //     ]});
	    //     return;
	    // }
	  },
	
	  didSelectRefund: function didSelectRefund(refund) {
	    var credit = 0;
	    var points = 0;
	    if (typeof refund.creditTransaction !== 'undefined' && refund.creditTransaction != null) {
	      refund = refund.creditTransaction;
	      credit = -refund.Credit;
	    }
	    if (typeof refund.pointsTransaction !== 'undefined' && refund.pointsTransaction != null) {
	      refund = refund.pointsTransaction;
	      points = -refund.Points;
	    }
	    if (typeof refund.passTransaction !== 'undefined' && refund.passTransaction != null) refund = refund.passTransaction;
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var refundAlertTitle = locMan.localizedStringForKeyAndParams("REFUND_CREDIT_AND_POINTS_ALERT_BODY", [locMan.localizedDollars(credit), locMan.localizedPoints(points)], "Refund %0%, %1% and other related transactions?");
	    appActions.showLocalizedAlert("REFUND_CREDIT_AND_POINTS_ALERT_TITLE", refundAlertTitle, ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert(), function () {
	      appActions.hideAlert();
	      appActions.setSpinnerShown(true, thisThing.locMan.localizedStringForKey("REFUNDING_SPINNER", "Refunding..."));
	      NetworkManager.refund(thisThing.props.appManager, refund.TransactionID, function () {
	        thisThing.refs.ptr.doOnlineUpdate();
	        setTimeout(function () {
	          appActions.setSpinnerShown(false);
	        }, 1000);
	      }, function () {
	        appActions.setSpinnerShown(false);
	      });
	    }]);
	  },
	
	  render: function render() {
	    var thisRefunds = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	    var offRowBackgroundColor = appManager.getColorForKey("GeneralTitleColor", 0.05);
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    var refunds = this.state.refunds.sort(function (a, b) {
	      return b.TransactionID - a.TransactionID;
	    });
	
	    var numUserPoints = user[ModelConstants.Points];
	    return React.createElement(
	      View,
	      { style: styles.container },
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, featureName: 'Refunds', isEmpty: refunds.length <= 0 },
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        React.createElement(View, { style: { height: Globals.STATUS_BAR_HEIGHT } }),
	        refunds.map(function (refund, index) {
	          var text = getCreditPointsText(refund, appManager);
	
	          return React.createElement(
	            MKButton,
	            { key: refund.TransactionID, style: [styles.refundRowContainer],
	              backgroundColor: 'transparent',
	              shadowRadius: 2,
	              shadowOffset: { width: 0, height: 2 },
	              shadowOpacity: 0.7,
	              shadowColor: 'transparent',
	              onPress: function onPress() {
	                thisRefunds.didSelectRefund(refund);
	              }
	            },
	            React.createElement(
	              View,
	              { style: [styles.refundRow, { backgroundColor: index % 2 == 0 ? offRowBackgroundColor : 'transparent' }] },
	              React.createElement(
	                View,
	                { style: styles.refundLeftContainer },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ opacity: .6, color: generalTitleColor }] },
	                  locManager.dateTime(text.timeStamp)
	                ),
	                text.userName.length > 0 ? React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ opacity: .6, color: generalTitleColor }] },
	                  text.userName
	                ) : null,
	                text.creditText == null ? null : React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ color: generalTitleColor }] },
	                  text.creditText
	                ),
	                text.pointsText == null ? null : React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ color: generalTitleColor }] },
	                  text.pointsText
	                ),
	                text.passText == null ? null : React.createElement(
	                  ReUpText,
	                  { appManager: appManager, style: [{ color: generalTitleColor }] },
	                  text.passText
	                )
	              ),
	              React.createElement(
	                View,
	                { style: styles.refundRightContainer },
	                React.createElement(
	                  ReUpText,
	                  { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor, fontSize: 12, textAlign: 'center' }] },
	                  locManager.localizedStringForKeyAndParams("TRANS_ID_LABEL_AND_ID", [text.transactionIDs.join()])
	                )
	              )
	            ),
	            React.createElement(View, { style: styles.refundDivider })
	          );
	        })
	      ),
	      React.createElement(
	        View,
	        { style: { alignSelf: 'stretch', backgroundColor: generalColor } },
	        React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, paddingLeft: 20, paddingRight: 20 }],
	          appManager: appManager,
	          text: locManager.localizedStringForKey("CANCEL_BUTTON"),
	          onPress: function onPress() {
	            thisRefunds.props.appActions.requestPop(false);
	          }
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  refundRowContainer: {},
	  refundRow: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	  refundDivider: {
	    height: 1,
	    backgroundColor: '#DADADA'
	  },
	  refundLeftContainer: {
	    paddingTop: 8,
	    marginLeft: 4,
	    marginRight: 4,
	    paddingBottom: 8,
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'flex-start'
	  },
	  refundAmountContainer: {
	    width: 80,
	    height: 80,
	    borderRadius: 40,
	    borderWidth: 8,
	    margin: 10,
	    justifyContent: 'center',
	    alignItems: 'center',
	    alignSelf: 'center',
	    flex: 1
	  },
	  refundAmount: {
	    fontSize: 34,
	    flex: 1,
	    alignSelf: 'center',
	    justifyContent: 'center'
	  },
	  refundRightContainer: {
	    width: 100,
	    justifyContent: 'center',
	    paddingRight: 8,
	    paddingBottom: 4,
	    paddingTop: 4
	  },
	  refundDescription: {
	    padding: 0,
	    margin: 0,
	    opacity: .8
	  }
	
	});
	
	Refunds.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var points = parseFloat(user[ModelConstants.Points]);
	    var refunds = typeof data.Refunds !== 'undefined' ? data.Refunds : [];
	    var refunds = typeof data.Refunds !== 'undefined' ? data.Refunds.sort(function (a, b) {
	      return a.Points - b.Points;
	    }) : [];
	    if (typeof refunds === 'undefined' || refunds == null || refunds.length <= 0) return [];
	
	    var affordedRefund = null;
	    for (var i = 0; i < refunds.length; i++) {
	      var refund = refunds[i];
	      if (refund.Points <= points) {
	        affordedRefund = refund;
	      } else {
	        break;
	      }
	    }
	    if (affordedRefund == null) return [];
	
	    // get date acheived
	    var sortOrder = -1;
	    if (typeof data.Transactions !== 'undefined') {
	      var trans = data.Transactions;
	      var runningPoints = points;
	      var refundTrans = null;
	      for (var i = 0; i < trans.length; i++) {
	        var thisTrans = trans[i];
	        runningPoints -= thisTrans.Points;
	        if (runningPoints < affordedRefund.Points) break;
	        refundTrans = thisTrans;
	      }
	      if (refundTrans != null) {
	        var time = appManager.getTime(refundTrans.Timestamp);
	        sortOrder = new Date().getTime() - time;
	      }
	    }
	
	    sortOrder -= 1000; // reduce by a second so that it is above transaction history
	    var cheapestRefund = refunds[0];
	    if (points < cheapestRefund.Points) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("Refunds");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: sortOrder
	    }];
	  }
	};
	
	Refunds.dataDependencies = ["EligibleRefunds"];
	
	module.exports = Refunds;

/***/ },
/* 1137 */
1111,
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var moment = __webpack_require__(3);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ArcMeter = __webpack_require__(58);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpButton = __webpack_require__(12);
	var NetworkManager = __webpack_require__(15);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MK = __webpack_require__(14);
	
	var MKButton = MK.MKButton;
	
	
	function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
	  var angleInRadians = angleInDegrees * Math.PI / 180.0;
	  var x = centerX + radius * Math.cos(angleInRadians);
	  var y = centerY + radius * Math.sin(angleInRadians);
	  return [x, y];
	}
	
	function svgArc(startAngle, endAngle, percentage) {
	  while (startAngle < 0) {
	    startAngle += 360;
	  }while (endAngle < 0 || endAngle < startAngle) {
	    endAngle += 360;
	  }var portionAngle = (endAngle - startAngle) * percentage;
	  var stopAngle = startAngle + portionAngle;
	
	  var _polarToCartesian = polarToCartesian(50, 50, 40, startAngle % 360),
	      _polarToCartesian2 = _slicedToArray(_polarToCartesian, 2),
	      sx = _polarToCartesian2[0],
	      sy = _polarToCartesian2[1];
	
	  var _polarToCartesian3 = polarToCartesian(50, 50, 40, stopAngle),
	      _polarToCartesian4 = _slicedToArray(_polarToCartesian3, 2),
	      ex = _polarToCartesian4[0],
	      ey = _polarToCartesian4[1];
	
	  var flag = (stopAngle - startAngle) % 360 < 180 ? "0" : "1";
	
	  return "M " + ex + " " + ey + " A 40 50 0 " + flag + " 0 " + sx + " " + sy;
	}
	
	var Rewards = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      rewards: [],
	      oneTimeRewards: [],
	      angle: 10
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.didUpdate();
	  },
	
	  didUpdate: function didUpdate(data) {
	    var rewards = this;
	    // if( this.props.appManager.currentUser()[ModelConstants.UserName].toLowerCase() == "kjregan10@gmail.com" )
	    // {
	    //   rewards.setState({rewards:[
	    //         {
	    //             "RewardID": "-1",
	    //             "RewardName": "Free Item",
	    //             "Description": "Enjoy one of our signature Items, on the house!",
	    //             "Points": "100",
	    //             "IsDeleted": "0"
	    //         },
	    //         {
	    //             "RewardID": "-2",
	    //             "RewardName": "Free Thing",
	    //             "Description": "Feeling thirsty today? We've got the Thing you need!",
	    //             "Points": "200",
	    //             "IsDeleted": "0"
	    //         },
	    //         {
	    //             "RewardID": "-3",
	    //             "RewardName": "Free Stuff",
	    //             "Description": "Keep it up! You've got the Stuff!",
	    //             "Points": "500",
	    //             "IsDeleted": "0"
	    //         }
	    //     ]});
	    //     return;
	    // }
	    this.props.appManager.getDataType("Rewards", function (data) {
	      if (typeof data !== 'undefined' && data != null) {
	        var deduplicatedRewards = [];
	        for (var i = 0; i < data.length; i++) {
	          var alreadyExists = false;
	          var reward = data[i];
	          for (var j = 0; j < deduplicatedRewards.length; j++) {
	            if (reward.RewardID == deduplicatedRewards[j].RewardID) {
	              if (typeof deduplicatedRewards[j].others === 'undefined') deduplicatedRewards[j].others = [];
	              deduplicatedRewards[j].others.push(reward);
	              alreadyExists = true;
	            }
	          }
	          if (!alreadyExists) {
	            deduplicatedRewards.push(reward);
	          }
	        }
	        rewards.setState({ rewards: deduplicatedRewards });
	      }
	    });
	
	    this.props.appManager.getDataType("OneTimeRewards", function (data) {
	      if (typeof data !== 'undefined' && data != null) {
	        var deduplicatedOneTimeRewards = [];
	        for (var i = 0; i < data.length; i++) {
	          var alreadyExists = false;
	          var reward = data[i];
	          for (var j = 0; j < deduplicatedOneTimeRewards.length; j++) {
	            if (reward.RewardID == deduplicatedOneTimeRewards[j].RewardID) {
	              if (typeof deduplicatedOneTimeRewards[j].others === 'undefined') deduplicatedOneTimeRewards[j].others = [];
	              deduplicatedOneTimeRewards[j].others.push(reward);
	              alreadyExists = true;
	            }
	          }
	          if (!alreadyExists) {
	            deduplicatedOneTimeRewards.push(reward);
	          }
	        }
	        rewards.setState({ oneTimeRewards: deduplicatedOneTimeRewards });
	      }
	    });
	  },
	
	  didSelectReward: function didSelectReward(reward) {
	    if (reward.RewardType == 0 || reward.RewardType == 1) // points for product or one-time reward
	      {
	        this.props.appActions.requestFeatureName("UseReward", { reward: reward });
	      } else if (reward.RewardType == 2) {
	      var thisThing = this;
	      var appManager = this.props.appManager;
	      var appActions = this.props.appActions;
	      var locManager = appManager.getLocalizationManager();
	      var title = locManager.localizedStringForKey("REDEEM_REWARD_ALERT_TITLE", "Redeem Reward");
	      var body = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BODY", [locManager.localizedPoints(reward.Points), locManager.localizedDollarsShort(reward.Credit)], "Are you sure you want to redeem %0% to add %1% to your account?");
	      var buttonTitle = locManager.localizedStringForKeyAndParams("REDEEM_REWARD_ALERT_BUTTON", [locManager.localizedPts(reward.Points)], "Use %0%");
	      appActions.showLocalizedAlert(title, body, ["NO_ALERT_BUTTON", buttonTitle], [function () {
	        appActions.hideAlert();
	      }, function () {
	        appActions.setSpinnerShown(true);
	        NetworkManager.clientRedeemReward(appManager, reward.RewardID, function () {
	          if (typeof thisThing.refs.ptr !== 'undefined') thisThing.refs.ptr.doOnlineUpdate();
	          setTimeout(function () {
	            return appActions.setSpinnerShown(false);
	          }, 500);
	        }, function () {
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(function () {}, function () {});
	        }, function () {
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(function () {}, function () {});
	        });
	        appActions.hideAlert();
	      }], function () {});
	    }
	  },
	
	  getLocalizedRewardData: function getLocalizedRewardData(reward) {
	    var preferredLocale = this.props.appManager.getActiveLocale();
	    var localizedRewardData = {};
	    if (typeof reward.LocaleOverride !== 'undefined' && reward.LocaleOverride != null && reward.LocaleOverride.length > 0) {
	      var preferredLocaleOverrides = JSON.parse(reward.LocaleOverride);
	      if (typeof preferredLocaleOverrides[preferredLocale] !== 'undefined') {
	        localizedRewardData.name = preferredLocaleOverrides[preferredLocale].RewardName;
	        localizedRewardData.description = preferredLocaleOverrides[preferredLocale].Description;
	      } else {
	        localizedRewardData.name = reward.RewardName;
	        localizedRewardData.description = reward.Description;
	      }
	    } else {
	      localizedRewardData.name = reward.RewardName;
	      localizedRewardData.description = reward.Description;
	    }
	
	    return localizedRewardData;
	  },
	
	  render: function render() {
	    var thisRewards = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    var buttonPrimaryTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    if (profileMeterBackgroundColor == generalColor) profileMeterBackgroundColor = appManager.getColorForKey("PrimaryColor", 0.4);
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    var rewards = this.state.rewards.sort(function (a, b) {
	      if (a.Points == b.Points) return b.RewardName.localeCompare(a.RewardName);else return a.Points - b.Points;
	    });
	
	    var disableScan = this.props.featureData.disableScan === true;
	    var additionalRewardProps = {};
	    if (!disableScan && (typeof this.props.extras === 'undefined' || !this.props.extras.disableUseReward)) {
	      additionalRewardProps = {
	        icon: 'angle-right',
	        iconColor: 'red'
	      };
	    }
	
	    var oneTimeRewards = this.state.oneTimeRewards.sort(function (a, b) {
	      if (a.DateExpires == b.DateExpires) return b.RewardName != null ? b.RewardName.localeCompare(a.RewardName) : 0;else {
	        var dateA = new Date(a.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsA = moment(dateA).valueOf();
	        var dateB = new Date(b.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsB = moment(dateB).valueOf();
	
	        return dateSecondsA - dateSecondsB;
	      }
	    });
	
	    var numUserPoints = user[ModelConstants.Points];
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, featureName: 'Rewards', isEmpty: rewards.length <= 0 },
	        oneTimeRewards.length > 0 ? React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	              locManager.localizedStringForKey("ONE_TIME_REWARD_STATMENT", "You have limited time rewards.")
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: this.props.appActions,
	            onPress: function onPress() {
	              thisRewards.props.appActions.showAlert(locManager.localizedStringForKey("ONE_TIME_REWARD_ALERT_TITLE", "Your Limited Time Rewards"), locManager.localizedStringForKey("ONE_TIME_REWARD_ALERT_BODY", "Limited time rewards disappear after their expiry date if not used."), [locManager.localizedStringForKey("GOT_IT_ALERT_BUTTON")], [thisRewards.props.appActions.hideAlert], function () {});
	            }
	          })
	        ) : null,
	        oneTimeRewards.length > 0 ? React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }) : null,
	        oneTimeRewards.length > 0 ? oneTimeRewards.map(function (reward, index) {
	          var localizedRewardData = thisRewards.getLocalizedRewardData(reward);
	          if (typeof reward.others !== 'undefined' && reward.others.length > 0) name += " (" + (1 + reward.others.length) + ")";
	
	          var iconName = reward["IsBirthday"] ? "birthday-cake" : "star";
	          var other = {};
	          if (!disableScan) {
	            other.icon = 'angle-right';
	            other.onPress = function () {
	              thisRewards.didSelectReward(reward);
	            };
	          }
	          return React.createElement(
	            View,
	            { style: { overflow: 'auto' } },
	            React.createElement(
	              ReUpButton,
	              Object.assign({ key: reward.RewardID, appManager: appManager, isTertiary: true,
	                iconColor: 'red',
	                maskBorderRadius: 0,
	                style: { backgroundColor: 'transparent', padding: 0, alignSelf: 'stretch', margin: 0, width: -1, height: -1 }
	              }, other),
	              React.createElement(
	                View,
	                { style: { flex: 1 } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'center' } },
	                  React.createElement(
	                    View,
	                    { style: { margin: 20, width: 80, height: 80, borderRadius: 40, alignItems: 'center', backgroundColor: buttonPrimaryColor, justifyContent: 'center' } },
	                    React.createElement(
	                      View,
	                      { style: { marginTop: 5 } },
	                      React.createElement(_ReUpIcon2.default, { name: iconName, size: 44, color: buttonPrimaryTitleColor })
	                    )
	                  ),
	                  React.createElement(
	                    View,
	                    { style: { marginRight: 20, flex: 1, flexDirection: 'column' } },
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor }] },
	                        localizedRewardData.name
	                      )
	                    ),
	                    React.createElement(View, { style: { height: 4 } }),
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor } },
	                        localizedRewardData.description
	                      )
	                    )
	                  )
	                )
	              ),
	              React.createElement(View, { style: {
	                  height: 1,
	                  position: 'absolute',
	                  left: 0, right: 0, bottom: 0,
	                  backgroundColor: '#DADADA'
	                } })
	            )
	          );
	        }) : null,
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	              pointsLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: this.props.appActions
	          })
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        rewards.map(function (reward, index) {
	          var afforded = parseInt(numUserPoints) >= parseInt(reward.Points);
	          if (reward.IsDeleted == "1") return React.createElement(View, { key: reward.RewardID });
	          var fraction = Math.min(1, parseFloat(reward.Points) <= 0 ? 1 : parseFloat(numUserPoints) / parseFloat(reward.Points));
	          var amountFontSize = 30 - ((reward.Points + "").length > 3 ? ((reward.Points + "").length - 3) * 5 : 0);
	          var localizedRewardData = thisRewards.getLocalizedRewardData(reward);
	
	          return React.createElement(
	            View,
	            { style: { overflow: 'auto' } },
	            React.createElement(
	              ReUpButton,
	              Object.assign({ key: reward.RewardID, appManager: appManager, isTertiary: true,
	                maskBorderRadius: 0,
	                enabled: afforded,
	                style: { backgroundColor: 'transparent', padding: 0, alignSelf: 'stretch', margin: 0, width: -1, height: -1 },
	                onPress: function onPress() {
	                  if (!disableScan && (typeof thisRewards.props.extras === 'undefined' || !thisRewards.props.extras.disableUseReward)) thisRewards.didSelectReward(reward);
	                }
	              }, additionalRewardProps),
	              React.createElement(
	                View,
	                { style: { flex: 1 } },
	                React.createElement(
	                  View,
	                  { style: { flexDirection: 'row', alignItems: 'center' } },
	                  React.createElement(
	                    View,
	                    { style: { margin: 5, width: 110, height: 110, alignItems: 'center', justifyContent: 'center' } },
	                    React.createElement(
	                      ArcMeter,
	                      { fgColor: profileMeterColor, bgColor: profileMeterBackgroundColor, percentage: fraction, style: { width: 100, height: 100 } },
	                      React.createElement(
	                        View,
	                        null,
	                        React.createElement(
	                          ReUpText,
	                          { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.rewardAmount, { fontSize: amountFontSize, color: generalTitleColor }] },
	                          reward.Points
	                        )
	                      )
	                    )
	                  ),
	                  React.createElement(
	                    View,
	                    { style: { marginRight: 20, flex: 1, flexDirection: 'column' } },
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor }] },
	                        localizedRewardData.name
	                      )
	                    ),
	                    React.createElement(View, { style: { height: 4 } }),
	                    React.createElement(
	                      View,
	                      null,
	                      React.createElement(
	                        ReUpText,
	                        { appManager: appManager, style: { color: generalTitleColor } },
	                        localizedRewardData.description
	                      )
	                    )
	                  )
	                )
	              ),
	              React.createElement(View, { style: {
	                  height: 1,
	                  position: 'absolute',
	                  left: 0, right: 0, bottom: 0,
	                  backgroundColor: '#DADADA'
	                } })
	            )
	          );
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  rewardRowContainer: {},
	  rewardRow: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	  rewardDivider: {
	    height: 1,
	    backgroundColor: '#DADADA'
	  },
	  rewardLeftContainer: {
	    width: 100,
	    height: 100,
	    paddingTop: 8,
	    marginLeft: 4,
	    marginRight: 4,
	    paddingBottom: 8,
	    justifyContent: 'center',
	    alignItems: 'center'
	  },
	  rewardAmountContainer: {
	    width: 80,
	    height: 80,
	    borderRadius: 40,
	    borderWidth: 8,
	    margin: 10,
	    justifyContent: 'center',
	    alignItems: 'center',
	    alignSelf: 'center',
	    flex: 1
	  },
	  rewardAmount: {
	    fontSize: 34,
	    alignSelf: 'center',
	    justifyContent: 'center'
	  },
	  rewardRightContainer: {
	    flex: 1,
	    justifyContent: 'center',
	    paddingRight: 8,
	    paddingBottom: 4,
	    paddingTop: 4
	  },
	  rewardDescription: {
	    padding: 0,
	    margin: 0,
	    opacity: .8
	  }
	
	});
	
	Rewards.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var points = parseFloat(user[ModelConstants.Points]);
	    var rewards = typeof data.Rewards !== 'undefined' ? data.Rewards : [];
	    var rewards = typeof data.Rewards !== 'undefined' ? data.Rewards.sort(function (a, b) {
	      return a.Points - b.Points;
	    }) : [];
	    if (typeof rewards === 'undefined' || rewards == null || rewards.length <= 0) return [];
	
	    var affordedReward = null;
	    for (var i = 0; i < rewards.length; i++) {
	      var reward = rewards[i];
	      if (reward.Points <= points) {
	        affordedReward = reward;
	      } else {
	        break;
	      }
	    }
	    if (affordedReward == null) return [];
	
	    // get date acheived
	    var sortOrder = -1;
	    if (typeof data.Transactions !== 'undefined') {
	      var trans = data.Transactions;
	      var runningPoints = points;
	      var rewardTrans = null;
	      for (var i = 0; i < trans.length; i++) {
	        var thisTrans = trans[i];
	        runningPoints -= thisTrans.Points;
	        if (runningPoints < affordedReward.Points) break;
	        rewardTrans = thisTrans;
	      }
	      if (rewardTrans != null) {
	        var time = appManager.getTime(rewardTrans.Timestamp);
	        sortOrder = new Date().getTime() - time;
	      }
	    }
	
	    sortOrder -= 1000; // reduce by a second so that it is above transaction history
	    var cheapestReward = rewards[0];
	    if (points < cheapestReward.Points) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("Rewards");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: sortOrder
	    }];
	  }
	};
	
	Rewards.dataDependencies = ["Users", "Rewards", "OneTimeRewards", "Transactions"];
	
	module.exports = Rewards;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var Globals = __webpack_require__(10);
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpTabBar = __webpack_require__(74);
	
	var RewardsCampaigns = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      visibleFeature: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor", .6);
	    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
	
	    var rewardsFeature = appManager.getFeatureForName("Rewards");
	    var earnPointsFeature = appManager.getFeatureForName("EarnPoints");
	    var shouldShowEarnPointsFirst = typeof this.props.extras !== 'undefined' && typeof this.props.extras.showEarnPointsFirst !== 'undefined' && this.props.extras.showEarnPointsFirst;
	
	    return React.createElement(
	      View,
	      { style: { flex: 1, backgroundColor: generalColor, alignSelf: 'stretch', flexDirection: 'column' } },
	      React.createElement(
	        View,
	        { style: { flex: 1, overflow: 'hidden', marginTop: Globals.TAB_BAR_HEIGHT } },
	        this.state.visibleFeature
	      ),
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column', position: 'absolute', top: this.props.extras && this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT, left: 0, right: 0 } },
	        React.createElement(ReUpTabBar, {
	          style: { flex: 1, alignSelf: 'stretch' },
	          textColor: generalTitleColor,
	          barColor: iconColor,
	          rippleColor: rippleColor,
	          iconColor: iconColor,
	          layout: this.state.layout,
	          canDismiss: false,
	          initialTabSelected: shouldShowEarnPointsFirst ? 1 : 0,
	          showFeature: function showFeature(feature) {
	            var layout = { width: thisThing.state.layout.width, height: thisThing.state.layout.height - 40 - (_this.props.extras && _this.props.extras.shouldHideActionBar ? 0 : Globals.ACTION_BAR_HEIGHT) };
	            var featureView = appActions.featureForData(feature, layout, appManager, thisThing.props.extras);
	            thisThing.setState({ visibleFeature: featureView });
	          },
	          hideFeature: function hideFeature() {},
	          buttonFeatures: [rewardsFeature, earnPointsFeature]
	        })
	      )
	    );
	  }
	});
	
	RewardsCampaigns.dataDependencies = [];
	
	module.exports = RewardsCampaigns;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	
	var ArcMeter = __webpack_require__(58);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var MK = __webpack_require__(14);
	
	var MKButton = MK.MKButton;
	
	
	var RewardsList = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      style: {},
	      didSelectReward: function didSelectReward(reward) {},
	      rewards: [],
	      numUserPoints: 0,
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      value: 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  doTransaction: function doTransaction() {
	    this.props.appActions.requestFeatureName("TransactionResult");
	  },
	
	  numSelected: function numSelected(i) {
	    var newValue = this.state.value * 10 + i;
	    if (this.stringDollarValue(newValue).length > 11) return; // some sort of max
	    this.valueChanged(newValue);
	
	    this.setState({ value: newValue });
	  },
	
	  deleteSelected: function deleteSelected() {
	    var newValue = Math.floor(this.state.value / 10);
	    this.valueChanged(newValue);
	
	    this.setState({ value: newValue });
	  },
	
	  stringDollarValue: function stringDollarValue(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	
	    return this.props.appManager.getLocalizationManager().localizedDollars(parseFloat(value) / 100);
	  },
	
	  stringPointValue: function stringPointValue(value) {
	    value = this.pointsAmount(value);
	
	    var points = this.props.appManager.getLocalizationManager().localizedPoints(value);
	    if (points.length > 12) {
	      points = this.props.appManager.getLocalizationManager().localizedPts(value);
	    }
	
	    return points;
	  },
	
	  stringValue: function stringValue(value) {
	    if (this.props.isDollars) {
	      return this.stringDollarValue(value);
	    } else {
	      return this.stringPointValue(value);
	    }
	  },
	
	  clearSelected: function clearSelected() {
	    var newValue = 0;
	    this.valueChanged(newValue);
	
	    this.setState({ value: newValue });
	  },
	
	  valueChanged: function valueChanged(newValue) {
	    if (this.props.isDollars) {
	      this.props.valueChanged(newValue, this.stringValue(newValue));
	    } else if (this.props.isCheckin) {
	      this.props.valueChanged(newValue, this.stringPointValue(newValue));
	    } else {
	      this.props.valueChanged(newValue);
	    }
	  },
	
	  pointsAmount: function pointsAmount(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	
	    return Math.floor(value / (100 * this.props.pointsPerDollar));
	  },
	
	  dollarsAmount: function dollarsAmount(value) {
	    if (typeof value === 'undefined') value = this.state.value;
	
	    return parseFloat(value) / 100;
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	
	    var rowStyle = { flexDirection: 'row', flex: 1 };
	    var numSelected = thisThing.numSelected;
	    var clearSelected = thisThing.clearSelected;
	    var deleteSelected = thisThing.deleteSelected;
	    var appManager = this.props.appManager;
	    var rewards = this.props.rewards;
	    var numUserPoints = this.props.numUserPoints;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("SecondaryColor");
	    var profileMeterColor = appManager.getColorForKey("PrimaryColor");
	
	    return React.createElement(
	      View,
	      { style: this.props.style },
	      rewards.map(function (reward, index) {
	        if (typeof reward.Points == 'undefined') reward.Points = 0;
	
	        var afforded = parseInt(numUserPoints) >= parseInt(reward.Points);
	        if (reward.IsDeleted == "1") return React.createElement(View, { key: reward.RewardID });
	        var fraction = Math.min(1, parseFloat(reward.Points) <= 0 ? 1 : parseFloat(numUserPoints) / parseFloat(reward.Points));
	        var amountFontSize = 30 - ((reward.Points + "").length > 3 ? ((reward.Points + "").length - 3) * 5 : 0);
	        var name = reward.RewardName;
	        if (typeof reward.others !== 'undefined' && reward.others.length > 0) name += " (" + (reward.others.length + 1) + ")";
	        return React.createElement(
	          ReUpButton,
	          { key: reward.RewardID, appManager: appManager, isTertiary: true,
	            icon: 'angle-right', iconColor: 'red',
	            maskBorderRadius: 0,
	            enabled: afforded,
	            style: { backgroundColor: 'transparent', padding: 0, alignSelf: 'stretch', margin: 0, width: -1, height: -1 },
	            onPress: function onPress() {
	              thisThing.props.didSelectReward(reward);
	            }
	          },
	          React.createElement(
	            View,
	            { style: { flex: 1 } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', alignItems: 'center' } },
	              React.createElement(
	                View,
	                { style: { margin: 5, width: 110, height: 110, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ArcMeter,
	                  { fgColor: profileMeterColor, bgColor: profileMeterBackgroundColor, percentage: fraction, style: { width: 100, height: 100 } },
	                  React.createElement(
	                    View,
	                    null,
	                    React.createElement(
	                      ReUpText,
	                      { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.rewardAmount, { fontSize: amountFontSize, color: generalTitleColor }] },
	                      reward.Points
	                    )
	                  )
	                )
	              ),
	              React.createElement(
	                View,
	                { style: { marginRight: 20, flex: 1, flexDirection: 'column' } },
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, isTitle: true, style: [{ color: generalTitleColor }] },
	                    name
	                  )
	                ),
	                React.createElement(View, { style: { height: 4 } }),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: { color: generalTitleColor } },
	                    reward.Description
	                  )
	                )
	              )
	            )
	          ),
	          React.createElement(View, { style: {
	              height: 1,
	              position: 'absolute',
	              left: 0, right: 0, bottom: 0,
	              backgroundColor: '#DADADA'
	            } })
	        );
	      })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  rewardAmountContainer: {
	    width: 80,
	    height: 80,
	    borderRadius: 40,
	    borderWidth: 8,
	    margin: 10,
	    justifyContent: 'center',
	    alignItems: 'center',
	    alignSelf: 'center',
	    flex: 1
	  },
	  rewardAmount: {
	    fontSize: 34,
	    alignSelf: 'center',
	    justifyContent: 'center'
	  },
	  rewardRightContainer: {
	    flex: 1,
	    justifyContent: 'center',
	    paddingRight: 8,
	    paddingBottom: 4,
	    paddingTop: 4
	  },
	  rewardDescription: {
	    padding: 0,
	    margin: 0,
	    opacity: .8
	  }
	
	});
	
	module.exports = RewardsList;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	var PriceChooserView = __webpack_require__(150);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ReUpText = __webpack_require__(8);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var SendCredit = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      message: "",
	      numMessageLines: 1,
	      sendButton: "Send", //TODO:localize
	      emailError: false,
	      nameError: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  _email: "",
	  _emailHasBeenValid: false,
	  emailChanged: function emailChanged(email) {
	    this._email = email;
	    var emailValid = this.props.appManager.isValidEmail(email);
	    if (this._emailHasBeenValid && !emailValid && !this.state.emailError) {
	      this.setState({ emailError: true });
	    }
	
	    if (emailValid) {
	      this._emailHasBeenValid = true;
	      if (this.state.emailError) {
	        this.setState({ emailError: false });
	      }
	    }
	  },
	
	  _name: "",
	  _nameHasSucceeded: false,
	  nameChanged: function nameChanged(text) {
	    this._name = text;
	    var nameError = !(text.indexOf(" ") > -1);
	    if (nameError != this.state.nameError && this._nameHasSucceeded) {
	      this.setState({ nameError: nameError });
	    }
	
	    if (!nameError) this._nameHasSucceeded = true;
	  },
	
	  _message: "",
	  messageChanged: function messageChanged(message) {
	    this._message = message;
	    this.setState({ message: message });
	  },
	
	  submitPressed: function submitPressed() {
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = this.props.appManager.currentUser();
	    if (!this.props.appManager.isValidEmail(this._email) || user[ModelConstants.UserName].toLowerCase() == this._email.toLowerCase()) {
	      this.setState({ emailError: true });
	      appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	        thisThing.refs.email.focus();
	      }], function () {});
	    } else if (this._name.indexOf(" ") < 0) // name error
	      {
	        this.setState({ nameError: true });
	        var theirFirstLastNameError = "Please enter their first and last name.";
	        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", theirFirstLastNameError, ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          thisThing.refs.name.focus();
	        }], function () {});
	      } else {
	      var email = this._email;
	      var message = this._message;
	      var amount = this.refs.PriceChooserView.getAmount();
	      var thisThing = this;
	      var user = this.props.appManager.getCurrentUser(function (user) {
	        var credit = user[ModelConstants.Credits];
	        if (credit < amount) {
	          appActions.showLocalizedAlert(locManager.localizedStringForKey("NSF_ALERT_TITLE"), locManager.localizedStringForKey("NSF_ALERT_BODY"), ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	            appActions.hideAlert();
	            thisThing.refs.PriceChooserView.focus();
	          }, function () {
	            appActions.hideAlert();
	            appActions.requestFeatureName("AddCredit");
	          }], function () {});
	        } else {
	          var confirmTitle = locManager.localizedStringForKey("CONFIRM_ALERT_TITLE", "Confirmation");
	          var confirmBody = locManager.localizedStringForKeyAndParams("SEND_CREDIT_CONFIRMATION_BODY", [locManager.localizedDollars(amount), thisThing._name, email], "Would you like to send %0% to %1% (%2%)?");
	          var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON");
	          var noButton = locManager.localizedStringForKey("NO_ALERT_BUTTON");
	          appActions.setSpinnerShown(false);
	          appActions.showAlert(confirmTitle, confirmBody, [noButton, yesButton], [function () {
	            appActions.hideAlert();
	          }, function () {
	            appActions.hideAlert();thisThing.send(amount, email, message);
	          }]);
	        }
	      });
	    }
	  },
	
	  send: function send(amount, email, message) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	
	    var names = this._name.split(" ");
	    var lastName = names[names.length - 1];
	    var firstName = "";
	    for (var i = 0; i < names.length - 1; i++) {
	      if (firstName.length > 0) firstName += " ";
	      firstName += names[i];
	    }
	
	    appActions.setSpinnerShown(true, processingHUD);
	    NetworkManager.sendCredit(appManager, amount, email, message, firstName, lastName, function (data) {
	      appActions.setSpinnerShown(false);
	      var user = appManager.currentUser();
	      user[ModelConstants.Credits] = parseFloat(user[ModelConstants.Credits]) - amount;
	      var sendSuccess = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_TITLE");
	      var creditSent = locManager.localizedStringForKey("SEND_CREDIT_SUCCESS_ALERT_BODY");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appManager.setCurrentUser(user, function () {
	        appActions.showAlert(sendSuccess, creditSent, [okayText], [function () {
	          appActions.requestPop(false);appActions.hideAlert();
	        }]);
	      });
	    }, function (data) {
	      var sendFailedTitle = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_TITLE");
	      var sendFailedBody = locManager.localizedStringForKey("SEND_CREDIT_FAIL_ALERT_BODY");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appActions.setSpinnerShown(false);
	      appActions.showAlert(sendFailedTitle, sendFailedBody, [okayText]);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  didStartChoosingPrice: function didStartChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(false);
	  },
	
	  didEndChoosingPrice: function didEndChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(true);
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = this.state.user;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var howMuchCreditToSendStatement = locManager.localizedStringForKey("SEND_GC_AMOUNT_LABEL");
	    var whoToSendStatement = locManager.localizedStringForKey("SEND_GC_RECIPIENT_LABEL");
	    var emailLabel = locManager.localizedStringForKey("EMAIL_LABEL");
	    var messageLabel = locManager.localizedStringForKey("SEND_GC_MESSAGE_LABEL");
	    var sendButton = locManager.localizedStringForKey("SEND_BUTTON");
	    var priceChooserProps = {};
	    if (typeof this.props.featureData.choiceValue !== 'undefined') {
	      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
	    }
	    if (typeof this.props.featureData.choiceIndex !== 'undefined') {
	      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
	    }
	
	    var nameLabel = "Name (First and Last):"; //locManager.localizedStringForKey("NAME_LABEL");
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	              creditsLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: appActions
	          })
	        ),
	        React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	        React.createElement(
	          View,
	          null,
	          React.createElement(
	            ReUpText,
	            { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	            howMuchCreditToSendStatement
	          ),
	          React.createElement(PriceChooserView, Object.assign({ ref: "PriceChooserView", style: [styles.choicesContainer, { marginBottom: 10 }], appManager: this.props.appManager,
	            initialLayout: this.state.layout, didChangeValueAndText: function didChangeValueAndText(v, t) {
	              return thisThing.setState({ sendButtonTitle: sendButton + " - " + t });
	            },
	            didStartChoosingPrice: this.didStartChoosingPrice, didEndChoosingPrice: this.didEndChoosingPrice
	          }, priceChooserProps)),
	          React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	          React.createElement(
	            ReUpText,
	            { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	            whoToSendStatement
	          ),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            key: 'email', ref: 'email',
	            autoCapitalize: 'none',
	            keyboardType: 'email-address',
	            onChangeText: this.emailChanged,
	            placeholder: emailLabel,
	            isInError: this.state.emailError,
	            style: [styles.textField, { margin: 10, marginTop: 0 }] }),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            key: 'name', ref: 'name',
	            autoCapitalize: 'words',
	            onChangeText: this.nameChanged,
	            placeholder: nameLabel,
	            isInError: this.state.nameError,
	            style: [styles.textField, { margin: 10, marginTop: 0 }] }),
	          React.createElement(ReUpField, {
	            appManager: appManager,
	            key: 'message', ref: 'message',
	            onChangeText: this.messageChanged,
	            placeholder: messageLabel,
	            isInError: false,
	            style: [_defineProperty({ margin: 10, marginTop: 0, borderWidth: 0, borderColor: generalTitleColor, borderBottomWidth: 0,
	              flex: 1,
	              width: -1,
	              height: 22 + Math.max(1, this.state.numMessageLines) * 30
	            }, 'marginTop', 0)],
	            numberOfLines: 3,
	            multiline: true }),
	          React.createElement(
	            ReUpText,
	            { appManager: typeof appManager === 'undefined' ? null : appManager, style: [{ position: 'absolute', margin: 10, borderWidth: 0, borderColor: generalTitleColor, borderBottomWidth: 0,
	                flex: 1,
	                width: -1,
	                marginTop: 10, fontFamily: 'Arial', padding: 2, opacity: 0 }], onLayout: function onLayout(evt) {
	                var numMessageLines = parseInt(evt.nativeEvent.layout.height) / 29;thisThing.setState({ numMessageLines: numMessageLines });
	              } },
	            this.state.message
	          ),
	          React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: this.state.sendButtonTitle,
	            onPress: this.submitPressed })
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    margin: 10,
	    alignItems: 'center',
	    marginLeft: 20,
	    marginRight: 20,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    fontSize: 26,
	    padding: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    padding: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    fontSize: 30,
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    flex: 1,
	    width: -1,
	    height: 50,
	    marginTop: 10
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    margin: 8,
	    marginTop: 0
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginRight: 10, marginLeft: 10, marginBottom: 10
	  },
	
	  segmentContainer: {
	    height: 50,
	    padding: 4,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	SendCredit.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn || typeof ModelConstants === 'undefined') return [];else {
	    var user = appManager.currentUser();
	    var credit = user[ModelConstants.Credits];
	    if (credit < 20) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("SendCredit");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	SendCredit.dataDependencies = ["Users"];
	
	module.exports = SendCredit;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var ReUpScrollView = __webpack_require__(16);
	var ShadowView = __webpack_require__(20);
	var PriceChooserView = __webpack_require__(150);
	var PaymentMethodChooserView = __webpack_require__(94);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton;
	
	
	var MKSegmentControl = __webpack_require__(36);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpField = __webpack_require__(26);
	var ReUpText = __webpack_require__(8);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var SendGiftCard = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      initialLayout: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var sendButtonStr = locManager.localizedStringForKey("SEND_BUTTON", "Send");
	    return {
	      layout: this.props.initialLayout,
	      message: "",
	      numMessageLines: 1,
	      messageHeight: 50,
	      sendButton: "Send", //TODO:localize
	      emailError: false,
	      nameError: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  setScrollOffset: function setScrollOffset(yOffset) {
	    var thisThing = this;
	    setTimeout(function () {
	      var minScrollOffset = 0;
	      var keyboardOffset = typeof thisThing.refs.ptr !== 'undefined' ? thisThing.refs.ptr._keyboardOffset : 0;
	      var maxScrollOffset = thisThing._contentHeight - (thisThing._scrollViewHeight - keyboardOffset);
	      var normalizedScroll = Math.max(minScrollOffset, Math.min(maxScrollOffset, yOffset));
	
	      thisThing.refs.ptr.scrollTo(0, normalizedScroll);
	    }, 800);
	  },
	
	  _email: "",
	  _emailHasBeenValid: false,
	  emailChanged: function emailChanged(email) {
	    this._email = email;
	    var emailValid = this.props.appManager.isValidEmail(email);
	    if (this._emailHasBeenValid && !emailValid && !this.state.emailError) {
	      this.setState({ emailError: true });
	    }
	
	    if (emailValid) {
	      this._emailHasBeenValid = true;
	      if (this.state.emailError) {
	        this.setState({ emailError: false });
	      }
	    }
	  },
	
	  _name: "",
	  _nameHasSucceeded: false,
	  nameChanged: function nameChanged(text) {
	    this._name = text;
	    var nameError = !this.props.appManager.isNameValid(this._name);
	    if (nameError != this.state.nameError && this._nameHasSucceeded) {
	      this.setState({ nameError: nameError });
	    }
	
	    if (!nameError) this._nameHasSucceeded = true;
	  },
	
	  _message: "",
	  messageChanged: function messageChanged(message) {
	    this._message = message;
	    this.setState({ message: message });
	  },
	
	  submitPressed: function submitPressed() {
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = this.props.appManager.currentUser();
	    var nameIsValid = this.props.appManager.isNameValid(this._name);
	    if (!this.props.appManager.isValidEmail(this._email)) {
	      this.setState({ emailError: true });
	      appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	        thisThing.refs.email.focus();
	      }], function () {});
	    } else if (!nameIsValid) // name error
	      {
	        this.setState({ nameError: true });
	        var theirFirstLastNameError = locManager.localizedStringForKey("THEIR_NAME_EMPTY_FAIL_ALERT_BODY", "Please enter recipient's first and last name.");
	        appActions.showLocalizedAlert("NAME_EMPTY_FAIL_ALERT_TITLE", theirFirstLastNameError, ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	          thisThing.refs.name.focus();
	        }], function () {});
	      } else if (this.refs.paymentMethod.getPrimaryPaymentMethod() == null) {
	      appActions.showLocalizedAlert("SET_PRIMARY_ERROR_ALERT_TITLE", "SET_PRIMARY_ERROR_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	        appActions.hideAlert();
	        appActions.requestFeatureName("PaymentTypes", { shouldPopAfterSelectingPaymentType: true });
	      }], function () {});
	    } else {
	      var email = this._email;
	      var message = this._message;
	      var amount = this.refs.PriceChooserView.getAmount();
	      var thisThing = this;
	      var confirmTitle = locManager.localizedStringForKey("CONFIRM_ALERT_TITLE", "Confirmation");
	      var confirmBody = locManager.localizedStringForKeyAndParams("SEND_CREDIT_CONFIRMATION_BODY", [locManager.localizedDollars(amount), thisThing._name, email], "Would you like to send %0% to %1% (%2%)?");
	      var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON");
	      var noButton = locManager.localizedStringForKey("NO_ALERT_BUTTON");
	      appActions.setSpinnerShown(false);
	      appActions.showAlert(confirmTitle, confirmBody, [noButton, yesButton], [function () {
	        appActions.hideAlert();
	      }, function () {
	        appActions.hideAlert();thisThing.send(amount, email, message);
	      }]);
	    }
	  },
	
	  send: function send(amount, email, message) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	    var processingHUD = locManager.localizedStringForKey("PAYING_HUD");
	
	    var _appManager$parseName = appManager.parseName(this._name),
	        firstName = _appManager$parseName.firstName,
	        lastName = _appManager$parseName.lastName;
	
	    var paymentMethod = this.refs.paymentMethod.getPrimaryPaymentMethod();
	    appActions.setSpinnerShown(true, processingHUD);
	    NetworkManager.sendGiftCard(appManager, amount, email, message, firstName, lastName, paymentMethod, function (data) {
	      appActions.setSpinnerShown(false);
	      var sendSuccess = locManager.localizedStringForKey("SEND_GC_SUCCESS_ALERT_TITLE", "Success!");
	      var creditSent = locManager.localizedStringForKey("SEND_GC_SUCCESS_ALERT_BODY", "Your gift card has been sent.");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appActions.showAlert(sendSuccess, creditSent, [okayText], [function () {
	        appActions.requestPop(false);appActions.hideAlert();
	      }]);
	    }, function (data) {
	      var sendFailedTitle = locManager.localizedStringForKey("SEND_GC_FAIL_ALERT_TITLE", "Transaction Failed!");
	      var sendFailedBody = locManager.localizedStringForKey("SEND_GC_FAIL_ALERT_BODY", "Your gift card could not be sent.");
	      var okayText = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      appActions.setSpinnerShown(false);
	      appActions.showAlert(sendFailedTitle, sendFailedBody, [okayText]);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	  },
	
	  didUpdate: function didUpdate(data) {},
	
	  didStartChoosingPrice: function didStartChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(false);
	  },
	
	  didEndChoosingPrice: function didEndChoosingPrice() {
	    this.refs.ptr.setRefreshEnabled(true);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var howMuchCreditToSendStatement = locManager.localizedStringForKey("SEND_GC_AMOUNT_LABEL");
	    var howWouldYouLikeToPayStatement = locManager.localizedStringForKey("SEND_GC_METHOD_LABEL");
	    var whoToSendStatement = locManager.localizedStringForKey("SEND_GC_RECIPIENT_LABEL");
	    var emailLabel = locManager.localizedStringForKey("EMAIL_LABEL");
	    var messageLabel = locManager.localizedStringForKey("SEND_GC_MESSAGE_LABEL");
	    var sendButton = locManager.localizedStringForKey("SEND_BUTTON");
	    var priceChooserProps = {};
	    if (typeof this.props.featureData.choiceValue !== 'undefined') {
	      priceChooserProps.choiceValue = this.props.featureData.choiceValue;
	    }
	    if (typeof this.props.featureData.choiceIndex !== 'undefined') {
	      priceChooserProps.initialIndex = this.props.featureData.choiceIndex;
	    }
	
	    var nameLabel = locManager.localizedStringForKey("SEND_GC_NAME_LABEL");
	    var paymentInfo = appManager.getPaymentInfo();
	    var hasPrimaryPaymentMethod = false;
	    for (var i = 0; i < paymentInfo.length; i++) {
	      if (paymentInfo[i].isPrimary) {
	        hasPrimaryPaymentMethod = true;
	        break;
	      }
	    }
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, onLayout: function onLayout(event) {
	            return _this._scrollViewHeight = event.nativeEvent.layout.height;
	          } },
	        React.createElement(
	          View,
	          { onLayout: function onLayout(event) {
	              return _this._contentHeight = event.nativeEvent.layout.height;
	            } },
	          React.createElement(
	            View,
	            { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	            React.createElement(
	              View,
	              { style: { alignSelf: 'center' } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	                creditsLeftStatement
	              )
	            ),
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(ReUpIconButton, { type: 3,
	              appManager: appManager,
	              featureData: this.props.featureData,
	              appActions: appActions
	            })
	          ),
	          React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	          !hasPrimaryPaymentMethod ? React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	              locManager.localizedStringForKey("SEND_GIFT_CARD_INSTRUCTION")
	            ),
	            React.createElement(PaymentMethodChooserView, Object.assign({ ref: "paymentMethod", style: [styles.paymentMethodContainer, { marginBottom: 10 }], appManager: this.props.appManager, appActions: this.props.appActions,
	              initialLayout: this.state.layout, paymentInfo: paymentInfo }, priceChooserProps))
	          ) : React.createElement(
	            View,
	            null,
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	              howMuchCreditToSendStatement
	            ),
	            React.createElement(PriceChooserView, Object.assign({ ref: "PriceChooserView", style: [styles.choicesContainer, { marginBottom: 10 }], appManager: this.props.appManager,
	              initialLayout: this.state.layout, didChangeValueAndText: function didChangeValueAndText(v, t) {
	                return thisThing.setState({ sendButtonTitle: sendButton + " - " + t });
	              },
	              didStartChoosingPrice: this.didStartChoosingPrice, didEndChoosingPrice: this.didEndChoosingPrice
	            }, priceChooserProps)),
	            React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	              howWouldYouLikeToPayStatement
	            ),
	            React.createElement(PaymentMethodChooserView, Object.assign({ ref: "paymentMethod", style: [styles.paymentMethodContainer, { marginBottom: 10 }], appManager: this.props.appManager, appActions: this.props.appActions,
	              initialLayout: this.state.layout, paymentInfo: paymentInfo }, priceChooserProps)),
	            React.createElement(
	              View,
	              { style: { flexDirection: 'column', alignItems: 'stretch' } },
	              React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [styles.bodyText, { color: generalTitleColor }] },
	                whoToSendStatement
	              ),
	              React.createElement(ReUpField, {
	                appManager: appManager,
	                key: 'email', ref: 'email',
	                autoCapitalize: 'none',
	                keyboardType: 'email-address',
	                onChangeText: this.emailChanged,
	                placeholder: emailLabel,
	                isInError: this.state.emailError,
	                style: [styles.textField, { margin: 10, marginTop: 0 }],
	                onFocus: function onFocus() {
	                  return _this.setScrollOffset(100);
	                },
	                returnKeyType: 'next',
	                onSubmitEditing: function onSubmitEditing() {
	                  thisThing.refs.name.focus();
	                } }),
	              React.createElement(ReUpField, {
	                appManager: appManager,
	                key: 'name', ref: 'name',
	                autoCapitalize: 'words',
	                onChangeText: this.nameChanged,
	                placeholder: nameLabel,
	                isInError: this.state.nameError,
	                style: [styles.textField, { margin: 10, marginTop: 0 }],
	                onFocus: function onFocus() {
	                  return _this.setScrollOffset(220);
	                },
	                returnKeyType: 'next',
	                onSubmitEditing: function onSubmitEditing() {
	                  thisThing.refs.message.focus();
	                } }),
	              React.createElement(ReUpField, {
	                appManager: appManager,
	                key: 'message', ref: 'message',
	                onChangeText: this.messageChanged,
	                placeholder: messageLabel,
	                isInError: false,
	                style: [{
	                  margin: 10,
	                  borderWidth: 0,
	                  borderColor: generalTitleColor,
	                  borderBottomWidth: 0,
	                  height: Math.max(55, this.state.messageHeight),
	                  marginTop: 0
	                }],
	                numberOfLines: 3,
	                multiline: true,
	                onLayout: function onLayout(evt) {
	                  console.log("fieldheight", evt.nativeEvent.layout.height);
	                },
	                onFocus: function onFocus() {
	                  return _this.setScrollOffset(500);
	                },
	                onSubmitEditing: this.submitPressed }),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{
	                    position: 'absolute',
	                    borderWidth: 0,
	                    left: 0,
	                    right: 0,
	                    padding: 9,
	                    opacity: 0,
	                    margin: 10,
	                    fontSize: 16, fontFamily: 'Arial'
	                  }],
	                  onLayout: function onLayout(evt) {
	                    thisThing.setState({ messageHeight: evt.nativeEvent.layout.height + 5 });
	                  } },
	                this.state.message
	              ),
	              React.createElement(ReUpButton, { appManager: appManager, style: [styles.doneButton], text: this.state.sendButtonTitle,
	                onPress: this.submitPressed })
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	
	  // meter
	
	  meterContainer: {
	    margin: 10,
	    height: 20,
	    borderRadius: 10,
	    flexDirection: 'row'
	  },
	  meterFiller: {
	    margin: 1,
	    height: 18,
	    borderRadius: 9
	  },
	  meterAntiFiller: {
	    height: 18,
	    borderRadius: 9
	  },
	
	  // body
	
	  bodyText: {
	    margin: 10,
	    textAlign: 'left'
	
	  },
	
	  alertTitle: {
	    margin: 4,
	    textAlign: 'center'
	  },
	
	  // Payments
	
	  paymentMethodContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 60,
	    flex: 1,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	
	  // choices
	
	  choicesContainer: {
	    flexDirection: 'row',
	    marginTop: 0,
	    marginBottom: 0,
	    marginLeft: 0,
	    marginRight: 0,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  choiceButton: {
	    justifyContent: 'center',
	    flex: 1,
	    height: 40
	  },
	
	  // credit card
	  oldCardContainer: {
	    flexDirection: 'row',
	    margin: 10,
	    alignItems: 'center',
	    marginLeft: 20,
	    marginRight: 20,
	    justifyContent: 'center'
	  },
	  creditCardIcon: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center',
	    fontSize: 26,
	    padding: 4,
	    opacity: .6
	  },
	  creditCardText: {
	    fontStyle: 'italic',
	    padding: 4,
	    flex: 1,
	    textAlign: 'center',
	    opacity: .6
	  },
	  creditCardEditButton: {
	    padding: 4
	  },
	  creditCardEditButtonIcon: {
	    fontSize: 30,
	    backgroundColor: 'transparent'
	  },
	
	  // new card
	  cardNumberContainer: {
	    flexDirection: 'row',
	    margin: 8,
	    marginTop: 0
	  },
	
	  textField: {
	    width: -1,
	    height: 50
	  },
	
	  dateContainer: {
	    flexDirection: 'row',
	    alignItems: 'flex-end',
	    margin: 8,
	    marginTop: 0
	  },
	  dateField: {
	    flex: -1,
	    width: 40,
	    textAlign: 'center'
	  },
	  cvvField: {
	    flex: -1,
	    width: 80,
	    textAlign: 'center'
	  },
	  dateSlash: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    alignSelf: 'flex-end',
	    textAlign: 'center'
	  },
	
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginRight: 10, marginLeft: 10, marginBottom: 10
	  },
	
	  segmentContainer: {
	    height: 50,
	    padding: 4,
	    flex: 1,
	    alignSelf: 'center'
	  }
	});
	
	SendGiftCard.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	
	  if (!isLoggedIn || typeof ModelConstants === 'undefined') return [];else {
	    var user = appManager.currentUser();
	    var credit = user[ModelConstants.Credits];
	    if (credit < 20) return [];
	
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("SendGiftCard");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: featureData.data.tip,
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 0
	    }];
	  }
	};
	
	SendGiftCard.dataDependencies = ["Users"];
	
	module.exports = SendGiftCard;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(114);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var PlatformConstants = __webpack_require__(31);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var LinkingManager = __webpack_require__(27);
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	
	
	var FBSDK = __webpack_require__(152);
	var LoginManager = FBSDK.LoginManager,
	    AccessToken = FBSDK.AccessToken;
	
	
	var FeedCard = __webpack_require__(41);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var RNFS = __webpack_require__(96);
	
	
	var Settings = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      user: this.props.appManager.currentUser(),
	      showPassword: false,
	      selfieURL: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var settings = this;
	    this.props.appManager.getCurrentUser(function (user) {
	      settings.props.appManager.getSelfie(function (selfieURL) {
	        settings.setState({ user: user, selfieURL: selfieURL });
	      });
	    });
	  },
	
	  logoutPressed: function logoutPressed() {
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    appActions.setSpinnerShown(true, "Logging out...");
	    this.props.appManager.logout(function () {
	      appActions.setSpinnerShown(false);
	      appActions.requestPop();
	    });
	  },
	
	  _camera: null,
	  _canCapture: false,
	  cameraDidLoad: function cameraDidLoad(camera) {
	    if (!camera) return;
	    this._canCapture = true;
	    this._camera = camera;
	  },
	
	  takePicture: function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var appManager, thisThing, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(this._camera && this._canCapture)) {
	                _context.next = 14;
	                break;
	              }
	
	              this._canCapture = false;
	              _context.prev = 2;
	              appManager = this.props.appManager;
	              thisThing = this;
	              _context.next = 7;
	              return this._camera.capture({ target: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk, mode: _reactNativeCameraWrapper2.default.constants.CaptureMode.still, type: _reactNativeCameraWrapper2.default.constants.Type.front, quality: 'medium' });
	
	            case 7:
	              data = _context.sent;
	
	              // console.log(data);
	              appManager.setSelfie(data, function () {
	                // console.log("did set selfie")
	                appManager.getSelfie(function (selfieURL) {
	                  // console.log("did get selfie with url" + selfieURL)
	                  thisThing.props.appActions.hideAlert();
	                  thisThing.setState({ selfieURL: selfieURL });
	                  thisThing.props.appManager._eventEmitter.emit("checkUserChanged", {});
	                });
	              });
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](2);
	
	              console.error(_context.t0);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[2, 11]]);
	    }));
	
	    function takePicture() {
	      return _ref.apply(this, arguments);
	    }
	
	    return takePicture;
	  }(),
	
	  didUpdate: function didUpdate() {},
	
	  profilePicSelected: function profilePicSelected() {
	    if (Platform.OS === 'ios') {
	      var thisThing = this;
	      var appActions = this.props.appActions;
	      _reactNativeCameraWrapper2.default.checkVideoAuthorizationStatus().then(function (hasPermission) {
	        if (hasPermission) {
	          thisThing.showCamera();
	        } else {
	          appActions.showAlert("Camera Permission Required", "You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.", ["Okay"], [function () {
	            appActions.hideAlert();
	          }]);
	        }
	      });
	    } else {
	      this.showCamera();
	    }
	  },
	
	  showCamera: function showCamera() {
	    var _React$createElement, _React$createElement2;
	
	    var cameraDim = Math.min(this.state.layout.width, this.state.layout.height) - 20;
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	
	    var customAlert = Platform.OS === 'ios' ? React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        _reactNativeCameraWrapper2.default,
	        { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'flex-end', padding: 10 },
	          captureAudio: false,
	          captureQuality: "medium",
	          captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	          type: _reactNativeCameraWrapper2.default.constants.Type.front,
	          aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill },
	        React.createElement(ReUpIconButton, (_React$createElement = { iconName: "camera", type: 1, style: { margin: 10 },
	          appManager: appManager
	        }, _defineProperty(_React$createElement, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement, 'onPress', function onPress() {
	          thisThing.takePicture();
	        }), _React$createElement))
	      )
	    ) : React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0, paddingBottom: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(_reactNativeCameraWrapper2.default, { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'flex-end', padding: 10, marginBottom: 10 },
	        captureAudio: false,
	        aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill,
	        captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	        captureQuality: "medium",
	        type: _reactNativeCameraWrapper2.default.constants.Type.front,
	        orientation: _reactNativeCameraWrapper2.default.constants.Orientation.portrait }),
	      React.createElement(ReUpIconButton, (_React$createElement2 = { iconName: "camera", type: 1, style: { margin: 10 },
	        appManager: appManager
	      }, _defineProperty(_React$createElement2, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement2, 'onPress', function onPress() {
	        thisThing.takePicture();
	      }), _React$createElement2))
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  changePasswordPressed: function changePasswordPressed() {
	    this._showPassword = false;
	    this._currentPassword = "";
	    this._newPassword = "";
	    this._currentPasswordError = false;
	    this._newPasswordError = false;
	
	    this.showChangePass();
	  },
	
	  _showPassword: false,
	  _currentPassword: "",
	  _newPassword: "",
	  _currentPasswordError: false,
	  _newPasswordError: false,
	  showChangePass: function showChangePass() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locManager = thisThing.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	
	    var locMan = appManager.getLocalizationManager();
	    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	    var newPassDescription = locMan.localizedStringForKey("CHANGE_PASSWORD_LABEL");
	    var passPlaceholder = locMan.localizedStringForKey("CURRENT_PASSWORD_PLACEHOLDER");
	    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
	    var currPass = appManager.currentUser()[ModelConstants.Password];
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column' } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { marginTop: 10, textAlign: 'center' } },
	          newPassDescription
	        ),
	        React.createElement(ReUpField, { appManager: appManager,
	          key: 'oldPassword',
	          tintColor: bannerColor,
	          highlightColor: bannerColor,
	          onChangeText: function onChangeText(text) {
	            _this._currentPassword = text;
	          },
	          placeholder: passPlaceholder,
	          secureTextEntry: true }),
	        React.createElement(
	          View,
	          { style: styles.passwordContainer },
	          React.createElement(ReUpField, {
	            onChangeText: function onChangeText(text) {
	              _this._newPassword = text;
	            },
	            key: 'password',
	            ref: function ref(a) {
	              return thisThing._passwordField = a;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            appManager: appManager,
	            placeholder: newPassPlaceholder,
	            secureTextEntry: !this._showPassword,
	            style: [{ flex: 1, alignSelf: 'center', height: 50 }] }),
	          React.createElement(
	            MKIconToggle,
	            {
	              style: { marginTop: 22, height: 30, width: 30, position: 'absolute', right: 0, backgroundColor: 'transparent' },
	              checked: this._showPassword,
	              onCheckedChange: function onCheckedChange(info) {
	                thisThing._passwordField.onBlur();
	                thisThing._showPassword = info.checked;
	                thisThing.showChangePass();
	              }
	            },
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	          )
	        ),
	        React.createElement(ReUpButton, { onPress: function onPress() {
	            if (currPass != thisThing._currentPassword) {
	              var title = locManager.localizedStringForKey("ERROR_FAIL_ALERT_TITLE");
	              var body = locManager.localizedStringForKey("PASSWORD_INCORRECT_BODY");
	              var button = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	              appActions.showAlert(title, body, [button], [thisThing.showChangePass], function () {});
	            } else if (appManager.isValidPassword(thisThing._newPassword)) {
	              thisThing.changePassword(thisThing._newPassword);
	            } else {
	              appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [thisThing.showChangePass], function () {});
	            }
	          }, appManager: this.props.appManager, text: changePasswordButton, style: [styles.logoutButton, { marginTop: 10, marginBottom: 10 }] })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  changePassword: function changePassword(newPass) {
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var locMan = appManager.getLocalizationManager();
	    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
	    thisThing.props.appActions.setSpinnerShown(true, changingPassword);
	    NetworkManager.changePassword(this.props.appManager, newPass, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var user = appManager.getCurrentUser(function (currentUser) {
	        currentUser[ModelConstants.Password] = newPass;
	        appManager.setCurrentUser(currentUser, function () {
	          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
	          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
	          var okayButton = locMan.localizedStringForKey("VERSION_OKAY_ALERT_OPTION");
	
	          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function () {
	            thisThing.props.appActions.hideAlert();
	          }], function () {});
	        });
	      });
	    }, function (data) {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
	      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
	      var okayButton = locMan.localizedStringForKey("OKAY_ALERT_OPTION");
	
	      thisThing.props.appActions.showAlert(title, body, [okayButton], [function () {
	        thisThing.showChangePass();
	      }], function () {});
	    }, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      thisThing.props.appActions.showNetworkErrorAlert(function () {
	        thisThing.showChangePass();
	      }, function () {});
	    });
	  },
	
	  contactSupport: function contactSupport() {
	    var email = this.props.appManager.getSupportEmail();
	    var platform = Platform.OS;
	    if (platform == "android") platform = "Android";
	    var subject = this.props.appManager.appNameLong + " Support";
	    var body = "Hi, my email is " + this.props.appManager.currentUser()[ModelConstants.UserName] + " and I am on " + platform + ". I am having an issue with...";
	    var url = "mailto:" + encodeURI(email) + "?subject=" + encodeURI(subject) + "&body=" + encodeURI(body);
	    LinkingManager.canOpenURL(url, function (can) {
	      if (can) {
	        LinkingManager.openURL(url);
	      }
	    });
	  },
	
	  loginFacebookPressed: function loginFacebookPressed() {
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    appActions.setSpinnerShown(true);
	    LoginManager.logInWithReadPermissions(['email', 'public_profile']).then(function (result) {
	      if (result.isCancelled) {
	        console.log("Facebook cancelled");
	        appActions.setSpinnerShown(false);
	      } else {
	        AccessToken.getCurrentAccessToken().then(function (data) {
	          var password = data.accessToken.toString();
	          NetworkManager.createUserFacebook(appManager, password, "", true, function (email) {
	            NetworkManager.login(appManager, email, password, function (data) {
	              data[ModelConstants.Password] = password;
	              appManager.setCurrentUser(data, function () {
	                appActions.setSpinnerShown(false);
	              });
	            }, function () {
	              appActions.setSpinnerShown(false);
	            }, function () {
	              appActions.setSpinnerShown(false);
	            });
	          }, function () {
	            appActions.setSpinnerShown(false);
	          });
	        });
	      }
	    }, function (error) {
	      appActions.setSpinnerShown(false);
	      console.log('Login fail with error: ' + error);
	    });
	  },
	
	  joinGroupPressed: function joinGroupPressed() {
	    this._groupCodeError = false;
	    this._groupCode = "";
	
	    this.showJoinGroup();
	  },
	
	  _groupCodeError: false,
	  _groupCode: "",
	  showJoinGroup: function showJoinGroup() {
	    var _this2 = this;
	
	    var locMan = this.props.appManager.getLocalizationManager();
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var user = appManager.currentUser();
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	          locMan.localizedStringForKey("JOIN_GROUP_ALERT_TITLE", "Enter Your Group Code")
	        ),
	        React.createElement(
	          View,
	          { style: {
	              paddingTop: 4,
	              paddingLeft: 20,
	              paddingRight: 20,
	              alignItems: 'center',
	              justifyContent: 'center',
	              flexDirection: 'row'
	            } },
	          React.createElement(ReUpField, {
	            key: 'groupcode',
	            ref: function ref(a) {
	              return _this2._groupCodeField = a;
	            },
	            appManager: appManager,
	            onChangeText: function onChangeText(text) {
	              thisThing._groupCode = text;
	              if (thisThing._groupCodeError) {
	                thisThing._groupCodeError = false;
	                thisThing.showJoinGroup();
	              }
	            },
	            autoCorrect: false,
	            isInError: this._groupCodeError,
	            defaultValue: this._groupCode,
	            useGeneric: true,
	            autoCapitalize: 'none',
	            onSubmitEditing: this.submitGroupRequest,
	            placeholder: this._groupCodeError ? locMan.localizedStringForKey("GROUP_CODE_ERROR_PLACEHOLDER", "invalid group code") : locMan.localizedStringForKey("GROUP_CODE_PLACEHOLDER", "group code"),
	            style: {
	              width: 180,
	              height: 50,
	              marginTop: 10
	            } })
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', marginTop: 4 } },
	          React.createElement(ReUpButton, { onPress: this.submitGroupRequest, appManager: appManager, text: locMan.localizedStringForKey("JOIN_GROUP_BUTTON", "Join Group"), style: [{ margin: 10, flex: 1 }] })
	        )
	      )
	    );
	
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  submitGroupRequest: function submitGroupRequest() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var user = appManager.currentUser();
	    var locMan = appManager.getLocalizationManager();
	    var thisThing = this;
	
	    appActions.hideAlert();
	    appActions.setSpinnerShown(true);
	    NetworkManager.joinGroup(appManager, thisThing._groupCode, function () {
	      NetworkManager.login(appManager, user[ModelConstants.UserName], user[ModelConstants.Password], function (updatedUser) {
	        appActions.setSpinnerShown(false);
	        updatedUser[ModelConstants.Password] = user[ModelConstants.Password];
	        appManager.setCurrentUser(updatedUser, function () {
	          thisThing.forceUpdate();
	          appActions.showLocalizedAlert(locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"), locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"), ["OK_ALERT_BUTTON"], [appActions.hideAlert], function () {});
	        });
	      }, function () {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert(locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"), locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"), ["OK_ALERT_BUTTON"], [appActions.hideAlert], function () {});
	      }, function () {
	        appActions.setSpinnerShown(false);
	        appActions.showLocalizedAlert(locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_TITLE", "Joined Group"), locMan.localizedStringForKey("JOIN_GROUP_SUCCESS_ALERT_BODY", "You successfully joined the group!"), ["OK_ALERT_BUTTON"], [appActions.hideAlert], function () {});
	      });
	    }, function () {
	      appActions.setSpinnerShown(false);
	      thisThing._groupCodeError = true;
	      thisThing.showJoinGroup();
	      thisThing._groupCodeField.setIsInError(true);
	    }, function () {
	      appActions.setSpinnerShown(false);
	      thisThing._groupCodeError = true;
	      thisThing.showJoinGroup();
	      thisThing._groupCodeField.setIsInError(true);
	    });
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var feedFeatureData = appManager.getFeatureForName("Feed");
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	
	    if (this.state.user == null || !this.props.appManager.isLoggedIn()) // early return if we dont have the user yet
	      {
	        return React.createElement(
	          View,
	          { style: styles.container },
	          React.createElement(Image, {
	            style: [styles.image, { width: this.state.layout.width, height: this.state.layout.height }],
	            source: { uri: bgImage }
	          })
	        );
	      }
	
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var logoutButton = locManager.localizedStringForKey("LOGOUT_BUTTON");
	
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);
	
	    var user = this.state.user;
	    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
	    var email = user[ModelConstants.UserName];
	    var initials = appManager.currentUserInitials();
	    var paymentInfo = appManager.getPaymentInfo();
	
	    var profileImageName = appManager.absoluteResourceForPath("Feed/feed_profile_placeholder_admin.png");
	
	    var paymentInfoFeature = appManager.getFeatureForName('PaymentTypes');
	    var transactionHistoryFeature = appManager.getFeatureForName('TransactionHistory');
	
	    var tutorialFeature = appManager.getFeatureForName("Tutorial");
	    var showTutorial = typeof tutorialFeature !== 'undefined'; // && tutorialFeature.data.tutorialImages != "TUTORIAL_IMAGE_LIST";
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(Image, {
	        key: appManager.getImageKey("settingsbg"),
	        resizeMode: 'cover',
	        style: { position: 'absolute', top: 0, left: 0, bottom: 0, right: 0 },
	        source: { uri: bgImage }
	      }),
	      React.createElement(
	        ReUpScrollView,
	        { bounces: true, responder: this },
	        React.createElement(FeedCard, { settingsFeatureData: this.props.featureData,
	          loggedInAsName: userFullName,
	          loggedInAsEmail: email,
	          logoutText: logoutButton,
	          profileImage: profileImageName,
	          cardType: 3,
	          iconColor: bannerIconColor,
	          bannerColor: bannerColor,
	          cardColor: cardColor,
	          titleColor: titleColor,
	          bodyColor: bodyColor,
	          appManager: appManager,
	          profilePicSelected: this.profilePicSelected,
	          selfieURL: this.state.selfieURL
	        }),
	        typeof transactionHistoryFeature !== 'undefined' && transactionHistoryFeature != null ? React.createElement(FeedCard, { cardType: 9,
	          iconColor: bannerIconColor,
	          bannerColor: bannerColor,
	          cardColor: cardColor,
	          titleColor: titleColor,
	          bodyColor: bodyColor,
	          appManager: appManager,
	          transactionHistoryFeatureData: transactionHistoryFeature.data,
	          changePasswordPressed: this.changePasswordPressed,
	          appActions: appActions,
	          paymentInfo: paymentInfo,
	          loginFacebookPressed: this.loginFacebookPressed,
	          joinGroupPressed: this.joinGroupPressed }) : null,
	        showTutorial ? React.createElement(FeedCard, { cardType: 10,
	          iconColor: bannerIconColor,
	          bannerColor: bannerColor,
	          cardColor: cardColor,
	          titleColor: titleColor,
	          bodyColor: bodyColor,
	          appManager: appManager,
	          tutorialFeatureData: tutorialFeature.data,
	          contactSupport: this.contactSupport,
	          appActions: appActions }) : null,
	        React.createElement(
	          View,
	          { style: [styles.profileBottomContainer, { paddingTop: 0, marginTop: 4, paddingBottom: 10, paddingLeft: 4, paddingRight: 4 }] },
	          React.createElement(ReUpButton, {
	            isSecondary: true,
	            style: [styles.logoutButton],
	            appManager: appManager,
	            text: locManager.localizedStringForKey("LOGOUT_BUTTON"),
	            onPress: this.logoutPressed })
	        ),
	        React.createElement(View, { style: { height: 20 } })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  image: {
	    position: 'absolute',
	    flex: 1
	  },
	  profileImage: {
	    height: 80,
	    width: 80,
	    borderRadius: 40,
	    borderWidth: 2,
	    borderColor: 'black',
	    justifyContent: 'center'
	  },
	  profileImageText: {
	    textAlign: 'center',
	    fontSize: 40,
	    fontWeight: 'bold',
	    backgroundColor: 'transparent'
	  },
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  profileBottomContainer: {
	    flexDirection: 'row',
	    alignItems: 'stretch',
	    justifyContent: 'center',
	    padding: 8
	  },
	  logoutButton: {
	    flex: 1
	  }
	});
	
	Settings.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var locManager = appManager.getLocalizationManager();
	  var isLoggedIn = appManager.isLoggedIn();
	  if (!isLoggedIn) return [];
	
	  var user = appManager.currentUser();
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var storeURL = Platform.OS === 'ios' ? user.AppStoreURL : user.PlayStoreURL;
	
	  var cards = [];
	
	  var TRANSACTION_COUNT_FOR_NOT_SHOWING_SELFIE = 2;
	  if (false) {
	    cards.push({
	      didSelect: function didSelect() {
	        appActions.requestFeatureName("Settings");
	      },
	      title: "Profile Selfie",
	      body1: "Head to " + featureData.data.title + " and tap on your initials circle to set your profile selfie!",
	      icon: iconName,
	      cardType: 0,
	      sortOrder: 4
	    });
	  }
	
	  var TRANSACTION_COUNT_FOR_RATING = 2;
	  if (isLoggedIn && typeof data.Transactions !== 'undefined' && data.Transactions.length >= TRANSACTION_COUNT_FOR_RATING && storeURL.length > 0) {
	    var sortOrder = 6;
	    var transactionIndexForSorting = data.Transactions.length - TRANSACTION_COUNT_FOR_RATING;
	    if (transactionIndexForSorting >= 0 && transactionIndexForSorting < data.Transactions.length) {
	      var transaction = data.Transactions[transactionIndexForSorting];
	      var date = transaction.Timestamp;
	      var thisDateTime = appManager.getTime(date);
	      sortOrder = new Date().getTime() - thisDateTime - 10;
	    }
	
	    cards.push({
	      didSelect: function didSelect() {
	        LinkingManager.openURL(storeURL);
	      },
	      title: locManager.localizedStringForKey("REVIEW_CARD_TITLE"),
	      body1: locManager.localizedStringForKey("REVIEW_CARD_BODY"),
	      icon: "smile-o",
	      cardType: 0,
	      sortOrder: sortOrder
	    });
	  }
	
	  return cards;
	};
	
	Settings.dataDependencies = ["Users", "Transactions"];
	
	module.exports = Settings;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1201);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var LinkingManager = __webpack_require__(27);
	var Animated = __webpack_require__(9);
	var ProgressOverlay = __webpack_require__(52);
	var NumericalInput = __webpack_require__(92);
	var ReUpScrollView = __webpack_require__(16);
	
	// import {CheckBox} from 'react-native-web';
	var createReactClass = __webpack_require__(5);
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet,
	    TextInput = ReactNative.TextInput,
	    Linking = ReactNative.Linking;
	
	
	var SimpleCFD = createReactClass({
	  displayName: 'SimpleCFD',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      hasValidPhone: false,
	      errorMessage: "",
	      isShowingPhone: true,
	      isShowingSuccess: false,
	      isShowingSpinner: false,
	
	      inputWidth: new Animated.Value(this.props.initialLayout.width / 3),
	      isShowingPhoneKeyboard: true,
	      thankYouOpacity: new Animated.Value(0),
	      inputOpacity: new Animated.Value(1),
	      showInput: true,
	      showThankYou: false,
	      showTextMe: false,
	      thankYouKey: "CHECK_MESSAGES_SIGNUP",
	      phoneNumber: "",
	      phoneLocales: [{ "Region": "CA", "Code": "1" }],
	      countryCode: ""
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._scrollView.doOnlineUpdate();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof newProps.initialLayout !== 'undefined') {
	      if (this._isShowingThankYou) {
	        this.setState({ inputWidth: new Animated.Value(this.props.initialLayout.width) });
	      } else {
	        this.setState({ inputWidth: new Animated.Value(this.props.initialLayout.width / 3) });
	      }
	    }
	  },
	
	  didUpdate: function didUpdate(data) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    this.props.appManager.getDataType("PhoneLocales", function (data) {
	      if (typeof data !== 'undefined' && data != null) {
	        thisThing.setState({ phoneLocales: data.reverse() });
	      }
	    });
	  },
	
	  resetRecaptcha: function resetRecaptcha() {
	    window.parent.postMessage({ resetRecaptchaToken: true }, '*');
	  },
	
	  textLink: function textLink() {
	    var _this = this;
	
	    this.setState({ isShowingSpinner: true });
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var phone = this.state.phoneNumber;
	    var countryCode = this.refs.phoneInput._phoneInput.getCountryCode();
	    var recaptchaToken = localStorage.getItem('recaptchaToken');
	    NetworkManager.createUserByPhone(appManager, phone, countryCode, recaptchaToken, function () {
	      _this.setState({ isShowingSpinner: false });
	      _this.resetRecaptcha();
	      thisThing.showThankYou();
	    }, function (error) {
	      thisThing.setState({ isShowingSpinner: false });
	      if (typeof error !== 'undefined' && error.code == -69) {
	        thisThing.setState({ thankYouKey: "CHECK_MESSAGES_LOGIN" });
	        thisThing.showThankYou();
	      } else {
	        thisThing.setState({ errorMessage: locManager.localizedStringForKey("INVALID_PHONE_ERROR", "Invalid phone number") });
	      }
	      _this.resetRecaptcha();
	    });
	  },
	
	  isHorizontal: function isHorizontal() {
	    return this.props.initialLayout.width > this.props.initialLayout.height;
	  },
	
	  _isShowingThankYou: false,
	  showThankYou: function showThankYou() {
	    if (this._isShowingThankYou) return;
	    this._isShowingThankYou = true;
	
	    if (this._showInputTimeout != null) {
	      clearTimeout(this._showInputTimeout);
	      this._showInputTimeout = null;
	    }
	
	    var thisThing = this;
	    this._showInputTimeout = setTimeout(function () {
	      thisThing.showNumberInput();
	    }, 20000);
	
	    Animated.timing(thisThing.state.inputOpacity, {
	      toValue: 0,
	      duration: 400
	    }).start(function () {
	      thisThing.setState({ showThankYou: true, showInput: false });
	      Animated.timing(thisThing.state.thankYouOpacity, {
	        toValue: 1,
	        duration: 400
	      }).start(function () {});
	    });
	
	    Animated.timing(thisThing.state.inputWidth, {
	      toValue: this.props.initialLayout.width,
	      duration: 800
	    }).start(function () {});
	  },
	
	  _showInputTimeout: null,
	  showNumberInput: function showNumberInput() {
	
	    if (!this._isShowingThankYou) return;
	    this._isShowingThankYou = false;
	
	    if (this._showInputTimeout != null) {
	      clearTimeout(this._showInputTimeout);
	      this._showInputTimeout = null;
	    }
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.thankYouOpacity, {
	      toValue: 0,
	      duration: 400
	    }).start(function () {
	      thisThing.setState({ thankYouKey: "CHECK_MESSAGES_SIGNUP", showThankYou: false, showInput: true, showTextMe: false });
	      Animated.timing(thisThing.state.inputOpacity, {
	        toValue: 1,
	        duration: 400
	      }).start(function () {});
	    });
	
	    Animated.timing(thisThing.state.inputWidth, {
	      toValue: this.props.initialLayout.width / 3,
	      duration: 800
	    }).start(function () {});
	  },
	
	  _phoneNumber: "",
	  hasValidPhone: function hasValidPhone(phoneNumber) {
	    if (typeof phoneNumber === 'undefined') phoneNumber = this.state.phoneNumber;
	
	    return phoneNumber.length > 1;
	  },
	
	  setPhoneNumber: function setPhoneNumber(phoneNumber) {
	    if (this.state.phoneNumber == phoneNumber) return;
	
	    this.setState({ phoneNumber: phoneNumber, showTextMe: this.hasValidPhone(phoneNumber), errorMessage: "" });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = appManager.getLocalizationManager();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var buttonPrimaryColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var isHorizontal = false; //this.isHorizontal();
	    if (isHorizontal) {
	      var backgroundImage = appManager.absoluteResourceForPath("Feed/background.png");
	      var iconImage = appManager.absoluteResourceForPath("App/iTunesArtwork.png");
	      var ratio = 230.0 / 170.0; // h / w
	      var maxWidth = this.props.initialLayout.width / 3 - 20;
	      var maxHeight = this.props.initialLayout.height - 170;
	      var inputWidth = maxWidth;
	      var inputHeight = Math.min(maxHeight, inputWidth * ratio);
	      // inputWidth = inputHeight / ratio;
	
	      var iconDim = this.props.initialLayout.height / 4;
	
	      return React.createElement(
	        View,
	        { style: { flexDirection: 'row', alignItems: 'stretch', backgroundColor: headerColor, height: this.props.initialLayout.height, width: this.props.initialLayout.width } },
	        React.createElement(
	          View,
	          { style: { flex: 2, flexDirection: 'column' } },
	          React.createElement(
	            View,
	            { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 } },
	            React.createElement(Image, { style: { width: '100%', height: this.props.initialLayout.height }, resizeMode: "cover", source: { uri: backgroundImage } })
	          ),
	          React.createElement(View, { style: { flex: 3 } }),
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(Image, { style: { width: iconDim, height: iconDim, borderRadius: iconDim / 10 }, resizeMode: "contain", source: { uri: iconImage } })
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: generalColor, textAlign: 'center', marginBottom: 10, fontSize: this.props.initialLayout.height / 10 } },
	              locManager.localizedStringForKey("EARN_POINTS_STATEMENT_4")
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: generalColor, textAlign: 'center', fontSize: this.props.initialLayout.height / 15 } },
	              locManager.localizedStringForKey("ON_EVERY_PURCHASE_STATEMENT")
	            )
	          ),
	          React.createElement(View, { style: { flex: 6 } })
	        ),
	        React.createElement(View, { style: { flex: 1 } }),
	        React.createElement(
	          Animated.View,
	          { style: { position: 'absolute', flexDirection: 'column', backgroundColor: profileColor, top: 0, bottom: 0, right: 0, width: this.state.inputWidth } },
	          this.state.showInput ? React.createElement(
	            Animated.View,
	            { style: { flex: 1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center', opacity: this.state.inputOpacity } },
	            React.createElement(
	              View,
	              { style: { height: inputHeight, width: inputWidth, backgroundColor: 'transparent', marginRight: 9 } },
	              React.createElement(NumericalInput, { ref: 'phoneInput',
	                style: { height: inputHeight, width: inputWidth },
	                isPhoneNumber: true,
	                appManager: this.props.appManager,
	                initialValue: "",
	                inputTextColor: profileTitleColor,
	                previewStyle: { fontFamily: 'Courier', fontSize: inputHeight / 15, color: profileTitleColor, borderColor: profileMeterColor },
	                valueChanged: function valueChanged(newValue, newStringValue) {
	                  var phoneNumber = thisThing.refs.phoneInput.strippedPhoneNumber(newValue);
	                  thisThing.setPhoneNumber(phoneNumber);
	                }
	              })
	            ),
	            React.createElement(
	              View,
	              { style: { height: inputHeight / 5, marginTop: 20, marginLeft: 2, alignSelf: 'center', alignItems: 'stretch', justifyContent: 'center' } },
	              this.state.showTextMe && this.state.errorMessage == "" ? React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { flex: 1, height: inputHeight / 5, width: inputWidth - 6 }, fontSize: this.props.initialLayout.height / 25, text: locManager.localizedStringForKey("TEXT_ME_BUTTON"),
	                onPress: function onPress() {
	                  thisThing.textLink();
	                } }) : React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center', fontSize: this.props.initialLayout.height / 40 } },
	                this.state.errorMessage
	              )
	            )
	          ) : null,
	          this.state.showThankYou ? React.createElement(
	            Animated.View,
	            { style: { flex: 1, alignSelf: 'stretch', margin: 20, justifyContent: 'stretch', backgroundColor: profileColor, opacity: this.state.thankYouOpacity } },
	            React.createElement(
	              View,
	              { style: { flexDirection: "column", justifyContent: "space-around", height: '100%' } },
	              React.createElement(
	                View,
	                { style: { flex: 1, justifyContent: "flex-end", alignSelf: 'center' } },
	                React.createElement(Image, { style: { width: iconDim / 2, height: iconDim / 2, borderRadius: iconDim / 10 }, resizeMode: "contain", source: { uri: iconImage } })
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isTitle: true, style: { flex: 0.15, alignSelf: 'center', color: profileTitleColor, textAlign: 'center', marginTop: 20, fontSize: "20px" } },
	                locManager.localizedStringForKey("THANKS_STATEMENT")
	              ),
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { flex: 1, alignSelf: 'center', color: profileTitleColor, textAlign: 'center', fontSize: "18px" } },
	                locManager.localizedStringForKey(this.state.thankYouKey)
	              )
	            )
	          ) : null
	        ),
	        this.state.isShowingSpinner ? React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.isShowingSpinner,
	          layout: this.props.initialLayout, appManager: appManager }) : null
	      );
	    }
	
	    var stripHeight = this.props.initialLayout.width * 123 / 375;
	
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	
	    var backgroundImage = appManager.absoluteResourceForPath("Feed/background.png");
	    var iconImage = appManager.absoluteResourceForPath("App/iTunesArtwork.png");
	    var ratio = 230.0 / 190.0; // h / w
	    var maxWidth = this.props.initialLayout.width - 20;
	    var maxHeight = this.props.initialLayout.height - stripHeight - 170;
	    var inputWidth = maxWidth;
	    var inputHeight = Math.min(maxHeight, inputWidth * ratio);
	    var privacyURL = locManager.localizedStringForKey("PRIVACY_URL");
	    var tacURL = appManager.getTermsLink();
	    var recaptchaLocale = appManager.getActiveLocale();
	    if (recaptchaLocale == '' || recaptchaLocale == null) {
	      recaptchaLocale = 'en';
	    } else {
	      recaptchaLocale = recaptchaLocale.substr(0, 2);
	    }
	    // inputWidth = inputHeight / ratio;
	
	    var iconDim = this.props.initialLayout.height / 4;
	
	    return React.createElement(
	      View,
	      { style: { flexDirection: 'row', alignItems: 'stretch', backgroundColor: profileColor, height: '100%', width: '100%' } },
	      React.createElement(
	        ReUpScrollView,
	        { ref: function ref(a) {
	            return _this2._scrollView = a;
	          }, responder: this },
	        this.state.showInput ? React.createElement(
	          Animated.View,
	          { style: { height: '100%', flex: -1, alignSelf: 'stretch', alignItems: 'center', justifyContent: 'center', opacity: this.state.inputOpacity } },
	          React.createElement(
	            View,
	            { style: { height: stripHeight, backgroundColor: headerIconColor, alignSelf: 'stretch' } },
	            React.createElement(Image, { style: { width: '100%', height: stripHeight }, resizeMode: "cover", source: { uri: stripImage } }),
	            React.createElement(
	              View,
	              { style: { position: 'absolute', top: 20, left: 20, right: 20, bottom: 20 } },
	              React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, flexDirection: 'column', backgroundColor: 'transparent', alignItems: 'stretch', paddingRight: 18, paddingLeft: 18, width: '100%' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { flex: 0, color: profileTitleColor, textAlign: 'center', paddingTop: 18, paddingBottom: 18 } },
	              locManager.localizedStringForKey("ENTER_PHONE_NUMBER_STATEMENT")
	            ),
	            React.createElement(NumericalInput, { ref: 'phoneInput',
	              style: { flex: 1, minHeight: 55 },
	              isPhoneNumber: true,
	              appManager: this.props.appManager,
	              initialValue: locManager.localizedStringForKey("PHONE_NUMBER"),
	              inputTextColor: profileTitleColor,
	              phoneLocales: this.state.phoneLocales,
	              isInError: this.state.errorMessage.length > 0,
	              previewStyle: { color: generalTitleColor, borderColor: profileMeterColor, paddingTop: 8, paddingBottom: 8 },
	              valueChanged: function valueChanged(newValue, newStringValue) {
	                var phoneNumber = thisThing.refs.phoneInput.strippedPhoneNumber(newValue);
	                thisThing.setPhoneNumber(phoneNumber);
	              }
	            }),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { color: appManager.getErrorColor(), textAlign: 'center', fontSize: "13px" } },
	              this.state.errorMessage
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: false, style: { flex: 0.25, color: profileTitleColor, opacity: 0.5, textAlign: 'center', marginTop: 18, marginBottom: 18, fontSize: "11px" } },
	              locManager.localizedStringForKey("SMS_WARNING_TEXT")
	            ),
	            React.createElement(
	              View,
	              { style: { flex: -1, justifyContent: 'center', backgroundColor: 'transparent', flexDirection: 'row' } },
	              React.createElement(
	                Text,
	                { onPress: function onPress() {
	                    Linking.openURL(privacyURL);
	                  }, appManager: appManager, isTitle: true, style: { color: profileMeterColor, fontSize: "10px", textAlign: 'center', padding: 18 } },
	                locManager.localizedStringForKey("PRIVACY_LABEL")
	              ),
	              React.createElement(
	                Text,
	                { onPress: function onPress() {
	                    Linking.openURL(tacURL);
	                  }, appManager: appManager, isTitle: true, style: { color: profileMeterColor, fontSize: "10px", textAlign: 'center', padding: 18 } },
	                locManager.localizedStringForKey("TAC_LABEL")
	              )
	            ),
	            React.createElement(View, { style: { flex: 2, justifyContent: 'flex-end' } }),
	            React.createElement(
	              View,
	              { style: { flex: 1, marginBottom: 18, alignSelf: 'stretch', alignItems: 'stretch', justifyContent: 'flex-end' } },
	              this.state.showTextMe && this.state.errorMessage == "" ? React.createElement(ReUpButton, { appManager: appManager, maskBorderRadius: 40, style: { minHeight: '60px', maxHeight: '60px', flex: 1 }, fontSize: 20, text: locManager.localizedStringForKey("CONTINUE_BUTTON"),
	                onPress: function onPress() {
	                  thisThing.textLink();
	                } }) : null
	            )
	          )
	        ) : null,
	        this.state.showThankYou ? React.createElement(
	          Animated.View,
	          { style: { flex: 1, alignSelf: 'stretch', margin: 20, justifyContent: 'stretch', backgroundColor: profileColor, opacity: this.state.thankYouOpacity } },
	          React.createElement(
	            View,
	            { style: { flexDirection: "column", justifyContent: "space-around", height: '100%' } },
	            React.createElement(
	              View,
	              { style: { flex: 1, justifyContent: "flex-end", alignSelf: 'center' } },
	              React.createElement(Image, { style: { width: iconDim / 2, height: iconDim / 2, borderRadius: iconDim / 10 }, resizeMode: "contain", source: { uri: iconImage } })
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, isTitle: true, style: { flex: 0.15, alignSelf: 'center', color: profileTitleColor, textAlign: 'center', marginTop: 20, fontSize: "20px" } },
	              locManager.localizedStringForKey("SENT_LINK")
	            ),
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { flex: 1, alignSelf: 'center', color: profileTitleColor, textAlign: 'center', fontSize: "18px" } },
	              locManager.localizedStringForKey(this.state.thankYouKey)
	            )
	          )
	        ) : null,
	        this.state.isShowingSpinner ? React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.isShowingSpinner,
	          layout: this.props.initialLayout, appManager: appManager }) : null
	      )
	    );
	
	    var phoneSeparators = ["(", ") ", " - "];
	
	    // return (
	    //   <View key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
	    //     style={{backgroundColor:headerColor, flexDirection:'column', flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}>
	    //     <View style={{height:30}}>
	    //     </View>
	    //     <View style={{height:stripHeight, backgroundColor:headerIconColor}}>
	    //       <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
	    //       <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
	    //         <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
	    //       </View>
	    //     </View>
	    //     <View style={{flexDirection:'column', alignItems:'center', marginTop:40, marginLeft:20, marginRight:20}}>
	    //       <ReUpText appManager={appManager} isTitle={true} style={{color:headerTitleColor, textAlign:'center', marginBottom:4}}>
	    //       {"Enter your phone number below to receive a login link."}
	    //       </ReUpText>
	    //     </View>
	    //     <View style={{flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
	    //       <View style={{alignItems:'center', justifyContent:'center', flex:1, flexDirection:'row'}}>
	    //         <ReUpText appManager={appManager} style={{marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[0]}</ReUpText>
	    //         <ReUpField
	    //           appManager={appManager}
	    //           ref={(a)=>{thisThing._phone1=a}}
	    //           key="phone1"
	    //           keyboardType={"phone-pad"}
	    //           onKeyPress={(event)=>
	    //           {
	    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone1")
	    //           }}
	    //           onChangeText={(text) =>
	    //           {
	    //             thisThing._phoneText1 = text;
	    //             var hasValidPhone = thisThing.hasValidPhone();
	    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //             if( text.length >= 3 ) thisThing._phone2.focus()
	    //             thisThing.setIsInError(false);
	    //           }}
	    //           placeholder={thisThing._phoneText1Placeholder}
	    //           maxLength={3}
	    //           isInError={this.state.isInError}
	    //           style={{flex:-1, width:45}}/>
	    //         <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
	    //         <ReUpField
	    //           appManager={appManager}
	    //           ref={(a)=>{thisThing._phone2=a}}
	    //           key="phone2"
	    //           keyboardType={"phone-pad"}
	    //           onKeyPress={(event)=>
	    //           {
	    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone2")
	    //           }}
	    //           onChangeText={(text) =>
	    //           {
	    //             thisThing._phoneText2 = text;
	    //             var hasValidPhone = thisThing.hasValidPhone();
	    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //             if( text.length >= 3 ) thisThing._phone3.focus()
	    //             thisThing.setIsInError(false);
	    //           }}
	    //           placeholder={thisThing._phoneText2Placeholder}
	    //           maxLength={3}
	    //           isInError={this.state.isInError}
	    //           style={{flex:-1, width:45}}/>
	    //         <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
	    //         <ReUpField
	    //           appManager={appManager}
	    //           ref={(a)=>{thisThing._phone3=a}}
	    //           key="phone3"
	    //           keyboardType={"phone-pad"}
	    //           onKeyPress={(event)=>
	    //           {
	    //             if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone3")
	    //           }}
	    //           onChangeText={(text) =>
	    //           {
	    //             thisThing._phoneText3 = text;
	    //             var hasValidPhone = thisThing.hasValidPhone();
	    //             if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //             thisThing.setIsInError(false);
	    //           }}
	    //           placeholder={thisThing._phoneText3Placeholder}
	    //           maxLength={4}
	    //           isInError={this.state.isInError}
	    //           style={{flex:-1,width:65}}/>
	    //       </View>
	    //       {
	    //         this.state.errorMessage != null ?
	    //           <View>
	    //             <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', margin:10}}>
	    //             {this.state.errorMessage}
	    //             </ReUpText>
	    //           </View>
	    //         : null
	    //       }
	    //     </View>
	    //     <View style={{flexDirection:'column', alignItems:'center', marginTop:40}}>
	    //       <ReUpButton appManager={appManager} isSecondary={true} style={{width:240}} text={"Text Me"}
	    //         onPress={()=>
	    //         {
	    //           thisThing.submitNewPhone();
	    //         }} />
	    //     </View>
	    //     <View style={{flex:1}} />
	    //   </View>
	    // )
	    return null;
	    // return(
	    //   <View style={[styles.container, {backgroundColor:headerColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
	    //     <View style={{width:this.props.initialLayout.width, height:stripHeight, backgroundColor:headerIconColor}}>
	    //       <Image style={{width:this.props.initialLayout.width, height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
	    //       <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
	    //         <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
	    //       </View>
	    //     </View>
	    //     <View style={{flex:1}} />
	    //     {
	    //       this.state.isShowingPhone ?
	    //         <View style={{alignSelf:'stretch', flexDirection:'column'}}>
	    //           <View style={{paddingRight:8, alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
	    //             <ReUpText appManager={appManager} style={{marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[0]}</ReUpText>
	    //             <ReUpField
	    //               appManager={appManager}
	    //               ref={(a)=>{thisThing._phone1=a}}
	    //               key="phone1"
	    //               keyboardType={"phone-pad"}
	    //               onKeyPress={(event)=>
	    //               {
	    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone1")
	    //               }}
	    //               onChangeText={(text) =>
	    //               {
	    //                 thisThing._phoneText1 = text;
	    //                 var hasValidPhone = thisThing.hasValidPhone();
	    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //                 if( text.length >= 3 ) thisThing._phone2.focus()
	    //                 thisThing.setIsInError(false);
	    //               }}
	    //               placeholder={thisThing._phoneText1Placeholder}
	    //               maxLength={3}
	    //               isInError={this.state.isInError}
	    //               style={{flex:-1, width:45}}/>
	    //             <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[1]}</ReUpText>
	    //             <ReUpField
	    //               appManager={appManager}
	    //               ref={(a)=>{thisThing._phone2=a}}
	    //               key="phone2"
	    //               keyboardType={"phone-pad"}
	    //               onKeyPress={(event)=>
	    //               {
	    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone2")
	    //               }}
	    //               onChangeText={(text) =>
	    //               {
	    //                 thisThing._phoneText2 = text;
	    //                 var hasValidPhone = thisThing.hasValidPhone();
	    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //                 if( text.length >= 3 ) thisThing._phone3.focus()
	    //                 thisThing.setIsInError(false);
	    //               }}
	    //               placeholder={thisThing._phoneText2Placeholder}
	    //               maxLength={3}
	    //               isInError={this.state.isInError}
	    //               style={{flex:-1, width:45}}/>
	    //             <ReUpText appManager={appManager} style={{flex:-1, marginTop:18, padding:4, fontSize:24}}>{phoneSeparators[2]}</ReUpText>
	    //             <ReUpField
	    //               appManager={appManager}
	    //               ref={(a)=>{thisThing._phone3=a}}
	    //               key="phone3"
	    //               keyboardType={"phone-pad"}
	    //               onKeyPress={(event)=>
	    //               {
	    //                 if( event.nativeEvent.key == "Backspace" ) thisThing.backSpacePressed("phone3")
	    //               }}
	    //               onChangeText={(text) =>
	    //               {
	    //                 thisThing._phoneText3 = text;
	    //                 var hasValidPhone = thisThing.hasValidPhone();
	    //                 if( thisThing.state.hasValidPhone != hasValidPhone ) thisThing.setState({hasValidPhone});
	    //                 thisThing.setIsInError(false);
	    //               }}
	    //               placeholder={thisThing._phoneText3Placeholder}
	    //               maxLength={4}
	    //               isInError={this.state.isInError}
	    //               style={{flex:-1,width:65}}/>
	    //           </View>
	    //
	    //
	    //           {
	    //             this.state.hasValidPhone && this.state.errorMessage == null ?
	    //               <View style={{padding:20, height:80}}>
	    //                 <ReUpButton appManager={appManager} text={locManager.localizedStringForKey("TEXT_CFC_BUTTON", "Text Me")} onPress={()=>
	    //                   {
	    //                     thisThing.textLink();
	    //                   }}/>
	    //               </View>
	    //             :
	    //               <View style={{height:80, padding:20}}>
	    //               {
	    //                 this.state.errorMessage != null ?
	    //                     <ReUpText appManager={appManager} style={{color:'red', alignSelf:'center', textAlign:'center'}}>
	    //                     {this.state.errorMessage}
	    //                     </ReUpText>
	    //                 : null
	    //               }
	    //               </View>
	    //           }
	    //         </View>
	    //       : null
	    //     }
	    //     {
	    //       this.state.isShowingSuccess ?
	    //         <View style={{padding:20}}>
	    //           <ReUpText appManager={appManager} isTitle={true} style={{alignSelf:'center', margin:10}}>
	    //           {"Success!"}
	    //           </ReUpText>
	    //           <ReUpText appManager={appManager} isTitle={false} style={{alignSelf:'center', margin:10, textAlign:'center'}}>
	    //           {"A text has been sent to "+this.getPhoneNumber()+"!"}
	    //           </ReUpText>
	    //         </View>
	    //       : null
	    //     }
	    //     <View style={{flex:1}} />
	    //     {
	    //       this.state.isShowingSpinner ?
	    //       <ProgressOverlay ref="spinner" key="spinner" isVisible={this.state.isShowingSpinner}
	    //         layout={this.state.layout} appManager={appManager}>
	    //       </ProgressOverlay>
	    //       : null
	    //     }
	    //   </View>
	    // )
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'center',
	    flexDirection: 'column',
	    justifyContent: 'center'
	  }
	});
	
	SimpleCFD.dataDependencies = ["PhoneLocales"];
	
	module.exports = SimpleCFD;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var createReactClass = __webpack_require__(5);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var NetworkManager = __webpack_require__(15);
	var LinkingManager = __webpack_require__(27);
	var dismissKeyboard = __webpack_require__(105);
	
	var ReUpScrollView = __webpack_require__(16);
	var ReUpField = __webpack_require__(26);
	var ReUpButton = __webpack_require__(12);
	var ReUpStyle = __webpack_require__(151);
	var ReUpText = __webpack_require__(8);
	var ShadowView = __webpack_require__(20);
	var ProgressOverlay = __webpack_require__(52);
	var LinkingManager = __webpack_require__(27);
	var AnalyticsManager = __webpack_require__(50);
	var Hyperlink = __webpack_require__(113);
	var AddToWalletButton = __webpack_require__(62);
	var OffsetView = __webpack_require__(93);
	var createReactClass = __webpack_require__(5);
	var MK = __webpack_require__(14);
	
	var MKIconToggle = MK.MKIconToggle,
	    MKCheckbox = MK.MKCheckbox,
	    MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    AppState = ReactNative.AppState,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image,
	    CheckBox = ReactNative.CheckBox;
	
	
	function getParameterByName(url, name) {
	  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	      results = regex.exec(url);
	  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	  return result;
	}
	
	var SimpleCreateUser = createReactClass({
	  displayName: 'SimpleCreateUser',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      didCompleteRegistration: function didCompleteRegistration() {},
	      storeFocus: function storeFocus() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var appManager = this.props.appManager;
	
	    return {
	      layout: this.props.initialLayout,
	      showPassword: false,
	      nameError: false,
	      firstNameError: false,
	      lastNameError: false,
	      emailError: false,
	      emailErrorString: 'Please use a valid email',
	      passwordError: false,
	      shouldShowSpinner: false,
	      spinnerText: '',
	      optedIn: false,
	      showNameDoneButton: typeof appManager._urlFirstName !== 'undefined' && typeof appManager._urlLastName !== 'undefined',
	      showEmailDoneButton: typeof appManager._urlEmail !== 'undefined',
	      showPasswordDoneButton: false,
	      formOffset: new Animated.Value(0),
	      spinnerTitle: "",
	      spinnerBody: "",
	      shouldDrawPage: [true, false, false]
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.focus();
	
	    this._linkUserID = findGetParameter("userid");
	    this._linkUserHash = findGetParameter("hash");
	
	    var appManager = this.props.appManager;
	    this._firstName = typeof appManager._urlFirstName !== 'undefined' ? appManager._urlFirstName : "";
	    this._lastName = typeof appManager._urlLastName !== 'undefined' ? appManager._urlLastName : "";
	    this._email = typeof appManager._urlEmail !== 'undefined' ? appManager._urlEmail : "";
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  focus: function focus() {
	    if (this.refs.firstName) this.refs.firstName.focus();
	  },
	
	  _email: "",
	  emailChanged: function emailChanged(text) {
	    if (this.props.appManager.isValidEmail(text)) this._enableEmailError = true;
	    this._email = text;
	
	    var newState = this.checkErrors();
	    newState.showEmailDoneButton = this._email.length > 0;
	    if (this.state.emailError != newState.emailError || this.state.showEmailDoneButton !== newState.showEmailDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _firstName: "",
	  firstNameChanged: function firstNameChanged(text) {
	    var firstNameValid = this._firstName.length > 0;
	    if (firstNameValid) this._enableFirstNameError = true;
	
	    this._firstName = text;
	    var newState = this.checkErrors();
	    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
	    if (this.state.firstNameError !== newState.firstNameError || this.state.showNameDoneButton !== newState.showNameDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _lastName: "",
	  lastNameChanged: function lastNameChanged(text) {
	    var lastNameValid = this._lastName.length > 0;
	    if (lastNameValid) this._enableLastNameError = true;
	
	    this._lastName = text;
	    var newState = this.checkErrors();
	    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
	    if (this.state.lastNameError !== newState.lastNameError || this.state.showNameDoneButton !== newState.showNameDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _password: "",
	  passwordChanged: function passwordChanged(text) {
	    if (this.props.appManager.isValidPassword(text)) this._enablePasswordError = true;
	
	    this._password = text;
	    var newState = this.checkErrors();
	    newState.showPasswordDoneButton = this._password.length > 0;
	    if (this.state.passwordError != newState.passwordError || this.state.showPasswordDoneButton !== newState.showPasswordDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _refCode: "",
	  refCodeChanged: function refCodeChanged(text) {
	    this._refCode = text;
	  },
	
	  _enableFirstNameError: false,
	  _enableLastNameError: false,
	  _enableEmailError: false,
	  _enablePasswordError: false,
	  _enableInlineErrors: false,
	  checkErrors: function checkErrors() {
	    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
	    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
	    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
	    var passwordError = false; //this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);
	
	    return { emailError: emailError, firstNameError: firstNameError, lastNameError: lastNameError, passwordError: passwordError };
	  },
	
	  showRefCodeField: function showRefCodeField() {
	    var thisThing = this;
	    thisThing.setState({ showRefCode: !thisThing.state.showRefCode });
	    Animated.timing(this.state.fadeRefCode, {
	      toValue: 1,
	      duration: 500
	    }).start(function () {
	      thisThing.refs.refCode.focus();
	    });
	  },
	
	  showEmailSpinnerAndMessage: function showEmailSpinnerAndMessage(email) {
	    var thisThing = this;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var spinnerText = locMan.localizedStringForKey("VERIFY_YOUR_ACCOUNT_TITLE", "Verify Your Account");
	    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_YOUR_ACCOUNT_SMS_BODY", [], 'We have sent you a text message. Please check your text messages and tap the link to access your account.');
	    this.checkForMailApp(function (can) {
	      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
	    });
	  },
	
	  showSpinnerAndMessage: function showSpinnerAndMessage(spinnerTitle, spinnerBody) {
	    dismissKeyboard();
	    this.goToPage(2);
	    this.setState({ shouldShowSpinner: true, spinnerTitle: spinnerTitle, spinnerBody: spinnerBody });
	  },
	
	  hideSpinnerAndMessage: function hideSpinnerAndMessage() {
	    this.setState({ shouldShowSpinner: false });
	  },
	
	  _currentPageNum: 0,
	  goToPage: function goToPage(pageNum, animated) {
	    var _this = this;
	
	    // if( typeof this._pageContainer.scrollTo !== 'undefined' ) this._pageContainer.scrollTo(0,0);
	    if (this._currentPageNum == pageNum) return;
	    this._currentPageNum = pageNum;
	
	    if (typeof animated === 'undefined') animated = true;
	
	    var newOffset = pageNum * this.props.initialLayout.width;
	
	    var shouldDrawPage = this.state.shouldDrawPage;
	    shouldDrawPage[pageNum] = true;
	    this.setState({ shouldDrawPage: shouldDrawPage });
	
	    this.storeFocus();
	
	    var thisThing = this;
	    if (this._pageContainer != null) {
	      this._pageContainer.scrollTo({ x: newOffset, animated: animated, completion: function completion() {
	          var fieldToFocus = null;
	          if (pageNum == 0) fieldToFocus = thisThing._firstNameField;
	          if (pageNum == 1) fieldToFocus = thisThing._emailField;
	          if (fieldToFocus != null) fieldToFocus.focus();
	          _this.setState({ shouldDrawPage: [pageNum == 0, pageNum == 1, pageNum == 2] });
	        } });
	    }
	  },
	
	  submitPressed: function submitPressed() {
	    this._enableEmailError = true;
	    this._enableFirstNameError = true;
	    this._enableLastNameError = true;
	    this._enablePasswordError = true;
	
	    var newState = this.checkErrors();
	    this.setState(newState);
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    if (newState.firstNameError) {
	      this.goToPage(0);
	    } else if (newState.lastNameError) {
	      this.goToPage(0);
	    } else if (newState.emailError) {
	      this.goToPage(1);
	    } else {
	      var appManager = this.props.appManager;
	      var email = this._email;
	      var password = this._password;
	      var locManager = this.props.appManager.getLocalizationManager();
	
	      NetworkManager.createUserEmail(this.props.appManager, this._email, this._firstName, this._lastName, "", this._refCode, this.state.optedIn, this._linkUserID, this._linkUserHash, function (emailUser) {
	        AnalyticsManager.logSignUpEvent(appManager, 'PassPortal', true);
	        NetworkManager.login(thisThing.props.appManager, emailUser[ModelConstants.UserName], emailUser[ModelConstants.Hash], function (data) {
	          data[ModelConstants.Password] = data[ModelConstants.Hash];
	          appManager.setCurrentUser(data, function () {
	            console.log("loggedin?", data);
	            thisThing.accountCreated();
	          });
	        }, function (data) {
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	        }, function (data) {
	          appActions.setSpinnerShown(false);
	          appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	        });
	      }, function (data) {
	        AnalyticsManager.logSignUpEvent(appManager, 'Normal', false, { error: data.code });
	        if (data.code == -4) {
	          // not verified or account already created, so lets try to log them in anyways
	          NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	            data[ModelConstants.Password] = password;
	            appManager.setCurrentUser(data, function () {
	              thisThing.accountCreated();
	            });
	          }, function (data) {
	            thisThing.goToPage(1);
	            thisThing.setState({ emailError: true, emailErrorString: locManager.localizedStringForKey("CREATEUSER_EXISTS_2_FAIL_ALERT_BODY", "This email is already connected to an account, please try another.") });
	          }, function (data) {
	            thisThing.goToPage(1);
	            thisThing.setState({ emailError: true, emailErrorString: locManager.localizedStringForKey("CREATEUSER_EXISTS_2_FAIL_ALERT_BODY", "This email is already connected to an account, please try another.") });
	          });
	        } else if (data.code == -44) {
	          thisThing.goToPage(1);
	          thisThing.setState({ emailError: true, emailErrorString: locManager.localizedStringForKey("Please enter a valid referral code or clear the field.") });
	        } else {
	          thisThing.goToPage(1);
	          thisThing.setState({ emailError: true, emailErrorString: locManager.localizedStringForKey("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY") });
	        }
	      }, function (data) {
	        AnalyticsManager.logSignUpEvent(appManager, 'Normal', false);
	        appActions.setSpinnerShown(false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }
	  },
	
	  openTosLink: function openTosLink(url) {
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.canOpenURL(url, function (can) {
	      if (can) {
	        LinkingManager.openURL(url, tintColor, barTintColor);
	      }
	    });
	  },
	
	  _recursiveLoginPaused: false,
	  setRecursiveLoginPaused: function setRecursiveLoginPaused(paused) {
	    if (paused != this._recursiveLoginPaused) {
	      if (paused) // can only pause if there is login info recorded
	        {
	          if (this._loginInfoForPause != null) {
	            this._recursiveLoginPaused = paused;
	            clearTimeout(this._recursiveLoginTimeout);
	          }
	        } else {
	        this._recursiveLoginPaused = paused;
	        if (this._loginInfoForPause != null) // can only resume if login info is recorded
	          {
	            this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin);
	          }
	      }
	    }
	  },
	
	  _shouldContinueRecuriveLogin: false,
	  _recursiveLoginTimeout: null,
	  _loginInfoForPause: null,
	  recursiveLogin: function recursiveLogin(appManager, email, password, didLogin) {
	    if (!this._shouldContinueRecuriveLogin || this._recursiveLoginPaused) return;
	
	    this._loginInfoForPause = { appManager: appManager, email: email, password: password, didLogin: didLogin };
	    var thisThing = this;
	    NetworkManager.login(appManager, email, password, function (data) {
	      didLogin(data);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    });
	  },
	
	  storeFocus: function storeFocus() {
	    if (typeof this.props.extras !== 'undefined' && typeof this.props.extras.storeFocus !== 'undefined') {
	      this.props.extras.storeFocus();
	    }
	  },
	
	  nameSubmit: function nameSubmit() {
	    this._enableFirstNameError = true;
	    this._enableLastNameError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.firstNameError && !errors.lastNameError) {
	      this.goToPage(1);
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  emailSubmit: function emailSubmit() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var creatingAccountMessage = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_BODY", "Please wait while we register your email.");
	    var creatingAccountTitle = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_TITLE", "Creating Account");
	    this._enableEmailError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.emailError) {
	      this.showSpinnerAndMessage(creatingAccountTitle, creatingAccountMessage);
	      this.submitPressed();
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  passwordSubmit: function passwordSubmit() {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var creatingAccountMessage = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_BODY", "Please wait while we register your email.");
	    var creatingAccountTitle = locManager.localizedStringForKey("CREATING_ACCOUNT_SPINNER_TITLE", "Creating Account");
	    this._enablePasswordError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.passwordError) {
	      this.showSpinnerAndMessage(creatingAccountTitle, creatingAccountMessage);
	      this.submitPressed();
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  accountCreated: function accountCreated() {
	    this.props.extras.didCompleteRegistration();
	  },
	
	  optInMarketing: function optInMarketing() {
	    this.setState({ optedIn: !this.state.optedIn });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var thisThing = this;
	    var createUser = this;
	    var appManager = this.props.appManager;
	    var featureData = appManager.getFeatureForName("SimpleCreateUser");
	    var locManager = this.props.appManager.getLocalizationManager();
	    var appInfo = appManager.getAppInfo();
	    var tosLink = appManager.getTermsLink();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	
	    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
	    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
	    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
	    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
	    var registerButton = featureData.data.title;
	    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
	    var mailURL = "message://";
	    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
	    if (typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK") {
	      optInText = "I’d like to receive exclusive deals from " + appManager.appNameLong + ".";
	    }
	
	    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	    var stripHeight = Math.min(120, this.props.initialLayout.height / 3);
	
	    var firstNameOther = {};
	    if (typeof appManager._urlFirstName !== 'undefined') firstNameOther.defaultValue = appManager._urlFirstName;
	
	    var lastNameOther = {};
	    if (typeof appManager._urlLastName !== 'undefined') lastNameOther.defaultValue = appManager._urlLastName;
	
	    var emailOther = {};
	    if (typeof appManager._urlEmail !== 'undefined') emailOther.defaultValue = appManager._urlEmail;
	
	    return React.createElement(
	      View,
	      { style: { flex: 1, alignSelf: 'stretch', flexDirection: 'column', justifyContent: 'center', height: this.props.initialLayout.height - stripHeight } },
	      React.createElement(
	        View,
	        null,
	        React.createElement(Image, { style: { width: '100%', height: stripHeight, top: 0, left: 0, right: 0 }, resizeMode: "cover", source: { uri: stripImage } }),
	        React.createElement(
	          View,
	          { style: { position: 'absolute', top: 20, left: 20, right: 20 } },
	          React.createElement(Image, { style: { width: '100%', height: stripHeight - 40 }, resizeMode: "contain", source: { uri: headerImage } })
	        )
	      ),
	      React.createElement(
	        OffsetView,
	        { ref: function ref(a) {
	            return _this2._pageContainer = a;
	          }, horizontal: true, style: [styles.container, { backgroundColor: profileColor }] },
	        this.state.shouldDrawPage[0] ? React.createElement(
	          View,
	          { style: { paddingRight: 18, paddingLeft: 18, width: this.props.initialLayout.width, height: this.props.initialLayout.height - stripHeight, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'stretch' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { flex: 0, color: profileTitleColor, textAlign: 'center', paddingTop: 18, paddingBottom: 18 } },
	            locManager.localizedStringForKey("INTRODUCE_YOURSELF_1_OF_2_STATEMENT")
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', width: '100%', justifyContent: 'center' } },
	            React.createElement(ReUpField, Object.assign({
	              invertBG: true,
	              appManager: appManager,
	              underlineColorAndroid: 'transparent',
	              key: 'firstName', ref: function ref(a) {
	                return _this2._firstNameField = a;
	              },
	              autoCapitalize: 'words',
	              autoCorrect: false,
	              onFocus: function onFocus() {
	                thisThing.goToPage(0);
	              },
	              onChangeText: this.firstNameChanged,
	              onSubmitEditing: function onSubmitEditing() {
	                _this2._lastNameField.focus();
	              },
	              returnKeyType: 'next',
	              isInError: this.state.firstNameError,
	              placeholder: firstNameLabel,
	              style: [styles.textField]
	            }, firstNameOther)),
	            React.createElement(View, { style: { width: 8 } }),
	            React.createElement(ReUpField, Object.assign({
	              invertBG: true,
	              appManager: appManager,
	              underlineColorAndroid: 'transparent',
	              key: 'lastName', ref: function ref(a) {
	                return _this2._lastNameField = a;
	              },
	              autoCapitalize: 'words',
	              autoCorrect: false,
	              onFocus: function onFocus() {
	                thisThing.goToPage(0);
	              },
	              onChangeText: this.lastNameChanged,
	              onSubmitEditing: function onSubmitEditing() {
	                _this2.nameSubmit();
	              },
	              returnKeyType: 'next',
	              isInError: this.state.lastNameError,
	              placeholder: lastNameLabel,
	              style: [styles.textField]
	            }, lastNameOther))
	          ),
	          React.createElement(
	            View,
	            { style: { height: 26 } },
	            this.state.firstNameError || this.state.lastNameError ? React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: appManager.getErrorColor(), marginHorizontal: 10, paddingTop: 6 } },
	              locManager.localizedStringForKey("FILL_IN_FULL_NAME_STATEMENT")
	            ) : null
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, marginBottom: 18, alignSelf: 'stretch', alignItems: 'stretch', justifyContent: 'flex-end' } },
	            this.state.showNameDoneButton ? React.createElement(ReUpButton, { appManager: appManager, maskBorderRadius: 40, fontSize: 20, text: locManager.localizedStringForKey("NEXT_BUTTON"), style: { minHeight: '60px', maxHeight: '60px', flex: 1 }, onPress: function onPress() {
	                createUser.nameSubmit();
	              } }) : null
	          )
	        ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } }),
	        this.state.shouldDrawPage[1] ? React.createElement(
	          View,
	          { style: { paddingRight: 18, paddingLeft: 18, width: this.props.initialLayout.width, height: this.props.initialLayout.height - stripHeight, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'stretch' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { flex: 0, color: profileTitleColor, textAlign: 'center', paddingTop: 18, paddingBottom: 18 } },
	            locManager.localizedStringForKey("INTRODUCE_YOURSELF_2_OF_2_STATEMENT")
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', width: '100%' } },
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', width: '100%', justifyContent: 'center', alignSelf: 'stretch' } },
	              React.createElement(ReUpField, Object.assign({
	                invertBG: true,
	                appManager: appManager,
	                key: 'email', ref: function ref(a) {
	                  return _this2._emailField = a;
	                },
	                underlineColorAndroid: 'transparent',
	                autoCapitalize: 'none',
	                autoCorrect: false,
	                onFocus: function onFocus() {
	                  thisThing.goToPage(1);
	                },
	                keyboardType: 'email-address',
	                onChangeText: this.emailChanged,
	                onSubmitEditing: function onSubmitEditing() {
	                  _this2.emailSubmit();
	                },
	                returnKeyType: 'next',
	                placeholder: emailLabel,
	                isInError: this.state.emailError,
	                style: [styles.textField, { width: '100%' }]
	              }, emailOther))
	            ),
	            React.createElement(
	              View,
	              { style: { height: 26 } },
	              this.state.emailError ? React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { color: appManager.getErrorColor(), paddingTop: 6, marginHorizontal: 10 } },
	                this.state.emailErrorString
	              ) : null
	            ),
	            appManager.shouldContrastColor() ? React.createElement(
	              View,
	              { style: { width: '100%', flexDirection: 'row', alignSelf: 'center', backgroundColor: '#F2F5F8', height: 'auto', borderRadius: 3, padding: 15 } },
	              React.createElement(MKCheckbox, {
	                clickHandler: this.optInMarketing,
	                checked: this.state.optedIn,
	                description: optInText,
	                fillColor: '#2F3137',
	                textColor: '#2F3137',
	                style: { paddingTop: 0 },
	                checkboxSideLength: 20
	              })
	            ) : React.createElement(
	              View,
	              { style: _defineProperty({ width: '100%', flexDirection: 'row', alignSelf: 'center', height: 55, borderRadius: 3, padding: 15 }, 'height', 'auto') },
	              React.createElement(MKCheckbox, {
	                clickHandler: this.optInMarketing,
	                checked: this.state.optedIn,
	                description: optInText,
	                fillColor: profileTitleColor,
	                textColor: profileTitleColor,
	                style: { paddingTop: 0 },
	                checkboxSideLength: 20
	              })
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { flex: 1, marginBottom: 18, alignSelf: 'stretch', alignItems: 'stretch', justifyContent: 'flex-end' } },
	            this.state.showEmailDoneButton ? React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("NEXT_BUTTON"), fontSize: 20, style: { minHeight: '60px', maxHeight: '60px', flex: 1 }, onPress: function onPress() {
	                createUser.emailSubmit();
	              } }) : null
	          )
	        ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } }),
	        this.state.shouldDrawPage[2] ? React.createElement(
	          View,
	          { style: { paddingRight: 18, paddingLeft: 18, width: this.props.initialLayout.width, height: this.props.initialLayout.height - stripHeight, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'stretch' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { flex: 0, color: profileTitleColor, textAlign: 'center', paddingTop: 18, paddingBottom: 18 } },
	            this.state.spinnerTitle
	          ),
	          React.createElement(
	            View,
	            { style: { margin: 10 } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: { color: profileTitleColor, textAlign: 'center' } },
	              this.state.spinnerBody
	            )
	          ),
	          this.state.shouldShowSpinner ? React.createElement(
	            View,
	            { ref: 'spinner', key: 'spinner', style: { height: 60 } },
	            React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { alignSelf: 'center' } })
	          ) : null
	        ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignSelf: 'stretch',
	    alignItems: 'stretch',
	    flexDirection: 'row'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  backgroundView: _defineProperty({
	    position: 'absolute',
	    top: 0, left: 0, bottom: 0 }, 'top', 0),
	  textField: {
	    flex: 1
	  },
	  fieldsContainer: {
	    flexDirection: 'column',
	    paddingHorizontal: 16,
	    paddingVertical: 10
	  },
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  passwordShowButton: {
	    borderRadius: 25,
	    width: 50,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    margin: 4
	  },
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginHorizontal: 16,
	    marginBottom: 8
	  }
	});
	
	SimpleCreateUser.dataDependencies = ["Users"];
	
	module.exports = SimpleCreateUser;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var NetworkManager = __webpack_require__(15);
	var LinkingManager = __webpack_require__(27);
	var dismissKeyboard = __webpack_require__(105);
	
	var ReUpScrollView = __webpack_require__(16);
	var ReUpField = __webpack_require__(26);
	var ReUpButton = __webpack_require__(12);
	var ReUpStyle = __webpack_require__(151);
	var ReUpText = __webpack_require__(8);
	var ShadowView = __webpack_require__(20);
	var ProgressOverlay = __webpack_require__(52);
	var LinkingManager = __webpack_require__(27);
	var AnalyticsManager = __webpack_require__(50);
	var Hyperlink = __webpack_require__(113);
	var AddToWalletButton = __webpack_require__(62);
	var OffsetView = __webpack_require__(93);
	var createReactClass = __webpack_require__(5);
	
	var MK = __webpack_require__(14);
	
	var MKIconToggle = MK.MKIconToggle,
	    MKCheckbox = MK.MKCheckbox,
	    MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet,
	    AppState = ReactNative.AppState,
	    Platform = ReactNative.Platform,
	    Image = ReactNative.Image;
	
	
	var SimpleLogin = createReactClass({
	  displayName: 'SimpleLogin',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      didCompleteRegistration: function didCompleteRegistration() {},
	      userName: null,
	      storeFocus: function storeFocus() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var shouldDrawPage = [true, false, false];
	    if (typeof this.props.extras !== 'undefined' && typeof this.props.extras.userName !== 'undefined') {
	      shouldDrawPage = [false, true, false];
	    }
	    return {
	      layout: this.props.initialLayout,
	      showPassword: false,
	      nameError: false,
	      firstNameError: false,
	      lastNameError: false,
	      emailError: false,
	      emailErrorString: 'Please use a valid email',
	      passwordError: false,
	      shouldShowSpinner: false,
	      spinnerText: '',
	      optedIn: false,
	      showNameDoneButton: false,
	      showEmailDoneButton: false,
	      showPasswordDoneButton: false,
	      spinnerTitle: "",
	      spinnerBody: "",
	      shouldDrawPage: shouldDrawPage
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (typeof this.props.extras !== 'undefined' && typeof this.props.extras.userName !== 'undefined') {
	      if (this._emailField) this._emailField.setText(this.props.extras.userName);
	      this._email = this.props.extras.userName;
	      this.goToPage(1, 1);
	    } else {
	      this.focus();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  focus: function focus() {
	    if (this.refs.firstName) this.refs.firstName.focus();
	  },
	
	  _email: "",
	  emailChanged: function emailChanged(text) {
	    if (this.props.appManager.isValidEmail(text)) this._enableEmailError = true;
	    this._email = text;
	
	    var newState = this.checkErrors();
	    newState.showEmailDoneButton = this._email.length > 0;
	    if (this.state.emailError != newState.emailError || this.state.showEmailDoneButton !== newState.showEmailDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _firstName: "",
	  firstNameChanged: function firstNameChanged(text) {
	    var firstNameValid = this._firstName.length > 0;
	    if (firstNameValid) this._enableFirstNameError = true;
	
	    this._firstName = text;
	    var newState = this.checkErrors();
	    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
	    if (this.state.firstNameError !== newState.firstNameError || this.state.showNameDoneButton !== newState.showNameDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _lastName: "",
	  lastNameChanged: function lastNameChanged(text) {
	    var lastNameValid = this._lastName.length > 0;
	    if (lastNameValid) this._enableLastNameError = true;
	
	    this._lastName = text;
	    var newState = this.checkErrors();
	    newState.showNameDoneButton = this._firstName.length > 0 && this._lastName.length > 0;
	    if (this.state.lastNameError !== newState.lastNameError || this.state.showNameDoneButton !== newState.showNameDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _password: "",
	  passwordChanged: function passwordChanged(text) {
	    if (this.props.appManager.isValidPassword(text)) this._enablePasswordError = true;
	
	    this._password = text;
	    var newState = this.checkErrors();
	    newState.showPasswordDoneButton = this._password.length > 0;
	    if (this.state.passwordError != newState.passwordError || this.state.showPasswordDoneButton !== newState.showPasswordDoneButton) {
	      this.setState(newState);
	    }
	  },
	
	  _refCode: "",
	  refCodeChanged: function refCodeChanged(text) {
	    this._refCode = text;
	  },
	
	  _enableFirstNameError: false,
	  _enableLastNameError: false,
	  _enableEmailError: false,
	  _enablePasswordError: false,
	  _enableInlineErrors: false,
	  checkErrors: function checkErrors() {
	    var firstNameError = this._enableFirstNameError && !this._firstName.length > 0;
	    var lastNameError = this._enableLastNameError && !this._lastName.length > 0;
	    var emailError = this._enableEmailError && !this.props.appManager.isValidEmail(this._email);
	    var passwordError = this._enablePasswordError && !this.props.appManager.isValidPassword(this._password);
	
	    return { emailError: emailError, firstNameError: firstNameError, lastNameError: lastNameError, passwordError: passwordError };
	  },
	
	  showRefCodeField: function showRefCodeField() {
	    var thisThing = this;
	    thisThing.setState({ showRefCode: !thisThing.state.showRefCode });
	    Animated.timing(this.state.fadeRefCode, {
	      toValue: 1,
	      duration: 500
	    }).start(function () {
	      thisThing.refs.refCode.focus();
	    });
	  },
	
	  showEmailSpinnerAndMessage: function showEmailSpinnerAndMessage(email) {
	    var thisThing = this;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var spinnerText = locMan.localizedStringForKey("VERIFY_YOUR_ACCOUNT_TITLE", "Verify Your Account");
	    var spinnerBody = locMan.localizedStringForKeyAndParams("VERIFY_YOUR_ACCOUNT_SMS_BODY", [], 'We have sent you a text message. Please check your text messages and tap the link to access your account.');
	    this.checkForMailApp(function (can) {
	      thisThing.showSpinnerAndMessage(spinnerText, spinnerBody, can);
	    });
	  },
	
	  showSpinnerAndMessage: function showSpinnerAndMessage(spinnerTitle, spinnerBody) {
	    dismissKeyboard();
	    this.goToPage(2);
	    this.setState({ shouldShowSpinner: true, spinnerTitle: spinnerTitle, spinnerBody: spinnerBody });
	  },
	
	  hideSpinnerAndMessage: function hideSpinnerAndMessage() {
	    this.setState({ shouldShowSpinner: false });
	  },
	
	  _currentPageNum: 0,
	  goToPage: function goToPage(pageNum, animated) {
	    // if( typeof this._pageContainer.scrollTo !== 'undefined' ) this._pageContainer.scrollTo(0,0);
	    if (this._currentPageNum == pageNum) return;
	    this._currentPageNum = pageNum;
	
	    if (typeof animated === 'undefined') animated = true;
	
	    var newOffset = pageNum * this.props.initialLayout.width;
	
	    var shouldDrawPage = this.state.shouldDrawPage;
	    shouldDrawPage[pageNum] = true;
	    this.setState({ shouldDrawPage: shouldDrawPage });
	    this.storeFocus();
	
	    var thisThing = this;
	    if (this._pageContainer != null) {
	      this._pageContainer.scrollTo({ x: newOffset, animated: animated, completion: function completion() {
	          var fieldToFocus = null;
	          if (pageNum == 0) fieldToFocus = thisThing._emailField;
	          if (pageNum == 1) fieldToFocus = thisThing._passwordField;
	          if (fieldToFocus != null) fieldToFocus.focus();
	          thisThing.setState({ shouldDrawPage: [pageNum == 0, pageNum == 1, pageNum == 2] });
	        } });
	    }
	  },
	
	  storeFocus: function storeFocus() {
	    if (typeof this.props.extras !== 'undefined' && typeof this.props.extras.storeFocus !== 'undefined') {
	      this.props.extras.storeFocus();
	    }
	  },
	
	  submitPressed: function submitPressed() {
	    this._enableEmailError = true;
	    this._enablePasswordError = true;
	
	    var newState = this.checkErrors();
	    this.setState(newState);
	    var thisThing = this;
	    var appActions = this.props.appActions;
	
	    if (newState.emailError) {
	      this.goToPage(0);
	    } else if (newState.passwordError) {
	      this.goToPage(1);
	    } else {
	      var appManager = this.props.appManager;
	      var email = this._email;
	      var password = this._password;
	      var locManager = this.props.appManager.getLocalizationManager();
	
	      NetworkManager.login(thisThing.props.appManager, thisThing._email, thisThing._password, function (data) {
	        AnalyticsManager.logLoginEvent(appManager, 'PassPortal', true);
	        data[ModelConstants.Password] = password;
	        appManager.setCurrentUser(data, function () {
	          thisThing.loginComplete();
	        });
	      }, function (data) {
	        thisThing._password = "";
	        AnalyticsManager.logLoginEvent(appManager, 'regular', false);
	        if (data.code == -23) // not verified
	          {
	            appActions.showLocalizedAlert("UNVERIFIED_FAIL_ALERT_TITLE", "UNVERIFIED_FAIL_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [appActions.hideAlert, function () {
	              NetworkManager.resendVerifyEmail(appManager, thisThing._email, function () {
	                if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	                  thisThing.goToPage(1);
	                } else {
	                  thisThing.goToPage(0);
	                }
	                appActions.showLocalizedAlert("EMAIL_PASS_SUCCESS_ALERT_TITLE", "CREATEUSER_SUCCESS_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              }, function () {
	                if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	                  thisThing.goToPage(1);
	                } else {
	                  thisThing.goToPage(0);
	                }
	                appActions.showLocalizedAlert("CREATEUSER_EMAIL_INVALID_FAIL_ALERT_TITLE", "CREATEUSER_EMAIL_INVALID_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [appActions.hideAlert], appActions.hideAlert);
	              }, function () {
	                if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	                  thisThing.goToPage(1);
	                } else {
	                  thisThing.goToPage(0);
	                }
	                appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	              });
	            }], function () {
	              if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	                thisThing.goToPage(1);
	              } else {
	                thisThing.goToPage(0);
	              }
	              appActions.hideAlert();
	            });
	          } else {
	          appActions.showLocalizedAlert("LOGIN_FAIL_ALERT_TITLE", "LOGIN_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	            appActions.hideAlert();
	            if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	              thisThing.goToPage(1);
	            } else {
	              thisThing.goToPage(0);
	            }
	          }], function () {
	            if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	              thisThing.goToPage(1);
	            } else {
	              thisThing.goToPage(0);
	            }
	            appActions.hideAlert();
	          });
	        }
	      }, function (data) {
	        if (typeof thisThing.props.extras !== 'undefined' && typeof thisThing.props.extras.userName !== 'undefined') {
	          thisThing.goToPage(1);
	        } else {
	          thisThing.goToPage(0);
	        }
	        AnalyticsManager.logLoginEvent(appManager, 'Normal', false);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	      });
	    }
	  },
	
	  openTosLink: function openTosLink(url) {
	    var barTintColor = this.props.appManager.getColorForKey("HeaderColor");
	    var tintColor = this.props.appManager.getColorForKey("HeaderIconColor");
	    LinkingManager.canOpenURL(url, function (can) {
	      if (can) {
	        LinkingManager.openURL(url, tintColor, barTintColor);
	      }
	    });
	  },
	
	  _recursiveLoginPaused: false,
	  setRecursiveLoginPaused: function setRecursiveLoginPaused(paused) {
	    if (paused != this._recursiveLoginPaused) {
	      if (paused) // can only pause if there is login info recorded
	        {
	          if (this._loginInfoForPause != null) {
	            this._recursiveLoginPaused = paused;
	            clearTimeout(this._recursiveLoginTimeout);
	          }
	        } else {
	        this._recursiveLoginPaused = paused;
	        if (this._loginInfoForPause != null) // can only resume if login info is recorded
	          {
	            this.recursiveLogin(this._loginInfoForPause.appManager, this._loginInfoForPause.email, this._loginInfoForPause.password, this._loginInfoForPause.didLogin);
	          }
	      }
	    }
	  },
	
	  _shouldContinueRecuriveLogin: false,
	  _recursiveLoginTimeout: null,
	  _loginInfoForPause: null,
	  recursiveLogin: function recursiveLogin(appManager, email, password, didLogin) {
	    if (!this._shouldContinueRecuriveLogin || this._recursiveLoginPaused) return;
	
	    this._loginInfoForPause = { appManager: appManager, email: email, password: password, didLogin: didLogin };
	    var thisThing = this;
	    NetworkManager.login(appManager, email, password, function (data) {
	      didLogin(data);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    }, function (data) {
	      thisThing._recursiveLoginTimeout = setTimeout(function () {
	        thisThing.recursiveLogin(appManager, email, password, didLogin);
	      }, 1000);
	    });
	  },
	
	  nameSubmit: function nameSubmit() {
	    this._enableFirstNameError = true;
	    this._enableLastNameError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.firstNameError && !errors.lastNameError) {
	      this.goToPage(1);
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  emailSubmit: function emailSubmit() {
	    this._enableEmailError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.emailError) {
	      this.goToPage(1);
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  passwordSubmit: function passwordSubmit() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var loggingInTitle = locManager.localizedStringForKey("LOGIN_SPINNER_TITLE");
	    var loggingInBody = locManager.localizedStringForKey("LOGIN_SPINNER_BODY");
	    this._enablePasswordError = true;
	    var errors = this.checkErrors();
	
	    if (!errors.passwordError) {
	      this.showSpinnerAndMessage(loggingInTitle, loggingInBody);
	      this.submitPressed();
	    } else {
	      this.setState(errors);
	    }
	  },
	
	  forgotPassword: function forgotPassword() {
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var forgotPassTitle = locManager.localizedStringForKey("FORGOT_PASS_SPINNER_TITLE");
	    var forgotPassBody = locManager.localizedStringForKey("FORGOT_PASS_SPINNER_BODY");
	    this.showSpinnerAndMessage(forgotPassTitle, forgotPassBody);
	  },
	
	  loginComplete: function loginComplete() {
	    this.props.extras.didCompleteLogin();
	  },
	
	  render: function render() {
	    var _this = this,
	        _ref;
	
	    var createUser = this;
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var featureData = appManager.getFeatureForName("SimpleLogin");
	    var locManager = this.props.appManager.getLocalizationManager();
	    var appInfo = appManager.getAppInfo();
	    var tosLink = appManager.getTermsLink();
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var headerColor = appManager.getColorForKey("HeaderColor");
	    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
	    var primaryButtonColorLight = appManager.getColorForKey("ButtonPrimaryColor", 0.2);
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	
	    var firstNameLabel = locManager.localizedStringForKey("FIRSTNAME_PLACEHOLDER");
	    var lastNameLabel = locManager.localizedStringForKey("LASTNAME_PLACEHOLDER");
	    var emailLabel = locManager.localizedStringForKey("USERNAME_PLACEHOLDER");
	    var passwordLabel = locManager.localizedStringForKey("PASSWORD_PLACEHOLDER");
	    var registerButton = featureData.data.title;
	    var refCodeButton = locManager.localizedStringForKey("REFERRAL_CODE_LABEL") + "?";
	    var mailURL = "message://";
	    var optInText = locManager.localizedStringForKeyAndParams("OPT_IN_CHECK", [appManager.appNameLong]);
	    if (typeof optInText === 'undefined' || optInText == "OPT_IN_CHECK") {
	      optInText = "I’d like to receive exclusive deals from " + appManager.appNameLong + ".";
	    }
	
	    var iconImageName = this.props.appManager.absoluteResourceForPath('App/iTunesArtwork.png');
	
	    return React.createElement(
	      OffsetView,
	      { ref: function ref(a) {
	          return _this._pageContainer = a;
	        }, horizontal: true, style: [styles.container, { height: this.props.initialLayout.height, backgroundColor: profileColor }] },
	      this.state.shouldDrawPage[0] ? React.createElement(
	        View,
	        { style: { padding: 12, width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } },
	        React.createElement(
	          View,
	          { style: { margin: 10 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: (_ref = { color: profileTitleColor }, _defineProperty(_ref, 'color', profileTitleColor), _defineProperty(_ref, 'textAlign', 'center'), _ref) },
	            locManager.localizedStringForKey("PLEASE_LOGIN_LABEL")
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', marginTop: 10, marginLeft: 10, marginRight: 10, marginBottom: 4 } },
	          React.createElement(ReUpField, {
	            invertBG: true,
	            appManager: appManager,
	            key: 'email', ref: function ref(a) {
	              return _this._emailField = a;
	            },
	            underlineColorAndroid: 'transparent',
	            autoCapitalize: 'none',
	            autoCorrect: false,
	            onFocus: function onFocus() {
	              thisThing.goToPage(0);
	            },
	            keyboardType: 'email-address',
	            onChangeText: this.emailChanged,
	            onSubmitEditing: function onSubmitEditing() {
	              _this.emailSubmit();
	            },
	            returnKeyType: 'next',
	            placeholder: emailLabel,
	            isInError: this.state.emailError,
	            style: [styles.textField] })
	        ),
	        React.createElement(
	          View,
	          { style: { height: 26 } },
	          this.state.emailError ? React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { color: 'red', marginHorizontal: 10 } },
	            this.state.emailErrorString
	          ) : null
	        ),
	        React.createElement(
	          View,
	          { style: { height: 60, flexDirection: "row" } },
	          this.state.showEmailDoneButton ? React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("NEXT_BUTTON"), style: { margin: 10, flex: 1, alignSelf: 'stretch' }, onPress: function onPress() {
	              createUser.emailSubmit();
	            } }) : null
	        )
	      ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } }),
	      this.state.shouldDrawPage[1] ? React.createElement(
	        View,
	        { style: { padding: 12, width: this.props.initialLayout.width, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } },
	        React.createElement(
	          View,
	          { style: { margin: 10 } },
	          typeof this.props.extras !== 'undefined' && typeof this.props.extras.userName !== 'undefined' ? React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center' } },
	            typeof this.props.extras.phoneNumber !== 'undefined' && this.props.extras.phoneNumber != null ? "Please enter the password for \n" + this.props.extras.phoneNumber + ":" : "Please enter the password for \n" + this.props.extras.userName + ":"
	          ) : React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center' } },
	            locManager.localizedStringForKey("PLEASE_ENTER_PASS_LABEL")
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', marginTop: 10, marginLeft: 10, marginRight: 10, marginBottom: 4 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', flex: 1 } },
	            React.createElement(
	              View,
	              { style: styles.passwordContainer },
	              React.createElement(ReUpField, {
	                invertBG: true,
	                appManager: appManager,
	                underlineColorAndroid: 'transparent',
	                onChangeText: this.passwordChanged,
	                onSubmitEditing: this.state.showRefCode ? function () {
	                  _this.refs.refCode.focus();
	                } : this.passwordSubmit,
	                returnKeyType: this.state.showRefCode ? 'next' : 'done',
	                key: 'password',
	                ref: function ref(a) {
	                  return _this._passwordField = a;
	                },
	                onFocus: function onFocus() {
	                  thisThing.goToPage(1);
	                },
	                isInError: this.state.passwordError,
	                placeholder: passwordLabel,
	                secureTextEntry: !this.state.showPassword,
	                style: [styles.textField] }),
	              React.createElement(
	                MKIconToggle,
	                {
	                  style: { marginTop: 22, height: 30, width: 30, position: 'absolute', right: 0, backgroundColor: 'transparent' },
	                  checked: this.state.showPassword,
	                  onCheckedChange: this.state.showPassword ? function () {
	                    createUser.setState({ showPassword: false });_this._passwordField.onBlur();_this._passwordField.focus();
	                  } : function () {
	                    createUser.setState({ showPassword: true });_this._passwordField.onBlur();_this._passwordField.focus();
	                  }
	                },
	                React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	                React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	              )
	            )
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { height: 26 } },
	          this.state.passwordError ? React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { color: 'red', marginHorizontal: 10 } },
	            locManager.localizedStringForKey("PASS_EIGHT_CHARACTERS_LOGIN_STATEMENT")
	          ) : null
	        ),
	        React.createElement(
	          View,
	          { style: { height: 60 } },
	          this.state.showPasswordDoneButton ? React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("NEXT_BUTTON"), style: { margin: 10, alignSelf: 'stretch' }, onPress: function onPress() {
	              createUser.passwordSubmit();
	            } }) : React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("FORGOT_PASS_BUTTON"), style: { margin: 10, alignSelf: 'stretch' }, onPress: function onPress() {
	              createUser.forgotPassword();
	            } })
	        )
	      ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } }),
	      this.state.shouldDrawPage[2] ? React.createElement(
	        View,
	        { style: { padding: 12, width: this.props.initialLayout.width, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } },
	        React.createElement(
	          View,
	          { style: { margin: 10 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { color: profileTitleColor, textAlign: 'center' } },
	            this.state.spinnerTitle
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { margin: 10 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { color: profileTitleColor, textAlign: 'center' } },
	            this.state.spinnerBody
	          )
	        ),
	        this.state.shouldShowSpinner ? React.createElement(
	          View,
	          { ref: 'spinner', key: 'spinner', style: { height: 60 } },
	          React.createElement(MKSpinner, { strokeColor: [appManager.getColorForKey("HeaderTitleColor"), appManager.getColorForKey("HeaderColor")], style: { alignSelf: 'center' } })
	        ) : null
	      ) : React.createElement(View, { style: { width: this.props.initialLayout.width, height: this.props.initialLayout.height, flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignSelf: 'stretch',
	    alignItems: 'stretch',
	    flexDirection: 'row'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  backgroundView: _defineProperty({
	    position: 'absolute',
	    top: 0, left: 0, bottom: 0 }, 'top', 0),
	  textField: {
	    flex: 1
	  },
	  fieldsContainer: {
	    flexDirection: 'column',
	    paddingHorizontal: 16,
	    paddingVertical: 10
	  },
	  passwordContainer: {
	    flexDirection: 'row'
	  },
	  passwordShowButton: {
	    borderRadius: 25,
	    width: 50,
	    height: 50,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    margin: 4
	  },
	  doneButton: {
	    justifyContent: 'center',
	    flex: 1,
	    marginHorizontal: 16,
	    marginBottom: 8
	  }
	});
	
	SimpleLogin.dataDependencies = ["Users"];
	
	module.exports = SimpleLogin;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(114);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var LinkingManager = __webpack_require__(27);
	var createReactClass = __webpack_require__(5);
	
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var RNFS = __webpack_require__(96);
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	
	  return result;
	}
	
	var SimpleSettings = createReactClass({
	  displayName: 'SimpleSettings',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      user: this.props.appManager.currentUser(),
	      showPassword: false,
	      selfieURL: null,
	      hasOptedInForEmail: this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()["hasOptedInForEmail"]
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var settings = this;
	    this.props.appManager.getCurrentUser(function (user) {
	      settings.props.appManager.getSelfie(function (selfieURL) {
	        settings.setState({ user: user, selfieURL: selfieURL });
	      });
	    });
	
	    this.refreshUser();
	  },
	
	  logoutPressed: function logoutPressed() {
	    var appActions = this.props.appActions;
	    var thisThing = this;
	    appActions.setSpinnerShown(true, "Logging out...");
	    this.props.appManager.logout(function () {
	      appActions.setSpinnerShown(false);
	      appActions.requestPop();
	    });
	  },
	
	  _camera: null,
	  _canCapture: false,
	  cameraDidLoad: function cameraDidLoad(camera) {
	    if (!camera) return;
	    this._canCapture = true;
	    this._camera = camera;
	  },
	
	  takePicture: function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var appManager, thisThing, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(this._camera && this._canCapture)) {
	                _context.next = 14;
	                break;
	              }
	
	              this._canCapture = false;
	              _context.prev = 2;
	              appManager = this.props.appManager;
	              thisThing = this;
	              _context.next = 7;
	              return this._camera.capture({ target: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk, mode: _reactNativeCameraWrapper2.default.constants.CaptureMode.still, type: _reactNativeCameraWrapper2.default.constants.Type.front, quality: 'medium' });
	
	            case 7:
	              data = _context.sent;
	
	              // console.log(data);
	              appManager.setSelfie(data, function () {
	                // console.log("did set selfie")
	                appManager.getSelfie(function (selfieURL) {
	                  // console.log("did get selfie with url" + selfieURL)
	                  thisThing.props.appActions.hideAlert();
	                  thisThing.setState({ selfieURL: selfieURL });
	                  thisThing.props.appManager._eventEmitter.emit("checkUserChanged", {});
	                });
	              });
	              _context.next = 14;
	              break;
	
	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](2);
	
	              console.error(_context.t0);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this, [[2, 11]]);
	    }));
	
	    function takePicture() {
	      return _ref.apply(this, arguments);
	    }
	
	    return takePicture;
	  }(),
	
	  didUpdate: function didUpdate() {},
	
	  profilePicSelected: function profilePicSelected() {
	    if (Platform.OS === 'ios') {
	      var thisThing = this;
	      var appActions = this.props.appActions;
	      _reactNativeCameraWrapper2.default.checkVideoAuthorizationStatus().then(function (hasPermission) {
	        if (hasPermission) {
	          thisThing.showCamera();
	        } else {
	          appActions.showAlert("Camera Permission Required", "You have not granted permission to use the camera. Please go into your phone's Settings and add the permission.", ["Okay"], [function () {
	            appActions.hideAlert();
	          }]);
	        }
	      });
	    } else {
	      this.showCamera();
	    }
	  },
	
	  showCamera: function showCamera() {
	    var _React$createElement, _React$createElement2;
	
	    var cameraDim = Math.min(this.state.layout.width, this.state.layout.height) - 20;
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	
	    var customAlert = Platform.OS === 'ios' ? React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        _reactNativeCameraWrapper2.default,
	        { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'flex-end', padding: 10 },
	          captureAudio: false,
	          captureQuality: "medium",
	          captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	          type: _reactNativeCameraWrapper2.default.constants.Type.front,
	          aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill },
	        React.createElement(ReUpIconButton, (_React$createElement = { iconName: "camera", type: 1, style: { margin: 10 },
	          appManager: appManager
	        }, _defineProperty(_React$createElement, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement, 'onPress', function onPress() {
	          thisThing.takePicture();
	        }), _React$createElement))
	      )
	    ) : React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 0, paddingBottom: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(_reactNativeCameraWrapper2.default, { ref: this.cameraDidLoad, style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'flex-end', padding: 10, marginBottom: 10 },
	        captureAudio: false,
	        aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill,
	        captureTarget: _reactNativeCameraWrapper2.default.constants.CaptureTarget.disk,
	        captureQuality: "medium",
	        type: _reactNativeCameraWrapper2.default.constants.Type.front,
	        orientation: _reactNativeCameraWrapper2.default.constants.Orientation.portrait }),
	      React.createElement(ReUpIconButton, (_React$createElement2 = { iconName: "camera", type: 1, style: { margin: 10 },
	        appManager: appManager
	      }, _defineProperty(_React$createElement2, 'style', { alignSelf: 'flex-end' }), _defineProperty(_React$createElement2, 'onPress', function onPress() {
	        thisThing.takePicture();
	      }), _React$createElement2))
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  changePasswordPressed: function changePasswordPressed() {
	    this._showPassword = false;
	    this._currentPassword = "";
	    this._newPassword = "";
	    this._currentPasswordError = false;
	    this._newPasswordError = false;
	
	    this.showChangePass();
	  },
	
	  _showPassword: false,
	  _currentPassword: "",
	  _newPassword: "",
	  _currentPasswordError: false,
	  _newPasswordError: false,
	  showChangePass: function showChangePass() {
	    var _this = this;
	
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var appActions = thisThing.props.appActions;
	    var locManager = thisThing.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	
	    var locMan = appManager.getLocalizationManager();
	    var changePasswordButton = locMan.localizedStringForKey("CHANGE_PASSWORD_BUTTON");
	    var newPassDescription = locMan.localizedStringForKey("CHANGE_PASSWORD_LABEL");
	    var passPlaceholder = locMan.localizedStringForKey("CURRENT_PASSWORD_PLACEHOLDER");
	    var newPassPlaceholder = locMan.localizedStringForKey("NEW_PASSWORD_PLACEHOLDER");
	    var currPass = appManager.currentUser()[ModelConstants.Password];
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { key: 'changepassscroll', bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10, flexBasis: 'auto', height: 225 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column' } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { marginTop: 10, textAlign: 'center' } },
	          newPassDescription
	        ),
	        React.createElement(ReUpField, { appManager: appManager,
	          key: 'oldPassword',
	          tintColor: bannerColor,
	          highlightColor: bannerColor,
	          onChangeText: function onChangeText(text) {
	            _this._currentPassword = text;
	          },
	          placeholder: passPlaceholder,
	          secureTextEntry: true }),
	        React.createElement(
	          View,
	          { style: { alignSelf: 'stretch' } },
	          React.createElement(ReUpField, {
	            onChangeText: function onChangeText(text) {
	              _this._newPassword = text;
	            },
	            key: 'password',
	            ref: function ref(a) {
	              return thisThing._passwordField = a;
	            },
	            tintColor: bannerColor,
	            highlightColor: bannerColor,
	            appManager: appManager,
	            placeholder: newPassPlaceholder,
	            secureTextEntry: !this._showPassword,
	            style: [{ flex: 1, alignSelf: 'stretch', height: 50 }] }),
	          React.createElement(
	            MKIconToggle,
	            {
	              style: { marginTop: 22, height: 30, width: 30, position: 'absolute', right: 0, backgroundColor: 'transparent' },
	              checked: this._showPassword,
	              onCheckedChange: function onCheckedChange(info) {
	                thisThing._passwordField.onBlur();
	                thisThing._showPassword = info.checked;
	                thisThing.showChangePass();
	              }
	            },
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: true, style: [styles.creditCardEditButtonIcon], name: "eye", size: 14, color: generalTitleColor }),
	            React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', state_checked: false, style: [styles.creditCardEditButtonIcon], name: "eye-slash", size: 14, color: generalTitleColor })
	          )
	        ),
	        React.createElement(ReUpButton, { key: 'changepassbutton', onPress: function onPress() {
	            if (thisThing._currentPassword.length <= 0 || thisThing._newPassword.length <= 0) return;
	
	            if (currPass != thisThing._currentPassword) {
	              var title = locManager.localizedStringForKey("ERROR_FAIL_ALERT_TITLE");
	              var body = locManager.localizedStringForKey("PASSWORD_INCORRECT_BODY");
	              var button = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	              appActions.showAlert(title, body, [button], [thisThing.showChangePass], function () {});
	            } else if (appManager.isValidPassword(thisThing._newPassword)) {
	              thisThing.changePassword(thisThing._newPassword);
	            } else {
	              appActions.showLocalizedAlert("CHANGE_PASS_FORMAT_FAIL_ALERT_TITLE", "CHANGE_PASS_FORMAT_FAIL_ALERT_BODY", ["OK_ALERT_BUTTON"], [function () {
	                thisThing.props.appActions.hideAlert();
	                thisThing.showChangePass();
	              }], function () {});
	            }
	          }, appManager: this.props.appManager, text: changePasswordButton, style: [styles.logoutButton, { marginTop: 20, marginBottom: 10 }] })
	      )
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert);
	  },
	
	  changePassword: function changePassword(newPass) {
	    var thisThing = this;
	    var appManager = thisThing.props.appManager;
	    var locMan = appManager.getLocalizationManager();
	    var changingPassword = appManager.getLocalizationManager().localizedStringForKey("SAVING_HUD");
	    thisThing.props.appActions.setSpinnerShown(true, changingPassword);
	    NetworkManager.changePassword(this.props.appManager, newPass, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var user = appManager.getCurrentUser(function (currentUser) {
	        currentUser[ModelConstants.Password] = newPass;
	        appManager.setCurrentUser(currentUser, function () {
	          var changePassSuccessTitle = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_TITLE");
	          var changePassSuccessBody = locMan.localizedStringForKey("CHANGE_PASS_SUCCESS_ALERT_BODY");
	          var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	
	          thisThing.props.appActions.showAlert(changePassSuccessTitle, changePassSuccessBody, [okayButton], [function () {
	            thisThing.props.appActions.hideAlert();
	          }], function () {});
	        });
	      });
	    }, function (data) {
	      thisThing.props.appActions.setSpinnerShown(false);
	      var title = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_TITLE");
	      var body = locMan.localizedStringForKey("CHANGE_PASS_FAIL_ALERT_BODY");
	      var okayButton = locMan.localizedStringForKey("OK_ALERT_BUTTON");
	
	      thisThing.props.appActions.showAlert(title, body, [okayButton], [function () {
	        thisThing.showChangePass();
	      }], function () {});
	    }, function () {
	      thisThing.props.appActions.setSpinnerShown(false);
	      thisThing.props.appActions.showNetworkErrorAlert(function () {
	        thisThing.showChangePass();
	      }, function () {});
	    });
	  },
	
	  contactSupport: function contactSupport() {
	    var email = "hello@getreup.com";
	    var platform = Platform.OS;
	    if (platform == "android") platform = "Android";
	    var subject = this.props.appManager.appNameLong + " Support";
	    var body = "Hi, my email is " + this.props.appManager.currentUser()[ModelConstants.UserName] + " and I am on " + platform + ". I am having an issue with...";
	    var url = "mailto:" + encodeURI(email) + "?subject=" + encodeURI(subject) + "&body=" + encodeURI(body);
	    LinkingManager.canOpenURL(url, function (can) {
	      if (can) {
	        LinkingManager.openURL(url);
	      }
	    });
	  },
	
	  showTerms: function showTerms() {
	    var tosLink = this.props.appManager.getTermsLink();
	    LinkingManager.openURL(tosLink);
	  },
	
	  refreshUser: function refreshUser() {
	    var appManager = this.props.appManager;
	    var userID = appManager.currentUser()[ModelConstants.UserID];
	    var hash = appManager.currentUser()[ModelConstants.Hash];
	    var thisThing = this;
	    console.log("refreshinguser", userID, hash);
	    NetworkManager.getUser(appManager, userID, hash, function (data) {
	      thisThing.setState({ hasOptedInForEmail: data["HasOptedInForEmail"] });
	      appManager.setCurrentUser(data);
	    }, function () {
	      console.log("couldn't refresh user");
	    });
	  },
	
	  unsubscribe: function unsubscribe() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var userID = appManager.currentUser()[ModelConstants.UserID];
	
	    var hash = appManager.currentUser()[ModelConstants.Hash];
	    var thisThing = this;
	    appActions.showLocalizedAlert("UNSUBSCRIBE_CONFIRMATION_ALERT_TITLE", "UNSUBSCRIBE_CONFIRMATION_ALERT_BODY", ["UNSUBSCRIBE_CONFIRMATION_ALERT_NO_BUTTON", "UNSUBSCRIBE_CONFIRMATION_ALERT_CONFIRM_BUTTON"], [function () {
	      appActions.hideAlert();
	    }, function () {
	      thisThing.setState({ hasOptedInForEmail: false });
	      appActions.hideAlert();
	      NetworkManager.optOutEmail(appManager, userID, hash, function () {
	        thisThing.refreshUser();
	      }, function () {});
	    }]);
	  },
	
	  subscribe: function subscribe() {
	    var appManager = this.props.appManager;
	    var userID = appManager.currentUser()[ModelConstants.UserID];
	    var hash = appManager.currentUser()[ModelConstants.Hash];
	    var thisThing = this;
	    console.log("subscribe", userID, hash);
	    NetworkManager.optInEmail(appManager, userID, hash, function () {
	      thisThing.setState({ hasOptedInForEmail: true });
	      thisThing.refreshUser();
	    }, function () {});
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var feedFeatureData = appManager.getFeatureForName("Feed");
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	
	    if (this.state.user == null || !this.props.appManager.isLoggedIn()) // early return if we dont have the user yet
	      {
	        return React.createElement(
	          View,
	          { style: styles.container },
	          React.createElement(Image, {
	            style: [styles.image, { width: this.state.layout.width, height: this.state.layout.height }],
	            source: { uri: bgImage }
	          })
	        );
	      }
	
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	
	    var logoutButton = locManager.localizedStringForKey("LOGOUT_BUTTON");
	
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var profileColor = appManager.getColorForKey("ProfileColor");
	    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
	    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
	    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
	    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
	    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
	    var profileImageColorLight = appManager.getColorForKey("ProfileImageColor", .2);
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var user = this.state.user;
	    var userFullName = user[ModelConstants.FirstName] + " " + user[ModelConstants.LastName];
	    var email = user[ModelConstants.UserName];
	    var initials = appManager.currentUserInitials();
	    var paymentInfo = appManager.getPaymentInfo();
	
	    var profileImageName = appManager.absoluteResourceForPath("Feed/feed_profile_placeholder_admin.png");
	
	    var phoneNumberVerifyFeature = appManager.getFeatureForName('PhoneNumberVerify');
	    var transactionHistoryFeature = appManager.getFeatureForName('TransactionHistory');
	
	    var buttonWidth = 220;
	    var margin = 4;
	
	    var thisThing = this;
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: { flex: 2 } }),
	      React.createElement(
	        View,
	        { style: { flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: 40 } },
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor }, isTitle: true },
	          appManager.currentUserFullName()
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	          appManager.currentUser()[ModelConstants.UserName]
	        )
	      ),
	      typeof transactionHistoryFeature !== 'undefined' ? React.createElement(ReUpButton, { isSecondary: true, appManager: appManager, style: { margin: margin, width: buttonWidth }, text: transactionHistoryFeature.data.title,
	        onPress: function onPress() {
	          appActions.requestFeatureName("TransactionHistory");
	        } }) : null,
	      this.state.hasOptedInForEmail ? React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: margin, width: buttonWidth }, text: locManager.localizedStringForKey("UNSUBSCRIBE_BUTTON"),
	        onPress: function onPress() {
	          thisThing.unsubscribe();
	        } }) : React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: margin, width: buttonWidth }, text: locManager.localizedStringForKey("SUBSCRIBE_BUTTON"),
	        onPress: function onPress() {
	          thisThing.subscribe();
	        } }),
	      React.createElement(View, { style: { flex: 2 } }),
	      React.createElement(ReUpButton, { isTertiary: true, appManager: appManager, text: locManager.localizedStringForKey("TERMS_AND_CONDITIONS_BUTTON"),
	        onPress: function onPress() {
	          thisThing.showTerms();
	        } }),
	      React.createElement(View, { style: { height: 20 } })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'center',
	    flexDirection: 'column',
	    justifyContent: 'center'
	  }
	});
	
	SimpleSettings.dataDependencies = ["Users", "Transactions"];
	
	module.exports = SimpleSettings;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpField = __webpack_require__(26);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var LinkingManager = __webpack_require__(27);
	var createReactClass = __webpack_require__(5);
	
	
	var MK = __webpack_require__(14);
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKIconToggle = MK.MKIconToggle;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	
	  return result;
	}
	
	var TermsPreferences = createReactClass({
	  displayName: 'TermsPreferences',
	
	  getDefaultProps: function getDefaultProps() {
	    var userID = findGetParameter("userid");
	    var hash = findGetParameter("hash");
	    return {
	      appManager: null,
	      userID: userID,
	      hash: hash
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      user: this.props.appManager.currentUser(),
	      showPassword: false,
	      selfieURL: null,
	      hasOptedInForPhone: this.props.appManager.isLoggedIn() && this.props.appManager.currentUser()["hasOptedInForPhone"]
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.refreshUser();
	  },
	
	  contactSupport: function contactSupport() {
	    var email = "hello@getreup.com";
	    var platform = Platform.OS;
	    if (platform == "android") platform = "Android";
	    var subject = this.props.appManager.appNameLong + " Support";
	    var body = "Hi, I am having an issue with...";
	
	    var appManager = this.props.appManager;
	    var locMan = appManager.getLocalizationManager();
	    if (this.props.appManager.currentUser() != null) {
	      var userName = appManager.currentUser()[ModelConstants.UserName];
	      if (appManager.isValidEmail(userName)) body = "Hi, my email is " + userName + " and I am on " + platform + ". I am having an issue with...";else body = "Hi, my phone number is " + locMan.localizedPhone(userName) + " and I am on " + platform + ". I am having an issue with...";
	    }
	
	    var url = "mailto:" + encodeURI(email) + "?subject=" + encodeURI(subject) + "&body=" + encodeURI(body);
	    LinkingManager.openURL(url);
	  },
	
	  refreshUser: function refreshUser() {
	    var appManager = this.props.appManager;
	    var userID = this.props.userID;
	    var hash = this.props.hash;
	    if (this.state.user != null) {
	      userID = this.state.user[ModelConstants.UserID];
	      hash = this.state.user[ModelConstants.Hash];
	    }
	    var thisThing = this;
	    NetworkManager.getUser(appManager, userID, hash, function (data) {
	      thisThing.setState({ hasOptedInForPhone: data["HasOptedInForPhone"] });
	      appManager.setCurrentUser(data);
	    }, function () {
	      console.log("couldn't refresh user");
	    });
	  },
	
	  unsubscribe: function unsubscribe() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var userID = this.props.userID;
	    var hash = this.props.hash;
	    if (this.state.user != null) {
	      userID = this.state.user[ModelConstants.UserID];
	      hash = this.state.user[ModelConstants.Hash];
	    }
	    var thisThing = this;
	    appActions.showAlert("Confirmation", "Are you sure you want to unsubscribe?", ["No", "Unsubscribe"], [function () {
	      appActions.hideAlert();
	    }, function () {
	      thisThing.setState({ hasOptedInForPhone: false });
	      appActions.hideAlert();
	      NetworkManager.optOutPhone(appManager, userID, hash, function () {
	        thisThing.refreshUser();
	      }, function () {});
	    }]);
	  },
	
	  subscribe: function subscribe() {
	    var appManager = this.props.appManager;
	    var userID = this.props.userID;
	    var hash = this.props.hash;
	    if (this.state.user != null) {
	      userID = this.state.user[ModelConstants.UserID];
	      hash = this.state.user[ModelConstants.Hash];
	    }
	    var thisThing = this;
	    NetworkManager.optInPhone(appManager, userID, hash, function () {
	      thisThing.setState({ hasOptedInForPhone: true });
	      thisThing.refreshUser();
	    }, function () {});
	  },
	
	  showTerms: function showTerms() {
	    var tosLink = this.props.appManager.getTermsLink();
	    LinkingManager.openURL(tosLink);
	  },
	
	  render: function render() {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
	
	    var stripHeight = 60;
	    var textWarning = "By signing up with your phone number you agree to receive updates on your reward balance";
	    var unsubscribe = "You may unsubscribe at any time.";
	    var messageRates = "Standard message rates apply.";
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    return React.createElement(
	      View,
	      { style: styles.container },
	      React.createElement(
	        View,
	        { style: { flex: 1, alignSelf: 'stretch', justifyContent: 'center', alignItems: 'center', padding: 20, backgroundColor: generalColor } },
	        React.createElement(
	          View,
	          { style: { alignSelf: 'stretch', marginBottom: 20 } },
	          React.createElement(Image, { style: { width: '100%', height: stripHeight }, resizeMode: "contain", source: { uri: headerImage } })
	        ),
	        React.createElement(
	          View,
	          { style: { margin: 4 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	            textWarning
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { margin: 4 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	            unsubscribe
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { margin: 4 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { textAlign: 'center', color: generalTitleColor } },
	            messageRates
	          )
	        ),
	        React.createElement(View, { style: { flex: 1 } }),
	        this.state.hasOptedInForPhone ? React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: 0, width: 240 }, text: locManager.localizedStringForKey("UNSUBSCRIBE_BUTTON"),
	          onPress: function onPress() {
	            thisThing.unsubscribe();
	          } }) : React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: 0, width: 240 }, text: locManager.localizedStringForKey("SUBSCRIBE_BUTTON"),
	          onPress: function onPress() {
	            thisThing.subscribe();
	          } }),
	        React.createElement(View, { style: { height: 8 } }),
	        React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: 0, width: 240 }, text: locManager.localizedStringForKey("TERMS_AND_CONDITIONS_BUTTON"),
	          onPress: function onPress() {
	            thisThing.showTerms();
	          } }),
	        React.createElement(View, { style: { height: 8 } }),
	        React.createElement(ReUpButton, { appManager: appManager, isSecondary: true, style: { margin: 0, width: 240 }, text: locManager.localizedStringForKey("SUPPORT_BUTTON"),
	          onPress: function onPress() {
	            thisThing.contactSupport();
	          } }),
	        React.createElement(View, { style: { flex: 1 } })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    flexDirection: 'column'
	  }
	});
	
	TermsPreferences.dataDependencies = [];
	
	module.exports = TermsPreferences;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var TransactionHistory = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      transactions: []
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.didUpdate();
	  },
	
	  dataDependencies: function dataDependencies() {
	    return ["Transactions", "Users"];
	  },
	
	  didUpdate: function didUpdate(data) {
	    var transHis = this;
	    this.props.appManager.getDataType("Transactions", function (data) {
	      transHis.setState({ transactions: data });
	    });
	  },
	
	  render: function render() {
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_POINTS_LEFT_STATEMENT");
	    if (user[ModelConstants.Credit] <= 0) creditsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	
	    var compiledTransactions = TransactionHistory.compiledTransactions(this.state.transactions, appManager);
	    var filteredCompiledTransactions = [];
	    for (var i = 0; i < compiledTransactions.length; i++) {
	      var transaction = compiledTransactions[i];
	      var text = TransactionHistory.getCreditPointsText(transaction, appManager);
	      if (text.pointsText == null && text.creditText == null && text.passText == null) continue;
	      filteredCompiledTransactions.push(transaction);
	    }
	
	    var offRowBackgroundColor = appManager.getColorForKey("GeneralTitleColor", 0.05);
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, featureName: "TransactionHistory" },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor }] },
	          React.createElement(
	            View,
	            { style: { alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { numberOfLines: 3, appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor, width: this.state.layout.width - 80 }] },
	              creditsLeftStatement
	            )
	          ),
	          React.createElement(View, { style: { flex: 1 } }),
	          React.createElement(ReUpIconButton, { type: 3,
	            appManager: appManager,
	            featureData: this.props.featureData,
	            appActions: this.props.appActions
	          })
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        filteredCompiledTransactions.map(function (transaction, index) {
	          var text = TransactionHistory.getCreditPointsText(transaction, appManager);
	          if (text.pointsText == null && text.creditText == null && text.passText == null) return React.createElement(View, { key: index });
	          return React.createElement(
	            View,
	            { key: index },
	            React.createElement(
	              View,
	              { style: [styles.transactionRow, { backgroundColor: index % 2 == 0 ? offRowBackgroundColor : 'transparent' }] },
	              React.createElement(
	                ReUpText,
	                { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.dateText, { color: generalTitleColor }] },
	                locManager.dateTime(text.timeStamp)
	              ),
	              text.creditText == null ? null : React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor }] },
	                text.creditText
	              ),
	              text.pointsText == null ? null : React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor }] },
	                text.pointsText
	              ),
	              text.passText == null ? null : React.createElement(
	                ReUpText,
	                { appManager: appManager, style: [{ color: generalTitleColor }] },
	                text.passText
	              )
	            ),
	            React.createElement(View, { style: styles.transactionDivider })
	          );
	        })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  dateText: {
	    opacity: .6
	  },
	  transactionRow: {
	    padding: 10
	  },
	  transactionDivider: {
	    height: 1,
	    backgroundColor: '#DADADA'
	  }
	});
	
	TransactionHistory.dataDependencies = ["Transactions", "Users"];
	// TODO: should have users too
	// TransactionHistory.dataDependencies = ["Transactions", "Users"];
	
	TransactionHistory.getCreditPointsText = function (transaction, appManager) {
	  var locManager = appManager.getLocalizationManager();
	  var creditTransaction = transaction.creditTransaction;
	  var pointsTransaction = transaction.pointsTransaction;
	  var passTransaction = transaction.passTransaction;
	  var creditText = null;
	  var pointsText = null;
	  var passText = null;
	  var dateText = null;
	  var timeStamp = null;
	  if (creditTransaction != null) {
	    dateText = typeof creditTransaction.TimestampEpoch !== 'undefined' && creditTransaction.TimestampEpoch > 0 ? appManager.timeSince(creditTransaction.TimestampEpoch) : appManager.timeSince(creditTransaction.Timestamp);
	    timeStamp = creditTransaction.Timestamp;
	    var credit = parseFloat(creditTransaction['Credit']);
	    if (credit == 0) {} else if (credit < 0) {
	      if (creditTransaction["Source"] == "99") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(-credit)]);
	      } else if (creditTransaction["Source"] == "6") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_SENT_GC_STATEMENT", [locManager.localizedDollars(-credit), "You sent a %0% gift card!"]);
	      } else {
	        creditText = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(-credit)]);
	      }
	    } else {
	      if (creditTransaction["Source"] == "99") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locManager.localizedDollars(credit)]);
	      } else if (creditTransaction["Source"] == "6") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_GC_STATEMENT", [locManager.localizedDollars(credit), "You received a %0% gift card!"]);
	      } else if (creditTransaction["Source"] == "11") {
	        creditText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locManager.localizedDollars(credit)], "You transferred %0% from an old loyalty account!");
	      } else {
	        creditText = locManager.localizedStringForKeyAndParams("USER_DEPOSITED_STATEMENT", [locManager.localizedDollars(credit)]);
	      }
	    }
	  }
	
	  if (pointsTransaction != null) {
	    dateText = typeof pointsTransaction.TimestampEpoch !== 'undefined' && pointsTransaction.TimestampEpoch > 0 ? appManager.timeSince(pointsTransaction.TimestampEpoch) : appManager.timeSince(pointsTransaction.Timestamp);
	    timeStamp = pointsTransaction.Timestamp;
	    var points = parseInt(pointsTransaction['Points']);
	    if (points == 0) {} else if (points < 0) {
	      points = Math.abs(points);
	      if (pointsTransaction["Source"] == "99") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_LOST_STATEMENT", [locManager.localizedPoints(points)]);
	      } else if (pointsTransaction["Source"] == "6") {
	
	        pointsText = locManager.localizedStringForKeyAndParams("USER_SENT_POINTS_STATEMENT", [locManager.localizedPoints(points)], "You sent %0%!");
	
	        pointsText = "";
	      } else {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", [locManager.localizedPoints(points)]);
	      }
	    } else {
	      var locPoints = locManager.localizedPoints(points);
	      if (pointsTransaction["Source"] == "99") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_REFUNDED_STATEMENT", [locPoints]);
	      } else if (pointsTransaction["Source"] == "6") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_RECEIVED_POINTS_STATEMENT", [locPoints], "You received %0%!");
	      } else if (pointsTransaction["Source"] == "11") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_TRANSFERRED_OLD_ACCOUNT_STATEMENT", [locPoints], "You transferred %0% from an old loyalty account!");
	      } else if (pointsTransaction["Source"] == "10") {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_POINTS_FOR_REFERRAL", [locPoints] + "You earned %0% for a referral");
	      } else {
	        pointsText = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locPoints]);
	      }
	    }
	  }
	
	  if (passTransaction != null) {
	    dateText = typeof passTransaction.TimestampEpoch !== 'undefined' && passTransaction.TimestampEpoch > 0 ? appManager.timeSince(passTransaction.TimestampEpoch) : appManager.timeSince(passTransaction.Timestamp);
	    timeStamp = passTransaction.Timestamp;
	    if (passTransaction.IsCredit == "1") {
	      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_PURCHASE", [passTransaction.PassQuantityRemaining, passTransaction.PassName, locManager.localizedDollars(passTransaction.Credit)], "You purchased %0% %1% for %2%!");
	    } else {
	      passText = locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassName], "You redeemed one of the %0%.");
	      if (passTransaction.PassQuantityRemaining > 0) passText += " " + locManager.localizedStringForKeyAndParams("PASS_TRANSACTION_REDEEMED", [passTransaction.PassQuantityRemaining], "Only %0% are left!");else passText += " " + locManager.localizedStringForKey("PASS_TRANSACTION_NONE_ARE_LEFT", "None are left.");
	    }
	  }
	
	  return { creditText: creditText, pointsText: pointsText, passText: passText, dateText: dateText, timeStamp: timeStamp };
	};
	
	TransactionHistory.compiledTransactions = function (transactions, appManager) {
	  var timeThreshold = 2000;
	  if (transactions == null) return [];
	
	  transactions = transactions.sort(function (a, b) {
	    return appManager.getTime(b.Timestamp) - appManager.getTime(a.Timestamp);
	  });
	  var compiledTransactions = [];
	  for (var i = 0; i < transactions.length; i++) {
	    var thisTrans = transactions[i];
	    if (thisTrans.IsDeleted == '1') continue;
	    var thisCreditTrans = null;
	    var thisPointsTrans = null;
	    var thisPassTrans = null;
	    if (thisTrans.IsCredit == "1") {
	      if (typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0) {
	        thisPassTrans = thisTrans;
	      } else {
	        thisCreditTrans = thisTrans;
	      }
	    } else {
	      if (typeof thisTrans.PassID !== 'undefined' && thisTrans.PassID.length > 0) {
	        thisPassTrans = thisTrans;
	      } else {
	        thisPointsTrans = thisTrans;
	      }
	    }
	
	    if (i < transactions.length - 1) {
	      var nextTrans = transactions[i + 1];
	      if (nextTrans.IsDeleted == '1') continue;
	      var thisTime = appManager.getTime(thisTrans.Timestamp);
	      var nextTime = appManager.getTime(nextTrans.Timestamp);
	      if (Math.abs(thisTime - nextTime) <= timeThreshold) {
	        if (typeof nextTrans.PassID !== 'undefined' && nextTrans.PassID.length > 0 && thisPassTrans != null) {
	          if (thisPassTrans.Credit < 0 && nextTrans.Credit > 0) {
	            thisPassTrans = nextTrans;
	          }
	          i++;
	        } else if (nextTrans.IsCredit == "1" && thisCreditTrans == null) {
	          thisCreditTrans = nextTrans;
	          i++;
	        } else if (thisPointsTrans == null && nextTrans.IsCredit != "1") {
	          thisPointsTrans = nextTrans;
	          i++;
	        }
	      }
	    }
	    compiledTransactions.push({ pointsTransaction: thisPointsTrans, creditTransaction: thisCreditTrans, passTransaction: thisPassTrans });
	  }
	
	  return compiledTransactions;
	};
	
	TransactionHistory.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var locManager = appActions._appManager.getLocalizationManager();
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var cards = [];
	  var transactions = data != null && typeof data !== 'undefined' && typeof data.Transactions !== 'undefined' && data.Transactions != null ? TransactionHistory.compiledTransactions(data.Transactions, appActions._appManager) : [];
	  if (transactions.length <= 0) return [];
	  var didSelect = function didSelect() {
	    appActions.requestFeatureName("TransactionHistory");
	  };
	  var transactionData = [];
	  var MAX_TRANSACTIONS = 3;
	  var biggestTimeStamp = 0;
	  for (var i = 0; i < transactions.length && i < MAX_TRANSACTIONS; i++) {
	    var thisData = [];
	    var transaction = transactions[i];
	    var pointsTransaction = transaction.pointsTransaction;
	    var creditTransaction = transaction.creditTransaction;
	    var passTransaction = transaction.passTransaction;
	
	    if (passTransaction == null) {
	      var date = transaction.pointsTransaction == null ? creditTransaction.Timestamp : pointsTransaction.Timestamp;
	      thisData.push(locManager.localizedLongDate(date));
	      var thisDateTime = appManager.getTime(date);
	      if (thisDateTime > biggestTimeStamp) {
	        biggestTimeStamp = thisDateTime;
	      }
	
	      if (pointsTransaction != null) thisData.push(locManager.localizedPts(pointsTransaction.Points));else thisData.push(locManager.localizedPts(0));
	
	      if (creditTransaction != null) thisData.push(locManager.localizedDollars(creditTransaction.Credit));else thisData.push(locManager.localizedDollars(0));
	
	      transactionData.push(thisData);
	    }
	  }
	
	  if (transactionData.length <= 0) return [];
	
	  if (transactions.length > MAX_TRANSACTIONS) {
	    var moreLabel = locManager.localizedStringForKey("MORE_LABEL");
	    transactionData.push(["", "", moreLabel]);
	  }
	
	  var sortOrder = new Date().getTime() - biggestTimeStamp;
	
	  return [{
	    didSelect: didSelect,
	    title: featureData.data.title,
	    columnData: transactionData,
	    icon: iconName,
	    cardType: 0,
	    sortOrder: sortOrder
	  }];
	};
	
	module.exports = TransactionHistory;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	
	var ShadowView = __webpack_require__(20);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var TransactionResult = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  render: function render() {
	
	    // {
	    //     "jsonrpc": "2.0",
	    //     "error": {
	    //         "code": -11,
	    //         "message": "NSF -- Not enough credit",
	    //         "usermsg": "",
	    //         "AppStoreURL": "",
	    //         "PlayStoreURL": ""
	    //     },
	    //     "result": {
	    //         "FirstName": "ReUp",
	    //         "LastName": "Scanner",
	    //         "UserCredit": "0.00",
	    //         "Total": 0.08
	    //     },
	    //     "info": {
	    //         "Profile": 0.0451028347015
	    //     },
	    //     "ID": 1
	    // }
	
	    var appManager = this.props.appManager;
	    appManager._lastTransaction = this.props.extras;
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    var textStyle1 = { fontSize: 18 };
	    var textStyle2 = { fontSize: 22, fontWeight: 'bold' };
	    var locMan = this.props.appManager.getLocalizationManager();
	    var assignPointsHeader = locMan.localizedStringForKey("ASSIGN_POINTS_HEADER");
	    var successHeader = locMan.localizedStringForKey("SUCCESS_HEADER");
	    var purchaseHeader = locMan.localizedStringForKey("PURCHASE_HEADER");
	    var rewardHeader = locMan.localizedStringForKey("REWARD_HEADER");
	    var redeemedHeader = locMan.localizedStringForKey("REDEEMED_HEADER");
	    var passHeader = locMan.localizedStringForKey("PASS_HEADER");
	    var transferHeader = locMan.localizedStringForKey("TRANSFER_HEADER");
	    var creditAddHeader = locMan.localizedStringForKey("CREDIT_ADD_HEADER");
	    if (this.props.extras.success) {
	      var userCurrentCredit = locMan.localizedStringForKeyAndParams("USERS_CREDIT_LABEL", [locMan.localizedDollars(this.props.extras.UserCredit)]);
	      var headerBlurb = this.props.extras.isCheckin ? assignPointsHeader + "\n" + successHeader : purchaseHeader + "\n" + successHeader;
	      var headerColor = this.props.extras.isCheckin ? "blue" : "green";
	      var iconName = "usd";
	      if (this.props.extras.isCheckin) iconName = "map-marker";
	      if (this.props.extras.isReward) {
	        iconName = "star";
	        headerColor = "purple";
	        headerBlurb = rewardHeader + "\n" + redeemedHeader;
	      }
	      if (this.props.extras.isPass) {
	        iconName = "ticket";
	        headerColor = "green";
	        headerBlurb = passHeader + "\n" + redeemedHeader;
	      }
	      if (this.props.extras.isTransfer) {
	        iconName = "exchange";
	        headerColor = "black";
	        headerBlurb = transferHeader + "\n" + successHeader;
	      }
	      if (this.props.extras.isAddingCredit) {
	        iconName = "usd";
	        headerColor = "green";
	        headerBlurb = creditAddHeader + "\n" + successHeader;
	      }
	
	      var tipTotalIsNotZero = typeof this.props.extras.TipTotal !== 'undefined' && this.props.extras.TipTotal > 0;
	
	      return React.createElement(
	        View,
	        { style: [styles.container, { flexDirection: 'column' }] },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', flex: 1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flex: 1, backgroundColor: headerColor } },
	            React.createElement(
	              View,
	              { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(
	                ReUpText,
	                { style: { fontSize: 22, fontWeight: 'bold', color: 'white' } },
	                headerBlurb
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', name: iconName, size: 96, color: "white" })
	            )
	          ),
	          React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', justifyContent: 'center', flex: 2, padding: 10 } },
	            React.createElement(
	              ScrollView,
	              { style: { flex: 1 } },
	              typeof this.props.extras.reward !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'column', padding: 8, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle2 },
	                  this.props.extras.reward.RewardName
	                ),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle2 },
	                  locMan.localizedPoints(this.props.extras.reward.Points)
	                )
	              ) : null,
	              typeof this.props.extras.PassName !== 'undefined' && typeof this.props.extras.PassQuantityRemaining !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'column', padding: 8, alignItems: 'center', justifyContent: 'center' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle2 },
	                  this.props.extras.PassName
	                ),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle2 },
	                  this.props.extras.PassQuantityRemaining + " Remaining."
	                )
	              ) : null,
	              typeof this.props.extras.Subtotal !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("SUBTOTAL_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedDollars(this.props.extras.Subtotal)
	                )
	              ) : null,
	              typeof this.props.extras.ServiceFee !== 'undefined' ? React.createElement(
	                View,
	                { style: { marginLeft: 30, flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("SERVICE_FEE_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedDollars(this.props.extras.ServiceFee)
	                )
	              ) : null,
	              typeof this.props.extras.TipTotal !== 'undefined' ? React.createElement(
	                View,
	                { style: { marginLeft: 30, flexDirection: 'row', backgroundColor: tipTotalIsNotZero ? 'yellow' : 'transparent' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("TIP_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedDollars(this.props.extras.TipTotal)
	                )
	              ) : null,
	              React.createElement(View, { style: { backgroundColor: 'black', height: 2, marginLeft: 30, marginBottom: 10 } }),
	              typeof this.props.extras.CreditUsed !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: [textStyle1, { fontWeight: 'bold' }] },
	                  locMan.localizedStringForKey("TOTAL_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: [textStyle1, { fontWeight: 'bold' }] },
	                  locMan.localizedDollars(this.props.extras.CreditUsed)
	                )
	              ) : null,
	              typeof this.props.extras.CreditAdded !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row', marginTop: 20 } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("CREDIT_ADDED_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedDollars(this.props.extras.CreditAdded)
	                )
	              ) : React.createElement(View, { style: { height: 20 } }),
	              typeof this.props.extras.PointsEarned !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("POINTS_EARNED_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedPoints(this.props.extras.PointsEarned)
	                )
	              ) : null,
	              React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	              typeof this.props.extras.TransactionID !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row', marginTop: 20 } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("TRANSACTION_ID_LABEL_2")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  this.props.extras.TransactionID
	                )
	              ) : null,
	              typeof this.props.extras.UserName !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  this.props.extras.UserName.indexOf("@") >= 0 ? locMan.localizedStringForKey("EMAIL_LABEL") : locMan.localizedStringForKey("PHONE_NUMBER_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  this.props.extras.UserName.indexOf("@") >= 0 ? this.props.extras.UserName : locMan.localizedPhone(this.props.extras.UserName)
	                )
	              ) : null,
	              typeof this.props.extras.GCID !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("GIFT_CARD_ID_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  this.props.extras.GCID
	                )
	              ) : null,
	              typeof this.props.extras.FirstName !== 'undefined' && typeof this.props.extras.LastName !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("NAME_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  this.props.extras.FirstName + " " + this.props.extras.LastName
	                )
	              ) : null,
	              typeof this.props.extras.CurrentCredit !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedDollars(this.props.extras.CurrentCredit)
	                )
	              ) : null,
	              typeof this.props.extras.CurrentPoints !== 'undefined' ? React.createElement(
	                View,
	                { style: { flexDirection: 'row' } },
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedStringForKey("CURRENT_POINTS_LABEL")
	                ),
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  ReUpText,
	                  { style: textStyle1 },
	                  locMan.localizedPoints(this.props.extras.CurrentPoints)
	                )
	              ) : null
	            ),
	            React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10 }],
	              appManager: appManager,
	              text: locMan.localizedStringForKey("SCAN_NEW_BUTTON"),
	              onPress: function onPress() {
	                thisThing.props.appActions.requestPopToIndex(1);
	                if (typeof thisThing.props.extras.scanner !== 'undefined') {
	                  setTimeout(function () {
	                    thisThing.props.extras.scanner.scan();
	                  }, 300);
	                }
	              }
	            })
	          )
	        )
	      );
	    } else {
	      var errorAcronym = this.props.extras.code == -11 ? "NSF" : this.props.extras.code == -3 ? "ERR" : "NSP";
	
	      var userCurrentCredit = this.props.extras.code == -3 ? "" : locMan.localizedStringForKeyAndParams("USERS_CREDIT_LABEL", [this.props.appManager.getLocalizationManager().localizedDollars(this.props.extras.result.UserCredit)], "User's Credit: %0%");
	      return React.createElement(
	        View,
	        { style: [styles.container, { flexDirection: 'column' }] },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'column', flex: 1 } },
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', flex: 1, backgroundColor: 'red' } },
	            React.createElement(
	              View,
	              { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(
	                ReUpText,
	                { style: { fontSize: 64, fontWeight: 'bold', color: 'white' } },
	                errorAcronym
	              )
	            ),
	            React.createElement(
	              View,
	              { style: { flex: 1, alignItems: 'center', justifyContent: 'center' } },
	              React.createElement(_ReUpIcon2.default, { pointerEvents: 'none', name: "times", size: 96, color: "white" })
	            )
	          ),
	          React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', justifyContent: 'center', flex: 2, padding: 10 } },
	            typeof this.props.extras.message !== 'undefined' ? React.createElement(
	              ReUpText,
	              { style: { fontSize: 22, color: 'black' } },
	              this.props.extras.message
	            ) : null,
	            React.createElement(ShadowView, { layout: this.state.layout, appManager: appManager }),
	            typeof this.props.extras.result.FirstName !== 'undefined' && typeof this.props.extras.result.LastName !== 'undefined' ? React.createElement(
	              View,
	              { style: { flexDirection: 'row', marginTop: 20 } },
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedStringForKey("NAME_LABEL")
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                this.props.extras.result.FirstName + " " + this.props.extras.result.LastName
	              )
	            ) : null,
	            typeof this.props.extras.result.CurrentCredit !== 'undefined' ? React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedDollars(this.props.extras.result.CurrentCredit)
	              )
	            ) : null,
	            typeof this.props.extras.result.UserCredit !== 'undefined' ? React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedStringForKey("CURRENT_CREDIT_LABEL")
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedDollars(this.props.extras.result.UserCredit)
	              )
	            ) : null,
	            typeof this.props.extras.result.CurrentPoints !== 'undefined' ? React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedStringForKey("CURRENT_POINTS_LABEL", "Current Credit:")
	              ),
	              React.createElement(View, { style: { flex: 1 } }),
	              React.createElement(
	                ReUpText,
	                { style: textStyle1 },
	                locMan.localizedPoints(this.props.extras.result.CurrentPoints)
	              )
	            ) : null,
	            React.createElement(View, { style: { flex: 1 } }),
	            React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10 }],
	              appManager: appManager,
	              text: locMan.localizedStringForKey("SCAN_NEW_BUTTON"),
	              onPress: function onPress() {
	                thisThing.props.appActions.requestPopToIndex(1);
	                if (typeof thisThing.props.extras.scanner !== 'undefined') {
	                  setTimeout(function () {
	                    thisThing.props.extras.scanner.scan();
	                  }, 300);
	                }
	              }
	            })
	          )
	        )
	      );
	    }
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	TransactionResult.dataDependencies = [];
	
	module.exports = TransactionResult;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _regenerator = __webpack_require__(114);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	var _reactNativeCameraWrapper = __webpack_require__(77);
	
	var _reactNativeCameraWrapper2 = _interopRequireDefault(_reactNativeCameraWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var Globals = __webpack_require__(10);
	var NetworkManager = __webpack_require__(15);
	var ModelConstants = __webpack_require__(11);
	var ReUpButton = __webpack_require__(12);
	var ReUpScrollView = __webpack_require__(16);
	var ReUpText = __webpack_require__(8);
	var PlatformConstants = __webpack_require__(31);
	var Sound = __webpack_require__(1170);
	Sound.setCategory('Playback');
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    AppState = ReactNative.AppState,
	    Platform = ReactNative.Platform,
	    StyleSheet = ReactNative.StyleSheet,
	    Keyboard = ReactNative.Keyboard;
	
	
	var creditQR = { "Type": "credit", "AppID": "reup0", "U": "101", "H": "610aa656aa", "T": 0, "TT": "P" };
	var rewardQR = { T: 'reward', R: '5', "AppID": "reup0", U: '251', "H": '377b46debc' };
	var checkinQR = { Type: 'checkin', "AppID": "reup0", "U": "101", "H": "35a964eff9" };
	var passQR = { Type: 'pass', P: '1', "AppID": "reup0", U: '2', "H": '99dd4cc155' };
	var giftCardQR = { "U": "15", "T": "GC", "H": "ce1086dedd" }; //{T:'GC',"AppID":"reup0",U:'101',H:'610aa656aa'};
	var garbageQR = "asdfasdf";
	
	var MAX_SCAN_TRIES = 3;
	
	var beep = null;
	
	var TransactionScan = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      isDebugging: false,
	      extras: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      isScanning: false,
	      buttonOpacity: new Animated.Value(0),
	      qrCodeOpacity: new Animated.Value(0),
	      showPhoneButton: true,
	      hasPermission: Platform.OS !== 'ios' // only need to request on ios for now
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    beep = new Sound('beep.mp3', Sound.MAIN_BUNDLE, function (error) {
	      if (error) {
	        return;
	      }
	      // loaded successfully
	    });
	    Keyboard.dismiss();
	    var thisThing = this;
	
	    if (!this.state.hasPermission) {
	      var someAsyncFunction = function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, _this);
	        }));
	
	        return function someAsyncFunction() {
	          return _ref.apply(this, arguments);
	        };
	      }();
	    } else {
	      setTimeout(function () {
	        thisThing.scan();
	      }, 200);
	    }
	
	    this.props.appManager._eventEmitter.on('stopScan', this.stopScan, this);
	    AppState.addEventListener('change', this._handleAppStateChange);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    AppState.removeEventListener('change', this._handleAppStateChange);
	    this.props.appManager._eventEmitter.removeListener('stopScan', this.stopScan, this);
	  },
	
	  getPermission: function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(succeeded, failed) {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.next = 2;
	              return _reactNativeCameraWrapper2.default.checkVideoAuthorizationStatus();
	
	            case 2:
	              if (!_context2.sent) {
	                _context2.next = 6;
	                break;
	              }
	
	              succeeded();
	              _context2.next = 7;
	              break;
	
	            case 6:
	              failed();
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, this);
	    }));
	
	    function getPermission(_x, _x2) {
	      return _ref2.apply(this, arguments);
	    }
	
	    return getPermission;
	  }(),
	
	  _handleAppStateChange: function _handleAppStateChange(appState) {
	    if (appState == 'active') {
	      // this.scan();
	    } else {
	      this.stopScan();
	    }
	  },
	
	  didUpdate: function didUpdate(data) {
	    if (typeof data.Rewards !== 'undefined') {
	      this._rewards = data.Rewards;
	      this._passes = data.Passes;
	    }
	  },
	
	
	  _qrCodePulsing: false,
	  setQRCodePulsing: function setQRCodePulsing(enable) {
	    if (enable != this._qrCodePulsing) {
	      if (enable) {
	        this.fadeInQRCode();
	      }
	      this._qrCodePulsing = enable;
	    }
	  },
	
	  fadeInQRCode: function fadeInQRCode() {
	    var thisThing = this;
	    Animated.timing(thisThing.state.qrCodeOpacity, { toValue: 1,
	      duration: 700 }).start(function () {
	      if (thisThing._qrCodePulsing) thisThing.fadeOutQRCode();
	    });
	  },
	
	  fadeOutQRCode: function fadeOutQRCode() {
	    var thisThing = this;
	    Animated.timing(thisThing.state.qrCodeOpacity, { toValue: 0,
	      duration: 700 }).start(function () {
	      if (thisThing._qrCodePulsing) thisThing.fadeInQRCode();
	    });
	  },
	
	  _scannerTimeout: null,
	  _SCANNER_TIMEOUT_SECONDS: 60,
	  scan: function scan() {
	    var thisThing = this;
	    thisThing._scanTries = 0;
	    var appActions = this.props.appActions;
	    if (Platform.OS == 'ios') {
	      this.getPermission(function () {
	        thisThing._hasScanned = false;
	        thisThing._scannerTimeout = setTimeout(function () {
	          thisThing.stopScan();
	        }, thisThing._SCANNER_TIMEOUT_SECONDS * 1000);
	        thisThing.setState({ isScanning: true, hasPermission: true });
	      }, function () {
	        appActions.showLocalizedAlert("Camera Permission Error", "To use the scanner, the camera permission must be turned on. Please enable the camera for this app in your device settings.", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	      });
	    } else {
	      thisThing._hasScanned = false;
	      thisThing.setState({ isScanning: true, hasPermission: true });
	    }
	  },
	
	  stopScan: function stopScan() {
	    if (this._scannerTimeout != null) {
	      clearTimeout(this._scannerTimeout);
	      this._scannerTimeout = null;
	    }
	    this.setState({ isScanning: false });
	  },
	
	  _rewards: [],
	  getReward: function getReward(rewardID, userID, hash, completion) {
	    for (var i = 0; i < this._rewards.length; i++) {
	      if (this._rewards[i].rewardID == rewardID) {
	        completion(this._rewards[i]);
	        return;
	      }
	    }
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    appActions.setSpinnerShown("Fetching Rewards...");
	    NetworkManager.updateFeature(this.props.appManager, "Rewards", function (data) {
	      thisThing._rewards = data;
	      for (var i = 0; i < thisThing._rewards.length; i++) {
	        if (thisThing._rewards[i].RewardID == rewardID) {
	          appActions.setSpinnerShown(false);
	          completion(thisThing._rewards[i]);
	          return;
	        }
	      }
	      // if not found, try to get one time reward
	      NetworkManager.getOneTimeRewards(thisThing.props.appManager, userID, hash, function (oneTimeRewards) {
	        appActions.setSpinnerShown(false);
	        for (var i = 0; i < oneTimeRewards.length; i++) {
	          thisThing._rewards.push(oneTimeRewards[i]);
	          if (oneTimeRewards[i].RewardID == rewardID) {
	            completion(oneTimeRewards[i]);
	            return;
	          }
	        }
	        completion(null);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        completion(null);
	      }, function (data) {
	        appActions.setSpinnerShown(false);
	        completion(null);
	        appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	      });
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      completion(null);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      completion(null);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	    });
	  },
	
	  _passes: [],
	  getPass: function getPass(passID, completion) {
	    for (var i = 0; i < this._passes.length; i++) {
	      if (this._passes[i].passID == passID) {
	        completion(this._passes[i]);
	        return;
	      }
	    }
	
	    var thisThing = this;
	    var appActions = this.props.appActions;
	    appActions.setSpinnerShown("Fetching Passes...");
	    NetworkManager.updateFeature(this.props.appManager, "Passes", function (data) {
	      appActions.setSpinnerShown(false);
	      thisThing._passes = data;
	      for (var i = 0; i < thisThing._passes.length; i++) {
	        if (thisThing._passes[i].PassID == passID) {
	          completion(thisThing._passes[i]);
	          return;
	        }
	      }
	      completion(null);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      completion(null);
	    }, function (data) {
	      appActions.setSpinnerShown(false);
	      completion(null);
	      appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	    });
	  },
	
	  _hasScanned: false,
	  didScanData: function didScanData(data) {
	    if (this._hasScanned) return;
	    this._hasScanned = true;
	
	    // Play the sound with an onEnd callback
	    beep.play(function (success) {});
	
	    var thisThing = this;
	    try {
	      var appActions = this.props.appActions;
	      var appManager = this.props.appManager;
	      var locManager = appManager.getLocalizationManager();
	      var jsonString = atob(data);
	      var obj = JSON.parse(jsonString);
	      var extras = data;
	      if (obj) {
	        var scannerAppID = appManager.currentUser().AppID;
	        var qrAppID = obj.AppID;
	        var userID = typeof obj.U !== 'undefined' ? obj.U : typeof obj.UserID !== 'undefined' ? obj.UserID : -1;
	        var type = typeof obj.T !== 'undefined' ? obj.T : typeof obj.Type !== 'undefined' ? obj.Type : 'credit';
	        var rewardID = typeof obj.R !== 'undefined' ? obj.R : typeof obj.RewardID !== 'undefined' ? obj.RewardID : '';
	        var passID = typeof obj.P !== 'undefined' ? obj.P : typeof obj.PassID !== 'undefined' ? obj.PassID : '';
	        var hash = typeof obj.H !== 'undefined' ? obj.H : typeof obj.Hash !== 'undefined' ? obj.Hash : '';
	        obj.userID = userID;
	        obj.type = type;
	        obj.rewardID = rewardID;
	        obj.passID = passID;
	        obj.hash = hash;
	        if (qrAppID != scannerAppID && !(type == "GC" || type == "giftcard")) // dont do check for gc
	          {
	            thisThing.stopScan();
	            var QRalertTitle = locManager.localizedStringForKey("INVALID_QR_CODE_SCANNER_ALERT_TITLE", "Invalid QR Code");
	            var QRalertBody = locManager.localizedStringForKey("INVALID_QR_CODE_SCANNER_ALERT_BODY", "This QR Code is not for your store.");
	            var okButton = locManager.localizedStringForKey("OK_ALERT_BUTTON", "OK");
	            appActions.showAlert(QRalertTitle, QRalertBody, [okButton], [function () {
	              thisThing.scan();
	              appActions.hideAlert();
	            }], function () {});
	            return;
	          }
	        if (type == "GC" || type == "giftcard") // is gift card
	          {
	            this.stopScan();
	            appActions.setSpinnerShown(true, "Retrieving User...");
	            NetworkManager.getGCInfoByUserIDVendor(appManager, userID, hash, function (data) {
	              var qrcode = obj;
	              for (var key in data) {
	                qrcode[key] = data[key];
	              }
	              // this is a hack for the cap sensitivity
	              if (typeof qrcode.PhoneNumber !== 'undefined') qrcode.phoneNumber = qrcode.PhoneNumber;
	              qrcode.scanner = thisThing;
	              qrcode.hash = hash;
	              appActions.setSpinnerShown(false);
	              appActions.requestFeatureName("GiftCardOptions", qrcode);
	            }, function (data) {
	              appActions.setSpinnerShown(false);
	              appActions.showLocalizedAlert("Error", "Unable to get gift card info.", ["OK_ALERT_BUTTON"], [function () {
	                thisThing.scan();
	                appActions.hideAlert();
	              }], appActions.hideAlert);
	            }, function (data) {
	              appActions.setSpinnerShown(false);
	              appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	            });
	          } else if (type == "R" || type == "reward" || rewardID.length > 0) // redeem reward
	          {
	            this.stopScan();
	            var rewardID = typeof obj.R !== 'undefined' ? obj.R : -1;
	            var hash = typeof obj.H !== 'undefined' ? obj.H : typeof obj.Hash !== 'undefined' ? obj.Hash : -1;
	            this.getReward(rewardID, userID, hash, function (reward) {
	              if (reward == null) {
	                appActions.showLocalizedAlert("Invalid Reward", "This reward no longer exists.", ["OK_ALERT_BUTTON"], [function () {
	                  appActions.hideAlert();
	                  thisThing.scan();
	                }], function () {});
	              } else {
	                var rewardName = reward.RewardName;
	                appActions.showLocalizedAlert(rewardName, "Allow this customer to redeem for reward: " + rewardName + "?", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	                  appActions.hideAlert();
	                  thisThing.scan();
	                }, function () {
	                  appActions.hideAlert();
	                  var redeemingSpinner = locManager.localizedStringForKey("REDEEMING_SPINNER", "Redeeming...");
	                  appActions.setSpinnerShown(true, redeemingSpinner);
	                  NetworkManager.vendorRedeemReward(appManager, userID, rewardID, type, hash, function (data) {
	                    appActions.setSpinnerShown(false);
	                    data.success = true;
	                    data.scanner = thisThing;
	                    data.isReward = true;
	                    data.reward = reward;
	                    appActions.requestFeatureName("TransactionResult", data);
	                  }, function (data) {
	                    appActions.setSpinnerShown(false);
	                    data.success = false;
	                    data.scanner = thisThing;
	                    data.reward = reward;
	                    appActions.requestFeatureName("TransactionResult", data);
	                  }, function (data) {
	                    appActions.setSpinnerShown(false);
	                    appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	                  });
	                }], function () {});
	              }
	            });
	          } else if (type == "P" || type == "pass" || passID.length > 0) // redeem pass
	          {
	            this.stopScan();
	            var passID = typeof obj.P !== 'undefined' ? obj.P : -1;
	            var hash = typeof obj.H !== 'undefined' ? obj.H : typeof obj.Hash !== 'undefined' ? obj.Hash : -1;
	            this.getPass(passID, function (pass) {
	              if (pass == null) {
	                appActions.showLocalizedAlert("Invalid Pass", "This pass no longer exists.", ["OK_ALERT_BUTTON"], [function () {
	                  appActions.hideAlert();
	                  thisThing.scan();
	                }], function () {});
	              } else {
	                var passName = pass.Name;
	                var validPassTitle = locManager.localizedStringForKeyAndParams("ALLOW_CUSTOMER_REDEEM_PASS_ALERT_BODY", [passName], "Allow this customer to redeem pass: %0%?");
	                var nobutton = locManager.localizedStringForKey("NO_ALERT_BUTTON", "No");
	                var yesButton = locManager.localizedStringForKey("YES_ALERT_BUTTON", "Yes");
	                appActions.showAlert(passName, validPassTitle, [nobutton, yesButton], [function () {
	                  appActions.hideAlert();
	                  thisThing.scan();
	                }, function () {
	                  appActions.hideAlert();
	                  appActions.setSpinnerShown(true, "Redeeming...");
	                  NetworkManager.vendorRedeemPass(appManager, userID, passID, hash, function (data) {
	                    appActions.setSpinnerShown(false);
	                    data.success = true;
	                    data.scanner = thisThing;
	                    data.isPass = true;
	                    data.pass = pass;
	                    appActions.requestFeatureName("TransactionResult", data);
	                  }, function (data) {
	                    appActions.setSpinnerShown(false);
	                    data.success = false;
	                    data.scanner = thisThing;
	                    data.pass = pass;
	                    appActions.requestFeatureName("TransactionResult", data);
	                  }, function (data) {
	                    appActions.setSpinnerShown(false);
	                    appActions.showNetworkErrorAlert(appActions.hideAlert, appActions.hideAlert);
	                  });
	                }], function () {});
	              }
	            });
	          } else if (type == "checkin") // checkin
	          {
	            setTimeout(this.stopScan, 1000);
	            var userID = typeof obj.U !== 'undefined' ? obj.U : typeof obj.UserID !== 'undefined' ? obj.UserID : -1;
	            obj.scanner = thisThing;
	            obj.userID = userID;
	            obj.hash = typeof obj.H !== 'undefined' ? obj.H : typeof obj.Hash !== 'undefined' ? obj.Hash : -1;
	            this.props.appActions.requestFeatureName("CheckInInput", obj);
	          } else // must be credit
	          {
	            setTimeout(this.stopScan, 1000);
	            obj.scanner = thisThing;
	            this.props.appActions.requestFeatureName("CreditInput", obj);
	          }
	      }
	    } catch (e) {
	      thisThing._scanTries++;
	      if (thisThing._scanTries >= MAX_SCAN_TRIES) {
	        appActions.showLocalizedAlert("Invalid QR Code", "Please only scan ReUp app, gift card or pass QR codes from your own account.", ["OK_ALERT_BUTTON"], [function () {
	          appActions.hideAlert();
	        }], function () {});
	        thisThing.stopScan();
	      }
	      thisThing._hasScanned = false;
	    } finally {}
	  },
	
	  verifyLogout: function verifyLogout() {
	    TransactionScan.backOverride(this.props.appManager, this.props.appActions);
	  },
	
	  render: function render() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var feedFeatureData = appManager.getFeatureForName("DomainLogin");
	    var thisThing = this;
	
	    var cardColor = appManager.getColorForKey("FeedCardColor");
	    var bannerColor = appManager.getColorForKey("FeedCardBannerColor");
	    var bannerIconColor = appManager.getColorForKey("FeedCardBannerIconColor");
	    var titleColor = appManager.getColorForKey("FeedCardTitleColor");
	    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var bgImage = appManager.absoluteResourceForPath(feedFeatureData.data.name + "/" + feedFeatureData.data.bgImage);
	    var cameraDim = Math.min(this.state.layout.width, this.state.layout.height - 200) - 20;
	    var cameraAspectRatio = 4 / 3;
	
	    var user = appManager.currentUser();
	    var shouldShowScanner = true;
	    var shouldShowPhone = true;
	    if (user != null && typeof user.ReUpPackage !== 'undefined' && user.ReUpPackage.length > 0) {
	      var reUpPackage = JSON.parse(user.ReUpPackage);
	      if (typeof reUpPackage.options !== 'undefined') {
	        if (typeof reUpPackage.options.enableScan !== 'undefined') shouldShowScanner = reUpPackage.options.enableScan;
	        if (typeof reUpPackage.options.enablePhone !== 'undefined') shouldShowPhone = reUpPackage.options.enablePhone;
	      }
	    }
	
	    return React.createElement(
	      View,
	      { style: [styles.container, { backgroundColor: generalColor }] },
	      React.createElement(
	        ReUpScrollView,
	        { responder: this },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', alignItems: 'center' } },
	          React.createElement(View, { style: { width: 0, height: this.props.initialLayout.height } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column', flex: 1 } },
	            this.state.isScanning && shouldShowScanner ? React.createElement(
	              View,
	              { style: { padding: 10 } },
	              React.createElement(
	                _reactNativeCameraWrapper2.default,
	                { style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'center', marginTop: 20 },
	                  barCodeTypes: [_reactNativeCameraWrapper2.default.constants.BarCodeType.qr],
	                  captureAudio: false,
	                  type: _reactNativeCameraWrapper2.default.constants.Type.back,
	                  aspect: _reactNativeCameraWrapper2.default.constants.Aspect.Fill,
	                  onBarCodeRead: function onBarCodeRead(evt) {
	                    // {"data":"eyJVIjoiMTUwIiwiVCI6IkdDIiwiSCI6IjIyMGY2ZWNjZDIifQ==","type":"org.iso.QRCode","bounds":{"size":{"width":"0.377938","height":"0.672479"},"origin":{"x":"0.348706","y":"0.132129"}}}
	                    thisThing.didScanData(evt.data);
	                  } },
	                React.createElement(
	                  Animated.View,
	                  { style: { opacity: thisThing.state.qrCodeOpacity } },
	                  React.createElement(_ReUpIcon2.default, { name: "qrcode", size: 200, color: 'black', style: { backgroundColor: 'transparent', justifyContent: 'center', alignSelf: 'center', padding: 0, paddingBottom: 0, lineHeight: 216 } })
	                )
	              )
	            ) : React.createElement(
	              View,
	              { style: { padding: 10 } },
	              shouldShowScanner ? React.createElement(
	                View,
	                { style: { alignSelf: 'center', height: cameraDim, width: cameraDim, justifyContent: 'center', marginTop: 20, alignItems: 'center', backgroundColor: 'white', borderRadius: 10 } },
	                React.createElement(
	                  ReUpText,
	                  { isTitle: true, style: { color: generalTitleColor, textAlign: 'center' } },
	                  'Select "Scan" to begin!'
	                ),
	                typeof appManager._lastTransaction !== 'undefined' ? React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, alignSelf: 'stretch', paddingLeft: 20, paddingRight: 20 }],
	                  appManager: appManager,
	                  text: locManager.localizedStringForKey("VIEW_PREVIOUS_TRANSACTION_BUTTON"),
	                  onPress: function onPress() {
	                    appActions.requestFeatureName("TransactionResult", appManager._lastTransaction);
	                  }
	                }) : null,
	                React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, alignSelf: 'stretch', paddingLeft: 20, paddingRight: 20 }],
	                  appManager: appManager,
	                  text: locManager.localizedStringForKey("VIEW_REFUNDS_BUTTON"),
	                  onPress: function onPress() {
	                    appActions.requestFeatureName("Refunds");
	                  }
	                })
	              ) : null
	            ),
	            shouldShowScanner ? React.createElement(
	              View,
	              { style: { marginHorizontal: 10 } },
	              this.state.isScanning ? React.createElement(ReUpButton, { style: [styles.button, { marginTop: 20 }],
	                appManager: appManager,
	                text: locManager.localizedStringForKey("STOP_SCAN_BUTTON"),
	                onPress: function onPress() {
	                  thisThing.stopScan();
	                }
	              }) : React.createElement(ReUpButton, { style: [styles.button, { marginTop: 20 }],
	                appManager: appManager,
	                text: locManager.localizedStringForKey("SCAN_BUTTON"),
	                onPress: function onPress() {
	                  thisThing.scan();
	                }
	              })
	            ) : null,
	            shouldShowPhone ? React.createElement(ReUpButton, { style: [styles.button, { marginTop: 8, marginHorizontal: 10 }],
	              appManager: appManager,
	              text: locManager.localizedStringForKey("INPUT_PHONE_BUTTON"),
	              onPress: function onPress() {
	                thisThing.stopScan();
	                appActions.requestFeatureName("PhoneLoyaltyInput");
	              }
	            }) : null,
	            !shouldShowScanner ? React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, alignSelf: 'stretch', paddingLeft: 20, paddingRight: 20 }],
	              appManager: appManager,
	              text: locManager.localizedStringForKey("VIEW_REFUNDS_BUTTON"),
	              onPress: function onPress() {
	                appActions.requestFeatureName("Refunds");
	              }
	            }) : null,
	            typeof appManager._lastTransaction !== 'undefined' && !shouldShowScanner ? React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10, alignSelf: 'stretch', paddingLeft: 20, paddingRight: 20 }],
	              appManager: appManager,
	              text: locManager.localizedStringForKey("VIEW_PREVIOUS_TRANSACTION_BUTTON"),
	              onPress: function onPress() {
	                appActions.requestFeatureName("TransactionResult", appManager._lastTransaction);
	              }
	            }) : null,
	            React.createElement(ReUpButton, { isSecondary: true, style: [styles.button, { margin: 10 }],
	              appManager: appManager,
	              text: locManager.localizedStringForKey("LOGOUT_BUTTON"),
	              onPress: function onPress() {
	                thisThing.stopScan();
	                thisThing.verifyLogout();
	              }
	            }),
	            React.createElement(
	              View,
	              { style: { margin: 20 } },
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { isTitle: false, style: { color: generalTitleColor, textAlign: 'center' } },
	                    locManager.localizedStringForKey("SUBDOMAIN_LABEL")
	                  )
	                ),
	                React.createElement(View, { style: { width: 5 } }),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { isTitle: true, style: { color: generalTitleColor, textAlign: 'center' } },
	                    appManager._domain
	                  )
	                ),
	                React.createElement(View, { style: { flex: 1 } })
	              ),
	              React.createElement(
	                View,
	                { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' } },
	                React.createElement(View, { style: { flex: 1 } }),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { isTitle: false, style: { color: generalTitleColor, textAlign: 'center' } },
	                    locManager.localizedStringForKey("EMAIL_LABEL")
	                  )
	                ),
	                React.createElement(View, { style: { width: 5 } }),
	                React.createElement(
	                  View,
	                  null,
	                  React.createElement(
	                    ReUpText,
	                    { isTitle: true, style: { color: generalTitleColor, textAlign: 'center' } },
	                    appManager.isLoggedIn() ? appManager.currentUser()[ModelConstants.UserName] : ""
	                  )
	                ),
	                React.createElement(View, { style: { flex: 1 } })
	              )
	            ),
	            this.props.isDebugging ? React.createElement(
	              View,
	              { style: { flexDirection: 'row' } },
	              React.createElement(ReUpButton, { appManager: appManager, text: "PASS", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  var jsonString = JSON.stringify(passQR);
	                  var base = btoa(jsonString);
	                  thisThing.didScanData(base);
	                }
	              }),
	              React.createElement(ReUpButton, { appManager: appManager, text: "CRED", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  var jsonString = JSON.stringify(creditQR);
	                  var base = btoa(jsonString);
	                  thisThing.didScanData(base);
	                }
	              }),
	              React.createElement(ReUpButton, { appManager: appManager, text: "RWD", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  var jsonString = JSON.stringify(rewardQR);
	                  var base = btoa(jsonString);
	                  thisThing.didScanData(base);
	                }
	              }),
	              React.createElement(ReUpButton, { appManager: appManager, text: "CHK", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  var jsonString = JSON.stringify(checkinQR);
	                  var base = btoa(jsonString);
	                  thisThing.didScanData(base);
	                }
	              }),
	              React.createElement(ReUpButton, { appManager: appManager, text: "GC", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  var jsonString = JSON.stringify(giftCardQR);
	                  var base = btoa(jsonString);
	                  thisThing.didScanData(base);
	                }
	              }),
	              React.createElement(ReUpButton, { appManager: appManager, text: "GAR", style: { margin: 2, flex: 1 },
	                onPress: function onPress() {
	                  thisThing.didScanData(garbageQR);
	                }
	              })
	            ) : null
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column',
	    backgroundColor: 'white'
	  },
	  actionBarSpacer: {
	    height: 0 //Globals.ACTION_BAR_HEIGHT,
	  },
	  image: {
	    position: 'absolute'
	  }
	});
	
	TransactionScan.backOverride = function (appManager, appActions) {
	  appManager._eventEmitter.emit("stopScan");
	  appActions.showLocalizedAlert("LOG_OUT_ALERT_TITLE", "LOG_OUT_ALERT_BODY", ["NO_ALERT_BUTTON", "YES_ALERT_BUTTON"], [function () {
	    appActions.hideAlert();
	  }, function () {
	    appManager.logout(function () {
	      appActions.requestPop();
	      appActions.hideAlert();
	    });
	  }], function () {});
	};
	
	TransactionScan.dataDependencies = ["Rewards", "Campaigns", "Passes", "Users"];
	
	module.exports = TransactionScan;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var LinkingManager = __webpack_require__(27);
	var NetworkManager = __webpack_require__(15);
	
	var View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Twitter = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {};
	  },
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  componentWillUnmount: function componentWillUnmount() {},
	
	  didUpdate: function didUpdate(data) {},
	
	  render: function render() {
	    return React.createElement(View, null);
	  }
	});
	
	Twitter.getCards = function (featureData, appActions, data) {
	  var didSelect = function didSelect() {
	    Twitter.customNavigation(featureData, appActions);
	  };
	  var appManager = appActions._appManager;
	  var iconName = featureData.data.icon.replace("fa-", "");
	  var cards = [];
	  if (typeof data.Twitter !== 'undefined') {
	    data.Twitter = data.Twitter.sort(function (a, b) {
	      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
	    });
	
	    var MAX_TWITTER_POSTS = 1;
	    for (var i = 0; i < data.Twitter.length && i < MAX_TWITTER_POSTS; i++) {
	      var twit = data.Twitter[i];
	      var message = twit.text;
	      var date = new Date(twit.created_at);
	
	      var dateText = appManager.getLocalizationManager().localizedLongDate(date.getTime());
	      var sortOrder = new Date().getTime() - date.getTime();
	      var media = typeof twit.entities !== 'undefined' && typeof twit.entities.media !== 'undefined' ? twit.entities.media : [];
	      cards.push({
	        key: "twit-" + twit.id,
	        didSelect: didSelect,
	        smallTitle: dateText,
	        body1: message,
	        media: media,
	        icon: iconName,
	        cardType: 0,
	        sortOrder: sortOrder
	      });
	    }
	  }
	  //console.log(cards)
	  return cards;
	};
	Twitter.customNavigation = function (featureData, appActions) {
	  var twitterURL = "twitter://" + featureData.data.twitter_screen_name;
	  LinkingManager.canOpenURL(twitterURL, function (can) {
	    if (can) {
	      LinkingManager.openURL(twitterURL);
	    } else {
	      var url = "http://www.twitter.com/" + featureData.data.twitter_screen_name;
	      var appManager = appActions._appManager;
	      var barTintColor = appManager.getColorForKey("HeaderColor");
	      var tintColor = appManager.getColorForKey("HeaderIconColor");
	
	      LinkingManager.openURL(url, tintColor, barTintColor);
	    }
	  });
	};
	// Twitter.customDependencyKeys = ["Twitter"];
	// Twitter.customDataDependency = function(appManager, completion)
	// {
	//   var featureData = appManager.getFeatureForName("Twitter");
	//   NetworkManager.getTwitterInfo(appManager, featureData.data.twitter_screen_name, function(data)
	//   {
	//     var filteredData = [];
	//     for( var i = 0; i < data.length; i++ )
	//     {
	//       var thisData = data[i];
	//       var media = (typeof thisData.entities !== 'undefined') && (typeof thisData.entities.media !== 'undefined') ? thisData.entities.media : [];
	//       var newMedia = [];
	//       for( var j = 0; j < media.length; j++ )
	//       {
	//         if( typeof media[j].media_url_https !== 'undefined' )
	//         {
	//           newMedia.push({media_url_https:media[j].media_url_https})
	//         }
	//       }
	//       filteredData.push({created_time:thisData.created_time, created_at:thisData.created_at, text:thisData.text, entities:{media:newMedia}})
	//     }
	//     appManager.setData({Twitter:filteredData}, function()
	//     {
	//       completion({Twitter:filteredData})
	//     })
	//   }, function(a)
	//   {
	//     completion({})
	//   }, function()
	//   {
	//     completion({})
	//   })
	// }
	
	Twitter.dataDependencies = [];
	
	module.exports = Twitter;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var dismissKeyboard = __webpack_require__(105);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var QRCodeView = __webpack_require__(95);
	var ReUpButton = __webpack_require__(12);
	var MKSegmentControl = __webpack_require__(36);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var ReUpField = __webpack_require__(26);
	var NetworkManager = __webpack_require__(15);
	var CheckMarkView = __webpack_require__(146);
	var FadingView = __webpack_require__(51);
	
	var _require = __webpack_require__(148),
	    PhysScene = _require.PhysScene,
	    PhysObject = _require.PhysObject;
	
	var PaymentMethodChooserView = __webpack_require__(94);
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet,
	    Vibration = ReactNative.Vibration,
	    Platform = ReactNative.Platform,
	    Keyboard = ReactNative.Keyboard,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	var PREVIOUS_TIP_AMOUNT = "PREVIOUS_TIP_AMOUNT";
	var PREVIOUS_TIP_TYPE = "PREVIOUS_TIP_TYPE";
	
	function getBase64Data(data) {
	  var dataJsonString = JSON.stringify(data);
	  var dataBase64 = btoa(dataJsonString);
	
	  return dataBase64;
	}
	
	var UseCredit = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var otherText = this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON");
	    var tipChoiceTitles = ["0%", "15%", "20%", otherText];
	    var tipChoiceValues = [0, 15, 20];
	    var tipEnabled = true;
	    var tipChoiceType = 0;
	    if (this.props.appManager != null) {
	      var featureData = this.props.appManager.getFeatureForName("UseCredit");
	      if (featureData && typeof featureData !== 'undefined') {
	        tipEnabled = typeof featureData.data.shouldUseTip === 'undefined' || featureData.data.shouldUseTip;
	        if (typeof featureData.data.tipValues !== 'undefined') {
	          tipChoiceType = typeof featureData.data.tipType !== 'undefined' ? featureData.data.tipType : 0;
	          tipChoiceTitles = [];
	          tipChoiceValues = [];
	          for (var i = 0; i < featureData.data.tipValues.length; i++) {
	            var thisValue = featureData.data.tipValues[i];
	            tipChoiceValues.push(parseInt(thisValue));
	            if (tipChoiceType == 0) {
	              tipChoiceTitles.push(thisValue + "%");
	            } else {
	              tipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedDollars(thisValue));
	            }
	          }
	          tipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON"));
	        }
	      }
	      var locManager = this.props.appManager.getLocalizationManager();
	      if (typeof locManager.getConstants()["TIP_CHOICES"] !== 'undefined') {
	        tipChoiceValues = locManager.getConstants()["TIP_CHOICES"];
	        tipChoiceTitles = [];
	        for (var i = 0; i < tipChoiceValues.length; i++) {
	          tipChoiceTitles.push(tipChoiceValues[i] + "%");
	        }
	        if (tipChoiceValues.length > 0) tipChoiceTitles.push(locManager.localizedStringForKey("OTHER_BUTTON"));
	      }
	    }
	
	    var appManager = this.props.appManager;
	    var hasSelectedTip = false;
	    if (typeof appManager._tipAmount !== 'undefined' && typeof appManager._tipType !== 'undefined') {
	      this._tipAmount = appManager._tipAmount;
	      this._tipType = appManager._tipType;
	
	      var newTipChoiceTitles = [];
	      for (var i = 0; i < tipChoiceTitles.length - 1; i++) {
	        newTipChoiceTitles.push(tipChoiceTitles[i]);
	      }
	      if (this._tipType == "P") newTipChoiceTitles.push(this._tipAmount + "%");else if (this._tipType == "D") newTipChoiceTitles.push(locManager.localizedDollars(this._tipAmount));
	
	      hasSelectedTip = true;
	      tipChoiceTitles = newTipChoiceTitles;
	    }
	
	    var addCreditFeature = this.props.appManager.getFeatureForName("AddCredit");
	    var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;
	
	    var shouldShowLoadCredit = !isLivePay && typeof addCreditFeature !== 'undefined' && addCreditFeature != null && !this.props.appActions._navigator.featureIsInStack(addCreditFeature);
	    var shouldShowPaymentMethods = isLivePay;
	    var shouldShowBalance = !isLivePay || this.props.appManager.currentUser()[ModelConstants.Credits] > 0;
	    var shouldShowTip = !isLivePay || this.props.appManager.currentUser()[ModelConstants.Credits] > 0;
	
	    return {
	      layout: this.props.initialLayout,
	      tipChoiceTitles: tipChoiceTitles,
	      tipChoiceValues: tipChoiceValues,
	      tipChoiceType: tipChoiceType,
	      tipEnabled: tipEnabled,
	      shouldShowLoadCredit: shouldShowLoadCredit,
	      shouldShowPaymentMethods: shouldShowPaymentMethods,
	      shouldShowBalance: shouldShowBalance,
	      shouldShowTip: shouldShowTip,
	      hasSelectedTip: hasSelectedTip,
	      renderAlternative: false,
	      renderAlternativeView: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	
	    var thisThing = this;
	    appManager.getVariable(PREVIOUS_TIP_AMOUNT, function (varAmount) {
	      if (varAmount != null) {
	        appManager.getVariable(PREVIOUS_TIP_TYPE, function (varType) {
	          if (varType != null) {
	            if (varAmount != thisThing._tipAmount || varType != thisThing._tipType) {
	              setTimeout(function () {
	                return thisThing.setTip(varAmount, varType);
	              }, 100);
	            }
	          }
	        });
	      }
	    });
	
	    if (appManager.isLoggedIn()) {
	      this._creditUsed = appManager.currentUser()[ModelConstants.TotalCreditUsedAtScanner];
	      this._pointsAdded = appManager.currentUser()[ModelConstants.TotalPointsAddedAtScanner];
	      this._points = appManager.currentUser()[ModelConstants.Points];
	      this._credit = appManager.currentUser()[ModelConstants.Credits];
	      this._hash = appManager.currentUser()[ModelConstants.Hash];
	    }
	
	    this.setTip();
	    this.queuePoll();
	    //
	    // NetworkManager.update(appManager, ['Users'], function()
	    // {
	    //   // success
	    // }, function(result)
	    // {
	    //   appActions.checkErrorCodeAndReturnIfHandled(result.code)
	    // }, function(data)
	    // {
	    //   appActions.showNetworkErrorAlert(appActions.hideAlert, function(){})
	    // });
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._pollTimeout != null) clearTimeout(this._pollTimeout);
	  },
	
	  _pollTimeout: null,
	  _isFirstPoll: true,
	  queuePoll: function queuePoll() {
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    this._pollTimeout = setTimeout(function () {
	      if (appManager.isLoggedIn()) {
	        NetworkManager.updateFeature(appManager, "User", function (user) {
	          if (typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined') {
	            var newHash = user[ModelConstants.Hash];
	            var newCreditUsed = user[ModelConstants.TotalCreditUsedAtScanner];
	            var newPointsAdded = user[ModelConstants.TotalPointsAddedAtScanner];
	            var newCredit = user[ModelConstants.Credits];
	            var newPoints = user[ModelConstants.Points];
	            if (newCredit != thisThing._credit || newPoints != thisThing._points || newHash != thisThing._hash || newCreditUsed != thisThing._creditUsed || newPointsAdded != thisThing._pointsAdded) {
	              appManager.setCurrentUser(user, function () {
	                if ((newCreditUsed > thisThing._creditUsed || newPointsAdded > thisThing._pointsAdded) && !thisThing._isFirstPoll) thisThing.announceTransaction(newCreditUsed - thisThing._creditUsed, newPointsAdded - thisThing._pointsAdded);
	                thisThing._credit = newCredit;
	                thisThing._points = newPoints;
	                thisThing._hash = newHash;
	                thisThing._creditUsed = newCreditUsed;
	                thisThing._pointsAdded = newPointsAdded;
	                thisThing._hash = newHash;
	                thisThing.setTip();
	                thisThing.forceUpdate();
	              });
	            }
	          }
	          thisThing._isFirstPoll = false;
	          thisThing.queuePoll();
	        }, function () {
	          thisThing.queuePoll();
	        });
	      } else {
	        thisThing.queuePoll();
	      }
	    }, appManager._isDemo ? 20000 : 5000);
	  },
	
	  _hash: null,
	  _creditUsed: null,
	  didUpdate: function didUpdate() {
	    var appManager = this.props.appManager;
	    var addCreditFeature = this.props.appManager.getFeatureForName("AddCredit");
	    var isLivePay = appManager.isLoggedIn() && appManager.currentUser()[ModelConstants.PayMode] == 1;
	    var shouldShowLoadCredit = !isLivePay && typeof addCreditFeature !== 'undefined' && addCreditFeature != null && !this.props.appActions._navigator.featureIsInStack(addCreditFeature);
	    var shouldShowPaymentMethods = isLivePay;
	    var shouldShowBalance = !isLivePay || this.props.appManager.currentUser()[ModelConstants.Credits] > 0;
	    var shouldShowTip = !isLivePay || this.props.appManager.currentUser()[ModelConstants.Credits] > 0;
	
	    this.setState({ shouldShowBalance: shouldShowBalance, shouldShowTip: shouldShowTip, shouldShowPaymentMethods: shouldShowPaymentMethods, shouldShowLoadCredit: shouldShowLoadCredit });
	  },
	
	  _tipAmount: 0,
	  _tipType: "P",
	  setTip: function setTip(amount, type) {
	    if (typeof amount !== 'undefined') this._tipAmount = amount;
	    if (typeof type !== 'undefined') this._tipType = type;
	
	    var shouldUpdateButton = typeof amount !== 'undefined' && typeof type !== 'undefined';
	    var appManager = this.props.appManager;
	
	    if (typeof amount !== 'undefined') {
	      appManager.setVariable(PREVIOUS_TIP_AMOUNT, this._tipAmount);
	      appManager._tipAmount = this._tipAmount;
	    } else {
	      amount = 0;
	    }
	
	    if (typeof type !== 'undefined') {
	      appManager.setVariable(PREVIOUS_TIP_TYPE, this._tipType);
	      appManager._tipType = this._tipType;
	    } else {
	      type = "P";
	    }
	
	    var user = appManager.currentUser();
	    var qrData = {};
	    qrData["Type"] = "credit";
	    qrData["AppID"] = appManager.getAppInfo()["appid"];
	    qrData["U"] = user[ModelConstants.UserID];
	    qrData["H"] = user[ModelConstants.Hash];
	    qrData["T"] = typeof this._tipAmount === 'undefined' ? 0 : this._tipAmount;
	    qrData["TT"] = typeof this._tipType === 'undefined' ? "P" : this._tipType;
	
	    var qrDataBase64 = getBase64Data(qrData);
	
	    if (this.refs.qrcode) this.refs.qrcode.setData(qrDataBase64);
	
	    if (shouldUpdateButton) {
	      var newTipChoiceTitles = [];
	      for (var i = 0; i < this.state.tipChoiceTitles.length - 1; i++) {
	        newTipChoiceTitles.push(this.state.tipChoiceTitles[i]);
	      }
	      if (type == "P") newTipChoiceTitles.push(amount + "%");
	      if (type == "D") newTipChoiceTitles.push(appManager.getLocalizationManager().localizedDollars(amount));
	      this.setState({ tipChoiceTitles: newTipChoiceTitles, hasSelectedTip: true });
	    }
	  },
	
	  announceTransaction: function announceTransaction(deltaCredit, deltaPoints) {
	    var _this = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	
	    var message = "";
	    if (deltaCredit > 0 && deltaPoints > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_EARNED_STATEMENT", [locManager.localizedDollars(deltaCredit), locManager.localizedPoints(deltaPoints)], "You spent %0% and earned %1%.");
	    } else if (deltaCredit > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_WITHDREW_STATEMENT", [locManager.localizedDollars(deltaCredit)]);
	    } else if (deltaPoints > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_EARNED_STATEMENT", [locManager.localizedPoints(deltaPoints)]);
	    }
	
	    var pattern, patternLiteral, patternDescription;
	    if (Platform.OS === 'android') {
	      pattern = [0, 2000];
	    } else {
	      pattern = [0];
	    }
	    Vibration.vibrate(pattern);
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var objBG = 'transparent'; //appManager.getColorForKey("FeedCardBannerColor");
	    var objFG = appManager.getColorForKey("ButtonPrimaryColor"); //appManager.getColorForKey("FeedCardBannerIconColor");
	
	    var MAX_OBJECTS = 10;
	    var numObjects = Math.abs(deltaPoints);
	    while (numObjects > MAX_OBJECTS) {
	      numObjects /= 2;
	    }var renderObject = function renderObject() {
	      return React.createElement(
	        View,
	        { style: { width: 40, height: 40, borderRadius: 20, backgroundColor: objBG, alignItems: 'center', flexDirection: 'row', justifyContent: 'center' } },
	        React.createElement(_ReUpIcon2.default, { name: "trophy", size: 40, color: objFG, style: { backgroundColor: 'transparent' } })
	      );
	    };
	    var objects = [];
	    for (var i = 0; i < numObjects; i++) {
	      var imod = i % 4;
	      var velX = (imod == 0 || imod == 1 ? -1 : 1) * (0.0005 + 0.0001 * Math.random());
	      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
	      var velY = -0.001 + -0.002 * Math.random();
	      var startTime = 300 + (i + 1) * 100;
	      objects.push({
	        posX: .5, posY: .5, velX: velX, velY: velY, renderObject: renderObject, startTime: startTime
	      });
	    }
	    var thisThing = this;
	    thisThing._doneButtonFadingView = null;
	    setTimeout(function () {
	      if (thisThing._doneButtonFadingView) thisThing._doneButtonFadingView.setFadedOut(false);
	    }, 3000);
	    // setTimeout(()=>
	    // {
	    //   if( thisThing.state.renderAlternative )
	    //   {
	    //     thisThing.setState({renderAlternative:false});
	    //     setTimeout(()=>
	    //     {
	    //       thisThing.setTip();
	    //     }, 200)
	    //   }
	    // }, 10000)
	    this.setState({
	      renderAlternative: true,
	      renderAlternativeView: function renderAlternativeView() {
	        return React.createElement(
	          View,
	          { style: { backgroundColor: generalColor, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: _this.state.layout.width, height: _this.state.layout.height } },
	          false ? React.createElement(PhysScene, {
	            style: { position: 'absolute', top: 0, left: 0, width: _this.state.layout.width, height: _this.state.layout.height },
	            objectInfos: objects }) : null,
	          React.createElement(
	            View,
	            { style: { marginHorizontal: 20, borderRadius: 8, flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              View,
	              { style: { width: 100, height: 100, flexDirection: 'column', marginBottom: 20 } },
	              React.createElement(CheckMarkView, { color: appManager.getColorForKey("FeedCardBannerColor"), style: { flex: 1, alignSelf: 'stretch' } })
	            ),
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: appManager, style: { color: appManager.getColorForKey("FeedCardTitleColor"), backgroundColor: appManager.getColorForKey("FeedCardColor", .6), textAlign: 'center' } },
	              message
	            )
	          ),
	          React.createElement(
	            FadingView,
	            { ref: function ref(a) {
	                return thisThing._doneButtonFadingView = a;
	              }, animDuration: 200, style: { height: 50, marginHorizontal: 20, marginTop: 40, alignSelf: 'stretch' } },
	            React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("DONE_BUTTON", "Done") })
	          ),
	          React.createElement(
	            TouchableWithoutFeedback,
	            { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, onPress: function onPress() {
	                thisThing.setState({ renderAlternative: false });
	                setTimeout(function () {
	                  thisThing.setTip();
	                }, 200);
	              } },
	            React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 } })
	          )
	        );
	      }
	    });
	  },
	
	  _previouslySelectedIndex: 0,
	  didSelectTipIndex: function didSelectTipIndex(index) {
	    if (index < this.state.tipChoiceValues.length) {
	      this._previouslySelectedIndex = index;
	      this.setTip(this.state.tipChoiceValues[index], this.state.tipChoiceType == 0 ? "P" : "D");
	      var newTipChoiceTitles = [];
	      for (var i = 0; i < this.state.tipChoiceTitles.length - 1; i++) {
	        newTipChoiceTitles.push(this.state.tipChoiceTitles[i]);
	      }
	      newTipChoiceTitles.push(this.props.appManager.getLocalizationManager().localizedStringForKey("OTHER_BUTTON"));
	      this.setState({ tipChoiceTitles: newTipChoiceTitles });
	    } else {
	      this.showTipPercentageChoice();
	    }
	  },
	
	  _customPercent: 0,
	  _tipPercentButton: null,
	  showTipPercentageChoice: function showTipPercentageChoice() {
	    var _this2 = this;
	
	    this._customPercent = 0;
	    var useCredit = this;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var percentLabel = locMan.localizedStringForKey("PERCENTAGE_LABEL");
	    var okButton = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + (isNaN(parseFloat(useCredit._customPercent)) ? 0 : parseFloat(useCredit._customPercent)) + "%"; //locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var dollarSign = locMan.localizedDollarSymbol();
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(MKSegmentControl, {
	        style: styles.tipTypeContainer,
	        choiceTitles: ["%", dollarSign],
	        didSelectIndex: function didSelectIndex(index) {
	          if (index == 1) {
	            useCredit.showTipDollarChoice();
	          }
	        },
	        activeBackgroundColor: primaryButtonColor,
	        activeShadowColor: primaryButtonBorderColor,
	        activeTextColor: primaryButtonTitleColor,
	        inactiveBackgroundColor: secondaryButtonColor,
	        inactiveTextColor: secondaryButtonTitleColor }),
	      React.createElement(
	        View,
	        { style: styles.tipValueContainer },
	        React.createElement(ReUpField, {
	          key: 'percent',
	          ref: function ref(a) {
	            if (a != null) {
	              a.focus();
	              useCredit._tipField = a;
	            }
	          },
	          appManager: appManager,
	          keyboardType: "numeric",
	          onChangeText: function onChangeText(text) {
	            var tipError = isNaN(parseFloat(text)) || parseFloat(text) < 0;
	            useCredit._tipField.setIsInError(tipError);
	            useCredit._customPercent = tipError ? "0" : text;
	            var newTitle = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + parseFloat(useCredit._customPercent) + "%";
	            useCredit._tipPercentButton.setTitle(newTitle);
	          },
	          tintColor: bannerColor,
	          highlightColor: bannerColor,
	          textInputStyle: { color: generalTitleColor },
	          placeholder: percentLabel,
	          style: [styles.textField] }),
	        React.createElement(
	          View,
	          { style: { alignSelf: "flex-end", marginBottom: 6 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: styles.tipLabel },
	            '%'
	          )
	        )
	      ),
	      React.createElement(ReUpButton, { key: "percentButton", ref: function ref(a) {
	          return _this2._tipPercentButton = a;
	        },
	        style: [styles.button, { marginTop: 20 }],
	        appManager: appManager,
	        text: okButton,
	        onPress: function onPress() {
	          Keyboard.dismiss();
	          setTimeout(function () {
	            useCredit._previouslySelectedIndex = useCredit.state.tipChoiceTitles.length - 1;
	            useCredit.setTip(useCredit._customPercent, "P");
	            var newTipChoiceTitles = [];
	            for (var i = 0; i < useCredit.state.tipChoiceTitles.length - 1; i++) {
	              newTipChoiceTitles.push(useCredit.state.tipChoiceTitles[i]);
	            }
	            newTipChoiceTitles.push(useCredit._customPercent + "%");
	            useCredit.setState({ tipChoiceTitles: newTipChoiceTitles, hasSelectedTip: true });
	          }, 200);
	          useCredit.props.appActions.setCustomAlertShown(false);
	        }
	      })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {
	      // if( typeof useCredit.refs.segmentControl === 'undefined' ) return;
	      // useCredit.refs.segmentControl.setSelectedIndex(useCredit._previouslySelectedIndex);
	    });
	  },
	
	  _customDollar: 0,
	  showTipDollarChoice: function showTipDollarChoice() {
	    var _this3 = this;
	
	    this._customDollar = 0;
	    var useCredit = this;
	    var appManager = this.props.appManager;
	    var locMan = this.props.appManager.getLocalizationManager();
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	    var generalColor = 'white'; //appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = 'black'; //appManager.getColorForKey("GeneralTitleColor");
	    var bannerColor = 'black'; //appManager.getColorForKey("FeedCardBannerColor");
	    var dollarLabel = locMan.localizedStringForKey("DOLLARS_LABEL");
	    var okButton = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + locMan.localizedDollars(useCredit._customDollar); //locMan.localizedStringForKey("OK_ALERT_BUTTON");
	    var dollarSign = locMan.localizedDollarSymbol();
	    var shouldPutDollarSignAtEnd = locMan.shouldUseComma();
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 10, marginLeft: 10, marginRight: 10 },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(MKSegmentControl, {
	        style: styles.tipTypeContainer,
	        choiceTitles: ["%", dollarSign],
	        selectedIndex: 1,
	        didSelectIndex: function didSelectIndex(index) {
	          if (index == 0) {
	            useCredit.showTipPercentageChoice();
	          }
	        },
	        activeBackgroundColor: primaryButtonColor,
	        activeShadowColor: primaryButtonBorderColor,
	        activeTextColor: primaryButtonTitleColor,
	        inactiveBackgroundColor: secondaryButtonColor,
	        inactiveTextColor: secondaryButtonTitleColor }),
	      React.createElement(
	        View,
	        { style: [styles.tipValueContainer] },
	        !shouldPutDollarSignAtEnd ? React.createElement(
	          View,
	          { style: { alignSelf: "flex-end", marginBottom: 6 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: styles.tipLabel },
	            dollarSign
	          )
	        ) : null,
	        React.createElement(ReUpField, {
	          key: 'dollar',
	          ref: function ref(a) {
	            if (a != null) {
	              a.focus();
	              useCredit._dollarTipField = a;
	            }
	          },
	          appManager: appManager,
	          keyboardType: "numeric",
	          onChangeText: function onChangeText(text) {
	            var tipError = isNaN(parseFloat(text)) || parseFloat(text) < 0;
	            useCredit._dollarTipField.setIsInError(tipError);
	            useCredit._customDollar = tipError ? "0" : text;
	            var newTitle = locMan.localizedStringForKey("SETTIP_LABEL") + " - " + locMan.localizedDollars(useCredit._customDollar);
	            useCredit._dollarButton.setTitle(newTitle);
	          },
	          tintColor: bannerColor,
	          highlightColor: bannerColor,
	          textInputStyle: { color: generalTitleColor },
	          placeholder: dollarLabel,
	          style: [styles.textField] }),
	        shouldPutDollarSignAtEnd ? React.createElement(
	          View,
	          { style: { alignSelf: "flex-end", marginBottom: 6 } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: styles.tipLabel },
	            dollarSign
	          )
	        ) : null
	      ),
	      React.createElement(ReUpButton, { key: "dollarButton", style: [styles.button, { marginTop: 20 }],
	        ref: function ref(a) {
	          return _this3._dollarButton = a;
	        },
	        appManager: appManager,
	        text: okButton,
	        onPress: function onPress() {
	          Keyboard.dismiss();
	          setTimeout(function () {
	            useCredit._previouslySelectedIndex = useCredit.state.tipChoiceTitles.length - 1;
	            useCredit.setTip(useCredit._customDollar, "D");
	            var newTipChoiceTitles = [];
	            for (var i = 0; i < useCredit.state.tipChoiceTitles.length - 1; i++) {
	              newTipChoiceTitles.push(useCredit.state.tipChoiceTitles[i]);
	            }
	            newTipChoiceTitles.push(locMan.localizedDollars(useCredit._customDollar));
	            useCredit.setState({ tipChoiceTitles: newTipChoiceTitles, hasSelectedTip: true });
	          }, 200);
	          useCredit.props.appActions.setCustomAlertShown(false);
	        }
	      })
	    );
	    this.props.appActions.setCustomAlertShown(true, customAlert, function () {
	      // if( typeof useCredit.refs.segmentControl === 'undefined' ) return;
	      // useCredit.refs.segmentControl.setSelectedIndex(useCredit._previouslySelectedIndex);
	    });
	  },
	
	  render: function render() {
	    var _this4 = this;
	
	    var addCredit = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var appActions = this.props.appActions;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
	    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
	    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
	    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
	    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
	    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");
	
	    var creditsLeftStatement = locManager.localizedStringForKey("CREDITS_LEFT_STATEMENT");
	    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");
	    var hasSelectedTip = this.state.hasSelectedTip;
	
	    var addCreditFeature = appManager.getFeatureForName("AddCredit");
	
	    var dimension = Math.min(this.state.layout.width - 100, this.state.layout.height - 164);
	
	    var dollarsPerPoint = appManager.currentUser().DollarsPerPoint;
	    var instructions = locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints(Math.round(1 / dollarsPerPoint)), locManager.localizedDollars(1)]);
	    var borderRadius = typeof this.props.extras !== 'undefined' && typeof this.props.extras.borderRadius !== 'undefined' ? this.props.extras.borderRadius : 0;
	
	    return React.createElement(
	      View,
	      { style: [styles.container],
	        onLayout: function onLayout(event) {
	          return _this4.setState({ containerLayout: event.nativeEvent.layout });
	        } },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height + Globals.ACTION_BAR_HEIGHT, overflow: 'hidden', backgroundColor: generalColor, borderRadius: borderRadius }] }),
	      React.createElement(
	        ReUpScrollView,
	        { ref: 'ptr', bounces: true, responder: this, renderAlternative: this.state.renderAlternative, renderAlternativeView: this.state.renderAlternativeView },
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', alignItems: 'stretch' } },
	          React.createElement(View, { style: { height: this.state.layout.height } }),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'column' } },
	            React.createElement(
	              View,
	              { style: { flex: 1 } },
	              React.createElement(
	                View,
	                { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	                React.createElement(
	                  View,
	                  { style: { alignSelf: 'center', flex: 1 } },
	                  React.createElement(
	                    ReUpText,
	                    { appManager: appManager, style: [styles.instructionText, { color: instructionTitleColor }] },
	                    instructions
	                  )
	                ),
	                React.createElement(ReUpIconButton, { type: 3,
	                  appManager: appManager,
	                  featureData: this.props.featureData,
	                  appActions: this.props.appActions
	                })
	              ),
	              React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	              React.createElement(View, { style: { flex: 1 } })
	            ),
	            this.state.shouldShowLoadCredit ? React.createElement(ReUpButton, { isSecondary: true, style: { marginHorizontal: 40, alignSelf: 'stretch' },
	              appManager: appManager,
	              text: addCreditFeature.data.title,
	              onPress: function onPress() {
	                appActions.requestFeatureName("AddCredit");
	              }
	            }) : null,
	            React.createElement(QRCodeView, { ref: 'qrcode', key: 'qrcode', data: "", dimension: dimension, style: styles.qrcode, spinnerView: React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }) }),
	            this.state.shouldShowBalance ? React.createElement(
	              View,
	              { style: { alignSelf: 'center', flex: -1 } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, style: { color: generalTitleColor } },
	                creditsLeftStatement
	              )
	            ) : null,
	            React.createElement(
	              View,
	              { style: { flexDirection: 'row', alignSelf: 'stretch', marginTop: 8, flex: -1 } },
	              this.state.shouldShowPaymentMethods ? React.createElement(
	                View,
	                { style: { flex: 1, padding: 10, justifyContent: 'center', alignSelf: 'center' } },
	                React.createElement(PaymentMethodChooserView, { ref: "paymentMethod",
	                  style: { flex: 1, marginTop: 0 }, useSmall: true,
	                  appManager: appManager, appActions: this.props.appActions,
	                  paymentInfo: appManager.getPaymentInfo() })
	              ) : null,
	              this.state.tipEnabled && this.state.shouldShowPaymentMethods ? React.createElement(
	                View,
	                { style: { flex: 1, padding: 10, paddingLeft: 5, alignSelf: 'stretch' } },
	                React.createElement(ReUpButton, { style: { flex: 1, height: 40 },
	                  appManager: appManager,
	                  text: !hasSelectedTip ? locManager.localizedStringForKey("SETTIP_LABEL") : tipStatement + " " + this.state.tipChoiceTitles[this.state.tipChoiceTitles.length - 1],
	                  onPress: function onPress() {
	                    if (_this4._tipType == "D") _this4.showTipDollarChoice();else _this4.showTipPercentageChoice();
	                  }
	                })
	              ) : null,
	              this.state.tipEnabled && !this.state.shouldShowPaymentMethods ? React.createElement(ReUpButton, { style: { marginHorizontal: 40, flex: 1, alignSelf: 'stretch' },
	                appManager: appManager,
	                text: !hasSelectedTip ? locManager.localizedStringForKey("SETTIP_LABEL") : tipStatement + " " + this.state.tipChoiceTitles[this.state.tipChoiceTitles.length - 1],
	                onPress: function onPress() {
	                  if (_this4._tipType == "D") _this4.showTipDollarChoice();else _this4.showTipPercentageChoice();
	                }
	              }) : null
	            ),
	             true ? React.createElement(View, null) : React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.tipText, { color: generalTitleColor }] },
	              tipStatement
	            ),
	            React.createElement(View, { style: { flex: 1 } })
	          )
	        )
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    alignSelf: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  tipText: {
	    alignSelf: 'center'
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  qrcode: {
	    padding: 10,
	    alignItems: 'center'
	  },
	  tipContainer: {
	    height: 50,
	    flex: 1,
	    padding: 10
	  },
	  tipTypeContainer: {
	    height: 40,
	    width: 180,
	    alignSelf: 'center'
	  },
	  textField: {
	    width: 120,
	    height: 50,
	    marginTop: 10
	  },
	  button: {
	    justifyContent: 'center',
	    flex: 1
	  },
	  tipValueContainer: {
	    paddingTop: 4,
	    paddingLeft: 20,
	    paddingRight: 20,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row'
	  },
	  tipLabel: {
	    paddingLeft: 8,
	    paddingRight: 8,
	    textAlign: 'center',
	    alignSelf: 'flex-end'
	  }
	});
	
	UseCredit.getCards = function (featureData, appActions, data) {
	  var appManager = appActions._appManager;
	  var isLoggedIn = appManager.isLoggedIn();
	  var locManager = appManager.getLocalizationManager();
	
	  if (!isLoggedIn) return [];else {
	    var user = appManager.currentUser();
	    var transactions = typeof data.Transactions === 'undefined' ? [] : data.Transactions;
	    var biggestTimeStamp = 0;
	    for (var i = 0; i < transactions.length; i++) {
	      var thisTrans = transactions[i];
	      if (thisTrans.Credit > 0) {
	        var thisTime = appManager.getTime(thisTrans.Timestamp);
	        if (thisTime > biggestTimeStamp) {
	          biggestTimeStamp = thisTime;
	        }
	      }
	    }
	    var sortOrder = new Date().getTime() - biggestTimeStamp;
	    sortOrder = sortOrder - 1000; // minus one so that we are on top of the transaction history card
	    var didSelect = function didSelect() {
	      appActions.requestFeatureName("UseCredit");
	    };
	    var iconName = featureData.data.icon.replace("fa-", "");
	    var dollarsPerPoint = user.DollarsPerPoint;
	
	    return [{
	      didSelect: didSelect,
	      title: featureData.data.title,
	      body1: locManager.localizedStringForKeyAndParams("EARN_POINTS_DESCRIPTION", [locManager.localizedPoints(Math.round(1 / dollarsPerPoint)), locManager.localizedDollars(1)]),
	      icon: iconName,
	      cardType: 0,
	      sortOrder: sortOrder
	    }];
	  }
	};
	
	UseCredit.dataDependencies = ["Users", "Transactions"];
	
	module.exports = UseCredit;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var QRCodeView = __webpack_require__(95);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var NetworkManager = __webpack_require__(15);
	
	var MK = __webpack_require__(14);
	
	var MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter;
	
	
	function getBase64Data(data) {
	  var dataJsonString = JSON.stringify(data);
	  var dataBase64 = btoa(dataJsonString);
	
	  return dataBase64;
	}
	
	var testData = [{
	  "PassID": "1",
	  "Name": "Facials",
	  "Description": "Get 5 facials for the price of 4!",
	  "RedeemQuantity": "5",
	  "Cost": "100.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
	  "AmountCharged": "113.00"
	}, {
	  "PassID": "2",
	  "Name": "Manicures",
	  "Description": "Get 10 manicures for $200!",
	  "RedeemQuantity": "10",
	  "Cost": "200.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"StartDate\": \"\", \"EndDate\": \"\", \"LimitPerCustomer\": \"\", \"PurchaseWithCredit\": \"\"}",
	  "AmountCharged": "226.00",
	  "StateEnum": "1",
	  "RedeemQuantityRemaining": "6"
	}, {
	  "PassID": "3",
	  "Name": "Unlimited Blows",
	  "Description": "Subscribe now and get unlimited blows for $30 per month!",
	  "RedeemQuantity": "10",
	  "Cost": "30.00",
	  "TaxRate": "0.13",
	  "IsDisabled": "0",
	  "IsDeleted": "0",
	  "PassBlob": "{\"type\": \"1\"}",
	  "AmountCharged": "33.90"
	}];
	
	var UsePass = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      pass: this.props.extras.pass
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	
	    NetworkManager.update(appManager, ['Users'], function () {
	      // success
	    }, function (result) {
	      appActions.checkErrorCodeAndReturnIfHandled(result.code);
	    }, function (data) {
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	
	    this._hash = appManager.currentUser()[ModelConstants.Hash];
	    this.queuePoll();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._pollTimeout != null) clearTimeout(this._pollTimeout);
	  },
	
	  _pollTimeout: null,
	  queuePoll: function queuePoll() {
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    this._pollTimeout = setTimeout(function () {
	      if (appManager.isLoggedIn()) {
	        NetworkManager.update(appManager, ["Passes", "User"], function (data) {
	          if (typeof data["Users"] !== 'undefined' && data["Users"].length > 0) {
	            var user = data["Users"][0];
	            if (typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined') {
	              var newHash = user[ModelConstants.Hash];
	              if (newHash != thisThing._hash) {
	                appManager.setCurrentUser(user, function () {
	                  thisThing._hash = newHash;
	                  thisThing.forceUpdate();
	                });
	              }
	            }
	          }
	
	          var passes = data["Passes"];
	          if (typeof passes !== 'undefined' && passes != null && passes.length > 0) {
	            for (var i = 0; i < passes.length; i++) {
	              if (passes[i].PassID == thisThing.props.extras.pass.PassID) {
	                if (JSON.stringify(passes[i]) != JSON.stringify(thisThing.state.pass)) {
	                  appManager.setData({ Passes: passes });
	                  thisThing.setState({ pass: passes[i] });
	                }
	                break;
	              }
	            }
	          }
	          thisThing.queuePoll();
	        }, function () {
	          thisThing.queuePoll();
	        });
	      } else {
	        thisThing.queuePoll();
	      }
	    }, 5000);
	  },
	
	  didUpdate: function didUpdate() {
	    var thisThing = this;
	    this.props.appManager.getDataType("Passes", function (data) {
	      // data = testData;
	      if (data == null) return;
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i].PassID == thisThing.props.extras.pass.PassID) {
	          thisThing.setState({ pass: data[i] });
	          break;
	        }
	      }
	    });
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var thisPass = this;
	    var appManager = this.props.appManager;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	    var pass = this.state.pass;
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");
	
	    var dimension = Math.min(this.state.layout.width - 100, this.state.layout.height - 164);
	
	    var qrData = {};
	    qrData["AppID"] = appManager.getAppInfo()["appid"];
	    qrData["Type"] = "pass";
	    qrData["U"] = user[ModelConstants.UserID];
	    qrData["H"] = user[ModelConstants.Hash];
	    qrData["P"] = pass.PassID;
	
	    var qrDataBase64 = getBase64Data(qrData);
	    var passName = pass.Name;
	    var instructions = (typeof pass.RedeemQuantityRemaining === 'undefined' ? "0" : pass.RedeemQuantityRemaining) + "/" + pass.RedeemQuantity + " " + passName + " remaining";
	
	    return React.createElement(
	      View,
	      { style: styles.container,
	        onLayout: function onLayout(event) {
	          return _this.setState({ layout: event.nativeEvent.layout });
	        } },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { bounces: true, responder: this },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	          React.createElement(
	            View,
	            { style: { flex: 1, alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: appManager, style: [styles.instructionText, { numberOfLines: 3, color: instructionTitleColor }] },
	              instructions
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { width: 50 } },
	            React.createElement(ReUpIconButton, { type: 3,
	              appManager: appManager,
	              featureData: this.props.featureData,
	              appActions: this.props.appActions,
	              locParams: [passName]
	            })
	          )
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        React.createElement(QRCodeView, { key: 'qrcode', data: qrDataBase64, dimension: dimension, style: styles.qrcode, spinnerView: React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }) })
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  qrcode: {
	    padding: 30,
	    alignItems: 'center'
	  }
	});
	
	UsePass.dataDependencies = ["Passes"];
	
	module.exports = UsePass;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Globals = __webpack_require__(10);
	var ModelConstants = __webpack_require__(11);
	var ReUpScrollView = __webpack_require__(16);
	var QRCodeView = __webpack_require__(95);
	var MKSegmentControl = __webpack_require__(36);
	var ReUpIconButton = __webpack_require__(18);
	var ShadowView = __webpack_require__(20);
	var ReUpText = __webpack_require__(8);
	var NetworkManager = __webpack_require__(15);
	var CheckMarkView = __webpack_require__(146);
	var FadingView = __webpack_require__(51);
	var ReUpButton = __webpack_require__(12);
	var ReUpCountdown = __webpack_require__(73);
	var moment = __webpack_require__(3);
	
	var _require = __webpack_require__(148),
	    PhysScene = _require.PhysScene,
	    PhysObject = _require.PhysObject;
	
	var MK = __webpack_require__(14);
	
	var MKColor = MK.MKColor,
	    MKCardStyles = MK.MKCardStyles,
	    MKTextField = MK.MKTextField,
	    MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    StyleSheet = ReactNative.StyleSheet,
	    Vibration = ReactNative.Vibration,
	    Platform = ReactNative.Platform,
	    TouchableWithoutFeedback = ReactNative.TouchableWithoutFeedback;
	
	
	function getBase64Data(data) {
	  var dataJsonString = JSON.stringify(data);
	  var dataBase64 = btoa(dataJsonString);
	
	  return dataBase64;
	}
	
	var UseReward = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      reward: {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      layout: this.props.initialLayout,
	      currentPageIndex: 0,
	      shouldShowPrevious: false,
	      shouldShowNext: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var appActions = this.props.appActions;
	    var appManager = this.props.appManager;
	    this.queuePoll();
	
	    if (appManager.isLoggedIn()) {
	      this._pointsUsed = appManager.currentUser()[ModelConstants.TotalPointsUsedAtScanner];
	      this._hash = appManager.currentUser()[ModelConstants.Hash];
	    }
	
	    NetworkManager.update(appManager, ['Users'], function () {
	      // success
	    }, function (result) {
	      appActions.checkErrorCodeAndReturnIfHandled(result.code);
	    }, function (data) {
	      appActions.showNetworkErrorAlert(appActions.hideAlert, function () {});
	    });
	  },
	
	  onScroll: function onScroll(offset) {
	    var others = [];
	    if (typeof this.props.extras.reward.others !== 'undefined') {
	      others.push(this.props.extras.reward);
	      for (var i = 0; i < this.props.extras.reward.others.length; i++) {
	        others.push(this.props.extras.reward.others[i]);
	      }
	      var page = Math.round(offset / this.state.layout.width);
	      if (page != this.state.currentPageIndex) {
	        this.state.currentPageIndex = page;
	        var shouldShowPrevious = page > 0;
	        var shouldShowNext = page < others.length - 1;
	        this.setState({ currentPageIndex: page, shouldShowNext: shouldShowNext, shouldShowPrevious: shouldShowPrevious });
	      }
	    }
	  },
	
	  _pollTimeout: null,
	  _isFirstPoll: true,
	  _hasExpired: false,
	  queuePoll: function queuePoll() {
	    var appManager = this.props.appManager;
	    var thisThing = this;
	    this._pollTimeout = setTimeout(function () {
	      if (appManager.isLoggedIn()) {
	        if (thisThing._hasExpired) return;
	
	        var isOneTimeReward = typeof thisThing.props.extras.reward.DateExpires !== 'undefined';
	        if (isOneTimeReward) {
	          // if this is a one time reward, check if the quantity has decreased to determine if one has been spent
	          var countOfReward = 1 + (typeof thisThing.props.extras.reward.others !== 'undefined' ? thisThing.props.extras.reward.others.length : 0);
	          NetworkManager.updateFeature(appManager, "OneTimeRewards", function (oneTimeRewards) {
	            thisThing._isFirstPoll = false;
	            var numTheseRewards = 0;
	            for (var i = 0; i < oneTimeRewards.length; i++) {
	              if (oneTimeRewards[i].RewardID == thisThing.props.extras.reward.RewardID) numTheseRewards++;
	            }
	
	            var hasChanged = numTheseRewards != countOfReward;
	            if (hasChanged) {
	              thisThing.announceTransaction(0, thisThing.props.extras.reward.RewardName, true);
	            } else {
	              thisThing.queuePoll();
	            }
	          }, function () {
	            thisThing.queuePoll();
	          });
	        } else {
	          // if its not a one time reward, then check the points change to determine if there has been a reward used
	          NetworkManager.updateFeature(appManager, "User", function (user) {
	            if (typeof user !== 'undefined' && user != null && typeof user[ModelConstants.Hash] !== 'undefined') {
	              var newHash = user[ModelConstants.Hash];
	              var newPointsUsed = user[ModelConstants.TotalPointsUsedAtScanner];
	              if (newHash != thisThing._hash || newPointsUsed != thisThing._pointsUsed) {
	                appManager.setCurrentUser(user, function () {
	                  if (newPointsUsed > thisThing._pointsUsed && !thisThing._isFirstPoll) thisThing.announceTransaction(newPointsUsed - thisThing._pointsUsed);
	                  thisThing._pointsUsed = newPointsUsed;
	                  thisThing._hash = newHash;
	                  thisThing.forceUpdate();
	                });
	              }
	            }
	            thisThing._isFirstPoll = false;
	            thisThing.queuePoll();
	          }, function () {
	            thisThing.queuePoll();
	          });
	        }
	      } else {
	        thisThing.queuePoll();
	      }
	    }, 5000);
	  },
	
	  didUpdate: function didUpdate() {},
	
	  announceTransaction: function announceTransaction(deltaPoints) {
	    var _this = this;
	
	    var rewardName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var shouldPop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	
	    var message = "";
	    if (deltaPoints > 0) {
	      message = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", [locManager.localizedPoints(deltaPoints)]);
	    } else if (rewardName != null) {
	      message = locManager.localizedStringForKeyAndParams("USER_REDEEMED_STATEMENT", ["1 " + rewardName]);
	    }
	
	    var pattern, patternLiteral, patternDescription;
	    if (Platform.OS === 'android') {
	      pattern = [0, 2000];
	    } else {
	      pattern = [0];
	    }
	    Vibration.vibrate(pattern);
	
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	    var objBG = 'transparent'; //appManager.getColorForKey("FeedCardBannerColor");
	    var objFG = appManager.getColorForKey("ButtonPrimaryColor"); //appManager.getColorForKey("FeedCardBannerIconColor");
	
	    var MAX_OBJECTS = 10;
	    var numObjects = Math.abs(deltaPoints);
	    while (numObjects > MAX_OBJECTS) {
	      numObjects /= 2;
	    }var renderObject = function renderObject() {
	      return React.createElement(
	        View,
	        { style: { width: 40, height: 40, borderRadius: 20, backgroundColor: objBG, alignItems: 'center', flexDirection: 'row', justifyContent: 'center' } },
	        React.createElement(_ReUpIcon2.default, { name: "trophy", size: 40, color: objFG, style: { backgroundColor: 'transparent' } })
	      );
	    };
	    var objects = [];
	    for (var i = 0; i < numObjects; i++) {
	      var imod = i % 4;
	      var velX = (imod == 0 || imod == 1 ? -1 : 1) * (0.0005 + 0.0001 * Math.random());
	      // var velY = (imod == 0 || imod == 3 ? -1 : 1 ) * (0.0005 + 0.0001 * Math.random());
	      var velY = -0.001 + -0.002 * Math.random();
	      var startTime = 300 + (i + 1) * 100;
	      objects.push({
	        posX: .5, posY: .5, velX: velX, velY: velY, renderObject: renderObject, startTime: startTime
	      });
	    }
	    var thisThing = this;
	    thisThing._doneButtonFadingView = null;
	    setTimeout(function () {
	      if (thisThing._doneButtonFadingView) thisThing._doneButtonFadingView.setFadedOut(false);
	    }, 3000);
	    // setTimeout(()=>
	    // {
	    //   if( thisThing.state.renderAlternative )
	    //   {
	    //     thisThing.setState({renderAlternative:false});
	    //     setTimeout(()=>
	    //     {
	    //       // thisThing.setQRCode();
	    //     }, 200)
	    //   }
	    // }, 30000)
	    this.setState({
	      renderAlternative: true,
	      renderAlternativeView: function renderAlternativeView() {
	        return React.createElement(
	          View,
	          { style: { backgroundColor: generalColor, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: _this.state.layout.width, height: _this.state.layout.height } },
	          false ? React.createElement(PhysScene, {
	            style: { position: 'absolute', top: 0, left: 0, width: _this.state.layout.width, height: _this.state.layout.height },
	            objectInfos: objects }) : null,
	          React.createElement(
	            View,
	            { style: { marginHorizontal: 20, borderRadius: 8, flexDirection: 'column', alignItems: 'center' } },
	            React.createElement(
	              View,
	              { style: { width: 100, height: 100, flexDirection: 'column', marginBottom: 20 } },
	              React.createElement(CheckMarkView, { color: appManager.getColorForKey("FeedCardBannerColor"), style: { flex: 1, alignSelf: 'stretch' } })
	            ),
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: appManager, style: { color: appManager.getColorForKey("FeedCardTitleColor"), backgroundColor: appManager.getColorForKey("FeedCardColor", .6), textAlign: 'center' } },
	              message
	            )
	          ),
	          React.createElement(
	            FadingView,
	            { ref: function ref(a) {
	                return thisThing._doneButtonFadingView = a;
	              }, animDuration: 200, style: { height: 50, marginHorizontal: 20, marginTop: 40, alignSelf: 'stretch' } },
	            React.createElement(ReUpButton, { appManager: appManager, text: locManager.localizedStringForKey("DONE_BUTTON", "Done") })
	          ),
	          React.createElement(
	            TouchableWithoutFeedback,
	            { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }, onPress: function onPress() {
	                if (shouldPop) {
	                  thisThing.props.appActions.requestPop();
	                } else {
	                  thisThing.setState({ renderAlternative: false });
	                  setTimeout(function () {
	                    // thisThing.setQRCode();
	                  }, 200);
	                }
	              } },
	            React.createElement(View, { style: { position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 } })
	          )
	        );
	      }
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var thisRewards = this;
	    var appManager = this.props.appManager;
	    var appActions = this.props.appActions;
	    var locManager = this.props.appManager.getLocalizationManager();
	    var user = appManager.currentUser();
	
	    var instructionColor = appManager.getColorForKey("InstructionColor");
	    var instructionTitleColor = appManager.getColorForKey("InstructionTitleColor");
	    var generalColor = appManager.getColorForKey("GeneralColor");
	    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
	
	    var pointsLeftStatement = locManager.localizedStringForKey("POINTS_LEFT_STATEMENT");
	    var tipStatement = locManager.localizedStringForKey("TIP_PERCENTAGE_LABEL");
	
	    var dimension = Math.min(this.state.layout.width - 100, this.state.layout.height - 164);
	
	    var qrData = {};
	    qrData["AppID"] = appManager.getAppInfo()["appid"];
	    qrData["Type"] = "reward";
	    qrData["U"] = user[ModelConstants.UserID];
	    qrData["H"] = user[ModelConstants.Hash];
	    qrData["R"] = this.props.extras.reward.RewardID;
	
	    var qrDataBase64 = getBase64Data(qrData);
	
	    var rewardTitle = this.props.extras.reward.RewardName;
	    var others = [];
	    if (typeof this.props.extras.reward.others !== 'undefined') {
	      others.push(this.props.extras.reward);
	      for (var i = 0; i < this.props.extras.reward.others.length; i++) {
	        others.push(this.props.extras.reward.others[i]);
	      }
	    }
	    others = others.sort(function (a, b) {
	      if (a.DateExpires == b.DateExpires) return b.RewardName.localeCompare(a.RewardName);else {
	        var dateA = new Date(a.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsA = moment(dateA).valueOf();
	        var dateB = new Date(b.DateExpires.replace(' ', 'T') + 'Z');
	        var dateSecondsB = moment(dateB).valueOf();
	
	        return dateSecondsA - dateSecondsB;
	      }
	    });
	    var shouldShowPageControl = others.length > 1;
	
	    var layout = this.state.layout;
	
	    return React.createElement(
	      View,
	      { style: styles.container,
	        onLayout: function onLayout(event) {
	          return _this2.setState({ layout: event.nativeEvent.layout });
	        } },
	      this.props.extras && this.props.extras.shouldHideActionBar ? null : React.createElement(View, { style: styles.actionBarSpacer }),
	      React.createElement(View, { style: [styles.backgroundView, { width: this.state.layout.width, height: this.state.layout.height, backgroundColor: generalColor }] }),
	      React.createElement(
	        ReUpScrollView,
	        { bounces: true, responder: this, featureName: 'UseReward',
	          renderAlternative: this.state.renderAlternative, renderAlternativeView: this.state.renderAlternativeView },
	        React.createElement(
	          View,
	          { style: [styles.instructionContainer, { backgroundColor: instructionColor, color: instructionTitleColor }] },
	          React.createElement(
	            View,
	            { style: { flex: 1, alignSelf: 'center' } },
	            React.createElement(
	              ReUpText,
	              { appManager: typeof appManager === 'undefined' ? null : appManager, style: [styles.instructionText, { numberOfLines: 3, color: instructionTitleColor }] },
	              rewardTitle
	            )
	          ),
	          React.createElement(
	            View,
	            { style: { width: 50 } },
	            React.createElement(ReUpIconButton, { type: 3,
	              appManager: appManager,
	              featureData: this.props.featureData,
	              appActions: this.props.appActions,
	              locParams: [rewardTitle]
	            })
	          )
	        ),
	        React.createElement(ShadowView, { appManager: appManager, layout: this.state.layout }),
	        React.createElement(QRCodeView, { key: 'qrcode', data: qrDataBase64, dimension: dimension, style: styles.qrcode, spinnerView: React.createElement(MKSpinner, { style: { alignSelf: 'center', backgroundColor: 'transparent' }, strokeColor: [generalTitleColor] }) }),
	        others.length > 0 ? React.createElement(
	          View,
	          null,
	          React.createElement(
	            View,
	            null,
	            React.createElement(
	              ScrollView,
	              { ref: 'expiryScroll', horizontal: true, pagingEnabled: true, showsHorizontalScrollIndicator: false, style: { alignSelf: 'stretch', height: 80 },
	                onScroll: function onScroll(info) {
	                  thisRewards.onScroll(info.nativeEvent.contentOffset.x);
	                } },
	              others.map(function (other, index) {
	                return React.createElement(
	                  View,
	                  { style: { width: layout.width, height: 80, justifyContent: 'center', alignItems: 'center' } },
	                  React.createElement(
	                    View,
	                    { style: { justifyContent: 'center', alignItems: 'center', flexDirection: 'row' } },
	                    React.createElement(
	                      ReUpText,
	                      { appManager: appManager },
	                      locManager.localizedStringForKey("EXPIRES_STATEMENT", "Expires ")
	                    ),
	                    React.createElement(ReUpCountdown, { appManager: appManager, endDate: new Date(other.DateExpires.replace(' ', 'T') + 'Z'), complete: function complete() {
	                        thisRewards._hasExpired = true;
	                        appActions.showLocalizedAlert(locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_TITLE", "Reward Expired"), locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_DESCRIPTION", "Sorry, this reward has expired."), ["OK_ALERT_BUTTON"], [function () {
	                          appActions.hideAlert();
	                          appActions.requestPop();
	                        }], function () {
	                          appActions.requestPop();
	                        });
	                      } })
	                  )
	                );
	              })
	            ),
	            React.createElement(ReUpButton, { appManager: appManager, style: { position: 'absolute', left: 0 } }),
	            this.state.shouldShowPrevious ? React.createElement(
	              View,
	              { style: { position: 'absolute', left: 10, top: 0, bottom: 0, justifyContent: 'center', alignItems: 'center' } },
	              React.createElement(ReUpIconButton, { iconName: "angle-left", appManager: appManager, type: 1, onPress: function onPress() {
	                  thisRewards.refs.expiryScroll.scrollTo({ x: (thisRewards.state.currentPageIndex - 1) * layout.width });
	                } })
	            ) : null,
	            this.state.shouldShowNext ? React.createElement(
	              View,
	              { style: { position: 'absolute', right: 10, top: 0, bottom: 0, justifyContent: 'center', alignItems: 'center' } },
	              React.createElement(ReUpIconButton, { iconName: "angle-right", appManager: appManager, type: 1, onPress: function onPress() {
	                  thisRewards.refs.expiryScroll.scrollTo({ x: (thisRewards.state.currentPageIndex + 1) * layout.width });
	                } })
	            ) : null
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center' } },
	            shouldShowPageControl ? others.map(function (page, index) {
	              if (index == thisRewards.state.currentPageIndex) {
	                return React.createElement(View, { style: { marginHorizontal: 5, width: 8, height: 8, borderRadius: 999, backgroundColor: appManager.getColorForKey("FeedCardBannerColor") } });
	              }
	              return React.createElement(View, { style: { marginHorizontal: 5, width: 8, height: 8, borderRadius: 999, backgroundColor: appManager.getColorForKey("FeedCardTitleColor") } });
	            }) : null
	          )
	        ) : typeof this.props.extras.reward.DateExpires !== 'undefined' ? React.createElement(
	          View,
	          { style: { justifyContent: 'center', alignItems: 'center', flexDirection: 'row' } },
	          React.createElement(
	            ReUpText,
	            { appManager: appManager },
	            locManager.localizedStringForKey("EXPIRES_STATEMENT", "Expires ")
	          ),
	          React.createElement(ReUpCountdown, { appManager: appManager, endDate: new Date(this.props.extras.reward.DateExpires.replace(' ', 'T') + 'Z'), complete: function complete() {
	              appActions.showLocalizedAlert(locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_TITLE", "Reward Expired"), locManager.localizedStringForKey("REWARD_EXPIRED_ALERT_DESCRIPTION", "Sorry, this reward has expired."), ["OK_ALERT_BUTTON"], [function () {
	                appActions.hideAlert();
	                appActions.requestPop();
	              }], function () {
	                appActions.requestPop();
	              });
	            } })
	        ) : null
	      )
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    alignItems: 'stretch',
	    flexDirection: 'column'
	  },
	  actionBarSpacer: {
	    height: Globals.ACTION_BAR_HEIGHT
	  },
	  instructionContainer: {
	    backgroundColor: 'blue',
	    flexDirection: 'row'
	  },
	  instructionText: {
	    margin: 10
	  },
	  backgroundView: {
	    position: 'absolute'
	  },
	  qrcode: {
	    padding: 30,
	    alignItems: 'center'
	  },
	  tipContainer: {
	    height: 50,
	    flex: 1,
	    padding: 10
	  },
	  tipTypeContainer: {
	    height: 50,
	    width: 180,
	    alignSelf: 'center'
	  },
	  textField: {
	    width: 120,
	    height: 50,
	    marginTop: 10
	  },
	  button: {
	    justifyContent: 'center',
	    flex: 1
	  },
	  tipValueContainer: {
	    paddingTop: 4,
	    paddingLeft: 20,
	    paddingRight: 20,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row'
	  }
	});
	
	UseReward.dataDependencies = ["Rewards", "OneTimeRewards"];
	
	module.exports = UseReward;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _colorContrastChecker = __webpack_require__(1174);
	
	var _colorContrastChecker2 = _interopRequireDefault(_colorContrastChecker);
	
	var _DBManager = __webpack_require__(1103);
	
	var _DBManager2 = _interopRequireDefault(_DBManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlistParser = __webpack_require__(1238);
	var plist = __webpack_require__(1239);
	
	var LocalizationManager = __webpack_require__(1119);
	var ModelConstants = __webpack_require__(11);
	var PlatformConstants = __webpack_require__(31);
	var DeepLinkManager = __webpack_require__(1161);
	var NetworkManager = __webpack_require__(15);
	var BundleVersion = __webpack_require__(844);
	var EventEmitter = __webpack_require__(857);
	var DeviceInfo = __webpack_require__(1379);
	var PushManager = __webpack_require__(1164);
	
	var AnalyticsManager = __webpack_require__(50);
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var StatusBar = ReactNative.StatusBar,
	    Platform = ReactNative.Platform,
	    NativeModules = ReactNative.NativeModules,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    AppState = ReactNative.AppState,
	    Linking = ReactNative.Linking;
	
	
	var AccessibilityManager = NativeModules.AccessibilityManager;
	var AmazonSNSManager = NativeModules.RNAmazonSNSManager;
	var RNReUpUpdater = NativeModules.RNReUpUpdater;
	
	var RNFS = __webpack_require__(96);
	
	var RNZipManager = NativeModules.RNZipManager;
	
	var PushNotification = __webpack_require__(1168);
	
	var DEFAULT_USER = null;
	if (false) {
	  DEFAULT_USER = {
	    DollarsPerPoint: 1,
	    UserID: 1,
	    UserName: "kjregan10@gmail.com",
	    Password: "12341234",
	    Hash: "asdf",
	    FirstName: "Kelsey",
	    LastName: "Regan",
	    DOB: "",
	    Admin: 0,
	    Credit: 100,
	    Points: 1100,
	    QRCode_Pay: "QRCode_Pay",
	    QRCode_Redeem: "QRCode_Redeem",
	    STRIPE_lastFour: "",
	    STRIPE_paymentType: "",
	    STRIPE_pubKey: "",
	    PayPalClientID: "",
	    PayPal_Environment: "PayPal_Environment",
	    CardType: "0",
	    PaymentInfo: "PaymentInfo",
	    PayPal_ClientID: "PayPal_ClientID",
	    DirtyPassword: 0,
	    CC_Gateway_Primary: "CC_Gateway_Primary",
	    PayMode: 0,
	    PhoneNumber: "",
	    ShowPhoneNumber: 0,
	    RequirePhoneForPurchase: 0,
	    RequirePhoneForRewards: 0,
	    RequirePostalCode: 0,
	    RequirePhoneForPaymentTypes: 0,
	    HasPassword: 1,
	    HasFacebook: 0,
	    DefaultDistance: "km",
	    UsePhoneLoyalty: 0,
	    TotalCreditUsedAtScanner: 100,
	    TotalPointsUsedAtScanner: 100,
	    TotalPointsAddedAtScanner: 100
	  };
	}
	
	function getParameterByName(url, name) {
	  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
	      results = regex.exec(url);
	  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
	}
	
	function _findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	  return result;
	}
	
	function calcLuminance(hex) {
	  var r = parseInt("0x" + hex.substring(0, 2));
	  var g = parseInt("0x" + hex.substring(2, 4));
	  var b = parseInt("0x" + hex.substring(4, 6));
	
	  return (r * 0.299 + g * 0.587 + b * 0.114) / parseFloat(256);
	}
	
	function shadeBlend(p, c0, c1) {
	  var n = p < 0 ? p * -1 : p,
	      u = Math.round,
	      w = parseInt;
	  if (c0.length > 7) {
	    var f = c0.split(","),
	        t = (c1 ? c1 : p < 0 ? "rgb(0,0,0)" : "rgb(255,255,255)").split(","),
	        R = w(f[0].slice(4)),
	        G = w(f[1]),
	        B = w(f[2]);
	    return "rgb(" + (u((w(t[0].slice(4)) - R) * n) + R) + "," + (u((w(t[1]) - G) * n) + G) + "," + (u((w(t[2]) - B) * n) + B) + ")";
	  } else {
	    var f = w(c0.slice(1), 16),
	        t = w((c1 ? c1 : p < 0 ? "#000000" : "#FFFFFF").slice(1), 16),
	        R1 = f >> 16,
	        G1 = f >> 8 & 0x00FF,
	        B1 = f & 0x0000FF;
	    return "#" + (0x1000000 + (u(((t >> 16) - R1) * n) + R1) * 0x10000 + (u(((t >> 8 & 0x00FF) - G1) * n) + G1) * 0x100 + (u(((t & 0x0000FF) - B1) * n) + B1)).toString(16).slice(1);
	  }
	}
	
	function encodeQueryData(data) {
	  var ret = [];
	  for (var d in data) {
	    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
	  }return ret.join("&");
	}
	
	var DB = __webpack_require__(846);
	global.self = global; //DO NOT DELETE
	
	var NextContextID = -1;
	
	function copyFile(source, destination, encoding, completion) {
	  RNFS.readFile(source.replace(/file\:\/\//g, ''), encoding).then(function (contents) {
	    RNFS.writeFile(destination.replace(/file\:\/\//g, ''), contents, encoding).then(function (success) {
	      if (completion) completion(success);
	    }).catch(function (err) {
	      //console.log(err.message);
	      if (completion) completion(true);
	    });
	  }).catch(function (err) {
	    //console.log(err.message, err.code);
	    if (completion) completion(false);
	  });
	}
	
	// for now, return that there is no '.' in the name
	function isDir(fileName) {
	  return fileName.search('\\.') < 0;
	}
	
	function encodingForFile(fileName) {
	  if (fileName.search('\\.plist') >= 0 || fileName.search('\\.json') >= 0) return 'utf8';
	
	  return 'base64';
	}
	
	function copyDirectory(source, destination, completion) {
	  RNFS.mkdir(destination.replace(/file\:\/\//g, '')).then(function (result) {
	    //console.log("TESTREUP", "mkdir", result)
	    var success = typeof result !== 'undefined' && result[0];
	    RNFS.readDir(source.replace(/file\:\/\//g, '')).then(function (result) {
	      //console.log("TESTREUP", "readir", result)
	      copyFiles(result, destination, function () {
	        if (completion) completion();
	      });
	    }).catch(function (err) {
	      //console.log("TESTREUP", "readir error", err.message, err.code)
	      completion();
	    });
	  }).catch(function (err) {
	    //console.log("TESTREUP", "mkdir error", err)
	  });
	}
	
	var __DEV__ = false;
	
	function copyFiles(fileSources, fileDestination, completion, index) {
	  var currIndex = typeof index === 'undefined' ? 0 : index;
	  if (currIndex >= fileSources.length) {
	    if (completion) completion();
	    return;
	  }
	
	  var fileSource = fileSources[currIndex];
	  var fileName = fileSource.name;
	  var filePath = fileSource.path;
	  var fileDestinationPath = fileDestination + '/' + fileName;
	  if (isDir(fileName)) {
	    copyDirectory(filePath.replace(/file\:\/\//g, ''), fileDestinationPath.replace(/file\:\/\//g, ''), function (didSucceed) {
	      copyFiles(fileSources, fileDestination.replace(/file\:\/\//g, ''), completion, ++currIndex);
	    });
	  } else {
	    var encoding = encodingForFile(fileName);
	    copyFile(filePath.replace(/file\:\/\//g, ''), fileDestinationPath.replace(/file\:\/\//g, ''), encoding, function (didSucceed) {
	      copyFiles(fileSources, fileDestination.replace(/file\:\/\//g, ''), completion, ++currIndex);
	    });
	  }
	}
	
	function deleteDirectory(directory, completion) {
	  RNFS.unlink(directory).then(function () {
	    if (completion) completion();
	  }).catch(function (err) {
	    if (completion) completion();
	  });
	}
	
	var tableData = [{ tableName: "Variables", primaryKey: "key" }, { tableName: "Auphan", primaryKey: "store_id" }];
	
	var AppManager = {
	  getReUpScrollViewContext: function getReUpScrollViewContext() {
	    NextContextID++;
	
	    return "ReUpScrollView" + NextContextID;
	  },
	
	  _isDemo: _findGetParameter("isDemo"),
	  TUTORIAL_LAST_VIEWED: "TUTORIAL_LAST_VIEWED",
	  _eventEmitter: new EventEmitter(),
	  _dbManager: new _DBManager2.default(),
	  _varTable: null,
	  _fontScale: 1,
	  _imageCachePostfix: 0,
	  _hasInitialized: false,
	  _availableLocales: [],
	  _activeLocale: null,
	  _deviceLocale: null,
	
	  initialize: function initialize(completion) {
	    if (typeof screen !== 'undefined' && typeof screen.lockOrientation !== 'undefined') screen.lockOrientation("portrait-primary");
	    this._hasInitialized = true;
	    var thisThing = this;
	    PushManager.initialize();
	    DeepLinkManager.removeEventListener();
	    DeepLinkManager.addEventListener(function (event) {
	      thisThing._handleOpenURL(event, thisThing);
	    });
	    if (DeviceEventEmitter) {
	      DeviceEventEmitter.removeListener('didRegisterPush');
	      DeviceEventEmitter.addListener('didRegisterPush', function (deviceInfo) {
	        thisThing.setDeviceInfo(deviceInfo);
	      });
	    }
	    // AppState.removeEventListener('change'); // removing this for now, web is compaining if it removes a listener that doesn't exist
	    AppState.addEventListener('change', function (appState) {
	      thisThing._handleAppStateChange(appState);
	    });
	
	    this._dbManager.initialize(tableData, function () {
	      thisThing._varTable = thisThing._dbManager.table("Variables");
	      thisThing._auphanTable = thisThing._dbManager.table("Auphan");
	      thisThing.convertVariablesFromOldDB(function () {
	        if (Platform.OS != 'web') {
	          PushNotification.configure({
	
	            // (optional) Called when Token is generated (iOS and Android)
	            onRegister: function onRegister(token) {
	              thisThing.setDeviceInfo({
	                installationId: token.token,
	                deviceType: token.os
	              });
	            },
	
	            // (required) Called when a remote or local notification is opened or received
	            onNotification: function onNotification(notification) {
	              console.log('NOTIFICATION:', notification);
	            },
	
	            // ANDROID ONLY: GCM Sender ID (optional - not required for local notifications, but is need to receive remote push notifications)
	            senderID: "873218453782",
	
	            // IOS ONLY (optional): default: all - Permissions to register.
	            permissions: {
	              alert: true,
	              badge: true,
	              sound: true
	            },
	
	            // Should the initial notification be popped automatically
	            // default: true
	            popInitialNotification: true,
	
	            /**
	              * (optional) default: true
	              * - Specified if permissions (ios) and token (android and ios) will requested or not,
	              * - if not, you must call PushNotificationsHandler.requestPermissions() later
	              */
	            requestPermissions: true
	          });
	        }
	        thisThing.syncDeviceInfo();
	        thisThing.resetResourcesIfPackagedVersionIsNewer(function (version) {
	          thisThing.checkForDownloadedResourcesAndSwap(function () {
	            thisThing.initializeWithPList(PlatformConstants.configFileName, function () {
	              if (RNReUpUpdater) RNReUpUpdater.setResourceHeader(AppManager._appData.Header);
	              thisThing.getCurrentUser();
	              thisThing.updateCurrentPosition();
	              AnalyticsManager.initialize(thisThing);
	              thisThing._imageCachePostfix++;
	
	              var doAfterDone = function doAfterDone() {
	                thisThing.updateCurrentPosition();
	                AnalyticsManager.initialize(thisThing);
	                thisThing._imageCachePostfix++;
	
	                if (Platform.OS == 'ios') {
	                  AccessibilityManager.getMultiplier(function (value) {
	                    thisThing._fontScale = value;
	                    if (completion) completion();
	                  });
	                } else {
	                  if (completion) completion();
	                }
	                thisThing._checkURL(thisThing);
	              };
	
	              var appManager = AppManager;
	              var locManager = AppManager.getLocalizationManager();
	              var features = thisThing.getFeatureDict();
	              if (typeof features.FeedPlus !== 'undefined') features.FeedPlus.data.title = locManager.localizedStringForKey("FEED_TITLE");
	              if (typeof features.PhoneNumberVerify !== 'undefined') {
	                features.PhoneNumberVerify.data.title = locManager.localizedStringForKey("SET_PHONE_TITLE");
	                features.PhoneNumberVerify.data.instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
	              }
	              if (typeof features.Birthday !== 'undefined') {
	                features.Birthday.data.title = locManager.localizedStringForKey("SET_BIRTHDAY_TITLE");
	                features.Birthday.data.instructions = locManager.localizedStringForKey("SET_BIRTHDAY_INSTRUCTIONS");
	              }
	              if (typeof features.PhoneNumberVerify !== 'undefined') {
	                features.PhoneNumberVerify.data.title = locManager.localizedStringForKey("SET_PHONE_TITLE");
	                features.PhoneNumberVerify.data.instructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
	              }
	              if (typeof features.SimpleSettings !== 'undefined') features.SimpleSettings.data.title = locManager.localizedStringForKey("SIMPLE_SETTINGS_TITLE");
	              if (typeof features.SimpleCreateUser !== 'undefined') features.SimpleCreateUser.data.title = locManager.localizedStringForKey("SIMPLE_CREATE_USER_TITLE");
	              if (typeof features.SimpleCFD !== 'undefined') features.SimpleCFD.data.title = locManager.localizedStringForKey("LOGIN_TITLE");
	              if (typeof features.ProHome !== 'undefined') features.ProHome.data.title = locManager.localizedStringForKey("FEED_TITLE");
	
	              var userID = _findGetParameter("userid");
	              var hash = _findGetParameter("hash");
	              if (_findGetParameter("isPass") == "1" || _findGetParameter("isPassFree") == "1" || _findGetParameter("isPassPro") == "1") {
	                if (userID != null && hash != null) {
	                  // logged into correct account, proceed to pass home
	                  NetworkManager.getUser(appManager, userID, hash, function (urlUser) {
	                    if (typeof urlUser["ExtFirstName"] !== 'undefined') appManager._urlFirstName = urlUser["ExtFirstName"];
	                    if (typeof urlUser["ExtLastName"] !== 'undefined') appManager._urlLastName = urlUser["ExtLastName"];
	                    if (typeof urlUser["ExtEmail"] !== 'undefined' && urlUser["ExtEmail"].indexOf("@") > 0) appManager._urlEmail = urlUser["ExtEmail"];
	
	                    urlUser[ModelConstants.Password] = hash;
	                    NetworkManager.getLinkedUsers(appManager, userID, hash, function (linkedUsers) {
	                      var emailUser = null;
	                      var phoneUser = null;
	                      for (var i = 0; i < linkedUsers.length; i++) {
	                        if (linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app") emailUser = linkedUsers[i];
	                        if (linkedUsers[i]["Type"] == "phone") phoneUser = linkedUsers[i];
	                      }
	
	                      if (emailUser == null) {
	                        AppManager._currentUser = null;
	                        thisThing._needsRegistration = true;
	                        doAfterDone();
	                      } else {
	                        userID = emailUser[ModelConstants.UserID];
	                        hash = emailUser[ModelConstants.Hash];
	                        NetworkManager.getUser(appManager, userID, hash, function (emailUserUpdated) {
	                          emailUserUpdated[ModelConstants.Password] = emailUserUpdated[ModelConstants.Hash];
	                          appManager.setCurrentUser(emailUserUpdated, function () {
	                            doAfterDone();
	                          });
	                        }, function () {
	                          AppManager._currentUser = null;
	                          AppManager._expiredLink = true;
	                          doAfterDone();
	                        }, function () {
	                          AppManager._currentUser = null;
	                          AppManager._expiredLink = true;
	                          doAfterDone();
	                        });
	                      }
	                    }, function (errorData) {
	                      AppManager._currentUser = null;
	                      AppManager._expiredLink = true;
	                      doAfterDone();
	                      console.log("errorData", errorData);
	                    }, function (errorData) {
	                      AppManager._currentUser = null;
	                      AppManager._expiredLink = true;
	                      doAfterDone();
	                      console.log("errorData", errorData);
	                    });
	                  }, function () {
	                    AppManager._currentUser = null;
	                    AppManager._expiredLink = true;
	                    doAfterDone();
	                  }, function () {
	                    AppManager._currentUser = null;
	                    AppManager._expiredLink = true;
	                    doAfterDone();
	                  });
	                } else if (appManager._isDemo) {
	                  NetworkManager.login(appManager, "kjregan10@gmail.com", "asdfwxyzabcd", function (urlUser) {
	                    userID = urlUser[ModelConstants.UserID];
	                    hash = urlUser[ModelConstants.Hash];
	                    NetworkManager.getLinkedUsers(appManager, userID, hash, function (linkedUsers) {
	                      var emailUser = null;
	                      var phoneUser = null;
	                      for (var i = 0; i < linkedUsers.length; i++) {
	                        if (linkedUsers[i]["Type"] == "email" || linkedUsers[i]["Type"] == "app") emailUser = linkedUsers[i];
	                        if (linkedUsers[i]["Type"] == "phone") phoneUser = linkedUsers[i];
	                      }
	
	                      if (emailUser == null) {
	                        thisThing._needsRegistration = true;
	                        doAfterDone();
	                      } else {
	                        userID = emailUser[ModelConstants.UserID];
	                        hash = emailUser[ModelConstants.Hash];
	                        NetworkManager.getUser(appManager, userID, hash, function (emailUser) {
	                          emailUser[ModelConstants.Password] = hash;
	                          appManager.setCurrentUser(emailUser, function () {
	                            doAfterDone();
	                          });
	                        }, function () {
	                          AppManager._currentUser = null;
	                          AppManager._expiredLink = true;
	                          doAfterDone();
	                        }, function () {
	                          AppManager._currentUser = null;
	                          AppManager._expiredLink = true;
	                          doAfterDone();
	                        });
	                      }
	                    }, function (errorData) {
	                      AppManager._currentUser = null;
	                      AppManager._expiredLink = true;
	                      doAfterDone();
	                      console.log("errorData", errorData);
	                    }, function (errorData) {
	                      AppManager._currentUser = null;
	                      AppManager._expiredLink = true;
	                      doAfterDone();
	                      console.log("errorData", errorData);
	                    });
	                  }, function () {
	                    AppManager._currentUser = null;
	                    AppManager._expiredLink = true;
	                    doAfterDone();
	                  }, function () {
	                    AppManager._currentUser = null;
	                    AppManager._expiredLink = true;
	                    doAfterDone();
	                  });
	                } else {
	                  AppManager._currentUser = null;
	                  AppManager._needsCFD = true;
	                  doAfterDone();
	                }
	              } else {
	                thisThing.getCurrentUser();
	
	                doAfterDone();
	              }
	            });
	          });
	        });
	      });
	    });
	  },
	
	  getActiveLocale: function getActiveLocale() {
	    var devicelocalehaschanged = (window.navigator.userLanguage || window.navigator.language) != this._deviceLocale;
	    if (this._activeLocale == null || devicelocalehaschanged) {
	      var deviceLocale = this.getDeviceLocale();
	      var localeSet = false;
	      //checking for exact match
	      for (var i = 0; i < this._availableLocales.length; i++) {
	        if (this._availableLocales[i] == deviceLocale) {
	          this._activeLocale = this._availableLocales[i];
	          localeSet = true;
	          break;
	        }
	      }
	
	      if (!localeSet) {
	        //checking for major language match
	        for (var i = 0; i < this._availableLocales.length; i++) {
	          var majorLangDevice = deviceLocale.substr(0, 2);
	          var majorLangAvailableLocale = this._availableLocales[i].substr(0, 2);
	          if (majorLangDevice == majorLangAvailableLocale) {
	            this._activeLocale = this._availableLocales[i];
	            localeSet = true;
	            break;
	          }
	        }
	      }
	      if (!localeSet) this._activeLocale = "";
	    }
	
	    return this._activeLocale;
	  },
	
	  getDeviceLocale: function getDeviceLocale() {
	    if (this._deviceLocale == null || this._deviceLocale != (window.navigator.userLanguage || window.navigator.language)) {
	      RNFS.readFile(PlatformConstants.configFileName.replace(/file\:\/\//g, '')).then(function (contents) {
	        var data = plist.parse(contents); //plist.parse();
	        AppManager.setAppData(data);
	      }).catch(function (error) {});
	      this._deviceLocale = this.getDeviceInfo().locale;
	    }
	
	    return this._deviceLocale;
	  },
	
	  setAvailableLocales: function setAvailableLocales(data) {
	    var appData = Object.keys(data);
	    var localesfound = [];
	    var LocalizedStringPlistElement = "LocalizedStrings";
	    var HeaderPlistElement = "Header";
	    var FeaturePlistElement = "Features";
	
	    appData.forEach(function (element) {
	      var thisLocale = "";
	      if (element.includes(LocalizedStringPlistElement)) {
	        var LocalizedStringLength = LocalizedStringPlistElement.length;
	        var elementStringLength = element.length;
	        // default lang
	        if (elementStringLength == LocalizedStringLength) return;
	
	        var thisLocale = element.substr(LocalizedStringLength + 1, elementStringLength);
	        var localeDefined = false;
	        localesfound.forEach(function (foundLocales) {
	          if (typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale) {
	            foundLocales.frequency = foundLocales.frequency + 1;
	            localeDefined = true;
	            return;
	          }
	        });
	        if (!localeDefined) {
	          localesfound.push({ "locale": thisLocale, "frequency": 1 });
	        }
	      }
	      if (element.includes(HeaderPlistElement)) {
	        var HeaderLength = HeaderPlistElement.length;
	        var elementStringLength = element.length;
	        // default lang
	        if (elementStringLength == HeaderLength) return;
	
	        var thisLocale = element.substr(HeaderLength + 1, elementStringLength);
	        var localeDefined = false;
	        localesfound.forEach(function (foundLocales) {
	          if (typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale) {
	            foundLocales.frequency = foundLocales.frequency + 1;
	            localeDefined = true;
	            return;
	          }
	        });
	        if (!localeDefined) {
	          localesfound.push({ "locale": thisLocale, "frequency": 1 });
	        }
	      }
	      if (element.includes(FeaturePlistElement)) {
	        var FeatureLength = FeaturePlistElement.length;
	        var elementStringLength = element.length;
	        // default lang
	        if (elementStringLength == FeatureLength) return;
	
	        var thisLocale = element.substr(FeatureLength + 1, elementStringLength);
	        var localeDefined = false;
	        localesfound.forEach(function (foundLocales) {
	          if (typeof foundLocales !== 'undefined' && typeof foundLocales.locale !== 'undefined' && foundLocales.locale == thisLocale) {
	            foundLocales.frequency = foundLocales.frequency + 1;
	            localeDefined = true;
	            return;
	          }
	        });
	        if (!localeDefined) {
	          localesfound.push({ "locale": thisLocale, "frequency": 1 });
	        }
	      }
	    });
	
	    var self = this;
	    localesfound.forEach(function (foundLocales) {
	      if (foundLocales.frequency == 3) self._availableLocales.push(foundLocales.locale);
	    });
	  },
	
	  initializeWithPList: function initializeWithPList(plistPath, completion) {
	    var contentsHandler = function contentsHandler(contents) {
	      // log the file contents
	      // var plist = new PlistParser.PlistParser(contents);
	      var data = contents;
	      if (typeof contents === 'string') {
	        var plist = new PlistParser.PlistParser(contents);
	        data = plist.parse();
	      }
	
	      AppManager.setAvailableLocales(data);
	      AppManager.setAppData(data);
	      // check if we are logged in
	      AppManager.getCurrentUser(function (user) {
	        if (completion) completion(data);
	      });
	    };
	
	    if (typeof this.configOverride !== 'undefined' && this.configOverride != null) {
	      contentsHandler(this.configOverride);
	    } else {
	      RNFS.readFile(plistPath.replace(/file\:\/\//g, '')).then(contentsHandler).catch(function (err) {
	        //console.log(err.message, err.code);
	      });
	    }
	  },
	
	  resetResources: function resetResources(completion) {
	    if (Platform.OS == "web") {
	      completion();
	      return;
	    }
	    var sourceDir = PlatformConstants.packagedResourcesDirectory;
	    var destDir = PlatformConstants.resourcesDirectory;
	    copyDirectory(sourceDir, destDir, completion);
	  },
	
	  resetResourcesIfPackagedVersionIsNewer: function resetResourcesIfPackagedVersionIsNewer(completion) {
	    var thisThing = this;
	    this.getVariable('lastInstalledVersion', function (bundleVersion) {
	      if (bundleVersion != null && BundleVersion != bundleVersion) {
	        thisThing.resetResources(function () {
	          completion(true);
	        });
	      } else {
	        completion(false);
	      }
	    });
	  },
	
	  doResourcesExist: function doResourcesExist(completion) {
	    RNFS.readFile(PlatformConstants.configFileName.replace(/file\:\/\//g, ''), 'utf8').then(function (contents) {
	      if (completion) completion(contents.length > 0);
	    }).catch(function (err) {
	      if (completion) completion(false);
	    });
	  },
	
	  doPendingResourcesExist: function doPendingResourcesExist(completion) {
	    RNFS.readFile(PlatformConstants.pendingConfigFileName.replace(/file\:\/\//g, ''), 'utf8').then(function (contents) {
	      if (completion) completion(contents.length > 0);
	    }).catch(function (err) {
	      if (completion) completion(false);
	    });
	  },
	
	  doesResourceExist: function doesResourceExist(filePath, completion) {
	    RNFS.exists(PlatformConstants.resourcesDirectory.replace(/file\:\/\//g, '') + "/" + filePath).then(completion);
	  },
	
	  syncPendingResources: function syncPendingResources(completion) {
	    if (Platform.OS == "web") {
	      completion();
	      return;
	    }
	    var thisThing = this;
	    this.getVariable('lastInstalledVersion', function (value) {
	      thisThing.setVariable('lastInstalledVersion', BundleVersion, function () {});
	      var shouldReset = typeof value === 'undefined' || value == null;
	      var thisBundleVersionParts = BundleVersion.split(".");
	      if (!shouldReset && thisBundleVersionParts.length == 3) {
	        var valueParts = value.split('.');
	        if (valueParts.length == 3) {
	          shouldReset |= parseInt(valueParts[2]) < parseInt(thisBundleVersionParts[2]);
	        }
	      }
	      if (shouldReset) {
	        thisThing.resetResources(function () {
	          if (completion) completion(true);
	        });
	      } else {
	        var sourceZip = PlatformConstants.pendingResourcesDirectory.replace(/file\:\/\//g, '') + ".zip"; //PlatformConstants.pendingResourcesDirectory + '.zip';
	        if (RNZipManager) {
	          RNZipManager.unzip(sourceZip, PlatformConstants.absoluteFilesPrefix.replace(/file\:\/\//g, ''), true, function (didSucceed) {
	            if (completion) completion(true);
	          });
	        } else {
	          if (completion) completion(true);
	        }
	      }
	    });
	  },
	
	  checkForDownloadedResourcesAndSwap: function checkForDownloadedResourcesAndSwap(completion) {
	    var appManager = this;
	    appManager.syncPendingResources(function () {
	      appManager.doResourcesExist(function (resourceExist) {
	        if (resourceExist) {
	          if (completion) completion();
	        } else {
	          appManager.resetResources(function () {
	            if (completion) completion();
	          });
	        }
	      });
	    });
	  },
	
	  _didDownloadResources: false,
	  downloadNewResources: function downloadNewResources() {
	    if (this._didDownloadResources) return;
	    this._didDownloadResources = true;
	
	    var mockSize = 1400000;
	    var appManager = this;
	    var resourceUpdaterURL = "https://builder.getreup.com/php/ResourceManager.php?";
	    if (typeof this._appData["ResourceVersions"] === 'undefined' || typeof this._appData["ResourceVersions"]["ReUp-Config.plist"] === 'undefined') return;
	
	    var params = {
	      methodName: "DownloadResources",
	      appID: this._appData["Header"]["AppID"],
	      bundleVersion: BundleVersion,
	      resourceVersion: this._appData["ResourceVersions"]["ReUp-Config.plist"],
	      platform: Platform.OS,
	      config: __DEV__ ? 'dev' : 'prod'
	    };
	    resourceUpdaterURL = resourceUpdaterURL + encodeQueryData(params);
	    var options = {
	      fromUrl: resourceUpdaterURL, // URL to download file from
	      toFile: PlatformConstants.pendingResourcesDirectory.replace(/file\:\/\//g, '') + ".zip", // Local filesystem path to save the file to
	      background: true,
	      begin: function begin(downloadBeginCallbackResult) {
	        var jobID = downloadBeginCallbackResult.jobID,
	            statusCode = downloadBeginCallbackResult.statusCode,
	            contentLength = downloadBeginCallbackResult.contentLength,
	            headers = downloadBeginCallbackResult.headers;
	
	        appManager._eventEmitter.emit("downloadStarted");
	      },
	      progress: function progress(downloadProgressCallbackResult) {
	        var jobID = downloadProgressCallbackResult.jobID,
	            contentLength = downloadProgressCallbackResult.contentLength,
	            bytesWritten = downloadProgressCallbackResult.bytesWritten;
	        //console.log(progressObj.bytesWritten)
	
	        appManager._eventEmitter.emit("downloadProgressed", { progress: 100 * bytesWritten / mockSize });
	      }
	    };
	
	    if (RNFS.downloadFile) {
	      RNFS.downloadFile(options).promise.then(function (downloadResult) {
	        if (appManager._didDownloadResources) appManager._eventEmitter.emit("downloadCompleted", { updateSuccess: typeof downloadResult.bytesWritten !== 'undefined' && downloadResult.bytesWritten > 0 });
	        appManager._didDownloadResources = false;
	      }).catch(function (err) {
	        appManager._didDownloadResources = false;
	      });
	    }
	  },
	
	  _checkURL: function _checkURL(thisThing) {
	    DeepLinkManager.getLaunchedURL(function (url) {
	      if (url) thisThing._handleOpenURL({ url: url }, thisThing);
	    });
	  },
	
	  _handleOpenURL: function _handleOpenURL(event, appManager) {
	    if (appManager.isLoggedIn()) return;
	
	    var reupParam = getParameterByName(event.url, "REUPKEY");
	    if (reupParam && reupParam.length > 0) {
	      var stateKey = getParameterByName(event.url, "REUPKEY");
	      var base64Info = getParameterByName(event.url, "REUPINFO");
	
	      if (base64Info) {
	        var infoStr = atob(base64Info);
	        if (infoStr) {
	          var info = JSON.parse(infoStr);
	          if (stateKey == "SMNRegistrationLogin" && typeof info[ModelConstants.UserName] !== 'undefined') {
	            var username = info[ModelConstants.UserName].toLowerCase();
	            appManager.getTempUserPass(function (tempUserPass) {
	              if (tempUserPass != null && tempUserPass.length > 1 && typeof tempUserPass[0] !== 'undefined' && tempUserPass[0].toLowerCase() == username.toLowerCase()) {
	                if (appManager.loginCallBackStart) appManager.loginCallBackStart();
	                NetworkManager.login(appManager, tempUserPass[0].trim(), tempUserPass[1], function (data) {
	                  AnalyticsManager.logLoginEvent(appManager, 'auto', true);
	                  data[ModelConstants.Password] = tempUserPass[1];
	                  appManager.setCurrentUser(data, function () {
	                    if (appManager.loginCallBackFinish) appManager.loginCallBackFinish();
	                  });
	                }, function (data) {
	                  AnalyticsManager.logLoginEvent(appManager, 'auto', false);
	                  if (appManager.loginCallBackFinish) appManager.loginCallBackFinish();
	                }, function (data) {
	                  AnalyticsManager.logLoginEvent(appManager, 'auto', false);
	                  if (appManager.loginCallBackFinish) appManager.loginCallBackFinish();
	                });
	              }
	            });
	          }
	        }
	      }
	    }
	  },
	
	  _shouldShowLocKeys: _findGetParameter('domain') != null,
	  _handleAppStateChange: function _handleAppStateChange(appState) {
	    if (appState == 'active') {
	      this.downloadNewResources();
	    }
	  },
	
	  _appData: {},
	  setAppData: function setAppData(data) {
	    var locManager = this.getLocalizationManager();
	    var header = data["Header"];
	    var appName = header["AppName"];
	    var appNameLong = header["AppNameLong"];
	    var fonts = data["Fonts"];
	    var defaultCurrency = header["DefaultCurrency"];
	    var defaultCurrencySymbol = header["DefaultCurrencySymbol"];
	    if (typeof fonts !== 'undefined') this.setFonts(fonts);
	    if (typeof defaultCurrency !== 'undefined') this.setCurrency(defaultCurrency);
	    if (typeof defaultCurrencySymbol !== 'undefined') this.setCurrencySymbol(defaultCurrencySymbol);
	    this.appName = appName;
	    this.appNameLong = appNameLong;
	    var locale = this.getActiveLocale();
	    var featureDatas = typeof locale !== 'undefined' && typeof data["Features-" + locale] !== 'undefined' ? data["Features-" + locale] : data['Features'];
	    if (typeof data["Features-" + locale.split('-')[0]] !== 'undefined') featureDatas = data["Features-" + locale.split('-')[0]];
	    if (typeof data["Features-" + locale] !== 'undefined') featureDatas = data["Features-" + locale];
	    this._appData = data;
	    this.setFeatureDatas(featureDatas);
	    if (typeof featureDatas.FeedPlus === 'undefined') {
	      featureDatas.FeedPlus = {
	        bgImage: 'background.png',
	        headerImage: 'header.png',
	        title: 'Feed',
	        shouldShowInMenu: false
	      };
	    }
	    if (typeof featureDatas.PhoneNumberVerify === 'undefined') {
	      var verifyPhoneNumberTitleString = locManager.localizedStringForKey("SET_PHONE_TITLE");
	      var verifyPhoneNumberInstructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
	      featureDatas.PhoneNumberVerify = {
	        title: verifyPhoneNumberTitleString,
	        shouldShowInMenu: false,
	        instructions: verifyPhoneNumberInstructions
	      };
	    }
	    if (typeof featureDatas.Birthday === 'undefined') {
	      var setBirthdayTitleString = locManager.localizedStringForKey("SET_BIRTHDAY_TITLE");
	      var setBirthdayInstructions = locManager.localizedStringForKey("SET_BIRTHDAY_INSTRUCTIONS");
	      featureDatas.Birthday = {
	        title: setBirthdayTitleString,
	        icon: "birthday-cake",
	        shouldShowInMenu: false,
	        instructions: setBirthdayInstructions
	      };
	    }
	
	    var features = [];
	    var featureDict = {};
	    var shouldShowFeatureKey = this._shouldShowLocKeys;
	    for (var featureName in featureDatas) {
	      var featureData = featureDatas[featureName];
	      featureData["name"] = featureName;
	      var feature = { data: featureData, key: featureName };
	      if (shouldShowFeatureKey) {
	        feature.data.title = "Feature." + featureName + ".title";
	        feature.data.instructions = "Feature." + featureName + ".instructions";
	        feature.data.instructions2 = "Feature." + featureName + ".instructions2";
	        feature.data.tip = "Feature." + featureName + ".tip";
	        feature.data.shortTitle = "Feature." + featureName + ".shortTitle";
	      }
	      features.push(feature);
	      featureDict[featureName] = feature;
	    }
	
	    var adminFeatureDatas = data["Features-admin"];
	    var adminFeatures = [];
	    var adminFeatureDict = {};
	    for (var featureName in adminFeatureDatas) {
	      var featureData = adminFeatureDatas[featureName];
	      featureData["name"] = featureName;
	      console.log("in feature name admin" + featureName);
	      var feature = { data: featureData, key: featureName };
	      if (shouldShowFeatureKey) {
	        feature.data.title = "Features-admin." + featureName + ".title";
	        feature.data.instructions = "Features-admin." + featureName + ".instructions";
	        feature.data.instructions2 = "Features-admin." + featureName + ".instructions2";
	        feature.data.tip = "Features-admin." + featureName + ".tip";
	        feature.data.shortTitlep = "Features-admin." + featureName + ".shortTitle";
	      }
	      adminFeatures.push(feature);
	      adminFeatureDict[featureName] = feature;
	    }
	
	    this.setFeatures(features, adminFeatures);
	    this.setFeatureDict(featureDict, adminFeatureDict);
	
	    this._appData = data;
	    if (_findGetParameter("isPass") == "1") {
	      // this._appData.MainScreen.rootFeature = "PassHome";
	      // this._appData.MainScreen.disableNavHeader = true;
	      this._appData.MainScreen.disableFeed = true;
	      this._appData.MainScreen.buttonType = 2;
	      // if( typeof this._appData.Features.FeedPlus !== 'undefined' ) this._appData.Features.FeedPlus.feedPlusType = 2;
	    } else if (_findGetParameter("isPassFree") == "1") {
	      this._appData.MainScreen.rootFeature = "BasicHome";
	      this._appData.MainScreen.disableNavHeader = true;
	      this._appData.MainScreen.disableFeed = true;
	      this._appData.MainScreen.buttonType = 2;
	      if (typeof this._appData.Features.FeedPlus !== 'undefined') this._appData.Features.FeedPlus.feedPlusType = 2;
	    } else if (_findGetParameter("isPassPro") == "1") {
	      this._appData.MainScreen.rootFeature = "ProHome";
	      this._appData.MainScreen.disableNavHeader = true;
	      this._appData.MainScreen.disableFeed = true;
	      this._appData.MainScreen.buttonType = 2;
	      if (typeof this._appData.Features.FeedPlus !== 'undefined') this._appData.Features.FeedPlus.feedPlusType = 2;
	    }
	    // sets the status bar
	    var headerColor = this.getColorDictionary()["HeaderColor"];
	    var hex = headerColor[0];
	    var isBright = false;
	    if (typeof hex === 'undefined') hex = headerColor["0"];
	    if (typeof hex !== 'undefined') {
	      isBright = calcLuminance(hex) > 0.6;
	      StatusBar.setBarStyle(!isBright ? 'light-content' : 'default', true);
	    }
	
	    if (typeof hex !== 'undefined' && Platform.OS != 'ios') {
	      var headerColor = this.getColorDictionary()["HeaderColor"];
	      var headerColorHex = headerColor[0];
	      var androidStatusColor = isBright ? hex : headerColorHex;
	      var darkenedColor = shadeBlend(-0.6, "#" + androidStatusColor);
	      StatusBar.setBackgroundColor(darkenedColor, true);
	    }
	  },
	
	  getResourceInfo: function getResourceInfo() {
	    var resourceInfo = "";
	    for (var key in this._appData.Header) {
	      if (resourceInfo.length > 0) resourceInfo += "\n";
	      var info = this._appData.Header[key];
	      resourceInfo += key + ": " + info;
	    }
	    return resourceInfo;
	  },
	
	  getAppData: function getAppData() {
	    return this._appData;
	  },
	
	  getImageKey: function getImageKey(name) {
	    return name + "-" + this._imageCachePostfix;
	  },
	
	  absoluteResourceForPath: function absoluteResourceForPath(pathRelativeToReUpResources) {
	    return PlatformConstants.resourcesDirectory + "/" + pathRelativeToReUpResources + (typeof this._imageCacheIndex !== 'undefined' ? "?" + this._imageCacheIndex : "");
	  },
	
	  _fonts: {},
	  setFonts: function setFonts(fonts) {
	    this._fonts = fonts;
	  },
	
	  getFontForKey: function getFontForKey(key) {
	    if (typeof this._fonts[key] === 'undefined') {
	      if (typeof this._fonts.Regular === 'undefined') return "Helvetica";
	
	      return this._fonts.Regular;
	    }
	
	    return this._fonts[key];
	  },
	
	  setAvailableFonts: function setAvailableFonts(fonts) {
	    if (this._fonts == null || typeof this._fonts === 'undefined') return;
	    if (typeof fonts === 'undefined') fonts = [];
	
	    var refinedFonts = {};
	    for (var key in this._fonts) {
	      var foundFont = false;
	      var fontName = this._fonts[key];
	      for (var i = 0; i < fonts.length; i++) {
	        if (fonts[i] == fontName) {
	          foundFont = true;
	          break;
	        }
	      }
	      if (foundFont) refinedFonts.key = fontName;
	      if (!foundFont) alert(fontName);
	    }
	
	    this._fonts = refinedFonts;
	  },
	
	  _defaultCurrency: "CAD",
	  _defaultCurrencySymbol: "$",
	  setCurrency: function setCurrency(currency) {
	    this._defaultCurrency = currency;
	  },
	  setCurrencySymbol: function setCurrencySymbol(currencySymbol) {
	    this._defaultCurrencySymbol = currencySymbol;
	  },
	
	  getCurrencySign: function getCurrencySign() {
	    return this._defaultCurrencySymbol;
	  },
	
	  _features: [],
	  _adminFeatures: [],
	  _topRightFeatures: [],
	  setFeatures: function setFeatures(features, adminFeatures) {
	    this._features = features;
	    this._adminFeatures = adminFeatures;
	    var topRightFeatures = [];
	    for (var i = 0; i < features.length; i++) {
	      var feature = features[i];
	      if (typeof feature !== 'undefined' && typeof feature.data !== 'undefined' && feature.data.shouldShowTopRight) {
	        topRightFeatures.push(feature);
	      }
	    }
	
	    this._topRightFeatures = topRightFeatures;
	
	    // TODO: remove this
	    // this._topRightFeatures = [{
	    //   key:"EarnPay",
	    //   data:{
	    //     title:"Pay • Earn",
	    //     shortTitle:"Pay",
	    //     icon:"credit-pay",
	    //     requiresLogin:true,
	    //     name:"EarnPay",
	    //   }
	    // }]
	  },
	
	  getTopRightFeatures: function getTopRightFeatures() {
	    return this._topRightFeatures;
	  },
	
	  getFeatures: function getFeatures() {
	    if (this.isAdminLoggedIn()) return this._adminFeatures;
	
	    return this._features;
	  },
	
	  getMobileOperatingSystem: function getMobileOperatingSystem() {
	    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	
	    // Windows Phone must come first because its UA also contains "Android"
	    if (/windows phone/i.test(userAgent)) {
	      return "windows";
	    }
	
	    if (/android/i.test(userAgent)) {
	      return "android";
	    }
	
	    // iOS detection from: http://stackoverflow.com/a/9039885/177710
	    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	      return "ios";
	    }
	
	    return "unknown";
	  },
	
	  _featureVersion: 0,
	  setFeatureDatas: function setFeatureDatas(featureDatas) {
	    this._featureVersion++;
	    var locManager = this.getLocalizationManager();
	    var myCardTitleString = locManager.localizedStringForKey("MY_CARD_TITLE");
	    var simpleSettingsTitleString = locManager.localizedStringForKey("SIMPLE_SETTINGS_TITLE");
	    var createAccountTitleString = locManager.localizedStringForKey("CREATE_USER_TITLE");
	    var cfdTitleString = locManager.localizedStringForKey("CFD_TITLE");
	    var loginTitleString = locManager.localizedStringForKey("LOGIN_TITLE");
	    var verifyPhoneNumberTitleString = locManager.localizedStringForKey("SET_PHONE_TITLE");
	    var feedTitleString = locManager.localizedStringForKey("FEED_TITLE");
	    var verifyPhoneNumberInstructions = locManager.localizedStringForKey("PHONE_INSTRUCTIONS");
	
	    if (typeof featureDatas.FeedPlus === 'undefined') {
	      featureDatas.FeedPlus = {
	        bgImage: 'background.png',
	        headerImage: 'header.png',
	        title: 'Feed',
	        shouldShowInMenu: false
	      };
	    }
	
	    if (_findGetParameter("isPass") == "1") {
	      // featureDatas.PassHome = {
	      //   bgImage:'background.png',
	      //   headerImage:'header.png',
	      //   title:'Feed',
	      //   shouldShowInMenu:false
	      // }
	      if (typeof featureDatas.MyCard === 'undefined') {
	        featureDatas.MyCard = {
	          title: myCardTitleString,
	          shouldShowOnFeedPlus: true,
	          shouldShowInMenu: false,
	          icon: 'fa-qrcode',
	          shouldShowTopRight: true
	        };
	      }
	      featureDatas.SimpleSettings = {
	        title: simpleSettingsTitleString,
	        shouldShowOnFeedPlus: true,
	        shouldShowInMenu: false
	      };
	      featureDatas.SimpleCreateUser = {
	        title: createAccountTitleString,
	        shouldShowOnFeedPlus: false,
	        shouldShowInMenu: false
	      };
	      featureDatas.SimpleCFD = {
	        title: cfdTitleString,
	        shouldShowOnFeedPlus: false,
	        shouldShowInMenu: false
	      };
	      featureDatas.SimpleLogin = {
	        title: loginTitleString,
	        shouldShowOnFeedPlus: false,
	        shouldShowInMenu: false
	      };
	      if (typeof featureDatas.Rewards !== 'undefined') {
	        featureDatas.Rewards.title = featureDatas.Rewards.shortTitle;
	      }
	      if (typeof featureDatas.PhoneNumberVerify !== 'undefined') {
	        featureDatas.PhoneNumberVerify.title = verifyPhoneNumberTitleString;
	      }
	      // earnPayFeatureData.data.shouldShowOnFeedPlus = false;
	      // useCreditFeatureData.data.shouldShowOnFeedPlus = false;
	      // rewardsFeatureData.data.shouldShowOnFeedPlus = true;
	      // if( typeof auphanFeatureData !== 'undefined' ) auphanFeatureData.data.shouldShowOnFeedPlus = true;
	      // if( typeof grabbFeatureData !== 'undefined' ) grabbFeatureData.data.shouldShowOnFeedPlus = true;
	
	      delete featureDatas.Instagram;
	      delete featureDatas.EarnPay;
	      delete featureDatas.Auphan;
	      delete featureDatas.Grabb;
	      delete featureDatas.Tutorial;
	      delete featureDatas.Settings;
	      delete featureDatas.Twitter;
	      delete featureDatas.Facebook;
	      this._showTopBar = false;
	      if (typeof featureDatas.Rewards !== 'undefined') featureDatas.Rewards.shouldShowOnFeedPlus = true;
	    } else if (_findGetParameter("isPassFree") == "1") {
	      featureDatas.BasicHome = {
	        bgImage: 'background.png',
	        headerImage: 'header.png',
	        title: feedTitleString,
	        shouldShowInMenu: false
	      };
	      featureDatas.SimpleCFD = {
	        title: cfdTitleString,
	        shouldShowOnFeedPlus: false
	      };
	      featureDatas.TermsPreferences = {
	        title: '',
	        shouldShowOnFeedPlus: false
	      };
	      featureDatas.SimpleSettings = {
	        title: simpleSettingsTitleString,
	        shouldShowOnFeedPlus: true
	      };
	      delete featureDatas.RewardsCampaigns;
	      delete featureDatas.Instagram;
	      delete featureDatas.EarnPay;
	      delete featureDatas.RewardsCampaigns;
	      delete featureDatas.Auphan;
	      delete featureDatas.Grabb;
	      delete featureDatas.Tutorial;
	      delete featureDatas.Twitter;
	      delete featureDatas.PhoneNumberVerify;
	    } else if (_findGetParameter("isPassPro") == "1") {
	      featureDatas.ProHome = {
	        bgImage: 'background.png',
	        headerImage: 'header.png',
	        title: feedTitleString,
	        shouldShowInMenu: false
	      };
	      featureDatas.SimpleCFD = {
	        title: cfdTitleString,
	        shouldShowOnFeedPlus: false
	      };
	      featureDatas.TermsPreferences = {
	        title: '',
	        shouldShowOnFeedPlus: false
	      };
	      featureDatas.SimpleSettings = {
	        title: simpleSettingsTitleString,
	        shouldShowOnFeedPlus: true
	      };
	      delete featureDatas.RewardsCampaigns;
	      delete featureDatas.Instagram;
	      delete featureDatas.EarnPay;
	      delete featureDatas.RewardsCampaigns;
	      delete featureDatas.Auphan;
	      delete featureDatas.Grabb;
	      delete featureDatas.Tutorial;
	      delete featureDatas.Twitter;
	      delete featureDatas.PhoneNumberVerify;
	    }
	
	    if (typeof featureDatas.PhoneNumberVerify === 'undefined') {
	      featureDatas.PhoneNumberVerify = {
	        title: verifyPhoneNumberTitleString,
	        shouldShowInMenu: false,
	        instructions: verifyPhoneNumberInstructions
	      };
	    }
	    var features = [];
	    var featureDict = {};
	    for (var featureName in featureDatas) {
	      var featureData = featureDatas[featureName];
	      featureData["name"] = featureName;
	      var feature = { data: featureData, key: featureName };
	      features.push(feature);
	      featureDict[featureName] = feature;
	    }
	
	    this.setFeatures(features, features);
	    this.setFeatureDict(featureDict, featureDict);
	  },
	
	  _featureDict: {},
	  _adminFeatureDict: {},
	  setFeatureDict: function setFeatureDict(featureDict, adminFeatureDict) {
	    this._featureDict = featureDict;
	    this._adminFeatureDict = adminFeatureDict;
	  },
	
	  getFeatureDict: function getFeatureDict() {
	    if (this.isAdminLoggedIn()) return this._adminFeatureDict;
	
	    return this._featureDict;
	  },
	
	  getRootFeature: function getRootFeature() {
	    var featureName = this._appData.MainScreen.rootFeature;
	
	    return this.getFeatureDict()[featureName];
	  },
	
	  shouldDisableNavHeader: function shouldDisableNavHeader(index) {
	    var shouldDisabled = typeof this._appData.MainScreen.disableNavHeader !== 'undefined' && this._appData.MainScreen.disableNavHeader == true;
	    return shouldDisabled || index == 0 && this.shouldDisableNavHeaderOnFirstScreen();
	  },
	
	  shouldUseFloatingNav: function shouldUseFloatingNav() {
	    return this._appData.MainScreen.rootFeature == "FeedPlus" || this._appData.MainScreen.rootFeature == "PassHome" || this._appData.MainScreen.rootFeature == "BasicHome" || this._appData.MainScreen.rootFeature == "ProHome" || this._appData.MainScreen.rootFeature == this.shouldUseTab();
	  },
	
	  shouldDisableNavHeaderOnFirstScreen: function shouldDisableNavHeaderOnFirstScreen() {
	    return this._appData.MainScreen.rootFeature == "FeedPlus" || typeof this._appData.MainScreen.disableNavHeaderOnFirstScreen !== 'undefined' && this._appData.MainScreen.disableNavHeaderOnFirstScreen == true;
	  },
	
	  shouldUseTab: function shouldUseTab() {
	    return typeof this._appData.MainScreen.shouldUseTab !== 'undefined' && this._appData.MainScreen.shouldUseTab == true;
	  },
	
	  feedPlusType: function feedPlusType() {
	    // return 1;
	    // console.log("this._appData.Features.FeedPlus",this._appData.Features.FeedPlus);
	    return typeof this._appData.Features.FeedPlus === 'undefined' || typeof this._appData.Features.FeedPlus.feedPlusType === 'undefined' ? 0 : this._appData.Features.FeedPlus.feedPlusType;
	  },
	
	  shouldShowPassButton: function shouldShowPassButton() {
	    return Platform.OS == "web" && _findGetParameter("isPass") == "1";
	  },
	
	  feedPlusTopOffsetPercentage: function feedPlusTopOffsetPercentage() {
	    // return 0.13;
	    return typeof this._appData.Features.FeedPlus.topOffsetPercentage === 'undefined' ? 0 : this._appData.Features.FeedPlus.topOffsetPercentage;
	  },
	
	  feedPlusBottomOffsetPercentage: function feedPlusBottomOffsetPercentage() {
	    // return 0.30;
	    return typeof this._appData.Features.FeedPlus.bottomOffsetPercentage === 'undefined' ? 0 : this._appData.Features.FeedPlus.bottomOffsetPercentage;
	  },
	
	  shouldDisableLockOnFeedPlus: function shouldDisableLockOnFeedPlus() {
	    return typeof this._appData.MainScreen.disableLockIcon === 'undefined' ? false : this._appData.MainScreen.disableLockIcon;
	  },
	
	  buttonType: function buttonType() {
	    // return 1;
	    return typeof this._appData.MainScreen.buttonType === 'undefined' ? 0 : this._appData.MainScreen.buttonType;
	  },
	
	  useCapsButtons: function useCapsButtons() {
	    // return true;
	    return typeof this._appData.MainScreen.capsButtons === 'undefined' ? false : this._appData.MainScreen.capsButtons;
	  },
	
	  disableFeed: function disableFeed() {
	    return typeof this._appData.MainScreen.disableFeed === 'undefined' ? false : this._appData.MainScreen.disableFeed;
	  },
	
	  _showTopBar: true,
	  showTopBar: function showTopBar() {
	    return this._showTopBar;
	  },
	
	  _expiredLink: false,
	  expiredLink: function expiredLink() {
	    return this._expiredLink;
	  },
	
	  _needsRegistration: false,
	  needsRegistration: function needsRegistration() {
	    return this._needsRegistration;
	  },
	
	  _needsCFD: false,
	  needsCFD: function needsCFD() {
	    return this._needsCFD;
	  },
	
	  shouldInvertColorOnFeedPlus: function shouldInvertColorOnFeedPlus() {
	    return typeof this._appData.MainScreen.invertColor === 'undefined' ? false : this._appData.MainScreen.invertColor && this.feedPlusType() != 2;
	  },
	
	  disableInterstitial: function disableInterstitial() {
	    if (Platform.OS === 'web') return false;
	
	    return typeof this._appData.MainScreen.disableInterstitial === 'undefined' ? false : this._appData.MainScreen.disableInterstitial;
	  },
	
	  findGetParameter: function findGetParameter(getParam) {
	    return _findGetParameter(getParam);
	  },
	
	  HAS_CONVERTED_KEY: "HAS_CONVERTED_KEY",
	  convertVariablesFromOldDB: function convertVariablesFromOldDB(completion) {
	    var thisThing = this;
	    var varTable = this._dbManager.table("Variables");
	    varTable.get(this.HAS_CONVERTED_KEY, function (obj) {
	      if (obj == null || !obj.value) {
	        DB.table("Variables").get_all(function (result) {
	          var varDatas = Object.values(result.rows);
	          varTable.setRows(varDatas, function () {
	            varTable.set({ key: thisThing.HAS_CONVERTED_KEY, value: true }, completion);
	          });
	        });
	      } else {
	        completion();
	      }
	    });
	  },
	
	  _externalLinkDates: {},
	  externalLinkDateForFeatureName: function externalLinkDateForFeatureName(featureName) {
	
	    if (typeof this._externalLinkDates[featureName] !== 'undefined') {
	      return this._externalLinkDates[featureName];
	    }
	
	    var thisThing = this;
	    var varKey = "externalLinkDate-" + featureName;
	    this.getVariable(varKey, function (value) {
	      if (value && value != null) {
	        thisThing._externalLinkDates[featureName] = value;
	      } else {
	        thisThing._externalLinkDates[featureName] = new Date().getTime();
	        thisThing.setVariable(varKey, new Date().getTime(), function () {});
	      }
	    });
	
	    return 0; // assume it is forever ago;
	  },
	
	  getColorDictionary: function getColorDictionary() {
	    return this._appData["ColorDictionary"];
	  },
	
	  getTabFeatures: function getTabFeatures() {
	    var tabFeatures = [];
	    var features = this.getFeatures();
	    var numFeatures = features.length;
	    for (var i = 0; i < numFeatures; i++) {
	      var feature = features[i];
	      if (feature.data.shouldShowInTabs == true) {
	        tabFeatures.push(feature);
	      }
	    }
	
	    tabFeatures = tabFeatures.sort(function (a, b) {
	      return a.data.tabSortOrder - b.data.tabSortOrder;
	    });
	
	    return tabFeatures;
	  },
	
	  getErrorColor: function getErrorColor() {
	    var ContrastChecker = new _colorContrastChecker2.default();
	    var acceptableContrastRatio = 2.1;
	    var defaultErrorColor = "#de2e37";
	    var colorDictionary = this.getColorDictionary();
	
	    var headerColor = colorDictionary["ProfileColor"][0];
	    var profileTitleColor = colorDictionary["ProfileTitleColor"][0];
	    var generalTitleColor = colorDictionary["GeneralTitleColor"][0];
	    //console.log("Contrast",ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(headerColor),ContrastChecker.hexToLuminance('#de2e37')));
	    if (ContrastChecker.isLevelCustom(headerColor, defaultErrorColor, acceptableContrastRatio)) {
	      //console.log("Contrast", "GOOD");
	
	      return defaultErrorColor;
	    } else {
	
	      var generalTitleColorContrastRatio = ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(generalTitleColor), ContrastChecker.hexToLuminance('#de2e37'));
	      var profileTitleColorContrastRatio = ContrastChecker.getContrastRatio(ContrastChecker.hexToLuminance(profileTitleColor), ContrastChecker.hexToLuminance('#de2e37'));
	
	      if (generalTitleColorContrastRatio > profileTitleColorContrastRatio) {
	        return "#" + generalTitleColor.toString();
	      } else {
	        return "#" + profileTitleColor.toString();
	      }
	    }
	  },
	
	  shouldContrastColor: function shouldContrastColor() {
	    var ContrastChecker = new _colorContrastChecker2.default();
	    var acceptableContrastRatio = 2.1;
	    var colorDictionary = this.getColorDictionary();
	    var profileTitleColor = colorDictionary["ProfileTitleColor"][0];
	    var white = "#fff";
	
	    return !ContrastChecker.isLevelCustom(white, profileTitleColor, acceptableContrastRatio);
	  },
	
	  getMenuFeatures: function getMenuFeatures() {
	    var menuFeatures = [];
	    var features = this.getFeatures();
	    var numFeatures = features.length;
	    var mediaFeatures = [];
	    for (var i = 0; i < numFeatures; i++) {
	      var feature = features[i];
	      if (feature.data.shouldShowInMenu != false) {
	        if ((feature.data.name == "Instagram" || feature.data.name == "Facebook" || feature.data.name == "Twitter") && (typeof feature.data.forceMenu === 'undefined' || !feature.data.forceMenu)) {
	          mediaFeatures.push(feature);
	        } else {
	          menuFeatures.push(feature);
	        }
	      }
	    }
	
	    if (mediaFeatures.length > 0) {
	      // for( var i = 0; i < mediaFeatures.length; i++ )
	      // {
	      //   var feature = mediaFeatures[i];
	      //   var name = feature.data.name;
	      //   if( name == "Promotions" )
	      //   {
	      //
	      //   }
	      // }
	    }
	
	    menuFeatures = menuFeatures.sort(function (a, b) {
	      return a.data.menuSortOrder - b.data.menuSortOrder;
	    });
	
	    // TODO: remove
	    // var featureNames = ["EarnPay", /*"Grabb",*/ "RewardsCampaigns", "Promotions", "Locations", "Gifts", /*"Passes", "Booking",*/ "Settings"];
	    // var menuFeatures = [];
	    // for( var i = 0; i < featureNames.length; i++ )
	    // {
	    //   menuFeatures.push(this.getFeatureForName(featureNames[i]));
	    // }
	
	    return menuFeatures;
	  },
	
	  getFeedFeatures: function getFeedFeatures() {
	    var feedFeatures = [];
	    var features = this.getFeatures();
	    if (typeof features === 'undefined') return [];
	
	    var numFeatures = features.length;
	    var isLoggedIn = this.isLoggedIn();
	    for (var i = 0; i < numFeatures; i++) {
	      var feature = features[i];
	      if (feature.data.shouldShowInFeed && (isLoggedIn || !feature.data.requiresLogin)) {
	        feedFeatures.push(feature);
	      }
	    }
	
	    return feedFeatures;
	  },
	
	  getFeedPlusFeatures: function getFeedPlusFeatures() {
	    var feedPlusFeatures = [];
	    var features = this.getFeatures();
	    if (typeof features === 'undefined') return [];
	
	    var numFeatures = features.length;
	    for (var i = 0; i < numFeatures; i++) {
	      var feature = features[i];
	      if (feature.data.shouldShowOnFeedPlus) {
	        feedPlusFeatures.push(feature);
	      }
	    }
	
	    return feedPlusFeatures;
	  },
	
	  getPassHomeFeatures: function getPassHomeFeatures() {
	    var feedPlusFeatures = [];
	    var features = this.getFeatures();
	    if (typeof features === 'undefined') return [];
	
	    var numFeatures = features.length;
	    for (var i = 0; i < numFeatures; i++) {
	      var feature = features[i];
	      if (feature.data.shouldShowOnFeedPlus) {
	        feedPlusFeatures.push(feature);
	      }
	    }
	
	    return feedPlusFeatures;
	  },
	
	  getFeedFeatureNames: function getFeedFeatureNames() {
	    var feedFeatures = this.getFeedFeatures();
	    var feedFeatureNames = [];
	    for (var i = 0; i < feedFeatures.length; i++) {
	      var feedFeature = feedFeatures[i];
	      feedFeatureNames.push(feedFeature.key);
	    }
	
	    return feedFeatureNames;
	  },
	
	  getFeatureForName: function getFeatureForName(featureName) {
	    if (featureName == "Refunds") {
	      return {
	        data: {
	          title: "Refunds",
	          requiresLogin: false,
	          icon: "pencil"
	        },
	        key: "Refunds" };
	    }
	
	    return this.getFeatureDict()[featureName];
	  },
	
	  getFeatureOverrideForName: function getFeatureOverrideForName(featureName, extras) {
	    if (featureName == "Rewards") {
	      var rewardsCampaignsFeature = this.getFeatureForName("RewardsCampaigns");
	      if (typeof rewardsCampaignsFeature !== 'undefined') {
	        featureName = "RewardsCampaigns";
	      }
	    }
	    if (featureName == "EarnPoints") {
	      var rewardsCampaignsFeature = this.getFeatureForName("RewardsCampaigns");
	      if (typeof rewardsCampaignsFeature !== 'undefined') {
	        featureName = "RewardsCampaigns";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showEarnPointsFirst = true;
	      }
	    }
	    if (featureName == "CheckIn") {
	      var earnPayFeature = this.getFeatureForName("EarnPay");
	      if (typeof earnPayFeature !== 'undefined') {
	        featureName = "EarnPay";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showCheckInFirst = true;
	      }
	    }
	    if (featureName == "UseCredit") {
	      var earnPayFeature = this.getFeatureForName("EarnPay");
	      if (typeof earnPayFeature !== 'undefined') {
	        featureName = "EarnPay";
	        if (typeof extras === 'undefined' || extras == null) extras = {};
	        extras.showUseCreditFirst = true;
	      }
	    }
	
	    return { featureName: featureName, extras: extras };
	  },
	
	  getPrerequisiteFeatureForName: function getPrerequisiteFeatureForName(featureName) {
	    if (featureName == "AddCredit" || featureName == "SendGiftCard" || featureName == "AddPass") {
	      var paymentTypesFeature = this.getFeatureForName("PaymentTypes");
	      if (typeof paymentTypesFeature !== 'undefined') {
	        var hasPrimaryPaymentMethod = this.userHasPrimaryPaymentMethod();
	        if (!hasPrimaryPaymentMethod) return paymentTypesFeature;
	      }
	
	      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
	      if (typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForPurchase]) {
	        var hasPhoneNumber = this.userHasPhoneNumber();
	        if (!hasPhoneNumber) return phoneNumberVerifyFeature;
	      }
	    } else if (featureName == "PaymentTypes") {
	      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
	      if (typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForPaymentTypes]) {
	        var hasPhoneNumber = this.userHasPhoneNumber();
	        if (!hasPhoneNumber) return phoneNumberVerifyFeature;
	      }
	    } else if (featureName == "UseReward" || featureName == "UsePass") {
	      var phoneNumberVerifyFeature = this.getFeatureForName("PhoneNumberVerify");
	      if (typeof phoneNumberVerifyFeature !== 'undefined' && this.isLoggedIn() && this.currentUser()[ModelConstants.RequirePhoneForRewards]) {
	        var hasPhoneNumber = this.userHasPhoneNumber();
	        if (!hasPhoneNumber) return phoneNumberVerifyFeature;
	      }
	    } else if (featureName == "UseCredit") {
	      if (this.isLoggedIn()) {
	        var userHasCredit = this.currentUser()[ModelConstants.Credits] > 0;
	        var userHasPrimaryPaymentMethod = this.userHasPrimaryPaymentMethod();
	        if (!userHasCredit && !userHasPrimaryPaymentMethod) {
	          var paymentTypesFeature = this.getFeatureForName("PaymentTypes");
	          if (typeof paymentTypesFeature !== 'undefined') return paymentTypesFeature;
	        }
	
	        var isLivePay = this.currentUser()[ModelConstants.PayMode] == 1;
	        if (!userHasCredit && !isLivePay && userHasPrimaryPaymentMethod) {
	          var addCreditFeature = this.getFeatureForName("AddCredit");
	          if (typeof addCreditFeature !== 'undefined') return addCreditFeature;
	        }
	      }
	    }
	
	    return null;
	  },
	
	  userHasPrimaryPaymentMethod: function userHasPrimaryPaymentMethod() {
	    var paymentInfo = this.getPaymentInfo();
	    var hasPrimaryPaymentMethod = false;
	    for (var i = 0; i < paymentInfo.length; i++) {
	      if (paymentInfo[i].isPrimary) {
	        hasPrimaryPaymentMethod = true;
	        break;
	      }
	    }
	
	    return hasPrimaryPaymentMethod;
	  },
	
	  userHasPhoneNumber: function userHasPhoneNumber() {
	    if (!this.isLoggedIn()) return false;
	
	    var phoneNumber = this.currentUser()[ModelConstants.PhoneNumber];
	
	    return typeof phoneNumber !== 'undefined' && phoneNumber != null;
	  },
	
	  userRequiresPostalCode: function userRequiresPostalCode() {
	    if (!this.isLoggedIn()) return false;
	
	    return typeof this.currentUser()[ModelConstants.RequirePostalCode] !== 'undefined' && this.currentUser()[ModelConstants.RequirePostalCode];
	  },
	
	  _domain: "",
	  getServerURL: function getServerURL() {
	    if (Platform.OS == 'web') {
	      var hostname = window.location.hostname;
	      if (typeof hostname !== 'undefined') {
	        if (hostname.indexOf(".dev.") >= 0 || hostname.indexOf("localhost") >= 0) {
	          this._appData["Header"]["APIBaseURL"] = "https://api.dev.getreup.com/client/";
	        } else if (hostname.indexOf(".stage.") >= 0) {
	          this._appData["Header"]["APIBaseURL"] = "https://api.stage.getreup.com/client/";
	        } else if (hostname.indexOf(".feature01.") >= 0) {
	          this._appData["Header"]["APIBaseURL"] = "https://api.feature01.getreup.com/client/";
	        } else if (hostname.indexOf(".feature02.") >= 0) {
	          this._appData["Header"]["APIBaseURL"] = "https://api.feature02.getreup.com/client/";
	        }
	      }
	    }
	
	    //console.log("config: " + JSON.stringify(this._appData));
	    if (this._domain.length > 0) {
	      return this._appData["Header"]["APIBaseURL"] + this._appData["Header"]["APIVersion"] + "/" + this._domain;
	      // https://dev.getreup.com/scanner/VX.Y/reupdemo/?hash=3761e6d58b358892d76768bc981bc940
	    }
	
	    return this._appData["Header"]["APIBaseURL"] + this._appData["Header"]["APIVersion"] + "/" + this._appData["Header"]["AppID"];
	    // return this.state.data["Header"]["APIBaseURL-DEBUG"] + this.state.data["Header"]["APIVersion"] + "/" + this.state.data["Header"]["AppID"];
	  },
	
	  getTermsLink: function getTermsLink() {
	    var environment = "";
	    var apiURL = this._appData["Header"]["APIBaseURL"];
	    var tosLink = apiURL.replace("/client/", "/misc/") + 'app_tc.php?appid=' + this._appData["Header"].AppID + '&appname=' + encodeURI(this.appNameLong);;
	
	    return tosLink;
	  },
	
	  getStripeElementsURL: function getStripeElementsURL() {
	    var baseURL = "https://api.getreup.com/misc/stripeElements.php";
	    if (this._appData["Header"]["APIBaseURL"].indexOf(".dev.") >= 0) baseURL = "https://api.dev.getreup.com/misc/stripeElements.php";
	    if (this._appData["Header"]["APIBaseURL"].indexOf(".stage.") >= 0) baseURL = "https://api.stage.getreup.com/misc/stripeElements.php";
	    if (this._appData["Header"]["APIBaseURL"].indexOf(".feature01.") >= 0) baseURL = "https://api.feature02.getreup.com/misc/stripeElements.php";
	    if (this._appData["Header"]["APIBaseURL"].indexOf(".feature02.") >= 0) baseURL = "https://api.feature02.getreup.com/misc/stripeElements.php";
	
	    var locale = "en";
	    var token = "";
	    var deviceInfo = this.getDeviceInfo();
	    if (typeof deviceInfo.locale !== 'undefined' && deviceInfo.locale != null && deviceInfo.locale.length > 0) {
	      locale = deviceInfo.locale.split("-")[0].split("_")[0].toLowerCase();
	    }
	    if (this.isLoggedIn()) {
	      token = this.currentUser()[ModelConstants.StripeKey];
	    }
	
	    return baseURL + "?locale=" + locale + "&token=" + token;
	  },
	
	  // this version doesn't go to the db
	  _currentUser: DEFAULT_USER,
	  currentUser: function currentUser() {
	    return this._currentUser;
	  },
	
	  // temp user/pass
	  getTempUserPass: function getTempUserPass(completion) {
	    AppManager.getVariable("tempuserpass", function (value) {
	      if (value && value != null) {
	        completion(JSON.parse(value));
	      } else {
	        completion(null);
	      }
	    });
	  },
	
	  setTempUserPass: function setTempUserPass(userPassArray, completion) {
	    var userPassStr = JSON.stringify(userPassArray);
	    this.setVariable("tempuserpass", userPassStr, completion);
	  },
	
	  getLastDomainEmail: function getLastDomainEmail(completion) {
	    this.getVariable("lastdomainemail", function (value) {
	      if (value && value != null) {
	        completion(JSON.parse(value));
	      } else {
	        completion(null);
	      }
	    });
	  },
	
	  setLastDomainEmail: function setLastDomainEmail(domainEmailArray, completion) {
	    var domainEmailArrayStr = JSON.stringify(domainEmailArray);
	    this.setVariable("lastdomainemail", domainEmailArrayStr, completion);
	  },
	
	  _hasSelfie: false,
	  getSelfie: function getSelfie(completion) {
	    if (!this.isLoggedIn()) {
	      this._hasSelfie = false;
	      completion(null);
	      return;
	    }
	    var thisThing = this;
	    var user = this._currentUser;
	    var selfieName = user[ModelConstants.UserName] + "-selfie";
	    this.getVariable(selfieName, function (data) {
	      thisThing._hasSelfie = data != null;
	      if (data != null && typeof data !== 'undefined' && typeof data.path !== 'undefined') data = data.path;
	      if (completion) completion(data);
	    });
	  },
	
	  setSelfie: function setSelfie(selfieURL, completion) {
	    if (typeof selfieURL.path !== 'undefined') selfieURL = selfieURL.path;
	
	    if (!this.isLoggedIn()) {
	      completion(null);
	      return;
	    }
	    var thisThing = this;
	    var user = this._currentUser;
	    var selfieName = user[ModelConstants.UserName] + "-selfie";
	    this.getSelfie(function (oldURL) {
	      if (oldURL && oldURL != null) {
	        RNFS.unlink(selfieName);
	      }
	      selfieURL = selfieURL.replace(/file\:\/\//g, '');
	      thisThing.encodeImageFileAsBase64(selfieURL, function (base64image) {
	        thisThing.setVariable(selfieName, "data:image/png;base64," + base64image, function () {
	          if (typeof completion !== 'undefined') completion();
	          thisThing._eventEmitter.emit("dbUpdated", {});
	        });
	      });
	    });
	  },
	
	  encodeImageFileAsBase64: function encodeImageFileAsBase64(url, completion) {
	    try {
	      RNFS.readFile(url, 'base64').then(function (response) {
	        if (completion) completion(response);
	      }).catch(function (e) {
	        console.log("ERRRRRORB", e);
	      });
	    } catch (e) {
	      console.log("ERRRRROR", e);
	    } finally {}
	  },
	
	  getVariable: function getVariable(varName, completion) {
	    this._varTable.get(varName, function (obj) {
	      completion(obj == null ? null : obj.value);
	    });
	  },
	
	  setVariable: function setVariable(varName, varValue, completion) {
	    this._varTable.set({ key: varName, value: varValue }, completion);
	  },
	
	  _SOFT_UPDATE_REPOST_SECONDS: 1 * 24 * 60 * 60,
	  _SOFT_UPDATE_ALERT_DATE: "SOFT_UPDATE_ALERT_DATE",
	  shouldSoftUpdateAlert: function shouldSoftUpdateAlert(completion) {
	    var appManager = this;
	    this.getVariable(this._SOFT_UPDATE_ALERT_DATE, function (variable) {
	      var nowSeconds = new Date().getTime() / 1000;
	      if (parseInt(variable) + appManager._SOFT_UPDATE_REPOST_SECONDS > nowSeconds) {
	        completion(false);
	      } else {
	        appManager.setVariable(appManager._SOFT_UPDATE_ALERT_DATE, nowSeconds + "", function () {
	          completion(true);
	        });
	      }
	    });
	  },
	
	  currentUserInitials: function currentUserInitials() {
	    if (this._currentUser && this._currentUser[ModelConstants.FirstName] && this._currentUser[ModelConstants.LastName]) var firstName = this._currentUser[ModelConstants.FirstName];
	    if (typeof firstName === 'undefined') return "";
	    var firstInitial = firstName.length > 0 ? firstName.substring(0, 1).toUpperCase() : "";
	
	    var lastName = this._currentUser[ModelConstants.LastName];
	    var lastInitial = lastName.length > 0 ? lastName.substring(0, 1).toUpperCase() : "";
	
	    return firstInitial + lastInitial;
	  },
	
	  currentUserFullName: function currentUserFullName() {
	    var firstName = null;
	    if (this._currentUser && this._currentUser[ModelConstants.FirstName] && this._currentUser[ModelConstants.LastName]) {
	      firstName = this._currentUser[ModelConstants.FirstName];
	    }
	    if (typeof firstName === 'undefined' || firstName == null) return "";
	
	    return firstName + " " + this._currentUser[ModelConstants.LastName];
	  },
	
	  getCurrentUser: function getCurrentUser(completion) {
	    var appManager = this;
	    if (appManager._currentUser != null) {
	      if (completion) completion(appManager._currentUser);
	      return;
	    }
	
	    DB.table("Users").get_all(function (data) {
	      var users = data.rows;
	      for (var key in users) {
	        appManager._currentUser = users[key];
	        if (completion) completion(users[key]);
	        return;
	      }
	      appManager._currentUser = null;
	      if (completion) completion(null);
	    });
	  },
	
	  setCurrentUser: function setCurrentUser(newUser, completion) {
	    // if( completion ) completion(this._currentUser);
	    // return;
	
	    if (newUser != null) {
	      var appMan = this;
	      this.setTempUserPass([]);
	      this.getCurrentUser(function (user) {
	        // if the user exists,
	        //   check if its the same username
	        //     if its the same username, use the old password, unless there is a new password
	        //   delete the table with the old user
	        //   add the new user
	        // if the user doesn't exist, just add the new user
	        var newUserName = newUser[ModelConstants.UserName];
	        if (user != null && (user[ModelConstants.UserName] == newUserName || user[ModelConstants.UserName].toLowerCase() == newUserName.toLowerCase())) {
	          var oldUserName = user[ModelConstants.UserName];
	          var oldPassword = user[ModelConstants.Password];
	          var newPassword = newUser[ModelConstants.Password];
	          if ((newUserName == oldUserName || newUserName.toLowerCase() == oldUserName.toLowerCase()) && (typeof newPassword === 'undefined' || newPassword == null || newPassword.length <= 0)) {
	            newUser[ModelConstants.Password] = oldPassword;
	          }
	          DB.table("Users").update({ UserName: newUserName }, newUser, function (updated_table) {
	            appMan._currentUser = newUser;
	            appMan._eventEmitter.emit("dbUpdated", {});
	            appMan._eventEmitter.emit("checkUserChanged", {});
	            if (completion) completion(newUser);
	          });
	        } else if (user == null) {
	          DB.table("Users").add(newUser, function () {
	            if (typeof newUser.Currency !== 'undefined') appMan.setCurrency(newUser.Currency);
	            appMan._currentUser = newUser;
	            appMan._eventEmitter.emit("dbUpdated", {});
	            appMan._eventEmitter.emit("checkUserChanged", {});
	            if (typeof appMan.loginCallBack !== 'undefined') appMan.loginCallBack();
	            if (completion) completion(newUser);
	          });
	        } else if (user[ModelConstants.UserName] != newUserName) {
	          DB.table("Users").erase_db(function (removed_data) {
	            var newPassword = newUser[ModelConstants.Password];
	            if (typeof newPassword === 'undefined' || newPassword == null || newPassword.length <= 0) {
	              // something wrong, log out
	              appMan._eventEmitter.emit("dbUpdated", {});
	              appMan._eventEmitter.emit("checkUserChanged", {});
	              appMan.logout(completion);
	            } else {
	              DB.table("Users").add(newUser, function () {
	                appMan._currentUser = newUser;
	                appMan._eventEmitter.emit("dbUpdated", {});
	                appMan._eventEmitter.emit("checkUserChanged", {});
	                if (completion) completion(newUser);
	              });
	            }
	          });
	        }
	      });
	    } else {
	      var appMan = this;
	      DB.table("Users").erase_db(function (removed_data) {
	        appMan._currentUser = null;
	        appMan._eventEmitter.emit("dbUpdated", {});
	        appMan._eventEmitter.emit("checkUserChanged", {});
	        if (completion) completion(newUser);
	      });
	    }
	  },
	
	  getPaymentInfo: function getPaymentInfo() {
	    var paymentInfoObject = [];
	    try {
	      paymentInfoObject = JSON.parse(this.currentUser()[ModelConstants.PaymentInfo]);
	      if (paymentInfoObject == null) paymentInfoObject = [];
	    } catch (e) {
	      return [];
	    } finally {
	      return paymentInfoObject;
	    }
	  },
	
	  setPaymentInfo: function setPaymentInfo(paymentInfo, completion) {
	    var thisThing = this;
	    this.getCurrentUser(function (user) {
	      if (!user) {
	        completion(null);
	      } else {
	        user[ModelConstants.PaymentInfo] = paymentInfo;
	        thisThing.setCurrentUser(user, function () {
	          completion(user);
	        });
	      }
	    });
	  },
	
	  _didDownloadPass: false,
	  _downloadCounter: 0,
	  getPassURL: function getPassURL() {
	    if (!this.isLoggedIn()) return null;
	    if (Platform.OS == 'ios') {
	      var serverURL = this.getServerURL();
	      var baseURL = "https://api.getreup.com/misc/generate_pass.php";
	      if (serverURL.indexOf(".dev.") >= 0) {
	        baseURL = "https://api.dev.getreup.com/misc/generate_pass.php";
	      } else if (serverURL.indexOf(".stage.") >= 0) {
	        baseURL = "https://api.stage.getreup.com/misc/generate_pass.php";
	      } else if (serverURL.indexOf(".feature01.") >= 0) {
	        baseURL = "https://api.feature01.getreup.com/misc/generate_pass.php";
	      } else if (serverURL.indexOf(".feature02.") >= 0) {
	        baseURL = "https://api.feature02.getreup.com/misc/generate_pass.php";
	      }
	
	      return baseURL + "?appid=" + this._appData["Header"]["AppID"] + "&userid=" + this.currentUser()[ModelConstants.UserID] + "&hash=" + this.currentUser()[ModelConstants.Hash] + "&n=" + this._downloadCounter;
	    }
	
	    return null;
	  },
	
	  getSupportEmail: function getSupportEmail() {
	    if (this.isLoggedIn()) {
	      var user = this.currentUser();
	      if (typeof user[ModelConstants.SupportEmail] !== 'undefined') return user[ModelConstants.SupportEmail];
	
	      return "support+" + this._appData["Header"]["AppID"] + "-" + user[ModelConstants.UserID] + "-" + Platform.OS + "@getreup.com";
	    }
	
	    return "support@getreup.com";
	  },
	
	  _currentPosition: { latitude: 0, longitude: 0 },
	  getCurrentPosition: function getCurrentPosition() {
	    return this._currentPosition;
	  },
	
	  hasCurrentPosition: function hasCurrentPosition() {
	    return typeof this._currentPosition !== 'undefined' && this._currentPosition.latitude != 0 && this._currentPosition.longitude != 0;
	  },
	
	  updateCurrentPosition: function updateCurrentPosition(completion) {
	    if (_findGetParameter("isPass") == "1" || _findGetParameter("isPassFree") == "1" || _findGetParameter("isPassPro") == "1") {
	      // completion()
	      return;
	    }
	    var thisThing = this;
	    if (this.SKIP_TUTORIAL) {
	      thisThing._currentPosition = {
	        latitude: parseFloat(49.504741),
	        longitude: parseFloat(-122.102057)
	      };
	      if (completion) completion(thisThing._currentPosition);
	      return;
	    }
	
	    navigator.geolocation.getCurrentPosition(function (position) {
	      thisThing._currentPosition = {
	        latitude: parseFloat(position.coords.latitude),
	        longitude: parseFloat(position.coords.longitude)
	      };
	
	      if (completion) completion(thisThing._currentPosition);
	    }, function (error) {
	      return console.log(JSON.stringify(error));
	    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 3000 });
	  },
	
	  logout: function logout(completion) {
	    var thisThing = this;
	    this._updatedFeatures = {};
	    this.setCurrentUser(null, function () {
	      var finalCompletion = function finalCompletion() {
	        thisThing.setData({ Transactions: [] }, completion);
	      };
	      NetworkManager.update(thisThing, [], finalCompletion, finalCompletion);
	    });
	  },
	
	  isLoggedIn: function isLoggedIn() {
	    return this._currentUser != null && this._currentUser[ModelConstants.UserName] != null && this._currentUser[ModelConstants.Password] != null;
	  },
	
	  useFacebookForFeatureName: function useFacebookForFeatureName(featureName) {
	    var feature = this.getFeatureForName(featureName);
	    if (typeof feature === 'undefined') return false;
	    if (typeof feature.data.useFacebook === 'undefined') return false;
	
	    return feature.data.useFacebook;
	  },
	
	  isValidPassword: function isValidPassword(pass) {
	    return pass.length >= 8;
	  },
	
	  isValidEmail: function isValidEmail(email) {
	    if (!(email.indexOf("@") > -1 && email.indexOf(".") > -1)) return false;
	    if (email.trim().indexOf(" ") > -1) return false;
	
	    return true;
	  },
	
	  parseName: function parseName(fullName) {
	    var names = fullName.trim().split(" ");
	    var lastName = names[names.length - 1];
	    var firstName = "";
	    for (var i = 0; i < names.length - 1; i++) {
	      if (firstName.length > 0) firstName += " ";
	      firstName += names[i];
	    }
	
	    return { firstName: firstName, lastName: lastName };
	  },
	
	  isNameValid: function isNameValid(fullName) {
	    var _parseName = this.parseName(fullName),
	        firstName = _parseName.firstName,
	        lastName = _parseName.lastName;
	
	    return firstName.length > 0 && lastName.length > 0;
	  },
	
	  isAdminLoggedIn: function isAdminLoggedIn() {
	    return false;
	  },
	
	  getAppInfo: function getAppInfo() {
	    if (this._appData["Header"]["AppID"] == "00000") return {};
	
	    return { appid: this._appData["Header"]["AppID"], appversion: BundleVersion, configversion: this._appData["Header"]["ConfigVersion"], "platform": Platform.OS };
	  },
	
	  _deviceInfo: {},
	  setDeviceInfo: function setDeviceInfo(deviceInfo) {
	    if (typeof deviceInfo === 'undefined' || deviceInfo == null) return;
	
	    if (typeof deviceInfo.installationId !== 'undefined') {
	      var thisThing = this;
	      this._deviceInfo.installationID = deviceInfo.installationId;
	      this.setVariable('installationID', deviceInfo.installationId, function () {
	        if (typeof deviceInfo.deviceType !== 'undefined') {
	          thisThing._deviceInfo.deviceType = deviceInfo.deviceType;
	          thisThing.setVariable('deviceType', deviceInfo.deviceType, function () {});
	        }
	      });
	    }
	  },
	
	  syncDeviceInfo: function syncDeviceInfo() {
	    var thisThing = this;
	
	    this.getVariable('deviceType', function (deviceType) {
	      if (typeof deviceType !== 'undefined' && deviceType != null) {
	        thisThing._deviceInfo.deviceType = deviceType;
	      }
	
	      thisThing.getVariable('installationID', function (installationID) {
	        if (typeof installationID !== 'undefined' && installationID != null) {
	          thisThing._deviceInfo.installationID = installationID;
	        }
	      });
	    });
	  },
	
	  getDeviceInfo: function getDeviceInfo() {
	    var currentPosition = this.getCurrentPosition();
	    if (typeof currentPosition.longitude !== 'undefined' && currentPosition.longitude != 0 && typeof currentPosition.latitude !== 'undefined' && currentPosition.latitude != 0) {
	      this._deviceInfo.locationInfo = currentPosition;
	    }
	
	    if (typeof this._deviceInfo.locale === 'undefined') {
	      if (Platform.OS != 'web') this._deviceInfo.locale = DeviceInfo.getDeviceLocale();else this._deviceInfo.locale = window.navigator.userLanguage || window.navigator.language;
	    }
	
	    this._deviceInfo.tz = new Date().getTimezoneOffset();
	
	    return this._deviceInfo;
	  },
	
	  getConfigFeatures: function getConfigFeatures() {
	    return this.getFeatures();
	  },
	
	  _THRESHOLD_TO_REUPDATE_SECONDS: 4,
	  _updatedFeatures: {},
	  hasUpdatedFeatureName: function hasUpdatedFeatureName(featureName) {
	    var secondsNow = new Date().getTime() / 1000;
	    if (typeof this._updatedFeatures[featureName] === 'undefined' || secondsNow - this._updatedFeatures[featureName] > this._THRESHOLD_TO_REUPDATE_SECONDS) {
	      this._updatedFeatures[featureName] = secondsNow;
	      return false;
	    }
	
	    return true;
	  },
	
	  setColorDictionary: function setColorDictionary(colorDictionary) {
	    this._appData.ColorDictionary = colorDictionary;
	  },
	
	  hexToRgb: function hexToRgb(hex) {
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
	      return r + r + g + g + b + b;
	    });
	
	    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	    return result ? {
	      r: parseInt(result[1], 16),
	      g: parseInt(result[2], 16),
	      b: parseInt(result[3], 16)
	    } : null;
	  },
	
	  getColorForKey: function getColorForKey(colorKey, alpha) {
	    var color = this._appData.ColorDictionary[colorKey];
	    var hex = color[0];
	    if (typeof hex === 'undefined') hex = color["0"];
	    if (typeof alpha === 'undefined') alpha = color[1];
	    if (typeof hex === 'undefined') alpha = color["1"];
	
	    hex = hex + "";
	    if (hex.length == 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	    if (hex.length == 1) hex = hex + hex + hex + hex + hex + hex;
	    var rgb = AppManager.hexToRgb(hex);
	    if (rgb == null || typeof rgb === 'undefined') {
	      alert("color for key missing: " + colorKey);
	      return "";
	    }
	
	    return "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + alpha + ")";
	  },
	
	  getLocalizationManager: function getLocalizationManager() {
	    LocalizationManager.setAppManager(this);
	    LocalizationManager._defaultCurrency = this._defaultCurrency;
	    if (typeof _appData !== 'undefined') LocalizationManager._defaultDistance = typeof this._appData.Header.defaultDistance !== 'undefined' ? this._appData.Header.defaultDistance : "meters";
	    if (this.isLoggedIn() && typeof this.currentUser()[ModelConstants.DefaultDistance] !== 'undefined') LocalizationManager._defaultDistance = this.currentUser()[ModelConstants.DefaultDistance];
	    var locale = Platform.OS == "web" ? window.navigator.userLanguage || window.navigator.language : this.getDeviceInfo().locale;
	    LocalizationManager._defaultTime = locale.indexOf("fr-") === 0 ? "24" : "12";
	
	    return LocalizationManager;
	  },
	
	  getDataType: function getDataType(dataType, completion) {
	    if (typeof this.getCacheData(dataType) !== 'undefined' && this.getCacheData(dataType).length > 0) {
	      if (completion) completion(this.getCacheData(dataType));
	      return;
	    }
	
	    if (dataType == "Auphan" || dataType == "OrderAhead") {
	      this._auphanTable.getAll(function (rows) {
	        if (completion) completion(rows);
	      });
	      return;
	    }
	
	    DB.table(dataType).get_all(function (data) {
	      var data = data.rows;
	      var retData = [];
	      for (var rowID in data) {
	        if (dataType == "Twitter" || dataType == "Facebook" || dataType == "Instagram") {
	          try {
	            if (typeof data[rowID].objstring !== 'undefined') {
	              var object = JSON.parse(data[rowID].objstring);
	              retData.push(object);
	            } else {
	              retData.push(data[rowID]);
	            }
	          } catch (e) {} finally {}
	        } else {
	          retData.push(data[rowID]);
	        }
	      }
	      if (completion) completion(retData);
	    });
	  },
	
	  getDataTypes: function getDataTypes(dataTypes, completion, retData, index) {
	    index = typeof index === 'undefined' ? 0 : index;
	    retData = typeof retData === 'undefined' ? {} : retData;
	    if (index >= dataTypes.length) {
	      if (completion) completion(retData);
	      return;
	    }
	
	    var thisThing = this;
	    var dataType = dataTypes[index];
	
	    this.getDataType(dataType, function (data) {
	      retData[dataType] = data;
	      thisThing.getDataTypes(dataTypes, completion, retData, index + 1);
	    });
	  },
	
	  setData: function setData(newData, completion, makeCopy) {
	    if (typeof makeCopy === 'undefined') makeCopy = true;
	
	    var updatedNewData = newData;
	    if (makeCopy) updatedNewData = JSON.parse(JSON.stringify(newData));
	
	    this.setDataRecursive(updatedNewData, 0, completion);
	  },
	
	  setDataRecursive: function setDataRecursive(newData, index, completion, keys) {
	    if (typeof keys == 'undefined') keys = Object.keys(newData);
	
	    if (index >= keys.length) {
	      this._eventEmitter.emit("dbUpdated", newData);
	      if (typeof completion !== 'undefined') completion();
	
	      return;
	    }
	    var appMan = this;
	    var dataType = keys[index];
	    if (dataType == "Users") {
	      var objects = newData[dataType];
	      if (objects.length > 0) {
	        appMan.setCurrentUser(objects[0], function () {
	          appMan.setDataRecursive(newData, index + 1, completion, keys);
	        });
	      } else {
	        appMan.logout(function () {
	          appMan.setDataRecursive(newData, index + 1, completion, keys);
	        });
	      }
	    } else if (dataType == "Auphan" || dataType == "OrderAhead") {
	      appMan._auphanTable.setRows(newData[dataType], function () {
	        appMan.setDataRecursive(newData, index + 1, completion, keys);
	      });
	    } else if (dataType == "Twitter" || dataType == "Facebook" || dataType == "Instagram") {
	      var objects = newData[dataType];
	      if (objects != null && typeof objects !== 'undefined') {
	        appMan.setCacheData(dataType, objects);
	        var objectStrings = [];
	        if (objects != null) {
	          for (var i = 0; i < objects.length; i++) {
	            var object = objects[i];
	            try {
	              var objectString = JSON.stringify(object);
	              objectStrings.push({ objstring: objectString });
	            } catch (e) {} finally {}
	          }
	        }
	        DB.table(dataType).erase_db(function (removed_data) {
	          appMan.addObjectsOfTypeRecursive(objectStrings, dataType, 0, function () {
	            appMan.setCacheData(dataType, []);
	            appMan.setDataRecursive(newData, index + 1, completion, keys);
	          }, false);
	        });
	      } else {
	        appMan.setDataRecursive(newData, index + 1, completion, keys);
	      }
	    } else {
	      if (dataType != null) {
	        var objects = JSON.parse(JSON.stringify(newData[dataType]));
	        if (objects == null) {
	          objects = [];
	        }
	        appMan.setCacheData(dataType, objects);
	
	        DB.table(dataType).erase_db(function (removed_data) {
	          appMan.addObjectsOfTypeRecursive(objects, dataType, 0, function () {
	            appMan.setCacheData(dataType, []);
	            appMan.setDataRecursive(newData, index + 1, completion, keys);
	          }, false);
	        });
	      } else {
	        appMan.setDataRecursive(newData, index + 1, completion, keys);
	      }
	    }
	  },
	
	  addObjectsOfTypeRecursive: function addObjectsOfTypeRecursive(objects, dataType, index, completion, cache) {
	    if (typeof cache === 'undefined') cache = true;
	    if (index >= objects.length) {
	      if (typeof completion !== 'undefined') completion();
	
	      return;
	    }
	
	    var appMan = this;
	    if (dataType == "Users" || dataType == "User") {
	      if (typeof objects.UserID !== 'undefined') {
	        // not an array, just use this
	        appMan.setCurrentUser(objects, function () {
	          if (typeof completion !== 'undefined') completion();
	        });
	      } else {
	        appMan.setCurrentUser(objects[0], function () {
	          if (typeof completion !== 'undefined') completion();
	        });
	      }
	    } else {
	      // putting in batch add
	      if (cache) {
	        for (var i = 0; i < objects.length; i++) {
	          appMan.addCacheData(dataType, objects[i]);
	        }
	      }
	
	      DB.table(dataType).add_all(objects, function () {
	        if (cache) appMan.setCacheData(dataType, []);
	        completion();
	      });
	      // DB.table(dataType).add(objects[index], function()
	      // {
	      //   appMan.addObjectsOfTypeRecursive(objects, dataType, index+1, completion);
	      // })
	    }
	  },
	
	  _cachedData: {},
	  setCacheData: function setCacheData(dataType, data) {
	    if (typeof data !== 'undefined' && data != null && typeof data.slice !== 'undefined') this._cachedData[dataType] = data.slice(0, 100);
	  },
	  addCacheData: function addCacheData(dataType, data) {
	    this.getCacheData(dataType).push(data);
	  },
	  getCacheData: function getCacheData(dataType) {
	    if (typeof this._cachedData[dataType] == 'undefined') this._cachedData[dataType] = [];
	
	    return JSON.parse(JSON.stringify(this._cachedData[dataType]));
	  },
	
	
	  getTime: function getTime(dateString) {
	    if (typeof dateString === 'undefined') return 0;
	    var find = "-";
	    var re = new RegExp(find, 'g');
	    var newDateString = dateString.replace(re, '/');
	    var date = new Date(newDateString);
	
	    return date.getTime();
	  },
	
	  _lastUpdatedDates: {},
	  getTimeSinceLastUpdateOfFeatureName: function getTimeSinceLastUpdateOfFeatureName(featureName) {
	    if (typeof this._lastUpdatedDates[featureName] === 'undefined') return Number.MAX_VALUE;
	
	    return new Date().getTime() - this._lastUpdatedDates[featureName].getTime();
	  },
	
	  setUpdatedDateOfFeatureName: function setUpdatedDateOfFeatureName(featureName) {
	    this._lastUpdatedDates[featureName] = new Date();
	  },
	
	  timeSince: function timeSince(date, addAgo) {
	    if (typeof addAgo === 'undefined') addAgo = true;
	
	    var seconds = 0;
	    if (isNaN(date) && (typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
	      seconds = Math.abs(parseInt(date));
	    } else {
	      if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
	        var find = "-";
	        var re = new RegExp(find, 'g');
	        var newDateString = date.replace(re, '/');
	        var date = new Date(newDateString);
	        date = new Date(date);
	      }
	      seconds = Math.abs(Math.floor((new Date().getTime() - date.getTime()) / 1000));
	    }
	
	    if (addAgo) return this.getLocalizationManager().localizedLongDate(seconds * 1000);
	
	    return this.getLocalizationManager().localizedLongDateFuture(seconds * 1000);
	  },
	
	  timeTill: function timeTill(seconds) {
	    return this.getLocalizationManager().localizedLongDateFuture(seconds * 1000);
	  }
	};
	
	module.exports = AppManager;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ReUpIcon = __webpack_require__(13);
	
	var _ReUpIcon2 = _interopRequireDefault(_ReUpIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var AppActions = __webpack_require__(63);
	var PlatformConstants = __webpack_require__(31);
	var Globals = __webpack_require__(10);
	
	var FeatureBuilder = __webpack_require__(90);
	var ReUpButton = __webpack_require__(12);
	var ReUpIconButton = __webpack_require__(18);
	var ReUpText = __webpack_require__(8);
	var ReUpTabBar = __webpack_require__(74);
	var ReUpTabContentContainer = __webpack_require__(1134);
	
	var Feed = __webpack_require__(849);
	var Menu = __webpack_require__(75);
	var ProgressOverlay = __webpack_require__(52);
	var CustomAlertOverlay = __webpack_require__(1102);
	var BundleInfo = __webpack_require__(843);
	var Overlay = __webpack_require__(112);
	var ReUpFloatingNavigator = __webpack_require__(1130);
	var Keyboard = __webpack_require__(76);
	
	var MK = __webpack_require__(14);
	var MKButton = MK.MKButton,
	    MKSpinner = MK.MKSpinner;
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    PixelRatio = ReactNative.PixelRatio,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    TouchableOpacity = ReactNative.TouchableOpacity,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    NativeAppEventEmitter = ReactNative.NativeAppEventEmitter,
	    DeviceEventEmitter = ReactNative.DeviceEventEmitter,
	    NetInfo = ReactNative.NetInfo,
	    StyleSheet = ReactNative.StyleSheet,
	    Platform = ReactNative.Platform,
	    StatusBar = ReactNative.StatusBar,
	    NativeModules = ReactNative.NativeModules,
	    Vibration = ReactNative.Vibration,
	    Dimensions = ReactNative.Dimensions;
	
	
	var Animated = __webpack_require__(9);
	var Navigator = __webpack_require__(850);
	
	var AmazonSNSManager = NativeModules.RNAmazonSNSManager;
	
	var AppNavigator = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      appManager: null,
	      restartApp: function restartApp() {
	        alert("restartApp");
	      }
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      menuContainerShown: false,
	      menuContainerLayout: { x: 0, y: 0, width: 0, height: 0 },
	      currentLayout: { x: 0, y: 0, width: 0, height: 0 },
	      shouldRender: false,
	      shouldShowCustomAlert: false,
	      customAlertChildren: React.createElement(View, null),
	      customAlertDidCancel: function customAlertDidCancel() {},
	      shouldShowSpinner: false,
	      spinnerText: "",
	      updateProgress: new Animated.Value(0),
	      updateOpacity: new Animated.Value(0),
	      updateHasStarted: false,
	      updateProgress2: new Animated.Value(0),
	      updateOpacity2: new Animated.Value(0),
	      updateHasStarted2: false,
	      networkConnected: true,
	      shouldHideNetworkStatus: false
	    };
	  },
	
	  _bundleUpdateStartedListener: null,
	  _bundleUpdateProgressListener: null,
	  _bundleUpdateCompleteListener: null,
	  _networkConnectivityChange: null,
	  componentDidMount: function componentDidMount() {
	    Globals.addHardwareBackListener(this.backPushed);
	    AppActions.initialize(this.props.appManager, this);
	    var thisThing = this;
	
	    if (Platform.OS != 'web') {
	      this._networkConnectivityChange = NetInfo.addEventListener('connectionChange', thisThing.handleNetworkConnectivityChange);
	
	      NetInfo.isConnected.fetch().done(function (isConnected) {
	        thisThing.setState({ networkConnected: isConnected });
	      });
	    }
	
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    appManager._eventEmitter.on('downloadStarted', this.downloadStarted, this);
	    appManager._eventEmitter.on('downloadProgressed', this.downloadProgressed, this);
	    appManager._eventEmitter.on('downloadCompleted', this.downloadCompleted, this);
	    appManager.downloadNewResources();
	
	    var locManager = appManager.getLocalizationManager();
	    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	    if (Platform.OS == 'ios') AmazonSNSManager.addListener("didReceivePush");else {
	      // DeviceEventEmitter.addListener(
	      //   'didReceivePush',
	      //   (deviceInfo) =>
	      //   {
	      //     thisThing.setDeviceInfo(deviceInfo);
	      //   }
	      // )
	    }
	    if (Platform.OS == "ios") {
	      this._bundleUpdateStartedListener = NativeAppEventEmitter.addListener('bundleUpdateStarted', function () {
	        thisThing.setState({ updateProgress: new Animated.Value(0), updateOpacity: new Animated.Value(0) });
	        Animated.timing(thisThing.state.updateOpacity, { toValue: 1,
	          duration: 500 }).start(function () {});
	      });
	      this._bundleUpdateProgressListener = NativeAppEventEmitter.addListener('bundleUpdateProgress', function (data) {
	        var ratio = parseFloat(data.progress / 100);
	        Animated.spring(thisThing.state.updateProgress, {
	          toValue: thisThing.state.currentLayout.width * ratio,
	          tension: 10,
	          friction: 10
	        }).start();
	      });
	      this._bundleUpdateCompleteListener = NativeAppEventEmitter.addListener('bundleUpdateComplete', function (data) {
	        if (data.updateSuccess) {
	          Animated.spring(thisThing.state.updateProgress, {
	            toValue: thisThing.state.currentLayout.width,
	            tension: 10,
	            friction: 10
	          }).start(function () {
	            setTimeout(function () {
	              Animated.timing(thisThing.state.updateOpacity, { toValue: 0,
	                duration: 500 }).start(function () {
	                thisThing.showAlert("App Updated", "Please reopen your app to complete the update.", [okayString], [thisThing.props.restartApp]);
	              });
	            }, 0);
	          });
	        } else {
	          Animated.timing(thisThing.state.updateOpacity, { toValue: 0,
	            duration: 500 }).start(function () {});
	        }
	      });
	
	      var appManager = this.props.appManager;
	      var locManager = appManager.getLocalizationManager();
	      var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	      this._didReceivePushListener = NativeAppEventEmitter.addListener('didReceivePush', this.didReceivePush);
	    } else {
	      if (DeviceEventEmitter) {
	        this._bundleUpdateStartedListener = DeviceEventEmitter.addListener('bundleUpdateStarted', function () {
	          thisThing.setState({ updateProgress: new Animated.Value(0), updateOpacity: new Animated.Value(0) });
	          Animated.timing(thisThing.state.updateOpacity, { toValue: 1,
	            duration: 500 }).start(function () {});
	        });
	        this._bundleUpdateProgressListener = DeviceEventEmitter.addListener('bundleUpdateProgress', function (data) {
	          var ratio = parseFloat(data.progress / 100);
	          Animated.spring(thisThing.state.updateProgress, {
	            toValue: thisThing.state.currentLayout.width * ratio,
	            tension: 10,
	            friction: 10
	          }).start();
	        });
	        this._bundleUpdateCompleteListener = DeviceEventEmitter.addListener('bundleUpdateComplete', function (data) {
	          if (data.updateSuccess) {
	            Animated.spring(thisThing.state.updateProgress, {
	              toValue: thisThing.state.currentLayout.width,
	              tension: 10,
	              friction: 10
	            }).start(function () {
	              setTimeout(function () {
	                Animated.timing(thisThing.state.updateOpacity, { toValue: 0,
	                  duration: 500 }).start(function () {
	                  thisThing.showAlert("App Updated", "Please reopen your app to complete the update.", [okayString], [thisThing.props.restartApp]);
	                });
	              }, 0);
	            });
	          } else {
	            Animated.timing(thisThing.state.updateOpacity, { toValue: 0,
	              duration: 500 }).start(function () {});
	          }
	        });
	
	        var appManager = this.props.appManager;
	        var locManager = appManager.getLocalizationManager();
	        var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	        this._didReceivePushListener = DeviceEventEmitter.addListener('didReceivePush', this.didReceivePush);
	      }
	    }
	
	    if (typeof this.props.appLoadCompletion !== 'undefined' && this.props.appLoadCompletion != null) {
	      var thisThing = this;
	      this._didExecuteAppLoadCompletion = true;
	      setTimeout(function () {
	        thisThing.props.appLoadCompletion(AppActions);
	      }, 1000);
	    }
	  },
	
	  _didExecuteAppLoadCompletion: false,
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (typeof this.props.appLoadCompletion !== 'undefined' && this.props.appLoadCompletion != null) {
	      var thisThing = this;
	      this._didExecuteAppLoadCompletion = true;
	      setTimeout(function () {
	        newProps.appLoadCompletion(AppActions);
	      }, 1000);
	    }
	  },
	
	  didReceivePush: function didReceivePush(data) {
	    var pattern, patternLiteral, patternDescription;
	    if (Platform.OS === 'android') {
	      pattern = [0, 2000];
	    } else {
	      pattern = [0];
	    }
	    Vibration.vibrate(pattern);
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	    // alert(JSON.stringify(data.aps))
	    if (typeof data.aps.TransactionID !== 'undefined') {
	      var title = "Transaction Success!";
	      var body = data.aps.alert;
	      if (typeof data.aps.CreditUsed !== 'undefined' && typeof data.aps.PointsEarned !== 'undefined') {
	        title = data.aps.alert;
	        body = "You spent " + locManager.localizedDollars(data.aps.CreditUsed) + " and earned " + locManager.localizedPoints(data.aps.PointsEarned) + "!";
	      } else if (typeof data.aps.PointsEarned !== 'undefined') {
	        title = data.aps.alert;
	        body = "You earned " + locManager.localizedPoints(data.aps.PointsEarned) + "!";
	      } else if (typeof data.aps.PointsUsed !== 'undefined' && typeof data.aps.RewardName !== 'undefined') {
	        title = data.aps.alert;
	        body = "You redeemed " + locManager.localizedPoints(data.aps.PointsUsed) + " for a " + data.aps.RewardName + "!";
	      } else if (typeof data.aps.FreePoints !== 'undefined') {
	        title = data.aps.alert;
	        body = "You earned " + locManager.localizedPoints(data.aps.FreePoints) + "!";
	      }
	
	      // data.aps.FirstName + ' ' + data.aps.UserName + ' ' + data.aps.CreditUsed + ' ' + data.aps.Subtotal + ' ' + data.aps.TipTotal + ' ' + data.aps.PointsEarned + ' ' + data.aps.TransactionID + ' ' + data.aps.FirstName + ' ' + data.aps.LastName + ' ' + data.aps.CurrentCredit + ' ' + data.aps.CurrentPoints + ' ' + data.aps.ServiceFee
	      var thisThing = this;
	      var customAlert = React.createElement(
	        ScrollView,
	        { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10 },
	          keyboardShouldPersistTaps: true,
	          keyboardDismissMode: "interactive" },
	        React.createElement(
	          View,
	          null,
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, isTitle: true, style: { marginTop: 10, textAlign: 'center' } },
	            title
	          ),
	          React.createElement(
	            ReUpText,
	            { appManager: appManager, style: { marginTop: 10, textAlign: 'center' } },
	            body
	          ),
	          React.createElement(
	            View,
	            { style: { flexDirection: 'row', marginTop: 4 } },
	            React.createElement(ReUpButton, { onPress: function onPress() {
	                return thisThing.hideAlert();
	              }, appManager: appManager, text: okayString, style: [{ margin: 10, flex: 1 }] })
	          )
	        )
	      );
	      AppActions.setCustomAlertShown(true, customAlert);
	    } else {
	      this.showAlert(appManager.appName, data.aps.alert, [okayString]);
	    }
	  },
	
	  downloadStarted: function downloadStarted() {
	    if (this.state.updateHasStarted2) return;
	
	    this.setState({ updateProgress2: new Animated.Value(0), updateOpacity2: new Animated.Value(0), updateHasStarted2: true });
	    Animated.timing(this.state.updateOpacity2, { toValue: 1,
	      duration: 500 }).start(function () {});
	  },
	
	  downloadProgressed: function downloadProgressed(data) {
	    if (!this.state.updateHasStarted2) {
	      this.downloadStarted();
	      return;
	    }
	    var thisThing = this;
	    var ratio = parseFloat(data.progress / 100);
	    Animated.spring(thisThing.state.updateProgress2, {
	      toValue: thisThing.state.currentLayout.width * ratio,
	      tension: 10,
	      friction: 10
	    }).start();
	  },
	
	  downloadCompleted: function downloadCompleted(data) {
	    var thisThing = this;
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	    if (data.updateSuccess) {
	      Animated.spring(thisThing.state.updateProgress2, {
	        toValue: thisThing.state.currentLayout.width,
	        tension: 10,
	        friction: 10
	      }).start(function () {
	        setTimeout(function () {
	          Animated.timing(thisThing.state.updateOpacity2, { toValue: 0,
	            duration: 500 }).start(function () {
	            var oldRootFeature = thisThing.props.appManager.getRootFeature();
	            thisThing.props.appManager.initialize(function () {
	              thisThing.setState({ updateHasStarted2: false });
	
	              // if the root feature has changed, restart the app
	              var newRootFeature = thisThing.props.appManager.getRootFeature();
	              if (typeof oldRootFeature !== 'undefined' && typeof oldRootFeature.data !== 'undefined' && typeof newRootFeature !== 'undefined' && typeof newRootFeature.data !== 'undefined' && newRootFeature.data.name != oldRootFeature.data.name) thisThing.props.restartApp();
	            });
	          });
	        }, 0);
	      });
	    } else {
	      Animated.timing(thisThing.state.updateOpacity2, { toValue: 0,
	        duration: 500 }).start(function () {
	        thisThing.setState({ updateHasStarted2: false });
	      });
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    Globals.removeHardwareBackListener(this.backPushed);
	    if (this._bundleUpdateStartedListener != null) this._bundleUpdateStartedListener.remove();
	    if (this._bundleUpdateProgressListener != null) this._bundleUpdateProgressListener.remove();
	    if (this._bundleUpdateCompleteListener != null) this._bundleUpdateCompleteListener.remove();
	    if (this._didReceivePushListener != null) this._didReceivePushListener.remove();
	
	    this.props.appManager._eventEmitter.removeListener('downloadStarted', this.downloadStarted, this);
	    this.props.appManager._eventEmitter.removeListener('downloadProgressed', this.downloadProgressed, this);
	    this.props.appManager._eventEmitter.removeListener('downloadCompleted', this.downloadCompleted, this);
	  },
	
	  stackIndex: function stackIndex() {
	    var stackIndex = typeof this._nav !== 'undefined' ? this._nav.state.routeStack.length - 1 : 0;
	
	    return stackIndex;
	  },
	
	  overrideMenuOpen: false,
	  pushFeature: function pushFeature(feature, extras, shouldAnimate) {
	    if (typeof shouldAnimate === 'undefined') shouldAnimate = true;
	
	    var thisThing = this;
	    feature.extras = extras;
	    AppActions.navLayout = thisThing.state.currentLayout;
	    if (FeatureBuilder.featureCustomNavigation(feature, AppActions, thisThing.state.currentLayout, extras)) {
	      return;
	    }
	
	    if (this.props.appManager.shouldUseFloatingNav()) {
	      if (this.props.appManager.shouldUseTab()) {
	        var foundTab = -1;
	        var tabFeatures = this.props.appManager.getTabFeatures();
	        var overriddenFeature = this.props.appManager.getFeatureOverrideForName(feature.data.name, extras);
	        var prerequisiteFeature = this.props.appManager.getPrerequisiteFeatureForName(overriddenFeature.featureName);
	        if (prerequisiteFeature == null && (!feature.data.requiresLogin || this.props.appManager.isLoggedIn())) {
	          var featureName = overriddenFeature.featureName;
	          extras = overriddenFeature.extras;
	          for (var i = 0; i < tabFeatures.length; i++) {
	            var otherOverriddenFeature = this.props.appManager.getFeatureOverrideForName(tabFeatures[i].data.name, extras);
	            if (otherOverriddenFeature.featureName == featureName) {
	              foundTab = i;
	              break;
	            }
	          }
	          if (foundTab >= 0 && !this._floatingNav.isShown() && this.stackIndex() <= 0 || this._floatingNav.isShown()) {
	            if (foundTab >= 0) this._tabs.setTabSelected(foundTab, false);
	            this._floatingNav.pushFeature(this.props.appManager.getFeatureForName(featureName), extras);
	            return;
	          }
	        }
	
	        var thisThing = this;
	        setTimeout(function () {
	          thisThing._tabs.setTabSelected(-1, false);
	        }, 200);
	      } else {
	        this._floatingNav.pushFeature(feature, extras);
	        return;
	      }
	    }
	    // if( this.refs.menu.state.isExpanded )
	    // {
	    //   this.overrideMenuOpen = true;
	    // }
	    AppActions.closeDrawer();
	    if (!shouldAnimate) {
	      var routeStack = this._nav.state.routeStack;
	      routeStack.push(feature);
	      this._nav.immediatelyResetRouteStack(routeStack);
	    } else {
	      this._nav.push(feature);
	    }
	
	    var shouldUseTab = this.props.appManager.shouldUseTab();
	    if (shouldUseTab) {
	      this._tabs.setVisible(false);
	      this._tabs.setTabSelected(-1);
	      // this._tabsContent.hideFeature();
	    }
	  },
	
	  backPushed: function backPushed() {
	    if (typeof this.refs.spinner !== 'undefined' && this.refs.spinner.state.isVisible) return true;
	    if (this.refs.customAlertOverlay._didFadeIn) {
	      this.hideAlert();
	      return true;
	    } else if (this.stackIndex() > 1) {
	      var currentFeature = this._nav.state.routeStack[this._nav.state.routeStack.length - 1];
	      if (typeof currentFeature !== 'undefined') {
	        var backOverride = FeatureBuilder.backOverrideForFeatureData(currentFeature);
	        if (backOverride != null) {
	          backOverride(this.props.appManager, AppActions);
	          return true;
	        }
	      }
	      if (this.stackIndex() > 2) {
	        this.popFeature();
	        return true;
	      }
	    }
	
	    if (this.props.appManager.shouldUseFloatingNav()) {
	      if (this._floatingNav.isShown()) {
	        this._floatingNav.popFeature();
	        return true;
	      }
	    }
	
	    return true;
	  },
	
	  popFeature: function popFeature() {
	    Keyboard.dismiss();
	    if (this.props.appManager.shouldUseFloatingNav()) {
	      this._floatingNav.popFeature();
	      return;
	    }
	
	    if (this.stackIndex() <= 0) {
	      return false;
	    }
	    AppActions.closeDrawer();
	
	    var shouldUseTab = this.props.appManager.shouldUseTab();
	    var stackIndex = this.stackIndex();
	    if (shouldUseTab && stackIndex <= 1) {
	      this._tabs.setVisible(true);
	    }
	
	    this._nav.pop();
	
	    return true;
	  },
	
	  popToIndex: function popToIndex(index) {
	    if (this.stackIndex() == 0 && this.props.appManager.shouldUseFloatingNav()) {
	      if (index == 0) this._floatingNav.dismiss();
	      return;
	    }
	
	    var routes = this.refs.mainNav.getCurrentRoutes();
	    if (index < routes.length) {
	      this._nav.popToRoute(routes[index]);
	    }
	  },
	
	  setCurrentFeature: function setCurrentFeature(feature, extras) {
	    AppActions.closeDrawer();
	    feature.extras = extras;
	
	    if (this.stackIndex() == 0 && this.props.appManager.shouldUseFloatingNav()) {
	      this.refs.floatingNav.replace(feature, extras);
	      return;
	    }
	
	    this._nav.replace(feature);
	  },
	
	  floatingNavDidDismiss: function floatingNavDidDismiss() {
	    if (this.props.appManager.shouldUseTab()) this._tabs.setTabSelected(-1);
	  },
	
	  _resetConnectivityChangeTimeout: null,
	  handleNetworkConnectivityChange: function handleNetworkConnectivityChange(reach) {
	    var isNotConnected = reach == "none" || reach == "NONE" || reach === false;
	
	    this._isNotConnected = isNotConnected;
	    this.setState({ networkConnected: !isNotConnected, shouldHideNetworkStatus: false });
	    console.log(reach);
	    if (isNotConnected) {
	      if (this._resetConnectivityChangeTimeout != null) clearTimeout(this._resetConnectivityChangeTimeout);
	
	      var thisThing = this;
	      this._resetConnectivityChangeTimeout = setTimeout(function () {
	        if (Platform.OS != 'web') {
	          NetInfo.removeEventListener('connectionChange', thisThing.handleNetworkConnectivityChange);
	
	          thisThing._networkConnectivityChange = NetInfo.addEventListener('connectionChange', thisThing.handleNetworkConnectivityChange);
	        }
	      }, 3000);
	    }
	  },
	
	  toggleMenu: function toggleMenu() {
	    AppActions.toggleDrawer();
	  },
	
	  _menuExpanded: false,
	  menuExpandedChanged: function menuExpandedChanged(isExpanded) {
	    this._menuExpanded = isExpanded;
	    if (typeof this._nav._navBar !== 'undefined') this._nav._navBar.forceUpdate();
	
	    if (this.state.isMenuExpanded != isExpanded) {
	      // not needed anymore
	      // this.setState({isMenuExpanded:isExpanded});
	    }
	  },
	
	  showAlert: function showAlert(title, body, buttonTitles, actions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize) {
	    var thisThing = this;
	    buttonTitles = typeof buttonTitles === 'undefined' ? [] : buttonTitles;
	    title = typeof title === 'undefined' ? "" : title;
	    body = typeof body === 'undefined' ? "" : body;
	    actions = typeof actions === 'undefined' ? [this.hideAlert] : actions;
	    didCancel = typeof didCancel === 'undefined' ? function () {} : didCancel;
	    var appManager = this.props.appManager;
	
	    var titleStyle = { marginTop: 10, textAlign: 'center' };
	    if (typeof titleFontSize !== 'undefined') titleStyle.fontSize = titleFontSize;
	
	    var bodyStyle = { marginTop: 10, textAlign: 'center' };
	    if (typeof bodyFontSize !== 'undefined') bodyStyle.fontSize = bodyFontSize;
	
	    var addedButtonFontStyle = {};
	    if (typeof addedButtonFontStyle !== 'undefined') addedButtonFontStyle.fontSize = buttonFontSize;
	
	    var customAlert = React.createElement(
	      ScrollView,
	      { bounces: true, style: { margin: 0, padding: 2, marginLeft: 10, marginRight: 10, flexBasis: "auto" },
	        keyboardShouldPersistTaps: true,
	        keyboardDismissMode: "interactive" },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, isTitle: true, style: titleStyle },
	          title
	        ),
	        React.createElement(
	          ReUpText,
	          { appManager: appManager, style: bodyStyle },
	          body
	        ),
	        React.createElement(
	          View,
	          { style: { flexDirection: 'row', marginTop: 4 } },
	          buttonTitles.map(function (buttonTitle, index) {
	            var isSecondary = buttonTitles.length > 1 && index == 0;
	            return React.createElement(ReUpButton, Object.assign({ isSecondary: isSecondary, onPress: function onPress() {
	                if (typeof actions[index] != 'undefined') {
	                  actions[index]();
	                } else {
	                  thisThing.hideAlert();
	                }
	              }, appManager: appManager, text: buttonTitle, style: [{ margin: 10, flex: 1 }] }, addedButtonFontStyle));
	          })
	        )
	      )
	    );
	    this.showCustomAlert(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss);
	  },
	
	  showCustomAlert: function showCustomAlert(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss) {
	    if (typeof this.refs.customAlertOverlay !== 'undefined') this.refs.customAlertOverlay.fadeIn(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss);
	  },
	
	  showNetworkErrorAlert: function showNetworkErrorAlert(okAction, didCancel) {
	    var locManager = this.props.appManager.getLocalizationManager();
	    var errorTitle = locManager.localizedStringForKey("NETWORK_FAIL_ALERT_TITLE");
	    var errorBody = locManager.localizedStringForKey("NETWORK_FAIL_ALERT_BODY");
	    var errorOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");
	
	    this.showAlert(errorTitle, errorBody, [errorOkay], [okAction], didCancel);
	  },
	
	  hideAlert: function hideAlert() {
	    this.refs.customAlertOverlay.fadeOut();
	  },
	
	  viewDidLayout: function viewDidLayout(info) {
	    var currentLayout = info.nativeEvent.layout;
	    var menuLayout = info.nativeEvent.layout;
	    menuLayout.height -= Globals.LAYOUT_HEIGHT_ADJUSTMENT;
	    currentLayout.height += Globals.LAYOUT_HEIGHT_ADJUSTMENT;
	    // layout.height -= 64;//styles.floatView.top;
	    if (typeof window.orientation != "undefined" && Math.abs(window.orientation) == 0) {
	      if (this.state.orientation == "landscape") {
	        document.location.reload();
	      }
	      this.setState({ orientation: "portrait" });
	    } else {
	      if (this.state.orientation == "portrait") {
	        document.location.reload();
	      }
	      this.setState({ orientation: "landscape" });
	    }
	
	    if (currentLayout.width != this.state.currentLayout.width || currentLayout.height != this.state.currentLayout.height) {
	      this.setState({ menuContainerLayout: menuLayout, currentLayout: currentLayout, shouldRender: true });
	    }
	  },
	
	  _lastDoubleTouch: -1,
	  _doubleTouchCount: 0,
	  MULTI_TOUCH_TIME_THRESHOLD: 500,
	  DEBUG_MENU_NUMBER_OF_TOUCHES: 5,
	  showDebugIfEnoughTouches: function showDebugIfEnoughTouches(timestamp) {
	    // touch too long, reset
	    if (this._lastDoubleTouch > 0 && timestamp - this._lastDoubleTouch > this.MULTI_TOUCH_TIME_THRESHOLD) {
	      this._doubleTouchCount = 0;
	      this._lastDoubleTouch = -1;
	    }
	
	    // show info
	    this._doubleTouchCount++;
	    if (this._doubleTouchCount >= this.DEBUG_MENU_NUMBER_OF_TOUCHES) {
	      this._doubleTouchCount = 0;
	      this._lastDoubleTouch = -1;
	      var appManager = this.props.appManager;
	      var resourceInfo = appManager.getResourceInfo();
	      this.showCustomAlert(React.createElement(
	        View,
	        null,
	        React.createElement(
	          Text,
	          { style: { fontSize: 12 } },
	          "Bundle Info\n\n" + BundleInfo + "\nResource Info\n\n" + resourceInfo
	        )
	      ));
	
	      return;
	    }
	
	    this._lastDoubleTouch = timestamp;
	  },
	
	  getLeftButtonState: function getLeftButtonState(isMenuExpanded, isAtRoot) {
	    var isAtRoot = typeof isAtRoot === 'undefined' ? this.stackIndex() <= 0 : isAtRoot;
	    var isMenuExpanded = (typeof isMenuExpanded !== 'undefined' ? isMenuExpanded : this._menuExpanded) || this.overrideMenuOpen;
	    var thisNav = this;
	
	    if (!isAtRoot) {
	      var retVal = {
	        ionicIconName: null,
	        iconName: "arrow-left",
	        onPress: function onPress() {
	          AppActions.requestPop();
	        }
	      };
	      return retVal;
	    } else if (isMenuExpanded) {
	      var retVal = {
	        ionicIconName: null,
	        iconName: "times",
	        onPress: function onPress() {
	          thisNav.toggleMenu();
	        }
	      };
	      return retVal;
	    } else {
	      var retVal = {
	        ionicIconName: null,
	        iconName: "bars",
	        onPress: function onPress() {
	          thisNav.toggleMenu();
	        }
	      };
	      return retVal;
	    }
	  },
	
	  featureIsInStack: function featureIsInStack(feature) {
	    if (!this._nav) return false;
	
	    var routeStack = this._nav.state.routeStack;
	    for (var i = 0, len = routeStack.length; i < len; i++) {
	      var thisFeature = routeStack[i];
	      if (thisFeature.data.name == feature.data.name) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  featureForData: function featureForData(route, layout, appManager, extras) {
	    return FeatureBuilder.featureForData(route, layout, appManager, extras);
	  },
	
	  _topRightDisabled: false,
	  render: function render() {
	    var _this = this;
	
	    var appManager = this.props.appManager;
	    var locManager = appManager.getLocalizationManager();
	    if (!this.state.shouldRender) {
	      return React.createElement(View, { key: 'container', style: styles.container, onLayout: this.viewDidLayout });
	    }
	    var thisNav = this;
	    var appManager = this.props.appManager;
	    var shouldDisableNavHeader = appManager.shouldDisableNavHeader(this.stackIndex());
	    var shouldUseTab = appManager.shouldUseTab();
	
	    var NavigationBar = shouldDisableNavHeader ? {
	      LeftButton: function LeftButton(route, navigator, index, navState) {
	        return React.createElement(View, null);
	      },
	      RightButton: function RightButton(route, navigator, index, navState) {
	        return React.createElement(View, null);
	      },
	      Title: function Title(route, navigator, index, navState) {
	        return React.createElement(View, null);
	      }
	    } : {
	      LeftButton: function LeftButton(route, navigator, index, navState) {
	        if (index == 0 && shouldUseTab) return null;
	        return React.createElement(
	          View,
	          {
	            style: Globals.TOP_LEFT_STYLE_ADJUSTMENT },
	          React.createElement(ReUpIconButton, { ref: function ref(leftButton) {
	              if (leftButton != null) leftButton.setState(thisNav.getLeftButtonState(undefined, index <= 0));
	            }, key: "leftNavButton" + index,
	            appManager: appManager,
	            type: 2,
	            accessibilityLabel: locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON") })
	        );
	      },
	
	      RightButton: function RightButton(route, navigator, index, navState) {
	        if (index == 0 && shouldUseTab) return null;
	        var topRightFeatures = appManager.getTopRightFeatures();
	        if (topRightFeatures.length <= 0) return React.createElement(View, null);
	
	        var feature = topRightFeatures[0];
	        if (feature.data.name == route.data.name || typeof feature === 'undefined') return React.createElement(View, null);
	        if (feature.data.requiresLogin && !appManager.isLoggedIn()) return React.createElement(View, null);
	        for (var i = 0, len = navState.routeStack.length; i < len && i < navState.routeStack.length; i++) {
	          var thisFeature = navState.routeStack[i];
	          if (thisFeature.data.name == feature.data.name) {
	            return React.createElement(View, null);
	          }
	        }
	
	        var thisThing = this;
	        var iconName = feature.data.icon.replace("fa-", "");
	        var topRightButtonName = feature.data.title;
	        if (typeof feature.data.shortTitle !== 'undefined') topRightButtonName = feature.data.shortTitle;
	        var useText = topRightButtonName.length <= 5;
	        return React.createElement(
	          MKButton,
	          { maskColor: 'transparent',
	            onPress: function onPress(evt) {
	              AppActions.requestFeatureName(feature.data.name);
	            },
	            style: Globals.TOP_RIGHT_STYLE_ADJUSTMENT },
	          useText ? React.createElement(
	            View,
	            { style: [{ width: 60, margin: 6, borderRadius: 30, alignItems: 'center', justifyContent: 'center', flexDirection: 'row', backgroundColor: appManager.getColorForKey("HeaderIconColor") }, Globals.TOP_RIGHT_INNER_STYLE_ADJUSTMENT] },
	            React.createElement(
	              ReUpText,
	              { isTitle: true, appManager: appManager, style: { color: appManager.getColorForKey("HeaderColor") } },
	              topRightButtonName
	            )
	          ) : React.createElement(ReUpIconButton, { key: "rightButton" + index,
	            appManager: appManager,
	            type: 4,
	            iconName: iconName,
	            iconSize: 18,
	            onPress: function onPress() {
	              if (thisThing._topRightDisabled) return;
	              thisThing._topRightDisabled = true;
	              setTimeout(function () {
	                thisThing._topRightDisabled = false;
	              }, 2000);
	              AppActions.requestFeatureName(feature.data.name);
	            }
	          })
	        );
	      },
	
	      Title: function Title(route, navigator, index, navState) {
	        if (index == 0 && shouldUseTab) return null;
	        if (route.data.headerImage && route.data.headerImage.trim().length > 0) {
	          var headerPath = appManager.absoluteResourceForPath(route.key + '/' + route.data.headerImage);
	          if (route.key == "FeedPlus" || route.key == "PassHome") headerPath = appManager.absoluteResourceForPath('Feed' + '/' + 'header.png');
	
	          return React.createElement(
	            View,
	            { onStartShouldSetResponder: function onStartShouldSetResponder(evt) {
	                if (evt.nativeEvent.identifier == 2 || Platform.OS != "ios" && evt.nativeEvent.identifier == 1) thisNav.showDebugIfEnoughTouches(evt.nativeEvent.timestamp);
	              },
	              style: [styles.navBarTitleContainer, { alignSelf: 'stretch', flex: 1, marginRight: Platform.OS != "ios" && Platform.OS != "web" ? 70 : 0 }] },
	            React.createElement(Image, { key: appManager.getImageKey("header"), style: [styles.navBarTitleImage], resizeMode: "stretch", source: { uri: headerPath } })
	          );
	        } else {
	          return React.createElement(
	            View,
	            { onStartShouldSetResponder: function onStartShouldSetResponder(evt) {
	                if (evt.nativeEvent.identifier >= 1) thisNav.showDebugIfEnoughTouches(evt.nativeEvent.timestamp);
	              },
	              style: [styles.navBarTitleContainer, { alignSelf: 'stretch', flex: 1, marginRight: Platform.OS != "ios" && Platform.OS != "web" ? 70 : 0 }] },
	            React.createElement(
	              View,
	              { style: { alignSelf: 'center' } },
	              React.createElement(
	                ReUpText,
	                { appManager: appManager, isSuperTitle: true, shrinksAtLength: 20, style: [styles.navBarTitleText, { color: appManager.getColorForKey("HeaderTitleColor") }] },
	                route.data.title
	              )
	            )
	          );
	        }
	      }
	
	    };
	
	    var navStyles = Navigator.NavigationBar.Styles;
	    if (Platform.OS == 'ios') {
	      navStyles.General.TotalNavHeight = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Left.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Left.RightButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Center.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Center.RightButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Right.LeftButton.height = Globals.NAV_BAR_HEIGHT;
	      navStyles.Stages.Right.RightButton.height = Globals.NAV_BAR_HEIGHT;
	    }
	
	    var navBar = React.createElement(Navigator.NavigationBar, { routeMapper: NavigationBar, navigationStyles: navStyles, style: [styles.navBar, { height: Globals.NAV_BAR_HEIGHT }, { backgroundColor: this.props.appManager.getColorForKey("HeaderColor") }, shouldDisableNavHeader ? { height: 0, opacity: 0, display: 'none', pointerEvents: 'none' } : {}] });
	    var initialRoute = appManager.getRootFeature();
	    var appNav = this;
	
	    if (this.state.shouldShowSpinner && this.refs.customAlertOverlay) {
	      // this.refs.customAlertOverlay.fadeOut();
	    }
	
	    var navSpacerLineColor = appManager.shouldDisableNavHeader(this.stackIndex()) ? 'transparent' : appManager.getColorForKey("HeaderTitleColor", 0.1);
	
	    var isFeedPlus = true;
	
	    var addedContainerStyle = { top: 0, left: 0, bottom: 0, right: 0, position: 'absolute' };
	    var height = 0;
	    var width = 0;
	    try {
	      height = window.innerHeight;
	      width = window.innerWidth;
	      if (height > 0 && width > 0) {
	        if (Platform.OS !== 'ios' && Platform.OS !== 'web') height -= 24; // status bar
	        addedContainerStyle = { width: width, height: height };
	      }
	    } catch (e) {} finally {}
	
	    return React.createElement(
	      View,
	      { key: 'container', style: [styles.container, addedContainerStyle], onLayout: this.viewDidLayout },
	      React.createElement(Navigator, { ref: function ref(a) {
	          if (a) thisNav._nav = a;
	        }, key: 'mainNav', navigationBar: this.props.appManager.shouldUseFloatingNav() && !this.props.appManager.shouldUseTab() ? null : navBar, initialRoute: initialRoute, style: addedContainerStyle,
	        onWillFocus: function onWillFocus(route) {
	          AppActions.closeDrawer();
	          appNav.forceUpdate();
	          if (typeof appNav._nav !== 'undefined' && typeof appNav._nav._navBar !== 'undefined') {
	            // appNav._nav._navBar.forceUpdate();
	          }
	        },
	        onDidFocus: function onDidFocus(route) {
	          if (appNav.overrideMenuOpen) {
	            appNav.overrideMenuOpen = false;
	            // if( typeof appNav._nav._navBar !== 'undefined' ) appNav._nav._navBar.forceUpdate();
	          }
	
	          // appNav.forceUpdate();
	
	          if (typeof route === 'undefined' || route.key == 'Feed' || route.key == 'FeedPlus' || route.key == 'PassHome') appManager._eventEmitter.emit("checkUserChanged", {});
	        },
	        renderScene: function renderScene(route, navigator) {
	          return FeatureBuilder.featureForData(route, _this.state.currentLayout, appManager, route.extras);
	        },
	        configureScene: function configureScene(route, routeStack) {
	          if (typeof routeStack === 'undefined') routeStack = appNav._nav.state.routeStack;
	          if (isFeedPlus && routeStack.length <= 2) return Navigator.SceneConfigs.FloatFromRight;
	
	          return Navigator.SceneConfigs.PushFromRight;
	        }
	      }),
	      shouldUseTab ? React.createElement(ReUpTabBar, { ref: function ref(a) {
	          return _this._tabs = a;
	        }, buttonFeatures: appManager.getTabFeatures(),
	        inactiveBackgroundColor: appManager.getColorForKey("HeaderColor"),
	        activeBackgroundColor: appManager.getColorForKey("HeaderColor"),
	        rippleColor: appManager.getColorForKey("HeaderIconColor", 0.4),
	        barColor: appManager.getColorForKey("ButtonPrimaryColor"),
	        showX: true,
	        showFeature: function showFeature(feature, index, extras) {
	          AppActions.requestFeatureName(feature.data.name, extras, false, null, thisNav._floatingNav.isShown());
	          // thisNav.setCurrentFeature(feature, extras);
	          // thisNav._tabs.setTabSelected(index);
	          // thisNav._tabsContent.showFeature(feature, {}, true, function()
	          // {
	          //   thisNav._tabs.setTabSelected(index)
	          // }, function()
	          // {
	          //   thisNav._tabs.setTabSelected(-1)
	          // })
	        },
	        hideFeature: function hideFeature() {
	          thisNav.popToIndex(0);
	          // thisNav._tabsContent.hideFeature()
	        },
	        textColor: appManager.getColorForKey("HeaderTitleColor"),
	        iconColor: 'transparent', style: { paddingTop: Globals.STATUS_BAR_HEIGHT, width: this.state.currentLayout.width, height: Globals.ACTION_BAR_HEIGHT, position: 'absolute', top: 0, left: 0, right: 0, pointerEvents: 'none' } }) : null,
	      React.createElement(View, { style: { backgroundColor: navSpacerLineColor, width: this.state.currentLayout.width, height: 1, position: 'absolute', top: Globals.ACTION_BAR_HEIGHT - 1, left: 0 } }),
	      shouldUseTab && false ? React.createElement(ReUpTabContentContainer, { ref: 'tabsContent', appActions: AppActions,
	        layout: this.state.currentLayout,
	        appManager: appManager,
	        activeTop: Globals.ACTION_BAR_HEIGHT,
	        height: this.state.currentLayout.height - Globals.ACTION_BAR_HEIGHT,
	        width: this.state.currentLayout.width }) : null,
	      React.createElement(ReUpFloatingNavigator, { ref: function ref(a) {
	          if (a != null) _this._floatingNav = a;
	        }, appManager: appManager, appActions: AppActions, style: { position: 'absolute', left: 0, top: shouldUseTab ? Globals.ACTION_BAR_HEIGHT : 0, width: width, height: height }, ignoreStatusBar: shouldUseTab, disableNavHeader: shouldUseTab, onDismiss: this.floatingNavDidDismiss }),
	      this.state.networkConnected || this.state.shouldHideNetworkStatus ? null : React.createElement(
	        TouchableOpacity,
	        { activeOpacity: 0.8, onPress: function onPress() {
	            thisNav.setState({ shouldHideNetworkStatus: true });
	          }, style: [styles.networkStatus, { backgroundColor: appManager.getColorForKey("HeaderIconColor"), alignItems: 'center', justifyContent: 'center', top: shouldDisableNavHeader ? Globals.STATUS_BAR_HEIGHT : Globals.ACTION_BAR_HEIGHT }] },
	        React.createElement(
	          View,
	          { style: { paddingLeft: 30, flex: 1, alignItems: 'center', justifyContent: 'center' } },
	          React.createElement(
	            ReUpText,
	            { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: appManager.getColorForKey("HeaderColor") } },
	            appManager.getLocalizationManager().localizedStringForKey("NO_CONNECTION_STATEMENT")
	          )
	        ),
	        React.createElement(
	          View,
	          { style: { width: 30 } },
	          React.createElement(
	            ReUpText,
	            { appManager: typeof appManager === 'undefined' ? null : appManager, style: { color: appManager.getColorForKey("HeaderColor") } },
	            'X'
	          )
	        )
	      ),
	      React.createElement(
	        View,
	        { style: styles.updateMeter },
	        React.createElement(Animated.View, { style: { width: this.state.updateProgress, opacity: this.state.updateOpacity, height: 2, backgroundColor: appManager.getColorForKey("HeaderIconColor") } })
	      ),
	      React.createElement(
	        View,
	        { style: styles.updateMeter },
	        React.createElement(Animated.View, { style: { width: this.state.updateProgress2, opacity: this.state.updateOpacity2, height: 2, backgroundColor: appManager.getColorForKey("HeaderIconColor") } })
	      ),
	      React.createElement(
	        CustomAlertOverlay,
	        { ref: 'customAlertOverlay', key: 'customAlert', isVisible: true, shouldHideTemporarily: this.state.shouldShowSpinner, cancelSelected: function cancelSelected() {
	            AppActions.setCustomAlertShown(false);if (typeof appNav.state.customAlertDidCancel !== 'undefined') appNav.state.customAlertDidCancel();
	          }, layout: this.state.currentLayout },
	        this.state.customAlertChildren
	      ),
	      React.createElement(ProgressOverlay, { ref: 'spinner', key: 'spinner', isVisible: this.state.shouldShowSpinner, spinnerText: this.state.spinnerText, layout: this.state.currentLayout, appManager: appManager })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  floatView: {
	    position: 'absolute',
	    backgroundColor: 'transparent',
	    flex: 1,
	    width: 0,
	    height: 0,
	    top: Globals.ACTION_BAR_HEIGHT,
	    left: 0
	  },
	  container: {
	    alignItems: 'stretch',
	    flex: 1,
	    alignSelf: 'stretch'
	  },
	  messageText: {
	    fontWeight: '500',
	    padding: 15,
	    marginTop: 50,
	    marginLeft: 15
	  },
	  button: {
	    backgroundColor: 'white',
	    padding: 15,
	    borderBottomWidth: 1 / PixelRatio.get(),
	    borderBottomColor: '#CDCDCD'
	  },
	  buttonText: {},
	  navBar: {
	    backgroundColor: 'grey',
	    padding: 0,
	    flex: -1
	  },
	  navBarTitleImage: {
	    height: 44,
	    width: 150,
	    padding: 0,
	    flex: -1
	  },
	  navBarTitleContainer: {
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  navBarText: {
	    marginVertical: 10
	  },
	  navBarTitleText: {
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center'
	  },
	  navBarLeftButton: {
	    flexDirection: 'row',
	    width: 44,
	    height: 44,
	    marginTop: 6,
	    borderRadius: 22,
	    alignItems: 'center',
	    justifyContent: 'center',
	    alignSelf: 'center',
	    backgroundColor: 'transparent'
	  },
	  navBarRightButton: {
	    paddingRight: 10,
	    flexDirection: 'row',
	    width: 44,
	    alignItems: 'center',
	    justifyContent: 'center',
	    flex: -1
	  },
	  navBarButtonText: {
	    color: 'green',
	    paddingLeft: 2,
	    paddingTop: 2
	  },
	  scene: {
	    flex: 1,
	    paddingTop: 20,
	    backgroundColor: '#EAEAEA'
	  },
	  menuContainerShown: {
	    opacity: 1
	  },
	  updateMeter: {
	    position: 'absolute',
	    flexDirection: 'row',
	    top: 0,
	    left: 0,
	    right: 0,
	    height: 2,
	    backgroundColor: 'transparent'
	  },
	  networkStatus: {
	    position: 'absolute',
	    flexDirection: 'row',
	    left: 0,
	    right: 0,
	    height: 30
	  }
	});
	
	module.exports = AppNavigator;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	
	var ReUpText = __webpack_require__(8);
	
	var Image = ReactNative.Image,
	    ListView = ReactNative.ListView,
	    TouchableHighlight = ReactNative.TouchableHighlight,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var Category = __webpack_require__(5)({
	
	  getInitialState: function getInitialState() {
	
	    var getSectionData = function getSectionData(dataBlob, sectionID) {
	      return dataBlob[sectionID];
	    };
	
	    return {
	      dataBlob: {},
	      dataSource: new ListView.DataSource({
	        getSectionData: getSectionData,
	        rowHasChanged: function rowHasChanged(r1, r2) {
	          return r1 !== r2;
	        },
	        sectionHeaderHasChanged: function sectionHeaderHasChanged(s1, s2) {
	          return s1 !== s2;
	        }
	      }).cloneWithRowsAndSections(this.generateRows())
	    };
	  },
	
	  renderSectionHeader: function renderSectionHeader(sectionData, sectionID) {
	    return React.createElement(
	      View,
	      { style: styles.catListHeaderContainer },
	      React.createElement(
	        ReUpText,
	        { appManager: this.props.appManager, style: styles.catListTitle },
	        'Categories ',
	        sectionID
	      )
	    );
	  },
	
	  render: function render() {
	    return React.createElement(ListView, {
	      contentContainerStyle: styles.list,
	      dataSource: this.state.dataSource,
	      renderRow: this.renderRow,
	      renderSectionHeader: this.renderSectionHeader
	    });
	  },
	
	  renderRow: function renderRow(rowData, sectionID, rowID) {
	    return React.createElement(
	      TouchableHighlight,
	      { underlayColor: 'rgba(0,0,0,0)' },
	      React.createElement(
	        View,
	        null,
	        React.createElement(
	          View,
	          { style: styles.row },
	          React.createElement(
	            ReUpText,
	            { appManager: this.props.appManager, style: styles.text },
	            rowData
	          )
	        )
	      )
	    );
	  },
	
	  generateRows: function generateRows() {
	    var dataBlob = [];
	    for (var ii = 0; ii < 50; ii++) {
	      dataBlob.push('Cell ' + ii);
	    }
	    return [dataBlob, dataBlob];
	  }
	
	});
	
	var styles = StyleSheet.create({
	  list: {},
	  row: {
	    padding: 12,
	    backgroundColor: '#F6F6F6',
	    borderColor: '#eee',
	    borderBottomWidth: 1
	  },
	  text: {},
	  catListTitle: {
	    fontWeight: 'bold',
	    color: '#ffffff'
	  },
	  catListHeaderContainer: {
	    padding: 12,
	    backgroundColor: '#1F2036'
	  }
	});
	
	module.exports = Category;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Animated = __webpack_require__(9);
	var ReactDOM = __webpack_require__(65);
	var createReactClass = __webpack_require__(5);
	// var RCTLog = require('RCTLog');
	var Splash = __webpack_require__(1160);
	var AppNavigator = __webpack_require__(1157);
	var appActions = __webpack_require__(63);
	var featureBuilder = __webpack_require__(90);
	var InterstitialContainer = __webpack_require__(1118);
	// var RNOverlay = require('./src/wrappers/react-native-overlay-wrapper.android.js');
	// global.self = global; //DO NOT DELETE
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	  return result;
	}
	
	var AppRegistry = ReactNative.AppRegistry,
	    StyleSheet = ReactNative.StyleSheet,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Navigator = ReactNative.Navigator;
	
	
	var Animated = __webpack_require__(9);
	
	var ReUp = createReactClass({
	  displayName: 'ReUp',
	
	  getInitialState: function getInitialState() {
	    var shouldShowInterstitial = findGetParameter("isPass") != "1" && findGetParameter("isPassFree") != "1";
	    return {
	      shouldShowSplash: true,
	      shouldShowApp: false,
	      shouldShowInterstitial: shouldShowInterstitial,
	
	      appManager: null,
	      splashOpacity: new Animated.Value(1),
	      interstitialOpacity: new Animated.Value(0)
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var styleElement = document.getElementById('react-native-stylesheet');
	    // if not, inject the style sheet
	    if (styleElement) {
	      // styleElement.innerHTML = "div{padding:0px}"
	    }
	    document.head.insertAdjacentHTML('beforeend', '<style id="custom">:focus { outline: 0; } div{padding:0px; padding-top:0px; padding-bottom:0px; padding-left:0px; padding-right:0px; margin:0px; overflow:none;}</style>');
	  },
	
	  _shouldSkipInterstitial: false,
	  splashDidFinish: function splashDidFinish(appManager) {
	    var thisThing = this;
	    if (this._cacheIndex != null) appManager._imageCacheIndex = this._cacheIndex;
	    // appManager.setAvailableFonts(this.props.availableFonts);
	    appManager.getVariable(appManager.TUTORIAL_LAST_VIEWED, function (date) {
	      thisThing.setState({ appManager: appManager });
	      thisThing._shouldSkipInterstitial = true; //thisThing._shouldSkipInterstitial || (typeof thisThing.state.appManager.getFeatureForName('DomainLogin') !== 'undefined') || (typeof date !== 'undefined' && date != null) || (typeof thisThing.props.SKIP_TUTORIAL === 'undefined' ? false : (thisThing.props.SKIP_TUTORIAL == "YES"));
	
	      var thisThingThing = thisThing;
	      if (thisThing._shouldSkipInterstitial) {
	        thisThing.setState({ shouldShowApp: true });
	        Animated.timing(thisThing.state.splashOpacity, {
	          toValue: 0,
	          duration: 150
	        }).start(function () {
	          thisThing.setState({ shouldShowSplash: false, shouldShowInterstitial: false });
	        });
	      } else {
	        thisThing.setState({ shouldShowInterstitial: true });
	        setTimeout(function () {
	          Animated.timing(thisThing.state.interstitialOpacity, {
	            toValue: 1,
	            duration: 150
	          }).start(function () {});
	        }, 1000); // give the first image a sec to load
	      }
	    });
	  },
	
	  interstitialDidFinish: function interstitialDidFinish(completion) {
	    this.setState({ shouldShowApp: true });
	    if (typeof completion !== 'undefined') this.setState({ appLoadCompletion: completion });
	
	    var thisThing = this;
	    Animated.timing(thisThing.state.interstitialOpacity, {
	      toValue: 0,
	      duration: 300
	    }).start(function () {
	      thisThing.setState({ shouldShowInterstitial: false, shouldShowSplash: false });
	    });
	
	    Animated.timing(thisThing.state.splashOpacity, {
	      toValue: 0,
	      duration: 300
	    }).start(function () {});
	  },
	
	  _cacheIndex: null,
	  restartApp: function restartApp() {
	    this._cacheIndex = new Date().getTime();
	    this.setState({ shouldShowSplash: true, shouldHideSplash: false, shouldShowInterstitial: false, shouldShowApp: false });
	  },
	
	  render: function render() {
	    return React.createElement(
	      View,
	      { style: { flex: 1, alignSelf: 'stretch', height: '100%', width: '100%', maxWidth: '100%', overflow: 'hidden', flexDirection: 'column' } },
	      this.state.shouldShowApp ? React.createElement(
	        View,
	        { style: { flex: 1, alignSelf: 'stretch' } },
	        React.createElement(AppNavigator, { key: 'appNav', appManager: this.state.appManager, restartApp: this.restartApp, appLoadCompletion: this.state.appLoadCompletion })
	      ) : null,
	      this.state.shouldShowSplash ? React.createElement(
	        Animated.View,
	        { ref: "splashContainer", key: "splashContainer", style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, flexDirection: 'column', opacity: this.state.splashOpacity, flex: -1 }, layout: this.props.layout },
	        React.createElement(Splash, { splashDidFinish: this.splashDidFinish })
	      ) : null,
	      this.state.shouldShowInterstitial && this.state.appManager != null && typeof this.state.appManager.getFeatureForName('DomainLogin') === 'undefined' ? React.createElement(
	        Animated.View,
	        { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, flexDirection: 'column', opacity: this.state.interstitialOpacity, flex: -1 } },
	        React.createElement(InterstitialContainer, { key: 'appNav', appManager: this.state.appManager, appActions: this.state.appActions, featureBuilder: featureBuilder, interstitialDidFinish: this.interstitialDidFinish })
	      ) : null
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  container: {
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'center',
	    backgroundColor: '#F5FCFF'
	  },
	  welcome: {
	    fontSize: 20,
	    textAlign: 'center',
	    margin: 10
	  },
	  instructions: {
	    textAlign: 'center',
	    color: '#333333',
	    marginBottom: 5
	  }
	});
	ReactDOM.render(React.createElement(ReUp, null), document.getElementById("root"));
	// AppRegistry.registerComponent('ReUp', () => ReUp);

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var AppManager = __webpack_require__(1156);
	var BundleVersion = __webpack_require__(844);
	var RNReUpUpdater = __webpack_require__(4).NativeModules.RNReUpUpdater;
	
	var PlatformConstants = __webpack_require__(31);
	
	var AppRegistry = ReactNative.AppRegistry,
	    Text = ReactNative.Text,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	  return result;
	}
	
	var SPLASH_DELAY = findGetParameter("isPass") != "1" && findGetParameter("isPassFree") != "1" ? 200 : 0;
	
	var Splash = __webpack_require__(5)({
	  getDefaultProps: function getDefaultProps() {
	    return {
	      splashDidFinish: function splashDidFinish() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      resourcesSynced: false,
	      hasCheckedResourcesSynced: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var splash = this;
	
	    AppManager.SKIP_TUTORIAL = typeof this.props.SKIP_TUTORIAL !== 'undefined' && this.props.SKIP_TUTORIAL;
	
	    AppManager.doResourcesExist(function (resourceExist) {
	      splash.setState({ resourcesSynced: resourceExist, hasCheckedResourcesSynced: true });
	    });
	
	    if (RNReUpUpdater) RNReUpUpdater.setBundleVersionString(BundleVersion);
	    AppManager.initialize(function (data) {
	      splash.checkUpdate(function () {
	        setTimeout(function () {
	          splash.props.splashDidFinish(AppManager);
	        }, SPLASH_DELAY);
	      });
	    });
	  },
	
	  checkUpdate: function checkUpdate(completion) {
	    if (completion) completion();
	  },
	
	  render: function render() {
	    if (this.state.hasCheckedResourcesSynced == false) return React.createElement(View, { style: { backgroundColor: 'black' } });
	
	    var splashImageURI = PlatformConstants.resourcesDirectory + '/App/Splash.png';
	    if (!this.state.resourcesSynced) {
	      splashImageURI = PlatformConstants.packagedResourcesDirectory + '/App/Splash.png';
	    }
	    if (findGetParameter("isPass") == "1" || findGetParameter("isPassFree") == "1") {
	      splashImageURI = "";
	    }
	
	    return React.createElement(
	      View,
	      { style: styles.imageContainer },
	      React.createElement(Image, {
	        style: styles.image,
	        resizeMode: "cover",
	        source: { uri: splashImageURI }
	      })
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  imageContainer: {
	    flex: 1,
	    alignItems: 'stretch'
	  },
	  image: {
	    flex: 1,
	    alignItems: 'center',
	    justifyContent: 'center'
	  }
	});
	
	module.exports = Splash;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ReactNative = __webpack_require__(4);
	var Linking = ReactNative.Linking;
	
	
	module.exports = {
	  getLaunchedURL: function getLaunchedURL(completion) {
	    var url = Linking.getInitialURL().then(function (url) {
	      if (completion) completion(url);
	    }).catch(function (err) {
	      return console.error('An error occurred', err);
	    });
	  },
	  addEventListener: function addEventListener(responder) {
	    Linking.addEventListener('url', responder);
	  },
	  removeEventListener: function removeEventListener(responder) {
	    Linking.removeEventListener('url', responder);
	  }
	};

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	
	var Linking = ReactNative.Linking;
	
	
	module.exports = {
	  call: function call(phoneNumber) {
	    var url = "tel://" + phoneNumber;
	    Linking.openURL(url);
	  },
	
	  canCall: function canCall(completion) {
	    Linking.canOpenURL("tel://1231231234", completion);
	  }
	};

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var Animated = __webpack_require__(9);
	
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    ScrollView = ReactNative.ScrollView,
	    Easing = ReactNative.Easing,
	    Text = ReactNative.Text,
	    StyleSheet = ReactNative.StyleSheet;
	
	
	var ReUpText = __webpack_require__(8);
	
	var PullToRefreshScrollView = createReactClass({
	  displayName: 'PullToRefreshScrollView',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      pullDistancePX: 50,
	      minUpdateTime: 1000,
	      didStartRefreshing: function didStartRefreshing() {},
	      pullRefreshView: React.createElement(
	        View,
	        { style: { height: 50, backgroundColor: 'blue' } },
	        React.createElement(
	          ReUpText,
	          null,
	          'Pull to refresh...'
	        )
	      ),
	      releaseRefreshView: React.createElement(
	        View,
	        { style: { height: 50, backgroundColor: 'blue' } },
	        React.createElement(
	          ReUpText,
	          null,
	          'Release to refresh...'
	        )
	      ),
	      refreshingView: React.createElement(
	        View,
	        { style: { height: 50, backgroundColor: 'blue' } },
	        React.createElement(
	          ReUpText,
	          null,
	          'Refreshing...'
	        )
	      )
	    };
	  },
	
	  PULL_TO_REFRESH: 0,
	  RELEASE_TO_REFRESH: 1,
	  REFRESHING: 2,
	  getInitialState: function getInitialState() {
	    return {
	      pullState: this.PULL_TO_REFRESH,
	      pullOffset: new Animated.Value(-50),
	      pullHeight: new Animated.Value(50)
	    };
	  },
	  componentDidMount: function componentDidMount() {},
	
	  // _lastOffsetY:0,
	  didScroll: function didScroll(event) {
	    // this._lastOffsetY = event.nativeEvent.contentOffset.y;
	    if (this.state.pullState == this.PULL_TO_REFRESH) {
	      if (-event.nativeEvent.contentOffset.y > this.props.pullDistancePX) {
	        this.setState({ pullState: this.RELEASE_TO_REFRESH });
	      }
	    } else if (this.state.pullState == this.RELEASE_TO_REFRESH) {
	      if (-event.nativeEvent.contentOffset.y < this.props.pullDistancePX) {
	        this.setState({ pullState: this.PULL_TO_REFRESH });
	      }
	    }
	  },
	
	  didRelease: function didRelease(event) {
	    if (this.state.pullState == this.RELEASE_TO_REFRESH) {
	      this.setIsRefreshing(true);
	    }
	  },
	
	  isRefreshing: function isRefreshing() {
	    return this.state.pullState == this.REFRESHING;
	  },
	
	  _readyToStopRefreshing: false,
	  _shouldStopRefreshing: false,
	  setIsRefreshing: function setIsRefreshing(isRefreshing) {
	    if (this.isRefreshing() == isRefreshing) return; // no change, do nothing
	
	    this.setState({
	      pullState: this.REFRESHING
	    });
	
	    var ptr = this;
	    if (isRefreshing) {
	      this.props.didStartRefreshing(this);
	      Animated.timing(ptr.state.pullOffset, { toValue: 0,
	        duration: 200,
	        easing: Easing.out(Easing.ease) }).start();
	
	      this._readyToStopRefreshing = false;
	      this._shouldStopRefreshing = false;
	      setTimeout(function () {
	        ptr._readyToStopRefreshing = true;
	        if (ptr._shouldStopRefreshing) {
	          Animated.timing( // Uses easing functions
	          ptr.state.pullOffset, // The value to drive
	          { toValue: -ptr.props.pullDistancePX,
	            duration: 100 } // Configuration
	          ).start(); // Don't forget start!
	          setTimeout(function () {
	            ptr.setState({ pullState: ptr.PULL_TO_REFRESH });
	          }, 100);
	        }
	      }, this.props.minUpdateTime);
	    } else {
	      this._shouldStopRefreshing = true;
	      if (this._readyToStopRefreshing) {
	        Animated.timing( // Uses easing functions
	        ptr.state.pullOffset, // The value to drive
	        { toValue: -ptr.props.pullDistancePX,
	          duration: 100 } // Configuration
	        ).start(); // Don't forget start!
	        setTimeout(function () {
	          ptr.setState({ pullState: ptr.PULL_TO_REFRESH });
	        }, 100);
	      }
	    }
	  },
	
	  scrollTo: function scrollTo(x, y) {
	    this._pullToReleaseScroll.scrollTo(x, y);
	  },
	
	  currentView: function currentView() {
	    if (this.state.pullState == this.PULL_TO_REFRESH) return this.props.pullRefreshView;else if (this.state.pullState == this.RELEASE_TO_REFRESH) return this.props.releaseRefreshView;else return this.props.refreshingView;
	  },
	
	  getScrollResponder: function getScrollResponder() {
	    return this._pullToReleaseScroll;
	  },
	
	  _pullToReleaseScroll: null,
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        pullDistancePX = _props.pullDistancePX,
	        _onScroll = _props.onScroll,
	        style = _props.style,
	        _onResponderRelease = _props.onResponderRelease,
	        pullRefreshView = _props.pullRefreshView,
	        releaseRefreshView = _props.releaseRefreshView,
	        refreshingView = _props.refreshingView,
	        children = _props.children,
	        other = _objectWithoutProperties(_props, ['pullDistancePX', 'onScroll', 'style', 'onResponderRelease', 'pullRefreshView', 'releaseRefreshView', 'refreshingView', 'children']);
	
	    return React.createElement(
	      ScrollView,
	      Object.assign({
	        key: 'pullToReleaseScroll', ref: function ref(a) {
	          return _this._pullToReleaseScroll = a;
	        },
	        onScroll: function onScroll(event) {
	          _this.didScroll(event);if (typeof _onScroll !== 'undefined' && _onScroll != null) _onScroll(event);
	        },
	        scrollEventThrottle: 20,
	        removeClippedSubviews: true,
	        onResponderRelease: function onResponderRelease(event) {
	          _this.didRelease(event);if (typeof _onResponderRelease !== 'undefined' && _onResponderRelease != null) _onResponderRelease(event);
	        },
	        style: [{ flex: 1 }, style],
	        contentContainerStyle: { flex: 1 }
	      }, other),
	      React.createElement(
	        Animated.View,
	        { key: 'pullToReleaseContainer', style: [styles.pullToRefreshViewContainer, { height: this.props.pullDistancePX, marginTop: this.state.pullOffset }] },
	        this.currentView()
	      ),
	      children
	    );
	  }
	});
	
	var styles = StyleSheet.create({
	  pullToRefreshViewContainer: {
	    flexDirection: 'column',
	    justifyContent: 'flex-end',
	    backgroundColor: 'red'
	  }
	});
	
	module.exports = PullToRefreshScrollView;

/***/ },
/* 1164 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  initialize: function initialize() {
	    console.log('initialize push manager');
	  },
	  addEventListener: function addEventListener(responder) {
	    console.log('push manager - add event listener', responder);
	  },
	  removeEventListener: function removeEventListener(responder) {
	    console.log('push manager - remove event listener', responder);
	  }
	};

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _reactNative = __webpack_require__(4);
	
	var Events = __webpack_require__(857);
	var RNDBModel = {};
	RNDBModel.DBEvents = new Events();
	
	var useDefaultData = false;
	// useDefaultData = true;
	var defaultData = {
	  // "Features": {
	  //   "Features--1":{
	  //       "rowID" : "-1",
	  //       "FeatureID": "3",
	  //       "FeatureName": "Astarte Fresh Yogurt",
	  //       "ImageFileName": "https:\/\/s3.amazonaws.com\/reup-web-storage\/6ba88\/news\/147384409705790te.jpg",
	  //       "Description": "Come by to check out our always changing seasonal menu items!",
	  //       "Timestamp": "2016-09-14 09:08:17",
	  //       "IsDeleted": "0",
	  //       "LocaleOverride": null
	  //   }
	  // },
	  "Users": {
	    "Users--1": {
	      "UserID": "332",
	      "UserName": "kjregan10@gmail.com",
	      "Password": "asdfwxyzabcd",
	      "FirstName": "Re",
	      "LastName": "Up",
	      "DOB": "0000-00-00",
	      "ProfileURL": "",
	      "Credit": "0.00",
	      "Points": "0",
	      "Verified": "1",
	      "Admin": 0,
	      "STRIPE_lastFour": "",
	      "STRIPE_expMonth": "0",
	      "STRIPE_expYear": "0",
	      "STRIPE_cardType": "0",
	      "PaymentInfo": "[]",
	      "DirtyPassword": "0",
	      "ReferralCode": "kelseyr332",
	      "HasTransferredLoyalty": "0",
	      "PhoneNumber": null,
	      "AppStoreURL": "https:\/\/itunes.apple.com\/us\/app\/astarte\/id815879832?mt=8",
	      "PlayStoreURL": "https:\/\/play.google.com\/store\/apps\/details?id=com.surepathmobile.astarte1&hl=en",
	      "STRIPE_pubKey": "pk_live_1LMbvJ2hQjpEO4zahLVho2IZ",
	      "DollarsPerPoint": "5",
	      "PayPal_ClientID": "",
	      "ShowPhoneNumber": false,
	      "RequirePhoneForPurchase": false,
	      "RequirePhoneForRewards": false,
	      "RequirePhoneForPaymentTypes": false,
	      "RequirePostalCode": false,
	      "PayPal_Environment": "live",
	      "CC_Gateway_Primary": "stripecc",
	      "Hash": "5cb8ed9367",
	      "PayMode": 0,
	      "Locale": "en"
	    }
	  }
	};
	
	function findGetParameter(parameterName) {
	  var result = null,
	      tmp = [];
	  location.search.substr(1).split("&").forEach(function (item) {
	    tmp = item.split("=");
	    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
	  });
	  return result;
	}
	
	var isDemo = findGetParameter("isDemo");
	if (isDemo != null) useDefaultData = isDemo;
	
	RNDBModel.create_db = function (db) {
	  var me = this;
	  me.db_name = db;
	  me.rows = {};
	  var localItemsString = localStorage.getItem(db);
	  if ((typeof localItemsString === 'undefined' ? 'undefined' : _typeof(localItemsString)) !== undefined && localItemsString != null) {
	    try {
	      var newRows = JSON.parse(localItemsString);
	      if (newRows) me.rows = newRows;
	    } catch (e) {
	      console.log("couldn't parse local storage", localItemsString, e);
	    } finally {}
	  }
	  if (useDefaultData && typeof defaultData[db] !== 'undefined') me.rows = defaultData[db];
	
	  me.nextRowID = 0;
	
	  /**
	   * @description Finds all the objects based on the query
	   * @param query_data
	   * @param callback
	   */
	  me.get = function (query_data, callback) {
	    callback([]); // dont use for now
	    // ReactNativeStore.table(me.db_name).then(function(collection){
	    //     var results = collection.where(query_data).find();
	    //     if(callback){
	    //         callback(results)
	    //     }
	    // });
	  };
	
	  /**
	   * @description Finds by ID
	   * @param id
	   * @param callback
	   */
	  me.get_id = function (id, callback) {
	    callback({}); // dont use for now
	  };
	
	  /**
	   * @description Gets all the data of the table
	   * @param callback
	   */
	  me.get_all = function (callback) {
	    // if( useDefaultData && typeof defaultData[me.db_name] !== 'undefined' )
	    // {
	    //   console.log("using default " + me.db_name, defaultData[me.db_name])
	    //   me.rows = defaultData[me.db_name];
	    // }
	    callback(me);
	  };
	
	  /**
	   * @description Adds data to the Table in the DB
	   * @param data_to_add
	   * @param callback
	   */
	  me.add = function (data_to_add, callback) {
	    me.rows[me.db_name + me.nextRowID++] = data_to_add;
	    me.backupRows();
	    if (callback) callback(data_to_add);
	  };
	
	  /**
	   * @description Adds array of data to the Table in the DB
	   * @param data_to_add
	   * @param callback
	   */
	  me.add_all = function (data_to_add, callback) {
	    if (data_to_add.length <= 0) return null;
	
	    var added_data = [];
	
	    var addItem = function addItem(data_to_add) {
	      if (data_to_add.length == 0 && callback) {
	        return callback(added_data);
	      }
	      var data = data_to_add.pop();
	
	      me.add(data, function (data_added) {
	        addItem(data_to_add);
	        added_data.push(data_added);
	      });
	    };
	
	    addItem(data_to_add);
	    if (callback) callback(added_data);
	  };
	
	  /**
	   * @description Removes all the objects matching the query
	   * @param query_data
	   * @param callback
	   */
	  me.remove = function (query_data, callback) {
	    callback(); // dont use
	  };
	
	  /**
	   * @description Removed object by ID
	   * @param id
	   * @param callback
	   */
	  me.remove_id = function (id, callback) {
	    callback(); // dont use
	  };
	
	  /**
	   * @description Erases the complete DB
	   * @param callback
	   */
	  me.erase_db = function (callback) {
	    var copy = JSON.parse(JSON.stringify(me.rows));
	    me.rows = {};
	    me.backupRows();
	    callback(copy);
	  };
	  /**
	   * @description Updates the Table with the query
	   * @param query_data
	   * @param replace_data
	   * @param callback
	   */
	  me.update = function (query_data, replace_data, callback) {
	    var retRows = [];
	    for (var i = 0; i < me.rows.length; i++) {
	      var isMatch = true;
	      for (var key in query_data) {
	        if (query_data[key] != me.rows[i][key]) {
	          isMatch = false;
	          break;
	        }
	      }
	
	      if (isMatch) {
	        for (var key in query_data) {
	          me.rows[i][key] = replace_data[key];
	        }
	        retRows.push(me.rows[i]);
	      }
	    }
	    if (callback) callback(retRows);
	  };
	
	  /**
	   * @description Updates the DB Object by ID
	   * @param id
	   * @param replace_data
	   * @param callback
	   */
	  me.update_id = function (id, replace_data, callback) {
	    callback(); // dont use
	  };
	
	  /**
	   * @description Removed object by ID
	   * @param id
	   * @param callback
	   */
	  me.remove_id = function (id, callback) {
	    callback(); // dont use
	  };
	
	  me.backupRows = function () {
	    try {
	      localStorage.setItem(me.db_name, JSON.stringify(me.rows));
	    } catch (e) {
	      console.log("problems saving to local storage", e);
	    } finally {}
	  };
	};
	
	module.exports = RNDBModel;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactMotionDrawer = __webpack_require__(1370);
	
	var _reactMotionDrawer2 = _interopRequireDefault(_reactMotionDrawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var React = __webpack_require__(1);
	var ReactNative = __webpack_require__(4);
	var createReactClass = __webpack_require__(5);
	var AppRegistry = ReactNative.AppRegistry,
	    View = ReactNative.View,
	    Image = ReactNative.Image,
	    Platform = ReactNative.Platform,
	    findNodeHandle = ReactNative.findNodeHandle;
	
	
	var Globals = __webpack_require__(10);
	
	
	var DrawerWrapper = createReactClass({
	  displayName: 'DrawerWrapper',
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onOpen: function onOpen() {},
	      onClose: function onClose() {},
	      content: null
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {},
	
	  open: function open() {
	    this._draw.open();
	  },
	
	  close: function close() {
	    this._draw.close();
	  },
	
	  toggle: function toggle() {
	    if (this._isOpen) this.close();else this.open();
	  },
	
	  _isOpen: false,
	  render: function render() {
	    var _this = this;
	
	    var thisThing = this;
	    return React.createElement(
	      View,
	      { style: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, paddingTop: Globals.ACTION_BAR_HEIGHT } },
	      React.createElement(
	        _reactMotionDrawer2.default,
	        { ref: function ref(a) {
	            if (a != null) _this._draw = a;
	          }, noTouchOpen: true, handleWidth: 0, onChange: function onChange(a) {
	            thisThing._isOpen = a;
	            if (a) thisThing.props.onOpen();else thisThing.props.onClose();
	          }, drawerStyle: { top: Globals.ACTION_BAR_HEIGHT, marginRight: 50 }
	        },
	        React.createElement(
	          View,
	          { style: { flex: 1, alignSelf: 'stretch', backgroundColor: 'red', height: '100%' } },
	          this.props.content
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	
	DrawerWrapper.tweenPresets = { parallax: 1 };
	
	exports.default = DrawerWrapper;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNative = __webpack_require__(4);
	
	if (_reactNative.Platform.OS === 'web') {
	  module.exports = {
	    Answers: {
	      logPurchase: function logPurchase() {},
	      logCustom: function logCustom() {},
	      logLogin: function logLogin() {},
	      logContentView: function logContentView() {},
	      logSignUp: function logSignUp() {}
	    },
	
	    Crashlytics: {
	      recordError: function recordError(error) {},
	      logException: function logException(error) {}
	    }
	  };
	}

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactNative = __webpack_require__(4);
	
	if (_reactNative.Platform.OS === 'web') {
	  module.exports = {
	    unlink: function unlink() {}
	  };
	}

/***/ },
/* 1169 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  Accelerometer: {},
	  Gyroscope: {}
	};

/***/ },
/* 1170 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  setCategory: function setCategory(mode) {}
	};

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1172);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1172 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1173 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * Color Contast Checker
	 * An accessibility checker tool for validating the color contrast based on WCAG 2.0 standard.
	 * var ccc = new ColorContrastChecker();
	
	 * var color1 = "#FFFFFF";
	 * var color2 = "#000000;
	
	 * if (ccc.isLevelAA(color1, color2, 14)) {
	 *     alert("Valid Level AA");
	 * } else {
	 *     alert("Invalid Contrast");
	 * }
	 */
	
	if (false)
	    var define = require("amdefine")(module, require);
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var ColorContrastChecker = function() {};
	
	    ColorContrastChecker.prototype = {
	        fontSize: 14,
	        rgbClass : {
	            toString: function() {
	                return "<r: " + this.r +
	                    " g: " + this.g +
	                    " b: " + this.b +
	                    " >";
	            }
	        },
	        isValidSixDigitColorCode: function (hex){
	            var regSixDigitColorcode = /^(#)?([0-9a-fA-F]{6})?$/;
	            return regSixDigitColorcode.test(hex);
	        },
	        isValidThreeDigitColorCode: function (hex){
	            var regThreeDigitColorcode = /^(#)?([0-9a-fA-F]{3})?$/;
	            return regThreeDigitColorcode.test(hex);
	        },
	        isValidColorCode : function (hex){
	            return this.isValidSixDigitColorCode(hex) || this.isValidThreeDigitColorCode(hex);
	        },
	        isValidRatio : function (ratio){
	            return (typeof ratio === "number");
	        },
	        convertColorToSixDigit: function (hex) {
	            return "#" + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
	        },
	        hexToLuminance: function (color) {
	            if (!this.isValidColorCode(color)) {
	                throw new Error("Invalid Color :" + color);
	            }
	
	            if (this.isValidThreeDigitColorCode(color)) {
	                color = this.convertColorToSixDigit(color);
	            }
	
	            color = this.getRGBFromHex(color);
	
	            var LRGB = this.calculateLRGB(color);
	
	            return this.calculateLuminance(LRGB);
	        },
	        check: function (colorA, colorB, fontSize, customRatio) {
	            if (typeof fontSize !== "undefined") {
	                this.fontSize = fontSize;
	            }
	
	            if(!colorA || !colorB) {
	                return false;
	            }
	
	            var l1 = this.hexToLuminance(colorA); /* higher value */
	            var l2 = this.hexToLuminance(colorB); /* lower value */
	            var contrastRatio = this.getContrastRatio(l1, l2);
	
	            if (typeof customRatio !== "undefined") {
	                if (!this.isValidRatio(customRatio)) {
	                    return false;
	                }
	                return this.verifyCustomContrastRatio(contrastRatio, customRatio);
	            } else {
	                return this.verifyContrastRatio(contrastRatio);
	            }
	            
	        },
	        checkPairs: function (pairs, customRatio) {
	            var results = [];
	
	            for (var i in pairs) {
	                var pair = pairs[i];
	                if (typeof pair.fontSize !== "undefined") {
	                    results.push(
	                        this.check(
	                            pair.colorA,
	                            pair.colorB,
	                            pair.fontSize,
	                            customRatio
	                        )
	                    );
	                } else {
	                    results.push(
	                        this.check(
	                            pair.colorA,
	                            pair.colorB,
	                            void 0,
	                            customRatio
	                        )
	                    );
	                }
	            }
	            return results;
	        },
	        calculateLuminance: function(lRGB) {
	            return (0.2126 * lRGB.r) + (0.7152 * lRGB.g) + (0.0722 * lRGB.b);
	        },
	        isLevelAA : function(colorA, colorB, fontSize) {
	            var result = this.check(colorA, colorB, fontSize);
	            return result.WCAG_AA;
	        },
	        isLevelAAA : function(colorA, colorB, fontSize) {
	            var result = this.check(colorA, colorB, fontSize);
	            return result.WCAG_AAA; 
	        },
	        isLevelCustom : function(colorA, colorB, ratio) {
	            var result = this.check(colorA, colorB, void 0, ratio);
	            return result.customRatio;
	        },
	        getRGBFromHex : function(color) {
	
	            var rgb = Object.create(this.rgbClass),
	                rVal,
	                gVal,
	                bVal;
	
	            if (typeof color !== "string") {
	                throw new Error("must use string");
	            }
	
	            rVal = parseInt(color.slice(1, 3), 16);
	            gVal = parseInt(color.slice(3, 5), 16);
	            bVal = parseInt(color.slice(5, 7), 16);
	
	            rgb.r = rVal;
	            rgb.g = gVal;
	            rgb.b = bVal;
	
	            return rgb;
	        },
	        calculateSRGB : function(rgb) {
	            var sRGB = Object.create(this.rgbClass),
	                key;
	
	            for (key in rgb) {
	                if (rgb.hasOwnProperty(key)) {
	                    sRGB[key] = parseFloat((rgb[key] / 255), 10);
	                }
	            }
	
	            return sRGB;
	        },
	        calculateLRGB: function (rgb) {
	            var sRGB = this.calculateSRGB(rgb);
	            var lRGB = Object.create(this.rgbClass),
	                key,
	                val = 0;
	
	            for (key in sRGB) {
	                if (sRGB.hasOwnProperty(key)) {
	                    val = parseFloat(sRGB[key], 10);
	                    if (val <= 0.03928) {
	                        lRGB[key] = (val / 12.92);
	                    } else {
	                        lRGB[key] = Math.pow(((val + 0.055) / 1.055), 2.4);
	                    }
	                }
	            }
	
	            return lRGB;
	        },
	        getContrastRatio : function(lumA, lumB) {
	            var ratio,
	                lighter,
	                darker;
	
	            if (lumA >= lumB) {
	                lighter = lumA;
	                darker = lumB;
	            } else {
	                lighter = lumB;
	                darker = lumA;
	            }
	
	            ratio = (lighter + 0.05) / (darker + 0.05);
	
	            return ratio;
	        },
	        verifyContrastRatio : function(ratio) {
	
	
	            var resultsClass = {
	                toString: function() {
	                    return "< WCAG-AA: " + ((this.WCAG_AA) ? "pass" : "fail") +
	                        " WCAG-AAA: " + ((this.WCAG_AAA) ? "pass" : "fail") +
	                        " >";
	                }
	            };
	            var WCAG_REQ_RATIO_AA_LG = 3.0,
	                WCAG_REQ_RATIO_AA_SM = 4.5,
	                WCAG_REQ_RATIO_AAA_LG = 4.5,
	                WCAG_REQ_RATIO_AAA_SM = 7.0,
	                WCAG_FONT_CUTOFF = 18;
	
	            var results = Object.create(resultsClass),
	                fontSize = this.fontSize || 14;
	
	            if (fontSize >= WCAG_FONT_CUTOFF) {
	                results.WCAG_AA = (ratio >= WCAG_REQ_RATIO_AA_LG);
	                results.WCAG_AAA = (ratio >= WCAG_REQ_RATIO_AAA_LG);
	            } else {
	                results.WCAG_AA = (ratio >= WCAG_REQ_RATIO_AA_SM);
	                results.WCAG_AAA = (ratio >= WCAG_REQ_RATIO_AAA_SM);
	            }
	
	            return results;
	        },
	        verifyCustomContrastRatio : function(inputRatio, checkRatio) {
	
	            var resultsClass = {
	                toString: function() {
	                    return "< Custom Ratio: " + ((this.customRatio) ? "pass" : "fail") +
	                        "  >";
	                }
	            };
	
	            var results = Object.create(resultsClass);
	
	            results.customRatio = (inputRatio >= checkRatio);
	            return results;
	        }
	
	    };
	
	    return ColorContrastChecker;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(80), __webpack_require__(81), __webpack_require__(64), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Lookup tables
		    var SBOX = [];
		    var INV_SBOX = [];
		    var SUB_MIX_0 = [];
		    var SUB_MIX_1 = [];
		    var SUB_MIX_2 = [];
		    var SUB_MIX_3 = [];
		    var INV_SUB_MIX_0 = [];
		    var INV_SUB_MIX_1 = [];
		    var INV_SUB_MIX_2 = [];
		    var INV_SUB_MIX_3 = [];
	
		    // Compute lookup tables
		    (function () {
		        // Compute double table
		        var d = [];
		        for (var i = 0; i < 256; i++) {
		            if (i < 128) {
		                d[i] = i << 1;
		            } else {
		                d[i] = (i << 1) ^ 0x11b;
		            }
		        }
	
		        // Walk GF(2^8)
		        var x = 0;
		        var xi = 0;
		        for (var i = 0; i < 256; i++) {
		            // Compute sbox
		            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
		            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
		            SBOX[x] = sx;
		            INV_SBOX[sx] = x;
	
		            // Compute multiplication
		            var x2 = d[x];
		            var x4 = d[x2];
		            var x8 = d[x4];
	
		            // Compute sub bytes, mix columns tables
		            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
		            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
		            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
		            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
		            SUB_MIX_3[x] = t;
	
		            // Compute inv sub bytes, inv mix columns tables
		            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
		            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
		            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
		            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
		            INV_SUB_MIX_3[sx] = t;
	
		            // Compute next counter
		            if (!x) {
		                x = xi = 1;
		            } else {
		                x = x2 ^ d[d[d[x8 ^ x2]]];
		                xi ^= d[d[xi]];
		            }
		        }
		    }());
	
		    // Precomputed Rcon lookup
		    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	
		    /**
		     * AES block cipher algorithm.
		     */
		    var AES = C_algo.AES = BlockCipher.extend({
		        _doReset: function () {
		            // Skip reset of nRounds has been set before and key did not change
		            if (this._nRounds && this._keyPriorReset === this._key) {
		                return;
		            }
	
		            // Shortcuts
		            var key = this._keyPriorReset = this._key;
		            var keyWords = key.words;
		            var keySize = key.sigBytes / 4;
	
		            // Compute number of rounds
		            var nRounds = this._nRounds = keySize + 6;
	
		            // Compute number of key schedule rows
		            var ksRows = (nRounds + 1) * 4;
	
		            // Compute key schedule
		            var keySchedule = this._keySchedule = [];
		            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
		                if (ksRow < keySize) {
		                    keySchedule[ksRow] = keyWords[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 1];
	
		                    if (!(ksRow % keySize)) {
		                        // Rot word
		                        t = (t << 8) | (t >>> 24);
	
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	
		                        // Mix Rcon
		                        t ^= RCON[(ksRow / keySize) | 0] << 24;
		                    } else if (keySize > 6 && ksRow % keySize == 4) {
		                        // Sub word
		                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
		                    }
	
		                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
		                }
		            }
	
		            // Compute inv key schedule
		            var invKeySchedule = this._invKeySchedule = [];
		            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
		                var ksRow = ksRows - invKsRow;
	
		                if (invKsRow % 4) {
		                    var t = keySchedule[ksRow];
		                } else {
		                    var t = keySchedule[ksRow - 4];
		                }
	
		                if (invKsRow < 4 || ksRow <= 4) {
		                    invKeySchedule[invKsRow] = t;
		                } else {
		                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
		                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
		                }
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
		        },
	
		        decryptBlock: function (M, offset) {
		            // Swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
	
		            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
	
		            // Inv swap 2nd and 4th rows
		            var t = M[offset + 1];
		            M[offset + 1] = M[offset + 3];
		            M[offset + 3] = t;
		        },
	
		        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
		            // Shortcut
		            var nRounds = this._nRounds;
	
		            // Get input, add round key
		            var s0 = M[offset]     ^ keySchedule[0];
		            var s1 = M[offset + 1] ^ keySchedule[1];
		            var s2 = M[offset + 2] ^ keySchedule[2];
		            var s3 = M[offset + 3] ^ keySchedule[3];
	
		            // Key schedule row counter
		            var ksRow = 4;
	
		            // Rounds
		            for (var round = 1; round < nRounds; round++) {
		                // Shift rows, sub bytes, mix columns, add round key
		                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
		                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
		                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
		                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
	
		                // Update state
		                s0 = t0;
		                s1 = t1;
		                s2 = t2;
		                s3 = t3;
		            }
	
		            // Shift rows, sub bytes, add round key
		            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
		            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
		            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
		            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	
		            // Set output
		            M[offset]     = t0;
		            M[offset + 1] = t1;
		            M[offset + 2] = t2;
		            M[offset + 3] = t3;
		        },
	
		        keySize: 256/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
		     */
		    C.AES = BlockCipher._createHelper(AES);
		}());
	
	
		return CryptoJS.AES;
	
	}));

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * UTF-16 BE encoding strategy.
		     */
		    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
		        /**
		         * Converts a word array to a UTF-16 BE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 BE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 BE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 BE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    /**
		     * UTF-16 LE encoding strategy.
		     */
		    C_enc.Utf16LE = {
		        /**
		         * Converts a word array to a UTF-16 LE string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-16 LE string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var utf16Chars = [];
		            for (var i = 0; i < sigBytes; i += 2) {
		                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
		                utf16Chars.push(String.fromCharCode(codePoint));
		            }
	
		            return utf16Chars.join('');
		        },
	
		        /**
		         * Converts a UTF-16 LE string to a word array.
		         *
		         * @param {string} utf16Str The UTF-16 LE string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
		         */
		        parse: function (utf16Str) {
		            // Shortcut
		            var utf16StrLength = utf16Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < utf16StrLength; i++) {
		                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
		            }
	
		            return WordArray.create(words, utf16StrLength * 2);
		        }
		    };
	
		    function swapEndian(word) {
		        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
		    }
		}());
	
	
		return CryptoJS.enc.Utf16;
	
	}));

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (undefined) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var CipherParams = C_lib.CipherParams;
		    var C_enc = C.enc;
		    var Hex = C_enc.Hex;
		    var C_format = C.format;
	
		    var HexFormatter = C_format.Hex = {
		        /**
		         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
		         *
		         * @param {CipherParams} cipherParams The cipher params object.
		         *
		         * @return {string} The hexadecimally encoded string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
		         */
		        stringify: function (cipherParams) {
		            return cipherParams.ciphertext.toString(Hex);
		        },
	
		        /**
		         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
		         *
		         * @param {string} input The hexadecimally encoded string.
		         *
		         * @return {CipherParams} The cipher params object.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
		         */
		        parse: function (input) {
		            var ciphertext = Hex.parse(input);
		            return CipherParams.create({ ciphertext: ciphertext });
		        }
		    };
		}());
	
	
		return CryptoJS.format.Hex;
	
	}));

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(115), __webpack_require__(1179), __webpack_require__(1176), __webpack_require__(80), __webpack_require__(81), __webpack_require__(154), __webpack_require__(855), __webpack_require__(1195), __webpack_require__(856), __webpack_require__(1197), __webpack_require__(1196), __webpack_require__(1194), __webpack_require__(153), __webpack_require__(1190), __webpack_require__(64), __webpack_require__(33), __webpack_require__(1180), __webpack_require__(1182), __webpack_require__(1181), __webpack_require__(1184), __webpack_require__(1183), __webpack_require__(1185), __webpack_require__(1186), __webpack_require__(1187), __webpack_require__(1189), __webpack_require__(1188), __webpack_require__(1177), __webpack_require__(1175), __webpack_require__(1198), __webpack_require__(1193), __webpack_require__(1192), __webpack_require__(1191));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		return CryptoJS;
	
	}));

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Check if typed arrays are supported
		    if (typeof ArrayBuffer != 'function') {
		        return;
		    }
	
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
	
		    // Reference original init
		    var superInit = WordArray.init;
	
		    // Augment WordArray.init to handle typed arrays
		    var subInit = WordArray.init = function (typedArray) {
		        // Convert buffers to uint8
		        if (typedArray instanceof ArrayBuffer) {
		            typedArray = new Uint8Array(typedArray);
		        }
	
		        // Convert other array views to uint8
		        if (
		            typedArray instanceof Int8Array ||
		            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
		            typedArray instanceof Int16Array ||
		            typedArray instanceof Uint16Array ||
		            typedArray instanceof Int32Array ||
		            typedArray instanceof Uint32Array ||
		            typedArray instanceof Float32Array ||
		            typedArray instanceof Float64Array
		        ) {
		            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
		        }
	
		        // Handle Uint8Array
		        if (typedArray instanceof Uint8Array) {
		            // Shortcut
		            var typedArrayByteLength = typedArray.byteLength;
	
		            // Extract bytes
		            var words = [];
		            for (var i = 0; i < typedArrayByteLength; i++) {
		                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
		            }
	
		            // Initialize this word array
		            superInit.call(this, words, typedArrayByteLength);
		        } else {
		            // Else call normal init
		            superInit.apply(this, arguments);
		        }
		    };
	
		    subInit.prototype = WordArray;
		}());
	
	
		return CryptoJS.lib.WordArray;
	
	}));

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Cipher Feedback block mode.
		 */
		CryptoJS.mode.CFB = (function () {
		    var CFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    CFB.Encryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // Remember this block to use with next block
		            this._prevBlock = words.slice(offset, offset + blockSize);
		        }
		    });
	
		    CFB.Decryptor = CFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher;
		            var blockSize = cipher.blockSize;
	
		            // Remember this block to use with next block
		            var thisBlock = words.slice(offset, offset + blockSize);
	
		            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
	
		            // This block becomes the previous block
		            this._prevBlock = thisBlock;
		        }
		    });
	
		    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
		        // Shortcut
		        var iv = this._iv;
	
		        // Generate keystream
		        if (iv) {
		            var keystream = iv.slice(0);
	
		            // Remove IV for subsequent blocks
		            this._iv = undefined;
		        } else {
		            var keystream = this._prevBlock;
		        }
		        cipher.encryptBlock(keystream, 0);
	
		        // Encrypt
		        for (var i = 0; i < blockSize; i++) {
		            words[offset + i] ^= keystream[i];
		        }
		    }
	
		    return CFB;
		}());
	
	
		return CryptoJS.mode.CFB;
	
	}));

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
		 * derived from CryptoJS.mode.CTR
		 * Jan Hruby jhruby.web@gmail.com
		 */
		CryptoJS.mode.CTRGladman = (function () {
		    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
	
			function incWord(word)
			{
				if (((word >> 24) & 0xff) === 0xff) { //overflow
				var b1 = (word >> 16)&0xff;
				var b2 = (word >> 8)&0xff;
				var b3 = word & 0xff;
	
				if (b1 === 0xff) // overflow b1
				{
				b1 = 0;
				if (b2 === 0xff)
				{
					b2 = 0;
					if (b3 === 0xff)
					{
						b3 = 0;
					}
					else
					{
						++b3;
					}
				}
				else
				{
					++b2;
				}
				}
				else
				{
				++b1;
				}
	
				word = 0;
				word += (b1 << 16);
				word += (b2 << 8);
				word += b3;
				}
				else
				{
				word += (0x01 << 24);
				}
				return word;
			}
	
			function incCounter(counter)
			{
				if ((counter[0] = incWord(counter[0])) === 0)
				{
					// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
					counter[1] = incWord(counter[1]);
				}
				return counter;
			}
	
		    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
	
					incCounter(counter);
	
					var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTRGladman.Decryptor = Encryptor;
	
		    return CTRGladman;
		}());
	
	
	
	
		return CryptoJS.mode.CTRGladman;
	
	}));

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Counter block mode.
		 */
		CryptoJS.mode.CTR = (function () {
		    var CTR = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = CTR.Encryptor = CTR.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var counter = this._counter;
	
		            // Generate keystream
		            if (iv) {
		                counter = this._counter = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            var keystream = counter.slice(0);
		            cipher.encryptBlock(keystream, 0);
	
		            // Increment counter
		            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    CTR.Decryptor = Encryptor;
	
		    return CTR;
		}());
	
	
		return CryptoJS.mode.CTR;
	
	}));

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Electronic Codebook block mode.
		 */
		CryptoJS.mode.ECB = (function () {
		    var ECB = CryptoJS.lib.BlockCipherMode.extend();
	
		    ECB.Encryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.encryptBlock(words, offset);
		        }
		    });
	
		    ECB.Decryptor = ECB.extend({
		        processBlock: function (words, offset) {
		            this._cipher.decryptBlock(words, offset);
		        }
		    });
	
		    return ECB;
		}());
	
	
		return CryptoJS.mode.ECB;
	
	}));

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Output Feedback block mode.
		 */
		CryptoJS.mode.OFB = (function () {
		    var OFB = CryptoJS.lib.BlockCipherMode.extend();
	
		    var Encryptor = OFB.Encryptor = OFB.extend({
		        processBlock: function (words, offset) {
		            // Shortcuts
		            var cipher = this._cipher
		            var blockSize = cipher.blockSize;
		            var iv = this._iv;
		            var keystream = this._keystream;
	
		            // Generate keystream
		            if (iv) {
		                keystream = this._keystream = iv.slice(0);
	
		                // Remove IV for subsequent blocks
		                this._iv = undefined;
		            }
		            cipher.encryptBlock(keystream, 0);
	
		            // Encrypt
		            for (var i = 0; i < blockSize; i++) {
		                words[offset + i] ^= keystream[i];
		            }
		        }
		    });
	
		    OFB.Decryptor = Encryptor;
	
		    return OFB;
		}());
	
	
		return CryptoJS.mode.OFB;
	
	}));

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ANSI X.923 padding strategy.
		 */
		CryptoJS.pad.AnsiX923 = {
		    pad: function (data, blockSize) {
		        // Shortcuts
		        var dataSigBytes = data.sigBytes;
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
	
		        // Compute last byte position
		        var lastBytePos = dataSigBytes + nPaddingBytes - 1;
	
		        // Pad
		        data.clamp();
		        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
		        data.sigBytes += nPaddingBytes;
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Ansix923;
	
	}));

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO 10126 padding strategy.
		 */
		CryptoJS.pad.Iso10126 = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Count padding bytes
		        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
	
		        // Pad
		        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
		             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
		    },
	
		    unpad: function (data) {
		        // Get number of padding bytes from last byte
		        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;
	
		        // Remove padding
		        data.sigBytes -= nPaddingBytes;
		    }
		};
	
	
		return CryptoJS.pad.Iso10126;
	
	}));

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * ISO/IEC 9797-1 Padding Method 2.
		 */
		CryptoJS.pad.Iso97971 = {
		    pad: function (data, blockSize) {
		        // Add 0x80 byte
		        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));
	
		        // Zero pad the rest
		        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
		    },
	
		    unpad: function (data) {
		        // Remove zero padding
		        CryptoJS.pad.ZeroPadding.unpad(data);
	
		        // Remove one more byte -- the 0x80 byte
		        data.sigBytes--;
		    }
		};
	
	
		return CryptoJS.pad.Iso97971;
	
	}));

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * A noop padding strategy.
		 */
		CryptoJS.pad.NoPadding = {
		    pad: function () {
		    },
	
		    unpad: function () {
		    }
		};
	
	
		return CryptoJS.pad.NoPadding;
	
	}));

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/**
		 * Zero padding strategy.
		 */
		CryptoJS.pad.ZeroPadding = {
		    pad: function (data, blockSize) {
		        // Shortcut
		        var blockSizeBytes = blockSize * 4;
	
		        // Pad
		        data.clamp();
		        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
		    },
	
		    unpad: function (data) {
		        // Shortcut
		        var dataWords = data.words;
	
		        // Unpad
		        var i = data.sigBytes - 1;
		        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
		            i--;
		        }
		        data.sigBytes = i + 1;
		    }
		};
	
	
		return CryptoJS.pad.ZeroPadding;
	
	}));

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(154), __webpack_require__(153));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha1", "./hmac"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var Base = C_lib.Base;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA1 = C_algo.SHA1;
		    var HMAC = C_algo.HMAC;
	
		    /**
		     * Password-Based Key Derivation Function 2 algorithm.
		     */
		    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
		         * @property {Hasher} hasher The hasher to use. Default: SHA1
		         * @property {number} iterations The number of iterations to perform. Default: 1
		         */
		        cfg: Base.extend({
		            keySize: 128/32,
		            hasher: SHA1,
		            iterations: 1
		        }),
	
		        /**
		         * Initializes a newly created key derivation function.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
		         *
		         * @example
		         *
		         *     var kdf = CryptoJS.algo.PBKDF2.create();
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
		         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
		         */
		        init: function (cfg) {
		            this.cfg = this.cfg.extend(cfg);
		        },
	
		        /**
		         * Computes the Password-Based Key Derivation Function 2.
		         *
		         * @param {WordArray|string} password The password.
		         * @param {WordArray|string} salt A salt.
		         *
		         * @return {WordArray} The derived key.
		         *
		         * @example
		         *
		         *     var key = kdf.compute(password, salt);
		         */
		        compute: function (password, salt) {
		            // Shortcut
		            var cfg = this.cfg;
	
		            // Init HMAC
		            var hmac = HMAC.create(cfg.hasher, password);
	
		            // Initial values
		            var derivedKey = WordArray.create();
		            var blockIndex = WordArray.create([0x00000001]);
	
		            // Shortcuts
		            var derivedKeyWords = derivedKey.words;
		            var blockIndexWords = blockIndex.words;
		            var keySize = cfg.keySize;
		            var iterations = cfg.iterations;
	
		            // Generate key
		            while (derivedKeyWords.length < keySize) {
		                var block = hmac.update(salt).finalize(blockIndex);
		                hmac.reset();
	
		                // Shortcuts
		                var blockWords = block.words;
		                var blockWordsLength = blockWords.length;
	
		                // Iterations
		                var intermediate = block;
		                for (var i = 1; i < iterations; i++) {
		                    intermediate = hmac.finalize(intermediate);
		                    hmac.reset();
	
		                    // Shortcut
		                    var intermediateWords = intermediate.words;
	
		                    // XOR intermediate with block
		                    for (var j = 0; j < blockWordsLength; j++) {
		                        blockWords[j] ^= intermediateWords[j];
		                    }
		                }
	
		                derivedKey.concat(block);
		                blockIndexWords[0]++;
		            }
		            derivedKey.sigBytes = keySize * 4;
	
		            return derivedKey;
		        }
		    });
	
		    /**
		     * Computes the Password-Based Key Derivation Function 2.
		     *
		     * @param {WordArray|string} password The password.
		     * @param {WordArray|string} salt A salt.
		     * @param {Object} cfg (Optional) The configuration options to use for this computation.
		     *
		     * @return {WordArray} The derived key.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var key = CryptoJS.PBKDF2(password, salt);
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
		     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
		     */
		    C.PBKDF2 = function (password, salt, cfg) {
		        return PBKDF2.create(cfg).compute(password, salt);
		    };
		}());
	
	
		return CryptoJS.PBKDF2;
	
	}));

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(80), __webpack_require__(81), __webpack_require__(64), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm.
		     *
		     * This is a legacy version that neglected to convert the key to little-endian.
		     * This error doesn't affect the cipher's security,
		     * but it does affect its compatibility with other implementations.
		     */
		    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
		     */
		    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
		}());
	
	
		return CryptoJS.RabbitLegacy;
	
	}));

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(80), __webpack_require__(81), __webpack_require__(64), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    // Reusable objects
		    var S  = [];
		    var C_ = [];
		    var G  = [];
	
		    /**
		     * Rabbit stream cipher algorithm
		     */
		    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var K = this._key.words;
		            var iv = this.cfg.iv;
	
		            // Swap endian
		            for (var i = 0; i < 4; i++) {
		                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
		                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
		            }
	
		            // Generate initial state values
		            var X = this._X = [
		                K[0], (K[3] << 16) | (K[2] >>> 16),
		                K[1], (K[0] << 16) | (K[3] >>> 16),
		                K[2], (K[1] << 16) | (K[0] >>> 16),
		                K[3], (K[2] << 16) | (K[1] >>> 16)
		            ];
	
		            // Generate initial counter values
		            var C = this._C = [
		                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
		                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
		                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
		                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
		            ];
	
		            // Carry bit
		            this._b = 0;
	
		            // Iterate the system four times
		            for (var i = 0; i < 4; i++) {
		                nextState.call(this);
		            }
	
		            // Modify the counters
		            for (var i = 0; i < 8; i++) {
		                C[i] ^= X[(i + 4) & 7];
		            }
	
		            // IV setup
		            if (iv) {
		                // Shortcuts
		                var IV = iv.words;
		                var IV_0 = IV[0];
		                var IV_1 = IV[1];
	
		                // Generate four subvectors
		                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
		                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
		                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
		                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);
	
		                // Modify counter values
		                C[0] ^= i0;
		                C[1] ^= i1;
		                C[2] ^= i2;
		                C[3] ^= i3;
		                C[4] ^= i0;
		                C[5] ^= i1;
		                C[6] ^= i2;
		                C[7] ^= i3;
	
		                // Iterate the system four times
		                for (var i = 0; i < 4; i++) {
		                    nextState.call(this);
		                }
		            }
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var X = this._X;
	
		            // Iterate the system
		            nextState.call(this);
	
		            // Generate four keystream words
		            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
		            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
		            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
		            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);
	
		            for (var i = 0; i < 4; i++) {
		                // Swap endian
		                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
		                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);
	
		                // Encrypt
		                M[offset + i] ^= S[i];
		            }
		        },
	
		        blockSize: 128/32,
	
		        ivSize: 64/32
		    });
	
		    function nextState() {
		        // Shortcuts
		        var X = this._X;
		        var C = this._C;
	
		        // Save old counter values
		        for (var i = 0; i < 8; i++) {
		            C_[i] = C[i];
		        }
	
		        // Calculate new counter values
		        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
		        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
		        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
		        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
		        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
		        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
		        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
		        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
		        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;
	
		        // Calculate the g-values
		        for (var i = 0; i < 8; i++) {
		            var gx = X[i] + C[i];
	
		            // Construct high and low argument for squaring
		            var ga = gx & 0xffff;
		            var gb = gx >>> 16;
	
		            // Calculate high and low result of squaring
		            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
		            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);
	
		            // High XOR low
		            G[i] = gh ^ gl;
		        }
	
		        // Calculate new state values
		        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
		        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
		        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
		        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
		        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
		        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
		        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
		        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
		     */
		    C.Rabbit = StreamCipher._createHelper(Rabbit);
		}());
	
	
		return CryptoJS.Rabbit;
	
	}));

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(80), __webpack_require__(81), __webpack_require__(64), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var StreamCipher = C_lib.StreamCipher;
		    var C_algo = C.algo;
	
		    /**
		     * RC4 stream cipher algorithm.
		     */
		    var RC4 = C_algo.RC4 = StreamCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
		            var keySigBytes = key.sigBytes;
	
		            // Init sbox
		            var S = this._S = [];
		            for (var i = 0; i < 256; i++) {
		                S[i] = i;
		            }
	
		            // Key setup
		            for (var i = 0, j = 0; i < 256; i++) {
		                var keyByteIndex = i % keySigBytes;
		                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;
	
		                j = (j + S[i] + keyByte) % 256;
	
		                // Swap
		                var t = S[i];
		                S[i] = S[j];
		                S[j] = t;
		            }
	
		            // Counters
		            this._i = this._j = 0;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            M[offset] ^= generateKeystreamWord.call(this);
		        },
	
		        keySize: 256/32,
	
		        ivSize: 0
		    });
	
		    function generateKeystreamWord() {
		        // Shortcuts
		        var S = this._S;
		        var i = this._i;
		        var j = this._j;
	
		        // Generate keystream word
		        var keystreamWord = 0;
		        for (var n = 0; n < 4; n++) {
		            i = (i + 1) % 256;
		            j = (j + S[i]) % 256;
	
		            // Swap
		            var t = S[i];
		            S[i] = S[j];
		            S[j] = t;
	
		            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
		        }
	
		        // Update counters
		        this._i = i;
		        this._j = j;
	
		        return keystreamWord;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4 = StreamCipher._createHelper(RC4);
	
		    /**
		     * Modified RC4 stream cipher algorithm.
		     */
		    var RC4Drop = C_algo.RC4Drop = RC4.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} drop The number of keystream words to drop. Default 192
		         */
		        cfg: RC4.cfg.extend({
		            drop: 192
		        }),
	
		        _doReset: function () {
		            RC4._doReset.call(this);
	
		            // Drop
		            for (var i = this.cfg.drop; i > 0; i--) {
		                generateKeystreamWord.call(this);
		            }
		        }
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
		     */
		    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
		}());
	
	
		return CryptoJS.RC4;
	
	}));

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		/** @preserve
		(c) 2012 by Cédric Mesnil. All rights reserved.
	
		Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
		    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
		    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
		THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		*/
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Constants table
		    var _zl = WordArray.create([
		        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
		        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
		        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
		        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
		        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
		    var _zr = WordArray.create([
		        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
		        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
		        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
		        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
		        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
		    var _sl = WordArray.create([
		         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
		        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
		        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
		          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
		        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
		    var _sr = WordArray.create([
		        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
		        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
		        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
		        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
		        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);
	
		    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
		    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);
	
		    /**
		     * RIPEMD160 hash algorithm.
		     */
		    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
		        _doReset: function () {
		            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
		        },
	
		        _doProcessBlock: function (M, offset) {
	
		            // Swap endian
		            for (var i = 0; i < 16; i++) {
		                // Shortcuts
		                var offset_i = offset + i;
		                var M_offset_i = M[offset_i];
	
		                // Swap
		                M[offset_i] = (
		                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
		                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
		                );
		            }
		            // Shortcut
		            var H  = this._hash.words;
		            var hl = _hl.words;
		            var hr = _hr.words;
		            var zl = _zl.words;
		            var zr = _zr.words;
		            var sl = _sl.words;
		            var sr = _sr.words;
	
		            // Working variables
		            var al, bl, cl, dl, el;
		            var ar, br, cr, dr, er;
	
		            ar = al = H[0];
		            br = bl = H[1];
		            cr = cl = H[2];
		            dr = dl = H[3];
		            er = el = H[4];
		            // Computation
		            var t;
		            for (var i = 0; i < 80; i += 1) {
		                t = (al +  M[offset+zl[i]])|0;
		                if (i<16){
			            t +=  f1(bl,cl,dl) + hl[0];
		                } else if (i<32) {
			            t +=  f2(bl,cl,dl) + hl[1];
		                } else if (i<48) {
			            t +=  f3(bl,cl,dl) + hl[2];
		                } else if (i<64) {
			            t +=  f4(bl,cl,dl) + hl[3];
		                } else {// if (i<80) {
			            t +=  f5(bl,cl,dl) + hl[4];
		                }
		                t = t|0;
		                t =  rotl(t,sl[i]);
		                t = (t+el)|0;
		                al = el;
		                el = dl;
		                dl = rotl(cl, 10);
		                cl = bl;
		                bl = t;
	
		                t = (ar + M[offset+zr[i]])|0;
		                if (i<16){
			            t +=  f5(br,cr,dr) + hr[0];
		                } else if (i<32) {
			            t +=  f4(br,cr,dr) + hr[1];
		                } else if (i<48) {
			            t +=  f3(br,cr,dr) + hr[2];
		                } else if (i<64) {
			            t +=  f2(br,cr,dr) + hr[3];
		                } else {// if (i<80) {
			            t +=  f1(br,cr,dr) + hr[4];
		                }
		                t = t|0;
		                t =  rotl(t,sr[i]) ;
		                t = (t+er)|0;
		                ar = er;
		                er = dr;
		                dr = rotl(cr, 10);
		                cr = br;
		                br = t;
		            }
		            // Intermediate hash value
		            t    = (H[1] + cl + dr)|0;
		            H[1] = (H[2] + dl + er)|0;
		            H[2] = (H[3] + el + ar)|0;
		            H[3] = (H[4] + al + br)|0;
		            H[4] = (H[0] + bl + cr)|0;
		            H[0] =  t;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
		                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
		                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
		            );
		            data.sigBytes = (dataWords.length + 1) * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var hash = this._hash;
		            var H = hash.words;
	
		            // Swap endian
		            for (var i = 0; i < 5; i++) {
		                // Shortcut
		                var H_i = H[i];
	
		                // Swap
		                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
		                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
		            }
	
		            // Return final computed hash
		            return hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
	
		    function f1(x, y, z) {
		        return ((x) ^ (y) ^ (z));
	
		    }
	
		    function f2(x, y, z) {
		        return (((x)&(y)) | ((~x)&(z)));
		    }
	
		    function f3(x, y, z) {
		        return (((x) | (~(y))) ^ (z));
		    }
	
		    function f4(x, y, z) {
		        return (((x) & (z)) | ((y)&(~(z))));
		    }
	
		    function f5(x, y, z) {
		        return ((x) ^ ((y) |(~(z))));
	
		    }
	
		    function rotl(x,n) {
		        return (x<<n) | (x>>>(32-n));
		    }
	
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.RIPEMD160('message');
		     *     var hash = CryptoJS.RIPEMD160(wordArray);
		     */
		    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
		     */
		    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
		}(Math));
	
	
		return CryptoJS.RIPEMD160;
	
	}));

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(855));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./sha256"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_algo = C.algo;
		    var SHA256 = C_algo.SHA256;
	
		    /**
		     * SHA-224 hash algorithm.
		     */
		    var SHA224 = C_algo.SHA224 = SHA256.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init([
		                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
		                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA256._doFinalize.call(this);
	
		            hash.sigBytes -= 4;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA224('message');
		     *     var hash = CryptoJS.SHA224(wordArray);
		     */
		    C.SHA224 = SHA256._createHelper(SHA224);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA224(message, key);
		     */
		    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
		}());
	
	
		return CryptoJS.SHA224;
	
	}));

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(115));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var C_algo = C.algo;
	
		    // Constants tables
		    var RHO_OFFSETS = [];
		    var PI_INDEXES  = [];
		    var ROUND_CONSTANTS = [];
	
		    // Compute Constants
		    (function () {
		        // Compute rho offset constants
		        var x = 1, y = 0;
		        for (var t = 0; t < 24; t++) {
		            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;
	
		            var newX = y % 5;
		            var newY = (2 * x + 3 * y) % 5;
		            x = newX;
		            y = newY;
		        }
	
		        // Compute pi index constants
		        for (var x = 0; x < 5; x++) {
		            for (var y = 0; y < 5; y++) {
		                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
		            }
		        }
	
		        // Compute round constants
		        var LFSR = 0x01;
		        for (var i = 0; i < 24; i++) {
		            var roundConstantMsw = 0;
		            var roundConstantLsw = 0;
	
		            for (var j = 0; j < 7; j++) {
		                if (LFSR & 0x01) {
		                    var bitPosition = (1 << j) - 1;
		                    if (bitPosition < 32) {
		                        roundConstantLsw ^= 1 << bitPosition;
		                    } else /* if (bitPosition >= 32) */ {
		                        roundConstantMsw ^= 1 << (bitPosition - 32);
		                    }
		                }
	
		                // Compute next LFSR
		                if (LFSR & 0x80) {
		                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
		                    LFSR = (LFSR << 1) ^ 0x71;
		                } else {
		                    LFSR <<= 1;
		                }
		            }
	
		            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
		        }
		    }());
	
		    // Reusable objects for temporary values
		    var T = [];
		    (function () {
		        for (var i = 0; i < 25; i++) {
		            T[i] = X64Word.create();
		        }
		    }());
	
		    /**
		     * SHA-3 hash algorithm.
		     */
		    var SHA3 = C_algo.SHA3 = Hasher.extend({
		        /**
		         * Configuration options.
		         *
		         * @property {number} outputLength
		         *   The desired number of bits in the output hash.
		         *   Only values permitted are: 224, 256, 384, 512.
		         *   Default: 512
		         */
		        cfg: Hasher.cfg.extend({
		            outputLength: 512
		        }),
	
		        _doReset: function () {
		            var state = this._state = []
		            for (var i = 0; i < 25; i++) {
		                state[i] = new X64Word.init();
		            }
	
		            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcuts
		            var state = this._state;
		            var nBlockSizeLanes = this.blockSize / 2;
	
		            // Absorb
		            for (var i = 0; i < nBlockSizeLanes; i++) {
		                // Shortcuts
		                var M2i  = M[offset + 2 * i];
		                var M2i1 = M[offset + 2 * i + 1];
	
		                // Swap endian
		                M2i = (
		                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
		                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
		                );
		                M2i1 = (
		                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
		                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
		                );
	
		                // Absorb message into state
		                var lane = state[i];
		                lane.high ^= M2i1;
		                lane.low  ^= M2i;
		            }
	
		            // Rounds
		            for (var round = 0; round < 24; round++) {
		                // Theta
		                for (var x = 0; x < 5; x++) {
		                    // Mix column lanes
		                    var tMsw = 0, tLsw = 0;
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        tMsw ^= lane.high;
		                        tLsw ^= lane.low;
		                    }
	
		                    // Temporary values
		                    var Tx = T[x];
		                    Tx.high = tMsw;
		                    Tx.low  = tLsw;
		                }
		                for (var x = 0; x < 5; x++) {
		                    // Shortcuts
		                    var Tx4 = T[(x + 4) % 5];
		                    var Tx1 = T[(x + 1) % 5];
		                    var Tx1Msw = Tx1.high;
		                    var Tx1Lsw = Tx1.low;
	
		                    // Mix surrounding columns
		                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
		                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
		                    for (var y = 0; y < 5; y++) {
		                        var lane = state[x + 5 * y];
		                        lane.high ^= tMsw;
		                        lane.low  ^= tLsw;
		                    }
		                }
	
		                // Rho Pi
		                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
		                    // Shortcuts
		                    var lane = state[laneIndex];
		                    var laneMsw = lane.high;
		                    var laneLsw = lane.low;
		                    var rhoOffset = RHO_OFFSETS[laneIndex];
	
		                    // Rotate lanes
		                    if (rhoOffset < 32) {
		                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
		                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
		                    } else /* if (rhoOffset >= 32) */ {
		                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
		                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
		                    }
	
		                    // Transpose lanes
		                    var TPiLane = T[PI_INDEXES[laneIndex]];
		                    TPiLane.high = tMsw;
		                    TPiLane.low  = tLsw;
		                }
	
		                // Rho pi at x = y = 0
		                var T0 = T[0];
		                var state0 = state[0];
		                T0.high = state0.high;
		                T0.low  = state0.low;
	
		                // Chi
		                for (var x = 0; x < 5; x++) {
		                    for (var y = 0; y < 5; y++) {
		                        // Shortcuts
		                        var laneIndex = x + 5 * y;
		                        var lane = state[laneIndex];
		                        var TLane = T[laneIndex];
		                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
		                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];
	
		                        // Mix rows
		                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
		                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
		                    }
		                }
	
		                // Iota
		                var lane = state[0];
		                var roundConstant = ROUND_CONSTANTS[round];
		                lane.high ^= roundConstant.high;
		                lane.low  ^= roundConstant.low;;
		            }
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
		            var blockSizeBits = this.blockSize * 32;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
		            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Shortcuts
		            var state = this._state;
		            var outputLengthBytes = this.cfg.outputLength / 8;
		            var outputLengthLanes = outputLengthBytes / 8;
	
		            // Squeeze
		            var hashWords = [];
		            for (var i = 0; i < outputLengthLanes; i++) {
		                // Shortcuts
		                var lane = state[i];
		                var laneMsw = lane.high;
		                var laneLsw = lane.low;
	
		                // Swap endian
		                laneMsw = (
		                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
		                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
		                );
		                laneLsw = (
		                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
		                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
		                );
	
		                // Squeeze state to retrieve hash
		                hashWords.push(laneLsw);
		                hashWords.push(laneMsw);
		            }
	
		            // Return final computed hash
		            return new WordArray.init(hashWords, outputLengthBytes);
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
	
		            var state = clone._state = this._state.slice(0);
		            for (var i = 0; i < 25; i++) {
		                state[i] = state[i].clone();
		            }
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA3('message');
		     *     var hash = CryptoJS.SHA3(wordArray);
		     */
		    C.SHA3 = Hasher._createHelper(SHA3);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA3(message, key);
		     */
		    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
		}(Math));
	
	
		return CryptoJS.SHA3;
	
	}));

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(115), __webpack_require__(856));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./x64-core", "./sha512"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_x64 = C.x64;
		    var X64Word = C_x64.Word;
		    var X64WordArray = C_x64.WordArray;
		    var C_algo = C.algo;
		    var SHA512 = C_algo.SHA512;
	
		    /**
		     * SHA-384 hash algorithm.
		     */
		    var SHA384 = C_algo.SHA384 = SHA512.extend({
		        _doReset: function () {
		            this._hash = new X64WordArray.init([
		                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
		                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
		                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
		                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
		            ]);
		        },
	
		        _doFinalize: function () {
		            var hash = SHA512._doFinalize.call(this);
	
		            hash.sigBytes -= 16;
	
		            return hash;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA384('message');
		     *     var hash = CryptoJS.SHA384(wordArray);
		     */
		    C.SHA384 = SHA512._createHelper(SHA384);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA384(message, key);
		     */
		    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
		}());
	
	
		return CryptoJS.SHA384;
	
	}));

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory, undef) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(21), __webpack_require__(80), __webpack_require__(81), __webpack_require__(64), __webpack_require__(33));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var BlockCipher = C_lib.BlockCipher;
		    var C_algo = C.algo;
	
		    // Permuted Choice 1 constants
		    var PC1 = [
		        57, 49, 41, 33, 25, 17, 9,  1,
		        58, 50, 42, 34, 26, 18, 10, 2,
		        59, 51, 43, 35, 27, 19, 11, 3,
		        60, 52, 44, 36, 63, 55, 47, 39,
		        31, 23, 15, 7,  62, 54, 46, 38,
		        30, 22, 14, 6,  61, 53, 45, 37,
		        29, 21, 13, 5,  28, 20, 12, 4
		    ];
	
		    // Permuted Choice 2 constants
		    var PC2 = [
		        14, 17, 11, 24, 1,  5,
		        3,  28, 15, 6,  21, 10,
		        23, 19, 12, 4,  26, 8,
		        16, 7,  27, 20, 13, 2,
		        41, 52, 31, 37, 47, 55,
		        30, 40, 51, 45, 33, 48,
		        44, 49, 39, 56, 34, 53,
		        46, 42, 50, 36, 29, 32
		    ];
	
		    // Cumulative bit shift constants
		    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];
	
		    // SBOXes and round permutation constants
		    var SBOX_P = [
		        {
		            0x0: 0x808200,
		            0x10000000: 0x8000,
		            0x20000000: 0x808002,
		            0x30000000: 0x2,
		            0x40000000: 0x200,
		            0x50000000: 0x808202,
		            0x60000000: 0x800202,
		            0x70000000: 0x800000,
		            0x80000000: 0x202,
		            0x90000000: 0x800200,
		            0xa0000000: 0x8200,
		            0xb0000000: 0x808000,
		            0xc0000000: 0x8002,
		            0xd0000000: 0x800002,
		            0xe0000000: 0x0,
		            0xf0000000: 0x8202,
		            0x8000000: 0x0,
		            0x18000000: 0x808202,
		            0x28000000: 0x8202,
		            0x38000000: 0x8000,
		            0x48000000: 0x808200,
		            0x58000000: 0x200,
		            0x68000000: 0x808002,
		            0x78000000: 0x2,
		            0x88000000: 0x800200,
		            0x98000000: 0x8200,
		            0xa8000000: 0x808000,
		            0xb8000000: 0x800202,
		            0xc8000000: 0x800002,
		            0xd8000000: 0x8002,
		            0xe8000000: 0x202,
		            0xf8000000: 0x800000,
		            0x1: 0x8000,
		            0x10000001: 0x2,
		            0x20000001: 0x808200,
		            0x30000001: 0x800000,
		            0x40000001: 0x808002,
		            0x50000001: 0x8200,
		            0x60000001: 0x200,
		            0x70000001: 0x800202,
		            0x80000001: 0x808202,
		            0x90000001: 0x808000,
		            0xa0000001: 0x800002,
		            0xb0000001: 0x8202,
		            0xc0000001: 0x202,
		            0xd0000001: 0x800200,
		            0xe0000001: 0x8002,
		            0xf0000001: 0x0,
		            0x8000001: 0x808202,
		            0x18000001: 0x808000,
		            0x28000001: 0x800000,
		            0x38000001: 0x200,
		            0x48000001: 0x8000,
		            0x58000001: 0x800002,
		            0x68000001: 0x2,
		            0x78000001: 0x8202,
		            0x88000001: 0x8002,
		            0x98000001: 0x800202,
		            0xa8000001: 0x202,
		            0xb8000001: 0x808200,
		            0xc8000001: 0x800200,
		            0xd8000001: 0x0,
		            0xe8000001: 0x8200,
		            0xf8000001: 0x808002
		        },
		        {
		            0x0: 0x40084010,
		            0x1000000: 0x4000,
		            0x2000000: 0x80000,
		            0x3000000: 0x40080010,
		            0x4000000: 0x40000010,
		            0x5000000: 0x40084000,
		            0x6000000: 0x40004000,
		            0x7000000: 0x10,
		            0x8000000: 0x84000,
		            0x9000000: 0x40004010,
		            0xa000000: 0x40000000,
		            0xb000000: 0x84010,
		            0xc000000: 0x80010,
		            0xd000000: 0x0,
		            0xe000000: 0x4010,
		            0xf000000: 0x40080000,
		            0x800000: 0x40004000,
		            0x1800000: 0x84010,
		            0x2800000: 0x10,
		            0x3800000: 0x40004010,
		            0x4800000: 0x40084010,
		            0x5800000: 0x40000000,
		            0x6800000: 0x80000,
		            0x7800000: 0x40080010,
		            0x8800000: 0x80010,
		            0x9800000: 0x0,
		            0xa800000: 0x4000,
		            0xb800000: 0x40080000,
		            0xc800000: 0x40000010,
		            0xd800000: 0x84000,
		            0xe800000: 0x40084000,
		            0xf800000: 0x4010,
		            0x10000000: 0x0,
		            0x11000000: 0x40080010,
		            0x12000000: 0x40004010,
		            0x13000000: 0x40084000,
		            0x14000000: 0x40080000,
		            0x15000000: 0x10,
		            0x16000000: 0x84010,
		            0x17000000: 0x4000,
		            0x18000000: 0x4010,
		            0x19000000: 0x80000,
		            0x1a000000: 0x80010,
		            0x1b000000: 0x40000010,
		            0x1c000000: 0x84000,
		            0x1d000000: 0x40004000,
		            0x1e000000: 0x40000000,
		            0x1f000000: 0x40084010,
		            0x10800000: 0x84010,
		            0x11800000: 0x80000,
		            0x12800000: 0x40080000,
		            0x13800000: 0x4000,
		            0x14800000: 0x40004000,
		            0x15800000: 0x40084010,
		            0x16800000: 0x10,
		            0x17800000: 0x40000000,
		            0x18800000: 0x40084000,
		            0x19800000: 0x40000010,
		            0x1a800000: 0x40004010,
		            0x1b800000: 0x80010,
		            0x1c800000: 0x0,
		            0x1d800000: 0x4010,
		            0x1e800000: 0x40080010,
		            0x1f800000: 0x84000
		        },
		        {
		            0x0: 0x104,
		            0x100000: 0x0,
		            0x200000: 0x4000100,
		            0x300000: 0x10104,
		            0x400000: 0x10004,
		            0x500000: 0x4000004,
		            0x600000: 0x4010104,
		            0x700000: 0x4010000,
		            0x800000: 0x4000000,
		            0x900000: 0x4010100,
		            0xa00000: 0x10100,
		            0xb00000: 0x4010004,
		            0xc00000: 0x4000104,
		            0xd00000: 0x10000,
		            0xe00000: 0x4,
		            0xf00000: 0x100,
		            0x80000: 0x4010100,
		            0x180000: 0x4010004,
		            0x280000: 0x0,
		            0x380000: 0x4000100,
		            0x480000: 0x4000004,
		            0x580000: 0x10000,
		            0x680000: 0x10004,
		            0x780000: 0x104,
		            0x880000: 0x4,
		            0x980000: 0x100,
		            0xa80000: 0x4010000,
		            0xb80000: 0x10104,
		            0xc80000: 0x10100,
		            0xd80000: 0x4000104,
		            0xe80000: 0x4010104,
		            0xf80000: 0x4000000,
		            0x1000000: 0x4010100,
		            0x1100000: 0x10004,
		            0x1200000: 0x10000,
		            0x1300000: 0x4000100,
		            0x1400000: 0x100,
		            0x1500000: 0x4010104,
		            0x1600000: 0x4000004,
		            0x1700000: 0x0,
		            0x1800000: 0x4000104,
		            0x1900000: 0x4000000,
		            0x1a00000: 0x4,
		            0x1b00000: 0x10100,
		            0x1c00000: 0x4010000,
		            0x1d00000: 0x104,
		            0x1e00000: 0x10104,
		            0x1f00000: 0x4010004,
		            0x1080000: 0x4000000,
		            0x1180000: 0x104,
		            0x1280000: 0x4010100,
		            0x1380000: 0x0,
		            0x1480000: 0x10004,
		            0x1580000: 0x4000100,
		            0x1680000: 0x100,
		            0x1780000: 0x4010004,
		            0x1880000: 0x10000,
		            0x1980000: 0x4010104,
		            0x1a80000: 0x10104,
		            0x1b80000: 0x4000004,
		            0x1c80000: 0x4000104,
		            0x1d80000: 0x4010000,
		            0x1e80000: 0x4,
		            0x1f80000: 0x10100
		        },
		        {
		            0x0: 0x80401000,
		            0x10000: 0x80001040,
		            0x20000: 0x401040,
		            0x30000: 0x80400000,
		            0x40000: 0x0,
		            0x50000: 0x401000,
		            0x60000: 0x80000040,
		            0x70000: 0x400040,
		            0x80000: 0x80000000,
		            0x90000: 0x400000,
		            0xa0000: 0x40,
		            0xb0000: 0x80001000,
		            0xc0000: 0x80400040,
		            0xd0000: 0x1040,
		            0xe0000: 0x1000,
		            0xf0000: 0x80401040,
		            0x8000: 0x80001040,
		            0x18000: 0x40,
		            0x28000: 0x80400040,
		            0x38000: 0x80001000,
		            0x48000: 0x401000,
		            0x58000: 0x80401040,
		            0x68000: 0x0,
		            0x78000: 0x80400000,
		            0x88000: 0x1000,
		            0x98000: 0x80401000,
		            0xa8000: 0x400000,
		            0xb8000: 0x1040,
		            0xc8000: 0x80000000,
		            0xd8000: 0x400040,
		            0xe8000: 0x401040,
		            0xf8000: 0x80000040,
		            0x100000: 0x400040,
		            0x110000: 0x401000,
		            0x120000: 0x80000040,
		            0x130000: 0x0,
		            0x140000: 0x1040,
		            0x150000: 0x80400040,
		            0x160000: 0x80401000,
		            0x170000: 0x80001040,
		            0x180000: 0x80401040,
		            0x190000: 0x80000000,
		            0x1a0000: 0x80400000,
		            0x1b0000: 0x401040,
		            0x1c0000: 0x80001000,
		            0x1d0000: 0x400000,
		            0x1e0000: 0x40,
		            0x1f0000: 0x1000,
		            0x108000: 0x80400000,
		            0x118000: 0x80401040,
		            0x128000: 0x0,
		            0x138000: 0x401000,
		            0x148000: 0x400040,
		            0x158000: 0x80000000,
		            0x168000: 0x80001040,
		            0x178000: 0x40,
		            0x188000: 0x80000040,
		            0x198000: 0x1000,
		            0x1a8000: 0x80001000,
		            0x1b8000: 0x80400040,
		            0x1c8000: 0x1040,
		            0x1d8000: 0x80401000,
		            0x1e8000: 0x400000,
		            0x1f8000: 0x401040
		        },
		        {
		            0x0: 0x80,
		            0x1000: 0x1040000,
		            0x2000: 0x40000,
		            0x3000: 0x20000000,
		            0x4000: 0x20040080,
		            0x5000: 0x1000080,
		            0x6000: 0x21000080,
		            0x7000: 0x40080,
		            0x8000: 0x1000000,
		            0x9000: 0x20040000,
		            0xa000: 0x20000080,
		            0xb000: 0x21040080,
		            0xc000: 0x21040000,
		            0xd000: 0x0,
		            0xe000: 0x1040080,
		            0xf000: 0x21000000,
		            0x800: 0x1040080,
		            0x1800: 0x21000080,
		            0x2800: 0x80,
		            0x3800: 0x1040000,
		            0x4800: 0x40000,
		            0x5800: 0x20040080,
		            0x6800: 0x21040000,
		            0x7800: 0x20000000,
		            0x8800: 0x20040000,
		            0x9800: 0x0,
		            0xa800: 0x21040080,
		            0xb800: 0x1000080,
		            0xc800: 0x20000080,
		            0xd800: 0x21000000,
		            0xe800: 0x1000000,
		            0xf800: 0x40080,
		            0x10000: 0x40000,
		            0x11000: 0x80,
		            0x12000: 0x20000000,
		            0x13000: 0x21000080,
		            0x14000: 0x1000080,
		            0x15000: 0x21040000,
		            0x16000: 0x20040080,
		            0x17000: 0x1000000,
		            0x18000: 0x21040080,
		            0x19000: 0x21000000,
		            0x1a000: 0x1040000,
		            0x1b000: 0x20040000,
		            0x1c000: 0x40080,
		            0x1d000: 0x20000080,
		            0x1e000: 0x0,
		            0x1f000: 0x1040080,
		            0x10800: 0x21000080,
		            0x11800: 0x1000000,
		            0x12800: 0x1040000,
		            0x13800: 0x20040080,
		            0x14800: 0x20000000,
		            0x15800: 0x1040080,
		            0x16800: 0x80,
		            0x17800: 0x21040000,
		            0x18800: 0x40080,
		            0x19800: 0x21040080,
		            0x1a800: 0x0,
		            0x1b800: 0x21000000,
		            0x1c800: 0x1000080,
		            0x1d800: 0x40000,
		            0x1e800: 0x20040000,
		            0x1f800: 0x20000080
		        },
		        {
		            0x0: 0x10000008,
		            0x100: 0x2000,
		            0x200: 0x10200000,
		            0x300: 0x10202008,
		            0x400: 0x10002000,
		            0x500: 0x200000,
		            0x600: 0x200008,
		            0x700: 0x10000000,
		            0x800: 0x0,
		            0x900: 0x10002008,
		            0xa00: 0x202000,
		            0xb00: 0x8,
		            0xc00: 0x10200008,
		            0xd00: 0x202008,
		            0xe00: 0x2008,
		            0xf00: 0x10202000,
		            0x80: 0x10200000,
		            0x180: 0x10202008,
		            0x280: 0x8,
		            0x380: 0x200000,
		            0x480: 0x202008,
		            0x580: 0x10000008,
		            0x680: 0x10002000,
		            0x780: 0x2008,
		            0x880: 0x200008,
		            0x980: 0x2000,
		            0xa80: 0x10002008,
		            0xb80: 0x10200008,
		            0xc80: 0x0,
		            0xd80: 0x10202000,
		            0xe80: 0x202000,
		            0xf80: 0x10000000,
		            0x1000: 0x10002000,
		            0x1100: 0x10200008,
		            0x1200: 0x10202008,
		            0x1300: 0x2008,
		            0x1400: 0x200000,
		            0x1500: 0x10000000,
		            0x1600: 0x10000008,
		            0x1700: 0x202000,
		            0x1800: 0x202008,
		            0x1900: 0x0,
		            0x1a00: 0x8,
		            0x1b00: 0x10200000,
		            0x1c00: 0x2000,
		            0x1d00: 0x10002008,
		            0x1e00: 0x10202000,
		            0x1f00: 0x200008,
		            0x1080: 0x8,
		            0x1180: 0x202000,
		            0x1280: 0x200000,
		            0x1380: 0x10000008,
		            0x1480: 0x10002000,
		            0x1580: 0x2008,
		            0x1680: 0x10202008,
		            0x1780: 0x10200000,
		            0x1880: 0x10202000,
		            0x1980: 0x10200008,
		            0x1a80: 0x2000,
		            0x1b80: 0x202008,
		            0x1c80: 0x200008,
		            0x1d80: 0x0,
		            0x1e80: 0x10000000,
		            0x1f80: 0x10002008
		        },
		        {
		            0x0: 0x100000,
		            0x10: 0x2000401,
		            0x20: 0x400,
		            0x30: 0x100401,
		            0x40: 0x2100401,
		            0x50: 0x0,
		            0x60: 0x1,
		            0x70: 0x2100001,
		            0x80: 0x2000400,
		            0x90: 0x100001,
		            0xa0: 0x2000001,
		            0xb0: 0x2100400,
		            0xc0: 0x2100000,
		            0xd0: 0x401,
		            0xe0: 0x100400,
		            0xf0: 0x2000000,
		            0x8: 0x2100001,
		            0x18: 0x0,
		            0x28: 0x2000401,
		            0x38: 0x2100400,
		            0x48: 0x100000,
		            0x58: 0x2000001,
		            0x68: 0x2000000,
		            0x78: 0x401,
		            0x88: 0x100401,
		            0x98: 0x2000400,
		            0xa8: 0x2100000,
		            0xb8: 0x100001,
		            0xc8: 0x400,
		            0xd8: 0x2100401,
		            0xe8: 0x1,
		            0xf8: 0x100400,
		            0x100: 0x2000000,
		            0x110: 0x100000,
		            0x120: 0x2000401,
		            0x130: 0x2100001,
		            0x140: 0x100001,
		            0x150: 0x2000400,
		            0x160: 0x2100400,
		            0x170: 0x100401,
		            0x180: 0x401,
		            0x190: 0x2100401,
		            0x1a0: 0x100400,
		            0x1b0: 0x1,
		            0x1c0: 0x0,
		            0x1d0: 0x2100000,
		            0x1e0: 0x2000001,
		            0x1f0: 0x400,
		            0x108: 0x100400,
		            0x118: 0x2000401,
		            0x128: 0x2100001,
		            0x138: 0x1,
		            0x148: 0x2000000,
		            0x158: 0x100000,
		            0x168: 0x401,
		            0x178: 0x2100400,
		            0x188: 0x2000001,
		            0x198: 0x2100000,
		            0x1a8: 0x0,
		            0x1b8: 0x2100401,
		            0x1c8: 0x100401,
		            0x1d8: 0x400,
		            0x1e8: 0x2000400,
		            0x1f8: 0x100001
		        },
		        {
		            0x0: 0x8000820,
		            0x1: 0x20000,
		            0x2: 0x8000000,
		            0x3: 0x20,
		            0x4: 0x20020,
		            0x5: 0x8020820,
		            0x6: 0x8020800,
		            0x7: 0x800,
		            0x8: 0x8020000,
		            0x9: 0x8000800,
		            0xa: 0x20800,
		            0xb: 0x8020020,
		            0xc: 0x820,
		            0xd: 0x0,
		            0xe: 0x8000020,
		            0xf: 0x20820,
		            0x80000000: 0x800,
		            0x80000001: 0x8020820,
		            0x80000002: 0x8000820,
		            0x80000003: 0x8000000,
		            0x80000004: 0x8020000,
		            0x80000005: 0x20800,
		            0x80000006: 0x20820,
		            0x80000007: 0x20,
		            0x80000008: 0x8000020,
		            0x80000009: 0x820,
		            0x8000000a: 0x20020,
		            0x8000000b: 0x8020800,
		            0x8000000c: 0x0,
		            0x8000000d: 0x8020020,
		            0x8000000e: 0x8000800,
		            0x8000000f: 0x20000,
		            0x10: 0x20820,
		            0x11: 0x8020800,
		            0x12: 0x20,
		            0x13: 0x800,
		            0x14: 0x8000800,
		            0x15: 0x8000020,
		            0x16: 0x8020020,
		            0x17: 0x20000,
		            0x18: 0x0,
		            0x19: 0x20020,
		            0x1a: 0x8020000,
		            0x1b: 0x8000820,
		            0x1c: 0x8020820,
		            0x1d: 0x20800,
		            0x1e: 0x820,
		            0x1f: 0x8000000,
		            0x80000010: 0x20000,
		            0x80000011: 0x800,
		            0x80000012: 0x8020020,
		            0x80000013: 0x20820,
		            0x80000014: 0x20,
		            0x80000015: 0x8020000,
		            0x80000016: 0x8000000,
		            0x80000017: 0x8000820,
		            0x80000018: 0x8020820,
		            0x80000019: 0x8000020,
		            0x8000001a: 0x8000800,
		            0x8000001b: 0x0,
		            0x8000001c: 0x20800,
		            0x8000001d: 0x820,
		            0x8000001e: 0x20020,
		            0x8000001f: 0x8020800
		        }
		    ];
	
		    // Masks that select the SBOX input
		    var SBOX_MASK = [
		        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
		        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
		    ];
	
		    /**
		     * DES block cipher algorithm.
		     */
		    var DES = C_algo.DES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Select 56 bits according to PC1
		            var keyBits = [];
		            for (var i = 0; i < 56; i++) {
		                var keyBitPos = PC1[i] - 1;
		                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
		            }
	
		            // Assemble 16 subkeys
		            var subKeys = this._subKeys = [];
		            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
		                // Create subkey
		                var subKey = subKeys[nSubKey] = [];
	
		                // Shortcut
		                var bitShift = BIT_SHIFTS[nSubKey];
	
		                // Select 48 bits according to PC2
		                for (var i = 0; i < 24; i++) {
		                    // Select from the left 28 key bits
		                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);
	
		                    // Select from the right 28 key bits
		                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
		                }
	
		                // Since each subkey is applied to an expanded 32-bit input,
		                // the subkey can be broken into 8 values scaled to 32-bits,
		                // which allows the key to be used without expansion
		                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
		                for (var i = 1; i < 7; i++) {
		                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
		                }
		                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
		            }
	
		            // Compute inverse subkeys
		            var invSubKeys = this._invSubKeys = [];
		            for (var i = 0; i < 16; i++) {
		                invSubKeys[i] = subKeys[15 - i];
		            }
		        },
	
		        encryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._subKeys);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._doCryptBlock(M, offset, this._invSubKeys);
		        },
	
		        _doCryptBlock: function (M, offset, subKeys) {
		            // Get input
		            this._lBlock = M[offset];
		            this._rBlock = M[offset + 1];
	
		            // Initial permutation
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeLR.call(this, 1,  0x55555555);
	
		            // Rounds
		            for (var round = 0; round < 16; round++) {
		                // Shortcuts
		                var subKey = subKeys[round];
		                var lBlock = this._lBlock;
		                var rBlock = this._rBlock;
	
		                // Feistel function
		                var f = 0;
		                for (var i = 0; i < 8; i++) {
		                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
		                }
		                this._lBlock = rBlock;
		                this._rBlock = lBlock ^ f;
		            }
	
		            // Undo swap from last round
		            var t = this._lBlock;
		            this._lBlock = this._rBlock;
		            this._rBlock = t;
	
		            // Final permutation
		            exchangeLR.call(this, 1,  0x55555555);
		            exchangeRL.call(this, 8,  0x00ff00ff);
		            exchangeRL.call(this, 2,  0x33333333);
		            exchangeLR.call(this, 16, 0x0000ffff);
		            exchangeLR.call(this, 4,  0x0f0f0f0f);
	
		            // Set output
		            M[offset] = this._lBlock;
		            M[offset + 1] = this._rBlock;
		        },
	
		        keySize: 64/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    // Swap bits across the left and right words
		    function exchangeLR(offset, mask) {
		        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
		        this._rBlock ^= t;
		        this._lBlock ^= t << offset;
		    }
	
		    function exchangeRL(offset, mask) {
		        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
		        this._lBlock ^= t;
		        this._rBlock ^= t << offset;
		    }
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
		     */
		    C.DES = BlockCipher._createHelper(DES);
	
		    /**
		     * Triple-DES block cipher algorithm.
		     */
		    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
		        _doReset: function () {
		            // Shortcuts
		            var key = this._key;
		            var keyWords = key.words;
	
		            // Create DES instances
		            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
		            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
		            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
		        },
	
		        encryptBlock: function (M, offset) {
		            this._des1.encryptBlock(M, offset);
		            this._des2.decryptBlock(M, offset);
		            this._des3.encryptBlock(M, offset);
		        },
	
		        decryptBlock: function (M, offset) {
		            this._des3.decryptBlock(M, offset);
		            this._des2.encryptBlock(M, offset);
		            this._des1.decryptBlock(M, offset);
		        },
	
		        keySize: 192/32,
	
		        ivSize: 64/32,
	
		        blockSize: 64/32
		    });
	
		    /**
		     * Shortcut functions to the cipher's object interface.
		     *
		     * @example
		     *
		     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
		     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
		     */
		    C.TripleDES = BlockCipher._createHelper(TripleDES);
		}());
	
	
		return CryptoJS.TripleDES;
	
	}));

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(159);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObj = __webpack_require__(1235);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Sources cannot be null or undefined');
		}
	
		return Object(val);
	}
	
	function assignKey(to, from, key) {
		var val = from[key];
	
		if (val === undefined || val === null) {
			return;
		}
	
		if (hasOwnProperty.call(to, key)) {
			if (to[key] === undefined || to[key] === null) {
				throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
			}
		}
	
		if (!hasOwnProperty.call(to, key) || !isObj(val)) {
			to[key] = val;
		} else {
			to[key] = assign(Object(to[key]), from[key]);
		}
	}
	
	function assign(to, from) {
		if (to === from) {
			return to;
		}
	
		from = Object(from);
	
		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				assignKey(to, from, key);
			}
		}
	
		if (Object.getOwnPropertySymbols) {
			var symbols = Object.getOwnPropertySymbols(from);
	
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					assignKey(to, from, symbols[i]);
				}
			}
		}
	
		return to;
	}
	
	module.exports = function deepAssign(target) {
		target = toObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			assign(target, arguments[s]);
		}
	
		return target;
	};


/***/ },
/* 1201 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1202 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function extractSingleTouch(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;

/***/ },
/* 1203 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(1203);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(1213);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var createArrayFromMixed = __webpack_require__(1206);
	var getMarkupWrap = __webpack_require__(1208);
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 1209 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 1210 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(1210);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 1212 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(1212);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 1214 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance = window.performance || window.msPerformance || window.webkitPerformance;
	}
	
	module.exports = performance || {};

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var performance = __webpack_require__(1215);
	
	var performanceNow;
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (performance.now) {
	  performanceNow = function performanceNow() {
	    return performance.now();
	  };
	} else {
	  performanceNow = function performanceNow() {
	    return Date.now();
	  };
	}
	
	module.exports = performanceNow;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ },
/* 1218 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1233);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(1234);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(1231);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(1232);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        style = (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = crossFade;
	
	var _isPrefixedValue = __webpack_require__(99);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#search=cross-fade
	var prefixes = ['-webkit-', ''];
	function crossFade(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1221 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filter;
	
	var _isPrefixedValue = __webpack_require__(99);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-filter-function
	var prefixes = ['-webkit-', ''];
	function filter(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/filter\(/g, prefix + 'filter(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1223 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1224 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1225 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines',
	  flexGrow: 'WebkitBoxFlex'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(99);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return value.replace(values, function (grad) {
	        return prefix + grad;
	      });
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = imageSet;
	
	var _isPrefixedValue = __webpack_require__(99);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// http://caniuse.com/#feat=css-image-set
	var prefixes = ['-webkit-', ''];
	function imageSet(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/image-set\(/g, prefix + 'image-set(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1228 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = position;
	function position(property, value) {
	  if (property === 'position' && value === 'sticky') {
	    return ['-webkit-sticky', 'sticky'];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1229 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(1199);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(99);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(861);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1231 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 1232 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(861);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var newStyle = {};
	    var requiredPrefixes = prefixProperties[property];
	    var capitalizedProperty = (0, _capitalizeString2.default)(property);
	    var keys = Object.keys(style);
	    for (var i = 0; i < keys.length; i++) {
	      var styleProperty = keys[i];
	      if (styleProperty === property) {
	        for (var j = 0; j < requiredPrefixes.length; j++) {
	          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
	        }
	      }
	      newStyle[styleProperty] = style[styleProperty];
	    }
	    return newStyle;
	  }
	  return style;
	}
	module.exports = exports['default'];

/***/ },
/* 1234 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 1235 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (x) {
		var type = typeof x;
		return x !== null && (type === 'object' || type === 'function');
	};


/***/ },
/* 1236 */
/***/ function(module, exports) {

	String.prototype.bytes = function () {
	    'use strict';
	
	    var c;
	
	    var bytes = [];
	    var chars = this.toString().split('');
	
	    for (c = 0; c < chars.length; c += 1) {
	
	        var charcode = chars[c].charCodeAt(0);
	
	        var multi = false;
	
	        // Json encoding uses UTF-16 like encod
	        if (charcode > 0xD800) {
	            c += 1;
	
	            multi = true;
	
	            var encoded = [charcode, chars[c].charCodeAt(0)];
	
	            var vh = encoded[0] - 0xD800;
	            var vl = encoded[1] - 0xDC00;
	
	            /* jshint bitwise: false */
	            var v = vh << 10;
	            v |= vl;
	            v += 0x10000;
	            /* jshint bitwise: true */
	
	            charcode = v;
	        }
	
	        var bt = [];
	
	        if (charcode > 0x7F) { // Multibyte UTF-8
	
	            var prefs = [ 0x80, 0xC0, 0xE0, 0xF0, 0xF8, 0xFC ];
	
	            while (true) {
	                /* jshint bitwise: false */
	
	                if (multi === true && charcode === 0 || multi === false && charcode < prefs[0]) {
	                    if (bt.length > 0) {
	                        charcode |= prefs[bt.length];
	                    }
	
	                    bt.unshift(charcode);
	                    break;
	                }
	
	                var b = charcode;
	
	                b &= 0x3F; // get 6 LS bits
	                b |= prefs[0];
	
	                bt.unshift(b);
	
	                charcode >>>= 6;
	
	                /* jshint bitwise: true */
	            }
	
	            while (bt.length) {
	                bytes.push(bt.shift());
	            }
	        }
	        else {
	            bytes.push(charcode);
	        }
	    }
	
	    return bytes;
	};
	
	Array.prototype.parseInt = function (radix) {
	    'use strict';
	
	    radix = radix || 10;
	    return this.map(function (e) {
	        return parseInt(e, radix);
	    });
	};
	
	var Config = function () {
	
	};
	
	Config.prototype.constructor = Config;
	
	Config.prototype.xorBits = function (first, second) {
	    'use strict';
	
	    /* jshint bitwise: false */
	
	    return (parseInt(first, 2) ^ parseInt(second, 2)).toString(2);
	};
	Config.prototype.getVersionInformationString = function (version) {
	    'use strict';
	
	    var generatorPolynominal = '1111100100101';
	
	    var versionString = parseInt(version).toString(2);
	
	    while (versionString.length < 6) {
	        versionString = '0' + versionString;
	    }
	
	    var result = versionString;
	
	    // Turn this into an 18 bit string by padding on the right with 0s:
	    while (result.length < 18) {
	        result += '0';
	    }
	
	    // And remove the 0s from the left side:
	    result = result.replace(/^0+/, '');
	
	    while (result.length >= 13) {
	        var gp = generatorPolynominal;
	
	        // 1. Pad the generator polynomial string on the RIGHT with 0s to make it the same length as the current format string.
	        while (gp.length < result.length) {
	            gp += '0';
	        }
	
	        // 2. XOR the padded generator polynomial string with the current format string.
	        result = this.xorBits(gp, result);
	
	        // 3. Remove 0s from the left side of the result.
	        result = result.replace(/^0+/, '');
	    }
	
	    // If the result were smaller than 10 bits, we would pad it on the LEFT with 0s to make it 10 bits long.
	    while (result.length < 12) {
	        result = '0' + result;
	    }
	
	    return versionString + result;
	};
	Config.prototype.getFormatString = function (correctionLevel, maskPattern) {
	    'use strict';
	
	    correctionLevel = correctionLevel || 'M';
	    maskPattern = maskPattern || 0;
	
	    var generatorPolynominal = '10100110111';
	    var mask = '101010000010010';
	
	    var formatString = '';
	    var result;
	
	    var cl = this.correctionLevels[correctionLevel].toString(2);
	    while (cl.length < 2) {
	        cl = '0' + cl;
	    }
	    formatString += cl;
	
	    var mp = parseInt(maskPattern).toString(2);
	    while (mp.length < 3) {
	        mp = '0' + mp;
	    }
	    formatString += mp;
	
	    result = formatString;
	
	    // To do this, first create a 15-bit string by putting ten 0s to the RIGHT of the format string, like so:
	    while (result.length < 15) {
	        result += '0';
	    }
	
	    // Now remove any 0s from the LEFT side:
	    result = result.replace(/^0+/, '');
	
	    while (result.length >= 11) {
	        var gp = generatorPolynominal;
	
	        // 1. Pad the generator polynomial string on the RIGHT with 0s to make it the same length as the current format string.
	        while (gp.length < result.length) {
	            gp += '0';
	        }
	
	        // 2. XOR the padded generator polynomial string with the current format string.
	        result = this.xorBits(gp, result);
	
	        // 3. Remove 0s from the left side of the result.
	        result = result.replace(/^0+/, '');
	    }
	
	    // If the result were smaller than 10 bits, we would pad it on the LEFT with 0s to make it 10 bits long.
	    while (result.length < 10) {
	        result = '0' + result;
	    }
	
	    // Put the Format and Error Correction Bits Together
	    formatString += result;
	
	    // XOR with the Mask String:
	    formatString = this.xorBits(formatString, mask);
	
	    while (formatString.length < 15) {
	        formatString = '0' + formatString;
	    }
	
	    return formatString;
	};
	Config.prototype.getBlockInfo = function (version, correctionLevel) {
	    'use strict';
	
	    var key = version + '-' + correctionLevel;
	
	    if(!(version !== null && correctionLevel !== null)) {
	        throw new InvalidVersionNumberException();
	    }
	
	    return this.dataSizeInfo[key];
	};
	Config.prototype.getCharacterCountIndicator = function(characterCount, mode, version) {
	    'use strict';
	
	    var characterCountIndicator = characterCount.toString(2);
	    var wordSizes = this.wordSizes[mode];
	    var wordSize = 0;
	
	    for (var key in wordSizes) {
	        if (wordSizes.hasOwnProperty(key)) {
	            var range = key.split('-').parseInt();
	            if (version >= range[0] && version <= range[1]) {
	                wordSize = wordSizes[key];
	                break;
	            }
	        }
	    }
	    while (characterCountIndicator.length < wordSize) {
	        characterCountIndicator = '0' + characterCountIndicator;
	    }
	
	    return characterCountIndicator;
	};
	Config.prototype.getCapacityRange = function(mode, eclevel) {
	    'use strict';
	
	    var maxversion = Object.keys(this.characterCapacities).pop();
	
	    return {
	        min: 1,
	        max: this.characterCapacities[maxversion][eclevel][mode]
	    };
	};
	Config.prototype.correctionLevels = {
	    L: 1,
	    M: 0,
	    Q: 3,
	    H: 2
	};
	Config.prototype.remainderBits = {
	    1: 0,
	    2: 7,
	    3: 7,
	    4: 7,
	    5: 7,
	    6: 7,
	    7: 0,
	    8: 0,
	    9: 0,
	    10: 0,
	    11: 0,
	    12: 0,
	    13: 0,
	    14: 3,
	    15: 3,
	    16: 3,
	    17: 3,
	    18: 3,
	    19: 3,
	    20: 3,
	    21: 4,
	    22: 4,
	    23: 4,
	    24: 4,
	    25: 4,
	    26: 4,
	    27: 4,
	    28: 3,
	    29: 3,
	    30: 3,
	    31: 3,
	    32: 3,
	    33: 3,
	    34: 3,
	    35: 0,
	    36: 0,
	    37: 0,
	    38: 0,
	    39: 0,
	    40: 0
	};
	Config.prototype.dataSizeInfo = {
	    "1-L": [19, 7, 1, 19, 0, 0],
	    "1-M": [16, 10, 1, 16, 0, 0],
	    "1-Q": [13, 13, 1, 13, 0, 0],
	    "1-H": [9, 17, 1, 9, 0, 0],
	    "2-L": [34, 10, 1, 34, 0, 0],
	    "2-M": [28, 16, 1, 28, 0, 0],
	    "2-Q": [22, 22, 1, 22, 0, 0],
	    "2-H": [16, 28, 1, 16, 0, 0],
	    "3-L": [55, 15, 1, 55, 0, 0],
	    "3-M": [44, 26, 1, 44, 0, 0],
	    "3-Q": [34, 18, 2, 17, 0, 0],
	    "3-H": [26, 22, 2, 13, 0, 0],
	    "4-L": [80, 20, 1, 80, 0, 0],
	    "4-M": [64, 18, 2, 32, 0, 0],
	    "4-Q": [48, 26, 2, 24, 0, 0],
	    "4-H": [36, 16, 4, 9, 0, 0],
	    "5-L": [108, 26, 1, 108, 0, 0],
	    "5-M": [86, 24, 2, 43, 0, 0],
	    "5-Q": [62, 18, 2, 15, 2, 16],
	    "5-H": [46, 22, 2, 11, 2, 12],
	    "6-L": [136, 18, 2, 68, 0, 0],
	    "6-M": [108, 16, 4, 27, 0, 0],
	    "6-Q": [76, 24, 4, 19, 0, 0],
	    "6-H": [60, 28, 4, 15, 0, 0],
	    "7-L": [156, 20, 2, 78, 0, 0],
	    "7-M": [124, 18, 4, 31, 0, 0],
	    "7-Q": [88, 18, 2, 14, 4, 15],
	    "7-H": [66, 26, 4, 13, 1, 14],
	    "8-L": [194, 24, 2, 97, 0, 0],
	    "8-M": [154, 22, 2, 38, 2, 39],
	    "8-Q": [110, 22, 4, 18, 2, 19],
	    "8-H": [86, 26, 4, 14, 2, 15],
	    "9-L": [232, 30, 2, 116, 0, 0],
	    "9-M": [182, 22, 3, 36, 2, 37],
	    "9-Q": [132, 20, 4, 16, 4, 17],
	    "9-H": [100, 24, 4, 12, 4, 13],
	    "10-L": [274, 18, 2, 68, 2, 69],
	    "10-M": [216, 26, 4, 43, 1, 44],
	    "10-Q": [154, 24, 6, 19, 2, 20],
	    "10-H": [122, 28, 6, 15, 2, 16],
	    "11-L": [324, 20, 4, 81, 0, 0],
	    "11-M": [254, 30, 1, 50, 4, 51],
	    "11-Q": [180, 28, 4, 22, 4, 23],
	    "11-H": [140, 24, 3, 12, 8, 13],
	    "12-L": [370, 24, 2, 92, 2, 93],
	    "12-M": [290, 22, 6, 36, 2, 37],
	    "12-Q": [206, 26, 4, 20, 6, 21],
	    "12-H": [158, 28, 7, 14, 4, 15],
	    "13-L": [428, 26, 4, 107, 0, 0],
	    "13-M": [334, 22, 8, 37, 1, 38],
	    "13-Q": [244, 24, 8, 20, 4, 21],
	    "13-H": [180, 22, 12, 11, 4, 12],
	    "14-L": [461, 30, 3, 115, 1, 116],
	    "14-M": [365, 24, 4, 40, 5, 41],
	    "14-Q": [261, 20, 11, 16, 5, 17],
	    "14-H": [197, 24, 11, 12, 5, 13],
	    "15-L": [523, 22, 5, 87, 1, 88],
	    "15-M": [415, 24, 5, 41, 5, 42],
	    "15-Q": [295, 30, 5, 24, 7, 25],
	    "15-H": [223, 24, 11, 12, 7, 13],
	    "16-L": [589, 24, 5, 98, 1, 99],
	    "16-M": [453, 28, 7, 45, 3, 46],
	    "16-Q": [325, 24, 15, 19, 2, 20],
	    "16-H": [253, 30, 3, 15, 13, 16],
	    "17-L": [647, 28, 1, 107, 5, 108],
	    "17-M": [507, 28, 10, 46, 1, 47],
	    "17-Q": [367, 28, 1, 22, 15, 23],
	    "17-H": [283, 28, 2, 14, 17, 15],
	    "18-L": [721, 30, 5, 120, 1, 121],
	    "18-M": [563, 26, 9, 43, 4, 44],
	    "18-Q": [397, 28, 17, 22, 1, 23],
	    "18-H": [313, 28, 2, 14, 19, 15],
	    "19-L": [795, 28, 3, 113, 4, 114],
	    "19-M": [627, 26, 3, 44, 11, 45],
	    "19-Q": [445, 26, 17, 21, 4, 22],
	    "19-H": [341, 26, 9, 13, 16, 14],
	    "20-L": [861, 28, 3, 107, 5, 108],
	    "20-M": [669, 26, 3, 41, 13, 42],
	    "20-Q": [485, 30, 15, 24, 5, 25],
	    "20-H": [385, 28, 15, 15, 10, 16],
	    "21-L": [932, 28, 4, 116, 4, 117],
	    "21-M": [714, 26, 17, 42, 0, 0],
	    "21-Q": [512, 28, 17, 22, 6, 23],
	    "21-H": [406, 30, 19, 16, 6, 17],
	    "22-L": [1006, 28, 2, 111, 7, 112],
	    "22-M": [782, 28, 17, 46, 0, 0],
	    "22-Q": [568, 30, 7, 24, 16, 25],
	    "22-H": [442, 24, 34, 13, 0, 0],
	    "23-L": [1094, 30, 4, 121, 5, 122],
	    "23-M": [860, 28, 4, 47, 14, 48],
	    "23-Q": [614, 30, 11, 24, 14, 25],
	    "23-H": [464, 30, 16, 15, 14, 16],
	    "24-L": [1174, 30, 6, 117, 4, 118],
	    "24-M": [914, 28, 6, 45, 14, 46],
	    "24-Q": [664, 30, 11, 24, 16, 25],
	    "24-H": [514, 30, 30, 16, 2, 17],
	    "25-L": [1276, 26, 8, 106, 4, 107],
	    "25-M": [1000, 28, 8, 47, 13, 48],
	    "25-Q": [718, 30, 7, 24, 22, 25],
	    "25-H": [538, 30, 22, 15, 13, 16],
	    "26-L": [1370, 28, 10, 114, 2, 115],
	    "26-M": [1062, 28, 19, 46, 4, 47],
	    "26-Q": [754, 28, 28, 22, 6, 23],
	    "26-H": [596, 30, 33, 16, 4, 17],
	    "27-L": [1468, 30, 8, 122, 4, 123],
	    "27-M": [1128, 28, 22, 45, 3, 46],
	    "27-Q": [808, 30, 8, 23, 26, 24],
	    "27-H": [628, 30, 12, 15, 28, 16],
	    "28-L": [1531, 30, 3, 117, 10, 118],
	    "28-M": [1193, 28, 3, 45, 23, 46],
	    "28-Q": [871, 30, 4, 24, 31, 25],
	    "28-H": [661, 30, 11, 15, 31, 16],
	    "29-L": [1631, 30, 7, 116, 7, 117],
	    "29-M": [1267, 28, 21, 45, 7, 46],
	    "29-Q": [911, 30, 1, 23, 37, 24],
	    "29-H": [701, 30, 19, 15, 26, 16],
	    "30-L": [1735, 30, 5, 115, 10, 116],
	    "30-M": [1373, 28, 19, 47, 10, 48],
	    "30-Q": [985, 30, 15, 24, 25, 25],
	    "30-H": [745, 30, 23, 15, 25, 16],
	    "31-L": [1843, 30, 13, 115, 3, 116],
	    "31-M": [1455, 28, 2, 46, 29, 47],
	    "31-Q": [1033, 30, 42, 24, 1, 25],
	    "31-H": [793, 30, 23, 15, 28, 16],
	    "32-L": [1955, 30, 17, 115, 0, 0],
	    "32-M": [1541, 28, 10, 46, 23, 47],
	    "32-Q": [1115, 30, 10, 24, 35, 25],
	    "32-H": [845, 30, 19, 15, 35, 16],
	    "33-L": [2071, 30, 17, 115, 1, 116],
	    "33-M": [1631, 28, 14, 46, 21, 47],
	    "33-Q": [1171, 30, 29, 24, 19, 25],
	    "33-H": [901, 30, 11, 15, 46, 16],
	    "34-L": [2191, 30, 13, 115, 6, 116],
	    "34-M": [1725, 28, 14, 46, 23, 47],
	    "34-Q": [1231, 30, 44, 24, 7, 25],
	    "34-H": [961, 30, 59, 16, 1, 17],
	    "35-L": [2306, 30, 12, 121, 7, 122],
	    "35-M": [1812, 28, 12, 47, 26, 48],
	    "35-Q": [1286, 30, 39, 24, 14, 25],
	    "35-H": [986, 30, 22, 15, 41, 16],
	    "36-L": [2434, 30, 6, 121, 14, 122],
	    "36-M": [1914, 28, 6, 47, 34, 48],
	    "36-Q": [1354, 30, 46, 24, 10, 25],
	    "36-H": [1054, 30, 2, 15, 64, 16],
	    "37-L": [2566, 30, 17, 122, 4, 123],
	    "37-M": [1992, 28, 29, 46, 14, 47],
	    "37-Q": [1426, 30, 49, 24, 10, 25],
	    "37-H": [1096, 30, 24, 15, 46, 16],
	    "38-L": [2702, 30, 4, 122, 18, 123],
	    "38-M": [2102, 28, 13, 46, 32, 47],
	    "38-Q": [1502, 30, 48, 24, 14, 25],
	    "38-H": [1142, 30, 42, 15, 32, 16],
	    "39-L": [2812, 30, 20, 117, 4, 118],
	    "39-M": [2216, 28, 40, 47, 7, 48],
	    "39-Q": [1582, 30, 43, 24, 22, 25],
	    "39-H": [1222, 30, 10, 15, 67, 16],
	    "40-L": [2956, 30, 19, 118, 6, 119],
	    "40-M": [2334, 28, 18, 47, 31, 48],
	    "40-Q": [1666, 30, 34, 24, 34, 25],
	    "40-H": [1276, 30, 20, 15, 61, 16]
	};
	Config.prototype.dataModeBitStrings = {
	    numeric: '0001',
	    alphanumeric: '0010',
	    binary: '0100',
	    kanji: '1000'
	};
	Config.prototype.wordSizes = {
	    numeric: {
	        '1-9': 10,
	        '10-26': 12,
	        '27-40': 14
	    },
	    alphanumeric: {
	        '1-9': 9,
	        '10-26': 11,
	        '27-40': 13
	    },
	    binary: {
	        '1-9': 8,
	        '10-26': 16,
	        '27-40': 16
	    },
	    kanji: {
	        '1-9': 8,
	        '10-26': 10,
	        '27-40': 12
	    }
	};
	Config.prototype.alignmentPatternLocations = {
	    1: [],
	    2: [6, 18],
	    3: [6, 22],
	    4: [6, 26],
	    5: [6, 30],
	    6: [6, 34],
	    7: [6, 22, 38],
	    8: [6, 24, 42],
	    9: [6, 26, 46],
	    10: [6, 28, 50],
	    11: [6, 30, 54],
	    12: [6, 32, 58],
	    13: [6, 34, 62],
	    14: [6, 26, 46, 66],
	    15: [6, 26, 48, 70],
	    16: [6, 26, 50, 74],
	    17: [6, 30, 54, 78],
	    18: [6, 30, 56, 82],
	    19: [6, 30, 58, 86],
	    20: [6, 34, 62, 90],
	    21: [6, 28, 50, 72, 94],
	    22: [6, 26, 50, 74, 98],
	    23: [6, 30, 54, 78, 102],
	    24: [6, 28, 54, 80, 106],
	    25: [6, 32, 58, 84, 110],
	    26: [6, 30, 58, 86, 114],
	    27: [6, 34, 62, 90, 118],
	    28: [6, 26, 50, 74, 98, 122],
	    29: [6, 30, 54, 78, 102, 126],
	    30: [6, 26, 52, 78, 104, 130],
	    31: [6, 30, 56, 82, 108, 134],
	    32: [6, 34, 60, 86, 112, 138],
	    33: [6, 30, 58, 86, 114, 142],
	    34: [6, 34, 62, 90, 118, 146],
	    35: [6, 30, 54, 78, 102, 126, 150],
	    36: [6, 24, 50, 76, 102, 128, 154],
	    37: [6, 28, 54, 80, 106, 132, 158],
	    38: [6, 32, 58, 84, 110, 136, 162],
	    39: [6, 26, 54, 82, 110, 138, 166],
	    40: [6, 30, 58, 86, 114, 142, 170]
	};
	Config.prototype.characterCapacities = {
	    "1": {
	        "L": {
	            "numeric": 41,
	            "alphanumeric": 25,
	            "binary": 17,
	            "kanji": 10
	        },
	        "M": {
	            "numeric": 34,
	            "alphanumeric": 20,
	            "binary": 14,
	            "kanji": 8
	        },
	        "Q": {
	            "numeric": 27,
	            "alphanumeric": 16,
	            "binary": 11,
	            "kanji": 7
	        },
	        "H": {
	            "numeric": 17,
	            "alphanumeric": 10,
	            "binary": 7,
	            "kanji": 4
	        }
	    },
	    "2": {
	        "L": {
	            "numeric": 77,
	            "alphanumeric": 47,
	            "binary": 32,
	            "kanji": 20
	        },
	        "M": {
	            "numeric": 63,
	            "alphanumeric": 38,
	            "binary": 26,
	            "kanji": 16
	        },
	        "Q": {
	            "numeric": 48,
	            "alphanumeric": 29,
	            "binary": 20,
	            "kanji": 12
	        },
	        "H": {
	            "numeric": 34,
	            "alphanumeric": 20,
	            "binary": 14,
	            "kanji": 8
	        }
	    },
	    "3": {
	        "L": {
	            "numeric": 127,
	            "alphanumeric": 77,
	            "binary": 53,
	            "kanji": 32
	        },
	        "M": {
	            "numeric": 101,
	            "alphanumeric": 61,
	            "binary": 42,
	            "kanji": 26
	        },
	        "Q": {
	            "numeric": 77,
	            "alphanumeric": 47,
	            "binary": 32,
	            "kanji": 20
	        },
	        "H": {
	            "numeric": 58,
	            "alphanumeric": 35,
	            "binary": 24,
	            "kanji": 15
	        }
	    },
	    "4": {
	        "L": {
	            "numeric": 187,
	            "alphanumeric": 114,
	            "binary": 78,
	            "kanji": 48
	        },
	        "M": {
	            "numeric": 149,
	            "alphanumeric": 90,
	            "binary": 62,
	            "kanji": 38
	        },
	        "Q": {
	            "numeric": 111,
	            "alphanumeric": 67,
	            "binary": 46,
	            "kanji": 28
	        },
	        "H": {
	            "numeric": 82,
	            "alphanumeric": 50,
	            "binary": 34,
	            "kanji": 21
	        }
	    },
	    "5": {
	        "L": {
	            "numeric": 255,
	            "alphanumeric": 154,
	            "binary": 106,
	            "kanji": 65
	        },
	        "M": {
	            "numeric": 202,
	            "alphanumeric": 122,
	            "binary": 84,
	            "kanji": 52
	        },
	        "Q": {
	            "numeric": 144,
	            "alphanumeric": 87,
	            "binary": 60,
	            "kanji": 37
	        },
	        "H": {
	            "numeric": 106,
	            "alphanumeric": 64,
	            "binary": 44,
	            "kanji": 27
	        }
	    },
	    "6": {
	        "L": {
	            "numeric": 322,
	            "alphanumeric": 195,
	            "binary": 134,
	            "kanji": 82
	        },
	        "M": {
	            "numeric": 255,
	            "alphanumeric": 154,
	            "binary": 106,
	            "kanji": 65
	        },
	        "Q": {
	            "numeric": 178,
	            "alphanumeric": 108,
	            "binary": 74,
	            "kanji": 45
	        },
	        "H": {
	            "numeric": 139,
	            "alphanumeric": 84,
	            "binary": 58,
	            "kanji": 36
	        }
	    },
	    "7": {
	        "L": {
	            "numeric": 370,
	            "alphanumeric": 224,
	            "binary": 154,
	            "kanji": 95
	        },
	        "M": {
	            "numeric": 293,
	            "alphanumeric": 178,
	            "binary": 122,
	            "kanji": 75
	        },
	        "Q": {
	            "numeric": 207,
	            "alphanumeric": 125,
	            "binary": 86,
	            "kanji": 53
	        },
	        "H": {
	            "numeric": 154,
	            "alphanumeric": 93,
	            "binary": 64,
	            "kanji": 39
	        }
	    },
	    "8": {
	        "L": {
	            "numeric": 461,
	            "alphanumeric": 279,
	            "binary": 192,
	            "kanji": 118
	        },
	        "M": {
	            "numeric": 365,
	            "alphanumeric": 221,
	            "binary": 152,
	            "kanji": 93
	        },
	        "Q": {
	            "numeric": 259,
	            "alphanumeric": 157,
	            "binary": 108,
	            "kanji": 66
	        },
	        "H": {
	            "numeric": 202,
	            "alphanumeric": 122,
	            "binary": 84,
	            "kanji": 52
	        }
	    },
	    "9": {
	        "L": {
	            "numeric": 552,
	            "alphanumeric": 335,
	            "binary": 230,
	            "kanji": 141
	        },
	        "M": {
	            "numeric": 432,
	            "alphanumeric": 262,
	            "binary": 180,
	            "kanji": 111
	        },
	        "Q": {
	            "numeric": 312,
	            "alphanumeric": 189,
	            "binary": 130,
	            "kanji": 80
	        },
	        "H": {
	            "numeric": 235,
	            "alphanumeric": 143,
	            "binary": 98,
	            "kanji": 60
	        }
	    },
	    "10": {
	        "L": {
	            "numeric": 652,
	            "alphanumeric": 395,
	            "binary": 271,
	            "kanji": 167
	        },
	        "M": {
	            "numeric": 513,
	            "alphanumeric": 311,
	            "binary": 213,
	            "kanji": 131
	        },
	        "Q": {
	            "numeric": 364,
	            "alphanumeric": 221,
	            "binary": 151,
	            "kanji": 93
	        },
	        "H": {
	            "numeric": 288,
	            "alphanumeric": 174,
	            "binary": 119,
	            "kanji": 74
	        }
	    },
	    "11": {
	        "L": {
	            "numeric": 772,
	            "alphanumeric": 468,
	            "binary": 321,
	            "kanji": 198
	        },
	        "M": {
	            "numeric": 604,
	            "alphanumeric": 366,
	            "binary": 251,
	            "kanji": 155
	        },
	        "Q": {
	            "numeric": 427,
	            "alphanumeric": 259,
	            "binary": 177,
	            "kanji": 109
	        },
	        "H": {
	            "numeric": 331,
	            "alphanumeric": 200,
	            "binary": 137,
	            "kanji": 85
	        }
	    },
	    "12": {
	        "L": {
	            "numeric": 883,
	            "alphanumeric": 535,
	            "binary": 367,
	            "kanji": 226
	        },
	        "M": {
	            "numeric": 691,
	            "alphanumeric": 419,
	            "binary": 287,
	            "kanji": 177
	        },
	        "Q": {
	            "numeric": 489,
	            "alphanumeric": 296,
	            "binary": 203,
	            "kanji": 125
	        },
	        "H": {
	            "numeric": 374,
	            "alphanumeric": 227,
	            "binary": 155,
	            "kanji": 96
	        }
	    },
	    "13": {
	        "L": {
	            "numeric": 1022,
	            "alphanumeric": 619,
	            "binary": 425,
	            "kanji": 262
	        },
	        "M": {
	            "numeric": 796,
	            "alphanumeric": 483,
	            "binary": 331,
	            "kanji": 204
	        },
	        "Q": {
	            "numeric": 580,
	            "alphanumeric": 352,
	            "binary": 241,
	            "kanji": 149
	        },
	        "H": {
	            "numeric": 427,
	            "alphanumeric": 259,
	            "binary": 177,
	            "kanji": 109
	        }
	    },
	    "14": {
	        "L": {
	            "numeric": 1101,
	            "alphanumeric": 667,
	            "binary": 458,
	            "kanji": 282
	        },
	        "M": {
	            "numeric": 871,
	            "alphanumeric": 528,
	            "binary": 362,
	            "kanji": 223
	        },
	        "Q": {
	            "numeric": 621,
	            "alphanumeric": 376,
	            "binary": 258,
	            "kanji": 159
	        },
	        "H": {
	            "numeric": 468,
	            "alphanumeric": 283,
	            "binary": 194,
	            "kanji": 120
	        }
	    },
	    "15": {
	        "L": {
	            "numeric": 1250,
	            "alphanumeric": 758,
	            "binary": 520,
	            "kanji": 320
	        },
	        "M": {
	            "numeric": 991,
	            "alphanumeric": 600,
	            "binary": 412,
	            "kanji": 254
	        },
	        "Q": {
	            "numeric": 703,
	            "alphanumeric": 426,
	            "binary": 292,
	            "kanji": 180
	        },
	        "H": {
	            "numeric": 530,
	            "alphanumeric": 321,
	            "binary": 220,
	            "kanji": 136
	        }
	    },
	    "16": {
	        "L": {
	            "numeric": 1408,
	            "alphanumeric": 854,
	            "binary": 586,
	            "kanji": 361
	        },
	        "M": {
	            "numeric": 1082,
	            "alphanumeric": 656,
	            "binary": 450,
	            "kanji": 277
	        },
	        "Q": {
	            "numeric": 775,
	            "alphanumeric": 470,
	            "binary": 322,
	            "kanji": 198
	        },
	        "H": {
	            "numeric": 602,
	            "alphanumeric": 365,
	            "binary": 250,
	            "kanji": 154
	        }
	    },
	    "17": {
	        "L": {
	            "numeric": 1548,
	            "alphanumeric": 938,
	            "binary": 644,
	            "kanji": 397
	        },
	        "M": {
	            "numeric": 1212,
	            "alphanumeric": 734,
	            "binary": 504,
	            "kanji": 310
	        },
	        "Q": {
	            "numeric": 876,
	            "alphanumeric": 531,
	            "binary": 364,
	            "kanji": 224
	        },
	        "H": {
	            "numeric": 674,
	            "alphanumeric": 408,
	            "binary": 280,
	            "kanji": 173
	        }
	    },
	    "18": {
	        "L": {
	            "numeric": 1725,
	            "alphanumeric": 1046,
	            "binary": 718,
	            "kanji": 442
	        },
	        "M": {
	            "numeric": 1346,
	            "alphanumeric": 816,
	            "binary": 560,
	            "kanji": 345
	        },
	        "Q": {
	            "numeric": 948,
	            "alphanumeric": 574,
	            "binary": 394,
	            "kanji": 243
	        },
	        "H": {
	            "numeric": 746,
	            "alphanumeric": 452,
	            "binary": 310,
	            "kanji": 191
	        }
	    },
	    "19": {
	        "L": {
	            "numeric": 1903,
	            "alphanumeric": 1153,
	            "binary": 792,
	            "kanji": 488
	        },
	        "M": {
	            "numeric": 1500,
	            "alphanumeric": 909,
	            "binary": 624,
	            "kanji": 384
	        },
	        "Q": {
	            "numeric": 1063,
	            "alphanumeric": 644,
	            "binary": 442,
	            "kanji": 272
	        },
	        "H": {
	            "numeric": 813,
	            "alphanumeric": 493,
	            "binary": 338,
	            "kanji": 208
	        }
	    },
	    "20": {
	        "L": {
	            "numeric": 2061,
	            "alphanumeric": 1249,
	            "binary": 858,
	            "kanji": 528
	        },
	        "M": {
	            "numeric": 1600,
	            "alphanumeric": 970,
	            "binary": 666,
	            "kanji": 410
	        },
	        "Q": {
	            "numeric": 1159,
	            "alphanumeric": 702,
	            "binary": 482,
	            "kanji": 297
	        },
	        "H": {
	            "numeric": 919,
	            "alphanumeric": 557,
	            "binary": 382,
	            "kanji": 235
	        }
	    },
	    "21": {
	        "L": {
	            "numeric": 2232,
	            "alphanumeric": 1352,
	            "binary": 929,
	            "kanji": 572
	        },
	        "M": {
	            "numeric": 1708,
	            "alphanumeric": 1035,
	            "binary": 711,
	            "kanji": 438
	        },
	        "Q": {
	            "numeric": 1224,
	            "alphanumeric": 742,
	            "binary": 509,
	            "kanji": 314
	        },
	        "H": {
	            "numeric": 969,
	            "alphanumeric": 587,
	            "binary": 403,
	            "kanji": 248
	        }
	    },
	    "22": {
	        "L": {
	            "numeric": 2409,
	            "alphanumeric": 1460,
	            "binary": 1003,
	            "kanji": 618
	        },
	        "M": {
	            "numeric": 1872,
	            "alphanumeric": 1134,
	            "binary": 779,
	            "kanji": 480
	        },
	        "Q": {
	            "numeric": 1358,
	            "alphanumeric": 823,
	            "binary": 565,
	            "kanji": 348
	        },
	        "H": {
	            "numeric": 1056,
	            "alphanumeric": 640,
	            "binary": 439,
	            "kanji": 270
	        }
	    },
	    "23": {
	        "L": {
	            "numeric": 2620,
	            "alphanumeric": 1588,
	            "binary": 1091,
	            "kanji": 672
	        },
	        "M": {
	            "numeric": 2059,
	            "alphanumeric": 1248,
	            "binary": 857,
	            "kanji": 528
	        },
	        "Q": {
	            "numeric": 1468,
	            "alphanumeric": 890,
	            "binary": 611,
	            "kanji": 376
	        },
	        "H": {
	            "numeric": 1108,
	            "alphanumeric": 672,
	            "binary": 461,
	            "kanji": 284
	        }
	    },
	    "24": {
	        "L": {
	            "numeric": 2812,
	            "alphanumeric": 1704,
	            "binary": 1171,
	            "kanji": 721
	        },
	        "M": {
	            "numeric": 2188,
	            "alphanumeric": 1326,
	            "binary": 911,
	            "kanji": 561
	        },
	        "Q": {
	            "numeric": 1588,
	            "alphanumeric": 963,
	            "binary": 661,
	            "kanji": 407
	        },
	        "H": {
	            "numeric": 1228,
	            "alphanumeric": 744,
	            "binary": 511,
	            "kanji": 315
	        }
	    },
	    "25": {
	        "L": {
	            "numeric": 3057,
	            "alphanumeric": 1853,
	            "binary": 1273,
	            "kanji": 784
	        },
	        "M": {
	            "numeric": 2395,
	            "alphanumeric": 1451,
	            "binary": 997,
	            "kanji": 614
	        },
	        "Q": {
	            "numeric": 1718,
	            "alphanumeric": 1041,
	            "binary": 715,
	            "kanji": 440
	        },
	        "H": {
	            "numeric": 1286,
	            "alphanumeric": 779,
	            "binary": 535,
	            "kanji": 330
	        }
	    },
	    "26": {
	        "L": {
	            "numeric": 3283,
	            "alphanumeric": 1990,
	            "binary": 1367,
	            "kanji": 842
	        },
	        "M": {
	            "numeric": 2544,
	            "alphanumeric": 1542,
	            "binary": 1059,
	            "kanji": 652
	        },
	        "Q": {
	            "numeric": 1804,
	            "alphanumeric": 1094,
	            "binary": 751,
	            "kanji": 462
	        },
	        "H": {
	            "numeric": 1425,
	            "alphanumeric": 864,
	            "binary": 593,
	            "kanji": 365
	        }
	    },
	    "27": {
	        "L": {
	            "numeric": 3517,
	            "alphanumeric": 2132,
	            "binary": 1465,
	            "kanji": 902
	        },
	        "M": {
	            "numeric": 2701,
	            "alphanumeric": 1637,
	            "binary": 1125,
	            "kanji": 692
	        },
	        "Q": {
	            "numeric": 1933,
	            "alphanumeric": 1172,
	            "binary": 805,
	            "kanji": 496
	        },
	        "H": {
	            "numeric": 1501,
	            "alphanumeric": 910,
	            "binary": 625,
	            "kanji": 385
	        }
	    },
	    "28": {
	        "L": {
	            "numeric": 3669,
	            "alphanumeric": 2223,
	            "binary": 1528,
	            "kanji": 940
	        },
	        "M": {
	            "numeric": 2857,
	            "alphanumeric": 1732,
	            "binary": 1190,
	            "kanji": 732
	        },
	        "Q": {
	            "numeric": 2085,
	            "alphanumeric": 1263,
	            "binary": 868,
	            "kanji": 534
	        },
	        "H": {
	            "numeric": 1581,
	            "alphanumeric": 958,
	            "binary": 658,
	            "kanji": 405
	        }
	    },
	    "29": {
	        "L": {
	            "numeric": 3909,
	            "alphanumeric": 2369,
	            "binary": 1628,
	            "kanji": 1002
	        },
	        "M": {
	            "numeric": 3035,
	            "alphanumeric": 1839,
	            "binary": 1264,
	            "kanji": 778
	        },
	        "Q": {
	            "numeric": 2181,
	            "alphanumeric": 1322,
	            "binary": 908,
	            "kanji": 559
	        },
	        "H": {
	            "numeric": 1677,
	            "alphanumeric": 1016,
	            "binary": 698,
	            "kanji": 430
	        }
	    },
	    "30": {
	        "L": {
	            "numeric": 4158,
	            "alphanumeric": 2520,
	            "binary": 1732,
	            "kanji": 1066
	        },
	        "M": {
	            "numeric": 3289,
	            "alphanumeric": 1994,
	            "binary": 1370,
	            "kanji": 843
	        },
	        "Q": {
	            "numeric": 2358,
	            "alphanumeric": 1429,
	            "binary": 982,
	            "kanji": 604
	        },
	        "H": {
	            "numeric": 1782,
	            "alphanumeric": 1080,
	            "binary": 742,
	            "kanji": 457
	        }
	    },
	    "31": {
	        "L": {
	            "numeric": 4417,
	            "alphanumeric": 2677,
	            "binary": 1840,
	            "kanji": 1132
	        },
	        "M": {
	            "numeric": 3486,
	            "alphanumeric": 2113,
	            "binary": 1452,
	            "kanji": 894
	        },
	        "Q": {
	            "numeric": 2473,
	            "alphanumeric": 1499,
	            "binary": 1030,
	            "kanji": 634
	        },
	        "H": {
	            "numeric": 1897,
	            "alphanumeric": 1150,
	            "binary": 790,
	            "kanji": 486
	        }
	    },
	    "32": {
	        "L": {
	            "numeric": 4686,
	            "alphanumeric": 2840,
	            "binary": 1952,
	            "kanji": 1201
	        },
	        "M": {
	            "numeric": 3693,
	            "alphanumeric": 2238,
	            "binary": 1538,
	            "kanji": 947
	        },
	        "Q": {
	            "numeric": 2670,
	            "alphanumeric": 1618,
	            "binary": 1112,
	            "kanji": 684
	        },
	        "H": {
	            "numeric": 2022,
	            "alphanumeric": 1226,
	            "binary": 842,
	            "kanji": 518
	        }
	    },
	    "33": {
	        "L": {
	            "numeric": 4965,
	            "alphanumeric": 3009,
	            "binary": 2068,
	            "kanji": 1273
	        },
	        "M": {
	            "numeric": 3909,
	            "alphanumeric": 2369,
	            "binary": 1628,
	            "kanji": 1002
	        },
	        "Q": {
	            "numeric": 2805,
	            "alphanumeric": 1700,
	            "binary": 1168,
	            "kanji": 719
	        },
	        "H": {
	            "numeric": 2157,
	            "alphanumeric": 1307,
	            "binary": 898,
	            "kanji": 553
	        }
	    },
	    "34": {
	        "L": {
	            "numeric": 5253,
	            "alphanumeric": 3183,
	            "binary": 2188,
	            "kanji": 1347
	        },
	        "M": {
	            "numeric": 4134,
	            "alphanumeric": 2506,
	            "binary": 1722,
	            "kanji": 1060
	        },
	        "Q": {
	            "numeric": 2949,
	            "alphanumeric": 1787,
	            "binary": 1228,
	            "kanji": 756
	        },
	        "H": {
	            "numeric": 2301,
	            "alphanumeric": 1394,
	            "binary": 958,
	            "kanji": 590
	        }
	    },
	    "35": {
	        "L": {
	            "numeric": 5529,
	            "alphanumeric": 3351,
	            "binary": 2303,
	            "kanji": 1417
	        },
	        "M": {
	            "numeric": 4343,
	            "alphanumeric": 2632,
	            "binary": 1809,
	            "kanji": 1113
	        },
	        "Q": {
	            "numeric": 3081,
	            "alphanumeric": 1867,
	            "binary": 1283,
	            "kanji": 790
	        },
	        "H": {
	            "numeric": 2361,
	            "alphanumeric": 1431,
	            "binary": 983,
	            "kanji": 605
	        }
	    },
	    "36": {
	        "L": {
	            "numeric": 5836,
	            "alphanumeric": 3537,
	            "binary": 2431,
	            "kanji": 1496
	        },
	        "M": {
	            "numeric": 4588,
	            "alphanumeric": 2780,
	            "binary": 1911,
	            "kanji": 1176
	        },
	        "Q": {
	            "numeric": 3244,
	            "alphanumeric": 1966,
	            "binary": 1351,
	            "kanji": 832
	        },
	        "H": {
	            "numeric": 2524,
	            "alphanumeric": 1530,
	            "binary": 1051,
	            "kanji": 647
	        }
	    },
	    "37": {
	        "L": {
	            "numeric": 6153,
	            "alphanumeric": 3729,
	            "binary": 2563,
	            "kanji": 1577
	        },
	        "M": {
	            "numeric": 4775,
	            "alphanumeric": 2894,
	            "binary": 1989,
	            "kanji": 1224
	        },
	        "Q": {
	            "numeric": 3417,
	            "alphanumeric": 2071,
	            "binary": 1423,
	            "kanji": 876
	        },
	        "H": {
	            "numeric": 2625,
	            "alphanumeric": 1591,
	            "binary": 1093,
	            "kanji": 673
	        }
	    },
	    "38": {
	        "L": {
	            "numeric": 6479,
	            "alphanumeric": 3927,
	            "binary": 2699,
	            "kanji": 1661
	        },
	        "M": {
	            "numeric": 5039,
	            "alphanumeric": 3054,
	            "binary": 2099,
	            "kanji": 1292
	        },
	        "Q": {
	            "numeric": 3599,
	            "alphanumeric": 2181,
	            "binary": 1499,
	            "kanji": 923
	        },
	        "H": {
	            "numeric": 2735,
	            "alphanumeric": 1658,
	            "binary": 1139,
	            "kanji": 701
	        }
	    },
	    "39": {
	        "L": {
	            "numeric": 6743,
	            "alphanumeric": 4087,
	            "binary": 2809,
	            "kanji": 1729
	        },
	        "M": {
	            "numeric": 5313,
	            "alphanumeric": 3220,
	            "binary": 2213,
	            "kanji": 1362
	        },
	        "Q": {
	            "numeric": 3791,
	            "alphanumeric": 2298,
	            "binary": 1579,
	            "kanji": 972
	        },
	        "H": {
	            "numeric": 2927,
	            "alphanumeric": 1774,
	            "binary": 1219,
	            "kanji": 750
	        }
	    },
	    "40": {
	        "L": {
	            "numeric": 7089,
	            "alphanumeric": 4296,
	            "binary": 2953,
	            "kanji": 1817
	        },
	        "M": {
	            "numeric": 5596,
	            "alphanumeric": 3391,
	            "binary": 2331,
	            "kanji": 1435
	        },
	        "Q": {
	            "numeric": 3993,
	            "alphanumeric": 2420,
	            "binary": 1663,
	            "kanji": 1024
	        },
	        "H": {
	            "numeric": 3057,
	            "alphanumeric": 1852,
	            "binary": 1273,
	            "kanji": 784
	        }
	    }
	};
	
	/**
	 * Data Analyzer
	 *
	 * @param {number} version
	 * @constructor
	 */
	var DataAnalyzer = function (version) {
	    'use strict';
	
	    this.config = new Config();
	    this.encoder = new DataEncoder();
	    this.version = version || null;
	    this.version = parseInt(this.version);
	    this.version = isNaN(this.version) ? null : parseInt(this.version);
	
	};
	
	DataAnalyzer.prototype.constructor = DataAnalyzer;
	
	DataAnalyzer.prototype.modes = {
	    numeric: function (data, self) {
	        'use strict';
	
	        return data.match(/^\d+$/) !== null;
	    },
	    alphanumeric: function (data, self) {
	        'use strict';
	
	        var chars = data.split('').sort().filter(function (el, i, array) {
	            return (i === array.indexOf(el) && el.length > 0);
	        });
	
	        while (chars.length > 0) {
	            if (typeof self.encoder.alphanumericCharsTable[chars.shift()] === 'undefined') {
	                return false;
	            }
	        }
	
	        return true;
	    },
	    kanji: function (data, self) {
	        'use strict';
	
	        return false; // TODO: do the research and implement
	    }
	};
	
	DataAnalyzer.prototype.analyze = function (data, eclevels) {
	
	    'use strict';
	
	    data = data || '';
	    var data_length = data.bytes().length;
	
	    var defaultEcLevels = ['H', 'Q', 'M', 'L'];
	
	    if(data_length === 0) {
	        throw new EmptyDataException();
	    }
	
	    eclevels = eclevels || defaultEcLevels;
	
	    var result = {
	        data: data,
	        capacity: 0,
	        datalen: data_length,
	        mode: 'binary',
	        eclevel: null,
	        version: 2
	    };
	
	    for (var mode in this.modes) {
	        if (this.modes.hasOwnProperty(mode)) {
	            var matches = this.modes[mode](data, this);
	            if (matches) {
	                result.mode = mode;
	                break;
	            }
	        }
	    }
	
	    var outOfRange = true;
	
	    for(var i = 0; i < eclevels.length; i += 1) {
	        var range = this.config.getCapacityRange(result.mode, eclevels[i]);
	        if(data_length >= range.min && data_length <= range.max) {
	            outOfRange = false;
	            break;
	        }
	    }
	
	    if(outOfRange === true) {
	        throw new DataOutOfRangeException();
	    }
	
	    for (var version in this.config.characterCapacities) {
	        if (this.config.characterCapacities.hasOwnProperty(version)) {
	
	            if (this.version !== null && parseInt(version) !== this.version) {
	                continue;
	            }
	
	            for (var c = 0; c < eclevels.length; c += 1) {
	                var eclevel = eclevels[c];
	                var capacity = this.config.characterCapacities[version][eclevel][result.mode];
	
	                if (data_length <= capacity) {
	                    result.capacity = capacity;
	                    result.eclevel = eclevel;
	                    result.version = parseInt(version);
	                    break;
	                }
	            }
	
	            if (result.capacity > 0) {
	                break;
	            }
	
	        }
	    }
	
	    return result;
	};
	
	var DataEncoder = function () {
	    'use strict';
	
	    this.config = new Config();
	    this.ec = new ErrorCorrection();
	};
	
	DataEncoder.prototype.constructor = DataEncoder;
	
	DataEncoder.prototype.encodeNumeric = function (data) {
	    'use strict';
	
	    var wordSize = 10;
	    var characters = data.split('');
	    var word = null;
	    var output = [];
	
	    for (var i = 0; i < characters.length; i += 3) {
	        var slice = characters.slice(i, i + 3).join('');
	
	        wordSize = slice.length * 3 + 1;
	        word = parseInt(slice);
	
	        var binary = word.toString(2);
	
	        while (binary.length < wordSize) {
	            binary = '0' + binary;
	        }
	
	        output.push(binary);
	    }
	
	    return output;
	};
	
	DataEncoder.prototype.encodeAlphanumeric = function (data) {
	    'use strict';
	
	    var wordSize = 11;
	    var characters = data.split('');
	    var word = null;
	    var output = [];
	
	    var numbers = characters.map(function (e) {
	        return this.alphanumericCharsTable[e];
	    }, this);
	
	    for (var i = 0; i < numbers.length; i += 2) {
	        if (i + 1 < numbers.length) {
	            word = 45 * numbers[i] + numbers[i + 1];
	        }
	        else {
	            word = numbers[i];
	            wordSize = Math.ceil(wordSize / 2);
	        }
	
	        var binary = word.toString(2);
	        while (binary.length < wordSize) {
	            binary = '0' + binary;
	        }
	        output.push(binary);
	    }
	
	    return output;
	};
	
	DataEncoder.prototype.encodeBinary = function (data) {
	    'use strict';
	
	    var wordSize = 8;
	    var characters = data.bytes();
	    var binary;
	    var output = [];
	
	    for (var i = 0; i < characters.length; i += 1) {
	        binary = characters[i].toString(2);
	        while (binary.length < wordSize) {
	            binary = '0' + binary;
	        }
	        output.push(binary);
	    }
	
	    return output;
	};
	
	DataEncoder.prototype.encodeData = function (data, mode, version, ecLevel) {
	    'use strict';
	
	    var padBytes = ['11101100', '00010001'];
	
	    // Set mode indicator and character count indicator:
	
	    var bitdata = [];
	
	    // Encode data for given mode:
	
	    if (mode === 'numeric') {
	        bitdata = bitdata.concat(this.encodeNumeric(data));
	    }
	    else if (mode === 'alphanumeric') {
	        bitdata = bitdata.concat(this.encodeAlphanumeric(data));
	    }
	    else if (mode === 'binary') {
	        bitdata = bitdata.concat(this.encodeBinary(data));
	    }
	    else {
	        throw new NotSupportedModeException(mode);
	    }
	
	    var modeIndicator = this.config.dataModeBitStrings[mode];
	    var characterCountIndicator = this.config.getCharacterCountIndicator(data.bytes().length, mode, version);
	
	    bitdata.unshift(characterCountIndicator);
	    bitdata.unshift(modeIndicator);
	
	    var bitstring = bitdata.join('');
	
	    // Add terminator:
	    // ------------------------------------------------------------------------------
	
	    bitstring += this.terminator(bitstring.length, version, ecLevel);
	
	    // ------------------------------------------------------------------------------
	
	    var codewords = [];
	
	    var i = 0;
	    while (true) {
	        var octet = bitstring.substring(i, i + 8);
	        if (octet === '') {
	            break;
	        }
	
	        codewords.push(octet);
	        i += 8;
	    }
	
	    // Add More 0s to Make the Length a Multiple of 8
	    while (codewords[codewords.length - 1].length < 8) {
	        codewords[codewords.length - 1] += '0';
	    }
	
	    // Add Pad Bytes if the String is Still too Short
	    var blockInfo = this.config.getBlockInfo(version, ecLevel);
	    var numberOfDataCodewords = blockInfo[0];
	    var b = 0;
	    while (codewords.length < numberOfDataCodewords) {
	        codewords.push(padBytes[b % padBytes.length]);
	        b += 1;
	    }
	
	    return codewords.parseInt(2);
	};
	
	DataEncoder.prototype.encode = function (data, mode, version, ecLevel) {
	    'use strict';
	
	    var encdata = this.encodeData(data, mode, version, ecLevel);
	    var bytes = [];
	    var octet;
	
	    var databytes = encdata.map(function (e) {
	        var val = e.toString(2);
	        while (val.length < 8) {
	            val = '0' + val;
	        }
	        return val;
	    });
	
	    var groups = {
	        '1': [],
	        '2': []
	    };
	
	    var block = [];
	    var blocks = [];
	
	    var ecc;
	    var eccblocks = [];
	
	    var nobg = {};
	    var ndcg = {};
	
	    var blockInfo = this.config.getBlockInfo(version, ecLevel);
	    nobg['1'] = blockInfo[2]; // Number of Blocks in Group 1
	    ndcg['1'] = blockInfo[3]; // Number of Data Codewords in Each of Group 1's Blocks
	    nobg['2'] = blockInfo[4]; // Number of Blocks in Group 2
	    ndcg['2'] = blockInfo[5]; // Number of Data Codewords in Each of Group 2's Blocks
	
	    var ndcmax = Math.max(ndcg['1'], ndcg['2']);
	
	    var g, b, c, n, index;
	
	    for (index in nobg) {
	        if (nobg.hasOwnProperty(index)) {
	            for (g = 0; g < nobg[index]; g += 1) {
	                block = [];
	
	                for (c = 0; c < ndcg[index]; c += 1) {
	                    block.push(parseInt(databytes.shift(), 2));
	                }
	
	                ecc = this.ec.getCode(block, version, ecLevel);
	                eccblocks.push(ecc);
	
	                while (block.length < ndcmax) {
	                    block.push(null);
	                }
	
	                groups[index][g] = block;
	                blocks.push(block);
	            }
	        }
	    }
	
	    var finalData = [];
	    var finalEcCodewords = [];
	
	    // Interleave the Data Codewords
	    for (n = 0; n < ndcmax; n += 1) {
	        for (b = 0; b < blocks.length; b += 1) {
	            if (blocks[b][n] !== null) {
	                finalData.push(blocks[b][n]);
	            }
	        }
	    }
	
	    // Interleave the Error Correction Codewords
	    for (n = 0; n < eccblocks[0].length; n += 1) {
	        for (b = 0; b < eccblocks.length; b += 1) {
	            finalEcCodewords.push(eccblocks[b][n]);
	        }
	    }
	
	    finalData = finalData.concat(finalEcCodewords);
	
	    while (finalData.length > 0) {
	        octet = finalData.shift().toString(2);
	
	        while (octet.length < 8) {
	            octet = '0' + octet;
	        }
	
	        bytes.push(octet);
	    }
	
	    var datastr = bytes.join('');
	
	    // Add remainder:
	    // ------------------------------------------------------------------------------
	
	    datastr += this.remainder(version);
	
	    // ------------------------------------------------------------------------------
	
	    return datastr;
	};
	
	DataEncoder.prototype.terminator = function (len, version, ecLevel) {
	    'use strict';
	
	    var terminator = '0000';
	    var blockInfo = this.config.getBlockInfo(version, ecLevel);
	
	    var numberOfDataCodewords = blockInfo[0];
	    var numberOfDataBits = numberOfDataCodewords * 8;
	    var diff = numberOfDataBits - len;
	
	    if (diff < 4) {
	        terminator = '';
	        for (var d = 0; d < diff; d += 1) {
	            terminator += '0';
	        }
	    }
	
	    return terminator;
	};
	
	DataEncoder.prototype.remainder = function (version) {
	    'use strict';
	
	    var rb = this.config.remainderBits[version];
	    var remainder = '';
	
	    while (rb > 0) {
	        remainder += '0';
	        rb -= 1;
	    }
	
	    return remainder;
	};
	
	DataEncoder.prototype.alphanumericCharsTable = {
	    '0': 0,
	    '1': 1,
	    '2': 2,
	    '3': 3,
	    '4': 4,
	    '5': 5,
	    '6': 6,
	    '7': 7,
	    '8': 8,
	    '9': 9,
	    'A': 10,
	    'B': 11,
	    'C': 12,
	    'D': 13,
	    'E': 14,
	    'F': 15,
	    'G': 16,
	    'H': 17,
	    'I': 18,
	    'J': 19,
	    'K': 20,
	    'L': 21,
	    'M': 22,
	    'N': 23,
	    'O': 24,
	    'P': 25,
	    'Q': 26,
	    'R': 27,
	    'S': 28,
	    'T': 29,
	    'U': 30,
	    'V': 31,
	    'W': 32,
	    'X': 33,
	    'Y': 34,
	    'Z': 35,
	    ' ': 36,
	    '$': 37,
	    '%': 38,
	    '*': 39,
	    '+': 40,
	    '-': 41,
	    '.': 42,
	    '/': 43,
	    ':': 44
	};
	
	
	var ErrorCorrection = function () {
	    'use strict';
	
	    this.config = new Config();
	    this.gen = new GeneratorPolynominal();
	};
	
	ErrorCorrection.prototype.constructor = ErrorCorrection;
	
	ErrorCorrection.prototype.getCode = function (data, version, eclevel) {
	    'use strict';
	
	    var numberOfEcCodewords = parseInt(this.config.dataSizeInfo['' + version + '-' + eclevel][1]);
	
	    var genpn = this.gen.polynominal(numberOfEcCodewords);
	    var result = [];
	    result = result.concat(data);
	
	    for (var s = 0; s < data.length; s += 1) {
	        var lterm = this.gen.int2exp(result[0]) % 255;
	
	        for (var i = 0; i < genpn.length; i += 1) {
	            var exp = (genpn[i] + lterm) % 255;
	
	            exp = this.gen.exp2int(exp);
	
	            /* jshint bitwise: false */
	            result[i] = result[i] ^ exp;
	            /* jshint bitwise: true */
	        }
	
	        result.shift();
	    }
	
	    return result;
	};
	
	var Evaluation = function (matrix) {
	    'use strict';
	
	    this.matrix = matrix;
	};
	
	Evaluation.prototype.constructor = Evaluation;
	
	Evaluation.prototype.evaluatePattern = function (data) {
	    'use strict';
	
	    var result = {
	        total: 0,
	        1: 0,
	        2: 0,
	        3: 0,
	        4: 0
	    };
	
	    for (var cond in this.rules) {
	        if (this.rules.hasOwnProperty(cond)) {
	            var c = parseInt(cond);
	            var res = this.rules[c](data);
	            result[c] = res.total;
	            result.total += result[c];
	        }
	    }
	
	    return result;
	};
	
	Evaluation.prototype.rules = {
	
	    1: function (data) {
	        'use strict';
	
	        /**
	         * The first rule gives the QR code a penalty
	         * for each group of five or more same-colored modules in a row (or column).
	         */
	        var result = {
	            horizontal: 0,
	            vertical: 0,
	            total: 0
	        };
	
	        var r, c, f, found, penalty, totest;
	
	        // rows:
	
	        for (r = 0; r < data.length; r += 1) {
	            penalty = 0;
	            totest = data[r].join('');
	
	            found = totest.match(/(0{5,}|1{5,})/g);
	
	            if (found !== null) {
	                for(f = 0; f < found.length; f+=1) {
	                    penalty += (3 + found[f].length - 5);
	                }
	            }
	
	            result.horizontal += penalty;
	        }
	
	        // columns:
	
	        for (c = 0; c < data.length; c += 1) {
	            penalty = 0;
	            totest = '';
	
	            for (r = 0; r < data[0].length; r += 1) {
	                totest += data[r][c];
	            }
	
	            found = totest.match(/(0{5,}|1{5,})/g);
	
	            if (found !== null) {
	                for(f = 0; f < found.length; f+=1) {
	                    penalty += (3 + found[f].length - 5);
	                }
	            }
	
	            result.vertical += penalty;
	        }
	
	        result.total = result.horizontal + result.vertical;
	
	        return result;
	    },
	
	    2: function (data) {
	        'use strict';
	
	        /**
	         * The second rule gives the QR code a penalty
	         * for each 2x2 area of same-colored modules in the matrix.
	         */
	        var result = {
	            found: 0,
	            total: 0
	        };
	
	        var penalty = 3;
	
	        var r, c;
	
	        for (r = 0; r < data.length - 1; r += 1) {
	            for (c = 0; c < data[0].length - 1; c += 1) {
	                if (data[r][c] === data[r][c + 1] && data[r][c] === data[r + 1][c] && data[r][c] === data[r + 1][c + 1]) {
	                    result.found += 1;
	                }
	            }
	        }
	
	        result.total = result.found * penalty;
	
	        return result;
	    },
	
	    3: function (data) {
	        'use strict';
	
	        /**
	         * The third rule gives the QR code a large penalty
	         * if there are patterns that look similar to the finder patterns.
	         *
	         * (1 x dark: 1 x bright: 3 x dark: 1 x bright: 1 x dark) pattern (and reversed) in a line or a column
	         * [ 1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0 ]
	         * [ 0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1 ]
	         */
	        var result = {
	            cols: 0,
	            rows: 0,
	            total: 0
	        };
	
	        var patterns = [
	            [ 1, 0, 1, 1, 1, 0, 1, 0, 0, 0, 0 ],
	            [ 0, 0, 0, 0, 1, 0, 1, 1, 1, 0, 1 ]
	        ];
	
	        var penalty = 40;
	
	        var match = true;
	        var r, c, p;
	
	        // Rows:
	        for (r = 0; r < data.length; r += 1) {
	            for (c = 0; c < data[0].length - patterns[0].length + 1; c += 1) {
	                match = [true, true];
	
	                for (p = 0; p < patterns[0].length; p += 1) {
	                    if (data[r][c + p] !== patterns[0][p]) {
	                        match[0] = false;
	                    }
	                    if (data[r][c + p] !== patterns[1][p]) {
	                        match[1] = false;
	                    }
	                }
	
	                if (match[0] === true) {
	                    result.rows += 1;
	                }
	
	                if (match[1] === true) {
	                    result.rows += 1;
	                }
	            }
	        }
	
	        // Cols:
	        for (c = 0; c < data[0].length; c += 1) {
	            for (r = 0; r < data.length - patterns[0].length + 1; r += 1) {
	                match = [true, true];
	
	                for (p = 0; p < patterns[0].length; p += 1) {
	                    if (data[r + p][c] !== patterns[0][p]) {
	                        match[0] = false;
	                    }
	                    if (data[r + p][c] !== patterns[1][p]) {
	                        match[1] = false;
	                    }
	                }
	
	                if (match[0] === true) {
	                    result.cols += 1;
	                }
	
	                if (match[1] === true) {
	                    result.cols += 1;
	                }
	            }
	        }
	
	        result.total = (result.rows + result.cols) * penalty;
	
	        return result;
	    },
	
	    4: function (data) {
	        'use strict';
	
	        /**
	         * The fourth rule gives the QR code a penalty
	         * if more than half of the modules are dark or light, with a larger penalty for a larger difference.
	         */
	        var result = {
	            dark: 0,
	            all: 0,
	            total: 0
	        };
	
	        var penalty = 10;
	
	        var r, c;
	
	        for (r = 0; r < data.length; r += 1) {
	            for (c = 0; c < data[0].length; c += 1) {
	                result.dark += data[r][c] === 1 ? 1 : 0;
	                result.all += 1;
	            }
	        }
	
	        var percentage = (result.dark / result.all) * 100;
	
	        var fivemul = {
	            upper: 0,
	            lower: 0
	        };
	
	        while (fivemul.upper < percentage) {
	            fivemul.upper += 5;
	        }
	
	        fivemul.lower = fivemul.upper - 5;
	
	        var a = Math.abs(fivemul.lower - 50);
	        var b = Math.abs(fivemul.upper - 50);
	
	        result.total = Math.min(a, b) * penalty;
	
	        return result;
	    }
	};
	
	
	/**
	 * Invalid Out Of Range
	 */
	var OutOfRangeException = function(message) {
	    'use strict';
	
	    message = message || 'Value is out of range.';
	    this.message = message;
	};
	
	OutOfRangeException.prototype.constructor = OutOfRangeException;
	
	OutOfRangeException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	/**
	 * Not supported mode.
	 */
	var NotSupportedModeException = function(mode) {
	    'use strict';
	
	    this.message = 'Mode ' + mode + ' is not supported.';
	};
	
	NotSupportedModeException.prototype.constructor = NotSupportedModeException;
	
	NotSupportedModeException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	/**
	 * Invalid Error Correction Level
	 */
	var InvalidErrorCorrectionLevelException = function(message) {
	    'use strict';
	
	    message = message || 'Invalid Error Correction Level, only L, M, Q or H is supported.';
	    this.message = message;
	};
	
	InvalidErrorCorrectionLevelException.prototype.constructor = InvalidErrorCorrectionLevelException;
	
	InvalidErrorCorrectionLevelException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	/**
	 * Invalid Version Number
	 */
	var InvalidVersionNumberException = function(message) {
	    'use strict';
	
	    message = message || 'Invalid Version number.';
	    this.message = message;
	};
	
	InvalidVersionNumberException.prototype.constructor = InvalidVersionNumberException;
	
	InvalidVersionNumberException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	
	/**
	 * Empty Data
	 */
	var EmptyDataException = function(message) {
	    'use strict';
	
	    message = message || 'Data should contain at least one character.';
	    this.message = message;
	};
	
	EmptyDataException.prototype.constructor = EmptyDataException;
	
	EmptyDataException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	/**
	 * Data out of Range
	 */
	var DataOutOfRangeException = function(message) {
	    'use strict';
	
	    message = message || 'Data size is out of supported range.';
	    this.message = message;
	};
	
	DataOutOfRangeException.prototype.constructor = DataOutOfRangeException;
	
	DataOutOfRangeException.prototype.toString = function() {
	    'use strict';
	
	    return this.message;
	};
	
	/**
	 * Generator polynominal
	 *
	 * @constructor
	 */
	var GeneratorPolynominal = function () {
	    'use strict';
	    this.log = [];
	    this.antilog = [];
	    this.symbol = ',';
	
	    this.createLogAndAntilog();
	};
	
	GeneratorPolynominal.prototype.constructor = GeneratorPolynominal;
	
	GeneratorPolynominal.prototype.createLogAndAntilog = function () {
	    'use strict';
	
	    for (var i = 0; i < 256; i += 1) {
	        var a = 1;
	        var ix = i;
	
	        while (ix > 0) {
	            /* jshint bitwise: false */
	            a <<= 1;
	            a = a > 255 ? (a ^ 285) : a;
	            /* jshint bitwise: true */
	            ix -= 1;
	        }
	
	        this.log[i] = a;
	        this.antilog[a] = i;
	    }
	};
	
	GeneratorPolynominal.prototype.exp2int = function (exp) {
	    'use strict';
	    return this.log[exp];
	};
	
	GeneratorPolynominal.prototype.int2exp = function (exp) {
	    'use strict';
	    return this.antilog[exp];
	};
	
	GeneratorPolynominal.prototype.multiply = function (fst, sec) {
	    'use strict';
	
	    /* jshint bitwise: false */
	
	    var temp = {};
	    var res = [];
	    var aexp, xexp, fs, sc;
	
	    for (var s = 0; s < sec.length; s += 1) {
	        for (var f = 0; f < fst.length; f += 1) {
	            fs = fst[f];
	            sc = sec[s];
	
	            var fsa = fs.split(this.symbol).parseInt();
	            var sca = sc.split(this.symbol).parseInt();
	
	            fs = fsa[0] + sca[0];
	            sc = fsa[1] + sca[1];
	
	            fs %= 255;
	            sc %= 255;
	
	            sc = this.symbol + sc;
	
	            if (typeof temp[sc] === 'undefined') {
	                temp[sc] = [];
	            }
	
	            temp[sc].push(fs);
	        }
	    }
	
	    for (var k in temp) {
	        if (temp.hasOwnProperty(k)) {
	
	            aexp = 0;
	            xexp = parseInt(k.toString().replace(/\D/, ''));
	
	            fs = parseInt(temp[k][0]);
	
	            if (temp[k].length > 1) {
	                sc = parseInt(temp[k][1]);
	
	                fs = this.exp2int(fs);
	                sc = this.exp2int(sc);
	
	                var intg = fs ^ sc;
	                aexp = this.int2exp(intg);
	            }
	            else {
	                aexp = fs;
	            }
	
	            aexp %= 255;
	            res.push(aexp + this.symbol + xexp);
	        }
	    }
	
	    return res;
	};
	
	GeneratorPolynominal.prototype.polynominal = function (degree) {
	    'use strict';
	    var pn = [];
	
	    var exp = 1;
	    var result = ['0' + this.symbol + '1', '0' + this.symbol + '0'];
	
	    do {
	        var second = ['0' + this.symbol + '1', exp + this.symbol + '0'];
	        result = this.multiply(result, second);
	        exp += 1;
	    } while (exp < degree);
	
	    while (result.length > 0) {
	        var chunk = result.shift().split(this.symbol).shift();
	        pn.push(parseInt(chunk));
	    }
	
	    return pn;
	};
	
	
	var Mask = function (matrix) {
	    'use strict';
	
	    this.matrix = matrix;
	    this.config = new Config();
	};
	
	Mask.prototype.constructor = Mask;
	
	/**
	 * Applies mask
	 *
	 * @param {number} pattern number of specific mask pattern.
	 * @param {boolean} maskTest flag to show mask applied on empty grid.
	 *
	 * @returns {object} mask data and evaluation results.
	 */
	Mask.prototype.apply = function (pattern, maskTest) {
	    'use strict';
	
	    maskTest = maskTest || false;
	
	    var maskinfo = {
	        evaluation: {},
	        data: []
	    };
	
	    var pat = this.patterns[pattern];
	    var val, r, c;
	
	    if (maskTest === true) {
	        for (r = 0; r < this.matrix.data.length; r += 1) {
	            for (c = 0; c < this.matrix.data[r].length; c += 1) {
	                this.matrix.mask[r][c] = this.matrix.MASK_DATA;
	                this.matrix.data[r][c] = 0;
	            }
	        }
	    }
	
	    for (r = 0; r < this.matrix.getSize(); r += 1) {
	        maskinfo.data[r] = [];
	        for (c = 0; c < this.matrix.getSize(); c += 1) {
	            maskinfo.data[r][c] = this.matrix.data[r][c];
	            if (this.matrix.mask[r][c] === this.matrix.MASK_DATA) {
	                val = maskinfo.data[r][c];
	                /* jshint bitwise: false */
	                maskinfo.data[r][c] = pat(r, c) ? val ^ 1 : val;
	                /* jshint bitwise: true */
	            }
	        }
	    }
	
	    if (maskTest === false) {
	        var formatString = this.config.getFormatString(this.matrix.eclevel, pattern);
	        var versionInformationString = this.config.getVersionInformationString(this.matrix.version);
	        this.matrix.setFormatInformationArea(formatString, maskinfo.data);
	        this.matrix.setVersionInformationArea(versionInformationString, maskinfo.data);
	    }
	
	    var evaluation = new Evaluation(this.matrix);
	    maskinfo.evaluation = evaluation.evaluatePattern(maskinfo.data);
	
	    return maskinfo;
	};
	
	Mask.prototype.patterns = {
	
	    0: function (row, column) {
	        'use strict';
	        return (row + column) % 2 === 0;
	    },
	    1: function (row, column) {
	        'use strict';
	        return (row) % 2 === 0;
	    },
	    2: function (row, column) {
	        'use strict';
	        return (column) % 3 === 0;
	    },
	    3: function (row, column) {
	        'use strict';
	        return (row + column) % 3 === 0;
	    },
	    4: function (row, column) {
	        'use strict';
	        return (Math.floor(row / 2) + Math.floor(column / 3)) % 2 === 0;
	    },
	    5: function (row, column) {
	        'use strict';
	        return ((row * column) % 2) + ((row * column) % 3) === 0;
	    },
	    6: function (row, column) {
	        'use strict';
	        return (((row * column) % 2) + ((row * column) % 3)) % 2 === 0;
	    },
	    7: function (row, column) {
	        'use strict';
	        return (((row + column) % 2) + ((row * column) % 3)) % 2 === 0;
	    }
	};
	var Matrix = function (version, eclevel) {
	    'use strict';
	
	    this.config = new Config();
	
	    if (typeof version === 'undefined' || isNaN(parseInt(version))) {
	        throw new InvalidVersionNumberException();
	    }
	
	    this.DATA_UNDEFINED_MODULE = 7;
	    this.DATA_LIGHT_MODULE = 0;
	    this.DATA_DARK_MODULE = 1;
	
	    this.MASK_UNDEFINED_MODULE = 15;
	    this.MASK_POSITION_DETECTION_PATTERN = 101;
	    this.MASK_SEPARATOR = 102;
	    this.MASK_TOP_TIMER = 103;
	    this.MASK_LEFT_TIMER = 104;
	    this.MASK_ALIGNMENT_PATTERN = 105;
	    this.MASK_FIXED_DARK_MODULE = 106;
	
	    this.MASK_FORMAT_INFORMATION = 201;
	    this.MASK_VERSION_INFORMATION_NE = 202;
	    this.MASK_VERSION_INFORMATION_SW = 222;
	    this.MASK_DATA = 255;
	
	    this.version = parseInt(version);
	    this.eclevel = eclevel;
	    this.size = (((this.version - 1) * 4) + 21);
	    this.data = this.allocate(this.size, this.DATA_UNDEFINED_MODULE);
	    this.mask = this.allocate(this.size, this.MASK_UNDEFINED_MODULE);
	};
	
	Matrix.prototype.constructor = Matrix;
	
	/**
	 * Main stream logic methods
	 */
	
	Matrix.prototype.setStaticAreas = function () {
	    'use strict';
	
	    this.setPositionDetectionPatterns();
	    this.setSeparators();
	    this.setTimingPatterns();
	    this.setFixedDarkModule();
	    this.setAlignmentPatterns();
	};
	
	Matrix.prototype.setFixedDarkModule = function () {
	    'use strict';
	
	    var x = 8;
	    var y = (4 * this.version) + 9;
	
	    this.setDarkModule(x, y, this.MASK_FIXED_DARK_MODULE);
	};
	
	Matrix.prototype.setPositionDetectionPatterns = function () {
	    'use strict';
	
	    this.setPositionDetectionPattern(0, 0);
	    this.setPositionDetectionPattern(this.getSize() - 7, 0);
	    this.setPositionDetectionPattern(0, this.getSize() - 7);
	};
	
	Matrix.prototype.setSeparators = function () {
	    'use strict';
	
	    var i;
	    var x = 0, y = 0;
	    var offset = this.getSize() - 7;
	    var aoffset = 0;
	    var boffset = 7;
	
	    // LEFT-TOP:
	    i = 7;
	    while (i > 0) {
	        i -= 1;
	        this.setLightModule(x + boffset, y + aoffset + i, this.MASK_SEPARATOR);
	        this.setLightModule(x + aoffset + i, y + boffset, this.MASK_SEPARATOR);
	    }
	
	    aoffset = boffset;
	    boffset = aoffset;
	    this.setLightModule(x + aoffset, y + boffset, this.MASK_SEPARATOR);
	
	    // RIGHT-TOP:
	    i = 7;
	    while (i > 0) {
	        i -= 1;
	        aoffset = offset;
	        boffset = 7;
	        this.setLightModule(x + aoffset + i, y + boffset, this.MASK_SEPARATOR);
	        aoffset = offset - 1;
	        boffset = 0;
	        this.setLightModule(x + aoffset, y + boffset + i, this.MASK_SEPARATOR);
	    }
	
	    aoffset = offset - 1;
	    boffset = 7;
	
	    this.setLightModule(x + aoffset, y + boffset, this.MASK_SEPARATOR);
	
	    // LEFT BOTTOM:
	    i = 7;
	    while (i > 0) {
	        i -= 1;
	        aoffset = 7;
	        boffset = offset;
	        this.setLightModule(x + aoffset, y + boffset + i, this.MASK_SEPARATOR);
	        aoffset = 0;
	        boffset = offset - 1;
	        this.setLightModule(x + aoffset + i, y + boffset, this.MASK_SEPARATOR);
	    }
	
	    aoffset = offset - 1;
	    boffset = 7;
	    this.setLightModule(x + boffset, y + aoffset, this.MASK_SEPARATOR);
	};
	
	Matrix.prototype.setTimingPatterns = function () {
	    'use strict';
	
	    var limit = this.getSize() - 7;
	
	    for (var c = 8; c < limit - 1; c += 1) {
	        if (c % 2 === 0) {
	            this.setDarkModule(c, 6, this.MASK_TOP_TIMER);
	            this.setDarkModule(6, c, this.MASK_LEFT_TIMER);
	        } else {
	            this.setLightModule(c, 6, this.MASK_TOP_TIMER);
	            this.setLightModule(6, c, this.MASK_LEFT_TIMER);
	        }
	    }
	};
	
	Matrix.prototype.setAlignmentPatterns = function () {
	    'use strict';
	
	    var table = this.config.alignmentPatternLocations[this.version];
	
	    for (var x = 0; x < table.length; x += 1) {
	        for (var y = 0; y < table.length; y += 1) {
	
	            if (x === 0 && y === 0 || x === 0 && y === table.length - 1 || x === table.length - 1 && y === 0) {
	                continue;
	            }
	
	            this.setAlignmentPattern(table[x], table[y]);
	        }
	    }
	};
	
	Matrix.prototype.setReservedAreas = function () {
	    'use strict';
	
	    this.setFormatInformationArea();
	    this.setVersionInformationArea();
	};
	
	Matrix.prototype.setDataArea = function (datastr) {
	    'use strict';
	
	    var UP = -1;
	    var DOWN = 1;
	    var direction = UP;
	
	    // Start at the last module:
	    var x = this.getSize() - 1;
	    var y = this.getSize() - 1;
	    var tempy = y;
	
	    var data = datastr.split('').parseInt();
	    var bit;
	
	    while (data.length > 0) {
	
	        // Check if matrix bottom or top is reached:
	        if (!(y >= 0 && y < this.getSize())) {
	
	            x -= 2;
	            y = tempy;
	
	            // Switch move direction when code area boundary is reached:
	            direction = direction === UP ? DOWN : UP;
	
	            // Left timing pattern exception:
	            if (x === 6) {
	                x -= 1;
	            }
	        }
	
	        // Place data bit only if current module is undefined:
	        if (this.isModuleUndefined(x, y)) {
	            bit = data.shift();
	            this.setModule(x, y, bit, this.MASK_DATA);
	        }
	
	        x -= 1;
	
	        if (this.isModuleUndefined(x, y)) {
	            bit = data.shift();
	            this.setModule(x, y, bit, this.MASK_DATA);
	        }
	
	        x += 1;
	
	        tempy = y;
	        y += direction;
	    }
	};
	
	Matrix.prototype.setFormatInformationArea = function (formatInformationString, data) {
	    'use strict';
	
	    /**
	     * If no format information string is given, reserve area (fill with light modules)
	     * @type {*|string}
	     */
	    formatInformationString = formatInformationString || '000000000000000';
	
	    data = data || this.data;
	
	    var formatInformation = formatInformationString.split('').map(function (e) {
	        return parseInt(e);
	    });
	
	    var bits = [
	        [],
	        []
	    ];
	
	    var val = 0;
	    var x, y;
	
	    while (formatInformation.length > 0) {
	        val = formatInformation.shift();
	        bits[0].push(val);
	        bits[1].push(val);
	    }
	
	    // Next to the NW Position Detection Pattern
	    x = 8;
	    y = 0;
	    for (; y < 8; y += 1) {
	        if (y !== 6) {
	            if (bits[0].pop() === 1) {
	                this.setDarkModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	            }
	            else {
	                this.setLightModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	            }
	        }
	    }
	
	    // Below the NW Position Detection Pattern
	    x = 8;
	    y = 8;
	    for (; x >= 0; x -= 1) {
	        if (x !== 6) {
	            if (bits[0].pop() === 1) {
	                this.setDarkModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	            }
	            else {
	                this.setLightModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	            }
	        }
	    }
	
	    // Below the NE Position Detection Pattern
	    x = this.size - 1;
	    y = 8;
	    for (; x >= this.size - 8; x -= 1) {
	        if (bits[1].pop() === 1) {
	            this.setDarkModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	        }
	        else {
	            this.setLightModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	        }
	    }
	
	    // Next to the SW Position Detection Pattern
	    x = 8;
	    y = (4 * this.version) + 9 + 1;
	    for (; y < this.size; y += 1) {
	        if (bits[1].pop() === 1) {
	            this.setDarkModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	        }
	        else {
	            this.setLightModule(x, y, this.MASK_FORMAT_INFORMATION, data);
	        }
	    }
	};
	
	Matrix.prototype.setVersionInformationArea = function (versionInformationString, data) {
	    'use strict';
	
	    if(this.version < 7) {
	        return false;
	    }
	
	    /**
	     * If no version information string is given, reserve area (fill with light modules)
	     * @type {*|string}
	     */
	    versionInformationString = versionInformationString || '000000000000000000';
	
	    data = data || this.data;
	
	    var temp = versionInformationString.split('').map(function (e) {
	        return parseInt(e);
	    });
	
	    var bits = [
	        [],
	        []
	    ];
	
	    var val, x, y, i;
	
	    while (temp.length > 0) {
	        val = temp.shift();
	        bits[0].push(val);
	        bits[1].push(val);
	    }
	
	    // NE
	    y = 0;
	    x = this.size - 11;
	
	    for (; y < 6; y += 1) {
	        for (i = 0; i < 3; i += 1) {
	            if (bits[0].pop() === 1) {
	                this.setDarkModule(x + i, y, this.MASK_VERSION_INFORMATION_NE, data);
	            }
	            else {
	                this.setLightModule(x + i, y, this.MASK_VERSION_INFORMATION_NE, data);
	            }
	        }
	    }
	
	    // SW
	    y = this.size - 11;
	    x = 0;
	
	    for (; x < 6; x += 1) {
	        for (i = 0; i < 3; i += 1) {
	            if (bits[1].pop() === 1) {
	                this.setDarkModule(x, y + i, this.MASK_VERSION_INFORMATION_SW, data);
	            }
	            else {
	                this.setLightModule(x, y + i, this.MASK_VERSION_INFORMATION_SW, data);
	            }
	        }
	    }
	
	    return true;
	};
	
	/**
	 * Helpers
	 */
	
	Matrix.prototype.allocate = function (size, module) {
	    'use strict';
	
	    var r, c;
	
	    var data = [];
	
	    for (r = 0; r < size; r += 1) {
	        var row = [];
	        for (c = 0; c < size; c += 1) {
	            row[c] = module;
	        }
	        data.push(row);
	    }
	
	    return data;
	};
	
	Matrix.prototype.getSize = function () {
	    'use strict';
	
	    return this.size;
	};
	
	Matrix.prototype.getData = function () {
	    'use strict';
	
	    return this.data;
	};
	
	Matrix.prototype.getMask = function () {
	    'use strict';
	
	    return this.mask;
	};
	
	Matrix.prototype.setAlignmentPattern = function (cx, cy) {
	    'use strict';
	
	    var x, y, i, offset;
	
	    // CENTER:
	    this.setDarkModule(cx, cy, this.MASK_ALIGNMENT_PATTERN);
	
	    offset = 1;
	
	    for (x = cx - offset; x <= cx + offset; x += 1) {
	        y = cy - offset;
	        this.setLightModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	        y = cy + offset;
	        this.setLightModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	    }
	
	    for (i = cy - offset; i <= cy + offset; i += 1) {
	        y = i;
	        x = cx - offset;
	        this.setLightModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	        x = cx + offset;
	        this.setLightModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	    }
	
	    offset = 2;
	
	    for (i = cx - offset; i <= cx + offset; i += 1) {
	        x = i;
	        y = cy - offset;
	        this.setDarkModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	        y = cy + offset;
	        this.setDarkModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	    }
	
	    for (i = cy - offset; i <= cy + offset; i += 1) {
	        y = i;
	        x = cx - offset;
	        this.setDarkModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	        x = cx + offset;
	        this.setDarkModule(x, y, this.MASK_ALIGNMENT_PATTERN);
	    }
	};
	
	Matrix.prototype.setPositionDetectionPattern = function (top, left) {
	    'use strict';
	
	    var x, y;
	
	    // TOP/BOTTOM:
	    for (x = 0; x < 7; x += 1) {
	        y = 0;
	        this.setDarkModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	        y = 6;
	        this.setDarkModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	    }
	
	    // INNER SEPARATOR TOP/BOTTOM:
	    for (x = 1; x < 6; x += 1) {
	        y = 1;
	        this.setLightModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	        y = 5;
	        this.setLightModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	    }
	
	    // RIGHT/LEFT:
	    for (y = 1; y < 6; y += 1) {
	        x = 0;
	        this.setDarkModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	        x = 6;
	        this.setDarkModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	    }
	
	    // INNER SEPARATOR RIGHT/LEFT:
	    for (y = 1; y < 6; y += 1) {
	        x = 1;
	        this.setLightModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	        x = 5;
	        this.setLightModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	    }
	
	    // CENTER:
	    for (x = 2; x < 5; x += 1) {
	        for (y = 2; y < 5; y += 1) {
	            this.setDarkModule((left + x), (top + y), this.MASK_POSITION_DETECTION_PATTERN);
	        }
	    }
	};
	
	Matrix.prototype.isModuleUndefined = function (x, y, data) {
	    'use strict';
	    data = data || this.data;
	    return data[y][x] === this.DATA_UNDEFINED_MODULE;
	};
	
	Matrix.prototype.setModule = function (x, y, value, maskValue, data) {
	    'use strict';
	
	    data = data || this.data;
	    data[y][x] = value;
	    this.mask[y][x] = maskValue;
	};
	
	Matrix.prototype.setDarkModule = function (x, y, maskValue, data) {
	    'use strict';
	
	    data = data || this.data;
	    this.setModule(x, y, this.DATA_DARK_MODULE, maskValue, data);
	};
	
	Matrix.prototype.setLightModule = function (x, y, maskValue, data) {
	    'use strict';
	
	    data = data || this.data;
	    this.setModule(x, y, this.DATA_LIGHT_MODULE, maskValue, data);
	};
	
	/**
	 * Quick Response Model 2 Code generator
	 *
	 * @param {string} data raw data
	 * @param {array} ecstrategy error correction strategy, default ['M']
	 * @param {number|null} maskPattern force mask pattern, default null
	 * @param {number} version version number
	 * @param {boolean} dataOnly if no mask is to be applied
	 * @param {boolean} maskTest shows only mask
	 *
	 * @throws {string} Out of range Exception
	 *
	 * @constructor
	 */
	var QrCode = function (data, ecstrategy, maskPattern, version, dataOnly, maskTest) {
	    'use strict';
	
	    data = data || '';
	    ecstrategy = ecstrategy || ['M'];
	    version = version || null;
	    dataOnly = dataOnly || false;
	    maskTest = maskTest || false;
	
	    // Error correction validation:
	
	    if(toString.call(ecstrategy) !== '[object Array]') {
	        throw new InvalidErrorCorrectionLevelException();
	    }
	
	    ecstrategy.forEach(function(e){
	        if(e.match(/^[LMQH]$/i) === null) {
	            throw new InvalidErrorCorrectionLevelException();
	        }
	    });
	
	    // Mask pattern validation:
	
	    if(typeof parseInt(maskPattern) !== 'number') {
	        maskPattern = null;
	    }
	    else {
	        maskPattern = parseInt(maskPattern);
	    }
	
	    if(isNaN(maskPattern)) {
	        maskPattern = null;
	    }
	
	    if(maskPattern !== null && !(maskPattern >=0 && maskPattern < 8)) {
	        throw new OutOfRangeException('Mask pattern value is out of 0..7 range.');
	    }
	
	    // Version validation:
	
	    if(version !== null && typeof parseInt(version) !== 'number') {
	        throw new InvalidVersionNumberException();
	    }
	
	    this.info = {};
	
	    var analyzer, encoder, tiler, mask;
	    var datastr;
	    var maskinfo = {};
	    var pattern = 0;
	
	    analyzer = new DataAnalyzer(version);
	    this.info = analyzer.analyze(data, ecstrategy);
	
	    encoder = new DataEncoder();
	    datastr = encoder.encode(data, this.info.mode, this.info.version, this.info.eclevel);
	
	    this.matrix = new Matrix(this.info.version, this.info.eclevel);
	    this.matrix.setStaticAreas();
	    this.matrix.setReservedAreas();
	    this.matrix.setDataArea(datastr);
	
	    if(dataOnly === true) {
	        return;
	    }
	
	    mask = new Mask(this.matrix);
	
	    if (maskPattern === null) {
	        var results = [];
	        var evaluations = {};
	
	        for (pattern = 0; pattern < 8; pattern += 1) {
	            maskinfo = mask.apply(pattern);
	            results.push(maskinfo.evaluation.total);
	            evaluations[results[pattern]] = pattern;
	        }
	
	        results = results.sort();
	        pattern = evaluations[results[0]];
	    }
	    else {
	        pattern = parseInt(maskPattern);
	        pattern = isNaN(pattern) ? 0 : pattern;
	    }
	
	    this.info.pattern = pattern;
	
	    maskinfo = mask.apply(pattern, maskTest);
	    this.matrix.data = maskinfo.data;
	};
	
	QrCode.prototype.getInfo = function () {
	    'use strict';
	
	    return this.info;
	};
	
	QrCode.prototype.getData = function () {
	    'use strict';
	
	    return this.matrix.getData();
	};
	
	QrCode.prototype.getSize = function () {
	    'use strict';
	
	    return this.matrix.getSize();
	};
	
	module.exports.QrCode = QrCode;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 863,
		"./af.js": 863,
		"./ar": 870,
		"./ar-dz": 864,
		"./ar-dz.js": 864,
		"./ar-kw": 865,
		"./ar-kw.js": 865,
		"./ar-ly": 866,
		"./ar-ly.js": 866,
		"./ar-ma": 867,
		"./ar-ma.js": 867,
		"./ar-sa": 868,
		"./ar-sa.js": 868,
		"./ar-tn": 869,
		"./ar-tn.js": 869,
		"./ar.js": 870,
		"./az": 871,
		"./az.js": 871,
		"./be": 872,
		"./be.js": 872,
		"./bg": 873,
		"./bg.js": 873,
		"./bm": 874,
		"./bm.js": 874,
		"./bn": 875,
		"./bn.js": 875,
		"./bo": 876,
		"./bo.js": 876,
		"./br": 877,
		"./br.js": 877,
		"./bs": 878,
		"./bs.js": 878,
		"./ca": 879,
		"./ca.js": 879,
		"./cs": 880,
		"./cs.js": 880,
		"./cv": 881,
		"./cv.js": 881,
		"./cy": 882,
		"./cy.js": 882,
		"./da": 883,
		"./da.js": 883,
		"./de": 886,
		"./de-at": 884,
		"./de-at.js": 884,
		"./de-ch": 885,
		"./de-ch.js": 885,
		"./de.js": 886,
		"./dv": 887,
		"./dv.js": 887,
		"./el": 888,
		"./el.js": 888,
		"./en-SG": 889,
		"./en-SG.js": 889,
		"./en-au": 890,
		"./en-au.js": 890,
		"./en-ca": 891,
		"./en-ca.js": 891,
		"./en-gb": 892,
		"./en-gb.js": 892,
		"./en-ie": 893,
		"./en-ie.js": 893,
		"./en-il": 894,
		"./en-il.js": 894,
		"./en-nz": 895,
		"./en-nz.js": 895,
		"./eo": 896,
		"./eo.js": 896,
		"./es": 899,
		"./es-do": 897,
		"./es-do.js": 897,
		"./es-us": 898,
		"./es-us.js": 898,
		"./es.js": 899,
		"./et": 900,
		"./et.js": 900,
		"./eu": 901,
		"./eu.js": 901,
		"./fa": 902,
		"./fa.js": 902,
		"./fi": 903,
		"./fi.js": 903,
		"./fo": 904,
		"./fo.js": 904,
		"./fr": 907,
		"./fr-ca": 905,
		"./fr-ca.js": 905,
		"./fr-ch": 906,
		"./fr-ch.js": 906,
		"./fr.js": 907,
		"./fy": 908,
		"./fy.js": 908,
		"./ga": 909,
		"./ga.js": 909,
		"./gd": 910,
		"./gd.js": 910,
		"./gl": 911,
		"./gl.js": 911,
		"./gom-latn": 912,
		"./gom-latn.js": 912,
		"./gu": 913,
		"./gu.js": 913,
		"./he": 914,
		"./he.js": 914,
		"./hi": 915,
		"./hi.js": 915,
		"./hr": 916,
		"./hr.js": 916,
		"./hu": 917,
		"./hu.js": 917,
		"./hy-am": 918,
		"./hy-am.js": 918,
		"./id": 919,
		"./id.js": 919,
		"./is": 920,
		"./is.js": 920,
		"./it": 922,
		"./it-ch": 921,
		"./it-ch.js": 921,
		"./it.js": 922,
		"./ja": 923,
		"./ja.js": 923,
		"./jv": 924,
		"./jv.js": 924,
		"./ka": 925,
		"./ka.js": 925,
		"./kk": 926,
		"./kk.js": 926,
		"./km": 927,
		"./km.js": 927,
		"./kn": 928,
		"./kn.js": 928,
		"./ko": 929,
		"./ko.js": 929,
		"./ku": 930,
		"./ku.js": 930,
		"./ky": 931,
		"./ky.js": 931,
		"./lb": 932,
		"./lb.js": 932,
		"./lo": 933,
		"./lo.js": 933,
		"./lt": 934,
		"./lt.js": 934,
		"./lv": 935,
		"./lv.js": 935,
		"./me": 936,
		"./me.js": 936,
		"./mi": 937,
		"./mi.js": 937,
		"./mk": 938,
		"./mk.js": 938,
		"./ml": 939,
		"./ml.js": 939,
		"./mn": 940,
		"./mn.js": 940,
		"./mr": 941,
		"./mr.js": 941,
		"./ms": 943,
		"./ms-my": 942,
		"./ms-my.js": 942,
		"./ms.js": 943,
		"./mt": 944,
		"./mt.js": 944,
		"./my": 945,
		"./my.js": 945,
		"./nb": 946,
		"./nb.js": 946,
		"./ne": 947,
		"./ne.js": 947,
		"./nl": 949,
		"./nl-be": 948,
		"./nl-be.js": 948,
		"./nl.js": 949,
		"./nn": 950,
		"./nn.js": 950,
		"./pa-in": 951,
		"./pa-in.js": 951,
		"./pl": 952,
		"./pl.js": 952,
		"./pt": 954,
		"./pt-br": 953,
		"./pt-br.js": 953,
		"./pt.js": 954,
		"./ro": 955,
		"./ro.js": 955,
		"./ru": 956,
		"./ru.js": 956,
		"./sd": 957,
		"./sd.js": 957,
		"./se": 958,
		"./se.js": 958,
		"./si": 959,
		"./si.js": 959,
		"./sk": 960,
		"./sk.js": 960,
		"./sl": 961,
		"./sl.js": 961,
		"./sq": 962,
		"./sq.js": 962,
		"./sr": 964,
		"./sr-cyrl": 963,
		"./sr-cyrl.js": 963,
		"./sr.js": 964,
		"./ss": 965,
		"./ss.js": 965,
		"./sv": 966,
		"./sv.js": 966,
		"./sw": 967,
		"./sw.js": 967,
		"./ta": 968,
		"./ta.js": 968,
		"./te": 969,
		"./te.js": 969,
		"./tet": 970,
		"./tet.js": 970,
		"./tg": 971,
		"./tg.js": 971,
		"./th": 972,
		"./th.js": 972,
		"./tl-ph": 973,
		"./tl-ph.js": 973,
		"./tlh": 974,
		"./tlh.js": 974,
		"./tr": 975,
		"./tr.js": 975,
		"./tzl": 976,
		"./tzl.js": 976,
		"./tzm": 978,
		"./tzm-latn": 977,
		"./tzm-latn.js": 977,
		"./tzm.js": 978,
		"./ug-cn": 979,
		"./ug-cn.js": 979,
		"./uk": 980,
		"./uk.js": 980,
		"./ur": 981,
		"./ur.js": 981,
		"./uz": 983,
		"./uz-latn": 982,
		"./uz-latn.js": 982,
		"./uz.js": 983,
		"./vi": 984,
		"./vi.js": 984,
		"./x-pseudo": 985,
		"./x-pseudo.js": 985,
		"./yo": 986,
		"./yo.js": 986,
		"./zh-cn": 987,
		"./zh-cn.js": 987,
		"./zh-hk": 988,
		"./zh-hk.js": 988,
		"./zh-tw": 989,
		"./zh-tw.js": 989
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1237;


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.4.0
	(function() {
	  var PlistNode, PlistParser, root;
	
	  root = typeof exports !== "undefined" && exports !== null ? exports : this;
	
	  PlistNode = (function() {
	
	    function PlistNode(type, processors) {
	      this.type = type;
	      this.processors = processors;
	      this.key = null;
	      this.value = null;
	      this.parent = null;
	      this.children = [];
	      return this;
	    }
	
	    PlistNode.prototype.addChild = function(node) {
	      node.parent = this;
	      this.children.push(node);
	      return node;
	    };
	
	    PlistNode.prototype.getParent = function() {
	      if (this.parent) {
	        return this.parent;
	      }
	      return this;
	    };
	
	    PlistNode.prototype.convert = function() {
	      var child, iterable, _i, _j, _len, _len1, _ref, _ref1;
	      if (!this.children.length) {
	        if ((this.processors != null) && (this.processors[this.type] != null)) {
	          return this.processors[this.type](this.value);
	        }
	        if (this.type === 'integer') {
	          return parseInt(this.value, 10);
	        } else if (this.type === 'string') {
	          return this.value;
	        } else if (this.type === 'date') {
	          try {
	            return new Date(this.value);
	          } catch (e) {
	            return null;
	          }
	        } else if (this.type === 'true') {
	          return true;
	        } else if (this.type === 'false') {
	          return false;
	        } else if (this.type === 'real') {
	          return parseFloat(this.value);
	        } else if (this.type === 'data') {
	          return this.value;
	        } else if (this.type === 'dict') {
	          return {};
	        } else if (this.type === 'array') {
	          return [];
	        } else {
	          return this.value;
	        }
	      } else {
	        if (this.type === 'dict') {
	          iterable = {};
	          _ref = this.children;
	          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	            child = _ref[_i];
	            if (child.key) {
	              iterable[child.key] = child.convert();
	            }
	          }
	        } else if (this.type === 'array') {
	          iterable = [];
	          _ref1 = this.children;
	          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	            child = _ref1[_j];
	            iterable.push(child.convert());
	          }
	        }
	      }
	      return iterable;
	    };
	
	    return PlistNode;
	
	  })();
	
	  PlistParser = (function() {
	
	    function PlistParser(xml, opts) {
	      var sax, _ref, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
	      if (opts == null) {
	        opts = null;
	      }
	      if ((typeof exports !== "undefined" && exports !== null) && !(exports.sax != null)) {
	        try {
	          sax = __webpack_require__(1502);
	        } catch (e) {
	
	        }
	      }
	      if (!(sax != null) && !(root.sax != null)) {
	        return new Error('Missing required dependency: sax-js (https://github.com/isaacs/sax-js)');
	      }
	      this.sax = sax != null ? sax : root.sax;
	      this.xml = xml;
	      this.traverser = null;
	      this.last = {
	        'parent': null,
	        'node': null,
	        'key': null,
	        'tag': null,
	        'value': null
	      };
	      this.error = null;
	      this.opts = {
	        'processors': {
	          'integer': (_ref = opts != null ? (_ref1 = opts.processors) != null ? _ref1.integer : void 0 : void 0) != null ? _ref : null,
	          'string': (_ref2 = opts != null ? (_ref3 = opts.processors) != null ? _ref3.string : void 0 : void 0) != null ? _ref2 : null,
	          'date': (_ref4 = opts != null ? (_ref5 = opts.processors) != null ? _ref5.date : void 0 : void 0) != null ? _ref4 : null,
	          'true': (_ref6 = opts != null ? (_ref7 = opts.processors) != null ? _ref7["true"] : void 0 : void 0) != null ? _ref6 : null,
	          'false': (_ref8 = opts != null ? (_ref9 = opts.processors) != null ? _ref9["false"] : void 0 : void 0) != null ? _ref8 : null,
	          'real': (_ref10 = opts != null ? (_ref11 = opts.processors) != null ? _ref11.real : void 0 : void 0) != null ? _ref10 : null,
	          'data': (_ref12 = opts != null ? (_ref13 = opts.processors) != null ? _ref13.data : void 0 : void 0) != null ? _ref12 : null,
	          'dict': (_ref14 = opts != null ? (_ref15 = opts.processors) != null ? _ref15.dict : void 0 : void 0) != null ? _ref14 : null,
	          'array': (_ref16 = opts != null ? (_ref17 = opts.processors) != null ? _ref17.array : void 0 : void 0) != null ? _ref16 : null
	        }
	      };
	      return this;
	    }
	
	    PlistParser.prototype.validate = function() {
	      var parser,
	        _this = this;
	      parser = this.sax.parser(true);
	      parser.onopentag = function(node) {
	        if (!this.first) {
	          this.first = true;
	          if (node.name !== 'plist') {
	            return this.error = new Error('Invalid Property List contents (<plist> missing)');
	          }
	        }
	      };
	      parser.ondoctype = function(doctype) {
	        if (doctype !== ' plist PUBLIC "-//Apple Computer//DTD PLIST 1.0//EN" "http://www.apple.com/DTDs/PropertyList-1.0.dtd"') {
	          return _this.error = new Error('Invalid Property List DOCTYPE');
	        }
	      };
	      parser.onerror = function(error) {
	        return _this.error = error;
	      };
	      parser.write(this.xml).close();
	      if (this.error) {
	        return false;
	      }
	      return true;
	    };
	
	    PlistParser.prototype.parse = function() {
	      var parser,
	        _this = this;
	      parser = this.sax.parser(true);
	      parser.onopentag = function(node) {
	        if (node.name === 'plist') {
	          return;
	        } else if (node.name === 'key') {
	          _this.last.key = null;
	          return;
	        }
	        if (!_this.traverser) {
	          _this.traverser = _this.last.node = new PlistNode(node.name, _this.opts.processors);
	          return;
	        }
	        _this.last.node = _this.traverser.addChild(new PlistNode(node.name, _this.opts.processors));
	        if (_this.last.key) {
	          _this.last.node.key = _this.last.key.valueOf();
	          _this.last.key = null;
	        }
	        if ((node.name === 'dict') || (node.name === 'array')) {
	          return _this.traverser = _this.last.node;
	        }
	      };
	      parser.ontext = function(text) {
	        return _this.last.value = text;
	      };
	      parser.onclosetag = function(name) {
	        if ((name === 'dict') || (name === 'array')) {
	          return _this.traverser = _this.traverser.getParent();
	        } else if (name === 'key') {
	          if (_this.last.value) {
	            _this.last.key = _this.last.value.valueOf();
	            return _this.last.value = null;
	          }
	        } else if (_this.last.node) {
	          if (_this.last.value) {
	            _this.last.node.value = _this.last.value.valueOf();
	          }
	          return _this.last.node = null;
	        }
	      };
	      parser.write(this.xml).close();
	      return this.traverser.convert();
	    };
	
	    return PlistParser;
	
	  })();
	
	  root.PlistParser = PlistParser;
	
	  root.PlistNode = PlistNode;
	
	}).call(this);


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Parser functions.
	 */
	
	var parserFunctions = __webpack_require__(1241);
	Object.keys(parserFunctions).forEach(function (k) { exports[k] = parserFunctions[k]; });
	
	/**
	 * Builder functions.
	 */
	
	var builderFunctions = __webpack_require__(1240);
	Object.keys(builderFunctions).forEach(function (k) { exports[k] = builderFunctions[k]; });


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Module dependencies.
	 */
	
	var base64 = __webpack_require__(1245);
	var xmlbuilder = __webpack_require__(1513);
	
	/**
	 * Module exports.
	 */
	
	exports.build = build;
	
	/**
	 * Accepts a `Date` instance and returns an ISO date string.
	 *
	 * @param {Date} d - Date instance to serialize
	 * @returns {String} ISO date string representation of `d`
	 * @api private
	 */
	
	function ISODateString(d){
	  function pad(n){
	    return n < 10 ? '0' + n : n;
	  }
	  return d.getUTCFullYear()+'-'
	    + pad(d.getUTCMonth()+1)+'-'
	    + pad(d.getUTCDate())+'T'
	    + pad(d.getUTCHours())+':'
	    + pad(d.getUTCMinutes())+':'
	    + pad(d.getUTCSeconds())+'Z';
	}
	
	/**
	 * Returns the internal "type" of `obj` via the
	 * `Object.prototype.toString()` trick.
	 *
	 * @param {Mixed} obj - any value
	 * @returns {String} the internal "type" name
	 * @api private
	 */
	
	var toString = Object.prototype.toString;
	function type (obj) {
	  var m = toString.call(obj).match(/\[object (.*)\]/);
	  return m ? m[1] : m;
	}
	
	/**
	 * Generate an XML plist string from the input object `obj`.
	 *
	 * @param {Object} obj - the object to convert
	 * @param {Object} [opts] - optional options object
	 * @returns {String} converted plist XML string
	 * @api public
	 */
	
	function build (obj, opts) {
	  var XMLHDR = {
	    version: '1.0',
	    encoding: 'UTF-8'
	  };
	
	  var XMLDTD = {
	    pubid: '-//Apple//DTD PLIST 1.0//EN',
	    sysid: 'http://www.apple.com/DTDs/PropertyList-1.0.dtd'
	  };
	
	  var doc = xmlbuilder.create('plist');
	
	  doc.dec(XMLHDR.version, XMLHDR.encoding, XMLHDR.standalone);
	  doc.dtd(XMLDTD.pubid, XMLDTD.sysid);
	  doc.att('version', '1.0');
	
	  walk_obj(obj, doc);
	
	  if (!opts) opts = {};
	  // default `pretty` to `true`
	  opts.pretty = opts.pretty !== false;
	  return doc.end(opts);
	}
	
	/**
	 * depth first, recursive traversal of a javascript object. when complete,
	 * next_child contains a reference to the build XML object.
	 *
	 * @api private
	 */
	
	function walk_obj(next, next_child) {
	  var tag_type, i, prop;
	  var name = type(next);
	
	  if ('Undefined' == name) {
	    return;
	  } else if (Array.isArray(next)) {
	    next_child = next_child.ele('array');
	    for (i = 0; i < next.length; i++) {
	      walk_obj(next[i], next_child);
	    }
	
	  } else if (Buffer.isBuffer(next)) {
	    next_child.ele('data').raw(next.toString('base64'));
	
	  } else if ('Object' == name) {
	    next_child = next_child.ele('dict');
	    for (prop in next) {
	      if (next.hasOwnProperty(prop)) {
	        next_child.ele('key').txt(prop);
	        walk_obj(next[prop], next_child);
	      }
	    }
	
	  } else if ('Number' == name) {
	    // detect if this is an integer or real
	    // TODO: add an ability to force one way or another via a "cast"
	    tag_type = (next % 1 === 0) ? 'integer' : 'real';
	    next_child.ele(tag_type).txt(next.toString());
	
	  } else if ('Date' == name) {
	    next_child.ele('date').txt(ISODateString(new Date(next)));
	
	  } else if ('Boolean' == name) {
	    next_child.ele(next ? 'true' : 'false');
	
	  } else if ('String' == name) {
	    next_child.ele('string').txt(next);
	
	  } else if ('ArrayBuffer' == name) {
	    next_child.ele('data').raw(base64.fromByteArray(next));
	
	  } else if (next && next.buffer && 'ArrayBuffer' == type(next.buffer)) {
	    // a typed array
	    next_child.ele('data').raw(base64.fromByteArray(new Uint8Array(next.buffer), next_child));
	
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer))

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/**
	 * Module dependencies.
	 */
	
	var DOMParser = __webpack_require__(1242).DOMParser;
	
	/**
	 * Module exports.
	 */
	
	exports.parse = parse;
	
	var TEXT_NODE = 3;
	var CDATA_NODE = 4;
	var COMMENT_NODE = 8;
	
	
	/**
	 * We ignore raw text (usually whitespace), <!-- xml comments -->,
	 * and raw CDATA nodes.
	 *
	 * @param {Element} node
	 * @returns {Boolean}
	 * @api private
	 */
	
	function shouldIgnoreNode (node) {
	  return node.nodeType === TEXT_NODE
	    || node.nodeType === COMMENT_NODE
	    || node.nodeType === CDATA_NODE;
	}
	
	/**
	 * Check if the node is empty. Some plist file has such node:
	 * <key />
	 * this node shoud be ignored.
	 *
	 * @see https://github.com/TooTallNate/plist.js/issues/66
	 * @param {Element} node
	 * @returns {Boolean}
	 * @api private
	 */
	function isEmptyNode(node){
	  if(!node.childNodes || node.childNodes.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	function invariant(test, message) {
	  if (!test) {
	    throw new Error(message);
	  }
	}
	
	/**
	 * Parses a Plist XML string. Returns an Object.
	 *
	 * @param {String} xml - the XML String to decode
	 * @returns {Mixed} the decoded value from the Plist XML
	 * @api public
	 */
	
	function parse (xml) {
	  var doc = new DOMParser().parseFromString(xml);
	  invariant(
	    doc.documentElement.nodeName === 'plist',
	    'malformed document. First element should be <plist>'
	  );
	  var plist = parsePlistXML(doc.documentElement);
	
	  // the root <plist> node gets interpreted as an Array,
	  // so pull out the inner data first
	  if (plist.length == 1) plist = plist[0];
	
	  return plist;
	}
	
	/**
	 * Convert an XML based plist document into a JSON representation.
	 *
	 * @param {Object} xml_node - current XML node in the plist
	 * @returns {Mixed} built up JSON object
	 * @api private
	 */
	
	function parsePlistXML (node) {
	  var i, new_obj, key, val, new_arr, res, counter, type;
	
	  if (!node)
	    return null;
	
	  if (node.nodeName === 'plist') {
	    new_arr = [];
	    if (isEmptyNode(node)) {
	      return new_arr;
	    }
	    for (i=0; i < node.childNodes.length; i++) {
	      if (!shouldIgnoreNode(node.childNodes[i])) {
	        new_arr.push( parsePlistXML(node.childNodes[i]));
	      }
	    }
	    return new_arr;
	  } else if (node.nodeName === 'dict') {
	    new_obj = {};
	    key = null;
	    counter = 0;
	    if (isEmptyNode(node)) {
	      return new_obj;
	    }
	    for (i=0; i < node.childNodes.length; i++) {
	      if (shouldIgnoreNode(node.childNodes[i])) continue;
	      if (counter % 2 === 0) {
	        invariant(
	          node.childNodes[i].nodeName === 'key',
	          'Missing key while parsing <dict/>.'
	        );
	        key = parsePlistXML(node.childNodes[i]);
	      } else {
	        invariant(
	          node.childNodes[i].nodeName !== 'key',
	          'Unexpected key "'
	            + parsePlistXML(node.childNodes[i])
	            + '" while parsing <dict/>.'
	        );
	        new_obj[key] = parsePlistXML(node.childNodes[i]);
	      }
	      counter += 1;
	    }
	    if (counter % 2 === 1) {
	      throw new Error('Missing value for "' + key + '" while parsing <dict/>');
	    }
	    return new_obj;
	
	  } else if (node.nodeName === 'array') {
	    new_arr = [];
	    if (isEmptyNode(node)) {
	      return new_arr;
	    }
	    for (i=0; i < node.childNodes.length; i++) {
	      if (!shouldIgnoreNode(node.childNodes[i])) {
	        res = parsePlistXML(node.childNodes[i]);
	        if (null != res) new_arr.push(res);
	      }
	    }
	    return new_arr;
	
	  } else if (node.nodeName === '#text') {
	    // TODO: what should we do with text types? (CDATA sections)
	
	  } else if (node.nodeName === 'key') {
	    if (isEmptyNode(node)) {
	      return '';
	    }
	    return node.childNodes[0].nodeValue;
	  } else if (node.nodeName === 'string') {
	    res = '';
	    if (isEmptyNode(node)) {
	      return res;
	    }
	    for (i=0; i < node.childNodes.length; i++) {
	      var type = node.childNodes[i].nodeType;
	      if (type === TEXT_NODE || type === CDATA_NODE) {
	        res += node.childNodes[i].nodeValue;
	      }
	    }
	    return res;
	
	  } else if (node.nodeName === 'integer') {
	    invariant(
	      !isEmptyNode(node),
	      'Cannot parse "" as integer.'
	    );
	    return parseInt(node.childNodes[0].nodeValue, 10);
	
	  } else if (node.nodeName === 'real') {
	    invariant(
	      !isEmptyNode(node),
	      'Cannot parse "" as real.'
	    );
	    res = '';
	    for (i=0; i < node.childNodes.length; i++) {
	      if (node.childNodes[i].nodeType === TEXT_NODE) {
	        res += node.childNodes[i].nodeValue;
	      }
	    }
	    return parseFloat(res);
	
	  } else if (node.nodeName === 'data') {
	    res = '';
	    if (isEmptyNode(node)) {
	      return Buffer.from(res, 'base64');
	    }
	    for (i=0; i < node.childNodes.length; i++) {
	      if (node.childNodes[i].nodeType === TEXT_NODE) {
	        res += node.childNodes[i].nodeValue.replace(/\s+/g, '');
	      }
	    }
	    return Buffer.from(res, 'base64');
	
	  } else if (node.nodeName === 'date') {
	    invariant(
	      !isEmptyNode(node),
	      'Cannot parse "" as Date.'
	    )
	    return new Date(node.childNodes[0].nodeValue);
	
	  } else if (node.nodeName === 'true') {
	    return true;
	
	  } else if (node.nodeName === 'false') {
	    return false;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer))

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	function DOMParser(options){
		this.options = options ||{locator:{}};
	}
	
	DOMParser.prototype.parseFromString = function(source,mimeType){
		var options = this.options;
		var sax =  new XMLReader();
		var domBuilder = options.domBuilder || new DOMHandler();//contentHandler and LexicalHandler
		var errorHandler = options.errorHandler;
		var locator = options.locator;
		var defaultNSMap = options.xmlns||{};
		var isHTML = /\/x?html?$/.test(mimeType);//mimeType.toLowerCase().indexOf('html') > -1;
	  	var entityMap = isHTML?htmlEntity.entityMap:{'lt':'<','gt':'>','amp':'&','quot':'"','apos':"'"};
		if(locator){
			domBuilder.setDocumentLocator(locator)
		}
	
		sax.errorHandler = buildErrorHandler(errorHandler,domBuilder,locator);
		sax.domBuilder = options.domBuilder || domBuilder;
		if(isHTML){
			defaultNSMap['']= 'http://www.w3.org/1999/xhtml';
		}
		defaultNSMap.xml = defaultNSMap.xml || 'http://www.w3.org/XML/1998/namespace';
		if(source && typeof source === 'string'){
			sax.parse(source,defaultNSMap,entityMap);
		}else{
			sax.errorHandler.error("invalid doc source");
		}
		return domBuilder.doc;
	}
	function buildErrorHandler(errorImpl,domBuilder,locator){
		if(!errorImpl){
			if(domBuilder instanceof DOMHandler){
				return domBuilder;
			}
			errorImpl = domBuilder ;
		}
		var errorHandler = {}
		var isCallback = errorImpl instanceof Function;
		locator = locator||{}
		function build(key){
			var fn = errorImpl[key];
			if(!fn && isCallback){
				fn = errorImpl.length == 2?function(msg){errorImpl(key,msg)}:errorImpl;
			}
			errorHandler[key] = fn && function(msg){
				fn('[xmldom '+key+']\t'+msg+_locator(locator));
			}||function(){};
		}
		build('warning');
		build('error');
		build('fatalError');
		return errorHandler;
	}
	
	//console.log('#\n\n\n\n\n\n\n####')
	/**
	 * +ContentHandler+ErrorHandler
	 * +LexicalHandler+EntityResolver2
	 * -DeclHandler-DTDHandler
	 *
	 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
	 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
	 */
	function DOMHandler() {
	    this.cdata = false;
	}
	function position(locator,node){
		node.lineNumber = locator.lineNumber;
		node.columnNumber = locator.columnNumber;
	}
	/**
	 * @see org.xml.sax.ContentHandler#startDocument
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
	 */
	DOMHandler.prototype = {
		startDocument : function() {
	    	this.doc = new DOMImplementation().createDocument(null, null, null);
	    	if (this.locator) {
	        	this.doc.documentURI = this.locator.systemId;
	    	}
		},
		startElement:function(namespaceURI, localName, qName, attrs) {
			var doc = this.doc;
		    var el = doc.createElementNS(namespaceURI, qName||localName);
		    var len = attrs.length;
		    appendElement(this, el);
		    this.currentElement = el;
	
			this.locator && position(this.locator,el)
		    for (var i = 0 ; i < len; i++) {
		        var namespaceURI = attrs.getURI(i);
		        var value = attrs.getValue(i);
		        var qName = attrs.getQName(i);
				var attr = doc.createAttributeNS(namespaceURI, qName);
				this.locator &&position(attrs.getLocator(i),attr);
				attr.value = attr.nodeValue = value;
				el.setAttributeNode(attr)
		    }
		},
		endElement:function(namespaceURI, localName, qName) {
			var current = this.currentElement
			var tagName = current.tagName;
			this.currentElement = current.parentNode;
		},
		startPrefixMapping:function(prefix, uri) {
		},
		endPrefixMapping:function(prefix) {
		},
		processingInstruction:function(target, data) {
		    var ins = this.doc.createProcessingInstruction(target, data);
		    this.locator && position(this.locator,ins)
		    appendElement(this, ins);
		},
		ignorableWhitespace:function(ch, start, length) {
		},
		characters:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
			//console.log(chars)
			if(chars){
				if (this.cdata) {
					var charNode = this.doc.createCDATASection(chars);
				} else {
					var charNode = this.doc.createTextNode(chars);
				}
				if(this.currentElement){
					this.currentElement.appendChild(charNode);
				}else if(/^\s*$/.test(chars)){
					this.doc.appendChild(charNode);
					//process xml
				}
				this.locator && position(this.locator,charNode)
			}
		},
		skippedEntity:function(name) {
		},
		endDocument:function() {
			this.doc.normalize();
		},
		setDocumentLocator:function (locator) {
		    if(this.locator = locator){// && !('lineNumber' in locator)){
		    	locator.lineNumber = 0;
		    }
		},
		//LexicalHandler
		comment:function(chars, start, length) {
			chars = _toString.apply(this,arguments)
		    var comm = this.doc.createComment(chars);
		    this.locator && position(this.locator,comm)
		    appendElement(this, comm);
		},
	
		startCDATA:function() {
		    //used in characters() methods
		    this.cdata = true;
		},
		endCDATA:function() {
		    this.cdata = false;
		},
	
		startDTD:function(name, publicId, systemId) {
			var impl = this.doc.implementation;
		    if (impl && impl.createDocumentType) {
		        var dt = impl.createDocumentType(name, publicId, systemId);
		        this.locator && position(this.locator,dt)
		        appendElement(this, dt);
		    }
		},
		/**
		 * @see org.xml.sax.ErrorHandler
		 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
		 */
		warning:function(error) {
			console.warn('[xmldom warning]\t'+error,_locator(this.locator));
		},
		error:function(error) {
			console.error('[xmldom error]\t'+error,_locator(this.locator));
		},
		fatalError:function(error) {
			throw new ParseError(error, this.locator);
		}
	}
	function _locator(l){
		if(l){
			return '\n@'+(l.systemId ||'')+'#[line:'+l.lineNumber+',col:'+l.columnNumber+']'
		}
	}
	function _toString(chars,start,length){
		if(typeof chars == 'string'){
			return chars.substr(start,length)
		}else{//java sax connect width xmldom on rhino(what about: "? && !(chars instanceof String)")
			if(chars.length >= start+length || start){
				return new java.lang.String(chars,start,length)+'';
			}
			return chars;
		}
	}
	
	/*
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
	 * used method of org.xml.sax.ext.LexicalHandler:
	 *  #comment(chars, start, length)
	 *  #startCDATA()
	 *  #endCDATA()
	 *  #startDTD(name, publicId, systemId)
	 *
	 *
	 * IGNORED method of org.xml.sax.ext.LexicalHandler:
	 *  #endDTD()
	 *  #startEntity(name)
	 *  #endEntity(name)
	 *
	 *
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
	 * IGNORED method of org.xml.sax.ext.DeclHandler
	 * 	#attributeDecl(eName, aName, type, mode, value)
	 *  #elementDecl(name, model)
	 *  #externalEntityDecl(name, publicId, systemId)
	 *  #internalEntityDecl(name, value)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
	 * IGNORED method of org.xml.sax.EntityResolver2
	 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
	 *  #resolveEntity(publicId, systemId)
	 *  #getExternalSubset(name, baseURI)
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
	 * IGNORED method of org.xml.sax.DTDHandler
	 *  #notationDecl(name, publicId, systemId) {};
	 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
	 */
	"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(key){
		DOMHandler.prototype[key] = function(){return null}
	})
	
	/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */
	function appendElement (hander,node) {
	    if (!hander.currentElement) {
	        hander.doc.appendChild(node);
	    } else {
	        hander.currentElement.appendChild(node);
	    }
	}//appendChild and setAttributeNS are preformance key
	
	//if(typeof require == 'function'){
	var htmlEntity = __webpack_require__(1243);
	var sax = __webpack_require__(1244);
	var XMLReader = sax.XMLReader;
	var ParseError = sax.ParseError;
	var DOMImplementation = exports.DOMImplementation = __webpack_require__(990).DOMImplementation;
	exports.XMLSerializer = __webpack_require__(990).XMLSerializer ;
	exports.DOMParser = DOMParser;
	exports.__DOMHandler = DOMHandler;
	//}


/***/ },
/* 1243 */
/***/ function(module, exports) {

	exports.entityMap = {
	       lt: '<',
	       gt: '>',
	       amp: '&',
	       quot: '"',
	       apos: "'",
	       Agrave: "À",
	       Aacute: "Á",
	       Acirc: "Â",
	       Atilde: "Ã",
	       Auml: "Ä",
	       Aring: "Å",
	       AElig: "Æ",
	       Ccedil: "Ç",
	       Egrave: "È",
	       Eacute: "É",
	       Ecirc: "Ê",
	       Euml: "Ë",
	       Igrave: "Ì",
	       Iacute: "Í",
	       Icirc: "Î",
	       Iuml: "Ï",
	       ETH: "Ð",
	       Ntilde: "Ñ",
	       Ograve: "Ò",
	       Oacute: "Ó",
	       Ocirc: "Ô",
	       Otilde: "Õ",
	       Ouml: "Ö",
	       Oslash: "Ø",
	       Ugrave: "Ù",
	       Uacute: "Ú",
	       Ucirc: "Û",
	       Uuml: "Ü",
	       Yacute: "Ý",
	       THORN: "Þ",
	       szlig: "ß",
	       agrave: "à",
	       aacute: "á",
	       acirc: "â",
	       atilde: "ã",
	       auml: "ä",
	       aring: "å",
	       aelig: "æ",
	       ccedil: "ç",
	       egrave: "è",
	       eacute: "é",
	       ecirc: "ê",
	       euml: "ë",
	       igrave: "ì",
	       iacute: "í",
	       icirc: "î",
	       iuml: "ï",
	       eth: "ð",
	       ntilde: "ñ",
	       ograve: "ò",
	       oacute: "ó",
	       ocirc: "ô",
	       otilde: "õ",
	       ouml: "ö",
	       oslash: "ø",
	       ugrave: "ù",
	       uacute: "ú",
	       ucirc: "û",
	       uuml: "ü",
	       yacute: "ý",
	       thorn: "þ",
	       yuml: "ÿ",
	       nbsp: "\u00a0",
	       iexcl: "¡",
	       cent: "¢",
	       pound: "£",
	       curren: "¤",
	       yen: "¥",
	       brvbar: "¦",
	       sect: "§",
	       uml: "¨",
	       copy: "©",
	       ordf: "ª",
	       laquo: "«",
	       not: "¬",
	       shy: "­­",
	       reg: "®",
	       macr: "¯",
	       deg: "°",
	       plusmn: "±",
	       sup2: "²",
	       sup3: "³",
	       acute: "´",
	       micro: "µ",
	       para: "¶",
	       middot: "·",
	       cedil: "¸",
	       sup1: "¹",
	       ordm: "º",
	       raquo: "»",
	       frac14: "¼",
	       frac12: "½",
	       frac34: "¾",
	       iquest: "¿",
	       times: "×",
	       divide: "÷",
	       forall: "∀",
	       part: "∂",
	       exist: "∃",
	       empty: "∅",
	       nabla: "∇",
	       isin: "∈",
	       notin: "∉",
	       ni: "∋",
	       prod: "∏",
	       sum: "∑",
	       minus: "−",
	       lowast: "∗",
	       radic: "√",
	       prop: "∝",
	       infin: "∞",
	       ang: "∠",
	       and: "∧",
	       or: "∨",
	       cap: "∩",
	       cup: "∪",
	       'int': "∫",
	       there4: "∴",
	       sim: "∼",
	       cong: "≅",
	       asymp: "≈",
	       ne: "≠",
	       equiv: "≡",
	       le: "≤",
	       ge: "≥",
	       sub: "⊂",
	       sup: "⊃",
	       nsub: "⊄",
	       sube: "⊆",
	       supe: "⊇",
	       oplus: "⊕",
	       otimes: "⊗",
	       perp: "⊥",
	       sdot: "⋅",
	       Alpha: "Α",
	       Beta: "Β",
	       Gamma: "Γ",
	       Delta: "Δ",
	       Epsilon: "Ε",
	       Zeta: "Ζ",
	       Eta: "Η",
	       Theta: "Θ",
	       Iota: "Ι",
	       Kappa: "Κ",
	       Lambda: "Λ",
	       Mu: "Μ",
	       Nu: "Ν",
	       Xi: "Ξ",
	       Omicron: "Ο",
	       Pi: "Π",
	       Rho: "Ρ",
	       Sigma: "Σ",
	       Tau: "Τ",
	       Upsilon: "Υ",
	       Phi: "Φ",
	       Chi: "Χ",
	       Psi: "Ψ",
	       Omega: "Ω",
	       alpha: "α",
	       beta: "β",
	       gamma: "γ",
	       delta: "δ",
	       epsilon: "ε",
	       zeta: "ζ",
	       eta: "η",
	       theta: "θ",
	       iota: "ι",
	       kappa: "κ",
	       lambda: "λ",
	       mu: "μ",
	       nu: "ν",
	       xi: "ξ",
	       omicron: "ο",
	       pi: "π",
	       rho: "ρ",
	       sigmaf: "ς",
	       sigma: "σ",
	       tau: "τ",
	       upsilon: "υ",
	       phi: "φ",
	       chi: "χ",
	       psi: "ψ",
	       omega: "ω",
	       thetasym: "ϑ",
	       upsih: "ϒ",
	       piv: "ϖ",
	       OElig: "Œ",
	       oelig: "œ",
	       Scaron: "Š",
	       scaron: "š",
	       Yuml: "Ÿ",
	       fnof: "ƒ",
	       circ: "ˆ",
	       tilde: "˜",
	       ensp: " ",
	       emsp: " ",
	       thinsp: " ",
	       zwnj: "‌",
	       zwj: "‍",
	       lrm: "‎",
	       rlm: "‏",
	       ndash: "–",
	       mdash: "—",
	       lsquo: "‘",
	       rsquo: "’",
	       sbquo: "‚",
	       ldquo: "“",
	       rdquo: "”",
	       bdquo: "„",
	       dagger: "†",
	       Dagger: "‡",
	       bull: "•",
	       hellip: "…",
	       permil: "‰",
	       prime: "′",
	       Prime: "″",
	       lsaquo: "‹",
	       rsaquo: "›",
	       oline: "‾",
	       euro: "€",
	       trade: "™",
	       larr: "←",
	       uarr: "↑",
	       rarr: "→",
	       darr: "↓",
	       harr: "↔",
	       crarr: "↵",
	       lceil: "⌈",
	       rceil: "⌉",
	       lfloor: "⌊",
	       rfloor: "⌋",
	       loz: "◊",
	       spades: "♠",
	       clubs: "♣",
	       hearts: "♥",
	       diams: "♦"
	};


/***/ },
/* 1244 */
/***/ function(module, exports) {

	//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
	//[5]   	Name	   ::=   	NameStartChar (NameChar)*
	var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]///\u10000-\uEFFFF
	var nameChar = new RegExp("[\\-\\.0-9"+nameStartChar.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
	var tagNamePattern = new RegExp('^'+nameStartChar.source+nameChar.source+'*(?:\:'+nameStartChar.source+nameChar.source+'*)?$');
	//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
	//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
	
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
	var S_TAG = 0;//tag name offerring
	var S_ATTR = 1;//attr name offerring 
	var S_ATTR_SPACE=2;//attr name end and space offer
	var S_EQ = 3;//=space?
	var S_ATTR_NOQUOT_VALUE = 4;//attr value(no quot value only)
	var S_ATTR_END = 5;//attr value end and no space(quot end)
	var S_TAG_SPACE = 6;//(attr value end || tag end ) && (space offer)
	var S_TAG_CLOSE = 7;//closed el<el />
	
	/**
	 * Creates an error that will not be caught by XMLReader aka the SAX parser.
	 *
	 * @param {string} message
	 * @param {any?} locator Optional, can provide details about the location in the source
	 * @constructor
	 */
	function ParseError(message, locator) {
		this.message = message
		this.locator = locator
		if(Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
	}
	ParseError.prototype = new Error();
	ParseError.prototype.name = ParseError.name
	
	function XMLReader(){
		
	}
	
	XMLReader.prototype = {
		parse:function(source,defaultNSMap,entityMap){
			var domBuilder = this.domBuilder;
			domBuilder.startDocument();
			_copy(defaultNSMap ,defaultNSMap = {})
			parse(source,defaultNSMap,entityMap,
					domBuilder,this.errorHandler);
			domBuilder.endDocument();
		}
	}
	function parse(source,defaultNSMapCopy,entityMap,domBuilder,errorHandler){
		function fixedFromCharCode(code) {
			// String.prototype.fromCharCode does not supports
			// > 2 bytes unicode chars directly
			if (code > 0xffff) {
				code -= 0x10000;
				var surrogate1 = 0xd800 + (code >> 10)
					, surrogate2 = 0xdc00 + (code & 0x3ff);
	
				return String.fromCharCode(surrogate1, surrogate2);
			} else {
				return String.fromCharCode(code);
			}
		}
		function entityReplacer(a){
			var k = a.slice(1,-1);
			if(k in entityMap){
				return entityMap[k]; 
			}else if(k.charAt(0) === '#'){
				return fixedFromCharCode(parseInt(k.substr(1).replace('x','0x')))
			}else{
				errorHandler.error('entity not found:'+a);
				return a;
			}
		}
		function appendText(end){//has some bugs
			if(end>start){
				var xt = source.substring(start,end).replace(/&#?\w+;/g,entityReplacer);
				locator&&position(start);
				domBuilder.characters(xt,0,end-start);
				start = end
			}
		}
		function position(p,m){
			while(p>=lineEnd && (m = linePattern.exec(source))){
				lineStart = m.index;
				lineEnd = lineStart + m[0].length;
				locator.lineNumber++;
				//console.log('line++:',locator,startPos,endPos)
			}
			locator.columnNumber = p-lineStart+1;
		}
		var lineStart = 0;
		var lineEnd = 0;
		var linePattern = /.*(?:\r\n?|\n)|.*$/g
		var locator = domBuilder.locator;
		
		var parseStack = [{currentNSMap:defaultNSMapCopy}]
		var closeMap = {};
		var start = 0;
		while(true){
			try{
				var tagStart = source.indexOf('<',start);
				if(tagStart<0){
					if(!source.substr(start).match(/^\s*$/)){
						var doc = domBuilder.doc;
		    			var text = doc.createTextNode(source.substr(start));
		    			doc.appendChild(text);
		    			domBuilder.currentElement = text;
					}
					return;
				}
				if(tagStart>start){
					appendText(tagStart);
				}
				switch(source.charAt(tagStart+1)){
				case '/':
					var end = source.indexOf('>',tagStart+3);
					var tagName = source.substring(tagStart+2,end);
					var config = parseStack.pop();
					if(end<0){
						
		        		tagName = source.substring(tagStart+2).replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' is not complete:'+config.tagName);
		        		end = tagStart+1+tagName.length;
		        	}else if(tagName.match(/\s</)){
		        		tagName = tagName.replace(/[\s<].*/,'');
		        		errorHandler.error("end tag name: "+tagName+' maybe not complete');
		        		end = tagStart+1+tagName.length;
					}
					var localNSMap = config.localNSMap;
					var endMatch = config.tagName == tagName;
					var endIgnoreCaseMach = endMatch || config.tagName&&config.tagName.toLowerCase() == tagName.toLowerCase()
			        if(endIgnoreCaseMach){
			        	domBuilder.endElement(config.uri,config.localName,tagName);
						if(localNSMap){
							for(var prefix in localNSMap){
								domBuilder.endPrefixMapping(prefix) ;
							}
						}
						if(!endMatch){
			            	errorHandler.fatalError("end tag name: "+tagName+' is not match the current start tagName:'+config.tagName ); // No known test case
						}
			        }else{
			        	parseStack.push(config)
			        }
					
					end++;
					break;
					// end elment
				case '?':// <?...?>
					locator&&position(tagStart);
					end = parseInstruction(source,tagStart,domBuilder);
					break;
				case '!':// <!doctype,<![CDATA,<!--
					locator&&position(tagStart);
					end = parseDCC(source,tagStart,domBuilder,errorHandler);
					break;
				default:
					locator&&position(tagStart);
					var el = new ElementAttributes();
					var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
					//elStartEnd
					var end = parseElementStartPart(source,tagStart,el,currentNSMap,entityReplacer,errorHandler);
					var len = el.length;
					
					
					if(!el.closed && fixSelfClosed(source,end,el.tagName,closeMap)){
						el.closed = true;
						if(!entityMap.nbsp){
							errorHandler.warning('unclosed xml attribute');
						}
					}
					if(locator && len){
						var locator2 = copyLocator(locator,{});
						//try{//attribute position fixed
						for(var i = 0;i<len;i++){
							var a = el[i];
							position(a.offset);
							a.locator = copyLocator(locator,{});
						}
						domBuilder.locator = locator2
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
						domBuilder.locator = locator;
					}else{
						if(appendElement(el,domBuilder,currentNSMap)){
							parseStack.push(el)
						}
					}
					
					
					
					if(el.uri === 'http://www.w3.org/1999/xhtml' && !el.closed){
						end = parseHtmlSpecialContent(source,end,el.tagName,entityReplacer,domBuilder)
					}else{
						end++;
					}
				}
			}catch(e){
				if (e instanceof ParseError) {
					throw e;
				}
				errorHandler.error('element parse error: '+e)
				end = -1;
			}
			if(end>start){
				start = end;
			}else{
				//TODO: 这里有可能sax回退，有位置错误风险
				appendText(Math.max(tagStart,start)+1);
			}
		}
	}
	function copyLocator(f,t){
		t.lineNumber = f.lineNumber;
		t.columnNumber = f.columnNumber;
		return t;
	}
	
	/**
	 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
	 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
	 */
	function parseElementStartPart(source,start,el,currentNSMap,entityReplacer,errorHandler){
	
		/**
		 * @param {string} qname
		 * @param {string} value
		 * @param {number} startIndex
		 */
		function addAttribute(qname, value, startIndex) {
			if (qname in el.attributeNames) errorHandler.fatalError('Attribute ' + qname + ' redefined')
			el.addValue(qname, value, startIndex)
		}
		var attrName;
		var value;
		var p = ++start;
		var s = S_TAG;//status
		while(true){
			var c = source.charAt(p);
			switch(c){
			case '=':
				if(s === S_ATTR){//attrName
					attrName = source.slice(start,p);
					s = S_EQ;
				}else if(s === S_ATTR_SPACE){
					s = S_EQ;
				}else{
					//fatalError: equal must after attrName or space after attrName
					throw new Error('attribute equal must after attrName'); // No known test case
				}
				break;
			case '\'':
			case '"':
				if(s === S_EQ || s === S_ATTR //|| s == S_ATTR_SPACE
					){//equal
					if(s === S_ATTR){
						errorHandler.warning('attribute value must after "="')
						attrName = source.slice(start,p)
					}
					start = p+1;
					p = source.indexOf(c,start)
					if(p>0){
						value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
						addAttribute(attrName, value, start-1);
						s = S_ATTR_END;
					}else{
						//fatalError: no end quot match
						throw new Error('attribute value no end \''+c+'\' match');
					}
				}else if(s == S_ATTR_NOQUOT_VALUE){
					value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
					//console.log(attrName,value,start,p)
					addAttribute(attrName, value, start);
					//console.dir(el)
					errorHandler.warning('attribute "'+attrName+'" missed start quot('+c+')!!');
					start = p+1;
					s = S_ATTR_END
				}else{
					//fatalError: no equal before
					throw new Error('attribute value must after "="'); // No known test case
				}
				break;
			case '/':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					s =S_TAG_CLOSE;
					el.closed = true;
				case S_ATTR_NOQUOT_VALUE:
				case S_ATTR:
				case S_ATTR_SPACE:
					break;
				//case S_EQ:
				default:
					throw new Error("attribute invalid close char('/')") // No known test case
				}
				break;
			case ''://end document
				errorHandler.error('unexpected end of input');
				if(s == S_TAG){
					el.setTagName(source.slice(start,p));
				}
				return p;
			case '>':
				switch(s){
				case S_TAG:
					el.setTagName(source.slice(start,p));
				case S_ATTR_END:
				case S_TAG_SPACE:
				case S_TAG_CLOSE:
					break;//normal
				case S_ATTR_NOQUOT_VALUE://Compatible state
				case S_ATTR:
					value = source.slice(start,p);
					if(value.slice(-1) === '/'){
						el.closed  = true;
						value = value.slice(0,-1)
					}
				case S_ATTR_SPACE:
					if(s === S_ATTR_SPACE){
						value = attrName;
					}
					if(s == S_ATTR_NOQUOT_VALUE){
						errorHandler.warning('attribute "'+value+'" missed quot(")!');
						addAttribute(attrName, value.replace(/&#?\w+;/g,entityReplacer), start)
					}else{
						if(currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !value.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+value+'" missed value!! "'+value+'" instead!!')
						}
						addAttribute(value, value, start)
					}
					break;
				case S_EQ:
					throw new Error('attribute value missed!!');
				}
	//			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
				return p;
			/*xml space '\x20' | #x9 | #xD | #xA; */
			case '\u0080':
				c = ' ';
			default:
				if(c<= ' '){//space
					switch(s){
					case S_TAG:
						el.setTagName(source.slice(start,p));//tagName
						s = S_TAG_SPACE;
						break;
					case S_ATTR:
						attrName = source.slice(start,p)
						s = S_ATTR_SPACE;
						break;
					case S_ATTR_NOQUOT_VALUE:
						var value = source.slice(start,p).replace(/&#?\w+;/g,entityReplacer);
						errorHandler.warning('attribute "'+value+'" missed quot(")!!');
						addAttribute(attrName, value, start)
					case S_ATTR_END:
						s = S_TAG_SPACE;
						break;
					//case S_TAG_SPACE:
					//case S_EQ:
					//case S_ATTR_SPACE:
					//	void();break;
					//case S_TAG_CLOSE:
						//ignore warning
					}
				}else{//not space
	//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
	//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
					switch(s){
					//case S_TAG:void();break;
					//case S_ATTR:void();break;
					//case S_ATTR_NOQUOT_VALUE:void();break;
					case S_ATTR_SPACE:
						var tagName =  el.tagName;
						if(currentNSMap[''] !== 'http://www.w3.org/1999/xhtml' || !attrName.match(/^(?:disabled|checked|selected)$/i)){
							errorHandler.warning('attribute "'+attrName+'" missed value!! "'+attrName+'" instead2!!')
						}
						addAttribute(attrName, attrName, start);
						start = p;
						s = S_ATTR;
						break;
					case S_ATTR_END:
						errorHandler.warning('attribute space is required"'+attrName+'"!!')
					case S_TAG_SPACE:
						s = S_ATTR;
						start = p;
						break;
					case S_EQ:
						s = S_ATTR_NOQUOT_VALUE;
						start = p;
						break;
					case S_TAG_CLOSE:
						throw new Error("elements closed character '/' and '>' must be connected to");
					}
				}
			}//end outer switch
			//console.log('p++',p)
			p++;
		}
	}
	/**
	 * @return true if has new namespace define
	 */
	function appendElement(el,domBuilder,currentNSMap){
		var tagName = el.tagName;
		var localNSMap = null;
		//var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
		var i = el.length;
		while(i--){
			var a = el[i];
			var qName = a.qName;
			var value = a.value;
			var nsp = qName.indexOf(':');
			if(nsp>0){
				var prefix = a.prefix = qName.slice(0,nsp);
				var localName = qName.slice(nsp+1);
				var nsPrefix = prefix === 'xmlns' && localName
			}else{
				localName = qName;
				prefix = null
				nsPrefix = qName === 'xmlns' && ''
			}
			//can not set prefix,because prefix !== ''
			a.localName = localName ;
			//prefix == null for no ns prefix attribute 
			if(nsPrefix !== false){//hack!!
				if(localNSMap == null){
					localNSMap = {}
					//console.log(currentNSMap,0)
					_copy(currentNSMap,currentNSMap={})
					//console.log(currentNSMap,1)
				}
				currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
				a.uri = 'http://www.w3.org/2000/xmlns/'
				domBuilder.startPrefixMapping(nsPrefix, value) 
			}
		}
		var i = el.length;
		while(i--){
			a = el[i];
			var prefix = a.prefix;
			if(prefix){//no prefix attribute has no namespace
				if(prefix === 'xml'){
					a.uri = 'http://www.w3.org/XML/1998/namespace';
				}if(prefix !== 'xmlns'){
					a.uri = currentNSMap[prefix || '']
					
					//{console.log('###'+a.qName,domBuilder.locator.systemId+'',currentNSMap,a.uri)}
				}
			}
		}
		var nsp = tagName.indexOf(':');
		if(nsp>0){
			prefix = el.prefix = tagName.slice(0,nsp);
			localName = el.localName = tagName.slice(nsp+1);
		}else{
			prefix = null;//important!!
			localName = el.localName = tagName;
		}
		//no prefix element has default namespace
		var ns = el.uri = currentNSMap[prefix || ''];
		domBuilder.startElement(ns,localName,tagName,el);
		//endPrefixMapping and startPrefixMapping have not any help for dom builder
		//localNSMap = null
		if(el.closed){
			domBuilder.endElement(ns,localName,tagName);
			if(localNSMap){
				for(prefix in localNSMap){
					domBuilder.endPrefixMapping(prefix) 
				}
			}
		}else{
			el.currentNSMap = currentNSMap;
			el.localNSMap = localNSMap;
			//parseStack.push(el);
			return true;
		}
	}
	function parseHtmlSpecialContent(source,elStartEnd,tagName,entityReplacer,domBuilder){
		if(/^(?:script|textarea)$/i.test(tagName)){
			var elEndStart =  source.indexOf('</'+tagName+'>',elStartEnd);
			var text = source.substring(elStartEnd+1,elEndStart);
			if(/[&<]/.test(text)){
				if(/^script$/i.test(tagName)){
					//if(!/\]\]>/.test(text)){
						//lexHandler.startCDATA();
						domBuilder.characters(text,0,text.length);
						//lexHandler.endCDATA();
						return elEndStart;
					//}
				}//}else{//text area
					text = text.replace(/&#?\w+;/g,entityReplacer);
					domBuilder.characters(text,0,text.length);
					return elEndStart;
				//}
				
			}
		}
		return elStartEnd+1;
	}
	function fixSelfClosed(source,elStartEnd,tagName,closeMap){
		//if(tagName in closeMap){
		var pos = closeMap[tagName];
		if(pos == null){
			//console.log(tagName)
			pos =  source.lastIndexOf('</'+tagName+'>')
			if(pos<elStartEnd){//忘记闭合
				pos = source.lastIndexOf('</'+tagName)
			}
			closeMap[tagName] =pos
		}
		return pos<elStartEnd;
		//} 
	}
	function _copy(source,target){
		for(var n in source){target[n] = source[n]}
	}
	function parseDCC(source,start,domBuilder,errorHandler){//sure start with '<!'
		var next= source.charAt(start+2)
		switch(next){
		case '-':
			if(source.charAt(start + 3) === '-'){
				var end = source.indexOf('-->',start+4);
				//append comment source.substring(4,end)//<!--
				if(end>start){
					domBuilder.comment(source,start+4,end-start-4);
					return end+3;
				}else{
					errorHandler.error("Unclosed comment");
					return -1;
				}
			}else{
				//error
				return -1;
			}
		default:
			if(source.substr(start+3,6) == 'CDATA['){
				var end = source.indexOf(']]>',start+9);
				domBuilder.startCDATA();
				domBuilder.characters(source,start+9,end-start-9);
				domBuilder.endCDATA() 
				return end+3;
			}
			//<!DOCTYPE
			//startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId) 
			var matchs = split(source,start);
			var len = matchs.length;
			if(len>1 && /!doctype/i.test(matchs[0][0])){
				var name = matchs[1][0];
				var pubid = false;
				var sysid = false;
				if(len>3){
					if(/^public$/i.test(matchs[2][0])){
						pubid = matchs[3][0];
						sysid = len>4 && matchs[4][0];
					}else if(/^system$/i.test(matchs[2][0])){
						sysid = matchs[3][0];
					}
				}
				var lastMatch = matchs[len-1]
				domBuilder.startDTD(name, pubid, sysid);
				domBuilder.endDTD();
				
				return lastMatch.index+lastMatch[0].length
			}
		}
		return -1;
	}
	
	
	
	function parseInstruction(source,start,domBuilder){
		var end = source.indexOf('?>',start);
		if(end){
			var match = source.substring(start,end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
			if(match){
				var len = match[0].length;
				domBuilder.processingInstruction(match[1], match[2]) ;
				return end+2;
			}else{//error
				return -1;
			}
		}
		return -1;
	}
	
	function ElementAttributes(){
		this.attributeNames = {}
	}
	ElementAttributes.prototype = {
		setTagName:function(tagName){
			if(!tagNamePattern.test(tagName)){
				throw new Error('invalid tagName:'+tagName)
			}
			this.tagName = tagName
		},
		addValue:function(qName, value, offset) {
			if(!tagNamePattern.test(qName)){
				throw new Error('invalid attribute:'+qName)
			}
			this.attributeNames[qName] = this.length;
			this[this.length++] = {qName:qName,value:value,offset:offset}
		},
		length:0,
		getLocalName:function(i){return this[i].localName},
		getLocator:function(i){return this[i].locator},
		getQName:function(i){return this[i].qName},
		getURI:function(i){return this[i].uri},
		getValue:function(i){return this[i].value}
	//	,getIndex:function(uri, localName)){
	//		if(localName){
	//			
	//		}else{
	//			var qName = uri
	//		}
	//	},
	//	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
	//	getType:function(uri,localName){}
	//	getType:function(i){},
	}
	
	
	
	function split(source,start){
		var match;
		var buf = [];
		var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
		reg.lastIndex = start;
		reg.exec(source);//skip <
		while(match = reg.exec(source)){
			buf.push(match);
			if(match[1])return buf;
		}
	}
	
	exports.XMLReader = XMLReader;
	exports.ParseError = ParseError;


/***/ },
/* 1245 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(992);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(1259);
	var assign = __webpack_require__(25);
	
	var ReactPropTypesSecret = __webpack_require__(992);
	var checkPropTypes = __webpack_require__(1246);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.11.0
	 * react-art.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var aa=__webpack_require__(1),ba=__webpack_require__(25),ca=__webpack_require__(61),da=__webpack_require__(1086),m=__webpack_require__(1504);var ha=__webpack_require__(1087);function ia(){ia=Object.assign||function(a){for(var b=1;b<arguments.length;b++){var c=arguments[b],d;for(d in c)Object.prototype.hasOwnProperty.call(c,d)&&(a[d]=c[d])}return a};return ia.apply(this,arguments)}
	function ja(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a;a.__proto__=b}function ka(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}
	function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var t=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;t.hasOwnProperty("ReactCurrentDispatcher")||(t.ReactCurrentDispatcher={current:null});
	t.hasOwnProperty("ReactCurrentBatchConfig")||(t.ReactCurrentBatchConfig={suspense:null});
	var w="function"===typeof Symbol&&Symbol.for,la=w?Symbol.for("react.element"):60103,ma=w?Symbol.for("react.portal"):60106,na=w?Symbol.for("react.fragment"):60107,oa=w?Symbol.for("react.strict_mode"):60108,pa=w?Symbol.for("react.profiler"):60114,qa=w?Symbol.for("react.provider"):60109,ra=w?Symbol.for("react.context"):60110,sa=w?Symbol.for("react.concurrent_mode"):60111,ta=w?Symbol.for("react.forward_ref"):60112,ua=w?Symbol.for("react.suspense"):60113,va=w?Symbol.for("react.suspense_list"):60120,wa=
	w?Symbol.for("react.memo"):60115,xa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var ya="function"===typeof Symbol&&Symbol.iterator;function za(a){if(null===a||"object"!==typeof a)return null;a=ya&&a[ya]||a["@@iterator"];return"function"===typeof a?a:null}
	function Aa(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Ba(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case na:return"Fragment";case ma:return"Portal";case pa:return"Profiler";case oa:return"StrictMode";case ua:return"Suspense";case va:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ra:return"Context.Consumer";case qa:return"Context.Provider";case ta:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case wa:return Ba(a.type);case xa:if(a=1===a._status?a._result:null)return Ba(a)}return null}function Da(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Ea(a){if(Da(a)!==a)throw Error(p(188));}
	function Fa(a){var b=a.alternate;if(!b){b=Da(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Ea(e),a;if(f===d)return Ea(e),b;f=f.sibling}throw Error(p(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,l=e.child;l;){if(l===c){g=!0;c=e;d=f;break}if(l===d){g=!0;d=e;c=f;break}l=l.sibling}if(!g){for(l=f.child;l;){if(l===
	c){g=!0;c=f;d=e;break}if(l===d){g=!0;d=f;c=e;break}l=l.sibling}if(!g)throw Error(p(189));}}if(c.alternate!==d)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function Ga(a){a=Fa(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var Ha={CLIPPING_RECTANGLE:"ClippingRectangle",GROUP:"Group",SHAPE:"Shape",TEXT:"Text"},Ia={onClick:"click",onMouseMove:"mousemove",onMouseOver:"mouseover",onMouseOut:"mouseout",onMouseUp:"mouseup",onMouseDown:"mousedown"};function Ja(a){return a?"string"===typeof a?a:a.length?a.join(""):"":""}function Ka(){throw Error(p(305));}var La=new ca,Ma={},Na={};function Oa(a){return function(b){var c=a._listeners[b.type];c&&("function"===typeof c?c.call(a,b):c.handleEvent&&c.handleEvent(b))}}
	function Pa(a){if(a._subscriptions)for(var b in a._subscriptions)a._subscriptions[b]();a._subscriptions=null;a._listeners=null}function Qa(a,b){Ra(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:{});a.width=b.width;a.height=b.height}function Sa(a,b){Ra(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:{});a.width=b.width;a.height=b.height}
	function Ra(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};var d=null!=b.scaleX?b.scaleX:null!=b.scale?b.scale:1;var e=null!=b.scaleY?b.scaleY:null!=b.scale?b.scale:1;La.transformTo(1,0,0,1,0,0).move(b.x||0,b.y||0).rotate(b.rotation||0,b.originX,b.originY).scale(d,e,b.originX,b.originY);null!=b.transform&&La.transform(b.transform);a.xx===La.xx&&a.yx===La.yx&&a.xy===La.xy&&a.yy===La.yy&&a.x===La.x&&a.y===La.y||a.transformTo(La);b.cursor===c.cursor&&b.title===c.title||a.indicate(b.cursor,
	b.title);a.blend&&b.opacity!==c.opacity&&a.blend(null==b.opacity?1:b.opacity);b.visible!==c.visible&&(null==b.visible||b.visible?a.show():a.hide());for(var f in Ia)c=a,d=Ia[f],e=b[f],c._listeners||(c._listeners={},c._subscriptions={}),(c._listeners[d]=e)?c._subscriptions[d]||(c._subscriptions[d]=c.subscribe(d,Oa(c),c)):c._subscriptions[d]&&(c._subscriptions[d](),delete c._subscriptions[d])}
	function Ta(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};Ra(a,b,c);c.fill!==b.fill&&(b.fill&&b.fill.applyFill?b.fill.applyFill(a):a.fill(b.fill));c.stroke===b.stroke&&c.strokeWidth===b.strokeWidth&&c.strokeCap===b.strokeCap&&c.strokeJoin===b.strokeJoin&&c.strokeDash===b.strokeDash||a.stroke(b.stroke,b.strokeWidth,b.strokeCap,b.strokeJoin,b.strokeDash)}
	function Ua(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};Ta(a,b,c);var d=b.d||Ja(b.children),e=a._prevDelta;if(d!==a._prevPath||d.delta!==e||c.height!==b.height||c.width!==b.width)a.draw(d,b.width,b.height),a._prevDelta=d.delta,a._prevPath=d}
	function Va(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};Ta(a,b,c);var d=b.children,e;if(!(e=a._currentString!==d)){e=b.font;var f=c.font;e=e===f?!0:"string"===typeof f||"string"===typeof e?!1:f.fontSize===e.fontSize&&f.fontStyle===e.fontStyle&&f.fontVariant===e.fontVariant&&f.fontWeight===e.fontWeight&&f.fontFamily===e.fontFamily;e=!e}if(e||b.alignment!==c.alignment||b.path!==c.path)a.draw(d,b.font,b.alignment,b.path),a._currentString=d}var Wa=setTimeout,Xa=clearTimeout;
	function Ya(a,b){return"string"===typeof b.children||"number"===typeof b.children}var Za=/^(.*)[\\\/]/;function $a(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ba(a.type);c=null;d&&(c=Ba(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Za,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}new Set;var ab=[],bb=-1;
	function x(a){0>bb||(a.current=ab[bb],ab[bb]=null,bb--)}function z(a,b){bb++;ab[bb]=a.current;a.current=b}var cb={},A={current:cb},B={current:!1},db=cb;function eb(a,b){var c=a.type.contextTypes;if(!c)return cb;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}
	function D(a){a=a.childContextTypes;return null!==a&&void 0!==a}function fb(a){x(B,a);x(A,a)}function gb(a){x(B,a);x(A,a)}function hb(a,b,c){if(A.current!==cb)throw Error(p(168));z(A,b,a);z(B,c,a)}function ib(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(p(108,Ba(b)||"Unknown",e));return ba({},c,{},d)}
	function jb(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||cb;db=A.current;z(A,b,a);z(B,B.current,a);return!0}function kb(a,b,c){var d=a.stateNode;if(!d)throw Error(p(169));c?(b=ib(a,b,db),d.__reactInternalMemoizedMergedChildContext=b,x(B,a),x(A,a),z(A,b,a)):x(B,a);z(B,c,a)}
	var lb=m.unstable_runWithPriority,mb=m.unstable_scheduleCallback,nb=m.unstable_cancelCallback,ob=m.unstable_shouldYield,pb=m.unstable_requestPaint,qb=m.unstable_now,rb=m.unstable_getCurrentPriorityLevel,sb=m.unstable_ImmediatePriority,tb=m.unstable_UserBlockingPriority,ub=m.unstable_NormalPriority,vb=m.unstable_LowPriority,wb=m.unstable_IdlePriority,xb={},yb=void 0!==pb?pb:function(){},zb=null,Ab=null,Bb=!1,Cb=qb(),E=1E4>Cb?qb:function(){return qb()-Cb};
	function Db(){switch(rb()){case sb:return 99;case tb:return 98;case ub:return 97;case vb:return 96;case wb:return 95;default:throw Error(p(332));}}function Eb(a){switch(a){case 99:return sb;case 98:return tb;case 97:return ub;case 96:return vb;case 95:return wb;default:throw Error(p(332));}}function Fb(a,b){a=Eb(a);return lb(a,b)}function Gb(a,b,c){a=Eb(a);return mb(a,b,c)}function Hb(a){null===zb?(zb=[a],Ab=mb(sb,Ib)):zb.push(a);return xb}function Jb(){if(null!==Ab){var a=Ab;Ab=null;nb(a)}Ib()}
	function Ib(){if(!Bb&&null!==zb){Bb=!0;var a=0;try{var b=zb;Fb(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});zb=null}catch(c){throw null!==zb&&(zb=zb.slice(a+1)),mb(sb,Jb),c;}finally{Bb=!1}}}function Kb(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var Lb="function"===typeof Object.is?Object.is:Kb,Mb=Object.prototype.hasOwnProperty;
	function Nb(a,b){if(Lb(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Mb.call(b,c[d])||!Lb(a[c[d]],b[c[d]]))return!1;return!0}function G(a,b){if(a&&a.defaultProps){b=ba({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var Ob={current:null},Pb=null,Qb=null,Rb=null;function Sb(){Rb=Qb=Pb=null}
	function Tb(a,b){var c=a.type._context;z(Ob,c._currentValue2,a);c._currentValue2=b}function Ub(a){var b=Ob.current;x(Ob,a);a.type._context._currentValue2=b}function Vb(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function Wb(a,b){Pb=a;Rb=Qb=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(H=!0),a.firstContext=null)}function I(a,b){if(Rb!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Rb=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Qb){if(null===Pb)throw Error(p(308));Qb=b;Pb.dependencies={expirationTime:0,firstContext:b,responders:null}}else Qb=Qb.next=b}return a._currentValue2}var Xb=!1;
	function Yb(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Zb(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function $b(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function ac(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function bc(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Yb(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Yb(a.memoizedState),e=c.updateQueue=Yb(c.memoizedState)):d=a.updateQueue=Zb(e):null===e&&(e=c.updateQueue=Zb(d));null===e||d===e?ac(d,b):null===d.lastUpdate||null===e.lastUpdate?(ac(d,b),ac(e,b)):(ac(d,b),e.lastUpdate=b)}
	function cc(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Yb(a.memoizedState):dc(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function dc(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Zb(b));return b}
	function ec(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return ba({},d,e);case 2:Xb=!0}return d}
	function fc(a,b,c,d,e){Xb=!1;b=dc(a,b);for(var f=b.baseState,g=null,l=0,h=b.firstUpdate,k=f;null!==h;){var n=h.expirationTime;n<e?(null===g&&(g=h,f=k),l<n&&(l=n)):(gc(n,h.suspenseConfig),k=ec(a,b,h,k,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=h:(b.lastEffect.nextEffect=h,b.lastEffect=h)));h=h.next}n=null;for(h=b.firstCapturedUpdate;null!==h;){var C=h.expirationTime;C<e?(null===n&&(n=h,null===g&&(f=k)),l<C&&(l=C)):(k=ec(a,b,h,k,c,d),null!==
	h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=h:(b.lastCapturedEffect.nextEffect=h,b.lastCapturedEffect=h)));h=h.next}null===g&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===n&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=n;hc(l);a.expirationTime=l;a.memoizedState=k}
	function ic(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);jc(b.firstEffect,c);b.firstEffect=b.lastEffect=null;jc(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function jc(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(p(191,c));c.call(d)}a=a.nextEffect}}
	var kc=t.ReactCurrentBatchConfig,lc=(new aa.Component).refs;function mc(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:ba({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var qc={isMounted:function(a){return(a=a._reactInternalFiber)?Da(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=nc(),e=kc.suspense;d=oc(d,a,e);e=$b(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);bc(a,e);pc(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=nc(),e=kc.suspense;d=oc(d,a,e);e=$b(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);bc(a,e);pc(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=nc(),d=kc.suspense;
	c=oc(c,a,d);d=$b(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);bc(a,d);pc(a,c)}};function rc(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Nb(c,d)||!Nb(e,f):!0}
	function sc(a,b,c){var d=!1,e=cb;var f=b.contextType;"object"===typeof f&&null!==f?f=I(f):(e=D(b)?db:A.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?eb(a,e):cb);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=qc;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function tc(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qc.enqueueReplaceState(b,b.state,null)}
	function uc(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=lc;var f=b.contextType;"object"===typeof f&&null!==f?e.context=I(f):(f=D(b)?db:A.current,e.context=eb(a,f));f=a.updateQueue;null!==f&&(fc(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(mc(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&qc.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(fc(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var vc=Array.isArray;
	function wc(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(p(309));var d=c.stateNode}if(!d)throw Error(p(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(b){var a=d.refs;a===lc&&(a=d.refs={});null===b?delete a[e]:a[e]=b};b._stringRef=e;return b}if("string"!==typeof a)throw Error(p(284));if(!c._owner)throw Error(p(290,a));}return a}
	function xc(a,b){if("textarea"!==a.type)throw Error(p(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function yc(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(b,a){for(b=new Map;null!==a;)null!==a.key?b.set(a.key,a):b.set(a.index,a),a=a.sibling;return b}function e(b,a,c){b=zc(b,a,c);b.index=0;b.sibling=null;return b}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function l(b,a,c,d){if(null===a||6!==a.tag)return a=Ac(c,b.mode,d),a.return=b,a;a=e(a,c,d);a.return=b;return a}function h(b,a,c,d){if(null!==a&&a.elementType===c.type)return d=e(a,c.props,d),d.ref=wc(b,a,c),d.return=b,d;d=Bc(c.type,c.key,c.props,null,b.mode,d);d.ref=wc(b,a,c);d.return=b;return d}function k(b,a,c,d){if(null===a||4!==a.tag||a.stateNode.containerInfo!==c.containerInfo||a.stateNode.implementation!==
	c.implementation)return a=Cc(c,b.mode,d),a.return=b,a;a=e(a,c.children||[],d);a.return=b;return a}function n(b,a,c,d,f){if(null===a||7!==a.tag)return a=Dc(c,b.mode,d,f),a.return=b,a;a=e(a,c,d);a.return=b;return a}function C(b,a,c){if("string"===typeof a||"number"===typeof a)return a=Ac(""+a,b.mode,c),a.return=b,a;if("object"===typeof a&&null!==a){switch(a.$$typeof){case la:return c=Bc(a.type,a.key,a.props,null,b.mode,c),c.ref=wc(b,null,a),c.return=b,c;case ma:return a=Cc(a,b.mode,c),a.return=b,a}if(vc(a)||
	za(a))return a=Dc(a,b.mode,c,null),a.return=b,a;xc(b,a)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:l(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case la:return c.key===e?c.type===na?n(a,b,c.props.children,d,e):h(a,b,c,d):null;case ma:return c.key===e?k(a,b,c,d):null}if(vc(c)||za(c))return null!==e?null:n(a,b,c,d,null);xc(a,c)}return null}function F(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,l(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case la:return a=a.get(null===d.key?c:d.key)||null,d.type===na?n(b,a,d.props.children,e,d.key):h(b,a,d,e);case ma:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(vc(d)||za(d))return a=a.get(c)||null,n(b,a,d,e,null);xc(b,d)}return null}function ea(e,g,h,k){for(var l=null,v=null,q=g,r=g=0,n=null;null!==q&&r<h.length;r++){q.index>r?(n=q,q=null):n=q.sibling;var u=y(e,q,h[r],k);if(null===u){null===q&&(q=n);break}a&&
	q&&null===u.alternate&&b(e,q);g=f(u,g,r);null===v?l=u:v.sibling=u;v=u;q=n}if(r===h.length)return c(e,q),l;if(null===q){for(;r<h.length;r++)q=C(e,h[r],k),null!==q&&(g=f(q,g,r),null===v?l=q:v.sibling=q,v=q);return l}for(q=d(e,q);r<h.length;r++)n=F(q,e,r,h[r],k),null!==n&&(a&&null!==n.alternate&&q.delete(null===n.key?r:n.key),g=f(n,g,r),null===v?l=n:v.sibling=n,v=n);a&&q.forEach(function(a){return b(e,a)});return l}function fa(e,g,h,l){var k=za(h);if("function"!==typeof k)throw Error(p(150));h=k.call(h);
	if(null==h)throw Error(p(151));for(var q=k=null,r=g,v=g=0,n=null,u=h.next();null!==r&&!u.done;v++,u=h.next()){r.index>v?(n=r,r=null):n=r.sibling;var L=y(e,r,u.value,l);if(null===L){null===r&&(r=n);break}a&&r&&null===L.alternate&&b(e,r);g=f(L,g,v);null===q?k=L:q.sibling=L;q=L;r=n}if(u.done)return c(e,r),k;if(null===r){for(;!u.done;v++,u=h.next())u=C(e,u.value,l),null!==u&&(g=f(u,g,v),null===q?k=u:q.sibling=u,q=u);return k}for(r=d(e,r);!u.done;v++,u=h.next())u=F(r,e,v,u.value,l),null!==u&&(a&&null!==
	u.alternate&&r.delete(null===u.key?v:u.key),g=f(u,g,v),null===q?k=u:q.sibling=u,q=u);a&&r.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===na&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case la:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===na:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===na?f.props.children:f.props,h);d.ref=wc(a,k,f);d.return=a;a=d;break a}else{c(a,
	k);break}else b(a,k);k=k.sibling}f.type===na?(d=Dc(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Bc(f.type,f.key,f.props,null,a.mode,h),h.ref=wc(a,d,f),h.return=a,a=h)}return g(a);case ma:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Cc(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
	typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=Ac(f,a.mode,h),d.return=a,a=d),g(a);if(vc(f))return ea(a,d,f,h);if(za(f))return fa(a,d,f,h);l&&xc(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(p(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Ec=yc(!0),Fc=yc(!1),Gc={},J={current:Gc},Hc={current:Gc},Ic={current:Gc};function Jc(a){if(a===Gc)throw Error(p(174));return a}
	function Kc(a,b){z(Ic,b,a);z(Hc,a,a);z(J,Gc,a);x(J,a);z(J,Ma,a)}function Lc(a){x(J,a);x(Hc,a);x(Ic,a)}function Mc(a){Jc(Ic.current);Jc(J.current)!==Ma&&(z(Hc,a,a),z(J,Ma,a))}function Nc(a){Hc.current===a&&(x(J,a),x(Hc,a))}var K={current:0};
	function Oc(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||Ka(c)||Ka(c)))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function Pc(a,b){return{responder:a,props:b}}
	var Qc=t.ReactCurrentDispatcher,M=t.ReactCurrentBatchConfig,Rc=0,Sc=null,N=null,O=null,Tc=null,P=null,Uc=null,Vc=0,Wc=null,Xc=0,Yc=!1,Zc=null,$c=0;function Q(){throw Error(p(321));}function ad(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!Lb(a[c],b[c]))return!1;return!0}
	function bd(a,b,c,d,e,f){Rc=f;Sc=b;O=null!==a?a.memoizedState:null;Qc.current=null===O?cd:dd;b=c(d,e);if(Yc){do Yc=!1,$c+=1,O=null!==a?a.memoizedState:null,Uc=Tc,Wc=P=N=null,Qc.current=dd,b=c(d,e);while(Yc);Zc=null;$c=0}Qc.current=ed;a=Sc;a.memoizedState=Tc;a.expirationTime=Vc;a.updateQueue=Wc;a.effectTag|=Xc;a=null!==N&&null!==N.next;Rc=0;Uc=P=Tc=O=N=Sc=null;Vc=0;Wc=null;Xc=0;if(a)throw Error(p(300));return b}
	function fd(){Qc.current=ed;Rc=0;Uc=P=Tc=O=N=Sc=null;Vc=0;Wc=null;Xc=0;Yc=!1;Zc=null;$c=0}function gd(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?Tc=P=a:P=P.next=a;return P}function hd(){if(null!==Uc)P=Uc,Uc=P.next,N=O,O=null!==N?N.next:null;else{if(null===O)throw Error(p(310));N=O;var a={memoizedState:N.memoizedState,baseState:N.baseState,queue:N.queue,baseUpdate:N.baseUpdate,next:null};P=null===P?Tc=a:P.next=a;O=N.next}return P}
	function id(a,b){return"function"===typeof b?b(a):b}
	function jd(a){var b=hd(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;if(0<$c){var d=c.dispatch;if(null!==Zc){var e=Zc.get(c);if(void 0!==e){Zc.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);Lb(f,b.memoizedState)||(H=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var l=e=null,h=d,k=!1;do{var n=h.expirationTime;n<Rc?(k||(k=!0,l=g,e=f),n>Vc&&(Vc=n,hc(Vc))):(gc(n,h.suspenseConfig),f=h.eagerReducer===a?h.eagerState:a(f,h.action));g=h;h=h.next}while(null!==h&&h!==d);k||(l=g,e=f);Lb(f,b.memoizedState)||(H=!0);b.memoizedState=f;b.baseUpdate=l;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function kd(a){var b=gd();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:id,lastRenderedState:a};a=a.dispatch=ld.bind(null,Sc,a);return[b.memoizedState,a]}function md(a){return jd(id,a)}function nd(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Wc?(Wc={lastEffect:null},Wc.lastEffect=a.next=a):(b=Wc.lastEffect,null===b?Wc.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Wc.lastEffect=a));return a}
	function od(a,b,c,d){var e=gd();Xc|=a;e.memoizedState=nd(b,c,void 0,void 0===d?null:d)}function pd(a,b,c,d){var e=hd();d=void 0===d?null:d;var f=void 0;if(null!==N){var g=N.memoizedState;f=g.destroy;if(null!==d&&ad(d,g.deps)){nd(0,c,f,d);return}}Xc|=a;e.memoizedState=nd(b,c,f,d)}function qd(a,b){return od(516,192,a,b)}function rd(a,b){return pd(516,192,a,b)}
	function sd(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function td(){}function ud(a,b){gd().memoizedState=[a,void 0===b?null:b];return a}function vd(a,b){var c=hd();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ad(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function ld(a,b,c){if(!(25>$c))throw Error(p(301));var d=a.alternate;if(a===Sc||null!==d&&d===Sc)if(Yc=!0,a={expirationTime:Rc,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Zc&&(Zc=new Map),c=Zc.get(b),void 0===c)Zc.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=nc(),f=kc.suspense;e=oc(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var l=g.next;null!==l&&
	(f.next=l);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var h=b.lastRenderedState,k=d(h,c);f.eagerReducer=d;f.eagerState=k;if(Lb(k,h))return}catch(n){}finally{}pc(a,e)}}
	var ed={readContext:I,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},cd={readContext:I,useCallback:ud,useContext:I,useEffect:qd,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return od(4,36,sd.bind(null,b,a),c)},useLayoutEffect:function(a,b){return od(4,36,a,b)},useMemo:function(a,b){var c=gd();b=void 0===b?null:b;a=a();c.memoizedState=
	[a,b];return a},useReducer:function(a,b,c){var d=gd();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=ld.bind(null,Sc,a);return[d.memoizedState,a]},useRef:function(a){var b=gd();a={current:a};return b.memoizedState=a},useState:kd,useDebugValue:td,useResponder:Pc,useDeferredValue:function(a,b){var c=kd(a),d=c[0],e=c[1];qd(function(){m.unstable_next(function(){var c=M.suspense;M.suspense=void 0===b?null:b;try{e(a)}finally{M.suspense=
	c}})},[a,b]);return d},useTransition:function(a){var b=kd(!1),c=b[0],d=b[1];return[ud(function(b){d(!0);m.unstable_next(function(){var c=M.suspense;M.suspense=void 0===a?null:a;try{d(!1),b()}finally{M.suspense=c}})},[a,c]),c]}},dd={readContext:I,useCallback:vd,useContext:I,useEffect:rd,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return pd(4,36,sd.bind(null,b,a),c)},useLayoutEffect:function(a,b){return pd(4,36,a,b)},useMemo:function(a,b){var c=hd();b=void 0===b?null:
	b;var d=c.memoizedState;if(null!==d&&null!==b&&ad(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:jd,useRef:function(){return hd().memoizedState},useState:md,useDebugValue:td,useResponder:Pc,useDeferredValue:function(a,b){var c=md(a),d=c[0],e=c[1];rd(function(){m.unstable_next(function(){var c=M.suspense;M.suspense=void 0===b?null:b;try{e(a)}finally{M.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=md(!1),c=b[0],d=b[1];return[vd(function(b){d(!0);m.unstable_next(function(){var c=
	M.suspense;M.suspense=void 0===a?null:a;try{d(!1),b()}finally{M.suspense=c}})},[a,c]),c]}},wd=null,xd=null,yd=!1;function zd(a,b){switch(a.tag){case 5:return b=Ka(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=Ka(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Ad(a){if(yd){var b=xd;if(b){var c=b;if(!zd(a,b)){b=Ka(c);if(!b||!zd(a,b)){a.effectTag=a.effectTag&-1025|2;yd=!1;wd=a;return}var d=wd,e=Bd(5,null,null,0);e.elementType="DELETED";e.type="DELETED";e.stateNode=c;e.return=d;e.effectTag=8;null!==d.lastEffect?(d.lastEffect.nextEffect=e,d.lastEffect=e):d.firstEffect=d.lastEffect=e}wd=a;xd=Ka(b)}else a.effectTag=a.effectTag&-1025|2,yd=!1,wd=a}}var Cd=t.ReactCurrentOwner,H=!1;function R(a,b,c,d){b.child=null===a?Fc(b,null,c,d):Ec(b,a.child,c,d)}
	function Dd(a,b,c,d,e){c=c.render;var f=b.ref;Wb(b,e);d=bd(a,b,c,d,f,e);if(null!==a&&!H)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Ed(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function Fd(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Gd(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Hd(a,b,g,d,e,f);a=Bc(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Nb,c(e,d)&&a.ref===b.ref))return Ed(a,b,f);b.effectTag|=1;a=zc(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Hd(a,b,c,d,e,f){return null!==a&&Nb(a.memoizedProps,d)&&a.ref===b.ref&&(H=!1,e<f)?Ed(a,b,f):Id(a,b,c,d,f)}function Jd(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Id(a,b,c,d,e){var f=D(c)?db:A.current;f=eb(b,f);Wb(b,e);c=bd(a,b,c,d,f,e);if(null!==a&&!H)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Ed(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function Kd(a,b,c,d,e){if(D(c)){var f=!0;jb(b)}else f=!1;Wb(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),sc(b,c,d,e),uc(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,l=b.memoizedProps;g.props=l;var h=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=I(k):(k=D(c)?db:A.current,k=eb(b,k));var n=c.getDerivedStateFromProps,C="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(l!==d||h!==k)&&tc(b,g,d,k);Xb=!1;var y=b.memoizedState;h=g.state=y;var F=b.updateQueue;null!==F&&(fc(b,F,d,g,e),h=b.memoizedState);l!==d||y!==h||B.current||Xb?("function"===typeof n&&(mc(b,c,n,d),h=b.memoizedState),(l=Xb||rc(b,c,l,d,y,h,k))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=h),g.props=d,g.state=h,g.context=k,d=l):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,l=b.memoizedProps,g.props=b.type===b.elementType?l:G(b.type,l),h=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=I(k):(k=D(c)?db:A.current,k=eb(b,k)),n=c.getDerivedStateFromProps,(C="function"===
	typeof n||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(l!==d||h!==k)&&tc(b,g,d,k),Xb=!1,h=b.memoizedState,y=g.state=h,F=b.updateQueue,null!==F&&(fc(b,F,d,g,e),y=b.memoizedState),l!==d||h!==y||B.current||Xb?("function"===typeof n&&(mc(b,c,n,d),y=b.memoizedState),(n=Xb||rc(b,c,l,d,h,y,k))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	y),g.props=d,g.state=y,g.context=k,d=n):("function"!==typeof g.componentDidUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||l===a.memoizedProps&&h===a.memoizedState||(b.effectTag|=256),d=!1);return Ld(a,b,c,d,f,e)}
	function Ld(a,b,c,d,e,f){Jd(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&kb(b,c,!1),Ed(a,b,f);d=b.stateNode;Cd.current=b;var l=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Ec(b,a.child,null,f),b.child=Ec(b,null,l,f)):R(a,b,l,f);b.memoizedState=d.state;e&&kb(b,c,!0);return b.child}function Md(a){var b=a.stateNode;b.pendingContext?hb(a,b.pendingContext,b.pendingContext!==b.context):b.context&&hb(a,b.context,!1);Kc(a,b.containerInfo)}
	var Nd={dehydrated:null,retryTime:0};
	function Od(a,b,c){var d=b.mode,e=b.pendingProps,f=K.current,g=!1,l;(l=0!==(b.effectTag&64))||(l=0!==(f&2)&&(null===a||null!==a.memoizedState));l?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);z(K,f&1,b);if(null===a){void 0!==e.fallback&&Ad(b);if(g){g=e.fallback;e=Dc(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Dc(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=Nd;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Fc(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=zc(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=zc(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=Nd;b.child=c;return d}c=Ec(b,a.child,e.children,c);b.memoizedState=
	null;return b.child=c}a=a.child;if(g){g=e.fallback;e=Dc(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Dc(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=Nd;b.child=e;return c}b.memoizedState=null;return b.child=Ec(b,a,e.children,c)}
	function Pd(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);Vb(a.return,b)}function Qd(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function Rd(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=K.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&Pd(a,c);else if(19===a.tag)Pd(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}z(K,d,b);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===Oc(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qd(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===Oc(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Qd(b,!0,c,null,f,b.lastEffect);break;case "together":Qd(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function Ed(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&hc(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(p(153));if(null!==b.child){a=b.child;c=zc(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=zc(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}var Sd,Td,Ud,Vd;
	Sd=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag){var d=a,e=c.stateNode;if("string"===typeof e)throw Error(p(216));e.inject(d)}else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Td=function(){};Ud=function(a,b,c,d){a.memoizedProps!==d&&(Jc(J.current),b.updateQueue=Na)&&(b.effectTag|=4)};
	Vd=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function Wd(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function Xd(a){switch(a.tag){case 1:D(a.type)&&fb(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:Lc(a);gb(a);b=a.effectTag;if(0!==(b&64))throw Error(p(285));a.effectTag=b&-4097|64;return a;case 5:return Nc(a),null;case 13:return x(K,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return x(K,a),null;case 4:return Lc(a),null;case 10:return Ub(a),null;default:return null}}function Yd(a,b){return{value:a,source:b,stack:$a(b)}}
	var Zd="function"===typeof WeakSet?WeakSet:Set;function $d(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=$a(c));null!==c&&Ba(c.type);b=b.value;null!==a&&1===a.tag&&Ba(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ae(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){be(a,c)}}function ce(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){be(a,c)}else b.current=null}
	function de(a,b){switch(b.tag){case 0:case 11:case 15:ee(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:G(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(p(163));}}
	function ee(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function fe(a,b,c){"function"===typeof ge&&ge(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;Fb(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(l){be(g,l)}}a=a.next}while(a!==d)})}break;case 1:ce(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&ae(b,c);break;case 5:ce(b);break;case 4:he(a,b,c)}}
	function ie(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&ie(b)}function je(a){return 5===a.tag||3===a.tag||4===a.tag}
	function ke(a){a:{for(var b=a.return;null!==b;){if(je(b)){var c=b;break a}b=b.return}throw Error(p(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(p(161));}c.effectTag&16&&(c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||je(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;if(null===
	c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f)if(f=f?e.stateNode:e.stateNode.instance,c)if(d){var g=c;if(f===g)throw Error(p(218));f.injectBefore(g)}else{g=c;if(f===g)throw Error(p(218));f.injectBefore(g)}else g=b,f.parentNode===g&&f.eject(),f.inject(g);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===
	a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function he(a,b,c){for(var d=b,e=!1,f;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(p(160));switch(e.tag){case 5:f=!1;break a;case 3:f=!0;break a;case 4:f=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var g=a,l=d,h=c,k=l;;)if(fe(g,k,h),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===l)break;for(;null===k.sibling;){if(null===k.return||k.return===l)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}g=d.stateNode,Pa(g),g.eject()}else if(4===d.tag){if(null!==
	d.child){f=!0;d.child.return=d;d=d.child;continue}}else if(fe(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function le(a,b){switch(b.tag){case 0:case 11:case 14:case 15:ee(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.updateQueue;b.updateQueue=null;null!==e&&c._applyProps(c,d,a)}break;case 6:if(null===b.stateNode)throw Error(p(162));break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,me=E());if(null!==c)a:for(a=c;;){if(5===a.tag)e=a.stateNode,d?e.hide():(e=a.memoizedProps,(null==e.visible||
	e.visible)&&a.stateNode.show());else if(6!==a.tag)if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){e=a.child.sibling;e.return=a;a=e;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}ne(b);break;case 19:ne(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(p(163));}}
	function ne(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Zd);b.forEach(function(b){var d=oe.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var pe="function"===typeof WeakMap?WeakMap:Map;function qe(a,b,c){c=$b(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){re||(re=!0,se=d);$d(a,b)};return c}
	function te(a,b,c){c=$b(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){$d(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===ue?ue=new Set([this]):ue.add(this),$d(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var ve=Math.ceil,we=t.ReactCurrentDispatcher,xe=t.ReactCurrentOwner,S=0,ye=8,ze=16,Ae=32,Be=0,Ce=1,De=2,Ee=3,Fe=4,Ge=5,T=S,U=null,V=null,W=0,X=Be,He=null,Ie=1073741823,Je=1073741823,Ke=null,Le=0,Me=!1,me=0,Ne=500,Y=null,re=!1,se=null,ue=null,Oe=!1,Pe=null,Qe=90,Re=null,Se=0,Te=null,Ue=0;function nc(){return(T&(ze|Ae))!==S?1073741821-(E()/10|0):0!==Ue?Ue:Ue=1073741821-(E()/10|0)}
	function oc(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=Db();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&ze)!==S)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=2;break;default:throw Error(p(326));}null!==U&&a===W&&--a;return a}
	function pc(a,b){if(50<Se)throw Se=0,Te=null,Error(p(185));a=Ve(a,b);if(null!==a){var c=Db();1073741823===b?(T&ye)!==S&&(T&(ze|Ae))===S?We(a):(Z(a),T===S&&Jb()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Re?Re=new Map([[a,b]]):(c=Re.get(a),(void 0===c||c>b)&&Re.set(a,b)))}}
	function Ve(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(hc(b),X===Fe&&Xe(e,W)),Ye(e,b));return e}
	function Ze(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!$e(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=Hb(We.bind(null,a));else{var b=Ze(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=nc();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==xb&&nb(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?Hb(We.bind(null,a)):Gb(d,af.bind(null,a),{timeout:10*(1073741821-b)-E()});a.callbackNode=b}}}
	function af(a,b){Ue=0;if(b){b=nc();var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b;Z(a);return null}c=Ze(a);if(0!==c){b=a.callbackNode;if((T&(ze|Ae))!==S)throw Error(p(327));bf();a===U&&c===W||cf(a,c);if(null!==V){var d=T;T|=ze;var e=df(a);do try{ef();break}catch(l){gf(a,l)}while(1);Sb();T=d;we.current=e;if(X===Ce)throw b=He,cf(a,c),Xe(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case Be:case Ce:throw Error(p(345));case De:c=
	2<c?2:c;d=a.lastExpiredTime;if(0===d||d>c)a.lastExpiredTime=c;break;case Ee:Xe(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=hf(e));if(1073741823===Ie&&(e=me+Ne-E(),10<e)){if(Me){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;cf(a,c);break}}f=Ze(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Wa(jf.bind(null,a),e);break}jf(a);break;case Fe:Xe(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=hf(e));if(Me&&(e=a.lastPingedTime,0===
	e||e>=c)){a.lastPingedTime=c;cf(a,c);break}e=Ze(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}1073741823!==Je?d=10*(1073741821-Je)-E():1073741823===Ie?d=0:(d=10*(1073741821-Ie)-5E3,e=E(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*ve(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Wa(jf.bind(null,a),d);break}jf(a);break;case Ge:if(1073741823!==Ie&&null!==Ke){f=Ie;var g=Ke;d=g.busyMinDurationMs|0;0>=d?d=0:(e=
	g.busyDelayMs|0,f=E()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Xe(a,c);a.timeoutHandle=Wa(jf.bind(null,a),d);break}}jf(a);break;default:throw Error(p(329));}Z(a);if(a.callbackNode===b)return af.bind(null,a)}}return null}
	function We(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)jf(a);else{if((T&(ze|Ae))!==S)throw Error(p(327));bf();a===U&&b===W||cf(a,b);if(null!==V){var c=T;T|=ze;var d=df(a);do try{kf();break}catch(e){gf(a,e)}while(1);Sb();T=c;we.current=d;if(X===Ce)throw c=He,cf(a,b),Xe(a,b),Z(a),c;if(null!==V)throw Error(p(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;jf(a);Z(a)}}return null}
	function cf(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Xa(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&fb(d);break;case 3:Lc(d);gb(d);break;case 5:Nc(d);break;case 4:Lc(d);break;case 13:x(K,d);break;case 19:x(K,d);break;case 10:Ub(d)}c=c.return}U=a;V=zc(a.current,null,b);W=b;X=Be;He=null;Je=Ie=1073741823;Ke=null;Le=0;Me=!1}
	function gf(a,b){do{try{Sb();fd();if(null===V||null===V.return)return X=Ce,He=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,l=0!==(K.current&1),h=d;do{var k;if(k=13===h.tag){var n=h.memoizedState;if(null!==n)k=null!==n.dehydrated?!0:!1;else{var C=h.memoizedProps;k=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:l?!1:!0}}if(k){var y=h.updateQueue;if(null===y){var F=new Set;
	F.add(g);h.updateQueue=F}else y.add(g);if(0===(h.mode&2)){h.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var ea=$b(1073741823,null);ea.tag=2;bc(e,ea)}e.expirationTime=1073741823;break a}f=void 0;e=b;var fa=c.pingCache;null===fa?(fa=c.pingCache=new pe,f=new Set,fa.set(g,f)):(f=fa.get(g),void 0===f&&(f=new Set,fa.set(g,f)));if(!f.has(e)){f.add(e);var q=lf.bind(null,c,g,e);g.then(q,q)}h.effectTag|=4096;h.expirationTime=b;break a}h=h.return}while(null!==h);f=Error((Ba(e.type)||
	"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+$a(e))}X!==Ge&&(X=De);f=Yd(f,e);h=d;do{switch(h.tag){case 3:g=f;h.effectTag|=4096;h.expirationTime=b;var r=qe(h,g,b);cc(h,r);break a;case 1:g=f;var v=h.type,L=h.stateNode;if(0===(h.effectTag&64)&&("function"===typeof v.getDerivedStateFromError||null!==L&&"function"===typeof L.componentDidCatch&&
	(null===ue||!ue.has(L)))){h.effectTag|=4096;h.expirationTime=b;var Ca=te(h,g,b);cc(h,Ca);break a}}h=h.return}while(null!==h)}V=mf(V)}catch(ff){b=ff;continue}break}while(1)}function df(){var a=we.current;we.current=ed;return null===a?ed:a}function gc(a,b){a<Ie&&2<a&&(Ie=a);null!==b&&a<Je&&2<a&&(Je=a,Ke=b)}function hc(a){a>Le&&(Le=a)}function kf(){for(;null!==V;)V=nf(V)}function ef(){for(;null!==V&&!ob();)V=nf(V)}
	function nf(a){var b=of(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=mf(a));xe.current=null;return b}
	function mf(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=void 0;var d=b;b=V;var e=W,f=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:D(b.type)&&fb(b);break;case 3:Lc(b);gb(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);Td(b);break;case 5:Nc(b);e=Jc(Ic.current);var g=b.type;if(null!==d&&null!=b.stateNode)Ud(d,b,g,f,e),d.ref!==b.ref&&(b.effectTag|=128);else if(f){Jc(J.current);switch(g){case Ha.CLIPPING_RECTANGLE:c=
	da.ClippingRectangle();c._applyProps=Qa;break;case Ha.GROUP:c=da.Group();c._applyProps=Sa;break;case Ha.SHAPE:c=da.Shape();c._applyProps=Ua;break;case Ha.TEXT:c=da.Text(f.children,f.font,f.alignment,f.path),c._applyProps=Va}if(!c)throw Error(p(217,g));c._applyProps(c,f);d=c;Sd(d,b,!1,!1);b.stateNode=d;null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(p(166));break;case 6:if(d&&null!=b.stateNode)Vd(d,b,d.memoizedProps,f);else{if("string"!==typeof f&&null===b.stateNode)throw Error(p(166));
	Jc(Ic.current);Jc(J.current);b.stateNode=f}break;case 11:break;case 13:x(K,b);c=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=e;break a}e=null!==c;c=!1;null!==d&&(f=d.memoizedState,c=null!==f,e||null===f||(f=d.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(e&&!c&&0!==(b.mode&2))if(null===d&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(K.current&1))X===Be&&(X=Ee);else{if(X===
	Be||X===Ee)X=Fe;0!==Le&&null!==U&&(Xe(U,W),Ye(U,Le))}if(e||c)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Lc(b);Td(b);break;case 10:Ub(b);break;case 9:break;case 14:break;case 17:D(b.type)&&fb(b);break;case 19:x(K,b);c=b.memoizedState;if(null===c)break;f=0!==(b.effectTag&64);g=c.rendering;if(null===g)if(f)Wd(c,!1);else{if(X!==Be||null!==d&&0!==(d.effectTag&64))for(d=b.child;null!==d;){g=Oc(d);if(null!==g){b.effectTag|=64;Wd(c,!1);d=g.updateQueue;null!==d&&(b.updateQueue=d,b.effectTag|=
	4);null===c.lastEffect&&(b.firstEffect=null);b.lastEffect=c.lastEffect;d=e;for(e=b.child;null!==e;)c=e,f=d,c.effectTag&=2,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null,g=c.alternate,null===g?(c.childExpirationTime=0,c.expirationTime=f,c.child=null,c.memoizedProps=null,c.memoizedState=null,c.updateQueue=null,c.dependencies=null):(c.childExpirationTime=g.childExpirationTime,c.expirationTime=g.expirationTime,c.child=g.child,c.memoizedProps=g.memoizedProps,c.memoizedState=g.memoizedState,c.updateQueue=
	g.updateQueue,f=g.dependencies,c.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),e=e.sibling;z(K,K.current&1|2,b);b=b.child;break a}d=d.sibling}}else{if(!f)if(d=Oc(g),null!==d){if(b.effectTag|=64,f=!0,d=d.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Wd(c,!0),null===c.tail&&"hidden"===c.tailMode){b=b.lastEffect=c.lastEffect;null!==b&&(b.nextEffect=null);break}}else E()>c.tailExpiration&&1<e&&(b.effectTag|=64,f=!0,Wd(c,!1),
	b.expirationTime=b.childExpirationTime=e-1);c.isBackwards?(g.sibling=b.child,b.child=g):(d=c.last,null!==d?d.sibling=g:b.child=g,c.last=g)}if(null!==c.tail){0===c.tailExpiration&&(c.tailExpiration=E()+500);d=c.tail;c.rendering=d;c.tail=d.sibling;c.lastEffect=b.lastEffect;d.sibling=null;e=K.current;e=f?e&1|2:e&1;z(K,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(p(156,b.tag));}b=null}d=V;if(1===W||1!==d.childExpirationTime){e=0;for(c=d.child;null!==c;)f=c.expirationTime,g=c.childExpirationTime,
	f>e&&(e=f),g>e&&(e=g),c=c.sibling;d.childExpirationTime=e}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Xd(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==
	b)return b;V=a}while(null!==V);X===Be&&(X=Ge);return null}function hf(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function jf(a){var b=Db();Fb(99,pf.bind(null,a,b));return null}
	function pf(a,b){bf();if((T&(ze|Ae))!==S)throw Error(p(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(p(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=hf(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=d-1);d<=a.lastPingedTime&&
	(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=Ae;xe.current=null;Y=e;do try{qf()}catch(Ca){if(null===Y)throw Error(p(330));be(Y,Ca);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(var g=a,l=b;null!==Y;){var h=Y.effectTag;if(h&128){var k=Y.alternate;if(null!==k){var n=k.ref;null!==n&&("function"===typeof n?n(null):n.current=null)}}switch(h&
	1038){case 2:ke(Y);Y.effectTag&=-3;break;case 6:ke(Y);Y.effectTag&=-3;le(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;le(Y.alternate,Y);break;case 4:le(Y.alternate,Y);break;case 8:var C=Y;he(g,C,l);ie(C)}Y=Y.nextEffect}}catch(Ca){if(null===Y)throw Error(p(330));be(Y,Ca);Y=Y.nextEffect}while(null!==Y);a.current=c;Y=e;do try{for(h=d;null!==Y;){var y=Y.effectTag;if(y&36){var F=Y.alternate;k=Y;n=h;switch(k.tag){case 0:case 11:case 15:ee(16,32,k);break;case 1:var ea=
	k.stateNode;if(k.effectTag&4)if(null===F)ea.componentDidMount();else{var fa=k.elementType===k.type?F.memoizedProps:G(k.type,F.memoizedProps);ea.componentDidUpdate(fa,F.memoizedState,ea.__reactInternalSnapshotBeforeUpdate)}var q=k.updateQueue;null!==q&&ic(k,q,ea,n);break;case 3:var r=k.updateQueue;if(null!==r){g=null;if(null!==k.child)switch(k.child.tag){case 5:g=k.child.stateNode;break;case 1:g=k.child.stateNode}ic(k,r,g,n)}break;case 5:break;case 6:break;case 4:break;case 12:break;case 13:break;
	case 19:case 17:case 20:case 21:break;default:throw Error(p(163));}}if(y&128){k=void 0;var v=Y.ref;if(null!==v){var L=Y.stateNode;switch(Y.tag){case 5:k=L;break;default:k=L}"function"===typeof v?v(k):v.current=k}}Y=Y.nextEffect}}catch(Ca){if(null===Y)throw Error(p(330));be(Y,Ca);Y=Y.nextEffect}while(null!==Y);Y=null;yb();T=f}else a.current=c;if(Oe)Oe=!1,Pe=a,Qe=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(ue=null);1073741823===b?a===Te?Se++:(Se=0,Te=a):
	Se=0;"function"===typeof rf&&rf(c.stateNode,d);Z(a);if(re)throw re=!1,a=se,se=null,a;if((T&ye)!==S)return null;Jb();return null}function qf(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&de(Y.alternate,Y);0===(a&512)||Oe||(Oe=!0,Gb(97,function(){bf();return null}));Y=Y.nextEffect}}function bf(){if(90!==Qe){var a=97<Qe?97:Qe;Qe=90;return Fb(a,sf)}}
	function sf(){if(null===Pe)return!1;var a=Pe;Pe=null;if((T&(ze|Ae))!==S)throw Error(p(331));var b=T;T|=Ae;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:ee(128,0,c),ee(0,64,c)}}catch(d){if(null===a)throw Error(p(330));be(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;Jb();return!0}function tf(a,b,c){b=Yd(c,b);b=qe(a,b,1073741823);bc(a,b);a=Ve(a,1073741823);null!==a&&Z(a)}
	function be(a,b){if(3===a.tag)tf(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){tf(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===ue||!ue.has(d))){a=Yd(b,a);a=te(c,a,1073741823);bc(c,a);c=Ve(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function lf(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===Fe||X===Ee&&1073741823===Ie&&E()-me<Ne?cf(a,W):Me=!0:$e(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function oe(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=nc(),b=oc(b,a,null));a=Ve(a,b);null!==a&&Z(a)}var of;
	of=function(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||B.current)H=!0;else{if(d<c){H=!1;switch(b.tag){case 3:Md(b);break;case 5:Mc(b);break;case 1:D(b.type)&&jb(b);break;case 4:Kc(b,b.stateNode.containerInfo);break;case 10:Tb(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Od(a,b,c);z(K,K.current&1,b);b=Ed(a,b,c);return null!==b?b.sibling:null}z(K,K.current&1,b);break;case 19:d=b.childExpirationTime>=
	c;if(0!==(a.effectTag&64)){if(d)return Rd(a,b,c);b.effectTag|=64}var e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);z(K,K.current,b);if(!d)return null}return Ed(a,b,c)}H=!1}else H=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=eb(b,A.current);Wb(b,c);e=bd(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;fd();if(D(d)){var f=!0;jb(b)}else f=
	!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&mc(b,d,g,a);e.updater=qc;b.stateNode=e;e._reactInternalFiber=b;uc(b,d,a,c);b=Ld(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Aa(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=uf(e);a=G(e,a);switch(f){case 0:b=Id(null,b,e,a,c);break;case 1:b=Kd(null,
	b,e,a,c);break;case 11:b=Dd(null,b,e,a,c);break;case 14:b=Fd(null,b,e,G(e.type,a),d,c);break;default:throw Error(p(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:G(d,e),Id(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:G(d,e),Kd(a,b,d,e,c);case 3:Md(b);d=b.updateQueue;if(null===d)throw Error(p(282));e=b.memoizedState;e=null!==e?e.element:null;fc(b,d,b.pendingProps,null,c);d=b.memoizedState.element;d===e?b=Ed(a,b,c):(R(a,b,d,c),b=b.child);
	return b;case 5:return Mc(b),null===a&&Ad(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ya(d,e)?g=null:null!==f&&Ya(d,f)&&(b.effectTag|=16),Jd(a,b),R(a,b,g,c),b=b.child,b;case 6:return null===a&&Ad(b),null;case 13:return Od(a,b,c);case 4:return Kc(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Ec(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:G(d,e),Dd(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;
	case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Tb(b,f);if(null!==g){var l=g.value;f=Lb(l,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(l,f):1073741823)|0;if(0===f){if(g.children===e.children&&!B.current){b=Ed(a,b,c);break a}}else for(l=b.child,null!==l&&(l.return=b);null!==l;){var h=l.dependencies;if(null!==h){g=l.child;for(var k=h.firstContext;null!==
	k;){if(k.context===d&&0!==(k.observedBits&f)){1===l.tag&&(k=$b(c,null),k.tag=2,bc(l,k));l.expirationTime<c&&(l.expirationTime=c);k=l.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);Vb(l.return,c);h.expirationTime<c&&(h.expirationTime=c);break}k=k.next}}else g=10===l.tag?l.type===b.type?null:l.child:l.child;if(null!==g)g.return=l;else for(g=l;null!==g;){if(g===b){g=null;break}l=g.sibling;if(null!==l){l.return=g.return;g=l;break}g=g.return}l=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=
	b.type,f=b.pendingProps,d=f.children,Wb(b,c),e=I(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=G(e,b.pendingProps),f=G(e.type,f),Fd(a,b,e,f,d,c);case 15:return Hd(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:G(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,D(d)?(a=!0,jb(b)):a=!1,Wb(b,c),sc(b,d,e,c),uc(b,d,e,c),Ld(null,b,d,!0,a,c);case 19:return Rd(a,b,c)}throw Error(p(156,b.tag));
	};var rf=null,ge=null;function vf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);rf=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ge=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function wf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Bd(a,b,c,d){return new wf(a,b,c,d)}
	function Gd(a){a=a.prototype;return!(!a||!a.isReactComponent)}function uf(a){if("function"===typeof a)return Gd(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===ta)return 11;if(a===wa)return 14}return 2}
	function zc(a,b){var c=a.alternate;null===c?(c=Bd(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Bc(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Gd(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case na:return Dc(c.children,e,f,b);case sa:g=8;e|=7;break;case oa:g=8;e|=1;break;case pa:return a=Bd(12,c,b,e|8),a.elementType=pa,a.type=pa,a.expirationTime=f,a;case ua:return a=Bd(13,c,b,e),a.type=ua,a.elementType=ua,a.expirationTime=f,a;case va:return a=Bd(19,c,b,e),a.elementType=va,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case qa:g=
	10;break a;case ra:g=9;break a;case ta:g=11;break a;case wa:g=14;break a;case xa:g=16;d=null;break a}throw Error(p(130,null==a?a:typeof a,""));}b=Bd(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Dc(a,b,c,d){a=Bd(7,a,d,b);a.expirationTime=c;return a}function Ac(a,b,c){a=Bd(6,a,null,b);a.expirationTime=c;return a}
	function Cc(a,b,c){b=Bd(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function xf(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function $e(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Xe(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function Ye(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}
	function yf(a,b,c,d){var e=b.current,f=nc(),g=kc.suspense;f=oc(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(Da(c)!==c||1!==c.tag)throw Error(p(170));var l=c;do{switch(l.tag){case 3:l=l.stateNode.context;break b;case 1:if(D(l.type)){l=l.stateNode.__reactInternalMemoizedMergedChildContext;break b}}l=l.return}while(null!==l);throw Error(p(171));}if(1===c.tag){var h=c.type;if(D(h)){c=ib(c,h,l);break a}}c=l}else c=cb;null===b.context?b.context=c:b.pendingContext=c;b=$b(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);bc(e,b);pc(e,f);return f}da.setCurrent(ha);
	var zf=Array.prototype.slice,Af=function(){function a(a,c,d,e,f){this._args=zf.call(arguments)}a.prototype.applyFill=function(a){a.fillLinear.apply(a,this._args)};return a}(),Bf=function(){function a(a,c,d,e,f,g,l){this._args=zf.call(arguments)}a.prototype.applyFill=function(a){a.fillRadial.apply(a,this._args)};return a}(),Cf=function(){function a(a,c,d,e,f){this._args=zf.call(arguments)}a.prototype.applyFill=function(a){a.fillImage.apply(a,this._args)};return a}(),Df=function(a){function b(){return a.apply(this,
	arguments)||this}ja(b,a);var c=b.prototype;c.componentDidMount=function(){var a=this.props;this._surface=da.Surface(+a.width,+a.height,this._tagRef);a=new xf(this._surface,0,!1);var b=Bd(3,null,null,0);a.current=b;this._mountNode=b.stateNode=a;yf(this.props.children,this._mountNode,this)};c.componentDidUpdate=function(a){var b=this.props;b.height===a.height&&b.width===a.width||this._surface.resize(+b.width,+b.height);yf(this.props.children,this._mountNode,this);this._surface.render&&this._surface.render()};
	c.componentWillUnmount=function(){yf(null,this._mountNode,this)};c.render=function(){var a=this,b=this.props;return aa.createElement(da.Surface.tagName,{ref:function(b){return a._tagRef=b},accessKey:b.accessKey,className:b.className,draggable:b.draggable,role:b.role,style:b.style,tabIndex:b.tabIndex,title:b.title})};return b}(aa.Component),Ef=function(a){function b(b){var c=a.call(this,b)||this;["height","width","x","y"].forEach(function(a){Object.defineProperty(ka(c),a,{get:function(){return this._text?
	this._text[a]:void 0}})});return c}ja(b,a);b.prototype.render=function(){var a=this;return aa.createElement(Ha.TEXT,ia({},this.props,{ref:function(b){return a._text=b}}),Ja(this.props.children))};return b}(aa.Component);
	(function(a){var b=a.findFiberByHostInstance;return vf(ba({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:t.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Ga(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:function(){return null},bundleType:0,
	version:"16.11.0",rendererPackageName:"react-art"});module.exports={ClippingRectangle:Ha.CLIPPING_RECTANGLE,Group:Ha.GROUP,Shape:Ha.SHAPE,Path:da.Path,LinearGradient:Af,Pattern:Cf,RadialGradient:Bf,Surface:Df,Text:Ef,Transform:ca};


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1250);
	} else {
	  module.exports = require('./cjs/react-art.development.js');
	}


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.0
	 * react-dom-unstable-native-dependencies.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(65),k=__webpack_require__(25);function m(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var n=null,q=null,r=null;
	function t(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))throw Error(m(103));a.currentTarget=b?r(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b}function u(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function v(a,b,c){for(var f=[];a;)f.push(a),a=u(a);for(a=f.length;0<a--;)b(f[a],"captured",c);for(a=0;a<f.length;a++)b(f[a],"bubbled",c)}
	function w(a,b){var c=a.stateNode;if(!c)return null;var f=n(c);if(!f)return null;c=f[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(f=!f.disabled)||(a=a.type,f=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!f;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(m(231,
	b,typeof c));return c}function x(a,b){if(null==b)throw Error(m(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function y(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}function z(a,b,c){if(b=w(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=x(c._dispatchListeners,b),c._dispatchInstances=x(c._dispatchInstances,a)}
	function A(a){a&&a.dispatchConfig.phasedRegistrationNames&&v(a._targetInst,z,a)}function aa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?u(b):null;v(b,z,a)}}function B(a){if(a&&a.dispatchConfig.registrationName){var b=a._targetInst;if(b&&a&&a.dispatchConfig.registrationName){var c=w(b,a.dispatchConfig.registrationName);c&&(a._dispatchListeners=x(a._dispatchListeners,c),a._dispatchInstances=x(a._dispatchInstances,b))}}}function C(){return!0}function D(){return!1}
	function E(a,b,c,f){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var d in a)a.hasOwnProperty(d)&&((b=a[d])?this[d]=b(c):"target"===d?this.target=f:this[d]=c[d]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C:D;this.isPropagationStopped=D;return this}
	k(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C)},persist:function(){this.isPersistent=C},isPersistent:D,destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=
	null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=D;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	E.extend=function(a){function b(){}function c(){return f.apply(this,arguments)}var f=this;b.prototype=f.prototype;var d=new b;k(d,c.prototype);c.prototype=d;c.prototype.constructor=c;c.Interface=k({},f.Interface,a);c.extend=f.extend;F(c);return c};F(E);function ba(a,b,c,f){if(this.eventPool.length){var d=this.eventPool.pop();this.call(d,a,b,c,f);return d}return new this(a,b,c,f)}
	function ca(a){if(!(a instanceof this))throw Error(m(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function F(a){a.eventPool=[];a.getPooled=ba;a.release=ca}var G=E.extend({touchHistory:function(){return null}});function H(a){return"touchstart"===a||"mousedown"===a}function I(a){return"touchmove"===a||"mousemove"===a}function J(a){return"touchend"===a||"touchcancel"===a||"mouseup"===a}
	var K=["touchstart","mousedown"],L=["touchmove","mousemove"],N=["touchcancel","touchend","mouseup"],O=[],P={touchBank:O,numberActiveTouches:0,indexOfSingleActiveTouch:-1,mostRecentTimeStamp:0};function Q(a){return a.timeStamp||a.timestamp}function R(a){a=a.identifier;if(null==a)throw Error(m(138));return a}
	function da(a){var b=R(a),c=O[b];c?(c.touchActive=!0,c.startPageX=a.pageX,c.startPageY=a.pageY,c.startTimeStamp=Q(a),c.currentPageX=a.pageX,c.currentPageY=a.pageY,c.currentTimeStamp=Q(a),c.previousPageX=a.pageX,c.previousPageY=a.pageY,c.previousTimeStamp=Q(a)):(c={touchActive:!0,startPageX:a.pageX,startPageY:a.pageY,startTimeStamp:Q(a),currentPageX:a.pageX,currentPageY:a.pageY,currentTimeStamp:Q(a),previousPageX:a.pageX,previousPageY:a.pageY,previousTimeStamp:Q(a)},O[b]=c);P.mostRecentTimeStamp=Q(a)}
	function ea(a){var b=O[R(a)];b&&(b.touchActive=!0,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=Q(a),P.mostRecentTimeStamp=Q(a))}function fa(a){var b=O[R(a)];b&&(b.touchActive=!1,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=Q(a),P.mostRecentTimeStamp=Q(a))}
	var S={recordTouchTrack:function(a,b){if(I(a))b.changedTouches.forEach(ea);else if(H(a))b.changedTouches.forEach(da),P.numberActiveTouches=b.touches.length,1===P.numberActiveTouches&&(P.indexOfSingleActiveTouch=b.touches[0].identifier);else if(J(a)&&(b.changedTouches.forEach(fa),P.numberActiveTouches=b.touches.length,1===P.numberActiveTouches))for(a=0;a<O.length;a++)if(b=O[a],null!=b&&b.touchActive){P.indexOfSingleActiveTouch=a;break}},touchHistory:P};
	function T(a,b){if(null==b)throw Error(m(334));return null==a?b:Array.isArray(a)?a.concat(b):Array.isArray(b)?[a].concat(b):[a,b]}var U=null,V=0;function W(a,b){var c=U;U=a;if(null!==X.GlobalResponderHandler)X.GlobalResponderHandler.onChange(c,a,b)}
	var Y={startShouldSetResponder:{phasedRegistrationNames:{bubbled:"onStartShouldSetResponder",captured:"onStartShouldSetResponderCapture"},dependencies:K},scrollShouldSetResponder:{phasedRegistrationNames:{bubbled:"onScrollShouldSetResponder",captured:"onScrollShouldSetResponderCapture"},dependencies:["scroll"]},selectionChangeShouldSetResponder:{phasedRegistrationNames:{bubbled:"onSelectionChangeShouldSetResponder",captured:"onSelectionChangeShouldSetResponderCapture"},dependencies:["selectionchange"]},
	moveShouldSetResponder:{phasedRegistrationNames:{bubbled:"onMoveShouldSetResponder",captured:"onMoveShouldSetResponderCapture"},dependencies:L},responderStart:{registrationName:"onResponderStart",dependencies:K},responderMove:{registrationName:"onResponderMove",dependencies:L},responderEnd:{registrationName:"onResponderEnd",dependencies:N},responderRelease:{registrationName:"onResponderRelease",dependencies:N},responderTerminationRequest:{registrationName:"onResponderTerminationRequest",dependencies:[]},
	responderGrant:{registrationName:"onResponderGrant",dependencies:[]},responderReject:{registrationName:"onResponderReject",dependencies:[]},responderTerminate:{registrationName:"onResponderTerminate",dependencies:[]}},X={_getResponder:function(){return U},eventTypes:Y,extractEvents:function(a,b,c,f){if(H(a))V+=1;else if(J(a))if(0<=V)--V;else return null;S.recordTouchTrack(a,c);if(b&&("scroll"===a&&!c.responderIgnoreScroll||0<V&&"selectionchange"===a||H(a)||I(a))){var d=H(a)?Y.startShouldSetResponder:
	I(a)?Y.moveShouldSetResponder:"selectionchange"===a?Y.selectionChangeShouldSetResponder:Y.scrollShouldSetResponder;if(U)b:{var e=U;for(var g=0,p=e;p;p=u(p))g++;p=0;for(var M=b;M;M=u(M))p++;for(;0<g-p;)e=u(e),g--;for(;0<p-g;)b=u(b),p--;for(;g--;){if(e===b||e===b.alternate)break b;e=u(e);b=u(b)}e=null}else e=b;b=e===U;e=G.getPooled(d,e,c,f);e.touchHistory=S.touchHistory;b?y(e,aa):y(e,A);b:{d=e._dispatchListeners;b=e._dispatchInstances;if(Array.isArray(d))for(g=0;g<d.length&&!e.isPropagationStopped();g++){if(d[g](e,
	b[g])){d=b[g];break b}}else if(d&&d(e,b)){d=b;break b}d=null}e._dispatchInstances=null;e._dispatchListeners=null;e.isPersistent()||e.constructor.release(e);if(d&&d!==U)if(e=G.getPooled(Y.responderGrant,d,c,f),e.touchHistory=S.touchHistory,y(e,B),b=!0===t(e),U)if(g=G.getPooled(Y.responderTerminationRequest,U,c,f),g.touchHistory=S.touchHistory,y(g,B),p=!g._dispatchListeners||t(g),g.isPersistent()||g.constructor.release(g),p){g=G.getPooled(Y.responderTerminate,U,c,f);g.touchHistory=S.touchHistory;y(g,
	B);var l=T(l,[e,g]);W(d,b)}else d=G.getPooled(Y.responderReject,d,c,f),d.touchHistory=S.touchHistory,y(d,B),l=T(l,d);else l=T(l,e),W(d,b);else l=null}else l=null;d=U&&H(a);e=U&&I(a);b=U&&J(a);if(d=d?Y.responderStart:e?Y.responderMove:b?Y.responderEnd:null)d=G.getPooled(d,U,c,f),d.touchHistory=S.touchHistory,y(d,B),l=T(l,d);d=U&&"touchcancel"===a;if(a=U&&!d&&J(a))a:{if((a=c.touches)&&0!==a.length)for(e=0;e<a.length;e++)if(b=a[e].target,null!==b&&void 0!==b&&0!==b){g=q(b);b:{for(b=U;g;){if(b===g||b===
	g.alternate){b=!0;break b}g=u(g)}b=!1}if(b){a=!1;break a}}a=!0}if(a=d?Y.responderTerminate:a?Y.responderRelease:null)c=G.getPooled(a,U,c,f),c.touchHistory=S.touchHistory,y(c,B),l=T(l,c),W(null);return l},GlobalResponderHandler:null,injection:{injectGlobalResponderHandler:function(a){X.GlobalResponderHandler=a}}},Z=h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,ha=Z[3],ia=Z[0],ja=Z[1];n=Z[2];q=ia;r=ja;module.exports={__proto__:null,ResponderEventPlugin:X,ResponderTouchHistoryStore:S,injectEventPluginsByName:ha};


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.13.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(25),r=__webpack_require__(1255);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;pa.hasOwnProperty("ReactCurrentDispatcher")||(pa.ReactCurrentDispatcher={current:null});pa.hasOwnProperty("ReactCurrentBatchConfig")||(pa.ReactCurrentBatchConfig={suspense:null});
	var qa=/^(.*)[\\\/]/,v="function"===typeof Symbol&&Symbol.for,ra=v?Symbol.for("react.element"):60103,sa=v?Symbol.for("react.portal"):60106,ta=v?Symbol.for("react.fragment"):60107,ua=v?Symbol.for("react.strict_mode"):60108,va=v?Symbol.for("react.profiler"):60114,wa=v?Symbol.for("react.provider"):60109,xa=v?Symbol.for("react.context"):60110,ya=v?Symbol.for("react.concurrent_mode"):60111,za=v?Symbol.for("react.forward_ref"):60112,Aa=v?Symbol.for("react.suspense"):60113,Ba=v?Symbol.for("react.suspense_list"):
	60120,Ca=v?Symbol.for("react.memo"):60115,Da=v?Symbol.for("react.lazy"):60116,Ea=v?Symbol.for("react.block"):60121,Fa="function"===typeof Symbol&&Symbol.iterator;function Ga(a){if(null===a||"object"!==typeof a)return null;a=Fa&&a[Fa]||a["@@iterator"];return"function"===typeof a?a:null}function Ha(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Ia(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ta:return"Fragment";case sa:return"Portal";case va:return"Profiler";case ua:return"StrictMode";case Aa:return"Suspense";case Ba:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case xa:return"Context.Consumer";case wa:return"Context.Provider";case za:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case Ca:return Ia(a.type);case Ea:return Ia(a.render);case Da:if(a=1===a._status?a._result:null)return Ia(a)}return null}function Ja(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ia(a.type);c=null;d&&(c=Ia(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(qa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ka=null,La={};
	function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!Na[c]){if(!b.extractEvents)throw Error(u(97,a));Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(Oa.hasOwnProperty(h))throw Error(u(99,h));Oa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Pa(k[e],g,h);e=!0}else f.registrationName?(Pa(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function Pa(a,b,c){if(Qa[a])throw Error(u(100,a));Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!La.hasOwnProperty(c)||La[c]!==d){if(La[c])throw Error(u(102,c));La[c]=d;b=!0}}b&&Ma()}var Ta=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ua=null,Va=null,Wa=null;
	function Xa(a){if(a=ma(a)){if("function"!==typeof Ua)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),Ua(a.stateNode,a.type,b))}}function Ya(a){Va?Wa?Wa.push(a):Wa=[a]:Va=a}function Za(){if(Va){var a=Va,b=Wa;Wa=Va=null;Xa(a);if(b)for(a=0;a<b.length;a++)Xa(b[a])}}function $a(a,b){return a(b)}function ab(a,b,c,d,e){return a(b,c,d,e)}function bb(){}var cb=$a,db=!1,eb=!1;function fb(){if(null!==Va||null!==Wa)bb(),Za()}
	function gb(a,b,c){if(eb)return a(b,c);eb=!0;try{return cb(a,b,c)}finally{eb=!1,fb()}}var hb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ib=Object.prototype.hasOwnProperty,jb={},kb={};
	function lb(a){if(ib.call(kb,a))return!0;if(ib.call(jb,a))return!1;if(hb.test(a))return kb[a]=!0;jb[a]=!0;return!1}function mb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function nb(a,b,c,d){if(null===b||"undefined"===typeof b||mb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var E={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new C(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new C(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new C(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new C(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new C(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){E[a]=new C(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){E[a]=new C(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){E[a]=new C(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){E[a]=new C(a,5,!1,a.toLowerCase(),null,!1)});var ob=/[\-:]([a-z])/g;function pb(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ob,
	pb);E[b]=new C(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!1)});
	E.xlinkHref=new C("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!0)});
	function qb(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(nb(b,c,e,d)&&(c=null),d||null===e?lb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&qb(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	Ta&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<Na.length;k++){var l=Na[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){db||bb();var e=id,f=db;db=!0;try{ab(e,a,b,c,d)}finally{(db=f)||fb()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{gb(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{gb(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=Ra[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=Ta&&"CompositionEvent"in window,ke=null;Ta&&"documentMode"in document&&(ke=document.documentMode);
	var le=Ta&&"TextEvent"in window&&!ke,me=Ta&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Ya(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;Ta&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),db)mc(a);else{db=!0;try{$a(Ce,a)}finally{db=!1,fb()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=Ta&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=Ra.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(Ka)throw Error(u(101));Ka=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ma();var xf=Nc;la=Qd;ma=xf;na=Pd;Sa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Ia(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=pa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ra:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case sa:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	Ga(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ra:return c.key===e?c.type===ta?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case sa:return c.key===e?l(a,b,c,d):null}if(Og(c)||Ga(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ra:return a=a.get(null===d.key?c:d.key)||null,d.type===ta?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case sa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||Ga(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=Ga(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ta&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ra:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ta){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ta?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case sa:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(Ga(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=pa.ReactCurrentDispatcher,kh=pa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=pa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Qa.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(Qa.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):Qa.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(Qa.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&qb(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:Ja(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Ja(c));null!==c&&Ia(c.type);b=b.value;null!==a&&1===a.tag&&Ia(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):qb(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=pa.ReactCurrentDispatcher,dj=pa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):g.memoizedState=null}var m=0!==
	(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;break a}h=void 0;g=b;var A=e.pingCache;
	null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((Ia(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Ja(g))}S!==jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=
	h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}
	function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Ha(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===za)return 11;if(a===Ca)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ta:return Wg(c.children,e,f,b);case ya:g=8;e|=7;break;case ua:g=8;e|=1;break;case va:return a=Sh(12,c,b,e|8),a.elementType=va,a.type=va,a.expirationTime=f,a;case Aa:return a=Sh(13,c,b,e),a.type=Aa,a.elementType=Aa,a.expirationTime=f,a;case Ba:return a=Sh(19,c,b,e),a.elementType=Ba,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case wa:g=
	10;break a;case xa:g=9;break a;case za:g=11;break a;case Ca:g=14;break a;case Da:g=16;d=null;break a;case Ea:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:sa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	Ua=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};$a=Mj;
	ab=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};bb=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};cb=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,Sa,Oa,Xd,function(a){jc(a,Wd)},Ya,Za,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:pa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.0";


/***/ },
/* 1254 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 1255 */
[1516, 1254],
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// require('hammerjs') when in a browser. This is safe because Hammer is only
	// invoked in componentDidMount, which is not executed on the server.
	var Hammer = typeof window !== 'undefined' ? __webpack_require__(1217) : undefined;
	
	var privateProps = {
		children: true,
		direction: true,
		options: true,
		recognizeWith: true,
		vertical: true
	};
	
	/**
	 * Hammer Component
	 * ================
	 */
	
	var handlerToEvent = {
		action: 'tap press',
		onDoubleTap: 'doubletap',
		onPan: 'pan',
		onPanCancel: 'pancancel',
		onPanEnd: 'panend',
		onPanStart: 'panstart',
		onPinch: 'pinch',
		onPinchCancel: 'pinchcancel',
		onPinchEnd: 'pinchend',
		onPinchIn: 'pinchin',
		onPinchOut: 'pinchout',
		onPinchStart: 'pinchstart',
		onPress: 'press',
		onPressUp: 'pressup',
		onRotate: 'rotate',
		onRotateCancel: 'rotatecancel',
		onRotateEnd: 'rotateend',
		onRotateMove: 'rotatemove',
		onRotateStart: 'rotatestart',
		onSwipe: 'swipe',
		onSwipeRight: 'swiperight',
		onSwipeLeft: 'swipeleft',
		onSwipeUp: 'swipeup',
		onSwipeDown: 'swipedown',
		onTap: 'tap'
	};
	
	Object.keys(handlerToEvent).forEach(function (i) {
		privateProps[i] = true;
	});
	
	function updateHammer(hammer, props) {
		if (props.hasOwnProperty('vertical')) {
			console.warn('vertical is deprecated, please use `direction` instead');
		}
	
		var directionProp = props.direction;
		if (directionProp || props.hasOwnProperty('vertical')) {
			var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
			hammer.get('pan').set({ direction: Hammer[direction] });
			hammer.get('swipe').set({ direction: Hammer[direction] });
		}
	
		if (props.options) {
			Object.keys(props.options).forEach(function (option) {
				if (option === 'recognizers') {
					Object.keys(props.options.recognizers).forEach(function (gesture) {
						var recognizer = hammer.get(gesture);
						recognizer.set(props.options.recognizers[gesture]);
						if (props.options.recognizers[gesture].requireFailure) {
							recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
						}
					}, this);
				} else {
					var key = option;
					var optionObj = {};
					optionObj[key] = props.options[option];
					hammer.set(optionObj);
				}
			}, this);
		}
	
		if (props.recognizeWith) {
			Object.keys(props.recognizeWith).forEach(function (gesture) {
				var recognizer = hammer.get(gesture);
				recognizer.recognizeWith(props.recognizeWith[gesture]);
			}, this);
		}
	
		Object.keys(props).forEach(function (p) {
			var e = handlerToEvent[p];
			if (e) {
				hammer.off(e);
				hammer.on(e, props[p]);
			}
		});
	}
	
	var HammerComponent = function (_React$Component) {
		_inherits(HammerComponent, _React$Component);
	
		function HammerComponent() {
			_classCallCheck(this, HammerComponent);
	
			return _possibleConstructorReturn(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
		}
	
		_createClass(HammerComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.hammer = new Hammer(this.domElement);
				updateHammer(this.hammer, this.props);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.hammer) {
					updateHammer(this.hammer, this.props);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.hammer) {
					this.hammer.stop();
					this.hammer.destroy();
				}
				this.hammer = null;
			}
		}, {
			key: 'render',
			value: function render() {
				var props = {};
	
				Object.keys(this.props).forEach(function (i) {
					if (!privateProps[i]) {
						props[i] = this.props[i];
					}
				}, this);
	
				var self = this;
				props.ref = function (domElement) {
					if (self.props.ref) {
						self.props.ref(domElement);
					}
					self.domElement = domElement;
				};
	
				// Reuse the child provided
				// This makes it flexible to use whatever element is wanted (div, ul, etc)
				return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
			}
		}]);
	
		return HammerComponent;
	}(_react2.default.Component);
	
	HammerComponent.displayName = 'Hammer';
	HammerComponent.propTypes = {
		className: _propTypes2.default.string
	};
	exports.default = HammerComponent;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./500px": 163,
		"./500px.js": 163,
		"./adjust": 164,
		"./adjust.js": 164,
		"./adn": 165,
		"./adn.js": 165,
		"./align-center": 166,
		"./align-center.js": 166,
		"./align-justify": 167,
		"./align-justify.js": 167,
		"./align-left": 168,
		"./align-left.js": 168,
		"./align-right": 169,
		"./align-right.js": 169,
		"./amazon": 170,
		"./amazon.js": 170,
		"./ambulance": 171,
		"./ambulance.js": 171,
		"./american-sign-language-interpreting": 172,
		"./american-sign-language-interpreting.js": 172,
		"./anchor": 173,
		"./anchor.js": 173,
		"./android": 174,
		"./android.js": 174,
		"./angellist": 175,
		"./angellist.js": 175,
		"./angle-double-down": 176,
		"./angle-double-down.js": 176,
		"./angle-double-left": 177,
		"./angle-double-left.js": 177,
		"./angle-double-right": 178,
		"./angle-double-right.js": 178,
		"./angle-double-up": 179,
		"./angle-double-up.js": 179,
		"./angle-down": 180,
		"./angle-down.js": 180,
		"./angle-left": 181,
		"./angle-left.js": 181,
		"./angle-right": 182,
		"./angle-right.js": 182,
		"./angle-up": 183,
		"./angle-up.js": 183,
		"./apple": 184,
		"./apple.js": 184,
		"./archive": 185,
		"./archive.js": 185,
		"./area-chart": 186,
		"./area-chart.js": 186,
		"./arrow-circle-down": 187,
		"./arrow-circle-down.js": 187,
		"./arrow-circle-left": 188,
		"./arrow-circle-left.js": 188,
		"./arrow-circle-o-down": 189,
		"./arrow-circle-o-down.js": 189,
		"./arrow-circle-o-left": 190,
		"./arrow-circle-o-left.js": 190,
		"./arrow-circle-o-right": 191,
		"./arrow-circle-o-right.js": 191,
		"./arrow-circle-o-up": 192,
		"./arrow-circle-o-up.js": 192,
		"./arrow-circle-right": 193,
		"./arrow-circle-right.js": 193,
		"./arrow-circle-up": 194,
		"./arrow-circle-up.js": 194,
		"./arrow-down": 195,
		"./arrow-down.js": 195,
		"./arrow-left": 196,
		"./arrow-left.js": 196,
		"./arrow-right": 197,
		"./arrow-right.js": 197,
		"./arrow-up": 198,
		"./arrow-up.js": 198,
		"./arrows": 202,
		"./arrows-alt": 199,
		"./arrows-alt.js": 199,
		"./arrows-h": 200,
		"./arrows-h.js": 200,
		"./arrows-v": 201,
		"./arrows-v.js": 201,
		"./arrows.js": 202,
		"./assistive-listening-systems": 203,
		"./assistive-listening-systems.js": 203,
		"./asterisk": 204,
		"./asterisk.js": 204,
		"./at": 205,
		"./at.js": 205,
		"./audio-description": 206,
		"./audio-description.js": 206,
		"./automobile": 207,
		"./automobile.js": 207,
		"./backward": 208,
		"./backward.js": 208,
		"./balance-scale": 209,
		"./balance-scale.js": 209,
		"./ban": 210,
		"./ban.js": 210,
		"./bank": 211,
		"./bank.js": 211,
		"./bar-chart": 212,
		"./bar-chart.js": 212,
		"./barcode": 213,
		"./barcode.js": 213,
		"./bars": 214,
		"./bars.js": 214,
		"./battery-0": 215,
		"./battery-0.js": 215,
		"./battery-1": 216,
		"./battery-1.js": 216,
		"./battery-2": 217,
		"./battery-2.js": 217,
		"./battery-3": 218,
		"./battery-3.js": 218,
		"./battery-4": 219,
		"./battery-4.js": 219,
		"./bed": 220,
		"./bed.js": 220,
		"./beer": 221,
		"./beer.js": 221,
		"./behance": 223,
		"./behance-square": 222,
		"./behance-square.js": 222,
		"./behance.js": 223,
		"./bell": 227,
		"./bell-o": 224,
		"./bell-o.js": 224,
		"./bell-slash": 226,
		"./bell-slash-o": 225,
		"./bell-slash-o.js": 225,
		"./bell-slash.js": 226,
		"./bell.js": 227,
		"./bicycle": 228,
		"./bicycle.js": 228,
		"./binoculars": 229,
		"./binoculars.js": 229,
		"./birthday-cake": 230,
		"./birthday-cake.js": 230,
		"./bitbucket": 232,
		"./bitbucket-square": 231,
		"./bitbucket-square.js": 231,
		"./bitbucket.js": 232,
		"./bitcoin": 233,
		"./bitcoin.js": 233,
		"./black-tie": 234,
		"./black-tie.js": 234,
		"./blind": 235,
		"./blind.js": 235,
		"./bluetooth": 237,
		"./bluetooth-b": 236,
		"./bluetooth-b.js": 236,
		"./bluetooth.js": 237,
		"./bold": 238,
		"./bold.js": 238,
		"./bolt": 239,
		"./bolt.js": 239,
		"./bomb": 240,
		"./bomb.js": 240,
		"./book": 241,
		"./book.js": 241,
		"./bookmark": 243,
		"./bookmark-o": 242,
		"./bookmark-o.js": 242,
		"./bookmark.js": 243,
		"./braille": 244,
		"./braille.js": 244,
		"./briefcase": 245,
		"./briefcase.js": 245,
		"./bug": 246,
		"./bug.js": 246,
		"./building": 248,
		"./building-o": 247,
		"./building-o.js": 247,
		"./building.js": 248,
		"./bullhorn": 249,
		"./bullhorn.js": 249,
		"./bullseye": 250,
		"./bullseye.js": 250,
		"./bus": 251,
		"./bus.js": 251,
		"./buysellads": 252,
		"./buysellads.js": 252,
		"./cab": 253,
		"./cab.js": 253,
		"./calculator": 254,
		"./calculator.js": 254,
		"./calendar": 260,
		"./calendar-check-o": 255,
		"./calendar-check-o.js": 255,
		"./calendar-minus-o": 256,
		"./calendar-minus-o.js": 256,
		"./calendar-o": 257,
		"./calendar-o.js": 257,
		"./calendar-plus-o": 258,
		"./calendar-plus-o.js": 258,
		"./calendar-times-o": 259,
		"./calendar-times-o.js": 259,
		"./calendar.js": 260,
		"./camera": 262,
		"./camera-retro": 261,
		"./camera-retro.js": 261,
		"./camera.js": 262,
		"./caret-down": 263,
		"./caret-down.js": 263,
		"./caret-left": 264,
		"./caret-left.js": 264,
		"./caret-right": 265,
		"./caret-right.js": 265,
		"./caret-square-o-down": 266,
		"./caret-square-o-down.js": 266,
		"./caret-square-o-left": 267,
		"./caret-square-o-left.js": 267,
		"./caret-square-o-right": 268,
		"./caret-square-o-right.js": 268,
		"./caret-square-o-up": 269,
		"./caret-square-o-up.js": 269,
		"./caret-up": 270,
		"./caret-up.js": 270,
		"./cart-arrow-down": 271,
		"./cart-arrow-down.js": 271,
		"./cart-plus": 272,
		"./cart-plus.js": 272,
		"./cc": 281,
		"./cc-amex": 273,
		"./cc-amex.js": 273,
		"./cc-diners-club": 274,
		"./cc-diners-club.js": 274,
		"./cc-discover": 275,
		"./cc-discover.js": 275,
		"./cc-jcb": 276,
		"./cc-jcb.js": 276,
		"./cc-mastercard": 277,
		"./cc-mastercard.js": 277,
		"./cc-paypal": 278,
		"./cc-paypal.js": 278,
		"./cc-stripe": 279,
		"./cc-stripe.js": 279,
		"./cc-visa": 280,
		"./cc-visa.js": 280,
		"./cc.js": 281,
		"./certificate": 282,
		"./certificate.js": 282,
		"./chain": 284,
		"./chain-broken": 283,
		"./chain-broken.js": 283,
		"./chain.js": 284,
		"./check": 289,
		"./check-circle": 286,
		"./check-circle-o": 285,
		"./check-circle-o.js": 285,
		"./check-circle.js": 286,
		"./check-square": 288,
		"./check-square-o": 287,
		"./check-square-o.js": 287,
		"./check-square.js": 288,
		"./check.js": 289,
		"./chevron-circle-down": 290,
		"./chevron-circle-down.js": 290,
		"./chevron-circle-left": 291,
		"./chevron-circle-left.js": 291,
		"./chevron-circle-right": 292,
		"./chevron-circle-right.js": 292,
		"./chevron-circle-up": 293,
		"./chevron-circle-up.js": 293,
		"./chevron-down": 294,
		"./chevron-down.js": 294,
		"./chevron-left": 295,
		"./chevron-left.js": 295,
		"./chevron-right": 296,
		"./chevron-right.js": 296,
		"./chevron-up": 297,
		"./chevron-up.js": 297,
		"./child": 298,
		"./child.js": 298,
		"./chrome": 299,
		"./chrome.js": 299,
		"./circle": 303,
		"./circle-o": 301,
		"./circle-o-notch": 300,
		"./circle-o-notch.js": 300,
		"./circle-o.js": 301,
		"./circle-thin": 302,
		"./circle-thin.js": 302,
		"./circle.js": 303,
		"./clipboard": 304,
		"./clipboard.js": 304,
		"./clock-o": 305,
		"./clock-o.js": 305,
		"./clone": 306,
		"./clone.js": 306,
		"./close": 307,
		"./close.js": 307,
		"./cloud": 310,
		"./cloud-download": 308,
		"./cloud-download.js": 308,
		"./cloud-upload": 309,
		"./cloud-upload.js": 309,
		"./cloud.js": 310,
		"./cny": 311,
		"./cny.js": 311,
		"./code": 313,
		"./code-fork": 312,
		"./code-fork.js": 312,
		"./code.js": 313,
		"./codepen": 314,
		"./codepen.js": 314,
		"./codiepie": 315,
		"./codiepie.js": 315,
		"./coffee": 316,
		"./coffee.js": 316,
		"./cog": 317,
		"./cog.js": 317,
		"./cogs": 318,
		"./cogs.js": 318,
		"./columns": 319,
		"./columns.js": 319,
		"./comment": 321,
		"./comment-o": 320,
		"./comment-o.js": 320,
		"./comment.js": 321,
		"./commenting": 323,
		"./commenting-o": 322,
		"./commenting-o.js": 322,
		"./commenting.js": 323,
		"./comments": 325,
		"./comments-o": 324,
		"./comments-o.js": 324,
		"./comments.js": 325,
		"./compass": 326,
		"./compass.js": 326,
		"./compress": 327,
		"./compress.js": 327,
		"./connectdevelop": 328,
		"./connectdevelop.js": 328,
		"./contao": 329,
		"./contao.js": 329,
		"./copy": 330,
		"./copy.js": 330,
		"./copyright": 331,
		"./copyright.js": 331,
		"./creative-commons": 332,
		"./creative-commons.js": 332,
		"./credit-card": 334,
		"./credit-card-alt": 333,
		"./credit-card-alt.js": 333,
		"./credit-card.js": 334,
		"./crop": 335,
		"./crop.js": 335,
		"./crosshairs": 336,
		"./crosshairs.js": 336,
		"./css3": 337,
		"./css3.js": 337,
		"./cube": 338,
		"./cube.js": 338,
		"./cubes": 339,
		"./cubes.js": 339,
		"./cut": 340,
		"./cut.js": 340,
		"./cutlery": 341,
		"./cutlery.js": 341,
		"./dashboard": 342,
		"./dashboard.js": 342,
		"./dashcube": 343,
		"./dashcube.js": 343,
		"./database": 344,
		"./database.js": 344,
		"./deaf": 345,
		"./deaf.js": 345,
		"./dedent": 346,
		"./dedent.js": 346,
		"./delicious": 347,
		"./delicious.js": 347,
		"./desktop": 348,
		"./desktop.js": 348,
		"./deviantart": 349,
		"./deviantart.js": 349,
		"./diamond": 350,
		"./diamond.js": 350,
		"./digg": 351,
		"./digg.js": 351,
		"./dollar": 352,
		"./dollar.js": 352,
		"./dot-circle-o": 353,
		"./dot-circle-o.js": 353,
		"./download": 354,
		"./download.js": 354,
		"./dribbble": 355,
		"./dribbble.js": 355,
		"./dropbox": 356,
		"./dropbox.js": 356,
		"./drupal": 357,
		"./drupal.js": 357,
		"./edge": 358,
		"./edge.js": 358,
		"./edit": 359,
		"./edit.js": 359,
		"./eject": 360,
		"./eject.js": 360,
		"./ellipsis-h": 361,
		"./ellipsis-h.js": 361,
		"./ellipsis-v": 362,
		"./ellipsis-v.js": 362,
		"./empire": 363,
		"./empire.js": 363,
		"./envelope": 366,
		"./envelope-o": 364,
		"./envelope-o.js": 364,
		"./envelope-square": 365,
		"./envelope-square.js": 365,
		"./envelope.js": 366,
		"./envira": 367,
		"./envira.js": 367,
		"./eraser": 368,
		"./eraser.js": 368,
		"./eur": 369,
		"./eur.js": 369,
		"./exchange": 370,
		"./exchange.js": 370,
		"./exclamation": 373,
		"./exclamation-circle": 371,
		"./exclamation-circle.js": 371,
		"./exclamation-triangle": 372,
		"./exclamation-triangle.js": 372,
		"./exclamation.js": 373,
		"./expand": 374,
		"./expand.js": 374,
		"./expeditedssl": 375,
		"./expeditedssl.js": 375,
		"./external-link": 377,
		"./external-link-square": 376,
		"./external-link-square.js": 376,
		"./external-link.js": 377,
		"./eye": 379,
		"./eye-slash": 378,
		"./eye-slash.js": 378,
		"./eye.js": 379,
		"./eyedropper": 380,
		"./eyedropper.js": 380,
		"./facebook": 383,
		"./facebook-official": 381,
		"./facebook-official.js": 381,
		"./facebook-square": 382,
		"./facebook-square.js": 382,
		"./facebook.js": 383,
		"./fast-backward": 384,
		"./fast-backward.js": 384,
		"./fast-forward": 385,
		"./fast-forward.js": 385,
		"./fax": 386,
		"./fax.js": 386,
		"./feed": 387,
		"./feed.js": 387,
		"./female": 388,
		"./female.js": 388,
		"./fighter-jet": 389,
		"./fighter-jet.js": 389,
		"./file": 402,
		"./file-archive-o": 390,
		"./file-archive-o.js": 390,
		"./file-audio-o": 391,
		"./file-audio-o.js": 391,
		"./file-code-o": 392,
		"./file-code-o.js": 392,
		"./file-excel-o": 393,
		"./file-excel-o.js": 393,
		"./file-image-o": 394,
		"./file-image-o.js": 394,
		"./file-movie-o": 395,
		"./file-movie-o.js": 395,
		"./file-o": 396,
		"./file-o.js": 396,
		"./file-pdf-o": 397,
		"./file-pdf-o.js": 397,
		"./file-powerpoint-o": 398,
		"./file-powerpoint-o.js": 398,
		"./file-text": 400,
		"./file-text-o": 399,
		"./file-text-o.js": 399,
		"./file-text.js": 400,
		"./file-word-o": 401,
		"./file-word-o.js": 401,
		"./file.js": 402,
		"./film": 403,
		"./film.js": 403,
		"./filter": 404,
		"./filter.js": 404,
		"./fire": 406,
		"./fire-extinguisher": 405,
		"./fire-extinguisher.js": 405,
		"./fire.js": 406,
		"./firefox": 407,
		"./firefox.js": 407,
		"./flag": 410,
		"./flag-checkered": 408,
		"./flag-checkered.js": 408,
		"./flag-o": 409,
		"./flag-o.js": 409,
		"./flag.js": 410,
		"./flask": 411,
		"./flask.js": 411,
		"./flickr": 412,
		"./flickr.js": 412,
		"./floppy-o": 413,
		"./floppy-o.js": 413,
		"./folder": 417,
		"./folder-o": 414,
		"./folder-o.js": 414,
		"./folder-open": 416,
		"./folder-open-o": 415,
		"./folder-open-o.js": 415,
		"./folder-open.js": 416,
		"./folder.js": 417,
		"./font": 418,
		"./font.js": 418,
		"./fonticons": 419,
		"./fonticons.js": 419,
		"./fort-awesome": 420,
		"./fort-awesome.js": 420,
		"./forumbee": 421,
		"./forumbee.js": 421,
		"./forward": 422,
		"./forward.js": 422,
		"./foursquare": 423,
		"./foursquare.js": 423,
		"./frown-o": 424,
		"./frown-o.js": 424,
		"./futbol-o": 425,
		"./futbol-o.js": 425,
		"./gamepad": 426,
		"./gamepad.js": 426,
		"./gavel": 427,
		"./gavel.js": 427,
		"./gbp": 428,
		"./gbp.js": 428,
		"./genderless": 429,
		"./genderless.js": 429,
		"./get-pocket": 430,
		"./get-pocket.js": 430,
		"./gg": 432,
		"./gg-circle": 431,
		"./gg-circle.js": 431,
		"./gg.js": 432,
		"./gift": 433,
		"./gift.js": 433,
		"./git": 435,
		"./git-square": 434,
		"./git-square.js": 434,
		"./git.js": 435,
		"./github": 438,
		"./github-alt": 436,
		"./github-alt.js": 436,
		"./github-square": 437,
		"./github-square.js": 437,
		"./github.js": 438,
		"./gitlab": 439,
		"./gitlab.js": 439,
		"./gittip": 440,
		"./gittip.js": 440,
		"./glass": 441,
		"./glass.js": 441,
		"./glide": 443,
		"./glide-g": 442,
		"./glide-g.js": 442,
		"./glide.js": 443,
		"./globe": 444,
		"./globe.js": 444,
		"./google": 448,
		"./google-plus": 446,
		"./google-plus-square": 445,
		"./google-plus-square.js": 445,
		"./google-plus.js": 446,
		"./google-wallet": 447,
		"./google-wallet.js": 447,
		"./google.js": 448,
		"./graduation-cap": 449,
		"./graduation-cap.js": 449,
		"./group": 450,
		"./group.js": 450,
		"./h-square": 451,
		"./h-square.js": 451,
		"./hacker-news": 452,
		"./hacker-news.js": 452,
		"./hand-grab-o": 453,
		"./hand-grab-o.js": 453,
		"./hand-lizard-o": 454,
		"./hand-lizard-o.js": 454,
		"./hand-o-down": 455,
		"./hand-o-down.js": 455,
		"./hand-o-left": 456,
		"./hand-o-left.js": 456,
		"./hand-o-right": 457,
		"./hand-o-right.js": 457,
		"./hand-o-up": 458,
		"./hand-o-up.js": 458,
		"./hand-paper-o": 459,
		"./hand-paper-o.js": 459,
		"./hand-peace-o": 460,
		"./hand-peace-o.js": 460,
		"./hand-pointer-o": 461,
		"./hand-pointer-o.js": 461,
		"./hand-scissors-o": 462,
		"./hand-scissors-o.js": 462,
		"./hand-spock-o": 463,
		"./hand-spock-o.js": 463,
		"./hashtag": 464,
		"./hashtag.js": 464,
		"./hdd-o": 465,
		"./hdd-o.js": 465,
		"./header": 466,
		"./header.js": 466,
		"./headphones": 467,
		"./headphones.js": 467,
		"./heart": 469,
		"./heart-o": 468,
		"./heart-o.js": 468,
		"./heart.js": 469,
		"./heartbeat": 470,
		"./heartbeat.js": 470,
		"./history": 471,
		"./history.js": 471,
		"./home": 472,
		"./home.js": 472,
		"./hospital-o": 473,
		"./hospital-o.js": 473,
		"./hourglass": 478,
		"./hourglass-1": 474,
		"./hourglass-1.js": 474,
		"./hourglass-2": 475,
		"./hourglass-2.js": 475,
		"./hourglass-3": 476,
		"./hourglass-3.js": 476,
		"./hourglass-o": 477,
		"./hourglass-o.js": 477,
		"./hourglass.js": 478,
		"./houzz": 479,
		"./houzz.js": 479,
		"./html5": 480,
		"./html5.js": 480,
		"./i-cursor": 481,
		"./i-cursor.js": 481,
		"./ils": 482,
		"./ils.js": 482,
		"./image": 483,
		"./image.js": 483,
		"./inbox": 484,
		"./inbox.js": 484,
		"./indent": 485,
		"./indent.js": 485,
		"./index": 994,
		"./index.js": 994,
		"./industry": 486,
		"./industry.js": 486,
		"./info": 488,
		"./info-circle": 487,
		"./info-circle.js": 487,
		"./info.js": 488,
		"./inr": 489,
		"./inr.js": 489,
		"./instagram": 490,
		"./instagram.js": 490,
		"./internet-explorer": 491,
		"./internet-explorer.js": 491,
		"./intersex": 492,
		"./intersex.js": 492,
		"./ioxhost": 493,
		"./ioxhost.js": 493,
		"./italic": 494,
		"./italic.js": 494,
		"./joomla": 495,
		"./joomla.js": 495,
		"./jsfiddle": 496,
		"./jsfiddle.js": 496,
		"./key": 497,
		"./key.js": 497,
		"./keyboard-o": 498,
		"./keyboard-o.js": 498,
		"./krw": 499,
		"./krw.js": 499,
		"./language": 500,
		"./language.js": 500,
		"./laptop": 501,
		"./laptop.js": 501,
		"./lastfm": 503,
		"./lastfm-square": 502,
		"./lastfm-square.js": 502,
		"./lastfm.js": 503,
		"./leaf": 504,
		"./leaf.js": 504,
		"./leanpub": 505,
		"./leanpub.js": 505,
		"./lemon-o": 506,
		"./lemon-o.js": 506,
		"./level-down": 507,
		"./level-down.js": 507,
		"./level-up": 508,
		"./level-up.js": 508,
		"./life-bouy": 509,
		"./life-bouy.js": 509,
		"./lightbulb-o": 510,
		"./lightbulb-o.js": 510,
		"./line-chart": 511,
		"./line-chart.js": 511,
		"./linkedin": 513,
		"./linkedin-square": 512,
		"./linkedin-square.js": 512,
		"./linkedin.js": 513,
		"./linux": 514,
		"./linux.js": 514,
		"./list": 518,
		"./list-alt": 515,
		"./list-alt.js": 515,
		"./list-ol": 516,
		"./list-ol.js": 516,
		"./list-ul": 517,
		"./list-ul.js": 517,
		"./list.js": 518,
		"./location-arrow": 519,
		"./location-arrow.js": 519,
		"./lock": 520,
		"./lock.js": 520,
		"./long-arrow-down": 521,
		"./long-arrow-down.js": 521,
		"./long-arrow-left": 522,
		"./long-arrow-left.js": 522,
		"./long-arrow-right": 523,
		"./long-arrow-right.js": 523,
		"./long-arrow-up": 524,
		"./long-arrow-up.js": 524,
		"./low-vision": 525,
		"./low-vision.js": 525,
		"./magic": 526,
		"./magic.js": 526,
		"./magnet": 527,
		"./magnet.js": 527,
		"./mail-forward": 528,
		"./mail-forward.js": 528,
		"./mail-reply": 530,
		"./mail-reply-all": 529,
		"./mail-reply-all.js": 529,
		"./mail-reply.js": 530,
		"./male": 531,
		"./male.js": 531,
		"./map": 536,
		"./map-marker": 532,
		"./map-marker.js": 532,
		"./map-o": 533,
		"./map-o.js": 533,
		"./map-pin": 534,
		"./map-pin.js": 534,
		"./map-signs": 535,
		"./map-signs.js": 535,
		"./map.js": 536,
		"./mars": 541,
		"./mars-double": 537,
		"./mars-double.js": 537,
		"./mars-stroke": 540,
		"./mars-stroke-h": 538,
		"./mars-stroke-h.js": 538,
		"./mars-stroke-v": 539,
		"./mars-stroke-v.js": 539,
		"./mars-stroke.js": 540,
		"./mars.js": 541,
		"./maxcdn": 542,
		"./maxcdn.js": 542,
		"./meanpath": 543,
		"./meanpath.js": 543,
		"./medium": 544,
		"./medium.js": 544,
		"./medkit": 545,
		"./medkit.js": 545,
		"./meh-o": 546,
		"./meh-o.js": 546,
		"./mercury": 547,
		"./mercury.js": 547,
		"./microphone": 549,
		"./microphone-slash": 548,
		"./microphone-slash.js": 548,
		"./microphone.js": 549,
		"./minus": 553,
		"./minus-circle": 550,
		"./minus-circle.js": 550,
		"./minus-square": 552,
		"./minus-square-o": 551,
		"./minus-square-o.js": 551,
		"./minus-square.js": 552,
		"./minus.js": 553,
		"./mixcloud": 554,
		"./mixcloud.js": 554,
		"./mobile": 555,
		"./mobile.js": 555,
		"./modx": 556,
		"./modx.js": 556,
		"./money": 557,
		"./money.js": 557,
		"./moon-o": 558,
		"./moon-o.js": 558,
		"./motorcycle": 559,
		"./motorcycle.js": 559,
		"./mouse-pointer": 560,
		"./mouse-pointer.js": 560,
		"./music": 561,
		"./music.js": 561,
		"./neuter": 562,
		"./neuter.js": 562,
		"./newspaper-o": 563,
		"./newspaper-o.js": 563,
		"./object-group": 564,
		"./object-group.js": 564,
		"./object-ungroup": 565,
		"./object-ungroup.js": 565,
		"./odnoklassniki": 567,
		"./odnoklassniki-square": 566,
		"./odnoklassniki-square.js": 566,
		"./odnoklassniki.js": 567,
		"./opencart": 568,
		"./opencart.js": 568,
		"./openid": 569,
		"./openid.js": 569,
		"./opera": 570,
		"./opera.js": 570,
		"./optin-monster": 571,
		"./optin-monster.js": 571,
		"./pagelines": 572,
		"./pagelines.js": 572,
		"./paint-brush": 573,
		"./paint-brush.js": 573,
		"./paper-plane": 575,
		"./paper-plane-o": 574,
		"./paper-plane-o.js": 574,
		"./paper-plane.js": 575,
		"./paperclip": 576,
		"./paperclip.js": 576,
		"./paragraph": 577,
		"./paragraph.js": 577,
		"./pause": 580,
		"./pause-circle": 579,
		"./pause-circle-o": 578,
		"./pause-circle-o.js": 578,
		"./pause-circle.js": 579,
		"./pause.js": 580,
		"./paw": 581,
		"./paw.js": 581,
		"./paypal": 582,
		"./paypal.js": 582,
		"./pencil": 584,
		"./pencil-square": 583,
		"./pencil-square.js": 583,
		"./pencil.js": 584,
		"./percent": 585,
		"./percent.js": 585,
		"./phone": 587,
		"./phone-square": 586,
		"./phone-square.js": 586,
		"./phone.js": 587,
		"./pie-chart": 588,
		"./pie-chart.js": 588,
		"./pied-piper": 590,
		"./pied-piper-alt": 589,
		"./pied-piper-alt.js": 589,
		"./pied-piper.js": 590,
		"./pinterest": 593,
		"./pinterest-p": 591,
		"./pinterest-p.js": 591,
		"./pinterest-square": 592,
		"./pinterest-square.js": 592,
		"./pinterest.js": 593,
		"./plane": 594,
		"./plane.js": 594,
		"./play": 597,
		"./play-circle": 596,
		"./play-circle-o": 595,
		"./play-circle-o.js": 595,
		"./play-circle.js": 596,
		"./play.js": 597,
		"./plug": 598,
		"./plug.js": 598,
		"./plus": 602,
		"./plus-circle": 599,
		"./plus-circle.js": 599,
		"./plus-square": 601,
		"./plus-square-o": 600,
		"./plus-square-o.js": 600,
		"./plus-square.js": 601,
		"./plus.js": 602,
		"./power-off": 603,
		"./power-off.js": 603,
		"./print": 604,
		"./print.js": 604,
		"./product-hunt": 605,
		"./product-hunt.js": 605,
		"./puzzle-piece": 606,
		"./puzzle-piece.js": 606,
		"./qq": 607,
		"./qq.js": 607,
		"./qrcode": 608,
		"./qrcode.js": 608,
		"./question": 611,
		"./question-circle": 610,
		"./question-circle-o": 609,
		"./question-circle-o.js": 609,
		"./question-circle.js": 610,
		"./question.js": 611,
		"./quote-left": 612,
		"./quote-left.js": 612,
		"./quote-right": 613,
		"./quote-right.js": 613,
		"./ra": 614,
		"./ra.js": 614,
		"./random": 615,
		"./random.js": 615,
		"./recycle": 616,
		"./recycle.js": 616,
		"./reddit": 619,
		"./reddit-alien": 617,
		"./reddit-alien.js": 617,
		"./reddit-square": 618,
		"./reddit-square.js": 618,
		"./reddit.js": 619,
		"./refresh": 620,
		"./refresh.js": 620,
		"./registered": 621,
		"./registered.js": 621,
		"./renren": 622,
		"./renren.js": 622,
		"./repeat": 623,
		"./repeat.js": 623,
		"./retweet": 624,
		"./retweet.js": 624,
		"./road": 625,
		"./road.js": 625,
		"./rocket": 626,
		"./rocket.js": 626,
		"./rotate-left": 627,
		"./rotate-left.js": 627,
		"./rouble": 628,
		"./rouble.js": 628,
		"./rss-square": 629,
		"./rss-square.js": 629,
		"./safari": 630,
		"./safari.js": 630,
		"./scribd": 631,
		"./scribd.js": 631,
		"./search": 634,
		"./search-minus": 632,
		"./search-minus.js": 632,
		"./search-plus": 633,
		"./search-plus.js": 633,
		"./search.js": 634,
		"./sellsy": 635,
		"./sellsy.js": 635,
		"./server": 636,
		"./server.js": 636,
		"./share-alt": 638,
		"./share-alt-square": 637,
		"./share-alt-square.js": 637,
		"./share-alt.js": 638,
		"./share-square": 640,
		"./share-square-o": 639,
		"./share-square-o.js": 639,
		"./share-square.js": 640,
		"./shield": 641,
		"./shield.js": 641,
		"./ship": 642,
		"./ship.js": 642,
		"./shirtsinbulk": 643,
		"./shirtsinbulk.js": 643,
		"./shopping-bag": 644,
		"./shopping-bag.js": 644,
		"./shopping-basket": 645,
		"./shopping-basket.js": 645,
		"./shopping-cart": 646,
		"./shopping-cart.js": 646,
		"./sign-in": 647,
		"./sign-in.js": 647,
		"./sign-language": 648,
		"./sign-language.js": 648,
		"./sign-out": 649,
		"./sign-out.js": 649,
		"./signal": 650,
		"./signal.js": 650,
		"./simplybuilt": 651,
		"./simplybuilt.js": 651,
		"./sitemap": 652,
		"./sitemap.js": 652,
		"./skyatlas": 653,
		"./skyatlas.js": 653,
		"./skype": 654,
		"./skype.js": 654,
		"./slack": 655,
		"./slack.js": 655,
		"./sliders": 656,
		"./sliders.js": 656,
		"./slideshare": 657,
		"./slideshare.js": 657,
		"./smile-o": 658,
		"./smile-o.js": 658,
		"./snapchat": 661,
		"./snapchat-ghost": 659,
		"./snapchat-ghost.js": 659,
		"./snapchat-square": 660,
		"./snapchat-square.js": 660,
		"./snapchat.js": 661,
		"./sort": 670,
		"./sort-alpha-asc": 662,
		"./sort-alpha-asc.js": 662,
		"./sort-alpha-desc": 663,
		"./sort-alpha-desc.js": 663,
		"./sort-amount-asc": 664,
		"./sort-amount-asc.js": 664,
		"./sort-amount-desc": 665,
		"./sort-amount-desc.js": 665,
		"./sort-asc": 666,
		"./sort-asc.js": 666,
		"./sort-desc": 667,
		"./sort-desc.js": 667,
		"./sort-numeric-asc": 668,
		"./sort-numeric-asc.js": 668,
		"./sort-numeric-desc": 669,
		"./sort-numeric-desc.js": 669,
		"./sort.js": 670,
		"./soundcloud": 671,
		"./soundcloud.js": 671,
		"./space-shuttle": 672,
		"./space-shuttle.js": 672,
		"./spinner": 673,
		"./spinner.js": 673,
		"./spoon": 674,
		"./spoon.js": 674,
		"./spotify": 675,
		"./spotify.js": 675,
		"./square": 677,
		"./square-o": 676,
		"./square-o.js": 676,
		"./square.js": 677,
		"./stack-exchange": 678,
		"./stack-exchange.js": 678,
		"./stack-overflow": 679,
		"./stack-overflow.js": 679,
		"./star": 683,
		"./star-half": 681,
		"./star-half-empty": 680,
		"./star-half-empty.js": 680,
		"./star-half.js": 681,
		"./star-o": 682,
		"./star-o.js": 682,
		"./star.js": 683,
		"./steam": 685,
		"./steam-square": 684,
		"./steam-square.js": 684,
		"./steam.js": 685,
		"./step-backward": 686,
		"./step-backward.js": 686,
		"./step-forward": 687,
		"./step-forward.js": 687,
		"./stethoscope": 688,
		"./stethoscope.js": 688,
		"./sticky-note": 690,
		"./sticky-note-o": 689,
		"./sticky-note-o.js": 689,
		"./sticky-note.js": 690,
		"./stop": 693,
		"./stop-circle": 692,
		"./stop-circle-o": 691,
		"./stop-circle-o.js": 691,
		"./stop-circle.js": 692,
		"./stop.js": 693,
		"./street-view": 694,
		"./street-view.js": 694,
		"./strikethrough": 695,
		"./strikethrough.js": 695,
		"./stumbleupon": 697,
		"./stumbleupon-circle": 696,
		"./stumbleupon-circle.js": 696,
		"./stumbleupon.js": 697,
		"./subscript": 698,
		"./subscript.js": 698,
		"./subway": 699,
		"./subway.js": 699,
		"./suitcase": 700,
		"./suitcase.js": 700,
		"./sun-o": 701,
		"./sun-o.js": 701,
		"./superscript": 702,
		"./superscript.js": 702,
		"./table": 703,
		"./table.js": 703,
		"./tablet": 704,
		"./tablet.js": 704,
		"./tag": 705,
		"./tag.js": 705,
		"./tags": 706,
		"./tags.js": 706,
		"./tasks": 707,
		"./tasks.js": 707,
		"./television": 708,
		"./television.js": 708,
		"./tencent-weibo": 709,
		"./tencent-weibo.js": 709,
		"./terminal": 710,
		"./terminal.js": 710,
		"./text-height": 711,
		"./text-height.js": 711,
		"./text-width": 712,
		"./text-width.js": 712,
		"./th": 715,
		"./th-large": 713,
		"./th-large.js": 713,
		"./th-list": 714,
		"./th-list.js": 714,
		"./th.js": 715,
		"./thumb-tack": 716,
		"./thumb-tack.js": 716,
		"./thumbs-down": 717,
		"./thumbs-down.js": 717,
		"./thumbs-o-down": 718,
		"./thumbs-o-down.js": 718,
		"./thumbs-o-up": 719,
		"./thumbs-o-up.js": 719,
		"./thumbs-up": 720,
		"./thumbs-up.js": 720,
		"./ticket": 721,
		"./ticket.js": 721,
		"./times-circle": 723,
		"./times-circle-o": 722,
		"./times-circle-o.js": 722,
		"./times-circle.js": 723,
		"./tint": 724,
		"./tint.js": 724,
		"./toggle-off": 725,
		"./toggle-off.js": 725,
		"./toggle-on": 726,
		"./toggle-on.js": 726,
		"./trademark": 727,
		"./trademark.js": 727,
		"./train": 728,
		"./train.js": 728,
		"./transgender-alt": 729,
		"./transgender-alt.js": 729,
		"./trash": 731,
		"./trash-o": 730,
		"./trash-o.js": 730,
		"./trash.js": 731,
		"./tree": 732,
		"./tree.js": 732,
		"./trello": 733,
		"./trello.js": 733,
		"./tripadvisor": 734,
		"./tripadvisor.js": 734,
		"./trophy": 735,
		"./trophy.js": 735,
		"./truck": 736,
		"./truck.js": 736,
		"./try": 737,
		"./try.js": 737,
		"./tty": 738,
		"./tty.js": 738,
		"./tumblr": 740,
		"./tumblr-square": 739,
		"./tumblr-square.js": 739,
		"./tumblr.js": 740,
		"./twitch": 741,
		"./twitch.js": 741,
		"./twitter": 743,
		"./twitter-square": 742,
		"./twitter-square.js": 742,
		"./twitter.js": 743,
		"./umbrella": 744,
		"./umbrella.js": 744,
		"./underline": 745,
		"./underline.js": 745,
		"./universal-access": 746,
		"./universal-access.js": 746,
		"./unlock": 748,
		"./unlock-alt": 747,
		"./unlock-alt.js": 747,
		"./unlock.js": 748,
		"./upload": 749,
		"./upload.js": 749,
		"./usb": 750,
		"./usb.js": 750,
		"./user": 755,
		"./user-md": 751,
		"./user-md.js": 751,
		"./user-plus": 752,
		"./user-plus.js": 752,
		"./user-secret": 753,
		"./user-secret.js": 753,
		"./user-times": 754,
		"./user-times.js": 754,
		"./user.js": 755,
		"./venus": 758,
		"./venus-double": 756,
		"./venus-double.js": 756,
		"./venus-mars": 757,
		"./venus-mars.js": 757,
		"./venus.js": 758,
		"./viacoin": 759,
		"./viacoin.js": 759,
		"./viadeo": 761,
		"./viadeo-square": 760,
		"./viadeo-square.js": 760,
		"./viadeo.js": 761,
		"./video-camera": 762,
		"./video-camera.js": 762,
		"./vimeo": 764,
		"./vimeo-square": 763,
		"./vimeo-square.js": 763,
		"./vimeo.js": 764,
		"./vine": 765,
		"./vine.js": 765,
		"./vk": 766,
		"./vk.js": 766,
		"./volume-control-phone": 767,
		"./volume-control-phone.js": 767,
		"./volume-down": 768,
		"./volume-down.js": 768,
		"./volume-off": 769,
		"./volume-off.js": 769,
		"./volume-up": 770,
		"./volume-up.js": 770,
		"./wechat": 771,
		"./wechat.js": 771,
		"./weibo": 772,
		"./weibo.js": 772,
		"./whatsapp": 773,
		"./whatsapp.js": 773,
		"./wheelchair": 775,
		"./wheelchair-alt": 774,
		"./wheelchair-alt.js": 774,
		"./wheelchair.js": 775,
		"./wifi": 776,
		"./wifi.js": 776,
		"./wikipedia-w": 777,
		"./wikipedia-w.js": 777,
		"./windows": 778,
		"./windows.js": 778,
		"./wordpress": 779,
		"./wordpress.js": 779,
		"./wpbeginner": 780,
		"./wpbeginner.js": 780,
		"./wpforms": 781,
		"./wpforms.js": 781,
		"./wrench": 782,
		"./wrench.js": 782,
		"./xing": 784,
		"./xing-square": 783,
		"./xing-square.js": 783,
		"./xing.js": 784,
		"./y-combinator": 785,
		"./y-combinator.js": 785,
		"./yahoo": 786,
		"./yahoo.js": 786,
		"./yelp": 787,
		"./yelp.js": 787,
		"./youtube": 790,
		"./youtube-play": 788,
		"./youtube-play.js": 788,
		"./youtube-square": 789,
		"./youtube-square.js": 789,
		"./youtube.js": 790
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1257;


/***/ },
/* 1258 */
/***/ function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1258);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Row = __webpack_require__(117);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Autocomplete = function (_Component) {
	  _inherits(Autocomplete, _Component);
	
	  function Autocomplete(props) {
	    _classCallCheck(this, Autocomplete);
	
	    var _this = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, props));
	
	    _this.state = {
	      value: ''
	    };
	
	    _this.renderIcon = _this.renderIcon.bind(_this);
	    _this.renderDropdown = _this.renderDropdown.bind(_this);
	    _this._onChange = _this._onChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(Autocomplete, [{
	    key: 'renderIcon',
	    value: function renderIcon(icon, iconClassName) {
	      return _react2.default.createElement(
	        _Icon2.default,
	        { className: iconClassName },
	        icon
	      );
	    }
	  }, {
	    key: 'renderDropdown',
	    value: function renderDropdown(data, minLength) {
	      var _this2 = this;
	
	      var value = this.state.value;
	
	
	      if (minLength && minLength > value.length || !value) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'autocomplete-content dropdown-content' },
	        Object.keys(data).map(function (key, idx) {
	          var index = key.toUpperCase().indexOf(value.toUpperCase());
	          if (index !== -1 && value.length < key.length) {
	            return _react2.default.createElement(
	              'li',
	              { key: key + '_' + idx, onClick: function onClick(evt) {
	                  return _this2.setState({ value: key });
	                } },
	              data[key] ? _react2.default.createElement('img', { src: data[key], className: 'right circle' }) : null,
	              _react2.default.createElement(
	                'span',
	                null,
	                index !== 0 ? key.substring(0, index) : '',
	                _react2.default.createElement(
	                  'span',
	                  { className: 'highlight' },
	                  value
	                ),
	                key.length !== index + value.length ? key.substring(index + value.length) : ''
	              )
	            );
	          }
	        })
	      );
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(evt) {
	      this.setState({ value: evt.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          title = _props.title,
	          data = _props.data,
	          icon = _props.icon,
	          iconClassName = _props.iconClassName,
	          s = _props.s,
	          m = _props.m,
	          l = _props.l,
	          offset = _props.offset,
	          minLength = _props.minLength,
	          props = _objectWithoutProperties(_props, ['className', 'title', 'data', 'icon', 'iconClassName', 's', 'm', 'l', 'offset', 'minLength']);
	
	      var _id = 'autocomplete-input';
	      var sizes = { s: s, m: m, l: l };
	      var classes = {};
	      _constants2.default.SIZES.forEach(function (size) {
	        classes[size + sizes[size]] = sizes[size];
	      });
	
	      return _react2.default.createElement(
	        _Row2.default,
	        null,
	        _react2.default.createElement(
	          _Col2.default,
	          _extends({ offset: offset, className: (0, _classnames2.default)('input-field', className, classes) }, props),
	          icon && this.renderIcon(icon, iconClassName),
	          _react2.default.createElement('input', {
	            className: 'autocomplete',
	            id: _id,
	            onChange: this._onChange,
	            type: 'text',
	            value: this.state.value
	          }),
	          _react2.default.createElement(
	            'label',
	            { htmlFor: _id },
	            title
	          ),
	          this.renderDropdown(data, minLength)
	        )
	      );
	    }
	  }]);
	
	  return Autocomplete;
	}(_react.Component);
	
	Autocomplete.propTypes = {
	  className: _propTypes2.default.string,
	  /*
	   * The title of the autocomplete component.
	   */
	  title: _propTypes2.default.string,
	  /*
	   * An object with the keys of the items to match in autocomplete
	   * The values are either null or a location to an image
	   */
	  data: _propTypes2.default.object.isRequired,
	  /*
	   * Optional materialize icon to add to the autocomplete bar
	   */
	  icon: _propTypes2.default.string,
	  iconClassName: _propTypes2.default.string,
	  s: _propTypes2.default.number,
	  m: _propTypes2.default.number,
	  l: _propTypes2.default.number,
	  offset: _propTypes2.default.string,
	  /*
	   * Determine input length before dropdown
	   */
	  minLength: _propTypes2.default.number
	};
	
	exports.default = Autocomplete;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Badge = function Badge(_ref) {
	  var className = _ref.className,
	      newIcon = _ref.newIcon,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['className', 'newIcon', 'children']);
	
	  var classes = {
	    badge: true,
	    'new': newIcon
	  };
	
	  return _react2.default.createElement(
	    'span',
	    _extends({}, props, { className: (0, _classnames2.default)(classes, className) }),
	    children
	  );
	};
	
	Badge.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  /**
	   * Add the <b>new</b> class name
	   */
	  newIcon: _propTypes2.default.bool
	};
	
	exports.default = Badge;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function Breadcrumb(_ref) {
	  var cols = _ref.cols,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'nav',
	    { className: 'row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'nav-wrapper' },
	      _react2.default.createElement(
	        _Col2.default,
	        { s: cols },
	        _react2.default.Children.map(children, function (item) {
	          return _react2.default.cloneElement(item, { className: 'breadcrumb' });
	        })
	      )
	    )
	  );
	};
	
	Breadcrumb.propTypes = {
	  children: _propTypes2.default.node,
	  cols: _propTypes2.default.number
	};
	
	Breadcrumb.defaultProps = {
	  cols: 12
	};
	
	exports.default = Breadcrumb;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Card = function (_Component) {
	  _inherits(Card, _Component);
	
	  function Card(props) {
	    _classCallCheck(this, Card);
	
	    var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).call(this, props));
	
	    _this.renderTitle = _this.renderTitle.bind(_this);
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          header = _props.header,
	          className = _props.className,
	          textClassName = _props.textClassName,
	          actions = _props.actions,
	          reveal = _props.reveal,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['title', 'header', 'className', 'textClassName', 'actions', 'reveal', 'children']);
	
	      var classes = { card: true };
	      return _react2.default.createElement(
	        'div',
	        _extends({}, props, {
	          className: (0, _classnames2.default)(className, classes) }),
	        header,
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('card-content', textClassName) },
	          title ? this.renderTitle(title, reveal) : null,
	          _react2.default.createElement(
	            'div',
	            null,
	            children
	          )
	        ),
	        this.renderReveal(title, reveal),
	        actions ? this.renderAction(actions) : null
	      );
	    }
	  }, {
	    key: 'renderTitle',
	    value: function renderTitle(title, reveal) {
	      var revealIcon = null;
	      if (reveal) {
	        revealIcon = _react2.default.createElement(
	          _Icon2.default,
	          { right: true },
	          'more_vert'
	        );
	      }
	      var classes = {
	        'card-title': true,
	        'grey-text': true,
	        'text-darken-4': true,
	        'activator': reveal
	      };
	      return _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)(classes) },
	        title,
	        revealIcon
	      );
	    }
	  }, {
	    key: 'renderReveal',
	    value: function renderReveal(title, reveal) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-reveal' },
	        _react2.default.createElement(
	          'span',
	          { className: 'card-title grey-text text-darken-4' },
	          title,
	          _react2.default.createElement(
	            _Icon2.default,
	            { right: true },
	            'close'
	          )
	        ),
	        reveal
	      );
	    }
	  }, {
	    key: 'renderAction',
	    value: function renderAction(actions) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'card-action' },
	        actions
	      );
	    }
	  }]);
	
	  return Card;
	}(_react.Component);
	
	Card.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  textClassName: _propTypes2.default.string,
	  reveal: _propTypes2.default.element,
	  header: _propTypes2.default.element,
	  // The buttons to be displayed at the action area
	  actions: _propTypes2.default.arrayOf(_propTypes2.default.element)
	};
	
	exports.default = Card;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CardPanel = function CardPanel(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['className', 'children']);
	
	  var classes = {
	    'card-panel': true
	  };
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ className: (0, _classnames2.default)(classes, className) }, props),
	    children
	  );
	};
	
	CardPanel.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	exports.default = CardPanel;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardTitle = function (_Component) {
	  _inherits(CardTitle, _Component);
	
	  function CardTitle() {
	    _classCallCheck(this, CardTitle);
	
	    return _possibleConstructorReturn(this, (CardTitle.__proto__ || Object.getPrototypeOf(CardTitle)).apply(this, arguments));
	  }
	
	  _createClass(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          image = _props.image,
	          reveal = _props.reveal,
	          waves = _props.waves,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['image', 'reveal', 'waves', 'children']);
	
	      var classes = {
	        'card-image': true
	      };
	      if (waves) {
	        classes['waves-effect'] = true;
	        classes['waves-' + waves] = true;
	        classes['waves-block'] = true;
	      }
	      var imgClasses = { 'activator': reveal };
	      var titleClasses = {
	        'card-title': true
	      };
	      return _react2.default.createElement(
	        'div',
	        _extends({ className: (0, _classnames2.default)(classes) }, props),
	        _react2.default.createElement('img', { className: (0, _classnames2.default)(imgClasses), src: image }),
	        _react2.default.createElement(
	          'span',
	          { className: (0, _classnames2.default)(titleClasses) },
	          children
	        )
	      );
	    }
	  }]);
	
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.propTypes = {
	  children: _propTypes2.default.node,
	  // Whether the image serves as activator for the reveal
	  reveal: _propTypes2.default.bool,
	  // the waves effect
	  waves: _propTypes2.default.oneOf(_constants2.default.WAVES),
	  // The path to the image
	  image: _propTypes2.default.string.isRequired
	};
	
	exports.default = CardTitle;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collapsible = function (_Component) {
	  _inherits(Collapsible, _Component);
	
	  function Collapsible(props) {
	    _classCallCheck(this, Collapsible);
	
	    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));
	
	    _this.renderItem = _this.renderItem.bind(_this);
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    _this.state = {
	      activeKey: _this.props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  _createClass(Collapsible, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          accordion = _props.accordion,
	          popout = _props.popout,
	          className = _props.className,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['accordion', 'popout', 'className', 'children']);
	
	      delete props.defaultActiveKey;
	
	      var classes = {
	        collapsible: true,
	        popout: popout
	      };
	      var collapsible = accordion ? 'accordion' : 'expandable';
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({ className: (0, _classnames2.default)(className, classes) }, props, { 'data-collapsible': collapsible }),
	        _react2.default.Children.map(children, this.renderItem)
	      );
	    }
	  }, {
	    key: 'renderItem',
	    value: function renderItem(child) {
	      if (!child) return null;
	
	      var props = {};
	
	      if (this.props.accordion) {
	        props.expanded = child.props.eventKey === this.state.activeKey;
	        props.onSelect = this.handleSelect;
	      }
	
	      return _react2.default.cloneElement(child, props);
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(key) {
	      var onSelect = this.props.onSelect;
	
	
	      if (onSelect) {
	        onSelect(key);
	      }
	      if (this.state.activeKey === key) {
	        key = null;
	      }
	
	      this.setState({ activeKey: key });
	    }
	  }]);
	
	  return Collapsible;
	}(_react.Component);
	
	Collapsible.propTypes = {
	  /**
	   * There are two ways a collapsible can behave. It can either allow multiple sections to stay open,
	   * or it can only allow one section to stay open at a time, which is called an accordion.
	   * @default false
	   */
	  accordion: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  /**
	   * Enable popout style
	   */
	  popout: _propTypes2.default.bool,
	  /**
	   * The default CollapsibleItem that should be expanded. This value should match the specified
	   * item's eventKey value. Ignored if accordion is false.
	   */
	  defaultActiveKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func
	};
	
	Collapsible.defaultProps = {
	  accordion: false
	};
	
	exports.default = Collapsible;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(999);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsibleItem = function (_Component) {
	  _inherits(CollapsibleItem, _Component);
	
	  function CollapsibleItem(props) {
	    _classCallCheck(this, CollapsibleItem);
	
	    var _this = _possibleConstructorReturn(this, (CollapsibleItem.__proto__ || Object.getPrototypeOf(CollapsibleItem)).call(this, props));
	
	    _this.state = {
	      expanded: props.expanded
	    };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.renderBody = _this.renderBody.bind(_this);
	    _this.renderIcon = _this.renderIcon.bind(_this);
	    return _this;
	  }
	
	  _createClass(CollapsibleItem, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props = this.props,
	          scroll = _props.scroll,
	          expanded = _props.expanded;
	
	
	      if (expanded) {
	        _reactDom2.default.findDOMNode(this).scrollIntoView({ behavior: scroll });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          node = _props2.node,
	          header = _props2.header,
	          icon = _props2.icon,
	          iconClassName = _props2.iconClassName,
	          className = _props2.className,
	          props = _objectWithoutProperties(_props2, ['node', 'header', 'icon', 'iconClassName', 'className']);
	
	      var expanded = this.state.expanded;
	
	
	      delete props.expanded;
	      delete props.eventKey;
	
	      var C = node;
	      var liClasses = {
	        active: expanded
	      };
	      var headerClasses = {
	        'collapsible-header': true,
	        active: expanded
	      };
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ className: (0, _classnames2.default)(liClasses, className) }, props),
	        _react2.default.createElement(
	          C,
	          { className: (0, _classnames2.default)(headerClasses), onClick: this.handleClick },
	          icon && this.renderIcon(icon, iconClassName),
	          header
	        ),
	        expanded && this.renderBody()
	      );
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _props3 = this.props,
	          onSelect = _props3.onSelect,
	          eventKey = _props3.eventKey;
	
	
	      if (onSelect) {
	        onSelect(eventKey);
	      } else {
	        this.setState({ expanded: !this.state.expanded });
	      }
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'collapsible-body', style: { display: 'block' } },
	        this.props.children
	      );
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon(icon, iconClassName) {
	      return _react2.default.createElement(
	        _Icon2.default,
	        { className: iconClassName },
	        icon
	      );
	    }
	  }]);
	
	  return CollapsibleItem;
	}(_react.Component);
	
	CollapsibleItem.propTypes = {
	  header: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.string,
	  iconClassName: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  onSelect: _propTypes2.default.func,
	  /**
	   * If the item is expanded by default. Overridden if the parent Collapsible is an accordion.
	   * @default false
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * The value to pass to the onSelect callback.
	   */
	  eventKey: _propTypes2.default.any,
	  className: _propTypes2.default.string,
	  /**
	   * The node type of the header
	   * @default a
	   */
	  node: _propTypes2.default.node,
	  /**
	   * The scroll behavior for scrollIntoView
	   */
	  scroll: _propTypes2.default.oneOf(['auto', 'instant', 'smooth'])
	};
	
	CollapsibleItem.defaultProps = {
	  expanded: false,
	  node: 'a'
	};
	
	exports.default = CollapsibleItem;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Collection = function (_Component) {
	  _inherits(Collection, _Component);
	
	  function Collection(props) {
	    _classCallCheck(this, Collection);
	
	    var _this = _possibleConstructorReturn(this, (Collection.__proto__ || Object.getPrototypeOf(Collection)).call(this, props));
	
	    _this.renderHeader = _this.renderHeader.bind(_this);
	    return _this;
	  }
	
	  _createClass(Collection, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          header = _props.header;
	
	
	      var classes = {
	        collection: true,
	        'with-header': !!header
	      };
	      var C = 'ul';
	      _react2.default.Children.forEach(children, function (child) {
	        if (child.props.href) {
	          C = 'div';
	        }
	      });
	      return _react2.default.createElement(
	        C,
	        { className: (0, _classnames2.default)(classes) },
	        header ? this.renderHeader() : null,
	        children
	      );
	    }
	  }, {
	    key: 'renderHeader',
	    value: function renderHeader() {
	      var header = void 0;
	      if (this.props.header) {
	        if (_react2.default.isValidElement(this.props.header)) {
	          header = this.props.header;
	        } else {
	          header = _react2.default.createElement(
	            'h4',
	            null,
	            this.props.header
	          );
	        }
	        return _react2.default.createElement(
	          'li',
	          { className: 'collection-header' },
	          header
	        );
	      }
	    }
	  }]);
	
	  return Collection;
	}(_react.Component);
	
	Collection.propTypes = {
	  children: _propTypes2.default.node,
	  header: _propTypes2.default.node
	};
	
	exports.default = Collection;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollectionItem = function (_Component) {
	  _inherits(CollectionItem, _Component);
	
	  function CollectionItem() {
	    _classCallCheck(this, CollectionItem);
	
	    return _possibleConstructorReturn(this, (CollectionItem.__proto__ || Object.getPrototypeOf(CollectionItem)).apply(this, arguments));
	  }
	
	  _createClass(CollectionItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          className = _props.className,
	          other = _objectWithoutProperties(_props, ['active', 'children', 'className']);
	
	      var classes = {
	        'collection-item': true,
	        active: active
	      };
	
	      var C = this.props.href ? 'a' : 'li';
	
	      return _react2.default.createElement(
	        C,
	        _extends({}, other, { className: (0, _classnames2.default)(className, classes) }),
	        children
	      );
	    }
	  }]);
	
	  return CollectionItem;
	}(_react.Component);
	
	CollectionItem.propTypes = {
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  href: _propTypes2.default.string
	};
	
	exports.default = CollectionItem;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var classes = {
	  'dropdown-content': true
	};
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));
	
	    _this.renderTrigger = _this.renderTrigger.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var options = this.props.options || {};
	
	      $(this._trigger).dropdown(options);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      $(this._trigger).off();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['children', 'className']);
	
	      this.idx = 'dropdown_' + (0, _idgen2.default)();
	      delete props.trigger;
	      delete props.options;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.renderTrigger(),
	        _react2.default.createElement(
	          'ul',
	          _extends({}, props, { className: (0, _classnames2.default)(classes, className), id: this.idx }),
	          children
	        )
	      );
	    }
	  }, {
	    key: 'renderTrigger',
	    value: function renderTrigger() {
	      var _this2 = this;
	
	      var trigger = this.props.trigger;
	
	
	      return _react2.default.cloneElement(trigger, {
	        ref: function ref(t) {
	          return _this2._trigger = '[data-activates=' + _this2.idx + ']';
	        },
	        className: 'dropdown-button',
	        'data-activates': this.idx
	      });
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  /**
	   * The node to trigger the dropdown
	   */
	  trigger: _propTypes2.default.node.isRequired,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  /**
	   * Options hash for the dropdown
	   * more info: http://materializecss.com/dropdown.html#options
	   */
	  options: _propTypes2.default.shape({
	    inDuration: _propTypes2.default.number,
	    outDuration: _propTypes2.default.number,
	    constrain_width: _propTypes2.default.bool,
	    hover: _propTypes2.default.bool,
	    gutter: _propTypes2.default.number,
	    belowOrigin: _propTypes2.default.bool,
	    alignment: _propTypes2.default.oneOf(['left', 'right'])
	  })
	};
	
	exports.default = Dropdown;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Row = __webpack_require__(117);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          copyrights = _props.copyrights,
	          links = _props.links,
	          moreLinks = _props.moreLinks,
	          props = _objectWithoutProperties(_props, ['children', 'className', 'copyrights', 'links', 'moreLinks']);
	
	      var classes = {
	        'page-footer': true
	      };
	
	      return _react2.default.createElement(
	        'footer',
	        _extends({ className: (0, _classnames2.default)(classes, className) }, props),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            _Row2.default,
	            null,
	            _react2.default.createElement(
	              _Col2.default,
	              { l: 6, s: 12 },
	              children
	            ),
	            _react2.default.createElement(
	              _Col2.default,
	              { l: 4, s: 12, offset: 'l2' },
	              links
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'footer-copyright' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            copyrights,
	            moreLinks
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	Footer.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  copyrights: _propTypes2.default.string,
	  links: _propTypes2.default.node,
	  moreLinks: _propTypes2.default.node
	};
	
	exports.default = Footer;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.state = {
	      value: props.defaultValue
	    };
	
	    _this._onChange = _this._onChange.bind(_this);
	    _this.getMultipleValues = _this.getMultipleValues.bind(_this);
	    _this.isSelect = _this.isSelect.bind(_this);
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.isMaterialSelect()) {
	        $(this.selectInput).material_select();
	        $(this.selectInput).on('change', this._onChange);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.isMaterialSelect() && !this.props.multiple) {
	        $(this.selectInput).material_select();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.isMaterialSelect()) {
	        this.setState({
	          value: nextProps.defaultValue
	        }, function () {
	          return $(_this2.selectInput).material_select();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.isMaterialSelect()) {
	        $(this.selectInput).off('change', this._onChange);
	      }
	    }
	  }, {
	    key: 'getMultipleValues',
	    value: function getMultipleValues(_ref) {
	      var options = _ref.options;
	
	      if (!options) {
	        return;
	      }
	
	      return Array.from(options).filter(function (opt) {
	        return opt.selected;
	      }).map(function (opt) {
	        return opt.value;
	      });
	    }
	  }, {
	    key: '_onChange',
	    value: function _onChange(e) {
	      var onChange = this.props.onChange;
	
	      var types = {
	        'checkbox': e.target.checked,
	        'select-multiple': this.getMultipleValues(e.target),
	        'default': e.target.value
	      };
	      var value = types[e.target.type] || types['default'];
	      if (onChange) {
	        onChange(e);
	      }
	
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          browserDefault = _props.browserDefault,
	          children = _props.children,
	          className = _props.className,
	          defaultValue = _props.defaultValue,
	          error = _props.error,
	          label = _props.label,
	          multiple = _props.multiple,
	          placeholder = _props.placeholder,
	          success = _props.success,
	          s = _props.s,
	          m = _props.m,
	          l = _props.l,
	          type = _props.type,
	          validate = _props.validate,
	          onLabel = _props.onLabel,
	          offLabel = _props.offLabel,
	          other = _objectWithoutProperties(_props, ['browserDefault', 'children', 'className', 'defaultValue', 'error', 'label', 'multiple', 'placeholder', 'success', 's', 'm', 'l', 'type', 'validate', 'onLabel', 'offLabel']);
	
	      var sizes = { s: s, m: m, l: l };
	      this._id = this._id || this.props.id || 'input_' + (0, _idgen2.default)();
	      var classes = {
	        col: true,
	        'input-field': type !== 'checkbox' && type !== 'radio'
	      };
	      _constants2.default.SIZES.forEach(function (size) {
	        classes[size + sizes[size]] = sizes[size];
	      });
	      var inputClasses = {
	        validate: validate,
	        invalid: error,
	        valid: success,
	        'browser-default': browserDefault && this.isSelect()
	      };
	      var C = void 0,
	          inputType = void 0;
	      switch (type) {
	        case 'textarea':
	          C = 'textarea';
	          inputClasses['materialize-textarea'] = true;
	          break;
	        case 'switch':
	          C = 'input';
	          inputType = 'checkbox';
	          break;
	        default:
	          C = 'input';
	          inputType = type || 'text';
	      }
	      var labelClasses = {
	        active: this.state.value || this.isSelect()
	      };
	
	      var htmlLabel = label || inputType === 'radio' ? _react2.default.createElement(
	        'label',
	        {
	          className: (0, _classnames2.default)(labelClasses),
	          'data-success': success,
	          'data-error': error,
	          htmlFor: this._id
	        },
	        label
	      ) : null;
	
	      if (this.isSelect()) {
	        var options = placeholder && !defaultValue ? [_react2.default.createElement(
	          'option',
	          { disabled: true, key: (0, _idgen2.default)() },
	          placeholder
	        )] : [];
	        options = options.concat(_react2.default.Children.map(children, function (child) {
	          return _react2.default.cloneElement(child, { 'key': child.props.value });
	        }));
	
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes) },
	          htmlLabel,
	          _react2.default.createElement(
	            'select',
	            _extends({}, other, {
	              multiple: multiple,
	              id: this._id,
	              className: (0, _classnames2.default)(className, inputClasses),
	              ref: function ref(_ref2) {
	                return _this3.selectInput = _ref2;
	              },
	              defaultValue: defaultValue
	            }),
	            options
	          )
	        );
	      } else if (type === 'switch') {
	        return _react2.default.createElement(
	          'div',
	          { className: 'switch' },
	          _react2.default.createElement(
	            'label',
	            null,
	            offLabel || 'Off',
	            _react2.default.createElement('input', _extends({}, other, {
	              onChange: this._onChange,
	              type: 'checkbox'
	            })),
	            _react2.default.createElement('span', { className: 'lever' }),
	            onLabel || 'On'
	          )
	        );
	      } else {
	        var _defaultValue = inputType !== 'checkbox' && inputType !== 'radio' ? this.state.value : _defaultValue;
	
	        return _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes) },
	          this.renderIcon(),
	          _react2.default.createElement(C, _extends({}, other, {
	            className: (0, _classnames2.default)(className, inputClasses),
	            defaultValue: _defaultValue,
	            id: this._id,
	            onChange: this._onChange,
	            placeholder: placeholder,
	            type: inputType
	          })),
	          htmlLabel
	        );
	      }
	    }
	  }, {
	    key: 'renderIcon',
	    value: function renderIcon() {
	      var _props2 = this.props,
	          icon = _props2.icon,
	          children = _props2.children;
	
	      if (icon) {
	        return _react2.default.createElement(
	          _Icon2.default,
	          { className: 'prefix' },
	          icon
	        );
	      } else {
	        var _icon = null;
	        if (_react2.default.Children.count(children) === 1) {
	          _icon = _react2.default.Children.only(children);
	        }
	        return _icon === null ? null : _react2.default.cloneElement(_icon, { className: 'prefix' });
	      }
	    }
	  }, {
	    key: 'isSelect',
	    value: function isSelect() {
	      return this.props.type === 'select';
	    }
	  }, {
	    key: 'isMaterialSelect',
	    value: function isMaterialSelect() {
	      return this.props.type === 'select' && !this.props.browserDefault && typeof $ !== 'undefined';
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	Input.propTypes = {
	  s: _propTypes2.default.number,
	  m: _propTypes2.default.number,
	  l: _propTypes2.default.number,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  error: _propTypes2.default.string,
	  success: _propTypes2.default.string,
	  /**
	   * Input field type, e.g. select, checkbox, radio, text, tel, email
	   * @default 'text'
	   */
	  type: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.any,
	  placeholder: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  validate: _propTypes2.default.bool,
	  multiple: _propTypes2.default.bool,
	  browserDefault: _propTypes2.default.bool,
	  onLabel: _propTypes2.default.string,
	  offLabel: _propTypes2.default.string,
	  onChange: _propTypes2.default.func
	};
	
	Input.defaultProps = { type: 'text' };
	
	exports.default = Input;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MediaBox = function MediaBox(_ref) {
	  var src = _ref.src,
	      className = _ref.className,
	      caption = _ref.caption,
	      props = _objectWithoutProperties(_ref, ['src', 'className', 'caption']);
	
	  return _react2.default.createElement('img', _extends({ className: (0, _classnames2.default)('materialboxed', className), 'data-caption': caption, src: src }, props));
	};
	
	MediaBox.propTypes = {
	  className: _propTypes2.default.string,
	  /**
	   * The caption shown below the image when opened
	   */
	  caption: _propTypes2.default.string,
	  /**
	   * The path to the image
	   */
	  src: _propTypes2.default.string.isRequired
	};
	
	exports.default = MediaBox;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This should be used within any component that has a menu like interface
	var MenuItem = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem() {
	    _classCallCheck(this, MenuItem);
	
	    return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
	  }
	
	  _createClass(MenuItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          href = _props.href,
	          breadcrumbItem = _props.breadcrumbItem,
	          children = _props.children,
	          className = _props.className,
	          props = _objectWithoutProperties(_props, ['href', 'breadcrumbItem', 'children', 'className']);
	
	      var classes = {
	        breadcrumb: breadcrumbItem
	      };
	      return _react2.default.createElement(
	        'a',
	        _extends({ href: href }, props, { className: (0, _classnames2.default)(classes, className) }),
	        children
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  // internal
	  breadcrumbItem: _propTypes2.default.bool,
	  /**
	   * The link for the anchor
	   */
	  href: _propTypes2.default.string
	};
	
	exports.default = MenuItem;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(791);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _OverlayTrigger = __webpack_require__(997);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
	
	    _this.modalID = props.id || 'modal_' + (0, _idgen2.default)();
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          trigger = _props.trigger,
	          modalOptions = _props.modalOptions;
	
	
	      if (!trigger) {
	        $('#' + this.modalID).modal(modalOptions);
	      }
	    }
	  }, {
	    key: 'renderOverlay',
	    value: function renderOverlay() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          bottomSheet = _props2.bottomSheet,
	          children = _props2.children,
	          fixedFooter = _props2.fixedFooter,
	          header = _props2.header,
	          other = _objectWithoutProperties(_props2, ['actions', 'bottomSheet', 'children', 'fixedFooter', 'header']);
	
	      delete other.modalOptions;
	      delete other.trigger;
	
	      var classes = (0, _classnames2.default)({
	        'modal': true,
	        'modal-fixed-footer': fixedFooter,
	        'bottom-sheet': bottomSheet
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { className: classes, id: this.modalID }),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-content' },
	          _react2.default.createElement(
	            'h4',
	            null,
	            header
	          ),
	          children
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'modal-footer' },
	          _react2.default.Children.toArray(actions)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          modalOptions = _props3.modalOptions,
	          trigger = _props3.trigger;
	
	
	      return _react2.default.createElement(
	        _OverlayTrigger2.default,
	        {
	          modalOptions: modalOptions,
	          overlay: this.renderOverlay()
	        },
	        trigger
	      );
	    }
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  /**
	  * ModalOptions
	  * Object with options for modal
	  */
	  modalOptions: _propTypes2.default.shape({
	    /*
	     * Modal can be dismissed by clicking outside of the modal
	     */
	    dismissible: _propTypes2.default.bool,
	    /*
	     * Opacity of modal background ( from 0 to 1 )
	     */
	    opacity: _propTypes2.default.number,
	    /*
	     * Transition in duration
	     */
	    inDuration: _propTypes2.default.number,
	    /*
	     * Transition out duration
	     */
	    outDuration: _propTypes2.default.number,
	    /*
	     * Starting top style attribute
	     */
	    startingTop: _propTypes2.default.string,
	    /*
	     * Ending top style attribute
	     */
	    endingTop: _propTypes2.default.string,
	    /*
	     * Callback for Modal open. Modal and trigger parameters available.
	     */
	    ready: _propTypes2.default.func,
	    /*
	     *  Callback for Modal close
	     */
	    complete: _propTypes2.default.func
	  }),
	  /**
	  * BottomSheet styled modal
	  * @default false
	  */
	  bottomSheet: _propTypes2.default.bool,
	  /**
	   * Component children
	   */
	  children: _propTypes2.default.node,
	  /**
	  * FixedFooter styled modal
	  * @default false
	  */
	  fixedFooter: _propTypes2.default.bool,
	  /**
	   * Text to shown in the header of the modal
	   */
	  header: _propTypes2.default.string,
	  /**
	   * The button to trigger the display of the modal
	   */
	  trigger: _propTypes2.default.node,
	  /**
	   * The buttons to show in the footer of the modal
	   * @default <Button>Close</Button>
	   */
	  actions: _propTypes2.default.node,
	  /**
	   * The ID to trigger the modal opening/closing
	   */
	  id: _propTypes2.default.string
	};
	
	Modal.defaultProps = {
	  modalOptions: {},
	  fixedFooter: false,
	  bottomSheet: false,
	  actions: [_react2.default.createElement(
	    _Button2.default,
	    { waves: 'light', modal: 'close', flat: true },
	    'Close'
	  )]
	};
	
	exports.default = Modal;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavItem = function (_Component) {
	  _inherits(NavItem, _Component);
	
	  function NavItem() {
	    _classCallCheck(this, NavItem);
	
	    return _possibleConstructorReturn(this, (NavItem.__proto__ || Object.getPrototypeOf(NavItem)).apply(this, arguments));
	  }
	
	  _createClass(NavItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          divider = _props.divider,
	          href = _props.href,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['divider', 'href', 'children']);
	
	      if (divider) {
	        return _react2.default.createElement('li', { className: 'divider' });
	      } else {
	        return _react2.default.createElement(
	          'li',
	          props,
	          _react2.default.createElement(
	            'a',
	            { href: href },
	            children
	          )
	        );
	      }
	    }
	  }]);
	
	  return NavItem;
	}(_react.Component);
	
	NavItem.propTypes = {
	  children: _propTypes2.default.node,
	  divider: _propTypes2.default.bool,
	  href: _propTypes2.default.string
	};
	
	exports.default = NavItem;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_Component) {
	  _inherits(Navbar, _Component);
	
	  function Navbar(props) {
	    _classCallCheck(this, Navbar);
	
	    var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));
	
	    _this.renderSideNav = _this.renderSideNav.bind(_this);
	    return _this;
	  }
	
	  _createClass(Navbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof $ !== 'undefined') {
	        $('.button-collapse').sideNav(this.props.options);
	      }
	    }
	  }, {
	    key: 'renderSideNav',
	    value: function renderSideNav() {
	      return _react2.default.createElement(
	        'ul',
	        { id: 'nav-mobile', className: 'side-nav' },
	        this.props.children
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          brand = _props.brand,
	          className = _props.className,
	          left = _props.left,
	          right = _props.right,
	          href = _props.href,
	          other = _objectWithoutProperties(_props, ['brand', 'className', 'left', 'right', 'href']);
	
	      var classes = {
	        right: right,
	        'hide-on-med-and-down': true
	      };
	
	      var brandClasses = {
	        'brand-logo': true,
	        right: left
	      };
	
	      return _react2.default.createElement(
	        'nav',
	        _extends({}, other, { className: className }),
	        _react2.default.createElement(
	          'div',
	          { className: 'nav-wrapper' },
	          _react2.default.createElement(
	            _Col2.default,
	            { s: 12 },
	            _react2.default.createElement(
	              'a',
	              { href: href, className: (0, _classnames2.default)(brandClasses) },
	              brand
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: (0, _classnames2.default)(className, classes) },
	              this.props.children
	            ),
	            this.renderSideNav(),
	            _react2.default.createElement(
	              'a',
	              { className: 'button-collapse', href: '#', 'data-activates': 'nav-mobile' },
	              _react2.default.createElement(
	                _Icon2.default,
	                null,
	                'view_headline'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Navbar;
	}(_react.Component);
	
	Navbar.propTypes = {
	  brand: _propTypes2.default.node,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  left: _propTypes2.default.bool,
	  right: _propTypes2.default.bool,
	  href: _propTypes2.default.string,
	  /**
	   * Options hash for the sidenav.
	   * More info: http://materializecss.com/side-nav.html#options
	   */
	  options: _propTypes2.default.shape({
	    menuWidth: _propTypes2.default.number,
	    edge: _propTypes2.default.oneOf(['left', 'right']),
	    closeOnClick: _propTypes2.default.bool,
	    draggable: _propTypes2.default.bool
	  })
	};
	
	Navbar.defaultProps = {
	  href: '/',
	  options: {}
	};
	
	exports.default = Navbar;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _PaginationButton = __webpack_require__(998);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_Component) {
	  _inherits(Pagination, _Component);
	
	  function Pagination(props) {
	    _classCallCheck(this, Pagination);
	
	    var _this = _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    var activePage = props.activePage,
	        items = props.items;
	
	
	    _this.state = {
	      activePage: activePage > 0 && activePage <= items ? activePage : 1
	    };
	
	    _this.renderButtons = _this.renderButtons.bind(_this);
	    _this._onClick = _this._onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: '_onClick',
	    value: function _onClick(i) {
	      var _this2 = this;
	
	      var _props = this.props,
	          items = _props.items,
	          onSelect = _props.onSelect;
	
	
	      return function () {
	        if (i > 0 && i <= items) {
	          if (onSelect) {
	            onSelect(i);
	          }
	          _this2.setState({ activePage: i });
	        }
	      };
	    }
	  }, {
	    key: 'renderButtons',
	    value: function renderButtons() {
	      var _props2 = this.props,
	          items = _props2.items,
	          children = _props2.children,
	          _props2$maxButtons = _props2.maxButtons,
	          maxButtons = _props2$maxButtons === undefined ? items : _props2$maxButtons;
	      var activePage = this.state.activePage;
	
	
	      if (children) return children;
	
	      var buttonsCount = Math.min(maxButtons, items);
	
	      var maxPos = items - buttonsCount;
	      var halfButtons = parseInt(buttonsCount / 2, 10);
	
	      var hiddenPagesBefore = activePage - halfButtons;
	      if (hiddenPagesBefore > maxPos) {
	        hiddenPagesBefore = maxPos + 1;
	      }
	
	      var from = Math.max(hiddenPagesBefore, 1);
	      var to = Math.min(items, from + maxButtons - 1);
	
	      var buttons = [_react2.default.createElement(
	        _PaginationButton2.default,
	        {
	          disabled: activePage === 1,
	          key: 'pagination-0',
	          onSelect: this._onClick(activePage - 1)
	        },
	        _react2.default.createElement(
	          _Icon2.default,
	          null,
	          'chevron_left'
	        )
	      )];
	
	      for (var i = from; i <= to; i++) {
	        buttons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            active: i === activePage,
	            key: 'pagination-' + i,
	            onSelect: this._onClick(i)
	          },
	          i
	        ));
	      }
	
	      buttons.push(_react2.default.createElement(
	        _PaginationButton2.default,
	        {
	          key: 'pagination-' + (items + 1),
	          disabled: activePage === items,
	          onSelect: this._onClick(activePage + 1)
	        },
	        _react2.default.createElement(
	          _Icon2.default,
	          null,
	          'chevron_right'
	        )
	      ));
	
	      return buttons;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'ul',
	        { className: (0, _classnames2.default)('pagination', this.props.className) },
	        this.renderButtons()
	      );
	    }
	  }]);
	
	  return Pagination;
	}(_react.Component);
	
	Pagination.propTypes = {
	  /**
	   * Number of items in the component
	   */
	  items: _propTypes2.default.number.isRequired,
	  /**
	   * The initial activePage
	   */
	  activePage: _propTypes2.default.number,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  maxButtons: _propTypes2.default.number,
	  onSelect: _propTypes2.default.func
	};
	
	Pagination.defaultProps = {
	  activePage: 1,
	  items: 10
	};
	
	exports.default = Pagination;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Parallax = function (_Component) {
	  _inherits(Parallax, _Component);
	
	  function Parallax() {
	    _classCallCheck(this, Parallax);
	
	    return _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).apply(this, arguments));
	  }
	
	  _createClass(Parallax, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      $('.parallax').parallax();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          imageSrc = _props.imageSrc;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('parallax-container', className) },
	        _react2.default.createElement(
	          'div',
	          { className: 'parallax' },
	          _react2.default.createElement('img', { src: imageSrc })
	        )
	      );
	    }
	  }]);
	
	  return Parallax;
	}(_react.Component);
	
	Parallax.propTypes = {
	  className: _propTypes2.default.string,
	  /**
	  * The image path which will be used for the background of the parallax
	  */
	  imageSrc: _propTypes2.default.string
	};
	exports.default = Parallax;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Spinner = __webpack_require__(1287);
	
	var _Spinner2 = _interopRequireDefault(_Spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colors = ['blue', 'red', 'yellow', 'green'];
	
	var Preloader = function (_Component) {
	  _inherits(Preloader, _Component);
	
	  function Preloader() {
	    _classCallCheck(this, Preloader);
	
	    return _possibleConstructorReturn(this, (Preloader.__proto__ || Object.getPrototypeOf(Preloader)).apply(this, arguments));
	  }
	
	  _createClass(Preloader, [{
	    key: 'render',
	    value: function render() {
	      var classes = {
	        'preloader-wrapper': true,
	        active: this.props.active
	      };
	
	      if (this.props.size) {
	        classes[this.props.size] = true;
	      }
	
	      var spinners = void 0;
	      if (this.props.flashing) {
	        spinners = [];
	        colors.map(function (color) {
	          spinners.push(_react2.default.createElement(_Spinner2.default, { color: color, only: false, key: color }));
	        });
	      } else {
	        spinners = _react2.default.createElement(_Spinner2.default, { color: this.props.color });
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(this.props.className, classes) },
	        spinners
	      );
	    }
	  }]);
	
	  return Preloader;
	}(_react.Component);
	
	Preloader.propTypes = {
	  className: _propTypes2.default.string,
	  /**
	   * The scale of the circle
	   * @default 'medium'
	   */
	  size: _propTypes2.default.oneOf(['big', 'small', 'medium']),
	  /**
	   * Whether to spin
	   * @default true
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The color of the circle, if not flashing
	   * @default 'blue'
	   */
	  color: _propTypes2.default.oneOf(['blue', 'red', 'yellow', 'green']),
	  /**
	   * Wheter to circle four different colors
	   * @default false
	   */
	  flashing: _propTypes2.default.bool
	};
	
	Preloader.defaultProps = {
	  active: true,
	  flashing: false,
	  color: 'blue'
	};
	
	exports.default = Preloader;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProgressBar = function ProgressBar(_ref) {
	  var progress = _ref.progress,
	      className = _ref.className;
	
	  var style = void 0;
	  var classes = {
	    indeterminate: progress === undefined,
	    determinate: !!progress
	  };
	  if (progress) {
	    style = {
	      width: progress + '%'
	    };
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('progress lighten-5', className) },
	    _react2.default.createElement('div', { className: (0, _classnames2.default)(classes, className), style: style })
	  );
	};
	
	ProgressBar.propTypes = {
	  className: _propTypes2.default.string,
	  /**
	   * A number between 0..100 that indicates the current progress,
	   * when provided, a determinate bar with the progress is displayed,
	   * otherwise a indeterminate bar is shown
	   */
	  progress: _propTypes2.default.number
	};
	
	exports.default = ProgressBar;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchForm = function SearchForm() {
	  return _react2.default.createElement(
	    'form',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'input-field' },
	      _react2.default.createElement('input', { id: 'search', type: 'search', required: true }),
	      _react2.default.createElement(
	        'label',
	        { htmlFor: 'search' },
	        _react2.default.createElement(
	          _Icon2.default,
	          null,
	          'search'
	        )
	      ),
	      _react2.default.createElement(
	        _Icon2.default,
	        null,
	        'close'
	      )
	    )
	  );
	};
	
	exports.default = SearchForm;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _idgen = __webpack_require__(84);
	
	var _idgen2 = _interopRequireDefault(_idgen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideNav = function (_Component) {
	  _inherits(SideNav, _Component);
	
	  function SideNav(props) {
	    _classCallCheck(this, SideNav);
	
	    var _this = _possibleConstructorReturn(this, (SideNav.__proto__ || Object.getPrototypeOf(SideNav)).call(this, props));
	
	    _this.id = props.id || 'sidenav_' + (0, _idgen2.default)();
	    return _this;
	  }
	
	  _createClass(SideNav, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$options = this.props.options,
	          options = _props$options === undefined ? {} : _props$options;
	
	      $(this._trigger).sideNav(options);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['children']);
	
	      delete props.id;
	      delete props.trigger;
	      delete props.options;
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.renderTrigger(),
	        _react2.default.createElement(
	          'ul',
	          _extends({ id: this.id, className: 'side-nav' }, props),
	          children
	        )
	      );
	    }
	  }, {
	    key: 'renderTrigger',
	    value: function renderTrigger() {
	      var _this2 = this;
	
	      var trigger = this.props.trigger;
	
	      return _react2.default.cloneElement(trigger, {
	        ref: function ref(t) {
	          return _this2._trigger = '[data-activates=' + _this2.id + ']';
	        },
	        'data-activates': this.id
	      });
	    }
	  }]);
	
	  return SideNav;
	}(_react.Component);
	
	SideNav.propTypes = {
	  /**
	   * sidenav id. If none is passed, an id will be generated.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Component that is rendered to trigger the sidenav
	   */
	  trigger: _propTypes2.default.node.isRequired,
	  /**
	   * Options hash for the sidenav.
	   * More info: http://materializecss.com/side-nav.html#options
	   */
	  options: _propTypes2.default.shape({
	    menuWidth: _propTypes2.default.number,
	    edge: _propTypes2.default.oneOf(['left', 'right']),
	    closeOnClick: _propTypes2.default.bool,
	    draggable: _propTypes2.default.bool
	  }),
	  children: _propTypes2.default.node
	};
	
	exports.default = SideNav;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UserView = __webpack_require__(1293);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SideNavItem = function (_Component) {
	  _inherits(SideNavItem, _Component);
	
	  function SideNavItem() {
	    _classCallCheck(this, SideNavItem);
	
	    return _possibleConstructorReturn(this, (SideNavItem.__proto__ || Object.getPrototypeOf(SideNavItem)).apply(this, arguments));
	  }
	
	  _createClass(SideNavItem, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          divider = _props.divider,
	          subheader = _props.subheader,
	          userView = _props.userView,
	          icon = _props.icon,
	          _props$href = _props.href,
	          href = _props$href === undefined ? '#!' : _props$href,
	          waves = _props.waves,
	          _props$user = _props.user,
	          user = _props$user === undefined ? {} : _props$user,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['divider', 'subheader', 'userView', 'icon', 'href', 'waves', 'user', 'children']);
	
	      var itemClasses = {
	        'divider': divider
	      };
	      var linkClasses = {
	        'subheader': subheader,
	        'waves-effect': waves
	      };
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ className: (0, _classnames2.default)(itemClasses) }, props),
	        userView && user && _react2.default.createElement(_UserView.UserView, user),
	        !userView && _react2.default.createElement(
	          'a',
	          { className: (0, _classnames2.default)(linkClasses), href: href },
	          icon && _react2.default.createElement(
	            'i',
	            { className: 'material-icons' },
	            icon
	          ),
	          children
	        )
	      );
	    }
	  }]);
	
	  return SideNavItem;
	}(_react.Component);
	
	SideNavItem.propTypes = {
	  children: _propTypes2.default.node,
	  divider: _propTypes2.default.bool,
	  subheader: _propTypes2.default.bool,
	  userView: _propTypes2.default.bool,
	  waves: _propTypes2.default.bool,
	  href: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  user: _propTypes2.default.shape(_UserView.UserShape)
	};
	
	exports.default = SideNavItem;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _constants = __webpack_require__(66);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slide = function (_Component) {
	  _inherits(Slide, _Component);
	
	  function Slide(props) {
	    _classCallCheck(this, Slide);
	
	    var _this = _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).call(this, props));
	
	    _this.renderCaption = _this.renderCaption.bind(_this);
	    return _this;
	  }
	
	  _createClass(Slide, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement('img', { src: this.props.src }),
	        this.renderCaption()
	      );
	    }
	  }, {
	    key: 'renderCaption',
	    value: function renderCaption() {
	      var _props = this.props,
	          title = _props.title,
	          className = _props.className,
	          alignment = _props.alignment,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['title', 'className', 'alignment', 'children']);
	
	      delete props.placement;
	
	      var classes = _defineProperty({
	        caption: true
	      }, alignment + '-align', alignment);
	
	      if (typeof title !== 'undefined' || typeof children !== 'undefined') {
	        return _react2.default.createElement(
	          'div',
	          _extends({ className: (0, _classnames2.default)(classes) }, props),
	          _react2.default.createElement(
	            'h3',
	            null,
	            title
	          ),
	          _react2.default.createElement(
	            'h5',
	            { className: className },
	            children
	          )
	        );
	      } else return null;
	    }
	  }]);
	
	  return Slide;
	}(_react.Component);
	
	Slide.propTypes = {
	  /**
	  * Aliment of the caption
	  * @default 'center'
	  */
	  alignment: _propTypes2.default.oneOf(_constants2.default.PLACEMENTS),
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  /**
	  * The tagline of the caption
	  */
	  title: _propTypes2.default.string,
	  /**
	   * The path of the background image
	   */
	  src: _propTypes2.default.string.isRequired
	};
	
	Slide.defaultProps = {
	  placement: 'center'
	};
	
	exports.default = Slide;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider() {
	    _classCallCheck(this, Slider);
	
	    return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
	  }
	
	  _createClass(Slider, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          fullscreen = _props.fullscreen,
	          indicators = _props.indicators,
	          interval = _props.interval,
	          transition = _props.transition;
	
	
	      $('.slider').slider({
	        full_width: fullscreen,
	        indicators: indicators,
	        interval: interval,
	        transition: transition
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          fullscreen = _props2.fullscreen,
	          children = _props2.children,
	          className = _props2.className;
	
	      var classes = {
	        fullscreen: fullscreen,
	        slider: true
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(classes, className) },
	        _react2.default.createElement(
	          'ul',
	          { className: 'slides' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  fullscreen: _propTypes2.default.bool,
	  /**
	  * Set to false to hide slide indicators
	  * @default true
	  */
	  indicators: _propTypes2.default.bool,
	  /**
	  * The interval between transitions in ms
	  * @default 6000
	  */
	  interval: _propTypes2.default.number,
	  /**
	  * The duration of the transation animation in ms
	  * @default 500
	  */
	  transition: _propTypes2.default.number
	};
	
	Slider.defaultProps = {
	  fullscreen: false,
	  indicators: true,
	  interval: 6000
	};
	
	exports.default = Slider;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(_ref) {
	  var color = _ref.color,
	      only = _ref.only;
	
	  var spinnerClasses = {
	    'spinner-layer': true
	  };
	  if (only) {
	    spinnerClasses['spinner-' + color + '-only'] = true;
	  } else {
	    spinnerClasses['spinner-' + color] = true;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)(spinnerClasses) },
	    _react2.default.createElement(
	      'div',
	      { className: 'circle-clipper left' },
	      _react2.default.createElement('div', { className: 'circle' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'gap-patch' },
	      _react2.default.createElement('div', { className: 'circle' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'circle-clipper right' },
	      _react2.default.createElement('div', { className: 'circle' })
	    )
	  );
	};
	
	Spinner.defaultProps = {
	  only: true
	};
	
	Spinner.propTypes = {
	  color: _propTypes2.default.string,
	  only: _propTypes2.default.bool
	};
	
	exports.default = Spinner;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// This is just a holder for the props and children for tab, thus
	// there is no logic here.
	var Tab = function (_React$Component) {
	  _inherits(Tab, _React$Component);
	
	  function Tab() {
	    _classCallCheck(this, Tab);
	
	    return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
	  }
	
	  _createClass(Tab, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = {
	  /**
	  * The title shown in the tabs list
	  */
	  title: _propTypes2.default.node.isRequired,
	  /**
	  * The width of the Tab
	  */
	  tabWidth: _propTypes2.default.number,
	  /**
	  * Pre-select the tab
	  * @default false
	  */
	  active: _propTypes2.default.bool,
	  /**
	  * Disable the tab
	  * @default false
	  */
	  disabled: _propTypes2.default.bool
	};
	
	Tab.defaultProps = {
	  active: false,
	  disabled: false
	};
	
	exports.default = Tab;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Table = function (_Component) {
	  _inherits(Table, _Component);
	
	  function Table() {
	    _classCallCheck(this, Table);
	
	    return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
	  }
	
	  _createClass(Table, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bordered = _props.bordered,
	          centered = _props.centered,
	          children = _props.children,
	          className = _props.className,
	          hoverable = _props.hoverable,
	          responsive = _props.responsive,
	          stripped = _props.stripped,
	          props = _objectWithoutProperties(_props, ['bordered', 'centered', 'children', 'className', 'hoverable', 'responsive', 'stripped']);
	
	      var classes = {
	        centered: centered,
	        highlight: hoverable,
	        'responsive-table': responsive,
	        stripped: stripped,
	        bordered: bordered
	      };
	
	      return _react2.default.createElement(
	        'table',
	        _extends({ className: (0, _classnames2.default)(classes, className) }, props),
	        children
	      );
	    }
	  }]);
	
	  return Table;
	}(_react.Component);
	
	Table.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  /**
	  * Center align all the text in the table
	  * @default false
	  */
	  centered: _propTypes2.default.bool,
	  /**
	  * Highlight the row that's hovered
	  * @default false
	  */
	  hoverable: _propTypes2.default.bool,
	  /**
	  * Enable response to make the table horizontally scrollable on smaller screens
	  * @default false
	  */
	  responsive: _propTypes2.default.bool,
	  /**
	  * Stripped style
	  * @default false
	  */
	  stripped: _propTypes2.default.bool,
	  /**
	  * Add border to each row
	  * @default false
	  */
	  bordered: _propTypes2.default.bool
	};
	
	exports.default = Table;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Row = __webpack_require__(117);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = function (_Component) {
	  _inherits(Tabs, _Component);
	
	  function Tabs() {
	    _classCallCheck(this, Tabs);
	
	    return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
	  }
	
	  _createClass(Tabs, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (typeof $ !== 'undefined') {
	        $(this._tabsEl).tabs();
	      }
	    }
	  }, {
	    key: '_onSelect',
	    value: function _onSelect(idx, e) {
	      var onChange = this.props.onChange;
	
	
	      if (onChange) onChange(idx, e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          defaultValue = _props.defaultValue;
	
	
	      return _react2.default.createElement(
	        _Row2.default,
	        null,
	        _react2.default.createElement(
	          _Col2.default,
	          { s: 12 },
	          _react2.default.createElement(
	            'ul',
	            { className: (0, _classnames2.default)('tabs', className), ref: function ref(el) {
	                return _this2._tabsEl = el;
	              } },
	            _react2.default.Children.map(children, function (child, idx) {
	              var _classes;
	
	              var _child$props = child.props,
	                  active = _child$props.active,
	                  className = _child$props.className,
	                  disabled = _child$props.disabled,
	                  tabWidth = _child$props.tabWidth,
	                  title = _child$props.title;
	
	
	              var classes = (_classes = {}, _defineProperty(_classes, 's' + tabWidth, tabWidth), _defineProperty(_classes, 'tab', true), _defineProperty(_classes, 'disabled', disabled), _defineProperty(_classes, 'col', true), _classes);
	
	              return _react2.default.createElement(
	                'li',
	                { className: (0, _classnames2.default)(classes, className), key: idx },
	                _react2.default.createElement(
	                  'a',
	                  _extends({ href: '#tab_' + idx, className: active || defaultValue === idx ? 'active' : ''
	                  }, disabled ? {} : { onClick: _this2._onSelect.bind(_this2, idx) }),
	                  title
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.Children.map(children, function (child, idx) {
	          return _react2.default.createElement(
	            _Col2.default,
	            { id: 'tab_' + idx, s: 12, key: 'tab' + idx,
	              style: { 'display': child.props.active || defaultValue === idx ? 'block' : 'none' } },
	            child.props.children
	          );
	        })
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_react.Component);
	
	Tabs.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.string,
	  onChange: _propTypes2.default.func
	};
	
	exports.default = Tabs;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Chip = __webpack_require__(995);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tag = function Tag(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _Chip2.default,
	    { close: true },
	    children
	  );
	};
	
	Tag.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = Tag;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(22);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(791);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toast = function (_Component) {
	  _inherits(Toast, _Component);
	
	  function Toast(props) {
	    _classCallCheck(this, Toast);
	
	    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));
	
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Toast, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          rounded = _props.rounded;
	
	      var classes = { toast: true, rounded: rounded };
	
	      return _react2.default.createElement(
	        _Button2.default,
	        { onClick: this.onClick, className: (0, _classnames2.default)(classes) },
	        children
	      );
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick() {
	      Materialize.toast(this.props.toast, 1000);
	    }
	  }]);
	
	  return Toast;
	}(_react.Component);
	
	Toast.propTypes = {
	  toast: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node,
	  rounded: _propTypes2.default.bool
	};
	
	exports.default = Toast;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserView = exports.UserShape = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(17);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserShape = exports.UserShape = {
	  background: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  email: _propTypes2.default.string
	};
	
	var UserView = exports.UserView = function (_Component) {
	  _inherits(UserView, _Component);
	
	  function UserView() {
	    _classCallCheck(this, UserView);
	
	    return _possibleConstructorReturn(this, (UserView.__proto__ || Object.getPrototypeOf(UserView)).apply(this, arguments));
	  }
	
	  _createClass(UserView, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          background = _props.background,
	          image = _props.image,
	          name = _props.name,
	          email = _props.email;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'userView' },
	        background && _react2.default.createElement(
	          'div',
	          { className: 'background' },
	          _react2.default.createElement('img', { src: background })
	        ),
	        image && _react2.default.createElement(
	          'a',
	          { href: '#!user' },
	          _react2.default.createElement('img', { className: 'circle', src: image })
	        ),
	        name && _react2.default.createElement(
	          'a',
	          { href: '#!name' },
	          _react2.default.createElement(
	            'span',
	            { className: 'white-text name' },
	            name
	          )
	        ),
	        email && _react2.default.createElement(
	          'a',
	          { href: '#!email' },
	          _react2.default.createElement(
	            'span',
	            { className: 'white-text email' },
	            email
	          )
	        )
	      );
	    }
	  }]);
	
	  return UserView;
	}(_react.Component);
	
	;
	
	UserView.propTypes = UserShape;
	
	exports.default = UserView;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Toast = exports.Tag = exports.Table = exports.Tabs = exports.Tab = exports.Slider = exports.Slide = exports.SideNavItem = exports.SideNav = exports.SearchForm = exports.Row = exports.ProgressBar = exports.Preloader = exports.PaginationButton = exports.Pagination = exports.Parallax = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.Navbar = exports.Modal = exports.MenuItem = exports.MediaBox = exports.Input = exports.Icon = exports.Footer = exports.Dropdown = exports.CollectionItem = exports.Collection = exports.CollapsibleItem = exports.Collapsible = exports.Col = exports.Chip = exports.CardTitle = exports.CardPanel = exports.Card = exports.Button = exports.Breadcrumb = exports.Badge = exports.Autocomplete = undefined;
	
	var _Autocomplete = __webpack_require__(1260);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _Badge = __webpack_require__(1261);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	var _Breadcrumb = __webpack_require__(1262);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _Button = __webpack_require__(791);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Card = __webpack_require__(1263);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _CardPanel = __webpack_require__(1264);
	
	var _CardPanel2 = _interopRequireDefault(_CardPanel);
	
	var _CardTitle = __webpack_require__(1265);
	
	var _CardTitle2 = _interopRequireDefault(_CardTitle);
	
	var _Chip = __webpack_require__(995);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Col = __webpack_require__(83);
	
	var _Col2 = _interopRequireDefault(_Col);
	
	var _Collapsible = __webpack_require__(1266);
	
	var _Collapsible2 = _interopRequireDefault(_Collapsible);
	
	var _CollapsibleItem = __webpack_require__(1267);
	
	var _CollapsibleItem2 = _interopRequireDefault(_CollapsibleItem);
	
	var _Collection = __webpack_require__(1268);
	
	var _Collection2 = _interopRequireDefault(_Collection);
	
	var _CollectionItem = __webpack_require__(1269);
	
	var _CollectionItem2 = _interopRequireDefault(_CollectionItem);
	
	var _Dropdown = __webpack_require__(1270);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _Parallax = __webpack_require__(1279);
	
	var _Parallax2 = _interopRequireDefault(_Parallax);
	
	var _Footer = __webpack_require__(1271);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Icon = __webpack_require__(53);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	var _Input = __webpack_require__(1272);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _MediaBox = __webpack_require__(1273);
	
	var _MediaBox2 = _interopRequireDefault(_MediaBox);
	
	var _MenuItem = __webpack_require__(1274);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Modal = __webpack_require__(1275);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Navbar = __webpack_require__(1277);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _NavItem = __webpack_require__(1276);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _Overlay = __webpack_require__(996);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _OverlayTrigger = __webpack_require__(997);
	
	var _OverlayTrigger2 = _interopRequireDefault(_OverlayTrigger);
	
	var _Pagination = __webpack_require__(1278);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _PaginationButton = __webpack_require__(998);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _Preloader = __webpack_require__(1280);
	
	var _Preloader2 = _interopRequireDefault(_Preloader);
	
	var _ProgressBar = __webpack_require__(1281);
	
	var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
	
	var _Row = __webpack_require__(117);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _SearchForm = __webpack_require__(1282);
	
	var _SearchForm2 = _interopRequireDefault(_SearchForm);
	
	var _SideNav = __webpack_require__(1283);
	
	var _SideNav2 = _interopRequireDefault(_SideNav);
	
	var _SideNavItem = __webpack_require__(1284);
	
	var _SideNavItem2 = _interopRequireDefault(_SideNavItem);
	
	var _Slide = __webpack_require__(1285);
	
	var _Slide2 = _interopRequireDefault(_Slide);
	
	var _Slider = __webpack_require__(1286);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Tab = __webpack_require__(1288);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _Tabs = __webpack_require__(1290);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Table = __webpack_require__(1289);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Tag = __webpack_require__(1291);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _Toast = __webpack_require__(1292);
	
	var _Toast2 = _interopRequireDefault(_Toast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Autocomplete = _Autocomplete2.default;
	exports.Badge = _Badge2.default;
	exports.Breadcrumb = _Breadcrumb2.default;
	exports.Button = _Button2.default;
	exports.Card = _Card2.default;
	exports.CardPanel = _CardPanel2.default;
	exports.CardTitle = _CardTitle2.default;
	exports.Chip = _Chip2.default;
	exports.Col = _Col2.default;
	exports.Collapsible = _Collapsible2.default;
	exports.CollapsibleItem = _CollapsibleItem2.default;
	exports.Collection = _Collection2.default;
	exports.CollectionItem = _CollectionItem2.default;
	exports.Dropdown = _Dropdown2.default;
	exports.Footer = _Footer2.default;
	exports.Icon = _Icon2.default;
	exports.Input = _Input2.default;
	exports.MediaBox = _MediaBox2.default;
	exports.MenuItem = _MenuItem2.default;
	exports.Modal = _Modal2.default;
	exports.Navbar = _Navbar2.default;
	exports.NavItem = _NavItem2.default;
	exports.Overlay = _Overlay2.default;
	exports.OverlayTrigger = _OverlayTrigger2.default;
	exports.Parallax = _Parallax2.default;
	exports.Pagination = _Pagination2.default;
	exports.PaginationButton = _PaginationButton2.default;
	exports.Preloader = _Preloader2.default;
	exports.ProgressBar = _ProgressBar2.default;
	exports.Row = _Row2.default;
	exports.SearchForm = _SearchForm2.default;
	exports.SideNav = _SideNav2.default;
	exports.SideNavItem = _SideNavItem2.default;
	exports.Slide = _Slide2.default;
	exports.Slider = _Slider2.default;
	exports.Tab = _Tab2.default;
	exports.Tabs = _Tabs2.default;
	exports.Table = _Table2.default;
	exports.Tag = _Tag2.default;
	exports.Toast = _Toast2.default;

/***/ },
/* 1295 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var focusNode = __webpack_require__(859);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(101);
	var ExecutionEnvironment = __webpack_require__(24);
	var FallbackCompositionState = __webpack_require__(1303);
	var SyntheticCompositionEvent = __webpack_require__(1340);
	var SyntheticInputEvent = __webpack_require__(1343);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1000);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactInstrumentation = __webpack_require__(43);
	
	var camelizeStyleName = __webpack_require__(1204);
	var dangerousStyleValue = __webpack_require__(1349);
	var hyphenateStyleName = __webpack_require__(1211);
	var memoizeStringOnly = __webpack_require__(1214);
	var warning = __webpack_require__(19);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(100);
	var EventPropagators = __webpack_require__(101);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(47);
	var SyntheticEvent = __webpack_require__(54);
	
	var inputValueTracking = __webpack_require__(1016);
	var getEventTarget = __webpack_require__(804);
	var isEventSupported = __webpack_require__(805);
	var isTextInputElement = __webpack_require__(1018);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var DOMLazyTree = __webpack_require__(85);
	var ExecutionEnvironment = __webpack_require__(24);
	
	var createNodesFromMarkup = __webpack_require__(1207);
	var emptyFunction = __webpack_require__(37);
	var invariant = __webpack_require__(7);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1301 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(101);
	var ReactDOMComponentTree = __webpack_require__(32);
	var SyntheticMouseEvent = __webpack_require__(119);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var PooledClass = __webpack_require__(67);
	
	var getTextContentAccessor = __webpack_require__(1015);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(86);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(87);
	
	var instantiateReactComponent = __webpack_require__(1017);
	var KeyEscapeUtils = __webpack_require__(796);
	var shouldUpdateReactComponent = __webpack_require__(806);
	var traverseAllChildren = __webpack_require__(1020);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1022);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(792);
	var ReactDOMIDOperations = __webpack_require__(1313);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var React = __webpack_require__(88);
	var ReactComponentEnvironment = __webpack_require__(798);
	var ReactCurrentOwner = __webpack_require__(55);
	var ReactErrorUtils = __webpack_require__(799);
	var ReactInstanceMap = __webpack_require__(102);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactNodeTypes = __webpack_require__(1010);
	var ReactReconciler = __webpack_require__(87);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(157);
	var invariant = __webpack_require__(7);
	var shallowEqual = __webpack_require__(158);
	var shouldUpdateReactComponent = __webpack_require__(806);
	var warning = __webpack_require__(19);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDefaultInjection = __webpack_require__(1321);
	var ReactMount = __webpack_require__(1009);
	var ReactReconciler = __webpack_require__(87);
	var ReactUpdates = __webpack_require__(47);
	var ReactVersion = __webpack_require__(1334);
	
	var findDOMNode = __webpack_require__(1350);
	var getHostComponentFromComposite = __webpack_require__(1014);
	var renderSubtreeIntoContainer = __webpack_require__(1357);
	var warning = __webpack_require__(19);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var AutoFocusUtils = __webpack_require__(1296);
	var CSSPropertyOperations = __webpack_require__(1298);
	var DOMLazyTree = __webpack_require__(85);
	var DOMNamespaces = __webpack_require__(793);
	var DOMProperty = __webpack_require__(86);
	var DOMPropertyOperations = __webpack_require__(1002);
	var EventPluginHub = __webpack_require__(100);
	var EventPluginRegistry = __webpack_require__(794);
	var ReactBrowserEventEmitter = __webpack_require__(118);
	var ReactDOMComponentFlags = __webpack_require__(1003);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMInput = __webpack_require__(1314);
	var ReactDOMOption = __webpack_require__(1315);
	var ReactDOMSelect = __webpack_require__(1004);
	var ReactDOMTextarea = __webpack_require__(1318);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactMultiChild = __webpack_require__(1327);
	var ReactServerRenderingTransaction = __webpack_require__(1332);
	
	var emptyFunction = __webpack_require__(37);
	var escapeTextContentForBrowser = __webpack_require__(121);
	var invariant = __webpack_require__(7);
	var isEventSupported = __webpack_require__(805);
	var shallowEqual = __webpack_require__(158);
	var inputValueTracking = __webpack_require__(1016);
	var validateDOMNesting = __webpack_require__(807);
	var warning = __webpack_require__(19);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(807);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var DOMLazyTree = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1312 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(792);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var DOMPropertyOperations = __webpack_require__(1002);
	var LinkedValueUtils = __webpack_require__(797);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(47);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var React = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMSelect = __webpack_require__(1004);
	
	var warning = __webpack_require__(19);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	var getNodeForCharacterOffset = __webpack_require__(1354);
	var getTextContentAccessor = __webpack_require__(1015);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var DOMChildrenOperations = __webpack_require__(792);
	var DOMLazyTree = __webpack_require__(85);
	var ReactDOMComponentTree = __webpack_require__(32);
	
	var escapeTextContentForBrowser = __webpack_require__(121);
	var invariant = __webpack_require__(7);
	var validateDOMNesting = __webpack_require__(807);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(25);
	
	var LinkedValueUtils = __webpack_require__(797);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(47);
	
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var ReactUpdates = __webpack_require__(47);
	var Transaction = __webpack_require__(120);
	
	var emptyFunction = __webpack_require__(37);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1295);
	var BeforeInputEventPlugin = __webpack_require__(1297);
	var ChangeEventPlugin = __webpack_require__(1299);
	var DefaultEventPluginOrder = __webpack_require__(1301);
	var EnterLeaveEventPlugin = __webpack_require__(1302);
	var HTMLDOMPropertyConfig = __webpack_require__(1304);
	var ReactComponentBrowserEnvironment = __webpack_require__(1306);
	var ReactDOMComponent = __webpack_require__(1309);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactDOMEmptyComponent = __webpack_require__(1311);
	var ReactDOMTreeTraversal = __webpack_require__(1319);
	var ReactDOMTextComponent = __webpack_require__(1317);
	var ReactDefaultBatchingStrategy = __webpack_require__(1320);
	var ReactEventListener = __webpack_require__(1324);
	var ReactInjection = __webpack_require__(1325);
	var ReactReconcileTransaction = __webpack_require__(1330);
	var SVGDOMPropertyConfig = __webpack_require__(1335);
	var SelectEventPlugin = __webpack_require__(1336);
	var SimpleEventPlugin = __webpack_require__(1337);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1322 */
1023,
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(100);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var EventListener = __webpack_require__(858);
	var ExecutionEnvironment = __webpack_require__(24);
	var PooledClass = __webpack_require__(67);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactUpdates = __webpack_require__(47);
	
	var getEventTarget = __webpack_require__(804);
	var getUnboundedScrollPosition = __webpack_require__(1209);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(86);
	var EventPluginHub = __webpack_require__(100);
	var EventPluginUtils = __webpack_require__(795);
	var ReactComponentEnvironment = __webpack_require__(798);
	var ReactEmptyComponent = __webpack_require__(1005);
	var ReactBrowserEventEmitter = __webpack_require__(118);
	var ReactHostComponent = __webpack_require__(1007);
	var ReactUpdates = __webpack_require__(47);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1348);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactComponentEnvironment = __webpack_require__(798);
	var ReactInstanceMap = __webpack_require__(102);
	var ReactInstrumentation = __webpack_require__(43);
	
	var ReactCurrentOwner = __webpack_require__(55);
	var ReactReconciler = __webpack_require__(87);
	var ReactChildReconciler = __webpack_require__(1305);
	
	var emptyFunction = __webpack_require__(37);
	var flattenChildren = __webpack_require__(1351);
	var invariant = __webpack_require__(7);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1329 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var CallbackQueue = __webpack_require__(1001);
	var PooledClass = __webpack_require__(67);
	var ReactBrowserEventEmitter = __webpack_require__(118);
	var ReactInputSelection = __webpack_require__(1008);
	var ReactInstrumentation = __webpack_require__(43);
	var Transaction = __webpack_require__(120);
	var ReactUpdateQueue = __webpack_require__(800);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1328);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var PooledClass = __webpack_require__(67);
	var Transaction = __webpack_require__(120);
	var ReactInstrumentation = __webpack_require__(43);
	var ReactServerUpdateQueue = __webpack_require__(1333);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(800);
	
	var warning = __webpack_require__(19);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1334 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1335 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(101);
	var ExecutionEnvironment = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInputSelection = __webpack_require__(1008);
	var SyntheticEvent = __webpack_require__(54);
	
	var getActiveElement = __webpack_require__(860);
	var isTextInputElement = __webpack_require__(1018);
	var shallowEqual = __webpack_require__(158);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var EventListener = __webpack_require__(858);
	var EventPropagators = __webpack_require__(101);
	var ReactDOMComponentTree = __webpack_require__(32);
	var SyntheticAnimationEvent = __webpack_require__(1338);
	var SyntheticClipboardEvent = __webpack_require__(1339);
	var SyntheticEvent = __webpack_require__(54);
	var SyntheticFocusEvent = __webpack_require__(1342);
	var SyntheticKeyboardEvent = __webpack_require__(1344);
	var SyntheticMouseEvent = __webpack_require__(119);
	var SyntheticDragEvent = __webpack_require__(1341);
	var SyntheticTouchEvent = __webpack_require__(1345);
	var SyntheticTransitionEvent = __webpack_require__(1346);
	var SyntheticUIEvent = __webpack_require__(103);
	var SyntheticWheelEvent = __webpack_require__(1347);
	
	var emptyFunction = __webpack_require__(37);
	var getEventCharCode = __webpack_require__(802);
	var invariant = __webpack_require__(7);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(119);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(103);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(103);
	
	var getEventCharCode = __webpack_require__(802);
	var getEventKey = __webpack_require__(1352);
	var getEventModifierState = __webpack_require__(803);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(103);
	
	var getEventModifierState = __webpack_require__(803);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(54);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(119);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1348 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1000);
	var warning = __webpack_require__(19);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(32);
	var ReactInstanceMap = __webpack_require__(102);
	
	var getHostComponentFromComposite = __webpack_require__(1014);
	var invariant = __webpack_require__(7);
	var warning = __webpack_require__(19);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(796);
	var traverseAllChildren = __webpack_require__(1020);
	var warning = __webpack_require__(19);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1022);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(802);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1353 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1354 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(24);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(121);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(1009);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1358 */
796,
/* 1359 */
[1517, 104],
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1359);
	var ReactElement = __webpack_require__(89);
	
	var emptyFunction = __webpack_require__(37);
	var traverseAllChildren = __webpack_require__(1369);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(89);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(89),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(991);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1363 */
1334,
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(1021),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(89),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(1024);
	var factory = __webpack_require__(854);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1365 */
1353,
/* 1366 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(104);
	
	var ReactElement = __webpack_require__(89);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(104);
	
	var ReactCurrentOwner = __webpack_require__(55);
	var REACT_ELEMENT_TYPE = __webpack_require__(1023);
	
	var getIteratorFn = __webpack_require__(1365);
	var invariant = __webpack_require__(7);
	var KeyEscapeUtils = __webpack_require__(1358);
	var warning = __webpack_require__(19);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMotion = __webpack_require__(1376);
	
	var _reactHammerjs = __webpack_require__(1256);
	
	var _reactHammerjs2 = _interopRequireDefault(_reactHammerjs);
	
	var _assign = __webpack_require__(1078);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _isFunction = __webpack_require__(1079);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _styles2 = __webpack_require__(1371);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bool = _propTypes2.default.bool,
	    number = _propTypes2.default.number,
	    array = _propTypes2.default.array,
	    object = _propTypes2.default.object,
	    string = _propTypes2.default.string,
	    func = _propTypes2.default.func,
	    oneOfType = _propTypes2.default.oneOfType;
	
	var Drawer = function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      currentState: "CLOSED"
	    }, _this.isState = function () {
	      var _this2;
	
	      return (_this2 = _this).__isState__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _this.isClosed = function () {
	      var _this3;
	
	      return (_this3 = _this).__isClosed__REACT_HOT_LOADER__.apply(_this3, arguments);
	    }, _this.isOpen = function () {
	      var _this4;
	
	      return (_this4 = _this).__isOpen__REACT_HOT_LOADER__.apply(_this4, arguments);
	    }, _this.isOpening = function () {
	      var _this5;
	
	      return (_this5 = _this).__isOpening__REACT_HOT_LOADER__.apply(_this5, arguments);
	    }, _this.isClosing = function () {
	      var _this6;
	
	      return (_this6 = _this).__isClosing__REACT_HOT_LOADER__.apply(_this6, arguments);
	    }, _this.onPress = function () {
	      var _this7;
	
	      return (_this7 = _this).__onPress__REACT_HOT_LOADER__.apply(_this7, arguments);
	    }, _this.onPressUp = function () {
	      var _this8;
	
	      return (_this8 = _this).__onPressUp__REACT_HOT_LOADER__.apply(_this8, arguments);
	    }, _this.onPan = function () {
	      var _this9;
	
	      return (_this9 = _this).__onPan__REACT_HOT_LOADER__.apply(_this9, arguments);
	    }, _this.onOverlayTap = function () {
	      var _this10;
	
	      return (_this10 = _this).__onOverlayTap__REACT_HOT_LOADER__.apply(_this10, arguments);
	    }, _this.calculateWidth = function () {
	      var _this11;
	
	      return (_this11 = _this).__calculateWidth__REACT_HOT_LOADER__.apply(_this11, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Drawer, [{
	    key: "__calculateWidth__REACT_HOT_LOADER__",
	    value: function __calculateWidth__REACT_HOT_LOADER__() {
	      return this.__calculateWidth__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__onOverlayTap__REACT_HOT_LOADER__",
	    value: function __onOverlayTap__REACT_HOT_LOADER__() {
	      return this.__onOverlayTap__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__onPan__REACT_HOT_LOADER__",
	    value: function __onPan__REACT_HOT_LOADER__() {
	      return this.__onPan__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__onPressUp__REACT_HOT_LOADER__",
	    value: function __onPressUp__REACT_HOT_LOADER__() {
	      return this.__onPressUp__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__onPress__REACT_HOT_LOADER__",
	    value: function __onPress__REACT_HOT_LOADER__() {
	      return this.__onPress__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__isClosing__REACT_HOT_LOADER__",
	    value: function __isClosing__REACT_HOT_LOADER__() {
	      return this.__isClosing__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__isOpening__REACT_HOT_LOADER__",
	    value: function __isOpening__REACT_HOT_LOADER__() {
	      return this.__isOpening__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__isOpen__REACT_HOT_LOADER__",
	    value: function __isOpen__REACT_HOT_LOADER__() {
	      return this.__isOpen__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__isClosed__REACT_HOT_LOADER__",
	    value: function __isClosed__REACT_HOT_LOADER__() {
	      return this.__isClosed__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "__isState__REACT_HOT_LOADER__",
	    value: function __isState__REACT_HOT_LOADER__() {
	      return this.__isState__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var open = this.props.open;
	      var nextOpen = nextProps.open;
	
	
	      if (nextOpen !== open) {
	        if (nextOpen) this.open();else this.close();
	      }
	    }
	  }, {
	    key: "__isState__REACT_HOT_LOADER__",
	    value: function __isState__REACT_HOT_LOADER__(s) {
	      return s === this.state.currentState;
	    }
	  }, {
	    key: "__isClosed__REACT_HOT_LOADER__",
	    value: function __isClosed__REACT_HOT_LOADER__() {
	      return this.isState("CLOSED");
	    }
	  }, {
	    key: "__isOpen__REACT_HOT_LOADER__",
	    value: function __isOpen__REACT_HOT_LOADER__() {
	      return this.isState("OPEN");
	    }
	  }, {
	    key: "__isOpening__REACT_HOT_LOADER__",
	    value: function __isOpening__REACT_HOT_LOADER__() {
	      return this.isState("IS_OPENING");
	    }
	  }, {
	    key: "__isClosing__REACT_HOT_LOADER__",
	    value: function __isClosing__REACT_HOT_LOADER__() {
	      return this.isState("IS_CLOSING");
	    }
	  }, {
	    key: "peak",
	    value: function peak() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          handleWidth = _props.handleWidth;
	
	      onChange(false);
	      return this.setState({ currentState: "PEAK", x: handleWidth });
	    }
	  }, {
	    key: "close",
	    value: function close() {
	      this.props.onChange(false);
	      return this.setState({ currentState: "CLOSED", x: 0 });
	    }
	  }, {
	    key: "open",
	    value: function open() {
	      var _props2 = this.props,
	          onChange = _props2.onChange,
	          width = _props2.width;
	
	      onChange(true);
	
	      return this.setState({ currentState: "OPEN", x: this.calculateWidth() });
	    }
	  }, {
	    key: "isClosingDirection",
	    value: function isClosingDirection(direction) {
	      var right = this.props.right;
	
	      var isClosing = direction === 2;
	
	      if (right) return !isClosing;else return isClosing;
	    }
	  }, {
	    key: "closingOrOpening",
	    value: function closingOrOpening(direction) {
	      return this.isClosingDirection(direction) ? "IS_CLOSING" : "IS_OPENING";
	    }
	  }, {
	    key: "inPanTolerance",
	    value: function inPanTolerance(deltaX) {
	      var currentState = this.state.currentState;
	      var panTolerance = this.props.panTolerance;
	
	
	      return Math.abs(deltaX) <= panTolerance && currentState === "OPEN";
	    }
	  }, {
	    key: "__onPress__REACT_HOT_LOADER__",
	    value: function __onPress__REACT_HOT_LOADER__(e) {
	      if (this.props.noTouchOpen) return;
	      e.preventDefault();
	      this.peak();
	    }
	  }, {
	    key: "__onPressUp__REACT_HOT_LOADER__",
	    value: function __onPressUp__REACT_HOT_LOADER__(e) {
	      e.preventDefault();
	      this.close();
	    }
	  }, {
	    key: "__onPan__REACT_HOT_LOADER__",
	    value: function __onPan__REACT_HOT_LOADER__(e) {
	      if (this.isClosed() && this.props.noTouchOpen) return;
	      if (this.isOpen() && this.props.noTouchClose) return;
	      e.preventDefault();
	
	      var isFinal = e.isFinal,
	          pointers = e.pointers,
	          direction = e.direction,
	          deltaX = e.deltaX;
	
	      if (this.inPanTolerance(deltaX)) return;
	
	      if (isFinal) {
	        if (this.isOpening()) this.open();else if (this.isClosing()) this.close();
	        return;
	      }
	
	      var currentState = this.state.currentState;
	      var _props3 = this.props,
	          right = _props3.right,
	          peakingWidth = _props3.peakingWidth,
	          handleWidth = _props3.handleWidth;
	
	      var _calculateWidth = this.calculateWidth(),
	          width = _calculateWidth.width;
	
	      var clientX = pointers[0].clientX;
	
	
	      var x = right ? document.body.clientWidth - clientX : clientX;
	
	      if (x + peakingWidth >= width) x = width - peakingWidth;
	
	      var closingOrOpening = this.closingOrOpening(direction);
	      var nextState = {
	        PEAK: closingOrOpening,
	        IS_OPENING: closingOrOpening,
	        IS_CLOSING: closingOrOpening,
	        OPEN: "IS_CLOSING",
	        CLOSED: "PEAK"
	      };
	
	      this.setState({
	        currentState: nextState[currentState],
	        x: this.isClosed() ? peakingWidth : peakingWidth / 2 + x
	      });
	    }
	  }, {
	    key: "__onOverlayTap__REACT_HOT_LOADER__",
	    value: function __onOverlayTap__REACT_HOT_LOADER__(e) {
	      e.preventDefault();
	      if (this.isOpen()) this.close();
	    }
	  }, {
	    key: "__calculateWidth__REACT_HOT_LOADER__",
	    value: function __calculateWidth__REACT_HOT_LOADER__() {
	      var width = this.props.width;
	      return (/\D/.test(width) ? document.body.clientWidth * (width.match(/\d*/) / 100) : width
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this12 = this;
	
	      var _props4 = this.props,
	          config = _props4.config,
	          drawerStyle = _props4.drawerStyle,
	          className = _props4.className,
	          overlayClassName = _props4.overlayClassName,
	          width = _props4.width,
	          children = _props4.children,
	          offset = _props4.offset;
	      var _state = this.state,
	          currentState = _state.currentState,
	          x = _state.x;
	
	
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        { style: { myProp: (0, _reactMotion.spring)(Math.min(x + offset || 0, this.calculateWidth()), config) } },
	        function (interpolated) {
	          var _styles = (0, _styles3.default)(interpolated.myProp, _this12.props),
	              drawer = _styles.drawer,
	              transform = _styles.transform,
	              overlay = _styles.overlay;
	
	          var computedStyle = (0, _assign2.default)(drawer, drawerStyle);
	          if (interpolated.myProp > 0) computedStyle.display = "block";else computedStyle.display = "none";
	
	          return _react2.default.createElement(
	            "div",
	            { style: transform },
	            _react2.default.createElement(
	              _reactHammerjs2.default,
	              {
	                onPress: _this12.onPress,
	                onPressUp: _this12.onPressUp,
	                onPan: _this12.onPan,
	                direction: _reactHammerjs2.default.DIRECTION_HORIZONTAL
	              },
	              _react2.default.createElement(
	                "div",
	                { className: className, style: computedStyle },
	                (0, _isFunction2.default)(children) ? children(interpolated.myProp) : children,
	                !_this12.isClosed() && _react2.default.createElement(
	                  _reactHammerjs2.default,
	                  {
	                    style: overlay,
	                    className: overlayClassName,
	                    onTap: _this12.onOverlayTap
	                  },
	                  _react2.default.createElement("span", null)
	                )
	              )
	            )
	          );
	        }
	      );
	    }
	  }]);
	
	  return Drawer;
	}(_react2.default.Component);
	
	Drawer.propTypes = {
	  zIndex: number, // z-index of the drawer default is 10000
	  noTouchOpen: bool, // can a user pan to open
	  noTouchClose: bool, // can a user pan to close
	  onChange: func, // called when the drawer is open
	  drawerStyle: object, // additional drawer styles
	  className: string, // additional drawer className
	  overlayClassName: string, // additional overlay className
	  config: array, // configuration of the react-motion animation
	  open: bool, // states if the drawer is open
	  width: oneOfType([number, string]), // width of the drawer
	  height: oneOfType([number, string]), // height of the drawer
	  handleWidth: number, // width of the handle
	  peakingWidth: number, // width that the drawer peaks on press
	  panTolerance: number, // tolerance until the drawer starts to move
	  right: bool, // drawer on the right side of the screen
	  overlayColor: string, // color of the overlay
	  fadeOut: bool, // fade out
	  offset: number // offset
	};
	Drawer.defaultProps = {
	  zIndex: 10000,
	  noTouchOpen: false,
	  noTouchClose: false,
	  onChange: function onChange() {},
	  overlayColor: "rgba(0, 0, 0, 0.4)",
	  config: [350, 40],
	  open: false,
	  width: 300,
	  height: "100%",
	  handleWidth: 20,
	  peakingWidth: 50,
	  panTolerance: 50,
	  right: false,
	  fadeOut: false,
	  offset: 0
	};
	var _default = Drawer;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(bool, "bool", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(number, "number", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(array, "array", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(object, "object", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(string, "string", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(func, "func", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(oneOfType, "oneOfType", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(Drawer, "Drawer", "lib/drawer.jsx");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "lib/drawer.jsx");
	}();
	
	;

/***/ },
/* 1371 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _default = function _default(val, props) {
	  var _transform, _overlay;
	
	  var zIndex = props.zIndex,
	      left = props.left,
	      right = props.right,
	      height = props.height,
	      handleWidth = props.handleWidth,
	      overlayColor = props.overlayColor,
	      fadeOut = props.fadeOut,
	      offset = props.offset;
	
	
	  var clientWidth = 1000;
	  var width = props.width;
	
	  if (typeof document !== "undefined") {
	    clientWidth = document.body.clientWidth;
	    if (/\D/.test(width)) width = document.body.clientWidth * (width.match(/\d*/) / 100);
	  }
	
	  var opacity = (val - offset) / width;
	
	  if (right) val = width - val;else val = val - width;
	
	  var drawer = {
	    display: "block",
	    width: width,
	    height: height,
	    overflow: "auto"
	  };
	
	  var transform = (_transform = {
	    boxSizing: "content-box",
	    pointer: "cursor",
	    position: "fixed",
	    display: "block",
	    zIndex: zIndex,
	    width: width
	  }, _defineProperty(_transform, right ? "paddingLeft" : "paddingRight", handleWidth), _defineProperty(_transform, "maxWidth", width), _defineProperty(_transform, "height", height), _defineProperty(_transform, "top", 0), _defineProperty(_transform, right ? "right" : "left", 0), _defineProperty(_transform, "margin", 0), _defineProperty(_transform, "transform", "translate3d(" + val + "px, 0, 0)"), _defineProperty(_transform, "WebkitTransform", "translate3d(" + val + "px, 0, 0)"), _defineProperty(_transform, "opacity", fadeOut ? opacity : 1), _transform);
	
	  var overlayTransform = right ? -width : width;
	  var overlay = (_overlay = {
	    zIndex: -2,
	    pointer: "cursor",
	    position: "fixed",
	    width: clientWidth,
	    height: "100%",
	    background: overlayColor,
	    opacity: opacity,
	    top: 0
	  }, _defineProperty(_overlay, right ? "right" : "left", 0), _defineProperty(_overlay, "margin", 0), _defineProperty(_overlay, "transform", "translate3d(" + overlayTransform + "px, 0, 0)"), _defineProperty(_overlay, "WebkitTransform", "translate3d(" + overlayTransform + "px, 0, 0)"), _overlay);
	
	  return { drawer: drawer, transform: transform, overlay: overlay };
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(_default, "default", "lib/styles.js");
	}();
	
	;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(808);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(123);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(810);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(161);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(162);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(809);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(808);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(123);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(810);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(161);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(162);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(809);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(808);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(123);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(810);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1375);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(161);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(162);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(809);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ },
/* 1375 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1372);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1373);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1374);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1378);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(1026);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(123);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1377);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(1026);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @providesModule react-native-device-info
	 */
	
	var RNDeviceInfo = __webpack_require__(4).NativeModules.RNDeviceInfo;
	
	module.exports = {
	  getUniqueID: function () {
	    return RNDeviceInfo.uniqueId;
	  },
	  getInstanceID: function() {
	    return RNDeviceInfo.instanceId;
	  },
	  getDeviceId: function () {
	    return RNDeviceInfo.deviceId;
	  },
	  getManufacturer: function () {
	    return RNDeviceInfo.systemManufacturer;
	  },
	  getModel: function () {
	    return RNDeviceInfo.model;
	  },
	  getBrand: function () {
	    return RNDeviceInfo.brand;
	  },
	  getSystemName: function () {
	    return RNDeviceInfo.systemName;
	  },
	  getSystemVersion: function () {
	    return RNDeviceInfo.systemVersion;
	  },
	  getBundleId: function() {
	    return RNDeviceInfo.bundleId;
	  },
	  getBuildNumber: function() {
	    return RNDeviceInfo.buildNumber;
	  },
	  getVersion: function() {
	    return RNDeviceInfo.appVersion;
	  },
	  getReadableVersion: function() {
	    return RNDeviceInfo.appVersion + "." + RNDeviceInfo.buildNumber;
	  },
	  getDeviceName: function() {
	    return RNDeviceInfo.deviceName;
	  },
	  getUserAgent: function() {
	    return RNDeviceInfo.userAgent;
	  },
	  getDeviceLocale: function() {
	    return RNDeviceInfo.deviceLocale;
	  },
	  getDeviceCountry: function() {
	    return RNDeviceInfo.deviceCountry;
	  },
	  getTimezone: function() {
	    return RNDeviceInfo.timezone;
	  },
	  isEmulator: function() {
	    return RNDeviceInfo.isEmulator;
	  },
	  isTablet: function() {
	    return RNDeviceInfo.isTablet;
	  },
	  isPinOrFingerprintSet: function () {
	    return RNDeviceInfo.isPinOrFingerprintSet;
	  },
	};


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactArt = __webpack_require__(1251);
	
	var _reactArt2 = _interopRequireDefault(_reactArt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _reactArt2.default;
	module.exports = exports['default'];

/***/ },
/* 1381 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function emptyFunction() {}
	
	var AccessibilityInfo = {
	  /**
	   * Query whether a screen reader is currently enabled.
	   *
	   * Returns a promise which resolves to a boolean.
	   * The result is `true` when a screen reader is enabled and `false` otherwise.
	   */
	  fetch: function fetch() {
	    return new Promise(function (resolve, reject) {
	      resolve(true);
	    });
	  },
	
	  /**
	   * Add an event handler. Supported events:
	   */
	  addEventListener: function addEventListener(eventName, handler) {
	    return {
	      remove: emptyFunction
	    };
	  },
	
	  /**
	   * Set accessibility focus to a react component.
	   */
	  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
	
	  /**
	   * Post a string to be announced by the screen reader.
	   */
	  announceForAccessibility: function announceForAccessibility(announcement) {},
	
	  /**
	   * Remove an event handler.
	   */
	  removeEventListener: function removeEventListener(eventName, handler) {
	    return;
	  }
	};
	
	exports.default = AccessibilityInfo;
	module.exports = exports["default"];

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var createSvgCircle = function createSvgCircle(style) {
	  return _react2.default.createElement('circle', { cx: '16', cy: '16', fill: 'none', r: '14', strokeWidth: '4', style: style });
	};
	
	var ActivityIndicator = function (_Component) {
	  _inherits(ActivityIndicator, _Component);
	
	  function ActivityIndicator() {
	    _classCallCheck(this, ActivityIndicator);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ActivityIndicator.prototype.render = function render() {
	    var _props = this.props,
	        animating = _props.animating,
	        color = _props.color,
	        hidesWhenStopped = _props.hidesWhenStopped,
	        size = _props.size,
	        style = _props.style,
	        other = _objectWithoutProperties(_props, ['animating', 'color', 'hidesWhenStopped', 'size', 'style']);
	
	    var svg = _react2.default.createElement(
	      'svg',
	      { height: '100%', viewBox: '0 0 32 32', width: '100%' },
	      createSvgCircle({
	        stroke: color,
	        opacity: 0.2
	      }),
	      createSvgCircle({
	        stroke: color,
	        strokeDasharray: 80,
	        strokeDashoffset: 60
	      })
	    );
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, {
	        accessibilityRole: 'progressbar',
	        'aria-valuemax': '1',
	        'aria-valuemin': '0',
	        style: [styles.container, style]
	      }),
	      _react2.default.createElement(_View2.default, {
	        children: svg,
	        style: [typeof size === 'number' ? { height: size, width: size } : indicatorSizes[size], styles.animation, !animating && styles.animationPause, !animating && hidesWhenStopped && styles.hidesWhenStopped]
	      })
	    );
	  };
	
	  return ActivityIndicator;
	}(_react.Component);
	
	ActivityIndicator.displayName = 'ActivityIndicator';
	ActivityIndicator.defaultProps = {
	  animating: true,
	  color: '#1976D2',
	  hidesWhenStopped: true,
	  size: 'small'
	};
	ActivityIndicator.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  animating: _propTypes.bool,
	  color: _propTypes.string,
	  hidesWhenStopped: _propTypes.bool,
	  size: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(['small', 'large']), _propTypes.number])
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  container: {
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  hidesWhenStopped: {
	    visibility: 'hidden'
	  },
	  animation: {
	    animationDuration: '0.75s',
	    animationName: [{
	      '0%': { transform: [{ rotate: '0deg' }] },
	      '100%': { transform: [{ rotate: '360deg' }] }
	    }],
	    animationTimingFunction: 'linear',
	    animationIterationCount: 'infinite'
	  },
	  animationPause: {
	    animationPlayState: 'paused'
	  }
	});
	
	var indicatorSizes = _StyleSheet2.default.create({
	  small: {
	    width: 20,
	    height: 20
	  },
	  large: {
	    width: 36,
	    height: 36
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(ActivityIndicator);
	module.exports = exports['default'];

/***/ },
/* 1383 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var Alert = function () {
	  function Alert() {
	    _classCallCheck(this, Alert);
	  }
	
	  Alert.alert = function alert() {};
	
	  return Alert;
	}();
	
	exports.default = Alert;
	module.exports = exports["default"];

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AppContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { mainKey: 1 }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AppContainer.prototype.getChildContext = function getChildContext() {
	    return {
	      rootTag: this.props.rootTag
	    };
	  };
	
	  AppContainer.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        WrapperComponent = _props.WrapperComponent;
	
	    var innerView = _react2.default.createElement(_View2.default, {
	      children: children,
	      key: this.state.mainKey,
	      pointerEvents: 'box-none',
	      style: styles.appContainer
	    });
	
	    if (WrapperComponent) {
	      innerView = _react2.default.createElement(
	        WrapperComponent,
	        null,
	        innerView
	      );
	    }
	
	    return _react2.default.createElement(
	      _View2.default,
	      { pointerEvents: 'box-none', style: styles.appContainer },
	      innerView
	    );
	  };
	
	  return AppContainer;
	}(_react.Component);
	
	AppContainer.childContextTypes = {
	  rootTag: _propTypes.any
	};
	exports.default = AppContainer;
	AppContainer.propTypes =  false ? {
	  WrapperComponent: _propTypes.any,
	  children: _propTypes.node,
	  rootTag: _propTypes.any.isRequired
	} : {};
	
	
	var styles = _StyleSheet2.default.create({
	  appContainer: {
	    flex: 1
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _unmountComponentAtNode = __webpack_require__(1043);
	
	var _unmountComponentAtNode2 = _interopRequireDefault(_unmountComponentAtNode);
	
	var _renderApplication = __webpack_require__(1386);
	
	var _renderApplication2 = _interopRequireDefault(_renderApplication);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	var emptyObject = {};
	var runnables = {};
	
	var componentProviderInstrumentationHook = function componentProviderInstrumentationHook(component) {
	  return component();
	};
	var wrapperComponentProvider = void 0;
	
	/**
	 * `AppRegistry` is the JS entry point to running all React Native apps.
	 */
	var AppRegistry = function () {
	  function AppRegistry() {
	    _classCallCheck(this, AppRegistry);
	  }
	
	  AppRegistry.getAppKeys = function getAppKeys() {
	    return Object.keys(runnables);
	  };
	
	  AppRegistry.getApplication = function getApplication(appKey, appParameters) {
	    (0, _invariant2.default)(runnables[appKey] && runnables[appKey].getApplication, 'Application ' + appKey + ' has not been registered. ' + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
	
	    return runnables[appKey].getApplication(appParameters);
	  };
	
	  AppRegistry.registerComponent = function registerComponent(appKey, componentProvider) {
	    runnables[appKey] = {
	      getApplication: function getApplication(appParameters) {
	        return (0, _renderApplication.getApplication)(componentProviderInstrumentationHook(componentProvider), appParameters ? appParameters.initialProps : emptyObject, wrapperComponentProvider && wrapperComponentProvider(appParameters));
	      },
	      run: function run(appParameters) {
	        return (0, _renderApplication2.default)(componentProviderInstrumentationHook(componentProvider), appParameters.initialProps || emptyObject, appParameters.rootTag, wrapperComponentProvider && wrapperComponentProvider(appParameters), appParameters.callback);
	      }
	    };
	    return appKey;
	  };
	
	  AppRegistry.registerConfig = function registerConfig(config) {
	    config.forEach(function (_ref) {
	      var appKey = _ref.appKey,
	          component = _ref.component,
	          run = _ref.run;
	
	      if (run) {
	        AppRegistry.registerRunnable(appKey, run);
	      } else {
	        (0, _invariant2.default)(component, 'No component provider passed in');
	        AppRegistry.registerComponent(appKey, component);
	      }
	    });
	  };
	
	  // TODO: fix style sheet creation when using this method
	
	
	  AppRegistry.registerRunnable = function registerRunnable(appKey, run) {
	    runnables[appKey] = { run: run };
	    return appKey;
	  };
	
	  AppRegistry.runApplication = function runApplication(appKey, appParameters) {
	    var isDevelopment = ("production") !== 'production';
	    if (isDevelopment) {
	      var params = Object.assign({}, appParameters);
	      params.rootTag = '#' + params.rootTag.id;
	
	      console.log('Running application "' + appKey + '" with appParams: ' + JSON.stringify(params) + '.\n' + ('Development-level warnings: ' + (isDevelopment ? 'ON' : 'OFF') + '.\n') + ('Performance optimizations: ' + (isDevelopment ? 'OFF' : 'ON') + '.'));
	    }
	
	    (0, _invariant2.default)(runnables[appKey] && runnables[appKey].run, 'Application "' + appKey + '" has not been registered. ' + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
	
	    runnables[appKey].run(appParameters);
	  };
	
	  AppRegistry.setComponentProviderInstrumentationHook = function setComponentProviderInstrumentationHook(hook) {
	    componentProviderInstrumentationHook = hook;
	  };
	
	  AppRegistry.setWrapperComponentProvider = function setWrapperComponentProvider(provider) {
	    wrapperComponentProvider = provider;
	  };
	
	  AppRegistry.unmountApplicationComponentAtRootTag = function unmountApplicationComponentAtRootTag(rootTag) {
	    (0, _unmountComponentAtNode2.default)(rootTag);
	  };
	
	  return AppRegistry;
	}();
	
	exports.default = AppRegistry;
	module.exports = exports['default'];

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                   * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * 
	                                                                                                                                                                                                                                                                   */
	
	exports.default = renderApplication;
	exports.getApplication = getApplication;
	
	var _AppContainer = __webpack_require__(1384);
	
	var _AppContainer2 = _interopRequireDefault(_AppContainer);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _hydrate = __webpack_require__(1449);
	
	var _hydrate2 = _interopRequireDefault(_hydrate);
	
	var _render = __webpack_require__(1042);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _styleResolver = __webpack_require__(815);
	
	var _styleResolver2 = _interopRequireDefault(_styleResolver);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderFn =  false ? _render2.default : _hydrate2.default;
	
	function renderApplication(RootComponent, initialProps, rootTag, WrapperComponent, callback) {
	  (0, _invariant2.default)(rootTag, 'Expect to have a valid rootTag, instead got ', rootTag);
	
	  renderFn(_react2.default.createElement(
	    _AppContainer2.default,
	    { WrapperComponent: WrapperComponent, rootTag: rootTag },
	    _react2.default.createElement(RootComponent, initialProps)
	  ), rootTag, callback);
	}
	
	function getApplication(RootComponent, initialProps, WrapperComponent) {
	  var element = _react2.default.createElement(
	    _AppContainer2.default,
	    { WrapperComponent: WrapperComponent, rootTag: {} },
	    _react2.default.createElement(RootComponent, initialProps)
	  );
	  // Don't escape CSS text
	  var getStyleElement = function getStyleElement(props) {
	    var sheet = _styleResolver2.default.getStyleSheet();
	    return _react2.default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: sheet.textContent }, id: sheet.id }));
	  };
	  return { element: element, getStyleElement: getStyleElement };
	}

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @noflow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _arrayFindIndex = __webpack_require__(834);
	
	var _arrayFindIndex2 = _interopRequireDefault(_arrayFindIndex);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Android 4.4 browser
	var isPrefixed = _ExecutionEnvironment.canUseDOM && !document.hasOwnProperty('hidden') && document.hasOwnProperty('webkitHidden');
	
	var EVENT_TYPES = ['change', 'memoryWarning'];
	var VISIBILITY_CHANGE_EVENT = isPrefixed ? 'webkitvisibilitychange' : 'visibilitychange';
	var VISIBILITY_STATE_PROPERTY = isPrefixed ? 'webkitVisibilityState' : 'visibilityState';
	
	var AppStates = {
	  BACKGROUND: 'background',
	  ACTIVE: 'active'
	};
	
	var listeners = [];
	
	var AppState = function () {
	  function AppState() {
	    _classCallCheck(this, AppState);
	  }
	
	  AppState.addEventListener = function addEventListener(type, handler) {
	    if (AppState.isAvailable) {
	      (0, _invariant2.default)(EVENT_TYPES.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
	      if (type === 'change') {
	        var callback = function callback() {
	          return handler(AppState.currentState);
	        };
	        listeners.push([handler, callback]);
	        document.addEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
	      }
	    }
	  };
	
	  AppState.removeEventListener = function removeEventListener(type, handler) {
	    if (AppState.isAvailable) {
	      (0, _invariant2.default)(EVENT_TYPES.indexOf(type) !== -1, 'Trying to remove listener for unknown event: "%s"', type);
	      if (type === 'change') {
	        var listenerIndex = (0, _arrayFindIndex2.default)(listeners, function (pair) {
	          return pair[0] === handler;
	        });
	        (0, _invariant2.default)(listenerIndex !== -1, 'Trying to remove AppState listener for unregistered handler');
	        var callback = listeners[listenerIndex][1];
	        document.removeEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
	        listeners.splice(listenerIndex, 1);
	      }
	    }
	  };
	
	  _createClass(AppState, null, [{
	    key: 'currentState',
	    get: function get() {
	      if (!AppState.isAvailable) {
	        return AppStates.ACTIVE;
	      }
	
	      switch (document[VISIBILITY_STATE_PROPERTY]) {
	        case 'hidden':
	        case 'prerender':
	        case 'unloaded':
	          return AppStates.BACKGROUND;
	        default:
	          return AppStates.ACTIVE;
	      }
	    }
	  }]);
	
	  return AppState;
	}();
	
	AppState.isAvailable = _ExecutionEnvironment.canUseDOM && document[VISIBILITY_STATE_PROPERTY];
	exports.default = AppState;
	module.exports = exports['default'];

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _deepAssign = __webpack_require__(1200);
	
	var _deepAssign2 = _interopRequireDefault(_deepAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	var mergeLocalStorageItem = function mergeLocalStorageItem(key, value) {
	  var oldValue = window.localStorage.getItem(key);
	  var oldObject = JSON.parse(oldValue);
	  var newObject = JSON.parse(value);
	  var nextValue = JSON.stringify((0, _deepAssign2.default)({}, oldObject, newObject));
	  window.localStorage.setItem(key, nextValue);
	};
	
	var createPromise = function createPromise(getValue, callback) {
	  return new Promise(function (resolve, reject) {
	    try {
	      var value = getValue();
	      if (callback) {
	        callback(null, value);
	      }
	      resolve(value);
	    } catch (err) {
	      if (callback) {
	        callback(err);
	      }
	      reject(err);
	    }
	  });
	};
	
	var createPromiseAll = function createPromiseAll(promises, callback, processResult) {
	  return Promise.all(promises).then(function (result) {
	    var value = processResult ? processResult(result) : null;
	    callback && callback(null, value);
	    return Promise.resolve(value);
	  }, function (errors) {
	    callback && callback(errors);
	    return Promise.reject(errors);
	  });
	};
	
	var AsyncStorage = function () {
	  function AsyncStorage() {
	    _classCallCheck(this, AsyncStorage);
	  }
	
	  /**
	   * Erases *all* AsyncStorage for the domain.
	   */
	  AsyncStorage.clear = function clear(callback) {
	    return createPromise(function () {
	      window.localStorage.clear();
	    }, callback);
	  };
	
	  /**
	   * (stub) Flushes any pending requests using a single batch call to get the data.
	   */
	
	
	  AsyncStorage.flushGetRequests = function flushGetRequests() {};
	
	  /**
	   * Gets *all* keys known to the app, for all callers, libraries, etc.
	   */
	
	
	  AsyncStorage.getAllKeys = function getAllKeys(callback) {
	    return createPromise(function () {
	      var numberOfKeys = window.localStorage.length;
	      var keys = [];
	      for (var i = 0; i < numberOfKeys; i += 1) {
	        var key = window.localStorage.key(i);
	        keys.push(key);
	      }
	      return keys;
	    }, callback);
	  };
	
	  /**
	   * Fetches `key` value.
	   */
	
	
	  AsyncStorage.getItem = function getItem(key, callback) {
	    return createPromise(function () {
	      return window.localStorage.getItem(key);
	    }, callback);
	  };
	
	  /**
	   * multiGet resolves to an array of key-value pair arrays that matches the
	   * input format of multiSet.
	   *
	   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
	   */
	
	
	  AsyncStorage.multiGet = function multiGet(keys, callback) {
	    var promises = keys.map(function (key) {
	      return AsyncStorage.getItem(key);
	    });
	    var processResult = function processResult(result) {
	      return result.map(function (value, i) {
	        return [keys[i], value];
	      });
	    };
	    return createPromiseAll(promises, callback, processResult);
	  };
	
	  /**
	   * Sets `value` for `key`.
	   */
	
	
	  AsyncStorage.setItem = function setItem(key, value, callback) {
	    return createPromise(function () {
	      window.localStorage.setItem(key, value);
	    }, callback);
	  };
	
	  /**
	   * Takes an array of key-value array pairs.
	   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
	   */
	
	
	  AsyncStorage.multiSet = function multiSet(keyValuePairs, callback) {
	    var promises = keyValuePairs.map(function (item) {
	      return AsyncStorage.setItem(item[0], item[1]);
	    });
	    return createPromiseAll(promises, callback);
	  };
	
	  /**
	   * Merges existing value with input value, assuming they are stringified JSON.
	   */
	
	
	  AsyncStorage.mergeItem = function mergeItem(key, value, callback) {
	    return createPromise(function () {
	      mergeLocalStorageItem(key, value);
	    }, callback);
	  };
	
	  /**
	   * Takes an array of key-value array pairs and merges them with existing
	   * values, assuming they are stringified JSON.
	   *
	   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
	   */
	
	
	  AsyncStorage.multiMerge = function multiMerge(keyValuePairs, callback) {
	    var promises = keyValuePairs.map(function (item) {
	      return AsyncStorage.mergeItem(item[0], item[1]);
	    });
	    return createPromiseAll(promises, callback);
	  };
	
	  /**
	   * Removes a `key`
	   */
	
	
	  AsyncStorage.removeItem = function removeItem(key, callback) {
	    return createPromise(function () {
	      return window.localStorage.removeItem(key);
	    }, callback);
	  };
	
	  /**
	   * Delete all the keys in the `keys` array.
	   */
	
	
	  AsyncStorage.multiRemove = function multiRemove(keys, callback) {
	    var promises = keys.map(function (key) {
	      return AsyncStorage.removeItem(key);
	    });
	    return createPromiseAll(promises, callback);
	  };
	
	  return AsyncStorage;
	}();
	
	exports.default = AsyncStorage;
	module.exports = exports['default'];

/***/ },
/* 1389 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function emptyFunction() {}
	
	var BackHandler = {
	  exitApp: emptyFunction,
	  addEventListener: function addEventListener() {
	    return {
	      remove: emptyFunction
	    };
	  },
	
	  removeEventListener: emptyFunction
	};
	
	exports.default = BackHandler;
	module.exports = exports["default"];

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _TouchableOpacity = __webpack_require__(1039);
	
	var _TouchableOpacity2 = _interopRequireDefault(_TouchableOpacity);
	
	var _Text = __webpack_require__(818);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Button = function (_Component) {
	  _inherits(Button, _Component);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Button.prototype.render = function render() {
	    var _props = this.props,
	        accessibilityLabel = _props.accessibilityLabel,
	        color = _props.color,
	        disabled = _props.disabled,
	        onPress = _props.onPress,
	        testID = _props.testID,
	        title = _props.title;
	
	
	    return _react2.default.createElement(
	      _TouchableOpacity2.default,
	      {
	        accessibilityLabel: accessibilityLabel,
	        accessibilityRole: 'button',
	        disabled: disabled,
	        onPress: onPress,
	        style: [styles.button, color && { backgroundColor: color }, disabled && styles.buttonDisabled],
	        testID: testID
	      },
	      _react2.default.createElement(
	        _Text2.default,
	        { style: [styles.text, disabled && styles.textDisabled] },
	        title
	      )
	    );
	  };
	
	  return Button;
	}(_react.Component);
	
	Button.propTypes =  false ? {
	  accessibilityLabel: _propTypes.string,
	  color: _ColorPropType2.default,
	  disabled: _propTypes.bool,
	  onPress: _propTypes.func.isRequired,
	  testID: _propTypes.string,
	  title: _propTypes.string.isRequired
	} : {};
	
	
	var styles = _StyleSheet2.default.create({
	  button: {
	    backgroundColor: '#2196F3',
	    borderRadius: 2
	  },
	  text: {
	    color: '#fff',
	    fontWeight: '500',
	    padding: 8,
	    textAlign: 'center',
	    textTransform: 'uppercase'
	  },
	  buttonDisabled: {
	    backgroundColor: '#dfdfdf'
	  },
	  textDisabled: {
	    color: '#a1a1a1'
	  }
	});
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CheckBox = function (_Component) {
	  _inherits(CheckBox, _Component);
	
	  function CheckBox() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CheckBox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (event) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onValueChange = _this$props.onValueChange;
	
	      var value = event.nativeEvent.target.checked;
	      event.nativeEvent.value = value;
	      onChange && onChange(event);
	      onValueChange && onValueChange(value);
	    }, _this._setCheckboxRef = function (element) {
	      _this._checkboxElement = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CheckBox.prototype.blur = function blur() {
	    _UIManager2.default.blur(this._checkboxElement);
	  };
	
	  CheckBox.prototype.focus = function focus() {
	    _UIManager2.default.focus(this._checkboxElement);
	  };
	
	  CheckBox.prototype.render = function render() {
	    var _props = this.props,
	        color = _props.color,
	        disabled = _props.disabled,
	        onChange = _props.onChange,
	        onValueChange = _props.onValueChange,
	        style = _props.style,
	        value = _props.value,
	        other = _objectWithoutProperties(_props, ['color', 'disabled', 'onChange', 'onValueChange', 'style', 'value']);
	
	    var fakeControl = _react2.default.createElement(_View2.default, {
	      style: [styles.fakeControl, value && styles.fakeControlChecked,
	      // custom color
	      value && color && { backgroundColor: color, borderColor: color }, disabled && styles.fakeControlDisabled, value && disabled && styles.fakeControlCheckedAndDisabled]
	    });
	
	    var nativeControl = (0, _createElement2.default)('input', {
	      checked: value,
	      disabled: disabled,
	      onChange: this._handleChange,
	      ref: this._setCheckboxRef,
	      style: [styles.nativeControl, styles.cursorInherit],
	      type: 'checkbox'
	    });
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, { style: [styles.root, style, disabled && styles.cursorDefault] }),
	      fakeControl,
	      nativeControl
	    );
	  };
	
	  return CheckBox;
	}(_react.Component);
	
	CheckBox.displayName = 'CheckBox';
	CheckBox.defaultProps = {
	  disabled: false,
	  value: false
	};
	CheckBox.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  color: _ColorPropType2.default,
	  disabled: _propTypes.bool,
	  onChange: _propTypes.func,
	  onValueChange: _propTypes.func,
	  value: _propTypes.bool
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    cursor: 'pointer',
	    height: 16,
	    userSelect: 'none',
	    width: 16
	  },
	  cursorDefault: {
	    cursor: 'default'
	  },
	  cursorInherit: {
	    cursor: 'inherit'
	  },
	  fakeControl: {
	    alignItems: 'center',
	    backgroundColor: '#fff',
	    borderColor: '#657786',
	    borderRadius: 2,
	    borderStyle: 'solid',
	    borderWidth: 2,
	    height: '100%',
	    justifyContent: 'center',
	    width: '100%'
	  },
	  fakeControlChecked: {
	    backgroundColor: '#009688',
	    backgroundImage: 'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K")',
	    backgroundRepeat: 'no-repeat',
	    borderColor: '#009688'
	  },
	  fakeControlDisabled: {
	    borderColor: '#CCD6DD'
	  },
	  fakeControlCheckedAndDisabled: {
	    backgroundColor: '#AAB8C2',
	    borderColor: '#AAB8C2'
	  },
	  nativeControl: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '100%',
	    margin: 0,
	    opacity: 0,
	    padding: 0,
	    width: '100%'
	  })
	});
	
	exports.default = (0, _applyNativeMethods2.default)(CheckBox);
	module.exports = exports['default'];

/***/ },
/* 1392 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var Clipboard = function () {
	  function Clipboard() {
	    _classCallCheck(this, Clipboard);
	  }
	
	  Clipboard.isAvailable = function isAvailable() {
	    return typeof document.queryCommandSupported === 'function' && document.queryCommandSupported('copy');
	  };
	
	  Clipboard.getString = function getString() {
	    return Promise.resolve('');
	  };
	
	  Clipboard.setString = function setString(text) {
	    var success = false;
	    var body = document.body;
	
	    if (body) {
	      // add the text to a hidden node
	      var node = document.createElement('span');
	      node.textContent = text;
	      node.style.opacity = '0';
	      node.style.position = 'absolute';
	      node.style.whiteSpace = 'pre-wrap';
	      body.appendChild(node);
	
	      // select the text
	      var selection = window.getSelection();
	      selection.removeAllRanges();
	      var range = document.createRange();
	      range.selectNodeContents(node);
	      selection.addRange(range);
	
	      // attempt to copy
	      try {
	        document.execCommand('copy');
	        success = true;
	      } catch (e) {}
	
	      // remove selection and node
	      selection.removeAllRanges();
	      body.removeChild(node);
	    }
	
	    return success;
	  };
	
	  return Clipboard;
	}();
	
	exports.default = Clipboard;
	module.exports = exports['default'];

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _Dimensions = __webpack_require__(124);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var DeviceInfo = {
	  Dimensions: {
	    get windowPhysicalPixels() {
	      var _Dimensions$get = _Dimensions2.default.get('window'),
	          width = _Dimensions$get.width,
	          height = _Dimensions$get.height,
	          fontScale = _Dimensions$get.fontScale,
	          scale = _Dimensions$get.scale;
	
	      return {
	        width: width * scale,
	        height: height * scale,
	        scale: scale,
	        fontScale: fontScale
	      };
	    },
	    get screenPhysicalPixels() {
	      var _Dimensions$get2 = _Dimensions2.default.get('screen'),
	          width = _Dimensions$get2.width,
	          height = _Dimensions$get2.height,
	          fontScale = _Dimensions$get2.fontScale,
	          scale = _Dimensions$get2.scale;
	
	      return {
	        width: width * scale,
	        height: height * scale,
	        scale: scale,
	        fontScale: fontScale
	      };
	    }
	  },
	
	  get locale() {
	    if (_ExecutionEnvironment.canUseDOM) {
	      if (window.navigator.languages) {
	        return window.navigator.languages[0];
	      } else {
	        return window.navigator.language;
	      }
	    }
	  },
	
	  get totalMemory() {
	    return _ExecutionEnvironment.canUseDOM ? window.navigator.deviceMemory : undefined;
	  },
	
	  get userAgent() {
	    return _ExecutionEnvironment.canUseDOM ? window.navigator.userAgent : '';
	  }
	};
	
	exports.default = DeviceInfo;
	module.exports = exports['default'];

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Easing = __webpack_require__(1061);
	
	var _Easing2 = _interopRequireDefault(_Easing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Easing2.default; /**
	                                     * Copyright (c) 2016-present, Nicolas Gallagher.
	                                     *
	                                     * This source code is licensed under the MIT license found in the
	                                     * LICENSE file in the root directory of this source tree.
	                                     *
	                                     * 
	                                     */
	
	module.exports = exports['default'];

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _FlatList = __webpack_require__(1063);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatList2.default; /**
	                                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                                       *
	                                       * This source code is licensed under the MIT license found in the
	                                       * LICENSE file in the root directory of this source tree.
	                                       *
	                                       * 
	                                       */
	
	module.exports = exports['default'];

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageURISourcePropType = _propTypes2.default.shape({
	  /**
	   * `uri` is a string representing the resource identifier for the image, which
	   * could be an http address, a local file path, or the name of a static image
	   * resource (which should be wrapped in the `require('./path/to/image.png')`
	   * function).
	   */
	  uri: _propTypes2.default.string,
	  /**
	   * `bundle` is the iOS asset bundle which the image is included in. This
	   * will default to [NSBundle mainBundle] if not set.
	   * @platform ios
	   */
	  bundle: _propTypes2.default.string,
	  /**
	   * `method` is the HTTP Method to use. Defaults to GET if not specified.
	   */
	  method: _propTypes2.default.string,
	  /**
	   * `headers` is an object representing the HTTP headers to send along with the
	   * request for a remote image.
	   */
	  headers: _propTypes2.default.objectOf(_propTypes2.default.string),
	  /**
	   * `body` is the HTTP body to send with the request. This must be a valid
	   * UTF-8 string, and will be sent exactly as specified, with no
	   * additional encoding (e.g. URL-escaping or base64) applied.
	   */
	  body: _propTypes2.default.string,
	  /**
	   * `cache` determines how the requests handles potentially cached
	   * responses.
	   *
	   * - `default`: Use the native platforms default strategy. `useProtocolCachePolicy` on iOS.
	   *
	   * - `reload`: The data for the URL will be loaded from the originating source.
	   * No existing cache data should be used to satisfy a URL load request.
	   *
	   * - `force-cache`: The existing cached data will be used to satisfy the request,
	   * regardless of its age or expiration date. If there is no existing data in the cache
	   * corresponding the request, the data is loaded from the originating source.
	   *
	   * - `only-if-cached`: The existing cache data will be used to satisfy a request, regardless of
	   * its age or expiration date. If there is no existing data in the cache corresponding
	   * to a URL load request, no attempt is made to load the data from the originating source,
	   * and the load is considered to have failed.
	   *
	   * @platform ios
	   */
	  cache: _propTypes2.default.oneOf(['default', 'reload', 'force-cache', 'only-if-cached']),
	  /**
	   * `width` and `height` can be specified if known at build time, in which case
	   * these will be used to set the default `<Image/>` component dimensions.
	   */
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  /**
	   * `scale` is used to indicate the scale factor of the image. Defaults to 1.0 if
	   * unspecified, meaning that one image pixel equates to one display point / DIP.
	   */
	  scale: _propTypes2.default.number
	});
	
	var ImageSourcePropType = _propTypes2.default.oneOfType([ImageURISourcePropType,
	// Opaque type returned by require('./image.jpg')
	_propTypes2.default.number, _propTypes2.default.string,
	// Multiple sources
	_propTypes2.default.arrayOf(ImageURISourcePropType)]);
	
	exports.default = ImageSourcePropType;
	module.exports = exports['default'];

/***/ },
/* 1397 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var dataUriPattern = /^data:/;
	
	var ImageUriCache = function () {
	  function ImageUriCache() {
	    _classCallCheck(this, ImageUriCache);
	  }
	
	  ImageUriCache.has = function has(uri) {
	    var entries = ImageUriCache._entries;
	    var isDataUri = dataUriPattern.test(uri);
	    return isDataUri || Boolean(entries[uri]);
	  };
	
	  ImageUriCache.add = function add(uri) {
	    var entries = ImageUriCache._entries;
	    var lastUsedTimestamp = Date.now();
	    if (entries[uri]) {
	      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
	      entries[uri].refCount += 1;
	    } else {
	      entries[uri] = {
	        lastUsedTimestamp: lastUsedTimestamp,
	        refCount: 1
	      };
	    }
	  };
	
	  ImageUriCache.remove = function remove(uri) {
	    var entries = ImageUriCache._entries;
	    if (entries[uri]) {
	      entries[uri].refCount -= 1;
	    }
	    // Free up entries when the cache is "full"
	    ImageUriCache._cleanUpIfNeeded();
	  };
	
	  ImageUriCache._cleanUpIfNeeded = function _cleanUpIfNeeded() {
	    var entries = ImageUriCache._entries;
	    var imageUris = Object.keys(entries);
	
	    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
	      var leastRecentlyUsedKey = void 0;
	      var leastRecentlyUsedEntry = void 0;
	
	      imageUris.forEach(function (uri) {
	        var entry = entries[uri];
	        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
	          leastRecentlyUsedKey = uri;
	          leastRecentlyUsedEntry = entry;
	        }
	      });
	
	      if (leastRecentlyUsedKey) {
	        delete entries[leastRecentlyUsedKey];
	      }
	    }
	  };
	
	  return ImageUriCache;
	}();
	
	ImageUriCache._maximumEntries = 256;
	ImageUriCache._entries = {};
	exports.default = ImageUriCache;
	module.exports = exports["default"];

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ensureComponentIsNative = __webpack_require__(1055);
	
	var _ensureComponentIsNative2 = _interopRequireDefault(_ensureComponentIsNative);
	
	var _Image = __webpack_require__(812);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var emptyObject = {};
	
	/**
	 * Very simple drop-in replacement for <Image> which supports nesting views.
	 */
	
	var ImageBackground = function (_Component) {
	  _inherits(ImageBackground, _Component);
	
	  function ImageBackground() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ImageBackground);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._viewRef = null, _this._captureRef = function (ref) {
	      _this._viewRef = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ImageBackground.prototype.setNativeProps = function setNativeProps(props) {
	    // Work-around flow
	    var viewRef = this._viewRef;
	    if (viewRef) {
	      (0, _ensureComponentIsNative2.default)(viewRef);
	      viewRef.setNativeProps(props);
	    }
	  };
	
	  ImageBackground.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        style = _props.style,
	        imageStyle = _props.imageStyle,
	        imageRef = _props.imageRef,
	        props = _objectWithoutProperties(_props, ['children', 'style', 'imageStyle', 'imageRef']);
	
	    return _react2.default.createElement(
	      _View2.default,
	      { ref: this._captureRef, style: style },
	      _react2.default.createElement(_Image2.default, _extends({}, props, {
	        ref: imageRef,
	        style: [_StyleSheet2.default.absoluteFill, {
	          // Temporary Workaround:
	          // Current (imperfect yet) implementation of <Image> overwrites width and height styles
	          // (which is not quite correct), and these styles conflict with explicitly set styles
	          // of <ImageBackground> and with our internal layout model here.
	          // So, we have to proxy/reapply these styles explicitly for actual <Image> component.
	          // This workaround should be removed after implementing proper support of
	          // intrinsic content size of the <Image>.
	          width: style.width,
	          height: style.height,
	          zIndex: -1
	        }, imageStyle]
	      })),
	      children
	    );
	  };
	
	  return ImageBackground;
	}(_react.Component);
	
	ImageBackground.defaultProps = {
	  style: emptyObject
	};
	ImageBackground.propTypes =  false ? Object.assign({}, _Image2.default.propTypes, {
	  imageStyle: _Image2.default.propTypes.style,
	  style: _ViewPropTypes2.default.style
	}) : {};
	exports.default = ImageBackground;
	module.exports = exports['default'];

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dismissKeyboard = __webpack_require__(1054);
	
	var _dismissKeyboard2 = _interopRequireDefault(_dismissKeyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Keyboard = {
	  addListener: function addListener() {
	    return { remove: function remove() {} };
	  },
	  dismiss: function dismiss() {
	    (0, _dismissKeyboard2.default)();
	  },
	  removeAllListeners: function removeAllListeners() {},
	  removeListener: function removeListener() {}
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	exports.default = Keyboard;
	module.exports = exports['default'];

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _propTypes = __webpack_require__(6);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2017-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var KeyboardAvoidingView = function (_Component) {
	  _inherits(KeyboardAvoidingView, _Component);
	
	  function KeyboardAvoidingView() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, KeyboardAvoidingView);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.frame = null, _this.onLayout = function (event) {
	      _this.frame = event.nativeEvent.layout;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  KeyboardAvoidingView.prototype.relativeKeyboardHeight = function relativeKeyboardHeight(keyboardFrame) {
	    var frame = this.frame;
	    if (!frame || !keyboardFrame) {
	      return 0;
	    }
	    var keyboardY = keyboardFrame.screenY - this.props.keyboardVerticalOffset;
	    return Math.max(frame.y + frame.height - keyboardY, 0);
	  };
	
	  KeyboardAvoidingView.prototype.onKeyboardChange = function onKeyboardChange(event) {};
	
	  KeyboardAvoidingView.prototype.render = function render() {
	    var _props = this.props,
	        behavior = _props.behavior,
	        contentContainerStyle = _props.contentContainerStyle,
	        keyboardVerticalOffset = _props.keyboardVerticalOffset,
	        rest = _objectWithoutProperties(_props, ['behavior', 'contentContainerStyle', 'keyboardVerticalOffset']);
	
	    return _react2.default.createElement(_View2.default, _extends({ onLayout: this.onLayout }, rest));
	  };
	
	  return KeyboardAvoidingView;
	}(_react.Component);
	
	KeyboardAvoidingView.defaultProps = {
	  keyboardVerticalOffset: 0
	};
	KeyboardAvoidingView.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  behavior: (0, _propTypes.oneOf)(['height', 'padding', 'position']),
	  contentContainerStyle: _ViewPropTypes2.default.style,
	  keyboardVerticalOffset: _propTypes.number.isRequired
	}) : {};
	exports.default = KeyboardAvoidingView;
	module.exports = exports['default'];

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _LayoutAnimation = __webpack_require__(1474);
	
	var _LayoutAnimation2 = _interopRequireDefault(_LayoutAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LayoutAnimation2.default; /**
	                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                              *
	                                              * This source code is licensed under the MIT license found in the
	                                              * LICENSE file in the root directory of this source tree.
	                                              *
	                                              * 
	                                              */
	
	module.exports = exports['default'];

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var initialURL = _ExecutionEnvironment.canUseDOM ? window.location.href : '';
	
	var Linking = {
	  addEventListener: function addEventListener() {},
	  removeEventListener: function removeEventListener() {},
	  canOpenURL: function canOpenURL() {
	    return Promise.resolve(true);
	  },
	  getInitialURL: function getInitialURL() {
	    return Promise.resolve(initialURL);
	  },
	  openURL: function openURL(url) {
	    try {
	      open(url);
	      return Promise.resolve();
	    } catch (e) {
	      return Promise.reject(e);
	    }
	  },
	  _validateURL: function _validateURL(url) {
	    (0, _invariant2.default)(typeof url === 'string', 'Invalid URL: should be a string. Was: ' + url);
	    (0, _invariant2.default)(url, 'Invalid URL: cannot be empty');
	  }
	};
	
	var open = function open(url) {
	  if (_ExecutionEnvironment.canUseDOM) {
	    window.location = new URL(url, window.location).toString();
	  }
	};
	
	exports.default = Linking;
	module.exports = exports['default'];

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ListView = __webpack_require__(1065);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ListView2.default; /**
	                                       * Copyright (c) 2016-present, Nicolas Gallagher.
	                                       *
	                                       * This source code is licensed under the MIT license found in the
	                                       * LICENSE file in the root directory of this source tree.
	                                       *
	                                       * 
	                                       */
	
	module.exports = exports['default'];

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UnimplementedView2.default;
	module.exports = exports['default'];

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _NativeEventEmitter = __webpack_require__(1066);
	
	var _NativeEventEmitter2 = _interopRequireDefault(_NativeEventEmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _NativeEventEmitter2.default; /**
	                                                 * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                 *
	                                                 * This source code is licensed under the MIT license found in the
	                                                 * LICENSE file in the root directory of this source tree.
	                                                 *
	                                                 * 
	                                                 */
	
	module.exports = exports['default'];

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _ExecutionEnvironment2 = _interopRequireDefault(_ExecutionEnvironment);
	
	var _arrayFindIndex = __webpack_require__(834);
	
	var _arrayFindIndex2 = _interopRequireDefault(_arrayFindIndex);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var connection = _ExecutionEnvironment2.default.canUseDOM && (window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection);
	
	// Prevent the underlying event handlers from leaking and include additional
	// properties available in browsers
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var getConnectionInfoObject = function getConnectionInfoObject() {
	  var result = {
	    effectiveType: 'unknown',
	    type: 'unknown'
	  };
	  if (!connection) {
	    return result;
	  }
	  for (var prop in connection) {
	    var value = connection[prop];
	    if (typeof value !== 'function' && value != null) {
	      result[prop] = value;
	    }
	  }
	  return result;
	};
	
	// Map React Native events to browser equivalents
	var eventTypesMap = {
	  change: 'change',
	  connectionChange: 'change'
	};
	var eventTypes = Object.keys(eventTypesMap);
	
	var connectionListeners = [];
	var netInfoListeners = [];
	
	/**
	 * Navigator online: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
	 * Network Connection API: https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
	 */
	var NetInfo = {
	  addEventListener: function addEventListener(type, handler) {
	    (0, _invariant2.default)(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
	    if (type === 'change') {
	      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
	    }
	    if (!connection) {
	      console.error('Network Connection API is not supported. Not listening for connection type changes.');
	      return {
	        remove: function remove() {}
	      };
	    }
	
	    var wrappedHandler = function wrappedHandler() {
	      return handler(getConnectionInfoObject());
	    };
	    netInfoListeners.push([handler, wrappedHandler]);
	    connection.addEventListener(eventTypesMap[type], wrappedHandler);
	    return {
	      remove: function remove() {
	        return NetInfo.removeEventListener(eventTypesMap[type], handler);
	      }
	    };
	  },
	  removeEventListener: function removeEventListener(type, handler) {
	    (0, _invariant2.default)(eventTypes.indexOf(type) !== -1, 'Trying to unsubscribe from unknown event: "%s"', type);
	    if (type === 'change') {
	      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
	    }
	
	    var listenerIndex = (0, _arrayFindIndex2.default)(netInfoListeners, function (pair) {
	      return pair[0] === handler;
	    });
	    (0, _invariant2.default)(listenerIndex !== -1, 'Trying to remove NetInfo listener for unregistered handler');
	    var _netInfoListeners$lis = netInfoListeners[listenerIndex],
	        wrappedHandler = _netInfoListeners$lis[1];
	
	    connection.removeEventListener(eventTypesMap[type], wrappedHandler);
	    netInfoListeners.splice(listenerIndex, 1);
	  },
	  fetch: function fetch() {
	    console.warn('`fetch` is deprecated. Use `getConnectionInfo` instead.');
	    return new Promise(function (resolve, reject) {
	      try {
	        resolve(connection.type);
	      } catch (err) {
	        resolve('unknown');
	      }
	    });
	  },
	  getConnectionInfo: function getConnectionInfo() {
	    return new Promise(function (resolve, reject) {
	      resolve(getConnectionInfoObject());
	    });
	  },
	
	
	  isConnected: {
	    addEventListener: function addEventListener(type, handler) {
	      (0, _invariant2.default)(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
	      if (type === 'change') {
	        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
	      }
	
	      var onlineCallback = function onlineCallback() {
	        return handler(true);
	      };
	      var offlineCallback = function offlineCallback() {
	        return handler(false);
	      };
	      connectionListeners.push([handler, onlineCallback, offlineCallback]);
	
	      window.addEventListener('online', onlineCallback, false);
	      window.addEventListener('offline', offlineCallback, false);
	
	      return {
	        remove: function remove() {
	          return NetInfo.isConnected.removeEventListener(eventTypesMap[type], handler);
	        }
	      };
	    },
	    removeEventListener: function removeEventListener(type, handler) {
	      (0, _invariant2.default)(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);
	      if (type === 'change') {
	        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
	      }
	
	      var listenerIndex = (0, _arrayFindIndex2.default)(connectionListeners, function (pair) {
	        return pair[0] === handler;
	      });
	      (0, _invariant2.default)(listenerIndex !== -1, 'Trying to remove NetInfo connection listener for unregistered handler');
	      var _connectionListeners$ = connectionListeners[listenerIndex],
	          onlineCallback = _connectionListeners$[1],
	          offlineCallback = _connectionListeners$[2];
	
	
	      window.removeEventListener('online', onlineCallback, false);
	      window.removeEventListener('offline', offlineCallback, false);
	
	      connectionListeners.splice(listenerIndex, 1);
	    },
	    fetch: function fetch() {
	      return new Promise(function (resolve, reject) {
	        try {
	          resolve(window.navigator.onLine);
	        } catch (err) {
	          resolve(true);
	        }
	      });
	    }
	  }
	};
	
	exports.default = NetInfo;
	module.exports = exports['default'];

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _react = __webpack_require__(1);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PickerItem = function (_Component) {
	  _inherits(PickerItem, _Component);
	
	  function PickerItem() {
	    _classCallCheck(this, PickerItem);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  PickerItem.prototype.render = function render() {
	    var _props = this.props,
	        color = _props.color,
	        label = _props.label,
	        testID = _props.testID,
	        value = _props.value;
	
	    var style = { color: color };
	    return (0, _createElement2.default)('option', { style: style, testID: testID, value: value }, label);
	  };
	
	  return PickerItem;
	}(_react.Component);
	
	exports.default = PickerItem;
	PickerItem.propTypes =  false ? {
	  color: _ColorPropType2.default,
	  label: _propTypes.string.isRequired,
	  testID: _propTypes.string,
	  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string])
	} : {};
	module.exports = exports['default'];

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ = __webpack_require__(1031);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var PickerItemPropType = function PickerItemPropType(props, propName, componentName) {
	  var prop = props[propName];
	  var error = null;
	  _react2.default.Children.forEach(prop, function (child) {
	    if (child.type !== _2.default.Item) {
	      error = new Error('`Picker` children must be of type `Picker.Item`.');
	    }
	  });
	  return error;
	};
	
	exports.default = PickerItemPropType;
	module.exports = exports['default'];

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _ViewStylePropTypes = __webpack_require__(108);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var PickerStylePropTypes = Object.assign({}, _ViewStylePropTypes2.default, {
	  color: _ColorPropType2.default
	});
	
	exports.default = PickerStylePropTypes;
	module.exports = exports['default'];

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dimensions = __webpack_require__(124);
	
	var _Dimensions2 = _interopRequireDefault(_Dimensions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * PixelRatio gives access to the device pixel density.
	 */
	var PixelRatio = function () {
	  function PixelRatio() {
	    _classCallCheck(this, PixelRatio);
	  }
	
	  /**
	   * Returns the device pixel density.
	   */
	  PixelRatio.get = function get() {
	    return _Dimensions2.default.get('window').scale;
	  };
	
	  /**
	   * No equivalent for Web
	   */
	
	
	  PixelRatio.getFontScale = function getFontScale() {
	    return _Dimensions2.default.get('window').fontScale || PixelRatio.get();
	  };
	
	  /**
	   * Converts a layout size (dp) to pixel size (px).
	   * Guaranteed to return an integer number.
	   */
	
	
	  PixelRatio.getPixelSizeForLayoutSize = function getPixelSizeForLayoutSize(layoutSize) {
	    return Math.round(layoutSize * PixelRatio.get());
	  };
	
	  /**
	   * Rounds a layout size (dp) to the nearest layout size that corresponds to
	   * an integer number of pixels. For example, on a device with a PixelRatio
	   * of 3, `PixelRatio.roundToNearestPixel(8.4) = 8.33`, which corresponds to
	   * exactly (8.33 * 3) = 25 pixels.
	   */
	
	
	  PixelRatio.roundToNearestPixel = function roundToNearestPixel(layoutSize) {
	    var ratio = PixelRatio.get();
	    return Math.round(layoutSize * ratio) / ratio;
	  };
	
	  return PixelRatio;
	}();
	
	exports.default = PixelRatio;
	module.exports = exports['default'];

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createStrictShapeTypeChecker = __webpack_require__(824);
	
	var _createStrictShapeTypeChecker2 = _interopRequireDefault(_createStrictShapeTypeChecker);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var PointPropType = (0, _createStrictShapeTypeChecker2.default)({
	  x: _propTypes.number,
	  y: _propTypes.number
	});
	
	exports.default = PointPropType;
	module.exports = exports['default'];

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ProgressBar = function (_Component) {
	  _inherits(ProgressBar, _Component);
	
	  function ProgressBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProgressBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._setProgressRef = function (element) {
	      _this._progressElement = element;
	    }, _this._updateProgressWidth = function () {
	      var _this$props = _this.props,
	          indeterminate = _this$props.indeterminate,
	          progress = _this$props.progress;
	
	      var percentageProgress = indeterminate ? 50 : progress * 100;
	      var width = indeterminate ? '25%' : percentageProgress + '%';
	      if (_this._progressElement) {
	        _this._progressElement.setNativeProps({
	          style: { width: width }
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProgressBar.prototype.componentDidMount = function componentDidMount() {
	    this._updateProgressWidth();
	  };
	
	  ProgressBar.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._updateProgressWidth();
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        color = _props.color,
	        indeterminate = _props.indeterminate,
	        progress = _props.progress,
	        trackColor = _props.trackColor,
	        style = _props.style,
	        other = _objectWithoutProperties(_props, ['color', 'indeterminate', 'progress', 'trackColor', 'style']);
	
	    var percentageProgress = progress * 100;
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, {
	        accessibilityRole: 'progressbar',
	        'aria-valuemax': '100',
	        'aria-valuemin': '0',
	        'aria-valuenow': indeterminate ? null : percentageProgress,
	        style: [styles.track, style, { backgroundColor: trackColor }]
	      }),
	      _react2.default.createElement(_View2.default, {
	        ref: this._setProgressRef,
	        style: [styles.progress, indeterminate && styles.animation, { backgroundColor: color }]
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react.Component);
	
	ProgressBar.displayName = 'ProgressBar';
	ProgressBar.defaultProps = {
	  color: '#1976D2',
	  indeterminate: false,
	  progress: 0,
	  trackColor: 'transparent'
	};
	ProgressBar.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  color: _ColorPropType2.default,
	  indeterminate: _propTypes.bool,
	  progress: _propTypes.number,
	  trackColor: _ColorPropType2.default
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  track: {
	    height: 5,
	    overflow: 'hidden',
	    userSelect: 'none',
	    zIndex: 0
	  },
	  progress: {
	    height: '100%',
	    zIndex: -1
	  },
	  animation: {
	    animationDuration: '1s',
	    animationName: [{
	      '0%': { transform: [{ translateX: '-100%' }] },
	      '100%': { transform: [{ translateX: '400%' }] }
	    }],
	    animationTimingFunction: 'linear',
	    animationIterationCount: 'infinite'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(ProgressBar);
	module.exports = exports['default'];

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var SafeAreaView = function (_React$Component) {
	  _inherits(SafeAreaView, _React$Component);
	
	  function SafeAreaView() {
	    _classCallCheck(this, SafeAreaView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SafeAreaView.prototype.render = function render() {
	    var _props = this.props,
	        style = _props.style,
	        rest = _objectWithoutProperties(_props, ['style']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, rest, { style: _StyleSheet2.default.compose(styles.root, style) }));
	  };
	
	  return SafeAreaView;
	}(_react2.default.Component);
	
	SafeAreaView.displayName = 'SafeAreaView';
	SafeAreaView.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    paddingTop: 'env(safe-area-inset-top)',
	    paddingRight: 'env(safe-area-inset-right)',
	    paddingBottom: 'env(safe-area-inset-bottom)',
	    paddingLeft: 'env(safe-area-inset-left)'
	  }
	});
	
	exports.default = SafeAreaView;
	module.exports = exports['default'];

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _debounce = __webpack_require__(155);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var normalizeScrollEvent = function normalizeScrollEvent(e) {
	  return {
	    nativeEvent: {
	      contentOffset: {
	        get x() {
	          return e.target.scrollLeft;
	        },
	        get y() {
	          return e.target.scrollTop;
	        }
	      },
	      contentSize: {
	        get height() {
	          return e.target.scrollHeight;
	        },
	        get width() {
	          return e.target.scrollWidth;
	        }
	      },
	      layoutMeasurement: {
	        get height() {
	          return e.target.offsetHeight;
	        },
	        get width() {
	          return e.target.offsetWidth;
	        }
	      }
	    },
	    timeStamp: Date.now()
	  };
	};
	
	/**
	 * Encapsulates the Web-specific scroll throttling and disabling logic
	 */
	
	var ScrollViewBase = function (_Component) {
	  _inherits(ScrollViewBase, _Component);
	
	  function ScrollViewBase() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScrollViewBase);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._debouncedOnScrollEnd = (0, _debounce2.default)(_this._handleScrollEnd, 100), _this._state = { isScrolling: false, scrollLastTick: 0 }, _this._createPreventableScrollHandler = function (handler) {
	      return function (e) {
	        if (_this.props.scrollEnabled) {
	          if (handler) {
	            handler(e);
	          }
	        } else {
	          // To disable scrolling in all browsers except Chrome
	          e.preventDefault();
	        }
	      };
	    }, _this._handleScroll = function (e) {
	      e.persist();
	      e.stopPropagation();
	      var scrollEventThrottle = _this.props.scrollEventThrottle;
	      // A scroll happened, so the scroll bumps the debounce.
	
	      _this._debouncedOnScrollEnd(e);
	      if (_this._state.isScrolling) {
	        // Scroll last tick may have changed, check if we need to notify
	        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
	          _this._handleScrollTick(e);
	        }
	      } else {
	        // Weren't scrolling, so we must have just started
	        _this._handleScrollStart(e);
	      }
	    }, _this._setViewRef = function (element) {
	      _this._viewRef = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ScrollViewBase.prototype.setNativeProps = function setNativeProps(props) {
	    if (this._viewRef) {
	      this._viewRef.setNativeProps(props);
	    }
	  };
	
	  ScrollViewBase.prototype.render = function render() {
	    var _props = this.props,
	        scrollEnabled = _props.scrollEnabled,
	        style = _props.style,
	        alwaysBounceHorizontal = _props.alwaysBounceHorizontal,
	        alwaysBounceVertical = _props.alwaysBounceVertical,
	        automaticallyAdjustContentInsets = _props.automaticallyAdjustContentInsets,
	        bounces = _props.bounces,
	        bouncesZoom = _props.bouncesZoom,
	        canCancelContentTouches = _props.canCancelContentTouches,
	        centerContent = _props.centerContent,
	        contentInset = _props.contentInset,
	        contentInsetAdjustmentBehavior = _props.contentInsetAdjustmentBehavior,
	        contentOffset = _props.contentOffset,
	        decelerationRate = _props.decelerationRate,
	        directionalLockEnabled = _props.directionalLockEnabled,
	        endFillColor = _props.endFillColor,
	        indicatorStyle = _props.indicatorStyle,
	        keyboardShouldPersistTaps = _props.keyboardShouldPersistTaps,
	        maximumZoomScale = _props.maximumZoomScale,
	        minimumZoomScale = _props.minimumZoomScale,
	        onMomentumScrollBegin = _props.onMomentumScrollBegin,
	        onMomentumScrollEnd = _props.onMomentumScrollEnd,
	        onScrollBeginDrag = _props.onScrollBeginDrag,
	        onScrollEndDrag = _props.onScrollEndDrag,
	        overScrollMode = _props.overScrollMode,
	        pinchGestureEnabled = _props.pinchGestureEnabled,
	        removeClippedSubviews = _props.removeClippedSubviews,
	        scrollEventThrottle = _props.scrollEventThrottle,
	        scrollIndicatorInsets = _props.scrollIndicatorInsets,
	        scrollPerfTag = _props.scrollPerfTag,
	        scrollsToTop = _props.scrollsToTop,
	        showsHorizontalScrollIndicator = _props.showsHorizontalScrollIndicator,
	        showsVerticalScrollIndicator = _props.showsVerticalScrollIndicator,
	        snapToInterval = _props.snapToInterval,
	        snapToAlignment = _props.snapToAlignment,
	        zoomScale = _props.zoomScale,
	        other = _objectWithoutProperties(_props, ['scrollEnabled', 'style', 'alwaysBounceHorizontal', 'alwaysBounceVertical', 'automaticallyAdjustContentInsets', 'bounces', 'bouncesZoom', 'canCancelContentTouches', 'centerContent', 'contentInset', 'contentInsetAdjustmentBehavior', 'contentOffset', 'decelerationRate', 'directionalLockEnabled', 'endFillColor', 'indicatorStyle', 'keyboardShouldPersistTaps', 'maximumZoomScale', 'minimumZoomScale', 'onMomentumScrollBegin', 'onMomentumScrollEnd', 'onScrollBeginDrag', 'onScrollEndDrag', 'overScrollMode', 'pinchGestureEnabled', 'removeClippedSubviews', 'scrollEventThrottle', 'scrollIndicatorInsets', 'scrollPerfTag', 'scrollsToTop', 'showsHorizontalScrollIndicator', 'showsVerticalScrollIndicator', 'snapToInterval', 'snapToAlignment', 'zoomScale']);
	
	    return _react2.default.createElement(_View2.default, _extends({}, other, {
	      onScroll: this._handleScroll,
	      onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
	      onWheel: this._createPreventableScrollHandler(this.props.onWheel),
	      ref: this._setViewRef,
	      style: _StyleSheet2.default.compose(style, !scrollEnabled && styles.scrollDisabled)
	    }));
	  };
	
	  ScrollViewBase.prototype._handleScrollStart = function _handleScrollStart(e) {
	    this._state.isScrolling = true;
	    this._state.scrollLastTick = Date.now();
	  };
	
	  ScrollViewBase.prototype._handleScrollTick = function _handleScrollTick(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.scrollLastTick = Date.now();
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._handleScrollEnd = function _handleScrollEnd(e) {
	    var onScroll = this.props.onScroll;
	
	    this._state.isScrolling = false;
	    if (onScroll) {
	      onScroll(normalizeScrollEvent(e));
	    }
	  };
	
	  ScrollViewBase.prototype._shouldEmitScrollEvent = function _shouldEmitScrollEvent(lastTick, eventThrottle) {
	    var timeSinceLastTick = Date.now() - lastTick;
	    return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
	  };
	
	  return ScrollViewBase;
	}(_react.Component);
	
	// Chrome doesn't support e.preventDefault in this case; touch-action must be
	// used to disable scrolling.
	// https://developers.google.com/web/updates/2017/01/scrolling-intervention
	
	
	ScrollViewBase.defaultProps = {
	  scrollEnabled: true,
	  scrollEventThrottle: 0
	};
	exports.default = ScrollViewBase;
	ScrollViewBase.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  onMomentumScrollBegin: _propTypes.func,
	  onMomentumScrollEnd: _propTypes.func,
	  onScroll: _propTypes.func,
	  onScrollBeginDrag: _propTypes.func,
	  onScrollEndDrag: _propTypes.func,
	  onTouchMove: _propTypes.func,
	  onWheel: _propTypes.func,
	  removeClippedSubviews: _propTypes.bool,
	  scrollEnabled: _propTypes.bool,
	  scrollEventThrottle: _propTypes.number,
	  showsHorizontalScrollIndicator: _propTypes.bool,
	  showsVerticalScrollIndicator: _propTypes.bool
	}) : {};
	var styles = _StyleSheet2.default.create({
	  scrollDisabled: {
	    touchAction: 'none'
	  }
	});
	module.exports = exports['default'];

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SectionList = __webpack_require__(1477);
	
	var _SectionList2 = _interopRequireDefault(_SectionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SectionList2.default; /**
	                                          * Copyright (c) 2016-present, Nicolas Gallagher.
	                                          *
	                                          * This source code is licensed under the MIT license found in the
	                                          * LICENSE file in the root directory of this source tree.
	                                          *
	                                          * 
	                                          */
	
	module.exports = exports['default'];

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2018-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2016-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Share = function () {
	  function Share() {
	    _classCallCheck(this, Share);
	  }
	
	  Share.share = function share(content) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    (0, _invariant2.default)(typeof content === 'object' && content !== null, 'Content to share must be a valid object');
	    (0, _invariant2.default)(typeof content.url === 'string' || typeof content.message === 'string', 'At least one of URL and message is required');
	    (0, _invariant2.default)(typeof options === 'object' && options !== null, 'Options must be a valid object');
	    (0, _invariant2.default)(!content.title || typeof content.title === 'string', 'Invalid title: title should be a string.');
	
	    if (window.navigator.share !== undefined) {
	      return window.navigator.share({
	        title: content.title,
	        text: content.message,
	        url: content.url
	      });
	    } else {
	      return Promise.reject(new Error('Share is not supported in this browser'));
	    }
	  };
	
	  /**
	   * The content was successfully shared.
	   */
	
	
	  _createClass(Share, null, [{
	    key: 'sharedAction',
	    get: function get() {
	      return 'sharedAction';
	    }
	
	    /**
	     * The dialog has been dismissed.
	     * @platform ios
	     */
	
	  }, {
	    key: 'dismissedAction',
	    get: function get() {
	      return 'dismissedAction';
	    }
	  }]);
	
	  return Share;
	}();
	
	exports.default = Share;
	module.exports = exports['default'];

/***/ },
/* 1417 */
1404,
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var StatusBar = function (_Component) {
	  _inherits(StatusBar, _Component);
	
	  function StatusBar() {
	    _classCallCheck(this, StatusBar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StatusBar.setBackgroundColor = function setBackgroundColor() {};
	
	  StatusBar.setBarStyle = function setBarStyle() {};
	
	  StatusBar.setHidden = function setHidden() {};
	
	  StatusBar.setNetworkActivityIndicatorVisible = function setNetworkActivityIndicatorVisible() {};
	
	  StatusBar.setTranslucent = function setTranslucent() {};
	
	  StatusBar.prototype.render = function render() {
	    return null;
	  };
	
	  return StatusBar;
	}(_react.Component);
	
	exports.default = StatusBar;
	module.exports = exports['default'];

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _createReactDOMStyle = __webpack_require__(1033);
	
	var _createReactDOMStyle2 = _interopRequireDefault(_createReactDOMStyle);
	
	var _flattenArray = __webpack_require__(1448);
	
	var _flattenArray2 = _interopRequireDefault(_flattenArray);
	
	var _flattenStyle = __webpack_require__(1035);
	
	var _flattenStyle2 = _interopRequireDefault(_flattenStyle);
	
	var _I18nManager = __webpack_require__(125);
	
	var _I18nManager2 = _interopRequireDefault(_I18nManager);
	
	var _i18nStyle = __webpack_require__(1036);
	
	var _i18nStyle2 = _interopRequireDefault(_i18nStyle);
	
	var _prefixStyles = __webpack_require__(1058);
	
	var _StyleSheetManager = __webpack_require__(1421);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * @noflow
	                                                                                                                                                           */
	
	/**
	 * WARNING: changes to this file in particular can cause significant changes to
	 * the results of render performance benchmarks.
	 */
	
	var emptyObject = {};
	
	var ReactNativeStyleResolver = function () {
	  ReactNativeStyleResolver.prototype._init = function _init() {
	    this.cache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
	    this.injectedCache = { ltr: {}, rtl: {}, rtlNoSwap: {} };
	    this.styleSheetManager = new _StyleSheetManager2.default();
	  };
	
	  function ReactNativeStyleResolver() {
	    _classCallCheck(this, ReactNativeStyleResolver);
	
	    this._init();
	  }
	
	  ReactNativeStyleResolver.prototype.getStyleSheet = function getStyleSheet() {
	    // reset state on the server so critical css is always the result
	    var sheet = this.styleSheetManager.getStyleSheet();
	    if (!_ExecutionEnvironment.canUseDOM) {
	      this._init();
	    }
	    return sheet;
	  };
	
	  ReactNativeStyleResolver.prototype._injectRegisteredStyle = function _injectRegisteredStyle(id) {
	    var _this = this;
	
	    var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	        isRTL = _I18nManager2.default.isRTL;
	
	    var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
	    if (!this.injectedCache[dir][id]) {
	      var style = (0, _flattenStyle2.default)(id);
	      var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(style));
	      Object.keys(domStyle).forEach(function (styleProp) {
	        var value = domStyle[styleProp];
	        if (value != null) {
	          _this.styleSheetManager.injectDeclaration(styleProp, value);
	        }
	      });
	      this.injectedCache[dir][id] = true;
	    }
	  };
	
	  /**
	   * Resolves a React Native style object to DOM attributes
	   */
	
	
	  ReactNativeStyleResolver.prototype.resolve = function resolve(style) {
	    if (!style) {
	      return emptyObject;
	    }
	
	    // fast and cachable
	    if (typeof style === 'number') {
	      this._injectRegisteredStyle(style);
	      var _key = createCacheKey(style);
	      return this._resolveStyleIfNeeded(style, _key);
	    }
	
	    // resolve a plain RN style object
	    if (!Array.isArray(style)) {
	      return this._resolveStyleIfNeeded(style);
	    }
	
	    // flatten the style array
	    // cache resolved props when all styles are registered
	    // otherwise fallback to resolving
	    var flatArray = (0, _flattenArray2.default)(style);
	    var isArrayOfNumbers = true;
	    for (var i = 0; i < flatArray.length; i++) {
	      var id = flatArray[i];
	      if (typeof id !== 'number') {
	        isArrayOfNumbers = false;
	      } else {
	        this._injectRegisteredStyle(id);
	      }
	    }
	    var key = isArrayOfNumbers ? createCacheKey(flatArray.join('-')) : null;
	    return this._resolveStyleIfNeeded(flatArray, key);
	  };
	
	  /**
	   * Resolves a React Native style object to DOM attributes, accounting for
	   * the existing styles applied to the DOM node.
	   *
	   * To determine the next style, some of the existing DOM state must be
	   * converted back into React Native styles.
	   */
	
	
	  ReactNativeStyleResolver.prototype.resolveWithNode = function resolveWithNode(rnStyleNext, node) {
	    var _this2 = this;
	
	    var _getDOMStyleInfo = getDOMStyleInfo(node),
	        rdomClassList = _getDOMStyleInfo.classList,
	        rdomStyle = _getDOMStyleInfo.style;
	    // Convert the DOM classList back into a React Native form
	    // Preserves unrecognized class names.
	
	
	    var _rdomClassList$reduce = rdomClassList.reduce(function (styleProps, className) {
	      var _styleSheetManager$ge = _this2.styleSheetManager.getDeclaration(className),
	          prop = _styleSheetManager$ge.prop,
	          value = _styleSheetManager$ge.value;
	
	      if (prop) {
	        styleProps.style[prop] = value;
	      } else {
	        styleProps.classList.push(className);
	      }
	      return styleProps;
	    }, { classList: [], style: {} }),
	        rnClassList = _rdomClassList$reduce.classList,
	        rnStyle = _rdomClassList$reduce.style;
	
	    // Create next DOM style props from current and next RN styles
	
	
	    var _resolve = this.resolve([(0, _i18nStyle2.default)(rnStyle), rnStyleNext]),
	        rdomClassListNext = _resolve.classList,
	        rdomStyleNext = _resolve.style;
	
	    // Final className
	    // Add the current class names not managed by React Native
	
	
	    var className = classListToString(rdomClassListNext.concat(rnClassList));
	
	    // Final style
	    // Next class names take priority over current inline styles
	    var style = Object.assign({}, rdomStyle);
	    rdomClassListNext.forEach(function (className) {
	      var _styleSheetManager$ge2 = _this2.styleSheetManager.getDeclaration(className),
	          prop = _styleSheetManager$ge2.prop;
	
	      if (style[prop]) {
	        style[prop] = '';
	      }
	    });
	    // Next inline styles take priority over current inline styles
	    Object.assign(style, rdomStyleNext);
	
	    return { className: className, style: style };
	  };
	
	  /**
	   * Resolves a React Native style object
	   */
	
	
	  ReactNativeStyleResolver.prototype._resolveStyle = function _resolveStyle(style) {
	    var _this3 = this;
	
	    var flatStyle = (0, _flattenStyle2.default)(style);
	    var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(flatStyle));
	
	    var props = Object.keys(domStyle).reduce(function (props, styleProp) {
	      var value = domStyle[styleProp];
	      if (value != null) {
	        var className = _this3.styleSheetManager.getClassName(styleProp, value);
	        if (className) {
	          props.classList.push(className);
	        } else {
	          // Certain properties and values are not transformed by 'createReactDOMStyle' as they
	          // require more complex transforms into multiple CSS rules. Here we assume that StyleManager
	          // can bind these styles to a className, and prevent them becoming invalid inline-styles.
	          if (styleProp === 'pointerEvents' || styleProp === 'placeholderTextColor' || styleProp === 'animationName') {
	            var _className = _this3.styleSheetManager.injectDeclaration(styleProp, value);
	            if (_className) {
	              props.classList.push(_className);
	            }
	          } else {
	            if (!props.style) {
	              props.style = {};
	            }
	            // 4x slower render
	            props.style[styleProp] = value;
	          }
	        }
	      }
	      return props;
	    }, { classList: [] });
	
	    props.className = classListToString(props.classList);
	    if (props.style) {
	      props.style = (0, _prefixStyles.prefixInlineStyles)(props.style);
	    }
	    return props;
	  };
	
	  /**
	   * Caching layer over 'resolveStyle'
	   */
	
	
	  ReactNativeStyleResolver.prototype._resolveStyleIfNeeded = function _resolveStyleIfNeeded(style, key) {
	    if (key) {
	      var doLeftAndRightSwapInRTL = _I18nManager2.default.doLeftAndRightSwapInRTL,
	          isRTL = _I18nManager2.default.isRTL;
	
	      var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';
	      if (!this.cache[dir][key]) {
	        // slow: convert style object to props and cache
	        this.cache[dir][key] = this._resolveStyle(style);
	      }
	      return this.cache[dir][key];
	    }
	    return this._resolveStyle(style);
	  };
	
	  return ReactNativeStyleResolver;
	}();
	
	/**
	 * Misc helpers
	 */
	
	
	exports.default = ReactNativeStyleResolver;
	var createCacheKey = function createCacheKey(id) {
	  var prefix = 'rn';
	  return prefix + '-' + id;
	};
	
	var classListToString = function classListToString(list) {
	  return list.join(' ').trim();
	};
	
	/**
	 * Copies classList and style data from a DOM node
	 */
	var hyphenPattern = /-([a-z])/g;
	var toCamelCase = function toCamelCase(str) {
	  return str.replace(hyphenPattern, function (m) {
	    return m[1].toUpperCase();
	  });
	};
	
	var getDOMStyleInfo = function getDOMStyleInfo(node) {
	  var nodeStyle = node.style;
	  var classList = Array.prototype.slice.call(node.classList);
	  var style = {};
	  // DOM style is a CSSStyleDeclaration
	  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
	  for (var i = 0; i < nodeStyle.length; i += 1) {
	    var property = nodeStyle.item(i);
	    if (property) {
	      // DOM style uses hyphenated prop names and may include vendor prefixes
	      // Transform back into React DOM style.
	      style[toCamelCase(property)] = nodeStyle.getPropertyValue(property);
	    }
	  }
	  return { classList: classList, style: style };
	};
	module.exports = exports['default'];

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetValidation = __webpack_require__(1422);
	
	var _StyleSheetValidation2 = _interopRequireDefault(_StyleSheetValidation);
	
	var _ReactNativePropRegistry = __webpack_require__(1049);
	
	var _ReactNativePropRegistry2 = _interopRequireDefault(_ReactNativePropRegistry);
	
	var _flattenStyle = __webpack_require__(1035);
	
	var _flattenStyle2 = _interopRequireDefault(_flattenStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var absoluteFillObject = {
	  position: 'absolute',
	  left: 0,
	  right: 0,
	  top: 0,
	  bottom: 0
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * @noflow
	    */
	
	var absoluteFill = _ReactNativePropRegistry2.default.register(absoluteFillObject);
	
	var StyleSheet = {
	  absoluteFill: absoluteFill,
	  absoluteFillObject: absoluteFillObject,
	  compose: function compose(style1, style2) {
	    if (style1 && style2) {
	      return [style1, style2];
	    } else {
	      return style1 || style2;
	    }
	  },
	  create: function create(styles) {
	    var result = {};
	    Object.keys(styles).forEach(function (key) {
	      if (false) {
	        _StyleSheetValidation2.default.validateStyle(key, styles);
	      }
	      var id = styles[key] && _ReactNativePropRegistry2.default.register(styles[key]);
	      result[key] = id;
	    });
	    return result;
	  },
	
	  flatten: _flattenStyle2.default,
	  hairlineWidth: 1
	};
	
	exports.default = StyleSheet;
	module.exports = exports['default'];

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createAtomicRules = __webpack_require__(1424);
	
	var _createAtomicRules2 = _interopRequireDefault(_createAtomicRules);
	
	var _hash = __webpack_require__(1060);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _initialRules = __webpack_require__(1426);
	
	var _initialRules2 = _interopRequireDefault(_initialRules);
	
	var _WebStyleSheet = __webpack_require__(1423);
	
	var _WebStyleSheet2 = _interopRequireDefault(_WebStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * @noflow
	                                                                                                                                                           */
	
	var emptyObject = {};
	var STYLE_ELEMENT_ID = 'react-native-stylesheet';
	
	var createClassName = function createClassName(prop, value) {
	  var hashed = (0, _hash2.default)(prop + normalizeValue(value));
	  return  false ? 'rn-' + prop + '-' + hashed : 'rn-' + hashed;
	};
	
	var normalizeValue = function normalizeValue(value) {
	  return typeof value === 'object' ? JSON.stringify(value) : value;
	};
	
	var StyleSheetManager = function () {
	  function StyleSheetManager() {
	    var _this = this;
	
	    _classCallCheck(this, StyleSheetManager);
	
	    this._cache = {
	      byClassName: {},
	      byProp: {}
	    };
	
	    this._sheet = new _WebStyleSheet2.default(STYLE_ELEMENT_ID);
	    _initialRules2.default.forEach(function (rule) {
	      _this._sheet.insertRuleOnce(rule);
	    });
	  }
	
	  StyleSheetManager.prototype.getClassName = function getClassName(prop, value) {
	    var val = normalizeValue(value);
	    var cache = this._cache.byProp;
	    return cache[prop] && cache[prop].hasOwnProperty(val) && cache[prop][val];
	  };
	
	  StyleSheetManager.prototype.getDeclaration = function getDeclaration(className) {
	    var cache = this._cache.byClassName;
	    return cache[className] || emptyObject;
	  };
	
	  StyleSheetManager.prototype.getStyleSheet = function getStyleSheet() {
	    var cssText = this._sheet.cssText;
	
	
	    return {
	      id: STYLE_ELEMENT_ID,
	      textContent: cssText
	    };
	  };
	
	  StyleSheetManager.prototype.injectDeclaration = function injectDeclaration(prop, value) {
	    var _this2 = this;
	
	    var val = normalizeValue(value);
	    var className = this.getClassName(prop, val);
	    if (!className) {
	      className = createClassName(prop, val);
	      this._addToCache(className, prop, val);
	      var rules = (0, _createAtomicRules2.default)('.' + className, prop, value);
	      rules.forEach(function (rule) {
	        _this2._sheet.insertRuleOnce(rule);
	      });
	    }
	    return className;
	  };
	
	  StyleSheetManager.prototype._addToCache = function _addToCache(className, prop, value) {
	    var cache = this._cache;
	    if (!cache.byProp[prop]) {
	      cache.byProp[prop] = {};
	    }
	    cache.byProp[prop][value] = className;
	    cache.byClassName[className] = { prop: prop, value: value };
	  };
	
	  return StyleSheetManager;
	}();
	
	exports.default = StyleSheetManager;
	module.exports = exports['default'];

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ImageStylePropTypes = __webpack_require__(1029);
	
	var _ImageStylePropTypes2 = _interopRequireDefault(_ImageStylePropTypes);
	
	var _TextInputStylePropTypes = __webpack_require__(1038);
	
	var _TextInputStylePropTypes2 = _interopRequireDefault(_TextInputStylePropTypes);
	
	var _TextStylePropTypes = __webpack_require__(817);
	
	var _TextStylePropTypes2 = _interopRequireDefault(_TextStylePropTypes);
	
	var _ViewStylePropTypes = __webpack_require__(108);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	// Hardcoded because this is a legit case but we don't want to load it from
	// a private API. We might likely want to unify style sheet creation with how it
	// is done in the DOM so this might move into React. I know what I'm doing so
	// plz don't fire me.
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var StyleSheetValidation = function () {
	  function StyleSheetValidation() {
	    _classCallCheck(this, StyleSheetValidation);
	  }
	
	  StyleSheetValidation.validateStyleProp = function validateStyleProp(prop, style, caller) {
	    if (false) {
	      var value = style[prop];
	
	      var isCustomProperty = prop.indexOf('--') === 0;
	      if (isCustomProperty) return;
	
	      if (allStylePropTypes[prop] === undefined) {
	        var message1 = '"' + prop + '" is not a valid style property.';
	        var message2 = '\nValid style props: ' + JSON.stringify(Object.keys(allStylePropTypes).sort(), null, '  ');
	        styleError(message1, style, caller, message2);
	      } else if (typeof value === 'string' && value.indexOf('!important') > -1) {
	        styleError('Invalid value of "' + value + '" set on prop "' + prop + '". Values cannot include "!important"', style, caller);
	      } else {
	        var error = allStylePropTypes[prop](style, prop, caller, 'prop', null, ReactPropTypesSecret);
	        if (error) {
	          styleError(error.message, style, caller);
	        }
	      }
	    }
	  };
	
	  StyleSheetValidation.validateStyle = function validateStyle(name, styles) {
	    if (false) {
	      for (var prop in styles[name]) {
	        StyleSheetValidation.validateStyleProp(prop, styles[name], 'StyleSheet ' + name);
	      }
	    }
	  };
	
	  StyleSheetValidation.addValidStylePropTypes = function addValidStylePropTypes(stylePropTypes) {
	    for (var key in stylePropTypes) {
	      allStylePropTypes[key] = stylePropTypes[key];
	    }
	  };
	
	  return StyleSheetValidation;
	}();
	
	var styleError = function styleError(message1, style, caller, message2) {
	  (0, _warning2.default)(false, message1 + '\n' + (caller || '<<unknown>>') + ': ' + JSON.stringify(style, null, '  ') + (message2 || ''));
	};
	
	var allStylePropTypes = {};
	
	StyleSheetValidation.addValidStylePropTypes(_ImageStylePropTypes2.default);
	StyleSheetValidation.addValidStylePropTypes(_TextStylePropTypes2.default);
	StyleSheetValidation.addValidStylePropTypes(_TextInputStylePropTypes2.default);
	StyleSheetValidation.addValidStylePropTypes(_ViewStylePropTypes2.default);
	
	StyleSheetValidation.addValidStylePropTypes({
	  appearance: _propTypes.string,
	  borderCollapse: _propTypes.string,
	  borderSpacing: (0, _propTypes.oneOf)([_propTypes.number, _propTypes.string]),
	  clear: _propTypes.string,
	  cursor: _propTypes.string,
	  fill: _propTypes.string,
	  float: (0, _propTypes.oneOf)(['end', 'left', 'none', 'right', 'start']),
	  listStyle: _propTypes.string,
	  objectFit: (0, _propTypes.oneOf)(['fill', 'contain', 'cover', 'none', 'scale-down']),
	  objectPosition: _propTypes.string,
	  pointerEvents: _propTypes.string,
	  tableLayout: _propTypes.string,
	  /* @private */
	  MozAppearance: _propTypes.string,
	  WebkitAppearance: _propTypes.string
	});
	
	exports.default = StyleSheetValidation;
	module.exports = exports['default'];

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _modality = __webpack_require__(1427);
	
	var _modality2 = _interopRequireDefault(_modality);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var WebStyleSheet = function () {
	  function WebStyleSheet(id) {
	    _classCallCheck(this, WebStyleSheet);
	
	    this._cssRules = [];
	    this._sheet = null;
	    this._textContent = '';
	
	    var domStyleElement = void 0;
	
	    // on the client we check for an existing style sheet before injecting
	    if (_ExecutionEnvironment.canUseDOM) {
	      domStyleElement = document.getElementById(id);
	      if (!domStyleElement) {
	        var html = '<style id="' + id + '"></style>';
	        if (document.head) {
	          document.head.insertAdjacentHTML('afterbegin', html);
	          domStyleElement = document.getElementById(id);
	        }
	      }
	
	      if (domStyleElement) {
	        (0, _modality2.default)(domStyleElement);
	        // $FlowFixMe
	        this._sheet = domStyleElement.sheet;
	        this._textContent = domStyleElement.textContent;
	      }
	    }
	  }
	
	  WebStyleSheet.prototype.containsRule = function containsRule(rule) {
	    return this._cssRules.indexOf(rule) > -1;
	  };
	
	  WebStyleSheet.prototype.insertRuleOnce = function insertRuleOnce(rule, position) {
	    // Reduce chance of duplicate rules
	    if (!this.containsRule(rule)) {
	      this._cssRules.push(rule);
	
	      // Check whether a rule was part of any prerendered styles (textContent
	      // doesn't include styles injected via 'insertRule')
	      if (this._textContent.indexOf(rule) === -1 && this._sheet) {
	        var pos = position || this._sheet.cssRules.length;
	        this._sheet.insertRule(rule, pos);
	      }
	    }
	  };
	
	  _createClass(WebStyleSheet, [{
	    key: 'cssText',
	    get: function get() {
	      return this._cssRules.join('\n');
	    }
	  }]);
	
	  return WebStyleSheet;
	}();
	
	exports.default = WebStyleSheet;
	module.exports = exports['default'];

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createKeyframesRules2 = __webpack_require__(1425);
	
	var _createKeyframesRules3 = _interopRequireDefault(_createKeyframesRules2);
	
	var _createRuleBlock7 = __webpack_require__(1034);
	
	var _createRuleBlock8 = _interopRequireDefault(_createRuleBlock7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createAtomicRules = function createAtomicRules(selector, prop, value) {
	  var rules = [];
	
	  // Handle custom properties and custom values that require additional rules
	  // to be created.
	  switch (prop) {
	    // See #513
	    case 'pointerEvents':
	      {
	        var _createRuleBlock3;
	
	        var val = value;
	        if (value === 'auto' || value === 'box-only') {
	          val = 'auto !important';
	          if (value === 'box-only') {
	            var _createRuleBlock;
	
	            var _block = (0, _createRuleBlock8.default)((_createRuleBlock = {}, _createRuleBlock[prop] = 'none', _createRuleBlock));
	            rules.push(selector + ' > *{' + _block + '}');
	          }
	        } else if (value === 'none' || value === 'box-none') {
	          val = 'none !important';
	          if (value === 'box-none') {
	            var _createRuleBlock2;
	
	            var _block2 = (0, _createRuleBlock8.default)((_createRuleBlock2 = {}, _createRuleBlock2[prop] = 'auto', _createRuleBlock2));
	            rules.push(selector + ' > *{' + _block2 + '}');
	          }
	        }
	        var block = (0, _createRuleBlock8.default)((_createRuleBlock3 = {}, _createRuleBlock3[prop] = val, _createRuleBlock3));
	        rules.push(selector + '{' + block + '}');
	        break;
	      }
	
	    case 'placeholderTextColor':
	      {
	        var _block3 = (0, _createRuleBlock8.default)({ color: value, opacity: 1 });
	        rules.push('@media all {' + (selector + '::-webkit-input-placeholder{' + _block3 + '}') + (selector + '::-moz-placeholder{' + _block3 + '}') + (selector + ':-ms-input-placeholder{' + _block3 + '}') + (selector + '::placeholder{' + _block3 + '}') + '}');
	        break;
	      }
	
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          var _createRuleBlock4;
	
	          // add a className referencing the animation
	          var _block4 = (0, _createRuleBlock8.default)((_createRuleBlock4 = {}, _createRuleBlock4[prop] = value, _createRuleBlock4));
	          rules.push(selector + '{' + _block4 + '}');
	        } else {
	          var _createRuleBlock5;
	
	          var animationNames = [];
	
	          // add the keyframes needed to implement each value
	          value.forEach(function (keyframes) {
	            if (typeof keyframes === 'string') {
	              animationNames.push(keyframes);
	            } else {
	              var _createKeyframesRules = (0, _createKeyframesRules3.default)(keyframes),
	                  identifier = _createKeyframesRules.identifier,
	                  keyframesRules = _createKeyframesRules.rules;
	
	              keyframesRules.forEach(function (rule) {
	                rules.push(rule);
	              });
	              animationNames.push(identifier);
	            }
	          });
	
	          // add a className referencing the animation identifiers
	          var _block5 = (0, _createRuleBlock8.default)((_createRuleBlock5 = {}, _createRuleBlock5[prop] = animationNames.join(','), _createRuleBlock5));
	          rules.push(selector + '{' + _block5 + '}');
	        }
	
	        break;
	      }
	
	    default:
	      {
	        var _createRuleBlock6;
	
	        var _block6 = (0, _createRuleBlock8.default)((_createRuleBlock6 = {}, _createRuleBlock6[prop] = value, _createRuleBlock6));
	        rules.push(selector + '{' + _block6 + '}');
	      }
	  }
	
	  return rules;
	};
	
	exports.default = createAtomicRules;
	module.exports = exports['default'];

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createRuleBlock = __webpack_require__(1034);
	
	var _createRuleBlock2 = _interopRequireDefault(_createRuleBlock);
	
	var _createReactDOMStyle = __webpack_require__(1033);
	
	var _createReactDOMStyle2 = _interopRequireDefault(_createReactDOMStyle);
	
	var _i18nStyle = __webpack_require__(1036);
	
	var _i18nStyle2 = _interopRequireDefault(_i18nStyle);
	
	var _hash = __webpack_require__(1060);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hashObject = function hashObject(obj) {
	  return (0, _hash2.default)(JSON.stringify(obj));
	};
	
	var createIdentifier = function createIdentifier(obj) {
	  var hashed = hashObject(obj);
	  return  false ? 'rn-anim-' + hashed : 'rn-' + hashed;
	};
	
	var prefixes = ['-webkit-', ''];
	
	var makeBlock = function makeBlock(rule) {
	  var domStyle = (0, _createReactDOMStyle2.default)((0, _i18nStyle2.default)(rule));
	  return (0, _createRuleBlock2.default)(domStyle);
	};
	
	var makeSteps = function makeSteps(keyframes) {
	  return Object.keys(keyframes).map(function (stepName) {
	    var rule = keyframes[stepName];
	    var block = makeBlock(rule);
	    return stepName + '{' + block + '}';
	  }).join('');
	};
	
	var createKeyframesRules = function createKeyframesRules(keyframes) {
	  var identifier = createIdentifier(keyframes);
	  var rules = prefixes.map(function (prefix) {
	    return '@media all {@' + prefix + 'keyframes ' + identifier + '{' + makeSteps(keyframes) + '}}';
	  });
	  return { identifier: identifier, rules: rules };
	};
	
	exports.default = createKeyframesRules;
	module.exports = exports['default'];

/***/ },
/* 1426 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	// Prevent browsers throwing parse errors, e.g., on vendor-prefixed pseudo-elements
	var safeRule = function safeRule(rule) {
	  return '@media all{\n' + rule + '\n}';
	};
	
	var resets = [
	// minimal top-level reset
	'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}', 'body{margin:0;}',
	// minimal form pseudo-element reset
	'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}', 'input::-webkit-inner-spin-button,input::-webkit-outer-spin-button,' + 'input::-webkit-search-cancel-button,input::-webkit-search-decoration,' + 'input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}'];
	
	var reset = [safeRule(resets.join('\n'))];
	
	exports.default = reset;
	module.exports = exports['default'];

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var rule = ':focus { outline: none; }'; /**
	                                         * Adapts focus styles based on the user's active input modality (i.e., how
	                                         * they are interacting with the UI right now).
	                                         *
	                                         * Focus styles are only relevant when using the keyboard to interact with the
	                                         * page. If we only show the focus ring when relevant, we can avoid user
	                                         * confusion without compromising accessibility.
	                                         *
	                                         * The script uses two heuristics to determine whether the keyboard is being used:
	                                         *
	                                         * 1. a keydown event occurred immediately before a focus event;
	                                         * 2. a focus event happened on an element which requires keyboard interaction (e.g., a text field);
	                                         *
	                                         * Based on https://github.com/WICG/focus-ring
	                                         *
	                                         * @noflow
	                                         */
	
	var ruleExists = false;
	
	var modality = function modality(styleElement) {
	  if (!_ExecutionEnvironment.canUseDOM) {
	    return;
	  }
	
	  var hadKeyboardEvent = false;
	  var keyboardThrottleTimeoutID = 0;
	
	  var proto = window.Element.prototype;
	  var matches = proto.matches || proto.mozMatchesSelector || proto.msMatchesSelector || proto.webkitMatchesSelector;
	
	  // These elements should always have a focus ring drawn, because they are
	  // associated with switching to a keyboard modality.
	  var keyboardModalityWhitelist = ['input:not([type])', 'input[type=text]', 'input[type=search]', 'input[type=url]', 'input[type=tel]', 'input[type=email]', 'input[type=password]', 'input[type=number]', 'input[type=date]', 'input[type=month]', 'input[type=week]', 'input[type=time]', 'input[type=datetime]', 'input[type=datetime-local]', 'textarea', '[role=textbox]'].join(',');
	
	  /**
	   * Computes whether the given element should automatically trigger the
	   * `focus-ring`.
	   */
	  var focusTriggersKeyboardModality = function focusTriggersKeyboardModality(el) {
	    if (matches) {
	      return matches.call(el, keyboardModalityWhitelist) && matches.call(el, ':not([readonly])');
	    } else {
	      return false;
	    }
	  };
	
	  /**
	   * Add the focus ring style
	   */
	  var addFocusRing = function addFocusRing() {
	    if (styleElement && ruleExists) {
	      styleElement.sheet.deleteRule(0);
	      ruleExists = false;
	    }
	  };
	
	  /**
	   * Remove the focus ring style
	   */
	  var removeFocusRing = function removeFocusRing() {
	    if (styleElement && !ruleExists) {
	      styleElement.sheet.insertRule(rule, 0);
	      ruleExists = true;
	    }
	  };
	
	  /**
	   * On `keydown`, set `hadKeyboardEvent`, to be removed 100ms later if there
	   * are no further keyboard events. The 100ms throttle handles cases where
	   * focus is redirected programmatically after a keyboard event, such as
	   * opening a menu or dialog.
	   */
	  var handleKeyDown = function handleKeyDown(e) {
	    hadKeyboardEvent = true;
	    if (keyboardThrottleTimeoutID !== 0) {
	      clearTimeout(keyboardThrottleTimeoutID);
	    }
	    keyboardThrottleTimeoutID = setTimeout(function () {
	      hadKeyboardEvent = false;
	      keyboardThrottleTimeoutID = 0;
	    }, 100);
	  };
	
	  /**
	   * Display the focus-ring when the keyboard was used to focus
	   */
	  var handleFocus = function handleFocus(e) {
	    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
	      addFocusRing();
	    }
	  };
	
	  /**
	   * Remove the focus-ring when the keyboard was used to focus
	   */
	  var handleBlur = function handleBlur() {
	    if (!hadKeyboardEvent) {
	      removeFocusRing();
	    }
	  };
	
	  if (document.body && document.body.addEventListener) {
	    removeFocusRing();
	    document.body.addEventListener('keydown', handleKeyDown, true);
	    document.body.addEventListener('focus', handleFocus, true);
	    document.body.addEventListener('blur', handleBlur, true);
	  }
	};
	
	exports.default = modality;
	module.exports = exports['default'];

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwipeableFlatList = __webpack_require__(1479);
	
	var _SwipeableFlatList2 = _interopRequireDefault(_SwipeableFlatList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableFlatList2.default; /**
	                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                *
	                                                * This source code is licensed under the MIT license found in the
	                                                * LICENSE file in the root directory of this source tree.
	                                                *
	                                                * 
	                                                */
	
	module.exports = exports['default'];

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _SwipeableListView = __webpack_require__(1481);
	
	var _SwipeableListView2 = _interopRequireDefault(_SwipeableListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SwipeableListView2.default; /**
	                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                *
	                                                * This source code is licensed under the MIT license found in the
	                                                * LICENSE file in the root directory of this source tree.
	                                                *
	                                                * 
	                                                */
	
	module.exports = exports['default'];

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _multiplyStyleLengthValue = __webpack_require__(1056);
	
	var _multiplyStyleLengthValue2 = _interopRequireDefault(_multiplyStyleLengthValue);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var emptyObject = {};
	var thumbDefaultBoxShadow = '0px 1px 3px rgba(0,0,0,0.5)';
	var thumbFocusedBoxShadow = thumbDefaultBoxShadow + ', 0 0 0 10px rgba(0,0,0,0.1)';
	
	var Switch = function (_Component) {
	  _inherits(Switch, _Component);
	
	  function Switch() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Switch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleChange = function (event) {
	      var onValueChange = _this.props.onValueChange;
	
	      onValueChange && onValueChange(event.nativeEvent.target.checked);
	    }, _this._handleFocusState = function (event) {
	      var isFocused = event.nativeEvent.type === 'focus';
	      var boxShadow = isFocused ? thumbFocusedBoxShadow : thumbDefaultBoxShadow;
	      if (_this._thumbElement) {
	        _this._thumbElement.setNativeProps({ style: { boxShadow: boxShadow } });
	      }
	    }, _this._setCheckboxRef = function (element) {
	      _this._checkboxElement = element;
	    }, _this._setThumbRef = function (element) {
	      _this._thumbElement = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Switch.prototype.blur = function blur() {
	    _UIManager2.default.blur(this._checkboxElement);
	  };
	
	  Switch.prototype.focus = function focus() {
	    _UIManager2.default.focus(this._checkboxElement);
	  };
	
	  Switch.prototype.render = function render() {
	    var _props = this.props,
	        accessibilityLabel = _props.accessibilityLabel,
	        activeThumbColor = _props.activeThumbColor,
	        activeTrackColor = _props.activeTrackColor,
	        disabled = _props.disabled,
	        onValueChange = _props.onValueChange,
	        style = _props.style,
	        thumbColor = _props.thumbColor,
	        trackColor = _props.trackColor,
	        value = _props.value,
	        onTintColor = _props.onTintColor,
	        thumbTintColor = _props.thumbTintColor,
	        tintColor = _props.tintColor,
	        other = _objectWithoutProperties(_props, ['accessibilityLabel', 'activeThumbColor', 'activeTrackColor', 'disabled', 'onValueChange', 'style', 'thumbColor', 'trackColor', 'value', 'onTintColor', 'thumbTintColor', 'tintColor']);
	
	    var _StyleSheet$flatten = _StyleSheet2.default.flatten(style),
	        styleHeight = _StyleSheet$flatten.height,
	        styleWidth = _StyleSheet$flatten.width;
	
	    var height = styleHeight || 20;
	    var minWidth = (0, _multiplyStyleLengthValue2.default)(height, 2);
	    var width = styleWidth > minWidth ? styleWidth : minWidth;
	    var trackBorderRadius = (0, _multiplyStyleLengthValue2.default)(height, 0.5);
	    var trackCurrentColor = value ? onTintColor || activeTrackColor : tintColor || trackColor;
	    var thumbCurrentColor = value ? activeThumbColor : thumbTintColor || thumbColor;
	    var thumbHeight = height;
	    var thumbWidth = thumbHeight;
	
	    var rootStyle = [styles.root, style, { height: height, width: width }, disabled && styles.cursorDefault];
	
	    var trackStyle = [styles.track, {
	      backgroundColor: trackCurrentColor,
	      borderRadius: trackBorderRadius
	    }, disabled && styles.disabledTrack];
	
	    var thumbStyle = [styles.thumb, {
	      backgroundColor: thumbCurrentColor,
	      height: thumbHeight,
	      width: thumbWidth
	    }, disabled && styles.disabledThumb];
	
	    var nativeControl = (0, _createElement2.default)('input', {
	      accessibilityLabel: accessibilityLabel,
	      checked: value,
	      disabled: disabled,
	      onBlur: this._handleFocusState,
	      onChange: this._handleChange,
	      onFocus: this._handleFocusState,
	      ref: this._setCheckboxRef,
	      style: [styles.nativeControl, styles.cursorInherit],
	      type: 'checkbox'
	    });
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, { style: rootStyle }),
	      _react2.default.createElement(_View2.default, { style: trackStyle }),
	      _react2.default.createElement(_View2.default, {
	        ref: this._setThumbRef,
	        style: [thumbStyle, value && styles.thumbOn, {
	          marginStart: value ? (0, _multiplyStyleLengthValue2.default)(thumbWidth, -1) : 0
	        }]
	      }),
	      nativeControl
	    );
	  };
	
	  return Switch;
	}(_react.Component);
	
	Switch.displayName = 'Switch';
	Switch.defaultProps = {
	  activeThumbColor: '#009688',
	  activeTrackColor: '#A3D3CF',
	  disabled: false,
	  style: emptyObject,
	  thumbColor: '#FAFAFA',
	  trackColor: '#939393',
	  value: false
	};
	Switch.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  activeThumbColor: _ColorPropType2.default,
	  activeTrackColor: _ColorPropType2.default,
	  disabled: _propTypes.bool,
	  onValueChange: _propTypes.func,
	  thumbColor: _ColorPropType2.default,
	  trackColor: _ColorPropType2.default,
	  value: _propTypes.bool,
	
	  /* eslint-disable react/sort-prop-types */
	  // Equivalent of 'activeTrackColor'
	  onTintColor: _ColorPropType2.default,
	  // Equivalent of 'thumbColor'
	  thumbTintColor: _ColorPropType2.default,
	  // Equivalent of 'trackColor'
	  tintColor: _ColorPropType2.default
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    cursor: 'pointer',
	    userSelect: 'none'
	  },
	  cursorDefault: {
	    cursor: 'default'
	  },
	  cursorInherit: {
	    cursor: 'inherit'
	  },
	  track: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '70%',
	    margin: 'auto',
	    transitionDuration: '0.1s',
	    width: '100%'
	  }),
	  disabledTrack: {
	    backgroundColor: '#D5D5D5'
	  },
	  thumb: {
	    alignSelf: 'flex-start',
	    borderRadius: '100%',
	    boxShadow: thumbDefaultBoxShadow,
	    start: '0%',
	    transform: [{ translateZ: 0 }],
	    transitionDuration: '0.1s'
	  },
	  thumbOn: {
	    start: '100%'
	  },
	  disabledThumb: {
	    backgroundColor: '#BDBDBD'
	  },
	  nativeControl: Object.assign({}, _StyleSheet2.default.absoluteFillObject, {
	    height: '100%',
	    margin: 0,
	    opacity: 0,
	    padding: 0,
	    width: '100%'
	  })
	});
	
	exports.default = (0, _applyNativeMethods2.default)(Switch);
	module.exports = exports['default'];

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _applyLayout = __webpack_require__(823);
	
	var _applyLayout2 = _interopRequireDefault(_applyLayout);
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _react = __webpack_require__(1);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _createElement = __webpack_require__(56);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetPropType = __webpack_require__(109);
	
	var _StyleSheetPropType2 = _interopRequireDefault(_StyleSheetPropType);
	
	var _TextInputStylePropTypes = __webpack_require__(1038);
	
	var _TextInputStylePropTypes2 = _interopRequireDefault(_TextInputStylePropTypes);
	
	var _TextInputState = __webpack_require__(822);
	
	var _TextInputState2 = _interopRequireDefault(_TextInputState);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var isAndroid = _ExecutionEnvironment.canUseDOM && /Android/i.test(navigator && navigator.userAgent);
	var emptyObject = {};
	
	/**
	 * React Native events differ from W3C events.
	 */
	var normalizeEventHandler = function normalizeEventHandler(handler) {
	  return function (e) {
	    if (handler) {
	      e.nativeEvent.text = e.target.value;
	      return handler(e);
	    }
	  };
	};
	
	/**
	 * Determines whether a 'selection' prop differs from a node's existing
	 * selection state.
	 */
	var isSelectionStale = function isSelectionStale(node, selection) {
	  if (node && selection) {
	    var selectionEnd = node.selectionEnd,
	        selectionStart = node.selectionStart;
	    var start = selection.start,
	        end = selection.end;
	
	    return start !== selectionStart || end !== selectionEnd;
	  }
	  return false;
	};
	
	/**
	 * Certain input types do no support 'selectSelectionRange' and will throw an
	 * error.
	 */
	var setSelection = function setSelection(node, selection) {
	  try {
	    if (isSelectionStale(node, selection)) {
	      var start = selection.start,
	          end = selection.end;
	      // workaround for Blink on Android: see https://github.com/text-mask/text-mask/issues/300
	
	      if (isAndroid) {
	        setTimeout(function () {
	          return node.setSelectionRange(start, end || start);
	        }, 10);
	      } else {
	        node.setSelectionRange(start, end || start);
	      }
	    }
	  } catch (e) {}
	};
	
	var TextInput = function (_Component) {
	  _inherits(TextInput, _Component);
	
	  function TextInput() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._handleBlur = function (e) {
	      var onBlur = _this.props.onBlur;
	
	      _TextInputState2.default._currentlyFocusedNode = null;
	      if (onBlur) {
	        onBlur(e);
	      }
	    }, _this._handleChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onChangeText = _this$props.onChangeText;
	      var text = e.nativeEvent.text;
	
	      if (onChange) {
	        onChange(e);
	      }
	      if (onChangeText) {
	        onChangeText(text);
	      }
	      _this._handleSelectionChange(e);
	    }, _this._handleFocus = function (e) {
	      var _this$props2 = _this.props,
	          clearTextOnFocus = _this$props2.clearTextOnFocus,
	          onFocus = _this$props2.onFocus,
	          selectTextOnFocus = _this$props2.selectTextOnFocus;
	
	      var node = _this._node;
	      _TextInputState2.default._currentlyFocusedNode = _this._node;
	      if (onFocus) {
	        onFocus(e);
	      }
	      if (clearTextOnFocus) {
	        _this.clear();
	      }
	      if (selectTextOnFocus) {
	        node && node.select();
	      }
	    }, _this._handleKeyDown = function (e) {
	      // Prevent key events bubbling (see #612)
	      e.stopPropagation();
	
	      // Backspace, Tab, Cmd+Enter, and Arrow keys only fire 'keydown' DOM events
	      if (e.which === 8 || e.which === 9 || e.which === 13 && e.metaKey || e.which === 37 || e.which === 38 || e.which === 39 || e.which === 40) {
	        _this._handleKeyPress(e);
	      }
	    }, _this._handleKeyPress = function (e) {
	      var _this$props3 = _this.props,
	          blurOnSubmit = _this$props3.blurOnSubmit,
	          multiline = _this$props3.multiline,
	          onKeyPress = _this$props3.onKeyPress,
	          onSubmitEditing = _this$props3.onSubmitEditing;
	
	      var blurOnSubmitDefault = !multiline;
	      var shouldBlurOnSubmit = blurOnSubmit == null ? blurOnSubmitDefault : blurOnSubmit;
	
	      if (onKeyPress) {
	        var keyValue = void 0;
	        switch (e.which) {
	          case 8:
	            keyValue = 'Backspace';
	            break;
	          case 9:
	            keyValue = 'Tab';
	            break;
	          case 13:
	            keyValue = 'Enter';
	            break;
	          case 32:
	            keyValue = ' ';
	            break;
	          case 37:
	            keyValue = 'ArrowLeft';
	            break;
	          case 38:
	            keyValue = 'ArrowUp';
	            break;
	          case 39:
	            keyValue = 'ArrowRight';
	            break;
	          case 40:
	            keyValue = 'ArrowDown';
	            break;
	          default:
	            {
	              // Trim to only care about the keys that have a textual representation
	              if (e.shiftKey) {
	                keyValue = String.fromCharCode(e.which).trim();
	              } else {
	                keyValue = String.fromCharCode(e.which).toLowerCase().trim();
	              }
	            }
	        }
	
	        if (keyValue) {
	          e.nativeEvent = {
	            altKey: e.altKey,
	            ctrlKey: e.ctrlKey,
	            key: keyValue,
	            metaKey: e.metaKey,
	            shiftKey: e.shiftKey,
	            target: e.target
	          };
	          onKeyPress(e);
	        }
	      }
	
	      if (!e.isDefaultPrevented() && e.which === 13 && !e.shiftKey) {
	        if ((blurOnSubmit || !multiline) && onSubmitEditing) {
	          // prevent "Enter" from inserting a newline
	          e.preventDefault();
	          e.nativeEvent = { target: e.target, text: e.target.value };
	          onSubmitEditing(e);
	        }
	        if (shouldBlurOnSubmit) {
	          _this.blur();
	        }
	      }
	    }, _this._handleSelectionChange = function (e) {
	      var _this$props4 = _this.props,
	          onSelectionChange = _this$props4.onSelectionChange,
	          _this$props4$selectio = _this$props4.selection,
	          selection = _this$props4$selectio === undefined ? emptyObject : _this$props4$selectio;
	
	      if (onSelectionChange) {
	        try {
	          var node = e.target;
	          if (isSelectionStale(node, selection)) {
	            var selectionStart = node.selectionStart,
	                selectionEnd = node.selectionEnd;
	
	            e.nativeEvent.selection = {
	              start: selectionStart,
	              end: selectionEnd
	            };
	            onSelectionChange(e);
	          }
	        } catch (e) {}
	      }
	    }, _this._setNode = function (component) {
	      _this._node = (0, _findNodeHandle2.default)(component);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TextInput.prototype.clear = function clear() {
	    this._node.value = '';
	  };
	
	  TextInput.prototype.isFocused = function isFocused() {
	    return _TextInputState2.default.currentlyFocusedField() === this._node;
	  };
	
	  TextInput.prototype.componentDidMount = function componentDidMount() {
	    setSelection(this._node, this.props.selection);
	    if (document.activeElement === this._node) {
	      _TextInputState2.default._currentlyFocusedNode = this._node;
	    }
	  };
	
	  TextInput.prototype.componentDidUpdate = function componentDidUpdate() {
	    setSelection(this._node, this.props.selection);
	  };
	
	  TextInput.prototype.render = function render() {
	    var _props = this.props,
	        autoCorrect = _props.autoCorrect,
	        editable = _props.editable,
	        keyboardType = _props.keyboardType,
	        multiline = _props.multiline,
	        numberOfLines = _props.numberOfLines,
	        secureTextEntry = _props.secureTextEntry,
	        style = _props.style,
	        blurOnSubmit = _props.blurOnSubmit,
	        clearTextOnFocus = _props.clearTextOnFocus,
	        onChangeText = _props.onChangeText,
	        onLayout = _props.onLayout,
	        onSelectionChange = _props.onSelectionChange,
	        onSubmitEditing = _props.onSubmitEditing,
	        selection = _props.selection,
	        selectTextOnFocus = _props.selectTextOnFocus,
	        spellCheck = _props.spellCheck,
	        accessibilityViewIsModal = _props.accessibilityViewIsModal,
	        allowFontScaling = _props.allowFontScaling,
	        caretHidden = _props.caretHidden,
	        clearButtonMode = _props.clearButtonMode,
	        dataDetectorTypes = _props.dataDetectorTypes,
	        disableFullscreenUI = _props.disableFullscreenUI,
	        enablesReturnKeyAutomatically = _props.enablesReturnKeyAutomatically,
	        hitSlop = _props.hitSlop,
	        inlineImageLeft = _props.inlineImageLeft,
	        inlineImagePadding = _props.inlineImagePadding,
	        inputAccessoryViewID = _props.inputAccessoryViewID,
	        keyboardAppearance = _props.keyboardAppearance,
	        needsOffscreenAlphaCompositing = _props.needsOffscreenAlphaCompositing,
	        onAccessibilityTap = _props.onAccessibilityTap,
	        onContentSizeChange = _props.onContentSizeChange,
	        onEndEditing = _props.onEndEditing,
	        onMagicTap = _props.onMagicTap,
	        onScroll = _props.onScroll,
	        removeClippedSubviews = _props.removeClippedSubviews,
	        renderToHardwareTextureAndroid = _props.renderToHardwareTextureAndroid,
	        returnKeyLabel = _props.returnKeyLabel,
	        returnKeyType = _props.returnKeyType,
	        scrollEnabled = _props.scrollEnabled,
	        selectionColor = _props.selectionColor,
	        selectionState = _props.selectionState,
	        shouldRasterizeIOS = _props.shouldRasterizeIOS,
	        textBreakStrategy = _props.textBreakStrategy,
	        textContentType = _props.textContentType,
	        underlineColorAndroid = _props.underlineColorAndroid,
	        otherProps = _objectWithoutProperties(_props, ['autoCorrect', 'editable', 'keyboardType', 'multiline', 'numberOfLines', 'secureTextEntry', 'style', 'blurOnSubmit', 'clearTextOnFocus', 'onChangeText', 'onLayout', 'onSelectionChange', 'onSubmitEditing', 'selection', 'selectTextOnFocus', 'spellCheck', 'accessibilityViewIsModal', 'allowFontScaling', 'caretHidden', 'clearButtonMode', 'dataDetectorTypes', 'disableFullscreenUI', 'enablesReturnKeyAutomatically', 'hitSlop', 'inlineImageLeft', 'inlineImagePadding', 'inputAccessoryViewID', 'keyboardAppearance', 'needsOffscreenAlphaCompositing', 'onAccessibilityTap', 'onContentSizeChange', 'onEndEditing', 'onMagicTap', 'onScroll', 'removeClippedSubviews', 'renderToHardwareTextureAndroid', 'returnKeyLabel', 'returnKeyType', 'scrollEnabled', 'selectionColor', 'selectionState', 'shouldRasterizeIOS', 'textBreakStrategy', 'textContentType', 'underlineColorAndroid']);
	
	    var type = void 0;
	
	    switch (keyboardType) {
	      case 'email-address':
	        type = 'email';
	        break;
	      case 'number-pad':
	      case 'numeric':
	        type = 'number';
	        break;
	      case 'phone-pad':
	        type = 'tel';
	        break;
	      case 'search':
	      case 'web-search':
	        type = 'search';
	        break;
	      case 'url':
	        type = 'url';
	        break;
	      default:
	        type = 'text';
	    }
	
	    if (secureTextEntry) {
	      type = 'password';
	    }
	
	    var component = multiline ? 'textarea' : 'input';
	
	    Object.assign(otherProps, {
	      autoCorrect: autoCorrect ? 'on' : 'off',
	      dir: 'auto',
	      onBlur: normalizeEventHandler(this._handleBlur),
	      onChange: normalizeEventHandler(this._handleChange),
	      onFocus: normalizeEventHandler(this._handleFocus),
	      onKeyDown: this._handleKeyDown,
	      onKeyPress: this._handleKeyPress,
	      onSelect: normalizeEventHandler(this._handleSelectionChange),
	      readOnly: !editable,
	      ref: this._setNode,
	      spellCheck: spellCheck != null ? spellCheck : autoCorrect,
	      style: [styles.initial, style]
	    });
	
	    if (multiline) {
	      otherProps.rows = numberOfLines;
	    } else {
	      otherProps.type = type;
	    }
	
	    return (0, _createElement2.default)(component, otherProps);
	  };
	
	  return TextInput;
	}(_react.Component);
	
	TextInput.displayName = 'TextInput';
	TextInput.defaultProps = {
	  autoCapitalize: 'sentences',
	  autoComplete: 'on',
	  autoCorrect: true,
	  editable: true,
	  keyboardType: 'default',
	  multiline: false,
	  numberOfLines: 1,
	  secureTextEntry: false,
	  style: emptyObject
	};
	TextInput.State = _TextInputState2.default;
	TextInput.propTypes =  false ? Object.assign({}, _ViewPropTypes2.default, {
	  autoCapitalize: (0, _propTypes.oneOf)(['characters', 'none', 'sentences', 'words']),
	  autoComplete: _propTypes.string,
	  autoCorrect: _propTypes.bool,
	  autoFocus: _propTypes.bool,
	  blurOnSubmit: _propTypes.bool,
	  clearTextOnFocus: _propTypes.bool,
	  defaultValue: _propTypes.string,
	  editable: _propTypes.bool,
	  inputAccessoryViewID: _propTypes.string,
	  keyboardType: (0, _propTypes.oneOf)(['default', 'email-address', 'number-pad', 'numbers-and-punctuation', 'numeric', 'phone-pad', 'search', 'url', 'web-search']),
	  maxLength: _propTypes.number,
	  multiline: _propTypes.bool,
	  numberOfLines: _propTypes.number,
	  onBlur: _propTypes.func,
	  onChange: _propTypes.func,
	  onChangeText: _propTypes.func,
	  onFocus: _propTypes.func,
	  onKeyPress: _propTypes.func,
	  onSelectionChange: _propTypes.func,
	  onSubmitEditing: _propTypes.func,
	  placeholder: _propTypes.string,
	  placeholderTextColor: _ColorPropType2.default,
	  secureTextEntry: _propTypes.bool,
	  selectTextOnFocus: _propTypes.bool,
	  selection: (0, _propTypes.shape)({
	    start: _propTypes.number.isRequired,
	    end: _propTypes.number
	  }),
	  spellCheck: _propTypes.bool,
	  style: (0, _StyleSheetPropType2.default)(_TextInputStylePropTypes2.default),
	  value: _propTypes.string,
	  /* react-native compat */
	  /* eslint-disable */
	  caretHidden: _propTypes.bool,
	  clearButtonMode: _propTypes.string,
	  dataDetectorTypes: _propTypes.string,
	  disableFullscreenUI: _propTypes.bool,
	  enablesReturnKeyAutomatically: _propTypes.bool,
	  keyboardAppearance: _propTypes.string,
	  inlineImageLeft: _propTypes.string,
	  inlineImagePadding: _propTypes.number,
	  onContentSizeChange: _propTypes.func,
	  onEndEditing: _propTypes.func,
	  onScroll: _propTypes.func,
	  returnKeyLabel: _propTypes.string,
	  returnKeyType: _propTypes.string,
	  selectionColor: _ColorPropType2.default,
	  selectionState: _propTypes.any,
	  textBreakStrategy: _propTypes.string,
	  underlineColorAndroid: _ColorPropType2.default
	  /* eslint-enable */
	}) : {};
	
	
	var styles = _StyleSheet2.default.create({
	  initial: {
	    MozAppearance: 'textfield',
	    WebkitAppearance: 'none',
	    backgroundColor: 'transparent',
	    borderColor: 'black',
	    borderRadius: 0,
	    borderStyle: 'solid',
	    borderWidth: 0,
	    boxSizing: 'border-box',
	    fontFamily: 'System',
	    fontSize: 14,
	    padding: 0,
	    resize: 'none'
	  }
	});
	
	exports.default = (0, _applyLayout2.default)((0, _applyNativeMethods2.default)(TextInput));
	module.exports = exports['default'];

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TextPropTypes = __webpack_require__(816);
	
	var _TextPropTypes2 = _interopRequireDefault(_TextPropTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextPropTypes2.default;
	module.exports = exports['default'];

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(1067);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler;
	
	/**
	 * PooledClass representing the bounding rectangle of a region.
	 */
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function BoundingDimensions(width, height) {
	  this.width = width;
	  this.height = height;
	}
	
	BoundingDimensions.prototype.destructor = function () {
	  this.width = null;
	  this.height = null;
	};
	
	BoundingDimensions.getPooledFromElement = function (element) {
	  return BoundingDimensions.getPooled(element.offsetWidth, element.offsetHeight);
	};
	
	_PooledClass2.default.addPoolingTo(BoundingDimensions, twoArgumentPooler);
	
	exports.default = BoundingDimensions;
	module.exports = exports['default'];

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PooledClass = __webpack_require__(1067);
	
	var _PooledClass2 = _interopRequireDefault(_PooledClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var twoArgumentPooler = _PooledClass2.default.twoArgumentPooler; /**
	                                                                  * Copyright (c) 2015-present, Facebook, Inc.
	                                                                  *
	                                                                  * This source code is licensed under the MIT license found in the
	                                                                  * LICENSE file in the root directory of this source tree.
	                                                                  *
	                                                                  * @noflow
	                                                                  */
	
	function Position(left, top) {
	  this.left = left;
	  this.top = top;
	}
	
	Position.prototype.destructor = function () {
	  this.left = null;
	  this.top = null;
	};
	
	_PooledClass2.default.addPoolingTo(Position, twoArgumentPooler);
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _applyNativeMethods = __webpack_require__(45);
	
	var _applyNativeMethods2 = _interopRequireDefault(_applyNativeMethods);
	
	var _ColorPropType = __webpack_require__(34);
	
	var _ColorPropType2 = _interopRequireDefault(_ColorPropType);
	
	var _createReactClass = __webpack_require__(5);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _ensureComponentIsNative = __webpack_require__(1055);
	
	var _ensureComponentIsNative2 = _interopRequireDefault(_ensureComponentIsNative);
	
	var _ensurePositiveDelayProps = __webpack_require__(819);
	
	var _ensurePositiveDelayProps2 = _interopRequireDefault(_ensurePositiveDelayProps);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _reactTimerMixin = __webpack_require__(128);
	
	var _reactTimerMixin2 = _interopRequireDefault(_reactTimerMixin);
	
	var _Touchable = __webpack_require__(127);
	
	var _Touchable2 = _interopRequireDefault(_Touchable);
	
	var _TouchableWithoutFeedback = __webpack_require__(820);
	
	var _TouchableWithoutFeedback2 = _interopRequireDefault(_TouchableWithoutFeedback);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _ViewPropTypes = __webpack_require__(35);
	
	var _ViewPropTypes2 = _interopRequireDefault(_ViewPropTypes);
	
	var _propTypes = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                              * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                              * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * @noflow
	                                                                                                                                                                                                                              */
	
	var DEFAULT_PROPS = {
	  activeOpacity: 0.85,
	  underlayColor: 'black'
	};
	
	var PRESS_RETENTION_OFFSET = { top: 20, left: 20, right: 20, bottom: 30 };
	
	/**
	 * A wrapper for making views respond properly to touches.
	 * On press down, the opacity of the wrapped view is decreased, which allows
	 * the underlay color to show through, darkening or tinting the view.
	 *
	 * The underlay comes from wrapping the child in a new View, which can affect
	 * layout, and sometimes cause unwanted visual artifacts if not used correctly,
	 * for example if the backgroundColor of the wrapped view isn't explicitly set
	 * to an opaque color.
	 *
	 * TouchableHighlight must have one child (not zero or more than one).
	 * If you wish to have several child components, wrap them in a View.
	 *
	 * Example:
	 *
	 * ```
	 * renderButton: function() {
	 *   return (
	 *     <TouchableHighlight onPress={this._onPressButton}>
	 *       <Image
	 *         style={styles.button}
	 *         source={require('./myButton.png')}
	 *       />
	 *     </TouchableHighlight>
	 *   );
	 * },
	 * ```
	 */
	
	/* eslint-disable react/prefer-es6-class */
	var TouchableHighlight = (0, _createReactClass2.default)({
	  displayName: 'TouchableHighlight',
	  propTypes: Object.assign({}, _TouchableWithoutFeedback2.default.propTypes, {
	    /**
	     * Determines what the opacity of the wrapped view should be when touch is
	     * active.
	     */
	    activeOpacity: _propTypes.number,
	    /**
	     * Called immediately after the underlay is hidden
	     */
	    onHideUnderlay: _propTypes.func,
	    /**
	     * Called immediately after the underlay is shown
	     */
	    onShowUnderlay: _propTypes.func,
	    style: _ViewPropTypes2.default.style,
	    /**
	     * The color of the underlay that will show through when the touch is
	     * active.
	     */
	    underlayColor: _ColorPropType2.default
	  }),
	
	  mixins: [_reactTimerMixin2.default, _Touchable2.default.Mixin],
	
	  getDefaultProps: function getDefaultProps() {
	    return DEFAULT_PROPS;
	  },
	
	  // Performance optimization to avoid constantly re-generating these objects.
	  _computeSyntheticState: function _computeSyntheticState(props) {
	    return {
	      activeProps: {
	        style: {
	          opacity: props.activeOpacity
	        }
	      },
	      activeUnderlayProps: {
	        style: {
	          backgroundColor: props.underlayColor
	        }
	      },
	      underlayStyle: [INACTIVE_UNDERLAY_PROPS.style, props.style]
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    this._isMounted = false;
	    return Object.assign({}, this.touchableGetInitialState(), this._computeSyntheticState(this.props));
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._isMounted = true;
	    (0, _ensurePositiveDelayProps2.default)(this.props);
	    (0, _ensureComponentIsNative2.default)(this._childRef);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._isMounted = false;
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    (0, _ensureComponentIsNative2.default)(this._childRef);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    (0, _ensurePositiveDelayProps2.default)(nextProps);
	    if (nextProps.activeOpacity !== this.props.activeOpacity || nextProps.underlayColor !== this.props.underlayColor || nextProps.style !== this.props.style) {
	      this.setState(this._computeSyntheticState(nextProps));
	    }
	  },
	
	  /**
	   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
	   * defined on your component.
	   */
	  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
	    this.clearTimeout(this._hideTimeout);
	    this._hideTimeout = null;
	    this._showUnderlay();
	    this.props.onPressIn && this.props.onPressIn(e);
	  },
	
	  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
	    if (!this._hideTimeout) {
	      this._hideUnderlay();
	    }
	    this.props.onPressOut && this.props.onPressOut(e);
	  },
	
	  touchableHandlePress: function touchableHandlePress(e) {
	    this.clearTimeout(this._hideTimeout);
	    this._showUnderlay();
	    this._hideTimeout = this.setTimeout(this._hideUnderlay, this.props.delayPressOut || 100);
	    this.props.onPress && this.props.onPress(e);
	  },
	
	  touchableHandleLongPress: function touchableHandleLongPress(e) {
	    this.props.onLongPress && this.props.onLongPress(e);
	  },
	
	  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
	    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
	  },
	
	  touchableGetHitSlop: function touchableGetHitSlop() {
	    return this.props.hitSlop;
	  },
	
	  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
	    return this.props.delayPressIn;
	  },
	
	  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
	    return this.props.delayLongPress;
	  },
	
	  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
	    return this.props.delayPressOut;
	  },
	
	  _showUnderlay: function _showUnderlay() {
	    if (!this._isMounted || !this._hasPressHandler()) {
	      return;
	    }
	
	    this._underlayRef.setNativeProps(this.state.activeUnderlayProps);
	    this._childRef.setNativeProps(this.state.activeProps);
	    this.props.onShowUnderlay && this.props.onShowUnderlay();
	  },
	
	  _hideUnderlay: function _hideUnderlay() {
	    this.clearTimeout(this._hideTimeout);
	    this._hideTimeout = null;
	    if (this._hasPressHandler() && this._underlayRef) {
	      this._childRef.setNativeProps(INACTIVE_CHILD_PROPS);
	      this._underlayRef.setNativeProps(Object.assign({}, INACTIVE_UNDERLAY_PROPS, {
	        style: this.state.underlayStyle
	      }));
	      this.props.onHideUnderlay && this.props.onHideUnderlay();
	    }
	  },
	
	  _hasPressHandler: function _hasPressHandler() {
	    return !!(this.props.onPress || this.props.onPressIn || this.props.onPressOut || this.props.onLongPress);
	  },
	
	  _setChildRef: function _setChildRef(node) {
	    this._childRef = node;
	  },
	  _setUnderlayRef: function _setUnderlayRef(node) {
	    this._underlayRef = node;
	  },
	
	
	  render: function render() {
	    var _props = this.props,
	        activeOpacity = _props.activeOpacity,
	        onHideUnderlay = _props.onHideUnderlay,
	        onShowUnderlay = _props.onShowUnderlay,
	        underlayColor = _props.underlayColor,
	        delayLongPress = _props.delayLongPress,
	        delayPressIn = _props.delayPressIn,
	        delayPressOut = _props.delayPressOut,
	        onLongPress = _props.onLongPress,
	        onPress = _props.onPress,
	        onPressIn = _props.onPressIn,
	        onPressOut = _props.onPressOut,
	        pressRetentionOffset = _props.pressRetentionOffset,
	        other = _objectWithoutProperties(_props, ['activeOpacity', 'onHideUnderlay', 'onShowUnderlay', 'underlayColor', 'delayLongPress', 'delayPressIn', 'delayPressOut', 'onLongPress', 'onPress', 'onPressIn', 'onPressOut', 'pressRetentionOffset']);
	
	    return _react2.default.createElement(
	      _View2.default,
	      _extends({}, other, {
	        accessible: this.props.accessible !== false,
	        onKeyDown: this.touchableHandleKeyEvent,
	        onKeyUp: this.touchableHandleKeyEvent,
	        onResponderGrant: this.touchableHandleResponderGrant,
	        onResponderMove: this.touchableHandleResponderMove,
	        onResponderRelease: this.touchableHandleResponderRelease,
	        onResponderTerminate: this.touchableHandleResponderTerminate,
	        onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
	        onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
	        ref: this._setUnderlayRef,
	        style: [styles.root, !this.props.disabled && styles.actionable, this.state.underlayStyle]
	      }),
	      _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
	        ref: this._setChildRef
	      }),
	      _Touchable2.default.renderDebugView({ color: 'green', hitSlop: this.props.hitSlop })
	    );
	  }
	});
	
	var INACTIVE_CHILD_PROPS = {
	  style: _StyleSheet2.default.create({ x: { opacity: 1.0 } }).x
	};
	var INACTIVE_UNDERLAY_PROPS = {
	  style: _StyleSheet2.default.create({ x: { backgroundColor: 'transparent' } }).x
	};
	
	var styles = _StyleSheet2.default.create({
	  root: {
	    userSelect: 'none'
	  },
	  actionable: {
	    cursor: 'pointer',
	    touchAction: 'manipulation'
	  }
	});
	
	exports.default = (0, _applyNativeMethods2.default)(TouchableHighlight);
	module.exports = exports['default'];

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _UnimplementedView2.default; /**
	                                                * Copyright 2017-present, Nicolas Gallagher
	                                                *
	                                                * This source code is licensed under the MIT license found in the
	                                                * LICENSE file in the root directory of this source tree.
	                                                *
	                                                * 
	                                                */
	
	module.exports = exports['default'];

/***/ },
/* 1437 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	
	var _vibrate = function _vibrate(pattern) {
	  if ('vibrate' in window.navigator) {
	    window.navigator.vibrate(pattern);
	  }
	}; /**
	    * Copyright (c) 2016-present, Nicolas Gallagher.
	    * Copyright (c) 2015-present, Facebook, Inc.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	var Vibration = {
	  cancel: function cancel() {
	    _vibrate(0);
	  },
	  vibrate: function vibrate() {
	    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;
	
	    _vibrate(pattern);
	  }
	};
	
	exports.default = Vibration;
	module.exports = exports['default'];

/***/ },
/* 1438 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var whitelist = {
	  accessibilityComponentType: true,
	  accessibilityLabel: true,
	  accessibilityLiveRegion: true,
	  accessibilityRole: true,
	  accessibilityTraits: true,
	  accessible: true,
	  children: true,
	  disabled: true,
	  importantForAccessibility: true,
	  onBlur: true,
	  onContextMenu: true,
	  onFocus: true,
	  onMoveShouldSetResponder: true,
	  onMoveShouldSetResponderCapture: true,
	  onResponderEnd: true,
	  onResponderGrant: true,
	  onResponderMove: true,
	  onResponderReject: true,
	  onResponderRelease: true,
	  onResponderStart: true,
	  onResponderTerminate: true,
	  onResponderTerminationRequest: true,
	  onScrollShouldSetResponder: true,
	  onScrollShouldSetResponderCapture: true,
	  onSelectionChangeShouldSetResponder: true,
	  onSelectionChangeShouldSetResponderCapture: true,
	  onStartShouldSetResponder: true,
	  onStartShouldSetResponderCapture: true,
	  onTouchCancel: true,
	  onTouchCancelCapture: true,
	  onTouchEnd: true,
	  onTouchEndCapture: true,
	  onTouchMove: true,
	  onTouchMoveCapture: true,
	  onTouchStart: true,
	  onTouchStartCapture: true,
	  pointerEvents: true,
	  style: true,
	  testID: true,
	  /* @platform web */
	  onScroll: true,
	  onWheel: true,
	  // keyboard events
	  onKeyDown: true,
	  onKeyPress: true,
	  onKeyUp: true,
	  // mouse events (e.g, hover effects)
	  onMouseDown: true,
	  onMouseEnter: true,
	  onMouseLeave: true,
	  onMouseMove: true,
	  onMouseOver: true,
	  onMouseOut: true,
	  onMouseUp: true,
	  // unstable escape-hatches for web
	  className: true,
	  href: true,
	  onClick: true,
	  onClickCapture: true,
	  rel: true,
	  target: true
	};
	
	var filterSupportedProps = function filterSupportedProps(props) {
	  var safeProps = {};
	  for (var prop in props) {
	    if (props.hasOwnProperty(prop)) {
	      if (whitelist[prop] || prop.indexOf('aria-') === 0 || prop.indexOf('data-') === 0) {
	        safeProps[prop] = props[prop];
	      }
	    }
	  }
	  return safeProps;
	};
	
	exports.default = filterSupportedProps;
	module.exports = exports['default'];

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _VirtualizedList = __webpack_require__(829);
	
	var _VirtualizedList2 = _interopRequireDefault(_VirtualizedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _VirtualizedList2.default; /**
	                                              * Copyright (c) 2016-present, Nicolas Gallagher.
	                                              *
	                                              * This source code is licensed under the MIT license found in the
	                                              * LICENSE file in the root directory of this source tree.
	                                              *
	                                              * 
	                                              */
	
	module.exports = exports['default'];

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2016-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var YellowBox = function (_React$Component) {
	  _inherits(YellowBox, _React$Component);
	
	  function YellowBox() {
	    _classCallCheck(this, YellowBox);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  YellowBox.ignoreWarnings = function ignoreWarnings() {};
	
	  YellowBox.prototype.render = function render() {
	    return _react2.default.createElement(_UnimplementedView2.default, this.props);
	  };
	
	  return YellowBox;
	}(_react2.default.Component);
	
	exports.default = YellowBox;
	module.exports = exports['default'];

/***/ },
/* 1441 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var buttonLikeRoles = {
	  // ARIA button behaves like native 'button' element
	  button: true,
	  // ARIA menuitem responds to Enter/Space like a button. Spec requires AT to
	  // ignore ARIA roles of any children.
	  // https://www.w3.org/WAI/GL/wiki/Using_ARIA_menus
	  menuitem: true
	};
	
	exports.default = buttonLikeRoles;
	module.exports = exports["default"];

/***/ },
/* 1442 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2017-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isDisabled = function isDisabled(props) {
	  return props.disabled || props['aria-disabled'];
	};
	
	exports.default = isDisabled;
	module.exports = exports['default'];

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propsToAriaRole = __webpack_require__(1044);
	
	var _propsToAriaRole2 = _interopRequireDefault(_propsToAriaRole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var roleComponents = {
	  article: 'article',
	  banner: 'header',
	  complementary: 'aside',
	  contentinfo: 'footer',
	  form: 'form',
	  label: 'label',
	  link: 'a',
	  list: 'ul',
	  listitem: 'li',
	  main: 'main',
	  navigation: 'nav',
	  region: 'section'
	}; /**
	    * Copyright (c) 2017-present, Nicolas Gallagher.
	    *
	    * This source code is licensed under the MIT license found in the
	    * LICENSE file in the root directory of this source tree.
	    *
	    * 
	    */
	
	var emptyObject = {};
	
	var propsToAccessibilityComponent = function propsToAccessibilityComponent() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject;
	
	  var role = (0, _propsToAriaRole2.default)(props);
	  if (role) {
	    if (role === 'heading') {
	      var level = props['aria-level'] || 1;
	      return 'h' + level;
	    }
	    return roleComponents[role];
	  }
	};
	
	exports.default = propsToAccessibilityComponent;
	module.exports = exports['default'];

/***/ },
/* 1444 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.registerAsset = registerAsset;
	exports.getAssetByID = getAssetByID;
	
	
	var assets = []; /**
	                  * Copyright (c) 2015-present, Facebook, Inc.
	                  *
	                  * This source code is licensed under the MIT license found in the
	                  * LICENSE file in the root directory of this source tree.
	                  *
	                  * 
	                  */
	
	function registerAsset(asset) {
	  // `push` returns new array length, so the first asset will
	  // get id 1 (not 0) to make the value truthy
	  return assets.push(asset);
	}
	
	function getAssetByID(assetId) {
	  return assets[assetId - 1];
	}

/***/ },
/* 1445 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 */
	
	var id = 0;
	var requests = {};
	
	var ImageLoader = {
	  abort: function abort(requestId) {
	    var image = requests['' + requestId];
	    if (image) {
	      image.onerror = image.onload = image = null;
	      delete requests['' + requestId];
	    }
	  },
	  getSize: function getSize(uri, success, failure) {
	    var complete = false;
	    var interval = setInterval(callback, 16);
	    var requestId = ImageLoader.load(uri, callback, errorCallback);
	
	    function callback() {
	      var image = requests['' + requestId];
	      if (image) {
	        var naturalHeight = image.naturalHeight,
	            naturalWidth = image.naturalWidth;
	
	        if (naturalHeight && naturalWidth) {
	          success(naturalWidth, naturalHeight);
	          complete = true;
	        }
	      }
	      if (complete) {
	        ImageLoader.abort(requestId);
	        clearInterval(interval);
	      }
	    }
	
	    function errorCallback() {
	      if (typeof failure === 'function') {
	        failure();
	      }
	      ImageLoader.abort(requestId);
	      clearInterval(interval);
	    }
	  },
	  load: function load(uri, onLoad, onError) {
	    id += 1;
	    var image = new window.Image();
	    image.onerror = onError;
	    image.onload = function (e) {
	      // avoid blocking the main thread
	      var onDecode = function onDecode() {
	        return onLoad(e);
	      };
	      if (typeof image.decode === 'function') {
	        // Safari currently throws exceptions when decoding svgs.
	        // We want to catch that error and allow the load handler
	        // to be forwarded to the onLoad handler in this case
	        image.decode().then(onDecode, onDecode);
	      } else {
	        setTimeout(onDecode, 0);
	      }
	    };
	    image.src = uri;
	    requests['' + id] = image;
	    return id;
	  },
	  prefetch: function prefetch(uri) {
	    return new Promise(function (resolve, reject) {
	      ImageLoader.load(uri, resolve, reject);
	    });
	  }
	};
	
	exports.default = ImageLoader;
	module.exports = exports['default'];

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createDOMProps = __webpack_require__(1053);
	
	var _createDOMProps2 = _interopRequireDefault(_createDOMProps);
	
	var _findNodeHandle = __webpack_require__(44);
	
	var _findNodeHandle2 = _interopRequireDefault(_findNodeHandle);
	
	var _styleResolver = __webpack_require__(815);
	
	var _styleResolver2 = _interopRequireDefault(_styleResolver);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2016-present, Nicolas Gallagher.
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var NativeMethodsMixin = {
	  /**
	   * Removes focus from an input or view. This is the opposite of `focus()`.
	   */
	  blur: function blur() {
	    _UIManager2.default.blur((0, _findNodeHandle2.default)(this));
	  },
	
	
	  /**
	   * Requests focus for the given input or view.
	   * The exact behavior triggered will depend the type of view.
	   */
	  focus: function focus() {
	    _UIManager2.default.focus((0, _findNodeHandle2.default)(this));
	  },
	
	
	  /**
	   * Determines the position and dimensions of the view
	   */
	  measure: function measure(callback) {
	    _UIManager2.default.measure((0, _findNodeHandle2.default)(this), callback);
	  },
	
	
	  /**
	   * Determines the location of the given view in the window and returns the
	   * values via an async callback. If the React root view is embedded in
	   * another native view, this will give you the absolute coordinates. If
	   * successful, the callback will be called be called with the following
	   * arguments:
	   *
	   *  - x
	   *  - y
	   *  - width
	   *  - height
	   *
	   * Note that these measurements are not available until after the rendering
	   * has been completed.
	   */
	  measureInWindow: function measureInWindow(callback) {
	    _UIManager2.default.measureInWindow((0, _findNodeHandle2.default)(this), callback);
	  },
	
	
	  /**
	   * Measures the view relative to another view (usually an ancestor)
	   */
	  measureLayout: function measureLayout(relativeToNativeNode, onSuccess, onFail) {
	    _UIManager2.default.measureLayout((0, _findNodeHandle2.default)(this), relativeToNativeNode, onFail, onSuccess);
	  },
	
	
	  /**
	   * This function sends props straight to the underlying DOM node.
	   * This works as if all styles were set as inline styles. Since a DOM node
	   * may aleady be styled with class names and inline styles, we need to get
	   * the initial styles from the DOM node and merge them with incoming props.
	   */
	  setNativeProps: function setNativeProps(nativeProps) {
	    if (!nativeProps) {
	      return;
	    }
	    var node = (0, _findNodeHandle2.default)(this);
	    if (node) {
	      // Next state is determined by comparison to existing state (in the DOM).
	      // Existing state has already gone through i18n transform
	      var domProps = (0, _createDOMProps2.default)(null, nativeProps, function (style) {
	        return _styleResolver2.default.resolveWithNode(style, node);
	      });
	      _UIManager2.default.updateView(node, domProps, this);
	    }
	  }
	};
	
	exports.default = NativeMethodsMixin;
	module.exports = exports['default'];

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _normalizeNativeEvent = __webpack_require__(1057);
	
	var _normalizeNativeEvent2 = _interopRequireDefault(_normalizeNativeEvent);
	
	var _unstableNativeDependencies = __webpack_require__(993);
	
	var _unstableNativeDependencies2 = _interopRequireDefault(_unstableNativeDependencies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// based on https://github.com/facebook/react/pull/4303/files
	
	var ResponderEventPlugin = _unstableNativeDependencies2.default.ResponderEventPlugin,
	    ResponderTouchHistoryStore = _unstableNativeDependencies2.default.ResponderTouchHistoryStore;
	
	// On older versions of React (< 16.4) we have to inject the dependencies in
	// order for the plugin to work properly in the browser. This version still
	// uses `top*` strings to identify the internal event names.
	// https://github.com/facebook/react/pull/12629
	
	if (!ResponderEventPlugin.eventTypes.responderMove.dependencies) {
	  var topMouseDown = 'topMouseDown';
	  var topMouseMove = 'topMouseMove';
	  var topMouseUp = 'topMouseUp';
	  var topScroll = 'topScroll';
	  var topSelectionChange = 'topSelectionChange';
	  var topTouchCancel = 'topTouchCancel';
	  var topTouchEnd = 'topTouchEnd';
	  var topTouchMove = 'topTouchMove';
	  var topTouchStart = 'topTouchStart';
	
	  var endDependencies = [topTouchCancel, topTouchEnd, topMouseUp];
	  var moveDependencies = [topTouchMove, topMouseMove];
	  var startDependencies = [topTouchStart, topMouseDown];
	
	  /**
	   * Setup ResponderEventPlugin dependencies
	   */
	  ResponderEventPlugin.eventTypes.responderMove.dependencies = moveDependencies;
	  ResponderEventPlugin.eventTypes.responderEnd.dependencies = endDependencies;
	  ResponderEventPlugin.eventTypes.responderStart.dependencies = startDependencies;
	  ResponderEventPlugin.eventTypes.responderRelease.dependencies = endDependencies;
	  ResponderEventPlugin.eventTypes.responderTerminationRequest.dependencies = [];
	  ResponderEventPlugin.eventTypes.responderGrant.dependencies = [];
	  ResponderEventPlugin.eventTypes.responderReject.dependencies = [];
	  ResponderEventPlugin.eventTypes.responderTerminate.dependencies = [];
	  ResponderEventPlugin.eventTypes.moveShouldSetResponder.dependencies = moveDependencies;
	  ResponderEventPlugin.eventTypes.selectionChangeShouldSetResponder.dependencies = [topSelectionChange];
	  ResponderEventPlugin.eventTypes.scrollShouldSetResponder.dependencies = [topScroll];
	  ResponderEventPlugin.eventTypes.startShouldSetResponder.dependencies = startDependencies;
	}
	
	var lastActiveTouchTimestamp = null;
	// The length of time after a touch that we ignore the browser's emulated mouse events
	// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Using_Touch_Events
	var EMULATED_MOUSE_THERSHOLD_MS = 1000;
	
	var originalExtractEvents = ResponderEventPlugin.extractEvents;
	ResponderEventPlugin.extractEvents = function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var hasActiveTouches = ResponderTouchHistoryStore.touchHistory.numberActiveTouches > 0;
	  var eventType = nativeEvent.type;
	
	  var shouldSkipMouseAfterTouch = false;
	  if (eventType.indexOf('touch') > -1) {
	    lastActiveTouchTimestamp = Date.now();
	  } else if (lastActiveTouchTimestamp && eventType.indexOf('mouse') > -1) {
	    var now = Date.now();
	    shouldSkipMouseAfterTouch = now - lastActiveTouchTimestamp < EMULATED_MOUSE_THERSHOLD_MS;
	  }
	
	  if (
	  // Filter out mousemove and mouseup events when a touch hasn't started yet
	  (eventType === 'mousemove' || eventType === 'mouseup') && !hasActiveTouches ||
	  // Filter out events from wheel/middle and right click.
	  nativeEvent.button === 1 || nativeEvent.button === 2 ||
	  // Filter out mouse events that browsers dispatch immediately after touch events end
	  // Prevents the REP from calling handlers twice for touch interactions.
	  // See #802 and #932.
	  shouldSkipMouseAfterTouch) {
	    return;
	  }
	
	  var normalizedEvent = (0, _normalizeNativeEvent2.default)(nativeEvent);
	
	  return originalExtractEvents.call(ResponderEventPlugin, topLevelType, targetInst, normalizedEvent, nativeEventTarget);
	};
	
	exports.default = ResponderEventPlugin;
	module.exports = exports['default'];

/***/ },
/* 1448 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function flattenArray(array) {
	  function flattenDown(array, result) {
	    for (var i = 0; i < array.length; i++) {
	      var value = array[i];
	
	      if (Array.isArray(value)) {
	        flattenDown(value, result);
	      } else if (value != null && value !== false) {
	        result.push(value);
	      }
	    }
	
	    return result;
	  }
	  return flattenDown(array, []);
	}
	
	exports.default = flattenArray;
	module.exports = exports["default"];

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactDom = __webpack_require__(65);
	
	exports.default = _reactDom.hydrate; /**
	                                      * Copyright (c) 2016-present, Nicolas Gallagher.
	                                      *
	                                      * This source code is licensed under the MIT license found in the
	                                      * LICENSE file in the root directory of this source tree.
	                                      *
	                                      * @noflow
	                                      */
	
	module.exports = exports['default'];

/***/ },
/* 1450 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isWebColor = function isWebColor(color) {
	  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
	};
	
	exports.default = isWebColor;
	module.exports = exports['default'];

/***/ },
/* 1451 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var mapKeyValue = function mapKeyValue(obj, fn) {
	  var result = [];
	  for (var key in obj) {
	    if (hasOwnProperty.call(obj, key)) {
	      var r = fn(key, obj[key]);
	      r && result.push(r);
	    }
	  }
	  return result;
	};
	
	exports.default = mapKeyValue;
	module.exports = exports["default"];

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _crossFade = __webpack_require__(1220);
	
	var _crossFade2 = _interopRequireDefault(_crossFade);
	
	var _cursor = __webpack_require__(1221);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _filter = __webpack_require__(1222);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _flex = __webpack_require__(1223);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1224);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1225);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1226);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _imageSet = __webpack_require__(1227);
	
	var _imageSet2 = _interopRequireDefault(_imageSet);
	
	var _position = __webpack_require__(1228);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _sizing = __webpack_require__(1229);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1230);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var w = ['Webkit'];
	var m = ['Moz'];
	var ms = ['ms'];
	var wm = ['Webkit', 'Moz'];
	var wms = ['Webkit', 'ms'];
	var wmms = ['Webkit', 'Moz', 'ms'];
	
	exports.default = {
	  plugins: [_crossFade2.default, _cursor2.default, _filter2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _imageSet2.default, _position2.default, _sizing2.default, _transition2.default],
	  prefixMap: {
	    animation: w,
	    animationDelay: w,
	    animationDirection: w,
	    animationFillMode: w,
	    animationDuration: w,
	    animationIterationCount: w,
	    animationName: w,
	    animationPlayState: w,
	    animationTimingFunction: w,
	    appearance: wm,
	    userSelect: wmms,
	    textEmphasisPosition: w,
	    textEmphasis: w,
	    textEmphasisStyle: w,
	    textEmphasisColor: w,
	    boxDecorationBreak: w,
	    clipPath: w,
	    maskImage: w,
	    maskMode: w,
	    maskRepeat: w,
	    maskPosition: w,
	    maskClip: w,
	    maskOrigin: w,
	    maskSize: w,
	    maskComposite: w,
	    mask: w,
	    maskBorderSource: w,
	    maskBorderMode: w,
	    maskBorderSlice: w,
	    maskBorderWidth: w,
	    maskBorderOutset: w,
	    maskBorderRepeat: w,
	    maskBorder: w,
	    maskType: w,
	    textDecorationStyle: w,
	    textDecorationSkip: w,
	    textDecorationLine: w,
	    textDecorationColor: w,
	    filter: w,
	    fontFeatureSettings: w,
	    breakAfter: wmms,
	    breakBefore: wmms,
	    breakInside: wmms,
	    columnCount: wm,
	    columnFill: wm,
	    columnGap: wm,
	    columnRule: wm,
	    columnRuleColor: wm,
	    columnRuleStyle: wm,
	    columnRuleWidth: wm,
	    columns: wm,
	    columnSpan: wm,
	    columnWidth: wm,
	    writingMode: wms,
	    flex: wms,
	    flexBasis: w,
	    flexDirection: wms,
	    flexGrow: w,
	    flexFlow: wms,
	    flexShrink: w,
	    flexWrap: wms,
	    alignContent: w,
	    alignItems: w,
	    alignSelf: w,
	    justifyContent: w,
	    order: w,
	    transform: w,
	    transformOrigin: w,
	    transformOriginX: w,
	    transformOriginY: w,
	    backfaceVisibility: w,
	    perspective: w,
	    perspectiveOrigin: w,
	    transformStyle: w,
	    transformOriginZ: w,
	    backdropFilter: w,
	    fontKerning: w,
	    scrollSnapType: wms,
	    scrollSnapPointsX: wms,
	    scrollSnapPointsY: wms,
	    scrollSnapDestination: wms,
	    scrollSnapCoordinate: wms,
	    shapeImageThreshold: w,
	    shapeImageMargin: w,
	    shapeImageOutside: w,
	    hyphens: wmms,
	    flowInto: wms,
	    flowFrom: wms,
	    regionFragment: wms,
	    textAlignLast: m,
	    tabSize: m,
	    wrapFlow: ms,
	    wrapThrough: ms,
	    wrapMargin: ms,
	    touchAction: ms,
	    gridTemplateColumns: ms,
	    gridTemplateRows: ms,
	    gridTemplateAreas: ms,
	    gridTemplate: ms,
	    gridAutoColumns: ms,
	    gridAutoRows: ms,
	    gridAutoFlow: ms,
	    grid: ms,
	    gridRowStart: ms,
	    gridColumnStart: ms,
	    gridRowEnd: ms,
	    gridRow: ms,
	    gridColumn: ms,
	    gridColumnEnd: ms,
	    gridColumnGap: ms,
	    gridRowGap: ms,
	    gridArea: ms,
	    gridGap: ms,
	    textSizeAdjust: wms,
	    borderImage: w,
	    borderImageOutset: w,
	    borderImageRepeat: w,
	    borderImageSlice: w,
	    borderImageSource: w,
	    borderImageWidth: w,
	    transitionDelay: w,
	    transitionDuration: w,
	    transitionProperty: w,
	    transitionTimingFunction: w
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.cancelIdleCallback = undefined;
	
	var _ExecutionEnvironment = __webpack_require__(24);
	
	var _requestIdleCallback = function _requestIdleCallback(cb, options) {
	  return setTimeout(function () {
	    var start = Date.now();
	    cb({
	      didTimeout: false,
	      timeRemaining: function timeRemaining() {
	        return Math.max(0, 50 - (Date.now() - start));
	      }
	    });
	  }, 1);
	};
	
	// $FlowFixMe (TimeoutID type is not recognized by eslint)
	/**
	 * Copyright (c) 2015-present, Nicolas Gallagher.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var _cancelIdleCallback = function _cancelIdleCallback(id) {
	  clearTimeout(id);
	};
	
	var isSupported = _ExecutionEnvironment.canUseDOM && typeof window.requestIdleCallback !== 'undefined';
	
	var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
	var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
	
	exports.default = requestIdleCallback;
	exports.cancelIdleCallback = cancelIdleCallback;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _unitlessNumbers = __webpack_require__(1059);
	
	var _unitlessNumbers2 = _interopRequireDefault(_unitlessNumbers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(_unitlessNumbers2.default.hasOwnProperty(name) && _unitlessNumbers2.default[name])) {
	    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
	  }
	
	  return ('' + value).trim();
	} /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * From React 16.0.0
	 */
	
	exports.default = dangerousStyleValue;
	module.exports = exports['default'];

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dangerousStyleValue = __webpack_require__(1454);
	
	var _dangerousStyleValue2 = _interopRequireDefault(_dangerousStyleValue);
	
	var _hyphenateStyleName = __webpack_require__(159);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _warnValidStyle = __webpack_require__(1456);
	
	var _warnValidStyle2 = _interopRequireDefault(_warnValidStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sets the value for multiple styles on a node.  If a value is specified as
	 * '' (empty string), the corresponding style property will be unset.
	 *
	 * @param {DOMElement} node
	 * @param {object} styles
	 */
	function setValueForStyles(node, styles, getStack) {
	  var style = node.style;
	  for (var styleName in styles) {
	    if (!styles.hasOwnProperty(styleName)) {
	      continue;
	    }
	    var isCustomProperty = styleName.indexOf('--') === 0;
	    var isImportant = typeof styles[styleName] === 'string' && styles[styleName].indexOf('!important') > -1;
	    if (false) {
	      if (!isCustomProperty) {
	        (0, _warnValidStyle2.default)(styleName, styles[styleName], getStack);
	      }
	    }
	    var styleValue = (0, _dangerousStyleValue2.default)(styleName, styles[styleName], isCustomProperty);
	    if (styleName === 'float') {
	      styleName = 'cssFloat';
	    }
	    if (isCustomProperty || isImportant) {
	      var name = isCustomProperty ? styleName : (0, _hyphenateStyleName2.default)(styleName);
	      if (isImportant) {
	        var _styleValue$split = styleValue.split('!'),
	            value = _styleValue$split[0],
	            priority = _styleValue$split[1];
	
	        style.setProperty(name, value, priority);
	      } else {
	        style.setProperty(name, styleValue);
	      }
	    } else {
	      style[styleName] = styleValue;
	    }
	  }
	} /* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on React 16.3.0
	 */
	
	exports.default = setValueForStyles;
	module.exports = exports['default'];

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	/* eslint-disable */
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on React 16.3.0
	 */
	
	var emptyFunction = __webpack_require__(37);
	
	var warnValidStyle = emptyFunction;
	
	if (false) {
	  var getComponentName = function getComponentName(instanceOrFiber) {
	    if (typeof instanceOrFiber.getName === 'function') {
	      // Stack reconciler
	      var instance = instanceOrFiber;
	      return instance.getName();
	    }
	    if (typeof instanceOrFiber.tag === 'number') {
	      // Fiber reconciler
	      var fiber = instanceOrFiber;
	      var type = fiber.type;
	
	      if (typeof type === 'string') {
	        return type;
	      }
	      if (typeof type === 'function') {
	        return type.displayName || type.name;
	      }
	    }
	    return null;
	  };
	
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	
	
	  var camelizeStyleName = require('fbjs/lib/camelizeStyleName');
	  var warning = require('fbjs/lib/warning');
	
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	  var warnedForInfinityValue = false;
	
	  var warnHyphenatedStyleName = function warnHyphenatedStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner));
	  };
	
	  var warnBadVendoredStyleName = function warnBadVendoredStyleName(name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner));
	  };
	
	  var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, ''));
	  };
	
	  var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
	  };
	
	  var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value, owner) {
	    if (warnedForInfinityValue) {
	      return;
	    }
	
	    warnedForInfinityValue = true;
	    warning(false, '`Infinity` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner));
	  };
	
	  var checkRenderMessage = function checkRenderMessage(owner) {
	    var ownerName;
	    if (owner != null) {
	      // Stack passes the owner manually all the way to CSSPropertyOperations.
	      ownerName = getComponentName(owner);
	    } else {
	      // Fiber doesn't pass it but uses ReactDebugCurrentFiber to track it.
	      // It is only enabled in development and tracks host components too.
	      // var {getCurrentFiberOwnerName} = require('ReactDebugCurrentFiber');
	      //  ownerName = getCurrentFiberOwnerName();
	      // TODO: also report the stack.
	    }
	    if (ownerName) {
	      return '\n\nCheck the render method of `' + ownerName + '`.';
	    }
	    return '';
	  };
	
	  warnValidStyle = function warnValidStyle(name, value, component) {
	    var owner;
	    if (component) {
	      // TODO: this only works with Stack. Seems like we need to add unit tests?
	      // owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number') {
	      if (isNaN(value)) {
	        warnStyleValueIsNaN(name, value, owner);
	      } else if (!isFinite(value)) {
	        warnStyleValueIsInfinity(name, value, owner);
	      }
	    }
	  };
	}
	
	exports.default = warnValidStyle;
	module.exports = exports['default'];

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 * @preventMunge
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedEvent = __webpack_require__(826);
	
	var _AnimatedAddition = __webpack_require__(1464);
	
	var _AnimatedAddition2 = _interopRequireDefault(_AnimatedAddition);
	
	var _AnimatedDiffClamp = __webpack_require__(1465);
	
	var _AnimatedDiffClamp2 = _interopRequireDefault(_AnimatedDiffClamp);
	
	var _AnimatedDivision = __webpack_require__(1466);
	
	var _AnimatedDivision2 = _interopRequireDefault(_AnimatedDivision);
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedModulo = __webpack_require__(1467);
	
	var _AnimatedModulo2 = _interopRequireDefault(_AnimatedModulo);
	
	var _AnimatedMultiplication = __webpack_require__(1468);
	
	var _AnimatedMultiplication2 = _interopRequireDefault(_AnimatedMultiplication);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedProps = __webpack_require__(1062);
	
	var _AnimatedProps2 = _interopRequireDefault(_AnimatedProps);
	
	var _AnimatedTracking = __webpack_require__(1470);
	
	var _AnimatedTracking2 = _interopRequireDefault(_AnimatedTracking);
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedValueXY = __webpack_require__(828);
	
	var _AnimatedValueXY2 = _interopRequireDefault(_AnimatedValueXY);
	
	var _DecayAnimation = __webpack_require__(1459);
	
	var _DecayAnimation2 = _interopRequireDefault(_DecayAnimation);
	
	var _SpringAnimation = __webpack_require__(1460);
	
	var _SpringAnimation2 = _interopRequireDefault(_SpringAnimation);
	
	var _TimingAnimation = __webpack_require__(1461);
	
	var _TimingAnimation2 = _interopRequireDefault(_TimingAnimation);
	
	var _createAnimatedComponent = __webpack_require__(1463);
	
	var _createAnimatedComponent2 = _interopRequireDefault(_createAnimatedComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var add = function add(a, b) {
	  return new _AnimatedAddition2.default(a, b);
	};
	
	var divide = function divide(a, b) {
	  return new _AnimatedDivision2.default(a, b);
	};
	
	var multiply = function multiply(a, b) {
	  return new _AnimatedMultiplication2.default(a, b);
	};
	
	var modulo = function modulo(a, modulus) {
	  return new _AnimatedModulo2.default(a, modulus);
	};
	
	var diffClamp = function diffClamp(a, min, max) {
	  return new _AnimatedDiffClamp2.default(a, min, max);
	};
	
	var _combineCallbacks = function _combineCallbacks(callback, config) {
	  if (callback && config.onComplete) {
	    return function () {
	      config.onComplete && config.onComplete.apply(config, arguments);
	      callback && callback.apply(undefined, arguments);
	    };
	  } else {
	    return callback || config.onComplete;
	  }
	};
	
	var maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
	  if (value instanceof _AnimatedValueXY2.default) {
	    var configX = Object.assign({}, config);
	    var configY = Object.assign({}, config);
	    for (var key in config) {
	      var _config$key = config[key],
	          x = _config$key.x,
	          y = _config$key.y;
	
	      if (x !== undefined && y !== undefined) {
	        configX[key] = x;
	        configY[key] = y;
	      }
	    }
	    var aX = anim(value.x, configX);
	    var aY = anim(value.y, configY);
	    // We use `stopTogether: false` here because otherwise tracking will break
	    // because the second animation will get stopped before it can update.
	    return parallel([aX, aY], { stopTogether: false });
	  }
	  return null;
	};
	
	var spring = function spring(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof _AnimatedNode2.default) {
	      singleValue.track(new _AnimatedTracking2.default(singleValue, configuration.toValue, _SpringAnimation2.default, singleConfig, callback));
	    } else {
	      singleValue.animate(new _SpringAnimation2.default(singleConfig), callback);
	    }
	  };
	  return maybeVectorAnim(value, config, spring) || {
	    start: function (_start) {
	      function start(_x) {
	        return _start.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = Object.assign({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var timing = function timing(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    if (configuration.toValue instanceof _AnimatedNode2.default) {
	      singleValue.track(new _AnimatedTracking2.default(singleValue, configuration.toValue, _TimingAnimation2.default, singleConfig, callback));
	    } else {
	      singleValue.animate(new _TimingAnimation2.default(singleConfig), callback);
	    }
	  };
	
	  return maybeVectorAnim(value, config, timing) || {
	    start: function (_start2) {
	      function start(_x2) {
	        return _start2.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start2.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = Object.assign({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var decay = function decay(value, config) {
	  var start = function start(animatedValue, configuration, callback) {
	    callback = _combineCallbacks(callback, configuration);
	    var singleValue = animatedValue;
	    var singleConfig = configuration;
	    singleValue.stopTracking();
	    singleValue.animate(new _DecayAnimation2.default(singleConfig), callback);
	  };
	
	  return maybeVectorAnim(value, config, decay) || {
	    start: function (_start3) {
	      function start(_x3) {
	        return _start3.apply(this, arguments);
	      }
	
	      start.toString = function () {
	        return _start3.toString();
	      };
	
	      return start;
	    }(function (callback) {
	      start(value, config, callback);
	    }),
	
	    stop: function stop() {
	      value.stopAnimation();
	    },
	
	    reset: function reset() {
	      value.resetAnimation();
	    },
	
	    _startNativeLoop: function _startNativeLoop(iterations) {
	      var singleConfig = Object.assign({}, config, { iterations: iterations });
	      start(value, singleConfig);
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return config.useNativeDriver || false;
	    }
	  };
	};
	
	var sequence = function sequence(animations) {
	  var current = 0;
	  return {
	    start: function start(callback) {
	      var onComplete = function onComplete(result) {
	        if (!result.finished) {
	          callback && callback(result);
	          return;
	        }
	
	        current++;
	
	        if (current === animations.length) {
	          callback && callback(result);
	          return;
	        }
	
	        animations[current].start(onComplete);
	      };
	
	      if (animations.length === 0) {
	        callback && callback({ finished: true });
	      } else {
	        animations[current].start(onComplete);
	      }
	    },
	
	    stop: function stop() {
	      if (current < animations.length) {
	        animations[current].stop();
	      }
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        if (idx <= current) {
	          animation.reset();
	        }
	      });
	      current = 0;
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	};
	
	var parallel = function parallel(animations, config) {
	  var doneCount = 0;
	  // Make sure we only call stop() at most once for each animation
	  var hasEnded = {};
	  var stopTogether = !(config && config.stopTogether === false);
	
	  var result = {
	    start: function start(callback) {
	      if (doneCount === animations.length) {
	        callback && callback({ finished: true });
	        return;
	      }
	
	      animations.forEach(function (animation, idx) {
	        var cb = function cb(endResult) {
	          hasEnded[idx] = true;
	          doneCount++;
	          if (doneCount === animations.length) {
	            doneCount = 0;
	            callback && callback(endResult);
	            return;
	          }
	
	          if (!endResult.finished && stopTogether) {
	            result.stop();
	          }
	        };
	
	        if (!animation) {
	          cb({ finished: true });
	        } else {
	          animation.start(cb);
	        }
	      });
	    },
	
	    stop: function stop() {
	      animations.forEach(function (animation, idx) {
	        !hasEnded[idx] && animation.stop();
	        hasEnded[idx] = true;
	      });
	    },
	
	    reset: function reset() {
	      animations.forEach(function (animation, idx) {
	        animation.reset();
	        hasEnded[idx] = false;
	        doneCount = 0;
	      });
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return false;
	    }
	  };
	
	  return result;
	};
	
	var delay = function delay(time) {
	  // Would be nice to make a specialized implementation
	  return timing(new _AnimatedValue2.default(0), { toValue: 0, delay: time, duration: 0 });
	};
	
	var stagger = function stagger(time, animations) {
	  return parallel(animations.map(function (animation, i) {
	    return sequence([delay(time * i), animation]);
	  }));
	};
	
	var loop = function loop(animation) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$iterations = _ref.iterations,
	      iterations = _ref$iterations === undefined ? -1 : _ref$iterations;
	
	  var isFinished = false;
	  var iterationsSoFar = 0;
	  return {
	    start: function start(callback) {
	      var restart = function restart() {
	        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { finished: true };
	
	        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
	          callback && callback(result);
	        } else {
	          iterationsSoFar++;
	          animation.reset();
	          animation.start(restart);
	        }
	      };
	      if (!animation || iterations === 0) {
	        callback && callback({ finished: true });
	      } else {
	        if (animation._isUsingNativeDriver()) {
	          animation._startNativeLoop(iterations);
	        } else {
	          restart(); // Start looping recursively on the js thread
	        }
	      }
	    },
	
	    stop: function stop() {
	      isFinished = true;
	      animation.stop();
	    },
	
	    reset: function reset() {
	      iterationsSoFar = 0;
	      isFinished = false;
	      animation.reset();
	    },
	
	    _startNativeLoop: function _startNativeLoop() {
	      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
	    },
	
	    _isUsingNativeDriver: function _isUsingNativeDriver() {
	      return animation._isUsingNativeDriver();
	    }
	  };
	};
	
	function forkEvent(event, listener) {
	  if (!event) {
	    return listener;
	  } else if (event instanceof _AnimatedEvent.AnimatedEvent) {
	    event.__addListener(listener);
	    return event;
	  } else {
	    return function () {
	      typeof event === 'function' && event.apply(undefined, arguments);
	      listener.apply(undefined, arguments);
	    };
	  }
	}
	
	function unforkEvent(event, listener) {
	  if (event && event instanceof _AnimatedEvent.AnimatedEvent) {
	    event.__removeListener(listener);
	  }
	}
	
	var event = function event(argMapping, config) {
	  var animatedEvent = new _AnimatedEvent.AnimatedEvent(argMapping, config);
	  if (animatedEvent.__isNative) {
	    return animatedEvent;
	  } else {
	    return animatedEvent.__getHandler();
	  }
	};
	
	/**
	 * The `Animated` library is designed to make animations fluid, powerful, and
	 * easy to build and maintain. `Animated` focuses on declarative relationships
	 * between inputs and outputs, with configurable transforms in between, and
	 * simple `start`/`stop` methods to control time-based animation execution.
	 *
	 * See http://facebook.github.io/react-native/docs/animated.html
	 */
	var AnimatedImplementation = {
	  /**
	   * Standard value class for driving animations.  Typically initialized with
	   * `new Animated.Value(0);`
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#value
	   */
	  Value: _AnimatedValue2.default,
	  /**
	   * 2D value class for driving 2D animations, such as pan gestures.
	   *
	   * See https://facebook.github.io/react-native/releases/next/docs/animatedvaluexy.html
	   */
	  ValueXY: _AnimatedValueXY2.default,
	  /**
	   * Exported to use the Interpolation type in flow.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#interpolation
	   */
	  Interpolation: _AnimatedInterpolation2.default,
	  /**
	   * Exported for ease of type checking. All animated values derive from this
	   * class.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#node
	   */
	  Node: _AnimatedNode2.default,
	
	  /**
	   * Animates a value from an initial velocity to zero based on a decay
	   * coefficient.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#decay
	   */
	  decay: decay,
	  /**
	   * Animates a value along a timed easing curve. The Easing module has tons of
	   * predefined curves, or you can use your own function.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#timing
	   */
	  timing: timing,
	  /**
	   * Animates a value according to an analytical spring model based on
	   * damped harmonic oscillation.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#spring
	   */
	  spring: spring,
	
	  /**
	   * Creates a new Animated value composed from two Animated values added
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#add
	   */
	  add: add,
	
	  /**
	   * Creates a new Animated value composed by dividing the first Animated value
	   * by the second Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#divide
	   */
	  divide: divide,
	
	  /**
	   * Creates a new Animated value composed from two Animated values multiplied
	   * together.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#multiply
	   */
	  multiply: multiply,
	
	  /**
	   * Creates a new Animated value that is the (non-negative) modulo of the
	   * provided Animated value.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#modulo
	   */
	  modulo: modulo,
	
	  /**
	   * Create a new Animated value that is limited between 2 values. It uses the
	   * difference between the last value so even if the value is far from the
	   * bounds it will start changing when the value starts getting closer again.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#diffclamp
	   */
	  diffClamp: diffClamp,
	
	  /**
	   * Starts an animation after the given delay.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#delay
	   */
	  delay: delay,
	  /**
	   * Starts an array of animations in order, waiting for each to complete
	   * before starting the next. If the current running animation is stopped, no
	   * following animations will be started.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#sequence
	   */
	  sequence: sequence,
	  /**
	   * Starts an array of animations all at the same time. By default, if one
	   * of the animations is stopped, they will all be stopped. You can override
	   * this with the `stopTogether` flag.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#parallel
	   */
	  parallel: parallel,
	  /**
	   * Array of animations may run in parallel (overlap), but are started in
	   * sequence with successive delays.  Nice for doing trailing effects.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#stagger
	   */
	  stagger: stagger,
	  /**
	   * Loops a given animation continuously, so that each time it reaches the
	   * end, it resets and begins again from the start.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#loop
	   */
	  loop: loop,
	
	  /**
	   * Takes an array of mappings and extracts values from each arg accordingly,
	   * then calls `setValue` on the mapped outputs.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#event
	   */
	  event: event,
	
	  /**
	   * Make any React component Animatable.  Used to create `Animated.View`, etc.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#createanimatedcomponent
	   */
	  createAnimatedComponent: _createAnimatedComponent2.default,
	
	  /**
	   * Imperative API to attach an animated value to an event on a view. Prefer
	   * using `Animated.event` with `useNativeDrive: true` if possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#attachnativeevent
	   */
	  attachNativeEvent: _AnimatedEvent.attachNativeEvent,
	
	  /**
	   * Advanced imperative API for snooping on animated events that are passed in
	   * through props. Use values directly where possible.
	   *
	   * See http://facebook.github.io/react-native/docs/animated.html#forkevent
	   */
	  forkEvent: forkEvent,
	  unforkEvent: unforkEvent,
	
	  __PropsOnlyForTests: _AnimatedProps2.default
	};
	
	exports.default = AnimatedImplementation;
	module.exports = exports['default'];

/***/ },
/* 1458 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	
	function stiffnessFromOrigamiValue(oValue) {
	  return (oValue - 30) * 3.62 + 194;
	}
	
	function dampingFromOrigamiValue(oValue) {
	  return (oValue - 8) * 3 + 25;
	}
	
	function fromOrigamiTensionAndFriction(tension, friction) {
	  return {
	    stiffness: stiffnessFromOrigamiValue(tension),
	    damping: dampingFromOrigamiValue(friction)
	  };
	}
	
	function fromBouncinessAndSpeed(bounciness, speed) {
	  function normalize(value, startValue, endValue) {
	    return (value - startValue) / (endValue - startValue);
	  }
	
	  function projectNormal(n, start, end) {
	    return start + n * (end - start);
	  }
	
	  function linearInterpolation(t, start, end) {
	    return t * end + (1 - t) * start;
	  }
	
	  function quadraticOutInterpolation(t, start, end) {
	    return linearInterpolation(2 * t - t * t, start, end);
	  }
	
	  function b3Friction1(x) {
	    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
	  }
	
	  function b3Friction2(x) {
	    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
	  }
	
	  function b3Friction3(x) {
	    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
	  }
	
	  function b3Nobounce(tension) {
	    if (tension <= 18) {
	      return b3Friction1(tension);
	    } else if (tension > 18 && tension <= 44) {
	      return b3Friction2(tension);
	    } else {
	      return b3Friction3(tension);
	    }
	  }
	
	  var b = normalize(bounciness / 1.7, 0, 20);
	  b = projectNormal(b, 0, 0.8);
	  var s = normalize(speed / 1.7, 0, 20);
	  var bouncyTension = projectNormal(s, 0.5, 200);
	  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);
	
	  return {
	    stiffness: stiffnessFromOrigamiValue(bouncyTension),
	    damping: dampingFromOrigamiValue(bouncyFriction)
	  };
	}
	
	exports.fromOrigamiTensionAndFriction = fromOrigamiTensionAndFriction;
	exports.fromBouncinessAndSpeed = fromBouncinessAndSpeed;
	exports.default = { fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction, fromBouncinessAndSpeed: fromBouncinessAndSpeed };

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _Animation2 = __webpack_require__(827);
	
	var _Animation3 = _interopRequireDefault(_Animation2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DecayAnimation = function (_Animation) {
	  _inherits(DecayAnimation, _Animation);
	
	  function DecayAnimation(config) {
	    _classCallCheck(this, DecayAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._deceleration = config.deceleration !== undefined ? config.deceleration : 0.998;
	    _this._velocity = config.velocity;
	    _this._useNativeDriver = (0, _NativeAnimatedHelper.shouldUseNativeDriver)(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    return _this;
	  }
	
	  DecayAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'decay',
	      deceleration: this._deceleration,
	      velocity: this._velocity,
	      iterations: this.__iterations
	    };
	  };
	
	  DecayAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    this.__active = true;
	    this._lastValue = fromValue;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._startTime = Date.now();
	    if (this._useNativeDriver) {
	      this.__startNativeAnimation(animatedValue);
	    } else {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	
	    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));
	
	    this._onUpdate(value);
	
	    if (Math.abs(this._lastValue - value) < 0.1) {
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._lastValue = value;
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  DecayAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return DecayAnimation;
	}(_Animation3.default);
	
	exports.default = DecayAnimation;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedValueXY = __webpack_require__(828);
	
	var _AnimatedValueXY2 = _interopRequireDefault(_AnimatedValueXY);
	
	var _Animation2 = __webpack_require__(827);
	
	var _Animation3 = _interopRequireDefault(_Animation2);
	
	var _SpringConfig = __webpack_require__(1458);
	
	var _SpringConfig2 = _interopRequireDefault(_SpringConfig);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withDefault(value, defaultValue) {
	  if (value === undefined || value === null) {
	    return defaultValue;
	  }
	  return value;
	}
	
	var SpringAnimation = function (_Animation) {
	  _inherits(SpringAnimation, _Animation);
	
	  function SpringAnimation(config) {
	    _classCallCheck(this, SpringAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._overshootClamping = withDefault(config.overshootClamping, false);
	    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.001);
	    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.001);
	    _this._initialVelocity = withDefault(config.velocity, 0);
	    _this._lastVelocity = withDefault(config.velocity, 0);
	    _this._toValue = config.toValue;
	    _this._delay = withDefault(config.delay, 0);
	    _this._useNativeDriver = (0, _NativeAnimatedHelper.shouldUseNativeDriver)(config);
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	
	    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
	      (0, _invariant2.default)(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      _this._stiffness = withDefault(config.stiffness, 100);
	      _this._damping = withDefault(config.damping, 10);
	      _this._mass = withDefault(config.mass, 1);
	    } else if (config.bounciness !== undefined || config.speed !== undefined) {
	      // Convert the origami bounciness/speed values to stiffness/damping
	      // We assume mass is 1.
	      (0, _invariant2.default)(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
	      var springConfig = _SpringConfig2.default.fromBouncinessAndSpeed(withDefault(config.bounciness, 8), withDefault(config.speed, 12));
	      _this._stiffness = springConfig.stiffness;
	      _this._damping = springConfig.damping;
	      _this._mass = 1;
	    } else {
	      // Convert the origami tension/friction values to stiffness/damping
	      // We assume mass is 1.
	      var _springConfig = _SpringConfig2.default.fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));
	      _this._stiffness = _springConfig.stiffness;
	      _this._damping = _springConfig.damping;
	      _this._mass = 1;
	    }
	
	    (0, _invariant2.default)(_this._stiffness > 0, 'Stiffness value must be greater than 0');
	    (0, _invariant2.default)(_this._damping > 0, 'Damping value must be greater than 0');
	    (0, _invariant2.default)(_this._mass > 0, 'Mass value must be greater than 0');
	    return _this;
	  }
	
	  SpringAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    return {
	      type: 'spring',
	      overshootClamping: this._overshootClamping,
	      restDisplacementThreshold: this._restDisplacementThreshold,
	      restSpeedThreshold: this._restSpeedThreshold,
	      stiffness: this._stiffness,
	      damping: this._damping,
	      mass: this._mass,
	      initialVelocity: withDefault(this._initialVelocity, this._lastVelocity),
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  SpringAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._startPosition = fromValue;
	    this._lastPosition = this._startPosition;
	
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	    this._lastTime = Date.now();
	    this._frameTime = 0.0;
	
	    if (previousAnimation instanceof SpringAnimation) {
	      var internalState = previousAnimation.getInternalState();
	      this._lastPosition = internalState.lastPosition;
	      this._lastVelocity = internalState.lastVelocity;
	      // Set the initial velocity to the last velocity
	      this._initialVelocity = this._lastVelocity;
	      this._lastTime = internalState.lastTime;
	    }
	
	    var start = function start() {
	      if (_this2._useNativeDriver) {
	        _this2.__startNativeAnimation(animatedValue);
	      } else {
	        _this2.onUpdate();
	      }
	    };
	
	    //  If this._delay is more than 0, we start after the timeout.
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  SpringAnimation.prototype.getInternalState = function getInternalState() {
	    return {
	      lastPosition: this._lastPosition,
	      lastVelocity: this._lastVelocity,
	      lastTime: this._lastTime
	    };
	  };
	
	  /**
	   * This spring model is based off of a damped harmonic oscillator
	   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
	   *
	   * We use the closed form of the second order differential equation:
	   *
	   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
	   *
	   * where
	   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
	   *    ζ = c / 2√mk (damping ratio),
	   *    c = damping constant
	   *    k = stiffness
	   *    m = mass
	   *
	   * The derivation of the closed form is described in detail here:
	   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
	   *
	   * This algorithm happens to match the algorithm used by CASpringAnimation,
	   * a QuartzCore (iOS) API that creates spring animations.
	   */
	
	
	  SpringAnimation.prototype.onUpdate = function onUpdate() {
	    // If for some reason we lost a lot of frames (e.g. process large payload or
	    // stopped in the debugger), we only advance by 4 frames worth of
	    // computation and will continue on the next frame. It's better to have it
	    // running at faster speed than jumping to the end.
	    var MAX_STEPS = 64;
	    var now = Date.now();
	    if (now > this._lastTime + MAX_STEPS) {
	      now = this._lastTime + MAX_STEPS;
	    }
	
	    var deltaTime = (now - this._lastTime) / 1000;
	    this._frameTime += deltaTime;
	
	    var c = this._damping;
	    var m = this._mass;
	    var k = this._stiffness;
	    var v0 = -this._initialVelocity;
	
	    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio
	    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)
	    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay
	    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0
	
	    var position = 0.0;
	    var velocity = 0.0;
	    var t = this._frameTime;
	    if (zeta < 1) {
	      // Under damped
	      var envelope = Math.exp(-zeta * omega0 * t);
	      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t));
	      // This looks crazy -- it's actually just the derivative of the
	      // oscillation function
	      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
	    } else {
	      // Critically damped
	      var _envelope = Math.exp(-omega0 * t);
	      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
	      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
	    }
	
	    this._lastTime = now;
	    this._lastPosition = position;
	    this._lastVelocity = velocity;
	
	    this._onUpdate(position);
	    if (!this.__active) {
	      // a listener might have stopped us in _onUpdate
	      return;
	    }
	
	    // Conditions for stopping the spring animation
	    var isOvershooting = false;
	    if (this._overshootClamping && this._stiffness !== 0) {
	      if (this._startPosition < this._toValue) {
	        isOvershooting = position > this._toValue;
	      } else {
	        isOvershooting = position < this._toValue;
	      }
	    }
	    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;
	    var isDisplacement = true;
	    if (this._stiffness !== 0) {
	      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
	    }
	
	    if (isOvershooting || isVelocity && isDisplacement) {
	      if (this._stiffness !== 0) {
	        // Ensure that we end up with a round value
	        this._lastPosition = this._toValue;
	        this._lastVelocity = 0;
	        this._onUpdate(this._toValue);
	      }
	
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	  };
	
	  SpringAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return SpringAnimation;
	}(_Animation3.default);
	
	exports.default = SpringAnimation;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedValueXY = __webpack_require__(828);
	
	var _AnimatedValueXY2 = _interopRequireDefault(_AnimatedValueXY);
	
	var _Animation2 = __webpack_require__(827);
	
	var _Animation3 = _interopRequireDefault(_Animation2);
	
	var _Easing = __webpack_require__(1061);
	
	var _Easing2 = _interopRequireDefault(_Easing);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _easeInOut = void 0;
	function easeInOut() {
	  if (!_easeInOut) {
	    _easeInOut = _Easing2.default.inOut(_Easing2.default.ease);
	  }
	  return _easeInOut;
	}
	
	var TimingAnimation = function (_Animation) {
	  _inherits(TimingAnimation, _Animation);
	
	  function TimingAnimation(config) {
	    _classCallCheck(this, TimingAnimation);
	
	    var _this = _possibleConstructorReturn(this, _Animation.call(this));
	
	    _this._toValue = config.toValue;
	    _this._easing = config.easing !== undefined ? config.easing : easeInOut();
	    _this._duration = config.duration !== undefined ? config.duration : 500;
	    _this._delay = config.delay !== undefined ? config.delay : 0;
	    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
	    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
	    _this._useNativeDriver = (0, _NativeAnimatedHelper.shouldUseNativeDriver)(config);
	    return _this;
	  }
	
	  TimingAnimation.prototype.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
	    var frameDuration = 1000.0 / 60.0;
	    var frames = [];
	    for (var dt = 0.0; dt < this._duration; dt += frameDuration) {
	      frames.push(this._easing(dt / this._duration));
	    }
	    frames.push(this._easing(1));
	    return {
	      type: 'frames',
	      frames: frames,
	      toValue: this._toValue,
	      iterations: this.__iterations
	    };
	  };
	
	  TimingAnimation.prototype.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
	    var _this2 = this;
	
	    this.__active = true;
	    this._fromValue = fromValue;
	    this._onUpdate = onUpdate;
	    this.__onEnd = onEnd;
	
	    var start = function start() {
	      // Animations that sometimes have 0 duration and sometimes do not
	      // still need to use the native driver when duration is 0 so as to
	      // not cause intermixed JS and native animations.
	      if (_this2._duration === 0 && !_this2._useNativeDriver) {
	        _this2._onUpdate(_this2._toValue);
	        _this2.__debouncedOnEnd({ finished: true });
	      } else {
	        _this2._startTime = Date.now();
	        if (_this2._useNativeDriver) {
	          _this2.__startNativeAnimation(animatedValue);
	        } else {
	          _this2._animationFrame = requestAnimationFrame(_this2.onUpdate.bind(_this2));
	        }
	      }
	    };
	    if (this._delay) {
	      this._timeout = setTimeout(start, this._delay);
	    } else {
	      start();
	    }
	  };
	
	  TimingAnimation.prototype.onUpdate = function onUpdate() {
	    var now = Date.now();
	    if (now >= this._startTime + this._duration) {
	      if (this._duration === 0) {
	        this._onUpdate(this._toValue);
	      } else {
	        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
	      }
	      this.__debouncedOnEnd({ finished: true });
	      return;
	    }
	
	    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));
	    if (this.__active) {
	      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
	    }
	  };
	
	  TimingAnimation.prototype.stop = function stop() {
	    _Animation.prototype.stop.call(this);
	    this.__active = false;
	    clearTimeout(this._timeout);
	    global.cancelAnimationFrame(this._animationFrame);
	    this.__debouncedOnEnd({ finished: false });
	  };
	
	  return TimingAnimation;
	}(_Animation3.default);
	
	exports.default = TimingAnimation;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1462 */
/***/ function(module, exports) {

	/**
	 * BezierEasing - use bezier curve for transition easing function
	 * https://github.com/gre/bezier-easing
	 *
	 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
	 * @noflow
	 */
	'use strict';
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	
	var NEWTON_ITERATIONS = 4;
	var NEWTON_MIN_SLOPE = 0.001;
	var SUBDIVISION_PRECISION = 0.0000001;
	var SUBDIVISION_MAX_ITERATIONS = 10;
	
	var kSplineTableSize = 11;
	var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	var float32ArraySupported = typeof Float32Array === 'function';
	
	function A(aA1, aA2) {
	  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
	}
	function B(aA1, aA2) {
	  return 3.0 * aA2 - 6.0 * aA1;
	}
	function C(aA1) {
	  return 3.0 * aA1;
	}
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	function calcBezier(aT, aA1, aA2) {
	  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
	}
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	function getSlope(aT, aA1, aA2) {
	  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	}
	
	function binarySubdivide(aX, aA, aB, mX1, mX2) {
	  var currentX,
	      currentT,
	      i = 0;
	  do {
	    currentT = aA + (aB - aA) / 2.0;
	    currentX = calcBezier(currentT, mX1, mX2) - aX;
	    if (currentX > 0.0) {
	      aB = currentT;
	    } else {
	      aA = currentT;
	    }
	  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	  return currentT;
	}
	
	function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
	  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	    var currentSlope = getSlope(aGuessT, mX1, mX2);
	    if (currentSlope === 0.0) {
	      return aGuessT;
	    }
	    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	    aGuessT -= currentX / currentSlope;
	  }
	  return aGuessT;
	}
	
	module.exports = function bezier(mX1, mY1, mX2, mY2) {
	  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
	    // eslint-disable-line yoda
	    throw new Error('bezier x values must be in [0, 1] range');
	  }
	
	  // Precompute samples table
	  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	  if (mX1 !== mY1 || mX2 !== mY2) {
	    for (var i = 0; i < kSplineTableSize; ++i) {
	      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  function getTForX(aX) {
	    var intervalStart = 0.0;
	    var currentSample = 1;
	    var lastSample = kSplineTableSize - 1;
	
	    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
	      intervalStart += kSampleStepSize;
	    }
	    --currentSample;
	
	    // Interpolate to provide an initial guess for t
	    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
	    var guessForT = intervalStart + dist * kSampleStepSize;
	
	    var initialSlope = getSlope(guessForT, mX1, mX2);
	    if (initialSlope >= NEWTON_MIN_SLOPE) {
	      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	    } else if (initialSlope === 0.0) {
	      return guessForT;
	    } else {
	      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	    }
	  }
	
	  return function BezierEasing(x) {
	    if (mX1 === mY1 && mX2 === mY2) {
	      return x; // linear
	    }
	    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	    if (x === 0) {
	      return 0;
	    }
	    if (x === 1) {
	      return 1;
	    }
	    return calcBezier(getTForX(x), mY1, mY2);
	  };
	};

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _AnimatedEvent = __webpack_require__(826);
	
	var _AnimatedProps = __webpack_require__(1062);
	
	var _AnimatedProps2 = _interopRequireDefault(_AnimatedProps);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ViewStylePropTypes = __webpack_require__(108);
	
	var _ViewStylePropTypes2 = _interopRequireDefault(_ViewStylePropTypes);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createAnimatedComponent(Component) {
	  (0, _invariant2.default)(typeof Component === 'string' || Component.prototype && Component.prototype.isReactComponent, '`createAnimatedComponent` does not support stateless functional components; ' + 'use a class component instead.');
	
	  var AnimatedComponent = function (_React$Component) {
	    _inherits(AnimatedComponent, _React$Component);
	
	    function AnimatedComponent(props) {
	      _classCallCheck(this, AnimatedComponent);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this._invokeAnimatedPropsCallbackOnMount = false;
	      _this._eventDetachers = [];
	
	      _this._animatedPropsCallback = function () {
	        if (_this._component == null) {
	          // AnimatedProps is created in will-mount because it's used in render.
	          // But this callback may be invoked before mount in async mode,
	          // In which case we should defer the setNativeProps() call.
	          // React may throw away uncommitted work in async mode,
	          // So a deferred call won't always be invoked.
	          _this._invokeAnimatedPropsCallbackOnMount = true;
	        } else if (AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY || typeof _this._component.setNativeProps !== 'function') {
	          _this.forceUpdate();
	        } else if (!_this._propsAnimated.__isNative) {
	          _this._component.setNativeProps(_this._propsAnimated.__getAnimatedValue());
	        } else {
	          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
	        }
	      };
	
	      _this._setComponentRef = _this._setComponentRef.bind(_this);
	      return _this;
	    }
	
	    AnimatedComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this._propsAnimated && this._propsAnimated.__detach();
	      this._detachNativeEvents();
	    };
	
	    AnimatedComponent.prototype.setNativeProps = function setNativeProps(props) {
	      this._component.setNativeProps(props);
	    };
	
	    AnimatedComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	      this._attachProps(this.props);
	    };
	
	    AnimatedComponent.prototype.componentDidMount = function componentDidMount() {
	      if (this._invokeAnimatedPropsCallbackOnMount) {
	        this._invokeAnimatedPropsCallbackOnMount = false;
	        this._animatedPropsCallback();
	      }
	
	      this._propsAnimated.setNativeView(this._component);
	      this._attachNativeEvents();
	    };
	
	    AnimatedComponent.prototype._attachNativeEvents = function _attachNativeEvents() {
	      var _this2 = this;
	
	      // Make sure to get the scrollable node for components that implement
	      // `ScrollResponder.Mixin`.
	      var scrollableNode = this._component.getScrollableNode ? this._component.getScrollableNode() : this._component;
	
	      var _loop = function _loop(key) {
	        var prop = _this2.props[key];
	        if (prop instanceof _AnimatedEvent.AnimatedEvent && prop.__isNative) {
	          prop.__attach(scrollableNode, key);
	          _this2._eventDetachers.push(function () {
	            return prop.__detach(scrollableNode, key);
	          });
	        }
	      };
	
	      for (var key in this.props) {
	        _loop(key);
	      }
	    };
	
	    AnimatedComponent.prototype._detachNativeEvents = function _detachNativeEvents() {
	      this._eventDetachers.forEach(function (remove) {
	        return remove();
	      });
	      this._eventDetachers = [];
	    };
	
	    // The system is best designed when setNativeProps is implemented. It is
	    // able to avoid re-rendering and directly set the attributes that changed.
	    // However, setNativeProps can only be implemented on leaf native
	    // components. If you want to animate a composite component, you need to
	    // re-render it. In this case, we have a fallback that uses forceUpdate.
	
	
	    AnimatedComponent.prototype._attachProps = function _attachProps(nextProps) {
	      var oldPropsAnimated = this._propsAnimated;
	
	      this._propsAnimated = new _AnimatedProps2.default(nextProps, this._animatedPropsCallback);
	
	      // When you call detach, it removes the element from the parent list
	      // of children. If it goes to 0, then the parent also detaches itself
	      // and so on.
	      // An optimization is to attach the new elements and THEN detach the old
	      // ones instead of detaching and THEN attaching.
	      // This way the intermediate state isn't to go to 0 and trigger
	      // this expensive recursive detaching to then re-attach everything on
	      // the very next operation.
	      oldPropsAnimated && oldPropsAnimated.__detach();
	    };
	
	    AnimatedComponent.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
	      this._attachProps(newProps);
	    };
	
	    AnimatedComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	      if (this._component !== this._prevComponent) {
	        this._propsAnimated.setNativeView(this._component);
	      }
	      if (this._component !== this._prevComponent || prevProps !== this.props) {
	        this._detachNativeEvents();
	        this._attachNativeEvents();
	      }
	    };
	
	    AnimatedComponent.prototype.render = function render() {
	      var props = this._propsAnimated.__getValue();
	      return _react2.default.createElement(Component, _extends({}, props, {
	        ref: this._setComponentRef
	        // The native driver updates views directly through the UI thread so we
	        // have to make sure the view doesn't get optimized away because it cannot
	        // go through the NativeViewHierarchyManager since it operates on the shadow
	        // thread.
	        , collapsable: this._propsAnimated.__isNative ? false : props.collapsable
	      }));
	    };
	
	    AnimatedComponent.prototype._setComponentRef = function _setComponentRef(c) {
	      this._prevComponent = this._component;
	      this._component = c;
	    };
	
	    // A third party library can use getNode()
	    // to get the node reference of the decorated component
	
	
	    AnimatedComponent.prototype.getNode = function getNode() {
	      return this._component;
	    };
	
	    return AnimatedComponent;
	  }(_react2.default.Component);
	
	  AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY = false;
	
	
	  var propTypes = Component.propTypes;
	
	  AnimatedComponent.propTypes =  false ? {
	    style: function style(props, propName, componentName) {
	      if (!propTypes) {
	        return;
	      }
	
	      for (var key in _ViewStylePropTypes2.default) {
	        if (!propTypes[key] && props[key] !== undefined) {
	          console.warn('You are setting the style `{ ' + key + ': ... }` as a prop. You ' + 'should nest it in a style object. ' + 'E.g. `{ style: { ' + key + ': ... } }`');
	        }
	      }
	    }
	  } : {};
	
	  return AnimatedComponent;
	}
	
	exports.default = createAnimatedComponent;
	module.exports = exports['default'];

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedAddition = function (_AnimatedWithChildren) {
	  _inherits(AnimatedAddition, _AnimatedWithChildren);
	
	  function AnimatedAddition(a, b) {
	    _classCallCheck(this, AnimatedAddition);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new _AnimatedValue2.default(a) : a;
	    _this._b = typeof b === 'number' ? new _AnimatedValue2.default(b) : b;
	    return _this;
	  }
	
	  AnimatedAddition.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedAddition.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() + this._b.__getValue();
	  };
	
	  AnimatedAddition.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  AnimatedAddition.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedAddition.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedAddition.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'addition',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedAddition;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedAddition;
	module.exports = exports['default'];

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedDiffClamp = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDiffClamp, _AnimatedWithChildren);
	
	  function AnimatedDiffClamp(a, min, max) {
	    _classCallCheck(this, AnimatedDiffClamp);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._min = min;
	    _this._max = max;
	    _this._value = _this._lastValue = _this._a.__getValue();
	    return _this;
	  }
	
	  AnimatedDiffClamp.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  AnimatedDiffClamp.prototype.__getValue = function __getValue() {
	    var value = this._a.__getValue();
	    var diff = value - this._lastValue;
	    this._lastValue = value;
	    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
	    return this._value;
	  };
	
	  AnimatedDiffClamp.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedDiffClamp.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDiffClamp.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'diffclamp',
	      input: this._a.__getNativeTag(),
	      min: this._min,
	      max: this._max
	    };
	  };
	
	  return AnimatedDiffClamp;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedDiffClamp;
	module.exports = exports['default'];

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedDivision = function (_AnimatedWithChildren) {
	  _inherits(AnimatedDivision, _AnimatedWithChildren);
	
	  function AnimatedDivision(a, b) {
	    _classCallCheck(this, AnimatedDivision);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new _AnimatedValue2.default(a) : a;
	    _this._b = typeof b === 'number' ? new _AnimatedValue2.default(b) : b;
	    return _this;
	  }
	
	  AnimatedDivision.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedDivision.prototype.__getValue = function __getValue() {
	    var a = this._a.__getValue();
	    var b = this._b.__getValue();
	    if (b === 0) {
	      console.error('Detected division by zero in AnimatedDivision');
	    }
	    return a / b;
	  };
	
	  AnimatedDivision.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  AnimatedDivision.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedDivision.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedDivision.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'division',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedDivision;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedDivision;
	module.exports = exports['default'];

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedModulo = function (_AnimatedWithChildren) {
	  _inherits(AnimatedModulo, _AnimatedWithChildren);
	
	  function AnimatedModulo(a, modulus) {
	    _classCallCheck(this, AnimatedModulo);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = a;
	    _this._modulus = modulus;
	    return _this;
	  }
	
	  AnimatedModulo.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedModulo.prototype.__getValue = function __getValue() {
	    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
	  };
	
	  AnimatedModulo.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  AnimatedModulo.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	  };
	
	  AnimatedModulo.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedModulo.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'modulus',
	      input: this._a.__getNativeTag(),
	      modulus: this._modulus
	    };
	  };
	
	  return AnimatedModulo;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedModulo;
	module.exports = exports['default'];

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedInterpolation = __webpack_require__(69);
	
	var _AnimatedInterpolation2 = _interopRequireDefault(_AnimatedInterpolation);
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedMultiplication = function (_AnimatedWithChildren) {
	  _inherits(AnimatedMultiplication, _AnimatedWithChildren);
	
	  function AnimatedMultiplication(a, b) {
	    _classCallCheck(this, AnimatedMultiplication);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._a = typeof a === 'number' ? new _AnimatedValue2.default(a) : a;
	    _this._b = typeof b === 'number' ? new _AnimatedValue2.default(b) : b;
	    return _this;
	  }
	
	  AnimatedMultiplication.prototype.__makeNative = function __makeNative() {
	    this._a.__makeNative();
	    this._b.__makeNative();
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getValue = function __getValue() {
	    return this._a.__getValue() * this._b.__getValue();
	  };
	
	  AnimatedMultiplication.prototype.interpolate = function interpolate(config) {
	    return new _AnimatedInterpolation2.default(this, config);
	  };
	
	  AnimatedMultiplication.prototype.__attach = function __attach() {
	    this._a.__addChild(this);
	    this._b.__addChild(this);
	  };
	
	  AnimatedMultiplication.prototype.__detach = function __detach() {
	    this._a.__removeChild(this);
	    this._b.__removeChild(this);
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedMultiplication.prototype.__getNativeConfig = function __getNativeConfig() {
	    return {
	      type: 'multiplication',
	      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
	    };
	  };
	
	  return AnimatedMultiplication;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedMultiplication;
	module.exports = exports['default'];

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedTransform = __webpack_require__(1471);
	
	var _AnimatedTransform2 = _interopRequireDefault(_AnimatedTransform);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	var _StyleSheet = __webpack_require__(28);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var flattenStyle = _StyleSheet2.default.flatten;
	
	var AnimatedStyle = function (_AnimatedWithChildren) {
	  _inherits(AnimatedStyle, _AnimatedWithChildren);
	
	  function AnimatedStyle(style) {
	    _classCallCheck(this, AnimatedStyle);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    style = flattenStyle(style) || {};
	    if (style.transform) {
	      style = Object.assign({}, style, {
	        transform: new _AnimatedTransform2.default(style.transform)
	      });
	    }
	    _this._style = style;
	    return _this;
	  }
	
	  // Recursively get values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetValues = function _walkStyleAndGetValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof _AnimatedNode2.default) {
	        if (!value.__isNative) {
	          // We cannot use value of natively driven nodes this way as the value we have access from
	          // JS may not be up to date.
	          updatedStyle[key] = value.__getValue();
	        }
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetValues(value);
	      } else {
	        updatedStyle[key] = value;
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getValue = function __getValue() {
	    return this._walkStyleAndGetValues(this._style);
	  };
	
	  // Recursively get animated values for nested styles (like iOS's shadowOffset)
	
	
	  AnimatedStyle.prototype._walkStyleAndGetAnimatedValues = function _walkStyleAndGetAnimatedValues(style) {
	    var updatedStyle = {};
	    for (var key in style) {
	      var value = style[key];
	      if (value instanceof _AnimatedNode2.default) {
	        updatedStyle[key] = value.__getAnimatedValue();
	      } else if (value && !Array.isArray(value) && typeof value === 'object') {
	        // Support animating nested values (for example: shadowOffset.height)
	        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
	      }
	    }
	    return updatedStyle;
	  };
	
	  AnimatedStyle.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._walkStyleAndGetAnimatedValues(this._style);
	  };
	
	  AnimatedStyle.prototype.__attach = function __attach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof _AnimatedNode2.default) {
	        value.__addChild(this);
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__detach = function __detach() {
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof _AnimatedNode2.default) {
	        value.__removeChild(this);
	      }
	    }
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedStyle.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    for (var key in this._style) {
	      var value = this._style[key];
	      if (value instanceof _AnimatedNode2.default) {
	        value.__makeNative();
	      }
	    }
	  };
	
	  AnimatedStyle.prototype.__getNativeConfig = function __getNativeConfig() {
	    var styleConfig = {};
	    for (var styleKey in this._style) {
	      if (this._style[styleKey] instanceof _AnimatedNode2.default) {
	        styleConfig[styleKey] = this._style[styleKey].__getNativeTag();
	      }
	      // Non-animated styles are set using `setNativeProps`, no need
	      // to pass those as a part of the node config
	    }
	    _NativeAnimatedHelper2.default.validateStyles(styleConfig);
	    return {
	      type: 'style',
	      style: styleConfig
	    };
	  };
	
	  return AnimatedStyle;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedStyle;
	module.exports = exports['default'];

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedValue = __webpack_require__(57);
	
	var _AnimatedValue2 = _interopRequireDefault(_AnimatedValue);
	
	var _AnimatedNode2 = __webpack_require__(39);
	
	var _AnimatedNode3 = _interopRequireDefault(_AnimatedNode2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedTracking = function (_AnimatedNode) {
	  _inherits(AnimatedTracking, _AnimatedNode);
	
	  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
	    _classCallCheck(this, AnimatedTracking);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedNode.call(this));
	
	    _this._value = value;
	    _this._parent = parent;
	    _this._animationClass = animationClass;
	    _this._animationConfig = animationConfig;
	    _this._useNativeDriver = (0, _NativeAnimatedHelper.shouldUseNativeDriver)(animationConfig);
	    _this._callback = callback;
	    _this.__attach();
	    return _this;
	  }
	
	  AnimatedTracking.prototype.__makeNative = function __makeNative() {
	    this.__isNative = true;
	    this._parent.__makeNative();
	    _AnimatedNode.prototype.__makeNative.call(this);
	    this._value.__makeNative();
	  };
	
	  AnimatedTracking.prototype.__getValue = function __getValue() {
	    return this._parent.__getValue();
	  };
	
	  AnimatedTracking.prototype.__attach = function __attach() {
	    this._parent.__addChild(this);
	    if (this._useNativeDriver) {
	      // when the tracking starts we need to convert this node to a "native node"
	      // so that the parent node will be made "native" too. This is necessary as
	      // if we don't do this `update` method will get called. At that point it
	      // may be too late as it would mean the JS driver has already started
	      // updating node values
	      this.__makeNative();
	    }
	  };
	
	  AnimatedTracking.prototype.__detach = function __detach() {
	    this._parent.__removeChild(this);
	    _AnimatedNode.prototype.__detach.call(this);
	  };
	
	  AnimatedTracking.prototype.update = function update() {
	    this._value.animate(new this._animationClass(Object.assign({}, this._animationConfig, {
	      toValue: this._animationConfig.toValue.__getValue()
	    })), this._callback);
	  };
	
	  AnimatedTracking.prototype.__getNativeConfig = function __getNativeConfig() {
	    var animation = new this._animationClass(Object.assign({}, this._animationConfig, {
	      // remove toValue from the config as it's a ref to Animated.Value
	      toValue: undefined
	    }));
	    var animationConfig = animation.__getNativeAnimationConfig();
	    return {
	      type: 'tracking',
	      animationId: (0, _NativeAnimatedHelper.generateNewAnimationId)(),
	      animationConfig: animationConfig,
	      toValue: this._parent.__getNativeTag(),
	      value: this._value.__getNativeTag()
	    };
	  };
	
	  return AnimatedTracking;
	}(_AnimatedNode3.default);
	
	exports.default = AnimatedTracking;
	module.exports = exports['default'];

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _AnimatedNode = __webpack_require__(39);
	
	var _AnimatedNode2 = _interopRequireDefault(_AnimatedNode);
	
	var _AnimatedWithChildren2 = __webpack_require__(49);
	
	var _AnimatedWithChildren3 = _interopRequireDefault(_AnimatedWithChildren2);
	
	var _NativeAnimatedHelper = __webpack_require__(38);
	
	var _NativeAnimatedHelper2 = _interopRequireDefault(_NativeAnimatedHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimatedTransform = function (_AnimatedWithChildren) {
	  _inherits(AnimatedTransform, _AnimatedWithChildren);
	
	  function AnimatedTransform(transforms) {
	    _classCallCheck(this, AnimatedTransform);
	
	    var _this = _possibleConstructorReturn(this, _AnimatedWithChildren.call(this));
	
	    _this._transforms = transforms;
	    return _this;
	  }
	
	  AnimatedTransform.prototype.__makeNative = function __makeNative() {
	    _AnimatedWithChildren.prototype.__makeNative.call(this);
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          value.__makeNative();
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__getValue = function __getValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          result[key] = value.__getValue();
	        } else {
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__getAnimatedValue = function __getAnimatedValue() {
	    return this._transforms.map(function (transform) {
	      var result = {};
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          result[key] = value.__getAnimatedValue();
	        } else {
	          // All transform components needed to recompose matrix
	          result[key] = value;
	        }
	      }
	      return result;
	    });
	  };
	
	  AnimatedTransform.prototype.__attach = function __attach() {
	    var _this2 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          value.__addChild(_this2);
	        }
	      }
	    });
	  };
	
	  AnimatedTransform.prototype.__detach = function __detach() {
	    var _this3 = this;
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          value.__removeChild(_this3);
	        }
	      }
	    });
	    _AnimatedWithChildren.prototype.__detach.call(this);
	  };
	
	  AnimatedTransform.prototype.__getNativeConfig = function __getNativeConfig() {
	    var transConfigs = [];
	
	    this._transforms.forEach(function (transform) {
	      for (var key in transform) {
	        var value = transform[key];
	        if (value instanceof _AnimatedNode2.default) {
	          transConfigs.push({
	            type: 'animated',
	            property: key,
	            nodeTag: value.__getNativeTag()
	          });
	        } else {
	          transConfigs.push({
	            type: 'static',
	            property: key,
	            value: value
	          });
	        }
	      }
	    });
	
	    _NativeAnimatedHelper2.default.validateTransform(transConfigs);
	    return {
	      type: 'transform',
	      transforms: transConfigs
	    };
	  };
	
	  return AnimatedTransform;
	}(_AnimatedWithChildren3.default);
	
	exports.default = AnimatedTransform;
	module.exports = exports['default'];

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InteractionManager = __webpack_require__(126);
	
	var _InteractionManager2 = _interopRequireDefault(_InteractionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           */
	
	/**
	 * A simple class for batching up invocations of a low-pri callback. A timeout is set to run the
	 * callback once after a delay, no matter how many times it's scheduled. Once the delay is reached,
	 * InteractionManager.runAfterInteractions is used to invoke the callback after any hi-pri
	 * interactions are done running.
	 *
	 * Make sure to cleanup with dispose().  Example:
	 *
	 *   class Widget extends React.Component {
	 *     _batchedSave: new Batchinator(() => this._saveState, 1000);
	 *     _saveSate() {
	 *       // save this.state to disk
	 *     }
	 *     componentDidUpdate() {
	 *       this._batchedSave.schedule();
	 *     }
	 *     componentWillUnmount() {
	 *       this._batchedSave.dispose();
	 *     }
	 *     ...
	 *   }
	 */
	var Batchinator = function () {
	  function Batchinator(callback, delayMS) {
	    _classCallCheck(this, Batchinator);
	
	    this._delay = delayMS;
	    this._callback = callback;
	  }
	  /*
	   * Cleanup any pending tasks.
	   *
	   * By default, if there is a pending task the callback is run immediately. Set the option abort to
	   * true to not call the callback if it was pending.
	   */
	
	
	  Batchinator.prototype.dispose = function dispose() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { abort: false };
	
	    if (this._taskHandle) {
	      this._taskHandle.cancel();
	      if (!options.abort) {
	        this._callback();
	      }
	      this._taskHandle = null;
	    }
	  };
	
	  Batchinator.prototype.schedule = function schedule() {
	    var _this = this;
	
	    if (this._taskHandle) {
	      return;
	    }
	    var timeoutHandle = setTimeout(function () {
	      _this._taskHandle = _InteractionManager2.default.runAfterInteractions(function () {
	        // Note that we clear the handle before invoking the callback so that if the callback calls
	        // schedule again, it will actually schedule another task.
	        _this._taskHandle = null;
	        _this._callback();
	      });
	    }, this._delay);
	    this._taskHandle = { cancel: function cancel() {
	        return clearTimeout(timeoutHandle);
	      } };
	  };
	
	  return Batchinator;
	}();
	
	exports.default = Batchinator;
	module.exports = exports['default'];

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _performanceNow = __webpack_require__(1216);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _warning = __webpack_require__(19);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * 
	                                                                                                                                                           * @format
	                                                                                                                                                           */
	
	var Info = function Info() {
	  _classCallCheck(this, Info);
	
	  this.any_blank_count = 0;
	  this.any_blank_ms = 0;
	  this.any_blank_speed_sum = 0;
	  this.mostly_blank_count = 0;
	  this.mostly_blank_ms = 0;
	  this.pixels_blank = 0;
	  this.pixels_sampled = 0;
	  this.pixels_scrolled = 0;
	  this.total_time_spent = 0;
	  this.sample_count = 0;
	};
	
	var DEBUG = false;
	
	var _listeners = [];
	var _minSampleCount = 10;
	var _sampleRate = DEBUG ? 1 : null;
	
	/**
	 * A helper class for detecting when the maximem fill rate of `VirtualizedList` is exceeded.
	 * By default the sampling rate is set to zero and this will do nothing. If you want to collect
	 * samples (e.g. to log them), make sure to call `FillRateHelper.setSampleRate(0.0-1.0)`.
	 *
	 * Listeners and sample rate are global for all `VirtualizedList`s - typical usage will combine with
	 * `SceneTracker.getActiveScene` to determine the context of the events.
	 */
	
	var FillRateHelper = function () {
	  FillRateHelper.addListener = function addListener(callback) {
	    (0, _warning2.default)(_sampleRate !== null, 'Call `FillRateHelper.setSampleRate` before `addListener`.');
	    _listeners.push(callback);
	    return {
	      remove: function remove() {
	        _listeners = _listeners.filter(function (listener) {
	          return callback !== listener;
	        });
	      }
	    };
	  };
	
	  FillRateHelper.setSampleRate = function setSampleRate(sampleRate) {
	    _sampleRate = sampleRate;
	  };
	
	  FillRateHelper.setMinSampleCount = function setMinSampleCount(minSampleCount) {
	    _minSampleCount = minSampleCount;
	  };
	
	  function FillRateHelper(getFrameMetrics) {
	    _classCallCheck(this, FillRateHelper);
	
	    this._anyBlankStartTime = null;
	    this._enabled = false;
	    this._info = new Info();
	    this._mostlyBlankStartTime = null;
	    this._samplesStartTime = null;
	
	    this._getFrameMetrics = getFrameMetrics;
	    this._enabled = (_sampleRate || 0) > Math.random();
	    this._resetData();
	  }
	
	  FillRateHelper.prototype.activate = function activate() {
	    if (this._enabled && this._samplesStartTime == null) {
	      DEBUG && console.debug('FillRateHelper: activate');
	      this._samplesStartTime = (0, _performanceNow2.default)();
	    }
	  };
	
	  FillRateHelper.prototype.deactivateAndFlush = function deactivateAndFlush() {
	    if (!this._enabled) {
	      return;
	    }
	    var start = this._samplesStartTime; // const for flow
	    if (start == null) {
	      DEBUG && console.debug('FillRateHelper: bail on deactivate with no start time');
	      return;
	    }
	    if (this._info.sample_count < _minSampleCount) {
	      // Don't bother with under-sampled events.
	      this._resetData();
	      return;
	    }
	    var total_time_spent = (0, _performanceNow2.default)() - start;
	    var info = Object.assign({}, this._info, {
	      total_time_spent: total_time_spent
	    });
	    if (DEBUG) {
	      var derived = {
	        avg_blankness: this._info.pixels_blank / this._info.pixels_sampled,
	        avg_speed: this._info.pixels_scrolled / (total_time_spent / 1000),
	        avg_speed_when_any_blank: this._info.any_blank_speed_sum / this._info.any_blank_count,
	        any_blank_per_min: this._info.any_blank_count / (total_time_spent / 1000 / 60),
	        any_blank_time_frac: this._info.any_blank_ms / total_time_spent,
	        mostly_blank_per_min: this._info.mostly_blank_count / (total_time_spent / 1000 / 60),
	        mostly_blank_time_frac: this._info.mostly_blank_ms / total_time_spent
	      };
	      for (var key in derived) {
	        derived[key] = Math.round(1000 * derived[key]) / 1000;
	      }
	      console.debug('FillRateHelper deactivateAndFlush: ', { derived: derived, info: info });
	    }
	    _listeners.forEach(function (listener) {
	      return listener(info);
	    });
	    this._resetData();
	  };
	
	  FillRateHelper.prototype.computeBlankness = function computeBlankness(props, state, scrollMetrics) {
	    if (!this._enabled || props.getItemCount(props.data) === 0 || this._samplesStartTime == null) {
	      return 0;
	    }
	    var dOffset = scrollMetrics.dOffset,
	        offset = scrollMetrics.offset,
	        velocity = scrollMetrics.velocity,
	        visibleLength = scrollMetrics.visibleLength;
	
	    // Denominator metrics that we track for all events - most of the time there is no blankness and
	    // we want to capture that.
	
	    this._info.sample_count++;
	    this._info.pixels_sampled += Math.round(visibleLength);
	    this._info.pixels_scrolled += Math.round(Math.abs(dOffset));
	    var scrollSpeed = Math.round(Math.abs(velocity) * 1000); // px / sec
	
	    // Whether blank now or not, record the elapsed time blank if we were blank last time.
	    var now = (0, _performanceNow2.default)();
	    if (this._anyBlankStartTime != null) {
	      this._info.any_blank_ms += now - this._anyBlankStartTime;
	    }
	    this._anyBlankStartTime = null;
	    if (this._mostlyBlankStartTime != null) {
	      this._info.mostly_blank_ms += now - this._mostlyBlankStartTime;
	    }
	    this._mostlyBlankStartTime = null;
	
	    var blankTop = 0;
	    var first = state.first;
	    var firstFrame = this._getFrameMetrics(first);
	    while (first <= state.last && (!firstFrame || !firstFrame.inLayout)) {
	      firstFrame = this._getFrameMetrics(first);
	      first++;
	    }
	    // Only count blankTop if we aren't rendering the first item, otherwise we will count the header
	    // as blank.
	    if (firstFrame && first > 0) {
	      blankTop = Math.min(visibleLength, Math.max(0, firstFrame.offset - offset));
	    }
	    var blankBottom = 0;
	    var last = state.last;
	    var lastFrame = this._getFrameMetrics(last);
	    while (last >= state.first && (!lastFrame || !lastFrame.inLayout)) {
	      lastFrame = this._getFrameMetrics(last);
	      last--;
	    }
	    // Only count blankBottom if we aren't rendering the last item, otherwise we will count the
	    // footer as blank.
	    if (lastFrame && last < props.getItemCount(props.data) - 1) {
	      var bottomEdge = lastFrame.offset + lastFrame.length;
	      blankBottom = Math.min(visibleLength, Math.max(0, offset + visibleLength - bottomEdge));
	    }
	    var pixels_blank = Math.round(blankTop + blankBottom);
	    var blankness = pixels_blank / visibleLength;
	    if (blankness > 0) {
	      this._anyBlankStartTime = now;
	      this._info.any_blank_speed_sum += scrollSpeed;
	      this._info.any_blank_count++;
	      this._info.pixels_blank += pixels_blank;
	      if (blankness > 0.5) {
	        this._mostlyBlankStartTime = now;
	        this._info.mostly_blank_count++;
	      }
	    } else if (scrollSpeed < 0.01 || Math.abs(dOffset) < 1) {
	      this.deactivateAndFlush();
	    }
	    return blankness;
	  };
	
	  FillRateHelper.prototype.enabled = function enabled() {
	    return this._enabled;
	  };
	
	  FillRateHelper.prototype._resetData = function _resetData() {
	    this._anyBlankStartTime = null;
	    this._info = new Info();
	    this._mostlyBlankStartTime = null;
	    this._samplesStartTime = null;
	  };
	
	  return FillRateHelper;
	}();
	
	exports.default = FillRateHelper;
	module.exports = exports['default'];

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _UIManager = __webpack_require__(48);
	
	var _UIManager2 = _interopRequireDefault(_UIManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @noflow
	 * @format
	 */
	
	var __DEV__ = ({"NODE_ENV":"production","PUBLIC_URL":""}).NODE !== 'production';
	var checkPropTypes = _propTypes2.default.checkPropTypes;
	
	
	var Types = {
	  spring: 'spring',
	  linear: 'linear',
	  easeInEaseOut: 'easeInEaseOut',
	  easeIn: 'easeIn',
	  easeOut: 'easeOut',
	  keyboard: 'keyboard'
	};
	
	var Properties = {
	  opacity: 'opacity',
	  scaleX: 'scaleX',
	  scaleY: 'scaleY',
	  scaleXY: 'scaleXY'
	};
	
	var animType = _propTypes2.default.shape({
	  duration: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	  springDamping: _propTypes2.default.number,
	  initialVelocity: _propTypes2.default.number,
	  type: _propTypes2.default.oneOf(Object.keys(Types)).isRequired,
	  property: _propTypes2.default.oneOf(
	  // Only applies to create/delete
	  Object.keys(Properties))
	});
	
	var configType = _propTypes2.default.shape({
	  duration: _propTypes2.default.number.isRequired,
	  create: animType,
	  update: animType,
	  delete: animType
	});
	
	function checkConfig(config, location, name) {
	  checkPropTypes({ config: configType }, { config: config }, location, name);
	}
	
	function configureNext(config, onAnimationDidEnd) {
	  if (__DEV__) {
	    checkConfig(config, 'config', 'LayoutAnimation.configureNext');
	  }
	  _UIManager2.default.configureNextLayoutAnimation(config, onAnimationDidEnd || function () {}, function () {
	    /* unused */
	  });
	}
	
	function create(duration, type, creationProp) {
	  return {
	    duration: duration,
	    create: {
	      type: type,
	      property: creationProp
	    },
	    update: {
	      type: type
	    },
	    delete: {
	      type: type,
	      property: creationProp
	    }
	  };
	}
	
	var Presets = {
	  easeInEaseOut: create(300, Types.easeInEaseOut, Properties.opacity),
	  linear: create(500, Types.linear, Properties.opacity),
	  spring: {
	    duration: 700,
	    create: {
	      type: Types.linear,
	      property: Properties.opacity
	    },
	    update: {
	      type: Types.spring,
	      springDamping: 0.4
	    },
	    delete: {
	      type: Types.linear,
	      property: Properties.opacity
	    }
	  }
	};
	
	/**
	 * Automatically animates views to their new positions when the
	 * next layout happens.
	 *
	 * A common way to use this API is to call it before calling `setState`.
	 *
	 * Note that in order to get this to work on **Android** you need to set the following flags via `UIManager`:
	 *
	 *     UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true);
	 */
	var LayoutAnimation = {
	  /**
	   * Schedules an animation to happen on the next layout.
	   *
	   * @param config Specifies animation properties:
	   *
	   *   - `duration` in milliseconds
	   *   - `create`, config for animating in new views (see `Anim` type)
	   *   - `update`, config for animating views that have been updated
	   * (see `Anim` type)
	   *
	   * @param onAnimationDidEnd Called when the animation finished.
	   * Only supported on iOS.
	   * @param onError Called on error. Only supported on iOS.
	   */
	  configureNext: configureNext,
	  /**
	   * Helper for creating a config for `configureNext`.
	   */
	  create: create,
	  Types: Types,
	  Properties: Properties,
	  checkConfig: checkConfig,
	  Presets: Presets,
	  easeInEaseOut: configureNext.bind(null, Presets.easeInEaseOut),
	  linear: configureNext.bind(null, Presets.linear),
	  spring: configureNext.bind(null, Presets.spring)
	};
	
	exports.default = LayoutAnimation;
	module.exports = exports['default'];

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var __DEV__ = ("production") !== 'production';
	
	function cloneReferencedElement(element, config) {
	  var cloneRef = config.ref;
	  var originalRef = element.ref;
	
	  for (var _len = arguments.length, children = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    children[_key - 2] = arguments[_key];
	  }
	
	  if (originalRef == null || cloneRef == null) {
	    return _react2.default.cloneElement.apply(_react2.default, [element, config].concat(children));
	  }
	
	  if (typeof originalRef !== 'function') {
	    if (__DEV__) {
	      console.warn('Cloning an element with a ref that will be overwritten because it ' + 'is not a function. Use a composable callback-style ref instead. ' + 'Ignoring ref: ' + originalRef);
	    }
	    return _react2.default.cloneElement.apply(_react2.default, [element, config].concat(children));
	  }
	
	  return _react2.default.cloneElement.apply(_react2.default, [element, Object.assign({}, config, {
	    ref: function ref(component) {
	      cloneRef(component);
	      originalRef(component);
	    }
	  })].concat(children));
	}
	
	exports.default = cloneReferencedElement;
	module.exports = exports['default'];

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _InteractionManager = __webpack_require__(126);
	
	var _InteractionManager2 = _interopRequireDefault(_InteractionManager);
	
	var _TouchHistoryMath = __webpack_require__(1482);
	
	var _TouchHistoryMath2 = _interopRequireDefault(_TouchHistoryMath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var currentCentroidXOfTouchesChangedAfter = _TouchHistoryMath2.default.currentCentroidXOfTouchesChangedAfter;
	var currentCentroidYOfTouchesChangedAfter = _TouchHistoryMath2.default.currentCentroidYOfTouchesChangedAfter;
	var previousCentroidXOfTouchesChangedAfter = _TouchHistoryMath2.default.previousCentroidXOfTouchesChangedAfter;
	var previousCentroidYOfTouchesChangedAfter = _TouchHistoryMath2.default.previousCentroidYOfTouchesChangedAfter;
	var currentCentroidX = _TouchHistoryMath2.default.currentCentroidX;
	var currentCentroidY = _TouchHistoryMath2.default.currentCentroidY;
	
	/**
	 * `PanResponder` reconciles several touches into a single gesture. It makes
	 * single-touch gestures resilient to extra touches, and can be used to
	 * recognize simple multi-touch gestures.
	 *
	 * By default, `PanResponder` holds an `InteractionManager` handle to block
	 * long-running JS events from interrupting active gestures.
	 *
	 * It provides a predictable wrapper of the responder handlers provided by the
	 * [gesture responder system](docs/gesture-responder-system.html).
	 * For each handler, it provides a new `gestureState` object alongside the
	 * native event object:
	 *
	 * ```
	 * onPanResponderMove: (event, gestureState) => {}
	 * ```
	 *
	 * A native event is a synthetic touch event with the following form:
	 *
	 *  - `nativeEvent`
	 *      + `changedTouches` - Array of all touch events that have changed since the last event
	 *      + `identifier` - The ID of the touch
	 *      + `locationX` - The X position of the touch, relative to the element
	 *      + `locationY` - The Y position of the touch, relative to the element
	 *      + `pageX` - The X position of the touch, relative to the root element
	 *      + `pageY` - The Y position of the touch, relative to the root element
	 *      + `target` - The node id of the element receiving the touch event
	 *      + `timestamp` - A time identifier for the touch, useful for velocity calculation
	 *      + `touches` - Array of all current touches on the screen
	 *
	 * A `gestureState` object has the following:
	 *
	 *  - `stateID` - ID of the gestureState- persisted as long as there at least
	 *     one touch on screen
	 *  - `moveX` - the latest screen coordinates of the recently-moved touch
	 *  - `moveY` - the latest screen coordinates of the recently-moved touch
	 *  - `x0` - the screen coordinates of the responder grant
	 *  - `y0` - the screen coordinates of the responder grant
	 *  - `dx` - accumulated distance of the gesture since the touch started
	 *  - `dy` - accumulated distance of the gesture since the touch started
	 *  - `vx` - current velocity of the gesture
	 *  - `vy` - current velocity of the gesture
	 *  - `numberActiveTouches` - Number of touches currently on screen
	 *
	 * ### Basic Usage
	 *
	 * ```
	 *   componentWillMount: function() {
	 *     this._panResponder = PanResponder.create({
	 *       // Ask to be the responder:
	 *       onStartShouldSetPanResponder: (evt, gestureState) => true,
	 *       onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
	 *       onMoveShouldSetPanResponder: (evt, gestureState) => true,
	 *       onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
	 *
	 *       onPanResponderGrant: (evt, gestureState) => {
	 *         // The gesture has started. Show visual feedback so the user knows
	 *         // what is happening!
	 *
	 *         // gestureState.d{x,y} will be set to zero now
	 *       },
	 *       onPanResponderMove: (evt, gestureState) => {
	 *         // The most recent move distance is gestureState.move{X,Y}
	 *
	 *         // The accumulated gesture distance since becoming responder is
	 *         // gestureState.d{x,y}
	 *       },
	 *       onPanResponderTerminationRequest: (evt, gestureState) => true,
	 *       onPanResponderRelease: (evt, gestureState) => {
	 *         // The user has released all touches while this view is the
	 *         // responder. This typically means a gesture has succeeded
	 *       },
	 *       onPanResponderTerminate: (evt, gestureState) => {
	 *         // Another component has become the responder, so this gesture
	 *         // should be cancelled
	 *       },
	 *       onShouldBlockNativeResponder: (evt, gestureState) => {
	 *         // Returns whether this component should block native components from becoming the JS
	 *         // responder. Returns true by default. Is currently only supported on android.
	 *         return true;
	 *       },
	 *     });
	 *   },
	 *
	 *   render: function() {
	 *     return (
	 *       <View {...this._panResponder.panHandlers} />
	 *     );
	 *   },
	 *
	 * ```
	 *
	 * ### Working Example
	 *
	 * To see it in action, try the
	 * [PanResponder example in RNTester](https://github.com/facebook/react-native/blob/master/RNTester/js/PanResponderExample.js)
	 */
	
	var PanResponder = {
	
	  /**
	   *
	   * A graphical explanation of the touch data flow:
	   *
	   * +----------------------------+             +--------------------------------+
	   * | ResponderTouchHistoryStore |             |TouchHistoryMath                |
	   * +----------------------------+             +----------+---------------------+
	   * |Global store of touchHistory|             |Allocation-less math util       |
	   * |including activeness, start |             |on touch history (centroids     |
	   * |position, prev/cur position.|             |and multitouch movement etc)    |
	   * |                            |             |                                |
	   * +----^-----------------------+             +----^---------------------------+
	   *      |                                          |
	   *      | (records relevant history                |
	   *      |  of touches relevant for                 |
	   *      |  implementing higher level               |
	   *      |  gestures)                               |
	   *      |                                          |
	   * +----+-----------------------+             +----|---------------------------+
	   * | ResponderEventPlugin       |             |    |   Your App/Component      |
	   * +----------------------------+             +----|---------------------------+
	   * |Negotiates which view gets  | Low level   |    |             High level    |
	   * |onResponderMove events.     | events w/   |  +-+-------+     events w/     |
	   * |Also records history into   | touchHistory|  |   Pan   |     multitouch +  |
	   * |ResponderTouchHistoryStore. +---------------->Responder+-----> accumulative|
	   * +----------------------------+ attached to |  |         |     distance and  |
	   *                                 each event |  +---------+     velocity.     |
	   *                                            |                                |
	   *                                            |                                |
	   *                                            +--------------------------------+
	   *
	   *
	   *
	   * Gesture that calculates cumulative movement over time in a way that just
	   * "does the right thing" for multiple touches. The "right thing" is very
	   * nuanced. When moving two touches in opposite directions, the cumulative
	   * distance is zero in each dimension. When two touches move in parallel five
	   * pixels in the same direction, the cumulative distance is five, not ten. If
	   * two touches start, one moves five in a direction, then stops and the other
	   * touch moves fives in the same direction, the cumulative distance is ten.
	   *
	   * This logic requires a kind of processing of time "clusters" of touch events
	   * so that two touch moves that essentially occur in parallel but move every
	   * other frame respectively, are considered part of the same movement.
	   *
	   * Explanation of some of the non-obvious fields:
	   *
	   * - moveX/moveY: If no move event has been observed, then `(moveX, moveY)` is
	   *   invalid. If a move event has been observed, `(moveX, moveY)` is the
	   *   centroid of the most recently moved "cluster" of active touches.
	   *   (Currently all move have the same timeStamp, but later we should add some
	   *   threshold for what is considered to be "moving"). If a palm is
	   *   accidentally counted as a touch, but a finger is moving greatly, the palm
	   *   will move slightly, but we only want to count the single moving touch.
	   * - x0/y0: Centroid location (non-cumulative) at the time of becoming
	   *   responder.
	   * - dx/dy: Cumulative touch distance - not the same thing as sum of each touch
	   *   distance. Accounts for touch moves that are clustered together in time,
	   *   moving the same direction. Only valid when currently responder (otherwise,
	   *   it only represents the drag distance below the threshold).
	   * - vx/vy: Velocity.
	   */
	
	  _initializeGestureState: function _initializeGestureState(gestureState) {
	    gestureState.moveX = 0;
	    gestureState.moveY = 0;
	    gestureState.x0 = 0;
	    gestureState.y0 = 0;
	    gestureState.dx = 0;
	    gestureState.dy = 0;
	    gestureState.vx = 0;
	    gestureState.vy = 0;
	    gestureState.numberActiveTouches = 0;
	    // All `gestureState` accounts for timeStamps up until:
	    gestureState._accountsForMovesUpTo = 0;
	  },
	
	  /**
	   * This is nuanced and is necessary. It is incorrect to continuously take all
	   * active *and* recently moved touches, find the centroid, and track how that
	   * result changes over time. Instead, we must take all recently moved
	   * touches, and calculate how the centroid has changed just for those
	   * recently moved touches, and append that change to an accumulator. This is
	   * to (at least) handle the case where the user is moving three fingers, and
	   * then one of the fingers stops but the other two continue.
	   *
	   * This is very different than taking all of the recently moved touches and
	   * storing their centroid as `dx/dy`. For correctness, we must *accumulate
	   * changes* in the centroid of recently moved touches.
	   *
	   * There is also some nuance with how we handle multiple moved touches in a
	   * single event. With the way `ReactNativeEventEmitter` dispatches touches as
	   * individual events, multiple touches generate two 'move' events, each of
	   * them triggering `onResponderMove`. But with the way `PanResponder` works,
	   * all of the gesture inference is performed on the first dispatch, since it
	   * looks at all of the touches (even the ones for which there hasn't been a
	   * native dispatch yet). Therefore, `PanResponder` does not call
	   * `onResponderMove` passed the first dispatch. This diverges from the
	   * typical responder callback pattern (without using `PanResponder`), but
	   * avoids more dispatches than necessary.
	   */
	  _updateGestureStateOnMove: function _updateGestureStateOnMove(gestureState, touchHistory) {
	    gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
	    gestureState.moveX = currentCentroidXOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
	    gestureState.moveY = currentCentroidYOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
	    var movedAfter = gestureState._accountsForMovesUpTo;
	    var prevX = previousCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
	    var x = currentCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
	    var prevY = previousCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
	    var y = currentCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
	    var nextDX = gestureState.dx + (x - prevX);
	    var nextDY = gestureState.dy + (y - prevY);
	
	    // TODO: This must be filtered intelligently.
	    var dt = touchHistory.mostRecentTimeStamp - gestureState._accountsForMovesUpTo;
	    gestureState.vx = (nextDX - gestureState.dx) / dt;
	    gestureState.vy = (nextDY - gestureState.dy) / dt;
	
	    gestureState.dx = nextDX;
	    gestureState.dy = nextDY;
	    gestureState._accountsForMovesUpTo = touchHistory.mostRecentTimeStamp;
	  },
	
	  /**
	   * @param {object} config Enhanced versions of all of the responder callbacks
	   * that provide not only the typical `ResponderSyntheticEvent`, but also the
	   * `PanResponder` gesture state.  Simply replace the word `Responder` with
	   * `PanResponder` in each of the typical `onResponder*` callbacks. For
	   * example, the `config` object would look like:
	   *
	   *  - `onMoveShouldSetPanResponder: (e, gestureState) => {...}`
	   *  - `onMoveShouldSetPanResponderCapture: (e, gestureState) => {...}`
	   *  - `onStartShouldSetPanResponder: (e, gestureState) => {...}`
	   *  - `onStartShouldSetPanResponderCapture: (e, gestureState) => {...}`
	   *  - `onPanResponderReject: (e, gestureState) => {...}`
	   *  - `onPanResponderGrant: (e, gestureState) => {...}`
	   *  - `onPanResponderStart: (e, gestureState) => {...}`
	   *  - `onPanResponderEnd: (e, gestureState) => {...}`
	   *  - `onPanResponderRelease: (e, gestureState) => {...}`
	   *  - `onPanResponderMove: (e, gestureState) => {...}`
	   *  - `onPanResponderTerminate: (e, gestureState) => {...}`
	   *  - `onPanResponderTerminationRequest: (e, gestureState) => {...}`
	   *  - `onShouldBlockNativeResponder: (e, gestureState) => {...}`
	   *
	   *  In general, for events that have capture equivalents, we update the
	   *  gestureState once in the capture phase and can use it in the bubble phase
	   *  as well.
	   *
	   *  Be careful with onStartShould* callbacks. They only reflect updated
	   *  `gestureState` for start/end events that bubble/capture to the Node.
	   *  Once the node is the responder, you can rely on every start/end event
	   *  being processed by the gesture and `gestureState` being updated
	   *  accordingly. (numberActiveTouches) may not be totally accurate unless you
	   *  are the responder.
	   */
	  create: function create(config) {
	    var interactionState = {
	      handle: null
	    };
	    var gestureState = {
	      // Useful for debugging
	      stateID: Math.random()
	    };
	    PanResponder._initializeGestureState(gestureState);
	    var panHandlers = {
	      onStartShouldSetResponder: function onStartShouldSetResponder(e) {
	        return config.onStartShouldSetPanResponder === undefined ? false : config.onStartShouldSetPanResponder(e, gestureState);
	      },
	      onMoveShouldSetResponder: function onMoveShouldSetResponder(e) {
	        return config.onMoveShouldSetPanResponder === undefined ? false : config.onMoveShouldSetPanResponder(e, gestureState);
	      },
	      onStartShouldSetResponderCapture: function onStartShouldSetResponderCapture(e) {
	        // TODO: Actually, we should reinitialize the state any time
	        // touches.length increases from 0 active to > 0 active.
	        if (e.nativeEvent.touches.length === 1) {
	          PanResponder._initializeGestureState(gestureState);
	        }
	        gestureState.numberActiveTouches = e.touchHistory.numberActiveTouches;
	        return config.onStartShouldSetPanResponderCapture !== undefined ? config.onStartShouldSetPanResponderCapture(e, gestureState) : false;
	      },
	
	      onMoveShouldSetResponderCapture: function onMoveShouldSetResponderCapture(e) {
	        var touchHistory = e.touchHistory;
	        // Responder system incorrectly dispatches should* to current responder
	        // Filter out any touch moves past the first one - we would have
	        // already processed multi-touch geometry during the first event.
	        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
	          return false;
	        }
	        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
	        return config.onMoveShouldSetPanResponderCapture ? config.onMoveShouldSetPanResponderCapture(e, gestureState) : false;
	      },
	
	      onResponderGrant: function onResponderGrant(e) {
	        if (!interactionState.handle) {
	          interactionState.handle = _InteractionManager2.default.createInteractionHandle();
	        }
	        gestureState.x0 = currentCentroidX(e.touchHistory);
	        gestureState.y0 = currentCentroidY(e.touchHistory);
	        gestureState.dx = 0;
	        gestureState.dy = 0;
	        if (config.onPanResponderGrant) {
	          config.onPanResponderGrant(e, gestureState);
	        }
	        // TODO: t7467124 investigate if this can be removed
	        return config.onShouldBlockNativeResponder === undefined ? true : config.onShouldBlockNativeResponder();
	      },
	
	      onResponderReject: function onResponderReject(e) {
	        clearInteractionHandle(interactionState, config.onPanResponderReject, e, gestureState);
	      },
	
	      onResponderRelease: function onResponderRelease(e) {
	        clearInteractionHandle(interactionState, config.onPanResponderRelease, e, gestureState);
	        PanResponder._initializeGestureState(gestureState);
	      },
	
	      onResponderStart: function onResponderStart(e) {
	        var touchHistory = e.touchHistory;
	        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
	        if (config.onPanResponderStart) {
	          config.onPanResponderStart(e, gestureState);
	        }
	      },
	
	      onResponderMove: function onResponderMove(e) {
	        var touchHistory = e.touchHistory;
	        // Guard against the dispatch of two touch moves when there are two
	        // simultaneously changed touches.
	        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
	          return;
	        }
	        // Filter out any touch moves past the first one - we would have
	        // already processed multi-touch geometry during the first event.
	        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);
	        if (config.onPanResponderMove) {
	          config.onPanResponderMove(e, gestureState);
	        }
	      },
	
	      onResponderEnd: function onResponderEnd(e) {
	        var touchHistory = e.touchHistory;
	        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
	        clearInteractionHandle(interactionState, config.onPanResponderEnd, e, gestureState);
	      },
	
	      onResponderTerminate: function onResponderTerminate(e) {
	        clearInteractionHandle(interactionState, config.onPanResponderTerminate, e, gestureState);
	        PanResponder._initializeGestureState(gestureState);
	      },
	
	      onResponderTerminationRequest: function onResponderTerminationRequest(e) {
	        return config.onPanResponderTerminationRequest === undefined ? true : config.onPanResponderTerminationRequest(e, gestureState);
	      }
	    };
	    return {
	      panHandlers: panHandlers,
	      getInteractionHandle: function getInteractionHandle() {
	        return interactionState.handle;
	      }
	    };
	  }
	};
	
	function clearInteractionHandle(interactionState, callback, event, gestureState) {
	  if (interactionState.handle) {
	    _InteractionManager2.default.clearInteractionHandle(interactionState.handle);
	    interactionState.handle = null;
	  }
	  if (callback) {
	    callback(event, gestureState);
	  }
	}
	
	exports.default = PanResponder;
	module.exports = exports['default'];

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _UnimplementedView = __webpack_require__(68);
	
	var _UnimplementedView2 = _interopRequireDefault(_UnimplementedView);
	
	var _Platform = __webpack_require__(106);
	
	var _Platform2 = _interopRequireDefault(_Platform);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ScrollView = __webpack_require__(107);
	
	var _ScrollView2 = _interopRequireDefault(_ScrollView);
	
	var _VirtualizedSectionList = __webpack_require__(1485);
	
	var _VirtualizedSectionList2 = _interopRequireDefault(_VirtualizedSectionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @noflow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var defaultProps = Object.assign({}, _VirtualizedSectionList2.default.defaultProps, {
	  stickySectionHeadersEnabled: _Platform2.default.OS === 'ios'
	});
	
	/**
	 * A performant interface for rendering sectioned lists, supporting the most handy features:
	 *
	 *  - Fully cross-platform.
	 *  - Configurable viewability callbacks.
	 *  - List header support.
	 *  - List footer support.
	 *  - Item separator support.
	 *  - Section header support.
	 *  - Section separator support.
	 *  - Heterogeneous data and item rendering support.
	 *  - Pull to Refresh.
	 *  - Scroll loading.
	 *
	 * If you don't need section support and want a simpler interface, use
	 * [`<FlatList>`](/react-native/docs/flatlist.html).
	 *
	 * Simple Examples:
	 *
	 *     <SectionList
	 *       renderItem={({item}) => <ListItem title={item} />}
	 *       renderSectionHeader={({section}) => <Header title={section.title} />}
	 *       sections={[ // homogeneous rendering between sections
	 *         {data: [...], title: ...},
	 *         {data: [...], title: ...},
	 *         {data: [...], title: ...},
	 *       ]}
	 *     />
	 *
	 *     <SectionList
	 *       sections={[ // heterogeneous rendering between sections
	 *         {data: [...], renderItem: ...},
	 *         {data: [...], renderItem: ...},
	 *         {data: [...], renderItem: ...},
	 *       ]}
	 *     />
	 *
	 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
	 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
	 * here, along with the following caveats:
	 *
	 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
	 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
	 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
	 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
	 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
	 *   changes. This includes the `data` prop and parent component state.
	 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
	 *   offscreen. This means it's possible to scroll faster than the fill rate and momentarily see
	 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
	 *   and we are working on improving it behind the scenes.
	 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
	 *   Alternatively, you can provide a custom `keyExtractor` prop.
	 *
	 */
	var SectionList = function (_React$PureComponent) {
	  _inherits(SectionList, _React$PureComponent);
	
	  function SectionList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SectionList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this._captureRef = function (ref) {
	      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	       * suppresses an error when upgrading Flow's support for React. To see the
	       * error delete this comment and run Flow. */
	      _this._wrapperListRef = ref;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Scrolls to the item at the specified `sectionIndex` and `itemIndex` (within the section)
	   * positioned in the viewable area such that `viewPosition` 0 places it at the top (and may be
	   * covered by a sticky header), 1 at the bottom, and 0.5 centered in the middle. `viewOffset` is a
	   * fixed number of pixels to offset the final target position, e.g. to compensate for sticky
	   * headers.
	   *
	   * Note: cannot scroll to locations outside the render window without specifying the
	   * `getItemLayout` prop.
	   */
	  SectionList.prototype.scrollToLocation = function scrollToLocation(params) {
	    this._wrapperListRef.scrollToLocation(params);
	  };
	
	  /**
	   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
	   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
	   * taps on items or by navigation actions.
	   */
	
	
	  SectionList.prototype.recordInteraction = function recordInteraction() {
	    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
	    listRef && listRef.recordInteraction();
	  };
	
	  /**
	   * Displays the scroll indicators momentarily.
	   *
	   * @platform ios
	   */
	
	
	  SectionList.prototype.flashScrollIndicators = function flashScrollIndicators() {
	    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
	    listRef && listRef.flashScrollIndicators();
	  };
	
	  /**
	   * Provides a handle to the underlying scroll responder.
	   */
	
	
	  SectionList.prototype.getScrollResponder = function getScrollResponder() {
	    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
	    if (listRef) {
	      return listRef.getScrollResponder();
	    }
	  };
	
	  SectionList.prototype.getScrollableNode = function getScrollableNode() {
	    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
	    if (listRef) {
	      return listRef.getScrollableNode();
	    }
	  };
	
	  SectionList.prototype.setNativeProps = function setNativeProps(props) {
	    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();
	    if (listRef) {
	      listRef.setNativeProps(props);
	    }
	  };
	
	  SectionList.prototype.render = function render() {
	    var List = this.props.legacyImplementation ? _UnimplementedView2.default : _VirtualizedSectionList2.default;
	    /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
	     * error found when Flow v0.66 was deployed. To see the error delete this
	     * comment and run Flow. */
	    return _react2.default.createElement(List, _extends({}, this.props, { ref: this._captureRef }));
	  };
	
	  return SectionList;
	}(_react2.default.PureComponent);
	
	SectionList.defaultProps = defaultProps;
	exports.default = SectionList;
	module.exports = exports['default'];

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Nicolas Gallagher.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Renders static content efficiently by allowing React to short-circuit the
	 * reconciliation process. This component should be used when you know that a
	 * subtree of components will never need to be updated.
	 *
	 *   const someValue = ...; // We know for certain this value will never change.
	 *   return (
	 *     <StaticRenderer render={() => <MyComponent value={someValue} />} />
	 *   );
	 *
	 * Typically, you will not need to use this component and should opt for normal
	 * React reconciliation.
	 */
	
	var StaticRenderer = function (_Component) {
	  _inherits(StaticRenderer, _Component);
	
	  function StaticRenderer() {
	    _classCallCheck(this, StaticRenderer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StaticRenderer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.shouldUpdate;
	  };
	
	  StaticRenderer.prototype.render = function render() {
	    return this.props.render();
	  };
	
	  return StaticRenderer;
	}(_react.Component);
	
	exports.default = StaticRenderer;
	StaticRenderer.propTypes =  false ? {
	  render: _propTypes.func.isRequired,
	  shouldUpdate: _propTypes.bool.isRequired
	} : {};
	module.exports = exports['default'];

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule SwipeableFlatList
	 * @noflow
	 * @format
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SwipeableRow = __webpack_require__(1068);
	
	var _SwipeableRow2 = _interopRequireDefault(_SwipeableRow);
	
	var _FlatList = __webpack_require__(1063);
	
	var _FlatList2 = _interopRequireDefault(_FlatList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A container component that renders multiple SwipeableRow's in a FlatList
	 * implementation. This is designed to be a drop-in replacement for the
	 * standard React Native `FlatList`, so use it as if it were a FlatList, but
	 * with extra props, i.e.
	 *
	 * <SwipeableListView renderRow={..} renderQuickActions={..} {..FlatList props} />
	 *
	 * SwipeableRow can be used independently of this component, but the main
	 * benefit of using this component is
	 *
	 * - It ensures that at most 1 row is swiped open (auto closes others)
	 * - It can bounce the 1st row of the list so users know it's swipeable
	 * - Increase performance on iOS by locking list swiping when row swiping is occurring
	 * - More to come
	 */
	
	var SwipeableFlatList = function (_React$Component) {
	  _inherits(SwipeableFlatList, _React$Component);
	
	  function SwipeableFlatList(props, context) {
	    _classCallCheck(this, SwipeableFlatList);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this._flatListRef = null;
	    _this._shouldBounceFirstRowOnMount = false;
	
	    _this._onScroll = function (e) {
	      // Close any opens rows on ListView scroll
	      if (_this.state.openRowKey) {
	        _this.setState({
	          openRowKey: null
	        });
	      }
	
	      _this.props.onScroll && _this.props.onScroll(e);
	    };
	
	    _this._renderItem = function (info) {
	      var slideoutView = _this.props.renderQuickActions(info);
	      var key = _this.props.keyExtractor(info.item, info.index);
	
	      // If renderQuickActions is unspecified or returns falsey, don't allow swipe
	      if (!slideoutView) {
	        return _this.props.renderItem(info);
	      }
	
	      var shouldBounceOnMount = false;
	      if (_this._shouldBounceFirstRowOnMount) {
	        _this._shouldBounceFirstRowOnMount = false;
	        shouldBounceOnMount = true;
	      }
	
	      return _react2.default.createElement(
	        _SwipeableRow2.default,
	        {
	          slideoutView: slideoutView,
	          isOpen: key === _this.state.openRowKey,
	          maxSwipeDistance: _this._getMaxSwipeDistance(info),
	          onOpen: function onOpen() {
	            return _this._onOpen(key);
	          },
	          onClose: function onClose() {
	            return _this._onClose(key);
	          },
	          shouldBounceOnMount: shouldBounceOnMount,
	          onSwipeEnd: _this._setListViewScrollable,
	          onSwipeStart: _this._setListViewNotScrollable },
	        _this.props.renderItem(info)
	      );
	    };
	
	    _this._setListViewScrollable = function () {
	      _this._setListViewScrollableTo(true);
	    };
	
	    _this._setListViewNotScrollable = function () {
	      _this._setListViewScrollableTo(false);
	    };
	
	    _this.state = {
	      openRowKey: null
	    };
	
	    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
	    return _this;
	  }
	
	  SwipeableFlatList.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_FlatList2.default, _extends({}, this.props, {
	      ref: function ref(_ref) {
	        _this2._flatListRef = _ref;
	      },
	      onScroll: this._onScroll,
	      renderItem: this._renderItem
	    }));
	  };
	
	  // This enables rows having variable width slideoutView.
	  SwipeableFlatList.prototype._getMaxSwipeDistance = function _getMaxSwipeDistance(info) {
	    if (typeof this.props.maxSwipeDistance === 'function') {
	      return this.props.maxSwipeDistance(info);
	    }
	
	    return this.props.maxSwipeDistance;
	  };
	
	  SwipeableFlatList.prototype._setListViewScrollableTo = function _setListViewScrollableTo(value) {
	    if (this._flatListRef) {
	      this._flatListRef.setNativeProps({
	        scrollEnabled: value
	      });
	    }
	  };
	
	  SwipeableFlatList.prototype._onOpen = function _onOpen(key) {
	    this.setState({
	      openRowKey: key
	    });
	  };
	
	  SwipeableFlatList.prototype._onClose = function _onClose(key) {
	    this.setState({
	      openRowKey: null
	    });
	  };
	
	  return SwipeableFlatList;
	}(_react2.default.Component);
	
	SwipeableFlatList.defaultProps = Object.assign({}, _FlatList2.default.defaultProps, {
	  bounceFirstRowOnMount: true,
	  renderQuickActions: function renderQuickActions() {
	    return null;
	  }
	});
	SwipeableFlatList.propTypes =  false ? Object.assign({}, _FlatList2.default.propTypes, {
	
	  /**
	   * To alert the user that swiping is possible, the first row can bounce
	   * on component mount.
	   */
	  bounceFirstRowOnMount: _propTypes2.default.bool.isRequired,
	
	  // Maximum distance to open to after a swipe
	  maxSwipeDistance: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  // Callback method to render the view that will be unveiled on swipe
	  renderQuickActions: _propTypes2.default.func.isRequired
	}) : {};
	exports.default = SwipeableFlatList;
	module.exports = exports['default'];

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule SwipeableListViewDataSource
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _ListViewDataSource = __webpack_require__(1064);
	
	var _ListViewDataSource2 = _interopRequireDefault(_ListViewDataSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Data source wrapper around ListViewDataSource to allow for tracking of
	 * which row is swiped open and close opened row(s) when another row is swiped
	 * open.
	 *
	 * See https://github.com/facebook/react-native/pull/5602 for why
	 * ListViewDataSource is not subclassed.
	 */
	var SwipeableListViewDataSource = function () {
	  function SwipeableListViewDataSource(params) {
	    var _this = this;
	
	    _classCallCheck(this, SwipeableListViewDataSource);
	
	    this._dataSource = new _ListViewDataSource2.default({
	      getRowData: params.getRowData,
	      getSectionHeaderData: params.getSectionHeaderData,
	      rowHasChanged: function rowHasChanged(row1, row2) {
	        /**
	         * Row needs to be re-rendered if its swiped open/close status is
	         * changed, or its data blob changed.
	         */
	        return row1.id !== _this._previousOpenRowID && row2.id === _this._openRowID || row1.id === _this._previousOpenRowID && row2.id !== _this._openRowID || params.rowHasChanged(row1, row2);
	      },
	      sectionHeaderHasChanged: params.sectionHeaderHasChanged
	    });
	  }
	
	  SwipeableListViewDataSource.prototype.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
	    this._dataSource = this._dataSource.cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities);
	
	    this._dataBlob = dataBlob;
	    this.rowIdentities = this._dataSource.rowIdentities;
	    this.sectionIdentities = this._dataSource.sectionIdentities;
	
	    return this;
	  };
	
	  // For the actual ListView to use
	
	
	  SwipeableListViewDataSource.prototype.getDataSource = function getDataSource() {
	    return this._dataSource;
	  };
	
	  SwipeableListViewDataSource.prototype.getOpenRowID = function getOpenRowID() {
	    return this._openRowID;
	  };
	
	  SwipeableListViewDataSource.prototype.getFirstRowID = function getFirstRowID() {
	    /**
	     * If rowIdentities is specified, find the first data row from there since
	     * we don't want to attempt to bounce section headers. If unspecified, find
	     * the first data row from _dataBlob.
	     */
	    if (this.rowIdentities) {
	      return this.rowIdentities[0] && this.rowIdentities[0][0];
	    }
	    return Object.keys(this._dataBlob)[0];
	  };
	
	  SwipeableListViewDataSource.prototype.getLastRowID = function getLastRowID() {
	    if (this.rowIdentities && this.rowIdentities.length) {
	      var lastSection = this.rowIdentities[this.rowIdentities.length - 1];
	      if (lastSection && lastSection.length) {
	        return lastSection[lastSection.length - 1];
	      }
	    }
	    return Object.keys(this._dataBlob)[this._dataBlob.length - 1];
	  };
	
	  SwipeableListViewDataSource.prototype.setOpenRowID = function setOpenRowID(rowID) {
	    this._previousOpenRowID = this._openRowID;
	    this._openRowID = rowID;
	
	    this._dataSource = this._dataSource.cloneWithRowsAndSections(this._dataBlob, this.sectionIdentities, this.rowIdentities);
	
	    return this;
	  };
	
	  return SwipeableListViewDataSource;
	}();
	
	exports.default = SwipeableListViewDataSource;
	module.exports = exports['default'];

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule SwipeableListView
	 * @noflow
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ListView = __webpack_require__(1065);
	
	var _ListView2 = _interopRequireDefault(_ListView);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SwipeableListViewDataSource = __webpack_require__(1480);
	
	var _SwipeableListViewDataSource2 = _interopRequireDefault(_SwipeableListViewDataSource);
	
	var _SwipeableRow = __webpack_require__(1068);
	
	var _SwipeableRow2 = _interopRequireDefault(_SwipeableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A container component that renders multiple SwipeableRow's in a ListView
	 * implementation. This is designed to be a drop-in replacement for the
	 * standard React Native `ListView`, so use it as if it were a ListView, but
	 * with extra props, i.e.
	 *
	 * let ds = SwipeableListView.getNewDataSource();
	 * ds.cloneWithRowsAndSections(dataBlob, ?sectionIDs, ?rowIDs);
	 * // ..
	 * <SwipeableListView renderRow={..} renderQuickActions={..} {..ListView props} />
	 *
	 * SwipeableRow can be used independently of this component, but the main
	 * benefit of using this component is
	 *
	 * - It ensures that at most 1 row is swiped open (auto closes others)
	 * - It can bounce the 1st row of the list so users know it's swipeable
	 * - More to come
	 */
	var SwipeableListView = function (_React$Component) {
	  _inherits(SwipeableListView, _React$Component);
	
	  SwipeableListView.getNewDataSource = function getNewDataSource() {
	    return new _SwipeableListViewDataSource2.default({
	      getRowData: function getRowData(data, sectionID, rowID) {
	        return data[sectionID][rowID];
	      },
	      getSectionHeaderData: function getSectionHeaderData(data, sectionID) {
	        return data[sectionID];
	      },
	      rowHasChanged: function rowHasChanged(row1, row2) {
	        return row1 !== row2;
	      },
	      sectionHeaderHasChanged: function sectionHeaderHasChanged(s1, s2) {
	        return s1 !== s2;
	      }
	    });
	  };
	
	  function SwipeableListView(props, context) {
	    _classCallCheck(this, SwipeableListView);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this._listViewRef = null;
	    _this._shouldBounceFirstRowOnMount = false;
	
	    _this._onScroll = function (e) {
	      // Close any opens rows on ListView scroll
	      if (_this.props.dataSource.getOpenRowID()) {
	        _this.setState({
	          dataSource: _this.state.dataSource.setOpenRowID(null)
	        });
	      }
	      _this.props.onScroll && _this.props.onScroll(e);
	    };
	
	    _this._renderRow = function (rowData, sectionID, rowID) {
	      var slideoutView = _this.props.renderQuickActions(rowData, sectionID, rowID);
	
	      // If renderQuickActions is unspecified or returns falsey, don't allow swipe
	      if (!slideoutView) {
	        return _this.props.renderRow(rowData, sectionID, rowID);
	      }
	
	      var shouldBounceOnMount = false;
	      if (_this._shouldBounceFirstRowOnMount) {
	        _this._shouldBounceFirstRowOnMount = false;
	        shouldBounceOnMount = rowID === _this.props.dataSource.getFirstRowID();
	      }
	
	      return _react2.default.createElement(
	        _SwipeableRow2.default,
	        {
	          slideoutView: slideoutView,
	          isOpen: rowData.id === _this.props.dataSource.getOpenRowID(),
	          maxSwipeDistance: _this._getMaxSwipeDistance(rowData, sectionID, rowID),
	          key: rowID,
	          onOpen: function onOpen() {
	            return _this._onOpen(rowData.id);
	          },
	          onClose: function onClose() {
	            return _this._onClose(rowData.id);
	          },
	          onSwipeEnd: function onSwipeEnd() {
	            return _this._setListViewScrollable(true);
	          },
	          onSwipeStart: function onSwipeStart() {
	            return _this._setListViewScrollable(false);
	          },
	          shouldBounceOnMount: shouldBounceOnMount },
	        _this.props.renderRow(rowData, sectionID, rowID)
	      );
	    };
	
	    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  SwipeableListView.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (this.state.dataSource.getDataSource() !== nextProps.dataSource.getDataSource()) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  };
	
	  SwipeableListView.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(_ListView2.default, _extends({}, this.props, {
	      ref: function ref(_ref) {
	        _this2._listViewRef = _ref;
	      },
	      dataSource: this.state.dataSource.getDataSource(),
	      onScroll: this._onScroll,
	      renderRow: this._renderRow
	    }));
	  };
	
	  /**
	   * This is a work-around to lock vertical `ListView` scrolling on iOS and
	   * mimic Android behaviour. Locking vertical scrolling when horizontal
	   * scrolling is active allows us to significantly improve framerates
	   * (from high 20s to almost consistently 60 fps)
	   */
	  SwipeableListView.prototype._setListViewScrollable = function _setListViewScrollable(value) {
	    if (this._listViewRef && typeof this._listViewRef.setNativeProps === 'function') {
	      this._listViewRef.setNativeProps({
	        scrollEnabled: value
	      });
	    }
	  };
	
	  // Passing through ListView's getScrollResponder() function
	
	
	  SwipeableListView.prototype.getScrollResponder = function getScrollResponder() {
	    if (this._listViewRef && typeof this._listViewRef.getScrollResponder === 'function') {
	      return this._listViewRef.getScrollResponder();
	    }
	  };
	
	  // This enables rows having variable width slideoutView.
	
	
	  SwipeableListView.prototype._getMaxSwipeDistance = function _getMaxSwipeDistance(rowData, sectionID, rowID) {
	    if (typeof this.props.maxSwipeDistance === 'function') {
	      return this.props.maxSwipeDistance(rowData, sectionID, rowID);
	    }
	
	    return this.props.maxSwipeDistance;
	  };
	
	  SwipeableListView.prototype._onOpen = function _onOpen(rowID) {
	    this.setState({
	      dataSource: this.state.dataSource.setOpenRowID(rowID)
	    });
	  };
	
	  SwipeableListView.prototype._onClose = function _onClose(rowID) {
	    this.setState({
	      dataSource: this.state.dataSource.setOpenRowID(null)
	    });
	  };
	
	  return SwipeableListView;
	}(_react2.default.Component);
	
	SwipeableListView.defaultProps = {
	  bounceFirstRowOnMount: false,
	  renderQuickActions: function renderQuickActions() {
	    return null;
	  }
	};
	SwipeableListView.propTypes =  false ? {
	  /**
	   * To alert the user that swiping is possible, the first row can bounce
	   * on component mount.
	   */
	  bounceFirstRowOnMount: _propTypes2.default.bool.isRequired,
	  /**
	   * Use `SwipeableListView.getNewDataSource()` to get a data source to use,
	   * then use it just like you would a normal ListView data source
	   */
	  dataSource: _propTypes2.default.instanceOf(_SwipeableListViewDataSource2.default).isRequired,
	  // Maximum distance to open to after a swipe
	  maxSwipeDistance: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  // Callback method to render the swipeable view
	  renderRow: _propTypes2.default.func.isRequired,
	  // Callback method to render the view that will be unveiled on swipe
	  renderQuickActions: _propTypes2.default.func.isRequired
	} : {};
	exports.default = SwipeableListView;
	module.exports = exports['default'];

/***/ },
/* 1482 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var TouchHistoryMath = {
	  /**
	   * This code is optimized and not intended to look beautiful. This allows
	   * computing of touch centroids that have moved after `touchesChangedAfter`
	   * timeStamp. You can compute the current centroid involving all touches
	   * moves after `touchesChangedAfter`, or you can compute the previous
	   * centroid of all touches that were moved after `touchesChangedAfter`.
	   *
	   * @param {TouchHistoryMath} touchHistory Standard Responder touch track
	   * data.
	   * @param {number} touchesChangedAfter timeStamp after which moved touches
	   * are considered "actively moving" - not just "active".
	   * @param {boolean} isXAxis Consider `x` dimension vs. `y` dimension.
	   * @param {boolean} ofCurrent Compute current centroid for actively moving
	   * touches vs. previous centroid of now actively moving touches.
	   * @return {number} value of centroid in specified dimension.
	   */
	  centroidDimension: function centroidDimension(touchHistory, touchesChangedAfter, isXAxis, ofCurrent) {
	    var touchBank = touchHistory.touchBank;
	    var total = 0;
	    var count = 0;
	
	    var oneTouchData = touchHistory.numberActiveTouches === 1 ? touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch] : null;
	
	    if (oneTouchData !== null) {
	      if (oneTouchData.touchActive && oneTouchData.currentTimeStamp > touchesChangedAfter) {
	        total += ofCurrent && isXAxis ? oneTouchData.currentPageX : ofCurrent && !isXAxis ? oneTouchData.currentPageY : !ofCurrent && isXAxis ? oneTouchData.previousPageX : oneTouchData.previousPageY;
	        count = 1;
	      }
	    } else {
	      for (var i = 0; i < touchBank.length; i++) {
	        var touchTrack = touchBank[i];
	        if (touchTrack !== null && touchTrack !== undefined && touchTrack.touchActive && touchTrack.currentTimeStamp >= touchesChangedAfter) {
	          var toAdd = void 0; // Yuck, program temporarily in invalid state.
	          if (ofCurrent && isXAxis) {
	            toAdd = touchTrack.currentPageX;
	          } else if (ofCurrent && !isXAxis) {
	            toAdd = touchTrack.currentPageY;
	          } else if (!ofCurrent && isXAxis) {
	            toAdd = touchTrack.previousPageX;
	          } else {
	            toAdd = touchTrack.previousPageY;
	          }
	          total += toAdd;
	          count++;
	        }
	      }
	    }
	    return count > 0 ? total / count : TouchHistoryMath.noCentroid;
	  },
	
	  currentCentroidXOfTouchesChangedAfter: function currentCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
	    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
	    true);
	  },
	
	  currentCentroidYOfTouchesChangedAfter: function currentCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
	    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
	    true);
	  },
	
	  previousCentroidXOfTouchesChangedAfter: function previousCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
	    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
	    false);
	  },
	
	  previousCentroidYOfTouchesChangedAfter: function previousCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
	    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
	    false);
	  },
	
	  currentCentroidX: function currentCentroidX(touchHistory) {
	    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
	    true, // isXAxis
	    true);
	  },
	
	  currentCentroidY: function currentCentroidY(touchHistory) {
	    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
	    false, // isXAxis
	    true);
	  },
	
	  noCentroid: -1
	};
	
	exports.default = TouchHistoryMath;
	module.exports = exports["default"];

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                           *
	                                                                                                                                                           * This source code is licensed under the MIT license found in the
	                                                                                                                                                           * LICENSE file in the root directory of this source tree.
	                                                                                                                                                           *
	                                                                                                                                                           * @noflow
	                                                                                                                                                           * @format
	                                                                                                                                                           */
	
	/**
	 * A Utility class for calculating viewable items based on current metrics like scroll position and
	 * layout.
	 *
	 * An item is said to be in a "viewable" state when any of the following
	 * is true for longer than `minimumViewTime` milliseconds (after an interaction if `waitForInteraction`
	 * is true):
	 *
	 * - Occupying >= `viewAreaCoveragePercentThreshold` of the view area XOR fraction of the item
	 *   visible in the view area >= `itemVisiblePercentThreshold`.
	 * - Entirely visible on screen
	 */
	var ViewabilityHelper = function () {
	  function ViewabilityHelper() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { viewAreaCoveragePercentThreshold: 0 };
	
	    _classCallCheck(this, ViewabilityHelper);
	
	    this._hasInteracted = false;
	    this._timers = new Set();
	    this._viewableIndices = [];
	    this._viewableItems = new Map();
	
	    this._config = config;
	  }
	
	  /**
	   * Cleanup, e.g. on unmount. Clears any pending timers.
	   */
	
	  /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an error
	   * found when Flow v0.63 was deployed. To see the error delete this comment
	   * and run Flow. */
	
	
	  ViewabilityHelper.prototype.dispose = function dispose() {
	    this._timers.forEach(clearTimeout);
	  };
	
	  /**
	   * Determines which items are viewable based on the current metrics and config.
	   */
	
	
	  ViewabilityHelper.prototype.computeViewableItems = function computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange) {
	    var _config = this._config,
	        itemVisiblePercentThreshold = _config.itemVisiblePercentThreshold,
	        viewAreaCoveragePercentThreshold = _config.viewAreaCoveragePercentThreshold;
	
	    var viewAreaMode = viewAreaCoveragePercentThreshold != null;
	    var viewablePercentThreshold = viewAreaMode ? viewAreaCoveragePercentThreshold : itemVisiblePercentThreshold;
	    (0, _invariant2.default)(viewablePercentThreshold != null && itemVisiblePercentThreshold != null !== (viewAreaCoveragePercentThreshold != null), 'Must set exactly one of itemVisiblePercentThreshold or viewAreaCoveragePercentThreshold');
	    var viewableIndices = [];
	    if (itemCount === 0) {
	      return viewableIndices;
	    }
	    var firstVisible = -1;
	
	    var _ref = renderRange || { first: 0, last: itemCount - 1 },
	        first = _ref.first,
	        last = _ref.last;
	
	    (0, _invariant2.default)(last < itemCount, 'Invalid render range ' + JSON.stringify({ renderRange: renderRange, itemCount: itemCount }));
	    for (var idx = first; idx <= last; idx++) {
	      var metrics = getFrameMetrics(idx);
	      if (!metrics) {
	        continue;
	      }
	      var top = metrics.offset - scrollOffset;
	      var bottom = top + metrics.length;
	      if (top < viewportHeight && bottom > 0) {
	        firstVisible = idx;
	        if (_isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, metrics.length)) {
	          viewableIndices.push(idx);
	        }
	      } else if (firstVisible >= 0) {
	        break;
	      }
	    }
	    return viewableIndices;
	  };
	
	  /**
	   * Figures out which items are viewable and how that has changed from before and calls
	   * `onViewableItemsChanged` as appropriate.
	   */
	
	
	  ViewabilityHelper.prototype.onUpdate = function onUpdate(itemCount, scrollOffset, viewportHeight, getFrameMetrics, createViewToken, onViewableItemsChanged, renderRange) {
	    var _this = this;
	
	    if (this._config.waitForInteraction && !this._hasInteracted || itemCount === 0 || !getFrameMetrics(0)) {
	      return;
	    }
	    var viewableIndices = [];
	    if (itemCount) {
	      viewableIndices = this.computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange);
	    }
	    if (this._viewableIndices.length === viewableIndices.length && this._viewableIndices.every(function (v, ii) {
	      return v === viewableIndices[ii];
	    })) {
	      // We might get a lot of scroll events where visibility doesn't change and we don't want to do
	      // extra work in those cases.
	      return;
	    }
	    this._viewableIndices = viewableIndices;
	    if (this._config.minimumViewTime) {
	      var handle = setTimeout(function () {
	        _this._timers.delete(handle);
	        _this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
	      }, this._config.minimumViewTime);
	      this._timers.add(handle);
	    } else {
	      this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
	    }
	  };
	
	  /**
	   * clean-up cached _viewableIndices to evaluate changed items on next update
	   */
	
	
	  ViewabilityHelper.prototype.resetViewableIndices = function resetViewableIndices() {
	    this._viewableIndices = [];
	  };
	
	  /**
	   * Records that an interaction has happened even if there has been no scroll.
	   */
	
	
	  ViewabilityHelper.prototype.recordInteraction = function recordInteraction() {
	    this._hasInteracted = true;
	  };
	
	  ViewabilityHelper.prototype._onUpdateSync = function _onUpdateSync(viewableIndicesToCheck, onViewableItemsChanged, createViewToken) {
	    var _this2 = this;
	
	    // Filter out indices that have gone out of view since this call was scheduled.
	    viewableIndicesToCheck = viewableIndicesToCheck.filter(function (ii) {
	      return _this2._viewableIndices.includes(ii);
	    });
	    var prevItems = this._viewableItems;
	    var nextItems = new Map(viewableIndicesToCheck.map(function (ii) {
	      var viewable = createViewToken(ii, true);
	      return [viewable.key, viewable];
	    }));
	
	    var changed = [];
	    for (var _iterator = nextItems, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref3;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref3 = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref3 = _i.value;
	      }
	
	      var _ref2 = _ref3;
	      var _key = _ref2[0];
	      var viewable = _ref2[1];
	
	      if (!prevItems.has(_key)) {
	        changed.push(viewable);
	      }
	    }
	    for (var _iterator2 = prevItems, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	      var _ref5;
	
	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref5 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref5 = _i2.value;
	      }
	
	      var _ref4 = _ref5;
	      var _key2 = _ref4[0];
	      var _viewable = _ref4[1];
	
	      if (!nextItems.has(_key2)) {
	        changed.push(Object.assign({}, _viewable, { isViewable: false }));
	      }
	    }
	    if (changed.length > 0) {
	      this._viewableItems = nextItems;
	      onViewableItemsChanged({
	        viewableItems: Array.from(nextItems.values()),
	        changed: changed,
	        viewabilityConfig: this._config
	      });
	    }
	  };
	
	  return ViewabilityHelper;
	}();
	
	function _isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, itemLength) {
	  if (_isEntirelyVisible(top, bottom, viewportHeight)) {
	    return true;
	  } else {
	    var pixels = _getPixelsVisible(top, bottom, viewportHeight);
	    var percent = 100 * (viewAreaMode ? pixels / viewportHeight : pixels / itemLength);
	    return percent >= viewablePercentThreshold;
	  }
	}
	
	function _getPixelsVisible(top, bottom, viewportHeight) {
	  var visibleHeight = Math.min(bottom, viewportHeight) - Math.max(top, 0);
	  return Math.max(0, visibleHeight);
	}
	
	function _isEntirelyVisible(top, bottom, viewportHeight) {
	  return top >= 0 && bottom <= viewportHeight && bottom > top;
	}
	
	exports.default = ViewabilityHelper;
	module.exports = exports['default'];

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.newRangeCount = exports.elementsThatOverlapOffsets = exports.computeWindowedRenderLimits = undefined;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Used to find the indices of the frames that overlap the given offsets. Useful for finding the
	 * items that bound different windows of content, such as the visible area or the buffered overscan
	 * area.
	 */
	function elementsThatOverlapOffsets(offsets, itemCount, getFrameMetrics) {
	  var out = [];
	  var outLength = 0;
	  for (var ii = 0; ii < itemCount; ii++) {
	    var frame = getFrameMetrics(ii);
	    var trailingOffset = frame.offset + frame.length;
	    for (var kk = 0; kk < offsets.length; kk++) {
	      if (out[kk] == null && trailingOffset >= offsets[kk]) {
	        out[kk] = ii;
	        outLength++;
	        if (kk === offsets.length - 1) {
	          (0, _invariant2.default)(outLength === offsets.length, 'bad offsets input, should be in increasing order: %s', JSON.stringify(offsets));
	          return out;
	        }
	      }
	    }
	  }
	  return out;
	}
	
	/**
	 * Computes the number of elements in the `next` range that are new compared to the `prev` range.
	 * Handy for calculating how many new items will be rendered when the render window changes so we
	 * can restrict the number of new items render at once so that content can appear on the screen
	 * faster.
	 */
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @format
	 */
	
	function newRangeCount(prev, next) {
	  return next.last - next.first + 1 - Math.max(0, 1 + Math.min(next.last, prev.last) - Math.max(next.first, prev.first));
	}
	
	/**
	 * Custom logic for determining which items should be rendered given the current frame and scroll
	 * metrics, as well as the previous render state. The algorithm may evolve over time, but generally
	 * prioritizes the visible area first, then expands that with overscan regions ahead and behind,
	 * biased in the direction of scroll.
	 */
	function computeWindowedRenderLimits(props, prev, getFrameMetricsApprox, scrollMetrics) {
	  var data = props.data,
	      getItemCount = props.getItemCount,
	      maxToRenderPerBatch = props.maxToRenderPerBatch,
	      windowSize = props.windowSize;
	
	  var itemCount = getItemCount(data);
	  if (itemCount === 0) {
	    return prev;
	  }
	  var offset = scrollMetrics.offset,
	      velocity = scrollMetrics.velocity,
	      visibleLength = scrollMetrics.visibleLength;
	
	  // Start with visible area, then compute maximum overscan region by expanding from there, biased
	  // in the direction of scroll. Total overscan area is capped, which should cap memory consumption
	  // too.
	
	  var visibleBegin = Math.max(0, offset);
	  var visibleEnd = visibleBegin + visibleLength;
	  var overscanLength = (windowSize - 1) * visibleLength;
	
	  // Considering velocity seems to introduce more churn than it's worth.
	  var leadFactor = 0.5; // Math.max(0, Math.min(1, velocity / 25 + 0.5));
	
	  var fillPreference = velocity > 1 ? 'after' : velocity < -1 ? 'before' : 'none';
	
	  var overscanBegin = Math.max(0, visibleBegin - (1 - leadFactor) * overscanLength);
	  var overscanEnd = Math.max(0, visibleEnd + leadFactor * overscanLength);
	
	  var lastItemOffset = getFrameMetricsApprox(itemCount - 1).offset;
	  if (lastItemOffset < overscanBegin) {
	    // Entire list is before our overscan window
	    return {
	      first: Math.max(0, itemCount - 1 - maxToRenderPerBatch),
	      last: itemCount - 1
	    };
	  }
	
	  // Find the indices that correspond to the items at the render boundaries we're targeting.
	
	  var _elementsThatOverlapO = elementsThatOverlapOffsets([overscanBegin, visibleBegin, visibleEnd, overscanEnd], props.getItemCount(props.data), getFrameMetricsApprox),
	      overscanFirst = _elementsThatOverlapO[0],
	      first = _elementsThatOverlapO[1],
	      last = _elementsThatOverlapO[2],
	      overscanLast = _elementsThatOverlapO[3];
	
	  overscanFirst = overscanFirst == null ? 0 : overscanFirst;
	  first = first == null ? Math.max(0, overscanFirst) : first;
	  overscanLast = overscanLast == null ? itemCount - 1 : overscanLast;
	  last = last == null ? Math.min(overscanLast, first + maxToRenderPerBatch - 1) : last;
	  var visible = { first: first, last: last };
	
	  // We want to limit the number of new cells we're rendering per batch so that we can fill the
	  // content on the screen quickly. If we rendered the entire overscan window at once, the user
	  // could be staring at white space for a long time waiting for a bunch of offscreen content to
	  // render.
	  var newCellCount = newRangeCount(prev, visible);
	
	  while (true) {
	    if (first <= overscanFirst && last >= overscanLast) {
	      // If we fill the entire overscan range, we're done.
	      break;
	    }
	    var maxNewCells = newCellCount >= maxToRenderPerBatch;
	    var firstWillAddMore = first <= prev.first || first > prev.last;
	    var firstShouldIncrement = first > overscanFirst && (!maxNewCells || !firstWillAddMore);
	    var lastWillAddMore = last >= prev.last || last < prev.first;
	    var lastShouldIncrement = last < overscanLast && (!maxNewCells || !lastWillAddMore);
	    if (maxNewCells && !firstShouldIncrement && !lastShouldIncrement) {
	      // We only want to stop if we've hit maxNewCells AND we cannot increment first or last
	      // without rendering new items. This let's us preserve as many already rendered items as
	      // possible, reducing render churn and keeping the rendered overscan range as large as
	      // possible.
	      break;
	    }
	    if (firstShouldIncrement && !(fillPreference === 'after' && lastShouldIncrement && lastWillAddMore)) {
	      if (firstWillAddMore) {
	        newCellCount++;
	      }
	      first--;
	    }
	    if (lastShouldIncrement && !(fillPreference === 'before' && firstShouldIncrement && firstWillAddMore)) {
	      if (lastWillAddMore) {
	        newCellCount++;
	      }
	      last++;
	    }
	  }
	  if (!(last >= first && first >= 0 && last < itemCount && first >= overscanFirst && last <= overscanLast && first <= visible.first && last >= visible.last)) {
	    throw new Error('Bad window calculation ' + JSON.stringify({
	      first: first,
	      last: last,
	      itemCount: itemCount,
	      overscanFirst: overscanFirst,
	      overscanLast: overscanLast,
	      visible: visible
	    }));
	  }
	  return { first: first, last: last };
	}
	
	exports.computeWindowedRenderLimits = computeWindowedRenderLimits;
	exports.elementsThatOverlapOffsets = elementsThatOverlapOffsets;
	exports.newRangeCount = newRangeCount;
	
	
	var VirtualizeUtils = {
	  computeWindowedRenderLimits: computeWindowedRenderLimits,
	  elementsThatOverlapOffsets: elementsThatOverlapOffsets,
	  newRangeCount: newRangeCount
	};
	
	exports.default = VirtualizeUtils;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _View = __webpack_require__(29);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _VirtualizedList = __webpack_require__(829);
	
	var _VirtualizedList2 = _interopRequireDefault(_VirtualizedList);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright (c) 2015-present, Facebook, Inc.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This source code is licensed under the MIT license found in the
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LICENSE file in the root directory of this source tree.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @noflow
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @format
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * Right now this just flattens everything into one list and uses VirtualizedList under the
	 * hood. The only operation that might not scale well is concatting the data arrays of all the
	 * sections when new props are received, which should be plenty fast for up to ~10,000 items.
	 */
	var VirtualizedSectionList = function (_React$PureComponent) {
	  _inherits(VirtualizedSectionList, _React$PureComponent);
	
	  VirtualizedSectionList.prototype.scrollToLocation = function scrollToLocation(params) {
	    var index = params.itemIndex + 1;
	    for (var ii = 0; ii < params.sectionIndex; ii++) {
	      index += this.props.sections[ii].data.length + 2;
	    }
	    var toIndexParams = Object.assign({}, params, {
	      index: index
	    });
	    this._listRef.scrollToIndex(toIndexParams);
	  };
	
	  VirtualizedSectionList.prototype.getListRef = function getListRef() {
	    return this._listRef;
	  };
	
	  VirtualizedSectionList.prototype._subExtractor = function _subExtractor(index) {
	    var itemIndex = index;
	    var defaultKeyExtractor = this.props.keyExtractor;
	    for (var ii = 0; ii < this.props.sections.length; ii++) {
	      var _section = this.props.sections[ii];
	      var _key = _section.key || String(ii);
	      itemIndex -= 1; // The section adds an item for the header
	      if (itemIndex >= _section.data.length + 1) {
	        itemIndex -= _section.data.length + 1; // The section adds an item for the footer.
	      } else if (itemIndex === -1) {
	        return {
	          section: _section,
	          key: _key + ':header',
	          index: null,
	          header: true,
	          trailingSection: this.props.sections[ii + 1]
	        };
	      } else if (itemIndex === _section.data.length) {
	        return {
	          section: _section,
	          key: _key + ':footer',
	          index: null,
	          header: false,
	          trailingSection: this.props.sections[ii + 1]
	        };
	      } else {
	        var _keyExtractor = _section.keyExtractor || defaultKeyExtractor;
	        return {
	          section: _section,
	          key: _key + ':' + _keyExtractor(_section.data[itemIndex], itemIndex),
	          index: itemIndex,
	          leadingItem: _section.data[itemIndex - 1],
	          leadingSection: this.props.sections[ii - 1],
	          trailingItem: _section.data[itemIndex + 1],
	          trailingSection: this.props.sections[ii + 1]
	        };
	      }
	    }
	  };
	
	  VirtualizedSectionList.prototype._getSeparatorComponent = function _getSeparatorComponent(index, info) {
	    info = info || this._subExtractor(index);
	    if (!info) {
	      return null;
	    }
	    var ItemSeparatorComponent = info.section.ItemSeparatorComponent || this.props.ItemSeparatorComponent;
	    var SectionSeparatorComponent = this.props.SectionSeparatorComponent;
	
	    var isLastItemInList = index === this.state.childProps.getItemCount() - 1;
	    var isLastItemInSection = info.index === info.section.data.length - 1;
	    if (SectionSeparatorComponent && isLastItemInSection) {
	      return SectionSeparatorComponent;
	    }
	    if (ItemSeparatorComponent && !isLastItemInSection && !isLastItemInList) {
	      return ItemSeparatorComponent;
	    }
	    return null;
	  };
	
	  VirtualizedSectionList.prototype._computeState = function _computeState(props) {
	    var offset = props.ListHeaderComponent ? 1 : 0;
	    var stickyHeaderIndices = [];
	    var itemCount = props.sections.reduce(function (v, section) {
	      stickyHeaderIndices.push(v + offset);
	      return v + section.data.length + 2; // Add two for the section header and footer.
	    }, 0);
	
	    return {
	      childProps: Object.assign({}, props, {
	        renderItem: this._renderItem,
	        ItemSeparatorComponent: undefined, // Rendered with renderItem
	        data: props.sections,
	        getItemCount: function getItemCount() {
	          return itemCount;
	        },
	        getItem: getItem,
	        keyExtractor: this._keyExtractor,
	        onViewableItemsChanged: props.onViewableItemsChanged ? this._onViewableItemsChanged : undefined,
	        stickyHeaderIndices: props.stickySectionHeadersEnabled ? stickyHeaderIndices : undefined
	      })
	    };
	  };
	
	  function VirtualizedSectionList(props, context) {
	    _classCallCheck(this, VirtualizedSectionList);
	
	    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));
	
	    _this._keyExtractor = function (item, index) {
	      var info = _this._subExtractor(index);
	      return info && info.key || String(index);
	    };
	
	    _this._convertViewable = function (viewable) {
	      (0, _invariant2.default)(viewable.index != null, 'Received a broken ViewToken');
	      var info = _this._subExtractor(viewable.index);
	      if (!info) {
	        return null;
	      }
	      var keyExtractor = info.section.keyExtractor || _this.props.keyExtractor;
	      return Object.assign({}, viewable, {
	        index: info.index,
	        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
	         * error found when Flow v0.63 was deployed. To see the error delete this
	         * comment and run Flow. */
	        key: keyExtractor(viewable.item, info.index),
	        section: info.section
	      });
	    };
	
	    _this._onViewableItemsChanged = function (_ref) {
	      var viewableItems = _ref.viewableItems,
	          changed = _ref.changed;
	
	      if (_this.props.onViewableItemsChanged) {
	        _this.props.onViewableItemsChanged({
	          viewableItems: viewableItems.map(_this._convertViewable, _this).filter(Boolean),
	          changed: changed.map(_this._convertViewable, _this).filter(Boolean)
	        });
	      }
	    };
	
	    _this._renderItem = function (_ref2) {
	      var item = _ref2.item,
	          index = _ref2.index;
	
	      var info = _this._subExtractor(index);
	      if (!info) {
	        return null;
	      }
	      var infoIndex = info.index;
	      if (infoIndex == null) {
	        var _section2 = info.section;
	
	        if (info.header === true) {
	          var _renderSectionHeader = _this.props.renderSectionHeader;
	
	          return _renderSectionHeader ? _renderSectionHeader({ section: _section2 }) : null;
	        } else {
	          var _renderSectionFooter = _this.props.renderSectionFooter;
	
	          return _renderSectionFooter ? _renderSectionFooter({ section: _section2 }) : null;
	        }
	      } else {
	        var _renderItem = info.section.renderItem || _this.props.renderItem;
	        var _SeparatorComponent = _this._getSeparatorComponent(index, info);
	        (0, _invariant2.default)(_renderItem, 'no renderItem!');
	        return _react2.default.createElement(ItemWithSeparator, {
	          SeparatorComponent: _SeparatorComponent,
	          LeadingSeparatorComponent: infoIndex === 0 ? _this.props.SectionSeparatorComponent : undefined,
	          cellKey: info.key,
	          index: infoIndex,
	          item: item,
	          leadingItem: info.leadingItem,
	          leadingSection: info.leadingSection,
	          onUpdateSeparator: _this._onUpdateSeparator,
	          prevCellKey: (_this._subExtractor(index - 1) || {}).key,
	          ref: function ref(_ref3) {
	            _this._cellRefs[info.key] = _ref3;
	          },
	          renderItem: _renderItem,
	          section: info.section,
	          trailingItem: info.trailingItem,
	          trailingSection: info.trailingSection
	        });
	      }
	    };
	
	    _this._onUpdateSeparator = function (key, newProps) {
	      var ref = _this._cellRefs[key];
	      ref && ref.updateSeparatorProps(newProps);
	    };
	
	    _this._cellRefs = {};
	
	    _this._captureRef = function (ref) {
	      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
	       * suppresses an error when upgrading Flow's support for React. To see the
	       * error delete this comment and run Flow. */
	      _this._listRef = ref;
	    };
	
	    _this.state = _this._computeState(props);
	    return _this;
	  }
	
	  VirtualizedSectionList.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    this.setState(this._computeState(nextProps));
	  };
	
	  VirtualizedSectionList.prototype.render = function render() {
	    return _react2.default.createElement(_VirtualizedList2.default, _extends({}, this.state.childProps, { ref: this._captureRef }));
	  };
	
	  return VirtualizedSectionList;
	}(_react2.default.PureComponent);
	
	VirtualizedSectionList.defaultProps = Object.assign({}, _VirtualizedList2.default.defaultProps, {
	  data: []
	});
	
	var ItemWithSeparator = function (_React$Component) {
	  _inherits(ItemWithSeparator, _React$Component);
	
	  function ItemWithSeparator() {
	    var _temp, _this2, _ret;
	
	    _classCallCheck(this, ItemWithSeparator);
	
	    for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this2), _this2.state = {
	      separatorProps: {
	        highlighted: false,
	        leadingItem: _this2.props.item,
	        leadingSection: _this2.props.leadingSection,
	        section: _this2.props.section,
	        trailingItem: _this2.props.trailingItem,
	        trailingSection: _this2.props.trailingSection
	      },
	      leadingSeparatorProps: {
	        highlighted: false,
	        leadingItem: _this2.props.leadingItem,
	        leadingSection: _this2.props.leadingSection,
	        section: _this2.props.section,
	        trailingItem: _this2.props.item,
	        trailingSection: _this2.props.trailingSection
	      }
	    }, _this2._separators = {
	      highlight: function highlight() {
	        ['leading', 'trailing'].forEach(function (s) {
	          return _this2._separators.updateProps(s, { highlighted: true });
	        });
	      },
	      unhighlight: function unhighlight() {
	        ['leading', 'trailing'].forEach(function (s) {
	          return _this2._separators.updateProps(s, { highlighted: false });
	        });
	      },
	      updateProps: function updateProps(select, newProps) {
	        var _this2$props = _this2.props,
	            LeadingSeparatorComponent = _this2$props.LeadingSeparatorComponent,
	            cellKey = _this2$props.cellKey,
	            prevCellKey = _this2$props.prevCellKey;
	
	        if (select === 'leading' && LeadingSeparatorComponent) {
	          _this2.setState(function (state) {
	            return {
	              leadingSeparatorProps: Object.assign({}, state.leadingSeparatorProps, newProps)
	            };
	          });
	        } else {
	          _this2.props.onUpdateSeparator(select === 'leading' && prevCellKey || cellKey, newProps);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this2, _ret);
	  }
	
	  ItemWithSeparator.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
	    var _this3 = this;
	
	    this.setState(function (state) {
	      return {
	        separatorProps: Object.assign({}, _this3.state.separatorProps, {
	          leadingItem: props.item,
	          leadingSection: props.leadingSection,
	          section: props.section,
	          trailingItem: props.trailingItem,
	          trailingSection: props.trailingSection
	        }),
	        leadingSeparatorProps: Object.assign({}, _this3.state.leadingSeparatorProps, {
	          leadingItem: props.leadingItem,
	          leadingSection: props.leadingSection,
	          section: props.section,
	          trailingItem: props.item,
	          trailingSection: props.trailingSection
	        })
	      };
	    });
	  };
	
	  ItemWithSeparator.prototype.updateSeparatorProps = function updateSeparatorProps(newProps) {
	    this.setState(function (state) {
	      return {
	        separatorProps: Object.assign({}, state.separatorProps, newProps)
	      };
	    });
	  };
	
	  ItemWithSeparator.prototype.render = function render() {
	    var _props = this.props,
	        LeadingSeparatorComponent = _props.LeadingSeparatorComponent,
	        SeparatorComponent = _props.SeparatorComponent,
	        item = _props.item,
	        index = _props.index,
	        section = _props.section;
	
	    var element = this.props.renderItem({
	      item: item,
	      index: index,
	      section: section,
	      separators: this._separators
	    });
	    var leadingSeparator = LeadingSeparatorComponent && _react2.default.createElement(LeadingSeparatorComponent, this.state.leadingSeparatorProps);
	    var separator = SeparatorComponent && _react2.default.createElement(SeparatorComponent, this.state.separatorProps);
	    return leadingSeparator || separator ? _react2.default.createElement(
	      _View2.default,
	      null,
	      leadingSeparator,
	      element,
	      separator
	    ) : element;
	  };
	
	  return ItemWithSeparator;
	}(_react2.default.Component);
	
	function getItem(sections, index) {
	  if (!sections) {
	    return null;
	  }
	  var itemIdx = index - 1;
	  for (var ii = 0; ii < sections.length; ii++) {
	    if (itemIdx === -1 || itemIdx === sections[ii].data.length) {
	      // We intend for there to be overflow by one on both ends of the list.
	      // This will be for headers and footers. When returning a header or footer
	      // item the section itself is the item.
	      return sections[ii];
	    } else if (itemIdx < sections[ii].data.length) {
	      // If we are in the bounds of the list's data then return the item.
	      return sections[ii].data[itemIdx];
	    } else {
	      itemIdx -= sections[ii].data.length + 2; // Add two for the header and footer
	    }
	  }
	  return null;
	}
	
	exports.default = VirtualizedSectionList;
	module.exports = exports['default'];

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule EmitterSubscription
	 * 
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _EventSubscription2 = __webpack_require__(1488);
	
	var _EventSubscription3 = _interopRequireDefault(_EventSubscription2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * EmitterSubscription represents a subscription with listener and context data.
	 */
	var EmitterSubscription = function (_EventSubscription) {
	  _inherits(EmitterSubscription, _EventSubscription);
	
	  /**
	   * @param {EventEmitter} emitter - The event emitter that registered this
	   *   subscription
	   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
	   *   this subscription
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	  function EmitterSubscription(emitter, subscriber, listener, context) {
	    _classCallCheck(this, EmitterSubscription);
	
	    var _this = _possibleConstructorReturn(this, _EventSubscription.call(this, subscriber));
	
	    _this.emitter = emitter;
	    _this.listener = listener;
	    _this.context = context;
	    return _this;
	  }
	
	  /**
	   * Removes this subscription from the emitter that registered it.
	   * Note: we're overriding the `remove()` method of EventSubscription here
	   * but deliberately not calling `super.remove()` as the responsibility
	   * for removing the subscription lies with the EventEmitter.
	   */
	
	
	  EmitterSubscription.prototype.remove = function remove() {
	    this.emitter.removeSubscription(this);
	  };
	
	  return EmitterSubscription;
	}(_EventSubscription3.default);
	
	exports.default = EmitterSubscription;
	module.exports = exports['default'];

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule EventEmitter
	 * @noflow
	 * @typecheck
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _EmitterSubscription = __webpack_require__(1486);
	
	var _EmitterSubscription2 = _interopRequireDefault(_EmitterSubscription);
	
	var _EventSubscriptionVendor = __webpack_require__(1489);
	
	var _EventSubscriptionVendor2 = _interopRequireDefault(_EventSubscriptionVendor);
	
	var _emptyFunction = __webpack_require__(37);
	
	var _emptyFunction2 = _interopRequireDefault(_emptyFunction);
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @class EventEmitter
	 * @description
	 * An EventEmitter is responsible for managing a set of listeners and publishing
	 * events to them when it is told that such events happened. In addition to the
	 * data for the given event it also sends a event control object which allows
	 * the listeners/handlers to prevent the default behavior of the given event.
	 *
	 * The emitter is designed to be generic enough to support all the different
	 * contexts in which one might want to emit events. It is a simple multicast
	 * mechanism on top of which extra functionality can be composed. For example, a
	 * more advanced emitter may use an EventHolder and EventFactory.
	 */
	var EventEmitter = function () {
	
	  /**
	   * @constructor
	   *
	   * @param {EventSubscriptionVendor} subscriber - Optional subscriber instance
	   *   to use. If omitted, a new subscriber will be created for the emitter.
	   */
	  function EventEmitter(subscriber) {
	    _classCallCheck(this, EventEmitter);
	
	    this._subscriber = subscriber || new _EventSubscriptionVendor2.default();
	  }
	
	  /**
	   * Adds a listener to be invoked when events of the specified type are
	   * emitted. An optional calling context may be provided. The data arguments
	   * emitted will be passed to the listener function.
	   *
	   * TODO: Annotate the listener arg's type. This is tricky because listeners
	   *       can be invoked with varargs.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	
	  EventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
	
	    return this._subscriber.addSubscription(eventType, new _EmitterSubscription2.default(this, this._subscriber, listener, context));
	  };
	
	  /**
	   * Similar to addListener, except that the listener is removed after it is
	   * invoked once.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke only once when the
	   *   specified event is emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	
	  EventEmitter.prototype.once = function once(eventType, listener, context) {
	    var _this = this;
	
	    return this.addListener(eventType, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this.removeCurrentListener();
	      listener.apply(context, args);
	    });
	  };
	
	  /**
	   * Removes all of the registered listeners, including those registered as
	   * listener maps.
	   *
	   * @param {?string} eventType - Optional name of the event whose registered
	   *   listeners to remove
	   */
	
	
	  EventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
	    this._subscriber.removeAllSubscriptions(eventType);
	  };
	
	  /**
	   * Provides an API that can be called during an eventing cycle to remove the
	   * last listener that was invoked. This allows a developer to provide an event
	   * object that can remove the listener (or listener map) during the
	   * invocation.
	   *
	   * If it is called when not inside of an emitting cycle it will throw.
	   *
	   * @throws {Error} When called not during an eventing cycle
	   *
	   * @example
	   *   var subscription = emitter.addListenerMap({
	   *     someEvent: function(data, event) {
	   *       console.log(data);
	   *       emitter.removeCurrentListener();
	   *     }
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   *   emitter.emit('someEvent', 'def'); // does not log anything
	   */
	
	
	  EventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
	    (0, _invariant2.default)(!!this._currentSubscription, 'Not in an emitting cycle; there is no current subscription');
	    this.removeSubscription(this._currentSubscription);
	  };
	
	  /**
	   * Removes a specific subscription. Called by the `remove()` method of the
	   * subscription itself to ensure any necessary cleanup is performed.
	   */
	
	
	  EventEmitter.prototype.removeSubscription = function removeSubscription(subscription) {
	    (0, _invariant2.default)(subscription.emitter === this, 'Subscription does not belong to this emitter.');
	    this._subscriber.removeSubscription(subscription);
	  };
	
	  /**
	   * Returns an array of listeners that are currently registered for the given
	   * event.
	   *
	   * @param {string} eventType - Name of the event to query
	   * @returns {array}
	   */
	
	
	  EventEmitter.prototype.listeners = function listeners(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    return subscriptions ? subscriptions.filter(_emptyFunction2.default.thatReturnsTrue).map(function (subscription) {
	      return subscription.listener;
	    }) : [];
	  };
	
	  /**
	   * Emits an event of the given type with the given data. All handlers of that
	   * particular type will be notified.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {...*} Arbitrary arguments to be passed to each registered listener
	   *
	   * @example
	   *   emitter.addListener('someEvent', function(message) {
	   *     console.log(message);
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   */
	
	
	  EventEmitter.prototype.emit = function emit(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    if (subscriptions) {
	      for (var i = 0, l = subscriptions.length; i < l; i++) {
	        var subscription = subscriptions[i];
	
	        // The subscription may have been removed during this event loop.
	        if (subscription) {
	          this._currentSubscription = subscription;
	          subscription.listener.apply(subscription.context, Array.prototype.slice.call(arguments, 1));
	        }
	      }
	      this._currentSubscription = null;
	    }
	  };
	
	  /**
	   * Removes the given listener for event of specific type.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   *
	   * @example
	   *   emitter.removeListener('someEvent', function(message) {
	   *     console.log(message);
	   *   }); // removes the listener if already registered
	   *
	   */
	
	
	  EventEmitter.prototype.removeListener = function removeListener(eventType, listener) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	    if (subscriptions) {
	      for (var i = 0, l = subscriptions.length; i < l; i++) {
	        var subscription = subscriptions[i];
	
	        // The subscription may have been removed during this event loop.
	        // its listener matches the listener in method parameters
	        if (subscription && subscription.listener === listener) {
	          subscription.remove();
	        }
	      }
	    }
	  };
	
	  return EventEmitter;
	}();
	
	exports.default = EventEmitter;
	module.exports = exports['default'];

/***/ },
/* 1488 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule EventSubscription
	 * 
	 */
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * EventSubscription represents a subscription to a particular event. It can
	 * remove its own subscription.
	 */
	var EventSubscription = function () {
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
	   *   this subscription.
	   */
	  function EventSubscription(subscriber) {
	    _classCallCheck(this, EventSubscription);
	
	    this.subscriber = subscriber;
	  }
	
	  /**
	   * Removes this subscription from the subscriber that controls it.
	   */
	
	
	  EventSubscription.prototype.remove = function remove() {
	    this.subscriber.removeSubscription(this);
	  };
	
	  return EventSubscription;
	}();
	
	exports.default = EventSubscription;
	module.exports = exports['default'];

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule EventSubscriptionVendor
	 * 
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _invariant = __webpack_require__(7);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * EventSubscriptionVendor stores a set of EventSubscriptions that are
	 * subscribed to a particular event type.
	 */
	var EventSubscriptionVendor = function () {
	  function EventSubscriptionVendor() {
	    _classCallCheck(this, EventSubscriptionVendor);
	
	    this._subscriptionsForType = {};
	    this._currentSubscription = null;
	  }
	
	  /**
	   * Adds a subscription keyed by an event type.
	   *
	   * @param {string} eventType
	   * @param {EventSubscription} subscription
	   */
	
	
	  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
	    (0, _invariant2.default)(subscription.subscriber === this, 'The subscriber of the subscription is incorrectly set.');
	    if (!this._subscriptionsForType[eventType]) {
	      this._subscriptionsForType[eventType] = [];
	    }
	    var key = this._subscriptionsForType[eventType].length;
	    this._subscriptionsForType[eventType].push(subscription);
	    subscription.eventType = eventType;
	    subscription.key = key;
	    return subscription;
	  };
	
	  /**
	   * Removes a bulk set of the subscriptions.
	   *
	   * @param {?string} eventType - Optional name of the event type whose
	   *   registered supscriptions to remove, if null remove all subscriptions.
	   */
	
	
	  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
	    if (eventType === undefined) {
	      this._subscriptionsForType = {};
	    } else {
	      delete this._subscriptionsForType[eventType];
	    }
	  };
	
	  /**
	   * Removes a specific subscription. Instead of calling this function, call
	   * `subscription.remove()` directly.
	   *
	   * @param {object} subscription
	   */
	
	
	  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
	    var eventType = subscription.eventType;
	    var key = subscription.key;
	
	    var subscriptionsForType = this._subscriptionsForType[eventType];
	    if (subscriptionsForType) {
	      delete subscriptionsForType[key];
	    }
	  };
	
	  /**
	   * Returns the array of subscriptions that are currently registered for the
	   * given event type.
	   *
	   * Note: This array can be potentially sparse as subscriptions are deleted
	   * from it when they are removed.
	   *
	   * TODO: This returns a nullable array. wat?
	   *
	   * @param {string} eventType
	   * @returns {?array}
	   */
	
	
	  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
	    return this._subscriptionsForType[eventType];
	  };
	
	  return EventSubscriptionVendor;
	}();
	
	exports.default = EventSubscriptionVendor;
	module.exports = exports['default'];

/***/ },
/* 1490 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	/**
	 * Intentional info-level logging for clear separation from ad-hoc console debug logging.
	 */
	
	exports.__esModule = true;
	function infoLog() {
	  var _console;
	
	  return (_console = console).log.apply(_console, arguments);
	}
	
	exports.default = infoLog;
	module.exports = exports['default'];

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1493).enable();
	  window.Promise = __webpack_require__(1492);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1494);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(25);


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(1070);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(1070);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1494 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.11.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(25),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
	var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
	function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
	H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
	function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
	0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
	function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
	var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
	if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.11.0",
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(70);


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(1072);
	
	/*<replacement>*/
	var util = __webpack_require__(98);
	util.inherits = __webpack_require__(82);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(129).Buffer;
	var util = __webpack_require__(1515);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(831).PassThrough


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(831).Transform


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(830);


/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// wrapper for non-node envs
	;(function (sax) {
	
	sax.parser = function (strict, opt) { return new SAXParser(strict, opt) }
	sax.SAXParser = SAXParser
	sax.SAXStream = SAXStream
	sax.createStream = createStream
	
	// When we pass the MAX_BUFFER_LENGTH position, start checking for buffer overruns.
	// When we check, schedule the next check for MAX_BUFFER_LENGTH - (max(buffer lengths)),
	// since that's the earliest that a buffer overrun could occur.  This way, checks are
	// as rare as required, but as often as necessary to ensure never crossing this bound.
	// Furthermore, buffers are only tested at most once per write(), so passing a very
	// large string into write() might have undesirable effects, but this is manageable by
	// the caller, so it is assumed to be safe.  Thus, a call to write() may, in the extreme
	// edge case, result in creating at most one complete copy of the string passed in.
	// Set to Infinity to have unlimited buffers.
	sax.MAX_BUFFER_LENGTH = 64 * 1024
	
	var buffers = [
	  "comment", "sgmlDecl", "textNode", "tagName", "doctype",
	  "procInstName", "procInstBody", "entity", "attribName",
	  "attribValue", "cdata", "script"
	]
	
	sax.EVENTS = // for discoverability.
	  [ "text"
	  , "processinginstruction"
	  , "sgmldeclaration"
	  , "doctype"
	  , "comment"
	  , "attribute"
	  , "opentag"
	  , "closetag"
	  , "opencdata"
	  , "cdata"
	  , "closecdata"
	  , "error"
	  , "end"
	  , "ready"
	  , "script"
	  , "opennamespace"
	  , "closenamespace"
	  ]
	
	function SAXParser (strict, opt) {
	  if (!(this instanceof SAXParser)) return new SAXParser(strict, opt)
	
	  var parser = this
	  clearBuffers(parser)
	  parser.q = parser.c = ""
	  parser.bufferCheckPosition = sax.MAX_BUFFER_LENGTH
	  parser.opt = opt || {}
	  parser.opt.lowercase = parser.opt.lowercase || parser.opt.lowercasetags
	  parser.looseCase = parser.opt.lowercase ? "toLowerCase" : "toUpperCase"
	  parser.tags = []
	  parser.closed = parser.closedRoot = parser.sawRoot = false
	  parser.tag = parser.error = null
	  parser.strict = !!strict
	  parser.noscript = !!(strict || parser.opt.noscript)
	  parser.state = S.BEGIN
	  parser.ENTITIES = Object.create(sax.ENTITIES)
	  parser.attribList = []
	
	  // namespaces form a prototype chain.
	  // it always points at the current tag,
	  // which protos to its parent tag.
	  if (parser.opt.xmlns) parser.ns = Object.create(rootNS)
	
	  // mostly just for error reporting
	  parser.trackPosition = parser.opt.position !== false
	  if (parser.trackPosition) {
	    parser.position = parser.line = parser.column = 0
	  }
	  emit(parser, "onready")
	}
	
	if (!Object.create) Object.create = function (o) {
	  function f () { this.__proto__ = o }
	  f.prototype = o
	  return new f
	}
	
	if (!Object.getPrototypeOf) Object.getPrototypeOf = function (o) {
	  return o.__proto__
	}
	
	if (!Object.keys) Object.keys = function (o) {
	  var a = []
	  for (var i in o) if (o.hasOwnProperty(i)) a.push(i)
	  return a
	}
	
	function checkBufferLength (parser) {
	  var maxAllowed = Math.max(sax.MAX_BUFFER_LENGTH, 10)
	    , maxActual = 0
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    var len = parser[buffers[i]].length
	    if (len > maxAllowed) {
	      // Text/cdata nodes can get big, and since they're buffered,
	      // we can get here under normal conditions.
	      // Avoid issues by emitting the text node now,
	      // so at least it won't get any bigger.
	      switch (buffers[i]) {
	        case "textNode":
	          closeText(parser)
	        break
	
	        case "cdata":
	          emitNode(parser, "oncdata", parser.cdata)
	          parser.cdata = ""
	        break
	
	        case "script":
	          emitNode(parser, "onscript", parser.script)
	          parser.script = ""
	        break
	
	        default:
	          error(parser, "Max buffer length exceeded: "+buffers[i])
	      }
	    }
	    maxActual = Math.max(maxActual, len)
	  }
	  // schedule the next check for the earliest possible buffer overrun.
	  parser.bufferCheckPosition = (sax.MAX_BUFFER_LENGTH - maxActual)
	                             + parser.position
	}
	
	function clearBuffers (parser) {
	  for (var i = 0, l = buffers.length; i < l; i ++) {
	    parser[buffers[i]] = ""
	  }
	}
	
	function flushBuffers (parser) {
	  closeText(parser)
	  if (parser.cdata !== "") {
	    emitNode(parser, "oncdata", parser.cdata)
	    parser.cdata = ""
	  }
	  if (parser.script !== "") {
	    emitNode(parser, "onscript", parser.script)
	    parser.script = ""
	  }
	}
	
	SAXParser.prototype =
	  { end: function () { end(this) }
	  , write: write
	  , resume: function () { this.error = null; return this }
	  , close: function () { return this.write(null) }
	  , flush: function () { flushBuffers(this) }
	  }
	
	try {
	  var Stream = __webpack_require__(1506).Stream
	} catch (ex) {
	  var Stream = function () {}
	}
	
	
	var streamWraps = sax.EVENTS.filter(function (ev) {
	  return ev !== "error" && ev !== "end"
	})
	
	function createStream (strict, opt) {
	  return new SAXStream(strict, opt)
	}
	
	function SAXStream (strict, opt) {
	  if (!(this instanceof SAXStream)) return new SAXStream(strict, opt)
	
	  Stream.apply(this)
	
	  this._parser = new SAXParser(strict, opt)
	  this.writable = true
	  this.readable = true
	
	
	  var me = this
	
	  this._parser.onend = function () {
	    me.emit("end")
	  }
	
	  this._parser.onerror = function (er) {
	    me.emit("error", er)
	
	    // if didn't throw, then means error was handled.
	    // go ahead and clear error, so we can write again.
	    me._parser.error = null
	  }
	
	  this._decoder = null;
	
	  streamWraps.forEach(function (ev) {
	    Object.defineProperty(me, "on" + ev, {
	      get: function () { return me._parser["on" + ev] },
	      set: function (h) {
	        if (!h) {
	          me.removeAllListeners(ev)
	          return me._parser["on"+ev] = h
	        }
	        me.on(ev, h)
	      },
	      enumerable: true,
	      configurable: false
	    })
	  })
	}
	
	SAXStream.prototype = Object.create(Stream.prototype,
	  { constructor: { value: SAXStream } })
	
	SAXStream.prototype.write = function (data) {
	  if (typeof Buffer === 'function' &&
	      typeof Buffer.isBuffer === 'function' &&
	      Buffer.isBuffer(data)) {
	    if (!this._decoder) {
	      var SD = __webpack_require__(832).StringDecoder
	      this._decoder = new SD('utf8')
	    }
	    data = this._decoder.write(data);
	  }
	
	  this._parser.write(data.toString())
	  this.emit("data", data)
	  return true
	}
	
	SAXStream.prototype.end = function (chunk) {
	  if (chunk && chunk.length) this.write(chunk)
	  this._parser.end()
	  return true
	}
	
	SAXStream.prototype.on = function (ev, handler) {
	  var me = this
	  if (!me._parser["on"+ev] && streamWraps.indexOf(ev) !== -1) {
	    me._parser["on"+ev] = function () {
	      var args = arguments.length === 1 ? [arguments[0]]
	               : Array.apply(null, arguments)
	      args.splice(0, 0, ev)
	      me.emit.apply(me, args)
	    }
	  }
	
	  return Stream.prototype.on.call(me, ev, handler)
	}
	
	
	
	// character classes and tokens
	var whitespace = "\r\n\t "
	  // this really needs to be replaced with character classes.
	  // XML allows all manner of ridiculous numbers and digits.
	  , number = "0124356789"
	  , letter = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
	  // (Letter | "_" | ":")
	  , quote = "'\""
	  , entity = number+letter+"#"
	  , attribEnd = whitespace + ">"
	  , CDATA = "[CDATA["
	  , DOCTYPE = "DOCTYPE"
	  , XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace"
	  , XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/"
	  , rootNS = { xml: XML_NAMESPACE, xmlns: XMLNS_NAMESPACE }
	
	// turn all the string character sets into character class objects.
	whitespace = charClass(whitespace)
	number = charClass(number)
	letter = charClass(letter)
	
	// http://www.w3.org/TR/REC-xml/#NT-NameStartChar
	// This implementation works on strings, a single character at a time
	// as such, it cannot ever support astral-plane characters (10000-EFFFF)
	// without a significant breaking change to either this  parser, or the
	// JavaScript language.  Implementation of an emoji-capable xml parser
	// is left as an exercise for the reader.
	var nameStart = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/
	
	var nameBody = /[:_A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u00B7\u0300-\u036F\u203F-\u2040\.\d-]/
	
	quote = charClass(quote)
	entity = charClass(entity)
	attribEnd = charClass(attribEnd)
	
	function charClass (str) {
	  return str.split("").reduce(function (s, c) {
	    s[c] = true
	    return s
	  }, {})
	}
	
	function isRegExp (c) {
	  return Object.prototype.toString.call(c) === '[object RegExp]'
	}
	
	function is (charclass, c) {
	  return isRegExp(charclass) ? !!c.match(charclass) : charclass[c]
	}
	
	function not (charclass, c) {
	  return !is(charclass, c)
	}
	
	var S = 0
	sax.STATE =
	{ BEGIN                     : S++
	, TEXT                      : S++ // general stuff
	, TEXT_ENTITY               : S++ // &amp and such.
	, OPEN_WAKA                 : S++ // <
	, SGML_DECL                 : S++ // <!BLARG
	, SGML_DECL_QUOTED          : S++ // <!BLARG foo "bar
	, DOCTYPE                   : S++ // <!DOCTYPE
	, DOCTYPE_QUOTED            : S++ // <!DOCTYPE "//blah
	, DOCTYPE_DTD               : S++ // <!DOCTYPE "//blah" [ ...
	, DOCTYPE_DTD_QUOTED        : S++ // <!DOCTYPE "//blah" [ "foo
	, COMMENT_STARTING          : S++ // <!-
	, COMMENT                   : S++ // <!--
	, COMMENT_ENDING            : S++ // <!-- blah -
	, COMMENT_ENDED             : S++ // <!-- blah --
	, CDATA                     : S++ // <![CDATA[ something
	, CDATA_ENDING              : S++ // ]
	, CDATA_ENDING_2            : S++ // ]]
	, PROC_INST                 : S++ // <?hi
	, PROC_INST_BODY            : S++ // <?hi there
	, PROC_INST_ENDING          : S++ // <?hi "there" ?
	, OPEN_TAG                  : S++ // <strong
	, OPEN_TAG_SLASH            : S++ // <strong /
	, ATTRIB                    : S++ // <a
	, ATTRIB_NAME               : S++ // <a foo
	, ATTRIB_NAME_SAW_WHITE     : S++ // <a foo _
	, ATTRIB_VALUE              : S++ // <a foo=
	, ATTRIB_VALUE_QUOTED       : S++ // <a foo="bar
	, ATTRIB_VALUE_CLOSED       : S++ // <a foo="bar"
	, ATTRIB_VALUE_UNQUOTED     : S++ // <a foo=bar
	, ATTRIB_VALUE_ENTITY_Q     : S++ // <foo bar="&quot;"
	, ATTRIB_VALUE_ENTITY_U     : S++ // <foo bar=&quot;
	, CLOSE_TAG                 : S++ // </a
	, CLOSE_TAG_SAW_WHITE       : S++ // </a   >
	, SCRIPT                    : S++ // <script> ...
	, SCRIPT_ENDING             : S++ // <script> ... <
	}
	
	sax.ENTITIES =
	{ "amp" : "&"
	, "gt" : ">"
	, "lt" : "<"
	, "quot" : "\""
	, "apos" : "'"
	, "AElig" : 198
	, "Aacute" : 193
	, "Acirc" : 194
	, "Agrave" : 192
	, "Aring" : 197
	, "Atilde" : 195
	, "Auml" : 196
	, "Ccedil" : 199
	, "ETH" : 208
	, "Eacute" : 201
	, "Ecirc" : 202
	, "Egrave" : 200
	, "Euml" : 203
	, "Iacute" : 205
	, "Icirc" : 206
	, "Igrave" : 204
	, "Iuml" : 207
	, "Ntilde" : 209
	, "Oacute" : 211
	, "Ocirc" : 212
	, "Ograve" : 210
	, "Oslash" : 216
	, "Otilde" : 213
	, "Ouml" : 214
	, "THORN" : 222
	, "Uacute" : 218
	, "Ucirc" : 219
	, "Ugrave" : 217
	, "Uuml" : 220
	, "Yacute" : 221
	, "aacute" : 225
	, "acirc" : 226
	, "aelig" : 230
	, "agrave" : 224
	, "aring" : 229
	, "atilde" : 227
	, "auml" : 228
	, "ccedil" : 231
	, "eacute" : 233
	, "ecirc" : 234
	, "egrave" : 232
	, "eth" : 240
	, "euml" : 235
	, "iacute" : 237
	, "icirc" : 238
	, "igrave" : 236
	, "iuml" : 239
	, "ntilde" : 241
	, "oacute" : 243
	, "ocirc" : 244
	, "ograve" : 242
	, "oslash" : 248
	, "otilde" : 245
	, "ouml" : 246
	, "szlig" : 223
	, "thorn" : 254
	, "uacute" : 250
	, "ucirc" : 251
	, "ugrave" : 249
	, "uuml" : 252
	, "yacute" : 253
	, "yuml" : 255
	, "copy" : 169
	, "reg" : 174
	, "nbsp" : 160
	, "iexcl" : 161
	, "cent" : 162
	, "pound" : 163
	, "curren" : 164
	, "yen" : 165
	, "brvbar" : 166
	, "sect" : 167
	, "uml" : 168
	, "ordf" : 170
	, "laquo" : 171
	, "not" : 172
	, "shy" : 173
	, "macr" : 175
	, "deg" : 176
	, "plusmn" : 177
	, "sup1" : 185
	, "sup2" : 178
	, "sup3" : 179
	, "acute" : 180
	, "micro" : 181
	, "para" : 182
	, "middot" : 183
	, "cedil" : 184
	, "ordm" : 186
	, "raquo" : 187
	, "frac14" : 188
	, "frac12" : 189
	, "frac34" : 190
	, "iquest" : 191
	, "times" : 215
	, "divide" : 247
	, "OElig" : 338
	, "oelig" : 339
	, "Scaron" : 352
	, "scaron" : 353
	, "Yuml" : 376
	, "fnof" : 402
	, "circ" : 710
	, "tilde" : 732
	, "Alpha" : 913
	, "Beta" : 914
	, "Gamma" : 915
	, "Delta" : 916
	, "Epsilon" : 917
	, "Zeta" : 918
	, "Eta" : 919
	, "Theta" : 920
	, "Iota" : 921
	, "Kappa" : 922
	, "Lambda" : 923
	, "Mu" : 924
	, "Nu" : 925
	, "Xi" : 926
	, "Omicron" : 927
	, "Pi" : 928
	, "Rho" : 929
	, "Sigma" : 931
	, "Tau" : 932
	, "Upsilon" : 933
	, "Phi" : 934
	, "Chi" : 935
	, "Psi" : 936
	, "Omega" : 937
	, "alpha" : 945
	, "beta" : 946
	, "gamma" : 947
	, "delta" : 948
	, "epsilon" : 949
	, "zeta" : 950
	, "eta" : 951
	, "theta" : 952
	, "iota" : 953
	, "kappa" : 954
	, "lambda" : 955
	, "mu" : 956
	, "nu" : 957
	, "xi" : 958
	, "omicron" : 959
	, "pi" : 960
	, "rho" : 961
	, "sigmaf" : 962
	, "sigma" : 963
	, "tau" : 964
	, "upsilon" : 965
	, "phi" : 966
	, "chi" : 967
	, "psi" : 968
	, "omega" : 969
	, "thetasym" : 977
	, "upsih" : 978
	, "piv" : 982
	, "ensp" : 8194
	, "emsp" : 8195
	, "thinsp" : 8201
	, "zwnj" : 8204
	, "zwj" : 8205
	, "lrm" : 8206
	, "rlm" : 8207
	, "ndash" : 8211
	, "mdash" : 8212
	, "lsquo" : 8216
	, "rsquo" : 8217
	, "sbquo" : 8218
	, "ldquo" : 8220
	, "rdquo" : 8221
	, "bdquo" : 8222
	, "dagger" : 8224
	, "Dagger" : 8225
	, "bull" : 8226
	, "hellip" : 8230
	, "permil" : 8240
	, "prime" : 8242
	, "Prime" : 8243
	, "lsaquo" : 8249
	, "rsaquo" : 8250
	, "oline" : 8254
	, "frasl" : 8260
	, "euro" : 8364
	, "image" : 8465
	, "weierp" : 8472
	, "real" : 8476
	, "trade" : 8482
	, "alefsym" : 8501
	, "larr" : 8592
	, "uarr" : 8593
	, "rarr" : 8594
	, "darr" : 8595
	, "harr" : 8596
	, "crarr" : 8629
	, "lArr" : 8656
	, "uArr" : 8657
	, "rArr" : 8658
	, "dArr" : 8659
	, "hArr" : 8660
	, "forall" : 8704
	, "part" : 8706
	, "exist" : 8707
	, "empty" : 8709
	, "nabla" : 8711
	, "isin" : 8712
	, "notin" : 8713
	, "ni" : 8715
	, "prod" : 8719
	, "sum" : 8721
	, "minus" : 8722
	, "lowast" : 8727
	, "radic" : 8730
	, "prop" : 8733
	, "infin" : 8734
	, "ang" : 8736
	, "and" : 8743
	, "or" : 8744
	, "cap" : 8745
	, "cup" : 8746
	, "int" : 8747
	, "there4" : 8756
	, "sim" : 8764
	, "cong" : 8773
	, "asymp" : 8776
	, "ne" : 8800
	, "equiv" : 8801
	, "le" : 8804
	, "ge" : 8805
	, "sub" : 8834
	, "sup" : 8835
	, "nsub" : 8836
	, "sube" : 8838
	, "supe" : 8839
	, "oplus" : 8853
	, "otimes" : 8855
	, "perp" : 8869
	, "sdot" : 8901
	, "lceil" : 8968
	, "rceil" : 8969
	, "lfloor" : 8970
	, "rfloor" : 8971
	, "lang" : 9001
	, "rang" : 9002
	, "loz" : 9674
	, "spades" : 9824
	, "clubs" : 9827
	, "hearts" : 9829
	, "diams" : 9830
	}
	
	Object.keys(sax.ENTITIES).forEach(function (key) {
	    var e = sax.ENTITIES[key]
	    var s = typeof e === 'number' ? String.fromCharCode(e) : e
	    sax.ENTITIES[key] = s
	})
	
	for (var S in sax.STATE) sax.STATE[sax.STATE[S]] = S
	
	// shorthand
	S = sax.STATE
	
	function emit (parser, event, data) {
	  parser[event] && parser[event](data)
	}
	
	function emitNode (parser, nodeType, data) {
	  if (parser.textNode) closeText(parser)
	  emit(parser, nodeType, data)
	}
	
	function closeText (parser) {
	  parser.textNode = textopts(parser.opt, parser.textNode)
	  if (parser.textNode) emit(parser, "ontext", parser.textNode)
	  parser.textNode = ""
	}
	
	function textopts (opt, text) {
	  if (opt.trim) text = text.trim()
	  if (opt.normalize) text = text.replace(/\s+/g, " ")
	  return text
	}
	
	function error (parser, er) {
	  closeText(parser)
	  if (parser.trackPosition) {
	    er += "\nLine: "+parser.line+
	          "\nColumn: "+parser.column+
	          "\nChar: "+parser.c
	  }
	  er = new Error(er)
	  parser.error = er
	  emit(parser, "onerror", er)
	  return parser
	}
	
	function end (parser) {
	  if (!parser.closedRoot) strictFail(parser, "Unclosed root tag")
	  if ((parser.state !== S.BEGIN) && (parser.state !== S.TEXT)) error(parser, "Unexpected end")
	  closeText(parser)
	  parser.c = ""
	  parser.closed = true
	  emit(parser, "onend")
	  SAXParser.call(parser, parser.strict, parser.opt)
	  return parser
	}
	
	function strictFail (parser, message) {
	  if (typeof parser !== 'object' || !(parser instanceof SAXParser))
	    throw new Error('bad call to strictFail');
	  if (parser.strict) error(parser, message)
	}
	
	function newTag (parser) {
	  if (!parser.strict) parser.tagName = parser.tagName[parser.looseCase]()
	  var parent = parser.tags[parser.tags.length - 1] || parser
	    , tag = parser.tag = { name : parser.tagName, attributes : {} }
	
	  // will be overridden if tag contails an xmlns="foo" or xmlns:foo="bar"
	  if (parser.opt.xmlns) tag.ns = parent.ns
	  parser.attribList.length = 0
	}
	
	function qname (name, attribute) {
	  var i = name.indexOf(":")
	    , qualName = i < 0 ? [ "", name ] : name.split(":")
	    , prefix = qualName[0]
	    , local = qualName[1]
	
	  // <x "xmlns"="http://foo">
	  if (attribute && name === "xmlns") {
	    prefix = "xmlns"
	    local = ""
	  }
	
	  return { prefix: prefix, local: local }
	}
	
	function attrib (parser) {
	  if (!parser.strict) parser.attribName = parser.attribName[parser.looseCase]()
	
	  if (parser.attribList.indexOf(parser.attribName) !== -1 ||
	      parser.tag.attributes.hasOwnProperty(parser.attribName)) {
	    return parser.attribName = parser.attribValue = ""
	  }
	
	  if (parser.opt.xmlns) {
	    var qn = qname(parser.attribName, true)
	      , prefix = qn.prefix
	      , local = qn.local
	
	    if (prefix === "xmlns") {
	      // namespace binding attribute; push the binding into scope
	      if (local === "xml" && parser.attribValue !== XML_NAMESPACE) {
	        strictFail( parser
	                  , "xml: prefix must be bound to " + XML_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else if (local === "xmlns" && parser.attribValue !== XMLNS_NAMESPACE) {
	        strictFail( parser
	                  , "xmlns: prefix must be bound to " + XMLNS_NAMESPACE + "\n"
	                  + "Actual: " + parser.attribValue )
	      } else {
	        var tag = parser.tag
	          , parent = parser.tags[parser.tags.length - 1] || parser
	        if (tag.ns === parent.ns) {
	          tag.ns = Object.create(parent.ns)
	        }
	        tag.ns[local] = parser.attribValue
	      }
	    }
	
	    // defer onattribute events until all attributes have been seen
	    // so any new bindings can take effect; preserve attribute order
	    // so deferred events can be emitted in document order
	    parser.attribList.push([parser.attribName, parser.attribValue])
	  } else {
	    // in non-xmlns mode, we can emit the event right away
	    parser.tag.attributes[parser.attribName] = parser.attribValue
	    emitNode( parser
	            , "onattribute"
	            , { name: parser.attribName
	              , value: parser.attribValue } )
	  }
	
	  parser.attribName = parser.attribValue = ""
	}
	
	function openTag (parser, selfClosing) {
	  if (parser.opt.xmlns) {
	    // emit namespace binding events
	    var tag = parser.tag
	
	    // add namespace info to tag
	    var qn = qname(parser.tagName)
	    tag.prefix = qn.prefix
	    tag.local = qn.local
	    tag.uri = tag.ns[qn.prefix] || ""
	
	    if (tag.prefix && !tag.uri) {
	      strictFail(parser, "Unbound namespace prefix: "
	                       + JSON.stringify(parser.tagName))
	      tag.uri = qn.prefix
	    }
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (tag.ns && parent.ns !== tag.ns) {
	      Object.keys(tag.ns).forEach(function (p) {
	        emitNode( parser
	                , "onopennamespace"
	                , { prefix: p , uri: tag.ns[p] } )
	      })
	    }
	
	    // handle deferred onattribute events
	    // Note: do not apply default ns to attributes:
	    //   http://www.w3.org/TR/REC-xml-names/#defaulting
	    for (var i = 0, l = parser.attribList.length; i < l; i ++) {
	      var nv = parser.attribList[i]
	      var name = nv[0]
	        , value = nv[1]
	        , qualName = qname(name, true)
	        , prefix = qualName.prefix
	        , local = qualName.local
	        , uri = prefix == "" ? "" : (tag.ns[prefix] || "")
	        , a = { name: name
	              , value: value
	              , prefix: prefix
	              , local: local
	              , uri: uri
	              }
	
	      // if there's any attributes with an undefined namespace,
	      // then fail on them now.
	      if (prefix && prefix != "xmlns" && !uri) {
	        strictFail(parser, "Unbound namespace prefix: "
	                         + JSON.stringify(prefix))
	        a.uri = prefix
	      }
	      parser.tag.attributes[name] = a
	      emitNode(parser, "onattribute", a)
	    }
	    parser.attribList.length = 0
	  }
	
	  parser.tag.isSelfClosing = !!selfClosing
	
	  // process the tag
	  parser.sawRoot = true
	  parser.tags.push(parser.tag)
	  emitNode(parser, "onopentag", parser.tag)
	  if (!selfClosing) {
	    // special case for <script> in non-strict mode.
	    if (!parser.noscript && parser.tagName.toLowerCase() === "script") {
	      parser.state = S.SCRIPT
	    } else {
	      parser.state = S.TEXT
	    }
	    parser.tag = null
	    parser.tagName = ""
	  }
	  parser.attribName = parser.attribValue = ""
	  parser.attribList.length = 0
	}
	
	function closeTag (parser) {
	  if (!parser.tagName) {
	    strictFail(parser, "Weird empty close tag.")
	    parser.textNode += "</>"
	    parser.state = S.TEXT
	    return
	  }
	
	  if (parser.script) {
	    if (parser.tagName !== "script") {
	      parser.script += "</" + parser.tagName + ">"
	      parser.tagName = ""
	      parser.state = S.SCRIPT
	      return
	    }
	    emitNode(parser, "onscript", parser.script)
	    parser.script = ""
	  }
	
	  // first make sure that the closing tag actually exists.
	  // <a><b></c></b></a> will close everything, otherwise.
	  var t = parser.tags.length
	  var tagName = parser.tagName
	  if (!parser.strict) tagName = tagName[parser.looseCase]()
	  var closeTo = tagName
	  while (t --) {
	    var close = parser.tags[t]
	    if (close.name !== closeTo) {
	      // fail the first time in strict mode
	      strictFail(parser, "Unexpected close tag")
	    } else break
	  }
	
	  // didn't find it.  we already failed for strict, so just abort.
	  if (t < 0) {
	    strictFail(parser, "Unmatched closing tag: "+parser.tagName)
	    parser.textNode += "</" + parser.tagName + ">"
	    parser.state = S.TEXT
	    return
	  }
	  parser.tagName = tagName
	  var s = parser.tags.length
	  while (s --> t) {
	    var tag = parser.tag = parser.tags.pop()
	    parser.tagName = parser.tag.name
	    emitNode(parser, "onclosetag", parser.tagName)
	
	    var x = {}
	    for (var i in tag.ns) x[i] = tag.ns[i]
	
	    var parent = parser.tags[parser.tags.length - 1] || parser
	    if (parser.opt.xmlns && tag.ns !== parent.ns) {
	      // remove namespace bindings introduced by tag
	      Object.keys(tag.ns).forEach(function (p) {
	        var n = tag.ns[p]
	        emitNode(parser, "onclosenamespace", { prefix: p, uri: n })
	      })
	    }
	  }
	  if (t === 0) parser.closedRoot = true
	  parser.tagName = parser.attribValue = parser.attribName = ""
	  parser.attribList.length = 0
	  parser.state = S.TEXT
	}
	
	function parseEntity (parser) {
	  var entity = parser.entity
	    , entityLC = entity.toLowerCase()
	    , num
	    , numStr = ""
	  if (parser.ENTITIES[entity])
	    return parser.ENTITIES[entity]
	  if (parser.ENTITIES[entityLC])
	    return parser.ENTITIES[entityLC]
	  entity = entityLC
	  if (entity.charAt(0) === "#") {
	    if (entity.charAt(1) === "x") {
	      entity = entity.slice(2)
	      num = parseInt(entity, 16)
	      numStr = num.toString(16)
	    } else {
	      entity = entity.slice(1)
	      num = parseInt(entity, 10)
	      numStr = num.toString(10)
	    }
	  }
	  entity = entity.replace(/^0+/, "")
	  if (numStr.toLowerCase() !== entity) {
	    strictFail(parser, "Invalid character entity")
	    return "&"+parser.entity + ";"
	  }
	  return String.fromCharCode(num)
	}
	
	function write (chunk) {
	  var parser = this
	  if (this.error) throw this.error
	  if (parser.closed) return error(parser,
	    "Cannot write after close. Assign an onready handler.")
	  if (chunk === null) return end(parser)
	  var i = 0, c = ""
	  while (parser.c = c = chunk.charAt(i++)) {
	    if (parser.trackPosition) {
	      parser.position ++
	      if (c === "\n") {
	        parser.line ++
	        parser.column = 0
	      } else parser.column ++
	    }
	    switch (parser.state) {
	
	      case S.BEGIN:
	        if (c === "<") {
	          parser.state = S.OPEN_WAKA
	          parser.startTagPosition = parser.position
	        } else if (not(whitespace,c)) {
	          // have to process this as a text node.
	          // weird, but happens.
	          strictFail(parser, "Non-whitespace before first tag.")
	          parser.textNode = c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.TEXT:
	        if (parser.sawRoot && !parser.closedRoot) {
	          var starti = i-1
	          while (c && c!=="<" && c!=="&") {
	            c = chunk.charAt(i++)
	            if (c && parser.trackPosition) {
	              parser.position ++
	              if (c === "\n") {
	                parser.line ++
	                parser.column = 0
	              } else parser.column ++
	            }
	          }
	          parser.textNode += chunk.substring(starti, i-1)
	        }
	        if (c === "<") {
	          parser.state = S.OPEN_WAKA
	          parser.startTagPosition = parser.position
	        } else {
	          if (not(whitespace, c) && (!parser.sawRoot || parser.closedRoot))
	            strictFail(parser, "Text data outside of root node.")
	          if (c === "&") parser.state = S.TEXT_ENTITY
	          else parser.textNode += c
	        }
	      continue
	
	      case S.SCRIPT:
	        // only non-strict
	        if (c === "<") {
	          parser.state = S.SCRIPT_ENDING
	        } else parser.script += c
	      continue
	
	      case S.SCRIPT_ENDING:
	        if (c === "/") {
	          parser.state = S.CLOSE_TAG
	        } else {
	          parser.script += "<" + c
	          parser.state = S.SCRIPT
	        }
	      continue
	
	      case S.OPEN_WAKA:
	        // either a /, ?, !, or text is coming next.
	        if (c === "!") {
	          parser.state = S.SGML_DECL
	          parser.sgmlDecl = ""
	        } else if (is(whitespace, c)) {
	          // wait for it...
	        } else if (is(nameStart,c)) {
	          parser.state = S.OPEN_TAG
	          parser.tagName = c
	        } else if (c === "/") {
	          parser.state = S.CLOSE_TAG
	          parser.tagName = ""
	        } else if (c === "?") {
	          parser.state = S.PROC_INST
	          parser.procInstName = parser.procInstBody = ""
	        } else {
	          strictFail(parser, "Unencoded <")
	          // if there was some whitespace, then add that in.
	          if (parser.startTagPosition + 1 < parser.position) {
	            var pad = parser.position - parser.startTagPosition
	            c = new Array(pad).join(" ") + c
	          }
	          parser.textNode += "<" + c
	          parser.state = S.TEXT
	        }
	      continue
	
	      case S.SGML_DECL:
	        if ((parser.sgmlDecl+c).toUpperCase() === CDATA) {
	          emitNode(parser, "onopencdata")
	          parser.state = S.CDATA
	          parser.sgmlDecl = ""
	          parser.cdata = ""
	        } else if (parser.sgmlDecl+c === "--") {
	          parser.state = S.COMMENT
	          parser.comment = ""
	          parser.sgmlDecl = ""
	        } else if ((parser.sgmlDecl+c).toUpperCase() === DOCTYPE) {
	          parser.state = S.DOCTYPE
	          if (parser.doctype || parser.sawRoot) strictFail(parser,
	            "Inappropriately located doctype declaration")
	          parser.doctype = ""
	          parser.sgmlDecl = ""
	        } else if (c === ">") {
	          emitNode(parser, "onsgmldeclaration", parser.sgmlDecl)
	          parser.sgmlDecl = ""
	          parser.state = S.TEXT
	        } else if (is(quote, c)) {
	          parser.state = S.SGML_DECL_QUOTED
	          parser.sgmlDecl += c
	        } else parser.sgmlDecl += c
	      continue
	
	      case S.SGML_DECL_QUOTED:
	        if (c === parser.q) {
	          parser.state = S.SGML_DECL
	          parser.q = ""
	        }
	        parser.sgmlDecl += c
	      continue
	
	      case S.DOCTYPE:
	        if (c === ">") {
	          parser.state = S.TEXT
	          emitNode(parser, "ondoctype", parser.doctype)
	          parser.doctype = true // just remember that we saw it.
	        } else {
	          parser.doctype += c
	          if (c === "[") parser.state = S.DOCTYPE_DTD
	          else if (is(quote, c)) {
	            parser.state = S.DOCTYPE_QUOTED
	            parser.q = c
	          }
	        }
	      continue
	
	      case S.DOCTYPE_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.q = ""
	          parser.state = S.DOCTYPE
	        }
	      continue
	
	      case S.DOCTYPE_DTD:
	        parser.doctype += c
	        if (c === "]") parser.state = S.DOCTYPE
	        else if (is(quote,c)) {
	          parser.state = S.DOCTYPE_DTD_QUOTED
	          parser.q = c
	        }
	      continue
	
	      case S.DOCTYPE_DTD_QUOTED:
	        parser.doctype += c
	        if (c === parser.q) {
	          parser.state = S.DOCTYPE_DTD
	          parser.q = ""
	        }
	      continue
	
	      case S.COMMENT:
	        if (c === "-") parser.state = S.COMMENT_ENDING
	        else parser.comment += c
	      continue
	
	      case S.COMMENT_ENDING:
	        if (c === "-") {
	          parser.state = S.COMMENT_ENDED
	          parser.comment = textopts(parser.opt, parser.comment)
	          if (parser.comment) emitNode(parser, "oncomment", parser.comment)
	          parser.comment = ""
	        } else {
	          parser.comment += "-" + c
	          parser.state = S.COMMENT
	        }
	      continue
	
	      case S.COMMENT_ENDED:
	        if (c !== ">") {
	          strictFail(parser, "Malformed comment")
	          // allow <!-- blah -- bloo --> in non-strict mode,
	          // which is a comment of " blah -- bloo "
	          parser.comment += "--" + c
	          parser.state = S.COMMENT
	        } else parser.state = S.TEXT
	      continue
	
	      case S.CDATA:
	        if (c === "]") parser.state = S.CDATA_ENDING
	        else parser.cdata += c
	      continue
	
	      case S.CDATA_ENDING:
	        if (c === "]") parser.state = S.CDATA_ENDING_2
	        else {
	          parser.cdata += "]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.CDATA_ENDING_2:
	        if (c === ">") {
	          if (parser.cdata) emitNode(parser, "oncdata", parser.cdata)
	          emitNode(parser, "onclosecdata")
	          parser.cdata = ""
	          parser.state = S.TEXT
	        } else if (c === "]") {
	          parser.cdata += "]"
	        } else {
	          parser.cdata += "]]" + c
	          parser.state = S.CDATA
	        }
	      continue
	
	      case S.PROC_INST:
	        if (c === "?") parser.state = S.PROC_INST_ENDING
	        else if (is(whitespace, c)) parser.state = S.PROC_INST_BODY
	        else parser.procInstName += c
	      continue
	
	      case S.PROC_INST_BODY:
	        if (!parser.procInstBody && is(whitespace, c)) continue
	        else if (c === "?") parser.state = S.PROC_INST_ENDING
	        else parser.procInstBody += c
	      continue
	
	      case S.PROC_INST_ENDING:
	        if (c === ">") {
	          emitNode(parser, "onprocessinginstruction", {
	            name : parser.procInstName,
	            body : parser.procInstBody
	          })
	          parser.procInstName = parser.procInstBody = ""
	          parser.state = S.TEXT
	        } else {
	          parser.procInstBody += "?" + c
	          parser.state = S.PROC_INST_BODY
	        }
	      continue
	
	      case S.OPEN_TAG:
	        if (is(nameBody, c)) parser.tagName += c
	        else {
	          newTag(parser)
	          if (c === ">") openTag(parser)
	          else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	          else {
	            if (not(whitespace, c)) strictFail(
	              parser, "Invalid character in tag name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.OPEN_TAG_SLASH:
	        if (c === ">") {
	          openTag(parser, true)
	          closeTag(parser)
	        } else {
	          strictFail(parser, "Forward-slash in opening tag not followed by >")
	          parser.state = S.ATTRIB
	        }
	      continue
	
	      case S.ATTRIB:
	        // haven't read the attribute name yet.
	        if (is(whitespace, c)) continue
	        else if (c === ">") openTag(parser)
	        else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	        else if (is(nameStart, c)) {
	          parser.attribName = c
	          parser.attribValue = ""
	          parser.state = S.ATTRIB_NAME
	        } else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (c === ">") {
	          strictFail(parser, "Attribute without value")
	          parser.attribValue = parser.attribName
	          attrib(parser)
	          openTag(parser)
	        }
	        else if (is(whitespace, c)) parser.state = S.ATTRIB_NAME_SAW_WHITE
	        else if (is(nameBody, c)) parser.attribName += c
	        else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_NAME_SAW_WHITE:
	        if (c === "=") parser.state = S.ATTRIB_VALUE
	        else if (is(whitespace, c)) continue
	        else {
	          strictFail(parser, "Attribute without value")
	          parser.tag.attributes[parser.attribName] = ""
	          parser.attribValue = ""
	          emitNode(parser, "onattribute",
	                   { name : parser.attribName, value : "" })
	          parser.attribName = ""
	          if (c === ">") openTag(parser)
	          else if (is(nameStart, c)) {
	            parser.attribName = c
	            parser.state = S.ATTRIB_NAME
	          } else {
	            strictFail(parser, "Invalid attribute name")
	            parser.state = S.ATTRIB
	          }
	        }
	      continue
	
	      case S.ATTRIB_VALUE:
	        if (is(whitespace, c)) continue
	        else if (is(quote, c)) {
	          parser.q = c
	          parser.state = S.ATTRIB_VALUE_QUOTED
	        } else {
	          strictFail(parser, "Unquoted attribute value")
	          parser.state = S.ATTRIB_VALUE_UNQUOTED
	          parser.attribValue = c
	        }
	      continue
	
	      case S.ATTRIB_VALUE_QUOTED:
	        if (c !== parser.q) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_Q
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        parser.q = ""
	        parser.state = S.ATTRIB_VALUE_CLOSED
	      continue
	
	      case S.ATTRIB_VALUE_CLOSED:
	        if (is(whitespace, c)) {
	          parser.state = S.ATTRIB
	        } else if (c === ">") openTag(parser)
	        else if (c === "/") parser.state = S.OPEN_TAG_SLASH
	        else if (is(nameStart, c)) {
	          strictFail(parser, "No whitespace between attributes")
	          parser.attribName = c
	          parser.attribValue = ""
	          parser.state = S.ATTRIB_NAME
	        } else strictFail(parser, "Invalid attribute name")
	      continue
	
	      case S.ATTRIB_VALUE_UNQUOTED:
	        if (not(attribEnd,c)) {
	          if (c === "&") parser.state = S.ATTRIB_VALUE_ENTITY_U
	          else parser.attribValue += c
	          continue
	        }
	        attrib(parser)
	        if (c === ">") openTag(parser)
	        else parser.state = S.ATTRIB
	      continue
	
	      case S.CLOSE_TAG:
	        if (!parser.tagName) {
	          if (is(whitespace, c)) continue
	          else if (not(nameStart, c)) {
	            if (parser.script) {
	              parser.script += "</" + c
	              parser.state = S.SCRIPT
	            } else {
	              strictFail(parser, "Invalid tagname in closing tag.")
	            }
	          } else parser.tagName = c
	        }
	        else if (c === ">") closeTag(parser)
	        else if (is(nameBody, c)) parser.tagName += c
	        else if (parser.script) {
	          parser.script += "</" + parser.tagName
	          parser.tagName = ""
	          parser.state = S.SCRIPT
	        } else {
	          if (not(whitespace, c)) strictFail(parser,
	            "Invalid tagname in closing tag")
	          parser.state = S.CLOSE_TAG_SAW_WHITE
	        }
	      continue
	
	      case S.CLOSE_TAG_SAW_WHITE:
	        if (is(whitespace, c)) continue
	        if (c === ">") closeTag(parser)
	        else strictFail(parser, "Invalid characters in closing tag")
	      continue
	
	      case S.TEXT_ENTITY:
	      case S.ATTRIB_VALUE_ENTITY_Q:
	      case S.ATTRIB_VALUE_ENTITY_U:
	        switch(parser.state) {
	          case S.TEXT_ENTITY:
	            var returnState = S.TEXT, buffer = "textNode"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_Q:
	            var returnState = S.ATTRIB_VALUE_QUOTED, buffer = "attribValue"
	          break
	
	          case S.ATTRIB_VALUE_ENTITY_U:
	            var returnState = S.ATTRIB_VALUE_UNQUOTED, buffer = "attribValue"
	          break
	        }
	        if (c === ";") {
	          parser[buffer] += parseEntity(parser)
	          parser.entity = ""
	          parser.state = returnState
	        }
	        else if (is(entity, c)) parser.entity += c
	        else {
	          strictFail(parser, "Invalid character entity")
	          parser[buffer] += "&" + parser.entity + c
	          parser.entity = ""
	          parser.state = returnState
	        }
	      continue
	
	      default:
	        throw new Error(parser, "Unknown state: " + parser.state)
	    }
	  } // while
	  // cdata blocks can get very big under normal conditions. emit and move on.
	  // if (parser.state === S.CDATA && parser.cdata) {
	  //   emitNode(parser, "oncdata", parser.cdata)
	  //   parser.cdata = ""
	  // }
	  if (parser.position >= parser.bufferCheckPosition) checkBufferLength(parser)
	  return parser
	}
	
	})( false ? sax = {} : exports)
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79).Buffer))

/***/ },
/* 1503 */
/***/ function(module, exports) {

	/** @license React v0.17.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout,A=window.requestAnimationFrame,B=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));if("object"===typeof w&&
	"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var C=x.now();exports.unstable_now=function(){return x.now()-C}}var D=!1,E=null,F=-1,G=5,H=0;k=function(){return exports.unstable_now()>=H};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):G=0<a?Math.floor(1E3/a):33.33};var I=new MessageChannel,J=I.port2;I.port1.onmessage=
	function(){if(null!==E){var a=exports.unstable_now();H=a+G;try{E(!0,a)?J.postMessage(null):(D=!1,E=null)}catch(b){throw J.postMessage(null),b;}}else D=!1};f=function(a){E=a;D||(D=!0,J.postMessage(null))};g=function(a,b){F=y(function(){a(exports.unstable_now())},b)};h=function(){z(F);F=-1}}function K(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<L(e,b))a[d]=b,a[c]=e,c=d;else break a}}function M(a){a=a[0];return void 0===a?null:a}
	function N(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>L(n,c))void 0!==r&&0>L(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>L(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function L(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var O=[],P=[],Q=1,R=null,S=3,T=!1,U=!1,V=!1;
	function W(a){for(var b=M(P);null!==b;){if(null===b.callback)N(P);else if(b.startTime<=a)N(P),b.sortIndex=b.expirationTime,K(O,b);else break;b=M(P)}}function X(a){V=!1;W(a);if(!U)if(null!==M(O))U=!0,f(Y);else{var b=M(P);null!==b&&g(X,b.startTime-a)}}
	function Y(a,b){U=!1;V&&(V=!1,h());T=!0;var c=S;try{W(b);for(R=M(O);null!==R&&(!(R.expirationTime>b)||a&&!k());){var d=R.callback;if(null!==d){R.callback=null;S=R.priorityLevel;var e=d(R.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?R.callback=e:R===M(O)&&N(O);W(b)}else N(O);R=M(O)}if(null!==R)var m=!0;else{var n=M(P);null!==n&&g(X,n.startTime-b);m=!1}return m}finally{R=null,S=c,T=!1}}
	function Z(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var aa=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=S;S=a;try{return b()}finally{S=c}};
	exports.unstable_next=function(a){switch(S){case 1:case 2:case 3:var b=3;break;default:b=S}var c=S;S=b;try{return a()}finally{S=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Z(a)}else c=Z(a),e=d;c=e+c;a={id:Q++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,K(P,a),null===M(O)&&a===M(P)&&(V?h():V=!0,g(X,e-d))):(a.sortIndex=c,K(O,a),U||T||(U=!0,f(Y)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
	exports.unstable_wrapCallback=function(a){var b=S;return function(){var c=S;S=b;try{return a.apply(this,arguments)}finally{S=c}}};exports.unstable_getCurrentPriorityLevel=function(){return S};exports.unstable_shouldYield=function(){var a=exports.unstable_now();W(a);var b=M(O);return b!==R&&null!==R&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<R.expirationTime||k()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){U||T||(U=!0,f(Y))};
	exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M(O)};exports.unstable_Profiling=null;


/***/ },
/* 1504 */
[1516, 1503],
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)))

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(156).EventEmitter;
	var inherits = __webpack_require__(82);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(831);
	Stream.Writable = __webpack_require__(1501);
	Stream.Duplex = __webpack_require__(1496);
	Stream.Transform = __webpack_require__(1500);
	Stream.PassThrough = __webpack_require__(1499);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1505);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1508 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1509 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  isPlainObject = __webpack_require__(60).isPlainObject;
	
	  XMLNode = __webpack_require__(40);
	
	  XMLStringifier = __webpack_require__(1076);
	
	  XMLStringWriter = __webpack_require__(833);
	
	  module.exports = XMLDocument = (function(superClass) {
	    extend(XMLDocument, superClass);
	
	    function XMLDocument(options) {
	      XMLDocument.__super__.constructor.call(this, null);
	      options || (options = {});
	      if (!options.writer) {
	        options.writer = new XMLStringWriter();
	      }
	      this.options = options;
	      this.stringify = new XMLStringifier(options);
	      this.isDocument = true;
	    }
	
	    XMLDocument.prototype.end = function(writer) {
	      var writerOptions;
	      if (!writer) {
	        writer = this.options.writer;
	      } else if (isPlainObject(writer)) {
	        writerOptions = writer;
	        writer = this.options.writer.set(writerOptions);
	      }
	      return writer.document(this);
	    };
	
	    XMLDocument.prototype.toString = function(options) {
	      return this.options.writer.set(options).document(this);
	    };
	
	    return XMLDocument;
	
	  })(XMLNode);
	
	}).call(this);


/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, isFunction, isObject, isPlainObject, ref,
	    hasProp = {}.hasOwnProperty;
	
	  ref = __webpack_require__(60), isObject = ref.isObject, isFunction = ref.isFunction, isPlainObject = ref.isPlainObject;
	
	  XMLElement = __webpack_require__(138);
	
	  XMLCData = __webpack_require__(130);
	
	  XMLComment = __webpack_require__(131);
	
	  XMLRaw = __webpack_require__(140);
	
	  XMLText = __webpack_require__(141);
	
	  XMLProcessingInstruction = __webpack_require__(139);
	
	  XMLDeclaration = __webpack_require__(136);
	
	  XMLDocType = __webpack_require__(137);
	
	  XMLDTDAttList = __webpack_require__(132);
	
	  XMLDTDEntity = __webpack_require__(134);
	
	  XMLDTDElement = __webpack_require__(133);
	
	  XMLDTDNotation = __webpack_require__(135);
	
	  XMLAttribute = __webpack_require__(1075);
	
	  XMLStringifier = __webpack_require__(1076);
	
	  XMLStringWriter = __webpack_require__(833);
	
	  module.exports = XMLDocumentCB = (function() {
	    function XMLDocumentCB(options, onData, onEnd) {
	      var writerOptions;
	      options || (options = {});
	      if (!options.writer) {
	        options.writer = new XMLStringWriter(options);
	      } else if (isPlainObject(options.writer)) {
	        writerOptions = options.writer;
	        options.writer = new XMLStringWriter(writerOptions);
	      }
	      this.options = options;
	      this.writer = options.writer;
	      this.stringify = new XMLStringifier(options);
	      this.onDataCallback = onData || function() {};
	      this.onEndCallback = onEnd || function() {};
	      this.currentNode = null;
	      this.currentLevel = -1;
	      this.openTags = {};
	      this.documentStarted = false;
	      this.documentCompleted = false;
	      this.root = null;
	    }
	
	    XMLDocumentCB.prototype.node = function(name, attributes, text) {
	      var ref1;
	      if (name == null) {
	        throw new Error("Missing node name");
	      }
	      if (this.root && this.currentLevel === -1) {
	        throw new Error("Document can only have one root node");
	      }
	      this.openCurrent();
	      name = name.valueOf();
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes = attributes.valueOf();
	      if (!isObject(attributes)) {
	        ref1 = [attributes, text], text = ref1[0], attributes = ref1[1];
	      }
	      this.currentNode = new XMLElement(this, name, attributes);
	      this.currentNode.children = false;
	      this.currentLevel++;
	      this.openTags[this.currentLevel] = this.currentNode;
	      if (text != null) {
	        this.text(text);
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.element = function(name, attributes, text) {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.dtdElement.apply(this, arguments);
	      } else {
	        return this.node(name, attributes, text);
	      }
	    };
	
	    XMLDocumentCB.prototype.attribute = function(name, value) {
	      var attName, attValue;
	      if (!this.currentNode || this.currentNode.children) {
	        throw new Error("att() can only be used immediately after an ele() call in callback mode");
	      }
	      if (name != null) {
	        name = name.valueOf();
	      }
	      if (isObject(name)) {
	        for (attName in name) {
	          if (!hasProp.call(name, attName)) continue;
	          attValue = name[attName];
	          this.attribute(attName, attValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        if (!this.options.skipNullAttributes || (value != null)) {
	          this.currentNode.attributes[name] = new XMLAttribute(this, name, value);
	        }
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.text = function(value) {
	      var node;
	      this.openCurrent();
	      node = new XMLText(this, value);
	      this.onData(this.writer.text(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.cdata = function(value) {
	      var node;
	      this.openCurrent();
	      node = new XMLCData(this, value);
	      this.onData(this.writer.cdata(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.comment = function(value) {
	      var node;
	      this.openCurrent();
	      node = new XMLComment(this, value);
	      this.onData(this.writer.comment(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.raw = function(value) {
	      var node;
	      this.openCurrent();
	      node = new XMLRaw(this, value);
	      this.onData(this.writer.raw(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.instruction = function(target, value) {
	      var i, insTarget, insValue, len, node;
	      this.openCurrent();
	      if (target != null) {
	        target = target.valueOf();
	      }
	      if (value != null) {
	        value = value.valueOf();
	      }
	      if (Array.isArray(target)) {
	        for (i = 0, len = target.length; i < len; i++) {
	          insTarget = target[i];
	          this.instruction(insTarget);
	        }
	      } else if (isObject(target)) {
	        for (insTarget in target) {
	          if (!hasProp.call(target, insTarget)) continue;
	          insValue = target[insTarget];
	          this.instruction(insTarget, insValue);
	        }
	      } else {
	        if (isFunction(value)) {
	          value = value.apply();
	        }
	        node = new XMLProcessingInstruction(this, target, value);
	        this.onData(this.writer.processingInstruction(node, this.currentLevel + 1));
	      }
	      return this;
	    };
	
	    XMLDocumentCB.prototype.declaration = function(version, encoding, standalone) {
	      var node;
	      this.openCurrent();
	      if (this.documentStarted) {
	        throw new Error("declaration() must be the first node");
	      }
	      node = new XMLDeclaration(this, version, encoding, standalone);
	      this.onData(this.writer.declaration(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.doctype = function(root, pubID, sysID) {
	      this.openCurrent();
	      if (root == null) {
	        throw new Error("Missing root node name");
	      }
	      if (this.root) {
	        throw new Error("dtd() must come before the root node");
	      }
	      this.currentNode = new XMLDocType(this, pubID, sysID);
	      this.currentNode.rootNodeName = root;
	      this.currentNode.children = false;
	      this.currentLevel++;
	      this.openTags[this.currentLevel] = this.currentNode;
	      return this;
	    };
	
	    XMLDocumentCB.prototype.dtdElement = function(name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDElement(this, name, value);
	      this.onData(this.writer.dtdElement(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.attList = function(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
	      this.onData(this.writer.dtdAttList(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.entity = function(name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDEntity(this, false, name, value);
	      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.pEntity = function(name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDEntity(this, true, name, value);
	      this.onData(this.writer.dtdEntity(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.notation = function(name, value) {
	      var node;
	      this.openCurrent();
	      node = new XMLDTDNotation(this, name, value);
	      this.onData(this.writer.dtdNotation(node, this.currentLevel + 1));
	      return this;
	    };
	
	    XMLDocumentCB.prototype.up = function() {
	      if (this.currentLevel < 0) {
	        throw new Error("The document node has no parent");
	      }
	      if (this.currentNode) {
	        if (this.currentNode.children) {
	          this.closeNode(this.currentNode);
	        } else {
	          this.openNode(this.currentNode);
	        }
	        this.currentNode = null;
	      } else {
	        this.closeNode(this.openTags[this.currentLevel]);
	      }
	      delete this.openTags[this.currentLevel];
	      this.currentLevel--;
	      return this;
	    };
	
	    XMLDocumentCB.prototype.end = function() {
	      while (this.currentLevel >= 0) {
	        this.up();
	      }
	      return this.onEnd();
	    };
	
	    XMLDocumentCB.prototype.openCurrent = function() {
	      if (this.currentNode) {
	        this.currentNode.children = true;
	        return this.openNode(this.currentNode);
	      }
	    };
	
	    XMLDocumentCB.prototype.openNode = function(node) {
	      if (!node.isOpen) {
	        if (!this.root && this.currentLevel === 0 && node instanceof XMLElement) {
	          this.root = node;
	        }
	        this.onData(this.writer.openNode(node, this.currentLevel));
	        return node.isOpen = true;
	      }
	    };
	
	    XMLDocumentCB.prototype.closeNode = function(node) {
	      if (!node.isClosed) {
	        this.onData(this.writer.closeNode(node, this.currentLevel));
	        return node.isClosed = true;
	      }
	    };
	
	    XMLDocumentCB.prototype.onData = function(chunk) {
	      this.documentStarted = true;
	      return this.onDataCallback(chunk);
	    };
	
	    XMLDocumentCB.prototype.onEnd = function() {
	      this.documentCompleted = true;
	      return this.onEndCallback();
	    };
	
	    XMLDocumentCB.prototype.ele = function() {
	      return this.element.apply(this, arguments);
	    };
	
	    XMLDocumentCB.prototype.nod = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.txt = function(value) {
	      return this.text(value);
	    };
	
	    XMLDocumentCB.prototype.dat = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLDocumentCB.prototype.com = function(value) {
	      return this.comment(value);
	    };
	
	    XMLDocumentCB.prototype.ins = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLDocumentCB.prototype.dec = function(version, encoding, standalone) {
	      return this.declaration(version, encoding, standalone);
	    };
	
	    XMLDocumentCB.prototype.dtd = function(root, pubID, sysID) {
	      return this.doctype(root, pubID, sysID);
	    };
	
	    XMLDocumentCB.prototype.e = function(name, attributes, text) {
	      return this.element(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.n = function(name, attributes, text) {
	      return this.node(name, attributes, text);
	    };
	
	    XMLDocumentCB.prototype.t = function(value) {
	      return this.text(value);
	    };
	
	    XMLDocumentCB.prototype.d = function(value) {
	      return this.cdata(value);
	    };
	
	    XMLDocumentCB.prototype.c = function(value) {
	      return this.comment(value);
	    };
	
	    XMLDocumentCB.prototype.r = function(value) {
	      return this.raw(value);
	    };
	
	    XMLDocumentCB.prototype.i = function(target, value) {
	      return this.instruction(target, value);
	    };
	
	    XMLDocumentCB.prototype.att = function() {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.attList.apply(this, arguments);
	      } else {
	        return this.attribute.apply(this, arguments);
	      }
	    };
	
	    XMLDocumentCB.prototype.a = function() {
	      if (this.currentNode && this.currentNode instanceof XMLDocType) {
	        return this.attList.apply(this, arguments);
	      } else {
	        return this.attribute.apply(this, arguments);
	      }
	    };
	
	    XMLDocumentCB.prototype.ent = function(name, value) {
	      return this.entity(name, value);
	    };
	
	    XMLDocumentCB.prototype.pent = function(name, value) {
	      return this.pEntity(name, value);
	    };
	
	    XMLDocumentCB.prototype.not = function(name, value) {
	      return this.notation(name, value);
	    };
	
	    return XMLDocumentCB;
	
	  })();
	
	}).call(this);


/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStreamWriter, XMLText, XMLWriterBase,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;
	
	  XMLDeclaration = __webpack_require__(136);
	
	  XMLDocType = __webpack_require__(137);
	
	  XMLCData = __webpack_require__(130);
	
	  XMLComment = __webpack_require__(131);
	
	  XMLElement = __webpack_require__(138);
	
	  XMLRaw = __webpack_require__(140);
	
	  XMLText = __webpack_require__(141);
	
	  XMLProcessingInstruction = __webpack_require__(139);
	
	  XMLDTDAttList = __webpack_require__(132);
	
	  XMLDTDElement = __webpack_require__(133);
	
	  XMLDTDEntity = __webpack_require__(134);
	
	  XMLDTDNotation = __webpack_require__(135);
	
	  XMLWriterBase = __webpack_require__(1077);
	
	  module.exports = XMLStreamWriter = (function(superClass) {
	    extend(XMLStreamWriter, superClass);
	
	    function XMLStreamWriter(stream, options) {
	      XMLStreamWriter.__super__.constructor.call(this, options);
	      this.stream = stream;
	    }
	
	    XMLStreamWriter.prototype.document = function(doc) {
	      var child, i, j, len, len1, ref, ref1, results;
	      ref = doc.children;
	      for (i = 0, len = ref.length; i < len; i++) {
	        child = ref[i];
	        child.isLastRootNode = false;
	      }
	      doc.children[doc.children.length - 1].isLastRootNode = true;
	      ref1 = doc.children;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        child = ref1[j];
	        switch (false) {
	          case !(child instanceof XMLDeclaration):
	            results.push(this.declaration(child));
	            break;
	          case !(child instanceof XMLDocType):
	            results.push(this.docType(child));
	            break;
	          case !(child instanceof XMLComment):
	            results.push(this.comment(child));
	            break;
	          case !(child instanceof XMLProcessingInstruction):
	            results.push(this.processingInstruction(child));
	            break;
	          default:
	            results.push(this.element(child));
	        }
	      }
	      return results;
	    };
	
	    XMLStreamWriter.prototype.attribute = function(att) {
	      return this.stream.write(' ' + att.name + '="' + att.value + '"');
	    };
	
	    XMLStreamWriter.prototype.cdata = function(node, level) {
	      return this.stream.write(this.space(level) + '<![CDATA[' + node.text + ']]>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.comment = function(node, level) {
	      return this.stream.write(this.space(level) + '<!-- ' + node.text + ' -->' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.declaration = function(node, level) {
	      this.stream.write(this.space(level));
	      this.stream.write('<?xml version="' + node.version + '"');
	      if (node.encoding != null) {
	        this.stream.write(' encoding="' + node.encoding + '"');
	      }
	      if (node.standalone != null) {
	        this.stream.write(' standalone="' + node.standalone + '"');
	      }
	      this.stream.write(this.spacebeforeslash + '?>');
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.docType = function(node, level) {
	      var child, i, len, ref;
	      level || (level = 0);
	      this.stream.write(this.space(level));
	      this.stream.write('<!DOCTYPE ' + node.root().name);
	      if (node.pubID && node.sysID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	      } else if (node.sysID) {
	        this.stream.write(' SYSTEM "' + node.sysID + '"');
	      }
	      if (node.children.length > 0) {
	        this.stream.write(' [');
	        this.stream.write(this.endline(node));
	        ref = node.children;
	        for (i = 0, len = ref.length; i < len; i++) {
	          child = ref[i];
	          switch (false) {
	            case !(child instanceof XMLDTDAttList):
	              this.dtdAttList(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDElement):
	              this.dtdElement(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDEntity):
	              this.dtdEntity(child, level + 1);
	              break;
	            case !(child instanceof XMLDTDNotation):
	              this.dtdNotation(child, level + 1);
	              break;
	            case !(child instanceof XMLCData):
	              this.cdata(child, level + 1);
	              break;
	            case !(child instanceof XMLComment):
	              this.comment(child, level + 1);
	              break;
	            case !(child instanceof XMLProcessingInstruction):
	              this.processingInstruction(child, level + 1);
	              break;
	            default:
	              throw new Error("Unknown DTD node type: " + child.constructor.name);
	          }
	        }
	        this.stream.write(']');
	      }
	      this.stream.write(this.spacebeforeslash + '>');
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.element = function(node, level) {
	      var att, child, i, len, name, ref, ref1, space;
	      level || (level = 0);
	      space = this.space(level);
	      this.stream.write(space + '<' + node.name);
	      ref = node.attributes;
	      for (name in ref) {
	        if (!hasProp.call(ref, name)) continue;
	        att = ref[name];
	        this.attribute(att);
	      }
	      if (node.children.length === 0 || node.children.every(function(e) {
	        return e.value === '';
	      })) {
	        if (this.allowEmpty) {
	          this.stream.write('></' + node.name + '>');
	        } else {
	          this.stream.write(this.spacebeforeslash + '/>');
	        }
	      } else if (this.pretty && node.children.length === 1 && (node.children[0].value != null)) {
	        this.stream.write('>');
	        this.stream.write(node.children[0].value);
	        this.stream.write('</' + node.name + '>');
	      } else {
	        this.stream.write('>' + this.newline);
	        ref1 = node.children;
	        for (i = 0, len = ref1.length; i < len; i++) {
	          child = ref1[i];
	          switch (false) {
	            case !(child instanceof XMLCData):
	              this.cdata(child, level + 1);
	              break;
	            case !(child instanceof XMLComment):
	              this.comment(child, level + 1);
	              break;
	            case !(child instanceof XMLElement):
	              this.element(child, level + 1);
	              break;
	            case !(child instanceof XMLRaw):
	              this.raw(child, level + 1);
	              break;
	            case !(child instanceof XMLText):
	              this.text(child, level + 1);
	              break;
	            case !(child instanceof XMLProcessingInstruction):
	              this.processingInstruction(child, level + 1);
	              break;
	            default:
	              throw new Error("Unknown XML node type: " + child.constructor.name);
	          }
	        }
	        this.stream.write(space + '</' + node.name + '>');
	      }
	      return this.stream.write(this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.processingInstruction = function(node, level) {
	      this.stream.write(this.space(level) + '<?' + node.target);
	      if (node.value) {
	        this.stream.write(' ' + node.value);
	      }
	      return this.stream.write(this.spacebeforeslash + '?>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.raw = function(node, level) {
	      return this.stream.write(this.space(level) + node.value + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.text = function(node, level) {
	      return this.stream.write(this.space(level) + node.value + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdAttList = function(node, level) {
	      this.stream.write(this.space(level) + '<!ATTLIST ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType);
	      if (node.defaultValueType !== '#DEFAULT') {
	        this.stream.write(' ' + node.defaultValueType);
	      }
	      if (node.defaultValue) {
	        this.stream.write(' "' + node.defaultValue + '"');
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdElement = function(node, level) {
	      this.stream.write(this.space(level) + '<!ELEMENT ' + node.name + ' ' + node.value);
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdEntity = function(node, level) {
	      this.stream.write(this.space(level) + '<!ENTITY');
	      if (node.pe) {
	        this.stream.write(' %');
	      }
	      this.stream.write(' ' + node.name);
	      if (node.value) {
	        this.stream.write(' "' + node.value + '"');
	      } else {
	        if (node.pubID && node.sysID) {
	          this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	        } else if (node.sysID) {
	          this.stream.write(' SYSTEM "' + node.sysID + '"');
	        }
	        if (node.nData) {
	          this.stream.write(' NDATA ' + node.nData);
	        }
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.dtdNotation = function(node, level) {
	      this.stream.write(this.space(level) + '<!NOTATION ' + node.name);
	      if (node.pubID && node.sysID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
	      } else if (node.pubID) {
	        this.stream.write(' PUBLIC "' + node.pubID + '"');
	      } else if (node.sysID) {
	        this.stream.write(' SYSTEM "' + node.sysID + '"');
	      }
	      return this.stream.write(this.spacebeforeslash + '>' + this.endline(node));
	    };
	
	    XMLStreamWriter.prototype.endline = function(node) {
	      if (!node.isLastRootNode) {
	        return this.newline;
	      } else {
	        return '';
	      }
	    };
	
	    return XMLStreamWriter;
	
	  })(XMLWriterBase);
	
	}).call(this);


/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction, ref;
	
	  ref = __webpack_require__(60), assign = ref.assign, isFunction = ref.isFunction;
	
	  XMLDocument = __webpack_require__(1510);
	
	  XMLDocumentCB = __webpack_require__(1511);
	
	  XMLStringWriter = __webpack_require__(833);
	
	  XMLStreamWriter = __webpack_require__(1512);
	
	  module.exports.create = function(name, xmldec, doctype, options) {
	    var doc, root;
	    if (name == null) {
	      throw new Error("Root element needs a name");
	    }
	    options = assign({}, xmldec, doctype, options);
	    doc = new XMLDocument(options);
	    root = doc.element(name);
	    if (!options.headless) {
	      doc.declaration(options);
	      if ((options.pubID != null) || (options.sysID != null)) {
	        doc.doctype(options);
	      }
	    }
	    return root;
	  };
	
	  module.exports.begin = function(options, onData, onEnd) {
	    var ref1;
	    if (isFunction(options)) {
	      ref1 = [options, onData], onData = ref1[0], onEnd = ref1[1];
	      options = {};
	    }
	    if (onData) {
	      return new XMLDocumentCB(options, onData, onEnd);
	    } else {
	      return new XMLDocument(options);
	    }
	  };
	
	  module.exports.stringWriter = function(options) {
	    return new XMLStringWriter(options);
	  };
	
	  module.exports.streamWriter = function(stream, options) {
	    return new XMLStreamWriter(stream, options);
	  };
	
	}).call(this);


/***/ },
/* 1514 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1515 */
1514,
/* 1516 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(7);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.541e18eb.js